{
  "schemaVersion": 1,
  "id": "vilnius-wide-judu-public-transport-network",
  "description": "Canonical weekday bus and trolleybus route patterns, ordered stops and service departures compiled from official JUDU static GTFS.",
  "source": {
    "name": "Vilnius public transport static GTFS",
    "publisher": "SĮ Susisiekimo paslaugos (JUDU)",
    "catalogUrl": "https://judu.lt/atviri-duomenys/",
    "url": "https://www.stops.lt/vilnius/vilnius/gtfs.zip",
    "termsUrl": "https://judu.lt/wp-content/uploads/2022/03/Duomenu-naudojimo-salygos-lt.pdf",
    "fetchedAt": "2026-08-11",
    "serviceDate": "20260811",
    "archiveFileName": "vilnius-gtfs.zip",
    "archiveSha256": "6707aff0990da48d6e670b7f79ca6666b9a52a9e14a205292134bc91ed5063cb",
    "notes": "For each route and direction, the most frequently scheduled active stop-sequence and shape pair is retained. Routes must provide both directions and remain wholly inside data/regions/vilnius-wide.json. Shapes are projected to EPSG:3346 and simplified to a 1.25 m tolerance; stop positions remain exact GTFS coordinates."
  },
  "localOriginLks94": {
    "crs": "EPSG:3346",
    "easting": 582400,
    "northing": 6062080,
    "elevationM": 80
  },
  "boundsLks94": {
    "minEasting": 556032,
    "minNorthing": 6051072,
    "maxEasting": 594176,
    "maxNorthing": 6077184
  },
  "routeCount": 101,
  "patternCount": 202,
  "departureCount": 8661,
  "rejectedPatternCount": {
    "outsideGeneratedWorld": 10,
    "stopShapeFit": 0
  },
  "routes": [
    {
      "id": "judu:route:vilnius_bus_1",
      "sourceRouteId": "vilnius_bus_1",
      "mode": "bus",
      "shortName": "1",
      "longName": "Stotis–Vikingų g.–Oro uostas–Rodūnios sodai",
      "color": "0073AC",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_bus_1:0",
          "sourceRouteId": "vilnius_bus_1",
          "sourceShapeId": "vilnius_bus_1_a-b",
          "directionId": 0,
          "headsign": "Rodūnios sodai",
          "directionName": "Stotis–Vikingų g.–Oro uostas–Rodūnios sodai",
          "mode": "bus",
          "routeShortName": "1",
          "routeLongName": "Stotis–Vikingų g.–Oro uostas–Rodūnios sodai",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              365.148,
              1967.953,
              0
            ],
            [
              359.628,
              1983.639,
              16.629
            ],
            [
              363.117,
              1998.047,
              31.453
            ],
            [
              375.555,
              2007.839,
              47.283
            ],
            [
              384.565,
              2006.561,
              56.383
            ],
            [
              450.348,
              1969.735,
              131.773
            ],
            [
              464.314,
              1957.234,
              150.516
            ],
            [
              465.443,
              1943.866,
              163.932
            ],
            [
              460.314,
              1934.517,
              174.596
            ],
            [
              448.99,
              1930.796,
              186.515
            ],
            [
              427.686,
              1930.073,
              207.831
            ],
            [
              403.862,
              1932.735,
              231.803
            ],
            [
              390.012,
              1916.29,
              253.304
            ],
            [
              339.428,
              1831.495,
              352.04
            ],
            [
              318.606,
              1821.856,
              374.985
            ],
            [
              29.934,
              1735.835,
              676.201
            ],
            [
              -11.394,
              1732.372,
              717.674
            ],
            [
              -46.755,
              1740.57,
              753.973
            ],
            [
              -320.217,
              1781.157,
              1030.43
            ],
            [
              -514.905,
              1842.557,
              1234.571
            ],
            [
              -520.923,
              1849.358,
              1243.652
            ],
            [
              -525.385,
              1862.522,
              1257.552
            ],
            [
              -507.688,
              1932.818,
              1330.042
            ],
            [
              -496.901,
              1964.699,
              1363.698
            ],
            [
              -462.075,
              2106.562,
              1509.773
            ],
            [
              -436.719,
              2188.482,
              1595.527
            ],
            [
              -427.991,
              2207.248,
              1616.224
            ],
            [
              -344.32,
              2338.207,
              1771.63
            ],
            [
              -326.137,
              2380.181,
              1817.373
            ],
            [
              -285.296,
              2533.066,
              1975.619
            ],
            [
              -285.194,
              2584.883,
              2027.437
            ],
            [
              -278.622,
              2616.436,
              2059.667
            ],
            [
              -251.706,
              2819.669,
              2264.674
            ],
            [
              -239.003,
              2950.799,
              2396.418
            ],
            [
              -239.164,
              2977.519,
              2423.139
            ],
            [
              -243.808,
              3023.423,
              2469.277
            ],
            [
              -251.845,
              3073.034,
              2519.535
            ],
            [
              -253.033,
              3102.452,
              2548.977
            ],
            [
              -344.245,
              3589.471,
              3044.463
            ],
            [
              -365.994,
              3598.855,
              3068.151
            ],
            [
              -488.127,
              3578.246,
              3192.01
            ],
            [
              -511.49,
              3565.528,
              3218.61
            ],
            [
              -517.55,
              3544.613,
              3240.386
            ],
            [
              -513.753,
              3531.31,
              3254.22
            ],
            [
              -508.087,
              3523.415,
              3263.937
            ],
            [
              -481.25,
              3508.458,
              3294.661
            ],
            [
              -441.711,
              3517.762,
              3335.28
            ],
            [
              -307.871,
              3566.547,
              3477.734
            ],
            [
              -94.218,
              3673.994,
              3716.883
            ],
            [
              9.183,
              3716.644,
              3828.735
            ],
            [
              123.958,
              3745.726,
              3947.137
            ],
            [
              243.774,
              3768.034,
              4069.012
            ],
            [
              305.255,
              3776.931,
              4131.133
            ],
            [
              329.292,
              3785.398,
              4156.618
            ],
            [
              358.258,
              3805.906,
              4192.109
            ],
            [
              365.29,
              3821.166,
              4208.912
            ],
            [
              354.918,
              3916.291,
              4304.6
            ],
            [
              348.689,
              3928.65,
              4318.44
            ],
            [
              334.031,
              3938.937,
              4336.348
            ],
            [
              293.984,
              3937.441,
              4376.423
            ],
            [
              249.963,
              3930.452,
              4420.995
            ],
            [
              216.024,
              3909.919,
              4460.662
            ],
            [
              197.12,
              3904.137,
              4480.431
            ],
            [
              187.109,
              3891.786,
              4496.329
            ],
            [
              173.696,
              3889.539,
              4509.929
            ],
            [
              160.288,
              3897.576,
              4525.561
            ],
            [
              157.848,
              3905.413,
              4533.769
            ],
            [
              158.696,
              3916.53,
              4544.919
            ],
            [
              171.18,
              3928.548,
              4562.247
            ],
            [
              184.71,
              3927.189,
              4575.845
            ],
            [
              199.993,
              3915.778,
              4594.919
            ],
            [
              209.048,
              3916.726,
              4604.023
            ],
            [
              218.183,
              3922.126,
              4614.635
            ],
            [
              228.044,
              3931.965,
              4628.565
            ],
            [
              267.488,
              3948.037,
              4671.157
            ],
            [
              353.288,
              3955.725,
              4757.301
            ],
            [
              339.014,
              4105.83,
              4908.083
            ],
            [
              334.908,
              4131.667,
              4934.244
            ],
            [
              328.44,
              4248.396,
              5051.152
            ],
            [
              4.962,
              4265.541,
              5375.084
            ],
            [
              -16.313,
              4267.041,
              5396.412
            ],
            [
              -27.868,
              4270.591,
              5408.5
            ],
            [
              -30.045,
              4292.895,
              5430.91
            ],
            [
              -28.186,
              4359.654,
              5497.695
            ],
            [
              -33.24,
              4507.805,
              5645.932
            ],
            [
              -26.822,
              4612.332,
              5750.656
            ],
            [
              -9.27,
              4725.561,
              5865.237
            ],
            [
              19.778,
              4831.903,
              5975.475
            ],
            [
              33.779,
              4891.762,
              6036.95
            ],
            [
              49.008,
              4912.637,
              6062.79
            ],
            [
              65.892,
              4953.519,
              6107.021
            ],
            [
              77.939,
              5047.924,
              6202.192
            ],
            [
              184.135,
              5048.078,
              6308.388
            ],
            [
              182.661,
              4953.647,
              6402.83
            ],
            [
              182.349,
              4943.721,
              6412.761
            ],
            [
              173.579,
              4881.378,
              6475.718
            ],
            [
              169.369,
              4876.96,
              6481.82
            ],
            [
              101.806,
              4898.57,
              6552.755
            ],
            [
              64.014,
              4921.27,
              6596.841
            ],
            [
              58.972,
              4928.041,
              6605.283
            ],
            [
              69.22,
              4959.024,
              6637.917
            ],
            [
              77.939,
              5047.924,
              6727.243
            ],
            [
              78.797,
              5201.533,
              6880.855
            ],
            [
              78.179,
              5208.345,
              6887.694
            ],
            [
              78,
              5217.141,
              6896.493
            ],
            [
              76.863,
              5233.86,
              6913.25
            ],
            [
              20.879,
              5425.231,
              7112.642
            ],
            [
              17.567,
              5495.409,
              7182.898
            ],
            [
              25.504,
              5566.669,
              7254.598
            ],
            [
              32.204,
              5602.361,
              7290.914
            ],
            [
              35.963,
              5722.187,
              7410.799
            ],
            [
              38.892,
              5812.305,
              7500.964
            ],
            [
              35.717,
              5831.897,
              7520.812
            ],
            [
              27.798,
              5835.852,
              7529.664
            ],
            [
              19.569,
              5837.856,
              7538.133
            ],
            [
              12.338,
              5844.433,
              7547.908
            ],
            [
              11.237,
              5853.997,
              7557.534
            ],
            [
              20.437,
              5886.242,
              7591.066
            ],
            [
              30.732,
              6002.814,
              7708.092
            ],
            [
              131.614,
              6188.001,
              7918.974
            ],
            [
              138.313,
              6201.238,
              7933.81
            ],
            [
              140.607,
              6210.031,
              7942.897
            ],
            [
              136.836,
              6223.439,
              7956.825
            ],
            [
              132.195,
              6222.849,
              7961.504
            ],
            [
              126.451,
              6223.718,
              7967.313
            ],
            [
              112.679,
              6220.202,
              7981.526
            ],
            [
              108.676,
              6219.659,
              7985.566
            ],
            [
              98.519,
              6218.282,
              7995.816
            ],
            [
              75.753,
              6215.194,
              8018.79
            ],
            [
              72.632,
              6214.771,
              8021.94
            ],
            [
              73.304,
              6214.862,
              8022.619
            ],
            [
              75.974,
              6217.957,
              8026.706
            ],
            [
              97.361,
              6222.01,
              8048.473
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:8262",
              "position": {
                "x": 365.148,
                "z": 1967.953
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": -240,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:6650",
              "position": {
                "x": -11.424,
                "z": 1732.135
              },
              "distanceAlongShapeM": 717.674,
              "shapeOffsetM": 0.239,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:7851",
              "position": {
                "x": -511.654,
                "z": 1933.795
              },
              "distanceAlongShapeM": 1330.021,
              "shapeOffsetM": 4.085,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:5173",
              "position": {
                "x": -290.153,
                "z": 2585.475
              },
              "distanceAlongShapeM": 2027.437,
              "shapeOffsetM": 4.994,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:5175",
              "position": {
                "x": -255.513,
                "z": 3072.44
              },
              "distanceAlongShapeM": 2519.535,
              "shapeOffsetM": 3.716,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:10359",
              "position": {
                "x": 228.044,
                "z": 3931.965
              },
              "distanceAlongShapeM": 4628.565,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:9738",
              "position": {
                "x": 333.674,
                "z": 4131.532
              },
              "distanceAlongShapeM": 4934.244,
              "shapeOffsetM": 1.242,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:18375",
              "position": {
                "x": 190.96,
                "z": 4943.45
              },
              "distanceAlongShapeM": 6412.761,
              "shapeOffsetM": 8.615,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:7817",
              "position": {
                "x": 75.045,
                "z": 5208.281
              },
              "distanceAlongShapeM": 6887.694,
              "shapeOffsetM": 3.135,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            },
            {
              "stopId": "judu:stop:4290",
              "position": {
                "x": 11.237,
                "z": 5853.997
              },
              "distanceAlongShapeM": 7557.534,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1560,
              "departureOffsetSeconds": 1560
            },
            {
              "stopId": "judu:stop:9226",
              "position": {
                "x": 97.359,
                "z": 6222.021
              },
              "distanceAlongShapeM": 8048.473,
              "shapeOffsetM": 0.011,
              "arrivalOffsetSeconds": 1560,
              "departureOffsetSeconds": 1560
            }
          ],
          "departuresSeconds": [
            20340,
            22140,
            24060,
            25920,
            27840,
            29940,
            31800,
            33780,
            38160,
            40080,
            42120,
            44160,
            46260,
            48420,
            50520,
            52620,
            54780,
            56940,
            59100,
            61380,
            63600,
            65820,
            67860,
            69960,
            74160,
            76020,
            77880,
            79680,
            81540,
            83340
          ]
        },
        {
          "id": "judu:pattern:vilnius_bus_1:1",
          "sourceRouteId": "vilnius_bus_1",
          "sourceShapeId": "vilnius_bus_1_b-a",
          "directionId": 1,
          "headsign": "Stotis",
          "directionName": "Rodūnios sodai–Oro uostas–Vikingų g.–Stotis",
          "mode": "bus",
          "routeShortName": "1",
          "routeLongName": "Stotis–Vikingų g.–Oro uostas–Rodūnios sodai",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              97.361,
              6222.01,
              0
            ],
            [
              127.138,
              6225.932,
              30.035
            ],
            [
              133.573,
              6224.701,
              36.586
            ],
            [
              142.706,
              6215.536,
              49.525
            ],
            [
              140.371,
              6207.879,
              57.53
            ],
            [
              50.853,
              6036.785,
              250.628
            ],
            [
              32.79,
              6009.456,
              283.387
            ],
            [
              28.35,
              5978.367,
              314.791
            ],
            [
              22.033,
              5877.189,
              416.166
            ],
            [
              40.521,
              5837.748,
              459.726
            ],
            [
              33.365,
              5610.979,
              686.607
            ],
            [
              17.617,
              5496.52,
              802.145
            ],
            [
              20.94,
              5428.569,
              870.177
            ],
            [
              46.935,
              5331.246,
              970.912
            ],
            [
              78.012,
              5229.378,
              1077.415
            ],
            [
              80.91,
              5140.267,
              1166.573
            ],
            [
              77.939,
              5047.924,
              1258.963
            ],
            [
              184.512,
              5044.319,
              1365.598
            ],
            [
              182.626,
              4952.534,
              1457.402
            ],
            [
              182.349,
              4943.721,
              1466.22
            ],
            [
              173.065,
              4882.548,
              1528.093
            ],
            [
              169.677,
              4876.86,
              1534.713
            ],
            [
              106.887,
              4896.161,
              1600.402
            ],
            [
              65.284,
              4920.133,
              1648.418
            ],
            [
              56.935,
              4922.512,
              1657.099
            ],
            [
              38.922,
              4890.556,
              1693.782
            ],
            [
              8.764,
              4794.253,
              1794.697
            ],
            [
              -10.098,
              4715.557,
              1875.622
            ],
            [
              -20.79,
              4660.091,
              1932.109
            ],
            [
              -26.278,
              4606.755,
              1985.727
            ],
            [
              -28.3,
              4495.47,
              2097.03
            ],
            [
              -27.162,
              4273.918,
              2318.585
            ],
            [
              -18.208,
              4269.302,
              2328.659
            ],
            [
              130.759,
              4261.026,
              2477.855
            ],
            [
              339.461,
              4254.589,
              2686.656
            ],
            [
              343.708,
              4221.52,
              2719.997
            ],
            [
              363.696,
              4063.891,
              2878.889
            ],
            [
              372.087,
              3972.752,
              2970.413
            ],
            [
              375.049,
              3958.226,
              2985.238
            ],
            [
              372.971,
              3950.472,
              2993.266
            ],
            [
              369.038,
              3947.204,
              2998.379
            ],
            [
              354.089,
              3943.277,
              3013.835
            ],
            [
              330.159,
              3939.008,
              3038.143
            ],
            [
              288.801,
              3936.423,
              3079.582
            ],
            [
              255.146,
              3931.471,
              3113.599
            ],
            [
              244.74,
              3927.207,
              3124.845
            ],
            [
              217.197,
              3907.83,
              3158.521
            ],
            [
              195.233,
              3902.506,
              3181.121
            ],
            [
              191.24,
              3895.899,
              3188.841
            ],
            [
              180.169,
              3890.535,
              3201.143
            ],
            [
              173.716,
              3890.652,
              3207.597
            ],
            [
              166.034,
              3894.132,
              3216.031
            ],
            [
              157.848,
              3905.413,
              3229.969
            ],
            [
              157.95,
              3910.978,
              3235.535
            ],
            [
              162.024,
              3922.036,
              3247.319
            ],
            [
              167.288,
              3927.506,
              3254.911
            ],
            [
              180.213,
              3928.384,
              3267.866
            ],
            [
              192.997,
              3921.471,
              3282.399
            ],
            [
              194.227,
              3918.109,
              3285.979
            ],
            [
              201.929,
              3915.742,
              3294.036
            ],
            [
              218.162,
              3921.013,
              3311.104
            ],
            [
              228.044,
              3931.965,
              3325.855
            ],
            [
              250.207,
              3943.806,
              3350.983
            ],
            [
              371.802,
              3957.172,
              3473.31
            ],
            [
              383.803,
              3836.724,
              3594.355
            ],
            [
              380.002,
              3770,
              3661.187
            ],
            [
              336.329,
              3640.55,
              3797.805
            ],
            [
              326.991,
              3624.022,
              3816.789
            ],
            [
              309.951,
              3609.861,
              3838.945
            ],
            [
              293.699,
              3603.478,
              3856.406
            ],
            [
              276.903,
              3602.672,
              3873.221
            ],
            [
              258.273,
              3607.464,
              3892.457
            ],
            [
              244.24,
              3616.626,
              3909.217
            ],
            [
              221.077,
              3656.012,
              3954.909
            ],
            [
              215.797,
              3685.052,
              3984.425
            ],
            [
              212.108,
              3695.138,
              3995.164
            ],
            [
              203.903,
              3705.307,
              4008.231
            ],
            [
              188.193,
              3715.135,
              4026.761
            ],
            [
              162.871,
              3720.526,
              4052.651
            ],
            [
              93.084,
              3716.231,
              4122.57
            ],
            [
              41.303,
              3708.267,
              4174.96
            ],
            [
              -53.374,
              3671.462,
              4276.539
            ],
            [
              -107.145,
              3637.493,
              4340.141
            ],
            [
              -149.771,
              3600.417,
              4396.636
            ],
            [
              -182.033,
              3565.379,
              4444.264
            ],
            [
              -225.808,
              3500.493,
              4522.536
            ],
            [
              -239.68,
              3482.933,
              4544.914
            ],
            [
              -275.691,
              3454.642,
              4590.709
            ],
            [
              -305.209,
              3428.459,
              4630.166
            ],
            [
              -308.011,
              3416.265,
              4642.678
            ],
            [
              -288.192,
              3299.017,
              4761.589
            ],
            [
              -248.134,
              3087.891,
              4976.482
            ],
            [
              -233.72,
              2993.006,
              5072.455
            ],
            [
              -227.915,
              2951.79,
              5114.078
            ],
            [
              -268.934,
              2604.253,
              5464.027
            ],
            [
              -287.151,
              2501.929,
              5567.96
            ],
            [
              -327.226,
              2355.709,
              5719.573
            ],
            [
              -350.367,
              2324.958,
              5758.058
            ],
            [
              -412.128,
              2228.113,
              5872.921
            ],
            [
              -425.492,
              2202.75,
              5901.589
            ],
            [
              -439.803,
              2160.707,
              5946.001
            ],
            [
              -445.668,
              2121.85,
              5985.298
            ],
            [
              -471.768,
              2034.377,
              6076.582
            ],
            [
              -499.661,
              1919.106,
              6195.18
            ],
            [
              -512.556,
              1856.885,
              6258.722
            ],
            [
              -491.403,
              1846.355,
              6282.352
            ],
            [
              -471.457,
              1839.899,
              6303.316
            ],
            [
              -432.32,
              1825.49,
              6345.022
            ],
            [
              -327.19,
              1787.963,
              6456.649
            ],
            [
              -259.046,
              1774.482,
              6526.113
            ],
            [
              -147.106,
              1756.865,
              6639.431
            ],
            [
              -84.021,
              1749.04,
              6703
            ],
            [
              9.981,
              1738.424,
              6797.599
            ],
            [
              41.02,
              1742.312,
              6828.881
            ],
            [
              64.443,
              1752.06,
              6854.251
            ],
            [
              97.435,
              1757.984,
              6887.771
            ],
            [
              310.866,
              1821.998,
              7110.595
            ],
            [
              325.04,
              1828.343,
              7126.124
            ],
            [
              357.53,
              1884.349,
              7190.872
            ],
            [
              380.962,
              1915.342,
              7229.726
            ],
            [
              392.354,
              1938.511,
              7255.544
            ],
            [
              391.831,
              1945.2,
              7262.253
            ],
            [
              387.438,
              1951.96,
              7270.315
            ],
            [
              365.148,
              1967.953,
              7297.749
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:9226",
              "position": {
                "x": 97.359,
                "z": 6222.021
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 0.011,
              "arrivalOffsetSeconds": -480,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:9276",
              "position": {
                "x": 42.585,
                "z": 5837.842
              },
              "distanceAlongShapeM": 459.726,
              "shapeOffsetM": 2.066,
              "arrivalOffsetSeconds": 60,
              "departureOffsetSeconds": 60
            },
            {
              "stopId": "judu:stop:7820",
              "position": {
                "x": 80.91,
                "z": 5140.267
              },
              "distanceAlongShapeM": 1166.573,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:18375",
              "position": {
                "x": 190.96,
                "z": 4943.45
              },
              "distanceAlongShapeM": 1466.22,
              "shapeOffsetM": 8.615,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:9750",
              "position": {
                "x": 366.01,
                "z": 4064.148
              },
              "distanceAlongShapeM": 2878.889,
              "shapeOffsetM": 2.329,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:10359",
              "position": {
                "x": 228.044,
                "z": 3931.965
              },
              "distanceAlongShapeM": 3325.855,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:7414",
              "position": {
                "x": -225.435,
                "z": 2951.666
              },
              "distanceAlongShapeM": 5114.078,
              "shapeOffsetM": 2.483,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            },
            {
              "stopId": "judu:stop:6854",
              "position": {
                "x": -266.588,
                "z": 2603.973
              },
              "distanceAlongShapeM": 5464.027,
              "shapeOffsetM": 2.363,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:5166",
              "position": {
                "x": -470.051,
                "z": 1843.985
              },
              "distanceAlongShapeM": 6303.316,
              "shapeOffsetM": 4.322,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:5160",
              "position": {
                "x": 63.816,
                "z": 1754.143
              },
              "distanceAlongShapeM": 6854.251,
              "shapeOffsetM": 2.176,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            },
            {
              "stopId": "judu:stop:7573",
              "position": {
                "x": 355.259,
                "z": 1885.754
              },
              "distanceAlongShapeM": 7190.872,
              "shapeOffsetM": 2.67,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            }
          ],
          "departuresSeconds": [
            18720,
            20520,
            22320,
            24120,
            25920,
            27960,
            30000,
            32100,
            36300,
            38160,
            40320,
            42420,
            44520,
            46620,
            48720,
            50820,
            52920,
            55020,
            57120,
            59280,
            61500,
            63720,
            65940,
            68160,
            72420,
            74340,
            76200,
            77940,
            79800,
            81660
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_expressbus_1G",
      "sourceRouteId": "vilnius_expressbus_1G",
      "mode": "bus",
      "shortName": "1G",
      "longName": "Stotis–Kalvarijų g.–Santariškės",
      "color": "008000",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_expressbus_1G:0",
          "sourceRouteId": "vilnius_expressbus_1G",
          "sourceShapeId": "vilnius_expressbus_1G_a-b",
          "directionId": 0,
          "headsign": "Santariškės",
          "directionName": "Stotis–Kalvarijų g.–Santariškės",
          "mode": "bus",
          "routeShortName": "1G",
          "routeLongName": "Stotis–Kalvarijų g.–Santariškės",
          "routeColor": "008000",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              357.53,
              1884.349,
              0
            ],
            [
              392.313,
              1936.286,
              62.509
            ],
            [
              391.729,
              1939.636,
              65.909
            ],
            [
              372.202,
              1965.597,
              98.394
            ],
            [
              357.795,
              1989.238,
              126.079
            ],
            [
              356.647,
              1997.052,
              133.977
            ],
            [
              359.39,
              2005.908,
              143.248
            ],
            [
              369.819,
              2015.615,
              157.496
            ],
            [
              380.856,
              2017.112,
              168.634
            ],
            [
              389.202,
              2013.156,
              177.87
            ],
            [
              477.214,
              1956.998,
              282.272
            ],
            [
              482.1,
              1946.369,
              293.97
            ],
            [
              482.411,
              1939.16,
              301.187
            ],
            [
              476.08,
              1930.301,
              312.075
            ],
            [
              460.458,
              1922.794,
              329.407
            ],
            [
              416.68,
              1928.048,
              373.499
            ],
            [
              398.6,
              1927.265,
              391.596
            ],
            [
              339.428,
              1831.495,
              504.171
            ],
            [
              330.657,
              1810.504,
              526.921
            ],
            [
              391.321,
              1670.242,
              679.74
            ],
            [
              473.433,
              1574.115,
              806.163
            ],
            [
              482.238,
              1561.708,
              821.377
            ],
            [
              478.313,
              1549.038,
              834.641
            ],
            [
              469.529,
              1536.247,
              850.158
            ],
            [
              453.691,
              1517.701,
              874.546
            ],
            [
              360.424,
              1427.008,
              1004.638
            ],
            [
              315.899,
              1391.085,
              1061.848
            ],
            [
              256.42,
              1348.755,
              1134.852
            ],
            [
              223.566,
              1315.958,
              1181.274
            ],
            [
              196.476,
              1280.829,
              1225.635
            ],
            [
              149.248,
              1202.651,
              1316.971
            ],
            [
              55.081,
              1061.873,
              1486.34
            ],
            [
              46.275,
              1047.293,
              1503.373
            ],
            [
              35.556,
              1031.037,
              1522.845
            ],
            [
              -5.066,
              911.568,
              1649.031
            ],
            [
              -20.812,
              826.136,
              1735.902
            ],
            [
              -29.409,
              769.885,
              1792.806
            ],
            [
              -32.739,
              739.524,
              1823.35
            ],
            [
              -31.911,
              641.542,
              1921.335
            ],
            [
              -49.15,
              509.381,
              2054.616
            ],
            [
              -49.278,
              431.457,
              2132.54
            ],
            [
              15.61,
              348.039,
              2238.223
            ],
            [
              38.092,
              270.675,
              2318.788
            ],
            [
              60.241,
              141.136,
              2450.207
            ],
            [
              63.955,
              129.761,
              2462.172
            ],
            [
              96.95,
              138.241,
              2496.24
            ],
            [
              106.691,
              127.84,
              2510.491
            ],
            [
              112.53,
              93.98,
              2544.85
            ],
            [
              124.691,
              -38.156,
              2677.544
            ],
            [
              129.098,
              -79.426,
              2719.049
            ],
            [
              129.88,
              -107.271,
              2746.905
            ],
            [
              116.846,
              -256.206,
              2896.409
            ],
            [
              117.887,
              -305.208,
              2945.422
            ],
            [
              127.343,
              -387.845,
              3028.598
            ],
            [
              135.914,
              -423.248,
              3065.025
            ],
            [
              144.816,
              -445.964,
              3089.422
            ],
            [
              174.587,
              -519.993,
              3169.213
            ],
            [
              236.049,
              -695.879,
              3355.529
            ],
            [
              238.113,
              -713.732,
              3373.501
            ],
            [
              217.158,
              -872.542,
              3533.687
            ],
            [
              276.82,
              -1242.113,
              3908.043
            ],
            [
              294.15,
              -1318.635,
              3986.503
            ],
            [
              320.249,
              -1546.82,
              4216.176
            ],
            [
              342.249,
              -1718.661,
              4389.419
            ],
            [
              352.701,
              -1764.728,
              4436.657
            ],
            [
              354.758,
              -1810.175,
              4482.15
            ],
            [
              356.121,
              -1841.371,
              4513.376
            ],
            [
              372.957,
              -1942.984,
              4616.375
            ],
            [
              426.379,
              -2158.817,
              4838.721
            ],
            [
              439.077,
              -2195.331,
              4877.38
            ],
            [
              440.947,
              -2208.066,
              4890.251
            ],
            [
              462.343,
              -2342.047,
              5025.93
            ],
            [
              478.13,
              -2430.282,
              5115.566
            ],
            [
              495.815,
              -2557.403,
              5243.911
            ],
            [
              505.672,
              -2659.601,
              5346.584
            ],
            [
              511.756,
              -2776.003,
              5463.144
            ],
            [
              513.301,
              -2797.183,
              5484.381
            ],
            [
              524.563,
              -2850.825,
              5539.192
            ],
            [
              523.952,
              -2902.017,
              5590.388
            ],
            [
              518.333,
              -3049.981,
              5738.458
            ],
            [
              511.327,
              -3110.973,
              5799.852
            ],
            [
              509.295,
              -3158.898,
              5847.82
            ],
            [
              508.428,
              -3204.542,
              5893.472
            ],
            [
              505.742,
              -3244.567,
              5933.587
            ],
            [
              505.902,
              -3256.64,
              5945.661
            ],
            [
              503.774,
              -3366.969,
              6056.01
            ],
            [
              489.873,
              -3512.567,
              6202.27
            ],
            [
              474.056,
              -3566.826,
              6258.788
            ],
            [
              440.465,
              -3641.474,
              6340.645
            ],
            [
              383.151,
              -3709.882,
              6429.89
            ],
            [
              302.538,
              -3790.592,
              6543.963
            ],
            [
              278.895,
              -3808.166,
              6573.422
            ],
            [
              228.358,
              -3858.451,
              6644.714
            ],
            [
              158.106,
              -3965.152,
              6772.465
            ],
            [
              125.932,
              -4039.781,
              6853.734
            ],
            [
              102.95,
              -4092.167,
              6910.94
            ],
            [
              79.561,
              -4208.631,
              7029.729
            ],
            [
              75.006,
              -4246.398,
              7067.77
            ],
            [
              72.804,
              -4296.453,
              7117.873
            ],
            [
              57.959,
              -4368.543,
              7191.476
            ],
            [
              50.952,
              -4440.233,
              7263.507
            ],
            [
              47.442,
              -4461.8,
              7285.358
            ],
            [
              42.119,
              -4495.164,
              7319.144
            ],
            [
              45.832,
              -4598.763,
              7422.81
            ],
            [
              43.273,
              -4641.013,
              7465.138
            ],
            [
              -32.111,
              -5068.242,
              7898.966
            ],
            [
              -38.249,
              -5115.663,
              7946.783
            ],
            [
              -42.927,
              -5131.5,
              7963.296
            ],
            [
              -75.729,
              -5270.057,
              8105.683
            ],
            [
              -95.037,
              -5339.84,
              8178.087
            ],
            [
              -109.429,
              -5409.977,
              8249.686
            ],
            [
              -116.661,
              -5430.732,
              8271.665
            ],
            [
              -144.967,
              -5534.861,
              8379.572
            ],
            [
              -183.275,
              -5657.733,
              8508.278
            ],
            [
              -188.212,
              -5716.645,
              8567.396
            ],
            [
              -190.648,
              -5736.736,
              8587.635
            ],
            [
              -196.91,
              -5769.923,
              8621.407
            ],
            [
              -201.665,
              -5818.819,
              8670.534
            ],
            [
              -201.086,
              -5857.793,
              8709.512
            ],
            [
              -195.599,
              -5910.215,
              8762.22
            ],
            [
              -136.015,
              -6175.138,
              9033.761
            ],
            [
              -127.679,
              -6205.529,
              9065.274
            ],
            [
              -123.468,
              -6228.802,
              9088.926
            ],
            [
              -113.557,
              -6285.758,
              9146.738
            ],
            [
              -58.166,
              -6532.794,
              9399.907
            ],
            [
              -46.468,
              -6597.576,
              9465.737
            ],
            [
              -39.377,
              -6667.839,
              9536.357
            ],
            [
              -35.045,
              -6748.072,
              9616.707
            ],
            [
              -26.235,
              -6767.677,
              9638.2
            ],
            [
              -16.413,
              -6780.218,
              9654.13
            ],
            [
              0.443,
              -6790.505,
              9673.877
            ],
            [
              9.552,
              -6811.226,
              9696.511
            ],
            [
              9.735,
              -6827.796,
              9713.083
            ],
            [
              7.024,
              -6842.352,
              9727.889
            ],
            [
              -10.864,
              -6869.857,
              9760.699
            ],
            [
              -21.671,
              -6897.49,
              9790.37
            ],
            [
              -11.966,
              -6926.765,
              9821.212
            ],
            [
              -9.853,
              -6955.595,
              9850.119
            ],
            [
              6.027,
              -7144.023,
              10039.215
            ],
            [
              11.629,
              -7176.924,
              10072.589
            ],
            [
              9.978,
              -7209.777,
              10105.484
            ],
            [
              38.024,
              -7507.525,
              10404.55
            ],
            [
              44.494,
              -7541.041,
              10438.685
            ],
            [
              46.371,
              -7614.549,
              10512.217
            ],
            [
              74.723,
              -7859.981,
              10759.281
            ],
            [
              95.181,
              -7883.513,
              10790.463
            ],
            [
              81.064,
              -7935.798,
              10844.62
            ],
            [
              115.822,
              -8265.129,
              11175.78
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:5156",
              "position": {
                "x": 389.202,
                "z": 2013.156
              },
              "distanceAlongShapeM": 177.87,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:6834",
              "position": {
                "x": 472.7,
                "z": 1534.052
              },
              "distanceAlongShapeM": 850.158,
              "shapeOffsetM": 3.857,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:5346",
              "position": {
                "x": 52.802,
                "z": 1042.989
              },
              "distanceAlongShapeM": 1503.373,
              "shapeOffsetM": 7.818,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:5492",
              "position": {
                "x": 116.145,
                "z": 94.475
              },
              "distanceAlongShapeM": 2544.85,
              "shapeOffsetM": 3.649,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:5245",
              "position": {
                "x": 150.182,
                "z": -443.837
              },
              "distanceAlongShapeM": 3089.451,
              "shapeOffsetM": 5.773,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:6843",
              "position": {
                "x": 297.35,
                "z": -1318.188
              },
              "distanceAlongShapeM": 3986.503,
              "shapeOffsetM": 3.231,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:6844",
              "position": {
                "x": 356.237,
                "z": -1764.56
              },
              "distanceAlongShapeM": 4436.657,
              "shapeOffsetM": 3.54,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:19086",
              "position": {
                "x": 511.316,
                "z": -3256.915
              },
              "distanceAlongShapeM": 5945.831,
              "shapeOffsetM": 5.419,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            },
            {
              "stopId": "judu:stop:5848",
              "position": {
                "x": 303.678,
                "z": -3791.921
              },
              "distanceAlongShapeM": 6543.963,
              "shapeOffsetM": 1.751,
              "arrivalOffsetSeconds": 1620,
              "departureOffsetSeconds": 1620
            },
            {
              "stopId": "judu:stop:6487",
              "position": {
                "x": 54.707,
                "z": -4440.844
              },
              "distanceAlongShapeM": 7263.507,
              "shapeOffsetM": 3.804,
              "arrivalOffsetSeconds": 1740,
              "departureOffsetSeconds": 1740
            },
            {
              "stopId": "judu:stop:6497",
              "position": {
                "x": -185.377,
                "z": -5737.848
              },
              "distanceAlongShapeM": 8587.75,
              "shapeOffsetM": 5.386,
              "arrivalOffsetSeconds": 1920,
              "departureOffsetSeconds": 1920
            },
            {
              "stopId": "judu:stop:6500",
              "position": {
                "x": -122.378,
                "z": -6204.331
              },
              "distanceAlongShapeM": 9065.274,
              "shapeOffsetM": 5.434,
              "arrivalOffsetSeconds": 1980,
              "departureOffsetSeconds": 1980
            },
            {
              "stopId": "judu:stop:6532",
              "position": {
                "x": 16.38,
                "z": -7176.496
              },
              "distanceAlongShapeM": 10072.589,
              "shapeOffsetM": 4.77,
              "arrivalOffsetSeconds": 2100,
              "departureOffsetSeconds": 2100
            },
            {
              "stopId": "judu:stop:8716",
              "position": {
                "x": 44.494,
                "z": -7541.041
              },
              "distanceAlongShapeM": 10438.685,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2160,
              "departureOffsetSeconds": 2160
            },
            {
              "stopId": "judu:stop:16649",
              "position": {
                "x": 118.182,
                "z": -8264.884
              },
              "distanceAlongShapeM": 11175.78,
              "shapeOffsetM": 2.373,
              "arrivalOffsetSeconds": 2280,
              "departureOffsetSeconds": 2280
            }
          ],
          "departuresSeconds": [
            18240,
            18840,
            19260,
            19740,
            20160,
            20520,
            20880,
            21240,
            21660,
            22080,
            22440,
            22800,
            23160,
            23520,
            23820,
            24120,
            24420,
            24720,
            25020,
            25320,
            25620,
            25920,
            26220,
            26520,
            26820,
            27120,
            27420,
            27720,
            28020,
            28320,
            28680,
            28980,
            29280,
            29580,
            29880,
            30180,
            30480,
            30780,
            31140,
            31560,
            31980,
            32580,
            33180,
            33660,
            34080,
            34560,
            34980,
            35460,
            35940,
            36360,
            36840,
            37320,
            37800,
            38220,
            38640,
            39060,
            39540,
            40020,
            40560,
            41040,
            41580,
            42060,
            42540,
            43020,
            43500,
            44040,
            44580,
            45120,
            45600,
            46080,
            46620,
            47100,
            47580,
            48060,
            48540,
            48960,
            49380,
            49800,
            50280,
            50820,
            51360,
            51900,
            52440,
            52920,
            53460,
            54000,
            54540,
            55020,
            55500,
            55980,
            56460,
            56940,
            57300,
            57660,
            58020,
            58320,
            58620,
            58920,
            59280,
            59580,
            59880,
            60180,
            60480,
            60780,
            61140,
            61500,
            61860,
            62220,
            62520,
            62820,
            63120,
            63420,
            63720,
            64020,
            64320,
            64680,
            65040,
            65400,
            65820,
            66240,
            66720,
            67140,
            67560,
            67920,
            68340,
            68700,
            69060,
            69480,
            69900,
            70320,
            70800,
            71220,
            71700,
            72180,
            72660,
            73140,
            73560,
            74040,
            74580,
            75060,
            75540,
            76020,
            76500,
            77040,
            77520,
            78000,
            78540,
            79020,
            79500,
            79980,
            80460,
            80940,
            81420,
            81960,
            82500,
            83100,
            83700,
            84360,
            85080,
            86400
          ]
        },
        {
          "id": "judu:pattern:vilnius_expressbus_1G:1",
          "sourceRouteId": "vilnius_expressbus_1G",
          "sourceShapeId": "vilnius_expressbus_1G_b-a",
          "directionId": 1,
          "headsign": "Stotis",
          "directionName": "Santariškės–Kalvarijų g.–Stotis",
          "mode": "bus",
          "routeShortName": "1G",
          "routeLongName": "Stotis–Kalvarijų g.–Santariškės",
          "routeColor": "008000",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              115.822,
              -8265.129,
              0
            ],
            [
              113.324,
              -8319.345,
              54.273
            ],
            [
              119.934,
              -8345.07,
              80.834
            ],
            [
              124.397,
              -8357.922,
              94.439
            ],
            [
              125.966,
              -8374.275,
              110.867
            ],
            [
              129.247,
              -8412.532,
              149.264
            ],
            [
              129.399,
              -8415.69,
              152.426
            ],
            [
              123.699,
              -8420.84,
              160.108
            ],
            [
              117.67,
              -8418.478,
              166.583
            ],
            [
              117.339,
              -8411.609,
              173.46
            ],
            [
              113.324,
              -8319.345,
              265.812
            ],
            [
              103.551,
              -8220.087,
              365.55
            ],
            [
              64.771,
              -7840.874,
              746.741
            ],
            [
              60.212,
              -7808.507,
              779.427
            ],
            [
              55.915,
              -7784.559,
              803.758
            ],
            [
              54.874,
              -7748.294,
              840.038
            ],
            [
              46.371,
              -7614.549,
              974.053
            ],
            [
              38.797,
              -7570.994,
              1018.261
            ],
            [
              26.258,
              -7471.636,
              1118.408
            ],
            [
              8.189,
              -7201.951,
              1388.697
            ],
            [
              -2.477,
              -7116.037,
              1475.271
            ],
            [
              -10.317,
              -7079.698,
              1512.446
            ],
            [
              -10.894,
              -7047.975,
              1544.174
            ],
            [
              -21.671,
              -6897.49,
              1695.044
            ],
            [
              -33.557,
              -6878.349,
              1717.576
            ],
            [
              -59.463,
              -6851.158,
              1755.132
            ],
            [
              -67.548,
              -6835.425,
              1772.821
            ],
            [
              -70.502,
              -6820.899,
              1787.644
            ],
            [
              -64.262,
              -6796.522,
              1812.807
            ],
            [
              -53.909,
              -6786.595,
              1827.15
            ],
            [
              -43.463,
              -6771.142,
              1845.803
            ],
            [
              -41.984,
              -6740.153,
              1876.827
            ],
            [
              -44.194,
              -6720.074,
              1897.027
            ],
            [
              -50.641,
              -6695.446,
              1922.485
            ],
            [
              -50.159,
              -6658.737,
              1959.197
            ],
            [
              -53.169,
              -6611.926,
              2006.105
            ],
            [
              -67.701,
              -6525.941,
              2093.309
            ],
            [
              -119.736,
              -6306.797,
              2318.546
            ],
            [
              -170.109,
              -6102.156,
              2529.296
            ],
            [
              -180.294,
              -6069.166,
              2563.822
            ],
            [
              -186.217,
              -6031.729,
              2601.725
            ],
            [
              -210.448,
              -5912.171,
              2723.714
            ],
            [
              -214.769,
              -5866.45,
              2769.639
            ],
            [
              -215.425,
              -5796.303,
              2839.789
            ],
            [
              -201.667,
              -5690.858,
              2946.127
            ],
            [
              -179.043,
              -5602.148,
              3037.677
            ],
            [
              -173.463,
              -5579.628,
              3060.878
            ],
            [
              -161.79,
              -5539.008,
              3103.142
            ],
            [
              -100.123,
              -5300.784,
              3349.218
            ],
            [
              -94.509,
              -5271.442,
              3379.092
            ],
            [
              -86.291,
              -5248.713,
              3403.261
            ],
            [
              -41.786,
              -5033.555,
              3622.974
            ],
            [
              -37.931,
              -4996.288,
              3660.44
            ],
            [
              -29.601,
              -4965.87,
              3691.978
            ],
            [
              29.378,
              -4628.52,
              4034.445
            ],
            [
              28.501,
              -4570.615,
              4092.356
            ],
            [
              22.071,
              -4499.251,
              4164.009
            ],
            [
              25.378,
              -4459.234,
              4204.163
            ],
            [
              39.057,
              -4380.444,
              4284.131
            ],
            [
              52.989,
              -4285.429,
              4380.163
            ],
            [
              59.203,
              -4265.034,
              4401.483
            ],
            [
              91.736,
              -4106.435,
              4563.384
            ],
            [
              104.143,
              -4062.131,
              4609.393
            ],
            [
              127.703,
              -3998.463,
              4677.281
            ],
            [
              151.352,
              -3953.466,
              4728.113
            ],
            [
              246.3,
              -3828.721,
              4884.882
            ],
            [
              290.877,
              -3787.233,
              4945.778
            ],
            [
              365.399,
              -3712.855,
              5051.067
            ],
            [
              434.283,
              -3627.326,
              5160.886
            ],
            [
              450.253,
              -3599.787,
              5192.72
            ],
            [
              463.769,
              -3565.524,
              5229.553
            ],
            [
              474.065,
              -3531.203,
              5265.385
            ],
            [
              484.063,
              -3477.95,
              5319.568
            ],
            [
              490.334,
              -3345.62,
              5452.047
            ],
            [
              488.575,
              -3319.869,
              5477.858
            ],
            [
              479.687,
              -3259.675,
              5538.704
            ],
            [
              477.905,
              -3216.226,
              5582.19
            ],
            [
              481.339,
              -3169.533,
              5629.009
            ],
            [
              500.602,
              -3103.091,
              5698.187
            ],
            [
              504.082,
              -3078.362,
              5723.16
            ],
            [
              504.445,
              -3034.141,
              5767.382
            ],
            [
              503.491,
              -2980.688,
              5820.844
            ],
            [
              505.751,
              -2962.917,
              5838.758
            ],
            [
              504.844,
              -2912.819,
              5888.864
            ],
            [
              509.899,
              -2877.274,
              5924.767
            ],
            [
              511.861,
              -2840.573,
              5961.52
            ],
            [
              496.04,
              -2648.805,
              6153.94
            ],
            [
              487.991,
              -2601.316,
              6202.106
            ],
            [
              485.911,
              -2568.466,
              6235.022
            ],
            [
              474.223,
              -2432.437,
              6371.552
            ],
            [
              449.166,
              -2287.257,
              6518.878
            ],
            [
              413.918,
              -2135.211,
              6674.957
            ],
            [
              407.333,
              -2116.119,
              6695.152
            ],
            [
              406.254,
              -2096.107,
              6715.193
            ],
            [
              369.715,
              -1944.038,
              6871.591
            ],
            [
              352.071,
              -1851.316,
              6965.976
            ],
            [
              343.07,
              -1744.281,
              7073.389
            ],
            [
              332.874,
              -1667.281,
              7151.061
            ],
            [
              326.222,
              -1640.218,
              7178.929
            ],
            [
              326.097,
              -1614.835,
              7204.313
            ],
            [
              277.22,
              -1255.479,
              7566.978
            ],
            [
              271.867,
              -1230.89,
              7592.143
            ],
            [
              269.371,
              -1219.076,
              7604.218
            ],
            [
              267.28,
              -1199.635,
              7623.771
            ],
            [
              257.056,
              -1141.194,
              7683.099
            ],
            [
              216.915,
              -885.896,
              7941.534
            ],
            [
              226.048,
              -703.492,
              8124.166
            ],
            [
              223.795,
              -685.64,
              8142.16
            ],
            [
              209.218,
              -636.391,
              8193.521
            ],
            [
              192.022,
              -589.321,
              8243.634
            ],
            [
              159.237,
              -513.023,
              8326.677
            ],
            [
              151.725,
              -500.641,
              8341.16
            ],
            [
              143.086,
              -479.332,
              8364.153
            ],
            [
              126.134,
              -439.133,
              8407.781
            ],
            [
              106.146,
              -277.163,
              8570.979
            ],
            [
              46.11,
              -280.522,
              8631.109
            ],
            [
              26.264,
              -279.764,
              8650.969
            ],
            [
              16.623,
              -264.894,
              8668.691
            ],
            [
              14.513,
              -253.218,
              8680.557
            ],
            [
              16.439,
              -245.471,
              8688.54
            ],
            [
              45.916,
              -220.403,
              8727.235
            ],
            [
              103.215,
              -190.277,
              8791.971
            ],
            [
              127.382,
              -102.772,
              8882.751
            ],
            [
              121.848,
              -52.576,
              8933.252
            ],
            [
              118.496,
              -36.512,
              8949.661
            ],
            [
              117.583,
              -3.516,
              8982.67
            ],
            [
              102.671,
              133.684,
              9120.678
            ],
            [
              63.181,
              125.497,
              9161.008
            ],
            [
              59.312,
              125.568,
              9164.878
            ],
            [
              57.419,
              127.829,
              9167.826
            ],
            [
              31.786,
              278.582,
              9320.743
            ],
            [
              4.856,
              358.112,
              9404.709
            ],
            [
              -8.924,
              380.627,
              9431.106
            ],
            [
              -39.768,
              422.378,
              9483.015
            ],
            [
              -46.8,
              425.846,
              9490.855
            ],
            [
              -51.212,
              431.492,
              9498.021
            ],
            [
              -51.307,
              497.175,
              9563.704
            ],
            [
              -54.16,
              522.615,
              9589.303
            ],
            [
              -44.593,
              547.148,
              9615.636
            ],
            [
              -34.25,
              619.32,
              9688.545
            ],
            [
              -34.886,
              726.201,
              9795.428
            ],
            [
              -29.964,
              784,
              9853.436
            ],
            [
              -28.88,
              804.74,
              9874.205
            ],
            [
              -24.076,
              823.969,
              9894.024
            ],
            [
              -6.94,
              914.942,
              9986.597
            ],
            [
              5.94,
              949.218,
              10023.213
            ],
            [
              14.89,
              980.225,
              10055.486
            ],
            [
              20.723,
              1007.284,
              10083.167
            ],
            [
              104.844,
              1137.779,
              10238.426
            ],
            [
              208.532,
              1302.485,
              10433.052
            ],
            [
              265.611,
              1357.493,
              10512.323
            ],
            [
              360.424,
              1427.008,
              10629.889
            ],
            [
              406.382,
              1470.698,
              10693.3
            ],
            [
              390.605,
              1489.911,
              10718.161
            ],
            [
              398.092,
              1546.549,
              10775.291
            ],
            [
              395.449,
              1569.043,
              10797.94
            ],
            [
              397.453,
              1582.184,
              10811.233
            ],
            [
              391.321,
              1670.242,
              10899.504
            ],
            [
              327.595,
              1819.466,
              11061.766
            ],
            [
              328.524,
              1835.034,
              11077.362
            ],
            [
              357.53,
              1884.349,
              11134.574
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:7830",
              "position": {
                "x": 112.767,
                "z": -8385.016
              },
              "distanceAlongShapeM": 200.227,
              "shapeOffsetM": 3.412,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:7831",
              "position": {
                "x": 25.801,
                "z": -7471.678
              },
              "distanceAlongShapeM": 1118.408,
              "shapeOffsetM": 0.459,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:6526",
              "position": {
                "x": -15.345,
                "z": -7080.178
              },
              "distanceAlongShapeM": 1512.446,
              "shapeOffsetM": 5.051,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:6501",
              "position": {
                "x": -182.398,
                "z": -6069.649
              },
              "distanceAlongShapeM": 2563.822,
              "shapeOffsetM": 2.159,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:6494",
              "position": {
                "x": -176.685,
                "z": -5578.813
              },
              "distanceAlongShapeM": 3060.878,
              "shapeOffsetM": 3.324,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:5836",
              "position": {
                "x": 49.82,
                "z": -4284.902
              },
              "distanceAlongShapeM": 4380.163,
              "shapeOffsetM": 3.212,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:5846",
              "position": {
                "x": 383.579,
                "z": -3686.512
              },
              "distanceAlongShapeM": 5082.986,
              "shapeOffsetM": 2.365,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:5481",
              "position": {
                "x": 502.159,
                "z": -2912.756
              },
              "distanceAlongShapeM": 5888.864,
              "shapeOffsetM": 2.686,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            },
            {
              "stopId": "judu:stop:5467",
              "position": {
                "x": 324.984,
                "z": -1640.419
              },
              "distanceAlongShapeM": 7178.929,
              "shapeOffsetM": 1.254,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:5378",
              "position": {
                "x": 265.625,
                "z": -1219.643
              },
              "distanceAlongShapeM": 7604.218,
              "shapeOffsetM": 3.789,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:5244",
              "position": {
                "x": 121.213,
                "z": -441.083
              },
              "distanceAlongShapeM": 8407.781,
              "shapeOffsetM": 5.293,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            },
            {
              "stopId": "judu:stop:5409",
              "position": {
                "x": 115.041,
                "z": -36.866
              },
              "distanceAlongShapeM": 8949.661,
              "shapeOffsetM": 3.473,
              "arrivalOffsetSeconds": 1680,
              "departureOffsetSeconds": 1680
            },
            {
              "stopId": "judu:stop:5338",
              "position": {
                "x": -56,
                "z": 522.864
              },
              "distanceAlongShapeM": 9589.303,
              "shapeOffsetM": 1.857,
              "arrivalOffsetSeconds": 1860,
              "departureOffsetSeconds": 1860
            },
            {
              "stopId": "judu:stop:5345",
              "position": {
                "x": 17.976,
                "z": 1008
              },
              "distanceAlongShapeM": 10083.167,
              "shapeOffsetM": 2.839,
              "arrivalOffsetSeconds": 1980,
              "departureOffsetSeconds": 1980
            },
            {
              "stopId": "judu:stop:7573",
              "position": {
                "x": 355.259,
                "z": 1885.754
              },
              "distanceAlongShapeM": 11134.574,
              "shapeOffsetM": 2.67,
              "arrivalOffsetSeconds": 2160,
              "departureOffsetSeconds": 2160
            }
          ],
          "departuresSeconds": [
            18660,
            19140,
            19800,
            20520,
            20940,
            21420,
            21840,
            22260,
            22560,
            22860,
            23160,
            23460,
            23760,
            24120,
            24480,
            24780,
            25080,
            25380,
            25740,
            26100,
            26400,
            26700,
            27000,
            27300,
            27600,
            27900,
            28200,
            28500,
            28800,
            29100,
            29400,
            29820,
            30240,
            30660,
            31020,
            31440,
            31920,
            32280,
            32640,
            32940,
            33360,
            33780,
            34260,
            34740,
            35160,
            35580,
            36000,
            36480,
            36960,
            37500,
            38040,
            38580,
            39060,
            39540,
            40020,
            40500,
            40980,
            41460,
            41940,
            42420,
            42900,
            43380,
            43860,
            44340,
            44820,
            45300,
            45780,
            46260,
            46680,
            47100,
            47580,
            48060,
            48480,
            48960,
            49500,
            49980,
            50520,
            51060,
            51600,
            52140,
            52680,
            53220,
            53760,
            54300,
            54720,
            55140,
            55560,
            55980,
            56460,
            56940,
            57420,
            57840,
            58260,
            58680,
            59100,
            59520,
            59940,
            60240,
            60540,
            60840,
            61140,
            61440,
            61740,
            62100,
            62460,
            62820,
            63180,
            63480,
            63840,
            64260,
            64680,
            65100,
            65520,
            65940,
            66360,
            66720,
            67140,
            67500,
            67860,
            68160,
            68460,
            68820,
            69180,
            69660,
            70140,
            70620,
            71160,
            71700,
            72240,
            72720,
            73200,
            73680,
            74160,
            74640,
            75120,
            75600,
            76080,
            76500,
            76860,
            77220,
            77640,
            78120,
            78600,
            79080,
            79560,
            80100,
            80640,
            81180,
            81720,
            82320,
            82920,
            83520,
            84360
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_bus_2",
      "sourceRouteId": "vilnius_bus_2",
      "mode": "bus",
      "shortName": "2",
      "longName": "Stotis–Liepkalnio–Vikingų g.–Oro uostas",
      "color": "0073AC",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_bus_2:0",
          "sourceRouteId": "vilnius_bus_2",
          "sourceShapeId": "vilnius_bus_2_a-b",
          "directionId": 0,
          "headsign": "Oro uostas",
          "directionName": "Stotis–Liepkalnio–Vikingų g.–Oro uostas",
          "mode": "bus",
          "routeShortName": "2",
          "routeLongName": "Stotis–Liepkalnio–Vikingų g.–Oro uostas",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              493.411,
              1911.506,
              0
            ],
            [
              468.32,
              1929.33,
              30.777
            ],
            [
              440.606,
              1930.95,
              58.538
            ],
            [
              420.672,
              1934.654,
              78.813
            ],
            [
              395.721,
              1946.243,
              106.325
            ],
            [
              365.148,
              1967.953,
              143.822
            ],
            [
              366.037,
              1981.295,
              157.193
            ],
            [
              377.518,
              2000.134,
              179.255
            ],
            [
              392.142,
              1997.517,
              194.111
            ],
            [
              473.887,
              1951.492,
              287.922
            ],
            [
              478.68,
              1931.366,
              308.611
            ],
            [
              623.161,
              1858.587,
              470.387
            ],
            [
              825.163,
              1791.425,
              683.262
            ],
            [
              863.527,
              1836.207,
              742.229
            ],
            [
              869.06,
              1862.978,
              769.566
            ],
            [
              873.401,
              1888.503,
              795.458
            ],
            [
              890.379,
              1910.039,
              822.881
            ],
            [
              909.687,
              1916.752,
              843.323
            ],
            [
              941.154,
              1923.993,
              875.612
            ],
            [
              953.593,
              1933.783,
              891.442
            ],
            [
              1083.618,
              2057.184,
              1070.702
            ],
            [
              1196.071,
              2172,
              1231.415
            ],
            [
              1233.034,
              2216.96,
              1289.618
            ],
            [
              1262.402,
              2269.853,
              1350.117
            ],
            [
              1275.582,
              2294.627,
              1378.179
            ],
            [
              1295.641,
              2322.675,
              1412.662
            ],
            [
              1353.693,
              2426.246,
              1531.393
            ],
            [
              1363.843,
              2451.663,
              1558.761
            ],
            [
              1395.21,
              2612.502,
              1722.63
            ],
            [
              1412.03,
              2684.551,
              1796.617
            ],
            [
              1428.563,
              2741.021,
              1855.457
            ],
            [
              1438.754,
              2768.663,
              1884.918
            ],
            [
              1469.827,
              2811.004,
              1937.437
            ],
            [
              1480.947,
              2816.864,
              1950.007
            ],
            [
              1584.045,
              2912.919,
              2090.917
            ],
            [
              1624.327,
              2962.268,
              2154.62
            ],
            [
              1644.883,
              2991.944,
              2190.72
            ],
            [
              1682.229,
              3056.932,
              2265.674
            ],
            [
              1693.837,
              3091.227,
              2301.88
            ],
            [
              1697.848,
              3133.456,
              2344.299
            ],
            [
              1698.943,
              3192.437,
              2403.29
            ],
            [
              1697.261,
              3310.472,
              2521.337
            ],
            [
              1700.204,
              3399.476,
              2610.39
            ],
            [
              1674.097,
              3592.551,
              2805.222
            ],
            [
              1669.889,
              3748.482,
              2961.21
            ],
            [
              1617.274,
              3730.533,
              3016.802
            ],
            [
              1602.425,
              3723.737,
              3033.132
            ],
            [
              1498.067,
              3700.051,
              3140.144
            ],
            [
              1228.761,
              3628.622,
              3418.762
            ],
            [
              1081.72,
              3600.162,
              3568.532
            ],
            [
              1000.053,
              3581.628,
              3652.276
            ],
            [
              917.844,
              3568.668,
              3735.5
            ],
            [
              819.044,
              3566.031,
              3834.335
            ],
            [
              779.706,
              3567.866,
              3873.716
            ],
            [
              724.965,
              3574.437,
              3928.85
            ],
            [
              647.824,
              3591.436,
              4007.842
            ],
            [
              549.01,
              3623.303,
              4111.667
            ],
            [
              339.987,
              3699.484,
              4334.14
            ],
            [
              289.853,
              3711.576,
              4385.712
            ],
            [
              262.015,
              3706.473,
              4414.014
            ],
            [
              248.282,
              3696.705,
              4430.866
            ],
            [
              235.8,
              3684.687,
              4448.193
            ],
            [
              231.06,
              3672.528,
              4461.244
            ],
            [
              230.715,
              3653.609,
              4480.166
            ],
            [
              236.096,
              3630.133,
              4504.251
            ],
            [
              244.26,
              3617.739,
              4519.092
            ],
            [
              255.046,
              3607.523,
              4533.948
            ],
            [
              271.096,
              3602.778,
              4550.685
            ],
            [
              285.291,
              3602.519,
              4564.882
            ],
            [
              311.928,
              3612.052,
              4593.174
            ],
            [
              323.12,
              3624.093,
              4609.613
            ],
            [
              341.857,
              3660.487,
              4650.547
            ],
            [
              361.224,
              3731.38,
              4724.038
            ],
            [
              371.817,
              3781.282,
              4775.051
            ],
            [
              370.232,
              3835.859,
              4829.652
            ],
            [
              356.638,
              3905.942,
              4901.041
            ],
            [
              346.987,
              3927.764,
              4924.901
            ],
            [
              325.018,
              3940.215,
              4950.154
            ],
            [
              260.994,
              3933.59,
              5014.52
            ],
            [
              244.74,
              3927.207,
              5031.982
            ],
            [
              208.199,
              3905.609,
              5074.429
            ],
            [
              199.022,
              3904.374,
              5083.688
            ],
            [
              193.902,
              3900.304,
              5090.229
            ],
            [
              189.264,
              3893.709,
              5098.292
            ],
            [
              180.814,
              3890.523,
              5107.322
            ],
            [
              167.304,
              3892.996,
              5121.057
            ],
            [
              160.288,
              3897.576,
              5129.436
            ],
            [
              155.933,
              3906.561,
              5139.42
            ],
            [
              156.7,
              3913.227,
              5146.13
            ],
            [
              169.203,
              3926.358,
              5164.262
            ],
            [
              178.923,
              3928.407,
              5174.195
            ],
            [
              191.081,
              3922.619,
              5187.661
            ],
            [
              196.787,
              3916.949,
              5195.705
            ],
            [
              205.821,
              3916.785,
              5204.74
            ],
            [
              228.044,
              3931.965,
              5231.653
            ],
            [
              267.488,
              3948.037,
              5274.246
            ],
            [
              353.288,
              3955.725,
              5360.389
            ],
            [
              339.014,
              4105.83,
              5511.171
            ],
            [
              334.908,
              4131.667,
              5537.332
            ],
            [
              328.44,
              4248.396,
              5654.241
            ],
            [
              -16.313,
              4267.041,
              5999.498
            ],
            [
              -27.868,
              4270.591,
              6011.586
            ],
            [
              -30.045,
              4292.895,
              6033.996
            ],
            [
              -28.186,
              4359.654,
              6100.78
            ],
            [
              -33.24,
              4507.805,
              6249.018
            ],
            [
              -26.822,
              4612.332,
              6353.741
            ],
            [
              -9.27,
              4725.561,
              6468.323
            ],
            [
              19.778,
              4831.903,
              6578.561
            ],
            [
              33.779,
              4891.762,
              6640.035
            ],
            [
              49.008,
              4912.637,
              6665.875
            ],
            [
              65.892,
              4953.519,
              6710.106
            ],
            [
              77.939,
              5047.924,
              6805.277
            ],
            [
              184.135,
              5048.078,
              6911.473
            ],
            [
              182.661,
              4953.647,
              7005.916
            ],
            [
              182.349,
              4943.721,
              7015.847
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:8262",
              "position": {
                "x": 365.148,
                "z": 1967.953
              },
              "distanceAlongShapeM": 143.822,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:5941",
              "position": {
                "x": 889.31,
                "z": 1911.588
              },
              "distanceAlongShapeM": 822.881,
              "shapeOffsetM": 1.882,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:5944",
              "position": {
                "x": 1272.571,
                "z": 2296.383
              },
              "distanceAlongShapeM": 1378.179,
              "shapeOffsetM": 3.486,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:5946",
              "position": {
                "x": 1466.069,
                "z": 2814.913
              },
              "distanceAlongShapeM": 1937.437,
              "shapeOffsetM": 5.422,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:16978",
              "position": {
                "x": 1602.913,
                "z": 3721.893
              },
              "distanceAlongShapeM": 3033.132,
              "shapeOffsetM": 1.908,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:10359",
              "position": {
                "x": 228.044,
                "z": 3931.965
              },
              "distanceAlongShapeM": 5231.653,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:9738",
              "position": {
                "x": 333.674,
                "z": 4131.532
              },
              "distanceAlongShapeM": 5537.332,
              "shapeOffsetM": 1.242,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            },
            {
              "stopId": "judu:stop:18375",
              "position": {
                "x": 190.96,
                "z": 4943.45
              },
              "distanceAlongShapeM": 7015.847,
              "shapeOffsetM": 8.615,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            }
          ],
          "departuresSeconds": [
            19860,
            23280,
            26880,
            30480,
            32640,
            36720,
            40020,
            43740,
            47520,
            51240,
            54720,
            57120,
            58620,
            60480,
            62160,
            63840,
            65340,
            71520,
            74460,
            77400,
            80340
          ]
        },
        {
          "id": "judu:pattern:vilnius_bus_2:1",
          "sourceRouteId": "vilnius_bus_2",
          "sourceShapeId": "vilnius_bus_2_b1-a1",
          "directionId": 1,
          "headsign": "Stotis",
          "directionName": "Oro uostas–Vikingų–Liepynės kapinės–Stotis",
          "mode": "bus",
          "routeShortName": "2",
          "routeLongName": "Stotis–Liepkalnio–Vikingų g.–Oro uostas",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              182.349,
              4943.721,
              0
            ],
            [
              173.065,
              4882.548,
              61.873
            ],
            [
              169.677,
              4876.86,
              68.494
            ],
            [
              106.887,
              4896.161,
              134.183
            ],
            [
              65.284,
              4920.133,
              182.198
            ],
            [
              56.935,
              4922.512,
              190.879
            ],
            [
              38.922,
              4890.556,
              227.563
            ],
            [
              8.764,
              4794.253,
              328.477
            ],
            [
              -10.098,
              4715.557,
              409.402
            ],
            [
              -20.79,
              4660.091,
              465.889
            ],
            [
              -26.278,
              4606.755,
              519.507
            ],
            [
              -28.3,
              4495.47,
              630.81
            ],
            [
              -27.162,
              4273.918,
              852.365
            ],
            [
              -18.208,
              4269.302,
              862.439
            ],
            [
              130.759,
              4261.026,
              1011.636
            ],
            [
              339.461,
              4254.589,
              1220.437
            ],
            [
              343.708,
              4221.52,
              1253.778
            ],
            [
              363.696,
              4063.891,
              1412.669
            ],
            [
              372.087,
              3972.752,
              1504.193
            ],
            [
              375.049,
              3958.226,
              1519.018
            ],
            [
              372.971,
              3950.472,
              1527.046
            ],
            [
              369.038,
              3947.204,
              1532.159
            ],
            [
              354.089,
              3943.277,
              1547.616
            ],
            [
              330.159,
              3939.008,
              1571.923
            ],
            [
              288.801,
              3936.423,
              1613.362
            ],
            [
              255.146,
              3931.471,
              1647.379
            ],
            [
              244.74,
              3927.207,
              1658.625
            ],
            [
              217.197,
              3907.83,
              1692.301
            ],
            [
              195.233,
              3902.506,
              1714.902
            ],
            [
              191.24,
              3895.899,
              1722.621
            ],
            [
              180.169,
              3890.535,
              1734.923
            ],
            [
              173.716,
              3890.652,
              1741.378
            ],
            [
              166.034,
              3894.132,
              1749.811
            ],
            [
              159.078,
              3902.051,
              1760.351
            ],
            [
              157.95,
              3910.978,
              1769.349
            ],
            [
              162.024,
              3922.036,
              1781.134
            ],
            [
              167.288,
              3927.506,
              1788.725
            ],
            [
              180.213,
              3928.384,
              1801.68
            ],
            [
              192.997,
              3921.471,
              1816.214
            ],
            [
              194.227,
              3918.109,
              1819.793
            ],
            [
              201.929,
              3915.742,
              1827.851
            ],
            [
              218.162,
              3921.013,
              1844.918
            ],
            [
              228.044,
              3931.965,
              1859.67
            ],
            [
              360.751,
              3952.921,
              1994.021
            ],
            [
              375.672,
              3843.023,
              2104.927
            ],
            [
              398.438,
              3780.857,
              2171.13
            ],
            [
              423.248,
              3734.7,
              2223.533
            ],
            [
              449.718,
              3699.706,
              2267.411
            ],
            [
              489.722,
              3666.587,
              2319.345
            ],
            [
              524.294,
              3648.247,
              2358.481
            ],
            [
              632.02,
              3609.538,
              2472.95
            ],
            [
              682.727,
              3594.136,
              2525.945
            ],
            [
              736.158,
              3586.477,
              2579.922
            ],
            [
              825.762,
              3580.379,
              2669.733
            ],
            [
              940.191,
              3590.522,
              2784.611
            ],
            [
              906.986,
              3806.782,
              3003.405
            ],
            [
              901.522,
              3816.7,
              3014.729
            ],
            [
              862.991,
              3850.211,
              3065.793
            ],
            [
              857.792,
              3860.521,
              3077.34
            ],
            [
              858.019,
              3860.13,
              3077.792
            ],
            [
              889.732,
              3827.617,
              3123.21
            ],
            [
              898.479,
              3821.218,
              3134.048
            ],
            [
              908.103,
              3798.436,
              3158.779
            ],
            [
              943.156,
              3602.721,
              3357.609
            ],
            [
              1319.455,
              3681.496,
              3742.065
            ],
            [
              1545.858,
              3742.988,
              3976.67
            ],
            [
              1664.639,
              3778.637,
              4100.685
            ],
            [
              1674.798,
              3769.542,
              4114.321
            ],
            [
              1679.129,
              3759.443,
              4125.309
            ],
            [
              1679.506,
              3729.455,
              4155.3
            ],
            [
              1684.234,
              3721.498,
              4164.556
            ],
            [
              1679.247,
              3710.449,
              4176.678
            ],
            [
              1680.184,
              3591.526,
              4295.604
            ],
            [
              1696.885,
              3464.105,
              4424.115
            ],
            [
              1701.035,
              3409.48,
              4478.898
            ],
            [
              1703.196,
              3282.531,
              4605.865
            ],
            [
              1703.03,
              3134.473,
              4753.923
            ],
            [
              1699.891,
              3104.474,
              4784.086
            ],
            [
              1687.994,
              3054.599,
              4835.36
            ],
            [
              1659.262,
              3001.697,
              4895.561
            ],
            [
              1605.061,
              2932.568,
              4983.405
            ],
            [
              1556.997,
              2881.137,
              5053.799
            ],
            [
              1484.111,
              2813.466,
              5153.256
            ],
            [
              1478.391,
              2802.8,
              5165.359
            ],
            [
              1453.839,
              2781.743,
              5197.704
            ],
            [
              1433.991,
              2755.392,
              5230.694
            ],
            [
              1428.563,
              2741.021,
              5246.056
            ],
            [
              1382.281,
              2541.494,
              5450.88
            ],
            [
              1365.86,
              2456.079,
              5537.86
            ],
            [
              1336.284,
              2392.058,
              5608.382
            ],
            [
              1222.21,
              2196.952,
              5834.389
            ],
            [
              958.108,
              1933.7,
              6207.285
            ],
            [
              918.257,
              1878.079,
              6275.709
            ],
            [
              898.105,
              1863.557,
              6300.548
            ],
            [
              863.527,
              1836.207,
              6344.635
            ],
            [
              825.163,
              1791.425,
              6403.603
            ],
            [
              623.161,
              1858.587,
              6616.478
            ],
            [
              493.411,
              1911.506,
              6756.605
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:18375",
              "position": {
                "x": 190.96,
                "z": 4943.45
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 8.615,
              "arrivalOffsetSeconds": -240,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:9750",
              "position": {
                "x": 366.01,
                "z": 4064.148
              },
              "distanceAlongShapeM": 1412.669,
              "shapeOffsetM": 2.329,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:10359",
              "position": {
                "x": 228.044,
                "z": 3931.965
              },
              "distanceAlongShapeM": 1859.67,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:17003",
              "position": {
                "x": 916.272,
                "z": 3799.136
              },
              "distanceAlongShapeM": 2994.438,
              "shapeOffsetM": 8.018,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:6024",
              "position": {
                "x": 1319.455,
                "z": 3681.496
              },
              "distanceAlongShapeM": 3742.065,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:5998",
              "position": {
                "x": 1684.234,
                "z": 3721.498
              },
              "distanceAlongShapeM": 4164.556,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:5947",
              "position": {
                "x": 1478.744,
                "z": 2802.433
              },
              "distanceAlongShapeM": 5165.359,
              "shapeOffsetM": 0.509,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            },
            {
              "stopId": "judu:stop:5945",
              "position": {
                "x": 1224.883,
                "z": 2194.846
              },
              "distanceAlongShapeM": 5834.389,
              "shapeOffsetM": 3.403,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:5942",
              "position": {
                "x": 922.174,
                "z": 1874.247
              },
              "distanceAlongShapeM": 6275.709,
              "shapeOffsetM": 5.48,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:8264",
              "position": {
                "x": 493.148,
                "z": 1911.064
              },
              "distanceAlongShapeM": 6756.605,
              "shapeOffsetM": 0.515,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            }
          ],
          "departuresSeconds": [
            21180,
            31980,
            34140,
            38220,
            41520,
            45240,
            49020,
            52800,
            56340,
            58680,
            60180,
            63720,
            78660
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_expressbus_2G",
      "sourceRouteId": "vilnius_expressbus_2G",
      "mode": "bus",
      "shortName": "2G",
      "longName": "Santariškės–Laisvės pr.–Stotis",
      "color": "008000",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_expressbus_2G:0",
          "sourceRouteId": "vilnius_expressbus_2G",
          "sourceShapeId": "vilnius_expressbus_2G_a-b",
          "directionId": 0,
          "headsign": "Stotis",
          "directionName": "Santariškės–Laisvės pr.–Stotis",
          "mode": "bus",
          "routeShortName": "2G",
          "routeLongName": "Santariškės–Laisvės pr.–Stotis",
          "routeColor": "008000",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              71.413,
              -7563.928,
              0
            ],
            [
              68.088,
              -7589.527,
              25.814
            ],
            [
              45.368,
              -7598.945,
              50.409
            ],
            [
              37.787,
              -7591.014,
              61.38
            ],
            [
              26.258,
              -7471.636,
              181.314
            ],
            [
              8.189,
              -7201.951,
              451.603
            ],
            [
              -2.477,
              -7116.037,
              538.177
            ],
            [
              -10.317,
              -7079.698,
              575.352
            ],
            [
              -10.894,
              -7047.975,
              607.08
            ],
            [
              -21.671,
              -6897.49,
              757.951
            ],
            [
              -33.557,
              -6878.349,
              780.482
            ],
            [
              -59.463,
              -6851.158,
              818.038
            ],
            [
              -67.548,
              -6835.425,
              835.727
            ],
            [
              -70.502,
              -6820.899,
              850.55
            ],
            [
              -64.262,
              -6796.522,
              875.713
            ],
            [
              -53.909,
              -6786.595,
              890.056
            ],
            [
              -43.463,
              -6771.142,
              908.709
            ],
            [
              -41.984,
              -6740.153,
              939.733
            ],
            [
              -44.194,
              -6720.074,
              959.934
            ],
            [
              -50.641,
              -6695.446,
              985.391
            ],
            [
              -50.159,
              -6658.737,
              1022.104
            ],
            [
              -53.169,
              -6611.926,
              1069.011
            ],
            [
              -67.701,
              -6525.941,
              1156.216
            ],
            [
              -119.736,
              -6306.797,
              1381.453
            ],
            [
              -170.109,
              -6102.156,
              1592.202
            ],
            [
              -180.294,
              -6069.166,
              1626.728
            ],
            [
              -186.217,
              -6031.729,
              1664.631
            ],
            [
              -210.448,
              -5912.171,
              1786.62
            ],
            [
              -214.688,
              -5861.998,
              1836.972
            ],
            [
              -215.425,
              -5796.303,
              1902.671
            ],
            [
              -210.007,
              -5746.306,
              1952.961
            ],
            [
              -195.772,
              -5671.978,
              2028.64
            ],
            [
              -200.158,
              -5665.219,
              2036.697
            ],
            [
              -245.834,
              -5662.161,
              2082.475
            ],
            [
              -275.267,
              -5661.057,
              2111.929
            ],
            [
              -314.611,
              -5654.232,
              2151.861
            ],
            [
              -365.398,
              -5648.856,
              2202.931
            ],
            [
              -408.358,
              -5638.057,
              2247.228
            ],
            [
              -454.376,
              -5618.297,
              2297.309
            ],
            [
              -662.96,
              -5509.616,
              2532.509
            ],
            [
              -740.412,
              -5464.845,
              2621.97
            ],
            [
              -765.768,
              -5455.693,
              2648.927
            ],
            [
              -887.614,
              -5390.039,
              2787.335
            ],
            [
              -926.205,
              -5371.757,
              2830.038
            ],
            [
              -1090.384,
              -5275.062,
              3020.575
            ],
            [
              -1302.999,
              -5205.56,
              3244.262
            ],
            [
              -1387.113,
              -5180.474,
              3332.037
            ],
            [
              -1687.713,
              -4997.177,
              3684.114
            ],
            [
              -1731.791,
              -4976.352,
              3732.864
            ],
            [
              -1759.787,
              -4964.492,
              3763.268
            ],
            [
              -1786.639,
              -4945.316,
              3796.264
            ],
            [
              -1870.695,
              -4890.382,
              3896.679
            ],
            [
              -2020.603,
              -4770.824,
              4088.425
            ],
            [
              -2055.71,
              -4745.4,
              4131.771
            ],
            [
              -2116.546,
              -4695.646,
              4210.362
            ],
            [
              -2169.487,
              -4665.762,
              4271.155
            ],
            [
              -2190.603,
              -4657.594,
              4293.796
            ],
            [
              -2217.593,
              -4653.776,
              4321.054
            ],
            [
              -2245.097,
              -4651.92,
              4348.621
            ],
            [
              -2248.369,
              -4645.437,
              4355.883
            ],
            [
              -2421.69,
              -4610.083,
              4532.773
            ],
            [
              -2609.045,
              -4566.695,
              4725.086
            ],
            [
              -2630.024,
              -4563.338,
              4746.332
            ],
            [
              -2748.743,
              -4524.155,
              4871.35
            ],
            [
              -2770.501,
              -4511.218,
              4896.664
            ],
            [
              -2804.191,
              -4483.318,
              4940.406
            ],
            [
              -2811.989,
              -4476.099,
              4951.033
            ],
            [
              -2835.666,
              -4448.038,
              4987.748
            ],
            [
              -2880.475,
              -4394.928,
              5057.236
            ],
            [
              -2902.49,
              -4364.484,
              5094.806
            ],
            [
              -2922.066,
              -4325.629,
              5138.314
            ],
            [
              -2938.397,
              -4244.738,
              5220.836
            ],
            [
              -2943.47,
              -4203.459,
              5262.426
            ],
            [
              -2943.332,
              -4158.933,
              5306.952
            ],
            [
              -2942.883,
              -4106.854,
              5359.033
            ],
            [
              -2936.886,
              -4048.837,
              5417.359
            ],
            [
              -2933.232,
              -3950.938,
              5515.326
            ],
            [
              -2933.288,
              -3880.804,
              5585.46
            ],
            [
              -2935.53,
              -3825.104,
              5641.206
            ],
            [
              -2941.624,
              -3778.189,
              5688.515
            ],
            [
              -2941.11,
              -3739.288,
              5727.419
            ],
            [
              -2942.553,
              -3711.432,
              5755.312
            ],
            [
              -2962.772,
              -3578.604,
              5889.67
            ],
            [
              -2994.393,
              -3434.443,
              6037.259
            ],
            [
              -3009.522,
              -3378.516,
              6095.196
            ],
            [
              -3022.156,
              -3343.455,
              6132.464
            ],
            [
              -3029.648,
              -3313.596,
              6163.248
            ],
            [
              -3083.217,
              -3134.541,
              6350.145
            ],
            [
              -3102.428,
              -3054.053,
              6432.894
            ],
            [
              -3135.722,
              -2971.783,
              6521.645
            ],
            [
              -3158.619,
              -2877.179,
              6618.981
            ],
            [
              -3186.209,
              -2796.544,
              6704.205
            ],
            [
              -3248.067,
              -2685.253,
              6831.532
            ],
            [
              -3332.852,
              -2557.976,
              6984.463
            ],
            [
              -3345.044,
              -2540.486,
              7005.783
            ],
            [
              -3361.538,
              -2502.927,
              7046.804
            ],
            [
              -3386.79,
              -2435.693,
              7118.624
            ],
            [
              -3393.431,
              -2409.973,
              7145.187
            ],
            [
              -3395.464,
              -2378.768,
              7176.459
            ],
            [
              -3388.347,
              -2243.256,
              7312.158
            ],
            [
              -3384.424,
              -2226.45,
              7329.415
            ],
            [
              -3365.672,
              -2038.645,
              7518.154
            ],
            [
              -3370.713,
              -1991.384,
              7565.683
            ],
            [
              -3374.974,
              -1943.859,
              7613.399
            ],
            [
              -3391.774,
              -1872.32,
              7686.884
            ],
            [
              -3430.979,
              -1754.748,
              7810.82
            ],
            [
              -3480.186,
              -1619.191,
              7955.032
            ],
            [
              -3508.003,
              -1550.799,
              8028.865
            ],
            [
              -3521.109,
              -1520.135,
              8062.212
            ],
            [
              -3534.455,
              -1477.979,
              8106.43
            ],
            [
              -3620.717,
              -1211.532,
              8386.493
            ],
            [
              -3662.686,
              -1103.933,
              8501.987
            ],
            [
              -3677.364,
              -1066.903,
              8541.821
            ],
            [
              -3720.589,
              -911.454,
              8703.167
            ],
            [
              -3751.424,
              -837.404,
              8783.38
            ],
            [
              -3758.325,
              -817.25,
              8804.683
            ],
            [
              -3766.218,
              -791.548,
              8831.57
            ],
            [
              -3793.988,
              -719.82,
              8908.486
            ],
            [
              -3843.779,
              -616.54,
              9023.141
            ],
            [
              -3881.258,
              -546.871,
              9102.252
            ],
            [
              -3968.352,
              -399.129,
              9273.754
            ],
            [
              -3983.006,
              -376.666,
              9300.574
            ],
            [
              -3999.719,
              -350.005,
              9332.041
            ],
            [
              -4048.201,
              -282.373,
              9415.255
            ],
            [
              -4133.499,
              -180.709,
              9547.963
            ],
            [
              -4196.231,
              -117.271,
              9637.179
            ],
            [
              -4217.103,
              -95.271,
              9667.505
            ],
            [
              -4243.751,
              -67.483,
              9706.006
            ],
            [
              -4402.336,
              85.535,
              9926.377
            ],
            [
              -4449.086,
              142,
              9999.684
            ],
            [
              -4479.797,
              193.736,
              10059.849
            ],
            [
              -4502.905,
              237.549,
              10109.382
            ],
            [
              -4519.036,
              274.562,
              10149.757
            ],
            [
              -4536.228,
              324.952,
              10202.999
            ],
            [
              -4547.048,
              370.78,
              10250.087
            ],
            [
              -4566.578,
              510.266,
              10390.934
            ],
            [
              -4570.606,
              537.669,
              10418.632
            ],
            [
              -4575.517,
              590.57,
              10471.76
            ],
            [
              -4579.623,
              651.866,
              10533.193
            ],
            [
              -4586.366,
              709.869,
              10591.587
            ],
            [
              -4584.541,
              741.007,
              10622.778
            ],
            [
              -4573.306,
              794.248,
              10677.192
            ],
            [
              -4555.909,
              830.684,
              10717.568
            ],
            [
              -4538.646,
              859.331,
              10751.015
            ],
            [
              -4503.175,
              896.569,
              10802.443
            ],
            [
              -4462.091,
              922.579,
              10851.068
            ],
            [
              -4443.54,
              937.916,
              10875.138
            ],
            [
              -4396.195,
              965.972,
              10930.171
            ],
            [
              -4188.107,
              1100.42,
              11177.915
            ],
            [
              -4152.942,
              1128.063,
              11222.645
            ],
            [
              -4048.114,
              1175.924,
              11337.882
            ],
            [
              -3997.487,
              1193.972,
              11391.629
            ],
            [
              -3829.673,
              1236.704,
              11564.799
            ],
            [
              -3789.4,
              1252.704,
              11608.133
            ],
            [
              -3749.695,
              1273.165,
              11652.8
            ],
            [
              -3705.908,
              1305.8,
              11707.411
            ],
            [
              -3669.839,
              1339.683,
              11756.899
            ],
            [
              -3634.26,
              1382.479,
              11812.553
            ],
            [
              -3619.001,
              1406.704,
              11841.183
            ],
            [
              -3601.633,
              1440.911,
              11879.547
            ],
            [
              -3592.427,
              1468.215,
              11908.361
            ],
            [
              -3579.402,
              1495.072,
              11938.21
            ],
            [
              -3566.606,
              1526.019,
              11971.698
            ],
            [
              -3560.672,
              1570.444,
              12016.517
            ],
            [
              -3561.909,
              1610.54,
              12056.632
            ],
            [
              -3553.124,
              1670.501,
              12117.234
            ],
            [
              -3546.511,
              1753.876,
              12200.87
            ],
            [
              -3528.502,
              1849.211,
              12297.892
            ],
            [
              -3507.519,
              1881.216,
              12336.162
            ],
            [
              -3466.64,
              1929.443,
              12399.383
            ],
            [
              -3411.117,
              1970.818,
              12468.627
            ],
            [
              -3378.421,
              1984.588,
              12504.104
            ],
            [
              -3293.772,
              2003.28,
              12590.792
            ],
            [
              -3253.06,
              2007.021,
              12631.676
            ],
            [
              -3234.374,
              2005.581,
              12650.417
            ],
            [
              -3211.057,
              2010.74,
              12674.298
            ],
            [
              -2960.432,
              2100.974,
              12940.672
            ],
            [
              -2902.519,
              2128.901,
              13004.967
            ],
            [
              -2763.528,
              2181.007,
              13153.404
            ],
            [
              -2704.044,
              2203.421,
              13216.971
            ],
            [
              -2694.973,
              2206.697,
              13226.616
            ],
            [
              -2620.644,
              2234.153,
              13305.853
            ],
            [
              -2602.113,
              2260.544,
              13338.1
            ],
            [
              -2588.136,
              2284.788,
              13366.085
            ],
            [
              -2571.13,
              2297.847,
              13387.526
            ],
            [
              -2532.153,
              2312.745,
              13429.253
            ],
            [
              -2506.977,
              2313.414,
              13454.438
            ],
            [
              -2483.854,
              2307.44,
              13478.32
            ],
            [
              -2455.846,
              2285.795,
              13513.718
            ],
            [
              -2438.355,
              2253.203,
              13550.706
            ],
            [
              -2433.47,
              2237.532,
              13567.121
            ],
            [
              -2435.723,
              2169.786,
              13634.904
            ],
            [
              -2432.837,
              2155.209,
              13649.765
            ],
            [
              -2421.673,
              2138.248,
              13670.07
            ],
            [
              -2405.237,
              2119.033,
              13695.355
            ],
            [
              -2339.12,
              2063.317,
              13781.818
            ],
            [
              -2328.352,
              2051.995,
              13797.443
            ],
            [
              -2314.582,
              2044.048,
              13813.341
            ],
            [
              -2298.509,
              2024.75,
              13838.456
            ],
            [
              -1925.909,
              1679.727,
              14346.267
            ],
            [
              -1869.698,
              1631.955,
              14420.035
            ],
            [
              -1860.469,
              1622.903,
              14432.963
            ],
            [
              -1769.084,
              1537.785,
              14557.848
            ],
            [
              -1704.495,
              1480.033,
              14644.491
            ],
            [
              -1698.901,
              1478.9,
              14650.198
            ],
            [
              -1682.168,
              1491.708,
              14671.27
            ],
            [
              -1671.651,
              1502.653,
              14686.449
            ],
            [
              -1651.454,
              1530.355,
              14720.732
            ],
            [
              -1603.973,
              1571.579,
              14783.612
            ],
            [
              -1299.013,
              1921.245,
              15247.581
            ],
            [
              -1270.801,
              1947.457,
              15286.09
            ],
            [
              -1190.297,
              2047.317,
              15414.359
            ],
            [
              -1173.912,
              2061.495,
              15436.027
            ],
            [
              -1158.937,
              2069.019,
              15452.786
            ],
            [
              -1145.392,
              2068.776,
              15466.333
            ],
            [
              -1135.112,
              2066.366,
              15476.892
            ],
            [
              -987.662,
              2013.623,
              15633.491
            ],
            [
              -960.072,
              2006.847,
              15661.901
            ],
            [
              -943.398,
              1999.468,
              15680.135
            ],
            [
              -544.505,
              1865.369,
              16100.965
            ],
            [
              -471.457,
              1839.899,
              16178.326
            ],
            [
              -420.186,
              1818.591,
              16233.848
            ],
            [
              -302.823,
              1779.729,
              16357.478
            ],
            [
              -124.613,
              1752.004,
              16537.832
            ],
            [
              29.934,
              1735.835,
              16693.223
            ],
            [
              64.443,
              1752.06,
              16731.355
            ],
            [
              97.435,
              1757.984,
              16764.875
            ],
            [
              156.41,
              1772.494,
              16825.609
            ],
            [
              318.606,
              1821.856,
              16995.15
            ],
            [
              358.443,
              1883.47,
              17068.521
            ],
            [
              374.971,
              1912.538,
              17101.959
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:7831",
              "position": {
                "x": 25.801,
                "z": -7471.678
              },
              "distanceAlongShapeM": 181.314,
              "shapeOffsetM": 0.459,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:6526",
              "position": {
                "x": -15.345,
                "z": -7080.178
              },
              "distanceAlongShapeM": 575.352,
              "shapeOffsetM": 5.051,
              "arrivalOffsetSeconds": 60,
              "departureOffsetSeconds": 60
            },
            {
              "stopId": "judu:stop:6501",
              "position": {
                "x": -182.398,
                "z": -6069.649
              },
              "distanceAlongShapeM": 1626.728,
              "shapeOffsetM": 2.159,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:6634",
              "position": {
                "x": -663.705,
                "z": -5510.974
              },
              "distanceAlongShapeM": 2532.509,
              "shapeOffsetM": 1.549,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:5814",
              "position": {
                "x": -1387.604,
                "z": -5181.778
              },
              "distanceAlongShapeM": 3332.037,
              "shapeOffsetM": 1.394,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:5812",
              "position": {
                "x": -1760.592,
                "z": -4965.819
              },
              "distanceAlongShapeM": 3763.268,
              "shapeOffsetM": 1.552,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:8269",
              "position": {
                "x": -2245.99,
                "z": -4656.611
              },
              "distanceAlongShapeM": 4348.621,
              "shapeOffsetM": 4.776,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:6523",
              "position": {
                "x": -2947.565,
                "z": -4106.537
              },
              "distanceAlongShapeM": 5359.033,
              "shapeOffsetM": 4.693,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:6482",
              "position": {
                "x": -2942.439,
                "z": -3778.227
              },
              "distanceAlongShapeM": 5688.515,
              "shapeOffsetM": 0.816,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:6477",
              "position": {
                "x": -3137.083,
                "z": -2972.18
              },
              "distanceAlongShapeM": 6521.645,
              "shapeOffsetM": 1.418,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:5620",
              "position": {
                "x": -3375.166,
                "z": -1991.724
              },
              "distanceAlongShapeM": 7565.742,
              "shapeOffsetM": 4.466,
              "arrivalOffsetSeconds": 1410,
              "departureOffsetSeconds": 1410
            },
            {
              "stopId": "judu:stop:928",
              "position": {
                "x": -3525.544,
                "z": -1521.55
              },
              "distanceAlongShapeM": 8062.212,
              "shapeOffsetM": 4.655,
              "arrivalOffsetSeconds": 1560,
              "departureOffsetSeconds": 1560
            },
            {
              "stopId": "judu:stop:5643",
              "position": {
                "x": -3680.758,
                "z": -1067.996
              },
              "distanceAlongShapeM": 8541.821,
              "shapeOffsetM": 3.566,
              "arrivalOffsetSeconds": 1680,
              "departureOffsetSeconds": 1680
            },
            {
              "stopId": "judu:stop:5651",
              "position": {
                "x": -3986.683,
                "z": -379.175
              },
              "distanceAlongShapeM": 9300.482,
              "shapeOffsetM": 4.451,
              "arrivalOffsetSeconds": 1800,
              "departureOffsetSeconds": 1800
            },
            {
              "stopId": "judu:stop:5668",
              "position": {
                "x": -4574.501,
                "z": 537.119
              },
              "distanceAlongShapeM": 10418.632,
              "shapeOffsetM": 3.934,
              "arrivalOffsetSeconds": 1920,
              "departureOffsetSeconds": 1920
            },
            {
              "stopId": "judu:stop:6461",
              "position": {
                "x": -4154.055,
                "z": 1129.888
              },
              "distanceAlongShapeM": 11222.645,
              "shapeOffsetM": 2.137,
              "arrivalOffsetSeconds": 2040,
              "departureOffsetSeconds": 2040
            },
            {
              "stopId": "judu:stop:6333",
              "position": {
                "x": -3596.615,
                "z": 1469.767
              },
              "distanceAlongShapeM": 11908.361,
              "shapeOffsetM": 4.467,
              "arrivalOffsetSeconds": 2100,
              "departureOffsetSeconds": 2100
            },
            {
              "stopId": "judu:stop:5535",
              "position": {
                "x": -2313.635,
                "z": 2045.055
              },
              "distanceAlongShapeM": 13813.341,
              "shapeOffsetM": 1.383,
              "arrivalOffsetSeconds": 2340,
              "departureOffsetSeconds": 2340
            },
            {
              "stopId": "judu:stop:7853",
              "position": {
                "x": -1868.675,
                "z": 1633.068
              },
              "distanceAlongShapeM": 14420.035,
              "shapeOffsetM": 1.512,
              "arrivalOffsetSeconds": 2460,
              "departureOffsetSeconds": 2460
            },
            {
              "stopId": "judu:stop:6366",
              "position": {
                "x": -1299.013,
                "z": 1921.245
              },
              "distanceAlongShapeM": 15247.581,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2640,
              "departureOffsetSeconds": 2640
            },
            {
              "stopId": "judu:stop:6363",
              "position": {
                "x": -958.677,
                "z": 2010.875
              },
              "distanceAlongShapeM": 15661.901,
              "shapeOffsetM": 4.262,
              "arrivalOffsetSeconds": 2700,
              "departureOffsetSeconds": 2700
            },
            {
              "stopId": "judu:stop:5166",
              "position": {
                "x": -470.051,
                "z": 1843.985
              },
              "distanceAlongShapeM": 16178.308,
              "shapeOffsetM": 4.322,
              "arrivalOffsetSeconds": 2880,
              "departureOffsetSeconds": 2880
            },
            {
              "stopId": "judu:stop:3616",
              "position": {
                "x": 373.827,
                "z": 1913.246
              },
              "distanceAlongShapeM": 17101.959,
              "shapeOffsetM": 1.345,
              "arrivalOffsetSeconds": 3120,
              "departureOffsetSeconds": 3120
            }
          ],
          "departuresSeconds": [
            19320,
            19980,
            20700,
            21060,
            21660,
            22080,
            22500,
            22860,
            23220,
            23580,
            23940,
            24300,
            24660,
            25080,
            25500,
            25920,
            26340,
            26760,
            27180,
            27600,
            28020,
            28500,
            28980,
            29400,
            29880,
            30300,
            30780,
            31320,
            31860,
            32460,
            33060,
            33660,
            34260,
            34920,
            35520,
            36060,
            36600,
            37080,
            37560,
            37980,
            38460,
            38820,
            39240,
            39840,
            40440,
            40920,
            41400,
            42000,
            42660,
            43140,
            43740,
            44280,
            44760,
            45240,
            45720,
            46200,
            46680,
            47280,
            47820,
            48300,
            48780,
            49320,
            49860,
            50340,
            50880,
            51420,
            51960,
            52440,
            52980,
            53520,
            54180,
            54600,
            55020,
            55620,
            56220,
            56760,
            57360,
            57840,
            58380,
            58920,
            59460,
            59940,
            60480,
            60960,
            61380,
            61800,
            62220,
            62640,
            63060,
            63480,
            63900,
            64380,
            64920,
            65460,
            66300,
            67320,
            67740,
            68280,
            68820,
            69420,
            69960,
            70500,
            71160,
            71820,
            72420,
            72900,
            73500,
            74100,
            74760,
            75300,
            75900,
            76500,
            77040,
            77580,
            78120,
            78600,
            79080,
            79680,
            80280,
            80940,
            81480,
            82620
          ]
        },
        {
          "id": "judu:pattern:vilnius_expressbus_2G:1",
          "sourceRouteId": "vilnius_expressbus_2G",
          "sourceShapeId": "vilnius_expressbus_2G_b-a",
          "directionId": 1,
          "headsign": "Santariškės",
          "directionName": "Stotis–Laisvės pr.–Santariškės",
          "mode": "bus",
          "routeShortName": "2G",
          "routeLongName": "Santariškės–Laisvės pr.–Stotis",
          "routeColor": "008000",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              374.971,
              1912.538,
              0
            ],
            [
              381.688,
              1919.781,
              9.878
            ],
            [
              390.297,
              1931.87,
              24.719
            ],
            [
              381.613,
              1950.953,
              45.685
            ],
            [
              374.681,
              1959.986,
              57.072
            ],
            [
              359.73,
              1989.203,
              89.892
            ],
            [
              357.312,
              1998.153,
              99.163
            ],
            [
              360.055,
              2007.009,
              108.434
            ],
            [
              365.317,
              2012.479,
              116.024
            ],
            [
              381.462,
              2013.297,
              132.189
            ],
            [
              469.575,
              1962.704,
              233.794
            ],
            [
              480.298,
              1952.175,
              248.822
            ],
            [
              481.71,
              1947.816,
              253.405
            ],
            [
              476.141,
              1933.639,
              268.636
            ],
            [
              470.194,
              1925.956,
              278.352
            ],
            [
              463.683,
              1922.735,
              285.616
            ],
            [
              447.558,
              1923.03,
              301.744
            ],
            [
              415.411,
              1929.184,
              334.474
            ],
            [
              398.6,
              1927.265,
              351.395
            ],
            [
              334.106,
              1822.687,
              474.261
            ],
            [
              318.606,
              1821.856,
              489.783
            ],
            [
              29.934,
              1735.835,
              790.999
            ],
            [
              -11.394,
              1732.372,
              832.471
            ],
            [
              -46.755,
              1740.57,
              868.77
            ],
            [
              -320.217,
              1781.157,
              1145.228
            ],
            [
              -550.531,
              1853.232,
              1386.556
            ],
            [
              -581.279,
              1862.523,
              1418.677
            ],
            [
              -596.688,
              1869.651,
              1435.655
            ],
            [
              -1032.712,
              2019.998,
              1896.872
            ],
            [
              -1047.441,
              2021.391,
              1911.666
            ],
            [
              -1075.687,
              2034.129,
              1942.652
            ],
            [
              -1134.042,
              2054.101,
              2004.33
            ],
            [
              -1154.642,
              2056.697,
              2025.093
            ],
            [
              -1164.417,
              2051.306,
              2036.256
            ],
            [
              -1208.37,
              2010.905,
              2095.956
            ],
            [
              -1267.715,
              1939.609,
              2188.719
            ],
            [
              -1394.1,
              1799.379,
              2377.498
            ],
            [
              -1413.741,
              1770.628,
              2412.318
            ],
            [
              -1434.923,
              1753.354,
              2439.65
            ],
            [
              -1515.962,
              1659.065,
              2563.979
            ],
            [
              -1594.12,
              1581.422,
              2674.148
            ],
            [
              -1692.298,
              1466.285,
              2825.46
            ],
            [
              -1701.366,
              1464.22,
              2834.76
            ],
            [
              -1708.441,
              1465.459,
              2841.943
            ],
            [
              -1712.191,
              1472.205,
              2849.661
            ],
            [
              -1970.62,
              1705.012,
              3197.49
            ],
            [
              -1985.783,
              1723.093,
              3221.087
            ],
            [
              -2263.842,
              1978.495,
              3598.641
            ],
            [
              -2290.557,
              2000.118,
              3633.01
            ],
            [
              -2318.992,
              2034.018,
              3677.257
            ],
            [
              -2425.036,
              2130.514,
              3820.634
            ],
            [
              -2441.629,
              2140.826,
              3840.17
            ],
            [
              -2453.884,
              2141.043,
              3852.427
            ],
            [
              -2464.869,
              2140.123,
              3863.45
            ],
            [
              -2491.57,
              2126.123,
              3893.599
            ],
            [
              -2514.888,
              2120.968,
              3917.48
            ],
            [
              -2528.453,
              2120.094,
              3931.073
            ],
            [
              -2551.595,
              2124.955,
              3954.72
            ],
            [
              -2561.443,
              2130.364,
              3965.956
            ],
            [
              -2579.681,
              2142.148,
              3987.669
            ],
            [
              -2607.297,
              2186.05,
              4039.535
            ],
            [
              -2618.809,
              2191.819,
              4052.412
            ],
            [
              -2640.075,
              2193.306,
              4073.729
            ],
            [
              -2665.388,
              2184.846,
              4100.419
            ],
            [
              -2681.67,
              2176.227,
              4118.841
            ],
            [
              -2692.184,
              2172.41,
              4130.027
            ],
            [
              -2738.119,
              2158.296,
              4178.081
            ],
            [
              -2899.782,
              2101.023,
              4349.59
            ],
            [
              -2971.67,
              2085.586,
              4423.116
            ],
            [
              -3160.259,
              2016.062,
              4624.112
            ],
            [
              -3215.258,
              1991.889,
              4684.189
            ],
            [
              -3241.166,
              1975.384,
              4714.908
            ],
            [
              -3275.786,
              1961.777,
              4752.106
            ],
            [
              -3353.278,
              1920.828,
              4839.752
            ],
            [
              -3402.898,
              1887.184,
              4899.702
            ],
            [
              -3447.61,
              1838.983,
              4965.448
            ],
            [
              -3464.825,
              1813.679,
              4996.053
            ],
            [
              -3479.576,
              1781.653,
              5031.313
            ],
            [
              -3552.495,
              1521.32,
              5301.665
            ],
            [
              -3561.139,
              1488.768,
              5335.346
            ],
            [
              -3571.509,
              1457.992,
              5367.821
            ],
            [
              -3607.243,
              1385.693,
              5448.469
            ],
            [
              -3647.326,
              1335.952,
              5512.35
            ],
            [
              -3697.872,
              1285.623,
              5583.68
            ],
            [
              -3750.727,
              1250.919,
              5646.91
            ],
            [
              -3785.215,
              1233.706,
              5685.455
            ],
            [
              -3881.236,
              1201.976,
              5786.583
            ],
            [
              -3947.947,
              1186.435,
              5855.08
            ],
            [
              -4028.355,
              1162.223,
              5939.054
            ],
            [
              -4081.657,
              1138.655,
              5997.334
            ],
            [
              -4117.491,
              1118.124,
              6038.633
            ],
            [
              -4158.16,
              1094.22,
              6085.806
            ],
            [
              -4168.309,
              1088.946,
              6097.244
            ],
            [
              -4405.143,
              935,
              6379.715
            ],
            [
              -4424.214,
              922.705,
              6402.405
            ],
            [
              -4433.353,
              916.8,
              6413.287
            ],
            [
              -4463.138,
              899.22,
              6447.873
            ],
            [
              -4519.455,
              850.095,
              6522.605
            ],
            [
              -4559.388,
              778.424,
              6604.65
            ],
            [
              -4567.189,
              737.369,
              6646.439
            ],
            [
              -4562.176,
              653.793,
              6730.165
            ],
            [
              -4542.083,
              471.996,
              6913.069
            ],
            [
              -4535.565,
              436.694,
              6948.968
            ],
            [
              -4533.311,
              419.524,
              6966.285
            ],
            [
              -4527.744,
              368.221,
              7017.89
            ],
            [
              -4516.259,
              323.495,
              7064.067
            ],
            [
              -4491.638,
              255.166,
              7136.696
            ],
            [
              -4427.619,
              152.763,
              7257.464
            ],
            [
              -4367.011,
              77.134,
              7354.382
            ],
            [
              -4080.333,
              -210.913,
              7760.774
            ],
            [
              -3954.469,
              -380.846,
              7972.243
            ],
            [
              -3926.158,
              -422.036,
              8022.225
            ],
            [
              -3919.036,
              -433.74,
              8035.925
            ],
            [
              -3857.936,
              -540.596,
              8159.016
            ],
            [
              -3823.641,
              -607.984,
              8234.629
            ],
            [
              -3766.483,
              -732.543,
              8371.676
            ],
            [
              -3707.64,
              -908.34,
              8557.06
            ],
            [
              -3695.741,
              -928.584,
              8580.542
            ],
            [
              -3679.687,
              -950.175,
              8607.447
            ],
            [
              -3673.878,
              -969.04,
              8627.187
            ],
            [
              -3654.555,
              -1007.226,
              8669.983
            ],
            [
              -3618.264,
              -1069.098,
              8741.713
            ],
            [
              -3599.031,
              -1113.947,
              8790.512
            ],
            [
              -3569.469,
              -1193.5,
              8875.38
            ],
            [
              -3554.873,
              -1243.849,
              8927.802
            ],
            [
              -3546.348,
              -1270.446,
              8955.732
            ],
            [
              -3520.478,
              -1415.883,
              9103.452
            ],
            [
              -3500.646,
              -1498.607,
              9188.52
            ],
            [
              -3461.302,
              -1608.388,
              9305.138
            ],
            [
              -3438.975,
              -1658.872,
              9360.339
            ],
            [
              -3424.066,
              -1696.754,
              9401.05
            ],
            [
              -3409.647,
              -1735.195,
              9442.106
            ],
            [
              -3354.323,
              -1899.889,
              9615.844
            ],
            [
              -3343.31,
              -1954.868,
              9671.915
            ],
            [
              -3339.232,
              -2037.994,
              9755.141
            ],
            [
              -3350.012,
              -2176.443,
              9894.008
            ],
            [
              -3368.406,
              -2305.768,
              10024.635
            ],
            [
              -3372.034,
              -2365.819,
              10084.796
            ],
            [
              -3365.771,
              -2420.444,
              10139.779
            ],
            [
              -3338.206,
              -2495.543,
              10219.777
            ],
            [
              -3294.464,
              -2574.233,
              10309.807
            ],
            [
              -3260.996,
              -2616.85,
              10363.995
            ],
            [
              -3240.415,
              -2653.104,
              10405.684
            ],
            [
              -3181.544,
              -2750.984,
              10519.904
            ],
            [
              -3157.274,
              -2800.391,
              10574.95
            ],
            [
              -3108.891,
              -2944.844,
              10727.29
            ],
            [
              -3088.313,
              -3020.904,
              10806.085
            ],
            [
              -3081.131,
              -3038.915,
              10825.475
            ],
            [
              -3066.407,
              -3094.76,
              10883.229
            ],
            [
              -3058.312,
              -3116.524,
              10906.45
            ],
            [
              -3044.503,
              -3168.617,
              10960.341
            ],
            [
              -2983.753,
              -3378.969,
              11179.29
            ],
            [
              -2973.575,
              -3406.127,
              11208.293
            ],
            [
              -2964.33,
              -3447.216,
              11250.409
            ],
            [
              -2935.834,
              -3585.756,
              11391.849
            ],
            [
              -2926.739,
              -3654.936,
              11461.624
            ],
            [
              -2914.467,
              -3799.87,
              11607.077
            ],
            [
              -2911.34,
              -3835.779,
              11643.122
            ],
            [
              -2910.491,
              -3863.444,
              11670.8
            ],
            [
              -2921.12,
              -4178.248,
              11985.783
            ],
            [
              -2920.043,
              -4206.629,
              12014.185
            ],
            [
              -2916.033,
              -4240.012,
              12047.808
            ],
            [
              -2908.744,
              -4273.666,
              12082.242
            ],
            [
              -2894.838,
              -4317.386,
              12128.12
            ],
            [
              -2876.57,
              -4356.153,
              12170.976
            ],
            [
              -2823.799,
              -4432.662,
              12263.919
            ],
            [
              -2759.103,
              -4490.576,
              12350.75
            ],
            [
              -2703.07,
              -4524.178,
              12416.086
            ],
            [
              -2600.663,
              -4562.712,
              12525.503
            ],
            [
              -2523.056,
              -4586.026,
              12606.536
            ],
            [
              -2471.67,
              -4594.727,
              12658.654
            ],
            [
              -2274.597,
              -4634.953,
              12859.79
            ],
            [
              -2190.603,
              -4657.594,
              12946.782
            ],
            [
              -2137.713,
              -4671.9,
              13001.573
            ],
            [
              -2112.872,
              -4685.417,
              13029.853
            ],
            [
              -2099.157,
              -4695.955,
              13047.149
            ],
            [
              -2067.351,
              -4718.784,
              13086.3
            ],
            [
              -2007.683,
              -4768.827,
              13164.175
            ],
            [
              -1998.706,
              -4771.214,
              13173.464
            ],
            [
              -1979.306,
              -4767.106,
              13193.294
            ],
            [
              -1962.099,
              -4770.654,
              13210.863
            ],
            [
              -1951.469,
              -4783.649,
              13227.652
            ],
            [
              -1941.516,
              -4815.647,
              13261.163
            ],
            [
              -1918.262,
              -4848.345,
              13301.286
            ],
            [
              -1854.05,
              -4896.245,
              13381.396
            ],
            [
              -1743.848,
              -4966.117,
              13511.882
            ],
            [
              -1676.24,
              -5004.061,
              13589.41
            ],
            [
              -1627.812,
              -5023.801,
              13641.706
            ],
            [
              -1586.957,
              -5054.639,
              13692.894
            ],
            [
              -1465.895,
              -5129.166,
              13835.056
            ],
            [
              -1407.208,
              -5161.388,
              13902.007
            ],
            [
              -1338.038,
              -5183.78,
              13974.712
            ],
            [
              -1272.777,
              -5203.963,
              14043.023
            ],
            [
              -1246.49,
              -5215.481,
              14071.722
            ],
            [
              -1208.756,
              -5230.63,
              14112.383
            ],
            [
              -1099.904,
              -5267.098,
              14227.182
            ],
            [
              -1057.683,
              -5283.443,
              14272.456
            ],
            [
              -934.323,
              -5346.656,
              14411.069
            ],
            [
              -827.457,
              -5404.886,
              14532.77
            ],
            [
              -674.33,
              -5492.97,
              14709.424
            ],
            [
              -590.252,
              -5533.933,
              14802.95
            ],
            [
              -509.147,
              -5583.907,
              14898.215
            ],
            [
              -408.358,
              -5638.057,
              15012.629
            ],
            [
              -376.948,
              -5646.42,
              15045.133
            ],
            [
              -183.275,
              -5657.733,
              15239.136
            ],
            [
              -188.212,
              -5716.645,
              15298.255
            ],
            [
              -190.648,
              -5736.736,
              15318.493
            ],
            [
              -196.91,
              -5769.923,
              15352.266
            ],
            [
              -201.665,
              -5818.819,
              15401.392
            ],
            [
              -201.086,
              -5857.793,
              15440.371
            ],
            [
              -195.599,
              -5910.215,
              15493.079
            ],
            [
              -136.015,
              -6175.138,
              15764.62
            ],
            [
              -127.679,
              -6205.529,
              15796.133
            ],
            [
              -123.468,
              -6228.802,
              15819.784
            ],
            [
              -113.557,
              -6285.758,
              15877.596
            ],
            [
              -58.166,
              -6532.794,
              16130.766
            ],
            [
              -46.468,
              -6597.576,
              16196.596
            ],
            [
              -39.377,
              -6667.839,
              16267.216
            ],
            [
              -35.045,
              -6748.072,
              16347.566
            ],
            [
              -26.235,
              -6767.677,
              16369.059
            ],
            [
              -16.413,
              -6780.218,
              16384.989
            ],
            [
              0.443,
              -6790.505,
              16404.736
            ],
            [
              9.552,
              -6811.226,
              16427.37
            ],
            [
              9.735,
              -6827.796,
              16443.942
            ],
            [
              7.024,
              -6842.352,
              16458.748
            ],
            [
              -10.864,
              -6869.857,
              16491.558
            ],
            [
              -21.671,
              -6897.49,
              16521.229
            ],
            [
              -11.966,
              -6926.765,
              16552.07
            ],
            [
              -9.853,
              -6955.595,
              16580.978
            ],
            [
              6.027,
              -7144.023,
              16770.074
            ],
            [
              11.629,
              -7176.924,
              16803.448
            ],
            [
              10.845,
              -7197.547,
              16824.086
            ],
            [
              32.291,
              -7398.322,
              17026.004
            ],
            [
              36.523,
              -7443.114,
              17070.995
            ],
            [
              37.062,
              -7489.696,
              17117.58
            ],
            [
              41.201,
              -7509.81,
              17138.116
            ],
            [
              62.699,
              -7531.354,
              17168.551
            ],
            [
              71.413,
              -7563.928,
              17202.27
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:3616",
              "position": {
                "x": 373.827,
                "z": 1913.246
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 1.345,
              "arrivalOffsetSeconds": -120,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:5167",
              "position": {
                "x": -582.7,
                "z": 1858.267
              },
              "distanceAlongShapeM": 1418.677,
              "shapeOffsetM": 4.487,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:6362",
              "position": {
                "x": -1048.212,
                "z": 2019.164
              },
              "distanceAlongShapeM": 1911.666,
              "shapeOffsetM": 2.357,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:6365",
              "position": {
                "x": -1411.426,
                "z": 1768.519
              },
              "distanceAlongShapeM": 2412.318,
              "shapeOffsetM": 3.132,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:7852",
              "position": {
                "x": -1970.62,
                "z": 1705.012
              },
              "distanceAlongShapeM": 3197.49,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:5532",
              "position": {
                "x": -2290.557,
                "z": 2000.118
              },
              "distanceAlongShapeM": 3633.01,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:790",
              "position": {
                "x": -3555.031,
                "z": 1486.855
              },
              "distanceAlongShapeM": 5335.346,
              "shapeOffsetM": 6.401,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:6648",
              "position": {
                "x": -4156.018,
                "z": 1090.96
              },
              "distanceAlongShapeM": 6085.612,
              "shapeOffsetM": 3.896,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:1071",
              "position": {
                "x": -4530.426,
                "z": 437.286
              },
              "distanceAlongShapeM": 6949.05,
              "shapeOffsetM": 5.172,
              "arrivalOffsetSeconds": 1380,
              "departureOffsetSeconds": 1380
            },
            {
              "stopId": "judu:stop:6649",
              "position": {
                "x": -3921.604,
                "z": -419.265
              },
              "distanceAlongShapeM": 8022.225,
              "shapeOffsetM": 5.33,
              "arrivalOffsetSeconds": 1500,
              "departureOffsetSeconds": 1500
            },
            {
              "stopId": "judu:stop:6643",
              "position": {
                "x": -3679.35,
                "z": -950.021
              },
              "distanceAlongShapeM": 8607.447,
              "shapeOffsetM": 0.37,
              "arrivalOffsetSeconds": 1560,
              "departureOffsetSeconds": 1560
            },
            {
              "stopId": "judu:stop:4990",
              "position": {
                "x": -3543.073,
                "z": -1269.659
              },
              "distanceAlongShapeM": 8955.732,
              "shapeOffsetM": 3.368,
              "arrivalOffsetSeconds": 1680,
              "departureOffsetSeconds": 1680
            },
            {
              "stopId": "judu:stop:6472",
              "position": {
                "x": -3345.53,
                "z": -2177.035
              },
              "distanceAlongShapeM": 9894.008,
              "shapeOffsetM": 4.521,
              "arrivalOffsetSeconds": 1860,
              "departureOffsetSeconds": 1860
            },
            {
              "stopId": "judu:stop:5067",
              "position": {
                "x": -3053.229,
                "z": -3115.03
              },
              "distanceAlongShapeM": 10906.45,
              "shapeOffsetM": 5.298,
              "arrivalOffsetSeconds": 2100,
              "departureOffsetSeconds": 2100
            },
            {
              "stopId": "judu:stop:6481",
              "position": {
                "x": -2906.719,
                "z": -3835.629
              },
              "distanceAlongShapeM": 11643.122,
              "shapeOffsetM": 4.623,
              "arrivalOffsetSeconds": 2220,
              "departureOffsetSeconds": 2220
            },
            {
              "stopId": "judu:stop:6653",
              "position": {
                "x": -2914.524,
                "z": -4206.195
              },
              "distanceAlongShapeM": 12014.412,
              "shapeOffsetM": 5.531,
              "arrivalOffsetSeconds": 2280,
              "departureOffsetSeconds": 2280
            },
            {
              "stopId": "judu:stop:5804",
              "position": {
                "x": -2134.709,
                "z": -4666.379
              },
              "distanceAlongShapeM": 13001.573,
              "shapeOffsetM": 6.285,
              "arrivalOffsetSeconds": 2460,
              "departureOffsetSeconds": 2460
            },
            {
              "stopId": "judu:stop:5810",
              "position": {
                "x": -1625.643,
                "z": -5020.551
              },
              "distanceAlongShapeM": 13641.706,
              "shapeOffsetM": 3.907,
              "arrivalOffsetSeconds": 2580,
              "departureOffsetSeconds": 2580
            },
            {
              "stopId": "judu:stop:5815",
              "position": {
                "x": -1271.325,
                "z": -5199.449
              },
              "distanceAlongShapeM": 14043.023,
              "shapeOffsetM": 4.742,
              "arrivalOffsetSeconds": 2640,
              "departureOffsetSeconds": 2640
            },
            {
              "stopId": "judu:stop:6633",
              "position": {
                "x": -589.373,
                "z": -5532.358
              },
              "distanceAlongShapeM": 14802.95,
              "shapeOffsetM": 1.804,
              "arrivalOffsetSeconds": 2820,
              "departureOffsetSeconds": 2820
            },
            {
              "stopId": "judu:stop:6500",
              "position": {
                "x": -122.378,
                "z": -6204.331
              },
              "distanceAlongShapeM": 15796.133,
              "shapeOffsetM": 5.434,
              "arrivalOffsetSeconds": 3000,
              "departureOffsetSeconds": 3000
            },
            {
              "stopId": "judu:stop:6532",
              "position": {
                "x": 16.38,
                "z": -7176.496
              },
              "distanceAlongShapeM": 16803.448,
              "shapeOffsetM": 4.77,
              "arrivalOffsetSeconds": 3120,
              "departureOffsetSeconds": 3120
            },
            {
              "stopId": "judu:stop:10244",
              "position": {
                "x": 48.234,
                "z": -7442.03
              },
              "distanceAlongShapeM": 17070.995,
              "shapeOffsetM": 11.761,
              "arrivalOffsetSeconds": 3180,
              "departureOffsetSeconds": 3180
            }
          ],
          "departuresSeconds": [
            18420,
            19440,
            20460,
            21120,
            21720,
            22260,
            22620,
            22920,
            23280,
            23640,
            24000,
            24360,
            24720,
            25140,
            25560,
            25920,
            26220,
            26520,
            26820,
            27180,
            27540,
            27960,
            28440,
            28860,
            29340,
            29820,
            30240,
            30660,
            31080,
            31500,
            31980,
            32460,
            32940,
            33360,
            33840,
            34320,
            34860,
            35340,
            35880,
            36360,
            36960,
            37560,
            38220,
            38820,
            39300,
            39840,
            40320,
            40800,
            41220,
            41700,
            42120,
            42540,
            43140,
            43740,
            44220,
            44700,
            45300,
            45840,
            46380,
            46980,
            47520,
            48000,
            48480,
            48960,
            49440,
            49920,
            50520,
            51060,
            51540,
            52020,
            52560,
            53160,
            53640,
            54180,
            54720,
            55320,
            55800,
            56340,
            56880,
            57180,
            57480,
            57900,
            58380,
            58680,
            58980,
            59280,
            59580,
            59880,
            60180,
            60480,
            60840,
            61260,
            61860,
            62340,
            62880,
            63360,
            63960,
            64500,
            64920,
            65340,
            65760,
            66240,
            66660,
            67080,
            67440,
            67860,
            68400,
            68940,
            69660,
            70680,
            71100,
            71580,
            72120,
            72720,
            73200,
            73740,
            74340,
            75000,
            75540,
            76080,
            76620,
            77220,
            77880,
            78420,
            79080,
            79680,
            80160,
            80700,
            81240,
            81720,
            82200,
            82740,
            83340,
            85080,
            86280
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_bus_3",
      "sourceRouteId": "vilnius_bus_3",
      "mode": "bus",
      "shortName": "3",
      "longName": "Stotis–Eišiškių pl.–Dilgynė–Salininkai–Vaidotai",
      "color": "0073AC",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_bus_3:0",
          "sourceRouteId": "vilnius_bus_3",
          "sourceShapeId": "vilnius_bus_3_a-b",
          "directionId": 0,
          "headsign": "Vaidotai",
          "directionName": "Stotis–Eišiškių pl.–Dilgynė–Salininkai–Vaidotai",
          "mode": "bus",
          "routeShortName": "3",
          "routeLongName": "Stotis–Eišiškių pl.–Dilgynė–Salininkai–Vaidotai",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              365.148,
              1967.953,
              0
            ],
            [
              359.628,
              1983.639,
              16.629
            ],
            [
              363.117,
              1998.047,
              31.453
            ],
            [
              375.555,
              2007.839,
              47.283
            ],
            [
              384.565,
              2006.561,
              56.383
            ],
            [
              450.348,
              1969.735,
              131.773
            ],
            [
              464.314,
              1957.234,
              150.516
            ],
            [
              465.443,
              1943.866,
              163.932
            ],
            [
              460.314,
              1934.517,
              174.596
            ],
            [
              448.99,
              1930.796,
              186.515
            ],
            [
              427.686,
              1930.073,
              207.831
            ],
            [
              403.862,
              1932.735,
              231.803
            ],
            [
              390.012,
              1916.29,
              253.304
            ],
            [
              339.428,
              1831.495,
              352.04
            ],
            [
              318.606,
              1821.856,
              374.985
            ],
            [
              29.934,
              1735.835,
              676.201
            ],
            [
              -11.394,
              1732.372,
              717.674
            ],
            [
              -46.755,
              1740.57,
              753.973
            ],
            [
              -320.217,
              1781.157,
              1030.43
            ],
            [
              -514.905,
              1842.557,
              1234.571
            ],
            [
              -520.923,
              1849.358,
              1243.652
            ],
            [
              -525.385,
              1862.522,
              1257.552
            ],
            [
              -507.688,
              1932.818,
              1330.042
            ],
            [
              -496.901,
              1964.699,
              1363.698
            ],
            [
              -462.075,
              2106.562,
              1509.773
            ],
            [
              -436.719,
              2188.482,
              1595.527
            ],
            [
              -427.991,
              2207.248,
              1616.224
            ],
            [
              -344.32,
              2338.207,
              1771.63
            ],
            [
              -326.137,
              2380.181,
              1817.373
            ],
            [
              -285.296,
              2533.066,
              1975.619
            ],
            [
              -285.194,
              2584.883,
              2027.437
            ],
            [
              -278.622,
              2616.436,
              2059.667
            ],
            [
              -251.706,
              2819.669,
              2264.674
            ],
            [
              -239.003,
              2950.799,
              2396.418
            ],
            [
              -239.164,
              2977.519,
              2423.139
            ],
            [
              -243.808,
              3023.423,
              2469.277
            ],
            [
              -251.845,
              3073.034,
              2519.535
            ],
            [
              -253.335,
              3121.382,
              2567.906
            ],
            [
              -336.623,
              3547.03,
              3001.626
            ],
            [
              -379.958,
              3791.61,
              3250.015
            ],
            [
              -382.016,
              3856.215,
              3314.653
            ],
            [
              -345.945,
              4030.338,
              3492.473
            ],
            [
              -408.418,
              4109.394,
              3593.233
            ],
            [
              -481.301,
              4219.808,
              3725.533
            ],
            [
              -539.627,
              4314.372,
              3836.638
            ],
            [
              -576.107,
              4369.49,
              3902.735
            ],
            [
              -621.677,
              4489.515,
              4031.119
            ],
            [
              -657.683,
              4569.203,
              4118.564
            ],
            [
              -717.04,
              4707.668,
              4269.216
            ],
            [
              -708.363,
              4781.374,
              4343.431
            ],
            [
              -693.915,
              4887.124,
              4450.163
            ],
            [
              -643.028,
              5310.343,
              4876.43
            ],
            [
              -620.517,
              5545.88,
              5113.041
            ],
            [
              -612.702,
              5667.139,
              5234.551
            ],
            [
              -664.451,
              5972.136,
              5543.907
            ],
            [
              -708.429,
              6267.775,
              5842.799
            ],
            [
              -736.795,
              6428.239,
              6005.751
            ],
            [
              -745.195,
              6485.515,
              6063.64
            ],
            [
              -1066.466,
              6433.4,
              6389.11
            ],
            [
              -1083.129,
              6428.337,
              6406.525
            ],
            [
              -1122.835,
              6423.278,
              6446.552
            ],
            [
              -1321.777,
              6385.649,
              6649.022
            ],
            [
              -1272.547,
              6079.139,
              6959.46
            ],
            [
              -1220.288,
              5741.51,
              7301.11
            ],
            [
              -1254.235,
              5720.135,
              7341.225
            ],
            [
              -1341.654,
              5851.663,
              7499.155
            ],
            [
              -1432.809,
              5984.824,
              7660.527
            ],
            [
              -1431.833,
              5983.214,
              7662.41
            ],
            [
              -1471.061,
              6054.352,
              7743.646
            ],
            [
              -1667.836,
              6423.029,
              8161.55
            ],
            [
              -1679.373,
              6468.839,
              8208.79
            ],
            [
              -1707.91,
              6788.838,
              8530.059
            ],
            [
              -1712.089,
              6821.577,
              8563.063
            ],
            [
              -1712.83,
              6839.019,
              8580.521
            ],
            [
              -1721.42,
              6937.135,
              8679.013
            ],
            [
              -1729.279,
              6967.331,
              8710.215
            ],
            [
              -1746.568,
              7012.167,
              8758.269
            ],
            [
              -1767.164,
              7052.608,
              8803.652
            ],
            [
              -1986.586,
              7354.842,
              9177.138
            ],
            [
              -2025.855,
              7391.323,
              9230.737
            ],
            [
              -2100.781,
              7451.446,
              9326.803
            ],
            [
              -2037.346,
              7586.889,
              9476.365
            ],
            [
              -2021.629,
              7620.543,
              9513.508
            ],
            [
              -2003.942,
              7651.262,
              9548.955
            ],
            [
              -1949.699,
              7759.395,
              9669.93
            ],
            [
              -1905.866,
              7863.259,
              9782.665
            ],
            [
              -1804.677,
              8031.784,
              9979.235
            ],
            [
              -1769.656,
              8075.69,
              10035.398
            ],
            [
              -1704.351,
              8151.341,
              10135.337
            ],
            [
              -1667.469,
              8190.76,
              10189.319
            ],
            [
              -1631.959,
              8225.751,
              10239.172
            ],
            [
              -1597.192,
              8255.189,
              10284.728
            ],
            [
              -1554.934,
              8285.19,
              10336.553
            ],
            [
              -1537.002,
              8303.418,
              10362.123
            ],
            [
              -1526.833,
              8324.068,
              10385.141
            ],
            [
              -1511.486,
              8383.991,
              10446.999
            ],
            [
              -1505.414,
              8438.346,
              10501.691
            ],
            [
              -1503.229,
              8488.402,
              10551.795
            ],
            [
              -1511.708,
              8556.458,
              10620.377
            ],
            [
              -1543.904,
              8744.051,
              10810.713
            ],
            [
              -1553.048,
              8789.284,
              10856.861
            ],
            [
              -1618.698,
              9225.174,
              11297.667
            ],
            [
              -1909.16,
              9171.333,
              11593.077
            ],
            [
              -1929.991,
              9162.797,
              11615.589
            ],
            [
              -1953.562,
              9145.403,
              11644.883
            ],
            [
              -1966.778,
              9128.939,
              11665.995
            ],
            [
              -1992.214,
              9079.296,
              11721.775
            ],
            [
              -2048.725,
              8956.22,
              11857.205
            ],
            [
              -2094.779,
              8856.705,
              11966.86
            ],
            [
              -2113.142,
              8822.964,
              12005.275
            ],
            [
              -2119.588,
              8814.928,
              12015.576
            ],
            [
              -2130.035,
              8808.909,
              12027.633
            ],
            [
              -2137.374,
              8800.224,
              12039.003
            ],
            [
              -2151.227,
              8791.906,
              12055.162
            ],
            [
              -2170.376,
              8785.553,
              12075.337
            ],
            [
              -2742.154,
              8675.804,
              12657.553
            ],
            [
              -3334.939,
              8564.092,
              13260.772
            ],
            [
              -3591.691,
              8512.898,
              13522.578
            ],
            [
              -3607.502,
              8520.077,
              13539.942
            ],
            [
              -3656.717,
              8569.961,
              13610.018
            ],
            [
              -3745.095,
              8658.073,
              13734.815
            ],
            [
              -3801.051,
              8716.912,
              13816.013
            ],
            [
              -3845.638,
              8757.253,
              13876.141
            ],
            [
              -4138.195,
              8968.743,
              14237.137
            ],
            [
              -4247.36,
              9008.472,
              14353.306
            ],
            [
              -4356.161,
              9040.861,
              14466.826
            ],
            [
              -4417.136,
              9055.919,
              14529.633
            ],
            [
              -4590.126,
              9104.527,
              14709.322
            ],
            [
              -4643.384,
              9134.166,
              14770.272
            ],
            [
              -4774.327,
              9253.508,
              14947.44
            ],
            [
              -5077.134,
              9610.12,
              15415.269
            ],
            [
              -5091.17,
              9619.942,
              15432.4
            ],
            [
              -5109.674,
              9620.549,
              15450.914
            ],
            [
              -5126.181,
              9614.615,
              15468.456
            ],
            [
              -5233.744,
              9521.824,
              15610.512
            ],
            [
              -5252.892,
              9495.064,
              15643.417
            ],
            [
              -5257.075,
              9479.92,
              15659.128
            ],
            [
              -5249.054,
              9457.52,
              15682.921
            ],
            [
              -5237.188,
              9447.975,
              15698.149
            ],
            [
              -5215.706,
              9442.482,
              15720.323
            ],
            [
              -5202.504,
              9444.62,
              15733.697
            ],
            [
              -5029.309,
              9591.693,
              15960.912
            ],
            [
              -5024.984,
              9607.243,
              15977.053
            ],
            [
              -5025.6,
              9615.584,
              15985.417
            ],
            [
              -5094.927,
              9704.251,
              16097.969
            ],
            [
              -5304.35,
              9529.266,
              16370.875
            ],
            [
              -5328.941,
              9510.083,
              16402.063
            ],
            [
              -5342.155,
              9498.937,
              16419.35
            ],
            [
              -5367.474,
              9474.959,
              16454.222
            ],
            [
              -5370.881,
              9470.674,
              16459.696
            ],
            [
              -5369.461,
              9462.714,
              16467.782
            ],
            [
              -5371.233,
              9455.142,
              16475.558
            ],
            [
              -5379.783,
              9446.381,
              16487.8
            ],
            [
              -5388.219,
              9444.298,
              16496.489
            ],
            [
              -5395.953,
              9445.542,
              16504.323
            ],
            [
              -5402.319,
              9451.216,
              16512.85
            ],
            [
              -5407.282,
              9460.708,
              16523.561
            ],
            [
              -5440.968,
              9483.181,
              16564.055
            ],
            [
              -5440.881,
              9483.155,
              16564.146
            ],
            [
              -5481.837,
              9489.048,
              16605.524
            ],
            [
              -5545.139,
              9489.258,
              16668.826
            ],
            [
              -5626.626,
              9511.091,
              16753.187
            ],
            [
              -5665.918,
              9536.631,
              16800.05
            ],
            [
              -5758.358,
              9606.406,
              16915.868
            ],
            [
              -5990.709,
              9775.16,
              17203.035
            ],
            [
              -6015.502,
              9793.234,
              17233.716
            ],
            [
              -6059.308,
              9827.629,
              17289.411
            ],
            [
              -6275.706,
              9982.473,
              17555.504
            ],
            [
              -6379.209,
              10057.887,
              17683.566
            ],
            [
              -6409.882,
              10087.79,
              17726.403
            ],
            [
              -6418.526,
              10102.509,
              17743.473
            ],
            [
              -6442.156,
              10416.039,
              18057.893
            ],
            [
              -6442.408,
              10421.588,
              18063.447
            ],
            [
              -6437.63,
              10427.19,
              18070.81
            ],
            [
              -6427.72,
              10422.665,
              18081.705
            ],
            [
              -6424.929,
              10421.534,
              18084.716
            ],
            [
              -6432.024,
              10402.521,
              18105.009
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:8262",
              "position": {
                "x": 365.148,
                "z": 1967.953
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": -240,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:6650",
              "position": {
                "x": -11.424,
                "z": 1732.135
              },
              "distanceAlongShapeM": 717.674,
              "shapeOffsetM": 0.239,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:7851",
              "position": {
                "x": -511.654,
                "z": 1933.795
              },
              "distanceAlongShapeM": 1330.021,
              "shapeOffsetM": 4.085,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:5173",
              "position": {
                "x": -290.153,
                "z": 2585.475
              },
              "distanceAlongShapeM": 2027.437,
              "shapeOffsetM": 4.994,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:5175",
              "position": {
                "x": -255.513,
                "z": 3072.44
              },
              "distanceAlongShapeM": 2519.535,
              "shapeOffsetM": 3.716,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:5304",
              "position": {
                "x": -578.027,
                "z": 4368.5
              },
              "distanceAlongShapeM": 3902.735,
              "shapeOffsetM": 2.16,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:5310",
              "position": {
                "x": -710.664,
                "z": 4781.67
              },
              "distanceAlongShapeM": 4343.431,
              "shapeOffsetM": 2.32,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            },
            {
              "stopId": "judu:stop:5313",
              "position": {
                "x": -621.345,
                "z": 5545.954
              },
              "distanceAlongShapeM": 5113.061,
              "shapeOffsetM": 0.831,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:5315",
              "position": {
                "x": -665.323,
                "z": 5971.996
              },
              "distanceAlongShapeM": 5543.907,
              "shapeOffsetM": 0.883,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:5317",
              "position": {
                "x": -741.072,
                "z": 6427.553
              },
              "distanceAlongShapeM": 6005.751,
              "shapeOffsetM": 4.331,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:5316",
              "position": {
                "x": -1082.746,
                "z": 6425.899
              },
              "distanceAlongShapeM": 6406.525,
              "shapeOffsetM": 2.468,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:5319",
              "position": {
                "x": -1269.126,
                "z": 6079.688
              },
              "distanceAlongShapeM": 6959.46,
              "shapeOffsetM": 3.464,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            },
            {
              "stopId": "judu:stop:8347",
              "position": {
                "x": -1434.909,
                "z": 5981.348
              },
              "distanceAlongShapeM": 7662.41,
              "shapeOffsetM": 3.598,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            },
            {
              "stopId": "judu:stop:6963",
              "position": {
                "x": -1715.73,
                "z": 6821.26
              },
              "distanceAlongShapeM": 8563.063,
              "shapeOffsetM": 3.654,
              "arrivalOffsetSeconds": 1560,
              "departureOffsetSeconds": 1560
            },
            {
              "stopId": "judu:stop:6967",
              "position": {
                "x": -2023.848,
                "z": 7621.558
              },
              "distanceAlongShapeM": 9513.489,
              "shapeOffsetM": 2.44,
              "arrivalOffsetSeconds": 1680,
              "departureOffsetSeconds": 1680
            },
            {
              "stopId": "judu:stop:6264",
              "position": {
                "x": -1542.006,
                "z": 8306.527
              },
              "distanceAlongShapeM": 10360.83,
              "shapeOffsetM": 5.748,
              "arrivalOffsetSeconds": 1800,
              "departureOffsetSeconds": 1800
            },
            {
              "stopId": "judu:stop:6261",
              "position": {
                "x": -1556.03,
                "z": 8788.795
              },
              "distanceAlongShapeM": 10856.861,
              "shapeOffsetM": 3.022,
              "arrivalOffsetSeconds": 1860,
              "departureOffsetSeconds": 1860
            },
            {
              "stopId": "judu:stop:9003",
              "position": {
                "x": -1669.285,
                "z": 9214.942
              },
              "distanceAlongShapeM": 11349.272,
              "shapeOffsetM": 0.841,
              "arrivalOffsetSeconds": 1920,
              "departureOffsetSeconds": 1920
            },
            {
              "stopId": "judu:stop:6973",
              "position": {
                "x": -2047.392,
                "z": 8955.594
              },
              "distanceAlongShapeM": 11857.213,
              "shapeOffsetM": 1.472,
              "arrivalOffsetSeconds": 1980,
              "departureOffsetSeconds": 1980
            },
            {
              "stopId": "judu:stop:4705",
              "position": {
                "x": -2935.628,
                "z": 8638.383
              },
              "distanceAlongShapeM": 12854.61,
              "shapeOffsetM": 0.943,
              "arrivalOffsetSeconds": 2100,
              "departureOffsetSeconds": 2100
            },
            {
              "stopId": "judu:stop:6974",
              "position": {
                "x": -3746.2,
                "z": 8656.953
              },
              "distanceAlongShapeM": 13734.807,
              "shapeOffsetM": 1.574,
              "arrivalOffsetSeconds": 2220,
              "departureOffsetSeconds": 2220
            },
            {
              "stopId": "judu:stop:9200",
              "position": {
                "x": -5302.797,
                "z": 9527.45
              },
              "distanceAlongShapeM": 16370.848,
              "shapeOffsetM": 2.39,
              "arrivalOffsetSeconds": 2520,
              "departureOffsetSeconds": 2520
            },
            {
              "stopId": "judu:stop:9773",
              "position": {
                "x": -5443.232,
                "z": 9477.513
              },
              "distanceAlongShapeM": 16565.669,
              "shapeOffsetM": 5.919,
              "arrivalOffsetSeconds": 2580,
              "departureOffsetSeconds": 2580
            },
            {
              "stopId": "judu:stop:5756",
              "position": {
                "x": -6020.289,
                "z": 9786.701
              },
              "distanceAlongShapeM": 17233.716,
              "shapeOffsetM": 8.099,
              "arrivalOffsetSeconds": 2670,
              "departureOffsetSeconds": 2670
            },
            {
              "stopId": "judu:stop:9732",
              "position": {
                "x": -6430.087,
                "z": 10401.368
              },
              "distanceAlongShapeM": 18105.009,
              "shapeOffsetM": 2.255,
              "arrivalOffsetSeconds": 2790,
              "departureOffsetSeconds": 2790
            }
          ],
          "departuresSeconds": [
            18660,
            19920,
            21480,
            23100,
            24660,
            26700,
            28320,
            31080,
            34140,
            36180,
            40200,
            42300,
            46080,
            48360,
            52320,
            54600,
            55860,
            57060,
            59040,
            61080,
            62700,
            64320,
            68640,
            70560,
            74400,
            79920
          ]
        },
        {
          "id": "judu:pattern:vilnius_bus_3:1",
          "sourceRouteId": "vilnius_bus_3",
          "sourceShapeId": "vilnius_bus_3_b-a",
          "directionId": 1,
          "headsign": "Stotis",
          "directionName": "Vaidotai–Salininkai–Dilgynė–Eišiškių pl.–Stotis",
          "mode": "bus",
          "routeShortName": "3",
          "routeLongName": "Stotis–Eišiškių pl.–Dilgynė–Salininkai–Vaidotai",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              -6432.024,
              10402.521,
              0
            ],
            [
              -6439.595,
              10389.804,
              14.8
            ],
            [
              -6428.175,
              10206.531,
              198.428
            ],
            [
              -6421.93,
              10116.26,
              288.915
            ],
            [
              -6420.731,
              10110.674,
              294.628
            ],
            [
              -6414.248,
              10097.798,
              309.044
            ],
            [
              -6405.46,
              10085.184,
              324.418
            ],
            [
              -6400.197,
              10079.006,
              332.534
            ],
            [
              -6375.494,
              10057.233,
              365.462
            ],
            [
              -6365.061,
              10049.218,
              378.619
            ],
            [
              -6357.837,
              10044.073,
              387.488
            ],
            [
              -6339.089,
              10028.46,
              411.885
            ],
            [
              -5957.236,
              9753.921,
              882.187
            ],
            [
              -5658.167,
              9531.244,
              1255.05
            ],
            [
              -5627.131,
              9511.363,
              1291.908
            ],
            [
              -5583.581,
              9494.281,
              1338.689
            ],
            [
              -5567.086,
              9490.742,
              1355.559
            ],
            [
              -5516.116,
              9488.249,
              1406.59
            ],
            [
              -5468.239,
              9489.069,
              1454.474
            ],
            [
              -5399.943,
              9475.92,
              1524.024
            ],
            [
              -5385.05,
              9478.753,
              1539.184
            ],
            [
              -5379.273,
              9476.428,
              1545.411
            ],
            [
              -5152.703,
              9663.529,
              1839.249
            ],
            [
              -5090.079,
              9707.207,
              1915.6
            ],
            [
              -5041.367,
              9640.752,
              1997.997
            ],
            [
              -5033.294,
              9630.749,
              2010.85
            ],
            [
              -5018.812,
              9636.023,
              2026.263
            ],
            [
              -5006.788,
              9638.184,
              2038.48
            ],
            [
              -4954.279,
              9679.721,
              2105.431
            ],
            [
              -4945.89,
              9689.466,
              2118.29
            ],
            [
              -4944.386,
              9707.346,
              2136.233
            ],
            [
              -4947.439,
              9717.68,
              2147.009
            ],
            [
              -4955.042,
              9725.062,
              2157.606
            ],
            [
              -4958.813,
              9727.535,
              2162.115
            ],
            [
              -4997.692,
              9721.519,
              2201.457
            ],
            [
              -5079.038,
              9650.548,
              2309.411
            ],
            [
              -5081.85,
              9637.238,
              2323.015
            ],
            [
              -5080.837,
              9626.937,
              2333.365
            ],
            [
              -4806.589,
              9294.134,
              2764.608
            ],
            [
              -4729.86,
              9208.677,
              2879.457
            ],
            [
              -4643.384,
              9134.166,
              2993.606
            ],
            [
              -4545.47,
              9090.421,
              3100.848
            ],
            [
              -4197.811,
              8996.486,
              3460.973
            ],
            [
              -4150.353,
              8975.631,
              3512.811
            ],
            [
              -4059.622,
              8916.181,
              3621.284
            ],
            [
              -3845.638,
              8757.253,
              3887.831
            ],
            [
              -3716.049,
              8636.15,
              4065.199
            ],
            [
              -3697.804,
              8616.039,
              4092.353
            ],
            [
              -3661.015,
              8576.44,
              4146.404
            ],
            [
              -3619.725,
              8535.648,
              4204.445
            ],
            [
              -3591.691,
              8512.898,
              4240.549
            ],
            [
              -2877.571,
              8652.622,
              4968.21
            ],
            [
              -2205.592,
              8779.166,
              5652
            ],
            [
              -2160.179,
              8789.495,
              5698.573
            ],
            [
              -2145.869,
              8794.808,
              5713.837
            ],
            [
              -2111.689,
              8827.6,
              5761.204
            ],
            [
              -1976.691,
              9115.75,
              6079.409
            ],
            [
              -1958.124,
              9143.258,
              6112.597
            ],
            [
              -1928.659,
              9164.999,
              6149.215
            ],
            [
              -1890.993,
              9175.464,
              6188.308
            ],
            [
              -1618.698,
              9225.174,
              6465.103
            ],
            [
              -1611.932,
              9178.268,
              6512.494
            ],
            [
              -1594.884,
              9079.558,
              6612.666
            ],
            [
              -1553.706,
              8810.898,
              6884.463
            ],
            [
              -1551.783,
              8799.178,
              6896.34
            ],
            [
              -1550.14,
              8789.161,
              6906.491
            ],
            [
              -1535.825,
              8767.618,
              6932.356
            ],
            [
              -1545.584,
              8758.552,
              6945.676
            ],
            [
              -1504.025,
              8516.246,
              7191.52
            ],
            [
              -1501.823,
              8482.803,
              7225.036
            ],
            [
              -1503.347,
              8447.272,
              7260.6
            ],
            [
              -1506.906,
              8413.918,
              7294.143
            ],
            [
              -1524.816,
              8328.484,
              7381.434
            ],
            [
              -1528.566,
              8312.945,
              7397.419
            ],
            [
              -1534.753,
              8301.638,
              7410.308
            ],
            [
              -1539.544,
              8295.235,
              7418.305
            ],
            [
              -1552.417,
              8283.602,
              7435.656
            ],
            [
              -1597.232,
              8252.963,
              7489.943
            ],
            [
              -1633.27,
              8224.661,
              7535.766
            ],
            [
              -1763.019,
              8085.591,
              7725.964
            ],
            [
              -1804.677,
              8031.784,
              7794.012
            ],
            [
              -1903.889,
              7865.451,
              7987.687
            ],
            [
              -1952.381,
              7753.877,
              8109.343
            ],
            [
              -2057.537,
              7543.118,
              8344.879
            ],
            [
              -2100.781,
              7451.446,
              8446.238
            ],
            [
              -2076.129,
              7435.653,
              8475.515
            ],
            [
              -2051.692,
              7418.233,
              8505.525
            ],
            [
              -1963.411,
              7327.615,
              8632.037
            ],
            [
              -1775.285,
              7067.396,
              8953.137
            ],
            [
              -1722.735,
              6948.109,
              9083.487
            ],
            [
              -1717.474,
              6904.781,
              9127.133
            ],
            [
              -1680.546,
              6475.539,
              9557.96
            ],
            [
              -1667.836,
              6423.029,
              9611.986
            ],
            [
              -1471.061,
              6054.352,
              10029.89
            ],
            [
              -1461.106,
              6042.209,
              10045.592
            ],
            [
              -1442.825,
              6008.206,
              10084.197
            ],
            [
              -1415.255,
              5960.959,
              10138.9
            ],
            [
              -1254.235,
              5720.135,
              10428.596
            ],
            [
              -1220.288,
              5741.51,
              10468.712
            ],
            [
              -1281.176,
              6108.605,
              10840.822
            ],
            [
              -1297.318,
              6209.86,
              10943.356
            ],
            [
              -1321.777,
              6385.649,
              11120.838
            ],
            [
              -1085.526,
              6433.883,
              11361.963
            ],
            [
              -745.195,
              6485.515,
              11706.188
            ],
            [
              -731.455,
              6425.567,
              11767.69
            ],
            [
              -708.429,
              6267.775,
              11927.154
            ],
            [
              -659.01,
              5968.833,
              12230.152
            ],
            [
              -612.702,
              5667.139,
              12535.38
            ],
            [
              -622.959,
              5467.023,
              12735.759
            ],
            [
              -628.77,
              5414.899,
              12788.206
            ],
            [
              -643.028,
              5310.343,
              12893.729
            ],
            [
              -682.124,
              4968.176,
              13238.123
            ],
            [
              -717.04,
              4707.668,
              13500.96
            ],
            [
              -710.747,
              4695.74,
              13514.446
            ],
            [
              -707.871,
              4685.883,
              13524.714
            ],
            [
              -676.746,
              4621.868,
              13595.895
            ],
            [
              -601.144,
              4446.842,
              13786.551
            ],
            [
              -555.893,
              4349.843,
              13893.586
            ],
            [
              -486.107,
              4235.088,
              14027.894
            ],
            [
              -475.614,
              4213.025,
              14052.326
            ],
            [
              -396.44,
              4093.592,
              14195.618
            ],
            [
              -345.945,
              4030.338,
              14276.555
            ],
            [
              -378.367,
              3879.526,
              14430.813
            ],
            [
              -382.056,
              3853.989,
              14456.615
            ],
            [
              -382.136,
              3813.914,
              14496.69
            ],
            [
              -379.958,
              3791.61,
              14519.1
            ],
            [
              -326.239,
              3550.182,
              14766.433
            ],
            [
              -300.672,
              3393.867,
              14924.825
            ],
            [
              -259.604,
              3167.138,
              15155.243
            ],
            [
              -234.366,
              2993.018,
              15331.183
            ],
            [
              -227.915,
              2951.79,
              15372.912
            ],
            [
              -268.934,
              2604.253,
              15722.861
            ],
            [
              -287.151,
              2501.929,
              15826.794
            ],
            [
              -327.226,
              2355.709,
              15978.407
            ],
            [
              -350.367,
              2324.958,
              16016.892
            ],
            [
              -412.128,
              2228.113,
              16131.755
            ],
            [
              -425.492,
              2202.75,
              16160.423
            ],
            [
              -439.803,
              2160.707,
              16204.835
            ],
            [
              -445.668,
              2121.85,
              16244.132
            ],
            [
              -471.768,
              2034.377,
              16335.416
            ],
            [
              -499.661,
              1919.106,
              16454.014
            ],
            [
              -512.556,
              1856.885,
              16517.556
            ],
            [
              -491.403,
              1846.355,
              16541.186
            ],
            [
              -471.457,
              1839.899,
              16562.15
            ],
            [
              -432.32,
              1825.49,
              16603.856
            ],
            [
              -327.19,
              1787.963,
              16715.483
            ],
            [
              -259.046,
              1774.482,
              16784.947
            ],
            [
              -147.106,
              1756.865,
              16898.265
            ],
            [
              9.981,
              1738.424,
              17056.431
            ],
            [
              41.02,
              1742.312,
              17087.713
            ],
            [
              64.443,
              1752.06,
              17113.083
            ],
            [
              135.751,
              1771.757,
              17187.061
            ],
            [
              319.251,
              1821.845,
              17377.275
            ],
            [
              341.2,
              1822.557,
              17399.235
            ],
            [
              378.73,
              1828.551,
              17437.241
            ],
            [
              526.755,
              1843.654,
              17586.034
            ],
            [
              583.03,
              1851.529,
              17642.858
            ],
            [
              594.469,
              1864.396,
              17660.074
            ],
            [
              593.052,
              1870.271,
              17666.117
            ],
            [
              545.045,
              1891.188,
              17718.483
            ],
            [
              472.814,
              1928.134,
              17799.615
            ],
            [
              457.253,
              1923.966,
              17815.724
            ],
            [
              443.063,
              1924.225,
              17829.917
            ],
            [
              417.95,
              1926.911,
              17855.173
            ],
            [
              405.756,
              1930.474,
              17867.877
            ],
            [
              392.999,
              1938.5,
              17882.948
            ],
            [
              365.148,
              1967.953,
              17923.484
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:9732",
              "position": {
                "x": -6430.087,
                "z": 10401.368
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 2.255,
              "arrivalOffsetSeconds": -480,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:3575",
              "position": {
                "x": -6388.113,
                "z": 10090.091
              },
              "distanceAlongShapeM": 334.269,
              "shapeOffsetM": 16.306,
              "arrivalOffsetSeconds": 60,
              "departureOffsetSeconds": 60
            },
            {
              "stopId": "judu:stop:5757",
              "position": {
                "x": -5956.85,
                "z": 9754.465
              },
              "distanceAlongShapeM": 882.183,
              "shapeOffsetM": 0.667,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:9201",
              "position": {
                "x": -5153.129,
                "z": 9664.054
              },
              "distanceAlongShapeM": 1839.249,
              "shapeOffsetM": 0.676,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:6975",
              "position": {
                "x": -3713.566,
                "z": 8638.576
              },
              "distanceAlongShapeM": 4065.199,
              "shapeOffsetM": 3.471,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:4706",
              "position": {
                "x": -2877.847,
                "z": 8654.069
              },
              "distanceAlongShapeM": 4968.21,
              "shapeOffsetM": 1.473,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:6972",
              "position": {
                "x": -2032.412,
                "z": 8998.744
              },
              "distanceAlongShapeM": 5949.816,
              "shapeOffsetM": 0.819,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:9740",
              "position": {
                "x": -1611.777,
                "z": 9178.296
              },
              "distanceAlongShapeM": 6512.489,
              "shapeOffsetM": 0.158,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:6260",
              "position": {
                "x": -1540.488,
                "z": 8790.744
              },
              "distanceAlongShapeM": 6910.514,
              "shapeOffsetM": 8.915,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:6263",
              "position": {
                "x": -1532.635,
                "z": 8288.548
              },
              "distanceAlongShapeM": 7418.305,
              "shapeOffsetM": 9.615,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:6966",
              "position": {
                "x": -2070.914,
                "z": 7444.279
              },
              "distanceAlongShapeM": 8475.253,
              "shapeOffsetM": 10.077,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:6964",
              "position": {
                "x": -1717.974,
                "z": 6949.319
              },
              "distanceAlongShapeM": 9083.487,
              "shapeOffsetM": 4.912,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:6961",
              "position": {
                "x": -1459.639,
                "z": 6043.016
              },
              "distanceAlongShapeM": 10045.592,
              "shapeOffsetM": 1.674,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:9728",
              "position": {
                "x": -1286.059,
                "z": 6107.821
              },
              "distanceAlongShapeM": 10840.822,
              "shapeOffsetM": 4.946,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            },
            {
              "stopId": "judu:stop:9729",
              "position": {
                "x": -1086.38,
                "z": 6439.323
              },
              "distanceAlongShapeM": 11361.963,
              "shapeOffsetM": 5.507,
              "arrivalOffsetSeconds": 1380,
              "departureOffsetSeconds": 1380
            },
            {
              "stopId": "judu:stop:9731",
              "position": {
                "x": -727.534,
                "z": 6426.196
              },
              "distanceAlongShapeM": 11767.69,
              "shapeOffsetM": 3.971,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            },
            {
              "stopId": "judu:stop:9730",
              "position": {
                "x": -654.389,
                "z": 5969.573
              },
              "distanceAlongShapeM": 12230.152,
              "shapeOffsetM": 4.68,
              "arrivalOffsetSeconds": 1500,
              "departureOffsetSeconds": 1500
            },
            {
              "stopId": "judu:stop:491",
              "position": {
                "x": -626.941,
                "z": 5414.695
              },
              "distanceAlongShapeM": 12788.206,
              "shapeOffsetM": 1.84,
              "arrivalOffsetSeconds": 1620,
              "departureOffsetSeconds": 1620
            },
            {
              "stopId": "judu:stop:5307",
              "position": {
                "x": -708.316,
                "z": 4697.023
              },
              "distanceAlongShapeM": 13514.446,
              "shapeOffsetM": 2.749,
              "arrivalOffsetSeconds": 1740,
              "departureOffsetSeconds": 1740
            },
            {
              "stopId": "judu:stop:5305",
              "position": {
                "x": -482.27,
                "z": 4237.637
              },
              "distanceAlongShapeM": 14027.71,
              "shapeOffsetM": 4.603,
              "arrivalOffsetSeconds": 1800,
              "departureOffsetSeconds": 1800
            },
            {
              "stopId": "judu:stop:7414",
              "position": {
                "x": -225.435,
                "z": 2951.666
              },
              "distanceAlongShapeM": 15372.912,
              "shapeOffsetM": 2.483,
              "arrivalOffsetSeconds": 2040,
              "departureOffsetSeconds": 2040
            },
            {
              "stopId": "judu:stop:6854",
              "position": {
                "x": -266.588,
                "z": 2603.973
              },
              "distanceAlongShapeM": 15722.861,
              "shapeOffsetM": 2.363,
              "arrivalOffsetSeconds": 2100,
              "departureOffsetSeconds": 2100
            },
            {
              "stopId": "judu:stop:5166",
              "position": {
                "x": -470.051,
                "z": 1843.985
              },
              "distanceAlongShapeM": 16562.15,
              "shapeOffsetM": 4.322,
              "arrivalOffsetSeconds": 2280,
              "departureOffsetSeconds": 2280
            },
            {
              "stopId": "judu:stop:5160",
              "position": {
                "x": 63.816,
                "z": 1754.143
              },
              "distanceAlongShapeM": 17113.083,
              "shapeOffsetM": 2.176,
              "arrivalOffsetSeconds": 2430,
              "departureOffsetSeconds": 2430
            },
            {
              "stopId": "judu:stop:16581",
              "position": {
                "x": 378.73,
                "z": 1828.551
              },
              "distanceAlongShapeM": 17437.241,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2520,
              "departureOffsetSeconds": 2520
            }
          ],
          "departuresSeconds": [
            21720,
            23400,
            24780,
            26880,
            28200,
            30180,
            32040,
            34980,
            37320,
            39240,
            43200,
            45360,
            49140,
            51480,
            55440,
            57780,
            59400,
            60900,
            62700,
            64680,
            66540,
            68340,
            71640,
            79080
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_expressbus_3G",
      "sourceRouteId": "vilnius_expressbus_3G",
      "mode": "bus",
      "shortName": "3G",
      "longName": "Perkūnkiemis–Šeškinė–Centras–Oro uostas",
      "color": "008000",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_expressbus_3G:0",
          "sourceRouteId": "vilnius_expressbus_3G",
          "sourceShapeId": "vilnius_expressbus_3G_a-b",
          "directionId": 0,
          "headsign": "Oro uostas",
          "directionName": "Perkūnkiemis–Šeškinė–Centras–Oro uostas",
          "mode": "bus",
          "routeShortName": "3G",
          "routeLongName": "Perkūnkiemis–Šeškinė–Centras–Oro uostas",
          "routeColor": "008000",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              -3846.109,
              -5119.902,
              0
            ],
            [
              -3862.028,
              -5154.789,
              38.347
            ],
            [
              -3896.745,
              -5150.846,
              73.287
            ],
            [
              -3904.981,
              -5142.911,
              84.724
            ],
            [
              -3906.076,
              -5131.759,
              95.93
            ],
            [
              -3903.757,
              -5109.535,
              118.274
            ],
            [
              -3869.632,
              -5096.489,
              154.808
            ],
            [
              -3868.639,
              -5091.898,
              159.505
            ],
            [
              -3866.173,
              -5086.493,
              165.446
            ],
            [
              -3845.952,
              -5058.592,
              199.904
            ],
            [
              -3847.945,
              -5048.709,
              209.986
            ],
            [
              -3872.993,
              -5044.39,
              235.403
            ],
            [
              -4005.398,
              -5041.282,
              367.845
            ],
            [
              -4035.808,
              -5039.998,
              398.282
            ],
            [
              -4047.31,
              -5059.234,
              420.695
            ],
            [
              -4054.001,
              -5192.645,
              554.273
            ],
            [
              -3973.672,
              -5345.865,
              727.274
            ],
            [
              -3834.829,
              -5591.359,
              1009.31
            ],
            [
              -3738.866,
              -5774.019,
              1215.644
            ],
            [
              -3673.968,
              -5896.125,
              1353.925
            ],
            [
              -3663.88,
              -5908.547,
              1369.927
            ],
            [
              -3644.251,
              -5924.59,
              1395.279
            ],
            [
              -3618.634,
              -5899.316,
              1431.265
            ],
            [
              -3485.286,
              -5750.246,
              1631.274
            ],
            [
              -3386.562,
              -5629.518,
              1787.228
            ],
            [
              -3374.401,
              -5614.415,
              1806.618
            ],
            [
              -3323.404,
              -5553.81,
              1885.825
            ],
            [
              -3282.741,
              -5512.22,
              1943.99
            ],
            [
              -3111.162,
              -5314.848,
              2205.515
            ],
            [
              -3040.755,
              -5230.366,
              2315.489
            ],
            [
              -2985.976,
              -5155.629,
              2408.151
            ],
            [
              -2932.597,
              -5072.211,
              2507.186
            ],
            [
              -2911.623,
              -5041.062,
              2544.739
            ],
            [
              -2884.805,
              -5007.124,
              2587.993
            ],
            [
              -2783.196,
              -4834.137,
              2788.615
            ],
            [
              -2685.035,
              -4674.45,
              2976.059
            ],
            [
              -2617.123,
              -4549.854,
              3117.961
            ],
            [
              -2599.885,
              -4512.041,
              3159.518
            ],
            [
              -2570.953,
              -4452.706,
              3225.531
            ],
            [
              -2472.865,
              -4225.115,
              3473.36
            ],
            [
              -2375.99,
              -3957.429,
              3758.036
            ],
            [
              -2366.341,
              -3921.977,
              3794.778
            ],
            [
              -2313.476,
              -3774.854,
              3951.11
            ],
            [
              -2292.987,
              -3709.537,
              4019.565
            ],
            [
              -2280.97,
              -3679.424,
              4051.988
            ],
            [
              -2072.945,
              -3075.564,
              4690.675
            ],
            [
              -2040.52,
              -2976.08,
              4795.309
            ],
            [
              -2024.769,
              -2939.494,
              4835.142
            ],
            [
              -2004.312,
              -2876.403,
              4901.467
            ],
            [
              -1942.85,
              -2718.306,
              5071.091
            ],
            [
              -1897.194,
              -2615.588,
              5183.498
            ],
            [
              -1889.264,
              -2604.597,
              5197.051
            ],
            [
              -1854.797,
              -2587.399,
              5235.571
            ],
            [
              -1805.935,
              -2485.853,
              5348.261
            ],
            [
              -1803.13,
              -2436.921,
              5397.273
            ],
            [
              -1757.32,
              -2362.039,
              5485.056
            ],
            [
              -1745.639,
              -2333.352,
              5516.03
            ],
            [
              -1727.311,
              -2305.799,
              5549.122
            ],
            [
              -1547.472,
              -2017.345,
              5889.045
            ],
            [
              -1343.434,
              -1674.784,
              6287.768
            ],
            [
              -1305.861,
              -1628.702,
              6347.226
            ],
            [
              -1268.647,
              -1602.651,
              6392.652
            ],
            [
              -1054.592,
              -1494.059,
              6632.677
            ],
            [
              -1027.103,
              -1471.176,
              6668.444
            ],
            [
              -1009.966,
              -1450.333,
              6695.427
            ],
            [
              -998.422,
              -1410.718,
              6736.69
            ],
            [
              -987.78,
              -1363.9,
              6784.702
            ],
            [
              -988.723,
              -1201.352,
              6947.253
            ],
            [
              -990.397,
              -1186.85,
              6961.851
            ],
            [
              -1017.615,
              -1122.906,
              7031.347
            ],
            [
              -1020.518,
              -1105.042,
              7049.445
            ],
            [
              -1018.304,
              -1089.497,
              7065.147
            ],
            [
              -1013.532,
              -1075.111,
              7080.304
            ],
            [
              -1005.537,
              -1060.783,
              7096.712
            ],
            [
              -969.041,
              -1039.175,
              7139.125
            ],
            [
              -947.066,
              -1036.231,
              7161.296
            ],
            [
              -930.307,
              -1036.533,
              7178.058
            ],
            [
              -906.579,
              -1043.639,
              7202.827
            ],
            [
              -895.802,
              -1053.852,
              7217.674
            ],
            [
              -890.221,
              -1066.198,
              7231.223
            ],
            [
              -882.043,
              -1077.478,
              7245.156
            ],
            [
              -868.708,
              -1088.851,
              7262.682
            ],
            [
              -846.005,
              -1097.331,
              7286.918
            ],
            [
              -837.363,
              -1098.358,
              7295.62
            ],
            [
              -813.038,
              -1094.85,
              7320.197
            ],
            [
              -785.651,
              -1089.799,
              7348.045
            ],
            [
              -774.937,
              -1088.05,
              7358.901
            ],
            [
              -717.669,
              -1083.853,
              7416.323
            ],
            [
              -647.083,
              -1062.792,
              7489.984
            ],
            [
              -599.769,
              -1049.176,
              7539.218
            ],
            [
              -535.555,
              -1028.072,
              7606.811
            ],
            [
              -464.693,
              -995.958,
              7684.61
            ],
            [
              -361.843,
              -942.16,
              7800.681
            ],
            [
              -331.427,
              -923.524,
              7836.352
            ],
            [
              -286.654,
              -898.264,
              7887.759
            ],
            [
              -196.966,
              -846.075,
              7991.526
            ],
            [
              -115.583,
              -803.025,
              8083.594
            ],
            [
              -95.312,
              -792.953,
              8106.229
            ],
            [
              -40.176,
              -770.281,
              8165.845
            ],
            [
              224.176,
              -700.119,
              8439.349
            ],
            [
              211.01,
              -644.216,
              8496.782
            ],
            [
              143.71,
              -480.456,
              8673.832
            ],
            [
              126.134,
              -439.133,
              8718.738
            ],
            [
              119.827,
              -411,
              8747.569
            ],
            [
              106.146,
              -277.163,
              8882.103
            ],
            [
              35.151,
              -280.322,
              8953.168
            ],
            [
              -101.904,
              -298.979,
              9091.487
            ],
            [
              -140.054,
              -304.394,
              9130.02
            ],
            [
              -153.37,
              -311.158,
              9144.955
            ],
            [
              -191.836,
              -315.156,
              9183.628
            ],
            [
              -244.276,
              -326.45,
              9237.27
            ],
            [
              -305.298,
              -348.72,
              9302.229
            ],
            [
              -413.017,
              -421.354,
              9432.149
            ],
            [
              -450.326,
              -380.602,
              9487.4
            ],
            [
              -465.596,
              -369.193,
              9506.461
            ],
            [
              -470.512,
              -355.745,
              9520.78
            ],
            [
              -508.466,
              -314.982,
              9576.476
            ],
            [
              -611.52,
              -58.189,
              9853.176
            ],
            [
              -614.075,
              -53.155,
              9858.822
            ],
            [
              -625.745,
              -24.535,
              9889.729
            ],
            [
              -643.846,
              18.014,
              9935.968
            ],
            [
              -652.524,
              63.893,
              9982.661
            ],
            [
              -679.973,
              222.467,
              10143.593
            ],
            [
              -691.721,
              250.51,
              10173.997
            ],
            [
              -832.714,
              443.415,
              10412.935
            ],
            [
              -840.816,
              459.146,
              10430.63
            ],
            [
              -843.214,
              469.208,
              10440.974
            ],
            [
              -833.842,
              667.193,
              10639.181
            ],
            [
              -824.076,
              731.394,
              10704.12
            ],
            [
              -800.789,
              819.11,
              10794.875
            ],
            [
              -787.05,
              855.14,
              10833.436
            ],
            [
              -767.948,
              887.538,
              10871.046
            ],
            [
              -708.773,
              1021.171,
              11017.194
            ],
            [
              -697.048,
              1063.262,
              11060.888
            ],
            [
              -655.787,
              1240.633,
              11242.995
            ],
            [
              -653.864,
              1286.859,
              11289.261
            ],
            [
              -631.67,
              1361.539,
              11367.169
            ],
            [
              -535.95,
              1804.839,
              11820.686
            ],
            [
              -507.688,
              1932.818,
              11951.748
            ],
            [
              -496.901,
              1964.699,
              11985.404
            ],
            [
              -457.217,
              2125.399,
              12150.932
            ],
            [
              -447.865,
              2143.041,
              12170.899
            ],
            [
              -441.536,
              2171.87,
              12200.415
            ],
            [
              -427.991,
              2207.248,
              12238.297
            ],
            [
              -406.646,
              2245.825,
              12282.386
            ],
            [
              -367.501,
              2305.23,
              12353.528
            ],
            [
              -344.32,
              2338.207,
              12393.838
            ],
            [
              -327.226,
              2355.709,
              12418.302
            ],
            [
              -287.151,
              2501.929,
              12569.915
            ],
            [
              -286.021,
              2528.626,
              12596.636
            ],
            [
              -285.194,
              2584.883,
              12652.899
            ],
            [
              -278.622,
              2616.436,
              12685.129
            ],
            [
              -255.517,
              2787.454,
              12857.701
            ],
            [
              -234.366,
              2993.018,
              13064.35
            ],
            [
              -241.863,
              3011.415,
              13084.216
            ],
            [
              -245.725,
              3035.253,
              13108.365
            ],
            [
              -251.845,
              3073.034,
              13146.638
            ],
            [
              -253.335,
              3121.382,
              13195.009
            ],
            [
              -378.969,
              3774.894,
              13860.488
            ],
            [
              -384.152,
              3809.498,
              13895.478
            ],
            [
              -385.02,
              3832.891,
              13918.887
            ],
            [
              -382.299,
              3876.258,
              13962.339
            ],
            [
              -328.221,
              4117.961,
              14210.018
            ],
            [
              -328.111,
              4136.803,
              14228.86
            ],
            [
              -271.052,
              4387.439,
              14485.909
            ],
            [
              -225.312,
              4631.519,
              14734.238
            ],
            [
              -199.899,
              4822.533,
              14926.935
            ],
            [
              -198.969,
              4859.225,
              14963.639
            ],
            [
              -191.024,
              4884.712,
              14990.335
            ],
            [
              -172.749,
              5038.005,
              15144.714
            ],
            [
              -160.849,
              5053.375,
              15164.152
            ],
            [
              182.36,
              5048.046,
              15507.402
            ],
            [
              184.56,
              5043.71,
              15512.264
            ],
            [
              182.661,
              4953.638,
              15602.356
            ],
            [
              182.349,
              4943.721,
              15612.279
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:7603",
              "position": {
                "x": -3854.099,
                "z": -5069.209
              },
              "distanceAlongShapeM": 186.526,
              "shapeOffsetM": 0.366,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:15634",
              "position": {
                "x": -3828.987,
                "z": -5588.405
              },
              "distanceAlongShapeM": 1009.412,
              "shapeOffsetM": 6.545,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:7077",
              "position": {
                "x": -3618.634,
                "z": -5899.316
              },
              "distanceAlongShapeM": 1431.265,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:9153",
              "position": {
                "x": -3375.968,
                "z": -5613.005
              },
              "distanceAlongShapeM": 1806.688,
              "shapeOffsetM": 2.107,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:5443",
              "position": {
                "x": -2914.996,
                "z": -5038.876
              },
              "distanceAlongShapeM": 2544.668,
              "shapeOffsetM": 4.019,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:7896",
              "position": {
                "x": -2601.622,
                "z": -4511.165
              },
              "distanceAlongShapeM": 3159.544,
              "shapeOffsetM": 1.945,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:5451",
              "position": {
                "x": -2289.819,
                "z": -3676.197
              },
              "distanceAlongShapeM": 4051.705,
              "shapeOffsetM": 9.414,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:5452",
              "position": {
                "x": -2044.086,
                "z": -2974.773
              },
              "distanceAlongShapeM": 4795.309,
              "shapeOffsetM": 3.798,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:5214",
              "position": {
                "x": -1747.763,
                "z": -2332.152
              },
              "distanceAlongShapeM": 5516.03,
              "shapeOffsetM": 2.44,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            },
            {
              "stopId": "judu:stop:6635",
              "position": {
                "x": -775.751,
                "z": -1082.734
              },
              "distanceAlongShapeM": 7358.901,
              "shapeOffsetM": 5.378,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:17638",
              "position": {
                "x": -42.035,
                "z": -765.399
              },
              "distanceAlongShapeM": 8165.845,
              "shapeOffsetM": 5.224,
              "arrivalOffsetSeconds": 1380,
              "departureOffsetSeconds": 1380
            },
            {
              "stopId": "judu:stop:5244",
              "position": {
                "x": 121.213,
                "z": -441.083
              },
              "distanceAlongShapeM": 8718.738,
              "shapeOffsetM": 5.293,
              "arrivalOffsetSeconds": 1560,
              "departureOffsetSeconds": 1560
            },
            {
              "stopId": "judu:stop:5264",
              "position": {
                "x": -646.921,
                "z": 17.037
              },
              "distanceAlongShapeM": 9935.968,
              "shapeOffsetM": 3.227,
              "arrivalOffsetSeconds": 1860,
              "departureOffsetSeconds": 1860
            },
            {
              "stopId": "judu:stop:5266",
              "position": {
                "x": -793.638,
                "z": 857.944
              },
              "distanceAlongShapeM": 10833.436,
              "shapeOffsetM": 7.159,
              "arrivalOffsetSeconds": 2100,
              "departureOffsetSeconds": 2100
            },
            {
              "stopId": "judu:stop:5272",
              "position": {
                "x": -656.233,
                "z": 1287.397
              },
              "distanceAlongShapeM": 11289.261,
              "shapeOffsetM": 2.429,
              "arrivalOffsetSeconds": 2220,
              "departureOffsetSeconds": 2220
            },
            {
              "stopId": "judu:stop:7851",
              "position": {
                "x": -511.654,
                "z": 1933.795
              },
              "distanceAlongShapeM": 11951.748,
              "shapeOffsetM": 4.085,
              "arrivalOffsetSeconds": 2340,
              "departureOffsetSeconds": 2340
            },
            {
              "stopId": "judu:stop:5175",
              "position": {
                "x": -255.513,
                "z": 3072.44
              },
              "distanceAlongShapeM": 13146.638,
              "shapeOffsetM": 3.716,
              "arrivalOffsetSeconds": 2640,
              "departureOffsetSeconds": 2640
            },
            {
              "stopId": "judu:stop:5180",
              "position": {
                "x": -328.523,
                "z": 4136.892
              },
              "distanceAlongShapeM": 14228.86,
              "shapeOffsetM": 0.422,
              "arrivalOffsetSeconds": 2760,
              "departureOffsetSeconds": 2760
            },
            {
              "stopId": "judu:stop:5182",
              "position": {
                "x": -232.492,
                "z": 4591.573
              },
              "distanceAlongShapeM": 14693.653,
              "shapeOffsetM": 0.301,
              "arrivalOffsetSeconds": 2820,
              "departureOffsetSeconds": 2820
            },
            {
              "stopId": "judu:stop:18375",
              "position": {
                "x": 190.96,
                "z": 4943.45
              },
              "distanceAlongShapeM": 15612.279,
              "shapeOffsetM": 8.615,
              "arrivalOffsetSeconds": 2940,
              "departureOffsetSeconds": 2940
            }
          ],
          "departuresSeconds": [
            18540,
            19320,
            20100,
            20820,
            21360,
            21840,
            22260,
            22680,
            23040,
            23400,
            23760,
            24060,
            24360,
            24660,
            24960,
            25260,
            25560,
            25920,
            26220,
            26520,
            26820,
            27180,
            27540,
            27900,
            28260,
            28740,
            29280,
            29940,
            30660,
            31320,
            32040,
            32760,
            33120,
            33540,
            33960,
            34380,
            34800,
            35220,
            35640,
            36060,
            36540,
            37140,
            37860,
            38580,
            39300,
            39900,
            40440,
            41040,
            41640,
            42240,
            42840,
            43440,
            44040,
            44580,
            45180,
            45840,
            46500,
            46980,
            47460,
            48180,
            48960,
            49620,
            50280,
            50940,
            51600,
            52200,
            52740,
            53280,
            53820,
            54240,
            54720,
            55080,
            55500,
            55860,
            56220,
            56580,
            57000,
            57300,
            57660,
            58020,
            58380,
            58860,
            59220,
            59760,
            60300,
            60840,
            61380,
            61920,
            62280,
            62640,
            63060,
            63420,
            63900,
            64320,
            64680,
            65160,
            65700,
            66180,
            66600,
            67200,
            67800,
            68340,
            68940,
            69600,
            70260,
            70980,
            71640,
            72300,
            72960,
            73560,
            74160,
            74760,
            75360,
            75900,
            76500,
            77100,
            77700,
            78300,
            78900,
            79740,
            80580,
            81420,
            82620
          ]
        },
        {
          "id": "judu:pattern:vilnius_expressbus_3G:1",
          "sourceRouteId": "vilnius_expressbus_3G",
          "sourceShapeId": "vilnius_expressbus_3G_b-a",
          "directionId": 1,
          "headsign": "Perkūnkiemis",
          "directionName": "Oro uostas–Centras–Šeškinė–Perkūnkiemis",
          "mode": "bus",
          "routeShortName": "3G",
          "routeLongName": "Perkūnkiemis–Šeškinė–Centras–Oro uostas",
          "routeColor": "008000",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              182.349,
              4943.721,
              0
            ],
            [
              180.147,
              4916.929,
              26.882
            ],
            [
              171.149,
              4883.696,
              61.312
            ],
            [
              160.096,
              4879.445,
              73.154
            ],
            [
              101.063,
              4899.444,
              135.483
            ],
            [
              60.903,
              4922.533,
              181.807
            ],
            [
              56.975,
              4924.737,
              186.311
            ],
            [
              65.084,
              4944.628,
              207.791
            ],
            [
              70.713,
              4970.13,
              233.907
            ],
            [
              75.861,
              5040.169,
              304.135
            ],
            [
              -161.696,
              5042.258,
              541.701
            ],
            [
              -169.039,
              5035.787,
              551.488
            ],
            [
              -173.264,
              4999.541,
              587.979
            ],
            [
              -176.211,
              4974.653,
              613.042
            ],
            [
              -230.472,
              4551.546,
              1039.614
            ],
            [
              -236.808,
              4531.537,
              1060.602
            ],
            [
              -291.097,
              4278.706,
              1319.196
            ],
            [
              -315.819,
              4161.153,
              1439.32
            ],
            [
              -323.596,
              4115.749,
              1485.385
            ],
            [
              -345.945,
              4030.338,
              1573.672
            ],
            [
              -367.116,
              3930.531,
              1675.7
            ],
            [
              -376.774,
              3896.196,
              1711.367
            ],
            [
              -379.958,
              3791.61,
              1816.002
            ],
            [
              -316.278,
              3458.717,
              2154.931
            ],
            [
              -227.915,
              2951.79,
              2669.501
            ],
            [
              -238.382,
              2849.628,
              2772.198
            ],
            [
              -279.066,
              2556.33,
              3068.305
            ],
            [
              -287.151,
              2501.929,
              3123.303
            ],
            [
              -313.901,
              2414.469,
              3214.762
            ],
            [
              -330.149,
              2372.461,
              3259.803
            ],
            [
              -366.936,
              2300.767,
              3340.384
            ],
            [
              -419.989,
              2221.576,
              3435.704
            ],
            [
              -434.119,
              2189.548,
              3470.71
            ],
            [
              -525.296,
              1821.606,
              3849.781
            ],
            [
              -530.605,
              1766.267,
              3905.374
            ],
            [
              -536.862,
              1752.795,
              3920.228
            ],
            [
              -542.324,
              1736.195,
              3937.704
            ],
            [
              -601.244,
              1474.539,
              4205.911
            ],
            [
              -678.532,
              1124.155,
              4564.718
            ],
            [
              -683.338,
              1093.819,
              4595.433
            ],
            [
              -691.829,
              1066.507,
              4624.034
            ],
            [
              -722.413,
              980.227,
              4715.574
            ],
            [
              -789.726,
              824.476,
              4885.249
            ],
            [
              -808.22,
              764.696,
              4947.824
            ],
            [
              -816.493,
              725.027,
              4988.347
            ],
            [
              -824.878,
              699.315,
              5015.391
            ],
            [
              -838.2,
              496.948,
              5218.196
            ],
            [
              -838.156,
              463.551,
              5251.593
            ],
            [
              -823.183,
              435.45,
              5283.435
            ],
            [
              -689.434,
              255.78,
              5507.421
            ],
            [
              -671.067,
              215.627,
              5551.576
            ],
            [
              -634.631,
              19.041,
              5751.51
            ],
            [
              -585.127,
              -96.516,
              5877.224
            ],
            [
              -572.146,
              -122.078,
              5905.894
            ],
            [
              -567.275,
              -143.594,
              5927.954
            ],
            [
              -513.161,
              -289.293,
              6083.378
            ],
            [
              -501.093,
              -299.53,
              6099.203
            ],
            [
              -461.426,
              -352.57,
              6165.435
            ],
            [
              -452.174,
              -363.943,
              6180.096
            ],
            [
              -413.017,
              -421.354,
              6249.589
            ],
            [
              -305.298,
              -348.72,
              6379.508
            ],
            [
              -203.339,
              -309.381,
              6488.793
            ],
            [
              -102.285,
              -284.5,
              6592.865
            ],
            [
              -49.535,
              -271.256,
              6647.253
            ],
            [
              -22.626,
              -265.911,
              6674.687
            ],
            [
              -0.545,
              -257.407,
              6698.349
            ],
            [
              46.601,
              -218.189,
              6759.675
            ],
            [
              70.758,
              -201.931,
              6788.793
            ],
            [
              82.464,
              -196.578,
              6801.665
            ],
            [
              94.753,
              -194.576,
              6814.116
            ],
            [
              102.687,
              -199.192,
              6823.295
            ],
            [
              115.784,
              -208.318,
              6839.258
            ],
            [
              118.351,
              -267.309,
              6898.304
            ],
            [
              118.552,
              -304.106,
              6935.102
            ],
            [
              124.949,
              -377.696,
              7008.97
            ],
            [
              130.203,
              -407.85,
              7039.578
            ],
            [
              144.816,
              -445.964,
              7080.397
            ],
            [
              174.587,
              -519.993,
              7160.188
            ],
            [
              187.997,
              -562.53,
              7204.789
            ],
            [
              214.213,
              -645.388,
              7291.696
            ],
            [
              223.987,
              -656.808,
              7306.728
            ],
            [
              236.049,
              -695.879,
              7347.618
            ],
            [
              236.925,
              -708.144,
              7359.914
            ],
            [
              229.693,
              -715.805,
              7370.449
            ],
            [
              23.734,
              -765.484,
              7582.315
            ],
            [
              -55.388,
              -799.514,
              7668.445
            ],
            [
              -306.711,
              -924.235,
              7949.013
            ],
            [
              -475.993,
              -1014.678,
              8140.941
            ],
            [
              -535.776,
              -1040.314,
              8205.989
            ],
            [
              -673.187,
              -1080.133,
              8349.053
            ],
            [
              -764.624,
              -1108.462,
              8444.777
            ],
            [
              -822.801,
              -1117.509,
              8503.654
            ],
            [
              -837.686,
              -1120.58,
              8518.852
            ],
            [
              -857.223,
              -1131.36,
              8541.166
            ],
            [
              -899.68,
              -1161.766,
              8593.388
            ],
            [
              -917.464,
              -1182.597,
              8620.778
            ],
            [
              -926.283,
              -1206.929,
              8646.659
            ],
            [
              -917.431,
              -1323.977,
              8764.041
            ],
            [
              -911.942,
              -1448.758,
              8888.943
            ],
            [
              -922.391,
              -1491.986,
              8933.416
            ],
            [
              -939.829,
              -1529.521,
              8974.803
            ],
            [
              -961.618,
              -1558.073,
              9010.72
            ],
            [
              -995.732,
              -1590.856,
              9058.032
            ],
            [
              -1026.383,
              -1610.342,
              9094.353
            ],
            [
              -1072.441,
              -1626.213,
              9143.069
            ],
            [
              -1262.636,
              -1662.874,
              9336.765
            ],
            [
              -1320.472,
              -1688.554,
              9400.046
            ],
            [
              -1370.209,
              -1729.965,
              9464.765
            ],
            [
              -1653.223,
              -2198.827,
              10012.423
            ],
            [
              -1682.619,
              -2257.615,
              10078.151
            ],
            [
              -1702.963,
              -2314.026,
              10138.118
            ],
            [
              -1715.793,
              -2345.231,
              10171.858
            ],
            [
              -1755.799,
              -2415.464,
              10252.685
            ],
            [
              -1791.442,
              -2468.3,
              10316.42
            ],
            [
              -1838.817,
              -2558.74,
              10418.517
            ],
            [
              -1870.823,
              -2630.339,
              10496.944
            ],
            [
              -1876.019,
              -2641.711,
              10509.447
            ],
            [
              -1912.507,
              -2715.506,
              10591.77
            ],
            [
              -1995.657,
              -2933.332,
              10824.926
            ],
            [
              -2020.861,
              -3009.696,
              10905.342
            ],
            [
              -2029.851,
              -3041.625,
              10938.513
            ],
            [
              -2244.442,
              -3639.648,
              11573.871
            ],
            [
              -2468.164,
              -4250.803,
              12224.688
            ],
            [
              -2559.838,
              -4475.922,
              12467.757
            ],
            [
              -2704.304,
              -4744.243,
              12772.497
            ],
            [
              -2811.577,
              -4909.336,
              12969.381
            ],
            [
              -2905.084,
              -5061.315,
              13147.822
            ],
            [
              -2920.679,
              -5091.738,
              13182.009
            ],
            [
              -2950.713,
              -5128.419,
              13229.417
            ],
            [
              -3045.536,
              -5245.867,
              13380.366
            ],
            [
              -3100.371,
              -5323.943,
              13475.774
            ],
            [
              -3306.232,
              -5566.356,
              13793.804
            ],
            [
              -3330.246,
              -5592.97,
              13829.65
            ],
            [
              -3342.875,
              -5612.201,
              13852.657
            ],
            [
              -3386.425,
              -5658.464,
              13916.194
            ],
            [
              -3630.767,
              -5930.275,
              14281.685
            ],
            [
              -3641.05,
              -5928.983,
              14292.049
            ],
            [
              -3660.796,
              -5916.393,
              14315.468
            ],
            [
              -3697.564,
              -5862.541,
              14380.674
            ],
            [
              -3758.86,
              -5741.023,
              14516.777
            ],
            [
              -3880.406,
              -5510.021,
              14777.804
            ],
            [
              -3932.919,
              -5417.334,
              14884.334
            ],
            [
              -3995.884,
              -5305.978,
              15012.258
            ],
            [
              -4047.188,
              -5208.349,
              15122.547
            ],
            [
              -4048.716,
              -5193.793,
              15137.182
            ],
            [
              -4048.98,
              -5125.94,
              15205.036
            ],
            [
              -4046.772,
              -5078.347,
              15252.68
            ],
            [
              -4047.126,
              -5066.426,
              15264.607
            ],
            [
              -4019.327,
              -5040.59,
              15302.558
            ],
            [
              -3998.254,
              -5041.637,
              15323.657
            ],
            [
              -3823.908,
              -5049.815,
              15498.195
            ],
            [
              -3827.684,
              -5087.455,
              15536.024
            ],
            [
              -3836.059,
              -5117.022,
              15566.754
            ],
            [
              -3846.109,
              -5119.902,
              15577.209
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:18375",
              "position": {
                "x": 190.96,
                "z": 4943.45
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 8.615,
              "arrivalOffsetSeconds": -540,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:410",
              "position": {
                "x": -229.992,
                "z": 4551.452
              },
              "distanceAlongShapeM": 1039.614,
              "shapeOffsetM": 0.49,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:5181",
              "position": {
                "x": -323.098,
                "z": 4115.642
              },
              "distanceAlongShapeM": 1485.385,
              "shapeOffsetM": 0.509,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:7414",
              "position": {
                "x": -225.435,
                "z": 2951.666
              },
              "distanceAlongShapeM": 2669.501,
              "shapeOffsetM": 2.483,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:5168",
              "position": {
                "x": -529.526,
                "z": 1766.021
              },
              "distanceAlongShapeM": 3905.374,
              "shapeOffsetM": 1.107,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:6853",
              "position": {
                "x": -679.739,
                "z": 1093.006
              },
              "distanceAlongShapeM": 4595.433,
              "shapeOffsetM": 3.689,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:5267",
              "position": {
                "x": -810.251,
                "z": 723.543
              },
              "distanceAlongShapeM": 4988.347,
              "shapeOffsetM": 6.416,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            },
            {
              "stopId": "judu:stop:6736",
              "position": {
                "x": -570.097,
                "z": -121.279
              },
              "distanceAlongShapeM": 5905.894,
              "shapeOffsetM": 2.199,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:5245",
              "position": {
                "x": 150.182,
                "z": -443.837
              },
              "distanceAlongShapeM": 7080.332,
              "shapeOffsetM": 5.772,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            },
            {
              "stopId": "judu:stop:753",
              "position": {
                "x": -53.078,
                "z": -805.275
              },
              "distanceAlongShapeM": 7668.936,
              "shapeOffsetM": 6.187,
              "arrivalOffsetSeconds": 1620,
              "departureOffsetSeconds": 1620
            },
            {
              "stopId": "judu:stop:988",
              "position": {
                "x": -763.423,
                "z": -1114.127
              },
              "distanceAlongShapeM": 8444.777,
              "shapeOffsetM": 5.791,
              "arrivalOffsetSeconds": 1740,
              "departureOffsetSeconds": 1740
            },
            {
              "stopId": "judu:stop:5290",
              "position": {
                "x": -1711.936,
                "z": -2347.263
              },
              "distanceAlongShapeM": 10171.858,
              "shapeOffsetM": 4.36,
              "arrivalOffsetSeconds": 1920,
              "departureOffsetSeconds": 1920
            },
            {
              "stopId": "judu:stop:986",
              "position": {
                "x": -2025.964,
                "z": -3043.002
              },
              "distanceAlongShapeM": 10938.513,
              "shapeOffsetM": 4.124,
              "arrivalOffsetSeconds": 2040,
              "departureOffsetSeconds": 2040
            },
            {
              "stopId": "judu:stop:4388",
              "position": {
                "x": -2242.142,
                "z": -3640.305
              },
              "distanceAlongShapeM": 11573.713,
              "shapeOffsetM": 2.386,
              "arrivalOffsetSeconds": 2160,
              "departureOffsetSeconds": 2160
            },
            {
              "stopId": "judu:stop:7897",
              "position": {
                "x": -2556.572,
                "z": -4477.451
              },
              "distanceAlongShapeM": 12467.757,
              "shapeOffsetM": 3.606,
              "arrivalOffsetSeconds": 2280,
              "departureOffsetSeconds": 2280
            },
            {
              "stopId": "judu:stop:481",
              "position": {
                "x": -2916.619,
                "z": -5094.508
              },
              "distanceAlongShapeM": 13182.009,
              "shapeOffsetM": 4.915,
              "arrivalOffsetSeconds": 2400,
              "departureOffsetSeconds": 2400
            },
            {
              "stopId": "judu:stop:9152",
              "position": {
                "x": -3341.197,
                "z": -5613.613
              },
              "distanceAlongShapeM": 13852.657,
              "shapeOffsetM": 2.193,
              "arrivalOffsetSeconds": 2520,
              "departureOffsetSeconds": 2520
            },
            {
              "stopId": "judu:stop:15639",
              "position": {
                "x": -3701.111,
                "z": -5864.482
              },
              "distanceAlongShapeM": 14380.674,
              "shapeOffsetM": 4.043,
              "arrivalOffsetSeconds": 2640,
              "departureOffsetSeconds": 2640
            },
            {
              "stopId": "judu:stop:15636",
              "position": {
                "x": -3885.643,
                "z": -5512.834
              },
              "distanceAlongShapeM": 14777.938,
              "shapeOffsetM": 5.944,
              "arrivalOffsetSeconds": 2700,
              "departureOffsetSeconds": 2700
            },
            {
              "stopId": "judu:stop:6931",
              "position": {
                "x": -3827.361,
                "z": -5087.486
              },
              "distanceAlongShapeM": 15536.023,
              "shapeOffsetM": 0.325,
              "arrivalOffsetSeconds": 2880,
              "departureOffsetSeconds": 2880
            }
          ],
          "departuresSeconds": [
            18900,
            19560,
            20220,
            20880,
            21420,
            21960,
            22440,
            22920,
            23400,
            23880,
            24360,
            24840,
            25320,
            25740,
            26160,
            26580,
            26940,
            27300,
            27660,
            28020,
            28380,
            28800,
            29160,
            29700,
            30240,
            30780,
            31320,
            31800,
            32280,
            33000,
            33480,
            34080,
            34680,
            35160,
            35700,
            36480,
            37020,
            37560,
            38160,
            38700,
            39240,
            39780,
            40320,
            40800,
            41460,
            42120,
            42780,
            43260,
            43800,
            44400,
            44940,
            45660,
            46320,
            46920,
            47460,
            48060,
            48660,
            49320,
            49980,
            50880,
            51360,
            51960,
            52680,
            53280,
            53940,
            54540,
            55140,
            55800,
            56460,
            57000,
            57480,
            57900,
            58320,
            58740,
            59160,
            59700,
            60180,
            60660,
            61200,
            61620,
            62100,
            62520,
            63060,
            63600,
            64080,
            64860,
            65580,
            66360,
            66780,
            67260,
            67740,
            68040,
            68520,
            69000,
            69600,
            70320,
            70920,
            71700,
            72300,
            72840,
            73380,
            73920,
            74520,
            75060,
            75660,
            76260,
            77040,
            77640,
            78180,
            78780,
            79380,
            79980,
            80580,
            81240,
            81840,
            82440,
            83040,
            83640
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_expressbus_3G-A",
      "sourceRouteId": "vilnius_expressbus_3G-A",
      "mode": "bus",
      "shortName": "3G-A",
      "longName": "Fabijoniškės–Žaliasis tiltas (Apylanka P. Žadeikos g.)",
      "color": "008000",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_expressbus_3G-A:0",
          "sourceRouteId": "vilnius_expressbus_3G-A",
          "sourceShapeId": "vilnius_expressbus_3G-A_a-b",
          "directionId": 0,
          "headsign": "Žaliasis tiltas (Apylanka P. Žadeikos g.)",
          "directionName": "Fabijoniškės–Žaliasis tiltas (Apylanka P. Žadeikos g.)",
          "mode": "bus",
          "routeShortName": "3G-A",
          "routeLongName": "Fabijoniškės–Žaliasis tiltas (Apylanka P. Žadeikos g.)",
          "routeColor": "008000",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              -2480.761,
              -5727.829,
              0
            ],
            [
              -2465.38,
              -5705.215,
              27.349
            ],
            [
              -2457.131,
              -5687.973,
              46.463
            ],
            [
              -2458.05,
              -5680.376,
              54.116
            ],
            [
              -2467.523,
              -5671.289,
              67.242
            ],
            [
              -2484.515,
              -5648.724,
              95.489
            ],
            [
              -2453.276,
              -5597.994,
              155.066
            ],
            [
              -2437.971,
              -5575.488,
              182.284
            ],
            [
              -2323.024,
              -5404.447,
              388.361
            ],
            [
              -2243.482,
              -5280.09,
              535.981
            ],
            [
              -2221.212,
              -5257.08,
              568.002
            ],
            [
              -2172.788,
              -5214.524,
              632.469
            ],
            [
              -2110.315,
              -5178.897,
              704.386
            ],
            [
              -2136.613,
              -5136.438,
              754.33
            ],
            [
              -2215.749,
              -4985.55,
              924.711
            ],
            [
              -2261.515,
              -4895.899,
              1025.368
            ],
            [
              -2303.85,
              -4831.475,
              1102.457
            ],
            [
              -2250.757,
              -4780.095,
              1176.34
            ],
            [
              -2246.649,
              -4770.794,
              1186.508
            ],
            [
              -2217.023,
              -4730.598,
              1236.442
            ],
            [
              -2199.094,
              -4664.123,
              1305.293
            ],
            [
              -2245.097,
              -4651.92,
              1352.887
            ],
            [
              -2248.369,
              -4645.437,
              1360.148
            ],
            [
              -2421.69,
              -4610.083,
              1537.038
            ],
            [
              -2609.045,
              -4566.695,
              1729.352
            ],
            [
              -2745.017,
              -4497.235,
              1882.038
            ],
            [
              -2770.825,
              -4531.174,
              1924.675
            ],
            [
              -2804.177,
              -4598.877,
              2000.147
            ],
            [
              -2799.786,
              -4605.634,
              2008.206
            ],
            [
              -2740.129,
              -4632.849,
              2073.777
            ],
            [
              -2740.424,
              -4632.704,
              2074.106
            ],
            [
              -2716.354,
              -4644.453,
              2100.891
            ],
            [
              -2663.277,
              -4659.378,
              2156.026
            ],
            [
              -2599.885,
              -4512.041,
              2316.422
            ],
            [
              -2575.776,
              -4470.432,
              2364.511
            ],
            [
              -2511.16,
              -4330.887,
              2518.29
            ],
            [
              -2380.854,
              -3977.381,
              2895.048
            ],
            [
              -2366.341,
              -3921.977,
              2952.321
            ],
            [
              -2313.476,
              -3774.854,
              3108.653
            ],
            [
              -2292.987,
              -3709.537,
              3177.109
            ],
            [
              -2280.97,
              -3679.424,
              3209.531
            ],
            [
              -2072.945,
              -3075.564,
              3848.218
            ],
            [
              -2040.52,
              -2976.08,
              3952.852
            ],
            [
              -2024.769,
              -2939.494,
              3992.685
            ],
            [
              -2004.312,
              -2876.403,
              4059.01
            ],
            [
              -1942.85,
              -2718.306,
              4228.634
            ],
            [
              -1897.194,
              -2615.588,
              4341.041
            ],
            [
              -1889.264,
              -2604.597,
              4354.594
            ],
            [
              -1854.797,
              -2587.399,
              4393.114
            ],
            [
              -1805.935,
              -2485.853,
              4505.804
            ],
            [
              -1803.13,
              -2436.921,
              4554.816
            ],
            [
              -1757.32,
              -2362.039,
              4642.599
            ],
            [
              -1745.639,
              -2333.352,
              4673.573
            ],
            [
              -1727.311,
              -2305.799,
              4706.666
            ],
            [
              -1547.472,
              -2017.345,
              5046.589
            ],
            [
              -1343.434,
              -1674.784,
              5445.311
            ],
            [
              -1305.861,
              -1628.702,
              5504.769
            ],
            [
              -1268.647,
              -1602.651,
              5550.195
            ],
            [
              -1054.592,
              -1494.059,
              5790.22
            ],
            [
              -1027.103,
              -1471.176,
              5825.987
            ],
            [
              -1009.966,
              -1450.333,
              5852.97
            ],
            [
              -998.422,
              -1410.718,
              5894.233
            ],
            [
              -987.78,
              -1363.9,
              5942.245
            ],
            [
              -988.723,
              -1201.352,
              6104.796
            ],
            [
              -990.397,
              -1186.85,
              6119.394
            ],
            [
              -1017.615,
              -1122.906,
              6188.89
            ],
            [
              -1020.518,
              -1105.042,
              6206.989
            ],
            [
              -1018.304,
              -1089.497,
              6222.69
            ],
            [
              -1013.532,
              -1075.111,
              6237.847
            ],
            [
              -1005.537,
              -1060.783,
              6254.255
            ],
            [
              -969.041,
              -1039.175,
              6296.668
            ],
            [
              -947.066,
              -1036.231,
              6318.839
            ],
            [
              -930.307,
              -1036.533,
              6335.601
            ],
            [
              -906.579,
              -1043.639,
              6360.37
            ],
            [
              -895.802,
              -1053.852,
              6375.218
            ],
            [
              -890.221,
              -1066.198,
              6388.767
            ],
            [
              -882.043,
              -1077.478,
              6402.699
            ],
            [
              -868.708,
              -1088.851,
              6420.225
            ],
            [
              -846.005,
              -1097.331,
              6444.461
            ],
            [
              -837.363,
              -1098.358,
              6453.163
            ],
            [
              -813.038,
              -1094.85,
              6477.74
            ],
            [
              -785.651,
              -1089.799,
              6505.588
            ],
            [
              -774.937,
              -1088.05,
              6516.445
            ],
            [
              -717.669,
              -1083.853,
              6573.866
            ],
            [
              -647.083,
              -1062.792,
              6647.527
            ],
            [
              -599.769,
              -1049.176,
              6696.761
            ],
            [
              -535.555,
              -1028.072,
              6764.354
            ],
            [
              -464.693,
              -995.958,
              6842.154
            ],
            [
              -361.843,
              -942.16,
              6958.224
            ],
            [
              -331.427,
              -923.524,
              6993.895
            ],
            [
              -286.654,
              -898.264,
              7045.302
            ],
            [
              -196.966,
              -846.075,
              7149.07
            ],
            [
              -115.583,
              -803.025,
              7241.138
            ],
            [
              -95.312,
              -792.953,
              7263.773
            ],
            [
              -40.176,
              -770.281,
              7323.388
            ],
            [
              224.176,
              -700.119,
              7596.893
            ],
            [
              211.01,
              -644.216,
              7654.325
            ],
            [
              143.71,
              -480.456,
              7831.375
            ],
            [
              126.134,
              -439.133,
              7876.281
            ],
            [
              119.827,
              -411,
              7905.112
            ],
            [
              105.562,
              -273.812,
              8043.039
            ],
            [
              80.298,
              -280.031,
              8069.058
            ],
            [
              41.557,
              -282.665,
              8107.888
            ],
            [
              35.151,
              -280.322,
              8114.709
            ],
            [
              24.998,
              -271.231,
              8128.337
            ],
            [
              19.399,
              -259.997,
              8140.889
            ],
            [
              19.541,
              -252.207,
              8148.681
            ],
            [
              25.627,
              -236.732,
              8165.309
            ],
            [
              52.464,
              -214.957,
              8199.869
            ],
            [
              95.418,
              -193.475,
              8247.895
            ],
            [
              111.139,
              -187.69,
              8264.647
            ],
            [
              118.546,
              -198.349,
              8277.627
            ],
            [
              118.351,
              -267.309,
              8346.587
            ],
            [
              118.552,
              -304.106,
              8383.385
            ],
            [
              124.949,
              -377.696,
              8457.253
            ],
            [
              130.203,
              -407.85,
              8487.861
            ],
            [
              144.816,
              -445.964,
              8528.68
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:1158",
              "position": {
                "x": -2456.526,
                "z": -5595.784
              },
              "distanceAlongShapeM": 155.066,
              "shapeOffsetM": 3.93,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:6914",
              "position": {
                "x": -2139.87,
                "z": -5138.296
              },
              "distanceAlongShapeM": 754.33,
              "shapeOffsetM": 3.749,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:8269",
              "position": {
                "x": -2245.99,
                "z": -4656.611
              },
              "distanceAlongShapeM": 1352.547,
              "shapeOffsetM": 4.764,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:7896",
              "position": {
                "x": -2601.622,
                "z": -4511.165
              },
              "distanceAlongShapeM": 2316.422,
              "shapeOffsetM": 1.945,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:5450",
              "position": {
                "x": -2366.341,
                "z": -3921.977
              },
              "distanceAlongShapeM": 2952.321,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:5451",
              "position": {
                "x": -2289.819,
                "z": -3676.197
              },
              "distanceAlongShapeM": 3209.248,
              "shapeOffsetM": 9.414,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:5452",
              "position": {
                "x": -2044.086,
                "z": -2974.773
              },
              "distanceAlongShapeM": 3952.852,
              "shapeOffsetM": 3.798,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:5214",
              "position": {
                "x": -1747.763,
                "z": -2332.152
              },
              "distanceAlongShapeM": 4673.573,
              "shapeOffsetM": 2.44,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:5220",
              "position": {
                "x": -1001.511,
                "z": -1410.409
              },
              "distanceAlongShapeM": 5893.666,
              "shapeOffsetM": 3.052,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:6635",
              "position": {
                "x": -775.751,
                "z": -1082.734
              },
              "distanceAlongShapeM": 6516.445,
              "shapeOffsetM": 5.378,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:17638",
              "position": {
                "x": -42.035,
                "z": -765.399
              },
              "distanceAlongShapeM": 7323.388,
              "shapeOffsetM": 5.224,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:5244",
              "position": {
                "x": 121.213,
                "z": -441.083
              },
              "distanceAlongShapeM": 7876.281,
              "shapeOffsetM": 5.293,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            },
            {
              "stopId": "judu:stop:5245",
              "position": {
                "x": 150.182,
                "z": -443.837
              },
              "distanceAlongShapeM": 8528.615,
              "shapeOffsetM": 5.772,
              "arrivalOffsetSeconds": 1680,
              "departureOffsetSeconds": 1680
            }
          ],
          "departuresSeconds": [
            18240,
            19680,
            20640,
            21720,
            22560,
            23580,
            24480,
            25500,
            26340,
            27360,
            28260,
            29400,
            30240,
            31260,
            32220,
            34020,
            35940,
            37740,
            39540,
            40860,
            42120,
            43440,
            44760,
            46080,
            47400,
            48720,
            50040,
            51360,
            52560,
            53820,
            55140,
            56340,
            57420,
            58440,
            59640,
            60840,
            61980,
            63000,
            64080,
            65160,
            66180,
            67080,
            69120,
            71220,
            73560,
            74820,
            75960,
            77160,
            78360,
            79560,
            80760,
            81960,
            83160
          ]
        },
        {
          "id": "judu:pattern:vilnius_expressbus_3G-A:1",
          "sourceRouteId": "vilnius_expressbus_3G-A",
          "sourceShapeId": "vilnius_expressbus_3G-A_b-a",
          "directionId": 1,
          "headsign": "Fabijoniškės (Apylanka P. Žadeikos g.)",
          "directionName": "Žaliasis tiltas–Fabijoniškės (Apylanka P. Žadeikos g.)",
          "mode": "bus",
          "routeShortName": "3G-A",
          "routeLongName": "Fabijoniškės–Žaliasis tiltas (Apylanka P. Žadeikos g.)",
          "routeColor": "008000",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              144.816,
              -445.964,
              0
            ],
            [
              174.587,
              -519.993,
              79.791
            ],
            [
              187.997,
              -562.53,
              124.392
            ],
            [
              214.213,
              -645.388,
              211.298
            ],
            [
              223.987,
              -656.808,
              226.33
            ],
            [
              236.049,
              -695.879,
              267.22
            ],
            [
              236.925,
              -708.144,
              279.517
            ],
            [
              229.693,
              -715.805,
              290.052
            ],
            [
              23.734,
              -765.484,
              501.918
            ],
            [
              -55.388,
              -799.514,
              588.048
            ],
            [
              -306.711,
              -924.235,
              868.616
            ],
            [
              -475.993,
              -1014.678,
              1060.544
            ],
            [
              -535.776,
              -1040.314,
              1125.591
            ],
            [
              -673.187,
              -1080.133,
              1268.655
            ],
            [
              -764.624,
              -1108.462,
              1364.38
            ],
            [
              -822.801,
              -1117.509,
              1423.257
            ],
            [
              -837.686,
              -1120.58,
              1438.455
            ],
            [
              -857.223,
              -1131.36,
              1460.769
            ],
            [
              -899.68,
              -1161.766,
              1512.991
            ],
            [
              -917.464,
              -1182.597,
              1540.381
            ],
            [
              -926.283,
              -1206.929,
              1566.261
            ],
            [
              -917.431,
              -1323.977,
              1683.644
            ],
            [
              -911.942,
              -1448.758,
              1808.545
            ],
            [
              -922.391,
              -1491.986,
              1853.018
            ],
            [
              -939.829,
              -1529.521,
              1894.406
            ],
            [
              -961.618,
              -1558.073,
              1930.322
            ],
            [
              -995.732,
              -1590.856,
              1977.635
            ],
            [
              -1026.383,
              -1610.342,
              2013.956
            ],
            [
              -1072.441,
              -1626.213,
              2062.672
            ],
            [
              -1262.636,
              -1662.874,
              2256.368
            ],
            [
              -1320.472,
              -1688.554,
              2319.648
            ],
            [
              -1370.209,
              -1729.965,
              2384.368
            ],
            [
              -1653.223,
              -2198.827,
              2932.025
            ],
            [
              -1682.619,
              -2257.615,
              2997.753
            ],
            [
              -1702.963,
              -2314.026,
              3057.721
            ],
            [
              -1715.793,
              -2345.231,
              3091.461
            ],
            [
              -1755.799,
              -2415.464,
              3172.288
            ],
            [
              -1791.442,
              -2468.3,
              3236.023
            ],
            [
              -1838.817,
              -2558.74,
              3338.119
            ],
            [
              -1870.823,
              -2630.339,
              3416.546
            ],
            [
              -1876.019,
              -2641.711,
              3429.049
            ],
            [
              -1912.507,
              -2715.506,
              3511.372
            ],
            [
              -1995.657,
              -2933.332,
              3744.529
            ],
            [
              -2020.861,
              -3009.696,
              3824.945
            ],
            [
              -2029.851,
              -3041.625,
              3858.116
            ],
            [
              -2244.442,
              -3639.648,
              4493.474
            ],
            [
              -2268.114,
              -3687.714,
              4547.053
            ],
            [
              -2346.702,
              -3915.499,
              4788.014
            ],
            [
              -2363.609,
              -3964.478,
              4839.829
            ],
            [
              -2466.817,
              -4247.487,
              5141.07
            ],
            [
              -2539.058,
              -4427.617,
              5335.146
            ],
            [
              -2559.838,
              -4475.922,
              5387.731
            ],
            [
              -2571.739,
              -4497.221,
              5412.129
            ],
            [
              -2635.224,
              -4626.347,
              5556.018
            ],
            [
              -2636.28,
              -4649.706,
              5579.4
            ],
            [
              -2631.949,
              -4659.802,
              5590.386
            ],
            [
              -2592.254,
              -4673.861,
              5632.497
            ],
            [
              -2567.235,
              -4679.869,
              5658.228
            ],
            [
              -2547.659,
              -4684.927,
              5678.446
            ],
            [
              -2514.956,
              -4692.987,
              5712.128
            ],
            [
              -2465.325,
              -4709.501,
              5764.434
            ],
            [
              -2409.103,
              -4736.1,
              5826.631
            ],
            [
              -2349.957,
              -4779.45,
              5899.962
            ],
            [
              -2306.893,
              -4821.402,
              5960.083
            ],
            [
              -2285.316,
              -4847.778,
              5994.161
            ],
            [
              -2241.672,
              -4921.636,
              6079.949
            ],
            [
              -2239.148,
              -4925.337,
              6084.429
            ],
            [
              -2217.405,
              -4969.935,
              6134.045
            ],
            [
              -2110.315,
              -5178.897,
              6368.85
            ],
            [
              -2127.276,
              -5190.841,
              6389.595
            ],
            [
              -2145.02,
              -5203.693,
              6411.504
            ],
            [
              -2175.503,
              -5222.268,
              6447.201
            ],
            [
              -2204.955,
              -5248.463,
              6486.616
            ],
            [
              -2230.543,
              -5274.726,
              6523.284
            ],
            [
              -2512.326,
              -5691.648,
              7026.499
            ],
            [
              -2515.223,
              -5708.154,
              7043.257
            ],
            [
              -2529.5,
              -5729.639,
              7069.053
            ],
            [
              -2529.407,
              -5747.007,
              7086.421
            ],
            [
              -2525.623,
              -5751.527,
              7092.316
            ],
            [
              -2510.288,
              -5758.477,
              7109.153
            ],
            [
              -2499.033,
              -5756.062,
              7120.664
            ],
            [
              -2480.761,
              -5727.829,
              7154.294
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:5245",
              "position": {
                "x": 150.182,
                "z": -443.837
              },
              "distanceAlongShapeM": 0.029,
              "shapeOffsetM": 5.773,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:753",
              "position": {
                "x": -53.078,
                "z": -805.275
              },
              "distanceAlongShapeM": 588.539,
              "shapeOffsetM": 6.187,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:988",
              "position": {
                "x": -763.423,
                "z": -1114.127
              },
              "distanceAlongShapeM": 1364.38,
              "shapeOffsetM": 5.791,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:5290",
              "position": {
                "x": -1711.936,
                "z": -2347.263
              },
              "distanceAlongShapeM": 3091.461,
              "shapeOffsetM": 4.36,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:986",
              "position": {
                "x": -2025.964,
                "z": -3043.002
              },
              "distanceAlongShapeM": 3858.116,
              "shapeOffsetM": 4.124,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:4388",
              "position": {
                "x": -2242.142,
                "z": -3640.305
              },
              "distanceAlongShapeM": 4493.316,
              "shapeOffsetM": 2.386,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:823",
              "position": {
                "x": -2360.668,
                "z": -3965.493
              },
              "distanceAlongShapeM": 4839.829,
              "shapeOffsetM": 3.112,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:7897",
              "position": {
                "x": -2556.572,
                "z": -4477.451
              },
              "distanceAlongShapeM": 5387.731,
              "shapeOffsetM": 3.606,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:6911",
              "position": {
                "x": -2236.559,
                "z": -4923.953
              },
              "distanceAlongShapeM": 6084.429,
              "shapeOffsetM": 2.936,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:6915",
              "position": {
                "x": -2143.028,
                "z": -5207.26
              },
              "distanceAlongShapeM": 6411.659,
              "shapeOffsetM": 4.083,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:5512",
              "position": {
                "x": -2513.285,
                "z": -5709.442
              },
              "distanceAlongShapeM": 7043.257,
              "shapeOffsetM": 2.327,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            }
          ],
          "departuresSeconds": [
            19800,
            21240,
            22260,
            23340,
            24180,
            25140,
            26040,
            27060,
            27960,
            29040,
            29940,
            31140,
            32040,
            33060,
            34020,
            35700,
            37620,
            39480,
            41220,
            42540,
            43800,
            45120,
            46440,
            47760,
            49080,
            50340,
            51660,
            53100,
            54300,
            55560,
            56880,
            58140,
            59220,
            60300,
            61500,
            62700,
            63840,
            64860,
            65880,
            66960,
            67980,
            68880,
            70920,
            72900,
            75180,
            76440,
            77580,
            78780,
            79920,
            81120,
            82260,
            83460,
            84660
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_bus_4",
      "sourceRouteId": "vilnius_bus_4",
      "mode": "bus",
      "shortName": "4",
      "longName": "Stotis–Rodūnios kelias–Kirtimai",
      "color": "0073AC",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_bus_4:0",
          "sourceRouteId": "vilnius_bus_4",
          "sourceShapeId": "vilnius_bus_4_a-b",
          "directionId": 0,
          "headsign": "Kirtimai",
          "directionName": "Stotis–Rodūnios kelias–Kirtimai",
          "mode": "bus",
          "routeShortName": "4",
          "routeLongName": "Stotis–Rodūnios kelias–Kirtimai",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              365.148,
              1967.953,
              0
            ],
            [
              359.628,
              1983.639,
              16.629
            ],
            [
              363.117,
              1998.047,
              31.453
            ],
            [
              375.555,
              2007.839,
              47.283
            ],
            [
              384.565,
              2006.561,
              56.383
            ],
            [
              450.348,
              1969.735,
              131.773
            ],
            [
              464.314,
              1957.234,
              150.516
            ],
            [
              465.443,
              1943.866,
              163.932
            ],
            [
              460.314,
              1934.517,
              174.596
            ],
            [
              448.99,
              1930.796,
              186.515
            ],
            [
              427.686,
              1930.073,
              207.831
            ],
            [
              403.862,
              1932.735,
              231.803
            ],
            [
              390.012,
              1916.29,
              253.304
            ],
            [
              339.428,
              1831.495,
              352.04
            ],
            [
              318.606,
              1821.856,
              374.985
            ],
            [
              29.934,
              1735.835,
              676.201
            ],
            [
              -11.394,
              1732.372,
              717.674
            ],
            [
              -46.755,
              1740.57,
              753.973
            ],
            [
              -320.217,
              1781.157,
              1030.43
            ],
            [
              -514.905,
              1842.557,
              1234.571
            ],
            [
              -520.923,
              1849.358,
              1243.652
            ],
            [
              -525.385,
              1862.522,
              1257.552
            ],
            [
              -507.688,
              1932.818,
              1330.042
            ],
            [
              -496.901,
              1964.699,
              1363.698
            ],
            [
              -462.075,
              2106.562,
              1509.773
            ],
            [
              -436.719,
              2188.482,
              1595.527
            ],
            [
              -427.991,
              2207.248,
              1616.224
            ],
            [
              -344.32,
              2338.207,
              1771.63
            ],
            [
              -326.137,
              2380.181,
              1817.373
            ],
            [
              -285.296,
              2533.066,
              1975.619
            ],
            [
              -285.194,
              2584.883,
              2027.437
            ],
            [
              -278.622,
              2616.436,
              2059.667
            ],
            [
              -251.706,
              2819.669,
              2264.674
            ],
            [
              -239.003,
              2950.799,
              2396.418
            ],
            [
              -239.164,
              2977.519,
              2423.139
            ],
            [
              -243.808,
              3023.423,
              2469.277
            ],
            [
              -251.845,
              3073.034,
              2519.535
            ],
            [
              -253.335,
              3121.382,
              2567.906
            ],
            [
              -378.969,
              3774.894,
              3233.384
            ],
            [
              -384.152,
              3809.498,
              3268.374
            ],
            [
              -385.02,
              3832.891,
              3291.783
            ],
            [
              -382.299,
              3876.258,
              3335.236
            ],
            [
              -328.221,
              4117.961,
              3582.914
            ],
            [
              -328.111,
              4136.803,
              3601.757
            ],
            [
              -271.052,
              4387.439,
              3858.805
            ],
            [
              -232.43,
              4591.563,
              4066.551
            ],
            [
              -198.969,
              4859.225,
              4336.297
            ],
            [
              -145.658,
              5250.139,
              4730.829
            ],
            [
              -103.917,
              5593.368,
              5076.587
            ],
            [
              -105.118,
              5624.591,
              5107.833
            ],
            [
              -112.727,
              5670.599,
              5154.466
            ],
            [
              -126.648,
              5764.103,
              5249
            ],
            [
              -188.014,
              6119.22,
              5609.381
            ],
            [
              -193.614,
              6145.786,
              5636.531
            ],
            [
              -199.413,
              6202.918,
              5693.956
            ],
            [
              -253.467,
              6534.523,
              6029.938
            ],
            [
              -260.337,
              6549.067,
              6046.023
            ],
            [
              -273.081,
              6549.358,
              6058.769
            ],
            [
              -281.668,
              6554.207,
              6068.631
            ],
            [
              -283.919,
              6560.648,
              6075.454
            ],
            [
              -282.992,
              6566.105,
              6080.989
            ],
            [
              -276.64,
              6571.497,
              6089.322
            ],
            [
              -272.146,
              6572.479,
              6093.921
            ],
            [
              -259.894,
              6566.677,
              6107.478
            ],
            [
              -257.427,
              6557.862,
              6116.631
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:8262",
              "position": {
                "x": 365.148,
                "z": 1967.953
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": -300,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:6650",
              "position": {
                "x": -11.424,
                "z": 1732.135
              },
              "distanceAlongShapeM": 717.674,
              "shapeOffsetM": 0.239,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:7851",
              "position": {
                "x": -511.654,
                "z": 1933.795
              },
              "distanceAlongShapeM": 1330.021,
              "shapeOffsetM": 4.085,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:5173",
              "position": {
                "x": -290.153,
                "z": 2585.475
              },
              "distanceAlongShapeM": 2027.437,
              "shapeOffsetM": 4.994,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:5175",
              "position": {
                "x": -255.513,
                "z": 3072.44
              },
              "distanceAlongShapeM": 2519.535,
              "shapeOffsetM": 3.716,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:5180",
              "position": {
                "x": -328.523,
                "z": 4136.892
              },
              "distanceAlongShapeM": 3601.757,
              "shapeOffsetM": 0.422,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:5182",
              "position": {
                "x": -232.492,
                "z": 4591.573
              },
              "distanceAlongShapeM": 4066.553,
              "shapeOffsetM": 0.062,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:8240",
              "position": {
                "x": -199.233,
                "z": 4859.257
              },
              "distanceAlongShapeM": 4336.296,
              "shapeOffsetM": 0.266,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            },
            {
              "stopId": "judu:stop:5193",
              "position": {
                "x": -114.143,
                "z": 5670.365
              },
              "distanceAlongShapeM": 5154.466,
              "shapeOffsetM": 1.436,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:5194",
              "position": {
                "x": -197.879,
                "z": 6145.003
              },
              "distanceAlongShapeM": 5636.531,
              "shapeOffsetM": 4.336,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:690",
              "position": {
                "x": -256.918,
                "z": 6557.964
              },
              "distanceAlongShapeM": 6116.631,
              "shapeOffsetM": 0.519,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            }
          ],
          "departuresSeconds": [
            19800,
            21300,
            22680,
            24480,
            26100,
            27900,
            29640,
            36000,
            39180,
            42060,
            45420,
            48900,
            52560,
            56100,
            59820,
            64020,
            70380,
            73200,
            75960,
            78720,
            81480
          ]
        },
        {
          "id": "judu:pattern:vilnius_bus_4:1",
          "sourceRouteId": "vilnius_bus_4",
          "sourceShapeId": "vilnius_bus_4_b-a",
          "directionId": 1,
          "headsign": "Stotis",
          "directionName": "Kirtimai–Rodūnios kelias–Stotis",
          "mode": "bus",
          "routeShortName": "4",
          "routeLongName": "Stotis–Rodūnios kelias–Kirtimai",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              -257.427,
              6557.862,
              0
            ],
            [
              -213.845,
              6303.224,
              258.341
            ],
            [
              -208.763,
              6274.258,
              287.75
            ],
            [
              -205.197,
              6253.932,
              308.386
            ],
            [
              -199.413,
              6202.918,
              359.727
            ],
            [
              -142.241,
              5865.689,
              701.768
            ],
            [
              -125.115,
              5777.434,
              791.669
            ],
            [
              -117.825,
              5741.349,
              828.483
            ],
            [
              -114.707,
              5710.452,
              859.537
            ],
            [
              -99.68,
              5613.329,
              957.815
            ],
            [
              -109.103,
              5521.102,
              1050.523
            ],
            [
              -145.658,
              5250.139,
              1323.94
            ],
            [
              -167.989,
              5051.278,
              1524.051
            ],
            [
              -173.264,
              4999.541,
              1576.056
            ],
            [
              -176.211,
              4974.653,
              1601.118
            ],
            [
              -230.472,
              4551.546,
              2027.69
            ],
            [
              -236.808,
              4531.537,
              2048.678
            ],
            [
              -291.097,
              4278.706,
              2307.272
            ],
            [
              -315.819,
              4161.153,
              2427.397
            ],
            [
              -323.596,
              4115.749,
              2473.462
            ],
            [
              -345.945,
              4030.338,
              2561.749
            ],
            [
              -367.116,
              3930.531,
              2663.776
            ],
            [
              -376.774,
              3896.196,
              2699.444
            ],
            [
              -379.958,
              3791.61,
              2804.078
            ],
            [
              -316.278,
              3458.717,
              3143.007
            ],
            [
              -227.915,
              2951.79,
              3657.578
            ],
            [
              -268.934,
              2604.253,
              4007.527
            ],
            [
              -287.151,
              2501.929,
              4111.46
            ],
            [
              -327.226,
              2355.709,
              4263.072
            ],
            [
              -350.367,
              2324.958,
              4301.558
            ],
            [
              -412.128,
              2228.113,
              4416.42
            ],
            [
              -425.492,
              2202.75,
              4445.089
            ],
            [
              -439.803,
              2160.707,
              4489.501
            ],
            [
              -445.668,
              2121.85,
              4528.798
            ],
            [
              -471.768,
              2034.377,
              4620.082
            ],
            [
              -499.661,
              1919.106,
              4738.679
            ],
            [
              -512.556,
              1856.885,
              4802.222
            ],
            [
              -491.403,
              1846.355,
              4825.851
            ],
            [
              -471.457,
              1839.899,
              4846.816
            ],
            [
              -432.32,
              1825.49,
              4888.522
            ],
            [
              -327.19,
              1787.963,
              5000.149
            ],
            [
              -259.046,
              1774.482,
              5069.613
            ],
            [
              -147.106,
              1756.865,
              5182.931
            ],
            [
              9.981,
              1738.424,
              5341.097
            ],
            [
              41.02,
              1742.312,
              5372.378
            ],
            [
              64.443,
              1752.06,
              5397.748
            ],
            [
              135.751,
              1771.757,
              5471.727
            ],
            [
              319.251,
              1821.845,
              5661.94
            ],
            [
              341.2,
              1822.557,
              5683.901
            ],
            [
              378.73,
              1828.551,
              5721.906
            ],
            [
              526.755,
              1843.654,
              5870.7
            ],
            [
              583.03,
              1851.529,
              5927.523
            ],
            [
              594.469,
              1864.396,
              5944.739
            ],
            [
              593.052,
              1870.271,
              5950.783
            ],
            [
              545.045,
              1891.188,
              6003.149
            ],
            [
              472.814,
              1928.134,
              6084.28
            ],
            [
              457.253,
              1923.966,
              6100.39
            ],
            [
              443.063,
              1924.225,
              6114.582
            ],
            [
              417.95,
              1926.911,
              6139.839
            ],
            [
              405.756,
              1930.474,
              6152.542
            ],
            [
              392.999,
              1938.5,
              6167.614
            ],
            [
              365.148,
              1967.953,
              6208.15
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:690",
              "position": {
                "x": -256.918,
                "z": 6557.964
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 0.519,
              "arrivalOffsetSeconds": -420,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:493",
              "position": {
                "x": -202.621,
                "z": 6275.335
              },
              "distanceAlongShapeM": 287.75,
              "shapeOffsetM": 6.236,
              "arrivalOffsetSeconds": 60,
              "departureOffsetSeconds": 60
            },
            {
              "stopId": "judu:stop:588",
              "position": {
                "x": -116.078,
                "z": 5741.647
              },
              "distanceAlongShapeM": 828.483,
              "shapeOffsetM": 1.772,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:5184",
              "position": {
                "x": -168.292,
                "z": 4998.962
              },
              "distanceAlongShapeM": 1576.056,
              "shapeOffsetM": 5.005,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:410",
              "position": {
                "x": -229.992,
                "z": 4551.452
              },
              "distanceAlongShapeM": 2027.69,
              "shapeOffsetM": 0.49,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:5181",
              "position": {
                "x": -323.098,
                "z": 4115.642
              },
              "distanceAlongShapeM": 2473.462,
              "shapeOffsetM": 0.509,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:7414",
              "position": {
                "x": -225.435,
                "z": 2951.666
              },
              "distanceAlongShapeM": 3657.578,
              "shapeOffsetM": 2.483,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:6854",
              "position": {
                "x": -266.588,
                "z": 2603.973
              },
              "distanceAlongShapeM": 4007.527,
              "shapeOffsetM": 2.363,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:5166",
              "position": {
                "x": -470.051,
                "z": 1843.985
              },
              "distanceAlongShapeM": 4846.816,
              "shapeOffsetM": 4.322,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:5160",
              "position": {
                "x": 63.816,
                "z": 1754.143
              },
              "distanceAlongShapeM": 5397.748,
              "shapeOffsetM": 2.176,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            },
            {
              "stopId": "judu:stop:16581",
              "position": {
                "x": 378.73,
                "z": 1828.551
              },
              "distanceAlongShapeM": 5721.906,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            }
          ],
          "departuresSeconds": [
            21180,
            22680,
            24420,
            26220,
            27900,
            29700,
            31500,
            37500,
            40680,
            43980,
            47400,
            50700,
            54540,
            57900,
            61680,
            65700,
            71820,
            74580,
            77340,
            80040,
            82860
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_expressbus_4G",
      "sourceRouteId": "vilnius_expressbus_4G",
      "mode": "bus",
      "shortName": "4G",
      "longName": "Pilaitė–Konstitucijos pr.–Saulėtekis",
      "color": "008000",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_expressbus_4G:0",
          "sourceRouteId": "vilnius_expressbus_4G",
          "sourceShapeId": "vilnius_expressbus_4G_a-b",
          "directionId": 0,
          "headsign": "Saulėtekis",
          "directionName": "Pilaitė–Konstitucijos pr.–Saulėtekis",
          "mode": "bus",
          "routeShortName": "4G",
          "routeLongName": "Pilaitė–Konstitucijos pr.–Saulėtekis",
          "routeColor": "008000",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              -6782.722,
              -1517.922,
              0
            ],
            [
              -6790.213,
              -1503.239,
              16.483
            ],
            [
              -6789.666,
              -1493.237,
              26.501
            ],
            [
              -6789.574,
              -1493.338,
              26.637
            ],
            [
              -6793.888,
              -1496.036,
              31.725
            ],
            [
              -6804.801,
              -1471.131,
              58.916
            ],
            [
              -6817.871,
              -1443.083,
              89.859
            ],
            [
              -6849.755,
              -1383.551,
              157.392
            ],
            [
              -6861.847,
              -1368.999,
              176.312
            ],
            [
              -6868.44,
              -1344.278,
              201.897
            ],
            [
              -6865.755,
              -1340.811,
              206.282
            ],
            [
              -6856.389,
              -1336.272,
              216.69
            ],
            [
              -6847.396,
              -1333.735,
              226.034
            ],
            [
              -6839.19,
              -1361.045,
              254.55
            ],
            [
              -6823.318,
              -1421.841,
              317.384
            ],
            [
              -6726.31,
              -1602.786,
              522.693
            ],
            [
              -6717.082,
              -1622.391,
              544.361
            ],
            [
              -6684.251,
              -1702.465,
              630.904
            ],
            [
              -6676.395,
              -1733.766,
              663.176
            ],
            [
              -6677.514,
              -1993.121,
              922.533
            ],
            [
              -6624.319,
              -1987.967,
              975.977
            ],
            [
              -6584.624,
              -1989.111,
              1015.689
            ],
            [
              -6371.246,
              -1988.684,
              1229.067
            ],
            [
              -6349.222,
              -1988.597,
              1251.091
            ],
            [
              -6316.461,
              -1988.613,
              1283.853
            ],
            [
              -6227.58,
              -1992.883,
              1372.836
            ],
            [
              -5930.998,
              -1988.982,
              1669.443
            ],
            [
              -5852.467,
              -2027.262,
              1756.808
            ],
            [
              -5732.389,
              -2088.886,
              1891.775
            ],
            [
              -5670.572,
              -2064.637,
              1958.178
            ],
            [
              -5318.875,
              -1890.278,
              2350.724
            ],
            [
              -5264.212,
              -1860.04,
              2413.193
            ],
            [
              -5225.223,
              -1841.781,
              2456.245
            ],
            [
              -5160.018,
              -1798.366,
              2534.581
            ],
            [
              -5102.28,
              -1739.239,
              2617.223
            ],
            [
              -5012.864,
              -1637.24,
              2752.866
            ],
            [
              -4831.761,
              -1414.361,
              3040.048
            ],
            [
              -4763.266,
              -1360.258,
              3127.333
            ],
            [
              -4704.75,
              -1314.599,
              3201.555
            ],
            [
              -4653.804,
              -1300.53,
              3254.408
            ],
            [
              -4405.208,
              -1203.507,
              3521.266
            ],
            [
              -4296.995,
              -1171.977,
              3633.979
            ],
            [
              -4246.587,
              -1162.091,
              3685.348
            ],
            [
              -4190.857,
              -1159.392,
              3741.143
            ],
            [
              -3912.052,
              -1135.777,
              4020.946
            ],
            [
              -3758.891,
              -1120.334,
              4174.884
            ],
            [
              -3704.617,
              -1115.802,
              4229.347
            ],
            [
              -3657.704,
              -1114.039,
              4276.293
            ],
            [
              -3599.031,
              -1113.947,
              4334.966
            ],
            [
              -3412.497,
              -1176.2,
              4531.614
            ],
            [
              -3355.367,
              -1190.556,
              4590.52
            ],
            [
              -3109.19,
              -1234.288,
              4840.551
            ],
            [
              -3070.013,
              -1242.306,
              4880.54
            ],
            [
              -2879.155,
              -1277.94,
              5074.696
            ],
            [
              -2839.273,
              -1283.094,
              5114.91
            ],
            [
              -2787.087,
              -1285.125,
              5167.135
            ],
            [
              -2748.376,
              -1283.58,
              5205.877
            ],
            [
              -2714.118,
              -1278.617,
              5240.493
            ],
            [
              -2670.7,
              -1266.023,
              5285.7
            ],
            [
              -2624.585,
              -1246.798,
              5335.662
            ],
            [
              -2499.949,
              -1183.085,
              5475.639
            ],
            [
              -2469.831,
              -1172.717,
              5507.492
            ],
            [
              -2418.716,
              -1162.489,
              5559.62
            ],
            [
              -2392.231,
              -1159.617,
              5586.26
            ],
            [
              -2152.041,
              -1187.387,
              5828.05
            ],
            [
              -2126.526,
              -1191.159,
              5853.842
            ],
            [
              -2118.854,
              -1195.63,
              5862.722
            ],
            [
              -1988.935,
              -1213.522,
              5993.867
            ],
            [
              -1948.388,
              -1217.583,
              6034.617
            ],
            [
              -1866.572,
              -1221.265,
              6116.516
            ],
            [
              -1794.345,
              -1220.324,
              6188.749
            ],
            [
              -1681.879,
              -1204.518,
              6302.32
            ],
            [
              -1544.075,
              -1178.035,
              6442.646
            ],
            [
              -1435.713,
              -1149.425,
              6554.721
            ],
            [
              -1393.22,
              -1142.883,
              6597.715
            ],
            [
              -1155.149,
              -1098.17,
              6839.948
            ],
            [
              -1103.532,
              -1084.281,
              6893.401
            ],
            [
              -1083.324,
              -1083.875,
              6913.613
            ],
            [
              -1022.536,
              -1073.836,
              6975.225
            ],
            [
              -998.991,
              -1055.334,
              7005.169
            ],
            [
              -969.041,
              -1039.175,
              7039.2
            ],
            [
              -947.066,
              -1036.231,
              7061.372
            ],
            [
              -930.307,
              -1036.533,
              7078.134
            ],
            [
              -906.579,
              -1043.639,
              7102.903
            ],
            [
              -895.802,
              -1053.852,
              7117.75
            ],
            [
              -890.221,
              -1066.198,
              7131.299
            ],
            [
              -876.342,
              -1083.147,
              7153.206
            ],
            [
              -864.236,
              -1091.158,
              7167.722
            ],
            [
              -846.005,
              -1097.331,
              7186.97
            ],
            [
              -813.038,
              -1094.85,
              7220.03
            ],
            [
              -785.651,
              -1089.799,
              7247.879
            ],
            [
              -774.937,
              -1088.05,
              7258.735
            ],
            [
              -717.669,
              -1083.853,
              7316.156
            ],
            [
              -647.083,
              -1062.792,
              7389.818
            ],
            [
              -599.769,
              -1049.176,
              7439.052
            ],
            [
              -511.525,
              -1018.488,
              7532.48
            ],
            [
              -361.843,
              -942.16,
              7700.499
            ],
            [
              -331.427,
              -923.524,
              7736.17
            ],
            [
              -286.654,
              -898.264,
              7787.577
            ],
            [
              -196.966,
              -846.075,
              7891.345
            ],
            [
              -115.583,
              -803.025,
              7983.413
            ],
            [
              -95.312,
              -792.953,
              8006.048
            ],
            [
              -40.176,
              -770.281,
              8065.663
            ],
            [
              224.8,
              -701.243,
              8339.486
            ],
            [
              238.603,
              -700.678,
              8353.3
            ],
            [
              294.146,
              -689.755,
              8409.907
            ],
            [
              331.506,
              -684.268,
              8447.668
            ],
            [
              436.802,
              -673.948,
              8553.468
            ],
            [
              647.48,
              -719,
              8768.909
            ],
            [
              692.52,
              -724.28,
              8814.258
            ],
            [
              727.857,
              -730.038,
              8850.061
            ],
            [
              752.192,
              -734.856,
              8874.868
            ],
            [
              1031.058,
              -793.963,
              9159.929
            ],
            [
              1157.03,
              -816.326,
              9287.871
            ],
            [
              1199.169,
              -824.315,
              9330.761
            ],
            [
              1220.015,
              -827.509,
              9351.85
            ],
            [
              1248.96,
              -831.383,
              9381.053
            ],
            [
              1325.104,
              -828.339,
              9457.258
            ],
            [
              1339.141,
              -836.391,
              9473.44
            ],
            [
              1354.364,
              -850.032,
              9493.881
            ],
            [
              1360.583,
              -862.393,
              9507.718
            ],
            [
              1367.85,
              -922.642,
              9568.404
            ],
            [
              1384.491,
              -964.14,
              9613.114
            ],
            [
              1464.439,
              -1103.664,
              9773.92
            ],
            [
              1477.634,
              -1123.116,
              9797.425
            ],
            [
              1488.813,
              -1145.306,
              9822.272
            ],
            [
              1537.374,
              -1238.606,
              9927.453
            ],
            [
              1587.871,
              -1366.453,
              10064.912
            ],
            [
              1626.598,
              -1502.988,
              10206.833
            ],
            [
              1647.564,
              -1589.097,
              10295.457
            ],
            [
              1670.179,
              -1759.844,
              10467.696
            ],
            [
              1672.682,
              -1787.97,
              10495.933
            ],
            [
              1672.408,
              -1813.321,
              10521.285
            ],
            [
              1675.205,
              -1948.102,
              10656.095
            ],
            [
              1724.96,
              -1945.743,
              10705.906
            ],
            [
              1955.555,
              -1909.879,
              10939.273
            ],
            [
              1982.08,
              -1904.808,
              10966.279
            ],
            [
              2058.828,
              -1881.42,
              11046.512
            ],
            [
              2066.336,
              -1880.775,
              11054.047
            ],
            [
              2070.784,
              -1884.198,
              11059.66
            ],
            [
              2081.808,
              -1938.356,
              11114.928
            ],
            [
              2087.374,
              -1962.435,
              11139.642
            ],
            [
              2110.719,
              -2024.1,
              11205.578
            ],
            [
              2234.812,
              -2316.979,
              11523.662
            ],
            [
              2284.924,
              -2429.242,
              11646.602
            ],
            [
              2299.015,
              -2468.47,
              11688.284
            ],
            [
              2319.691,
              -2569.05,
              11790.967
            ],
            [
              2323.471,
              -2587.599,
              11809.897
            ],
            [
              2323.492,
              -2606.972,
              11829.27
            ],
            [
              2328.687,
              -2639.354,
              11862.066
            ],
            [
              2411.872,
              -3118.499,
              12348.378
            ],
            [
              2415.738,
              -3139.252,
              12369.488
            ],
            [
              2418.768,
              -3163.158,
              12393.586
            ],
            [
              2474.472,
              -3526.012,
              12760.691
            ],
            [
              2513.109,
              -3664.781,
              12904.738
            ],
            [
              2520.474,
              -3683.355,
              12924.719
            ],
            [
              2522.312,
              -3689.445,
              12931.08
            ],
            [
              2535.711,
              -3730.887,
              12974.634
            ],
            [
              2556.818,
              -3773.588,
              13022.267
            ],
            [
              2598.204,
              -3834.482,
              13095.894
            ],
            [
              2619.624,
              -3860.489,
              13129.586
            ],
            [
              2635.392,
              -3877.441,
              13152.738
            ],
            [
              2642.893,
              -3890.985,
              13168.22
            ],
            [
              2709.56,
              -3977.961,
              13277.807
            ],
            [
              3021.059,
              -4338.966,
              13754.626
            ],
            [
              3086.352,
              -4293.444,
              13834.222
            ],
            [
              3112.838,
              -4272.891,
              13867.747
            ],
            [
              3142.482,
              -4255.542,
              13902.094
            ],
            [
              3336.938,
              -4126.748,
              14135.335
            ],
            [
              3389.682,
              -4097.691,
              14195.553
            ],
            [
              3403.448,
              -4088.142,
              14212.306
            ],
            [
              3446.229,
              -4072.046,
              14258.015
            ],
            [
              3528.69,
              -4039.102,
              14346.814
            ],
            [
              3592.048,
              -4028.061,
              14411.126
            ],
            [
              3640.778,
              -4019.583,
              14460.588
            ],
            [
              3666.294,
              -4020.567,
              14486.123
            ],
            [
              3848.026,
              -4019.578,
              14667.858
            ],
            [
              3878.881,
              -4023.507,
              14698.962
            ],
            [
              3901.964,
              -4029.514,
              14722.814
            ],
            [
              3958.181,
              -4055.079,
              14784.571
            ],
            [
              3965.111,
              -4059.221,
              14792.645
            ],
            [
              4018.762,
              -4121.92,
              14875.165
            ],
            [
              4037.773,
              -4172.381,
              14929.088
            ],
            [
              4030.875,
              -4184.064,
              14942.656
            ],
            [
              4020.501,
              -4190.327,
              14954.774
            ],
            [
              4013.086,
              -4190.447,
              14962.189
            ],
            [
              4002.213,
              -4183.979,
              14974.841
            ],
            [
              3961.129,
              -4130.112,
              15042.587
            ],
            [
              3954.003,
              -4105.097,
              15068.597
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:7694",
              "position": {
                "x": -6837.763,
                "z": -1360.375
              },
              "distanceAlongShapeM": 254.319,
              "shapeOffsetM": 1.56,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:4526",
              "position": {
                "x": -6711.23,
                "z": -1619.637
              },
              "distanceAlongShapeM": 544.361,
              "shapeOffsetM": 6.468,
              "arrivalOffsetSeconds": 60,
              "departureOffsetSeconds": 60
            },
            {
              "stopId": "judu:stop:6611",
              "position": {
                "x": -6624.485,
                "z": -1982.877
              },
              "distanceAlongShapeM": 975.977,
              "shapeOffsetM": 5.092,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:6615",
              "position": {
                "x": -6349.244,
                "z": -1983.044
              },
              "distanceAlongShapeM": 1251.091,
              "shapeOffsetM": 5.553,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:9561",
              "position": {
                "x": -5852.356,
                "z": -2027.048
              },
              "distanceAlongShapeM": 1756.809,
              "shapeOffsetM": 0.241,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:8934",
              "position": {
                "x": -4704.97,
                "z": -1314.122
              },
              "distanceAlongShapeM": 3201.555,
              "shapeOffsetM": 0.525,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:4989",
              "position": {
                "x": -4247.02,
                "z": -1152.802
              },
              "distanceAlongShapeM": 3685.364,
              "shapeOffsetM": 9.299,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:7342",
              "position": {
                "x": -3705.284,
                "z": -1106.532
              },
              "distanceAlongShapeM": 4229.347,
              "shapeOffsetM": 9.294,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:7416",
              "position": {
                "x": -3108.49,
                "z": -1230.499
              },
              "distanceAlongShapeM": 4840.551,
              "shapeOffsetM": 3.854,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:6397",
              "position": {
                "x": -1103.929,
                "z": -1082.392
              },
              "distanceAlongShapeM": 6893.401,
              "shapeOffsetM": 1.931,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:6635",
              "position": {
                "x": -775.751,
                "z": -1082.734
              },
              "distanceAlongShapeM": 7258.735,
              "shapeOffsetM": 5.378,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:17638",
              "position": {
                "x": -42.035,
                "z": -765.399
              },
              "distanceAlongShapeM": 8065.663,
              "shapeOffsetM": 5.224,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:5667",
              "position": {
                "x": 292.85,
                "z": -682.448
              },
              "distanceAlongShapeM": 8409.907,
              "shapeOffsetM": 7.421,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            },
            {
              "stopId": "judu:stop:6665",
              "position": {
                "x": 1480.223,
                "z": -1121.768
              },
              "distanceAlongShapeM": 9797.425,
              "shapeOffsetM": 2.918,
              "arrivalOffsetSeconds": 1560,
              "departureOffsetSeconds": 1560
            },
            {
              "stopId": "judu:stop:6666",
              "position": {
                "x": 1676.751,
                "z": -1787.797
              },
              "distanceAlongShapeM": 10495.933,
              "shapeOffsetM": 4.073,
              "arrivalOffsetSeconds": 1680,
              "departureOffsetSeconds": 1680
            },
            {
              "stopId": "judu:stop:5092",
              "position": {
                "x": 2087.852,
                "z": -1936.84
              },
              "distanceAlongShapeM": 11114.648,
              "shapeOffsetM": 6.225,
              "arrivalOffsetSeconds": 1860,
              "departureOffsetSeconds": 1860
            },
            {
              "stopId": "judu:stop:5095",
              "position": {
                "x": 2327.089,
                "z": -2587.001
              },
              "distanceAlongShapeM": 11809.897,
              "shapeOffsetM": 3.667,
              "arrivalOffsetSeconds": 1980,
              "departureOffsetSeconds": 1980
            },
            {
              "stopId": "judu:stop:741",
              "position": {
                "x": 2636.723,
                "z": -3876.397
              },
              "distanceAlongShapeM": 13152.738,
              "shapeOffsetM": 1.691,
              "arrivalOffsetSeconds": 2220,
              "departureOffsetSeconds": 2220
            },
            {
              "stopId": "judu:stop:5104",
              "position": {
                "x": 3111.27,
                "z": -4270.537
              },
              "distanceAlongShapeM": 13867.747,
              "shapeOffsetM": 2.828,
              "arrivalOffsetSeconds": 2340,
              "departureOffsetSeconds": 2340
            },
            {
              "stopId": "judu:stop:5105",
              "position": {
                "x": 3402.776,
                "z": -4086.807
              },
              "distanceAlongShapeM": 14212.306,
              "shapeOffsetM": 1.495,
              "arrivalOffsetSeconds": 2400,
              "departureOffsetSeconds": 2400
            },
            {
              "stopId": "judu:stop:5107",
              "position": {
                "x": 3640.634,
                "z": -4014.513
              },
              "distanceAlongShapeM": 14460.588,
              "shapeOffsetM": 5.072,
              "arrivalOffsetSeconds": 2460,
              "departureOffsetSeconds": 2460
            },
            {
              "stopId": "judu:stop:900",
              "position": {
                "x": 3967.843,
                "z": -4055.264
              },
              "distanceAlongShapeM": 14792.645,
              "shapeOffsetM": 4.809,
              "arrivalOffsetSeconds": 2520,
              "departureOffsetSeconds": 2520
            }
          ],
          "departuresSeconds": [
            17940,
            18600,
            19200,
            19800,
            20400,
            21000,
            21480,
            21900,
            22320,
            22740,
            23100,
            23520,
            23940,
            24300,
            24660,
            25020,
            25380,
            25740,
            26100,
            26520,
            27000,
            27480,
            27900,
            28380,
            28860,
            29340,
            29760,
            30180,
            30660,
            31140,
            31620,
            32100,
            32580,
            33180,
            33780,
            34320,
            34860,
            35400,
            35880,
            36360,
            36840,
            37320,
            37980,
            38580,
            39120,
            39660,
            40260,
            40920,
            41640,
            42360,
            43140,
            43920,
            44700,
            45480,
            46200,
            46920,
            47640,
            48360,
            49080,
            49680,
            50340,
            51000,
            51720,
            52200,
            52680,
            53100,
            53520,
            53880,
            54240,
            54600,
            55080,
            55440,
            55800,
            56160,
            56520,
            56880,
            57240,
            57600,
            58080,
            58560,
            59040,
            59520,
            59880,
            60240,
            60600,
            60960,
            61380,
            61800,
            62280,
            62820,
            63300,
            63720,
            64140,
            64560,
            65040,
            65460,
            65880,
            66360,
            66840,
            67380,
            67920,
            68520,
            69300,
            70680,
            71700,
            72780,
            73680,
            74580,
            75360,
            76020,
            76680,
            77340,
            77880,
            78360,
            78960,
            79500,
            80100,
            80700,
            81360,
            82020,
            82740,
            83460,
            84180,
            84840,
            85620,
            86340
          ]
        },
        {
          "id": "judu:pattern:vilnius_expressbus_4G:1",
          "sourceRouteId": "vilnius_expressbus_4G",
          "sourceShapeId": "vilnius_expressbus_4G_b-a",
          "directionId": 1,
          "headsign": "Pilaitė",
          "directionName": "Saulėtekis–Konstitucijos pr.–Pilaitė",
          "mode": "bus",
          "routeShortName": "4G",
          "routeLongName": "Pilaitė–Konstitucijos pr.–Saulėtekis",
          "routeColor": "008000",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              3954.003,
              -4105.097,
              0
            ],
            [
              3949.52,
              -4094.868,
              11.169
            ],
            [
              3943.333,
              -4069.038,
              37.729
            ],
            [
              3940.538,
              -4057,
              50.087
            ],
            [
              3918.536,
              -4045.003,
              75.147
            ],
            [
              3899.276,
              -4037.251,
              95.909
            ],
            [
              3898.616,
              -4036.13,
              97.209
            ],
            [
              3858.828,
              -4027.577,
              137.906
            ],
            [
              3592.048,
              -4028.061,
              404.687
            ],
            [
              3581.678,
              -4031.203,
              415.522
            ],
            [
              3564.996,
              -4038.354,
              433.672
            ],
            [
              3520.083,
              -4051.184,
              480.382
            ],
            [
              3445.458,
              -4078.711,
              559.922
            ],
            [
              3358.965,
              -4120.486,
              655.975
            ],
            [
              3358.852,
              -4122.75,
              658.242
            ],
            [
              3310.064,
              -4150.73,
              714.484
            ],
            [
              3021.059,
              -4338.966,
              1059.385
            ],
            [
              2959.695,
              -4278.804,
              1145.321
            ],
            [
              2940.311,
              -4262.522,
              1170.635
            ],
            [
              2920.517,
              -4237.987,
              1202.16
            ],
            [
              2810.169,
              -4110.107,
              1371.068
            ],
            [
              2739.116,
              -4050.879,
              1463.569
            ],
            [
              2661.391,
              -4003.772,
              1554.455
            ],
            [
              2637.654,
              -3993.387,
              1580.365
            ],
            [
              2619.338,
              -3978.489,
              1603.974
            ],
            [
              2604.004,
              -3971.521,
              1620.817
            ],
            [
              2506.601,
              -3911.447,
              1735.256
            ],
            [
              2494.44,
              -3897.264,
              1753.939
            ],
            [
              2486.488,
              -3883.251,
              1770.051
            ],
            [
              2480.459,
              -3864.316,
              1789.922
            ],
            [
              2475.702,
              -3831.185,
              1823.394
            ],
            [
              2503.004,
              -3722.48,
              1935.475
            ],
            [
              2508.663,
              -3661.358,
              1996.858
            ],
            [
              2467.501,
              -3518.217,
              2145.8
            ],
            [
              2463.864,
              -3499.82,
              2164.553
            ],
            [
              2434.339,
              -3309.248,
              2357.399
            ],
            [
              2430.841,
              -3283.862,
              2383.024
            ],
            [
              2426.976,
              -3256.769,
              2410.391
            ],
            [
              2373.189,
              -2912.935,
              2758.407
            ],
            [
              2328.687,
              -2639.354,
              3035.584
            ],
            [
              2308.053,
              -2536.548,
              3140.44
            ],
            [
              2300.116,
              -2511.178,
              3167.023
            ],
            [
              2295.002,
              -2476.188,
              3202.385
            ],
            [
              2274.24,
              -2414.57,
              3267.406
            ],
            [
              2234.812,
              -2316.979,
              3372.661
            ],
            [
              2177.257,
              -2188.992,
              3512.994
            ],
            [
              2082.177,
              -1964.565,
              3756.731
            ],
            [
              2063.994,
              -1895.874,
              3827.787
            ],
            [
              2025.955,
              -1900.505,
              3866.107
            ],
            [
              1998.15,
              -1907.334,
              3894.739
            ],
            [
              1855.148,
              -1935.839,
              4040.554
            ],
            [
              1712.252,
              -1958.784,
              4185.28
            ],
            [
              1669.637,
              -1962.445,
              4228.052
            ],
            [
              1663.92,
              -1957.886,
              4235.365
            ],
            [
              1665.702,
              -1896.69,
              4296.587
            ],
            [
              1663.09,
              -1759.712,
              4433.589
            ],
            [
              1657.26,
              -1724.669,
              4469.114
            ],
            [
              1660.464,
              -1692.869,
              4501.075
            ],
            [
              1642.718,
              -1572.308,
              4622.935
            ],
            [
              1626.598,
              -1502.988,
              4694.105
            ],
            [
              1590.763,
              -1384.318,
              4818.067
            ],
            [
              1541.473,
              -1260.946,
              4950.921
            ],
            [
              1439.941,
              -1068.699,
              5168.332
            ],
            [
              1422.22,
              -1045.077,
              5197.863
            ],
            [
              1413.029,
              -1024.784,
              5220.14
            ],
            [
              1382.574,
              -969.885,
              5282.921
            ],
            [
              1372.327,
              -959.462,
              5297.537
            ],
            [
              1333.941,
              -943.166,
              5339.239
            ],
            [
              1307.513,
              -942.677,
              5365.671
            ],
            [
              1293.291,
              -944.641,
              5380.028
            ],
            [
              1278.614,
              -942.95,
              5394.803
            ],
            [
              1269.114,
              -935.31,
              5406.993
            ],
            [
              1257.937,
              -924.707,
              5422.4
            ],
            [
              1253.197,
              -916.068,
              5432.253
            ],
            [
              1249.597,
              -901.529,
              5447.231
            ],
            [
              1250.468,
              -889.3,
              5459.491
            ],
            [
              1243.124,
              -868.013,
              5482.01
            ],
            [
              1234.408,
              -851.153,
              5500.989
            ],
            [
              1218.52,
              -838.613,
              5521.23
            ],
            [
              1192.86,
              -831.46,
              5547.868
            ],
            [
              1155.132,
              -824.781,
              5586.183
            ],
            [
              1120.288,
              -815.648,
              5622.204
            ],
            [
              1031.058,
              -793.963,
              5714.031
            ],
            [
              773.373,
              -745.803,
              5976.178
            ],
            [
              730.608,
              -739.605,
              6019.39
            ],
            [
              702.691,
              -732.259,
              6048.257
            ],
            [
              508.13,
              -687.5,
              6247.9
            ],
            [
              443.852,
              -676.304,
              6313.146
            ],
            [
              405.738,
              -680.059,
              6351.444
            ],
            [
              363.165,
              -686.919,
              6394.567
            ],
            [
              341.718,
              -690.021,
              6416.237
            ],
            [
              237.095,
              -710.389,
              6522.824
            ],
            [
              219.749,
              -721.682,
              6543.523
            ],
            [
              73.653,
              -750.808,
              6692.493
            ],
            [
              -18.428,
              -779.188,
              6788.848
            ],
            [
              -55.388,
              -799.514,
              6831.029
            ],
            [
              -306.711,
              -924.235,
              7111.597
            ],
            [
              -475.993,
              -1014.678,
              7303.525
            ],
            [
              -535.776,
              -1040.314,
              7368.573
            ],
            [
              -673.187,
              -1080.133,
              7511.637
            ],
            [
              -764.624,
              -1108.462,
              7607.362
            ],
            [
              -829.227,
              -1116.28,
              7672.436
            ],
            [
              -865.018,
              -1134.559,
              7712.625
            ],
            [
              -891.825,
              -1155.228,
              7746.475
            ],
            [
              -898.939,
              -1163.415,
              7757.321
            ],
            [
              -908.077,
              -1171.394,
              7769.452
            ],
            [
              -917.363,
              -1177.032,
              7780.316
            ],
            [
              -929.666,
              -1178.977,
              7792.772
            ],
            [
              -961.877,
              -1178.457,
              7824.987
            ],
            [
              -977.23,
              -1175.77,
              7840.573
            ],
            [
              -995.797,
              -1164.488,
              7862.299
            ],
            [
              -1006.474,
              -1148.711,
              7881.349
            ],
            [
              -1029.882,
              -1123.799,
              7915.533
            ],
            [
              -1062.634,
              -1116.531,
              7949.082
            ],
            [
              -1097.251,
              -1122.142,
              7984.151
            ],
            [
              -1143.947,
              -1120.636,
              8030.871
            ],
            [
              -1339.338,
              -1158.32,
              8229.862
            ],
            [
              -1374.945,
              -1168.896,
              8267.007
            ],
            [
              -1791.301,
              -1230.398,
              8687.881
            ],
            [
              -1855.793,
              -1231.475,
              8752.382
            ],
            [
              -1940.187,
              -1227.747,
              8836.858
            ],
            [
              -2027.705,
              -1218.399,
              8924.874
            ],
            [
              -2166.609,
              -1198.122,
              9065.25
            ],
            [
              -2255.397,
              -1187.643,
              9154.654
            ],
            [
              -2266.36,
              -1186.843,
              9165.647
            ],
            [
              -2295.924,
              -1182.472,
              9195.532
            ],
            [
              -2392.506,
              -1175.197,
              9292.387
            ],
            [
              -2431.277,
              -1180.078,
              9331.464
            ],
            [
              -2478.584,
              -1193.714,
              9380.697
            ],
            [
              -2533.196,
              -1219.467,
              9441.077
            ],
            [
              -2617.204,
              -1266.966,
              9537.583
            ],
            [
              -2663.944,
              -1285.067,
              9587.706
            ],
            [
              -2710.565,
              -1296.491,
              9635.706
            ],
            [
              -2762.381,
              -1304.469,
              9688.133
            ],
            [
              -2808.767,
              -1305.331,
              9734.527
            ],
            [
              -2858.119,
              -1300.984,
              9784.07
            ],
            [
              -3071.028,
              -1263.439,
              10000.264
            ],
            [
              -3139.719,
              -1251.188,
              10070.039
            ],
            [
              -3159.719,
              -1247.413,
              10090.392
            ],
            [
              -3359.526,
              -1207.182,
              10294.209
            ],
            [
              -3495.953,
              -1192.555,
              10431.418
            ],
            [
              -3569.469,
              -1193.5,
              10504.94
            ],
            [
              -3626.266,
              -1196.964,
              10561.843
            ],
            [
              -3684.51,
              -1178.609,
              10622.91
            ],
            [
              -3714.349,
              -1169.288,
              10654.171
            ],
            [
              -3768.714,
              -1158.717,
              10709.554
            ],
            [
              -3858.305,
              -1156.194,
              10799.181
            ],
            [
              -4063.615,
              -1172.672,
              11005.151
            ],
            [
              -4237.967,
              -1188.581,
              11180.227
            ],
            [
              -4268.356,
              -1193.623,
              11211.032
            ],
            [
              -4296.043,
              -1199.905,
              11239.423
            ],
            [
              -4333.704,
              -1206.966,
              11277.74
            ],
            [
              -4364.15,
              -1215.347,
              11309.318
            ],
            [
              -4597.068,
              -1300.392,
              11557.277
            ],
            [
              -4637.998,
              -1318.612,
              11602.079
            ],
            [
              -4714.189,
              -1362.945,
              11690.229
            ],
            [
              -4755.992,
              -1394.51,
              11742.611
            ],
            [
              -4809.036,
              -1442.581,
              11814.197
            ],
            [
              -4835.962,
              -1480.117,
              11860.391
            ],
            [
              -5091.057,
              -1790.801,
              12262.384
            ],
            [
              -5145.804,
              -1834.231,
              12332.265
            ],
            [
              -5350.813,
              -1948.734,
              12567.083
            ],
            [
              -5768.874,
              -2159.819,
              13035.412
            ],
            [
              -5759.931,
              -2298.028,
              13173.91
            ],
            [
              -5764.309,
              -2346.913,
              13222.991
            ],
            [
              -5745.608,
              -2354.913,
              13243.331
            ],
            [
              -5699.018,
              -2373.624,
              13293.538
            ],
            [
              -5698.581,
              -1978.091,
              13689.072
            ],
            [
              -5726.603,
              -1880.986,
              13790.138
            ],
            [
              -5827.254,
              -1945.668,
              13909.781
            ],
            [
              -5930.998,
              -1988.982,
              14022.204
            ],
            [
              -6228.224,
              -1992.872,
              14319.455
            ],
            [
              -6278.571,
              -1995.984,
              14369.898
            ],
            [
              -6312.713,
              -1995.515,
              14404.043
            ],
            [
              -6605.358,
              -1994.8,
              14696.689
            ],
            [
              -6631.353,
              -1995.05,
              14722.686
            ],
            [
              -6677.514,
              -1993.121,
              14768.887
            ],
            [
              -6680.925,
              -1734.803,
              15027.227
            ],
            [
              -6684.251,
              -1702.465,
              15059.736
            ],
            [
              -6705.09,
              -1676.513,
              15093.019
            ],
            [
              -6747.127,
              -1568.943,
              15208.511
            ],
            [
              -6771.666,
              -1532.911,
              15252.106
            ],
            [
              -6834.733,
              -1410.519,
              15389.791
            ],
            [
              -6861.847,
              -1368.999,
              15439.38
            ],
            [
              -6868.44,
              -1344.278,
              15464.965
            ],
            [
              -6865.755,
              -1340.811,
              15469.35
            ],
            [
              -6856.389,
              -1336.272,
              15479.758
            ],
            [
              -6847.396,
              -1333.735,
              15489.102
            ],
            [
              -6839.19,
              -1361.045,
              15517.618
            ],
            [
              -6825.084,
              -1411.793,
              15570.29
            ],
            [
              -6801.411,
              -1461.169,
              15625.048
            ],
            [
              -6771.957,
              -1511.755,
              15683.584
            ],
            [
              -6765.128,
              -1527.454,
              15700.704
            ],
            [
              -6769.807,
              -1537.394,
              15711.69
            ],
            [
              -6771.141,
              -1540.619,
              15715.18
            ],
            [
              -6827.09,
              -1597.371,
              15794.873
            ],
            [
              -6841.227,
              -1604.648,
              15810.774
            ],
            [
              -6863.189,
              -1570.343,
              15851.506
            ],
            [
              -6866.907,
              -1561.375,
              15861.214
            ],
            [
              -6864.843,
              -1553.618,
              15869.241
            ],
            [
              -6782.722,
              -1517.922,
              15958.785
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:6239",
              "position": {
                "x": 3898.552,
                "z": -4039.468
              },
              "distanceAlongShapeM": 95.752,
              "shapeOffsetM": 2.327,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:5116",
              "position": {
                "x": 3565.986,
                "z": -4043.151
              },
              "distanceAlongShapeM": 434.038,
              "shapeOffsetM": 4.885,
              "arrivalOffsetSeconds": 60,
              "departureOffsetSeconds": 60
            },
            {
              "stopId": "judu:stop:6715",
              "position": {
                "x": 3360.169,
                "z": -4124.962
              },
              "distanceAlongShapeM": 658.242,
              "shapeOffsetM": 2.574,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:5103",
              "position": {
                "x": 2937.404,
                "z": -4265.024
              },
              "distanceAlongShapeM": 1170.635,
              "shapeOffsetM": 3.836,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:5118",
              "position": {
                "x": 2463.001,
                "z": -3519.117
              },
              "distanceAlongShapeM": 2145.8,
              "shapeOffsetM": 4.589,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:5096",
              "position": {
                "x": 2296.913,
                "z": -2511.848
              },
              "distanceAlongShapeM": 3167.023,
              "shapeOffsetM": 3.272,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:5091",
              "position": {
                "x": 2031.037,
                "z": -1906.834
              },
              "distanceAlongShapeM": 3861.827,
              "shapeOffsetM": 6.897,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:5658",
              "position": {
                "x": 1653.419,
                "z": -1725.022
              },
              "distanceAlongShapeM": 4469.114,
              "shapeOffsetM": 3.857,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:5661",
              "position": {
                "x": 1418.417,
                "z": -1047.149
              },
              "distanceAlongShapeM": 5197.863,
              "shapeOffsetM": 4.331,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:677",
              "position": {
                "x": 364.219,
                "z": -693.772
              },
              "distanceAlongShapeM": 6394.567,
              "shapeOffsetM": 6.934,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:753",
              "position": {
                "x": -53.078,
                "z": -805.275
              },
              "distanceAlongShapeM": 6831.521,
              "shapeOffsetM": 6.187,
              "arrivalOffsetSeconds": 1380,
              "departureOffsetSeconds": 1380
            },
            {
              "stopId": "judu:stop:988",
              "position": {
                "x": -763.423,
                "z": -1114.127
              },
              "distanceAlongShapeM": 7607.362,
              "shapeOffsetM": 5.791,
              "arrivalOffsetSeconds": 1500,
              "departureOffsetSeconds": 1500
            },
            {
              "stopId": "judu:stop:6404",
              "position": {
                "x": -1096.995,
                "z": -1127.045
              },
              "distanceAlongShapeM": 7984.151,
              "shapeOffsetM": 4.91,
              "arrivalOffsetSeconds": 1620,
              "departureOffsetSeconds": 1620
            },
            {
              "stopId": "judu:stop:7415",
              "position": {
                "x": -3140.52,
                "z": -1255.542
              },
              "distanceAlongShapeM": 10070.039,
              "shapeOffsetM": 4.427,
              "arrivalOffsetSeconds": 1920,
              "departureOffsetSeconds": 1920
            },
            {
              "stopId": "judu:stop:4991",
              "position": {
                "x": -3688.025,
                "z": -1189.21
              },
              "distanceAlongShapeM": 10623.105,
              "shapeOffsetM": 11.167,
              "arrivalOffsetSeconds": 2040,
              "departureOffsetSeconds": 2040
            },
            {
              "stopId": "judu:stop:4988",
              "position": {
                "x": -4294.993,
                "z": -1205.408
              },
              "distanceAlongShapeM": 11239.423,
              "shapeOffsetM": 5.602,
              "arrivalOffsetSeconds": 2160,
              "departureOffsetSeconds": 2160
            },
            {
              "stopId": "judu:stop:8060",
              "position": {
                "x": -4834.84,
                "z": -1481.101
              },
              "distanceAlongShapeM": 11860.44,
              "shapeOffsetM": 1.492,
              "arrivalOffsetSeconds": 2280,
              "departureOffsetSeconds": 2280
            },
            {
              "stopId": "judu:stop:17769",
              "position": {
                "x": -5758.969,
                "z": -2298.023
              },
              "distanceAlongShapeM": 13173.91,
              "shapeOffsetM": 0.962,
              "arrivalOffsetSeconds": 2400,
              "departureOffsetSeconds": 2400
            },
            {
              "stopId": "judu:stop:6619",
              "position": {
                "x": -5825.26,
                "z": -1949.582
              },
              "distanceAlongShapeM": 13909.781,
              "shapeOffsetM": 4.393,
              "arrivalOffsetSeconds": 2520,
              "departureOffsetSeconds": 2520
            },
            {
              "stopId": "judu:stop:6614",
              "position": {
                "x": -6278.639,
                "z": -2000.929
              },
              "distanceAlongShapeM": 14369.898,
              "shapeOffsetM": 4.946,
              "arrivalOffsetSeconds": 2580,
              "departureOffsetSeconds": 2580
            },
            {
              "stopId": "judu:stop:6612",
              "position": {
                "x": -6631.209,
                "z": -1999.462
              },
              "distanceAlongShapeM": 14722.584,
              "shapeOffsetM": 4.413,
              "arrivalOffsetSeconds": 2640,
              "departureOffsetSeconds": 2640
            },
            {
              "stopId": "judu:stop:7695",
              "position": {
                "x": -6705.09,
                "z": -1676.513
              },
              "distanceAlongShapeM": 15093.019,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2700,
              "departureOffsetSeconds": 2700
            },
            {
              "stopId": "judu:stop:7693",
              "position": {
                "x": -6863.711,
                "z": -1369.96
              },
              "distanceAlongShapeM": 15439.38,
              "shapeOffsetM": 2.097,
              "arrivalOffsetSeconds": 2760,
              "departureOffsetSeconds": 2760
            }
          ],
          "departuresSeconds": [
            19080,
            19680,
            20340,
            21000,
            21660,
            22260,
            22860,
            23460,
            23940,
            24420,
            24900,
            25380,
            25860,
            26280,
            26700,
            27180,
            27660,
            28080,
            28500,
            28920,
            29340,
            29820,
            30240,
            30720,
            31200,
            31680,
            32160,
            32640,
            33120,
            33600,
            34020,
            34440,
            34920,
            35400,
            35880,
            36300,
            36780,
            37260,
            37680,
            38160,
            38700,
            39240,
            39780,
            40320,
            40860,
            41400,
            41940,
            42540,
            43140,
            43800,
            44520,
            45180,
            45780,
            46440,
            47160,
            47940,
            48720,
            49500,
            50220,
            51000,
            51780,
            52500,
            53160,
            53820,
            54480,
            55080,
            55680,
            56160,
            56640,
            57060,
            57480,
            57840,
            58260,
            58680,
            59040,
            59460,
            59880,
            60360,
            60780,
            61200,
            61620,
            62100,
            62580,
            63000,
            63420,
            63780,
            64200,
            64560,
            64920,
            65280,
            65640,
            66000,
            66420,
            66900,
            67320,
            67740,
            68220,
            68700,
            69120,
            69540,
            69960,
            70560,
            71160,
            71820,
            72660,
            73620,
            74640,
            75660,
            76560,
            77460,
            78180,
            78900,
            79680,
            80400,
            81060,
            81660,
            82320,
            82920,
            83460,
            84060,
            84720,
            85320,
            86040
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_bus_5",
      "sourceRouteId": "vilnius_bus_5",
      "mode": "bus",
      "shortName": "5",
      "longName": "Fabijoniškės–Žalgirio g.–Tuskulėnų g.–Šiaurės miestelis",
      "color": "0073AC",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_bus_5:0",
          "sourceRouteId": "vilnius_bus_5",
          "sourceShapeId": "vilnius_bus_5_a-b",
          "directionId": 0,
          "headsign": "Šiaurės miestelis",
          "directionName": "Fabijoniškės–Žalgirio g.–Tuskulėnų g.–Šiaurės miestelis",
          "mode": "bus",
          "routeShortName": "5",
          "routeLongName": "Fabijoniškės–Žalgirio g.–Tuskulėnų g.–Šiaurės miestelis",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              -2480.761,
              -5727.829,
              0
            ],
            [
              -2465.38,
              -5705.215,
              27.349
            ],
            [
              -2457.131,
              -5687.973,
              46.463
            ],
            [
              -2458.05,
              -5680.376,
              54.116
            ],
            [
              -2467.523,
              -5671.289,
              67.242
            ],
            [
              -2484.515,
              -5648.724,
              95.489
            ],
            [
              -2453.276,
              -5597.994,
              155.066
            ],
            [
              -2437.971,
              -5575.488,
              182.284
            ],
            [
              -2323.024,
              -5404.447,
              388.361
            ],
            [
              -2243.482,
              -5280.09,
              535.981
            ],
            [
              -2221.212,
              -5257.08,
              568.002
            ],
            [
              -2172.788,
              -5214.524,
              632.469
            ],
            [
              -2110.315,
              -5178.897,
              704.386
            ],
            [
              -2136.613,
              -5136.438,
              754.33
            ],
            [
              -2215.749,
              -4985.55,
              924.711
            ],
            [
              -2261.515,
              -4895.899,
              1025.368
            ],
            [
              -2303.85,
              -4831.475,
              1102.457
            ],
            [
              -2250.757,
              -4780.095,
              1176.34
            ],
            [
              -2246.649,
              -4770.794,
              1186.508
            ],
            [
              -2217.023,
              -4730.598,
              1236.442
            ],
            [
              -2199.094,
              -4664.123,
              1305.293
            ],
            [
              -2245.097,
              -4651.92,
              1352.887
            ],
            [
              -2248.369,
              -4645.437,
              1360.148
            ],
            [
              -2421.69,
              -4610.083,
              1537.038
            ],
            [
              -2609.045,
              -4566.695,
              1729.352
            ],
            [
              -2745.017,
              -4497.235,
              1882.038
            ],
            [
              -2770.825,
              -4531.174,
              1924.675
            ],
            [
              -2804.177,
              -4598.877,
              2000.147
            ],
            [
              -2799.786,
              -4605.634,
              2008.206
            ],
            [
              -2740.129,
              -4632.849,
              2073.777
            ],
            [
              -2740.424,
              -4632.704,
              2074.106
            ],
            [
              -2716.354,
              -4644.453,
              2100.891
            ],
            [
              -2663.277,
              -4659.378,
              2156.026
            ],
            [
              -2599.885,
              -4512.041,
              2316.422
            ],
            [
              -2575.776,
              -4470.432,
              2364.511
            ],
            [
              -2511.16,
              -4330.887,
              2518.29
            ],
            [
              -2380.854,
              -3977.381,
              2895.048
            ],
            [
              -2366.341,
              -3921.977,
              2952.321
            ],
            [
              -2313.476,
              -3774.854,
              3108.653
            ],
            [
              -2292.987,
              -3709.537,
              3177.109
            ],
            [
              -2280.97,
              -3679.424,
              3209.531
            ],
            [
              -2072.945,
              -3075.564,
              3848.218
            ],
            [
              -2040.52,
              -2976.08,
              3952.852
            ],
            [
              -2024.769,
              -2939.494,
              3992.685
            ],
            [
              -2004.312,
              -2876.403,
              4059.01
            ],
            [
              -1942.85,
              -2718.306,
              4228.634
            ],
            [
              -1911.924,
              -2646.496,
              4306.82
            ],
            [
              -1897.194,
              -2615.588,
              4341.059
            ],
            [
              -1889.264,
              -2604.597,
              4354.612
            ],
            [
              -1854.797,
              -2587.399,
              4393.131
            ],
            [
              -1805.935,
              -2485.853,
              4505.821
            ],
            [
              -1803.13,
              -2436.921,
              4554.834
            ],
            [
              -1757.32,
              -2362.039,
              4642.617
            ],
            [
              -1745.639,
              -2333.352,
              4673.591
            ],
            [
              -1727.311,
              -2305.799,
              4706.683
            ],
            [
              -1547.472,
              -2017.345,
              5046.606
            ],
            [
              -1343.434,
              -1674.784,
              5445.328
            ],
            [
              -1305.861,
              -1628.702,
              5504.787
            ],
            [
              -1268.647,
              -1602.651,
              5550.213
            ],
            [
              -1054.592,
              -1494.059,
              5790.237
            ],
            [
              -1027.103,
              -1471.176,
              5826.004
            ],
            [
              -1009.966,
              -1450.333,
              5852.988
            ],
            [
              -998.422,
              -1410.718,
              5894.25
            ],
            [
              -987.78,
              -1363.9,
              5942.263
            ],
            [
              -988.723,
              -1201.352,
              6104.813
            ],
            [
              -990.397,
              -1186.85,
              6119.412
            ],
            [
              -1017.615,
              -1122.906,
              6188.907
            ],
            [
              -1020.518,
              -1105.042,
              6207.006
            ],
            [
              -1018.304,
              -1089.497,
              6222.708
            ],
            [
              -1013.532,
              -1075.111,
              6237.864
            ],
            [
              -1005.537,
              -1060.783,
              6254.272
            ],
            [
              -969.041,
              -1039.175,
              6296.685
            ],
            [
              -947.066,
              -1036.231,
              6318.856
            ],
            [
              -930.307,
              -1036.533,
              6335.618
            ],
            [
              -906.579,
              -1043.639,
              6360.387
            ],
            [
              -895.802,
              -1053.852,
              6375.235
            ],
            [
              -890.221,
              -1066.198,
              6388.784
            ],
            [
              -867.459,
              -1091.1,
              6422.521
            ],
            [
              -847.054,
              -1103.713,
              6446.51
            ],
            [
              -821.251,
              -1103.065,
              6472.321
            ],
            [
              -688.757,
              -1085.417,
              6605.985
            ],
            [
              -659.265,
              -1201.726,
              6725.975
            ],
            [
              -651.167,
              -1217.458,
              6743.669
            ],
            [
              -631.025,
              -1244.539,
              6777.419
            ],
            [
              -620.269,
              -1255.866,
              6793.039
            ],
            [
              -612.377,
              -1263.559,
              6804.061
            ],
            [
              -593.158,
              -1289.753,
              6836.549
            ],
            [
              -557.225,
              -1334.932,
              6894.275
            ],
            [
              -548.544,
              -1354.014,
              6915.239
            ],
            [
              -546.208,
              -1367.415,
              6928.842
            ],
            [
              -541.958,
              -1488.834,
              7050.336
            ],
            [
              -536.137,
              -1559.073,
              7120.815
            ],
            [
              -520.589,
              -1697.395,
              7260.008
            ],
            [
              -504.478,
              -1804.557,
              7368.375
            ],
            [
              -451.512,
              -1798.837,
              7421.649
            ],
            [
              -397.434,
              -1792.064,
              7476.149
            ],
            [
              -386.905,
              -1791.102,
              7486.722
            ],
            [
              -162.795,
              -1768.453,
              7711.974
            ],
            [
              -103.598,
              -1755.97,
              7772.472
            ],
            [
              91.167,
              -1735.227,
              7968.339
            ],
            [
              238.547,
              -1717.597,
              8116.77
            ],
            [
              252.628,
              -1719.249,
              8130.947
            ],
            [
              342.249,
              -1718.661,
              8220.57
            ],
            [
              510.658,
              -1710.612,
              8389.171
            ],
            [
              550.922,
              -1706.707,
              8429.625
            ],
            [
              586.765,
              -1697.182,
              8466.711
            ],
            [
              616.278,
              -1681.379,
              8500.189
            ],
            [
              646.312,
              -1660.778,
              8536.609
            ],
            [
              676.214,
              -1635.564,
              8575.723
            ],
            [
              696.914,
              -1614.56,
              8605.213
            ],
            [
              891.199,
              -1385.857,
              8905.299
            ],
            [
              926.904,
              -1337.532,
              8965.384
            ],
            [
              938.594,
              -1321.715,
              8985.052
            ],
            [
              959.848,
              -1299.175,
              9016.032
            ],
            [
              1019.189,
              -1227.908,
              9108.77
            ],
            [
              1188.158,
              -1016.171,
              9379.663
            ],
            [
              1211.885,
              -984.023,
              9419.619
            ],
            [
              1229.979,
              -967.272,
              9444.277
            ],
            [
              1246.923,
              -941.557,
              9475.072
            ],
            [
              1250.475,
              -923.811,
              9493.17
            ],
            [
              1249.57,
              -868.132,
              9548.856
            ],
            [
              1251.975,
              -858.297,
              9558.981
            ],
            [
              1256.345,
              -850.445,
              9567.967
            ],
            [
              1271.438,
              -836.252,
              9588.685
            ],
            [
              1287.032,
              -829.861,
              9605.538
            ],
            [
              1325.104,
              -828.339,
              9643.641
            ],
            [
              1339.141,
              -836.391,
              9659.823
            ],
            [
              1354.364,
              -850.032,
              9680.264
            ],
            [
              1360.583,
              -862.393,
              9694.101
            ],
            [
              1367.85,
              -922.642,
              9754.786
            ],
            [
              1384.491,
              -964.14,
              9799.497
            ],
            [
              1464.439,
              -1103.664,
              9960.303
            ],
            [
              1477.634,
              -1123.116,
              9983.808
            ],
            [
              1488.813,
              -1145.306,
              10008.655
            ],
            [
              1537.374,
              -1238.606,
              10113.836
            ],
            [
              1587.871,
              -1366.453,
              10251.294
            ],
            [
              1626.598,
              -1502.988,
              10393.215
            ],
            [
              1647.564,
              -1589.097,
              10481.84
            ],
            [
              1670.179,
              -1759.844,
              10654.078
            ],
            [
              1672.682,
              -1787.97,
              10682.315
            ],
            [
              1672.408,
              -1813.321,
              10707.668
            ],
            [
              1676.981,
              -1962.613,
              10857.029
            ],
            [
              1675.815,
              -2011.543,
              10905.974
            ],
            [
              1684.596,
              -2579.462,
              11473.961
            ],
            [
              1622.02,
              -2584.755,
              11536.76
            ],
            [
              1614.3,
              -2581.496,
              11545.14
            ],
            [
              1426.817,
              -2576.903,
              11732.679
            ],
            [
              1419.812,
              -2572.32,
              11741.05
            ],
            [
              1406.874,
              -2540.387,
              11775.505
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:1158",
              "position": {
                "x": -2456.526,
                "z": -5595.784
              },
              "distanceAlongShapeM": 155.066,
              "shapeOffsetM": 3.93,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:6914",
              "position": {
                "x": -2139.87,
                "z": -5138.296
              },
              "distanceAlongShapeM": 754.33,
              "shapeOffsetM": 3.749,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:5803",
              "position": {
                "x": -2249.272,
                "z": -4768.989
              },
              "distanceAlongShapeM": 1186.508,
              "shapeOffsetM": 3.184,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:8269",
              "position": {
                "x": -2245.99,
                "z": -4656.611
              },
              "distanceAlongShapeM": 1352.547,
              "shapeOffsetM": 4.764,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:364",
              "position": {
                "x": -2737.686,
                "z": -4627.879
              },
              "distanceAlongShapeM": 2074.45,
              "shapeOffsetM": 5.537,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:7896",
              "position": {
                "x": -2601.622,
                "z": -4511.165
              },
              "distanceAlongShapeM": 2316.422,
              "shapeOffsetM": 1.945,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:5450",
              "position": {
                "x": -2366.341,
                "z": -3921.977
              },
              "distanceAlongShapeM": 2952.321,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:5451",
              "position": {
                "x": -2289.819,
                "z": -3676.197
              },
              "distanceAlongShapeM": 3209.248,
              "shapeOffsetM": 9.414,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:5452",
              "position": {
                "x": -2044.086,
                "z": -2974.773
              },
              "distanceAlongShapeM": 3952.852,
              "shapeOffsetM": 3.798,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:5214",
              "position": {
                "x": -1747.763,
                "z": -2332.152
              },
              "distanceAlongShapeM": 4673.591,
              "shapeOffsetM": 2.44,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:5220",
              "position": {
                "x": -1001.511,
                "z": -1410.409
              },
              "distanceAlongShapeM": 5893.683,
              "shapeOffsetM": 3.052,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:7769",
              "position": {
                "x": -610.057,
                "z": -1261.617
              },
              "distanceAlongShapeM": 6804.061,
              "shapeOffsetM": 3.025,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            },
            {
              "stopId": "judu:stop:5462",
              "position": {
                "x": -397.821,
                "z": -1788.678
              },
              "distanceAlongShapeM": 7476.149,
              "shapeOffsetM": 3.408,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            },
            {
              "stopId": "judu:stop:17318",
              "position": {
                "x": -103.866,
                "z": -1753.939
              },
              "distanceAlongShapeM": 7772.472,
              "shapeOffsetM": 2.048,
              "arrivalOffsetSeconds": 1500,
              "departureOffsetSeconds": 1500
            },
            {
              "stopId": "judu:stop:7691",
              "position": {
                "x": 238.49,
                "z": -1716.765
              },
              "distanceAlongShapeM": 8116.77,
              "shapeOffsetM": 0.834,
              "arrivalOffsetSeconds": 1560,
              "departureOffsetSeconds": 1560
            },
            {
              "stopId": "judu:stop:6542",
              "position": {
                "x": 673.267,
                "z": -1632.329
              },
              "distanceAlongShapeM": 8575.958,
              "shapeOffsetM": 4.37,
              "arrivalOffsetSeconds": 1680,
              "departureOffsetSeconds": 1680
            },
            {
              "stopId": "judu:stop:6544",
              "position": {
                "x": 934.987,
                "z": -1318.756
              },
              "distanceAlongShapeM": 8985.052,
              "shapeOffsetM": 4.665,
              "arrivalOffsetSeconds": 1800,
              "departureOffsetSeconds": 1800
            },
            {
              "stopId": "judu:stop:6546",
              "position": {
                "x": 1209.421,
                "z": -982.054
              },
              "distanceAlongShapeM": 9419.619,
              "shapeOffsetM": 3.154,
              "arrivalOffsetSeconds": 1860,
              "departureOffsetSeconds": 1860
            },
            {
              "stopId": "judu:stop:6665",
              "position": {
                "x": 1480.223,
                "z": -1121.768
              },
              "distanceAlongShapeM": 9983.808,
              "shapeOffsetM": 2.918,
              "arrivalOffsetSeconds": 1980,
              "departureOffsetSeconds": 1980
            },
            {
              "stopId": "judu:stop:6666",
              "position": {
                "x": 1676.751,
                "z": -1787.797
              },
              "distanceAlongShapeM": 10682.315,
              "shapeOffsetM": 4.073,
              "arrivalOffsetSeconds": 2100,
              "departureOffsetSeconds": 2100
            },
            {
              "stopId": "judu:stop:5013",
              "position": {
                "x": 1621.888,
                "z": -2589.429
              },
              "distanceAlongShapeM": 11536.76,
              "shapeOffsetM": 4.676,
              "arrivalOffsetSeconds": 2340,
              "departureOffsetSeconds": 2340
            },
            {
              "stopId": "judu:stop:15167",
              "position": {
                "x": 1413.343,
                "z": -2538.803
              },
              "distanceAlongShapeM": 11774.544,
              "shapeOffsetM": 6.59,
              "arrivalOffsetSeconds": 2400,
              "departureOffsetSeconds": 2400
            }
          ],
          "departuresSeconds": [
            19140,
            21420,
            23580,
            24840,
            26100,
            27300,
            28500,
            29700,
            30900,
            32400,
            34380,
            35880,
            37440,
            39000,
            42000,
            43740,
            45480,
            47220,
            49380,
            51180,
            53040,
            55200,
            56520,
            57480,
            58440,
            59760,
            61080,
            62400,
            63780,
            65280,
            66960,
            68640,
            69960,
            74580,
            75720,
            76920,
            79380,
            80820,
            82320,
            84000,
            85380
          ]
        },
        {
          "id": "judu:pattern:vilnius_bus_5:1",
          "sourceRouteId": "vilnius_bus_5",
          "sourceShapeId": "vilnius_bus_5_b-a",
          "directionId": 1,
          "headsign": "Fabijoniškės",
          "directionName": "Šiaurės miestelis–Tuskulėnų g.–Žalgirio g.–Fabijoniškės",
          "mode": "bus",
          "routeShortName": "5",
          "routeLongName": "Fabijoniškės–Žalgirio g.–Tuskulėnų g.–Šiaurės miestelis",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              1407.302,
              -2542.364,
              0
            ],
            [
              1404.085,
              -2529.725,
              13.042
            ],
            [
              1492.99,
              -2519.128,
              102.577
            ],
            [
              1552.992,
              -2512.565,
              162.937
            ],
            [
              1553.1,
              -2518.989,
              169.362
            ],
            [
              1555.103,
              -2528.173,
              178.763
            ],
            [
              1555.716,
              -2564.875,
              215.47
            ],
            [
              1565.454,
              -2573.909,
              228.753
            ],
            [
              1658.884,
              -2575.644,
              322.199
            ],
            [
              1668.545,
              -2575.213,
              331.87
            ],
            [
              1679.839,
              -2564.679,
              347.315
            ],
            [
              1679.479,
              -2552.424,
              359.575
            ],
            [
              1678.725,
              -2527.718,
              384.292
            ],
            [
              1679.06,
              -2495.866,
              416.146
            ],
            [
              1670.601,
              -2049.296,
              862.796
            ],
            [
              1665.105,
              -1963.474,
              948.794
            ],
            [
              1664.613,
              -1816.516,
              1095.753
            ],
            [
              1663.09,
              -1759.712,
              1152.577
            ],
            [
              1657.26,
              -1724.669,
              1188.102
            ],
            [
              1660.464,
              -1692.869,
              1220.063
            ],
            [
              1642.718,
              -1572.308,
              1341.923
            ],
            [
              1626.598,
              -1502.988,
              1413.092
            ],
            [
              1590.763,
              -1384.318,
              1537.055
            ],
            [
              1541.473,
              -1260.946,
              1669.909
            ],
            [
              1439.941,
              -1068.699,
              1887.32
            ],
            [
              1422.22,
              -1045.077,
              1916.85
            ],
            [
              1413.029,
              -1024.784,
              1939.128
            ],
            [
              1382.574,
              -969.885,
              2001.909
            ],
            [
              1372.327,
              -959.462,
              2016.525
            ],
            [
              1333.941,
              -943.166,
              2058.226
            ],
            [
              1285.577,
              -943.385,
              2106.591
            ],
            [
              1262.269,
              -948.52,
              2130.458
            ],
            [
              1247.842,
              -961.612,
              2149.94
            ],
            [
              1192.361,
              -1032.948,
              2240.311
            ],
            [
              1178.442,
              -1052.156,
              2264.032
            ],
            [
              1157.377,
              -1076.831,
              2296.476
            ],
            [
              1022.871,
              -1237.996,
              2506.395
            ],
            [
              942.352,
              -1338.93,
              2635.511
            ],
            [
              920.55,
              -1367.472,
              2671.427
            ],
            [
              902.533,
              -1392.857,
              2702.556
            ],
            [
              882.932,
              -1414.649,
              2731.866
            ],
            [
              768.148,
              -1556.146,
              2914.066
            ],
            [
              700.938,
              -1635.064,
              3017.725
            ],
            [
              639.183,
              -1686.107,
              3097.844
            ],
            [
              593.366,
              -1704.078,
              3147.06
            ],
            [
              576.207,
              -1710.199,
              3165.278
            ],
            [
              475.715,
              -1717.765,
              3266.054
            ],
            [
              322.189,
              -1722.747,
              3419.661
            ],
            [
              290.154,
              -1723.98,
              3451.72
            ],
            [
              249.082,
              -1725.746,
              3492.829
            ],
            [
              91.167,
              -1735.227,
              3651.029
            ],
            [
              -460.696,
              -1807.576,
              4207.614
            ],
            [
              -504.679,
              -1815.686,
              4252.339
            ],
            [
              -529.853,
              -1817.457,
              4277.575
            ],
            [
              -565.742,
              -1833.742,
              4316.986
            ],
            [
              -590.636,
              -1808.652,
              4352.33
            ],
            [
              -669.059,
              -1793.975,
              4432.115
            ],
            [
              -739.986,
              -1780.261,
              4504.356
            ],
            [
              -775.874,
              -1768.481,
              4542.127
            ],
            [
              -800.123,
              -1754.685,
              4570.026
            ],
            [
              -815.269,
              -1736.6,
              4593.616
            ],
            [
              -917.833,
              -1561.088,
              4796.898
            ],
            [
              -998.805,
              -1475.025,
              4915.065
            ],
            [
              -1007.808,
              -1473.75,
              4924.158
            ],
            [
              -1034.951,
              -1499.706,
              4961.714
            ],
            [
              -1061.478,
              -1518.427,
              4994.182
            ],
            [
              -1072.846,
              -1524.64,
              5007.137
            ],
            [
              -1114.823,
              -1540.49,
              5052.007
            ],
            [
              -1223.074,
              -1577.865,
              5166.528
            ],
            [
              -1268.647,
              -1602.651,
              5218.405
            ],
            [
              -1297.383,
              -1623.287,
              5253.783
            ],
            [
              -1333.607,
              -1666.054,
              5309.829
            ],
            [
              -1382.029,
              -1741.999,
              5399.898
            ],
            [
              -1597.414,
              -2106.624,
              5823.386
            ],
            [
              -1645.063,
              -2175.906,
              5907.472
            ],
            [
              -1682.619,
              -2257.615,
              5997.398
            ],
            [
              -1702.963,
              -2314.026,
              6057.366
            ],
            [
              -1715.793,
              -2345.231,
              6091.106
            ],
            [
              -1755.799,
              -2415.464,
              6171.933
            ],
            [
              -1791.442,
              -2468.3,
              6235.668
            ],
            [
              -1838.817,
              -2558.74,
              6337.765
            ],
            [
              -1870.823,
              -2630.339,
              6416.191
            ],
            [
              -1876.019,
              -2641.711,
              6428.694
            ],
            [
              -1912.507,
              -2715.506,
              6511.017
            ],
            [
              -1995.657,
              -2933.332,
              6744.174
            ],
            [
              -2020.861,
              -3009.696,
              6824.59
            ],
            [
              -2029.851,
              -3041.625,
              6857.761
            ],
            [
              -2244.442,
              -3639.648,
              7493.119
            ],
            [
              -2268.114,
              -3687.714,
              7546.698
            ],
            [
              -2346.702,
              -3915.499,
              7787.659
            ],
            [
              -2363.609,
              -3964.478,
              7839.474
            ],
            [
              -2466.817,
              -4247.487,
              8140.715
            ],
            [
              -2539.058,
              -4427.617,
              8334.791
            ],
            [
              -2559.838,
              -4475.922,
              8387.376
            ],
            [
              -2571.739,
              -4497.221,
              8411.774
            ],
            [
              -2635.224,
              -4626.347,
              8555.663
            ],
            [
              -2636.28,
              -4649.706,
              8579.046
            ],
            [
              -2631.949,
              -4659.802,
              8590.031
            ],
            [
              -2592.254,
              -4673.861,
              8632.142
            ],
            [
              -2567.235,
              -4679.869,
              8657.873
            ],
            [
              -2547.659,
              -4684.927,
              8678.091
            ],
            [
              -2514.956,
              -4692.987,
              8711.773
            ],
            [
              -2465.325,
              -4709.501,
              8764.079
            ],
            [
              -2409.103,
              -4736.1,
              8826.276
            ],
            [
              -2349.957,
              -4779.45,
              8899.607
            ],
            [
              -2306.893,
              -4821.402,
              8959.728
            ],
            [
              -2285.316,
              -4847.778,
              8993.806
            ],
            [
              -2241.672,
              -4921.636,
              9079.594
            ],
            [
              -2239.148,
              -4925.337,
              9084.074
            ],
            [
              -2217.405,
              -4969.935,
              9133.69
            ],
            [
              -2110.315,
              -5178.897,
              9368.495
            ],
            [
              -2127.276,
              -5190.841,
              9389.24
            ],
            [
              -2145.02,
              -5203.693,
              9411.149
            ],
            [
              -2175.503,
              -5222.268,
              9446.846
            ],
            [
              -2204.955,
              -5248.463,
              9486.261
            ],
            [
              -2230.543,
              -5274.726,
              9522.929
            ],
            [
              -2512.326,
              -5691.648,
              10026.144
            ],
            [
              -2515.223,
              -5708.154,
              10042.902
            ],
            [
              -2529.5,
              -5729.639,
              10068.698
            ],
            [
              -2529.407,
              -5747.007,
              10086.066
            ],
            [
              -2525.623,
              -5751.527,
              10091.961
            ],
            [
              -2510.288,
              -5758.477,
              10108.798
            ],
            [
              -2499.033,
              -5756.062,
              10120.309
            ],
            [
              -2480.761,
              -5727.829,
              10153.939
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:7589",
              "position": {
                "x": 1524.687,
                "z": -2513.037
              },
              "distanceAlongShapeM": 134.748,
              "shapeOffsetM": 2.608,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:5088",
              "position": {
                "x": 1670.083,
                "z": -2527.983
              },
              "distanceAlongShapeM": 384.291,
              "shapeOffsetM": 8.646,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:5658",
              "position": {
                "x": 1653.419,
                "z": -1725.022
              },
              "distanceAlongShapeM": 1188.102,
              "shapeOffsetM": 3.857,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:5661",
              "position": {
                "x": 1418.417,
                "z": -1047.149
              },
              "distanceAlongShapeM": 1916.85,
              "shapeOffsetM": 4.331,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:6547",
              "position": {
                "x": 1184.819,
                "z": -1057.3
              },
              "distanceAlongShapeM": 2264.032,
              "shapeOffsetM": 8.193,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:1032",
              "position": {
                "x": 905.214,
                "z": -1395.021
              },
              "distanceAlongShapeM": 2702.556,
              "shapeOffsetM": 3.445,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:18847",
              "position": {
                "x": 578.225,
                "z": -1717.417
              },
              "distanceAlongShapeM": 3165.278,
              "shapeOffsetM": 7.495,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:5498",
              "position": {
                "x": 290.448,
                "z": -1731.073
              },
              "distanceAlongShapeM": 3451.699,
              "shapeOffsetM": 7.099,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:5499",
              "position": {
                "x": -564.13,
                "z": -1823.516
              },
              "distanceAlongShapeM": 4323.11,
              "shapeOffsetM": 8.347,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:5289",
              "position": {
                "x": -1070.7,
                "z": -1529.393
              },
              "distanceAlongShapeM": 5007.137,
              "shapeOffsetM": 5.215,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:5290",
              "position": {
                "x": -1711.936,
                "z": -2347.263
              },
              "distanceAlongShapeM": 6091.106,
              "shapeOffsetM": 4.36,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:1039",
              "position": {
                "x": -1871.271,
                "z": -2643.88
              },
              "distanceAlongShapeM": 6428.694,
              "shapeOffsetM": 5.22,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            },
            {
              "stopId": "judu:stop:986",
              "position": {
                "x": -2025.964,
                "z": -3043.002
              },
              "distanceAlongShapeM": 6857.761,
              "shapeOffsetM": 4.124,
              "arrivalOffsetSeconds": 1380,
              "departureOffsetSeconds": 1380
            },
            {
              "stopId": "judu:stop:4388",
              "position": {
                "x": -2242.142,
                "z": -3640.305
              },
              "distanceAlongShapeM": 7492.961,
              "shapeOffsetM": 2.386,
              "arrivalOffsetSeconds": 1500,
              "departureOffsetSeconds": 1500
            },
            {
              "stopId": "judu:stop:823",
              "position": {
                "x": -2360.668,
                "z": -3965.493
              },
              "distanceAlongShapeM": 7839.474,
              "shapeOffsetM": 3.112,
              "arrivalOffsetSeconds": 1560,
              "departureOffsetSeconds": 1560
            },
            {
              "stopId": "judu:stop:7897",
              "position": {
                "x": -2556.572,
                "z": -4477.451
              },
              "distanceAlongShapeM": 8387.376,
              "shapeOffsetM": 3.606,
              "arrivalOffsetSeconds": 1620,
              "departureOffsetSeconds": 1620
            },
            {
              "stopId": "judu:stop:6911",
              "position": {
                "x": -2236.559,
                "z": -4923.953
              },
              "distanceAlongShapeM": 9084.074,
              "shapeOffsetM": 2.936,
              "arrivalOffsetSeconds": 1800,
              "departureOffsetSeconds": 1800
            },
            {
              "stopId": "judu:stop:6915",
              "position": {
                "x": -2143.028,
                "z": -5207.26
              },
              "distanceAlongShapeM": 9411.304,
              "shapeOffsetM": 4.083,
              "arrivalOffsetSeconds": 1860,
              "departureOffsetSeconds": 1860
            },
            {
              "stopId": "judu:stop:5512",
              "position": {
                "x": -2513.285,
                "z": -5709.442
              },
              "distanceAlongShapeM": 10042.902,
              "shapeOffsetM": 2.327,
              "arrivalOffsetSeconds": 1980,
              "departureOffsetSeconds": 1980
            }
          ],
          "departuresSeconds": [
            19320,
            21480,
            22380,
            23640,
            24600,
            25560,
            26460,
            27840,
            29220,
            30600,
            31860,
            33660,
            34920,
            36480,
            38400,
            39600,
            41160,
            42720,
            44760,
            46620,
            48480,
            50340,
            52380,
            53820,
            56160,
            58500,
            59640,
            60780,
            61920,
            63180,
            64500,
            66120,
            67740,
            69240,
            72180,
            73200,
            74280,
            77160,
            78420,
            79800,
            81900,
            83280,
            84780
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_expressbus_5G",
      "sourceRouteId": "vilnius_expressbus_5G",
      "mode": "bus",
      "shortName": "5G",
      "longName": "Perkūnkiemis–Ozo g.–Saulėtekis",
      "color": "008000",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_expressbus_5G:0",
          "sourceRouteId": "vilnius_expressbus_5G",
          "sourceShapeId": "vilnius_expressbus_5G_a-b",
          "directionId": 0,
          "headsign": "Saulėtekis",
          "directionName": "Perkūnkiemis–Ozo g.–Saulėtekis",
          "mode": "bus",
          "routeShortName": "5G",
          "routeLongName": "Perkūnkiemis–Ozo g.–Saulėtekis",
          "routeColor": "008000",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              -3846.109,
              -5119.902,
              0
            ],
            [
              -3862.028,
              -5154.789,
              38.347
            ],
            [
              -3896.745,
              -5150.846,
              73.287
            ],
            [
              -3904.981,
              -5142.911,
              84.724
            ],
            [
              -3906.076,
              -5131.759,
              95.93
            ],
            [
              -3903.757,
              -5109.535,
              118.274
            ],
            [
              -3869.632,
              -5096.489,
              154.808
            ],
            [
              -3868.639,
              -5091.898,
              159.505
            ],
            [
              -3866.173,
              -5086.493,
              165.446
            ],
            [
              -3845.592,
              -5061.565,
              197.772
            ],
            [
              -3842.178,
              -5050.492,
              209.359
            ],
            [
              -3838.726,
              -5037.193,
              223.099
            ],
            [
              -3828.914,
              -4880.4,
              380.199
            ],
            [
              -3839.647,
              -4756.647,
              504.416
            ],
            [
              -3856.989,
              -4679.534,
              583.455
            ],
            [
              -3893.073,
              -4568.698,
              700.017
            ],
            [
              -3919.183,
              -4476.961,
              795.398
            ],
            [
              -3925.083,
              -4445.689,
              827.221
            ],
            [
              -3932.868,
              -4417.028,
              856.921
            ],
            [
              -3934.344,
              -4385.414,
              888.569
            ],
            [
              -3933.945,
              -4325.308,
              948.677
            ],
            [
              -3923.556,
              -4246.45,
              1028.216
            ],
            [
              -3859.131,
              -4078.116,
              1208.457
            ],
            [
              -3844.834,
              -4049.433,
              1240.505
            ],
            [
              -3724.705,
              -3815.753,
              1503.256
            ],
            [
              -3680.975,
              -3716.371,
              1611.834
            ],
            [
              -3652.775,
              -3644.457,
              1689.079
            ],
            [
              -3636.19,
              -3580.18,
              1755.461
            ],
            [
              -3630.111,
              -3520.538,
              1815.412
            ],
            [
              -3624.82,
              -3482.415,
              1853.9
            ],
            [
              -3626.214,
              -3414.484,
              1921.846
            ],
            [
              -3629.537,
              -3383.256,
              1953.25
            ],
            [
              -3641.883,
              -3315.135,
              2022.481
            ],
            [
              -3659.519,
              -3254.715,
              2085.422
            ],
            [
              -3681.569,
              -3188.651,
              2155.069
            ],
            [
              -3706.235,
              -3124.768,
              2223.548
            ],
            [
              -3706.685,
              -3113.628,
              2234.697
            ],
            [
              -3698.222,
              -3105.983,
              2246.102
            ],
            [
              -3686.788,
              -3103.033,
              2257.91
            ],
            [
              -3663.87,
              -3096.551,
              2281.727
            ],
            [
              -3644.524,
              -3091.72,
              2301.667
            ],
            [
              -3580.998,
              -3080.855,
              2366.116
            ],
            [
              -3537.19,
              -3076.506,
              2410.139
            ],
            [
              -3288.387,
              -3074.173,
              2658.953
            ],
            [
              -3226.908,
              -3059.664,
              2722.121
            ],
            [
              -3088.313,
              -3020.904,
              2866.034
            ],
            [
              -3076.179,
              -3017.184,
              2878.725
            ],
            [
              -3065.414,
              -3014.303,
              2889.869
            ],
            [
              -3011.076,
              -2998.586,
              2946.434
            ],
            [
              -2972.094,
              -2983.696,
              2988.163
            ],
            [
              -2923.591,
              -2962.569,
              3041.068
            ],
            [
              -2796.251,
              -2867.959,
              3199.708
            ],
            [
              -2713.249,
              -2802.628,
              3305.336
            ],
            [
              -2678.551,
              -2772.069,
              3351.573
            ],
            [
              -2644.38,
              -2734.822,
              3402.12
            ],
            [
              -2633.43,
              -2718.353,
              3421.896
            ],
            [
              -2600.033,
              -2668.811,
              3481.644
            ],
            [
              -2574.02,
              -2619.176,
              3537.683
            ],
            [
              -2545.641,
              -2545.091,
              3617.017
            ],
            [
              -2520.523,
              -2473.175,
              3693.194
            ],
            [
              -2499.973,
              -2404.518,
              3764.86
            ],
            [
              -2490.126,
              -2357.937,
              3812.47
            ],
            [
              -2467.791,
              -2224.746,
              3947.521
            ],
            [
              -2432.042,
              -2227.602,
              3983.384
            ],
            [
              -2417.854,
              -2231.757,
              3998.168
            ],
            [
              -2373.845,
              -2246.595,
              4044.611
            ],
            [
              -2196.773,
              -2317.488,
              4235.347
            ],
            [
              -2137.794,
              -2339.218,
              4298.203
            ],
            [
              -2015.246,
              -2367.466,
              4423.964
            ],
            [
              -1889.653,
              -2373.04,
              4549.68
            ],
            [
              -1756.388,
              -2382.093,
              4683.252
            ],
            [
              -1647.51,
              -2385.149,
              4792.173
            ],
            [
              -1597.953,
              -2389.374,
              4841.91
            ],
            [
              -1522.821,
              -2405.189,
              4918.689
            ],
            [
              -1485.023,
              -2418.11,
              4958.634
            ],
            [
              -1375.913,
              -2480.178,
              5084.163
            ],
            [
              -1328.533,
              -2508.869,
              5139.552
            ],
            [
              -1293.411,
              -2533.191,
              5182.274
            ],
            [
              -1235.733,
              -2570.637,
              5251.041
            ],
            [
              -1150.916,
              -2621.142,
              5349.756
            ],
            [
              -1079.915,
              -2651.362,
              5426.921
            ],
            [
              -1012.681,
              -2675.949,
              5498.51
            ],
            [
              -916.353,
              -2695.496,
              5596.801
            ],
            [
              -830.758,
              -2702.605,
              5682.691
            ],
            [
              -592.882,
              -2700.223,
              5920.579
            ],
            [
              -320.273,
              -2701.823,
              6193.192
            ],
            [
              -192.234,
              -2714.168,
              6321.825
            ],
            [
              11.208,
              -2748.6,
              6528.16
            ],
            [
              66.553,
              -2763.639,
              6585.512
            ],
            [
              144.816,
              -2787.102,
              6667.216
            ],
            [
              177.432,
              -2801.056,
              6702.692
            ],
            [
              247.996,
              -2851.902,
              6789.666
            ],
            [
              331.278,
              -2917.419,
              6895.631
            ],
            [
              357.389,
              -2934.595,
              6926.885
            ],
            [
              386.802,
              -2947.379,
              6958.956
            ],
            [
              425.203,
              -2957.314,
              6998.621
            ],
            [
              460.267,
              -2963.644,
              7034.252
            ],
            [
              521.193,
              -2964.305,
              7095.181
            ],
            [
              532.037,
              -2970.195,
              7107.522
            ],
            [
              600.884,
              -2980.955,
              7177.204
            ],
            [
              619.319,
              -2990.605,
              7198.012
            ],
            [
              906.98,
              -3153.977,
              7528.829
            ],
            [
              1051.83,
              -3232.348,
              7693.521
            ],
            [
              1074.157,
              -3240.804,
              7717.396
            ],
            [
              1095.125,
              -3260.979,
              7746.493
            ],
            [
              1260.9,
              -3357.556,
              7938.349
            ],
            [
              1339.233,
              -3407.989,
              8031.513
            ],
            [
              1373.568,
              -3433.117,
              8074.061
            ],
            [
              1493.843,
              -3550.011,
              8241.781
            ],
            [
              1520.486,
              -3572.771,
              8276.822
            ],
            [
              1584,
              -3657.444,
              8382.669
            ],
            [
              1660.25,
              -3750.148,
              8502.703
            ],
            [
              1866.498,
              -3989.997,
              8819.035
            ],
            [
              1889,
              -4009.127,
              8848.569
            ],
            [
              1892.95,
              -4022.775,
              8862.777
            ],
            [
              1975.005,
              -4114.479,
              8985.833
            ],
            [
              2057.826,
              -4199.52,
              9104.54
            ],
            [
              2170.271,
              -4319.627,
              9269.068
            ],
            [
              2237.981,
              -4385.463,
              9363.508
            ],
            [
              2278.639,
              -4416.283,
              9414.527
            ],
            [
              2288.882,
              -4419.815,
              9425.362
            ],
            [
              2297.281,
              -4420.426,
              9433.784
            ],
            [
              2310.823,
              -4417.999,
              9447.541
            ],
            [
              2320.672,
              -4408.165,
              9461.459
            ],
            [
              2330.583,
              -4394.991,
              9477.945
            ],
            [
              2336.672,
              -4379.52,
              9494.571
            ],
            [
              2338.759,
              -4373.358,
              9501.077
            ],
            [
              2352.029,
              -4350.863,
              9527.195
            ],
            [
              2362.441,
              -4310.981,
              9568.413
            ],
            [
              2385.909,
              -4193.416,
              9688.298
            ],
            [
              2408.961,
              -4098.109,
              9786.353
            ],
            [
              2465.77,
              -3886.543,
              10005.413
            ],
            [
              2503.327,
              -3739.507,
              10157.17
            ],
            [
              2513.829,
              -3729.363,
              10171.771
            ],
            [
              2523.211,
              -3727.63,
              10181.312
            ],
            [
              2532.532,
              -3728.601,
              10190.683
            ],
            [
              2540.338,
              -3736.718,
              10201.945
            ],
            [
              2566.251,
              -3786.011,
              10257.634
            ],
            [
              2598.162,
              -3836.707,
              10317.537
            ],
            [
              2614.638,
              -3851.49,
              10339.673
            ],
            [
              2635.392,
              -3877.441,
              10372.902
            ],
            [
              2642.893,
              -3890.985,
              10388.385
            ],
            [
              2709.56,
              -3977.961,
              10497.972
            ],
            [
              3021.059,
              -4338.966,
              10974.791
            ],
            [
              3086.352,
              -4293.444,
              11054.386
            ],
            [
              3112.838,
              -4272.891,
              11087.912
            ],
            [
              3142.482,
              -4255.542,
              11122.259
            ],
            [
              3336.938,
              -4126.748,
              11355.499
            ],
            [
              3389.682,
              -4097.691,
              11415.717
            ],
            [
              3403.448,
              -4088.142,
              11432.471
            ],
            [
              3446.229,
              -4072.046,
              11478.18
            ],
            [
              3528.69,
              -4039.102,
              11566.978
            ],
            [
              3592.048,
              -4028.061,
              11631.291
            ],
            [
              3640.778,
              -4019.583,
              11680.753
            ],
            [
              3666.294,
              -4020.567,
              11706.288
            ],
            [
              3848.026,
              -4019.578,
              11888.023
            ],
            [
              3878.881,
              -4023.507,
              11919.127
            ],
            [
              3901.964,
              -4029.514,
              11942.979
            ],
            [
              3958.181,
              -4055.079,
              12004.735
            ],
            [
              3965.111,
              -4059.221,
              12012.809
            ],
            [
              4018.762,
              -4121.92,
              12095.329
            ],
            [
              4037.773,
              -4172.381,
              12149.253
            ],
            [
              4030.875,
              -4184.064,
              12162.82
            ],
            [
              4020.501,
              -4190.327,
              12174.938
            ],
            [
              4013.086,
              -4190.447,
              12182.354
            ],
            [
              4002.213,
              -4183.979,
              12195.005
            ],
            [
              3961.129,
              -4130.112,
              12262.752
            ],
            [
              3954.003,
              -4105.097,
              12288.761
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:7603",
              "position": {
                "x": -3854.099,
                "z": -5069.209
              },
              "distanceAlongShapeM": 186.461,
              "shapeOffsetM": 1.694,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:687",
              "position": {
                "x": -3938.125,
                "z": -4417.632
              },
              "distanceAlongShapeM": 856.921,
              "shapeOffsetM": 5.291,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:5060",
              "position": {
                "x": -3633.854,
                "z": -3520.107
              },
              "distanceAlongShapeM": 1815.412,
              "shapeOffsetM": 3.767,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:7001",
              "position": {
                "x": -3665.065,
                "z": -3092.089
              },
              "distanceAlongShapeM": 2281.727,
              "shapeOffsetM": 4.619,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:855",
              "position": {
                "x": -3013.674,
                "z": -2991.043
              },
              "distanceAlongShapeM": 2946.035,
              "shapeOffsetM": 7.967,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:394",
              "position": {
                "x": -2636.314,
                "z": -2716.04
              },
              "distanceAlongShapeM": 3422.203,
              "shapeOffsetM": 3.684,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:1069",
              "position": {
                "x": -2415.576,
                "z": -2224.555
              },
              "distanceAlongShapeM": 3998.168,
              "shapeOffsetM": 7.553,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:7017",
              "position": {
                "x": -1324.1,
                "z": -2502.258
              },
              "distanceAlongShapeM": 5139.552,
              "shapeOffsetM": 7.96,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            },
            {
              "stopId": "judu:stop:5080",
              "position": {
                "x": 12.173,
                "z": -2744.606
              },
              "distanceAlongShapeM": 6528.16,
              "shapeOffsetM": 4.109,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:6846",
              "position": {
                "x": 602.169,
                "z": -2976.932
              },
              "distanceAlongShapeM": 7177.204,
              "shapeOffsetM": 4.223,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:6873",
              "position": {
                "x": 1553.844,
                "z": -3615.694
              },
              "distanceAlongShapeM": 8331.176,
              "shapeOffsetM": 0.929,
              "arrivalOffsetSeconds": 1500,
              "departureOffsetSeconds": 1500
            },
            {
              "stopId": "judu:stop:5476",
              "position": {
                "x": 2336.174,
                "z": -4371.718
              },
              "distanceAlongShapeM": 9501.176,
              "shapeOffsetM": 3.059,
              "arrivalOffsetSeconds": 1620,
              "departureOffsetSeconds": 1620
            },
            {
              "stopId": "judu:stop:741",
              "position": {
                "x": 2636.723,
                "z": -3876.397
              },
              "distanceAlongShapeM": 10372.902,
              "shapeOffsetM": 1.691,
              "arrivalOffsetSeconds": 1800,
              "departureOffsetSeconds": 1800
            },
            {
              "stopId": "judu:stop:5104",
              "position": {
                "x": 3111.27,
                "z": -4270.537
              },
              "distanceAlongShapeM": 11087.912,
              "shapeOffsetM": 2.828,
              "arrivalOffsetSeconds": 1920,
              "departureOffsetSeconds": 1920
            },
            {
              "stopId": "judu:stop:5105",
              "position": {
                "x": 3402.776,
                "z": -4086.807
              },
              "distanceAlongShapeM": 11432.471,
              "shapeOffsetM": 1.495,
              "arrivalOffsetSeconds": 1980,
              "departureOffsetSeconds": 1980
            },
            {
              "stopId": "judu:stop:5107",
              "position": {
                "x": 3640.634,
                "z": -4014.513
              },
              "distanceAlongShapeM": 11680.753,
              "shapeOffsetM": 5.072,
              "arrivalOffsetSeconds": 2040,
              "departureOffsetSeconds": 2040
            },
            {
              "stopId": "judu:stop:900",
              "position": {
                "x": 3967.843,
                "z": -4055.264
              },
              "distanceAlongShapeM": 12012.809,
              "shapeOffsetM": 4.809,
              "arrivalOffsetSeconds": 2100,
              "departureOffsetSeconds": 2100
            }
          ],
          "departuresSeconds": [
            19080,
            19920,
            20640,
            21360,
            21960,
            22680,
            23280,
            23760,
            24180,
            24660,
            25140,
            25620,
            26100,
            26460,
            26940,
            27420,
            27900,
            28380,
            28860,
            29400,
            29940,
            30600,
            31200,
            31740,
            32280,
            32760,
            33300,
            33960,
            34680,
            35400,
            35940,
            36420,
            36960,
            37440,
            37920,
            38520,
            39180,
            39720,
            40260,
            40860,
            41460,
            42060,
            42660,
            43320,
            44100,
            44880,
            45600,
            46320,
            47040,
            47760,
            48480,
            49080,
            49800,
            50400,
            51180,
            51960,
            52620,
            53460,
            54120,
            54840,
            55500,
            56040,
            56880,
            57720,
            58440,
            59220,
            59820,
            60420,
            60900,
            61380,
            61980,
            62520,
            63000,
            63540,
            64020,
            64500,
            65040,
            65640,
            66180,
            66720,
            67200,
            67680,
            68220,
            69000,
            69780,
            70500,
            71280,
            72060,
            72840,
            73620,
            74280,
            74940,
            75600,
            76260,
            76920,
            77580,
            78240,
            78900,
            79620,
            80340,
            81060,
            81780,
            82500,
            83220,
            83880,
            84540
          ]
        },
        {
          "id": "judu:pattern:vilnius_expressbus_5G:1",
          "sourceRouteId": "vilnius_expressbus_5G",
          "sourceShapeId": "vilnius_expressbus_5G_b-a",
          "directionId": 1,
          "headsign": "Perkūnkiemis",
          "directionName": "Saulėtekis–Ozo g.–Perkūnkiemis",
          "mode": "bus",
          "routeShortName": "5G",
          "routeLongName": "Perkūnkiemis–Ozo g.–Saulėtekis",
          "routeColor": "008000",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              3954.003,
              -4105.097,
              0
            ],
            [
              3949.52,
              -4094.868,
              11.169
            ],
            [
              3943.333,
              -4069.038,
              37.729
            ],
            [
              3940.538,
              -4057,
              50.087
            ],
            [
              3918.536,
              -4045.003,
              75.147
            ],
            [
              3899.276,
              -4037.251,
              95.909
            ],
            [
              3898.616,
              -4036.13,
              97.209
            ],
            [
              3858.828,
              -4027.577,
              137.906
            ],
            [
              3592.048,
              -4028.061,
              404.687
            ],
            [
              3581.678,
              -4031.203,
              415.522
            ],
            [
              3564.996,
              -4038.354,
              433.672
            ],
            [
              3520.083,
              -4051.184,
              480.382
            ],
            [
              3445.458,
              -4078.711,
              559.922
            ],
            [
              3358.965,
              -4120.486,
              655.975
            ],
            [
              3358.852,
              -4122.75,
              658.242
            ],
            [
              3310.064,
              -4150.73,
              714.484
            ],
            [
              3021.059,
              -4338.966,
              1059.385
            ],
            [
              2959.695,
              -4278.804,
              1145.321
            ],
            [
              2940.311,
              -4262.522,
              1170.635
            ],
            [
              2920.517,
              -4237.987,
              1202.16
            ],
            [
              2810.169,
              -4110.107,
              1371.068
            ],
            [
              2739.116,
              -4050.879,
              1463.569
            ],
            [
              2661.391,
              -4003.772,
              1554.455
            ],
            [
              2637.654,
              -3993.387,
              1580.365
            ],
            [
              2624.428,
              -3981.925,
              1597.866
            ],
            [
              2519.252,
              -3920.945,
              1719.441
            ],
            [
              2498.616,
              -3902.574,
              1747.07
            ],
            [
              2481.543,
              -3870.14,
              1783.723
            ],
            [
              2477.811,
              -3839.994,
              1814.099
            ],
            [
              2486.808,
              -3795.651,
              1859.346
            ],
            [
              2504.454,
              -3737.639,
              1919.982
            ],
            [
              2509.229,
              -3731.078,
              1928.097
            ],
            [
              2516.335,
              -3727.718,
              1935.957
            ],
            [
              2523.372,
              -3727.648,
              1942.994
            ],
            [
              2538.183,
              -3736.5,
              1960.249
            ],
            [
              2569.187,
              -3809.611,
              2039.663
            ],
            [
              2575.274,
              -3839.824,
              2070.482
            ],
            [
              2574.802,
              -3870.332,
              2100.995
            ],
            [
              2567.828,
              -3895.962,
              2127.556
            ],
            [
              2541.083,
              -3951.972,
              2189.624
            ],
            [
              2518.107,
              -3984.62,
              2229.546
            ],
            [
              2481.327,
              -4031.329,
              2288.998
            ],
            [
              2454.012,
              -4066.67,
              2333.664
            ],
            [
              2436.763,
              -4093.064,
              2365.195
            ],
            [
              2406.107,
              -4181.549,
              2458.84
            ],
            [
              2398.976,
              -4218.153,
              2496.132
            ],
            [
              2394.879,
              -4264.833,
              2542.992
            ],
            [
              2388.205,
              -4311.465,
              2590.099
            ],
            [
              2381.138,
              -4344.73,
              2624.106
            ],
            [
              2380.534,
              -4359.108,
              2638.497
            ],
            [
              2363.369,
              -4398.946,
              2681.875
            ],
            [
              2340.823,
              -4433.034,
              2722.745
            ],
            [
              2328.252,
              -4450.61,
              2744.354
            ],
            [
              2298.04,
              -4481.215,
              2787.359
            ],
            [
              2296.644,
              -4486.96,
              2793.271
            ],
            [
              2297.644,
              -4502.36,
              2808.704
            ],
            [
              2324.901,
              -4526.249,
              2844.948
            ],
            [
              2369.547,
              -4550.465,
              2895.738
            ],
            [
              2386.895,
              -4553.017,
              2913.273
            ],
            [
              2397.928,
              -4548.771,
              2925.095
            ],
            [
              2404.556,
              -4538.876,
              2937.004
            ],
            [
              2405.535,
              -4521.082,
              2954.825
            ],
            [
              2396.166,
              -4505.32,
              2973.162
            ],
            [
              2310.611,
              -4463.639,
              3068.33
            ],
            [
              2264.435,
              -4428.158,
              3126.563
            ],
            [
              2254.143,
              -4416.937,
              3141.789
            ],
            [
              2239.684,
              -4397.741,
              3165.821
            ],
            [
              2102.49,
              -4258.698,
              3361.155
            ],
            [
              2005.819,
              -4155.131,
              3502.828
            ],
            [
              1848.669,
              -3978.532,
              3739.225
            ],
            [
              1832.856,
              -3962.652,
              3761.635
            ],
            [
              1812.233,
              -3946.912,
              3787.579
            ],
            [
              1800.044,
              -3925.303,
              3812.388
            ],
            [
              1667.691,
              -3765.872,
              4019.597
            ],
            [
              1499.686,
              -3582.404,
              4268.367
            ],
            [
              1482.767,
              -3556.485,
              4299.319
            ],
            [
              1455.612,
              -3532.495,
              4335.554
            ],
            [
              1443.07,
              -3507.879,
              4363.18
            ],
            [
              1391.152,
              -3457.934,
              4435.222
            ],
            [
              1338.486,
              -3413.541,
              4504.102
            ],
            [
              1317.474,
              -3399.793,
              4529.212
            ],
            [
              978.337,
              -3198.709,
              4923.481
            ],
            [
              945.685,
              -3186.974,
              4958.178
            ],
            [
              931.778,
              -3172.246,
              4978.435
            ],
            [
              710.47,
              -3045.716,
              5233.36
            ],
            [
              680.065,
              -3035.6,
              5265.404
            ],
            [
              665.217,
              -3018.166,
              5288.304
            ],
            [
              641.604,
              -3005.487,
              5315.106
            ],
            [
              624.331,
              -2998.49,
              5333.742
            ],
            [
              521.572,
              -2978.793,
              5438.372
            ],
            [
              442.369,
              -2977.974,
              5517.579
            ],
            [
              342.529,
              -2936.549,
              5625.672
            ],
            [
              249.744,
              -2864.719,
              5743.012
            ],
            [
              215.338,
              -2842.938,
              5783.732
            ],
            [
              172.556,
              -2821.005,
              5831.809
            ],
            [
              117.391,
              -2800.55,
              5890.644
            ],
            [
              -65.348,
              -2754.326,
              6079.139
            ],
            [
              -120.668,
              -2747.991,
              6134.82
            ],
            [
              -224.17,
              -2733.625,
              6239.315
            ],
            [
              -312.321,
              -2725.345,
              6327.854
            ],
            [
              -534.611,
              -2721.315,
              6550.18
            ],
            [
              -763.526,
              -2727.196,
              6779.171
            ],
            [
              -847.912,
              -2724.56,
              6863.598
            ],
            [
              -963.025,
              -2710.24,
              6979.598
            ],
            [
              -1021.438,
              -2696.943,
              7039.505
            ],
            [
              -1084.241,
              -2676.889,
              7105.433
            ],
            [
              -1158.443,
              -2645.498,
              7186.001
            ],
            [
              -1386.622,
              -2502.251,
              7455.418
            ],
            [
              -1448.618,
              -2469.866,
              7525.363
            ],
            [
              -1488.158,
              -2449.225,
              7569.966
            ],
            [
              -1548.409,
              -2430.336,
              7633.109
            ],
            [
              -1640.314,
              -2415.335,
              7726.23
            ],
            [
              -1771.001,
              -2406.324,
              7857.227
            ],
            [
              -1888.196,
              -2401.495,
              7974.521
            ],
            [
              -1933.866,
              -2394.517,
              8020.722
            ],
            [
              -2056.217,
              -2387.889,
              8143.252
            ],
            [
              -2112.006,
              -2376.568,
              8200.179
            ],
            [
              -2168.467,
              -2356.953,
              8259.949
            ],
            [
              -2217.889,
              -2337.923,
              8312.908
            ],
            [
              -2396.372,
              -2270.498,
              8503.703
            ],
            [
              -2472.07,
              -2248.048,
              8582.659
            ],
            [
              -2473.439,
              -2303.416,
              8638.044
            ],
            [
              -2477.313,
              -2325.88,
              8660.84
            ],
            [
              -2484.017,
              -2376.97,
              8712.368
            ],
            [
              -2514.005,
              -2505.574,
              8844.422
            ],
            [
              -2552.25,
              -2627.352,
              8972.064
            ],
            [
              -2587.598,
              -2694.635,
              9048.068
            ],
            [
              -2669.545,
              -2793.221,
              9176.265
            ],
            [
              -2878.335,
              -2954.459,
              9440.066
            ],
            [
              -2942.823,
              -2993.401,
              9515.399
            ],
            [
              -2993.467,
              -3014.776,
              9570.369
            ],
            [
              -3056.314,
              -3033.711,
              9636.007
            ],
            [
              -3148.249,
              -3057.702,
              9731.021
            ],
            [
              -3175.722,
              -3067.532,
              9760.2
            ],
            [
              -3258.301,
              -3085.832,
              9844.782
            ],
            [
              -3322.825,
              -3090.269,
              9909.458
            ],
            [
              -3543.885,
              -3090.861,
              10130.519
            ],
            [
              -3642.787,
              -3108.062,
              10230.906
            ],
            [
              -3690.695,
              -3120.586,
              10280.423
            ],
            [
              -3680.304,
              -3153.05,
              10314.51
            ],
            [
              -3667.758,
              -3180.973,
              10345.122
            ],
            [
              -3659.777,
              -3201.747,
              10367.377
            ],
            [
              -3640.55,
              -3257.597,
              10426.443
            ],
            [
              -3617.776,
              -3346.817,
              10518.524
            ],
            [
              -3610.984,
              -3396.99,
              10569.155
            ],
            [
              -3610.019,
              -3500.257,
              10672.426
            ],
            [
              -3620.065,
              -3579.347,
              10752.152
            ],
            [
              -3630.094,
              -3629.184,
              10802.987
            ],
            [
              -3640.182,
              -3661.375,
              10836.722
            ],
            [
              -3673.181,
              -3743.178,
              10924.93
            ],
            [
              -3862.172,
              -4125.062,
              11351.021
            ],
            [
              -3878.53,
              -4166.876,
              11395.92
            ],
            [
              -3892.491,
              -4201.348,
              11433.112
            ],
            [
              -3906.204,
              -4248.978,
              11482.677
            ],
            [
              -3915.447,
              -4298.912,
              11533.459
            ],
            [
              -3918.758,
              -4341.156,
              11575.833
            ],
            [
              -3914.159,
              -4410.256,
              11645.086
            ],
            [
              -3903.629,
              -4471.665,
              11707.391
            ],
            [
              -3893.942,
              -4507.456,
              11744.47
            ],
            [
              -3887.4,
              -4526.56,
              11764.663
            ],
            [
              -3876.856,
              -4562.301,
              11801.927
            ],
            [
              -3837.687,
              -4680.982,
              11926.904
            ],
            [
              -3830.05,
              -4723.417,
              11970.021
            ],
            [
              -3816.509,
              -4833.861,
              12081.292
            ],
            [
              -3815.714,
              -4936.291,
              12183.725
            ],
            [
              -3827.684,
              -5087.455,
              12335.362
            ],
            [
              -3836.059,
              -5117.022,
              12366.092
            ],
            [
              -3846.109,
              -5119.902,
              12376.547
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:6239",
              "position": {
                "x": 3898.552,
                "z": -4039.468
              },
              "distanceAlongShapeM": 95.752,
              "shapeOffsetM": 2.327,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:5116",
              "position": {
                "x": 3565.986,
                "z": -4043.151
              },
              "distanceAlongShapeM": 434.038,
              "shapeOffsetM": 4.885,
              "arrivalOffsetSeconds": 60,
              "departureOffsetSeconds": 60
            },
            {
              "stopId": "judu:stop:6715",
              "position": {
                "x": 3360.169,
                "z": -4124.962
              },
              "distanceAlongShapeM": 658.242,
              "shapeOffsetM": 2.574,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:5103",
              "position": {
                "x": 2937.404,
                "z": -4265.024
              },
              "distanceAlongShapeM": 1170.635,
              "shapeOffsetM": 3.836,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:5485",
              "position": {
                "x": 2577.544,
                "z": -3870.831
              },
              "distanceAlongShapeM": 2100.995,
              "shapeOffsetM": 2.787,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:5490",
              "position": {
                "x": 2383.36,
                "z": -4363.697
              },
              "distanceAlongShapeM": 2641.593,
              "shapeOffsetM": 4.411,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:5125",
              "position": {
                "x": 1455.5,
                "z": -3532.601
              },
              "distanceAlongShapeM": 4335.554,
              "shapeOffsetM": 0.154,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:5131",
              "position": {
                "x": 442.304,
                "z": -2978.453
              },
              "distanceAlongShapeM": 5517.579,
              "shapeOffsetM": 0.484,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            },
            {
              "stopId": "judu:stop:8463",
              "position": {
                "x": -121.383,
                "z": -2752.193
              },
              "distanceAlongShapeM": 6134.951,
              "shapeOffsetM": 4.261,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:6937",
              "position": {
                "x": -1450.559,
                "z": -2473.275
              },
              "distanceAlongShapeM": 7525.506,
              "shapeOffsetM": 3.921,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:5074",
              "position": {
                "x": -2470.476,
                "z": -2303.737
              },
              "distanceAlongShapeM": 8638.044,
              "shapeOffsetM": 2.98,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            },
            {
              "stopId": "judu:stop:393",
              "position": {
                "x": -2667.366,
                "z": -2795.644
              },
              "distanceAlongShapeM": 9176.265,
              "shapeOffsetM": 3.259,
              "arrivalOffsetSeconds": 1560,
              "departureOffsetSeconds": 1560
            },
            {
              "stopId": "judu:stop:5137",
              "position": {
                "x": -3175.503,
                "z": -3068.357
              },
              "distanceAlongShapeM": 9760.2,
              "shapeOffsetM": 0.854,
              "arrivalOffsetSeconds": 1680,
              "departureOffsetSeconds": 1680
            },
            {
              "stopId": "judu:stop:5063",
              "position": {
                "x": -3662.711,
                "z": -3178.96
              },
              "distanceAlongShapeM": 10345.122,
              "shapeOffsetM": 5.433,
              "arrivalOffsetSeconds": 1800,
              "departureOffsetSeconds": 1800
            },
            {
              "stopId": "judu:stop:5140",
              "position": {
                "x": -3625.467,
                "z": -3630.461
              },
              "distanceAlongShapeM": 10802.987,
              "shapeOffsetM": 4.8,
              "arrivalOffsetSeconds": 1920,
              "departureOffsetSeconds": 1920
            },
            {
              "stopId": "judu:stop:6925",
              "position": {
                "x": -3883.947,
                "z": -4525.441
              },
              "distanceAlongShapeM": 11764.663,
              "shapeOffsetM": 3.63,
              "arrivalOffsetSeconds": 2100,
              "departureOffsetSeconds": 2100
            },
            {
              "stopId": "judu:stop:6931",
              "position": {
                "x": -3827.361,
                "z": -5087.486
              },
              "distanceAlongShapeM": 12335.362,
              "shapeOffsetM": 0.325,
              "arrivalOffsetSeconds": 2160,
              "departureOffsetSeconds": 2160
            }
          ],
          "departuresSeconds": [
            19380,
            20220,
            21060,
            21900,
            22680,
            23400,
            24060,
            24600,
            25380,
            25980,
            26580,
            27060,
            27600,
            28140,
            28680,
            29160,
            29640,
            30120,
            30960,
            31800,
            32640,
            33180,
            33720,
            34260,
            34740,
            35340,
            35940,
            36540,
            37020,
            37680,
            38220,
            38760,
            39240,
            39840,
            40560,
            41340,
            42300,
            43020,
            43680,
            44340,
            45060,
            45720,
            46380,
            47100,
            47700,
            48300,
            49080,
            49860,
            50640,
            51300,
            51960,
            52680,
            53280,
            53940,
            54720,
            55500,
            56280,
            56880,
            57420,
            57840,
            58380,
            58920,
            59460,
            59940,
            60360,
            60840,
            61320,
            61860,
            62400,
            62940,
            63480,
            64020,
            64560,
            65160,
            65820,
            66720,
            67620,
            68460,
            69360,
            70260,
            70920,
            71580,
            72240,
            72900,
            73560,
            74220,
            74880,
            75540,
            76260,
            76980,
            77640,
            78300,
            78960,
            79680,
            80400,
            81120,
            81840,
            82560,
            83280,
            84000,
            84780
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_expressbus_6G",
      "sourceRouteId": "vilnius_expressbus_6G",
      "mode": "bus",
      "shortName": "6G",
      "longName": "Parko–Olandų g.–Žaliasis tiltas",
      "color": "008000",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_expressbus_6G:0",
          "sourceRouteId": "vilnius_expressbus_6G",
          "sourceShapeId": "vilnius_expressbus_6G_a-b",
          "directionId": 0,
          "headsign": "Žaliasis tiltas",
          "directionName": "Parko–Olandų g.–Žaliasis tiltas",
          "mode": "bus",
          "routeShortName": "6G",
          "routeLongName": "Parko–Olandų g.–Žaliasis tiltas",
          "routeColor": "008000",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              9868.776,
              118.274,
              0
            ],
            [
              9862.137,
              118.949,
              6.673
            ],
            [
              9810.14,
              131.141,
              60.081
            ],
            [
              9748.867,
              131.276,
              121.354
            ],
            [
              9682.329,
              129.236,
              187.923
            ],
            [
              9621.808,
              131.634,
              248.492
            ],
            [
              9517.36,
              133.756,
              352.961
            ],
            [
              9448.882,
              128.466,
              421.643
            ],
            [
              9389.611,
              131.895,
              481.013
            ],
            [
              9156.08,
              129.945,
              714.552
            ],
            [
              9090.691,
              117.908,
              781.04
            ],
            [
              9071.372,
              103.392,
              805.205
            ],
            [
              9049.578,
              94.246,
              828.84
            ],
            [
              8990.008,
              50.917,
              902.501
            ],
            [
              8869.532,
              -70.228,
              1073.354
            ],
            [
              8853.145,
              -83.257,
              1094.289
            ],
            [
              8819.883,
              -101.512,
              1132.231
            ],
            [
              8767.948,
              -118.279,
              1186.806
            ],
            [
              8695.316,
              -137.969,
              1262.059
            ],
            [
              8672.646,
              -150.383,
              1287.906
            ],
            [
              8624.533,
              -154.886,
              1336.229
            ],
            [
              8595.54,
              -160.454,
              1365.752
            ],
            [
              8590.933,
              -197.1,
              1402.686
            ],
            [
              8584.694,
              -314.984,
              1520.735
            ],
            [
              8567.281,
              -539.519,
              1745.944
            ],
            [
              8554.112,
              -617.185,
              1824.719
            ],
            [
              8531.721,
              -672.4,
              1884.301
            ],
            [
              8487.656,
              -660.31,
              1929.995
            ],
            [
              8367.171,
              -581.146,
              2074.16
            ],
            [
              8314.693,
              -528.882,
              2148.224
            ],
            [
              8254.878,
              -456.433,
              2242.174
            ],
            [
              8204.93,
              -406.448,
              2312.838
            ],
            [
              8163.673,
              -373.337,
              2365.738
            ],
            [
              8140.11,
              -358.393,
              2393.641
            ],
            [
              8089.693,
              -331.779,
              2450.651
            ],
            [
              8068.574,
              -323.563,
              2473.312
            ],
            [
              7987.101,
              -301.896,
              2557.617
            ],
            [
              7941.44,
              -295.418,
              2603.735
            ],
            [
              7928.015,
              -296.961,
              2617.248
            ],
            [
              7910.517,
              -293.688,
              2635.05
            ],
            [
              7877.639,
              -293.032,
              2667.934
            ],
            [
              7803.39,
              -297.118,
              2742.296
            ],
            [
              7662.12,
              -331.043,
              2887.582
            ],
            [
              7526.029,
              -370.999,
              3029.417
            ],
            [
              7481.619,
              -392.025,
              3078.553
            ],
            [
              7422.914,
              -425.371,
              3146.068
            ],
            [
              7391.551,
              -445.901,
              3183.553
            ],
            [
              7274.84,
              -542.67,
              3335.163
            ],
            [
              7223.786,
              -580.623,
              3398.779
            ],
            [
              7148.018,
              -629.221,
              3488.793
            ],
            [
              7093.297,
              -657.084,
              3550.199
            ],
            [
              6995.189,
              -694.109,
              3655.061
            ],
            [
              6921.973,
              -711.59,
              3730.335
            ],
            [
              6856.67,
              -720.321,
              3796.219
            ],
            [
              6795.988,
              -723.577,
              3856.988
            ],
            [
              6712.188,
              -721.926,
              3940.805
            ],
            [
              6649.147,
              -714.005,
              4004.341
            ],
            [
              6571.433,
              -698.004,
              4083.686
            ],
            [
              6523.349,
              -683.7,
              4133.852
            ],
            [
              6449.764,
              -654.422,
              4213.048
            ],
            [
              6436.826,
              -651.702,
              4226.269
            ],
            [
              6365.394,
              -616.028,
              4306.113
            ],
            [
              6247.14,
              -562.5,
              4435.918
            ],
            [
              6102.584,
              -501.78,
              4592.709
            ],
            [
              6033.375,
              -479.275,
              4665.485
            ],
            [
              5958.9,
              -462.234,
              4741.885
            ],
            [
              5902.989,
              -452.237,
              4798.682
            ],
            [
              5819.302,
              -444.914,
              4882.689
            ],
            [
              5710.368,
              -441.803,
              4991.667
            ],
            [
              5691.671,
              -442.516,
              5010.378
            ],
            [
              5642.585,
              -443.152,
              5059.468
            ],
            [
              5383.59,
              -465.511,
              5319.426
            ],
            [
              5245.194,
              -488.734,
              5459.757
            ],
            [
              5168.103,
              -503.64,
              5538.276
            ],
            [
              5099.964,
              -525.701,
              5609.898
            ],
            [
              5024.562,
              -556.529,
              5691.358
            ],
            [
              4957.541,
              -587.519,
              5765.197
            ],
            [
              4906.057,
              -615.47,
              5823.779
            ],
            [
              4828.015,
              -649.59,
              5908.954
            ],
            [
              4765.144,
              -666.191,
              5973.98
            ],
            [
              4704.378,
              -673.927,
              6035.236
            ],
            [
              4650.166,
              -676.224,
              6089.497
            ],
            [
              4614.755,
              -673.316,
              6125.027
            ],
            [
              4552.441,
              -660.985,
              6188.549
            ],
            [
              4508.24,
              -645.664,
              6235.33
            ],
            [
              4426.454,
              -606.243,
              6326.121
            ],
            [
              4266.373,
              -479.602,
              6530.238
            ],
            [
              4207.404,
              -435.42,
              6603.923
            ],
            [
              4102.373,
              -355.119,
              6736.134
            ],
            [
              4073.746,
              -334.533,
              6771.394
            ],
            [
              4021.499,
              -301.251,
              6833.341
            ],
            [
              3924.337,
              -255.979,
              6940.533
            ],
            [
              3871.834,
              -236.053,
              6996.69
            ],
            [
              3794.896,
              -212.322,
              7077.204
            ],
            [
              3748.025,
              -201.41,
              7125.329
            ],
            [
              3692.751,
              -191.452,
              7181.493
            ],
            [
              3533.915,
              -167.282,
              7342.157
            ],
            [
              3462.884,
              -150.608,
              7415.119
            ],
            [
              3394.357,
              -124.205,
              7488.557
            ],
            [
              3376.313,
              -111.969,
              7510.358
            ],
            [
              3343.728,
              -95.766,
              7546.749
            ],
            [
              3282.595,
              -54.531,
              7620.489
            ],
            [
              2977.671,
              191.693,
              8012.414
            ],
            [
              2944.561,
              216.482,
              8053.775
            ],
            [
              2919.043,
              240.05,
              8088.511
            ],
            [
              2850.195,
              306.534,
              8184.22
            ],
            [
              2697.486,
              451.904,
              8395.058
            ],
            [
              2679.584,
              466.091,
              8417.9
            ],
            [
              2649.901,
              493.988,
              8458.634
            ],
            [
              2582.473,
              544.237,
              8542.727
            ],
            [
              2413.667,
              623.104,
              8729.047
            ],
            [
              2393.054,
              624.603,
              8749.715
            ],
            [
              2378.182,
              622.655,
              8764.714
            ],
            [
              2363.247,
              617.369,
              8780.557
            ],
            [
              2305.672,
              573.917,
              8852.688
            ],
            [
              2269.605,
              542.307,
              8900.647
            ],
            [
              2254.026,
              527.847,
              8921.903
            ],
            [
              2223.804,
              507.54,
              8958.313
            ],
            [
              1990.962,
              334.88,
              9248.187
            ],
            [
              1969.782,
              310.225,
              9280.69
            ],
            [
              1935.827,
              283.585,
              9323.849
            ],
            [
              1864.599,
              199.192,
              9434.282
            ],
            [
              1763.619,
              40.763,
              9622.156
            ],
            [
              1755.04,
              12.778,
              9651.427
            ],
            [
              1734.841,
              -15.477,
              9686.159
            ],
            [
              1714.048,
              -58.507,
              9733.95
            ],
            [
              1702.489,
              -90.576,
              9768.038
            ],
            [
              1692.553,
              -139.375,
              9817.839
            ],
            [
              1696.284,
              -216.258,
              9894.812
            ],
            [
              1701.445,
              -250.864,
              9929.801
            ],
            [
              1720.689,
              -325.809,
              10007.177
            ],
            [
              1730.124,
              -347.569,
              10030.895
            ],
            [
              1742.617,
              -429.749,
              10114.019
            ],
            [
              1739.19,
              -475.328,
              10159.726
            ],
            [
              1717.531,
              -565.098,
              10252.072
            ],
            [
              1721.402,
              -599.681,
              10286.871
            ],
            [
              1718.066,
              -610.324,
              10298.025
            ],
            [
              1700.984,
              -622.679,
              10319.107
            ],
            [
              1670.687,
              -622.116,
              10349.409
            ],
            [
              1656.263,
              -617.38,
              10364.591
            ],
            [
              1647.146,
              -604.98,
              10379.981
            ],
            [
              1647.435,
              -589.4,
              10395.564
            ],
            [
              1641.361,
              -569.249,
              10416.611
            ],
            [
              1626.241,
              -550.043,
              10441.054
            ],
            [
              1613.941,
              -537.088,
              10458.918
            ],
            [
              1585.646,
              -513.666,
              10495.65
            ],
            [
              1220.098,
              -229.7,
              10958.534
            ],
            [
              1131.659,
              -164.612,
              11068.343
            ],
            [
              1087.044,
              -135.958,
              11121.367
            ],
            [
              1061.875,
              -125.757,
              11148.525
            ],
            [
              1042.305,
              -113.981,
              11171.364
            ],
            [
              992.552,
              -84.12,
              11229.39
            ],
            [
              920.398,
              -44.941,
              11311.495
            ],
            [
              797.689,
              -19.306,
              11436.853
            ],
            [
              670.384,
              1.958,
              11565.922
            ],
            [
              652.936,
              0.051,
              11583.474
            ],
            [
              630.873,
              -7.336,
              11606.741
            ],
            [
              602.561,
              -27.877,
              11641.719
            ],
            [
              564.962,
              -49.544,
              11685.114
            ],
            [
              476.44,
              -129.188,
              11804.191
            ],
            [
              402.286,
              -199.078,
              11906.09
            ],
            [
              346.776,
              -237.026,
              11973.332
            ],
            [
              281.176,
              -262.545,
              12043.721
            ],
            [
              119.684,
              -277.409,
              12205.895
            ],
            [
              130.203,
              -407.85,
              12336.76
            ],
            [
              144.816,
              -445.964,
              12377.579
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:6073",
              "position": {
                "x": 9682.346,
                "z": 127.063
              },
              "distanceAlongShapeM": 187.923,
              "shapeOffsetM": 2.173,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:6045",
              "position": {
                "x": 9448.882,
                "z": 128.466
              },
              "distanceAlongShapeM": 421.643,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 60,
              "departureOffsetSeconds": 60
            },
            {
              "stopId": "judu:stop:6043",
              "position": {
                "x": 9073.545,
                "z": 99.328
              },
              "distanceAlongShapeM": 805.205,
              "shapeOffsetM": 4.609,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:6041",
              "position": {
                "x": 8673.105,
                "z": -151.995
              },
              "distanceAlongShapeM": 1287.906,
              "shapeOffsetM": 1.676,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:5400",
              "position": {
                "x": 8486.109,
                "z": -663.69
              },
              "distanceAlongShapeM": 1929.995,
              "shapeOffsetM": 3.717,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:6729",
              "position": {
                "x": 7927.813,
                "z": -299.599
              },
              "distanceAlongShapeM": 2617.248,
              "shapeOffsetM": 2.646,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:5424",
              "position": {
                "x": 2941.964,
                "z": 213.518
              },
              "distanceAlongShapeM": 8053.775,
              "shapeOffsetM": 3.941,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:6572",
              "position": {
                "x": 2256.376,
                "z": 524.743
              },
              "distanceAlongShapeM": 8921.903,
              "shapeOffsetM": 3.893,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:449",
              "position": {
                "x": 1973.014,
                "z": 306.27
              },
              "distanceAlongShapeM": 9280.69,
              "shapeOffsetM": 5.108,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:5768",
              "position": {
                "x": 1608.96,
                "z": -543.043
              },
              "distanceAlongShapeM": 10458.029,
              "shapeOffsetM": 7.713,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:848",
              "position": {
                "x": 604.636,
                "z": -31.346
              },
              "distanceAlongShapeM": 11641.719,
              "shapeOffsetM": 4.042,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            },
            {
              "stopId": "judu:stop:5245",
              "position": {
                "x": 150.182,
                "z": -443.837
              },
              "distanceAlongShapeM": 12377.514,
              "shapeOffsetM": 5.772,
              "arrivalOffsetSeconds": 1620,
              "departureOffsetSeconds": 1620
            }
          ],
          "departuresSeconds": [
            18840,
            19200,
            19620,
            20040,
            20460,
            20940,
            21420,
            21960,
            22440,
            22860,
            23280,
            23700,
            24120,
            24540,
            25020,
            25500,
            26040,
            26520,
            27000,
            27480,
            27960,
            28440,
            28800,
            29220,
            29580,
            29940,
            30660,
            31500,
            32340,
            33180,
            34020,
            34680,
            35340,
            36240,
            37080,
            37620,
            38160,
            38700,
            39240,
            39780,
            40320,
            40800,
            41340,
            41880,
            42420,
            42960,
            43500,
            44040,
            44580,
            45060,
            45600,
            46080,
            46620,
            47160,
            47640,
            48180,
            48720,
            49200,
            49740,
            50280,
            50820,
            51300,
            51780,
            52260,
            52680,
            53100,
            53520,
            53940,
            54420,
            54900,
            55380,
            55860,
            56340,
            56820,
            57300,
            57780,
            58260,
            58740,
            59220,
            59700,
            60180,
            60720,
            61260,
            61800,
            62340,
            62880,
            63420,
            63960,
            64620,
            65280,
            66120,
            66900,
            67680,
            68460,
            69360,
            70260,
            70920,
            71520,
            72060,
            72600,
            73140,
            73680,
            74160,
            74700,
            75180,
            75660,
            76140,
            76620,
            77160,
            77700,
            78240,
            78780,
            79320,
            79860,
            80400,
            80940,
            81480,
            82020,
            82560,
            83100
          ]
        },
        {
          "id": "judu:pattern:vilnius_expressbus_6G:1",
          "sourceRouteId": "vilnius_expressbus_6G",
          "sourceShapeId": "vilnius_expressbus_6G_b-a",
          "directionId": 1,
          "headsign": "Parko g.",
          "directionName": "Žaliasis tiltas–Olandų–Parko g.",
          "mode": "bus",
          "routeShortName": "6G",
          "routeLongName": "Parko–Olandų g.–Žaliasis tiltas",
          "routeColor": "008000",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              144.816,
              -445.964,
              0
            ],
            [
              174.587,
              -519.993,
              79.791
            ],
            [
              186.708,
              -562.507,
              123.999
            ],
            [
              214.213,
              -645.388,
              211.325
            ],
            [
              223.987,
              -656.808,
              226.357
            ],
            [
              236.049,
              -695.879,
              267.247
            ],
            [
              294.146,
              -689.755,
              325.666
            ],
            [
              331.506,
              -684.268,
              363.427
            ],
            [
              436.802,
              -673.948,
              469.228
            ],
            [
              647.48,
              -719,
              684.669
            ],
            [
              692.52,
              -724.28,
              730.017
            ],
            [
              727.857,
              -730.038,
              765.82
            ],
            [
              752.192,
              -734.856,
              790.627
            ],
            [
              1031.058,
              -793.963,
              1075.689
            ],
            [
              1157.03,
              -816.326,
              1203.63
            ],
            [
              1199.169,
              -824.315,
              1246.52
            ],
            [
              1220.015,
              -827.509,
              1267.609
            ],
            [
              1248.96,
              -831.383,
              1296.812
            ],
            [
              1306.39,
              -829.106,
              1354.287
            ],
            [
              1381.451,
              -814.909,
              1430.679
            ],
            [
              1608.787,
              -656.591,
              1707.71
            ],
            [
              1644.195,
              -624.964,
              1755.187
            ],
            [
              1649.997,
              -609.491,
              1771.712
            ],
            [
              1647.435,
              -589.4,
              1791.966
            ],
            [
              1649.076,
              -570.506,
              1810.931
            ],
            [
              1661.593,
              -556.266,
              1829.89
            ],
            [
              1707.61,
              -543.762,
              1877.576
            ],
            [
              1715.531,
              -533.89,
              1890.233
            ],
            [
              1739.19,
              -475.328,
              1953.393
            ],
            [
              1739.832,
              -440.829,
              1987.898
            ],
            [
              1737.688,
              -417.411,
              2011.414
            ],
            [
              1728.721,
              -379.394,
              2050.474
            ],
            [
              1717.488,
              -353.728,
              2078.491
            ],
            [
              1709.957,
              -313.364,
              2119.551
            ],
            [
              1701.073,
              -270.896,
              2162.939
            ],
            [
              1691.292,
              -207.259,
              2227.323
            ],
            [
              1692.553,
              -139.375,
              2295.219
            ],
            [
              1699.889,
              -91.641,
              2343.513
            ],
            [
              1722.281,
              -31.942,
              2407.273
            ],
            [
              1763.619,
              40.763,
              2490.908
            ],
            [
              1784.543,
              87.474,
              2542.092
            ],
            [
              1803.689,
              114.605,
              2575.298
            ],
            [
              1864.141,
              209.22,
              2687.576
            ],
            [
              1913.636,
              269.526,
              2765.593
            ],
            [
              1990.962,
              334.88,
              2866.837
            ],
            [
              2018.633,
              366.989,
              2909.225
            ],
            [
              2052.586,
              388.28,
              2949.301
            ],
            [
              2087.216,
              412.125,
              2991.347
            ],
            [
              2136.967,
              451.273,
              3054.653
            ],
            [
              2182.309,
              496.069,
              3118.392
            ],
            [
              2210.658,
              528.937,
              3161.796
            ],
            [
              2229.877,
              556.409,
              3195.324
            ],
            [
              2248.742,
              590.591,
              3234.366
            ],
            [
              2266.569,
              621.404,
              3269.964
            ],
            [
              2281.67,
              670.105,
              3320.953
            ],
            [
              2292.591,
              736.695,
              3388.432
            ],
            [
              2303.283,
              756.534,
              3410.969
            ],
            [
              2315.701,
              765.207,
              3426.116
            ],
            [
              2333.759,
              767.736,
              3444.35
            ],
            [
              2353.101,
              764.507,
              3463.96
            ],
            [
              2377.645,
              731.764,
              3504.881
            ],
            [
              2411.777,
              694.387,
              3555.497
            ],
            [
              2429.021,
              676.964,
              3580.011
            ],
            [
              2453.553,
              653.492,
              3613.963
            ],
            [
              2501.276,
              617.009,
              3674.034
            ],
            [
              2634.367,
              525.451,
              3835.577
            ],
            [
              2716.164,
              450.439,
              3946.561
            ],
            [
              2736.291,
              431.885,
              3973.935
            ],
            [
              2755.449,
              412.963,
              4000.862
            ],
            [
              2864.4,
              307.38,
              4152.579
            ],
            [
              2936.644,
              239.224,
              4251.899
            ],
            [
              2983.62,
              199.374,
              4313.501
            ],
            [
              3033.392,
              162.998,
              4375.149
            ],
            [
              3060.52,
              138.92,
              4411.421
            ],
            [
              3266.423,
              -23.054,
              4673.398
            ],
            [
              3339.574,
              -76.762,
              4764.148
            ],
            [
              3415.597,
              -114.94,
              4849.219
            ],
            [
              3440.614,
              -122.094,
              4875.239
            ],
            [
              3504.684,
              -140.35,
              4941.859
            ],
            [
              3501.543,
              -139.949,
              4945.026
            ],
            [
              3709.123,
              -178.405,
              5156.138
            ],
            [
              3787.457,
              -196.594,
              5236.556
            ],
            [
              3851.65,
              -212.29,
              5302.64
            ],
            [
              3930.415,
              -241.623,
              5386.689
            ],
            [
              4021.131,
              -286.771,
              5488.019
            ],
            [
              4084.273,
              -323.602,
              5561.118
            ],
            [
              4201.401,
              -403.77,
              5703.054
            ],
            [
              4228.208,
              -425.014,
              5737.258
            ],
            [
              4243.612,
              -437.324,
              5756.976
            ],
            [
              4278.232,
              -466.47,
              5802.232
            ],
            [
              4369.718,
              -538.359,
              5918.584
            ],
            [
              4422.518,
              -576.109,
              5983.491
            ],
            [
              4472.265,
              -604.896,
              6040.966
            ],
            [
              4515.715,
              -625.769,
              6089.17
            ],
            [
              4558.025,
              -638.827,
              6133.449
            ],
            [
              4617.783,
              -649.996,
              6194.242
            ],
            [
              4673.822,
              -653.3,
              6250.378
            ],
            [
              4729.99,
              -649.928,
              6306.647
            ],
            [
              4754.55,
              -647.061,
              6331.374
            ],
            [
              4785.642,
              -639.867,
              6363.288
            ],
            [
              4844.087,
              -618.728,
              6425.438
            ],
            [
              5036.703,
              -528.931,
              6637.957
            ],
            [
              5111.461,
              -498.092,
              6718.826
            ],
            [
              5156.243,
              -483.372,
              6765.965
            ],
            [
              5224.275,
              -466.876,
              6835.969
            ],
            [
              5273.441,
              -458.923,
              6885.774
            ],
            [
              5284.768,
              -457.104,
              6897.246
            ],
            [
              5327.098,
              -452.169,
              6939.863
            ],
            [
              5348.35,
              -453.695,
              6961.169
            ],
            [
              5548.21,
              -426.923,
              7162.814
            ],
            [
              5629.62,
              -418.569,
              7244.652
            ],
            [
              5749.654,
              -415.325,
              7364.73
            ],
            [
              5806.905,
              -417.675,
              7422.029
            ],
            [
              5963.202,
              -440.053,
              7579.92
            ],
            [
              5998.147,
              -448.938,
              7615.977
            ],
            [
              6073.54,
              -468.999,
              7693.993
            ],
            [
              6189.436,
              -512.386,
              7817.744
            ],
            [
              6360.739,
              -590.332,
              8005.947
            ],
            [
              6402.87,
              -612.311,
              8053.467
            ],
            [
              6557.754,
              -672.13,
              8219.501
            ],
            [
              6602.659,
              -684.146,
              8265.986
            ],
            [
              6682.351,
              -697.96,
              8346.866
            ],
            [
              6780.934,
              -702.128,
              8445.537
            ],
            [
              6864.177,
              -699.316,
              8528.828
            ],
            [
              6937.971,
              -685.187,
              8603.962
            ],
            [
              7035.236,
              -658.162,
              8704.912
            ],
            [
              7126.343,
              -616.546,
              8805.073
            ],
            [
              7192.221,
              -578.885,
              8880.957
            ],
            [
              7263.567,
              -525.747,
              8969.917
            ],
            [
              7363.253,
              -442,
              9100.112
            ],
            [
              7412.953,
              -407.361,
              9160.692
            ],
            [
              7461.255,
              -378.261,
              9217.083
            ],
            [
              7507.446,
              -358.026,
              9267.512
            ],
            [
              7566.531,
              -338.048,
              9329.883
            ],
            [
              7666.431,
              -308.863,
              9433.959
            ],
            [
              7747.458,
              -288.21,
              9517.576
            ],
            [
              7874.867,
              -273.035,
              9645.885
            ],
            [
              7914.079,
              -274.485,
              9685.125
            ],
            [
              7971.362,
              -282.656,
              9742.987
            ],
            [
              8031.61,
              -296.506,
              9804.807
            ],
            [
              8097.029,
              -319.679,
              9874.209
            ],
            [
              8139.789,
              -341.705,
              9922.308
            ],
            [
              8190.291,
              -376.496,
              9983.635
            ],
            [
              8211.099,
              -398.071,
              10013.608
            ],
            [
              8367.171,
              -581.146,
              10254.181
            ],
            [
              8434.632,
              -625.918,
              10335.147
            ],
            [
              8481.22,
              -650.233,
              10387.698
            ],
            [
              8531.721,
              -672.4,
              10442.85
            ],
            [
              8541.441,
              -631.817,
              10484.581
            ],
            [
              8559.188,
              -557.169,
              10561.309
            ],
            [
              8576.654,
              -426.152,
              10693.486
            ],
            [
              8584.228,
              -306.068,
              10813.808
            ],
            [
              8588.332,
              -198.161,
              10921.793
            ],
            [
              8595.54,
              -160.454,
              10960.183
            ],
            [
              8696.309,
              -134.44,
              11064.256
            ],
            [
              8720.235,
              -127.625,
              11089.133
            ],
            [
              8744.3,
              -121.003,
              11114.093
            ],
            [
              8789.403,
              -109.804,
              11160.565
            ],
            [
              8826.448,
              -96.087,
              11200.068
            ],
            [
              8853.145,
              -83.257,
              11229.688
            ],
            [
              8900.484,
              -38.566,
              11294.79
            ],
            [
              8997.947,
              60.777,
              11433.959
            ],
            [
              9045.087,
              95.45,
              11492.478
            ],
            [
              9064.009,
              106.201,
              11514.241
            ],
            [
              9090.691,
              117.908,
              11543.378
            ],
            [
              9117.305,
              128.24,
              11571.927
            ],
            [
              9141.918,
              131.345,
              11596.735
            ],
            [
              9732.973,
              138.29,
              12187.831
            ],
            [
              9774.103,
              135.215,
              12229.076
            ],
            [
              9799.87,
              133.577,
              12254.895
            ],
            [
              9819.523,
              134.263,
              12274.56
            ],
            [
              9844.442,
              127.789,
              12300.306
            ],
            [
              9855.41,
              124.412,
              12311.782
            ],
            [
              9866.644,
              120.91,
              12323.55
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:5245",
              "position": {
                "x": 150.182,
                "z": -443.837
              },
              "distanceAlongShapeM": 0.029,
              "shapeOffsetM": 5.773,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:5667",
              "position": {
                "x": 292.85,
                "z": -682.448
              },
              "distanceAlongShapeM": 325.143,
              "shapeOffsetM": 7.402,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:6660",
              "position": {
                "x": 1200.176,
                "z": -819.349
              },
              "distanceAlongShapeM": 1246.763,
              "shapeOffsetM": 5.061,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:6565",
              "position": {
                "x": 1714.349,
                "z": -354.636
              },
              "distanceAlongShapeM": 2078.491,
              "shapeOffsetM": 3.268,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:6571",
              "position": {
                "x": 2015.503,
                "z": 371.16
              },
              "distanceAlongShapeM": 2909.225,
              "shapeOffsetM": 5.214,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:6574",
              "position": {
                "x": 2244.749,
                "z": 592.868
              },
              "distanceAlongShapeM": 3234.366,
              "shapeOffsetM": 4.597,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:5372",
              "position": {
                "x": 3035.88,
                "z": 166.104
              },
              "distanceAlongShapeM": 4375.149,
              "shapeOffsetM": 3.98,
              "arrivalOffsetSeconds": 750,
              "departureOffsetSeconds": 750
            },
            {
              "stopId": "judu:stop:6727",
              "position": {
                "x": 7874.837,
                "z": -271.823
              },
              "distanceAlongShapeM": 9645.885,
              "shapeOffsetM": 1.213,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:6225",
              "position": {
                "x": 8539.64,
                "z": -631.367
              },
              "distanceAlongShapeM": 10484.602,
              "shapeOffsetM": 1.856,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:6040",
              "position": {
                "x": 8718.239,
                "z": -120.617
              },
              "distanceAlongShapeM": 11089.133,
              "shapeOffsetM": 7.287,
              "arrivalOffsetSeconds": 1380,
              "departureOffsetSeconds": 1380
            },
            {
              "stopId": "judu:stop:6042",
              "position": {
                "x": 9116.151,
                "z": 132.979
              },
              "distanceAlongShapeM": 11571.927,
              "shapeOffsetM": 4.877,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            },
            {
              "stopId": "judu:stop:6044",
              "position": {
                "x": 9552.934,
                "z": 138.6
              },
              "distanceAlongShapeM": 12007.808,
              "shapeOffsetM": 2.425,
              "arrivalOffsetSeconds": 1560,
              "departureOffsetSeconds": 1560
            },
            {
              "stopId": "judu:stop:7444",
              "position": {
                "x": 9732.975,
                "z": 142.732
              },
              "distanceAlongShapeM": 12187.831,
              "shapeOffsetM": 4.442,
              "arrivalOffsetSeconds": 1620,
              "departureOffsetSeconds": 1620
            }
          ],
          "departuresSeconds": [
            20340,
            20700,
            21120,
            21540,
            21960,
            22500,
            22980,
            23520,
            24000,
            24420,
            24900,
            25320,
            25800,
            26280,
            26760,
            27240,
            27780,
            28260,
            28740,
            29220,
            29760,
            30240,
            30600,
            31020,
            31380,
            31740,
            32460,
            33180,
            34020,
            34860,
            35700,
            36360,
            36960,
            37860,
            38700,
            39240,
            39780,
            40320,
            40860,
            41400,
            41940,
            42420,
            42960,
            43500,
            44040,
            44580,
            45120,
            45660,
            46200,
            46680,
            47220,
            47700,
            48240,
            48780,
            49260,
            49800,
            50340,
            50880,
            51420,
            51960,
            52500,
            52980,
            53460,
            53940,
            54360,
            54780,
            55200,
            55620,
            56100,
            56580,
            57060,
            57540,
            58020,
            58560,
            59040,
            59520,
            60000,
            60480,
            60960,
            61440,
            61920,
            62460,
            63000,
            63540,
            64080,
            64620,
            65160,
            65640,
            66300,
            66960,
            67800,
            68580,
            69300,
            70080,
            70980,
            71880,
            72540,
            73080,
            73620,
            74160,
            74700,
            75240,
            75720,
            76260,
            76740,
            77220,
            77700,
            78180,
            78720,
            79200,
            79740,
            80280,
            80820,
            81360,
            81900,
            82440,
            82980,
            83520,
            84000,
            84540
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_bus_7",
      "sourceRouteId": "vilnius_bus_7",
      "mode": "bus",
      "shortName": "7",
      "longName": "Šiaurės miestelis–Verkių g.–Viršuliškės–Lazdynai",
      "color": "0073AC",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_bus_7:0",
          "sourceRouteId": "vilnius_bus_7",
          "sourceShapeId": "vilnius_bus_7_a-b",
          "directionId": 0,
          "headsign": "Lazdynai",
          "directionName": "Šiaurės miestelis–Verkių g.–Viršuliškės–Lazdynai",
          "mode": "bus",
          "routeShortName": "7",
          "routeLongName": "Šiaurės miestelis–Verkių g.–Viršuliškės–Lazdynai",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              1407.302,
              -2542.364,
              0
            ],
            [
              1404.085,
              -2529.725,
              13.042
            ],
            [
              1492.99,
              -2519.128,
              102.577
            ],
            [
              1552.992,
              -2512.565,
              162.937
            ],
            [
              1553.062,
              -2516.719,
              167.092
            ],
            [
              1555.121,
              -2529.24,
              179.781
            ],
            [
              1555.678,
              -2562.629,
              213.175
            ],
            [
              1562.253,
              -2572.736,
              225.233
            ],
            [
              1574.454,
              -2575.189,
              237.678
            ],
            [
              1684.596,
              -2579.462,
              347.903
            ],
            [
              1689.647,
              -2585.122,
              355.489
            ],
            [
              1692.552,
              -2638.806,
              409.252
            ],
            [
              1690.652,
              -2669.748,
              440.251
            ],
            [
              1690.731,
              -2873.474,
              643.977
            ],
            [
              1700.851,
              -3126.37,
              897.076
            ],
            [
              1707.344,
              -3177.803,
              948.917
            ],
            [
              1701.896,
              -3208.77,
              980.36
            ],
            [
              1697.306,
              -3247.648,
              1019.508
            ],
            [
              1679.831,
              -3286.287,
              1061.915
            ],
            [
              1593.247,
              -3437.193,
              1235.896
            ],
            [
              1579.69,
              -3472.235,
              1273.468
            ],
            [
              1566.424,
              -3493.47,
              1298.507
            ],
            [
              1508.519,
              -3591.87,
              1412.68
            ],
            [
              1412.221,
              -3746.656,
              1594.977
            ],
            [
              1401.002,
              -3760.92,
              1613.124
            ],
            [
              1342.534,
              -3804.924,
              1686.301
            ],
            [
              1325.974,
              -3810.739,
              1703.852
            ],
            [
              1219.986,
              -3862.213,
              1821.678
            ],
            [
              1095.571,
              -3757.361,
              1984.384
            ],
            [
              1093.2,
              -3739.235,
              2002.665
            ],
            [
              1088.237,
              -3640.604,
              2101.421
            ],
            [
              1091.873,
              -3611.591,
              2130.66
            ],
            [
              1094.401,
              -3579.354,
              2162.996
            ],
            [
              1093.805,
              -3506.982,
              2235.371
            ],
            [
              1085.19,
              -3450.047,
              2292.954
            ],
            [
              1055.574,
              -3343.742,
              2403.307
            ],
            [
              1027.41,
              -3228.558,
              2521.884
            ],
            [
              978.337,
              -3198.709,
              2579.322
            ],
            [
              945.685,
              -3186.974,
              2614.019
            ],
            [
              931.778,
              -3172.246,
              2634.275
            ],
            [
              710.47,
              -3045.716,
              2889.201
            ],
            [
              680.065,
              -3035.6,
              2921.245
            ],
            [
              665.217,
              -3018.166,
              2944.145
            ],
            [
              624.331,
              -2998.49,
              2989.519
            ],
            [
              521.572,
              -2978.793,
              3094.149
            ],
            [
              442.369,
              -2977.974,
              3173.356
            ],
            [
              342.529,
              -2936.549,
              3281.449
            ],
            [
              249.744,
              -2864.719,
              3398.789
            ],
            [
              215.338,
              -2842.938,
              3439.509
            ],
            [
              172.556,
              -2821.005,
              3487.586
            ],
            [
              117.391,
              -2800.55,
              3546.421
            ],
            [
              -65.348,
              -2754.326,
              3734.916
            ],
            [
              -120.668,
              -2747.991,
              3790.597
            ],
            [
              -224.17,
              -2733.625,
              3895.092
            ],
            [
              -312.321,
              -2725.345,
              3983.631
            ],
            [
              -534.611,
              -2721.315,
              4205.957
            ],
            [
              -763.526,
              -2727.196,
              4434.948
            ],
            [
              -847.912,
              -2724.56,
              4519.375
            ],
            [
              -963.025,
              -2710.24,
              4635.375
            ],
            [
              -1021.438,
              -2696.943,
              4695.282
            ],
            [
              -1084.241,
              -2676.889,
              4761.209
            ],
            [
              -1158.443,
              -2645.498,
              4841.778
            ],
            [
              -1386.622,
              -2502.251,
              5111.195
            ],
            [
              -1448.618,
              -2469.866,
              5181.14
            ],
            [
              -1488.158,
              -2449.225,
              5225.743
            ],
            [
              -1548.409,
              -2430.336,
              5288.886
            ],
            [
              -1640.314,
              -2415.335,
              5382.007
            ],
            [
              -1771.001,
              -2406.324,
              5513.004
            ],
            [
              -1888.196,
              -2401.495,
              5630.298
            ],
            [
              -1933.866,
              -2394.517,
              5676.499
            ],
            [
              -2056.217,
              -2387.889,
              5799.029
            ],
            [
              -2112.006,
              -2376.568,
              5855.956
            ],
            [
              -2168.467,
              -2356.953,
              5915.726
            ],
            [
              -2218.449,
              -2337.7,
              5969.289
            ],
            [
              -2472.07,
              -2248.048,
              6238.289
            ],
            [
              -2531.314,
              -2244.774,
              6297.623
            ],
            [
              -2551.192,
              -2238.857,
              6318.363
            ],
            [
              -2575.188,
              -2210.603,
              6355.432
            ],
            [
              -2621.185,
              -2114.055,
              6462.377
            ],
            [
              -2635.944,
              -2073.719,
              6505.328
            ],
            [
              -2636.896,
              -2018.041,
              6561.014
            ],
            [
              -2630.036,
              -1958.048,
              6621.398
            ],
            [
              -2627.177,
              -1869.041,
              6710.451
            ],
            [
              -2627.347,
              -1805.585,
              6773.907
            ],
            [
              -2628.381,
              -1791.095,
              6788.434
            ],
            [
              -2639.18,
              -1781.999,
              6802.553
            ],
            [
              -2733.191,
              -1775.889,
              6896.763
            ],
            [
              -2793.887,
              -1781.5,
              6957.718
            ],
            [
              -2841.812,
              -1794.015,
              7007.25
            ],
            [
              -2868.748,
              -1805.2,
              7036.416
            ],
            [
              -2934.027,
              -1832.47,
              7107.162
            ],
            [
              -3144.971,
              -1987.959,
              7369.219
            ],
            [
              -3184.69,
              -2010.641,
              7414.959
            ],
            [
              -3221.031,
              -2024.476,
              7453.844
            ],
            [
              -3255.341,
              -2032.781,
              7489.145
            ],
            [
              -3305.078,
              -2038.591,
              7539.22
            ],
            [
              -3365.672,
              -2038.645,
              7599.814
            ],
            [
              -3370.713,
              -1991.384,
              7647.343
            ],
            [
              -3374.974,
              -1943.859,
              7695.059
            ],
            [
              -3391.774,
              -1872.32,
              7768.544
            ],
            [
              -3430.979,
              -1754.748,
              7892.48
            ],
            [
              -3480.186,
              -1619.191,
              8036.692
            ],
            [
              -3508.003,
              -1550.799,
              8110.525
            ],
            [
              -3521.109,
              -1520.135,
              8143.872
            ],
            [
              -3534.455,
              -1477.979,
              8188.09
            ],
            [
              -3620.717,
              -1211.532,
              8468.153
            ],
            [
              -3662.686,
              -1103.933,
              8583.647
            ],
            [
              -3677.364,
              -1066.903,
              8623.481
            ],
            [
              -3685.368,
              -1042.059,
              8649.582
            ],
            [
              -3720.918,
              -930.373,
              8766.789
            ],
            [
              -3751.424,
              -837.404,
              8864.635
            ],
            [
              -3758.325,
              -817.25,
              8885.938
            ],
            [
              -3766.218,
              -791.548,
              8912.824
            ],
            [
              -3793.988,
              -719.82,
              8989.74
            ],
            [
              -3843.779,
              -616.54,
              9104.396
            ],
            [
              -3881.258,
              -546.871,
              9183.506
            ],
            [
              -3968.352,
              -399.129,
              9355.009
            ],
            [
              -3983.006,
              -376.666,
              9381.829
            ],
            [
              -3999.719,
              -350.005,
              9413.295
            ],
            [
              -4048.201,
              -282.373,
              9496.51
            ],
            [
              -4133.499,
              -180.709,
              9629.217
            ],
            [
              -4196.231,
              -117.271,
              9718.434
            ],
            [
              -4217.103,
              -95.271,
              9748.759
            ],
            [
              -4243.751,
              -67.483,
              9787.26
            ],
            [
              -4402.336,
              85.535,
              10007.632
            ],
            [
              -4449.086,
              142,
              10080.939
            ],
            [
              -4479.797,
              193.736,
              10141.103
            ],
            [
              -4502.905,
              237.549,
              10190.637
            ],
            [
              -4519.036,
              274.562,
              10231.012
            ],
            [
              -4536.228,
              324.952,
              10284.254
            ],
            [
              -4547.048,
              370.78,
              10331.342
            ],
            [
              -4566.578,
              510.266,
              10472.189
            ],
            [
              -4570.606,
              537.669,
              10499.886
            ],
            [
              -4575.517,
              590.57,
              10553.015
            ],
            [
              -4579.623,
              651.866,
              10614.448
            ],
            [
              -4586.366,
              709.869,
              10672.842
            ],
            [
              -4584.541,
              741.007,
              10704.033
            ],
            [
              -4573.306,
              794.248,
              10758.447
            ],
            [
              -4555.909,
              830.684,
              10798.823
            ],
            [
              -4554.824,
              856.269,
              10824.431
            ],
            [
              -4566.917,
              903.232,
              10872.926
            ],
            [
              -4569.191,
              921.082,
              10890.92
            ],
            [
              -4557.807,
              945.377,
              10917.75
            ],
            [
              -4520.63,
              969.228,
              10961.92
            ],
            [
              -4517.8,
              981.449,
              10974.465
            ],
            [
              -4524.608,
              1000.466,
              10994.663
            ],
            [
              -4563.16,
              1046.77,
              11054.916
            ],
            [
              -4607.63,
              1086.496,
              11114.546
            ],
            [
              -4747.102,
              1153.456,
              11269.258
            ],
            [
              -4804.625,
              1184.498,
              11334.623
            ],
            [
              -4849.214,
              1217.545,
              11390.123
            ],
            [
              -4874.57,
              1243.583,
              11426.467
            ],
            [
              -4893.428,
              1253.165,
              11447.62
            ],
            [
              -4923.976,
              1296.749,
              11500.844
            ],
            [
              -4964.695,
              1367.577,
              11582.542
            ],
            [
              -4983.262,
              1413.535,
              11632.109
            ],
            [
              -4991.189,
              1440.387,
              11660.107
            ],
            [
              -5000.423,
              1503.997,
              11724.383
            ],
            [
              -5002.868,
              1549.68,
              11770.132
            ],
            [
              -5001.995,
              1563.024,
              11783.504
            ],
            [
              -4994.33,
              1596.289,
              11817.641
            ],
            [
              -4987.652,
              1609.533,
              11832.473
            ],
            [
              -4906.917,
              1690.529,
              11946.835
            ],
            [
              -4842.797,
              1742.865,
              12029.602
            ],
            [
              -4801.101,
              1766.641,
              12077.6
            ],
            [
              -4774.467,
              1777.316,
              12106.294
            ],
            [
              -4728.427,
              1790.998,
              12154.324
            ],
            [
              -4687.68,
              1796.979,
              12195.508
            ],
            [
              -4579.155,
              1805.134,
              12304.339
            ],
            [
              -4546.833,
              1810.069,
              12337.035
            ],
            [
              -4518.395,
              1811.882,
              12365.531
            ],
            [
              -4369.14,
              1824.898,
              12515.352
            ],
            [
              -4282.619,
              1828.972,
              12601.969
            ],
            [
              -4232.446,
              1820.314,
              12652.884
            ],
            [
              -4165.014,
              1802.452,
              12722.641
            ],
            [
              -4141.304,
              1793.136,
              12748.116
            ],
            [
              -4122.773,
              1782.797,
              12769.336
            ],
            [
              -4070.589,
              1735.287,
              12839.907
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:7589",
              "position": {
                "x": 1524.687,
                "z": -2513.037
              },
              "distanceAlongShapeM": 134.748,
              "shapeOffsetM": 2.608,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:5606",
              "position": {
                "x": 1696.386,
                "z": -2638.684
              },
              "distanceAlongShapeM": 409.252,
              "shapeOffsetM": 3.836,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:6667",
              "position": {
                "x": 1709.563,
                "z": -3177.741
              },
              "distanceAlongShapeM": 948.917,
              "shapeOffsetM": 2.22,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:6668",
              "position": {
                "x": 1582.257,
                "z": -3473.726
              },
              "distanceAlongShapeM": 1273.468,
              "shapeOffsetM": 2.969,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:5154",
              "position": {
                "x": 1342.825,
                "z": -3805.485
              },
              "distanceAlongShapeM": 1686.301,
              "shapeOffsetM": 0.632,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:5022",
              "position": {
                "x": 1084.896,
                "z": -3640.407
              },
              "distanceAlongShapeM": 2101.421,
              "shapeOffsetM": 3.346,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:5127",
              "position": {
                "x": 945.685,
                "z": -3186.974
              },
              "distanceAlongShapeM": 2614.019,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:5131",
              "position": {
                "x": 442.304,
                "z": -2978.453
              },
              "distanceAlongShapeM": 3173.356,
              "shapeOffsetM": 0.484,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:8463",
              "position": {
                "x": -121.383,
                "z": -2752.193
              },
              "distanceAlongShapeM": 3790.728,
              "shapeOffsetM": 4.261,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:6937",
              "position": {
                "x": -1450.559,
                "z": -2473.275
              },
              "distanceAlongShapeM": 5181.283,
              "shapeOffsetM": 3.921,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:19157",
              "position": {
                "x": -2402.929,
                "z": -2274.874
              },
              "distanceAlongShapeM": 6164.16,
              "shapeOffsetM": 2.249,
              "arrivalOffsetSeconds": 1380,
              "departureOffsetSeconds": 1380
            },
            {
              "stopId": "judu:stop:16691",
              "position": {
                "x": -2636.896,
                "z": -2018.041
              },
              "distanceAlongShapeM": 6561.014,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1500,
              "departureOffsetSeconds": 1500
            },
            {
              "stopId": "judu:stop:5613",
              "position": {
                "x": -2867.844,
                "z": -1808.029
              },
              "distanceAlongShapeM": 7036.672,
              "shapeOffsetM": 2.959,
              "arrivalOffsetSeconds": 1620,
              "departureOffsetSeconds": 1620
            },
            {
              "stopId": "judu:stop:5620",
              "position": {
                "x": -3375.166,
                "z": -1991.724
              },
              "distanceAlongShapeM": 7647.402,
              "shapeOffsetM": 4.466,
              "arrivalOffsetSeconds": 1740,
              "departureOffsetSeconds": 1740
            },
            {
              "stopId": "judu:stop:928",
              "position": {
                "x": -3525.544,
                "z": -1521.55
              },
              "distanceAlongShapeM": 8143.872,
              "shapeOffsetM": 4.655,
              "arrivalOffsetSeconds": 1860,
              "departureOffsetSeconds": 1860
            },
            {
              "stopId": "judu:stop:5643",
              "position": {
                "x": -3680.758,
                "z": -1067.996
              },
              "distanceAlongShapeM": 8623.481,
              "shapeOffsetM": 3.566,
              "arrivalOffsetSeconds": 1980,
              "departureOffsetSeconds": 1980
            },
            {
              "stopId": "judu:stop:5646",
              "position": {
                "x": -3761.526,
                "z": -818.346
              },
              "distanceAlongShapeM": 8885.938,
              "shapeOffsetM": 3.383,
              "arrivalOffsetSeconds": 2040,
              "departureOffsetSeconds": 2040
            },
            {
              "stopId": "judu:stop:5651",
              "position": {
                "x": -3986.683,
                "z": -379.175
              },
              "distanceAlongShapeM": 9381.737,
              "shapeOffsetM": 4.451,
              "arrivalOffsetSeconds": 2100,
              "departureOffsetSeconds": 2100
            },
            {
              "stopId": "judu:stop:5656",
              "position": {
                "x": -4221.08,
                "z": -99.045
              },
              "distanceAlongShapeM": 9748.789,
              "shapeOffsetM": 5.483,
              "arrivalOffsetSeconds": 2160,
              "departureOffsetSeconds": 2160
            },
            {
              "stopId": "judu:stop:5668",
              "position": {
                "x": -4574.501,
                "z": 537.119
              },
              "distanceAlongShapeM": 10499.886,
              "shapeOffsetM": 3.934,
              "arrivalOffsetSeconds": 2280,
              "departureOffsetSeconds": 2280
            },
            {
              "stopId": "judu:stop:16703",
              "position": {
                "x": -4563.16,
                "z": 1046.77
              },
              "distanceAlongShapeM": 11054.916,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2400,
              "departureOffsetSeconds": 2400
            },
            {
              "stopId": "judu:stop:5672",
              "position": {
                "x": -4893.764,
                "z": 1252.817
              },
              "distanceAlongShapeM": 11447.62,
              "shapeOffsetM": 0.484,
              "arrivalOffsetSeconds": 2460,
              "departureOffsetSeconds": 2460
            },
            {
              "stopId": "judu:stop:5691",
              "position": {
                "x": -4547.361,
                "z": 1815.72
              },
              "distanceAlongShapeM": 12337.035,
              "shapeOffsetM": 5.676,
              "arrivalOffsetSeconds": 2580,
              "departureOffsetSeconds": 2580
            },
            {
              "stopId": "judu:stop:5693",
              "position": {
                "x": -4066.123,
                "z": 1738.403
              },
              "distanceAlongShapeM": 12839.907,
              "shapeOffsetM": 5.445,
              "arrivalOffsetSeconds": 2640,
              "departureOffsetSeconds": 2640
            }
          ],
          "departuresSeconds": [
            18540,
            19500,
            20400,
            21300,
            22020,
            22740,
            23460,
            24180,
            24720,
            25320,
            25860,
            26400,
            26940,
            27480,
            28200,
            28920,
            29640,
            30540,
            31440,
            32340,
            33300,
            34260,
            35220,
            36180,
            37080,
            38040,
            39000,
            39960,
            40740,
            41580,
            42360,
            43260,
            44160,
            45120,
            46020,
            46920,
            47760,
            48540,
            49320,
            50220,
            51060,
            51840,
            52620,
            53400,
            54180,
            54900,
            55620,
            56340,
            57060,
            57660,
            58200,
            58800,
            59400,
            60120,
            60840,
            61560,
            62280,
            63060,
            63900,
            64740,
            65700,
            66720,
            67860,
            69000,
            69960,
            70860,
            71760,
            72660,
            73500,
            74340,
            75180,
            76020,
            76860,
            77700,
            78540,
            79380,
            80160,
            81000,
            81840,
            82680,
            83580
          ]
        },
        {
          "id": "judu:pattern:vilnius_bus_7:1",
          "sourceRouteId": "vilnius_bus_7",
          "sourceShapeId": "vilnius_bus_7_b-a",
          "directionId": 1,
          "headsign": "Šiaurės miestelis",
          "directionName": "Lazdynai–Viršuliškės–Verkių g.–Šiaurės miestelis",
          "mode": "bus",
          "routeShortName": "7",
          "routeLongName": "Šiaurės miestelis–Verkių g.–Viršuliškės–Lazdynai",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              -4070.589,
              1735.287,
              0
            ],
            [
              -4047.235,
              1694.122,
              47.329
            ],
            [
              -4037.796,
              1664.197,
              78.707
            ],
            [
              -4021.405,
              1600.417,
              144.559
            ],
            [
              -3992.198,
              1462.162,
              285.866
            ],
            [
              -3985.157,
              1436.356,
              312.615
            ],
            [
              -3986.154,
              1438.68,
              315.143
            ],
            [
              -3973.348,
              1390.702,
              364.801
            ],
            [
              -3971.11,
              1376.08,
              379.593
            ],
            [
              -3953.873,
              1291.178,
              466.227
            ],
            [
              -3953.633,
              1267.797,
              489.609
            ],
            [
              -3919.363,
              1123.6,
              637.823
            ],
            [
              -3889.289,
              1035.135,
              731.26
            ],
            [
              -3881.018,
              1009.279,
              758.407
            ],
            [
              -3879.245,
              944.791,
              822.919
            ],
            [
              -3886.86,
              914.867,
              853.797
            ],
            [
              -3898.384,
              892.134,
              879.283
            ],
            [
              -3911.432,
              874.104,
              901.54
            ],
            [
              -3948.102,
              842.457,
              949.978
            ],
            [
              -4089.107,
              782.559,
              1103.177
            ],
            [
              -4161.662,
              727.04,
              1194.537
            ],
            [
              -4178.229,
              714.534,
              1215.295
            ],
            [
              -4216.46,
              691.251,
              1260.057
            ],
            [
              -4255.439,
              676.425,
              1301.76
            ],
            [
              -4279.313,
              674.524,
              1325.71
            ],
            [
              -4304.422,
              677.184,
              1350.96
            ],
            [
              -4330.724,
              685.43,
              1378.524
            ],
            [
              -4370.887,
              712.839,
              1427.148
            ],
            [
              -4391.801,
              734.351,
              1457.151
            ],
            [
              -4418.25,
              771.542,
              1502.788
            ],
            [
              -4423.862,
              782.771,
              1515.341
            ],
            [
              -4434.781,
              784.705,
              1526.43
            ],
            [
              -4479.393,
              779.274,
              1571.371
            ],
            [
              -4503.366,
              773.007,
              1596.15
            ],
            [
              -4524.836,
              762.245,
              1620.166
            ],
            [
              -4546.478,
              741.466,
              1650.169
            ],
            [
              -4558.582,
              712.731,
              1681.349
            ],
            [
              -4564.028,
              688.195,
              1706.482
            ],
            [
              -4562.176,
              653.793,
              1740.934
            ],
            [
              -4542.083,
              471.996,
              1923.838
            ],
            [
              -4535.565,
              436.694,
              1959.736
            ],
            [
              -4533.311,
              419.524,
              1977.054
            ],
            [
              -4527.744,
              368.221,
              2028.658
            ],
            [
              -4516.259,
              323.495,
              2074.835
            ],
            [
              -4491.638,
              255.166,
              2147.465
            ],
            [
              -4427.619,
              152.763,
              2268.232
            ],
            [
              -4367.011,
              77.134,
              2365.15
            ],
            [
              -4080.333,
              -210.913,
              2771.543
            ],
            [
              -3954.469,
              -380.846,
              2983.012
            ],
            [
              -3926.158,
              -422.036,
              3032.993
            ],
            [
              -3919.036,
              -433.74,
              3046.694
            ],
            [
              -3857.936,
              -540.596,
              3169.785
            ],
            [
              -3823.641,
              -607.984,
              3245.398
            ],
            [
              -3766.483,
              -732.543,
              3382.445
            ],
            [
              -3707.64,
              -908.34,
              3567.829
            ],
            [
              -3695.741,
              -928.584,
              3591.311
            ],
            [
              -3679.687,
              -950.175,
              3618.216
            ],
            [
              -3673.878,
              -969.04,
              3637.955
            ],
            [
              -3654.555,
              -1007.226,
              3680.752
            ],
            [
              -3618.264,
              -1069.098,
              3752.481
            ],
            [
              -3599.031,
              -1113.947,
              3801.281
            ],
            [
              -3569.469,
              -1193.5,
              3886.149
            ],
            [
              -3554.873,
              -1243.849,
              3938.571
            ],
            [
              -3546.348,
              -1270.446,
              3966.5
            ],
            [
              -3520.478,
              -1415.883,
              4114.221
            ],
            [
              -3500.646,
              -1498.607,
              4199.289
            ],
            [
              -3461.302,
              -1608.388,
              4315.907
            ],
            [
              -3438.975,
              -1658.872,
              4371.108
            ],
            [
              -3424.066,
              -1696.754,
              4411.818
            ],
            [
              -3409.647,
              -1735.195,
              4452.874
            ],
            [
              -3354.323,
              -1899.889,
              4626.613
            ],
            [
              -3343.31,
              -1954.868,
              4682.683
            ],
            [
              -3339.232,
              -2037.994,
              4765.909
            ],
            [
              -3303.125,
              -2037.512,
              4802.02
            ],
            [
              -3264.382,
              -2033.736,
              4840.946
            ],
            [
              -3221.031,
              -2024.476,
              4885.275
            ],
            [
              -3174.263,
              -2004.144,
              4936.272
            ],
            [
              -3125.366,
              -1972.718,
              4994.397
            ],
            [
              -2913.056,
              -1818.539,
              5256.783
            ],
            [
              -2889.736,
              -1806.531,
              5283.013
            ],
            [
              -2844.844,
              -1789.915,
              5330.882
            ],
            [
              -2788.35,
              -1776.706,
              5388.899
            ],
            [
              -2751.709,
              -1771.873,
              5425.857
            ],
            [
              -2703.468,
              -1771.96,
              5474.099
            ],
            [
              -2639.18,
              -1781.999,
              5539.166
            ],
            [
              -2627.658,
              -1786.655,
              5551.593
            ],
            [
              -2624.007,
              -1798.964,
              5564.432
            ],
            [
              -2631.168,
              -1949.123,
              5714.762
            ],
            [
              -2631.119,
              -2055.992,
              5821.631
            ],
            [
              -2625.902,
              -2086.22,
              5852.306
            ],
            [
              -2619.378,
              -2113.776,
              5880.624
            ],
            [
              -2575.188,
              -2210.603,
              5987.058
            ],
            [
              -2562.457,
              -2219.734,
              6002.725
            ],
            [
              -2509.617,
              -2220.667,
              6055.573
            ],
            [
              -2432.042,
              -2227.602,
              6133.457
            ],
            [
              -2417.854,
              -2231.757,
              6148.241
            ],
            [
              -2373.845,
              -2246.595,
              6194.684
            ],
            [
              -2196.773,
              -2317.488,
              6385.42
            ],
            [
              -2137.794,
              -2339.218,
              6448.276
            ],
            [
              -2015.246,
              -2367.466,
              6574.037
            ],
            [
              -1889.653,
              -2373.04,
              6699.753
            ],
            [
              -1756.388,
              -2382.093,
              6833.325
            ],
            [
              -1647.51,
              -2385.149,
              6942.246
            ],
            [
              -1597.953,
              -2389.374,
              6991.983
            ],
            [
              -1522.821,
              -2405.189,
              7068.762
            ],
            [
              -1485.023,
              -2418.11,
              7108.707
            ],
            [
              -1375.913,
              -2480.178,
              7234.236
            ],
            [
              -1328.533,
              -2508.869,
              7289.625
            ],
            [
              -1293.411,
              -2533.191,
              7332.347
            ],
            [
              -1235.733,
              -2570.637,
              7401.114
            ],
            [
              -1150.916,
              -2621.142,
              7499.829
            ],
            [
              -1079.915,
              -2651.362,
              7576.994
            ],
            [
              -1012.681,
              -2675.949,
              7648.583
            ],
            [
              -916.353,
              -2695.496,
              7746.874
            ],
            [
              -830.758,
              -2702.605,
              7832.764
            ],
            [
              -592.882,
              -2700.223,
              8070.652
            ],
            [
              -320.273,
              -2701.823,
              8343.265
            ],
            [
              -192.234,
              -2714.168,
              8471.898
            ],
            [
              11.208,
              -2748.6,
              8678.233
            ],
            [
              66.553,
              -2763.639,
              8735.585
            ],
            [
              144.816,
              -2787.102,
              8817.29
            ],
            [
              177.432,
              -2801.056,
              8852.765
            ],
            [
              222.629,
              -2831.939,
              8907.506
            ],
            [
              331.278,
              -2917.419,
              9045.75
            ],
            [
              357.389,
              -2934.595,
              9077.004
            ],
            [
              386.802,
              -2947.379,
              9109.075
            ],
            [
              425.203,
              -2957.314,
              9148.74
            ],
            [
              460.267,
              -2963.644,
              9184.371
            ],
            [
              521.193,
              -2964.305,
              9245.301
            ],
            [
              532.037,
              -2970.195,
              9257.641
            ],
            [
              600.884,
              -2980.955,
              9327.323
            ],
            [
              619.319,
              -2990.605,
              9348.132
            ],
            [
              631.438,
              -2997.507,
              9362.078
            ],
            [
              906.98,
              -3153.977,
              9678.948
            ],
            [
              1026.951,
              -3218.53,
              9815.183
            ],
            [
              1027.41,
              -3228.558,
              9825.222
            ],
            [
              1043.901,
              -3277.845,
              9877.194
            ],
            [
              1066.366,
              -3362.988,
              9965.251
            ],
            [
              1066.595,
              -3375.116,
              9977.381
            ],
            [
              1098.437,
              -3500.388,
              10106.637
            ],
            [
              1100.082,
              -3516.004,
              10122.339
            ],
            [
              1093.2,
              -3739.235,
              10345.676
            ],
            [
              1117.238,
              -3769.584,
              10384.392
            ],
            [
              1132.841,
              -3780.616,
              10403.5
            ],
            [
              1147.08,
              -3797.41,
              10425.518
            ],
            [
              1219.986,
              -3862.213,
              10523.062
            ],
            [
              1375.611,
              -3774.922,
              10701.496
            ],
            [
              1393.375,
              -3755.212,
              10728.03
            ],
            [
              1412.221,
              -3746.656,
              10748.727
            ],
            [
              1509.877,
              -3564.24,
              10955.638
            ],
            [
              1556.885,
              -3486.613,
              11046.39
            ],
            [
              1610.18,
              -3392.177,
              11154.826
            ],
            [
              1620.009,
              -3384.254,
              11167.451
            ],
            [
              1689.847,
              -3267.548,
              11303.457
            ],
            [
              1697.306,
              -3247.648,
              11324.709
            ],
            [
              1696.944,
              -3128.524,
              11443.833
            ],
            [
              1692.78,
              -3098.159,
              11474.483
            ],
            [
              1691.952,
              -3068.3,
              11504.353
            ],
            [
              1688.435,
              -2754.314,
              11818.359
            ],
            [
              1682.19,
              -2639.533,
              11933.309
            ],
            [
              1680.853,
              -2611.627,
              11961.247
            ],
            [
              1680.619,
              -2598.143,
              11974.734
            ],
            [
              1670.987,
              -2586.136,
              11990.127
            ],
            [
              1656.786,
              -2584.511,
              12004.42
            ],
            [
              1622.02,
              -2584.755,
              12039.187
            ],
            [
              1614.3,
              -2581.496,
              12047.567
            ],
            [
              1426.817,
              -2576.903,
              12235.106
            ],
            [
              1419.812,
              -2572.32,
              12243.477
            ],
            [
              1406.874,
              -2540.387,
              12277.931
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:5693",
              "position": {
                "x": -4066.123,
                "z": 1738.403
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 5.445,
              "arrivalOffsetSeconds": -300,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:5697",
              "position": {
                "x": -3968.906,
                "z": 1391.627
              },
              "distanceAlongShapeM": 364.801,
              "shapeOffsetM": 4.537,
              "arrivalOffsetSeconds": 60,
              "departureOffsetSeconds": 60
            },
            {
              "stopId": "judu:stop:5701",
              "position": {
                "x": -3876.172,
                "z": 1010.417
              },
              "distanceAlongShapeM": 758.407,
              "shapeOffsetM": 4.978,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:5704",
              "position": {
                "x": -4175.491,
                "z": 710.581
              },
              "distanceAlongShapeM": 1215.295,
              "shapeOffsetM": 4.809,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:1071",
              "position": {
                "x": -4530.426,
                "z": 437.286
              },
              "distanceAlongShapeM": 1959.819,
              "shapeOffsetM": 5.172,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:1004",
              "position": {
                "x": -4077.229,
                "z": -208.399
              },
              "distanceAlongShapeM": 2771.543,
              "shapeOffsetM": 3.995,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:6649",
              "position": {
                "x": -3921.604,
                "z": -419.265
              },
              "distanceAlongShapeM": 3032.993,
              "shapeOffsetM": 5.33,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:6643",
              "position": {
                "x": -3679.35,
                "z": -950.021
              },
              "distanceAlongShapeM": 3618.216,
              "shapeOffsetM": 0.37,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:4990",
              "position": {
                "x": -3543.073,
                "z": -1269.659
              },
              "distanceAlongShapeM": 3966.5,
              "shapeOffsetM": 3.368,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:5722",
              "position": {
                "x": -3418.974,
                "z": -1694.844
              },
              "distanceAlongShapeM": 4411.818,
              "shapeOffsetM": 5.439,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:5619",
              "position": {
                "x": -3340.35,
                "z": -1954.483
              },
              "distanceAlongShapeM": 4682.683,
              "shapeOffsetM": 2.984,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:5614",
              "position": {
                "x": -2788.614,
                "z": -1774.913
              },
              "distanceAlongShapeM": 5388.899,
              "shapeOffsetM": 1.813,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            },
            {
              "stopId": "judu:stop:16692",
              "position": {
                "x": -2621.319,
                "z": -2085.109
              },
              "distanceAlongShapeM": 5851.99,
              "shapeOffsetM": 4.706,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:1069",
              "position": {
                "x": -2415.576,
                "z": -2224.555
              },
              "distanceAlongShapeM": 6148.241,
              "shapeOffsetM": 7.553,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:7017",
              "position": {
                "x": -1324.1,
                "z": -2502.258
              },
              "distanceAlongShapeM": 7289.625,
              "shapeOffsetM": 7.96,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            },
            {
              "stopId": "judu:stop:5080",
              "position": {
                "x": 12.173,
                "z": -2744.606
              },
              "distanceAlongShapeM": 8678.233,
              "shapeOffsetM": 4.109,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            },
            {
              "stopId": "judu:stop:6846",
              "position": {
                "x": 602.169,
                "z": -2976.932
              },
              "distanceAlongShapeM": 9327.323,
              "shapeOffsetM": 4.223,
              "arrivalOffsetSeconds": 1560,
              "departureOffsetSeconds": 1560
            },
            {
              "stopId": "judu:stop:6847",
              "position": {
                "x": 1066.821,
                "z": -3362.875
              },
              "distanceAlongShapeM": 9965.251,
              "shapeOffsetM": 0.469,
              "arrivalOffsetSeconds": 1740,
              "departureOffsetSeconds": 1740
            },
            {
              "stopId": "judu:stop:5147",
              "position": {
                "x": 1133.882,
                "z": -3779.354
              },
              "distanceAlongShapeM": 10403.5,
              "shapeOffsetM": 1.636,
              "arrivalOffsetSeconds": 1800,
              "departureOffsetSeconds": 1800
            },
            {
              "stopId": "judu:stop:5149",
              "position": {
                "x": 1393.375,
                "z": -3755.212
              },
              "distanceAlongShapeM": 10728.03,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1860,
              "departureOffsetSeconds": 1860
            },
            {
              "stopId": "judu:stop:5086",
              "position": {
                "x": 1607.644,
                "z": -3390.704
              },
              "distanceAlongShapeM": 11154.826,
              "shapeOffsetM": 2.933,
              "arrivalOffsetSeconds": 1980,
              "departureOffsetSeconds": 1980
            },
            {
              "stopId": "judu:stop:5087",
              "position": {
                "x": 1687.839,
                "z": -3098.296
              },
              "distanceAlongShapeM": 11474.483,
              "shapeOffsetM": 4.943,
              "arrivalOffsetSeconds": 2040,
              "departureOffsetSeconds": 2040
            },
            {
              "stopId": "judu:stop:5013",
              "position": {
                "x": 1621.888,
                "z": -2589.429
              },
              "distanceAlongShapeM": 12039.187,
              "shapeOffsetM": 4.676,
              "arrivalOffsetSeconds": 2160,
              "departureOffsetSeconds": 2160
            },
            {
              "stopId": "judu:stop:15167",
              "position": {
                "x": 1413.343,
                "z": -2538.803
              },
              "distanceAlongShapeM": 12276.97,
              "shapeOffsetM": 6.59,
              "arrivalOffsetSeconds": 2220,
              "departureOffsetSeconds": 2220
            }
          ],
          "departuresSeconds": [
            19140,
            19860,
            20580,
            21120,
            21600,
            22080,
            22560,
            23040,
            23580,
            24120,
            24720,
            25440,
            26160,
            26880,
            27540,
            28200,
            28800,
            29400,
            30000,
            30600,
            31320,
            32040,
            32820,
            33720,
            34560,
            35400,
            36300,
            37200,
            38160,
            39000,
            39960,
            40920,
            41940,
            42840,
            43680,
            44520,
            45300,
            46140,
            47100,
            48120,
            49080,
            50100,
            51060,
            51780,
            52560,
            53460,
            54360,
            55020,
            55740,
            56460,
            57240,
            57960,
            58740,
            59460,
            60180,
            60780,
            61380,
            61980,
            62700,
            63420,
            64200,
            64980,
            65760,
            66540,
            67320,
            68160,
            69000,
            69960,
            70980,
            72000,
            72960,
            73800,
            74640,
            75480,
            76320,
            77160,
            78000,
            78900,
            79860,
            80940,
            82020,
            82920,
            83760
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_bus_8",
      "sourceRouteId": "vilnius_bus_8",
      "mode": "bus",
      "shortName": "8",
      "longName": "Žemieji Paneriai–Aukštieji Paneriai–Vaidotai",
      "color": "0073AC",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_bus_8:0",
          "sourceRouteId": "vilnius_bus_8",
          "sourceShapeId": "vilnius_bus_8_a-b",
          "directionId": 0,
          "headsign": "Vaidotai",
          "directionName": "Žemieji Paneriai–Aukštieji Paneriai–Vaidotai",
          "mode": "bus",
          "routeShortName": "8",
          "routeLongName": "Žemieji Paneriai–Aukštieji Paneriai–Vaidotai",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              -4326.297,
              4774.12,
              0
            ],
            [
              -4336.239,
              4784.086,
              14.077
            ],
            [
              -4346.108,
              4793.98,
              28.052
            ],
            [
              -4357.093,
              4810.287,
              47.714
            ],
            [
              -4404.75,
              4854.522,
              112.736
            ],
            [
              -4468.845,
              4919.076,
              203.705
            ],
            [
              -4486.139,
              4928.009,
              223.17
            ],
            [
              -4510.925,
              4949.856,
              256.21
            ],
            [
              -4579.258,
              4993.33,
              337.2
            ],
            [
              -4600.366,
              5004.825,
              361.235
            ],
            [
              -4835.366,
              5155.793,
              640.549
            ],
            [
              -5032.11,
              5279.379,
              872.889
            ],
            [
              -5271.713,
              5427.062,
              1154.349
            ],
            [
              -5460.164,
              5546.035,
              1377.213
            ],
            [
              -5507.478,
              5573.554,
              1431.948
            ],
            [
              -5539.526,
              5587.456,
              1466.881
            ],
            [
              -5570.341,
              5597.997,
              1499.449
            ],
            [
              -5599.939,
              5604.064,
              1529.663
            ],
            [
              -5632.195,
              5605.723,
              1561.962
            ],
            [
              -5666.482,
              5601.851,
              1596.466
            ],
            [
              -5724.289,
              5581.678,
              1657.692
            ],
            [
              -5767.933,
              5559.039,
              1706.859
            ],
            [
              -5844.413,
              5503.558,
              1801.343
            ],
            [
              -5862.75,
              5488.283,
              1825.209
            ],
            [
              -5911.642,
              5422.317,
              1907.318
            ],
            [
              -5931.13,
              5377.005,
              1956.643
            ],
            [
              -5950.367,
              5308.312,
              2027.979
            ],
            [
              -5960.48,
              5282.88,
              2055.348
            ],
            [
              -5972.455,
              5261.931,
              2079.478
            ],
            [
              -5985.57,
              5249.907,
              2097.271
            ],
            [
              -6003.755,
              5243.534,
              2116.54
            ],
            [
              -6024.466,
              5240.544,
              2137.466
            ],
            [
              -6043.418,
              5245.327,
              2157.012
            ],
            [
              -6066.047,
              5261.363,
              2184.747
            ],
            [
              -6086.896,
              5290.575,
              2220.636
            ],
            [
              -6284.365,
              5565.511,
              2559.138
            ],
            [
              -6384.618,
              5670.718,
              2704.463
            ],
            [
              -6399.757,
              5685.605,
              2725.694
            ],
            [
              -6425.222,
              5713.7,
              2763.613
            ],
            [
              -6633.66,
              5914.22,
              3052.844
            ],
            [
              -6722.128,
              5991.393,
              3170.242
            ],
            [
              -6612.351,
              6454.122,
              3645.814
            ],
            [
              -6608.72,
              6475.702,
              3667.699
            ],
            [
              -6607.431,
              6481.884,
              3674.013
            ],
            [
              -6604.935,
              6487.334,
              3680.007
            ],
            [
              -6606.674,
              6481.348,
              3686.241
            ],
            [
              -6607.79,
              6475.997,
              3691.707
            ],
            [
              -6609.451,
              6468.03,
              3699.845
            ],
            [
              -6612.772,
              6452.1,
              3716.117
            ],
            [
              -6653.627,
              6265.205,
              3907.426
            ],
            [
              -6722.128,
              5991.393,
              4189.676
            ],
            [
              -6750.44,
              6004.56,
              4220.901
            ],
            [
              -6809.039,
              6038.832,
              4288.786
            ],
            [
              -6882.79,
              6076.446,
              4371.575
            ],
            [
              -6955.867,
              6108.831,
              4451.506
            ],
            [
              -7039.365,
              6135.823,
              4539.259
            ],
            [
              -7206.108,
              6166.42,
              4708.786
            ],
            [
              -7774.707,
              6263.751,
              5285.655
            ],
            [
              -7867.343,
              6285.312,
              5380.767
            ],
            [
              -8047.971,
              6336.143,
              5568.411
            ],
            [
              -8098.629,
              6343.525,
              5619.604
            ],
            [
              -8217.003,
              6398.476,
              5750.111
            ],
            [
              -8626.991,
              6549.307,
              6186.963
            ],
            [
              -8792.345,
              6604.692,
              6361.347
            ],
            [
              -8874.082,
              6622.063,
              6444.908
            ],
            [
              -8982.049,
              6627.08,
              6552.992
            ],
            [
              -8997.056,
              6618.566,
              6570.245
            ],
            [
              -9013.93,
              6623.266,
              6587.762
            ],
            [
              -9016.342,
              6639.281,
              6603.958
            ],
            [
              -9018.873,
              6651.963,
              6616.89
            ],
            [
              -9005.179,
              6664.131,
              6635.209
            ],
            [
              -9000.031,
              6680.014,
              6651.906
            ],
            [
              -8987.422,
              6704.318,
              6679.285
            ],
            [
              -8845.746,
              7014.942,
              7020.693
            ],
            [
              -8802.47,
              7117.645,
              7132.142
            ],
            [
              -8787.862,
              7152.128,
              7169.591
            ],
            [
              -8783.058,
              7159.63,
              7178.5
            ],
            [
              -8763.058,
              7190.747,
              7215.49
            ],
            [
              -8468.88,
              7057.676,
              7538.365
            ],
            [
              -8276.156,
              6969.013,
              7750.505
            ],
            [
              -8239.13,
              6972.01,
              7787.653
            ],
            [
              -8137.056,
              6990.613,
              7891.408
            ],
            [
              -8136.692,
              6997.097,
              7897.902
            ],
            [
              -8131.694,
              7014.312,
              7915.829
            ],
            [
              -8118.947,
              7011.23,
              7928.943
            ],
            [
              -8098.509,
              7013.839,
              7949.546
            ],
            [
              -7967.56,
              7190.464,
              8169.42
            ],
            [
              -7898.354,
              7287.522,
              8288.624
            ],
            [
              -7860.12,
              7353.836,
              8365.171
            ],
            [
              -7733.341,
              7557.445,
              8605.024
            ],
            [
              -7651.053,
              7675.899,
              8749.255
            ],
            [
              -7535.576,
              7834.992,
              8945.84
            ],
            [
              -7370.398,
              8056.782,
              9222.381
            ],
            [
              -7280.724,
              8175.572,
              9371.218
            ],
            [
              -7287.938,
              8167.034,
              9382.395
            ],
            [
              -7273.153,
              8179.39,
              9401.664
            ],
            [
              -6944.155,
              8394.148,
              9794.551
            ],
            [
              -6484.668,
              8683.541,
              10337.577
            ],
            [
              -6061.821,
              8921.037,
              10822.555
            ],
            [
              -5941.967,
              8981.29,
              10956.702
            ],
            [
              -5871.728,
              9014.994,
              11034.609
            ],
            [
              -5617.109,
              9207.728,
              11353.948
            ],
            [
              -5372.483,
              9419.541,
              11677.532
            ],
            [
              -5390.005,
              9437.184,
              11702.397
            ],
            [
              -5440.968,
              9483.181,
              11771.048
            ],
            [
              -5440.881,
              9483.155,
              11771.138
            ],
            [
              -5481.837,
              9489.048,
              11812.516
            ],
            [
              -5545.139,
              9489.258,
              11875.818
            ],
            [
              -5626.626,
              9511.091,
              11960.18
            ],
            [
              -5665.918,
              9536.631,
              12007.043
            ],
            [
              -5758.358,
              9606.406,
              12122.86
            ],
            [
              -5990.709,
              9775.16,
              12410.028
            ],
            [
              -6015.502,
              9793.234,
              12440.709
            ],
            [
              -6051.294,
              9819.463,
              12485.083
            ],
            [
              -6392.311,
              10068.737,
              12907.492
            ],
            [
              -6411.379,
              10089.811,
              12935.913
            ],
            [
              -6418.418,
              10102.262,
              12950.216
            ],
            [
              -6415.455,
              10100.097,
              12953.886
            ],
            [
              -6411.468,
              10093.291,
              12961.773
            ],
            [
              -6400.197,
              10079.006,
              12979.97
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:5567",
              "position": {
                "x": -4488.111,
                "z": 4924.973
              },
              "distanceAlongShapeM": 223.17,
              "shapeOffsetM": 3.62,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:5728",
              "position": {
                "x": -6069.366,
                "z": 5257.998
              },
              "distanceAlongShapeM": 2184.747,
              "shapeOffsetM": 4.727,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:5732",
              "position": {
                "x": -6403.151,
                "z": 5682.161
              },
              "distanceAlongShapeM": 2725.694,
              "shapeOffsetM": 4.835,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:9967",
              "position": {
                "x": -6701.294,
                "z": 6078.986
              },
              "distanceAlongShapeM": 3260.279,
              "shapeOffsetM": 0.052,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:8784",
              "position": {
                "x": -6615.878,
                "z": 6476.078
              },
              "distanceAlongShapeM": 3666.881,
              "shapeOffsetM": 7.122,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:5738",
              "position": {
                "x": -6754.294,
                "z": 5998.609
              },
              "distanceAlongShapeM": 4221.223,
              "shapeOffsetM": 7.082,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:5742",
              "position": {
                "x": -8100.928,
                "z": 6335.897
              },
              "distanceAlongShapeM": 5619.604,
              "shapeOffsetM": 7.967,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:6450",
              "position": {
                "x": -8792.189,
                "z": 7154.212
              },
              "distanceAlongShapeM": 7169.591,
              "shapeOffsetM": 4.803,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:5747",
              "position": {
                "x": -8076.884,
                "z": 7054.61
              },
              "distanceAlongShapeM": 7995.178,
              "shapeOffsetM": 6.91,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:5750",
              "position": {
                "x": -7651.984,
                "z": 7676.571
              },
              "distanceAlongShapeM": 8749.255,
              "shapeOffsetM": 1.148,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:9727",
              "position": {
                "x": -7283.86,
                "z": 8179.212
              },
              "distanceAlongShapeM": 9371.218,
              "shapeOffsetM": 4.805,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:9773",
              "position": {
                "x": -5443.232,
                "z": 9477.513
              },
              "distanceAlongShapeM": 11768.931,
              "shapeOffsetM": 5.725,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:5756",
              "position": {
                "x": -6020.289,
                "z": 9786.701
              },
              "distanceAlongShapeM": 12440.709,
              "shapeOffsetM": 8.099,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            },
            {
              "stopId": "judu:stop:3575",
              "position": {
                "x": -6388.113,
                "z": 10090.091
              },
              "distanceAlongShapeM": 12978.753,
              "shapeOffsetM": 16.353,
              "arrivalOffsetSeconds": 1380,
              "departureOffsetSeconds": 1380
            }
          ],
          "departuresSeconds": [
            24840,
            28020,
            30240,
            34560,
            36840,
            38460,
            40680,
            42540,
            44820,
            46500,
            48540,
            50580,
            52800,
            55320,
            57900,
            60300,
            63000,
            66780,
            69360,
            71460,
            73560,
            75660,
            77760,
            79680,
            81660
          ]
        },
        {
          "id": "judu:pattern:vilnius_bus_8:1",
          "sourceRouteId": "vilnius_bus_8",
          "sourceShapeId": "vilnius_bus_8_b-a",
          "directionId": 1,
          "headsign": "Žemieji Paneriai",
          "directionName": "Vaidotai–Aukštieji Paneriai–Žemieji Paneriai",
          "mode": "bus",
          "routeShortName": "8",
          "routeLongName": "Žemieji Paneriai–Aukštieji Paneriai–Vaidotai",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              -6400.197,
              10079.006,
              0
            ],
            [
              -6365.061,
              10049.218,
              46.064
            ],
            [
              -6357.837,
              10044.073,
              54.933
            ],
            [
              -6339.089,
              10028.46,
              79.33
            ],
            [
              -5957.236,
              9753.921,
              549.632
            ],
            [
              -5658.167,
              9531.244,
              922.495
            ],
            [
              -5627.131,
              9511.363,
              959.353
            ],
            [
              -5583.581,
              9494.281,
              1006.134
            ],
            [
              -5516.116,
              9488.249,
              1073.868
            ],
            [
              -5468.239,
              9489.069,
              1121.751
            ],
            [
              -5399.943,
              9475.92,
              1191.302
            ],
            [
              -5385.05,
              9478.753,
              1206.462
            ],
            [
              -5379.273,
              9476.428,
              1212.689
            ],
            [
              -5152.703,
              9663.529,
              1506.527
            ],
            [
              -5090.079,
              9707.207,
              1582.878
            ],
            [
              -5041.367,
              9640.752,
              1665.275
            ],
            [
              -5033.294,
              9630.749,
              1678.128
            ],
            [
              -5018.812,
              9636.023,
              1693.541
            ],
            [
              -5006.788,
              9638.184,
              1705.757
            ],
            [
              -4954.279,
              9679.721,
              1772.709
            ],
            [
              -4945.89,
              9689.466,
              1785.568
            ],
            [
              -4944.386,
              9707.346,
              1803.51
            ],
            [
              -4947.439,
              9717.68,
              1814.287
            ],
            [
              -4955.042,
              9725.062,
              1824.884
            ],
            [
              -4958.813,
              9727.535,
              1829.393
            ],
            [
              -4971.063,
              9729.938,
              1841.876
            ],
            [
              -5097.983,
              9638.625,
              1998.231
            ],
            [
              -5372.483,
              9419.541,
              2349.44
            ],
            [
              -5517.025,
              9279.504,
              2550.693
            ],
            [
              -5790.95,
              9053.706,
              2905.686
            ],
            [
              -5877.861,
              8996.174,
              3009.914
            ],
            [
              -6281.878,
              8793.689,
              3461.832
            ],
            [
              -6394.741,
              8730.026,
              3591.411
            ],
            [
              -6495.171,
              8673.698,
              3706.56
            ],
            [
              -6572.283,
              8621.554,
              3799.647
            ],
            [
              -6659.083,
              8569.571,
              3900.823
            ],
            [
              -6721.945,
              8519.413,
              3981.243
            ],
            [
              -6878.686,
              8418.499,
              4167.66
            ],
            [
              -6969.617,
              8361.457,
              4275.002
            ],
            [
              -7007.98,
              8312.884,
              4336.897
            ],
            [
              -7055.112,
              8260.021,
              4407.721
            ],
            [
              -7156.647,
              8138.64,
              4565.969
            ],
            [
              -7194.121,
              8097.577,
              4621.562
            ],
            [
              -7222.723,
              8086.919,
              4652.085
            ],
            [
              -7245.9,
              8091.756,
              4675.761
            ],
            [
              -7295.779,
              8122.637,
              4734.426
            ],
            [
              -7314.897,
              8138.538,
              4759.292
            ],
            [
              -7328.822,
              8115.077,
              4786.575
            ],
            [
              -7420.735,
              7988.896,
              4942.682
            ],
            [
              -7537.283,
              7832.677,
              5137.587
            ],
            [
              -7697.089,
              7604.958,
              5415.785
            ],
            [
              -7745.971,
              7538.045,
              5498.651
            ],
            [
              -7771.966,
              7490.42,
              5552.908
            ],
            [
              -7815.057,
              7423.225,
              5632.733
            ],
            [
              -7839.736,
              7375.765,
              5686.226
            ],
            [
              -7882.861,
              7306.344,
              5767.952
            ],
            [
              -7952.066,
              7213.809,
              5883.502
            ],
            [
              -8017.894,
              7125.727,
              5993.465
            ],
            [
              -8076.478,
              7051.316,
              6088.171
            ],
            [
              -8098.162,
              7014.136,
              6131.212
            ],
            [
              -8098.091,
              7003.781,
              6141.567
            ],
            [
              -8100.342,
              6993.071,
              6152.511
            ],
            [
              -8105.69,
              6979.831,
              6166.791
            ],
            [
              -8113.131,
              6975.266,
              6175.52
            ],
            [
              -8125.314,
              6976.369,
              6187.753
            ],
            [
              -8130.718,
              6978.786,
              6193.673
            ],
            [
              -8138.348,
              6982.337,
              6202.089
            ],
            [
              -8146.49,
              6983.685,
              6210.342
            ],
            [
              -8275.618,
              6968.767,
              6340.328
            ],
            [
              -8331.528,
              6994.229,
              6401.763
            ],
            [
              -8763.058,
              7190.747,
              6875.933
            ],
            [
              -8807.889,
              7102.148,
              6975.228
            ],
            [
              -8834.518,
              7039.61,
              7043.2
            ],
            [
              -8870.194,
              6964.013,
              7126.792
            ],
            [
              -8903.405,
              6886.77,
              7210.872
            ],
            [
              -8943.948,
              6799.652,
              7306.962
            ],
            [
              -8950.76,
              6764.189,
              7343.073
            ],
            [
              -8929.156,
              6743.653,
              7372.881
            ],
            [
              -8872.538,
              6700.223,
              7444.236
            ],
            [
              -8798.467,
              6647.824,
              7534.968
            ],
            [
              -8640.476,
              6573.211,
              7709.692
            ],
            [
              -8605.888,
              6555.057,
              7748.754
            ],
            [
              -8387.496,
              6464.144,
              7985.313
            ],
            [
              -8217.003,
              6398.476,
              8168.016
            ],
            [
              -8093.947,
              6355.277,
              8298.435
            ],
            [
              -8047.971,
              6336.143,
              8348.233
            ],
            [
              -7869.852,
              6289.806,
              8532.28
            ],
            [
              -7783.654,
              6269.464,
              8620.846
            ],
            [
              -7104.955,
              6152.496,
              9309.55
            ],
            [
              -7039.365,
              6135.823,
              9377.226
            ],
            [
              -6990.505,
              6122.766,
              9427.801
            ],
            [
              -6923.128,
              6097.155,
              9499.881
            ],
            [
              -6819.933,
              6050.909,
              9612.965
            ],
            [
              -6722.128,
              5991.393,
              9727.455
            ],
            [
              -6612.351,
              6454.122,
              10203.027
            ],
            [
              -6608.72,
              6475.702,
              10224.911
            ],
            [
              -6607.431,
              6481.884,
              10231.226
            ],
            [
              -6604.935,
              6487.334,
              10237.22
            ],
            [
              -6606.674,
              6481.348,
              10243.454
            ],
            [
              -6607.79,
              6475.997,
              10248.92
            ],
            [
              -6609.451,
              6468.03,
              10257.057
            ],
            [
              -6612.772,
              6452.1,
              10273.33
            ],
            [
              -6653.627,
              6265.205,
              10464.639
            ],
            [
              -6722.128,
              5991.393,
              10746.889
            ],
            [
              -6667.814,
              5949.093,
              10815.732
            ],
            [
              -6413.106,
              5704.591,
              11168.8
            ],
            [
              -6357.16,
              5652.447,
              11245.279
            ],
            [
              -6339.044,
              5634.784,
              11270.581
            ],
            [
              -6315.93,
              5608.341,
              11305.702
            ],
            [
              -6284.365,
              5565.511,
              11358.907
            ],
            [
              -6235.578,
              5510.146,
              11432.7
            ],
            [
              -6210.778,
              5487.465,
              11466.307
            ],
            [
              -6170.561,
              5460.073,
              11514.967
            ],
            [
              -6118.615,
              5439.162,
              11570.964
            ],
            [
              -6089.662,
              5433.109,
              11600.543
            ],
            [
              -6052.281,
              5429.14,
              11638.134
            ],
            [
              -6005.048,
              5435.024,
              11685.732
            ],
            [
              -5948.573,
              5452.996,
              11744.997
            ],
            [
              -5873.554,
              5498.484,
              11832.73
            ],
            [
              -5789.253,
              5558.286,
              11936.088
            ],
            [
              -5728.563,
              5596.222,
              12007.659
            ],
            [
              -5697.335,
              5610.165,
              12041.859
            ],
            [
              -5669.446,
              5617.486,
              12070.693
            ],
            [
              -5631.932,
              5621.303,
              12108.4
            ],
            [
              -5582.93,
              5617.134,
              12157.579
            ],
            [
              -5526.428,
              5598.366,
              12217.117
            ],
            [
              -5379.437,
              5509.043,
              12389.12
            ],
            [
              -4710.592,
              5090.204,
              13178.284
            ],
            [
              -4580.889,
              5011.17,
              13330.169
            ],
            [
              -4518.9,
              4977.81,
              13400.565
            ],
            [
              -4380.813,
              4857.45,
              13583.744
            ],
            [
              -4298.311,
              4774.766,
              13700.548
            ],
            [
              -4237.94,
              4719.179,
              13782.612
            ],
            [
              -4229.781,
              4705.68,
              13798.385
            ],
            [
              -4240.925,
              4695.853,
              13813.243
            ],
            [
              -4266.982,
              4719.679,
              13848.551
            ],
            [
              -4289.168,
              4743.439,
              13881.059
            ],
            [
              -4306.085,
              4753.859,
              13900.928
            ],
            [
              -4314.059,
              4761.853,
              13912.219
            ],
            [
              -4326.297,
              4774.12,
              13929.546
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:3575",
              "position": {
                "x": -6388.113,
                "z": 10090.091
              },
              "distanceAlongShapeM": 2.049,
              "shapeOffsetM": 16.269,
              "arrivalOffsetSeconds": -600,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:5757",
              "position": {
                "x": -5956.85,
                "z": 9754.465
              },
              "distanceAlongShapeM": 549.628,
              "shapeOffsetM": 0.667,
              "arrivalOffsetSeconds": 60,
              "departureOffsetSeconds": 60
            },
            {
              "stopId": "judu:stop:9201",
              "position": {
                "x": -5153.129,
                "z": 9664.054
              },
              "distanceAlongShapeM": 1506.527,
              "shapeOffsetM": 0.676,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:9726",
              "position": {
                "x": -7321.189,
                "z": 8109.7
              },
              "distanceAlongShapeM": 4786.575,
              "shapeOffsetM": 9.336,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:5751",
              "position": {
                "x": -7697.089,
                "z": 7604.958
              },
              "distanceAlongShapeM": 5415.785,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:7910",
              "position": {
                "x": -8333.045,
                "z": 6990.897
              },
              "distanceAlongShapeM": 6401.763,
              "shapeOffsetM": 3.661,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:9115",
              "position": {
                "x": -8830.889,
                "z": 7037.958
              },
              "distanceAlongShapeM": 7043.2,
              "shapeOffsetM": 3.987,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:9776",
              "position": {
                "x": -8090.106,
                "z": 6365.775
              },
              "distanceAlongShapeM": 8298.435,
              "shapeOffsetM": 11.179,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:9967",
              "position": {
                "x": -6701.294,
                "z": 6078.986
              },
              "distanceAlongShapeM": 9817.492,
              "shapeOffsetM": 0.052,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:357",
              "position": {
                "x": -6598.614,
                "z": 6465.771
              },
              "distanceAlongShapeM": 10257.057,
              "shapeOffsetM": 11.07,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:4410",
              "position": {
                "x": -6663.331,
                "z": 5954.79
              },
              "distanceAlongShapeM": 10815.732,
              "shapeOffsetM": 7.249,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:5731",
              "position": {
                "x": -6334.791,
                "z": 5638.714
              },
              "distanceAlongShapeM": 11270.581,
              "shapeOffsetM": 5.79,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:6850",
              "position": {
                "x": -4517.509,
                "z": 4980.025
              },
              "distanceAlongShapeM": 13400.565,
              "shapeOffsetM": 2.616,
              "arrivalOffsetSeconds": 1380,
              "departureOffsetSeconds": 1380
            }
          ],
          "departuresSeconds": [
            19860,
            22560,
            25260,
            27300,
            30180,
            32340,
            36420,
            38580,
            40740,
            42480,
            44400,
            46560,
            48420,
            50400,
            52860,
            55260,
            57240,
            60180,
            62460,
            65100,
            68820,
            71400,
            73500,
            75600,
            77760,
            79620,
            81420,
            83400
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_bus_9",
      "sourceRouteId": "vilnius_bus_9",
      "mode": "bus",
      "shortName": "9",
      "longName": "Zuikių–Agrastų g.–Baltoji Vokė–Vaidotai",
      "color": "0073AC",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_bus_9:0",
          "sourceRouteId": "vilnius_bus_9",
          "sourceShapeId": "vilnius_bus_9_a1-b1",
          "directionId": 0,
          "headsign": "Salininkai",
          "directionName": "Zuikių–Agrastų g.–Salininkai",
          "mode": "bus",
          "routeShortName": "9",
          "routeLongName": "Zuikių–Agrastų g.–Baltoji Vokė–Vaidotai",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              -5023.415,
              6328.479,
              0
            ],
            [
              -5028.3,
              6333.984,
              7.359
            ],
            [
              -5044.689,
              6366.848,
              44.084
            ],
            [
              -5083.859,
              6448.368,
              134.526
            ],
            [
              -5104.54,
              6479.113,
              171.579
            ],
            [
              -5143.303,
              6498.231,
              214.8
            ],
            [
              -5205.356,
              6522.406,
              281.396
            ],
            [
              -5224.598,
              6546.241,
              312.029
            ],
            [
              -5243.249,
              6581.895,
              352.267
            ],
            [
              -5257.73,
              6598.885,
              374.591
            ],
            [
              -5341.347,
              6658.041,
              477.017
            ],
            [
              -5352.926,
              6663.415,
              489.782
            ],
            [
              -5374.753,
              6666.494,
              511.825
            ],
            [
              -5432.048,
              6657.189,
              569.871
            ],
            [
              -5502.725,
              6652.078,
              640.733
            ],
            [
              -5525.809,
              6657.245,
              664.388
            ],
            [
              -5545.344,
              6667.071,
              686.255
            ],
            [
              -5577.068,
              6691.207,
              726.118
            ],
            [
              -5581.281,
              6705.801,
              741.307
            ],
            [
              -5581.323,
              6718.976,
              754.482
            ],
            [
              -5575.343,
              6751.341,
              787.395
            ],
            [
              -5546.737,
              6835.948,
              876.707
            ],
            [
              -5513.536,
              6889.105,
              939.381
            ],
            [
              -5474.664,
              6944.54,
              1007.086
            ],
            [
              -5406.327,
              7012.113,
              1103.191
            ],
            [
              -5350.09,
              7172.565,
              1273.212
            ],
            [
              -5320.629,
              7267.998,
              1373.089
            ],
            [
              -5331.188,
              7315.389,
              1421.642
            ],
            [
              -5369.345,
              7401.216,
              1515.57
            ],
            [
              -5386.891,
              7418.523,
              1540.214
            ],
            [
              -5412.673,
              7443.57,
              1576.16
            ],
            [
              -5546.455,
              7354.083,
              1737.113
            ],
            [
              -6210.588,
              6898.687,
              2542.381
            ],
            [
              -6300.719,
              6838.7,
              2650.65
            ],
            [
              -6382.587,
              6782.495,
              2749.955
            ],
            [
              -6405.301,
              6765.807,
              2778.14
            ],
            [
              -6426.565,
              6754.658,
              2802.149
            ],
            [
              -6453.912,
              6738.306,
              2834.012
            ],
            [
              -6457.935,
              6729.468,
              2843.723
            ],
            [
              -6458.102,
              6719.452,
              2853.74
            ],
            [
              -6452.481,
              6706.199,
              2868.136
            ],
            [
              -6391.771,
              6697.684,
              2929.44
            ],
            [
              -6384.938,
              6696.832,
              2936.327
            ],
            [
              -6386.089,
              6696.973,
              2937.487
            ],
            [
              -6398.531,
              6698.536,
              2950.026
            ],
            [
              -6413.467,
              6700.472,
              2965.088
            ],
            [
              -6447.085,
              6705.307,
              2999.051
            ],
            [
              -6456.72,
              6706.919,
              3008.82
            ],
            [
              -6459.487,
              6713.909,
              3016.338
            ],
            [
              -6426.19,
              6928.195,
              3233.195
            ],
            [
              -6396.062,
              7145.873,
              3452.948
            ],
            [
              -6388.153,
              7171.22,
              3479.501
            ],
            [
              -6375.131,
              7200.068,
              3511.152
            ],
            [
              -6358.142,
              7222.607,
              3539.377
            ],
            [
              -6247.601,
              7285.616,
              3666.614
            ],
            [
              -6216.391,
              7304.42,
              3703.051
            ],
            [
              -6198.31,
              7320.89,
              3727.509
            ],
            [
              -6185.607,
              7337.979,
              3748.802
            ],
            [
              -6173.264,
              7367.904,
              3781.173
            ],
            [
              -6163.748,
              7402.46,
              3817.015
            ],
            [
              -6149.889,
              7496.847,
              3912.414
            ],
            [
              -6148.739,
              7526.884,
              3942.473
            ],
            [
              -6150.43,
              7591.567,
              4007.178
            ],
            [
              -6154.824,
              7626.059,
              4041.949
            ],
            [
              -6179.16,
              7715.522,
              4134.663
            ],
            [
              -6181.746,
              7764.261,
              4183.47
            ],
            [
              -6169.802,
              7797.336,
              4218.636
            ],
            [
              -6135.491,
              7853.936,
              4284.823
            ],
            [
              -6112.139,
              7898.07,
              4334.755
            ],
            [
              -6097.978,
              7933.454,
              4372.867
            ],
            [
              -6084.013,
              7995.557,
              4436.521
            ],
            [
              -6073.613,
              8177.903,
              4619.163
            ],
            [
              -6068.013,
              8201.186,
              4643.11
            ],
            [
              -6058.273,
              8219.986,
              4664.284
            ],
            [
              -6040.423,
              8244.176,
              4694.346
            ],
            [
              -5980.162,
              8289.839,
              4769.954
            ],
            [
              -5946.236,
              8312.721,
              4810.875
            ],
            [
              -5919.379,
              8334.532,
              4845.473
            ],
            [
              -5887.851,
              8365.169,
              4889.435
            ],
            [
              -5837.16,
              8421.087,
              4964.91
            ],
            [
              -5801.091,
              8452.76,
              5012.911
            ],
            [
              -5757.214,
              8487.642,
              5068.964
            ],
            [
              -5746.673,
              8499.709,
              5084.987
            ],
            [
              -5728.174,
              8523.886,
              5115.429
            ],
            [
              -5719.083,
              8541.078,
              5134.876
            ],
            [
              -5682.214,
              8605.485,
              5209.09
            ],
            [
              -5636.103,
              8718.33,
              5330.992
            ],
            [
              -5627.146,
              8767.078,
              5380.556
            ],
            [
              -5612.863,
              8820.352,
              5435.712
            ],
            [
              -5575.366,
              8868.996,
              5497.13
            ],
            [
              -5449.08,
              8980.02,
              5665.281
            ],
            [
              -5321.224,
              9089.169,
              5833.39
            ],
            [
              -5164.382,
              9093.505,
              5990.292
            ],
            [
              -5027.774,
              9098.543,
              6126.993
            ],
            [
              -4919.79,
              9102.916,
              6235.065
            ],
            [
              -4855.784,
              9100.167,
              6299.13
            ],
            [
              -4643.297,
              9063.34,
              6514.785
            ],
            [
              -4619.899,
              9067.578,
              6538.564
            ],
            [
              -4613.812,
              9076.546,
              6549.403
            ],
            [
              -4607.651,
              9098.704,
              6572.402
            ],
            [
              -4601.07,
              9106.941,
              6582.944
            ],
            [
              -4518.84,
              9078.815,
              6669.852
            ],
            [
              -4238.18,
              9009.869,
              6958.856
            ],
            [
              -4087.776,
              8932.251,
              7128.107
            ],
            [
              -3845.638,
              8757.253,
              7426.863
            ],
            [
              -3716.049,
              8636.15,
              7604.231
            ],
            [
              -3697.804,
              8616.039,
              7631.384
            ],
            [
              -3661.015,
              8576.44,
              7685.435
            ],
            [
              -3619.725,
              8535.648,
              7743.477
            ],
            [
              -3591.691,
              8512.898,
              7779.581
            ],
            [
              -2877.571,
              8652.622,
              8507.241
            ],
            [
              -2205.592,
              8779.166,
              9191.032
            ],
            [
              -2160.179,
              8789.495,
              9237.605
            ],
            [
              -2145.869,
              8794.808,
              9252.869
            ],
            [
              -2111.689,
              8827.6,
              9300.236
            ],
            [
              -2031.993,
              8998.547,
              9488.847
            ],
            [
              -1968.13,
              9125.624,
              9631.069
            ],
            [
              -1958.452,
              9139.024,
              9647.598
            ],
            [
              -1929.991,
              9162.797,
              9684.682
            ],
            [
              -1618.698,
              9225.174,
              10002.163
            ],
            [
              -1566.4,
              9238.022,
              10056.016
            ],
            [
              -1337.536,
              9280.082,
              10288.713
            ],
            [
              -974.554,
              9283.037,
              10651.707
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:9303",
              "position": {
                "x": -5024.685,
                "z": 6320.084
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 8.491,
              "arrivalOffsetSeconds": -450,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:9308",
              "position": {
                "x": -5545.775,
                "z": 7353.073
              },
              "distanceAlongShapeM": 1737.123,
              "shapeOffsetM": 1.218,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:9311",
              "position": {
                "x": -6208.433,
                "z": 6895.6
              },
              "distanceAlongShapeM": 2542.35,
              "shapeOffsetM": 3.765,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:7189",
              "position": {
                "x": -6401.347,
                "z": 6676.2
              },
              "distanceAlongShapeM": 2950.026,
              "shapeOffsetM": 22.513,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:7188",
              "position": {
                "x": -5722.041,
                "z": 8542.707
              },
              "distanceAlongShapeM": 5134.876,
              "shapeOffsetM": 3.377,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:6975",
              "position": {
                "x": -3713.566,
                "z": 8638.576
              },
              "distanceAlongShapeM": 7604.231,
              "shapeOffsetM": 3.471,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:4706",
              "position": {
                "x": -2877.847,
                "z": 8654.069
              },
              "distanceAlongShapeM": 8507.241,
              "shapeOffsetM": 1.473,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:6972",
              "position": {
                "x": -2032.412,
                "z": 8998.744
              },
              "distanceAlongShapeM": 9488.847,
              "shapeOffsetM": 0.463,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:6257",
              "position": {
                "x": -1566.739,
                "z": 9239.834
              },
              "distanceAlongShapeM": 10056.016,
              "shapeOffsetM": 1.843,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:6253",
              "position": {
                "x": -974.57,
                "z": 9288.252
              },
              "distanceAlongShapeM": 10651.707,
              "shapeOffsetM": 5.215,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            }
          ],
          "departuresSeconds": [
            23280,
            26820,
            30720,
            33960,
            39660,
            42960,
            46260,
            49500,
            53460,
            56400,
            60960,
            65340,
            71280,
            74700,
            78060,
            81420
          ]
        },
        {
          "id": "judu:pattern:vilnius_bus_9:1",
          "sourceRouteId": "vilnius_bus_9",
          "sourceShapeId": "vilnius_bus_9_b1-a1",
          "directionId": 1,
          "headsign": "Zuikių g.",
          "directionName": "Salininkai–Agrastų–Zuikių g.",
          "mode": "bus",
          "routeShortName": "9",
          "routeLongName": "Zuikių–Agrastų g.–Baltoji Vokė–Vaidotai",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              -974.554,
              9283.037,
              0
            ],
            [
              -970.748,
              9283.049,
              3.805
            ],
            [
              -956.601,
              9281.251,
              18.067
            ],
            [
              -947.577,
              9279.976,
              27.18
            ],
            [
              -933.324,
              9281.946,
              41.569
            ],
            [
              -928.339,
              9290.732,
              51.671
            ],
            [
              -928.412,
              9305.619,
              66.558
            ],
            [
              -905.066,
              9281.708,
              99.977
            ],
            [
              -888.329,
              9281.708,
              116.714
            ],
            [
              -880.696,
              9281.708,
              124.347
            ],
            [
              -878.878,
              9281.708,
              126.165
            ],
            [
              -878.978,
              9281.708,
              126.265
            ],
            [
              -881.622,
              9281.708,
              128.909
            ],
            [
              -888.748,
              9281.146,
              136.057
            ],
            [
              -908.755,
              9281.708,
              156.072
            ],
            [
              -979.944,
              9280.133,
              227.279
            ],
            [
              -1100.766,
              9279.883,
              348.101
            ],
            [
              -1238.935,
              9284.4,
              486.343
            ],
            [
              -1306.849,
              9281.954,
              554.302
            ],
            [
              -1341.168,
              9278.114,
              588.835
            ],
            [
              -1472.788,
              9253.745,
              722.692
            ],
            [
              -1539.363,
              9240.213,
              790.629
            ],
            [
              -1618.698,
              9225.174,
              871.376
            ],
            [
              -1909.16,
              9171.333,
              1166.786
            ],
            [
              -1929.991,
              9162.797,
              1189.298
            ],
            [
              -1953.562,
              9145.403,
              1218.592
            ],
            [
              -1966.778,
              9128.939,
              1239.704
            ],
            [
              -1992.214,
              9079.296,
              1295.484
            ],
            [
              -2048.725,
              8956.22,
              1430.914
            ],
            [
              -2094.779,
              8856.705,
              1540.569
            ],
            [
              -2113.142,
              8822.964,
              1578.984
            ],
            [
              -2119.588,
              8814.928,
              1589.285
            ],
            [
              -2130.035,
              8808.909,
              1601.341
            ],
            [
              -2137.374,
              8800.224,
              1612.712
            ],
            [
              -2151.227,
              8791.906,
              1628.871
            ],
            [
              -2170.376,
              8785.553,
              1649.046
            ],
            [
              -2742.154,
              8675.804,
              2231.262
            ],
            [
              -3334.939,
              8564.092,
              2834.481
            ],
            [
              -3591.691,
              8512.898,
              3096.287
            ],
            [
              -3607.502,
              8520.077,
              3113.651
            ],
            [
              -3656.717,
              8569.961,
              3183.727
            ],
            [
              -3845.638,
              8757.253,
              3449.752
            ],
            [
              -4086.157,
              8935.096,
              3748.88
            ],
            [
              -4170.263,
              8982.654,
              3845.501
            ],
            [
              -4253.103,
              9008.836,
              3932.38
            ],
            [
              -4417.136,
              9055.919,
              4103.036
            ],
            [
              -4502.747,
              9075.199,
              4190.791
            ],
            [
              -4565.123,
              9092.967,
              4255.649
            ],
            [
              -4587.077,
              9094.255,
              4277.64
            ],
            [
              -4594.877,
              9091.251,
              4285.999
            ],
            [
              -4611.236,
              9079.286,
              4306.266
            ],
            [
              -4617.039,
              9070.705,
              4316.626
            ],
            [
              -4625.008,
              9064.328,
              4326.831
            ],
            [
              -4639.951,
              9063.025,
              4341.832
            ],
            [
              -4853.743,
              9099.83,
              4558.768
            ],
            [
              -5239.068,
              9092.497,
              4944.163
            ],
            [
              -5294.083,
              9090.398,
              4999.218
            ],
            [
              -5309.238,
              9099.427,
              5016.859
            ],
            [
              -5477.622,
              8956.44,
              5237.762
            ],
            [
              -5556.53,
              8889.028,
              5341.545
            ],
            [
              -5592.36,
              8855.965,
              5390.299
            ],
            [
              -5612.863,
              8820.352,
              5431.393
            ],
            [
              -5631.713,
              8738.153,
              5515.725
            ],
            [
              -5661.076,
              8643.492,
              5614.835
            ],
            [
              -5687.47,
              8592.338,
              5672.398
            ],
            [
              -5735.366,
              8508.182,
              5769.228
            ],
            [
              -5794.863,
              8455.078,
              5848.978
            ],
            [
              -5928.01,
              8324.736,
              6035.303
            ],
            [
              -5966.351,
              8295.88,
              6083.29
            ],
            [
              -6010.377,
              8267.136,
              6135.868
            ],
            [
              -6040.423,
              8244.176,
              6173.682
            ],
            [
              -6063.172,
              8205.333,
              6218.697
            ],
            [
              -6071.686,
              8172.861,
              6252.266
            ],
            [
              -6076.086,
              8121.213,
              6304.101
            ],
            [
              -6085.445,
              7973.635,
              6451.976
            ],
            [
              -6095.054,
              7936.346,
              6490.483
            ],
            [
              -6126.775,
              7866.244,
              6567.428
            ],
            [
              -6172.088,
              7785.169,
              6660.306
            ],
            [
              -6180.175,
              7752.468,
              6693.993
            ],
            [
              -6177.574,
              7705.594,
              6740.939
            ],
            [
              -6160.994,
              7649.324,
              6799.6
            ],
            [
              -6147.267,
              7586.85,
              6863.565
            ],
            [
              -6145.749,
              7534.6,
              6915.837
            ],
            [
              -6164.488,
              7396.906,
              7054.8
            ],
            [
              -6182.714,
              7337.328,
              7117.104
            ],
            [
              -6226.3,
              7294.451,
              7178.244
            ],
            [
              -6283.058,
              7266.551,
              7241.488
            ],
            [
              -6325.252,
              7243.583,
              7289.529
            ],
            [
              -6355.368,
              7223.114,
              7325.943
            ],
            [
              -6373.235,
              7205.151,
              7351.279
            ],
            [
              -6394.017,
              7141.55,
              7418.189
            ],
            [
              -6407.034,
              7069.248,
              7491.653
            ],
            [
              -6458.596,
              6710.843,
              7853.748
            ],
            [
              -6442.713,
              6704.673,
              7870.787
            ],
            [
              -6395.791,
              6699.484,
              7917.995
            ],
            [
              -6384.649,
              6696.796,
              7929.456
            ],
            [
              -6379.085,
              6696.112,
              7935.063
            ],
            [
              -6378.27,
              6696.012,
              7935.884
            ],
            [
              -6380.757,
              6696.318,
              7938.39
            ],
            [
              -6398.531,
              6698.536,
              7956.302
            ],
            [
              -6419.366,
              6701.315,
              7977.321
            ],
            [
              -6455.297,
              6706.677,
              8013.65
            ],
            [
              -6459.561,
              6709.458,
              8018.741
            ],
            [
              -6460.086,
              6718.149,
              8027.447
            ],
            [
              -6456.569,
              6733.897,
              8043.584
            ],
            [
              -6406.958,
              6765.349,
              8102.324
            ],
            [
              -5616.991,
              7307.392,
              9060.373
            ],
            [
              -5412.673,
              7443.57,
              9305.915
            ],
            [
              -5379.538,
              7411.736,
              9351.864
            ],
            [
              -5355.856,
              7373.719,
              9396.654
            ],
            [
              -5320.266,
              7279.022,
              9497.818
            ],
            [
              -5366.68,
              7116.055,
              9667.265
            ],
            [
              -5383.906,
              7062.695,
              9723.337
            ],
            [
              -5408.235,
              7009.511,
              9781.822
            ],
            [
              -5434.756,
              6981.876,
              9820.124
            ],
            [
              -5484.996,
              6930.949,
              9891.661
            ],
            [
              -5544.326,
              6842.651,
              9998.041
            ],
            [
              -5565.414,
              6774.602,
              10069.283
            ],
            [
              -5579.858,
              6734.998,
              10111.438
            ],
            [
              -5581.791,
              6708.034,
              10138.471
            ],
            [
              -5578.67,
              6695.332,
              10151.551
            ],
            [
              -5557.056,
              6674.387,
              10181.649
            ],
            [
              -5521.419,
              6655.807,
              10221.838
            ],
            [
              -5495.632,
              6651.765,
              10247.94
            ],
            [
              -5483.93,
              6652.671,
              10259.677
            ],
            [
              -5397.109,
              6662.8,
              10347.087
            ],
            [
              -5365.139,
              6666.155,
              10379.233
            ],
            [
              -5301.574,
              6633.152,
              10450.854
            ],
            [
              -5260.783,
              6601.289,
              10502.615
            ],
            [
              -5236.658,
              6573.196,
              10539.645
            ],
            [
              -5224.744,
              6546.662,
              10568.732
            ],
            [
              -5217.407,
              6531.534,
              10585.545
            ],
            [
              -5207.157,
              6522.565,
              10599.164
            ],
            [
              -5183.511,
              6512.033,
              10625.05
            ],
            [
              -5134.082,
              6494.493,
              10677.499
            ],
            [
              -5107.193,
              6480.677,
              10707.73
            ],
            [
              -5083.399,
              6447.527,
              10748.535
            ],
            [
              -5062.357,
              6406.059,
              10795.037
            ],
            [
              -5040.257,
              6355.693,
              10850.038
            ],
            [
              -5029.135,
              6334.612,
              10873.873
            ],
            [
              -5014.961,
              6326.539,
              10890.185
            ],
            [
              -5004.175,
              6322.849,
              10901.584
            ],
            [
              -4994.839,
              6319.729,
              10911.427
            ],
            [
              -4987.322,
              6317.735,
              10919.204
            ],
            [
              -4987.203,
              6316.824,
              10920.123
            ],
            [
              -4993.093,
              6318.387,
              10926.216
            ],
            [
              -5002.121,
              6320.239,
              10935.433
            ],
            [
              -5021.26,
              6327.433,
              10955.879
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:6254",
              "position": {
                "x": -1100.805,
                "z": 9276.043
              },
              "distanceAlongShapeM": 348.101,
              "shapeOffsetM": 3.84,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:9003",
              "position": {
                "x": -1669.285,
                "z": 9214.942
              },
              "distanceAlongShapeM": 922.98,
              "shapeOffsetM": 0.841,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:6973",
              "position": {
                "x": -2047.392,
                "z": 8955.594
              },
              "distanceAlongShapeM": 1430.922,
              "shapeOffsetM": 1.472,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:4705",
              "position": {
                "x": -2935.628,
                "z": 8638.383
              },
              "distanceAlongShapeM": 2428.319,
              "shapeOffsetM": 0.943,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:6974",
              "position": {
                "x": -3746.2,
                "z": 8656.953
              },
              "distanceAlongShapeM": 3308.52,
              "shapeOffsetM": 1.221,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:7187",
              "position": {
                "x": -5734.269,
                "z": 8507.291
              },
              "distanceAlongShapeM": 5769.228,
              "shapeOffsetM": 1.414,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:7189",
              "position": {
                "x": -6401.347,
                "z": 6676.2
              },
              "distanceAlongShapeM": 7956.302,
              "shapeOffsetM": 22.513,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:9312",
              "position": {
                "x": -6105.124,
                "z": 6970.674
              },
              "distanceAlongShapeM": 8467.372,
              "shapeOffsetM": 1.469,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:9310",
              "position": {
                "x": -5616.326,
                "z": 7306.401
              },
              "distanceAlongShapeM": 9060.361,
              "shapeOffsetM": 1.194,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            },
            {
              "stopId": "judu:stop:9303",
              "position": {
                "x": -5024.685,
                "z": 6320.084
              },
              "distanceAlongShapeM": 10955.879,
              "shapeOffsetM": 8.108,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            }
          ],
          "departuresSeconds": [
            21780,
            24960,
            28800,
            32340,
            37980,
            41340,
            44640,
            47880,
            51780,
            55500,
            58260,
            62940,
            69420,
            72960,
            76320,
            79680
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_bus_10",
      "sourceRouteId": "vilnius_bus_10",
      "mode": "bus",
      "shortName": "10",
      "longName": "Fabijoniškės–Baltupiai–Markučiai",
      "color": "0073AC",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_bus_10:0",
          "sourceRouteId": "vilnius_bus_10",
          "sourceShapeId": "vilnius_bus_10_a1-b1",
          "directionId": 0,
          "headsign": "Markučiai",
          "directionName": "Fabijoniškės–Baltupiai–Markučiai",
          "mode": "bus",
          "routeShortName": "10",
          "routeLongName": "Fabijoniškės–Baltupiai–Markučiai",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              -2239.88,
              -4760.959,
              0
            ],
            [
              -2255.322,
              -4781.331,
              25.563
            ],
            [
              -2271.646,
              -4798.295,
              49.106
            ],
            [
              -2275.726,
              -4802.032,
              54.639
            ],
            [
              -2275.987,
              -4802.271,
              54.992
            ],
            [
              -2271.287,
              -4797.967,
              61.365
            ],
            [
              -2262.567,
              -4792.131,
              71.858
            ],
            [
              -2250.902,
              -4775.979,
              91.782
            ],
            [
              -2246.649,
              -4770.794,
              98.487
            ],
            [
              -2233.519,
              -4752.57,
              120.949
            ],
            [
              -2214.894,
              -4719.504,
              158.9
            ],
            [
              -2197.201,
              -4666.383,
              214.89
            ],
            [
              -2190.603,
              -4657.594,
              225.88
            ],
            [
              -2137.713,
              -4671.9,
              280.67
            ],
            [
              -2112.872,
              -4685.417,
              308.951
            ],
            [
              -2099.157,
              -4695.955,
              326.247
            ],
            [
              -2067.351,
              -4718.784,
              365.397
            ],
            [
              -2007.683,
              -4768.827,
              443.273
            ],
            [
              -1998.706,
              -4771.214,
              452.562
            ],
            [
              -1979.306,
              -4767.106,
              472.392
            ],
            [
              -1962.099,
              -4770.654,
              489.961
            ],
            [
              -1951.469,
              -4783.649,
              506.749
            ],
            [
              -1941.516,
              -4815.647,
              540.26
            ],
            [
              -1918.262,
              -4848.345,
              580.384
            ],
            [
              -1854.05,
              -4896.245,
              660.494
            ],
            [
              -1743.848,
              -4966.117,
              790.979
            ],
            [
              -1676.24,
              -5004.061,
              868.507
            ],
            [
              -1627.812,
              -5023.801,
              920.804
            ],
            [
              -1586.957,
              -5054.639,
              971.991
            ],
            [
              -1465.895,
              -5129.166,
              1114.154
            ],
            [
              -1407.208,
              -5161.388,
              1181.105
            ],
            [
              -1338.038,
              -5183.78,
              1253.809
            ],
            [
              -1272.777,
              -5203.963,
              1322.12
            ],
            [
              -1246.49,
              -5215.481,
              1350.819
            ],
            [
              -1183.862,
              -5243.323,
              1419.357
            ],
            [
              -1057.683,
              -5283.443,
              1551.761
            ],
            [
              -1011.763,
              -5305.715,
              1602.797
            ],
            [
              -893.41,
              -5369.475,
              1737.232
            ],
            [
              -881.963,
              -5370.3,
              1748.709
            ],
            [
              -880.613,
              -5358.995,
              1760.095
            ],
            [
              -871.302,
              -5283.486,
              1836.176
            ],
            [
              -867.295,
              -5263.497,
              1856.562
            ],
            [
              -873.84,
              -5126.451,
              1993.765
            ],
            [
              -873.198,
              -5090.839,
              2029.382
            ],
            [
              -867.363,
              -5053.094,
              2067.576
            ],
            [
              -847.141,
              -4967.74,
              2155.292
            ],
            [
              -716.635,
              -4519.236,
              2622.398
            ],
            [
              -646.885,
              -4514.933,
              2692.281
            ],
            [
              -568.48,
              -4520.803,
              2770.905
            ],
            [
              -439.606,
              -4519.799,
              2899.783
            ],
            [
              -373.187,
              -4516.551,
              2966.281
            ],
            [
              -303.365,
              -4503.347,
              3037.341
            ],
            [
              -273.394,
              -4484.966,
              3072.499
            ],
            [
              -264.248,
              -4475.971,
              3085.328
            ],
            [
              -247.988,
              -4462.621,
              3106.366
            ],
            [
              -206.653,
              -4415.152,
              3169.309
            ],
            [
              -184.743,
              -4390.249,
              3202.479
            ],
            [
              -166.1,
              -4374.591,
              3226.825
            ],
            [
              -152.82,
              -4365.759,
              3242.773
            ],
            [
              -100.827,
              -4348.95,
              3297.416
            ],
            [
              -72.436,
              -4347.387,
              3325.85
            ],
            [
              -23.573,
              -4348.894,
              3374.737
            ],
            [
              35.061,
              -4351.207,
              3433.416
            ],
            [
              46.147,
              -4344.95,
              3446.146
            ],
            [
              48.454,
              -4310.97,
              3480.204
            ],
            [
              52.989,
              -4285.429,
              3506.145
            ],
            [
              60.111,
              -4250.579,
              3541.715
            ],
            [
              104.143,
              -4062.131,
              3735.239
            ],
            [
              127.703,
              -3998.463,
              3803.126
            ],
            [
              151.352,
              -3953.466,
              3853.959
            ],
            [
              179.07,
              -3910.986,
              3904.682
            ],
            [
              264.038,
              -3810.121,
              4036.566
            ],
            [
              345.157,
              -3743.697,
              4141.411
            ],
            [
              387.493,
              -3689.441,
              4210.23
            ],
            [
              434.283,
              -3627.326,
              4287.996
            ],
            [
              450.253,
              -3599.787,
              4319.831
            ],
            [
              463.769,
              -3565.524,
              4356.663
            ],
            [
              474.065,
              -3531.203,
              4392.495
            ],
            [
              484.063,
              -3477.95,
              4446.679
            ],
            [
              490.334,
              -3345.62,
              4579.157
            ],
            [
              488.575,
              -3319.869,
              4604.968
            ],
            [
              479.687,
              -3259.675,
              4665.815
            ],
            [
              477.905,
              -3216.226,
              4709.3
            ],
            [
              481.339,
              -3169.533,
              4756.119
            ],
            [
              500.602,
              -3103.091,
              4825.297
            ],
            [
              504.082,
              -3078.362,
              4850.27
            ],
            [
              504.445,
              -3034.141,
              4894.493
            ],
            [
              503.491,
              -2980.688,
              4947.954
            ],
            [
              505.751,
              -2962.917,
              4965.868
            ],
            [
              504.844,
              -2912.819,
              5015.974
            ],
            [
              509.397,
              -2869.472,
              5059.56
            ],
            [
              513.301,
              -2797.183,
              5131.954
            ],
            [
              494.515,
              -2626.513,
              5303.655
            ],
            [
              487.991,
              -2601.316,
              5329.683
            ],
            [
              485.911,
              -2568.466,
              5362.599
            ],
            [
              462.343,
              -2342.047,
              5590.241
            ],
            [
              451.425,
              -2269.486,
              5663.619
            ],
            [
              407.333,
              -2116.119,
              5823.198
            ],
            [
              406.254,
              -2096.107,
              5843.239
            ],
            [
              361.405,
              -1904.922,
              6039.614
            ],
            [
              342.249,
              -1718.661,
              6226.858
            ],
            [
              326.222,
              -1640.218,
              6306.921
            ],
            [
              326.097,
              -1614.835,
              6332.305
            ],
            [
              277.22,
              -1255.479,
              6694.969
            ],
            [
              271.867,
              -1230.89,
              6720.134
            ],
            [
              269.371,
              -1219.076,
              6732.209
            ],
            [
              267.28,
              -1199.635,
              6751.762
            ],
            [
              257.056,
              -1141.194,
              6811.09
            ],
            [
              216.915,
              -885.896,
              7069.525
            ],
            [
              226.048,
              -703.492,
              7252.158
            ],
            [
              223.795,
              -685.64,
              7270.151
            ],
            [
              209.218,
              -636.391,
              7321.512
            ],
            [
              192.022,
              -589.321,
              7371.625
            ],
            [
              159.237,
              -513.023,
              7454.669
            ],
            [
              151.725,
              -500.641,
              7469.151
            ],
            [
              143.086,
              -479.332,
              7492.145
            ],
            [
              126.134,
              -439.133,
              7535.772
            ],
            [
              106.146,
              -277.163,
              7698.971
            ],
            [
              46.11,
              -280.522,
              7759.1
            ],
            [
              26.264,
              -279.764,
              7778.961
            ],
            [
              16.623,
              -264.894,
              7796.683
            ],
            [
              14.513,
              -253.218,
              7808.548
            ],
            [
              16.439,
              -245.471,
              7816.531
            ],
            [
              45.916,
              -220.403,
              7855.226
            ],
            [
              103.215,
              -190.277,
              7919.962
            ],
            [
              127.382,
              -102.772,
              8010.743
            ],
            [
              121.848,
              -52.576,
              8061.243
            ],
            [
              118.496,
              -36.512,
              8077.653
            ],
            [
              117.583,
              -3.516,
              8110.662
            ],
            [
              102.671,
              133.684,
              8248.67
            ],
            [
              63.181,
              125.497,
              8288.999
            ],
            [
              59.312,
              125.568,
              8292.869
            ],
            [
              57.419,
              127.829,
              8295.818
            ],
            [
              31.786,
              278.582,
              8448.735
            ],
            [
              4.856,
              358.112,
              8532.7
            ],
            [
              -8.924,
              380.627,
              8559.097
            ],
            [
              -39.768,
              422.378,
              8611.006
            ],
            [
              -46.8,
              425.846,
              8618.847
            ],
            [
              -51.212,
              431.492,
              8626.012
            ],
            [
              -51.307,
              497.175,
              8691.695
            ],
            [
              -54.16,
              522.615,
              8717.295
            ],
            [
              -44.593,
              547.148,
              8743.627
            ],
            [
              -34.25,
              619.32,
              8816.536
            ],
            [
              -34.886,
              726.201,
              8923.419
            ],
            [
              -29.964,
              784,
              8981.427
            ],
            [
              -28.88,
              804.74,
              9002.196
            ],
            [
              -24.076,
              823.969,
              9022.016
            ],
            [
              -6.94,
              914.942,
              9114.589
            ],
            [
              5.94,
              949.218,
              9151.205
            ],
            [
              14.89,
              980.225,
              9183.478
            ],
            [
              20.723,
              1007.284,
              9211.159
            ],
            [
              98.858,
              1127.869,
              9354.845
            ],
            [
              208.532,
              1302.485,
              9561.047
            ],
            [
              266.256,
              1357.482,
              9640.776
            ],
            [
              337.506,
              1408.502,
              9728.409
            ],
            [
              360.424,
              1427.008,
              9757.866
            ],
            [
              406.382,
              1470.698,
              9821.277
            ],
            [
              500.704,
              1583.635,
              9968.421
            ],
            [
              509.636,
              1588.204,
              9978.454
            ],
            [
              522.358,
              1585.17,
              9991.532
            ],
            [
              534.824,
              1579.67,
              10005.158
            ],
            [
              580.038,
              1581.942,
              10050.429
            ],
            [
              658.651,
              1577.401,
              10129.173
            ],
            [
              692.229,
              1579.012,
              10162.789
            ],
            [
              741.723,
              1585.833,
              10212.751
            ],
            [
              775.59,
              1587.408,
              10246.655
            ],
            [
              809.306,
              1578.914,
              10281.424
            ],
            [
              847.494,
              1567.254,
              10321.353
            ],
            [
              881.41,
              1552.158,
              10358.477
            ],
            [
              943.873,
              1514.16,
              10431.59
            ],
            [
              977.642,
              1498.755,
              10468.706
            ],
            [
              986.83,
              1496.24,
              10478.232
            ],
            [
              1014.875,
              1489.647,
              10507.042
            ],
            [
              1169.279,
              1454.457,
              10665.405
            ],
            [
              1174.911,
              1305.179,
              10814.789
            ],
            [
              1219.91,
              1296.555,
              10860.607
            ],
            [
              1269.292,
              1286.69,
              10910.965
            ],
            [
              1287.836,
              1282.198,
              10930.046
            ],
            [
              1461.257,
              1230.864,
              11110.904
            ],
            [
              1535.192,
              1217.248,
              11186.083
            ],
            [
              1586.927,
              1224.082,
              11238.267
            ],
            [
              1634.086,
              1227.66,
              11285.562
            ],
            [
              1673.656,
              1231.674,
              11325.335
            ],
            [
              1721.874,
              1230.483,
              11373.568
            ],
            [
              1775.523,
              1236.165,
              11427.517
            ],
            [
              1885.773,
              1260.149,
              11540.346
            ],
            [
              1890.6,
              1266.382,
              11548.229
            ],
            [
              1963.37,
              1277.199,
              11621.799
            ],
            [
              2113.235,
              1310.887,
              11775.404
            ],
            [
              2127.941,
              1314.115,
              11790.46
            ],
            [
              2155.776,
              1320.367,
              11818.988
            ],
            [
              2174.041,
              1331.158,
              11840.203
            ],
            [
              2182.009,
              1343.255,
              11854.688
            ],
            [
              2194.157,
              1371.972,
              11885.869
            ],
            [
              2205.74,
              1408.854,
              11924.527
            ],
            [
              2215.938,
              1432.794,
              11950.548
            ],
            [
              2225.175,
              1443.754,
              11964.882
            ],
            [
              2240.882,
              1455.706,
              11984.619
            ],
            [
              2252.905,
              1467.367,
              12001.368
            ],
            [
              2268.486,
              1473.928,
              12018.274
            ],
            [
              2303.961,
              1477.634,
              12053.942
            ],
            [
              2356.118,
              1478.074,
              12106.101
            ],
            [
              2355.491,
              1478.053,
              12106.729
            ],
            [
              2367.632,
              1474.379,
              12119.413
            ],
            [
              2429.513,
              1441.875,
              12189.312
            ],
            [
              2462.029,
              1426.419,
              12225.315
            ],
            [
              2496.871,
              1414.177,
              12262.245
            ],
            [
              2523.512,
              1412.569,
              12288.934
            ],
            [
              2540.263,
              1416.251,
              12306.084
            ],
            [
              2579.775,
              1431.547,
              12348.454
            ],
            [
              2615.559,
              1447.574,
              12387.663
            ],
            [
              2702.107,
              1478.263,
              12479.491
            ],
            [
              2766.788,
              1495.942,
              12546.545
            ],
            [
              2803.963,
              1506.738,
              12585.256
            ],
            [
              2823.834,
              1510.454,
              12605.471
            ],
            [
              2867.468,
              1522.36,
              12650.701
            ],
            [
              2890.618,
              1528.122,
              12674.557
            ],
            [
              2897.818,
              1525.221,
              12682.319
            ],
            [
              2906.882,
              1514.823,
              12696.113
            ],
            [
              2909.484,
              1502.162,
              12709.039
            ],
            [
              2907.465,
              1497.747,
              12713.894
            ],
            [
              2898.312,
              1498.011,
              12723.05
            ],
            [
              2870.575,
              1509.289,
              12752.993
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:5803",
              "position": {
                "x": -2249.272,
                "z": -4768.989
              },
              "distanceAlongShapeM": 12.073,
              "shapeOffsetM": 2.634,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:5804",
              "position": {
                "x": -2134.709,
                "z": -4666.379
              },
              "distanceAlongShapeM": 280.67,
              "shapeOffsetM": 6.285,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:5808",
              "position": {
                "x": -1961.313,
                "z": -4769.653
              },
              "distanceAlongShapeM": 489.961,
              "shapeOffsetM": 1.273,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:5810",
              "position": {
                "x": -1625.643,
                "z": -5020.551
              },
              "distanceAlongShapeM": 920.804,
              "shapeOffsetM": 3.907,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:5815",
              "position": {
                "x": -1271.325,
                "z": -5199.449
              },
              "distanceAlongShapeM": 1322.12,
              "shapeOffsetM": 4.742,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:348",
              "position": {
                "x": -871.52,
                "z": -5283.459
              },
              "distanceAlongShapeM": 1836.176,
              "shapeOffsetM": 0.219,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:5833",
              "position": {
                "x": -646.915,
                "z": -4511.591
              },
              "distanceAlongShapeM": 2692.281,
              "shapeOffsetM": 3.342,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:5836",
              "position": {
                "x": 49.82,
                "z": -4284.902
              },
              "distanceAlongShapeM": 3506.11,
              "shapeOffsetM": 3.212,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:5839",
              "position": {
                "x": 148.043,
                "z": -3951.609
              },
              "distanceAlongShapeM": 3853.959,
              "shapeOffsetM": 3.794,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:5846",
              "position": {
                "x": 383.579,
                "z": -3686.512
              },
              "distanceAlongShapeM": 4210.131,
              "shapeOffsetM": 4.888,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:5481",
              "position": {
                "x": 502.159,
                "z": -2912.756
              },
              "distanceAlongShapeM": 5015.974,
              "shapeOffsetM": 2.686,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:5347",
              "position": {
                "x": 482.722,
                "z": -2601.805
              },
              "distanceAlongShapeM": 5329.683,
              "shapeOffsetM": 5.291,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:5351",
              "position": {
                "x": 407.176,
                "z": -2116.162
              },
              "distanceAlongShapeM": 5823.198,
              "shapeOffsetM": 0.163,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:5467",
              "position": {
                "x": 324.984,
                "z": -1640.419
              },
              "distanceAlongShapeM": 6306.921,
              "shapeOffsetM": 1.254,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            },
            {
              "stopId": "judu:stop:5378",
              "position": {
                "x": 265.625,
                "z": -1219.643
              },
              "distanceAlongShapeM": 6732.209,
              "shapeOffsetM": 3.789,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            },
            {
              "stopId": "judu:stop:5244",
              "position": {
                "x": 121.213,
                "z": -441.083
              },
              "distanceAlongShapeM": 7535.772,
              "shapeOffsetM": 5.293,
              "arrivalOffsetSeconds": 1620,
              "departureOffsetSeconds": 1620
            },
            {
              "stopId": "judu:stop:5409",
              "position": {
                "x": 115.041,
                "z": -36.866
              },
              "distanceAlongShapeM": 8077.653,
              "shapeOffsetM": 3.473,
              "arrivalOffsetSeconds": 1800,
              "departureOffsetSeconds": 1800
            },
            {
              "stopId": "judu:stop:5338",
              "position": {
                "x": -56,
                "z": 522.864
              },
              "distanceAlongShapeM": 8717.295,
              "shapeOffsetM": 1.857,
              "arrivalOffsetSeconds": 1980,
              "departureOffsetSeconds": 1980
            },
            {
              "stopId": "judu:stop:5345",
              "position": {
                "x": 17.976,
                "z": 1008
              },
              "distanceAlongShapeM": 9211.159,
              "shapeOffsetM": 2.839,
              "arrivalOffsetSeconds": 2100,
              "departureOffsetSeconds": 2100
            },
            {
              "stopId": "judu:stop:5349",
              "position": {
                "x": 206.575,
                "z": 1304.022
              },
              "distanceAlongShapeM": 9561.047,
              "shapeOffsetM": 2.488,
              "arrivalOffsetSeconds": 2160,
              "departureOffsetSeconds": 2160
            },
            {
              "stopId": "judu:stop:5355",
              "position": {
                "x": 580.051,
                "z": 1583.295
              },
              "distanceAlongShapeM": 10050.429,
              "shapeOffsetM": 1.353,
              "arrivalOffsetSeconds": 2280,
              "departureOffsetSeconds": 2280
            },
            {
              "stopId": "judu:stop:5358",
              "position": {
                "x": 979.224,
                "z": 1503.603
              },
              "distanceAlongShapeM": 10468.134,
              "shapeOffsetM": 5.067,
              "arrivalOffsetSeconds": 2400,
              "departureOffsetSeconds": 2400
            },
            {
              "stopId": "judu:stop:5360",
              "position": {
                "x": 1270.109,
                "z": 1290.062
              },
              "distanceAlongShapeM": 10910.965,
              "shapeOffsetM": 3.47,
              "arrivalOffsetSeconds": 2460,
              "departureOffsetSeconds": 2460
            },
            {
              "stopId": "judu:stop:5362",
              "position": {
                "x": 1673.61,
                "z": 1236.945
              },
              "distanceAlongShapeM": 11325.335,
              "shapeOffsetM": 5.271,
              "arrivalOffsetSeconds": 2520,
              "departureOffsetSeconds": 2520
            },
            {
              "stopId": "judu:stop:5854",
              "position": {
                "x": 2112.443,
                "z": 1314.496
              },
              "distanceAlongShapeM": 11775.404,
              "shapeOffsetM": 3.695,
              "arrivalOffsetSeconds": 2580,
              "departureOffsetSeconds": 2580
            },
            {
              "stopId": "judu:stop:5857",
              "position": {
                "x": 2701.336,
                "z": 1480.473
              },
              "distanceAlongShapeM": 12479.491,
              "shapeOffsetM": 2.341,
              "arrivalOffsetSeconds": 2700,
              "departureOffsetSeconds": 2700
            },
            {
              "stopId": "judu:stop:8336",
              "position": {
                "x": 2870.248,
                "z": 1508.467
              },
              "distanceAlongShapeM": 12752.986,
              "shapeOffsetM": 0.884,
              "arrivalOffsetSeconds": 2760,
              "departureOffsetSeconds": 2760
            }
          ],
          "departuresSeconds": [
            19800,
            21660,
            22500,
            23400,
            24300,
            25260,
            26280,
            27300,
            28320,
            29340,
            30540,
            31740,
            33240,
            34260,
            35340,
            36420,
            37500,
            38580,
            39660,
            40560,
            41460,
            42420,
            43380,
            44340,
            45300,
            46260,
            47220,
            48180,
            49200,
            50220,
            51180,
            52140,
            53100,
            54060,
            55080,
            55920,
            56820,
            57660,
            58500,
            59520,
            60660,
            61800,
            63060,
            64380,
            65820,
            67260,
            68100,
            69060,
            70380,
            71520,
            72360,
            73200,
            74100,
            75000,
            75960,
            76860,
            77760,
            78840,
            79920,
            80880,
            83520
          ]
        },
        {
          "id": "judu:pattern:vilnius_bus_10:1",
          "sourceRouteId": "vilnius_bus_10",
          "sourceShapeId": "vilnius_bus_10_b1-a1",
          "directionId": 1,
          "headsign": "Fabijoniškės",
          "directionName": "Markučiai–Baltupiai–Fabijoniškės",
          "mode": "bus",
          "routeShortName": "10",
          "routeLongName": "Fabijoniškės–Baltupiai–Markučiai",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              2870.351,
              1509.477,
              0
            ],
            [
              2863.321,
              1517.503,
              10.67
            ],
            [
              2825.769,
              1510.417,
              48.885
            ],
            [
              2756.406,
              1492.797,
              120.451
            ],
            [
              2671.356,
              1464.338,
              210.136
            ],
            [
              2655.285,
              1456.175,
              228.161
            ],
            [
              2635.614,
              1450.537,
              248.624
            ],
            [
              2538.187,
              1415.628,
              352.116
            ],
            [
              2526.274,
              1410.171,
              365.22
            ],
            [
              2514.2,
              1409.399,
              377.318
            ],
            [
              2451.537,
              1427.791,
              442.625
            ],
            [
              2376.753,
              1466.883,
              527.01
            ],
            [
              2338.099,
              1479.492,
              567.668
            ],
            [
              2266.981,
              1473.452,
              639.042
            ],
            [
              2244.855,
              1461.198,
              664.335
            ],
            [
              2214.607,
              1430.592,
              707.366
            ],
            [
              2183.881,
              1339.88,
              803.141
            ],
            [
              2175.872,
              1325.557,
              819.551
            ],
            [
              2161.497,
              1315.807,
              836.921
            ],
            [
              2119.309,
              1302.122,
              881.273
            ],
            [
              2063.598,
              1289.803,
              938.329
            ],
            [
              2046.007,
              1283.71,
              956.946
            ],
            [
              2007.868,
              1276.37,
              995.785
            ],
            [
              1907.433,
              1252.636,
              1098.986
            ],
            [
              1817.405,
              1234.36,
              1190.85
            ],
            [
              1745.61,
              1223.362,
              1263.483
            ],
            [
              1634.607,
              1220.971,
              1374.511
            ],
            [
              1599.996,
              1216.751,
              1409.379
            ],
            [
              1535.192,
              1217.248,
              1474.185
            ],
            [
              1461.257,
              1230.864,
              1549.363
            ],
            [
              1250.055,
              1287.093,
              1767.922
            ],
            [
              1216.978,
              1291.043,
              1801.234
            ],
            [
              1174.911,
              1305.179,
              1845.612
            ],
            [
              1169.279,
              1454.457,
              1994.997
            ],
            [
              967.857,
              1498.137,
              2201.101
            ],
            [
              940.672,
              1512.105,
              2231.664
            ],
            [
              883.949,
              1549.885,
              2299.817
            ],
            [
              863.515,
              1561.393,
              2323.269
            ],
            [
              775.59,
              1587.408,
              2414.962
            ],
            [
              747.11,
              1581.344,
              2444.08
            ],
            [
              677.186,
              1572.743,
              2514.531
            ],
            [
              534.824,
              1579.67,
              2657.061
            ],
            [
              500.201,
              1591.437,
              2693.629
            ],
            [
              469.529,
              1536.247,
              2756.77
            ],
            [
              453.691,
              1517.701,
              2781.158
            ],
            [
              360.424,
              1427.008,
              2911.25
            ],
            [
              315.899,
              1391.085,
              2968.46
            ],
            [
              256.42,
              1348.755,
              3041.464
            ],
            [
              223.566,
              1315.958,
              3087.886
            ],
            [
              196.476,
              1280.829,
              3132.247
            ],
            [
              149.248,
              1202.651,
              3223.583
            ],
            [
              55.081,
              1061.873,
              3392.952
            ],
            [
              46.275,
              1047.293,
              3409.986
            ],
            [
              39.094,
              1036.402,
              3423.03
            ],
            [
              29.447,
              1013.439,
              3447.937
            ],
            [
              17.226,
              966.824,
              3496.128
            ],
            [
              -2.949,
              921.549,
              3545.695
            ],
            [
              -20.393,
              826.162,
              3642.664
            ],
            [
              -29.409,
              769.885,
              3699.658
            ],
            [
              -34.886,
              726.201,
              3743.684
            ],
            [
              -34.25,
              619.32,
              3850.567
            ],
            [
              -49.15,
              509.381,
              3961.511
            ],
            [
              -51.111,
              437.057,
              4033.862
            ],
            [
              -46.759,
              428.072,
              4043.846
            ],
            [
              -39.768,
              422.378,
              4052.862
            ],
            [
              15.61,
              348.039,
              4145.56
            ],
            [
              36.62,
              260.682,
              4235.409
            ],
            [
              56.855,
              132.292,
              4365.383
            ],
            [
              59.373,
              128.907,
              4369.602
            ],
            [
              70.978,
              128.695,
              4381.209
            ],
            [
              102.671,
              133.684,
              4413.293
            ],
            [
              112.53,
              93.98,
              4454.202
            ],
            [
              129.88,
              -107.271,
              4656.2
            ],
            [
              116.846,
              -256.206,
              4805.704
            ],
            [
              117.887,
              -305.208,
              4854.717
            ],
            [
              127.343,
              -387.845,
              4937.893
            ],
            [
              135.914,
              -423.248,
              4974.319
            ],
            [
              144.816,
              -445.964,
              4998.717
            ],
            [
              174.587,
              -519.993,
              5078.508
            ],
            [
              236.049,
              -695.879,
              5264.823
            ],
            [
              238.113,
              -713.732,
              5282.795
            ],
            [
              217.158,
              -872.542,
              5442.982
            ],
            [
              276.82,
              -1242.113,
              5817.338
            ],
            [
              294.15,
              -1318.635,
              5895.797
            ],
            [
              320.249,
              -1546.82,
              6125.47
            ],
            [
              342.249,
              -1718.661,
              6298.714
            ],
            [
              352.701,
              -1764.728,
              6345.951
            ],
            [
              354.758,
              -1810.175,
              6391.445
            ],
            [
              356.121,
              -1841.371,
              6422.671
            ],
            [
              372.957,
              -1942.984,
              6525.669
            ],
            [
              426.379,
              -2158.817,
              6748.015
            ],
            [
              439.077,
              -2195.331,
              6786.675
            ],
            [
              440.947,
              -2208.066,
              6799.546
            ],
            [
              462.343,
              -2342.047,
              6935.225
            ],
            [
              497.458,
              -2575.098,
              7170.906
            ],
            [
              511.756,
              -2776.003,
              7372.319
            ],
            [
              513.301,
              -2797.183,
              7393.556
            ],
            [
              524.563,
              -2850.825,
              7448.367
            ],
            [
              523.952,
              -2902.017,
              7499.563
            ],
            [
              518.333,
              -3049.981,
              7647.633
            ],
            [
              511.327,
              -3110.973,
              7709.026
            ],
            [
              506.062,
              -3253.474,
              7851.624
            ],
            [
              505.902,
              -3256.64,
              7854.795
            ],
            [
              503.774,
              -3366.969,
              7965.144
            ],
            [
              489.873,
              -3512.567,
              8111.404
            ],
            [
              474.056,
              -3566.826,
              8167.922
            ],
            [
              440.465,
              -3641.474,
              8249.779
            ],
            [
              383.151,
              -3709.882,
              8339.024
            ],
            [
              302.538,
              -3790.592,
              8453.097
            ],
            [
              278.895,
              -3808.166,
              8482.555
            ],
            [
              228.358,
              -3858.451,
              8553.848
            ],
            [
              158.106,
              -3965.152,
              8681.599
            ],
            [
              125.932,
              -4039.781,
              8762.868
            ],
            [
              102.95,
              -4092.167,
              8820.074
            ],
            [
              79.561,
              -4208.631,
              8938.863
            ],
            [
              75.006,
              -4246.398,
              8976.904
            ],
            [
              72.804,
              -4296.453,
              9027.007
            ],
            [
              62.209,
              -4347.469,
              9079.112
            ],
            [
              53.653,
              -4357.332,
              9092.168
            ],
            [
              38.173,
              -4361.187,
              9108.121
            ],
            [
              -1.759,
              -4357.435,
              9148.229
            ],
            [
              -43.581,
              -4357.963,
              9190.055
            ],
            [
              -86.799,
              -4356.998,
              9233.283
            ],
            [
              -112.623,
              -4359.868,
              9259.266
            ],
            [
              -137.864,
              -4366.088,
              9285.262
            ],
            [
              -171.117,
              -4387.748,
              9324.947
            ],
            [
              -197.387,
              -4415.101,
              9362.872
            ],
            [
              -229.695,
              -4455.703,
              9414.76
            ],
            [
              -260.472,
              -4482.974,
              9455.881
            ],
            [
              -335.167,
              -4516.128,
              9537.603
            ],
            [
              -368.095,
              -4519.983,
              9570.756
            ],
            [
              -469.274,
              -4521.487,
              9671.946
            ],
            [
              -484.821,
              -4525.503,
              9688.004
            ],
            [
              -495.138,
              -4525.415,
              9698.321
            ],
            [
              -531.808,
              -4523.694,
              9735.031
            ],
            [
              -716.635,
              -4519.236,
              9919.912
            ],
            [
              -810.335,
              -4855.967,
              10269.437
            ],
            [
              -844.605,
              -4970.012,
              10388.519
            ],
            [
              -859.998,
              -5037.642,
              10457.879
            ],
            [
              -867.261,
              -5083.153,
              10503.966
            ],
            [
              -868.716,
              -5113.183,
              10534.031
            ],
            [
              -863.974,
              -5257.991,
              10678.917
            ],
            [
              -875.788,
              -5375.937,
              10797.453
            ],
            [
              -880.302,
              -5384.62,
              10807.239
            ],
            [
              -887.614,
              -5390.039,
              10816.34
            ],
            [
              -926.205,
              -5371.757,
              10859.043
            ],
            [
              -1090.384,
              -5275.062,
              11049.581
            ],
            [
              -1302.999,
              -5205.56,
              11273.267
            ],
            [
              -1387.113,
              -5180.474,
              11361.042
            ],
            [
              -1687.713,
              -4997.177,
              11713.119
            ],
            [
              -1731.791,
              -4976.352,
              11761.869
            ],
            [
              -1759.787,
              -4964.492,
              11792.274
            ],
            [
              -1786.639,
              -4945.316,
              11825.27
            ],
            [
              -1870.695,
              -4890.382,
              11925.685
            ],
            [
              -2020.603,
              -4770.824,
              12117.431
            ],
            [
              -2055.71,
              -4745.4,
              12160.777
            ],
            [
              -2116.546,
              -4695.646,
              12239.367
            ],
            [
              -2169.487,
              -4665.762,
              12300.161
            ],
            [
              -2190.603,
              -4657.594,
              12322.801
            ],
            [
              -2199.666,
              -4696.396,
              12362.648
            ],
            [
              -2209.584,
              -4710.692,
              12380.047
            ],
            [
              -2214.161,
              -4714.963,
              12386.307
            ],
            [
              -2261.533,
              -4697.525,
              12436.787
            ],
            [
              -2270.649,
              -4702.93,
              12447.385
            ],
            [
              -2239.88,
              -4760.959,
              12513.066
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:8336",
              "position": {
                "x": 2870.248,
                "z": 1508.467
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 1.015,
              "arrivalOffsetSeconds": -540,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:5858",
              "position": {
                "x": 2656.314,
                "z": 1453.488
              },
              "distanceAlongShapeM": 228.161,
              "shapeOffsetM": 2.877,
              "arrivalOffsetSeconds": 60,
              "departureOffsetSeconds": 60
            },
            {
              "stopId": "judu:stop:5855",
              "position": {
                "x": 2047.248,
                "z": 1277.862
              },
              "distanceAlongShapeM": 956.946,
              "shapeOffsetM": 5.978,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:946",
              "position": {
                "x": 1600.284,
                "z": 1213.815
              },
              "distanceAlongShapeM": 1409.379,
              "shapeOffsetM": 2.95,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:5428",
              "position": {
                "x": 1216.542,
                "z": 1288.825
              },
              "distanceAlongShapeM": 1801.234,
              "shapeOffsetM": 2.261,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:15581",
              "position": {
                "x": 677.252,
                "z": 1571.494
              },
              "distanceAlongShapeM": 2514.531,
              "shapeOffsetM": 1.251,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:6834",
              "position": {
                "x": 472.7,
                "z": 1534.052
              },
              "distanceAlongShapeM": 2756.77,
              "shapeOffsetM": 3.857,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:5346",
              "position": {
                "x": 52.802,
                "z": 1042.989
              },
              "distanceAlongShapeM": 3409.986,
              "shapeOffsetM": 7.818,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:5432",
              "position": {
                "x": -26.358,
                "z": 769.462
              },
              "distanceAlongShapeM": 3699.594,
              "shapeOffsetM": 3.079,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:5459",
              "position": {
                "x": 18.234,
                "z": 348.963
              },
              "distanceAlongShapeM": 4145.56,
              "shapeOffsetM": 2.781,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            },
            {
              "stopId": "judu:stop:5492",
              "position": {
                "x": 116.145,
                "z": 94.475
              },
              "distanceAlongShapeM": 4454.202,
              "shapeOffsetM": 3.649,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:5245",
              "position": {
                "x": 150.182,
                "z": -443.837
              },
              "distanceAlongShapeM": 4998.746,
              "shapeOffsetM": 5.773,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:6843",
              "position": {
                "x": 297.35,
                "z": -1318.188
              },
              "distanceAlongShapeM": 5895.797,
              "shapeOffsetM": 3.231,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            },
            {
              "stopId": "judu:stop:6844",
              "position": {
                "x": 356.237,
                "z": -1764.56
              },
              "distanceAlongShapeM": 6345.951,
              "shapeOffsetM": 3.54,
              "arrivalOffsetSeconds": 1560,
              "departureOffsetSeconds": 1560
            },
            {
              "stopId": "judu:stop:6845",
              "position": {
                "x": 441.836,
                "z": -2194.724
              },
              "distanceAlongShapeM": 6786.675,
              "shapeOffsetM": 2.825,
              "arrivalOffsetSeconds": 1620,
              "departureOffsetSeconds": 1620
            },
            {
              "stopId": "judu:stop:5469",
              "position": {
                "x": 505.139,
                "z": -2574.385
              },
              "distanceAlongShapeM": 7170.906,
              "shapeOffsetM": 7.714,
              "arrivalOffsetSeconds": 1740,
              "departureOffsetSeconds": 1740
            },
            {
              "stopId": "judu:stop:19086",
              "position": {
                "x": 511.316,
                "z": -3256.915
              },
              "distanceAlongShapeM": 7854.965,
              "shapeOffsetM": 5.419,
              "arrivalOffsetSeconds": 1920,
              "departureOffsetSeconds": 1920
            },
            {
              "stopId": "judu:stop:5848",
              "position": {
                "x": 303.678,
                "z": -3791.921
              },
              "distanceAlongShapeM": 8453.097,
              "shapeOffsetM": 1.751,
              "arrivalOffsetSeconds": 2040,
              "departureOffsetSeconds": 2040
            },
            {
              "stopId": "judu:stop:5840",
              "position": {
                "x": 127.093,
                "z": -4040.286
              },
              "distanceAlongShapeM": 8762.868,
              "shapeOffsetM": 1.266,
              "arrivalOffsetSeconds": 2100,
              "departureOffsetSeconds": 2100
            },
            {
              "stopId": "judu:stop:5835",
              "position": {
                "x": -43.706,
                "z": -4361.123
              },
              "distanceAlongShapeM": 9190.109,
              "shapeOffsetM": 3.162,
              "arrivalOffsetSeconds": 2220,
              "departureOffsetSeconds": 2220
            },
            {
              "stopId": "judu:stop:5834",
              "position": {
                "x": -495.157,
                "z": -4527.698
              },
              "distanceAlongShapeM": 9698.321,
              "shapeOffsetM": 2.283,
              "arrivalOffsetSeconds": 2280,
              "departureOffsetSeconds": 2280
            },
            {
              "stopId": "judu:stop:5822",
              "position": {
                "x": -927.257,
                "z": -5373.739
              },
              "distanceAlongShapeM": 10859.043,
              "shapeOffsetM": 2.244,
              "arrivalOffsetSeconds": 2490,
              "departureOffsetSeconds": 2490
            },
            {
              "stopId": "judu:stop:5814",
              "position": {
                "x": -1387.604,
                "z": -5181.778
              },
              "distanceAlongShapeM": 11361.042,
              "shapeOffsetM": 1.394,
              "arrivalOffsetSeconds": 2580,
              "departureOffsetSeconds": 2580
            },
            {
              "stopId": "judu:stop:5812",
              "position": {
                "x": -1760.592,
                "z": -4965.819
              },
              "distanceAlongShapeM": 11792.274,
              "shapeOffsetM": 1.552,
              "arrivalOffsetSeconds": 2670,
              "departureOffsetSeconds": 2670
            },
            {
              "stopId": "judu:stop:5807",
              "position": {
                "x": -2056.897,
                "z": -4746.801
              },
              "distanceAlongShapeM": 12160.809,
              "shapeOffsetM": 1.835,
              "arrivalOffsetSeconds": 2730,
              "departureOffsetSeconds": 2730
            },
            {
              "stopId": "judu:stop:8258",
              "position": {
                "x": -2259.201,
                "z": -4747.662
              },
              "distanceAlongShapeM": 12492.268,
              "shapeOffsetM": 10.841,
              "arrivalOffsetSeconds": 2820,
              "departureOffsetSeconds": 2820
            }
          ],
          "departuresSeconds": [
            19560,
            20760,
            21600,
            22740,
            23940,
            24660,
            25320,
            26040,
            26760,
            27660,
            28560,
            29640,
            30720,
            31800,
            32880,
            34020,
            35220,
            36360,
            37560,
            38700,
            39840,
            40860,
            41820,
            42780,
            43800,
            44820,
            45780,
            46800,
            47820,
            48720,
            49620,
            50520,
            51540,
            52560,
            53580,
            54600,
            55620,
            56640,
            57660,
            58680,
            59640,
            60600,
            61380,
            62220,
            63060,
            64320,
            65580,
            66780,
            67980,
            69180,
            70380,
            71460,
            72540,
            73620,
            74700,
            75540,
            76380,
            77280,
            78180,
            79080,
            79860,
            80640,
            81900,
            83100
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_bus_11",
      "sourceRouteId": "vilnius_bus_11",
      "mode": "bus",
      "shortName": "11",
      "longName": "Žvėrynas–Senamiestis–Užupis",
      "color": "0073AC",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_bus_11:0",
          "sourceRouteId": "vilnius_bus_11",
          "sourceShapeId": "vilnius_bus_11_a1-b1",
          "directionId": 0,
          "headsign": "Užupis",
          "directionName": "Žvėrynas–Senamiestis–Užupis",
          "mode": "bus",
          "routeShortName": "11",
          "routeLongName": "Žvėrynas–Senamiestis–Užupis",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              -2126.184,
              -1067.567,
              0
            ],
            [
              -2101.779,
              -1069.748,
              24.503
            ],
            [
              -2090.919,
              -1074.785,
              36.474
            ],
            [
              -2044.642,
              -1098.197,
              88.336
            ],
            [
              -2000.939,
              -1090.854,
              132.652
            ],
            [
              -1847.461,
              -1053.546,
              290.599
            ],
            [
              -1747.184,
              -1034.143,
              392.736
            ],
            [
              -1694.072,
              -1020.619,
              447.543
            ],
            [
              -1436.344,
              -850.447,
              756.383
            ],
            [
              -1439.495,
              -803.431,
              803.504
            ],
            [
              -1437.755,
              -749.118,
              857.846
            ],
            [
              -1410.822,
              -361.085,
              1246.812
            ],
            [
              -1411.232,
              -345.582,
              1262.321
            ],
            [
              -1406.663,
              -308.838,
              1299.348
            ],
            [
              -1394.376,
              -198.849,
              1410.021
            ],
            [
              -1393.853,
              -97.555,
              1511.316
            ],
            [
              -1393.479,
              -39.378,
              1569.494
            ],
            [
              -1361.685,
              -39.532,
              1601.288
            ],
            [
              -1329.577,
              -37.478,
              1633.462
            ],
            [
              -1190.447,
              -11.028,
              1775.084
            ],
            [
              -1025.306,
              27.195,
              1944.59
            ],
            [
              -994.12,
              39.993,
              1978.3
            ],
            [
              -950.273,
              44.262,
              2022.354
            ],
            [
              -919.958,
              39.772,
              2053
            ],
            [
              -857.805,
              53.124,
              2116.571
            ],
            [
              -724.996,
              86.353,
              2253.474
            ],
            [
              -591.62,
              115.115,
              2389.916
            ],
            [
              -557.359,
              122.914,
              2425.053
            ],
            [
              -539.176,
              126.412,
              2443.57
            ],
            [
              -408.498,
              148.538,
              2576.108
            ],
            [
              -385.731,
              159.258,
              2601.272
            ],
            [
              -216.06,
              268.617,
              2803.133
            ],
            [
              -50.385,
              441.496,
              3042.581
            ],
            [
              -51.307,
              497.175,
              3098.268
            ],
            [
              -54.16,
              522.615,
              3123.867
            ],
            [
              -44.593,
              547.148,
              3150.199
            ],
            [
              -34.25,
              619.32,
              3223.109
            ],
            [
              -34.886,
              726.201,
              3329.992
            ],
            [
              -29.964,
              784,
              3388
            ],
            [
              -28.88,
              804.74,
              3408.768
            ],
            [
              -24.076,
              823.969,
              3428.588
            ],
            [
              -6.94,
              914.942,
              3521.161
            ],
            [
              5.94,
              949.218,
              3557.777
            ],
            [
              14.89,
              980.225,
              3590.05
            ],
            [
              20.723,
              1007.284,
              3617.731
            ],
            [
              98.858,
              1127.869,
              3761.417
            ],
            [
              208.532,
              1302.485,
              3967.619
            ],
            [
              266.256,
              1357.482,
              4047.348
            ],
            [
              337.506,
              1408.502,
              4134.981
            ],
            [
              360.424,
              1427.008,
              4164.438
            ],
            [
              406.382,
              1470.698,
              4227.849
            ],
            [
              500.704,
              1583.635,
              4374.993
            ],
            [
              509.636,
              1588.204,
              4385.026
            ],
            [
              522.358,
              1585.17,
              4398.104
            ],
            [
              534.824,
              1579.67,
              4411.73
            ],
            [
              580.038,
              1581.942,
              4457.001
            ],
            [
              658.651,
              1577.401,
              4535.745
            ],
            [
              692.229,
              1579.012,
              4569.362
            ],
            [
              741.723,
              1585.833,
              4619.323
            ],
            [
              775.59,
              1587.408,
              4653.227
            ],
            [
              809.306,
              1578.914,
              4687.996
            ],
            [
              847.494,
              1567.254,
              4727.925
            ],
            [
              881.41,
              1552.158,
              4765.049
            ],
            [
              943.873,
              1514.16,
              4838.162
            ],
            [
              977.642,
              1498.755,
              4875.279
            ],
            [
              986.83,
              1496.24,
              4884.805
            ],
            [
              1014.875,
              1489.647,
              4913.615
            ],
            [
              1169.279,
              1454.457,
              5071.978
            ],
            [
              1174.911,
              1305.179,
              5221.362
            ],
            [
              1219.91,
              1296.555,
              5267.18
            ],
            [
              1269.292,
              1286.69,
              5317.538
            ],
            [
              1287.836,
              1282.198,
              5336.618
            ],
            [
              1461.257,
              1230.864,
              5517.477
            ],
            [
              1463.545,
              1216.594,
              5531.929
            ],
            [
              1460.544,
              1208.106,
              5540.932
            ],
            [
              1454.169,
              1196.485,
              5554.187
            ],
            [
              1434.198,
              1197.968,
              5574.213
            ],
            [
              1382.814,
              1210.051,
              5626.999
            ],
            [
              1330.619,
              1213.243,
              5679.291
            ],
            [
              1297.566,
              1204.948,
              5713.369
            ],
            [
              1268.299,
              1192.13,
              5745.32
            ],
            [
              1139.738,
              1112.124,
              5896.743
            ],
            [
              1020.917,
              1035.275,
              6038.25
            ],
            [
              994.589,
              1006.816,
              6077.019
            ],
            [
              976.042,
              980.44,
              6109.263
            ],
            [
              965.109,
              947.244,
              6144.213
            ],
            [
              958.724,
              928.198,
              6164.301
            ],
            [
              942.928,
              898.67,
              6197.789
            ],
            [
              924.197,
              862.278,
              6238.718
            ],
            [
              1006.601,
              882.643,
              6323.602
            ],
            [
              1024.399,
              886.466,
              6341.805
            ],
            [
              1047.023,
              886.566,
              6364.43
            ],
            [
              1102.088,
              870.365,
              6421.829
            ],
            [
              1172.005,
              833.219,
              6501.001
            ],
            [
              1193.244,
              830.601,
              6522.4
            ],
            [
              1219.078,
              832.35,
              6548.293
            ],
            [
              1253.8,
              829.227,
              6583.155
            ],
            [
              1296.753,
              811.99,
              6629.438
            ],
            [
              1366.024,
              796.875,
              6700.339
            ],
            [
              1398.094,
              787.414,
              6733.776
            ],
            [
              1417.424,
              779.7,
              6754.588
            ],
            [
              1452.786,
              773.479,
              6790.493
            ],
            [
              1481.534,
              771.527,
              6819.307
            ],
            [
              1480.364,
              771.661,
              6820.484
            ],
            [
              1534.513,
              763.059,
              6875.313
            ],
            [
              1595.023,
              756.37,
              6936.191
            ],
            [
              1776.533,
              735.885,
              7118.854
            ],
            [
              1802.116,
              723.579,
              7147.243
            ],
            [
              1938.363,
              662.041,
              7296.742
            ],
            [
              1951.821,
              657.337,
              7310.999
            ],
            [
              1982.023,
              651.208,
              7341.816
            ],
            [
              2056.123,
              647.825,
              7415.993
            ],
            [
              2119.956,
              652.874,
              7480.026
            ],
            [
              2202.77,
              667.449,
              7564.113
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:4898",
              "position": {
                "x": -2071.721,
                "z": -1082.918
              },
              "distanceAlongShapeM": 57.276,
              "shapeOffsetM": 1.409,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:5872",
              "position": {
                "x": -1444.532,
                "z": -803.545
              },
              "distanceAlongShapeM": 803.504,
              "shapeOffsetM": 5.038,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:5875",
              "position": {
                "x": -1412.477,
                "z": -345.47
              },
              "distanceAlongShapeM": 1262.321,
              "shapeOffsetM": 1.25,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:5880",
              "position": {
                "x": -1362.417,
                "z": -34.664
              },
              "distanceAlongShapeM": 1600.532,
              "shapeOffsetM": 4.865,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:5881",
              "position": {
                "x": -949.475,
                "z": 48.095
              },
              "distanceAlongShapeM": 2022.582,
              "shapeOffsetM": 3.908,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:5332",
              "position": {
                "x": -557.893,
                "z": 125.637
              },
              "distanceAlongShapeM": 2425.053,
              "shapeOffsetM": 2.774,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:5338",
              "position": {
                "x": -56,
                "z": 522.864
              },
              "distanceAlongShapeM": 3123.867,
              "shapeOffsetM": 1.857,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:5345",
              "position": {
                "x": 17.976,
                "z": 1008
              },
              "distanceAlongShapeM": 3617.731,
              "shapeOffsetM": 2.839,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:5349",
              "position": {
                "x": 206.575,
                "z": 1304.022
              },
              "distanceAlongShapeM": 3967.619,
              "shapeOffsetM": 2.488,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:5355",
              "position": {
                "x": 580.051,
                "z": 1583.295
              },
              "distanceAlongShapeM": 4457.001,
              "shapeOffsetM": 1.353,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            },
            {
              "stopId": "judu:stop:5358",
              "position": {
                "x": 979.224,
                "z": 1503.603
              },
              "distanceAlongShapeM": 4874.706,
              "shapeOffsetM": 5.067,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:5360",
              "position": {
                "x": 1270.109,
                "z": 1290.062
              },
              "distanceAlongShapeM": 5317.538,
              "shapeOffsetM": 3.47,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:7124",
              "position": {
                "x": 960.871,
                "z": 927.284
              },
              "distanceAlongShapeM": 6164.301,
              "shapeOffsetM": 2.334,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:5900",
              "position": {
                "x": 1024.034,
                "z": 889.384
              },
              "distanceAlongShapeM": 6341.805,
              "shapeOffsetM": 2.941,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            },
            {
              "stopId": "judu:stop:5901",
              "position": {
                "x": 1480.513,
                "z": 772.965
              },
              "distanceAlongShapeM": 6820.484,
              "shapeOffsetM": 1.313,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            },
            {
              "stopId": "judu:stop:5902",
              "position": {
                "x": 1777.924,
                "z": 740.728
              },
              "distanceAlongShapeM": 7118.854,
              "shapeOffsetM": 5.039,
              "arrivalOffsetSeconds": 1500,
              "departureOffsetSeconds": 1500
            },
            {
              "stopId": "judu:stop:5904",
              "position": {
                "x": 2202.359,
                "z": 671.588
              },
              "distanceAlongShapeM": 7564.113,
              "shapeOffsetM": 4.159,
              "arrivalOffsetSeconds": 1620,
              "departureOffsetSeconds": 1620
            }
          ],
          "departuresSeconds": [
            19320,
            21180,
            23040,
            24900,
            27000,
            29100,
            32340,
            34680,
            36960,
            39240,
            41400,
            43500,
            45540,
            47520,
            49620,
            51660,
            53700,
            55740,
            57780,
            59880,
            62040,
            64200,
            66780,
            69540,
            72060,
            73920,
            75900,
            77880,
            79860,
            81720,
            83580
          ]
        },
        {
          "id": "judu:pattern:vilnius_bus_11:1",
          "sourceRouteId": "vilnius_bus_11",
          "sourceShapeId": "vilnius_bus_11_b-a",
          "directionId": 1,
          "headsign": "Žvėrynas",
          "directionName": "Užupis–Senamiestis–Žvėrynas",
          "mode": "bus",
          "routeShortName": "11",
          "routeLongName": "Žvėrynas–Senamiestis–Užupis",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              2202.77,
              667.449,
              0
            ],
            [
              2281.67,
              670.105,
              78.945
            ],
            [
              2285.519,
              703.43,
              112.491
            ],
            [
              2286.06,
              732.364,
              141.43
            ],
            [
              2274.704,
              814.957,
              224.8
            ],
            [
              2261.392,
              861.962,
              273.654
            ],
            [
              2144.257,
              1048.95,
              494.301
            ],
            [
              2120.129,
              1077.499,
              531.68
            ],
            [
              2107.735,
              1096.818,
              554.633
            ],
            [
              2088.256,
              1124.583,
              588.55
            ],
            [
              2063.317,
              1145.824,
              621.309
            ],
            [
              2049.437,
              1153.138,
              636.998
            ],
            [
              2015.127,
              1163.632,
              672.876
            ],
            [
              1965.977,
              1174.732,
              723.264
            ],
            [
              1928.988,
              1197.686,
              766.797
            ],
            [
              1911.304,
              1218.054,
              793.77
            ],
            [
              1889.263,
              1249.836,
              832.447
            ],
            [
              1817.405,
              1234.36,
              905.953
            ],
            [
              1745.61,
              1223.362,
              978.585
            ],
            [
              1634.607,
              1220.971,
              1089.614
            ],
            [
              1599.996,
              1216.751,
              1124.481
            ],
            [
              1535.192,
              1217.248,
              1189.287
            ],
            [
              1461.257,
              1230.864,
              1264.466
            ],
            [
              1250.055,
              1287.093,
              1483.024
            ],
            [
              1216.978,
              1291.043,
              1516.337
            ],
            [
              1174.911,
              1305.179,
              1560.715
            ],
            [
              1169.279,
              1454.457,
              1710.099
            ],
            [
              967.857,
              1498.137,
              1916.203
            ],
            [
              940.672,
              1512.105,
              1946.766
            ],
            [
              883.949,
              1549.885,
              2014.919
            ],
            [
              863.515,
              1561.393,
              2038.371
            ],
            [
              775.59,
              1587.408,
              2130.064
            ],
            [
              747.11,
              1581.344,
              2159.182
            ],
            [
              677.186,
              1572.743,
              2229.633
            ],
            [
              534.824,
              1579.67,
              2372.164
            ],
            [
              517.836,
              1586.248,
              2390.381
            ],
            [
              513.546,
              1587.271,
              2394.791
            ],
            [
              494.797,
              1578.177,
              2415.63
            ],
            [
              482.238,
              1561.708,
              2436.341
            ],
            [
              479.584,
              1551.234,
              2447.146
            ],
            [
              469.529,
              1536.247,
              2465.194
            ],
            [
              453.691,
              1517.701,
              2489.582
            ],
            [
              360.424,
              1427.008,
              2619.674
            ],
            [
              315.899,
              1391.085,
              2676.883
            ],
            [
              256.42,
              1348.755,
              2749.887
            ],
            [
              223.566,
              1315.958,
              2796.31
            ],
            [
              196.476,
              1280.829,
              2840.671
            ],
            [
              149.248,
              1202.651,
              2932.007
            ],
            [
              55.081,
              1061.873,
              3101.376
            ],
            [
              46.275,
              1047.293,
              3118.409
            ],
            [
              39.094,
              1036.402,
              3131.454
            ],
            [
              29.447,
              1013.439,
              3156.361
            ],
            [
              17.226,
              966.824,
              3204.552
            ],
            [
              -2.949,
              921.549,
              3254.118
            ],
            [
              -20.393,
              826.162,
              3351.088
            ],
            [
              -29.409,
              769.885,
              3408.082
            ],
            [
              -34.886,
              726.201,
              3452.108
            ],
            [
              -34.25,
              619.32,
              3558.991
            ],
            [
              -49.15,
              509.381,
              3669.935
            ],
            [
              -50.587,
              430.368,
              3748.961
            ],
            [
              -86.677,
              396.514,
              3798.444
            ],
            [
              -98.36,
              381.073,
              3817.807
            ],
            [
              -191.298,
              289.447,
              3948.317
            ],
            [
              -216.06,
              268.617,
              3980.675
            ],
            [
              -386.375,
              159.27,
              4183.07
            ],
            [
              -408.498,
              148.538,
              4207.659
            ],
            [
              -583.944,
              111.636,
              4386.944
            ],
            [
              -658.953,
              100.746,
              4462.739
            ],
            [
              -724.996,
              86.353,
              4530.332
            ],
            [
              -736.71,
              77.277,
              4545.151
            ],
            [
              -743.833,
              78.9,
              4552.457
            ],
            [
              -798.875,
              66.534,
              4608.871
            ],
            [
              -863.023,
              49.879,
              4675.146
            ],
            [
              -871.015,
              45.142,
              4684.437
            ],
            [
              -881.155,
              45.752,
              4694.595
            ],
            [
              -934.202,
              36.688,
              4748.411
            ],
            [
              -998.108,
              33.385,
              4812.402
            ],
            [
              -1169.756,
              -8.06,
              4988.983
            ],
            [
              -1264.262,
              -27.516,
              5085.47
            ],
            [
              -1378.216,
              -54.917,
              5202.672
            ],
            [
              -1391.122,
              -53.075,
              5215.709
            ],
            [
              -1389.273,
              -129.92,
              5292.577
            ],
            [
              -1400.576,
              -283.113,
              5446.186
            ],
            [
              -1404.948,
              -321.114,
              5484.438
            ],
            [
              -1437.755,
              -749.118,
              5913.697
            ],
            [
              -1435.814,
              -784.776,
              5949.408
            ],
            [
              -1434.682,
              -801.724,
              5966.393
            ],
            [
              -1436.344,
              -850.447,
              6015.145
            ],
            [
              -1681.042,
              -1013.058,
              6308.947
            ],
            [
              -1696.006,
              -1020.584,
              6325.697
            ],
            [
              -1761.404,
              -1036.116,
              6392.914
            ],
            [
              -1847.461,
              -1053.546,
              6480.718
            ],
            [
              -1896.086,
              -1068.228,
              6531.512
            ],
            [
              -1912.525,
              -1075.817,
              6549.618
            ],
            [
              -1931.09,
              -1078.737,
              6568.411
            ],
            [
              -2127.883,
              -1123.11,
              6770.145
            ],
            [
              -2142.708,
              -1122.847,
              6784.972
            ],
            [
              -2144.52,
              -1103.354,
              6804.549
            ],
            [
              -2147.892,
              -1084.504,
              6823.698
            ],
            [
              -2126.982,
              -1067.851,
              6850.429
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:5904",
              "position": {
                "x": 2202.359,
                "z": 671.588
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 4.159,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:5925",
              "position": {
                "x": 2116.361,
                "z": 1075.075
              },
              "distanceAlongShapeM": 531.68,
              "shapeOffsetM": 4.48,
              "arrivalOffsetSeconds": 60,
              "departureOffsetSeconds": 60
            },
            {
              "stopId": "judu:stop:946",
              "position": {
                "x": 1600.284,
                "z": 1213.815
              },
              "distanceAlongShapeM": 1124.481,
              "shapeOffsetM": 2.95,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:5428",
              "position": {
                "x": 1216.542,
                "z": 1288.825
              },
              "distanceAlongShapeM": 1516.337,
              "shapeOffsetM": 2.261,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:15581",
              "position": {
                "x": 677.252,
                "z": 1571.494
              },
              "distanceAlongShapeM": 2229.633,
              "shapeOffsetM": 1.251,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:6834",
              "position": {
                "x": 472.7,
                "z": 1534.052
              },
              "distanceAlongShapeM": 2465.194,
              "shapeOffsetM": 3.857,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:5346",
              "position": {
                "x": 52.802,
                "z": 1042.989
              },
              "distanceAlongShapeM": 3118.409,
              "shapeOffsetM": 7.818,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:5432",
              "position": {
                "x": -26.358,
                "z": 769.462
              },
              "distanceAlongShapeM": 3408.017,
              "shapeOffsetM": 3.079,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:5334",
              "position": {
                "x": -97.297,
                "z": 380.009
              },
              "distanceAlongShapeM": 3817.807,
              "shapeOffsetM": 1.504,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:5936",
              "position": {
                "x": -736.157,
                "z": 75.422
              },
              "distanceAlongShapeM": 4545.151,
              "shapeOffsetM": 1.935,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:19193",
              "position": {
                "x": -870.86,
                "z": 44.454
              },
              "distanceAlongShapeM": 4684.437,
              "shapeOffsetM": 0.705,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:1116",
              "position": {
                "x": -1397.824,
                "z": -283.392
              },
              "distanceAlongShapeM": 5446.186,
              "shapeOffsetM": 2.766,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:632",
              "position": {
                "x": -1429.022,
                "z": -801.596
              },
              "distanceAlongShapeM": 5966.393,
              "shapeOffsetM": 5.662,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            },
            {
              "stopId": "judu:stop:6432",
              "position": {
                "x": -1911.753,
                "z": -1079.081
              },
              "distanceAlongShapeM": 6549.618,
              "shapeOffsetM": 3.354,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            },
            {
              "stopId": "judu:stop:18481",
              "position": {
                "x": -2146.884,
                "z": -1103.849
              },
              "distanceAlongShapeM": 6804.275,
              "shapeOffsetM": 2.4,
              "arrivalOffsetSeconds": 1500,
              "departureOffsetSeconds": 1500
            }
          ],
          "departuresSeconds": [
            19200,
            20820,
            22680,
            24600,
            26460,
            28620,
            30720,
            34020,
            36360,
            38580,
            40860,
            43020,
            45120,
            47160,
            49140,
            51180,
            53280,
            55320,
            57360,
            59400,
            61560,
            63840,
            66000,
            68460,
            71160,
            73680,
            75480,
            77460,
            79440,
            81420,
            83280,
            85140
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_bus_12",
      "sourceRouteId": "vilnius_bus_12",
      "mode": "bus",
      "shortName": "12",
      "longName": "Stotis–Rudamina–Skaidiškės",
      "color": "0073AC",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_bus_12:0",
          "sourceRouteId": "vilnius_bus_12",
          "sourceShapeId": "vilnius_bus_12_a-b",
          "directionId": 0,
          "headsign": "Skaidiškės",
          "directionName": "Stotis–Rudamina–Skaidiškės",
          "mode": "bus",
          "routeShortName": "12",
          "routeLongName": "Stotis–Rudamina–Skaidiškės",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              448.24,
              1918.913,
              0
            ],
            [
              414.243,
              1935.885,
              37.998
            ],
            [
              388.144,
              1955.287,
              70.519
            ],
            [
              374.884,
              1971.114,
              91.166
            ],
            [
              370.552,
              1981.213,
              102.155
            ],
            [
              369.405,
              1989.026,
              110.052
            ],
            [
              372.127,
              1996.769,
              118.26
            ],
            [
              376.723,
              2001.138,
              124.601
            ],
            [
              383.214,
              2003.246,
              131.425
            ],
            [
              391.578,
              2001.98,
              139.885
            ],
            [
              462.481,
              1962.833,
              220.877
            ],
            [
              478.32,
              1946.958,
              243.302
            ],
            [
              475.394,
              1928.087,
              262.399
            ],
            [
              494.54,
              1916.604,
              284.724
            ],
            [
              623.161,
              1858.587,
              425.825
            ],
            [
              825.163,
              1791.425,
              638.699
            ],
            [
              863.527,
              1836.207,
              697.667
            ],
            [
              869.06,
              1862.978,
              725.004
            ],
            [
              873.401,
              1888.503,
              750.895
            ],
            [
              890.379,
              1910.039,
              778.319
            ],
            [
              909.687,
              1916.752,
              798.76
            ],
            [
              941.154,
              1923.993,
              831.05
            ],
            [
              953.593,
              1933.783,
              846.879
            ],
            [
              1083.618,
              2057.184,
              1026.14
            ],
            [
              1196.071,
              2172,
              1186.852
            ],
            [
              1233.034,
              2216.96,
              1245.056
            ],
            [
              1262.402,
              2269.853,
              1305.555
            ],
            [
              1275.582,
              2294.627,
              1333.617
            ],
            [
              1295.641,
              2322.675,
              1368.099
            ],
            [
              1353.693,
              2426.246,
              1486.83
            ],
            [
              1363.843,
              2451.663,
              1514.199
            ],
            [
              1395.21,
              2612.502,
              1678.068
            ],
            [
              1412.03,
              2684.551,
              1752.054
            ],
            [
              1428.563,
              2741.021,
              1810.894
            ],
            [
              1438.754,
              2768.663,
              1840.355
            ],
            [
              1469.827,
              2811.004,
              1892.875
            ],
            [
              1478.408,
              2819.138,
              1904.698
            ],
            [
              1513.094,
              2845.213,
              1948.092
            ],
            [
              1567.546,
              2893.187,
              2020.663
            ],
            [
              1617.065,
              2953.497,
              2098.698
            ],
            [
              1672.764,
              3033.73,
              2196.369
            ],
            [
              1688.949,
              3071.28,
              2237.259
            ],
            [
              1698.328,
              3124.541,
              2291.339
            ],
            [
              1700.436,
              3377.207,
              2544.014
            ],
            [
              1694.118,
              3454.138,
              2621.204
            ],
            [
              1677.248,
              3567.892,
              2736.202
            ],
            [
              1670.163,
              3728.439,
              2896.905
            ],
            [
              1664.831,
              3754.142,
              2923.156
            ],
            [
              1667.138,
              3878.769,
              3047.804
            ],
            [
              1663.704,
              3902.223,
              3071.508
            ],
            [
              1665.775,
              3934.434,
              3103.785
            ],
            [
              1673.134,
              4166.999,
              3336.467
            ],
            [
              1673.634,
              4298.351,
              3467.82
            ],
            [
              1669.336,
              4336.28,
              3505.992
            ],
            [
              1674.124,
              4359.57,
              3529.769
            ],
            [
              1676.865,
              4402.935,
              3573.22
            ],
            [
              1687.031,
              4881.438,
              4051.831
            ],
            [
              1684.461,
              4913.77,
              4084.265
            ],
            [
              1688.75,
              4939.294,
              4110.147
            ],
            [
              1707.244,
              5553.457,
              4724.588
            ],
            [
              1715.118,
              5664.634,
              4836.044
            ],
            [
              1721.355,
              5722.407,
              4894.153
            ],
            [
              1837.871,
              6538.4,
              5718.422
            ],
            [
              1901.016,
              6997.851,
              6182.192
            ],
            [
              1908.882,
              7038.147,
              6223.249
            ],
            [
              1906.805,
              7049.277,
              6234.571
            ],
            [
              1901.784,
              7057.163,
              6243.92
            ],
            [
              1900.905,
              7072.006,
              6258.788
            ],
            [
              1917.676,
              7086.323,
              6280.839
            ],
            [
              1931.649,
              7146.561,
              6342.677
            ],
            [
              1976.571,
              7327.402,
              6529.014
            ],
            [
              2080.762,
              7788.568,
              7001.803
            ],
            [
              2098.628,
              7881.063,
              7096.007
            ],
            [
              2148.255,
              8082.317,
              7303.29
            ],
            [
              2205.009,
              8319.492,
              7547.161
            ],
            [
              2258.98,
              8511.074,
              7746.2
            ],
            [
              2288.95,
              8626.634,
              7865.583
            ],
            [
              2406.853,
              9024.854,
              8280.891
            ],
            [
              2423.882,
              9142.045,
              8399.312
            ],
            [
              2426.207,
              9161.42,
              8418.826
            ],
            [
              2420.977,
              9178.856,
              8437.03
            ],
            [
              2426.143,
              9192.592,
              8451.705
            ],
            [
              2432.968,
              9252.478,
              8511.979
            ],
            [
              2438.391,
              9309.754,
              8569.511
            ],
            [
              2455.974,
              9474.795,
              8735.486
            ],
            [
              2471.058,
              9624.8,
              8886.248
            ],
            [
              2509.684,
              10119.393,
              9382.346
            ],
            [
              2495.278,
              10141.16,
              9408.449
            ],
            [
              2495.623,
              10149.142,
              9416.438
            ],
            [
              2501.108,
              10157.642,
              9426.555
            ],
            [
              2502.933,
              10161.411,
              9430.742
            ],
            [
              2512.182,
              10165.061,
              9440.685
            ],
            [
              2517.214,
              10155.398,
              9451.58
            ],
            [
              2520.21,
              10151.777,
              9456.28
            ],
            [
              2521.311,
              10146.286,
              9461.88
            ],
            [
              2515.562,
              10040.344,
              9567.978
            ],
            [
              2529.481,
              10038.534,
              9582.014
            ],
            [
              2655.639,
              10082.124,
              9715.49
            ],
            [
              3518.296,
              10367.281,
              10624.056
            ],
            [
              3745.54,
              10440.182,
              10862.707
            ],
            [
              4166.121,
              10578.399,
              11305.418
            ],
            [
              4247.514,
              10604.087,
              11390.768
            ],
            [
              4346.898,
              10635.082,
              11494.873
            ],
            [
              4412.859,
              10653.465,
              11563.348
            ],
            [
              4646.153,
              10674.046,
              11797.548
            ],
            [
              4688.468,
              10687.382,
              11841.915
            ],
            [
              4696.052,
              10701.737,
              11858.15
            ],
            [
              4704.126,
              10705.778,
              11867.179
            ],
            [
              4711.86,
              10704.516,
              11875.015
            ],
            [
              4718.841,
              10700.984,
              11882.838
            ],
            [
              4722.334,
              10694.819,
              11889.925
            ],
            [
              4718.229,
              10677.497,
              11907.727
            ],
            [
              4738.709,
              10655.018,
              11938.137
            ],
            [
              5228.698,
              10464.597,
              12463.826
            ],
            [
              5336.008,
              10418.644,
              12580.561
            ],
            [
              5387.188,
              10390.937,
              12638.76
            ],
            [
              5481.558,
              10331.015,
              12750.547
            ],
            [
              5595.153,
              10247.756,
              12891.387
            ],
            [
              5632.243,
              10226.999,
              12933.89
            ],
            [
              5919.165,
              10105.553,
              13245.456
            ],
            [
              6349.524,
              9538.599,
              13957.246
            ],
            [
              6413.661,
              9462.95,
              14056.425
            ],
            [
              6458.839,
              9413.536,
              14123.378
            ],
            [
              6521.07,
              9375.948,
              14196.08
            ],
            [
              6588.386,
              9346.198,
              14269.677
            ],
            [
              6748.008,
              9274.548,
              14444.643
            ],
            [
              6806.744,
              9237.769,
              14513.943
            ],
            [
              6844.39,
              9197.778,
              14568.866
            ],
            [
              6890.585,
              9133.789,
              14647.787
            ],
            [
              6981.657,
              8994.398,
              14814.293
            ],
            [
              7017.927,
              8937.451,
              14881.808
            ],
            [
              7128.78,
              8755.082,
              15095.226
            ],
            [
              7142.474,
              8724.386,
              15128.838
            ],
            [
              7157.916,
              8663.891,
              15191.273
            ],
            [
              7162.3,
              8642.863,
              15212.752
            ],
            [
              7152.29,
              8642.548,
              15222.767
            ],
            [
              7144.427,
              8644.462,
              15230.86
            ],
            [
              7137.016,
              8649.03,
              15239.565
            ],
            [
              7133.69,
              8655.693,
              15247.012
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:939",
              "position": {
                "x": 448.101,
                "z": 1917.454
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 1.465,
              "arrivalOffsetSeconds": -720,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:5941",
              "position": {
                "x": 889.31,
                "z": 1911.588
              },
              "distanceAlongShapeM": 778.319,
              "shapeOffsetM": 1.882,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:5944",
              "position": {
                "x": 1272.571,
                "z": 2296.383
              },
              "distanceAlongShapeM": 1333.617,
              "shapeOffsetM": 3.486,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:5946",
              "position": {
                "x": 1466.069,
                "z": 2814.913
              },
              "distanceAlongShapeM": 1892.875,
              "shapeOffsetM": 5.422,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:5953",
              "position": {
                "x": 1663.704,
                "z": 3902.223
              },
              "distanceAlongShapeM": 3071.508,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:5955",
              "position": {
                "x": 1669.173,
                "z": 4336.284
              },
              "distanceAlongShapeM": 3505.992,
              "shapeOffsetM": 0.163,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:5956",
              "position": {
                "x": 1684.403,
                "z": 4913.771
              },
              "distanceAlongShapeM": 4084.265,
              "shapeOffsetM": 0.058,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:5958",
              "position": {
                "x": 1721.355,
                "z": 5722.407
              },
              "distanceAlongShapeM": 4894.153,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:17944",
              "position": {
                "x": 1837.248,
                "z": 6538.482
              },
              "distanceAlongShapeM": 5718.415,
              "shapeOffsetM": 0.629,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:5960",
              "position": {
                "x": 1900.043,
                "z": 6998.194
              },
              "distanceAlongShapeM": 6182.342,
              "shapeOffsetM": 1.02,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            },
            {
              "stopId": "judu:stop:5964",
              "position": {
                "x": 2095.419,
                "z": 7881.806
              },
              "distanceAlongShapeM": 7096.007,
              "shapeOffsetM": 3.294,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:5967",
              "position": {
                "x": 2286.351,
                "z": 8627.453
              },
              "distanceAlongShapeM": 7865.631,
              "shapeOffsetM": 2.725,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:17222",
              "position": {
                "x": 2420.685,
                "z": 9142.598
              },
              "distanceAlongShapeM": 8399.48,
              "shapeOffsetM": 3.24,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:5971",
              "position": {
                "x": 2654.817,
                "z": 10084.466
              },
              "distanceAlongShapeM": 9715.478,
              "shapeOffsetM": 2.482,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            },
            {
              "stopId": "judu:stop:5973",
              "position": {
                "x": 3516.709,
                "z": 10372.156
              },
              "distanceAlongShapeM": 10624.056,
              "shapeOffsetM": 5.127,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            },
            {
              "stopId": "judu:stop:5975",
              "position": {
                "x": 4165.181,
                "z": 10581.378
              },
              "distanceAlongShapeM": 11305.418,
              "shapeOffsetM": 3.124,
              "arrivalOffsetSeconds": 1500,
              "departureOffsetSeconds": 1500
            },
            {
              "stopId": "judu:stop:17594",
              "position": {
                "x": 4648.102,
                "z": 10683.473
              },
              "distanceAlongShapeM": 11802.241,
              "shapeOffsetM": 8.406,
              "arrivalOffsetSeconds": 1620,
              "departureOffsetSeconds": 1620
            },
            {
              "stopId": "judu:stop:5981",
              "position": {
                "x": 5750.274,
                "z": 10180.179
              },
              "distanceAlongShapeM": 13060.835,
              "shapeOffsetM": 2.891,
              "arrivalOffsetSeconds": 1800,
              "departureOffsetSeconds": 1800
            },
            {
              "stopId": "judu:stop:5986",
              "position": {
                "x": 6984.236,
                "z": 8996.04
              },
              "distanceAlongShapeM": 14814.293,
              "shapeOffsetM": 3.057,
              "arrivalOffsetSeconds": 1980,
              "departureOffsetSeconds": 1980
            },
            {
              "stopId": "judu:stop:5988",
              "position": {
                "x": 7133.918,
                "z": 8655.771
              },
              "distanceAlongShapeM": 15246.98,
              "shapeOffsetM": 0.239,
              "arrivalOffsetSeconds": 2040,
              "departureOffsetSeconds": 2040
            }
          ],
          "departuresSeconds": [
            18540,
            21780,
            22680,
            23820,
            27120,
            28980,
            32760,
            35880,
            38760,
            41940,
            44820,
            47940,
            50580,
            52620,
            53820,
            56340,
            57720,
            60420,
            63300,
            65220,
            68880,
            71640,
            74400,
            77340,
            80640
          ]
        },
        {
          "id": "judu:pattern:vilnius_bus_12:1",
          "sourceRouteId": "vilnius_bus_12",
          "sourceShapeId": "vilnius_bus_12_b-a",
          "directionId": 1,
          "headsign": "Stotis",
          "directionName": "Skaidiškės–Rudamina–Stotis",
          "mode": "bus",
          "routeShortName": "12",
          "routeLongName": "Stotis–Rudamina–Skaidiškės",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              7133.69,
              8655.693,
              0
            ],
            [
              7129.649,
              8672.554,
              17.339
            ],
            [
              7136.037,
              8685.099,
              31.417
            ],
            [
              7148.963,
              8697.778,
              49.523
            ],
            [
              7139.272,
              8732.187,
              85.27
            ],
            [
              7093.732,
              8813.534,
              178.497
            ],
            [
              6944.198,
              9052.862,
              460.699
            ],
            [
              6923.851,
              9078.916,
              493.758
            ],
            [
              6913.209,
              9097.632,
              515.287
            ],
            [
              6869.616,
              9162.846,
              593.73
            ],
            [
              6826.399,
              9218.458,
              664.16
            ],
            [
              6802.783,
              9243.151,
              698.328
            ],
            [
              6756.87,
              9272.943,
              753.06
            ],
            [
              6501.766,
              9387.846,
              1032.847
            ],
            [
              6465.588,
              9406.996,
              1073.781
            ],
            [
              6447.825,
              9424.042,
              1098.399
            ],
            [
              6308.307,
              9593.759,
              1318.102
            ],
            [
              5941.639,
              10082.93,
              1929.439
            ],
            [
              5920.633,
              10104.364,
              1959.451
            ],
            [
              5906.059,
              10113.697,
              1976.757
            ],
            [
              5712.31,
              10190.838,
              2185.298
            ],
            [
              5664.862,
              10204.086,
              2234.56
            ],
            [
              5604.155,
              10241.115,
              2305.67
            ],
            [
              5533.917,
              10290.132,
              2391.32
            ],
            [
              5343.031,
              10414.055,
              2618.904
            ],
            [
              5266.11,
              10447.825,
              2702.912
            ],
            [
              5036.443,
              10537.674,
              2949.528
            ],
            [
              4862.1,
              10606.448,
              3136.946
            ],
            [
              4788.595,
              10635.322,
              3215.919
            ],
            [
              4756.608,
              10646.827,
              3249.912
            ],
            [
              4736.123,
              10656.868,
              3272.725
            ],
            [
              4711.028,
              10673.037,
              3302.578
            ],
            [
              4698.838,
              10673.596,
              3314.781
            ],
            [
              4459.788,
              10659.054,
              3554.273
            ],
            [
              4402.6,
              10649.635,
              3612.232
            ],
            [
              3986.402,
              10518.167,
              4048.7
            ],
            [
              3763.068,
              10444.314,
              4283.928
            ],
            [
              3491.087,
              10356.057,
              4569.871
            ],
            [
              3349.399,
              10309.637,
              4718.969
            ],
            [
              2914.685,
              10167.107,
              5176.452
            ],
            [
              2612.459,
              10064.799,
              5495.525
            ],
            [
              2585.051,
              10055.551,
              5524.451
            ],
            [
              2538.358,
              10040.465,
              5573.52
            ],
            [
              2514.771,
              10026.972,
              5600.694
            ],
            [
              2509.931,
              9954.952,
              5672.877
            ],
            [
              2485.37,
              9954.259,
              5697.448
            ],
            [
              2484.44,
              9963.242,
              5706.48
            ],
            [
              2495.516,
              10148.734,
              5892.301
            ],
            [
              2499.228,
              10155.465,
              5899.988
            ],
            [
              2503.545,
              10162.807,
              5908.506
            ],
            [
              2505.674,
              10165.332,
              5911.808
            ],
            [
              2512.807,
              10163.937,
              5919.077
            ],
            [
              2508.449,
              10094.01,
              5989.139
            ],
            [
              2502.974,
              10018.287,
              6065.06
            ],
            [
              2500.933,
              9978.249,
              6105.15
            ],
            [
              2497.161,
              9949.375,
              6134.269
            ],
            [
              2428.313,
              9114.98,
              6971.5
            ],
            [
              2407.245,
              8999.834,
              7088.557
            ],
            [
              2321.643,
              8718.08,
              7383.028
            ],
            [
              2245.962,
              8457.723,
              7654.161
            ],
            [
              2230.567,
              8408.074,
              7706.143
            ],
            [
              2199.344,
              8292.88,
              7825.493
            ],
            [
              2161.604,
              8139.957,
              7983.004
            ],
            [
              2081.366,
              7786.33,
              8345.62
            ],
            [
              2071.644,
              7726.961,
              8405.78
            ],
            [
              2051.798,
              7655.519,
              8479.927
            ],
            [
              1937.224,
              7156.695,
              8991.74
            ],
            [
              1923.337,
              7104.632,
              9045.623
            ],
            [
              1917.487,
              7081.031,
              9069.939
            ],
            [
              1920.906,
              7080.352,
              9073.426
            ],
            [
              1928.176,
              7052.22,
              9102.481
            ],
            [
              1916.464,
              7040.944,
              9118.739
            ],
            [
              1840.946,
              6503.051,
              9661.907
            ],
            [
              1710.961,
              5614.616,
              10559.801
            ],
            [
              1705.045,
              5504.515,
              10670.061
            ],
            [
              1687.181,
              4854.718,
              11320.104
            ],
            [
              1690.302,
              4817.923,
              11357.03
            ],
            [
              1685.654,
              4772.367,
              11402.823
            ],
            [
              1681.965,
              4538.656,
              11636.563
            ],
            [
              1676.865,
              4402.935,
              11772.38
            ],
            [
              1678.187,
              4335.004,
              11840.324
            ],
            [
              1682.001,
              4273.043,
              11902.402
            ],
            [
              1693.897,
              4242.314,
              11935.354
            ],
            [
              1695.023,
              4233.387,
              11944.351
            ],
            [
              1700.816,
              4219.593,
              11959.313
            ],
            [
              1697.544,
              4199.121,
              11980.044
            ],
            [
              1674.822,
              4153.608,
              12030.914
            ],
            [
              1671.231,
              3959.972,
              12224.583
            ],
            [
              1674.798,
              3769.542,
              12415.046
            ],
            [
              1679.511,
              3724.956,
              12459.881
            ],
            [
              1684.234,
              3721.498,
              12465.734
            ],
            [
              1679.247,
              3710.449,
              12477.856
            ],
            [
              1680.184,
              3591.526,
              12596.783
            ],
            [
              1696.885,
              3464.105,
              12725.294
            ],
            [
              1701.829,
              3382.747,
              12806.802
            ],
            [
              1703.03,
              3134.473,
              13055.079
            ],
            [
              1699.891,
              3104.474,
              13085.242
            ],
            [
              1687.994,
              3054.599,
              13136.516
            ],
            [
              1659.262,
              3001.697,
              13196.717
            ],
            [
              1605.061,
              2932.568,
              13284.561
            ],
            [
              1556.997,
              2881.137,
              13354.955
            ],
            [
              1484.111,
              2813.466,
              13454.412
            ],
            [
              1478.391,
              2802.8,
              13466.515
            ],
            [
              1453.839,
              2781.743,
              13498.86
            ],
            [
              1433.991,
              2755.392,
              13531.85
            ],
            [
              1428.563,
              2741.021,
              13547.212
            ],
            [
              1382.281,
              2541.494,
              13752.036
            ],
            [
              1365.86,
              2456.079,
              13839.015
            ],
            [
              1336.284,
              2392.058,
              13909.538
            ],
            [
              1222.21,
              2196.952,
              14135.545
            ],
            [
              958.108,
              1933.7,
              14508.441
            ],
            [
              918.257,
              1878.079,
              14576.865
            ],
            [
              898.105,
              1863.557,
              14601.704
            ],
            [
              863.527,
              1836.207,
              14645.791
            ],
            [
              825.163,
              1791.425,
              14704.759
            ],
            [
              623.161,
              1858.587,
              14917.633
            ],
            [
              493.411,
              1911.506,
              15057.76
            ],
            [
              481.742,
              1922.405,
              15073.727
            ],
            [
              470.798,
              1923.718,
              15084.75
            ],
            [
              464.267,
              1919.385,
              15092.587
            ],
            [
              448.24,
              1918.913,
              15108.621
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:5988",
              "position": {
                "x": 7133.918,
                "z": 8655.771
              },
              "distanceAlongShapeM": 0.022,
              "shapeOffsetM": 0.24,
              "arrivalOffsetSeconds": -660,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:6137",
              "position": {
                "x": 6919.899,
                "z": 9076.348
              },
              "distanceAlongShapeM": 493.758,
              "shapeOffsetM": 4.713,
              "arrivalOffsetSeconds": 60,
              "departureOffsetSeconds": 60
            },
            {
              "stopId": "judu:stop:5982",
              "position": {
                "x": 5710.988,
                "z": 10187.621
              },
              "distanceAlongShapeM": 2185.706,
              "shapeOffsetM": 3.454,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:17589",
              "position": {
                "x": 4786.728,
                "z": 10630.719
              },
              "distanceAlongShapeM": 3216.118,
              "shapeOffsetM": 4.964,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:5976",
              "position": {
                "x": 4067.464,
                "z": 10542.049
              },
              "distanceAlongShapeM": 3964.209,
              "shapeOffsetM": 1.644,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:5974",
              "position": {
                "x": 3493.025,
                "z": 10350.339
              },
              "distanceAlongShapeM": 4569.792,
              "shapeOffsetM": 6.037,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:5972",
              "position": {
                "x": 2614.276,
                "z": 10059.621
              },
              "distanceAlongShapeM": 5495.464,
              "shapeOffsetM": 5.487,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:5969",
              "position": {
                "x": 2431.148,
                "z": 9114.572
              },
              "distanceAlongShapeM": 6971.5,
              "shapeOffsetM": 2.864,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:5966",
              "position": {
                "x": 2249.566,
                "z": 8456.702
              },
              "distanceAlongShapeM": 7654.136,
              "shapeOffsetM": 3.746,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            },
            {
              "stopId": "judu:stop:5965",
              "position": {
                "x": 2074.435,
                "z": 7726.344
              },
              "distanceAlongShapeM": 8405.78,
              "shapeOffsetM": 2.858,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:646",
              "position": {
                "x": 1908.814,
                "z": 6983.559
              },
              "distanceAlongShapeM": 9176.631,
              "shapeOffsetM": 0.403,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:17945",
              "position": {
                "x": 1843.043,
                "z": 6502.751
              },
              "distanceAlongShapeM": 9661.907,
              "shapeOffsetM": 2.118,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:5995",
              "position": {
                "x": 1738.128,
                "z": 5791.116
              },
              "distanceAlongShapeM": 10381.228,
              "shapeOffsetM": 1.329,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:5957",
              "position": {
                "x": 1690.373,
                "z": 4817.922
              },
              "distanceAlongShapeM": 11357.03,
              "shapeOffsetM": 0.071,
              "arrivalOffsetSeconds": 1380,
              "departureOffsetSeconds": 1380
            },
            {
              "stopId": "judu:stop:5996",
              "position": {
                "x": 1693.572,
                "z": 4189.997
              },
              "distanceAlongShapeM": 11989.982,
              "shapeOffsetM": 0.522,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            },
            {
              "stopId": "judu:stop:5998",
              "position": {
                "x": 1684.234,
                "z": 3721.498
              },
              "distanceAlongShapeM": 12465.734,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1560,
              "departureOffsetSeconds": 1560
            },
            {
              "stopId": "judu:stop:5947",
              "position": {
                "x": 1478.744,
                "z": 2802.433
              },
              "distanceAlongShapeM": 13466.515,
              "shapeOffsetM": 0.509,
              "arrivalOffsetSeconds": 1740,
              "departureOffsetSeconds": 1740
            },
            {
              "stopId": "judu:stop:5945",
              "position": {
                "x": 1224.883,
                "z": 2194.846
              },
              "distanceAlongShapeM": 14135.545,
              "shapeOffsetM": 3.403,
              "arrivalOffsetSeconds": 1800,
              "departureOffsetSeconds": 1800
            },
            {
              "stopId": "judu:stop:5942",
              "position": {
                "x": 922.174,
                "z": 1874.247
              },
              "distanceAlongShapeM": 14576.865,
              "shapeOffsetM": 5.48,
              "arrivalOffsetSeconds": 1860,
              "departureOffsetSeconds": 1860
            },
            {
              "stopId": "judu:stop:8264",
              "position": {
                "x": 493.148,
                "z": 1911.064
              },
              "distanceAlongShapeM": 15057.76,
              "shapeOffsetM": 0.515,
              "arrivalOffsetSeconds": 2040,
              "departureOffsetSeconds": 2040
            }
          ],
          "departuresSeconds": [
            21000,
            24180,
            25500,
            27000,
            29940,
            31800,
            35160,
            38580,
            41580,
            44520,
            47400,
            50580,
            53580,
            55260,
            57120,
            59700,
            60540,
            63300,
            66060,
            68520,
            71220,
            74280,
            77580,
            80700,
            83880
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_bus_13",
      "sourceRouteId": "vilnius_bus_13",
      "mode": "bus",
      "shortName": "13",
      "longName": "Žemasis Pavilnys–Markučiai–Stotis–Vilkpėdė",
      "color": "0073AC",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_bus_13:0",
          "sourceRouteId": "vilnius_bus_13",
          "sourceShapeId": "vilnius_bus_13_a-b",
          "directionId": 0,
          "headsign": "Vilkpėdė",
          "directionName": "Žemasis Pavilnys–Markučiai–Stotis–Vilkpėdė",
          "mode": "bus",
          "routeShortName": "13",
          "routeLongName": "Žemasis Pavilnys–Markučiai–Stotis–Vilkpėdė",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              5262.757,
              922.983,
              0
            ],
            [
              5159.088,
              993.981,
              125.651
            ],
            [
              4969.212,
              1135.82,
              362.655
            ],
            [
              4854.135,
              1237.06,
              515.927
            ],
            [
              4778.537,
              1260.316,
              595.021
            ],
            [
              4708.264,
              1275.96,
              667.014
            ],
            [
              4683.239,
              1278.032,
              692.125
            ],
            [
              4637.455,
              1245.514,
              748.282
            ],
            [
              4614.892,
              1236.955,
              772.413
            ],
            [
              4590.399,
              1247.532,
              799.092
            ],
            [
              4567.438,
              1261.053,
              825.738
            ],
            [
              4551.828,
              1267.302,
              842.553
            ],
            [
              4527.584,
              1268.777,
              866.842
            ],
            [
              4503.659,
              1265.896,
              890.94
            ],
            [
              4470.598,
              1257.624,
              925.02
            ],
            [
              4385.25,
              1223.499,
              1016.937
            ],
            [
              4291.558,
              1239.904,
              1112.055
            ],
            [
              3971.67,
              1244.903,
              1431.982
            ],
            [
              3914.434,
              1256.957,
              1490.473
            ],
            [
              3727.999,
              1356.417,
              1701.779
            ],
            [
              3642.49,
              1405.913,
              1800.58
            ],
            [
              3526.09,
              1449.291,
              1924.8
            ],
            [
              3456.065,
              1475.133,
              1999.442
            ],
            [
              3436.009,
              1472.174,
              2019.715
            ],
            [
              3409.272,
              1457.095,
              2050.411
            ],
            [
              3386.362,
              1439.717,
              2079.166
            ],
            [
              3313.681,
              1443.076,
              2151.925
            ],
            [
              3160.83,
              1454.003,
              2305.166
            ],
            [
              3101.371,
              1448.446,
              2364.884
            ],
            [
              3055.835,
              1440.258,
              2411.15
            ],
            [
              3025.334,
              1439.609,
              2441.658
            ],
            [
              2986.419,
              1448.108,
              2481.49
            ],
            [
              2930.114,
              1478.705,
              2545.572
            ],
            [
              2901.016,
              1497.868,
              2580.413
            ],
            [
              2870.575,
              1509.289,
              2612.926
            ],
            [
              2863.321,
              1517.503,
              2623.885
            ],
            [
              2825.769,
              1510.417,
              2662.099
            ],
            [
              2756.406,
              1492.797,
              2733.665
            ],
            [
              2671.356,
              1464.338,
              2823.35
            ],
            [
              2655.285,
              1456.175,
              2841.376
            ],
            [
              2635.614,
              1450.537,
              2861.839
            ],
            [
              2538.187,
              1415.628,
              2965.331
            ],
            [
              2526.274,
              1410.171,
              2978.435
            ],
            [
              2514.2,
              1409.399,
              2990.533
            ],
            [
              2451.537,
              1427.791,
              3055.839
            ],
            [
              2376.753,
              1466.883,
              3140.225
            ],
            [
              2338.099,
              1479.492,
              3180.883
            ],
            [
              2266.981,
              1473.452,
              3252.257
            ],
            [
              2244.855,
              1461.198,
              3277.55
            ],
            [
              2214.607,
              1430.592,
              3320.581
            ],
            [
              2183.881,
              1339.88,
              3416.355
            ],
            [
              2175.872,
              1325.557,
              3432.766
            ],
            [
              2161.497,
              1315.807,
              3450.135
            ],
            [
              2119.309,
              1302.122,
              3494.487
            ],
            [
              2063.598,
              1289.803,
              3551.544
            ],
            [
              2046.007,
              1283.71,
              3570.16
            ],
            [
              2007.868,
              1276.37,
              3608.999
            ],
            [
              1907.433,
              1252.636,
              3712.201
            ],
            [
              1817.405,
              1234.36,
              3804.065
            ],
            [
              1745.61,
              1223.362,
              3876.697
            ],
            [
              1634.607,
              1220.971,
              3987.726
            ],
            [
              1599.996,
              1216.751,
              4022.594
            ],
            [
              1535.192,
              1217.248,
              4087.399
            ],
            [
              1461.257,
              1230.864,
              4162.578
            ],
            [
              1250.055,
              1287.093,
              4381.137
            ],
            [
              1216.978,
              1291.043,
              4414.449
            ],
            [
              1174.911,
              1305.179,
              4458.827
            ],
            [
              1169.279,
              1454.457,
              4608.211
            ],
            [
              990.627,
              1492.26,
              4790.819
            ],
            [
              961.104,
              1500.597,
              4821.497
            ],
            [
              886.508,
              1548.725,
              4910.271
            ],
            [
              861.581,
              1561.429,
              4938.249
            ],
            [
              775.59,
              1587.408,
              5028.078
            ],
            [
              773.577,
              1623.63,
              5064.356
            ],
            [
              781.269,
              1649.737,
              5091.573
            ],
            [
              802.898,
              1738.399,
              5182.835
            ],
            [
              825.163,
              1791.425,
              5240.345
            ],
            [
              623.161,
              1858.587,
              5453.22
            ],
            [
              598.791,
              1864.715,
              5478.348
            ],
            [
              535.995,
              1890.241,
              5546.134
            ],
            [
              493.411,
              1911.506,
              5593.733
            ],
            [
              476.616,
              1921.478,
              5613.264
            ],
            [
              453.967,
              1920.686,
              5635.928
            ],
            [
              432.764,
              1925.527,
              5657.676
            ],
            [
              422.444,
              1925.716,
              5667.998
            ],
            [
              419.803,
              1922.424,
              5672.218
            ],
            [
              403.951,
              1926.595,
              5688.61
            ],
            [
              397.229,
              1922.837,
              5696.311
            ],
            [
              334.106,
              1822.687,
              5814.694
            ],
            [
              318.606,
              1821.856,
              5830.216
            ],
            [
              29.934,
              1735.835,
              6131.433
            ],
            [
              -11.394,
              1732.372,
              6172.905
            ],
            [
              -46.755,
              1740.57,
              6209.204
            ],
            [
              -320.217,
              1781.157,
              6485.662
            ],
            [
              -550.531,
              1853.232,
              6726.99
            ],
            [
              -581.279,
              1862.523,
              6759.111
            ],
            [
              -596.688,
              1869.651,
              6776.089
            ],
            [
              -717.241,
              1910.79,
              6903.468
            ],
            [
              -690.784,
              2018.296,
              7014.182
            ],
            [
              -657.818,
              2164.646,
              7164.198
            ],
            [
              -656.287,
              2177.977,
              7177.617
            ],
            [
              -658.202,
              2189.409,
              7189.208
            ],
            [
              -822.084,
              2251.1,
              7364.317
            ],
            [
              -883.687,
              2270.02,
              7428.76
            ],
            [
              -1046.445,
              2333.06,
              7603.3
            ],
            [
              -1116.835,
              2355.976,
              7677.327
            ],
            [
              -1465.657,
              2488.628,
              8050.52
            ],
            [
              -1523.427,
              2397.263,
              8158.617
            ],
            [
              -1557.257,
              2417.904,
              8198.246
            ],
            [
              -1585.57,
              2434.895,
              8231.267
            ],
            [
              -1589.092,
              2441.85,
              8239.062
            ],
            [
              -1615.966,
              2454.575,
              8268.797
            ],
            [
              -1665.298,
              2474.379,
              8321.955
            ],
            [
              -1973.715,
              2584.507,
              8649.445
            ],
            [
              -1980.067,
              2590.186,
              8657.965
            ],
            [
              -1990.862,
              2563.661,
              8686.603
            ],
            [
              -1996.181,
              2554.849,
              8696.896
            ],
            [
              -2002.73,
              2549.399,
              8705.416
            ],
            [
              -2004.833,
              2545.942,
              8709.463
            ],
            [
              -2009.26,
              2545.063,
              8713.976
            ],
            [
              -2019.015,
              2540.783,
              8724.628
            ],
            [
              -2077.913,
              2530.695,
              8784.384
            ],
            [
              -2082.858,
              2558.783,
              8812.904
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:7364",
              "position": {
                "x": 5262.105,
                "z": 920.636
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 2.435,
              "arrivalOffsetSeconds": -300,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:8332",
              "position": {
                "x": 4968.201,
                "z": 1134.498
              },
              "distanceAlongShapeM": 362.655,
              "shapeOffsetM": 1.665,
              "arrivalOffsetSeconds": 60,
              "departureOffsetSeconds": 60
            },
            {
              "stopId": "judu:stop:8335",
              "position": {
                "x": 4706.972,
                "z": 1270.896
              },
              "distanceAlongShapeM": 667.884,
              "shapeOffsetM": 5.153,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:8345",
              "position": {
                "x": 4172.232,
                "z": 1241.073
              },
              "distanceAlongShapeM": 1231.384,
              "shapeOffsetM": 0.696,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:8336",
              "position": {
                "x": 2870.248,
                "z": 1508.467
              },
              "distanceAlongShapeM": 2612.926,
              "shapeOffsetM": 0.884,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:5858",
              "position": {
                "x": 2656.314,
                "z": 1453.488
              },
              "distanceAlongShapeM": 2841.376,
              "shapeOffsetM": 2.877,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:5855",
              "position": {
                "x": 2047.248,
                "z": 1277.862
              },
              "distanceAlongShapeM": 3570.16,
              "shapeOffsetM": 5.978,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:946",
              "position": {
                "x": 1600.284,
                "z": 1213.815
              },
              "distanceAlongShapeM": 4022.594,
              "shapeOffsetM": 2.95,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:5428",
              "position": {
                "x": 1216.542,
                "z": 1288.825
              },
              "distanceAlongShapeM": 4414.449,
              "shapeOffsetM": 2.261,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:6714",
              "position": {
                "x": 769.19,
                "z": 1624.355
              },
              "distanceAlongShapeM": 5064.356,
              "shapeOffsetM": 4.447,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:3590",
              "position": {
                "x": 419.803,
                "z": 1922.424
              },
              "distanceAlongShapeM": 5672.218,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:6650",
              "position": {
                "x": -11.424,
                "z": 1732.135
              },
              "distanceAlongShapeM": 6172.905,
              "shapeOffsetM": 0.239,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:5167",
              "position": {
                "x": -582.7,
                "z": 1858.267
              },
              "distanceAlongShapeM": 6759.111,
              "shapeOffsetM": 4.487,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            },
            {
              "stopId": "judu:stop:5549",
              "position": {
                "x": -883.687,
                "z": 2270.02
              },
              "distanceAlongShapeM": 7428.76,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1560,
              "departureOffsetSeconds": 1560
            },
            {
              "stopId": "judu:stop:5552",
              "position": {
                "x": -1117.02,
                "z": 2355.478
              },
              "distanceAlongShapeM": 7677.327,
              "shapeOffsetM": 0.531,
              "arrivalOffsetSeconds": 1620,
              "departureOffsetSeconds": 1620
            },
            {
              "stopId": "judu:stop:7941",
              "position": {
                "x": -1586.671,
                "z": 2432.901
              },
              "distanceAlongShapeM": 8231.184,
              "shapeOffsetM": 2.276,
              "arrivalOffsetSeconds": 1800,
              "departureOffsetSeconds": 1800
            },
            {
              "stopId": "judu:stop:19255",
              "position": {
                "x": -2002.849,
                "z": 2542.722
              },
              "distanceAlongShapeM": 8709.463,
              "shapeOffsetM": 3.782,
              "arrivalOffsetSeconds": 1860,
              "departureOffsetSeconds": 1860
            }
          ],
          "departuresSeconds": [
            18540,
            20940,
            23340,
            25680,
            28200,
            30720,
            34500,
            39480,
            44280,
            49200,
            54000,
            56400,
            58860,
            61500,
            64200,
            66600,
            70680,
            75900,
            80580
          ]
        },
        {
          "id": "judu:pattern:vilnius_bus_13:1",
          "sourceRouteId": "vilnius_bus_13",
          "sourceShapeId": "vilnius_bus_13_b-a",
          "directionId": 1,
          "headsign": "Žemasis Pavilnys",
          "directionName": "Vilkpėdė–Stotis–Markučiai–Žemasis Pavilnys",
          "mode": "bus",
          "routeShortName": "13",
          "routeLongName": "Žemasis Pavilnys–Markučiai–Stotis–Vilkpėdė",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              -2004.833,
              2545.942,
              0
            ],
            [
              -2009.26,
              2545.063,
              4.513
            ],
            [
              -2019.015,
              2540.783,
              15.166
            ],
            [
              -2077.913,
              2530.695,
              74.921
            ],
            [
              -2082.858,
              2558.783,
              103.441
            ],
            [
              -2083.009,
              2570.861,
              115.52
            ],
            [
              -2085.436,
              2584.647,
              129.518
            ],
            [
              -2057.496,
              2590.447,
              158.053
            ],
            [
              -2049.628,
              2587.512,
              166.451
            ],
            [
              -2043.42,
              2571.065,
              184.031
            ],
            [
              -2044.167,
              2564.653,
              190.486
            ],
            [
              -2036.471,
              2538.866,
              217.397
            ],
            [
              -2016.375,
              2544.076,
              238.157
            ],
            [
              -2000.11,
              2551.579,
              256.07
            ],
            [
              -1974.301,
              2587.857,
              300.591
            ],
            [
              -1936.092,
              2569.619,
              342.93
            ],
            [
              -1765.274,
              2512.896,
              522.92
            ],
            [
              -1632.053,
              2457.088,
              667.358
            ],
            [
              -1583.952,
              2440.645,
              718.192
            ],
            [
              -1568.278,
              2436.193,
              734.486
            ],
            [
              -1560.402,
              2422.413,
              750.358
            ],
            [
              -1524.111,
              2395.048,
              795.81
            ],
            [
              -1465.597,
              2491.966,
              909.022
            ],
            [
              -1465.657,
              2488.628,
              912.36
            ],
            [
              -1177.095,
              2387.726,
              1218.055
            ],
            [
              -1141.897,
              2371.51,
              1256.809
            ],
            [
              -1046.445,
              2333.06,
              1359.714
            ],
            [
              -850.89,
              2263.864,
              1567.15
            ],
            [
              -825.857,
              2258.131,
              1592.831
            ],
            [
              -811.159,
              2248.676,
              1610.308
            ],
            [
              -650.281,
              2189.001,
              1781.897
            ],
            [
              -664.346,
              2124.688,
              1847.73
            ],
            [
              -669.355,
              2097.648,
              1875.23
            ],
            [
              -681.857,
              2048.192,
              1926.242
            ],
            [
              -715.105,
              1921.884,
              2056.852
            ],
            [
              -544.505,
              1865.369,
              2236.57
            ],
            [
              -527.366,
              1860.18,
              2254.477
            ],
            [
              -491.403,
              1846.355,
              2293.006
            ],
            [
              -471.457,
              1839.899,
              2313.97
            ],
            [
              -432.32,
              1825.49,
              2355.676
            ],
            [
              -327.19,
              1787.963,
              2467.303
            ],
            [
              -259.046,
              1774.482,
              2536.767
            ],
            [
              -147.106,
              1756.865,
              2650.085
            ],
            [
              9.981,
              1738.424,
              2808.251
            ],
            [
              41.02,
              1742.312,
              2839.532
            ],
            [
              64.443,
              1752.06,
              2864.902
            ],
            [
              97.435,
              1757.984,
              2898.422
            ],
            [
              156.41,
              1772.494,
              2959.156
            ],
            [
              318.606,
              1821.856,
              3128.697
            ],
            [
              328.524,
              1835.034,
              3145.19
            ],
            [
              357.53,
              1884.349,
              3202.403
            ],
            [
              388.342,
              1930.792,
              3258.138
            ],
            [
              389.754,
              1937.446,
              3264.94
            ],
            [
              364.123,
              1982.443,
              3316.725
            ],
            [
              364.306,
              1992.459,
              3326.743
            ],
            [
              376.139,
              2004.488,
              3343.616
            ],
            [
              393.574,
              2005.283,
              3361.069
            ],
            [
              403.209,
              2002.88,
              3370.999
            ],
            [
              452.283,
              1969.699,
              3430.238
            ],
            [
              463.689,
              1958.358,
              3446.323
            ],
            [
              466.167,
              1952.747,
              3452.457
            ],
            [
              464.949,
              1938.663,
              3466.593
            ],
            [
              459.371,
              1933.946,
              3473.898
            ],
            [
              450.885,
              1928.535,
              3483.963
            ],
            [
              432.16,
              1927.765,
              3502.703
            ],
            [
              419.803,
              1922.424,
              3516.165
            ],
            [
              402.263,
              1927.258,
              3534.36
            ],
            [
              397.27,
              1925.063,
              3539.813
            ],
            [
              384.004,
              1905.267,
              3563.643
            ],
            [
              371.312,
              1878.4,
              3593.357
            ],
            [
              344.166,
              1843.654,
              3637.45
            ],
            [
              330.657,
              1810.504,
              3673.247
            ],
            [
              391.321,
              1670.242,
              3826.066
            ],
            [
              477.846,
              1568.468,
              3959.649
            ],
            [
              485.021,
              1572.79,
              3968.025
            ],
            [
              495.103,
              1594.87,
              3992.298
            ],
            [
              501.968,
              1590.033,
              4000.696
            ],
            [
              515.385,
              1586.833,
              4014.49
            ],
            [
              552.903,
              1580.453,
              4052.546
            ],
            [
              580.038,
              1581.942,
              4079.722
            ],
            [
              658.651,
              1577.401,
              4158.466
            ],
            [
              692.229,
              1579.012,
              4192.083
            ],
            [
              741.723,
              1585.833,
              4242.044
            ],
            [
              775.59,
              1587.408,
              4275.948
            ],
            [
              809.306,
              1578.914,
              4310.717
            ],
            [
              847.494,
              1567.254,
              4350.646
            ],
            [
              881.41,
              1552.158,
              4387.77
            ],
            [
              943.873,
              1514.16,
              4460.883
            ],
            [
              977.642,
              1498.755,
              4498
            ],
            [
              986.83,
              1496.24,
              4507.526
            ],
            [
              1014.875,
              1489.647,
              4536.336
            ],
            [
              1169.279,
              1454.457,
              4694.699
            ],
            [
              1174.911,
              1305.179,
              4844.083
            ],
            [
              1219.91,
              1296.555,
              4889.901
            ],
            [
              1269.292,
              1286.69,
              4940.259
            ],
            [
              1287.836,
              1282.198,
              4959.339
            ],
            [
              1461.257,
              1230.864,
              5140.198
            ],
            [
              1535.192,
              1217.248,
              5215.376
            ],
            [
              1586.927,
              1224.082,
              5267.561
            ],
            [
              1634.086,
              1227.66,
              5314.855
            ],
            [
              1673.656,
              1231.674,
              5354.628
            ],
            [
              1721.874,
              1230.483,
              5402.861
            ],
            [
              1745.776,
              1232.265,
              5426.829
            ],
            [
              1775.523,
              1236.165,
              5456.831
            ],
            [
              1885.773,
              1260.149,
              5569.66
            ],
            [
              1890.6,
              1266.382,
              5577.544
            ],
            [
              1963.37,
              1277.199,
              5651.113
            ],
            [
              2113.235,
              1310.887,
              5804.718
            ],
            [
              2127.941,
              1314.115,
              5819.774
            ],
            [
              2155.776,
              1320.367,
              5848.302
            ],
            [
              2174.041,
              1331.158,
              5869.517
            ],
            [
              2182.009,
              1343.255,
              5884.002
            ],
            [
              2194.157,
              1371.972,
              5915.183
            ],
            [
              2205.74,
              1408.854,
              5953.841
            ],
            [
              2215.938,
              1432.794,
              5979.863
            ],
            [
              2225.175,
              1443.754,
              5994.196
            ],
            [
              2240.882,
              1455.706,
              6013.933
            ],
            [
              2252.905,
              1467.367,
              6030.683
            ],
            [
              2268.486,
              1473.928,
              6047.588
            ],
            [
              2303.961,
              1477.634,
              6083.256
            ],
            [
              2356.118,
              1478.074,
              6135.416
            ],
            [
              2355.491,
              1478.053,
              6136.043
            ],
            [
              2367.632,
              1474.379,
              6148.728
            ],
            [
              2429.513,
              1441.875,
              6218.626
            ],
            [
              2462.029,
              1426.419,
              6254.629
            ],
            [
              2496.871,
              1414.177,
              6291.559
            ],
            [
              2523.512,
              1412.569,
              6318.248
            ],
            [
              2540.263,
              1416.251,
              6335.399
            ],
            [
              2579.775,
              1431.547,
              6377.769
            ],
            [
              2615.559,
              1447.574,
              6416.978
            ],
            [
              2702.107,
              1478.263,
              6508.806
            ],
            [
              2890.618,
              1528.122,
              6703.799
            ],
            [
              2897.818,
              1525.221,
              6711.561
            ],
            [
              2906.882,
              1514.823,
              6725.355
            ],
            [
              2909.561,
              1502.523,
              6737.944
            ],
            [
              2930.368,
              1480.616,
              6768.157
            ],
            [
              2953.916,
              1463.474,
              6797.284
            ],
            [
              2984.641,
              1450.649,
              6830.578
            ],
            [
              3039.264,
              1438.834,
              6886.464
            ],
            [
              3058.729,
              1443.372,
              6906.451
            ],
            [
              3155.687,
              1456.735,
              7004.326
            ],
            [
              3332.252,
              1444.081,
              7181.343
            ],
            [
              3366.994,
              1438.97,
              7216.459
            ],
            [
              3387.186,
              1442.759,
              7237.004
            ],
            [
              3404.007,
              1451.628,
              7256.019
            ],
            [
              3428.452,
              1470.796,
              7287.083
            ],
            [
              3476.567,
              1470.176,
              7335.202
            ],
            [
              3655.283,
              1400.104,
              7527.164
            ],
            [
              3881.197,
              1272.102,
              7786.821
            ],
            [
              3954.279,
              1246.348,
              7864.308
            ],
            [
              4263.08,
              1243.105,
              8173.126
            ],
            [
              4382.21,
              1223.695,
              8293.827
            ],
            [
              4406.22,
              1231.028,
              8318.932
            ],
            [
              4456.04,
              1254.72,
              8374.098
            ],
            [
              4492.343,
              1264.65,
              8411.735
            ],
            [
              4525.649,
              1268.814,
              8445.3
            ],
            [
              4563.328,
              1263.043,
              8483.419
            ],
            [
              4611.315,
              1233.209,
              8539.924
            ],
            [
              4645.928,
              1250.936,
              8578.812
            ],
            [
              4667.701,
              1270.394,
              8608.013
            ],
            [
              4683.431,
              1278.849,
              8625.871
            ],
            [
              4724.772,
              1273.656,
              8667.537
            ],
            [
              4766.797,
              1261.952,
              8711.162
            ],
            [
              4837.587,
              1245.003,
              8783.953
            ],
            [
              4855.977,
              1235.906,
              8804.47
            ],
            [
              4878.932,
              1215.115,
              8835.44
            ],
            [
              4972.382,
              1135.708,
              8958.071
            ],
            [
              5015.474,
              1100.803,
              9013.527
            ],
            [
              5026.222,
              1092.724,
              9026.973
            ],
            [
              5228.796,
              946.655,
              9276.718
            ],
            [
              5253.359,
              929.264,
              9306.814
            ],
            [
              5280.87,
              923.613,
              9334.899
            ],
            [
              5282.944,
              923.132,
              9337.029
            ],
            [
              5282.621,
              923.075,
              9337.357
            ],
            [
              5277.133,
              922.62,
              9342.864
            ],
            [
              5262.757,
              922.983,
              9357.244
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:8311",
              "position": {
                "x": -2042.349,
                "z": 2571.254
              },
              "distanceAlongShapeM": 184.031,
              "shapeOffsetM": 1.087,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:8309",
              "position": {
                "x": -1563.915,
                "z": 2442.514
              },
              "distanceAlongShapeM": 734.486,
              "shapeOffsetM": 7.681,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:5553",
              "position": {
                "x": -1177.095,
                "z": 2387.726
              },
              "distanceAlongShapeM": 1218.055,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:5550",
              "position": {
                "x": -825.149,
                "z": 2260.061
              },
              "distanceAlongShapeM": 1592.831,
              "shapeOffsetM": 2.056,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:640",
              "position": {
                "x": -666.138,
                "z": 2096.89
              },
              "distanceAlongShapeM": 1875.23,
              "shapeOffsetM": 3.305,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:5166",
              "position": {
                "x": -470.051,
                "z": 1843.985
              },
              "distanceAlongShapeM": 2313.97,
              "shapeOffsetM": 4.322,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:5160",
              "position": {
                "x": 63.816,
                "z": 1754.143
              },
              "distanceAlongShapeM": 2864.902,
              "shapeOffsetM": 2.176,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:4267",
              "position": {
                "x": 372.531,
                "z": 1877.646
              },
              "distanceAlongShapeM": 3593.357,
              "shapeOffsetM": 1.434,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:5355",
              "position": {
                "x": 580.051,
                "z": 1583.295
              },
              "distanceAlongShapeM": 4079.722,
              "shapeOffsetM": 1.353,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            },
            {
              "stopId": "judu:stop:5358",
              "position": {
                "x": 979.224,
                "z": 1503.603
              },
              "distanceAlongShapeM": 4497.427,
              "shapeOffsetM": 5.067,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:5360",
              "position": {
                "x": 1270.109,
                "z": 1290.062
              },
              "distanceAlongShapeM": 4940.259,
              "shapeOffsetM": 3.47,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:5362",
              "position": {
                "x": 1673.61,
                "z": 1236.945
              },
              "distanceAlongShapeM": 5354.628,
              "shapeOffsetM": 5.271,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:5854",
              "position": {
                "x": 2112.443,
                "z": 1314.496
              },
              "distanceAlongShapeM": 5804.718,
              "shapeOffsetM": 3.695,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            },
            {
              "stopId": "judu:stop:5857",
              "position": {
                "x": 2701.336,
                "z": 1480.473
              },
              "distanceAlongShapeM": 6508.806,
              "shapeOffsetM": 2.341,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            },
            {
              "stopId": "judu:stop:684",
              "position": {
                "x": 2908.446,
                "z": 1515.54
              },
              "distanceAlongShapeM": 6725.355,
              "shapeOffsetM": 1.72,
              "arrivalOffsetSeconds": 1500,
              "departureOffsetSeconds": 1500
            },
            {
              "stopId": "judu:stop:8344",
              "position": {
                "x": 4263.289,
                "z": 1246.011
              },
              "distanceAlongShapeM": 8173.126,
              "shapeOffsetM": 2.914,
              "arrivalOffsetSeconds": 1620,
              "departureOffsetSeconds": 1620
            },
            {
              "stopId": "judu:stop:8333",
              "position": {
                "x": 4725.115,
                "z": 1275
              },
              "distanceAlongShapeM": 8667.537,
              "shapeOffsetM": 1.387,
              "arrivalOffsetSeconds": 1680,
              "departureOffsetSeconds": 1680
            },
            {
              "stopId": "judu:stop:8331",
              "position": {
                "x": 5019.254,
                "z": 1105.681
              },
              "distanceAlongShapeM": 9013.394,
              "shapeOffsetM": 6.17,
              "arrivalOffsetSeconds": 1740,
              "departureOffsetSeconds": 1740
            },
            {
              "stopId": "judu:stop:7364",
              "position": {
                "x": 5262.105,
                "z": 920.636
              },
              "distanceAlongShapeM": 9357.244,
              "shapeOffsetM": 2.435,
              "arrivalOffsetSeconds": 1800,
              "departureOffsetSeconds": 1800
            }
          ],
          "departuresSeconds": [
            21060,
            23460,
            25980,
            28500,
            32340,
            37320,
            42180,
            47040,
            51840,
            54240,
            56640,
            59160,
            61680,
            64260,
            68520,
            73560,
            78540,
            82920
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_bus_14",
      "sourceRouteId": "vilnius_bus_14",
      "mode": "bus",
      "shortName": "14",
      "longName": "Rudamina–Didžiasalis–Grigaičiai–Parko–Arimų g.",
      "color": "0073AC",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_bus_14:0",
          "sourceRouteId": "vilnius_bus_14",
          "sourceShapeId": "vilnius_bus_14_a-b",
          "directionId": 0,
          "headsign": "Arimų g.",
          "directionName": "Rudamina–Didžiasalis–Grigaičiai–Parko–Arimų g.",
          "mode": "bus",
          "routeShortName": "14",
          "routeLongName": "Rudamina–Didžiasalis–Grigaičiai–Parko–Arimų g.",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              4788.595,
              10635.322,
              0
            ],
            [
              4708.117,
              10672.392,
              88.605
            ],
            [
              4700.923,
              10673.555,
              95.892
            ],
            [
              4691.468,
              10683.505,
              109.618
            ],
            [
              4689.696,
              10694.922,
              121.172
            ],
            [
              4697.705,
              10705.039,
              134.075
            ],
            [
              4703.857,
              10706.899,
              140.502
            ],
            [
              4711.837,
              10705.862,
              148.548
            ],
            [
              4721.345,
              10697.317,
              161.332
            ],
            [
              4722.928,
              10687.167,
              171.605
            ],
            [
              4736.593,
              10657.663,
              204.12
            ],
            [
              4800.987,
              10632.671,
              273.194
            ],
            [
              4924.084,
              10600.906,
              400.323
            ],
            [
              5069.074,
              10528.107,
              562.563
            ],
            [
              5273.175,
              10445.462,
              782.762
            ],
            [
              5353.305,
              10410.517,
              870.18
            ],
            [
              5426.133,
              10365.693,
              955.697
            ],
            [
              5603.75,
              10244.672,
              1170.624
            ],
            [
              5657.249,
              10216.495,
              1231.09
            ],
            [
              5919.165,
              10105.553,
              1515.533
            ],
            [
              6349.524,
              9538.599,
              2227.324
            ],
            [
              6413.661,
              9462.95,
              2326.502
            ],
            [
              6458.839,
              9413.536,
              2393.456
            ],
            [
              6521.07,
              9375.948,
              2466.157
            ],
            [
              6588.386,
              9346.198,
              2539.754
            ],
            [
              6748.008,
              9274.548,
              2714.72
            ],
            [
              6806.744,
              9237.769,
              2784.021
            ],
            [
              6844.39,
              9197.778,
              2838.944
            ],
            [
              6890.585,
              9133.789,
              2917.864
            ],
            [
              6981.657,
              8994.398,
              3084.371
            ],
            [
              7068.705,
              8855.218,
              3248.53
            ],
            [
              7118.296,
              8775.225,
              3342.648
            ],
            [
              7134.705,
              8742.897,
              3378.901
            ],
            [
              7147.989,
              8707.499,
              3416.71
            ],
            [
              7173.919,
              8587.072,
              3539.897
            ],
            [
              7188.264,
              8545.076,
              3584.275
            ],
            [
              7195.291,
              8533.097,
              3598.164
            ],
            [
              7216.924,
              8508.269,
              3631.094
            ],
            [
              7250.597,
              8473.583,
              3679.437
            ],
            [
              7268.253,
              8453.384,
              3706.265
            ],
            [
              7282.642,
              8436.942,
              3728.113
            ],
            [
              7285.215,
              8422.217,
              3743.062
            ],
            [
              7292.833,
              8379.626,
              3786.329
            ],
            [
              7315.865,
              8154.226,
              4012.902
            ],
            [
              7318.527,
              8119.926,
              4047.306
            ],
            [
              7365.191,
              7528.991,
              4640.08
            ],
            [
              7376.228,
              7378.845,
              4790.631
            ],
            [
              7394.939,
              7216.723,
              4953.829
            ],
            [
              7445.318,
              7062.441,
              5116.128
            ],
            [
              7610.466,
              6807.214,
              5420.126
            ],
            [
              7799.852,
              6559.741,
              5731.751
            ],
            [
              7841.635,
              6460.276,
              5839.635
            ],
            [
              7872.445,
              6364.563,
              5940.185
            ],
            [
              7879.521,
              6286.243,
              6018.824
            ],
            [
              7877.482,
              6198.742,
              6106.349
            ],
            [
              7863.087,
              5994.254,
              6311.343
            ],
            [
              7850.896,
              5847.254,
              6458.847
            ],
            [
              7853.89,
              5769.94,
              6536.219
            ],
            [
              7891.63,
              5624.362,
              6686.609
            ],
            [
              8199.516,
              4890.412,
              7482.522
            ],
            [
              8274.774,
              4644.497,
              7739.695
            ],
            [
              8372.638,
              4332.45,
              8066.728
            ],
            [
              8560.46,
              3732.849,
              8695.058
            ],
            [
              8562.195,
              3733.095,
              8696.81
            ],
            [
              8571.746,
              3729.858,
              8706.895
            ],
            [
              8578.087,
              3724.164,
              8715.417
            ],
            [
              8581.112,
              3714.084,
              8725.941
            ],
            [
              8577.707,
              3705.246,
              8735.413
            ],
            [
              8571.788,
              3699.798,
              8743.457
            ],
            [
              8569.169,
              3697.869,
              8746.71
            ],
            [
              8621.938,
              3533.763,
              8919.092
            ],
            [
              8664.623,
              3408.45,
              9051.475
            ],
            [
              8795.595,
              3081.339,
              9403.832
            ],
            [
              8813.257,
              3034.497,
              9453.894
            ],
            [
              8856.865,
              2834.407,
              9658.68
            ],
            [
              8895.1,
              2624.349,
              9872.19
            ],
            [
              8901.756,
              2584.326,
              9912.762
            ],
            [
              8904.196,
              2545.312,
              9951.853
            ],
            [
              8904.191,
              2534.701,
              9962.464
            ],
            [
              8901.093,
              2515.221,
              9982.188
            ],
            [
              8901.437,
              2517.036,
              9984.036
            ],
            [
              8898.415,
              2502.108,
              9999.268
            ],
            [
              8898.237,
              2501.275,
              10000.12
            ],
            [
              8891.727,
              2470.972,
              10031.114
            ],
            [
              8858.803,
              2310.209,
              10195.213
            ],
            [
              8847.277,
              2282.609,
              10225.123
            ],
            [
              8731.774,
              2154.679,
              10397.481
            ],
            [
              8712.486,
              2126.121,
              10431.942
            ],
            [
              8701.741,
              2105.185,
              10455.474
            ],
            [
              8692.272,
              2056.506,
              10505.066
            ],
            [
              8691.4,
              1943.966,
              10617.609
            ],
            [
              8693.489,
              1904.774,
              10656.857
            ],
            [
              8696.6,
              1837.986,
              10723.717
            ],
            [
              8709.72,
              1695.278,
              10867.027
            ],
            [
              8718.924,
              1653.9,
              10909.417
            ],
            [
              8801.604,
              1411.711,
              11165.33
            ],
            [
              8807.441,
              1382.568,
              11195.051
            ],
            [
              8817.485,
              1309.543,
              11268.763
            ],
            [
              8840.299,
              1142.392,
              11437.464
            ],
            [
              8854.097,
              1019.998,
              11560.634
            ],
            [
              8848.028,
              981.187,
              11599.916
            ],
            [
              8818.093,
              865.976,
              11718.953
            ],
            [
              8791.61,
              800.83,
              11789.276
            ],
            [
              8699.358,
              584.416,
              12024.532
            ],
            [
              8685.547,
              537.815,
              12073.137
            ],
            [
              8661.183,
              441.631,
              12172.359
            ],
            [
              8618.998,
              285.592,
              12334
            ],
            [
              8586.11,
              199.304,
              12426.342
            ],
            [
              8585.045,
              183.764,
              12441.919
            ],
            [
              8590.333,
              158.052,
              12468.169
            ],
            [
              8621.917,
              92.846,
              12540.622
            ],
            [
              8636.204,
              33.555,
              12601.61
            ],
            [
              8637.068,
              12.385,
              12622.797
            ],
            [
              8604.283,
              -110.532,
              12750.012
            ],
            [
              8595.54,
              -160.454,
              12800.693
            ],
            [
              8696.309,
              -134.44,
              12904.766
            ],
            [
              8720.235,
              -127.625,
              12929.644
            ],
            [
              8744.3,
              -121.003,
              12954.603
            ],
            [
              8789.403,
              -109.804,
              13001.076
            ],
            [
              8826.448,
              -96.087,
              13040.579
            ],
            [
              8853.145,
              -83.257,
              13070.199
            ],
            [
              8900.484,
              -38.566,
              13135.301
            ],
            [
              8997.947,
              60.777,
              13274.47
            ],
            [
              9045.087,
              95.45,
              13332.988
            ],
            [
              9064.009,
              106.201,
              13354.751
            ],
            [
              9090.691,
              117.908,
              13383.888
            ],
            [
              9117.305,
              128.24,
              13412.438
            ],
            [
              9141.918,
              131.345,
              13437.246
            ],
            [
              9732.973,
              138.29,
              14028.342
            ],
            [
              9769.057,
              138.275,
              14064.425
            ],
            [
              9778.039,
              138.272,
              14073.407
            ],
            [
              9786.285,
              131.627,
              14083.997
            ],
            [
              9791.489,
              121.44,
              14095.437
            ],
            [
              9796.374,
              85.087,
              14132.116
            ],
            [
              9803.746,
              38.867,
              14178.921
            ],
            [
              9829,
              -19.539,
              14242.553
            ],
            [
              9893.228,
              -127.725,
              14368.368
            ],
            [
              9950.915,
              -240.232,
              14494.802
            ],
            [
              10000.794,
              -355.92,
              14620.785
            ],
            [
              10004.906,
              -370.35,
              14635.789
            ],
            [
              9909.839,
              -387.304,
              14732.356
            ],
            [
              9765.854,
              -393.225,
              14876.462
            ],
            [
              9656.901,
              -394.558,
              14985.424
            ],
            [
              9634.914,
              -397.45,
              15007.6
            ],
            [
              9568.733,
              -419.011,
              15077.205
            ],
            [
              9549.863,
              -423.677,
              15096.643
            ],
            [
              9353.83,
              -424.029,
              15292.676
            ],
            [
              9077.686,
              -426.428,
              15568.831
            ],
            [
              8999.086,
              -425.757,
              15647.434
            ],
            [
              8637.297,
              -425.144,
              16009.223
            ],
            [
              8583.813,
              -422.956,
              16062.752
            ],
            [
              8560.674,
              -579.465,
              16220.962
            ],
            [
              8539.859,
              -652.524,
              16296.929
            ],
            [
              8531.721,
              -672.4,
              16318.406
            ],
            [
              8487.656,
              -660.31,
              16364.1
            ],
            [
              8367.171,
              -581.146,
              16508.265
            ],
            [
              8316.776,
              -617.987,
              16570.69
            ],
            [
              8223.611,
              -697.391,
              16693.102
            ],
            [
              8208.584,
              -707.11,
              16710.998
            ],
            [
              8186.511,
              -714.461,
              16734.263
            ],
            [
              8174.886,
              -715.341,
              16745.921
            ],
            [
              8111.113,
              -711.839,
              16809.79
            ],
            [
              7990.769,
              -699.414,
              16930.774
            ],
            [
              7876.325,
              -682.607,
              17046.446
            ],
            [
              7825.635,
              -669.399,
              17098.828
            ],
            [
              7675.302,
              -640.799,
              17251.857
            ],
            [
              7649.128,
              -789.458,
              17402.803
            ],
            [
              7642.645,
              -888.412,
              17501.969
            ],
            [
              7789.211,
              -879.085,
              17648.832
            ],
            [
              7854.937,
              -849.223,
              17721.023
            ],
            [
              7929.289,
              -822.584,
              17800.003
            ],
            [
              7959.195,
              -812.14,
              17831.68
            ],
            [
              8004.239,
              -799.879,
              17878.364
            ],
            [
              8037.181,
              -797.197,
              17911.415
            ],
            [
              8131.96,
              -797.979,
              18006.197
            ],
            [
              8199.6,
              -801.56,
              18073.932
            ],
            [
              8316.695,
              -815.038,
              18191.8
            ],
            [
              8390.598,
              -821.883,
              18266.019
            ],
            [
              8436.278,
              -833.024,
              18313.038
            ],
            [
              8452.882,
              -841.15,
              18331.524
            ],
            [
              8489.177,
              -864.145,
              18374.49
            ],
            [
              8593.333,
              -879.597,
              18479.786
            ],
            [
              8629.498,
              -876.985,
              18516.045
            ],
            [
              8793.463,
              -924.493,
              18686.754
            ],
            [
              8878.821,
              -949.094,
              18775.587
            ],
            [
              9226.371,
              -1049.347,
              19137.307
            ],
            [
              9251.576,
              -1055.085,
              19163.157
            ],
            [
              9273.821,
              -1062.554,
              19186.622
            ],
            [
              9471.228,
              -1120.116,
              19392.25
            ],
            [
              9671.66,
              -1185.297,
              19603.015
            ],
            [
              9718.457,
              -1204.068,
              19653.436
            ],
            [
              9984.772,
              -1298.562,
              19936.018
            ],
            [
              9946.688,
              -1403.558,
              20047.707
            ],
            [
              9942.307,
              -1481.305,
              20125.579
            ],
            [
              9920.124,
              -1591.155,
              20237.646
            ],
            [
              9909.928,
              -1637.662,
              20285.257
            ],
            [
              9897.43,
              -1681.89,
              20331.217
            ],
            [
              9882.757,
              -1712.489,
              20365.152
            ],
            [
              9881.662,
              -1714.525,
              20367.464
            ],
            [
              9877.578,
              -1722.12,
              20376.087
            ],
            [
              9854.408,
              -1765.207,
              20425.009
            ],
            [
              9853.104,
              -1767.631,
              20427.762
            ],
            [
              9854.39,
              -1765.24,
              20430.477
            ],
            [
              9858.509,
              -1757.579,
              20439.175
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:17589",
              "position": {
                "x": 4786.728,
                "z": 10630.719
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 4.968,
              "arrivalOffsetSeconds": -120,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:5981",
              "position": {
                "x": 5750.274,
                "z": 10180.179
              },
              "distanceAlongShapeM": 1330.912,
              "shapeOffsetM": 2.843,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:5986",
              "position": {
                "x": 6984.236,
                "z": 8996.04
              },
              "distanceAlongShapeM": 3084.371,
              "shapeOffsetM": 3.057,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:6134",
              "position": {
                "x": 7319.162,
                "z": 8154.482
              },
              "distanceAlongShapeM": 4012.902,
              "shapeOffsetM": 3.306,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:6131",
              "position": {
                "x": 7383.302,
                "z": 7379.491
              },
              "distanceAlongShapeM": 4790.8,
              "shapeOffsetM": 7.102,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:16184",
              "position": {
                "x": 8058.864,
                "z": 5233.034
              },
              "distanceAlongShapeM": 7112.164,
              "shapeOffsetM": 2.836,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:16176",
              "position": {
                "x": 8380.527,
                "z": 4334.865
              },
              "distanceAlongShapeM": 8066.782,
              "shapeOffsetM": 8.25,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:4965",
              "position": {
                "x": 8920.296,
                "z": 2511.588
              },
              "distanceAlongShapeM": 9982.188,
              "shapeOffsetM": 19.543,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:6030",
              "position": {
                "x": 8696.422,
                "z": 1904.9
              },
              "distanceAlongShapeM": 10656.868,
              "shapeOffsetM": 2.936,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:7357",
              "position": {
                "x": 8821.879,
                "z": 1310.104
              },
              "distanceAlongShapeM": 11268.802,
              "shapeOffsetM": 4.43,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            },
            {
              "stopId": "judu:stop:6035",
              "position": {
                "x": 8692.348,
                "z": 547.88
              },
              "distanceAlongShapeM": 12061.554,
              "shapeOffsetM": 3.661,
              "arrivalOffsetSeconds": 1380,
              "departureOffsetSeconds": 1380
            },
            {
              "stopId": "judu:stop:6040",
              "position": {
                "x": 8718.239,
                "z": -120.617
              },
              "distanceAlongShapeM": 12929.644,
              "shapeOffsetM": 7.287,
              "arrivalOffsetSeconds": 1560,
              "departureOffsetSeconds": 1560
            },
            {
              "stopId": "judu:stop:6042",
              "position": {
                "x": 9116.151,
                "z": 132.979
              },
              "distanceAlongShapeM": 13412.438,
              "shapeOffsetM": 4.877,
              "arrivalOffsetSeconds": 1620,
              "departureOffsetSeconds": 1620
            },
            {
              "stopId": "judu:stop:6044",
              "position": {
                "x": 9552.934,
                "z": 138.6
              },
              "distanceAlongShapeM": 13848.319,
              "shapeOffsetM": 2.425,
              "arrivalOffsetSeconds": 1680,
              "departureOffsetSeconds": 1680
            },
            {
              "stopId": "judu:stop:6047",
              "position": {
                "x": 9800.829,
                "z": 85.686
              },
              "distanceAlongShapeM": 14132.227,
              "shapeOffsetM": 4.493,
              "arrivalOffsetSeconds": 1800,
              "departureOffsetSeconds": 1800
            },
            {
              "stopId": "judu:stop:16156",
              "position": {
                "x": 9909.859,
                "z": -387.464
              },
              "distanceAlongShapeM": 14732.356,
              "shapeOffsetM": 0.161,
              "arrivalOffsetSeconds": 1920,
              "departureOffsetSeconds": 1920
            },
            {
              "stopId": "judu:stop:16160",
              "position": {
                "x": 9596.607,
                "z": -410.031
              },
              "distanceAlongShapeM": 15047.92,
              "shapeOffsetM": 0.096,
              "arrivalOffsetSeconds": 1980,
              "departureOffsetSeconds": 1980
            },
            {
              "stopId": "judu:stop:16164",
              "position": {
                "x": 9077.667,
                "z": -430.684
              },
              "distanceAlongShapeM": 15568.831,
              "shapeOffsetM": 4.256,
              "arrivalOffsetSeconds": 2100,
              "departureOffsetSeconds": 2100
            },
            {
              "stopId": "judu:stop:16158",
              "position": {
                "x": 8637.297,
                "z": -425.144
              },
              "distanceAlongShapeM": 16009.223,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2160,
              "departureOffsetSeconds": 2160
            },
            {
              "stopId": "judu:stop:5400",
              "position": {
                "x": 8486.109,
                "z": -663.69
              },
              "distanceAlongShapeM": 16364.1,
              "shapeOffsetM": 3.717,
              "arrivalOffsetSeconds": 2280,
              "departureOffsetSeconds": 2280
            },
            {
              "stopId": "judu:stop:5415",
              "position": {
                "x": 7876.316,
                "z": -682.656
              },
              "distanceAlongShapeM": 17046.446,
              "shapeOffsetM": 0.05,
              "arrivalOffsetSeconds": 2400,
              "departureOffsetSeconds": 2400
            },
            {
              "stopId": "judu:stop:6054",
              "position": {
                "x": 7958.873,
                "z": -811.219
              },
              "distanceAlongShapeM": 17831.68,
              "shapeOffsetM": 0.976,
              "arrivalOffsetSeconds": 2520,
              "departureOffsetSeconds": 2520
            },
            {
              "stopId": "judu:stop:6056",
              "position": {
                "x": 8390.735,
                "z": -820.977
              },
              "distanceAlongShapeM": 18266.019,
              "shapeOffsetM": 0.916,
              "arrivalOffsetSeconds": 2640,
              "departureOffsetSeconds": 2640
            },
            {
              "stopId": "judu:stop:6059",
              "position": {
                "x": 8794.329,
                "z": -921.496
              },
              "distanceAlongShapeM": 18686.752,
              "shapeOffsetM": 3.12,
              "arrivalOffsetSeconds": 2700,
              "departureOffsetSeconds": 2700
            },
            {
              "stopId": "judu:stop:6062",
              "position": {
                "x": 9252.086,
                "z": -1053.208
              },
              "distanceAlongShapeM": 19163.157,
              "shapeOffsetM": 1.945,
              "arrivalOffsetSeconds": 2760,
              "departureOffsetSeconds": 2760
            },
            {
              "stopId": "judu:stop:6065",
              "position": {
                "x": 9672.457,
                "z": -1183.092
              },
              "distanceAlongShapeM": 19603.015,
              "shapeOffsetM": 2.345,
              "arrivalOffsetSeconds": 2820,
              "departureOffsetSeconds": 2820
            },
            {
              "stopId": "judu:stop:6069",
              "position": {
                "x": 9955.997,
                "z": -1381.473
              },
              "distanceAlongShapeM": 20023.772,
              "shapeOffsetM": 1.221,
              "arrivalOffsetSeconds": 2880,
              "departureOffsetSeconds": 2880
            },
            {
              "stopId": "judu:stop:342",
              "position": {
                "x": 9859.336,
                "z": -1758.024
              },
              "distanceAlongShapeM": 20439.175,
              "shapeOffsetM": 0.939,
              "arrivalOffsetSeconds": 2940,
              "departureOffsetSeconds": 2940
            }
          ],
          "departuresSeconds": [
            17100,
            21900,
            23700,
            26160,
            28620,
            30780,
            33120,
            36420,
            39300,
            43140,
            46800,
            50220,
            53880,
            56880,
            58980,
            61440,
            63780,
            66120,
            68580,
            72240,
            76620,
            79920,
            83100
          ]
        },
        {
          "id": "judu:pattern:vilnius_bus_14:1",
          "sourceRouteId": "vilnius_bus_14",
          "sourceShapeId": "vilnius_bus_14_b-a",
          "directionId": 1,
          "headsign": "Rudamina",
          "directionName": "Arimų–Parko g.–Grigaičiai–Didžiasalis–Rudamina",
          "mode": "bus",
          "routeShortName": "14",
          "routeLongName": "Rudamina–Didžiasalis–Grigaičiai–Parko–Arimų g.",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              9858.509,
              -1757.579,
              0
            ],
            [
              9897.43,
              -1681.89,
              85.11
            ],
            [
              9923.019,
              -1575.628,
              194.41
            ],
            [
              9942.374,
              -1480.279,
              291.703
            ],
            [
              9946.338,
              -1412.448,
              359.65
            ],
            [
              9959.785,
              -1362.152,
              411.713
            ],
            [
              9984.772,
              -1298.562,
              480.036
            ],
            [
              9756.88,
              -1217.097,
              722.051
            ],
            [
              9755.854,
              -1218.748,
              723.994
            ],
            [
              9705.012,
              -1199.341,
              778.414
            ],
            [
              9471.228,
              -1120.116,
              1025.257
            ],
            [
              9190.433,
              -1040.826,
              1317.032
            ],
            [
              9149.36,
              -1031.089,
              1359.244
            ],
            [
              9144.271,
              -1027.646,
              1365.388
            ],
            [
              9086.597,
              -1009.78,
              1425.766
            ],
            [
              8773.932,
              -923.659,
              1750.074
            ],
            [
              8687.842,
              -893.745,
              1841.214
            ],
            [
              8644.901,
              -880.635,
              1886.111
            ],
            [
              8624.985,
              -876.894,
              1906.376
            ],
            [
              8593.333,
              -879.597,
              1938.143
            ],
            [
              8489.821,
              -864.158,
              2042.8
            ],
            [
              8477.019,
              -859.447,
              2056.441
            ],
            [
              8459.816,
              -849.082,
              2076.525
            ],
            [
              8449.036,
              -839.959,
              2090.648
            ],
            [
              8421.519,
              -829.387,
              2120.126
            ],
            [
              8324.408,
              -816.306,
              2218.114
            ],
            [
              8300.804,
              -813.952,
              2241.834
            ],
            [
              8276.176,
              -810.703,
              2266.676
            ],
            [
              8198.955,
              -801.547,
              2344.438
            ],
            [
              8122.914,
              -798.912,
              2420.525
            ],
            [
              8006.796,
              -801.043,
              2536.662
            ],
            [
              7987.391,
              -803.996,
              2556.291
            ],
            [
              7940.058,
              -823.961,
              2607.662
            ],
            [
              7856.182,
              -851.475,
              2695.936
            ],
            [
              7787.9,
              -880.172,
              2770.003
            ],
            [
              7642.645,
              -888.412,
              2915.491
            ],
            [
              7643.176,
              -861.704,
              2942.205
            ],
            [
              7643.14,
              -841.77,
              2962.138
            ],
            [
              7644.596,
              -822.767,
              2981.197
            ],
            [
              7675.302,
              -640.799,
              3165.738
            ],
            [
              7843.017,
              -670.859,
              3336.125
            ],
            [
              7940.902,
              -687.034,
              3435.338
            ],
            [
              7983.745,
              -695.934,
              3479.095
            ],
            [
              8105.956,
              -711.736,
              3602.324
            ],
            [
              8174.886,
              -715.341,
              3671.348
            ],
            [
              8196.247,
              -711.316,
              3693.085
            ],
            [
              8219.654,
              -701.765,
              3718.366
            ],
            [
              8291.234,
              -637.515,
              3814.552
            ],
            [
              8322.689,
              -612.539,
              3854.716
            ],
            [
              8367.171,
              -581.146,
              3909.161
            ],
            [
              8434.632,
              -625.918,
              3990.127
            ],
            [
              8481.22,
              -650.233,
              4042.678
            ],
            [
              8531.721,
              -672.4,
              4097.83
            ],
            [
              8573.203,
              -469.501,
              4304.926
            ],
            [
              8571.94,
              -436.076,
              4338.375
            ],
            [
              8574.788,
              -422.774,
              4351.978
            ],
            [
              8666.491,
              -418.952,
              4443.761
            ],
            [
              8743.801,
              -420.608,
              4521.089
            ],
            [
              8906.3,
              -421.657,
              4683.591
            ],
            [
              9047.613,
              -418.441,
              4824.941
            ],
            [
              9204.269,
              -420.999,
              4981.618
            ],
            [
              9542.829,
              -422.298,
              5320.18
            ],
            [
              9555.123,
              -420.321,
              5332.632
            ],
            [
              9582.253,
              -411.139,
              5361.274
            ],
            [
              9636.453,
              -395.759,
              5417.614
            ],
            [
              9884.115,
              -386.377,
              5665.453
            ],
            [
              9942.526,
              -379.318,
              5724.289
            ],
            [
              9966.818,
              -374.737,
              5749.01
            ],
            [
              9985.026,
              -371.303,
              5767.539
            ],
            [
              9999.301,
              -365.91,
              5782.798
            ],
            [
              9996.949,
              -354.729,
              5794.224
            ],
            [
              9979.108,
              -318.867,
              5834.279
            ],
            [
              9967.299,
              -290.665,
              5864.853
            ],
            [
              9947.183,
              -233.476,
              5925.477
            ],
            [
              9888.206,
              -120.943,
              6052.528
            ],
            [
              9839.53,
              -40.906,
              6146.204
            ],
            [
              9813.404,
              6.385,
              6200.232
            ],
            [
              9798.056,
              44.55,
              6241.368
            ],
            [
              9791,
              78.093,
              6275.645
            ],
            [
              9786.285,
              131.627,
              6329.386
            ],
            [
              9766.321,
              133.147,
              6349.408
            ],
            [
              9682.329,
              129.236,
              6433.491
            ],
            [
              9621.808,
              131.634,
              6494.059
            ],
            [
              9517.36,
              133.756,
              6598.529
            ],
            [
              9448.882,
              128.466,
              6667.211
            ],
            [
              9389.611,
              131.895,
              6726.581
            ],
            [
              9156.08,
              129.945,
              6960.12
            ],
            [
              9090.691,
              117.908,
              7026.608
            ],
            [
              9071.372,
              103.392,
              7050.773
            ],
            [
              9049.578,
              94.246,
              7074.408
            ],
            [
              8990.008,
              50.917,
              7148.069
            ],
            [
              8869.532,
              -70.228,
              7318.922
            ],
            [
              8853.145,
              -83.257,
              7339.857
            ],
            [
              8819.883,
              -101.512,
              7377.799
            ],
            [
              8767.948,
              -118.279,
              7432.374
            ],
            [
              8695.316,
              -137.969,
              7507.627
            ],
            [
              8672.646,
              -150.383,
              7533.474
            ],
            [
              8624.533,
              -154.886,
              7581.797
            ],
            [
              8595.54,
              -160.454,
              7611.32
            ],
            [
              8604.283,
              -110.532,
              7662.001
            ],
            [
              8637.068,
              12.385,
              7789.216
            ],
            [
              8636.294,
              38.006,
              7814.848
            ],
            [
              8617.005,
              105.191,
              7884.747
            ],
            [
              8590.333,
              158.052,
              7943.956
            ],
            [
              8585.045,
              183.764,
              7970.206
            ],
            [
              8586.558,
              194.867,
              7981.412
            ],
            [
              8620.876,
              297.713,
              8089.833
            ],
            [
              8659.092,
              433.88,
              8231.261
            ],
            [
              8697.807,
              584.174,
              8386.461
            ],
            [
              8727.087,
              659.577,
              8467.35
            ],
            [
              8759.643,
              727.216,
              8542.415
            ],
            [
              8819.472,
              870.402,
              8697.599
            ],
            [
              8846.872,
              976.844,
              8807.511
            ],
            [
              8854.075,
              1018.886,
              8850.165
            ],
            [
              8852.191,
              1053.436,
              8884.766
            ],
            [
              8820.751,
              1266.063,
              9099.705
            ],
            [
              8821.267,
              1283.385,
              9117.035
            ],
            [
              8816.868,
              1314.381,
              9148.341
            ],
            [
              8803.5,
              1403.78,
              9238.735
            ],
            [
              8726.321,
              1627.089,
              9475.005
            ],
            [
              8709.628,
              1695.336,
              9545.264
            ],
            [
              8695.548,
              1856.955,
              9707.494
            ],
            [
              8691.341,
              1888.41,
              9739.23
            ],
            [
              8690.755,
              1943.979,
              9794.802
            ],
            [
              8687.807,
              2021.969,
              9872.848
            ],
            [
              8694.889,
              2071.277,
              9922.662
            ],
            [
              8714.191,
              2131.483,
              9985.886
            ],
            [
              8739.783,
              2167.877,
              10030.377
            ],
            [
              8789.814,
              2216.968,
              10100.47
            ],
            [
              8839.29,
              2270.523,
              10173.381
            ],
            [
              8861.119,
              2329.088,
              10235.882
            ],
            [
              8873.164,
              2395.571,
              10303.447
            ],
            [
              8889.584,
              2460.002,
              10369.938
            ],
            [
              8901.904,
              2553.156,
              10463.904
            ],
            [
              8891.971,
              2625.775,
              10537.199
            ],
            [
              8844.081,
              2893.865,
              10809.532
            ],
            [
              8816.266,
              3018.004,
              10936.749
            ],
            [
              8737.273,
              3224.747,
              11158.07
            ],
            [
              8666.307,
              3395.562,
              11343.039
            ],
            [
              8588.584,
              3629.121,
              11589.191
            ],
            [
              8586.413,
              3640.955,
              11601.222
            ],
            [
              8565.578,
              3697.008,
              11661.022
            ],
            [
              8555.783,
              3698.512,
              11670.932
            ],
            [
              8549.758,
              3702.999,
              11678.444
            ],
            [
              8551.031,
              3726.934,
              11702.413
            ],
            [
              8519.117,
              3856.433,
              11835.786
            ],
            [
              8452.796,
              4062.099,
              12051.882
            ],
            [
              8358.803,
              4364.495,
              12368.549
            ],
            [
              8285.348,
              4610.432,
              12625.221
            ],
            [
              8179.106,
              4935.496,
              12967.207
            ],
            [
              8066.968,
              5186.114,
              13241.768
            ],
            [
              7979.641,
              5394.37,
              13467.593
            ],
            [
              7942.136,
              5487.635,
              13568.116
            ],
            [
              7871.26,
              5669.837,
              13763.618
            ],
            [
              7850.792,
              5777.119,
              13872.835
            ],
            [
              7861.16,
              6024.042,
              14119.976
            ],
            [
              7872.697,
              6126.268,
              14222.851
            ],
            [
              7879.43,
              6290.793,
              14387.513
            ],
            [
              7862.95,
              6388.066,
              14486.172
            ],
            [
              7808.99,
              6532.752,
              14640.593
            ],
            [
              7714.906,
              6673.782,
              14810.125
            ],
            [
              7583.294,
              6844.498,
              15025.684
            ],
            [
              7467.937,
              7028.855,
              15243.158
            ],
            [
              7408.088,
              7163.026,
              15390.072
            ],
            [
              7386.487,
              7252.734,
              15482.344
            ],
            [
              7369.167,
              7431.41,
              15661.857
            ],
            [
              7349.896,
              7730.618,
              15961.686
            ],
            [
              7321.385,
              8083.103,
              16315.322
            ],
            [
              7310.334,
              8184.67,
              16417.488
            ],
            [
              7307.762,
              8231.523,
              16464.412
            ],
            [
              7293.63,
              8366.508,
              16600.134
            ],
            [
              7289.46,
              8384.403,
              16618.509
            ],
            [
              7287.294,
              8405.597,
              16639.813
            ],
            [
              7277.531,
              8434.735,
              16670.543
            ],
            [
              7258.703,
              8462.939,
              16704.454
            ],
            [
              7199.274,
              8523.215,
              16789.101
            ],
            [
              7185.357,
              8544.542,
              16814.567
            ],
            [
              7179.271,
              8563.588,
              16834.562
            ],
            [
              7147.693,
              8698.916,
              16973.525
            ],
            [
              7134.896,
              8738.133,
              17014.777
            ],
            [
              7111.941,
              8780.618,
              17063.067
            ],
            [
              6966.325,
              9013.166,
              17337.443
            ],
            [
              6944.198,
              9052.862,
              17382.89
            ],
            [
              6923.851,
              9078.916,
              17415.948
            ],
            [
              6913.209,
              9097.632,
              17437.478
            ],
            [
              6869.616,
              9162.846,
              17515.92
            ],
            [
              6826.399,
              9218.458,
              17586.35
            ],
            [
              6802.783,
              9243.151,
              17620.518
            ],
            [
              6756.87,
              9272.943,
              17675.251
            ],
            [
              6501.766,
              9387.846,
              17955.037
            ],
            [
              6465.588,
              9406.996,
              17995.971
            ],
            [
              6447.825,
              9424.042,
              18020.59
            ],
            [
              6308.307,
              9593.759,
              18240.292
            ],
            [
              5941.639,
              10082.93,
              18851.63
            ],
            [
              5920.633,
              10104.364,
              18881.641
            ],
            [
              5906.059,
              10113.697,
              18898.947
            ],
            [
              5712.31,
              10190.838,
              19107.488
            ],
            [
              5616.885,
              10235.089,
              19212.674
            ],
            [
              5562.694,
              10269.478,
              19276.856
            ],
            [
              5466.994,
              10339.297,
              19395.318
            ],
            [
              5408.901,
              10377.158,
              19464.659
            ],
            [
              5325.109,
              10423.307,
              19560.319
            ],
            [
              5232.119,
              10461.84,
              19660.977
            ],
            [
              4788.595,
              10635.322,
              20137.222
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:342",
              "position": {
                "x": 9859.336,
                "z": -1758.024
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 0.939,
              "arrivalOffsetSeconds": -900,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:6068",
              "position": {
                "x": 9955.14,
                "z": -1360.302
              },
              "distanceAlongShapeM": 411.736,
              "shapeOffsetM": 5,
              "arrivalOffsetSeconds": 60,
              "departureOffsetSeconds": 60
            },
            {
              "stopId": "judu:stop:6066",
              "position": {
                "x": 9754.856,
                "z": -1221.509
              },
              "distanceAlongShapeM": 723.994,
              "shapeOffsetM": 2.936,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:6064",
              "position": {
                "x": 9149.36,
                "z": -1031.089
              },
              "distanceAlongShapeM": 1359.244,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:6060",
              "position": {
                "x": 8772.945,
                "z": -926.631
              },
              "distanceAlongShapeM": 1750.074,
              "shapeOffsetM": 3.132,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:6057",
              "position": {
                "x": 8300.557,
                "z": -815.828
              },
              "distanceAlongShapeM": 2241.834,
              "shapeOffsetM": 1.893,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:6055",
              "position": {
                "x": 7940.535,
                "z": -825.326
              },
              "distanceAlongShapeM": 2607.662,
              "shapeOffsetM": 1.446,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:5394",
              "position": {
                "x": 7639.707,
                "z": -841.596
              },
              "distanceAlongShapeM": 2962.138,
              "shapeOffsetM": 3.437,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:5396",
              "position": {
                "x": 7941.422,
                "z": -683.956
              },
              "distanceAlongShapeM": 3435.338,
              "shapeOffsetM": 3.122,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:6225",
              "position": {
                "x": 8539.64,
                "z": -631.367
              },
              "distanceAlongShapeM": 4139.618,
              "shapeOffsetM": 0.461,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:16167",
              "position": {
                "x": 8666.486,
                "z": -416.825
              },
              "distanceAlongShapeM": 4443.761,
              "shapeOffsetM": 2.127,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:16165",
              "position": {
                "x": 9047.616,
                "z": -417.831
              },
              "distanceAlongShapeM": 4824.941,
              "shapeOffsetM": 0.61,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:16162",
              "position": {
                "x": 9579.337,
                "z": -403
              },
              "distanceAlongShapeM": 5361.121,
              "shapeOffsetM": 8.645,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            },
            {
              "stopId": "judu:stop:6049",
              "position": {
                "x": 9971.821,
                "z": -321.93
              },
              "distanceAlongShapeM": 5834.279,
              "shapeOffsetM": 7.905,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:6073",
              "position": {
                "x": 9682.346,
                "z": 127.063
              },
              "distanceAlongShapeM": 6433.491,
              "shapeOffsetM": 2.173,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:6045",
              "position": {
                "x": 9448.882,
                "z": 128.466
              },
              "distanceAlongShapeM": 6667.211,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:6043",
              "position": {
                "x": 9073.545,
                "z": 99.328
              },
              "distanceAlongShapeM": 7050.773,
              "shapeOffsetM": 4.609,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            },
            {
              "stopId": "judu:stop:6041",
              "position": {
                "x": 8673.105,
                "z": -151.995
              },
              "distanceAlongShapeM": 7533.474,
              "shapeOffsetM": 1.676,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            },
            {
              "stopId": "judu:stop:6032",
              "position": {
                "x": 8721.736,
                "z": 661.957
              },
              "distanceAlongShapeM": 8467.35,
              "shapeOffsetM": 5.856,
              "arrivalOffsetSeconds": 1620,
              "departureOffsetSeconds": 1620
            },
            {
              "stopId": "judu:stop:7356",
              "position": {
                "x": 8817.758,
                "z": 1265.655
              },
              "distanceAlongShapeM": 9099.705,
              "shapeOffsetM": 3.02,
              "arrivalOffsetSeconds": 1680,
              "departureOffsetSeconds": 1680
            },
            {
              "stopId": "judu:stop:6029",
              "position": {
                "x": 8689.636,
                "z": 1888.337
              },
              "distanceAlongShapeM": 9739.23,
              "shapeOffsetM": 1.707,
              "arrivalOffsetSeconds": 1800,
              "departureOffsetSeconds": 1800
            },
            {
              "stopId": "judu:stop:16179",
              "position": {
                "x": 8885.791,
                "z": 2624.726
              },
              "distanceAlongShapeM": 10536.997,
              "shapeOffsetM": 6.266,
              "arrivalOffsetSeconds": 1920,
              "departureOffsetSeconds": 1920
            },
            {
              "stopId": "judu:stop:16182",
              "position": {
                "x": 8525.272,
                "z": 3826.533
              },
              "distanceAlongShapeM": 11805.283,
              "shapeOffsetM": 1.178,
              "arrivalOffsetSeconds": 2040,
              "departureOffsetSeconds": 2040
            },
            {
              "stopId": "judu:stop:16180",
              "position": {
                "x": 8354.625,
                "z": 4363.216
              },
              "distanceAlongShapeM": 12368.549,
              "shapeOffsetM": 4.369,
              "arrivalOffsetSeconds": 2100,
              "departureOffsetSeconds": 2100
            },
            {
              "stopId": "judu:stop:16183",
              "position": {
                "x": 7970.313,
                "z": 5390.658
              },
              "distanceAlongShapeM": 13467.629,
              "shapeOffsetM": 10.04,
              "arrivalOffsetSeconds": 2220,
              "departureOffsetSeconds": 2220
            },
            {
              "stopId": "judu:stop:6130",
              "position": {
                "x": 7364.295,
                "z": 7431.078
              },
              "distanceAlongShapeM": 15661.857,
              "shapeOffsetM": 4.883,
              "arrivalOffsetSeconds": 2400,
              "departureOffsetSeconds": 2400
            },
            {
              "stopId": "judu:stop:6133",
              "position": {
                "x": 7301.003,
                "z": 8183.786
              },
              "distanceAlongShapeM": 16417.488,
              "shapeOffsetM": 9.373,
              "arrivalOffsetSeconds": 2520,
              "departureOffsetSeconds": 2520
            },
            {
              "stopId": "judu:stop:6137",
              "position": {
                "x": 6919.899,
                "z": 9076.348
              },
              "distanceAlongShapeM": 17415.948,
              "shapeOffsetM": 4.713,
              "arrivalOffsetSeconds": 2640,
              "departureOffsetSeconds": 2640
            },
            {
              "stopId": "judu:stop:5982",
              "position": {
                "x": 5710.988,
                "z": 10187.621
              },
              "distanceAlongShapeM": 19107.488,
              "shapeOffsetM": 3.478,
              "arrivalOffsetSeconds": 2820,
              "departureOffsetSeconds": 2820
            },
            {
              "stopId": "judu:stop:17589",
              "position": {
                "x": 4786.728,
                "z": 10630.719
              },
              "distanceAlongShapeM": 20137.222,
              "shapeOffsetM": 4.968,
              "arrivalOffsetSeconds": 2880,
              "departureOffsetSeconds": 2880
            }
          ],
          "departuresSeconds": [
            18900,
            20700,
            23100,
            25500,
            27600,
            30000,
            33420,
            36360,
            39960,
            43560,
            47160,
            50760,
            53760,
            55860,
            58260,
            60660,
            63060,
            65460,
            69180,
            73560,
            76860,
            80100,
            83340
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_bus_15",
      "sourceRouteId": "vilnius_bus_15",
      "mode": "bus",
      "shortName": "15",
      "longName": "Žolyno g.–Antakalnis–Turniškės",
      "color": "0073AC",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_bus_15:0",
          "sourceRouteId": "vilnius_bus_15",
          "sourceShapeId": "vilnius_bus_15_a-b",
          "directionId": 0,
          "headsign": "Turniškės",
          "directionName": "Žolyno g.–Antakalnis–Turniškės",
          "mode": "bus",
          "routeShortName": "15",
          "routeLongName": "Žolyno g.–Antakalnis–Turniškės",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              3855.286,
              -2232.394,
              0
            ],
            [
              3777.563,
              -2239.239,
              78.024
            ],
            [
              3730.395,
              -2245.02,
              125.544
            ],
            [
              3478.067,
              -2293.658,
              382.517
            ],
            [
              3430.234,
              -2300.543,
              430.843
            ],
            [
              3387.662,
              -2301.962,
              473.439
            ],
            [
              3196.764,
              -2272.74,
              666.561
            ],
            [
              3157.806,
              -2287.589,
              708.253
            ],
            [
              3002.929,
              -2364.816,
              881.316
            ],
            [
              2811.307,
              -2442.469,
              1088.074
            ],
            [
              2719.174,
              -2508.643,
              1201.509
            ],
            [
              2680.157,
              -2526.834,
              1244.558
            ],
            [
              2599.153,
              -2549.802,
              1328.756
            ],
            [
              2457.059,
              -2599.457,
              1479.276
            ],
            [
              2382.154,
              -2627.435,
              1559.235
            ],
            [
              2328.687,
              -2639.354,
              1614.015
            ],
            [
              2411.872,
              -3118.499,
              2100.327
            ],
            [
              2415.738,
              -3139.252,
              2121.437
            ],
            [
              2418.768,
              -3163.158,
              2145.534
            ],
            [
              2474.472,
              -3526.012,
              2512.639
            ],
            [
              2513.109,
              -3664.781,
              2656.686
            ],
            [
              2520.474,
              -3683.355,
              2676.668
            ],
            [
              2522.312,
              -3689.445,
              2683.029
            ],
            [
              2535.711,
              -3730.887,
              2726.583
            ],
            [
              2556.818,
              -3773.588,
              2774.216
            ],
            [
              2579.36,
              -3808.522,
              2815.791
            ],
            [
              2619.624,
              -3860.489,
              2881.531
            ],
            [
              2635.392,
              -3877.441,
              2904.683
            ],
            [
              2642.893,
              -3890.985,
              2920.165
            ],
            [
              2709.56,
              -3977.961,
              3029.752
            ],
            [
              3021.059,
              -4338.966,
              3506.571
            ],
            [
              3040.626,
              -4360.488,
              3535.659
            ],
            [
              3055.715,
              -4376.506,
              3557.664
            ],
            [
              3068.958,
              -4395.535,
              3580.848
            ],
            [
              3153.475,
              -4491.761,
              3708.921
            ],
            [
              3273.19,
              -4634.3,
              3895.063
            ],
            [
              3314.847,
              -4683.97,
              3959.889
            ],
            [
              3313.956,
              -4692.963,
              3968.926
            ],
            [
              3308.075,
              -4697.304,
              3976.236
            ],
            [
              3299.661,
              -4699.371,
              3984.9
            ],
            [
              3277.414,
              -4683.364,
              4012.307
            ],
            [
              3252.761,
              -4658.405,
              4047.389
            ],
            [
              3232.404,
              -4644.66,
              4071.952
            ],
            [
              3223.387,
              -4644.489,
              4080.97
            ],
            [
              3212.182,
              -4656.828,
              4097.638
            ],
            [
              3040.179,
              -4759.027,
              4297.712
            ],
            [
              2915.811,
              -4831.406,
              4441.608
            ],
            [
              2711.294,
              -4946.528,
              4676.3
            ],
            [
              2678.277,
              -4962.937,
              4713.17
            ],
            [
              2617.044,
              -4981.921,
              4777.278
            ],
            [
              2514.567,
              -5005.782,
              4882.496
            ],
            [
              2466.981,
              -5014.351,
              4930.847
            ],
            [
              2459.717,
              -5015.05,
              4938.145
            ],
            [
              2477.192,
              -4890.915,
              5063.504
            ],
            [
              2478.273,
              -4847.513,
              5106.92
            ],
            [
              2467.953,
              -4744.499,
              5210.449
            ],
            [
              2456.892,
              -4693.21,
              5262.917
            ],
            [
              2442.274,
              -4637.442,
              5320.569
            ],
            [
              2414.258,
              -4598.556,
              5368.496
            ],
            [
              2383.913,
              -4573.045,
              5408.14
            ],
            [
              2367.733,
              -4562.047,
              5427.704
            ],
            [
              2340.004,
              -4545.458,
              5460.017
            ],
            [
              2306.93,
              -4522.572,
              5500.237
            ],
            [
              2282.55,
              -4496.91,
              5535.633
            ],
            [
              2226.836,
              -4533.318,
              5602.188
            ],
            [
              2194.425,
              -4557.766,
              5642.786
            ],
            [
              2023.857,
              -4667.428,
              5845.565
            ],
            [
              1937.537,
              -4728.535,
              5951.325
            ],
            [
              1867.134,
              -4788.872,
              6044.046
            ],
            [
              1634.717,
              -4873.729,
              6291.469
            ],
            [
              1419.845,
              -4960.882,
              6523.343
            ],
            [
              1390.251,
              -4966.37,
              6553.442
            ],
            [
              1372.845,
              -4968.418,
              6570.968
            ],
            [
              1253.552,
              -4950.953,
              6691.533
            ],
            [
              1217.033,
              -4945.712,
              6728.426
            ],
            [
              1176.266,
              -4939.77,
              6769.623
            ],
            [
              1118.975,
              -4934.63,
              6827.145
            ],
            [
              1098.764,
              -4947.615,
              6851.168
            ],
            [
              1088.192,
              -4961.892,
              6868.933
            ],
            [
              1083.868,
              -4972.85,
              6880.713
            ],
            [
              1006.146,
              -5218.651,
              7138.509
            ],
            [
              963.765,
              -5358.008,
              7284.168
            ],
            [
              947.584,
              -5434.792,
              7362.639
            ],
            [
              918.816,
              -5587.751,
              7518.279
            ],
            [
              921.352,
              -5743.695,
              7674.244
            ],
            [
              937.406,
              -5832.544,
              7764.531
            ],
            [
              967.755,
              -5975.104,
              7910.286
            ],
            [
              974.352,
              -6008.625,
              7944.45
            ],
            [
              984.893,
              -6031.469,
              7969.609
            ],
            [
              991.707,
              -6049.171,
              7988.577
            ],
            [
              1019.122,
              -6056.27,
              8016.897
            ],
            [
              1427.516,
              -6173.724,
              8441.845
            ],
            [
              1450.227,
              -6176.718,
              8464.752
            ],
            [
              1479.222,
              -6177.013,
              8493.749
            ],
            [
              1579.802,
              -6136.578,
              8602.152
            ],
            [
              2228.31,
              -5864.8,
              9305.307
            ],
            [
              2307.913,
              -5828.97,
              9392.602
            ],
            [
              2314.172,
              -5888.675,
              9452.634
            ],
            [
              2340.618,
              -6008.19,
              9575.039
            ],
            [
              2375.766,
              -6139.026,
              9710.514
            ],
            [
              2403.257,
              -6223.475,
              9799.326
            ],
            [
              2449.696,
              -6296.391,
              9885.774
            ],
            [
              2590.403,
              -6470.118,
              10109.335
            ],
            [
              2613.25,
              -6493.228,
              10141.832
            ],
            [
              2629.114,
              -6505.772,
              10162.056
            ],
            [
              2638.687,
              -6510.406,
              10172.692
            ],
            [
              2652.624,
              -6512.367,
              10186.766
            ],
            [
              2665.14,
              -6501.93,
              10203.063
            ],
            [
              2767.649,
              -6291.981,
              10436.701
            ],
            [
              2777.043,
              -6277.001,
              10454.382
            ],
            [
              2813.404,
              -6257.67,
              10495.563
            ],
            [
              2840.71,
              -6250.75,
              10523.732
            ],
            [
              2857.331,
              -6250.94,
              10540.354
            ],
            [
              2873.255,
              -6252.973,
              10556.407
            ],
            [
              3081.554,
              -6358.425,
              10789.878
            ],
            [
              3095.462,
              -6365.399,
              10805.436
            ],
            [
              3098.685,
              -6367.913,
              10809.524
            ],
            [
              3099.858,
              -6368.491,
              10810.832
            ],
            [
              3093.797,
              -6365.479,
              10817.601
            ],
            [
              3079.287,
              -6358.22,
              10833.826
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:1167",
              "position": {
                "x": 3855.662,
                "z": -2234.048
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 1.696,
              "arrivalOffsetSeconds": -540,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:4521",
              "position": {
                "x": 3280.303,
                "z": -2286.568
              },
              "distanceAlongShapeM": 581.891,
              "shapeOffsetM": 1.028,
              "arrivalOffsetSeconds": 60,
              "departureOffsetSeconds": 60
            },
            {
              "stopId": "judu:stop:11046",
              "position": {
                "x": 2680.157,
                "z": -2526.834
              },
              "distanceAlongShapeM": 1244.558,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:6720",
              "position": {
                "x": 2382.396,
                "z": -2628.114
              },
              "distanceAlongShapeM": 1559.235,
              "shapeOffsetM": 0.721,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:1035",
              "position": {
                "x": 2419.872,
                "z": -3138.687
              },
              "distanceAlongShapeM": 2121.437,
              "shapeOffsetM": 4.173,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:6711",
              "position": {
                "x": 2522.438,
                "z": -3682.768
              },
              "distanceAlongShapeM": 2676.673,
              "shapeOffsetM": 2.05,
              "arrivalOffsetSeconds": 450,
              "departureOffsetSeconds": 450
            },
            {
              "stopId": "judu:stop:741",
              "position": {
                "x": 2636.723,
                "z": -3876.397
              },
              "distanceAlongShapeM": 2904.683,
              "shapeOffsetM": 1.691,
              "arrivalOffsetSeconds": 510,
              "departureOffsetSeconds": 510
            },
            {
              "stopId": "judu:stop:3566",
              "position": {
                "x": 3057.099,
                "z": -4375.272
              },
              "distanceAlongShapeM": 3557.664,
              "shapeOffsetM": 1.854,
              "arrivalOffsetSeconds": 630,
              "departureOffsetSeconds": 630
            },
            {
              "stopId": "judu:stop:6083",
              "position": {
                "x": 2917.006,
                "z": -4833.515
              },
              "distanceAlongShapeM": 4441.608,
              "shapeOffsetM": 2.425,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:16155",
              "position": {
                "x": 2468.085,
                "z": -4964.219
              },
              "distanceAlongShapeM": 4989.646,
              "shapeOffsetM": 1.2,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:16147",
              "position": {
                "x": 2194.798,
                "z": -4558.323
              },
              "distanceAlongShapeM": 5642.786,
              "shapeOffsetM": 0.671,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            },
            {
              "stopId": "judu:stop:16148",
              "position": {
                "x": 1942.804,
                "z": -4735.073
              },
              "distanceAlongShapeM": 5950.804,
              "shapeOffsetM": 8.38,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:16145",
              "position": {
                "x": 1216.637,
                "z": -4948.682
              },
              "distanceAlongShapeM": 6728.396,
              "shapeOffsetM": 2.996,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:16149",
              "position": {
                "x": 953.825,
                "z": -5435.882
              },
              "distanceAlongShapeM": 7362.418,
              "shapeOffsetM": 6.332,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:16150",
              "position": {
                "x": 974.169,
                "z": -5973.957
              },
              "distanceAlongShapeM": 7910.399,
              "shapeOffsetM": 6.515,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:16152",
              "position": {
                "x": 1579.802,
                "z": -6136.578
              },
              "distanceAlongShapeM": 8602.152,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            },
            {
              "stopId": "judu:stop:16153",
              "position": {
                "x": 2129.65,
                "z": -5905.257
              },
              "distanceAlongShapeM": 9198.677,
              "shapeOffsetM": 0.82,
              "arrivalOffsetSeconds": 1380,
              "departureOffsetSeconds": 1380
            },
            {
              "stopId": "judu:stop:6095",
              "position": {
                "x": 2571.037,
                "z": -6443.45
              },
              "distanceAlongShapeM": 10076.423,
              "shapeOffsetM": 1.736,
              "arrivalOffsetSeconds": 1500,
              "departureOffsetSeconds": 1500
            },
            {
              "stopId": "judu:stop:1028",
              "position": {
                "x": 3072.159,
                "z": -6371.637
              },
              "distanceAlongShapeM": 10833.826,
              "shapeOffsetM": 15.193,
              "arrivalOffsetSeconds": 1560,
              "departureOffsetSeconds": 1560
            }
          ],
          "departuresSeconds": [
            22380,
            24540,
            26640,
            28860,
            31080,
            33240,
            37020,
            39120,
            41400,
            43200,
            44820,
            46320,
            47820,
            49320,
            50820,
            52320,
            54420,
            56220,
            58200,
            60180,
            61560,
            63060,
            64620,
            66240,
            67800,
            69360,
            75660,
            77760,
            79860,
            81960,
            84000,
            86040
          ]
        },
        {
          "id": "judu:pattern:vilnius_bus_15:1",
          "sourceRouteId": "vilnius_bus_15",
          "sourceShapeId": "vilnius_bus_15_b-a",
          "directionId": 1,
          "headsign": "Žolyno g.",
          "directionName": "Turniškės–Antakalnis–Žolyno g.",
          "mode": "bus",
          "routeShortName": "15",
          "routeLongName": "Žolyno g.–Antakalnis–Turniškės",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              3079.287,
              -6358.22,
              0
            ],
            [
              3061.297,
              -6347.635,
              20.872
            ],
            [
              2902.861,
              -6264.903,
              199.609
            ],
            [
              2876.653,
              -6254.389,
              227.847
            ],
            [
              2856.101,
              -6250.857,
              248.701
            ],
            [
              2840.71,
              -6250.75,
              264.092
            ],
            [
              2812.369,
              -6258.169,
              293.388
            ],
            [
              2777.043,
              -6277.001,
              333.42
            ],
            [
              2735.637,
              -6355.262,
              421.959
            ],
            [
              2673.248,
              -6487.678,
              568.337
            ],
            [
              2663.276,
              -6504.189,
              587.625
            ],
            [
              2652.624,
              -6512.367,
              601.054
            ],
            [
              2646.317,
              -6513.297,
              607.43
            ],
            [
              2634.523,
              -6509.177,
              619.923
            ],
            [
              2605.603,
              -6487.907,
              655.822
            ],
            [
              2598.569,
              -6481.499,
              665.338
            ],
            [
              2545.165,
              -6415.132,
              750.523
            ],
            [
              2442.609,
              -6286.293,
              915.196
            ],
            [
              2423.775,
              -6260.334,
              947.268
            ],
            [
              2403.26,
              -6220.985,
              991.643
            ],
            [
              2387.917,
              -6180.619,
              1034.827
            ],
            [
              2327.75,
              -5954.612,
              1268.706
            ],
            [
              2313.675,
              -5880.873,
              1343.776
            ],
            [
              2308.179,
              -5829.56,
              1395.383
            ],
            [
              2277.224,
              -5843.704,
              1429.416
            ],
            [
              2253.133,
              -5854.719,
              1455.905
            ],
            [
              2186.104,
              -5882.935,
              1528.631
            ],
            [
              1550.581,
              -6149.394,
              2217.753
            ],
            [
              1522.663,
              -6161.977,
              2248.377
            ],
            [
              1472.076,
              -6178.675,
              2301.647
            ],
            [
              1432.873,
              -6177.176,
              2340.879
            ],
            [
              1348.419,
              -6153.967,
              2428.464
            ],
            [
              986.377,
              -6052.319,
              2804.506
            ],
            [
              968.837,
              -6020.648,
              2840.709
            ],
            [
              969.202,
              -5999.815,
              2861.545
            ],
            [
              961.161,
              -5945.885,
              2916.071
            ],
            [
              943.844,
              -5872.091,
              2991.87
            ],
            [
              923.346,
              -5757.175,
              3108.6
            ],
            [
              915.738,
              -5656.689,
              3209.374
            ],
            [
              923.281,
              -5560.213,
              3306.144
            ],
            [
              952.194,
              -5406.708,
              3462.348
            ],
            [
              970.809,
              -5322.469,
              3548.619
            ],
            [
              978.203,
              -5301.629,
              3570.732
            ],
            [
              1054.122,
              -5062.569,
              3821.558
            ],
            [
              1069.297,
              -5008.3,
              3877.908
            ],
            [
              1072.198,
              -4997.859,
              3888.745
            ],
            [
              1086.945,
              -4959.643,
              3929.707
            ],
            [
              1095.833,
              -4947.834,
              3944.488
            ],
            [
              1104.704,
              -4939.932,
              3956.368
            ],
            [
              1118.975,
              -4934.63,
              3971.592
            ],
            [
              1142.2,
              -4932.833,
              3994.886
            ],
            [
              1277.376,
              -4952.022,
              4131.418
            ],
            [
              1313.697,
              -4960.498,
              4168.714
            ],
            [
              1359.318,
              -4966.91,
              4214.784
            ],
            [
              1389.607,
              -4966.358,
              4245.078
            ],
            [
              1429.741,
              -4955.97,
              4286.534
            ],
            [
              1621.931,
              -4875.456,
              4494.908
            ],
            [
              1827.524,
              -4801.945,
              4713.248
            ],
            [
              1854.801,
              -4790.208,
              4742.943
            ],
            [
              1892.618,
              -4761.763,
              4790.263
            ],
            [
              1911.281,
              -4745.922,
              4814.743
            ],
            [
              2211.295,
              -4537.48,
              5180.06
            ],
            [
              2213.373,
              -4529.726,
              5188.087
            ],
            [
              2275.248,
              -4494.147,
              5259.462
            ],
            [
              2318.377,
              -4530.58,
              5315.92
            ],
            [
              2409.89,
              -4592.552,
              5426.443
            ],
            [
              2434.591,
              -4620.707,
              5463.897
            ],
            [
              2445.164,
              -4640.944,
              5486.729
            ],
            [
              2469.174,
              -4740.574,
              5589.212
            ],
            [
              2477,
              -4803.073,
              5652.199
            ],
            [
              2479.803,
              -4866.445,
              5715.632
            ],
            [
              2476.456,
              -4919.775,
              5769.068
            ],
            [
              2463.032,
              -5001.717,
              5852.102
            ],
            [
              2467.989,
              -5013.444,
              5864.833
            ],
            [
              2479.923,
              -5012.706,
              5876.791
            ],
            [
              2497.431,
              -5008.893,
              5894.709
            ],
            [
              2653.861,
              -4972.649,
              6055.283
            ],
            [
              2718.503,
              -4942.283,
              6126.702
            ],
            [
              2869.838,
              -4856.479,
              6300.669
            ],
            [
              2886.379,
              -4847.107,
              6319.68
            ],
            [
              2909.627,
              -4833.933,
              6346.401
            ],
            [
              3212.543,
              -4656.53,
              6697.443
            ],
            [
              3218.499,
              -4650.823,
              6705.692
            ],
            [
              3221.672,
              -4645.56,
              6711.838
            ],
            [
              3217.76,
              -4635.476,
              6722.654
            ],
            [
              3140.028,
              -4589.474,
              6812.978
            ],
            [
              3137.62,
              -4580.522,
              6822.248
            ],
            [
              3139.678,
              -4573.882,
              6829.2
            ],
            [
              3146.203,
              -4569.552,
              6837.031
            ],
            [
              3156.487,
              -4570.86,
              6847.398
            ],
            [
              3202.417,
              -4595.108,
              6899.336
            ],
            [
              3210.79,
              -4595.267,
              6907.71
            ],
            [
              3215.74,
              -4591.823,
              6913.74
            ],
            [
              3219.006,
              -4584.137,
              6922.091
            ],
            [
              3218.877,
              -4576.495,
              6929.734
            ],
            [
              3193.34,
              -4554.253,
              6963.6
            ],
            [
              3172.809,
              -4525.525,
              6998.91
            ],
            [
              3060.003,
              -4392.026,
              7173.687
            ],
            [
              3021.059,
              -4338.966,
              7239.505
            ],
            [
              2961.544,
              -4283.292,
              7321.002
            ],
            [
              2940.311,
              -4262.522,
              7350.704
            ],
            [
              2920.517,
              -4237.987,
              7382.228
            ],
            [
              2810.169,
              -4110.107,
              7551.136
            ],
            [
              2739.116,
              -4050.879,
              7643.637
            ],
            [
              2661.391,
              -4003.772,
              7734.523
            ],
            [
              2637.654,
              -3993.387,
              7760.433
            ],
            [
              2619.338,
              -3978.489,
              7784.043
            ],
            [
              2604.004,
              -3971.521,
              7800.886
            ],
            [
              2521.22,
              -3923.064,
              7896.809
            ],
            [
              2506.601,
              -3911.447,
              7915.482
            ],
            [
              2490.099,
              -3890.638,
              7942.04
            ],
            [
              2480.459,
              -3864.316,
              7970.071
            ],
            [
              2475.702,
              -3831.185,
              8003.542
            ],
            [
              2503.004,
              -3722.48,
              8115.623
            ],
            [
              2508.663,
              -3661.358,
              8177.007
            ],
            [
              2467.501,
              -3518.217,
              8325.949
            ],
            [
              2463.864,
              -3499.82,
              8344.701
            ],
            [
              2434.339,
              -3309.248,
              8537.548
            ],
            [
              2430.841,
              -3283.862,
              8563.173
            ],
            [
              2426.976,
              -3256.769,
              8590.54
            ],
            [
              2328.687,
              -2639.354,
              9215.73
            ],
            [
              2422.077,
              -2608.82,
              9313.985
            ],
            [
              2444.816,
              -2599.227,
              9338.665
            ],
            [
              2646.504,
              -2533.994,
              9550.64
            ],
            [
              2717.262,
              -2507.494,
              9626.197
            ],
            [
              2743.995,
              -2491.298,
              9657.454
            ],
            [
              2805.445,
              -2445.699,
              9733.974
            ],
            [
              2826.856,
              -2438.309,
              9756.624
            ],
            [
              2849.016,
              -2425.368,
              9782.286
            ],
            [
              2992.535,
              -2369.073,
              9936.451
            ],
            [
              3051.699,
              -2342.359,
              10001.367
            ],
            [
              3144.148,
              -2294.01,
              10105.695
            ],
            [
              3171.465,
              -2281.167,
              10135.881
            ],
            [
              3196.764,
              -2272.74,
              10162.546
            ],
            [
              3228.339,
              -2273.338,
              10194.127
            ],
            [
              3336.411,
              -2291.815,
              10303.767
            ],
            [
              3341.954,
              -2292.861,
              10309.408
            ],
            [
              3360.683,
              -2296.997,
              10328.588
            ],
            [
              3397.349,
              -2301.032,
              10365.476
            ],
            [
              3432.188,
              -2299.467,
              10400.35
            ],
            [
              3478.067,
              -2293.658,
              10446.595
            ],
            [
              3621.692,
              -2266.33,
              10592.797
            ],
            [
              3717.486,
              -2245.887,
              10690.748
            ],
            [
              3791.3,
              -2234.903,
              10765.375
            ],
            [
              3808.63,
              -2233.258,
              10782.782
            ],
            [
              3855.426,
              -2227.388,
              10829.945
            ],
            [
              3942.497,
              -2202.802,
              10920.421
            ],
            [
              3964.664,
              -2197.164,
              10943.294
            ],
            [
              3982.138,
              -2189.325,
              10962.445
            ],
            [
              4002.404,
              -2174.453,
              10987.583
            ],
            [
              4009.595,
              -2173.53,
              10994.833
            ],
            [
              4015.389,
              -2176.429,
              11001.311
            ],
            [
              4016.493,
              -2183.681,
              11008.647
            ],
            [
              4009.878,
              -2192.461,
              11019.64
            ],
            [
              3987.905,
              -2195.381,
              11041.806
            ],
            [
              3864.811,
              -2227.543,
              11169.032
            ],
            [
              3855.286,
              -2232.394,
              11179.722
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:1028",
              "position": {
                "x": 3072.159,
                "z": -6371.637
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 15.193,
              "arrivalOffsetSeconds": -420,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:6096",
              "position": {
                "x": 2596.035,
                "z": -6483.998
              },
              "distanceAlongShapeM": 665.338,
              "shapeOffsetM": 3.559,
              "arrivalOffsetSeconds": 60,
              "departureOffsetSeconds": 60
            },
            {
              "stopId": "judu:stop:4426",
              "position": {
                "x": 2254.834,
                "z": -5858.618
              },
              "distanceAlongShapeM": 1455.905,
              "shapeOffsetM": 4.254,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:6100",
              "position": {
                "x": 1525.12,
                "z": -6167.846
              },
              "distanceAlongShapeM": 2248.377,
              "shapeOffsetM": 6.363,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:18768",
              "position": {
                "x": 965.306,
                "z": -6000.511
              },
              "distanceAlongShapeM": 2860.781,
              "shapeOffsetM": 3.884,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:6106",
              "position": {
                "x": 967.53,
                "z": -5321.47
              },
              "distanceAlongShapeM": 3548.619,
              "shapeOffsetM": 3.428,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:6107",
              "position": {
                "x": 1070.146,
                "z": -4997.183
              },
              "distanceAlongShapeM": 3888.745,
              "shapeOffsetM": 2.161,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:6109",
              "position": {
                "x": 1888.913,
                "z": -4757.446
              },
              "distanceAlongShapeM": 4789.897,
              "shapeOffsetM": 5.677,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:6110",
              "position": {
                "x": 2213.373,
                "z": -4529.726
              },
              "distanceAlongShapeM": 5188.087,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:6084",
              "position": {
                "x": 2496.935,
                "z": -5005.952
              },
              "distanceAlongShapeM": 5894.889,
              "shapeOffsetM": 2.977,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:6082",
              "position": {
                "x": 2882.726,
                "z": -4840.661
              },
              "distanceAlongShapeM": 6319.68,
              "shapeOffsetM": 7.409,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:6079",
              "position": {
                "x": 3190.252,
                "z": -4557.027
              },
              "distanceAlongShapeM": 6963.6,
              "shapeOffsetM": 4.151,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:5103",
              "position": {
                "x": 2937.404,
                "z": -4265.024
              },
              "distanceAlongShapeM": 7350.704,
              "shapeOffsetM": 3.836,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:5117",
              "position": {
                "x": 2636.416,
                "z": -3995.509
              },
              "distanceAlongShapeM": 7760.433,
              "shapeOffsetM": 2.457,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:5118",
              "position": {
                "x": 2463.001,
                "z": -3519.117
              },
              "distanceAlongShapeM": 8325.949,
              "shapeOffsetM": 4.589,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:5119",
              "position": {
                "x": 2425.512,
                "z": -3284.63
              },
              "distanceAlongShapeM": 8563.14,
              "shapeOffsetM": 5.384,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:6723",
              "position": {
                "x": 2444.816,
                "z": -2599.227
              },
              "distanceAlongShapeM": 9338.665,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            },
            {
              "stopId": "judu:stop:11047",
              "position": {
                "x": 2826.856,
                "z": -2438.309
              },
              "distanceAlongShapeM": 9756.624,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1560,
              "departureOffsetSeconds": 1560
            },
            {
              "stopId": "judu:stop:4520",
              "position": {
                "x": 3336.988,
                "z": -2288.755
              },
              "distanceAlongShapeM": 10303.767,
              "shapeOffsetM": 3.114,
              "arrivalOffsetSeconds": 1620,
              "departureOffsetSeconds": 1620
            },
            {
              "stopId": "judu:stop:8266",
              "position": {
                "x": 3808.621,
                "z": -2233.151
              },
              "distanceAlongShapeM": 10782.787,
              "shapeOffsetM": 0.107,
              "arrivalOffsetSeconds": 1680,
              "departureOffsetSeconds": 1680
            }
          ],
          "departuresSeconds": [
            20340,
            22440,
            24540,
            26640,
            28740,
            30960,
            39300,
            41040,
            42480,
            43920,
            45360,
            46860,
            48360,
            49860,
            51300,
            52800,
            54660,
            58440,
            60240,
            62040,
            63660,
            65340,
            66960,
            71820,
            73620,
            75420,
            77580,
            79680,
            81780,
            83880,
            85980,
            87840
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_bus_16",
      "sourceRouteId": "vilnius_bus_16",
      "mode": "bus",
      "shortName": "16",
      "longName": "Stotis–Nemėžis–Skaidiškės",
      "color": "0073AC",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_bus_16:0",
          "sourceRouteId": "vilnius_bus_16",
          "sourceShapeId": "vilnius_bus_16_a-b",
          "directionId": 0,
          "headsign": "Skaidiškės",
          "directionName": "Stotis–Nemėžis–Skaidiškės",
          "mode": "bus",
          "routeShortName": "16",
          "routeLongName": "Stotis–Nemėžis–Skaidiškės",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              448.24,
              1918.913,
              0
            ],
            [
              414.243,
              1935.885,
              37.998
            ],
            [
              388.144,
              1955.287,
              70.519
            ],
            [
              374.884,
              1971.114,
              91.166
            ],
            [
              370.552,
              1981.213,
              102.155
            ],
            [
              369.405,
              1989.026,
              110.052
            ],
            [
              372.127,
              1996.769,
              118.26
            ],
            [
              376.723,
              2001.138,
              124.601
            ],
            [
              383.214,
              2003.246,
              131.425
            ],
            [
              391.578,
              2001.98,
              139.885
            ],
            [
              462.481,
              1962.833,
              220.877
            ],
            [
              478.32,
              1946.958,
              243.302
            ],
            [
              475.394,
              1928.087,
              262.399
            ],
            [
              494.54,
              1916.604,
              284.724
            ],
            [
              623.161,
              1858.587,
              425.825
            ],
            [
              825.163,
              1791.425,
              638.699
            ],
            [
              863.527,
              1836.207,
              697.667
            ],
            [
              869.06,
              1862.978,
              725.004
            ],
            [
              873.401,
              1888.503,
              750.895
            ],
            [
              890.379,
              1910.039,
              778.319
            ],
            [
              909.687,
              1916.752,
              798.76
            ],
            [
              941.154,
              1923.993,
              831.05
            ],
            [
              953.593,
              1933.783,
              846.879
            ],
            [
              1083.618,
              2057.184,
              1026.14
            ],
            [
              1196.071,
              2172,
              1186.852
            ],
            [
              1233.034,
              2216.96,
              1245.056
            ],
            [
              1262.402,
              2269.853,
              1305.555
            ],
            [
              1275.582,
              2294.627,
              1333.617
            ],
            [
              1295.641,
              2322.675,
              1368.099
            ],
            [
              1353.693,
              2426.246,
              1486.83
            ],
            [
              1363.843,
              2451.663,
              1514.199
            ],
            [
              1395.21,
              2612.502,
              1678.068
            ],
            [
              1412.03,
              2684.551,
              1752.054
            ],
            [
              1428.563,
              2741.021,
              1810.894
            ],
            [
              1438.754,
              2768.663,
              1840.355
            ],
            [
              1469.827,
              2811.004,
              1892.875
            ],
            [
              1513.094,
              2845.213,
              1948.032
            ],
            [
              1568.191,
              2893.175,
              2021.08
            ],
            [
              1626.949,
              2964.446,
              2113.449
            ],
            [
              1670.787,
              3031.54,
              2193.595
            ],
            [
              1688.949,
              3071.28,
              2237.288
            ],
            [
              1699.324,
              3143.448,
              2310.198
            ],
            [
              1699.269,
              3383.908,
              2550.658
            ],
            [
              1698.702,
              3422.882,
              2589.637
            ],
            [
              1683.625,
              3554.597,
              2722.212
            ],
            [
              1679.171,
              3622.514,
              2790.275
            ],
            [
              1674.798,
              3769.542,
              2937.368
            ],
            [
              1682.198,
              3784.941,
              2954.452
            ],
            [
              1743.856,
              3803.884,
              3018.955
            ],
            [
              1811.196,
              3832.214,
              3092.011
            ],
            [
              1875.636,
              3868.945,
              3166.184
            ],
            [
              2082.225,
              4019.124,
              3421.592
            ],
            [
              2137.697,
              4051.487,
              3485.814
            ],
            [
              2651.026,
              4265.645,
              4042.025
            ],
            [
              2753.781,
              4306.019,
              4152.427
            ],
            [
              2885.931,
              4363.573,
              4296.566
            ],
            [
              3782.546,
              4734.102,
              5266.726
            ],
            [
              4007.399,
              4827.702,
              5510.283
            ],
            [
              3993.542,
              4822.162,
              5525.206
            ],
            [
              4523.651,
              5031.081,
              6094.998
            ],
            [
              4822.139,
              5143.936,
              6414.108
            ],
            [
              5192.97,
              5290.722,
              6812.934
            ],
            [
              5390.215,
              5365.393,
              7023.84
            ],
            [
              5894.308,
              5558.47,
              7563.644
            ],
            [
              5942.539,
              5581.666,
              7617.162
            ],
            [
              6302.271,
              5748.669,
              8013.77
            ],
            [
              6563.825,
              5913.876,
              8323.13
            ],
            [
              6763.095,
              6063.593,
              8572.376
            ],
            [
              7004.989,
              6262.498,
              8885.547
            ],
            [
              7167.225,
              6415.217,
              9108.356
            ],
            [
              7556.938,
              6750.653,
              9622.548
            ],
            [
              7640.208,
              6815.537,
              9728.112
            ],
            [
              7656.725,
              6833.009,
              9752.156
            ],
            [
              7664.065,
              6849.199,
              9769.932
            ],
            [
              7662.924,
              6866.065,
              9786.836
            ],
            [
              7646.898,
              6892.22,
              9817.511
            ],
            [
              7605.965,
              6945.357,
              9884.586
            ],
            [
              7571.025,
              6974.995,
              9930.403
            ],
            [
              7556.886,
              6978.615,
              9944.998
            ],
            [
              7543.244,
              6974.421,
              9959.27
            ],
            [
              7528.574,
              6961.494,
              9978.823
            ],
            [
              7511.934,
              6959.467,
              9995.586
            ],
            [
              7503.073,
              6959.986,
              10004.462
            ],
            [
              7472.269,
              7011.464,
              10064.452
            ],
            [
              7419.136,
              7123.911,
              10188.82
            ],
            [
              7394.895,
              7214.498,
              10282.595
            ],
            [
              7378.213,
              7324.393,
              10393.749
            ],
            [
              7369.167,
              7431.41,
              10501.147
            ],
            [
              7349.896,
              7730.618,
              10800.976
            ],
            [
              7321.385,
              8083.103,
              11154.611
            ],
            [
              7310.334,
              8184.67,
              11256.778
            ],
            [
              7307.762,
              8231.523,
              11303.702
            ],
            [
              7293.63,
              8366.508,
              11439.424
            ],
            [
              7284.886,
              8414.551,
              11488.257
            ],
            [
              7277.531,
              8434.735,
              11509.739
            ],
            [
              7258.703,
              8462.939,
              11543.65
            ],
            [
              7199.274,
              8523.215,
              11628.296
            ],
            [
              7185.357,
              8544.542,
              11653.762
            ],
            [
              7179.271,
              8563.588,
              11673.757
            ],
            [
              7147.693,
              8698.916,
              11812.72
            ],
            [
              7134.896,
              8738.133,
              11853.973
            ],
            [
              7111.941,
              8780.618,
              11902.262
            ],
            [
              6966.325,
              9013.166,
              12176.639
            ],
            [
              6944.198,
              9052.862,
              12222.085
            ],
            [
              6965.853,
              9056.576,
              12244.056
            ],
            [
              7004.444,
              9053.606,
              12282.761
            ],
            [
              7368.796,
              9030.756,
              12647.829
            ],
            [
              7569.689,
              9026.322,
              12848.771
            ],
            [
              7572.36,
              9030.369,
              12853.62
            ],
            [
              7574.49,
              9040.044,
              12863.527
            ],
            [
              7579.189,
              9048.857,
              12873.514
            ],
            [
              7584.467,
              9054.318,
              12881.109
            ],
            [
              7592.953,
              9058.603,
              12890.615
            ],
            [
              7605.228,
              9058.36,
              12902.893
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:939",
              "position": {
                "x": 448.101,
                "z": 1917.454
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 1.465,
              "arrivalOffsetSeconds": -540,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:5941",
              "position": {
                "x": 889.31,
                "z": 1911.588
              },
              "distanceAlongShapeM": 778.319,
              "shapeOffsetM": 1.882,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:5944",
              "position": {
                "x": 1272.571,
                "z": 2296.383
              },
              "distanceAlongShapeM": 1333.617,
              "shapeOffsetM": 3.486,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:5946",
              "position": {
                "x": 1466.069,
                "z": 2814.913
              },
              "distanceAlongShapeM": 1892.875,
              "shapeOffsetM": 5.422,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:16977",
              "position": {
                "x": 1743.856,
                "z": 3803.884
              },
              "distanceAlongShapeM": 3018.955,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:616",
              "position": {
                "x": 2873.526,
                "z": 4357.203
              },
              "distanceAlongShapeM": 4282.649,
              "shapeOffsetM": 0.887,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:6120",
              "position": {
                "x": 4006.468,
                "z": 4830.032
              },
              "distanceAlongShapeM": 5510.283,
              "shapeOffsetM": 2.509,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:6122",
              "position": {
                "x": 4522.992,
                "z": 5032.789
              },
              "distanceAlongShapeM": 6094.998,
              "shapeOffsetM": 1.83,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:6124",
              "position": {
                "x": 5191.784,
                "z": 5293.78
              },
              "distanceAlongShapeM": 6812.934,
              "shapeOffsetM": 3.28,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            },
            {
              "stopId": "judu:stop:6126",
              "position": {
                "x": 5940.079,
                "z": 5587.636
              },
              "distanceAlongShapeM": 7617.445,
              "shapeOffsetM": 6.451,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:6128",
              "position": {
                "x": 7554.365,
                "z": 6753.784
              },
              "distanceAlongShapeM": 9622.548,
              "shapeOffsetM": 4.053,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:6130",
              "position": {
                "x": 7364.295,
                "z": 7431.078
              },
              "distanceAlongShapeM": 10501.147,
              "shapeOffsetM": 4.883,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            },
            {
              "stopId": "judu:stop:6133",
              "position": {
                "x": 7301.003,
                "z": 8183.786
              },
              "distanceAlongShapeM": 11256.778,
              "shapeOffsetM": 9.373,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            },
            {
              "stopId": "judu:stop:5985",
              "position": {
                "x": 7004.866,
                "z": 9059.09
              },
              "distanceAlongShapeM": 12282.839,
              "shapeOffsetM": 5.5,
              "arrivalOffsetSeconds": 1560,
              "departureOffsetSeconds": 1560
            },
            {
              "stopId": "judu:stop:863",
              "position": {
                "x": 7605.228,
                "z": 9058.36
              },
              "distanceAlongShapeM": 12902.893,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1620,
              "departureOffsetSeconds": 1620
            }
          ],
          "departuresSeconds": [
            18240,
            19500,
            21360,
            22680,
            24180,
            27660,
            29460,
            33180,
            35160,
            36960,
            38340,
            39840,
            41340,
            42720,
            44460,
            45780,
            47280,
            48900,
            50580,
            51780,
            53940,
            55140,
            56400,
            58200,
            59940,
            61320,
            63660,
            67740,
            69600,
            72360,
            73020,
            74820,
            76260,
            77760,
            79260,
            80940,
            83040
          ]
        },
        {
          "id": "judu:pattern:vilnius_bus_16:1",
          "sourceRouteId": "vilnius_bus_16",
          "sourceShapeId": "vilnius_bus_16_b-a",
          "directionId": 1,
          "headsign": "Stotis",
          "directionName": "Skaidiškės–Nemėžis–Stotis",
          "mode": "bus",
          "routeShortName": "16",
          "routeLongName": "Stotis–Nemėžis–Skaidiškės",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              7605.228,
              9058.36,
              0
            ],
            [
              7614.315,
              9055.479,
              9.533
            ],
            [
              7624.343,
              9044.622,
              24.313
            ],
            [
              7624.68,
              9029.029,
              39.909
            ],
            [
              7617.464,
              9023.606,
              48.936
            ],
            [
              6945.502,
              9053.032,
              721.542
            ],
            [
              6981.657,
              8994.398,
              790.427
            ],
            [
              7068.705,
              8855.218,
              954.586
            ],
            [
              7118.296,
              8775.225,
              1048.704
            ],
            [
              7134.705,
              8742.897,
              1084.957
            ],
            [
              7147.989,
              8707.499,
              1122.767
            ],
            [
              7173.919,
              8587.072,
              1245.953
            ],
            [
              7195.291,
              8533.097,
              1304.005
            ],
            [
              7216.924,
              8508.269,
              1336.936
            ],
            [
              7250.597,
              8473.583,
              1385.279
            ],
            [
              7268.253,
              8453.384,
              1412.107
            ],
            [
              7282.642,
              8436.942,
              1433.955
            ],
            [
              7285.215,
              8422.217,
              1448.904
            ],
            [
              7292.833,
              8379.626,
              1492.171
            ],
            [
              7315.865,
              8154.226,
              1718.744
            ],
            [
              7318.527,
              8119.926,
              1753.148
            ],
            [
              7365.191,
              7528.991,
              2345.922
            ],
            [
              7376.228,
              7378.845,
              2496.473
            ],
            [
              7381.445,
              7318.298,
              2557.244
            ],
            [
              7395.496,
              7212.259,
              2664.21
            ],
            [
              7408.712,
              7161.901,
              2716.274
            ],
            [
              7434.09,
              7094.365,
              2788.42
            ],
            [
              7503.377,
              6959.525,
              2940.02
            ],
            [
              7567.657,
              6869.919,
              3050.298
            ],
            [
              7688.331,
              6714.697,
              3246.909
            ],
            [
              7765.099,
              6612.737,
              3374.538
            ],
            [
              7766.457,
              6602.621,
              3384.745
            ],
            [
              7764.9,
              6589.293,
              3398.164
            ],
            [
              7746.16,
              6575.84,
              3421.233
            ],
            [
              7735.47,
              6570.952,
              3432.987
            ],
            [
              7711.514,
              6568.088,
              3457.114
            ],
            [
              7699.981,
              6572.77,
              3469.561
            ],
            [
              7692.344,
              6578.488,
              3479.101
            ],
            [
              7668.985,
              6605.671,
              3514.942
            ],
            [
              7588.239,
              6703.015,
              3641.416
            ],
            [
              7578.018,
              6708.784,
              3653.153
            ],
            [
              7556.065,
              6709.219,
              3675.11
            ],
            [
              7543.359,
              6702.023,
              3689.712
            ],
            [
              7494.908,
              6667.489,
              3749.211
            ],
            [
              7180.388,
              6394.918,
              4165.406
            ],
            [
              7069.903,
              6294.678,
              4314.587
            ],
            [
              6778.151,
              6041.032,
              4701.181
            ],
            [
              6603.205,
              5913.103,
              4917.912
            ],
            [
              6488.726,
              5838.533,
              5054.536
            ],
            [
              6330.566,
              5742.549,
              5239.542
            ],
            [
              6193.481,
              5667.301,
              5395.922
            ],
            [
              6046.682,
              5596.915,
              5558.723
            ],
            [
              5824.924,
              5500.12,
              5800.685
            ],
            [
              5803.572,
              5492.705,
              5823.289
            ],
            [
              5770.792,
              5482.945,
              5857.49
            ],
            [
              5147.335,
              5240.968,
              6526.259
            ],
            [
              4846.366,
              5127.884,
              6847.772
            ],
            [
              4639.868,
              5045.423,
              7070.125
            ],
            [
              4456.04,
              4974.85,
              7267.035
            ],
            [
              4418.443,
              4960.314,
              7307.344
            ],
            [
              4110.611,
              4840.291,
              7637.747
            ],
            [
              3917.18,
              4757.37,
              7848.202
            ],
            [
              3791.824,
              4712.774,
              7981.255
            ],
            [
              3112.5,
              4431.742,
              8716.414
            ],
            [
              2821.939,
              4306.494,
              9032.821
            ],
            [
              2811.195,
              4303.827,
              9043.89
            ],
            [
              2180.203,
              4046.241,
              9725.434
            ],
            [
              2131.974,
              4021.536,
              9779.622
            ],
            [
              2048.616,
              3965.985,
              9879.794
            ],
            [
              1961.818,
              3896.684,
              9990.864
            ],
            [
              1908.119,
              3855.38,
              10058.611
            ],
            [
              1885.245,
              3840.22,
              10086.053
            ],
            [
              1810.879,
              3798.186,
              10171.476
            ],
            [
              1773.103,
              3779.963,
              10213.418
            ],
            [
              1723.068,
              3761.967,
              10266.591
            ],
            [
              1676.987,
              3748.35,
              10314.641
            ],
            [
              1674.389,
              3729.453,
              10333.716
            ],
            [
              1684.234,
              3721.498,
              10346.373
            ],
            [
              1679.247,
              3710.449,
              10358.495
            ],
            [
              1680.184,
              3591.526,
              10477.421
            ],
            [
              1696.885,
              3464.105,
              10605.933
            ],
            [
              1701.829,
              3382.747,
              10687.441
            ],
            [
              1703.03,
              3134.473,
              10935.718
            ],
            [
              1699.891,
              3104.474,
              10965.88
            ],
            [
              1687.994,
              3054.599,
              11017.155
            ],
            [
              1659.262,
              3001.697,
              11077.356
            ],
            [
              1605.061,
              2932.568,
              11165.2
            ],
            [
              1556.997,
              2881.137,
              11235.593
            ],
            [
              1484.111,
              2813.466,
              11335.051
            ],
            [
              1478.391,
              2802.8,
              11347.154
            ],
            [
              1453.839,
              2781.743,
              11379.499
            ],
            [
              1433.991,
              2755.392,
              11412.488
            ],
            [
              1428.563,
              2741.021,
              11427.85
            ],
            [
              1382.281,
              2541.494,
              11632.675
            ],
            [
              1365.86,
              2456.079,
              11719.654
            ],
            [
              1336.284,
              2392.058,
              11790.176
            ],
            [
              1222.21,
              2196.952,
              12016.183
            ],
            [
              958.108,
              1933.7,
              12389.08
            ],
            [
              918.257,
              1878.079,
              12457.503
            ],
            [
              898.105,
              1863.557,
              12482.343
            ],
            [
              863.527,
              1836.207,
              12526.43
            ],
            [
              825.163,
              1791.425,
              12585.397
            ],
            [
              623.161,
              1858.587,
              12798.272
            ],
            [
              493.411,
              1911.506,
              12938.399
            ],
            [
              481.742,
              1922.405,
              12954.366
            ],
            [
              470.798,
              1923.718,
              12965.388
            ],
            [
              464.267,
              1919.385,
              12973.226
            ],
            [
              448.24,
              1918.913,
              12989.26
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:863",
              "position": {
                "x": 7605.228,
                "z": 9058.36
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": -540,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:5986",
              "position": {
                "x": 6984.236,
                "z": 8996.04
              },
              "distanceAlongShapeM": 790.382,
              "shapeOffsetM": 3.057,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:6134",
              "position": {
                "x": 7319.162,
                "z": 8154.482
              },
              "distanceAlongShapeM": 1718.744,
              "shapeOffsetM": 3.306,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:6131",
              "position": {
                "x": 7383.302,
                "z": 7379.491
              },
              "distanceAlongShapeM": 2496.347,
              "shapeOffsetM": 7.103,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:6129",
              "position": {
                "x": 7500.235,
                "z": 6662.455
              },
              "distanceAlongShapeM": 3747.795,
              "shapeOffsetM": 7.191,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:6127",
              "position": {
                "x": 5825.963,
                "z": 5497.457
              },
              "distanceAlongShapeM": 5800.685,
              "shapeOffsetM": 2.859,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:6125",
              "position": {
                "x": 5148.109,
                "z": 5238.96
              },
              "distanceAlongShapeM": 6526.259,
              "shapeOffsetM": 2.152,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:6123",
              "position": {
                "x": 4457.255,
                "z": 4971.707
              },
              "distanceAlongShapeM": 7267.027,
              "shapeOffsetM": 3.369,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:6121",
              "position": {
                "x": 3917.274,
                "z": 4757.143
              },
              "distanceAlongShapeM": 7848.202,
              "shapeOffsetM": 0.246,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:617",
              "position": {
                "x": 2822.207,
                "z": 4305.846
              },
              "distanceAlongShapeM": 9032.821,
              "shapeOffsetM": 0.701,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            },
            {
              "stopId": "judu:stop:5998",
              "position": {
                "x": 1684.234,
                "z": 3721.498
              },
              "distanceAlongShapeM": 10346.373,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:5947",
              "position": {
                "x": 1478.744,
                "z": 2802.433
              },
              "distanceAlongShapeM": 11347.154,
              "shapeOffsetM": 0.509,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            },
            {
              "stopId": "judu:stop:5945",
              "position": {
                "x": 1224.883,
                "z": 2194.846
              },
              "distanceAlongShapeM": 12016.183,
              "shapeOffsetM": 3.403,
              "arrivalOffsetSeconds": 1380,
              "departureOffsetSeconds": 1380
            },
            {
              "stopId": "judu:stop:5942",
              "position": {
                "x": 922.174,
                "z": 1874.247
              },
              "distanceAlongShapeM": 12457.503,
              "shapeOffsetM": 5.48,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            },
            {
              "stopId": "judu:stop:8264",
              "position": {
                "x": 493.148,
                "z": 1911.064
              },
              "distanceAlongShapeM": 12938.399,
              "shapeOffsetM": 0.515,
              "arrivalOffsetSeconds": 1620,
              "departureOffsetSeconds": 1620
            }
          ],
          "departuresSeconds": [
            19440,
            20400,
            21840,
            23520,
            25260,
            26400,
            30000,
            31800,
            35160,
            37440,
            39240,
            40380,
            42240,
            43440,
            44640,
            46440,
            48180,
            49320,
            51120,
            52920,
            54180,
            56040,
            57480,
            59040,
            61200,
            62280,
            64560,
            66900,
            69720,
            71820,
            74280,
            75360,
            76860,
            78720,
            79800,
            81180,
            82980,
            84900
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_bus_17",
      "sourceRouteId": "vilnius_bus_17",
      "mode": "bus",
      "shortName": "17",
      "longName": "Antakalnis–Nemenčinės pl.–Antaviliai",
      "color": "0073AC",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_bus_17:0",
          "sourceRouteId": "vilnius_bus_17",
          "sourceShapeId": "vilnius_bus_17_a-b",
          "directionId": 0,
          "headsign": "Antaviliai",
          "directionName": "Antakalnis–Nemenčinės pl.–Antaviliai",
          "mode": "bus",
          "routeShortName": "17",
          "routeLongName": "Antakalnis–Nemenčinės pl.–Antaviliai",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              2558.505,
              -3824.161,
              0
            ],
            [
              2555.4,
              -3867.621,
              43.571
            ],
            [
              2550.54,
              -3888.998,
              65.493
            ],
            [
              2499.38,
              -3984.027,
              173.418
            ],
            [
              2491.557,
              -3988.308,
              182.336
            ],
            [
              2481.913,
              -3989.406,
              192.042
            ],
            [
              2463.338,
              -3985.439,
              211.036
            ],
            [
              2456.234,
              -3979.843,
              220.08
            ],
            [
              2451.32,
              -3969.766,
              231.291
            ],
            [
              2449.513,
              -3963.053,
              238.243
            ],
            [
              2474.189,
              -3849.964,
              353.993
            ],
            [
              2506.597,
              -3737.02,
              471.494
            ],
            [
              2515.783,
              -3728.287,
              484.169
            ],
            [
              2532.532,
              -3728.601,
              500.921
            ],
            [
              2540.338,
              -3736.718,
              512.182
            ],
            [
              2566.251,
              -3786.011,
              567.872
            ],
            [
              2598.162,
              -3836.707,
              627.775
            ],
            [
              2614.638,
              -3851.49,
              649.911
            ],
            [
              2635.392,
              -3877.441,
              683.14
            ],
            [
              2642.893,
              -3890.985,
              698.622
            ],
            [
              2709.56,
              -3977.961,
              808.209
            ],
            [
              3021.059,
              -4338.966,
              1285.028
            ],
            [
              3040.626,
              -4360.488,
              1314.116
            ],
            [
              3055.715,
              -4376.506,
              1336.121
            ],
            [
              3068.958,
              -4395.535,
              1359.305
            ],
            [
              3153.475,
              -4491.761,
              1487.377
            ],
            [
              3273.19,
              -4634.3,
              1673.52
            ],
            [
              3311.137,
              -4671.757,
              1726.84
            ],
            [
              3331.492,
              -4694.37,
              1757.265
            ],
            [
              3344.656,
              -4709.628,
              1777.416
            ],
            [
              3435.309,
              -4816.612,
              1917.643
            ],
            [
              3777.629,
              -5210.544,
              2439.53
            ],
            [
              4146.482,
              -5643.721,
              3008.471
            ],
            [
              4168.317,
              -5663.414,
              3037.875
            ],
            [
              4198.544,
              -5701.751,
              3086.695
            ],
            [
              4479.429,
              -6026.379,
              3515.974
            ],
            [
              4583.65,
              -6150.351,
              3677.934
            ],
            [
              4780.064,
              -6376.448,
              3977.43
            ],
            [
              4845.472,
              -6457.867,
              4081.868
            ],
            [
              4963.748,
              -6636.051,
              4295.734
            ],
            [
              4993.701,
              -6685.615,
              4353.646
            ],
            [
              5053.853,
              -6775.422,
              4461.737
            ],
            [
              5115.634,
              -6873.894,
              4577.985
            ],
            [
              5492.477,
              -7463.46,
              5277.698
            ],
            [
              5510.414,
              -7489.1,
              5308.99
            ],
            [
              5529.947,
              -7523.193,
              5348.282
            ],
            [
              5547.262,
              -7548.172,
              5378.675
            ],
            [
              5756.997,
              -7898.345,
              5786.854
            ],
            [
              5981.39,
              -8266.524,
              6218.024
            ],
            [
              6023.483,
              -8337.838,
              6300.834
            ],
            [
              6501.767,
              -9354.534,
              7424.412
            ],
            [
              6620.083,
              -9622.678,
              7717.498
            ],
            [
              6649.506,
              -9716.251,
              7815.589
            ],
            [
              6650.564,
              -9948.701,
              8048.041
            ],
            [
              6621.527,
              -10577.121,
              8677.131
            ],
            [
              6605.789,
              -10950.812,
              9051.154
            ],
            [
              6605.304,
              -11044.464,
              9144.807
            ],
            [
              6619.136,
              -11126.008,
              9227.516
            ],
            [
              6634.585,
              -11172.11,
              9276.137
            ],
            [
              6663.288,
              -11235.983,
              9346.163
            ],
            [
              6708.141,
              -11310.347,
              9433.007
            ],
            [
              6789.131,
              -11436.885,
              9583.244
            ],
            [
              6890.308,
              -11597.842,
              9773.36
            ],
            [
              7024.638,
              -11824.368,
              10036.72
            ],
            [
              7050.787,
              -11874.895,
              10093.612
            ],
            [
              7132.514,
              -11999.223,
              10242.397
            ],
            [
              7234.172,
              -12163.543,
              10435.62
            ],
            [
              7290.957,
              -12251.511,
              10540.324
            ],
            [
              7316.708,
              -12289.241,
              10586.005
            ],
            [
              7336.786,
              -12308.088,
              10613.542
            ],
            [
              7429.771,
              -12386.758,
              10735.342
            ],
            [
              7471.911,
              -12417.99,
              10787.794
            ],
            [
              7911.991,
              -12758.844,
              11344.437
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:5483",
              "position": {
                "x": 2562.319,
                "z": -3823.788
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 3.832,
              "arrivalOffsetSeconds": -780,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:741",
              "position": {
                "x": 2636.723,
                "z": -3876.397
              },
              "distanceAlongShapeM": 683.14,
              "shapeOffsetM": 1.691,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:3566",
              "position": {
                "x": 3057.099,
                "z": -4375.272
              },
              "distanceAlongShapeM": 1336.121,
              "shapeOffsetM": 1.854,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:6081",
              "position": {
                "x": 3335.252,
                "z": -4691.14
              },
              "distanceAlongShapeM": 1757.275,
              "shapeOffsetM": 4.956,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:950",
              "position": {
                "x": 3777.629,
                "z": -5210.544
              },
              "distanceAlongShapeM": 2439.53,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:6140",
              "position": {
                "x": 4170.98,
                "z": -5661.145
              },
              "distanceAlongShapeM": 3037.875,
              "shapeOffsetM": 3.499,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:6143",
              "position": {
                "x": 4481.556,
                "z": -6024.468
              },
              "distanceAlongShapeM": 3515.92,
              "shapeOffsetM": 2.859,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:6147",
              "position": {
                "x": 5058.349,
                "z": -6772.589
              },
              "distanceAlongShapeM": 4461.737,
              "shapeOffsetM": 5.314,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:6148",
              "position": {
                "x": 5515.215,
                "z": -7486.168
              },
              "distanceAlongShapeM": 5308.99,
              "shapeOffsetM": 5.625,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:6153",
              "position": {
                "x": 6029.809,
                "z": -8334.524
              },
              "distanceAlongShapeM": 6300.834,
              "shapeOffsetM": 7.141,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:6155",
              "position": {
                "x": 6506.105,
                "z": -9352.524
              },
              "distanceAlongShapeM": 7424.412,
              "shapeOffsetM": 4.781,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:18878",
              "position": {
                "x": 6657.173,
                "z": -9948.89
              },
              "distanceAlongShapeM": 8048.041,
              "shapeOffsetM": 6.612,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:18879",
              "position": {
                "x": 6624.82,
                "z": -10577.264
              },
              "distanceAlongShapeM": 8677.122,
              "shapeOffsetM": 3.296,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:6160",
              "position": {
                "x": 6612.294,
                "z": -10951.085
              },
              "distanceAlongShapeM": 9051.393,
              "shapeOffsetM": 6.507,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:3610",
              "position": {
                "x": 7135.186,
                "z": -11997.921
              },
              "distanceAlongShapeM": 10242.695,
              "shapeOffsetM": 2.957,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:6163",
              "position": {
                "x": 7474.246,
                "z": -12414.364
              },
              "distanceAlongShapeM": 10787.511,
              "shapeOffsetM": 4.303,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            },
            {
              "stopId": "judu:stop:18504",
              "position": {
                "x": 7913.785,
                "z": -12756.029
              },
              "distanceAlongShapeM": 11344.132,
              "shapeOffsetM": 3.324,
              "arrivalOffsetSeconds": 1380,
              "departureOffsetSeconds": 1380
            }
          ],
          "departuresSeconds": [
            18900,
            20400,
            23040,
            24420,
            27120,
            28560,
            31200,
            34800,
            37380,
            39300,
            41400,
            43320,
            45420,
            47340,
            49440,
            51360,
            53280,
            55020,
            57000,
            59040,
            60960,
            63000,
            65040,
            69000,
            71100,
            72960,
            74580,
            76380,
            78000,
            79800,
            81300,
            83220,
            84540
          ]
        },
        {
          "id": "judu:pattern:vilnius_bus_17:1",
          "sourceRouteId": "vilnius_bus_17",
          "sourceShapeId": "vilnius_bus_17_b-a",
          "directionId": 1,
          "headsign": "Antakalnis",
          "directionName": "Antaviliai–Nemenčinės pl.–Antakalnis",
          "mode": "bus",
          "routeShortName": "17",
          "routeLongName": "Antakalnis–Nemenčinės pl.–Antaviliai",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              7911.991,
              -12758.844,
              0
            ],
            [
              8100.622,
              -12907.041,
              239.884
            ],
            [
              8483.875,
              -13604.702,
              1035.882
            ],
            [
              8562.798,
              -13708.72,
              1166.452
            ],
            [
              8548.427,
              -13712.89,
              1181.417
            ],
            [
              8476.848,
              -13618.309,
              1300.03
            ],
            [
              8293.149,
              -13281.239,
              1683.908
            ],
            [
              8119.635,
              -12958.51,
              2050.324
            ],
            [
              8078.79,
              -12898.502,
              2122.913
            ],
            [
              8037.509,
              -12861.623,
              2178.269
            ],
            [
              7899.635,
              -12770.505,
              2343.531
            ],
            [
              7604.474,
              -12551.672,
              2710.965
            ],
            [
              7400.905,
              -12383.027,
              2975.316
            ],
            [
              7315.352,
              -12303.053,
              3092.429
            ],
            [
              7225.347,
              -12170.974,
              3252.258
            ],
            [
              7080.784,
              -11942.205,
              3522.875
            ],
            [
              7025.317,
              -11848.233,
              3631.996
            ],
            [
              6987.764,
              -11787.486,
              3703.414
            ],
            [
              6800.036,
              -11630.9,
              3947.875
            ],
            [
              6778.836,
              -11619.459,
              3971.964
            ],
            [
              6718.966,
              -11608.925,
              4032.754
            ],
            [
              6643.636,
              -11599.482,
              4108.674
            ],
            [
              6615.393,
              -11586.191,
              4139.888
            ],
            [
              6598.746,
              -11565.988,
              4166.066
            ],
            [
              6591.475,
              -11548.613,
              4184.901
            ],
            [
              6568.723,
              -11378.147,
              4356.878
            ],
            [
              6566.175,
              -11303.314,
              4431.755
            ],
            [
              6581.816,
              -11178.799,
              4557.249
            ],
            [
              6587.836,
              -11081.971,
              4654.263
            ],
            [
              6593.463,
              -11056.522,
              4680.326
            ],
            [
              6592.241,
              -11045.346,
              4691.57
            ],
            [
              6540.143,
              -11020.912,
              4749.113
            ],
            [
              6537.278,
              -11003.043,
              4767.21
            ],
            [
              6544.684,
              -10882.641,
              4887.84
            ],
            [
              6587.452,
              -10892.696,
              4931.774
            ],
            [
              6593.404,
              -10841.903,
              4982.914
            ],
            [
              6608.734,
              -10544.661,
              5280.551
            ],
            [
              6614.322,
              -10423.606,
              5401.735
            ],
            [
              6639.065,
              -9827.377,
              5998.477
            ],
            [
              6641.096,
              -9752.632,
              6073.25
            ],
            [
              6629.211,
              -9670.014,
              6156.718
            ],
            [
              6616.981,
              -9637.487,
              6191.469
            ],
            [
              6560.251,
              -9511.679,
              6329.476
            ],
            [
              6537.201,
              -9465.963,
              6380.674
            ],
            [
              6333.896,
              -9010.693,
              6879.276
            ],
            [
              6109.136,
              -8524.224,
              7415.157
            ],
            [
              6084.291,
              -8478.092,
              7467.554
            ],
            [
              5995.189,
              -8327.166,
              7642.819
            ],
            [
              5966.681,
              -8280.092,
              7697.852
            ],
            [
              5943.813,
              -8246.371,
              7738.596
            ],
            [
              5718.303,
              -7868.644,
              8178.519
            ],
            [
              5531.206,
              -7557.73,
              8541.387
            ],
            [
              5498.755,
              -7504.773,
              8603.496
            ],
            [
              5460.94,
              -7445.074,
              8674.164
            ],
            [
              5438.248,
              -7404.514,
              8720.64
            ],
            [
              5196.866,
              -7023.685,
              9171.523
            ],
            [
              5048.284,
              -6793.546,
              9445.459
            ],
            [
              5013.85,
              -6744.741,
              9505.189
            ],
            [
              5008.891,
              -6732.667,
              9518.241
            ],
            [
              4990.138,
              -6703.359,
              9553.035
            ],
            [
              4903.043,
              -6578.1,
              9705.598
            ],
            [
              4831.501,
              -6480.976,
              9826.227
            ],
            [
              4576.487,
              -6178.813,
              10221.619
            ],
            [
              4434.336,
              -6018.807,
              10435.648
            ],
            [
              4391.884,
              -5964.854,
              10504.301
            ],
            [
              4192.109,
              -5735.026,
              10808.818
            ],
            [
              4068.653,
              -5589.049,
              11000
            ],
            [
              4055.494,
              -5577.515,
              11017.499
            ],
            [
              4018.912,
              -5529.094,
              11078.185
            ],
            [
              3747.122,
              -5188.81,
              11513.688
            ],
            [
              3704.824,
              -5143.473,
              11575.693
            ],
            [
              3685.238,
              -5124.116,
              11603.23
            ],
            [
              3665.724,
              -5099.311,
              11634.791
            ],
            [
              3449.572,
              -4845.828,
              11967.921
            ],
            [
              3395.411,
              -4790.022,
              12045.688
            ],
            [
              3252.761,
              -4658.405,
              12239.781
            ],
            [
              3244.62,
              -4646.005,
              12254.614
            ],
            [
              3235.159,
              -4601.295,
              12300.314
            ],
            [
              3218.877,
              -4576.495,
              12329.981
            ],
            [
              3193.34,
              -4554.253,
              12363.847
            ],
            [
              3172.809,
              -4525.525,
              12399.157
            ],
            [
              3060.003,
              -4392.026,
              12573.934
            ],
            [
              3021.059,
              -4338.966,
              12639.752
            ],
            [
              2961.544,
              -4283.292,
              12721.249
            ],
            [
              2940.311,
              -4262.522,
              12750.951
            ],
            [
              2920.517,
              -4237.987,
              12782.475
            ],
            [
              2810.169,
              -4110.107,
              12951.383
            ],
            [
              2739.116,
              -4050.879,
              13043.884
            ],
            [
              2661.391,
              -4003.772,
              13134.77
            ],
            [
              2637.654,
              -3993.387,
              13160.68
            ],
            [
              2609.738,
              -3974.969,
              13194.124
            ],
            [
              2502.106,
              -3906.664,
              13321.6
            ],
            [
              2488.357,
              -3884.741,
              13347.478
            ],
            [
              2476.247,
              -3843.323,
              13390.63
            ],
            [
              2501.318,
              -3743.601,
              13493.455
            ],
            [
              2515.139,
              -3728.275,
              13514.093
            ],
            [
              2523.372,
              -3727.648,
              13522.35
            ],
            [
              2540.053,
              -3739.875,
              13543.032
            ],
            [
              2551,
              -3774.592,
              13579.434
            ],
            [
              2558.505,
              -3824.161,
              13629.568
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:18504",
              "position": {
                "x": 7913.785,
                "z": -12756.029
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 3.338,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:18564",
              "position": {
                "x": 7894.03,
                "z": -12779.013
              },
              "distanceAlongShapeM": 2343.516,
              "shapeOffsetM": 10.189,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:6164",
              "position": {
                "x": 7396.294,
                "z": -12388.318
              },
              "distanceAlongShapeM": 2975.316,
              "shapeOffsetM": 7.018,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:6162",
              "position": {
                "x": 7073.808,
                "z": -11946.604
              },
              "distanceAlongShapeM": 3522.875,
              "shapeOffsetM": 8.247,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:7936",
              "position": {
                "x": 6563.323,
                "z": -11378.738
              },
              "distanceAlongShapeM": 4356.878,
              "shapeOffsetM": 5.432,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:6159",
              "position": {
                "x": 6586.147,
                "z": -10841.466
              },
              "distanceAlongShapeM": 4982.504,
              "shapeOffsetM": 7.259,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:18889",
              "position": {
                "x": 6604.695,
                "z": -10423.232
              },
              "distanceAlongShapeM": 5401.665,
              "shapeOffsetM": 9.634,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:18892",
              "position": {
                "x": 6631.904,
                "z": -9827.042
              },
              "distanceAlongShapeM": 5998.618,
              "shapeOffsetM": 7.168,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:6154",
              "position": {
                "x": 6530.846,
                "z": -9468.794
              },
              "distanceAlongShapeM": 6380.68,
              "shapeOffsetM": 6.957,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:6152",
              "position": {
                "x": 5939.418,
                "z": -8249.257
              },
              "distanceAlongShapeM": 7738.596,
              "shapeOffsetM": 5.258,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:6149",
              "position": {
                "x": 5457.379,
                "z": -7447.191
              },
              "distanceAlongShapeM": 8674.164,
              "shapeOffsetM": 4.143,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            },
            {
              "stopId": "judu:stop:6146",
              "position": {
                "x": 5011.851,
                "z": -6746.083
              },
              "distanceAlongShapeM": 9505.189,
              "shapeOffsetM": 2.408,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:6144",
              "position": {
                "x": 4433.996,
                "z": -6019.1
              },
              "distanceAlongShapeM": 10435.648,
              "shapeOffsetM": 0.449,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:6142",
              "position": {
                "x": 4052.725,
                "z": -5579.838
              },
              "distanceAlongShapeM": 11017.499,
              "shapeOffsetM": 3.614,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:6141",
              "position": {
                "x": 3682.602,
                "z": -5126.351
              },
              "distanceAlongShapeM": 11603.23,
              "shapeOffsetM": 3.456,
              "arrivalOffsetSeconds": 1380,
              "departureOffsetSeconds": 1380
            },
            {
              "stopId": "judu:stop:6079",
              "position": {
                "x": 3190.252,
                "z": -4557.027
              },
              "distanceAlongShapeM": 12363.847,
              "shapeOffsetM": 4.151,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            },
            {
              "stopId": "judu:stop:5103",
              "position": {
                "x": 2937.404,
                "z": -4265.024
              },
              "distanceAlongShapeM": 12750.951,
              "shapeOffsetM": 3.836,
              "arrivalOffsetSeconds": 1500,
              "departureOffsetSeconds": 1500
            },
            {
              "stopId": "judu:stop:5117",
              "position": {
                "x": 2636.416,
                "z": -3995.509
              },
              "distanceAlongShapeM": 13160.68,
              "shapeOffsetM": 2.457,
              "arrivalOffsetSeconds": 1560,
              "departureOffsetSeconds": 1560
            },
            {
              "stopId": "judu:stop:5483",
              "position": {
                "x": 2562.319,
                "z": -3823.788
              },
              "distanceAlongShapeM": 13629.568,
              "shapeOffsetM": 3.832,
              "arrivalOffsetSeconds": 1680,
              "departureOffsetSeconds": 1680
            }
          ],
          "departuresSeconds": [
            18120,
            20220,
            21720,
            24420,
            25800,
            28560,
            30060,
            32700,
            36300,
            38760,
            40680,
            42780,
            44700,
            46800,
            48720,
            50820,
            52740,
            54660,
            56400,
            58380,
            60420,
            62340,
            64380,
            66540,
            70380,
            72480,
            74280,
            75900,
            77700,
            79320,
            81120,
            82620,
            84540,
            85860
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_bus_18",
      "sourceRouteId": "vilnius_bus_18",
      "mode": "bus",
      "shortName": "18",
      "longName": "Antakalnis–Dvarčionys–Parko g.",
      "color": "0073AC",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_bus_18:0",
          "sourceRouteId": "vilnius_bus_18",
          "sourceShapeId": "vilnius_bus_18_a-b",
          "directionId": 0,
          "headsign": "Parko g.",
          "directionName": "Antakalnis–Dvarčionys–Parko g.",
          "mode": "bus",
          "routeShortName": "18",
          "routeLongName": "Antakalnis–Dvarčionys–Parko g.",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              2558.505,
              -3824.161,
              0
            ],
            [
              2555.4,
              -3867.621,
              43.571
            ],
            [
              2550.54,
              -3888.998,
              65.493
            ],
            [
              2499.38,
              -3984.027,
              173.418
            ],
            [
              2491.557,
              -3988.308,
              182.336
            ],
            [
              2481.913,
              -3989.406,
              192.042
            ],
            [
              2463.338,
              -3985.439,
              211.036
            ],
            [
              2456.234,
              -3979.843,
              220.08
            ],
            [
              2451.32,
              -3969.766,
              231.291
            ],
            [
              2449.513,
              -3963.053,
              238.243
            ],
            [
              2474.189,
              -3849.964,
              353.993
            ],
            [
              2506.597,
              -3737.02,
              471.494
            ],
            [
              2515.783,
              -3728.287,
              484.169
            ],
            [
              2532.532,
              -3728.601,
              500.921
            ],
            [
              2540.338,
              -3736.718,
              512.182
            ],
            [
              2566.251,
              -3786.011,
              567.872
            ],
            [
              2598.162,
              -3836.707,
              627.775
            ],
            [
              2614.638,
              -3851.49,
              649.911
            ],
            [
              2635.392,
              -3877.441,
              683.14
            ],
            [
              2642.893,
              -3890.985,
              698.622
            ],
            [
              2709.56,
              -3977.961,
              808.209
            ],
            [
              3021.059,
              -4338.966,
              1285.028
            ],
            [
              3086.352,
              -4293.444,
              1364.624
            ],
            [
              3112.838,
              -4272.891,
              1398.149
            ],
            [
              3142.482,
              -4255.542,
              1432.496
            ],
            [
              3336.938,
              -4126.748,
              1665.737
            ],
            [
              3389.682,
              -4097.691,
              1725.955
            ],
            [
              3403.448,
              -4088.142,
              1742.708
            ],
            [
              3446.229,
              -4072.046,
              1788.418
            ],
            [
              3528.69,
              -4039.102,
              1877.216
            ],
            [
              3592.048,
              -4028.061,
              1941.529
            ],
            [
              3640.778,
              -4019.583,
              1990.991
            ],
            [
              3666.294,
              -4020.567,
              2016.526
            ],
            [
              3848.026,
              -4019.578,
              2198.26
            ],
            [
              3878.881,
              -4023.507,
              2229.364
            ],
            [
              3901.964,
              -4029.514,
              2253.216
            ],
            [
              3958.181,
              -4055.079,
              2314.973
            ],
            [
              3965.111,
              -4059.221,
              2323.047
            ],
            [
              4003.977,
              -4097.523,
              2377.614
            ],
            [
              4018.762,
              -4121.92,
              2406.141
            ],
            [
              4037.773,
              -4172.381,
              2460.065
            ],
            [
              4076.734,
              -4257.734,
              2553.89
            ],
            [
              4093.076,
              -4279.199,
              2580.868
            ],
            [
              4128.571,
              -4309.937,
              2627.822
            ],
            [
              4222.379,
              -4357.378,
              2732.944
            ],
            [
              4258.043,
              -4379.213,
              2774.761
            ],
            [
              4380.089,
              -4463.989,
              2923.362
            ],
            [
              4409.879,
              -4485.153,
              2959.905
            ],
            [
              4437.325,
              -4505.114,
              2993.842
            ],
            [
              4500.992,
              -4543.134,
              3067.997
            ],
            [
              4784.007,
              -4703.272,
              3393.176
            ],
            [
              4912.858,
              -4770.329,
              3538.432
            ],
            [
              4956.995,
              -4786.768,
              3585.531
            ],
            [
              4973.727,
              -4792.975,
              3603.377
            ],
            [
              5002.978,
              -4807.696,
              3636.124
            ],
            [
              5509.136,
              -5005.307,
              4179.489
            ],
            [
              5765.06,
              -5109.726,
              4455.895
            ],
            [
              5806.767,
              -5118.333,
              4498.481
            ],
            [
              5878.63,
              -5129.051,
              4571.139
            ],
            [
              5891.491,
              -5134.461,
              4585.091
            ],
            [
              5956.294,
              -5147.973,
              4651.288
            ],
            [
              5988.132,
              -5134.123,
              4686.008
            ],
            [
              5995.156,
              -5125.955,
              4696.781
            ],
            [
              6011.57,
              -4989.855,
              4833.867
            ],
            [
              6021.457,
              -4945.517,
              4879.294
            ],
            [
              6027.558,
              -4930.051,
              4895.92
            ],
            [
              6092.568,
              -4834.468,
              5011.516
            ],
            [
              6127.551,
              -4791.735,
              5066.742
            ],
            [
              6152.504,
              -4767.731,
              5101.366
            ],
            [
              6159.829,
              -4755.629,
              5115.512
            ],
            [
              6161.4,
              -4741.187,
              5130.04
            ],
            [
              6125.051,
              -4655.893,
              5222.756
            ],
            [
              6001.369,
              -4687.956,
              5350.526
            ],
            [
              5943.985,
              -4702.264,
              5409.667
            ],
            [
              5887.559,
              -4716.566,
              5467.877
            ],
            [
              5850.665,
              -4726.952,
              5506.205
            ],
            [
              5840.825,
              -4727.158,
              5516.048
            ],
            [
              5842.74,
              -4726.38,
              5518.114
            ],
            [
              5842.929,
              -4726.317,
              5518.314
            ],
            [
              5876.327,
              -4719.282,
              5552.445
            ],
            [
              5917.574,
              -4709.024,
              5594.949
            ],
            [
              6088.174,
              -4665.357,
              5771.048
            ],
            [
              6114.992,
              -4655.609,
              5799.583
            ],
            [
              6125.051,
              -4655.893,
              5809.646
            ],
            [
              6136.422,
              -4666.325,
              5825.077
            ],
            [
              6142.269,
              -4679.446,
              5839.442
            ],
            [
              6157.107,
              -4716.379,
              5879.244
            ],
            [
              6163.114,
              -4752.353,
              5915.716
            ],
            [
              6148.487,
              -4775.446,
              5943.052
            ],
            [
              6122.934,
              -4797.211,
              5976.618
            ],
            [
              6095.897,
              -4828.966,
              6018.324
            ],
            [
              6024.895,
              -4934.452,
              6145.479
            ],
            [
              6018.15,
              -4949.906,
              6162.341
            ],
            [
              6009.703,
              -4986.479,
              6199.877
            ],
            [
              6001.73,
              -5101.059,
              6314.734
            ],
            [
              6002.517,
              -5123.272,
              6336.961
            ],
            [
              6007.161,
              -5135.764,
              6350.288
            ],
            [
              6016.623,
              -5161.362,
              6377.579
            ],
            [
              6030.604,
              -5169.466,
              6393.739
            ],
            [
              6078.772,
              -5177.089,
              6442.506
            ],
            [
              6272.282,
              -5197.581,
              6637.098
            ],
            [
              6739.794,
              -5240.179,
              7106.547
            ],
            [
              6910.627,
              -5258.468,
              7278.357
            ],
            [
              7009.219,
              -5271.64,
              7377.824
            ],
            [
              7693.441,
              -5410.458,
              8075.986
            ],
            [
              7726.596,
              -5424.106,
              8111.841
            ],
            [
              7856.491,
              -5508.838,
              8266.928
            ],
            [
              7915.742,
              -5518.477,
              8326.958
            ],
            [
              7983.934,
              -5517.856,
              8395.153
            ],
            [
              8001.794,
              -5505.648,
              8416.787
            ],
            [
              8143.655,
              -5460.694,
              8565.6
            ],
            [
              8219.756,
              -5424.367,
              8649.927
            ],
            [
              8440.114,
              -5166.053,
              8989.462
            ],
            [
              8478.071,
              -5117.449,
              9051.131
            ],
            [
              8538.59,
              -5041.23,
              9148.454
            ],
            [
              8551.775,
              -4867.708,
              9322.477
            ],
            [
              8545.916,
              -4710.614,
              9479.68
            ],
            [
              8538.616,
              -4652.146,
              9538.601
            ],
            [
              8536.557,
              -4605.836,
              9584.958
            ],
            [
              8534.412,
              -4577.9,
              9612.976
            ],
            [
              8538.438,
              -4537.902,
              9653.176
            ],
            [
              8566.956,
              -4401.54,
              9792.488
            ],
            [
              8572.237,
              -4299.223,
              9894.941
            ],
            [
              8558.698,
              -4224.878,
              9970.509
            ],
            [
              8548.326,
              -4173.409,
              10023.012
            ],
            [
              8486.05,
              -4067.036,
              10146.274
            ],
            [
              8472.64,
              -4028.914,
              10186.686
            ],
            [
              8480.829,
              -3839.802,
              10375.976
            ],
            [
              8544.622,
              -3611.976,
              10612.564
            ],
            [
              8560.894,
              -3560.06,
              10666.97
            ],
            [
              8585.514,
              -3497.61,
              10734.099
            ],
            [
              8603.763,
              -3426.894,
              10807.131
            ],
            [
              8611.532,
              -3243.492,
              10990.698
            ],
            [
              8613.26,
              -2969.586,
              11264.609
            ],
            [
              8614.689,
              -2958.552,
              11275.735
            ],
            [
              8615.893,
              -2930.743,
              11303.57
            ],
            [
              8624.784,
              -2905.316,
              11330.507
            ],
            [
              8640.718,
              -2882.258,
              11358.535
            ],
            [
              8693.778,
              -2817.191,
              11442.493
            ],
            [
              8823.576,
              -2636.564,
              11664.92
            ],
            [
              8863.989,
              -2550.542,
              11759.962
            ],
            [
              8918.227,
              -2450.327,
              11873.913
            ],
            [
              8930.847,
              -2427.66,
              11899.857
            ],
            [
              8947.424,
              -2401.129,
              11931.14
            ],
            [
              8961.152,
              -2367.696,
              11967.282
            ],
            [
              8971.226,
              -2301.129,
              12034.607
            ],
            [
              8977.303,
              -2242.511,
              12093.54
            ],
            [
              8995.823,
              -2162.737,
              12175.435
            ],
            [
              8997.195,
              -2143.446,
              12194.774
            ],
            [
              8993.679,
              -2124.346,
              12214.196
            ],
            [
              8803.817,
              -1844.422,
              12552.434
            ],
            [
              8744.135,
              -1760.06,
              12655.773
            ],
            [
              8705.113,
              -1701.233,
              12726.365
            ],
            [
              8683.694,
              -1676.309,
              12759.228
            ],
            [
              8633.675,
              -1630.77,
              12826.872
            ],
            [
              8602.364,
              -1616.781,
              12861.166
            ],
            [
              8579.919,
              -1610.763,
              12884.404
            ],
            [
              8461.891,
              -1580.558,
              13006.236
            ],
            [
              8394.509,
              -1564.732,
              13075.451
            ],
            [
              8379.735,
              -1563.219,
              13090.302
            ],
            [
              8345.129,
              -1551.495,
              13126.841
            ],
            [
              8247.927,
              -1530.179,
              13226.352
            ],
            [
              8124.401,
              -1498.088,
              13353.979
            ],
            [
              8094.331,
              -1486.354,
              13386.257
            ],
            [
              8060.506,
              -1468.978,
              13424.284
            ],
            [
              8032.526,
              -1449.493,
              13458.38
            ],
            [
              8003.39,
              -1423.305,
              13497.556
            ],
            [
              7919.797,
              -1333.856,
              13619.985
            ],
            [
              7869.87,
              -1276.824,
              13695.783
            ],
            [
              7850.622,
              -1250.722,
              13728.215
            ],
            [
              7830.876,
              -1215.015,
              13769.018
            ],
            [
              7805.738,
              -1143.988,
              13844.362
            ],
            [
              7791.221,
              -1101.783,
              13888.994
            ],
            [
              7779.053,
              -1076.908,
              13916.686
            ],
            [
              7761.946,
              -1049.988,
              13948.581
            ],
            [
              7720.825,
              -1010.204,
              14005.798
            ],
            [
              7689.684,
              -987.318,
              14044.444
            ],
            [
              7657.987,
              -959.968,
              14086.309
            ],
            [
              7648.028,
              -941.957,
              14106.89
            ],
            [
              7642.025,
              -919.572,
              14130.066
            ],
            [
              7643.176,
              -861.704,
              14187.946
            ],
            [
              7643.14,
              -841.77,
              14207.88
            ],
            [
              7644.596,
              -822.767,
              14226.938
            ],
            [
              7675.302,
              -640.799,
              14411.479
            ],
            [
              7843.017,
              -670.859,
              14581.867
            ],
            [
              7940.902,
              -687.034,
              14681.079
            ],
            [
              7983.745,
              -695.934,
              14724.837
            ],
            [
              8105.956,
              -711.736,
              14848.065
            ],
            [
              8174.886,
              -715.341,
              14917.089
            ],
            [
              8196.247,
              -711.316,
              14938.826
            ],
            [
              8219.654,
              -701.765,
              14964.107
            ],
            [
              8291.234,
              -637.515,
              15060.293
            ],
            [
              8322.689,
              -612.539,
              15100.458
            ],
            [
              8367.171,
              -581.146,
              15154.902
            ],
            [
              8434.632,
              -625.918,
              15235.868
            ],
            [
              8481.22,
              -650.233,
              15288.419
            ],
            [
              8531.721,
              -672.4,
              15343.571
            ],
            [
              8541.441,
              -631.817,
              15385.302
            ],
            [
              8559.188,
              -557.169,
              15462.031
            ],
            [
              8576.654,
              -426.152,
              15594.207
            ],
            [
              8584.228,
              -306.068,
              15714.529
            ],
            [
              8588.332,
              -198.161,
              15822.514
            ],
            [
              8595.54,
              -160.454,
              15860.904
            ],
            [
              8696.309,
              -134.44,
              15964.977
            ],
            [
              8720.235,
              -127.625,
              15989.855
            ],
            [
              8744.3,
              -121.003,
              16014.814
            ],
            [
              8789.403,
              -109.804,
              16061.287
            ],
            [
              8826.448,
              -96.087,
              16100.789
            ],
            [
              8853.145,
              -83.257,
              16130.409
            ],
            [
              8900.484,
              -38.566,
              16195.511
            ],
            [
              8997.947,
              60.777,
              16334.681
            ],
            [
              9045.087,
              95.45,
              16393.199
            ],
            [
              9064.009,
              106.201,
              16414.962
            ],
            [
              9090.691,
              117.908,
              16444.099
            ],
            [
              9117.305,
              128.24,
              16472.649
            ],
            [
              9141.918,
              131.345,
              16497.457
            ],
            [
              9732.973,
              138.29,
              17088.552
            ],
            [
              9774.103,
              135.215,
              17129.797
            ],
            [
              9799.87,
              133.577,
              17155.616
            ],
            [
              9819.523,
              134.263,
              17175.281
            ],
            [
              9844.442,
              127.789,
              17201.028
            ],
            [
              9855.41,
              124.412,
              17212.503
            ],
            [
              9866.644,
              120.91,
              17224.271
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:5483",
              "position": {
                "x": 2562.319,
                "z": -3823.788
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 3.832,
              "arrivalOffsetSeconds": -540,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:741",
              "position": {
                "x": 2636.723,
                "z": -3876.397
              },
              "distanceAlongShapeM": 683.14,
              "shapeOffsetM": 1.691,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:5104",
              "position": {
                "x": 3111.27,
                "z": -4270.537
              },
              "distanceAlongShapeM": 1398.149,
              "shapeOffsetM": 2.828,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:5105",
              "position": {
                "x": 3402.776,
                "z": -4086.807
              },
              "distanceAlongShapeM": 1742.708,
              "shapeOffsetM": 1.495,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:5107",
              "position": {
                "x": 3640.634,
                "z": -4014.513
              },
              "distanceAlongShapeM": 1990.991,
              "shapeOffsetM": 5.072,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:900",
              "position": {
                "x": 3967.843,
                "z": -4055.264
              },
              "distanceAlongShapeM": 2323.047,
              "shapeOffsetM": 4.809,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:6170",
              "position": {
                "x": 4412.655,
                "z": -4481.261
              },
              "distanceAlongShapeM": 2959.905,
              "shapeOffsetM": 4.78,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:6174",
              "position": {
                "x": 4975.65,
                "z": -4788.242
              },
              "distanceAlongShapeM": 3603.377,
              "shapeOffsetM": 5.109,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:6176",
              "position": {
                "x": 5878.72,
                "z": -5128.645
              },
              "distanceAlongShapeM": 4571.139,
              "shapeOffsetM": 0.416,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:6179",
              "position": {
                "x": 6139.84,
                "z": -4690.667
              },
              "distanceAlongShapeM": 5184.968,
              "shapeOffsetM": 0.028,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:6181",
              "position": {
                "x": 5860.806,
                "z": -4726.4
              },
              "distanceAlongShapeM": 5496.294,
              "shapeOffsetM": 2.217,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            },
            {
              "stopId": "judu:stop:8250",
              "position": {
                "x": 6147.186,
                "z": -4677.451
              },
              "distanceAlongShapeM": 5839.442,
              "shapeOffsetM": 5.306,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:6183",
              "position": {
                "x": 7009.8,
                "z": -5268.893
              },
              "distanceAlongShapeM": 7377.848,
              "shapeOffsetM": 2.808,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:16305",
              "position": {
                "x": 8001.075,
                "z": -5503.484
              },
              "distanceAlongShapeM": 8416.787,
              "shapeOffsetM": 2.28,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            },
            {
              "stopId": "judu:stop:6189",
              "position": {
                "x": 8475.919,
                "z": -5115.561
              },
              "distanceAlongShapeM": 9051.271,
              "shapeOffsetM": 2.859,
              "arrivalOffsetSeconds": 1380,
              "departureOffsetSeconds": 1380
            },
            {
              "stopId": "judu:stop:6191",
              "position": {
                "x": 8534.844,
                "z": -4652.5
              },
              "distanceAlongShapeM": 9538.601,
              "shapeOffsetM": 3.789,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            },
            {
              "stopId": "judu:stop:6192",
              "position": {
                "x": 8555.68,
                "z": -4225.412
              },
              "distanceAlongShapeM": 9970.582,
              "shapeOffsetM": 3.064,
              "arrivalOffsetSeconds": 1500,
              "departureOffsetSeconds": 1500
            },
            {
              "stopId": "judu:stop:6195",
              "position": {
                "x": 8535.854,
                "z": -3609.358
              },
              "distanceAlongShapeM": 10612.564,
              "shapeOffsetM": 9.151,
              "arrivalOffsetSeconds": 1560,
              "departureOffsetSeconds": 1560
            },
            {
              "stopId": "judu:stop:6199",
              "position": {
                "x": 8606.733,
                "z": -2969.524
              },
              "distanceAlongShapeM": 11264.609,
              "shapeOffsetM": 6.527,
              "arrivalOffsetSeconds": 1620,
              "departureOffsetSeconds": 1620
            },
            {
              "stopId": "judu:stop:6204",
              "position": {
                "x": 8924.565,
                "z": -2423.735
              },
              "distanceAlongShapeM": 11899.857,
              "shapeOffsetM": 7.408,
              "arrivalOffsetSeconds": 1680,
              "departureOffsetSeconds": 1680
            },
            {
              "stopId": "judu:stop:6207",
              "position": {
                "x": 8741.282,
                "z": -1762.079
              },
              "distanceAlongShapeM": 12655.772,
              "shapeOffsetM": 3.495,
              "arrivalOffsetSeconds": 1740,
              "departureOffsetSeconds": 1740
            },
            {
              "stopId": "judu:stop:6211",
              "position": {
                "x": 8379.708,
                "z": -1563.322
              },
              "distanceAlongShapeM": 13090.302,
              "shapeOffsetM": 0.106,
              "arrivalOffsetSeconds": 1800,
              "departureOffsetSeconds": 1800
            },
            {
              "stopId": "judu:stop:6217",
              "position": {
                "x": 7918.757,
                "z": -1334.778
              },
              "distanceAlongShapeM": 13619.985,
              "shapeOffsetM": 1.389,
              "arrivalOffsetSeconds": 1860,
              "departureOffsetSeconds": 1860
            },
            {
              "stopId": "judu:stop:5394",
              "position": {
                "x": 7639.707,
                "z": -841.596
              },
              "distanceAlongShapeM": 14207.88,
              "shapeOffsetM": 3.437,
              "arrivalOffsetSeconds": 1980,
              "departureOffsetSeconds": 1980
            },
            {
              "stopId": "judu:stop:5396",
              "position": {
                "x": 7941.422,
                "z": -683.956
              },
              "distanceAlongShapeM": 14681.079,
              "shapeOffsetM": 3.122,
              "arrivalOffsetSeconds": 2040,
              "departureOffsetSeconds": 2040
            },
            {
              "stopId": "judu:stop:6225",
              "position": {
                "x": 8539.64,
                "z": -631.367
              },
              "distanceAlongShapeM": 15385.323,
              "shapeOffsetM": 1.856,
              "arrivalOffsetSeconds": 2160,
              "departureOffsetSeconds": 2160
            },
            {
              "stopId": "judu:stop:6040",
              "position": {
                "x": 8718.239,
                "z": -120.617
              },
              "distanceAlongShapeM": 15989.855,
              "shapeOffsetM": 7.287,
              "arrivalOffsetSeconds": 2280,
              "departureOffsetSeconds": 2280
            },
            {
              "stopId": "judu:stop:6042",
              "position": {
                "x": 9116.151,
                "z": 132.979
              },
              "distanceAlongShapeM": 16472.649,
              "shapeOffsetM": 4.877,
              "arrivalOffsetSeconds": 2340,
              "departureOffsetSeconds": 2340
            },
            {
              "stopId": "judu:stop:6044",
              "position": {
                "x": 9552.934,
                "z": 138.6
              },
              "distanceAlongShapeM": 16908.529,
              "shapeOffsetM": 2.425,
              "arrivalOffsetSeconds": 2400,
              "departureOffsetSeconds": 2400
            },
            {
              "stopId": "judu:stop:7444",
              "position": {
                "x": 9732.975,
                "z": 142.732
              },
              "distanceAlongShapeM": 17088.552,
              "shapeOffsetM": 4.442,
              "arrivalOffsetSeconds": 2460,
              "departureOffsetSeconds": 2460
            }
          ],
          "departuresSeconds": [
            17400,
            19980,
            21300,
            22680,
            24120,
            25020,
            26460,
            28020,
            30540,
            31860,
            33720,
            35520,
            36720,
            38280,
            40320,
            41820,
            43380,
            45540,
            46620,
            48360,
            50220,
            51900,
            53520,
            55080,
            56640,
            58680,
            59700,
            60720,
            62220,
            64140,
            66180,
            67740,
            69660,
            70800,
            72720,
            74400,
            76140,
            77820,
            79320,
            80820,
            82260,
            83940
          ]
        },
        {
          "id": "judu:pattern:vilnius_bus_18:1",
          "sourceRouteId": "vilnius_bus_18",
          "sourceShapeId": "vilnius_bus_18_b-a",
          "directionId": 1,
          "headsign": "Antakalnis",
          "directionName": "Parko g.–Dvarčionys–Antakalnis",
          "mode": "bus",
          "routeShortName": "18",
          "routeLongName": "Antakalnis–Dvarčionys–Parko g.",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              9868.776,
              118.274,
              0
            ],
            [
              9862.137,
              118.949,
              6.673
            ],
            [
              9810.14,
              131.141,
              60.081
            ],
            [
              9748.867,
              131.276,
              121.354
            ],
            [
              9682.329,
              129.236,
              187.923
            ],
            [
              9621.808,
              131.634,
              248.492
            ],
            [
              9517.36,
              133.756,
              352.961
            ],
            [
              9448.882,
              128.466,
              421.643
            ],
            [
              9389.611,
              131.895,
              481.013
            ],
            [
              9156.08,
              129.945,
              714.552
            ],
            [
              9090.691,
              117.908,
              781.04
            ],
            [
              9071.372,
              103.392,
              805.205
            ],
            [
              9049.578,
              94.246,
              828.84
            ],
            [
              8990.008,
              50.917,
              902.501
            ],
            [
              8869.532,
              -70.228,
              1073.354
            ],
            [
              8853.145,
              -83.257,
              1094.289
            ],
            [
              8819.883,
              -101.512,
              1132.231
            ],
            [
              8767.948,
              -118.279,
              1186.806
            ],
            [
              8695.316,
              -137.969,
              1262.059
            ],
            [
              8672.646,
              -150.383,
              1287.906
            ],
            [
              8624.533,
              -154.886,
              1336.229
            ],
            [
              8595.54,
              -160.454,
              1365.752
            ],
            [
              8590.933,
              -197.1,
              1402.686
            ],
            [
              8584.694,
              -314.984,
              1520.735
            ],
            [
              8567.281,
              -539.519,
              1745.944
            ],
            [
              8554.112,
              -617.185,
              1824.719
            ],
            [
              8531.721,
              -672.4,
              1884.301
            ],
            [
              8487.656,
              -660.31,
              1929.995
            ],
            [
              8367.171,
              -581.146,
              2074.16
            ],
            [
              8316.776,
              -617.987,
              2136.585
            ],
            [
              8223.611,
              -697.391,
              2258.997
            ],
            [
              8208.584,
              -707.11,
              2276.893
            ],
            [
              8186.511,
              -714.461,
              2300.158
            ],
            [
              8174.886,
              -715.341,
              2311.817
            ],
            [
              8111.113,
              -711.839,
              2375.686
            ],
            [
              7990.769,
              -699.414,
              2496.669
            ],
            [
              7876.325,
              -682.607,
              2612.341
            ],
            [
              7825.635,
              -669.399,
              2664.723
            ],
            [
              7675.302,
              -640.799,
              2817.753
            ],
            [
              7649.128,
              -789.458,
              2968.698
            ],
            [
              7642.645,
              -888.412,
              3067.864
            ],
            [
              7646.227,
              -935.241,
              3114.83
            ],
            [
              7655.475,
              -956.578,
              3138.085
            ],
            [
              7745.125,
              -1028.985,
              3253.324
            ],
            [
              7766.347,
              -1055.642,
              3287.397
            ],
            [
              7788.775,
              -1095.054,
              3332.743
            ],
            [
              7822.274,
              -1193.691,
              3436.914
            ],
            [
              7847.723,
              -1243.184,
              3492.566
            ],
            [
              7892.309,
              -1303.078,
              3567.233
            ],
            [
              7925.18,
              -1336.019,
              3613.77
            ],
            [
              7938.338,
              -1355.208,
              3637.037
            ],
            [
              7958.585,
              -1374.538,
              3665.029
            ],
            [
              7962.875,
              -1377.597,
              3670.298
            ],
            [
              7988.855,
              -1408.541,
              3710.702
            ],
            [
              8028.081,
              -1446.064,
              3764.985
            ],
            [
              8052.217,
              -1464.359,
              3795.272
            ],
            [
              8094.331,
              -1486.354,
              3842.783
            ],
            [
              8131.468,
              -1499.343,
              3882.126
            ],
            [
              8200.096,
              -1517.416,
              3953.094
            ],
            [
              8364.374,
              -1556.335,
              4121.919
            ],
            [
              8442.629,
              -1573.736,
              4202.086
            ],
            [
              8477.867,
              -1582.217,
              4238.33
            ],
            [
              8608.742,
              -1620.249,
              4374.619
            ],
            [
              8633.675,
              -1630.77,
              4401.681
            ],
            [
              8676.655,
              -1663.23,
              4455.541
            ],
            [
              8797.6,
              -1832.267,
              4663.39
            ],
            [
              8993.679,
              -2124.346,
              5015.181
            ],
            [
              8999.046,
              -2151.368,
              5042.731
            ],
            [
              8981.429,
              -2228.86,
              5122.2
            ],
            [
              8962.683,
              -2369.206,
              5263.793
            ],
            [
              8933.873,
              -2426.309,
              5327.752
            ],
            [
              8918.227,
              -2450.327,
              5356.417
            ],
            [
              8906.472,
              -2473.281,
              5382.206
            ],
            [
              8894.661,
              -2493.258,
              5405.414
            ],
            [
              8886.503,
              -2507.056,
              5421.442
            ],
            [
              8823.576,
              -2636.564,
              5565.429
            ],
            [
              8693.778,
              -2817.191,
              5787.856
            ],
            [
              8633.187,
              -2893.097,
              5884.98
            ],
            [
              8622.762,
              -2909.729,
              5904.608
            ],
            [
              8617.696,
              -2925.05,
              5920.745
            ],
            [
              8615.157,
              -3048.747,
              6044.468
            ],
            [
              8615.087,
              -3075.494,
              6071.215
            ],
            [
              8610.627,
              -3267.946,
              6263.719
            ],
            [
              8607.651,
              -3370.322,
              6366.139
            ],
            [
              8602.547,
              -3433.686,
              6429.707
            ],
            [
              8585.514,
              -3497.61,
              6495.861
            ],
            [
              8480.411,
              -3842.585,
              6856.492
            ],
            [
              8473.917,
              -3967.692,
              6981.768
            ],
            [
              8472.763,
              -4020.25,
              7034.339
            ],
            [
              8478.487,
              -4052.192,
              7066.789
            ],
            [
              8526.066,
              -4127.959,
              7156.257
            ],
            [
              8544.03,
              -4163.946,
              7196.478
            ],
            [
              8560.569,
              -4224.834,
              7259.573
            ],
            [
              8572.237,
              -4299.223,
              7334.871
            ],
            [
              8566.162,
              -4416.858,
              7452.662
            ],
            [
              8551.249,
              -4479.528,
              7517.082
            ],
            [
              8536.971,
              -4546.779,
              7585.833
            ],
            [
              8536.557,
              -4605.836,
              7644.891
            ],
            [
              8547.759,
              -4715.105,
              7754.733
            ],
            [
              8551.58,
              -4769.231,
              7808.993
            ],
            [
              8548.398,
              -5003.463,
              8043.247
            ],
            [
              8536.644,
              -5043.305,
              8084.787
            ],
            [
              8512.077,
              -5079.55,
              8128.573
            ],
            [
              8440.114,
              -5166.053,
              8241.096
            ],
            [
              8420.62,
              -5192.663,
              8274.083
            ],
            [
              8403.489,
              -5213.051,
              8300.712
            ],
            [
              8359.186,
              -5265.696,
              8369.519
            ],
            [
              8263.064,
              -5381.389,
              8519.932
            ],
            [
              8231.698,
              -5414.963,
              8565.878
            ],
            [
              8203.434,
              -5435.173,
              8600.624
            ],
            [
              8147.412,
              -5460.51,
              8662.109
            ],
            [
              7983.934,
              -5517.856,
              8835.354
            ],
            [
              7926.678,
              -5518.741,
              8892.617
            ],
            [
              7892.106,
              -5518.7,
              8927.189
            ],
            [
              7841.422,
              -5505.523,
              8979.558
            ],
            [
              7701.025,
              -5412.858,
              9147.778
            ],
            [
              7048.217,
              -5280.786,
              9813.812
            ],
            [
              6784.784,
              -5245.52,
              10079.595
            ],
            [
              6076.818,
              -5178.164,
              10790.758
            ],
            [
              6011.533,
              -5169.201,
              10856.656
            ],
            [
              5986.3,
              -5161.92,
              10882.918
            ],
            [
              5981.499,
              -5158.246,
              10888.964
            ],
            [
              5980.83,
              -5145.113,
              10902.114
            ],
            [
              5992.039,
              -5131.973,
              10919.385
            ],
            [
              5997.747,
              -5122.02,
              10930.859
            ],
            [
              6009.977,
              -5005.41,
              11048.108
            ],
            [
              6012.226,
              -4969.877,
              11083.712
            ],
            [
              6022.232,
              -4938.853,
              11116.31
            ],
            [
              6026.936,
              -4928.925,
              11127.296
            ],
            [
              6102.313,
              -4821.094,
              11258.86
            ],
            [
              6130.193,
              -4788.447,
              11301.792
            ],
            [
              6148.553,
              -4772.107,
              11326.37
            ],
            [
              6156.478,
              -4762.243,
              11339.024
            ],
            [
              6161.248,
              -4748.977,
              11353.121
            ],
            [
              6159.686,
              -4730.021,
              11372.141
            ],
            [
              6140.414,
              -4690.434,
              11416.17
            ],
            [
              6125.051,
              -4655.893,
              11453.974
            ],
            [
              6001.369,
              -4687.956,
              11581.744
            ],
            [
              5943.985,
              -4702.264,
              11640.884
            ],
            [
              5887.559,
              -4716.566,
              11699.095
            ],
            [
              5850.665,
              -4726.952,
              11737.422
            ],
            [
              5840.825,
              -4727.158,
              11747.265
            ],
            [
              5842.74,
              -4726.38,
              11749.332
            ],
            [
              5842.929,
              -4726.317,
              11749.532
            ],
            [
              5876.327,
              -4719.282,
              11783.663
            ],
            [
              5917.574,
              -4709.024,
              11826.166
            ],
            [
              6088.174,
              -4665.357,
              12002.266
            ],
            [
              6114.992,
              -4655.609,
              12030.801
            ],
            [
              6125.051,
              -4655.893,
              12040.863
            ],
            [
              6136.422,
              -4666.325,
              12056.295
            ],
            [
              6142.269,
              -4679.446,
              12070.659
            ],
            [
              6158.391,
              -4720.832,
              12115.075
            ],
            [
              6163.78,
              -4751.253,
              12145.97
            ],
            [
              6151.795,
              -4771.057,
              12169.118
            ],
            [
              6112.346,
              -4811.476,
              12225.597
            ],
            [
              6090.548,
              -4838.881,
              12260.614
            ],
            [
              6026.248,
              -4931.138,
              12373.068
            ],
            [
              6016.775,
              -4954.332,
              12398.122
            ],
            [
              6009.203,
              -5012.074,
              12456.358
            ],
            [
              6000.05,
              -5117.657,
              12562.337
            ],
            [
              6007.267,
              -5136.206,
              12582.241
            ],
            [
              6013.543,
              -5152.433,
              12599.639
            ],
            [
              6017.881,
              -5162.508,
              12610.609
            ],
            [
              6016.502,
              -5165.85,
              12614.224
            ],
            [
              5956.294,
              -5147.973,
              12677.03
            ],
            [
              5814.308,
              -5121.089,
              12821.539
            ],
            [
              5758.991,
              -5108.418,
              12878.289
            ],
            [
              5655.118,
              -5065.278,
              12990.763
            ],
            [
              5349.652,
              -4947.461,
              13318.163
            ],
            [
              5090.698,
              -4844.537,
              13596.821
            ],
            [
              4956.995,
              -4786.768,
              13742.47
            ],
            [
              4922.404,
              -4776.733,
              13778.488
            ],
            [
              4893.064,
              -4761.041,
              13811.76
            ],
            [
              4762.926,
              -4693.959,
              13958.17
            ],
            [
              4470.367,
              -4529.128,
              14293.968
            ],
            [
              4430.884,
              -4504.99,
              14340.245
            ],
            [
              4360.976,
              -4454.664,
              14426.383
            ],
            [
              4345.928,
              -4445.468,
              14444.019
            ],
            [
              4316.488,
              -4422.639,
              14481.273
            ],
            [
              4266.267,
              -4387.164,
              14542.76
            ],
            [
              4203.85,
              -4349.23,
              14615.8
            ],
            [
              4164.858,
              -4332.897,
              14658.075
            ],
            [
              4107.571,
              -4296.175,
              14726.121
            ],
            [
              4086.034,
              -4276.838,
              14755.065
            ],
            [
              4073.041,
              -4259.008,
              14777.127
            ],
            [
              4054.871,
              -4221.691,
              14818.633
            ],
            [
              4018.762,
              -4121.92,
              14924.737
            ],
            [
              3999.262,
              -4097.055,
              14956.336
            ],
            [
              3970.079,
              -4073.119,
              14994.08
            ],
            [
              3943.496,
              -4057.143,
              15025.094
            ],
            [
              3899.276,
              -4037.251,
              15073.582
            ],
            [
              3898.616,
              -4036.13,
              15074.883
            ],
            [
              3858.828,
              -4027.577,
              15115.58
            ],
            [
              3592.048,
              -4028.061,
              15382.36
            ],
            [
              3581.678,
              -4031.203,
              15393.196
            ],
            [
              3564.996,
              -4038.354,
              15411.346
            ],
            [
              3520.083,
              -4051.184,
              15458.055
            ],
            [
              3445.458,
              -4078.711,
              15537.596
            ],
            [
              3358.965,
              -4120.486,
              15633.649
            ],
            [
              3358.852,
              -4122.75,
              15635.916
            ],
            [
              3310.064,
              -4150.73,
              15692.158
            ],
            [
              3021.059,
              -4338.966,
              16037.058
            ],
            [
              2959.695,
              -4278.804,
              16122.995
            ],
            [
              2940.311,
              -4262.522,
              16148.309
            ],
            [
              2920.517,
              -4237.987,
              16179.833
            ],
            [
              2810.169,
              -4110.107,
              16348.742
            ],
            [
              2739.116,
              -4050.879,
              16441.243
            ],
            [
              2661.391,
              -4003.772,
              16532.129
            ],
            [
              2637.654,
              -3993.387,
              16558.039
            ],
            [
              2609.738,
              -3974.969,
              16591.483
            ],
            [
              2502.106,
              -3906.664,
              16718.959
            ],
            [
              2488.357,
              -3884.741,
              16744.836
            ],
            [
              2476.247,
              -3843.323,
              16787.989
            ],
            [
              2501.318,
              -3743.601,
              16890.814
            ],
            [
              2515.139,
              -3728.275,
              16911.451
            ],
            [
              2523.372,
              -3727.648,
              16919.708
            ],
            [
              2540.053,
              -3739.875,
              16940.39
            ],
            [
              2551,
              -3774.592,
              16976.792
            ],
            [
              2558.505,
              -3824.161,
              17026.927
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:6073",
              "position": {
                "x": 9682.346,
                "z": 127.063
              },
              "distanceAlongShapeM": 187.923,
              "shapeOffsetM": 2.173,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:6045",
              "position": {
                "x": 9448.882,
                "z": 128.466
              },
              "distanceAlongShapeM": 421.643,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 60,
              "departureOffsetSeconds": 60
            },
            {
              "stopId": "judu:stop:6043",
              "position": {
                "x": 9073.545,
                "z": 99.328
              },
              "distanceAlongShapeM": 805.205,
              "shapeOffsetM": 4.609,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:6041",
              "position": {
                "x": 8673.105,
                "z": -151.995
              },
              "distanceAlongShapeM": 1287.906,
              "shapeOffsetM": 1.676,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:5400",
              "position": {
                "x": 8486.109,
                "z": -663.69
              },
              "distanceAlongShapeM": 1929.995,
              "shapeOffsetM": 3.717,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:5415",
              "position": {
                "x": 7876.316,
                "z": -682.656
              },
              "distanceAlongShapeM": 2612.341,
              "shapeOffsetM": 0.05,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:6230",
              "position": {
                "x": 7745.609,
                "z": -1028.51
              },
              "distanceAlongShapeM": 3253.324,
              "shapeOffsetM": 0.678,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:6215",
              "position": {
                "x": 7965.008,
                "z": -1375.78
              },
              "distanceAlongShapeM": 3670.298,
              "shapeOffsetM": 2.802,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:6212",
              "position": {
                "x": 8478.693,
                "z": -1578.669
              },
              "distanceAlongShapeM": 4238.303,
              "shapeOffsetM": 3.643,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:6208",
              "position": {
                "x": 8678.185,
                "z": -1661.725
              },
              "distanceAlongShapeM": 4455.541,
              "shapeOffsetM": 2.146,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:6203",
              "position": {
                "x": 8900.529,
                "z": -2496.728
              },
              "distanceAlongShapeM": 5405.414,
              "shapeOffsetM": 6.817,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            },
            {
              "stopId": "judu:stop:6198",
              "position": {
                "x": 8617.491,
                "z": -3075.504
              },
              "distanceAlongShapeM": 6071.215,
              "shapeOffsetM": 2.404,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:456",
              "position": {
                "x": 8522.753,
                "z": -3715.971
              },
              "distanceAlongShapeM": 6723.035,
              "shapeOffsetM": 3.603,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:6193",
              "position": {
                "x": 8562.788,
                "z": -4224.442
              },
              "distanceAlongShapeM": 7259.573,
              "shapeOffsetM": 2.254,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:6190",
              "position": {
                "x": 8560.209,
                "z": -4768.794
              },
              "distanceAlongShapeM": 7808.993,
              "shapeOffsetM": 8.64,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:6188",
              "position": {
                "x": 8428.495,
                "z": -5199.218
              },
              "distanceAlongShapeM": 8274.083,
              "shapeOffsetM": 10.246,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            },
            {
              "stopId": "judu:stop:16306",
              "position": {
                "x": 7891.85,
                "z": -5521.339
              },
              "distanceAlongShapeM": 8927.189,
              "shapeOffsetM": 2.651,
              "arrivalOffsetSeconds": 1380,
              "departureOffsetSeconds": 1380
            },
            {
              "stopId": "judu:stop:6184",
              "position": {
                "x": 6930.636,
                "z": -5265.1
              },
              "distanceAlongShapeM": 9932.435,
              "shapeOffsetM": 0.054,
              "arrivalOffsetSeconds": 1500,
              "departureOffsetSeconds": 1500
            },
            {
              "stopId": "judu:stop:6179",
              "position": {
                "x": 6139.84,
                "z": -4690.667
              },
              "distanceAlongShapeM": 11416.191,
              "shapeOffsetM": 0.619,
              "arrivalOffsetSeconds": 1680,
              "departureOffsetSeconds": 1680
            },
            {
              "stopId": "judu:stop:429",
              "position": {
                "x": 5873.348,
                "z": -4711.059
              },
              "distanceAlongShapeM": 11782.442,
              "shapeOffsetM": 8.661,
              "arrivalOffsetSeconds": 1740,
              "departureOffsetSeconds": 1740
            },
            {
              "stopId": "judu:stop:6180",
              "position": {
                "x": 6155.144,
                "z": -4698.76
              },
              "distanceAlongShapeM": 12093.33,
              "shapeOffsetM": 4.986,
              "arrivalOffsetSeconds": 1800,
              "departureOffsetSeconds": 1800
            },
            {
              "stopId": "judu:stop:6177",
              "position": {
                "x": 5813.742,
                "z": -5124.036
              },
              "distanceAlongShapeM": 12821.539,
              "shapeOffsetM": 3.001,
              "arrivalOffsetSeconds": 1920,
              "departureOffsetSeconds": 1920
            },
            {
              "stopId": "judu:stop:6173",
              "position": {
                "x": 4921.724,
                "z": -4778.293
              },
              "distanceAlongShapeM": 13778.488,
              "shapeOffsetM": 1.702,
              "arrivalOffsetSeconds": 1980,
              "departureOffsetSeconds": 1980
            },
            {
              "stopId": "judu:stop:6171",
              "position": {
                "x": 4344.358,
                "z": -4447.665
              },
              "distanceAlongShapeM": 14444.019,
              "shapeOffsetM": 2.701,
              "arrivalOffsetSeconds": 2040,
              "departureOffsetSeconds": 2040
            },
            {
              "stopId": "judu:stop:6239",
              "position": {
                "x": 3898.552,
                "z": -4039.468
              },
              "distanceAlongShapeM": 15073.333,
              "shapeOffsetM": 2.319,
              "arrivalOffsetSeconds": 2160,
              "departureOffsetSeconds": 2160
            },
            {
              "stopId": "judu:stop:5116",
              "position": {
                "x": 3565.986,
                "z": -4043.151
              },
              "distanceAlongShapeM": 15411.712,
              "shapeOffsetM": 4.885,
              "arrivalOffsetSeconds": 2220,
              "departureOffsetSeconds": 2220
            },
            {
              "stopId": "judu:stop:6715",
              "position": {
                "x": 3360.169,
                "z": -4124.962
              },
              "distanceAlongShapeM": 15635.916,
              "shapeOffsetM": 2.574,
              "arrivalOffsetSeconds": 2280,
              "departureOffsetSeconds": 2280
            },
            {
              "stopId": "judu:stop:5103",
              "position": {
                "x": 2937.404,
                "z": -4265.024
              },
              "distanceAlongShapeM": 16148.309,
              "shapeOffsetM": 3.836,
              "arrivalOffsetSeconds": 2400,
              "departureOffsetSeconds": 2400
            },
            {
              "stopId": "judu:stop:5117",
              "position": {
                "x": 2636.416,
                "z": -3995.509
              },
              "distanceAlongShapeM": 16558.039,
              "shapeOffsetM": 2.457,
              "arrivalOffsetSeconds": 2460,
              "departureOffsetSeconds": 2460
            },
            {
              "stopId": "judu:stop:5483",
              "position": {
                "x": 2562.319,
                "z": -3823.788
              },
              "distanceAlongShapeM": 17026.927,
              "shapeOffsetM": 3.832,
              "arrivalOffsetSeconds": 2520,
              "departureOffsetSeconds": 2520
            }
          ],
          "departuresSeconds": [
            19500,
            21060,
            23160,
            24720,
            25980,
            27360,
            28380,
            29700,
            31260,
            33960,
            35160,
            36960,
            38700,
            40260,
            41760,
            43380,
            44880,
            46500,
            48660,
            50040,
            51420,
            53400,
            55500,
            57000,
            58800,
            60480,
            61860,
            63000,
            64200,
            65460,
            67320,
            69420,
            71040,
            72780,
            74340,
            76080,
            77700,
            79320,
            81120,
            82500,
            83880,
            85140
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_bus_19",
      "sourceRouteId": "vilnius_bus_19",
      "mode": "bus",
      "shortName": "19",
      "longName": "Stotis–Lydos pl.–Salininkai",
      "color": "0073AC",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_bus_19:0",
          "sourceRouteId": "vilnius_bus_19",
          "sourceShapeId": "vilnius_bus_19_a-b",
          "directionId": 0,
          "headsign": "Salininkai",
          "directionName": "Stotis–Lydos pl.–Salininkai",
          "mode": "bus",
          "routeShortName": "19",
          "routeLongName": "Stotis–Lydos pl.–Salininkai",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              433.363,
              1920.43,
              0
            ],
            [
              403.923,
              1936.074,
              33.338
            ],
            [
              382.944,
              1953.155,
              60.392
            ],
            [
              371.557,
              1965.609,
              77.267
            ],
            [
              363.417,
              1979.117,
              93.038
            ],
            [
              363.117,
              1998.047,
              111.97
            ],
            [
              380.715,
              2007.745,
              132.063
            ],
            [
              401.919,
              2002.904,
              153.813
            ],
            [
              472.033,
              1955.979,
              238.181
            ],
            [
              476.345,
              1944.768,
              250.192
            ],
            [
              476.643,
              1925.838,
              269.125
            ],
            [
              530.958,
              1897.013,
              330.615
            ],
            [
              623.161,
              1858.587,
              430.504
            ],
            [
              825.163,
              1791.425,
              643.379
            ],
            [
              863.527,
              1836.207,
              702.346
            ],
            [
              869.06,
              1862.978,
              729.684
            ],
            [
              873.401,
              1888.503,
              755.575
            ],
            [
              890.379,
              1910.039,
              782.998
            ],
            [
              909.687,
              1916.752,
              803.44
            ],
            [
              941.154,
              1923.993,
              835.73
            ],
            [
              953.593,
              1933.783,
              851.559
            ],
            [
              1083.618,
              2057.184,
              1030.819
            ],
            [
              1196.071,
              2172,
              1191.532
            ],
            [
              1233.034,
              2216.96,
              1249.735
            ],
            [
              1262.402,
              2269.853,
              1310.234
            ],
            [
              1275.582,
              2294.627,
              1338.296
            ],
            [
              1295.641,
              2322.675,
              1372.779
            ],
            [
              1353.693,
              2426.246,
              1491.51
            ],
            [
              1363.843,
              2451.663,
              1518.878
            ],
            [
              1395.21,
              2612.502,
              1682.747
            ],
            [
              1412.03,
              2684.551,
              1756.734
            ],
            [
              1428.563,
              2741.021,
              1815.574
            ],
            [
              1438.754,
              2768.663,
              1845.035
            ],
            [
              1469.827,
              2811.004,
              1897.554
            ],
            [
              1478.408,
              2819.138,
              1909.378
            ],
            [
              1513.094,
              2845.213,
              1952.772
            ],
            [
              1567.546,
              2893.187,
              2025.343
            ],
            [
              1617.065,
              2953.497,
              2103.377
            ],
            [
              1672.764,
              3033.73,
              2201.049
            ],
            [
              1688.949,
              3071.28,
              2241.938
            ],
            [
              1698.328,
              3124.541,
              2296.019
            ],
            [
              1700.436,
              3377.207,
              2548.694
            ],
            [
              1694.118,
              3454.138,
              2625.884
            ],
            [
              1677.248,
              3567.892,
              2740.881
            ],
            [
              1670.163,
              3728.439,
              2901.585
            ],
            [
              1664.831,
              3754.142,
              2927.835
            ],
            [
              1667.138,
              3878.769,
              3052.484
            ],
            [
              1663.704,
              3902.223,
              3076.188
            ],
            [
              1665.775,
              3934.434,
              3108.465
            ],
            [
              1673.134,
              4166.999,
              3341.147
            ],
            [
              1673.634,
              4298.351,
              3472.5
            ],
            [
              1669.336,
              4336.28,
              3510.672
            ],
            [
              1674.124,
              4359.57,
              3534.448
            ],
            [
              1676.865,
              4402.935,
              3577.9
            ],
            [
              1687.031,
              4881.438,
              4056.511
            ],
            [
              1684.461,
              4913.77,
              4088.945
            ],
            [
              1688.75,
              4939.294,
              4114.827
            ],
            [
              1707.244,
              5553.457,
              4729.268
            ],
            [
              1715.118,
              5664.634,
              4840.724
            ],
            [
              1721.355,
              5722.407,
              4898.832
            ],
            [
              1837.871,
              6538.4,
              5723.102
            ],
            [
              1901.016,
              6997.851,
              6186.872
            ],
            [
              1908.882,
              7038.147,
              6227.928
            ],
            [
              1906.805,
              7049.277,
              6239.251
            ],
            [
              1901.784,
              7057.163,
              6248.6
            ],
            [
              1897.124,
              7070.419,
              6262.651
            ],
            [
              498.292,
              7831.237,
              7855
            ],
            [
              24.609,
              8094.76,
              8397.051
            ],
            [
              -36.687,
              8522.097,
              8828.762
            ],
            [
              -60.522,
              8786.803,
              9094.539
            ],
            [
              -61.625,
              8872.858,
              9180.601
            ],
            [
              -86.142,
              8909.577,
              9224.753
            ],
            [
              -231.023,
              9094.516,
              9459.684
            ],
            [
              -381.781,
              9219.949,
              9655.8
            ],
            [
              -421.991,
              9254.931,
              9709.097
            ],
            [
              -493.633,
              9312.445,
              9800.97
            ],
            [
              -530.619,
              9330.53,
              9842.14
            ],
            [
              -544.693,
              9331.823,
              9856.273
            ],
            [
              -569.939,
              9328.846,
              9881.694
            ],
            [
              -763.905,
              9287.809,
              10079.954
            ],
            [
              -800.202,
              9281.782,
              10116.748
            ],
            [
              -908.755,
              9281.708,
              10225.301
            ],
            [
              -1071.667,
              9279.588,
              10388.226
            ],
            [
              -1100.766,
              9279.883,
              10417.327
            ],
            [
              -1181.459,
              9283.052,
              10498.082
            ],
            [
              -1238.935,
              9284.4,
              10555.574
            ],
            [
              -1308.161,
              9280.864,
              10624.89
            ],
            [
              -1343.772,
              9277.047,
              10660.705
            ],
            [
              -1428.033,
              9262.966,
              10746.135
            ],
            [
              -1539.363,
              9240.213,
              10859.766
            ],
            [
              -1618.698,
              9225.174,
              10940.514
            ],
            [
              -1611.932,
              9178.268,
              10987.905
            ],
            [
              -1594.884,
              9079.558,
              11088.077
            ],
            [
              -1553.706,
              8810.898,
              11359.874
            ],
            [
              -1551.783,
              8799.178,
              11371.751
            ],
            [
              -1550.14,
              8789.161,
              11381.902
            ],
            [
              -1535.825,
              8767.618,
              11407.767
            ],
            [
              -1545.584,
              8758.552,
              11421.087
            ],
            [
              -1504.025,
              8516.246,
              11666.931
            ],
            [
              -1501.823,
              8482.803,
              11700.446
            ],
            [
              -1503.347,
              8447.272,
              11736.01
            ],
            [
              -1506.906,
              8413.918,
              11769.554
            ],
            [
              -1524.816,
              8328.484,
              11856.844
            ],
            [
              -1528.566,
              8312.945,
              11872.829
            ],
            [
              -1534.753,
              8301.638,
              11885.719
            ],
            [
              -1539.544,
              8295.235,
              11893.715
            ],
            [
              -1544.538,
              8290.457,
              11900.627
            ],
            [
              -1546.654,
              8292.394,
              11903.496
            ],
            [
              -1543.294,
              8295.458,
              11908.043
            ],
            [
              -1537.002,
              8303.418,
              11918.19
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:4266",
              "position": {
                "x": 433.307,
                "z": 1919.951
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 0.483,
              "arrivalOffsetSeconds": -300,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:5941",
              "position": {
                "x": 889.31,
                "z": 1911.588
              },
              "distanceAlongShapeM": 782.998,
              "shapeOffsetM": 1.882,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:5944",
              "position": {
                "x": 1272.571,
                "z": 2296.383
              },
              "distanceAlongShapeM": 1338.296,
              "shapeOffsetM": 3.486,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:5946",
              "position": {
                "x": 1466.069,
                "z": 2814.913
              },
              "distanceAlongShapeM": 1897.554,
              "shapeOffsetM": 5.422,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:5953",
              "position": {
                "x": 1663.704,
                "z": 3902.223
              },
              "distanceAlongShapeM": 3076.188,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:5955",
              "position": {
                "x": 1669.173,
                "z": 4336.284
              },
              "distanceAlongShapeM": 3510.672,
              "shapeOffsetM": 0.163,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:5956",
              "position": {
                "x": 1684.403,
                "z": 4913.771
              },
              "distanceAlongShapeM": 4088.945,
              "shapeOffsetM": 0.058,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:5958",
              "position": {
                "x": 1721.355,
                "z": 5722.407
              },
              "distanceAlongShapeM": 4898.832,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:17944",
              "position": {
                "x": 1837.248,
                "z": 6538.482
              },
              "distanceAlongShapeM": 5723.095,
              "shapeOffsetM": 0.629,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            },
            {
              "stopId": "judu:stop:5960",
              "position": {
                "x": 1900.043,
                "z": 6998.194
              },
              "distanceAlongShapeM": 6187.022,
              "shapeOffsetM": 1.02,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            },
            {
              "stopId": "judu:stop:8329",
              "position": {
                "x": 1211.864,
                "z": 7439.522
              },
              "distanceAlongShapeM": 7040.988,
              "shapeOffsetM": 3.168,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:6240",
              "position": {
                "x": 494.746,
                "z": 7824.496
              },
              "distanceAlongShapeM": 7854.894,
              "shapeOffsetM": 7.616,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:6243",
              "position": {
                "x": -46.267,
                "z": 8521.201
              },
              "distanceAlongShapeM": 8828.762,
              "shapeOffsetM": 9.622,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:6246",
              "position": {
                "x": -64.071,
                "z": 8786.47
              },
              "distanceAlongShapeM": 9094.526,
              "shapeOffsetM": 3.565,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            },
            {
              "stopId": "judu:stop:6248",
              "position": {
                "x": -383.893,
                "z": 9217.507
              },
              "distanceAlongShapeM": 9655.8,
              "shapeOffsetM": 3.228,
              "arrivalOffsetSeconds": 1380,
              "departureOffsetSeconds": 1380
            },
            {
              "stopId": "judu:stop:6254",
              "position": {
                "x": -1100.805,
                "z": 9276.043
              },
              "distanceAlongShapeM": 10417.327,
              "shapeOffsetM": 3.84,
              "arrivalOffsetSeconds": 1500,
              "departureOffsetSeconds": 1500
            },
            {
              "stopId": "judu:stop:6256",
              "position": {
                "x": -1538.979,
                "z": 9238.226
              },
              "distanceAlongShapeM": 10859.766,
              "shapeOffsetM": 2.024,
              "arrivalOffsetSeconds": 1620,
              "departureOffsetSeconds": 1620
            },
            {
              "stopId": "judu:stop:6260",
              "position": {
                "x": -1540.488,
                "z": 8790.744
              },
              "distanceAlongShapeM": 11385.925,
              "shapeOffsetM": 8.915,
              "arrivalOffsetSeconds": 1680,
              "departureOffsetSeconds": 1680
            },
            {
              "stopId": "judu:stop:6264",
              "position": {
                "x": -1542.006,
                "z": 8306.527
              },
              "distanceAlongShapeM": 11917.526,
              "shapeOffsetM": 5.854,
              "arrivalOffsetSeconds": 1800,
              "departureOffsetSeconds": 1800
            }
          ],
          "departuresSeconds": [
            18360,
            21420,
            23160,
            24420,
            26220,
            28200,
            30240,
            34500,
            36300,
            38760,
            40800,
            42900,
            45120,
            47460,
            49320,
            52020,
            54540,
            56820,
            59340,
            60840,
            62220,
            64740,
            67140,
            71100,
            72900,
            75240,
            77400,
            79200,
            81540,
            83160
          ]
        },
        {
          "id": "judu:pattern:vilnius_bus_19:1",
          "sourceRouteId": "vilnius_bus_19",
          "sourceShapeId": "vilnius_bus_19_b-a",
          "directionId": 1,
          "headsign": "Stotis",
          "directionName": "Salininkai–Lydos pl.–Stotis",
          "mode": "bus",
          "routeShortName": "19",
          "routeLongName": "Stotis–Lydos pl.–Salininkai",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              -1537.002,
              8303.418,
              0
            ],
            [
              -1526.833,
              8324.068,
              23.018
            ],
            [
              -1511.486,
              8383.991,
              84.875
            ],
            [
              -1505.414,
              8438.346,
              139.568
            ],
            [
              -1503.229,
              8488.402,
              189.672
            ],
            [
              -1511.708,
              8556.458,
              258.254
            ],
            [
              -1543.904,
              8744.051,
              448.59
            ],
            [
              -1553.048,
              8789.284,
              494.738
            ],
            [
              -1618.698,
              9225.174,
              935.544
            ],
            [
              -1566.4,
              9238.022,
              989.397
            ],
            [
              -1337.536,
              9280.082,
              1222.094
            ],
            [
              -974.554,
              9283.037,
              1585.088
            ],
            [
              -908.755,
              9281.708,
              1650.9
            ],
            [
              -810.253,
              9283.036,
              1749.411
            ],
            [
              -775.051,
              9286.212,
              1784.756
            ],
            [
              -684.622,
              9303.566,
              1876.836
            ],
            [
              -547.922,
              9331.915,
              2016.444
            ],
            [
              -527.939,
              9330.11,
              2036.508
            ],
            [
              -475.638,
              9302.384,
              2095.704
            ],
            [
              -309.377,
              9163.537,
              2312.317
            ],
            [
              -271.763,
              9128.649,
              2363.62
            ],
            [
              -238.634,
              9102.446,
              2405.859
            ],
            [
              -222.12,
              9086.562,
              2428.772
            ],
            [
              -69.688,
              8891.534,
              2676.303
            ],
            [
              -61.625,
              8872.858,
              2696.645
            ],
            [
              -61.822,
              8836.435,
              2733.069
            ],
            [
              -60.609,
              8813.88,
              2755.656
            ],
            [
              -25.838,
              8431.32,
              3139.793
            ],
            [
              12.313,
              8118.47,
              3454.96
            ],
            [
              24.609,
              8094.76,
              3481.67
            ],
            [
              35.318,
              8083.484,
              3497.22
            ],
            [
              544.189,
              7808.007,
              4075.871
            ],
            [
              567.546,
              7796.652,
              4101.842
            ],
            [
              1059.445,
              7533.649,
              4659.637
            ],
            [
              1281.146,
              7415.304,
              4910.947
            ],
            [
              1767.948,
              7151.479,
              5464.644
            ],
            [
              1897.124,
              7070.419,
              5617.147
            ],
            [
              1909.301,
              7079.288,
              5632.211
            ],
            [
              1919.028,
              7081.334,
              5642.151
            ],
            [
              1929.608,
              7078.41,
              5653.128
            ],
            [
              1934.323,
              7070.859,
              5662.03
            ],
            [
              1935.088,
              7062.17,
              5670.752
            ],
            [
              1928.176,
              7052.22,
              5682.868
            ],
            [
              1916.464,
              7040.944,
              5699.125
            ],
            [
              1840.946,
              6503.051,
              6242.294
            ],
            [
              1738.747,
              5824.501,
              6928.497
            ],
            [
              1738.128,
              5791.116,
              6961.888
            ],
            [
              1710.961,
              5614.616,
              7140.466
            ],
            [
              1705.045,
              5504.515,
              7250.726
            ],
            [
              1687.181,
              4854.718,
              7900.769
            ],
            [
              1690.302,
              4817.923,
              7937.696
            ],
            [
              1685.654,
              4772.367,
              7983.488
            ],
            [
              1681.965,
              4538.656,
              8217.229
            ],
            [
              1676.865,
              4402.935,
              8353.045
            ],
            [
              1678.187,
              4335.004,
              8420.989
            ],
            [
              1682.001,
              4273.043,
              8483.067
            ],
            [
              1693.897,
              4242.314,
              8516.019
            ],
            [
              1695.023,
              4233.387,
              8525.016
            ],
            [
              1700.816,
              4219.593,
              8539.978
            ],
            [
              1697.544,
              4199.121,
              8560.71
            ],
            [
              1674.822,
              4153.608,
              8611.579
            ],
            [
              1671.231,
              3959.972,
              8805.248
            ],
            [
              1674.798,
              3769.542,
              8995.712
            ],
            [
              1679.511,
              3724.956,
              9040.546
            ],
            [
              1684.234,
              3721.498,
              9046.399
            ],
            [
              1679.247,
              3710.449,
              9058.522
            ],
            [
              1680.184,
              3591.526,
              9177.448
            ],
            [
              1696.885,
              3464.105,
              9305.959
            ],
            [
              1701.829,
              3382.747,
              9387.467
            ],
            [
              1703.03,
              3134.473,
              9635.744
            ],
            [
              1699.891,
              3104.474,
              9665.907
            ],
            [
              1687.994,
              3054.599,
              9717.181
            ],
            [
              1659.262,
              3001.697,
              9777.382
            ],
            [
              1605.061,
              2932.568,
              9865.226
            ],
            [
              1556.997,
              2881.137,
              9935.62
            ],
            [
              1484.111,
              2813.466,
              10035.077
            ],
            [
              1478.391,
              2802.8,
              10047.18
            ],
            [
              1453.839,
              2781.743,
              10079.525
            ],
            [
              1433.991,
              2755.392,
              10112.515
            ],
            [
              1428.563,
              2741.021,
              10127.877
            ],
            [
              1382.281,
              2541.494,
              10332.701
            ],
            [
              1365.86,
              2456.079,
              10419.68
            ],
            [
              1336.284,
              2392.058,
              10490.203
            ],
            [
              1222.21,
              2196.952,
              10716.21
            ],
            [
              958.108,
              1933.7,
              11089.106
            ],
            [
              918.257,
              1878.079,
              11157.53
            ],
            [
              898.105,
              1863.557,
              11182.369
            ],
            [
              863.527,
              1836.207,
              11226.456
            ],
            [
              825.163,
              1791.425,
              11285.424
            ],
            [
              623.161,
              1858.587,
              11498.298
            ],
            [
              493.411,
              1911.506,
              11638.425
            ],
            [
              482.346,
              1920.167,
              11652.477
            ],
            [
              476.582,
              1922.499,
              11658.694
            ],
            [
              466.222,
              1920.462,
              11669.253
            ],
            [
              444.313,
              1921.976,
              11691.214
            ],
            [
              433.363,
              1920.43,
              11702.273
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:6264",
              "position": {
                "x": -1542.006,
                "z": 8306.527
              },
              "distanceAlongShapeM": 0.578,
              "shapeOffsetM": 5.863,
              "arrivalOffsetSeconds": -420,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:6261",
              "position": {
                "x": -1556.03,
                "z": 8788.795
              },
              "distanceAlongShapeM": 494.738,
              "shapeOffsetM": 3.022,
              "arrivalOffsetSeconds": 60,
              "departureOffsetSeconds": 60
            },
            {
              "stopId": "judu:stop:6257",
              "position": {
                "x": -1566.739,
                "z": 9239.834
              },
              "distanceAlongShapeM": 989.397,
              "shapeOffsetM": 1.843,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:6253",
              "position": {
                "x": -974.57,
                "z": 9288.252
              },
              "distanceAlongShapeM": 1585.088,
              "shapeOffsetM": 5.215,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:6249",
              "position": {
                "x": -307.276,
                "z": 9166.028
              },
              "distanceAlongShapeM": 2312.317,
              "shapeOffsetM": 3.258,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:6247",
              "position": {
                "x": -56.461,
                "z": 8814.162
              },
              "distanceAlongShapeM": 2755.751,
              "shapeOffsetM": 4.156,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:6244",
              "position": {
                "x": -12.983,
                "z": 8432.653
              },
              "distanceAlongShapeM": 3140.026,
              "shapeOffsetM": 12.922,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:6241",
              "position": {
                "x": 569.9,
                "z": 7800.858
              },
              "distanceAlongShapeM": 4101.935,
              "shapeOffsetM": 4.819,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:8330",
              "position": {
                "x": 1283.862,
                "z": 7420.383
              },
              "distanceAlongShapeM": 4910.947,
              "shapeOffsetM": 5.76,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:646",
              "position": {
                "x": 1908.814,
                "z": 6983.559
              },
              "distanceAlongShapeM": 5757.017,
              "shapeOffsetM": 0.403,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:17945",
              "position": {
                "x": 1843.043,
                "z": 6502.751
              },
              "distanceAlongShapeM": 6242.294,
              "shapeOffsetM": 2.118,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:5995",
              "position": {
                "x": 1738.128,
                "z": 5791.116
              },
              "distanceAlongShapeM": 6961.888,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            },
            {
              "stopId": "judu:stop:5957",
              "position": {
                "x": 1690.373,
                "z": 4817.922
              },
              "distanceAlongShapeM": 7937.696,
              "shapeOffsetM": 0.071,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:5996",
              "position": {
                "x": 1693.572,
                "z": 4189.997
              },
              "distanceAlongShapeM": 8570.647,
              "shapeOffsetM": 0.522,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:5998",
              "position": {
                "x": 1684.234,
                "z": 3721.498
              },
              "distanceAlongShapeM": 9046.399,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:5947",
              "position": {
                "x": 1478.744,
                "z": 2802.433
              },
              "distanceAlongShapeM": 10047.18,
              "shapeOffsetM": 0.509,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            },
            {
              "stopId": "judu:stop:5945",
              "position": {
                "x": 1224.883,
                "z": 2194.846
              },
              "distanceAlongShapeM": 10716.21,
              "shapeOffsetM": 3.403,
              "arrivalOffsetSeconds": 1500,
              "departureOffsetSeconds": 1500
            },
            {
              "stopId": "judu:stop:5942",
              "position": {
                "x": 922.174,
                "z": 1874.247
              },
              "distanceAlongShapeM": 11157.53,
              "shapeOffsetM": 5.48,
              "arrivalOffsetSeconds": 1560,
              "departureOffsetSeconds": 1560
            },
            {
              "stopId": "judu:stop:8264",
              "position": {
                "x": 493.148,
                "z": 1911.064
              },
              "distanceAlongShapeM": 11638.425,
              "shapeOffsetM": 0.515,
              "arrivalOffsetSeconds": 1740,
              "departureOffsetSeconds": 1740
            }
          ],
          "departuresSeconds": [
            19440,
            20640,
            23640,
            25620,
            27420,
            29220,
            31020,
            33180,
            36600,
            38520,
            40860,
            42900,
            45060,
            47220,
            49620,
            51480,
            54420,
            56940,
            59820,
            62460,
            64440,
            65880,
            67740,
            70140,
            73200,
            75300,
            77220,
            79500,
            81180,
            84120,
            85080
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_bus_20",
      "sourceRouteId": "vilnius_bus_20",
      "mode": "bus",
      "shortName": "20",
      "longName": "Žemieji Paneriai–Mūrinė Vokė–Lazdynai",
      "color": "0073AC",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_bus_20:0",
          "sourceRouteId": "vilnius_bus_20",
          "sourceShapeId": "vilnius_bus_20_a1-b1",
          "directionId": 0,
          "headsign": "Lazdynai",
          "directionName": "Žemieji Paneriai–Mūrinė Vokė–Paneriškių g.–Lazdynai",
          "mode": "bus",
          "routeShortName": "20",
          "routeLongName": "Žemieji Paneriai–Mūrinė Vokė–Lazdynai",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              -4326.297,
              4774.12,
              0
            ],
            [
              -4341.701,
              4789.561,
              21.811
            ],
            [
              -4357.738,
              4810.298,
              48.026
            ],
            [
              -4435.232,
              4883.989,
              154.963
            ],
            [
              -4468.845,
              4919.076,
              203.553
            ],
            [
              -4486.139,
              4928.009,
              223.018
            ],
            [
              -4510.925,
              4949.856,
              256.058
            ],
            [
              -4579.258,
              4993.33,
              337.048
            ],
            [
              -4600.366,
              5004.825,
              361.083
            ],
            [
              -4835.366,
              5155.793,
              640.397
            ],
            [
              -5032.11,
              5279.379,
              872.736
            ],
            [
              -5271.713,
              5427.062,
              1154.197
            ],
            [
              -5460.164,
              5546.035,
              1377.061
            ],
            [
              -5507.478,
              5573.554,
              1431.796
            ],
            [
              -5539.526,
              5587.456,
              1466.729
            ],
            [
              -5570.341,
              5597.997,
              1499.297
            ],
            [
              -5599.939,
              5604.064,
              1529.51
            ],
            [
              -5632.195,
              5605.723,
              1561.809
            ],
            [
              -5666.482,
              5601.851,
              1596.314
            ],
            [
              -5724.289,
              5581.678,
              1657.54
            ],
            [
              -5767.933,
              5559.039,
              1706.706
            ],
            [
              -5844.413,
              5503.558,
              1801.191
            ],
            [
              -5862.75,
              5488.283,
              1825.056
            ],
            [
              -5911.642,
              5422.317,
              1907.166
            ],
            [
              -5931.13,
              5377.005,
              1956.491
            ],
            [
              -5950.367,
              5308.312,
              2027.826
            ],
            [
              -5960.48,
              5282.88,
              2055.195
            ],
            [
              -5972.455,
              5261.931,
              2079.325
            ],
            [
              -5985.57,
              5249.907,
              2097.118
            ],
            [
              -6003.755,
              5243.534,
              2116.387
            ],
            [
              -6024.466,
              5240.544,
              2137.313
            ],
            [
              -6043.418,
              5245.327,
              2156.86
            ],
            [
              -6066.047,
              5261.363,
              2184.594
            ],
            [
              -6086.896,
              5290.575,
              2220.483
            ],
            [
              -6284.365,
              5565.511,
              2558.986
            ],
            [
              -6384.618,
              5670.718,
              2704.31
            ],
            [
              -6399.757,
              5685.605,
              2725.542
            ],
            [
              -6425.222,
              5713.7,
              2763.461
            ],
            [
              -6633.66,
              5914.22,
              3052.692
            ],
            [
              -6722.128,
              5991.393,
              3170.09
            ],
            [
              -6612.351,
              6454.122,
              3645.662
            ],
            [
              -6608.72,
              6475.702,
              3667.546
            ],
            [
              -6607.431,
              6481.884,
              3673.861
            ],
            [
              -6604.935,
              6487.334,
              3679.855
            ],
            [
              -6606.674,
              6481.348,
              3686.089
            ],
            [
              -6607.79,
              6475.997,
              3691.554
            ],
            [
              -6609.451,
              6468.03,
              3699.692
            ],
            [
              -6612.772,
              6452.1,
              3715.965
            ],
            [
              -6653.627,
              6265.205,
              3907.273
            ],
            [
              -6722.128,
              5991.393,
              4189.524
            ],
            [
              -6750.44,
              6004.56,
              4220.748
            ],
            [
              -6809.039,
              6038.832,
              4288.633
            ],
            [
              -6882.79,
              6076.446,
              4371.422
            ],
            [
              -6955.867,
              6108.831,
              4451.354
            ],
            [
              -7039.365,
              6135.823,
              4539.106
            ],
            [
              -7206.108,
              6166.42,
              4708.633
            ],
            [
              -7774.707,
              6263.751,
              5285.502
            ],
            [
              -7867.343,
              6285.312,
              5380.614
            ],
            [
              -8047.971,
              6336.143,
              5568.258
            ],
            [
              -8098.629,
              6343.525,
              5619.451
            ],
            [
              -8217.003,
              6398.476,
              5749.958
            ],
            [
              -8443.238,
              6418.491,
              5977.076
            ],
            [
              -8559.819,
              6432.883,
              6094.542
            ],
            [
              -8589.416,
              6433.102,
              6124.141
            ],
            [
              -8680.794,
              6417.715,
              6216.805
            ],
            [
              -8794.261,
              6391.731,
              6333.209
            ],
            [
              -8817.834,
              6386.609,
              6357.333
            ],
            [
              -8897.687,
              6370.288,
              6438.836
            ],
            [
              -8999.678,
              6346.078,
              6543.661
            ],
            [
              -9020.756,
              6334.804,
              6567.565
            ],
            [
              -9032.94,
              6322.084,
              6585.179
            ],
            [
              -9043.295,
              6284.446,
              6624.215
            ],
            [
              -9071.789,
              5999.937,
              6910.147
            ],
            [
              -9087.647,
              5810.99,
              7099.758
            ],
            [
              -9105.787,
              5654.292,
              7257.503
            ],
            [
              -9121.037,
              5469.753,
              7442.671
            ],
            [
              -9131.188,
              5400.901,
              7512.268
            ],
            [
              -9162.794,
              5083.047,
              7831.689
            ],
            [
              -9168.695,
              4967.451,
              7947.435
            ],
            [
              -9185.609,
              4829.613,
              8086.307
            ],
            [
              -9269.178,
              4812.099,
              8171.692
            ],
            [
              -9558.498,
              4764.394,
              8464.918
            ],
            [
              -9589.112,
              4759.224,
              8495.966
            ],
            [
              -9652.595,
              4749.707,
              8560.158
            ],
            [
              -9792.336,
              4740.884,
              8700.178
            ],
            [
              -9826.906,
              4727.345,
              8737.305
            ],
            [
              -9869.929,
              4708.645,
              8784.216
            ],
            [
              -9918.415,
              4700.029,
              8833.461
            ],
            [
              -9959.439,
              4692.733,
              8875.129
            ],
            [
              -9970.318,
              4645.189,
              8923.902
            ],
            [
              -9980.786,
              4636.451,
              8937.538
            ],
            [
              -10015.813,
              4625.879,
              8974.125
            ],
            [
              -10037.72,
              4628.455,
              8996.183
            ],
            [
              -10042.829,
              4631.876,
              9002.332
            ],
            [
              -10045.914,
              4640.83,
              9011.802
            ],
            [
              -10040.995,
              4677.716,
              9049.015
            ],
            [
              -10034.075,
              4679.035,
              9056.058
            ],
            [
              -9847.833,
              4715.586,
              9245.854
            ],
            [
              -9780.57,
              4742.885,
              9318.445
            ],
            [
              -9738.284,
              4743.887,
              9360.743
            ],
            [
              -9619.286,
              4757.562,
              9480.524
            ],
            [
              -9574.56,
              4766.659,
              9526.166
            ],
            [
              -9427.227,
              4786.377,
              9674.813
            ],
            [
              -9186.254,
              4829.624,
              9919.636
            ],
            [
              -8761.616,
              4900.668,
              10350.176
            ],
            [
              -8565.827,
              4935.105,
              10548.97
            ],
            [
              -8440.538,
              4954.439,
              10675.742
            ],
            [
              -8110.415,
              5008.04,
              11010.188
            ],
            [
              -7984.14,
              5031.572,
              11138.637
            ],
            [
              -7997.04,
              5078.168,
              11186.986
            ],
            [
              -8005.189,
              5086.463,
              11198.614
            ],
            [
              -8032.863,
              5094.147,
              11227.335
            ],
            [
              -8056.05,
              5095.089,
              11250.541
            ],
            [
              -8074.858,
              5089.832,
              11270.07
            ],
            [
              -8087.322,
              5077.791,
              11287.4
            ],
            [
              -8094.275,
              5061.214,
              11305.376
            ],
            [
              -8097.824,
              5027.871,
              11338.907
            ],
            [
              -8123.102,
              4509.547,
              11857.848
            ],
            [
              -8153.328,
              4043.622,
              12324.752
            ],
            [
              -8152.03,
              4004.64,
              12363.756
            ],
            [
              -8148.06,
              3971.18,
              12397.45
            ],
            [
              -8140.12,
              3941.964,
              12427.726
            ],
            [
              -8122.972,
              3887.281,
              12485.035
            ],
            [
              -8107.695,
              3848.767,
              12526.468
            ],
            [
              -8056.297,
              3760.771,
              12628.375
            ],
            [
              -8007.887,
              3702.832,
              12703.876
            ],
            [
              -7953.829,
              3654.078,
              12776.672
            ],
            [
              -7691.803,
              3497.261,
              13082.039
            ],
            [
              -7552.547,
              3410.361,
              13246.185
            ],
            [
              -7588.75,
              3341.895,
              13323.634
            ],
            [
              -7588.916,
              3335.821,
              13329.71
            ],
            [
              -7577.659,
              3332.338,
              13341.493
            ],
            [
              -7519.66,
              3289.633,
              13413.519
            ],
            [
              -7480.171,
              3259.999,
              13462.89
            ],
            [
              -7459.894,
              3237.4,
              13493.253
            ],
            [
              -7451.285,
              3211.655,
              13520.399
            ],
            [
              -7446.786,
              3171.506,
              13560.799
            ],
            [
              -7446.807,
              3115.831,
              13616.474
            ],
            [
              -7447.724,
              3075.788,
              13656.528
            ],
            [
              -7472.977,
              3070.64,
              13682.3
            ],
            [
              -7643.956,
              3072.351,
              13853.288
            ],
            [
              -7802.088,
              3070.505,
              14011.431
            ],
            [
              -7947.244,
              3072.892,
              14156.606
            ],
            [
              -8072.99,
              3078.78,
              14282.49
            ],
            [
              -8260.762,
              3079.146,
              14470.262
            ],
            [
              -8265.242,
              3081.446,
              14475.298
            ],
            [
              -8269.93,
              3110.465,
              14504.694
            ],
            [
              -8278.098,
              3123.957,
              14520.465
            ],
            [
              -8287.679,
              3133.276,
              14533.831
            ],
            [
              -8352.235,
              3128.509,
              14598.563
            ],
            [
              -8357.269,
              3136.383,
              14607.908
            ],
            [
              -8357.105,
              3146.399,
              14617.926
            ],
            [
              -8327.711,
              3174.433,
              14658.545
            ],
            [
              -8323.157,
              3170.334,
              14664.672
            ],
            [
              -8315.237,
              3165.809,
              14673.794
            ],
            [
              -8268.683,
              3109.603,
              14746.776
            ],
            [
              -8264.504,
              3081.346,
              14775.34
            ],
            [
              -8249.813,
              3077.854,
              14790.441
            ],
            [
              -8131.047,
              3080.369,
              14909.233
            ],
            [
              -7958.907,
              3073.587,
              15081.507
            ],
            [
              -7454.213,
              3073.669,
              15586.201
            ],
            [
              -7446.898,
              3067.954,
              15595.484
            ],
            [
              -7448.055,
              3016.795,
              15646.656
            ],
            [
              -7449.084,
              2876.551,
              15786.904
            ],
            [
              -7448.124,
              2778.576,
              15884.883
            ],
            [
              -7445.538,
              2762.914,
              15900.758
            ],
            [
              -7447.588,
              2693.965,
              15969.737
            ],
            [
              -7450.442,
              2521.47,
              16142.256
            ],
            [
              -7435.624,
              2481.15,
              16185.212
            ],
            [
              -7421.142,
              2428.359,
              16239.954
            ],
            [
              -7411.602,
              2239.48,
              16429.073
            ],
            [
              -7186.259,
              2188.702,
              16660.067
            ],
            [
              -7148.296,
              2182.506,
              16698.532
            ],
            [
              -7083.758,
              2183.659,
              16763.08
            ],
            [
              -7066.142,
              2184.642,
              16780.724
            ],
            [
              -7046.181,
              2193.053,
              16802.384
            ],
            [
              -7031.787,
              2205.059,
              16821.128
            ],
            [
              -6959.056,
              2310.713,
              16949.396
            ],
            [
              -6828.805,
              2537.858,
              17211.236
            ],
            [
              -6805.912,
              2556.4,
              17240.696
            ],
            [
              -6591.179,
              2664.13,
              17480.937
            ],
            [
              -6581.031,
              2659.878,
              17491.939
            ],
            [
              -6531.266,
              2600.636,
              17569.311
            ],
            [
              -6529.322,
              2581.832,
              17588.215
            ],
            [
              -6532.182,
              2565.182,
              17605.109
            ],
            [
              -6545.306,
              2552.044,
              17623.679
            ],
            [
              -6585.009,
              2531.558,
              17668.355
            ],
            [
              -6594.097,
              2517.218,
              17685.333
            ],
            [
              -6595.577,
              2504.775,
              17697.863
            ],
            [
              -6564.945,
              2441.22,
              17768.415
            ],
            [
              -6502.181,
              2353.175,
              17876.541
            ],
            [
              -6429.159,
              2282.933,
              17977.863
            ],
            [
              -6374.247,
              2248.616,
              18042.616
            ],
            [
              -6326.927,
              2223.331,
              18096.268
            ],
            [
              -6232.118,
              2195.121,
              18195.185
            ],
            [
              -6093.704,
              2164.862,
              18336.868
            ],
            [
              -5702.782,
              2084.789,
              18735.906
            ],
            [
              -5464.017,
              2049.57,
              18977.255
            ],
            [
              -5246.18,
              2035.846,
              19195.524
            ],
            [
              -5237.188,
              2033.466,
              19204.825
            ],
            [
              -5217.894,
              1991.949,
              19250.606
            ],
            [
              -5138.979,
              1928.265,
              19352.013
            ],
            [
              -5083.708,
              1887.989,
              19420.401
            ],
            [
              -5073.288,
              1883.729,
              19431.659
            ],
            [
              -5063.31,
              1863.521,
              19454.196
            ],
            [
              -4967.083,
              1756.123,
              19598.397
            ],
            [
              -4942.917,
              1735.672,
              19630.055
            ],
            [
              -4931.684,
              1728.355,
              19643.461
            ],
            [
              -4906.917,
              1690.529,
              19688.674
            ],
            [
              -4842.797,
              1742.865,
              19771.441
            ],
            [
              -4801.101,
              1766.641,
              19819.44
            ],
            [
              -4774.467,
              1777.316,
              19848.133
            ],
            [
              -4728.427,
              1790.998,
              19896.163
            ],
            [
              -4687.68,
              1796.979,
              19937.347
            ],
            [
              -4579.155,
              1805.134,
              20046.178
            ],
            [
              -4546.833,
              1810.069,
              20078.875
            ],
            [
              -4518.395,
              1811.882,
              20107.37
            ],
            [
              -4300.033,
              1829.272,
              20326.424
            ],
            [
              -4282.619,
              1828.972,
              20343.84
            ],
            [
              -4232.446,
              1820.314,
              20394.755
            ],
            [
              -4165.014,
              1802.452,
              20464.512
            ],
            [
              -4141.304,
              1793.136,
              20489.987
            ],
            [
              -4122.773,
              1782.797,
              20511.207
            ],
            [
              -4070.589,
              1735.287,
              20581.779
            ],
            [
              -4047.235,
              1694.122,
              20629.107
            ],
            [
              -4037.796,
              1664.197,
              20660.485
            ],
            [
              -4021.405,
              1600.417,
              20726.338
            ],
            [
              -3992.198,
              1462.162,
              20867.644
            ],
            [
              -3985.157,
              1436.356,
              20894.393
            ],
            [
              -3986.154,
              1438.68,
              20896.922
            ],
            [
              -3973.348,
              1390.702,
              20946.58
            ],
            [
              -3969.311,
              1368.257,
              20969.385
            ],
            [
              -3952.68,
              1285.592,
              21053.706
            ],
            [
              -3953.633,
              1267.797,
              21071.526
            ],
            [
              -3986.792,
              1252.786,
              21107.925
            ],
            [
              -4052.715,
              1233.557,
              21176.595
            ],
            [
              -4088.482,
              1228.943,
              21212.659
            ],
            [
              -4121.332,
              1231.737,
              21245.627
            ],
            [
              -4147.457,
              1237.551,
              21272.391
            ],
            [
              -4212.237,
              1261.595,
              21341.49
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:5567",
              "position": {
                "x": -4488.111,
                "z": 4924.973
              },
              "distanceAlongShapeM": 223.018,
              "shapeOffsetM": 3.62,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:5728",
              "position": {
                "x": -6069.366,
                "z": 5257.998
              },
              "distanceAlongShapeM": 2184.594,
              "shapeOffsetM": 4.727,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:5732",
              "position": {
                "x": -6403.151,
                "z": 5682.161
              },
              "distanceAlongShapeM": 2725.542,
              "shapeOffsetM": 4.835,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:9967",
              "position": {
                "x": -6701.294,
                "z": 6078.986
              },
              "distanceAlongShapeM": 3260.126,
              "shapeOffsetM": 0.052,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:8784",
              "position": {
                "x": -6615.878,
                "z": 6476.078
              },
              "distanceAlongShapeM": 3666.728,
              "shapeOffsetM": 7.122,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:5738",
              "position": {
                "x": -6754.294,
                "z": 5998.609
              },
              "distanceAlongShapeM": 4221.07,
              "shapeOffsetM": 7.082,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:5742",
              "position": {
                "x": -8100.928,
                "z": 6335.897
              },
              "distanceAlongShapeM": 5619.451,
              "shapeOffsetM": 7.967,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:6270",
              "position": {
                "x": -8793.026,
                "z": 6386.142
              },
              "distanceAlongShapeM": 6333.209,
              "shapeOffsetM": 5.724,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:6274",
              "position": {
                "x": -9087.112,
                "z": 5810.947
              },
              "distanceAlongShapeM": 7099.757,
              "shapeOffsetM": 0.537,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:6277",
              "position": {
                "x": -9121.037,
                "z": 5469.753
              },
              "distanceAlongShapeM": 7442.671,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:6279",
              "position": {
                "x": -9167.245,
                "z": 4967.349
              },
              "distanceAlongShapeM": 7947.435,
              "shapeOffsetM": 1.454,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            },
            {
              "stopId": "judu:stop:6282",
              "position": {
                "x": -9588.344,
                "z": 4754.839
              },
              "distanceAlongShapeM": 8495.939,
              "shapeOffsetM": 4.452,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:9626",
              "position": {
                "x": -10015.813,
                "z": 4625.879
              },
              "distanceAlongShapeM": 8974.125,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:6283",
              "position": {
                "x": -9574.594,
                "z": 4766.863
              },
              "distanceAlongShapeM": 9526.166,
              "shapeOffsetM": 0.207,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:6291",
              "position": {
                "x": -8566.072,
                "z": 4936.448
              },
              "distanceAlongShapeM": 10548.961,
              "shapeOffsetM": 1.365,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            },
            {
              "stopId": "judu:stop:6295",
              "position": {
                "x": -8134.965,
                "z": 3943.136
              },
              "distanceAlongShapeM": 12428.15,
              "shapeOffsetM": 5.27,
              "arrivalOffsetSeconds": 1500,
              "departureOffsetSeconds": 1500
            },
            {
              "stopId": "judu:stop:6296",
              "position": {
                "x": -7517.702,
                "z": 3292.902
              },
              "distanceAlongShapeM": 13413.157,
              "shapeOffsetM": 3.793,
              "arrivalOffsetSeconds": 1650,
              "departureOffsetSeconds": 1650
            },
            {
              "stopId": "judu:stop:18073",
              "position": {
                "x": -8298.116,
                "z": 3123.171
              },
              "distanceAlongShapeM": 14544.984,
              "shapeOffsetM": 9.309,
              "arrivalOffsetSeconds": 1770,
              "departureOffsetSeconds": 1770
            },
            {
              "stopId": "judu:stop:6301",
              "position": {
                "x": -7443.866,
                "z": 2762.921
              },
              "distanceAlongShapeM": 15900.758,
              "shapeOffsetM": 1.672,
              "arrivalOffsetSeconds": 1950,
              "departureOffsetSeconds": 1950
            },
            {
              "stopId": "judu:stop:7731",
              "position": {
                "x": -7420.363,
                "z": 2428.578
              },
              "distanceAlongShapeM": 16239.948,
              "shapeOffsetM": 0.809,
              "arrivalOffsetSeconds": 2010,
              "departureOffsetSeconds": 2010
            },
            {
              "stopId": "judu:stop:437",
              "position": {
                "x": -4928.804,
                "z": 1730.978
              },
              "distanceAlongShapeM": 19643.461,
              "shapeOffsetM": 3.896,
              "arrivalOffsetSeconds": 2370,
              "departureOffsetSeconds": 2370
            },
            {
              "stopId": "judu:stop:5691",
              "position": {
                "x": -4547.361,
                "z": 1815.72
              },
              "distanceAlongShapeM": 20078.875,
              "shapeOffsetM": 5.676,
              "arrivalOffsetSeconds": 2460,
              "departureOffsetSeconds": 2460
            },
            {
              "stopId": "judu:stop:5693",
              "position": {
                "x": -4066.123,
                "z": 1738.403
              },
              "distanceAlongShapeM": 20581.779,
              "shapeOffsetM": 5.445,
              "arrivalOffsetSeconds": 2520,
              "departureOffsetSeconds": 2520
            },
            {
              "stopId": "judu:stop:5697",
              "position": {
                "x": -3968.906,
                "z": 1391.627
              },
              "distanceAlongShapeM": 20946.58,
              "shapeOffsetM": 4.537,
              "arrivalOffsetSeconds": 2580,
              "departureOffsetSeconds": 2580
            },
            {
              "stopId": "judu:stop:6318",
              "position": {
                "x": -4215.081,
                "z": 1256.734
              },
              "distanceAlongShapeM": 21341.49,
              "shapeOffsetM": 5.632,
              "arrivalOffsetSeconds": 2640,
              "departureOffsetSeconds": 2640
            }
          ],
          "departuresSeconds": [
            20760,
            22680,
            26880,
            28800,
            39480,
            45780,
            53460,
            54900,
            60060,
            61920,
            65100,
            69840,
            73260,
            76140
          ]
        },
        {
          "id": "judu:pattern:vilnius_bus_20:1",
          "sourceRouteId": "vilnius_bus_20",
          "sourceShapeId": "vilnius_bus_20_b1-a1",
          "directionId": 1,
          "headsign": "Žemieji Paneriai",
          "directionName": "Lazdynai–Paneriškių g.–Mūrinė Vokė–Žemieji Paneriai",
          "mode": "bus",
          "routeShortName": "20",
          "routeLongName": "Žemieji Paneriai–Mūrinė Vokė–Lazdynai",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              -4212.237,
              1261.595,
              0
            ],
            [
              -4241.916,
              1271.669,
              31.342
            ],
            [
              -4268.203,
              1281.028,
              59.245
            ],
            [
              -4527.979,
              1404.616,
              346.921
            ],
            [
              -4557.013,
              1417.363,
              378.63
            ],
            [
              -4581.673,
              1433.369,
              408.029
            ],
            [
              -4718.251,
              1519.203,
              569.34
            ],
            [
              -4836.63,
              1608.523,
              717.635
            ],
            [
              -4906.917,
              1690.529,
              825.641
            ],
            [
              -4961.39,
              1738.988,
              898.549
            ],
            [
              -5068.788,
              1878.386,
              1074.521
            ],
            [
              -5059.867,
              1885.445,
              1085.897
            ],
            [
              -5029.586,
              1916.238,
              1129.085
            ],
            [
              -4999.789,
              1944.719,
              1170.304
            ],
            [
              -4996.021,
              1950.314,
              1177.05
            ],
            [
              -4991.999,
              1959.151,
              1186.759
            ],
            [
              -4993.076,
              1975.819,
              1203.461
            ],
            [
              -4999.984,
              1982.665,
              1213.187
            ],
            [
              -5014.09,
              1987.937,
              1228.245
            ],
            [
              -5109.447,
              1955.947,
              1328.825
            ],
            [
              -5196.989,
              1931.48,
              1419.723
            ],
            [
              -5257.124,
              1923.6,
              1480.372
            ],
            [
              -5290.037,
              1923.047,
              1513.289
            ],
            [
              -5339.624,
              1928.344,
              1563.158
            ],
            [
              -5376.881,
              1937.883,
              1601.617
            ],
            [
              -5383.292,
              1938.128,
              1608.033
            ],
            [
              -5484.519,
              1982.013,
              1718.363
            ],
            [
              -5567.024,
              2024.602,
              1811.212
            ],
            [
              -5630.478,
              2045.935,
              1878.157
            ],
            [
              -5691.568,
              2061.222,
              1941.13
            ],
            [
              -6211.482,
              2167.069,
              2471.709
            ],
            [
              -6281.748,
              2185.837,
              2544.438
            ],
            [
              -6354.831,
              2213.781,
              2622.681
            ],
            [
              -6397.293,
              2235.169,
              2670.226
            ],
            [
              -6460.176,
              2280.113,
              2747.519
            ],
            [
              -6493.177,
              2312.949,
              2794.073
            ],
            [
              -6562.36,
              2392.959,
              2899.846
            ],
            [
              -6586.677,
              2433.173,
              2946.84
            ],
            [
              -6607.725,
              2473.046,
              2991.928
            ],
            [
              -6630.621,
              2494.321,
              3023.182
            ],
            [
              -6655.594,
              2493.958,
              3048.159
            ],
            [
              -6683.476,
              2488.878,
              3076.499
            ],
            [
              -6701.158,
              2493.568,
              3094.792
            ],
            [
              -6714.175,
              2504.555,
              3111.826
            ],
            [
              -6753.855,
              2569.045,
              3187.545
            ],
            [
              -6777.27,
              2571.507,
              3211.09
            ],
            [
              -6819.626,
              2546.611,
              3260.221
            ],
            [
              -6838.704,
              2524.665,
              3289.3
            ],
            [
              -6924.55,
              2368.024,
              3467.922
            ],
            [
              -6961.691,
              2307.418,
              3539.003
            ],
            [
              -7010.001,
              2234.752,
              3626.263
            ],
            [
              -7027.805,
              2211.671,
              3655.413
            ],
            [
              -7050.77,
              2188.677,
              3687.911
            ],
            [
              -7066.765,
              2184.532,
              3704.434
            ],
            [
              -7161.178,
              2183.833,
              3798.85
            ],
            [
              -7411.602,
              2239.48,
              4055.382
            ],
            [
              -7415.939,
              2306.055,
              4122.098
            ],
            [
              -7414.963,
              2365.037,
              4181.088
            ],
            [
              -7420.052,
              2397.428,
              4213.876
            ],
            [
              -7437.051,
              2460.458,
              4279.158
            ],
            [
              -7450.442,
              2521.47,
              4341.623
            ],
            [
              -7450.392,
              2797.537,
              4617.69
            ],
            [
              -7452.691,
              2831.005,
              4651.237
            ],
            [
              -7452.996,
              3069.196,
              4889.428
            ],
            [
              -7460.037,
              3072.652,
              4897.271
            ],
            [
              -7778.827,
              3072.348,
              5216.061
            ],
            [
              -8005.288,
              3074.959,
              5442.537
            ],
            [
              -8103.302,
              3079.61,
              5540.662
            ],
            [
              -8260.799,
              3076.921,
              5698.181
            ],
            [
              -8267.619,
              3085.947,
              5709.495
            ],
            [
              -8266.431,
              3100.356,
              5723.952
            ],
            [
              -8276.79,
              3125.049,
              5750.73
            ],
            [
              -8287.679,
              3133.276,
              5764.378
            ],
            [
              -8338.078,
              3126.051,
              5815.292
            ],
            [
              -8352.88,
              3128.519,
              5830.298
            ],
            [
              -8359.223,
              3135.302,
              5839.585
            ],
            [
              -8353.861,
              3147.459,
              5852.872
            ],
            [
              -8327.389,
              3174.106,
              5890.433
            ],
            [
              -8324.713,
              3171.383,
              5894.25
            ],
            [
              -8314.216,
              3164.622,
              5906.736
            ],
            [
              -8273.351,
              3121.019,
              5966.496
            ],
            [
              -8265.765,
              3095.803,
              5992.828
            ],
            [
              -8267.494,
              3083.731,
              6005.023
            ],
            [
              -8262.716,
              3078.065,
              6012.435
            ],
            [
              -8080.741,
              3078.992,
              6194.412
            ],
            [
              -7967.923,
              3074.042,
              6307.338
            ],
            [
              -7860.114,
              3073.476,
              6415.149
            ],
            [
              -7527.127,
              3073.317,
              6748.136
            ],
            [
              -7458.12,
              3071.507,
              6817.167
            ],
            [
              -7450.286,
              3076.944,
              6826.703
            ],
            [
              -7448.075,
              3093.605,
              6843.51
            ],
            [
              -7447.837,
              3185.995,
              6935.9
            ],
            [
              -7451.285,
              3211.655,
              6961.791
            ],
            [
              -7464.281,
              3245.265,
              6997.826
            ],
            [
              -7482.696,
              3263.381,
              7023.658
            ],
            [
              -7574.672,
              3328.371,
              7136.278
            ],
            [
              -7589.945,
              3334.17,
              7152.615
            ],
            [
              -7612.059,
              3336.565,
              7174.858
            ],
            [
              -7612.585,
              3345.478,
              7183.787
            ],
            [
              -7610.505,
              3348.243,
              7187.247
            ],
            [
              -7605.049,
              3351.538,
              7193.621
            ],
            [
              -7588.268,
              3357.519,
              7211.436
            ],
            [
              -7565.191,
              3387.193,
              7249.027
            ],
            [
              -7848.444,
              3561.767,
              7581.756
            ],
            [
              -7970.179,
              3640.989,
              7726.999
            ],
            [
              -8010.925,
              3675.053,
              7780.108
            ],
            [
              -8074.26,
              3748.448,
              7877.052
            ],
            [
              -8116.454,
              3811.486,
              7952.908
            ],
            [
              -8127.628,
              3839.491,
              7983.06
            ],
            [
              -8128.299,
              3835.847,
              7986.765
            ],
            [
              -8161.184,
              3958.037,
              8113.303
            ],
            [
              -8165.573,
              4030.047,
              8185.447
            ],
            [
              -8128.206,
              4592.005,
              8748.646
            ],
            [
              -8114.065,
              4903.462,
              9060.424
            ],
            [
              -8124.873,
              4913.657,
              9075.282
            ],
            [
              -8158.233,
              4926.449,
              9111.01
            ],
            [
              -8180.177,
              4926.808,
              9132.957
            ],
            [
              -8198.839,
              4930.453,
              9151.972
            ],
            [
              -8215.237,
              4954.098,
              9180.746
            ],
            [
              -8225.899,
              4980.834,
              9209.53
            ],
            [
              -8226.272,
              4989.9,
              9218.604
            ],
            [
              -8636.135,
              4917.748,
              9634.769
            ],
            [
              -8675.296,
              4911.261,
              9674.464
            ],
            [
              -9185.609,
              4829.613,
              10191.267
            ],
            [
              -9269.178,
              4812.099,
              10276.651
            ],
            [
              -9558.498,
              4764.394,
              10569.878
            ],
            [
              -9589.112,
              4759.224,
              10600.926
            ],
            [
              -9674.339,
              4746.201,
              10687.142
            ],
            [
              -9691.455,
              4743.771,
              10704.43
            ],
            [
              -9773.861,
              4743.124,
              10786.838
            ],
            [
              -9804.36,
              4735.568,
              10818.259
            ],
            [
              -9850.41,
              4713.616,
              10869.274
            ],
            [
              -10016.825,
              4682.325,
              11038.605
            ],
            [
              -10031.193,
              4679.585,
              11053.232
            ],
            [
              -10038.335,
              4678.223,
              11060.502
            ],
            [
              -10047.296,
              4676.514,
              11069.626
            ],
            [
              -10038.868,
              4637.378,
              11109.658
            ],
            [
              -10034.44,
              4631.742,
              11116.826
            ],
            [
              -10024.132,
              4630.464,
              11127.213
            ],
            [
              -10003.374,
              4636.812,
              11148.92
            ],
            [
              -9973.634,
              4639.676,
              11178.797
            ],
            [
              -9961.804,
              4652.845,
              11196.5
            ],
            [
              -9955.91,
              4693.367,
              11237.448
            ],
            [
              -9945.706,
              4695.201,
              11247.815
            ],
            [
              -9929.417,
              4700.193,
              11264.852
            ],
            [
              -9859.503,
              4712.433,
              11335.829
            ],
            [
              -9786.723,
              4742.436,
              11414.551
            ],
            [
              -9707.307,
              4743.39,
              11493.973
            ],
            [
              -9671.094,
              4747.262,
              11530.392
            ],
            [
              -9574.56,
              4766.659,
              11628.856
            ],
            [
              -9510.443,
              4777.275,
              11693.846
            ],
            [
              -9185.609,
              4829.613,
              12022.869
            ],
            [
              -9172.692,
              5010.626,
              12204.343
            ],
            [
              -9167.098,
              5056.4,
              12250.457
            ],
            [
              -9158.902,
              5124.171,
              12318.722
            ],
            [
              -9120.102,
              5527.623,
              12724.035
            ],
            [
              -9120.138,
              5525.397,
              12726.261
            ],
            [
              -9105.787,
              5654.292,
              12855.953
            ],
            [
              -9088.239,
              5861.057,
              13063.461
            ],
            [
              -9065.832,
              6048.82,
              13252.557
            ],
            [
              -9042.56,
              6290,
              13494.857
            ],
            [
              -9035.69,
              6315.492,
              13521.258
            ],
            [
              -9027.745,
              6327.608,
              13535.747
            ],
            [
              -9013.989,
              6339.63,
              13554.016
            ],
            [
              -8762.419,
              6400.662,
              13812.883
            ],
            [
              -8591.351,
              6433.066,
              13986.993
            ],
            [
              -8565.587,
              6433.138,
              14012.758
            ],
            [
              -8514.008,
              6428.359,
              14064.557
            ],
            [
              -8481.082,
              6427.822,
              14097.488
            ],
            [
              -8465.66,
              6433.18,
              14113.814
            ],
            [
              -8454.951,
              6440.428,
              14126.745
            ],
            [
              -8444.423,
              6447.553,
              14139.457
            ],
            [
              -8404.728,
              6479.042,
              14190.125
            ],
            [
              -8380.155,
              6489.681,
              14216.903
            ],
            [
              -8362.497,
              6492.394,
              14234.769
            ],
            [
              -8333.419,
              6489.457,
              14263.994
            ],
            [
              -8314.17,
              6480.025,
              14285.43
            ],
            [
              -8259.214,
              6437.466,
              14354.939
            ],
            [
              -8217.003,
              6398.476,
              14412.401
            ],
            [
              -8093.947,
              6355.277,
              14542.82
            ],
            [
              -8047.971,
              6336.143,
              14592.618
            ],
            [
              -7869.852,
              6289.806,
              14776.666
            ],
            [
              -7783.654,
              6269.464,
              14865.232
            ],
            [
              -7104.955,
              6152.496,
              15553.936
            ],
            [
              -7039.365,
              6135.823,
              15621.612
            ],
            [
              -6990.505,
              6122.766,
              15672.187
            ],
            [
              -6923.128,
              6097.155,
              15744.267
            ],
            [
              -6819.933,
              6050.909,
              15857.351
            ],
            [
              -6722.128,
              5991.393,
              15971.841
            ],
            [
              -6612.351,
              6454.122,
              16447.413
            ],
            [
              -6608.72,
              6475.702,
              16469.297
            ],
            [
              -6607.431,
              6481.884,
              16475.612
            ],
            [
              -6604.935,
              6487.334,
              16481.606
            ],
            [
              -6606.674,
              6481.348,
              16487.839
            ],
            [
              -6607.79,
              6475.997,
              16493.305
            ],
            [
              -6609.451,
              6468.03,
              16501.443
            ],
            [
              -6612.772,
              6452.1,
              16517.716
            ],
            [
              -6653.627,
              6265.205,
              16709.024
            ],
            [
              -6722.128,
              5991.393,
              16991.275
            ],
            [
              -6667.814,
              5949.093,
              17060.117
            ],
            [
              -6413.106,
              5704.591,
              17413.186
            ],
            [
              -6357.16,
              5652.447,
              17489.664
            ],
            [
              -6339.044,
              5634.784,
              17514.966
            ],
            [
              -6315.93,
              5608.341,
              17550.087
            ],
            [
              -6284.365,
              5565.511,
              17603.292
            ],
            [
              -6235.578,
              5510.146,
              17677.085
            ],
            [
              -6210.778,
              5487.465,
              17710.693
            ],
            [
              -6170.561,
              5460.073,
              17759.352
            ],
            [
              -6118.615,
              5439.162,
              17815.349
            ],
            [
              -6089.662,
              5433.109,
              17844.928
            ],
            [
              -6052.281,
              5429.14,
              17882.519
            ],
            [
              -6005.048,
              5435.024,
              17930.117
            ],
            [
              -5948.573,
              5452.996,
              17989.383
            ],
            [
              -5873.554,
              5498.484,
              18077.116
            ],
            [
              -5789.253,
              5558.286,
              18180.474
            ],
            [
              -5728.563,
              5596.222,
              18252.045
            ],
            [
              -5697.335,
              5610.165,
              18286.244
            ],
            [
              -5669.446,
              5617.486,
              18315.078
            ],
            [
              -5631.932,
              5621.303,
              18352.786
            ],
            [
              -5582.93,
              5617.134,
              18401.965
            ],
            [
              -5526.428,
              5598.366,
              18461.502
            ],
            [
              -5379.437,
              5509.043,
              18633.505
            ],
            [
              -4710.592,
              5090.204,
              19422.669
            ],
            [
              -4580.889,
              5011.17,
              19574.555
            ],
            [
              -4518.9,
              4977.81,
              19644.95
            ],
            [
              -4380.813,
              4857.45,
              19828.129
            ],
            [
              -4298.311,
              4774.766,
              19944.933
            ],
            [
              -4237.94,
              4719.179,
              20026.998
            ],
            [
              -4229.781,
              4705.68,
              20042.771
            ],
            [
              -4240.925,
              4695.853,
              20057.629
            ],
            [
              -4266.982,
              4719.679,
              20092.937
            ],
            [
              -4289.168,
              4743.439,
              20125.445
            ],
            [
              -4306.085,
              4753.859,
              20145.314
            ],
            [
              -4314.059,
              4761.853,
              20156.604
            ],
            [
              -4326.297,
              4774.12,
              20173.932
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:6318",
              "position": {
                "x": -4215.081,
                "z": 1256.734
              },
              "distanceAlongShapeM": 1.13,
              "shapeOffsetM": 5.517,
              "arrivalOffsetSeconds": -420,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:6319",
              "position": {
                "x": -4558.781,
                "z": 1414.051
              },
              "distanceAlongShapeM": 378.63,
              "shapeOffsetM": 3.754,
              "arrivalOffsetSeconds": 60,
              "departureOffsetSeconds": 60
            },
            {
              "stopId": "judu:stop:6320",
              "position": {
                "x": -4838.028,
                "z": 1606.973
              },
              "distanceAlongShapeM": 717.635,
              "shapeOffsetM": 2.088,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:7730",
              "position": {
                "x": -7438.554,
                "z": 2460.048
              },
              "distanceAlongShapeM": 4279.154,
              "shapeOffsetM": 1.558,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:6300",
              "position": {
                "x": -7454.355,
                "z": 2830.998
              },
              "distanceAlongShapeM": 4651.237,
              "shapeOffsetM": 1.664,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:18073",
              "position": {
                "x": -8298.116,
                "z": 3123.171
              },
              "distanceAlongShapeM": 5776.143,
              "shapeOffsetM": 8.522,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:6297",
              "position": {
                "x": -7611.222,
                "z": 3413.556
              },
              "distanceAlongShapeM": 7302.045,
              "shapeOffsetM": 1.708,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:6294",
              "position": {
                "x": -8136.789,
                "z": 3831.848
              },
              "distanceAlongShapeM": 7986.765,
              "shapeOffsetM": 9.385,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:6290",
              "position": {
                "x": -8674.97,
                "z": 4909.278
              },
              "distanceAlongShapeM": 9674.464,
              "shapeOffsetM": 2.01,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            },
            {
              "stopId": "judu:stop:6282",
              "position": {
                "x": -9588.344,
                "z": 4754.839
              },
              "distanceAlongShapeM": 10600.899,
              "shapeOffsetM": 4.452,
              "arrivalOffsetSeconds": 1410,
              "departureOffsetSeconds": 1410
            },
            {
              "stopId": "judu:stop:6286",
              "position": {
                "x": -10003.374,
                "z": 4636.812
              },
              "distanceAlongShapeM": 11148.92,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1500,
              "departureOffsetSeconds": 1500
            },
            {
              "stopId": "judu:stop:6283",
              "position": {
                "x": -9574.594,
                "z": 4766.863
              },
              "distanceAlongShapeM": 11628.856,
              "shapeOffsetM": 0.207,
              "arrivalOffsetSeconds": 1560,
              "departureOffsetSeconds": 1560
            },
            {
              "stopId": "judu:stop:6278",
              "position": {
                "x": -9175.58,
                "z": 5010.897
              },
              "distanceAlongShapeM": 12204.343,
              "shapeOffsetM": 2.901,
              "arrivalOffsetSeconds": 1620,
              "departureOffsetSeconds": 1620
            },
            {
              "stopId": "judu:stop:6276",
              "position": {
                "x": -9120.102,
                "z": 5527.623
              },
              "distanceAlongShapeM": 12724.035,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1680,
              "departureOffsetSeconds": 1680
            },
            {
              "stopId": "judu:stop:6273",
              "position": {
                "x": -9088.239,
                "z": 5861.057
              },
              "distanceAlongShapeM": 13063.461,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1740,
              "departureOffsetSeconds": 1740
            },
            {
              "stopId": "judu:stop:6271",
              "position": {
                "x": -8763.039,
                "z": 6403.466
              },
              "distanceAlongShapeM": 13812.883,
              "shapeOffsetM": 2.871,
              "arrivalOffsetSeconds": 1800,
              "departureOffsetSeconds": 1800
            },
            {
              "stopId": "judu:stop:9776",
              "position": {
                "x": -8090.106,
                "z": 6365.775
              },
              "distanceAlongShapeM": 14542.82,
              "shapeOffsetM": 11.179,
              "arrivalOffsetSeconds": 1920,
              "departureOffsetSeconds": 1920
            },
            {
              "stopId": "judu:stop:9967",
              "position": {
                "x": -6701.294,
                "z": 6078.986
              },
              "distanceAlongShapeM": 16061.877,
              "shapeOffsetM": 0.052,
              "arrivalOffsetSeconds": 2040,
              "departureOffsetSeconds": 2040
            },
            {
              "stopId": "judu:stop:357",
              "position": {
                "x": -6598.614,
                "z": 6465.771
              },
              "distanceAlongShapeM": 16501.443,
              "shapeOffsetM": 11.07,
              "arrivalOffsetSeconds": 2100,
              "departureOffsetSeconds": 2100
            },
            {
              "stopId": "judu:stop:4410",
              "position": {
                "x": -6663.331,
                "z": 5954.79
              },
              "distanceAlongShapeM": 17060.117,
              "shapeOffsetM": 7.249,
              "arrivalOffsetSeconds": 2160,
              "departureOffsetSeconds": 2160
            },
            {
              "stopId": "judu:stop:5731",
              "position": {
                "x": -6334.791,
                "z": 5638.714
              },
              "distanceAlongShapeM": 17514.966,
              "shapeOffsetM": 5.79,
              "arrivalOffsetSeconds": 2220,
              "departureOffsetSeconds": 2220
            },
            {
              "stopId": "judu:stop:6850",
              "position": {
                "x": -4517.509,
                "z": 4980.025
              },
              "distanceAlongShapeM": 19644.95,
              "shapeOffsetM": 2.616,
              "arrivalOffsetSeconds": 2400,
              "departureOffsetSeconds": 2400
            }
          ],
          "departuresSeconds": [
            19680,
            23700,
            25800,
            30360,
            32280,
            34260,
            42720,
            48840,
            54840,
            57000,
            58560,
            63600,
            65340,
            68340,
            72840,
            79080
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_bus_21",
      "sourceRouteId": "vilnius_bus_21",
      "mode": "bus",
      "shortName": "21",
      "longName": "Lazdynėliai–Lazdynai–Centras",
      "color": "0073AC",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_bus_21:0",
          "sourceRouteId": "vilnius_bus_21",
          "sourceShapeId": "vilnius_bus_21_a-b",
          "directionId": 0,
          "headsign": "Centras",
          "directionName": "Lazdynėliai–Lazdynai–Centras",
          "mode": "bus",
          "routeShortName": "21",
          "routeLongName": "Lazdynėliai–Lazdynai–Centras",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              -5499.465,
              2967.761,
              0
            ],
            [
              -5504.864,
              2978.001,
              11.576
            ],
            [
              -5507.132,
              2984.125,
              18.106
            ],
            [
              -5507.064,
              2988.744,
              22.726
            ],
            [
              -5500.758,
              2997.505,
              33.52
            ],
            [
              -5483.457,
              2997.921,
              50.826
            ],
            [
              -5477.217,
              2994.663,
              57.865
            ],
            [
              -5475.234,
              2984.842,
              67.885
            ],
            [
              -5476.891,
              2939.215,
              113.542
            ],
            [
              -5471.207,
              2917.982,
              135.523
            ],
            [
              -5266.025,
              2529.648,
              574.73
            ],
            [
              -5254.606,
              2507.12,
              599.986
            ],
            [
              -5128.219,
              2256.474,
              880.695
            ],
            [
              -5121.579,
              2229.644,
              908.334
            ],
            [
              -5117.539,
              2201.745,
              936.524
            ],
            [
              -5116.758,
              2139.39,
              998.884
            ],
            [
              -5122.771,
              2125.053,
              1014.431
            ],
            [
              -5151.268,
              2124.22,
              1042.94
            ],
            [
              -5168.723,
              2123.338,
              1060.417
            ],
            [
              -5186.285,
              2118.906,
              1078.53
            ],
            [
              -5205.39,
              2106.815,
              1101.139
            ],
            [
              -5218.73,
              2094.377,
              1119.378
            ],
            [
              -5232.085,
              2067.888,
              1149.044
            ],
            [
              -5234.987,
              2049.013,
              1168.14
            ],
            [
              -5232.767,
              2027.825,
              1189.444
            ],
            [
              -5229.106,
              2015.517,
              1202.285
            ],
            [
              -5217.174,
              1996.39,
              1224.829
            ],
            [
              -5203.627,
              1982.351,
              1244.338
            ],
            [
              -5082.26,
              1887.222,
              1398.544
            ],
            [
              -5064.922,
              1882.473,
              1416.521
            ],
            [
              -5060.085,
              1863.466,
              1436.134
            ],
            [
              -4961.259,
              1757.137,
              1581.297
            ],
            [
              -4931.684,
              1728.355,
              1622.566
            ],
            [
              -4906.917,
              1690.529,
              1667.779
            ],
            [
              -4953.434,
              1637.843,
              1738.061
            ],
            [
              -4966.71,
              1626.986,
              1755.211
            ],
            [
              -4976.574,
              1616.023,
              1769.959
            ],
            [
              -4993.932,
              1581.81,
              1808.323
            ],
            [
              -4999.643,
              1549.625,
              1841.011
            ],
            [
              -5000.423,
              1503.997,
              1886.646
            ],
            [
              -4985.973,
              1443.638,
              1948.71
            ],
            [
              -4965.718,
              1383.179,
              2012.472
            ],
            [
              -4931.334,
              1319.138,
              2085.16
            ],
            [
              -4880.829,
              1254.822,
              2166.935
            ],
            [
              -4857.956,
              1234.393,
              2197.603
            ],
            [
              -4836.703,
              1220.787,
              2222.838
            ],
            [
              -4813.463,
              1195.782,
              2256.976
            ],
            [
              -4785.375,
              1178.602,
              2289.901
            ],
            [
              -4668.299,
              1122.047,
              2419.921
            ],
            [
              -4620.374,
              1095.621,
              2474.649
            ],
            [
              -4574.442,
              1065.888,
              2529.365
            ],
            [
              -4541.69,
              1036.656,
              2573.265
            ],
            [
              -4440.575,
              860.983,
              2775.96
            ],
            [
              -4425.036,
              789.47,
              2849.142
            ],
            [
              -4406.248,
              756.864,
              2886.773
            ],
            [
              -4380.992,
              725.259,
              2927.23
            ],
            [
              -4355.565,
              703.67,
              2960.586
            ],
            [
              -4324.219,
              688.657,
              2995.342
            ],
            [
              -4302.372,
              683.828,
              3017.716
            ],
            [
              -4269.507,
              682.148,
              3050.624
            ],
            [
              -4233.908,
              689.326,
              3086.939
            ],
            [
              -4200.071,
              706.552,
              3124.909
            ],
            [
              -4154.906,
              744.734,
              3184.05
            ],
            [
              -4131.603,
              764.725,
              3214.753
            ],
            [
              -4089.107,
              782.559,
              3260.84
            ],
            [
              -4026.001,
              813.75,
              3331.233
            ],
            [
              -3968.169,
              838.352,
              3394.081
            ],
            [
              -3939.526,
              853.44,
              3426.455
            ],
            [
              -3921.201,
              868.708,
              3450.307
            ],
            [
              -3904.031,
              891.787,
              3479.072
            ],
            [
              -3887.976,
              924.905,
              3515.876
            ],
            [
              -3883.393,
              966.014,
              3557.24
            ],
            [
              -3887.876,
              1005.054,
              3596.537
            ],
            [
              -3903.754,
              1056.537,
              3650.413
            ],
            [
              -3912.994,
              1078.798,
              3674.514
            ],
            [
              -3919.363,
              1123.6,
              3719.767
            ],
            [
              -3950.775,
              1246.597,
              3846.712
            ],
            [
              -3955.819,
              1253.363,
              3855.151
            ],
            [
              -3970.574,
              1258.072,
              3870.64
            ],
            [
              -4042.541,
              1237.053,
              3945.613
            ],
            [
              -4054.062,
              1233.271,
              3957.74
            ],
            [
              -4057.056,
              1218.38,
              3972.928
            ],
            [
              -4056.603,
              1207.24,
              3984.078
            ],
            [
              -4051.599,
              1198.248,
              3994.368
            ],
            [
              -4044.601,
              1192.561,
              4003.386
            ],
            [
              -4033.696,
              1189.033,
              4014.847
            ],
            [
              -4018.95,
              1190.263,
              4029.645
            ],
            [
              -3829.673,
              1236.704,
              4224.535
            ],
            [
              -3789.4,
              1252.704,
              4267.87
            ],
            [
              -3749.695,
              1273.165,
              4312.537
            ],
            [
              -3705.908,
              1305.8,
              4367.148
            ],
            [
              -3669.839,
              1339.683,
              4416.636
            ],
            [
              -3634.26,
              1382.479,
              4472.29
            ],
            [
              -3619.001,
              1406.704,
              4500.92
            ],
            [
              -3601.633,
              1440.911,
              4539.284
            ],
            [
              -3592.427,
              1468.215,
              4568.098
            ],
            [
              -3579.402,
              1495.072,
              4597.946
            ],
            [
              -3566.606,
              1526.019,
              4631.435
            ],
            [
              -3560.672,
              1570.444,
              4676.254
            ],
            [
              -3561.909,
              1610.54,
              4716.369
            ],
            [
              -3553.124,
              1670.501,
              4776.97
            ],
            [
              -3546.511,
              1753.876,
              4860.607
            ],
            [
              -3528.502,
              1849.211,
              4957.629
            ],
            [
              -3507.519,
              1881.216,
              4995.899
            ],
            [
              -3466.64,
              1929.443,
              5059.12
            ],
            [
              -3411.117,
              1970.818,
              5128.364
            ],
            [
              -3378.421,
              1984.588,
              5163.841
            ],
            [
              -3293.772,
              2003.28,
              5250.529
            ],
            [
              -3253.06,
              2007.021,
              5291.413
            ],
            [
              -3234.374,
              2005.581,
              5310.154
            ],
            [
              -3211.057,
              2010.74,
              5334.035
            ],
            [
              -2960.432,
              2100.974,
              5600.409
            ],
            [
              -2902.519,
              2128.901,
              5664.704
            ],
            [
              -2763.528,
              2181.007,
              5813.141
            ],
            [
              -2704.044,
              2203.421,
              5876.708
            ],
            [
              -2694.973,
              2206.697,
              5886.352
            ],
            [
              -2620.644,
              2234.153,
              5965.59
            ],
            [
              -2602.113,
              2260.544,
              5997.837
            ],
            [
              -2588.136,
              2284.788,
              6025.821
            ],
            [
              -2571.13,
              2297.847,
              6047.263
            ],
            [
              -2532.153,
              2312.745,
              6088.99
            ],
            [
              -2506.977,
              2313.414,
              6114.175
            ],
            [
              -2483.854,
              2307.44,
              6138.057
            ],
            [
              -2455.846,
              2285.795,
              6173.454
            ],
            [
              -2438.355,
              2253.203,
              6210.443
            ],
            [
              -2433.47,
              2237.532,
              6226.858
            ],
            [
              -2435.723,
              2169.786,
              6294.641
            ],
            [
              -2432.837,
              2155.209,
              6309.502
            ],
            [
              -2421.673,
              2138.248,
              6329.807
            ],
            [
              -2405.237,
              2119.033,
              6355.092
            ],
            [
              -2339.12,
              2063.317,
              6441.555
            ],
            [
              -2328.352,
              2051.995,
              6457.18
            ],
            [
              -2314.582,
              2044.048,
              6473.078
            ],
            [
              -2298.509,
              2024.75,
              6498.193
            ],
            [
              -1944.941,
              1697.877,
              6979.707
            ],
            [
              -1869.698,
              1631.955,
              7079.743
            ],
            [
              -1860.469,
              1622.903,
              7092.671
            ],
            [
              -1769.084,
              1537.785,
              7217.556
            ],
            [
              -1704.495,
              1480.033,
              7304.199
            ],
            [
              -1688.349,
              1470.667,
              7322.865
            ],
            [
              -1678.973,
              1453.802,
              7342.161
            ],
            [
              -1503.095,
              1295.926,
              7578.504
            ],
            [
              -1429.356,
              1232.268,
              7675.919
            ],
            [
              -1409.124,
              1211.868,
              7704.651
            ],
            [
              -1353.311,
              1158.548,
              7781.839
            ],
            [
              -1207.93,
              1027.923,
              7977.284
            ],
            [
              -1189.5,
              1013.819,
              8000.491
            ],
            [
              -1173.062,
              993.901,
              8026.316
            ],
            [
              -1066.972,
              902.938,
              8166.064
            ],
            [
              -958.695,
              862.029,
              8281.811
            ],
            [
              -800.989,
              807.981,
              8448.522
            ],
            [
              -799.135,
              803.495,
              8453.376
            ],
            [
              -800.094,
              794.656,
              8462.267
            ],
            [
              -808.22,
              764.696,
              8493.309
            ],
            [
              -816.493,
              725.027,
              8533.832
            ],
            [
              -829.673,
              683.817,
              8577.098
            ],
            [
              -843.054,
              478.111,
              8783.239
            ],
            [
              -804.926,
              410.63,
              8860.746
            ],
            [
              -682.331,
              234.755,
              9075.133
            ],
            [
              -671.067,
              215.627,
              9097.331
            ],
            [
              -647.308,
              102.762,
              9212.669
            ],
            [
              -591.62,
              115.115,
              9269.711
            ],
            [
              -557.359,
              122.914,
              9304.848
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:16622",
              "position": {
                "x": -5500.051,
                "z": 2967.452
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 0.662,
              "arrivalOffsetSeconds": -660,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:3560",
              "position": {
                "x": -5262.256,
                "z": 2531.491
              },
              "distanceAlongShapeM": 574.79,
              "shapeOffsetM": 4.195,
              "arrivalOffsetSeconds": 60,
              "departureOffsetSeconds": 60
            },
            {
              "stopId": "judu:stop:756",
              "position": {
                "x": -5151.175,
                "z": 2121.056
              },
              "distanceAlongShapeM": 1043.007,
              "shapeOffsetM": 3.165,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:7350",
              "position": {
                "x": -4952.35,
                "z": 1636.759
              },
              "distanceAlongShapeM": 1738.061,
              "shapeOffsetM": 1.533,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:329",
              "position": {
                "x": -4834.931,
                "z": 1222.866
              },
              "distanceAlongShapeM": 2222.838,
              "shapeOffsetM": 2.732,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:4395",
              "position": {
                "x": -4540.743,
                "z": 1037.479
              },
              "distanceAlongShapeM": 2573.265,
              "shapeOffsetM": 1.254,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:5703",
              "position": {
                "x": -4134.494,
                "z": 768.872
              },
              "distanceAlongShapeM": 3214.753,
              "shapeOffsetM": 5.055,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:5702",
              "position": {
                "x": -3916.285,
                "z": 1077.905
              },
              "distanceAlongShapeM": 3674.514,
              "shapeOffsetM": 3.41,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:6333",
              "position": {
                "x": -3596.615,
                "z": 1469.767
              },
              "distanceAlongShapeM": 4568.098,
              "shapeOffsetM": 4.467,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:721",
              "position": {
                "x": -3293.772,
                "z": 2003.28
              },
              "distanceAlongShapeM": 5250.529,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:6337",
              "position": {
                "x": -2705.632,
                "z": 2207.819
              },
              "distanceAlongShapeM": 5876.708,
              "shapeOffsetM": 4.675,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:5535",
              "position": {
                "x": -2313.635,
                "z": 2045.055
              },
              "distanceAlongShapeM": 6473.078,
              "shapeOffsetM": 1.383,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:7853",
              "position": {
                "x": -1868.675,
                "z": 1633.068
              },
              "distanceAlongShapeM": 7079.743,
              "shapeOffsetM": 1.512,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:6842",
              "position": {
                "x": -1427.428,
                "z": 1234.46
              },
              "distanceAlongShapeM": 7675.919,
              "shapeOffsetM": 2.919,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:5580",
              "position": {
                "x": -1188.159,
                "z": 1015.323
              },
              "distanceAlongShapeM": 8000.491,
              "shapeOffsetM": 2.015,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            },
            {
              "stopId": "judu:stop:5267",
              "position": {
                "x": -810.251,
                "z": 723.543
              },
              "distanceAlongShapeM": 8533.832,
              "shapeOffsetM": 6.416,
              "arrivalOffsetSeconds": 1500,
              "departureOffsetSeconds": 1500
            },
            {
              "stopId": "judu:stop:5332",
              "position": {
                "x": -557.893,
                "z": 125.637
              },
              "distanceAlongShapeM": 9304.848,
              "shapeOffsetM": 2.774,
              "arrivalOffsetSeconds": 1620,
              "departureOffsetSeconds": 1620
            }
          ],
          "departuresSeconds": [
            19980,
            21300,
            22800,
            24420,
            26100,
            27600,
            37740,
            39600,
            41160,
            42720,
            44340,
            45960,
            47640,
            49260,
            50820,
            52500,
            54180,
            55860,
            57540,
            59220,
            61020,
            71280,
            73080,
            74880,
            76260,
            77640,
            79380,
            81300
          ]
        },
        {
          "id": "judu:pattern:vilnius_bus_21:1",
          "sourceRouteId": "vilnius_bus_21",
          "sourceShapeId": "vilnius_bus_21_b1-a",
          "directionId": 1,
          "headsign": "Lazdynėliai",
          "directionName": "Centras–Kauno g.–Lazdynai–Lazdynėliai",
          "mode": "bus",
          "routeShortName": "21",
          "routeLongName": "Lazdynėliai–Lazdynai–Centras",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              -557.359,
              122.914,
              0
            ],
            [
              -539.176,
              126.412,
              18.517
            ],
            [
              -408.498,
              148.538,
              151.055
            ],
            [
              -385.731,
              159.258,
              176.219
            ],
            [
              -216.06,
              268.617,
              378.08
            ],
            [
              -50.385,
              441.496,
              617.528
            ],
            [
              -51.307,
              497.175,
              673.214
            ],
            [
              -54.16,
              522.615,
              698.814
            ],
            [
              -44.593,
              547.148,
              725.146
            ],
            [
              -34.25,
              619.32,
              798.055
            ],
            [
              -34.886,
              726.201,
              904.938
            ],
            [
              -29.964,
              784,
              962.947
            ],
            [
              -28.88,
              804.74,
              983.715
            ],
            [
              -24.076,
              823.969,
              1003.535
            ],
            [
              -6.94,
              914.942,
              1096.108
            ],
            [
              5.94,
              949.218,
              1132.724
            ],
            [
              14.89,
              980.225,
              1164.997
            ],
            [
              20.723,
              1007.284,
              1192.678
            ],
            [
              98.858,
              1127.869,
              1336.364
            ],
            [
              208.532,
              1302.485,
              1542.566
            ],
            [
              265.611,
              1357.493,
              1621.837
            ],
            [
              347.967,
              1416.104,
              1722.919
            ],
            [
              403.761,
              1468.519,
              1799.472
            ],
            [
              407.254,
              1474.663,
              1806.54
            ],
            [
              398.727,
              1481.949,
              1817.756
            ],
            [
              393.766,
              1486.188,
              1824.282
            ],
            [
              391.311,
              1493.238,
              1831.747
            ],
            [
              396.156,
              1548.878,
              1887.597
            ],
            [
              395.449,
              1569.043,
              1907.775
            ],
            [
              391.321,
              1670.242,
              2009.058
            ],
            [
              330.657,
              1810.504,
              2161.877
            ],
            [
              156.41,
              1772.494,
              2340.221
            ],
            [
              29.934,
              1735.835,
              2471.903
            ],
            [
              -11.394,
              1732.372,
              2513.376
            ],
            [
              -46.755,
              1740.57,
              2549.675
            ],
            [
              -320.217,
              1781.157,
              2826.132
            ],
            [
              -514.905,
              1842.557,
              3030.273
            ],
            [
              -530.605,
              1766.267,
              3108.161
            ],
            [
              -536.862,
              1752.795,
              3123.015
            ],
            [
              -542.324,
              1736.195,
              3140.491
            ],
            [
              -678.532,
              1124.155,
              3767.504
            ],
            [
              -683.338,
              1093.819,
              3798.219
            ],
            [
              -691.829,
              1066.507,
              3826.82
            ],
            [
              -722.413,
              980.227,
              3918.36
            ],
            [
              -796.476,
              807.9,
              4105.929
            ],
            [
              -803.749,
              798.012,
              4118.203
            ],
            [
              -958.695,
              862.029,
              4285.853
            ],
            [
              -1066.972,
              902.938,
              4401.6
            ],
            [
              -1103.368,
              923.63,
              4443.467
            ],
            [
              -1148.452,
              963.402,
              4503.587
            ],
            [
              -1166.61,
              973.416,
              4524.323
            ],
            [
              -1183.42,
              991.86,
              4549.278
            ],
            [
              -1484.246,
              1267.759,
              4957.465
            ],
            [
              -1501.298,
              1275.764,
              4976.303
            ],
            [
              -1524.902,
              1302.995,
              5012.34
            ],
            [
              -1970.62,
              1705.012,
              5612.575
            ],
            [
              -1985.783,
              1723.093,
              5636.173
            ],
            [
              -2263.842,
              1978.495,
              6013.727
            ],
            [
              -2290.557,
              2000.118,
              6048.096
            ],
            [
              -2318.992,
              2034.018,
              6092.342
            ],
            [
              -2425.036,
              2130.514,
              6235.719
            ],
            [
              -2441.629,
              2140.826,
              6255.255
            ],
            [
              -2453.884,
              2141.043,
              6267.512
            ],
            [
              -2464.869,
              2140.123,
              6278.535
            ],
            [
              -2491.57,
              2126.123,
              6308.684
            ],
            [
              -2514.888,
              2120.968,
              6332.565
            ],
            [
              -2528.453,
              2120.094,
              6346.158
            ],
            [
              -2551.595,
              2124.955,
              6369.805
            ],
            [
              -2561.443,
              2130.364,
              6381.042
            ],
            [
              -2579.681,
              2142.148,
              6402.755
            ],
            [
              -2607.297,
              2186.05,
              6454.62
            ],
            [
              -2618.809,
              2191.819,
              6467.497
            ],
            [
              -2640.075,
              2193.306,
              6488.815
            ],
            [
              -2665.388,
              2184.846,
              6515.504
            ],
            [
              -2681.67,
              2176.227,
              6533.927
            ],
            [
              -2692.184,
              2172.41,
              6545.112
            ],
            [
              -2738.119,
              2158.296,
              6593.166
            ],
            [
              -2899.782,
              2101.023,
              6764.675
            ],
            [
              -2971.67,
              2085.586,
              6838.202
            ],
            [
              -3160.259,
              2016.062,
              7039.198
            ],
            [
              -3215.258,
              1991.889,
              7099.274
            ],
            [
              -3241.166,
              1975.384,
              7129.993
            ],
            [
              -3275.786,
              1961.777,
              7167.191
            ],
            [
              -3353.278,
              1920.828,
              7254.837
            ],
            [
              -3402.898,
              1887.184,
              7314.788
            ],
            [
              -3447.61,
              1838.983,
              7380.533
            ],
            [
              -3464.825,
              1813.679,
              7411.138
            ],
            [
              -3479.576,
              1781.653,
              7446.398
            ],
            [
              -3552.495,
              1521.32,
              7716.75
            ],
            [
              -3561.139,
              1488.768,
              7750.431
            ],
            [
              -3571.509,
              1457.992,
              7782.907
            ],
            [
              -3607.243,
              1385.693,
              7863.555
            ],
            [
              -3647.326,
              1335.952,
              7927.436
            ],
            [
              -3697.872,
              1285.623,
              7998.765
            ],
            [
              -3750.727,
              1250.919,
              8061.995
            ],
            [
              -3785.215,
              1233.706,
              8100.54
            ],
            [
              -3881.236,
              1201.976,
              8201.668
            ],
            [
              -3947.947,
              1186.435,
              8270.165
            ],
            [
              -4025.13,
              1162.167,
              8351.073
            ],
            [
              -4030.044,
              1153.729,
              8360.838
            ],
            [
              -4035.169,
              1141.19,
              8374.384
            ],
            [
              -4036.064,
              1126.734,
              8388.868
            ],
            [
              -4033.96,
              1115.733,
              8400.068
            ],
            [
              -4024.139,
              1107.603,
              8412.818
            ],
            [
              -4011.945,
              1104.053,
              8425.518
            ],
            [
              -3919.363,
              1123.6,
              8520.141
            ],
            [
              -3891.127,
              1040.733,
              8607.687
            ],
            [
              -3881.018,
              1009.279,
              8640.725
            ],
            [
              -3879.245,
              944.791,
              8705.237
            ],
            [
              -3881.411,
              931.47,
              8718.733
            ],
            [
              -3898.384,
              892.134,
              8761.575
            ],
            [
              -3911.432,
              874.104,
              8783.831
            ],
            [
              -3948.102,
              842.457,
              8832.269
            ],
            [
              -4089.107,
              782.559,
              8985.469
            ],
            [
              -4161.662,
              727.04,
              9076.828
            ],
            [
              -4178.229,
              714.534,
              9097.586
            ],
            [
              -4241.116,
              682.771,
              9168.039
            ],
            [
              -4270.228,
              677.707,
              9197.588
            ],
            [
              -4302.372,
              683.828,
              9230.31
            ],
            [
              -4333.814,
              693.276,
              9263.141
            ],
            [
              -4354.294,
              702.534,
              9285.616
            ],
            [
              -4389.905,
              732.091,
              9331.895
            ],
            [
              -4413.832,
              765.9,
              9373.314
            ],
            [
              -4426.952,
              790.616,
              9401.297
            ],
            [
              -4443.78,
              862.151,
              9474.784
            ],
            [
              -4463.138,
              899.22,
              9516.604
            ],
            [
              -4510.16,
              977.953,
              9608.309
            ],
            [
              -4563.16,
              1046.77,
              9695.17
            ],
            [
              -4582.825,
              1066.032,
              9722.697
            ],
            [
              -4608.92,
              1086.518,
              9755.873
            ],
            [
              -4758.008,
              1156.982,
              9920.774
            ],
            [
              -4816.744,
              1192.498,
              9989.413
            ],
            [
              -4874.57,
              1243.583,
              10066.572
            ],
            [
              -4893.428,
              1253.165,
              10087.725
            ],
            [
              -4938.352,
              1323.711,
              10171.36
            ],
            [
              -4959.005,
              1360.8,
              10213.812
            ],
            [
              -4978.198,
              1407.883,
              10264.657
            ],
            [
              -4995.361,
              1460.496,
              10319.998
            ],
            [
              -5000.423,
              1503.997,
              10363.793
            ],
            [
              -5002.906,
              1547.455,
              10407.322
            ],
            [
              -4998.561,
              1575.21,
              10435.415
            ],
            [
              -4985.073,
              1609.489,
              10472.252
            ],
            [
              -4958.06,
              1642.423,
              10514.847
            ],
            [
              -4906.917,
              1690.529,
              10585.059
            ],
            [
              -4961.39,
              1738.988,
              10657.968
            ],
            [
              -4976.074,
              1758.503,
              10682.39
            ],
            [
              -5065.283,
              1861.328,
              10818.519
            ],
            [
              -5077.888,
              1869.006,
              10833.278
            ],
            [
              -5084.328,
              1879.465,
              10845.561
            ],
            [
              -5215.138,
              1981.641,
              11011.547
            ],
            [
              -5233.729,
              2008.428,
              11044.153
            ],
            [
              -5239.666,
              2025.783,
              11062.496
            ],
            [
              -5242.006,
              2043.57,
              11080.436
            ],
            [
              -5238.791,
              2070.128,
              11107.188
            ],
            [
              -5223.962,
              2099.283,
              11139.897
            ],
            [
              -5207.931,
              2116.333,
              11163.3
            ],
            [
              -5183.957,
              2128.294,
              11190.092
            ],
            [
              -5143.89,
              2132.063,
              11230.336
            ],
            [
              -5127.139,
              2130.664,
              11247.145
            ],
            [
              -5118.637,
              2137.21,
              11257.875
            ],
            [
              -5118.275,
              2163.922,
              11284.589
            ],
            [
              -5118.414,
              2191.207,
              11311.874
            ],
            [
              -5122.291,
              2228.865,
              11349.732
            ],
            [
              -5129.697,
              2256.977,
              11378.803
            ],
            [
              -5177.599,
              2353.365,
              11486.438
            ],
            [
              -5256.746,
              2507.237,
              11659.472
            ],
            [
              -5434.652,
              2850.293,
              12045.914
            ],
            [
              -5447.218,
              2874.188,
              12072.913
            ],
            [
              -5456.675,
              2890.795,
              12092.023
            ],
            [
              -5471.207,
              2917.982,
              12122.85
            ],
            [
              -5499.465,
              2967.761,
              12180.091
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:5332",
              "position": {
                "x": -557.893,
                "z": 125.637
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 2.774,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:5338",
              "position": {
                "x": -56,
                "z": 522.864
              },
              "distanceAlongShapeM": 698.814,
              "shapeOffsetM": 1.857,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:5345",
              "position": {
                "x": 17.976,
                "z": 1008
              },
              "distanceAlongShapeM": 1192.678,
              "shapeOffsetM": 2.839,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:5349",
              "position": {
                "x": 206.575,
                "z": 1304.022
              },
              "distanceAlongShapeM": 1542.566,
              "shapeOffsetM": 2.488,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:5430",
              "position": {
                "x": 392.049,
                "z": 1568.924
              },
              "distanceAlongShapeM": 1907.795,
              "shapeOffsetM": 3.402,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:6650",
              "position": {
                "x": -11.424,
                "z": 1732.135
              },
              "distanceAlongShapeM": 2513.376,
              "shapeOffsetM": 0.239,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:5168",
              "position": {
                "x": -529.526,
                "z": 1766.021
              },
              "distanceAlongShapeM": 3108.161,
              "shapeOffsetM": 1.107,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:6853",
              "position": {
                "x": -679.739,
                "z": 1093.006
              },
              "distanceAlongShapeM": 3798.219,
              "shapeOffsetM": 3.689,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:5579",
              "position": {
                "x": -1168.303,
                "z": 971.551
              },
              "distanceAlongShapeM": 4524.323,
              "shapeOffsetM": 2.518,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:6343",
              "position": {
                "x": -1502.183,
                "z": 1274.758
              },
              "distanceAlongShapeM": 4976.303,
              "shapeOffsetM": 1.34,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:7852",
              "position": {
                "x": -1970.62,
                "z": 1705.012
              },
              "distanceAlongShapeM": 5612.575,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            },
            {
              "stopId": "judu:stop:5532",
              "position": {
                "x": -2290.557,
                "z": 2000.118
              },
              "distanceAlongShapeM": 6048.096,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            },
            {
              "stopId": "judu:stop:6338",
              "position": {
                "x": -2690.837,
                "z": 2168.596
              },
              "distanceAlongShapeM": 6545.112,
              "shapeOffsetM": 4.045,
              "arrivalOffsetSeconds": 1560,
              "departureOffsetSeconds": 1560
            },
            {
              "stopId": "judu:stop:720",
              "position": {
                "x": -3240.098,
                "z": 1973.399
              },
              "distanceAlongShapeM": 7129.993,
              "shapeOffsetM": 2.254,
              "arrivalOffsetSeconds": 1620,
              "departureOffsetSeconds": 1620
            },
            {
              "stopId": "judu:stop:790",
              "position": {
                "x": -3555.031,
                "z": 1486.855
              },
              "distanceAlongShapeM": 7750.431,
              "shapeOffsetM": 6.401,
              "arrivalOffsetSeconds": 1680,
              "departureOffsetSeconds": 1680
            },
            {
              "stopId": "judu:stop:5701",
              "position": {
                "x": -3876.172,
                "z": 1010.417
              },
              "distanceAlongShapeM": 8640.725,
              "shapeOffsetM": 4.978,
              "arrivalOffsetSeconds": 1800,
              "departureOffsetSeconds": 1800
            },
            {
              "stopId": "judu:stop:5704",
              "position": {
                "x": -4175.491,
                "z": 710.581
              },
              "distanceAlongShapeM": 9097.586,
              "shapeOffsetM": 4.809,
              "arrivalOffsetSeconds": 1860,
              "departureOffsetSeconds": 1860
            },
            {
              "stopId": "judu:stop:16703",
              "position": {
                "x": -4563.16,
                "z": 1046.77
              },
              "distanceAlongShapeM": 9695.17,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1980,
              "departureOffsetSeconds": 1980
            },
            {
              "stopId": "judu:stop:5672",
              "position": {
                "x": -4893.764,
                "z": 1252.817
              },
              "distanceAlongShapeM": 10087.725,
              "shapeOffsetM": 0.484,
              "arrivalOffsetSeconds": 2040,
              "departureOffsetSeconds": 2040
            },
            {
              "stopId": "judu:stop:7341",
              "position": {
                "x": -4962.228,
                "z": 1738.229
              },
              "distanceAlongShapeM": 10657.968,
              "shapeOffsetM": 1.131,
              "arrivalOffsetSeconds": 2100,
              "departureOffsetSeconds": 2100
            },
            {
              "stopId": "judu:stop:7560",
              "position": {
                "x": -5126.114,
                "z": 2190.759
              },
              "distanceAlongShapeM": 11311.466,
              "shapeOffsetM": 7.703,
              "arrivalOffsetSeconds": 2220,
              "departureOffsetSeconds": 2220
            },
            {
              "stopId": "judu:stop:7171",
              "position": {
                "x": -5259.467,
                "z": 2505.84
              },
              "distanceAlongShapeM": 11659.484,
              "shapeOffsetM": 3.059,
              "arrivalOffsetSeconds": 2340,
              "departureOffsetSeconds": 2340
            },
            {
              "stopId": "judu:stop:16622",
              "position": {
                "x": -5500.051,
                "z": 2967.452
              },
              "distanceAlongShapeM": 12180.091,
              "shapeOffsetM": 0.662,
              "arrivalOffsetSeconds": 2460,
              "departureOffsetSeconds": 2460
            }
          ],
          "departuresSeconds": [
            21540,
            22860,
            24360,
            25980,
            27900,
            29460,
            34680,
            36540,
            38040,
            39420,
            41280,
            42780,
            44340,
            46020,
            47640,
            49320,
            50940,
            52500,
            54120,
            55800,
            57480,
            59160,
            60900,
            62700,
            68040,
            69720,
            71820,
            72840,
            74640,
            76440,
            77820,
            79260,
            81000,
            82800
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_bus_22",
      "sourceRouteId": "vilnius_bus_22",
      "mode": "bus",
      "shortName": "22",
      "longName": "Lazdynai–Oslo g.–Centras",
      "color": "0073AC",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_bus_22:0",
          "sourceRouteId": "vilnius_bus_22",
          "sourceShapeId": "vilnius_bus_22_a-b",
          "directionId": 0,
          "headsign": "Centras",
          "directionName": "Lazdynai–Oslo g.–Centras",
          "mode": "bus",
          "routeShortName": "22",
          "routeLongName": "Lazdynai–Oslo g.–Centras",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              -4070.589,
              1735.287,
              0
            ],
            [
              -4047.235,
              1694.122,
              47.329
            ],
            [
              -4037.796,
              1664.197,
              78.707
            ],
            [
              -4021.405,
              1600.417,
              144.559
            ],
            [
              -3992.198,
              1462.162,
              285.866
            ],
            [
              -3985.157,
              1436.356,
              312.615
            ],
            [
              -3986.154,
              1438.68,
              315.143
            ],
            [
              -3973.348,
              1390.702,
              364.801
            ],
            [
              -3969.311,
              1368.257,
              387.606
            ],
            [
              -3952.68,
              1285.592,
              471.927
            ],
            [
              -3953.633,
              1267.797,
              489.748
            ],
            [
              -3986.792,
              1252.786,
              526.146
            ],
            [
              -4052.715,
              1233.557,
              594.816
            ],
            [
              -4088.482,
              1228.943,
              630.88
            ],
            [
              -4121.332,
              1231.737,
              663.849
            ],
            [
              -4147.457,
              1237.551,
              690.613
            ],
            [
              -4212.237,
              1261.595,
              759.711
            ],
            [
              -4241.916,
              1271.669,
              791.053
            ],
            [
              -4268.203,
              1281.028,
              818.956
            ],
            [
              -4527.979,
              1404.616,
              1106.632
            ],
            [
              -4557.013,
              1417.363,
              1138.341
            ],
            [
              -4581.673,
              1433.369,
              1167.741
            ],
            [
              -4718.251,
              1519.203,
              1329.051
            ],
            [
              -4836.63,
              1608.523,
              1477.346
            ],
            [
              -4906.917,
              1690.529,
              1585.352
            ],
            [
              -4961.39,
              1738.988,
              1658.261
            ],
            [
              -5068.759,
              1878.357,
              1834.192
            ],
            [
              -5277.102,
              2035.914,
              2095.402
            ],
            [
              -5274.521,
              2038.555,
              2099.095
            ],
            [
              -5252.738,
              2043.812,
              2121.503
            ],
            [
              -5246.023,
              2048.225,
              2129.539
            ],
            [
              -5243.524,
              2050.617,
              2132.998
            ],
            [
              -5236.97,
              2075.695,
              2158.918
            ],
            [
              -5201.692,
              2109.98,
              2208.112
            ],
            [
              -5149.809,
              2125.485,
              2262.262
            ],
            [
              -5115.548,
              2129.353,
              2296.74
            ],
            [
              -5121.784,
              2044.927,
              2381.397
            ],
            [
              -4759.188,
              2066.486,
              2744.633
            ],
            [
              -4628.554,
              2084.282,
              2876.474
            ],
            [
              -4532.335,
              2089.308,
              2972.824
            ],
            [
              -4413.826,
              2088.426,
              3091.336
            ],
            [
              -4171.807,
              2044.134,
              3337.375
            ],
            [
              -4056.112,
              2018.757,
              3455.82
            ],
            [
              -4035.993,
              2013.78,
              3476.546
            ],
            [
              -4018.212,
              2009.195,
              3494.908
            ],
            [
              -3691.362,
              1920.037,
              3833.7
            ],
            [
              -3598.621,
              1910.632,
              3926.917
            ],
            [
              -3547.649,
              1910.858,
              3977.889
            ],
            [
              -3478.544,
              1919.039,
              4047.477
            ],
            [
              -3376.715,
              1945.728,
              4152.746
            ],
            [
              -3255.325,
              1988.136,
              4281.33
            ],
            [
              -3211.057,
              2010.74,
              4331.035
            ],
            [
              -3076.57,
              2064.047,
              4475.702
            ],
            [
              -3025.322,
              2079.847,
              4529.33
            ],
            [
              -2969.481,
              2100.019,
              4588.703
            ],
            [
              -2931.778,
              2116.056,
              4629.675
            ],
            [
              -2890.295,
              2136.475,
              4675.911
            ],
            [
              -2704.044,
              2203.421,
              4873.828
            ],
            [
              -2694.973,
              2206.697,
              4883.473
            ],
            [
              -2620.644,
              2234.153,
              4962.71
            ],
            [
              -2602.113,
              2260.544,
              4994.957
            ],
            [
              -2588.136,
              2284.788,
              5022.942
            ],
            [
              -2571.13,
              2297.847,
              5044.383
            ],
            [
              -2549.022,
              2307.476,
              5068.497
            ],
            [
              -2532.153,
              2312.745,
              5086.17
            ],
            [
              -2506.977,
              2313.414,
              5111.355
            ],
            [
              -2483.854,
              2307.44,
              5135.237
            ],
            [
              -2455.846,
              2285.795,
              5170.634
            ],
            [
              -2438.355,
              2253.203,
              5207.623
            ],
            [
              -2433.47,
              2237.532,
              5224.038
            ],
            [
              -2435.723,
              2169.786,
              5291.821
            ],
            [
              -2432.837,
              2155.209,
              5306.682
            ],
            [
              -2421.673,
              2138.248,
              5326.987
            ],
            [
              -2405.237,
              2119.033,
              5352.272
            ],
            [
              -2339.12,
              2063.317,
              5438.735
            ],
            [
              -2328.352,
              2051.995,
              5454.359
            ],
            [
              -2314.582,
              2044.048,
              5470.258
            ],
            [
              -2298.509,
              2024.75,
              5495.373
            ],
            [
              -1944.941,
              1697.877,
              5976.887
            ],
            [
              -1869.698,
              1631.955,
              6076.923
            ],
            [
              -1860.469,
              1622.903,
              6089.851
            ],
            [
              -1769.084,
              1537.785,
              6214.736
            ],
            [
              -1704.495,
              1480.033,
              6301.379
            ],
            [
              -1688.349,
              1470.667,
              6320.045
            ],
            [
              -1678.973,
              1453.802,
              6339.341
            ],
            [
              -1503.095,
              1295.926,
              6575.684
            ],
            [
              -1429.356,
              1232.268,
              6673.099
            ],
            [
              -1409.124,
              1211.868,
              6701.83
            ],
            [
              -1353.311,
              1158.548,
              6779.019
            ],
            [
              -1207.93,
              1027.923,
              6974.464
            ],
            [
              -1189.5,
              1013.819,
              6997.671
            ],
            [
              -1173.062,
              993.901,
              7023.496
            ],
            [
              -1066.972,
              902.938,
              7163.244
            ],
            [
              -958.695,
              862.029,
              7278.991
            ],
            [
              -800.989,
              807.981,
              7445.702
            ],
            [
              -799.135,
              803.495,
              7450.556
            ],
            [
              -800.094,
              794.656,
              7459.447
            ],
            [
              -808.22,
              764.696,
              7490.489
            ],
            [
              -816.493,
              725.027,
              7531.011
            ],
            [
              -824.878,
              699.315,
              7558.056
            ],
            [
              -838.2,
              496.948,
              7760.861
            ],
            [
              -838.156,
              463.551,
              7794.258
            ],
            [
              -823.183,
              435.45,
              7826.099
            ],
            [
              -689.434,
              255.78,
              8050.086
            ],
            [
              -671.067,
              215.627,
              8094.241
            ],
            [
              -634.631,
              19.041,
              8294.175
            ],
            [
              -585.127,
              -96.516,
              8419.889
            ],
            [
              -572.146,
              -122.078,
              8448.558
            ],
            [
              -567.275,
              -143.594,
              8470.619
            ],
            [
              -513.161,
              -289.293,
              8626.042
            ],
            [
              -501.093,
              -299.53,
              8641.867
            ],
            [
              -461.426,
              -352.57,
              8708.1
            ],
            [
              -452.174,
              -363.943,
              8722.761
            ],
            [
              -413.017,
              -421.354,
              8792.254
            ],
            [
              -305.298,
              -348.72,
              8922.173
            ],
            [
              -335.653,
              -209.016,
              9065.137
            ],
            [
              -372.626,
              -210.078,
              9102.125
            ],
            [
              -418.232,
              -210.859,
              9147.738
            ],
            [
              -451.474,
              -230.295,
              9186.245
            ],
            [
              -478.241,
              -268.382,
              9232.797
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:5693",
              "position": {
                "x": -4066.123,
                "z": 1738.403
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 5.445,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:5697",
              "position": {
                "x": -3968.906,
                "z": 1391.627
              },
              "distanceAlongShapeM": 364.801,
              "shapeOffsetM": 4.537,
              "arrivalOffsetSeconds": 60,
              "departureOffsetSeconds": 60
            },
            {
              "stopId": "judu:stop:6318",
              "position": {
                "x": -4215.081,
                "z": 1256.734
              },
              "distanceAlongShapeM": 760.841,
              "shapeOffsetM": 5.517,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:6319",
              "position": {
                "x": -4558.781,
                "z": 1414.051
              },
              "distanceAlongShapeM": 1138.341,
              "shapeOffsetM": 3.754,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:6320",
              "position": {
                "x": -4838.028,
                "z": 1606.973
              },
              "distanceAlongShapeM": 1477.346,
              "shapeOffsetM": 2.088,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:6350",
              "position": {
                "x": -4413.578,
                "z": 2091.718
              },
              "distanceAlongShapeM": 3091.336,
              "shapeOffsetM": 3.302,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:6352",
              "position": {
                "x": -4034.827,
                "z": 2018.389
              },
              "distanceAlongShapeM": 3476.546,
              "shapeOffsetM": 4.755,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:6337",
              "position": {
                "x": -2705.632,
                "z": 2207.819
              },
              "distanceAlongShapeM": 4873.821,
              "shapeOffsetM": 4.675,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:5535",
              "position": {
                "x": -2313.635,
                "z": 2045.055
              },
              "distanceAlongShapeM": 5470.258,
              "shapeOffsetM": 1.383,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:7853",
              "position": {
                "x": -1868.675,
                "z": 1633.068
              },
              "distanceAlongShapeM": 6076.923,
              "shapeOffsetM": 1.512,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:6842",
              "position": {
                "x": -1427.428,
                "z": 1234.46
              },
              "distanceAlongShapeM": 6673.099,
              "shapeOffsetM": 2.919,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:5580",
              "position": {
                "x": -1188.159,
                "z": 1015.323
              },
              "distanceAlongShapeM": 6997.671,
              "shapeOffsetM": 2.015,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:5267",
              "position": {
                "x": -810.251,
                "z": 723.543
              },
              "distanceAlongShapeM": 7531.011,
              "shapeOffsetM": 6.416,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            },
            {
              "stopId": "judu:stop:6736",
              "position": {
                "x": -570.097,
                "z": -121.279
              },
              "distanceAlongShapeM": 8448.558,
              "shapeOffsetM": 2.199,
              "arrivalOffsetSeconds": 1500,
              "departureOffsetSeconds": 1500
            },
            {
              "stopId": "judu:stop:5258",
              "position": {
                "x": -449.339,
                "z": -361.695
              },
              "distanceAlongShapeM": 8722.761,
              "shapeOffsetM": 3.618,
              "arrivalOffsetSeconds": 1560,
              "departureOffsetSeconds": 1560
            },
            {
              "stopId": "judu:stop:7663",
              "position": {
                "x": -372.48,
                "z": -212.801
              },
              "distanceAlongShapeM": 9102.057,
              "shapeOffsetM": 2.726,
              "arrivalOffsetSeconds": 1680,
              "departureOffsetSeconds": 1680
            }
          ],
          "departuresSeconds": [
            19800,
            21600,
            23100,
            24120,
            25320,
            26820,
            28260,
            29700,
            32460,
            34500,
            37320,
            38700,
            41100,
            42900,
            44820,
            46680,
            48480,
            50400,
            52200,
            54060,
            55860,
            57720,
            58740,
            60360,
            61980,
            63060,
            64800,
            67260,
            69660,
            70920,
            72240,
            73740,
            75780,
            77400,
            79260,
            81000,
            82800
          ]
        },
        {
          "id": "judu:pattern:vilnius_bus_22:1",
          "sourceRouteId": "vilnius_bus_22",
          "sourceShapeId": "vilnius_bus_22_b-a",
          "directionId": 1,
          "headsign": "Lazdynai",
          "directionName": "Centras–Oslo g.–Lazdynai",
          "mode": "bus",
          "routeShortName": "22",
          "routeLongName": "Lazdynai–Oslo g.–Centras",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              -478.241,
              -268.382,
              0
            ],
            [
              -501.093,
              -299.53,
              38.631
            ],
            [
              -510.139,
              -300.48,
              47.727
            ],
            [
              -513.322,
              -298.196,
              51.645
            ],
            [
              -611.52,
              -58.189,
              310.963
            ],
            [
              -614.075,
              -53.155,
              316.609
            ],
            [
              -625.745,
              -24.535,
              347.517
            ],
            [
              -643.846,
              18.014,
              393.755
            ],
            [
              -652.524,
              63.893,
              440.448
            ],
            [
              -682.331,
              234.755,
              613.891
            ],
            [
              -830.115,
              444.481,
              870.455
            ],
            [
              -843.054,
              478.111,
              906.488
            ],
            [
              -829.673,
              683.817,
              1112.629
            ],
            [
              -833.364,
              729.525,
              1158.485
            ],
            [
              -839.916,
              759.701,
              1189.365
            ],
            [
              -842.83,
              772.274,
              1202.271
            ],
            [
              -845.743,
              794.315,
              1224.503
            ],
            [
              -856.909,
              819.008,
              1251.604
            ],
            [
              -958.695,
              862.029,
              1362.108
            ],
            [
              -1094.5,
              914.565,
              1507.721
            ],
            [
              -1148.512,
              960.063,
              1578.342
            ],
            [
              -1166.61,
              973.416,
              1600.833
            ],
            [
              -1183.42,
              991.86,
              1625.788
            ],
            [
              -1484.246,
              1267.759,
              2033.975
            ],
            [
              -1501.298,
              1275.764,
              2052.813
            ],
            [
              -1524.902,
              1302.995,
              2088.85
            ],
            [
              -1970.62,
              1705.012,
              2689.085
            ],
            [
              -1985.783,
              1723.093,
              2712.682
            ],
            [
              -2263.842,
              1978.495,
              3090.236
            ],
            [
              -2290.557,
              2000.118,
              3124.605
            ],
            [
              -2318.992,
              2034.018,
              3168.852
            ],
            [
              -2425.036,
              2130.514,
              3312.228
            ],
            [
              -2441.629,
              2140.826,
              3331.765
            ],
            [
              -2464.869,
              2140.123,
              3355.015
            ],
            [
              -2491.57,
              2126.123,
              3385.164
            ],
            [
              -2503.239,
              2122.989,
              3397.246
            ],
            [
              -2528.453,
              2120.094,
              3422.626
            ],
            [
              -2543.24,
              2122.614,
              3437.626
            ],
            [
              -2561.443,
              2130.364,
              3457.411
            ],
            [
              -2579.681,
              2142.148,
              3479.124
            ],
            [
              -2607.297,
              2186.05,
              3530.99
            ],
            [
              -2618.809,
              2191.819,
              3543.866
            ],
            [
              -2640.075,
              2193.306,
              3565.184
            ],
            [
              -2665.388,
              2184.846,
              3591.873
            ],
            [
              -2681.67,
              2176.227,
              3610.296
            ],
            [
              -2692.184,
              2172.41,
              3621.482
            ],
            [
              -2745.273,
              2155.082,
              3677.327
            ],
            [
              -2858.912,
              2113.664,
              3798.278
            ],
            [
              -2885.494,
              2106.338,
              3825.851
            ],
            [
              -2963.852,
              2089.902,
              3905.915
            ],
            [
              -3175.505,
              2014.571,
              4130.574
            ],
            [
              -3269.998,
              1973.346,
              4233.668
            ],
            [
              -3463.705,
              1914.962,
              4435.982
            ],
            [
              -3534.885,
              1902.843,
              4508.187
            ],
            [
              -3642.009,
              1901.368,
              4615.321
            ],
            [
              -3703.185,
              1907.997,
              4676.855
            ],
            [
              -3763.581,
              1922.405,
              4738.946
            ],
            [
              -4034.529,
              1998.346,
              5020.335
            ],
            [
              -4081.754,
              2006.899,
              5068.328
            ],
            [
              -4108.338,
              2013.522,
              5095.724
            ],
            [
              -4294.183,
              2056.264,
              5286.421
            ],
            [
              -4414.529,
              2073.923,
              5408.056
            ],
            [
              -4474.544,
              2075.053,
              5468.082
            ],
            [
              -4495.165,
              2075.221,
              5488.703
            ],
            [
              -4714.759,
              2061.271,
              5708.74
            ],
            [
              -4881.318,
              2031.771,
              5877.892
            ],
            [
              -4920.175,
              2009.13,
              5922.864
            ],
            [
              -4946.298,
              1989.517,
              5955.529
            ],
            [
              -5067.466,
              1877.117,
              6120.804
            ],
            [
              -4961.259,
              1757.137,
              6281.038
            ],
            [
              -4931.684,
              1728.355,
              6322.307
            ],
            [
              -4906.917,
              1690.529,
              6367.52
            ],
            [
              -4842.797,
              1742.865,
              6450.287
            ],
            [
              -4801.101,
              1766.641,
              6498.286
            ],
            [
              -4774.467,
              1777.316,
              6526.979
            ],
            [
              -4728.427,
              1790.998,
              6575.009
            ],
            [
              -4687.68,
              1796.979,
              6616.193
            ],
            [
              -4579.155,
              1805.134,
              6725.024
            ],
            [
              -4546.833,
              1810.069,
              6757.721
            ],
            [
              -4518.395,
              1811.882,
              6786.216
            ],
            [
              -4300.033,
              1829.272,
              7005.269
            ],
            [
              -4282.619,
              1828.972,
              7022.686
            ],
            [
              -4257.523,
              1825.2,
              7048.064
            ],
            [
              -4165.014,
              1802.452,
              7143.329
            ],
            [
              -4141.304,
              1793.136,
              7168.803
            ],
            [
              -4122.773,
              1782.797,
              7190.023
            ],
            [
              -4070.589,
              1735.287,
              7260.595
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:6356",
              "position": {
                "x": -476.052,
                "z": -269.926
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 2.679,
              "arrivalOffsetSeconds": -720,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:5264",
              "position": {
                "x": -646.921,
                "z": 17.037
              },
              "distanceAlongShapeM": 393.755,
              "shapeOffsetM": 3.227,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:683",
              "position": {
                "x": -844.854,
                "z": 772.035
              },
              "distanceAlongShapeM": 1202.299,
              "shapeOffsetM": 2.038,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:5579",
              "position": {
                "x": -1168.303,
                "z": 971.551
              },
              "distanceAlongShapeM": 1600.833,
              "shapeOffsetM": 2.518,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:6343",
              "position": {
                "x": -1502.183,
                "z": 1274.758
              },
              "distanceAlongShapeM": 2052.813,
              "shapeOffsetM": 1.34,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:7852",
              "position": {
                "x": -1970.62,
                "z": 1705.012
              },
              "distanceAlongShapeM": 2689.085,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:5532",
              "position": {
                "x": -2290.557,
                "z": 2000.118
              },
              "distanceAlongShapeM": 3124.605,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:6338",
              "position": {
                "x": -2690.837,
                "z": 2168.596
              },
              "distanceAlongShapeM": 3621.482,
              "shapeOffsetM": 4.045,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:6353",
              "position": {
                "x": -4082.845,
                "z": 2002.521
              },
              "distanceAlongShapeM": 5068.328,
              "shapeOffsetM": 4.512,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:6351",
              "position": {
                "x": -4474.572,
                "z": 2071.617
              },
              "distanceAlongShapeM": 5468.045,
              "shapeOffsetM": 3.435,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:437",
              "position": {
                "x": -4928.804,
                "z": 1730.978
              },
              "distanceAlongShapeM": 6322.307,
              "shapeOffsetM": 3.896,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:5691",
              "position": {
                "x": -4547.361,
                "z": 1815.72
              },
              "distanceAlongShapeM": 6757.721,
              "shapeOffsetM": 5.676,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:5693",
              "position": {
                "x": -4066.123,
                "z": 1738.403
              },
              "distanceAlongShapeM": 7260.595,
              "shapeOffsetM": 5.445,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            }
          ],
          "departuresSeconds": [
            20520,
            22020,
            24180,
            25680,
            26880,
            28320,
            31140,
            34980,
            37380,
            39780,
            41640,
            43560,
            45360,
            47160,
            49080,
            50880,
            52740,
            54540,
            56400,
            58860,
            60360,
            61440,
            63180,
            65760,
            69600,
            72480,
            74520,
            76140,
            78000,
            79800,
            81660,
            83400
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_bus_24",
      "sourceRouteId": "vilnius_bus_24",
      "mode": "bus",
      "shortName": "24",
      "longName": "Fabijoniškės–Ukmergės g.–Žemieji Paneriai (Apylanka per P. Žadeikos g.)",
      "color": "0073AC",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_bus_24:0",
          "sourceRouteId": "vilnius_bus_24",
          "sourceShapeId": "vilnius_bus_24_a-b",
          "directionId": 0,
          "headsign": "Žemieji Paneriai (Apylanka per P. Žadeikos g.)",
          "directionName": "Fabijoniškės–Ukmergės g.–Žemieji Paneriai (Apylanka per P. Žadeikos g.)",
          "mode": "bus",
          "routeShortName": "24",
          "routeLongName": "Fabijoniškės–Ukmergės g.–Žemieji Paneriai (Apylanka per P. Žadeikos g.)",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              -2480.761,
              -5727.829,
              0
            ],
            [
              -2465.38,
              -5705.215,
              27.349
            ],
            [
              -2457.131,
              -5687.973,
              46.463
            ],
            [
              -2458.05,
              -5680.376,
              54.116
            ],
            [
              -2467.523,
              -5671.289,
              67.242
            ],
            [
              -2484.515,
              -5648.724,
              95.489
            ],
            [
              -2453.276,
              -5597.994,
              155.066
            ],
            [
              -2437.971,
              -5575.488,
              182.284
            ],
            [
              -2323.024,
              -5404.447,
              388.361
            ],
            [
              -2243.482,
              -5280.09,
              535.981
            ],
            [
              -2221.212,
              -5257.08,
              568.002
            ],
            [
              -2172.788,
              -5214.524,
              632.469
            ],
            [
              -2110.315,
              -5178.897,
              704.386
            ],
            [
              -2136.613,
              -5136.438,
              754.33
            ],
            [
              -2215.749,
              -4985.55,
              924.711
            ],
            [
              -2261.515,
              -4895.899,
              1025.368
            ],
            [
              -2303.85,
              -4831.475,
              1102.457
            ],
            [
              -2250.757,
              -4780.095,
              1176.34
            ],
            [
              -2246.649,
              -4770.794,
              1186.508
            ],
            [
              -2217.023,
              -4730.598,
              1236.442
            ],
            [
              -2199.094,
              -4664.123,
              1305.293
            ],
            [
              -2245.097,
              -4651.92,
              1352.887
            ],
            [
              -2248.369,
              -4645.437,
              1360.148
            ],
            [
              -2421.69,
              -4610.083,
              1537.038
            ],
            [
              -2609.045,
              -4566.695,
              1729.352
            ],
            [
              -2745.017,
              -4497.235,
              1882.038
            ],
            [
              -2770.825,
              -4531.174,
              1924.675
            ],
            [
              -2804.177,
              -4598.877,
              2000.147
            ],
            [
              -2799.786,
              -4605.634,
              2008.206
            ],
            [
              -2740.129,
              -4632.849,
              2073.777
            ],
            [
              -2740.424,
              -4632.704,
              2074.106
            ],
            [
              -2716.354,
              -4644.453,
              2100.891
            ],
            [
              -2663.277,
              -4659.378,
              2156.026
            ],
            [
              -2599.885,
              -4512.041,
              2316.422
            ],
            [
              -2575.776,
              -4470.432,
              2364.511
            ],
            [
              -2511.16,
              -4330.887,
              2518.29
            ],
            [
              -2380.854,
              -3977.381,
              2895.048
            ],
            [
              -2366.341,
              -3921.977,
              2952.321
            ],
            [
              -2313.476,
              -3774.854,
              3108.653
            ],
            [
              -2292.987,
              -3709.537,
              3177.109
            ],
            [
              -2280.97,
              -3679.424,
              3209.531
            ],
            [
              -2072.945,
              -3075.564,
              3848.218
            ],
            [
              -2040.52,
              -2976.08,
              3952.852
            ],
            [
              -2024.769,
              -2939.494,
              3992.685
            ],
            [
              -2004.312,
              -2876.403,
              4059.01
            ],
            [
              -1942.85,
              -2718.306,
              4228.634
            ],
            [
              -1911.924,
              -2646.496,
              4306.82
            ],
            [
              -1897.194,
              -2615.588,
              4341.059
            ],
            [
              -1889.264,
              -2604.597,
              4354.612
            ],
            [
              -1854.797,
              -2587.399,
              4393.131
            ],
            [
              -1805.935,
              -2485.853,
              4505.821
            ],
            [
              -1803.13,
              -2436.921,
              4554.834
            ],
            [
              -1757.32,
              -2362.039,
              4642.617
            ],
            [
              -1745.639,
              -2333.352,
              4673.591
            ],
            [
              -1727.311,
              -2305.799,
              4706.683
            ],
            [
              -1547.472,
              -2017.345,
              5046.606
            ],
            [
              -1343.434,
              -1674.784,
              5445.328
            ],
            [
              -1305.861,
              -1628.702,
              5504.787
            ],
            [
              -1268.647,
              -1602.651,
              5550.213
            ],
            [
              -1054.592,
              -1494.059,
              5790.237
            ],
            [
              -1027.103,
              -1471.176,
              5826.004
            ],
            [
              -1009.966,
              -1450.333,
              5852.988
            ],
            [
              -998.422,
              -1410.718,
              5894.25
            ],
            [
              -985.002,
              -1352.818,
              5953.685
            ],
            [
              -969.183,
              -1226.195,
              6081.293
            ],
            [
              -953.408,
              -1066.174,
              6242.089
            ],
            [
              -934.629,
              -918.453,
              6390.999
            ],
            [
              -924.604,
              -648.119,
              6661.519
            ],
            [
              -925.676,
              -600.231,
              6709.419
            ],
            [
              -929.003,
              -570.114,
              6739.719
            ],
            [
              -963.365,
              -407.756,
              6905.674
            ],
            [
              -999.484,
              -215.848,
              7100.951
            ],
            [
              -1016.316,
              -96.386,
              7221.593
            ],
            [
              -1024.059,
              -41.078,
              7277.441
            ],
            [
              -1032.456,
              167.59,
              7486.277
            ],
            [
              -1030.831,
              222.109,
              7540.82
            ],
            [
              -1020.545,
              292.057,
              7611.521
            ],
            [
              -1020.085,
              317.653,
              7637.121
            ],
            [
              -1024.702,
              347.793,
              7667.612
            ],
            [
              -1037.097,
              375.846,
              7698.282
            ],
            [
              -1053.401,
              401.744,
              7728.884
            ],
            [
              -1069.805,
              422.076,
              7755.009
            ],
            [
              -1102.209,
              449.376,
              7797.38
            ],
            [
              -1121.977,
              461.976,
              7820.822
            ],
            [
              -1146.339,
              470.206,
              7846.537
            ],
            [
              -1195.182,
              479.988,
              7896.35
            ],
            [
              -1304.163,
              480.469,
              8005.331
            ],
            [
              -1381.618,
              490.303,
              8083.409
            ],
            [
              -1420.535,
              501.837,
              8123.999
            ],
            [
              -1525.292,
              538.26,
              8234.907
            ],
            [
              -1569.626,
              549.783,
              8280.714
            ],
            [
              -1664.877,
              569.298,
              8377.943
            ],
            [
              -1735.414,
              582.536,
              8449.712
            ],
            [
              -1778.032,
              600.615,
              8496.006
            ],
            [
              -1818.632,
              630.433,
              8546.379
            ],
            [
              -1845.987,
              674.021,
              8597.84
            ],
            [
              -1887.023,
              766.31,
              8698.841
            ],
            [
              -2023.359,
              1241.737,
              9193.43
            ],
            [
              -2036.836,
              1282.052,
              9235.938
            ],
            [
              -2053.129,
              1320.26,
              9277.475
            ],
            [
              -2069.692,
              1357.221,
              9317.978
            ],
            [
              -2131.9,
              1450.721,
              9430.281
            ],
            [
              -2187.002,
              1508.471,
              9510.101
            ],
            [
              -2364.512,
              1685.273,
              9760.638
            ],
            [
              -2405.647,
              1730.529,
              9821.796
            ],
            [
              -2432.322,
              1754.377,
              9857.577
            ],
            [
              -2454.599,
              1782.57,
              9893.509
            ],
            [
              -2465.207,
              1807.407,
              9920.516
            ],
            [
              -2517.308,
              1910.614,
              10036.128
            ],
            [
              -2537.025,
              1963.282,
              10092.366
            ],
            [
              -2549.238,
              2002.46,
              10133.404
            ],
            [
              -2554.454,
              2035.948,
              10167.295
            ],
            [
              -2559.337,
              2088.355,
              10219.929
            ],
            [
              -2553.059,
              2151.698,
              10283.583
            ],
            [
              -2549.631,
              2181.469,
              10313.55
            ],
            [
              -2546.675,
              2206.576,
              10338.831
            ],
            [
              -2548.769,
              2256.45,
              10388.749
            ],
            [
              -2553.934,
              2289.911,
              10422.606
            ],
            [
              -2570.383,
              2352.49,
              10487.311
            ],
            [
              -2586.213,
              2430.585,
              10566.994
            ],
            [
              -2602.898,
              2582.275,
              10719.599
            ],
            [
              -2619.569,
              2661.607,
              10800.664
            ],
            [
              -2672.012,
              2798.342,
              10947.111
            ],
            [
              -2693.846,
              2841.028,
              10995.057
            ],
            [
              -2698.439,
              2873.392,
              11027.745
            ],
            [
              -2831.804,
              3253.114,
              11430.206
            ],
            [
              -2853.662,
              3294.686,
              11477.174
            ],
            [
              -2869.962,
              3320.622,
              11507.807
            ],
            [
              -2887.849,
              3332.714,
              11529.398
            ],
            [
              -2904.222,
              3355.687,
              11557.608
            ],
            [
              -3126.24,
              3576.651,
              11870.845
            ],
            [
              -3256.351,
              3702.491,
              12051.855
            ],
            [
              -3334.924,
              3786.24,
              12166.692
            ],
            [
              -3406.008,
              3855.385,
              12265.858
            ],
            [
              -3427.01,
              3872.449,
              12292.919
            ],
            [
              -3454.8,
              3907.442,
              12337.604
            ],
            [
              -3626.746,
              4078.528,
              12580.165
            ],
            [
              -3781.512,
              4235.95,
              12800.923
            ],
            [
              -3884.317,
              4337.92,
              12945.722
            ],
            [
              -3915.514,
              4362.95,
              12985.719
            ],
            [
              -3928.112,
              4380.98,
              13007.715
            ],
            [
              -4226.292,
              4683.356,
              13432.382
            ],
            [
              -4305.622,
              4762.647,
              13544.544
            ],
            [
              -4338.114,
              4787.696,
              13585.571
            ],
            [
              -4349.425,
              4805.702,
              13606.835
            ],
            [
              -4420.502,
              4877.057,
              13707.55
            ],
            [
              -4439.501,
              4898.534,
              13736.224
            ],
            [
              -4461.157,
              4915.604,
              13763.799
            ],
            [
              -4476.532,
              4922.548,
              13780.669
            ],
            [
              -4485.887,
              4927.855,
              13791.425
            ],
            [
              -4508.363,
              4948.698,
              13822.077
            ],
            [
              -4600.366,
              5004.825,
              13929.849
            ],
            [
              -4658.205,
              5020.288,
              13989.72
            ],
            [
              -4736.87,
              5026.089,
              14068.598
            ],
            [
              -4780.797,
              5023.521,
              14112.6
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:1158",
              "position": {
                "x": -2456.526,
                "z": -5595.784
              },
              "distanceAlongShapeM": 155.066,
              "shapeOffsetM": 3.93,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:6914",
              "position": {
                "x": -2139.87,
                "z": -5138.296
              },
              "distanceAlongShapeM": 754.33,
              "shapeOffsetM": 3.749,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:5803",
              "position": {
                "x": -2249.272,
                "z": -4768.989
              },
              "distanceAlongShapeM": 1186.508,
              "shapeOffsetM": 3.184,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:8269",
              "position": {
                "x": -2245.99,
                "z": -4656.611
              },
              "distanceAlongShapeM": 1352.547,
              "shapeOffsetM": 4.764,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:364",
              "position": {
                "x": -2737.686,
                "z": -4627.879
              },
              "distanceAlongShapeM": 2074.45,
              "shapeOffsetM": 5.537,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:7896",
              "position": {
                "x": -2601.622,
                "z": -4511.165
              },
              "distanceAlongShapeM": 2316.422,
              "shapeOffsetM": 1.945,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:5450",
              "position": {
                "x": -2366.341,
                "z": -3921.977
              },
              "distanceAlongShapeM": 2952.321,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:5451",
              "position": {
                "x": -2289.819,
                "z": -3676.197
              },
              "distanceAlongShapeM": 3209.248,
              "shapeOffsetM": 9.414,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:5452",
              "position": {
                "x": -2044.086,
                "z": -2974.773
              },
              "distanceAlongShapeM": 3952.852,
              "shapeOffsetM": 3.798,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:5214",
              "position": {
                "x": -1747.763,
                "z": -2332.152
              },
              "distanceAlongShapeM": 4673.591,
              "shapeOffsetM": 2.44,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:5220",
              "position": {
                "x": -1001.511,
                "z": -1410.409
              },
              "distanceAlongShapeM": 5893.683,
              "shapeOffsetM": 3.052,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:5774",
              "position": {
                "x": -1029.126,
                "z": -41.756
              },
              "distanceAlongShapeM": 7277.441,
              "shapeOffsetM": 5.112,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:5778",
              "position": {
                "x": -2055.531,
                "z": 1319.12
              },
              "distanceAlongShapeM": 9277.369,
              "shapeOffsetM": 2.657,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            },
            {
              "stopId": "judu:stop:5779",
              "position": {
                "x": -2457.669,
                "z": 1780.429
              },
              "distanceAlongShapeM": 9893.509,
              "shapeOffsetM": 3.743,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            },
            {
              "stopId": "judu:stop:7358",
              "position": {
                "x": -2553.368,
                "z": 2207.364
              },
              "distanceAlongShapeM": 10339.899,
              "shapeOffsetM": 6.654,
              "arrivalOffsetSeconds": 1500,
              "departureOffsetSeconds": 1500
            },
            {
              "stopId": "judu:stop:5543",
              "position": {
                "x": -2693.846,
                "z": 2841.028
              },
              "distanceAlongShapeM": 10995.057,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1620,
              "departureOffsetSeconds": 1620
            },
            {
              "stopId": "judu:stop:5573",
              "position": {
                "x": -2888.502,
                "z": 3332.034
              },
              "distanceAlongShapeM": 11529.398,
              "shapeOffsetM": 0.943,
              "arrivalOffsetSeconds": 1740,
              "departureOffsetSeconds": 1740
            },
            {
              "stopId": "judu:stop:5587",
              "position": {
                "x": -3427.01,
                "z": 3872.449
              },
              "distanceAlongShapeM": 12292.919,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1860,
              "departureOffsetSeconds": 1860
            },
            {
              "stopId": "judu:stop:5588",
              "position": {
                "x": -3915.514,
                "z": 4362.95
              },
              "distanceAlongShapeM": 12985.719,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1920,
              "departureOffsetSeconds": 1920
            },
            {
              "stopId": "judu:stop:5554",
              "position": {
                "x": -4338.114,
                "z": 4787.696
              },
              "distanceAlongShapeM": 13585.571,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2040,
              "departureOffsetSeconds": 2040
            },
            {
              "stopId": "judu:stop:5567",
              "position": {
                "x": -4488.111,
                "z": 4924.973
              },
              "distanceAlongShapeM": 13791.425,
              "shapeOffsetM": 3.641,
              "arrivalOffsetSeconds": 2100,
              "departureOffsetSeconds": 2100
            },
            {
              "stopId": "judu:stop:5557",
              "position": {
                "x": -4780.873,
                "z": 5020.164
              },
              "distanceAlongShapeM": 14112.6,
              "shapeOffsetM": 3.358,
              "arrivalOffsetSeconds": 2100,
              "departureOffsetSeconds": 2100
            }
          ],
          "departuresSeconds": [
            18660,
            19860,
            21060,
            22260,
            23460,
            24240,
            25200,
            26220,
            27120,
            28020,
            28800,
            29940,
            31080,
            32280,
            33960,
            35760,
            37860,
            40680,
            43380,
            45900,
            48660,
            50160,
            51780,
            53100,
            54840,
            55740,
            57180,
            58080,
            58980,
            59880,
            61200,
            61800,
            63180,
            64440,
            65940,
            67620,
            69840,
            71760,
            74820,
            77280,
            79800,
            82080
          ]
        },
        {
          "id": "judu:pattern:vilnius_bus_24:1",
          "sourceRouteId": "vilnius_bus_24",
          "sourceShapeId": "vilnius_bus_24_b-a",
          "directionId": 1,
          "headsign": "Fabijoniškės (Apylanka per P. Žadeikos g.)",
          "directionName": "Žemieji Paneriai–Ukmergės g.–Fabijoniškės (Apylanka per P. Žadeikos g.)",
          "mode": "bus",
          "routeShortName": "24",
          "routeLongName": "Fabijoniškės–Ukmergės g.–Žemieji Paneriai (Apylanka per P. Žadeikos g.)",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              -4780.797,
              5023.521,
              0
            ],
            [
              -4794.293,
              5028.186,
              14.28
            ],
            [
              -4887.841,
              5032.012,
              107.906
            ],
            [
              -4834.705,
              5081.197,
              180.312
            ],
            [
              -4785.441,
              5130.448,
              249.972
            ],
            [
              -4754.629,
              5157.75,
              291.14
            ],
            [
              -4724.691,
              5171.709,
              324.172
            ],
            [
              -4669.049,
              5178.483,
              380.225
            ],
            [
              -4632.924,
              5176.815,
              416.389
            ],
            [
              -4600.447,
              5171.052,
              449.373
            ],
            [
              -4586.132,
              5157.088,
              469.371
            ],
            [
              -4583.042,
              5111.394,
              515.169
            ],
            [
              -4580.889,
              5011.17,
              615.417
            ],
            [
              -4518.9,
              4977.81,
              685.812
            ],
            [
              -4503.635,
              4960.862,
              708.621
            ],
            [
              -4444.377,
              4915.316,
              783.36
            ],
            [
              -4189.698,
              4671.592,
              1135.87
            ],
            [
              -4167.195,
              4657.338,
              1162.507
            ],
            [
              -4146.524,
              4629.659,
              1197.053
            ],
            [
              -4048.773,
              4533.349,
              1334.278
            ],
            [
              -3823.59,
              4303.471,
              1656.072
            ],
            [
              -3802.623,
              4284.184,
              1684.561
            ],
            [
              -3780.952,
              4268.223,
              1711.475
            ],
            [
              -3768.394,
              4247.967,
              1735.308
            ],
            [
              -3367.467,
              3844.694,
              2303.966
            ],
            [
              -3344.636,
              3829.677,
              2331.293
            ],
            [
              -3315.43,
              3793.692,
              2377.639
            ],
            [
              -3282.402,
              3763.059,
              2422.686
            ],
            [
              -3142.94,
              3618.132,
              2623.816
            ],
            [
              -2996.449,
              3469.738,
              2832.336
            ],
            [
              -2905.063,
              3381.305,
              2959.504
            ],
            [
              -2851.864,
              3323.598,
              3037.991
            ],
            [
              -2827.523,
              3276.416,
              3091.082
            ],
            [
              -2808.656,
              3248.254,
              3124.98
            ],
            [
              -2806.545,
              3221.5,
              3151.817
            ],
            [
              -2772.86,
              3118.493,
              3260.192
            ],
            [
              -2707,
              2936.995,
              3453.27
            ],
            [
              -2660.341,
              2801.476,
              3596.596
            ],
            [
              -2637.179,
              2724.257,
              3677.214
            ],
            [
              -2612.218,
              2675.949,
              3731.59
            ],
            [
              -2598.361,
              2620.045,
              3789.185
            ],
            [
              -2580.849,
              2536.2,
              3874.84
            ],
            [
              -2576.299,
              2480.505,
              3930.72
            ],
            [
              -2568.347,
              2419.138,
              3992.6
            ],
            [
              -2533.425,
              2235.542,
              4179.488
            ],
            [
              -2536.272,
              2210.698,
              4204.494
            ],
            [
              -2548.095,
              2140.478,
              4275.703
            ],
            [
              -2550.229,
              2092.648,
              4323.581
            ],
            [
              -2549.196,
              2041.422,
              4374.817
            ],
            [
              -2537.883,
              1987.788,
              4429.631
            ],
            [
              -2509.509,
              1913.816,
              4508.858
            ],
            [
              -2480.295,
              1850.96,
              4578.172
            ],
            [
              -2442.052,
              1787.945,
              4651.883
            ],
            [
              -2376.353,
              1708.86,
              4754.698
            ],
            [
              -2337.094,
              1666.977,
              4812.104
            ],
            [
              -2299.874,
              1633.438,
              4862.206
            ],
            [
              -2280.351,
              1614.353,
              4889.507
            ],
            [
              -2250.859,
              1581.961,
              4933.314
            ],
            [
              -2130.979,
              1466.289,
              5099.901
            ],
            [
              -2084.281,
              1407.574,
              5174.922
            ],
            [
              -2039.718,
              1337.764,
              5257.743
            ],
            [
              -1998.617,
              1254.657,
              5350.458
            ],
            [
              -1968.033,
              1160.603,
              5449.36
            ],
            [
              -1951.907,
              1087.958,
              5523.773
            ],
            [
              -1939.203,
              1004.241,
              5608.448
            ],
            [
              -1908.784,
              853.508,
              5762.22
            ],
            [
              -1846.555,
              699.713,
              5928.128
            ],
            [
              -1780.01,
              619.005,
              6032.732
            ],
            [
              -1664.877,
              569.298,
              6158.137
            ],
            [
              -1541.563,
              550.755,
              6282.837
            ],
            [
              -1445.343,
              521.205,
              6383.492
            ],
            [
              -1378.584,
              503.312,
              6452.608
            ],
            [
              -1309.128,
              492.05,
              6522.971
            ],
            [
              -1189.179,
              491.013,
              6642.924
            ],
            [
              -1157.04,
              484.87,
              6675.645
            ],
            [
              -1128.85,
              474.345,
              6705.736
            ],
            [
              -1096.911,
              457.073,
              6742.046
            ],
            [
              -1065.072,
              434.237,
              6781.228
            ],
            [
              -1037.302,
              400.341,
              6825.047
            ],
            [
              -1011.162,
              347.549,
              6883.956
            ],
            [
              -1004.851,
              304.02,
              6927.94
            ],
            [
              -1003.617,
              265.035,
              6966.945
            ],
            [
              -1009.735,
              211.71,
              7020.619
            ],
            [
              -1014.4,
              131.642,
              7100.823
            ],
            [
              -1015.115,
              55.956,
              7176.513
            ],
            [
              -1007.35,
              -14.317,
              7247.213
            ],
            [
              -998.225,
              -59.455,
              7293.264
            ],
            [
              -996.422,
              -87.987,
              7321.853
            ],
            [
              -985.29,
              -186.151,
              7420.646
            ],
            [
              -968.032,
              -302.237,
              7538.008
            ],
            [
              -951.323,
              -377.124,
              7614.737
            ],
            [
              -922.383,
              -488.967,
              7730.263
            ],
            [
              -908.595,
              -582.727,
              7825.032
            ],
            [
              -906.947,
              -663.997,
              7906.318
            ],
            [
              -915.606,
              -793,
              8035.612
            ],
            [
              -919.543,
              -904.252,
              8146.933
            ],
            [
              -904.723,
              -968.011,
              8212.392
            ],
            [
              -906.763,
              -1018.032,
              8262.455
            ],
            [
              -903.416,
              -1047.036,
              8291.651
            ],
            [
              -878.9,
              -1081.988,
              8334.344
            ],
            [
              -875.273,
              -1095.412,
              8348.249
            ],
            [
              -879.138,
              -1130.965,
              8384.012
            ],
            [
              -892.47,
              -1155.216,
              8411.686
            ],
            [
              -917.464,
              -1182.597,
              8448.759
            ],
            [
              -926.283,
              -1206.929,
              8474.64
            ],
            [
              -917.431,
              -1323.977,
              8592.022
            ],
            [
              -911.942,
              -1448.758,
              8716.924
            ],
            [
              -922.391,
              -1491.986,
              8761.397
            ],
            [
              -939.829,
              -1529.521,
              8802.785
            ],
            [
              -961.618,
              -1558.073,
              8838.701
            ],
            [
              -995.732,
              -1590.856,
              8886.013
            ],
            [
              -1026.383,
              -1610.342,
              8922.334
            ],
            [
              -1072.441,
              -1626.213,
              8971.05
            ],
            [
              -1262.636,
              -1662.874,
              9164.746
            ],
            [
              -1320.472,
              -1688.554,
              9228.027
            ],
            [
              -1382.029,
              -1741.999,
              9309.548
            ],
            [
              -1597.414,
              -2106.624,
              9733.036
            ],
            [
              -1645.063,
              -2175.906,
              9817.121
            ],
            [
              -1682.619,
              -2257.615,
              9907.048
            ],
            [
              -1702.963,
              -2314.026,
              9967.015
            ],
            [
              -1715.793,
              -2345.231,
              10000.756
            ],
            [
              -1755.799,
              -2415.464,
              10081.582
            ],
            [
              -1791.442,
              -2468.3,
              10145.317
            ],
            [
              -1838.817,
              -2558.74,
              10247.414
            ],
            [
              -1870.823,
              -2630.339,
              10325.841
            ],
            [
              -1876.019,
              -2641.711,
              10338.344
            ],
            [
              -1912.507,
              -2715.506,
              10420.667
            ],
            [
              -1995.657,
              -2933.332,
              10653.824
            ],
            [
              -2020.861,
              -3009.696,
              10734.24
            ],
            [
              -2029.851,
              -3041.625,
              10767.41
            ],
            [
              -2244.442,
              -3639.648,
              11402.769
            ],
            [
              -2268.114,
              -3687.714,
              11456.348
            ],
            [
              -2346.702,
              -3915.499,
              11697.308
            ],
            [
              -2363.609,
              -3964.478,
              11749.123
            ],
            [
              -2466.817,
              -4247.487,
              12050.364
            ],
            [
              -2539.058,
              -4427.617,
              12244.44
            ],
            [
              -2559.838,
              -4475.922,
              12297.025
            ],
            [
              -2571.739,
              -4497.221,
              12321.424
            ],
            [
              -2635.224,
              -4626.347,
              12465.312
            ],
            [
              -2636.28,
              -4649.706,
              12488.695
            ],
            [
              -2631.949,
              -4659.802,
              12499.681
            ],
            [
              -2592.254,
              -4673.861,
              12541.792
            ],
            [
              -2567.235,
              -4679.869,
              12567.522
            ],
            [
              -2547.659,
              -4684.927,
              12587.741
            ],
            [
              -2514.956,
              -4692.987,
              12621.423
            ],
            [
              -2465.325,
              -4709.501,
              12673.729
            ],
            [
              -2409.103,
              -4736.1,
              12735.926
            ],
            [
              -2349.957,
              -4779.45,
              12809.257
            ],
            [
              -2306.893,
              -4821.402,
              12869.378
            ],
            [
              -2285.316,
              -4847.778,
              12903.455
            ],
            [
              -2241.672,
              -4921.636,
              12989.244
            ],
            [
              -2239.148,
              -4925.337,
              12993.724
            ],
            [
              -2217.405,
              -4969.935,
              13043.34
            ],
            [
              -2110.315,
              -5178.897,
              13278.145
            ],
            [
              -2127.276,
              -5190.841,
              13298.889
            ],
            [
              -2145.02,
              -5203.693,
              13320.799
            ],
            [
              -2175.503,
              -5222.268,
              13356.495
            ],
            [
              -2204.955,
              -5248.463,
              13395.911
            ],
            [
              -2230.543,
              -5274.726,
              13432.578
            ],
            [
              -2512.326,
              -5691.648,
              13935.794
            ],
            [
              -2515.223,
              -5708.154,
              13952.552
            ],
            [
              -2529.5,
              -5729.639,
              13978.348
            ],
            [
              -2529.407,
              -5747.007,
              13995.716
            ],
            [
              -2525.623,
              -5751.527,
              14001.611
            ],
            [
              -2510.288,
              -5758.477,
              14018.447
            ],
            [
              -2499.033,
              -5756.062,
              14029.958
            ],
            [
              -2480.761,
              -5727.829,
              14063.589
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:5557",
              "position": {
                "x": -4780.873,
                "z": 5020.164
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 3.358,
              "arrivalOffsetSeconds": -570,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:5594",
              "position": {
                "x": -4669.05,
                "z": 5178.548
              },
              "distanceAlongShapeM": 380.225,
              "shapeOffsetM": 0.065,
              "arrivalOffsetSeconds": 60,
              "departureOffsetSeconds": 60
            },
            {
              "stopId": "judu:stop:6850",
              "position": {
                "x": -4517.509,
                "z": 4980.025
              },
              "distanceAlongShapeM": 685.812,
              "shapeOffsetM": 2.616,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:6851",
              "position": {
                "x": -4166.695,
                "z": 4657.837
              },
              "distanceAlongShapeM": 1162.507,
              "shapeOffsetM": 0.707,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:5546",
              "position": {
                "x": -3780.952,
                "z": 4268.223
              },
              "distanceAlongShapeM": 1711.475,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:9384",
              "position": {
                "x": -3344.49,
                "z": 3829.822
              },
              "distanceAlongShapeM": 2331.293,
              "shapeOffsetM": 0.206,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:857",
              "position": {
                "x": -2808.656,
                "z": 3248.254
              },
              "distanceAlongShapeM": 3124.98,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:5542",
              "position": {
                "x": -2612.218,
                "z": 2675.949
              },
              "distanceAlongShapeM": 3731.59,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:7359",
              "position": {
                "x": -2530.947,
                "z": 2234.799
              },
              "distanceAlongShapeM": 4179.944,
              "shapeOffsetM": 2.546,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:5780",
              "position": {
                "x": -2295.02,
                "z": 1638.403
              },
              "distanceAlongShapeM": 4862.206,
              "shapeOffsetM": 6.943,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:474",
              "position": {
                "x": -995.257,
                "z": -59.064
              },
              "distanceAlongShapeM": 7293.264,
              "shapeOffsetM": 2.993,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:5534",
              "position": {
                "x": -902.638,
                "z": -968.011
              },
              "distanceAlongShapeM": 8212.392,
              "shapeOffsetM": 2.085,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:5290",
              "position": {
                "x": -1711.936,
                "z": -2347.263
              },
              "distanceAlongShapeM": 10000.756,
              "shapeOffsetM": 4.36,
              "arrivalOffsetSeconds": 1380,
              "departureOffsetSeconds": 1380
            },
            {
              "stopId": "judu:stop:1039",
              "position": {
                "x": -1871.271,
                "z": -2643.88
              },
              "distanceAlongShapeM": 10338.344,
              "shapeOffsetM": 5.22,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            },
            {
              "stopId": "judu:stop:986",
              "position": {
                "x": -2025.964,
                "z": -3043.002
              },
              "distanceAlongShapeM": 10767.41,
              "shapeOffsetM": 4.124,
              "arrivalOffsetSeconds": 1500,
              "departureOffsetSeconds": 1500
            },
            {
              "stopId": "judu:stop:4388",
              "position": {
                "x": -2242.142,
                "z": -3640.305
              },
              "distanceAlongShapeM": 11402.611,
              "shapeOffsetM": 2.386,
              "arrivalOffsetSeconds": 1620,
              "departureOffsetSeconds": 1620
            },
            {
              "stopId": "judu:stop:823",
              "position": {
                "x": -2360.668,
                "z": -3965.493
              },
              "distanceAlongShapeM": 11749.123,
              "shapeOffsetM": 3.112,
              "arrivalOffsetSeconds": 1680,
              "departureOffsetSeconds": 1680
            },
            {
              "stopId": "judu:stop:7897",
              "position": {
                "x": -2556.572,
                "z": -4477.451
              },
              "distanceAlongShapeM": 12297.025,
              "shapeOffsetM": 3.606,
              "arrivalOffsetSeconds": 1740,
              "departureOffsetSeconds": 1740
            },
            {
              "stopId": "judu:stop:6911",
              "position": {
                "x": -2236.559,
                "z": -4923.953
              },
              "distanceAlongShapeM": 12993.724,
              "shapeOffsetM": 2.936,
              "arrivalOffsetSeconds": 1920,
              "departureOffsetSeconds": 1920
            },
            {
              "stopId": "judu:stop:6915",
              "position": {
                "x": -2143.028,
                "z": -5207.26
              },
              "distanceAlongShapeM": 13320.954,
              "shapeOffsetM": 4.083,
              "arrivalOffsetSeconds": 1980,
              "departureOffsetSeconds": 1980
            },
            {
              "stopId": "judu:stop:5512",
              "position": {
                "x": -2513.285,
                "z": -5709.442
              },
              "distanceAlongShapeM": 13952.552,
              "shapeOffsetM": 2.327,
              "arrivalOffsetSeconds": 2100,
              "departureOffsetSeconds": 2100
            }
          ],
          "departuresSeconds": [
            18540,
            19740,
            21000,
            22500,
            23760,
            24960,
            26100,
            27060,
            28020,
            29040,
            29940,
            30900,
            31740,
            32700,
            34020,
            35280,
            36780,
            38160,
            40860,
            43380,
            46080,
            48600,
            51300,
            52560,
            54600,
            56040,
            57540,
            58560,
            60120,
            61020,
            62040,
            63060,
            64140,
            64740,
            66240,
            67560,
            68940,
            70320,
            72420,
            74460,
            77040,
            79500,
            82320,
            84300
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_bus_25",
      "sourceRouteId": "vilnius_bus_25",
      "mode": "bus",
      "shortName": "25",
      "longName": "Žemieji Paneriai–Kazbėjų–V. A. Graičiūno g.–Vaidotai",
      "color": "0073AC",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_bus_25:0",
          "sourceRouteId": "vilnius_bus_25",
          "sourceShapeId": "vilnius_bus_25_a-b",
          "directionId": 0,
          "headsign": "Vaidotai",
          "directionName": "Žemieji Paneriai–Kazbėjų–V. A. Graičiūno g.–Vaidotai",
          "mode": "bus",
          "routeShortName": "25",
          "routeLongName": "Žemieji Paneriai–Kazbėjų–V. A. Graičiūno g.–Vaidotai",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              -4326.297,
              4774.12,
              0
            ],
            [
              -4341.701,
              4789.561,
              21.811
            ],
            [
              -4357.738,
              4810.298,
              48.026
            ],
            [
              -4435.232,
              4883.989,
              154.963
            ],
            [
              -4468.845,
              4919.076,
              203.553
            ],
            [
              -4486.139,
              4928.009,
              223.018
            ],
            [
              -4510.925,
              4949.856,
              256.058
            ],
            [
              -4579.258,
              4993.33,
              337.048
            ],
            [
              -4600.366,
              5004.825,
              361.083
            ],
            [
              -4835.366,
              5155.793,
              640.397
            ],
            [
              -5032.11,
              5279.379,
              872.736
            ],
            [
              -5271.713,
              5427.062,
              1154.197
            ],
            [
              -5460.164,
              5546.035,
              1377.061
            ],
            [
              -5507.478,
              5573.554,
              1431.796
            ],
            [
              -5539.526,
              5587.456,
              1466.729
            ],
            [
              -5570.341,
              5597.997,
              1499.297
            ],
            [
              -5599.939,
              5604.064,
              1529.51
            ],
            [
              -5632.195,
              5605.723,
              1561.809
            ],
            [
              -5666.482,
              5601.851,
              1596.314
            ],
            [
              -5724.289,
              5581.678,
              1657.54
            ],
            [
              -5767.933,
              5559.039,
              1706.706
            ],
            [
              -5844.413,
              5503.558,
              1801.191
            ],
            [
              -5862.75,
              5488.283,
              1825.056
            ],
            [
              -5911.642,
              5422.317,
              1907.166
            ],
            [
              -5931.13,
              5377.005,
              1956.491
            ],
            [
              -5950.367,
              5308.312,
              2027.826
            ],
            [
              -5960.48,
              5282.88,
              2055.195
            ],
            [
              -5972.455,
              5261.931,
              2079.325
            ],
            [
              -5985.57,
              5249.907,
              2097.118
            ],
            [
              -6003.755,
              5243.534,
              2116.387
            ],
            [
              -6024.466,
              5240.544,
              2137.313
            ],
            [
              -6043.418,
              5245.327,
              2156.86
            ],
            [
              -6066.047,
              5261.363,
              2184.594
            ],
            [
              -6086.896,
              5290.575,
              2220.483
            ],
            [
              -6284.365,
              5565.511,
              2558.986
            ],
            [
              -6384.618,
              5670.718,
              2704.31
            ],
            [
              -6399.757,
              5685.605,
              2725.542
            ],
            [
              -6425.222,
              5713.7,
              2763.461
            ],
            [
              -6633.66,
              5914.22,
              3052.692
            ],
            [
              -6722.128,
              5991.393,
              3170.09
            ],
            [
              -6750.44,
              6004.56,
              3201.314
            ],
            [
              -6809.039,
              6038.832,
              3269.199
            ],
            [
              -6882.79,
              6076.446,
              3351.988
            ],
            [
              -6955.867,
              6108.831,
              3431.919
            ],
            [
              -7039.365,
              6135.823,
              3519.672
            ],
            [
              -7206.108,
              6166.42,
              3689.199
            ],
            [
              -7774.707,
              6263.751,
              4266.068
            ],
            [
              -7867.343,
              6285.312,
              4361.18
            ],
            [
              -8047.971,
              6336.143,
              4548.824
            ],
            [
              -8098.629,
              6343.525,
              4600.017
            ],
            [
              -8217.003,
              6398.476,
              4730.524
            ],
            [
              -8626.991,
              6549.307,
              5167.376
            ],
            [
              -8792.345,
              6604.692,
              5341.76
            ],
            [
              -8874.082,
              6622.063,
              5425.322
            ],
            [
              -8982.049,
              6627.08,
              5533.405
            ],
            [
              -8997.056,
              6618.566,
              5550.659
            ],
            [
              -9013.93,
              6623.266,
              5568.175
            ],
            [
              -9016.342,
              6639.281,
              5584.371
            ],
            [
              -9018.873,
              6651.963,
              5597.303
            ],
            [
              -9005.179,
              6664.131,
              5615.622
            ],
            [
              -9000.031,
              6680.014,
              5632.319
            ],
            [
              -8987.422,
              6704.318,
              5659.699
            ],
            [
              -8845.746,
              7014.942,
              6001.106
            ],
            [
              -8802.47,
              7117.645,
              6112.555
            ],
            [
              -8787.862,
              7152.128,
              6150.005
            ],
            [
              -8758.246,
              7215.999,
              6220.408
            ],
            [
              -8724.175,
              7285.575,
              6297.878
            ],
            [
              -8528.627,
              7712.077,
              6767.072
            ],
            [
              -8517.725,
              7736.63,
              6793.937
            ],
            [
              -8524.884,
              7783.259,
              6841.112
            ],
            [
              -8711.68,
              7975.533,
              7109.183
            ],
            [
              -8818.661,
              8089.357,
              7265.39
            ],
            [
              -8834.969,
              8101.095,
              7285.483
            ],
            [
              -8844.159,
              8112.007,
              7299.75
            ],
            [
              -8856.585,
              8122.595,
              7316.075
            ],
            [
              -8874.579,
              8128.452,
              7334.998
            ],
            [
              -8883.049,
              8144.116,
              7352.805
            ],
            [
              -8891.107,
              8152.064,
              7364.124
            ],
            [
              -8901.353,
              8162.171,
              7378.516
            ],
            [
              -8903.113,
              8164.613,
              7381.526
            ],
            [
              -8899.245,
              8161.134,
              7386.728
            ],
            [
              -8884.525,
              8149.575,
              7405.445
            ],
            [
              -8863.19,
              8128.624,
              7435.347
            ],
            [
              -8855.958,
              8121.472,
              7445.518
            ],
            [
              -8782.069,
              8052.247,
              7546.768
            ],
            [
              -8601.132,
              7861.308,
              7809.819
            ],
            [
              -8498.014,
              7756.965,
              7956.519
            ],
            [
              -8433.595,
              7842.359,
              8063.487
            ],
            [
              -8365.648,
              7922.035,
              8168.2
            ],
            [
              -8148.281,
              8215.026,
              8533.018
            ],
            [
              -7994.188,
              8416.174,
              8786.406
            ],
            [
              -7916.015,
              8513.562,
              8911.287
            ],
            [
              -7892.232,
              8545.453,
              8951.07
            ],
            [
              -7848.956,
              8605.402,
              9025.008
            ],
            [
              -7837.67,
              8619.926,
              9043.401
            ],
            [
              -7568.726,
              8965.362,
              9481.187
            ],
            [
              -7498.5,
              9062.708,
              9601.22
            ],
            [
              -7378.373,
              9211.873,
              9792.742
            ],
            [
              -7330.726,
              9251.97,
              9855.016
            ],
            [
              -7300.013,
              9272.612,
              9892.021
            ],
            [
              -7148.059,
              9315.5,
              10049.912
            ],
            [
              -7084.679,
              9313.49,
              10113.324
            ],
            [
              -7052.94,
              9312.28,
              10145.086
            ],
            [
              -6942.322,
              9309.401,
              10255.74
            ],
            [
              -6868.127,
              9308.051,
              10329.948
            ],
            [
              -6751.719,
              9369.261,
              10461.468
            ],
            [
              -6640.226,
              9428.626,
              10587.781
            ],
            [
              -6482.322,
              9499.662,
              10760.927
            ],
            [
              -6332.196,
              9572.575,
              10927.823
            ],
            [
              -5992.713,
              9773.992,
              11322.56
            ],
            [
              -6015.502,
              9793.234,
              11352.386
            ],
            [
              -6051.294,
              9819.463,
              11396.761
            ],
            [
              -6392.311,
              10068.737,
              11819.17
            ],
            [
              -6411.379,
              10089.811,
              11847.59
            ],
            [
              -6418.418,
              10102.262,
              11861.893
            ],
            [
              -6415.455,
              10100.097,
              11865.563
            ],
            [
              -6411.468,
              10093.291,
              11873.451
            ],
            [
              -6400.197,
              10079.006,
              11891.647
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:5567",
              "position": {
                "x": -4488.111,
                "z": 4924.973
              },
              "distanceAlongShapeM": 223.018,
              "shapeOffsetM": 3.62,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:5728",
              "position": {
                "x": -6069.366,
                "z": 5257.998
              },
              "distanceAlongShapeM": 2184.594,
              "shapeOffsetM": 4.727,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:5732",
              "position": {
                "x": -6403.151,
                "z": 5682.161
              },
              "distanceAlongShapeM": 2725.542,
              "shapeOffsetM": 4.835,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:5738",
              "position": {
                "x": -6754.294,
                "z": 5998.609
              },
              "distanceAlongShapeM": 3201.636,
              "shapeOffsetM": 7.082,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:5742",
              "position": {
                "x": -8100.928,
                "z": 6335.897
              },
              "distanceAlongShapeM": 4600.017,
              "shapeOffsetM": 7.967,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:6450",
              "position": {
                "x": -8792.189,
                "z": 7154.212
              },
              "distanceAlongShapeM": 6150.075,
              "shapeOffsetM": 4.802,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:7180",
              "position": {
                "x": -8897.56,
                "z": 8145.522
              },
              "distanceAlongShapeM": 7364.124,
              "shapeOffsetM": 9.189,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:6454",
              "position": {
                "x": -8437.312,
                "z": 7845.283
              },
              "distanceAlongShapeM": 8063.487,
              "shapeOffsetM": 4.729,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:6455",
              "position": {
                "x": -8152.148,
                "z": 8217.989
              },
              "distanceAlongShapeM": 8533.019,
              "shapeOffsetM": 4.871,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:10577",
              "position": {
                "x": -7995.129,
                "z": 8416.901
              },
              "distanceAlongShapeM": 8786.406,
              "shapeOffsetM": 1.189,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            },
            {
              "stopId": "judu:stop:6457",
              "position": {
                "x": -7842.491,
                "z": 8623.672
              },
              "distanceAlongShapeM": 9043.401,
              "shapeOffsetM": 6.105,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:16749",
              "position": {
                "x": -7499.264,
                "z": 9063.288
              },
              "distanceAlongShapeM": 9601.22,
              "shapeOffsetM": 0.959,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:5756",
              "position": {
                "x": -6020.289,
                "z": 9786.701
              },
              "distanceAlongShapeM": 11351.829,
              "shapeOffsetM": 8.08,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:3575",
              "position": {
                "x": -6388.113,
                "z": 10090.091
              },
              "distanceAlongShapeM": 11890.43,
              "shapeOffsetM": 16.353,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            }
          ],
          "departuresSeconds": [
            21840,
            25620,
            30120,
            36300,
            37740,
            40080,
            41760,
            43680,
            45480,
            47280,
            49260,
            51300,
            53100,
            54900,
            56880,
            58680,
            60900,
            63120,
            65340,
            69600,
            71700,
            73800,
            75600,
            77940,
            79260,
            82740
          ]
        },
        {
          "id": "judu:pattern:vilnius_bus_25:1",
          "sourceRouteId": "vilnius_bus_25",
          "sourceShapeId": "vilnius_bus_25_b-a",
          "directionId": 1,
          "headsign": "Žemieji Paneriai",
          "directionName": "Vaidotai–V. A. Graičiūno–Kazbėjų g.–Žemieji Paneriai",
          "mode": "bus",
          "routeShortName": "25",
          "routeLongName": "Žemieji Paneriai–Kazbėjų–V. A. Graičiūno g.–Vaidotai",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              -6400.197,
              10079.006,
              0
            ],
            [
              -6379.267,
              10060.308,
              28.066
            ],
            [
              -6368.178,
              10051.438,
              42.266
            ],
            [
              -6357.598,
              10043.903,
              55.255
            ],
            [
              -6353.692,
              10038.858,
              61.635
            ],
            [
              -5994.005,
              9774.014,
              508.308
            ],
            [
              -6407.76,
              9531.678,
              987.808
            ],
            [
              -6519.821,
              9480.295,
              1111.088
            ],
            [
              -6707.306,
              9397.463,
              1316.055
            ],
            [
              -6864.074,
              9309.058,
              1496.032
            ],
            [
              -6875.245,
              9306.696,
              1507.45
            ],
            [
              -6925.703,
              9314.902,
              1558.571
            ],
            [
              -7045.724,
              9311.97,
              1678.627
            ],
            [
              -7099.046,
              9313.866,
              1731.983
            ],
            [
              -7150.063,
              9313.543,
              1783.001
            ],
            [
              -7201.626,
              9302.091,
              1835.821
            ],
            [
              -7300.013,
              9272.612,
              1938.529
            ],
            [
              -7410.827,
              9175.372,
              2085.958
            ],
            [
              -7447.165,
              9126.992,
              2146.465
            ],
            [
              -7457.131,
              9110.459,
              2165.77
            ],
            [
              -7455.007,
              9108.639,
              2168.567
            ],
            [
              -7458.887,
              9103.531,
              2174.981
            ],
            [
              -7479.091,
              9076.934,
              2208.382
            ],
            [
              -7489.535,
              9063.185,
              2225.648
            ],
            [
              -7501.641,
              9047.243,
              2245.666
            ],
            [
              -7512.112,
              9033.326,
              2263.082
            ],
            [
              -7569.372,
              8965.373,
              2351.943
            ],
            [
              -7834.529,
              8612.804,
              2793.093
            ],
            [
              -7875.828,
              8560.769,
              2859.525
            ],
            [
              -7928.634,
              8492.619,
              2945.74
            ],
            [
              -7977.422,
              8427.028,
              3027.486
            ],
            [
              -7989.513,
              8411.021,
              3047.546
            ],
            [
              -8037.543,
              8351.919,
              3123.703
            ],
            [
              -8165.785,
              8180.923,
              3337.445
            ],
            [
              -8186.32,
              8154.127,
              3371.205
            ],
            [
              -8201.187,
              8134.568,
              3395.773
            ],
            [
              -8442.499,
              7819.956,
              3792.273
            ],
            [
              -8464.064,
              7791.963,
              3827.609
            ],
            [
              -8498.014,
              7756.965,
              3876.368
            ],
            [
              -8711.68,
              7975.533,
              4182.024
            ],
            [
              -8818.661,
              8089.357,
              4338.232
            ],
            [
              -8834.969,
              8101.095,
              4358.325
            ],
            [
              -8844.159,
              8112.007,
              4372.591
            ],
            [
              -8856.585,
              8122.595,
              4388.916
            ],
            [
              -8874.579,
              8128.452,
              4407.839
            ],
            [
              -8883.049,
              8144.116,
              4425.646
            ],
            [
              -8891.107,
              8152.064,
              4436.965
            ],
            [
              -8901.353,
              8162.171,
              4451.357
            ],
            [
              -8903.113,
              8164.613,
              4454.367
            ],
            [
              -8899.245,
              8161.134,
              4459.57
            ],
            [
              -8884.525,
              8149.575,
              4478.286
            ],
            [
              -8863.19,
              8128.624,
              4508.188
            ],
            [
              -8855.958,
              8121.472,
              4518.359
            ],
            [
              -8782.069,
              8052.247,
              4619.609
            ],
            [
              -8601.132,
              7861.308,
              4882.661
            ],
            [
              -8498.014,
              7756.965,
              5029.36
            ],
            [
              -8526.062,
              7710.922,
              5083.274
            ],
            [
              -8697.478,
              7338.573,
              5493.185
            ],
            [
              -8738.973,
              7242.662,
              5597.688
            ],
            [
              -8763.855,
              7190.801,
              5655.209
            ],
            [
              -8849.866,
              7005.89,
              5859.144
            ],
            [
              -8901.346,
              6891.167,
              5984.889
            ],
            [
              -8941.374,
              6805.245,
              6079.677
            ],
            [
              -8947.561,
              6791.798,
              6094.479
            ],
            [
              -8940.982,
              6755.011,
              6131.849
            ],
            [
              -8899.971,
              6720.713,
              6185.312
            ],
            [
              -8836.809,
              6672.936,
              6264.508
            ],
            [
              -8767.711,
              6632.854,
              6344.39
            ],
            [
              -8454.851,
              6491.959,
              6687.512
            ],
            [
              -8217.003,
              6398.476,
              6943.072
            ],
            [
              -8093.947,
              6355.277,
              7073.491
            ],
            [
              -8047.971,
              6336.143,
              7123.289
            ],
            [
              -7869.852,
              6289.806,
              7307.336
            ],
            [
              -7783.654,
              6269.464,
              7395.902
            ],
            [
              -7104.955,
              6152.496,
              8084.607
            ],
            [
              -6990.505,
              6122.766,
              8202.855
            ],
            [
              -6923.128,
              6097.155,
              8274.935
            ],
            [
              -6819.933,
              6050.909,
              8388.019
            ],
            [
              -6667.814,
              5949.093,
              8571.067
            ],
            [
              -6413.106,
              5704.591,
              8924.136
            ],
            [
              -6357.16,
              5652.447,
              9000.614
            ],
            [
              -6339.044,
              5634.784,
              9025.916
            ],
            [
              -6315.93,
              5608.341,
              9061.037
            ],
            [
              -6284.365,
              5565.511,
              9114.242
            ],
            [
              -6235.578,
              5510.146,
              9188.035
            ],
            [
              -6210.778,
              5487.465,
              9221.643
            ],
            [
              -6170.561,
              5460.073,
              9270.302
            ],
            [
              -6118.615,
              5439.162,
              9326.299
            ],
            [
              -6089.662,
              5433.109,
              9355.878
            ],
            [
              -6052.281,
              5429.14,
              9393.469
            ],
            [
              -6005.048,
              5435.024,
              9441.067
            ],
            [
              -5948.573,
              5452.996,
              9500.333
            ],
            [
              -5873.554,
              5498.484,
              9588.065
            ],
            [
              -5789.253,
              5558.286,
              9691.424
            ],
            [
              -5728.563,
              5596.222,
              9762.995
            ],
            [
              -5697.335,
              5610.165,
              9797.194
            ],
            [
              -5669.446,
              5617.486,
              9826.028
            ],
            [
              -5631.932,
              5621.303,
              9863.736
            ],
            [
              -5582.93,
              5617.134,
              9912.915
            ],
            [
              -5526.428,
              5598.366,
              9972.452
            ],
            [
              -5379.437,
              5509.043,
              10144.455
            ],
            [
              -4710.592,
              5090.204,
              10933.619
            ],
            [
              -4580.889,
              5011.17,
              11085.505
            ],
            [
              -4518.9,
              4977.81,
              11155.9
            ],
            [
              -4380.813,
              4857.45,
              11339.079
            ],
            [
              -4298.311,
              4774.766,
              11455.883
            ],
            [
              -4237.94,
              4719.179,
              11537.948
            ],
            [
              -4229.781,
              4705.68,
              11553.721
            ],
            [
              -4240.925,
              4695.853,
              11568.579
            ],
            [
              -4266.982,
              4719.679,
              11603.887
            ],
            [
              -4289.168,
              4743.439,
              11636.394
            ],
            [
              -4306.085,
              4753.859,
              11656.263
            ],
            [
              -4314.059,
              4761.853,
              11667.554
            ],
            [
              -4326.297,
              4774.12,
              11684.882
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:3575",
              "position": {
                "x": -6388.113,
                "z": 10090.091
              },
              "distanceAlongShapeM": 1.626,
              "shapeOffsetM": 16.317,
              "arrivalOffsetSeconds": -390,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:4531",
              "position": {
                "x": -7461.778,
                "z": 9063.783
              },
              "distanceAlongShapeM": 2208.382,
              "shapeOffsetM": 21.741,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:6458",
              "position": {
                "x": -7831.083,
                "z": 8610.126
              },
              "distanceAlongShapeM": 2793.093,
              "shapeOffsetM": 4.364,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:9298",
              "position": {
                "x": -7986.861,
                "z": 8408.973
              },
              "distanceAlongShapeM": 3047.546,
              "shapeOffsetM": 3.351,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:6456",
              "position": {
                "x": -8181.677,
                "z": 8150.569
              },
              "distanceAlongShapeM": 3371.228,
              "shapeOffsetM": 5.849,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:6469",
              "position": {
                "x": -8457.002,
                "z": 7786.606
              },
              "distanceAlongShapeM": 3827.543,
              "shapeOffsetM": 8.864,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:7180",
              "position": {
                "x": -8897.56,
                "z": 8145.522
              },
              "distanceAlongShapeM": 4436.965,
              "shapeOffsetM": 9.189,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:6449",
              "position": {
                "x": -8733.31,
                "z": 7240.084
              },
              "distanceAlongShapeM": 5597.688,
              "shapeOffsetM": 6.222,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:9115",
              "position": {
                "x": -8830.889,
                "z": 7037.958
              },
              "distanceAlongShapeM": 5822.065,
              "shapeOffsetM": 3.682,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:9776",
              "position": {
                "x": -8090.106,
                "z": 6365.775
              },
              "distanceAlongShapeM": 7073.491,
              "shapeOffsetM": 11.179,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:4410",
              "position": {
                "x": -6663.331,
                "z": 5954.79
              },
              "distanceAlongShapeM": 8571.067,
              "shapeOffsetM": 7.249,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:5731",
              "position": {
                "x": -6334.791,
                "z": 5638.714
              },
              "distanceAlongShapeM": 9025.916,
              "shapeOffsetM": 5.79,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:6850",
              "position": {
                "x": -4517.509,
                "z": 4980.025
              },
              "distanceAlongShapeM": 11155.9,
              "shapeOffsetM": 2.616,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            }
          ],
          "departuresSeconds": [
            23760,
            27540,
            32040,
            38220,
            39720,
            41700,
            43500,
            45300,
            47220,
            49080,
            50880,
            52980,
            54780,
            56700,
            58680,
            60660,
            62880,
            65100,
            67260,
            71520,
            73560,
            75900,
            77280,
            79560,
            80880,
            84360
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_bus_26",
      "sourceRouteId": "vilnius_bus_26",
      "mode": "bus",
      "shortName": "26",
      "longName": "Ozo g.–Kalvarijų g.–Santariškės–Didžioji Riešė–Didieji Gulbinai",
      "color": "0073AC",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_bus_26:0",
          "sourceRouteId": "vilnius_bus_26",
          "sourceShapeId": "vilnius_bus_26_a-b",
          "directionId": 0,
          "headsign": "Didieji Gulbinai",
          "directionName": "Ozo g.–Kalvarijų g.–Santariškės–Didžioji Riešė–Didieji Gulbinai",
          "mode": "bus",
          "routeShortName": "26",
          "routeLongName": "Ozo g.–Kalvarijų g.–Santariškės–Didžioji Riešė–Didieji Gulbinai",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              -97.934,
              -3002.895,
              0
            ],
            [
              -96.298,
              -2967.504,
              35.429
            ],
            [
              -92.311,
              -2960.897,
              43.146
            ],
            [
              -73.392,
              -2955.949,
              62.702
            ],
            [
              -69.728,
              -2944.592,
              74.634
            ],
            [
              -69.858,
              -2931.249,
              87.978
            ],
            [
              -70.404,
              -2921.042,
              98.199
            ],
            [
              -70.518,
              -2896.726,
              122.516
            ],
            [
              -71.838,
              -2871.091,
              148.185
            ],
            [
              -69.485,
              -2839.97,
              179.395
            ],
            [
              -47.138,
              -2753.559,
              268.649
            ],
            [
              -41.828,
              -2736.943,
              286.092
            ],
            [
              -37.172,
              -2738.672,
              291.059
            ],
            [
              11.208,
              -2748.6,
              340.447
            ],
            [
              24.728,
              -2752.265,
              354.455
            ],
            [
              115.892,
              -2776.972,
              448.908
            ],
            [
              149.216,
              -2788.545,
              484.185
            ],
            [
              177.432,
              -2801.056,
              515.05
            ],
            [
              235.996,
              -2841.089,
              585.989
            ],
            [
              300.135,
              -2893.471,
              668.8
            ],
            [
              349.094,
              -2929.99,
              729.879
            ],
            [
              400.25,
              -2952.078,
              785.6
            ],
            [
              460.411,
              -2963.666,
              846.867
            ],
            [
              513.462,
              -2964.172,
              899.92
            ],
            [
              519.179,
              -2968.73,
              907.232
            ],
            [
              521.572,
              -2978.793,
              917.575
            ],
            [
              511.327,
              -3110.973,
              1050.152
            ],
            [
              509.54,
              -3153.291,
              1092.507
            ],
            [
              507.077,
              -3235.606,
              1174.86
            ],
            [
              505.902,
              -3256.64,
              1195.926
            ],
            [
              503.774,
              -3366.969,
              1306.276
            ],
            [
              489.873,
              -3512.567,
              1452.536
            ],
            [
              474.056,
              -3566.826,
              1509.053
            ],
            [
              440.465,
              -3641.474,
              1590.91
            ],
            [
              383.151,
              -3709.882,
              1680.155
            ],
            [
              302.538,
              -3790.592,
              1794.228
            ],
            [
              278.895,
              -3808.166,
              1823.687
            ],
            [
              228.358,
              -3858.451,
              1894.979
            ],
            [
              158.106,
              -3965.152,
              2022.73
            ],
            [
              125.932,
              -4039.781,
              2104
            ],
            [
              102.95,
              -4092.167,
              2161.205
            ],
            [
              79.561,
              -4208.631,
              2279.994
            ],
            [
              75.006,
              -4246.398,
              2318.035
            ],
            [
              72.804,
              -4296.453,
              2368.138
            ],
            [
              57.959,
              -4368.543,
              2441.741
            ],
            [
              50.952,
              -4440.233,
              2513.772
            ],
            [
              47.442,
              -4461.8,
              2535.623
            ],
            [
              42.119,
              -4495.164,
              2569.409
            ],
            [
              45.832,
              -4598.763,
              2673.075
            ],
            [
              43.273,
              -4641.013,
              2715.403
            ],
            [
              -32.111,
              -5068.242,
              3149.231
            ],
            [
              -38.249,
              -5115.663,
              3197.048
            ],
            [
              -42.927,
              -5131.5,
              3213.561
            ],
            [
              -75.729,
              -5270.057,
              3355.948
            ],
            [
              -95.037,
              -5339.84,
              3428.353
            ],
            [
              -109.429,
              -5409.977,
              3499.951
            ],
            [
              -116.661,
              -5430.732,
              3521.93
            ],
            [
              -144.967,
              -5534.861,
              3629.838
            ],
            [
              -183.275,
              -5657.733,
              3758.543
            ],
            [
              -188.212,
              -5716.645,
              3817.661
            ],
            [
              -190.648,
              -5736.736,
              3837.9
            ],
            [
              -196.91,
              -5769.923,
              3871.672
            ],
            [
              -201.665,
              -5818.819,
              3920.799
            ],
            [
              -201.086,
              -5857.793,
              3959.777
            ],
            [
              -195.599,
              -5910.215,
              4012.485
            ],
            [
              -136.015,
              -6175.138,
              4284.026
            ],
            [
              -127.679,
              -6205.529,
              4315.54
            ],
            [
              -123.468,
              -6228.802,
              4339.191
            ],
            [
              -113.557,
              -6285.758,
              4397.003
            ],
            [
              -58.166,
              -6532.794,
              4650.172
            ],
            [
              -46.468,
              -6597.576,
              4716.002
            ],
            [
              -39.377,
              -6667.839,
              4786.622
            ],
            [
              -35.045,
              -6748.072,
              4866.972
            ],
            [
              -26.235,
              -6767.677,
              4888.465
            ],
            [
              -16.413,
              -6780.218,
              4904.395
            ],
            [
              0.443,
              -6790.505,
              4924.142
            ],
            [
              9.552,
              -6811.226,
              4946.777
            ],
            [
              9.735,
              -6827.796,
              4963.348
            ],
            [
              7.024,
              -6842.352,
              4978.154
            ],
            [
              -10.864,
              -6869.857,
              5010.964
            ],
            [
              -21.671,
              -6897.49,
              5040.635
            ],
            [
              -11.966,
              -6926.765,
              5071.477
            ],
            [
              -9.853,
              -6955.595,
              5100.384
            ],
            [
              6.027,
              -7144.023,
              5289.48
            ],
            [
              11.629,
              -7176.924,
              5322.854
            ],
            [
              9.978,
              -7209.777,
              5355.749
            ],
            [
              38.024,
              -7507.525,
              5654.815
            ],
            [
              44.494,
              -7541.041,
              5688.95
            ],
            [
              45.727,
              -7614.537,
              5762.456
            ],
            [
              52.252,
              -7680.338,
              5828.58
            ],
            [
              -275.17,
              -7699.975,
              6156.59
            ],
            [
              -508.925,
              -7738.032,
              6393.423
            ],
            [
              -520.351,
              -7792.005,
              6448.593
            ],
            [
              -532.67,
              -7994.742,
              6651.704
            ],
            [
              -556.838,
              -8498.621,
              7156.162
            ],
            [
              -556.833,
              -8537.512,
              7195.053
            ],
            [
              -557.975,
              -8577.631,
              7235.188
            ],
            [
              -560.585,
              -8663.304,
              7320.9
            ],
            [
              -562.152,
              -8716.691,
              7374.311
            ],
            [
              -566.652,
              -8826.85,
              7484.561
            ],
            [
              -568.242,
              -8918.004,
              7575.73
            ],
            [
              -572.031,
              -8981.494,
              7639.332
            ],
            [
              -575.268,
              -9029.307,
              7687.255
            ],
            [
              -577.415,
              -9132.793,
              7790.763
            ],
            [
              -572.564,
              -9298.698,
              7956.739
            ],
            [
              -564.515,
              -9391.126,
              8049.517
            ],
            [
              -548.417,
              -9503.75,
              8163.285
            ],
            [
              -508.405,
              -9675.795,
              8339.922
            ],
            [
              -446.478,
              -9971.222,
              8641.77
            ],
            [
              -416.433,
              -10127.142,
              8800.558
            ],
            [
              -415.215,
              -10189.126,
              8862.554
            ],
            [
              -419.082,
              -10198.193,
              8872.411
            ],
            [
              -429.435,
              -10201.973,
              8883.432
            ],
            [
              -450.661,
              -10213.817,
              8907.739
            ],
            [
              -515.481,
              -10297.923,
              9013.925
            ],
            [
              -529.8,
              -10317.931,
              9038.529
            ],
            [
              -538.659,
              -10334.693,
              9057.488
            ],
            [
              -539.172,
              -10339.265,
              9062.088
            ],
            [
              -538.093,
              -10337.156,
              9064.458
            ],
            [
              -536.865,
              -10334.756,
              9067.153
            ],
            [
              -533.33,
              -10328.926,
              9073.971
            ],
            [
              -505.907,
              -10289.485,
              9122.009
            ],
            [
              -497.36,
              -10277.592,
              9136.654
            ],
            [
              -495.758,
              -10275.362,
              9139.401
            ],
            [
              -497.044,
              -10275.333,
              9140.687
            ],
            [
              -537.976,
              -10332.479,
              9210.98
            ],
            [
              -603.204,
              -10546.739,
              9434.95
            ],
            [
              -776.992,
              -10977.955,
              9899.868
            ],
            [
              -984.333,
              -11574.733,
              10531.639
            ],
            [
              -1248.476,
              -12217.969,
              11226.998
            ],
            [
              -1403.468,
              -12598.048,
              11637.464
            ],
            [
              -1425.089,
              -12649.824,
              11693.573
            ],
            [
              -1529.156,
              -12906.064,
              11970.139
            ],
            [
              -1581.108,
              -13029.98,
              12104.505
            ],
            [
              -1600.868,
              -13091.968,
              12169.566
            ],
            [
              -1612.856,
              -13159.806,
              12238.455
            ],
            [
              -1613.772,
              -13201.947,
              12280.606
            ],
            [
              -1535.187,
              -13194.451,
              12359.548
            ],
            [
              -1337.143,
              -13167.821,
              12559.375
            ],
            [
              -1197.568,
              -13147.468,
              12700.425
            ],
            [
              -1056.905,
              -13095.074,
              12850.529
            ],
            [
              -787.402,
              -12913.322,
              13175.592
            ],
            [
              -766.499,
              -12907.636,
              13197.255
            ],
            [
              -451.805,
              -13060.393,
              13547.064
            ],
            [
              -283.762,
              -13190.363,
              13759.504
            ],
            [
              -200.79,
              -13259.784,
              13867.687
            ],
            [
              -169.922,
              -13294.858,
              13914.41
            ],
            [
              -148.585,
              -13308.071,
              13939.507
            ],
            [
              -129.086,
              -13312.302,
              13959.46
            ],
            [
              0.783,
              -13270.286,
              14095.957
            ],
            [
              71.23,
              -13244.62,
              14170.934
            ],
            [
              189.28,
              -13203.664,
              14295.886
            ],
            [
              452.066,
              -13110.317,
              14574.759
            ],
            [
              535.547,
              -13065.73,
              14669.4
            ],
            [
              642.573,
              -12997.988,
              14796.064
            ],
            [
              798.763,
              -12903.068,
              14978.835
            ],
            [
              893.442,
              -12854.753,
              15085.129
            ],
            [
              931.135,
              -12849.904,
              15123.132
            ],
            [
              944.663,
              -12843.003,
              15138.319
            ],
            [
              950.27,
              -12841.189,
              15144.212
            ],
            [
              959.085,
              -12851.371,
              15157.68
            ],
            [
              952.589,
              -12858.604,
              15167.402
            ],
            [
              937.206,
              -12852.08,
              15184.111
            ],
            [
              917.771,
              -12854.308,
              15203.673
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:8460",
              "position": {
                "x": -74.186,
                "z": -2921.151
              },
              "distanceAlongShapeM": 98.199,
              "shapeOffsetM": 3.784,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:5080",
              "position": {
                "x": 12.173,
                "z": -2744.606
              },
              "distanceAlongShapeM": 340.447,
              "shapeOffsetM": 4.109,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:19086",
              "position": {
                "x": 511.316,
                "z": -3256.915
              },
              "distanceAlongShapeM": 1196.097,
              "shapeOffsetM": 5.419,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:5848",
              "position": {
                "x": 303.678,
                "z": -3791.921
              },
              "distanceAlongShapeM": 1794.228,
              "shapeOffsetM": 1.751,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:5840",
              "position": {
                "x": 127.093,
                "z": -4040.286
              },
              "distanceAlongShapeM": 2104,
              "shapeOffsetM": 1.266,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:6487",
              "position": {
                "x": 54.707,
                "z": -4440.844
              },
              "distanceAlongShapeM": 2513.772,
              "shapeOffsetM": 3.804,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:6488",
              "position": {
                "x": -36.204,
                "z": -5116.037
              },
              "distanceAlongShapeM": 3197.048,
              "shapeOffsetM": 2.079,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:6491",
              "position": {
                "x": -105.993,
                "z": -5410.888
              },
              "distanceAlongShapeM": 3499.951,
              "shapeOffsetM": 3.555,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:6497",
              "position": {
                "x": -185.377,
                "z": -5737.848
              },
              "distanceAlongShapeM": 3838.015,
              "shapeOffsetM": 5.386,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:6500",
              "position": {
                "x": -122.378,
                "z": -6204.331
              },
              "distanceAlongShapeM": 4315.54,
              "shapeOffsetM": 5.434,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            },
            {
              "stopId": "judu:stop:6525",
              "position": {
                "x": -10.612,
                "z": -6926.637
              },
              "distanceAlongShapeM": 5071.477,
              "shapeOffsetM": 1.36,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:6532",
              "position": {
                "x": 16.38,
                "z": -7176.496
              },
              "distanceAlongShapeM": 5322.854,
              "shapeOffsetM": 4.77,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:8716",
              "position": {
                "x": 44.494,
                "z": -7541.041
              },
              "distanceAlongShapeM": 5688.95,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:16295",
              "position": {
                "x": -511.201,
                "z": -7792.54
              },
              "distanceAlongShapeM": 6447.221,
              "shapeOffsetM": 9.062,
              "arrivalOffsetSeconds": 1380,
              "departureOffsetSeconds": 1380
            },
            {
              "stopId": "judu:stop:7092",
              "position": {
                "x": -549.822,
                "z": -8537.712
              },
              "distanceAlongShapeM": 7195.053,
              "shapeOffsetM": 7.013,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            },
            {
              "stopId": "judu:stop:7374",
              "position": {
                "x": -561.229,
                "z": -8918.235
              },
              "distanceAlongShapeM": 7575.73,
              "shapeOffsetM": 7.017,
              "arrivalOffsetSeconds": 1500,
              "departureOffsetSeconds": 1500
            },
            {
              "stopId": "judu:stop:7095",
              "position": {
                "x": -505.453,
                "z": -9675.14
              },
              "distanceAlongShapeM": 8339.922,
              "shapeOffsetM": 3.023,
              "arrivalOffsetSeconds": 1560,
              "departureOffsetSeconds": 1560
            },
            {
              "stopId": "judu:stop:8472",
              "position": {
                "x": -520.046,
                "z": -10337.257
              },
              "distanceAlongShapeM": 9074.715,
              "shapeOffsetM": 15.663,
              "arrivalOffsetSeconds": 1740,
              "departureOffsetSeconds": 1740
            },
            {
              "stopId": "judu:stop:7098",
              "position": {
                "x": -597.23,
                "z": -10548.487
              },
              "distanceAlongShapeM": 9434.881,
              "shapeOffsetM": 6.224,
              "arrivalOffsetSeconds": 1860,
              "departureOffsetSeconds": 1860
            },
            {
              "stopId": "judu:stop:7100",
              "position": {
                "x": -776.158,
                "z": -10978.298
              },
              "distanceAlongShapeM": 9899.918,
              "shapeOffsetM": 0.901,
              "arrivalOffsetSeconds": 1920,
              "departureOffsetSeconds": 1920
            },
            {
              "stopId": "judu:stop:7102",
              "position": {
                "x": -997.254,
                "z": -11643.363
              },
              "distanceAlongShapeM": 10600.033,
              "shapeOffsetM": 14.118,
              "arrivalOffsetSeconds": 1980,
              "departureOffsetSeconds": 1980
            },
            {
              "stopId": "judu:stop:7104",
              "position": {
                "x": -1246.263,
                "z": -12218.875
              },
              "distanceAlongShapeM": 11227.001,
              "shapeOffsetM": 2.391,
              "arrivalOffsetSeconds": 2040,
              "departureOffsetSeconds": 2040
            },
            {
              "stopId": "judu:stop:8324",
              "position": {
                "x": -1401.025,
                "z": -12599.047
              },
              "distanceAlongShapeM": 11637.464,
              "shapeOffsetM": 2.639,
              "arrivalOffsetSeconds": 2100,
              "departureOffsetSeconds": 2100
            },
            {
              "stopId": "judu:stop:7107",
              "position": {
                "x": -1607.248,
                "z": -13160.874
              },
              "distanceAlongShapeM": 12239.401,
              "shapeOffsetM": 5.63,
              "arrivalOffsetSeconds": 2160,
              "departureOffsetSeconds": 2160
            },
            {
              "stopId": "judu:stop:4590",
              "position": {
                "x": -851.792,
                "z": -12954.058
              },
              "distanceAlongShapeM": 13099.431,
              "shapeOffsetM": 2.229,
              "arrivalOffsetSeconds": 2280,
              "departureOffsetSeconds": 2280
            },
            {
              "stopId": "judu:stop:15180",
              "position": {
                "x": -63.072,
                "z": -13289.016
              },
              "distanceAlongShapeM": 14029.436,
              "shapeOffsetM": 1.835,
              "arrivalOffsetSeconds": 2400,
              "departureOffsetSeconds": 2400
            },
            {
              "stopId": "judu:stop:15181",
              "position": {
                "x": 917.858,
                "z": -12855.062
              },
              "distanceAlongShapeM": 15203.673,
              "shapeOffsetM": 0.759,
              "arrivalOffsetSeconds": 2520,
              "departureOffsetSeconds": 2520
            }
          ],
          "departuresSeconds": [
            20160,
            25560,
            29460,
            33360,
            36360,
            39960,
            43560,
            46260,
            49260,
            52260,
            55560,
            59460,
            67260,
            73260,
            79260
          ]
        },
        {
          "id": "judu:pattern:vilnius_bus_26:1",
          "sourceRouteId": "vilnius_bus_26",
          "sourceShapeId": "vilnius_bus_26_b-a",
          "directionId": 1,
          "headsign": "Ozo g.",
          "directionName": "Didieji Gulbinai–Didžioji Riešė–Santariškės–Kalvarijų g.–Ozo g.",
          "mode": "bus",
          "routeShortName": "26",
          "routeLongName": "Ozo g.–Kalvarijų g.–Santariškės–Didžioji Riešė–Didieji Gulbinai",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              917.771,
              -12854.308,
              0
            ],
            [
              858.886,
              -12870.409,
              61.047
            ],
            [
              494.597,
              -13091.715,
              487.289
            ],
            [
              424.24,
              -13119.825,
              563.054
            ],
            [
              -59.92,
              -13294.345,
              1077.708
            ],
            [
              -131.057,
              -13314.477,
              1151.638
            ],
            [
              -152.167,
              -13308.541,
              1173.567
            ],
            [
              -196.466,
              -13264.943,
              1235.721
            ],
            [
              -253.879,
              -13216.329,
              1310.952
            ],
            [
              -430.895,
              -13077.472,
              1535.931
            ],
            [
              -486.175,
              -13040.843,
              1602.246
            ],
            [
              -625.125,
              -12972.638,
              1757.033
            ],
            [
              -666.936,
              -12953.473,
              1803.026
            ],
            [
              -718.667,
              -12924.974,
              1862.088
            ],
            [
              -762.42,
              -12907.83,
              1909.08
            ],
            [
              -774.514,
              -12909.814,
              1921.335
            ],
            [
              -1000.192,
              -13063.173,
              2194.19
            ],
            [
              -1042.959,
              -13089.364,
              2244.34
            ],
            [
              -1123.74,
              -13128.379,
              2334.049
            ],
            [
              -1194.959,
              -13149.937,
              2408.459
            ],
            [
              -1354.152,
              -13172.905,
              2569.3
            ],
            [
              -1591.935,
              -13203.452,
              2809.038
            ],
            [
              -1602.883,
              -13204.369,
              2820.024
            ],
            [
              -1616.975,
              -13199.859,
              2834.82
            ],
            [
              -1618.519,
              -13189.536,
              2845.257
            ],
            [
              -1598.643,
              -13072.631,
              2963.84
            ],
            [
              -1521.504,
              -12879.969,
              3171.371
            ],
            [
              -1375.728,
              -12522.23,
              3557.671
            ],
            [
              -1242.683,
              -12196.294,
              3909.716
            ],
            [
              -974.684,
              -11543.409,
              4615.465
            ],
            [
              -959.911,
              -11507.579,
              4654.222
            ],
            [
              -927.761,
              -11428.778,
              4739.328
            ],
            [
              -747.527,
              -10900.488,
              5297.516
            ],
            [
              -733.294,
              -10866.145,
              5334.693
            ],
            [
              -629.667,
              -10621.496,
              5600.384
            ],
            [
              -581.363,
              -10464.582,
              5764.564
            ],
            [
              -572.426,
              -10433.002,
              5797.385
            ],
            [
              -561.098,
              -10401.08,
              5831.257
            ],
            [
              -548.64,
              -10362.848,
              5871.467
            ],
            [
              -547.473,
              -10359.684,
              5874.839
            ],
            [
              -545.939,
              -10355.522,
              5879.275
            ],
            [
              -544.189,
              -10350.777,
              5884.333
            ],
            [
              -533.33,
              -10328.926,
              5908.733
            ],
            [
              -496.934,
              -10276.998,
              5972.146
            ],
            [
              -495.437,
              -10274.916,
              5974.71
            ],
            [
              -495.717,
              -10273.13,
              5976.518
            ],
            [
              -494.116,
              -10268.194,
              5981.707
            ],
            [
              -455.073,
              -10214.496,
              6048.099
            ],
            [
              -433.052,
              -10188.549,
              6082.131
            ],
            [
              -425.915,
              -10176.299,
              6096.308
            ],
            [
              -422.857,
              -10158.676,
              6114.194
            ],
            [
              -447.786,
              -10013.478,
              6261.517
            ],
            [
              -543.423,
              -9576.303,
              6709.031
            ],
            [
              -555.093,
              -9513.89,
              6772.525
            ],
            [
              -557.907,
              -9496.336,
              6790.304
            ],
            [
              -566.009,
              -9430.241,
              6856.893
            ],
            [
              -581.42,
              -9286.353,
              7001.604
            ],
            [
              -582.35,
              -9053.668,
              7234.291
            ],
            [
              -571.804,
              -8909.159,
              7379.184
            ],
            [
              -578.071,
              -8870.094,
              7418.748
            ],
            [
              -573.871,
              -8834.512,
              7454.578
            ],
            [
              -566.291,
              -8522.941,
              7766.241
            ],
            [
              -563.836,
              -8494.041,
              7795.245
            ],
            [
              -565.136,
              -8465.113,
              7824.202
            ],
            [
              -527.046,
              -7743.269,
              8547.05
            ],
            [
              -368.736,
              -7711.633,
              8708.49
            ],
            [
              -239.087,
              -7698.405,
              8838.812
            ],
            [
              49.054,
              -7679.166,
              9127.595
            ],
            [
              45.727,
              -7614.537,
              9192.31
            ],
            [
              26.258,
              -7471.636,
              9336.531
            ],
            [
              8.189,
              -7201.951,
              9606.82
            ],
            [
              -2.477,
              -7116.037,
              9693.394
            ],
            [
              -10.317,
              -7079.698,
              9730.569
            ],
            [
              -10.894,
              -7047.975,
              9762.297
            ],
            [
              -21.671,
              -6897.49,
              9913.168
            ],
            [
              -33.557,
              -6878.349,
              9935.699
            ],
            [
              -59.463,
              -6851.158,
              9973.255
            ],
            [
              -67.548,
              -6835.425,
              9990.944
            ],
            [
              -70.502,
              -6820.899,
              10005.767
            ],
            [
              -64.262,
              -6796.522,
              10030.93
            ],
            [
              -53.909,
              -6786.595,
              10045.273
            ],
            [
              -43.463,
              -6771.142,
              10063.926
            ],
            [
              -44.234,
              -6722.3,
              10112.774
            ],
            [
              -50.641,
              -6695.446,
              10140.381
            ],
            [
              -48.526,
              -6639.841,
              10196.027
            ],
            [
              -52.099,
              -6588.567,
              10247.425
            ],
            [
              -70.555,
              -6505.85,
              10332.176
            ],
            [
              -125.166,
              -6286.66,
              10558.067
            ],
            [
              -158.525,
              -6137.991,
              10710.433
            ],
            [
              -180.294,
              -6069.166,
              10782.618
            ],
            [
              -186.217,
              -6031.729,
              10820.521
            ],
            [
              -210.448,
              -5912.171,
              10942.51
            ],
            [
              -214.769,
              -5866.45,
              10988.435
            ],
            [
              -215.425,
              -5796.303,
              11058.585
            ],
            [
              -201.667,
              -5690.858,
              11164.923
            ],
            [
              -179.043,
              -5602.148,
              11256.473
            ],
            [
              -173.463,
              -5579.628,
              11279.674
            ],
            [
              -152.289,
              -5512.463,
              11350.097
            ],
            [
              -104.595,
              -5334.099,
              11534.728
            ],
            [
              -94.509,
              -5271.442,
              11598.192
            ],
            [
              -83.553,
              -5239.857,
              11631.623
            ],
            [
              -60.518,
              -5142.312,
              11731.851
            ],
            [
              -44.586,
              -5045.75,
              11829.718
            ],
            [
              -37.931,
              -4996.288,
              11879.626
            ],
            [
              -29.601,
              -4965.87,
              11911.164
            ],
            [
              29.378,
              -4628.52,
              12253.631
            ],
            [
              28.501,
              -4570.615,
              12311.542
            ],
            [
              22.071,
              -4499.251,
              12383.195
            ],
            [
              25.378,
              -4459.234,
              12423.349
            ],
            [
              39.56,
              -4363.958,
              12519.675
            ],
            [
              46.147,
              -4344.95,
              12539.792
            ],
            [
              48.454,
              -4310.97,
              12573.849
            ],
            [
              52.989,
              -4285.429,
              12599.791
            ],
            [
              60.111,
              -4250.579,
              12635.361
            ],
            [
              104.143,
              -4062.131,
              12828.884
            ],
            [
              127.703,
              -3998.463,
              12896.772
            ],
            [
              151.352,
              -3953.466,
              12947.605
            ],
            [
              179.07,
              -3910.986,
              12998.328
            ],
            [
              264.038,
              -3810.121,
              13130.212
            ],
            [
              345.157,
              -3743.697,
              13235.057
            ],
            [
              387.493,
              -3689.441,
              13303.876
            ],
            [
              446.225,
              -3608.619,
              13403.784
            ],
            [
              460.662,
              -3594.412,
              13424.039
            ],
            [
              478.493,
              -3535.737,
              13485.363
            ],
            [
              485.73,
              -3492.453,
              13529.248
            ],
            [
              490.942,
              -3419.075,
              13602.811
            ],
            [
              493.782,
              -3334.52,
              13687.414
            ],
            [
              479.687,
              -3259.675,
              13763.574
            ],
            [
              477.905,
              -3216.226,
              13807.06
            ],
            [
              481.339,
              -3169.533,
              13853.879
            ],
            [
              500.602,
              -3103.091,
              13923.057
            ],
            [
              504.082,
              -3078.362,
              13948.03
            ],
            [
              504.445,
              -3034.141,
              13992.252
            ],
            [
              503.491,
              -2980.688,
              14045.714
            ],
            [
              491.209,
              -2982.689,
              14058.158
            ],
            [
              442.369,
              -2977.974,
              14107.225
            ],
            [
              342.529,
              -2936.549,
              14215.317
            ],
            [
              249.744,
              -2864.719,
              14332.657
            ],
            [
              215.338,
              -2842.938,
              14373.378
            ],
            [
              172.556,
              -2821.005,
              14421.454
            ],
            [
              117.391,
              -2800.55,
              14480.289
            ],
            [
              -65.348,
              -2754.326,
              14668.784
            ],
            [
              -120.668,
              -2747.991,
              14724.466
            ],
            [
              -129.656,
              -2746.461,
              14733.582
            ],
            [
              -137.39,
              -2746.336,
              14741.318
            ],
            [
              -144.28,
              -2749.792,
              14749.026
            ],
            [
              -150.64,
              -2766.133,
              14766.561
            ],
            [
              -155.198,
              -2839.524,
              14840.094
            ],
            [
              -150.85,
              -2848.509,
              14850.075
            ],
            [
              -136.817,
              -2856.556,
              14866.252
            ],
            [
              -89.924,
              -2865.202,
              14913.935
            ],
            [
              -71.361,
              -2872.22,
              14933.781
            ],
            [
              -66.693,
              -2881.286,
              14943.978
            ],
            [
              -64.141,
              -2997.064,
              15059.783
            ],
            [
              -63.681,
              -3021.884,
              15084.608
            ],
            [
              -62.157,
              -3041.974,
              15104.756
            ],
            [
              -63.026,
              -3051.603,
              15114.424
            ],
            [
              -80.08,
              -3055.235,
              15131.861
            ],
            [
              -95.074,
              -3039.721,
              15153.436
            ],
            [
              -96.66,
              -3035.206,
              15158.221
            ],
            [
              -97.934,
              -3002.895,
              15190.557
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:15181",
              "position": {
                "x": 917.858,
                "z": -12855.062
              },
              "distanceAlongShapeM": 0.115,
              "shapeOffsetM": 0.75,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:15182",
              "position": {
                "x": -20.524,
                "z": -13283.114
              },
              "distanceAlongShapeM": 1036.837,
              "shapeOffsetM": 2.794,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:4591",
              "position": {
                "x": -669.903,
                "z": -12959.58
              },
              "distanceAlongShapeM": 1803.026,
              "shapeOffsetM": 6.79,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:7106",
              "position": {
                "x": -1604.989,
                "z": -13070.742
              },
              "distanceAlongShapeM": 2963.84,
              "shapeOffsetM": 6.621,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:8325",
              "position": {
                "x": -1386.063,
                "z": -12518.049
              },
              "distanceAlongShapeM": 3557.643,
              "shapeOffsetM": 11.149,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:7103",
              "position": {
                "x": -1244.556,
                "z": -12195.527
              },
              "distanceAlongShapeM": 3909.716,
              "shapeOffsetM": 2.024,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:7101",
              "position": {
                "x": -985.72,
                "z": -11538.926
              },
              "distanceAlongShapeM": 4615.421,
              "shapeOffsetM": 11.912,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:7099",
              "position": {
                "x": -754.749,
                "z": -10897.419
              },
              "distanceAlongShapeM": 5297.587,
              "shapeOffsetM": 7.847,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:7097",
              "position": {
                "x": -580.296,
                "z": -10430.79
              },
              "distanceAlongShapeM": 5797.37,
              "shapeOffsetM": 8.175,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:8472",
              "position": {
                "x": -520.046,
                "z": -10337.257
              },
              "distanceAlongShapeM": 5907.184,
              "shapeOffsetM": 15.604,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:7094",
              "position": {
                "x": -562.717,
                "z": -9497.095
              },
              "distanceAlongShapeM": 6790.304,
              "shapeOffsetM": 4.87,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:7343",
              "position": {
                "x": -580.308,
                "z": -8870.019
              },
              "distanceAlongShapeM": 7418.748,
              "shapeOffsetM": 2.239,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            },
            {
              "stopId": "judu:stop:7093",
              "position": {
                "x": -567.816,
                "z": -8465.025
              },
              "distanceAlongShapeM": 7824.202,
              "shapeOffsetM": 2.682,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:7831",
              "position": {
                "x": 25.801,
                "z": -7471.678
              },
              "distanceAlongShapeM": 9336.531,
              "shapeOffsetM": 0.459,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            },
            {
              "stopId": "judu:stop:6526",
              "position": {
                "x": -15.345,
                "z": -7080.178
              },
              "distanceAlongShapeM": 9730.569,
              "shapeOffsetM": 5.051,
              "arrivalOffsetSeconds": 1380,
              "departureOffsetSeconds": 1380
            },
            {
              "stopId": "judu:stop:6503",
              "position": {
                "x": -50.829,
                "z": -6695.462
              },
              "distanceAlongShapeM": 10140.381,
              "shapeOffsetM": 0.189,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            },
            {
              "stopId": "judu:stop:6501",
              "position": {
                "x": -182.398,
                "z": -6069.649
              },
              "distanceAlongShapeM": 10782.618,
              "shapeOffsetM": 2.159,
              "arrivalOffsetSeconds": 1560,
              "departureOffsetSeconds": 1560
            },
            {
              "stopId": "judu:stop:6494",
              "position": {
                "x": -176.685,
                "z": -5578.813
              },
              "distanceAlongShapeM": 11279.674,
              "shapeOffsetM": 3.324,
              "arrivalOffsetSeconds": 1680,
              "departureOffsetSeconds": 1680
            },
            {
              "stopId": "judu:stop:6492",
              "position": {
                "x": -97,
                "z": -5270.783
              },
              "distanceAlongShapeM": 11598.192,
              "shapeOffsetM": 2.577,
              "arrivalOffsetSeconds": 1740,
              "departureOffsetSeconds": 1740
            },
            {
              "stopId": "judu:stop:6489",
              "position": {
                "x": -41.097,
                "z": -4995.718
              },
              "distanceAlongShapeM": 11879.626,
              "shapeOffsetM": 3.217,
              "arrivalOffsetSeconds": 1800,
              "departureOffsetSeconds": 1800
            },
            {
              "stopId": "judu:stop:5836",
              "position": {
                "x": 49.82,
                "z": -4284.902
              },
              "distanceAlongShapeM": 12599.755,
              "shapeOffsetM": 3.212,
              "arrivalOffsetSeconds": 1920,
              "departureOffsetSeconds": 1920
            },
            {
              "stopId": "judu:stop:5839",
              "position": {
                "x": 148.043,
                "z": -3951.609
              },
              "distanceAlongShapeM": 12947.605,
              "shapeOffsetM": 3.794,
              "arrivalOffsetSeconds": 1980,
              "departureOffsetSeconds": 1980
            },
            {
              "stopId": "judu:stop:5846",
              "position": {
                "x": 383.579,
                "z": -3686.512
              },
              "distanceAlongShapeM": 13303.777,
              "shapeOffsetM": 4.888,
              "arrivalOffsetSeconds": 2040,
              "departureOffsetSeconds": 2040
            },
            {
              "stopId": "judu:stop:5131",
              "position": {
                "x": 442.304,
                "z": -2978.453
              },
              "distanceAlongShapeM": 14107.225,
              "shapeOffsetM": 0.484,
              "arrivalOffsetSeconds": 2280,
              "departureOffsetSeconds": 2280
            },
            {
              "stopId": "judu:stop:8463",
              "position": {
                "x": -121.383,
                "z": -2752.193
              },
              "distanceAlongShapeM": 14724.466,
              "shapeOffsetM": 4.263,
              "arrivalOffsetSeconds": 2400,
              "departureOffsetSeconds": 2400
            },
            {
              "stopId": "judu:stop:8462",
              "position": {
                "x": -101.456,
                "z": -3003.034
              },
              "distanceAlongShapeM": 15190.557,
              "shapeOffsetM": 3.524,
              "arrivalOffsetSeconds": 2520,
              "departureOffsetSeconds": 2520
            }
          ],
          "departuresSeconds": [
            22320,
            27960,
            32040,
            35880,
            38880,
            42540,
            46020,
            48780,
            51840,
            54900,
            58260,
            62220,
            69960,
            75660,
            81480
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_bus_27",
      "sourceRouteId": "vilnius_bus_27",
      "mode": "bus",
      "shortName": "27",
      "longName": "Kalvarijų–Tuskulėnų–Olandų–Arimų g.",
      "color": "0073AC",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_bus_27:0",
          "sourceRouteId": "vilnius_bus_27",
          "sourceShapeId": "vilnius_bus_27_a-b",
          "directionId": 0,
          "headsign": "Arimų g.",
          "directionName": "Kalvarijų–Tuskulėnų–Olandų–Arimų g.",
          "mode": "bus",
          "routeShortName": "27",
          "routeLongName": "Kalvarijų–Tuskulėnų–Olandų–Arimų g.",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              676.214,
              -1635.564,
              0
            ],
            [
              696.914,
              -1614.56,
              29.49
            ],
            [
              759.366,
              -1540.03,
              126.727
            ],
            [
              891.199,
              -1385.857,
              329.579
            ],
            [
              926.904,
              -1337.532,
              389.664
            ],
            [
              938.594,
              -1321.715,
              409.332
            ],
            [
              959.848,
              -1299.175,
              440.313
            ],
            [
              1019.189,
              -1227.908,
              533.051
            ],
            [
              1188.158,
              -1016.171,
              803.944
            ],
            [
              1211.885,
              -984.023,
              843.899
            ],
            [
              1229.979,
              -967.272,
              868.557
            ],
            [
              1246.923,
              -941.557,
              899.352
            ],
            [
              1250.475,
              -923.811,
              917.45
            ],
            [
              1249.57,
              -868.132,
              973.137
            ],
            [
              1251.975,
              -858.297,
              983.262
            ],
            [
              1263.58,
              -842.786,
              1002.633
            ],
            [
              1271.438,
              -836.252,
              1012.853
            ],
            [
              1287.032,
              -829.861,
              1029.706
            ],
            [
              1306.39,
              -829.106,
              1049.078
            ],
            [
              1381.451,
              -814.909,
              1125.47
            ],
            [
              1625.047,
              -649.1,
              1420.142
            ],
            [
              1633.665,
              -634.2,
              1437.355
            ],
            [
              1640.869,
              -630.468,
              1445.468
            ],
            [
              1649.997,
              -609.491,
              1468.345
            ],
            [
              1647.435,
              -589.4,
              1488.599
            ],
            [
              1649.076,
              -570.506,
              1507.564
            ],
            [
              1661.593,
              -556.266,
              1526.523
            ],
            [
              1707.61,
              -543.762,
              1574.209
            ],
            [
              1715.531,
              -533.89,
              1586.866
            ],
            [
              1739.19,
              -475.328,
              1650.026
            ],
            [
              1739.832,
              -440.829,
              1684.531
            ],
            [
              1737.688,
              -417.411,
              1708.047
            ],
            [
              1728.721,
              -379.394,
              1747.108
            ],
            [
              1717.488,
              -353.728,
              1775.125
            ],
            [
              1709.957,
              -313.364,
              1816.185
            ],
            [
              1701.073,
              -270.896,
              1859.572
            ],
            [
              1691.292,
              -207.259,
              1923.956
            ],
            [
              1692.553,
              -139.375,
              1991.852
            ],
            [
              1699.889,
              -91.641,
              2040.146
            ],
            [
              1722.281,
              -31.942,
              2103.907
            ],
            [
              1763.619,
              40.763,
              2187.542
            ],
            [
              1784.543,
              87.474,
              2238.725
            ],
            [
              1803.689,
              114.605,
              2271.931
            ],
            [
              1864.141,
              209.22,
              2384.21
            ],
            [
              1913.636,
              269.526,
              2462.226
            ],
            [
              1990.962,
              334.88,
              2563.471
            ],
            [
              2018.633,
              366.989,
              2605.858
            ],
            [
              2052.586,
              388.28,
              2645.934
            ],
            [
              2087.216,
              412.125,
              2687.98
            ],
            [
              2136.967,
              451.273,
              2751.287
            ],
            [
              2182.309,
              496.069,
              2815.025
            ],
            [
              2210.658,
              528.937,
              2858.43
            ],
            [
              2229.877,
              556.409,
              2891.957
            ],
            [
              2248.742,
              590.591,
              2930.999
            ],
            [
              2266.569,
              621.404,
              2966.598
            ],
            [
              2281.67,
              670.105,
              3017.586
            ],
            [
              2292.591,
              736.695,
              3085.066
            ],
            [
              2303.283,
              756.534,
              3107.602
            ],
            [
              2315.701,
              765.207,
              3122.749
            ],
            [
              2333.759,
              767.736,
              3140.983
            ],
            [
              2353.101,
              764.507,
              3160.593
            ],
            [
              2377.645,
              731.764,
              3201.514
            ],
            [
              2411.777,
              694.387,
              3252.131
            ],
            [
              2429.021,
              676.964,
              3276.645
            ],
            [
              2453.553,
              653.492,
              3310.596
            ],
            [
              2501.276,
              617.009,
              3370.667
            ],
            [
              2634.367,
              525.451,
              3532.21
            ],
            [
              2716.164,
              450.439,
              3643.194
            ],
            [
              2736.291,
              431.885,
              3670.569
            ],
            [
              2755.449,
              412.963,
              3697.496
            ],
            [
              2864.4,
              307.38,
              3849.213
            ],
            [
              2936.644,
              239.224,
              3948.533
            ],
            [
              2983.62,
              199.374,
              4010.134
            ],
            [
              3033.392,
              162.998,
              4071.782
            ],
            [
              3060.52,
              138.92,
              4108.055
            ],
            [
              3266.423,
              -23.054,
              4370.031
            ],
            [
              3339.574,
              -76.762,
              4460.781
            ],
            [
              3415.597,
              -114.94,
              4545.852
            ],
            [
              3440.614,
              -122.094,
              4571.872
            ],
            [
              3504.684,
              -140.35,
              4638.492
            ],
            [
              3501.543,
              -139.949,
              4641.659
            ],
            [
              3709.123,
              -178.405,
              4852.771
            ],
            [
              3787.457,
              -196.594,
              4933.189
            ],
            [
              3851.65,
              -212.29,
              4999.273
            ],
            [
              3930.415,
              -241.623,
              5083.323
            ],
            [
              4021.131,
              -286.771,
              5184.653
            ],
            [
              4084.273,
              -323.602,
              5257.751
            ],
            [
              4172.105,
              -381.04,
              5362.696
            ],
            [
              4228.208,
              -425.014,
              5433.98
            ],
            [
              4243.612,
              -437.324,
              5453.698
            ],
            [
              4278.232,
              -466.47,
              5498.954
            ],
            [
              4369.696,
              -539.472,
              5615.979
            ],
            [
              4440.375,
              -586.471,
              5700.858
            ],
            [
              4472.674,
              -598.742,
              5735.41
            ],
            [
              4535.503,
              -602.77,
              5798.368
            ],
            [
              4564.381,
              -603.496,
              5827.255
            ],
            [
              4590.149,
              -608.45,
              5853.494
            ],
            [
              4600.348,
              -614.661,
              5865.436
            ],
            [
              4607.256,
              -625.288,
              5878.11
            ],
            [
              4620.057,
              -702.628,
              5956.503
            ],
            [
              4631.404,
              -711.158,
              5970.698
            ],
            [
              4640.435,
              -712.774,
              5979.873
            ],
            [
              4717.315,
              -705.347,
              6057.111
            ],
            [
              4759.912,
              -694.47,
              6101.075
            ],
            [
              4779.318,
              -689.437,
              6121.123
            ],
            [
              4803.971,
              -686.859,
              6145.91
            ],
            [
              4838.141,
              -692.981,
              6180.624
            ],
            [
              4879.685,
              -710.291,
              6225.63
            ],
            [
              4967.346,
              -749.442,
              6321.637
            ],
            [
              5000.178,
              -762.126,
              6356.834
            ],
            [
              5046.427,
              -761.975,
              6403.083
            ],
            [
              5083.491,
              -745.61,
              6443.599
            ],
            [
              5128.224,
              -713.027,
              6498.941
            ],
            [
              5199.857,
              -670.887,
              6582.049
            ],
            [
              5218.62,
              -668.365,
              6600.982
            ],
            [
              5232.565,
              -669.077,
              6614.944
            ],
            [
              5269.317,
              -680.372,
              6653.393
            ],
            [
              5328.642,
              -712.398,
              6720.81
            ],
            [
              5359.244,
              -723.317,
              6753.302
            ],
            [
              5431.804,
              -739.198,
              6827.58
            ],
            [
              5487.924,
              -755.621,
              6886.054
            ],
            [
              5583.685,
              -797.254,
              6990.473
            ],
            [
              5593.099,
              -801.335,
              7000.733
            ],
            [
              5638.476,
              -822.256,
              7050.701
            ],
            [
              5749.132,
              -865.761,
              7169.602
            ],
            [
              5848.505,
              -905.248,
              7276.533
            ],
            [
              5867.671,
              -918.62,
              7299.903
            ],
            [
              5911.226,
              -950.183,
              7353.692
            ],
            [
              6008.944,
              -1036.548,
              7484.105
            ],
            [
              6087.015,
              -1067.02,
              7567.912
            ],
            [
              6340.67,
              -1153.257,
              7835.826
            ],
            [
              6400.264,
              -1172.239,
              7898.37
            ],
            [
              6429.826,
              -1177.272,
              7928.357
            ],
            [
              6466.653,
              -1173.542,
              7965.373
            ],
            [
              6498.854,
              -1163.655,
              7999.057
            ],
            [
              6529.033,
              -1149.162,
              8032.536
            ],
            [
              6568.917,
              -1118.733,
              8082.703
            ],
            [
              6606.065,
              -1068.294,
              8145.345
            ],
            [
              6631.466,
              -1029.087,
              8192.062
            ],
            [
              6647.211,
              -1008.987,
              8217.594
            ],
            [
              6694.847,
              -947.581,
              8295.31
            ],
            [
              6719.092,
              -928.019,
              8326.463
            ],
            [
              6752.36,
              -908.635,
              8364.966
            ],
            [
              6802.323,
              -892.921,
              8417.342
            ],
            [
              6838.485,
              -890.294,
              8453.599
            ],
            [
              6873.828,
              -896.557,
              8489.493
            ],
            [
              7035.561,
              -935.376,
              8655.819
            ],
            [
              7128.227,
              -945.002,
              8748.984
            ],
            [
              7158.102,
              -941.257,
              8779.093
            ],
            [
              7214.756,
              -938.922,
              8835.795
            ],
            [
              7395.103,
              -916.892,
              9017.482
            ],
            [
              7530.909,
              -897.323,
              9154.691
            ],
            [
              7546.132,
              -893.041,
              9170.505
            ],
            [
              7569.695,
              -892.527,
              9194.073
            ],
            [
              7789.211,
              -879.085,
              9414.001
            ],
            [
              7854.937,
              -849.223,
              9486.192
            ],
            [
              7929.289,
              -822.584,
              9565.172
            ],
            [
              7959.195,
              -812.14,
              9596.849
            ],
            [
              8004.239,
              -799.879,
              9643.533
            ],
            [
              8037.181,
              -797.197,
              9676.584
            ],
            [
              8131.96,
              -797.979,
              9771.366
            ],
            [
              8199.6,
              -801.56,
              9839.101
            ],
            [
              8316.695,
              -815.038,
              9956.969
            ],
            [
              8390.598,
              -821.883,
              10031.188
            ],
            [
              8436.278,
              -833.024,
              10078.207
            ],
            [
              8452.882,
              -841.15,
              10096.693
            ],
            [
              8489.177,
              -864.145,
              10139.659
            ],
            [
              8593.333,
              -879.597,
              10244.955
            ],
            [
              8629.498,
              -876.985,
              10281.214
            ],
            [
              8793.463,
              -924.493,
              10451.923
            ],
            [
              8878.821,
              -949.094,
              10540.756
            ],
            [
              9226.371,
              -1049.347,
              10902.476
            ],
            [
              9251.576,
              -1055.085,
              10928.326
            ],
            [
              9273.821,
              -1062.554,
              10951.791
            ],
            [
              9471.228,
              -1120.116,
              11157.419
            ],
            [
              9671.66,
              -1185.297,
              11368.184
            ],
            [
              9718.457,
              -1204.068,
              11418.605
            ],
            [
              9984.772,
              -1298.562,
              11701.187
            ],
            [
              9946.688,
              -1403.558,
              11812.876
            ],
            [
              9942.307,
              -1481.305,
              11890.748
            ],
            [
              9920.124,
              -1591.155,
              12002.815
            ],
            [
              9909.928,
              -1637.662,
              12050.426
            ],
            [
              9897.43,
              -1681.89,
              12096.386
            ],
            [
              9882.757,
              -1712.489,
              12130.321
            ],
            [
              9881.662,
              -1714.525,
              12132.633
            ],
            [
              9877.578,
              -1722.12,
              12141.256
            ],
            [
              9854.408,
              -1765.207,
              12190.178
            ],
            [
              9853.104,
              -1767.631,
              12192.931
            ],
            [
              9854.39,
              -1765.24,
              12195.646
            ],
            [
              9858.509,
              -1757.579,
              12204.344
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:6542",
              "position": {
                "x": 673.267,
                "z": -1632.329
              },
              "distanceAlongShapeM": 0.235,
              "shapeOffsetM": 4.37,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:6544",
              "position": {
                "x": 934.987,
                "z": -1318.756
              },
              "distanceAlongShapeM": 409.332,
              "shapeOffsetM": 4.665,
              "arrivalOffsetSeconds": 60,
              "departureOffsetSeconds": 60
            },
            {
              "stopId": "judu:stop:6546",
              "position": {
                "x": 1209.421,
                "z": -982.054
              },
              "distanceAlongShapeM": 843.899,
              "shapeOffsetM": 3.154,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:6565",
              "position": {
                "x": 1714.349,
                "z": -354.636
              },
              "distanceAlongShapeM": 1775.125,
              "shapeOffsetM": 3.268,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:6568",
              "position": {
                "x": 1781.292,
                "z": 89.417
              },
              "distanceAlongShapeM": 2238.725,
              "shapeOffsetM": 3.788,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:6571",
              "position": {
                "x": 2015.503,
                "z": 371.16
              },
              "distanceAlongShapeM": 2605.858,
              "shapeOffsetM": 5.214,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:6574",
              "position": {
                "x": 2244.749,
                "z": 592.868
              },
              "distanceAlongShapeM": 2930.999,
              "shapeOffsetM": 4.597,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:931",
              "position": {
                "x": 2432.805,
                "z": 680.634
              },
              "distanceAlongShapeM": 3276.841,
              "shapeOffsetM": 5.268,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:387",
              "position": {
                "x": 2739.748,
                "z": 435.524
              },
              "distanceAlongShapeM": 3670.569,
              "shapeOffsetM": 5.02,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:5372",
              "position": {
                "x": 3035.88,
                "z": 166.104
              },
              "distanceAlongShapeM": 4071.782,
              "shapeOffsetM": 3.98,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:5373",
              "position": {
                "x": 3506.161,
                "z": -134.47
              },
              "distanceAlongShapeM": 4638.301,
              "shapeOffsetM": 6.06,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:7587",
              "position": {
                "x": 4231.381,
                "z": -421.043
              },
              "distanceAlongShapeM": 5433.98,
              "shapeOffsetM": 5.083,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:5381",
              "position": {
                "x": 4564.597,
                "z": -598.876
              },
              "distanceAlongShapeM": 5827.255,
              "shapeOffsetM": 4.625,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:5384",
              "position": {
                "x": 5584.849,
                "z": -794.495
              },
              "distanceAlongShapeM": 6990.44,
              "shapeOffsetM": 2.994,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:5385",
              "position": {
                "x": 5850.363,
                "z": -902.086
              },
              "distanceAlongShapeM": 7276.533,
              "shapeOffsetM": 3.668,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:5389",
              "position": {
                "x": 6629.435,
                "z": -1027.563
              },
              "distanceAlongShapeM": 8192.062,
              "shapeOffsetM": 2.539,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:5391",
              "position": {
                "x": 7158.01,
                "z": -938.912
              },
              "distanceAlongShapeM": 8779.097,
              "shapeOffsetM": 2.347,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            },
            {
              "stopId": "judu:stop:7586",
              "position": {
                "x": 7545.867,
                "z": -890.94
              },
              "distanceAlongShapeM": 9170.505,
              "shapeOffsetM": 2.118,
              "arrivalOffsetSeconds": 1380,
              "departureOffsetSeconds": 1380
            },
            {
              "stopId": "judu:stop:6054",
              "position": {
                "x": 7958.873,
                "z": -811.219
              },
              "distanceAlongShapeM": 9596.849,
              "shapeOffsetM": 0.976,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            },
            {
              "stopId": "judu:stop:6056",
              "position": {
                "x": 8390.735,
                "z": -820.977
              },
              "distanceAlongShapeM": 10031.188,
              "shapeOffsetM": 0.916,
              "arrivalOffsetSeconds": 1500,
              "departureOffsetSeconds": 1500
            },
            {
              "stopId": "judu:stop:6059",
              "position": {
                "x": 8794.329,
                "z": -921.496
              },
              "distanceAlongShapeM": 10451.921,
              "shapeOffsetM": 3.12,
              "arrivalOffsetSeconds": 1560,
              "departureOffsetSeconds": 1560
            },
            {
              "stopId": "judu:stop:6062",
              "position": {
                "x": 9252.086,
                "z": -1053.208
              },
              "distanceAlongShapeM": 10928.326,
              "shapeOffsetM": 1.945,
              "arrivalOffsetSeconds": 1620,
              "departureOffsetSeconds": 1620
            },
            {
              "stopId": "judu:stop:6065",
              "position": {
                "x": 9672.457,
                "z": -1183.092
              },
              "distanceAlongShapeM": 11368.184,
              "shapeOffsetM": 2.345,
              "arrivalOffsetSeconds": 1680,
              "departureOffsetSeconds": 1680
            },
            {
              "stopId": "judu:stop:6069",
              "position": {
                "x": 9955.997,
                "z": -1381.473
              },
              "distanceAlongShapeM": 11788.941,
              "shapeOffsetM": 1.221,
              "arrivalOffsetSeconds": 1740,
              "departureOffsetSeconds": 1740
            },
            {
              "stopId": "judu:stop:342",
              "position": {
                "x": 9859.336,
                "z": -1758.024
              },
              "distanceAlongShapeM": 12204.344,
              "shapeOffsetM": 0.939,
              "arrivalOffsetSeconds": 1800,
              "departureOffsetSeconds": 1800
            }
          ],
          "departuresSeconds": [
            18720,
            21300,
            22500,
            23580,
            25740,
            27780,
            29280,
            30840,
            33360,
            36360,
            37980,
            40620,
            41940,
            43260,
            45420,
            46740,
            48420,
            50340,
            51660,
            54000,
            55080,
            56400,
            58860,
            60120,
            61860,
            64380,
            65940,
            67740,
            71820,
            73260,
            75060,
            76740,
            78180,
            79740,
            81240,
            82680,
            84120
          ]
        },
        {
          "id": "judu:pattern:vilnius_bus_27:1",
          "sourceRouteId": "vilnius_bus_27",
          "sourceShapeId": "vilnius_bus_27_b-a",
          "directionId": 1,
          "headsign": "Kalvarijų g.",
          "directionName": "Arimų–Olandų–Šeimyniškių–Kalvarijų g.",
          "mode": "bus",
          "routeShortName": "27",
          "routeLongName": "Kalvarijų–Tuskulėnų–Olandų–Arimų g.",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              9858.509,
              -1757.579,
              0
            ],
            [
              9897.43,
              -1681.89,
              85.11
            ],
            [
              9923.019,
              -1575.628,
              194.41
            ],
            [
              9942.374,
              -1480.279,
              291.703
            ],
            [
              9946.338,
              -1412.448,
              359.65
            ],
            [
              9959.785,
              -1362.152,
              411.713
            ],
            [
              9984.772,
              -1298.562,
              480.036
            ],
            [
              9756.88,
              -1217.097,
              722.051
            ],
            [
              9755.854,
              -1218.748,
              723.994
            ],
            [
              9705.012,
              -1199.341,
              778.414
            ],
            [
              9471.228,
              -1120.116,
              1025.257
            ],
            [
              9190.433,
              -1040.826,
              1317.032
            ],
            [
              9149.36,
              -1031.089,
              1359.244
            ],
            [
              9144.271,
              -1027.646,
              1365.388
            ],
            [
              9086.597,
              -1009.78,
              1425.766
            ],
            [
              8773.932,
              -923.659,
              1750.074
            ],
            [
              8687.842,
              -893.745,
              1841.214
            ],
            [
              8644.901,
              -880.635,
              1886.111
            ],
            [
              8624.985,
              -876.894,
              1906.376
            ],
            [
              8593.333,
              -879.597,
              1938.143
            ],
            [
              8489.821,
              -864.158,
              2042.8
            ],
            [
              8477.019,
              -859.447,
              2056.441
            ],
            [
              8459.816,
              -849.082,
              2076.525
            ],
            [
              8449.036,
              -839.959,
              2090.648
            ],
            [
              8421.519,
              -829.387,
              2120.126
            ],
            [
              8324.408,
              -816.306,
              2218.114
            ],
            [
              8300.804,
              -813.952,
              2241.834
            ],
            [
              8276.176,
              -810.703,
              2266.676
            ],
            [
              8198.955,
              -801.547,
              2344.438
            ],
            [
              8122.914,
              -798.912,
              2420.525
            ],
            [
              8006.796,
              -801.043,
              2536.662
            ],
            [
              7987.391,
              -803.996,
              2556.291
            ],
            [
              7940.058,
              -823.961,
              2607.662
            ],
            [
              7856.182,
              -851.475,
              2695.936
            ],
            [
              7787.9,
              -880.172,
              2770.003
            ],
            [
              7580.675,
              -891.632,
              2977.544
            ],
            [
              7571.329,
              -895.108,
              2987.516
            ],
            [
              7532.176,
              -898.461,
              3026.812
            ],
            [
              7253.497,
              -936.349,
              3308.055
            ],
            [
              7157.256,
              -944.463,
              3404.637
            ],
            [
              7057.345,
              -942.487,
              3504.568
            ],
            [
              6862.892,
              -895.228,
              3704.681
            ],
            [
              6815.28,
              -889.836,
              3752.598
            ],
            [
              6765.34,
              -904.438,
              3804.629
            ],
            [
              6738.048,
              -915.033,
              3833.905
            ],
            [
              6715.847,
              -929.068,
              3860.17
            ],
            [
              6696.803,
              -946.506,
              3885.992
            ],
            [
              6633.281,
              -1028.752,
              3989.912
            ],
            [
              6622.445,
              -1048.664,
              4012.581
            ],
            [
              6610.042,
              -1062.806,
              4031.392
            ],
            [
              6570.962,
              -1115.475,
              4096.976
            ],
            [
              6549.276,
              -1136.201,
              4126.974
            ],
            [
              6517.383,
              -1155.506,
              4164.255
            ],
            [
              6489.127,
              -1167.96,
              4195.133
            ],
            [
              6442.717,
              -1177.525,
              4242.519
            ],
            [
              6415.041,
              -1174.783,
              4270.33
            ],
            [
              6351.562,
              -1156.81,
              4336.304
            ],
            [
              6038.333,
              -1050.482,
              4667.088
            ],
            [
              6008.944,
              -1036.548,
              4699.613
            ],
            [
              5986.688,
              -1020.528,
              4727.035
            ],
            [
              5943.683,
              -977.383,
              4787.953
            ],
            [
              5898.548,
              -944.218,
              4843.962
            ],
            [
              5885.268,
              -935.147,
              4860.045
            ],
            [
              5868.614,
              -919.303,
              4883.031
            ],
            [
              5818.307,
              -892.555,
              4940.007
            ],
            [
              5645.523,
              -824.62,
              5125.667
            ],
            [
              5547.012,
              -783.74,
              5232.323
            ],
            [
              5507.663,
              -767.459,
              5274.908
            ],
            [
              5506.77,
              -764.032,
              5278.449
            ],
            [
              5491.429,
              -757.054,
              5295.303
            ],
            [
              5455.547,
              -745.225,
              5333.084
            ],
            [
              5442.719,
              -741.636,
              5346.405
            ],
            [
              5414.837,
              -737.692,
              5374.565
            ],
            [
              5390.419,
              -745.074,
              5400.074
            ],
            [
              5367.858,
              -744.637,
              5422.639
            ],
            [
              5351.184,
              -739.86,
              5439.984
            ],
            [
              5321.211,
              -722.58,
              5474.581
            ],
            [
              5288.289,
              -691.85,
              5519.617
            ],
            [
              5253.788,
              -674.516,
              5558.227
            ],
            [
              5232.565,
              -669.077,
              5580.136
            ],
            [
              5203.415,
              -670.169,
              5609.307
            ],
            [
              5176.283,
              -680.808,
              5638.45
            ],
            [
              5090.249,
              -741.392,
              5743.674
            ],
            [
              5071.379,
              -752.841,
              5765.747
            ],
            [
              5057.387,
              -759.088,
              5781.07
            ],
            [
              5034.723,
              -764.906,
              5804.468
            ],
            [
              5012.162,
              -764.47,
              5827.034
            ],
            [
              4982.617,
              -758.333,
              5857.209
            ],
            [
              4839.288,
              -693.396,
              6014.562
            ],
            [
              4819.925,
              -688.031,
              6034.655
            ],
            [
              4798.602,
              -686.689,
              6056.02
            ],
            [
              4775.46,
              -690.378,
              6079.455
            ],
            [
              4737.447,
              -700.328,
              6118.748
            ],
            [
              4707.696,
              -706.668,
              6149.167
            ],
            [
              4668.211,
              -711.346,
              6188.928
            ],
            [
              4623.675,
              -712.452,
              6233.478
            ],
            [
              4577.237,
              -704.109,
              6280.659
            ],
            [
              4555.062,
              -699.853,
              6303.239
            ],
            [
              4509.764,
              -675.436,
              6354.699
            ],
            [
              4499.453,
              -666.647,
              6368.248
            ],
            [
              4457.56,
              -640.029,
              6417.882
            ],
            [
              4437.737,
              -623.158,
              6443.912
            ],
            [
              4426.454,
              -606.243,
              6464.245
            ],
            [
              4266.373,
              -479.602,
              6668.362
            ],
            [
              4207.404,
              -435.42,
              6742.047
            ],
            [
              4102.373,
              -355.119,
              6874.258
            ],
            [
              4073.746,
              -334.533,
              6909.518
            ],
            [
              4021.499,
              -301.251,
              6971.465
            ],
            [
              3981.246,
              -281.557,
              7016.277
            ],
            [
              3924.337,
              -255.979,
              7078.67
            ],
            [
              3871.834,
              -236.053,
              7134.827
            ],
            [
              3794.896,
              -212.322,
              7215.342
            ],
            [
              3748.025,
              -201.41,
              7263.466
            ],
            [
              3692.751,
              -191.452,
              7319.63
            ],
            [
              3533.915,
              -167.282,
              7480.295
            ],
            [
              3462.884,
              -150.608,
              7553.257
            ],
            [
              3394.357,
              -124.205,
              7626.695
            ],
            [
              3396.087,
              -123.476,
              7628.572
            ],
            [
              3343.728,
              -95.766,
              7687.812
            ],
            [
              3282.595,
              -54.531,
              7761.552
            ],
            [
              2977.671,
              191.693,
              8153.476
            ],
            [
              2944.561,
              216.482,
              8194.837
            ],
            [
              2919.043,
              240.05,
              8229.574
            ],
            [
              2850.195,
              306.534,
              8325.283
            ],
            [
              2697.486,
              451.904,
              8536.12
            ],
            [
              2679.584,
              466.091,
              8558.963
            ],
            [
              2649.901,
              493.988,
              8599.697
            ],
            [
              2582.473,
              544.237,
              8683.789
            ],
            [
              2413.667,
              623.104,
              8870.11
            ],
            [
              2393.054,
              624.603,
              8890.777
            ],
            [
              2378.182,
              622.655,
              8905.777
            ],
            [
              2363.247,
              617.369,
              8921.619
            ],
            [
              2305.672,
              573.917,
              8993.751
            ],
            [
              2269.605,
              542.307,
              9041.709
            ],
            [
              2254.026,
              527.847,
              9062.965
            ],
            [
              2223.804,
              507.54,
              9099.376
            ],
            [
              1990.962,
              334.88,
              9389.25
            ],
            [
              1969.782,
              310.225,
              9421.752
            ],
            [
              1935.827,
              283.585,
              9464.911
            ],
            [
              1864.599,
              199.192,
              9575.345
            ],
            [
              1763.619,
              40.763,
              9763.219
            ],
            [
              1755.04,
              12.778,
              9792.49
            ],
            [
              1734.841,
              -15.477,
              9827.222
            ],
            [
              1714.048,
              -58.507,
              9875.012
            ],
            [
              1702.489,
              -90.576,
              9909.101
            ],
            [
              1692.553,
              -139.375,
              9958.901
            ],
            [
              1696.284,
              -216.258,
              10035.875
            ],
            [
              1701.445,
              -250.864,
              10070.863
            ],
            [
              1720.689,
              -325.809,
              10148.24
            ],
            [
              1730.124,
              -347.569,
              10171.957
            ],
            [
              1742.617,
              -429.749,
              10255.081
            ],
            [
              1739.19,
              -475.328,
              10300.789
            ],
            [
              1717.531,
              -565.098,
              10393.135
            ],
            [
              1721.402,
              -599.681,
              10427.934
            ],
            [
              1720.009,
              -605.221,
              10433.646
            ],
            [
              1711.776,
              -614.79,
              10446.27
            ],
            [
              1700.984,
              -622.679,
              10459.638
            ],
            [
              1684.224,
              -622.368,
              10476.4
            ],
            [
              1662.848,
              -627.537,
              10498.393
            ],
            [
              1381.451,
              -814.909,
              10836.464
            ],
            [
              1363.471,
              -845.747,
              10872.161
            ],
            [
              1363.126,
              -899.177,
              10925.592
            ],
            [
              1355.02,
              -919.065,
              10947.069
            ],
            [
              1339.886,
              -935.484,
              10969.399
            ],
            [
              1325.561,
              -943.011,
              10985.581
            ],
            [
              1293.291,
              -944.641,
              11017.892
            ],
            [
              1278.614,
              -942.95,
              11032.666
            ],
            [
              1269.114,
              -935.31,
              11044.857
            ],
            [
              1257.937,
              -924.707,
              11060.263
            ],
            [
              1253.197,
              -916.068,
              11070.117
            ],
            [
              1249.597,
              -901.529,
              11085.095
            ],
            [
              1250.468,
              -889.3,
              11097.355
            ],
            [
              1243.124,
              -868.013,
              11119.873
            ],
            [
              1234.408,
              -851.153,
              11138.853
            ],
            [
              1218.52,
              -838.613,
              11159.093
            ],
            [
              1192.86,
              -831.46,
              11185.732
            ],
            [
              1155.132,
              -824.781,
              11224.047
            ],
            [
              1120.288,
              -815.648,
              11260.067
            ],
            [
              1031.058,
              -793.963,
              11351.895
            ],
            [
              773.373,
              -745.803,
              11614.041
            ],
            [
              730.608,
              -739.605,
              11657.254
            ],
            [
              702.691,
              -732.259,
              11686.121
            ],
            [
              508.13,
              -687.5,
              11885.764
            ],
            [
              443.852,
              -676.304,
              11951.009
            ],
            [
              405.738,
              -680.059,
              11989.308
            ],
            [
              363.165,
              -686.919,
              12032.43
            ],
            [
              341.718,
              -690.021,
              12054.1
            ],
            [
              238.113,
              -713.732,
              12160.384
            ],
            [
              222.179,
              -844.803,
              12292.42
            ],
            [
              221.447,
              -884.866,
              12332.49
            ],
            [
              235.23,
              -977.516,
              12426.159
            ],
            [
              262.76,
              -1129.419,
              12580.537
            ],
            [
              277.464,
              -1242.125,
              12694.198
            ],
            [
              289.419,
              -1293.552,
              12746.996
            ],
            [
              294.15,
              -1318.635,
              12772.521
            ],
            [
              296.7,
              -1353.8,
              12807.779
            ],
            [
              342.249,
              -1718.661,
              13175.472
            ],
            [
              510.658,
              -1710.612,
              13344.073
            ],
            [
              550.922,
              -1706.707,
              13384.526
            ],
            [
              586.765,
              -1697.182,
              13421.613
            ],
            [
              616.278,
              -1681.379,
              13455.091
            ],
            [
              646.312,
              -1660.778,
              13491.511
            ],
            [
              676.214,
              -1635.564,
              13530.625
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:342",
              "position": {
                "x": 9859.336,
                "z": -1758.024
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 0.939,
              "arrivalOffsetSeconds": -1020,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:6068",
              "position": {
                "x": 9955.14,
                "z": -1360.302
              },
              "distanceAlongShapeM": 411.736,
              "shapeOffsetM": 5,
              "arrivalOffsetSeconds": 60,
              "departureOffsetSeconds": 60
            },
            {
              "stopId": "judu:stop:6066",
              "position": {
                "x": 9754.856,
                "z": -1221.509
              },
              "distanceAlongShapeM": 723.994,
              "shapeOffsetM": 2.936,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:6064",
              "position": {
                "x": 9149.36,
                "z": -1031.089
              },
              "distanceAlongShapeM": 1359.244,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:6060",
              "position": {
                "x": 8772.945,
                "z": -926.631
              },
              "distanceAlongShapeM": 1750.074,
              "shapeOffsetM": 3.132,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:6057",
              "position": {
                "x": 8300.557,
                "z": -815.828
              },
              "distanceAlongShapeM": 2241.834,
              "shapeOffsetM": 1.893,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:6055",
              "position": {
                "x": 7940.535,
                "z": -825.326
              },
              "distanceAlongShapeM": 2607.662,
              "shapeOffsetM": 1.446,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:5417",
              "position": {
                "x": 7571.54,
                "z": -897.017
              },
              "distanceAlongShapeM": 2987.516,
              "shapeOffsetM": 1.921,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:5390",
              "position": {
                "x": 7057.345,
                "z": -942.487
              },
              "distanceAlongShapeM": 3504.568,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:5388",
              "position": {
                "x": 6623.841,
                "z": -1049.718
              },
              "distanceAlongShapeM": 4012.581,
              "shapeOffsetM": 1.749,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:5387",
              "position": {
                "x": 5884.519,
                "z": -936.151
              },
              "distanceAlongShapeM": 4860.045,
              "shapeOffsetM": 1.252,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:5383",
              "position": {
                "x": 5505.995,
                "z": -770.697
              },
              "distanceAlongShapeM": 5274.908,
              "shapeOffsetM": 3.642,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:5382",
              "position": {
                "x": 4576.725,
                "z": -705.983
              },
              "distanceAlongShapeM": 6280.809,
              "shapeOffsetM": 1.937,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            },
            {
              "stopId": "judu:stop:5421",
              "position": {
                "x": 4205.92,
                "z": -437.254
              },
              "distanceAlongShapeM": 6742.112,
              "shapeOffsetM": 2.359,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:5423",
              "position": {
                "x": 3392.114,
                "z": -128.967
              },
              "distanceAlongShapeM": 7626.695,
              "shapeOffsetM": 5.264,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:5424",
              "position": {
                "x": 2941.964,
                "z": 213.518
              },
              "distanceAlongShapeM": 8194.837,
              "shapeOffsetM": 3.941,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:5425",
              "position": {
                "x": 2677.062,
                "z": 463.42
              },
              "distanceAlongShapeM": 8558.971,
              "shapeOffsetM": 3.673,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:6572",
              "position": {
                "x": 2256.376,
                "z": 524.743
              },
              "distanceAlongShapeM": 9062.965,
              "shapeOffsetM": 3.893,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:449",
              "position": {
                "x": 1973.014,
                "z": 306.27
              },
              "distanceAlongShapeM": 9421.752,
              "shapeOffsetM": 5.108,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            },
            {
              "stopId": "judu:stop:603",
              "position": {
                "x": 1759.816,
                "z": 9.663
              },
              "distanceAlongShapeM": 9792.49,
              "shapeOffsetM": 5.702,
              "arrivalOffsetSeconds": 1380,
              "departureOffsetSeconds": 1380
            },
            {
              "stopId": "judu:stop:6566",
              "position": {
                "x": 1735.144,
                "z": -346.116
              },
              "distanceAlongShapeM": 10171.957,
              "shapeOffsetM": 5.226,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            },
            {
              "stopId": "judu:stop:5662",
              "position": {
                "x": 1154.205,
                "z": -829.633
              },
              "distanceAlongShapeM": 11224.047,
              "shapeOffsetM": 4.939,
              "arrivalOffsetSeconds": 1620,
              "departureOffsetSeconds": 1620
            },
            {
              "stopId": "judu:stop:5664",
              "position": {
                "x": 729.54,
                "z": -744.998
              },
              "distanceAlongShapeM": 11657.254,
              "shapeOffsetM": 5.498,
              "arrivalOffsetSeconds": 1680,
              "departureOffsetSeconds": 1680
            },
            {
              "stopId": "judu:stop:677",
              "position": {
                "x": 364.219,
                "z": -693.772
              },
              "distanceAlongShapeM": 12032.43,
              "shapeOffsetM": 6.934,
              "arrivalOffsetSeconds": 1800,
              "departureOffsetSeconds": 1800
            },
            {
              "stopId": "judu:stop:6843",
              "position": {
                "x": 297.35,
                "z": -1318.188
              },
              "distanceAlongShapeM": 12772.521,
              "shapeOffsetM": 3.231,
              "arrivalOffsetSeconds": 1980,
              "departureOffsetSeconds": 1980
            },
            {
              "stopId": "judu:stop:6542",
              "position": {
                "x": 673.267,
                "z": -1632.329
              },
              "distanceAlongShapeM": 13530.457,
              "shapeOffsetM": 4.373,
              "arrivalOffsetSeconds": 2160,
              "departureOffsetSeconds": 2160
            }
          ],
          "departuresSeconds": [
            19260,
            21540,
            28560,
            31080,
            34140,
            35760,
            38460,
            39780,
            41100,
            43260,
            44580,
            46260,
            48120,
            49440,
            51840,
            52920,
            54240,
            56640,
            57900,
            59640,
            62040,
            63600,
            65520,
            69660,
            71100,
            72900,
            74640,
            76140,
            77640,
            79140,
            80640,
            82140
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_bus_28",
      "sourceRouteId": "vilnius_bus_28",
      "mode": "bus",
      "shortName": "28",
      "longName": "Žemieji Paneriai–Grigiškės–Valai",
      "color": "0073AC",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_bus_28:0",
          "sourceRouteId": "vilnius_bus_28",
          "sourceShapeId": "vilnius_bus_28_a-b",
          "directionId": 0,
          "headsign": "Valai",
          "directionName": "Žemieji Paneriai–Grigiškės–Valai",
          "mode": "bus",
          "routeShortName": "28",
          "routeLongName": "Žemieji Paneriai–Grigiškės–Valai",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              -4326.297,
              4774.12,
              0
            ],
            [
              -4341.701,
              4789.561,
              21.811
            ],
            [
              -4357.738,
              4810.298,
              48.026
            ],
            [
              -4435.232,
              4883.989,
              154.963
            ],
            [
              -4468.845,
              4919.076,
              203.553
            ],
            [
              -4486.139,
              4928.009,
              223.018
            ],
            [
              -4509.692,
              4946.495,
              252.959
            ],
            [
              -4579.258,
              4993.33,
              336.822
            ],
            [
              -4600.366,
              5004.825,
              360.857
            ],
            [
              -4803.437,
              5135.209,
              602.182
            ],
            [
              -5487.637,
              5563.199,
              1409.217
            ],
            [
              -5524.11,
              5582.742,
              1450.595
            ],
            [
              -5595.44,
              5602.875,
              1524.712
            ],
            [
              -5632.195,
              5605.723,
              1561.577
            ],
            [
              -5680.721,
              5599.865,
              1610.456
            ],
            [
              -5736.61,
              5578.547,
              1670.272
            ],
            [
              -5812.979,
              5529.744,
              1760.903
            ],
            [
              -8196.815,
              3831.718,
              4687.67
            ],
            [
              -8219.797,
              3805.97,
              4722.184
            ],
            [
              -8229.505,
              3779.848,
              4750.051
            ],
            [
              -8228.952,
              3761.001,
              4768.906
            ],
            [
              -8222.183,
              3740.854,
              4790.16
            ],
            [
              -8213.763,
              3729.797,
              4804.058
            ],
            [
              -8191.613,
              3715.863,
              4830.226
            ],
            [
              -8152.917,
              3714.116,
              4868.962
            ],
            [
              -8136.659,
              3721.642,
              4886.877
            ],
            [
              -8123.535,
              3734.785,
              4905.451
            ],
            [
              -8112.211,
              3751.45,
              4925.599
            ],
            [
              -8109.604,
              3779.072,
              4953.344
            ],
            [
              -8127.628,
              3839.491,
              5016.394
            ],
            [
              -8128.299,
              3835.847,
              5020.1
            ],
            [
              -8156.66,
              3919.002,
              5107.958
            ],
            [
              -8177.277,
              3951.786,
              5146.687
            ],
            [
              -8195.31,
              3963.048,
              5167.947
            ],
            [
              -8228.619,
              3966.047,
              5201.391
            ],
            [
              -8312.285,
              3953.83,
              5285.944
            ],
            [
              -8659.37,
              3923.869,
              5634.32
            ],
            [
              -8752.504,
              3912.026,
              5728.204
            ],
            [
              -8779.176,
              3899.101,
              5757.843
            ],
            [
              -8720.652,
              3687.761,
              5977.136
            ],
            [
              -8720.627,
              3672.793,
              5992.104
            ],
            [
              -8968.433,
              3531.486,
              6277.368
            ],
            [
              -9013.904,
              3513.299,
              6326.341
            ],
            [
              -9022.955,
              3512.332,
              6335.444
            ],
            [
              -9026.79,
              3514.621,
              6339.91
            ],
            [
              -9027.9,
              3525.77,
              6351.114
            ],
            [
              -9023.903,
              3533.498,
              6359.814
            ],
            [
              -8978.306,
              3559.475,
              6412.292
            ],
            [
              -8907.726,
              3573.916,
              6484.334
            ],
            [
              -8721.671,
              3676.772,
              6696.927
            ],
            [
              -8779.176,
              3899.101,
              6926.572
            ],
            [
              -8775.178,
              3906.828,
              6935.272
            ],
            [
              -8725.24,
              3921.601,
              6987.35
            ],
            [
              -8451.198,
              3944.967,
              7262.386
            ],
            [
              -8270.179,
              3963.16,
              7444.317
            ],
            [
              -8258.746,
              3951.842,
              7460.405
            ],
            [
              -8250.691,
              3936.001,
              7478.176
            ],
            [
              -8249.705,
              3912.733,
              7501.465
            ],
            [
              -8244.494,
              3893.901,
              7521.005
            ],
            [
              -8227.04,
              3877.853,
              7544.715
            ],
            [
              -8207.789,
              3867.881,
              7566.395
            ],
            [
              -8172.267,
              3872.504,
              7602.217
            ],
            [
              -8063.214,
              3949.752,
              7735.857
            ],
            [
              -8055.069,
              3974.108,
              7761.539
            ],
            [
              -8056.022,
              4005.21,
              7792.656
            ],
            [
              -8074.251,
              4024.515,
              7819.207
            ],
            [
              -8096.081,
              4031.552,
              7842.143
            ],
            [
              -8116.498,
              4027.676,
              7862.925
            ],
            [
              -8133.78,
              4015.473,
              7884.081
            ],
            [
              -8144.922,
              3998.921,
              7904.034
            ],
            [
              -8147.86,
              3983.421,
              7919.81
            ],
            [
              -8144.789,
              3964.366,
              7939.11
            ],
            [
              -8140.12,
              3941.964,
              7961.994
            ],
            [
              -8132.895,
              3911.933,
              7992.882
            ],
            [
              -8107.695,
              3848.767,
              8060.889
            ],
            [
              -8090.367,
              3814.163,
              8099.59
            ],
            [
              -8059.799,
              3799.633,
              8133.434
            ],
            [
              -8032.187,
              3798.122,
              8161.088
            ],
            [
              -8004.709,
              3810.411,
              8191.189
            ],
            [
              -7987.528,
              3830.701,
              8217.776
            ],
            [
              -7981.589,
              3860.471,
              8248.133
            ],
            [
              -7986.014,
              3885.568,
              8273.616
            ],
            [
              -8001.623,
              3905.998,
              8299.326
            ],
            [
              -8026.293,
              3920.116,
              8327.75
            ],
            [
              -8048.743,
              3922.393,
              8350.315
            ],
            [
              -8074.376,
              3914.747,
              8377.065
            ],
            [
              -8128.171,
              3885.14,
              8438.469
            ],
            [
              -8196.815,
              3831.718,
              8525.451
            ],
            [
              -8342.269,
              3738.365,
              8698.285
            ],
            [
              -8673.968,
              3542.289,
              9083.603
            ],
            [
              -9951.171,
              2814.843,
              10553.442
            ],
            [
              -10347.037,
              2591.844,
              11007.797
            ],
            [
              -10561.984,
              2505.092,
              11239.59
            ],
            [
              -10579.01,
              2448.591,
              11298.601
            ],
            [
              -10587.05,
              2429.795,
              11319.044
            ],
            [
              -10670.197,
              2394.378,
              11409.42
            ],
            [
              -10687.101,
              2384.205,
              11429.149
            ],
            [
              -10763.768,
              2356.721,
              11510.593
            ],
            [
              -10781.724,
              2355.749,
              11528.576
            ],
            [
              -10804.219,
              2359.617,
              11551.401
            ],
            [
              -10821.776,
              2366.457,
              11570.243
            ],
            [
              -10871.238,
              2410.915,
              11636.749
            ],
            [
              -10882.01,
              2423.329,
              11653.185
            ],
            [
              -10933.179,
              2410.779,
              11705.87
            ],
            [
              -11014.265,
              2383.116,
              11791.545
            ],
            [
              -11042.752,
              2376.885,
              11820.706
            ],
            [
              -11076.277,
              2378.406,
              11854.265
            ],
            [
              -11111.6,
              2375.848,
              11889.681
            ],
            [
              -11167.733,
              2347.684,
              11952.483
            ],
            [
              -11175.682,
              2356.108,
              11964.065
            ],
            [
              -11188.898,
              2381.881,
              11993.029
            ],
            [
              -11209.837,
              2410.442,
              12028.443
            ],
            [
              -11223.935,
              2425.375,
              12048.98
            ],
            [
              -11236.068,
              2433.358,
              12063.504
            ],
            [
              -11281.586,
              2451.884,
              12112.647
            ],
            [
              -11308.608,
              2456.76,
              12140.106
            ],
            [
              -11333.037,
              2457.586,
              12164.548
            ],
            [
              -11358.106,
              2453.226,
              12189.993
            ],
            [
              -11401.258,
              2432.42,
              12237.9
            ],
            [
              -11422.36,
              2422.676,
              12261.143
            ],
            [
              -11657.133,
              2308.505,
              12522.205
            ],
            [
              -11912.888,
              2185.736,
              12805.9
            ],
            [
              -11986.897,
              2154.558,
              12886.208
            ],
            [
              -12000.581,
              2145.866,
              12902.419
            ],
            [
              -12140.971,
              2079.03,
              13057.907
            ],
            [
              -12149.434,
              2068.558,
              13071.371
            ],
            [
              -12133.47,
              2034.328,
              13109.14
            ],
            [
              -12034.298,
              1818.238,
              13346.901
            ],
            [
              -12277.032,
              1708.233,
              13613.398
            ],
            [
              -12423.127,
              1639.755,
              13774.746
            ],
            [
              -12458.258,
              1627.549,
              13811.937
            ],
            [
              -12567.481,
              1592.439,
              13926.665
            ],
            [
              -12596.82,
              1650.319,
              13991.556
            ],
            [
              -12647.185,
              1758.475,
              14110.864
            ],
            [
              -12661.996,
              1802.116,
              14156.949
            ],
            [
              -12664.589,
              1812.84,
              14167.982
            ],
            [
              -12603.058,
              1859.092,
              14244.959
            ],
            [
              -12599.171,
              1860.145,
              14248.986
            ],
            [
              -12592.773,
              1856.707,
              14256.249
            ],
            [
              -12663.063,
              1816.603,
              14337.175
            ],
            [
              -12638.674,
              1738.412,
              14419.082
            ],
            [
              -12603.997,
              1662.557,
              14502.486
            ],
            [
              -12566.957,
              1592.377,
              14581.842
            ],
            [
              -12880.937,
              1491.574,
              14911.606
            ],
            [
              -12907.234,
              1484.961,
              14938.721
            ],
            [
              -12988.696,
              1481.515,
              15020.257
            ],
            [
              -13059.848,
              1460.667,
              15094.401
            ],
            [
              -13068.219,
              1449.327,
              15108.495
            ],
            [
              -13071.783,
              1413.24,
              15144.758
            ],
            [
              -13056.223,
              1376.267,
              15184.872
            ],
            [
              -13028.715,
              1361.375,
              15216.152
            ],
            [
              -12991.311,
              1360.802,
              15253.56
            ],
            [
              -12977.192,
              1356.133,
              15268.431
            ],
            [
              -12974.022,
              1310.445,
              15314.229
            ],
            [
              -12989.08,
              1253.905,
              15372.74
            ],
            [
              -13030.72,
              1150.285,
              15484.413
            ],
            [
              -13075.394,
              1089.947,
              15559.49
            ],
            [
              -13296.265,
              863.436,
              15875.862
            ],
            [
              -13335.311,
              798.356,
              15951.757
            ],
            [
              -13385.005,
              712.487,
              16050.969
            ],
            [
              -13413.984,
              680.585,
              16094.068
            ],
            [
              -13416.911,
              649.325,
              16125.464
            ],
            [
              -13432.388,
              620.409,
              16158.261
            ],
            [
              -13439.172,
              585.102,
              16194.214
            ],
            [
              -13438.367,
              539.542,
              16239.781
            ],
            [
              -13457.339,
              431.84,
              16349.142
            ],
            [
              -13484.148,
              324.09,
              16460.177
            ],
            [
              -13488.966,
              279.744,
              16504.784
            ],
            [
              -13487.235,
              228.51,
              16556.047
            ],
            [
              -13489.901,
              169.766,
              16614.851
            ],
            [
              -13504.299,
              77.384,
              16708.349
            ],
            [
              -13518.177,
              21.566,
              16765.866
            ],
            [
              -13518.26,
              7.468,
              16779.964
            ],
            [
              -13498.681,
              -19.545,
              16813.326
            ],
            [
              -13493.234,
              -43.004,
              16837.409
            ],
            [
              -13495.1,
              -80.823,
              16875.274
            ],
            [
              -13500.157,
              -97.749,
              16892.939
            ],
            [
              -13538.993,
              -183.589,
              16987.156
            ],
            [
              -13542.974,
              -209.87,
              17013.737
            ],
            [
              -13549.826,
              -264.566,
              17068.861
            ],
            [
              -13557.6,
              -282.167,
              17088.102
            ],
            [
              -13627.459,
              -325.826,
              17170.481
            ],
            [
              -13647.467,
              -350.688,
              17202.394
            ],
            [
              -13659.68,
              -387.776,
              17241.441
            ],
            [
              -13677.158,
              -452.374,
              17308.362
            ],
            [
              -13698.166,
              -513.645,
              17373.134
            ],
            [
              -13704.843,
              -539.158,
              17399.507
            ],
            [
              -13725.062,
              -647.208,
              17509.432
            ],
            [
              -13766.588,
              -748.65,
              17619.045
            ],
            [
              -13858.959,
              -901.254,
              17797.427
            ],
            [
              -13867.988,
              -938.951,
              17836.191
            ],
            [
              -13874.303,
              -977.829,
              17875.578
            ],
            [
              -13859.963,
              -1052.627,
              17951.738
            ],
            [
              -13854.362,
              -1067.382,
              17967.52
            ],
            [
              -13837.347,
              -1064.234,
              17984.824
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:5567",
              "position": {
                "x": -4488.111,
                "z": 4924.973
              },
              "distanceAlongShapeM": 223.018,
              "shapeOffsetM": 3.62,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:6294",
              "position": {
                "x": -8136.789,
                "z": 3831.848
              },
              "distanceAlongShapeM": 5020.1,
              "shapeOffsetM": 9.385,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:4455",
              "position": {
                "x": -8968.433,
                "z": 3531.486
              },
              "distanceAlongShapeM": 6277.368,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:9109",
              "position": {
                "x": -10685.89,
                "z": 2381.268
              },
              "distanceAlongShapeM": 11429.149,
              "shapeOffsetM": 3.177,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:9834",
              "position": {
                "x": -11398.758,
                "z": 2427.006
              },
              "distanceAlongShapeM": 12237.9,
              "shapeOffsetM": 5.963,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:8944",
              "position": {
                "x": -11656.141,
                "z": 2306.359
              },
              "distanceAlongShapeM": 12522.239,
              "shapeOffsetM": 2.364,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:6603",
              "position": {
                "x": -11912.865,
                "z": 2185.688
              },
              "distanceAlongShapeM": 12805.9,
              "shapeOffsetM": 0.053,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:9082",
              "position": {
                "x": -12128.727,
                "z": 2036.54
              },
              "distanceAlongShapeM": 13109.14,
              "shapeOffsetM": 5.234,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:9614",
              "position": {
                "x": -12592.773,
                "z": 1856.707
              },
              "distanceAlongShapeM": 14256.249,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1380,
              "departureOffsetSeconds": 1380
            },
            {
              "stopId": "judu:stop:16268",
              "position": {
                "x": -13073.534,
                "z": 1088.227
              },
              "distanceAlongShapeM": 15559.49,
              "shapeOffsetM": 2.533,
              "arrivalOffsetSeconds": 1620,
              "departureOffsetSeconds": 1620
            },
            {
              "stopId": "judu:stop:16266",
              "position": {
                "x": -13381.804,
                "z": 710.013
              },
              "distanceAlongShapeM": 16050.969,
              "shapeOffsetM": 4.045,
              "arrivalOffsetSeconds": 1740,
              "departureOffsetSeconds": 1740
            },
            {
              "stopId": "judu:stop:10250",
              "position": {
                "x": -13839.473,
                "z": -1061.843
              },
              "distanceAlongShapeM": 17983.168,
              "shapeOffsetM": 2.738,
              "arrivalOffsetSeconds": 1920,
              "departureOffsetSeconds": 1920
            }
          ],
          "departuresSeconds": [
            18300,
            19860,
            21300,
            23220,
            25020,
            26400,
            28500,
            31740,
            36540,
            41400,
            46260,
            51180,
            53100,
            55020,
            56520,
            58140,
            59820,
            61500,
            63180,
            64980,
            68280,
            72720,
            77400
          ]
        },
        {
          "id": "judu:pattern:vilnius_bus_28:1",
          "sourceRouteId": "vilnius_bus_28",
          "sourceShapeId": "vilnius_bus_28_b-a",
          "directionId": 1,
          "headsign": "Žemieji Paneriai",
          "directionName": "Valai–Grigiškės–Žemieji Paneriai",
          "mode": "bus",
          "routeShortName": "28",
          "routeLongName": "Žemieji Paneriai–Grigiškės–Valai",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              -13837.716,
              -1064.47,
              0
            ],
            [
              -13848.698,
              -1075.061,
              15.257
            ],
            [
              -13859.062,
              -1078.243,
              26.098
            ],
            [
              -13873.557,
              -968.005,
              137.285
            ],
            [
              -13864.869,
              -913.661,
              192.319
            ],
            [
              -13826.173,
              -843.421,
              272.513
            ],
            [
              -13771.038,
              -757.877,
              374.286
            ],
            [
              -13727.673,
              -649.572,
              490.949
            ],
            [
              -13703.305,
              -532.99,
              610.052
            ],
            [
              -13698.55,
              -515.133,
              628.53
            ],
            [
              -13675.32,
              -446.779,
              700.724
            ],
            [
              -13665.831,
              -408.979,
              739.696
            ],
            [
              -13642.837,
              -340.166,
              812.25
            ],
            [
              -13559.532,
              -284.273,
              912.568
            ],
            [
              -13547.571,
              -248.746,
              950.055
            ],
            [
              -13538.832,
              -182.723,
              1016.654
            ],
            [
              -13497.831,
              -90.8,
              1117.306
            ],
            [
              -13492.199,
              -59.717,
              1148.895
            ],
            [
              -13498.681,
              -19.545,
              1189.586
            ],
            [
              -13519.107,
              17.351,
              1231.759
            ],
            [
              -13498.972,
              101.82,
              1318.596
            ],
            [
              -13487.686,
              195.199,
              1412.653
            ],
            [
              -13484.593,
              320.728,
              1538.22
            ],
            [
              -13442.952,
              519.319,
              1741.131
            ],
            [
              -13440.442,
              587.897,
              1809.754
            ],
            [
              -13430.854,
              623.523,
              1846.648
            ],
            [
              -13418.261,
              650.042,
              1876.005
            ],
            [
              -13413.984,
              680.585,
              1906.846
            ],
            [
              -13352.772,
              771.816,
              2016.71
            ],
            [
              -13308.578,
              849.265,
              2105.881
            ],
            [
              -13281.064,
              883.185,
              2149.557
            ],
            [
              -13090.682,
              1077.852,
              2421.844
            ],
            [
              -13049.825,
              1120.145,
              2480.649
            ],
            [
              -13016.643,
              1183.958,
              2552.574
            ],
            [
              -12990.25,
              1261.715,
              2634.688
            ],
            [
              -12972.818,
              1304.861,
              2681.222
            ],
            [
              -12977.192,
              1356.133,
              2732.681
            ],
            [
              -12990.004,
              1361.895,
              2746.729
            ],
            [
              -13008.179,
              1357.001,
              2765.551
            ],
            [
              -13040.916,
              1364.902,
              2799.228
            ],
            [
              -13056.604,
              1376.489,
              2818.731
            ],
            [
              -13069.323,
              1399.05,
              2844.63
            ],
            [
              -13074.506,
              1424.459,
              2870.563
            ],
            [
              -13069.999,
              1445.494,
              2892.075
            ],
            [
              -13056.184,
              1463.092,
              2914.448
            ],
            [
              -13023.106,
              1474.83,
              2949.547
            ],
            [
              -12950.579,
              1485.229,
              3022.815
            ],
            [
              -12873.164,
              1493.681,
              3100.69
            ],
            [
              -12567.071,
              1592.39,
              3422.306
            ],
            [
              -12610.158,
              1672.444,
              3513.219
            ],
            [
              -12644.811,
              1745.081,
              3593.698
            ],
            [
              -12665.694,
              1813.304,
              3665.046
            ],
            [
              -12665.568,
              1823.821,
              3675.564
            ],
            [
              -12604.297,
              1862.45,
              3747.996
            ],
            [
              -12592.773,
              1856.707,
              3760.871
            ],
            [
              -12609.12,
              1842.488,
              3782.537
            ],
            [
              -12664.399,
              1812.687,
              3845.337
            ],
            [
              -12663.097,
              1814.378,
              3847.471
            ],
            [
              -12644.743,
              1749.532,
              3914.865
            ],
            [
              -12604.207,
              1662.909,
              4010.503
            ],
            [
              -12567.595,
              1592.452,
              4089.905
            ],
            [
              -12417.527,
              1642.075,
              4247.964
            ],
            [
              -12254.81,
              1722.219,
              4429.347
            ],
            [
              -12206.592,
              1746.184,
              4483.192
            ],
            [
              -12156.838,
              1767.73,
              4537.412
            ],
            [
              -12052.602,
              1832.132,
              4659.938
            ],
            [
              -12150.225,
              2064.703,
              4912.166
            ],
            [
              -12150.767,
              2071.39,
              4918.875
            ],
            [
              -12148.083,
              2078.027,
              4926.034
            ],
            [
              -11899.166,
              2197.592,
              5202.179
            ],
            [
              -11701.74,
              2290.557,
              5420.397
            ],
            [
              -11377.941,
              2445.282,
              5779.265
            ],
            [
              -11340.565,
              2456.843,
              5818.388
            ],
            [
              -11266.78,
              2448.701,
              5892.621
            ],
            [
              -11227.326,
              2428.015,
              5937.169
            ],
            [
              -11208.103,
              2411.357,
              5962.605
            ],
            [
              -11191.877,
              2389.948,
              5989.468
            ],
            [
              -11131.53,
              2270.307,
              6123.467
            ],
            [
              -10823.011,
              2415.895,
              6464.612
            ],
            [
              -10425.338,
              2577.505,
              6893.869
            ],
            [
              -10235.484,
              2674.832,
              7107.216
            ],
            [
              -9100.321,
              3317.667,
              8411.759
            ],
            [
              -8701.097,
              3553.784,
              8875.582
            ],
            [
              -8694.717,
              3576.022,
              8898.717
            ],
            [
              -8713.452,
              3654.249,
              8979.156
            ],
            [
              -8719.803,
              3669.656,
              8995.821
            ],
            [
              -8720.385,
              3671.872,
              8998.112
            ],
            [
              -8720.466,
              3672.182,
              8998.432
            ],
            [
              -8968.433,
              3531.486,
              9283.534
            ],
            [
              -9013.223,
              3515.514,
              9331.086
            ],
            [
              -9020.32,
              3515.629,
              9338.184
            ],
            [
              -9024.119,
              3520.143,
              9344.084
            ],
            [
              -9020.695,
              3532.333,
              9356.746
            ],
            [
              -9010.873,
              3541.079,
              9369.897
            ],
            [
              -8971.782,
              3563.822,
              9415.123
            ],
            [
              -8965.957,
              3564.841,
              9421.036
            ],
            [
              -8962.122,
              3562.553,
              9425.502
            ],
            [
              -8955.814,
              3553.545,
              9436.499
            ],
            [
              -8939.003,
              3555.499,
              9453.423
            ],
            [
              -8721.164,
              3674.84,
              9701.81
            ],
            [
              -8720.869,
              3674.406,
              9702.335
            ],
            [
              -8717.052,
              3671.005,
              9707.447
            ],
            [
              -8696.583,
              3593.723,
              9787.394
            ],
            [
              -8681.116,
              3580.213,
              9807.931
            ],
            [
              -8670.808,
              3575.782,
              9819.151
            ],
            [
              -8641.111,
              3578.489,
              9848.971
            ],
            [
              -8411.763,
              3711.671,
              10114.184
            ],
            [
              -8298.292,
              3783.286,
              10248.364
            ],
            [
              -8231.731,
              3827.837,
              10328.459
            ],
            [
              -7508.767,
              4341.367,
              11215.245
            ],
            [
              -6658.319,
              4940.599,
              12255.601
            ],
            [
              -6504.085,
              5052.678,
              12446.258
            ],
            [
              -5804.914,
              5548.532,
              13303.411
            ],
            [
              -5744.224,
              5586.468,
              13374.982
            ],
            [
              -5688.924,
              5611.136,
              13435.534
            ],
            [
              -5631.932,
              5621.303,
              13493.426
            ],
            [
              -5579.095,
              5614.843,
              13546.656
            ],
            [
              -5534.174,
              5598.497,
              13594.459
            ],
            [
              -5442.053,
              5547.954,
              13699.535
            ],
            [
              -4778.303,
              5132.552,
              14482.556
            ],
            [
              -4580.889,
              5011.17,
              14714.301
            ],
            [
              -4534.858,
              4984.776,
              14767.363
            ],
            [
              -4518.9,
              4977.81,
              14784.775
            ],
            [
              -4380.813,
              4857.45,
              14967.954
            ],
            [
              -4298.311,
              4774.766,
              15084.758
            ],
            [
              -4237.94,
              4719.179,
              15166.822
            ],
            [
              -4229.781,
              4705.68,
              15182.596
            ],
            [
              -4240.925,
              4695.853,
              15197.454
            ],
            [
              -4266.982,
              4719.679,
              15232.761
            ],
            [
              -4289.168,
              4743.439,
              15265.269
            ],
            [
              -4306.085,
              4753.859,
              15285.138
            ],
            [
              -4314.059,
              4761.853,
              15296.429
            ],
            [
              -4326.297,
              4774.12,
              15313.756
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:10250",
              "position": {
                "x": -13839.473,
                "z": -1061.843
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 3.161,
              "arrivalOffsetSeconds": -300,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:16263",
              "position": {
                "x": -13355.045,
                "z": 773.055
              },
              "distanceAlongShapeM": 2016.472,
              "shapeOffsetM": 2.578,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:16267",
              "position": {
                "x": -13093.644,
                "z": 1080.743
              },
              "distanceAlongShapeM": 2421.866,
              "shapeOffsetM": 4.138,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:9614",
              "position": {
                "x": -12592.773,
                "z": 1856.707
              },
              "distanceAlongShapeM": 3760.871,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:15964",
              "position": {
                "x": -12209.896,
                "z": 1752.832
              },
              "distanceAlongShapeM": 4483.192,
              "shapeOffsetM": 7.424,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:16236",
              "position": {
                "x": -12092.77,
                "z": 1942.477
              },
              "distanceAlongShapeM": 4777.229,
              "shapeOffsetM": 5.671,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:8945",
              "position": {
                "x": -11899.757,
                "z": 2198.842
              },
              "distanceAlongShapeM": 5202.179,
              "shapeOffsetM": 1.382,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:6604",
              "position": {
                "x": -11702.181,
                "z": 2291.494
              },
              "distanceAlongShapeM": 5420.403,
              "shapeOffsetM": 1.035,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:4454",
              "position": {
                "x": -11189.627,
                "z": 2391.441
              },
              "distanceAlongShapeM": 5989.468,
              "shapeOffsetM": 2.7,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:4455",
              "position": {
                "x": -8968.433,
                "z": 3531.486
              },
              "distanceAlongShapeM": 9283.534,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:6850",
              "position": {
                "x": -4517.509,
                "z": 4980.025
              },
              "distanceAlongShapeM": 14784.775,
              "shapeOffsetM": 2.616,
              "arrivalOffsetSeconds": 1620,
              "departureOffsetSeconds": 1620
            }
          ],
          "departuresSeconds": [
            20460,
            20520,
            22140,
            22860,
            23580,
            25620,
            27360,
            27720,
            28680,
            31080,
            34020,
            38880,
            43740,
            48660,
            53520,
            55440,
            56520,
            57360,
            58980,
            60600,
            61440,
            62340,
            63960,
            64020,
            65700,
            66480,
            67380,
            70320,
            70620,
            74700,
            75060,
            79080,
            79740,
            83400
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_bus_29",
      "sourceRouteId": "vilnius_bus_29",
      "mode": "bus",
      "shortName": "29",
      "longName": "Vilkpėdė–Žemaitės g.–Lazdynai–Grigiškės",
      "color": "0073AC",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_bus_29:0",
          "sourceRouteId": "vilnius_bus_29",
          "sourceShapeId": "vilnius_bus_29_a-b",
          "directionId": 0,
          "headsign": "Grigiškės",
          "directionName": "Vilkpėdė–Žemaitės g.–Lazdynai–Grigiškės",
          "mode": "bus",
          "routeShortName": "29",
          "routeLongName": "Vilkpėdė–Žemaitės g.–Lazdynai–Grigiškės",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              -2004.833,
              2545.942,
              0
            ],
            [
              -2009.26,
              2545.063,
              4.513
            ],
            [
              -2019.015,
              2540.783,
              15.166
            ],
            [
              -2077.913,
              2530.695,
              74.921
            ],
            [
              -2082.858,
              2558.783,
              103.441
            ],
            [
              -2083.009,
              2570.861,
              115.52
            ],
            [
              -2085.436,
              2584.647,
              129.518
            ],
            [
              -2057.496,
              2590.447,
              158.053
            ],
            [
              -2049.628,
              2587.512,
              166.451
            ],
            [
              -2043.42,
              2571.065,
              184.031
            ],
            [
              -2044.167,
              2564.653,
              190.486
            ],
            [
              -2036.471,
              2538.866,
              217.397
            ],
            [
              -2016.375,
              2544.076,
              238.157
            ],
            [
              -2000.11,
              2551.579,
              256.07
            ],
            [
              -1974.301,
              2587.857,
              300.591
            ],
            [
              -1936.092,
              2569.619,
              342.93
            ],
            [
              -1765.274,
              2512.896,
              522.92
            ],
            [
              -1632.053,
              2457.088,
              667.358
            ],
            [
              -1568.278,
              2436.193,
              734.469
            ],
            [
              -1527.823,
              2404.02,
              786.157
            ],
            [
              -1400.63,
              2277.747,
              965.386
            ],
            [
              -1328.942,
              2195.633,
              1074.39
            ],
            [
              -1190.297,
              2047.317,
              1277.417
            ],
            [
              -1413.741,
              1770.628,
              1633.063
            ],
            [
              -1434.923,
              1753.354,
              1660.395
            ],
            [
              -1515.962,
              1659.065,
              1784.725
            ],
            [
              -1594.12,
              1581.422,
              1894.893
            ],
            [
              -1688.349,
              1470.667,
              2040.309
            ],
            [
              -1695.542,
              1465.229,
              2049.326
            ],
            [
              -1708.441,
              1465.459,
              2062.227
            ],
            [
              -1712.191,
              1472.205,
              2069.946
            ],
            [
              -1970.62,
              1705.012,
              2417.774
            ],
            [
              -1985.783,
              1723.093,
              2441.372
            ],
            [
              -2263.842,
              1978.495,
              2818.925
            ],
            [
              -2290.557,
              2000.118,
              2853.295
            ],
            [
              -2318.992,
              2034.018,
              2897.541
            ],
            [
              -2425.036,
              2130.514,
              3040.918
            ],
            [
              -2441.629,
              2140.826,
              3060.454
            ],
            [
              -2453.884,
              2141.043,
              3072.711
            ],
            [
              -2464.869,
              2140.123,
              3083.734
            ],
            [
              -2491.57,
              2126.123,
              3113.883
            ],
            [
              -2514.888,
              2120.968,
              3137.764
            ],
            [
              -2528.453,
              2120.094,
              3151.357
            ],
            [
              -2551.595,
              2124.955,
              3175.004
            ],
            [
              -2561.443,
              2130.364,
              3186.241
            ],
            [
              -2579.681,
              2142.148,
              3207.954
            ],
            [
              -2607.297,
              2186.05,
              3259.819
            ],
            [
              -2618.809,
              2191.819,
              3272.696
            ],
            [
              -2625.885,
              2193.057,
              3279.879
            ],
            [
              -2640.075,
              2193.306,
              3294.071
            ],
            [
              -2665.388,
              2184.846,
              3320.761
            ],
            [
              -2681.67,
              2176.227,
              3339.183
            ],
            [
              -2692.184,
              2172.41,
              3350.369
            ],
            [
              -2745.273,
              2155.082,
              3406.214
            ],
            [
              -2858.912,
              2113.664,
              3527.166
            ],
            [
              -2885.494,
              2106.338,
              3554.739
            ],
            [
              -2963.852,
              2089.902,
              3634.802
            ],
            [
              -3175.505,
              2014.571,
              3859.461
            ],
            [
              -3269.998,
              1973.346,
              3962.555
            ],
            [
              -3463.705,
              1914.962,
              4164.87
            ],
            [
              -3534.885,
              1902.843,
              4237.074
            ],
            [
              -3642.009,
              1901.368,
              4344.208
            ],
            [
              -3703.185,
              1907.997,
              4405.742
            ],
            [
              -3763.581,
              1922.405,
              4467.833
            ],
            [
              -4034.529,
              1998.346,
              4749.222
            ],
            [
              -4081.754,
              2006.899,
              4797.216
            ],
            [
              -4108.338,
              2013.522,
              4824.612
            ],
            [
              -4294.183,
              2056.264,
              5015.309
            ],
            [
              -4414.529,
              2073.923,
              5136.943
            ],
            [
              -4474.544,
              2075.053,
              5196.969
            ],
            [
              -4495.165,
              2075.221,
              5217.59
            ],
            [
              -4714.759,
              2061.271,
              5437.627
            ],
            [
              -4899.174,
              2029.921,
              5624.688
            ],
            [
              -4949.692,
              2018.54,
              5676.472
            ],
            [
              -5128.906,
              1951.47,
              5867.825
            ],
            [
              -5181.415,
              1936.781,
              5922.35
            ],
            [
              -5229.978,
              1926.477,
              5971.994
            ],
            [
              -5267.443,
              1923.775,
              6009.557
            ],
            [
              -5312.592,
              1924.544,
              6054.712
            ],
            [
              -5351.822,
              1931.891,
              6094.624
            ],
            [
              -5407.689,
              1947.312,
              6152.581
            ],
            [
              -5579.166,
              2031.487,
              6343.604
            ],
            [
              -5622.78,
              2046.698,
              6389.794
            ],
            [
              -6203.337,
              2167.821,
              6982.852
            ],
            [
              -6281.103,
              2185.826,
              7062.675
            ],
            [
              -6367.656,
              2218.449,
              7155.172
            ],
            [
              -6455.072,
              2276.688,
              7260.211
            ],
            [
              -6521.774,
              2339.031,
              7351.512
            ],
            [
              -6563.365,
              2394.508,
              7420.848
            ],
            [
              -6591.947,
              2443.085,
              7477.211
            ],
            [
              -6687.246,
              2630.115,
              7687.12
            ],
            [
              -6717.477,
              2680.464,
              7745.847
            ],
            [
              -6732.812,
              2722.158,
              7790.272
            ],
            [
              -6787.208,
              2826.592,
              7908.023
            ],
            [
              -6821.115,
              2882.817,
              7973.681
            ],
            [
              -6849.514,
              2921.139,
              8021.379
            ],
            [
              -6885.636,
              2960.702,
              8074.952
            ],
            [
              -6915.475,
              2990.142,
              8116.869
            ],
            [
              -6953.037,
              3020.824,
              8165.37
            ],
            [
              -7039.186,
              3079.03,
              8269.339
            ],
            [
              -7610.996,
              3413.943,
              8932.01
            ],
            [
              -7653.308,
              3444.307,
              8984.09
            ],
            [
              -7928.052,
              3612.467,
              9306.211
            ],
            [
              -8049.841,
              3662.009,
              9437.691
            ],
            [
              -8132.216,
              3682.666,
              9522.616
            ],
            [
              -8226.83,
              3693.337,
              9617.83
            ],
            [
              -8295.18,
              3691.304,
              9686.211
            ],
            [
              -8418.27,
              3666.017,
              9811.871
            ],
            [
              -8511.565,
              3629.218,
              9912.162
            ],
            [
              -8673.968,
              3542.289,
              10096.366
            ],
            [
              -10220.742,
              2662.19,
              11875.996
            ],
            [
              -10349.565,
              2595.224,
              12021.185
            ],
            [
              -10561.984,
              2505.092,
              12251.935
            ],
            [
              -10574.221,
              2459.107,
              12299.521
            ],
            [
              -10587.068,
              2428.682,
              12332.547
            ],
            [
              -10687.101,
              2384.205,
              12442.022
            ],
            [
              -10763.768,
              2356.721,
              12523.466
            ],
            [
              -10781.724,
              2355.749,
              12541.449
            ],
            [
              -10804.219,
              2359.617,
              12564.274
            ],
            [
              -10821.776,
              2366.457,
              12583.116
            ],
            [
              -10871.238,
              2410.915,
              12649.622
            ],
            [
              -10882.01,
              2423.329,
              12666.058
            ],
            [
              -10933.179,
              2410.779,
              12718.743
            ],
            [
              -11014.265,
              2383.116,
              12804.418
            ],
            [
              -11042.752,
              2376.885,
              12833.579
            ],
            [
              -11076.277,
              2378.406,
              12867.138
            ],
            [
              -11111.6,
              2375.848,
              12902.554
            ],
            [
              -11167.733,
              2347.684,
              12965.356
            ],
            [
              -11175.682,
              2356.108,
              12976.938
            ],
            [
              -11188.898,
              2381.881,
              13005.902
            ],
            [
              -11209.837,
              2410.442,
              13041.316
            ],
            [
              -11223.935,
              2425.375,
              13061.853
            ],
            [
              -11236.068,
              2433.358,
              13076.377
            ],
            [
              -11281.586,
              2451.884,
              13125.52
            ],
            [
              -11308.608,
              2456.76,
              13152.979
            ],
            [
              -11333.037,
              2457.586,
              13177.421
            ],
            [
              -11358.106,
              2453.226,
              13202.866
            ],
            [
              -11401.258,
              2432.42,
              13250.773
            ],
            [
              -11422.36,
              2422.676,
              13274.016
            ],
            [
              -11657.133,
              2308.505,
              13535.078
            ],
            [
              -11912.888,
              2185.736,
              13818.773
            ],
            [
              -11986.897,
              2154.558,
              13899.081
            ],
            [
              -12000.581,
              2145.866,
              13915.292
            ],
            [
              -12140.971,
              2079.03,
              14070.78
            ],
            [
              -12149.434,
              2068.558,
              14084.244
            ],
            [
              -12133.47,
              2034.328,
              14122.013
            ],
            [
              -12034.298,
              1818.238,
              14359.774
            ],
            [
              -12277.032,
              1708.233,
              14626.272
            ],
            [
              -12423.127,
              1639.755,
              14787.619
            ],
            [
              -12458.258,
              1627.549,
              14824.81
            ],
            [
              -12567.481,
              1592.439,
              14939.538
            ],
            [
              -12596.82,
              1650.319,
              15004.429
            ],
            [
              -12647.185,
              1758.475,
              15123.737
            ],
            [
              -12661.996,
              1802.116,
              15169.823
            ],
            [
              -12664.589,
              1812.84,
              15180.855
            ],
            [
              -12603.058,
              1859.092,
              15257.832
            ],
            [
              -12599.171,
              1860.145,
              15261.859
            ],
            [
              -12592.773,
              1856.707,
              15269.122
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:8311",
              "position": {
                "x": -2042.349,
                "z": 2571.254
              },
              "distanceAlongShapeM": 184.031,
              "shapeOffsetM": 1.087,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:8309",
              "position": {
                "x": -1563.915,
                "z": 2442.514
              },
              "distanceAlongShapeM": 734.469,
              "shapeOffsetM": 7.681,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:9642",
              "position": {
                "x": -1399.067,
                "z": 2279.266
              },
              "distanceAlongShapeM": 965.386,
              "shapeOffsetM": 2.18,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:6365",
              "position": {
                "x": -1411.426,
                "z": 1768.519
              },
              "distanceAlongShapeM": 1633.063,
              "shapeOffsetM": 3.132,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:7852",
              "position": {
                "x": -1970.62,
                "z": 1705.012
              },
              "distanceAlongShapeM": 2417.774,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:5532",
              "position": {
                "x": -2290.557,
                "z": 2000.118
              },
              "distanceAlongShapeM": 2853.295,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:6338",
              "position": {
                "x": -2690.837,
                "z": 2168.596
              },
              "distanceAlongShapeM": 3350.369,
              "shapeOffsetM": 4.045,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:6353",
              "position": {
                "x": -4082.845,
                "z": 2002.521
              },
              "distanceAlongShapeM": 4797.216,
              "shapeOffsetM": 4.512,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:6351",
              "position": {
                "x": -4474.572,
                "z": 2071.617
              },
              "distanceAlongShapeM": 5196.932,
              "shapeOffsetM": 3.435,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            },
            {
              "stopId": "judu:stop:6309",
              "position": {
                "x": -6721.281,
                "z": 2678.551
              },
              "distanceAlongShapeM": 7745.847,
              "shapeOffsetM": 4.258,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:6297",
              "position": {
                "x": -7611.222,
                "z": 3413.556
              },
              "distanceAlongShapeM": 8932.01,
              "shapeOffsetM": 0.448,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            },
            {
              "stopId": "judu:stop:9109",
              "position": {
                "x": -10685.89,
                "z": 2381.268
              },
              "distanceAlongShapeM": 12442.022,
              "shapeOffsetM": 3.177,
              "arrivalOffsetSeconds": 1560,
              "departureOffsetSeconds": 1560
            },
            {
              "stopId": "judu:stop:9834",
              "position": {
                "x": -11398.758,
                "z": 2427.006
              },
              "distanceAlongShapeM": 13250.773,
              "shapeOffsetM": 5.963,
              "arrivalOffsetSeconds": 1680,
              "departureOffsetSeconds": 1680
            },
            {
              "stopId": "judu:stop:8944",
              "position": {
                "x": -11656.141,
                "z": 2306.359
              },
              "distanceAlongShapeM": 13535.112,
              "shapeOffsetM": 2.364,
              "arrivalOffsetSeconds": 1740,
              "departureOffsetSeconds": 1740
            },
            {
              "stopId": "judu:stop:6603",
              "position": {
                "x": -11912.865,
                "z": 2185.688
              },
              "distanceAlongShapeM": 13818.773,
              "shapeOffsetM": 0.053,
              "arrivalOffsetSeconds": 1800,
              "departureOffsetSeconds": 1800
            },
            {
              "stopId": "judu:stop:9082",
              "position": {
                "x": -12128.727,
                "z": 2036.54
              },
              "distanceAlongShapeM": 14122.013,
              "shapeOffsetM": 5.234,
              "arrivalOffsetSeconds": 1860,
              "departureOffsetSeconds": 1860
            },
            {
              "stopId": "judu:stop:9614",
              "position": {
                "x": -12592.773,
                "z": 1856.707
              },
              "distanceAlongShapeM": 15269.122,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2040,
              "departureOffsetSeconds": 2040
            }
          ],
          "departuresSeconds": [
            20700,
            21780,
            22800,
            24000,
            25500,
            27000,
            28500,
            29880,
            33300,
            35520,
            37800,
            39420,
            41160,
            42960,
            44700,
            46500,
            48300,
            50040,
            51840,
            53760,
            55260,
            56520,
            57780,
            59340,
            60900,
            62460,
            64020,
            65640,
            67740,
            70620,
            72180,
            74040,
            75540,
            77220,
            78900,
            80580,
            82140,
            83700
          ]
        },
        {
          "id": "judu:pattern:vilnius_bus_29:1",
          "sourceRouteId": "vilnius_bus_29",
          "sourceShapeId": "vilnius_bus_29_b-a",
          "directionId": 1,
          "headsign": "Vilkpėdė",
          "directionName": "Grigiškės–Lazdynai–Žemaitės g.–Vilkpėdė",
          "mode": "bus",
          "routeShortName": "29",
          "routeLongName": "Vilkpėdė–Žemaitės g.–Lazdynai–Grigiškės",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              -12592.773,
              1856.707,
              0
            ],
            [
              -12609.12,
              1842.488,
              21.666
            ],
            [
              -12664.399,
              1812.687,
              84.466
            ],
            [
              -12663.097,
              1814.378,
              86.6
            ],
            [
              -12644.743,
              1749.532,
              153.993
            ],
            [
              -12604.207,
              1662.909,
              249.632
            ],
            [
              -12567.595,
              1592.452,
              329.034
            ],
            [
              -12417.527,
              1642.075,
              487.093
            ],
            [
              -12254.81,
              1722.219,
              668.476
            ],
            [
              -12206.592,
              1746.184,
              722.321
            ],
            [
              -12156.838,
              1767.73,
              776.54
            ],
            [
              -12052.602,
              1832.132,
              899.066
            ],
            [
              -12150.225,
              2064.703,
              1151.295
            ],
            [
              -12150.767,
              2071.39,
              1158.004
            ],
            [
              -12148.083,
              2078.027,
              1165.163
            ],
            [
              -11899.166,
              2197.592,
              1441.307
            ],
            [
              -11701.74,
              2290.557,
              1659.526
            ],
            [
              -11377.941,
              2445.282,
              2018.393
            ],
            [
              -11340.565,
              2456.843,
              2057.517
            ],
            [
              -11266.78,
              2448.701,
              2131.75
            ],
            [
              -11227.326,
              2428.015,
              2176.297
            ],
            [
              -11208.103,
              2411.357,
              2201.733
            ],
            [
              -11191.877,
              2389.948,
              2228.597
            ],
            [
              -11131.53,
              2270.307,
              2362.596
            ],
            [
              -10763.263,
              2440.556,
              2768.312
            ],
            [
              -10394.145,
              2591.48,
              3167.093
            ],
            [
              -10234.129,
              2672.421,
              3346.415
            ],
            [
              -8792.209,
              3494.119,
              5006.03
            ],
            [
              -8701.097,
              3553.784,
              5114.94
            ],
            [
              -8570.058,
              3621.859,
              5262.606
            ],
            [
              -8433.864,
              3702.013,
              5420.636
            ],
            [
              -8208.82,
              3847.499,
              5688.612
            ],
            [
              -8066.385,
              3953.143,
              5865.949
            ],
            [
              -8052.704,
              3990.725,
              5905.943
            ],
            [
              -8073.606,
              4024.505,
              5945.667
            ],
            [
              -8101.114,
              4031.623,
              5974.081
            ],
            [
              -8136.922,
              4013.852,
              6014.056
            ],
            [
              -8147.092,
              3979.886,
              6049.512
            ],
            [
              -8141.382,
              3945.467,
              6084.401
            ],
            [
              -8140.12,
              3941.964,
              6088.124
            ],
            [
              -8107.695,
              3848.767,
              6186.801
            ],
            [
              -8064.844,
              3771.671,
              6275.005
            ],
            [
              -8003.462,
              3697.194,
              6371.517
            ],
            [
              -7956.982,
              3658.583,
              6431.942
            ],
            [
              -7913.617,
              3629.955,
              6483.905
            ],
            [
              -7552.547,
              3410.361,
              6906.508
            ],
            [
              -7508.479,
              3393.727,
              6953.611
            ],
            [
              -7243.876,
              3227.143,
              7266.284
            ],
            [
              -6939.838,
              3038.415,
              7624.135
            ],
            [
              -6822.27,
              2929.59,
              7784.339
            ],
            [
              -6681.993,
              2680.689,
              8070.047
            ],
            [
              -6526.174,
              2387.644,
              8401.943
            ],
            [
              -6505.826,
              2360.706,
              8435.703
            ],
            [
              -6467.962,
              2320.242,
              8491.12
            ],
            [
              -6423.391,
              2280.61,
              8550.762
            ],
            [
              -6374.551,
              2249.163,
              8608.85
            ],
            [
              -6301.902,
              2215.119,
              8689.081
            ],
            [
              -6210.095,
              2187.972,
              8784.817
            ],
            [
              -5882.154,
              2122.332,
              9119.263
            ],
            [
              -5773.544,
              2097.118,
              9230.761
            ],
            [
              -5628.871,
              2067.952,
              9378.345
            ],
            [
              -5544.962,
              2032.02,
              9469.624
            ],
            [
              -5507.285,
              2009.117,
              9513.716
            ],
            [
              -5454.831,
              1982.622,
              9572.481
            ],
            [
              -5402.89,
              1963.929,
              9627.684
            ],
            [
              -5349.622,
              1947.438,
              9683.446
            ],
            [
              -5303.942,
              1939.981,
              9729.731
            ],
            [
              -5264.579,
              1940.424,
              9769.096
            ],
            [
              -5230.357,
              1942.068,
              9803.358
            ],
            [
              -5160.434,
              1956.461,
              9874.747
            ],
            [
              -5129.323,
              1964.836,
              9906.965
            ],
            [
              -4970.825,
              2027.807,
              10077.514
            ],
            [
              -4893.032,
              2047.432,
              10157.744
            ],
            [
              -4844.59,
              2057.637,
              10207.249
            ],
            [
              -4659.818,
              2083.632,
              10393.841
            ],
            [
              -4413.826,
              2088.426,
              10639.88
            ],
            [
              -4171.807,
              2044.134,
              10885.918
            ],
            [
              -4056.112,
              2018.757,
              11004.364
            ],
            [
              -4035.993,
              2013.78,
              11025.09
            ],
            [
              -4018.212,
              2009.195,
              11043.452
            ],
            [
              -3691.362,
              1920.037,
              11382.244
            ],
            [
              -3598.621,
              1910.632,
              11475.461
            ],
            [
              -3547.649,
              1910.858,
              11526.433
            ],
            [
              -3478.544,
              1919.039,
              11596.021
            ],
            [
              -3376.715,
              1945.728,
              11701.289
            ],
            [
              -3255.325,
              1988.136,
              11829.874
            ],
            [
              -3211.057,
              2010.74,
              11879.579
            ],
            [
              -3076.57,
              2064.047,
              12024.245
            ],
            [
              -3025.322,
              2079.847,
              12077.874
            ],
            [
              -2969.481,
              2100.019,
              12137.247
            ],
            [
              -2931.778,
              2116.056,
              12178.218
            ],
            [
              -2890.295,
              2136.475,
              12224.455
            ],
            [
              -2704.044,
              2203.421,
              12422.372
            ],
            [
              -2694.973,
              2206.697,
              12432.017
            ],
            [
              -2620.644,
              2234.153,
              12511.254
            ],
            [
              -2602.113,
              2260.544,
              12543.501
            ],
            [
              -2588.136,
              2284.788,
              12571.486
            ],
            [
              -2571.13,
              2297.847,
              12592.927
            ],
            [
              -2532.153,
              2312.745,
              12634.654
            ],
            [
              -2506.977,
              2313.414,
              12659.839
            ],
            [
              -2483.854,
              2307.44,
              12683.722
            ],
            [
              -2455.846,
              2285.795,
              12719.119
            ],
            [
              -2438.355,
              2253.203,
              12756.107
            ],
            [
              -2433.47,
              2237.532,
              12772.522
            ],
            [
              -2435.723,
              2169.786,
              12840.305
            ],
            [
              -2432.837,
              2155.209,
              12855.166
            ],
            [
              -2421.673,
              2138.248,
              12875.471
            ],
            [
              -2405.237,
              2119.033,
              12900.757
            ],
            [
              -2339.12,
              2063.317,
              12987.219
            ],
            [
              -2328.352,
              2051.995,
              13002.844
            ],
            [
              -2314.582,
              2044.048,
              13018.742
            ],
            [
              -2298.509,
              2024.75,
              13043.857
            ],
            [
              -1944.941,
              1697.877,
              13525.372
            ],
            [
              -1869.698,
              1631.955,
              13625.408
            ],
            [
              -1860.469,
              1622.903,
              13638.335
            ],
            [
              -1769.084,
              1537.785,
              13763.22
            ],
            [
              -1704.495,
              1480.033,
              13849.863
            ],
            [
              -1698.901,
              1478.9,
              13855.57
            ],
            [
              -1682.168,
              1491.708,
              13876.643
            ],
            [
              -1671.651,
              1502.653,
              13891.822
            ],
            [
              -1651.454,
              1530.355,
              13926.104
            ],
            [
              -1603.973,
              1571.579,
              13988.984
            ],
            [
              -1299.013,
              1921.245,
              14452.953
            ],
            [
              -1270.801,
              1947.457,
              14491.463
            ],
            [
              -1190.297,
              2047.317,
              14619.731
            ],
            [
              -1514.694,
              2380.408,
              15084.686
            ],
            [
              -1536.735,
              2401.048,
              15114.883
            ],
            [
              -1585.57,
              2434.895,
              15174.301
            ],
            [
              -1589.092,
              2441.85,
              15182.096
            ],
            [
              -1665.298,
              2474.379,
              15264.955
            ],
            [
              -1973.715,
              2584.507,
              15592.444
            ],
            [
              -1980.067,
              2590.186,
              15600.964
            ],
            [
              -1990.862,
              2563.661,
              15629.602
            ],
            [
              -1996.181,
              2554.849,
              15639.895
            ],
            [
              -2002.73,
              2549.399,
              15648.415
            ],
            [
              -2004.613,
              2546.083,
              15652.229
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:9614",
              "position": {
                "x": -12592.773,
                "z": 1856.707
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": -480,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:15964",
              "position": {
                "x": -12209.896,
                "z": 1752.832
              },
              "distanceAlongShapeM": 722.321,
              "shapeOffsetM": 7.424,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:16236",
              "position": {
                "x": -12092.77,
                "z": 1942.477
              },
              "distanceAlongShapeM": 1016.358,
              "shapeOffsetM": 5.671,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:8945",
              "position": {
                "x": -11899.757,
                "z": 2198.842
              },
              "distanceAlongShapeM": 1441.307,
              "shapeOffsetM": 1.382,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:6604",
              "position": {
                "x": -11702.181,
                "z": 2291.494
              },
              "distanceAlongShapeM": 1659.532,
              "shapeOffsetM": 1.035,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:4454",
              "position": {
                "x": -11189.627,
                "z": 2391.441
              },
              "distanceAlongShapeM": 2228.597,
              "shapeOffsetM": 2.7,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:6295",
              "position": {
                "x": -8134.965,
                "z": 3943.136
              },
              "distanceAlongShapeM": 6088.711,
              "shapeOffsetM": 5.254,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:6609",
              "position": {
                "x": -7508.286,
                "z": 3394.045
              },
              "distanceAlongShapeM": 6953.611,
              "shapeOffsetM": 0.372,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:6310",
              "position": {
                "x": -6676.677,
                "z": 2683.371
              },
              "distanceAlongShapeM": 8070.175,
              "shapeOffsetM": 5.953,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:6350",
              "position": {
                "x": -4413.578,
                "z": 2091.718
              },
              "distanceAlongShapeM": 10639.88,
              "shapeOffsetM": 3.302,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:6352",
              "position": {
                "x": -4034.827,
                "z": 2018.389
              },
              "distanceAlongShapeM": 11025.09,
              "shapeOffsetM": 4.755,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:6337",
              "position": {
                "x": -2705.632,
                "z": 2207.819
              },
              "distanceAlongShapeM": 12422.365,
              "shapeOffsetM": 4.675,
              "arrivalOffsetSeconds": 1380,
              "departureOffsetSeconds": 1380
            },
            {
              "stopId": "judu:stop:5535",
              "position": {
                "x": -2313.635,
                "z": 2045.055
              },
              "distanceAlongShapeM": 13018.742,
              "shapeOffsetM": 1.383,
              "arrivalOffsetSeconds": 1500,
              "departureOffsetSeconds": 1500
            },
            {
              "stopId": "judu:stop:7853",
              "position": {
                "x": -1868.675,
                "z": 1633.068
              },
              "distanceAlongShapeM": 13625.408,
              "shapeOffsetM": 1.512,
              "arrivalOffsetSeconds": 1620,
              "departureOffsetSeconds": 1620
            },
            {
              "stopId": "judu:stop:6410",
              "position": {
                "x": -1654.972,
                "z": 1533.526
              },
              "distanceAlongShapeM": 13926.104,
              "shapeOffsetM": 4.736,
              "arrivalOffsetSeconds": 1710,
              "departureOffsetSeconds": 1710
            },
            {
              "stopId": "judu:stop:6366",
              "position": {
                "x": -1299.013,
                "z": 1921.245
              },
              "distanceAlongShapeM": 14452.953,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1800,
              "departureOffsetSeconds": 1800
            },
            {
              "stopId": "judu:stop:9701",
              "position": {
                "x": -1232.774,
                "z": 2089.268
              },
              "distanceAlongShapeM": 14679.421,
              "shapeOffsetM": 1.161,
              "arrivalOffsetSeconds": 1920,
              "departureOffsetSeconds": 1920
            },
            {
              "stopId": "judu:stop:7941",
              "position": {
                "x": -1586.671,
                "z": 2432.901
              },
              "distanceAlongShapeM": 15174.069,
              "shapeOffsetM": 2.266,
              "arrivalOffsetSeconds": 2040,
              "departureOffsetSeconds": 2040
            },
            {
              "stopId": "judu:stop:19255",
              "position": {
                "x": -2002.849,
                "z": 2542.722
              },
              "distanceAlongShapeM": 15652.229,
              "shapeOffsetM": 3.796,
              "arrivalOffsetSeconds": 2100,
              "departureOffsetSeconds": 2100
            }
          ],
          "departuresSeconds": [
            19320,
            21240,
            22860,
            24240,
            25440,
            26640,
            28020,
            29640,
            31200,
            32580,
            35880,
            38040,
            40320,
            41940,
            43620,
            45360,
            47160,
            48960,
            50820,
            52740,
            54420,
            56220,
            58020,
            59520,
            60960,
            62580,
            64200,
            65640,
            67020,
            68820,
            72900,
            74580,
            76380,
            78060,
            79740,
            81420,
            83040,
            84660
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_bus_30",
      "sourceRouteId": "vilnius_bus_30",
      "mode": "bus",
      "shortName": "30",
      "longName": "Pilaitė–Konstitucijos pr.–Apkasų g.–Šiaurės miestelis",
      "color": "0073AC",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_bus_30:0",
          "sourceRouteId": "vilnius_bus_30",
          "sourceShapeId": "vilnius_bus_30_a-b",
          "directionId": 0,
          "headsign": "Šiaurės miestelis",
          "directionName": "Pilaitė–Konstitucijos pr.–Apkasų g.–Šiaurės miestelis",
          "mode": "bus",
          "routeShortName": "30",
          "routeLongName": "Pilaitė–Konstitucijos pr.–Apkasų g.–Šiaurės miestelis",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              -6782.722,
              -1517.922,
              0
            ],
            [
              -6790.213,
              -1503.239,
              16.483
            ],
            [
              -6789.666,
              -1493.237,
              26.501
            ],
            [
              -6789.574,
              -1493.338,
              26.637
            ],
            [
              -6793.888,
              -1496.036,
              31.725
            ],
            [
              -6804.801,
              -1471.131,
              58.916
            ],
            [
              -6817.871,
              -1443.083,
              89.859
            ],
            [
              -6849.755,
              -1383.551,
              157.392
            ],
            [
              -6861.847,
              -1368.999,
              176.312
            ],
            [
              -6868.44,
              -1344.278,
              201.897
            ],
            [
              -6865.755,
              -1340.811,
              206.282
            ],
            [
              -6856.389,
              -1336.272,
              216.69
            ],
            [
              -6847.396,
              -1333.735,
              226.034
            ],
            [
              -6839.19,
              -1361.045,
              254.55
            ],
            [
              -6823.318,
              -1421.841,
              317.384
            ],
            [
              -6726.31,
              -1602.786,
              522.693
            ],
            [
              -6717.082,
              -1622.391,
              544.361
            ],
            [
              -6684.251,
              -1702.465,
              630.904
            ],
            [
              -6676.395,
              -1733.766,
              663.176
            ],
            [
              -6677.514,
              -1993.121,
              922.533
            ],
            [
              -6673.441,
              -2063.333,
              992.863
            ],
            [
              -6676.454,
              -2314.851,
              1244.399
            ],
            [
              -6640.332,
              -2313.345,
              1280.553
            ],
            [
              -6613.182,
              -2313.262,
              1307.703
            ],
            [
              -6575.914,
              -2315.423,
              1345.033
            ],
            [
              -6380.632,
              -2316.474,
              1540.318
            ],
            [
              -6294.875,
              -2314.577,
              1626.096
            ],
            [
              -6243.894,
              -2310.982,
              1677.204
            ],
            [
              -6220.641,
              -2308.034,
              1700.643
            ],
            [
              -6201.86,
              -2302.785,
              1720.144
            ],
            [
              -6169.955,
              -2294.517,
              1753.103
            ],
            [
              -6126.719,
              -2280.674,
              1798.5
            ],
            [
              -6104.034,
              -2273.265,
              1822.365
            ],
            [
              -5924.643,
              -2185.012,
              2022.289
            ],
            [
              -5877.169,
              -2160.211,
              2075.851
            ],
            [
              -5846.259,
              -2142.718,
              2111.367
            ],
            [
              -5795.942,
              -2121.511,
              2165.971
            ],
            [
              -5568.568,
              -2017.388,
              2416.052
            ],
            [
              -5236.974,
              -1850.486,
              2787.281
            ],
            [
              -5169.837,
              -1807.104,
              2867.214
            ],
            [
              -5127.302,
              -1769.981,
              2923.671
            ],
            [
              -5012.864,
              -1637.24,
              3098.931
            ],
            [
              -4831.761,
              -1414.361,
              3386.113
            ],
            [
              -4763.266,
              -1360.258,
              3473.398
            ],
            [
              -4704.75,
              -1314.599,
              3547.62
            ],
            [
              -4653.804,
              -1300.53,
              3600.473
            ],
            [
              -4405.208,
              -1203.507,
              3867.332
            ],
            [
              -4296.995,
              -1171.977,
              3980.044
            ],
            [
              -4246.587,
              -1162.091,
              4031.413
            ],
            [
              -4190.857,
              -1159.392,
              4087.208
            ],
            [
              -3912.052,
              -1135.777,
              4367.011
            ],
            [
              -3758.891,
              -1120.334,
              4520.949
            ],
            [
              -3704.617,
              -1115.802,
              4575.412
            ],
            [
              -3657.704,
              -1114.039,
              4622.358
            ],
            [
              -3599.031,
              -1113.947,
              4681.031
            ],
            [
              -3412.497,
              -1176.2,
              4877.679
            ],
            [
              -3355.367,
              -1190.556,
              4936.585
            ],
            [
              -3109.19,
              -1234.288,
              5186.616
            ],
            [
              -3070.013,
              -1242.306,
              5226.605
            ],
            [
              -2879.155,
              -1277.94,
              5420.761
            ],
            [
              -2839.273,
              -1283.094,
              5460.975
            ],
            [
              -2787.087,
              -1285.125,
              5513.2
            ],
            [
              -2748.376,
              -1283.58,
              5551.942
            ],
            [
              -2714.118,
              -1278.617,
              5586.558
            ],
            [
              -2670.7,
              -1266.023,
              5631.765
            ],
            [
              -2624.585,
              -1246.798,
              5681.727
            ],
            [
              -2499.949,
              -1183.085,
              5821.704
            ],
            [
              -2469.831,
              -1172.717,
              5853.557
            ],
            [
              -2418.716,
              -1162.489,
              5905.685
            ],
            [
              -2392.231,
              -1159.617,
              5932.325
            ],
            [
              -2152.041,
              -1187.387,
              6174.115
            ],
            [
              -2126.526,
              -1191.159,
              6199.907
            ],
            [
              -2118.854,
              -1195.63,
              6208.787
            ],
            [
              -1988.935,
              -1213.522,
              6339.932
            ],
            [
              -1948.388,
              -1217.583,
              6380.682
            ],
            [
              -1866.572,
              -1221.265,
              6462.581
            ],
            [
              -1794.345,
              -1220.324,
              6534.814
            ],
            [
              -1681.879,
              -1204.518,
              6648.385
            ],
            [
              -1544.075,
              -1178.035,
              6788.711
            ],
            [
              -1435.713,
              -1149.425,
              6900.787
            ],
            [
              -1393.22,
              -1142.883,
              6943.78
            ],
            [
              -1155.149,
              -1098.17,
              7186.013
            ],
            [
              -1103.532,
              -1084.281,
              7239.467
            ],
            [
              -1083.324,
              -1083.875,
              7259.678
            ],
            [
              -1022.536,
              -1073.836,
              7321.29
            ],
            [
              -998.991,
              -1055.334,
              7351.235
            ],
            [
              -969.041,
              -1039.175,
              7385.266
            ],
            [
              -947.066,
              -1036.231,
              7407.437
            ],
            [
              -930.307,
              -1036.533,
              7424.199
            ],
            [
              -906.579,
              -1043.639,
              7448.968
            ],
            [
              -895.802,
              -1053.852,
              7463.815
            ],
            [
              -890.221,
              -1066.198,
              7477.364
            ],
            [
              -876.342,
              -1083.147,
              7499.271
            ],
            [
              -864.236,
              -1091.158,
              7513.787
            ],
            [
              -846.005,
              -1097.331,
              7533.036
            ],
            [
              -813.038,
              -1094.85,
              7566.096
            ],
            [
              -785.651,
              -1089.799,
              7593.944
            ],
            [
              -774.937,
              -1088.05,
              7604.8
            ],
            [
              -717.669,
              -1083.853,
              7662.222
            ],
            [
              -647.083,
              -1062.792,
              7735.883
            ],
            [
              -535.555,
              -1028.072,
              7852.69
            ],
            [
              -464.693,
              -995.958,
              7930.489
            ],
            [
              -361.843,
              -942.16,
              8046.56
            ],
            [
              -331.427,
              -923.524,
              8082.231
            ],
            [
              -286.654,
              -898.264,
              8133.638
            ],
            [
              -196.966,
              -846.075,
              8237.405
            ],
            [
              -115.583,
              -803.025,
              8329.473
            ],
            [
              -95.312,
              -792.953,
              8352.108
            ],
            [
              -40.176,
              -770.281,
              8411.724
            ],
            [
              224.759,
              -703.469,
              8684.953
            ],
            [
              238.113,
              -713.732,
              8701.796
            ],
            [
              221.813,
              -864.834,
              8853.774
            ],
            [
              221.766,
              -902.683,
              8891.623
            ],
            [
              233.86,
              -981.944,
              8971.802
            ],
            [
              256.721,
              -1107.044,
              9098.973
            ],
            [
              276.82,
              -1242.113,
              9235.53
            ],
            [
              294.15,
              -1318.635,
              9313.989
            ],
            [
              320.249,
              -1546.82,
              9543.662
            ],
            [
              342.249,
              -1718.661,
              9716.906
            ],
            [
              352.701,
              -1764.728,
              9764.143
            ],
            [
              354.758,
              -1810.175,
              9809.637
            ],
            [
              356.121,
              -1841.371,
              9840.863
            ],
            [
              372.957,
              -1942.984,
              9943.861
            ],
            [
              426.379,
              -2158.817,
              10166.207
            ],
            [
              439.077,
              -2195.331,
              10204.867
            ],
            [
              440.947,
              -2208.066,
              10217.738
            ],
            [
              451.425,
              -2269.486,
              10280.045
            ],
            [
              777.261,
              -2147.444,
              10627.987
            ],
            [
              787.286,
              -2195.757,
              10677.328
            ],
            [
              791.563,
              -2252.452,
              10734.185
            ],
            [
              803.126,
              -2297.432,
              10780.628
            ],
            [
              810.049,
              -2322.85,
              10806.972
            ],
            [
              815.482,
              -2347.417,
              10832.132
            ],
            [
              839.035,
              -2433.57,
              10921.446
            ],
            [
              880.709,
              -2566.011,
              11060.289
            ],
            [
              897.973,
              -2653.975,
              11149.931
            ],
            [
              898.288,
              -2661.896,
              11157.858
            ],
            [
              905.605,
              -2670.265,
              11168.976
            ],
            [
              909.345,
              -2669.084,
              11172.897
            ],
            [
              920.843,
              -2665.533,
              11184.931
            ],
            [
              979.504,
              -2648.954,
              11245.89
            ],
            [
              1030.623,
              -2635.258,
              11298.812
            ],
            [
              1259.04,
              -2573.328,
              11535.475
            ],
            [
              1329.708,
              -2568.104,
              11606.336
            ],
            [
              1359.181,
              -2574.537,
              11636.503
            ],
            [
              1423.013,
              -2573.493,
              11700.344
            ],
            [
              1423.056,
              -2568.528,
              11705.309
            ],
            [
              1406.874,
              -2540.387,
              11737.771
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:7694",
              "position": {
                "x": -6837.763,
                "z": -1360.375
              },
              "distanceAlongShapeM": 254.319,
              "shapeOffsetM": 1.56,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:4526",
              "position": {
                "x": -6711.23,
                "z": -1619.637
              },
              "distanceAlongShapeM": 544.361,
              "shapeOffsetM": 6.468,
              "arrivalOffsetSeconds": 60,
              "departureOffsetSeconds": 60
            },
            {
              "stopId": "judu:stop:8067",
              "position": {
                "x": -6672.243,
                "z": -2063.34
              },
              "distanceAlongShapeM": 992.863,
              "shapeOffsetM": 1.198,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:7951",
              "position": {
                "x": -6613.194,
                "z": -2309.232
              },
              "distanceAlongShapeM": 1307.703,
              "shapeOffsetM": 4.03,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:7949",
              "position": {
                "x": -6171.35,
                "z": -2289.941
              },
              "distanceAlongShapeM": 1752.9,
              "shapeOffsetM": 4.779,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:8069",
              "position": {
                "x": -5847.188,
                "z": -2140.681
              },
              "distanceAlongShapeM": 2111.367,
              "shapeOffsetM": 2.239,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:8934",
              "position": {
                "x": -4704.97,
                "z": -1314.122
              },
              "distanceAlongShapeM": 3547.62,
              "shapeOffsetM": 0.525,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:4989",
              "position": {
                "x": -4247.02,
                "z": -1152.802
              },
              "distanceAlongShapeM": 4031.43,
              "shapeOffsetM": 9.299,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:7342",
              "position": {
                "x": -3705.284,
                "z": -1106.532
              },
              "distanceAlongShapeM": 4575.412,
              "shapeOffsetM": 9.294,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:7416",
              "position": {
                "x": -3108.49,
                "z": -1230.499
              },
              "distanceAlongShapeM": 5186.616,
              "shapeOffsetM": 3.854,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:6398",
              "position": {
                "x": -2151.528,
                "z": -1183.918
              },
              "distanceAlongShapeM": 6174.115,
              "shapeOffsetM": 3.507,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            },
            {
              "stopId": "judu:stop:6396",
              "position": {
                "x": -1436.465,
                "z": -1145.449
              },
              "distanceAlongShapeM": 6900.787,
              "shapeOffsetM": 4.046,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:6397",
              "position": {
                "x": -1103.929,
                "z": -1082.392
              },
              "distanceAlongShapeM": 7239.467,
              "shapeOffsetM": 1.931,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:6635",
              "position": {
                "x": -775.751,
                "z": -1082.734
              },
              "distanceAlongShapeM": 7604.8,
              "shapeOffsetM": 5.378,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:7381",
              "position": {
                "x": -333.702,
                "z": -919.293
              },
              "distanceAlongShapeM": 8082.329,
              "shapeOffsetM": 4.803,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            },
            {
              "stopId": "judu:stop:17638",
              "position": {
                "x": -42.035,
                "z": -765.399
              },
              "distanceAlongShapeM": 8411.724,
              "shapeOffsetM": 5.224,
              "arrivalOffsetSeconds": 1380,
              "departureOffsetSeconds": 1380
            },
            {
              "stopId": "judu:stop:6843",
              "position": {
                "x": 297.35,
                "z": -1318.188
              },
              "distanceAlongShapeM": 9313.989,
              "shapeOffsetM": 3.231,
              "arrivalOffsetSeconds": 1620,
              "departureOffsetSeconds": 1620
            },
            {
              "stopId": "judu:stop:6844",
              "position": {
                "x": 356.237,
                "z": -1764.56
              },
              "distanceAlongShapeM": 9764.143,
              "shapeOffsetM": 3.54,
              "arrivalOffsetSeconds": 1800,
              "departureOffsetSeconds": 1800
            },
            {
              "stopId": "judu:stop:6845",
              "position": {
                "x": 441.836,
                "z": -2194.724
              },
              "distanceAlongShapeM": 10204.867,
              "shapeOffsetM": 2.825,
              "arrivalOffsetSeconds": 1860,
              "departureOffsetSeconds": 1860
            },
            {
              "stopId": "judu:stop:9638",
              "position": {
                "x": 808.047,
                "z": -2296.071
              },
              "distanceAlongShapeM": 10780.534,
              "shapeOffsetM": 5.105,
              "arrivalOffsetSeconds": 2100,
              "departureOffsetSeconds": 2100
            },
            {
              "stopId": "judu:stop:18532",
              "position": {
                "x": 978.247,
                "z": -2644.311
              },
              "distanceAlongShapeM": 11245.89,
              "shapeOffsetM": 4.81,
              "arrivalOffsetSeconds": 2160,
              "departureOffsetSeconds": 2160
            },
            {
              "stopId": "judu:stop:9566",
              "position": {
                "x": 1329.768,
                "z": -2561.746
              },
              "distanceAlongShapeM": 11606.336,
              "shapeOffsetM": 6.358,
              "arrivalOffsetSeconds": 2280,
              "departureOffsetSeconds": 2280
            },
            {
              "stopId": "judu:stop:15167",
              "position": {
                "x": 1413.343,
                "z": -2538.803
              },
              "distanceAlongShapeM": 11735.919,
              "shapeOffsetM": 6.397,
              "arrivalOffsetSeconds": 2280,
              "departureOffsetSeconds": 2280
            }
          ],
          "departuresSeconds": [
            19020,
            20940,
            22740,
            24000,
            25080,
            25800,
            27300,
            28740,
            30180,
            31380,
            32580,
            33540,
            35280,
            37440,
            39240,
            41580,
            43500,
            45240,
            46740,
            48300,
            49920,
            51540,
            53160,
            54720,
            56460,
            58080,
            59520,
            60960,
            62100,
            63480,
            65220,
            66900,
            68640,
            70260,
            71880,
            73560,
            75120,
            76680,
            78300,
            79980,
            81660
          ]
        },
        {
          "id": "judu:pattern:vilnius_bus_30:1",
          "sourceRouteId": "vilnius_bus_30",
          "sourceShapeId": "vilnius_bus_30_b-a",
          "directionId": 1,
          "headsign": "Pilaitė",
          "directionName": "Šiaurės miestelis–Apkasų g.–Konstitucijos pr.–Pilaitė",
          "mode": "bus",
          "routeShortName": "30",
          "routeLongName": "Pilaitė–Konstitucijos pr.–Apkasų g.–Šiaurės miestelis",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              1407.302,
              -2542.364,
              0
            ],
            [
              1404.085,
              -2529.725,
              13.042
            ],
            [
              1492.99,
              -2519.128,
              102.577
            ],
            [
              1552.992,
              -2512.565,
              162.937
            ],
            [
              1553.131,
              -2520.895,
              171.269
            ],
            [
              1553.227,
              -2526.592,
              176.967
            ],
            [
              1553.355,
              -2534.309,
              184.685
            ],
            [
              1553.387,
              -2536.238,
              186.614
            ],
            [
              1447.352,
              -2569.169,
              297.645
            ],
            [
              1407.447,
              -2542.743,
              345.508
            ],
            [
              1407.868,
              -2547.344,
              350.128
            ],
            [
              1407.735,
              -2553.76,
              356.545
            ],
            [
              1415.904,
              -2574.474,
              378.812
            ],
            [
              1275.293,
              -2579.663,
              519.519
            ],
            [
              1255.056,
              -2585.375,
              540.546
            ],
            [
              1229.698,
              -2591.451,
              566.623
            ],
            [
              1196.042,
              -2600.83,
              601.561
            ],
            [
              955.306,
              -2665.04,
              850.713
            ],
            [
              918.306,
              -2677.632,
              889.797
            ],
            [
              895.761,
              -2678.415,
              912.355
            ],
            [
              887.466,
              -2673.809,
              921.843
            ],
            [
              879.035,
              -2624.079,
              972.283
            ],
            [
              876.281,
              -2581.204,
              1015.246
            ],
            [
              801.593,
              -2329.376,
              1277.917
            ],
            [
              782.583,
              -2257.77,
              1352.003
            ],
            [
              777.442,
              -2234.137,
              1376.189
            ],
            [
              777.363,
              -2141.88,
              1468.446
            ],
            [
              631.852,
              -2202.661,
              1626.141
            ],
            [
              450.781,
              -2269.474,
              1819.145
            ],
            [
              407.333,
              -2116.119,
              1978.536
            ],
            [
              406.254,
              -2096.107,
              1998.577
            ],
            [
              361.405,
              -1904.922,
              2194.952
            ],
            [
              342.249,
              -1718.661,
              2382.196
            ],
            [
              326.222,
              -1640.218,
              2462.259
            ],
            [
              326.097,
              -1614.835,
              2487.643
            ],
            [
              277.22,
              -1255.479,
              2850.307
            ],
            [
              271.867,
              -1230.89,
              2875.472
            ],
            [
              269.371,
              -1219.076,
              2887.547
            ],
            [
              267.3,
              -1198.523,
              2908.204
            ],
            [
              257.056,
              -1141.194,
              2966.441
            ],
            [
              216.915,
              -885.896,
              3224.876
            ],
            [
              223.616,
              -801.413,
              3309.624
            ],
            [
              219.749,
              -721.682,
              3389.448
            ],
            [
              73.653,
              -750.808,
              3538.419
            ],
            [
              -18.428,
              -779.188,
              3634.774
            ],
            [
              -55.388,
              -799.514,
              3676.955
            ],
            [
              -306.711,
              -924.235,
              3957.523
            ],
            [
              -475.993,
              -1014.678,
              4149.451
            ],
            [
              -535.166,
              -1050.172,
              4218.453
            ],
            [
              -673.187,
              -1080.133,
              4359.688
            ],
            [
              -764.624,
              -1108.462,
              4455.413
            ],
            [
              -829.227,
              -1116.28,
              4520.488
            ],
            [
              -865.018,
              -1134.559,
              4560.676
            ],
            [
              -891.825,
              -1155.228,
              4594.526
            ],
            [
              -898.939,
              -1163.415,
              4605.372
            ],
            [
              -908.077,
              -1171.394,
              4617.503
            ],
            [
              -917.363,
              -1177.032,
              4628.367
            ],
            [
              -929.666,
              -1178.977,
              4640.823
            ],
            [
              -961.877,
              -1178.457,
              4673.038
            ],
            [
              -977.23,
              -1175.77,
              4688.624
            ],
            [
              -995.797,
              -1164.488,
              4710.35
            ],
            [
              -1006.474,
              -1148.711,
              4729.4
            ],
            [
              -1029.882,
              -1123.799,
              4763.584
            ],
            [
              -1062.634,
              -1116.531,
              4797.133
            ],
            [
              -1097.251,
              -1122.142,
              4832.202
            ],
            [
              -1143.947,
              -1120.636,
              4878.922
            ],
            [
              -1339.338,
              -1158.32,
              5077.914
            ],
            [
              -1374.945,
              -1168.896,
              5115.058
            ],
            [
              -1791.301,
              -1230.398,
              5535.932
            ],
            [
              -1855.793,
              -1231.475,
              5600.433
            ],
            [
              -1940.187,
              -1227.747,
              5684.909
            ],
            [
              -2027.705,
              -1218.399,
              5772.925
            ],
            [
              -2166.609,
              -1198.122,
              5913.301
            ],
            [
              -2255.397,
              -1187.643,
              6002.705
            ],
            [
              -2266.36,
              -1186.843,
              6013.698
            ],
            [
              -2295.924,
              -1182.472,
              6043.583
            ],
            [
              -2392.506,
              -1175.197,
              6140.439
            ],
            [
              -2431.277,
              -1180.078,
              6179.516
            ],
            [
              -2478.584,
              -1193.714,
              6228.749
            ],
            [
              -2533.196,
              -1219.467,
              6289.128
            ],
            [
              -2617.204,
              -1266.966,
              6385.635
            ],
            [
              -2663.944,
              -1285.067,
              6435.757
            ],
            [
              -2710.565,
              -1296.491,
              6483.758
            ],
            [
              -2762.381,
              -1304.469,
              6536.185
            ],
            [
              -2808.767,
              -1305.331,
              6582.578
            ],
            [
              -2858.119,
              -1300.984,
              6632.122
            ],
            [
              -3071.028,
              -1263.439,
              6848.315
            ],
            [
              -3139.719,
              -1251.188,
              6918.09
            ],
            [
              -3159.719,
              -1247.413,
              6938.443
            ],
            [
              -3359.526,
              -1207.182,
              7142.26
            ],
            [
              -3495.953,
              -1192.555,
              7279.469
            ],
            [
              -3569.469,
              -1193.5,
              7352.991
            ],
            [
              -3626.266,
              -1196.964,
              7409.894
            ],
            [
              -3684.51,
              -1178.609,
              7470.961
            ],
            [
              -3714.349,
              -1169.288,
              7502.222
            ],
            [
              -3768.714,
              -1158.717,
              7557.605
            ],
            [
              -3858.305,
              -1156.194,
              7647.232
            ],
            [
              -4063.615,
              -1172.672,
              7853.202
            ],
            [
              -4237.967,
              -1188.581,
              8028.279
            ],
            [
              -4268.356,
              -1193.623,
              8059.083
            ],
            [
              -4296.043,
              -1199.905,
              8087.474
            ],
            [
              -4333.704,
              -1206.966,
              8125.791
            ],
            [
              -4364.15,
              -1215.347,
              8157.37
            ],
            [
              -4597.068,
              -1300.392,
              8405.328
            ],
            [
              -4637.998,
              -1318.612,
              8450.13
            ],
            [
              -4714.189,
              -1362.945,
              8538.281
            ],
            [
              -4755.992,
              -1394.51,
              8590.662
            ],
            [
              -4809.036,
              -1442.581,
              8662.248
            ],
            [
              -4835.962,
              -1480.117,
              8708.442
            ],
            [
              -5092.18,
              -1789.506,
              9110.151
            ],
            [
              -5145.16,
              -1834.242,
              9179.492
            ],
            [
              -5263.682,
              -1904.577,
              9317.312
            ],
            [
              -5341.696,
              -1943.323,
              9404.418
            ],
            [
              -5353.315,
              -1944.238,
              9416.073
            ],
            [
              -5858.685,
              -2210.618,
              9987.35
            ],
            [
              -5881.906,
              -2223.697,
              10014
            ],
            [
              -6049.087,
              -2302.022,
              10198.62
            ],
            [
              -6102.245,
              -2320.049,
              10254.752
            ],
            [
              -6166.945,
              -2334.543,
              10321.055
            ],
            [
              -6282.53,
              -2341.97,
              10436.879
            ],
            [
              -6377.159,
              -2339.91,
              10531.53
            ],
            [
              -6675.557,
              -2338.243,
              10829.933
            ],
            [
              -6684.39,
              -2262.232,
              10906.455
            ],
            [
              -6668.455,
              -1991.046,
              11178.109
            ],
            [
              -6680.407,
              -1819.414,
              11350.157
            ],
            [
              -6680.925,
              -1734.803,
              11434.769
            ],
            [
              -6684.251,
              -1702.465,
              11467.278
            ],
            [
              -6705.09,
              -1676.513,
              11500.561
            ],
            [
              -6747.127,
              -1568.943,
              11616.053
            ],
            [
              -6771.666,
              -1532.911,
              11659.647
            ],
            [
              -6834.733,
              -1410.519,
              11797.333
            ],
            [
              -6861.847,
              -1368.999,
              11846.922
            ],
            [
              -6868.44,
              -1344.278,
              11872.507
            ],
            [
              -6865.755,
              -1340.811,
              11876.892
            ],
            [
              -6856.389,
              -1336.272,
              11887.3
            ],
            [
              -6847.396,
              -1333.735,
              11896.643
            ],
            [
              -6839.19,
              -1361.045,
              11925.16
            ],
            [
              -6825.084,
              -1411.793,
              11977.832
            ],
            [
              -6801.411,
              -1461.169,
              12032.589
            ],
            [
              -6771.957,
              -1511.755,
              12091.126
            ],
            [
              -6765.128,
              -1527.454,
              12108.246
            ],
            [
              -6769.807,
              -1537.394,
              12119.232
            ],
            [
              -6771.141,
              -1540.619,
              12122.722
            ],
            [
              -6827.09,
              -1597.371,
              12202.415
            ],
            [
              -6841.227,
              -1604.648,
              12218.316
            ],
            [
              -6863.189,
              -1570.343,
              12259.048
            ],
            [
              -6866.907,
              -1561.375,
              12268.756
            ],
            [
              -6864.843,
              -1553.618,
              12276.783
            ],
            [
              -6782.722,
              -1517.922,
              12366.327
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:7589",
              "position": {
                "x": 1524.687,
                "z": -2513.037
              },
              "distanceAlongShapeM": 134.748,
              "shapeOffsetM": 2.608,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:9565",
              "position": {
                "x": 1231.149,
                "z": -2596.659
              },
              "distanceAlongShapeM": 566.425,
              "shapeOffsetM": 5.403,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:9637",
              "position": {
                "x": 874.193,
                "z": -2624.582
              },
              "distanceAlongShapeM": 972.283,
              "shapeOffsetM": 4.868,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:9640",
              "position": {
                "x": 793.859,
                "z": -2331.434
              },
              "distanceAlongShapeM": 1277.917,
              "shapeOffsetM": 8.003,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:5351",
              "position": {
                "x": 407.176,
                "z": -2116.162
              },
              "distanceAlongShapeM": 1978.536,
              "shapeOffsetM": 0.163,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:5467",
              "position": {
                "x": 324.984,
                "z": -1640.419
              },
              "distanceAlongShapeM": 2462.259,
              "shapeOffsetM": 1.254,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:5378",
              "position": {
                "x": 265.625,
                "z": -1219.643
              },
              "distanceAlongShapeM": 2887.547,
              "shapeOffsetM": 3.789,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:753",
              "position": {
                "x": -53.078,
                "z": -805.275
              },
              "distanceAlongShapeM": 3677.446,
              "shapeOffsetM": 6.187,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            },
            {
              "stopId": "judu:stop:7382",
              "position": {
                "x": -534.689,
                "z": -1051.466
              },
              "distanceAlongShapeM": 4218.453,
              "shapeOffsetM": 1.38,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:988",
              "position": {
                "x": -763.423,
                "z": -1114.127
              },
              "distanceAlongShapeM": 4455.413,
              "shapeOffsetM": 5.791,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:6404",
              "position": {
                "x": -1096.995,
                "z": -1127.045
              },
              "distanceAlongShapeM": 4832.202,
              "shapeOffsetM": 4.91,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:814",
              "position": {
                "x": -1374.402,
                "z": -1172.164
              },
              "distanceAlongShapeM": 5115.058,
              "shapeOffsetM": 3.313,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            },
            {
              "stopId": "judu:stop:5906",
              "position": {
                "x": -2267.097,
                "z": -1193.002
              },
              "distanceAlongShapeM": 6013.698,
              "shapeOffsetM": 6.203,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            },
            {
              "stopId": "judu:stop:7415",
              "position": {
                "x": -3140.52,
                "z": -1255.542
              },
              "distanceAlongShapeM": 6918.09,
              "shapeOffsetM": 4.427,
              "arrivalOffsetSeconds": 1560,
              "departureOffsetSeconds": 1560
            },
            {
              "stopId": "judu:stop:4991",
              "position": {
                "x": -3688.025,
                "z": -1189.21
              },
              "distanceAlongShapeM": 7471.156,
              "shapeOffsetM": 11.167,
              "arrivalOffsetSeconds": 1680,
              "departureOffsetSeconds": 1680
            },
            {
              "stopId": "judu:stop:4988",
              "position": {
                "x": -4294.993,
                "z": -1205.408
              },
              "distanceAlongShapeM": 8087.474,
              "shapeOffsetM": 5.602,
              "arrivalOffsetSeconds": 1800,
              "departureOffsetSeconds": 1800
            },
            {
              "stopId": "judu:stop:8060",
              "position": {
                "x": -4834.84,
                "z": -1481.101
              },
              "distanceAlongShapeM": 8708.485,
              "shapeOffsetM": 1.492,
              "arrivalOffsetSeconds": 1920,
              "departureOffsetSeconds": 1920
            },
            {
              "stopId": "judu:stop:7947",
              "position": {
                "x": -5880.858,
                "z": -2225.828
              },
              "distanceAlongShapeM": 10014,
              "shapeOffsetM": 2.374,
              "arrivalOffsetSeconds": 2040,
              "departureOffsetSeconds": 2040
            },
            {
              "stopId": "judu:stop:7948",
              "position": {
                "x": -6282.493,
                "z": -2344.842
              },
              "distanceAlongShapeM": 10436.879,
              "shapeOffsetM": 2.873,
              "arrivalOffsetSeconds": 2160,
              "departureOffsetSeconds": 2160
            },
            {
              "stopId": "judu:stop:7959",
              "position": {
                "x": -6689.755,
                "z": -2262.309
              },
              "distanceAlongShapeM": 10906.455,
              "shapeOffsetM": 5.365,
              "arrivalOffsetSeconds": 2280,
              "departureOffsetSeconds": 2280
            },
            {
              "stopId": "judu:stop:7695",
              "position": {
                "x": -6705.09,
                "z": -1676.513
              },
              "distanceAlongShapeM": 11500.561,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2400,
              "departureOffsetSeconds": 2400
            },
            {
              "stopId": "judu:stop:7693",
              "position": {
                "x": -6863.711,
                "z": -1369.96
              },
              "distanceAlongShapeM": 11846.922,
              "shapeOffsetM": 2.097,
              "arrivalOffsetSeconds": 2460,
              "departureOffsetSeconds": 2460
            }
          ],
          "departuresSeconds": [
            21420,
            22800,
            24180,
            25560,
            26880,
            28200,
            29520,
            30720,
            32400,
            34260,
            36060,
            38700,
            40380,
            42000,
            43140,
            44820,
            46620,
            48240,
            49860,
            51480,
            53100,
            54600,
            56160,
            57720,
            58680,
            59880,
            61680,
            63420,
            65220,
            66780,
            68700,
            70380,
            72060,
            73560,
            75060,
            76560,
            78060,
            79500,
            81000,
            82500,
            84000
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_bus_31",
      "sourceRouteId": "vilnius_bus_31",
      "mode": "bus",
      "shortName": "31",
      "longName": "Stotis–Pavilnys–Naujoji Vilnia (Apylanka)",
      "color": "0073AC",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_bus_31:0",
          "sourceRouteId": "vilnius_bus_31",
          "sourceShapeId": "vilnius_bus_31_a-b",
          "directionId": 0,
          "headsign": "Naujoji Vilnia (Apylanka)",
          "directionName": "Stotis–Pavilnys–Naujoji Vilnia (Apylanka)",
          "mode": "bus",
          "routeShortName": "31",
          "routeLongName": "Stotis–Pavilnys–Naujoji Vilnia (Apylanka)",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              493.411,
              1911.506,
              0
            ],
            [
              476.616,
              1921.478,
              19.531
            ],
            [
              453.967,
              1920.686,
              42.195
            ],
            [
              432.764,
              1925.527,
              63.943
            ],
            [
              422.444,
              1925.716,
              74.265
            ],
            [
              419.803,
              1922.424,
              78.485
            ],
            [
              402.263,
              1927.258,
              96.68
            ],
            [
              397.27,
              1925.063,
              102.134
            ],
            [
              384.004,
              1905.267,
              125.964
            ],
            [
              371.312,
              1878.4,
              155.677
            ],
            [
              344.166,
              1843.654,
              199.77
            ],
            [
              330.657,
              1810.504,
              235.567
            ],
            [
              391.321,
              1670.242,
              388.386
            ],
            [
              477.846,
              1568.468,
              521.969
            ],
            [
              485.021,
              1572.79,
              530.346
            ],
            [
              495.103,
              1594.87,
              554.618
            ],
            [
              501.968,
              1590.033,
              563.016
            ],
            [
              515.385,
              1586.833,
              576.81
            ],
            [
              552.903,
              1580.453,
              614.866
            ],
            [
              580.038,
              1581.942,
              642.043
            ],
            [
              658.651,
              1577.401,
              720.786
            ],
            [
              692.229,
              1579.012,
              754.403
            ],
            [
              741.723,
              1585.833,
              804.364
            ],
            [
              775.59,
              1587.408,
              838.268
            ],
            [
              809.306,
              1578.914,
              873.037
            ],
            [
              847.494,
              1567.254,
              912.966
            ],
            [
              881.41,
              1552.158,
              950.09
            ],
            [
              943.873,
              1514.16,
              1023.203
            ],
            [
              977.642,
              1498.755,
              1060.32
            ],
            [
              986.83,
              1496.24,
              1069.846
            ],
            [
              1014.875,
              1489.647,
              1098.656
            ],
            [
              1169.279,
              1454.457,
              1257.019
            ],
            [
              1223.933,
              1444.542,
              1312.565
            ],
            [
              1248.034,
              1479.023,
              1354.634
            ],
            [
              1335.324,
              1607.243,
              1509.746
            ],
            [
              1391.043,
              1689.705,
              1609.268
            ],
            [
              1392.56,
              1701.923,
              1621.58
            ],
            [
              1383.026,
              1766.597,
              1686.953
            ],
            [
              1394.43,
              1792.571,
              1715.32
            ],
            [
              1389.809,
              1786.443,
              1722.995
            ],
            [
              1472.71,
              1884.123,
              1851.112
            ],
            [
              1484.045,
              1903.952,
              1873.952
            ],
            [
              1527.015,
              1994.441,
              1974.126
            ],
            [
              1537.019,
              2014.769,
              1996.782
            ],
            [
              1543.504,
              2028.475,
              2011.944
            ],
            [
              1551.767,
              2041.852,
              2027.668
            ],
            [
              1562.918,
              2051.664,
              2042.521
            ],
            [
              1590.338,
              2068.968,
              2074.945
            ],
            [
              1610.663,
              2086.403,
              2101.723
            ],
            [
              1702.063,
              2282.863,
              2318.404
            ],
            [
              1756.341,
              2356.442,
              2409.837
            ],
            [
              1770.78,
              2369.533,
              2429.327
            ],
            [
              1787.717,
              2378.124,
              2448.318
            ],
            [
              1803.322,
              2384.513,
              2465.18
            ],
            [
              1851.97,
              2398.081,
              2515.685
            ],
            [
              1902.003,
              2404.315,
              2566.104
            ],
            [
              1960.233,
              2419.132,
              2626.19
            ],
            [
              1982.789,
              2423.477,
              2649.161
            ],
            [
              2016.977,
              2422.84,
              2683.355
            ],
            [
              2299.993,
              2357.105,
              2973.905
            ],
            [
              2317.36,
              2352.884,
              2991.777
            ],
            [
              2341.251,
              2347.002,
              3016.382
            ],
            [
              2404.362,
              2330.998,
              3081.49
            ],
            [
              2453.344,
              2327.854,
              3130.573
            ],
            [
              2522.158,
              2343.947,
              3201.244
            ],
            [
              2590.757,
              2354.799,
              3270.695
            ],
            [
              2633.759,
              2349.934,
              3313.972
            ],
            [
              2718.966,
              2326.47,
              3402.35
            ],
            [
              2777.655,
              2313.974,
              3462.355
            ],
            [
              2795.071,
              2313.647,
              3479.774
            ],
            [
              2818.355,
              2316.549,
              3503.238
            ],
            [
              2887.128,
              2336.406,
              3574.821
            ],
            [
              3040.725,
              2386.685,
              3736.437
            ],
            [
              3104.507,
              2394.461,
              3800.692
            ],
            [
              3102.149,
              2394.343,
              3803.053
            ],
            [
              3127.616,
              2394.214,
              3828.521
            ],
            [
              3198.032,
              2398.45,
              3899.064
            ],
            [
              3300.456,
              2423.231,
              4004.443
            ],
            [
              3355.729,
              2445.563,
              4064.057
            ],
            [
              3441.784,
              2491.803,
              4161.748
            ],
            [
              3660.291,
              2614.568,
              4412.381
            ],
            [
              3747.601,
              2658.552,
              4510.144
            ],
            [
              3985.636,
              2755.326,
              4767.099
            ],
            [
              4043.411,
              2773.149,
              4827.56
            ],
            [
              4084.265,
              2783.502,
              4869.706
            ],
            [
              4139.04,
              2791.278,
              4925.03
            ],
            [
              4152.847,
              2750.842,
              4967.759
            ],
            [
              4165.87,
              2713.822,
              5007.002
            ],
            [
              4170.055,
              2702.335,
              5019.228
            ],
            [
              4191.056,
              2664.57,
              5062.44
            ],
            [
              4218.241,
              2635.106,
              5102.529
            ],
            [
              4239.21,
              2618.006,
              5129.586
            ],
            [
              4282.48,
              2586.007,
              5183.403
            ],
            [
              4309.254,
              2568.796,
              5215.232
            ],
            [
              4467.307,
              2518.783,
              5381.009
            ],
            [
              4608.628,
              2469.276,
              5530.751
            ],
            [
              4652.542,
              2440.656,
              5583.167
            ],
            [
              4671.824,
              2429.363,
              5605.513
            ],
            [
              4814.301,
              2355.374,
              5766.056
            ],
            [
              4977.975,
              2276.518,
              5947.736
            ],
            [
              5036.251,
              2292.61,
              6008.193
            ],
            [
              5084.32,
              2303.41,
              6057.46
            ],
            [
              5241.303,
              2346.019,
              6220.123
            ],
            [
              5248.742,
              2330.289,
              6237.523
            ],
            [
              5275.468,
              2246.045,
              6325.905
            ],
            [
              5288.068,
              2206.568,
              6367.344
            ],
            [
              5291.267,
              2193.648,
              6380.654
            ],
            [
              5301.956,
              2163.05,
              6413.066
            ],
            [
              5310.723,
              2132.042,
              6445.289
            ],
            [
              5423.353,
              2164.203,
              6562.421
            ],
            [
              5529.09,
              2192.166,
              6671.793
            ],
            [
              5589.007,
              2202.446,
              6732.585
            ],
            [
              5669.02,
              2207.471,
              6812.756
            ],
            [
              5735.04,
              2214.148,
              6879.113
            ],
            [
              5787.277,
              2216.303,
              6931.394
            ],
            [
              5891.696,
              2210.786,
              7035.958
            ],
            [
              5919.864,
              2201.377,
              7065.657
            ],
            [
              5990.028,
              2169.634,
              7142.666
            ],
            [
              6007.137,
              2155.583,
              7164.806
            ],
            [
              6021.249,
              2131.273,
              7192.915
            ],
            [
              6065.185,
              2139.635,
              7237.639
            ],
            [
              6096.011,
              2142.926,
              7268.641
            ],
            [
              6153.148,
              2150.162,
              7326.234
            ],
            [
              6185.008,
              2156.828,
              7358.784
            ],
            [
              6187.19,
              2157.268,
              7361.009
            ],
            [
              6190.184,
              2157.873,
              7364.064
            ],
            [
              6302.78,
              2179.519,
              7478.722
            ],
            [
              6370.901,
              2198.223,
              7549.364
            ],
            [
              6485.314,
              2234.633,
              7669.431
            ],
            [
              6518.994,
              2247.642,
              7705.536
            ],
            [
              6647.152,
              2266.155,
              7835.024
            ],
            [
              6648.734,
              2249.547,
              7851.707
            ],
            [
              6664.061,
              2175.769,
              7927.061
            ],
            [
              6679.103,
              2087.525,
              8016.578
            ],
            [
              6685.858,
              2037.294,
              8067.261
            ],
            [
              6713.03,
              2017.898,
              8100.645
            ],
            [
              6722.098,
              2009.863,
              8112.761
            ],
            [
              6786.898,
              1954.139,
              8198.226
            ],
            [
              6934.171,
              1835.354,
              8387.432
            ],
            [
              6985.448,
              1801.667,
              8448.785
            ],
            [
              6994.719,
              1797.421,
              8458.982
            ],
            [
              7151.902,
              1752.011,
              8622.593
            ],
            [
              7180.711,
              1747.342,
              8651.778
            ],
            [
              7232.816,
              1732.598,
              8705.929
            ],
            [
              7218.9,
              1583.694,
              8855.481
            ],
            [
              7576.848,
              1544.311,
              9215.59
            ],
            [
              7614.877,
              1542.442,
              9253.664
            ],
            [
              7753.696,
              1547.075,
              9392.561
            ],
            [
              7798.773,
              1543.236,
              9437.801
            ],
            [
              7797.757,
              1494.417,
              9486.63
            ],
            [
              7793.796,
              1487.671,
              9494.453
            ],
            [
              7754.104,
              1114.398,
              9869.831
            ],
            [
              7755.189,
              1097.018,
              9887.245
            ],
            [
              7751.793,
              1095.518,
              9890.957
            ],
            [
              7745.305,
              1028.85,
              9957.94
            ],
            [
              8018.963,
              975.009,
              10236.843
            ],
            [
              8065.926,
              965.532,
              10284.754
            ],
            [
              8092.242,
              957.359,
              10312.31
            ],
            [
              8117.792,
              944.602,
              10340.867
            ],
            [
              8150.835,
              919.449,
              10382.395
            ],
            [
              8217.435,
              859.556,
              10471.965
            ],
            [
              8287.693,
              795.361,
              10567.134
            ],
            [
              8311.795,
              774.839,
              10598.789
            ],
            [
              8341.723,
              755.313,
              10634.523
            ],
            [
              8683.89,
              590.023,
              11014.521
            ],
            [
              8697.385,
              584.51,
              11029.099
            ],
            [
              8699.953,
              575.322,
              11038.639
            ],
            [
              8694.685,
              567.872,
              11047.763
            ],
            [
              8685.547,
              537.815,
              11079.179
            ],
            [
              8661.183,
              441.631,
              11178.401
            ],
            [
              8618.998,
              285.592,
              11340.042
            ],
            [
              8586.11,
              199.304,
              11432.384
            ],
            [
              8585.045,
              183.764,
              11447.961
            ],
            [
              8590.333,
              158.052,
              11474.211
            ],
            [
              8621.917,
              92.846,
              11546.664
            ],
            [
              8636.204,
              33.555,
              11607.652
            ],
            [
              8637.068,
              12.385,
              11628.839
            ],
            [
              8604.283,
              -110.532,
              11756.053
            ],
            [
              8595.54,
              -160.454,
              11806.735
            ],
            [
              8696.309,
              -134.44,
              11910.808
            ],
            [
              8720.235,
              -127.625,
              11935.686
            ],
            [
              8744.3,
              -121.003,
              11960.645
            ],
            [
              8789.403,
              -109.804,
              12007.118
            ],
            [
              8826.448,
              -96.087,
              12046.62
            ],
            [
              8853.145,
              -83.257,
              12076.241
            ],
            [
              8900.484,
              -38.566,
              12141.343
            ],
            [
              8997.947,
              60.777,
              12280.512
            ],
            [
              9045.087,
              95.45,
              12339.03
            ],
            [
              9064.009,
              106.201,
              12360.793
            ],
            [
              9090.691,
              117.908,
              12389.93
            ],
            [
              9117.305,
              128.24,
              12418.48
            ],
            [
              9141.918,
              131.345,
              12443.288
            ],
            [
              9732.973,
              138.29,
              13034.384
            ],
            [
              9769.057,
              138.275,
              13070.467
            ],
            [
              9778.039,
              138.272,
              13079.449
            ],
            [
              9786.285,
              131.627,
              13090.039
            ],
            [
              9791.489,
              121.44,
              13101.479
            ],
            [
              9796.374,
              85.087,
              13138.158
            ],
            [
              9802.683,
              50.022,
              13173.786
            ],
            [
              9807.365,
              26.547,
              13197.724
            ],
            [
              9824.001,
              -11.644,
              13239.381
            ],
            [
              9851.507,
              -54.51,
              13290.313
            ],
            [
              9917.554,
              -168.3,
              13421.882
            ],
            [
              9939.188,
              -214.387,
              13472.794
            ],
            [
              10013.097,
              -385.117,
              13658.835
            ],
            [
              10031.411,
              -422.47,
              13700.436
            ],
            [
              10043.876,
              -456.998,
              13737.145
            ],
            [
              10126.945,
              -652.41,
              13949.48
            ],
            [
              10156.362,
              -727.603,
              14030.223
            ],
            [
              10172.333,
              -798.068,
              14102.475
            ],
            [
              10176.882,
              -859.393,
              14163.969
            ],
            [
              10168.935,
              -951.301,
              14256.22
            ],
            [
              10159.659,
              -998.046,
              14303.876
            ],
            [
              10195.194,
              -1004.498,
              14339.992
            ],
            [
              10311.718,
              -976.814,
              14459.759
            ],
            [
              10391.505,
              -959.534,
              14541.397
            ],
            [
              10443.146,
              -948.083,
              14594.292
            ],
            [
              10485.404,
              -940.307,
              14637.259
            ],
            [
              10491.192,
              -941.758,
              14643.226
            ],
            [
              10485.498,
              -942.974,
              14649.048
            ],
            [
              10470.482,
              -946.181,
              14664.403
            ],
            [
              10459.683,
              -948.488,
              14675.445
            ],
            [
              10456.499,
              -949.168,
              14678.701
            ],
            [
              10449.419,
              -950.68,
              14685.941
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:4267",
              "position": {
                "x": 372.531,
                "z": 1877.646
              },
              "distanceAlongShapeM": 155.677,
              "shapeOffsetM": 1.434,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:5355",
              "position": {
                "x": 580.051,
                "z": 1583.295
              },
              "distanceAlongShapeM": 642.043,
              "shapeOffsetM": 1.353,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:5358",
              "position": {
                "x": 979.224,
                "z": 1503.603
              },
              "distanceAlongShapeM": 1059.747,
              "shapeOffsetM": 5.067,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:6673",
              "position": {
                "x": 1245.249,
                "z": 1480.885
              },
              "distanceAlongShapeM": 1354.564,
              "shapeOffsetM": 3.349,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:8821",
              "position": {
                "x": 1389.15,
                "z": 1796.611
              },
              "distanceAlongShapeM": 1715.32,
              "shapeOffsetM": 6.649,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:6675",
              "position": {
                "x": 1530.673,
                "z": 2017.752
              },
              "distanceAlongShapeM": 1996.656,
              "shapeOffsetM": 7.011,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:6678",
              "position": {
                "x": 1914.123,
                "z": 2409.17
              },
              "distanceAlongShapeM": 2579.048,
              "shapeOffsetM": 1.716,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:6681",
              "position": {
                "x": 2318.384,
                "z": 2357.098
              },
              "distanceAlongShapeM": 2991.777,
              "shapeOffsetM": 4.337,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:6683",
              "position": {
                "x": 3101.877,
                "z": 2398.039
              },
              "distanceAlongShapeM": 3803.053,
              "shapeOffsetM": 3.706,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:6687",
              "position": {
                "x": 4169.434,
                "z": 2715.08
              },
              "distanceAlongShapeM": 5007.04,
              "shapeOffsetM": 3.779,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:6691",
              "position": {
                "x": 4467.714,
                "z": 2520.116
              },
              "distanceAlongShapeM": 5380.995,
              "shapeOffsetM": 1.394,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:6694",
              "position": {
                "x": 5035.146,
                "z": 2296.566
              },
              "distanceAlongShapeM": 6008.18,
              "shapeOffsetM": 4.108,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:18787",
              "position": {
                "x": 5292.838,
                "z": 2208.09
              },
              "distanceAlongShapeM": 6367.344,
              "shapeOffsetM": 5.007,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:19201",
              "position": {
                "x": 6186.283,
                "z": 2161.76
              },
              "distanceAlongShapeM": 7361.009,
              "shapeOffsetM": 4.582,
              "arrivalOffsetSeconds": 1500,
              "departureOffsetSeconds": 1500
            },
            {
              "stopId": "judu:stop:19206",
              "position": {
                "x": 6713.888,
                "z": 2018.931
              },
              "distanceAlongShapeM": 8100.645,
              "shapeOffsetM": 1.343,
              "arrivalOffsetSeconds": 1680,
              "departureOffsetSeconds": 1680
            },
            {
              "stopId": "judu:stop:19200",
              "position": {
                "x": 7280.06,
                "z": 1576.917
              },
              "distanceAlongShapeM": 8917.016,
              "shapeOffsetM": 0.048,
              "arrivalOffsetSeconds": 1860,
              "departureOffsetSeconds": 1860
            },
            {
              "stopId": "judu:stop:18884",
              "position": {
                "x": 7799.733,
                "z": 1494.232
              },
              "distanceAlongShapeM": 9486.63,
              "shapeOffsetM": 1.985,
              "arrivalOffsetSeconds": 1980,
              "departureOffsetSeconds": 1980
            },
            {
              "stopId": "judu:stop:18903",
              "position": {
                "x": 7760.199,
                "z": 1096.464
              },
              "distanceAlongShapeM": 9887.245,
              "shapeOffsetM": 5.041,
              "arrivalOffsetSeconds": 2040,
              "departureOffsetSeconds": 2040
            },
            {
              "stopId": "judu:stop:6035",
              "position": {
                "x": 8692.348,
                "z": 547.88
              },
              "distanceAlongShapeM": 11067.571,
              "shapeOffsetM": 3.579,
              "arrivalOffsetSeconds": 2160,
              "departureOffsetSeconds": 2160
            },
            {
              "stopId": "judu:stop:6040",
              "position": {
                "x": 8718.239,
                "z": -120.617
              },
              "distanceAlongShapeM": 11935.686,
              "shapeOffsetM": 7.287,
              "arrivalOffsetSeconds": 2340,
              "departureOffsetSeconds": 2340
            },
            {
              "stopId": "judu:stop:6042",
              "position": {
                "x": 9116.151,
                "z": 132.979
              },
              "distanceAlongShapeM": 12418.48,
              "shapeOffsetM": 4.877,
              "arrivalOffsetSeconds": 2400,
              "departureOffsetSeconds": 2400
            },
            {
              "stopId": "judu:stop:6044",
              "position": {
                "x": 9552.934,
                "z": 138.6
              },
              "distanceAlongShapeM": 12854.36,
              "shapeOffsetM": 2.425,
              "arrivalOffsetSeconds": 2460,
              "departureOffsetSeconds": 2460
            },
            {
              "stopId": "judu:stop:6047",
              "position": {
                "x": 9800.829,
                "z": 85.686
              },
              "distanceAlongShapeM": 13138.358,
              "shapeOffsetM": 4.49,
              "arrivalOffsetSeconds": 2580,
              "departureOffsetSeconds": 2580
            },
            {
              "stopId": "judu:stop:6048",
              "position": {
                "x": 10034.288,
                "z": -421.176
              },
              "distanceAlongShapeM": 13700.436,
              "shapeOffsetM": 3.155,
              "arrivalOffsetSeconds": 2640,
              "departureOffsetSeconds": 2640
            },
            {
              "stopId": "judu:stop:6051",
              "position": {
                "x": 10171.77,
                "z": -951.693
              },
              "distanceAlongShapeM": 14256.22,
              "shapeOffsetM": 2.862,
              "arrivalOffsetSeconds": 2700,
              "departureOffsetSeconds": 2700
            },
            {
              "stopId": "judu:stop:8373",
              "position": {
                "x": 10364.963,
                "z": -964.556
              },
              "distanceAlongShapeM": 14514.393,
              "shapeOffsetM": 0.71,
              "arrivalOffsetSeconds": 2760,
              "departureOffsetSeconds": 2760
            },
            {
              "stopId": "judu:stop:1129",
              "position": {
                "x": 10452.051,
                "z": -963.002
              },
              "distanceAlongShapeM": 14685.941,
              "shapeOffsetM": 12.6,
              "arrivalOffsetSeconds": 2820,
              "departureOffsetSeconds": 2820
            }
          ],
          "departuresSeconds": [
            18420,
            19740,
            21960,
            22920,
            24120,
            25320,
            26700,
            28320,
            29520,
            30780,
            33780,
            35460,
            37140,
            39240,
            40560,
            42180,
            43920,
            45660,
            46920,
            48540,
            50280,
            52020,
            54060,
            55440,
            56460,
            57780,
            59040,
            60540,
            61920,
            63360,
            64800,
            66240,
            67620,
            69300,
            73260,
            74880,
            76500,
            78120,
            79560,
            81060,
            83220
          ]
        },
        {
          "id": "judu:pattern:vilnius_bus_31:1",
          "sourceRouteId": "vilnius_bus_31",
          "sourceShapeId": "vilnius_bus_31_b-a",
          "directionId": 1,
          "headsign": "Stotis (Apylanka)",
          "directionName": "Naujoji Vilnia–Pavilnys–Stotis (Apylanka)",
          "mode": "bus",
          "routeShortName": "31",
          "routeLongName": "Stotis–Pavilnys–Naujoji Vilnia (Apylanka)",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              10449.419,
              -950.68,
              0
            ],
            [
              10441.841,
              -952.298,
              7.749
            ],
            [
              10427.739,
              -953.597,
              21.911
            ],
            [
              10203.619,
              -1002.443,
              251.292
            ],
            [
              10159.659,
              -998.046,
              295.471
            ],
            [
              10166.522,
              -940.643,
              353.283
            ],
            [
              10170.977,
              -909.406,
              384.837
            ],
            [
              10174.554,
              -847.099,
              447.246
            ],
            [
              10168.048,
              -786.848,
              507.847
            ],
            [
              10156.362,
              -727.603,
              568.234
            ],
            [
              10041.964,
              -455.845,
              863.089
            ],
            [
              9995.97,
              -358.985,
              970.314
            ],
            [
              9979.108,
              -318.867,
              1013.831
            ],
            [
              9967.299,
              -290.665,
              1044.406
            ],
            [
              9947.183,
              -233.476,
              1105.03
            ],
            [
              9888.206,
              -120.943,
              1232.081
            ],
            [
              9839.53,
              -40.906,
              1325.757
            ],
            [
              9813.404,
              6.385,
              1379.785
            ],
            [
              9798.056,
              44.55,
              1420.921
            ],
            [
              9791,
              78.093,
              1455.198
            ],
            [
              9786.285,
              131.627,
              1508.939
            ],
            [
              9766.321,
              133.147,
              1528.961
            ],
            [
              9682.329,
              129.236,
              1613.044
            ],
            [
              9621.808,
              131.634,
              1673.612
            ],
            [
              9517.36,
              133.756,
              1778.082
            ],
            [
              9448.882,
              128.466,
              1846.764
            ],
            [
              9389.611,
              131.895,
              1906.134
            ],
            [
              9156.08,
              129.945,
              2139.673
            ],
            [
              9090.691,
              117.908,
              2206.161
            ],
            [
              9071.372,
              103.392,
              2230.326
            ],
            [
              9049.578,
              94.246,
              2253.961
            ],
            [
              8990.008,
              50.917,
              2327.622
            ],
            [
              8869.532,
              -70.228,
              2498.475
            ],
            [
              8853.145,
              -83.257,
              2519.41
            ],
            [
              8819.883,
              -101.512,
              2557.352
            ],
            [
              8767.948,
              -118.279,
              2611.927
            ],
            [
              8695.316,
              -137.969,
              2687.18
            ],
            [
              8672.646,
              -150.383,
              2713.027
            ],
            [
              8624.533,
              -154.886,
              2761.35
            ],
            [
              8595.54,
              -160.454,
              2790.873
            ],
            [
              8604.283,
              -110.532,
              2841.554
            ],
            [
              8637.068,
              12.385,
              2968.769
            ],
            [
              8631.494,
              55.915,
              3012.654
            ],
            [
              8618.16,
              98.488,
              3057.266
            ],
            [
              8587.933,
              167.007,
              3132.156
            ],
            [
              8585.045,
              183.764,
              3149.16
            ],
            [
              8637.514,
              355.27,
              3328.513
            ],
            [
              8660.493,
              439.418,
              3415.742
            ],
            [
              8697.348,
              584.583,
              3565.512
            ],
            [
              8662.22,
              595.021,
              3602.158
            ],
            [
              8637.029,
              608.653,
              3630.801
            ],
            [
              8464.489,
              692.014,
              3822.423
            ],
            [
              8342.301,
              751.962,
              3958.525
            ],
            [
              8316.842,
              769.171,
              3989.255
            ],
            [
              8273.062,
              805.674,
              4046.256
            ],
            [
              8139.983,
              925.232,
              4225.153
            ],
            [
              8108.786,
              945.895,
              4262.572
            ],
            [
              8069.094,
              961.161,
              4305.099
            ],
            [
              8003.009,
              974.194,
              4372.457
            ],
            [
              7745.305,
              1028.85,
              4635.893
            ],
            [
              7744.926,
              1042.217,
              4649.265
            ],
            [
              7748.948,
              1082.215,
              4689.465
            ],
            [
              7750.105,
              1104.277,
              4711.557
            ],
            [
              7752.147,
              1113.323,
              4720.831
            ],
            [
              7763.904,
              1217.738,
              4825.906
            ],
            [
              7796.816,
              1542.162,
              5151.995
            ],
            [
              7665.182,
              1541.442,
              5283.631
            ],
            [
              7625.101,
              1540.027,
              5323.737
            ],
            [
              7556.811,
              1542.482,
              5392.071
            ],
            [
              7314.963,
              1571.564,
              5635.661
            ],
            [
              7312.682,
              1571.801,
              5637.954
            ],
            [
              7303.454,
              1572.758,
              5647.232
            ],
            [
              7234.452,
              1582.006,
              5716.851
            ],
            [
              7216.672,
              1583.301,
              5734.678
            ],
            [
              7231.658,
              1731.418,
              5883.551
            ],
            [
              7175.7,
              1748.2,
              5941.971
            ],
            [
              7154.008,
              1750.77,
              5963.815
            ],
            [
              6990.433,
              1798.231,
              6134.136
            ],
            [
              6934.621,
              1833.741,
              6200.287
            ],
            [
              6851.474,
              1901.891,
              6307.795
            ],
            [
              6697.49,
              2028.4,
              6507.083
            ],
            [
              6685.346,
              2037.465,
              6522.236
            ],
            [
              6659.323,
              2200.601,
              6687.435
            ],
            [
              6645.17,
              2265.203,
              6753.569
            ],
            [
              6610.185,
              2258.097,
              6789.269
            ],
            [
              6564.923,
              2253.42,
              6834.772
            ],
            [
              6509.253,
              2244.494,
              6891.153
            ],
            [
              6489.706,
              2234.858,
              6912.946
            ],
            [
              6448.85,
              2224.527,
              6955.088
            ],
            [
              6333.161,
              2185.852,
              7077.07
            ],
            [
              6171.274,
              2153.147,
              7242.228
            ],
            [
              6096.011,
              2142.926,
              7318.181
            ],
            [
              6041.878,
              2135.637,
              7372.803
            ],
            [
              6021.128,
              2130.475,
              7394.185
            ],
            [
              6015.482,
              2140.299,
              7405.516
            ],
            [
              5994.066,
              2165.515,
              7438.599
            ],
            [
              5901.318,
              2207.402,
              7540.367
            ],
            [
              5845.213,
              2209.963,
              7596.531
            ],
            [
              5804.067,
              2215.947,
              7638.11
            ],
            [
              5767.883,
              2214.454,
              7674.324
            ],
            [
              5564.331,
              2199.486,
              7878.426
            ],
            [
              5535.175,
              2193.373,
              7908.216
            ],
            [
              5305.929,
              2130.755,
              8145.86
            ],
            [
              5296.303,
              2171.389,
              8187.619
            ],
            [
              5293.875,
              2178.996,
              8195.605
            ],
            [
              5290.601,
              2192.548,
              8209.546
            ],
            [
              5241.948,
              2346.007,
              8370.533
            ],
            [
              4977.975,
              2276.518,
              8643.499
            ],
            [
              4916.401,
              2303.24,
              8710.621
            ],
            [
              4657.116,
              2436.326,
              9002.067
            ],
            [
              4613.807,
              2466.102,
              9054.625
            ],
            [
              4521.576,
              2499.239,
              9152.628
            ],
            [
              4411.017,
              2532.981,
              9268.221
            ],
            [
              4354.111,
              2552.351,
              9328.334
            ],
            [
              4310.879,
              2567.321,
              9374.084
            ],
            [
              4239.21,
              2618.006,
              9461.864
            ],
            [
              4197.939,
              2653.306,
              9516.173
            ],
            [
              4139.04,
              2791.278,
              9666.191
            ],
            [
              4071.945,
              2780.397,
              9734.163
            ],
            [
              4052.738,
              2774.631,
              9754.216
            ],
            [
              4026.587,
              2767.592,
              9781.298
            ],
            [
              3985.636,
              2755.326,
              9824.047
            ],
            [
              3748.891,
              2658.528,
              10079.816
            ],
            [
              3605.492,
              2583.325,
              10241.738
            ],
            [
              3354.752,
              2444.01,
              10528.582
            ],
            [
              3277.045,
              2413.655,
              10612.007
            ],
            [
              3197.387,
              2398.462,
              10693.101
            ],
            [
              3161.141,
              2394.028,
              10729.617
            ],
            [
              3102.923,
              2391.543,
              10787.888
            ],
            [
              3048.326,
              2385.314,
              10842.839
            ],
            [
              3026.736,
              2382.758,
              10864.58
            ],
            [
              2944.248,
              2354.255,
              10951.854
            ],
            [
              2842.347,
              2322.777,
              11058.506
            ],
            [
              2808.638,
              2314.505,
              11093.215
            ],
            [
              2767.334,
              2314.168,
              11134.521
            ],
            [
              2727.488,
              2322.71,
              11175.272
            ],
            [
              2667.167,
              2340.542,
              11238.173
            ],
            [
              2599.009,
              2354.457,
              11307.738
            ],
            [
              2575.82,
              2354.087,
              11330.93
            ],
            [
              2455.843,
              2327.284,
              11453.863
            ],
            [
              2413.996,
              2328.591,
              11495.731
            ],
            [
              2299.657,
              2356.335,
              11613.388
            ],
            [
              2275.023,
              2359.894,
              11638.278
            ],
            [
              2242.456,
              2368.536,
              11671.972
            ],
            [
              2027.256,
              2420.422,
              11893.338
            ],
            [
              2006.656,
              2423.032,
              11914.103
            ],
            [
              1982.789,
              2423.477,
              11937.974
            ],
            [
              1947.251,
              2414.86,
              11974.542
            ],
            [
              1914.522,
              2403.084,
              12009.326
            ],
            [
              1894.574,
              2400.605,
              12029.427
            ],
            [
              1838.32,
              2392.769,
              12086.224
            ],
            [
              1803.322,
              2384.513,
              12122.182
            ],
            [
              1767.472,
              2365.141,
              12162.932
            ],
            [
              1729.877,
              2321.31,
              12220.677
            ],
            [
              1698.713,
              2276.246,
              12275.467
            ],
            [
              1642.821,
              2150.374,
              12413.19
            ],
            [
              1613.971,
              2090.794,
              12479.388
            ],
            [
              1599.762,
              2073.228,
              12501.981
            ],
            [
              1577.232,
              2058.078,
              12529.131
            ],
            [
              1556.282,
              2041.768,
              12555.681
            ],
            [
              1542.345,
              2020.875,
              12580.796
            ],
            [
              1520.803,
              1974.877,
              12631.589
            ],
            [
              1519.033,
              1971.216,
              12635.655
            ],
            [
              1482.673,
              1899.524,
              12716.041
            ],
            [
              1466.095,
              1875.34,
              12745.361
            ],
            [
              1388.903,
              1783.257,
              12865.519
            ],
            [
              1384.162,
              1771.099,
              12878.568
            ],
            [
              1394.596,
              1696.724,
              12953.672
            ],
            [
              1377.026,
              1664.36,
              12990.498
            ],
            [
              1369.509,
              1650.129,
              13006.592
            ],
            [
              1223.933,
              1444.542,
              13258.501
            ],
            [
              990.627,
              1492.26,
              13496.637
            ],
            [
              961.104,
              1500.597,
              13527.315
            ],
            [
              886.508,
              1548.725,
              13616.089
            ],
            [
              861.581,
              1561.429,
              13644.067
            ],
            [
              775.59,
              1587.408,
              13733.897
            ],
            [
              773.577,
              1623.63,
              13770.174
            ],
            [
              781.269,
              1649.737,
              13797.391
            ],
            [
              802.898,
              1738.399,
              13888.653
            ],
            [
              825.163,
              1791.425,
              13946.164
            ],
            [
              623.161,
              1858.587,
              14159.038
            ],
            [
              598.791,
              1864.715,
              14184.166
            ],
            [
              535.995,
              1890.241,
              14251.952
            ],
            [
              493.411,
              1911.506,
              14299.551
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:1129",
              "position": {
                "x": 10452.051,
                "z": -963.002
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 12.6,
              "arrivalOffsetSeconds": -870,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:6052",
              "position": {
                "x": 10164.907,
                "z": -940.42
              },
              "distanceAlongShapeM": 353.283,
              "shapeOffsetM": 1.63,
              "arrivalOffsetSeconds": 60,
              "departureOffsetSeconds": 60
            },
            {
              "stopId": "judu:stop:6049",
              "position": {
                "x": 9971.821,
                "z": -321.93
              },
              "distanceAlongShapeM": 1013.831,
              "shapeOffsetM": 7.905,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:6073",
              "position": {
                "x": 9682.346,
                "z": 127.063
              },
              "distanceAlongShapeM": 1613.044,
              "shapeOffsetM": 2.173,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:6045",
              "position": {
                "x": 9448.882,
                "z": 128.466
              },
              "distanceAlongShapeM": 1846.764,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:6043",
              "position": {
                "x": 9073.545,
                "z": 99.328
              },
              "distanceAlongShapeM": 2230.326,
              "shapeOffsetM": 4.609,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:6041",
              "position": {
                "x": 8673.105,
                "z": -151.995
              },
              "distanceAlongShapeM": 2713.027,
              "shapeOffsetM": 1.676,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:6034",
              "position": {
                "x": 8662.337,
                "z": 595.242
              },
              "distanceAlongShapeM": 3602.109,
              "shapeOffsetM": 0.245,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:19076",
              "position": {
                "x": 7748.101,
                "z": 1104.498
              },
              "distanceAlongShapeM": 4711.557,
              "shapeOffsetM": 2.017,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:18891",
              "position": {
                "x": 7751.004,
                "z": 1541.96
              },
              "distanceAlongShapeM": 5197.807,
              "shapeOffsetM": 0.049,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:19135",
              "position": {
                "x": 7312.108,
                "z": 1566.262
              },
              "distanceAlongShapeM": 5637.954,
              "shapeOffsetM": 5.568,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            },
            {
              "stopId": "judu:stop:18938",
              "position": {
                "x": 6681.136,
                "z": 2059.653
              },
              "distanceAlongShapeM": 6544.811,
              "shapeOffsetM": 0.663,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:19202",
              "position": {
                "x": 6096.19,
                "z": 2141.256
              },
              "distanceAlongShapeM": 7318.227,
              "shapeOffsetM": 1.679,
              "arrivalOffsetSeconds": 1380,
              "departureOffsetSeconds": 1380
            },
            {
              "stopId": "judu:stop:6695",
              "position": {
                "x": 5290.966,
                "z": 2178.068
              },
              "distanceAlongShapeM": 8195.605,
              "shapeOffsetM": 3.054,
              "arrivalOffsetSeconds": 1620,
              "departureOffsetSeconds": 1620
            },
            {
              "stopId": "judu:stop:6693",
              "position": {
                "x": 4915.878,
                "z": 2302.207
              },
              "distanceAlongShapeM": 8710.621,
              "shapeOffsetM": 1.158,
              "arrivalOffsetSeconds": 1740,
              "departureOffsetSeconds": 1740
            },
            {
              "stopId": "judu:stop:6690",
              "position": {
                "x": 4409.806,
                "z": 2529.019
              },
              "distanceAlongShapeM": 9268.221,
              "shapeOffsetM": 4.143,
              "arrivalOffsetSeconds": 1800,
              "departureOffsetSeconds": 1800
            },
            {
              "stopId": "judu:stop:6688",
              "position": {
                "x": 4054.293,
                "z": 2768.488
              },
              "distanceAlongShapeM": 9754.311,
              "shapeOffsetM": 6.336,
              "arrivalOffsetSeconds": 1860,
              "departureOffsetSeconds": 1860
            },
            {
              "stopId": "judu:stop:6682",
              "position": {
                "x": 3048.689,
                "z": 2383.457
              },
              "distanceAlongShapeM": 10842.689,
              "shapeOffsetM": 1.886,
              "arrivalOffsetSeconds": 1980,
              "departureOffsetSeconds": 1980
            },
            {
              "stopId": "judu:stop:6680",
              "position": {
                "x": 2273.814,
                "z": 2354.591
              },
              "distanceAlongShapeM": 11638.278,
              "shapeOffsetM": 5.439,
              "arrivalOffsetSeconds": 2100,
              "departureOffsetSeconds": 2100
            },
            {
              "stopId": "judu:stop:6679",
              "position": {
                "x": 1895.709,
                "z": 2390.588
              },
              "distanceAlongShapeM": 12029.685,
              "shapeOffsetM": 10.078,
              "arrivalOffsetSeconds": 2160,
              "departureOffsetSeconds": 2160
            },
            {
              "stopId": "judu:stop:6676",
              "position": {
                "x": 1523.961,
                "z": 1968.893
              },
              "distanceAlongShapeM": 12635.601,
              "shapeOffsetM": 5.448,
              "arrivalOffsetSeconds": 2280,
              "departureOffsetSeconds": 2280
            },
            {
              "stopId": "judu:stop:6674",
              "position": {
                "x": 1371.578,
                "z": 1648.875
              },
              "distanceAlongShapeM": 13006.592,
              "shapeOffsetM": 2.419,
              "arrivalOffsetSeconds": 2340,
              "departureOffsetSeconds": 2340
            },
            {
              "stopId": "judu:stop:6714",
              "position": {
                "x": 769.19,
                "z": 1624.355
              },
              "distanceAlongShapeM": 13770.174,
              "shapeOffsetM": 4.447,
              "arrivalOffsetSeconds": 2520,
              "departureOffsetSeconds": 2520
            },
            {
              "stopId": "judu:stop:8264",
              "position": {
                "x": 493.148,
                "z": 1911.064
              },
              "distanceAlongShapeM": 14299.551,
              "shapeOffsetM": 0.515,
              "arrivalOffsetSeconds": 2640,
              "departureOffsetSeconds": 2640
            }
          ],
          "departuresSeconds": [
            19140,
            20100,
            21240,
            22440,
            23640,
            25320,
            26580,
            27840,
            30840,
            32520,
            34200,
            36300,
            37620,
            39180,
            40920,
            42660,
            43980,
            45600,
            47340,
            49080,
            50340,
            51960,
            53520,
            54780,
            56040,
            57540,
            58920,
            60360,
            61800,
            63240,
            64680,
            66360,
            70320,
            71880,
            73680,
            75240,
            76680,
            78120,
            80100,
            81840,
            83160,
            84120
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_bus_32",
      "sourceRouteId": "vilnius_bus_32",
      "mode": "bus",
      "shortName": "32",
      "longName": "Žvėrynas–Zujūnai–Gineitiškės–Perkūnkiemis",
      "color": "0073AC",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_bus_32:0",
          "sourceRouteId": "vilnius_bus_32",
          "sourceShapeId": "vilnius_bus_32_a-b",
          "directionId": 0,
          "headsign": "Perkūnkiemis",
          "directionName": "Žvėrynas–Zujūnai–Gineitiškės–Perkūnkiemis",
          "mode": "bus",
          "routeShortName": "32",
          "routeLongName": "Žvėrynas–Zujūnai–Gineitiškės–Perkūnkiemis",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              -2130.743,
              -1067.44,
              0
            ],
            [
              -2108.809,
              -1065.561,
              22.014
            ],
            [
              -2072.667,
              -1084.451,
              62.795
            ],
            [
              -2070.025,
              -1103.286,
              81.814
            ],
            [
              -2072.195,
              -1109.627,
              88.516
            ],
            [
              -2142.708,
              -1122.847,
              160.258
            ],
            [
              -2159.624,
              -1131.453,
              179.237
            ],
            [
              -2184.705,
              -1155.271,
              213.825
            ],
            [
              -2202.716,
              -1161.859,
              233.003
            ],
            [
              -2224.67,
              -1163.697,
              255.034
            ],
            [
              -2246.137,
              -1174.448,
              279.043
            ],
            [
              -2255.963,
              -1183.18,
              292.188
            ],
            [
              -2262.447,
              -1185.292,
              299.007
            ],
            [
              -2339.674,
              -1177.245,
              376.653
            ],
            [
              -2392.506,
              -1175.197,
              429.524
            ],
            [
              -2433.855,
              -1180.032,
              471.155
            ],
            [
              -2474.658,
              -1190.444,
              513.266
            ],
            [
              -2521.496,
              -1214.107,
              565.742
            ],
            [
              -2594.45,
              -1256.235,
              649.986
            ],
            [
              -2624.997,
              -1270.168,
              683.56
            ],
            [
              -2680.78,
              -1289.223,
              742.508
            ],
            [
              -2710.565,
              -1296.491,
              773.167
            ],
            [
              -2777.752,
              -1304.214,
              840.796
            ],
            [
              -2815.153,
              -1304.669,
              878.2
            ],
            [
              -2855.028,
              -1301.32,
              918.216
            ],
            [
              -3099.309,
              -1258.49,
              1166.223
            ],
            [
              -3139.719,
              -1251.188,
              1207.287
            ],
            [
              -3159.719,
              -1247.413,
              1227.64
            ],
            [
              -3359.526,
              -1207.182,
              1431.457
            ],
            [
              -3495.953,
              -1192.555,
              1568.666
            ],
            [
              -3569.469,
              -1193.5,
              1642.188
            ],
            [
              -3626.266,
              -1196.964,
              1699.091
            ],
            [
              -3684.51,
              -1178.609,
              1760.158
            ],
            [
              -3714.349,
              -1169.288,
              1791.419
            ],
            [
              -3768.714,
              -1158.717,
              1846.802
            ],
            [
              -3858.305,
              -1156.194,
              1936.429
            ],
            [
              -4237.967,
              -1188.581,
              2317.47
            ],
            [
              -4268.356,
              -1193.623,
              2348.274
            ],
            [
              -4296.043,
              -1199.905,
              2376.666
            ],
            [
              -4637.998,
              -1318.612,
              2738.638
            ],
            [
              -4714.189,
              -1362.945,
              2826.789
            ],
            [
              -4755.992,
              -1394.51,
              2879.17
            ],
            [
              -4711.461,
              -1649.29,
              3137.813
            ],
            [
              -4687.836,
              -1855.434,
              3345.306
            ],
            [
              -4692.085,
              -1877.625,
              3367.9
            ],
            [
              -4695.288,
              -1876.457,
              3371.31
            ],
            [
              -4699.327,
              -1886.406,
              3382.047
            ],
            [
              -4837.811,
              -2105.557,
              3641.286
            ],
            [
              -4881.568,
              -2183.457,
              3730.635
            ],
            [
              -4945.898,
              -2281.818,
              3848.164
            ],
            [
              -4986.974,
              -2346.794,
              3925.035
            ],
            [
              -5093.592,
              -2550.912,
              4155.321
            ],
            [
              -5131.247,
              -2638.821,
              4250.955
            ],
            [
              -5144.644,
              -2668.554,
              4283.567
            ],
            [
              -5168.649,
              -2713.218,
              4334.273
            ],
            [
              -5208.585,
              -2776.607,
              4409.193
            ],
            [
              -5246.363,
              -2839.794,
              4482.812
            ],
            [
              -5314.063,
              -2932.324,
              4597.464
            ],
            [
              -5317.185,
              -2963.434,
              4628.731
            ],
            [
              -5302.543,
              -3060.302,
              4726.699
            ],
            [
              -5285.246,
              -3131.434,
              4799.904
            ],
            [
              -5243.028,
              -3263.037,
              4938.113
            ],
            [
              -5246.899,
              -3289.606,
              4964.962
            ],
            [
              -5263.493,
              -3315.972,
              4996.115
            ],
            [
              -5365.806,
              -3395.666,
              5125.804
            ],
            [
              -5411.327,
              -3458.318,
              5203.247
            ],
            [
              -5438.651,
              -3499.007,
              5252.26
            ],
            [
              -5479.991,
              -3555.111,
              5321.949
            ],
            [
              -5522.06,
              -3608.641,
              5390.031
            ],
            [
              -5880.739,
              -3866.748,
              5831.926
            ],
            [
              -6032.898,
              -3974.514,
              6018.382
            ],
            [
              -5982.973,
              -4047.605,
              6106.896
            ],
            [
              -5888.002,
              -4189.176,
              6277.371
            ],
            [
              -5885.221,
              -4197.231,
              6285.893
            ],
            [
              -5889.526,
              -4207.991,
              6297.482
            ],
            [
              -5900.587,
              -4218.301,
              6312.603
            ],
            [
              -5915.375,
              -4228.053,
              6330.317
            ],
            [
              -5993.646,
              -4281.77,
              6425.248
            ],
            [
              -6024.832,
              -4304.216,
              6463.672
            ],
            [
              -6145.801,
              -4387.352,
              6610.455
            ],
            [
              -6185.277,
              -4413.017,
              6657.54
            ],
            [
              -6227.195,
              -4446.218,
              6711.013
            ],
            [
              -6217.411,
              -4460.693,
              6728.484
            ],
            [
              -6174.391,
              -4515.863,
              6798.445
            ],
            [
              -6147.977,
              -4559.106,
              6849.117
            ],
            [
              -6136.229,
              -4584.016,
              6876.659
            ],
            [
              -5995.824,
              -4950.66,
              7269.266
            ],
            [
              -5997.296,
              -4947.917,
              7272.379
            ],
            [
              -5983.511,
              -4977.114,
              7304.667
            ],
            [
              -5963.946,
              -5025.616,
              7356.966
            ],
            [
              -5954.557,
              -5047.653,
              7380.92
            ],
            [
              -5917.492,
              -5099.709,
              7444.824
            ],
            [
              -5870.745,
              -5148.573,
              7512.448
            ],
            [
              -5845.606,
              -5167.502,
              7543.916
            ],
            [
              -5826.238,
              -5176.089,
              7565.103
            ],
            [
              -5803.951,
              -5182.624,
              7588.328
            ],
            [
              -5783.481,
              -5188.592,
              7609.65
            ],
            [
              -5768.708,
              -5191.069,
              7624.629
            ],
            [
              -5752.59,
              -5190.229,
              7640.769
            ],
            [
              -5745.811,
              -5188.92,
              7647.674
            ],
            [
              -5723.973,
              -5174.017,
              7674.112
            ],
            [
              -5700.812,
              -5158.945,
              7701.745
            ],
            [
              -5687.598,
              -5154.457,
              7715.7
            ],
            [
              -5645.843,
              -5145.22,
              7758.465
            ],
            [
              -5600.434,
              -5145.302,
              7803.874
            ],
            [
              -5575.256,
              -5150.983,
              7829.685
            ],
            [
              -5494.645,
              -5173.461,
              7913.371
            ],
            [
              -5460.904,
              -5178.949,
              7947.555
            ],
            [
              -5416.975,
              -5190.276,
              7992.921
            ],
            [
              -5372.043,
              -5191.233,
              8037.863
            ],
            [
              -5069.27,
              -5197.42,
              8340.7
            ],
            [
              -4792.724,
              -5185.463,
              8617.504
            ],
            [
              -4742.399,
              -5180.761,
              8668.048
            ],
            [
              -4156.396,
              -5191.488,
              9254.15
            ],
            [
              -4048.816,
              -5189.269,
              9361.752
            ],
            [
              -4047.433,
              -5048.201,
              9502.828
            ],
            [
              -3823.908,
              -5049.815,
              9726.359
            ],
            [
              -3827.684,
              -5087.455,
              9764.188
            ],
            [
              -3836.059,
              -5117.022,
              9794.918
            ],
            [
              -3846.109,
              -5119.902,
              9805.373
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:4898",
              "position": {
                "x": -2071.721,
                "z": -1082.918
              },
              "distanceAlongShapeM": 62.795,
              "shapeOffsetM": 1.801,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:7415",
              "position": {
                "x": -3140.52,
                "z": -1255.542
              },
              "distanceAlongShapeM": 1207.287,
              "shapeOffsetM": 4.427,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:4991",
              "position": {
                "x": -3688.025,
                "z": -1189.21
              },
              "distanceAlongShapeM": 1760.353,
              "shapeOffsetM": 11.167,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:4988",
              "position": {
                "x": -4294.993,
                "z": -1205.408
              },
              "distanceAlongShapeM": 2377.478,
              "shapeOffsetM": 5.543,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:16971",
              "position": {
                "x": -4704.903,
                "z": -1648.085
              },
              "distanceAlongShapeM": 3137.755,
              "shapeOffsetM": 6.667,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:10280",
              "position": {
                "x": -4877.224,
                "z": -2186.146
              },
              "distanceAlongShapeM": 3730.635,
              "shapeOffsetM": 5.108,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:6746",
              "position": {
                "x": -5030.968,
                "z": -2431.757
              },
              "distanceAlongShapeM": 4020.712,
              "shapeOffsetM": 0.341,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:6749",
              "position": {
                "x": -5280.712,
                "z": -3129.923
              },
              "distanceAlongShapeM": 4799.507,
              "shapeOffsetM": 4.763,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:19064",
              "position": {
                "x": -5435.257,
                "z": -3501.326
              },
              "distanceAlongShapeM": 5252.26,
              "shapeOffsetM": 4.111,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:8002",
              "position": {
                "x": -5519.608,
                "z": -3611.211
              },
              "distanceAlongShapeM": 5390.031,
              "shapeOffsetM": 3.552,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:6751",
              "position": {
                "x": -5878.394,
                "z": -3870.065
              },
              "distanceAlongShapeM": 5831.929,
              "shapeOffsetM": 4.062,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:18926",
              "position": {
                "x": -5981.248,
                "z": -4046.438
              },
              "distanceAlongShapeM": 6106.896,
              "shapeOffsetM": 2.083,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:18928",
              "position": {
                "x": -6182.724,
                "z": -4417.071
              },
              "distanceAlongShapeM": 6658.056,
              "shapeOffsetM": 4.763,
              "arrivalOffsetSeconds": 1380,
              "departureOffsetSeconds": 1380
            },
            {
              "stopId": "judu:stop:16896",
              "position": {
                "x": -6128.788,
                "z": -4580.508
              },
              "distanceAlongShapeM": 6876.659,
              "shapeOffsetM": 8.226,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            },
            {
              "stopId": "judu:stop:7392",
              "position": {
                "x": -5986.791,
                "z": -4945.811
              },
              "distanceAlongShapeM": 7267.969,
              "shapeOffsetM": 10.169,
              "arrivalOffsetSeconds": 1500,
              "departureOffsetSeconds": 1500
            },
            {
              "stopId": "judu:stop:7845",
              "position": {
                "x": -5524.097,
                "z": -5162.941
              },
              "distanceAlongShapeM": 7882.176,
              "shapeOffsetM": 2.223,
              "arrivalOffsetSeconds": 1590,
              "departureOffsetSeconds": 1590
            },
            {
              "stopId": "judu:stop:7395",
              "position": {
                "x": -4966.766,
                "z": -5192.496
              },
              "distanceAlongShapeM": 8443.321,
              "shapeOffsetM": 0.492,
              "arrivalOffsetSeconds": 1680,
              "departureOffsetSeconds": 1680
            },
            {
              "stopId": "judu:stop:9768",
              "position": {
                "x": -4156.392,
                "z": -5190.871
              },
              "distanceAlongShapeM": 9254.166,
              "shapeOffsetM": 0.616,
              "arrivalOffsetSeconds": 1800,
              "departureOffsetSeconds": 1800
            },
            {
              "stopId": "judu:stop:6931",
              "position": {
                "x": -3827.361,
                "z": -5087.486
              },
              "distanceAlongShapeM": 9764.187,
              "shapeOffsetM": 0.325,
              "arrivalOffsetSeconds": 1920,
              "departureOffsetSeconds": 1920
            }
          ],
          "departuresSeconds": [
            17880,
            19680,
            21120,
            22860,
            24720,
            26400,
            28500,
            30660,
            34080,
            36480,
            39060,
            41760,
            44220,
            46920,
            49560,
            52140,
            54840,
            57420,
            59100,
            60660,
            62820,
            64680,
            68220,
            70740,
            73320,
            75660,
            78300,
            81000
          ]
        },
        {
          "id": "judu:pattern:vilnius_bus_32:1",
          "sourceRouteId": "vilnius_bus_32",
          "sourceShapeId": "vilnius_bus_32_b-a",
          "directionId": 1,
          "headsign": "Žvėrynas",
          "directionName": "Perkūnkiemis–Gineitiškės–Zujūnai–Žvėrynas",
          "mode": "bus",
          "routeShortName": "32",
          "routeLongName": "Žvėrynas–Zujūnai–Gineitiškės–Perkūnkiemis",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              -3846.109,
              -5119.902,
              0
            ],
            [
              -3862.028,
              -5154.789,
              38.347
            ],
            [
              -3896.745,
              -5150.846,
              73.287
            ],
            [
              -3904.981,
              -5142.911,
              84.724
            ],
            [
              -3906.076,
              -5131.759,
              95.93
            ],
            [
              -3903.757,
              -5109.535,
              118.274
            ],
            [
              -3869.632,
              -5096.489,
              154.808
            ],
            [
              -3868.639,
              -5091.898,
              159.505
            ],
            [
              -3866.173,
              -5086.493,
              165.446
            ],
            [
              -3853.286,
              -5069.798,
              186.536
            ],
            [
              -3844.701,
              -5055.784,
              202.97
            ],
            [
              -4047.433,
              -5048.201,
              405.844
            ],
            [
              -4054.129,
              -5200.392,
              558.183
            ],
            [
              -4187.4,
              -5194.152,
              691.6
            ],
            [
              -4508.755,
              -5191.462,
              1012.967
            ],
            [
              -4560.955,
              -5192.789,
              1065.183
            ],
            [
              -4730.24,
              -5185.423,
              1234.629
            ],
            [
              -4792.724,
              -5185.463,
              1297.113
            ],
            [
              -4993.283,
              -5198.721,
              1498.109
            ],
            [
              -5032.681,
              -5200.077,
              1537.531
            ],
            [
              -5174.88,
              -5195.613,
              1679.8
            ],
            [
              -5316.341,
              -5190.444,
              1821.355
            ],
            [
              -5353.201,
              -5189.23,
              1858.235
            ],
            [
              -5402.148,
              -5191.901,
              1907.255
            ],
            [
              -5554.307,
              -5159.088,
              2062.912
            ],
            [
              -5574.822,
              -5151.098,
              2084.928
            ],
            [
              -5608.207,
              -5144.286,
              2119
            ],
            [
              -5629.424,
              -5144.453,
              2140.218
            ],
            [
              -5686.926,
              -5154.608,
              2198.61
            ],
            [
              -5717.438,
              -5168.562,
              2232.161
            ],
            [
              -5731.889,
              -5185.015,
              2254.06
            ],
            [
              -5748.774,
              -5192.431,
              2272.501
            ],
            [
              -5810.631,
              -5183.905,
              2334.943
            ],
            [
              -5822.365,
              -5180.407,
              2347.188
            ],
            [
              -5857.729,
              -5160.617,
              2387.712
            ],
            [
              -5872.995,
              -5149.226,
              2406.76
            ],
            [
              -5920.769,
              -5100.255,
              2475.174
            ],
            [
              -5937.764,
              -5078.947,
              2502.429
            ],
            [
              -5972.136,
              -5012.508,
              2577.233
            ],
            [
              -5994.12,
              -4960.159,
              2634.011
            ],
            [
              -6022.55,
              -4902.824,
              2698.008
            ],
            [
              -6031.88,
              -4869.351,
              2732.756
            ],
            [
              -6038.764,
              -4848.198,
              2755.001
            ],
            [
              -6043.761,
              -4831.698,
              2772.241
            ],
            [
              -6051.008,
              -4805.423,
              2799.498
            ],
            [
              -6076.085,
              -4723.209,
              2885.451
            ],
            [
              -6109.893,
              -4644.28,
              2971.316
            ],
            [
              -6156.873,
              -4547.675,
              3078.739
            ],
            [
              -6191.78,
              -4498.381,
              3139.14
            ],
            [
              -6205.413,
              -4481.13,
              3161.127
            ],
            [
              -6223.89,
              -4456.353,
              3192.035
            ],
            [
              -6295.909,
              -4339.217,
              3329.541
            ],
            [
              -6279.379,
              -4328.279,
              3349.362
            ],
            [
              -6244.202,
              -4311.188,
              3388.471
            ],
            [
              -6196.102,
              -4278.968,
              3446.365
            ],
            [
              -6153.73,
              -4250.041,
              3497.67
            ],
            [
              -6082.838,
              -4201.788,
              3583.425
            ],
            [
              -6049.388,
              -4177.947,
              3624.502
            ],
            [
              -6017.911,
              -4157.138,
              3662.236
            ],
            [
              -5976.949,
              -4129.451,
              3711.677
            ],
            [
              -5944.686,
              -4106.138,
              3751.481
            ],
            [
              -6024.537,
              -3987.664,
              3894.352
            ],
            [
              -6032.346,
              -3979.125,
              3905.923
            ],
            [
              -6031.206,
              -3969.817,
              3915.301
            ],
            [
              -5940.122,
              -3905.168,
              4026.996
            ],
            [
              -5844.093,
              -3837.347,
              4144.56
            ],
            [
              -5533.315,
              -3615.261,
              4526.535
            ],
            [
              -5518.773,
              -3601.291,
              4546.701
            ],
            [
              -5428.665,
              -3479.646,
              4698.084
            ],
            [
              -5413.278,
              -3459.398,
              4723.515
            ],
            [
              -5368.429,
              -3398.936,
              4798.795
            ],
            [
              -5346.93,
              -3377.624,
              4829.067
            ],
            [
              -5280.908,
              -3330.296,
              4910.301
            ],
            [
              -5264.536,
              -3314.991,
              4932.713
            ],
            [
              -5250.769,
              -3297.379,
              4955.067
            ],
            [
              -5242.119,
              -3258.646,
              4994.754
            ],
            [
              -5245.546,
              -3245.269,
              5008.563
            ],
            [
              -5284.185,
              -3142.537,
              5118.321
            ],
            [
              -5299.887,
              -3082.841,
              5180.048
            ],
            [
              -5303.167,
              -3074.142,
              5189.344
            ],
            [
              -5304.567,
              -3054.931,
              5208.606
            ],
            [
              -5317.716,
              -2956.745,
              5307.669
            ],
            [
              -5314.063,
              -2932.324,
              5332.362
            ],
            [
              -5224.213,
              -2802.492,
              5490.252
            ],
            [
              -5191.067,
              -2748.511,
              5553.597
            ],
            [
              -5129.111,
              -2630.456,
              5686.922
            ],
            [
              -5084.758,
              -2524.028,
              5802.222
            ],
            [
              -5017.627,
              -2389.875,
              5952.234
            ],
            [
              -4857.792,
              -2143.064,
              6246.28
            ],
            [
              -4831.99,
              -2094.153,
              6301.58
            ],
            [
              -4689.278,
              -1864.315,
              6572.12
            ],
            [
              -4687.173,
              -1854.332,
              6582.322
            ],
            [
              -4702.514,
              -1759.266,
              6678.619
            ],
            [
              -4755.992,
              -1394.51,
              7047.274
            ],
            [
              -4763.449,
              -1360.375,
              7082.214
            ],
            [
              -4704.75,
              -1314.599,
              7156.652
            ],
            [
              -4653.804,
              -1300.53,
              7209.505
            ],
            [
              -4405.208,
              -1203.507,
              7476.363
            ],
            [
              -4296.995,
              -1171.977,
              7589.076
            ],
            [
              -4246.587,
              -1162.091,
              7640.445
            ],
            [
              -4190.857,
              -1159.392,
              7696.24
            ],
            [
              -3912.052,
              -1135.777,
              7976.043
            ],
            [
              -3758.891,
              -1120.334,
              8129.981
            ],
            [
              -3704.617,
              -1115.802,
              8184.443
            ],
            [
              -3657.704,
              -1114.039,
              8231.389
            ],
            [
              -3599.031,
              -1113.947,
              8290.063
            ],
            [
              -3412.497,
              -1176.2,
              8486.71
            ],
            [
              -3355.367,
              -1190.556,
              8545.617
            ],
            [
              -3109.19,
              -1234.288,
              8795.648
            ],
            [
              -3070.013,
              -1242.306,
              8835.637
            ],
            [
              -2879.155,
              -1277.94,
              9029.793
            ],
            [
              -2839.273,
              -1283.094,
              9070.006
            ],
            [
              -2787.087,
              -1285.125,
              9122.232
            ],
            [
              -2748.376,
              -1283.58,
              9160.974
            ],
            [
              -2714.118,
              -1278.617,
              9195.589
            ],
            [
              -2670.7,
              -1266.023,
              9240.797
            ],
            [
              -2624.585,
              -1246.798,
              9290.759
            ],
            [
              -2499.949,
              -1183.085,
              9430.735
            ],
            [
              -2469.831,
              -1172.717,
              9462.588
            ],
            [
              -2418.716,
              -1162.489,
              9514.717
            ],
            [
              -2392.231,
              -1159.617,
              9541.357
            ],
            [
              -2246.137,
              -1174.448,
              9688.202
            ],
            [
              -2229.866,
              -1165.831,
              9706.614
            ],
            [
              -2190.996,
              -1155.388,
              9746.862
            ],
            [
              -2164.136,
              -1131.373,
              9782.892
            ],
            [
              -2142.708,
              -1122.847,
              9805.954
            ],
            [
              -2138.761,
              -1118.464,
              9811.852
            ],
            [
              -2144.773,
              -1093.867,
              9837.173
            ],
            [
              -2147.916,
              -1089.358,
              9842.67
            ],
            [
              -2139.925,
              -1075.028,
              9859.077
            ],
            [
              -2130.743,
              -1067.44,
              9870.989
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:7603",
              "position": {
                "x": -3854.099,
                "z": -5069.209
              },
              "distanceAlongShapeM": 186.614,
              "shapeOffsetM": 1,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:9766",
              "position": {
                "x": -4187.417,
                "z": -5197.013
              },
              "distanceAlongShapeM": 691.483,
              "shapeOffsetM": 2.859,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:17333",
              "position": {
                "x": -4394.793,
                "z": -5194.542
              },
              "distanceAlongShapeM": 898.983,
              "shapeOffsetM": 2.126,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:4479",
              "position": {
                "x": -5032.717,
                "z": -5206.951
              },
              "distanceAlongShapeM": 1537.531,
              "shapeOffsetM": 6.874,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:7844",
              "position": {
                "x": -5811.134,
                "z": -5185.897
              },
              "distanceAlongShapeM": 2334.943,
              "shapeOffsetM": 2.055,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:7393",
              "position": {
                "x": -6063.065,
                "z": -4808.711
              },
              "distanceAlongShapeM": 2799.87,
              "shapeOffsetM": 12.492,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:16898",
              "position": {
                "x": -6197.05,
                "z": -4502.546
              },
              "distanceAlongShapeM": 3138.787,
              "shapeOffsetM": 6.708,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:18927",
              "position": {
                "x": -6197.75,
                "z": -4276.554
              },
              "distanceAlongShapeM": 3446.339,
              "shapeOffsetM": 2.923,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:19106",
              "position": {
                "x": -5844.959,
                "z": -3836.122
              },
              "distanceAlongShapeM": 4144.568,
              "shapeOffsetM": 1.5,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:8001",
              "position": {
                "x": -5430.994,
                "z": -3478.021
              },
              "distanceAlongShapeM": 4698.004,
              "shapeOffsetM": 2.839,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:6748",
              "position": {
                "x": -5313.303,
                "z": -3075.933
              },
              "distanceAlongShapeM": 5189.344,
              "shapeOffsetM": 10.293,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:6743",
              "position": {
                "x": -5019.916,
                "z": -2388.532
              },
              "distanceAlongShapeM": 5952.234,
              "shapeOffsetM": 2.654,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            },
            {
              "stopId": "judu:stop:10281",
              "position": {
                "x": -4836.919,
                "z": -2091.101
              },
              "distanceAlongShapeM": 6301.58,
              "shapeOffsetM": 5.797,
              "arrivalOffsetSeconds": 1380,
              "departureOffsetSeconds": 1380
            },
            {
              "stopId": "judu:stop:16973",
              "position": {
                "x": -4708.767,
                "z": -1760.452
              },
              "distanceAlongShapeM": 6678.444,
              "shapeOffsetM": 6.363,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            },
            {
              "stopId": "judu:stop:8934",
              "position": {
                "x": -4704.97,
                "z": -1314.122
              },
              "distanceAlongShapeM": 7156.652,
              "shapeOffsetM": 0.525,
              "arrivalOffsetSeconds": 1560,
              "departureOffsetSeconds": 1560
            },
            {
              "stopId": "judu:stop:4989",
              "position": {
                "x": -4247.02,
                "z": -1152.802
              },
              "distanceAlongShapeM": 7640.461,
              "shapeOffsetM": 9.299,
              "arrivalOffsetSeconds": 1650,
              "departureOffsetSeconds": 1650
            },
            {
              "stopId": "judu:stop:7342",
              "position": {
                "x": -3705.284,
                "z": -1106.532
              },
              "distanceAlongShapeM": 8184.443,
              "shapeOffsetM": 9.294,
              "arrivalOffsetSeconds": 1710,
              "departureOffsetSeconds": 1710
            },
            {
              "stopId": "judu:stop:7416",
              "position": {
                "x": -3108.49,
                "z": -1230.499
              },
              "distanceAlongShapeM": 8795.648,
              "shapeOffsetM": 3.854,
              "arrivalOffsetSeconds": 1830,
              "departureOffsetSeconds": 1830
            },
            {
              "stopId": "judu:stop:18480",
              "position": {
                "x": -2130.763,
                "z": -1067.398
              },
              "distanceAlongShapeM": 9870.989,
              "shapeOffsetM": 0.046,
              "arrivalOffsetSeconds": 1980,
              "departureOffsetSeconds": 1980
            }
          ],
          "departuresSeconds": [
            18660,
            20280,
            22080,
            23640,
            25440,
            27540,
            29280,
            31260,
            36540,
            39180,
            41640,
            44400,
            46860,
            49500,
            52200,
            54780,
            56460,
            58020,
            60180,
            61860,
            63480,
            65580,
            67380,
            70800,
            73200,
            75720,
            78180,
            80760
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_bus_33",
      "sourceRouteId": "vilnius_bus_33",
      "mode": "bus",
      "shortName": "33",
      "longName": "Šiaurės miestelis–Rinktinės–Olandų g.–Sukilėlių g.–Guriai",
      "color": "0073AC",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_bus_33:0",
          "sourceRouteId": "vilnius_bus_33",
          "sourceShapeId": "vilnius_bus_33_a-b3",
          "directionId": 0,
          "headsign": "Guriai",
          "directionName": "Šiaurės miestelis–Rinktinės–Olandų g.–Sukilėlių g.–Kalnėnai–Guriai",
          "mode": "bus",
          "routeShortName": "33",
          "routeLongName": "Šiaurės miestelis–Rinktinės–Olandų g.–Sukilėlių g.–Guriai",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              1407.302,
              -2542.364,
              0
            ],
            [
              1404.085,
              -2529.725,
              13.042
            ],
            [
              1492.99,
              -2519.128,
              102.577
            ],
            [
              1552.992,
              -2512.565,
              162.937
            ],
            [
              1553.131,
              -2520.895,
              171.269
            ],
            [
              1553.227,
              -2526.592,
              176.967
            ],
            [
              1553.355,
              -2534.309,
              184.685
            ],
            [
              1553.387,
              -2536.238,
              186.614
            ],
            [
              1447.352,
              -2569.169,
              297.645
            ],
            [
              1407.447,
              -2542.743,
              345.508
            ],
            [
              1407.868,
              -2547.344,
              350.128
            ],
            [
              1407.735,
              -2553.76,
              356.545
            ],
            [
              1415.904,
              -2574.474,
              378.812
            ],
            [
              1275.293,
              -2579.663,
              519.519
            ],
            [
              1255.056,
              -2585.375,
              540.546
            ],
            [
              1229.698,
              -2591.451,
              566.623
            ],
            [
              1196.042,
              -2600.83,
              601.561
            ],
            [
              955.306,
              -2665.04,
              850.713
            ],
            [
              918.306,
              -2677.632,
              889.797
            ],
            [
              895.761,
              -2678.415,
              912.355
            ],
            [
              887.466,
              -2673.809,
              921.843
            ],
            [
              879.035,
              -2624.079,
              972.283
            ],
            [
              876.281,
              -2581.204,
              1015.246
            ],
            [
              801.593,
              -2329.376,
              1277.917
            ],
            [
              796.736,
              -2311.279,
              1296.654
            ],
            [
              783.008,
              -2255.534,
              1354.064
            ],
            [
              777.261,
              -2147.444,
              1462.307
            ],
            [
              711.928,
              -1879.065,
              1738.524
            ],
            [
              663.224,
              -1757.941,
              1869.073
            ],
            [
              616.278,
              -1681.379,
              1958.882
            ],
            [
              590.381,
              -1648.202,
              2000.969
            ],
            [
              569.208,
              -1611.494,
              2043.346
            ],
            [
              540.436,
              -1540.792,
              2119.678
            ],
            [
              521.99,
              -1479.266,
              2183.91
            ],
            [
              510.367,
              -1407.327,
              2256.782
            ],
            [
              508.692,
              -1376.399,
              2287.755
            ],
            [
              512.262,
              -1306.536,
              2357.709
            ],
            [
              526.396,
              -1238.888,
              2426.818
            ],
            [
              548.613,
              -1152.462,
              2516.054
            ],
            [
              606.765,
              -899.711,
              2775.409
            ],
            [
              630.682,
              -791.052,
              2886.669
            ],
            [
              637.879,
              -753.82,
              2924.59
            ],
            [
              647.48,
              -719,
              2960.709
            ],
            [
              718.871,
              -413.057,
              3274.871
            ],
            [
              707.994,
              -380.358,
              3309.332
            ],
            [
              685.601,
              -293.329,
              3399.196
            ],
            [
              645.363,
              9.096,
              3704.286
            ],
            [
              675.04,
              9.665,
              3733.968
            ],
            [
              707.88,
              6.836,
              3766.93
            ],
            [
              925.597,
              -42.81,
              3990.236
            ],
            [
              1129.224,
              -156.774,
              4223.585
            ],
            [
              1141.634,
              -163.763,
              4237.828
            ],
            [
              1606.423,
              -519.681,
              4823.238
            ],
            [
              1614.903,
              -526.354,
              4834.029
            ],
            [
              1648.803,
              -550.462,
              4875.627
            ],
            [
              1657.142,
              -552.844,
              4884.3
            ],
            [
              1673.279,
              -552.03,
              4900.458
            ],
            [
              1707.61,
              -543.762,
              4935.77
            ],
            [
              1715.531,
              -533.89,
              4948.427
            ],
            [
              1739.19,
              -475.328,
              5011.588
            ],
            [
              1739.832,
              -440.829,
              5046.093
            ],
            [
              1737.688,
              -417.411,
              5069.609
            ],
            [
              1728.721,
              -379.394,
              5108.669
            ],
            [
              1717.488,
              -353.728,
              5136.686
            ],
            [
              1709.957,
              -313.364,
              5177.746
            ],
            [
              1701.073,
              -270.896,
              5221.133
            ],
            [
              1691.292,
              -207.259,
              5285.517
            ],
            [
              1692.553,
              -139.375,
              5353.413
            ],
            [
              1699.889,
              -91.641,
              5401.707
            ],
            [
              1722.281,
              -31.942,
              5465.468
            ],
            [
              1763.619,
              40.763,
              5549.103
            ],
            [
              1784.543,
              87.474,
              5600.286
            ],
            [
              1803.689,
              114.605,
              5633.493
            ],
            [
              1864.141,
              209.22,
              5745.771
            ],
            [
              1913.636,
              269.526,
              5823.787
            ],
            [
              1990.962,
              334.88,
              5925.032
            ],
            [
              2018.633,
              366.989,
              5967.419
            ],
            [
              2052.586,
              388.28,
              6007.496
            ],
            [
              2087.216,
              412.125,
              6049.541
            ],
            [
              2136.967,
              451.273,
              6112.848
            ],
            [
              2182.309,
              496.069,
              6176.586
            ],
            [
              2210.658,
              528.937,
              6219.991
            ],
            [
              2229.877,
              556.409,
              6253.518
            ],
            [
              2248.742,
              590.591,
              6292.56
            ],
            [
              2266.569,
              621.404,
              6328.159
            ],
            [
              2281.67,
              670.105,
              6379.147
            ],
            [
              2285.519,
              703.43,
              6412.694
            ],
            [
              2286.06,
              732.364,
              6441.633
            ],
            [
              2274.704,
              814.957,
              6525.003
            ],
            [
              2261.392,
              861.962,
              6573.857
            ],
            [
              2144.257,
              1048.95,
              6794.504
            ],
            [
              2120.129,
              1077.499,
              6831.883
            ],
            [
              2107.735,
              1096.818,
              6854.836
            ],
            [
              2088.256,
              1124.583,
              6888.752
            ],
            [
              2063.317,
              1145.824,
              6921.511
            ],
            [
              2049.437,
              1153.138,
              6937.2
            ],
            [
              2015.127,
              1163.632,
              6973.079
            ],
            [
              1965.977,
              1174.732,
              7023.467
            ],
            [
              1928.988,
              1197.686,
              7066.999
            ],
            [
              1911.304,
              1218.054,
              7093.973
            ],
            [
              1891.954,
              1251.099,
              7132.267
            ],
            [
              1817.435,
              1512.583,
              7404.162
            ],
            [
              1773.71,
              1659.231,
              7557.19
            ],
            [
              1762.656,
              1724.004,
              7622.899
            ],
            [
              1756.881,
              1829.869,
              7728.921
            ],
            [
              1752.253,
              1863.138,
              7762.511
            ],
            [
              1759.639,
              1908.858,
              7808.824
            ],
            [
              1808.843,
              2126.139,
              8031.606
            ],
            [
              1796.441,
              2326.753,
              8232.603
            ],
            [
              1803.322,
              2384.513,
              8290.772
            ],
            [
              1851.97,
              2398.081,
              8341.276
            ],
            [
              1902.003,
              2404.315,
              8391.696
            ],
            [
              1960.233,
              2419.132,
              8451.782
            ],
            [
              1982.789,
              2423.477,
              8474.752
            ],
            [
              2016.977,
              2422.84,
              8508.946
            ],
            [
              2299.993,
              2357.105,
              8799.496
            ],
            [
              2317.36,
              2352.884,
              8817.368
            ],
            [
              2341.251,
              2347.002,
              8841.973
            ],
            [
              2404.362,
              2330.998,
              8907.082
            ],
            [
              2453.344,
              2327.854,
              8956.164
            ],
            [
              2522.158,
              2343.947,
              9026.835
            ],
            [
              2590.757,
              2354.799,
              9096.287
            ],
            [
              2633.759,
              2349.934,
              9139.563
            ],
            [
              2718.966,
              2326.47,
              9227.942
            ],
            [
              2777.655,
              2313.974,
              9287.947
            ],
            [
              2795.071,
              2313.647,
              9305.366
            ],
            [
              2818.355,
              2316.549,
              9328.83
            ],
            [
              2887.128,
              2336.406,
              9400.412
            ],
            [
              3040.725,
              2386.685,
              9562.029
            ],
            [
              3104.507,
              2394.461,
              9626.284
            ],
            [
              3102.149,
              2394.343,
              9628.645
            ],
            [
              3156.075,
              2396.681,
              9682.622
            ],
            [
              3223.295,
              2403.539,
              9750.19
            ],
            [
              3301.575,
              2421.35,
              9830.471
            ],
            [
              3441.784,
              2491.803,
              9987.385
            ],
            [
              3608.801,
              2587.715,
              10179.983
            ],
            [
              3711.158,
              2642.546,
              10296.101
            ],
            [
              3892.019,
              2719.259,
              10492.559
            ],
            [
              3986.281,
              2755.313,
              10593.48
            ],
            [
              3941.416,
              2898.718,
              10743.739
            ],
            [
              3906.137,
              3012.399,
              10862.769
            ],
            [
              3867.714,
              3162.115,
              11017.337
            ],
            [
              3855.951,
              3197.532,
              11054.656
            ],
            [
              3829.271,
              3243.275,
              11107.611
            ],
            [
              3776.691,
              3305.912,
              11189.392
            ],
            [
              3765.936,
              3329.391,
              11215.216
            ],
            [
              3736.4,
              3412.28,
              11303.211
            ],
            [
              3719.936,
              3443.921,
              11338.879
            ],
            [
              3679.16,
              3505.925,
              11413.089
            ],
            [
              3910.102,
              3736.428,
              11739.381
            ],
            [
              4069.085,
              3812.359,
              11915.565
            ],
            [
              4118.856,
              3834.577,
              11970.071
            ],
            [
              4455.787,
              3985.391,
              12339.214
            ],
            [
              4659.72,
              4077.746,
              12563.085
            ],
            [
              4783.97,
              3831.027,
              12839.325
            ],
            [
              4807.805,
              3794.944,
              12882.57
            ],
            [
              4844.485,
              3764.136,
              12930.471
            ],
            [
              4901.353,
              3711.915,
              13007.679
            ],
            [
              4947.841,
              3656.072,
              13080.339
            ],
            [
              4956.508,
              3633.975,
              13104.075
            ],
            [
              4967.105,
              3620.434,
              13121.27
            ],
            [
              4992.855,
              3483.006,
              13261.09
            ],
            [
              5094.075,
              3042.428,
              13713.146
            ],
            [
              5223.245,
              3060.314,
              13843.548
            ],
            [
              5302.402,
              3070.887,
              13923.408
            ],
            [
              5327.851,
              3076.289,
              13949.424
            ],
            [
              5372.372,
              3082.689,
              13994.403
            ],
            [
              5415.814,
              3092.98,
              14039.047
            ],
            [
              5455.384,
              3103.345,
              14079.952
            ],
            [
              5554.806,
              3138.154,
              14185.291
            ],
            [
              5575.02,
              3147.728,
              14207.658
            ],
            [
              5595.077,
              3151.873,
              14228.139
            ],
            [
              5609.76,
              3165.048,
              14247.867
            ],
            [
              5614.141,
              3171.542,
              14255.7
            ],
            [
              5620.144,
              3179.19,
              14265.423
            ],
            [
              5626.089,
              3180.788,
              14271.579
            ],
            [
              5632.191,
              3178.71,
              14278.025
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:7589",
              "position": {
                "x": 1524.687,
                "z": -2513.037
              },
              "distanceAlongShapeM": 134.748,
              "shapeOffsetM": 2.608,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:9565",
              "position": {
                "x": 1231.149,
                "z": -2596.659
              },
              "distanceAlongShapeM": 566.425,
              "shapeOffsetM": 5.403,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:9637",
              "position": {
                "x": 874.193,
                "z": -2624.582
              },
              "distanceAlongShapeM": 972.283,
              "shapeOffsetM": 4.868,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:9640",
              "position": {
                "x": 793.859,
                "z": -2331.434
              },
              "distanceAlongShapeM": 1277.934,
              "shapeOffsetM": 8.003,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:18780",
              "position": {
                "x": 587.849,
                "z": -1649.686
              },
              "distanceAlongShapeM": 2000.969,
              "shapeOffsetM": 2.935,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:7326",
              "position": {
                "x": 503.887,
                "z": -1376.517
              },
              "distanceAlongShapeM": 2287.755,
              "shapeOffsetM": 4.806,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:7337",
              "position": {
                "x": 635.244,
                "z": -753.286
              },
              "distanceAlongShapeM": 2924.59,
              "shapeOffsetM": 2.689,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:7323",
              "position": {
                "x": 707.215,
                "z": -380.559
              },
              "distanceAlongShapeM": 3309.332,
              "shapeOffsetM": 0.804,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:7278",
              "position": {
                "x": 707.88,
                "z": 6.836
              },
              "distanceAlongShapeM": 3766.93,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:6573",
              "position": {
                "x": 1143.99,
                "z": -160.386
              },
              "distanceAlongShapeM": 4237.828,
              "shapeOffsetM": 4.117,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:5770",
              "position": {
                "x": 1610.786,
                "z": -514.132
              },
              "distanceAlongShapeM": 4823.238,
              "shapeOffsetM": 7.059,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:6565",
              "position": {
                "x": 1714.349,
                "z": -354.636
              },
              "distanceAlongShapeM": 5136.686,
              "shapeOffsetM": 3.268,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:6568",
              "position": {
                "x": 1781.292,
                "z": 89.417
              },
              "distanceAlongShapeM": 5600.286,
              "shapeOffsetM": 3.788,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:6571",
              "position": {
                "x": 2015.503,
                "z": 371.16
              },
              "distanceAlongShapeM": 5967.419,
              "shapeOffsetM": 5.214,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            },
            {
              "stopId": "judu:stop:6574",
              "position": {
                "x": 2244.749,
                "z": 592.868
              },
              "distanceAlongShapeM": 6292.56,
              "shapeOffsetM": 4.597,
              "arrivalOffsetSeconds": 1380,
              "departureOffsetSeconds": 1380
            },
            {
              "stopId": "judu:stop:5925",
              "position": {
                "x": 2116.361,
                "z": 1075.075
              },
              "distanceAlongShapeM": 6831.883,
              "shapeOffsetM": 4.48,
              "arrivalOffsetSeconds": 1500,
              "departureOffsetSeconds": 1500
            },
            {
              "stopId": "judu:stop:7689",
              "position": {
                "x": 1746.536,
                "z": 1863.459
              },
              "distanceAlongShapeM": 7762.511,
              "shapeOffsetM": 5.726,
              "arrivalOffsetSeconds": 1620,
              "departureOffsetSeconds": 1620
            },
            {
              "stopId": "judu:stop:6678",
              "position": {
                "x": 1914.123,
                "z": 2409.17
              },
              "distanceAlongShapeM": 8404.639,
              "shapeOffsetM": 1.716,
              "arrivalOffsetSeconds": 1800,
              "departureOffsetSeconds": 1800
            },
            {
              "stopId": "judu:stop:6681",
              "position": {
                "x": 2318.384,
                "z": 2357.098
              },
              "distanceAlongShapeM": 8817.368,
              "shapeOffsetM": 4.337,
              "arrivalOffsetSeconds": 1860,
              "departureOffsetSeconds": 1860
            },
            {
              "stopId": "judu:stop:6683",
              "position": {
                "x": 3101.877,
                "z": 2398.039
              },
              "distanceAlongShapeM": 9628.645,
              "shapeOffsetM": 3.706,
              "arrivalOffsetSeconds": 1920,
              "departureOffsetSeconds": 1920
            },
            {
              "stopId": "judu:stop:9661",
              "position": {
                "x": 3900.799,
                "z": 3010.764
              },
              "distanceAlongShapeM": 10862.769,
              "shapeOffsetM": 5.583,
              "arrivalOffsetSeconds": 2100,
              "departureOffsetSeconds": 2100
            },
            {
              "stopId": "judu:stop:9600",
              "position": {
                "x": 4116.685,
                "z": 3839.361
              },
              "distanceAlongShapeM": 11970.038,
              "shapeOffsetM": 5.253,
              "arrivalOffsetSeconds": 2220,
              "departureOffsetSeconds": 2220
            },
            {
              "stopId": "judu:stop:16713",
              "position": {
                "x": 4688.859,
                "z": 4020.996
              },
              "distanceAlongShapeM": 12626.878,
              "shapeOffsetM": 0.499,
              "arrivalOffsetSeconds": 2340,
              "departureOffsetSeconds": 2340
            },
            {
              "stopId": "judu:stop:16724",
              "position": {
                "x": 4948.434,
                "z": 3656.418
              },
              "distanceAlongShapeM": 13080.339,
              "shapeOffsetM": 0.687,
              "arrivalOffsetSeconds": 2400,
              "departureOffsetSeconds": 2400
            },
            {
              "stopId": "judu:stop:7714",
              "position": {
                "x": 5327.727,
                "z": 3076.874
              },
              "distanceAlongShapeM": 13949.424,
              "shapeOffsetM": 0.598,
              "arrivalOffsetSeconds": 2520,
              "departureOffsetSeconds": 2520
            },
            {
              "stopId": "judu:stop:7716",
              "position": {
                "x": 5632.402,
                "z": 3178.951
              },
              "distanceAlongShapeM": 14278.025,
              "shapeOffsetM": 0.32,
              "arrivalOffsetSeconds": 2580,
              "departureOffsetSeconds": 2580
            }
          ],
          "departuresSeconds": [
            19080,
            20460,
            22500,
            25200,
            27000,
            29160,
            34200,
            36000,
            40500,
            42000,
            46800,
            48600,
            53700,
            54900,
            57600,
            61200,
            63900,
            65400,
            69900,
            70800,
            75660,
            76920,
            82440
          ]
        },
        {
          "id": "judu:pattern:vilnius_bus_33:1",
          "sourceRouteId": "vilnius_bus_33",
          "sourceShapeId": "vilnius_bus_33_b-a3",
          "directionId": 1,
          "headsign": "Šiaurės miestelis",
          "directionName": "Guriai–Kalnėnai–Sukilėlių g.–Olandų g.–Rinktinės g.–Šiaurės miestelis",
          "mode": "bus",
          "routeShortName": "33",
          "routeLongName": "Šiaurės miestelis–Rinktinės–Olandų g.–Sukilėlių g.–Guriai",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              5632.191,
              3178.71,
              0
            ],
            [
              5642.082,
              3171.875,
              12.023
            ],
            [
              5639.186,
              3166.792,
              17.872
            ],
            [
              5585.636,
              3148.497,
              74.461
            ],
            [
              5543.897,
              3133.572,
              118.788
            ],
            [
              5478.145,
              3110.062,
              188.617
            ],
            [
              5367.647,
              3081.385,
              302.776
            ],
            [
              5288.726,
              3065.734,
              383.234
            ],
            [
              5163.987,
              3053.323,
              508.589
            ],
            [
              5097.3,
              3042.366,
              576.17
            ],
            [
              5039.274,
              3279.497,
              820.297
            ],
            [
              4987.026,
              3515.403,
              1061.92
            ],
            [
              4968.138,
              3607.055,
              1155.498
            ],
            [
              4967.898,
              3620.204,
              1168.649
            ],
            [
              4948.711,
              3637.437,
              1194.439
            ],
            [
              4939.849,
              3666.11,
              1224.45
            ],
            [
              4927.785,
              3683.05,
              1245.247
            ],
            [
              4847.561,
              3761.89,
              1357.726
            ],
            [
              4819.787,
              3779.139,
              1390.421
            ],
            [
              4710.681,
              3962.111,
              1603.453
            ],
            [
              4659.534,
              4073.006,
              1725.576
            ],
            [
              4127.493,
              3835.367,
              2308.276
            ],
            [
              3926.906,
              3747.733,
              2527.171
            ],
            [
              3679.16,
              3505.925,
              2873.363
            ],
            [
              3722.364,
              3443.085,
              2949.623
            ],
            [
              3752.614,
              3357.01,
              3040.858
            ],
            [
              3767.289,
              3320.563,
              3080.148
            ],
            [
              3790.873,
              3283.176,
              3124.352
            ],
            [
              3847.839,
              3212.158,
              3215.395
            ],
            [
              3901.779,
              3036.225,
              3399.411
            ],
            [
              3986.281,
              2755.313,
              3692.757
            ],
            [
              3690.262,
              2629.584,
              4014.37
            ],
            [
              3441.784,
              2491.803,
              4298.492
            ],
            [
              3321.224,
              2429.518,
              4434.19
            ],
            [
              3223.295,
              2403.539,
              4535.507
            ],
            [
              3141.671,
              2392.954,
              4617.815
            ],
            [
              3073.885,
              2389.555,
              4685.686
            ],
            [
              3048.326,
              2385.314,
              4711.593
            ],
            [
              3026.736,
              2382.758,
              4733.335
            ],
            [
              2944.248,
              2354.255,
              4820.608
            ],
            [
              2842.347,
              2322.777,
              4927.26
            ],
            [
              2808.638,
              2314.505,
              4961.97
            ],
            [
              2767.334,
              2314.168,
              5003.275
            ],
            [
              2727.488,
              2322.71,
              5044.026
            ],
            [
              2667.167,
              2340.542,
              5106.928
            ],
            [
              2599.009,
              2354.457,
              5176.492
            ],
            [
              2575.82,
              2354.087,
              5199.684
            ],
            [
              2455.843,
              2327.284,
              5322.618
            ],
            [
              2413.996,
              2328.591,
              5364.485
            ],
            [
              2299.657,
              2356.335,
              5482.142
            ],
            [
              2275.023,
              2359.894,
              5507.032
            ],
            [
              2242.456,
              2368.536,
              5540.726
            ],
            [
              2027.256,
              2420.422,
              5762.093
            ],
            [
              2006.656,
              2423.032,
              5782.857
            ],
            [
              1982.789,
              2423.477,
              5806.729
            ],
            [
              1947.251,
              2414.86,
              5843.296
            ],
            [
              1914.522,
              2403.084,
              5878.08
            ],
            [
              1894.574,
              2400.605,
              5898.181
            ],
            [
              1838.32,
              2392.769,
              5954.978
            ],
            [
              1803.322,
              2384.513,
              5990.937
            ],
            [
              1798.959,
              2323.366,
              6052.239
            ],
            [
              1808.843,
              2126.139,
              6249.714
            ],
            [
              1771.307,
              1946.492,
              6433.24
            ],
            [
              1758.977,
              1873.247,
              6507.516
            ],
            [
              1756.881,
              1829.869,
              6550.944
            ],
            [
              1765.404,
              1768.775,
              6612.63
            ],
            [
              1767.563,
              1745.065,
              6636.438
            ],
            [
              1776.079,
              1682.565,
              6699.516
            ],
            [
              1851.599,
              1476.324,
              6919.149
            ],
            [
              1872.115,
              1434.752,
              6965.507
            ],
            [
              1901.514,
              1385.222,
              7023.105
            ],
            [
              1922.902,
              1355.88,
              7059.415
            ],
            [
              1975.634,
              1283.961,
              7148.595
            ],
            [
              2058.447,
              1213.363,
              7257.415
            ],
            [
              2130.485,
              1105.982,
              7386.722
            ],
            [
              2171.861,
              1041.755,
              7463.123
            ],
            [
              2183.916,
              1028.198,
              7481.265
            ],
            [
              2200.048,
              996.698,
              7516.655
            ],
            [
              2297.211,
              845.707,
              7696.207
            ],
            [
              2377.645,
              731.764,
              7835.68
            ],
            [
              2389.245,
              704.619,
              7865.199
            ],
            [
              2392.58,
              680.329,
              7889.717
            ],
            [
              2387.096,
              651.712,
              7918.855
            ],
            [
              2369.175,
              623.937,
              7951.91
            ],
            [
              2305.672,
              573.917,
              8032.747
            ],
            [
              2269.605,
              542.307,
              8080.705
            ],
            [
              2254.026,
              527.847,
              8101.961
            ],
            [
              2223.804,
              507.54,
              8138.372
            ],
            [
              1990.962,
              334.88,
              8428.246
            ],
            [
              1969.782,
              310.225,
              8460.748
            ],
            [
              1935.827,
              283.585,
              8503.907
            ],
            [
              1864.599,
              199.192,
              8614.341
            ],
            [
              1763.619,
              40.763,
              8802.215
            ],
            [
              1755.04,
              12.778,
              8831.486
            ],
            [
              1734.841,
              -15.477,
              8866.218
            ],
            [
              1714.048,
              -58.507,
              8914.008
            ],
            [
              1702.489,
              -90.576,
              8948.097
            ],
            [
              1692.553,
              -139.375,
              8997.897
            ],
            [
              1696.284,
              -216.258,
              9074.871
            ],
            [
              1701.445,
              -250.864,
              9109.86
            ],
            [
              1720.689,
              -325.809,
              9187.236
            ],
            [
              1730.124,
              -347.569,
              9210.953
            ],
            [
              1742.617,
              -429.749,
              9294.077
            ],
            [
              1739.19,
              -475.328,
              9339.785
            ],
            [
              1717.531,
              -565.098,
              9432.131
            ],
            [
              1721.402,
              -599.681,
              9466.93
            ],
            [
              1718.066,
              -610.324,
              9478.084
            ],
            [
              1700.984,
              -622.679,
              9499.165
            ],
            [
              1670.687,
              -622.116,
              9529.467
            ],
            [
              1656.263,
              -617.38,
              9544.649
            ],
            [
              1647.146,
              -604.98,
              9560.04
            ],
            [
              1647.435,
              -589.4,
              9575.623
            ],
            [
              1641.361,
              -569.249,
              9596.669
            ],
            [
              1626.241,
              -550.043,
              9621.113
            ],
            [
              1613.941,
              -537.088,
              9638.977
            ],
            [
              1227.773,
              -233.181,
              10130.388
            ],
            [
              1061.875,
              -125.757,
              10328.03
            ],
            [
              912.058,
              -42.561,
              10499.397
            ],
            [
              652.936,
              0.051,
              10761.999
            ],
            [
              646.469,
              -0.943,
              10768.542
            ],
            [
              667.023,
              -146.041,
              10915.089
            ],
            [
              673.645,
              -171.767,
              10941.653
            ],
            [
              679.226,
              -196.092,
              10966.611
            ],
            [
              683.338,
              -240.966,
              11011.672
            ],
            [
              694.504,
              -300.172,
              11071.922
            ],
            [
              716.179,
              -384.063,
              11158.568
            ],
            [
              718.871,
              -413.057,
              11187.686
            ],
            [
              701.12,
              -501.79,
              11278.178
            ],
            [
              662.621,
              -666.955,
              11447.77
            ],
            [
              647.48,
              -719,
              11501.973
            ],
            [
              642.877,
              -758.992,
              11542.229
            ],
            [
              646.789,
              -754.414,
              11548.25
            ],
            [
              633.66,
              -804.465,
              11599.994
            ],
            [
              601.763,
              -926.336,
              11725.97
            ],
            [
              572.282,
              -1057.158,
              11860.073
            ],
            [
              526.396,
              -1238.888,
              12047.507
            ],
            [
              517.316,
              -1312.195,
              12121.374
            ],
            [
              515.934,
              -1346.679,
              12155.885
            ],
            [
              511.377,
              -1390.013,
              12199.458
            ],
            [
              519.103,
              -1424.756,
              12235.05
            ],
            [
              528.313,
              -1486.062,
              12297.044
            ],
            [
              543.467,
              -1538.662,
              12351.783
            ],
            [
              561.361,
              -1582.406,
              12399.046
            ],
            [
              616.278,
              -1681.379,
              12512.234
            ],
            [
              662.58,
              -1757.929,
              12601.698
            ],
            [
              696.368,
              -1819.94,
              12672.316
            ],
            [
              713.36,
              -1871.299,
              12726.413
            ],
            [
              776.616,
              -2147.432,
              13009.699
            ],
            [
              787.286,
              -2195.757,
              13059.187
            ],
            [
              791.563,
              -2252.452,
              13116.044
            ],
            [
              803.126,
              -2297.432,
              13162.486
            ],
            [
              810.049,
              -2322.85,
              13188.831
            ],
            [
              815.482,
              -2347.417,
              13213.991
            ],
            [
              839.035,
              -2433.57,
              13303.305
            ],
            [
              880.709,
              -2566.011,
              13442.148
            ],
            [
              898.288,
              -2661.896,
              13539.631
            ],
            [
              905.605,
              -2670.265,
              13550.748
            ],
            [
              909.345,
              -2669.084,
              13554.67
            ],
            [
              979.504,
              -2648.954,
              13627.659
            ],
            [
              1030.623,
              -2635.258,
              13680.582
            ],
            [
              1259.04,
              -2573.328,
              13917.245
            ],
            [
              1329.708,
              -2568.104,
              13988.106
            ],
            [
              1359.181,
              -2574.537,
              14018.273
            ],
            [
              1423.013,
              -2573.493,
              14082.113
            ],
            [
              1423.056,
              -2568.528,
              14087.079
            ],
            [
              1406.874,
              -2540.387,
              14119.541
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:7716",
              "position": {
                "x": 5632.402,
                "z": 3178.951
              },
              "distanceAlongShapeM": 0.036,
              "shapeOffsetM": 0.318,
              "arrivalOffsetSeconds": -600,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:16230",
              "position": {
                "x": 5544.977,
                "z": 3130.552
              },
              "distanceAlongShapeM": 118.788,
              "shapeOffsetM": 3.207,
              "arrivalOffsetSeconds": 60,
              "departureOffsetSeconds": 60
            },
            {
              "stopId": "judu:stop:7715",
              "position": {
                "x": 5288.781,
                "z": 3065.382
              },
              "distanceAlongShapeM": 383.234,
              "shapeOffsetM": 0.356,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:16725",
              "position": {
                "x": 4925.678,
                "z": 3681.348
              },
              "distanceAlongShapeM": 1245.557,
              "shapeOffsetM": 2.691,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:16715",
              "position": {
                "x": 4705.105,
                "z": 3959.455
              },
              "distanceAlongShapeM": 1603.453,
              "shapeOffsetM": 6.177,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:9599",
              "position": {
                "x": 4128.817,
                "z": 3832.45
              },
              "distanceAlongShapeM": 2308.257,
              "shapeOffsetM": 3.204,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:9660",
              "position": {
                "x": 3905.823,
                "z": 3037.387
              },
              "distanceAlongShapeM": 3399.463,
              "shapeOffsetM": 4.207,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:6682",
              "position": {
                "x": 3048.689,
                "z": 2383.457
              },
              "distanceAlongShapeM": 4711.54,
              "shapeOffsetM": 1.892,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:6680",
              "position": {
                "x": 2273.814,
                "z": 2354.591
              },
              "distanceAlongShapeM": 5507.032,
              "shapeOffsetM": 5.439,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:6679",
              "position": {
                "x": 1895.709,
                "z": 2390.588
              },
              "distanceAlongShapeM": 5898.439,
              "shapeOffsetM": 10.078,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:7688",
              "position": {
                "x": 1773.178,
                "z": 1769.451
              },
              "distanceAlongShapeM": 6612.662,
              "shapeOffsetM": 7.803,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:356",
              "position": {
                "x": 2187.13,
                "z": 1030.337
              },
              "distanceAlongShapeM": 7481.265,
              "shapeOffsetM": 3.86,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:6572",
              "position": {
                "x": 2256.376,
                "z": 524.743
              },
              "distanceAlongShapeM": 8101.961,
              "shapeOffsetM": 3.893,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            },
            {
              "stopId": "judu:stop:449",
              "position": {
                "x": 1973.014,
                "z": 306.27
              },
              "distanceAlongShapeM": 8460.748,
              "shapeOffsetM": 5.108,
              "arrivalOffsetSeconds": 1380,
              "departureOffsetSeconds": 1380
            },
            {
              "stopId": "judu:stop:603",
              "position": {
                "x": 1759.816,
                "z": 9.663
              },
              "distanceAlongShapeM": 8831.486,
              "shapeOffsetM": 5.702,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            },
            {
              "stopId": "judu:stop:6566",
              "position": {
                "x": 1735.144,
                "z": -346.116
              },
              "distanceAlongShapeM": 9210.953,
              "shapeOffsetM": 5.226,
              "arrivalOffsetSeconds": 1500,
              "departureOffsetSeconds": 1500
            },
            {
              "stopId": "judu:stop:5768",
              "position": {
                "x": 1608.96,
                "z": -543.043
              },
              "distanceAlongShapeM": 9638.088,
              "shapeOffsetM": 7.713,
              "arrivalOffsetSeconds": 1560,
              "departureOffsetSeconds": 1560
            },
            {
              "stopId": "judu:stop:5771",
              "position": {
                "x": 1060.09,
                "z": -128.781
              },
              "distanceAlongShapeM": 10327.884,
              "shapeOffsetM": 3.508,
              "arrivalOffsetSeconds": 1620,
              "departureOffsetSeconds": 1620
            },
            {
              "stopId": "judu:stop:7322",
              "position": {
                "x": 684.82,
                "z": -195.35
              },
              "distanceAlongShapeM": 10966.611,
              "shapeOffsetM": 5.643,
              "arrivalOffsetSeconds": 1740,
              "departureOffsetSeconds": 1740
            },
            {
              "stopId": "judu:stop:7324",
              "position": {
                "x": 653.896,
                "z": -755.854
              },
              "distanceAlongShapeM": 11548.25,
              "shapeOffsetM": 7.252,
              "arrivalOffsetSeconds": 1920,
              "departureOffsetSeconds": 1920
            },
            {
              "stopId": "judu:stop:7325",
              "position": {
                "x": 526.877,
                "z": -1423.694
              },
              "distanceAlongShapeM": 12235.155,
              "shapeOffsetM": 7.846,
              "arrivalOffsetSeconds": 2040,
              "departureOffsetSeconds": 2040
            },
            {
              "stopId": "judu:stop:7331",
              "position": {
                "x": 704.051,
                "z": -1816.579
              },
              "distanceAlongShapeM": 12672.316,
              "shapeOffsetM": 8.386,
              "arrivalOffsetSeconds": 2160,
              "departureOffsetSeconds": 2160
            },
            {
              "stopId": "judu:stop:9638",
              "position": {
                "x": 808.047,
                "z": -2296.071
              },
              "distanceAlongShapeM": 13162.393,
              "shapeOffsetM": 5.105,
              "arrivalOffsetSeconds": 2280,
              "departureOffsetSeconds": 2280
            },
            {
              "stopId": "judu:stop:18532",
              "position": {
                "x": 978.247,
                "z": -2644.311
              },
              "distanceAlongShapeM": 13627.659,
              "shapeOffsetM": 4.81,
              "arrivalOffsetSeconds": 2340,
              "departureOffsetSeconds": 2340
            },
            {
              "stopId": "judu:stop:9566",
              "position": {
                "x": 1329.768,
                "z": -2561.746
              },
              "distanceAlongShapeM": 13988.106,
              "shapeOffsetM": 6.358,
              "arrivalOffsetSeconds": 2460,
              "departureOffsetSeconds": 2460
            },
            {
              "stopId": "judu:stop:15167",
              "position": {
                "x": 1413.343,
                "z": -2538.803
              },
              "distanceAlongShapeM": 14117.689,
              "shapeOffsetM": 6.397,
              "arrivalOffsetSeconds": 2460,
              "departureOffsetSeconds": 2460
            }
          ],
          "departuresSeconds": [
            22080,
            23400,
            25860,
            28500,
            30300,
            32460,
            37200,
            39000,
            43500,
            45300,
            50400,
            51900,
            57000,
            58500,
            61200,
            65100,
            66900,
            69000,
            72900,
            74100,
            78600,
            79680,
            85140
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_bus_34",
      "sourceRouteId": "vilnius_bus_34",
      "mode": "bus",
      "shortName": "34",
      "longName": "Stotis–Olandų g.–Baltupiai–Jeruzalės g.–Visoriai",
      "color": "0073AC",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_bus_34:0",
          "sourceRouteId": "vilnius_bus_34",
          "sourceShapeId": "vilnius_bus_34_a-b",
          "directionId": 0,
          "headsign": "Visoriai",
          "directionName": "Stotis–Olandų g.–Baltupiai–Jeruzalės g.–Visoriai",
          "mode": "bus",
          "routeShortName": "34",
          "routeLongName": "Stotis–Olandų g.–Baltupiai–Jeruzalės g.–Visoriai",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              493.411,
              1911.506,
              0
            ],
            [
              476.616,
              1921.478,
              19.531
            ],
            [
              453.967,
              1920.686,
              42.195
            ],
            [
              432.764,
              1925.527,
              63.943
            ],
            [
              422.444,
              1925.716,
              74.265
            ],
            [
              419.803,
              1922.424,
              78.485
            ],
            [
              402.263,
              1927.258,
              96.68
            ],
            [
              397.27,
              1925.063,
              102.134
            ],
            [
              384.004,
              1905.267,
              125.964
            ],
            [
              371.312,
              1878.4,
              155.677
            ],
            [
              344.166,
              1843.654,
              199.77
            ],
            [
              330.657,
              1810.504,
              235.567
            ],
            [
              391.321,
              1670.242,
              388.386
            ],
            [
              477.846,
              1568.468,
              521.969
            ],
            [
              485.021,
              1572.79,
              530.346
            ],
            [
              495.103,
              1594.87,
              554.618
            ],
            [
              501.968,
              1590.033,
              563.016
            ],
            [
              515.385,
              1586.833,
              576.81
            ],
            [
              552.903,
              1580.453,
              614.866
            ],
            [
              580.038,
              1581.942,
              642.043
            ],
            [
              658.651,
              1577.401,
              720.786
            ],
            [
              692.229,
              1579.012,
              754.403
            ],
            [
              741.723,
              1585.833,
              804.364
            ],
            [
              775.59,
              1587.408,
              838.268
            ],
            [
              809.306,
              1578.914,
              873.037
            ],
            [
              847.494,
              1567.254,
              912.966
            ],
            [
              881.41,
              1552.158,
              950.09
            ],
            [
              943.873,
              1514.16,
              1023.203
            ],
            [
              977.642,
              1498.755,
              1060.32
            ],
            [
              986.83,
              1496.24,
              1069.846
            ],
            [
              1014.875,
              1489.647,
              1098.656
            ],
            [
              1169.279,
              1454.457,
              1257.019
            ],
            [
              1174.911,
              1305.179,
              1406.403
            ],
            [
              1219.91,
              1296.555,
              1452.221
            ],
            [
              1269.292,
              1286.69,
              1502.579
            ],
            [
              1287.836,
              1282.198,
              1521.659
            ],
            [
              1461.257,
              1230.864,
              1702.518
            ],
            [
              1535.192,
              1217.248,
              1777.696
            ],
            [
              1586.927,
              1224.082,
              1829.881
            ],
            [
              1634.086,
              1227.66,
              1877.175
            ],
            [
              1673.656,
              1231.674,
              1916.948
            ],
            [
              1721.874,
              1230.483,
              1965.181
            ],
            [
              1775.523,
              1236.165,
              2019.13
            ],
            [
              1885.773,
              1260.149,
              2131.959
            ],
            [
              1890.6,
              1266.382,
              2139.843
            ],
            [
              1963.37,
              1277.199,
              2213.412
            ],
            [
              2043.065,
              1295.752,
              2295.238
            ],
            [
              2056.65,
              1297.725,
              2308.966
            ],
            [
              2074.707,
              1297.388,
              2327.026
            ],
            [
              2084.797,
              1284.954,
              2343.039
            ],
            [
              2090.422,
              1264.04,
              2364.696
            ],
            [
              2096.23,
              1229.103,
              2400.113
            ],
            [
              2092.782,
              1212.054,
              2417.507
            ],
            [
              2084.488,
              1199.24,
              2432.771
            ],
            [
              2081.118,
              1191.51,
              2441.203
            ],
            [
              2084.435,
              1172.338,
              2460.66
            ],
            [
              2162.024,
              1054.703,
              2601.579
            ],
            [
              2179.433,
              1032.707,
              2629.63
            ],
            [
              2183.916,
              1028.198,
              2635.989
            ],
            [
              2200.048,
              996.698,
              2671.379
            ],
            [
              2297.211,
              845.707,
              2850.931
            ],
            [
              2377.645,
              731.764,
              2990.404
            ],
            [
              2389.245,
              704.619,
              3019.923
            ],
            [
              2392.58,
              680.329,
              3044.441
            ],
            [
              2387.096,
              651.712,
              3073.579
            ],
            [
              2369.175,
              623.937,
              3106.634
            ],
            [
              2305.672,
              573.917,
              3187.471
            ],
            [
              2269.605,
              542.307,
              3235.43
            ],
            [
              2254.026,
              527.847,
              3256.685
            ],
            [
              2223.804,
              507.54,
              3293.096
            ],
            [
              1990.962,
              334.88,
              3582.97
            ],
            [
              1969.782,
              310.225,
              3615.472
            ],
            [
              1935.827,
              283.585,
              3658.631
            ],
            [
              1864.599,
              199.192,
              3769.065
            ],
            [
              1763.619,
              40.763,
              3956.939
            ],
            [
              1755.04,
              12.778,
              3986.21
            ],
            [
              1734.841,
              -15.477,
              4020.942
            ],
            [
              1714.048,
              -58.507,
              4068.733
            ],
            [
              1702.489,
              -90.576,
              4102.821
            ],
            [
              1692.553,
              -139.375,
              4152.621
            ],
            [
              1696.284,
              -216.258,
              4229.595
            ],
            [
              1701.445,
              -250.864,
              4264.584
            ],
            [
              1720.689,
              -325.809,
              4341.96
            ],
            [
              1730.124,
              -347.569,
              4365.677
            ],
            [
              1742.617,
              -429.749,
              4448.801
            ],
            [
              1739.19,
              -475.328,
              4494.509
            ],
            [
              1717.531,
              -565.098,
              4586.855
            ],
            [
              1721.402,
              -599.681,
              4621.654
            ],
            [
              1718.066,
              -610.324,
              4632.808
            ],
            [
              1700.984,
              -622.679,
              4653.889
            ],
            [
              1684.224,
              -622.368,
              4670.652
            ],
            [
              1662.848,
              -627.537,
              4692.644
            ],
            [
              1381.451,
              -814.909,
              5030.716
            ],
            [
              1363.471,
              -845.747,
              5066.413
            ],
            [
              1363.126,
              -899.177,
              5119.844
            ],
            [
              1355.02,
              -919.065,
              5141.32
            ],
            [
              1339.886,
              -935.484,
              5163.65
            ],
            [
              1325.561,
              -943.011,
              5179.832
            ],
            [
              1285.577,
              -943.385,
              5219.818
            ],
            [
              1262.269,
              -948.52,
              5243.685
            ],
            [
              1247.842,
              -961.612,
              5263.167
            ],
            [
              1192.361,
              -1032.948,
              5353.538
            ],
            [
              1178.442,
              -1052.156,
              5377.259
            ],
            [
              1157.377,
              -1076.831,
              5409.703
            ],
            [
              1022.871,
              -1237.996,
              5619.622
            ],
            [
              920.55,
              -1367.472,
              5784.648
            ],
            [
              902.533,
              -1392.857,
              5815.777
            ],
            [
              882.932,
              -1414.649,
              5845.087
            ],
            [
              768.148,
              -1556.146,
              6027.287
            ],
            [
              700.938,
              -1635.064,
              6130.946
            ],
            [
              639.183,
              -1686.107,
              6211.065
            ],
            [
              593.366,
              -1704.078,
              6260.281
            ],
            [
              576.207,
              -1710.199,
              6278.499
            ],
            [
              544.685,
              -1716.484,
              6310.641
            ],
            [
              351.211,
              -1722.165,
              6504.199
            ],
            [
              347.927,
              -1725.444,
              6508.839
            ],
            [
              347.744,
              -1735.46,
              6518.857
            ],
            [
              352.701,
              -1764.728,
              6548.542
            ],
            [
              354.758,
              -1810.175,
              6594.035
            ],
            [
              356.121,
              -1841.371,
              6625.261
            ],
            [
              372.957,
              -1942.984,
              6728.259
            ],
            [
              426.379,
              -2158.817,
              6950.605
            ],
            [
              439.077,
              -2195.331,
              6989.265
            ],
            [
              440.947,
              -2208.066,
              7002.136
            ],
            [
              462.343,
              -2342.047,
              7137.815
            ],
            [
              497.458,
              -2575.098,
              7373.496
            ],
            [
              511.756,
              -2776.003,
              7574.909
            ],
            [
              513.301,
              -2797.183,
              7596.146
            ],
            [
              524.563,
              -2850.825,
              7650.957
            ],
            [
              523.952,
              -2902.017,
              7702.153
            ],
            [
              518.333,
              -3049.981,
              7850.223
            ],
            [
              511.327,
              -3110.973,
              7911.616
            ],
            [
              506.062,
              -3253.474,
              8054.215
            ],
            [
              505.902,
              -3256.64,
              8057.385
            ],
            [
              503.774,
              -3366.969,
              8167.734
            ],
            [
              489.873,
              -3512.567,
              8313.994
            ],
            [
              474.056,
              -3566.826,
              8370.512
            ],
            [
              440.465,
              -3641.474,
              8452.369
            ],
            [
              383.151,
              -3709.882,
              8541.614
            ],
            [
              302.538,
              -3790.592,
              8655.687
            ],
            [
              278.895,
              -3808.166,
              8685.145
            ],
            [
              228.358,
              -3858.451,
              8756.438
            ],
            [
              158.106,
              -3965.152,
              8884.189
            ],
            [
              125.932,
              -4039.781,
              8965.458
            ],
            [
              102.95,
              -4092.167,
              9022.664
            ],
            [
              79.561,
              -4208.631,
              9141.453
            ],
            [
              75.006,
              -4246.398,
              9179.494
            ],
            [
              72.804,
              -4296.453,
              9229.597
            ],
            [
              62.209,
              -4347.469,
              9281.702
            ],
            [
              53.653,
              -4357.332,
              9294.759
            ],
            [
              38.173,
              -4361.187,
              9310.711
            ],
            [
              -1.759,
              -4357.435,
              9350.819
            ],
            [
              -43.581,
              -4357.963,
              9392.645
            ],
            [
              -86.799,
              -4356.998,
              9435.873
            ],
            [
              -112.623,
              -4359.868,
              9461.856
            ],
            [
              -137.864,
              -4366.088,
              9487.852
            ],
            [
              -171.117,
              -4387.748,
              9527.538
            ],
            [
              -197.387,
              -4415.101,
              9565.462
            ],
            [
              -229.695,
              -4455.703,
              9617.35
            ],
            [
              -260.472,
              -4482.974,
              9658.471
            ],
            [
              -335.167,
              -4516.128,
              9740.193
            ],
            [
              -368.095,
              -4519.983,
              9773.346
            ],
            [
              -469.274,
              -4521.487,
              9874.536
            ],
            [
              -484.821,
              -4525.503,
              9890.594
            ],
            [
              -495.138,
              -4525.415,
              9900.911
            ],
            [
              -531.808,
              -4523.694,
              9937.621
            ],
            [
              -716.635,
              -4519.236,
              10122.502
            ],
            [
              -810.335,
              -4855.967,
              10472.027
            ],
            [
              -844.605,
              -4970.012,
              10591.109
            ],
            [
              -859.998,
              -5037.642,
              10660.469
            ],
            [
              -867.261,
              -5083.153,
              10706.556
            ],
            [
              -868.716,
              -5113.183,
              10736.621
            ],
            [
              -863.974,
              -5257.991,
              10881.507
            ],
            [
              -875.788,
              -5375.937,
              11000.043
            ],
            [
              -865.47,
              -5384.739,
              11013.604
            ],
            [
              -827.457,
              -5404.886,
              11056.627
            ],
            [
              -674.33,
              -5492.97,
              11233.281
            ],
            [
              -590.252,
              -5533.933,
              11326.807
            ],
            [
              -565.267,
              -5552.833,
              11358.135
            ],
            [
              -421.759,
              -5631.135,
              11521.615
            ],
            [
              -383.93,
              -5640.727,
              11560.641
            ],
            [
              -342.157,
              -5645.939,
              11602.738
            ],
            [
              -257.182,
              -5648.596,
              11687.755
            ],
            [
              -196.756,
              -5655.261,
              11748.547
            ],
            [
              -180.177,
              -5664.469,
              11767.512
            ],
            [
              -177.649,
              -5676.666,
              11779.968
            ],
            [
              -188.191,
              -5725.09,
              11829.526
            ],
            [
              -190.648,
              -5736.736,
              11841.429
            ],
            [
              -196.91,
              -5769.923,
              11875.201
            ],
            [
              -201.665,
              -5818.819,
              11924.328
            ],
            [
              -201.086,
              -5857.793,
              11963.306
            ],
            [
              -195.599,
              -5910.215,
              12016.014
            ],
            [
              -136.015,
              -6175.138,
              12287.555
            ],
            [
              -127.679,
              -6205.529,
              12319.068
            ],
            [
              -123.468,
              -6228.802,
              12342.72
            ],
            [
              -113.557,
              -6285.758,
              12400.532
            ],
            [
              -58.166,
              -6532.794,
              12653.701
            ],
            [
              -46.468,
              -6597.576,
              12719.531
            ],
            [
              -39.377,
              -6667.839,
              12790.151
            ],
            [
              -35.045,
              -6748.072,
              12870.501
            ],
            [
              -26.235,
              -6767.677,
              12891.994
            ],
            [
              -16.413,
              -6780.218,
              12907.924
            ],
            [
              0.443,
              -6790.505,
              12927.671
            ],
            [
              9.552,
              -6811.226,
              12950.305
            ],
            [
              9.735,
              -6827.796,
              12966.877
            ],
            [
              7.024,
              -6842.352,
              12981.683
            ],
            [
              -2.815,
              -6852.191,
              12995.598
            ],
            [
              -13.86,
              -6857.556,
              13007.877
            ],
            [
              -37.095,
              -6860.472,
              13031.294
            ],
            [
              -47.374,
              -6859.171,
              13041.655
            ],
            [
              -59.463,
              -6851.158,
              13056.158
            ],
            [
              -78.653,
              -6844.129,
              13076.595
            ],
            [
              -94.726,
              -6842.723,
              13092.73
            ],
            [
              -112.168,
              -6845.745,
              13110.431
            ],
            [
              -131.642,
              -6854.296,
              13131.7
            ],
            [
              -159.633,
              -6886.315,
              13174.229
            ],
            [
              -179.506,
              -6901.294,
              13199.115
            ],
            [
              -377.89,
              -7081.371,
              13467.04
            ],
            [
              -432.166,
              -7127.141,
              13538.039
            ],
            [
              -475.073,
              -7149.741,
              13586.534
            ],
            [
              -543.125,
              -7174.111,
              13658.818
            ],
            [
              -668.705,
              -7210.8,
              13789.647
            ],
            [
              -673.975,
              -7217.384,
              13798.081
            ],
            [
              -654.083,
              -7256.707,
              13842.149
            ],
            [
              -637.449,
              -7283.542,
              13873.721
            ],
            [
              -627.895,
              -7303.938,
              13896.244
            ],
            [
              -546.854,
              -7512.775,
              14120.254
            ],
            [
              -515.78,
              -7627.271,
              14238.891
            ],
            [
              -515.818,
              -7656.64,
              14268.261
            ],
            [
              -519.805,
              -7734.495,
              14346.218
            ],
            [
              -528.583,
              -7735.443,
              14355.047
            ],
            [
              -533.22,
              -7728.712,
              14363.221
            ],
            [
              -553.645,
              -7714.385,
              14388.169
            ],
            [
              -554.029,
              -7703.108,
              14399.453
            ],
            [
              -548.387,
              -7640.899,
              14461.917
            ],
            [
              -637.752,
              -7637.15,
              14551.361
            ],
            [
              -661.958,
              -7636.641,
              14575.572
            ],
            [
              -677.044,
              -7635.907,
              14590.676
            ],
            [
              -928.758,
              -7670.321,
              14844.731
            ],
            [
              -968.788,
              -7695.626,
              14892.089
            ],
            [
              -996.594,
              -7701.107,
              14920.43
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:4267",
              "position": {
                "x": 372.531,
                "z": 1877.646
              },
              "distanceAlongShapeM": 155.677,
              "shapeOffsetM": 1.434,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:5355",
              "position": {
                "x": 580.051,
                "z": 1583.295
              },
              "distanceAlongShapeM": 642.043,
              "shapeOffsetM": 1.353,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:5358",
              "position": {
                "x": 979.224,
                "z": 1503.603
              },
              "distanceAlongShapeM": 1059.747,
              "shapeOffsetM": 5.067,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:5360",
              "position": {
                "x": 1270.109,
                "z": 1290.062
              },
              "distanceAlongShapeM": 1502.579,
              "shapeOffsetM": 3.47,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:5362",
              "position": {
                "x": 1673.61,
                "z": 1236.945
              },
              "distanceAlongShapeM": 1916.948,
              "shapeOffsetM": 5.271,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:1123",
              "position": {
                "x": 2093.452,
                "z": 1264.754
              },
              "distanceAlongShapeM": 2364.696,
              "shapeOffsetM": 3.113,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:356",
              "position": {
                "x": 2187.13,
                "z": 1030.337
              },
              "distanceAlongShapeM": 2635.989,
              "shapeOffsetM": 3.86,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:6572",
              "position": {
                "x": 2256.376,
                "z": 524.743
              },
              "distanceAlongShapeM": 3256.685,
              "shapeOffsetM": 3.893,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:449",
              "position": {
                "x": 1973.014,
                "z": 306.27
              },
              "distanceAlongShapeM": 3615.472,
              "shapeOffsetM": 5.108,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:603",
              "position": {
                "x": 1759.816,
                "z": 9.663
              },
              "distanceAlongShapeM": 3986.21,
              "shapeOffsetM": 5.702,
              "arrivalOffsetSeconds": 810,
              "departureOffsetSeconds": 810
            },
            {
              "stopId": "judu:stop:6566",
              "position": {
                "x": 1735.144,
                "z": -346.116
              },
              "distanceAlongShapeM": 4365.677,
              "shapeOffsetM": 5.226,
              "arrivalOffsetSeconds": 870,
              "departureOffsetSeconds": 870
            },
            {
              "stopId": "judu:stop:6547",
              "position": {
                "x": 1184.819,
                "z": -1057.3
              },
              "distanceAlongShapeM": 5377.259,
              "shapeOffsetM": 8.193,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:1032",
              "position": {
                "x": 905.214,
                "z": -1395.021
              },
              "distanceAlongShapeM": 5815.777,
              "shapeOffsetM": 3.445,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:18847",
              "position": {
                "x": 578.225,
                "z": -1717.417
              },
              "distanceAlongShapeM": 6278.499,
              "shapeOffsetM": 7.495,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:6844",
              "position": {
                "x": 356.237,
                "z": -1764.56
              },
              "distanceAlongShapeM": 6548.542,
              "shapeOffsetM": 3.54,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:6845",
              "position": {
                "x": 441.836,
                "z": -2194.724
              },
              "distanceAlongShapeM": 6989.265,
              "shapeOffsetM": 2.825,
              "arrivalOffsetSeconds": 1380,
              "departureOffsetSeconds": 1380
            },
            {
              "stopId": "judu:stop:5469",
              "position": {
                "x": 505.139,
                "z": -2574.385
              },
              "distanceAlongShapeM": 7373.496,
              "shapeOffsetM": 7.714,
              "arrivalOffsetSeconds": 1500,
              "departureOffsetSeconds": 1500
            },
            {
              "stopId": "judu:stop:19086",
              "position": {
                "x": 511.316,
                "z": -3256.915
              },
              "distanceAlongShapeM": 8057.555,
              "shapeOffsetM": 5.419,
              "arrivalOffsetSeconds": 1620,
              "departureOffsetSeconds": 1620
            },
            {
              "stopId": "judu:stop:5848",
              "position": {
                "x": 303.678,
                "z": -3791.921
              },
              "distanceAlongShapeM": 8655.687,
              "shapeOffsetM": 1.751,
              "arrivalOffsetSeconds": 1770,
              "departureOffsetSeconds": 1770
            },
            {
              "stopId": "judu:stop:5840",
              "position": {
                "x": 127.093,
                "z": -4040.286
              },
              "distanceAlongShapeM": 8965.458,
              "shapeOffsetM": 1.266,
              "arrivalOffsetSeconds": 1830,
              "departureOffsetSeconds": 1830
            },
            {
              "stopId": "judu:stop:5835",
              "position": {
                "x": -43.706,
                "z": -4361.123
              },
              "distanceAlongShapeM": 9392.699,
              "shapeOffsetM": 3.162,
              "arrivalOffsetSeconds": 1920,
              "departureOffsetSeconds": 1920
            },
            {
              "stopId": "judu:stop:5834",
              "position": {
                "x": -495.157,
                "z": -4527.698
              },
              "distanceAlongShapeM": 9900.911,
              "shapeOffsetM": 2.283,
              "arrivalOffsetSeconds": 1980,
              "departureOffsetSeconds": 1980
            },
            {
              "stopId": "judu:stop:5828",
              "position": {
                "x": -826.661,
                "z": -5403.385
              },
              "distanceAlongShapeM": 11056.627,
              "shapeOffsetM": 1.699,
              "arrivalOffsetSeconds": 2220,
              "departureOffsetSeconds": 2220
            },
            {
              "stopId": "judu:stop:6633",
              "position": {
                "x": -589.373,
                "z": -5532.358
              },
              "distanceAlongShapeM": 11326.807,
              "shapeOffsetM": 1.804,
              "arrivalOffsetSeconds": 2280,
              "departureOffsetSeconds": 2280
            },
            {
              "stopId": "judu:stop:6497",
              "position": {
                "x": -185.377,
                "z": -5737.848
              },
              "distanceAlongShapeM": 11841.544,
              "shapeOffsetM": 5.386,
              "arrivalOffsetSeconds": 2460,
              "departureOffsetSeconds": 2460
            },
            {
              "stopId": "judu:stop:6500",
              "position": {
                "x": -122.378,
                "z": -6204.331
              },
              "distanceAlongShapeM": 12319.068,
              "shapeOffsetM": 5.434,
              "arrivalOffsetSeconds": 2520,
              "departureOffsetSeconds": 2520
            },
            {
              "stopId": "judu:stop:6783",
              "position": {
                "x": -156.753,
                "z": -6889.462
              },
              "distanceAlongShapeM": 13174.229,
              "shapeOffsetM": 4.266,
              "arrivalOffsetSeconds": 2640,
              "departureOffsetSeconds": 2640
            },
            {
              "stopId": "judu:stop:7980",
              "position": {
                "x": -633.285,
                "z": -7281.575
              },
              "distanceAlongShapeM": 13873.721,
              "shapeOffsetM": 4.606,
              "arrivalOffsetSeconds": 2820,
              "departureOffsetSeconds": 2820
            },
            {
              "stopId": "judu:stop:7046",
              "position": {
                "x": -661.758,
                "z": -7645.09
              },
              "distanceAlongShapeM": 14575.194,
              "shapeOffsetM": 8.443,
              "arrivalOffsetSeconds": 2940,
              "departureOffsetSeconds": 2940
            },
            {
              "stopId": "judu:stop:1115",
              "position": {
                "x": -995.773,
                "z": -7709.189
              },
              "distanceAlongShapeM": 14920.43,
              "shapeOffsetM": 8.123,
              "arrivalOffsetSeconds": 3000,
              "departureOffsetSeconds": 3000
            }
          ],
          "departuresSeconds": [
            18540,
            21000,
            22920,
            24780,
            26100,
            27840,
            30060,
            32160,
            35400,
            37560,
            39660,
            42120,
            44460,
            46740,
            48840,
            51600,
            53880,
            56160,
            58140,
            60120,
            61920,
            63720,
            66060,
            69720,
            71820,
            73920,
            76080,
            78180,
            80280,
            82440
          ]
        },
        {
          "id": "judu:pattern:vilnius_bus_34:1",
          "sourceRouteId": "vilnius_bus_34",
          "sourceShapeId": "vilnius_bus_34_b-a",
          "directionId": 1,
          "headsign": "Stotis",
          "directionName": "Visoriai–Jeruzalės g. –Baltupiai–Olandų g.–Stotis",
          "mode": "bus",
          "routeShortName": "34",
          "routeLongName": "Stotis–Olandų g.–Baltupiai–Jeruzalės g.–Visoriai",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              -996.594,
              -7701.107,
              0
            ],
            [
              -1008.525,
              -7702.28,
              11.989
            ],
            [
              -1017.416,
              -7702.312,
              20.88
            ],
            [
              -1031.635,
              -7698.523,
              35.595
            ],
            [
              -1034.149,
              -7695.138,
              39.812
            ],
            [
              -1034.672,
              -7688.449,
              46.521
            ],
            [
              -1028.056,
              -7678.549,
              58.428
            ],
            [
              -952.572,
              -7669.891,
              134.407
            ],
            [
              -687.301,
              -7633.495,
              402.163
            ],
            [
              -639.032,
              -7633.262,
              450.433
            ],
            [
              -621.692,
              -7636.909,
              468.152
            ],
            [
              -533.131,
              -7645.065,
              557.088
            ],
            [
              -532.873,
              -7638.519,
              563.64
            ],
            [
              -542.156,
              -7601.205,
              602.091
            ],
            [
              -544.642,
              -7569.294,
              634.099
            ],
            [
              -559.134,
              -7524.492,
              681.186
            ],
            [
              -592.861,
              -7431.482,
              780.122
            ],
            [
              -636.284,
              -7340.523,
              880.915
            ],
            [
              -707.406,
              -7214.553,
              1025.576
            ],
            [
              -684.153,
              -7210.52,
              1049.176
            ],
            [
              -567.625,
              -7175.894,
              1170.74
            ],
            [
              -490.912,
              -7147.103,
              1252.678
            ],
            [
              -472.731,
              -7139.026,
              1272.572
            ],
            [
              -433.975,
              -7120.429,
              1315.559
            ],
            [
              -356.786,
              -7053.923,
              1417.447
            ],
            [
              -147.918,
              -6864.018,
              1699.741
            ],
            [
              -114.729,
              -6832.74,
              1745.345
            ],
            [
              -100.778,
              -6821.461,
              1763.286
            ],
            [
              -58.991,
              -6789.938,
              1815.629
            ],
            [
              -47.746,
              -6774.569,
              1834.673
            ],
            [
              -39.488,
              -6758.546,
              1852.699
            ],
            [
              -44.133,
              -6716.735,
              1894.767
            ],
            [
              -50.641,
              -6695.446,
              1917.028
            ],
            [
              -48.526,
              -6639.841,
              1972.674
            ],
            [
              -52.099,
              -6588.567,
              2024.072
            ],
            [
              -70.555,
              -6505.85,
              2108.823
            ],
            [
              -125.166,
              -6286.66,
              2334.714
            ],
            [
              -158.525,
              -6137.991,
              2487.08
            ],
            [
              -180.294,
              -6069.166,
              2559.265
            ],
            [
              -186.217,
              -6031.729,
              2597.168
            ],
            [
              -210.448,
              -5912.171,
              2719.157
            ],
            [
              -214.688,
              -5861.998,
              2769.508
            ],
            [
              -215.425,
              -5796.303,
              2835.208
            ],
            [
              -210.007,
              -5746.306,
              2885.497
            ],
            [
              -195.772,
              -5671.978,
              2961.176
            ],
            [
              -200.158,
              -5665.219,
              2969.233
            ],
            [
              -245.834,
              -5662.161,
              3015.012
            ],
            [
              -275.267,
              -5661.057,
              3044.466
            ],
            [
              -299.862,
              -5657.84,
              3069.27
            ],
            [
              -394.957,
              -5644.98,
              3165.231
            ],
            [
              -428.258,
              -5634.356,
              3200.185
            ],
            [
              -633.019,
              -5523.775,
              3432.898
            ],
            [
              -662.96,
              -5509.616,
              3466.018
            ],
            [
              -740.412,
              -5464.845,
              3555.479
            ],
            [
              -765.768,
              -5455.693,
              3582.436
            ],
            [
              -877.432,
              -5396.902,
              3708.631
            ],
            [
              -884.394,
              -5390.097,
              3718.367
            ],
            [
              -886.769,
              -5378.922,
              3729.791
            ],
            [
              -880.613,
              -5358.995,
              3750.647
            ],
            [
              -871.302,
              -5283.486,
              3826.728
            ],
            [
              -867.295,
              -5263.497,
              3847.115
            ],
            [
              -873.84,
              -5126.451,
              3984.317
            ],
            [
              -873.198,
              -5090.839,
              4019.935
            ],
            [
              -867.363,
              -5053.094,
              4058.128
            ],
            [
              -847.141,
              -4967.74,
              4145.845
            ],
            [
              -716.635,
              -4519.236,
              4612.951
            ],
            [
              -646.885,
              -4514.933,
              4682.833
            ],
            [
              -568.48,
              -4520.803,
              4761.458
            ],
            [
              -439.606,
              -4519.799,
              4890.336
            ],
            [
              -373.187,
              -4516.551,
              4956.834
            ],
            [
              -303.365,
              -4503.347,
              5027.894
            ],
            [
              -273.394,
              -4484.966,
              5063.052
            ],
            [
              -264.248,
              -4475.971,
              5075.88
            ],
            [
              -247.988,
              -4462.621,
              5096.918
            ],
            [
              -206.653,
              -4415.152,
              5159.862
            ],
            [
              -184.743,
              -4390.249,
              5193.032
            ],
            [
              -166.1,
              -4374.591,
              5217.378
            ],
            [
              -152.82,
              -4365.759,
              5233.326
            ],
            [
              -100.827,
              -4348.95,
              5287.969
            ],
            [
              -72.436,
              -4347.387,
              5316.403
            ],
            [
              -23.573,
              -4348.894,
              5365.289
            ],
            [
              35.061,
              -4351.207,
              5423.968
            ],
            [
              46.147,
              -4344.95,
              5436.699
            ],
            [
              48.454,
              -4310.97,
              5470.756
            ],
            [
              52.989,
              -4285.429,
              5496.697
            ],
            [
              60.111,
              -4250.579,
              5532.268
            ],
            [
              104.143,
              -4062.131,
              5725.791
            ],
            [
              127.703,
              -3998.463,
              5793.679
            ],
            [
              151.352,
              -3953.466,
              5844.512
            ],
            [
              179.07,
              -3910.986,
              5895.235
            ],
            [
              264.038,
              -3810.121,
              6027.119
            ],
            [
              345.157,
              -3743.697,
              6131.963
            ],
            [
              387.493,
              -3689.441,
              6200.783
            ],
            [
              434.283,
              -3627.326,
              6278.549
            ],
            [
              450.253,
              -3599.787,
              6310.383
            ],
            [
              463.769,
              -3565.524,
              6347.216
            ],
            [
              474.065,
              -3531.203,
              6383.048
            ],
            [
              484.063,
              -3477.95,
              6437.231
            ],
            [
              490.334,
              -3345.62,
              6569.71
            ],
            [
              488.575,
              -3319.869,
              6595.521
            ],
            [
              479.687,
              -3259.675,
              6656.367
            ],
            [
              477.905,
              -3216.226,
              6699.853
            ],
            [
              481.339,
              -3169.533,
              6746.672
            ],
            [
              500.602,
              -3103.091,
              6815.85
            ],
            [
              504.082,
              -3078.362,
              6840.823
            ],
            [
              504.445,
              -3034.141,
              6885.045
            ],
            [
              503.491,
              -2980.688,
              6938.507
            ],
            [
              505.751,
              -2962.917,
              6956.421
            ],
            [
              504.844,
              -2912.819,
              7006.527
            ],
            [
              509.397,
              -2869.472,
              7050.113
            ],
            [
              513.301,
              -2797.183,
              7122.507
            ],
            [
              494.515,
              -2626.513,
              7294.208
            ],
            [
              487.991,
              -2601.316,
              7320.236
            ],
            [
              485.911,
              -2568.466,
              7353.151
            ],
            [
              462.343,
              -2342.047,
              7580.794
            ],
            [
              451.425,
              -2269.486,
              7654.171
            ],
            [
              407.333,
              -2116.119,
              7813.75
            ],
            [
              406.254,
              -2096.107,
              7833.792
            ],
            [
              361.405,
              -1904.922,
              8030.167
            ],
            [
              342.249,
              -1718.661,
              8217.41
            ],
            [
              510.658,
              -1710.612,
              8386.012
            ],
            [
              550.922,
              -1706.707,
              8426.465
            ],
            [
              586.765,
              -1697.182,
              8463.552
            ],
            [
              616.278,
              -1681.379,
              8497.029
            ],
            [
              646.312,
              -1660.778,
              8533.45
            ],
            [
              676.214,
              -1635.564,
              8572.563
            ],
            [
              696.914,
              -1614.56,
              8602.053
            ],
            [
              891.199,
              -1385.857,
              8902.139
            ],
            [
              926.904,
              -1337.532,
              8962.224
            ],
            [
              938.594,
              -1321.715,
              8981.892
            ],
            [
              959.848,
              -1299.175,
              9012.872
            ],
            [
              1019.189,
              -1227.908,
              9105.61
            ],
            [
              1188.158,
              -1016.171,
              9376.504
            ],
            [
              1211.885,
              -984.023,
              9416.459
            ],
            [
              1229.979,
              -967.272,
              9441.117
            ],
            [
              1246.923,
              -941.557,
              9471.912
            ],
            [
              1250.475,
              -923.811,
              9490.01
            ],
            [
              1249.57,
              -868.132,
              9545.696
            ],
            [
              1251.975,
              -858.297,
              9555.822
            ],
            [
              1263.58,
              -842.786,
              9575.193
            ],
            [
              1271.438,
              -836.252,
              9585.413
            ],
            [
              1287.032,
              -829.861,
              9602.265
            ],
            [
              1306.39,
              -829.106,
              9621.638
            ],
            [
              1381.451,
              -814.909,
              9698.03
            ],
            [
              1625.047,
              -649.1,
              9992.702
            ],
            [
              1633.665,
              -634.2,
              10009.915
            ],
            [
              1640.869,
              -630.468,
              10018.028
            ],
            [
              1649.997,
              -609.491,
              10040.905
            ],
            [
              1647.435,
              -589.4,
              10061.159
            ],
            [
              1649.076,
              -570.506,
              10080.124
            ],
            [
              1661.593,
              -556.266,
              10099.083
            ],
            [
              1707.61,
              -543.762,
              10146.769
            ],
            [
              1715.531,
              -533.89,
              10159.426
            ],
            [
              1739.19,
              -475.328,
              10222.586
            ],
            [
              1739.832,
              -440.829,
              10257.091
            ],
            [
              1737.688,
              -417.411,
              10280.607
            ],
            [
              1728.721,
              -379.394,
              10319.667
            ],
            [
              1717.488,
              -353.728,
              10347.685
            ],
            [
              1709.957,
              -313.364,
              10388.745
            ],
            [
              1701.073,
              -270.896,
              10432.132
            ],
            [
              1691.292,
              -207.259,
              10496.516
            ],
            [
              1692.553,
              -139.375,
              10564.412
            ],
            [
              1699.889,
              -91.641,
              10612.706
            ],
            [
              1722.281,
              -31.942,
              10676.466
            ],
            [
              1763.619,
              40.763,
              10760.102
            ],
            [
              1784.543,
              87.474,
              10811.285
            ],
            [
              1803.689,
              114.605,
              10844.491
            ],
            [
              1864.141,
              209.22,
              10956.77
            ],
            [
              1913.636,
              269.526,
              11034.786
            ],
            [
              1990.962,
              334.88,
              11136.031
            ],
            [
              2018.633,
              366.989,
              11178.418
            ],
            [
              2052.586,
              388.28,
              11218.494
            ],
            [
              2087.216,
              412.125,
              11260.54
            ],
            [
              2136.967,
              451.273,
              11323.846
            ],
            [
              2182.309,
              496.069,
              11387.585
            ],
            [
              2210.658,
              528.937,
              11430.99
            ],
            [
              2229.877,
              556.409,
              11464.517
            ],
            [
              2248.742,
              590.591,
              11503.559
            ],
            [
              2266.569,
              621.404,
              11539.157
            ],
            [
              2281.67,
              670.105,
              11590.146
            ],
            [
              2285.519,
              703.43,
              11623.693
            ],
            [
              2286.06,
              732.364,
              11652.632
            ],
            [
              2274.704,
              814.957,
              11736.002
            ],
            [
              2261.392,
              861.962,
              11784.855
            ],
            [
              2144.257,
              1048.95,
              12005.502
            ],
            [
              2120.129,
              1077.499,
              12042.881
            ],
            [
              2107.735,
              1096.818,
              12065.835
            ],
            [
              2088.256,
              1124.583,
              12099.751
            ],
            [
              2063.317,
              1145.824,
              12132.51
            ],
            [
              2049.437,
              1153.138,
              12148.199
            ],
            [
              2015.127,
              1163.632,
              12184.078
            ],
            [
              1965.977,
              1174.732,
              12234.466
            ],
            [
              1928.988,
              1197.686,
              12277.998
            ],
            [
              1911.304,
              1218.054,
              12304.972
            ],
            [
              1889.263,
              1249.836,
              12343.649
            ],
            [
              1817.405,
              1234.36,
              12417.154
            ],
            [
              1745.61,
              1223.362,
              12489.787
            ],
            [
              1634.607,
              1220.971,
              12600.815
            ],
            [
              1599.996,
              1216.751,
              12635.683
            ],
            [
              1535.192,
              1217.248,
              12700.489
            ],
            [
              1461.257,
              1230.864,
              12775.667
            ],
            [
              1250.055,
              1287.093,
              12994.226
            ],
            [
              1216.978,
              1291.043,
              13027.538
            ],
            [
              1174.911,
              1305.179,
              13071.916
            ],
            [
              1169.279,
              1454.457,
              13221.3
            ],
            [
              990.627,
              1492.26,
              13403.908
            ],
            [
              961.104,
              1500.597,
              13434.586
            ],
            [
              886.508,
              1548.725,
              13523.36
            ],
            [
              861.581,
              1561.429,
              13551.338
            ],
            [
              775.59,
              1587.408,
              13641.168
            ],
            [
              773.577,
              1623.63,
              13677.445
            ],
            [
              781.269,
              1649.737,
              13704.662
            ],
            [
              802.898,
              1738.399,
              13795.924
            ],
            [
              825.163,
              1791.425,
              13853.435
            ],
            [
              623.161,
              1858.587,
              14066.309
            ],
            [
              598.791,
              1864.715,
              14091.437
            ],
            [
              535.995,
              1890.241,
              14159.223
            ],
            [
              493.411,
              1911.506,
              14206.822
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:1115",
              "position": {
                "x": -995.773,
                "z": -7709.189
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 8.123,
              "arrivalOffsetSeconds": -600,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:7047",
              "position": {
                "x": -638.969,
                "z": -7631.03
              },
              "distanceAlongShapeM": 450.433,
              "shapeOffsetM": 2.233,
              "arrivalOffsetSeconds": 60,
              "departureOffsetSeconds": 60
            },
            {
              "stopId": "judu:stop:8326",
              "position": {
                "x": -492.955,
                "z": -7141.624
              },
              "distanceAlongShapeM": 1253.035,
              "shapeOffsetM": 5.837,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:8327",
              "position": {
                "x": -119.568,
                "z": -6827.798
              },
              "distanceAlongShapeM": 1745.214,
              "shapeOffsetM": 6.915,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:6503",
              "position": {
                "x": -50.829,
                "z": -6695.462
              },
              "distanceAlongShapeM": 1917.028,
              "shapeOffsetM": 0.189,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:6501",
              "position": {
                "x": -182.398,
                "z": -6069.649
              },
              "distanceAlongShapeM": 2559.265,
              "shapeOffsetM": 2.159,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:6640",
              "position": {
                "x": -275.515,
                "z": -5664.961
              },
              "distanceAlongShapeM": 3044.466,
              "shapeOffsetM": 3.912,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:6634",
              "position": {
                "x": -663.705,
                "z": -5510.974
              },
              "distanceAlongShapeM": 3466.018,
              "shapeOffsetM": 1.549,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:348",
              "position": {
                "x": -871.52,
                "z": -5283.459
              },
              "distanceAlongShapeM": 3826.728,
              "shapeOffsetM": 0.219,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:5833",
              "position": {
                "x": -646.915,
                "z": -4511.591
              },
              "distanceAlongShapeM": 4682.833,
              "shapeOffsetM": 3.342,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            },
            {
              "stopId": "judu:stop:5836",
              "position": {
                "x": 49.82,
                "z": -4284.902
              },
              "distanceAlongShapeM": 5496.662,
              "shapeOffsetM": 3.212,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:5839",
              "position": {
                "x": 148.043,
                "z": -3951.609
              },
              "distanceAlongShapeM": 5844.512,
              "shapeOffsetM": 3.794,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:5846",
              "position": {
                "x": 383.579,
                "z": -3686.512
              },
              "distanceAlongShapeM": 6200.684,
              "shapeOffsetM": 4.888,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:5481",
              "position": {
                "x": 502.159,
                "z": -2912.756
              },
              "distanceAlongShapeM": 7006.527,
              "shapeOffsetM": 2.686,
              "arrivalOffsetSeconds": 1380,
              "departureOffsetSeconds": 1380
            },
            {
              "stopId": "judu:stop:5347",
              "position": {
                "x": 482.722,
                "z": -2601.805
              },
              "distanceAlongShapeM": 7320.236,
              "shapeOffsetM": 5.291,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            },
            {
              "stopId": "judu:stop:5351",
              "position": {
                "x": 407.176,
                "z": -2116.162
              },
              "distanceAlongShapeM": 7813.75,
              "shapeOffsetM": 0.163,
              "arrivalOffsetSeconds": 1560,
              "departureOffsetSeconds": 1560
            },
            {
              "stopId": "judu:stop:6542",
              "position": {
                "x": 673.267,
                "z": -1632.329
              },
              "distanceAlongShapeM": 8572.799,
              "shapeOffsetM": 4.37,
              "arrivalOffsetSeconds": 1800,
              "departureOffsetSeconds": 1800
            },
            {
              "stopId": "judu:stop:6544",
              "position": {
                "x": 934.987,
                "z": -1318.756
              },
              "distanceAlongShapeM": 8981.892,
              "shapeOffsetM": 4.665,
              "arrivalOffsetSeconds": 1860,
              "departureOffsetSeconds": 1860
            },
            {
              "stopId": "judu:stop:6546",
              "position": {
                "x": 1209.421,
                "z": -982.054
              },
              "distanceAlongShapeM": 9416.459,
              "shapeOffsetM": 3.154,
              "arrivalOffsetSeconds": 1980,
              "departureOffsetSeconds": 1980
            },
            {
              "stopId": "judu:stop:6565",
              "position": {
                "x": 1714.349,
                "z": -354.636
              },
              "distanceAlongShapeM": 10347.685,
              "shapeOffsetM": 3.268,
              "arrivalOffsetSeconds": 2160,
              "departureOffsetSeconds": 2160
            },
            {
              "stopId": "judu:stop:6568",
              "position": {
                "x": 1781.292,
                "z": 89.417
              },
              "distanceAlongShapeM": 10811.285,
              "shapeOffsetM": 3.788,
              "arrivalOffsetSeconds": 2220,
              "departureOffsetSeconds": 2220
            },
            {
              "stopId": "judu:stop:6571",
              "position": {
                "x": 2015.503,
                "z": 371.16
              },
              "distanceAlongShapeM": 11178.418,
              "shapeOffsetM": 5.214,
              "arrivalOffsetSeconds": 2280,
              "departureOffsetSeconds": 2280
            },
            {
              "stopId": "judu:stop:6574",
              "position": {
                "x": 2244.749,
                "z": 592.868
              },
              "distanceAlongShapeM": 11503.559,
              "shapeOffsetM": 4.597,
              "arrivalOffsetSeconds": 2340,
              "departureOffsetSeconds": 2340
            },
            {
              "stopId": "judu:stop:5925",
              "position": {
                "x": 2116.361,
                "z": 1075.075
              },
              "distanceAlongShapeM": 12042.881,
              "shapeOffsetM": 4.48,
              "arrivalOffsetSeconds": 2460,
              "departureOffsetSeconds": 2460
            },
            {
              "stopId": "judu:stop:946",
              "position": {
                "x": 1600.284,
                "z": 1213.815
              },
              "distanceAlongShapeM": 12635.683,
              "shapeOffsetM": 2.95,
              "arrivalOffsetSeconds": 2580,
              "departureOffsetSeconds": 2580
            },
            {
              "stopId": "judu:stop:5428",
              "position": {
                "x": 1216.542,
                "z": 1288.825
              },
              "distanceAlongShapeM": 13027.538,
              "shapeOffsetM": 2.261,
              "arrivalOffsetSeconds": 2640,
              "departureOffsetSeconds": 2640
            },
            {
              "stopId": "judu:stop:6714",
              "position": {
                "x": 769.19,
                "z": 1624.355
              },
              "distanceAlongShapeM": 13677.445,
              "shapeOffsetM": 4.447,
              "arrivalOffsetSeconds": 2760,
              "departureOffsetSeconds": 2760
            },
            {
              "stopId": "judu:stop:8264",
              "position": {
                "x": 493.148,
                "z": 1911.064
              },
              "distanceAlongShapeM": 14206.822,
              "shapeOffsetM": 0.515,
              "arrivalOffsetSeconds": 2940,
              "departureOffsetSeconds": 2940
            }
          ],
          "departuresSeconds": [
            18180,
            19980,
            21840,
            22860,
            24840,
            26820,
            28800,
            31980,
            34080,
            36180,
            38760,
            41040,
            43320,
            45420,
            47880,
            50340,
            52740,
            54540,
            56400,
            58320,
            60240,
            62340,
            66240,
            68100,
            70320,
            72900,
            75000,
            77100,
            79140,
            81180,
            83280
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_bus_35",
      "sourceRouteId": "vilnius_bus_35",
      "mode": "bus",
      "shortName": "35",
      "longName": "Žalgirio–Kalvarijų g.–Naujieji Verkiai–Ožkiniai",
      "color": "0073AC",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_bus_35:0",
          "sourceRouteId": "vilnius_bus_35",
          "sourceShapeId": "vilnius_bus_35_a-b",
          "directionId": 0,
          "headsign": "Ožkiniai",
          "directionName": "Žalgirio–Kalvarijų g.–Naujieji Verkiai–Ožkiniai",
          "mode": "bus",
          "routeShortName": "35",
          "routeLongName": "Žalgirio–Kalvarijų g.–Naujieji Verkiai–Ožkiniai",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              374.545,
              -1783.148,
              0
            ],
            [
              362.91,
              -1783.757,
              11.651
            ],
            [
              354.358,
              -1796.809,
              27.255
            ],
            [
              355.721,
              -1828.005,
              58.481
            ],
            [
              364.892,
              -1890.514,
              121.659
            ],
            [
              374.87,
              -1944.132,
              176.198
            ],
            [
              407.808,
              -2081.663,
              317.618
            ],
            [
              428.936,
              -2159.977,
              398.732
            ],
            [
              439.077,
              -2195.331,
              435.512
            ],
            [
              440.947,
              -2208.066,
              448.383
            ],
            [
              462.343,
              -2342.047,
              584.062
            ],
            [
              497.458,
              -2575.098,
              819.743
            ],
            [
              511.756,
              -2776.003,
              1021.157
            ],
            [
              513.301,
              -2797.183,
              1042.393
            ],
            [
              524.563,
              -2850.825,
              1097.204
            ],
            [
              523.952,
              -2902.017,
              1148.4
            ],
            [
              518.333,
              -3049.981,
              1296.471
            ],
            [
              511.327,
              -3110.973,
              1357.864
            ],
            [
              506.062,
              -3253.474,
              1500.462
            ],
            [
              505.902,
              -3256.64,
              1503.632
            ],
            [
              503.774,
              -3366.969,
              1613.982
            ],
            [
              489.873,
              -3512.567,
              1760.241
            ],
            [
              474.056,
              -3566.826,
              1816.759
            ],
            [
              440.465,
              -3641.474,
              1898.616
            ],
            [
              383.151,
              -3709.882,
              1987.861
            ],
            [
              302.538,
              -3790.592,
              2101.934
            ],
            [
              278.895,
              -3808.166,
              2131.393
            ],
            [
              228.358,
              -3858.451,
              2202.685
            ],
            [
              158.106,
              -3965.152,
              2330.436
            ],
            [
              125.932,
              -4039.781,
              2411.705
            ],
            [
              102.95,
              -4092.167,
              2468.911
            ],
            [
              79.561,
              -4208.631,
              2587.7
            ],
            [
              75.006,
              -4246.398,
              2625.741
            ],
            [
              72.804,
              -4296.453,
              2675.844
            ],
            [
              57.959,
              -4368.543,
              2749.447
            ],
            [
              50.952,
              -4440.233,
              2821.478
            ],
            [
              47.442,
              -4461.8,
              2843.329
            ],
            [
              42.119,
              -4495.164,
              2877.115
            ],
            [
              45.832,
              -4598.763,
              2980.781
            ],
            [
              43.273,
              -4641.013,
              3023.109
            ],
            [
              -32.111,
              -5068.242,
              3456.937
            ],
            [
              -38.249,
              -5115.663,
              3504.754
            ],
            [
              -42.927,
              -5131.5,
              3521.267
            ],
            [
              -75.729,
              -5270.057,
              3663.654
            ],
            [
              -95.037,
              -5339.84,
              3736.059
            ],
            [
              -109.429,
              -5409.977,
              3807.657
            ],
            [
              -116.661,
              -5430.732,
              3829.636
            ],
            [
              -144.967,
              -5534.861,
              3937.543
            ],
            [
              -183.275,
              -5657.733,
              4066.249
            ],
            [
              -188.212,
              -5716.645,
              4125.367
            ],
            [
              -190.648,
              -5736.736,
              4145.606
            ],
            [
              -196.91,
              -5769.923,
              4179.378
            ],
            [
              -201.665,
              -5818.819,
              4228.505
            ],
            [
              -201.086,
              -5857.793,
              4267.483
            ],
            [
              -195.599,
              -5910.215,
              4320.191
            ],
            [
              -136.015,
              -6175.138,
              4591.732
            ],
            [
              -127.679,
              -6205.529,
              4623.245
            ],
            [
              -123.468,
              -6228.802,
              4646.897
            ],
            [
              -113.557,
              -6285.758,
              4704.709
            ],
            [
              -58.166,
              -6532.794,
              4957.878
            ],
            [
              -46.468,
              -6597.576,
              5023.708
            ],
            [
              -39.377,
              -6667.839,
              5094.328
            ],
            [
              -35.045,
              -6748.072,
              5174.678
            ],
            [
              -26.235,
              -6767.677,
              5196.171
            ],
            [
              -16.413,
              -6780.218,
              5212.101
            ],
            [
              0.443,
              -6790.505,
              5231.848
            ],
            [
              316.667,
              -6965.921,
              5593.467
            ],
            [
              488.123,
              -7067.612,
              5792.812
            ],
            [
              569.198,
              -7111.985,
              5885.235
            ],
            [
              607.888,
              -7122.125,
              5925.232
            ],
            [
              857.011,
              -7088.385,
              6176.629
            ],
            [
              912.144,
              -7077.353,
              6232.855
            ],
            [
              963.953,
              -7074.956,
              6284.719
            ],
            [
              999.073,
              -7089.195,
              6322.617
            ],
            [
              1051.285,
              -7144.223,
              6398.473
            ],
            [
              1072.093,
              -7168.96,
              6430.797
            ],
            [
              1095.862,
              -7195.215,
              6466.214
            ],
            [
              1133.283,
              -7225.965,
              6514.648
            ],
            [
              1291.476,
              -7341.333,
              6710.441
            ],
            [
              1307.902,
              -7358.336,
              6734.082
            ],
            [
              1326.737,
              -7384.29,
              6766.15
            ],
            [
              1553.349,
              -7767.005,
              7210.924
            ],
            [
              1621.327,
              -7885.162,
              7347.24
            ],
            [
              1632.975,
              -7916.55,
              7380.72
            ],
            [
              1640.555,
              -7958.994,
              7423.835
            ],
            [
              1640.017,
              -8022.44,
              7487.284
            ],
            [
              1642.406,
              -8067.015,
              7531.923
            ],
            [
              1656.397,
              -8103.348,
              7570.856
            ],
            [
              1677.887,
              -8132.245,
              7606.868
            ],
            [
              1693.917,
              -8148.951,
              7630.021
            ],
            [
              1731.324,
              -8201.149,
              7694.239
            ],
            [
              1750.194,
              -8224.879,
              7724.557
            ],
            [
              1771.941,
              -8240.583,
              7751.381
            ],
            [
              1800.494,
              -8254.762,
              7783.261
            ],
            [
              1956.145,
              -8296.632,
              7944.445
            ],
            [
              2001.461,
              -8317.518,
              7994.343
            ],
            [
              2065.812,
              -8353.233,
              8067.94
            ],
            [
              2107.826,
              -8378.511,
              8116.973
            ],
            [
              2156.129,
              -8411.7,
              8175.579
            ],
            [
              2317.488,
              -8560.563,
              8395.117
            ],
            [
              2642.21,
              -8852.78,
              8831.964
            ],
            [
              2791.088,
              -8986.135,
              9031.834
            ],
            [
              2937.046,
              -9115.683,
              9226.991
            ],
            [
              2991.321,
              -9163.457,
              9299.297
            ],
            [
              3011.49,
              -9179.33,
              9324.963
            ],
            [
              3028.932,
              -9199.631,
              9351.728
            ],
            [
              3134.577,
              -9330.771,
              9520.128
            ],
            [
              3236.064,
              -9273.693,
              9636.565
            ],
            [
              3253.13,
              -9256.204,
              9661.001
            ],
            [
              3311.292,
              -9133.842,
              9796.483
            ],
            [
              3320.671,
              -9127.698,
              9807.695
            ],
            [
              3331.475,
              -9128.156,
              9818.509
            ],
            [
              3357.15,
              -9132.675,
              9844.579
            ],
            [
              3379.116,
              -9129.458,
              9866.779
            ],
            [
              3431.482,
              -9015.787,
              9991.932
            ],
            [
              3481.86,
              -8920.42,
              10099.787
            ],
            [
              3564.268,
              -8816.728,
              10232.238
            ],
            [
              3592.707,
              -8793.227,
              10269.13
            ],
            [
              3664.561,
              -8741.908,
              10357.429
            ],
            [
              3699.345,
              -8706.946,
              10406.747
            ],
            [
              3684.368,
              -8682.169,
              10435.699
            ],
            [
              3676.824,
              -8665.158,
              10454.308
            ],
            [
              3654.394,
              -8633.726,
              10492.922
            ],
            [
              3621.201,
              -8585.223,
              10551.696
            ],
            [
              3606.987,
              -8520.382,
              10618.076
            ],
            [
              3592.728,
              -8448.098,
              10691.753
            ],
            [
              3584.164,
              -8408.736,
              10732.037
            ],
            [
              3574.594,
              -8378.154,
              10764.08
            ],
            [
              3571.967,
              -8364.97,
              10777.524
            ],
            [
              3567.073,
              -8351.518,
              10791.838
            ],
            [
              3552.201,
              -8321.176,
              10825.629
            ],
            [
              3359.808,
              -8050.871,
              11157.412
            ],
            [
              3341.773,
              -8024.21,
              11189.6
            ],
            [
              3325.537,
              -8018.182,
              11206.919
            ],
            [
              3325.623,
              -8017.33,
              11207.775
            ],
            [
              3332.157,
              -8004.43,
              11222.236
            ],
            [
              3336.682,
              -8008.702,
              11228.459
            ],
            [
              3345.354,
              -8026.679,
              11248.418
            ],
            [
              3568.451,
              -8347.05,
              11638.816
            ],
            [
              3574.519,
              -8365.263,
              11658.013
            ],
            [
              3609.673,
              -8536.186,
              11832.513
            ],
            [
              3619.121,
              -8575.453,
              11872.901
            ],
            [
              3634.976,
              -8605.524,
              11906.896
            ],
            [
              3680.507,
              -8672.103,
              11987.554
            ],
            [
              3688.037,
              -8689.423,
              12006.44
            ],
            [
              3699.345,
              -8706.946,
              12027.295
            ],
            [
              3741.483,
              -8657.653,
              12092.144
            ],
            [
              3791.647,
              -8626.326,
              12151.287
            ],
            [
              3858.43,
              -8593.949,
              12225.504
            ],
            [
              3887.776,
              -8581.405,
              12257.419
            ],
            [
              3917.526,
              -8574.181,
              12288.033
            ],
            [
              3985.821,
              -8571.035,
              12356.401
            ],
            [
              4016.066,
              -8565.813,
              12387.093
            ],
            [
              4061.23,
              -8499.002,
              12467.738
            ],
            [
              4079.588,
              -8475.88,
              12497.261
            ],
            [
              4100.028,
              -8456.328,
              12525.547
            ],
            [
              4149.92,
              -8439.472,
              12578.209
            ],
            [
              4184.09,
              -8436.788,
              12612.485
            ],
            [
              4222.829,
              -8430.851,
              12651.676
            ],
            [
              4244.13,
              -8425.409,
              12673.661
            ],
            [
              4256.682,
              -8422.131,
              12686.635
            ],
            [
              4281.731,
              -8414.17,
              12712.918
            ],
            [
              4307.127,
              -8399.072,
              12742.463
            ],
            [
              4322.986,
              -8387.44,
              12762.13
            ],
            [
              4331.249,
              -8380.938,
              12772.645
            ],
            [
              4352.772,
              -8368.777,
              12797.366
            ],
            [
              4394.858,
              -8356.227,
              12841.283
            ],
            [
              4421.06,
              -8357.912,
              12867.539
            ],
            [
              4446.557,
              -8368.229,
              12895.044
            ],
            [
              4495.699,
              -8388.884,
              12948.35
            ],
            [
              4552.908,
              -8406.026,
              13008.073
            ],
            [
              4579.526,
              -8427.332,
              13042.168
            ],
            [
              4608.532,
              -8455.23,
              13082.412
            ],
            [
              4628.178,
              -8475.387,
              13110.56
            ],
            [
              4654.054,
              -8503.195,
              13148.545
            ],
            [
              4667.185,
              -8518.508,
              13168.717
            ],
            [
              4715.091,
              -8575.032,
              13242.811
            ],
            [
              4821.282,
              -8709.564,
              13414.203
            ],
            [
              4857.98,
              -8742.558,
              13463.553
            ],
            [
              4880.2,
              -8758.574,
              13490.943
            ],
            [
              4910.764,
              -8775.864,
              13526.059
            ],
            [
              5190.153,
              -8866.294,
              13819.718
            ],
            [
              5208.974,
              -8874.36,
              13840.195
            ],
            [
              5230.504,
              -8884.717,
              13864.086
            ],
            [
              5276.882,
              -8907.565,
              13915.787
            ],
            [
              5409.355,
              -8951.657,
              14055.405
            ],
            [
              5528.995,
              -9001.002,
              14184.821
            ],
            [
              5547.749,
              -9009.245,
              14205.307
            ],
            [
              5550.39,
              -9011.334,
              14208.674
            ],
            [
              5548.453,
              -9010.483,
              14210.789
            ],
            [
              5523.638,
              -9025.775,
              14239.938
            ],
            [
              5522.595,
              -9022.95,
              14242.95
            ],
            [
              5520.61,
              -9017.818,
              14248.453
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:6788",
              "position": {
                "x": 374.58,
                "z": -1783.82
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 0.673,
              "arrivalOffsetSeconds": -600,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:6845",
              "position": {
                "x": 441.836,
                "z": -2194.724
              },
              "distanceAlongShapeM": 435.512,
              "shapeOffsetM": 2.825,
              "arrivalOffsetSeconds": 60,
              "departureOffsetSeconds": 60
            },
            {
              "stopId": "judu:stop:5469",
              "position": {
                "x": 505.139,
                "z": -2574.385
              },
              "distanceAlongShapeM": 819.743,
              "shapeOffsetM": 7.714,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:19086",
              "position": {
                "x": 511.316,
                "z": -3256.915
              },
              "distanceAlongShapeM": 1503.802,
              "shapeOffsetM": 5.419,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:5848",
              "position": {
                "x": 303.678,
                "z": -3791.921
              },
              "distanceAlongShapeM": 2101.934,
              "shapeOffsetM": 1.751,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:5840",
              "position": {
                "x": 127.093,
                "z": -4040.286
              },
              "distanceAlongShapeM": 2411.705,
              "shapeOffsetM": 1.266,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:6487",
              "position": {
                "x": 54.707,
                "z": -4440.844
              },
              "distanceAlongShapeM": 2821.478,
              "shapeOffsetM": 3.804,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:6488",
              "position": {
                "x": -36.204,
                "z": -5116.037
              },
              "distanceAlongShapeM": 3504.754,
              "shapeOffsetM": 2.079,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:6491",
              "position": {
                "x": -105.993,
                "z": -5410.888
              },
              "distanceAlongShapeM": 3807.657,
              "shapeOffsetM": 3.555,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:6497",
              "position": {
                "x": -185.377,
                "z": -5737.848
              },
              "distanceAlongShapeM": 4145.721,
              "shapeOffsetM": 5.386,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:6500",
              "position": {
                "x": -122.378,
                "z": -6204.331
              },
              "distanceAlongShapeM": 4623.245,
              "shapeOffsetM": 5.434,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:16627",
              "position": {
                "x": 320.415,
                "z": -6959.406
              },
              "distanceAlongShapeM": 5593.467,
              "shapeOffsetM": 7.516,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:6797",
              "position": {
                "x": 1056.317,
                "z": -7139.934
              },
              "distanceAlongShapeM": 6398.473,
              "shapeOffsetM": 6.612,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:6800",
              "position": {
                "x": 1694.973,
                "z": -8148.149
              },
              "distanceAlongShapeM": 7630.021,
              "shapeOffsetM": 1.326,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:6803",
              "position": {
                "x": 3013.269,
                "z": -9177.069
              },
              "distanceAlongShapeM": 9324.963,
              "shapeOffsetM": 2.877,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            },
            {
              "stopId": "judu:stop:6808",
              "position": {
                "x": 3308.92,
                "z": -9131.464
              },
              "distanceAlongShapeM": 9796.483,
              "shapeOffsetM": 3.359,
              "arrivalOffsetSeconds": 1500,
              "departureOffsetSeconds": 1500
            },
            {
              "stopId": "judu:stop:6810",
              "position": {
                "x": 3562.117,
                "z": -8814.544
              },
              "distanceAlongShapeM": 10232.238,
              "shapeOffsetM": 3.065,
              "arrivalOffsetSeconds": 1560,
              "departureOffsetSeconds": 1560
            },
            {
              "stopId": "judu:stop:6814",
              "position": {
                "x": 3573.643,
                "z": -8378.361
              },
              "distanceAlongShapeM": 10764.08,
              "shapeOffsetM": 0.973,
              "arrivalOffsetSeconds": 1680,
              "departureOffsetSeconds": 1680
            },
            {
              "stopId": "judu:stop:738",
              "position": {
                "x": 3339.773,
                "z": -8015.44
              },
              "distanceAlongShapeM": 11235.871,
              "shapeOffsetM": 0.144,
              "arrivalOffsetSeconds": 1740,
              "departureOffsetSeconds": 1740
            },
            {
              "stopId": "judu:stop:1064",
              "position": {
                "x": 3556.685,
                "z": -8322.375
              },
              "distanceAlongShapeM": 11611.843,
              "shapeOffsetM": 4.446,
              "arrivalOffsetSeconds": 1800,
              "departureOffsetSeconds": 1800
            },
            {
              "stopId": "judu:stop:6816",
              "position": {
                "x": 4242.992,
                "z": -8420.106
              },
              "distanceAlongShapeM": 12673.9,
              "shapeOffsetM": 5.419,
              "arrivalOffsetSeconds": 1920,
              "departureOffsetSeconds": 1920
            },
            {
              "stopId": "judu:stop:6818",
              "position": {
                "x": 4655.998,
                "z": -8501.529
              },
              "distanceAlongShapeM": 13148.545,
              "shapeOffsetM": 2.56,
              "arrivalOffsetSeconds": 1980,
              "departureOffsetSeconds": 1980
            },
            {
              "stopId": "judu:stop:6820",
              "position": {
                "x": 5211.507,
                "z": -8868.529
              },
              "distanceAlongShapeM": 13840.195,
              "shapeOffsetM": 6.358,
              "arrivalOffsetSeconds": 2040,
              "departureOffsetSeconds": 2040
            },
            {
              "stopId": "judu:stop:1144",
              "position": {
                "x": 5527.927,
                "z": -9014.957
              },
              "distanceAlongShapeM": 14230.611,
              "shapeOffsetM": 6.96,
              "arrivalOffsetSeconds": 2100,
              "departureOffsetSeconds": 2100
            }
          ],
          "departuresSeconds": [
            43920,
            46620,
            49080,
            51480,
            52860,
            54660,
            56520,
            58380,
            60480,
            62460,
            64440,
            68040,
            71940,
            74280,
            76620,
            78960,
            81300
          ]
        },
        {
          "id": "judu:pattern:vilnius_bus_35:1",
          "sourceRouteId": "vilnius_bus_35",
          "sourceShapeId": "vilnius_bus_35_b2-a1",
          "directionId": 1,
          "headsign": "Žalgirio g.",
          "directionName": "Ožkiniai–Žalgirio g.",
          "mode": "bus",
          "routeShortName": "35",
          "routeLongName": "Žalgirio–Kalvarijų g.–Naujieji Verkiai–Ožkiniai",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              5520.61,
              -9017.818,
              0
            ],
            [
              5519.429,
              -9014.798,
              3.242
            ],
            [
              5505.197,
              -8992.248,
              29.908
            ],
            [
              5326.247,
              -8926.422,
              220.581
            ],
            [
              5182.572,
              -8866.308,
              376.325
            ],
            [
              5168.313,
              -8872.285,
              391.786
            ],
            [
              5160.604,
              -8872.519,
              399.498
            ],
            [
              5076.568,
              -8828.939,
              494.162
            ],
            [
              5012.471,
              -8809.005,
              561.288
            ],
            [
              4968.931,
              -8797.029,
              606.445
            ],
            [
              4931.204,
              -8784.053,
              646.341
            ],
            [
              4880.2,
              -8758.574,
              703.355
            ],
            [
              4856.05,
              -8742.521,
              732.353
            ],
            [
              4825.057,
              -8714.09,
              774.412
            ],
            [
              4777.893,
              -8656.401,
              848.926
            ],
            [
              4728.926,
              -8591.999,
              929.83
            ],
            [
              4682.36,
              -8536.549,
              1002.239
            ],
            [
              4628.135,
              -8477.613,
              1082.325
            ],
            [
              4600.957,
              -8451.483,
              1120.027
            ],
            [
              4586.831,
              -8437.799,
              1139.694
            ],
            [
              4567.846,
              -8420.344,
              1165.484
            ],
            [
              4546.157,
              -8405.183,
              1191.946
            ],
            [
              4510.524,
              -8392.227,
              1229.862
            ],
            [
              4492.353,
              -8387.965,
              1248.525
            ],
            [
              4467.148,
              -8379.883,
              1274.995
            ],
            [
              4439.766,
              -8365.3,
              1306.018
            ],
            [
              4420.491,
              -8357.701,
              1326.737
            ],
            [
              4405.819,
              -8355.324,
              1341.6
            ],
            [
              4381.945,
              -8358.205,
              1365.647
            ],
            [
              4345.688,
              -8370.933,
              1404.073
            ],
            [
              4332.5,
              -8379.937,
              1420.043
            ],
            [
              4322.04,
              -8388.183,
              1433.362
            ],
            [
              4307.749,
              -8400.197,
              1452.032
            ],
            [
              4285.169,
              -8414.479,
              1478.749
            ],
            [
              4240.89,
              -8428.971,
              1525.34
            ],
            [
              4219.669,
              -8433.573,
              1547.053
            ],
            [
              4195.673,
              -8437.01,
              1571.295
            ],
            [
              4153.116,
              -8440.647,
              1614.007
            ],
            [
              4134.899,
              -8444.394,
              1632.605
            ],
            [
              4115.601,
              -8449.947,
              1652.686
            ],
            [
              4092.822,
              -8462.87,
              1678.876
            ],
            [
              4075.09,
              -8480.896,
              1704.161
            ],
            [
              4049.534,
              -8518.246,
              1749.417
            ],
            [
              4035.736,
              -8545.189,
              1779.688
            ],
            [
              4019.792,
              -8563.196,
              1803.739
            ],
            [
              4006.261,
              -8569.857,
              1818.821
            ],
            [
              3907.209,
              -8575.097,
              1918.012
            ],
            [
              3890.393,
              -8579.229,
              1935.328
            ],
            [
              3862.489,
              -8590.941,
              1965.59
            ],
            [
              3754.733,
              -8645.605,
              2086.419
            ],
            [
              3743.765,
              -8657.807,
              2102.826
            ],
            [
              3728.98,
              -8671.887,
              2123.242
            ],
            [
              3679.595,
              -8729.948,
              2199.465
            ],
            [
              3635.761,
              -8764.672,
              2255.387
            ],
            [
              3590.263,
              -8795.162,
              2310.156
            ],
            [
              3552.411,
              -8834.756,
              2364.933
            ],
            [
              3546.154,
              -8842.211,
              2374.665
            ],
            [
              3495.433,
              -8902.337,
              2453.328
            ],
            [
              3482.225,
              -8919.898,
              2475.301
            ],
            [
              3437.527,
              -9002.543,
              2569.259
            ],
            [
              3395.857,
              -9095.265,
              2670.914
            ],
            [
              3389.04,
              -9118.937,
              2695.548
            ],
            [
              3385.695,
              -9124.974,
              2702.451
            ],
            [
              3381.867,
              -9129.145,
              2708.112
            ],
            [
              3367.199,
              -9135.86,
              2724.244
            ],
            [
              3346.552,
              -9141.844,
              2745.741
            ],
            [
              3336.168,
              -9145.58,
              2756.777
            ],
            [
              3286.5,
              -9183.155,
              2819.056
            ],
            [
              3262.827,
              -9237.085,
              2877.953
            ],
            [
              3255.081,
              -9255.128,
              2897.588
            ],
            [
              3242.316,
              -9272.416,
              2919.079
            ],
            [
              3134.577,
              -9330.771,
              3041.606
            ],
            [
              3021.317,
              -9193.92,
              3219.246
            ],
            [
              2970.687,
              -9148.431,
              3287.31
            ],
            [
              2956.452,
              -9138.027,
              3304.941
            ],
            [
              2944.749,
              -9124.562,
              3322.782
            ],
            [
              2590.356,
              -8808.28,
              3797.785
            ],
            [
              2140.228,
              -8401.383,
              4404.564
            ],
            [
              2107.826,
              -8378.511,
              4444.225
            ],
            [
              1978.502,
              -8305.956,
              4592.512
            ],
            [
              1955.502,
              -8296.62,
              4617.335
            ],
            [
              1919.797,
              -8287.49,
              4654.188
            ],
            [
              1794.124,
              -8252.003,
              4784.776
            ],
            [
              1773.386,
              -8241.44,
              4808.049
            ],
            [
              1750.194,
              -8224.879,
              4836.547
            ],
            [
              1684.136,
              -8142.38,
              4942.234
            ],
            [
              1655.922,
              -8101.778,
              4991.676
            ],
            [
              1643.486,
              -8078.168,
              5018.361
            ],
            [
              1639.977,
              -8059.177,
              5037.674
            ],
            [
              1639.433,
              -7950.068,
              5146.784
            ],
            [
              1629.362,
              -7903.123,
              5194.797
            ],
            [
              1545.21,
              -7754.608,
              5365.497
            ],
            [
              1341.067,
              -7410.16,
              5765.895
            ],
            [
              1312.907,
              -7366.221,
              5818.083
            ],
            [
              1291.476,
              -7341.333,
              5850.927
            ],
            [
              1145.93,
              -7238.444,
              6029.168
            ],
            [
              1102.154,
              -7203.124,
              6085.416
            ],
            [
              1045.977,
              -7141.97,
              6168.456
            ],
            [
              1029.249,
              -7124.149,
              6192.897
            ],
            [
              999.073,
              -7089.195,
              6239.075
            ],
            [
              951.943,
              -7073.438,
              6288.77
            ],
            [
              652.324,
              -7119.127,
              6591.852
            ],
            [
              622.009,
              -7121.909,
              6622.295
            ],
            [
              600.797,
              -7121.363,
              6643.514
            ],
            [
              577.752,
              -7115.358,
              6667.328
            ],
            [
              488.616,
              -7067.891,
              6768.315
            ],
            [
              60.82,
              -6823.295,
              7261.1
            ],
            [
              14.911,
              -6833.59,
              7308.149
            ],
            [
              -2.815,
              -6852.191,
              7333.844
            ],
            [
              -13.86,
              -6857.556,
              7346.123
            ],
            [
              -37.095,
              -6860.472,
              7369.54
            ],
            [
              -47.374,
              -6859.171,
              7379.901
            ],
            [
              -59.463,
              -6851.158,
              7394.404
            ],
            [
              -67.548,
              -6835.425,
              7412.093
            ],
            [
              -70.502,
              -6820.899,
              7426.917
            ],
            [
              -67.684,
              -6807.592,
              7440.519
            ],
            [
              -64.262,
              -6796.522,
              7452.106
            ],
            [
              -53.909,
              -6786.595,
              7466.449
            ],
            [
              -43.463,
              -6771.142,
              7485.102
            ],
            [
              -35.045,
              -6748.072,
              7509.659
            ],
            [
              -43.266,
              -6704.505,
              7553.995
            ],
            [
              -50.641,
              -6695.446,
              7565.676
            ],
            [
              -48.526,
              -6639.841,
              7621.322
            ],
            [
              -52.099,
              -6588.567,
              7672.72
            ],
            [
              -70.555,
              -6505.85,
              7757.471
            ],
            [
              -125.166,
              -6286.66,
              7983.362
            ],
            [
              -158.525,
              -6137.991,
              8135.727
            ],
            [
              -180.294,
              -6069.166,
              8207.913
            ],
            [
              -186.217,
              -6031.729,
              8245.816
            ],
            [
              -210.448,
              -5912.171,
              8367.804
            ],
            [
              -214.769,
              -5866.45,
              8413.729
            ],
            [
              -215.425,
              -5796.303,
              8483.879
            ],
            [
              -201.667,
              -5690.858,
              8590.218
            ],
            [
              -179.043,
              -5602.148,
              8681.768
            ],
            [
              -173.463,
              -5579.628,
              8704.969
            ],
            [
              -152.289,
              -5512.463,
              8775.392
            ],
            [
              -104.595,
              -5334.099,
              8960.023
            ],
            [
              -94.509,
              -5271.442,
              9023.486
            ],
            [
              -83.553,
              -5239.857,
              9056.917
            ],
            [
              -60.518,
              -5142.312,
              9157.145
            ],
            [
              -44.586,
              -5045.75,
              9255.013
            ],
            [
              -37.931,
              -4996.288,
              9304.92
            ],
            [
              -29.601,
              -4965.87,
              9336.458
            ],
            [
              29.378,
              -4628.52,
              9678.925
            ],
            [
              28.501,
              -4570.615,
              9736.837
            ],
            [
              22.071,
              -4499.251,
              9808.49
            ],
            [
              25.378,
              -4459.234,
              9848.643
            ],
            [
              39.56,
              -4363.958,
              9944.969
            ],
            [
              46.147,
              -4344.95,
              9965.086
            ],
            [
              48.454,
              -4310.97,
              9999.144
            ],
            [
              52.989,
              -4285.429,
              10025.085
            ],
            [
              60.111,
              -4250.579,
              10060.655
            ],
            [
              104.143,
              -4062.131,
              10254.179
            ],
            [
              127.703,
              -3998.463,
              10322.067
            ],
            [
              151.352,
              -3953.466,
              10372.899
            ],
            [
              179.07,
              -3910.986,
              10423.623
            ],
            [
              264.038,
              -3810.121,
              10555.506
            ],
            [
              345.157,
              -3743.697,
              10660.351
            ],
            [
              387.493,
              -3689.441,
              10729.17
            ],
            [
              434.283,
              -3627.326,
              10806.936
            ],
            [
              450.253,
              -3599.787,
              10838.771
            ],
            [
              463.769,
              -3565.524,
              10875.603
            ],
            [
              474.065,
              -3531.203,
              10911.435
            ],
            [
              484.063,
              -3477.95,
              10965.619
            ],
            [
              490.334,
              -3345.62,
              11098.097
            ],
            [
              488.575,
              -3319.869,
              11123.908
            ],
            [
              479.687,
              -3259.675,
              11184.755
            ],
            [
              477.905,
              -3216.226,
              11228.241
            ],
            [
              481.339,
              -3169.533,
              11275.06
            ],
            [
              500.602,
              -3103.091,
              11344.238
            ],
            [
              504.082,
              -3078.362,
              11369.211
            ],
            [
              504.445,
              -3034.141,
              11413.433
            ],
            [
              503.491,
              -2980.688,
              11466.894
            ],
            [
              505.751,
              -2962.917,
              11484.809
            ],
            [
              504.844,
              -2912.819,
              11534.915
            ],
            [
              509.397,
              -2869.472,
              11578.5
            ],
            [
              513.301,
              -2797.183,
              11650.895
            ],
            [
              494.515,
              -2626.513,
              11822.595
            ],
            [
              487.991,
              -2601.316,
              11848.623
            ],
            [
              485.911,
              -2568.466,
              11881.539
            ],
            [
              462.343,
              -2342.047,
              12109.181
            ],
            [
              451.425,
              -2269.486,
              12182.559
            ],
            [
              407.333,
              -2116.119,
              12342.138
            ],
            [
              406.254,
              -2096.107,
              12362.18
            ],
            [
              361.405,
              -1904.922,
              12558.555
            ],
            [
              342.249,
              -1718.661,
              12745.798
            ],
            [
              384.201,
              -1716.089,
              12787.829
            ],
            [
              395.76,
              -1718.527,
              12799.642
            ],
            [
              397.612,
              -1723.014,
              12804.496
            ],
            [
              396.067,
              -1765.998,
              12847.508
            ],
            [
              394.421,
              -1775.729,
              12857.377
            ],
            [
              394.599,
              -1781.96,
              12863.611
            ],
            [
              371.898,
              -1783.286,
              12886.35
            ],
            [
              374.545,
              -1783.148,
              12889
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:1144",
              "position": {
                "x": 5527.927,
                "z": -9014.957
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 7.857,
              "arrivalOffsetSeconds": -480,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:6821",
              "position": {
                "x": 5122.326,
                "z": -8853.439
              },
              "distanceAlongShapeM": 442.263,
              "shapeOffsetM": 0.684,
              "arrivalOffsetSeconds": 60,
              "departureOffsetSeconds": 60
            },
            {
              "stopId": "judu:stop:6819",
              "position": {
                "x": 4583.775,
                "z": -8441.133
              },
              "distanceAlongShapeM": 1139.569,
              "shapeOffsetM": 4.521,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:6817",
              "position": {
                "x": 4220.749,
                "z": -8438.604
              },
              "distanceAlongShapeM": 1547.053,
              "shapeOffsetM": 5.146,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:6811",
              "position": {
                "x": 3548.675,
                "z": -8844.347
              },
              "distanceAlongShapeM": 2374.673,
              "shapeOffsetM": 3.304,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:6809",
              "position": {
                "x": 3346.691,
                "z": -9142.201
              },
              "distanceAlongShapeM": 2745.706,
              "shapeOffsetM": 0.381,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:6804",
              "position": {
                "x": 2953.441,
                "z": -9141.425
              },
              "distanceAlongShapeM": 3304.941,
              "shapeOffsetM": 4.54,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:6801",
              "position": {
                "x": 1918.925,
                "z": -8290.37
              },
              "distanceAlongShapeM": 4654.245,
              "shapeOffsetM": 3.008,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:6798",
              "position": {
                "x": 1026.954,
                "z": -7126.033
              },
              "distanceAlongShapeM": 6192.971,
              "shapeOffsetM": 2.968,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:16628",
              "position": {
                "x": 229.7,
                "z": -6919.895
              },
              "distanceAlongShapeM": 7066.544,
              "shapeOffsetM": 0.036,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:6503",
              "position": {
                "x": -50.829,
                "z": -6695.462
              },
              "distanceAlongShapeM": 7565.676,
              "shapeOffsetM": 0.189,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:6501",
              "position": {
                "x": -182.398,
                "z": -6069.649
              },
              "distanceAlongShapeM": 8207.913,
              "shapeOffsetM": 2.159,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:6494",
              "position": {
                "x": -176.685,
                "z": -5578.813
              },
              "distanceAlongShapeM": 8704.969,
              "shapeOffsetM": 3.324,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:6492",
              "position": {
                "x": -97,
                "z": -5270.783
              },
              "distanceAlongShapeM": 9023.486,
              "shapeOffsetM": 2.577,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:6489",
              "position": {
                "x": -41.097,
                "z": -4995.718
              },
              "distanceAlongShapeM": 9304.92,
              "shapeOffsetM": 3.217,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:5836",
              "position": {
                "x": 49.82,
                "z": -4284.902
              },
              "distanceAlongShapeM": 10025.05,
              "shapeOffsetM": 3.212,
              "arrivalOffsetSeconds": 1380,
              "departureOffsetSeconds": 1380
            },
            {
              "stopId": "judu:stop:5839",
              "position": {
                "x": 148.043,
                "z": -3951.609
              },
              "distanceAlongShapeM": 10372.899,
              "shapeOffsetM": 3.794,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            },
            {
              "stopId": "judu:stop:5846",
              "position": {
                "x": 383.579,
                "z": -3686.512
              },
              "distanceAlongShapeM": 10729.071,
              "shapeOffsetM": 4.888,
              "arrivalOffsetSeconds": 1500,
              "departureOffsetSeconds": 1500
            },
            {
              "stopId": "judu:stop:5481",
              "position": {
                "x": 502.159,
                "z": -2912.756
              },
              "distanceAlongShapeM": 11534.915,
              "shapeOffsetM": 2.686,
              "arrivalOffsetSeconds": 1680,
              "departureOffsetSeconds": 1680
            },
            {
              "stopId": "judu:stop:5347",
              "position": {
                "x": 482.722,
                "z": -2601.805
              },
              "distanceAlongShapeM": 11848.623,
              "shapeOffsetM": 5.291,
              "arrivalOffsetSeconds": 1740,
              "departureOffsetSeconds": 1740
            },
            {
              "stopId": "judu:stop:5351",
              "position": {
                "x": 407.176,
                "z": -2116.162
              },
              "distanceAlongShapeM": 12342.138,
              "shapeOffsetM": 0.163,
              "arrivalOffsetSeconds": 1800,
              "departureOffsetSeconds": 1800
            },
            {
              "stopId": "judu:stop:6788",
              "position": {
                "x": 374.58,
                "z": -1783.82
              },
              "distanceAlongShapeM": 12889,
              "shapeOffsetM": 0.673,
              "arrivalOffsetSeconds": 1980,
              "departureOffsetSeconds": 1980
            }
          ],
          "departuresSeconds": [
            46440,
            49260,
            52080,
            53940,
            55800,
            57600,
            59400,
            61200,
            63240,
            65280,
            67320,
            70620,
            74340,
            76620,
            78960,
            81300,
            83640
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_bus_36",
      "sourceRouteId": "vilnius_bus_36",
      "mode": "bus",
      "shortName": "36",
      "longName": "Žalgirio–Kalvarijų g.–Balsiai–Naujaneriai–Pagubė",
      "color": "0073AC",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_bus_36:0",
          "sourceRouteId": "vilnius_bus_36",
          "sourceShapeId": "vilnius_bus_36_a-b",
          "directionId": 0,
          "headsign": "Pagubė",
          "directionName": "Žalgirio–Kalvarijų g.–Balsiai–Naujaneriai–Pagubė",
          "mode": "bus",
          "routeShortName": "36",
          "routeLongName": "Žalgirio–Kalvarijų g.–Balsiai–Naujaneriai–Pagubė",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              374.545,
              -1783.148,
              0
            ],
            [
              362.91,
              -1783.757,
              11.651
            ],
            [
              354.358,
              -1796.809,
              27.255
            ],
            [
              355.721,
              -1828.005,
              58.481
            ],
            [
              364.892,
              -1890.514,
              121.659
            ],
            [
              374.87,
              -1944.132,
              176.198
            ],
            [
              407.808,
              -2081.663,
              317.618
            ],
            [
              428.936,
              -2159.977,
              398.732
            ],
            [
              439.077,
              -2195.331,
              435.512
            ],
            [
              440.947,
              -2208.066,
              448.383
            ],
            [
              462.343,
              -2342.047,
              584.062
            ],
            [
              497.458,
              -2575.098,
              819.743
            ],
            [
              511.756,
              -2776.003,
              1021.157
            ],
            [
              513.301,
              -2797.183,
              1042.393
            ],
            [
              524.563,
              -2850.825,
              1097.204
            ],
            [
              523.952,
              -2902.017,
              1148.4
            ],
            [
              518.333,
              -3049.981,
              1296.471
            ],
            [
              511.327,
              -3110.973,
              1357.864
            ],
            [
              506.062,
              -3253.474,
              1500.462
            ],
            [
              505.902,
              -3256.64,
              1503.632
            ],
            [
              503.774,
              -3366.969,
              1613.982
            ],
            [
              489.873,
              -3512.567,
              1760.241
            ],
            [
              474.056,
              -3566.826,
              1816.759
            ],
            [
              440.465,
              -3641.474,
              1898.616
            ],
            [
              383.151,
              -3709.882,
              1987.861
            ],
            [
              302.538,
              -3790.592,
              2101.934
            ],
            [
              278.895,
              -3808.166,
              2131.393
            ],
            [
              228.358,
              -3858.451,
              2202.685
            ],
            [
              158.106,
              -3965.152,
              2330.436
            ],
            [
              125.932,
              -4039.781,
              2411.705
            ],
            [
              102.95,
              -4092.167,
              2468.911
            ],
            [
              79.561,
              -4208.631,
              2587.7
            ],
            [
              75.006,
              -4246.398,
              2625.741
            ],
            [
              72.804,
              -4296.453,
              2675.844
            ],
            [
              57.959,
              -4368.543,
              2749.447
            ],
            [
              50.952,
              -4440.233,
              2821.478
            ],
            [
              47.442,
              -4461.8,
              2843.329
            ],
            [
              42.119,
              -4495.164,
              2877.115
            ],
            [
              45.832,
              -4598.763,
              2980.781
            ],
            [
              43.273,
              -4641.013,
              3023.109
            ],
            [
              -32.111,
              -5068.242,
              3456.937
            ],
            [
              -38.249,
              -5115.663,
              3504.754
            ],
            [
              -42.927,
              -5131.5,
              3521.267
            ],
            [
              -75.729,
              -5270.057,
              3663.654
            ],
            [
              -95.037,
              -5339.84,
              3736.059
            ],
            [
              -109.429,
              -5409.977,
              3807.657
            ],
            [
              -116.661,
              -5430.732,
              3829.636
            ],
            [
              -144.967,
              -5534.861,
              3937.543
            ],
            [
              -183.275,
              -5657.733,
              4066.249
            ],
            [
              -188.212,
              -5716.645,
              4125.367
            ],
            [
              -190.648,
              -5736.736,
              4145.606
            ],
            [
              -196.91,
              -5769.923,
              4179.378
            ],
            [
              -201.665,
              -5818.819,
              4228.505
            ],
            [
              -201.086,
              -5857.793,
              4267.483
            ],
            [
              -195.599,
              -5910.215,
              4320.191
            ],
            [
              -136.015,
              -6175.138,
              4591.732
            ],
            [
              -127.679,
              -6205.529,
              4623.245
            ],
            [
              -123.468,
              -6228.802,
              4646.897
            ],
            [
              -113.557,
              -6285.758,
              4704.709
            ],
            [
              -58.166,
              -6532.794,
              4957.878
            ],
            [
              -46.468,
              -6597.576,
              5023.708
            ],
            [
              -39.377,
              -6667.839,
              5094.328
            ],
            [
              -35.045,
              -6748.072,
              5174.678
            ],
            [
              -26.235,
              -6767.677,
              5196.171
            ],
            [
              -16.413,
              -6780.218,
              5212.101
            ],
            [
              0.443,
              -6790.505,
              5231.848
            ],
            [
              316.667,
              -6965.921,
              5593.467
            ],
            [
              488.123,
              -7067.612,
              5792.812
            ],
            [
              569.198,
              -7111.985,
              5885.235
            ],
            [
              607.888,
              -7122.125,
              5925.232
            ],
            [
              857.011,
              -7088.385,
              6176.629
            ],
            [
              912.144,
              -7077.353,
              6232.855
            ],
            [
              963.953,
              -7074.956,
              6284.719
            ],
            [
              999.073,
              -7089.195,
              6322.617
            ],
            [
              1051.285,
              -7144.223,
              6398.473
            ],
            [
              1072.093,
              -7168.96,
              6430.797
            ],
            [
              1095.862,
              -7195.215,
              6466.214
            ],
            [
              1133.283,
              -7225.965,
              6514.648
            ],
            [
              1291.476,
              -7341.333,
              6710.441
            ],
            [
              1307.902,
              -7358.336,
              6734.082
            ],
            [
              1326.737,
              -7384.29,
              6766.15
            ],
            [
              1553.349,
              -7767.005,
              7210.924
            ],
            [
              1621.327,
              -7885.162,
              7347.24
            ],
            [
              1632.975,
              -7916.55,
              7380.72
            ],
            [
              1640.555,
              -7958.994,
              7423.835
            ],
            [
              1640.017,
              -8022.44,
              7487.284
            ],
            [
              1642.406,
              -8067.015,
              7531.923
            ],
            [
              1656.397,
              -8103.348,
              7570.856
            ],
            [
              1677.887,
              -8132.245,
              7606.868
            ],
            [
              1693.917,
              -8148.951,
              7630.021
            ],
            [
              1731.324,
              -8201.149,
              7694.239
            ],
            [
              1750.194,
              -8224.879,
              7724.557
            ],
            [
              1771.941,
              -8240.583,
              7751.381
            ],
            [
              1800.494,
              -8254.762,
              7783.261
            ],
            [
              1956.145,
              -8296.632,
              7944.445
            ],
            [
              2001.461,
              -8317.518,
              7994.343
            ],
            [
              2065.812,
              -8353.233,
              8067.94
            ],
            [
              2107.826,
              -8378.511,
              8116.973
            ],
            [
              2156.129,
              -8411.7,
              8175.579
            ],
            [
              2317.488,
              -8560.563,
              8395.117
            ],
            [
              2642.21,
              -8852.78,
              8831.964
            ],
            [
              2791.088,
              -8986.135,
              9031.834
            ],
            [
              2937.046,
              -9115.683,
              9226.991
            ],
            [
              2991.321,
              -9163.457,
              9299.297
            ],
            [
              3011.49,
              -9179.33,
              9324.963
            ],
            [
              3028.932,
              -9199.631,
              9351.728
            ],
            [
              3134.104,
              -9331.147,
              9520.125
            ],
            [
              3165.86,
              -9378.122,
              9576.827
            ],
            [
              3173.134,
              -9395.181,
              9595.373
            ],
            [
              3208.182,
              -9555.935,
              9759.903
            ],
            [
              3213.698,
              -9570.512,
              9775.488
            ],
            [
              3220.466,
              -9581.843,
              9788.687
            ],
            [
              3233.82,
              -9595.386,
              9807.706
            ],
            [
              3263.762,
              -9611.54,
              9841.728
            ],
            [
              3404.645,
              -9675.718,
              9996.54
            ],
            [
              3447.994,
              -9704.103,
              10048.356
            ],
            [
              3478.945,
              -9734.751,
              10091.913
            ],
            [
              3511.635,
              -9775.451,
              10144.116
            ],
            [
              3546.778,
              -9856.276,
              10232.251
            ],
            [
              3563.744,
              -9877.752,
              10259.62
            ],
            [
              3583.678,
              -9891.979,
              10284.11
            ],
            [
              3682.485,
              -9978.543,
              10415.472
            ],
            [
              3753.117,
              -10037.223,
              10507.3
            ],
            [
              3823.892,
              -10096.649,
              10599.715
            ],
            [
              3844.831,
              -10118.191,
              10629.756
            ],
            [
              3950.897,
              -10331.098,
              10867.621
            ],
            [
              3964.952,
              -10358.175,
              10898.128
            ],
            [
              4131.599,
              -10684.624,
              11264.652
            ],
            [
              4230.809,
              -10878.453,
              11482.396
            ],
            [
              4254.712,
              -10926.321,
              11535.901
            ],
            [
              4258.787,
              -10929.768,
              11541.238
            ],
            [
              4272.763,
              -10924.442,
              11556.194
            ],
            [
              4279.173,
              -10925.678,
              11562.722
            ],
            [
              4289.722,
              -10945.92,
              11585.548
            ],
            [
              4292.144,
              -10953.759,
              11593.753
            ],
            [
              4288.425,
              -10964.564,
              11605.18
            ],
            [
              4278.53,
              -10972.614,
              11617.936
            ],
            [
              4430.258,
              -11265.092,
              11947.427
            ],
            [
              4428.478,
              -11261.671,
              11951.283
            ],
            [
              4505.917,
              -11412.438,
              12120.775
            ],
            [
              4520.389,
              -11456.081,
              12166.754
            ],
            [
              4522.05,
              -11479.25,
              12189.983
            ],
            [
              4511.95,
              -11539.696,
              12251.267
            ],
            [
              4490.708,
              -11638.294,
              12352.127
            ],
            [
              4485.489,
              -11662.153,
              12376.55
            ],
            [
              4461.301,
              -11768.634,
              12485.744
            ],
            [
              4428.456,
              -11927.165,
              12647.642
            ],
            [
              4401.77,
              -12054.136,
              12777.387
            ],
            [
              4294.404,
              -12542.458,
              13277.373
            ],
            [
              4281.58,
              -12608.954,
              13345.094
            ],
            [
              4283.669,
              -12632.427,
              13368.66
            ],
            [
              4287.952,
              -12642.541,
              13379.643
            ],
            [
              4315.183,
              -12687.635,
              13432.321
            ],
            [
              4318.714,
              -12695.257,
              13440.721
            ],
            [
              4315.194,
              -12698.717,
              13445.657
            ],
            [
              4303.532,
              -12697.415,
              13457.392
            ],
            [
              4266.282,
              -12693.945,
              13494.803
            ],
            [
              4245.373,
              -12688.354,
              13516.446
            ],
            [
              4230.109,
              -12687.139,
              13531.759
            ],
            [
              4221.712,
              -12680.642,
              13542.376
            ],
            [
              4210.448,
              -12666.133,
              13560.744
            ],
            [
              4191.957,
              -12640.414,
              13592.421
            ],
            [
              4183.797,
              -12638.21,
              13600.872
            ],
            [
              4172.181,
              -12644.813,
              13614.234
            ],
            [
              4135.313,
              -12658.045,
              13653.405
            ],
            [
              4112.642,
              -12655.931,
              13676.174
            ],
            [
              3804.962,
              -12592.31,
              13990.363
            ],
            [
              3508.49,
              -12519.29,
              14295.695
            ],
            [
              3445.773,
              -12503.788,
              14360.299
            ],
            [
              3347.961,
              -12482.788,
              14460.34
            ],
            [
              3327.491,
              -12480.634,
              14480.923
            ],
            [
              3104.605,
              -12787.154,
              14859.913
            ],
            [
              3088.168,
              -12816.573,
              14893.612
            ],
            [
              3078.426,
              -12839.591,
              14918.607
            ],
            [
              3045.608,
              -12909.414,
              14995.758
            ],
            [
              3013.589,
              -12980.414,
              15073.644
            ],
            [
              2975.61,
              -13068.357,
              15169.437
            ],
            [
              2927.996,
              -13174.635,
              15285.893
            ],
            [
              2895.975,
              -13168.831,
              15318.436
            ],
            [
              2885.018,
              -13163.727,
              15330.524
            ],
            [
              2731.33,
              -13131.645,
              15487.524
            ],
            [
              2573.884,
              -13091.936,
              15649.901
            ],
            [
              2529.653,
              -13084.423,
              15694.765
            ],
            [
              2498.839,
              -13081.615,
              15725.707
            ],
            [
              2418.043,
              -13103.473,
              15809.407
            ],
            [
              2389.872,
              -13115.555,
              15840.06
            ],
            [
              2353.983,
              -13124.533,
              15877.055
            ],
            [
              2309.167,
              -13141.263,
              15924.892
            ],
            [
              2241.642,
              -13182.538,
              16004.032
            ],
            [
              2197.303,
              -13215.104,
              16059.046
            ],
            [
              2159.559,
              -13238.887,
              16103.658
            ],
            [
              2125.632,
              -13264.969,
              16146.452
            ],
            [
              2055.703,
              -13324.888,
              16238.541
            ],
            [
              2012.342,
              -13372.37,
              16302.842
            ],
            [
              2001.495,
              -13378.761,
              16315.432
            ],
            [
              1996.634,
              -13374.957,
              16321.605
            ],
            [
              1996.316,
              -13370.509,
              16326.064
            ],
            [
              1998.223,
              -13360.031,
              16336.714
            ],
            [
              2011.643,
              -13348.731,
              16354.257
            ],
            [
              2019.879,
              -13345.04,
              16363.282
            ],
            [
              2017.858,
              -13346.071,
              16365.551
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:6788",
              "position": {
                "x": 374.58,
                "z": -1783.82
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 0.673,
              "arrivalOffsetSeconds": -360,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:6845",
              "position": {
                "x": 441.836,
                "z": -2194.724
              },
              "distanceAlongShapeM": 435.512,
              "shapeOffsetM": 2.825,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:5469",
              "position": {
                "x": 505.139,
                "z": -2574.385
              },
              "distanceAlongShapeM": 819.743,
              "shapeOffsetM": 7.714,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:19086",
              "position": {
                "x": 511.316,
                "z": -3256.915
              },
              "distanceAlongShapeM": 1503.802,
              "shapeOffsetM": 5.419,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:5848",
              "position": {
                "x": 303.678,
                "z": -3791.921
              },
              "distanceAlongShapeM": 2101.934,
              "shapeOffsetM": 1.751,
              "arrivalOffsetSeconds": 510,
              "departureOffsetSeconds": 510
            },
            {
              "stopId": "judu:stop:5840",
              "position": {
                "x": 127.093,
                "z": -4040.286
              },
              "distanceAlongShapeM": 2411.705,
              "shapeOffsetM": 1.266,
              "arrivalOffsetSeconds": 570,
              "departureOffsetSeconds": 570
            },
            {
              "stopId": "judu:stop:6487",
              "position": {
                "x": 54.707,
                "z": -4440.844
              },
              "distanceAlongShapeM": 2821.478,
              "shapeOffsetM": 3.804,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:6488",
              "position": {
                "x": -36.204,
                "z": -5116.037
              },
              "distanceAlongShapeM": 3504.754,
              "shapeOffsetM": 2.079,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:6491",
              "position": {
                "x": -105.993,
                "z": -5410.888
              },
              "distanceAlongShapeM": 3807.657,
              "shapeOffsetM": 3.555,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:6497",
              "position": {
                "x": -185.377,
                "z": -5737.848
              },
              "distanceAlongShapeM": 4145.721,
              "shapeOffsetM": 5.386,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:6500",
              "position": {
                "x": -122.378,
                "z": -6204.331
              },
              "distanceAlongShapeM": 4623.245,
              "shapeOffsetM": 5.434,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            },
            {
              "stopId": "judu:stop:16627",
              "position": {
                "x": 320.415,
                "z": -6959.406
              },
              "distanceAlongShapeM": 5593.467,
              "shapeOffsetM": 7.516,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:6797",
              "position": {
                "x": 1056.317,
                "z": -7139.934
              },
              "distanceAlongShapeM": 6398.473,
              "shapeOffsetM": 6.612,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:6800",
              "position": {
                "x": 1694.973,
                "z": -8148.149
              },
              "distanceAlongShapeM": 7630.021,
              "shapeOffsetM": 1.326,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            },
            {
              "stopId": "judu:stop:6803",
              "position": {
                "x": 3013.269,
                "z": -9177.069
              },
              "distanceAlongShapeM": 9324.963,
              "shapeOffsetM": 2.877,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            },
            {
              "stopId": "judu:stop:6856",
              "position": {
                "x": 3684.789,
                "z": -9975.801
              },
              "distanceAlongShapeM": 10415.399,
              "shapeOffsetM": 3.581,
              "arrivalOffsetSeconds": 1560,
              "departureOffsetSeconds": 1560
            },
            {
              "stopId": "judu:stop:10554",
              "position": {
                "x": 3850.114,
                "z": -10113.666
              },
              "distanceAlongShapeM": 10629.756,
              "shapeOffsetM": 6.956,
              "arrivalOffsetSeconds": 1620,
              "departureOffsetSeconds": 1620
            },
            {
              "stopId": "judu:stop:6860",
              "position": {
                "x": 3968.377,
                "z": -10356.396
              },
              "distanceAlongShapeM": 10898.127,
              "shapeOffsetM": 3.86,
              "arrivalOffsetSeconds": 1680,
              "departureOffsetSeconds": 1680
            },
            {
              "stopId": "judu:stop:8315",
              "position": {
                "x": 4289.98,
                "z": -10965.964
              },
              "distanceAlongShapeM": 11605.18,
              "shapeOffsetM": 2.092,
              "arrivalOffsetSeconds": 1800,
              "departureOffsetSeconds": 1800
            },
            {
              "stopId": "judu:stop:8004",
              "position": {
                "x": 4493.832,
                "z": -11638.971
              },
              "distanceAlongShapeM": 12352.127,
              "shapeOffsetM": 3.197,
              "arrivalOffsetSeconds": 1920,
              "departureOffsetSeconds": 1920
            },
            {
              "stopId": "judu:stop:8005",
              "position": {
                "x": 4404.772,
                "z": -12054.736
              },
              "distanceAlongShapeM": 12777.356,
              "shapeOffsetM": 3.061,
              "arrivalOffsetSeconds": 1980,
              "departureOffsetSeconds": 1980
            },
            {
              "stopId": "judu:stop:8006",
              "position": {
                "x": 4295.286,
                "z": -12697.221
              },
              "distanceAlongShapeM": 13465.62,
              "shapeOffsetM": 0.572,
              "arrivalOffsetSeconds": 2070,
              "departureOffsetSeconds": 2070
            },
            {
              "stopId": "judu:stop:10552",
              "position": {
                "x": 3803.923,
                "z": -12596.508
              },
              "distanceAlongShapeM": 13990.368,
              "shapeOffsetM": 4.325,
              "arrivalOffsetSeconds": 2190,
              "departureOffsetSeconds": 2190
            },
            {
              "stopId": "judu:stop:8008",
              "position": {
                "x": 3507.545,
                "z": -12522.939
              },
              "distanceAlongShapeM": 14295.737,
              "shapeOffsetM": 3.77,
              "arrivalOffsetSeconds": 2250,
              "departureOffsetSeconds": 2250
            },
            {
              "stopId": "judu:stop:8009",
              "position": {
                "x": 3081.528,
                "z": -12841.03
              },
              "distanceAlongShapeM": 14918.607,
              "shapeOffsetM": 3.419,
              "arrivalOffsetSeconds": 2370,
              "departureOffsetSeconds": 2370
            },
            {
              "stopId": "judu:stop:8363",
              "position": {
                "x": 2895.887,
                "z": -13169.269
              },
              "distanceAlongShapeM": 15318.436,
              "shapeOffsetM": 0.446,
              "arrivalOffsetSeconds": 2430,
              "departureOffsetSeconds": 2430
            },
            {
              "stopId": "judu:stop:8012",
              "position": {
                "x": 2390.75,
                "z": -13118.545
              },
              "distanceAlongShapeM": 15840.06,
              "shapeOffsetM": 3.116,
              "arrivalOffsetSeconds": 2490,
              "departureOffsetSeconds": 2490
            },
            {
              "stopId": "judu:stop:8011",
              "position": {
                "x": 2018.624,
                "z": -13347.572
              },
              "distanceAlongShapeM": 16365.551,
              "shapeOffsetM": 1.685,
              "arrivalOffsetSeconds": 2550,
              "departureOffsetSeconds": 2550
            }
          ],
          "departuresSeconds": [
            19800,
            20880,
            22020,
            23400,
            24960,
            26160,
            28260,
            31500,
            32400,
            33480,
            36180,
            37260,
            38280,
            39300,
            40320,
            41220,
            42300,
            43200,
            44100,
            45060,
            46080,
            47100,
            48120,
            49440,
            50760,
            52200,
            54060,
            54780,
            55380,
            55980,
            56820,
            57660,
            58800,
            60120,
            61200,
            62340,
            63420,
            64560,
            66360,
            67860,
            69120,
            69840,
            70860,
            72540,
            74580,
            75900,
            77280,
            78780,
            80220,
            81600
          ]
        },
        {
          "id": "judu:pattern:vilnius_bus_36:1",
          "sourceRouteId": "vilnius_bus_36",
          "sourceShapeId": "vilnius_bus_36_b-a",
          "directionId": 1,
          "headsign": "Žalgirio g.",
          "directionName": "Pagubė–Naujaneriai–Balsiai–Kalvarijų–Žalgirio g.",
          "mode": "bus",
          "routeShortName": "36",
          "routeLongName": "Žalgirio–Kalvarijų g.–Balsiai–Naujaneriai–Pagubė",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              2017.858,
              -13346.071,
              0
            ],
            [
              2051.984,
              -13326.762,
              39.211
            ],
            [
              2126.959,
              -13262.768,
              137.783
            ],
            [
              2212.276,
              -13205.365,
              240.613
            ],
            [
              2263.128,
              -13168.469,
              303.44
            ],
            [
              2313.98,
              -13136.249,
              363.641
            ],
            [
              2386.334,
              -13114.009,
              439.335
            ],
            [
              2419.118,
              -13102.235,
              474.169
            ],
            [
              2473.705,
              -13084.482,
              531.571
            ],
            [
              2519.357,
              -13081.033,
              577.353
            ],
            [
              2533.441,
              -13082.364,
              591.5
            ],
            [
              2578.853,
              -13091.667,
              637.855
            ],
            [
              2628.295,
              -13105.208,
              689.117
            ],
            [
              2927.996,
              -13174.635,
              996.755
            ],
            [
              3093.974,
              -12804.056,
              1402.806
            ],
            [
              3103.184,
              -12789.293,
              1420.206
            ],
            [
              3181.127,
              -12681.111,
              1553.541
            ],
            [
              3223.253,
              -12619.485,
              1628.19
            ],
            [
              3249.211,
              -12579.253,
              1676.069
            ],
            [
              3292.751,
              -12522.008,
              1747.991
            ],
            [
              3314.158,
              -12494.871,
              1782.555
            ],
            [
              3325.61,
              -12480.559,
              1800.885
            ],
            [
              3351.885,
              -12483.289,
              1827.301
            ],
            [
              3457.661,
              -12505.485,
              1935.381
            ],
            [
              3764.574,
              -12581.452,
              2251.556
            ],
            [
              4112.642,
              -12655.931,
              2607.503
            ],
            [
              4128.878,
              -12657.2,
              2623.789
            ],
            [
              4153.045,
              -12653.796,
              2648.194
            ],
            [
              4185.354,
              -12636.396,
              2684.891
            ],
            [
              4190.961,
              -12637.325,
              2690.575
            ],
            [
              4219.012,
              -12675.834,
              2738.217
            ],
            [
              4225.367,
              -12683.033,
              2747.819
            ],
            [
              4234.678,
              -12687.693,
              2758.232
            ],
            [
              4250.357,
              -12687.839,
              2773.911
            ],
            [
              4258.816,
              -12687.218,
              2782.393
            ],
            [
              4272.356,
              -12672.821,
              2802.156
            ],
            [
              4333.648,
              -12356.237,
              3124.619
            ],
            [
              4384.004,
              -12131.153,
              3355.267
            ],
            [
              4416.375,
              -11975.39,
              3514.359
            ],
            [
              4488.674,
              -11647.682,
              3849.947
            ],
            [
              4501.985,
              -11574.76,
              3924.075
            ],
            [
              4520.672,
              -11481.402,
              4019.284
            ],
            [
              4515.699,
              -11439.001,
              4061.976
            ],
            [
              4355.404,
              -11119.987,
              4418.997
            ],
            [
              4228.911,
              -10878.804,
              4691.338
            ],
            [
              3950.897,
              -10331.098,
              5305.564
            ],
            [
              3933.283,
              -10299.209,
              5341.994
            ],
            [
              3858.592,
              -10138.8,
              5518.941
            ],
            [
              3836.085,
              -10112.757,
              5553.361
            ],
            [
              3633.404,
              -9936.97,
              5821.654
            ],
            [
              3615.583,
              -9923.348,
              5844.085
            ],
            [
              3583.925,
              -9891.609,
              5888.913
            ],
            [
              3560.012,
              -9871.001,
              5920.481
            ],
            [
              3541.801,
              -9847.275,
              5950.39
            ],
            [
              3514.661,
              -9785.528,
              6017.838
            ],
            [
              3500.953,
              -9761.888,
              6045.165
            ],
            [
              3482.098,
              -9738.151,
              6075.479
            ],
            [
              3456.873,
              -9710.952,
              6112.575
            ],
            [
              3423.2,
              -9688.046,
              6153.3
            ],
            [
              3388.156,
              -9669.567,
              6192.918
            ],
            [
              3277.145,
              -9618.474,
              6315.123
            ],
            [
              3228.737,
              -9591.949,
              6370.321
            ],
            [
              3213.634,
              -9573.85,
              6393.894
            ],
            [
              3206.315,
              -9552.559,
              6416.408
            ],
            [
              3171.376,
              -9392.699,
              6580.042
            ],
            [
              3164.552,
              -9379.21,
              6595.158
            ],
            [
              3134.104,
              -9331.147,
              6652.055
            ],
            [
              3021.317,
              -9193.92,
              6829.684
            ],
            [
              2970.687,
              -9148.431,
              6897.747
            ],
            [
              2956.452,
              -9138.027,
              6915.378
            ],
            [
              2944.749,
              -9124.562,
              6933.219
            ],
            [
              2590.356,
              -8808.28,
              7408.223
            ],
            [
              2140.228,
              -8401.383,
              8015.002
            ],
            [
              2107.826,
              -8378.511,
              8054.663
            ],
            [
              1978.502,
              -8305.956,
              8202.949
            ],
            [
              1955.502,
              -8296.62,
              8227.772
            ],
            [
              1919.797,
              -8287.49,
              8264.626
            ],
            [
              1794.124,
              -8252.003,
              8395.213
            ],
            [
              1773.386,
              -8241.44,
              8418.487
            ],
            [
              1750.194,
              -8224.879,
              8446.984
            ],
            [
              1684.136,
              -8142.38,
              8552.671
            ],
            [
              1655.922,
              -8101.778,
              8602.114
            ],
            [
              1643.486,
              -8078.168,
              8628.799
            ],
            [
              1639.977,
              -8059.177,
              8648.111
            ],
            [
              1639.433,
              -7950.068,
              8757.221
            ],
            [
              1629.362,
              -7903.123,
              8805.235
            ],
            [
              1545.21,
              -7754.608,
              8975.934
            ],
            [
              1341.067,
              -7410.16,
              9376.332
            ],
            [
              1312.907,
              -7366.221,
              9428.521
            ],
            [
              1291.476,
              -7341.333,
              9461.364
            ],
            [
              1145.93,
              -7238.444,
              9639.605
            ],
            [
              1102.154,
              -7203.124,
              9695.853
            ],
            [
              1045.977,
              -7141.97,
              9778.893
            ],
            [
              1029.249,
              -7124.149,
              9803.335
            ],
            [
              999.073,
              -7089.195,
              9849.513
            ],
            [
              951.943,
              -7073.438,
              9899.207
            ],
            [
              652.324,
              -7119.127,
              10202.29
            ],
            [
              622.009,
              -7121.909,
              10232.732
            ],
            [
              600.797,
              -7121.363,
              10253.951
            ],
            [
              577.752,
              -7115.358,
              10277.766
            ],
            [
              488.616,
              -7067.891,
              10378.753
            ],
            [
              60.82,
              -6823.295,
              10871.537
            ],
            [
              14.911,
              -6833.59,
              10918.586
            ],
            [
              -2.815,
              -6852.191,
              10944.281
            ],
            [
              -13.86,
              -6857.556,
              10956.56
            ],
            [
              -26.131,
              -6859.559,
              10968.993
            ],
            [
              -47.374,
              -6859.171,
              10990.24
            ],
            [
              -59.463,
              -6851.158,
              11004.743
            ],
            [
              -67.548,
              -6835.425,
              11022.432
            ],
            [
              -70.502,
              -6820.899,
              11037.256
            ],
            [
              -64.262,
              -6796.522,
              11062.419
            ],
            [
              -53.909,
              -6786.595,
              11076.762
            ],
            [
              -43.463,
              -6771.142,
              11095.415
            ],
            [
              -35.045,
              -6748.072,
              11119.972
            ],
            [
              -43.266,
              -6704.505,
              11164.308
            ],
            [
              -50.641,
              -6695.446,
              11175.989
            ],
            [
              -48.526,
              -6639.841,
              11231.635
            ],
            [
              -52.099,
              -6588.567,
              11283.033
            ],
            [
              -70.555,
              -6505.85,
              11367.784
            ],
            [
              -125.166,
              -6286.66,
              11593.675
            ],
            [
              -158.525,
              -6137.991,
              11746.041
            ],
            [
              -180.294,
              -6069.166,
              11818.226
            ],
            [
              -186.217,
              -6031.729,
              11856.129
            ],
            [
              -210.448,
              -5912.171,
              11978.118
            ],
            [
              -214.769,
              -5866.45,
              12024.042
            ],
            [
              -215.425,
              -5796.303,
              12094.192
            ],
            [
              -201.667,
              -5690.858,
              12200.531
            ],
            [
              -179.043,
              -5602.148,
              12292.081
            ],
            [
              -173.463,
              -5579.628,
              12315.282
            ],
            [
              -152.289,
              -5512.463,
              12385.705
            ],
            [
              -104.595,
              -5334.099,
              12570.336
            ],
            [
              -94.509,
              -5271.442,
              12633.799
            ],
            [
              -83.553,
              -5239.857,
              12667.23
            ],
            [
              -60.518,
              -5142.312,
              12767.458
            ],
            [
              -44.586,
              -5045.75,
              12865.326
            ],
            [
              -37.931,
              -4996.288,
              12915.233
            ],
            [
              -29.601,
              -4965.87,
              12946.772
            ],
            [
              29.378,
              -4628.52,
              13289.238
            ],
            [
              28.501,
              -4570.615,
              13347.15
            ],
            [
              22.071,
              -4499.251,
              13418.803
            ],
            [
              25.378,
              -4459.234,
              13458.957
            ],
            [
              39.56,
              -4363.958,
              13555.282
            ],
            [
              46.147,
              -4344.95,
              13575.399
            ],
            [
              48.454,
              -4310.97,
              13609.457
            ],
            [
              52.989,
              -4285.429,
              13635.398
            ],
            [
              60.111,
              -4250.579,
              13670.968
            ],
            [
              104.143,
              -4062.131,
              13864.492
            ],
            [
              127.703,
              -3998.463,
              13932.38
            ],
            [
              151.352,
              -3953.466,
              13983.212
            ],
            [
              179.07,
              -3910.986,
              14033.936
            ],
            [
              264.038,
              -3810.121,
              14165.819
            ],
            [
              345.157,
              -3743.697,
              14270.664
            ],
            [
              387.493,
              -3689.441,
              14339.483
            ],
            [
              434.283,
              -3627.326,
              14417.249
            ],
            [
              450.253,
              -3599.787,
              14449.084
            ],
            [
              463.769,
              -3565.524,
              14485.916
            ],
            [
              474.065,
              -3531.203,
              14521.749
            ],
            [
              484.063,
              -3477.95,
              14575.932
            ],
            [
              490.334,
              -3345.62,
              14708.41
            ],
            [
              488.575,
              -3319.869,
              14734.221
            ],
            [
              479.687,
              -3259.675,
              14795.068
            ],
            [
              477.905,
              -3216.226,
              14838.554
            ],
            [
              481.339,
              -3169.533,
              14885.373
            ],
            [
              500.602,
              -3103.091,
              14954.551
            ],
            [
              504.082,
              -3078.362,
              14979.524
            ],
            [
              504.445,
              -3034.141,
              15023.746
            ],
            [
              503.491,
              -2980.688,
              15077.207
            ],
            [
              505.751,
              -2962.917,
              15095.122
            ],
            [
              504.844,
              -2912.819,
              15145.228
            ],
            [
              509.397,
              -2869.472,
              15188.813
            ],
            [
              513.301,
              -2797.183,
              15261.208
            ],
            [
              494.515,
              -2626.513,
              15432.908
            ],
            [
              487.991,
              -2601.316,
              15458.936
            ],
            [
              485.911,
              -2568.466,
              15491.852
            ],
            [
              462.343,
              -2342.047,
              15719.494
            ],
            [
              451.425,
              -2269.486,
              15792.872
            ],
            [
              407.333,
              -2116.119,
              15952.451
            ],
            [
              406.254,
              -2096.107,
              15972.493
            ],
            [
              361.405,
              -1904.922,
              16168.868
            ],
            [
              342.249,
              -1718.661,
              16356.111
            ],
            [
              384.201,
              -1716.089,
              16398.142
            ],
            [
              395.76,
              -1718.527,
              16409.955
            ],
            [
              397.612,
              -1723.014,
              16414.809
            ],
            [
              396.067,
              -1765.998,
              16457.821
            ],
            [
              394.421,
              -1775.729,
              16467.69
            ],
            [
              394.599,
              -1781.96,
              16473.924
            ],
            [
              371.898,
              -1783.286,
              16496.663
            ],
            [
              374.545,
              -1783.148,
              16499.314
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:8011",
              "position": {
                "x": 2018.624,
                "z": -13347.572
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 1.685,
              "arrivalOffsetSeconds": -390,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:8016",
              "position": {
                "x": 2445.252,
                "z": -13092.852
              },
              "distanceAlongShapeM": 501.924,
              "shapeOffsetM": 0.84,
              "arrivalOffsetSeconds": 60,
              "departureOffsetSeconds": 60
            },
            {
              "stopId": "judu:stop:8367",
              "position": {
                "x": 2941.349,
                "z": -13145.637
              },
              "distanceAlongShapeM": 1028.677,
              "shapeOffsetM": 0.333,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:8017",
              "position": {
                "x": 3092.532,
                "z": -12803.387
              },
              "distanceAlongShapeM": 1402.806,
              "shapeOffsetM": 1.59,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:8018",
              "position": {
                "x": 3458.421,
                "z": -12501.964
              },
              "distanceAlongShapeM": 1935.381,
              "shapeOffsetM": 3.602,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:10551",
              "position": {
                "x": 3765.709,
                "z": -12576.851
              },
              "distanceAlongShapeM": 2251.703,
              "shapeOffsetM": 4.737,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:18426",
              "position": {
                "x": 4270.854,
                "z": -12663.353
              },
              "distanceAlongShapeM": 2811.167,
              "shapeOffsetM": 3.274,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:8021",
              "position": {
                "x": 4413.388,
                "z": -11974.746
              },
              "distanceAlongShapeM": 3514.359,
              "shapeOffsetM": 3.056,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:8022",
              "position": {
                "x": 4500.864,
                "z": -11574.536
              },
              "distanceAlongShapeM": 3924.075,
              "shapeOffsetM": 1.143,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:18370",
              "position": {
                "x": 4222.101,
                "z": -10882.277
              },
              "distanceAlongShapeM": 4691.338,
              "shapeOffsetM": 7.645,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:6861",
              "position": {
                "x": 3931.49,
                "z": -10300.026
              },
              "distanceAlongShapeM": 5342.011,
              "shapeOffsetM": 1.97,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:10556",
              "position": {
                "x": 3832.039,
                "z": -10116.66
              },
              "distanceAlongShapeM": 5553.861,
              "shapeOffsetM": 5.6,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:6857",
              "position": {
                "x": 3613.674,
                "z": -9925.461
              },
              "distanceAlongShapeM": 5844.085,
              "shapeOffsetM": 2.847,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:6804",
              "position": {
                "x": 2953.441,
                "z": -9141.425
              },
              "distanceAlongShapeM": 6915.378,
              "shapeOffsetM": 4.54,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:6801",
              "position": {
                "x": 1918.925,
                "z": -8290.37
              },
              "distanceAlongShapeM": 8264.682,
              "shapeOffsetM": 3.008,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:6798",
              "position": {
                "x": 1026.954,
                "z": -7126.033
              },
              "distanceAlongShapeM": 9803.409,
              "shapeOffsetM": 2.968,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:16628",
              "position": {
                "x": 229.7,
                "z": -6919.895
              },
              "distanceAlongShapeM": 10676.981,
              "shapeOffsetM": 0.036,
              "arrivalOffsetSeconds": 1380,
              "departureOffsetSeconds": 1380
            },
            {
              "stopId": "judu:stop:6503",
              "position": {
                "x": -50.829,
                "z": -6695.462
              },
              "distanceAlongShapeM": 11175.989,
              "shapeOffsetM": 0.189,
              "arrivalOffsetSeconds": 1500,
              "departureOffsetSeconds": 1500
            },
            {
              "stopId": "judu:stop:6501",
              "position": {
                "x": -182.398,
                "z": -6069.649
              },
              "distanceAlongShapeM": 11818.226,
              "shapeOffsetM": 2.159,
              "arrivalOffsetSeconds": 1620,
              "departureOffsetSeconds": 1620
            },
            {
              "stopId": "judu:stop:6494",
              "position": {
                "x": -176.685,
                "z": -5578.813
              },
              "distanceAlongShapeM": 12315.282,
              "shapeOffsetM": 3.324,
              "arrivalOffsetSeconds": 1740,
              "departureOffsetSeconds": 1740
            },
            {
              "stopId": "judu:stop:6492",
              "position": {
                "x": -97,
                "z": -5270.783
              },
              "distanceAlongShapeM": 12633.799,
              "shapeOffsetM": 2.577,
              "arrivalOffsetSeconds": 1800,
              "departureOffsetSeconds": 1800
            },
            {
              "stopId": "judu:stop:6489",
              "position": {
                "x": -41.097,
                "z": -4995.718
              },
              "distanceAlongShapeM": 12915.233,
              "shapeOffsetM": 3.217,
              "arrivalOffsetSeconds": 1860,
              "departureOffsetSeconds": 1860
            },
            {
              "stopId": "judu:stop:5836",
              "position": {
                "x": 49.82,
                "z": -4284.902
              },
              "distanceAlongShapeM": 13635.363,
              "shapeOffsetM": 3.212,
              "arrivalOffsetSeconds": 1980,
              "departureOffsetSeconds": 1980
            },
            {
              "stopId": "judu:stop:5839",
              "position": {
                "x": 148.043,
                "z": -3951.609
              },
              "distanceAlongShapeM": 13983.212,
              "shapeOffsetM": 3.794,
              "arrivalOffsetSeconds": 2040,
              "departureOffsetSeconds": 2040
            },
            {
              "stopId": "judu:stop:5846",
              "position": {
                "x": 383.579,
                "z": -3686.512
              },
              "distanceAlongShapeM": 14339.385,
              "shapeOffsetM": 4.888,
              "arrivalOffsetSeconds": 2100,
              "departureOffsetSeconds": 2100
            },
            {
              "stopId": "judu:stop:5481",
              "position": {
                "x": 502.159,
                "z": -2912.756
              },
              "distanceAlongShapeM": 15145.228,
              "shapeOffsetM": 2.686,
              "arrivalOffsetSeconds": 2280,
              "departureOffsetSeconds": 2280
            },
            {
              "stopId": "judu:stop:5347",
              "position": {
                "x": 482.722,
                "z": -2601.805
              },
              "distanceAlongShapeM": 15458.936,
              "shapeOffsetM": 5.291,
              "arrivalOffsetSeconds": 2340,
              "departureOffsetSeconds": 2340
            },
            {
              "stopId": "judu:stop:5351",
              "position": {
                "x": 407.176,
                "z": -2116.162
              },
              "distanceAlongShapeM": 15952.451,
              "shapeOffsetM": 0.163,
              "arrivalOffsetSeconds": 2460,
              "departureOffsetSeconds": 2460
            },
            {
              "stopId": "judu:stop:6788",
              "position": {
                "x": 374.58,
                "z": -1783.82
              },
              "distanceAlongShapeM": 16499.314,
              "shapeOffsetM": 0.673,
              "arrivalOffsetSeconds": 2580,
              "departureOffsetSeconds": 2580
            }
          ],
          "departuresSeconds": [
            19260,
            20400,
            22500,
            23820,
            24720,
            26400,
            27960,
            29520,
            31500,
            34260,
            35640,
            37200,
            39060,
            40140,
            41100,
            42120,
            43140,
            44100,
            45120,
            46140,
            47100,
            48060,
            49020,
            49980,
            50940,
            52440,
            53940,
            55440,
            57000,
            57900,
            58740,
            59580,
            60420,
            61260,
            62400,
            63540,
            64560,
            65700,
            66840,
            67920,
            69420,
            70860,
            72120,
            72960,
            74400,
            75900,
            77460,
            78900,
            80340,
            81780,
            83160,
            84360
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_bus_37",
      "sourceRouteId": "vilnius_bus_37",
      "mode": "bus",
      "shortName": "37",
      "longName": "Kalvarijų–Tuskulėnų–Olandų g.–Rokantiškės",
      "color": "0073AC",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_bus_37:0",
          "sourceRouteId": "vilnius_bus_37",
          "sourceShapeId": "vilnius_bus_37_a-b",
          "directionId": 0,
          "headsign": "Rokantiškės",
          "directionName": "Kalvarijų–Tuskulėnų–Olandų g.–Rokantiškės",
          "mode": "bus",
          "routeShortName": "37",
          "routeLongName": "Kalvarijų–Tuskulėnų–Olandų g.–Rokantiškės",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              676.214,
              -1635.564,
              0
            ],
            [
              696.914,
              -1614.56,
              29.49
            ],
            [
              759.366,
              -1540.03,
              126.727
            ],
            [
              891.199,
              -1385.857,
              329.579
            ],
            [
              926.904,
              -1337.532,
              389.664
            ],
            [
              938.594,
              -1321.715,
              409.332
            ],
            [
              959.848,
              -1299.175,
              440.313
            ],
            [
              1019.189,
              -1227.908,
              533.051
            ],
            [
              1188.158,
              -1016.171,
              803.944
            ],
            [
              1211.885,
              -984.023,
              843.899
            ],
            [
              1229.979,
              -967.272,
              868.557
            ],
            [
              1246.923,
              -941.557,
              899.352
            ],
            [
              1250.475,
              -923.811,
              917.45
            ],
            [
              1249.57,
              -868.132,
              973.137
            ],
            [
              1251.975,
              -858.297,
              983.262
            ],
            [
              1263.58,
              -842.786,
              1002.633
            ],
            [
              1271.438,
              -836.252,
              1012.853
            ],
            [
              1287.032,
              -829.861,
              1029.706
            ],
            [
              1306.39,
              -829.106,
              1049.078
            ],
            [
              1381.451,
              -814.909,
              1125.47
            ],
            [
              1625.047,
              -649.1,
              1420.142
            ],
            [
              1633.665,
              -634.2,
              1437.355
            ],
            [
              1640.869,
              -630.468,
              1445.468
            ],
            [
              1649.997,
              -609.491,
              1468.345
            ],
            [
              1647.435,
              -589.4,
              1488.599
            ],
            [
              1649.076,
              -570.506,
              1507.564
            ],
            [
              1661.593,
              -556.266,
              1526.523
            ],
            [
              1707.61,
              -543.762,
              1574.209
            ],
            [
              1715.531,
              -533.89,
              1586.866
            ],
            [
              1739.19,
              -475.328,
              1650.026
            ],
            [
              1739.832,
              -440.829,
              1684.531
            ],
            [
              1737.688,
              -417.411,
              1708.047
            ],
            [
              1728.721,
              -379.394,
              1747.108
            ],
            [
              1717.488,
              -353.728,
              1775.125
            ],
            [
              1709.957,
              -313.364,
              1816.185
            ],
            [
              1701.073,
              -270.896,
              1859.572
            ],
            [
              1691.292,
              -207.259,
              1923.956
            ],
            [
              1692.553,
              -139.375,
              1991.852
            ],
            [
              1699.889,
              -91.641,
              2040.146
            ],
            [
              1722.281,
              -31.942,
              2103.907
            ],
            [
              1763.619,
              40.763,
              2187.542
            ],
            [
              1784.543,
              87.474,
              2238.725
            ],
            [
              1803.689,
              114.605,
              2271.931
            ],
            [
              1864.141,
              209.22,
              2384.21
            ],
            [
              1913.636,
              269.526,
              2462.226
            ],
            [
              1990.962,
              334.88,
              2563.471
            ],
            [
              2018.633,
              366.989,
              2605.858
            ],
            [
              2052.586,
              388.28,
              2645.934
            ],
            [
              2087.216,
              412.125,
              2687.98
            ],
            [
              2136.967,
              451.273,
              2751.287
            ],
            [
              2182.309,
              496.069,
              2815.025
            ],
            [
              2210.658,
              528.937,
              2858.43
            ],
            [
              2229.877,
              556.409,
              2891.957
            ],
            [
              2248.742,
              590.591,
              2930.999
            ],
            [
              2266.569,
              621.404,
              2966.598
            ],
            [
              2281.67,
              670.105,
              3017.586
            ],
            [
              2292.591,
              736.695,
              3085.066
            ],
            [
              2303.283,
              756.534,
              3107.602
            ],
            [
              2315.701,
              765.207,
              3122.749
            ],
            [
              2333.759,
              767.736,
              3140.983
            ],
            [
              2353.101,
              764.507,
              3160.593
            ],
            [
              2377.645,
              731.764,
              3201.514
            ],
            [
              2411.777,
              694.387,
              3252.131
            ],
            [
              2429.021,
              676.964,
              3276.645
            ],
            [
              2453.553,
              653.492,
              3310.596
            ],
            [
              2501.276,
              617.009,
              3370.667
            ],
            [
              2634.367,
              525.451,
              3532.21
            ],
            [
              2716.164,
              450.439,
              3643.194
            ],
            [
              2736.291,
              431.885,
              3670.569
            ],
            [
              2755.449,
              412.963,
              3697.496
            ],
            [
              2864.4,
              307.38,
              3849.213
            ],
            [
              2936.644,
              239.224,
              3948.533
            ],
            [
              2983.62,
              199.374,
              4010.134
            ],
            [
              3033.392,
              162.998,
              4071.782
            ],
            [
              3060.52,
              138.92,
              4108.055
            ],
            [
              3266.423,
              -23.054,
              4370.031
            ],
            [
              3339.574,
              -76.762,
              4460.781
            ],
            [
              3415.597,
              -114.94,
              4545.852
            ],
            [
              3440.614,
              -122.094,
              4571.872
            ],
            [
              3504.684,
              -140.35,
              4638.492
            ],
            [
              3501.543,
              -139.949,
              4641.659
            ],
            [
              3709.123,
              -178.405,
              4852.771
            ],
            [
              3787.457,
              -196.594,
              4933.189
            ],
            [
              3851.65,
              -212.29,
              4999.273
            ],
            [
              3930.415,
              -241.623,
              5083.323
            ],
            [
              4021.131,
              -286.771,
              5184.653
            ],
            [
              4084.273,
              -323.602,
              5257.751
            ],
            [
              4228.208,
              -425.014,
              5433.824
            ],
            [
              4241.418,
              -435.707,
              5450.82
            ],
            [
              4278.232,
              -466.47,
              5498.795
            ],
            [
              4311.285,
              -491.595,
              5540.313
            ],
            [
              4330.475,
              -499.756,
              5561.167
            ],
            [
              4344.721,
              -496.689,
              5575.739
            ],
            [
              4357.14,
              -488.021,
              5590.884
            ],
            [
              4364.509,
              -473.69,
              5606.998
            ],
            [
              4364.163,
              -458.098,
              5622.594
            ],
            [
              4359.842,
              -447.995,
              5633.583
            ],
            [
              4352.277,
              -438.944,
              5645.379
            ],
            [
              4340.823,
              -430.932,
              5659.357
            ],
            [
              4325.351,
              -430.635,
              5674.832
            ],
            [
              4312.351,
              -435.953,
              5688.877
            ],
            [
              4227.382,
              -532.378,
              5817.398
            ],
            [
              4193.305,
              -557.245,
              5859.583
            ],
            [
              4145.028,
              -586.38,
              5915.97
            ],
            [
              4118.118,
              -609.14,
              5951.215
            ],
            [
              4108.056,
              -631.317,
              5975.568
            ],
            [
              4104.514,
              -647.948,
              5992.572
            ],
            [
              4104.478,
              -683.571,
              6028.195
            ],
            [
              4108.628,
              -702.576,
              6047.648
            ],
            [
              4120.493,
              -722.842,
              6071.131
            ],
            [
              4209.147,
              -841.43,
              6219.194
            ],
            [
              4291.339,
              -949.295,
              6354.805
            ],
            [
              4338.92,
              -1012.367,
              6433.812
            ],
            [
              4411.03,
              -1109.579,
              6554.849
            ],
            [
              4521.204,
              -1337.377,
              6807.891
            ],
            [
              4532.071,
              -1351.932,
              6826.056
            ],
            [
              4570.501,
              -1388.687,
              6879.232
            ],
            [
              4585.807,
              -1407.515,
              6903.497
            ],
            [
              4687.775,
              -1502.991,
              7043.187
            ],
            [
              4747.032,
              -1556.868,
              7123.274
            ],
            [
              4850.416,
              -1650.635,
              7262.847
            ],
            [
              4873.291,
              -1681.796,
              7301.503
            ],
            [
              4892.083,
              -1707.317,
              7333.196
            ],
            [
              4935.048,
              -1752.677,
              7395.675
            ],
            [
              4957.325,
              -1767.58,
              7422.477
            ],
            [
              5027.779,
              -1793.3,
              7497.479
            ],
            [
              5112.316,
              -1820.673,
              7586.337
            ],
            [
              5148.212,
              -1831.387,
              7623.798
            ],
            [
              5188.082,
              -1836.611,
              7664.009
            ],
            [
              5235.836,
              -1834.197,
              7711.824
            ],
            [
              5256.588,
              -1827.919,
              7733.505
            ],
            [
              5278.737,
              -1816.102,
              7758.609
            ],
            [
              5310.481,
              -1781.433,
              7805.615
            ],
            [
              5325.291,
              -1770.751,
              7823.875
            ],
            [
              5346.147,
              -1762.9,
              7846.161
            ],
            [
              5394.475,
              -1763.224,
              7894.489
            ],
            [
              5423.582,
              -1774.021,
              7925.535
            ],
            [
              5445.017,
              -1788.439,
              7951.368
            ],
            [
              5454.706,
              -1796.631,
              7964.056
            ],
            [
              5471.603,
              -1809.858,
              7985.513
            ],
            [
              5521.818,
              -1841.125,
              8044.668
            ],
            [
              5537.621,
              -1850.531,
              8063.058
            ],
            [
              5539.738,
              -1854.567,
              8067.615
            ],
            [
              5540.886,
              -1855.792,
              8069.294
            ],
            [
              5539.401,
              -1854.908,
              8071.023
            ],
            [
              5531.692,
              -1850.319,
              8079.995
            ],
            [
              5524.505,
              -1846.04,
              8088.359
            ],
            [
              5518.81,
              -1842.65,
              8094.986
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:6542",
              "position": {
                "x": 673.267,
                "z": -1632.329
              },
              "distanceAlongShapeM": 0.235,
              "shapeOffsetM": 4.37,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:6544",
              "position": {
                "x": 934.987,
                "z": -1318.756
              },
              "distanceAlongShapeM": 409.332,
              "shapeOffsetM": 4.665,
              "arrivalOffsetSeconds": 60,
              "departureOffsetSeconds": 60
            },
            {
              "stopId": "judu:stop:6546",
              "position": {
                "x": 1209.421,
                "z": -982.054
              },
              "distanceAlongShapeM": 843.899,
              "shapeOffsetM": 3.154,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:6565",
              "position": {
                "x": 1714.349,
                "z": -354.636
              },
              "distanceAlongShapeM": 1775.125,
              "shapeOffsetM": 3.268,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:6568",
              "position": {
                "x": 1781.292,
                "z": 89.417
              },
              "distanceAlongShapeM": 2238.725,
              "shapeOffsetM": 3.788,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:6571",
              "position": {
                "x": 2015.503,
                "z": 371.16
              },
              "distanceAlongShapeM": 2605.858,
              "shapeOffsetM": 5.214,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:6574",
              "position": {
                "x": 2244.749,
                "z": 592.868
              },
              "distanceAlongShapeM": 2930.999,
              "shapeOffsetM": 4.597,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:931",
              "position": {
                "x": 2432.805,
                "z": 680.634
              },
              "distanceAlongShapeM": 3276.841,
              "shapeOffsetM": 5.268,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:387",
              "position": {
                "x": 2739.748,
                "z": 435.524
              },
              "distanceAlongShapeM": 3670.569,
              "shapeOffsetM": 5.02,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:5372",
              "position": {
                "x": 3035.88,
                "z": 166.104
              },
              "distanceAlongShapeM": 4071.782,
              "shapeOffsetM": 3.98,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:5373",
              "position": {
                "x": 3506.161,
                "z": -134.47
              },
              "distanceAlongShapeM": 4638.301,
              "shapeOffsetM": 6.06,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:7587",
              "position": {
                "x": 4231.381,
                "z": -421.043
              },
              "distanceAlongShapeM": 5433.824,
              "shapeOffsetM": 5.083,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:6881",
              "position": {
                "x": 4298.76,
                "z": -943.34
              },
              "distanceAlongShapeM": 6354.567,
              "shapeOffsetM": 9.512,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            },
            {
              "stopId": "judu:stop:6883",
              "position": {
                "x": 4572.013,
                "z": -1387.211
              },
              "distanceAlongShapeM": 6879.232,
              "shapeOffsetM": 2.113,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:6887",
              "position": {
                "x": 4855.863,
                "z": -1646.502
              },
              "distanceAlongShapeM": 7262.847,
              "shapeOffsetM": 6.837,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:6888",
              "position": {
                "x": 5512.692,
                "z": -1852.928
              },
              "distanceAlongShapeM": 8094.986,
              "shapeOffsetM": 11.961,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            }
          ],
          "departuresSeconds": [
            18300,
            21060,
            24240,
            28140,
            32280,
            37920,
            41460,
            45060,
            48420,
            52020,
            55560,
            59580,
            64020,
            70260,
            73740,
            77160,
            80460
          ]
        },
        {
          "id": "judu:pattern:vilnius_bus_37:1",
          "sourceRouteId": "vilnius_bus_37",
          "sourceShapeId": "vilnius_bus_37_b-a",
          "directionId": 1,
          "headsign": "Kalvarijų g.",
          "directionName": "Rokantiškės–Olandų–Šeimyniškių–Kalvarijų g.",
          "mode": "bus",
          "routeShortName": "37",
          "routeLongName": "Kalvarijų–Tuskulėnų–Olandų g.–Rokantiškės",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              5518.81,
              -1842.65,
              0
            ],
            [
              5511.083,
              -1836.198,
              10.067
            ],
            [
              5475.747,
              -1812.651,
              52.53
            ],
            [
              5448.75,
              -1791.349,
              86.919
            ],
            [
              5407.793,
              -1766.782,
              134.678
            ],
            [
              5375.85,
              -1761.323,
              167.084
            ],
            [
              5339.515,
              -1764.574,
              203.564
            ],
            [
              5328.445,
              -1768.78,
              215.407
            ],
            [
              5308.521,
              -1783.482,
              240.168
            ],
            [
              5287.701,
              -1808.287,
              272.553
            ],
            [
              5270.213,
              -1822.586,
              295.142
            ],
            [
              5244.776,
              -1832.724,
              322.525
            ],
            [
              5198.333,
              -1837.541,
              369.217
            ],
            [
              5188.082,
              -1836.611,
              379.51
            ],
            [
              5172.595,
              -1837.357,
              395.015
            ],
            [
              5130.275,
              -1825.473,
              438.972
            ],
            [
              4985.466,
              -1779.256,
              590.978
            ],
            [
              4964.371,
              -1769.942,
              614.037
            ],
            [
              4940.762,
              -1757.24,
              640.846
            ],
            [
              4874.771,
              -1688.658,
              736.021
            ],
            [
              4817.852,
              -1611.266,
              832.091
            ],
            [
              4761.938,
              -1568.989,
              902.189
            ],
            [
              4592.397,
              -1415.215,
              1131.078
            ],
            [
              4569.994,
              -1391.625,
              1163.611
            ],
            [
              4541.517,
              -1362.949,
              1204.025
            ],
            [
              4537.596,
              -1359.307,
              1209.376
            ],
            [
              4527.905,
              -1367.438,
              1222.027
            ],
            [
              4515.011,
              -1368.169,
              1234.941
            ],
            [
              4506.486,
              -1358.575,
              1247.776
            ],
            [
              4508.875,
              -1351.846,
              1254.916
            ],
            [
              4515.045,
              -1343.344,
              1265.421
            ],
            [
              4515.651,
              -1339.854,
              1268.963
            ],
            [
              4469.197,
              -1234.945,
              1383.697
            ],
            [
              4407.8,
              -1107.967,
              1524.74
            ],
            [
              4295.883,
              -958.871,
              1711.167
            ],
            [
              4246.228,
              -894.212,
              1792.692
            ],
            [
              4227.329,
              -868.497,
              1824.605
            ],
            [
              4130.445,
              -741.958,
              1983.975
            ],
            [
              4108.048,
              -699.225,
              2032.221
            ],
            [
              4103.316,
              -676.87,
              2055.072
            ],
            [
              4104.061,
              -637.92,
              2094.029
            ],
            [
              4108.807,
              -625.765,
              2107.077
            ],
            [
              4112.315,
              -612.963,
              2120.351
            ],
            [
              4122.34,
              -593.527,
              2142.22
            ],
            [
              4170.59,
              -562.155,
              2199.773
            ],
            [
              4184.472,
              -547.057,
              2220.283
            ],
            [
              4199.863,
              -529.319,
              2243.767
            ],
            [
              4209.133,
              -505.225,
              2269.583
            ],
            [
              4205.025,
              -483.994,
              2291.208
            ],
            [
              4149.312,
              -396.094,
              2395.276
            ],
            [
              4134.822,
              -379.394,
              2417.387
            ],
            [
              4073.746,
              -334.533,
              2493.168
            ],
            [
              4027.903,
              -303.6,
              2548.471
            ],
            [
              3901.298,
              -246.634,
              2687.301
            ],
            [
              3784.624,
              -209.9,
              2809.621
            ],
            [
              3691.504,
              -189.202,
              2905.014
            ],
            [
              3594.389,
              -175.11,
              3003.146
            ],
            [
              3481.906,
              -155.162,
              3117.384
            ],
            [
              3433.85,
              -138.665,
              3168.193
            ],
            [
              3394.357,
              -124.205,
              3210.251
            ],
            [
              3396.087,
              -123.476,
              3212.128
            ],
            [
              3343.728,
              -95.766,
              3271.368
            ],
            [
              3282.595,
              -54.531,
              3345.107
            ],
            [
              2977.671,
              191.693,
              3737.032
            ],
            [
              2944.561,
              216.482,
              3778.393
            ],
            [
              2919.043,
              240.05,
              3813.13
            ],
            [
              2850.195,
              306.534,
              3908.839
            ],
            [
              2697.486,
              451.904,
              4119.676
            ],
            [
              2679.584,
              466.091,
              4142.518
            ],
            [
              2649.901,
              493.988,
              4183.253
            ],
            [
              2582.473,
              544.237,
              4267.345
            ],
            [
              2413.667,
              623.104,
              4453.666
            ],
            [
              2393.054,
              624.603,
              4474.333
            ],
            [
              2378.182,
              622.655,
              4489.332
            ],
            [
              2363.247,
              617.369,
              4505.175
            ],
            [
              2305.672,
              573.917,
              4577.307
            ],
            [
              2269.605,
              542.307,
              4625.265
            ],
            [
              2254.026,
              527.847,
              4646.521
            ],
            [
              2223.804,
              507.54,
              4682.932
            ],
            [
              1990.962,
              334.88,
              4972.806
            ],
            [
              1969.782,
              310.225,
              5005.308
            ],
            [
              1935.827,
              283.585,
              5048.467
            ],
            [
              1864.599,
              199.192,
              5158.901
            ],
            [
              1763.619,
              40.763,
              5346.775
            ],
            [
              1755.04,
              12.778,
              5376.045
            ],
            [
              1734.841,
              -15.477,
              5410.778
            ],
            [
              1714.048,
              -58.507,
              5458.568
            ],
            [
              1702.489,
              -90.576,
              5492.657
            ],
            [
              1692.553,
              -139.375,
              5542.457
            ],
            [
              1696.284,
              -216.258,
              5619.431
            ],
            [
              1701.445,
              -250.864,
              5654.419
            ],
            [
              1720.689,
              -325.809,
              5731.796
            ],
            [
              1730.124,
              -347.569,
              5755.513
            ],
            [
              1742.617,
              -429.749,
              5838.637
            ],
            [
              1739.19,
              -475.328,
              5884.345
            ],
            [
              1717.531,
              -565.098,
              5976.691
            ],
            [
              1721.402,
              -599.681,
              6011.49
            ],
            [
              1720.009,
              -605.221,
              6017.202
            ],
            [
              1711.776,
              -614.79,
              6029.825
            ],
            [
              1700.984,
              -622.679,
              6043.193
            ],
            [
              1684.224,
              -622.368,
              6059.956
            ],
            [
              1662.848,
              -627.537,
              6081.948
            ],
            [
              1381.451,
              -814.909,
              6420.02
            ],
            [
              1363.471,
              -845.747,
              6455.717
            ],
            [
              1363.126,
              -899.177,
              6509.148
            ],
            [
              1355.02,
              -919.065,
              6530.625
            ],
            [
              1339.886,
              -935.484,
              6552.954
            ],
            [
              1325.561,
              -943.011,
              6569.137
            ],
            [
              1293.291,
              -944.641,
              6601.448
            ],
            [
              1278.614,
              -942.95,
              6616.222
            ],
            [
              1269.114,
              -935.31,
              6628.413
            ],
            [
              1257.937,
              -924.707,
              6643.819
            ],
            [
              1253.197,
              -916.068,
              6653.673
            ],
            [
              1249.597,
              -901.529,
              6668.651
            ],
            [
              1250.468,
              -889.3,
              6680.911
            ],
            [
              1243.124,
              -868.013,
              6703.429
            ],
            [
              1234.408,
              -851.153,
              6722.409
            ],
            [
              1218.52,
              -838.613,
              6742.649
            ],
            [
              1192.86,
              -831.46,
              6769.288
            ],
            [
              1155.132,
              -824.781,
              6807.603
            ],
            [
              1120.288,
              -815.648,
              6843.623
            ],
            [
              1031.058,
              -793.963,
              6935.451
            ],
            [
              773.373,
              -745.803,
              7197.597
            ],
            [
              730.608,
              -739.605,
              7240.809
            ],
            [
              702.691,
              -732.259,
              7269.676
            ],
            [
              508.13,
              -687.5,
              7469.319
            ],
            [
              443.852,
              -676.304,
              7534.565
            ],
            [
              405.738,
              -680.059,
              7572.864
            ],
            [
              363.165,
              -686.919,
              7615.986
            ],
            [
              341.718,
              -690.021,
              7637.656
            ],
            [
              238.113,
              -713.732,
              7743.94
            ],
            [
              222.179,
              -844.803,
              7875.976
            ],
            [
              221.447,
              -884.866,
              7916.045
            ],
            [
              235.23,
              -977.516,
              8009.715
            ],
            [
              262.76,
              -1129.419,
              8164.093
            ],
            [
              277.464,
              -1242.125,
              8277.754
            ],
            [
              289.419,
              -1293.552,
              8330.552
            ],
            [
              294.15,
              -1318.635,
              8356.077
            ],
            [
              296.7,
              -1353.8,
              8391.335
            ],
            [
              342.249,
              -1718.661,
              8759.028
            ],
            [
              510.658,
              -1710.612,
              8927.629
            ],
            [
              550.922,
              -1706.707,
              8968.082
            ],
            [
              586.765,
              -1697.182,
              9005.169
            ],
            [
              616.278,
              -1681.379,
              9038.647
            ],
            [
              646.312,
              -1660.778,
              9075.067
            ],
            [
              676.214,
              -1635.564,
              9114.181
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:6888",
              "position": {
                "x": 5512.692,
                "z": -1852.928
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 11.961,
              "arrivalOffsetSeconds": -750,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:6886",
              "position": {
                "x": 4871.116,
                "z": -1691.327
              },
              "distanceAlongShapeM": 736.037,
              "shapeOffsetM": 4.526,
              "arrivalOffsetSeconds": 60,
              "departureOffsetSeconds": 60
            },
            {
              "stopId": "judu:stop:17889",
              "position": {
                "x": 4588.816,
                "z": -1418.705
              },
              "distanceAlongShapeM": 1131.078,
              "shapeOffsetM": 5.001,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:6880",
              "position": {
                "x": 4235.714,
                "z": -902.055
              },
              "distanceAlongShapeM": 1792.692,
              "shapeOffsetM": 13.117,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:7588",
              "position": {
                "x": 4121.07,
                "z": -591.488
              },
              "distanceAlongShapeM": 2142.267,
              "shapeOffsetM": 2.402,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:5423",
              "position": {
                "x": 3392.114,
                "z": -128.967
              },
              "distanceAlongShapeM": 3210.251,
              "shapeOffsetM": 5.264,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:5424",
              "position": {
                "x": 2941.964,
                "z": 213.518
              },
              "distanceAlongShapeM": 3778.393,
              "shapeOffsetM": 3.941,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:5425",
              "position": {
                "x": 2677.062,
                "z": 463.42
              },
              "distanceAlongShapeM": 4142.527,
              "shapeOffsetM": 3.673,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:6572",
              "position": {
                "x": 2256.376,
                "z": 524.743
              },
              "distanceAlongShapeM": 4646.521,
              "shapeOffsetM": 3.893,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:449",
              "position": {
                "x": 1973.014,
                "z": 306.27
              },
              "distanceAlongShapeM": 5005.308,
              "shapeOffsetM": 5.108,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:603",
              "position": {
                "x": 1759.816,
                "z": 9.663
              },
              "distanceAlongShapeM": 5376.045,
              "shapeOffsetM": 5.702,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:6566",
              "position": {
                "x": 1735.144,
                "z": -346.116
              },
              "distanceAlongShapeM": 5755.513,
              "shapeOffsetM": 5.226,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:5662",
              "position": {
                "x": 1154.205,
                "z": -829.633
              },
              "distanceAlongShapeM": 6807.603,
              "shapeOffsetM": 4.939,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            },
            {
              "stopId": "judu:stop:5664",
              "position": {
                "x": 729.54,
                "z": -744.998
              },
              "distanceAlongShapeM": 7240.809,
              "shapeOffsetM": 5.498,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:677",
              "position": {
                "x": 364.219,
                "z": -693.772
              },
              "distanceAlongShapeM": 7615.986,
              "shapeOffsetM": 6.934,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:6843",
              "position": {
                "x": 297.35,
                "z": -1318.188
              },
              "distanceAlongShapeM": 8356.077,
              "shapeOffsetM": 3.231,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            },
            {
              "stopId": "judu:stop:6542",
              "position": {
                "x": 673.267,
                "z": -1632.329
              },
              "distanceAlongShapeM": 9114.013,
              "shapeOffsetM": 4.373,
              "arrivalOffsetSeconds": 1500,
              "departureOffsetSeconds": 1500
            }
          ],
          "departuresSeconds": [
            19740,
            22860,
            26460,
            30540,
            36420,
            39960,
            43560,
            46920,
            50460,
            54060,
            58080,
            62340,
            68700,
            72300,
            75720,
            79080
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_bus_38",
      "sourceRouteId": "vilnius_bus_38",
      "mode": "bus",
      "shortName": "38",
      "longName": "Antakalnis–Dvarčionys–Šilėnų g.",
      "color": "0073AC",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_bus_38:0",
          "sourceRouteId": "vilnius_bus_38",
          "sourceShapeId": "vilnius_bus_38_a1-b1",
          "directionId": 0,
          "headsign": "Šilėnų g.",
          "directionName": "Antakalnis–Dvarčionys–Vismaliukai–Šilėnų g.",
          "mode": "bus",
          "routeShortName": "38",
          "routeLongName": "Antakalnis–Dvarčionys–Šilėnų g.",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              2558.505,
              -3824.161,
              0
            ],
            [
              2555.4,
              -3867.621,
              43.571
            ],
            [
              2550.54,
              -3888.998,
              65.493
            ],
            [
              2499.38,
              -3984.027,
              173.418
            ],
            [
              2491.557,
              -3988.308,
              182.336
            ],
            [
              2481.913,
              -3989.406,
              192.042
            ],
            [
              2463.338,
              -3985.439,
              211.036
            ],
            [
              2456.234,
              -3979.843,
              220.08
            ],
            [
              2451.32,
              -3969.766,
              231.291
            ],
            [
              2449.513,
              -3963.053,
              238.243
            ],
            [
              2474.189,
              -3849.964,
              353.993
            ],
            [
              2506.597,
              -3737.02,
              471.494
            ],
            [
              2515.783,
              -3728.287,
              484.169
            ],
            [
              2532.532,
              -3728.601,
              500.921
            ],
            [
              2540.338,
              -3736.718,
              512.182
            ],
            [
              2566.251,
              -3786.011,
              567.872
            ],
            [
              2598.162,
              -3836.707,
              627.775
            ],
            [
              2614.638,
              -3851.49,
              649.911
            ],
            [
              2635.392,
              -3877.441,
              683.14
            ],
            [
              2642.893,
              -3890.985,
              698.622
            ],
            [
              2709.56,
              -3977.961,
              808.209
            ],
            [
              3021.059,
              -4338.966,
              1285.028
            ],
            [
              3086.352,
              -4293.444,
              1364.624
            ],
            [
              3112.838,
              -4272.891,
              1398.149
            ],
            [
              3142.482,
              -4255.542,
              1432.496
            ],
            [
              3336.938,
              -4126.748,
              1665.737
            ],
            [
              3389.682,
              -4097.691,
              1725.955
            ],
            [
              3403.448,
              -4088.142,
              1742.708
            ],
            [
              3446.229,
              -4072.046,
              1788.418
            ],
            [
              3528.69,
              -4039.102,
              1877.216
            ],
            [
              3592.048,
              -4028.061,
              1941.529
            ],
            [
              3640.778,
              -4019.583,
              1990.991
            ],
            [
              3666.294,
              -4020.567,
              2016.526
            ],
            [
              3848.026,
              -4019.578,
              2198.26
            ],
            [
              3878.881,
              -4023.507,
              2229.364
            ],
            [
              3901.964,
              -4029.514,
              2253.216
            ],
            [
              3958.181,
              -4055.079,
              2314.973
            ],
            [
              3965.111,
              -4059.221,
              2323.047
            ],
            [
              4003.977,
              -4097.523,
              2377.614
            ],
            [
              4018.762,
              -4121.92,
              2406.141
            ],
            [
              4037.773,
              -4172.381,
              2460.065
            ],
            [
              4076.734,
              -4257.734,
              2553.89
            ],
            [
              4093.076,
              -4279.199,
              2580.868
            ],
            [
              4128.571,
              -4309.937,
              2627.822
            ],
            [
              4222.379,
              -4357.378,
              2732.944
            ],
            [
              4258.043,
              -4379.213,
              2774.761
            ],
            [
              4380.089,
              -4463.989,
              2923.362
            ],
            [
              4409.879,
              -4485.153,
              2959.905
            ],
            [
              4437.325,
              -4505.114,
              2993.842
            ],
            [
              4500.992,
              -4543.134,
              3067.997
            ],
            [
              4784.007,
              -4703.272,
              3393.176
            ],
            [
              4912.858,
              -4770.329,
              3538.432
            ],
            [
              4956.995,
              -4786.768,
              3585.531
            ],
            [
              4973.727,
              -4792.975,
              3603.377
            ],
            [
              5002.978,
              -4807.696,
              3636.124
            ],
            [
              5509.136,
              -5005.307,
              4179.489
            ],
            [
              5765.06,
              -5109.726,
              4455.895
            ],
            [
              5806.767,
              -5118.333,
              4498.481
            ],
            [
              5878.63,
              -5129.051,
              4571.139
            ],
            [
              5891.491,
              -5134.461,
              4585.091
            ],
            [
              5956.294,
              -5147.973,
              4651.288
            ],
            [
              5988.132,
              -5134.123,
              4686.008
            ],
            [
              5995.156,
              -5125.955,
              4696.781
            ],
            [
              6011.57,
              -4989.855,
              4833.867
            ],
            [
              6021.457,
              -4945.517,
              4879.294
            ],
            [
              6027.558,
              -4930.051,
              4895.92
            ],
            [
              6092.568,
              -4834.468,
              5011.516
            ],
            [
              6127.551,
              -4791.735,
              5066.742
            ],
            [
              6152.504,
              -4767.731,
              5101.366
            ],
            [
              6159.829,
              -4755.629,
              5115.512
            ],
            [
              6161.4,
              -4741.187,
              5130.04
            ],
            [
              6125.051,
              -4655.893,
              5222.756
            ],
            [
              6001.369,
              -4687.956,
              5350.526
            ],
            [
              5943.985,
              -4702.264,
              5409.667
            ],
            [
              5887.559,
              -4716.566,
              5467.877
            ],
            [
              5850.665,
              -4726.952,
              5506.205
            ],
            [
              5840.825,
              -4727.158,
              5516.048
            ],
            [
              5842.74,
              -4726.38,
              5518.114
            ],
            [
              5842.929,
              -4726.317,
              5518.314
            ],
            [
              5876.327,
              -4719.282,
              5552.445
            ],
            [
              5917.574,
              -4709.024,
              5594.949
            ],
            [
              6088.174,
              -4665.357,
              5771.048
            ],
            [
              6114.992,
              -4655.609,
              5799.583
            ],
            [
              6125.051,
              -4655.893,
              5809.646
            ],
            [
              6136.422,
              -4666.325,
              5825.077
            ],
            [
              6142.269,
              -4679.446,
              5839.442
            ],
            [
              6157.107,
              -4716.379,
              5879.244
            ],
            [
              6163.114,
              -4752.353,
              5915.716
            ],
            [
              6148.487,
              -4775.446,
              5943.052
            ],
            [
              6122.934,
              -4797.211,
              5976.618
            ],
            [
              6095.897,
              -4828.966,
              6018.324
            ],
            [
              6024.895,
              -4934.452,
              6145.479
            ],
            [
              6018.15,
              -4949.906,
              6162.341
            ],
            [
              6009.703,
              -4986.479,
              6199.877
            ],
            [
              6001.73,
              -5101.059,
              6314.734
            ],
            [
              6002.517,
              -5123.272,
              6336.961
            ],
            [
              6007.161,
              -5135.764,
              6350.288
            ],
            [
              6016.623,
              -5161.362,
              6377.579
            ],
            [
              6030.604,
              -5169.466,
              6393.739
            ],
            [
              6078.772,
              -5177.089,
              6442.506
            ],
            [
              6272.282,
              -5197.581,
              6637.098
            ],
            [
              6739.794,
              -5240.179,
              7106.547
            ],
            [
              6910.627,
              -5258.468,
              7278.357
            ],
            [
              7009.219,
              -5271.64,
              7377.824
            ],
            [
              7655.857,
              -5403.073,
              8037.684
            ],
            [
              7709.038,
              -5417.492,
              8092.785
            ],
            [
              7740.925,
              -5433.715,
              8128.562
            ],
            [
              7791.434,
              -5473.105,
              8192.614
            ],
            [
              7852.17,
              -5508.3,
              8262.811
            ],
            [
              7918.972,
              -5517.522,
              8330.246
            ],
            [
              7947.874,
              -5518.947,
              8359.183
            ],
            [
              7968.947,
              -5526.348,
              8381.519
            ],
            [
              7969.509,
              -5538.756,
              8393.94
            ],
            [
              7801.253,
              -5670.938,
              8607.907
            ],
            [
              7791.372,
              -5681.873,
              8622.645
            ],
            [
              7782.646,
              -5699.512,
              8642.324
            ],
            [
              7724.095,
              -5954.402,
              8903.853
            ],
            [
              7696.143,
              -6031.775,
              8986.12
            ],
            [
              7655.004,
              -6156.757,
              9117.699
            ],
            [
              7645.716,
              -6190.071,
              9152.283
            ],
            [
              7635.141,
              -6240.82,
              9204.122
            ],
            [
              7604.789,
              -6349.47,
              9316.932
            ],
            [
              7581.913,
              -6443.656,
              9413.857
            ],
            [
              7581.97,
              -6460.345,
              9430.546
            ],
            [
              7624.685,
              -6611.491,
              9587.611
            ],
            [
              7815.833,
              -6820.768,
              9871.044
            ],
            [
              7812.887,
              -7009.16,
              10059.46
            ],
            [
              7808.948,
              -7043.931,
              10094.452
            ],
            [
              7822.133,
              -7044.052,
              10107.638
            ],
            [
              7889.516,
              -6996.864,
              10189.901
            ],
            [
              7946.909,
              -6955.256,
              10260.789
            ],
            [
              8133.579,
              -6875.162,
              10463.917
            ],
            [
              8270.1,
              -6831.477,
              10607.257
            ],
            [
              8500.97,
              -6730.159,
              10859.38
            ],
            [
              8661.032,
              -6734.692,
              11019.506
            ],
            [
              8725.69,
              -6795.501,
              11108.267
            ],
            [
              8743.77,
              -6815.406,
              11135.157
            ],
            [
              8769.288,
              -6859.34,
              11185.964
            ],
            [
              8811.72,
              -6990.454,
              11323.773
            ],
            [
              8831.702,
              -7038.842,
              11376.125
            ],
            [
              8840.288,
              -7074.529,
              11412.83
            ],
            [
              8842.787,
              -7110.205,
              11448.594
            ],
            [
              8833.916,
              -7166.805,
              11505.885
            ],
            [
              8808.211,
              -7259.803,
              11602.37
            ],
            [
              8804.858,
              -7266.415,
              11609.783
            ],
            [
              8689.309,
              -7344.241,
              11749.097
            ],
            [
              8709.034,
              -7375.034,
              11785.666
            ],
            [
              8754.783,
              -7450.213,
              11873.671
            ],
            [
              8815.27,
              -7516.006,
              11963.043
            ],
            [
              8840.873,
              -7555.49,
              12010.102
            ],
            [
              8838.717,
              -7566.579,
              12021.399
            ],
            [
              8830.709,
              -7575.171,
              12033.143
            ],
            [
              8740.224,
              -7629.162,
              12138.512
            ],
            [
              8636.103,
              -7460.065,
              12337.095
            ],
            [
              8624.741,
              -7444.459,
              12356.399
            ],
            [
              8611.785,
              -7420.609,
              12383.541
            ],
            [
              8598.028,
              -7400.292,
              12408.077
            ],
            [
              8710.221,
              -7329.076,
              12540.964
            ],
            [
              8774.644,
              -7283.594,
              12619.825
            ],
            [
              8800.928,
              -7269.676,
              12649.566
            ],
            [
              8831.861,
              -7174.563,
              12749.582
            ],
            [
              8841.27,
              -7126.88,
              12798.185
            ],
            [
              8842.04,
              -7083.471,
              12841.601
            ],
            [
              8822.812,
              -7015.17,
              12912.557
            ],
            [
              8791.65,
              -6937.061,
              12996.652
            ],
            [
              8763.786,
              -6844.756,
              13093.071
            ],
            [
              8729.505,
              -6799.541,
              13149.813
            ],
            [
              8682.918,
              -6757.659,
              13212.458
            ],
            [
              8663.036,
              -6736.822,
              13241.258
            ],
            [
              8681.047,
              -6733.039,
              13259.662
            ],
            [
              8768.632,
              -6722.274,
              13347.905
            ],
            [
              8837.144,
              -6709.095,
              13417.674
            ],
            [
              8904.622,
              -6712.089,
              13485.218
            ],
            [
              8917.475,
              -6716.019,
              13498.658
            ],
            [
              8934.427,
              -6723.361,
              13517.132
            ],
            [
              8952.632,
              -6734.066,
              13538.251
            ],
            [
              8961.784,
              -6746.917,
              13554.028
            ],
            [
              8990.713,
              -6800.715,
              13615.111
            ],
            [
              9004.489,
              -6820.675,
              13639.363
            ],
            [
              9020.866,
              -6838.82,
              13663.806
            ],
            [
              9048.157,
              -6861.544,
              13699.319
            ],
            [
              9099.676,
              -6890.515,
              13758.425
            ],
            [
              9130.35,
              -6902.269,
              13791.274
            ],
            [
              9162.356,
              -6911.825,
              13824.676
            ],
            [
              9247.126,
              -6923.564,
              13910.255
            ],
            [
              9337.78,
              -6930.971,
              14001.211
            ],
            [
              9409.762,
              -6941.984,
              14074.031
            ],
            [
              9455.198,
              -6952.284,
              14120.62
            ],
            [
              9476.26,
              -6961.619,
              14143.658
            ],
            [
              9516.643,
              -6986.313,
              14190.993
            ],
            [
              9530.873,
              -6999.47,
              14210.373
            ],
            [
              9549.427,
              -7021.193,
              14238.941
            ],
            [
              9558.844,
              -7049.025,
              14268.323
            ],
            [
              9556.661,
              -7053.783,
              14273.558
            ],
            [
              9544.344,
              -7053.36,
              14285.882
            ],
            [
              9538.339,
              -7047.346,
              14294.381
            ],
            [
              9536.335,
              -7041.159,
              14300.885
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:5483",
              "position": {
                "x": 2562.319,
                "z": -3823.788
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 3.832,
              "arrivalOffsetSeconds": -540,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:741",
              "position": {
                "x": 2636.723,
                "z": -3876.397
              },
              "distanceAlongShapeM": 683.14,
              "shapeOffsetM": 1.691,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:5104",
              "position": {
                "x": 3111.27,
                "z": -4270.537
              },
              "distanceAlongShapeM": 1398.149,
              "shapeOffsetM": 2.828,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:5105",
              "position": {
                "x": 3402.776,
                "z": -4086.807
              },
              "distanceAlongShapeM": 1742.708,
              "shapeOffsetM": 1.495,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:5107",
              "position": {
                "x": 3640.634,
                "z": -4014.513
              },
              "distanceAlongShapeM": 1990.991,
              "shapeOffsetM": 5.072,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:900",
              "position": {
                "x": 3967.843,
                "z": -4055.264
              },
              "distanceAlongShapeM": 2323.047,
              "shapeOffsetM": 4.809,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:6170",
              "position": {
                "x": 4412.655,
                "z": -4481.261
              },
              "distanceAlongShapeM": 2959.905,
              "shapeOffsetM": 4.78,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:6174",
              "position": {
                "x": 4975.65,
                "z": -4788.242
              },
              "distanceAlongShapeM": 3603.377,
              "shapeOffsetM": 5.109,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:6176",
              "position": {
                "x": 5878.72,
                "z": -5128.645
              },
              "distanceAlongShapeM": 4571.139,
              "shapeOffsetM": 0.416,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:6179",
              "position": {
                "x": 6139.84,
                "z": -4690.667
              },
              "distanceAlongShapeM": 5184.968,
              "shapeOffsetM": 0.028,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:6181",
              "position": {
                "x": 5860.806,
                "z": -4726.4
              },
              "distanceAlongShapeM": 5496.294,
              "shapeOffsetM": 2.217,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            },
            {
              "stopId": "judu:stop:8250",
              "position": {
                "x": 6147.186,
                "z": -4677.451
              },
              "distanceAlongShapeM": 5839.442,
              "shapeOffsetM": 5.306,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:6183",
              "position": {
                "x": 7009.8,
                "z": -5268.893
              },
              "distanceAlongShapeM": 7377.847,
              "shapeOffsetM": 2.808,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:16307",
              "position": {
                "x": 7913.164,
                "z": -5582.996
              },
              "distanceAlongShapeM": 8465.577,
              "shapeOffsetM": 0.02,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            },
            {
              "stopId": "judu:stop:6895",
              "position": {
                "x": 7635.934,
                "z": -6240.988
              },
              "distanceAlongShapeM": 9204.122,
              "shapeOffsetM": 0.81,
              "arrivalOffsetSeconds": 1380,
              "departureOffsetSeconds": 1380
            },
            {
              "stopId": "judu:stop:6899",
              "position": {
                "x": 7824.11,
                "z": -7009.579
              },
              "distanceAlongShapeM": 10059.46,
              "shapeOffsetM": 11.231,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            },
            {
              "stopId": "judu:stop:16425",
              "position": {
                "x": 8711.254,
                "z": -7373.63
              },
              "distanceAlongShapeM": 11785.666,
              "shapeOffsetM": 2.627,
              "arrivalOffsetSeconds": 1620,
              "departureOffsetSeconds": 1620
            },
            {
              "stopId": "judu:stop:17952",
              "position": {
                "x": 8787.127,
                "z": -7602.276
              },
              "distanceAlongShapeM": 12084.458,
              "shapeOffsetM": 0.945,
              "arrivalOffsetSeconds": 1680,
              "departureOffsetSeconds": 1680
            },
            {
              "stopId": "judu:stop:16424",
              "position": {
                "x": 8621.568,
                "z": -7446.412
              },
              "distanceAlongShapeM": 12356.399,
              "shapeOffsetM": 3.726,
              "arrivalOffsetSeconds": 1680,
              "departureOffsetSeconds": 1680
            },
            {
              "stopId": "judu:stop:16422",
              "position": {
                "x": 8772.381,
                "z": -7280.232
              },
              "distanceAlongShapeM": 12619.825,
              "shapeOffsetM": 4.053,
              "arrivalOffsetSeconds": 1740,
              "departureOffsetSeconds": 1740
            },
            {
              "stopId": "judu:stop:6901",
              "position": {
                "x": 8836.787,
                "z": -6705.953
              },
              "distanceAlongShapeM": 13417.674,
              "shapeOffsetM": 3.163,
              "arrivalOffsetSeconds": 1860,
              "departureOffsetSeconds": 1860
            },
            {
              "stopId": "judu:stop:976",
              "position": {
                "x": 9537.116,
                "z": -7040.79
              },
              "distanceAlongShapeM": 14300.885,
              "shapeOffsetM": 0.864,
              "arrivalOffsetSeconds": 1980,
              "departureOffsetSeconds": 1980
            }
          ],
          "departuresSeconds": [
            23940,
            26520,
            29040,
            31500,
            34140,
            38160,
            43200,
            48120,
            53400,
            55800,
            58320,
            60840,
            65760
          ]
        },
        {
          "id": "judu:pattern:vilnius_bus_38:1",
          "sourceRouteId": "vilnius_bus_38",
          "sourceShapeId": "vilnius_bus_38_b1-a1",
          "directionId": 1,
          "headsign": "Antakalnis",
          "directionName": "Šilėnų g.–Vismaliukai–Dvarčionys–Antakalnis",
          "mode": "bus",
          "routeShortName": "38",
          "routeLongName": "Antakalnis–Dvarčionys–Šilėnų g.",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              9536.335,
              -7041.159,
              0
            ],
            [
              9533.503,
              -7028.47,
              13.001
            ],
            [
              9533.888,
              -7018.485,
              22.994
            ],
            [
              9533.165,
              -7005.109,
              36.389
            ],
            [
              9525.148,
              -6996.014,
              48.513
            ],
            [
              9464.12,
              -6956.919,
              120.99
            ],
            [
              9445.61,
              -6948.749,
              141.222
            ],
            [
              9357.668,
              -6934.715,
              230.277
            ],
            [
              9243.885,
              -6924.612,
              344.508
            ],
            [
              9201.489,
              -6919.298,
              387.236
            ],
            [
              9186.773,
              -6914.546,
              402.7
            ],
            [
              9163.705,
              -6912.585,
              425.851
            ],
            [
              9088.201,
              -6884.716,
              506.334
            ],
            [
              9029.9,
              -6848.729,
              574.847
            ],
            [
              9005.641,
              -6827.378,
              607.164
            ],
            [
              8996.259,
              -6816.668,
              621.403
            ],
            [
              8980.103,
              -6784.556,
              657.349
            ],
            [
              8955.253,
              -6739.521,
              708.785
            ],
            [
              8930.482,
              -6721.263,
              739.559
            ],
            [
              8899.142,
              -6711.667,
              772.334
            ],
            [
              8842.491,
              -6710.522,
              828.997
            ],
            [
              8818.357,
              -6715.581,
              853.656
            ],
            [
              8761.085,
              -6723.351,
              911.452
            ],
            [
              8693.423,
              -6731.735,
              979.632
            ],
            [
              8677.77,
              -6735.03,
              995.628
            ],
            [
              8670.071,
              -6733.825,
              1003.421
            ],
            [
              8668.069,
              -6737.061,
              1007.226
            ],
            [
              8666.449,
              -6745.601,
              1015.918
            ],
            [
              8737.733,
              -6808.483,
              1110.974
            ],
            [
              8766.758,
              -6857.062,
              1167.563
            ],
            [
              8790.366,
              -6933.475,
              1247.541
            ],
            [
              8839.802,
              -7066.726,
              1389.666
            ],
            [
              8841.972,
              -7086.809,
              1409.866
            ],
            [
              8841.6,
              -7122.451,
              1445.51
            ],
            [
              8828.961,
              -7188.971,
              1513.22
            ],
            [
              8810.232,
              -7255.391,
              1582.23
            ],
            [
              8802.216,
              -7269.702,
              1598.633
            ],
            [
              8688.022,
              -7344.215,
              1734.987
            ],
            [
              8709.034,
              -7375.034,
              1772.288
            ],
            [
              8754.783,
              -7450.213,
              1860.292
            ],
            [
              8815.27,
              -7516.006,
              1949.665
            ],
            [
              8840.873,
              -7555.49,
              1996.723
            ],
            [
              8838.717,
              -7566.579,
              2008.02
            ],
            [
              8830.709,
              -7575.171,
              2019.764
            ],
            [
              8740.224,
              -7629.162,
              2125.134
            ],
            [
              8636.103,
              -7460.065,
              2323.716
            ],
            [
              8624.741,
              -7444.459,
              2343.02
            ],
            [
              8611.785,
              -7420.609,
              2370.162
            ],
            [
              8598.028,
              -7400.292,
              2394.698
            ],
            [
              8710.221,
              -7329.076,
              2527.585
            ],
            [
              8774.644,
              -7283.594,
              2606.446
            ],
            [
              8804.835,
              -7267.528,
              2640.645
            ],
            [
              8815.899,
              -7229.899,
              2679.867
            ],
            [
              8832.935,
              -7183.484,
              2729.31
            ],
            [
              8843.184,
              -7122.459,
              2791.189
            ],
            [
              8841.86,
              -7092.373,
              2821.305
            ],
            [
              8836.232,
              -7052.181,
              2861.889
            ],
            [
              8800.096,
              -6960.16,
              2960.751
            ],
            [
              8772.993,
              -6867.208,
              3057.573
            ],
            [
              8755.687,
              -6831.233,
              3097.495
            ],
            [
              8738.103,
              -6808.881,
              3125.934
            ],
            [
              8660.965,
              -6738.031,
              3230.672
            ],
            [
              8507.953,
              -6729.807,
              3383.904
            ],
            [
              8373.852,
              -6792.036,
              3531.741
            ],
            [
              8277.045,
              -6829.962,
              3635.712
            ],
            [
              8157.951,
              -6868.192,
              3760.792
            ],
            [
              8081.364,
              -6898.405,
              3843.123
            ],
            [
              7949.49,
              -6953.409,
              3986.008
            ],
            [
              7915.248,
              -6977.832,
              4028.067
            ],
            [
              7853.939,
              -7025.616,
              4105.799
            ],
            [
              7826.018,
              -7043.016,
              4138.697
            ],
            [
              7809.174,
              -7043.171,
              4155.542
            ],
            [
              7810.028,
              -7009.355,
              4189.369
            ],
            [
              7814.771,
              -6832.378,
              4366.409
            ],
            [
              7811.308,
              -6812.269,
              4386.814
            ],
            [
              7628.808,
              -6621.3,
              4650.965
            ],
            [
              7581.97,
              -6460.345,
              4818.596
            ],
            [
              7581.804,
              -6446.985,
              4831.957
            ],
            [
              7617.025,
              -6297.887,
              4985.159
            ],
            [
              7651.767,
              -6166.909,
              5120.666
            ],
            [
              7709.064,
              -5997.521,
              5299.482
            ],
            [
              7737.395,
              -5901.229,
              5399.856
            ],
            [
              7780.648,
              -5702.812,
              5602.932
            ],
            [
              7791.372,
              -5681.873,
              5626.458
            ],
            [
              7932.238,
              -5563.338,
              5810.56
            ],
            [
              7942.378,
              -5549.082,
              5828.055
            ],
            [
              7942.986,
              -5541.287,
              5835.873
            ],
            [
              7938.723,
              -5528.956,
              5848.92
            ],
            [
              7930.146,
              -5522.413,
              5859.708
            ],
            [
              7918.962,
              -5518.541,
              5871.544
            ],
            [
              7892.106,
              -5518.7,
              5898.4
            ],
            [
              6930.794,
              -5263.749,
              6892.946
            ],
            [
              6784.784,
              -5245.52,
              7040.089
            ],
            [
              6137.243,
              -5184.914,
              7690.46
            ],
            [
              6011.533,
              -5169.201,
              7817.149
            ],
            [
              5986.3,
              -5161.92,
              7843.411
            ],
            [
              5981.499,
              -5158.246,
              7849.456
            ],
            [
              5980.83,
              -5145.113,
              7862.607
            ],
            [
              5992.039,
              -5131.973,
              7879.878
            ],
            [
              5997.747,
              -5122.02,
              7891.352
            ],
            [
              6009.977,
              -5005.41,
              8008.601
            ],
            [
              6012.226,
              -4969.877,
              8044.205
            ],
            [
              6022.232,
              -4938.853,
              8076.803
            ],
            [
              6026.936,
              -4928.925,
              8087.789
            ],
            [
              6102.313,
              -4821.094,
              8219.353
            ],
            [
              6130.193,
              -4788.447,
              8262.285
            ],
            [
              6148.553,
              -4772.107,
              8286.863
            ],
            [
              6156.478,
              -4762.243,
              8299.516
            ],
            [
              6161.248,
              -4748.977,
              8313.614
            ],
            [
              6159.686,
              -4730.021,
              8332.634
            ],
            [
              6140.414,
              -4690.434,
              8376.663
            ],
            [
              6125.051,
              -4655.893,
              8414.466
            ],
            [
              6001.369,
              -4687.956,
              8542.236
            ],
            [
              5943.985,
              -4702.264,
              8601.377
            ],
            [
              5887.559,
              -4716.566,
              8659.588
            ],
            [
              5850.665,
              -4726.952,
              8697.915
            ],
            [
              5840.825,
              -4727.158,
              8707.758
            ],
            [
              5842.74,
              -4726.38,
              8709.825
            ],
            [
              5842.929,
              -4726.317,
              8710.024
            ],
            [
              5876.327,
              -4719.282,
              8744.156
            ],
            [
              5917.574,
              -4709.024,
              8786.659
            ],
            [
              6088.174,
              -4665.357,
              8962.759
            ],
            [
              6114.992,
              -4655.609,
              8991.294
            ],
            [
              6125.051,
              -4655.893,
              9001.356
            ],
            [
              6136.422,
              -4666.325,
              9016.787
            ],
            [
              6142.269,
              -4679.446,
              9031.152
            ],
            [
              6158.391,
              -4720.832,
              9075.568
            ],
            [
              6163.78,
              -4751.253,
              9106.462
            ],
            [
              6151.795,
              -4771.057,
              9129.611
            ],
            [
              6112.346,
              -4811.476,
              9186.09
            ],
            [
              6090.548,
              -4838.881,
              9221.107
            ],
            [
              6026.248,
              -4931.138,
              9333.561
            ],
            [
              6016.775,
              -4954.332,
              9358.615
            ],
            [
              6009.203,
              -5012.074,
              9416.851
            ],
            [
              6000.05,
              -5117.657,
              9522.83
            ],
            [
              6007.267,
              -5136.206,
              9542.734
            ],
            [
              6013.543,
              -5152.433,
              9560.132
            ],
            [
              6017.881,
              -5162.508,
              9571.102
            ],
            [
              6016.502,
              -5165.85,
              9574.716
            ],
            [
              5956.294,
              -5147.973,
              9637.522
            ],
            [
              5814.308,
              -5121.089,
              9782.032
            ],
            [
              5758.991,
              -5108.418,
              9838.781
            ],
            [
              5655.118,
              -5065.278,
              9951.256
            ],
            [
              5349.652,
              -4947.461,
              10278.656
            ],
            [
              5090.698,
              -4844.537,
              10557.313
            ],
            [
              4956.995,
              -4786.768,
              10702.963
            ],
            [
              4922.404,
              -4776.733,
              10738.981
            ],
            [
              4893.064,
              -4761.041,
              10772.253
            ],
            [
              4762.926,
              -4693.959,
              10918.663
            ],
            [
              4470.367,
              -4529.128,
              11254.461
            ],
            [
              4430.884,
              -4504.99,
              11300.738
            ],
            [
              4360.976,
              -4454.664,
              11386.876
            ],
            [
              4345.928,
              -4445.468,
              11404.511
            ],
            [
              4316.488,
              -4422.639,
              11441.766
            ],
            [
              4266.267,
              -4387.164,
              11503.252
            ],
            [
              4203.85,
              -4349.23,
              11576.293
            ],
            [
              4164.858,
              -4332.897,
              11618.567
            ],
            [
              4107.571,
              -4296.175,
              11686.614
            ],
            [
              4086.034,
              -4276.838,
              11715.558
            ],
            [
              4073.041,
              -4259.008,
              11737.619
            ],
            [
              4054.871,
              -4221.691,
              11779.125
            ],
            [
              4018.762,
              -4121.92,
              11885.229
            ],
            [
              3999.262,
              -4097.055,
              11916.829
            ],
            [
              3970.079,
              -4073.119,
              11954.572
            ],
            [
              3943.496,
              -4057.143,
              11985.587
            ],
            [
              3899.276,
              -4037.251,
              12034.075
            ],
            [
              3898.616,
              -4036.13,
              12035.376
            ],
            [
              3858.828,
              -4027.577,
              12076.073
            ],
            [
              3592.048,
              -4028.061,
              12342.853
            ],
            [
              3581.678,
              -4031.203,
              12353.689
            ],
            [
              3564.996,
              -4038.354,
              12371.839
            ],
            [
              3520.083,
              -4051.184,
              12418.548
            ],
            [
              3445.458,
              -4078.711,
              12498.088
            ],
            [
              3358.965,
              -4120.486,
              12594.141
            ],
            [
              3358.852,
              -4122.75,
              12596.409
            ],
            [
              3310.064,
              -4150.73,
              12652.65
            ],
            [
              3021.059,
              -4338.966,
              12997.551
            ],
            [
              2959.695,
              -4278.804,
              13083.487
            ],
            [
              2940.311,
              -4262.522,
              13108.802
            ],
            [
              2920.517,
              -4237.987,
              13140.326
            ],
            [
              2810.169,
              -4110.107,
              13309.234
            ],
            [
              2739.116,
              -4050.879,
              13401.736
            ],
            [
              2661.391,
              -4003.772,
              13492.621
            ],
            [
              2637.654,
              -3993.387,
              13518.531
            ],
            [
              2609.738,
              -3974.969,
              13551.975
            ],
            [
              2502.106,
              -3906.664,
              13679.451
            ],
            [
              2488.357,
              -3884.741,
              13705.329
            ],
            [
              2476.247,
              -3843.323,
              13748.481
            ],
            [
              2501.318,
              -3743.601,
              13851.306
            ],
            [
              2515.139,
              -3728.275,
              13871.944
            ],
            [
              2523.372,
              -3727.648,
              13880.201
            ],
            [
              2540.053,
              -3739.875,
              13900.883
            ],
            [
              2551,
              -3774.592,
              13937.285
            ],
            [
              2558.505,
              -3824.161,
              13987.419
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:976",
              "position": {
                "x": 9537.116,
                "z": -7040.79
              },
              "distanceAlongShapeM": 0.19,
              "shapeOffsetM": 0.842,
              "arrivalOffsetSeconds": -420,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:6902",
              "position": {
                "x": 8819.091,
                "z": -6721.182
              },
              "distanceAlongShapeM": 853.681,
              "shapeOffsetM": 5.649,
              "arrivalOffsetSeconds": 60,
              "departureOffsetSeconds": 60
            },
            {
              "stopId": "judu:stop:16425",
              "position": {
                "x": 8711.254,
                "z": -7373.63
              },
              "distanceAlongShapeM": 1772.288,
              "shapeOffsetM": 2.627,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:17952",
              "position": {
                "x": 8787.127,
                "z": -7602.276
              },
              "distanceAlongShapeM": 2071.079,
              "shapeOffsetM": 0.945,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:16424",
              "position": {
                "x": 8621.568,
                "z": -7446.412
              },
              "distanceAlongShapeM": 2343.02,
              "shapeOffsetM": 3.726,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:16422",
              "position": {
                "x": 8772.381,
                "z": -7280.232
              },
              "distanceAlongShapeM": 2606.446,
              "shapeOffsetM": 4.053,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:6898",
              "position": {
                "x": 7806.73,
                "z": -7009.232
              },
              "distanceAlongShapeM": 4189.403,
              "shapeOffsetM": 3.3,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:6896",
              "position": {
                "x": 7614.845,
                "z": -6297.345
              },
              "distanceAlongShapeM": 4985.159,
              "shapeOffsetM": 2.247,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:16306",
              "position": {
                "x": 7891.85,
                "z": -5521.339
              },
              "distanceAlongShapeM": 5898.4,
              "shapeOffsetM": 2.651,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:6184",
              "position": {
                "x": 6930.636,
                "z": -5265.1
              },
              "distanceAlongShapeM": 6892.752,
              "shapeOffsetM": 1.346,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:6179",
              "position": {
                "x": 6139.84,
                "z": -4690.667
              },
              "distanceAlongShapeM": 8376.683,
              "shapeOffsetM": 0.619,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:429",
              "position": {
                "x": 5873.348,
                "z": -4711.059
              },
              "distanceAlongShapeM": 8742.935,
              "shapeOffsetM": 8.661,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:6180",
              "position": {
                "x": 6155.144,
                "z": -4698.76
              },
              "distanceAlongShapeM": 9053.823,
              "shapeOffsetM": 4.986,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:6177",
              "position": {
                "x": 5813.742,
                "z": -5124.036
              },
              "distanceAlongShapeM": 9782.032,
              "shapeOffsetM": 3.001,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:6173",
              "position": {
                "x": 4921.724,
                "z": -4778.293
              },
              "distanceAlongShapeM": 10738.981,
              "shapeOffsetM": 1.702,
              "arrivalOffsetSeconds": 1350,
              "departureOffsetSeconds": 1350
            },
            {
              "stopId": "judu:stop:6171",
              "position": {
                "x": 4344.358,
                "z": -4447.665
              },
              "distanceAlongShapeM": 11404.511,
              "shapeOffsetM": 2.701,
              "arrivalOffsetSeconds": 1410,
              "departureOffsetSeconds": 1410
            },
            {
              "stopId": "judu:stop:6239",
              "position": {
                "x": 3898.552,
                "z": -4039.468
              },
              "distanceAlongShapeM": 12033.826,
              "shapeOffsetM": 2.319,
              "arrivalOffsetSeconds": 1500,
              "departureOffsetSeconds": 1500
            },
            {
              "stopId": "judu:stop:5116",
              "position": {
                "x": 3565.986,
                "z": -4043.151
              },
              "distanceAlongShapeM": 12372.204,
              "shapeOffsetM": 4.885,
              "arrivalOffsetSeconds": 1560,
              "departureOffsetSeconds": 1560
            },
            {
              "stopId": "judu:stop:6715",
              "position": {
                "x": 3360.169,
                "z": -4124.962
              },
              "distanceAlongShapeM": 12596.409,
              "shapeOffsetM": 2.574,
              "arrivalOffsetSeconds": 1620,
              "departureOffsetSeconds": 1620
            },
            {
              "stopId": "judu:stop:5103",
              "position": {
                "x": 2937.404,
                "z": -4265.024
              },
              "distanceAlongShapeM": 13108.802,
              "shapeOffsetM": 3.836,
              "arrivalOffsetSeconds": 1740,
              "departureOffsetSeconds": 1740
            },
            {
              "stopId": "judu:stop:5117",
              "position": {
                "x": 2636.416,
                "z": -3995.509
              },
              "distanceAlongShapeM": 13518.531,
              "shapeOffsetM": 2.457,
              "arrivalOffsetSeconds": 1800,
              "departureOffsetSeconds": 1800
            },
            {
              "stopId": "judu:stop:5483",
              "position": {
                "x": 2562.319,
                "z": -3823.788
              },
              "distanceAlongShapeM": 13987.419,
              "shapeOffsetM": 3.832,
              "arrivalOffsetSeconds": 1890,
              "departureOffsetSeconds": 1890
            }
          ],
          "departuresSeconds": [
            26520,
            29040,
            31440,
            33840,
            37020,
            40680,
            45540,
            50820,
            55860,
            58380,
            60780,
            63300,
            65760,
            68160
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_bus_39",
      "sourceRouteId": "vilnius_bus_39",
      "mode": "bus",
      "shortName": "39",
      "longName": "Antakalnis–Nemenčinės pl.–Balžio g.",
      "color": "0073AC",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_bus_39:0",
          "sourceRouteId": "vilnius_bus_39",
          "sourceShapeId": "vilnius_bus_39_a-b",
          "directionId": 0,
          "headsign": "Balžio g.",
          "directionName": "Antakalnis–Nemenčinės pl.–Balžio g.",
          "mode": "bus",
          "routeShortName": "39",
          "routeLongName": "Antakalnis–Nemenčinės pl.–Balžio g.",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              2558.505,
              -3824.161,
              0
            ],
            [
              2555.4,
              -3867.621,
              43.571
            ],
            [
              2550.54,
              -3888.998,
              65.493
            ],
            [
              2499.38,
              -3984.027,
              173.418
            ],
            [
              2491.557,
              -3988.308,
              182.336
            ],
            [
              2481.913,
              -3989.406,
              192.042
            ],
            [
              2463.338,
              -3985.439,
              211.036
            ],
            [
              2456.234,
              -3979.843,
              220.08
            ],
            [
              2451.32,
              -3969.766,
              231.291
            ],
            [
              2449.513,
              -3963.053,
              238.243
            ],
            [
              2474.189,
              -3849.964,
              353.993
            ],
            [
              2506.597,
              -3737.02,
              471.494
            ],
            [
              2515.783,
              -3728.287,
              484.169
            ],
            [
              2532.532,
              -3728.601,
              500.921
            ],
            [
              2540.338,
              -3736.718,
              512.182
            ],
            [
              2566.251,
              -3786.011,
              567.872
            ],
            [
              2598.162,
              -3836.707,
              627.775
            ],
            [
              2614.638,
              -3851.49,
              649.911
            ],
            [
              2635.392,
              -3877.441,
              683.14
            ],
            [
              2642.893,
              -3890.985,
              698.622
            ],
            [
              2709.56,
              -3977.961,
              808.209
            ],
            [
              3021.059,
              -4338.966,
              1285.028
            ],
            [
              3040.626,
              -4360.488,
              1314.116
            ],
            [
              3055.715,
              -4376.506,
              1336.121
            ],
            [
              3068.958,
              -4395.535,
              1359.305
            ],
            [
              3153.475,
              -4491.761,
              1487.377
            ],
            [
              3273.19,
              -4634.3,
              1673.52
            ],
            [
              3311.137,
              -4671.757,
              1726.84
            ],
            [
              3331.492,
              -4694.37,
              1757.265
            ],
            [
              3344.656,
              -4709.628,
              1777.416
            ],
            [
              3435.309,
              -4816.612,
              1917.643
            ],
            [
              3777.629,
              -5210.544,
              2439.53
            ],
            [
              4146.482,
              -5643.721,
              3008.471
            ],
            [
              4168.317,
              -5663.414,
              3037.875
            ],
            [
              4198.544,
              -5701.751,
              3086.695
            ],
            [
              4479.429,
              -6026.379,
              3515.974
            ],
            [
              4583.65,
              -6150.351,
              3677.934
            ],
            [
              4780.064,
              -6376.448,
              3977.43
            ],
            [
              4845.472,
              -6457.867,
              4081.868
            ],
            [
              4963.748,
              -6636.051,
              4295.734
            ],
            [
              4993.701,
              -6685.615,
              4353.646
            ],
            [
              5053.853,
              -6775.422,
              4461.737
            ],
            [
              5115.634,
              -6873.894,
              4577.985
            ],
            [
              5492.477,
              -7463.46,
              5277.698
            ],
            [
              5510.414,
              -7489.1,
              5308.99
            ],
            [
              5529.947,
              -7523.193,
              5348.282
            ],
            [
              5547.262,
              -7548.172,
              5378.675
            ],
            [
              5756.997,
              -7898.345,
              5786.854
            ],
            [
              5981.39,
              -8266.524,
              6218.024
            ],
            [
              6023.483,
              -8337.838,
              6300.834
            ],
            [
              6501.767,
              -9354.534,
              7424.412
            ],
            [
              6638.284,
              -9666.853,
              7765.264
            ],
            [
              6649.358,
              -9715.066,
              7814.732
            ],
            [
              6653.677,
              -9767.354,
              7867.198
            ],
            [
              6674.775,
              -9774.45,
              7889.458
            ],
            [
              6698.847,
              -9793.851,
              7920.375
            ],
            [
              6734.411,
              -9820.369,
              7964.737
            ],
            [
              6760.157,
              -9866.236,
              8017.335
            ],
            [
              6768.205,
              -9866.472,
              8025.387
            ],
            [
              6775.128,
              -9874.402,
              8035.914
            ],
            [
              6776.838,
              -9885.569,
              8047.211
            ],
            [
              6822.284,
              -9897.143,
              8094.108
            ],
            [
              7045.916,
              -10076.817,
              8380.977
            ],
            [
              7141.062,
              -10168.864,
              8513.361
            ],
            [
              7431.846,
              -10377.284,
              8871.123
            ],
            [
              7902.342,
              -10709.089,
              9446.85
            ],
            [
              7941.354,
              -10734.07,
              9493.175
            ],
            [
              8244.035,
              -10943.662,
              9861.339
            ],
            [
              8873.229,
              -11380.865,
              10627.519
            ],
            [
              9040.656,
              -11505.384,
              10836.173
            ],
            [
              9091.585,
              -11548.088,
              10902.637
            ],
            [
              9201.141,
              -11617.782,
              11032.482
            ],
            [
              9361.557,
              -11735.681,
              11231.563
            ],
            [
              9477.369,
              -11806.795,
              11367.466
            ],
            [
              9537.24,
              -11837.053,
              11434.549
            ],
            [
              9559.02,
              -11840.746,
              11456.64
            ],
            [
              9629.371,
              -11829.895,
              11527.823
            ],
            [
              9651.569,
              -11831.773,
              11550.1
            ],
            [
              9677.606,
              -11840.575,
              11577.585
            ],
            [
              9735.766,
              -11891.917,
              11655.165
            ],
            [
              9760.772,
              -11907.283,
              11684.514
            ],
            [
              9778.232,
              -11912.982,
              11702.881
            ],
            [
              9989.307,
              -11950.551,
              11917.273
            ],
            [
              10008.73,
              -11954.207,
              11937.037
            ],
            [
              10021,
              -11959.537,
              11950.414
            ],
            [
              10023.089,
              -11961.694,
              11953.418
            ],
            [
              10007.521,
              -11989.166,
              11984.995
            ],
            [
              9975.473,
              -11985.761,
              12017.223
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:5483",
              "position": {
                "x": 2562.319,
                "z": -3823.788
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 3.832,
              "arrivalOffsetSeconds": -600,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:741",
              "position": {
                "x": 2636.723,
                "z": -3876.397
              },
              "distanceAlongShapeM": 683.14,
              "shapeOffsetM": 1.691,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:3566",
              "position": {
                "x": 3057.099,
                "z": -4375.272
              },
              "distanceAlongShapeM": 1336.121,
              "shapeOffsetM": 1.854,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:6081",
              "position": {
                "x": 3335.252,
                "z": -4691.14
              },
              "distanceAlongShapeM": 1757.275,
              "shapeOffsetM": 4.956,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:950",
              "position": {
                "x": 3777.629,
                "z": -5210.544
              },
              "distanceAlongShapeM": 2439.53,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:6140",
              "position": {
                "x": 4170.98,
                "z": -5661.145
              },
              "distanceAlongShapeM": 3037.875,
              "shapeOffsetM": 3.499,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:6143",
              "position": {
                "x": 4481.556,
                "z": -6024.468
              },
              "distanceAlongShapeM": 3515.92,
              "shapeOffsetM": 2.859,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:6147",
              "position": {
                "x": 5058.349,
                "z": -6772.589
              },
              "distanceAlongShapeM": 4461.737,
              "shapeOffsetM": 5.314,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:6148",
              "position": {
                "x": 5515.215,
                "z": -7486.168
              },
              "distanceAlongShapeM": 5308.99,
              "shapeOffsetM": 5.625,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:6153",
              "position": {
                "x": 6029.809,
                "z": -8334.524
              },
              "distanceAlongShapeM": 6300.834,
              "shapeOffsetM": 7.141,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:6155",
              "position": {
                "x": 6506.105,
                "z": -9352.524
              },
              "distanceAlongShapeM": 7424.412,
              "shapeOffsetM": 4.781,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:7319",
              "position": {
                "x": 6738.316,
                "z": -9815.783
              },
              "distanceAlongShapeM": 7964.737,
              "shapeOffsetM": 6.023,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:6905",
              "position": {
                "x": 7950.707,
                "z": -10720.526
              },
              "distanceAlongShapeM": 9493.175,
              "shapeOffsetM": 16.46,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:7471",
              "position": {
                "x": 9539.313,
                "z": -11829.211
              },
              "distanceAlongShapeM": 11432.862,
              "shapeOffsetM": 7.935,
              "arrivalOffsetSeconds": 1380,
              "departureOffsetSeconds": 1380
            },
            {
              "stopId": "judu:stop:7470",
              "position": {
                "x": 9977.079,
                "z": -11970.645
              },
              "distanceAlongShapeM": 12017.223,
              "shapeOffsetM": 15.201,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            }
          ],
          "departuresSeconds": [
            18120,
            20400,
            21780,
            22860,
            24060,
            25440,
            26820,
            28200,
            29700,
            31080,
            32700,
            36000,
            38640,
            40440,
            42240,
            44100,
            45960,
            47820,
            49680,
            51600,
            53460,
            54480,
            55680,
            57060,
            58260,
            59460,
            60900,
            62280,
            63660,
            65040,
            66360,
            69900,
            71640,
            73500,
            75300,
            76980,
            79020,
            80700,
            82680,
            84360
          ]
        },
        {
          "id": "judu:pattern:vilnius_bus_39:1",
          "sourceRouteId": "vilnius_bus_39",
          "sourceShapeId": "vilnius_bus_39_b-a",
          "directionId": 1,
          "headsign": "Antakalnis",
          "directionName": "Balžio g.–Nemenčinės pl.–Antakalnis",
          "mode": "bus",
          "routeShortName": "39",
          "routeLongName": "Antakalnis–Nemenčinės pl.–Balžio g.",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              9975.473,
              -11985.761,
              0
            ],
            [
              9975.967,
              -11948.04,
              37.724
            ],
            [
              9959.465,
              -11944.934,
              54.516
            ],
            [
              9791.031,
              -11914.51,
              225.676
            ],
            [
              9767.47,
              -11907.806,
              250.171
            ],
            [
              9756.969,
              -11903.416,
              261.553
            ],
            [
              9725.456,
              -11880.289,
              300.642
            ],
            [
              9687.868,
              -11847.496,
              350.525
            ],
            [
              9659.383,
              -11833.461,
              382.279
            ],
            [
              9636.993,
              -11830.104,
              404.92
            ],
            [
              9562.235,
              -11840.811,
              480.44
            ],
            [
              9526.988,
              -11833.454,
              516.447
            ],
            [
              9503.573,
              -11823.525,
              541.88
            ],
            [
              9477.369,
              -11806.795,
              572.969
            ],
            [
              9361.075,
              -11736.514,
              708.851
            ],
            [
              9177.223,
              -11602.496,
              936.364
            ],
            [
              9085.142,
              -11543.869,
              1045.525
            ],
            [
              9000.368,
              -11473.124,
              1155.94
            ],
            [
              8949.665,
              -11435.358,
              1219.162
            ],
            [
              8739.038,
              -11288.591,
              1475.88
            ],
            [
              8534.607,
              -11147.82,
              1724.091
            ],
            [
              7902.69,
              -10708.432,
              2493.754
            ],
            [
              7862.148,
              -10681.82,
              2542.25
            ],
            [
              7379.16,
              -10340.993,
              3133.384
            ],
            [
              7123.386,
              -10156.34,
              3448.848
            ],
            [
              7069.852,
              -10102.243,
              3524.956
            ],
            [
              7056.746,
              -10086.522,
              3545.423
            ],
            [
              6826.777,
              -9898.999,
              3842.157
            ],
            [
              6781.936,
              -9889.197,
              3888.056
            ],
            [
              6770.872,
              -9894.358,
              3900.265
            ],
            [
              6766.127,
              -9898.951,
              3906.869
            ],
            [
              6759.144,
              -9899.933,
              3913.92
            ],
            [
              6745.652,
              -9892.62,
              3929.266
            ],
            [
              6740.342,
              -9885.498,
              3938.15
            ],
            [
              6634.115,
              -9879.818,
              4044.53
            ],
            [
              6639.065,
              -9827.377,
              4097.203
            ],
            [
              6641.096,
              -9752.632,
              4171.976
            ],
            [
              6629.211,
              -9670.014,
              4255.445
            ],
            [
              6616.981,
              -9637.487,
              4290.195
            ],
            [
              6560.251,
              -9511.679,
              4428.202
            ],
            [
              6537.201,
              -9465.963,
              4479.4
            ],
            [
              6333.896,
              -9010.693,
              4978.002
            ],
            [
              6109.136,
              -8524.224,
              5513.884
            ],
            [
              6084.291,
              -8478.092,
              5566.281
            ],
            [
              5995.189,
              -8327.166,
              5741.546
            ],
            [
              5966.681,
              -8280.092,
              5796.579
            ],
            [
              5943.813,
              -8246.371,
              5837.322
            ],
            [
              5718.303,
              -7868.644,
              6277.246
            ],
            [
              5531.206,
              -7557.73,
              6640.113
            ],
            [
              5498.755,
              -7504.773,
              6702.222
            ],
            [
              5460.94,
              -7445.074,
              6772.89
            ],
            [
              5438.248,
              -7404.514,
              6819.366
            ],
            [
              5196.866,
              -7023.685,
              7270.25
            ],
            [
              5048.284,
              -6793.546,
              7544.185
            ],
            [
              5013.85,
              -6744.741,
              7603.915
            ],
            [
              5008.891,
              -6732.667,
              7616.968
            ],
            [
              4990.138,
              -6703.359,
              7651.762
            ],
            [
              4903.043,
              -6578.1,
              7804.324
            ],
            [
              4831.501,
              -6480.976,
              7924.953
            ],
            [
              4576.487,
              -6178.813,
              8320.345
            ],
            [
              4434.336,
              -6018.807,
              8534.375
            ],
            [
              4391.884,
              -5964.854,
              8603.027
            ],
            [
              4192.109,
              -5735.026,
              8907.545
            ],
            [
              4068.653,
              -5589.049,
              9098.727
            ],
            [
              4055.494,
              -5577.515,
              9116.225
            ],
            [
              4018.912,
              -5529.094,
              9176.912
            ],
            [
              3747.122,
              -5188.81,
              9612.415
            ],
            [
              3704.824,
              -5143.473,
              9674.419
            ],
            [
              3685.238,
              -5124.116,
              9701.957
            ],
            [
              3665.724,
              -5099.311,
              9733.517
            ],
            [
              3449.572,
              -4845.828,
              10066.647
            ],
            [
              3395.411,
              -4790.022,
              10144.415
            ],
            [
              3252.761,
              -4658.405,
              10338.507
            ],
            [
              3244.62,
              -4646.005,
              10353.341
            ],
            [
              3235.159,
              -4601.295,
              10399.041
            ],
            [
              3218.877,
              -4576.495,
              10428.708
            ],
            [
              3193.34,
              -4554.253,
              10462.573
            ],
            [
              3172.809,
              -4525.525,
              10497.883
            ],
            [
              3060.003,
              -4392.026,
              10672.661
            ],
            [
              3021.059,
              -4338.966,
              10738.479
            ],
            [
              2961.544,
              -4283.292,
              10819.975
            ],
            [
              2940.311,
              -4262.522,
              10849.677
            ],
            [
              2920.517,
              -4237.987,
              10881.201
            ],
            [
              2810.169,
              -4110.107,
              11050.11
            ],
            [
              2739.116,
              -4050.879,
              11142.611
            ],
            [
              2661.391,
              -4003.772,
              11233.497
            ],
            [
              2637.654,
              -3993.387,
              11259.407
            ],
            [
              2609.738,
              -3974.969,
              11292.85
            ],
            [
              2502.106,
              -3906.664,
              11420.327
            ],
            [
              2488.357,
              -3884.741,
              11446.204
            ],
            [
              2476.247,
              -3843.323,
              11489.357
            ],
            [
              2501.318,
              -3743.601,
              11592.182
            ],
            [
              2515.139,
              -3728.275,
              11612.819
            ],
            [
              2523.372,
              -3727.648,
              11621.076
            ],
            [
              2540.053,
              -3739.875,
              11641.758
            ],
            [
              2551,
              -3774.592,
              11678.16
            ],
            [
              2558.505,
              -3824.161,
              11728.295
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:7470",
              "position": {
                "x": 9977.079,
                "z": -11970.645
              },
              "distanceAlongShapeM": 15.136,
              "shapeOffsetM": 1.408,
              "arrivalOffsetSeconds": -300,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:6907",
              "position": {
                "x": 9498.734,
                "z": -11831.723
              },
              "distanceAlongShapeM": 541.88,
              "shapeOffsetM": 9.52,
              "arrivalOffsetSeconds": 60,
              "departureOffsetSeconds": 60
            },
            {
              "stopId": "judu:stop:6906",
              "position": {
                "x": 7856.737,
                "z": -10689.699
              },
              "distanceAlongShapeM": 2542.25,
              "shapeOffsetM": 9.558,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:18892",
              "position": {
                "x": 6631.904,
                "z": -9827.042
              },
              "distanceAlongShapeM": 4096.864,
              "shapeOffsetM": 7.161,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:6154",
              "position": {
                "x": 6530.846,
                "z": -9468.794
              },
              "distanceAlongShapeM": 4479.407,
              "shapeOffsetM": 6.957,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:6152",
              "position": {
                "x": 5939.418,
                "z": -8249.257
              },
              "distanceAlongShapeM": 5837.322,
              "shapeOffsetM": 5.258,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:6149",
              "position": {
                "x": 5457.379,
                "z": -7447.191
              },
              "distanceAlongShapeM": 6772.89,
              "shapeOffsetM": 4.143,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:6146",
              "position": {
                "x": 5011.851,
                "z": -6746.083
              },
              "distanceAlongShapeM": 7603.915,
              "shapeOffsetM": 2.408,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:6144",
              "position": {
                "x": 4433.996,
                "z": -6019.1
              },
              "distanceAlongShapeM": 8534.375,
              "shapeOffsetM": 0.449,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:6142",
              "position": {
                "x": 4052.725,
                "z": -5579.838
              },
              "distanceAlongShapeM": 9116.225,
              "shapeOffsetM": 3.614,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            },
            {
              "stopId": "judu:stop:6141",
              "position": {
                "x": 3682.602,
                "z": -5126.351
              },
              "distanceAlongShapeM": 9701.957,
              "shapeOffsetM": 3.456,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:6079",
              "position": {
                "x": 3190.252,
                "z": -4557.027
              },
              "distanceAlongShapeM": 10462.573,
              "shapeOffsetM": 4.151,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:5103",
              "position": {
                "x": 2937.404,
                "z": -4265.024
              },
              "distanceAlongShapeM": 10849.677,
              "shapeOffsetM": 3.836,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:5117",
              "position": {
                "x": 2636.416,
                "z": -3995.509
              },
              "distanceAlongShapeM": 11259.407,
              "shapeOffsetM": 2.457,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:5483",
              "position": {
                "x": 2562.319,
                "z": -3823.788
              },
              "distanceAlongShapeM": 11728.295,
              "shapeOffsetM": 3.832,
              "arrivalOffsetSeconds": 1380,
              "departureOffsetSeconds": 1380
            }
          ],
          "departuresSeconds": [
            19800,
            22020,
            23520,
            24720,
            26100,
            27540,
            28920,
            30300,
            31800,
            33180,
            34500,
            37860,
            40380,
            42120,
            43920,
            45840,
            47700,
            49560,
            51420,
            53340,
            55200,
            56280,
            57420,
            58800,
            60300,
            61500,
            62940,
            64320,
            65640,
            67140,
            68460,
            71700,
            73320,
            75180,
            77040,
            78720,
            80700,
            82440,
            84420,
            86040
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_bus_40",
      "sourceRouteId": "vilnius_bus_40",
      "mode": "bus",
      "shortName": "40",
      "longName": "Perkūnkiemis–Fabijoniškės–S.Stanevičiaus g.–Centras (Apylanka)",
      "color": "0073AC",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_bus_40:0",
          "sourceRouteId": "vilnius_bus_40",
          "sourceShapeId": "vilnius_bus_40_a1-b1",
          "directionId": 0,
          "headsign": "Centras (Apylanka)",
          "directionName": "Perkūnkiemis–Fabijoniškės–S.Stanevičiaus g.–Centras (Apylanka)",
          "mode": "bus",
          "routeShortName": "40",
          "routeLongName": "Perkūnkiemis–Fabijoniškės–S.Stanevičiaus g.–Centras (Apylanka)",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              -3846.109,
              -5119.902,
              0
            ],
            [
              -3862.028,
              -5154.789,
              38.347
            ],
            [
              -3896.745,
              -5150.846,
              73.287
            ],
            [
              -3904.981,
              -5142.911,
              84.724
            ],
            [
              -3906.076,
              -5131.759,
              95.93
            ],
            [
              -3903.757,
              -5109.535,
              118.274
            ],
            [
              -3869.632,
              -5096.489,
              154.808
            ],
            [
              -3868.639,
              -5091.898,
              159.505
            ],
            [
              -3866.173,
              -5086.493,
              165.446
            ],
            [
              -3845.952,
              -5058.592,
              199.904
            ],
            [
              -3847.945,
              -5048.709,
              209.986
            ],
            [
              -3872.993,
              -5044.39,
              235.403
            ],
            [
              -4005.398,
              -5041.282,
              367.845
            ],
            [
              -4035.808,
              -5039.998,
              398.282
            ],
            [
              -4047.31,
              -5059.234,
              420.695
            ],
            [
              -4054.001,
              -5192.645,
              554.273
            ],
            [
              -3973.672,
              -5345.865,
              727.274
            ],
            [
              -3834.829,
              -5591.359,
              1009.31
            ],
            [
              -3810.406,
              -5638.374,
              1062.29
            ],
            [
              -3680.31,
              -5890.449,
              1345.957
            ],
            [
              -3658.942,
              -5920.878,
              1383.139
            ],
            [
              -3616.192,
              -5943.888,
              1431.688
            ],
            [
              -3597.481,
              -5956.808,
              1454.426
            ],
            [
              -3499.935,
              -6109.56,
              1635.668
            ],
            [
              -3397.106,
              -5968.821,
              1809.97
            ],
            [
              -3296.359,
              -5830.43,
              1981.149
            ],
            [
              -3212.127,
              -5730.24,
              2112.041
            ],
            [
              -3175.031,
              -5687.77,
              2168.432
            ],
            [
              -3157.197,
              -5662.479,
              2199.378
            ],
            [
              -3141.704,
              -5623.788,
              2241.056
            ],
            [
              -3109.741,
              -5527.498,
              2342.512
            ],
            [
              -3092.92,
              -5486.604,
              2386.73
            ],
            [
              -3036.804,
              -5399.141,
              2490.648
            ],
            [
              -3033.871,
              -5388.564,
              2501.624
            ],
            [
              -2977.67,
              -5306.06,
              2601.451
            ],
            [
              -2859.367,
              -5119.841,
              2822.071
            ],
            [
              -2787.712,
              -4995.277,
              2965.774
            ],
            [
              -2737.802,
              -4912.753,
              3062.217
            ],
            [
              -2672.209,
              -4823.848,
              3172.7
            ],
            [
              -2619.375,
              -4786.931,
              3237.154
            ],
            [
              -2578.679,
              -4744.234,
              3296.139
            ],
            [
              -2552.315,
              -4687.753,
              3358.469
            ],
            [
              -2488.392,
              -4702.414,
              3424.052
            ],
            [
              -2436.56,
              -4722.255,
              3479.552
            ],
            [
              -2367.109,
              -4765.787,
              3561.518
            ],
            [
              -2297.928,
              -4830.879,
              3656.507
            ],
            [
              -2247.29,
              -4911.517,
              3751.727
            ],
            [
              -2239.148,
              -4925.337,
              3767.767
            ],
            [
              -2217.405,
              -4969.935,
              3817.383
            ],
            [
              -2110.315,
              -5178.897,
              4052.188
            ],
            [
              -2057.336,
              -5161.028,
              4108.099
            ],
            [
              -2028.76,
              -5156.969,
              4136.962
            ],
            [
              -1894.397,
              -5142.15,
              4272.14
            ],
            [
              -1856.383,
              -5135.547,
              4310.723
            ],
            [
              -1800.644,
              -5116.503,
              4369.625
            ],
            [
              -1770.723,
              -5100.339,
              4403.633
            ],
            [
              -1738.711,
              -5075.306,
              4444.271
            ],
            [
              -1710.503,
              -5046.865,
              4484.328
            ],
            [
              -1676.24,
              -5004.061,
              4539.157
            ],
            [
              -1664.171,
              -4977.559,
              4568.277
            ],
            [
              -1655.392,
              -4950.998,
              4596.252
            ],
            [
              -1638.506,
              -4911.224,
              4639.462
            ],
            [
              -1626.337,
              -4879.158,
              4673.759
            ],
            [
              -1604.435,
              -4807.19,
              4748.986
            ],
            [
              -1592.551,
              -4755.08,
              4802.434
            ],
            [
              -1586.265,
              -4691.738,
              4866.087
            ],
            [
              -1583.358,
              -4637.242,
              4920.66
            ],
            [
              -1588.338,
              -4591.511,
              4966.662
            ],
            [
              -1592.703,
              -4555.313,
              5003.122
            ],
            [
              -1592.123,
              -4561.86,
              5009.695
            ],
            [
              -1595.437,
              -4520.137,
              5051.549
            ],
            [
              -1616.287,
              -4244.797,
              5327.677
            ],
            [
              -1631.856,
              -4106.478,
              5466.87
            ],
            [
              -1635.514,
              -4066.939,
              5506.578
            ],
            [
              -1637.064,
              -4037.365,
              5536.192
            ],
            [
              -1635.048,
              -3960.588,
              5612.996
            ],
            [
              -1628.98,
              -3909.488,
              5664.455
            ],
            [
              -1609.35,
              -3809.976,
              5765.884
            ],
            [
              -1543.192,
              -3688.376,
              5904.316
            ],
            [
              -1515.42,
              -3648.796,
              5952.668
            ],
            [
              -1479.438,
              -3582.647,
              6027.97
            ],
            [
              -1461.972,
              -3542.883,
              6071.401
            ],
            [
              -1437.625,
              -3478.752,
              6139.998
            ],
            [
              -1385.229,
              -3323.838,
              6303.533
            ],
            [
              -1372.596,
              -3266.177,
              6362.561
            ],
            [
              -1370.241,
              -3230.903,
              6397.914
            ],
            [
              -1363.568,
              -3193.979,
              6435.436
            ],
            [
              -1359.808,
              -3163.989,
              6465.661
            ],
            [
              -1360.179,
              -3112.774,
              6516.877
            ],
            [
              -1362.723,
              -3074.878,
              6554.858
            ],
            [
              -1386.134,
              -2978.721,
              6653.824
            ],
            [
              -1409.242,
              -2901.495,
              6734.433
            ],
            [
              -1418.932,
              -2871.362,
              6766.087
            ],
            [
              -1430.357,
              -2820.964,
              6817.763
            ],
            [
              -1448.996,
              -2746.044,
              6894.967
            ],
            [
              -1452.909,
              -2712.577,
              6928.662
            ],
            [
              -1453.659,
              -2682.507,
              6958.741
            ],
            [
              -1443.344,
              -2610.331,
              7031.65
            ],
            [
              -1428.471,
              -2571.635,
              7073.106
            ],
            [
              -1415.77,
              -2546.258,
              7101.484
            ],
            [
              -1386.622,
              -2502.251,
              7154.269
            ],
            [
              -1448.618,
              -2469.866,
              7224.214
            ],
            [
              -1516.935,
              -2436.464,
              7300.259
            ],
            [
              -1567.016,
              -2425.55,
              7351.516
            ],
            [
              -1613.955,
              -2419.145,
              7398.89
            ],
            [
              -1678.312,
              -2413.543,
              7463.49
            ],
            [
              -1901.727,
              -2399.542,
              7687.343
            ],
            [
              -1904.451,
              -2409.591,
              7697.755
            ],
            [
              -1909.619,
              -2525.597,
              7813.876
            ],
            [
              -1934.345,
              -2592.607,
              7885.302
            ],
            [
              -1938.838,
              -2601.488,
              7895.255
            ],
            [
              -2055.259,
              -2914.461,
              8229.18
            ],
            [
              -2054.675,
              -2917.811,
              8232.581
            ],
            [
              -2048.251,
              -2919.038,
              8239.121
            ],
            [
              -2034.057,
              -2918.177,
              8253.341
            ],
            [
              -2023.689,
              -2915.022,
              8264.178
            ],
            [
              -2013.222,
              -2906.302,
              8277.802
            ],
            [
              -1995.719,
              -2864.311,
              8323.295
            ],
            [
              -1946.309,
              -2731.603,
              8464.902
            ],
            [
              -1893.853,
              -2608.968,
              8598.285
            ],
            [
              -1860.774,
              -2597.312,
              8633.358
            ],
            [
              -1798.045,
              -2477.088,
              8768.963
            ],
            [
              -1803.09,
              -2434.696,
              8811.654
            ],
            [
              -1743.312,
              -2335.571,
              8927.409
            ],
            [
              -1745.639,
              -2333.352,
              8930.624
            ],
            [
              -1727.311,
              -2305.799,
              8963.716
            ],
            [
              -1547.472,
              -2017.345,
              9303.639
            ],
            [
              -1343.434,
              -1674.784,
              9702.362
            ],
            [
              -1305.861,
              -1628.702,
              9761.82
            ],
            [
              -1268.647,
              -1602.651,
              9807.246
            ],
            [
              -1054.592,
              -1494.059,
              10047.27
            ],
            [
              -1027.103,
              -1471.176,
              10083.037
            ],
            [
              -1009.966,
              -1450.333,
              10110.021
            ],
            [
              -998.422,
              -1410.718,
              10151.284
            ],
            [
              -987.78,
              -1363.9,
              10199.296
            ],
            [
              -988.723,
              -1201.352,
              10361.847
            ],
            [
              -990.397,
              -1186.85,
              10376.445
            ],
            [
              -1017.615,
              -1122.906,
              10445.941
            ],
            [
              -1020.518,
              -1105.042,
              10464.039
            ],
            [
              -1018.304,
              -1089.497,
              10479.741
            ],
            [
              -1013.532,
              -1075.111,
              10494.898
            ],
            [
              -1005.537,
              -1060.783,
              10511.305
            ],
            [
              -990.532,
              -1051.034,
              10529.199
            ],
            [
              -976.596,
              -1029.02,
              10555.254
            ],
            [
              -969.87,
              -1013.556,
              10572.117
            ],
            [
              -967.031,
              -999.135,
              10586.815
            ],
            [
              -963.614,
              -973.419,
              10612.757
            ],
            [
              -954.808,
              -934.814,
              10652.354
            ],
            [
              -945.547,
              -916.03,
              10673.296
            ],
            [
              -940.714,
              -898.305,
              10691.669
            ],
            [
              -936.79,
              -859.413,
              10730.758
            ],
            [
              -924.604,
              -648.119,
              10942.403
            ],
            [
              -926.501,
              -610.235,
              10980.335
            ],
            [
              -934.701,
              -600.068,
              10993.396
            ],
            [
              -944.29,
              -595.443,
              11004.042
            ],
            [
              -952.65,
              -594.179,
              11012.497
            ],
            [
              -963.004,
              -596.219,
              11023.05
            ],
            [
              -972.833,
              -604.948,
              11036.196
            ],
            [
              -982.803,
              -621.467,
              11055.49
            ],
            [
              -992.823,
              -641.327,
              11077.735
            ],
            [
              -992.319,
              -666.855,
              11103.268
            ],
            [
              -989.606,
              -677.006,
              11113.775
            ],
            [
              -978.263,
              -691.682,
              11132.324
            ],
            [
              -964.927,
              -703.054,
              11149.85
            ],
            [
              -939.343,
              -714.647,
              11177.938
            ],
            [
              -865.474,
              -730.449,
              11253.478
            ],
            [
              -798.395,
              -729.432,
              11320.565
            ],
            [
              -764.735,
              -722.247,
              11354.983
            ],
            [
              -714.638,
              -697.546,
              11410.839
            ],
            [
              -690.623,
              -676.974,
              11442.46
            ],
            [
              -655.859,
              -656.305,
              11482.905
            ],
            [
              -601.451,
              -607.193,
              11556.2
            ],
            [
              -500.911,
              -503.255,
              11700.808
            ],
            [
              -413.017,
              -421.354,
              11820.946
            ],
            [
              -450.326,
              -380.602,
              11876.197
            ],
            [
              -465.596,
              -369.193,
              11895.259
            ],
            [
              -470.512,
              -355.745,
              11909.577
            ],
            [
              -508.466,
              -314.982,
              11965.274
            ],
            [
              -534.259,
              -344.928,
              12004.796
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:7603",
              "position": {
                "x": -3854.099,
                "z": -5069.209
              },
              "distanceAlongShapeM": 186.526,
              "shapeOffsetM": 0.366,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:15634",
              "position": {
                "x": -3828.987,
                "z": -5588.405
              },
              "distanceAlongShapeM": 1009.382,
              "shapeOffsetM": 6.546,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:16323",
              "position": {
                "x": -3400.186,
                "z": -5966.585
              },
              "distanceAlongShapeM": 1809.958,
              "shapeOffsetM": 3.806,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:7809",
              "position": {
                "x": -3033.871,
                "z": -5388.564
              },
              "distanceAlongShapeM": 2501.624,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:5518",
              "position": {
                "x": -2739.468,
                "z": -4911.72
              },
              "distanceAlongShapeM": 3062.217,
              "shapeOffsetM": 1.96,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:6911",
              "position": {
                "x": -2236.559,
                "z": -4923.953
              },
              "distanceAlongShapeM": 3767.767,
              "shapeOffsetM": 2.936,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:6913",
              "position": {
                "x": -2058.363,
                "z": -5155.329
              },
              "distanceAlongShapeM": 4108.099,
              "shapeOffsetM": 5.79,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:5813",
              "position": {
                "x": -1657.878,
                "z": -4949.841
              },
              "distanceAlongShapeM": 4596.345,
              "shapeOffsetM": 2.74,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:6917",
              "position": {
                "x": -1597.362,
                "z": -4555.726
              },
              "distanceAlongShapeM": 5003.122,
              "shapeOffsetM": 4.677,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            },
            {
              "stopId": "judu:stop:6921",
              "position": {
                "x": -1640.178,
                "z": -4067.366
              },
              "distanceAlongShapeM": 5506.578,
              "shapeOffsetM": 4.683,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:6924",
              "position": {
                "x": -1612.999,
                "z": -3808.47
              },
              "distanceAlongShapeM": 5765.884,
              "shapeOffsetM": 3.947,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:6928",
              "position": {
                "x": -1373.246,
                "z": -3230.542
              },
              "distanceAlongShapeM": 6397.914,
              "shapeOffsetM": 3.027,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:6933",
              "position": {
                "x": -1422.254,
                "z": -2872.318
              },
              "distanceAlongShapeM": 6766.087,
              "shapeOffsetM": 3.457,
              "arrivalOffsetSeconds": 1380,
              "departureOffsetSeconds": 1380
            },
            {
              "stopId": "judu:stop:6937",
              "position": {
                "x": -1450.559,
                "z": -2473.275
              },
              "distanceAlongShapeM": 7224.46,
              "shapeOffsetM": 3.916,
              "arrivalOffsetSeconds": 1500,
              "departureOffsetSeconds": 1500
            },
            {
              "stopId": "judu:stop:5294",
              "position": {
                "x": -1930.967,
                "z": -2593.836
              },
              "distanceAlongShapeM": 7885.286,
              "shapeOffsetM": 3.594,
              "arrivalOffsetSeconds": 1680,
              "departureOffsetSeconds": 1680
            },
            {
              "stopId": "judu:stop:5214",
              "position": {
                "x": -1747.763,
                "z": -2332.152
              },
              "distanceAlongShapeM": 8930.624,
              "shapeOffsetM": 2.44,
              "arrivalOffsetSeconds": 1800,
              "departureOffsetSeconds": 1800
            },
            {
              "stopId": "judu:stop:5220",
              "position": {
                "x": -1001.511,
                "z": -1410.409
              },
              "distanceAlongShapeM": 10150.716,
              "shapeOffsetM": 3.052,
              "arrivalOffsetSeconds": 1980,
              "departureOffsetSeconds": 1980
            },
            {
              "stopId": "judu:stop:5533",
              "position": {
                "x": -969.129,
                "z": -972.38
              },
              "distanceAlongShapeM": 10612.757,
              "shapeOffsetM": 5.612,
              "arrivalOffsetSeconds": 2160,
              "departureOffsetSeconds": 2160
            },
            {
              "stopId": "judu:stop:5539",
              "position": {
                "x": -692.924,
                "z": -673.447
              },
              "distanceAlongShapeM": 11442.46,
              "shapeOffsetM": 4.211,
              "arrivalOffsetSeconds": 2280,
              "departureOffsetSeconds": 2280
            },
            {
              "stopId": "judu:stop:5257",
              "position": {
                "x": -465.596,
                "z": -369.193
              },
              "distanceAlongShapeM": 11895.259,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2460,
              "departureOffsetSeconds": 2460
            },
            {
              "stopId": "judu:stop:5259",
              "position": {
                "x": -532.258,
                "z": -346.835
              },
              "distanceAlongShapeM": 12004.796,
              "shapeOffsetM": 2.765,
              "arrivalOffsetSeconds": 2520,
              "departureOffsetSeconds": 2520
            }
          ],
          "departuresSeconds": [
            18360,
            20100,
            21840,
            23280,
            24300,
            25260,
            26040,
            26880,
            27840,
            29820,
            30840,
            31860,
            33600,
            34200,
            35760,
            37320,
            39540,
            41220,
            42120,
            43140,
            44940,
            47700,
            48480,
            49260,
            51060,
            52920,
            54120,
            54900,
            55620,
            57000,
            58260,
            59520,
            60480,
            61500,
            63180,
            64440,
            65520,
            67620,
            68820,
            70080,
            71340,
            72960,
            74100,
            75360,
            76680,
            78000,
            79140
          ]
        },
        {
          "id": "judu:pattern:vilnius_bus_40:1",
          "sourceRouteId": "vilnius_bus_40",
          "sourceShapeId": "vilnius_bus_40_b-a",
          "directionId": 1,
          "headsign": "Perkūnkiemis",
          "directionName": "Centras–S.Stanevičiaus g.–Fabijoniškės–Perkūnkiemis",
          "mode": "bus",
          "routeShortName": "40",
          "routeLongName": "Perkūnkiemis–Fabijoniškės–S.Stanevičiaus g.–Centras (Apylanka)",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              -534.259,
              -344.928,
              0
            ],
            [
              -695.752,
              -508.638,
              229.958
            ],
            [
              -754.191,
              -530.962,
              292.516
            ],
            [
              -813.838,
              -548.811,
              354.777
            ],
            [
              -813.802,
              -550.154,
              356.12
            ],
            [
              -859.203,
              -561.352,
              402.882
            ],
            [
              -904.096,
              -589.484,
              455.861
            ],
            [
              -914.961,
              -793.012,
              659.679
            ],
            [
              -942.768,
              -1119.8,
              987.648
            ],
            [
              -997.296,
              -1462.806,
              1334.961
            ],
            [
              -1072.846,
              -1524.64,
              1432.589
            ],
            [
              -1114.823,
              -1540.49,
              1477.459
            ],
            [
              -1223.074,
              -1577.865,
              1591.98
            ],
            [
              -1268.647,
              -1602.651,
              1643.858
            ],
            [
              -1297.383,
              -1623.287,
              1679.236
            ],
            [
              -1333.607,
              -1666.054,
              1735.282
            ],
            [
              -1382.029,
              -1741.999,
              1825.35
            ],
            [
              -1597.414,
              -2106.624,
              2248.838
            ],
            [
              -1645.063,
              -2175.906,
              2332.924
            ],
            [
              -1682.619,
              -2257.615,
              2422.851
            ],
            [
              -1702.963,
              -2314.026,
              2482.818
            ],
            [
              -1715.793,
              -2345.231,
              2516.558
            ],
            [
              -1755.799,
              -2415.464,
              2597.385
            ],
            [
              -1791.442,
              -2468.3,
              2661.12
            ],
            [
              -1802.268,
              -2497.051,
              2691.842
            ],
            [
              -1803.487,
              -2529.313,
              2724.127
            ],
            [
              -1788.281,
              -2616.415,
              2812.546
            ],
            [
              -1772.234,
              -2692.401,
              2890.208
            ],
            [
              -1756.203,
              -2739.879,
              2940.32
            ],
            [
              -1746.662,
              -2848.708,
              3049.566
            ],
            [
              -1749.429,
              -2895.414,
              3096.354
            ],
            [
              -1759.481,
              -2953.123,
              3154.932
            ],
            [
              -1775.996,
              -3011.829,
              3215.917
            ],
            [
              -1683.756,
              -3043.532,
              3313.453
            ],
            [
              -1647.191,
              -3053.091,
              3351.246
            ],
            [
              -1571.382,
              -3065.693,
              3428.096
            ],
            [
              -1552.592,
              -3068.149,
              3447.046
            ],
            [
              -1523.92,
              -3071.312,
              3475.891
            ],
            [
              -1491.596,
              -3073.684,
              3508.302
            ],
            [
              -1438.786,
              -3075.742,
              3561.153
            ],
            [
              -1362.723,
              -3074.878,
              3637.22
            ],
            [
              -1357.098,
              -3120.622,
              3683.309
            ],
            [
              -1356.687,
              -3169.611,
              3732.3
            ],
            [
              -1363.762,
              -3240.731,
              3803.771
            ],
            [
              -1372.45,
              -3294.01,
              3857.753
            ],
            [
              -1374.779,
              -3312.201,
              3876.093
            ],
            [
              -1386.916,
              -3346.073,
              3912.074
            ],
            [
              -1441.889,
              -3500.94,
              4076.408
            ],
            [
              -1479.438,
              -3582.647,
              4166.33
            ],
            [
              -1526.789,
              -3671.971,
              4267.429
            ],
            [
              -1572.531,
              -3743.513,
              4352.344
            ],
            [
              -1605.428,
              -3817.511,
              4433.325
            ],
            [
              -1619.047,
              -3858.457,
              4476.476
            ],
            [
              -1621.258,
              -3874.003,
              4492.179
            ],
            [
              -1625.465,
              -3915.925,
              4534.311
            ],
            [
              -1630.122,
              -3937.298,
              4556.186
            ],
            [
              -1635.048,
              -3960.588,
              4579.991
            ],
            [
              -1633.18,
              -4036.321,
              4655.747
            ],
            [
              -1621.037,
              -4150.087,
              4770.159
            ],
            [
              -1615.667,
              -4168.374,
              4789.219
            ],
            [
              -1616.287,
              -4244.797,
              4865.644
            ],
            [
              -1593.127,
              -4499.027,
              5120.927
            ],
            [
              -1582.077,
              -4601.642,
              5224.135
            ],
            [
              -1576.639,
              -4648.623,
              5271.43
            ],
            [
              -1585.129,
              -4736.288,
              5359.505
            ],
            [
              -1597.975,
              -4806.192,
              5430.579
            ],
            [
              -1623.216,
              -4884.78,
              5513.121
            ],
            [
              -1642.847,
              -4937.864,
              5569.719
            ],
            [
              -1699.03,
              -5044.347,
              5690.115
            ],
            [
              -1793.54,
              -5115.517,
              5808.425
            ],
            [
              -1840.927,
              -5135.823,
              5859.979
            ],
            [
              -1904.939,
              -5149.154,
              5925.365
            ],
            [
              -2065.02,
              -5167.456,
              6086.488
            ],
            [
              -2110.315,
              -5178.897,
              6133.206
            ],
            [
              -2136.613,
              -5136.438,
              6183.15
            ],
            [
              -2154.069,
              -5103.533,
              6220.398
            ],
            [
              -2263.659,
              -4890.076,
              6460.344
            ],
            [
              -2297.928,
              -4830.879,
              6528.745
            ],
            [
              -2351.324,
              -4783.879,
              6599.879
            ],
            [
              -2378.887,
              -4764.376,
              6633.644
            ],
            [
              -2406.02,
              -4743.947,
              6667.608
            ],
            [
              -2443.585,
              -4718.791,
              6712.818
            ],
            [
              -2496.725,
              -4700.04,
              6769.169
            ],
            [
              -2552.315,
              -4687.753,
              6826.101
            ],
            [
              -2573.291,
              -4730.97,
              6874.139
            ],
            [
              -2592.46,
              -4758.462,
              6907.654
            ],
            [
              -2618.048,
              -4784.728,
              6944.324
            ],
            [
              -2673.576,
              -4828.277,
              7014.892
            ],
            [
              -2687.375,
              -4843.619,
              7035.527
            ],
            [
              -2770.874,
              -4975.733,
              7191.816
            ],
            [
              -2809.655,
              -5040.042,
              7266.912
            ],
            [
              -2805.159,
              -5032.764,
              7275.467
            ],
            [
              -2888.788,
              -5167.049,
              7433.665
            ],
            [
              -3082.323,
              -5484.648,
              7805.585
            ],
            [
              -3097.62,
              -5504.616,
              7830.739
            ],
            [
              -3107.875,
              -5528.627,
              7856.848
            ],
            [
              -3153.938,
              -5660.309,
              7996.354
            ],
            [
              -3175.09,
              -5691.109,
              8033.718
            ],
            [
              -3295.455,
              -5833.718,
              8220.333
            ],
            [
              -3344.232,
              -5897.431,
              8300.573
            ],
            [
              -3437.312,
              -6027.163,
              8460.243
            ],
            [
              -3453.782,
              -6058.124,
              8495.312
            ],
            [
              -3469.092,
              -6076.703,
              8519.386
            ],
            [
              -3486.182,
              -6096.442,
              8545.495
            ],
            [
              -3493.356,
              -6106.636,
              8557.961
            ],
            [
              -3499.272,
              -6108.459,
              8564.151
            ],
            [
              -3506.094,
              -6100.047,
              8574.982
            ],
            [
              -3587.742,
              -5974.441,
              8724.793
            ],
            [
              -3598.852,
              -5959.573,
              8743.353
            ],
            [
              -3620.055,
              -5943.82,
              8769.767
            ],
            [
              -3632.351,
              -5938.12,
              8783.32
            ],
            [
              -3658.961,
              -5921.991,
              8814.437
            ],
            [
              -3677.032,
              -5899.974,
              8842.92
            ],
            [
              -3687.852,
              -5880.293,
              8865.38
            ],
            [
              -3697.564,
              -5862.541,
              8885.614
            ],
            [
              -3758.86,
              -5741.023,
              9021.717
            ],
            [
              -3880.406,
              -5510.021,
              9282.744
            ],
            [
              -3932.919,
              -5417.334,
              9389.274
            ],
            [
              -3995.884,
              -5305.978,
              9517.199
            ],
            [
              -4047.188,
              -5208.349,
              9627.487
            ],
            [
              -4048.716,
              -5193.793,
              9642.123
            ],
            [
              -4048.98,
              -5125.94,
              9709.976
            ],
            [
              -4046.772,
              -5078.347,
              9757.62
            ],
            [
              -4047.126,
              -5066.426,
              9769.547
            ],
            [
              -4019.327,
              -5040.59,
              9807.498
            ],
            [
              -3998.254,
              -5041.637,
              9828.597
            ],
            [
              -3823.908,
              -5049.815,
              10003.135
            ],
            [
              -3827.684,
              -5087.455,
              10040.964
            ],
            [
              -3836.059,
              -5117.022,
              10071.694
            ],
            [
              -3846.109,
              -5119.902,
              10082.149
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:5259",
              "position": {
                "x": -532.258,
                "z": -346.835
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 2.765,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:10360",
              "position": {
                "x": -813.253,
                "z": -552.161
              },
              "distanceAlongShapeM": 356.12,
              "shapeOffsetM": 2.081,
              "arrivalOffsetSeconds": 60,
              "departureOffsetSeconds": 60
            },
            {
              "stopId": "judu:stop:5289",
              "position": {
                "x": -1070.7,
                "z": -1529.393
              },
              "distanceAlongShapeM": 1432.589,
              "shapeOffsetM": 5.215,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:5290",
              "position": {
                "x": -1711.936,
                "z": -2347.263
              },
              "distanceAlongShapeM": 2516.558,
              "shapeOffsetM": 4.36,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:1042",
              "position": {
                "x": -1749.208,
                "z": -2738.453
              },
              "distanceAlongShapeM": 2940.32,
              "shapeOffsetM": 7.139,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:6940",
              "position": {
                "x": -1551.978,
                "z": -3062.585
              },
              "distanceAlongShapeM": 3446.933,
              "shapeOffsetM": 5.596,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:6929",
              "position": {
                "x": -1372.145,
                "z": -3312.94
              },
              "distanceAlongShapeM": 3876.093,
              "shapeOffsetM": 2.736,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:6926",
              "position": {
                "x": -1622.014,
                "z": -3916.292
              },
              "distanceAlongShapeM": 4534.311,
              "shapeOffsetM": 3.47,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:6922",
              "position": {
                "x": -1612.338,
                "z": -4168.054
              },
              "distanceAlongShapeM": 4789.219,
              "shapeOffsetM": 3.344,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:6918",
              "position": {
                "x": -1574.54,
                "z": -4648.532
              },
              "distanceAlongShapeM": 5271.43,
              "shapeOffsetM": 2.101,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            },
            {
              "stopId": "judu:stop:5811",
              "position": {
                "x": -1696.959,
                "z": -5045.994
              },
              "distanceAlongShapeM": 5690.115,
              "shapeOffsetM": 2.646,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:6914",
              "position": {
                "x": -2139.87,
                "z": -5138.296
              },
              "distanceAlongShapeM": 6183.15,
              "shapeOffsetM": 3.749,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:6763",
              "position": {
                "x": -2381.317,
                "z": -4767.762
              },
              "distanceAlongShapeM": 6633.644,
              "shapeOffsetM": 4.167,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:5519",
              "position": {
                "x": -2803.001,
                "z": -5044.187
              },
              "distanceAlongShapeM": 7266.912,
              "shapeOffsetM": 7.839,
              "arrivalOffsetSeconds": 1380,
              "departureOffsetSeconds": 1380
            },
            {
              "stopId": "judu:stop:7810",
              "position": {
                "x": -3080.666,
                "z": -5485.706
              },
              "distanceAlongShapeM": 7805.585,
              "shapeOffsetM": 1.966,
              "arrivalOffsetSeconds": 1500,
              "departureOffsetSeconds": 1500
            },
            {
              "stopId": "judu:stop:7811",
              "position": {
                "x": -3270.462,
                "z": -5804.099
              },
              "distanceAlongShapeM": 8181.578,
              "shapeOffsetM": 0.005,
              "arrivalOffsetSeconds": 1560,
              "departureOffsetSeconds": 1560
            },
            {
              "stopId": "judu:stop:18831",
              "position": {
                "x": -3448.158,
                "z": -6058.144
              },
              "distanceAlongShapeM": 8492.688,
              "shapeOffsetM": 4.975,
              "arrivalOffsetSeconds": 1620,
              "departureOffsetSeconds": 1620
            },
            {
              "stopId": "judu:stop:15639",
              "position": {
                "x": -3701.111,
                "z": -5864.482
              },
              "distanceAlongShapeM": 8885.614,
              "shapeOffsetM": 4.043,
              "arrivalOffsetSeconds": 1860,
              "departureOffsetSeconds": 1860
            },
            {
              "stopId": "judu:stop:15636",
              "position": {
                "x": -3885.643,
                "z": -5512.834
              },
              "distanceAlongShapeM": 9282.878,
              "shapeOffsetM": 5.944,
              "arrivalOffsetSeconds": 1920,
              "departureOffsetSeconds": 1920
            },
            {
              "stopId": "judu:stop:6931",
              "position": {
                "x": -3827.361,
                "z": -5087.486
              },
              "distanceAlongShapeM": 10040.963,
              "shapeOffsetM": 0.325,
              "arrivalOffsetSeconds": 2100,
              "departureOffsetSeconds": 2100
            }
          ],
          "departuresSeconds": [
            20580,
            22320,
            24120,
            25740,
            26940,
            27960,
            28740,
            29700,
            30660,
            32640,
            33660,
            34680,
            36240,
            36780,
            38220,
            39780,
            42000,
            43740,
            44640,
            45660,
            47460,
            50160,
            50880,
            51720,
            53580,
            55500,
            56700,
            57480,
            58200,
            59820,
            61140,
            62460,
            63420,
            64500,
            66240,
            67200,
            68220,
            70200,
            71400,
            72420,
            73620,
            75240,
            76380,
            77640,
            78900,
            80220,
            81360
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_bus_41",
      "sourceRouteId": "vilnius_bus_41",
      "mode": "bus",
      "shortName": "41",
      "longName": "Stotis–Eišiškių pl.–Užusienis",
      "color": "0073AC",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_bus_41:0",
          "sourceRouteId": "vilnius_bus_41",
          "sourceShapeId": "vilnius_bus_41_a-b",
          "directionId": 0,
          "headsign": "Užusienis",
          "directionName": "Stotis–Eišiškių pl.–Užusienis",
          "mode": "bus",
          "routeShortName": "41",
          "routeLongName": "Stotis–Eišiškių pl.–Užusienis",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              378.73,
              1828.551,
              0
            ],
            [
              425.25,
              1832.153,
              46.659
            ],
            [
              579.14,
              1850.487,
              201.638
            ],
            [
              587.002,
              1857.023,
              211.862
            ],
            [
              594.321,
              1869.134,
              226.012
            ],
            [
              472.814,
              1928.134,
              361.086
            ],
            [
              461.768,
              1923.883,
              372.922
            ],
            [
              443.043,
              1923.113,
              391.663
            ],
            [
              408.316,
              1929.314,
              426.939
            ],
            [
              398.702,
              1932.829,
              437.175
            ],
            [
              373.309,
              1955.558,
              471.255
            ],
            [
              366.499,
              1971.268,
              488.377
            ],
            [
              365.997,
              1979.07,
              496.196
            ],
            [
              369.323,
              1984.575,
              502.627
            ],
            [
              370.213,
              1992.49,
              510.592
            ],
            [
              389.562,
              1997.564,
              530.595
            ],
            [
              401.172,
              1997.352,
              542.207
            ],
            [
              408.871,
              1994.984,
              550.262
            ],
            [
              424.209,
              1986.911,
              567.595
            ],
            [
              467.559,
              1958.288,
              619.542
            ],
            [
              473.887,
              1951.492,
              628.828
            ],
            [
              474.993,
              1941.453,
              638.928
            ],
            [
              465.719,
              1928.264,
              655.051
            ],
            [
              461.143,
              1925.008,
              660.667
            ],
            [
              452.073,
              1922.947,
              669.969
            ],
            [
              409.585,
              1928.177,
              712.777
            ],
            [
              398.6,
              1927.265,
              723.8
            ],
            [
              334.106,
              1822.687,
              846.666
            ],
            [
              318.606,
              1821.856,
              862.188
            ],
            [
              29.934,
              1735.835,
              1163.404
            ],
            [
              -11.394,
              1732.372,
              1204.877
            ],
            [
              -46.755,
              1740.57,
              1241.176
            ],
            [
              -320.217,
              1781.157,
              1517.633
            ],
            [
              -514.905,
              1842.557,
              1721.774
            ],
            [
              -520.923,
              1849.358,
              1730.855
            ],
            [
              -525.385,
              1862.522,
              1744.755
            ],
            [
              -507.688,
              1932.818,
              1817.245
            ],
            [
              -496.901,
              1964.699,
              1850.901
            ],
            [
              -462.075,
              2106.562,
              1996.976
            ],
            [
              -436.719,
              2188.482,
              2082.73
            ],
            [
              -427.991,
              2207.248,
              2103.427
            ],
            [
              -344.32,
              2338.207,
              2258.833
            ],
            [
              -326.137,
              2380.181,
              2304.576
            ],
            [
              -285.296,
              2533.066,
              2462.822
            ],
            [
              -285.194,
              2584.883,
              2514.64
            ],
            [
              -278.622,
              2616.436,
              2546.87
            ],
            [
              -251.706,
              2819.669,
              2751.877
            ],
            [
              -239.003,
              2950.799,
              2883.621
            ],
            [
              -239.164,
              2977.519,
              2910.342
            ],
            [
              -243.808,
              3023.423,
              2956.48
            ],
            [
              -251.845,
              3073.034,
              3006.738
            ],
            [
              -253.335,
              3121.382,
              3055.109
            ],
            [
              -336.623,
              3547.03,
              3488.829
            ],
            [
              -379.958,
              3791.61,
              3737.218
            ],
            [
              -382.016,
              3856.215,
              3801.856
            ],
            [
              -345.945,
              4030.338,
              3979.676
            ],
            [
              -408.418,
              4109.394,
              4080.436
            ],
            [
              -481.301,
              4219.808,
              4212.736
            ],
            [
              -539.627,
              4314.372,
              4323.841
            ],
            [
              -576.107,
              4369.49,
              4389.938
            ],
            [
              -621.677,
              4489.515,
              4518.322
            ],
            [
              -657.683,
              4569.203,
              4605.767
            ],
            [
              -717.04,
              4707.668,
              4756.419
            ],
            [
              -749.46,
              4756.695,
              4815.195
            ],
            [
              -787.149,
              4836.482,
              4903.436
            ],
            [
              -897.404,
              5076.333,
              5167.415
            ],
            [
              -917.463,
              5129.376,
              5224.124
            ],
            [
              -979.628,
              5262.965,
              5371.469
            ],
            [
              -1065.501,
              5406.998,
              5539.158
            ],
            [
              -1113.826,
              5484.677,
              5630.642
            ],
            [
              -1138.435,
              5522.615,
              5675.862
            ],
            [
              -1160.802,
              5565.67,
              5724.38
            ],
            [
              -1254.235,
              5720.135,
              5904.905
            ],
            [
              -1341.654,
              5851.663,
              6062.835
            ],
            [
              -1432.809,
              5984.824,
              6224.207
            ],
            [
              -1431.833,
              5983.214,
              6226.089
            ],
            [
              -1471.061,
              6054.352,
              6307.326
            ],
            [
              -1510.284,
              6061.35,
              6347.168
            ],
            [
              -1581.752,
              6095.581,
              6426.412
            ],
            [
              -1632.135,
              6113.731,
              6479.964
            ],
            [
              -1694.749,
              6112.885,
              6542.584
            ],
            [
              -1751.999,
              6096.523,
              6602.125
            ],
            [
              -1778.29,
              6091.027,
              6628.985
            ],
            [
              -1788.792,
              6090.067,
              6639.531
            ],
            [
              -1821.172,
              6088.637,
              6671.942
            ],
            [
              -1844.864,
              6089.438,
              6695.648
            ],
            [
              -1894.525,
              6094.791,
              6745.596
            ],
            [
              -1950.502,
              6105.769,
              6802.64
            ],
            [
              -2036.963,
              6128.338,
              6891.998
            ],
            [
              -2168.643,
              6166.887,
              7029.205
            ],
            [
              -2286.229,
              6189.051,
              7148.861
            ],
            [
              -2312.561,
              6197.308,
              7176.457
            ],
            [
              -2336.271,
              6207.746,
              7202.363
            ],
            [
              -2375.26,
              6224.983,
              7244.993
            ],
            [
              -2372.418,
              6223.221,
              7248.337
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:7914",
              "position": {
                "x": 373.309,
                "z": 1955.558
              },
              "distanceAlongShapeM": 471.255,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:6650",
              "position": {
                "x": -11.424,
                "z": 1732.135
              },
              "distanceAlongShapeM": 1204.877,
              "shapeOffsetM": 0.239,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:7851",
              "position": {
                "x": -511.654,
                "z": 1933.795
              },
              "distanceAlongShapeM": 1817.224,
              "shapeOffsetM": 4.085,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:5173",
              "position": {
                "x": -290.153,
                "z": 2585.475
              },
              "distanceAlongShapeM": 2514.64,
              "shapeOffsetM": 4.994,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:5175",
              "position": {
                "x": -255.513,
                "z": 3072.44
              },
              "distanceAlongShapeM": 3006.738,
              "shapeOffsetM": 3.716,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:5304",
              "position": {
                "x": -578.027,
                "z": 4368.5
              },
              "distanceAlongShapeM": 4389.938,
              "shapeOffsetM": 2.16,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            },
            {
              "stopId": "judu:stop:8339",
              "position": {
                "x": -753.761,
                "z": 4754.616
              },
              "distanceAlongShapeM": 4815.195,
              "shapeOffsetM": 4.777,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:6948",
              "position": {
                "x": -899.06,
                "z": 5075.611
              },
              "distanceAlongShapeM": 5167.415,
              "shapeOffsetM": 1.807,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:6949",
              "position": {
                "x": -1139.633,
                "z": 5521.875
              },
              "distanceAlongShapeM": 5675.862,
              "shapeOffsetM": 1.409,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:8347",
              "position": {
                "x": -1434.909,
                "z": 5981.348
              },
              "distanceAlongShapeM": 6226.089,
              "shapeOffsetM": 3.598,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:6957",
              "position": {
                "x": -1776.705,
                "z": 6079.833
              },
              "distanceAlongShapeM": 6628.985,
              "shapeOffsetM": 11.306,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:6959",
              "position": {
                "x": -2379.466,
                "z": 6211.848
              },
              "distanceAlongShapeM": 7248.337,
              "shapeOffsetM": 13.38,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            }
          ],
          "departuresSeconds": [
            18960,
            20940,
            22140,
            24300,
            25860,
            27840,
            29520,
            31320,
            35160,
            38160,
            41340,
            44640,
            47880,
            51120,
            52560,
            54540,
            55800,
            57840,
            59640,
            61560,
            63420,
            65340,
            67080,
            70920,
            74040,
            77100,
            80220
          ]
        },
        {
          "id": "judu:pattern:vilnius_bus_41:1",
          "sourceRouteId": "vilnius_bus_41",
          "sourceShapeId": "vilnius_bus_41_b-a",
          "directionId": 1,
          "headsign": "Stotis",
          "directionName": "Užusienis–Eišiškių pl.–Stotis",
          "mode": "bus",
          "routeShortName": "41",
          "routeLongName": "Stotis–Eišiškių pl.–Užusienis",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              -2372.418,
              6223.221,
              0
            ],
            [
              -2388.079,
              6232.927,
              18.425
            ],
            [
              -2391.704,
              6235.067,
              22.635
            ],
            [
              -2390.64,
              6234.452,
              23.864
            ],
            [
              -2382.986,
              6231.948,
              31.917
            ],
            [
              -2362.524,
              6220.454,
              55.387
            ],
            [
              -2322.792,
              6203.055,
              98.761
            ],
            [
              -2263.732,
              6183.087,
              161.105
            ],
            [
              -2158.151,
              6164.523,
              268.306
            ],
            [
              -2120.259,
              6152.72,
              307.994
            ],
            [
              -2096.89,
              6147.349,
              331.972
            ],
            [
              -2047.663,
              6131.397,
              383.719
            ],
            [
              -1994.237,
              6116.362,
              439.22
            ],
            [
              -1874.614,
              6093.818,
              560.949
            ],
            [
              -1815.926,
              6089.436,
              619.8
            ],
            [
              -1783.588,
              6092.201,
              652.256
            ],
            [
              -1749.483,
              6099.127,
              687.057
            ],
            [
              -1740.803,
              6101.496,
              696.055
            ],
            [
              -1698.855,
              6112.464,
              739.414
            ],
            [
              -1669.943,
              6115.599,
              768.494
            ],
            [
              -1643.992,
              6115.039,
              794.452
            ],
            [
              -1606.258,
              6105.566,
              833.356
            ],
            [
              -1576.319,
              6090.738,
              866.766
            ],
            [
              -1532.112,
              6071.026,
              915.169
            ],
            [
              -1514.135,
              6065.139,
              934.085
            ],
            [
              -1501.596,
              6058.33,
              948.353
            ],
            [
              -1471.061,
              6054.352,
              979.147
            ],
            [
              -1461.106,
              6042.209,
              994.849
            ],
            [
              -1442.825,
              6008.206,
              1033.455
            ],
            [
              -1415.255,
              5960.959,
              1088.157
            ],
            [
              -1254.235,
              5720.135,
              1377.853
            ],
            [
              -1174.644,
              5585.956,
              1533.862
            ],
            [
              -1108.397,
              5481.317,
              1657.709
            ],
            [
              -973.141,
              5253.719,
              1922.463
            ],
            [
              -871.561,
              5025.022,
              2172.705
            ],
            [
              -867.974,
              5019.201,
              2179.543
            ],
            [
              -856.066,
              4989.12,
              2211.894
            ],
            [
              -801.413,
              4869.022,
              2343.843
            ],
            [
              -766.573,
              4796.036,
              2424.718
            ],
            [
              -710.747,
              4695.74,
              2539.504
            ],
            [
              -707.871,
              4685.883,
              2549.772
            ],
            [
              -676.746,
              4621.868,
              2620.953
            ],
            [
              -601.144,
              4446.842,
              2811.609
            ],
            [
              -555.893,
              4349.843,
              2918.644
            ],
            [
              -486.107,
              4235.088,
              3052.952
            ],
            [
              -475.614,
              4213.025,
              3077.384
            ],
            [
              -396.44,
              4093.592,
              3220.676
            ],
            [
              -345.945,
              4030.338,
              3301.613
            ],
            [
              -378.367,
              3879.526,
              3455.871
            ],
            [
              -382.056,
              3853.989,
              3481.673
            ],
            [
              -382.136,
              3813.914,
              3521.748
            ],
            [
              -379.958,
              3791.61,
              3544.158
            ],
            [
              -326.239,
              3550.182,
              3791.49
            ],
            [
              -300.672,
              3393.867,
              3949.883
            ],
            [
              -259.604,
              3167.138,
              4180.301
            ],
            [
              -234.366,
              2993.018,
              4356.24
            ],
            [
              -227.915,
              2951.79,
              4397.97
            ],
            [
              -268.934,
              2604.253,
              4747.919
            ],
            [
              -287.151,
              2501.929,
              4851.852
            ],
            [
              -327.226,
              2355.709,
              5003.465
            ],
            [
              -350.367,
              2324.958,
              5041.95
            ],
            [
              -412.128,
              2228.113,
              5156.812
            ],
            [
              -425.492,
              2202.75,
              5185.481
            ],
            [
              -439.803,
              2160.707,
              5229.893
            ],
            [
              -445.668,
              2121.85,
              5269.19
            ],
            [
              -471.768,
              2034.377,
              5360.474
            ],
            [
              -499.661,
              1919.106,
              5479.072
            ],
            [
              -512.556,
              1856.885,
              5542.614
            ],
            [
              -491.403,
              1846.355,
              5566.243
            ],
            [
              -471.457,
              1839.899,
              5587.208
            ],
            [
              -432.32,
              1825.49,
              5628.914
            ],
            [
              -327.19,
              1787.963,
              5740.541
            ],
            [
              -259.046,
              1774.482,
              5810.005
            ],
            [
              -147.106,
              1756.865,
              5923.323
            ],
            [
              9.981,
              1738.424,
              6081.489
            ],
            [
              41.02,
              1742.312,
              6112.77
            ],
            [
              64.443,
              1752.06,
              6138.14
            ],
            [
              135.751,
              1771.757,
              6212.119
            ],
            [
              319.251,
              1821.845,
              6402.332
            ],
            [
              341.2,
              1822.557,
              6424.293
            ],
            [
              378.73,
              1828.551,
              6462.299
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:6959",
              "position": {
                "x": -2379.466,
                "z": 6211.848
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 13.38,
              "arrivalOffsetSeconds": -360,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:6956",
              "position": {
                "x": -1742.014,
                "z": 6105.934
              },
              "distanceAlongShapeM": 696.055,
              "shapeOffsetM": 4.6,
              "arrivalOffsetSeconds": 60,
              "departureOffsetSeconds": 60
            },
            {
              "stopId": "judu:stop:6961",
              "position": {
                "x": -1459.639,
                "z": 6043.016
              },
              "distanceAlongShapeM": 994.849,
              "shapeOffsetM": 1.674,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:6950",
              "position": {
                "x": -1106.766,
                "z": 5482.324
              },
              "distanceAlongShapeM": 1657.709,
              "shapeOffsetM": 1.917,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:6947",
              "position": {
                "x": -865.187,
                "z": 5020.454
              },
              "distanceAlongShapeM": 2179.543,
              "shapeOffsetM": 3.056,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:5307",
              "position": {
                "x": -708.316,
                "z": 4697.023
              },
              "distanceAlongShapeM": 2539.504,
              "shapeOffsetM": 2.749,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:5305",
              "position": {
                "x": -482.27,
                "z": 4237.637
              },
              "distanceAlongShapeM": 3052.768,
              "shapeOffsetM": 4.603,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:7414",
              "position": {
                "x": -225.435,
                "z": 2951.666
              },
              "distanceAlongShapeM": 4397.97,
              "shapeOffsetM": 2.483,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:6854",
              "position": {
                "x": -266.588,
                "z": 2603.973
              },
              "distanceAlongShapeM": 4747.919,
              "shapeOffsetM": 2.363,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:5166",
              "position": {
                "x": -470.051,
                "z": 1843.985
              },
              "distanceAlongShapeM": 5587.208,
              "shapeOffsetM": 4.322,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:5160",
              "position": {
                "x": 63.816,
                "z": 1754.143
              },
              "distanceAlongShapeM": 6138.14,
              "shapeOffsetM": 2.176,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:16581",
              "position": {
                "x": 378.73,
                "z": 1828.551
              },
              "distanceAlongShapeM": 6462.299,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            }
          ],
          "departuresSeconds": [
            20640,
            22800,
            24300,
            26100,
            27780,
            29580,
            31380,
            33180,
            36600,
            39780,
            43080,
            46320,
            49500,
            52800,
            54240,
            56220,
            57900,
            59760,
            61620,
            63540,
            65400,
            67260,
            69120,
            72600,
            75600,
            78720,
            81960
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_bus_42",
      "sourceRouteId": "vilnius_bus_42",
      "mode": "bus",
      "shortName": "42",
      "longName": "Stotis–Eišiškių pl.–Salininkai",
      "color": "0073AC",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_bus_42:0",
          "sourceRouteId": "vilnius_bus_42",
          "sourceShapeId": "vilnius_bus_42_a-b",
          "directionId": 0,
          "headsign": "Salininkai",
          "directionName": "Stotis–Eišiškių pl.–Salininkai",
          "mode": "bus",
          "routeShortName": "42",
          "routeLongName": "Stotis–Eišiškių pl.–Salininkai",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              378.73,
              1828.551,
              0
            ],
            [
              425.25,
              1832.153,
              46.659
            ],
            [
              579.14,
              1850.487,
              201.638
            ],
            [
              587.002,
              1857.023,
              211.862
            ],
            [
              594.321,
              1869.134,
              226.012
            ],
            [
              472.814,
              1928.134,
              361.086
            ],
            [
              461.768,
              1923.883,
              372.922
            ],
            [
              443.043,
              1923.113,
              391.663
            ],
            [
              408.316,
              1929.314,
              426.939
            ],
            [
              398.702,
              1932.829,
              437.175
            ],
            [
              373.309,
              1955.558,
              471.255
            ],
            [
              366.499,
              1971.268,
              488.377
            ],
            [
              365.997,
              1979.07,
              496.196
            ],
            [
              369.323,
              1984.575,
              502.627
            ],
            [
              370.213,
              1992.49,
              510.592
            ],
            [
              389.562,
              1997.564,
              530.595
            ],
            [
              401.172,
              1997.352,
              542.207
            ],
            [
              408.871,
              1994.984,
              550.262
            ],
            [
              424.209,
              1986.911,
              567.595
            ],
            [
              467.559,
              1958.288,
              619.542
            ],
            [
              473.887,
              1951.492,
              628.828
            ],
            [
              474.993,
              1941.453,
              638.928
            ],
            [
              465.719,
              1928.264,
              655.051
            ],
            [
              461.143,
              1925.008,
              660.667
            ],
            [
              452.073,
              1922.947,
              669.969
            ],
            [
              409.585,
              1928.177,
              712.777
            ],
            [
              398.6,
              1927.265,
              723.8
            ],
            [
              334.106,
              1822.687,
              846.666
            ],
            [
              318.606,
              1821.856,
              862.188
            ],
            [
              29.934,
              1735.835,
              1163.404
            ],
            [
              -11.394,
              1732.372,
              1204.877
            ],
            [
              -46.755,
              1740.57,
              1241.176
            ],
            [
              -320.217,
              1781.157,
              1517.633
            ],
            [
              -514.905,
              1842.557,
              1721.774
            ],
            [
              -520.923,
              1849.358,
              1730.855
            ],
            [
              -525.385,
              1862.522,
              1744.755
            ],
            [
              -507.688,
              1932.818,
              1817.245
            ],
            [
              -496.901,
              1964.699,
              1850.901
            ],
            [
              -462.075,
              2106.562,
              1996.976
            ],
            [
              -436.719,
              2188.482,
              2082.73
            ],
            [
              -427.991,
              2207.248,
              2103.427
            ],
            [
              -344.32,
              2338.207,
              2258.833
            ],
            [
              -326.137,
              2380.181,
              2304.576
            ],
            [
              -285.296,
              2533.066,
              2462.822
            ],
            [
              -285.194,
              2584.883,
              2514.64
            ],
            [
              -278.622,
              2616.436,
              2546.87
            ],
            [
              -251.706,
              2819.669,
              2751.877
            ],
            [
              -239.003,
              2950.799,
              2883.621
            ],
            [
              -239.164,
              2977.519,
              2910.342
            ],
            [
              -243.808,
              3023.423,
              2956.48
            ],
            [
              -251.845,
              3073.034,
              3006.738
            ],
            [
              -253.335,
              3121.382,
              3055.109
            ],
            [
              -336.623,
              3547.03,
              3488.829
            ],
            [
              -379.958,
              3791.61,
              3737.218
            ],
            [
              -382.016,
              3856.215,
              3801.856
            ],
            [
              -345.945,
              4030.338,
              3979.676
            ],
            [
              -408.418,
              4109.394,
              4080.436
            ],
            [
              -481.301,
              4219.808,
              4212.736
            ],
            [
              -539.627,
              4314.372,
              4323.841
            ],
            [
              -576.107,
              4369.49,
              4389.938
            ],
            [
              -621.677,
              4489.515,
              4518.322
            ],
            [
              -657.683,
              4569.203,
              4605.767
            ],
            [
              -717.04,
              4707.668,
              4756.419
            ],
            [
              -749.46,
              4756.695,
              4815.195
            ],
            [
              -787.149,
              4836.482,
              4903.436
            ],
            [
              -897.404,
              5076.333,
              5167.415
            ],
            [
              -917.463,
              5129.376,
              5224.124
            ],
            [
              -979.628,
              5262.965,
              5371.469
            ],
            [
              -1065.501,
              5406.998,
              5539.158
            ],
            [
              -1113.826,
              5484.677,
              5630.642
            ],
            [
              -1138.435,
              5522.615,
              5675.862
            ],
            [
              -1160.802,
              5565.67,
              5724.38
            ],
            [
              -1254.235,
              5720.135,
              5904.905
            ],
            [
              -1341.654,
              5851.663,
              6062.835
            ],
            [
              -1432.809,
              5984.824,
              6224.207
            ],
            [
              -1431.833,
              5983.214,
              6226.089
            ],
            [
              -1471.061,
              6054.352,
              6307.326
            ],
            [
              -1667.836,
              6423.029,
              6725.229
            ],
            [
              -1679.373,
              6468.839,
              6772.47
            ],
            [
              -1707.91,
              6788.838,
              7093.739
            ],
            [
              -1712.089,
              6821.577,
              7126.743
            ],
            [
              -1712.83,
              6839.019,
              7144.201
            ],
            [
              -1721.42,
              6937.135,
              7242.692
            ],
            [
              -1729.279,
              6967.331,
              7273.894
            ],
            [
              -1746.568,
              7012.167,
              7321.948
            ],
            [
              -1767.164,
              7052.608,
              7367.332
            ],
            [
              -1986.586,
              7354.842,
              7740.817
            ],
            [
              -2025.855,
              7391.323,
              7794.417
            ],
            [
              -2100.781,
              7451.446,
              7890.483
            ],
            [
              -2037.346,
              7586.889,
              8040.045
            ],
            [
              -2021.629,
              7620.543,
              8077.188
            ],
            [
              -2003.942,
              7651.262,
              8112.635
            ],
            [
              -1949.699,
              7759.395,
              8233.61
            ],
            [
              -1905.866,
              7863.259,
              8346.345
            ],
            [
              -1804.677,
              8031.784,
              8542.915
            ],
            [
              -1769.656,
              8075.69,
              8599.077
            ],
            [
              -1704.351,
              8151.341,
              8699.016
            ],
            [
              -1667.469,
              8190.76,
              8752.999
            ],
            [
              -1631.959,
              8225.751,
              8802.852
            ],
            [
              -1597.192,
              8255.189,
              8848.408
            ],
            [
              -1554.934,
              8285.19,
              8900.233
            ],
            [
              -1537.002,
              8303.418,
              8925.803
            ],
            [
              -1526.833,
              8324.068,
              8948.821
            ],
            [
              -1511.486,
              8383.991,
              9010.678
            ],
            [
              -1505.414,
              8438.346,
              9065.371
            ],
            [
              -1503.229,
              8488.402,
              9115.475
            ],
            [
              -1511.708,
              8556.458,
              9184.057
            ],
            [
              -1543.904,
              8744.051,
              9374.393
            ],
            [
              -1553.048,
              8789.284,
              9420.541
            ],
            [
              -1618.698,
              9225.174,
              9861.347
            ],
            [
              -1566.4,
              9238.022,
              9915.2
            ],
            [
              -1337.536,
              9280.082,
              10147.897
            ],
            [
              -974.554,
              9283.037,
              10510.891
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:7914",
              "position": {
                "x": 373.309,
                "z": 1955.558
              },
              "distanceAlongShapeM": 471.255,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:6650",
              "position": {
                "x": -11.424,
                "z": 1732.135
              },
              "distanceAlongShapeM": 1204.877,
              "shapeOffsetM": 0.239,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:7851",
              "position": {
                "x": -511.654,
                "z": 1933.795
              },
              "distanceAlongShapeM": 1817.224,
              "shapeOffsetM": 4.085,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:5173",
              "position": {
                "x": -290.153,
                "z": 2585.475
              },
              "distanceAlongShapeM": 2514.64,
              "shapeOffsetM": 4.994,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:5175",
              "position": {
                "x": -255.513,
                "z": 3072.44
              },
              "distanceAlongShapeM": 3006.738,
              "shapeOffsetM": 3.716,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:5304",
              "position": {
                "x": -578.027,
                "z": 4368.5
              },
              "distanceAlongShapeM": 4389.938,
              "shapeOffsetM": 2.16,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            },
            {
              "stopId": "judu:stop:8339",
              "position": {
                "x": -753.761,
                "z": 4754.616
              },
              "distanceAlongShapeM": 4815.195,
              "shapeOffsetM": 4.777,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:6948",
              "position": {
                "x": -899.06,
                "z": 5075.611
              },
              "distanceAlongShapeM": 5167.415,
              "shapeOffsetM": 1.807,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:6949",
              "position": {
                "x": -1139.633,
                "z": 5521.875
              },
              "distanceAlongShapeM": 5675.862,
              "shapeOffsetM": 1.409,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:8347",
              "position": {
                "x": -1434.909,
                "z": 5981.348
              },
              "distanceAlongShapeM": 6226.089,
              "shapeOffsetM": 3.598,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:6963",
              "position": {
                "x": -1715.73,
                "z": 6821.26
              },
              "distanceAlongShapeM": 7126.743,
              "shapeOffsetM": 3.654,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:6967",
              "position": {
                "x": -2023.848,
                "z": 7621.558
              },
              "distanceAlongShapeM": 8077.168,
              "shapeOffsetM": 2.44,
              "arrivalOffsetSeconds": 1380,
              "departureOffsetSeconds": 1380
            },
            {
              "stopId": "judu:stop:6264",
              "position": {
                "x": -1542.006,
                "z": 8306.527
              },
              "distanceAlongShapeM": 8924.51,
              "shapeOffsetM": 5.748,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            },
            {
              "stopId": "judu:stop:6261",
              "position": {
                "x": -1556.03,
                "z": 8788.795
              },
              "distanceAlongShapeM": 9420.541,
              "shapeOffsetM": 3.022,
              "arrivalOffsetSeconds": 1560,
              "departureOffsetSeconds": 1560
            },
            {
              "stopId": "judu:stop:6257",
              "position": {
                "x": -1566.739,
                "z": 9239.834
              },
              "distanceAlongShapeM": 9915.2,
              "shapeOffsetM": 1.843,
              "arrivalOffsetSeconds": 1620,
              "departureOffsetSeconds": 1620
            },
            {
              "stopId": "judu:stop:6253",
              "position": {
                "x": -974.57,
                "z": 9288.252
              },
              "distanceAlongShapeM": 10510.891,
              "shapeOffsetM": 5.215,
              "arrivalOffsetSeconds": 1680,
              "departureOffsetSeconds": 1680
            }
          ],
          "departuresSeconds": [
            19080,
            21240,
            23400,
            25680,
            26880,
            28080,
            30660,
            33060,
            35100,
            37620,
            40020,
            42420,
            44640,
            46860,
            49140,
            51420,
            53700,
            55920,
            58200,
            59820,
            61440,
            63600,
            65820,
            68400,
            70740,
            73380,
            75540,
            77760,
            79920
          ]
        },
        {
          "id": "judu:pattern:vilnius_bus_42:1",
          "sourceRouteId": "vilnius_bus_42",
          "sourceShapeId": "vilnius_bus_42_b-a",
          "directionId": 1,
          "headsign": "Stotis",
          "directionName": "Salininkai–Eišiškių pl.–Stotis",
          "mode": "bus",
          "routeShortName": "42",
          "routeLongName": "Stotis–Eišiškių pl.–Salininkai",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              -974.554,
              9283.037,
              0
            ],
            [
              -970.748,
              9283.049,
              3.805
            ],
            [
              -956.601,
              9281.251,
              18.067
            ],
            [
              -947.577,
              9279.976,
              27.18
            ],
            [
              -933.324,
              9281.946,
              41.569
            ],
            [
              -928.339,
              9290.732,
              51.671
            ],
            [
              -928.412,
              9305.619,
              66.558
            ],
            [
              -905.066,
              9281.708,
              99.977
            ],
            [
              -888.329,
              9281.708,
              116.714
            ],
            [
              -880.696,
              9281.708,
              124.347
            ],
            [
              -878.878,
              9281.708,
              126.165
            ],
            [
              -878.978,
              9281.708,
              126.265
            ],
            [
              -881.622,
              9281.708,
              128.909
            ],
            [
              -888.748,
              9281.146,
              136.057
            ],
            [
              -908.755,
              9281.708,
              156.072
            ],
            [
              -979.944,
              9280.133,
              227.279
            ],
            [
              -1100.766,
              9279.883,
              348.101
            ],
            [
              -1181.459,
              9283.052,
              428.856
            ],
            [
              -1238.935,
              9284.4,
              486.348
            ],
            [
              -1308.161,
              9280.864,
              555.664
            ],
            [
              -1343.772,
              9277.047,
              591.479
            ],
            [
              -1428.033,
              9262.966,
              676.909
            ],
            [
              -1539.363,
              9240.213,
              790.54
            ],
            [
              -1618.698,
              9225.174,
              871.288
            ],
            [
              -1611.932,
              9178.268,
              918.679
            ],
            [
              -1594.884,
              9079.558,
              1018.851
            ],
            [
              -1553.706,
              8810.898,
              1290.647
            ],
            [
              -1551.783,
              8799.178,
              1302.525
            ],
            [
              -1550.14,
              8789.161,
              1312.676
            ],
            [
              -1535.825,
              8767.618,
              1338.54
            ],
            [
              -1545.584,
              8758.552,
              1351.861
            ],
            [
              -1504.025,
              8516.246,
              1597.705
            ],
            [
              -1501.823,
              8482.803,
              1631.22
            ],
            [
              -1503.347,
              8447.272,
              1666.784
            ],
            [
              -1506.906,
              8413.918,
              1700.327
            ],
            [
              -1524.816,
              8328.484,
              1787.618
            ],
            [
              -1528.566,
              8312.945,
              1803.603
            ],
            [
              -1534.753,
              8301.638,
              1816.493
            ],
            [
              -1539.544,
              8295.235,
              1824.489
            ],
            [
              -1552.417,
              8283.602,
              1841.84
            ],
            [
              -1597.232,
              8252.963,
              1896.128
            ],
            [
              -1633.27,
              8224.661,
              1941.951
            ],
            [
              -1763.019,
              8085.591,
              2132.149
            ],
            [
              -1804.677,
              8031.784,
              2200.197
            ],
            [
              -1903.889,
              7865.451,
              2393.871
            ],
            [
              -1952.381,
              7753.877,
              2515.527
            ],
            [
              -2057.537,
              7543.118,
              2751.063
            ],
            [
              -2100.781,
              7451.446,
              2852.423
            ],
            [
              -2076.129,
              7435.653,
              2881.7
            ],
            [
              -2051.692,
              7418.233,
              2911.71
            ],
            [
              -1963.411,
              7327.615,
              3038.221
            ],
            [
              -1775.285,
              7067.396,
              3359.322
            ],
            [
              -1722.735,
              6948.109,
              3489.671
            ],
            [
              -1717.474,
              6904.781,
              3533.317
            ],
            [
              -1680.546,
              6475.539,
              3964.145
            ],
            [
              -1667.836,
              6423.029,
              4018.171
            ],
            [
              -1471.061,
              6054.352,
              4436.074
            ],
            [
              -1461.106,
              6042.209,
              4451.777
            ],
            [
              -1442.825,
              6008.206,
              4490.382
            ],
            [
              -1415.255,
              5960.959,
              4545.085
            ],
            [
              -1254.235,
              5720.135,
              4834.781
            ],
            [
              -1174.644,
              5585.956,
              4990.789
            ],
            [
              -1108.397,
              5481.317,
              5114.636
            ],
            [
              -973.141,
              5253.719,
              5379.39
            ],
            [
              -871.561,
              5025.022,
              5629.632
            ],
            [
              -867.974,
              5019.201,
              5636.47
            ],
            [
              -856.066,
              4989.12,
              5668.822
            ],
            [
              -801.413,
              4869.022,
              5800.77
            ],
            [
              -766.573,
              4796.036,
              5881.645
            ],
            [
              -710.747,
              4695.74,
              5996.431
            ],
            [
              -707.871,
              4685.883,
              6006.699
            ],
            [
              -676.746,
              4621.868,
              6077.88
            ],
            [
              -601.144,
              4446.842,
              6268.536
            ],
            [
              -555.893,
              4349.843,
              6375.571
            ],
            [
              -486.107,
              4235.088,
              6509.879
            ],
            [
              -475.614,
              4213.025,
              6534.311
            ],
            [
              -396.44,
              4093.592,
              6677.603
            ],
            [
              -345.945,
              4030.338,
              6758.54
            ],
            [
              -378.367,
              3879.526,
              6912.798
            ],
            [
              -382.056,
              3853.989,
              6938.6
            ],
            [
              -382.136,
              3813.914,
              6978.675
            ],
            [
              -379.958,
              3791.61,
              7001.085
            ],
            [
              -326.239,
              3550.182,
              7248.418
            ],
            [
              -300.672,
              3393.867,
              7406.81
            ],
            [
              -259.604,
              3167.138,
              7637.228
            ],
            [
              -234.366,
              2993.018,
              7813.168
            ],
            [
              -227.915,
              2951.79,
              7854.897
            ],
            [
              -268.934,
              2604.253,
              8204.846
            ],
            [
              -287.151,
              2501.929,
              8308.779
            ],
            [
              -327.226,
              2355.709,
              8460.392
            ],
            [
              -350.367,
              2324.958,
              8498.877
            ],
            [
              -412.128,
              2228.113,
              8613.74
            ],
            [
              -425.492,
              2202.75,
              8642.408
            ],
            [
              -439.803,
              2160.707,
              8686.82
            ],
            [
              -445.668,
              2121.85,
              8726.117
            ],
            [
              -471.768,
              2034.377,
              8817.401
            ],
            [
              -499.661,
              1919.106,
              8935.999
            ],
            [
              -512.556,
              1856.885,
              8999.541
            ],
            [
              -491.403,
              1846.355,
              9023.171
            ],
            [
              -471.457,
              1839.899,
              9044.135
            ],
            [
              -432.32,
              1825.49,
              9085.841
            ],
            [
              -327.19,
              1787.963,
              9197.468
            ],
            [
              -259.046,
              1774.482,
              9266.933
            ],
            [
              -147.106,
              1756.865,
              9380.25
            ],
            [
              9.981,
              1738.424,
              9538.416
            ],
            [
              41.02,
              1742.312,
              9569.698
            ],
            [
              64.443,
              1752.06,
              9595.068
            ],
            [
              135.751,
              1771.757,
              9669.046
            ],
            [
              319.251,
              1821.845,
              9859.26
            ],
            [
              341.2,
              1822.557,
              9881.22
            ],
            [
              378.73,
              1828.551,
              9919.226
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:6254",
              "position": {
                "x": -1100.805,
                "z": 9276.043
              },
              "distanceAlongShapeM": 348.101,
              "shapeOffsetM": 3.84,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:6256",
              "position": {
                "x": -1538.979,
                "z": 9238.226
              },
              "distanceAlongShapeM": 790.54,
              "shapeOffsetM": 2.024,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:6260",
              "position": {
                "x": -1540.488,
                "z": 8790.744
              },
              "distanceAlongShapeM": 1316.699,
              "shapeOffsetM": 8.915,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:6263",
              "position": {
                "x": -1532.635,
                "z": 8288.548
              },
              "distanceAlongShapeM": 1824.489,
              "shapeOffsetM": 9.615,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:6966",
              "position": {
                "x": -2070.914,
                "z": 7444.279
              },
              "distanceAlongShapeM": 2881.437,
              "shapeOffsetM": 10.077,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:6964",
              "position": {
                "x": -1717.974,
                "z": 6949.319
              },
              "distanceAlongShapeM": 3489.671,
              "shapeOffsetM": 4.912,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:6961",
              "position": {
                "x": -1459.639,
                "z": 6043.016
              },
              "distanceAlongShapeM": 4451.777,
              "shapeOffsetM": 1.674,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:6950",
              "position": {
                "x": -1106.766,
                "z": 5482.324
              },
              "distanceAlongShapeM": 5114.636,
              "shapeOffsetM": 1.917,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:6947",
              "position": {
                "x": -865.187,
                "z": 5020.454
              },
              "distanceAlongShapeM": 5636.47,
              "shapeOffsetM": 3.056,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:5307",
              "position": {
                "x": -708.316,
                "z": 4697.023
              },
              "distanceAlongShapeM": 5996.431,
              "shapeOffsetM": 2.749,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:5305",
              "position": {
                "x": -482.27,
                "z": 4237.637
              },
              "distanceAlongShapeM": 6509.695,
              "shapeOffsetM": 4.603,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:7414",
              "position": {
                "x": -225.435,
                "z": 2951.666
              },
              "distanceAlongShapeM": 7854.897,
              "shapeOffsetM": 2.483,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:6854",
              "position": {
                "x": -266.588,
                "z": 2603.973
              },
              "distanceAlongShapeM": 8204.846,
              "shapeOffsetM": 2.363,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:5166",
              "position": {
                "x": -470.051,
                "z": 1843.985
              },
              "distanceAlongShapeM": 9044.135,
              "shapeOffsetM": 4.322,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            },
            {
              "stopId": "judu:stop:5160",
              "position": {
                "x": 63.816,
                "z": 1754.143
              },
              "distanceAlongShapeM": 9595.068,
              "shapeOffsetM": 2.176,
              "arrivalOffsetSeconds": 1560,
              "departureOffsetSeconds": 1560
            },
            {
              "stopId": "judu:stop:16581",
              "position": {
                "x": 378.73,
                "z": 1828.551
              },
              "distanceAlongShapeM": 9919.226,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1620,
              "departureOffsetSeconds": 1620
            }
          ],
          "departuresSeconds": [
            18960,
            21120,
            23400,
            25740,
            28140,
            30300,
            32580,
            35160,
            36420,
            37980,
            40080,
            42360,
            44520,
            46800,
            49020,
            51360,
            53580,
            56100,
            58620,
            61020,
            63300,
            66300,
            68340,
            69540,
            71400,
            73500,
            75540,
            77640,
            79740,
            81900
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_bus_43",
      "sourceRouteId": "vilnius_bus_43",
      "mode": "bus",
      "shortName": "43",
      "longName": "Justiniškės–Šeškinė–Žaliasis tiltas–Centras (Apylanka Rygos g.)",
      "color": "0073AC",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_bus_43:0",
          "sourceRouteId": "vilnius_bus_43",
          "sourceShapeId": "vilnius_bus_43_a1-b_12345",
          "directionId": 0,
          "headsign": "Centras (Apylanka Rygos g.)",
          "directionName": "Justiniškės–Šeškinė–Žaliasis tiltas–Centras (Apylanka Rygos g.)",
          "mode": "bus",
          "routeShortName": "43",
          "routeLongName": "Justiniškės–Šeškinė–Žaliasis tiltas–Centras (Apylanka Rygos g.)",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              -4210.635,
              -2255.507,
              0
            ],
            [
              -4196.209,
              -2315.87,
              62.063
            ],
            [
              -4165.8,
              -2421.037,
              171.538
            ],
            [
              -4138.614,
              -2526.149,
              280.109
            ],
            [
              -4123.397,
              -2733.522,
              488.039
            ],
            [
              -4112.669,
              -2926.241,
              681.057
            ],
            [
              -4111.492,
              -2948.652,
              703.499
            ],
            [
              -4174.702,
              -3308.112,
              1068.474
            ],
            [
              -4109.871,
              -3292.845,
              1135.078
            ],
            [
              -4018.747,
              -3270.737,
              1228.846
            ],
            [
              -3940.176,
              -3236.477,
              1314.561
            ],
            [
              -3823.754,
              -3175.046,
              1446.197
            ],
            [
              -3810.118,
              -3166.508,
              1462.284
            ],
            [
              -3714.539,
              -3118.094,
              1569.426
            ],
            [
              -3714.983,
              -3109.031,
              1578.501
            ],
            [
              -3663.87,
              -3096.551,
              1631.115
            ],
            [
              -3644.524,
              -3091.72,
              1651.055
            ],
            [
              -3537.19,
              -3076.506,
              1759.462
            ],
            [
              -3288.387,
              -3074.173,
              2008.276
            ],
            [
              -3226.908,
              -3059.664,
              2071.444
            ],
            [
              -3088.313,
              -3020.904,
              2215.357
            ],
            [
              -3076.179,
              -3017.184,
              2228.048
            ],
            [
              -3065.414,
              -3014.303,
              2239.193
            ],
            [
              -3011.076,
              -2998.586,
              2295.757
            ],
            [
              -2972.094,
              -2983.696,
              2337.486
            ],
            [
              -2923.591,
              -2962.569,
              2390.391
            ],
            [
              -2796.251,
              -2867.959,
              2549.031
            ],
            [
              -2713.249,
              -2802.628,
              2654.66
            ],
            [
              -2678.551,
              -2772.069,
              2700.896
            ],
            [
              -2644.38,
              -2734.822,
              2751.443
            ],
            [
              -2633.43,
              -2718.353,
              2771.22
            ],
            [
              -2600.033,
              -2668.811,
              2830.968
            ],
            [
              -2574.02,
              -2619.176,
              2887.006
            ],
            [
              -2552.25,
              -2627.352,
              2910.261
            ],
            [
              -2471.713,
              -2665.511,
              2999.38
            ],
            [
              -2386.944,
              -2719.332,
              3099.792
            ],
            [
              -2340.637,
              -2761.341,
              3162.315
            ],
            [
              -2270.657,
              -2849.412,
              3274.803
            ],
            [
              -2238.843,
              -2908.976,
              3342.331
            ],
            [
              -2163.402,
              -2906.975,
              3417.799
            ],
            [
              -2137.689,
              -2910.771,
              3443.79
            ],
            [
              -2030.32,
              -2917.731,
              3551.385
            ],
            [
              -2013.906,
              -2908.516,
              3570.208
            ],
            [
              -1990.089,
              -2837.694,
              3644.928
            ],
            [
              -1938.142,
              -2707.257,
              3785.328
            ],
            [
              -1897.174,
              -2614.475,
              3886.753
            ],
            [
              -1860.754,
              -2596.199,
              3927.501
            ],
            [
              -1827.269,
              -2525.549,
              4005.685
            ],
            [
              -1801.306,
              -2479.256,
              4058.761
            ],
            [
              -1807.234,
              -2450.207,
              4088.409
            ],
            [
              -1793.772,
              -2418.163,
              4123.166
            ],
            [
              -1749.309,
              -2346.596,
              4207.42
            ],
            [
              -1745.639,
              -2333.352,
              4221.163
            ],
            [
              -1727.311,
              -2305.799,
              4254.255
            ],
            [
              -1547.472,
              -2017.345,
              4594.178
            ],
            [
              -1343.434,
              -1674.784,
              4992.901
            ],
            [
              -1305.861,
              -1628.702,
              5052.359
            ],
            [
              -1268.647,
              -1602.651,
              5097.785
            ],
            [
              -1054.592,
              -1494.059,
              5337.81
            ],
            [
              -1027.103,
              -1471.176,
              5373.577
            ],
            [
              -1009.966,
              -1450.333,
              5400.56
            ],
            [
              -998.422,
              -1410.718,
              5441.823
            ],
            [
              -987.78,
              -1363.9,
              5489.835
            ],
            [
              -988.723,
              -1201.352,
              5652.386
            ],
            [
              -990.397,
              -1186.85,
              5666.984
            ],
            [
              -1017.615,
              -1122.906,
              5736.48
            ],
            [
              -1020.518,
              -1105.042,
              5754.578
            ],
            [
              -1018.304,
              -1089.497,
              5770.28
            ],
            [
              -1013.532,
              -1075.111,
              5785.437
            ],
            [
              -1005.537,
              -1060.783,
              5801.844
            ],
            [
              -969.041,
              -1039.175,
              5844.257
            ],
            [
              -947.066,
              -1036.231,
              5866.429
            ],
            [
              -930.307,
              -1036.533,
              5883.191
            ],
            [
              -906.579,
              -1043.639,
              5907.96
            ],
            [
              -895.802,
              -1053.852,
              5922.807
            ],
            [
              -890.221,
              -1066.198,
              5936.356
            ],
            [
              -882.043,
              -1077.478,
              5950.289
            ],
            [
              -868.708,
              -1088.851,
              5967.815
            ],
            [
              -846.005,
              -1097.331,
              5992.05
            ],
            [
              -837.363,
              -1098.358,
              6000.753
            ],
            [
              -813.038,
              -1094.85,
              6025.33
            ],
            [
              -785.651,
              -1089.799,
              6053.178
            ],
            [
              -774.937,
              -1088.05,
              6064.034
            ],
            [
              -717.669,
              -1083.853,
              6121.456
            ],
            [
              -647.083,
              -1062.792,
              6195.117
            ],
            [
              -599.769,
              -1049.176,
              6244.351
            ],
            [
              -535.555,
              -1028.072,
              6311.944
            ],
            [
              -464.693,
              -995.958,
              6389.743
            ],
            [
              -361.843,
              -942.16,
              6505.814
            ],
            [
              -331.427,
              -923.524,
              6541.485
            ],
            [
              -286.654,
              -898.264,
              6592.892
            ],
            [
              -196.966,
              -846.075,
              6696.659
            ],
            [
              -115.583,
              -803.025,
              6788.727
            ],
            [
              -95.312,
              -792.953,
              6811.362
            ],
            [
              -40.176,
              -770.281,
              6870.978
            ],
            [
              224.176,
              -700.119,
              7144.482
            ],
            [
              211.01,
              -644.216,
              7201.915
            ],
            [
              143.71,
              -480.456,
              7378.965
            ],
            [
              126.134,
              -439.133,
              7423.871
            ],
            [
              119.827,
              -411,
              7452.701
            ],
            [
              106.146,
              -277.163,
              7587.236
            ],
            [
              35.151,
              -280.322,
              7658.301
            ],
            [
              -101.904,
              -298.979,
              7796.62
            ],
            [
              -140.054,
              -304.394,
              7835.153
            ],
            [
              -153.37,
              -311.158,
              7850.088
            ],
            [
              -191.836,
              -315.156,
              7888.761
            ],
            [
              -244.276,
              -326.45,
              7942.403
            ],
            [
              -305.298,
              -348.72,
              8007.362
            ],
            [
              -335.653,
              -209.016,
              8150.326
            ],
            [
              -372.626,
              -210.078,
              8187.314
            ],
            [
              -418.232,
              -210.859,
              8232.927
            ],
            [
              -451.474,
              -230.295,
              8271.434
            ],
            [
              -478.241,
              -268.382,
              8317.986
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:6990",
              "position": {
                "x": -4210.635,
                "z": -2255.507
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": -1320,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:6993",
              "position": {
                "x": -4108.545,
                "z": -2948.576
              },
              "distanceAlongShapeM": 703.499,
              "shapeOffsetM": 2.948,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:15412",
              "position": {
                "x": -4111.181,
                "z": -3286.947
              },
              "distanceAlongShapeM": 1135.196,
              "shapeOffsetM": 6.04,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:7001",
              "position": {
                "x": -3665.065,
                "z": -3092.089
              },
              "distanceAlongShapeM": 1631.013,
              "shapeOffsetM": 4.618,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:855",
              "position": {
                "x": -3013.674,
                "z": -2991.043
              },
              "distanceAlongShapeM": 2295.358,
              "shapeOffsetM": 7.967,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:394",
              "position": {
                "x": -2636.314,
                "z": -2716.04
              },
              "distanceAlongShapeM": 2771.526,
              "shapeOffsetM": 3.684,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:7003",
              "position": {
                "x": -2163.402,
                "z": -2906.975
              },
              "distanceAlongShapeM": 3417.799,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:5214",
              "position": {
                "x": -1747.763,
                "z": -2332.152
              },
              "distanceAlongShapeM": 4221.163,
              "shapeOffsetM": 2.44,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:5220",
              "position": {
                "x": -1001.511,
                "z": -1410.409
              },
              "distanceAlongShapeM": 5441.255,
              "shapeOffsetM": 3.052,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:6635",
              "position": {
                "x": -775.751,
                "z": -1082.734
              },
              "distanceAlongShapeM": 6064.034,
              "shapeOffsetM": 5.378,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:7381",
              "position": {
                "x": -333.702,
                "z": -919.293
              },
              "distanceAlongShapeM": 6541.583,
              "shapeOffsetM": 4.803,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:17638",
              "position": {
                "x": -42.035,
                "z": -765.399
              },
              "distanceAlongShapeM": 6870.978,
              "shapeOffsetM": 5.224,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            },
            {
              "stopId": "judu:stop:5244",
              "position": {
                "x": 121.213,
                "z": -441.083
              },
              "distanceAlongShapeM": 7423.871,
              "shapeOffsetM": 5.293,
              "arrivalOffsetSeconds": 1500,
              "departureOffsetSeconds": 1500
            },
            {
              "stopId": "judu:stop:5249",
              "position": {
                "x": -153.095,
                "z": -312.52
              },
              "distanceAlongShapeM": 7850.088,
              "shapeOffsetM": 1.39,
              "arrivalOffsetSeconds": 1680,
              "departureOffsetSeconds": 1680
            },
            {
              "stopId": "judu:stop:6356",
              "position": {
                "x": -476.052,
                "z": -269.926
              },
              "distanceAlongShapeM": 8317.986,
              "shapeOffsetM": 2.679,
              "arrivalOffsetSeconds": 1800,
              "departureOffsetSeconds": 1800
            }
          ],
          "departuresSeconds": [
            19200,
            20100,
            21000,
            21600,
            22500,
            23400,
            24300,
            25200,
            26100,
            27000,
            27900,
            28800,
            29700,
            30600,
            31800,
            33000,
            34200,
            35100,
            36300,
            37500,
            38700,
            39900,
            41100,
            42300,
            43200,
            44400,
            45600,
            46800,
            48000,
            49200,
            50400,
            51600,
            52800,
            53700,
            54600,
            55500,
            56400,
            57000,
            57900,
            58800,
            59700,
            60600,
            61800,
            62700,
            63600,
            64500,
            65400,
            66600,
            67800,
            69000,
            70200,
            71100,
            72300,
            73500,
            74700,
            75900,
            77100,
            78300,
            79500,
            80700,
            81900,
            83100,
            84000
          ]
        },
        {
          "id": "judu:pattern:vilnius_bus_43:1",
          "sourceRouteId": "vilnius_bus_43",
          "sourceShapeId": "vilnius_bus_43_b-a1_12345",
          "directionId": 1,
          "headsign": "Justiniškės (Apylanka Rygos g.)",
          "directionName": "Centras–Žaliasis tiltas–Šeškinė–Justiniškės (Apylanka Rygos g.)",
          "mode": "bus",
          "routeShortName": "43",
          "routeLongName": "Justiniškės–Šeškinė–Žaliasis tiltas–Centras (Apylanka Rygos g.)",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              -478.241,
              -268.382,
              0
            ],
            [
              -501.093,
              -299.53,
              38.631
            ],
            [
              -461.426,
              -352.57,
              104.864
            ],
            [
              -452.174,
              -363.943,
              119.525
            ],
            [
              -413.017,
              -421.354,
              189.018
            ],
            [
              -305.298,
              -348.72,
              318.937
            ],
            [
              -203.339,
              -309.381,
              428.222
            ],
            [
              -102.285,
              -284.5,
              532.294
            ],
            [
              -49.535,
              -271.256,
              586.682
            ],
            [
              -22.626,
              -265.911,
              614.116
            ],
            [
              -0.545,
              -257.407,
              637.778
            ],
            [
              46.601,
              -218.189,
              699.103
            ],
            [
              70.758,
              -201.931,
              728.222
            ],
            [
              82.464,
              -196.578,
              741.094
            ],
            [
              94.753,
              -194.576,
              753.545
            ],
            [
              102.687,
              -199.192,
              762.723
            ],
            [
              115.784,
              -208.318,
              778.687
            ],
            [
              118.351,
              -267.309,
              837.733
            ],
            [
              118.552,
              -304.106,
              874.531
            ],
            [
              124.949,
              -377.696,
              948.399
            ],
            [
              130.203,
              -407.85,
              979.007
            ],
            [
              144.816,
              -445.964,
              1019.826
            ],
            [
              174.587,
              -519.993,
              1099.617
            ],
            [
              187.997,
              -562.53,
              1144.218
            ],
            [
              214.213,
              -645.388,
              1231.124
            ],
            [
              223.987,
              -656.808,
              1246.156
            ],
            [
              236.049,
              -695.879,
              1287.046
            ],
            [
              236.925,
              -708.144,
              1299.343
            ],
            [
              229.693,
              -715.805,
              1309.878
            ],
            [
              23.734,
              -765.484,
              1521.744
            ],
            [
              -55.388,
              -799.514,
              1607.874
            ],
            [
              -306.711,
              -924.235,
              1888.442
            ],
            [
              -475.993,
              -1014.678,
              2080.37
            ],
            [
              -535.166,
              -1050.172,
              2149.371
            ],
            [
              -673.187,
              -1080.133,
              2290.607
            ],
            [
              -764.624,
              -1108.462,
              2386.331
            ],
            [
              -822.801,
              -1117.509,
              2445.208
            ],
            [
              -837.686,
              -1120.58,
              2460.407
            ],
            [
              -857.223,
              -1131.36,
              2482.72
            ],
            [
              -899.68,
              -1161.766,
              2534.942
            ],
            [
              -917.464,
              -1182.597,
              2562.332
            ],
            [
              -926.283,
              -1206.929,
              2588.213
            ],
            [
              -917.431,
              -1323.977,
              2705.595
            ],
            [
              -911.942,
              -1448.758,
              2830.497
            ],
            [
              -922.391,
              -1491.986,
              2874.97
            ],
            [
              -939.829,
              -1529.521,
              2916.358
            ],
            [
              -961.618,
              -1558.073,
              2952.274
            ],
            [
              -995.732,
              -1590.856,
              2999.587
            ],
            [
              -1026.383,
              -1610.342,
              3035.907
            ],
            [
              -1072.441,
              -1626.213,
              3084.623
            ],
            [
              -1262.636,
              -1662.874,
              3278.319
            ],
            [
              -1320.472,
              -1688.554,
              3341.6
            ],
            [
              -1370.209,
              -1729.965,
              3406.32
            ],
            [
              -1653.223,
              -2198.827,
              3953.977
            ],
            [
              -1682.619,
              -2257.615,
              4019.705
            ],
            [
              -1702.963,
              -2314.026,
              4079.672
            ],
            [
              -1715.793,
              -2345.231,
              4113.412
            ],
            [
              -1755.799,
              -2415.464,
              4194.239
            ],
            [
              -1791.442,
              -2468.3,
              4257.974
            ],
            [
              -1796.498,
              -2488.314,
              4278.617
            ],
            [
              -1790.029,
              -2509.393,
              4300.666
            ],
            [
              -1775.641,
              -2522.016,
              4319.806
            ],
            [
              -1757.6,
              -2522.338,
              4337.85
            ],
            [
              -1741.372,
              -2515.948,
              4355.291
            ],
            [
              -1726.898,
              -2499.508,
              4377.195
            ],
            [
              -1700.955,
              -2454.328,
              4429.293
            ],
            [
              -1699.408,
              -2439.884,
              4443.82
            ],
            [
              -1703.055,
              -2427.574,
              4456.659
            ],
            [
              -1715.393,
              -2414.799,
              4474.419
            ],
            [
              -1729.117,
              -2407.071,
              4490.17
            ],
            [
              -1892.062,
              -2399.714,
              4653.281
            ],
            [
              -1904.503,
              -2410.625,
              4669.828
            ],
            [
              -1906.831,
              -2505.207,
              4764.439
            ],
            [
              -1911.955,
              -2539.626,
              4799.237
            ],
            [
              -1934.345,
              -2592.607,
              4856.755
            ],
            [
              -1946.359,
              -2625.621,
              4891.887
            ],
            [
              -2027.538,
              -2841.481,
              5122.507
            ],
            [
              -2052.018,
              -2913.405,
              5198.483
            ],
            [
              -2063.11,
              -2921.001,
              5211.927
            ],
            [
              -2092.617,
              -2921.15,
              5241.434
            ],
            [
              -2134.547,
              -2915.279,
              5283.773
            ],
            [
              -2189.877,
              -2909.844,
              5339.369
            ],
            [
              -2238.843,
              -2908.976,
              5388.343
            ],
            [
              -2253.813,
              -2880.88,
              5420.178
            ],
            [
              -2299.624,
              -2811.049,
              5503.695
            ],
            [
              -2361.565,
              -2742.045,
              5596.422
            ],
            [
              -2438.543,
              -2685.023,
              5692.219
            ],
            [
              -2496.606,
              -2651.713,
              5759.158
            ],
            [
              -2552.25,
              -2627.352,
              5819.901
            ],
            [
              -2587.598,
              -2694.635,
              5895.904
            ],
            [
              -2669.545,
              -2793.221,
              6024.101
            ],
            [
              -2878.335,
              -2954.459,
              6287.902
            ],
            [
              -2942.823,
              -2993.401,
              6363.236
            ],
            [
              -2993.467,
              -3014.776,
              6418.206
            ],
            [
              -3056.314,
              -3033.711,
              6483.844
            ],
            [
              -3148.249,
              -3057.702,
              6578.857
            ],
            [
              -3175.722,
              -3067.532,
              6608.036
            ],
            [
              -3256.076,
              -3081.304,
              6689.561
            ],
            [
              -3258.184,
              -3079.154,
              6692.572
            ],
            [
              -3398.204,
              -3088.951,
              6832.935
            ],
            [
              -3540.683,
              -3092.03,
              6975.447
            ],
            [
              -3587.831,
              -3097.887,
              7022.957
            ],
            [
              -3688.781,
              -3121.733,
              7126.686
            ],
            [
              -4069.341,
              -3289.974,
              7542.775
            ],
            [
              -4174.702,
              -3308.112,
              7649.686
            ],
            [
              -4173.655,
              -3250.667,
              7707.141
            ],
            [
              -4124.202,
              -3034.023,
              7929.358
            ],
            [
              -4119.192,
              -3005.166,
              7958.646
            ],
            [
              -4115.728,
              -2954.018,
              8009.911
            ],
            [
              -4117.064,
              -2919.485,
              8044.47
            ],
            [
              -4121.349,
              -2884.733,
              8079.485
            ],
            [
              -4122.899,
              -2847.026,
              8117.224
            ],
            [
              -4138.614,
              -2526.149,
              8438.486
            ],
            [
              -4201.835,
              -2305.753,
              8667.77
            ],
            [
              -4229.293,
              -2290.807,
              8699.032
            ],
            [
              -4250.952,
              -2275.961,
              8725.291
            ],
            [
              -4254.722,
              -2270.33,
              8732.068
            ],
            [
              -4258.829,
              -2246.881,
              8755.873
            ],
            [
              -4260.118,
              -2246.859,
              8757.163
            ],
            [
              -4255.982,
              -2231.346,
              8773.218
            ],
            [
              -4254.713,
              -2232.481,
              8774.92
            ],
            [
              -4246.201,
              -2224.835,
              8786.362
            ],
            [
              -4226.129,
              -2219.616,
              8807.101
            ],
            [
              -4210.635,
              -2255.507,
              8846.194
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:6356",
              "position": {
                "x": -476.052,
                "z": -269.926
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 2.679,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:5258",
              "position": {
                "x": -449.339,
                "z": -361.695
              },
              "distanceAlongShapeM": 119.525,
              "shapeOffsetM": 3.618,
              "arrivalOffsetSeconds": 60,
              "departureOffsetSeconds": 60
            },
            {
              "stopId": "judu:stop:5248",
              "position": {
                "x": -50.388,
                "z": -267.632
              },
              "distanceAlongShapeM": 586.682,
              "shapeOffsetM": 3.723,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:5245",
              "position": {
                "x": 150.182,
                "z": -443.837
              },
              "distanceAlongShapeM": 1019.761,
              "shapeOffsetM": 5.772,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:753",
              "position": {
                "x": -53.078,
                "z": -805.275
              },
              "distanceAlongShapeM": 1608.365,
              "shapeOffsetM": 6.187,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:7382",
              "position": {
                "x": -534.689,
                "z": -1051.466
              },
              "distanceAlongShapeM": 2149.371,
              "shapeOffsetM": 1.38,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:988",
              "position": {
                "x": -763.423,
                "z": -1114.127
              },
              "distanceAlongShapeM": 2386.331,
              "shapeOffsetM": 5.791,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:5290",
              "position": {
                "x": -1711.936,
                "z": -2347.263
              },
              "distanceAlongShapeM": 4113.412,
              "shapeOffsetM": 4.36,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:5294",
              "position": {
                "x": -1930.967,
                "z": -2593.836
              },
              "distanceAlongShapeM": 4856.572,
              "shapeOffsetM": 3.59,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:5209",
              "position": {
                "x": -2092.806,
                "z": -2923.813
              },
              "distanceAlongShapeM": 5241.434,
              "shapeOffsetM": 2.67,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:393",
              "position": {
                "x": -2667.366,
                "z": -2795.644
              },
              "distanceAlongShapeM": 6024.101,
              "shapeOffsetM": 3.259,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:5137",
              "position": {
                "x": -3175.503,
                "z": -3068.357
              },
              "distanceAlongShapeM": 6608.036,
              "shapeOffsetM": 0.854,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            },
            {
              "stopId": "judu:stop:15411",
              "position": {
                "x": -3782.29,
                "z": -3162.408
              },
              "distanceAlongShapeM": 7228.656,
              "shapeOffsetM": 0.607,
              "arrivalOffsetSeconds": 1500,
              "departureOffsetSeconds": 1500
            },
            {
              "stopId": "judu:stop:6995",
              "position": {
                "x": -4176.922,
                "z": -3250.186
              },
              "distanceAlongShapeM": 7707.141,
              "shapeOffsetM": 3.302,
              "arrivalOffsetSeconds": 1620,
              "departureOffsetSeconds": 1620
            },
            {
              "stopId": "judu:stop:6992",
              "position": {
                "x": -4123.554,
                "z": -2884.864
              },
              "distanceAlongShapeM": 8079.485,
              "shapeOffsetM": 2.209,
              "arrivalOffsetSeconds": 1680,
              "departureOffsetSeconds": 1680
            },
            {
              "stopId": "judu:stop:6990",
              "position": {
                "x": -4210.635,
                "z": -2255.507
              },
              "distanceAlongShapeM": 8846.194,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1740,
              "departureOffsetSeconds": 1740
            }
          ],
          "departuresSeconds": [
            20760,
            21660,
            22620,
            23220,
            24180,
            25140,
            26040,
            27120,
            28020,
            28980,
            29880,
            30840,
            31680,
            32640,
            33840,
            34920,
            36060,
            37020,
            38160,
            39240,
            40440,
            41640,
            42840,
            44040,
            44940,
            46140,
            47340,
            48540,
            49740,
            51000,
            52200,
            53400,
            54600,
            55500,
            56400,
            57300,
            58260,
            58860,
            59760,
            60720,
            61680,
            62580,
            63840,
            64740,
            65580,
            66420,
            68520,
            70920,
            72060,
            72960,
            74160,
            75240,
            76380,
            77580,
            78720,
            79920,
            81120
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_bus_46",
      "sourceRouteId": "vilnius_bus_46",
      "mode": "bus",
      "shortName": "46",
      "longName": "Perkūnkiemis–Laisvės pr.–A.Goštauto g.–Centras",
      "color": "0073AC",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_bus_46:0",
          "sourceRouteId": "vilnius_bus_46",
          "sourceShapeId": "vilnius_bus_46_a-b",
          "directionId": 0,
          "headsign": "Centras",
          "directionName": "Perkūnkiemis–Laisvės pr.–A.Goštauto g.–Centras",
          "mode": "bus",
          "routeShortName": "46",
          "routeLongName": "Perkūnkiemis–Laisvės pr.–A.Goštauto g.–Centras",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              -3846.109,
              -5119.902,
              0
            ],
            [
              -3862.028,
              -5154.789,
              38.347
            ],
            [
              -3896.745,
              -5150.846,
              73.287
            ],
            [
              -3900.57,
              -5148.553,
              77.747
            ],
            [
              -3904.981,
              -5142.911,
              84.909
            ],
            [
              -3906.076,
              -5131.759,
              96.114
            ],
            [
              -3903.757,
              -5109.535,
              118.459
            ],
            [
              -3869.632,
              -5096.489,
              154.993
            ],
            [
              -3868.639,
              -5091.898,
              159.689
            ],
            [
              -3866.173,
              -5086.493,
              165.631
            ],
            [
              -3846.88,
              -5061.542,
              197.171
            ],
            [
              -3843.309,
              -5049.375,
              209.85
            ],
            [
              -3839.486,
              -5043.859,
              216.562
            ],
            [
              -3824.617,
              -5040.778,
              231.747
            ],
            [
              -3766.774,
              -5048.464,
              290.098
            ],
            [
              -3779.214,
              -4985.907,
              353.88
            ],
            [
              -3777.543,
              -4926.936,
              412.875
            ],
            [
              -3771.66,
              -4848,
              492.03
            ],
            [
              -3753.439,
              -4800.449,
              542.952
            ],
            [
              -3737.479,
              -4771.783,
              575.762
            ],
            [
              -3706.062,
              -4743.386,
              618.111
            ],
            [
              -3682.606,
              -4728.21,
              646.048
            ],
            [
              -3641.799,
              -4715.562,
              688.77
            ],
            [
              -3538.579,
              -4707.343,
              792.317
            ],
            [
              -3481.885,
              -4707.22,
              849.011
            ],
            [
              -3452.961,
              -4711.064,
              878.189
            ],
            [
              -3415.86,
              -4726.185,
              918.253
            ],
            [
              -3417.148,
              -4726.162,
              919.541
            ],
            [
              -3378.974,
              -4753.547,
              966.522
            ],
            [
              -3279.537,
              -4851.023,
              1105.768
            ],
            [
              -3072.1,
              -4737.98,
              1342.006
            ],
            [
              -3035.648,
              -4719.487,
              1382.881
            ],
            [
              -2942.026,
              -4671.037,
              1488.297
            ],
            [
              -2845.866,
              -4624.861,
              1594.969
            ],
            [
              -2808.606,
              -4606.111,
              1636.681
            ],
            [
              -2796.238,
              -4575.527,
              1669.671
            ],
            [
              -2770.825,
              -4531.174,
              1720.789
            ],
            [
              -2769.313,
              -4521.566,
              1730.515
            ],
            [
              -2770.322,
              -4516.868,
              1735.321
            ],
            [
              -2784.273,
              -4500.63,
              1756.729
            ],
            [
              -2804.191,
              -4483.318,
              1783.119
            ],
            [
              -2811.989,
              -4476.099,
              1793.745
            ],
            [
              -2835.666,
              -4448.038,
              1830.46
            ],
            [
              -2880.475,
              -4394.928,
              1899.948
            ],
            [
              -2902.49,
              -4364.484,
              1937.518
            ],
            [
              -2922.066,
              -4325.629,
              1981.026
            ],
            [
              -2938.397,
              -4244.738,
              2063.549
            ],
            [
              -2943.47,
              -4203.459,
              2105.138
            ],
            [
              -2943.332,
              -4158.933,
              2149.665
            ],
            [
              -2942.883,
              -4106.854,
              2201.745
            ],
            [
              -2936.886,
              -4048.837,
              2260.072
            ],
            [
              -2933.232,
              -3950.938,
              2358.039
            ],
            [
              -2935.53,
              -3825.104,
              2483.894
            ],
            [
              -2941.624,
              -3778.189,
              2531.203
            ],
            [
              -2941.11,
              -3739.288,
              2570.107
            ],
            [
              -2942.553,
              -3711.432,
              2598.001
            ],
            [
              -2947.139,
              -3679.068,
              2630.688
            ],
            [
              -2962.772,
              -3578.604,
              2732.361
            ],
            [
              -2994.393,
              -3434.443,
              2879.949
            ],
            [
              -3009.522,
              -3378.516,
              2937.886
            ],
            [
              -3022.156,
              -3343.455,
              2975.154
            ],
            [
              -3029.648,
              -3313.596,
              3005.939
            ],
            [
              -3083.217,
              -3134.541,
              3192.835
            ],
            [
              -3102.428,
              -3054.053,
              3275.584
            ],
            [
              -3114.845,
              -3027.118,
              3305.243
            ],
            [
              -3065.414,
              -3014.303,
              3356.309
            ],
            [
              -3011.076,
              -2998.586,
              3412.874
            ],
            [
              -2972.094,
              -2983.696,
              3454.603
            ],
            [
              -2923.591,
              -2962.569,
              3507.508
            ],
            [
              -2796.251,
              -2867.959,
              3666.147
            ],
            [
              -2713.249,
              -2802.628,
              3771.776
            ],
            [
              -2678.551,
              -2772.069,
              3818.012
            ],
            [
              -2644.38,
              -2734.822,
              3868.559
            ],
            [
              -2633.43,
              -2718.353,
              3888.336
            ],
            [
              -2600.033,
              -2668.811,
              3948.084
            ],
            [
              -2574.02,
              -2619.176,
              4004.122
            ],
            [
              -2520.523,
              -2473.175,
              4159.616
            ],
            [
              -2499.973,
              -2404.518,
              4231.282
            ],
            [
              -2490.126,
              -2357.937,
              4278.893
            ],
            [
              -2467.791,
              -2224.746,
              4413.944
            ],
            [
              -2432.042,
              -2227.602,
              4449.806
            ],
            [
              -2417.854,
              -2231.757,
              4464.591
            ],
            [
              -2373.845,
              -2246.595,
              4511.033
            ],
            [
              -2196.773,
              -2317.488,
              4701.77
            ],
            [
              -2137.794,
              -2339.218,
              4764.625
            ],
            [
              -2071.077,
              -2358.315,
              4834.021
            ],
            [
              -2038.61,
              -2363.283,
              4866.865
            ],
            [
              -1991.404,
              -2367.89,
              4914.296
            ],
            [
              -1948.857,
              -2368.231,
              4956.844
            ],
            [
              -1899.081,
              -2359.513,
              5007.378
            ],
            [
              -1862.838,
              -2351.253,
              5044.55
            ],
            [
              -1818.039,
              -2333.126,
              5092.878
            ],
            [
              -1763.981,
              -2301.806,
              5155.353
            ],
            [
              -1728.668,
              -2273.492,
              5200.616
            ],
            [
              -1675.636,
              -2214.729,
              5279.771
            ],
            [
              -1645.063,
              -2175.906,
              5329.187
            ],
            [
              -1547.472,
              -2017.345,
              5515.374
            ],
            [
              -1343.434,
              -1674.784,
              5914.096
            ],
            [
              -1305.861,
              -1628.702,
              5973.554
            ],
            [
              -1268.647,
              -1602.651,
              6018.98
            ],
            [
              -1054.592,
              -1494.059,
              6259.005
            ],
            [
              -1027.103,
              -1471.176,
              6294.772
            ],
            [
              -1009.966,
              -1450.333,
              6321.755
            ],
            [
              -998.422,
              -1410.718,
              6363.018
            ],
            [
              -987.78,
              -1363.9,
              6411.03
            ],
            [
              -988.723,
              -1201.352,
              6573.581
            ],
            [
              -990.397,
              -1186.85,
              6588.179
            ],
            [
              -1017.615,
              -1122.906,
              6657.675
            ],
            [
              -1020.518,
              -1105.042,
              6675.773
            ],
            [
              -1018.304,
              -1089.497,
              6691.475
            ],
            [
              -1013.532,
              -1075.111,
              6706.632
            ],
            [
              -1005.537,
              -1060.783,
              6723.04
            ],
            [
              -990.532,
              -1051.034,
              6740.934
            ],
            [
              -976.596,
              -1029.02,
              6766.988
            ],
            [
              -969.87,
              -1013.556,
              6783.851
            ],
            [
              -967.031,
              -999.135,
              6798.549
            ],
            [
              -963.614,
              -973.419,
              6824.492
            ],
            [
              -954.808,
              -934.814,
              6864.088
            ],
            [
              -945.547,
              -916.03,
              6885.031
            ],
            [
              -940.714,
              -898.305,
              6903.403
            ],
            [
              -936.79,
              -859.413,
              6942.492
            ],
            [
              -926.694,
              -692.61,
              7109.601
            ],
            [
              -924.604,
              -648.119,
              7154.141
            ],
            [
              -926.501,
              -610.235,
              7192.072
            ],
            [
              -934.701,
              -600.068,
              7205.134
            ],
            [
              -944.29,
              -595.443,
              7215.78
            ],
            [
              -952.65,
              -594.179,
              7224.235
            ],
            [
              -963.004,
              -596.219,
              7234.788
            ],
            [
              -972.833,
              -604.948,
              7247.934
            ],
            [
              -992.823,
              -641.327,
              7289.443
            ],
            [
              -992.319,
              -666.855,
              7314.976
            ],
            [
              -989.606,
              -677.006,
              7325.483
            ],
            [
              -978.263,
              -691.682,
              7344.032
            ],
            [
              -964.927,
              -703.054,
              7361.558
            ],
            [
              -939.343,
              -714.647,
              7389.646
            ],
            [
              -865.474,
              -730.449,
              7465.186
            ],
            [
              -798.395,
              -729.432,
              7532.273
            ],
            [
              -764.735,
              -722.247,
              7566.691
            ],
            [
              -714.638,
              -697.546,
              7622.547
            ],
            [
              -690.623,
              -676.974,
              7654.168
            ],
            [
              -655.859,
              -656.305,
              7694.613
            ],
            [
              -601.451,
              -607.193,
              7767.908
            ],
            [
              -500.911,
              -503.255,
              7912.516
            ],
            [
              -413.017,
              -421.354,
              8032.654
            ],
            [
              -305.298,
              -348.72,
              8162.573
            ],
            [
              -203.339,
              -309.381,
              8271.858
            ],
            [
              -102.285,
              -284.5,
              8375.93
            ],
            [
              -49.535,
              -271.256,
              8430.318
            ],
            [
              -22.626,
              -265.911,
              8457.752
            ],
            [
              -0.545,
              -257.407,
              8481.414
            ],
            [
              58.367,
              -209.498,
              8557.348
            ],
            [
              82.464,
              -196.578,
              8584.69
            ],
            [
              94.753,
              -194.576,
              8597.141
            ],
            [
              102.687,
              -199.192,
              8606.32
            ],
            [
              115.784,
              -208.318,
              8622.283
            ],
            [
              118.351,
              -267.309,
              8681.329
            ],
            [
              118.552,
              -304.106,
              8718.127
            ],
            [
              124.949,
              -377.696,
              8791.995
            ],
            [
              130.203,
              -407.85,
              8822.603
            ],
            [
              144.816,
              -445.964,
              8863.422
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:7603",
              "position": {
                "x": -3854.099,
                "z": -5069.209
              },
              "distanceAlongShapeM": 186.689,
              "shapeOffsetM": 1.021,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:7023",
              "position": {
                "x": -3417.148,
                "z": -4726.162
              },
              "distanceAlongShapeM": 919.541,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:7027",
              "position": {
                "x": -3074.543,
                "z": -4733.276
              },
              "distanceAlongShapeM": 1342.006,
              "shapeOffsetM": 5.301,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:6766",
              "position": {
                "x": -2809.985,
                "z": -4489.679
              },
              "distanceAlongShapeM": 1783.119,
              "shapeOffsetM": 8.604,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:6484",
              "position": {
                "x": -2923.723,
                "z": -4326.261
              },
              "distanceAlongShapeM": 1981.026,
              "shapeOffsetM": 1.774,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:6523",
              "position": {
                "x": -2947.565,
                "z": -4106.537
              },
              "distanceAlongShapeM": 2201.745,
              "shapeOffsetM": 4.693,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:6482",
              "position": {
                "x": -2942.439,
                "z": -3778.227
              },
              "distanceAlongShapeM": 2531.203,
              "shapeOffsetM": 0.816,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:6478",
              "position": {
                "x": -3026.974,
                "z": -3344.813
              },
              "distanceAlongShapeM": 2975.154,
              "shapeOffsetM": 5.006,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:855",
              "position": {
                "x": -3013.674,
                "z": -2991.043
              },
              "distanceAlongShapeM": 3412.474,
              "shapeOffsetM": 7.967,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:394",
              "position": {
                "x": -2636.314,
                "z": -2716.04
              },
              "distanceAlongShapeM": 3888.642,
              "shapeOffsetM": 3.684,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:1069",
              "position": {
                "x": -2415.576,
                "z": -2224.555
              },
              "distanceAlongShapeM": 4464.591,
              "shapeOffsetM": 7.553,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            },
            {
              "stopId": "judu:stop:5220",
              "position": {
                "x": -1001.511,
                "z": -1410.409
              },
              "distanceAlongShapeM": 6362.45,
              "shapeOffsetM": 3.052,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:5533",
              "position": {
                "x": -969.129,
                "z": -972.38
              },
              "distanceAlongShapeM": 6824.492,
              "shapeOffsetM": 5.612,
              "arrivalOffsetSeconds": 1380,
              "departureOffsetSeconds": 1380
            },
            {
              "stopId": "judu:stop:5539",
              "position": {
                "x": -692.924,
                "z": -673.447
              },
              "distanceAlongShapeM": 7654.168,
              "shapeOffsetM": 4.211,
              "arrivalOffsetSeconds": 1500,
              "departureOffsetSeconds": 1500
            },
            {
              "stopId": "judu:stop:5248",
              "position": {
                "x": -50.388,
                "z": -267.632
              },
              "distanceAlongShapeM": 8430.318,
              "shapeOffsetM": 3.723,
              "arrivalOffsetSeconds": 1680,
              "departureOffsetSeconds": 1680
            },
            {
              "stopId": "judu:stop:5245",
              "position": {
                "x": 150.182,
                "z": -443.837
              },
              "distanceAlongShapeM": 8863.357,
              "shapeOffsetM": 5.772,
              "arrivalOffsetSeconds": 1800,
              "departureOffsetSeconds": 1800
            }
          ],
          "departuresSeconds": [
            19260,
            20280,
            21300,
            23040,
            23940,
            24840,
            25740,
            27180,
            28320,
            29460,
            30600,
            33060,
            34200,
            36000,
            37440,
            38880,
            40320,
            41760,
            43200,
            44640,
            46080,
            47520,
            48960,
            50400,
            51780,
            53160,
            54540,
            56040,
            57240,
            58440,
            59580,
            60720,
            61920,
            63180,
            64440,
            67020,
            68040,
            70020,
            71460,
            72900,
            74400,
            75900,
            77400,
            78900,
            80340,
            81780,
            83220
          ]
        },
        {
          "id": "judu:pattern:vilnius_bus_46:1",
          "sourceRouteId": "vilnius_bus_46",
          "sourceShapeId": "vilnius_bus_46_b-a",
          "directionId": 1,
          "headsign": "Perkūnkiemis",
          "directionName": "Centras–A.Goštauto g.–Laisvės pr.–Perkūnkiemis",
          "mode": "bus",
          "routeShortName": "46",
          "routeLongName": "Perkūnkiemis–Laisvės pr.–A.Goštauto g.–Centras",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              144.816,
              -445.964,
              0
            ],
            [
              174.587,
              -519.993,
              79.791
            ],
            [
              187.997,
              -562.53,
              124.392
            ],
            [
              214.213,
              -645.388,
              211.298
            ],
            [
              223.987,
              -656.808,
              226.33
            ],
            [
              236.049,
              -695.879,
              267.22
            ],
            [
              236.925,
              -708.144,
              279.517
            ],
            [
              229.693,
              -715.805,
              290.052
            ],
            [
              23.734,
              -765.484,
              501.918
            ],
            [
              -55.388,
              -799.514,
              588.048
            ],
            [
              -306.711,
              -924.235,
              868.616
            ],
            [
              -475.993,
              -1014.678,
              1060.544
            ],
            [
              -535.166,
              -1050.172,
              1129.545
            ],
            [
              -673.187,
              -1080.133,
              1270.781
            ],
            [
              -764.624,
              -1108.462,
              1366.505
            ],
            [
              -822.801,
              -1117.509,
              1425.382
            ],
            [
              -837.686,
              -1120.58,
              1440.581
            ],
            [
              -857.223,
              -1131.36,
              1462.894
            ],
            [
              -899.68,
              -1161.766,
              1515.116
            ],
            [
              -917.464,
              -1182.597,
              1542.506
            ],
            [
              -926.283,
              -1206.929,
              1568.387
            ],
            [
              -917.431,
              -1323.977,
              1685.769
            ],
            [
              -911.942,
              -1448.758,
              1810.671
            ],
            [
              -922.391,
              -1491.986,
              1855.144
            ],
            [
              -939.829,
              -1529.521,
              1896.532
            ],
            [
              -961.618,
              -1558.073,
              1932.448
            ],
            [
              -995.732,
              -1590.856,
              1979.761
            ],
            [
              -1026.383,
              -1610.342,
              2016.081
            ],
            [
              -1072.441,
              -1626.213,
              2064.797
            ],
            [
              -1262.636,
              -1662.874,
              2258.493
            ],
            [
              -1320.472,
              -1688.554,
              2321.774
            ],
            [
              -1370.209,
              -1729.965,
              2386.494
            ],
            [
              -1653.223,
              -2198.827,
              2934.151
            ],
            [
              -1682.619,
              -2257.615,
              2999.879
            ],
            [
              -1702.963,
              -2314.026,
              3059.846
            ],
            [
              -1715.793,
              -2345.231,
              3093.586
            ],
            [
              -1755.799,
              -2415.464,
              3174.413
            ],
            [
              -1791.442,
              -2468.3,
              3238.148
            ],
            [
              -1797.501,
              -2485.334,
              3256.227
            ],
            [
              -1794.575,
              -2499.414,
              3270.608
            ],
            [
              -1786.456,
              -2514.031,
              3287.329
            ],
            [
              -1773.708,
              -2522.051,
              3302.39
            ],
            [
              -1755.022,
              -2522.384,
              3321.079
            ],
            [
              -1739.399,
              -2513.757,
              3338.925
            ],
            [
              -1728.911,
              -2503.925,
              3353.301
            ],
            [
              -1701.579,
              -2453.204,
              3410.918
            ],
            [
              -1699.467,
              -2443.223,
              3421.12
            ],
            [
              -1706.803,
              -2420.827,
              3444.687
            ],
            [
              -1718.536,
              -2413.488,
              3458.526
            ],
            [
              -1731.05,
              -2407.036,
              3472.605
            ],
            [
              -1888.196,
              -2401.495,
              3629.849
            ],
            [
              -1933.866,
              -2394.517,
              3676.049
            ],
            [
              -2056.217,
              -2387.889,
              3798.579
            ],
            [
              -2112.006,
              -2376.568,
              3855.506
            ],
            [
              -2168.467,
              -2356.953,
              3915.277
            ],
            [
              -2218.449,
              -2337.7,
              3968.839
            ],
            [
              -2387.812,
              -2273.476,
              4149.97
            ],
            [
              -2400.864,
              -2268.936,
              4163.789
            ],
            [
              -2472.07,
              -2248.048,
              4237.995
            ],
            [
              -2473.439,
              -2303.416,
              4293.38
            ],
            [
              -2477.313,
              -2325.88,
              4316.176
            ],
            [
              -2484.017,
              -2376.97,
              4367.704
            ],
            [
              -2514.005,
              -2505.574,
              4499.758
            ],
            [
              -2552.25,
              -2627.352,
              4627.4
            ],
            [
              -2587.598,
              -2694.635,
              4703.403
            ],
            [
              -2669.545,
              -2793.221,
              4831.6
            ],
            [
              -2878.335,
              -2954.459,
              5095.401
            ],
            [
              -2942.823,
              -2993.401,
              5170.735
            ],
            [
              -2993.467,
              -3014.776,
              5225.705
            ],
            [
              -3056.314,
              -3033.711,
              5291.343
            ],
            [
              -3080.894,
              -3038.845,
              5316.453
            ],
            [
              -3066.407,
              -3094.76,
              5374.214
            ],
            [
              -3058.312,
              -3116.524,
              5397.436
            ],
            [
              -3044.503,
              -3168.617,
              5451.327
            ],
            [
              -2983.753,
              -3378.969,
              5670.276
            ],
            [
              -2973.575,
              -3406.127,
              5699.279
            ],
            [
              -2964.33,
              -3447.216,
              5741.395
            ],
            [
              -2935.834,
              -3585.756,
              5882.835
            ],
            [
              -2926.739,
              -3654.936,
              5952.61
            ],
            [
              -2914.467,
              -3799.87,
              6098.063
            ],
            [
              -2911.34,
              -3835.779,
              6134.108
            ],
            [
              -2910.491,
              -3863.444,
              6161.786
            ],
            [
              -2921.12,
              -4178.248,
              6476.769
            ],
            [
              -2920.043,
              -4206.629,
              6505.171
            ],
            [
              -2915.905,
              -4240.706,
              6539.498
            ],
            [
              -2903.306,
              -4301.016,
              6601.11
            ],
            [
              -2872.92,
              -4368.343,
              6674.976
            ],
            [
              -2823.799,
              -4432.662,
              6755.907
            ],
            [
              -2778.775,
              -4473.531,
              6816.714
            ],
            [
              -2757.796,
              -4489.485,
              6843.07
            ],
            [
              -2753.128,
              -4500.522,
              6855.053
            ],
            [
              -2808.606,
              -4606.111,
              6974.33
            ],
            [
              -2823.831,
              -4617.456,
              6993.317
            ],
            [
              -2856.272,
              -4635.693,
              7030.532
            ],
            [
              -2965.525,
              -4688.436,
              7151.85
            ],
            [
              -3120.309,
              -4771.436,
              7327.484
            ],
            [
              -3150.693,
              -4788.872,
              7362.515
            ],
            [
              -3182.74,
              -4804.851,
              7398.325
            ],
            [
              -3279.537,
              -4851.023,
              7505.57
            ],
            [
              -3386.624,
              -4748.96,
              7653.504
            ],
            [
              -3428.663,
              -4721.508,
              7703.712
            ],
            [
              -3452.961,
              -4711.064,
              7730.16
            ],
            [
              -3508.973,
              -4708.973,
              7786.211
            ],
            [
              -3544.472,
              -4712.195,
              7821.856
            ],
            [
              -3563.13,
              -4711.368,
              7840.532
            ],
            [
              -3606.358,
              -4715.067,
              7883.918
            ],
            [
              -3659.948,
              -4721.925,
              7937.945
            ],
            [
              -3686.528,
              -4731.481,
              7966.191
            ],
            [
              -3706.062,
              -4743.386,
              7989.067
            ],
            [
              -3733.537,
              -4767.398,
              8025.556
            ],
            [
              -3748.737,
              -4789.398,
              8052.296
            ],
            [
              -3760.814,
              -4817.018,
              8082.441
            ],
            [
              -3769.026,
              -4844.706,
              8111.321
            ],
            [
              -3776.333,
              -4931.41,
              8198.332
            ],
            [
              -3777.165,
              -4979.264,
              8246.194
            ],
            [
              -3766.774,
              -5048.464,
              8316.169
            ],
            [
              -3780.192,
              -5052.746,
              8330.254
            ],
            [
              -3796.475,
              -5052.4,
              8346.541
            ],
            [
              -3825.435,
              -5050.783,
              8375.546
            ],
            [
              -3827.684,
              -5087.455,
              8412.287
            ],
            [
              -3836.059,
              -5117.022,
              8443.017
            ],
            [
              -3846.109,
              -5119.902,
              8453.472
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:5245",
              "position": {
                "x": 150.182,
                "z": -443.837
              },
              "distanceAlongShapeM": 0.029,
              "shapeOffsetM": 5.773,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:753",
              "position": {
                "x": -53.078,
                "z": -805.275
              },
              "distanceAlongShapeM": 588.539,
              "shapeOffsetM": 6.187,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:7382",
              "position": {
                "x": -534.689,
                "z": -1051.466
              },
              "distanceAlongShapeM": 1129.545,
              "shapeOffsetM": 1.38,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:988",
              "position": {
                "x": -763.423,
                "z": -1114.127
              },
              "distanceAlongShapeM": 1366.505,
              "shapeOffsetM": 5.791,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:5290",
              "position": {
                "x": -1711.936,
                "z": -2347.263
              },
              "distanceAlongShapeM": 3093.586,
              "shapeOffsetM": 4.36,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:5074",
              "position": {
                "x": -2470.476,
                "z": -2303.737
              },
              "distanceAlongShapeM": 4293.38,
              "shapeOffsetM": 2.98,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:393",
              "position": {
                "x": -2667.366,
                "z": -2795.644
              },
              "distanceAlongShapeM": 4831.6,
              "shapeOffsetM": 3.259,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:5067",
              "position": {
                "x": -3053.229,
                "z": -3115.03
              },
              "distanceAlongShapeM": 5397.436,
              "shapeOffsetM": 5.298,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:6479",
              "position": {
                "x": -2968.741,
                "z": -3404.837
              },
              "distanceAlongShapeM": 5699.279,
              "shapeOffsetM": 5.004,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:6481",
              "position": {
                "x": -2906.719,
                "z": -3835.629
              },
              "distanceAlongShapeM": 6134.108,
              "shapeOffsetM": 4.623,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:6653",
              "position": {
                "x": -2914.524,
                "z": -4206.195
              },
              "distanceAlongShapeM": 6505.405,
              "shapeOffsetM": 5.531,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:7898",
              "position": {
                "x": -2853.869,
                "z": -4640.305
              },
              "distanceAlongShapeM": 7030.532,
              "shapeOffsetM": 5.2,
              "arrivalOffsetSeconds": 1380,
              "departureOffsetSeconds": 1380
            },
            {
              "stopId": "judu:stop:7028",
              "position": {
                "x": -3149.017,
                "z": -4792.083
              },
              "distanceAlongShapeM": 7362.515,
              "shapeOffsetM": 3.622,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            },
            {
              "stopId": "judu:stop:7022",
              "position": {
                "x": -3543.926,
                "z": -4718.382
              },
              "distanceAlongShapeM": 7821.856,
              "shapeOffsetM": 6.211,
              "arrivalOffsetSeconds": 1560,
              "departureOffsetSeconds": 1560
            },
            {
              "stopId": "judu:stop:6931",
              "position": {
                "x": -3827.361,
                "z": -5087.486
              },
              "distanceAlongShapeM": 8412.287,
              "shapeOffsetM": 0.325,
              "arrivalOffsetSeconds": 1680,
              "departureOffsetSeconds": 1680
            }
          ],
          "departuresSeconds": [
            20880,
            21900,
            22920,
            24660,
            25620,
            26640,
            27600,
            29160,
            30420,
            31560,
            32700,
            34920,
            36060,
            37740,
            39180,
            40620,
            42060,
            43500,
            45000,
            46560,
            47940,
            49380,
            50760,
            52200,
            53640,
            55080,
            56460,
            57960,
            59160,
            60420,
            61620,
            62820,
            64200,
            65460,
            66600,
            68940,
            69960,
            71820,
            73260,
            74640,
            76080,
            77580,
            79080,
            80580,
            82020,
            83400,
            84900
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_bus_48",
      "sourceRouteId": "vilnius_bus_48",
      "mode": "bus",
      "shortName": "48",
      "longName": "Šeškinė–Pašilaičiai–Santariškės",
      "color": "0073AC",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_bus_48:0",
          "sourceRouteId": "vilnius_bus_48",
          "sourceShapeId": "vilnius_bus_48_a-b",
          "directionId": 0,
          "headsign": "Santariškės",
          "directionName": "Šeškinė–Pašilaičiai–Santariškės",
          "mode": "bus",
          "routeShortName": "48",
          "routeLongName": "Šeškinė–Pašilaičiai–Santariškės",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              -2194.158,
              -3114.447,
              0
            ],
            [
              -2187.067,
              -3114.727,
              7.097
            ],
            [
              -2174.766,
              -3111.606,
              19.787
            ],
            [
              -1943.03,
              -3126.856,
              252.025
            ],
            [
              -1903.67,
              -3124.217,
              291.473
            ],
            [
              -1868.018,
              -3112.606,
              328.968
            ],
            [
              -1837.381,
              -3093.114,
              365.28
            ],
            [
              -1816.447,
              -3075.675,
              392.526
            ],
            [
              -1775.996,
              -3011.829,
              468.108
            ],
            [
              -1683.756,
              -3043.532,
              565.644
            ],
            [
              -1647.191,
              -3053.091,
              603.438
            ],
            [
              -1571.382,
              -3065.693,
              680.288
            ],
            [
              -1552.592,
              -3068.149,
              699.237
            ],
            [
              -1523.92,
              -3071.312,
              728.083
            ],
            [
              -1491.596,
              -3073.684,
              760.494
            ],
            [
              -1438.786,
              -3075.742,
              813.344
            ],
            [
              -1362.723,
              -3074.878,
              889.412
            ],
            [
              -1386.134,
              -2978.721,
              988.378
            ],
            [
              -1409.242,
              -2901.495,
              1068.987
            ],
            [
              -1418.932,
              -2871.362,
              1100.64
            ],
            [
              -1430.357,
              -2820.964,
              1152.316
            ],
            [
              -1448.996,
              -2746.044,
              1229.52
            ],
            [
              -1452.909,
              -2712.577,
              1263.215
            ],
            [
              -1453.659,
              -2682.507,
              1293.295
            ],
            [
              -1443.344,
              -2610.331,
              1366.204
            ],
            [
              -1428.471,
              -2571.635,
              1407.66
            ],
            [
              -1415.77,
              -2546.258,
              1436.038
            ],
            [
              -1386.622,
              -2502.251,
              1488.822
            ],
            [
              -1448.618,
              -2469.866,
              1558.767
            ],
            [
              -1488.158,
              -2449.225,
              1603.371
            ],
            [
              -1548.409,
              -2430.336,
              1666.513
            ],
            [
              -1640.314,
              -2415.335,
              1759.634
            ],
            [
              -1771.001,
              -2406.324,
              1890.632
            ],
            [
              -1888.196,
              -2401.495,
              2007.926
            ],
            [
              -1933.866,
              -2394.517,
              2054.126
            ],
            [
              -2056.217,
              -2387.889,
              2176.657
            ],
            [
              -2112.006,
              -2376.568,
              2233.583
            ],
            [
              -2168.467,
              -2356.953,
              2293.354
            ],
            [
              -2218.449,
              -2337.7,
              2346.916
            ],
            [
              -2387.812,
              -2273.476,
              2528.047
            ],
            [
              -2400.864,
              -2268.936,
              2541.866
            ],
            [
              -2472.07,
              -2248.048,
              2616.073
            ],
            [
              -2473.439,
              -2303.416,
              2671.458
            ],
            [
              -2477.313,
              -2325.88,
              2694.253
            ],
            [
              -2484.017,
              -2376.97,
              2745.781
            ],
            [
              -2514.005,
              -2505.574,
              2877.835
            ],
            [
              -2552.25,
              -2627.352,
              3005.478
            ],
            [
              -2587.598,
              -2694.635,
              3081.481
            ],
            [
              -2669.545,
              -2793.221,
              3209.678
            ],
            [
              -2878.335,
              -2954.459,
              3473.479
            ],
            [
              -2942.823,
              -2993.401,
              3548.813
            ],
            [
              -2993.467,
              -3014.776,
              3603.783
            ],
            [
              -3056.314,
              -3033.711,
              3669.42
            ],
            [
              -3080.894,
              -3038.845,
              3694.531
            ],
            [
              -3066.407,
              -3094.76,
              3752.292
            ],
            [
              -3058.312,
              -3116.524,
              3775.513
            ],
            [
              -3044.503,
              -3168.617,
              3829.405
            ],
            [
              -2983.753,
              -3378.969,
              4048.353
            ],
            [
              -2973.575,
              -3406.127,
              4077.356
            ],
            [
              -2964.33,
              -3447.216,
              4119.472
            ],
            [
              -2935.834,
              -3585.756,
              4260.912
            ],
            [
              -2926.739,
              -3654.936,
              4330.688
            ],
            [
              -2914.467,
              -3799.87,
              4476.14
            ],
            [
              -2911.34,
              -3835.779,
              4512.185
            ],
            [
              -2910.491,
              -3863.444,
              4539.863
            ],
            [
              -2921.12,
              -4178.248,
              4854.847
            ],
            [
              -2920.043,
              -4206.629,
              4883.248
            ],
            [
              -2916.033,
              -4240.012,
              4916.871
            ],
            [
              -2908.744,
              -4273.666,
              4951.305
            ],
            [
              -2894.838,
              -4317.386,
              4997.183
            ],
            [
              -2876.57,
              -4356.153,
              5040.039
            ],
            [
              -2823.799,
              -4432.662,
              5132.982
            ],
            [
              -2759.103,
              -4490.576,
              5219.813
            ],
            [
              -2703.07,
              -4524.178,
              5285.149
            ],
            [
              -2600.663,
              -4562.712,
              5394.566
            ],
            [
              -2523.056,
              -4586.026,
              5475.599
            ],
            [
              -2471.67,
              -4594.727,
              5527.717
            ],
            [
              -2274.597,
              -4634.953,
              5728.853
            ],
            [
              -2190.603,
              -4657.594,
              5815.845
            ],
            [
              -2203.301,
              -4719.709,
              5879.245
            ],
            [
              -2218.687,
              -4751.72,
              5914.762
            ],
            [
              -2225.08,
              -4761.952,
              5926.826
            ],
            [
              -2297.39,
              -4830.477,
              6026.448
            ],
            [
              -2247.29,
              -4911.517,
              6121.724
            ],
            [
              -2239.148,
              -4925.337,
              6137.764
            ],
            [
              -2217.405,
              -4969.935,
              6187.38
            ],
            [
              -2110.315,
              -5178.897,
              6422.185
            ],
            [
              -2057.336,
              -5161.028,
              6478.096
            ],
            [
              -2028.76,
              -5156.969,
              6506.959
            ],
            [
              -1894.397,
              -5142.15,
              6642.137
            ],
            [
              -1856.383,
              -5135.547,
              6680.72
            ],
            [
              -1800.644,
              -5116.503,
              6739.622
            ],
            [
              -1770.723,
              -5100.339,
              6773.63
            ],
            [
              -1738.711,
              -5075.306,
              6814.268
            ],
            [
              -1710.503,
              -5046.865,
              6854.325
            ],
            [
              -1676.24,
              -5004.061,
              6909.154
            ],
            [
              -1627.812,
              -5023.801,
              6961.45
            ],
            [
              -1586.957,
              -5054.639,
              7012.637
            ],
            [
              -1465.895,
              -5129.166,
              7154.8
            ],
            [
              -1407.208,
              -5161.388,
              7221.751
            ],
            [
              -1338.038,
              -5183.78,
              7294.455
            ],
            [
              -1272.777,
              -5203.963,
              7362.766
            ],
            [
              -1246.49,
              -5215.481,
              7391.465
            ],
            [
              -1183.862,
              -5243.323,
              7460.003
            ],
            [
              -1057.683,
              -5283.443,
              7592.407
            ],
            [
              -1011.763,
              -5305.715,
              7643.443
            ],
            [
              -893.41,
              -5369.475,
              7777.878
            ],
            [
              -886.503,
              -5373.328,
              7785.787
            ],
            [
              -878.962,
              -5374.61,
              7793.436
            ],
            [
              -877.774,
              -5380.197,
              7799.148
            ],
            [
              -880.302,
              -5384.62,
              7804.242
            ],
            [
              -877.764,
              -5396.84,
              7816.723
            ],
            [
              -887.793,
              -5449.511,
              7870.34
            ],
            [
              -893.567,
              -5470.085,
              7891.709
            ],
            [
              -911.955,
              -5561.038,
              7984.503
            ],
            [
              -930.002,
              -5633.073,
              8058.764
            ],
            [
              -983.576,
              -5818.018,
              8251.312
            ],
            [
              -989.219,
              -5846.448,
              8280.296
            ],
            [
              -994.297,
              -5876.826,
              8311.096
            ],
            [
              -1014.167,
              -6014.509,
              8450.206
            ],
            [
              -1049.096,
              -6308.888,
              8746.65
            ],
            [
              -1050.642,
              -6358.956,
              8796.741
            ],
            [
              -1044.402,
              -6405.824,
              8844.023
            ],
            [
              -1041.098,
              -6426.656,
              8865.115
            ],
            [
              -1036.431,
              -6463.856,
              8902.607
            ],
            [
              -1013.612,
              -6555.552,
              8997.1
            ],
            [
              -980.393,
              -6641.87,
              9089.589
            ],
            [
              -928.004,
              -6736.327,
              9197.602
            ],
            [
              -886.521,
              -6792.738,
              9267.623
            ],
            [
              -721.383,
              -6990.538,
              9525.297
            ],
            [
              -581.501,
              -7153.472,
              9740.04
            ],
            [
              -567.625,
              -7175.894,
              9766.408
            ],
            [
              -490.912,
              -7147.103,
              9848.346
            ],
            [
              -472.731,
              -7139.026,
              9868.24
            ],
            [
              -433.975,
              -7120.429,
              9911.227
            ],
            [
              -356.786,
              -7053.923,
              10013.115
            ],
            [
              -147.918,
              -6864.018,
              10295.409
            ],
            [
              -114.729,
              -6832.74,
              10341.014
            ],
            [
              -99.394,
              -6820.307,
              10360.755
            ],
            [
              -53.78,
              -6786.694,
              10417.417
            ],
            [
              -44.707,
              -6783.519,
              10427.029
            ],
            [
              -24.066,
              -6781.669,
              10447.753
            ],
            [
              0.443,
              -6790.505,
              10473.806
            ],
            [
              9.552,
              -6811.226,
              10496.44
            ],
            [
              9.735,
              -6827.796,
              10513.012
            ],
            [
              7.024,
              -6842.352,
              10527.818
            ],
            [
              -10.864,
              -6869.857,
              10560.628
            ],
            [
              -21.671,
              -6897.49,
              10590.299
            ],
            [
              -11.966,
              -6926.765,
              10621.141
            ],
            [
              -9.853,
              -6955.595,
              10650.048
            ],
            [
              6.027,
              -7144.023,
              10839.144
            ],
            [
              11.629,
              -7176.924,
              10872.518
            ],
            [
              10.845,
              -7197.547,
              10893.157
            ],
            [
              32.291,
              -7398.322,
              11095.074
            ],
            [
              36.523,
              -7443.114,
              11140.065
            ],
            [
              37.062,
              -7489.696,
              11186.65
            ],
            [
              41.201,
              -7509.81,
              11207.186
            ],
            [
              62.699,
              -7531.354,
              11237.621
            ],
            [
              71.413,
              -7563.928,
              11271.34
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:5206",
              "position": {
                "x": -2195.778,
                "z": -3133.498
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 19.12,
              "arrivalOffsetSeconds": -600,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:6940",
              "position": {
                "x": -1551.978,
                "z": -3062.585
              },
              "distanceAlongShapeM": 699.125,
              "shapeOffsetM": 5.596,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:6933",
              "position": {
                "x": -1422.254,
                "z": -2872.318
              },
              "distanceAlongShapeM": 1100.64,
              "shapeOffsetM": 3.457,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:6937",
              "position": {
                "x": -1450.559,
                "z": -2473.275
              },
              "distanceAlongShapeM": 1558.91,
              "shapeOffsetM": 3.921,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:5074",
              "position": {
                "x": -2470.476,
                "z": -2303.737
              },
              "distanceAlongShapeM": 2671.458,
              "shapeOffsetM": 2.98,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:393",
              "position": {
                "x": -2667.366,
                "z": -2795.644
              },
              "distanceAlongShapeM": 3209.678,
              "shapeOffsetM": 3.259,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:5067",
              "position": {
                "x": -3053.229,
                "z": -3115.03
              },
              "distanceAlongShapeM": 3775.513,
              "shapeOffsetM": 5.298,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:6479",
              "position": {
                "x": -2968.741,
                "z": -3404.837
              },
              "distanceAlongShapeM": 4077.356,
              "shapeOffsetM": 5.004,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:6481",
              "position": {
                "x": -2906.719,
                "z": -3835.629
              },
              "distanceAlongShapeM": 4512.185,
              "shapeOffsetM": 4.623,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            },
            {
              "stopId": "judu:stop:6653",
              "position": {
                "x": -2914.524,
                "z": -4206.195
              },
              "distanceAlongShapeM": 4883.475,
              "shapeOffsetM": 5.531,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:8268",
              "position": {
                "x": -2701.004,
                "z": -4520.544
              },
              "distanceAlongShapeM": 5285.803,
              "shapeOffsetM": 4.129,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:8270",
              "position": {
                "x": -2222.124,
                "z": -4763.905
              },
              "distanceAlongShapeM": 5926.826,
              "shapeOffsetM": 3.543,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:6911",
              "position": {
                "x": -2236.559,
                "z": -4923.953
              },
              "distanceAlongShapeM": 6137.764,
              "shapeOffsetM": 2.936,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            },
            {
              "stopId": "judu:stop:6913",
              "position": {
                "x": -2058.363,
                "z": -5155.329
              },
              "distanceAlongShapeM": 6478.096,
              "shapeOffsetM": 5.79,
              "arrivalOffsetSeconds": 1380,
              "departureOffsetSeconds": 1380
            },
            {
              "stopId": "judu:stop:5810",
              "position": {
                "x": -1625.643,
                "z": -5020.551
              },
              "distanceAlongShapeM": 6961.45,
              "shapeOffsetM": 3.907,
              "arrivalOffsetSeconds": 1500,
              "departureOffsetSeconds": 1500
            },
            {
              "stopId": "judu:stop:5815",
              "position": {
                "x": -1271.325,
                "z": -5199.449
              },
              "distanceAlongShapeM": 7362.766,
              "shapeOffsetM": 4.742,
              "arrivalOffsetSeconds": 1560,
              "departureOffsetSeconds": 1560
            },
            {
              "stopId": "judu:stop:6773",
              "position": {
                "x": -884.191,
                "z": -5450.216
              },
              "distanceAlongShapeM": 7870.34,
              "shapeOffsetM": 3.671,
              "arrivalOffsetSeconds": 1680,
              "departureOffsetSeconds": 1680
            },
            {
              "stopId": "judu:stop:6775",
              "position": {
                "x": -986.029,
                "z": -5846.918
              },
              "distanceAlongShapeM": 8280.137,
              "shapeOffsetM": 3.221,
              "arrivalOffsetSeconds": 1740,
              "departureOffsetSeconds": 1740
            },
            {
              "stopId": "judu:stop:6777",
              "position": {
                "x": -1036.394,
                "z": -6426.006
              },
              "distanceAlongShapeM": 8865.115,
              "shapeOffsetM": 4.748,
              "arrivalOffsetSeconds": 1800,
              "departureOffsetSeconds": 1800
            },
            {
              "stopId": "judu:stop:8326",
              "position": {
                "x": -492.955,
                "z": -7141.624
              },
              "distanceAlongShapeM": 9848.703,
              "shapeOffsetM": 5.837,
              "arrivalOffsetSeconds": 1920,
              "departureOffsetSeconds": 1920
            },
            {
              "stopId": "judu:stop:8327",
              "position": {
                "x": -119.568,
                "z": -6827.798
              },
              "distanceAlongShapeM": 10340.882,
              "shapeOffsetM": 6.915,
              "arrivalOffsetSeconds": 1980,
              "departureOffsetSeconds": 1980
            },
            {
              "stopId": "judu:stop:6525",
              "position": {
                "x": -10.612,
                "z": -6926.637
              },
              "distanceAlongShapeM": 10621.141,
              "shapeOffsetM": 1.36,
              "arrivalOffsetSeconds": 2040,
              "departureOffsetSeconds": 2040
            },
            {
              "stopId": "judu:stop:6532",
              "position": {
                "x": 16.38,
                "z": -7176.496
              },
              "distanceAlongShapeM": 10872.518,
              "shapeOffsetM": 4.77,
              "arrivalOffsetSeconds": 2100,
              "departureOffsetSeconds": 2100
            },
            {
              "stopId": "judu:stop:6533",
              "position": {
                "x": 73.695,
                "z": -7563.839
              },
              "distanceAlongShapeM": 11271.34,
              "shapeOffsetM": 2.284,
              "arrivalOffsetSeconds": 2220,
              "departureOffsetSeconds": 2220
            }
          ],
          "departuresSeconds": [
            19620,
            24960,
            33240,
            38940,
            44760,
            50760,
            57840,
            64860,
            72720,
            77760,
            82620
          ]
        },
        {
          "id": "judu:pattern:vilnius_bus_48:1",
          "sourceRouteId": "vilnius_bus_48",
          "sourceShapeId": "vilnius_bus_48_b-a",
          "directionId": 1,
          "headsign": "Šeškinė",
          "directionName": "Santariškės–Pašilaičiai–Šeškinė",
          "mode": "bus",
          "routeShortName": "48",
          "routeLongName": "Šeškinė–Pašilaičiai–Santariškės",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              71.413,
              -7563.928,
              0
            ],
            [
              68.088,
              -7589.527,
              25.814
            ],
            [
              45.368,
              -7598.945,
              50.409
            ],
            [
              37.787,
              -7591.014,
              61.38
            ],
            [
              26.258,
              -7471.636,
              181.314
            ],
            [
              8.189,
              -7201.951,
              451.603
            ],
            [
              -2.477,
              -7116.037,
              538.177
            ],
            [
              -10.317,
              -7079.698,
              575.352
            ],
            [
              -10.894,
              -7047.975,
              607.08
            ],
            [
              -21.671,
              -6897.49,
              757.951
            ],
            [
              -33.557,
              -6878.349,
              780.482
            ],
            [
              -59.463,
              -6851.158,
              818.038
            ],
            [
              -78.653,
              -6844.129,
              838.475
            ],
            [
              -94.726,
              -6842.723,
              854.609
            ],
            [
              -112.168,
              -6845.745,
              872.311
            ],
            [
              -131.642,
              -6854.296,
              893.58
            ],
            [
              -159.633,
              -6886.315,
              936.109
            ],
            [
              -179.506,
              -6901.294,
              960.995
            ],
            [
              -377.89,
              -7081.371,
              1228.92
            ],
            [
              -448.339,
              -7131.301,
              1315.268
            ],
            [
              -497.724,
              -7156.009,
              1370.489
            ],
            [
              -567.625,
              -7175.894,
              1443.164
            ],
            [
              -600.3,
              -7135.061,
              1495.461
            ],
            [
              -624.57,
              -7106.612,
              1532.856
            ],
            [
              -899.778,
              -6778.026,
              1961.468
            ],
            [
              -953.071,
              -6698.025,
              2057.594
            ],
            [
              -984.944,
              -6635.356,
              2127.903
            ],
            [
              -1007.952,
              -6579.794,
              2188.04
            ],
            [
              -1020.611,
              -6541.903,
              2227.99
            ],
            [
              -1040.818,
              -6457.097,
              2315.17
            ],
            [
              -1055.577,
              -6320.967,
              2452.098
            ],
            [
              -1048.455,
              -6273.276,
              2500.318
            ],
            [
              -1013.163,
              -5994.489,
              2781.33
            ],
            [
              -983.421,
              -5799.754,
              2978.323
            ],
            [
              -976.395,
              -5776.958,
              3002.177
            ],
            [
              -917.287,
              -5570.961,
              3216.486
            ],
            [
              -886.888,
              -5421.223,
              3369.279
            ],
            [
              -884.178,
              -5399.29,
              3391.379
            ],
            [
              -887.614,
              -5390.039,
              3401.247
            ],
            [
              -926.205,
              -5371.757,
              3443.95
            ],
            [
              -1090.384,
              -5275.062,
              3634.488
            ],
            [
              -1302.999,
              -5205.56,
              3858.174
            ],
            [
              -1387.113,
              -5180.474,
              3945.949
            ],
            [
              -1666.095,
              -5013.148,
              4271.263
            ],
            [
              -1677.043,
              -5012.953,
              4282.213
            ],
            [
              -1699.03,
              -5044.347,
              4320.54
            ],
            [
              -1770.723,
              -5100.339,
              4411.507
            ],
            [
              -1793.54,
              -5115.517,
              4438.911
            ],
            [
              -1840.927,
              -5135.823,
              4490.466
            ],
            [
              -1904.939,
              -5149.154,
              4555.851
            ],
            [
              -2065.02,
              -5167.456,
              4716.975
            ],
            [
              -2110.315,
              -5178.897,
              4763.693
            ],
            [
              -2136.613,
              -5136.438,
              4813.636
            ],
            [
              -2154.069,
              -5103.533,
              4850.885
            ],
            [
              -2263.659,
              -4890.076,
              5090.83
            ],
            [
              -2297.928,
              -4830.879,
              5159.231
            ],
            [
              -2351.324,
              -4783.879,
              5230.365
            ],
            [
              -2378.887,
              -4764.376,
              5264.13
            ],
            [
              -2406.02,
              -4743.947,
              5298.094
            ],
            [
              -2443.585,
              -4718.791,
              5343.305
            ],
            [
              -2496.725,
              -4700.04,
              5399.656
            ],
            [
              -2552.315,
              -4687.753,
              5456.587
            ],
            [
              -2523.056,
              -4586.026,
              5562.439
            ],
            [
              -2609.045,
              -4566.695,
              5650.574
            ],
            [
              -2630.024,
              -4563.338,
              5671.82
            ],
            [
              -2748.743,
              -4524.155,
              5796.838
            ],
            [
              -2770.501,
              -4511.218,
              5822.152
            ],
            [
              -2804.191,
              -4483.318,
              5865.894
            ],
            [
              -2811.989,
              -4476.099,
              5876.521
            ],
            [
              -2835.666,
              -4448.038,
              5913.236
            ],
            [
              -2880.475,
              -4394.928,
              5982.724
            ],
            [
              -2902.49,
              -4364.484,
              6020.294
            ],
            [
              -2922.066,
              -4325.629,
              6063.802
            ],
            [
              -2938.397,
              -4244.738,
              6146.324
            ],
            [
              -2943.47,
              -4203.459,
              6187.914
            ],
            [
              -2943.332,
              -4158.933,
              6232.44
            ],
            [
              -2942.883,
              -4106.854,
              6284.521
            ],
            [
              -2936.886,
              -4048.837,
              6342.847
            ],
            [
              -2933.232,
              -3950.938,
              6440.814
            ],
            [
              -2935.53,
              -3825.104,
              6566.669
            ],
            [
              -2941.624,
              -3778.189,
              6613.979
            ],
            [
              -2941.11,
              -3739.288,
              6652.883
            ],
            [
              -2942.553,
              -3711.432,
              6680.776
            ],
            [
              -2947.139,
              -3679.068,
              6713.464
            ],
            [
              -2962.772,
              -3578.604,
              6815.137
            ],
            [
              -2994.393,
              -3434.443,
              6962.725
            ],
            [
              -3009.522,
              -3378.516,
              7020.662
            ],
            [
              -3022.156,
              -3343.455,
              7057.93
            ],
            [
              -3029.648,
              -3313.596,
              7088.714
            ],
            [
              -3083.217,
              -3134.541,
              7275.611
            ],
            [
              -3102.428,
              -3054.053,
              7358.36
            ],
            [
              -3114.845,
              -3027.118,
              7388.019
            ],
            [
              -3065.414,
              -3014.303,
              7439.085
            ],
            [
              -3011.076,
              -2998.586,
              7495.649
            ],
            [
              -2972.094,
              -2983.696,
              7537.379
            ],
            [
              -2923.591,
              -2962.569,
              7590.283
            ],
            [
              -2796.251,
              -2867.959,
              7748.923
            ],
            [
              -2713.249,
              -2802.628,
              7854.552
            ],
            [
              -2678.551,
              -2772.069,
              7900.788
            ],
            [
              -2644.38,
              -2734.822,
              7951.335
            ],
            [
              -2633.43,
              -2718.353,
              7971.112
            ],
            [
              -2600.033,
              -2668.811,
              8030.86
            ],
            [
              -2574.02,
              -2619.176,
              8086.898
            ],
            [
              -2520.523,
              -2473.175,
              8242.392
            ],
            [
              -2499.973,
              -2404.518,
              8314.058
            ],
            [
              -2490.126,
              -2357.937,
              8361.669
            ],
            [
              -2467.791,
              -2224.746,
              8496.719
            ],
            [
              -2432.042,
              -2227.602,
              8532.582
            ],
            [
              -2417.854,
              -2231.757,
              8547.367
            ],
            [
              -2373.845,
              -2246.595,
              8593.809
            ],
            [
              -2196.773,
              -2317.488,
              8784.545
            ],
            [
              -2137.794,
              -2339.218,
              8847.401
            ],
            [
              -2015.246,
              -2367.466,
              8973.162
            ],
            [
              -1889.653,
              -2373.04,
              9098.878
            ],
            [
              -1756.388,
              -2382.093,
              9232.45
            ],
            [
              -1647.51,
              -2385.149,
              9341.371
            ],
            [
              -1597.953,
              -2389.374,
              9391.108
            ],
            [
              -1522.821,
              -2405.189,
              9467.887
            ],
            [
              -1485.023,
              -2418.11,
              9507.832
            ],
            [
              -1375.913,
              -2480.178,
              9633.361
            ],
            [
              -1386.622,
              -2502.251,
              9657.894
            ],
            [
              -1411.106,
              -2549.069,
              9710.728
            ],
            [
              -1428.63,
              -2580.538,
              9746.747
            ],
            [
              -1442.46,
              -2628.145,
              9796.322
            ],
            [
              -1451.022,
              -2679.214,
              9848.104
            ],
            [
              -1448.996,
              -2746.044,
              9914.965
            ],
            [
              -1403.403,
              -2899.373,
              10074.929
            ],
            [
              -1388.37,
              -2943.738,
              10121.771
            ],
            [
              -1380.84,
              -2971.023,
              10150.077
            ],
            [
              -1362.723,
              -3074.878,
              10255.5
            ],
            [
              -1447.826,
              -3076.694,
              10340.622
            ],
            [
              -1522.501,
              -3072.018,
              10415.444
            ],
            [
              -1600.963,
              -3062.822,
              10494.443
            ],
            [
              -1630.583,
              -3058.786,
              10524.337
            ],
            [
              -1661.95,
              -3049.487,
              10557.053
            ],
            [
              -1775.996,
              -3011.829,
              10677.155
            ],
            [
              -1790.725,
              -3042.737,
              10711.393
            ],
            [
              -1806.584,
              -3064.719,
              10738.499
            ],
            [
              -1829.59,
              -3089.913,
              10772.617
            ],
            [
              -1853.041,
              -3103.967,
              10799.957
            ],
            [
              -1875.789,
              -3114.694,
              10825.107
            ],
            [
              -1903.67,
              -3124.217,
              10854.569
            ],
            [
              -1932.077,
              -3127.051,
              10883.117
            ],
            [
              -2119.439,
              -3117.041,
              11070.747
            ],
            [
              -2118.224,
              -3120.903,
              11074.796
            ],
            [
              -2103.133,
              -3152.23,
              11109.568
            ],
            [
              -2106.715,
              -3163.118,
              11121.03
            ],
            [
              -2108.873,
              -3170.545,
              11128.764
            ],
            [
              -2161.481,
              -3161.937,
              11182.071
            ],
            [
              -2189.769,
              -3158.095,
              11210.619
            ],
            [
              -2192.892,
              -3152.474,
              11217.049
            ],
            [
              -2194.158,
              -3114.447,
              11255.097
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:7831",
              "position": {
                "x": 25.801,
                "z": -7471.678
              },
              "distanceAlongShapeM": 181.314,
              "shapeOffsetM": 0.459,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:6526",
              "position": {
                "x": -15.345,
                "z": -7080.178
              },
              "distanceAlongShapeM": 575.352,
              "shapeOffsetM": 5.051,
              "arrivalOffsetSeconds": 60,
              "departureOffsetSeconds": 60
            },
            {
              "stopId": "judu:stop:6783",
              "position": {
                "x": -156.753,
                "z": -6889.462
              },
              "distanceAlongShapeM": 936.109,
              "shapeOffsetM": 4.266,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:6778",
              "position": {
                "x": -604.294,
                "z": -7138.492
              },
              "distanceAlongShapeM": 1495.277,
              "shapeOffsetM": 5.262,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:6776",
              "position": {
                "x": -1058.33,
                "z": -6320.967
              },
              "distanceAlongShapeM": 2452.098,
              "shapeOffsetM": 2.753,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:6774",
              "position": {
                "x": -985.81,
                "z": -5799.053
              },
              "distanceAlongShapeM": 2978.323,
              "shapeOffsetM": 2.489,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:5822",
              "position": {
                "x": -927.257,
                "z": -5373.739
              },
              "distanceAlongShapeM": 3443.95,
              "shapeOffsetM": 2.244,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:5814",
              "position": {
                "x": -1387.604,
                "z": -5181.778
              },
              "distanceAlongShapeM": 3945.949,
              "shapeOffsetM": 1.394,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:5811",
              "position": {
                "x": -1696.959,
                "z": -5045.994
              },
              "distanceAlongShapeM": 4320.54,
              "shapeOffsetM": 2.646,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:6914",
              "position": {
                "x": -2139.87,
                "z": -5138.296
              },
              "distanceAlongShapeM": 4813.636,
              "shapeOffsetM": 3.749,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:6763",
              "position": {
                "x": -2381.317,
                "z": -4767.762
              },
              "distanceAlongShapeM": 5264.13,
              "shapeOffsetM": 4.167,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:6766",
              "position": {
                "x": -2809.985,
                "z": -4489.679
              },
              "distanceAlongShapeM": 5865.894,
              "shapeOffsetM": 8.604,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:6484",
              "position": {
                "x": -2923.723,
                "z": -4326.261
              },
              "distanceAlongShapeM": 6063.802,
              "shapeOffsetM": 1.774,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:6523",
              "position": {
                "x": -2947.565,
                "z": -4106.537
              },
              "distanceAlongShapeM": 6284.521,
              "shapeOffsetM": 4.693,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:6482",
              "position": {
                "x": -2942.439,
                "z": -3778.227
              },
              "distanceAlongShapeM": 6613.979,
              "shapeOffsetM": 0.816,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:6478",
              "position": {
                "x": -3026.974,
                "z": -3344.813
              },
              "distanceAlongShapeM": 7057.93,
              "shapeOffsetM": 5.006,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:855",
              "position": {
                "x": -3013.674,
                "z": -2991.043
              },
              "distanceAlongShapeM": 7495.25,
              "shapeOffsetM": 7.967,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            },
            {
              "stopId": "judu:stop:394",
              "position": {
                "x": -2636.314,
                "z": -2716.04
              },
              "distanceAlongShapeM": 7971.418,
              "shapeOffsetM": 3.684,
              "arrivalOffsetSeconds": 1500,
              "departureOffsetSeconds": 1500
            },
            {
              "stopId": "judu:stop:1069",
              "position": {
                "x": -2415.576,
                "z": -2224.555
              },
              "distanceAlongShapeM": 8547.367,
              "shapeOffsetM": 7.553,
              "arrivalOffsetSeconds": 1620,
              "departureOffsetSeconds": 1620
            },
            {
              "stopId": "judu:stop:3512",
              "position": {
                "x": -1401.734,
                "z": -2554.302
              },
              "distanceAlongShapeM": 9710.74,
              "shapeOffsetM": 10.734,
              "arrivalOffsetSeconds": 1920,
              "departureOffsetSeconds": 1920
            },
            {
              "stopId": "judu:stop:6934",
              "position": {
                "x": -1382.255,
                "z": -2942.054
              },
              "distanceAlongShapeM": 10121.775,
              "shapeOffsetM": 6.342,
              "arrivalOffsetSeconds": 1980,
              "departureOffsetSeconds": 1980
            },
            {
              "stopId": "judu:stop:6941",
              "position": {
                "x": -1631.244,
                "z": -3062.281
              },
              "distanceAlongShapeM": 10524.337,
              "shapeOffsetM": 3.557,
              "arrivalOffsetSeconds": 2100,
              "departureOffsetSeconds": 2100
            },
            {
              "stopId": "judu:stop:5206",
              "position": {
                "x": -2195.778,
                "z": -3133.498
              },
              "distanceAlongShapeM": 11236.11,
              "shapeOffsetM": 2.253,
              "arrivalOffsetSeconds": 2220,
              "departureOffsetSeconds": 2220
            }
          ],
          "departuresSeconds": [
            22260,
            28320,
            36060,
            41880,
            47760,
            54360,
            60780,
            67740,
            75300,
            80280,
            85200
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_bus_49",
      "sourceRouteId": "vilnius_bus_49",
      "mode": "bus",
      "shortName": "49",
      "longName": "Bajorai–Ateities g.–Didlaukio g.–Žalgirio g.–Lazdynai–Bukčiai",
      "color": "0073AC",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_bus_49:0",
          "sourceRouteId": "vilnius_bus_49",
          "sourceShapeId": "vilnius_bus_49_a-b",
          "directionId": 0,
          "headsign": "Bukčiai",
          "directionName": "Bajorai–Ateities g.–Didlaukio g.–Žalgirio g.–Lazdynai–Bukčiai",
          "mode": "bus",
          "routeShortName": "49",
          "routeLongName": "Bajorai–Ateities g.–Didlaukio g.–Žalgirio g.–Lazdynai–Bukčiai",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              -1511.847,
              -7679.922,
              0
            ],
            [
              -1492.181,
              -7674.661,
              20.358
            ],
            [
              -1434.4,
              -7647.866,
              84.05
            ],
            [
              -1412.802,
              -7628.215,
              113.249
            ],
            [
              -1311.163,
              -7519.736,
              261.904
            ],
            [
              -1244.231,
              -7455.351,
              354.777
            ],
            [
              -1087.774,
              -7312.331,
              566.752
            ],
            [
              -1078.522,
              -7299.139,
              582.865
            ],
            [
              -1074.419,
              -7273.142,
              609.184
            ],
            [
              -1063.137,
              -7267.132,
              621.967
            ],
            [
              -1045.667,
              -7269.285,
              639.569
            ],
            [
              -1002.208,
              -7280.476,
              684.446
            ],
            [
              -979.66,
              -7279.769,
              707.005
            ],
            [
              -935.71,
              -7270.543,
              751.913
            ],
            [
              -707.406,
              -7214.553,
              986.982
            ],
            [
              -684.153,
              -7210.52,
              1010.583
            ],
            [
              -567.625,
              -7175.894,
              1132.146
            ],
            [
              -490.912,
              -7147.103,
              1214.084
            ],
            [
              -472.731,
              -7139.026,
              1233.979
            ],
            [
              -433.975,
              -7120.429,
              1276.965
            ],
            [
              -356.786,
              -7053.923,
              1378.854
            ],
            [
              -147.918,
              -6864.018,
              1661.147
            ],
            [
              -114.729,
              -6832.74,
              1706.752
            ],
            [
              -100.778,
              -6821.461,
              1724.692
            ],
            [
              -58.991,
              -6789.938,
              1777.036
            ],
            [
              -47.746,
              -6774.569,
              1796.08
            ],
            [
              -39.488,
              -6758.546,
              1814.106
            ],
            [
              -44.133,
              -6716.735,
              1856.174
            ],
            [
              -50.641,
              -6695.446,
              1878.435
            ],
            [
              -48.526,
              -6639.841,
              1934.081
            ],
            [
              -52.099,
              -6588.567,
              1985.479
            ],
            [
              -70.555,
              -6505.85,
              2070.23
            ],
            [
              -125.166,
              -6286.66,
              2296.121
            ],
            [
              -158.525,
              -6137.991,
              2448.486
            ],
            [
              -180.294,
              -6069.166,
              2520.672
            ],
            [
              -186.217,
              -6031.729,
              2558.575
            ],
            [
              -210.448,
              -5912.171,
              2680.563
            ],
            [
              -214.688,
              -5861.998,
              2730.915
            ],
            [
              -215.425,
              -5796.303,
              2796.614
            ],
            [
              -210.007,
              -5746.306,
              2846.904
            ],
            [
              -195.772,
              -5671.978,
              2922.583
            ],
            [
              -200.158,
              -5665.219,
              2930.64
            ],
            [
              -245.834,
              -5662.161,
              2976.418
            ],
            [
              -275.267,
              -5661.057,
              3005.872
            ],
            [
              -299.862,
              -5657.84,
              3030.677
            ],
            [
              -394.957,
              -5644.98,
              3126.637
            ],
            [
              -428.258,
              -5634.356,
              3161.592
            ],
            [
              -633.019,
              -5523.775,
              3394.305
            ],
            [
              -662.96,
              -5509.616,
              3427.425
            ],
            [
              -740.412,
              -5464.845,
              3516.886
            ],
            [
              -765.768,
              -5455.693,
              3543.843
            ],
            [
              -877.432,
              -5396.902,
              3670.038
            ],
            [
              -884.394,
              -5390.097,
              3679.773
            ],
            [
              -886.769,
              -5378.922,
              3691.198
            ],
            [
              -880.613,
              -5358.995,
              3712.054
            ],
            [
              -871.302,
              -5283.486,
              3788.135
            ],
            [
              -867.295,
              -5263.497,
              3808.522
            ],
            [
              -873.84,
              -5126.451,
              3945.724
            ],
            [
              -873.198,
              -5090.839,
              3981.342
            ],
            [
              -867.363,
              -5053.094,
              4019.535
            ],
            [
              -847.141,
              -4967.74,
              4107.252
            ],
            [
              -716.635,
              -4519.236,
              4574.357
            ],
            [
              -646.885,
              -4514.933,
              4644.24
            ],
            [
              -568.48,
              -4520.803,
              4722.865
            ],
            [
              -439.606,
              -4519.799,
              4851.742
            ],
            [
              -373.187,
              -4516.551,
              4918.241
            ],
            [
              -303.365,
              -4503.347,
              4989.3
            ],
            [
              -273.394,
              -4484.966,
              5024.459
            ],
            [
              -264.248,
              -4475.971,
              5037.287
            ],
            [
              -247.988,
              -4462.621,
              5058.325
            ],
            [
              -206.653,
              -4415.152,
              5121.269
            ],
            [
              -184.743,
              -4390.249,
              5154.438
            ],
            [
              -166.1,
              -4374.591,
              5178.784
            ],
            [
              -152.82,
              -4365.759,
              5194.733
            ],
            [
              -100.827,
              -4348.95,
              5249.376
            ],
            [
              -72.436,
              -4347.387,
              5277.81
            ],
            [
              -23.573,
              -4348.894,
              5326.696
            ],
            [
              35.061,
              -4351.207,
              5385.375
            ],
            [
              46.147,
              -4344.95,
              5398.105
            ],
            [
              48.454,
              -4310.97,
              5432.163
            ],
            [
              52.989,
              -4285.429,
              5458.104
            ],
            [
              60.111,
              -4250.579,
              5493.674
            ],
            [
              104.143,
              -4062.131,
              5687.198
            ],
            [
              127.703,
              -3998.463,
              5755.086
            ],
            [
              151.352,
              -3953.466,
              5805.918
            ],
            [
              179.07,
              -3910.986,
              5856.642
            ],
            [
              264.038,
              -3810.121,
              5988.525
            ],
            [
              345.157,
              -3743.697,
              6093.37
            ],
            [
              387.493,
              -3689.441,
              6162.189
            ],
            [
              434.283,
              -3627.326,
              6239.955
            ],
            [
              450.253,
              -3599.787,
              6271.79
            ],
            [
              463.769,
              -3565.524,
              6308.622
            ],
            [
              474.065,
              -3531.203,
              6344.455
            ],
            [
              484.063,
              -3477.95,
              6398.638
            ],
            [
              490.334,
              -3345.62,
              6531.116
            ],
            [
              488.575,
              -3319.869,
              6556.927
            ],
            [
              479.687,
              -3259.675,
              6617.774
            ],
            [
              477.905,
              -3216.226,
              6661.26
            ],
            [
              481.339,
              -3169.533,
              6708.079
            ],
            [
              500.602,
              -3103.091,
              6777.257
            ],
            [
              504.082,
              -3078.362,
              6802.23
            ],
            [
              504.445,
              -3034.141,
              6846.452
            ],
            [
              503.491,
              -2980.688,
              6899.913
            ],
            [
              505.751,
              -2962.917,
              6917.828
            ],
            [
              504.844,
              -2912.819,
              6967.934
            ],
            [
              509.397,
              -2869.472,
              7011.519
            ],
            [
              513.301,
              -2797.183,
              7083.914
            ],
            [
              494.515,
              -2626.513,
              7255.614
            ],
            [
              487.991,
              -2601.316,
              7281.642
            ],
            [
              485.911,
              -2568.466,
              7314.558
            ],
            [
              462.343,
              -2342.047,
              7542.2
            ],
            [
              451.425,
              -2269.486,
              7615.578
            ],
            [
              407.333,
              -2116.119,
              7775.157
            ],
            [
              406.254,
              -2096.107,
              7795.199
            ],
            [
              361.405,
              -1904.922,
              7991.574
            ],
            [
              342.249,
              -1718.661,
              8178.817
            ],
            [
              290.154,
              -1723.98,
              8231.183
            ],
            [
              249.082,
              -1725.746,
              8272.293
            ],
            [
              91.167,
              -1735.227,
              8430.492
            ],
            [
              -460.696,
              -1807.576,
              8987.077
            ],
            [
              -504.679,
              -1815.686,
              9031.802
            ],
            [
              -529.853,
              -1817.457,
              9057.038
            ],
            [
              -565.742,
              -1833.742,
              9096.449
            ],
            [
              -590.636,
              -1808.652,
              9131.793
            ],
            [
              -678.167,
              -1790.676,
              9221.151
            ],
            [
              -772.672,
              -1769.652,
              9317.966
            ],
            [
              -795.027,
              -1758.117,
              9343.122
            ],
            [
              -810.858,
              -1742.246,
              9365.539
            ],
            [
              -857.103,
              -1661.259,
              9458.799
            ],
            [
              -917.833,
              -1561.088,
              9575.942
            ],
            [
              -1006.944,
              -1461.52,
              9709.563
            ],
            [
              -1011.739,
              -1441.395,
              9730.251
            ],
            [
              -987.78,
              -1363.9,
              9811.365
            ],
            [
              -988.723,
              -1201.352,
              9973.916
            ],
            [
              -990.397,
              -1186.85,
              9988.514
            ],
            [
              -1006.474,
              -1148.711,
              10029.903
            ],
            [
              -1019.105,
              -1134.012,
              10049.284
            ],
            [
              -1029.882,
              -1123.799,
              10064.131
            ],
            [
              -1062.634,
              -1116.531,
              10097.68
            ],
            [
              -1097.251,
              -1122.142,
              10132.749
            ],
            [
              -1143.947,
              -1120.636,
              10179.469
            ],
            [
              -1339.338,
              -1158.32,
              10378.461
            ],
            [
              -1374.945,
              -1168.896,
              10415.605
            ],
            [
              -1791.301,
              -1230.398,
              10836.479
            ],
            [
              -1855.793,
              -1231.475,
              10900.98
            ],
            [
              -1940.187,
              -1227.747,
              10985.456
            ],
            [
              -2027.705,
              -1218.399,
              11073.472
            ],
            [
              -2166.609,
              -1198.122,
              11213.848
            ],
            [
              -2255.397,
              -1187.643,
              11303.253
            ],
            [
              -2266.36,
              -1186.843,
              11314.245
            ],
            [
              -2295.924,
              -1182.472,
              11344.13
            ],
            [
              -2392.506,
              -1175.197,
              11440.986
            ],
            [
              -2431.277,
              -1180.078,
              11480.063
            ],
            [
              -2478.584,
              -1193.714,
              11529.296
            ],
            [
              -2533.196,
              -1219.467,
              11589.675
            ],
            [
              -2617.204,
              -1266.966,
              11686.182
            ],
            [
              -2663.944,
              -1285.067,
              11736.304
            ],
            [
              -2710.565,
              -1296.491,
              11784.305
            ],
            [
              -2762.381,
              -1304.469,
              11836.732
            ],
            [
              -2808.767,
              -1305.331,
              11883.125
            ],
            [
              -2858.119,
              -1300.984,
              11932.669
            ],
            [
              -3071.028,
              -1263.439,
              12148.862
            ],
            [
              -3139.719,
              -1251.188,
              12218.637
            ],
            [
              -3159.719,
              -1247.413,
              12238.99
            ],
            [
              -3359.526,
              -1207.182,
              12442.807
            ],
            [
              -3495.953,
              -1192.555,
              12580.016
            ],
            [
              -3569.469,
              -1193.5,
              12653.538
            ],
            [
              -3626.266,
              -1196.964,
              12710.441
            ],
            [
              -3657.704,
              -1114.039,
              12799.125
            ],
            [
              -3677.364,
              -1066.903,
              12850.197
            ],
            [
              -3685.368,
              -1042.059,
              12876.299
            ],
            [
              -3720.918,
              -930.373,
              12993.506
            ],
            [
              -3751.424,
              -837.404,
              13091.352
            ],
            [
              -3758.325,
              -817.25,
              13112.655
            ],
            [
              -3766.218,
              -791.548,
              13139.541
            ],
            [
              -3793.988,
              -719.82,
              13216.457
            ],
            [
              -3843.779,
              -616.54,
              13331.113
            ],
            [
              -3881.258,
              -546.871,
              13410.223
            ],
            [
              -3968.352,
              -399.129,
              13581.726
            ],
            [
              -3983.006,
              -376.666,
              13608.545
            ],
            [
              -3999.719,
              -350.005,
              13640.012
            ],
            [
              -4048.201,
              -282.373,
              13723.226
            ],
            [
              -4133.499,
              -180.709,
              13855.934
            ],
            [
              -4196.231,
              -117.271,
              13945.15
            ],
            [
              -4217.103,
              -95.271,
              13975.476
            ],
            [
              -4243.751,
              -67.483,
              14013.977
            ],
            [
              -4402.336,
              85.535,
              14234.349
            ],
            [
              -4449.086,
              142,
              14307.655
            ],
            [
              -4479.797,
              193.736,
              14367.82
            ],
            [
              -4502.905,
              237.549,
              14417.353
            ],
            [
              -4519.036,
              274.562,
              14457.729
            ],
            [
              -4536.228,
              324.952,
              14510.971
            ],
            [
              -4547.048,
              370.78,
              14558.059
            ],
            [
              -4566.578,
              510.266,
              14698.905
            ],
            [
              -4570.606,
              537.669,
              14726.603
            ],
            [
              -4575.517,
              590.57,
              14779.731
            ],
            [
              -4579.623,
              651.866,
              14841.165
            ],
            [
              -4586.366,
              709.869,
              14899.558
            ],
            [
              -4584.541,
              741.007,
              14930.75
            ],
            [
              -4573.306,
              794.248,
              14985.163
            ],
            [
              -4555.909,
              830.684,
              15025.54
            ],
            [
              -4554.237,
              852.919,
              15047.837
            ],
            [
              -4568.699,
              912.168,
              15108.826
            ],
            [
              -4567.748,
              929.963,
              15126.646
            ],
            [
              -4555.854,
              946.456,
              15146.981
            ],
            [
              -4510.16,
              977.953,
              15202.478
            ],
            [
              -4440.575,
              860.983,
              15338.581
            ],
            [
              -4425.036,
              789.47,
              15411.763
            ],
            [
              -4406.248,
              756.864,
              15449.395
            ],
            [
              -4380.992,
              725.259,
              15489.851
            ],
            [
              -4355.565,
              703.67,
              15523.207
            ],
            [
              -4324.219,
              688.657,
              15557.963
            ],
            [
              -4302.372,
              683.828,
              15580.337
            ],
            [
              -4269.507,
              682.148,
              15613.245
            ],
            [
              -4233.908,
              689.326,
              15649.561
            ],
            [
              -4200.071,
              706.552,
              15687.53
            ],
            [
              -4154.906,
              744.734,
              15746.672
            ],
            [
              -4131.603,
              764.725,
              15777.375
            ],
            [
              -4089.107,
              782.559,
              15823.461
            ],
            [
              -4026.001,
              813.75,
              15893.855
            ],
            [
              -3968.169,
              838.352,
              15956.702
            ],
            [
              -3939.526,
              853.44,
              15989.076
            ],
            [
              -3921.201,
              868.708,
              16012.928
            ],
            [
              -3904.031,
              891.787,
              16041.694
            ],
            [
              -3887.976,
              924.905,
              16078.498
            ],
            [
              -3883.393,
              966.014,
              16119.862
            ],
            [
              -3887.876,
              1005.054,
              16159.158
            ],
            [
              -3903.754,
              1056.537,
              16213.034
            ],
            [
              -3912.994,
              1078.798,
              16237.136
            ],
            [
              -3919.363,
              1123.6,
              16282.389
            ],
            [
              -3949.447,
              1248.8,
              16411.153
            ],
            [
              -3955.799,
              1254.476,
              16419.671
            ],
            [
              -3966.06,
              1257.993,
              16430.518
            ],
            [
              -4052.898,
              1235.006,
              16520.347
            ],
            [
              -4088.424,
              1232.281,
              16555.977
            ],
            [
              -4119.34,
              1235.042,
              16587.017
            ],
            [
              -4212.237,
              1261.595,
              16683.634
            ],
            [
              -4241.916,
              1271.669,
              16714.976
            ],
            [
              -4268.203,
              1281.028,
              16742.879
            ],
            [
              -4527.979,
              1404.616,
              17030.556
            ],
            [
              -4557.013,
              1417.363,
              17062.264
            ],
            [
              -4581.673,
              1433.369,
              17091.664
            ],
            [
              -4718.251,
              1519.203,
              17252.974
            ],
            [
              -4836.63,
              1608.523,
              17401.269
            ],
            [
              -4855.022,
              1631.754,
              17430.9
            ],
            [
              -4943.107,
              1724.544,
              17558.841
            ],
            [
              -4961.39,
              1738.988,
              17582.141
            ],
            [
              -5069.077,
              1865.846,
              17748.543
            ],
            [
              -5076.134,
              1868.193,
              17755.98
            ],
            [
              -5119.953,
              1909.016,
              17815.868
            ],
            [
              -5214.195,
              1981.867,
              17934.985
            ],
            [
              -5228.689,
              2002.152,
              17959.916
            ],
            [
              -5236.77,
              2020.101,
              17979.6
            ],
            [
              -5240.925,
              2041.322,
              18001.224
            ],
            [
              -5239.294,
              2061.332,
              18021.3
            ],
            [
              -5227.836,
              2090.08,
              18052.248
            ],
            [
              -5213.304,
              2109.87,
              18076.8
            ],
            [
              -5193.689,
              2125.12,
              18101.646
            ],
            [
              -5147.095,
              2133.196,
              18148.935
            ],
            [
              -5075.343,
              2126.977,
              18220.955
            ],
            [
              -4973.287,
              2110.226,
              18324.377
            ],
            [
              -4894.768,
              2098.864,
              18403.714
            ],
            [
              -4850.889,
              2099.226,
              18447.594
            ],
            [
              -4603.07,
              2140.618,
              18698.846
            ],
            [
              -4527.565,
              2141.547,
              18774.357
            ],
            [
              -4479.873,
              2138.5,
              18822.146
            ],
            [
              -4449.411,
              2138.771,
              18852.61
            ],
            [
              -4390.804,
              2140.306,
              18911.237
            ],
            [
              -4376.576,
              2142.288,
              18925.602
            ],
            [
              -4195.427,
              2208.182,
              19118.364
            ],
            [
              -4108.264,
              2248.978,
              19214.601
            ],
            [
              -4011,
              2314.088,
              19331.647
            ],
            [
              -3941.175,
              2365.804,
              19418.538
            ],
            [
              -3943.03,
              2364.119,
              19421.044
            ],
            [
              -3945.224,
              2386.421,
              19443.453
            ],
            [
              -3957.678,
              2411.388,
              19471.354
            ],
            [
              -3991.012,
              2499.647,
              19565.698
            ],
            [
              -4043.609,
              2629.688,
              19705.973
            ],
            [
              -4055.333,
              2651.102,
              19730.387
            ],
            [
              -4116.103,
              2803.488,
              19894.443
            ],
            [
              -4124.654,
              2831.465,
              19923.697
            ],
            [
              -4144.707,
              2922.194,
              20016.616
            ],
            [
              -4153.919,
              2967.781,
              20063.125
            ],
            [
              -4167.578,
              3027.061,
              20123.958
            ],
            [
              -4202.041,
              3133.366,
              20235.71
            ],
            [
              -4257.982,
              3220.047,
              20338.874
            ],
            [
              -4348.426,
              3289.511,
              20452.916
            ],
            [
              -4400.505,
              3313.702,
              20510.338
            ],
            [
              -4445.196,
              3329.026,
              20557.584
            ],
            [
              -4463.829,
              3333.799,
              20576.819
            ],
            [
              -4473.683,
              3334.443,
              20586.694
            ],
            [
              -4488.71,
              3337.606,
              20602.05
            ],
            [
              -4576.755,
              3354.181,
              20691.641
            ],
            [
              -4674.562,
              3384.704,
              20794.101
            ],
            [
              -4808.507,
              3453.632,
              20944.74
            ],
            [
              -4863.17,
              3531.43,
              21039.822
            ],
            [
              -4903.609,
              3584.751,
              21106.743
            ],
            [
              -5020.374,
              3699.106,
              21270.179
            ],
            [
              -5108.961,
              3781.645,
              21391.258
            ],
            [
              -5130.818,
              3798.505,
              21418.862
            ],
            [
              -5148.233,
              3807.494,
              21438.461
            ],
            [
              -5163.573,
              3811.448,
              21454.302
            ],
            [
              -5212.289,
              3810.049,
              21503.038
            ],
            [
              -5282.075,
              3800.218,
              21573.513
            ],
            [
              -5290.054,
              3798.842,
              21581.61
            ],
            [
              -5292.881,
              3798.029,
              21584.551
            ],
            [
              -5292.823,
              3798.044,
              21584.61
            ],
            [
              -5281.536,
              3801.212,
              21596.334
            ],
            [
              -5272.274,
              3803.317,
              21605.832
            ],
            [
              -5263.647,
              3804.7,
              21614.569
            ],
            [
              -5248.566,
              3806.522,
              21629.759
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:370",
              "position": {
                "x": -1512.213,
                "z": -7678.755
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 1.223,
              "arrivalOffsetSeconds": -720,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:7052",
              "position": {
                "x": -1045.114,
                "z": -7267.457
              },
              "distanceAlongShapeM": 639.649,
              "shapeOffsetM": 1.908,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:8326",
              "position": {
                "x": -492.955,
                "z": -7141.624
              },
              "distanceAlongShapeM": 1214.442,
              "shapeOffsetM": 5.837,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:8327",
              "position": {
                "x": -119.568,
                "z": -6827.798
              },
              "distanceAlongShapeM": 1706.62,
              "shapeOffsetM": 6.915,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:6503",
              "position": {
                "x": -50.829,
                "z": -6695.462
              },
              "distanceAlongShapeM": 1878.435,
              "shapeOffsetM": 0.189,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:6501",
              "position": {
                "x": -182.398,
                "z": -6069.649
              },
              "distanceAlongShapeM": 2520.672,
              "shapeOffsetM": 2.159,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:6640",
              "position": {
                "x": -275.515,
                "z": -5664.961
              },
              "distanceAlongShapeM": 3005.872,
              "shapeOffsetM": 3.912,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:6634",
              "position": {
                "x": -663.705,
                "z": -5510.974
              },
              "distanceAlongShapeM": 3427.425,
              "shapeOffsetM": 1.549,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:348",
              "position": {
                "x": -871.52,
                "z": -5283.459
              },
              "distanceAlongShapeM": 3788.135,
              "shapeOffsetM": 0.219,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:5833",
              "position": {
                "x": -646.915,
                "z": -4511.591
              },
              "distanceAlongShapeM": 4644.24,
              "shapeOffsetM": 3.342,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:5836",
              "position": {
                "x": 49.82,
                "z": -4284.902
              },
              "distanceAlongShapeM": 5458.069,
              "shapeOffsetM": 3.212,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:5839",
              "position": {
                "x": 148.043,
                "z": -3951.609
              },
              "distanceAlongShapeM": 5805.918,
              "shapeOffsetM": 3.794,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:5846",
              "position": {
                "x": 383.579,
                "z": -3686.512
              },
              "distanceAlongShapeM": 6162.091,
              "shapeOffsetM": 4.888,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:5481",
              "position": {
                "x": 502.159,
                "z": -2912.756
              },
              "distanceAlongShapeM": 6967.934,
              "shapeOffsetM": 2.686,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            },
            {
              "stopId": "judu:stop:5347",
              "position": {
                "x": 482.722,
                "z": -2601.805
              },
              "distanceAlongShapeM": 7281.642,
              "shapeOffsetM": 5.291,
              "arrivalOffsetSeconds": 1500,
              "departureOffsetSeconds": 1500
            },
            {
              "stopId": "judu:stop:5351",
              "position": {
                "x": 407.176,
                "z": -2116.162
              },
              "distanceAlongShapeM": 7775.157,
              "shapeOffsetM": 0.163,
              "arrivalOffsetSeconds": 1620,
              "departureOffsetSeconds": 1620
            },
            {
              "stopId": "judu:stop:5498",
              "position": {
                "x": 290.448,
                "z": -1731.073
              },
              "distanceAlongShapeM": 8231.194,
              "shapeOffsetM": 7.099,
              "arrivalOffsetSeconds": 1740,
              "departureOffsetSeconds": 1740
            },
            {
              "stopId": "judu:stop:5499",
              "position": {
                "x": -564.13,
                "z": -1823.516
              },
              "distanceAlongShapeM": 9102.573,
              "shapeOffsetM": 8.347,
              "arrivalOffsetSeconds": 1980,
              "departureOffsetSeconds": 1980
            },
            {
              "stopId": "judu:stop:5220",
              "position": {
                "x": -1001.511,
                "z": -1410.409
              },
              "distanceAlongShapeM": 9762.875,
              "shapeOffsetM": 0.619,
              "arrivalOffsetSeconds": 2160,
              "departureOffsetSeconds": 2160
            },
            {
              "stopId": "judu:stop:6404",
              "position": {
                "x": -1096.995,
                "z": -1127.045
              },
              "distanceAlongShapeM": 10132.749,
              "shapeOffsetM": 4.91,
              "arrivalOffsetSeconds": 2280,
              "departureOffsetSeconds": 2280
            },
            {
              "stopId": "judu:stop:814",
              "position": {
                "x": -1374.402,
                "z": -1172.164
              },
              "distanceAlongShapeM": 10415.605,
              "shapeOffsetM": 3.313,
              "arrivalOffsetSeconds": 2340,
              "departureOffsetSeconds": 2340
            },
            {
              "stopId": "judu:stop:5906",
              "position": {
                "x": -2267.097,
                "z": -1193.002
              },
              "distanceAlongShapeM": 11314.245,
              "shapeOffsetM": 6.203,
              "arrivalOffsetSeconds": 2460,
              "departureOffsetSeconds": 2460
            },
            {
              "stopId": "judu:stop:7415",
              "position": {
                "x": -3140.52,
                "z": -1255.542
              },
              "distanceAlongShapeM": 12218.637,
              "shapeOffsetM": 4.427,
              "arrivalOffsetSeconds": 2580,
              "departureOffsetSeconds": 2580
            },
            {
              "stopId": "judu:stop:5643",
              "position": {
                "x": -3680.758,
                "z": -1067.996
              },
              "distanceAlongShapeM": 12850.197,
              "shapeOffsetM": 3.566,
              "arrivalOffsetSeconds": 2760,
              "departureOffsetSeconds": 2760
            },
            {
              "stopId": "judu:stop:5646",
              "position": {
                "x": -3761.526,
                "z": -818.346
              },
              "distanceAlongShapeM": 13112.655,
              "shapeOffsetM": 3.383,
              "arrivalOffsetSeconds": 2820,
              "departureOffsetSeconds": 2820
            },
            {
              "stopId": "judu:stop:5651",
              "position": {
                "x": -3986.683,
                "z": -379.175
              },
              "distanceAlongShapeM": 13608.453,
              "shapeOffsetM": 4.451,
              "arrivalOffsetSeconds": 2880,
              "departureOffsetSeconds": 2880
            },
            {
              "stopId": "judu:stop:5656",
              "position": {
                "x": -4221.08,
                "z": -99.045
              },
              "distanceAlongShapeM": 13975.505,
              "shapeOffsetM": 5.483,
              "arrivalOffsetSeconds": 2940,
              "departureOffsetSeconds": 2940
            },
            {
              "stopId": "judu:stop:5668",
              "position": {
                "x": -4574.501,
                "z": 537.119
              },
              "distanceAlongShapeM": 14726.603,
              "shapeOffsetM": 3.934,
              "arrivalOffsetSeconds": 3000,
              "departureOffsetSeconds": 3000
            },
            {
              "stopId": "judu:stop:5703",
              "position": {
                "x": -4134.494,
                "z": 768.872
              },
              "distanceAlongShapeM": 15777.375,
              "shapeOffsetM": 5.055,
              "arrivalOffsetSeconds": 3180,
              "departureOffsetSeconds": 3180
            },
            {
              "stopId": "judu:stop:5702",
              "position": {
                "x": -3916.285,
                "z": 1077.905
              },
              "distanceAlongShapeM": 16237.136,
              "shapeOffsetM": 3.41,
              "arrivalOffsetSeconds": 3240,
              "departureOffsetSeconds": 3240
            },
            {
              "stopId": "judu:stop:6318",
              "position": {
                "x": -4215.081,
                "z": 1256.734
              },
              "distanceAlongShapeM": 16684.765,
              "shapeOffsetM": 5.517,
              "arrivalOffsetSeconds": 3300,
              "departureOffsetSeconds": 3300
            },
            {
              "stopId": "judu:stop:6319",
              "position": {
                "x": -4558.781,
                "z": 1414.051
              },
              "distanceAlongShapeM": 17062.264,
              "shapeOffsetM": 3.754,
              "arrivalOffsetSeconds": 3360,
              "departureOffsetSeconds": 3360
            },
            {
              "stopId": "judu:stop:6320",
              "position": {
                "x": -4838.028,
                "z": 1606.973
              },
              "distanceAlongShapeM": 17401.269,
              "shapeOffsetM": 2.088,
              "arrivalOffsetSeconds": 3420,
              "departureOffsetSeconds": 3420
            },
            {
              "stopId": "judu:stop:6401",
              "position": {
                "x": -5074.894,
                "z": 2129.773
              },
              "distanceAlongShapeM": 18220.955,
              "shapeOffsetM": 2.831,
              "arrivalOffsetSeconds": 3600,
              "departureOffsetSeconds": 3600
            },
            {
              "stopId": "judu:stop:6379",
              "position": {
                "x": -4449.462,
                "z": 2143.543
              },
              "distanceAlongShapeM": 18852.684,
              "shapeOffsetM": 4.772,
              "arrivalOffsetSeconds": 3720,
              "departureOffsetSeconds": 3720
            },
            {
              "stopId": "judu:stop:9102",
              "position": {
                "x": -3966.145,
                "z": 2407.934
              },
              "distanceAlongShapeM": 19471.354,
              "shapeOffsetM": 9.144,
              "arrivalOffsetSeconds": 3780,
              "departureOffsetSeconds": 3780
            },
            {
              "stopId": "judu:stop:6389",
              "position": {
                "x": -4060.699,
                "z": 2648.908
              },
              "distanceAlongShapeM": 19730.387,
              "shapeOffsetM": 5.798,
              "arrivalOffsetSeconds": 3840,
              "departureOffsetSeconds": 3840
            },
            {
              "stopId": "judu:stop:7722",
              "position": {
                "x": -4474.19,
                "z": 3331.751
              },
              "distanceAlongShapeM": 20586.694,
              "shapeOffsetM": 2.74,
              "arrivalOffsetSeconds": 3960,
              "departureOffsetSeconds": 3960
            },
            {
              "stopId": "judu:stop:6391",
              "position": {
                "x": -4812.939,
                "z": 3448.883
              },
              "distanceAlongShapeM": 20944.74,
              "shapeOffsetM": 6.496,
              "arrivalOffsetSeconds": 4020,
              "departureOffsetSeconds": 4020
            },
            {
              "stopId": "judu:stop:639",
              "position": {
                "x": -5248.891,
                "z": 3809.209
              },
              "distanceAlongShapeM": 21629.759,
              "shapeOffsetM": 2.707,
              "arrivalOffsetSeconds": 4080,
              "departureOffsetSeconds": 4080
            }
          ],
          "departuresSeconds": [
            18420,
            20100,
            22200,
            23880,
            24900,
            26100,
            27300,
            28920,
            30360,
            31740,
            34140,
            37440,
            39840,
            41580,
            43320,
            44940,
            46440,
            47940,
            49500,
            51300,
            52920,
            54600,
            56280,
            57780,
            58680,
            59520,
            60420,
            61740,
            63360,
            65520,
            67920,
            71940,
            73860,
            75720,
            77520,
            79380,
            81420
          ]
        },
        {
          "id": "judu:pattern:vilnius_bus_49:1",
          "sourceRouteId": "vilnius_bus_49",
          "sourceShapeId": "vilnius_bus_49_b-a",
          "directionId": 1,
          "headsign": "Bajorai",
          "directionName": "Bukčiai–Lazdynai–Žalgirio g.–Didlaukio g.–Ateities g.–Bajorai",
          "mode": "bus",
          "routeShortName": "49",
          "routeLongName": "Bajorai–Ateities g.–Didlaukio g.–Žalgirio g.–Lazdynai–Bukčiai",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              -5248.566,
              3806.522,
              0
            ],
            [
              -5179.112,
              3813.369,
              69.791
            ],
            [
              -5142.158,
              3805.059,
              107.668
            ],
            [
              -5118.792,
              3790.961,
              134.958
            ],
            [
              -4891.4,
              3571.68,
              450.855
            ],
            [
              -4820.67,
              3469.765,
              574.909
            ],
            [
              -4796.885,
              3444.156,
              609.86
            ],
            [
              -4773.906,
              3429.29,
              637.228
            ],
            [
              -4731.798,
              3411.296,
              683.02
            ],
            [
              -4626.524,
              3367.764,
              796.939
            ],
            [
              -4510.545,
              3341.811,
              915.787
            ],
            [
              -4497.626,
              3342.407,
              928.719
            ],
            [
              -4441.951,
              3330.083,
              985.742
            ],
            [
              -4390.49,
              3312.436,
              1040.144
            ],
            [
              -4348.426,
              3289.511,
              1088.05
            ],
            [
              -4264.944,
              3227.96,
              1191.77
            ],
            [
              -4234.003,
              3188.464,
              1241.942
            ],
            [
              -4197.015,
              3125.487,
              1314.978
            ],
            [
              -4171.244,
              3048.231,
              1396.419
            ],
            [
              -4157.405,
              2990.106,
              1456.169
            ],
            [
              -4124.692,
              2829.24,
              1620.327
            ],
            [
              -4095.054,
              2751.917,
              1703.136
            ],
            [
              -4082.456,
              2725.06,
              1732.801
            ],
            [
              -4012.116,
              2547.88,
              1923.432
            ],
            [
              -3955.712,
              2419.407,
              2063.742
            ],
            [
              -3953.773,
              2414.399,
              2069.112
            ],
            [
              -3942.199,
              2386.283,
              2099.517
            ],
            [
              -3939.351,
              2371.866,
              2114.213
            ],
            [
              -3943.03,
              2364.119,
              2122.789
            ],
            [
              -4007.194,
              2316.209,
              2202.866
            ],
            [
              -4079.923,
              2267.378,
              2290.467
            ],
            [
              -4114.659,
              2244.056,
              2332.306
            ],
            [
              -4157.489,
              2223.171,
              2379.957
            ],
            [
              -4325.05,
              2156.176,
              2560.415
            ],
            [
              -4375.253,
              2139.958,
              2613.172
            ],
            [
              -4407.029,
              2135.374,
              2645.277
            ],
            [
              -4517.705,
              2137.698,
              2755.978
            ],
            [
              -4577.32,
              2138.604,
              2815.6
            ],
            [
              -4634.125,
              2135.585,
              2872.485
            ],
            [
              -4816.04,
              2099.743,
              3057.897
            ],
            [
              -4855.442,
              2097.078,
              3097.389
            ],
            [
              -4917.969,
              2100.374,
              3160.003
            ],
            [
              -4969.474,
              2106.821,
              3211.91
            ],
            [
              -5079.485,
              2125.398,
              3323.478
            ],
            [
              -5115.548,
              2129.353,
              3359.757
            ],
            [
              -5151.268,
              2124.22,
              3395.844
            ],
            [
              -5168.723,
              2123.338,
              3413.322
            ],
            [
              -5186.285,
              2118.906,
              3431.434
            ],
            [
              -5205.39,
              2106.815,
              3454.044
            ],
            [
              -5218.73,
              2094.377,
              3472.283
            ],
            [
              -5232.085,
              2067.888,
              3501.948
            ],
            [
              -5234.987,
              2049.013,
              3521.045
            ],
            [
              -5232.767,
              2027.825,
              3542.349
            ],
            [
              -5229.106,
              2015.517,
              3555.19
            ],
            [
              -5217.174,
              1996.39,
              3577.733
            ],
            [
              -5203.627,
              1982.351,
              3597.243
            ],
            [
              -5082.26,
              1887.222,
              3751.449
            ],
            [
              -5064.922,
              1882.473,
              3769.425
            ],
            [
              -5060.085,
              1863.466,
              3789.038
            ],
            [
              -4961.259,
              1757.137,
              3934.202
            ],
            [
              -4931.684,
              1728.355,
              3975.47
            ],
            [
              -4906.917,
              1690.529,
              4020.683
            ],
            [
              -4767.773,
              1565.694,
              4207.618
            ],
            [
              -4741.69,
              1550.026,
              4238.045
            ],
            [
              -4712.351,
              1524.668,
              4276.824
            ],
            [
              -4596.2,
              1451.429,
              4414.138
            ],
            [
              -4491.296,
              1399.532,
              4531.177
            ],
            [
              -4467.288,
              1389.272,
              4557.285
            ],
            [
              -4443.995,
              1374.227,
              4585.015
            ],
            [
              -4243.678,
              1281.718,
              4805.661
            ],
            [
              -4199.211,
              1271.037,
              4851.393
            ],
            [
              -4179.458,
              1265.024,
              4872.041
            ],
            [
              -4137.877,
              1254.669,
              4914.891
            ],
            [
              -4093.256,
              1251.097,
              4959.655
            ],
            [
              -4041.607,
              1253.735,
              5011.372
            ],
            [
              -3953.633,
              1267.797,
              5100.462
            ],
            [
              -3919.363,
              1123.6,
              5248.676
            ],
            [
              -3889.289,
              1035.135,
              5342.113
            ],
            [
              -3881.018,
              1009.279,
              5369.26
            ],
            [
              -3879.245,
              944.791,
              5433.772
            ],
            [
              -3881.411,
              931.47,
              5447.268
            ],
            [
              -3898.384,
              892.134,
              5490.109
            ],
            [
              -3911.432,
              874.104,
              5512.366
            ],
            [
              -3948.102,
              842.457,
              5560.803
            ],
            [
              -4089.107,
              782.559,
              5714.003
            ],
            [
              -4161.662,
              727.04,
              5805.363
            ],
            [
              -4178.229,
              714.534,
              5826.121
            ],
            [
              -4216.46,
              691.251,
              5870.883
            ],
            [
              -4255.439,
              676.425,
              5912.586
            ],
            [
              -4279.313,
              674.524,
              5936.536
            ],
            [
              -4304.422,
              677.184,
              5961.785
            ],
            [
              -4330.724,
              685.43,
              5989.35
            ],
            [
              -4370.887,
              712.839,
              6037.974
            ],
            [
              -4391.801,
              734.351,
              6067.977
            ],
            [
              -4418.25,
              771.542,
              6113.614
            ],
            [
              -4423.862,
              782.771,
              6126.167
            ],
            [
              -4434.781,
              784.705,
              6137.256
            ],
            [
              -4479.393,
              779.274,
              6182.197
            ],
            [
              -4503.366,
              773.007,
              6206.976
            ],
            [
              -4524.836,
              762.245,
              6230.992
            ],
            [
              -4546.478,
              741.466,
              6260.995
            ],
            [
              -4558.582,
              712.731,
              6292.175
            ],
            [
              -4564.028,
              688.195,
              6317.308
            ],
            [
              -4562.176,
              653.793,
              6351.76
            ],
            [
              -4542.083,
              471.996,
              6534.664
            ],
            [
              -4535.565,
              436.694,
              6570.562
            ],
            [
              -4533.311,
              419.524,
              6587.88
            ],
            [
              -4527.744,
              368.221,
              6639.484
            ],
            [
              -4516.259,
              323.495,
              6685.661
            ],
            [
              -4491.638,
              255.166,
              6758.291
            ],
            [
              -4427.619,
              152.763,
              6879.058
            ],
            [
              -4367.011,
              77.134,
              6975.976
            ],
            [
              -4080.333,
              -210.913,
              7382.369
            ],
            [
              -3954.469,
              -380.846,
              7593.838
            ],
            [
              -3926.158,
              -422.036,
              7643.819
            ],
            [
              -3919.036,
              -433.74,
              7657.52
            ],
            [
              -3857.936,
              -540.596,
              7780.611
            ],
            [
              -3823.641,
              -607.984,
              7856.223
            ],
            [
              -3766.483,
              -732.543,
              7993.271
            ],
            [
              -3707.64,
              -908.34,
              8178.654
            ],
            [
              -3695.741,
              -928.584,
              8202.136
            ],
            [
              -3679.687,
              -950.175,
              8229.042
            ],
            [
              -3668.232,
              -978.044,
              8259.173
            ],
            [
              -3606.925,
              -1085.98,
              8383.305
            ],
            [
              -3586.062,
              -1109.72,
              8414.91
            ],
            [
              -3575.241,
              -1117.701,
              8428.356
            ],
            [
              -3510.801,
              -1144.012,
              8497.96
            ],
            [
              -3355.367,
              -1190.556,
              8660.213
            ],
            [
              -3109.19,
              -1234.288,
              8910.244
            ],
            [
              -3070.013,
              -1242.306,
              8950.233
            ],
            [
              -2879.155,
              -1277.94,
              9144.389
            ],
            [
              -2839.273,
              -1283.094,
              9184.603
            ],
            [
              -2787.087,
              -1285.125,
              9236.829
            ],
            [
              -2748.376,
              -1283.58,
              9275.57
            ],
            [
              -2714.118,
              -1278.617,
              9310.186
            ],
            [
              -2670.7,
              -1266.023,
              9355.394
            ],
            [
              -2624.585,
              -1246.798,
              9405.356
            ],
            [
              -2499.949,
              -1183.085,
              9545.332
            ],
            [
              -2469.831,
              -1172.717,
              9577.185
            ],
            [
              -2418.716,
              -1162.489,
              9629.313
            ],
            [
              -2392.231,
              -1159.617,
              9655.953
            ],
            [
              -2152.041,
              -1187.387,
              9897.744
            ],
            [
              -2126.526,
              -1191.159,
              9923.535
            ],
            [
              -2118.854,
              -1195.63,
              9932.415
            ],
            [
              -1948.388,
              -1217.583,
              10104.289
            ],
            [
              -1827.9,
              -1221.953,
              10224.856
            ],
            [
              -1794.345,
              -1220.324,
              10258.451
            ],
            [
              -1681.879,
              -1204.518,
              10372.022
            ],
            [
              -1544.075,
              -1178.035,
              10512.348
            ],
            [
              -1435.713,
              -1149.425,
              10624.423
            ],
            [
              -1393.22,
              -1142.883,
              10667.417
            ],
            [
              -1155.149,
              -1098.17,
              10909.65
            ],
            [
              -1103.532,
              -1084.281,
              10963.103
            ],
            [
              -1083.324,
              -1083.875,
              10983.315
            ],
            [
              -1022.536,
              -1073.836,
              11044.926
            ],
            [
              -998.991,
              -1055.334,
              11074.871
            ],
            [
              -969.041,
              -1039.175,
              11108.902
            ],
            [
              -947.066,
              -1036.231,
              11131.074
            ],
            [
              -930.307,
              -1036.533,
              11147.835
            ],
            [
              -906.579,
              -1043.639,
              11172.605
            ],
            [
              -895.802,
              -1053.852,
              11187.452
            ],
            [
              -890.221,
              -1066.198,
              11201.001
            ],
            [
              -867.459,
              -1091.1,
              11234.738
            ],
            [
              -847.054,
              -1103.713,
              11258.727
            ],
            [
              -821.251,
              -1103.065,
              11284.538
            ],
            [
              -688.757,
              -1085.417,
              11418.202
            ],
            [
              -654.894,
              -1209.598,
              11546.918
            ],
            [
              -644.883,
              -1226.477,
              11566.542
            ],
            [
              -627.842,
              -1246.823,
              11593.082
            ],
            [
              -612.377,
              -1263.559,
              11615.869
            ],
            [
              -593.158,
              -1289.753,
              11648.358
            ],
            [
              -557.225,
              -1334.932,
              11706.084
            ],
            [
              -548.544,
              -1354.014,
              11727.048
            ],
            [
              -546.208,
              -1367.415,
              11740.651
            ],
            [
              -541.958,
              -1488.834,
              11862.144
            ],
            [
              -536.137,
              -1559.073,
              11932.624
            ],
            [
              -520.589,
              -1697.395,
              12071.817
            ],
            [
              -504.478,
              -1804.557,
              12180.183
            ],
            [
              -451.512,
              -1798.837,
              12233.457
            ],
            [
              -397.434,
              -1792.064,
              12287.957
            ],
            [
              -386.905,
              -1791.102,
              12298.531
            ],
            [
              -162.795,
              -1768.453,
              12523.782
            ],
            [
              -103.598,
              -1755.97,
              12584.281
            ],
            [
              91.167,
              -1735.227,
              12780.148
            ],
            [
              238.547,
              -1717.597,
              12928.578
            ],
            [
              252.628,
              -1719.249,
              12942.756
            ],
            [
              342.249,
              -1718.661,
              13032.379
            ],
            [
              352.701,
              -1764.728,
              13079.616
            ],
            [
              354.758,
              -1810.175,
              13125.11
            ],
            [
              356.121,
              -1841.371,
              13156.336
            ],
            [
              372.957,
              -1942.984,
              13259.334
            ],
            [
              426.379,
              -2158.817,
              13481.68
            ],
            [
              439.077,
              -2195.331,
              13520.34
            ],
            [
              440.947,
              -2208.066,
              13533.211
            ],
            [
              462.343,
              -2342.047,
              13668.889
            ],
            [
              497.458,
              -2575.098,
              13904.571
            ],
            [
              511.756,
              -2776.003,
              14105.984
            ],
            [
              513.301,
              -2797.183,
              14127.22
            ],
            [
              524.563,
              -2850.825,
              14182.032
            ],
            [
              523.952,
              -2902.017,
              14233.228
            ],
            [
              518.333,
              -3049.981,
              14381.298
            ],
            [
              511.327,
              -3110.973,
              14442.691
            ],
            [
              506.062,
              -3253.474,
              14585.289
            ],
            [
              505.902,
              -3256.64,
              14588.46
            ],
            [
              503.774,
              -3366.969,
              14698.809
            ],
            [
              489.873,
              -3512.567,
              14845.069
            ],
            [
              474.056,
              -3566.826,
              14901.587
            ],
            [
              440.465,
              -3641.474,
              14983.444
            ],
            [
              383.151,
              -3709.882,
              15072.689
            ],
            [
              302.538,
              -3790.592,
              15186.762
            ],
            [
              278.895,
              -3808.166,
              15216.22
            ],
            [
              228.358,
              -3858.451,
              15287.512
            ],
            [
              158.106,
              -3965.152,
              15415.264
            ],
            [
              125.932,
              -4039.781,
              15496.533
            ],
            [
              102.95,
              -4092.167,
              15553.738
            ],
            [
              79.561,
              -4208.631,
              15672.528
            ],
            [
              75.006,
              -4246.398,
              15710.568
            ],
            [
              72.804,
              -4296.453,
              15760.672
            ],
            [
              62.209,
              -4347.469,
              15812.776
            ],
            [
              53.653,
              -4357.332,
              15825.833
            ],
            [
              38.173,
              -4361.187,
              15841.786
            ],
            [
              -1.759,
              -4357.435,
              15881.894
            ],
            [
              -43.581,
              -4357.963,
              15923.72
            ],
            [
              -86.799,
              -4356.998,
              15966.948
            ],
            [
              -112.623,
              -4359.868,
              15992.931
            ],
            [
              -137.864,
              -4366.088,
              16018.927
            ],
            [
              -171.117,
              -4387.748,
              16058.612
            ],
            [
              -197.387,
              -4415.101,
              16096.537
            ],
            [
              -229.695,
              -4455.703,
              16148.425
            ],
            [
              -260.472,
              -4482.974,
              16189.546
            ],
            [
              -335.167,
              -4516.128,
              16271.268
            ],
            [
              -368.095,
              -4519.983,
              16304.421
            ],
            [
              -469.274,
              -4521.487,
              16405.611
            ],
            [
              -484.821,
              -4525.503,
              16421.669
            ],
            [
              -495.138,
              -4525.415,
              16431.985
            ],
            [
              -531.808,
              -4523.694,
              16468.696
            ],
            [
              -716.635,
              -4519.236,
              16653.577
            ],
            [
              -810.335,
              -4855.967,
              17003.102
            ],
            [
              -844.605,
              -4970.012,
              17122.184
            ],
            [
              -859.998,
              -5037.642,
              17191.544
            ],
            [
              -867.261,
              -5083.153,
              17237.631
            ],
            [
              -868.716,
              -5113.183,
              17267.696
            ],
            [
              -863.974,
              -5257.991,
              17412.582
            ],
            [
              -875.788,
              -5375.937,
              17531.118
            ],
            [
              -865.47,
              -5384.739,
              17544.679
            ],
            [
              -827.457,
              -5404.886,
              17587.702
            ],
            [
              -674.33,
              -5492.97,
              17764.356
            ],
            [
              -590.252,
              -5533.933,
              17857.881
            ],
            [
              -565.267,
              -5552.833,
              17889.21
            ],
            [
              -421.759,
              -5631.135,
              18052.69
            ],
            [
              -383.93,
              -5640.727,
              18091.716
            ],
            [
              -342.157,
              -5645.939,
              18133.813
            ],
            [
              -257.182,
              -5648.596,
              18218.829
            ],
            [
              -196.756,
              -5655.261,
              18279.622
            ],
            [
              -180.177,
              -5664.469,
              18298.586
            ],
            [
              -177.649,
              -5676.666,
              18311.043
            ],
            [
              -188.191,
              -5725.09,
              18360.601
            ],
            [
              -190.648,
              -5736.736,
              18372.503
            ],
            [
              -196.91,
              -5769.923,
              18406.276
            ],
            [
              -201.665,
              -5818.819,
              18455.402
            ],
            [
              -201.086,
              -5857.793,
              18494.381
            ],
            [
              -195.599,
              -5910.215,
              18547.089
            ],
            [
              -136.015,
              -6175.138,
              18818.63
            ],
            [
              -127.679,
              -6205.529,
              18850.143
            ],
            [
              -123.468,
              -6228.802,
              18873.794
            ],
            [
              -113.557,
              -6285.758,
              18931.606
            ],
            [
              -58.166,
              -6532.794,
              19184.776
            ],
            [
              -46.468,
              -6597.576,
              19250.606
            ],
            [
              -39.377,
              -6667.839,
              19321.226
            ],
            [
              -35.045,
              -6748.072,
              19401.576
            ],
            [
              -26.235,
              -6767.677,
              19423.069
            ],
            [
              -16.413,
              -6780.218,
              19438.999
            ],
            [
              0.443,
              -6790.505,
              19458.746
            ],
            [
              9.552,
              -6811.226,
              19481.38
            ],
            [
              9.735,
              -6827.796,
              19497.952
            ],
            [
              7.024,
              -6842.352,
              19512.758
            ],
            [
              -2.815,
              -6852.191,
              19526.672
            ],
            [
              -13.86,
              -6857.556,
              19538.951
            ],
            [
              -26.131,
              -6859.559,
              19551.385
            ],
            [
              -47.374,
              -6859.171,
              19572.631
            ],
            [
              -59.463,
              -6851.158,
              19587.135
            ],
            [
              -78.653,
              -6844.129,
              19607.572
            ],
            [
              -94.726,
              -6842.723,
              19623.706
            ],
            [
              -112.168,
              -6845.745,
              19641.408
            ],
            [
              -131.642,
              -6854.296,
              19662.677
            ],
            [
              -159.633,
              -6886.315,
              19705.206
            ],
            [
              -179.506,
              -6901.294,
              19730.091
            ],
            [
              -377.89,
              -7081.371,
              19998.017
            ],
            [
              -448.339,
              -7131.301,
              20084.365
            ],
            [
              -497.724,
              -7156.009,
              20139.586
            ],
            [
              -684.153,
              -7210.52,
              20333.821
            ],
            [
              -707.406,
              -7214.553,
              20357.421
            ],
            [
              -754.116,
              -7229.048,
              20406.328
            ],
            [
              -772.74,
              -7231.183,
              20425.075
            ],
            [
              -784.346,
              -7232.086,
              20436.716
            ],
            [
              -938.988,
              -7273.823,
              20596.891
            ],
            [
              -982.938,
              -7283.05,
              20641.799
            ],
            [
              -1022.982,
              -7288.847,
              20682.261
            ],
            [
              -1060.359,
              -7291.674,
              20719.744
            ],
            [
              -1074.66,
              -7299.209,
              20735.909
            ],
            [
              -1180.048,
              -7399.975,
              20881.719
            ],
            [
              -1243.352,
              -7456.944,
              20966.883
            ],
            [
              -1267.888,
              -7479.367,
              21000.121
            ],
            [
              -1317.777,
              -7526.782,
              21068.947
            ],
            [
              -1383.594,
              -7595.031,
              21163.762
            ],
            [
              -1422.488,
              -7638.033,
              21221.744
            ],
            [
              -1438.394,
              -7651.046,
              21242.295
            ],
            [
              -1481.803,
              -7670.394,
              21289.82
            ],
            [
              -1494.171,
              -7677.965,
              21304.322
            ],
            [
              -1503.037,
              -7684.767,
              21315.497
            ],
            [
              -1510.622,
              -7694.304,
              21327.682
            ],
            [
              -1518.384,
              -7699.796,
              21337.19
            ],
            [
              -1526.914,
              -7704.225,
              21346.802
            ],
            [
              -1526.871,
              -7694.675,
              21356.353
            ],
            [
              -1526.882,
              -7690.108,
              21360.92
            ],
            [
              -1511.847,
              -7679.922,
              21379.08
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:639",
              "position": {
                "x": -5248.891,
                "z": 3809.209
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 2.707,
              "arrivalOffsetSeconds": -450,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:6390",
              "position": {
                "x": -4728.933,
                "z": 3417.388
              },
              "distanceAlongShapeM": 683.339,
              "shapeOffsetM": 6.725,
              "arrivalOffsetSeconds": 60,
              "departureOffsetSeconds": 60
            },
            {
              "stopId": "judu:stop:7723",
              "position": {
                "x": -4497.206,
                "z": 3344.392
              },
              "distanceAlongShapeM": 928.719,
              "shapeOffsetM": 2.029,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:6388",
              "position": {
                "x": -4080.014,
                "z": 2726.053
              },
              "distanceAlongShapeM": 1732.801,
              "shapeOffsetM": 2.636,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:8328",
              "position": {
                "x": -3954.322,
                "z": 2419.974
              },
              "distanceAlongShapeM": 2063.742,
              "shapeOffsetM": 1.501,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:6387",
              "position": {
                "x": -4156.496,
                "z": 2220.868
              },
              "distanceAlongShapeM": 2379.957,
              "shapeOffsetM": 2.508,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:6381",
              "position": {
                "x": -4518.062,
                "z": 2131.364
              },
              "distanceAlongShapeM": 2756.238,
              "shapeOffsetM": 6.338,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:756",
              "position": {
                "x": -5151.175,
                "z": 2121.056
              },
              "distanceAlongShapeM": 3395.911,
              "shapeOffsetM": 3.165,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:437",
              "position": {
                "x": -4928.804,
                "z": 1730.978
              },
              "distanceAlongShapeM": 3975.47,
              "shapeOffsetM": 3.896,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:783",
              "position": {
                "x": -4739.606,
                "z": 1552.966
              },
              "distanceAlongShapeM": 4238.045,
              "shapeOffsetM": 3.604,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:3589",
              "position": {
                "x": -4466.279,
                "z": 1391.309
              },
              "distanceAlongShapeM": 4557.285,
              "shapeOffsetM": 2.273,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:6317",
              "position": {
                "x": -4197.987,
                "z": 1275.363
              },
              "distanceAlongShapeM": 4851.393,
              "shapeOffsetM": 4.495,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:5701",
              "position": {
                "x": -3876.172,
                "z": 1010.417
              },
              "distanceAlongShapeM": 5369.26,
              "shapeOffsetM": 4.978,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            },
            {
              "stopId": "judu:stop:5704",
              "position": {
                "x": -4175.491,
                "z": 710.581
              },
              "distanceAlongShapeM": 5826.121,
              "shapeOffsetM": 4.809,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:1071",
              "position": {
                "x": -4530.426,
                "z": 437.286
              },
              "distanceAlongShapeM": 6570.644,
              "shapeOffsetM": 5.172,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:1004",
              "position": {
                "x": -4077.229,
                "z": -208.399
              },
              "distanceAlongShapeM": 7382.369,
              "shapeOffsetM": 3.995,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:6649",
              "position": {
                "x": -3921.604,
                "z": -419.265
              },
              "distanceAlongShapeM": 7643.819,
              "shapeOffsetM": 5.33,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            },
            {
              "stopId": "judu:stop:6643",
              "position": {
                "x": -3679.35,
                "z": -950.021
              },
              "distanceAlongShapeM": 8229.042,
              "shapeOffsetM": 0.37,
              "arrivalOffsetSeconds": 1380,
              "departureOffsetSeconds": 1380
            },
            {
              "stopId": "judu:stop:7416",
              "position": {
                "x": -3108.49,
                "z": -1230.499
              },
              "distanceAlongShapeM": 8910.244,
              "shapeOffsetM": 3.854,
              "arrivalOffsetSeconds": 1500,
              "departureOffsetSeconds": 1500
            },
            {
              "stopId": "judu:stop:6398",
              "position": {
                "x": -2151.528,
                "z": -1183.918
              },
              "distanceAlongShapeM": 9897.744,
              "shapeOffsetM": 3.507,
              "arrivalOffsetSeconds": 1620,
              "departureOffsetSeconds": 1620
            },
            {
              "stopId": "judu:stop:6396",
              "position": {
                "x": -1436.465,
                "z": -1145.449
              },
              "distanceAlongShapeM": 10624.423,
              "shapeOffsetM": 4.046,
              "arrivalOffsetSeconds": 1740,
              "departureOffsetSeconds": 1740
            },
            {
              "stopId": "judu:stop:6397",
              "position": {
                "x": -1103.929,
                "z": -1082.392
              },
              "distanceAlongShapeM": 10963.103,
              "shapeOffsetM": 1.931,
              "arrivalOffsetSeconds": 1800,
              "departureOffsetSeconds": 1800
            },
            {
              "stopId": "judu:stop:7769",
              "position": {
                "x": -610.057,
                "z": -1261.617
              },
              "distanceAlongShapeM": 11615.869,
              "shapeOffsetM": 3.025,
              "arrivalOffsetSeconds": 1980,
              "departureOffsetSeconds": 1980
            },
            {
              "stopId": "judu:stop:5462",
              "position": {
                "x": -397.821,
                "z": -1788.678
              },
              "distanceAlongShapeM": 12287.957,
              "shapeOffsetM": 3.408,
              "arrivalOffsetSeconds": 2160,
              "departureOffsetSeconds": 2160
            },
            {
              "stopId": "judu:stop:17318",
              "position": {
                "x": -103.866,
                "z": -1753.939
              },
              "distanceAlongShapeM": 12584.281,
              "shapeOffsetM": 2.048,
              "arrivalOffsetSeconds": 2220,
              "departureOffsetSeconds": 2220
            },
            {
              "stopId": "judu:stop:6844",
              "position": {
                "x": 356.237,
                "z": -1764.56
              },
              "distanceAlongShapeM": 13079.616,
              "shapeOffsetM": 3.54,
              "arrivalOffsetSeconds": 2400,
              "departureOffsetSeconds": 2400
            },
            {
              "stopId": "judu:stop:6845",
              "position": {
                "x": 441.836,
                "z": -2194.724
              },
              "distanceAlongShapeM": 13520.34,
              "shapeOffsetM": 2.825,
              "arrivalOffsetSeconds": 2460,
              "departureOffsetSeconds": 2460
            },
            {
              "stopId": "judu:stop:5469",
              "position": {
                "x": 505.139,
                "z": -2574.385
              },
              "distanceAlongShapeM": 13904.571,
              "shapeOffsetM": 7.714,
              "arrivalOffsetSeconds": 2580,
              "departureOffsetSeconds": 2580
            },
            {
              "stopId": "judu:stop:19086",
              "position": {
                "x": 511.316,
                "z": -3256.915
              },
              "distanceAlongShapeM": 14588.63,
              "shapeOffsetM": 5.419,
              "arrivalOffsetSeconds": 2700,
              "departureOffsetSeconds": 2700
            },
            {
              "stopId": "judu:stop:5848",
              "position": {
                "x": 303.678,
                "z": -3791.921
              },
              "distanceAlongShapeM": 15186.762,
              "shapeOffsetM": 1.751,
              "arrivalOffsetSeconds": 2880,
              "departureOffsetSeconds": 2880
            },
            {
              "stopId": "judu:stop:5840",
              "position": {
                "x": 127.093,
                "z": -4040.286
              },
              "distanceAlongShapeM": 15496.533,
              "shapeOffsetM": 1.266,
              "arrivalOffsetSeconds": 2940,
              "departureOffsetSeconds": 2940
            },
            {
              "stopId": "judu:stop:5835",
              "position": {
                "x": -43.706,
                "z": -4361.123
              },
              "distanceAlongShapeM": 15923.774,
              "shapeOffsetM": 3.162,
              "arrivalOffsetSeconds": 3000,
              "departureOffsetSeconds": 3000
            },
            {
              "stopId": "judu:stop:5834",
              "position": {
                "x": -495.157,
                "z": -4527.698
              },
              "distanceAlongShapeM": 16431.985,
              "shapeOffsetM": 2.283,
              "arrivalOffsetSeconds": 3060,
              "departureOffsetSeconds": 3060
            },
            {
              "stopId": "judu:stop:5828",
              "position": {
                "x": -826.661,
                "z": -5403.385
              },
              "distanceAlongShapeM": 17587.702,
              "shapeOffsetM": 1.699,
              "arrivalOffsetSeconds": 3300,
              "departureOffsetSeconds": 3300
            },
            {
              "stopId": "judu:stop:6633",
              "position": {
                "x": -589.373,
                "z": -5532.358
              },
              "distanceAlongShapeM": 17857.881,
              "shapeOffsetM": 1.804,
              "arrivalOffsetSeconds": 3360,
              "departureOffsetSeconds": 3360
            },
            {
              "stopId": "judu:stop:6497",
              "position": {
                "x": -185.377,
                "z": -5737.848
              },
              "distanceAlongShapeM": 18372.618,
              "shapeOffsetM": 5.386,
              "arrivalOffsetSeconds": 3540,
              "departureOffsetSeconds": 3540
            },
            {
              "stopId": "judu:stop:6500",
              "position": {
                "x": -122.378,
                "z": -6204.331
              },
              "distanceAlongShapeM": 18850.143,
              "shapeOffsetM": 5.434,
              "arrivalOffsetSeconds": 3600,
              "departureOffsetSeconds": 3600
            },
            {
              "stopId": "judu:stop:6783",
              "position": {
                "x": -156.753,
                "z": -6889.462
              },
              "distanceAlongShapeM": 19705.206,
              "shapeOffsetM": 4.266,
              "arrivalOffsetSeconds": 3720,
              "departureOffsetSeconds": 3720
            },
            {
              "stopId": "judu:stop:7968",
              "position": {
                "x": -752.866,
                "z": -7235.995
              },
              "distanceAlongShapeM": 20406.328,
              "shapeOffsetM": 7.058,
              "arrivalOffsetSeconds": 3900,
              "departureOffsetSeconds": 3900
            },
            {
              "stopId": "judu:stop:8094",
              "position": {
                "x": -1178.242,
                "z": -7401.989
              },
              "distanceAlongShapeM": 20881.723,
              "shapeOffsetM": 2.705,
              "arrivalOffsetSeconds": 4020,
              "departureOffsetSeconds": 4020
            },
            {
              "stopId": "judu:stop:370",
              "position": {
                "x": -1512.213,
                "z": -7678.755
              },
              "distanceAlongShapeM": 21379.08,
              "shapeOffsetM": 1.223,
              "arrivalOffsetSeconds": 4080,
              "departureOffsetSeconds": 4080
            }
          ],
          "departuresSeconds": [
            19680,
            21120,
            22320,
            24000,
            25020,
            26340,
            28500,
            30480,
            32820,
            35220,
            36780,
            38700,
            39960,
            41340,
            42780,
            44520,
            46260,
            48000,
            49860,
            51360,
            52800,
            54420,
            56220,
            57900,
            59940,
            62160,
            64560,
            66120,
            67440,
            69180,
            71280,
            72900,
            74760,
            76200,
            77220,
            78780,
            80340,
            81960
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_bus_50",
      "sourceRouteId": "vilnius_bus_50",
      "mode": "bus",
      "shortName": "50",
      "longName": "Antakalnis–Didlaukio g.–Baltupio g.–Bajorai",
      "color": "0073AC",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_bus_50:0",
          "sourceRouteId": "vilnius_bus_50",
          "sourceShapeId": "vilnius_bus_50_a-b",
          "directionId": 0,
          "headsign": "Bajorai",
          "directionName": "Antakalnis–Didlaukio g.–Baltupio g.–Bajorai",
          "mode": "bus",
          "routeShortName": "50",
          "routeLongName": "Antakalnis–Didlaukio g.–Baltupio g.–Bajorai",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              2558.505,
              -3824.161,
              0
            ],
            [
              2555.4,
              -3867.621,
              43.571
            ],
            [
              2550.54,
              -3888.998,
              65.493
            ],
            [
              2499.38,
              -3984.027,
              173.418
            ],
            [
              2493.87,
              -3987.392,
              179.874
            ],
            [
              2480.707,
              -3991.548,
              193.678
            ],
            [
              2470.701,
              -3991,
              203.699
            ],
            [
              2459.88,
              -3985.473,
              215.85
            ],
            [
              2450.261,
              -3972.454,
              232.037
            ],
            [
              2446.334,
              -3960.766,
              244.367
            ],
            [
              2458.099,
              -3917.57,
              289.136
            ],
            [
              2495.249,
              -3757.959,
              453.014
            ],
            [
              2503.087,
              -3718.029,
              493.706
            ],
            [
              2508.663,
              -3661.358,
              550.65
            ],
            [
              2467.501,
              -3518.217,
              699.593
            ],
            [
              2463.864,
              -3499.82,
              718.345
            ],
            [
              2434.339,
              -3309.248,
              911.191
            ],
            [
              2430.841,
              -3283.862,
              936.817
            ],
            [
              2426.976,
              -3256.769,
              964.184
            ],
            [
              2328.687,
              -2639.354,
              1589.374
            ],
            [
              2308.053,
              -2536.548,
              1694.23
            ],
            [
              2300.116,
              -2511.178,
              1720.812
            ],
            [
              2295.002,
              -2476.188,
              1756.174
            ],
            [
              2274.24,
              -2414.57,
              1821.196
            ],
            [
              2234.812,
              -2316.979,
              1926.451
            ],
            [
              2177.257,
              -2188.992,
              2066.783
            ],
            [
              2082.177,
              -1964.565,
              2310.52
            ],
            [
              2063.994,
              -1895.874,
              2381.577
            ],
            [
              2025.955,
              -1900.505,
              2419.897
            ],
            [
              1998.15,
              -1907.334,
              2448.528
            ],
            [
              1855.148,
              -1935.839,
              2594.344
            ],
            [
              1712.252,
              -1958.784,
              2739.07
            ],
            [
              1647.639,
              -1960.909,
              2803.718
            ],
            [
              1610.284,
              -1958.819,
              2841.132
            ],
            [
              1296.179,
              -1874.744,
              3166.294
            ],
            [
              1221.902,
              -1853.157,
              3243.644
            ],
            [
              1060.096,
              -1806.436,
              3412.06
            ],
            [
              832.829,
              -1740.755,
              3648.627
            ],
            [
              806.202,
              -1730.511,
              3677.158
            ],
            [
              764.977,
              -1728.64,
              3718.425
            ],
            [
              722.32,
              -1734.535,
              3761.487
            ],
            [
              662.58,
              -1757.929,
              3825.645
            ],
            [
              696.368,
              -1819.94,
              3896.263
            ],
            [
              709.094,
              -1857.862,
              3936.263
            ],
            [
              776.616,
              -2147.432,
              4233.602
            ],
            [
              451.425,
              -2269.486,
              4580.944
            ],
            [
              462.343,
              -2342.047,
              4654.321
            ],
            [
              497.458,
              -2575.098,
              4890.003
            ],
            [
              511.756,
              -2776.003,
              5091.416
            ],
            [
              513.301,
              -2797.183,
              5112.652
            ],
            [
              524.563,
              -2850.825,
              5167.464
            ],
            [
              523.952,
              -2902.017,
              5218.66
            ],
            [
              518.333,
              -3049.981,
              5366.73
            ],
            [
              511.327,
              -3110.973,
              5428.123
            ],
            [
              506.062,
              -3253.474,
              5570.721
            ],
            [
              505.902,
              -3256.64,
              5573.892
            ],
            [
              503.774,
              -3366.969,
              5684.241
            ],
            [
              489.873,
              -3512.567,
              5830.501
            ],
            [
              474.056,
              -3566.826,
              5887.018
            ],
            [
              440.465,
              -3641.474,
              5968.876
            ],
            [
              383.151,
              -3709.882,
              6058.121
            ],
            [
              302.538,
              -3790.592,
              6172.193
            ],
            [
              278.895,
              -3808.166,
              6201.652
            ],
            [
              228.358,
              -3858.451,
              6272.944
            ],
            [
              158.106,
              -3965.152,
              6400.696
            ],
            [
              125.932,
              -4039.781,
              6481.965
            ],
            [
              102.95,
              -4092.167,
              6539.17
            ],
            [
              79.561,
              -4208.631,
              6657.96
            ],
            [
              75.006,
              -4246.398,
              6696
            ],
            [
              72.804,
              -4296.453,
              6746.104
            ],
            [
              62.209,
              -4347.469,
              6798.208
            ],
            [
              53.653,
              -4357.332,
              6811.265
            ],
            [
              38.173,
              -4361.187,
              6827.218
            ],
            [
              -1.759,
              -4357.435,
              6867.326
            ],
            [
              -43.581,
              -4357.963,
              6909.152
            ],
            [
              -86.799,
              -4356.998,
              6952.38
            ],
            [
              -112.623,
              -4359.868,
              6978.363
            ],
            [
              -137.864,
              -4366.088,
              7004.359
            ],
            [
              -171.117,
              -4387.748,
              7044.044
            ],
            [
              -197.387,
              -4415.101,
              7081.969
            ],
            [
              -229.695,
              -4455.703,
              7133.857
            ],
            [
              -260.472,
              -4482.974,
              7174.978
            ],
            [
              -335.167,
              -4516.128,
              7256.7
            ],
            [
              -368.095,
              -4519.983,
              7289.853
            ],
            [
              -469.274,
              -4521.487,
              7391.043
            ],
            [
              -484.821,
              -4525.503,
              7407.101
            ],
            [
              -495.138,
              -4525.415,
              7417.417
            ],
            [
              -531.808,
              -4523.694,
              7454.128
            ],
            [
              -716.635,
              -4519.236,
              7639.009
            ],
            [
              -810.335,
              -4855.967,
              7988.533
            ],
            [
              -844.605,
              -4970.012,
              8107.616
            ],
            [
              -852.956,
              -5004.372,
              8142.976
            ],
            [
              -867.261,
              -5083.153,
              8223.046
            ],
            [
              -868.716,
              -5113.183,
              8253.111
            ],
            [
              -863.974,
              -5257.991,
              8397.997
            ],
            [
              -875.788,
              -5375.937,
              8516.533
            ],
            [
              -880.302,
              -5384.62,
              8526.319
            ],
            [
              -877.764,
              -5396.84,
              8538.799
            ],
            [
              -887.793,
              -5449.511,
              8592.417
            ],
            [
              -893.567,
              -5470.085,
              8613.786
            ],
            [
              -911.955,
              -5561.038,
              8706.579
            ],
            [
              -930.002,
              -5633.073,
              8780.84
            ],
            [
              -983.576,
              -5818.018,
              8973.389
            ],
            [
              -989.219,
              -5846.448,
              9002.373
            ],
            [
              -994.297,
              -5876.826,
              9033.173
            ],
            [
              -1014.167,
              -6014.509,
              9172.282
            ],
            [
              -1049.096,
              -6308.888,
              9468.726
            ],
            [
              -1050.642,
              -6358.956,
              9518.818
            ],
            [
              -1044.402,
              -6405.824,
              9566.099
            ],
            [
              -1041.098,
              -6426.656,
              9587.192
            ],
            [
              -1036.431,
              -6463.856,
              9624.683
            ],
            [
              -1013.612,
              -6555.552,
              9719.176
            ],
            [
              -980.393,
              -6641.87,
              9811.666
            ],
            [
              -928.004,
              -6736.327,
              9919.678
            ],
            [
              -886.521,
              -6792.738,
              9989.7
            ],
            [
              -721.383,
              -6990.538,
              10247.373
            ],
            [
              -581.501,
              -7153.472,
              10462.116
            ],
            [
              -567.625,
              -7175.894,
              10488.484
            ],
            [
              -684.153,
              -7210.52,
              10610.048
            ],
            [
              -707.406,
              -7214.553,
              10633.648
            ],
            [
              -754.116,
              -7229.048,
              10682.555
            ],
            [
              -772.74,
              -7231.183,
              10701.301
            ],
            [
              -784.346,
              -7232.086,
              10712.942
            ],
            [
              -938.988,
              -7273.823,
              10873.118
            ],
            [
              -982.938,
              -7283.05,
              10918.026
            ],
            [
              -1022.982,
              -7288.847,
              10958.488
            ],
            [
              -1060.359,
              -7291.674,
              10995.971
            ],
            [
              -1074.66,
              -7299.209,
              11012.136
            ],
            [
              -1180.048,
              -7399.975,
              11157.945
            ],
            [
              -1243.352,
              -7456.944,
              11243.109
            ],
            [
              -1267.888,
              -7479.367,
              11276.347
            ],
            [
              -1317.777,
              -7526.782,
              11345.174
            ],
            [
              -1383.594,
              -7595.031,
              11439.988
            ],
            [
              -1422.488,
              -7638.033,
              11497.971
            ],
            [
              -1438.394,
              -7651.046,
              11518.522
            ],
            [
              -1481.803,
              -7670.394,
              11566.047
            ],
            [
              -1494.171,
              -7677.965,
              11580.548
            ],
            [
              -1503.037,
              -7684.767,
              11591.723
            ],
            [
              -1510.622,
              -7694.304,
              11603.909
            ],
            [
              -1518.384,
              -7699.796,
              11613.417
            ],
            [
              -1526.914,
              -7704.225,
              11623.029
            ],
            [
              -1526.871,
              -7694.675,
              11632.58
            ],
            [
              -1526.882,
              -7690.108,
              11637.146
            ],
            [
              -1511.847,
              -7679.922,
              11655.307
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:5483",
              "position": {
                "x": 2562.319,
                "z": -3823.788
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 3.832,
              "arrivalOffsetSeconds": -420,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:5118",
              "position": {
                "x": 2463.001,
                "z": -3519.117
              },
              "distanceAlongShapeM": 699.593,
              "shapeOffsetM": 4.589,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:5119",
              "position": {
                "x": 2425.512,
                "z": -3284.63
              },
              "distanceAlongShapeM": 936.783,
              "shapeOffsetM": 5.384,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:5096",
              "position": {
                "x": 2296.913,
                "z": -2511.848
              },
              "distanceAlongShapeM": 1720.812,
              "shapeOffsetM": 3.272,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:5091",
              "position": {
                "x": 2031.037,
                "z": -1906.834
              },
              "distanceAlongShapeM": 2415.617,
              "shapeOffsetM": 6.897,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:7042",
              "position": {
                "x": 1294.689,
                "z": -1879.791
              },
              "distanceAlongShapeM": 3166.316,
              "shapeOffsetM": 5.263,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:7045",
              "position": {
                "x": 831.715,
                "z": -1745.452
              },
              "distanceAlongShapeM": 3648.394,
              "shapeOffsetM": 4.822,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:7331",
              "position": {
                "x": 704.051,
                "z": -1816.579
              },
              "distanceAlongShapeM": 3896.263,
              "shapeOffsetM": 8.386,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            },
            {
              "stopId": "judu:stop:5469",
              "position": {
                "x": 505.139,
                "z": -2574.385
              },
              "distanceAlongShapeM": 4890.003,
              "shapeOffsetM": 7.714,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:19086",
              "position": {
                "x": 511.316,
                "z": -3256.915
              },
              "distanceAlongShapeM": 5574.062,
              "shapeOffsetM": 5.419,
              "arrivalOffsetSeconds": 1380,
              "departureOffsetSeconds": 1380
            },
            {
              "stopId": "judu:stop:5848",
              "position": {
                "x": 303.678,
                "z": -3791.921
              },
              "distanceAlongShapeM": 6172.193,
              "shapeOffsetM": 1.751,
              "arrivalOffsetSeconds": 1500,
              "departureOffsetSeconds": 1500
            },
            {
              "stopId": "judu:stop:5840",
              "position": {
                "x": 127.093,
                "z": -4040.286
              },
              "distanceAlongShapeM": 6481.965,
              "shapeOffsetM": 1.266,
              "arrivalOffsetSeconds": 1560,
              "departureOffsetSeconds": 1560
            },
            {
              "stopId": "judu:stop:5835",
              "position": {
                "x": -43.706,
                "z": -4361.123
              },
              "distanceAlongShapeM": 6909.206,
              "shapeOffsetM": 3.162,
              "arrivalOffsetSeconds": 1680,
              "departureOffsetSeconds": 1680
            },
            {
              "stopId": "judu:stop:5834",
              "position": {
                "x": -495.157,
                "z": -4527.698
              },
              "distanceAlongShapeM": 7417.417,
              "shapeOffsetM": 2.283,
              "arrivalOffsetSeconds": 1740,
              "departureOffsetSeconds": 1740
            },
            {
              "stopId": "judu:stop:6773",
              "position": {
                "x": -884.191,
                "z": -5450.216
              },
              "distanceAlongShapeM": 8592.417,
              "shapeOffsetM": 3.671,
              "arrivalOffsetSeconds": 1980,
              "departureOffsetSeconds": 1980
            },
            {
              "stopId": "judu:stop:6775",
              "position": {
                "x": -986.029,
                "z": -5846.918
              },
              "distanceAlongShapeM": 9002.213,
              "shapeOffsetM": 3.221,
              "arrivalOffsetSeconds": 2040,
              "departureOffsetSeconds": 2040
            },
            {
              "stopId": "judu:stop:6777",
              "position": {
                "x": -1036.394,
                "z": -6426.006
              },
              "distanceAlongShapeM": 9587.192,
              "shapeOffsetM": 4.748,
              "arrivalOffsetSeconds": 2100,
              "departureOffsetSeconds": 2100
            },
            {
              "stopId": "judu:stop:7968",
              "position": {
                "x": -752.866,
                "z": -7235.995
              },
              "distanceAlongShapeM": 10682.555,
              "shapeOffsetM": 7.058,
              "arrivalOffsetSeconds": 2370,
              "departureOffsetSeconds": 2370
            },
            {
              "stopId": "judu:stop:8094",
              "position": {
                "x": -1178.242,
                "z": -7401.989
              },
              "distanceAlongShapeM": 11157.95,
              "shapeOffsetM": 2.705,
              "arrivalOffsetSeconds": 2490,
              "departureOffsetSeconds": 2490
            },
            {
              "stopId": "judu:stop:370",
              "position": {
                "x": -1512.213,
                "z": -7678.755
              },
              "distanceAlongShapeM": 11655.307,
              "shapeOffsetM": 1.223,
              "arrivalOffsetSeconds": 2550,
              "departureOffsetSeconds": 2550
            }
          ],
          "departuresSeconds": [
            21240,
            22560,
            23700,
            25200,
            26700,
            27660,
            28920,
            30240,
            31980,
            34200,
            35940,
            37740,
            38940,
            41580,
            43380,
            45180,
            47160,
            49140,
            51000,
            52980,
            55080,
            57180,
            58440,
            59640,
            60840,
            62160,
            64020,
            65940,
            67560,
            69120,
            71100,
            73020,
            75000,
            76500,
            78540,
            80520,
            82440,
            84180
          ]
        },
        {
          "id": "judu:pattern:vilnius_bus_50:1",
          "sourceRouteId": "vilnius_bus_50",
          "sourceShapeId": "vilnius_bus_50_b-a",
          "directionId": 1,
          "headsign": "Antakalnis",
          "directionName": "Bajorai–Baltupio–Didlaukio g.–Antakalnis",
          "mode": "bus",
          "routeShortName": "50",
          "routeLongName": "Antakalnis–Didlaukio g.–Baltupio g.–Bajorai",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              -1511.847,
              -7679.922,
              0
            ],
            [
              -1492.181,
              -7674.661,
              20.358
            ],
            [
              -1434.4,
              -7647.866,
              84.05
            ],
            [
              -1412.802,
              -7628.215,
              113.249
            ],
            [
              -1311.163,
              -7519.736,
              261.904
            ],
            [
              -1244.231,
              -7455.351,
              354.777
            ],
            [
              -1087.774,
              -7312.331,
              566.752
            ],
            [
              -1078.522,
              -7299.139,
              582.865
            ],
            [
              -1074.419,
              -7273.142,
              609.184
            ],
            [
              -1063.137,
              -7267.132,
              621.967
            ],
            [
              -1045.667,
              -7269.285,
              639.569
            ],
            [
              -1002.208,
              -7280.476,
              684.446
            ],
            [
              -979.66,
              -7279.769,
              707.005
            ],
            [
              -935.71,
              -7270.543,
              751.913
            ],
            [
              -707.406,
              -7214.553,
              986.982
            ],
            [
              -684.153,
              -7210.52,
              1010.583
            ],
            [
              -567.625,
              -7175.894,
              1132.146
            ],
            [
              -600.3,
              -7135.061,
              1184.444
            ],
            [
              -624.57,
              -7106.612,
              1221.838
            ],
            [
              -899.778,
              -6778.026,
              1650.45
            ],
            [
              -953.071,
              -6698.025,
              1746.577
            ],
            [
              -984.944,
              -6635.356,
              1816.886
            ],
            [
              -1007.952,
              -6579.794,
              1877.023
            ],
            [
              -1020.611,
              -6541.903,
              1916.972
            ],
            [
              -1040.818,
              -6457.097,
              2004.153
            ],
            [
              -1055.577,
              -6320.967,
              2141.08
            ],
            [
              -1048.455,
              -6273.276,
              2189.3
            ],
            [
              -1013.163,
              -5994.489,
              2470.312
            ],
            [
              -983.421,
              -5799.754,
              2667.305
            ],
            [
              -976.395,
              -5776.958,
              2691.159
            ],
            [
              -917.287,
              -5570.961,
              2905.469
            ],
            [
              -886.888,
              -5421.223,
              3058.261
            ],
            [
              -884.178,
              -5399.29,
              3080.361
            ],
            [
              -887.614,
              -5390.039,
              3090.23
            ],
            [
              -881.963,
              -5370.3,
              3110.761
            ],
            [
              -880.613,
              -5358.995,
              3122.147
            ],
            [
              -871.302,
              -5283.486,
              3198.228
            ],
            [
              -867.295,
              -5263.497,
              3218.615
            ],
            [
              -873.84,
              -5126.451,
              3355.817
            ],
            [
              -873.198,
              -5090.839,
              3391.435
            ],
            [
              -867.363,
              -5053.094,
              3429.628
            ],
            [
              -847.141,
              -4967.74,
              3517.345
            ],
            [
              -716.635,
              -4519.236,
              3984.451
            ],
            [
              -646.885,
              -4514.933,
              4054.333
            ],
            [
              -568.48,
              -4520.803,
              4132.958
            ],
            [
              -439.606,
              -4519.799,
              4261.836
            ],
            [
              -373.187,
              -4516.551,
              4328.334
            ],
            [
              -303.365,
              -4503.347,
              4399.393
            ],
            [
              -273.394,
              -4484.966,
              4434.552
            ],
            [
              -264.248,
              -4475.971,
              4447.38
            ],
            [
              -247.988,
              -4462.621,
              4468.418
            ],
            [
              -206.653,
              -4415.152,
              4531.362
            ],
            [
              -184.743,
              -4390.249,
              4564.531
            ],
            [
              -166.1,
              -4374.591,
              4588.878
            ],
            [
              -152.82,
              -4365.759,
              4604.826
            ],
            [
              -100.827,
              -4348.95,
              4659.469
            ],
            [
              -72.436,
              -4347.387,
              4687.903
            ],
            [
              -23.573,
              -4348.894,
              4736.789
            ],
            [
              35.061,
              -4351.207,
              4795.468
            ],
            [
              46.147,
              -4344.95,
              4808.198
            ],
            [
              48.454,
              -4310.97,
              4842.256
            ],
            [
              52.989,
              -4285.429,
              4868.197
            ],
            [
              60.111,
              -4250.579,
              4903.767
            ],
            [
              104.143,
              -4062.131,
              5097.291
            ],
            [
              127.703,
              -3998.463,
              5165.179
            ],
            [
              151.352,
              -3953.466,
              5216.012
            ],
            [
              179.07,
              -3910.986,
              5266.735
            ],
            [
              264.038,
              -3810.121,
              5398.619
            ],
            [
              345.157,
              -3743.697,
              5503.463
            ],
            [
              387.493,
              -3689.441,
              5572.282
            ],
            [
              434.283,
              -3627.326,
              5650.049
            ],
            [
              450.253,
              -3599.787,
              5681.883
            ],
            [
              463.769,
              -3565.524,
              5718.716
            ],
            [
              474.065,
              -3531.203,
              5754.548
            ],
            [
              484.063,
              -3477.95,
              5808.731
            ],
            [
              490.334,
              -3345.62,
              5941.21
            ],
            [
              488.575,
              -3319.869,
              5967.02
            ],
            [
              479.687,
              -3259.675,
              6027.867
            ],
            [
              477.905,
              -3216.226,
              6071.353
            ],
            [
              481.339,
              -3169.533,
              6118.172
            ],
            [
              500.602,
              -3103.091,
              6187.35
            ],
            [
              504.082,
              -3078.362,
              6212.323
            ],
            [
              504.445,
              -3034.141,
              6256.545
            ],
            [
              503.491,
              -2980.688,
              6310.007
            ],
            [
              505.751,
              -2962.917,
              6327.921
            ],
            [
              504.844,
              -2912.819,
              6378.027
            ],
            [
              509.397,
              -2869.472,
              6421.612
            ],
            [
              513.301,
              -2797.183,
              6494.007
            ],
            [
              494.515,
              -2626.513,
              6665.708
            ],
            [
              487.991,
              -2601.316,
              6691.736
            ],
            [
              485.911,
              -2568.466,
              6724.651
            ],
            [
              462.343,
              -2342.047,
              6952.294
            ],
            [
              451.425,
              -2269.486,
              7025.671
            ],
            [
              407.333,
              -2116.119,
              7185.25
            ],
            [
              406.254,
              -2096.107,
              7205.292
            ],
            [
              361.405,
              -1904.922,
              7401.667
            ],
            [
              342.249,
              -1718.661,
              7588.91
            ],
            [
              510.658,
              -1710.612,
              7757.511
            ],
            [
              550.922,
              -1706.707,
              7797.965
            ],
            [
              586.765,
              -1697.182,
              7835.051
            ],
            [
              616.278,
              -1681.379,
              7868.529
            ],
            [
              662.58,
              -1757.929,
              7957.993
            ],
            [
              698.331,
              -1741.887,
              7997.178
            ],
            [
              729.45,
              -1732.439,
              8029.7
            ],
            [
              759.842,
              -1727.432,
              8060.501
            ],
            [
              793.978,
              -1729.173,
              8094.682
            ],
            [
              896.556,
              -1753.755,
              8200.164
            ],
            [
              910.678,
              -1757.912,
              8214.885
            ],
            [
              1359.255,
              -1888.307,
              8682.03
            ],
            [
              1407.551,
              -1902.564,
              8732.386
            ],
            [
              1546.604,
              -1941.398,
              8876.76
            ],
            [
              1594.695,
              -1951.324,
              8925.865
            ],
            [
              1677.147,
              -1950.75,
              9008.319
            ],
            [
              1724.96,
              -1945.743,
              9056.393
            ],
            [
              1982.08,
              -1904.808,
              9316.752
            ],
            [
              2058.828,
              -1881.42,
              9396.984
            ],
            [
              2066.336,
              -1880.775,
              9404.52
            ],
            [
              2070.784,
              -1884.198,
              9410.132
            ],
            [
              2081.808,
              -1938.356,
              9465.401
            ],
            [
              2087.374,
              -1962.435,
              9490.115
            ],
            [
              2110.719,
              -2024.1,
              9556.051
            ],
            [
              2234.812,
              -2316.979,
              9874.135
            ],
            [
              2284.924,
              -2429.242,
              9997.074
            ],
            [
              2299.015,
              -2468.47,
              10038.756
            ],
            [
              2319.691,
              -2569.05,
              10141.44
            ],
            [
              2323.471,
              -2587.599,
              10160.37
            ],
            [
              2323.492,
              -2606.972,
              10179.743
            ],
            [
              2328.687,
              -2639.354,
              10212.539
            ],
            [
              2411.872,
              -3118.499,
              10698.851
            ],
            [
              2415.738,
              -3139.252,
              10719.961
            ],
            [
              2418.768,
              -3163.158,
              10744.058
            ],
            [
              2474.472,
              -3526.012,
              11111.163
            ],
            [
              2513.109,
              -3664.781,
              11255.211
            ],
            [
              2520.474,
              -3683.355,
              11275.192
            ],
            [
              2553.555,
              -3775.753,
              11373.333
            ],
            [
              2558.505,
              -3824.161,
              11421.994
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:370",
              "position": {
                "x": -1512.213,
                "z": -7678.755
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 1.223,
              "arrivalOffsetSeconds": -480,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:7052",
              "position": {
                "x": -1045.114,
                "z": -7267.457
              },
              "distanceAlongShapeM": 639.649,
              "shapeOffsetM": 1.908,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:6778",
              "position": {
                "x": -604.294,
                "z": -7138.492
              },
              "distanceAlongShapeM": 1184.26,
              "shapeOffsetM": 5.262,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:6776",
              "position": {
                "x": -1058.33,
                "z": -6320.967
              },
              "distanceAlongShapeM": 2141.08,
              "shapeOffsetM": 2.753,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:6774",
              "position": {
                "x": -985.81,
                "z": -5799.053
              },
              "distanceAlongShapeM": 2667.305,
              "shapeOffsetM": 2.489,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:348",
              "position": {
                "x": -871.52,
                "z": -5283.459
              },
              "distanceAlongShapeM": 3198.228,
              "shapeOffsetM": 0.219,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:5833",
              "position": {
                "x": -646.915,
                "z": -4511.591
              },
              "distanceAlongShapeM": 4054.333,
              "shapeOffsetM": 3.342,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:5836",
              "position": {
                "x": 49.82,
                "z": -4284.902
              },
              "distanceAlongShapeM": 4868.162,
              "shapeOffsetM": 3.212,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:5839",
              "position": {
                "x": 148.043,
                "z": -3951.609
              },
              "distanceAlongShapeM": 5216.012,
              "shapeOffsetM": 3.794,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:5846",
              "position": {
                "x": 383.579,
                "z": -3686.512
              },
              "distanceAlongShapeM": 5572.184,
              "shapeOffsetM": 4.888,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:5481",
              "position": {
                "x": 502.159,
                "z": -2912.756
              },
              "distanceAlongShapeM": 6378.027,
              "shapeOffsetM": 2.686,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:5347",
              "position": {
                "x": 482.722,
                "z": -2601.805
              },
              "distanceAlongShapeM": 6691.736,
              "shapeOffsetM": 5.291,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:5351",
              "position": {
                "x": 407.176,
                "z": -2116.162
              },
              "distanceAlongShapeM": 7185.25,
              "shapeOffsetM": 0.163,
              "arrivalOffsetSeconds": 1380,
              "departureOffsetSeconds": 1380
            },
            {
              "stopId": "judu:stop:7044",
              "position": {
                "x": 914.226,
                "z": -1745.858
              },
              "distanceAlongShapeM": 8214.928,
              "shapeOffsetM": 12.565,
              "arrivalOffsetSeconds": 1680,
              "departureOffsetSeconds": 1680
            },
            {
              "stopId": "judu:stop:7043",
              "position": {
                "x": 1361.731,
                "z": -1879.919
              },
              "distanceAlongShapeM": 8682.03,
              "shapeOffsetM": 8.746,
              "arrivalOffsetSeconds": 1740,
              "departureOffsetSeconds": 1740
            },
            {
              "stopId": "judu:stop:5092",
              "position": {
                "x": 2087.852,
                "z": -1936.84
              },
              "distanceAlongShapeM": 9465.121,
              "shapeOffsetM": 6.225,
              "arrivalOffsetSeconds": 1980,
              "departureOffsetSeconds": 1980
            },
            {
              "stopId": "judu:stop:5095",
              "position": {
                "x": 2327.089,
                "z": -2587.001
              },
              "distanceAlongShapeM": 10160.37,
              "shapeOffsetM": 3.667,
              "arrivalOffsetSeconds": 2100,
              "departureOffsetSeconds": 2100
            },
            {
              "stopId": "judu:stop:1035",
              "position": {
                "x": 2419.872,
                "z": -3138.687
              },
              "distanceAlongShapeM": 10719.961,
              "shapeOffsetM": 4.173,
              "arrivalOffsetSeconds": 2220,
              "departureOffsetSeconds": 2220
            },
            {
              "stopId": "judu:stop:6711",
              "position": {
                "x": 2522.438,
                "z": -3682.768
              },
              "distanceAlongShapeM": 11275.301,
              "shapeOffsetM": 2.047,
              "arrivalOffsetSeconds": 2340,
              "departureOffsetSeconds": 2340
            },
            {
              "stopId": "judu:stop:5483",
              "position": {
                "x": 2562.319,
                "z": -3823.788
              },
              "distanceAlongShapeM": 11421.994,
              "shapeOffsetM": 3.832,
              "arrivalOffsetSeconds": 2340,
              "departureOffsetSeconds": 2340
            }
          ],
          "departuresSeconds": [
            18840,
            20220,
            21240,
            22560,
            23880,
            24840,
            25800,
            26880,
            28680,
            30360,
            31260,
            32400,
            33540,
            34920,
            37140,
            38880,
            40560,
            42240,
            44460,
            46320,
            48120,
            50040,
            52020,
            53940,
            56220,
            58440,
            60600,
            62040,
            63300,
            64500,
            65700,
            67380,
            69180,
            70620,
            72240,
            73860,
            75720,
            77700,
            79500,
            81240,
            83220,
            85140
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_bus_52",
      "sourceRouteId": "vilnius_bus_52",
      "mode": "bus",
      "shortName": "52",
      "longName": "Tarandė–Ukmergės g.–Pašilaičiai",
      "color": "0073AC",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_bus_52:0",
          "sourceRouteId": "vilnius_bus_52",
          "sourceShapeId": "vilnius_bus_52_a-b",
          "directionId": 0,
          "headsign": "Pašilaičiai",
          "directionName": "Tarandė–Ukmergės g.–Pašilaičiai",
          "mode": "bus",
          "routeShortName": "52",
          "routeLongName": "Tarandė–Ukmergės g.–Pašilaičiai",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              -6368.671,
              -6679.171,
              0
            ],
            [
              -6335.694,
              -6571.256,
              112.84
            ],
            [
              -6269.862,
              -6452.761,
              248.395
            ],
            [
              -6260.074,
              -6393.946,
              308.019
            ],
            [
              -6260.793,
              -6324.936,
              377.032
            ],
            [
              -6249.298,
              -6282.051,
              421.431
            ],
            [
              -6223.186,
              -6292.712,
              449.636
            ],
            [
              -6120.237,
              -6325.041,
              557.541
            ],
            [
              -5947.275,
              -6373.916,
              737.277
            ],
            [
              -5905.84,
              -6386.066,
              780.455
            ],
            [
              -5858.718,
              -6398.339,
              829.15
            ],
            [
              -5806.219,
              -6397.477,
              881.656
            ],
            [
              -5640.172,
              -6381.712,
              1048.45
            ],
            [
              -5593.332,
              -6384.461,
              1095.37
            ],
            [
              -5527.298,
              -6410.792,
              1166.461
            ],
            [
              -5458.944,
              -6443.125,
              1242.076
            ],
            [
              -5399.402,
              -6463.529,
              1305.017
            ],
            [
              -5211.984,
              -6537.509,
              1506.508
            ],
            [
              -5121.385,
              -6569.041,
              1602.437
            ],
            [
              -5003.983,
              -6600.273,
              1723.923
            ],
            [
              -4998.984,
              -6601.569,
              1729.087
            ],
            [
              -4726.851,
              -6673.846,
              2010.654
            ],
            [
              -4625.048,
              -6710.372,
              2118.812
            ],
            [
              -4568.082,
              -6727.787,
              2178.38
            ],
            [
              -4573.857,
              -6726.575,
              2184.281
            ],
            [
              -4504.62,
              -6746.311,
              2256.276
            ],
            [
              -4487.176,
              -6735.541,
              2276.777
            ],
            [
              -4289.756,
              -6793.82,
              2482.619
            ],
            [
              -4289.103,
              -6798.996,
              2487.837
            ],
            [
              -4295.395,
              -6800.796,
              2494.381
            ],
            [
              -4300.296,
              -6801.962,
              2499.419
            ],
            [
              -4302.229,
              -6844.812,
              2542.312
            ],
            [
              -4281.614,
              -6879.294,
              2582.486
            ],
            [
              -4297.05,
              -6902.552,
              2610.4
            ],
            [
              -4318.547,
              -6930.646,
              2645.776
            ],
            [
              -4327.424,
              -6937.896,
              2657.237
            ],
            [
              -4331.095,
              -6940.582,
              2661.786
            ],
            [
              -4333.111,
              -6942.057,
              2664.283
            ],
            [
              -4318.171,
              -6935.611,
              2680.554
            ],
            [
              -4302.855,
              -6918.273,
              2703.688
            ],
            [
              -4250.009,
              -6841.262,
              2797.087
            ],
            [
              -4210.931,
              -6778.485,
              2871.033
            ],
            [
              -4136.26,
              -6668.457,
              3004.007
            ],
            [
              -4095.853,
              -6603.478,
              3080.525
            ],
            [
              -4041.159,
              -6457.482,
              3236.429
            ],
            [
              -4021.737,
              -6414.403,
              3283.684
            ],
            [
              -3991.253,
              -6364.838,
              3341.873
            ],
            [
              -3967.007,
              -6340.768,
              3376.038
            ],
            [
              -3878.933,
              -6275.505,
              3485.657
            ],
            [
              -3859.174,
              -6250.244,
              3517.727
            ],
            [
              -3803.68,
              -6169.945,
              3615.336
            ],
            [
              -3744.108,
              -6077.471,
              3725.338
            ],
            [
              -3618.634,
              -5899.316,
              3943.243
            ],
            [
              -3485.286,
              -5750.246,
              4143.252
            ],
            [
              -3386.562,
              -5629.518,
              4299.206
            ],
            [
              -3374.401,
              -5614.415,
              4318.597
            ],
            [
              -3246.721,
              -5478.341,
              4505.193
            ],
            [
              -3136.921,
              -5351.132,
              4673.236
            ],
            [
              -3134.15,
              -5340.049,
              4684.66
            ],
            [
              -3152.804,
              -5301.872,
              4727.15
            ],
            [
              -3167.166,
              -5276.016,
              4756.727
            ],
            [
              -3174.738,
              -5266.977,
              4768.519
            ],
            [
              -3216.809,
              -5241.749,
              4817.574
            ],
            [
              -3284.068,
              -5215.356,
              4889.827
            ],
            [
              -3283.763,
              -5202.727,
              4902.459
            ],
            [
              -3276.308,
              -5192.767,
              4914.9
            ],
            [
              -3269.86,
              -5189.502,
              4922.128
            ],
            [
              -3251.909,
              -5200.004,
              4942.926
            ],
            [
              -3237.885,
              -5231.361,
              4977.275
            ],
            [
              -3198.857,
              -5246.517,
              5019.143
            ],
            [
              -3170.932,
              -5270.384,
              5055.878
            ],
            [
              -3134.21,
              -5337.848,
              5132.689
            ],
            [
              -3123.704,
              -5346.5,
              5146.298
            ],
            [
              -3113.758,
              -5352.652,
              5157.993
            ],
            [
              -3083.903,
              -5376.554,
              5196.238
            ],
            [
              -3052.839,
              -5404.93,
              5238.311
            ],
            [
              -3047.2,
              -5413.934,
              5248.935
            ],
            [
              -3035.925,
              -5397.775,
              5268.639
            ],
            [
              -3033.871,
              -5388.564,
              5278.076
            ],
            [
              -2977.67,
              -5306.06,
              5377.903
            ],
            [
              -2859.367,
              -5119.841,
              5598.523
            ],
            [
              -2787.712,
              -4995.277,
              5742.226
            ],
            [
              -2737.802,
              -4912.753,
              5838.669
            ],
            [
              -2678.162,
              -4832.649,
              5938.537
            ],
            [
              -2610.202,
              -4778.187,
              6025.627
            ],
            [
              -2593.143,
              -4760.677,
              6050.073
            ],
            [
              -2552.209,
              -4687.52,
              6133.903
            ],
            [
              -2531.088,
              -4688.482,
              6155.046
            ],
            [
              -2496.061,
              -4698.938,
              6191.601
            ],
            [
              -2442.961,
              -4719.916,
              6248.694
            ],
            [
              -2407.854,
              -4738.349,
              6288.346
            ],
            [
              -2377.9,
              -4756.69,
              6323.469
            ],
            [
              -2360.748,
              -4770.353,
              6345.398
            ],
            [
              -2299.967,
              -4830.431,
              6430.86
            ],
            [
              -2284.937,
              -4818.452,
              6450.079
            ],
            [
              -2261.864,
              -4788.804,
              6487.648
            ],
            [
              -2246.649,
              -4770.794,
              6511.224
            ],
            [
              -2217.023,
              -4730.598,
              6561.158
            ],
            [
              -2199.094,
              -4664.123,
              6630.009
            ],
            [
              -2245.097,
              -4651.92,
              6677.603
            ],
            [
              -2265.103,
              -4648.113,
              6697.968
            ],
            [
              -2319.72,
              -4636.38,
              6753.831
            ],
            [
              -2647.123,
              -4570.476,
              7087.801
            ],
            [
              -2704.754,
              -4550.534,
              7148.785
            ],
            [
              -2779.661,
              -4504.275,
              7236.824
            ],
            [
              -2804.191,
              -4483.318,
              7269.087
            ],
            [
              -2836.311,
              -4448.027,
              7316.807
            ],
            [
              -2848.061,
              -4456.725,
              7331.426
            ],
            [
              -2857.336,
              -4455.944,
              7340.733
            ],
            [
              -2898.02,
              -4403.939,
              7406.762
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:7615",
              "position": {
                "x": -6372.183,
                "z": -6678.131
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 3.663,
              "arrivalOffsetSeconds": -120,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:8445",
              "position": {
                "x": -6222.02,
                "z": -6288.814
              },
              "distanceAlongShapeM": 449.242,
              "shapeOffsetM": 4.049,
              "arrivalOffsetSeconds": 60,
              "departureOffsetSeconds": 60
            },
            {
              "stopId": "judu:stop:8046",
              "position": {
                "x": -5904.144,
                "z": -6379.903
              },
              "distanceAlongShapeM": 780.349,
              "shapeOffsetM": 6.391,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:18905",
              "position": {
                "x": -5398.05,
                "z": -6459.748
              },
              "distanceAlongShapeM": 1305.017,
              "shapeOffsetM": 4.015,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:8048",
              "position": {
                "x": -5003.068,
                "z": -6596.745
              },
              "distanceAlongShapeM": 1723.9,
              "shapeOffsetM": 3.645,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:8043",
              "position": {
                "x": -4623.743,
                "z": -6706.791
              },
              "distanceAlongShapeM": 2119.013,
              "shapeOffsetM": 3.806,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:18824",
              "position": {
                "x": -4302.229,
                "z": -6844.812
              },
              "distanceAlongShapeM": 2542.312,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:7077",
              "position": {
                "x": -3618.634,
                "z": -5899.316
              },
              "distanceAlongShapeM": 3943.243,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:9153",
              "position": {
                "x": -3375.968,
                "z": -5613.005
              },
              "distanceAlongShapeM": 4318.597,
              "shapeOffsetM": 2.109,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:795",
              "position": {
                "x": -3249.554,
                "z": -5198.873
              },
              "distanceAlongShapeM": 4942.926,
              "shapeOffsetM": 2.613,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:7809",
              "position": {
                "x": -3033.871,
                "z": -5388.564
              },
              "distanceAlongShapeM": 5278.076,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:5518",
              "position": {
                "x": -2739.468,
                "z": -4911.72
              },
              "distanceAlongShapeM": 5838.669,
              "shapeOffsetM": 1.96,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:5803",
              "position": {
                "x": -2249.272,
                "z": -4768.989
              },
              "distanceAlongShapeM": 6510.91,
              "shapeOffsetM": 3.168,
              "arrivalOffsetSeconds": 1380,
              "departureOffsetSeconds": 1380
            },
            {
              "stopId": "judu:stop:8269",
              "position": {
                "x": -2245.99,
                "z": -4656.611
              },
              "distanceAlongShapeM": 6677.263,
              "shapeOffsetM": 4.764,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            },
            {
              "stopId": "judu:stop:6766",
              "position": {
                "x": -2809.985,
                "z": -4489.679
              },
              "distanceAlongShapeM": 7269.087,
              "shapeOffsetM": 8.604,
              "arrivalOffsetSeconds": 1560,
              "departureOffsetSeconds": 1560
            },
            {
              "stopId": "judu:stop:8275",
              "position": {
                "x": -2897.378,
                "z": -4403.536
              },
              "distanceAlongShapeM": 7406.683,
              "shapeOffsetM": 0.754,
              "arrivalOffsetSeconds": 1560,
              "departureOffsetSeconds": 1560
            }
          ],
          "departuresSeconds": [
            19680,
            20880,
            21720,
            22380,
            23520,
            24000,
            24720,
            25620,
            26400,
            28260,
            34260,
            35880,
            36960,
            38520,
            40080,
            41220,
            42840,
            44400,
            45600,
            47220,
            48600,
            49860,
            51480,
            52860,
            54120,
            55740,
            57120,
            58380,
            59280,
            60120,
            60960,
            61740,
            63120,
            64140,
            65820,
            69060,
            70500,
            71760,
            72960,
            74160,
            75840,
            77280,
            78720,
            80160,
            81600,
            83040,
            84600
          ]
        },
        {
          "id": "judu:pattern:vilnius_bus_52:1",
          "sourceRouteId": "vilnius_bus_52",
          "sourceShapeId": "vilnius_bus_52_b-a",
          "directionId": 1,
          "headsign": "Tarandė",
          "directionName": "Pašilaičiai–Ukmergės g.–Tarandė",
          "mode": "bus",
          "routeShortName": "52",
          "routeLongName": "Tarandė–Ukmergės g.–Pašilaičiai",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              -2898.02,
              -4403.939,
              0
            ],
            [
              -2891.133,
              -4414.778,
              12.842
            ],
            [
              -2898.042,
              -4404.638,
              25.112
            ],
            [
              -2903.849,
              -4391.241,
              39.714
            ],
            [
              -2903.934,
              -4373.364,
              57.591
            ],
            [
              -2922.066,
              -4325.629,
              108.654
            ],
            [
              -2937.753,
              -4244.749,
              191.041
            ],
            [
              -2944.718,
              -4164.475,
              271.616
            ],
            [
              -2922.72,
              -4159.295,
              294.216
            ],
            [
              -2920.043,
              -4206.629,
              341.626
            ],
            [
              -2916.033,
              -4240.012,
              375.249
            ],
            [
              -2908.744,
              -4273.666,
              409.683
            ],
            [
              -2894.838,
              -4317.386,
              455.561
            ],
            [
              -2876.57,
              -4356.153,
              498.417
            ],
            [
              -2823.799,
              -4432.662,
              591.36
            ],
            [
              -2759.103,
              -4490.576,
              678.191
            ],
            [
              -2703.07,
              -4524.178,
              743.527
            ],
            [
              -2600.663,
              -4562.712,
              852.944
            ],
            [
              -2523.056,
              -4586.026,
              933.977
            ],
            [
              -2471.67,
              -4594.727,
              986.094
            ],
            [
              -2274.597,
              -4634.953,
              1187.231
            ],
            [
              -2190.603,
              -4657.594,
              1274.223
            ],
            [
              -2203.301,
              -4719.709,
              1337.622
            ],
            [
              -2218.687,
              -4751.72,
              1373.139
            ],
            [
              -2225.08,
              -4761.952,
              1385.204
            ],
            [
              -2268.035,
              -4809.846,
              1449.539
            ],
            [
              -2298.015,
              -4829.352,
              1485.306
            ],
            [
              -2351.324,
              -4783.879,
              1555.375
            ],
            [
              -2378.887,
              -4764.376,
              1589.14
            ],
            [
              -2406.02,
              -4743.947,
              1623.104
            ],
            [
              -2443.585,
              -4718.791,
              1668.314
            ],
            [
              -2496.725,
              -4700.04,
              1724.665
            ],
            [
              -2552.315,
              -4687.753,
              1781.597
            ],
            [
              -2573.291,
              -4730.97,
              1829.635
            ],
            [
              -2592.46,
              -4758.462,
              1863.15
            ],
            [
              -2618.048,
              -4784.728,
              1899.82
            ],
            [
              -2673.576,
              -4828.277,
              1970.388
            ],
            [
              -2687.375,
              -4843.619,
              1991.023
            ],
            [
              -2713.178,
              -4882.126,
              2037.375
            ],
            [
              -2770.874,
              -4975.733,
              2147.335
            ],
            [
              -2809.655,
              -5040.042,
              2222.432
            ],
            [
              -2859.367,
              -5119.841,
              2316.449
            ],
            [
              -3038.848,
              -5415.194,
              2662.06
            ],
            [
              -3072.82,
              -5405.692,
              2697.336
            ],
            [
              -3098.772,
              -5379.632,
              2734.114
            ],
            [
              -3115.924,
              -5365.973,
              2756.04
            ],
            [
              -3137.233,
              -5332.202,
              2795.972
            ],
            [
              -3160.824,
              -5281.693,
              2851.719
            ],
            [
              -3174.738,
              -5266.977,
              2871.971
            ],
            [
              -3209.14,
              -5245.223,
              2912.674
            ],
            [
              -3278.903,
              -5219.51,
              2987.025
            ],
            [
              -3281.476,
              -5213.213,
              2993.827
            ],
            [
              -3283.119,
              -5202.738,
              3004.43
            ],
            [
              -3277.85,
              -5196.151,
              3012.865
            ],
            [
              -3271.313,
              -5190.699,
              3021.378
            ],
            [
              -3262.297,
              -5190.857,
              3030.395
            ],
            [
              -3251.909,
              -5200.004,
              3044.236
            ],
            [
              -3223.815,
              -5237.173,
              3090.828
            ],
            [
              -3186.173,
              -5257.871,
              3133.785
            ],
            [
              -3160.161,
              -5280.592,
              3168.323
            ],
            [
              -3134.091,
              -5336.71,
              3230.201
            ],
            [
              -3130.596,
              -5356.766,
              3250.559
            ],
            [
              -3176.747,
              -5418.34,
              3327.509
            ],
            [
              -3342.875,
              -5612.201,
              3582.814
            ],
            [
              -3386.425,
              -5658.464,
              3646.35
            ],
            [
              -3498.767,
              -5784.52,
              3815.202
            ],
            [
              -3581.293,
              -5888.171,
              3947.693
            ],
            [
              -3613.93,
              -5925.003,
              3996.905
            ],
            [
              -3668.235,
              -5993.496,
              4084.314
            ],
            [
              -3747.187,
              -6106.361,
              4222.052
            ],
            [
              -3835.101,
              -6236.191,
              4378.848
            ],
            [
              -4223.914,
              -6821.676,
              5081.676
            ],
            [
              -4263.049,
              -6887.792,
              5158.506
            ],
            [
              -4344.083,
              -6993.674,
              5291.839
            ],
            [
              -4354.382,
              -6988.934,
              5303.176
            ],
            [
              -4341.106,
              -6953.222,
              5341.276
            ],
            [
              -4332.907,
              -6941.908,
              5355.248
            ],
            [
              -4344.052,
              -6842.976,
              5454.806
            ],
            [
              -4337.678,
              -6793.139,
              5505.049
            ],
            [
              -4364.279,
              -6782.583,
              5533.667
            ],
            [
              -4487.817,
              -6739.186,
              5664.606
            ],
            [
              -4534.079,
              -6735.053,
              5711.052
            ],
            [
              -4573.713,
              -6728.008,
              5751.308
            ],
            [
              -4715.898,
              -6679.621,
              5901.5
            ],
            [
              -4730.005,
              -6674.691,
              5916.444
            ],
            [
              -4796.638,
              -6655.583,
              5985.763
            ],
            [
              -5089.946,
              -6579.812,
              6288.7
            ],
            [
              -5461.191,
              -6442.648,
              6684.474
            ],
            [
              -5550.53,
              -6400.477,
              6783.265
            ],
            [
              -5600.255,
              -6383.947,
              6835.666
            ],
            [
              -5647.851,
              -6382.338,
              6883.289
            ],
            [
              -5829.804,
              -6399.02,
              7066.005
            ],
            [
              -5884.89,
              -6393.482,
              7121.369
            ],
            [
              -6248.716,
              -6287.182,
              7500.405
            ],
            [
              -6259.15,
              -6327.06,
              7541.625
            ],
            [
              -6260.204,
              -6371.75,
              7586.328
            ],
            [
              -6262.188,
              -6430.559,
              7645.17
            ],
            [
              -6271.187,
              -6454.965,
              7671.182
            ],
            [
              -6332.99,
              -6568.584,
              7800.523
            ],
            [
              -6449.205,
              -6506.481,
              7932.29
            ],
            [
              -6534.103,
              -6655.804,
              8104.06
            ],
            [
              -6529.358,
              -6663.907,
              8113.449
            ],
            [
              -6411.863,
              -6701.954,
              8236.951
            ],
            [
              -6386.002,
              -6707.611,
              8263.424
            ],
            [
              -6374.187,
              -6697.809,
              8278.776
            ],
            [
              -6368.671,
              -6679.171,
              8298.213
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:6653",
              "position": {
                "x": -2914.524,
                "z": -4206.195
              },
              "distanceAlongShapeM": 341.853,
              "shapeOffsetM": 5.531,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:8268",
              "position": {
                "x": -2701.004,
                "z": -4520.544
              },
              "distanceAlongShapeM": 744.18,
              "shapeOffsetM": 4.129,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:8270",
              "position": {
                "x": -2222.124,
                "z": -4763.905
              },
              "distanceAlongShapeM": 1385.204,
              "shapeOffsetM": 3.543,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:6763",
              "position": {
                "x": -2381.317,
                "z": -4767.762
              },
              "distanceAlongShapeM": 1589.14,
              "shapeOffsetM": 4.167,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:5519",
              "position": {
                "x": -2803.001,
                "z": -5044.187
              },
              "distanceAlongShapeM": 2222.432,
              "shapeOffsetM": 7.839,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:795",
              "position": {
                "x": -3249.554,
                "z": -5198.873
              },
              "distanceAlongShapeM": 3044.754,
              "shapeOffsetM": 2.561,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:9152",
              "position": {
                "x": -3341.197,
                "z": -5613.613
              },
              "distanceAlongShapeM": 3582.794,
              "shapeOffsetM": 2.193,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:7076",
              "position": {
                "x": -3580.452,
                "z": -5888.85
              },
              "distanceAlongShapeM": 3947.693,
              "shapeOffsetM": 1.08,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            },
            {
              "stopId": "judu:stop:18904",
              "position": {
                "x": -4364.256,
                "z": -6782.513
              },
              "distanceAlongShapeM": 5533.669,
              "shapeOffsetM": 0.073,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:8044",
              "position": {
                "x": -4732.817,
                "z": -6683.762
              },
              "distanceAlongShapeM": 5916.105,
              "shapeOffsetM": 9.491,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            },
            {
              "stopId": "judu:stop:19134",
              "position": {
                "x": -5091.073,
                "z": -6584.106
              },
              "distanceAlongShapeM": 6288.7,
              "shapeOffsetM": 4.439,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            },
            {
              "stopId": "judu:stop:19136",
              "position": {
                "x": -5462.201,
                "z": -6445.296
              },
              "distanceAlongShapeM": 6684.474,
              "shapeOffsetM": 2.834,
              "arrivalOffsetSeconds": 1500,
              "departureOffsetSeconds": 1500
            },
            {
              "stopId": "judu:stop:19137",
              "position": {
                "x": -5885.757,
                "z": -6396.912
              },
              "distanceAlongShapeM": 7121.369,
              "shapeOffsetM": 3.538,
              "arrivalOffsetSeconds": 1560,
              "departureOffsetSeconds": 1560
            },
            {
              "stopId": "judu:stop:8444",
              "position": {
                "x": -6256.261,
                "z": -6371.727
              },
              "distanceAlongShapeM": 7586.212,
              "shapeOffsetM": 3.941,
              "arrivalOffsetSeconds": 1620,
              "departureOffsetSeconds": 1620
            },
            {
              "stopId": "judu:stop:8447",
              "position": {
                "x": -6522.222,
                "z": -6639.985
              },
              "distanceAlongShapeM": 8084.436,
              "shapeOffsetM": 2.509,
              "arrivalOffsetSeconds": 1740,
              "departureOffsetSeconds": 1740
            },
            {
              "stopId": "judu:stop:7615",
              "position": {
                "x": -6372.183,
                "z": -6678.131
              },
              "distanceAlongShapeM": 8298.213,
              "shapeOffsetM": 3.663,
              "arrivalOffsetSeconds": 1740,
              "departureOffsetSeconds": 1740
            }
          ],
          "departuresSeconds": [
            21780,
            22980,
            23880,
            24660,
            25920,
            26460,
            27360,
            28260,
            29340,
            30960,
            32280,
            33900,
            35040,
            36600,
            38100,
            39240,
            40800,
            42360,
            43560,
            45240,
            46620,
            47880,
            49500,
            50880,
            52140,
            53760,
            55080,
            56340,
            57240,
            58080,
            58860,
            59640,
            61020,
            62040,
            62880,
            63720,
            64500,
            65880,
            67080,
            68520,
            69840,
            71100,
            72300,
            73980,
            75420,
            76860,
            78300,
            79740,
            81240,
            82800
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_bus_53",
      "sourceRouteId": "vilnius_bus_53",
      "mode": "bus",
      "shortName": "53",
      "longName": "Fabijoniškės–Kalvarijų–Pylimo g.–Stotis",
      "color": "0073AC",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_bus_53:0",
          "sourceRouteId": "vilnius_bus_53",
          "sourceShapeId": "vilnius_bus_53_a-b",
          "directionId": 0,
          "headsign": "Stotis",
          "directionName": "Fabijoniškės–Kalvarijų–Pylimo g.–Stotis",
          "mode": "bus",
          "routeShortName": "53",
          "routeLongName": "Fabijoniškės–Kalvarijų–Pylimo g.–Stotis",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              -2480.761,
              -5727.829,
              0
            ],
            [
              -2465.38,
              -5705.215,
              27.349
            ],
            [
              -2457.131,
              -5687.973,
              46.463
            ],
            [
              -2458.05,
              -5680.376,
              54.116
            ],
            [
              -2467.523,
              -5671.289,
              67.242
            ],
            [
              -2484.515,
              -5648.724,
              95.489
            ],
            [
              -2453.276,
              -5597.994,
              155.066
            ],
            [
              -2437.971,
              -5575.488,
              182.284
            ],
            [
              -2323.024,
              -5404.447,
              388.361
            ],
            [
              -2243.482,
              -5280.09,
              535.981
            ],
            [
              -2221.212,
              -5257.08,
              568.002
            ],
            [
              -2172.788,
              -5214.524,
              632.469
            ],
            [
              -2110.315,
              -5178.897,
              704.386
            ],
            [
              -2057.336,
              -5161.028,
              760.297
            ],
            [
              -2028.76,
              -5156.969,
              789.161
            ],
            [
              -1944.865,
              -5148.443,
              873.488
            ],
            [
              -1856.383,
              -5135.547,
              962.905
            ],
            [
              -1800.644,
              -5116.503,
              1021.807
            ],
            [
              -1770.723,
              -5100.339,
              1055.815
            ],
            [
              -1738.711,
              -5075.306,
              1096.453
            ],
            [
              -1710.503,
              -5046.865,
              1136.51
            ],
            [
              -1676.24,
              -5004.061,
              1191.338
            ],
            [
              -1664.171,
              -4977.559,
              1220.459
            ],
            [
              -1655.392,
              -4950.998,
              1248.433
            ],
            [
              -1638.506,
              -4911.224,
              1291.643
            ],
            [
              -1626.337,
              -4879.158,
              1325.941
            ],
            [
              -1604.435,
              -4807.19,
              1401.167
            ],
            [
              -1592.551,
              -4755.08,
              1454.615
            ],
            [
              -1586.265,
              -4691.738,
              1518.269
            ],
            [
              -1583.358,
              -4637.242,
              1572.842
            ],
            [
              -1588.338,
              -4591.511,
              1618.843
            ],
            [
              -1592.703,
              -4555.313,
              1655.304
            ],
            [
              -1592.123,
              -4561.86,
              1661.876
            ],
            [
              -1595.437,
              -4520.137,
              1703.73
            ],
            [
              -1616.287,
              -4244.797,
              1979.859
            ],
            [
              -1631.856,
              -4106.478,
              2119.051
            ],
            [
              -1635.514,
              -4066.939,
              2158.759
            ],
            [
              -1637.064,
              -4037.365,
              2188.374
            ],
            [
              -1635.048,
              -3960.588,
              2265.177
            ],
            [
              -1628.98,
              -3909.488,
              2316.636
            ],
            [
              -1609.35,
              -3809.976,
              2418.066
            ],
            [
              -1543.192,
              -3688.376,
              2556.498
            ],
            [
              -1515.42,
              -3648.796,
              2604.849
            ],
            [
              -1479.438,
              -3582.647,
              2680.151
            ],
            [
              -1461.972,
              -3542.883,
              2723.582
            ],
            [
              -1437.625,
              -3478.752,
              2792.179
            ],
            [
              -1385.229,
              -3323.838,
              2955.714
            ],
            [
              -1372.596,
              -3266.177,
              3014.743
            ],
            [
              -1370.241,
              -3230.903,
              3050.096
            ],
            [
              -1363.568,
              -3193.979,
              3087.618
            ],
            [
              -1359.808,
              -3163.989,
              3117.842
            ],
            [
              -1360.179,
              -3112.774,
              3169.059
            ],
            [
              -1362.723,
              -3074.878,
              3207.04
            ],
            [
              -1386.134,
              -2978.721,
              3306.006
            ],
            [
              -1409.242,
              -2901.495,
              3386.615
            ],
            [
              -1418.932,
              -2871.362,
              3418.268
            ],
            [
              -1430.357,
              -2820.964,
              3469.944
            ],
            [
              -1448.996,
              -2746.044,
              3547.148
            ],
            [
              -1452.909,
              -2712.577,
              3580.843
            ],
            [
              -1453.659,
              -2682.507,
              3610.923
            ],
            [
              -1443.344,
              -2610.331,
              3683.832
            ],
            [
              -1428.471,
              -2571.635,
              3725.288
            ],
            [
              -1415.77,
              -2546.258,
              3753.666
            ],
            [
              -1386.622,
              -2502.251,
              3806.45
            ],
            [
              -1375.913,
              -2480.178,
              3830.984
            ],
            [
              -1328.533,
              -2508.869,
              3886.373
            ],
            [
              -1293.411,
              -2533.191,
              3929.096
            ],
            [
              -1235.733,
              -2570.637,
              3997.863
            ],
            [
              -1150.916,
              -2621.142,
              4096.578
            ],
            [
              -1079.915,
              -2651.362,
              4173.742
            ],
            [
              -1012.681,
              -2675.949,
              4245.331
            ],
            [
              -916.353,
              -2695.496,
              4343.622
            ],
            [
              -830.758,
              -2702.605,
              4429.512
            ],
            [
              -592.882,
              -2700.223,
              4667.4
            ],
            [
              -320.273,
              -2701.823,
              4940.014
            ],
            [
              -192.234,
              -2714.168,
              5068.646
            ],
            [
              11.208,
              -2748.6,
              5274.981
            ],
            [
              30.399,
              -2753.863,
              5294.881
            ],
            [
              144.816,
              -2787.102,
              5414.028
            ],
            [
              177.432,
              -2801.056,
              5449.504
            ],
            [
              222.629,
              -2831.939,
              5504.245
            ],
            [
              331.278,
              -2917.419,
              5642.489
            ],
            [
              357.389,
              -2934.595,
              5673.743
            ],
            [
              386.802,
              -2947.379,
              5705.814
            ],
            [
              425.203,
              -2957.314,
              5745.479
            ],
            [
              460.267,
              -2963.644,
              5781.11
            ],
            [
              505.751,
              -2962.917,
              5826.6
            ],
            [
              504.844,
              -2912.819,
              5876.706
            ],
            [
              509.397,
              -2869.472,
              5920.291
            ],
            [
              513.301,
              -2797.183,
              5992.686
            ],
            [
              494.515,
              -2626.513,
              6164.386
            ],
            [
              487.991,
              -2601.316,
              6190.415
            ],
            [
              485.911,
              -2568.466,
              6223.33
            ],
            [
              462.343,
              -2342.047,
              6450.973
            ],
            [
              451.425,
              -2269.486,
              6524.35
            ],
            [
              407.333,
              -2116.119,
              6683.929
            ],
            [
              406.254,
              -2096.107,
              6703.971
            ],
            [
              361.405,
              -1904.922,
              6900.346
            ],
            [
              342.249,
              -1718.661,
              7087.589
            ],
            [
              326.222,
              -1640.218,
              7167.652
            ],
            [
              326.097,
              -1614.835,
              7193.036
            ],
            [
              277.22,
              -1255.479,
              7555.701
            ],
            [
              271.867,
              -1230.89,
              7580.866
            ],
            [
              269.371,
              -1219.076,
              7592.941
            ],
            [
              267.28,
              -1199.635,
              7612.494
            ],
            [
              257.056,
              -1141.194,
              7671.822
            ],
            [
              216.915,
              -885.896,
              7930.257
            ],
            [
              226.048,
              -703.492,
              8112.889
            ],
            [
              223.795,
              -685.64,
              8130.883
            ],
            [
              209.218,
              -636.391,
              8182.244
            ],
            [
              192.022,
              -589.321,
              8232.356
            ],
            [
              159.237,
              -513.023,
              8315.4
            ],
            [
              151.725,
              -500.641,
              8329.883
            ],
            [
              143.086,
              -479.332,
              8352.876
            ],
            [
              126.134,
              -439.133,
              8396.504
            ],
            [
              106.146,
              -277.163,
              8559.702
            ],
            [
              46.11,
              -280.522,
              8619.832
            ],
            [
              26.264,
              -279.764,
              8639.692
            ],
            [
              16.623,
              -264.894,
              8657.414
            ],
            [
              14.513,
              -253.218,
              8669.28
            ],
            [
              16.439,
              -245.471,
              8677.262
            ],
            [
              45.916,
              -220.403,
              8715.957
            ],
            [
              103.215,
              -190.277,
              8780.693
            ],
            [
              127.382,
              -102.772,
              8871.474
            ],
            [
              121.848,
              -52.576,
              8921.974
            ],
            [
              118.496,
              -36.512,
              8938.384
            ],
            [
              117.583,
              -3.516,
              8971.393
            ],
            [
              102.671,
              133.684,
              9109.401
            ],
            [
              63.181,
              125.497,
              9149.731
            ],
            [
              59.312,
              125.568,
              9153.6
            ],
            [
              57.419,
              127.829,
              9156.549
            ],
            [
              31.786,
              278.582,
              9309.466
            ],
            [
              4.856,
              358.112,
              9393.432
            ],
            [
              -8.924,
              380.627,
              9419.829
            ],
            [
              -39.768,
              422.378,
              9471.738
            ],
            [
              -46.8,
              425.846,
              9479.578
            ],
            [
              -51.212,
              431.492,
              9486.744
            ],
            [
              -51.307,
              497.175,
              9552.427
            ],
            [
              -54.16,
              522.615,
              9578.026
            ],
            [
              -44.593,
              547.148,
              9604.358
            ],
            [
              -34.25,
              619.32,
              9677.268
            ],
            [
              -34.886,
              726.201,
              9784.151
            ],
            [
              -29.964,
              784,
              9842.159
            ],
            [
              -28.88,
              804.74,
              9862.927
            ],
            [
              -24.076,
              823.969,
              9882.747
            ],
            [
              -6.94,
              914.942,
              9975.32
            ],
            [
              5.94,
              949.218,
              10011.936
            ],
            [
              14.89,
              980.225,
              10044.209
            ],
            [
              20.723,
              1007.284,
              10071.89
            ],
            [
              98.858,
              1127.869,
              10215.576
            ],
            [
              208.532,
              1302.485,
              10421.778
            ],
            [
              265.611,
              1357.493,
              10501.049
            ],
            [
              347.967,
              1416.104,
              10602.132
            ],
            [
              403.761,
              1468.519,
              10678.684
            ],
            [
              407.254,
              1474.663,
              10685.752
            ],
            [
              398.727,
              1481.949,
              10696.969
            ],
            [
              393.766,
              1486.188,
              10703.494
            ],
            [
              391.311,
              1493.238,
              10710.959
            ],
            [
              396.156,
              1548.878,
              10766.81
            ],
            [
              395.449,
              1569.043,
              10786.987
            ],
            [
              397.453,
              1582.184,
              10800.28
            ],
            [
              391.321,
              1670.242,
              10888.551
            ],
            [
              327.595,
              1819.466,
              11050.813
            ],
            [
              328.524,
              1835.034,
              11066.409
            ],
            [
              357.53,
              1884.349,
              11123.622
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:1158",
              "position": {
                "x": -2456.526,
                "z": -5595.784
              },
              "distanceAlongShapeM": 155.066,
              "shapeOffsetM": 3.93,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:6913",
              "position": {
                "x": -2058.363,
                "z": -5155.329
              },
              "distanceAlongShapeM": 760.297,
              "shapeOffsetM": 5.79,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:5813",
              "position": {
                "x": -1657.878,
                "z": -4949.841
              },
              "distanceAlongShapeM": 1248.527,
              "shapeOffsetM": 2.74,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:6917",
              "position": {
                "x": -1597.362,
                "z": -4555.726
              },
              "distanceAlongShapeM": 1655.304,
              "shapeOffsetM": 4.677,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:6921",
              "position": {
                "x": -1640.178,
                "z": -4067.366
              },
              "distanceAlongShapeM": 2158.759,
              "shapeOffsetM": 4.683,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:6924",
              "position": {
                "x": -1612.999,
                "z": -3808.47
              },
              "distanceAlongShapeM": 2418.066,
              "shapeOffsetM": 3.947,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:6928",
              "position": {
                "x": -1373.246,
                "z": -3230.542
              },
              "distanceAlongShapeM": 3050.096,
              "shapeOffsetM": 3.027,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:6933",
              "position": {
                "x": -1422.254,
                "z": -2872.318
              },
              "distanceAlongShapeM": 3418.268,
              "shapeOffsetM": 3.457,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:7017",
              "position": {
                "x": -1324.1,
                "z": -2502.258
              },
              "distanceAlongShapeM": 3886.373,
              "shapeOffsetM": 7.96,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:5080",
              "position": {
                "x": 12.173,
                "z": -2744.606
              },
              "distanceAlongShapeM": 5274.981,
              "shapeOffsetM": 4.109,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            },
            {
              "stopId": "judu:stop:5481",
              "position": {
                "x": 502.159,
                "z": -2912.756
              },
              "distanceAlongShapeM": 5876.706,
              "shapeOffsetM": 2.686,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:5347",
              "position": {
                "x": 482.722,
                "z": -2601.805
              },
              "distanceAlongShapeM": 6190.415,
              "shapeOffsetM": 5.291,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:5351",
              "position": {
                "x": 407.176,
                "z": -2116.162
              },
              "distanceAlongShapeM": 6683.929,
              "shapeOffsetM": 0.163,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            },
            {
              "stopId": "judu:stop:5467",
              "position": {
                "x": 324.984,
                "z": -1640.419
              },
              "distanceAlongShapeM": 7167.652,
              "shapeOffsetM": 1.254,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            },
            {
              "stopId": "judu:stop:5378",
              "position": {
                "x": 265.625,
                "z": -1219.643
              },
              "distanceAlongShapeM": 7592.941,
              "shapeOffsetM": 3.789,
              "arrivalOffsetSeconds": 1500,
              "departureOffsetSeconds": 1500
            },
            {
              "stopId": "judu:stop:5244",
              "position": {
                "x": 121.213,
                "z": -441.083
              },
              "distanceAlongShapeM": 8396.504,
              "shapeOffsetM": 5.293,
              "arrivalOffsetSeconds": 1680,
              "departureOffsetSeconds": 1680
            },
            {
              "stopId": "judu:stop:5409",
              "position": {
                "x": 115.041,
                "z": -36.866
              },
              "distanceAlongShapeM": 8938.384,
              "shapeOffsetM": 3.473,
              "arrivalOffsetSeconds": 1860,
              "departureOffsetSeconds": 1860
            },
            {
              "stopId": "judu:stop:5338",
              "position": {
                "x": -56,
                "z": 522.864
              },
              "distanceAlongShapeM": 9578.026,
              "shapeOffsetM": 1.857,
              "arrivalOffsetSeconds": 2040,
              "departureOffsetSeconds": 2040
            },
            {
              "stopId": "judu:stop:5345",
              "position": {
                "x": 17.976,
                "z": 1008
              },
              "distanceAlongShapeM": 10071.89,
              "shapeOffsetM": 2.839,
              "arrivalOffsetSeconds": 2160,
              "departureOffsetSeconds": 2160
            },
            {
              "stopId": "judu:stop:5349",
              "position": {
                "x": 206.575,
                "z": 1304.022
              },
              "distanceAlongShapeM": 10421.778,
              "shapeOffsetM": 2.488,
              "arrivalOffsetSeconds": 2280,
              "departureOffsetSeconds": 2280
            },
            {
              "stopId": "judu:stop:5430",
              "position": {
                "x": 392.049,
                "z": 1568.924
              },
              "distanceAlongShapeM": 10786.987,
              "shapeOffsetM": 3.402,
              "arrivalOffsetSeconds": 2400,
              "departureOffsetSeconds": 2400
            },
            {
              "stopId": "judu:stop:7573",
              "position": {
                "x": 355.259,
                "z": 1885.754
              },
              "distanceAlongShapeM": 11123.622,
              "shapeOffsetM": 2.67,
              "arrivalOffsetSeconds": 2460,
              "departureOffsetSeconds": 2460
            }
          ],
          "departuresSeconds": [
            19680,
            21720,
            22260,
            22860,
            23400,
            23940,
            24480,
            24960,
            25560,
            26160,
            26820,
            27720,
            28560,
            29460,
            30300,
            30900,
            31500,
            32280,
            32760,
            33480,
            34080,
            35460,
            36900,
            38040,
            38640,
            39240,
            39840,
            40500,
            41160,
            41940,
            42780,
            43440,
            44100,
            44760,
            45420,
            46140,
            46860,
            47520,
            48240,
            49020,
            49740,
            50520,
            51300,
            51960,
            52620,
            53280,
            53940,
            54780,
            55620,
            56400,
            57240,
            57720,
            58200,
            58680,
            59160,
            59760,
            60360,
            61080,
            61800,
            62640,
            63540,
            64740,
            66000,
            66600,
            67200,
            67920,
            68640,
            69960,
            70800,
            71580,
            72360,
            73140,
            73920,
            74640,
            75240,
            75840,
            76380,
            77160,
            77940,
            78780,
            79920,
            82380,
            83400
          ]
        },
        {
          "id": "judu:pattern:vilnius_bus_53:1",
          "sourceRouteId": "vilnius_bus_53",
          "sourceShapeId": "vilnius_bus_53_b-a",
          "directionId": 1,
          "headsign": "Fabijoniškės",
          "directionName": "Stotis–Pylimo–Kalvarijų g.–Fabijoniškės",
          "mode": "bus",
          "routeShortName": "53",
          "routeLongName": "Fabijoniškės–Kalvarijų–Pylimo g.–Stotis",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              357.53,
              1884.349,
              0
            ],
            [
              392.313,
              1936.286,
              62.509
            ],
            [
              391.729,
              1939.636,
              65.909
            ],
            [
              372.202,
              1965.597,
              98.394
            ],
            [
              357.795,
              1989.238,
              126.079
            ],
            [
              356.647,
              1997.052,
              133.977
            ],
            [
              359.39,
              2005.908,
              143.248
            ],
            [
              369.819,
              2015.615,
              157.496
            ],
            [
              380.856,
              2017.112,
              168.634
            ],
            [
              389.202,
              2013.156,
              177.87
            ],
            [
              477.214,
              1956.998,
              282.272
            ],
            [
              482.1,
              1946.369,
              293.97
            ],
            [
              482.411,
              1939.16,
              301.187
            ],
            [
              476.08,
              1930.301,
              312.075
            ],
            [
              460.458,
              1922.794,
              329.407
            ],
            [
              416.68,
              1928.048,
              373.499
            ],
            [
              398.6,
              1927.265,
              391.596
            ],
            [
              339.428,
              1831.495,
              504.171
            ],
            [
              330.657,
              1810.504,
              526.921
            ],
            [
              391.321,
              1670.242,
              679.74
            ],
            [
              473.433,
              1574.115,
              806.163
            ],
            [
              482.238,
              1561.708,
              821.377
            ],
            [
              478.313,
              1549.038,
              834.641
            ],
            [
              469.529,
              1536.247,
              850.158
            ],
            [
              453.691,
              1517.701,
              874.546
            ],
            [
              360.424,
              1427.008,
              1004.638
            ],
            [
              315.899,
              1391.085,
              1061.848
            ],
            [
              256.42,
              1348.755,
              1134.852
            ],
            [
              223.566,
              1315.958,
              1181.274
            ],
            [
              196.476,
              1280.829,
              1225.635
            ],
            [
              149.248,
              1202.651,
              1316.971
            ],
            [
              55.081,
              1061.873,
              1486.34
            ],
            [
              46.275,
              1047.293,
              1503.373
            ],
            [
              39.094,
              1036.402,
              1516.418
            ],
            [
              29.447,
              1013.439,
              1541.325
            ],
            [
              17.226,
              966.824,
              1589.516
            ],
            [
              -2.949,
              921.549,
              1639.083
            ],
            [
              -20.393,
              826.162,
              1736.052
            ],
            [
              -29.409,
              769.885,
              1793.046
            ],
            [
              -34.886,
              726.201,
              1837.072
            ],
            [
              -34.25,
              619.32,
              1943.955
            ],
            [
              -49.15,
              509.381,
              2054.899
            ],
            [
              -51.111,
              437.057,
              2127.25
            ],
            [
              -46.759,
              428.072,
              2137.234
            ],
            [
              -39.768,
              422.378,
              2146.25
            ],
            [
              15.61,
              348.039,
              2238.948
            ],
            [
              36.62,
              260.682,
              2328.797
            ],
            [
              56.855,
              132.292,
              2458.771
            ],
            [
              59.373,
              128.907,
              2462.99
            ],
            [
              70.978,
              128.695,
              2474.597
            ],
            [
              102.671,
              133.684,
              2506.68
            ],
            [
              112.53,
              93.98,
              2547.59
            ],
            [
              129.88,
              -107.271,
              2749.588
            ],
            [
              116.846,
              -256.206,
              2899.092
            ],
            [
              117.887,
              -305.208,
              2948.105
            ],
            [
              127.343,
              -387.845,
              3031.281
            ],
            [
              135.914,
              -423.248,
              3067.707
            ],
            [
              144.816,
              -445.964,
              3092.105
            ],
            [
              174.587,
              -519.993,
              3171.896
            ],
            [
              236.049,
              -695.879,
              3358.211
            ],
            [
              238.113,
              -713.732,
              3376.183
            ],
            [
              217.158,
              -872.542,
              3536.37
            ],
            [
              276.82,
              -1242.113,
              3910.726
            ],
            [
              294.15,
              -1318.635,
              3989.185
            ],
            [
              320.249,
              -1546.82,
              4218.858
            ],
            [
              342.249,
              -1718.661,
              4392.102
            ],
            [
              352.701,
              -1764.728,
              4439.339
            ],
            [
              354.758,
              -1810.175,
              4484.833
            ],
            [
              356.121,
              -1841.371,
              4516.059
            ],
            [
              372.957,
              -1942.984,
              4619.057
            ],
            [
              426.379,
              -2158.817,
              4841.403
            ],
            [
              439.077,
              -2195.331,
              4880.063
            ],
            [
              440.947,
              -2208.066,
              4892.934
            ],
            [
              462.343,
              -2342.047,
              5028.612
            ],
            [
              497.458,
              -2575.098,
              5264.294
            ],
            [
              511.756,
              -2776.003,
              5465.707
            ],
            [
              520.913,
              -2874.136,
              5564.267
            ],
            [
              522.633,
              -2920.924,
              5611.086
            ],
            [
              521.572,
              -2978.793,
              5668.965
            ],
            [
              442.369,
              -2977.974,
              5748.172
            ],
            [
              342.529,
              -2936.549,
              5856.265
            ],
            [
              249.744,
              -2864.719,
              5973.605
            ],
            [
              215.338,
              -2842.938,
              6014.325
            ],
            [
              172.556,
              -2821.005,
              6062.402
            ],
            [
              117.391,
              -2800.55,
              6121.237
            ],
            [
              -65.348,
              -2754.326,
              6309.732
            ],
            [
              -120.668,
              -2747.991,
              6365.413
            ],
            [
              -224.17,
              -2733.625,
              6469.907
            ],
            [
              -312.321,
              -2725.345,
              6558.446
            ],
            [
              -534.611,
              -2721.315,
              6780.773
            ],
            [
              -763.526,
              -2727.196,
              7009.764
            ],
            [
              -847.912,
              -2724.56,
              7094.191
            ],
            [
              -963.025,
              -2710.24,
              7210.191
            ],
            [
              -1021.438,
              -2696.943,
              7270.098
            ],
            [
              -1084.241,
              -2676.889,
              7336.025
            ],
            [
              -1158.443,
              -2645.498,
              7416.594
            ],
            [
              -1247.226,
              -2600.488,
              7516.135
            ],
            [
              -1307.096,
              -2560.451,
              7588.158
            ],
            [
              -1370.853,
              -2519.624,
              7663.867
            ],
            [
              -1392.945,
              -2518.653,
              7685.981
            ],
            [
              -1411.106,
              -2549.069,
              7721.406
            ],
            [
              -1428.63,
              -2580.538,
              7757.425
            ],
            [
              -1442.46,
              -2628.145,
              7807.001
            ],
            [
              -1451.022,
              -2679.214,
              7858.782
            ],
            [
              -1448.996,
              -2746.044,
              7925.643
            ],
            [
              -1403.403,
              -2899.373,
              8085.607
            ],
            [
              -1388.37,
              -2943.738,
              8132.449
            ],
            [
              -1380.84,
              -2971.023,
              8160.755
            ],
            [
              -1362.723,
              -3074.878,
              8266.178
            ],
            [
              -1357.098,
              -3120.622,
              8312.267
            ],
            [
              -1356.687,
              -3169.611,
              8361.257
            ],
            [
              -1363.762,
              -3240.731,
              8432.729
            ],
            [
              -1372.45,
              -3294.01,
              8486.711
            ],
            [
              -1374.779,
              -3312.201,
              8505.051
            ],
            [
              -1386.916,
              -3346.073,
              8541.032
            ],
            [
              -1441.889,
              -3500.94,
              8705.366
            ],
            [
              -1479.438,
              -3582.647,
              8795.288
            ],
            [
              -1526.789,
              -3671.971,
              8896.386
            ],
            [
              -1572.531,
              -3743.513,
              8981.302
            ],
            [
              -1605.428,
              -3817.511,
              9062.283
            ],
            [
              -1619.047,
              -3858.457,
              9105.434
            ],
            [
              -1621.258,
              -3874.003,
              9121.136
            ],
            [
              -1625.465,
              -3915.925,
              9163.269
            ],
            [
              -1630.122,
              -3937.298,
              9185.144
            ],
            [
              -1635.048,
              -3960.588,
              9208.949
            ],
            [
              -1633.18,
              -4036.321,
              9284.705
            ],
            [
              -1621.037,
              -4150.087,
              9399.117
            ],
            [
              -1615.667,
              -4168.374,
              9418.177
            ],
            [
              -1616.287,
              -4244.797,
              9494.602
            ],
            [
              -1593.127,
              -4499.027,
              9749.885
            ],
            [
              -1582.077,
              -4601.642,
              9853.093
            ],
            [
              -1576.639,
              -4648.623,
              9900.387
            ],
            [
              -1585.129,
              -4736.288,
              9988.463
            ],
            [
              -1597.975,
              -4806.192,
              10059.537
            ],
            [
              -1623.216,
              -4884.78,
              10142.079
            ],
            [
              -1642.847,
              -4937.864,
              10198.677
            ],
            [
              -1699.03,
              -5044.347,
              10319.072
            ],
            [
              -1793.54,
              -5115.517,
              10437.383
            ],
            [
              -1840.927,
              -5135.823,
              10488.937
            ],
            [
              -1875.217,
              -5144.118,
              10524.216
            ],
            [
              -1904.939,
              -5149.154,
              10554.362
            ],
            [
              -2065.02,
              -5167.456,
              10715.486
            ],
            [
              -2110.315,
              -5178.897,
              10762.203
            ],
            [
              -2127.276,
              -5190.841,
              10782.948
            ],
            [
              -2145.02,
              -5203.693,
              10804.857
            ],
            [
              -2175.503,
              -5222.268,
              10840.554
            ],
            [
              -2204.955,
              -5248.463,
              10879.969
            ],
            [
              -2230.543,
              -5274.726,
              10916.637
            ],
            [
              -2374.125,
              -5489.26,
              11174.785
            ],
            [
              -2484.515,
              -5648.724,
              11368.73
            ],
            [
              -2512.326,
              -5691.648,
              11419.876
            ],
            [
              -2515.223,
              -5708.154,
              11436.635
            ],
            [
              -2529.5,
              -5729.639,
              11462.431
            ],
            [
              -2529.407,
              -5747.007,
              11479.799
            ],
            [
              -2525.623,
              -5751.527,
              11485.694
            ],
            [
              -2510.288,
              -5758.477,
              11502.53
            ],
            [
              -2499.033,
              -5756.062,
              11514.041
            ],
            [
              -2480.761,
              -5727.829,
              11547.671
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:5156",
              "position": {
                "x": 389.202,
                "z": 2013.156
              },
              "distanceAlongShapeM": 177.87,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:6834",
              "position": {
                "x": 472.7,
                "z": 1534.052
              },
              "distanceAlongShapeM": 850.158,
              "shapeOffsetM": 3.857,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:5346",
              "position": {
                "x": 52.802,
                "z": 1042.989
              },
              "distanceAlongShapeM": 1503.373,
              "shapeOffsetM": 7.818,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:5432",
              "position": {
                "x": -26.358,
                "z": 769.462
              },
              "distanceAlongShapeM": 1792.981,
              "shapeOffsetM": 3.079,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:5459",
              "position": {
                "x": 18.234,
                "z": 348.963
              },
              "distanceAlongShapeM": 2238.948,
              "shapeOffsetM": 2.781,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:5492",
              "position": {
                "x": 116.145,
                "z": 94.475
              },
              "distanceAlongShapeM": 2547.59,
              "shapeOffsetM": 3.649,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:5245",
              "position": {
                "x": 150.182,
                "z": -443.837
              },
              "distanceAlongShapeM": 3092.134,
              "shapeOffsetM": 5.773,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:6843",
              "position": {
                "x": 297.35,
                "z": -1318.188
              },
              "distanceAlongShapeM": 3989.185,
              "shapeOffsetM": 3.231,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:6844",
              "position": {
                "x": 356.237,
                "z": -1764.56
              },
              "distanceAlongShapeM": 4439.339,
              "shapeOffsetM": 3.54,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:6845",
              "position": {
                "x": 441.836,
                "z": -2194.724
              },
              "distanceAlongShapeM": 4880.063,
              "shapeOffsetM": 2.825,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            },
            {
              "stopId": "judu:stop:5469",
              "position": {
                "x": 505.139,
                "z": -2574.385
              },
              "distanceAlongShapeM": 5264.294,
              "shapeOffsetM": 7.714,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            },
            {
              "stopId": "judu:stop:5131",
              "position": {
                "x": 442.304,
                "z": -2978.453
              },
              "distanceAlongShapeM": 5748.172,
              "shapeOffsetM": 0.484,
              "arrivalOffsetSeconds": 1680,
              "departureOffsetSeconds": 1680
            },
            {
              "stopId": "judu:stop:8463",
              "position": {
                "x": -121.383,
                "z": -2752.193
              },
              "distanceAlongShapeM": 6365.544,
              "shapeOffsetM": 4.261,
              "arrivalOffsetSeconds": 1800,
              "departureOffsetSeconds": 1800
            },
            {
              "stopId": "judu:stop:3512",
              "position": {
                "x": -1401.734,
                "z": -2554.302
              },
              "distanceAlongShapeM": 7721.095,
              "shapeOffsetM": 10.73,
              "arrivalOffsetSeconds": 1980,
              "departureOffsetSeconds": 1980
            },
            {
              "stopId": "judu:stop:6934",
              "position": {
                "x": -1382.255,
                "z": -2942.054
              },
              "distanceAlongShapeM": 8132.453,
              "shapeOffsetM": 6.342,
              "arrivalOffsetSeconds": 2040,
              "departureOffsetSeconds": 2040
            },
            {
              "stopId": "judu:stop:6929",
              "position": {
                "x": -1372.145,
                "z": -3312.94
              },
              "distanceAlongShapeM": 8505.051,
              "shapeOffsetM": 2.736,
              "arrivalOffsetSeconds": 2100,
              "departureOffsetSeconds": 2100
            },
            {
              "stopId": "judu:stop:6926",
              "position": {
                "x": -1622.014,
                "z": -3916.292
              },
              "distanceAlongShapeM": 9163.269,
              "shapeOffsetM": 3.47,
              "arrivalOffsetSeconds": 2220,
              "departureOffsetSeconds": 2220
            },
            {
              "stopId": "judu:stop:6922",
              "position": {
                "x": -1612.338,
                "z": -4168.054
              },
              "distanceAlongShapeM": 9418.177,
              "shapeOffsetM": 3.344,
              "arrivalOffsetSeconds": 2280,
              "departureOffsetSeconds": 2280
            },
            {
              "stopId": "judu:stop:6918",
              "position": {
                "x": -1574.54,
                "z": -4648.532
              },
              "distanceAlongShapeM": 9900.387,
              "shapeOffsetM": 2.101,
              "arrivalOffsetSeconds": 2400,
              "departureOffsetSeconds": 2400
            },
            {
              "stopId": "judu:stop:5811",
              "position": {
                "x": -1696.959,
                "z": -5045.994
              },
              "distanceAlongShapeM": 10319.072,
              "shapeOffsetM": 2.646,
              "arrivalOffsetSeconds": 2520,
              "departureOffsetSeconds": 2520
            },
            {
              "stopId": "judu:stop:6915",
              "position": {
                "x": -2143.028,
                "z": -5207.26
              },
              "distanceAlongShapeM": 10805.012,
              "shapeOffsetM": 4.083,
              "arrivalOffsetSeconds": 2580,
              "departureOffsetSeconds": 2580
            },
            {
              "stopId": "judu:stop:5512",
              "position": {
                "x": -2513.285,
                "z": -5709.442
              },
              "distanceAlongShapeM": 11436.635,
              "shapeOffsetM": 2.327,
              "arrivalOffsetSeconds": 2700,
              "departureOffsetSeconds": 2700
            }
          ],
          "departuresSeconds": [
            19740,
            20880,
            22200,
            23580,
            24300,
            25020,
            25740,
            26280,
            26880,
            27480,
            28080,
            28620,
            29160,
            29760,
            30660,
            31560,
            32400,
            33240,
            33900,
            34500,
            35280,
            35880,
            36480,
            37260,
            38460,
            39720,
            40860,
            41460,
            42120,
            42780,
            43440,
            44160,
            44880,
            45600,
            46320,
            47040,
            47760,
            48480,
            49140,
            49800,
            50520,
            51420,
            52260,
            52980,
            53700,
            54420,
            55140,
            55860,
            56460,
            57120,
            57840,
            58560,
            59340,
            60180,
            60720,
            61260,
            61800,
            62340,
            62880,
            63420,
            64140,
            64860,
            65760,
            66660,
            67740,
            68880,
            69540,
            70260,
            70980,
            71760,
            72720,
            73680,
            74580,
            75480,
            76620,
            77820,
            78600,
            79200,
            79980,
            81060,
            81660,
            82800,
            84960,
            86160
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_bus_54",
      "sourceRouteId": "vilnius_bus_54",
      "mode": "bus",
      "shortName": "54",
      "longName": "Pilaitė–Lazdynai–Stotis",
      "color": "0073AC",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_bus_54:0",
          "sourceRouteId": "vilnius_bus_54",
          "sourceShapeId": "vilnius_bus_54_a-b",
          "directionId": 0,
          "headsign": "Stotis",
          "directionName": "Pilaitė–Lazdynai–Stotis",
          "mode": "bus",
          "routeShortName": "54",
          "routeLongName": "Pilaitė–Lazdynai–Stotis",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              -6782.722,
              -1517.922,
              0
            ],
            [
              -6790.213,
              -1503.239,
              16.483
            ],
            [
              -6789.666,
              -1493.237,
              26.501
            ],
            [
              -6789.574,
              -1493.338,
              26.637
            ],
            [
              -6793.888,
              -1496.036,
              31.725
            ],
            [
              -6804.801,
              -1471.131,
              58.916
            ],
            [
              -6817.871,
              -1443.083,
              89.859
            ],
            [
              -6849.755,
              -1383.551,
              157.392
            ],
            [
              -6861.847,
              -1368.999,
              176.312
            ],
            [
              -6868.44,
              -1344.278,
              201.897
            ],
            [
              -6865.755,
              -1340.811,
              206.282
            ],
            [
              -6856.389,
              -1336.272,
              216.69
            ],
            [
              -6847.396,
              -1333.735,
              226.034
            ],
            [
              -6839.19,
              -1361.045,
              254.55
            ],
            [
              -6823.318,
              -1421.841,
              317.384
            ],
            [
              -6726.31,
              -1602.786,
              522.693
            ],
            [
              -6717.082,
              -1622.391,
              544.361
            ],
            [
              -6684.251,
              -1702.465,
              630.904
            ],
            [
              -6676.395,
              -1733.766,
              663.176
            ],
            [
              -6677.514,
              -1993.121,
              922.533
            ],
            [
              -6673.441,
              -2063.333,
              992.863
            ],
            [
              -6676.454,
              -2314.851,
              1244.399
            ],
            [
              -6640.332,
              -2313.345,
              1280.553
            ],
            [
              -6613.182,
              -2313.262,
              1307.703
            ],
            [
              -6575.914,
              -2315.423,
              1345.033
            ],
            [
              -6380.632,
              -2316.474,
              1540.318
            ],
            [
              -6294.875,
              -2314.577,
              1626.096
            ],
            [
              -6220.641,
              -2308.034,
              1700.618
            ],
            [
              -6201.86,
              -2302.785,
              1720.119
            ],
            [
              -6169.955,
              -2294.517,
              1753.078
            ],
            [
              -6126.719,
              -2280.674,
              1798.476
            ],
            [
              -6104.034,
              -2273.265,
              1822.34
            ],
            [
              -5924.643,
              -2185.012,
              2022.264
            ],
            [
              -5877.169,
              -2160.211,
              2075.826
            ],
            [
              -5846.259,
              -2142.718,
              2111.342
            ],
            [
              -5795.942,
              -2121.511,
              2165.946
            ],
            [
              -5568.568,
              -2017.388,
              2416.027
            ],
            [
              -5236.974,
              -1850.486,
              2787.256
            ],
            [
              -5169.837,
              -1807.104,
              2867.189
            ],
            [
              -5127.302,
              -1769.981,
              2923.646
            ],
            [
              -5012.864,
              -1637.24,
              3098.906
            ],
            [
              -4831.761,
              -1414.361,
              3386.088
            ],
            [
              -4763.266,
              -1360.258,
              3473.374
            ],
            [
              -4704.75,
              -1314.599,
              3547.595
            ],
            [
              -4653.804,
              -1300.53,
              3600.448
            ],
            [
              -4405.208,
              -1203.507,
              3867.307
            ],
            [
              -4296.995,
              -1171.977,
              3980.02
            ],
            [
              -4246.587,
              -1162.091,
              4031.388
            ],
            [
              -4190.857,
              -1159.392,
              4087.183
            ],
            [
              -3912.052,
              -1135.777,
              4366.987
            ],
            [
              -3758.891,
              -1120.334,
              4520.924
            ],
            [
              -3704.617,
              -1115.802,
              4575.387
            ],
            [
              -3657.704,
              -1114.039,
              4622.333
            ],
            [
              -3677.364,
              -1066.903,
              4673.405
            ],
            [
              -3685.368,
              -1042.059,
              4699.506
            ],
            [
              -3720.918,
              -930.373,
              4816.713
            ],
            [
              -3751.424,
              -837.404,
              4914.56
            ],
            [
              -3758.325,
              -817.25,
              4935.862
            ],
            [
              -3766.218,
              -791.548,
              4962.749
            ],
            [
              -3793.988,
              -719.82,
              5039.665
            ],
            [
              -3843.779,
              -616.54,
              5154.321
            ],
            [
              -3881.258,
              -546.871,
              5233.431
            ],
            [
              -3968.352,
              -399.129,
              5404.933
            ],
            [
              -3983.006,
              -376.666,
              5431.753
            ],
            [
              -3999.719,
              -350.005,
              5463.22
            ],
            [
              -4048.201,
              -282.373,
              5546.434
            ],
            [
              -4133.499,
              -180.709,
              5679.142
            ],
            [
              -4196.231,
              -117.271,
              5768.358
            ],
            [
              -4217.103,
              -95.271,
              5798.684
            ],
            [
              -4243.751,
              -67.483,
              5837.185
            ],
            [
              -4402.336,
              85.535,
              6057.557
            ],
            [
              -4449.086,
              142,
              6130.863
            ],
            [
              -4479.797,
              193.736,
              6191.028
            ],
            [
              -4502.905,
              237.549,
              6240.561
            ],
            [
              -4519.036,
              274.562,
              6280.937
            ],
            [
              -4536.228,
              324.952,
              6334.179
            ],
            [
              -4547.048,
              370.78,
              6381.267
            ],
            [
              -4566.578,
              510.266,
              6522.113
            ],
            [
              -4570.606,
              537.669,
              6549.811
            ],
            [
              -4575.517,
              590.57,
              6602.939
            ],
            [
              -4579.623,
              651.866,
              6664.373
            ],
            [
              -4586.366,
              709.869,
              6722.766
            ],
            [
              -4584.541,
              741.007,
              6753.958
            ],
            [
              -4573.306,
              794.248,
              6808.371
            ],
            [
              -4555.909,
              830.684,
              6848.747
            ],
            [
              -4554.237,
              852.919,
              6871.045
            ],
            [
              -4568.699,
              912.168,
              6932.034
            ],
            [
              -4567.748,
              929.963,
              6949.854
            ],
            [
              -4555.854,
              946.456,
              6970.188
            ],
            [
              -4510.16,
              977.953,
              7025.686
            ],
            [
              -4440.575,
              860.983,
              7161.789
            ],
            [
              -4425.036,
              789.47,
              7234.971
            ],
            [
              -4406.248,
              756.864,
              7272.603
            ],
            [
              -4380.992,
              725.259,
              7313.059
            ],
            [
              -4355.565,
              703.67,
              7346.415
            ],
            [
              -4324.219,
              688.657,
              7381.171
            ],
            [
              -4302.372,
              683.828,
              7403.545
            ],
            [
              -4269.507,
              682.148,
              7436.453
            ],
            [
              -4233.908,
              689.326,
              7472.769
            ],
            [
              -4200.071,
              706.552,
              7510.738
            ],
            [
              -4154.906,
              744.734,
              7569.88
            ],
            [
              -4131.603,
              764.725,
              7600.583
            ],
            [
              -4089.107,
              782.559,
              7646.669
            ],
            [
              -4026.001,
              813.75,
              7717.063
            ],
            [
              -3968.169,
              838.352,
              7779.91
            ],
            [
              -3939.526,
              853.44,
              7812.284
            ],
            [
              -3921.201,
              868.708,
              7836.136
            ],
            [
              -3904.031,
              891.787,
              7864.901
            ],
            [
              -3887.976,
              924.905,
              7901.706
            ],
            [
              -3883.393,
              966.014,
              7943.069
            ],
            [
              -3887.876,
              1005.054,
              7982.366
            ],
            [
              -3903.754,
              1056.537,
              8036.242
            ],
            [
              -3912.994,
              1078.798,
              8060.344
            ],
            [
              -3919.363,
              1123.6,
              8105.597
            ],
            [
              -3949.447,
              1248.8,
              8234.36
            ],
            [
              -3955.799,
              1254.476,
              8242.879
            ],
            [
              -3966.06,
              1257.993,
              8253.726
            ],
            [
              -4052.898,
              1235.006,
              8343.555
            ],
            [
              -4088.424,
              1232.281,
              8379.185
            ],
            [
              -4119.34,
              1235.042,
              8410.224
            ],
            [
              -4212.237,
              1261.595,
              8506.842
            ],
            [
              -4241.916,
              1271.669,
              8538.184
            ],
            [
              -4268.203,
              1281.028,
              8566.087
            ],
            [
              -4527.979,
              1404.616,
              8853.763
            ],
            [
              -4557.013,
              1417.363,
              8885.472
            ],
            [
              -4581.673,
              1433.369,
              8914.871
            ],
            [
              -4718.251,
              1519.203,
              9076.182
            ],
            [
              -4836.63,
              1608.523,
              9224.477
            ],
            [
              -4906.917,
              1690.529,
              9332.483
            ],
            [
              -4961.39,
              1738.988,
              9405.391
            ],
            [
              -5068.759,
              1878.357,
              9581.323
            ],
            [
              -5277.102,
              2035.914,
              9842.533
            ],
            [
              -5274.521,
              2038.555,
              9846.226
            ],
            [
              -5252.738,
              2043.812,
              9868.634
            ],
            [
              -5246.023,
              2048.225,
              9876.67
            ],
            [
              -5243.524,
              2050.617,
              9880.129
            ],
            [
              -5236.97,
              2075.695,
              9906.049
            ],
            [
              -5201.692,
              2109.98,
              9955.243
            ],
            [
              -5149.809,
              2125.485,
              10009.392
            ],
            [
              -5115.548,
              2129.353,
              10043.871
            ],
            [
              -5121.784,
              2044.927,
              10128.528
            ],
            [
              -4759.188,
              2066.486,
              10491.764
            ],
            [
              -4628.554,
              2084.282,
              10623.605
            ],
            [
              -4532.335,
              2089.308,
              10719.955
            ],
            [
              -4413.826,
              2088.426,
              10838.467
            ],
            [
              -4171.807,
              2044.134,
              11084.506
            ],
            [
              -4056.112,
              2018.757,
              11202.951
            ],
            [
              -4035.993,
              2013.78,
              11223.677
            ],
            [
              -4018.212,
              2009.195,
              11242.039
            ],
            [
              -3691.362,
              1920.037,
              11580.831
            ],
            [
              -3598.621,
              1910.632,
              11674.048
            ],
            [
              -3547.649,
              1910.858,
              11725.02
            ],
            [
              -3478.544,
              1919.039,
              11794.608
            ],
            [
              -3376.715,
              1945.728,
              11899.876
            ],
            [
              -3255.325,
              1988.136,
              12028.461
            ],
            [
              -3211.057,
              2010.74,
              12078.166
            ],
            [
              -3076.57,
              2064.047,
              12222.832
            ],
            [
              -3025.322,
              2079.847,
              12276.461
            ],
            [
              -2969.481,
              2100.019,
              12335.834
            ],
            [
              -2931.778,
              2116.056,
              12376.806
            ],
            [
              -2890.295,
              2136.475,
              12423.042
            ],
            [
              -2704.044,
              2203.421,
              12620.959
            ],
            [
              -2694.973,
              2206.697,
              12630.604
            ],
            [
              -2620.644,
              2234.153,
              12709.841
            ],
            [
              -2602.113,
              2260.544,
              12742.088
            ],
            [
              -2588.136,
              2284.788,
              12770.073
            ],
            [
              -2571.13,
              2297.847,
              12791.514
            ],
            [
              -2549.022,
              2307.476,
              12815.628
            ],
            [
              -2532.153,
              2312.745,
              12833.301
            ],
            [
              -2506.977,
              2313.414,
              12858.486
            ],
            [
              -2483.854,
              2307.44,
              12882.368
            ],
            [
              -2455.846,
              2285.795,
              12917.765
            ],
            [
              -2438.355,
              2253.203,
              12954.754
            ],
            [
              -2433.47,
              2237.532,
              12971.169
            ],
            [
              -2435.723,
              2169.786,
              13038.952
            ],
            [
              -2432.837,
              2155.209,
              13053.813
            ],
            [
              -2421.673,
              2138.248,
              13074.118
            ],
            [
              -2405.237,
              2119.033,
              13099.403
            ],
            [
              -2339.12,
              2063.317,
              13185.865
            ],
            [
              -2328.352,
              2051.995,
              13201.49
            ],
            [
              -2314.582,
              2044.048,
              13217.389
            ],
            [
              -2298.509,
              2024.75,
              13242.504
            ],
            [
              -1944.941,
              1697.877,
              13724.018
            ],
            [
              -1869.698,
              1631.955,
              13824.054
            ],
            [
              -1860.469,
              1622.903,
              13836.981
            ],
            [
              -1769.084,
              1537.785,
              13961.867
            ],
            [
              -1704.495,
              1480.033,
              14048.51
            ],
            [
              -1688.349,
              1470.667,
              14067.176
            ],
            [
              -1678.973,
              1453.802,
              14086.472
            ],
            [
              -1503.095,
              1295.926,
              14322.814
            ],
            [
              -1429.356,
              1232.268,
              14420.23
            ],
            [
              -1409.124,
              1211.868,
              14448.961
            ],
            [
              -1353.311,
              1158.548,
              14526.15
            ],
            [
              -1207.93,
              1027.923,
              14721.595
            ],
            [
              -1189.5,
              1013.819,
              14744.802
            ],
            [
              -1173.062,
              993.901,
              14770.627
            ],
            [
              -1066.972,
              902.938,
              14910.375
            ],
            [
              -958.695,
              862.029,
              15026.122
            ],
            [
              -808.429,
              808.426,
              15185.663
            ],
            [
              -794.487,
              837.665,
              15218.056
            ],
            [
              -787.05,
              855.14,
              15237.048
            ],
            [
              -767.948,
              887.538,
              15274.658
            ],
            [
              -708.773,
              1021.171,
              15420.807
            ],
            [
              -697.048,
              1063.262,
              15464.5
            ],
            [
              -655.787,
              1240.633,
              15646.607
            ],
            [
              -653.864,
              1286.859,
              15692.873
            ],
            [
              -631.67,
              1361.539,
              15770.781
            ],
            [
              -586.657,
              1567.786,
              15981.883
            ],
            [
              -585.791,
              1580.016,
              15994.144
            ],
            [
              -535.95,
              1804.839,
              16224.425
            ],
            [
              -529.205,
              1846.048,
              16266.182
            ],
            [
              -524.047,
              1854.98,
              16276.497
            ],
            [
              -516.247,
              1858.179,
              16284.927
            ],
            [
              -491.403,
              1846.355,
              16312.441
            ],
            [
              -471.457,
              1839.899,
              16333.406
            ],
            [
              -432.32,
              1825.49,
              16375.111
            ],
            [
              -327.19,
              1787.963,
              16486.738
            ],
            [
              -259.046,
              1774.482,
              16556.203
            ],
            [
              -147.106,
              1756.865,
              16669.521
            ],
            [
              9.981,
              1738.424,
              16827.687
            ],
            [
              41.02,
              1742.312,
              16858.968
            ],
            [
              64.443,
              1752.06,
              16884.338
            ],
            [
              135.751,
              1771.757,
              16958.317
            ],
            [
              319.251,
              1821.845,
              17148.53
            ],
            [
              341.2,
              1822.557,
              17170.491
            ],
            [
              378.73,
              1828.551,
              17208.496
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:7694",
              "position": {
                "x": -6837.763,
                "z": -1360.375
              },
              "distanceAlongShapeM": 254.319,
              "shapeOffsetM": 1.56,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:4526",
              "position": {
                "x": -6711.23,
                "z": -1619.637
              },
              "distanceAlongShapeM": 544.361,
              "shapeOffsetM": 6.468,
              "arrivalOffsetSeconds": 60,
              "departureOffsetSeconds": 60
            },
            {
              "stopId": "judu:stop:8067",
              "position": {
                "x": -6672.243,
                "z": -2063.34
              },
              "distanceAlongShapeM": 992.863,
              "shapeOffsetM": 1.198,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:7951",
              "position": {
                "x": -6613.194,
                "z": -2309.232
              },
              "distanceAlongShapeM": 1307.703,
              "shapeOffsetM": 4.03,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:7949",
              "position": {
                "x": -6171.35,
                "z": -2289.941
              },
              "distanceAlongShapeM": 1752.875,
              "shapeOffsetM": 4.779,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:8069",
              "position": {
                "x": -5847.188,
                "z": -2140.681
              },
              "distanceAlongShapeM": 2111.342,
              "shapeOffsetM": 2.239,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:8934",
              "position": {
                "x": -4704.97,
                "z": -1314.122
              },
              "distanceAlongShapeM": 3547.595,
              "shapeOffsetM": 0.525,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:4989",
              "position": {
                "x": -4247.02,
                "z": -1152.802
              },
              "distanceAlongShapeM": 4031.405,
              "shapeOffsetM": 9.299,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:5643",
              "position": {
                "x": -3680.758,
                "z": -1067.996
              },
              "distanceAlongShapeM": 4673.405,
              "shapeOffsetM": 3.566,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:5646",
              "position": {
                "x": -3761.526,
                "z": -818.346
              },
              "distanceAlongShapeM": 4935.862,
              "shapeOffsetM": 3.383,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:5651",
              "position": {
                "x": -3986.683,
                "z": -379.175
              },
              "distanceAlongShapeM": 5431.661,
              "shapeOffsetM": 4.451,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:5656",
              "position": {
                "x": -4221.08,
                "z": -99.045
              },
              "distanceAlongShapeM": 5798.713,
              "shapeOffsetM": 5.483,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            },
            {
              "stopId": "judu:stop:5668",
              "position": {
                "x": -4574.501,
                "z": 537.119
              },
              "distanceAlongShapeM": 6549.811,
              "shapeOffsetM": 3.934,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:5703",
              "position": {
                "x": -4134.494,
                "z": 768.872
              },
              "distanceAlongShapeM": 7600.583,
              "shapeOffsetM": 5.055,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:5702",
              "position": {
                "x": -3916.285,
                "z": 1077.905
              },
              "distanceAlongShapeM": 8060.344,
              "shapeOffsetM": 3.41,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:6318",
              "position": {
                "x": -4215.081,
                "z": 1256.734
              },
              "distanceAlongShapeM": 8507.972,
              "shapeOffsetM": 5.517,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            },
            {
              "stopId": "judu:stop:6319",
              "position": {
                "x": -4558.781,
                "z": 1414.051
              },
              "distanceAlongShapeM": 8885.472,
              "shapeOffsetM": 3.754,
              "arrivalOffsetSeconds": 1380,
              "departureOffsetSeconds": 1380
            },
            {
              "stopId": "judu:stop:6320",
              "position": {
                "x": -4838.028,
                "z": 1606.973
              },
              "distanceAlongShapeM": 9224.477,
              "shapeOffsetM": 2.088,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            },
            {
              "stopId": "judu:stop:6350",
              "position": {
                "x": -4413.578,
                "z": 2091.718
              },
              "distanceAlongShapeM": 10838.467,
              "shapeOffsetM": 3.302,
              "arrivalOffsetSeconds": 1680,
              "departureOffsetSeconds": 1680
            },
            {
              "stopId": "judu:stop:6352",
              "position": {
                "x": -4034.827,
                "z": 2018.389
              },
              "distanceAlongShapeM": 11223.677,
              "shapeOffsetM": 4.755,
              "arrivalOffsetSeconds": 1740,
              "departureOffsetSeconds": 1740
            },
            {
              "stopId": "judu:stop:6337",
              "position": {
                "x": -2705.632,
                "z": 2207.819
              },
              "distanceAlongShapeM": 12620.952,
              "shapeOffsetM": 4.675,
              "arrivalOffsetSeconds": 1860,
              "departureOffsetSeconds": 1860
            },
            {
              "stopId": "judu:stop:5535",
              "position": {
                "x": -2313.635,
                "z": 2045.055
              },
              "distanceAlongShapeM": 13217.389,
              "shapeOffsetM": 1.383,
              "arrivalOffsetSeconds": 1980,
              "departureOffsetSeconds": 1980
            },
            {
              "stopId": "judu:stop:7853",
              "position": {
                "x": -1868.675,
                "z": 1633.068
              },
              "distanceAlongShapeM": 13824.054,
              "shapeOffsetM": 1.512,
              "arrivalOffsetSeconds": 2100,
              "departureOffsetSeconds": 2100
            },
            {
              "stopId": "judu:stop:6842",
              "position": {
                "x": -1427.428,
                "z": 1234.46
              },
              "distanceAlongShapeM": 14420.23,
              "shapeOffsetM": 2.919,
              "arrivalOffsetSeconds": 2280,
              "departureOffsetSeconds": 2280
            },
            {
              "stopId": "judu:stop:5580",
              "position": {
                "x": -1188.159,
                "z": 1015.323
              },
              "distanceAlongShapeM": 14744.802,
              "shapeOffsetM": 2.015,
              "arrivalOffsetSeconds": 2340,
              "departureOffsetSeconds": 2340
            },
            {
              "stopId": "judu:stop:5266",
              "position": {
                "x": -793.638,
                "z": 857.944
              },
              "distanceAlongShapeM": 15237.048,
              "shapeOffsetM": 7.159,
              "arrivalOffsetSeconds": 2460,
              "departureOffsetSeconds": 2460
            },
            {
              "stopId": "judu:stop:5272",
              "position": {
                "x": -656.233,
                "z": 1287.397
              },
              "distanceAlongShapeM": 15692.873,
              "shapeOffsetM": 2.429,
              "arrivalOffsetSeconds": 2580,
              "departureOffsetSeconds": 2580
            },
            {
              "stopId": "judu:stop:5166",
              "position": {
                "x": -470.051,
                "z": 1843.985
              },
              "distanceAlongShapeM": 16333.406,
              "shapeOffsetM": 4.322,
              "arrivalOffsetSeconds": 2820,
              "departureOffsetSeconds": 2820
            },
            {
              "stopId": "judu:stop:5160",
              "position": {
                "x": 63.816,
                "z": 1754.143
              },
              "distanceAlongShapeM": 16884.338,
              "shapeOffsetM": 2.176,
              "arrivalOffsetSeconds": 2940,
              "departureOffsetSeconds": 2940
            },
            {
              "stopId": "judu:stop:16581",
              "position": {
                "x": 378.73,
                "z": 1828.551
              },
              "distanceAlongShapeM": 17208.496,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 3060,
              "departureOffsetSeconds": 3060
            }
          ],
          "departuresSeconds": [
            17820,
            19200,
            20760,
            22620,
            24180,
            25920,
            27900,
            30180,
            33960,
            36180,
            38280,
            40440,
            41580,
            43500,
            45540,
            47640,
            49020,
            50880,
            52920,
            54960,
            56280,
            58440,
            60720,
            63180,
            66660,
            69060,
            71040,
            73140,
            74520,
            76140,
            78180,
            80040
          ]
        },
        {
          "id": "judu:pattern:vilnius_bus_54:1",
          "sourceRouteId": "vilnius_bus_54",
          "sourceShapeId": "vilnius_bus_54_b-a",
          "directionId": 1,
          "headsign": "Pilaitė",
          "directionName": "Stotis–Lazdynai–Pilaitė",
          "mode": "bus",
          "routeShortName": "54",
          "routeLongName": "Pilaitė–Lazdynai–Stotis",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              378.73,
              1828.551,
              0
            ],
            [
              561.04,
              1848.593,
              183.408
            ],
            [
              586.961,
              1854.797,
              210.061
            ],
            [
              595.023,
              1864.837,
              222.937
            ],
            [
              591.157,
              1872.532,
              231.549
            ],
            [
              474.708,
              1925.873,
              359.634
            ],
            [
              453.987,
              1921.799,
              380.751
            ],
            [
              419.803,
              1922.424,
              414.941
            ],
            [
              403.951,
              1926.595,
              431.333
            ],
            [
              397.229,
              1922.837,
              439.034
            ],
            [
              334.106,
              1822.687,
              557.417
            ],
            [
              318.606,
              1821.856,
              572.939
            ],
            [
              29.934,
              1735.835,
              874.155
            ],
            [
              -11.394,
              1732.372,
              915.628
            ],
            [
              -46.755,
              1740.57,
              951.927
            ],
            [
              -320.217,
              1781.157,
              1228.384
            ],
            [
              -514.905,
              1842.557,
              1432.525
            ],
            [
              -530.605,
              1766.267,
              1510.414
            ],
            [
              -536.862,
              1752.795,
              1525.268
            ],
            [
              -542.324,
              1736.195,
              1542.743
            ],
            [
              -678.532,
              1124.155,
              2169.756
            ],
            [
              -683.338,
              1093.819,
              2200.471
            ],
            [
              -691.829,
              1066.507,
              2229.072
            ],
            [
              -722.413,
              980.227,
              2320.612
            ],
            [
              -796.476,
              807.9,
              2508.181
            ],
            [
              -803.749,
              798.012,
              2520.456
            ],
            [
              -958.695,
              862.029,
              2688.105
            ],
            [
              -1066.972,
              902.938,
              2803.853
            ],
            [
              -1103.368,
              923.63,
              2845.72
            ],
            [
              -1148.452,
              963.402,
              2905.839
            ],
            [
              -1166.61,
              973.416,
              2926.576
            ],
            [
              -1183.42,
              991.86,
              2951.531
            ],
            [
              -1484.246,
              1267.759,
              3359.718
            ],
            [
              -1501.298,
              1275.764,
              3378.555
            ],
            [
              -1524.902,
              1302.995,
              3414.592
            ],
            [
              -1970.62,
              1705.012,
              4014.827
            ],
            [
              -1985.783,
              1723.093,
              4038.425
            ],
            [
              -2263.842,
              1978.495,
              4415.979
            ],
            [
              -2290.557,
              2000.118,
              4450.348
            ],
            [
              -2318.992,
              2034.018,
              4494.595
            ],
            [
              -2425.036,
              2130.514,
              4637.971
            ],
            [
              -2441.629,
              2140.826,
              4657.507
            ],
            [
              -2464.869,
              2140.123,
              4680.758
            ],
            [
              -2491.57,
              2126.123,
              4710.907
            ],
            [
              -2503.239,
              2122.989,
              4722.989
            ],
            [
              -2528.453,
              2120.094,
              4748.369
            ],
            [
              -2543.24,
              2122.614,
              4763.369
            ],
            [
              -2561.443,
              2130.364,
              4783.154
            ],
            [
              -2579.681,
              2142.148,
              4804.867
            ],
            [
              -2607.297,
              2186.05,
              4856.732
            ],
            [
              -2618.809,
              2191.819,
              4869.609
            ],
            [
              -2640.075,
              2193.306,
              4890.927
            ],
            [
              -2665.388,
              2184.846,
              4917.616
            ],
            [
              -2681.67,
              2176.227,
              4936.039
            ],
            [
              -2692.184,
              2172.41,
              4947.225
            ],
            [
              -2745.273,
              2155.082,
              5003.07
            ],
            [
              -2858.912,
              2113.664,
              5124.021
            ],
            [
              -2885.494,
              2106.338,
              5151.594
            ],
            [
              -2963.852,
              2089.902,
              5231.657
            ],
            [
              -3175.505,
              2014.571,
              5456.317
            ],
            [
              -3269.998,
              1973.346,
              5559.41
            ],
            [
              -3463.705,
              1914.962,
              5761.725
            ],
            [
              -3534.885,
              1902.843,
              5833.929
            ],
            [
              -3642.009,
              1901.368,
              5941.064
            ],
            [
              -3703.185,
              1907.997,
              6002.598
            ],
            [
              -3763.581,
              1922.405,
              6064.689
            ],
            [
              -4034.529,
              1998.346,
              6346.078
            ],
            [
              -4081.754,
              2006.899,
              6394.071
            ],
            [
              -4108.338,
              2013.522,
              6421.467
            ],
            [
              -4294.183,
              2056.264,
              6612.164
            ],
            [
              -4414.529,
              2073.923,
              6733.799
            ],
            [
              -4474.544,
              2075.053,
              6793.825
            ],
            [
              -4495.165,
              2075.221,
              6814.446
            ],
            [
              -4714.759,
              2061.271,
              7034.483
            ],
            [
              -4881.318,
              2031.771,
              7203.634
            ],
            [
              -4920.175,
              2009.13,
              7248.606
            ],
            [
              -4946.298,
              1989.517,
              7281.272
            ],
            [
              -5067.466,
              1877.117,
              7446.547
            ],
            [
              -4961.259,
              1757.137,
              7606.781
            ],
            [
              -4931.684,
              1728.355,
              7648.05
            ],
            [
              -4906.917,
              1690.529,
              7693.263
            ],
            [
              -4767.773,
              1565.694,
              7880.198
            ],
            [
              -4741.69,
              1550.026,
              7910.625
            ],
            [
              -4712.351,
              1524.668,
              7949.404
            ],
            [
              -4596.2,
              1451.429,
              8086.717
            ],
            [
              -4491.296,
              1399.532,
              8203.757
            ],
            [
              -4467.288,
              1389.272,
              8229.865
            ],
            [
              -4443.995,
              1374.227,
              8257.594
            ],
            [
              -4243.678,
              1281.718,
              8478.241
            ],
            [
              -4199.211,
              1271.037,
              8523.973
            ],
            [
              -4179.458,
              1265.024,
              8544.62
            ],
            [
              -4137.877,
              1254.669,
              8587.471
            ],
            [
              -4093.256,
              1251.097,
              8632.235
            ],
            [
              -4041.607,
              1253.735,
              8683.951
            ],
            [
              -3953.633,
              1267.797,
              8773.042
            ],
            [
              -3919.363,
              1123.6,
              8921.256
            ],
            [
              -3889.289,
              1035.135,
              9014.693
            ],
            [
              -3881.018,
              1009.279,
              9041.839
            ],
            [
              -3879.245,
              944.791,
              9106.352
            ],
            [
              -3881.411,
              931.47,
              9119.848
            ],
            [
              -3898.384,
              892.134,
              9162.689
            ],
            [
              -3911.432,
              874.104,
              9184.945
            ],
            [
              -3948.102,
              842.457,
              9233.383
            ],
            [
              -4089.107,
              782.559,
              9386.583
            ],
            [
              -4161.662,
              727.04,
              9477.943
            ],
            [
              -4178.229,
              714.534,
              9498.7
            ],
            [
              -4216.46,
              691.251,
              9543.463
            ],
            [
              -4255.439,
              676.425,
              9585.166
            ],
            [
              -4279.313,
              674.524,
              9609.116
            ],
            [
              -4304.422,
              677.184,
              9634.365
            ],
            [
              -4330.724,
              685.43,
              9661.929
            ],
            [
              -4370.887,
              712.839,
              9710.554
            ],
            [
              -4391.801,
              734.351,
              9740.556
            ],
            [
              -4418.25,
              771.542,
              9786.193
            ],
            [
              -4423.862,
              782.771,
              9798.747
            ],
            [
              -4434.781,
              784.705,
              9809.835
            ],
            [
              -4479.393,
              779.274,
              9854.777
            ],
            [
              -4503.366,
              773.007,
              9879.556
            ],
            [
              -4524.836,
              762.245,
              9903.572
            ],
            [
              -4546.478,
              741.466,
              9933.574
            ],
            [
              -4558.582,
              712.731,
              9964.754
            ],
            [
              -4564.028,
              688.195,
              9989.888
            ],
            [
              -4562.176,
              653.793,
              10024.339
            ],
            [
              -4542.083,
              471.996,
              10207.243
            ],
            [
              -4535.565,
              436.694,
              10243.142
            ],
            [
              -4533.311,
              419.524,
              10260.459
            ],
            [
              -4527.744,
              368.221,
              10312.064
            ],
            [
              -4516.259,
              323.495,
              10358.241
            ],
            [
              -4491.638,
              255.166,
              10430.87
            ],
            [
              -4427.619,
              152.763,
              10551.638
            ],
            [
              -4367.011,
              77.134,
              10648.556
            ],
            [
              -4080.333,
              -210.913,
              11054.949
            ],
            [
              -3954.469,
              -380.846,
              11266.417
            ],
            [
              -3926.158,
              -422.036,
              11316.399
            ],
            [
              -3919.036,
              -433.74,
              11330.099
            ],
            [
              -3857.936,
              -540.596,
              11453.19
            ],
            [
              -3823.641,
              -607.984,
              11528.803
            ],
            [
              -3766.483,
              -732.543,
              11665.85
            ],
            [
              -3707.64,
              -908.34,
              11851.234
            ],
            [
              -3695.741,
              -928.584,
              11874.716
            ],
            [
              -3679.687,
              -950.175,
              11901.621
            ],
            [
              -3673.878,
              -969.04,
              11921.361
            ],
            [
              -3654.555,
              -1007.226,
              11964.157
            ],
            [
              -3618.264,
              -1069.098,
              12035.887
            ],
            [
              -3593.482,
              -1128.516,
              12100.266
            ],
            [
              -3583.125,
              -1163.206,
              12136.469
            ],
            [
              -3584.647,
              -1176.538,
              12149.888
            ],
            [
              -3590.504,
              -1187.291,
              12162.133
            ],
            [
              -3593.981,
              -1194.186,
              12169.855
            ],
            [
              -3599.82,
              -1196.311,
              12176.068
            ],
            [
              -3626.266,
              -1196.964,
              12202.522
            ],
            [
              -3684.51,
              -1178.609,
              12263.59
            ],
            [
              -3714.349,
              -1169.288,
              12294.851
            ],
            [
              -3768.714,
              -1158.717,
              12350.234
            ],
            [
              -3858.305,
              -1156.194,
              12439.861
            ],
            [
              -4237.967,
              -1188.581,
              12820.902
            ],
            [
              -4268.356,
              -1193.623,
              12851.706
            ],
            [
              -4296.043,
              -1199.905,
              12880.097
            ],
            [
              -4333.704,
              -1206.966,
              12918.414
            ],
            [
              -4364.15,
              -1215.347,
              12949.992
            ],
            [
              -4597.068,
              -1300.392,
              13197.951
            ],
            [
              -4637.998,
              -1318.612,
              13242.753
            ],
            [
              -4714.189,
              -1362.945,
              13330.904
            ],
            [
              -4755.992,
              -1394.51,
              13383.285
            ],
            [
              -4809.036,
              -1442.581,
              13454.871
            ],
            [
              -4835.962,
              -1480.117,
              13501.065
            ],
            [
              -5092.18,
              -1789.506,
              13902.773
            ],
            [
              -5145.16,
              -1834.242,
              13972.115
            ],
            [
              -5263.682,
              -1904.577,
              14109.935
            ],
            [
              -5341.696,
              -1943.323,
              14197.041
            ],
            [
              -5353.315,
              -1944.238,
              14208.696
            ],
            [
              -5858.685,
              -2210.618,
              14779.973
            ],
            [
              -5881.906,
              -2223.697,
              14806.623
            ],
            [
              -6049.087,
              -2302.022,
              14991.243
            ],
            [
              -6102.245,
              -2320.049,
              15047.374
            ],
            [
              -6166.945,
              -2334.543,
              15113.678
            ],
            [
              -6282.53,
              -2341.97,
              15229.502
            ],
            [
              -6377.159,
              -2339.91,
              15324.153
            ],
            [
              -6675.557,
              -2338.243,
              15622.555
            ],
            [
              -6684.39,
              -2262.232,
              15699.078
            ],
            [
              -6668.455,
              -1991.046,
              15970.732
            ],
            [
              -6680.407,
              -1819.414,
              16142.779
            ],
            [
              -6680.925,
              -1734.803,
              16227.392
            ],
            [
              -6684.251,
              -1702.465,
              16259.901
            ],
            [
              -6705.09,
              -1676.513,
              16293.184
            ],
            [
              -6747.127,
              -1568.943,
              16408.676
            ],
            [
              -6771.666,
              -1532.911,
              16452.27
            ],
            [
              -6834.733,
              -1410.519,
              16589.956
            ],
            [
              -6861.847,
              -1368.999,
              16639.545
            ],
            [
              -6868.44,
              -1344.278,
              16665.13
            ],
            [
              -6865.755,
              -1340.811,
              16669.515
            ],
            [
              -6856.389,
              -1336.272,
              16679.923
            ],
            [
              -6847.396,
              -1333.735,
              16689.266
            ],
            [
              -6839.19,
              -1361.045,
              16717.783
            ],
            [
              -6825.084,
              -1411.793,
              16770.455
            ],
            [
              -6801.411,
              -1461.169,
              16825.212
            ],
            [
              -6771.957,
              -1511.755,
              16883.748
            ],
            [
              -6765.128,
              -1527.454,
              16900.868
            ],
            [
              -6769.807,
              -1537.394,
              16911.855
            ],
            [
              -6771.141,
              -1540.619,
              16915.345
            ],
            [
              -6827.09,
              -1597.371,
              16995.038
            ],
            [
              -6841.227,
              -1604.648,
              17010.938
            ],
            [
              -6863.189,
              -1570.343,
              17051.671
            ],
            [
              -6866.907,
              -1561.375,
              17061.379
            ],
            [
              -6864.843,
              -1553.618,
              17069.406
            ],
            [
              -6782.722,
              -1517.922,
              17158.95
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:3590",
              "position": {
                "x": 419.803,
                "z": 1922.424
              },
              "distanceAlongShapeM": 414.941,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:6650",
              "position": {
                "x": -11.424,
                "z": 1732.135
              },
              "distanceAlongShapeM": 915.628,
              "shapeOffsetM": 0.239,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:5168",
              "position": {
                "x": -529.526,
                "z": 1766.021
              },
              "distanceAlongShapeM": 1510.414,
              "shapeOffsetM": 1.107,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:6853",
              "position": {
                "x": -679.739,
                "z": 1093.006
              },
              "distanceAlongShapeM": 2200.471,
              "shapeOffsetM": 3.689,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:5579",
              "position": {
                "x": -1168.303,
                "z": 971.551
              },
              "distanceAlongShapeM": 2926.576,
              "shapeOffsetM": 2.518,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:6343",
              "position": {
                "x": -1502.183,
                "z": 1274.758
              },
              "distanceAlongShapeM": 3378.555,
              "shapeOffsetM": 1.34,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:7852",
              "position": {
                "x": -1970.62,
                "z": 1705.012
              },
              "distanceAlongShapeM": 4014.827,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            },
            {
              "stopId": "judu:stop:5532",
              "position": {
                "x": -2290.557,
                "z": 2000.118
              },
              "distanceAlongShapeM": 4450.348,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:6338",
              "position": {
                "x": -2690.837,
                "z": 2168.596
              },
              "distanceAlongShapeM": 4947.225,
              "shapeOffsetM": 4.045,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:6353",
              "position": {
                "x": -4082.845,
                "z": 2002.521
              },
              "distanceAlongShapeM": 6394.071,
              "shapeOffsetM": 4.512,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            },
            {
              "stopId": "judu:stop:6351",
              "position": {
                "x": -4474.572,
                "z": 2071.617
              },
              "distanceAlongShapeM": 6793.788,
              "shapeOffsetM": 3.435,
              "arrivalOffsetSeconds": 1380,
              "departureOffsetSeconds": 1380
            },
            {
              "stopId": "judu:stop:437",
              "position": {
                "x": -4928.804,
                "z": 1730.978
              },
              "distanceAlongShapeM": 7648.05,
              "shapeOffsetM": 3.896,
              "arrivalOffsetSeconds": 1500,
              "departureOffsetSeconds": 1500
            },
            {
              "stopId": "judu:stop:783",
              "position": {
                "x": -4739.606,
                "z": 1552.966
              },
              "distanceAlongShapeM": 7910.625,
              "shapeOffsetM": 3.604,
              "arrivalOffsetSeconds": 1560,
              "departureOffsetSeconds": 1560
            },
            {
              "stopId": "judu:stop:3589",
              "position": {
                "x": -4466.279,
                "z": 1391.309
              },
              "distanceAlongShapeM": 8229.865,
              "shapeOffsetM": 2.273,
              "arrivalOffsetSeconds": 1620,
              "departureOffsetSeconds": 1620
            },
            {
              "stopId": "judu:stop:6317",
              "position": {
                "x": -4197.987,
                "z": 1275.363
              },
              "distanceAlongShapeM": 8523.973,
              "shapeOffsetM": 4.495,
              "arrivalOffsetSeconds": 1680,
              "departureOffsetSeconds": 1680
            },
            {
              "stopId": "judu:stop:5701",
              "position": {
                "x": -3876.172,
                "z": 1010.417
              },
              "distanceAlongShapeM": 9041.839,
              "shapeOffsetM": 4.978,
              "arrivalOffsetSeconds": 1800,
              "departureOffsetSeconds": 1800
            },
            {
              "stopId": "judu:stop:5704",
              "position": {
                "x": -4175.491,
                "z": 710.581
              },
              "distanceAlongShapeM": 9498.7,
              "shapeOffsetM": 4.809,
              "arrivalOffsetSeconds": 1860,
              "departureOffsetSeconds": 1860
            },
            {
              "stopId": "judu:stop:1071",
              "position": {
                "x": -4530.426,
                "z": 437.286
              },
              "distanceAlongShapeM": 10243.224,
              "shapeOffsetM": 5.172,
              "arrivalOffsetSeconds": 1980,
              "departureOffsetSeconds": 1980
            },
            {
              "stopId": "judu:stop:1004",
              "position": {
                "x": -4077.229,
                "z": -208.399
              },
              "distanceAlongShapeM": 11054.949,
              "shapeOffsetM": 3.995,
              "arrivalOffsetSeconds": 2100,
              "departureOffsetSeconds": 2100
            },
            {
              "stopId": "judu:stop:6649",
              "position": {
                "x": -3921.604,
                "z": -419.265
              },
              "distanceAlongShapeM": 11316.399,
              "shapeOffsetM": 5.33,
              "arrivalOffsetSeconds": 2160,
              "departureOffsetSeconds": 2160
            },
            {
              "stopId": "judu:stop:6643",
              "position": {
                "x": -3679.35,
                "z": -950.021
              },
              "distanceAlongShapeM": 11901.621,
              "shapeOffsetM": 0.37,
              "arrivalOffsetSeconds": 2220,
              "departureOffsetSeconds": 2220
            },
            {
              "stopId": "judu:stop:4991",
              "position": {
                "x": -3688.025,
                "z": -1189.21
              },
              "distanceAlongShapeM": 12263.785,
              "shapeOffsetM": 11.167,
              "arrivalOffsetSeconds": 2340,
              "departureOffsetSeconds": 2340
            },
            {
              "stopId": "judu:stop:4988",
              "position": {
                "x": -4294.993,
                "z": -1205.408
              },
              "distanceAlongShapeM": 12880.097,
              "shapeOffsetM": 5.602,
              "arrivalOffsetSeconds": 2460,
              "departureOffsetSeconds": 2460
            },
            {
              "stopId": "judu:stop:8060",
              "position": {
                "x": -4834.84,
                "z": -1481.101
              },
              "distanceAlongShapeM": 13501.108,
              "shapeOffsetM": 1.492,
              "arrivalOffsetSeconds": 2580,
              "departureOffsetSeconds": 2580
            },
            {
              "stopId": "judu:stop:7947",
              "position": {
                "x": -5880.858,
                "z": -2225.828
              },
              "distanceAlongShapeM": 14806.623,
              "shapeOffsetM": 2.374,
              "arrivalOffsetSeconds": 2700,
              "departureOffsetSeconds": 2700
            },
            {
              "stopId": "judu:stop:7948",
              "position": {
                "x": -6282.493,
                "z": -2344.842
              },
              "distanceAlongShapeM": 15229.502,
              "shapeOffsetM": 2.873,
              "arrivalOffsetSeconds": 2820,
              "departureOffsetSeconds": 2820
            },
            {
              "stopId": "judu:stop:7959",
              "position": {
                "x": -6689.755,
                "z": -2262.309
              },
              "distanceAlongShapeM": 15699.078,
              "shapeOffsetM": 5.365,
              "arrivalOffsetSeconds": 2940,
              "departureOffsetSeconds": 2940
            },
            {
              "stopId": "judu:stop:7695",
              "position": {
                "x": -6705.09,
                "z": -1676.513
              },
              "distanceAlongShapeM": 16293.184,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 3060,
              "departureOffsetSeconds": 3060
            },
            {
              "stopId": "judu:stop:7693",
              "position": {
                "x": -6863.711,
                "z": -1369.96
              },
              "distanceAlongShapeM": 16639.545,
              "shapeOffsetM": 2.097,
              "arrivalOffsetSeconds": 3120,
              "departureOffsetSeconds": 3120
            }
          ],
          "departuresSeconds": [
            20760,
            22440,
            24240,
            26400,
            27960,
            30240,
            32340,
            34440,
            37560,
            39660,
            41760,
            43980,
            45180,
            46920,
            49020,
            51120,
            52500,
            54480,
            56520,
            58680,
            60180,
            62460,
            64740,
            67020,
            70500,
            72540,
            74520,
            76560,
            77940,
            79440,
            81480,
            83220
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_bus_55",
      "sourceRouteId": "vilnius_bus_55",
      "mode": "bus",
      "shortName": "55",
      "longName": "Šiltnamių g.–Laisvės pr.–Fabijoniškės–Santariškės",
      "color": "0073AC",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_bus_55:0",
          "sourceRouteId": "vilnius_bus_55",
          "sourceShapeId": "vilnius_bus_55_a-b",
          "directionId": 0,
          "headsign": "Santariškės",
          "directionName": "Šiltnamių g.–Laisvės pr.–Fabijoniškės–Santariškės",
          "mode": "bus",
          "routeShortName": "55",
          "routeLongName": "Šiltnamių g.–Laisvės pr.–Fabijoniškės–Santariškės",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              -3610.504,
              2454.257,
              0
            ],
            [
              -3634.498,
              2448.213,
              24.744
            ],
            [
              -3763.252,
              2424.454,
              155.672
            ],
            [
              -3801.704,
              2417.669,
              194.718
            ],
            [
              -3851.741,
              2410.714,
              245.235
            ],
            [
              -3886.236,
              2402.097,
              280.791
            ],
            [
              -3907.032,
              2393.551,
              303.274
            ],
            [
              -3968.552,
              2343.41,
              382.639
            ],
            [
              -4007.194,
              2316.209,
              429.895
            ],
            [
              -4079.923,
              2267.378,
              517.496
            ],
            [
              -4114.659,
              2244.056,
              559.335
            ],
            [
              -4157.489,
              2223.171,
              606.986
            ],
            [
              -4325.05,
              2156.176,
              787.444
            ],
            [
              -4375.253,
              2139.958,
              840.201
            ],
            [
              -4407.029,
              2135.374,
              872.306
            ],
            [
              -4517.705,
              2137.698,
              983.007
            ],
            [
              -4577.32,
              2138.604,
              1042.629
            ],
            [
              -4634.125,
              2135.585,
              1099.514
            ],
            [
              -4816.04,
              2099.743,
              1284.926
            ],
            [
              -4855.442,
              2097.078,
              1324.418
            ],
            [
              -4917.969,
              2100.374,
              1387.032
            ],
            [
              -4969.474,
              2106.821,
              1438.939
            ],
            [
              -5079.485,
              2125.398,
              1550.507
            ],
            [
              -5115.548,
              2129.353,
              1586.787
            ],
            [
              -5151.268,
              2124.22,
              1622.873
            ],
            [
              -5168.723,
              2123.338,
              1640.351
            ],
            [
              -5186.285,
              2118.906,
              1658.464
            ],
            [
              -5205.39,
              2106.815,
              1681.073
            ],
            [
              -5218.73,
              2094.377,
              1699.312
            ],
            [
              -5232.085,
              2067.888,
              1728.977
            ],
            [
              -5234.987,
              2049.013,
              1748.074
            ],
            [
              -5232.767,
              2027.825,
              1769.378
            ],
            [
              -5229.106,
              2015.517,
              1782.219
            ],
            [
              -5217.174,
              1996.39,
              1804.763
            ],
            [
              -5203.627,
              1982.351,
              1824.272
            ],
            [
              -5082.26,
              1887.222,
              1978.478
            ],
            [
              -5064.922,
              1882.473,
              1996.454
            ],
            [
              -5060.085,
              1863.466,
              2016.067
            ],
            [
              -4961.259,
              1757.137,
              2161.231
            ],
            [
              -4931.684,
              1728.355,
              2202.499
            ],
            [
              -4906.917,
              1690.529,
              2247.712
            ],
            [
              -4953.434,
              1637.843,
              2317.995
            ],
            [
              -4966.71,
              1626.986,
              2335.145
            ],
            [
              -4976.574,
              1616.023,
              2349.892
            ],
            [
              -4993.932,
              1581.81,
              2388.257
            ],
            [
              -4999.643,
              1549.625,
              2420.944
            ],
            [
              -5000.423,
              1503.997,
              2466.579
            ],
            [
              -4985.973,
              1443.638,
              2528.644
            ],
            [
              -4965.718,
              1383.179,
              2592.405
            ],
            [
              -4931.334,
              1319.138,
              2665.093
            ],
            [
              -4880.829,
              1254.822,
              2746.869
            ],
            [
              -4857.956,
              1234.393,
              2777.537
            ],
            [
              -4836.703,
              1220.787,
              2802.772
            ],
            [
              -4813.463,
              1195.782,
              2836.909
            ],
            [
              -4785.375,
              1178.602,
              2869.835
            ],
            [
              -4668.299,
              1122.047,
              2999.855
            ],
            [
              -4620.374,
              1095.621,
              3054.583
            ],
            [
              -4574.442,
              1065.888,
              3109.298
            ],
            [
              -4541.69,
              1036.656,
              3153.198
            ],
            [
              -4444.368,
              865.501,
              3350.088
            ],
            [
              -4435.059,
              844.19,
              3373.344
            ],
            [
              -4426.154,
              799.508,
              3418.904
            ],
            [
              -4427.673,
              786.176,
              3432.323
            ],
            [
              -4431.619,
              781.791,
              3438.222
            ],
            [
              -4460.655,
              781.178,
              3467.264
            ],
            [
              -4494.281,
              776.19,
              3501.258
            ],
            [
              -4520.265,
              765.505,
              3529.353
            ],
            [
              -4539.27,
              748.021,
              3555.177
            ],
            [
              -4555.01,
              724.869,
              3583.173
            ],
            [
              -4560.516,
              698.28,
              3610.326
            ],
            [
              -4562.176,
              653.793,
              3654.844
            ],
            [
              -4542.083,
              471.996,
              3837.748
            ],
            [
              -4535.565,
              436.694,
              3873.646
            ],
            [
              -4533.311,
              419.524,
              3890.964
            ],
            [
              -4527.744,
              368.221,
              3942.568
            ],
            [
              -4516.259,
              323.495,
              3988.745
            ],
            [
              -4491.638,
              255.166,
              4061.375
            ],
            [
              -4427.619,
              152.763,
              4182.142
            ],
            [
              -4367.011,
              77.134,
              4279.06
            ],
            [
              -4080.333,
              -210.913,
              4685.453
            ],
            [
              -3954.469,
              -380.846,
              4896.922
            ],
            [
              -3926.158,
              -422.036,
              4946.903
            ],
            [
              -3919.036,
              -433.74,
              4960.604
            ],
            [
              -3857.936,
              -540.596,
              5083.695
            ],
            [
              -3823.641,
              -607.984,
              5159.308
            ],
            [
              -3766.483,
              -732.543,
              5296.355
            ],
            [
              -3707.64,
              -908.34,
              5481.739
            ],
            [
              -3695.741,
              -928.584,
              5505.221
            ],
            [
              -3679.687,
              -950.175,
              5532.126
            ],
            [
              -3673.878,
              -969.04,
              5551.865
            ],
            [
              -3654.555,
              -1007.226,
              5594.662
            ],
            [
              -3618.264,
              -1069.098,
              5666.392
            ],
            [
              -3599.031,
              -1113.947,
              5715.191
            ],
            [
              -3569.469,
              -1193.5,
              5800.059
            ],
            [
              -3554.873,
              -1243.849,
              5852.481
            ],
            [
              -3546.348,
              -1270.446,
              5880.411
            ],
            [
              -3520.478,
              -1415.883,
              6028.131
            ],
            [
              -3500.646,
              -1498.607,
              6113.199
            ],
            [
              -3461.302,
              -1608.388,
              6229.817
            ],
            [
              -3438.975,
              -1658.872,
              6285.018
            ],
            [
              -3424.066,
              -1696.754,
              6325.728
            ],
            [
              -3409.647,
              -1735.195,
              6366.784
            ],
            [
              -3354.323,
              -1899.889,
              6540.523
            ],
            [
              -3343.31,
              -1954.868,
              6596.593
            ],
            [
              -3339.232,
              -2037.994,
              6679.82
            ],
            [
              -3350.012,
              -2176.443,
              6818.687
            ],
            [
              -3368.406,
              -2305.768,
              6949.314
            ],
            [
              -3372.034,
              -2365.819,
              7009.475
            ],
            [
              -3365.771,
              -2420.444,
              7064.458
            ],
            [
              -3338.206,
              -2495.543,
              7144.456
            ],
            [
              -3294.464,
              -2574.233,
              7234.486
            ],
            [
              -3260.996,
              -2616.85,
              7288.674
            ],
            [
              -3240.415,
              -2653.104,
              7330.362
            ],
            [
              -3181.544,
              -2750.984,
              7444.583
            ],
            [
              -3157.274,
              -2800.391,
              7499.629
            ],
            [
              -3108.891,
              -2944.844,
              7651.969
            ],
            [
              -3088.313,
              -3020.904,
              7730.764
            ],
            [
              -3081.131,
              -3038.915,
              7750.154
            ],
            [
              -3066.407,
              -3094.76,
              7807.907
            ],
            [
              -3058.312,
              -3116.524,
              7831.128
            ],
            [
              -3044.503,
              -3168.617,
              7885.02
            ],
            [
              -2983.753,
              -3378.969,
              8103.969
            ],
            [
              -2973.575,
              -3406.127,
              8132.971
            ],
            [
              -2964.33,
              -3447.216,
              8175.088
            ],
            [
              -2935.834,
              -3585.756,
              8316.528
            ],
            [
              -2926.739,
              -3654.936,
              8386.303
            ],
            [
              -2914.467,
              -3799.87,
              8531.756
            ],
            [
              -2911.34,
              -3835.779,
              8567.801
            ],
            [
              -2910.491,
              -3863.444,
              8595.479
            ],
            [
              -2921.12,
              -4178.248,
              8910.462
            ],
            [
              -2920.043,
              -4206.629,
              8938.864
            ],
            [
              -2916.033,
              -4240.012,
              8972.487
            ],
            [
              -2908.744,
              -4273.666,
              9006.921
            ],
            [
              -2894.838,
              -4317.386,
              9052.799
            ],
            [
              -2876.57,
              -4356.153,
              9095.655
            ],
            [
              -2847.061,
              -4401.954,
              9150.139
            ],
            [
              -2823.799,
              -4432.662,
              9188.663
            ],
            [
              -2759.103,
              -4490.576,
              9275.494
            ],
            [
              -2703.07,
              -4524.178,
              9340.83
            ],
            [
              -2600.663,
              -4562.712,
              9450.247
            ],
            [
              -2523.056,
              -4586.026,
              9531.28
            ],
            [
              -2471.67,
              -4594.727,
              9583.397
            ],
            [
              -2274.597,
              -4634.953,
              9784.534
            ],
            [
              -2190.603,
              -4657.594,
              9871.526
            ],
            [
              -2137.713,
              -4671.9,
              9926.316
            ],
            [
              -2112.872,
              -4685.417,
              9954.597
            ],
            [
              -2099.157,
              -4695.955,
              9971.893
            ],
            [
              -2067.351,
              -4718.784,
              10011.044
            ],
            [
              -2007.683,
              -4768.827,
              10088.919
            ],
            [
              -1998.706,
              -4771.214,
              10098.208
            ],
            [
              -1979.306,
              -4767.106,
              10118.038
            ],
            [
              -1962.099,
              -4770.654,
              10135.607
            ],
            [
              -1951.469,
              -4783.649,
              10152.396
            ],
            [
              -1941.516,
              -4815.647,
              10185.906
            ],
            [
              -1918.262,
              -4848.345,
              10226.03
            ],
            [
              -1854.05,
              -4896.245,
              10306.14
            ],
            [
              -1743.848,
              -4966.117,
              10436.626
            ],
            [
              -1676.24,
              -5004.061,
              10514.154
            ],
            [
              -1627.812,
              -5023.801,
              10566.45
            ],
            [
              -1586.957,
              -5054.639,
              10617.637
            ],
            [
              -1465.895,
              -5129.166,
              10759.8
            ],
            [
              -1407.208,
              -5161.388,
              10826.751
            ],
            [
              -1338.038,
              -5183.78,
              10899.455
            ],
            [
              -1272.777,
              -5203.963,
              10967.766
            ],
            [
              -1246.49,
              -5215.481,
              10996.466
            ],
            [
              -1208.756,
              -5230.63,
              11037.127
            ],
            [
              -1099.904,
              -5267.098,
              11151.925
            ],
            [
              -1057.683,
              -5283.443,
              11197.2
            ],
            [
              -934.323,
              -5346.656,
              11335.813
            ],
            [
              -827.457,
              -5404.886,
              11457.514
            ],
            [
              -674.33,
              -5492.97,
              11634.168
            ],
            [
              -590.252,
              -5533.933,
              11727.693
            ],
            [
              -565.267,
              -5552.833,
              11759.022
            ],
            [
              -421.759,
              -5631.135,
              11922.502
            ],
            [
              -383.93,
              -5640.727,
              11961.528
            ],
            [
              -342.157,
              -5645.939,
              12003.625
            ],
            [
              -257.182,
              -5648.596,
              12088.641
            ],
            [
              -196.756,
              -5655.261,
              12149.434
            ],
            [
              -180.177,
              -5664.469,
              12168.398
            ],
            [
              -177.649,
              -5676.666,
              12180.855
            ],
            [
              -188.191,
              -5725.09,
              12230.413
            ],
            [
              -190.648,
              -5736.736,
              12242.315
            ],
            [
              -196.91,
              -5769.923,
              12276.088
            ],
            [
              -201.665,
              -5818.819,
              12325.214
            ],
            [
              -201.086,
              -5857.793,
              12364.193
            ],
            [
              -195.599,
              -5910.215,
              12416.901
            ],
            [
              -136.015,
              -6175.138,
              12688.442
            ],
            [
              -127.679,
              -6205.529,
              12719.955
            ],
            [
              -123.468,
              -6228.802,
              12743.606
            ],
            [
              -113.557,
              -6285.758,
              12801.418
            ],
            [
              -58.166,
              -6532.794,
              13054.588
            ],
            [
              -46.468,
              -6597.576,
              13120.418
            ],
            [
              -39.377,
              -6667.839,
              13191.038
            ],
            [
              -35.045,
              -6748.072,
              13271.388
            ],
            [
              -26.235,
              -6767.677,
              13292.881
            ],
            [
              -16.413,
              -6780.218,
              13308.811
            ],
            [
              0.443,
              -6790.505,
              13328.558
            ],
            [
              9.552,
              -6811.226,
              13351.192
            ],
            [
              9.735,
              -6827.796,
              13367.764
            ],
            [
              7.024,
              -6842.352,
              13382.57
            ],
            [
              -10.864,
              -6869.857,
              13415.38
            ],
            [
              -21.671,
              -6897.49,
              13445.051
            ],
            [
              -11.966,
              -6926.765,
              13475.892
            ],
            [
              -9.853,
              -6955.595,
              13504.8
            ],
            [
              6.027,
              -7144.023,
              13693.896
            ],
            [
              11.629,
              -7176.924,
              13727.27
            ],
            [
              9.978,
              -7209.777,
              13760.165
            ],
            [
              38.024,
              -7507.525,
              14059.231
            ],
            [
              44.494,
              -7541.041,
              14093.366
            ],
            [
              46.371,
              -7614.549,
              14166.898
            ],
            [
              74.723,
              -7859.981,
              14413.962
            ],
            [
              95.181,
              -7883.513,
              14445.143
            ],
            [
              82.416,
              -7930.335,
              14493.674
            ],
            [
              87.139,
              -8026.082,
              14589.537
            ],
            [
              96.148,
              -8132.005,
              14695.843
            ],
            [
              107.811,
              -8233.524,
              14798.03
            ],
            [
              115.822,
              -8265.129,
              14830.634
            ],
            [
              113.324,
              -8319.345,
              14884.907
            ],
            [
              119.934,
              -8345.07,
              14911.468
            ],
            [
              124.397,
              -8357.922,
              14925.073
            ],
            [
              125.966,
              -8374.275,
              14941.501
            ],
            [
              129.247,
              -8412.532,
              14979.899
            ],
            [
              129.399,
              -8415.69,
              14983.06
            ],
            [
              123.699,
              -8420.84,
              14990.742
            ],
            [
              117.67,
              -8418.478,
              14997.218
            ],
            [
              117.448,
              -8413.871,
              15001.83
            ],
            [
              115.093,
              -8384.787,
              15031.009
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:9965",
              "position": {
                "x": -3606.234,
                "z": 2437.31
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 17.477,
              "arrivalOffsetSeconds": -900,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:6387",
              "position": {
                "x": -4156.496,
                "z": 2220.868
              },
              "distanceAlongShapeM": 606.986,
              "shapeOffsetM": 2.508,
              "arrivalOffsetSeconds": 60,
              "departureOffsetSeconds": 60
            },
            {
              "stopId": "judu:stop:6381",
              "position": {
                "x": -4518.062,
                "z": 2131.364
              },
              "distanceAlongShapeM": 983.267,
              "shapeOffsetM": 6.338,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:756",
              "position": {
                "x": -5151.175,
                "z": 2121.056
              },
              "distanceAlongShapeM": 1622.94,
              "shapeOffsetM": 3.165,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:7350",
              "position": {
                "x": -4952.35,
                "z": 1636.759
              },
              "distanceAlongShapeM": 2317.995,
              "shapeOffsetM": 1.533,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:329",
              "position": {
                "x": -4834.931,
                "z": 1222.866
              },
              "distanceAlongShapeM": 2802.772,
              "shapeOffsetM": 2.732,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:4395",
              "position": {
                "x": -4540.743,
                "z": 1037.479
              },
              "distanceAlongShapeM": 3153.198,
              "shapeOffsetM": 1.254,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:1071",
              "position": {
                "x": -4530.426,
                "z": 437.286
              },
              "distanceAlongShapeM": 3873.729,
              "shapeOffsetM": 5.172,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:1004",
              "position": {
                "x": -4077.229,
                "z": -208.399
              },
              "distanceAlongShapeM": 4685.453,
              "shapeOffsetM": 3.995,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:6649",
              "position": {
                "x": -3921.604,
                "z": -419.265
              },
              "distanceAlongShapeM": 4946.903,
              "shapeOffsetM": 5.33,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:6643",
              "position": {
                "x": -3679.35,
                "z": -950.021
              },
              "distanceAlongShapeM": 5532.126,
              "shapeOffsetM": 0.37,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:4990",
              "position": {
                "x": -3543.073,
                "z": -1269.659
              },
              "distanceAlongShapeM": 5880.411,
              "shapeOffsetM": 3.368,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:5722",
              "position": {
                "x": -3418.974,
                "z": -1694.844
              },
              "distanceAlongShapeM": 6325.728,
              "shapeOffsetM": 5.439,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:6472",
              "position": {
                "x": -3345.53,
                "z": -2177.035
              },
              "distanceAlongShapeM": 6818.687,
              "shapeOffsetM": 4.521,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:6651",
              "position": {
                "x": -3256.485,
                "z": -2613.86
              },
              "distanceAlongShapeM": 7288.674,
              "shapeOffsetM": 5.412,
              "arrivalOffsetSeconds": 1380,
              "departureOffsetSeconds": 1380
            },
            {
              "stopId": "judu:stop:5067",
              "position": {
                "x": -3053.229,
                "z": -3115.03
              },
              "distanceAlongShapeM": 7831.128,
              "shapeOffsetM": 5.298,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            },
            {
              "stopId": "judu:stop:6479",
              "position": {
                "x": -2968.741,
                "z": -3404.837
              },
              "distanceAlongShapeM": 8132.971,
              "shapeOffsetM": 5.004,
              "arrivalOffsetSeconds": 1500,
              "departureOffsetSeconds": 1500
            },
            {
              "stopId": "judu:stop:6481",
              "position": {
                "x": -2906.719,
                "z": -3835.629
              },
              "distanceAlongShapeM": 8567.801,
              "shapeOffsetM": 4.623,
              "arrivalOffsetSeconds": 1560,
              "departureOffsetSeconds": 1560
            },
            {
              "stopId": "judu:stop:6653",
              "position": {
                "x": -2914.524,
                "z": -4206.195
              },
              "distanceAlongShapeM": 8939.091,
              "shapeOffsetM": 5.531,
              "arrivalOffsetSeconds": 1680,
              "departureOffsetSeconds": 1680
            },
            {
              "stopId": "judu:stop:8268",
              "position": {
                "x": -2701.004,
                "z": -4520.544
              },
              "distanceAlongShapeM": 9341.483,
              "shapeOffsetM": 4.129,
              "arrivalOffsetSeconds": 1800,
              "departureOffsetSeconds": 1800
            },
            {
              "stopId": "judu:stop:5804",
              "position": {
                "x": -2134.709,
                "z": -4666.379
              },
              "distanceAlongShapeM": 9926.316,
              "shapeOffsetM": 6.285,
              "arrivalOffsetSeconds": 1920,
              "departureOffsetSeconds": 1920
            },
            {
              "stopId": "judu:stop:5808",
              "position": {
                "x": -1961.313,
                "z": -4769.653
              },
              "distanceAlongShapeM": 10135.607,
              "shapeOffsetM": 1.273,
              "arrivalOffsetSeconds": 1980,
              "departureOffsetSeconds": 1980
            },
            {
              "stopId": "judu:stop:5810",
              "position": {
                "x": -1625.643,
                "z": -5020.551
              },
              "distanceAlongShapeM": 10566.45,
              "shapeOffsetM": 3.907,
              "arrivalOffsetSeconds": 2040,
              "departureOffsetSeconds": 2040
            },
            {
              "stopId": "judu:stop:5815",
              "position": {
                "x": -1271.325,
                "z": -5199.449
              },
              "distanceAlongShapeM": 10967.766,
              "shapeOffsetM": 4.742,
              "arrivalOffsetSeconds": 2100,
              "departureOffsetSeconds": 2100
            },
            {
              "stopId": "judu:stop:5828",
              "position": {
                "x": -826.661,
                "z": -5403.385
              },
              "distanceAlongShapeM": 11457.494,
              "shapeOffsetM": 1.699,
              "arrivalOffsetSeconds": 2220,
              "departureOffsetSeconds": 2220
            },
            {
              "stopId": "judu:stop:6633",
              "position": {
                "x": -589.373,
                "z": -5532.358
              },
              "distanceAlongShapeM": 11727.693,
              "shapeOffsetM": 1.804,
              "arrivalOffsetSeconds": 2280,
              "departureOffsetSeconds": 2280
            },
            {
              "stopId": "judu:stop:6497",
              "position": {
                "x": -185.377,
                "z": -5737.848
              },
              "distanceAlongShapeM": 12242.43,
              "shapeOffsetM": 5.386,
              "arrivalOffsetSeconds": 2460,
              "departureOffsetSeconds": 2460
            },
            {
              "stopId": "judu:stop:6500",
              "position": {
                "x": -122.378,
                "z": -6204.331
              },
              "distanceAlongShapeM": 12719.955,
              "shapeOffsetM": 5.434,
              "arrivalOffsetSeconds": 2520,
              "departureOffsetSeconds": 2520
            },
            {
              "stopId": "judu:stop:6525",
              "position": {
                "x": -10.612,
                "z": -6926.637
              },
              "distanceAlongShapeM": 13475.892,
              "shapeOffsetM": 1.36,
              "arrivalOffsetSeconds": 2640,
              "departureOffsetSeconds": 2640
            },
            {
              "stopId": "judu:stop:6532",
              "position": {
                "x": 16.38,
                "z": -7176.496
              },
              "distanceAlongShapeM": 13727.27,
              "shapeOffsetM": 4.77,
              "arrivalOffsetSeconds": 2700,
              "departureOffsetSeconds": 2700
            },
            {
              "stopId": "judu:stop:8716",
              "position": {
                "x": 44.494,
                "z": -7541.041
              },
              "distanceAlongShapeM": 14093.366,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2760,
              "departureOffsetSeconds": 2760
            },
            {
              "stopId": "judu:stop:7826",
              "position": {
                "x": 84.573,
                "z": -7884.653
              },
              "distanceAlongShapeM": 14439.044,
              "shapeOffsetM": 8.753,
              "arrivalOffsetSeconds": 2820,
              "departureOffsetSeconds": 2820
            },
            {
              "stopId": "judu:stop:16649",
              "position": {
                "x": 118.182,
                "z": -8264.884
              },
              "distanceAlongShapeM": 14830.634,
              "shapeOffsetM": 2.373,
              "arrivalOffsetSeconds": 2880,
              "departureOffsetSeconds": 2880
            }
          ],
          "departuresSeconds": [
            18420,
            20100,
            21780,
            23820,
            25560,
            27480,
            29400,
            31200,
            32580,
            34920,
            36660,
            38220,
            39780,
            42600,
            45540,
            47640,
            50280,
            52860,
            54960,
            56760,
            58320,
            59940,
            61560,
            63180,
            65340,
            67500,
            68880,
            70320,
            72900,
            75000,
            77280,
            79560,
            81780
          ]
        },
        {
          "id": "judu:pattern:vilnius_bus_55:1",
          "sourceRouteId": "vilnius_bus_55",
          "sourceShapeId": "vilnius_bus_55_b-a",
          "directionId": 1,
          "headsign": "Šiltnamių g.",
          "directionName": "Santariškės–Fabijoniškės–Laisvės pr.–Šiltnamių g.",
          "mode": "bus",
          "routeShortName": "55",
          "routeLongName": "Šiltnamių g.–Laisvės pr.–Fabijoniškės–Santariškės",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              115.093,
              -8384.787,
              0
            ],
            [
              113.12,
              -8330.473,
              54.35
            ],
            [
              110.052,
              -8287.001,
              97.93
            ],
            [
              60.212,
              -7808.507,
              579.013
            ],
            [
              55.915,
              -7784.559,
              603.343
            ],
            [
              54.874,
              -7748.294,
              639.623
            ],
            [
              42.293,
              -7591.096,
              797.324
            ],
            [
              26.258,
              -7471.636,
              917.856
            ],
            [
              8.189,
              -7201.951,
              1188.145
            ],
            [
              -2.477,
              -7116.037,
              1274.719
            ],
            [
              -10.317,
              -7079.698,
              1311.894
            ],
            [
              -10.894,
              -7047.975,
              1343.622
            ],
            [
              -21.671,
              -6897.49,
              1494.492
            ],
            [
              -33.557,
              -6878.349,
              1517.023
            ],
            [
              -59.463,
              -6851.158,
              1554.58
            ],
            [
              -67.548,
              -6835.425,
              1572.269
            ],
            [
              -70.502,
              -6820.899,
              1587.092
            ],
            [
              -64.262,
              -6796.522,
              1612.255
            ],
            [
              -53.909,
              -6786.595,
              1626.598
            ],
            [
              -43.463,
              -6771.142,
              1645.251
            ],
            [
              -44.234,
              -6722.3,
              1694.099
            ],
            [
              -50.641,
              -6695.446,
              1721.706
            ],
            [
              -48.526,
              -6639.841,
              1777.352
            ],
            [
              -52.099,
              -6588.567,
              1828.75
            ],
            [
              -70.555,
              -6505.85,
              1913.501
            ],
            [
              -125.166,
              -6286.66,
              2139.392
            ],
            [
              -158.525,
              -6137.991,
              2291.757
            ],
            [
              -180.294,
              -6069.166,
              2363.943
            ],
            [
              -186.217,
              -6031.729,
              2401.846
            ],
            [
              -210.448,
              -5912.171,
              2523.835
            ],
            [
              -214.688,
              -5861.998,
              2574.186
            ],
            [
              -215.425,
              -5796.303,
              2639.885
            ],
            [
              -210.007,
              -5746.306,
              2690.175
            ],
            [
              -195.772,
              -5671.978,
              2765.854
            ],
            [
              -200.158,
              -5665.219,
              2773.911
            ],
            [
              -245.834,
              -5662.161,
              2819.69
            ],
            [
              -275.267,
              -5661.057,
              2849.143
            ],
            [
              -299.862,
              -5657.84,
              2873.948
            ],
            [
              -394.957,
              -5644.98,
              2969.908
            ],
            [
              -428.258,
              -5634.356,
              3004.863
            ],
            [
              -633.019,
              -5523.775,
              3237.576
            ],
            [
              -662.96,
              -5509.616,
              3270.696
            ],
            [
              -740.412,
              -5464.845,
              3360.157
            ],
            [
              -765.768,
              -5455.693,
              3387.114
            ],
            [
              -887.614,
              -5390.039,
              3525.522
            ],
            [
              -926.205,
              -5371.757,
              3568.225
            ],
            [
              -1090.384,
              -5275.062,
              3758.763
            ],
            [
              -1302.999,
              -5205.56,
              3982.449
            ],
            [
              -1387.113,
              -5180.474,
              4070.224
            ],
            [
              -1687.713,
              -4997.177,
              4422.301
            ],
            [
              -1731.791,
              -4976.352,
              4471.051
            ],
            [
              -1759.787,
              -4964.492,
              4501.456
            ],
            [
              -1786.639,
              -4945.316,
              4534.452
            ],
            [
              -1870.695,
              -4890.382,
              4634.867
            ],
            [
              -2020.603,
              -4770.824,
              4826.613
            ],
            [
              -2055.71,
              -4745.4,
              4869.959
            ],
            [
              -2116.546,
              -4695.646,
              4948.549
            ],
            [
              -2169.487,
              -4665.762,
              5009.342
            ],
            [
              -2190.603,
              -4657.594,
              5031.983
            ],
            [
              -2217.593,
              -4653.776,
              5059.242
            ],
            [
              -2245.097,
              -4651.92,
              5086.809
            ],
            [
              -2265.103,
              -4648.113,
              5107.174
            ],
            [
              -2319.72,
              -4636.38,
              5163.036
            ],
            [
              -2647.123,
              -4570.476,
              5497.007
            ],
            [
              -2704.754,
              -4550.534,
              5557.99
            ],
            [
              -2779.661,
              -4504.275,
              5646.03
            ],
            [
              -2804.191,
              -4483.318,
              5678.293
            ],
            [
              -2811.989,
              -4476.099,
              5688.92
            ],
            [
              -2835.666,
              -4448.038,
              5725.635
            ],
            [
              -2880.475,
              -4394.928,
              5795.122
            ],
            [
              -2902.49,
              -4364.484,
              5832.692
            ],
            [
              -2922.066,
              -4325.629,
              5876.201
            ],
            [
              -2938.397,
              -4244.738,
              5958.723
            ],
            [
              -2943.47,
              -4203.459,
              6000.313
            ],
            [
              -2943.332,
              -4158.933,
              6044.839
            ],
            [
              -2942.883,
              -4106.854,
              6096.92
            ],
            [
              -2936.886,
              -4048.837,
              6155.246
            ],
            [
              -2933.232,
              -3950.938,
              6253.213
            ],
            [
              -2933.288,
              -3880.804,
              6323.347
            ],
            [
              -2935.53,
              -3825.104,
              6379.092
            ],
            [
              -2941.624,
              -3778.189,
              6426.401
            ],
            [
              -2941.11,
              -3739.288,
              6465.306
            ],
            [
              -2942.553,
              -3711.432,
              6493.199
            ],
            [
              -2962.772,
              -3578.604,
              6627.557
            ],
            [
              -2994.393,
              -3434.443,
              6775.145
            ],
            [
              -3009.522,
              -3378.516,
              6833.083
            ],
            [
              -3022.156,
              -3343.455,
              6870.351
            ],
            [
              -3029.648,
              -3313.596,
              6901.135
            ],
            [
              -3083.217,
              -3134.541,
              7088.032
            ],
            [
              -3102.428,
              -3054.053,
              7170.78
            ],
            [
              -3135.722,
              -2971.783,
              7259.532
            ],
            [
              -3158.619,
              -2877.179,
              7356.867
            ],
            [
              -3186.209,
              -2796.544,
              7442.092
            ],
            [
              -3248.067,
              -2685.253,
              7569.419
            ],
            [
              -3332.852,
              -2557.976,
              7722.35
            ],
            [
              -3345.044,
              -2540.486,
              7743.67
            ],
            [
              -3361.538,
              -2502.927,
              7784.691
            ],
            [
              -3386.79,
              -2435.693,
              7856.511
            ],
            [
              -3393.431,
              -2409.973,
              7883.074
            ],
            [
              -3395.464,
              -2378.768,
              7914.345
            ],
            [
              -3388.347,
              -2243.256,
              8050.044
            ],
            [
              -3384.424,
              -2226.45,
              8067.302
            ],
            [
              -3365.672,
              -2038.645,
              8256.041
            ],
            [
              -3370.713,
              -1991.384,
              8303.57
            ],
            [
              -3374.974,
              -1943.859,
              8351.285
            ],
            [
              -3391.774,
              -1872.32,
              8424.771
            ],
            [
              -3430.979,
              -1754.748,
              8548.707
            ],
            [
              -3480.186,
              -1619.191,
              8692.919
            ],
            [
              -3508.003,
              -1550.799,
              8766.751
            ],
            [
              -3521.109,
              -1520.135,
              8800.098
            ],
            [
              -3534.455,
              -1477.979,
              8844.317
            ],
            [
              -3620.717,
              -1211.532,
              9124.38
            ],
            [
              -3662.686,
              -1103.933,
              9239.874
            ],
            [
              -3677.364,
              -1066.903,
              9279.707
            ],
            [
              -3720.589,
              -911.454,
              9441.054
            ],
            [
              -3751.424,
              -837.404,
              9521.267
            ],
            [
              -3758.325,
              -817.25,
              9542.57
            ],
            [
              -3766.218,
              -791.548,
              9569.457
            ],
            [
              -3793.988,
              -719.82,
              9646.373
            ],
            [
              -3843.779,
              -616.54,
              9761.028
            ],
            [
              -3881.258,
              -546.871,
              9840.138
            ],
            [
              -3968.352,
              -399.129,
              10011.641
            ],
            [
              -3983.006,
              -376.666,
              10038.461
            ],
            [
              -3999.719,
              -350.005,
              10069.927
            ],
            [
              -4048.201,
              -282.373,
              10153.142
            ],
            [
              -4133.499,
              -180.709,
              10285.849
            ],
            [
              -4196.231,
              -117.271,
              10375.066
            ],
            [
              -4217.103,
              -95.271,
              10405.391
            ],
            [
              -4243.751,
              -67.483,
              10443.892
            ],
            [
              -4402.336,
              85.535,
              10664.264
            ],
            [
              -4449.086,
              142,
              10737.571
            ],
            [
              -4479.797,
              193.736,
              10797.735
            ],
            [
              -4502.905,
              237.549,
              10847.269
            ],
            [
              -4519.036,
              274.562,
              10887.644
            ],
            [
              -4536.228,
              324.952,
              10940.886
            ],
            [
              -4547.048,
              370.78,
              10987.974
            ],
            [
              -4566.578,
              510.266,
              11128.821
            ],
            [
              -4570.606,
              537.669,
              11156.518
            ],
            [
              -4575.517,
              590.57,
              11209.647
            ],
            [
              -4579.623,
              651.866,
              11271.08
            ],
            [
              -4586.366,
              709.869,
              11329.474
            ],
            [
              -4584.541,
              741.007,
              11360.665
            ],
            [
              -4573.306,
              794.248,
              11415.079
            ],
            [
              -4555.909,
              830.684,
              11455.455
            ],
            [
              -4554.824,
              856.269,
              11481.063
            ],
            [
              -4566.917,
              903.232,
              11529.558
            ],
            [
              -4569.191,
              921.082,
              11547.552
            ],
            [
              -4557.807,
              945.377,
              11574.382
            ],
            [
              -4520.63,
              969.228,
              11618.552
            ],
            [
              -4517.8,
              981.449,
              11631.097
            ],
            [
              -4524.608,
              1000.466,
              11651.296
            ],
            [
              -4563.16,
              1046.77,
              11711.548
            ],
            [
              -4607.63,
              1086.496,
              11771.178
            ],
            [
              -4747.102,
              1153.456,
              11925.891
            ],
            [
              -4804.625,
              1184.498,
              11991.255
            ],
            [
              -4849.214,
              1217.545,
              12046.755
            ],
            [
              -4874.57,
              1243.583,
              12083.099
            ],
            [
              -4893.428,
              1253.165,
              12104.252
            ],
            [
              -4938.352,
              1323.711,
              12187.888
            ],
            [
              -4959.005,
              1360.8,
              12230.339
            ],
            [
              -4978.198,
              1407.883,
              12281.184
            ],
            [
              -4995.361,
              1460.496,
              12336.526
            ],
            [
              -5000.423,
              1503.997,
              12380.32
            ],
            [
              -5002.906,
              1547.455,
              12423.849
            ],
            [
              -4998.561,
              1575.21,
              12451.942
            ],
            [
              -4985.073,
              1609.489,
              12488.779
            ],
            [
              -4958.06,
              1642.423,
              12531.374
            ],
            [
              -4906.917,
              1690.529,
              12601.587
            ],
            [
              -4961.39,
              1738.988,
              12674.495
            ],
            [
              -4984.325,
              1766.437,
              12710.265
            ],
            [
              -5071.353,
              1866.205,
              12842.656
            ],
            [
              -5078.2,
              1869.918,
              12850.445
            ],
            [
              -5081.805,
              1876.082,
              12857.586
            ],
            [
              -5219.905,
              1987.531,
              13035.047
            ],
            [
              -5231.838,
              2006.658,
              13057.591
            ],
            [
              -5236.713,
              2023.439,
              13075.066
            ],
            [
              -5239.294,
              2061.332,
              13113.047
            ],
            [
              -5225.18,
              2094.487,
              13149.081
            ],
            [
              -5204.824,
              2115.291,
              13178.187
            ],
            [
              -5185.303,
              2124.977,
              13199.979
            ],
            [
              -5163.278,
              2130.168,
              13222.608
            ],
            [
              -5075.343,
              2126.977,
              13310.6
            ],
            [
              -4973.287,
              2110.226,
              13414.022
            ],
            [
              -4894.768,
              2098.864,
              13493.359
            ],
            [
              -4850.889,
              2099.226,
              13537.239
            ],
            [
              -4603.07,
              2140.618,
              13788.491
            ],
            [
              -4527.565,
              2141.547,
              13864.002
            ],
            [
              -4479.873,
              2138.5,
              13911.791
            ],
            [
              -4449.411,
              2138.771,
              13942.254
            ],
            [
              -4390.804,
              2140.306,
              14000.882
            ],
            [
              -4376.576,
              2142.288,
              14015.247
            ],
            [
              -4195.427,
              2208.182,
              14208.008
            ],
            [
              -4108.264,
              2248.978,
              14304.246
            ],
            [
              -4011,
              2314.088,
              14421.292
            ],
            [
              -3941.175,
              2365.804,
              14508.183
            ],
            [
              -3943.03,
              2364.119,
              14510.689
            ],
            [
              -3907.655,
              2393.689,
              14556.794
            ],
            [
              -3774.237,
              2423.531,
              14693.509
            ],
            [
              -3651.362,
              2444.008,
              14818.078
            ],
            [
              -3633.133,
              2448.91,
              14836.955
            ],
            [
              -3619.772,
              2453.83,
              14851.193
            ],
            [
              -3623.074,
              2452.998,
              14854.598
            ],
            [
              -3574.836,
              2464.277,
              14904.137
            ],
            [
              -3569.02,
              2468.306,
              14911.212
            ],
            [
              -3565.865,
              2463.897,
              14916.633
            ],
            [
              -3572.689,
              2463.403,
              14923.475
            ],
            [
              -3572.888,
              2463.316,
              14923.692
            ],
            [
              -3581.618,
              2460.926,
              14932.744
            ],
            [
              -3610.504,
              2454.257,
              14962.389
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:7830",
              "position": {
                "x": 112.767,
                "z": -8385.016
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 2.337,
              "arrivalOffsetSeconds": -780,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:7827",
              "position": {
                "x": 51.629,
                "z": -7784.972
              },
              "distanceAlongShapeM": 603.343,
              "shapeOffsetM": 4.306,
              "arrivalOffsetSeconds": 60,
              "departureOffsetSeconds": 60
            },
            {
              "stopId": "judu:stop:7831",
              "position": {
                "x": 25.801,
                "z": -7471.678
              },
              "distanceAlongShapeM": 917.856,
              "shapeOffsetM": 0.459,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:6526",
              "position": {
                "x": -15.345,
                "z": -7080.178
              },
              "distanceAlongShapeM": 1311.894,
              "shapeOffsetM": 5.051,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:6503",
              "position": {
                "x": -50.829,
                "z": -6695.462
              },
              "distanceAlongShapeM": 1721.706,
              "shapeOffsetM": 0.189,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:6501",
              "position": {
                "x": -182.398,
                "z": -6069.649
              },
              "distanceAlongShapeM": 2363.943,
              "shapeOffsetM": 2.159,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:6640",
              "position": {
                "x": -275.515,
                "z": -5664.961
              },
              "distanceAlongShapeM": 2849.143,
              "shapeOffsetM": 3.912,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:6634",
              "position": {
                "x": -663.705,
                "z": -5510.974
              },
              "distanceAlongShapeM": 3270.696,
              "shapeOffsetM": 1.549,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:5822",
              "position": {
                "x": -927.257,
                "z": -5373.739
              },
              "distanceAlongShapeM": 3568.225,
              "shapeOffsetM": 2.244,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:5814",
              "position": {
                "x": -1387.604,
                "z": -5181.778
              },
              "distanceAlongShapeM": 4070.224,
              "shapeOffsetM": 1.394,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:5812",
              "position": {
                "x": -1760.592,
                "z": -4965.819
              },
              "distanceAlongShapeM": 4501.456,
              "shapeOffsetM": 1.552,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            },
            {
              "stopId": "judu:stop:5807",
              "position": {
                "x": -2056.897,
                "z": -4746.801
              },
              "distanceAlongShapeM": 4869.991,
              "shapeOffsetM": 1.835,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:8269",
              "position": {
                "x": -2245.99,
                "z": -4656.611
              },
              "distanceAlongShapeM": 5086.809,
              "shapeOffsetM": 4.776,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:6766",
              "position": {
                "x": -2809.985,
                "z": -4489.679
              },
              "distanceAlongShapeM": 5678.293,
              "shapeOffsetM": 8.604,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:6484",
              "position": {
                "x": -2923.723,
                "z": -4326.261
              },
              "distanceAlongShapeM": 5876.201,
              "shapeOffsetM": 1.774,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:6523",
              "position": {
                "x": -2947.565,
                "z": -4106.537
              },
              "distanceAlongShapeM": 6096.92,
              "shapeOffsetM": 4.693,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:6482",
              "position": {
                "x": -2942.439,
                "z": -3778.227
              },
              "distanceAlongShapeM": 6426.401,
              "shapeOffsetM": 0.816,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            },
            {
              "stopId": "judu:stop:6478",
              "position": {
                "x": -3026.974,
                "z": -3344.813
              },
              "distanceAlongShapeM": 6870.351,
              "shapeOffsetM": 5.006,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            },
            {
              "stopId": "judu:stop:6477",
              "position": {
                "x": -3137.083,
                "z": -2972.18
              },
              "distanceAlongShapeM": 7259.532,
              "shapeOffsetM": 1.418,
              "arrivalOffsetSeconds": 1500,
              "departureOffsetSeconds": 1500
            },
            {
              "stopId": "judu:stop:6476",
              "position": {
                "x": -3349.352,
                "z": -2543.216
              },
              "distanceAlongShapeM": 7743.67,
              "shapeOffsetM": 5.101,
              "arrivalOffsetSeconds": 1560,
              "departureOffsetSeconds": 1560
            },
            {
              "stopId": "judu:stop:6475",
              "position": {
                "x": -3389.87,
                "z": -2243.053
              },
              "distanceAlongShapeM": 8050.044,
              "shapeOffsetM": 1.536,
              "arrivalOffsetSeconds": 1680,
              "departureOffsetSeconds": 1680
            },
            {
              "stopId": "judu:stop:5620",
              "position": {
                "x": -3375.166,
                "z": -1991.724
              },
              "distanceAlongShapeM": 8303.629,
              "shapeOffsetM": 4.466,
              "arrivalOffsetSeconds": 1740,
              "departureOffsetSeconds": 1740
            },
            {
              "stopId": "judu:stop:928",
              "position": {
                "x": -3525.544,
                "z": -1521.55
              },
              "distanceAlongShapeM": 8800.098,
              "shapeOffsetM": 4.655,
              "arrivalOffsetSeconds": 1920,
              "departureOffsetSeconds": 1920
            },
            {
              "stopId": "judu:stop:5643",
              "position": {
                "x": -3680.758,
                "z": -1067.996
              },
              "distanceAlongShapeM": 9279.707,
              "shapeOffsetM": 3.566,
              "arrivalOffsetSeconds": 2040,
              "departureOffsetSeconds": 2040
            },
            {
              "stopId": "judu:stop:5646",
              "position": {
                "x": -3761.526,
                "z": -818.346
              },
              "distanceAlongShapeM": 9542.57,
              "shapeOffsetM": 3.383,
              "arrivalOffsetSeconds": 2100,
              "departureOffsetSeconds": 2100
            },
            {
              "stopId": "judu:stop:5651",
              "position": {
                "x": -3986.683,
                "z": -379.175
              },
              "distanceAlongShapeM": 10038.369,
              "shapeOffsetM": 4.451,
              "arrivalOffsetSeconds": 2160,
              "departureOffsetSeconds": 2160
            },
            {
              "stopId": "judu:stop:5656",
              "position": {
                "x": -4221.08,
                "z": -99.045
              },
              "distanceAlongShapeM": 10405.421,
              "shapeOffsetM": 5.483,
              "arrivalOffsetSeconds": 2220,
              "departureOffsetSeconds": 2220
            },
            {
              "stopId": "judu:stop:5668",
              "position": {
                "x": -4574.501,
                "z": 537.119
              },
              "distanceAlongShapeM": 11156.518,
              "shapeOffsetM": 3.934,
              "arrivalOffsetSeconds": 2280,
              "departureOffsetSeconds": 2280
            },
            {
              "stopId": "judu:stop:16703",
              "position": {
                "x": -4563.16,
                "z": 1046.77
              },
              "distanceAlongShapeM": 11711.548,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2400,
              "departureOffsetSeconds": 2400
            },
            {
              "stopId": "judu:stop:5672",
              "position": {
                "x": -4893.764,
                "z": 1252.817
              },
              "distanceAlongShapeM": 12104.252,
              "shapeOffsetM": 0.484,
              "arrivalOffsetSeconds": 2460,
              "departureOffsetSeconds": 2460
            },
            {
              "stopId": "judu:stop:7341",
              "position": {
                "x": -4962.228,
                "z": 1738.229
              },
              "distanceAlongShapeM": 12674.495,
              "shapeOffsetM": 1.131,
              "arrivalOffsetSeconds": 2520,
              "departureOffsetSeconds": 2520
            },
            {
              "stopId": "judu:stop:6401",
              "position": {
                "x": -5074.894,
                "z": 2129.773
              },
              "distanceAlongShapeM": 13310.6,
              "shapeOffsetM": 2.831,
              "arrivalOffsetSeconds": 2640,
              "departureOffsetSeconds": 2640
            },
            {
              "stopId": "judu:stop:6379",
              "position": {
                "x": -4449.462,
                "z": 2143.543
              },
              "distanceAlongShapeM": 13942.329,
              "shapeOffsetM": 4.772,
              "arrivalOffsetSeconds": 2760,
              "departureOffsetSeconds": 2760
            },
            {
              "stopId": "judu:stop:9966",
              "position": {
                "x": -3910.18,
                "z": 2398.059
              },
              "distanceAlongShapeM": 14556.794,
              "shapeOffsetM": 5.047,
              "arrivalOffsetSeconds": 2880,
              "departureOffsetSeconds": 2880
            },
            {
              "stopId": "judu:stop:9964",
              "position": {
                "x": -3623.967,
                "z": 2456.543
              },
              "distanceAlongShapeM": 14854.598,
              "shapeOffsetM": 3.656,
              "arrivalOffsetSeconds": 2940,
              "departureOffsetSeconds": 2940
            }
          ],
          "departuresSeconds": [
            18780,
            21540,
            23640,
            25920,
            27900,
            29640,
            31740,
            33360,
            34980,
            36660,
            38340,
            40260,
            42240,
            43980,
            46380,
            48900,
            51300,
            53640,
            56160,
            58440,
            60540,
            62340,
            64020,
            65460,
            67080,
            69060,
            70860,
            72420,
            73980,
            76260,
            78300,
            80340,
            82620
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_bus_56",
      "sourceRouteId": "vilnius_bus_56",
      "mode": "bus",
      "shortName": "56",
      "longName": "Fabijoniškės–Šeškinė–Konstitucijos pr.–A.Goštauto g.–Vilkpėdė (Apylanka)",
      "color": "0073AC",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_bus_56:0",
          "sourceRouteId": "vilnius_bus_56",
          "sourceShapeId": "vilnius_bus_56_a1-b1",
          "directionId": 0,
          "headsign": "Vilkpėdė (Apylanka)",
          "directionName": "Fabijoniškės–Šeškinė–Konstitucijos pr.–A.Goštauto g.–Vilkpėdė (Apylanka)",
          "mode": "bus",
          "routeShortName": "56",
          "routeLongName": "Fabijoniškės–Šeškinė–Konstitucijos pr.–A.Goštauto g.–Vilkpėdė (Apylanka)",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              -2480.761,
              -5727.829,
              0
            ],
            [
              -2465.38,
              -5705.215,
              27.349
            ],
            [
              -2457.131,
              -5687.973,
              46.463
            ],
            [
              -2458.05,
              -5680.376,
              54.116
            ],
            [
              -2467.523,
              -5671.289,
              67.242
            ],
            [
              -2484.515,
              -5648.724,
              95.489
            ],
            [
              -2453.276,
              -5597.994,
              155.066
            ],
            [
              -2437.971,
              -5575.488,
              182.284
            ],
            [
              -2323.024,
              -5404.447,
              388.361
            ],
            [
              -2243.482,
              -5280.09,
              535.981
            ],
            [
              -2221.212,
              -5257.08,
              568.002
            ],
            [
              -2172.788,
              -5214.524,
              632.469
            ],
            [
              -2110.315,
              -5178.897,
              704.386
            ],
            [
              -2057.336,
              -5161.028,
              760.297
            ],
            [
              -2028.76,
              -5156.969,
              789.161
            ],
            [
              -1944.865,
              -5148.443,
              873.488
            ],
            [
              -1856.383,
              -5135.547,
              962.905
            ],
            [
              -1800.644,
              -5116.503,
              1021.807
            ],
            [
              -1770.723,
              -5100.339,
              1055.815
            ],
            [
              -1738.711,
              -5075.306,
              1096.453
            ],
            [
              -1710.503,
              -5046.865,
              1136.51
            ],
            [
              -1676.24,
              -5004.061,
              1191.338
            ],
            [
              -1664.171,
              -4977.559,
              1220.459
            ],
            [
              -1655.392,
              -4950.998,
              1248.433
            ],
            [
              -1638.506,
              -4911.224,
              1291.643
            ],
            [
              -1626.337,
              -4879.158,
              1325.941
            ],
            [
              -1604.435,
              -4807.19,
              1401.167
            ],
            [
              -1592.551,
              -4755.08,
              1454.615
            ],
            [
              -1586.265,
              -4691.738,
              1518.269
            ],
            [
              -1583.358,
              -4637.242,
              1572.842
            ],
            [
              -1588.338,
              -4591.511,
              1618.843
            ],
            [
              -1592.703,
              -4555.313,
              1655.304
            ],
            [
              -1592.123,
              -4561.86,
              1661.876
            ],
            [
              -1595.437,
              -4520.137,
              1703.73
            ],
            [
              -1616.287,
              -4244.797,
              1979.859
            ],
            [
              -1631.856,
              -4106.478,
              2119.051
            ],
            [
              -1635.514,
              -4066.939,
              2158.759
            ],
            [
              -1637.064,
              -4037.365,
              2188.374
            ],
            [
              -1635.048,
              -3960.588,
              2265.177
            ],
            [
              -1628.98,
              -3909.488,
              2316.636
            ],
            [
              -1609.35,
              -3809.976,
              2418.066
            ],
            [
              -1543.192,
              -3688.376,
              2556.498
            ],
            [
              -1515.42,
              -3648.796,
              2604.849
            ],
            [
              -1479.438,
              -3582.647,
              2680.151
            ],
            [
              -1461.972,
              -3542.883,
              2723.582
            ],
            [
              -1437.625,
              -3478.752,
              2792.179
            ],
            [
              -1385.229,
              -3323.838,
              2955.714
            ],
            [
              -1372.596,
              -3266.177,
              3014.743
            ],
            [
              -1370.241,
              -3230.903,
              3050.096
            ],
            [
              -1363.568,
              -3193.979,
              3087.618
            ],
            [
              -1359.808,
              -3163.989,
              3117.842
            ],
            [
              -1360.179,
              -3112.774,
              3169.059
            ],
            [
              -1362.723,
              -3074.878,
              3207.04
            ],
            [
              -1386.134,
              -2978.721,
              3306.006
            ],
            [
              -1409.242,
              -2901.495,
              3386.615
            ],
            [
              -1418.932,
              -2871.362,
              3418.268
            ],
            [
              -1430.357,
              -2820.964,
              3469.944
            ],
            [
              -1448.996,
              -2746.044,
              3547.148
            ],
            [
              -1452.909,
              -2712.577,
              3580.843
            ],
            [
              -1453.659,
              -2682.507,
              3610.923
            ],
            [
              -1443.344,
              -2610.331,
              3683.832
            ],
            [
              -1428.471,
              -2571.635,
              3725.288
            ],
            [
              -1415.77,
              -2546.258,
              3753.666
            ],
            [
              -1386.622,
              -2502.251,
              3806.45
            ],
            [
              -1448.618,
              -2469.866,
              3876.395
            ],
            [
              -1516.935,
              -2436.464,
              3952.441
            ],
            [
              -1567.016,
              -2425.55,
              4003.697
            ],
            [
              -1613.955,
              -2419.145,
              4051.071
            ],
            [
              -1678.312,
              -2413.543,
              4115.671
            ],
            [
              -1901.727,
              -2399.542,
              4339.525
            ],
            [
              -1904.451,
              -2409.591,
              4349.937
            ],
            [
              -1909.619,
              -2525.597,
              4466.058
            ],
            [
              -1934.345,
              -2592.607,
              4537.483
            ],
            [
              -1938.838,
              -2601.488,
              4547.437
            ],
            [
              -2055.259,
              -2914.461,
              4881.362
            ],
            [
              -2054.675,
              -2917.811,
              4884.762
            ],
            [
              -2034.057,
              -2918.177,
              4905.383
            ],
            [
              -2023.689,
              -2915.022,
              4916.221
            ],
            [
              -2013.222,
              -2906.302,
              4929.844
            ],
            [
              -1995.719,
              -2864.311,
              4975.337
            ],
            [
              -1946.309,
              -2731.603,
              5116.945
            ],
            [
              -1893.853,
              -2608.968,
              5250.328
            ],
            [
              -1860.774,
              -2597.312,
              5285.4
            ],
            [
              -1798.045,
              -2477.088,
              5421.005
            ],
            [
              -1803.09,
              -2434.696,
              5463.696
            ],
            [
              -1743.312,
              -2335.571,
              5579.451
            ],
            [
              -1745.639,
              -2333.352,
              5582.666
            ],
            [
              -1727.311,
              -2305.799,
              5615.759
            ],
            [
              -1547.472,
              -2017.345,
              5955.682
            ],
            [
              -1343.434,
              -1674.784,
              6354.404
            ],
            [
              -1305.861,
              -1628.702,
              6413.862
            ],
            [
              -1268.647,
              -1602.651,
              6459.289
            ],
            [
              -1054.592,
              -1494.059,
              6699.313
            ],
            [
              -1027.103,
              -1471.176,
              6735.08
            ],
            [
              -1009.966,
              -1450.333,
              6762.063
            ],
            [
              -998.422,
              -1410.718,
              6803.326
            ],
            [
              -987.78,
              -1363.9,
              6851.338
            ],
            [
              -988.723,
              -1201.352,
              7013.889
            ],
            [
              -990.397,
              -1186.85,
              7028.487
            ],
            [
              -1017.615,
              -1122.906,
              7097.983
            ],
            [
              -1020.518,
              -1105.042,
              7116.082
            ],
            [
              -1018.304,
              -1089.497,
              7131.783
            ],
            [
              -1013.532,
              -1075.111,
              7146.94
            ],
            [
              -1005.537,
              -1060.783,
              7163.348
            ],
            [
              -969.041,
              -1039.175,
              7205.761
            ],
            [
              -947.066,
              -1036.231,
              7227.932
            ],
            [
              -930.307,
              -1036.533,
              7244.694
            ],
            [
              -906.579,
              -1043.639,
              7269.463
            ],
            [
              -895.802,
              -1053.852,
              7284.311
            ],
            [
              -890.221,
              -1066.198,
              7297.86
            ],
            [
              -882.043,
              -1077.478,
              7311.792
            ],
            [
              -868.708,
              -1088.851,
              7329.318
            ],
            [
              -846.005,
              -1097.331,
              7353.554
            ],
            [
              -837.363,
              -1098.358,
              7362.256
            ],
            [
              -813.038,
              -1094.85,
              7386.833
            ],
            [
              -785.651,
              -1089.799,
              7414.681
            ],
            [
              -774.937,
              -1088.05,
              7425.538
            ],
            [
              -717.669,
              -1083.853,
              7482.959
            ],
            [
              -647.083,
              -1062.792,
              7556.62
            ],
            [
              -599.769,
              -1049.176,
              7605.854
            ],
            [
              -535.555,
              -1028.072,
              7673.447
            ],
            [
              -464.693,
              -995.958,
              7751.247
            ],
            [
              -361.843,
              -942.16,
              7867.317
            ],
            [
              -331.427,
              -923.524,
              7902.988
            ],
            [
              -286.654,
              -898.264,
              7954.395
            ],
            [
              -196.966,
              -846.075,
              8058.163
            ],
            [
              -115.583,
              -803.025,
              8150.231
            ],
            [
              -95.312,
              -792.953,
              8172.866
            ],
            [
              -40.176,
              -770.281,
              8232.481
            ],
            [
              224.176,
              -700.119,
              8505.986
            ],
            [
              211.01,
              -644.216,
              8563.418
            ],
            [
              143.71,
              -480.456,
              8740.468
            ],
            [
              126.134,
              -439.133,
              8785.374
            ],
            [
              119.827,
              -411,
              8814.205
            ],
            [
              106.146,
              -277.163,
              8948.739
            ],
            [
              35.151,
              -280.322,
              9019.804
            ],
            [
              -101.904,
              -298.979,
              9158.124
            ],
            [
              -140.054,
              -304.394,
              9196.656
            ],
            [
              -153.37,
              -311.158,
              9211.591
            ],
            [
              -213.211,
              -320.334,
              9272.132
            ],
            [
              -272.238,
              -339.301,
              9334.131
            ],
            [
              -413.017,
              -421.354,
              9497.077
            ],
            [
              -472.96,
              -487.278,
              9586.178
            ],
            [
              -567.085,
              -584.226,
              9721.303
            ],
            [
              -678.943,
              -684.832,
              9871.748
            ],
            [
              -729.705,
              -710.633,
              9928.691
            ],
            [
              -764.735,
              -722.247,
              9965.596
            ],
            [
              -795.816,
              -729.479,
              9997.507
            ],
            [
              -837.191,
              -735.412,
              10039.305
            ],
            [
              -917.002,
              -727.295,
              10119.528
            ],
            [
              -964.927,
              -703.054,
              10173.235
            ],
            [
              -996.817,
              -683.556,
              10210.613
            ],
            [
              -1054.176,
              -610.165,
              10303.76
            ],
            [
              -1094.292,
              -545.99,
              10379.442
            ],
            [
              -1131.291,
              -451.814,
              10480.625
            ],
            [
              -1162.09,
              -335.486,
              10600.961
            ],
            [
              -1171.535,
              -267.372,
              10669.726
            ],
            [
              -1173.311,
              -206.15,
              10730.974
            ],
            [
              -1189.802,
              -11.04,
              10926.78
            ],
            [
              -1216.562,
              218.17,
              11157.547
            ],
            [
              -1222.87,
              266.746,
              11206.531
            ],
            [
              -1245.239,
              336.771,
              11280.042
            ],
            [
              -1266.107,
              373.277,
              11322.091
            ],
            [
              -1309.014,
              426.368,
              11390.353
            ],
            [
              -1352.826,
              465.002,
              11448.766
            ],
            [
              -1405.14,
              497.108,
              11510.146
            ],
            [
              -1439.818,
              505.521,
              11545.83
            ],
            [
              -1555.847,
              546.483,
              11668.877
            ],
            [
              -1726.88,
              579.453,
              11843.059
            ],
            [
              -1758.807,
              593.593,
              11877.977
            ],
            [
              -1828.277,
              640.472,
              11961.785
            ],
            [
              -1847.126,
              668.638,
              11995.676
            ],
            [
              -1893.219,
              760.742,
              12098.67
            ],
            [
              -1907.903,
              805.531,
              12145.805
            ],
            [
              -1929.361,
              897.061,
              12239.816
            ],
            [
              -1969.97,
              1051.542,
              12399.546
            ],
            [
              -1977.313,
              1104.145,
              12452.659
            ],
            [
              -1975.7,
              1128.456,
              12477.023
            ],
            [
              -1959.78,
              1189.4,
              12540.012
            ],
            [
              -1920.059,
              1246.582,
              12609.636
            ],
            [
              -1864.959,
              1297.923,
              12684.948
            ],
            [
              -1707.895,
              1459.884,
              12910.56
            ],
            [
              -1651.454,
              1530.355,
              13000.846
            ],
            [
              -1603.973,
              1571.579,
              13063.727
            ],
            [
              -1299.013,
              1921.245,
              13527.695
            ],
            [
              -1270.801,
              1947.457,
              13566.205
            ],
            [
              -1190.297,
              2047.317,
              13694.474
            ],
            [
              -1514.694,
              2380.408,
              14159.429
            ],
            [
              -1536.735,
              2401.048,
              14189.625
            ],
            [
              -1585.57,
              2434.895,
              14249.043
            ],
            [
              -1589.092,
              2441.85,
              14256.839
            ],
            [
              -1665.298,
              2474.379,
              14339.697
            ],
            [
              -1973.715,
              2584.507,
              14667.186
            ],
            [
              -1980.067,
              2590.186,
              14675.707
            ],
            [
              -1990.862,
              2563.661,
              14704.344
            ],
            [
              -1996.181,
              2554.849,
              14714.637
            ],
            [
              -2002.73,
              2549.399,
              14723.157
            ],
            [
              -2004.613,
              2546.083,
              14726.971
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:1158",
              "position": {
                "x": -2456.526,
                "z": -5595.784
              },
              "distanceAlongShapeM": 155.066,
              "shapeOffsetM": 3.93,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:6913",
              "position": {
                "x": -2058.363,
                "z": -5155.329
              },
              "distanceAlongShapeM": 760.297,
              "shapeOffsetM": 5.79,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:5813",
              "position": {
                "x": -1657.878,
                "z": -4949.841
              },
              "distanceAlongShapeM": 1248.527,
              "shapeOffsetM": 2.74,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:6917",
              "position": {
                "x": -1597.362,
                "z": -4555.726
              },
              "distanceAlongShapeM": 1655.304,
              "shapeOffsetM": 4.677,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:6921",
              "position": {
                "x": -1640.178,
                "z": -4067.366
              },
              "distanceAlongShapeM": 2158.759,
              "shapeOffsetM": 4.683,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:6924",
              "position": {
                "x": -1612.999,
                "z": -3808.47
              },
              "distanceAlongShapeM": 2418.066,
              "shapeOffsetM": 3.947,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:6928",
              "position": {
                "x": -1373.246,
                "z": -3230.542
              },
              "distanceAlongShapeM": 3050.096,
              "shapeOffsetM": 3.027,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:6933",
              "position": {
                "x": -1422.254,
                "z": -2872.318
              },
              "distanceAlongShapeM": 3418.268,
              "shapeOffsetM": 3.457,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:6937",
              "position": {
                "x": -1450.559,
                "z": -2473.275
              },
              "distanceAlongShapeM": 3876.642,
              "shapeOffsetM": 3.916,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:5294",
              "position": {
                "x": -1930.967,
                "z": -2593.836
              },
              "distanceAlongShapeM": 4537.467,
              "shapeOffsetM": 3.594,
              "arrivalOffsetSeconds": 990,
              "departureOffsetSeconds": 990
            },
            {
              "stopId": "judu:stop:5214",
              "position": {
                "x": -1747.763,
                "z": -2332.152
              },
              "distanceAlongShapeM": 5582.666,
              "shapeOffsetM": 2.44,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:5220",
              "position": {
                "x": -1001.511,
                "z": -1410.409
              },
              "distanceAlongShapeM": 6802.759,
              "shapeOffsetM": 3.052,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:6635",
              "position": {
                "x": -775.751,
                "z": -1082.734
              },
              "distanceAlongShapeM": 7425.538,
              "shapeOffsetM": 5.378,
              "arrivalOffsetSeconds": 1380,
              "departureOffsetSeconds": 1380
            },
            {
              "stopId": "judu:stop:7381",
              "position": {
                "x": -333.702,
                "z": -919.293
              },
              "distanceAlongShapeM": 7903.086,
              "shapeOffsetM": 4.803,
              "arrivalOffsetSeconds": 1500,
              "departureOffsetSeconds": 1500
            },
            {
              "stopId": "judu:stop:17638",
              "position": {
                "x": -42.035,
                "z": -765.399
              },
              "distanceAlongShapeM": 8232.481,
              "shapeOffsetM": 5.224,
              "arrivalOffsetSeconds": 1560,
              "departureOffsetSeconds": 1560
            },
            {
              "stopId": "judu:stop:5244",
              "position": {
                "x": 121.213,
                "z": -441.083
              },
              "distanceAlongShapeM": 8785.374,
              "shapeOffsetM": 5.293,
              "arrivalOffsetSeconds": 1740,
              "departureOffsetSeconds": 1740
            },
            {
              "stopId": "judu:stop:5249",
              "position": {
                "x": -153.095,
                "z": -312.52
              },
              "distanceAlongShapeM": 9211.591,
              "shapeOffsetM": 1.39,
              "arrivalOffsetSeconds": 1920,
              "departureOffsetSeconds": 1920
            },
            {
              "stopId": "judu:stop:3551",
              "position": {
                "x": -469.726,
                "z": -490.46
              },
              "distanceAlongShapeM": 9586.209,
              "shapeOffsetM": 4.537,
              "arrivalOffsetSeconds": 2010,
              "departureOffsetSeconds": 2010
            },
            {
              "stopId": "judu:stop:16553",
              "position": {
                "x": -1171.831,
                "z": -267.404
              },
              "distanceAlongShapeM": 10669.726,
              "shapeOffsetM": 0.298,
              "arrivalOffsetSeconds": 2130,
              "departureOffsetSeconds": 2130
            },
            {
              "stopId": "judu:stop:16773",
              "position": {
                "x": -1221.169,
                "z": 217.734
              },
              "distanceAlongShapeM": 11157.708,
              "shapeOffsetM": 4.625,
              "arrivalOffsetSeconds": 2250,
              "departureOffsetSeconds": 2250
            },
            {
              "stopId": "judu:stop:6410",
              "position": {
                "x": -1654.972,
                "z": 1533.526
              },
              "distanceAlongShapeM": 13000.846,
              "shapeOffsetM": 4.736,
              "arrivalOffsetSeconds": 2520,
              "departureOffsetSeconds": 2520
            },
            {
              "stopId": "judu:stop:6366",
              "position": {
                "x": -1299.013,
                "z": 1921.245
              },
              "distanceAlongShapeM": 13527.695,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2640,
              "departureOffsetSeconds": 2640
            },
            {
              "stopId": "judu:stop:9701",
              "position": {
                "x": -1232.774,
                "z": 2089.268
              },
              "distanceAlongShapeM": 13754.163,
              "shapeOffsetM": 1.161,
              "arrivalOffsetSeconds": 2730,
              "departureOffsetSeconds": 2730
            },
            {
              "stopId": "judu:stop:7941",
              "position": {
                "x": -1586.671,
                "z": 2432.901
              },
              "distanceAlongShapeM": 14248.812,
              "shapeOffsetM": 2.266,
              "arrivalOffsetSeconds": 2850,
              "departureOffsetSeconds": 2850
            },
            {
              "stopId": "judu:stop:19255",
              "position": {
                "x": -2002.849,
                "z": 2542.722
              },
              "distanceAlongShapeM": 14726.971,
              "shapeOffsetM": 3.796,
              "arrivalOffsetSeconds": 2910,
              "departureOffsetSeconds": 2910
            }
          ],
          "departuresSeconds": [
            18300,
            19680,
            21060,
            22740,
            24360,
            25260,
            26280,
            27960,
            29580,
            32700,
            34560,
            36360,
            38520,
            41220,
            43440,
            45660,
            48060,
            50340,
            52560,
            53760,
            54960,
            56340,
            57960,
            59760,
            61560,
            63960,
            65700,
            68220,
            70500,
            72780,
            74880,
            76980,
            79020,
            81120
          ]
        },
        {
          "id": "judu:pattern:vilnius_bus_56:1",
          "sourceRouteId": "vilnius_bus_56",
          "sourceShapeId": "vilnius_bus_56_b-a",
          "directionId": 1,
          "headsign": "Fabijoniškės",
          "directionName": "Vilkpėdė–A.Goštauto g.–Konstitucijos pr.–Šeškinė–Fabijoniškės",
          "mode": "bus",
          "routeShortName": "56",
          "routeLongName": "Fabijoniškės–Šeškinė–Konstitucijos pr.–A.Goštauto g.–Vilkpėdė (Apylanka)",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              -2004.833,
              2545.942,
              0
            ],
            [
              -2009.26,
              2545.063,
              4.513
            ],
            [
              -2019.015,
              2540.783,
              15.166
            ],
            [
              -2077.913,
              2530.695,
              74.921
            ],
            [
              -2082.858,
              2558.783,
              103.441
            ],
            [
              -2083.009,
              2570.861,
              115.52
            ],
            [
              -2085.436,
              2584.647,
              129.518
            ],
            [
              -2057.496,
              2590.447,
              158.053
            ],
            [
              -2049.628,
              2587.512,
              166.451
            ],
            [
              -2043.42,
              2571.065,
              184.031
            ],
            [
              -2044.167,
              2564.653,
              190.486
            ],
            [
              -2036.471,
              2538.866,
              217.397
            ],
            [
              -2016.375,
              2544.076,
              238.157
            ],
            [
              -2000.11,
              2551.579,
              256.07
            ],
            [
              -1974.301,
              2587.857,
              300.591
            ],
            [
              -1936.092,
              2569.619,
              342.93
            ],
            [
              -1765.274,
              2512.896,
              522.92
            ],
            [
              -1632.053,
              2457.088,
              667.358
            ],
            [
              -1568.278,
              2436.193,
              734.469
            ],
            [
              -1527.823,
              2404.02,
              786.157
            ],
            [
              -1400.63,
              2277.747,
              965.386
            ],
            [
              -1328.942,
              2195.633,
              1074.39
            ],
            [
              -1190.297,
              2047.317,
              1277.417
            ],
            [
              -1413.741,
              1770.628,
              1633.063
            ],
            [
              -1687.704,
              1470.656,
              2039.313
            ],
            [
              -1777.614,
              1373.011,
              2172.047
            ],
            [
              -1888.848,
              1260.499,
              2330.262
            ],
            [
              -1928.003,
              1198.855,
              2403.29
            ],
            [
              -1944.291,
              1153.502,
              2451.479
            ],
            [
              -1945.702,
              1087.638,
              2517.358
            ],
            [
              -1928.126,
              959.476,
              2646.72
            ],
            [
              -1902.894,
              832.701,
              2775.981
            ],
            [
              -1885.184,
              777.297,
              2834.147
            ],
            [
              -1847.199,
              699.714,
              2920.53
            ],
            [
              -1817.691,
              651.957,
              2976.668
            ],
            [
              -1749.056,
              597.872,
              3064.051
            ],
            [
              -1726.706,
              585.229,
              3089.73
            ],
            [
              -1590.154,
              573.993,
              3226.744
            ],
            [
              -1491.091,
              559.872,
              3326.807
            ],
            [
              -1444.24,
              546.789,
              3375.451
            ],
            [
              -1412.874,
              532.782,
              3409.802
            ],
            [
              -1377.327,
              509.767,
              3452.149
            ],
            [
              -1269.362,
              387.609,
              3615.18
            ],
            [
              -1233.883,
              335.963,
              3677.839
            ],
            [
              -1215.805,
              285.312,
              3731.619
            ],
            [
              -1200.621,
              173.264,
              3844.691
            ],
            [
              -1189.802,
              -11.04,
              4029.312
            ],
            [
              -1173.311,
              -206.15,
              4225.118
            ],
            [
              -1158.177,
              -289.849,
              4310.174
            ],
            [
              -1145.948,
              -370.286,
              4391.536
            ],
            [
              -1128.552,
              -442.958,
              4466.261
            ],
            [
              -1103.501,
              -520.22,
              4547.482
            ],
            [
              -1089.839,
              -549.409,
              4579.71
            ],
            [
              -1080.43,
              -564.05,
              4597.114
            ],
            [
              -1026.796,
              -638.192,
              4688.621
            ],
            [
              -986.543,
              -685.967,
              4751.094
            ],
            [
              -964.927,
              -703.054,
              4778.648
            ],
            [
              -944.499,
              -714.554,
              4802.09
            ],
            [
              -887.35,
              -727.829,
              4860.761
            ],
            [
              -849.963,
              -728.502,
              4898.154
            ],
            [
              -795.111,
              -726.152,
              4953.056
            ],
            [
              -764.735,
              -722.247,
              4983.682
            ],
            [
              -725.717,
              -704.026,
              5026.745
            ],
            [
              -702.814,
              -685.514,
              5056.194
            ],
            [
              -690.623,
              -676.974,
              5071.078
            ],
            [
              -655.859,
              -656.305,
              5111.523
            ],
            [
              -601.451,
              -607.193,
              5184.818
            ],
            [
              -500.911,
              -503.255,
              5329.426
            ],
            [
              -413.017,
              -421.354,
              5449.564
            ],
            [
              -305.298,
              -348.72,
              5579.484
            ],
            [
              -203.339,
              -309.381,
              5688.769
            ],
            [
              -102.285,
              -284.5,
              5792.84
            ],
            [
              -49.535,
              -271.256,
              5847.228
            ],
            [
              -22.626,
              -265.911,
              5874.662
            ],
            [
              -0.545,
              -257.407,
              5898.324
            ],
            [
              58.367,
              -209.498,
              5974.258
            ],
            [
              82.464,
              -196.578,
              6001.6
            ],
            [
              94.753,
              -194.576,
              6014.051
            ],
            [
              102.687,
              -199.192,
              6023.23
            ],
            [
              115.784,
              -208.318,
              6039.193
            ],
            [
              118.351,
              -267.309,
              6098.239
            ],
            [
              118.552,
              -304.106,
              6135.037
            ],
            [
              124.949,
              -377.696,
              6208.905
            ],
            [
              130.203,
              -407.85,
              6239.513
            ],
            [
              144.816,
              -445.964,
              6280.332
            ],
            [
              174.587,
              -519.993,
              6360.123
            ],
            [
              187.997,
              -562.53,
              6404.724
            ],
            [
              214.213,
              -645.388,
              6491.631
            ],
            [
              223.987,
              -656.808,
              6506.663
            ],
            [
              236.049,
              -695.879,
              6547.553
            ],
            [
              236.925,
              -708.144,
              6559.849
            ],
            [
              229.693,
              -715.805,
              6570.384
            ],
            [
              23.734,
              -765.484,
              6782.25
            ],
            [
              -55.388,
              -799.514,
              6868.38
            ],
            [
              -306.711,
              -924.235,
              7148.948
            ],
            [
              -475.993,
              -1014.678,
              7340.876
            ],
            [
              -535.166,
              -1050.172,
              7409.878
            ],
            [
              -673.187,
              -1080.133,
              7551.113
            ],
            [
              -764.624,
              -1108.462,
              7646.838
            ],
            [
              -822.801,
              -1117.509,
              7705.714
            ],
            [
              -837.686,
              -1120.58,
              7720.913
            ],
            [
              -857.223,
              -1131.36,
              7743.227
            ],
            [
              -899.68,
              -1161.766,
              7795.449
            ],
            [
              -917.464,
              -1182.597,
              7822.838
            ],
            [
              -926.283,
              -1206.929,
              7848.719
            ],
            [
              -917.431,
              -1323.977,
              7966.102
            ],
            [
              -911.942,
              -1448.758,
              8091.003
            ],
            [
              -922.391,
              -1491.986,
              8135.476
            ],
            [
              -939.829,
              -1529.521,
              8176.864
            ],
            [
              -961.618,
              -1558.073,
              8212.78
            ],
            [
              -995.732,
              -1590.856,
              8260.093
            ],
            [
              -1026.383,
              -1610.342,
              8296.414
            ],
            [
              -1072.441,
              -1626.213,
              8345.129
            ],
            [
              -1262.636,
              -1662.874,
              8538.825
            ],
            [
              -1320.472,
              -1688.554,
              8602.106
            ],
            [
              -1370.209,
              -1729.965,
              8666.826
            ],
            [
              -1653.223,
              -2198.827,
              9214.483
            ],
            [
              -1682.619,
              -2257.615,
              9280.211
            ],
            [
              -1702.963,
              -2314.026,
              9340.179
            ],
            [
              -1715.793,
              -2345.231,
              9373.919
            ],
            [
              -1755.799,
              -2415.464,
              9454.746
            ],
            [
              -1791.442,
              -2468.3,
              9518.48
            ],
            [
              -1802.268,
              -2497.051,
              9549.202
            ],
            [
              -1803.487,
              -2529.313,
              9581.487
            ],
            [
              -1788.281,
              -2616.415,
              9669.906
            ],
            [
              -1772.234,
              -2692.401,
              9747.568
            ],
            [
              -1756.203,
              -2739.879,
              9797.68
            ],
            [
              -1746.662,
              -2848.708,
              9906.926
            ],
            [
              -1749.429,
              -2895.414,
              9953.714
            ],
            [
              -1759.481,
              -2953.123,
              10012.292
            ],
            [
              -1775.996,
              -3011.829,
              10073.277
            ],
            [
              -1683.756,
              -3043.532,
              10170.813
            ],
            [
              -1647.191,
              -3053.091,
              10208.607
            ],
            [
              -1571.382,
              -3065.693,
              10285.456
            ],
            [
              -1552.592,
              -3068.149,
              10304.406
            ],
            [
              -1523.92,
              -3071.312,
              10333.252
            ],
            [
              -1491.596,
              -3073.684,
              10365.663
            ],
            [
              -1438.786,
              -3075.742,
              10418.513
            ],
            [
              -1362.723,
              -3074.878,
              10494.581
            ],
            [
              -1357.098,
              -3120.622,
              10540.669
            ],
            [
              -1356.687,
              -3169.611,
              10589.66
            ],
            [
              -1363.762,
              -3240.731,
              10661.131
            ],
            [
              -1372.45,
              -3294.01,
              10715.114
            ],
            [
              -1374.779,
              -3312.201,
              10733.454
            ],
            [
              -1386.916,
              -3346.073,
              10769.434
            ],
            [
              -1441.889,
              -3500.94,
              10933.769
            ],
            [
              -1479.438,
              -3582.647,
              11023.691
            ],
            [
              -1526.789,
              -3671.971,
              11124.789
            ],
            [
              -1572.531,
              -3743.513,
              11209.704
            ],
            [
              -1605.428,
              -3817.511,
              11290.685
            ],
            [
              -1619.047,
              -3858.457,
              11333.837
            ],
            [
              -1621.258,
              -3874.003,
              11349.539
            ],
            [
              -1625.465,
              -3915.925,
              11391.671
            ],
            [
              -1630.122,
              -3937.298,
              11413.546
            ],
            [
              -1635.048,
              -3960.588,
              11437.351
            ],
            [
              -1633.18,
              -4036.321,
              11513.107
            ],
            [
              -1621.037,
              -4150.087,
              11627.52
            ],
            [
              -1615.667,
              -4168.374,
              11646.579
            ],
            [
              -1616.287,
              -4244.797,
              11723.004
            ],
            [
              -1593.127,
              -4499.027,
              11978.287
            ],
            [
              -1582.077,
              -4601.642,
              12081.495
            ],
            [
              -1576.639,
              -4648.623,
              12128.79
            ],
            [
              -1585.129,
              -4736.288,
              12216.865
            ],
            [
              -1597.975,
              -4806.192,
              12287.94
            ],
            [
              -1623.216,
              -4884.78,
              12370.482
            ],
            [
              -1642.847,
              -4937.864,
              12427.079
            ],
            [
              -1699.03,
              -5044.347,
              12547.475
            ],
            [
              -1793.54,
              -5115.517,
              12665.785
            ],
            [
              -1840.927,
              -5135.823,
              12717.34
            ],
            [
              -1904.939,
              -5149.154,
              12782.725
            ],
            [
              -2065.02,
              -5167.456,
              12943.849
            ],
            [
              -2110.315,
              -5178.897,
              12990.566
            ],
            [
              -2127.276,
              -5190.841,
              13011.311
            ],
            [
              -2145.02,
              -5203.693,
              13033.221
            ],
            [
              -2175.503,
              -5222.268,
              13068.917
            ],
            [
              -2204.955,
              -5248.463,
              13108.333
            ],
            [
              -2230.543,
              -5274.726,
              13145
            ],
            [
              -2512.326,
              -5691.648,
              13648.215
            ],
            [
              -2515.223,
              -5708.154,
              13664.974
            ],
            [
              -2529.5,
              -5729.639,
              13690.77
            ],
            [
              -2529.407,
              -5747.007,
              13708.138
            ],
            [
              -2525.623,
              -5751.527,
              13714.033
            ],
            [
              -2510.288,
              -5758.477,
              13730.869
            ],
            [
              -2499.033,
              -5756.062,
              13742.38
            ],
            [
              -2480.761,
              -5727.829,
              13776.01
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:19255",
              "position": {
                "x": -2002.849,
                "z": 2542.722
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 3.782,
              "arrivalOffsetSeconds": -480,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:8311",
              "position": {
                "x": -2042.349,
                "z": 2571.254
              },
              "distanceAlongShapeM": 184.031,
              "shapeOffsetM": 1.087,
              "arrivalOffsetSeconds": 60,
              "departureOffsetSeconds": 60
            },
            {
              "stopId": "judu:stop:8309",
              "position": {
                "x": -1563.915,
                "z": 2442.514
              },
              "distanceAlongShapeM": 734.469,
              "shapeOffsetM": 7.681,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:9642",
              "position": {
                "x": -1399.067,
                "z": 2279.266
              },
              "distanceAlongShapeM": 965.386,
              "shapeOffsetM": 2.18,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:6365",
              "position": {
                "x": -1411.426,
                "z": 1768.519
              },
              "distanceAlongShapeM": 1633.063,
              "shapeOffsetM": 3.132,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:16770",
              "position": {
                "x": -1774.011,
                "z": 1369.777
              },
              "distanceAlongShapeM": 2171.985,
              "shapeOffsetM": 4.841,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:16772",
              "position": {
                "x": -1194.224,
                "z": 173.835
              },
              "distanceAlongShapeM": 3844.691,
              "shapeOffsetM": 6.422,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:9007",
              "position": {
                "x": -1150.937,
                "z": -288.931
              },
              "distanceAlongShapeM": 4310.355,
              "shapeOffsetM": 7.295,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:5539",
              "position": {
                "x": -692.924,
                "z": -673.447
              },
              "distanceAlongShapeM": 5071.078,
              "shapeOffsetM": 4.211,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            },
            {
              "stopId": "judu:stop:5248",
              "position": {
                "x": -50.388,
                "z": -267.632
              },
              "distanceAlongShapeM": 5847.228,
              "shapeOffsetM": 3.723,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:5245",
              "position": {
                "x": 150.182,
                "z": -443.837
              },
              "distanceAlongShapeM": 6280.267,
              "shapeOffsetM": 5.772,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            },
            {
              "stopId": "judu:stop:753",
              "position": {
                "x": -53.078,
                "z": -805.275
              },
              "distanceAlongShapeM": 6868.872,
              "shapeOffsetM": 6.187,
              "arrivalOffsetSeconds": 1560,
              "departureOffsetSeconds": 1560
            },
            {
              "stopId": "judu:stop:7382",
              "position": {
                "x": -534.689,
                "z": -1051.466
              },
              "distanceAlongShapeM": 7409.878,
              "shapeOffsetM": 1.38,
              "arrivalOffsetSeconds": 1650,
              "departureOffsetSeconds": 1650
            },
            {
              "stopId": "judu:stop:988",
              "position": {
                "x": -763.423,
                "z": -1114.127
              },
              "distanceAlongShapeM": 7646.838,
              "shapeOffsetM": 5.791,
              "arrivalOffsetSeconds": 1710,
              "departureOffsetSeconds": 1710
            },
            {
              "stopId": "judu:stop:5290",
              "position": {
                "x": -1711.936,
                "z": -2347.263
              },
              "distanceAlongShapeM": 9373.919,
              "shapeOffsetM": 4.36,
              "arrivalOffsetSeconds": 1890,
              "departureOffsetSeconds": 1890
            },
            {
              "stopId": "judu:stop:1042",
              "position": {
                "x": -1749.208,
                "z": -2738.453
              },
              "distanceAlongShapeM": 9797.68,
              "shapeOffsetM": 7.139,
              "arrivalOffsetSeconds": 1950,
              "departureOffsetSeconds": 1950
            },
            {
              "stopId": "judu:stop:6940",
              "position": {
                "x": -1551.978,
                "z": -3062.585
              },
              "distanceAlongShapeM": 10304.294,
              "shapeOffsetM": 5.596,
              "arrivalOffsetSeconds": 2070,
              "departureOffsetSeconds": 2070
            },
            {
              "stopId": "judu:stop:6929",
              "position": {
                "x": -1372.145,
                "z": -3312.94
              },
              "distanceAlongShapeM": 10733.454,
              "shapeOffsetM": 2.736,
              "arrivalOffsetSeconds": 2190,
              "departureOffsetSeconds": 2190
            },
            {
              "stopId": "judu:stop:6926",
              "position": {
                "x": -1622.014,
                "z": -3916.292
              },
              "distanceAlongShapeM": 11391.671,
              "shapeOffsetM": 3.47,
              "arrivalOffsetSeconds": 2310,
              "departureOffsetSeconds": 2310
            },
            {
              "stopId": "judu:stop:6922",
              "position": {
                "x": -1612.338,
                "z": -4168.054
              },
              "distanceAlongShapeM": 11646.579,
              "shapeOffsetM": 3.344,
              "arrivalOffsetSeconds": 2370,
              "departureOffsetSeconds": 2370
            },
            {
              "stopId": "judu:stop:6918",
              "position": {
                "x": -1574.54,
                "z": -4648.532
              },
              "distanceAlongShapeM": 12128.79,
              "shapeOffsetM": 2.101,
              "arrivalOffsetSeconds": 2490,
              "departureOffsetSeconds": 2490
            },
            {
              "stopId": "judu:stop:5811",
              "position": {
                "x": -1696.959,
                "z": -5045.994
              },
              "distanceAlongShapeM": 12547.475,
              "shapeOffsetM": 2.646,
              "arrivalOffsetSeconds": 2610,
              "departureOffsetSeconds": 2610
            },
            {
              "stopId": "judu:stop:6915",
              "position": {
                "x": -2143.028,
                "z": -5207.26
              },
              "distanceAlongShapeM": 13033.375,
              "shapeOffsetM": 4.083,
              "arrivalOffsetSeconds": 2670,
              "departureOffsetSeconds": 2670
            },
            {
              "stopId": "judu:stop:5512",
              "position": {
                "x": -2513.285,
                "z": -5709.442
              },
              "distanceAlongShapeM": 13664.974,
              "shapeOffsetM": 2.327,
              "arrivalOffsetSeconds": 2790,
              "departureOffsetSeconds": 2790
            }
          ],
          "departuresSeconds": [
            21180,
            22560,
            24300,
            26040,
            27840,
            28980,
            30120,
            31620,
            33120,
            36060,
            38040,
            39960,
            42180,
            44520,
            46740,
            49020,
            51240,
            53700,
            55980,
            57240,
            58740,
            59940,
            61740,
            63600,
            69360,
            71460,
            73620,
            75840,
            78060,
            80220
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_bus_57",
      "sourceRouteId": "vilnius_bus_57",
      "mode": "bus",
      "shortName": "57",
      "longName": "Fabijoniškės–Ateities g.–Jeruzalė–Bajorai–Bukiškis",
      "color": "0073AC",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_bus_57:0",
          "sourceRouteId": "vilnius_bus_57",
          "sourceShapeId": "vilnius_bus_57_a-b",
          "directionId": 0,
          "headsign": "Bukiškis",
          "directionName": "Fabijoniškės–Ateities g.–Jeruzalė–Bajorai–Bukiškis",
          "mode": "bus",
          "routeShortName": "57",
          "routeLongName": "Fabijoniškės–Ateities g.–Jeruzalė–Bajorai–Bukiškis",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              -2480.761,
              -5727.829,
              0
            ],
            [
              -2465.38,
              -5705.215,
              27.349
            ],
            [
              -2457.131,
              -5687.973,
              46.463
            ],
            [
              -2458.05,
              -5680.376,
              54.116
            ],
            [
              -2467.523,
              -5671.289,
              67.242
            ],
            [
              -2484.515,
              -5648.724,
              95.489
            ],
            [
              -2453.276,
              -5597.994,
              155.066
            ],
            [
              -2437.971,
              -5575.488,
              182.284
            ],
            [
              -2323.024,
              -5404.447,
              388.361
            ],
            [
              -2243.482,
              -5280.09,
              535.981
            ],
            [
              -2221.212,
              -5257.08,
              568.002
            ],
            [
              -2172.788,
              -5214.524,
              632.469
            ],
            [
              -2110.315,
              -5178.897,
              704.386
            ],
            [
              -2057.336,
              -5161.028,
              760.297
            ],
            [
              -2028.76,
              -5156.969,
              789.161
            ],
            [
              -1894.397,
              -5142.15,
              924.338
            ],
            [
              -1856.383,
              -5135.547,
              962.921
            ],
            [
              -1800.644,
              -5116.503,
              1021.824
            ],
            [
              -1770.723,
              -5100.339,
              1055.832
            ],
            [
              -1738.711,
              -5075.306,
              1096.47
            ],
            [
              -1710.503,
              -5046.865,
              1136.527
            ],
            [
              -1676.24,
              -5004.061,
              1191.355
            ],
            [
              -1627.812,
              -5023.801,
              1243.651
            ],
            [
              -1586.957,
              -5054.639,
              1294.839
            ],
            [
              -1465.895,
              -5129.166,
              1437.002
            ],
            [
              -1407.208,
              -5161.388,
              1503.953
            ],
            [
              -1338.038,
              -5183.78,
              1576.657
            ],
            [
              -1272.777,
              -5203.963,
              1644.968
            ],
            [
              -1246.49,
              -5215.481,
              1673.667
            ],
            [
              -1208.756,
              -5230.63,
              1714.328
            ],
            [
              -1099.904,
              -5267.098,
              1829.127
            ],
            [
              -1057.683,
              -5283.443,
              1874.401
            ],
            [
              -934.323,
              -5346.656,
              2013.015
            ],
            [
              -827.457,
              -5404.886,
              2134.715
            ],
            [
              -674.33,
              -5492.97,
              2311.369
            ],
            [
              -590.252,
              -5533.933,
              2404.895
            ],
            [
              -565.267,
              -5552.833,
              2436.223
            ],
            [
              -421.759,
              -5631.135,
              2599.703
            ],
            [
              -383.93,
              -5640.727,
              2638.729
            ],
            [
              -342.157,
              -5645.939,
              2680.826
            ],
            [
              -257.182,
              -5648.596,
              2765.843
            ],
            [
              -196.756,
              -5655.261,
              2826.635
            ],
            [
              -180.177,
              -5664.469,
              2845.6
            ],
            [
              -177.649,
              -5676.666,
              2858.056
            ],
            [
              -188.191,
              -5725.09,
              2907.614
            ],
            [
              -190.648,
              -5736.736,
              2919.517
            ],
            [
              -196.91,
              -5769.923,
              2953.289
            ],
            [
              -201.665,
              -5818.819,
              3002.416
            ],
            [
              -201.086,
              -5857.793,
              3041.394
            ],
            [
              -195.599,
              -5910.215,
              3094.102
            ],
            [
              -136.015,
              -6175.138,
              3365.643
            ],
            [
              -127.679,
              -6205.529,
              3397.156
            ],
            [
              -123.468,
              -6228.802,
              3420.808
            ],
            [
              -113.557,
              -6285.758,
              3478.62
            ],
            [
              -58.166,
              -6532.794,
              3731.789
            ],
            [
              -46.468,
              -6597.576,
              3797.619
            ],
            [
              -39.377,
              -6667.839,
              3868.239
            ],
            [
              -35.045,
              -6748.072,
              3948.589
            ],
            [
              -26.235,
              -6767.677,
              3970.082
            ],
            [
              -16.413,
              -6780.218,
              3986.012
            ],
            [
              0.443,
              -6790.505,
              4005.759
            ],
            [
              9.552,
              -6811.226,
              4028.394
            ],
            [
              9.735,
              -6827.796,
              4044.965
            ],
            [
              7.024,
              -6842.352,
              4059.771
            ],
            [
              -2.815,
              -6852.191,
              4073.686
            ],
            [
              -13.86,
              -6857.556,
              4085.965
            ],
            [
              -26.131,
              -6859.559,
              4098.398
            ],
            [
              -47.374,
              -6859.171,
              4119.645
            ],
            [
              -59.463,
              -6851.158,
              4134.148
            ],
            [
              -78.653,
              -6844.129,
              4154.585
            ],
            [
              -94.726,
              -6842.723,
              4170.719
            ],
            [
              -112.168,
              -6845.745,
              4188.421
            ],
            [
              -131.642,
              -6854.296,
              4209.69
            ],
            [
              -159.633,
              -6886.315,
              4252.219
            ],
            [
              -179.506,
              -6901.294,
              4277.105
            ],
            [
              -377.89,
              -7081.371,
              4545.03
            ],
            [
              -448.339,
              -7131.301,
              4631.378
            ],
            [
              -497.724,
              -7156.009,
              4686.599
            ],
            [
              -684.153,
              -7210.52,
              4880.834
            ],
            [
              -707.406,
              -7214.553,
              4904.435
            ],
            [
              -754.116,
              -7229.048,
              4953.341
            ],
            [
              -779.861,
              -7233.281,
              4979.433
            ],
            [
              -817.998,
              -7241.497,
              5018.445
            ],
            [
              -975.194,
              -7282.076,
              5180.794
            ],
            [
              -1008.745,
              -7285.924,
              5214.565
            ],
            [
              -1020.894,
              -7277.053,
              5229.608
            ],
            [
              -1037.959,
              -7273.641,
              5247.011
            ],
            [
              -1046.989,
              -7270.906,
              5256.445
            ],
            [
              -1052.105,
              -7269.905,
              5261.658
            ],
            [
              -1063.82,
              -7268.114,
              5273.509
            ],
            [
              -1077.072,
              -7274.096,
              5288.049
            ],
            [
              -1073.172,
              -7288.103,
              5302.589
            ],
            [
              -1073.856,
              -7290.317,
              5304.907
            ],
            [
              -1077.095,
              -7291.372,
              5308.313
            ],
            [
              -1151.78,
              -7291.141,
              5382.998
            ],
            [
              -1217.964,
              -7285.204,
              5449.449
            ],
            [
              -1329.053,
              -7266.803,
              5562.051
            ],
            [
              -1377.069,
              -7251.469,
              5612.456
            ],
            [
              -1412.065,
              -7231.821,
              5652.591
            ],
            [
              -1507.971,
              -7154.497,
              5775.785
            ],
            [
              -1536.15,
              -7138.686,
              5808.096
            ],
            [
              -1559.731,
              -7132.419,
              5832.496
            ],
            [
              -1599.016,
              -7132.829,
              5871.783
            ],
            [
              -1638.278,
              -7129.238,
              5911.21
            ],
            [
              -1667.886,
              -7128.794,
              5940.82
            ],
            [
              -1685.285,
              -7135.673,
              5959.53
            ],
            [
              -1717.247,
              -7158.622,
              5998.878
            ],
            [
              -1736.997,
              -7179.344,
              6027.504
            ],
            [
              -1784.713,
              -7255.305,
              6117.208
            ],
            [
              -1799.697,
              -7265.057,
              6135.086
            ],
            [
              -1917.793,
              -7297.143,
              6257.464
            ],
            [
              -1942.097,
              -7307.046,
              6283.707
            ],
            [
              -1954.522,
              -7314.206,
              6298.048
            ],
            [
              -2033.763,
              -7360.386,
              6389.763
            ],
            [
              -2181.211,
              -7464.674,
              6570.365
            ],
            [
              -2371.558,
              -7507.326,
              6765.432
            ],
            [
              -2672.29,
              -7564.577,
              7071.565
            ],
            [
              -2721.176,
              -7573.87,
              7121.326
            ],
            [
              -2749.794,
              -7578.826,
              7150.37
            ],
            [
              -2757.259,
              -7578.837,
              7157.835
            ],
            [
              -2764.478,
              -7572.527,
              7167.424
            ],
            [
              -2768.918,
              -7547.403,
              7192.936
            ],
            [
              -2776.371,
              -7516.016,
              7225.196
            ],
            [
              -2831.651,
              -7364.756,
              7386.241
            ],
            [
              -2959.943,
              -7378.775,
              7515.297
            ],
            [
              -3095.206,
              -7392.364,
              7651.24
            ],
            [
              -3193.135,
              -7402.797,
              7749.724
            ],
            [
              -3245.112,
              -7407.584,
              7801.921
            ],
            [
              -3248.145,
              -7419.792,
              7814.5
            ],
            [
              -3244.236,
              -7487.775,
              7882.596
            ],
            [
              -3245.507,
              -7560.083,
              7954.915
            ],
            [
              -3251.327,
              -7652.242,
              8047.257
            ],
            [
              -3264.992,
              -7651.83,
              8060.928
            ],
            [
              -3296.026,
              -7652.324,
              8091.967
            ],
            [
              -3373.056,
              -7654.704,
              8169.033
            ],
            [
              -3460.156,
              -7662.745,
              8256.504
            ],
            [
              -3500.062,
              -7664.729,
              8296.459
            ],
            [
              -3625.399,
              -7683.923,
              8423.257
            ],
            [
              -3667.728,
              -7717.463,
              8477.264
            ],
            [
              -3709.931,
              -7737.878,
              8524.145
            ],
            [
              -3925.223,
              -7818.125,
              8753.906
            ],
            [
              -4560.823,
              -8099.394,
              9448.96
            ],
            [
              -4674.085,
              -7867.184,
              9707.319
            ],
            [
              -4687.701,
              -7839.34,
              9738.314
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:1158",
              "position": {
                "x": -2456.526,
                "z": -5595.784
              },
              "distanceAlongShapeM": 155.066,
              "shapeOffsetM": 3.93,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:6913",
              "position": {
                "x": -2058.363,
                "z": -5155.329
              },
              "distanceAlongShapeM": 760.297,
              "shapeOffsetM": 5.79,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:5810",
              "position": {
                "x": -1625.643,
                "z": -5020.551
              },
              "distanceAlongShapeM": 1243.651,
              "shapeOffsetM": 3.907,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:5815",
              "position": {
                "x": -1271.325,
                "z": -5199.449
              },
              "distanceAlongShapeM": 1644.968,
              "shapeOffsetM": 4.742,
              "arrivalOffsetSeconds": 330,
              "departureOffsetSeconds": 330
            },
            {
              "stopId": "judu:stop:5828",
              "position": {
                "x": -826.661,
                "z": -5403.385
              },
              "distanceAlongShapeM": 2134.696,
              "shapeOffsetM": 1.699,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:6633",
              "position": {
                "x": -589.373,
                "z": -5532.358
              },
              "distanceAlongShapeM": 2404.895,
              "shapeOffsetM": 1.804,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:6497",
              "position": {
                "x": -185.377,
                "z": -5737.848
              },
              "distanceAlongShapeM": 2919.632,
              "shapeOffsetM": 5.386,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:6500",
              "position": {
                "x": -122.378,
                "z": -6204.331
              },
              "distanceAlongShapeM": 3397.156,
              "shapeOffsetM": 5.434,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:6783",
              "position": {
                "x": -156.753,
                "z": -6889.462
              },
              "distanceAlongShapeM": 4252.219,
              "shapeOffsetM": 4.266,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:7968",
              "position": {
                "x": -752.866,
                "z": -7235.995
              },
              "distanceAlongShapeM": 4953.341,
              "shapeOffsetM": 7.058,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:18018",
              "position": {
                "x": -1047.829,
                "z": -7275.201
              },
              "distanceAlongShapeM": 5256.005,
              "shapeOffsetM": 4.354,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:9693",
              "position": {
                "x": -1952.594,
                "z": -7317.992
              },
              "distanceAlongShapeM": 6298.288,
              "shapeOffsetM": 4.242,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:9970",
              "position": {
                "x": -2371.269,
                "z": -7508.706
              },
              "distanceAlongShapeM": 6765.432,
              "shapeOffsetM": 1.41,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            },
            {
              "stopId": "judu:stop:9496",
              "position": {
                "x": -2768.73,
                "z": -7557.34
              },
              "distanceAlongShapeM": 7183.118,
              "shapeOffsetM": 1.544,
              "arrivalOffsetSeconds": 1380,
              "departureOffsetSeconds": 1380
            },
            {
              "stopId": "judu:stop:9815",
              "position": {
                "x": -3037.466,
                "z": -7388.964
              },
              "distanceAlongShapeM": 7593.45,
              "shapeOffsetM": 2.389,
              "arrivalOffsetSeconds": 1500,
              "departureOffsetSeconds": 1500
            },
            {
              "stopId": "judu:stop:15551",
              "position": {
                "x": -3295.862,
                "z": -7658.283
              },
              "distanceAlongShapeM": 8091.897,
              "shapeOffsetM": 5.961,
              "arrivalOffsetSeconds": 1590,
              "departureOffsetSeconds": 1590
            },
            {
              "stopId": "judu:stop:15561",
              "position": {
                "x": -3923.224,
                "z": -7823.223
              },
              "distanceAlongShapeM": 8754.141,
              "shapeOffsetM": 5.47,
              "arrivalOffsetSeconds": 1650,
              "departureOffsetSeconds": 1650
            },
            {
              "stopId": "judu:stop:15556",
              "position": {
                "x": -4693.512,
                "z": -7842.182
              },
              "distanceAlongShapeM": 9738.314,
              "shapeOffsetM": 6.469,
              "arrivalOffsetSeconds": 1800,
              "departureOffsetSeconds": 1800
            }
          ],
          "departuresSeconds": [
            18660,
            20160,
            21660,
            23160,
            24660,
            26460,
            27960,
            29760,
            31560,
            33960,
            36360,
            38760,
            41160,
            43560,
            45960,
            48360,
            50760,
            53160,
            55260,
            56760,
            58560,
            60060,
            61860,
            63660,
            65460,
            67560,
            69960,
            72360,
            74760,
            76860,
            79260,
            81360
          ]
        },
        {
          "id": "judu:pattern:vilnius_bus_57:1",
          "sourceRouteId": "vilnius_bus_57",
          "sourceShapeId": "vilnius_bus_57_b-a",
          "directionId": 1,
          "headsign": "Fabijoniškės",
          "directionName": "Bukiškis–Bajorai–Jeruzalė–Ateities g.–Fabijoniškės",
          "mode": "bus",
          "routeShortName": "57",
          "routeLongName": "Fabijoniškės–Ateities g.–Jeruzalė–Bajorai–Bukiškis",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              -4687.701,
              -7839.34,
              0
            ],
            [
              -4700.003,
              -7814.184,
              28.003
            ],
            [
              -4707.336,
              -7799.188,
              44.696
            ],
            [
              -4725.002,
              -7801.564,
              62.52
            ],
            [
              -4830.883,
              -7856.518,
              181.813
            ],
            [
              -4883.92,
              -7902.212,
              251.819
            ],
            [
              -4918.989,
              -7926.25,
              294.336
            ],
            [
              -4943.046,
              -7954.949,
              331.784
            ],
            [
              -4959.979,
              -7989,
              369.813
            ],
            [
              -4966.096,
              -8007.82,
              389.602
            ],
            [
              -4951.499,
              -8247.35,
              629.576
            ],
            [
              -4941.005,
              -8308.818,
              691.934
            ],
            [
              -4929.829,
              -8301.36,
              705.37
            ],
            [
              -4909.866,
              -8291.597,
              727.592
            ],
            [
              -4767.003,
              -8451.366,
              941.92
            ],
            [
              -4686.486,
              -8422.569,
              1027.431
            ],
            [
              -4493.951,
              -8327.644,
              1242.095
            ],
            [
              -4467.942,
              -8312.508,
              1272.188
            ],
            [
              -4467.164,
              -8304.729,
              1280.005
            ],
            [
              -4516.158,
              -8197.015,
              1398.338
            ],
            [
              -4537.392,
              -8152.956,
              1447.247
            ],
            [
              -4562.73,
              -8101.573,
              1504.538
            ],
            [
              -3869.696,
              -7793.291,
              2263.045
            ],
            [
              -3753.246,
              -7748.255,
              2387.901
            ],
            [
              -3718.98,
              -7739.947,
              2423.159
            ],
            [
              -3672.311,
              -7721.836,
              2473.219
            ],
            [
              -3618.811,
              -7681.603,
              2540.159
            ],
            [
              -3309.325,
              -7652.69,
              2850.993
            ],
            [
              -3271.075,
              -7650.06,
              2889.334
            ],
            [
              -3148.064,
              -7637.497,
              3012.984
            ],
            [
              -3089.299,
              -7627.397,
              3072.611
            ],
            [
              -3033.05,
              -7613.913,
              3130.453
            ],
            [
              -2961.213,
              -7592.932,
              3205.291
            ],
            [
              -2864.617,
              -7595.38,
              3301.919
            ],
            [
              -2807.917,
              -7588.933,
              3358.984
            ],
            [
              -2765.944,
              -7581.88,
              3401.545
            ],
            [
              -2724.915,
              -7572.696,
              3443.59
            ],
            [
              -2672.29,
              -7564.577,
              3496.837
            ],
            [
              -2423.247,
              -7515.651,
              3750.64
            ],
            [
              -2199.283,
              -7470.475,
              3979.116
            ],
            [
              -1983.025,
              -7327.469,
              4238.38
            ],
            [
              -1920.619,
              -7298.168,
              4307.323
            ],
            [
              -1856.905,
              -7280.04,
              4373.566
            ],
            [
              -1808.787,
              -7269.347,
              4422.857
            ],
            [
              -1791.249,
              -7260.755,
              4442.387
            ],
            [
              -1761.58,
              -7220.757,
              4492.187
            ],
            [
              -1726.273,
              -7161.772,
              4560.932
            ],
            [
              -1714.551,
              -7147.067,
              4579.737
            ],
            [
              -1705.378,
              -7127.17,
              4601.647
            ],
            [
              -1690.122,
              -7114.501,
              4621.477
            ],
            [
              -1672.882,
              -7122.602,
              4640.526
            ],
            [
              -1630.537,
              -7131.152,
              4683.725
            ],
            [
              -1593.251,
              -7133.926,
              4721.115
            ],
            [
              -1568.683,
              -7130.715,
              4745.891
            ],
            [
              -1548.965,
              -7133.145,
              4765.758
            ],
            [
              -1518.794,
              -7147.624,
              4799.224
            ],
            [
              -1410.181,
              -7230.837,
              4936.049
            ],
            [
              -1380.891,
              -7249.174,
              4970.606
            ],
            [
              -1311.07,
              -7269.352,
              5043.284
            ],
            [
              -1233.406,
              -7282.993,
              5122.137
            ],
            [
              -1124.102,
              -7291.639,
              5231.782
            ],
            [
              -1082.888,
              -7291.268,
              5272.998
            ],
            [
              -1077.696,
              -7289.237,
              5278.573
            ],
            [
              -1074.971,
              -7270.348,
              5297.658
            ],
            [
              -1062.473,
              -7266.031,
              5310.881
            ],
            [
              -1045.667,
              -7269.285,
              5327.999
            ],
            [
              -1002.208,
              -7280.476,
              5372.875
            ],
            [
              -979.66,
              -7279.769,
              5395.435
            ],
            [
              -935.71,
              -7270.543,
              5440.342
            ],
            [
              -707.406,
              -7214.553,
              5675.412
            ],
            [
              -684.153,
              -7210.52,
              5699.012
            ],
            [
              -567.625,
              -7175.894,
              5820.576
            ],
            [
              -490.912,
              -7147.103,
              5902.514
            ],
            [
              -472.731,
              -7139.026,
              5922.408
            ],
            [
              -433.975,
              -7120.429,
              5965.395
            ],
            [
              -356.786,
              -7053.923,
              6067.283
            ],
            [
              -147.918,
              -6864.018,
              6349.577
            ],
            [
              -114.729,
              -6832.74,
              6395.182
            ],
            [
              -100.778,
              -6821.461,
              6413.122
            ],
            [
              -58.991,
              -6789.938,
              6465.465
            ],
            [
              -47.746,
              -6774.569,
              6484.509
            ],
            [
              -39.488,
              -6758.546,
              6502.535
            ],
            [
              -44.133,
              -6716.735,
              6544.603
            ],
            [
              -50.641,
              -6695.446,
              6566.864
            ],
            [
              -48.526,
              -6639.841,
              6622.51
            ],
            [
              -52.099,
              -6588.567,
              6673.908
            ],
            [
              -70.555,
              -6505.85,
              6758.659
            ],
            [
              -125.166,
              -6286.66,
              6984.55
            ],
            [
              -158.525,
              -6137.991,
              7136.916
            ],
            [
              -180.294,
              -6069.166,
              7209.101
            ],
            [
              -186.217,
              -6031.729,
              7247.004
            ],
            [
              -210.448,
              -5912.171,
              7368.993
            ],
            [
              -214.688,
              -5861.998,
              7419.344
            ],
            [
              -215.425,
              -5796.303,
              7485.044
            ],
            [
              -210.007,
              -5746.306,
              7535.333
            ],
            [
              -195.772,
              -5671.978,
              7611.012
            ],
            [
              -200.158,
              -5665.219,
              7619.07
            ],
            [
              -245.834,
              -5662.161,
              7664.848
            ],
            [
              -275.267,
              -5661.057,
              7694.302
            ],
            [
              -299.862,
              -5657.84,
              7719.106
            ],
            [
              -394.957,
              -5644.98,
              7815.067
            ],
            [
              -428.258,
              -5634.356,
              7850.021
            ],
            [
              -633.019,
              -5523.775,
              8082.734
            ],
            [
              -662.96,
              -5509.616,
              8115.854
            ],
            [
              -740.412,
              -5464.845,
              8205.315
            ],
            [
              -765.768,
              -5455.693,
              8232.272
            ],
            [
              -887.614,
              -5390.039,
              8370.68
            ],
            [
              -926.205,
              -5371.757,
              8413.383
            ],
            [
              -1090.384,
              -5275.062,
              8603.921
            ],
            [
              -1302.999,
              -5205.56,
              8827.607
            ],
            [
              -1387.113,
              -5180.474,
              8915.382
            ],
            [
              -1666.095,
              -5013.148,
              9240.696
            ],
            [
              -1677.043,
              -5012.953,
              9251.646
            ],
            [
              -1699.03,
              -5044.347,
              9289.973
            ],
            [
              -1770.723,
              -5100.339,
              9380.94
            ],
            [
              -1793.54,
              -5115.517,
              9408.344
            ],
            [
              -1816.278,
              -5126.243,
              9433.485
            ],
            [
              -1840.927,
              -5135.823,
              9459.93
            ],
            [
              -1875.217,
              -5144.118,
              9495.21
            ],
            [
              -1904.939,
              -5149.154,
              9525.355
            ],
            [
              -2065.02,
              -5167.456,
              9686.479
            ],
            [
              -2110.315,
              -5178.897,
              9733.197
            ],
            [
              -2127.276,
              -5190.841,
              9753.941
            ],
            [
              -2145.02,
              -5203.693,
              9775.851
            ],
            [
              -2175.503,
              -5222.268,
              9811.547
            ],
            [
              -2204.955,
              -5248.463,
              9850.963
            ],
            [
              -2230.543,
              -5274.726,
              9887.63
            ],
            [
              -2374.125,
              -5489.26,
              10145.779
            ],
            [
              -2484.515,
              -5648.724,
              10339.724
            ],
            [
              -2512.326,
              -5691.648,
              10390.87
            ],
            [
              -2515.223,
              -5708.154,
              10407.628
            ],
            [
              -2529.5,
              -5729.639,
              10433.424
            ],
            [
              -2529.407,
              -5747.007,
              10450.792
            ],
            [
              -2525.623,
              -5751.527,
              10456.687
            ],
            [
              -2510.288,
              -5758.477,
              10473.524
            ],
            [
              -2499.033,
              -5756.062,
              10485.035
            ],
            [
              -2480.761,
              -5727.829,
              10518.665
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:15556",
              "position": {
                "x": -4693.512,
                "z": -7842.182
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 6.469,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:15202",
              "position": {
                "x": -4542.477,
                "z": -8155.372
              },
              "distanceAlongShapeM": 1447.329,
              "shapeOffsetM": 5.629,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:15558",
              "position": {
                "x": -3871.136,
                "z": -7789.619
              },
              "distanceAlongShapeM": 2263.045,
              "shapeOffsetM": 3.944,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:15550",
              "position": {
                "x": -3271.151,
                "z": -7644.244
              },
              "distanceAlongShapeM": 2889.848,
              "shapeOffsetM": 5.793,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:15548",
              "position": {
                "x": -2725.784,
                "z": -7568.117
              },
              "distanceAlongShapeM": 3443.59,
              "shapeOffsetM": 4.661,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:9971",
              "position": {
                "x": -2424.106,
                "z": -7511.11
              },
              "distanceAlongShapeM": 3750.697,
              "shapeOffsetM": 4.622,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:9694",
              "position": {
                "x": -1983.025,
                "z": -7327.469
              },
              "distanceAlongShapeM": 4238.38,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:7052",
              "position": {
                "x": -1045.114,
                "z": -7267.457
              },
              "distanceAlongShapeM": 5328.078,
              "shapeOffsetM": 1.908,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:8326",
              "position": {
                "x": -492.955,
                "z": -7141.624
              },
              "distanceAlongShapeM": 5902.871,
              "shapeOffsetM": 5.837,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            },
            {
              "stopId": "judu:stop:8327",
              "position": {
                "x": -119.568,
                "z": -6827.798
              },
              "distanceAlongShapeM": 6395.05,
              "shapeOffsetM": 6.915,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:6503",
              "position": {
                "x": -50.829,
                "z": -6695.462
              },
              "distanceAlongShapeM": 6566.864,
              "shapeOffsetM": 0.189,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:6501",
              "position": {
                "x": -182.398,
                "z": -6069.649
              },
              "distanceAlongShapeM": 7209.101,
              "shapeOffsetM": 2.159,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:6640",
              "position": {
                "x": -275.515,
                "z": -5664.961
              },
              "distanceAlongShapeM": 7694.302,
              "shapeOffsetM": 3.912,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            },
            {
              "stopId": "judu:stop:6634",
              "position": {
                "x": -663.705,
                "z": -5510.974
              },
              "distanceAlongShapeM": 8115.854,
              "shapeOffsetM": 1.549,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            },
            {
              "stopId": "judu:stop:5822",
              "position": {
                "x": -927.257,
                "z": -5373.739
              },
              "distanceAlongShapeM": 8413.383,
              "shapeOffsetM": 2.244,
              "arrivalOffsetSeconds": 1560,
              "departureOffsetSeconds": 1560
            },
            {
              "stopId": "judu:stop:5814",
              "position": {
                "x": -1387.604,
                "z": -5181.778
              },
              "distanceAlongShapeM": 8915.382,
              "shapeOffsetM": 1.394,
              "arrivalOffsetSeconds": 1680,
              "departureOffsetSeconds": 1680
            },
            {
              "stopId": "judu:stop:5811",
              "position": {
                "x": -1696.959,
                "z": -5045.994
              },
              "distanceAlongShapeM": 9289.973,
              "shapeOffsetM": 2.646,
              "arrivalOffsetSeconds": 1740,
              "departureOffsetSeconds": 1740
            },
            {
              "stopId": "judu:stop:6915",
              "position": {
                "x": -2143.028,
                "z": -5207.26
              },
              "distanceAlongShapeM": 9776.006,
              "shapeOffsetM": 4.083,
              "arrivalOffsetSeconds": 1800,
              "departureOffsetSeconds": 1800
            },
            {
              "stopId": "judu:stop:5512",
              "position": {
                "x": -2513.285,
                "z": -5709.442
              },
              "distanceAlongShapeM": 10407.628,
              "shapeOffsetM": 2.327,
              "arrivalOffsetSeconds": 1920,
              "departureOffsetSeconds": 1920
            }
          ],
          "departuresSeconds": [
            20400,
            21900,
            23400,
            24900,
            26400,
            28380,
            29880,
            31560,
            33300,
            35760,
            38160,
            40620,
            42900,
            45360,
            47820,
            50220,
            52620,
            55020,
            57120,
            58680,
            60420,
            61980,
            63780,
            65640,
            67440,
            69420,
            71760,
            74160,
            76440,
            78540,
            80940,
            83100
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_bus_58",
      "sourceRouteId": "vilnius_bus_58",
      "mode": "bus",
      "shortName": "58",
      "longName": "Stotis–Dzūkų g.–Minsko pl.–Kalnėnai–Guriai–Grigaičiai",
      "color": "0073AC",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_bus_58:0",
          "sourceRouteId": "vilnius_bus_58",
          "sourceShapeId": "vilnius_bus_58_a-b",
          "directionId": 0,
          "headsign": "Grigaičiai",
          "directionName": "Stotis–Dzūkų g.–Minsko pl.–Kalnėnai–Guriai–Grigaičiai",
          "mode": "bus",
          "routeShortName": "58",
          "routeLongName": "Stotis–Dzūkų g.–Minsko pl.–Kalnėnai–Guriai–Grigaičiai",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              379.597,
              1946.537,
              0
            ],
            [
              374.762,
              1964.437,
              18.542
            ],
            [
              365.352,
              1979.081,
              35.948
            ],
            [
              363.579,
              1988.02,
              45.061
            ],
            [
              364.971,
              1993.56,
              50.774
            ],
            [
              373.539,
              2003.423,
              63.838
            ],
            [
              379.385,
              2005.542,
              70.057
            ],
            [
              392.284,
              2005.307,
              82.958
            ],
            [
              471.993,
              1953.753,
              177.886
            ],
            [
              476.99,
              1944.756,
              188.177
            ],
            [
              476.827,
              1935.853,
              197.082
            ],
            [
              481.158,
              1925.755,
              208.069
            ],
            [
              623.161,
              1858.587,
              365.157
            ],
            [
              825.163,
              1791.425,
              578.031
            ],
            [
              862.14,
              1837.501,
              637.11
            ],
            [
              759.825,
              1942.227,
              783.52
            ],
            [
              745.862,
              1957.85,
              804.474
            ],
            [
              722.942,
              1987.005,
              841.559
            ],
            [
              680.883,
              2015.607,
              892.422
            ],
            [
              612.97,
              2076.967,
              983.949
            ],
            [
              575.791,
              2125.517,
              1045.099
            ],
            [
              554.513,
              2161.53,
              1086.929
            ],
            [
              539.42,
              2182.958,
              1113.139
            ],
            [
              519.811,
              2204.469,
              1142.246
            ],
            [
              468.195,
              2239.923,
              1204.865
            ],
            [
              433.065,
              2259.491,
              1245.078
            ],
            [
              407.979,
              2274.133,
              1274.124
            ],
            [
              348.251,
              2314.476,
              1346.2
            ],
            [
              296.511,
              2343.252,
              1405.404
            ],
            [
              241.342,
              2360.957,
              1463.344
            ],
            [
              16.426,
              2411.811,
              1693.938
            ],
            [
              -125.342,
              2457.804,
              1842.98
            ],
            [
              -106.729,
              2502.326,
              1891.236
            ],
            [
              -85.333,
              2538.575,
              1933.328
            ],
            [
              -47.935,
              2568.062,
              1980.953
            ],
            [
              -26.027,
              2576.361,
              2004.38
            ],
            [
              62.617,
              2607.921,
              2098.475
            ],
            [
              140.019,
              2643.338,
              2183.595
            ],
            [
              194.472,
              2675.04,
              2246.604
            ],
            [
              216.306,
              2684.143,
              2270.26
            ],
            [
              299.909,
              2706.103,
              2356.699
            ],
            [
              363.854,
              2709.388,
              2420.728
            ],
            [
              542.176,
              2697.811,
              2599.425
            ],
            [
              613.119,
              2683.676,
              2671.763
            ],
            [
              639.106,
              2680.046,
              2698.002
            ],
            [
              659.423,
              2675.035,
              2718.928
            ],
            [
              708.204,
              2660.781,
              2769.749
            ],
            [
              908.397,
              2633.726,
              2971.762
            ],
            [
              971.677,
              2635.902,
              3035.079
            ],
            [
              1005.385,
              2644.187,
              3069.79
            ],
            [
              1060.379,
              2667.441,
              3129.499
            ],
            [
              1077.092,
              2674.808,
              3147.763
            ],
            [
              1206.381,
              2730.654,
              3288.598
            ],
            [
              1376.192,
              2805.444,
              3474.149
            ],
            [
              1396.799,
              2814.696,
              3496.738
            ],
            [
              1465.314,
              2843.871,
              3571.206
            ],
            [
              1478.278,
              2846.971,
              3584.536
            ],
            [
              1505.249,
              2839.792,
              3612.446
            ],
            [
              1568.191,
              2893.175,
              3694.977
            ],
            [
              1642.261,
              2989.766,
              3816.699
            ],
            [
              1688.949,
              3071.28,
              3910.637
            ],
            [
              1698.766,
              3113.401,
              3953.887
            ],
            [
              1697.905,
              3171.305,
              4011.797
            ],
            [
              1701.978,
              3216.872,
              4057.546
            ],
            [
              1702.066,
              3325.968,
              4166.642
            ],
            [
              1699.765,
              3410.617,
              4251.322
            ],
            [
              1687.827,
              3497.671,
              4339.191
            ],
            [
              1677.311,
              3606.988,
              4449.013
            ],
            [
              1678.691,
              3631.429,
              4473.492
            ],
            [
              1674.798,
              3769.542,
              4611.66
            ],
            [
              1682.198,
              3784.941,
              4628.744
            ],
            [
              1743.856,
              3803.884,
              4693.247
            ],
            [
              1811.196,
              3832.214,
              4766.303
            ],
            [
              1875.636,
              3868.945,
              4840.477
            ],
            [
              2082.225,
              4019.124,
              5095.884
            ],
            [
              2137.697,
              4051.487,
              5160.106
            ],
            [
              3783.191,
              4734.089,
              6941.565
            ],
            [
              4094.837,
              4859.518,
              7277.505
            ],
            [
              4105.015,
              4851.531,
              7290.443
            ],
            [
              4106.76,
              4841.478,
              7300.646
            ],
            [
              3917.18,
              4757.37,
              7508.046
            ],
            [
              3791.824,
              4712.774,
              7641.098
            ],
            [
              2821.939,
              4306.494,
              8692.641
            ],
            [
              2770.246,
              4289.011,
              8747.21
            ],
            [
              2807.11,
              4258.26,
              8795.216
            ],
            [
              2948.179,
              4207.737,
              8945.059
            ],
            [
              2964.035,
              4199.549,
              8962.905
            ],
            [
              2979.047,
              4187.028,
              8982.453
            ],
            [
              3008.608,
              4155.968,
              9025.331
            ],
            [
              3084.382,
              4084.475,
              9129.509
            ],
            [
              3137.191,
              4039.772,
              9198.698
            ],
            [
              3297.481,
              3913.396,
              9402.815
            ],
            [
              3423.046,
              3790.94,
              9578.207
            ],
            [
              3464.872,
              3750.332,
              9636.503
            ],
            [
              3524.985,
              3693.825,
              9719.005
            ],
            [
              3573.995,
              3640.18,
              9791.666
            ],
            [
              3587.716,
              3618.986,
              9816.914
            ],
            [
              3606.524,
              3589.684,
              9851.733
            ],
            [
              3645.319,
              3541.905,
              9913.279
            ],
            [
              3677.609,
              3505.18,
              9962.18
            ],
            [
              3704.474,
              3471.67,
              10005.13
            ],
            [
              3737.684,
              3408.728,
              10076.297
            ],
            [
              3768.579,
              3320.539,
              10169.74
            ],
            [
              3800.616,
              3274.286,
              10226.005
            ],
            [
              3829.554,
              3242.954,
              10268.656
            ],
            [
              3851.353,
              3210.801,
              10307.502
            ],
            [
              3863.893,
              3174.002,
              10346.379
            ],
            [
              3887.359,
              3084.495,
              10438.911
            ],
            [
              3901.779,
              3036.225,
              10489.289
            ],
            [
              3931.594,
              2930.045,
              10599.575
            ],
            [
              3985.636,
              2755.326,
              10782.461
            ],
            [
              4071.321,
              2781.522,
              10872.061
            ],
            [
              4105.66,
              2788.66,
              10907.134
            ],
            [
              4138.843,
              2793.388,
              10940.652
            ],
            [
              4163.33,
              2800.917,
              10966.271
            ],
            [
              4290.348,
              2828.546,
              11096.259
            ],
            [
              5092.921,
              3043.024,
              11926.996
            ],
            [
              5121.945,
              3048.569,
              11956.545
            ],
            [
              5292.05,
              3067.545,
              12127.705
            ],
            [
              5437.44,
              3099.69,
              12276.606
            ],
            [
              5500.224,
              3119.175,
              12342.344
            ],
            [
              5591.84,
              3150.794,
              12439.263
            ],
            [
              5668.535,
              3180,
              12521.33
            ],
            [
              5815.242,
              3219.71,
              12673.318
            ],
            [
              6262.907,
              3304.224,
              13128.89
            ],
            [
              6335.427,
              3311.056,
              13201.731
            ],
            [
              6385.807,
              3312.938,
              13252.146
            ],
            [
              6562.995,
              3305.501,
              13429.49
            ],
            [
              7047.967,
              3286.313,
              13914.841
            ],
            [
              7156.927,
              3279.329,
              14024.025
            ],
            [
              7272.999,
              3275.548,
              14140.159
            ],
            [
              7362.123,
              3280.212,
              14229.404
            ],
            [
              7395.391,
              3288.346,
              14263.652
            ],
            [
              7495,
              3304.919,
              14364.631
            ],
            [
              7573.651,
              3328.267,
              14446.674
            ],
            [
              7671.041,
              3361.54,
              14549.591
            ],
            [
              7847.425,
              3435.59,
              14740.888
            ],
            [
              8259.242,
              3596.959,
              15183.193
            ],
            [
              8337.039,
              3629.077,
              15267.359
            ],
            [
              8545.658,
              3711.144,
              15491.54
            ],
            [
              8552.88,
              3724.706,
              15506.905
            ],
            [
              8562.757,
              3732.265,
              15519.342
            ],
            [
              8572.68,
              3730.576,
              15529.407
            ],
            [
              8578.771,
              3724.585,
              15537.951
            ],
            [
              8581.483,
              3716.009,
              15546.946
            ],
            [
              8580.213,
              3708.229,
              15554.829
            ],
            [
              8568.02,
              3697.555,
              15571.035
            ],
            [
              8653.999,
              3429.179,
              15852.847
            ],
            [
              8776.995,
              3127.823,
              16178.336
            ],
            [
              8815.688,
              3021.356,
              16291.617
            ],
            [
              8866.434,
              2786.401,
              16531.989
            ],
            [
              8885.136,
              2681.294,
              16638.747
            ],
            [
              8904.676,
              2557.458,
              16764.115
            ],
            [
              8903.472,
              2527.793,
              16793.804
            ],
            [
              8903.577,
              2528.48,
              16794.499
            ],
            [
              8901.093,
              2515.221,
              16807.99
            ],
            [
              8901.437,
              2517.036,
              16809.837
            ],
            [
              8898.415,
              2502.108,
              16825.069
            ],
            [
              8898.237,
              2501.275,
              16825.921
            ],
            [
              8891.727,
              2470.972,
              16856.915
            ],
            [
              8858.803,
              2310.209,
              17021.014
            ],
            [
              8847.277,
              2282.609,
              17050.924
            ],
            [
              8731.774,
              2154.679,
              17223.282
            ],
            [
              8712.486,
              2126.121,
              17257.743
            ],
            [
              8701.741,
              2105.185,
              17281.275
            ],
            [
              8692.272,
              2056.506,
              17330.867
            ],
            [
              8691.4,
              1943.966,
              17443.41
            ],
            [
              8693.489,
              1904.774,
              17482.658
            ],
            [
              8696.6,
              1837.986,
              17549.518
            ],
            [
              8709.72,
              1695.278,
              17692.828
            ],
            [
              8718.924,
              1653.9,
              17735.218
            ],
            [
              8801.604,
              1411.711,
              17991.131
            ],
            [
              8817.485,
              1309.543,
              18094.525
            ],
            [
              8851.244,
              1062.1,
              18344.261
            ],
            [
              8850.092,
              1004.111,
              18402.261
            ],
            [
              8830.363,
              918.837,
              18489.788
            ],
            [
              8791.708,
              801.055,
              18613.751
            ],
            [
              8731.743,
              670.048,
              18757.829
            ],
            [
              8715.861,
              626.45,
              18804.23
            ],
            [
              8700.865,
              570.183,
              18862.461
            ],
            [
              8695.013,
              565.284,
              18870.093
            ],
            [
              8687.276,
              564.46,
              18877.873
            ],
            [
              8677.287,
              576.923,
              18893.846
            ],
            [
              8678.901,
              584.889,
              18901.974
            ],
            [
              8686.728,
              589.185,
              18910.902
            ],
            [
              8727.087,
              659.577,
              18992.044
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:3617",
              "position": {
                "x": 379.597,
                "z": 1946.537
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": -540,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:6005",
              "position": {
                "x": 756.914,
                "z": 1939.625
              },
              "distanceAlongShapeM": 783.52,
              "shapeOffsetM": 3.904,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:6008",
              "position": {
                "x": 406.177,
                "z": 2271.115
              },
              "distanceAlongShapeM": 1274.124,
              "shapeOffsetM": 3.515,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:6012",
              "position": {
                "x": -50.951,
                "z": 2574.454
              },
              "distanceAlongShapeM": 1980.953,
              "shapeOffsetM": 7.068,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:6014",
              "position": {
                "x": 191.691,
                "z": 2681.359
              },
              "distanceAlongShapeM": 2246.604,
              "shapeOffsetM": 6.904,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:6017",
              "position": {
                "x": 640.253,
                "z": 2685.405
              },
              "distanceAlongShapeM": 2698.002,
              "shapeOffsetM": 5.48,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:6019",
              "position": {
                "x": 1058.795,
                "z": 2671.034
              },
              "distanceAlongShapeM": 3129.439,
              "shapeOffsetM": 3.926,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:5948",
              "position": {
                "x": 1395.147,
                "z": 2818.452
              },
              "distanceAlongShapeM": 3496.738,
              "shapeOffsetM": 4.103,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:16977",
              "position": {
                "x": 1743.856,
                "z": 3803.884
              },
              "distanceAlongShapeM": 4693.247,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:616",
              "position": {
                "x": 2873.526,
                "z": 4357.203
              },
              "distanceAlongShapeM": 5956.916,
              "shapeOffsetM": 0.435,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            },
            {
              "stopId": "judu:stop:6121",
              "position": {
                "x": 3917.274,
                "z": 4757.143
              },
              "distanceAlongShapeM": 7508.046,
              "shapeOffsetM": 0.246,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:617",
              "position": {
                "x": 2822.207,
                "z": 4305.846
              },
              "distanceAlongShapeM": 8692.641,
              "shapeOffsetM": 0.701,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:16920",
              "position": {
                "x": 3009.186,
                "z": 4156.492
              },
              "distanceAlongShapeM": 9025.392,
              "shapeOffsetM": 0.778,
              "arrivalOffsetSeconds": 1230,
              "departureOffsetSeconds": 1230
            },
            {
              "stopId": "judu:stop:9593",
              "position": {
                "x": 3527.875,
                "z": 3696.935
              },
              "distanceAlongShapeM": 9718.98,
              "shapeOffsetM": 4.246,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            },
            {
              "stopId": "judu:stop:9660",
              "position": {
                "x": 3905.823,
                "z": 3037.387
              },
              "distanceAlongShapeM": 10489.289,
              "shapeOffsetM": 4.208,
              "arrivalOffsetSeconds": 1380,
              "departureOffsetSeconds": 1380
            },
            {
              "stopId": "judu:stop:7710",
              "position": {
                "x": 4207.39,
                "z": 2810.094
              },
              "distanceAlongShapeM": 11011.274,
              "shapeOffsetM": 0.398,
              "arrivalOffsetSeconds": 1500,
              "departureOffsetSeconds": 1500
            },
            {
              "stopId": "judu:stop:7711",
              "position": {
                "x": 4689.298,
                "z": 2935.561
              },
              "distanceAlongShapeM": 11509.312,
              "shapeOffsetM": 0.387,
              "arrivalOffsetSeconds": 1560,
              "departureOffsetSeconds": 1560
            },
            {
              "stopId": "judu:stop:7819",
              "position": {
                "x": 5061.022,
                "z": 3035.273
              },
              "distanceAlongShapeM": 11894.177,
              "shapeOffsetM": 0.748,
              "arrivalOffsetSeconds": 1620,
              "departureOffsetSeconds": 1620
            },
            {
              "stopId": "judu:stop:7714",
              "position": {
                "x": 5327.727,
                "z": 3076.874
              },
              "distanceAlongShapeM": 12164.555,
              "shapeOffsetM": 1.407,
              "arrivalOffsetSeconds": 1680,
              "departureOffsetSeconds": 1680
            },
            {
              "stopId": "judu:stop:16231",
              "position": {
                "x": 5667.349,
                "z": 3183.839
              },
              "distanceAlongShapeM": 12521.33,
              "shapeOffsetM": 4.018,
              "arrivalOffsetSeconds": 1740,
              "departureOffsetSeconds": 1740
            },
            {
              "stopId": "judu:stop:16171",
              "position": {
                "x": 6385.83,
                "z": 3322.335
              },
              "distanceAlongShapeM": 13252.146,
              "shapeOffsetM": 9.397,
              "arrivalOffsetSeconds": 1800,
              "departureOffsetSeconds": 1800
            },
            {
              "stopId": "judu:stop:16174",
              "position": {
                "x": 7571.128,
                "z": 3335.693
              },
              "distanceAlongShapeM": 14446.369,
              "shapeOffsetM": 7.837,
              "arrivalOffsetSeconds": 1920,
              "departureOffsetSeconds": 1920
            },
            {
              "stopId": "judu:stop:4965",
              "position": {
                "x": 8920.296,
                "z": 2511.588
              },
              "distanceAlongShapeM": 16807.99,
              "shapeOffsetM": 19.543,
              "arrivalOffsetSeconds": 2160,
              "departureOffsetSeconds": 2160
            },
            {
              "stopId": "judu:stop:6030",
              "position": {
                "x": 8696.422,
                "z": 1904.9
              },
              "distanceAlongShapeM": 17482.669,
              "shapeOffsetM": 2.936,
              "arrivalOffsetSeconds": 2280,
              "departureOffsetSeconds": 2280
            },
            {
              "stopId": "judu:stop:7357",
              "position": {
                "x": 8821.879,
                "z": 1310.104
              },
              "distanceAlongShapeM": 18094.564,
              "shapeOffsetM": 4.43,
              "arrivalOffsetSeconds": 2340,
              "departureOffsetSeconds": 2340
            },
            {
              "stopId": "judu:stop:6032",
              "position": {
                "x": 8721.736,
                "z": 661.957
              },
              "distanceAlongShapeM": 18991.447,
              "shapeOffsetM": 5.826,
              "arrivalOffsetSeconds": 2400,
              "departureOffsetSeconds": 2400
            }
          ],
          "departuresSeconds": [
            18720,
            22320,
            24240,
            26040,
            28440,
            32100,
            33900,
            37740,
            39900,
            43620,
            45840,
            49560,
            51660,
            55380,
            56880,
            58740,
            61080,
            63060,
            65280,
            67260,
            72420,
            76380,
            78480,
            81480
          ]
        },
        {
          "id": "judu:pattern:vilnius_bus_58:1",
          "sourceRouteId": "vilnius_bus_58",
          "sourceShapeId": "vilnius_bus_58_b-a",
          "directionId": 1,
          "headsign": "Stotis",
          "directionName": "Grigaičiai–Guriai–Kalnėnai–Minsko pl.–Dzūkų g.–Stotis",
          "mode": "bus",
          "routeShortName": "58",
          "routeLongName": "Stotis–Dzūkų g.–Minsko pl.–Kalnėnai–Guriai–Grigaičiai",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              8727.087,
              659.577,
              0
            ],
            [
              8759.643,
              727.216,
              75.065
            ],
            [
              8819.472,
              870.402,
              230.249
            ],
            [
              8846.872,
              976.844,
              340.161
            ],
            [
              8854.075,
              1018.886,
              382.815
            ],
            [
              8852.191,
              1053.436,
              417.417
            ],
            [
              8820.751,
              1266.063,
              632.355
            ],
            [
              8821.267,
              1283.385,
              649.685
            ],
            [
              8816.868,
              1314.381,
              680.992
            ],
            [
              8803.5,
              1403.78,
              771.385
            ],
            [
              8726.321,
              1627.089,
              1007.655
            ],
            [
              8709.628,
              1695.336,
              1077.914
            ],
            [
              8695.548,
              1856.955,
              1240.145
            ],
            [
              8691.341,
              1888.41,
              1271.88
            ],
            [
              8690.755,
              1943.979,
              1327.452
            ],
            [
              8687.807,
              2021.969,
              1405.498
            ],
            [
              8694.889,
              2071.277,
              1455.312
            ],
            [
              8714.191,
              2131.483,
              1518.536
            ],
            [
              8739.783,
              2167.877,
              1563.028
            ],
            [
              8789.814,
              2216.968,
              1633.121
            ],
            [
              8839.29,
              2270.523,
              1706.031
            ],
            [
              8861.119,
              2329.088,
              1768.532
            ],
            [
              8873.164,
              2395.571,
              1836.097
            ],
            [
              8889.584,
              2460.002,
              1902.588
            ],
            [
              8901.904,
              2553.156,
              1996.554
            ],
            [
              8891.976,
              2625.748,
              2069.821
            ],
            [
              8865.706,
              2780.991,
              2227.271
            ],
            [
              8820.304,
              2993.434,
              2444.512
            ],
            [
              8799.142,
              3065.107,
              2519.243
            ],
            [
              8684.554,
              3347.858,
              2824.331
            ],
            [
              8620.617,
              3528.706,
              3016.149
            ],
            [
              8586.437,
              3640.961,
              3133.492
            ],
            [
              8566.904,
              3701.12,
              3196.742
            ],
            [
              8548.693,
              3706.941,
              3215.861
            ],
            [
              8501.01,
              3678.953,
              3271.151
            ],
            [
              8306.055,
              3613.835,
              3476.694
            ],
            [
              7726.596,
              3382.449,
              4100.643
            ],
            [
              7650.714,
              3352.425,
              4182.249
            ],
            [
              7499.748,
              3303.153,
              4341.052
            ],
            [
              7380.651,
              3282.559,
              4461.916
            ],
            [
              7211.768,
              3278.244,
              4630.854
            ],
            [
              6350.083,
              3309.676,
              5493.112
            ],
            [
              6257.276,
              3299.684,
              5586.455
            ],
            [
              6181.877,
              3289.589,
              5662.528
            ],
            [
              5984.894,
              3250.018,
              5863.446
            ],
            [
              5854.069,
              3226.963,
              5996.287
            ],
            [
              5699.028,
              3186.563,
              6156.505
            ],
            [
              5543.897,
              3133.572,
              6320.437
            ],
            [
              5478.145,
              3110.062,
              6390.266
            ],
            [
              5367.647,
              3081.385,
              6504.424
            ],
            [
              5288.726,
              3065.734,
              6584.882
            ],
            [
              5197.6,
              3056.013,
              6676.525
            ],
            [
              5165.736,
              3051.048,
              6708.774
            ],
            [
              5102.461,
              3042.266,
              6772.655
            ],
            [
              4670.733,
              2928.273,
              7219.179
            ],
            [
              4138.843,
              2793.388,
              7767.906
            ],
            [
              4071.945,
              2780.397,
              7836.053
            ],
            [
              4052.738,
              2774.631,
              7856.107
            ],
            [
              4026.587,
              2767.592,
              7883.189
            ],
            [
              3985.636,
              2755.326,
              7925.937
            ],
            [
              3952.19,
              2873.685,
              8048.931
            ],
            [
              3930.43,
              2940.065,
              8118.787
            ],
            [
              3906.137,
              3012.399,
              8195.091
            ],
            [
              3859.028,
              3189.68,
              8378.525
            ],
            [
              3858.285,
              3194.99,
              8383.886
            ],
            [
              3829.554,
              3242.954,
              8439.797
            ],
            [
              3797.453,
              3277.686,
              8487.092
            ],
            [
              3777.961,
              3304.775,
              8520.465
            ],
            [
              3765.501,
              3328.39,
              8547.165
            ],
            [
              3756.892,
              3350.819,
              8571.19
            ],
            [
              3739.601,
              3403.156,
              8626.309
            ],
            [
              3714.362,
              3456.273,
              8685.117
            ],
            [
              3677.609,
              3505.18,
              8746.295
            ],
            [
              3619.09,
              3571.634,
              8834.842
            ],
            [
              3595.247,
              3607.71,
              8878.085
            ],
            [
              3585.636,
              3623.519,
              8896.586
            ],
            [
              3505.544,
              3708.064,
              9013.045
            ],
            [
              3423.046,
              3790.94,
              9129.982
            ],
            [
              3347.302,
              3865.756,
              9236.447
            ],
            [
              3289.347,
              3917.422,
              9314.087
            ],
            [
              3181.919,
              4004.914,
              9452.636
            ],
            [
              3071.739,
              4090.702,
              9592.275
            ],
            [
              3027.027,
              4131.437,
              9652.761
            ],
            [
              2994.997,
              4170.986,
              9703.653
            ],
            [
              2976.675,
              4189.151,
              9729.454
            ],
            [
              2942.434,
              4211.185,
              9770.172
            ],
            [
              2862.761,
              4236.857,
              9853.879
            ],
            [
              2800.72,
              4261.72,
              9920.716
            ],
            [
              2770.892,
              4288.999,
              9961.137
            ],
            [
              2014.561,
              3946.135,
              10791.554
            ],
            [
              1923.07,
              3875.507,
              10907.134
            ],
            [
              1866.512,
              3839.455,
              10974.206
            ],
            [
              1783.091,
              3795.567,
              11068.467
            ],
            [
              1749.936,
              3783.733,
              11103.671
            ],
            [
              1707.019,
              3766.718,
              11149.838
            ],
            [
              1679.129,
              3759.443,
              11178.661
            ],
            [
              1684.234,
              3721.498,
              11216.948
            ],
            [
              1695.827,
              3441.86,
              11496.826
            ],
            [
              1706.344,
              3348.137,
              11591.137
            ],
            [
              1706.2,
              3235.719,
              11703.556
            ],
            [
              1703.36,
              3152.279,
              11787.044
            ],
            [
              1697.873,
              3100.058,
              11839.552
            ],
            [
              1688.949,
              3071.28,
              11869.682
            ],
            [
              1673.368,
              3031.492,
              11912.412
            ],
            [
              1650.731,
              2994.062,
              11956.155
            ],
            [
              1615.61,
              2944.618,
              12016.803
            ],
            [
              1601.066,
              2925.963,
              12040.458
            ],
            [
              1567.546,
              2893.187,
              12087.339
            ],
            [
              1513.094,
              2845.213,
              12159.91
            ],
            [
              1497.028,
              2840.02,
              12176.795
            ],
            [
              1485.952,
              2848.206,
              12190.567
            ],
            [
              1443.457,
              2829.914,
              12236.832
            ],
            [
              1406.053,
              2814.911,
              12277.132
            ],
            [
              1368.348,
              2800.023,
              12317.67
            ],
            [
              1087.927,
              2676.064,
              12624.267
            ],
            [
              965.178,
              2631.877,
              12754.727
            ],
            [
              940.631,
              2632.02,
              12779.275
            ],
            [
              813.733,
              2644.372,
              12906.772
            ],
            [
              708.204,
              2660.781,
              13013.569
            ],
            [
              612.475,
              2680.657,
              13111.34
            ],
            [
              578.441,
              2686.89,
              13145.941
            ],
            [
              552.602,
              2691.464,
              13172.181
            ],
            [
              433.484,
              2705.889,
              13292.169
            ],
            [
              299.909,
              2706.103,
              13425.744
            ],
            [
              261.02,
              2696.793,
              13465.732
            ],
            [
              216.204,
              2680.913,
              13513.278
            ],
            [
              193.334,
              2669.24,
              13538.955
            ],
            [
              156.544,
              2647.625,
              13581.624
            ],
            [
              43.03,
              2597.236,
              13705.82
            ],
            [
              -51.133,
              2564.438,
              13805.532
            ],
            [
              -80.002,
              2538.245,
              13844.512
            ],
            [
              -91.978,
              2516.881,
              13869.004
            ],
            [
              -110.666,
              2484.254,
              13906.604
            ],
            [
              -125.342,
              2457.804,
              13936.853
            ],
            [
              111.529,
              2390.041,
              14183.226
            ],
            [
              232.331,
              2362.235,
              14307.187
            ],
            [
              296.511,
              2343.252,
              14374.115
            ],
            [
              445.925,
              2257.029,
              14546.623
            ],
            [
              471.523,
              2240.578,
              14577.052
            ],
            [
              489.286,
              2228.693,
              14598.424
            ],
            [
              521.142,
              2206.671,
              14637.151
            ],
            [
              550.785,
              2169.391,
              14684.78
            ],
            [
              572.709,
              2133.366,
              14726.952
            ],
            [
              601.666,
              2093.873,
              14775.923
            ],
            [
              681.508,
              2014.483,
              14888.518
            ],
            [
              722.942,
              1987.005,
              14938.235
            ],
            [
              765.267,
              1944.916,
              14997.925
            ],
            [
              779.403,
              1929.47,
              15018.863
            ],
            [
              795.489,
              1912.405,
              15042.314
            ],
            [
              837.497,
              1865.785,
              15105.069
            ],
            [
              846.187,
              1858.717,
              15116.27
            ],
            [
              855.386,
              1849.859,
              15129.041
            ],
            [
              865.733,
              1857.473,
              15141.888
            ],
            [
              873.237,
              1879.6,
              15165.252
            ],
            [
              883.178,
              1893.889,
              15182.659
            ],
            [
              896.673,
              1906.059,
              15200.832
            ],
            [
              910.295,
              1904.415,
              15214.553
            ],
            [
              914.607,
              1899.011,
              15221.466
            ],
            [
              917.259,
              1887.696,
              15233.087
            ],
            [
              914.949,
              1882.023,
              15239.213
            ],
            [
              888.993,
              1859.272,
              15273.728
            ],
            [
              863.527,
              1836.207,
              15308.087
            ],
            [
              825.163,
              1791.425,
              15367.055
            ],
            [
              623.161,
              1858.587,
              15579.929
            ],
            [
              598.791,
              1864.715,
              15605.057
            ],
            [
              535.995,
              1890.241,
              15672.843
            ],
            [
              493.411,
              1911.506,
              15720.442
            ],
            [
              476.616,
              1921.478,
              15739.973
            ],
            [
              453.967,
              1920.686,
              15762.637
            ],
            [
              432.764,
              1925.527,
              15784.385
            ],
            [
              422.444,
              1925.716,
              15794.707
            ],
            [
              419.803,
              1922.424,
              15798.927
            ],
            [
              402.263,
              1927.258,
              15817.122
            ],
            [
              397.27,
              1925.063,
              15822.576
            ],
            [
              384.004,
              1905.267,
              15846.406
            ],
            [
              371.312,
              1878.4,
              15876.119
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:6032",
              "position": {
                "x": 8721.736,
                "z": 661.957
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 5.856,
              "arrivalOffsetSeconds": -240,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:7356",
              "position": {
                "x": 8817.758,
                "z": 1265.655
              },
              "distanceAlongShapeM": 632.355,
              "shapeOffsetM": 3.02,
              "arrivalOffsetSeconds": 60,
              "departureOffsetSeconds": 60
            },
            {
              "stopId": "judu:stop:6029",
              "position": {
                "x": 8689.636,
                "z": 1888.337
              },
              "distanceAlongShapeM": 1271.88,
              "shapeOffsetM": 1.707,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:16179",
              "position": {
                "x": 8885.791,
                "z": 2624.726
              },
              "distanceAlongShapeM": 2069.647,
              "shapeOffsetM": 6.266,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:16175",
              "position": {
                "x": 8501.01,
                "z": 3678.953
              },
              "distanceAlongShapeM": 3271.151,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:16173",
              "position": {
                "x": 7501.876,
                "z": 3293.65
              },
              "distanceAlongShapeM": 4341.052,
              "shapeOffsetM": 9.738,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:16169",
              "position": {
                "x": 6258.117,
                "z": 3293.664
              },
              "distanceAlongShapeM": 5586.264,
              "shapeOffsetM": 6.076,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:16230",
              "position": {
                "x": 5544.977,
                "z": 3130.552
              },
              "distanceAlongShapeM": 6320.391,
              "shapeOffsetM": 3.207,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:7715",
              "position": {
                "x": 5288.781,
                "z": 3065.382
              },
              "distanceAlongShapeM": 6584.882,
              "shapeOffsetM": 0.356,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:7818",
              "position": {
                "x": 5046.033,
                "z": 3027.77
              },
              "distanceAlongShapeM": 6830.914,
              "shapeOffsetM": 0.39,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:7712",
              "position": {
                "x": 4671.063,
                "z": 2927.005
              },
              "distanceAlongShapeM": 7219.179,
              "shapeOffsetM": 1.31,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:6688",
              "position": {
                "x": 4054.293,
                "z": 2768.488
              },
              "distanceAlongShapeM": 7856.202,
              "shapeOffsetM": 6.336,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:9661",
              "position": {
                "x": 3900.799,
                "z": 3010.764
              },
              "distanceAlongShapeM": 8195.091,
              "shapeOffsetM": 5.583,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:9659",
              "position": {
                "x": 3502.858,
                "z": 3705.202
              },
              "distanceAlongShapeM": 9012.814,
              "shapeOffsetM": 3.918,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:10614",
              "position": {
                "x": 3069.21,
                "z": 4087.452
              },
              "distanceAlongShapeM": 9592.274,
              "shapeOffsetM": 4.117,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            },
            {
              "stopId": "judu:stop:5998",
              "position": {
                "x": 1684.234,
                "z": 3721.498
              },
              "distanceAlongShapeM": 11216.948,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1500,
              "departureOffsetSeconds": 1500
            },
            {
              "stopId": "judu:stop:8365",
              "position": {
                "x": 1444.986,
                "z": 2826.436
              },
              "distanceAlongShapeM": 12236.802,
              "shapeOffsetM": 3.8,
              "arrivalOffsetSeconds": 1680,
              "departureOffsetSeconds": 1680
            },
            {
              "stopId": "judu:stop:6020",
              "position": {
                "x": 965.707,
                "z": 2627.106
              },
              "distanceAlongShapeM": 12754.727,
              "shapeOffsetM": 4.8,
              "arrivalOffsetSeconds": 1740,
              "departureOffsetSeconds": 1740
            },
            {
              "stopId": "judu:stop:6018",
              "position": {
                "x": 577.598,
                "z": 2682.1
              },
              "distanceAlongShapeM": 13145.906,
              "shapeOffsetM": 4.864,
              "arrivalOffsetSeconds": 1800,
              "departureOffsetSeconds": 1800
            },
            {
              "stopId": "judu:stop:6015",
              "position": {
                "x": 159.372,
                "z": 2642.986
              },
              "distanceAlongShapeM": 13581.537,
              "shapeOffsetM": 5.432,
              "arrivalOffsetSeconds": 1860,
              "departureOffsetSeconds": 1860
            },
            {
              "stopId": "judu:stop:6013",
              "position": {
                "x": -88.167,
                "z": 2515.016
              },
              "distanceAlongShapeM": 13868.767,
              "shapeOffsetM": 4.236,
              "arrivalOffsetSeconds": 1920,
              "departureOffsetSeconds": 1920
            },
            {
              "stopId": "judu:stop:6009",
              "position": {
                "x": 475.413,
                "z": 2246.471
              },
              "distanceAlongShapeM": 14577.052,
              "shapeOffsetM": 7.061,
              "arrivalOffsetSeconds": 2040,
              "departureOffsetSeconds": 2040
            },
            {
              "stopId": "judu:stop:6006",
              "position": {
                "x": 782.59,
                "z": 1932.474
              },
              "distanceAlongShapeM": 15018.799,
              "shapeOffsetM": 4.379,
              "arrivalOffsetSeconds": 2100,
              "departureOffsetSeconds": 2100
            },
            {
              "stopId": "judu:stop:8264",
              "position": {
                "x": 493.148,
                "z": 1911.064
              },
              "distanceAlongShapeM": 15720.442,
              "shapeOffsetM": 0.515,
              "arrivalOffsetSeconds": 2340,
              "departureOffsetSeconds": 2340
            }
          ],
          "departuresSeconds": [
            21300,
            23160,
            25080,
            27420,
            29040,
            31500,
            34620,
            36840,
            40500,
            42720,
            46380,
            48660,
            52320,
            54240,
            58020,
            59700,
            61800,
            63840,
            66060,
            68280,
            70020,
            75120,
            79140,
            81180,
            84180
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_bus_59",
      "sourceRouteId": "vilnius_bus_59",
      "mode": "bus",
      "shortName": "59",
      "longName": "Grigiškės–Lazdynai–Laisvės pr.–Žvėrynas",
      "color": "0073AC",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_bus_59:0",
          "sourceRouteId": "vilnius_bus_59",
          "sourceShapeId": "vilnius_bus_59_a-b",
          "directionId": 0,
          "headsign": "Žvėrynas",
          "directionName": "Grigiškės–Lazdynai–Laisvės pr.–Žvėrynas",
          "mode": "bus",
          "routeShortName": "59",
          "routeLongName": "Grigiškės–Lazdynai–Laisvės pr.–Žvėrynas",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              -12592.773,
              1856.707,
              0
            ],
            [
              -12609.12,
              1842.488,
              21.666
            ],
            [
              -12664.399,
              1812.687,
              84.466
            ],
            [
              -12663.097,
              1814.378,
              86.6
            ],
            [
              -12644.743,
              1749.532,
              153.993
            ],
            [
              -12604.207,
              1662.909,
              249.632
            ],
            [
              -12567.595,
              1592.452,
              329.034
            ],
            [
              -12417.527,
              1642.075,
              487.093
            ],
            [
              -12254.81,
              1722.219,
              668.476
            ],
            [
              -12206.592,
              1746.184,
              722.321
            ],
            [
              -12156.838,
              1767.73,
              776.54
            ],
            [
              -12052.602,
              1832.132,
              899.066
            ],
            [
              -12150.225,
              2064.703,
              1151.295
            ],
            [
              -12150.767,
              2071.39,
              1158.004
            ],
            [
              -12148.083,
              2078.027,
              1165.163
            ],
            [
              -11899.166,
              2197.592,
              1441.307
            ],
            [
              -11701.74,
              2290.557,
              1659.526
            ],
            [
              -11377.941,
              2445.282,
              2018.393
            ],
            [
              -11340.565,
              2456.843,
              2057.517
            ],
            [
              -11266.78,
              2448.701,
              2131.75
            ],
            [
              -11227.326,
              2428.015,
              2176.297
            ],
            [
              -11208.103,
              2411.357,
              2201.733
            ],
            [
              -11191.877,
              2389.948,
              2228.597
            ],
            [
              -11131.53,
              2270.307,
              2362.596
            ],
            [
              -10763.263,
              2440.556,
              2768.312
            ],
            [
              -10394.145,
              2591.48,
              3167.093
            ],
            [
              -10234.129,
              2672.421,
              3346.415
            ],
            [
              -8792.209,
              3494.119,
              5006.03
            ],
            [
              -8701.097,
              3553.784,
              5114.94
            ],
            [
              -8570.058,
              3621.859,
              5262.606
            ],
            [
              -8433.864,
              3702.013,
              5420.636
            ],
            [
              -8208.82,
              3847.499,
              5688.612
            ],
            [
              -8066.385,
              3953.143,
              5865.949
            ],
            [
              -8052.704,
              3990.725,
              5905.943
            ],
            [
              -8073.606,
              4024.505,
              5945.667
            ],
            [
              -8101.114,
              4031.623,
              5974.081
            ],
            [
              -8136.922,
              4013.852,
              6014.056
            ],
            [
              -8147.092,
              3979.886,
              6049.512
            ],
            [
              -8141.382,
              3945.467,
              6084.401
            ],
            [
              -8140.12,
              3941.964,
              6088.124
            ],
            [
              -8107.695,
              3848.767,
              6186.801
            ],
            [
              -8064.844,
              3771.671,
              6275.005
            ],
            [
              -8003.462,
              3697.194,
              6371.517
            ],
            [
              -7956.982,
              3658.583,
              6431.942
            ],
            [
              -7913.617,
              3629.955,
              6483.905
            ],
            [
              -7552.547,
              3410.361,
              6906.508
            ],
            [
              -7508.479,
              3393.727,
              6953.611
            ],
            [
              -7243.876,
              3227.143,
              7266.284
            ],
            [
              -6939.838,
              3038.415,
              7624.135
            ],
            [
              -6822.27,
              2929.59,
              7784.339
            ],
            [
              -6681.993,
              2680.689,
              8070.047
            ],
            [
              -6663.874,
              2638.63,
              8115.843
            ],
            [
              -6617.715,
              2546.549,
              8218.845
            ],
            [
              -6572.047,
              2457.871,
              8318.592
            ],
            [
              -6515.563,
              2367.209,
              8425.41
            ],
            [
              -6469.844,
              2319.237,
              8491.679
            ],
            [
              -6422.765,
              2279.486,
              8553.295
            ],
            [
              -6337.172,
              2227.956,
              8653.203
            ],
            [
              -6224.894,
              2193.526,
              8770.641
            ],
            [
              -6125.197,
              2172.072,
              8872.62
            ],
            [
              -5648.753,
              2074.968,
              9358.859
            ],
            [
              -5407.978,
              2044.165,
              9601.596
            ],
            [
              -5248.741,
              2037.003,
              9760.994
            ],
            [
              -5237.188,
              2033.466,
              9773.077
            ],
            [
              -5229.201,
              2009.953,
              9797.909
            ],
            [
              -5217.875,
              1993.062,
              9818.246
            ],
            [
              -5096.905,
              1898.604,
              9971.726
            ],
            [
              -5077.101,
              1887.134,
              9994.611
            ],
            [
              -5062.888,
              1880.497,
              10010.297
            ],
            [
              -5063.879,
              1867.984,
              10022.85
            ],
            [
              -4984.799,
              1776.464,
              10143.802
            ],
            [
              -4951.187,
              1742.493,
              10191.591
            ],
            [
              -4931.684,
              1728.355,
              10215.68
            ],
            [
              -4906.917,
              1690.529,
              10260.893
            ],
            [
              -4767.773,
              1565.694,
              10447.828
            ],
            [
              -4741.69,
              1550.026,
              10478.255
            ],
            [
              -4712.351,
              1524.668,
              10517.034
            ],
            [
              -4596.2,
              1451.429,
              10654.348
            ],
            [
              -4491.296,
              1399.532,
              10771.387
            ],
            [
              -4467.288,
              1389.272,
              10797.495
            ],
            [
              -4443.995,
              1374.227,
              10825.224
            ],
            [
              -4243.678,
              1281.718,
              11045.871
            ],
            [
              -4199.211,
              1271.037,
              11091.603
            ],
            [
              -4179.458,
              1265.024,
              11112.25
            ],
            [
              -4137.877,
              1254.669,
              11155.101
            ],
            [
              -4093.256,
              1251.097,
              11199.865
            ],
            [
              -4041.607,
              1253.735,
              11251.581
            ],
            [
              -3953.633,
              1267.797,
              11340.672
            ],
            [
              -3919.363,
              1123.6,
              11488.886
            ],
            [
              -3889.289,
              1035.135,
              11582.323
            ],
            [
              -3881.018,
              1009.279,
              11609.469
            ],
            [
              -3879.245,
              944.791,
              11673.982
            ],
            [
              -3881.411,
              931.47,
              11687.478
            ],
            [
              -3898.384,
              892.134,
              11730.319
            ],
            [
              -3911.432,
              874.104,
              11752.575
            ],
            [
              -3948.102,
              842.457,
              11801.013
            ],
            [
              -4089.107,
              782.559,
              11954.213
            ],
            [
              -4161.662,
              727.04,
              12045.573
            ],
            [
              -4178.229,
              714.534,
              12066.33
            ],
            [
              -4216.46,
              691.251,
              12111.093
            ],
            [
              -4255.439,
              676.425,
              12152.796
            ],
            [
              -4279.313,
              674.524,
              12176.746
            ],
            [
              -4304.422,
              677.184,
              12201.995
            ],
            [
              -4330.724,
              685.43,
              12229.56
            ],
            [
              -4370.887,
              712.839,
              12278.184
            ],
            [
              -4391.801,
              734.351,
              12308.186
            ],
            [
              -4418.25,
              771.542,
              12353.823
            ],
            [
              -4423.862,
              782.771,
              12366.377
            ],
            [
              -4434.781,
              784.705,
              12377.465
            ],
            [
              -4479.393,
              779.274,
              12422.407
            ],
            [
              -4503.366,
              773.007,
              12447.186
            ],
            [
              -4524.836,
              762.245,
              12471.202
            ],
            [
              -4546.478,
              741.466,
              12501.204
            ],
            [
              -4558.582,
              712.731,
              12532.385
            ],
            [
              -4564.028,
              688.195,
              12557.518
            ],
            [
              -4562.176,
              653.793,
              12591.97
            ],
            [
              -4542.083,
              471.996,
              12774.874
            ],
            [
              -4535.565,
              436.694,
              12810.772
            ],
            [
              -4533.311,
              419.524,
              12828.09
            ],
            [
              -4527.744,
              368.221,
              12879.694
            ],
            [
              -4516.259,
              323.495,
              12925.871
            ],
            [
              -4491.638,
              255.166,
              12998.5
            ],
            [
              -4427.619,
              152.763,
              13119.268
            ],
            [
              -4367.011,
              77.134,
              13216.186
            ],
            [
              -4080.333,
              -210.913,
              13622.579
            ],
            [
              -3954.469,
              -380.846,
              13834.047
            ],
            [
              -3926.158,
              -422.036,
              13884.029
            ],
            [
              -3919.036,
              -433.74,
              13897.73
            ],
            [
              -3857.936,
              -540.596,
              14020.82
            ],
            [
              -3823.641,
              -607.984,
              14096.433
            ],
            [
              -3766.483,
              -732.543,
              14233.48
            ],
            [
              -3707.64,
              -908.34,
              14418.864
            ],
            [
              -3695.741,
              -928.584,
              14442.346
            ],
            [
              -3679.687,
              -950.175,
              14469.252
            ],
            [
              -3668.232,
              -978.044,
              14499.383
            ],
            [
              -3606.925,
              -1085.98,
              14623.515
            ],
            [
              -3586.062,
              -1109.72,
              14655.12
            ],
            [
              -3575.241,
              -1117.701,
              14668.565
            ],
            [
              -3510.801,
              -1144.012,
              14738.17
            ],
            [
              -3355.367,
              -1190.556,
              14900.423
            ],
            [
              -3109.19,
              -1234.288,
              15150.454
            ],
            [
              -3070.013,
              -1242.306,
              15190.443
            ],
            [
              -2879.155,
              -1277.94,
              15384.599
            ],
            [
              -2839.273,
              -1283.094,
              15424.813
            ],
            [
              -2787.087,
              -1285.125,
              15477.038
            ],
            [
              -2748.376,
              -1283.58,
              15515.78
            ],
            [
              -2714.118,
              -1278.617,
              15550.396
            ],
            [
              -2670.7,
              -1266.023,
              15595.603
            ],
            [
              -2624.585,
              -1246.798,
              15645.565
            ],
            [
              -2499.949,
              -1183.085,
              15785.542
            ],
            [
              -2469.831,
              -1172.717,
              15817.395
            ],
            [
              -2418.716,
              -1162.489,
              15869.523
            ],
            [
              -2392.231,
              -1159.617,
              15896.163
            ],
            [
              -2246.137,
              -1174.448,
              16043.008
            ],
            [
              -2229.866,
              -1165.831,
              16061.42
            ],
            [
              -2190.996,
              -1155.388,
              16101.668
            ],
            [
              -2164.136,
              -1131.373,
              16137.699
            ],
            [
              -2142.708,
              -1122.847,
              16160.761
            ],
            [
              -2138.761,
              -1118.464,
              16166.659
            ],
            [
              -2144.773,
              -1093.867,
              16191.98
            ],
            [
              -2147.916,
              -1089.358,
              16197.476
            ],
            [
              -2139.925,
              -1075.028,
              16213.884
            ],
            [
              -2130.743,
              -1067.44,
              16225.796
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:9614",
              "position": {
                "x": -12592.773,
                "z": 1856.707
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": -540,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:15964",
              "position": {
                "x": -12209.896,
                "z": 1752.832
              },
              "distanceAlongShapeM": 722.321,
              "shapeOffsetM": 7.424,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:16236",
              "position": {
                "x": -12092.77,
                "z": 1942.477
              },
              "distanceAlongShapeM": 1016.358,
              "shapeOffsetM": 5.671,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:8945",
              "position": {
                "x": -11899.757,
                "z": 2198.842
              },
              "distanceAlongShapeM": 1441.307,
              "shapeOffsetM": 1.382,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:6604",
              "position": {
                "x": -11702.181,
                "z": 2291.494
              },
              "distanceAlongShapeM": 1659.532,
              "shapeOffsetM": 1.035,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:4454",
              "position": {
                "x": -11189.627,
                "z": 2391.441
              },
              "distanceAlongShapeM": 2228.597,
              "shapeOffsetM": 2.7,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:6295",
              "position": {
                "x": -8134.965,
                "z": 3943.136
              },
              "distanceAlongShapeM": 6088.711,
              "shapeOffsetM": 5.254,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:6609",
              "position": {
                "x": -7508.286,
                "z": 3394.045
              },
              "distanceAlongShapeM": 6953.611,
              "shapeOffsetM": 0.372,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:6310",
              "position": {
                "x": -6676.677,
                "z": 2683.371
              },
              "distanceAlongShapeM": 8070.047,
              "shapeOffsetM": 5.954,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:437",
              "position": {
                "x": -4928.804,
                "z": 1730.978
              },
              "distanceAlongShapeM": 10215.68,
              "shapeOffsetM": 3.896,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:783",
              "position": {
                "x": -4739.606,
                "z": 1552.966
              },
              "distanceAlongShapeM": 10478.255,
              "shapeOffsetM": 3.604,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:3589",
              "position": {
                "x": -4466.279,
                "z": 1391.309
              },
              "distanceAlongShapeM": 10797.495,
              "shapeOffsetM": 2.273,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            },
            {
              "stopId": "judu:stop:6317",
              "position": {
                "x": -4197.987,
                "z": 1275.363
              },
              "distanceAlongShapeM": 11091.603,
              "shapeOffsetM": 4.495,
              "arrivalOffsetSeconds": 1380,
              "departureOffsetSeconds": 1380
            },
            {
              "stopId": "judu:stop:5701",
              "position": {
                "x": -3876.172,
                "z": 1010.417
              },
              "distanceAlongShapeM": 11609.469,
              "shapeOffsetM": 4.978,
              "arrivalOffsetSeconds": 1500,
              "departureOffsetSeconds": 1500
            },
            {
              "stopId": "judu:stop:5704",
              "position": {
                "x": -4175.491,
                "z": 710.581
              },
              "distanceAlongShapeM": 12066.33,
              "shapeOffsetM": 4.809,
              "arrivalOffsetSeconds": 1560,
              "departureOffsetSeconds": 1560
            },
            {
              "stopId": "judu:stop:1071",
              "position": {
                "x": -4530.426,
                "z": 437.286
              },
              "distanceAlongShapeM": 12810.854,
              "shapeOffsetM": 5.172,
              "arrivalOffsetSeconds": 1680,
              "departureOffsetSeconds": 1680
            },
            {
              "stopId": "judu:stop:1004",
              "position": {
                "x": -4077.229,
                "z": -208.399
              },
              "distanceAlongShapeM": 13622.579,
              "shapeOffsetM": 3.995,
              "arrivalOffsetSeconds": 1800,
              "departureOffsetSeconds": 1800
            },
            {
              "stopId": "judu:stop:6649",
              "position": {
                "x": -3921.604,
                "z": -419.265
              },
              "distanceAlongShapeM": 13884.029,
              "shapeOffsetM": 5.33,
              "arrivalOffsetSeconds": 1860,
              "departureOffsetSeconds": 1860
            },
            {
              "stopId": "judu:stop:6643",
              "position": {
                "x": -3679.35,
                "z": -950.021
              },
              "distanceAlongShapeM": 14469.252,
              "shapeOffsetM": 0.37,
              "arrivalOffsetSeconds": 1920,
              "departureOffsetSeconds": 1920
            },
            {
              "stopId": "judu:stop:7416",
              "position": {
                "x": -3108.49,
                "z": -1230.499
              },
              "distanceAlongShapeM": 15150.454,
              "shapeOffsetM": 3.854,
              "arrivalOffsetSeconds": 2040,
              "departureOffsetSeconds": 2040
            },
            {
              "stopId": "judu:stop:18480",
              "position": {
                "x": -2130.763,
                "z": -1067.398
              },
              "distanceAlongShapeM": 16225.796,
              "shapeOffsetM": 0.046,
              "arrivalOffsetSeconds": 2220,
              "departureOffsetSeconds": 2220
            }
          ],
          "departuresSeconds": [
            19620,
            22500,
            24540,
            26340,
            28320,
            30600,
            33000,
            36120,
            38580,
            41400,
            44100,
            46860,
            49380,
            52320,
            54780,
            57780,
            60540,
            62220,
            63840,
            66360,
            68880,
            71700,
            74460,
            77100,
            79800,
            82440
          ]
        },
        {
          "id": "judu:pattern:vilnius_bus_59:1",
          "sourceRouteId": "vilnius_bus_59",
          "sourceShapeId": "vilnius_bus_59_b-a",
          "directionId": 1,
          "headsign": "Grigiškės",
          "directionName": "Žvėrynas–Laisvės pr.–Lazdynai–Grigiškės",
          "mode": "bus",
          "routeShortName": "59",
          "routeLongName": "Grigiškės–Lazdynai–Laisvės pr.–Žvėrynas",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              -2130.743,
              -1067.44,
              0
            ],
            [
              -2108.809,
              -1065.561,
              22.014
            ],
            [
              -2072.667,
              -1084.451,
              62.795
            ],
            [
              -2070.025,
              -1103.286,
              81.814
            ],
            [
              -2072.195,
              -1109.627,
              88.516
            ],
            [
              -2142.708,
              -1122.847,
              160.258
            ],
            [
              -2159.624,
              -1131.453,
              179.237
            ],
            [
              -2184.705,
              -1155.271,
              213.825
            ],
            [
              -2202.716,
              -1161.859,
              233.003
            ],
            [
              -2224.67,
              -1163.697,
              255.034
            ],
            [
              -2246.137,
              -1174.448,
              279.043
            ],
            [
              -2255.963,
              -1183.18,
              292.188
            ],
            [
              -2262.447,
              -1185.292,
              299.007
            ],
            [
              -2339.674,
              -1177.245,
              376.653
            ],
            [
              -2392.506,
              -1175.197,
              429.524
            ],
            [
              -2433.855,
              -1180.032,
              471.155
            ],
            [
              -2474.658,
              -1190.444,
              513.266
            ],
            [
              -2521.496,
              -1214.107,
              565.742
            ],
            [
              -2594.45,
              -1256.235,
              649.986
            ],
            [
              -2624.997,
              -1270.168,
              683.56
            ],
            [
              -2680.78,
              -1289.223,
              742.508
            ],
            [
              -2710.565,
              -1296.491,
              773.167
            ],
            [
              -2777.752,
              -1304.214,
              840.796
            ],
            [
              -2815.153,
              -1304.669,
              878.2
            ],
            [
              -2855.028,
              -1301.32,
              918.216
            ],
            [
              -3099.309,
              -1258.49,
              1166.223
            ],
            [
              -3139.719,
              -1251.188,
              1207.287
            ],
            [
              -3159.719,
              -1247.413,
              1227.64
            ],
            [
              -3359.526,
              -1207.182,
              1431.457
            ],
            [
              -3495.953,
              -1192.555,
              1568.666
            ],
            [
              -3569.469,
              -1193.5,
              1642.188
            ],
            [
              -3626.266,
              -1196.964,
              1699.091
            ],
            [
              -3657.704,
              -1114.039,
              1787.775
            ],
            [
              -3677.364,
              -1066.903,
              1838.847
            ],
            [
              -3685.368,
              -1042.059,
              1864.949
            ],
            [
              -3720.918,
              -930.373,
              1982.156
            ],
            [
              -3751.424,
              -837.404,
              2080.002
            ],
            [
              -3758.325,
              -817.25,
              2101.304
            ],
            [
              -3766.218,
              -791.548,
              2128.191
            ],
            [
              -3793.988,
              -719.82,
              2205.107
            ],
            [
              -3843.779,
              -616.54,
              2319.763
            ],
            [
              -3881.258,
              -546.871,
              2398.873
            ],
            [
              -3968.352,
              -399.129,
              2570.375
            ],
            [
              -3983.006,
              -376.666,
              2597.195
            ],
            [
              -3999.719,
              -350.005,
              2628.662
            ],
            [
              -4048.201,
              -282.373,
              2711.876
            ],
            [
              -4133.499,
              -180.709,
              2844.584
            ],
            [
              -4196.231,
              -117.271,
              2933.8
            ],
            [
              -4217.103,
              -95.271,
              2964.126
            ],
            [
              -4243.751,
              -67.483,
              3002.627
            ],
            [
              -4402.336,
              85.535,
              3222.999
            ],
            [
              -4449.086,
              142,
              3296.305
            ],
            [
              -4479.797,
              193.736,
              3356.47
            ],
            [
              -4502.905,
              237.549,
              3406.003
            ],
            [
              -4519.036,
              274.562,
              3446.379
            ],
            [
              -4536.228,
              324.952,
              3499.621
            ],
            [
              -4547.048,
              370.78,
              3546.709
            ],
            [
              -4566.578,
              510.266,
              3687.555
            ],
            [
              -4570.606,
              537.669,
              3715.253
            ],
            [
              -4575.517,
              590.57,
              3768.381
            ],
            [
              -4579.623,
              651.866,
              3829.815
            ],
            [
              -4586.366,
              709.869,
              3888.208
            ],
            [
              -4584.541,
              741.007,
              3919.4
            ],
            [
              -4573.306,
              794.248,
              3973.813
            ],
            [
              -4555.909,
              830.684,
              4014.189
            ],
            [
              -4554.237,
              852.919,
              4036.487
            ],
            [
              -4568.699,
              912.168,
              4097.476
            ],
            [
              -4567.748,
              929.963,
              4115.296
            ],
            [
              -4555.854,
              946.456,
              4135.63
            ],
            [
              -4510.16,
              977.953,
              4191.128
            ],
            [
              -4440.575,
              860.983,
              4327.231
            ],
            [
              -4425.036,
              789.47,
              4400.413
            ],
            [
              -4406.248,
              756.864,
              4438.045
            ],
            [
              -4380.992,
              725.259,
              4478.501
            ],
            [
              -4355.565,
              703.67,
              4511.857
            ],
            [
              -4324.219,
              688.657,
              4546.613
            ],
            [
              -4302.372,
              683.828,
              4568.987
            ],
            [
              -4269.507,
              682.148,
              4601.895
            ],
            [
              -4233.908,
              689.326,
              4638.211
            ],
            [
              -4200.071,
              706.552,
              4676.18
            ],
            [
              -4154.906,
              744.734,
              4735.322
            ],
            [
              -4131.603,
              764.725,
              4766.025
            ],
            [
              -4089.107,
              782.559,
              4812.111
            ],
            [
              -4026.001,
              813.75,
              4882.505
            ],
            [
              -3968.169,
              838.352,
              4945.352
            ],
            [
              -3939.526,
              853.44,
              4977.726
            ],
            [
              -3921.201,
              868.708,
              5001.578
            ],
            [
              -3904.031,
              891.787,
              5030.343
            ],
            [
              -3887.976,
              924.905,
              5067.148
            ],
            [
              -3883.393,
              966.014,
              5108.512
            ],
            [
              -3887.876,
              1005.054,
              5147.808
            ],
            [
              -3903.754,
              1056.537,
              5201.684
            ],
            [
              -3912.994,
              1078.798,
              5225.786
            ],
            [
              -3919.363,
              1123.6,
              5271.039
            ],
            [
              -3949.447,
              1248.8,
              5399.803
            ],
            [
              -3955.799,
              1254.476,
              5408.321
            ],
            [
              -3966.06,
              1257.993,
              5419.168
            ],
            [
              -4052.898,
              1235.006,
              5508.997
            ],
            [
              -4088.424,
              1232.281,
              5544.627
            ],
            [
              -4119.34,
              1235.042,
              5575.666
            ],
            [
              -4212.237,
              1261.595,
              5672.284
            ],
            [
              -4241.916,
              1271.669,
              5703.626
            ],
            [
              -4268.203,
              1281.028,
              5731.529
            ],
            [
              -4527.979,
              1404.616,
              6019.205
            ],
            [
              -4557.013,
              1417.363,
              6050.914
            ],
            [
              -4581.673,
              1433.369,
              6080.313
            ],
            [
              -4718.251,
              1519.203,
              6241.624
            ],
            [
              -4836.63,
              1608.523,
              6389.919
            ],
            [
              -4906.917,
              1690.529,
              6497.925
            ],
            [
              -4961.39,
              1738.988,
              6570.834
            ],
            [
              -5068.788,
              1878.386,
              6746.805
            ],
            [
              -5048.449,
              1896.102,
              6773.779
            ],
            [
              -4996.021,
              1950.314,
              6849.195
            ],
            [
              -4992.511,
              1966.952,
              6866.199
            ],
            [
              -4995.545,
              1978.136,
              6877.787
            ],
            [
              -5002.796,
              1985.46,
              6888.094
            ],
            [
              -5010.228,
              1987.292,
              6895.748
            ],
            [
              -5028.5,
              1986.124,
              6914.057
            ],
            [
              -5177.583,
              1934.489,
              7071.829
            ],
            [
              -5251.262,
              1926.839,
              7145.904
            ],
            [
              -5286.129,
              1925.207,
              7180.809
            ],
            [
              -5329.267,
              1930.394,
              7224.258
            ],
            [
              -5390.957,
              1944.801,
              7287.608
            ],
            [
              -5430.093,
              1957.712,
              7328.818
            ],
            [
              -5538.852,
              2011.879,
              7450.32
            ],
            [
              -5604.833,
              2039.715,
              7521.932
            ],
            [
              -5664.553,
              2056.312,
              7583.916
            ],
            [
              -6261.201,
              2179.926,
              8193.234
            ],
            [
              -6367.656,
              2218.449,
              8306.445
            ],
            [
              -6455.072,
              2276.688,
              8411.485
            ],
            [
              -6521.774,
              2339.031,
              8502.785
            ],
            [
              -6563.365,
              2394.508,
              8572.122
            ],
            [
              -6591.947,
              2443.085,
              8628.484
            ],
            [
              -6687.246,
              2630.115,
              8838.393
            ],
            [
              -6717.477,
              2680.464,
              8897.121
            ],
            [
              -6732.812,
              2722.158,
              8941.546
            ],
            [
              -6787.208,
              2826.592,
              9059.297
            ],
            [
              -6821.115,
              2882.817,
              9124.955
            ],
            [
              -6849.514,
              2921.139,
              9172.652
            ],
            [
              -6915.475,
              2990.142,
              9268.111
            ],
            [
              -6953.037,
              3020.824,
              9316.611
            ],
            [
              -7039.186,
              3079.03,
              9420.58
            ],
            [
              -7610.996,
              3413.943,
              10083.251
            ],
            [
              -7653.308,
              3444.307,
              10135.331
            ],
            [
              -7928.052,
              3612.467,
              10457.452
            ],
            [
              -8049.841,
              3662.009,
              10588.933
            ],
            [
              -8132.216,
              3682.666,
              10673.858
            ],
            [
              -8226.83,
              3693.337,
              10769.071
            ],
            [
              -8295.18,
              3691.304,
              10837.452
            ],
            [
              -8418.27,
              3666.017,
              10963.113
            ],
            [
              -8511.565,
              3629.218,
              11063.403
            ],
            [
              -8673.968,
              3542.289,
              11247.608
            ],
            [
              -10220.742,
              2662.19,
              13027.238
            ],
            [
              -10349.565,
              2595.224,
              13172.427
            ],
            [
              -10561.984,
              2505.092,
              13403.177
            ],
            [
              -10574.221,
              2459.107,
              13450.762
            ],
            [
              -10587.068,
              2428.682,
              13483.788
            ],
            [
              -10687.101,
              2384.205,
              13593.264
            ],
            [
              -10763.768,
              2356.721,
              13674.708
            ],
            [
              -10781.724,
              2355.749,
              13692.691
            ],
            [
              -10804.219,
              2359.617,
              13715.516
            ],
            [
              -10821.776,
              2366.457,
              13734.357
            ],
            [
              -10871.238,
              2410.915,
              13800.863
            ],
            [
              -10882.01,
              2423.329,
              13817.299
            ],
            [
              -10933.179,
              2410.779,
              13869.985
            ],
            [
              -11014.265,
              2383.116,
              13955.66
            ],
            [
              -11042.752,
              2376.885,
              13984.82
            ],
            [
              -11076.277,
              2378.406,
              14018.38
            ],
            [
              -11111.6,
              2375.848,
              14053.795
            ],
            [
              -11167.733,
              2347.684,
              14116.598
            ],
            [
              -11175.682,
              2356.108,
              14128.18
            ],
            [
              -11188.898,
              2381.881,
              14157.144
            ],
            [
              -11209.837,
              2410.442,
              14192.558
            ],
            [
              -11223.935,
              2425.375,
              14213.094
            ],
            [
              -11236.068,
              2433.358,
              14227.618
            ],
            [
              -11281.586,
              2451.884,
              14276.762
            ],
            [
              -11308.608,
              2456.76,
              14304.22
            ],
            [
              -11333.037,
              2457.586,
              14328.663
            ],
            [
              -11358.106,
              2453.226,
              14354.108
            ],
            [
              -11401.258,
              2432.42,
              14402.014
            ],
            [
              -11422.36,
              2422.676,
              14425.257
            ],
            [
              -11657.133,
              2308.505,
              14686.32
            ],
            [
              -11912.888,
              2185.736,
              14970.014
            ],
            [
              -11986.897,
              2154.558,
              15050.323
            ],
            [
              -12000.581,
              2145.866,
              15066.534
            ],
            [
              -12140.971,
              2079.03,
              15222.022
            ],
            [
              -12149.434,
              2068.558,
              15235.485
            ],
            [
              -12133.47,
              2034.328,
              15273.255
            ],
            [
              -12034.298,
              1818.238,
              15511.016
            ],
            [
              -12277.032,
              1708.233,
              15777.513
            ],
            [
              -12423.127,
              1639.755,
              15938.86
            ],
            [
              -12458.258,
              1627.549,
              15976.052
            ],
            [
              -12567.481,
              1592.439,
              16090.779
            ],
            [
              -12596.82,
              1650.319,
              16155.671
            ],
            [
              -12647.185,
              1758.475,
              16274.978
            ],
            [
              -12661.996,
              1802.116,
              16321.064
            ],
            [
              -12664.589,
              1812.84,
              16332.097
            ],
            [
              -12603.058,
              1859.092,
              16409.073
            ],
            [
              -12599.171,
              1860.145,
              16413.1
            ],
            [
              -12592.773,
              1856.707,
              16420.364
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:4898",
              "position": {
                "x": -2071.721,
                "z": -1082.918
              },
              "distanceAlongShapeM": 62.795,
              "shapeOffsetM": 1.801,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:7415",
              "position": {
                "x": -3140.52,
                "z": -1255.542
              },
              "distanceAlongShapeM": 1207.287,
              "shapeOffsetM": 4.427,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:5643",
              "position": {
                "x": -3680.758,
                "z": -1067.996
              },
              "distanceAlongShapeM": 1838.847,
              "shapeOffsetM": 3.566,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:5646",
              "position": {
                "x": -3761.526,
                "z": -818.346
              },
              "distanceAlongShapeM": 2101.304,
              "shapeOffsetM": 3.383,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:5651",
              "position": {
                "x": -3986.683,
                "z": -379.175
              },
              "distanceAlongShapeM": 2597.103,
              "shapeOffsetM": 4.451,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:5656",
              "position": {
                "x": -4221.08,
                "z": -99.045
              },
              "distanceAlongShapeM": 2964.155,
              "shapeOffsetM": 5.483,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:5668",
              "position": {
                "x": -4574.501,
                "z": 537.119
              },
              "distanceAlongShapeM": 3715.253,
              "shapeOffsetM": 3.934,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:5703",
              "position": {
                "x": -4134.494,
                "z": 768.872
              },
              "distanceAlongShapeM": 4766.025,
              "shapeOffsetM": 5.055,
              "arrivalOffsetSeconds": 690,
              "departureOffsetSeconds": 690
            },
            {
              "stopId": "judu:stop:5702",
              "position": {
                "x": -3916.285,
                "z": 1077.905
              },
              "distanceAlongShapeM": 5225.786,
              "shapeOffsetM": 3.41,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:6318",
              "position": {
                "x": -4215.081,
                "z": 1256.734
              },
              "distanceAlongShapeM": 5673.414,
              "shapeOffsetM": 5.517,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:6319",
              "position": {
                "x": -4558.781,
                "z": 1414.051
              },
              "distanceAlongShapeM": 6050.914,
              "shapeOffsetM": 3.754,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:6320",
              "position": {
                "x": -4838.028,
                "z": 1606.973
              },
              "distanceAlongShapeM": 6389.919,
              "shapeOffsetM": 2.088,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            },
            {
              "stopId": "judu:stop:6309",
              "position": {
                "x": -6721.281,
                "z": 2678.551
              },
              "distanceAlongShapeM": 8897.121,
              "shapeOffsetM": 4.258,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:6297",
              "position": {
                "x": -7611.222,
                "z": 3413.556
              },
              "distanceAlongShapeM": 10083.251,
              "shapeOffsetM": 0.448,
              "arrivalOffsetSeconds": 1380,
              "departureOffsetSeconds": 1380
            },
            {
              "stopId": "judu:stop:9109",
              "position": {
                "x": -10685.89,
                "z": 2381.268
              },
              "distanceAlongShapeM": 13593.264,
              "shapeOffsetM": 3.177,
              "arrivalOffsetSeconds": 1620,
              "departureOffsetSeconds": 1620
            },
            {
              "stopId": "judu:stop:9834",
              "position": {
                "x": -11398.758,
                "z": 2427.006
              },
              "distanceAlongShapeM": 14402.014,
              "shapeOffsetM": 5.963,
              "arrivalOffsetSeconds": 1740,
              "departureOffsetSeconds": 1740
            },
            {
              "stopId": "judu:stop:8944",
              "position": {
                "x": -11656.141,
                "z": 2306.359
              },
              "distanceAlongShapeM": 14686.354,
              "shapeOffsetM": 2.364,
              "arrivalOffsetSeconds": 1800,
              "departureOffsetSeconds": 1800
            },
            {
              "stopId": "judu:stop:6603",
              "position": {
                "x": -11912.865,
                "z": 2185.688
              },
              "distanceAlongShapeM": 14970.014,
              "shapeOffsetM": 0.053,
              "arrivalOffsetSeconds": 1860,
              "departureOffsetSeconds": 1860
            },
            {
              "stopId": "judu:stop:9082",
              "position": {
                "x": -12128.727,
                "z": 2036.54
              },
              "distanceAlongShapeM": 15273.255,
              "shapeOffsetM": 5.234,
              "arrivalOffsetSeconds": 1920,
              "departureOffsetSeconds": 1920
            },
            {
              "stopId": "judu:stop:9614",
              "position": {
                "x": -12592.773,
                "z": 1856.707
              },
              "distanceAlongShapeM": 16420.364,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2100,
              "departureOffsetSeconds": 2100
            }
          ],
          "departuresSeconds": [
            19740,
            22080,
            23400,
            25380,
            27600,
            29880,
            33480,
            35700,
            38820,
            41340,
            44160,
            46800,
            49680,
            52200,
            55080,
            57720,
            59340,
            61080,
            63540,
            65940,
            69000,
            71640,
            74400,
            77100,
            79680,
            82560
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_bus_61",
      "sourceRouteId": "vilnius_bus_61",
      "mode": "bus",
      "shortName": "61",
      "longName": "Stotis–Nemėžis–Kuprioniškės",
      "color": "0073AC",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_bus_61:0",
          "sourceRouteId": "vilnius_bus_61",
          "sourceShapeId": "vilnius_bus_61_a-b",
          "directionId": 0,
          "headsign": "Kuprioniškės",
          "directionName": "Stotis–Nemėžis–Kuprioniškės",
          "mode": "bus",
          "routeShortName": "61",
          "routeLongName": "Stotis–Nemėžis–Kuprioniškės",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              448.24,
              1918.913,
              0
            ],
            [
              414.243,
              1935.885,
              37.998
            ],
            [
              388.144,
              1955.287,
              70.519
            ],
            [
              374.884,
              1971.114,
              91.166
            ],
            [
              370.552,
              1981.213,
              102.155
            ],
            [
              369.405,
              1989.026,
              110.052
            ],
            [
              372.127,
              1996.769,
              118.26
            ],
            [
              376.723,
              2001.138,
              124.601
            ],
            [
              383.214,
              2003.246,
              131.425
            ],
            [
              391.578,
              2001.98,
              139.885
            ],
            [
              462.481,
              1962.833,
              220.877
            ],
            [
              478.32,
              1946.958,
              243.302
            ],
            [
              475.394,
              1928.087,
              262.399
            ],
            [
              494.54,
              1916.604,
              284.724
            ],
            [
              623.161,
              1858.587,
              425.825
            ],
            [
              825.163,
              1791.425,
              638.699
            ],
            [
              863.527,
              1836.207,
              697.667
            ],
            [
              869.06,
              1862.978,
              725.004
            ],
            [
              873.401,
              1888.503,
              750.895
            ],
            [
              890.379,
              1910.039,
              778.319
            ],
            [
              909.687,
              1916.752,
              798.76
            ],
            [
              941.154,
              1923.993,
              831.05
            ],
            [
              953.593,
              1933.783,
              846.879
            ],
            [
              1083.618,
              2057.184,
              1026.14
            ],
            [
              1196.071,
              2172,
              1186.852
            ],
            [
              1233.034,
              2216.96,
              1245.056
            ],
            [
              1262.402,
              2269.853,
              1305.555
            ],
            [
              1275.582,
              2294.627,
              1333.617
            ],
            [
              1295.641,
              2322.675,
              1368.099
            ],
            [
              1353.693,
              2426.246,
              1486.83
            ],
            [
              1363.843,
              2451.663,
              1514.199
            ],
            [
              1395.21,
              2612.502,
              1678.068
            ],
            [
              1412.03,
              2684.551,
              1752.054
            ],
            [
              1428.563,
              2741.021,
              1810.894
            ],
            [
              1438.754,
              2768.663,
              1840.355
            ],
            [
              1469.827,
              2811.004,
              1892.875
            ],
            [
              1513.094,
              2845.213,
              1948.032
            ],
            [
              1568.191,
              2893.175,
              2021.08
            ],
            [
              1626.949,
              2964.446,
              2113.449
            ],
            [
              1670.787,
              3031.54,
              2193.595
            ],
            [
              1688.949,
              3071.28,
              2237.288
            ],
            [
              1699.324,
              3143.448,
              2310.198
            ],
            [
              1699.269,
              3383.908,
              2550.658
            ],
            [
              1698.702,
              3422.882,
              2589.637
            ],
            [
              1683.625,
              3554.597,
              2722.212
            ],
            [
              1679.171,
              3622.514,
              2790.275
            ],
            [
              1674.798,
              3769.542,
              2937.368
            ],
            [
              1682.198,
              3784.941,
              2954.452
            ],
            [
              1743.856,
              3803.884,
              3018.955
            ],
            [
              1811.196,
              3832.214,
              3092.011
            ],
            [
              1875.636,
              3868.945,
              3166.184
            ],
            [
              2082.225,
              4019.124,
              3421.592
            ],
            [
              2137.697,
              4051.487,
              3485.814
            ],
            [
              2651.026,
              4265.645,
              4042.025
            ],
            [
              2753.781,
              4306.019,
              4152.427
            ],
            [
              2885.931,
              4363.573,
              4296.566
            ],
            [
              3782.546,
              4734.102,
              5266.726
            ],
            [
              4007.399,
              4827.702,
              5510.283
            ],
            [
              3993.542,
              4822.162,
              5525.206
            ],
            [
              4523.651,
              5031.081,
              6094.998
            ],
            [
              4822.139,
              5143.936,
              6414.108
            ],
            [
              5115.095,
              5262.364,
              6730.096
            ],
            [
              5119.749,
              5308.53,
              6776.496
            ],
            [
              5126.535,
              5402.566,
              6870.777
            ],
            [
              5141.259,
              5519.633,
              6988.766
            ],
            [
              5112.186,
              5619.275,
              7092.563
            ],
            [
              5010.774,
              5903.475,
              7394.314
            ],
            [
              4984.974,
              5987.989,
              7482.679
            ],
            [
              4835.208,
              5924.077,
              7645.512
            ],
            [
              4785.365,
              5925.316,
              7695.371
            ],
            [
              4775.881,
              5928.557,
              7705.393
            ],
            [
              4348.009,
              6022.832,
              8143.528
            ],
            [
              3271.842,
              6271.154,
              9247.973
            ],
            [
              3238.8,
              6197.19,
              9328.982
            ],
            [
              3230.397,
              6166.313,
              9360.983
            ],
            [
              3230.651,
              5875.295,
              9652
            ],
            [
              3230.59,
              5829.589,
              9697.707
            ],
            [
              3234.062,
              5809.945,
              9717.655
            ],
            [
              3257.97,
              5739.717,
              9791.841
            ],
            [
              3262.66,
              5684.395,
              9847.361
            ],
            [
              3270.791,
              5654.277,
              9878.558
            ],
            [
              3296.501,
              5608.396,
              9931.151
            ],
            [
              3305.823,
              5583.627,
              9957.616
            ],
            [
              3302.589,
              5521.006,
              10020.32
            ],
            [
              3310.227,
              5500.063,
              10042.612
            ],
            [
              3320.257,
              5473.55,
              10070.959
            ],
            [
              3328.035,
              5417.346,
              10127.699
            ],
            [
              3337.973,
              5364.808,
              10181.169
            ],
            [
              3348.719,
              5350.161,
              10199.335
            ],
            [
              3397.957,
              5324.738,
              10254.749
            ],
            [
              3491.45,
              5291.687,
              10353.912
            ],
            [
              3513.919,
              5270.559,
              10384.754
            ],
            [
              3564.966,
              5171.889,
              10495.847
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:939",
              "position": {
                "x": 448.101,
                "z": 1917.454
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 1.465,
              "arrivalOffsetSeconds": -780,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:5941",
              "position": {
                "x": 889.31,
                "z": 1911.588
              },
              "distanceAlongShapeM": 778.319,
              "shapeOffsetM": 1.882,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:5944",
              "position": {
                "x": 1272.571,
                "z": 2296.383
              },
              "distanceAlongShapeM": 1333.617,
              "shapeOffsetM": 3.486,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:5946",
              "position": {
                "x": 1466.069,
                "z": 2814.913
              },
              "distanceAlongShapeM": 1892.875,
              "shapeOffsetM": 5.422,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:16977",
              "position": {
                "x": 1743.856,
                "z": 3803.884
              },
              "distanceAlongShapeM": 3018.955,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:616",
              "position": {
                "x": 2873.526,
                "z": 4357.203
              },
              "distanceAlongShapeM": 4282.649,
              "shapeOffsetM": 0.887,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:6120",
              "position": {
                "x": 4006.468,
                "z": 4830.032
              },
              "distanceAlongShapeM": 5510.283,
              "shapeOffsetM": 2.509,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:6122",
              "position": {
                "x": 4522.992,
                "z": 5032.789
              },
              "distanceAlongShapeM": 6094.998,
              "shapeOffsetM": 1.83,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:9677",
              "position": {
                "x": 5120.284,
                "z": 5403.146
              },
              "distanceAlongShapeM": 6870.777,
              "shapeOffsetM": 6.277,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:9678",
              "position": {
                "x": 5009.166,
                "z": 5902.915
              },
              "distanceAlongShapeM": 7394.314,
              "shapeOffsetM": 1.703,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:17854",
              "position": {
                "x": 4784.791,
                "z": 5921.707
              },
              "distanceAlongShapeM": 7695.371,
              "shapeOffsetM": 3.654,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:9680",
              "position": {
                "x": 4346.137,
                "z": 6014.725
              },
              "distanceAlongShapeM": 8143.529,
              "shapeOffsetM": 8.321,
              "arrivalOffsetSeconds": 1380,
              "departureOffsetSeconds": 1380
            },
            {
              "stopId": "judu:stop:10532",
              "position": {
                "x": 3811.243,
                "z": 6141.816
              },
              "distanceAlongShapeM": 8693.303,
              "shapeOffsetM": 4.748,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            },
            {
              "stopId": "judu:stop:9681",
              "position": {
                "x": 3255.717,
                "z": 6238.061
              },
              "distanceAlongShapeM": 9284.765,
              "shapeOffsetM": 1.225,
              "arrivalOffsetSeconds": 1560,
              "departureOffsetSeconds": 1560
            },
            {
              "stopId": "judu:stop:9790",
              "position": {
                "x": 3241.744,
                "z": 5874.294
              },
              "distanceAlongShapeM": 9652.986,
              "shapeOffsetM": 11.094,
              "arrivalOffsetSeconds": 1620,
              "departureOffsetSeconds": 1620
            },
            {
              "stopId": "judu:stop:9682",
              "position": {
                "x": 3302.002,
                "z": 5611.543
              },
              "distanceAlongShapeM": 9931.095,
              "shapeOffsetM": 6.337,
              "arrivalOffsetSeconds": 1680,
              "departureOffsetSeconds": 1680
            },
            {
              "stopId": "judu:stop:7874",
              "position": {
                "x": 3570.094,
                "z": 5174.529
              },
              "distanceAlongShapeM": 10495.847,
              "shapeOffsetM": 5.768,
              "arrivalOffsetSeconds": 1740,
              "departureOffsetSeconds": 1740
            }
          ],
          "departuresSeconds": [
            18600,
            20160,
            21780,
            22980,
            24180,
            25380,
            26580,
            27780,
            29100,
            30480,
            32040,
            33840,
            35580,
            37680,
            39480,
            41280,
            43080,
            44880,
            46680,
            48480,
            50280,
            52080,
            53880,
            55440,
            56820,
            58020,
            59220,
            60480,
            61800,
            63000,
            64200,
            65460,
            67140,
            68940,
            70980,
            72660,
            74460,
            76260,
            78060,
            79860,
            81660,
            83460,
            85260
          ]
        },
        {
          "id": "judu:pattern:vilnius_bus_61:1",
          "sourceRouteId": "vilnius_bus_61",
          "sourceShapeId": "vilnius_bus_61_b-a",
          "directionId": 1,
          "headsign": "Stotis",
          "directionName": "Kuprioniškės–Stotis",
          "mode": "bus",
          "routeShortName": "61",
          "routeLongName": "Stotis–Nemėžis–Kuprioniškės",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              3564.966,
              5171.889,
              0
            ],
            [
              3745.362,
              4816.232,
              398.791
            ],
            [
              3783.733,
              4739.623,
              484.473
            ],
            [
              3789.042,
              4736.205,
              490.787
            ],
            [
              4061.377,
              4840.017,
              782.237
            ],
            [
              4083.024,
              4847.283,
              805.071
            ],
            [
              4087.249,
              4834.058,
              818.955
            ],
            [
              4080.795,
              4825.546,
              829.637
            ],
            [
              3917.18,
              4757.37,
              1006.888
            ],
            [
              3791.824,
              4712.774,
              1139.94
            ],
            [
              3112.5,
              4431.742,
              1875.1
            ],
            [
              2821.939,
              4306.494,
              2191.506
            ],
            [
              2811.195,
              4303.827,
              2202.576
            ],
            [
              2180.203,
              4046.241,
              2884.119
            ],
            [
              2131.974,
              4021.536,
              2938.308
            ],
            [
              2048.616,
              3965.985,
              3038.48
            ],
            [
              1961.818,
              3896.684,
              3149.55
            ],
            [
              1908.119,
              3855.38,
              3217.296
            ],
            [
              1885.245,
              3840.22,
              3244.738
            ],
            [
              1810.879,
              3798.186,
              3330.162
            ],
            [
              1773.103,
              3779.963,
              3372.103
            ],
            [
              1723.068,
              3761.967,
              3425.276
            ],
            [
              1676.987,
              3748.35,
              3473.327
            ],
            [
              1674.389,
              3729.453,
              3492.401
            ],
            [
              1684.234,
              3721.498,
              3505.059
            ],
            [
              1679.247,
              3710.449,
              3517.181
            ],
            [
              1680.184,
              3591.526,
              3636.107
            ],
            [
              1696.885,
              3464.105,
              3764.618
            ],
            [
              1701.829,
              3382.747,
              3846.126
            ],
            [
              1703.03,
              3134.473,
              4094.403
            ],
            [
              1699.891,
              3104.474,
              4124.566
            ],
            [
              1687.994,
              3054.599,
              4175.84
            ],
            [
              1659.262,
              3001.697,
              4236.041
            ],
            [
              1605.061,
              2932.568,
              4323.885
            ],
            [
              1556.997,
              2881.137,
              4394.279
            ],
            [
              1484.111,
              2813.466,
              4493.736
            ],
            [
              1478.391,
              2802.8,
              4505.839
            ],
            [
              1453.839,
              2781.743,
              4538.184
            ],
            [
              1433.991,
              2755.392,
              4571.174
            ],
            [
              1428.563,
              2741.021,
              4586.536
            ],
            [
              1382.281,
              2541.494,
              4791.36
            ],
            [
              1365.86,
              2456.079,
              4878.339
            ],
            [
              1336.284,
              2392.058,
              4948.862
            ],
            [
              1222.21,
              2196.952,
              5174.869
            ],
            [
              958.108,
              1933.7,
              5547.765
            ],
            [
              918.257,
              1878.079,
              5616.189
            ],
            [
              898.105,
              1863.557,
              5641.028
            ],
            [
              863.527,
              1836.207,
              5685.115
            ],
            [
              825.163,
              1791.425,
              5744.083
            ],
            [
              623.161,
              1858.587,
              5956.957
            ],
            [
              493.411,
              1911.506,
              6097.085
            ],
            [
              481.742,
              1922.405,
              6113.051
            ],
            [
              470.798,
              1923.718,
              6124.074
            ],
            [
              464.267,
              1919.385,
              6131.911
            ],
            [
              448.24,
              1918.913,
              6147.945
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:7874",
              "position": {
                "x": 3570.094,
                "z": 5174.529
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 5.768,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:9585",
              "position": {
                "x": 3749.281,
                "z": 4818.228
              },
              "distanceAlongShapeM": 398.784,
              "shapeOffsetM": 4.398,
              "arrivalOffsetSeconds": 60,
              "departureOffsetSeconds": 60
            },
            {
              "stopId": "judu:stop:6121",
              "position": {
                "x": 3917.274,
                "z": 4757.143
              },
              "distanceAlongShapeM": 1006.888,
              "shapeOffsetM": 0.246,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:617",
              "position": {
                "x": 2822.207,
                "z": 4305.846
              },
              "distanceAlongShapeM": 2191.506,
              "shapeOffsetM": 0.701,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:5998",
              "position": {
                "x": 1684.234,
                "z": 3721.498
              },
              "distanceAlongShapeM": 3505.059,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:5947",
              "position": {
                "x": 1478.744,
                "z": 2802.433
              },
              "distanceAlongShapeM": 4505.839,
              "shapeOffsetM": 0.509,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:5945",
              "position": {
                "x": 1224.883,
                "z": 2194.846
              },
              "distanceAlongShapeM": 5174.869,
              "shapeOffsetM": 3.403,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:5942",
              "position": {
                "x": 922.174,
                "z": 1874.247
              },
              "distanceAlongShapeM": 5616.189,
              "shapeOffsetM": 5.48,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:8264",
              "position": {
                "x": 493.148,
                "z": 1911.064
              },
              "distanceAlongShapeM": 6097.085,
              "shapeOffsetM": 0.515,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:939",
              "position": {
                "x": 448.101,
                "z": 1917.454
              },
              "distanceAlongShapeM": 6147.945,
              "shapeOffsetM": 1.465,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            }
          ],
          "departuresSeconds": [
            20280,
            21840,
            23460,
            24720,
            25920,
            27240,
            28440,
            29640,
            30960,
            32340,
            33900,
            35640,
            37380,
            39480,
            41280,
            43020,
            44820,
            46740,
            48540,
            50280,
            52080,
            53940,
            55740,
            57300,
            58680,
            60180,
            61320,
            62520,
            63900,
            65100,
            66300,
            67200,
            68880,
            70680,
            72720,
            74280,
            76080,
            77940,
            79680,
            81480,
            83280,
            85080,
            86940
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_bus_62",
      "sourceRouteId": "vilnius_bus_62",
      "mode": "bus",
      "shortName": "62",
      "longName": "Žemieji Paneriai–Mūrinė Vokė– Gureliai–Lazdynai",
      "color": "0073AC",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_bus_62:0",
          "sourceRouteId": "vilnius_bus_62",
          "sourceShapeId": "vilnius_bus_62_a-b",
          "directionId": 0,
          "headsign": "Lazdynai",
          "directionName": "Žemieji Paneriai–Mūrinė Vokė– Gureliai–Lazdynai",
          "mode": "bus",
          "routeShortName": "62",
          "routeLongName": "Žemieji Paneriai–Mūrinė Vokė– Gureliai–Lazdynai",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              -4333.961,
              4766.474,
              0
            ],
            [
              -4351.156,
              4780.129,
              21.957
            ],
            [
              -4357.738,
              4810.298,
              52.837
            ],
            [
              -4435.232,
              4883.989,
              159.774
            ],
            [
              -4468.845,
              4919.076,
              208.363
            ],
            [
              -4488.111,
              4924.973,
              228.512
            ],
            [
              -4510.925,
              4949.856,
              262.27
            ],
            [
              -4579.258,
              4993.33,
              343.261
            ],
            [
              -4600.366,
              5004.825,
              367.295
            ],
            [
              -4835.366,
              5155.793,
              646.609
            ],
            [
              -5032.11,
              5279.379,
              878.948
            ],
            [
              -5271.713,
              5427.062,
              1160.409
            ],
            [
              -5460.164,
              5546.035,
              1383.274
            ],
            [
              -5507.478,
              5573.554,
              1438.008
            ],
            [
              -5539.526,
              5587.456,
              1472.942
            ],
            [
              -5570.341,
              5597.997,
              1505.509
            ],
            [
              -5599.939,
              5604.064,
              1535.723
            ],
            [
              -5632.195,
              5605.723,
              1568.022
            ],
            [
              -5666.482,
              5601.851,
              1602.527
            ],
            [
              -5724.289,
              5581.678,
              1663.753
            ],
            [
              -5767.933,
              5559.039,
              1712.918
            ],
            [
              -5844.413,
              5503.558,
              1807.403
            ],
            [
              -5862.75,
              5488.283,
              1831.269
            ],
            [
              -5911.642,
              5422.317,
              1913.378
            ],
            [
              -5931.13,
              5377.005,
              1962.703
            ],
            [
              -5950.367,
              5308.312,
              2034.039
            ],
            [
              -5960.48,
              5282.88,
              2061.409
            ],
            [
              -5972.455,
              5261.931,
              2085.538
            ],
            [
              -5985.57,
              5249.907,
              2103.331
            ],
            [
              -6003.755,
              5243.534,
              2122.6
            ],
            [
              -6024.466,
              5240.544,
              2143.526
            ],
            [
              -6045.12,
              5240.892,
              2164.183
            ],
            [
              -6069.366,
              5257.998,
              2193.856
            ],
            [
              -6086.896,
              5290.575,
              2230.85
            ],
            [
              -6284.365,
              5565.511,
              2569.352
            ],
            [
              -6384.618,
              5670.718,
              2714.677
            ],
            [
              -6403.151,
              5682.161,
              2736.458
            ],
            [
              -6425.222,
              5713.7,
              2774.953
            ],
            [
              -6633.66,
              5914.22,
              3064.184
            ],
            [
              -6722.128,
              5991.393,
              3181.582
            ],
            [
              -6610.439,
              6453.723,
              3657.212
            ],
            [
              -6615.859,
              6477.191,
              3681.297
            ],
            [
              -6611.247,
              6482.68,
              3688.466
            ],
            [
              -6601.507,
              6485.856,
              3698.711
            ],
            [
              -6595.808,
              6479.082,
              3707.564
            ],
            [
              -6595.901,
              6473.518,
              3713.129
            ],
            [
              -6598.614,
              6465.771,
              3721.337
            ],
            [
              -6609.831,
              6451.487,
              3739.499
            ],
            [
              -6653.627,
              6265.205,
              3930.861
            ],
            [
              -6722.128,
              5991.393,
              4213.111
            ],
            [
              -6754.294,
              5998.609,
              4246.076
            ],
            [
              -6809.827,
              6037.383,
              4313.806
            ],
            [
              -6882.79,
              6076.446,
              4396.569
            ],
            [
              -6955.867,
              6108.831,
              4476.5
            ],
            [
              -7039.365,
              6135.823,
              4564.252
            ],
            [
              -7206.108,
              6166.42,
              4733.779
            ],
            [
              -7774.707,
              6263.751,
              5310.649
            ],
            [
              -7867.343,
              6285.312,
              5405.76
            ],
            [
              -8047.971,
              6336.143,
              5593.404
            ],
            [
              -8100.928,
              6335.897,
              5646.362
            ],
            [
              -8216.781,
              6399.018,
              5778.294
            ],
            [
              -8443.118,
              6419.411,
              6005.548
            ],
            [
              -8559.774,
              6433.557,
              6123.059
            ],
            [
              -8589.455,
              6435.153,
              6152.782
            ],
            [
              -8680.794,
              6417.715,
              6245.771
            ],
            [
              -8793.026,
              6386.142,
              6362.36
            ],
            [
              -8817.578,
              6385.428,
              6386.922
            ],
            [
              -8897.885,
              6371.145,
              6468.489
            ],
            [
              -8999.678,
              6346.078,
              6573.323
            ],
            [
              -9021.163,
              6335.294,
              6597.362
            ],
            [
              -9032.999,
              6322.127,
              6615.067
            ],
            [
              -9043.295,
              6284.446,
              6654.13
            ],
            [
              -9071.789,
              5999.937,
              6940.062
            ],
            [
              -9087.112,
              5810.947,
              7129.673
            ],
            [
              -9105.787,
              5654.292,
              7287.436
            ],
            [
              -9121.037,
              5469.753,
              7472.604
            ],
            [
              -9131.188,
              5400.901,
              7542.201
            ],
            [
              -9162.794,
              5083.047,
              7861.623
            ],
            [
              -9167.245,
              4967.349,
              7977.406
            ],
            [
              -9185.609,
              4829.613,
              8116.36
            ],
            [
              -9269.169,
              4812.038,
              8201.749
            ],
            [
              -9558.495,
              4764.378,
              8494.974
            ],
            [
              -9588.344,
              4754.839,
              8526.31
            ],
            [
              -9674.339,
              4746.201,
              8612.738
            ],
            [
              -9691.208,
              4740.905,
              8630.419
            ],
            [
              -9773.869,
              4738.891,
              8713.104
            ],
            [
              -9802.39,
              4731.556,
              8742.554
            ],
            [
              -9849.213,
              4710.042,
              8794.082
            ],
            [
              -10016.251,
              4679.317,
              8963.923
            ],
            [
              -10029.91,
              4672.856,
              8979.033
            ],
            [
              -10035.843,
              4665.159,
              8988.751
            ],
            [
              -10041.326,
              4645.21,
              9009.44
            ],
            [
              -10038.868,
              4637.378,
              9017.648
            ],
            [
              -10034.44,
              4631.742,
              9024.816
            ],
            [
              -10024.132,
              4630.464,
              9035.203
            ],
            [
              -10003.374,
              4636.812,
              9056.91
            ],
            [
              -9985.268,
              4638.749,
              9075.119
            ],
            [
              -9974.208,
              4644.138,
              9087.422
            ],
            [
              -9966.985,
              4651.815,
              9097.963
            ],
            [
              -9956.86,
              4679.482,
              9127.424
            ],
            [
              -9956.789,
              4683.933,
              9131.876
            ],
            [
              -9961.898,
              4687.354,
              9138.026
            ],
            [
              -10095.11,
              4672.784,
              9272.031
            ],
            [
              -10234.242,
              4691.698,
              9412.444
            ],
            [
              -10328.863,
              4708.788,
              9508.595
            ],
            [
              -10457.848,
              4716.402,
              9637.805
            ],
            [
              -10625.087,
              4713.487,
              9805.069
            ],
            [
              -10645.983,
              4820.681,
              9914.281
            ],
            [
              -10656.837,
              4909.906,
              10004.163
            ],
            [
              -10709.285,
              5185.685,
              10284.885
            ],
            [
              -10725.756,
              5287.243,
              10387.77
            ],
            [
              -10747.257,
              5356.598,
              10460.381
            ],
            [
              -10770.707,
              5466.058,
              10572.325
            ],
            [
              -10773.201,
              5471.663,
              10578.46
            ],
            [
              -10785.271,
              5484.098,
              10595.79
            ],
            [
              -10799.977,
              5493.236,
              10613.103
            ],
            [
              -10816.008,
              5500.168,
              10630.569
            ],
            [
              -10854.979,
              5526.386,
              10677.538
            ],
            [
              -10936.846,
              5575.542,
              10773.03
            ],
            [
              -10955.931,
              5593.653,
              10799.34
            ],
            [
              -10973.058,
              5654.033,
              10862.102
            ],
            [
              -10992.852,
              5750.076,
              10960.164
            ],
            [
              -10990.06,
              5763.39,
              10973.767
            ],
            [
              -10980.062,
              5783.27,
              10996.019
            ],
            [
              -10955.774,
              5808.49,
              11031.032
            ],
            [
              -10898.789,
              5859.91,
              11107.787
            ],
            [
              -10872.164,
              5869.508,
              11136.089
            ],
            [
              -10795.047,
              5887.215,
              11215.213
            ],
            [
              -10745.688,
              5905.359,
              11267.802
            ],
            [
              -10731.991,
              5914.048,
              11284.022
            ],
            [
              -10703.077,
              5945.872,
              11327.02
            ],
            [
              -10692.678,
              5950.16,
              11338.268
            ],
            [
              -10690.148,
              5946.781,
              11342.49
            ],
            [
              -10692.138,
              5943.473,
              11346.35
            ],
            [
              -10703.828,
              5939.205,
              11358.795
            ],
            [
              -10737.924,
              5906.349,
              11406.145
            ],
            [
              -10772.994,
              5893.545,
              11443.479
            ],
            [
              -10833.937,
              5877.81,
              11506.421
            ],
            [
              -10887.815,
              5859.737,
              11563.249
            ],
            [
              -10906.676,
              5851.129,
              11583.981
            ],
            [
              -10974.862,
              5785.414,
              11678.68
            ],
            [
              -10976.799,
              5785.444,
              11680.617
            ],
            [
              -10986.902,
              5758.888,
              11709.031
            ],
            [
              -10985.039,
              5713.219,
              11754.737
            ],
            [
              -10959.105,
              5597.043,
              11873.773
            ],
            [
              -10950.296,
              5582.433,
              11890.833
            ],
            [
              -10886.221,
              5551.368,
              11962.042
            ],
            [
              -10778.242,
              5479.535,
              12091.732
            ],
            [
              -10759.827,
              5419.133,
              12154.878
            ],
            [
              -10743.002,
              5339.834,
              12235.943
            ],
            [
              -10725.721,
              5289.468,
              12289.191
            ],
            [
              -10643.067,
              4841.785,
              12744.44
            ],
            [
              -10625.016,
              4717.939,
              12869.595
            ],
            [
              -10404.928,
              4715.562,
              13089.696
            ],
            [
              -10343.026,
              4711.239,
              13151.749
            ],
            [
              -10142.866,
              4673.545,
              13355.426
            ],
            [
              -10106.797,
              4668.517,
              13391.844
            ],
            [
              -10049.863,
              4676.514,
              13449.337
            ],
            [
              -10001.283,
              4686.87,
              13499.008
            ],
            [
              -9954.065,
              4692.795,
              13546.597
            ],
            [
              -9954.87,
              4682.79,
              13556.635
            ],
            [
              -9971.053,
              4639.635,
              13602.724
            ],
            [
              -9996.31,
              4634.472,
              13628.504
            ],
            [
              -10015.813,
              4625.879,
              13649.816
            ],
            [
              -10037.72,
              4628.455,
              13671.874
            ],
            [
              -10042.829,
              4631.876,
              13678.023
            ],
            [
              -10045.914,
              4640.83,
              13687.494
            ],
            [
              -10043.084,
              4656.369,
              13703.288
            ],
            [
              -10039.034,
              4667.436,
              13715.073
            ],
            [
              -10033.119,
              4674.021,
              13723.924
            ],
            [
              -9847.833,
              4715.586,
              13913.815
            ],
            [
              -9780.287,
              4741.22,
              13986.062
            ],
            [
              -9738.284,
              4743.887,
              14028.149
            ],
            [
              -9619.286,
              4757.562,
              14147.931
            ],
            [
              -9574.594,
              4766.863,
              14193.58
            ],
            [
              -9427.108,
              4785.641,
              14342.257
            ],
            [
              -9186.254,
              4829.624,
              14587.094
            ],
            [
              -8761.616,
              4900.668,
              15017.634
            ],
            [
              -8566.072,
              4936.448,
              15216.424
            ],
            [
              -8440.538,
              4954.439,
              15343.242
            ],
            [
              -8110.415,
              5008.04,
              15677.687
            ],
            [
              -7984.14,
              5031.572,
              15806.137
            ],
            [
              -7996.281,
              5078.524,
              15854.634
            ],
            [
              -8005.189,
              5086.463,
              15866.566
            ],
            [
              -8032.814,
              5094.708,
              15895.395
            ],
            [
              -8056.05,
              5095.089,
              15918.634
            ],
            [
              -8074.858,
              5089.832,
              15938.163
            ],
            [
              -8087.322,
              5077.791,
              15955.493
            ],
            [
              -8094.05,
              5061.204,
              15973.393
            ],
            [
              -8097.824,
              5027.871,
              16006.939
            ],
            [
              -8123.102,
              4509.547,
              16525.879
            ],
            [
              -8153.328,
              4043.622,
              16992.783
            ],
            [
              -8152.03,
              4004.64,
              17031.787
            ],
            [
              -8148.06,
              3971.18,
              17065.482
            ],
            [
              -8134.965,
              3943.136,
              17096.432
            ],
            [
              -8122.972,
              3887.281,
              17153.56
            ],
            [
              -8106.816,
              3849.168,
              17194.956
            ],
            [
              -8055.33,
              3761.496,
              17296.628
            ],
            [
              -8007.887,
              3702.832,
              17372.075
            ],
            [
              -7953.829,
              3654.078,
              17444.871
            ],
            [
              -7691.803,
              3497.261,
              17750.239
            ],
            [
              -7552.547,
              3410.361,
              17914.384
            ],
            [
              -7508.286,
              3394.045,
              17961.556
            ],
            [
              -7243.876,
              3227.143,
              18274.237
            ],
            [
              -6939.838,
              3038.415,
              18632.088
            ],
            [
              -6822.27,
              2929.59,
              18792.291
            ],
            [
              -6676.677,
              2683.371,
              19078.335
            ],
            [
              -6663.874,
              2638.63,
              19124.872
            ],
            [
              -6617.665,
              2546.576,
              19227.873
            ],
            [
              -6572.047,
              2457.871,
              19327.62
            ],
            [
              -6516.148,
              2366.767,
              19434.507
            ],
            [
              -6469.844,
              2319.237,
              19500.863
            ],
            [
              -6422.765,
              2279.486,
              19562.479
            ],
            [
              -6337.172,
              2227.956,
              19662.386
            ],
            [
              -6224.837,
              2193.786,
              19779.804
            ],
            [
              -5648.753,
              2074.968,
              20368.013
            ],
            [
              -5407.978,
              2044.165,
              20610.751
            ],
            [
              -5248.741,
              2037.003,
              20770.149
            ],
            [
              -5237.188,
              2033.466,
              20782.231
            ],
            [
              -5229.201,
              2009.953,
              20807.064
            ],
            [
              -5217.875,
              1993.062,
              20827.4
            ],
            [
              -5096.905,
              1898.604,
              20980.881
            ],
            [
              -5077.101,
              1887.134,
              21003.767
            ],
            [
              -5061.716,
              1881.305,
              21020.218
            ],
            [
              -5063.879,
              1867.984,
              21033.714
            ],
            [
              -4984.799,
              1776.464,
              21154.667
            ],
            [
              -4951.187,
              1742.493,
              21202.455
            ],
            [
              -4928.804,
              1730.978,
              21227.626
            ],
            [
              -4906.917,
              1690.529,
              21273.618
            ],
            [
              -4842.797,
              1742.865,
              21356.385
            ],
            [
              -4801.101,
              1766.641,
              21404.384
            ],
            [
              -4774.467,
              1777.316,
              21433.077
            ],
            [
              -4728.427,
              1790.998,
              21481.108
            ],
            [
              -4687.68,
              1796.979,
              21522.291
            ],
            [
              -4579.155,
              1805.134,
              21631.122
            ],
            [
              -4547.361,
              1815.72,
              21664.632
            ],
            [
              -4518.395,
              1811.882,
              21693.851
            ],
            [
              -4369.14,
              1824.898,
              21843.672
            ],
            [
              -4282.619,
              1828.972,
              21930.289
            ],
            [
              -4232.446,
              1820.314,
              21981.204
            ],
            [
              -4165.014,
              1802.452,
              22050.962
            ],
            [
              -4141.304,
              1793.136,
              22076.436
            ],
            [
              -4122.773,
              1782.797,
              22097.656
            ],
            [
              -4066.123,
              1738.403,
              22169.629
            ],
            [
              -4047.525,
              1694.666,
              22217.156
            ],
            [
              -4037.081,
              1664.429,
              22249.146
            ],
            [
              -4020.121,
              1600.683,
              22315.109
            ],
            [
              -3992.198,
              1462.162,
              22456.416
            ],
            [
              -3984.902,
              1436.432,
              22483.161
            ],
            [
              -3986.154,
              1438.68,
              22485.733
            ],
            [
              -3968.906,
              1391.627,
              22535.848
            ],
            [
              -3969.311,
              1368.257,
              22559.222
            ],
            [
              -3952.68,
              1285.592,
              22643.544
            ],
            [
              -3953.633,
              1267.797,
              22661.364
            ],
            [
              -3986.792,
              1252.786,
              22697.762
            ],
            [
              -4052.311,
              1231.656,
              22766.603
            ],
            [
              -4088.482,
              1228.943,
              22802.876
            ],
            [
              -4121.332,
              1231.737,
              22835.845
            ],
            [
              -4147.695,
              1236.645,
              22862.661
            ],
            [
              -4215.081,
              1256.734,
              22932.977
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:5567",
              "position": {
                "x": -4488.111,
                "z": 4924.973
              },
              "distanceAlongShapeM": 228.512,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:5728",
              "position": {
                "x": -6069.366,
                "z": 5257.998
              },
              "distanceAlongShapeM": 2193.856,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:5732",
              "position": {
                "x": -6403.151,
                "z": 5682.161
              },
              "distanceAlongShapeM": 2736.458,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:9967",
              "position": {
                "x": -6701.294,
                "z": 6078.986
              },
              "distanceAlongShapeM": 3271.618,
              "shapeOffsetM": 0.317,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:8784",
              "position": {
                "x": -6615.878,
                "z": 6476.078
              },
              "distanceAlongShapeM": 3680.216,
              "shapeOffsetM": 0.269,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:5738",
              "position": {
                "x": -6754.294,
                "z": 5998.609
              },
              "distanceAlongShapeM": 4246.076,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:5742",
              "position": {
                "x": -8100.928,
                "z": 6335.897
              },
              "distanceAlongShapeM": 5646.362,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:6270",
              "position": {
                "x": -8793.026,
                "z": 6386.142
              },
              "distanceAlongShapeM": 6362.36,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:6274",
              "position": {
                "x": -9087.112,
                "z": 5810.947
              },
              "distanceAlongShapeM": 7129.673,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:6277",
              "position": {
                "x": -9121.037,
                "z": 5469.753
              },
              "distanceAlongShapeM": 7472.604,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:6279",
              "position": {
                "x": -9167.245,
                "z": 4967.349
              },
              "distanceAlongShapeM": 7977.406,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:6282",
              "position": {
                "x": -9588.344,
                "z": 4754.839
              },
              "distanceAlongShapeM": 8526.31,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            },
            {
              "stopId": "judu:stop:6286",
              "position": {
                "x": -10003.374,
                "z": 4636.812
              },
              "distanceAlongShapeM": 9056.91,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:15829",
              "position": {
                "x": -10645.983,
                "z": 4820.681
              },
              "distanceAlongShapeM": 9914.281,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:15833",
              "position": {
                "x": -10816.008,
                "z": 5500.168
              },
              "distanceAlongShapeM": 10630.569,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:15837",
              "position": {
                "x": -10692.138,
                "z": 5943.473
              },
              "distanceAlongShapeM": 11346.35,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1380,
              "departureOffsetSeconds": 1380
            },
            {
              "stopId": "judu:stop:15835",
              "position": {
                "x": -10886.221,
                "z": 5551.368
              },
              "distanceAlongShapeM": 11962.042,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1500,
              "departureOffsetSeconds": 1500
            },
            {
              "stopId": "judu:stop:15831",
              "position": {
                "x": -10643.067,
                "z": 4841.785
              },
              "distanceAlongShapeM": 12744.44,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1620,
              "departureOffsetSeconds": 1620
            },
            {
              "stopId": "judu:stop:9626",
              "position": {
                "x": -10015.813,
                "z": 4625.879
              },
              "distanceAlongShapeM": 13649.816,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1740,
              "departureOffsetSeconds": 1740
            },
            {
              "stopId": "judu:stop:6283",
              "position": {
                "x": -9574.594,
                "z": 4766.863
              },
              "distanceAlongShapeM": 14193.58,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1860,
              "departureOffsetSeconds": 1860
            },
            {
              "stopId": "judu:stop:6291",
              "position": {
                "x": -8566.072,
                "z": 4936.448
              },
              "distanceAlongShapeM": 15216.424,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1980,
              "departureOffsetSeconds": 1980
            },
            {
              "stopId": "judu:stop:6295",
              "position": {
                "x": -8134.965,
                "z": 3943.136
              },
              "distanceAlongShapeM": 17096.432,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2160,
              "departureOffsetSeconds": 2160
            },
            {
              "stopId": "judu:stop:6609",
              "position": {
                "x": -7508.286,
                "z": 3394.045
              },
              "distanceAlongShapeM": 17961.556,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2280,
              "departureOffsetSeconds": 2280
            },
            {
              "stopId": "judu:stop:6310",
              "position": {
                "x": -6676.677,
                "z": 2683.371
              },
              "distanceAlongShapeM": 19078.335,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2400,
              "departureOffsetSeconds": 2400
            },
            {
              "stopId": "judu:stop:437",
              "position": {
                "x": -4928.804,
                "z": 1730.978
              },
              "distanceAlongShapeM": 21227.626,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2610,
              "departureOffsetSeconds": 2610
            },
            {
              "stopId": "judu:stop:5691",
              "position": {
                "x": -4547.361,
                "z": 1815.72
              },
              "distanceAlongShapeM": 21664.632,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2670,
              "departureOffsetSeconds": 2670
            },
            {
              "stopId": "judu:stop:5693",
              "position": {
                "x": -4066.123,
                "z": 1738.403
              },
              "distanceAlongShapeM": 22169.629,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2730,
              "departureOffsetSeconds": 2730
            },
            {
              "stopId": "judu:stop:5697",
              "position": {
                "x": -3968.906,
                "z": 1391.627
              },
              "distanceAlongShapeM": 22535.848,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2820,
              "departureOffsetSeconds": 2820
            },
            {
              "stopId": "judu:stop:6318",
              "position": {
                "x": -4215.081,
                "z": 1256.734
              },
              "distanceAlongShapeM": 22932.977,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2880,
              "departureOffsetSeconds": 2880
            }
          ],
          "departuresSeconds": [
            19440,
            23040,
            26460,
            30300,
            34860,
            38880,
            42180,
            45660,
            49020,
            52620,
            55620,
            60300,
            64620,
            68880,
            72180,
            75720,
            79260,
            82020
          ]
        },
        {
          "id": "judu:pattern:vilnius_bus_62:1",
          "sourceRouteId": "vilnius_bus_62",
          "sourceShapeId": "vilnius_bus_62_b-a",
          "directionId": 1,
          "headsign": "Žemieji Paneriai",
          "directionName": "Lazdynai–Mūrinė Vokė–Gureliai–Žemieji Paneriai",
          "mode": "bus",
          "routeShortName": "62",
          "routeLongName": "Žemieji Paneriai–Mūrinė Vokė– Gureliai–Lazdynai",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              -4215.081,
              1256.734,
              0
            ],
            [
              -4241.916,
              1271.669,
              30.711
            ],
            [
              -4268.203,
              1281.028,
              58.614
            ],
            [
              -4527.979,
              1404.616,
              346.29
            ],
            [
              -4558.781,
              1414.051,
              378.505
            ],
            [
              -4581.673,
              1433.369,
              408.459
            ],
            [
              -4718.251,
              1519.203,
              569.77
            ],
            [
              -4838.028,
              1606.973,
              718.262
            ],
            [
              -4906.917,
              1690.529,
              826.555
            ],
            [
              -4962.228,
              1738.229,
              899.593
            ],
            [
              -5070.177,
              1876.997,
              1075.404
            ],
            [
              -5047.925,
              1895.541,
              1104.37
            ],
            [
              -4996.021,
              1950.314,
              1179.83
            ],
            [
              -4992.511,
              1966.952,
              1196.834
            ],
            [
              -4995.545,
              1978.136,
              1208.422
            ],
            [
              -5002.507,
              1986.047,
              1218.96
            ],
            [
              -5010.228,
              1987.292,
              1226.781
            ],
            [
              -5028.345,
              1984.262,
              1245.149
            ],
            [
              -5177.583,
              1934.489,
              1402.469
            ],
            [
              -5251.262,
              1926.839,
              1476.544
            ],
            [
              -5286.129,
              1925.207,
              1511.449
            ],
            [
              -5329.267,
              1930.394,
              1554.897
            ],
            [
              -5390.957,
              1944.801,
              1618.248
            ],
            [
              -5430.093,
              1957.712,
              1659.458
            ],
            [
              -5538.852,
              2011.879,
              1780.96
            ],
            [
              -5604.833,
              2039.715,
              1852.572
            ],
            [
              -5664.553,
              2056.312,
              1914.556
            ],
            [
              -6261.201,
              2179.926,
              2523.874
            ],
            [
              -6367.656,
              2218.449,
              2637.085
            ],
            [
              -6455.072,
              2276.688,
              2742.125
            ],
            [
              -6521.774,
              2339.031,
              2833.426
            ],
            [
              -6565.387,
              2393.195,
              2902.966
            ],
            [
              -6596.857,
              2440.475,
              2959.762
            ],
            [
              -6687.246,
              2630.115,
              3169.841
            ],
            [
              -6721.281,
              2678.551,
              3229.039
            ],
            [
              -6732.812,
              2722.158,
              3274.145
            ],
            [
              -6787.208,
              2826.592,
              3391.896
            ],
            [
              -6821.115,
              2882.817,
              3457.554
            ],
            [
              -6849.514,
              2921.139,
              3505.252
            ],
            [
              -6915.475,
              2990.142,
              3600.71
            ],
            [
              -6953.037,
              3020.824,
              3649.211
            ],
            [
              -7039.186,
              3079.03,
              3753.179
            ],
            [
              -7611.222,
              3413.556,
              4415.851
            ],
            [
              -7650.801,
              3439.813,
              4463.347
            ],
            [
              -7850.196,
              3558.868,
              4695.581
            ],
            [
              -7970.179,
              3640.989,
              4840.976
            ],
            [
              -8010.925,
              3675.053,
              4894.085
            ],
            [
              -8074.26,
              3748.448,
              4991.03
            ],
            [
              -8116.47,
              3811.478,
              5066.888
            ],
            [
              -8127.628,
              3839.491,
              5097.04
            ],
            [
              -8136.789,
              3831.848,
              5108.971
            ],
            [
              -8161.184,
              3958.037,
              5237.495
            ],
            [
              -8167.097,
              4030.49,
              5310.189
            ],
            [
              -8128.206,
              4592.005,
              5873.05
            ],
            [
              -8114.065,
              4903.462,
              6184.827
            ],
            [
              -8124.873,
              4913.657,
              6199.685
            ],
            [
              -8158.233,
              4926.449,
              6235.413
            ],
            [
              -8180.177,
              4926.808,
              6257.36
            ],
            [
              -8198.839,
              4930.453,
              6276.375
            ],
            [
              -8215.237,
              4954.098,
              6305.149
            ],
            [
              -8221.863,
              4983.149,
              6334.946
            ],
            [
              -8226.272,
              4989.9,
              6343.009
            ],
            [
              -8636.101,
              4917.551,
              6759.176
            ],
            [
              -8674.97,
              4909.278,
              6798.916
            ],
            [
              -9185.609,
              4829.613,
              7315.731
            ],
            [
              -9269.169,
              4812.038,
              7401.119
            ],
            [
              -9558.495,
              4764.378,
              7694.345
            ],
            [
              -9588.344,
              4754.839,
              7725.681
            ],
            [
              -9674.339,
              4746.201,
              7812.109
            ],
            [
              -9691.208,
              4740.905,
              7829.789
            ],
            [
              -9773.869,
              4738.891,
              7912.475
            ],
            [
              -9802.39,
              4731.556,
              7941.924
            ],
            [
              -9849.213,
              4710.042,
              7993.453
            ],
            [
              -10016.251,
              4679.317,
              8163.293
            ],
            [
              -10029.91,
              4672.856,
              8178.403
            ],
            [
              -10035.843,
              4665.159,
              8188.122
            ],
            [
              -10041.326,
              4645.21,
              8208.811
            ],
            [
              -10038.868,
              4637.378,
              8217.019
            ],
            [
              -10034.44,
              4631.742,
              8224.187
            ],
            [
              -10024.132,
              4630.464,
              8234.574
            ],
            [
              -10003.374,
              4636.812,
              8256.28
            ],
            [
              -9985.268,
              4638.749,
              8274.489
            ],
            [
              -9974.208,
              4644.138,
              8286.792
            ],
            [
              -9966.985,
              4651.815,
              8297.333
            ],
            [
              -9956.86,
              4679.482,
              8326.795
            ],
            [
              -9956.789,
              4683.933,
              8331.247
            ],
            [
              -9961.898,
              4687.354,
              8337.396
            ],
            [
              -10095.11,
              4672.784,
              8471.402
            ],
            [
              -10234.242,
              4691.698,
              8611.814
            ],
            [
              -10328.863,
              4708.788,
              8707.966
            ],
            [
              -10457.848,
              4716.402,
              8837.176
            ],
            [
              -10625.087,
              4713.487,
              9004.44
            ],
            [
              -10645.983,
              4820.681,
              9113.651
            ],
            [
              -10656.837,
              4909.906,
              9203.533
            ],
            [
              -10709.285,
              5185.685,
              9484.256
            ],
            [
              -10725.756,
              5287.243,
              9587.14
            ],
            [
              -10747.257,
              5356.598,
              9659.752
            ],
            [
              -10770.707,
              5466.058,
              9771.695
            ],
            [
              -10773.201,
              5471.663,
              9777.83
            ],
            [
              -10785.271,
              5484.098,
              9795.161
            ],
            [
              -10799.977,
              5493.236,
              9812.474
            ],
            [
              -10816.008,
              5500.168,
              9829.94
            ],
            [
              -10854.979,
              5526.386,
              9876.909
            ],
            [
              -10936.846,
              5575.542,
              9972.4
            ],
            [
              -10955.931,
              5593.653,
              9998.71
            ],
            [
              -10973.058,
              5654.033,
              10061.473
            ],
            [
              -10992.852,
              5750.076,
              10159.534
            ],
            [
              -10990.06,
              5763.39,
              10173.138
            ],
            [
              -10980.062,
              5783.27,
              10195.39
            ],
            [
              -10955.774,
              5808.49,
              10230.403
            ],
            [
              -10898.789,
              5859.91,
              10307.158
            ],
            [
              -10872.164,
              5869.508,
              10335.46
            ],
            [
              -10795.047,
              5887.215,
              10414.584
            ],
            [
              -10745.688,
              5905.359,
              10467.172
            ],
            [
              -10731.991,
              5914.048,
              10483.393
            ],
            [
              -10703.077,
              5945.872,
              10526.391
            ],
            [
              -10692.678,
              5950.16,
              10537.639
            ],
            [
              -10690.148,
              5946.781,
              10541.86
            ],
            [
              -10692.138,
              5943.473,
              10545.72
            ],
            [
              -10703.828,
              5939.205,
              10558.165
            ],
            [
              -10737.924,
              5906.349,
              10605.515
            ],
            [
              -10772.994,
              5893.545,
              10642.849
            ],
            [
              -10833.937,
              5877.81,
              10705.792
            ],
            [
              -10887.815,
              5859.737,
              10762.62
            ],
            [
              -10906.676,
              5851.129,
              10783.352
            ],
            [
              -10974.862,
              5785.414,
              10878.051
            ],
            [
              -10976.799,
              5785.444,
              10879.988
            ],
            [
              -10986.902,
              5758.888,
              10908.401
            ],
            [
              -10985.039,
              5713.219,
              10954.108
            ],
            [
              -10959.105,
              5597.043,
              11073.144
            ],
            [
              -10950.296,
              5582.433,
              11090.204
            ],
            [
              -10886.221,
              5551.368,
              11161.412
            ],
            [
              -10778.242,
              5479.535,
              11291.103
            ],
            [
              -10759.827,
              5419.133,
              11354.249
            ],
            [
              -10743.002,
              5339.834,
              11435.314
            ],
            [
              -10725.721,
              5289.468,
              11488.561
            ],
            [
              -10643.067,
              4841.785,
              11943.811
            ],
            [
              -10625.016,
              4717.939,
              12068.965
            ],
            [
              -10404.928,
              4715.562,
              12289.066
            ],
            [
              -10343.026,
              4711.239,
              12351.119
            ],
            [
              -10142.866,
              4673.545,
              12554.797
            ],
            [
              -10106.797,
              4668.517,
              12591.215
            ],
            [
              -10049.863,
              4676.514,
              12648.708
            ],
            [
              -10001.283,
              4686.87,
              12698.379
            ],
            [
              -9954.065,
              4692.795,
              12745.968
            ],
            [
              -9954.87,
              4682.79,
              12756.006
            ],
            [
              -9971.053,
              4639.635,
              12802.095
            ],
            [
              -9996.31,
              4634.472,
              12827.875
            ],
            [
              -10015.813,
              4625.879,
              12849.187
            ],
            [
              -10037.72,
              4628.455,
              12871.244
            ],
            [
              -10042.829,
              4631.876,
              12877.394
            ],
            [
              -10045.914,
              4640.83,
              12886.864
            ],
            [
              -10043.084,
              4656.369,
              12902.659
            ],
            [
              -10039.034,
              4667.436,
              12914.444
            ],
            [
              -10033.119,
              4674.021,
              12923.295
            ],
            [
              -9847.833,
              4715.586,
              13113.186
            ],
            [
              -9780.287,
              4741.22,
              13185.433
            ],
            [
              -9738.284,
              4743.887,
              13227.52
            ],
            [
              -9619.286,
              4757.562,
              13347.302
            ],
            [
              -9574.594,
              4766.863,
              13392.951
            ],
            [
              -9511.688,
              4784.775,
              13458.357
            ],
            [
              -9185.609,
              4829.613,
              13787.505
            ],
            [
              -9175.58,
              5010.897,
              13969.067
            ],
            [
              -9167.098,
              5056.4,
              14015.353
            ],
            [
              -9158.902,
              5124.171,
              14083.618
            ],
            [
              -9120.102,
              5527.623,
              14488.931
            ],
            [
              -9120.138,
              5525.397,
              14491.157
            ],
            [
              -9105.787,
              5654.292,
              14620.849
            ],
            [
              -9088.239,
              5861.057,
              14828.357
            ],
            [
              -9065.832,
              6048.82,
              15017.452
            ],
            [
              -9042.56,
              6290,
              15259.752
            ],
            [
              -9035.69,
              6315.492,
              15286.153
            ],
            [
              -9027.745,
              6327.608,
              15300.642
            ],
            [
              -9013.989,
              6339.63,
              15318.911
            ],
            [
              -8763.039,
              6403.466,
              15577.853
            ],
            [
              -8591.391,
              6435.185,
              15752.407
            ],
            [
              -8565.567,
              6434.764,
              15778.235
            ],
            [
              -8514.008,
              6428.359,
              15830.19
            ],
            [
              -8481.082,
              6427.822,
              15863.12
            ],
            [
              -8464.869,
              6432.011,
              15879.865
            ],
            [
              -8454.412,
              6439.632,
              15892.805
            ],
            [
              -8442.7,
              6445.007,
              15905.691
            ],
            [
              -8405.319,
              6480.019,
              15956.908
            ],
            [
              -8381.214,
              6492.984,
              15984.279
            ],
            [
              -8346.332,
              6493.528,
              16019.165
            ],
            [
              -8332.81,
              6491.081,
              16032.907
            ],
            [
              -8313.605,
              6480.748,
              16054.715
            ],
            [
              -8257.445,
              6439.757,
              16124.244
            ],
            [
              -8216.781,
              6399.018,
              16181.804
            ],
            [
              -8090.106,
              6365.775,
              16312.768
            ],
            [
              -8047.971,
              6336.143,
              16364.28
            ],
            [
              -7869.852,
              6289.806,
              16548.327
            ],
            [
              -7783.654,
              6269.464,
              16636.893
            ],
            [
              -7104.955,
              6152.496,
              17325.597
            ],
            [
              -7039.365,
              6135.823,
              17393.273
            ],
            [
              -6990.505,
              6122.766,
              17443.848
            ],
            [
              -6923.128,
              6097.155,
              17515.929
            ],
            [
              -6819.933,
              6050.909,
              17629.012
            ],
            [
              -6722.128,
              5991.393,
              17743.502
            ],
            [
              -6610.439,
              6453.723,
              18219.132
            ],
            [
              -6615.859,
              6477.191,
              18243.217
            ],
            [
              -6611.247,
              6482.68,
              18250.387
            ],
            [
              -6601.507,
              6485.856,
              18260.632
            ],
            [
              -6595.808,
              6479.082,
              18269.485
            ],
            [
              -6595.901,
              6473.518,
              18275.05
            ],
            [
              -6598.614,
              6465.771,
              18283.258
            ],
            [
              -6609.831,
              6451.487,
              18301.42
            ],
            [
              -6653.627,
              6265.205,
              18492.781
            ],
            [
              -6722.128,
              5991.393,
              18775.032
            ],
            [
              -6663.331,
              5954.79,
              18844.29
            ],
            [
              -6413.106,
              5704.591,
              19198.143
            ],
            [
              -6357.16,
              5652.447,
              19274.622
            ],
            [
              -6334.791,
              5638.714,
              19300.871
            ],
            [
              -6315.93,
              5608.341,
              19336.623
            ],
            [
              -6284.365,
              5565.511,
              19389.828
            ],
            [
              -6235.578,
              5510.146,
              19463.622
            ],
            [
              -6210.778,
              5487.465,
              19497.229
            ],
            [
              -6170.561,
              5460.073,
              19545.888
            ],
            [
              -6118.615,
              5439.162,
              19601.885
            ],
            [
              -6089.662,
              5433.109,
              19631.464
            ],
            [
              -6052.281,
              5429.14,
              19669.055
            ],
            [
              -6005.048,
              5435.024,
              19716.653
            ],
            [
              -5948.573,
              5452.996,
              19775.919
            ],
            [
              -5873.554,
              5498.484,
              19863.651
            ],
            [
              -5789.253,
              5558.286,
              19967.01
            ],
            [
              -5728.563,
              5596.222,
              20038.58
            ],
            [
              -5697.335,
              5610.165,
              20072.78
            ],
            [
              -5669.446,
              5617.486,
              20101.613
            ],
            [
              -5631.932,
              5621.303,
              20139.322
            ],
            [
              -5582.93,
              5617.134,
              20188.5
            ],
            [
              -5526.428,
              5598.366,
              20248.038
            ],
            [
              -5379.437,
              5509.043,
              20420.041
            ],
            [
              -4710.592,
              5090.204,
              21209.204
            ],
            [
              -4580.889,
              5011.17,
              21361.091
            ],
            [
              -4517.509,
              4980.025,
              21431.71
            ],
            [
              -4380.813,
              4857.45,
              21615.313
            ],
            [
              -4298.311,
              4774.766,
              21732.117
            ],
            [
              -4237.94,
              4719.179,
              21814.182
            ],
            [
              -4229.781,
              4705.68,
              21829.955
            ],
            [
              -4240.925,
              4695.853,
              21844.813
            ],
            [
              -4266.982,
              4719.679,
              21880.122
            ],
            [
              -4289.168,
              4743.439,
              21912.629
            ],
            [
              -4311.679,
              4748.279,
              21935.655
            ],
            [
              -4321.909,
              4754.022,
              21947.386
            ],
            [
              -4333.961,
              4766.474,
              21964.716
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:6318",
              "position": {
                "x": -4215.081,
                "z": 1256.734
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": -510,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:6319",
              "position": {
                "x": -4558.781,
                "z": 1414.051
              },
              "distanceAlongShapeM": 378.505,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 60,
              "departureOffsetSeconds": 60
            },
            {
              "stopId": "judu:stop:6320",
              "position": {
                "x": -4838.028,
                "z": 1606.973
              },
              "distanceAlongShapeM": 718.262,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:6309",
              "position": {
                "x": -6721.281,
                "z": 2678.551
              },
              "distanceAlongShapeM": 3229.039,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:6297",
              "position": {
                "x": -7611.222,
                "z": 3413.556
              },
              "distanceAlongShapeM": 4415.851,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:6294",
              "position": {
                "x": -8136.789,
                "z": 3831.848
              },
              "distanceAlongShapeM": 5108.971,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:6290",
              "position": {
                "x": -8674.97,
                "z": 4909.278
              },
              "distanceAlongShapeM": 6798.916,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:6282",
              "position": {
                "x": -9588.344,
                "z": 4754.839
              },
              "distanceAlongShapeM": 7725.681,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:6286",
              "position": {
                "x": -10003.374,
                "z": 4636.812
              },
              "distanceAlongShapeM": 8256.28,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            },
            {
              "stopId": "judu:stop:15829",
              "position": {
                "x": -10645.983,
                "z": 4820.681
              },
              "distanceAlongShapeM": 9113.651,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:15833",
              "position": {
                "x": -10816.008,
                "z": 5500.168
              },
              "distanceAlongShapeM": 9829.94,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:15837",
              "position": {
                "x": -10692.138,
                "z": 5943.473
              },
              "distanceAlongShapeM": 10545.72,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            },
            {
              "stopId": "judu:stop:15835",
              "position": {
                "x": -10886.221,
                "z": 5551.368
              },
              "distanceAlongShapeM": 11161.412,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            },
            {
              "stopId": "judu:stop:15831",
              "position": {
                "x": -10643.067,
                "z": 4841.785
              },
              "distanceAlongShapeM": 11943.811,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1560,
              "departureOffsetSeconds": 1560
            },
            {
              "stopId": "judu:stop:9626",
              "position": {
                "x": -10015.813,
                "z": 4625.879
              },
              "distanceAlongShapeM": 12849.187,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1680,
              "departureOffsetSeconds": 1680
            },
            {
              "stopId": "judu:stop:6283",
              "position": {
                "x": -9574.594,
                "z": 4766.863
              },
              "distanceAlongShapeM": 13392.951,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1740,
              "departureOffsetSeconds": 1740
            },
            {
              "stopId": "judu:stop:6278",
              "position": {
                "x": -9175.58,
                "z": 5010.897
              },
              "distanceAlongShapeM": 13969.067,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1800,
              "departureOffsetSeconds": 1800
            },
            {
              "stopId": "judu:stop:6276",
              "position": {
                "x": -9120.102,
                "z": 5527.623
              },
              "distanceAlongShapeM": 14488.931,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1860,
              "departureOffsetSeconds": 1860
            },
            {
              "stopId": "judu:stop:6273",
              "position": {
                "x": -9088.239,
                "z": 5861.057
              },
              "distanceAlongShapeM": 14828.357,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1920,
              "departureOffsetSeconds": 1920
            },
            {
              "stopId": "judu:stop:6271",
              "position": {
                "x": -8763.039,
                "z": 6403.466
              },
              "distanceAlongShapeM": 15577.853,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1980,
              "departureOffsetSeconds": 1980
            },
            {
              "stopId": "judu:stop:9776",
              "position": {
                "x": -8090.106,
                "z": 6365.775
              },
              "distanceAlongShapeM": 16312.768,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2100,
              "departureOffsetSeconds": 2100
            },
            {
              "stopId": "judu:stop:9967",
              "position": {
                "x": -6701.294,
                "z": 6078.986
              },
              "distanceAlongShapeM": 17833.539,
              "shapeOffsetM": 0.317,
              "arrivalOffsetSeconds": 2220,
              "departureOffsetSeconds": 2220
            },
            {
              "stopId": "judu:stop:357",
              "position": {
                "x": -6598.614,
                "z": 6465.771
              },
              "distanceAlongShapeM": 18283.258,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2280,
              "departureOffsetSeconds": 2280
            },
            {
              "stopId": "judu:stop:4410",
              "position": {
                "x": -6663.331,
                "z": 5954.79
              },
              "distanceAlongShapeM": 18844.29,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2340,
              "departureOffsetSeconds": 2340
            },
            {
              "stopId": "judu:stop:5731",
              "position": {
                "x": -6334.791,
                "z": 5638.714
              },
              "distanceAlongShapeM": 19300.871,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2400,
              "departureOffsetSeconds": 2400
            },
            {
              "stopId": "judu:stop:6850",
              "position": {
                "x": -4517.509,
                "z": 4980.025
              },
              "distanceAlongShapeM": 21431.71,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2580,
              "departureOffsetSeconds": 2580
            }
          ],
          "departuresSeconds": [
            19680,
            22620,
            26520,
            30000,
            33720,
            38280,
            42300,
            45660,
            49020,
            52500,
            56280,
            59400,
            64140,
            68580,
            72360,
            75900,
            79080,
            82740
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_bus_63",
      "sourceRouteId": "vilnius_bus_63",
      "mode": "bus",
      "shortName": "63",
      "longName": "Žvėrynas–Pilaitės pr.–Karveliškės",
      "color": "0073AC",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_bus_63:0",
          "sourceRouteId": "vilnius_bus_63",
          "sourceShapeId": "vilnius_bus_63_a-b",
          "directionId": 0,
          "headsign": "Karveliškės",
          "directionName": "Žvėrynas–Pilaitės pr.–Karveliškės",
          "mode": "bus",
          "routeShortName": "63",
          "routeLongName": "Žvėrynas–Pilaitės pr.–Karveliškės",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              -2130.743,
              -1067.44,
              0
            ],
            [
              -2108.809,
              -1065.561,
              22.014
            ],
            [
              -2072.667,
              -1084.451,
              62.795
            ],
            [
              -2070.025,
              -1103.286,
              81.814
            ],
            [
              -2072.195,
              -1109.627,
              88.516
            ],
            [
              -2142.708,
              -1122.847,
              160.258
            ],
            [
              -2159.624,
              -1131.453,
              179.237
            ],
            [
              -2184.705,
              -1155.271,
              213.825
            ],
            [
              -2202.716,
              -1161.859,
              233.003
            ],
            [
              -2224.67,
              -1163.697,
              255.034
            ],
            [
              -2246.137,
              -1174.448,
              279.043
            ],
            [
              -2255.963,
              -1183.18,
              292.188
            ],
            [
              -2262.447,
              -1185.292,
              299.007
            ],
            [
              -2339.674,
              -1177.245,
              376.653
            ],
            [
              -2392.506,
              -1175.197,
              429.524
            ],
            [
              -2433.855,
              -1180.032,
              471.155
            ],
            [
              -2474.658,
              -1190.444,
              513.266
            ],
            [
              -2521.496,
              -1214.107,
              565.742
            ],
            [
              -2594.45,
              -1256.235,
              649.986
            ],
            [
              -2624.997,
              -1270.168,
              683.56
            ],
            [
              -2680.78,
              -1289.223,
              742.508
            ],
            [
              -2710.565,
              -1296.491,
              773.167
            ],
            [
              -2777.752,
              -1304.214,
              840.796
            ],
            [
              -2815.153,
              -1304.669,
              878.2
            ],
            [
              -2855.028,
              -1301.32,
              918.216
            ],
            [
              -3099.309,
              -1258.49,
              1166.223
            ],
            [
              -3139.719,
              -1251.188,
              1207.287
            ],
            [
              -3159.719,
              -1247.413,
              1227.64
            ],
            [
              -3359.526,
              -1207.182,
              1431.457
            ],
            [
              -3495.953,
              -1192.555,
              1568.666
            ],
            [
              -3569.469,
              -1193.5,
              1642.188
            ],
            [
              -3626.266,
              -1196.964,
              1699.091
            ],
            [
              -3684.51,
              -1178.609,
              1760.158
            ],
            [
              -3714.349,
              -1169.288,
              1791.419
            ],
            [
              -3768.714,
              -1158.717,
              1846.802
            ],
            [
              -3858.305,
              -1156.194,
              1936.429
            ],
            [
              -4063.615,
              -1172.672,
              2142.399
            ],
            [
              -4237.967,
              -1188.581,
              2317.476
            ],
            [
              -4268.356,
              -1193.623,
              2348.28
            ],
            [
              -4296.043,
              -1199.905,
              2376.671
            ],
            [
              -4333.704,
              -1206.966,
              2414.988
            ],
            [
              -4364.15,
              -1215.347,
              2446.567
            ],
            [
              -4597.068,
              -1300.392,
              2694.525
            ],
            [
              -4637.998,
              -1318.612,
              2739.327
            ],
            [
              -4714.189,
              -1362.945,
              2827.478
            ],
            [
              -4755.992,
              -1394.51,
              2879.859
            ],
            [
              -4809.036,
              -1442.581,
              2951.445
            ],
            [
              -4835.962,
              -1480.117,
              2997.639
            ],
            [
              -5092.18,
              -1789.506,
              3399.347
            ],
            [
              -5145.16,
              -1834.242,
              3468.689
            ],
            [
              -5263.682,
              -1904.577,
              3606.509
            ],
            [
              -5341.696,
              -1943.323,
              3693.615
            ],
            [
              -5353.315,
              -1944.238,
              3705.27
            ],
            [
              -5858.685,
              -2210.618,
              4276.547
            ],
            [
              -5881.906,
              -2223.697,
              4303.197
            ],
            [
              -6049.087,
              -2302.022,
              4487.817
            ],
            [
              -6102.245,
              -2320.049,
              4543.948
            ],
            [
              -6166.945,
              -2334.543,
              4610.252
            ],
            [
              -6282.53,
              -2341.97,
              4726.076
            ],
            [
              -6377.159,
              -2339.91,
              4820.727
            ],
            [
              -6675.557,
              -2338.243,
              5119.129
            ],
            [
              -6743.953,
              -2341.19,
              5187.589
            ],
            [
              -6892.765,
              -2337.952,
              5336.436
            ],
            [
              -6953.492,
              -2340.887,
              5397.234
            ],
            [
              -7022.394,
              -2342.468,
              5466.154
            ],
            [
              -7057.945,
              -2347.242,
              5502.024
            ],
            [
              -7082.26,
              -2346.788,
              5526.343
            ],
            [
              -7159.459,
              -2329.054,
              5605.553
            ],
            [
              -7293.515,
              -2327.442,
              5739.619
            ],
            [
              -7577.175,
              -2332.143,
              6023.318
            ],
            [
              -7627.621,
              -2335.888,
              6073.903
            ],
            [
              -7864.838,
              -2344.091,
              6311.261
            ],
            [
              -7926.261,
              -2349.173,
              6372.894
            ],
            [
              -7948.158,
              -2353.805,
              6395.275
            ],
            [
              -8020.127,
              -2380.496,
              6472.035
            ],
            [
              -8196.744,
              -2459.97,
              6665.709
            ],
            [
              -8276.105,
              -2495.735,
              6752.757
            ],
            [
              -8768.854,
              -2723.349,
              7295.536
            ],
            [
              -8836.225,
              -2744.516,
              7366.154
            ],
            [
              -8885.999,
              -2753.725,
              7416.773
            ],
            [
              -9059.016,
              -2772.066,
              7590.76
            ],
            [
              -9106.213,
              -2781.319,
              7638.855
            ],
            [
              -9165.186,
              -2801.514,
              7701.19
            ],
            [
              -9383.037,
              -2882.593,
              7933.64
            ],
            [
              -9464.115,
              -2914.748,
              8020.861
            ],
            [
              -9640.43,
              -2978.63,
              8208.392
            ],
            [
              -9797.309,
              -3036.22,
              8375.508
            ],
            [
              -10065.643,
              -3136.927,
              8662.118
            ],
            [
              -10141.678,
              -3151.408,
              8739.519
            ],
            [
              -10178.872,
              -3153.948,
              8776.8
            ],
            [
              -10233.515,
              -3152.799,
              8831.455
            ],
            [
              -10324.141,
              -3137.995,
              8923.282
            ],
            [
              -10579.633,
              -3076.045,
              9186.177
            ],
            [
              -10703.26,
              -3048.499,
              9312.836
            ],
            [
              -10761.968,
              -3033.078,
              9373.535
            ],
            [
              -10849.933,
              -3012.762,
              9463.816
            ],
            [
              -10931.492,
              -2991.794,
              9548.027
            ],
            [
              -10947.218,
              -2982.866,
              9566.111
            ],
            [
              -10953.548,
              -2941.361,
              9608.096
            ],
            [
              -10963.569,
              -2916.65,
              9634.761
            ],
            [
              -10989.031,
              -2866.432,
              9691.066
            ],
            [
              -11031.385,
              -2812.543,
              9759.606
            ],
            [
              -11083.172,
              -2771.592,
              9825.628
            ],
            [
              -11131.081,
              -2737.822,
              9884.243
            ],
            [
              -11233.535,
              -2654.947,
              10016.02
            ],
            [
              -11321.574,
              -2556.717,
              10147.929
            ],
            [
              -11361.884,
              -2497.086,
              10219.906
            ],
            [
              -11384.956,
              -2447.744,
              10274.376
            ],
            [
              -11399.791,
              -2407.437,
              10317.326
            ],
            [
              -11406.46,
              -2380.617,
              10344.963
            ],
            [
              -11413.153,
              -2303.731,
              10422.14
            ],
            [
              -11414.047,
              -2248.031,
              10477.847
            ],
            [
              -11422.752,
              -2186.67,
              10539.822
            ],
            [
              -11430.832,
              -2167.619,
              10560.516
            ],
            [
              -11442.831,
              -2151.847,
              10580.333
            ],
            [
              -11462.924,
              -2130.214,
              10609.858
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:4898",
              "position": {
                "x": -2071.721,
                "z": -1082.918
              },
              "distanceAlongShapeM": 62.795,
              "shapeOffsetM": 1.801,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:7415",
              "position": {
                "x": -3140.52,
                "z": -1255.542
              },
              "distanceAlongShapeM": 1207.287,
              "shapeOffsetM": 4.427,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:4991",
              "position": {
                "x": -3688.025,
                "z": -1189.21
              },
              "distanceAlongShapeM": 1760.353,
              "shapeOffsetM": 11.167,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:4988",
              "position": {
                "x": -4294.993,
                "z": -1205.408
              },
              "distanceAlongShapeM": 2376.671,
              "shapeOffsetM": 5.602,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:8060",
              "position": {
                "x": -4834.84,
                "z": -1481.101
              },
              "distanceAlongShapeM": 2997.682,
              "shapeOffsetM": 1.492,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:7947",
              "position": {
                "x": -5880.858,
                "z": -2225.828
              },
              "distanceAlongShapeM": 4303.197,
              "shapeOffsetM": 2.374,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:7948",
              "position": {
                "x": -6282.493,
                "z": -2344.842
              },
              "distanceAlongShapeM": 4726.076,
              "shapeOffsetM": 2.873,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:7950",
              "position": {
                "x": -6743.953,
                "z": -2342.665
              },
              "distanceAlongShapeM": 5187.589,
              "shapeOffsetM": 1.475,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:8370",
              "position": {
                "x": -7627.546,
                "z": -2337.989
              },
              "distanceAlongShapeM": 6073.903,
              "shapeOffsetM": 2.103,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:19051",
              "position": {
                "x": -8274.722,
                "z": -2498.766
              },
              "distanceAlongShapeM": 6752.741,
              "shapeOffsetM": 3.331,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            },
            {
              "stopId": "judu:stop:7700",
              "position": {
                "x": -9462.876,
                "z": -2918.039
              },
              "distanceAlongShapeM": 8020.861,
              "shapeOffsetM": 3.517,
              "arrivalOffsetSeconds": 1560,
              "departureOffsetSeconds": 1560
            },
            {
              "stopId": "judu:stop:7702",
              "position": {
                "x": -10704.284,
                "z": -3052.916
              },
              "distanceAlongShapeM": 9312.836,
              "shapeOffsetM": 4.535,
              "arrivalOffsetSeconds": 1680,
              "departureOffsetSeconds": 1680
            },
            {
              "stopId": "judu:stop:7692",
              "position": {
                "x": -11463.119,
                "z": -2130.379
              },
              "distanceAlongShapeM": 10609.858,
              "shapeOffsetM": 0.255,
              "arrivalOffsetSeconds": 1800,
              "departureOffsetSeconds": 1800
            }
          ],
          "departuresSeconds": [
            19200,
            21900,
            24540,
            28020,
            32160,
            35700,
            38460,
            41160,
            43860,
            46560,
            49260,
            51960,
            54660,
            57360,
            60300,
            63300,
            66300,
            69540,
            73860,
            76860,
            79560,
            82260
          ]
        },
        {
          "id": "judu:pattern:vilnius_bus_63:1",
          "sourceRouteId": "vilnius_bus_63",
          "sourceShapeId": "vilnius_bus_63_b-a",
          "directionId": 1,
          "headsign": "Žvėrynas",
          "directionName": "Karveliškės–Pilaitės pr.–Žvėrynas",
          "mode": "bus",
          "routeShortName": "63",
          "routeLongName": "Žvėrynas–Pilaitės pr.–Karveliškės",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              -11462.924,
              -2130.214,
              0
            ],
            [
              -11478.411,
              -2111.865,
              24.011
            ],
            [
              -11480.134,
              -2105.622,
              30.488
            ],
            [
              -11475.703,
              -2092.64,
              44.205
            ],
            [
              -11472.09,
              -2090.228,
              48.549
            ],
            [
              -11468.504,
              -2087.83,
              52.863
            ],
            [
              -11465.848,
              -2122.331,
              87.466
            ],
            [
              -11425.819,
              -2173.152,
              152.158
            ],
            [
              -11418.217,
              -2194.003,
              174.352
            ],
            [
              -11414.7,
              -2230.348,
              210.867
            ],
            [
              -11412.144,
              -2326.093,
              306.645
            ],
            [
              -11405.187,
              -2385.54,
              366.498
            ],
            [
              -11386.165,
              -2442.699,
              426.739
            ],
            [
              -11371.434,
              -2476.272,
              463.402
            ],
            [
              -11333.536,
              -2538.718,
              536.448
            ],
            [
              -11267.786,
              -2619.9,
              640.916
            ],
            [
              -11241.612,
              -2645.328,
              677.409
            ],
            [
              -11206.517,
              -2676.655,
              724.451
            ],
            [
              -11034.876,
              -2809.528,
              941.513
            ],
            [
              -11016.777,
              -2826.731,
              966.483
            ],
            [
              -10987.947,
              -2868.318,
              1017.087
            ],
            [
              -10972.578,
              -2897.491,
              1050.06
            ],
            [
              -10950.739,
              -2949.855,
              1106.796
            ],
            [
              -10947.618,
              -2966.999,
              1124.221
            ],
            [
              -10946.62,
              -2978.784,
              1136.049
            ],
            [
              -10934.614,
              -2991.129,
              1153.268
            ],
            [
              -10910.966,
              -2996.533,
              1177.526
            ],
            [
              -10783.786,
              -3025.852,
              1308.042
            ],
            [
              -10408.881,
              -3117.721,
              1694.039
            ],
            [
              -10364.569,
              -3127.333,
              1739.382
            ],
            [
              -10252.859,
              -3148.583,
              1853.094
            ],
            [
              -10213.526,
              -3152.005,
              1892.576
            ],
            [
              -10132.906,
              -3147.727,
              1973.31
            ],
            [
              -10044.985,
              -3130.209,
              2062.959
            ],
            [
              -9814.167,
              -3042.628,
              2309.834
            ],
            [
              -9594.425,
              -2959.097,
              2544.917
            ],
            [
              -9481.578,
              -2918.851,
              2664.726
            ],
            [
              -9152.855,
              -2796.148,
              3015.603
            ],
            [
              -9059.566,
              -2770.297,
              3112.408
            ],
            [
              -8909.23,
              -2755.574,
              3263.463
            ],
            [
              -8882.796,
              -2754.89,
              3289.906
            ],
            [
              -8845.962,
              -2748.81,
              3327.238
            ],
            [
              -8768.872,
              -2724.462,
              3408.082
            ],
            [
              -8572.12,
              -2634.162,
              3624.566
            ],
            [
              -8422.08,
              -2563.144,
              3790.565
            ],
            [
              -8320.214,
              -2512.408,
              3904.367
            ],
            [
              -8261.042,
              -2485.729,
              3969.275
            ],
            [
              -7980.509,
              -2362.223,
              4275.792
            ],
            [
              -7940.983,
              -2349.516,
              4317.31
            ],
            [
              -7448.73,
              -2327.982,
              4810.034
            ],
            [
              -7201.882,
              -2323.377,
              5056.925
            ],
            [
              -7173.3,
              -2323.738,
              5085.509
            ],
            [
              -7097.84,
              -2344.551,
              5163.787
            ],
            [
              -7004.314,
              -2340.543,
              5257.398
            ],
            [
              -6921.18,
              -2340.332,
              5340.533
            ],
            [
              -6862.419,
              -2336.554,
              5399.415
            ],
            [
              -6640.332,
              -2313.345,
              5622.712
            ],
            [
              -6613.182,
              -2313.262,
              5649.862
            ],
            [
              -6575.914,
              -2315.423,
              5687.192
            ],
            [
              -6380.632,
              -2316.474,
              5882.477
            ],
            [
              -6294.875,
              -2314.577,
              5968.255
            ],
            [
              -6243.894,
              -2310.982,
              6019.363
            ],
            [
              -6220.641,
              -2308.034,
              6042.802
            ],
            [
              -6201.86,
              -2302.785,
              6062.303
            ],
            [
              -6169.955,
              -2294.517,
              6095.262
            ],
            [
              -6126.719,
              -2280.674,
              6140.659
            ],
            [
              -6104.034,
              -2273.265,
              6164.524
            ],
            [
              -5924.643,
              -2185.012,
              6364.448
            ],
            [
              -5877.169,
              -2160.211,
              6418.01
            ],
            [
              -5846.259,
              -2142.718,
              6453.526
            ],
            [
              -5795.942,
              -2121.511,
              6508.13
            ],
            [
              -5568.568,
              -2017.388,
              6758.211
            ],
            [
              -5236.974,
              -1850.486,
              7129.44
            ],
            [
              -5169.837,
              -1807.104,
              7209.373
            ],
            [
              -5127.302,
              -1769.981,
              7265.83
            ],
            [
              -5012.864,
              -1637.24,
              7441.09
            ],
            [
              -4831.761,
              -1414.361,
              7728.272
            ],
            [
              -4763.266,
              -1360.258,
              7815.557
            ],
            [
              -4704.75,
              -1314.599,
              7889.779
            ],
            [
              -4653.804,
              -1300.53,
              7942.632
            ],
            [
              -4405.208,
              -1203.507,
              8209.491
            ],
            [
              -4296.995,
              -1171.977,
              8322.203
            ],
            [
              -4246.587,
              -1162.091,
              8373.572
            ],
            [
              -4190.857,
              -1159.392,
              8429.367
            ],
            [
              -3912.052,
              -1135.777,
              8709.17
            ],
            [
              -3758.891,
              -1120.334,
              8863.108
            ],
            [
              -3704.617,
              -1115.802,
              8917.571
            ],
            [
              -3657.704,
              -1114.039,
              8964.517
            ],
            [
              -3599.031,
              -1113.947,
              9023.19
            ],
            [
              -3412.497,
              -1176.2,
              9219.838
            ],
            [
              -3355.367,
              -1190.556,
              9278.744
            ],
            [
              -3109.19,
              -1234.288,
              9528.775
            ],
            [
              -3070.013,
              -1242.306,
              9568.764
            ],
            [
              -2879.155,
              -1277.94,
              9762.92
            ],
            [
              -2839.273,
              -1283.094,
              9803.134
            ],
            [
              -2787.087,
              -1285.125,
              9855.359
            ],
            [
              -2748.376,
              -1283.58,
              9894.101
            ],
            [
              -2714.118,
              -1278.617,
              9928.717
            ],
            [
              -2670.7,
              -1266.023,
              9973.924
            ],
            [
              -2624.585,
              -1246.798,
              10023.886
            ],
            [
              -2499.949,
              -1183.085,
              10163.863
            ],
            [
              -2469.831,
              -1172.717,
              10195.716
            ],
            [
              -2418.716,
              -1162.489,
              10247.844
            ],
            [
              -2392.231,
              -1159.617,
              10274.484
            ],
            [
              -2246.137,
              -1174.448,
              10421.329
            ],
            [
              -2229.866,
              -1165.831,
              10439.741
            ],
            [
              -2190.996,
              -1155.388,
              10479.989
            ],
            [
              -2164.136,
              -1131.373,
              10516.02
            ],
            [
              -2142.708,
              -1122.847,
              10539.081
            ],
            [
              -2138.761,
              -1118.464,
              10544.98
            ],
            [
              -2144.773,
              -1093.867,
              10570.301
            ],
            [
              -2147.916,
              -1089.358,
              10575.797
            ],
            [
              -2139.925,
              -1075.028,
              10592.205
            ],
            [
              -2130.743,
              -1067.44,
              10604.117
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:4686",
              "position": {
                "x": -11439.329,
                "z": -2134.091
              },
              "distanceAlongShapeM": 113.113,
              "shapeOffsetM": 13.556,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:7703",
              "position": {
                "x": -10783.07,
                "z": -3022.726
              },
              "distanceAlongShapeM": 1308.038,
              "shapeOffsetM": 3.207,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:7701",
              "position": {
                "x": -9595.599,
                "z": -2955.975
              },
              "distanceAlongShapeM": 2544.917,
              "shapeOffsetM": 3.335,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:7699",
              "position": {
                "x": -8261.598,
                "z": -2484.51
              },
              "distanceAlongShapeM": 3969.269,
              "shapeOffsetM": 1.34,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:8371",
              "position": {
                "x": -7448.799,
                "z": -2325.363
              },
              "distanceAlongShapeM": 4810.034,
              "shapeOffsetM": 2.62,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:7951",
              "position": {
                "x": -6613.194,
                "z": -2309.232
              },
              "distanceAlongShapeM": 5649.862,
              "shapeOffsetM": 4.03,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            },
            {
              "stopId": "judu:stop:7949",
              "position": {
                "x": -6171.35,
                "z": -2289.941
              },
              "distanceAlongShapeM": 6095.059,
              "shapeOffsetM": 4.779,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:8069",
              "position": {
                "x": -5847.188,
                "z": -2140.681
              },
              "distanceAlongShapeM": 6453.526,
              "shapeOffsetM": 2.239,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:8934",
              "position": {
                "x": -4704.97,
                "z": -1314.122
              },
              "distanceAlongShapeM": 7889.779,
              "shapeOffsetM": 0.525,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:4989",
              "position": {
                "x": -4247.02,
                "z": -1152.802
              },
              "distanceAlongShapeM": 8373.589,
              "shapeOffsetM": 9.299,
              "arrivalOffsetSeconds": 1350,
              "departureOffsetSeconds": 1350
            },
            {
              "stopId": "judu:stop:7342",
              "position": {
                "x": -3705.284,
                "z": -1106.532
              },
              "distanceAlongShapeM": 8917.571,
              "shapeOffsetM": 9.294,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            },
            {
              "stopId": "judu:stop:7416",
              "position": {
                "x": -3108.49,
                "z": -1230.499
              },
              "distanceAlongShapeM": 9528.775,
              "shapeOffsetM": 3.854,
              "arrivalOffsetSeconds": 1560,
              "departureOffsetSeconds": 1560
            },
            {
              "stopId": "judu:stop:18480",
              "position": {
                "x": -2130.763,
                "z": -1067.398
              },
              "distanceAlongShapeM": 10604.117,
              "shapeOffsetM": 0.046,
              "arrivalOffsetSeconds": 1710,
              "departureOffsetSeconds": 1710
            }
          ],
          "departuresSeconds": [
            21840,
            24600,
            27360,
            31020,
            35100,
            38400,
            41100,
            43800,
            46500,
            49200,
            51900,
            54720,
            57420,
            60300,
            63300,
            66360,
            69420,
            72480,
            76380,
            79440,
            82200,
            85020
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_bus_65",
      "sourceRouteId": "vilnius_bus_65",
      "mode": "bus",
      "shortName": "65",
      "longName": "Ožkiniai–Naujieji Verkiai–Balsių g.–Pagubė",
      "color": "0073AC",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_bus_65:0",
          "sourceRouteId": "vilnius_bus_65",
          "sourceShapeId": "vilnius_bus_65_a-b",
          "directionId": 0,
          "headsign": "Pagubė",
          "directionName": "Ožkiniai–Naujieji Verkiai–Balsių g.–Pagubė",
          "mode": "bus",
          "routeShortName": "65",
          "routeLongName": "Ožkiniai–Naujieji Verkiai–Balsių g.–Pagubė",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              5520.61,
              -9017.818,
              0
            ],
            [
              5519.429,
              -9014.798,
              3.242
            ],
            [
              5505.197,
              -8992.248,
              29.908
            ],
            [
              5326.247,
              -8926.422,
              220.581
            ],
            [
              5182.572,
              -8866.308,
              376.325
            ],
            [
              5168.313,
              -8872.285,
              391.786
            ],
            [
              5160.604,
              -8872.519,
              399.498
            ],
            [
              5076.568,
              -8828.939,
              494.162
            ],
            [
              5012.471,
              -8809.005,
              561.288
            ],
            [
              4968.931,
              -8797.029,
              606.445
            ],
            [
              4931.204,
              -8784.053,
              646.341
            ],
            [
              4880.2,
              -8758.574,
              703.355
            ],
            [
              4856.05,
              -8742.521,
              732.353
            ],
            [
              4825.057,
              -8714.09,
              774.412
            ],
            [
              4777.893,
              -8656.401,
              848.926
            ],
            [
              4728.926,
              -8591.999,
              929.83
            ],
            [
              4682.36,
              -8536.549,
              1002.239
            ],
            [
              4628.135,
              -8477.613,
              1082.325
            ],
            [
              4600.957,
              -8451.483,
              1120.027
            ],
            [
              4586.831,
              -8437.799,
              1139.694
            ],
            [
              4567.846,
              -8420.344,
              1165.484
            ],
            [
              4546.157,
              -8405.183,
              1191.946
            ],
            [
              4510.524,
              -8392.227,
              1229.862
            ],
            [
              4492.353,
              -8387.965,
              1248.525
            ],
            [
              4467.148,
              -8379.883,
              1274.995
            ],
            [
              4439.766,
              -8365.3,
              1306.018
            ],
            [
              4420.491,
              -8357.701,
              1326.737
            ],
            [
              4405.819,
              -8355.324,
              1341.6
            ],
            [
              4381.945,
              -8358.205,
              1365.647
            ],
            [
              4345.688,
              -8370.933,
              1404.073
            ],
            [
              4332.5,
              -8379.937,
              1420.043
            ],
            [
              4322.04,
              -8388.183,
              1433.362
            ],
            [
              4307.749,
              -8400.197,
              1452.032
            ],
            [
              4285.169,
              -8414.479,
              1478.749
            ],
            [
              4240.89,
              -8428.971,
              1525.34
            ],
            [
              4219.669,
              -8433.573,
              1547.053
            ],
            [
              4195.673,
              -8437.01,
              1571.295
            ],
            [
              4153.116,
              -8440.647,
              1614.007
            ],
            [
              4115.601,
              -8449.947,
              1652.657
            ],
            [
              4092.822,
              -8462.87,
              1678.847
            ],
            [
              4075.09,
              -8480.896,
              1704.132
            ],
            [
              4049.534,
              -8518.246,
              1749.388
            ],
            [
              4035.736,
              -8545.189,
              1779.66
            ],
            [
              4019.792,
              -8563.196,
              1803.711
            ],
            [
              4006.261,
              -8569.857,
              1818.793
            ],
            [
              3907.209,
              -8575.097,
              1917.983
            ],
            [
              3890.393,
              -8579.229,
              1935.299
            ],
            [
              3862.489,
              -8590.941,
              1965.561
            ],
            [
              3754.733,
              -8645.605,
              2086.39
            ],
            [
              3743.765,
              -8657.807,
              2102.797
            ],
            [
              3728.98,
              -8671.887,
              2123.213
            ],
            [
              3699.345,
              -8706.946,
              2169.12
            ],
            [
              3684.368,
              -8682.169,
              2198.071
            ],
            [
              3676.824,
              -8665.158,
              2216.68
            ],
            [
              3654.394,
              -8633.726,
              2255.295
            ],
            [
              3621.201,
              -8585.223,
              2314.068
            ],
            [
              3606.987,
              -8520.382,
              2380.449
            ],
            [
              3592.728,
              -8448.098,
              2454.125
            ],
            [
              3584.164,
              -8408.736,
              2494.409
            ],
            [
              3574.594,
              -8378.154,
              2526.453
            ],
            [
              3571.967,
              -8364.97,
              2539.896
            ],
            [
              3567.073,
              -8351.518,
              2554.211
            ],
            [
              3552.201,
              -8321.176,
              2588.001
            ],
            [
              3359.808,
              -8050.871,
              2919.784
            ],
            [
              3341.773,
              -8024.21,
              2951.973
            ],
            [
              3325.537,
              -8018.182,
              2969.292
            ],
            [
              3323.985,
              -8017.397,
              2971.03
            ],
            [
              3332.021,
              -8004.119,
              2986.55
            ],
            [
              3332.157,
              -8004.43,
              2986.889
            ],
            [
              3336.682,
              -8008.702,
              2993.112
            ],
            [
              3345.354,
              -8026.679,
              3013.072
            ],
            [
              3568.451,
              -8347.05,
              3403.469
            ],
            [
              3574.519,
              -8365.263,
              3422.666
            ],
            [
              3609.673,
              -8536.186,
              3597.166
            ],
            [
              3619.121,
              -8575.453,
              3637.554
            ],
            [
              3634.976,
              -8605.524,
              3671.549
            ],
            [
              3680.507,
              -8672.103,
              3752.207
            ],
            [
              3688.037,
              -8689.423,
              3771.093
            ],
            [
              3699.345,
              -8706.946,
              3791.949
            ],
            [
              3679.595,
              -8729.948,
              3822.266
            ],
            [
              3635.761,
              -8764.672,
              3878.188
            ],
            [
              3590.263,
              -8795.162,
              3932.957
            ],
            [
              3552.411,
              -8834.756,
              3987.734
            ],
            [
              3546.154,
              -8842.211,
              3997.466
            ],
            [
              3495.433,
              -8902.337,
              4076.128
            ],
            [
              3482.225,
              -8919.898,
              4098.102
            ],
            [
              3437.527,
              -9002.543,
              4192.06
            ],
            [
              3414.033,
              -9053.306,
              4247.996
            ],
            [
              3395.857,
              -9095.265,
              4293.723
            ],
            [
              3389.04,
              -9118.937,
              4318.357
            ],
            [
              3385.695,
              -9124.974,
              4325.259
            ],
            [
              3381.867,
              -9129.145,
              4330.92
            ],
            [
              3367.199,
              -9135.86,
              4347.052
            ],
            [
              3346.552,
              -9141.844,
              4368.549
            ],
            [
              3336.168,
              -9145.58,
              4379.585
            ],
            [
              3286.5,
              -9183.155,
              4441.864
            ],
            [
              3262.827,
              -9237.085,
              4500.762
            ],
            [
              3255.081,
              -9255.128,
              4520.397
            ],
            [
              3242.316,
              -9272.416,
              4541.887
            ],
            [
              3134.577,
              -9330.771,
              4664.415
            ],
            [
              3165.86,
              -9378.122,
              4721.166
            ],
            [
              3173.134,
              -9395.181,
              4739.712
            ],
            [
              3208.182,
              -9555.935,
              4904.242
            ],
            [
              3213.698,
              -9570.512,
              4919.827
            ],
            [
              3220.466,
              -9581.843,
              4933.026
            ],
            [
              3233.82,
              -9595.386,
              4952.045
            ],
            [
              3263.762,
              -9611.54,
              4986.067
            ],
            [
              3404.645,
              -9675.718,
              5140.879
            ],
            [
              3447.994,
              -9704.103,
              5192.695
            ],
            [
              3478.945,
              -9734.751,
              5236.252
            ],
            [
              3511.635,
              -9775.451,
              5288.455
            ],
            [
              3546.778,
              -9856.276,
              5376.59
            ],
            [
              3563.744,
              -9877.752,
              5403.959
            ],
            [
              3583.678,
              -9891.979,
              5428.449
            ],
            [
              3682.485,
              -9978.543,
              5559.811
            ],
            [
              3753.117,
              -10037.223,
              5651.639
            ],
            [
              3823.892,
              -10096.649,
              5744.054
            ],
            [
              3844.831,
              -10118.191,
              5774.095
            ],
            [
              3858.592,
              -10138.8,
              5798.876
            ],
            [
              3926.673,
              -10148.641,
              5867.664
            ],
            [
              3939.417,
              -10136.766,
              5885.084
            ],
            [
              3958.891,
              -10112.407,
              5916.27
            ],
            [
              3976.899,
              -10082.83,
              5950.897
            ],
            [
              4005.248,
              -10076.848,
              5979.87
            ],
            [
              4078.036,
              -10076.185,
              6052.662
            ],
            [
              4616.869,
              -10074.981,
              6591.496
            ],
            [
              4852.261,
              -10074.019,
              6826.89
            ],
            [
              4900.288,
              -10073.896,
              6874.917
            ],
            [
              4837.14,
              -10286.278,
              7096.488
            ],
            [
              5053.096,
              -10366.148,
              7326.741
            ],
            [
              5067.726,
              -10355.898,
              7344.604
            ],
            [
              5062.5,
              -10367.629,
              7357.445
            ],
            [
              4896.095,
              -10309.333,
              7533.766
            ],
            [
              4833.28,
              -10286.204,
              7600.704
            ],
            [
              4729.917,
              -10573.66,
              7906.179
            ],
            [
              4712.27,
              -10627.858,
              7963.177
            ],
            [
              4697.985,
              -10669.421,
              8007.126
            ],
            [
              4668.42,
              -10726.105,
              8071.057
            ],
            [
              4648.672,
              -10748.94,
              8101.247
            ],
            [
              4626.349,
              -10769.747,
              8131.763
            ],
            [
              4582.524,
              -10800.967,
              8185.572
            ],
            [
              4520.59,
              -10827.778,
              8253.06
            ],
            [
              4504.183,
              -10834.24,
              8270.693
            ],
            [
              4278.9,
              -10923.384,
              8512.973
            ],
            [
              4292.187,
              -10951.534,
              8544.101
            ],
            [
              4288.547,
              -10964.423,
              8557.494
            ],
            [
              4278.53,
              -10972.614,
              8570.433
            ],
            [
              4430.258,
              -11265.092,
              8899.925
            ],
            [
              4428.478,
              -11261.671,
              8903.781
            ],
            [
              4494.067,
              -11389.215,
              9047.2
            ],
            [
              4505.917,
              -11412.438,
              9073.273
            ],
            [
              4520.389,
              -11456.081,
              9119.252
            ],
            [
              4522.05,
              -11479.25,
              9142.481
            ],
            [
              4511.95,
              -11539.696,
              9203.765
            ],
            [
              4490.708,
              -11638.294,
              9304.625
            ],
            [
              4485.489,
              -11662.153,
              9329.048
            ],
            [
              4441.273,
              -11862.841,
              9534.549
            ],
            [
              4401.77,
              -12054.136,
              9729.881
            ],
            [
              4294.404,
              -12542.458,
              10229.866
            ],
            [
              4281.58,
              -12608.954,
              10297.587
            ],
            [
              4283.669,
              -12632.427,
              10321.153
            ],
            [
              4287.952,
              -12642.541,
              10332.137
            ],
            [
              4315.183,
              -12687.635,
              10384.815
            ],
            [
              4318.714,
              -12695.257,
              10393.215
            ],
            [
              4315.194,
              -12698.717,
              10398.151
            ],
            [
              4303.532,
              -12697.415,
              10409.886
            ],
            [
              4266.282,
              -12693.945,
              10447.296
            ],
            [
              4245.373,
              -12688.354,
              10468.94
            ],
            [
              4230.109,
              -12687.139,
              10484.253
            ],
            [
              4221.712,
              -12680.642,
              10494.87
            ],
            [
              4210.448,
              -12666.133,
              10513.237
            ],
            [
              4191.957,
              -12640.414,
              10544.914
            ],
            [
              4183.797,
              -12638.21,
              10553.366
            ],
            [
              4172.181,
              -12644.813,
              10566.727
            ],
            [
              4135.313,
              -12658.045,
              10605.898
            ],
            [
              4112.642,
              -12655.931,
              10628.668
            ],
            [
              3804.962,
              -12592.31,
              10942.856
            ],
            [
              3508.49,
              -12519.29,
              11248.188
            ],
            [
              3445.773,
              -12503.788,
              11312.793
            ],
            [
              3347.961,
              -12482.788,
              11412.833
            ],
            [
              3327.491,
              -12480.634,
              11433.417
            ],
            [
              3104.605,
              -12787.154,
              11812.406
            ],
            [
              3088.168,
              -12816.573,
              11846.105
            ],
            [
              3078.426,
              -12839.591,
              11871.1
            ],
            [
              3045.608,
              -12909.414,
              11948.251
            ],
            [
              3013.589,
              -12980.414,
              12026.138
            ],
            [
              2975.61,
              -13068.357,
              12121.931
            ],
            [
              2927.996,
              -13174.635,
              12238.387
            ],
            [
              2895.975,
              -13168.831,
              12270.93
            ],
            [
              2885.018,
              -13163.727,
              12283.017
            ],
            [
              2731.33,
              -13131.645,
              12440.018
            ],
            [
              2573.884,
              -13091.936,
              12602.394
            ],
            [
              2529.653,
              -13084.423,
              12647.259
            ],
            [
              2498.839,
              -13081.615,
              12678.2
            ],
            [
              2418.043,
              -13103.473,
              12761.901
            ],
            [
              2389.872,
              -13115.555,
              12792.553
            ],
            [
              2353.983,
              -13124.533,
              12829.548
            ],
            [
              2309.167,
              -13141.263,
              12877.385
            ],
            [
              2241.642,
              -13182.538,
              12956.526
            ],
            [
              2197.303,
              -13215.104,
              13011.539
            ],
            [
              2159.559,
              -13238.887,
              13056.152
            ],
            [
              2125.632,
              -13264.969,
              13098.945
            ],
            [
              2055.703,
              -13324.888,
              13191.034
            ],
            [
              2012.342,
              -13372.37,
              13255.336
            ],
            [
              2001.495,
              -13378.761,
              13267.926
            ],
            [
              1996.634,
              -13374.957,
              13274.098
            ],
            [
              1996.316,
              -13370.509,
              13278.557
            ],
            [
              1998.223,
              -13360.031,
              13289.208
            ],
            [
              2011.643,
              -13348.731,
              13306.751
            ],
            [
              2019.879,
              -13345.04,
              13315.776
            ],
            [
              2017.858,
              -13346.071,
              13318.045
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:1144",
              "position": {
                "x": 5527.927,
                "z": -9014.957
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 7.857,
              "arrivalOffsetSeconds": -360,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:6821",
              "position": {
                "x": 5122.326,
                "z": -8853.439
              },
              "distanceAlongShapeM": 442.263,
              "shapeOffsetM": 0.684,
              "arrivalOffsetSeconds": 60,
              "departureOffsetSeconds": 60
            },
            {
              "stopId": "judu:stop:6819",
              "position": {
                "x": 4583.775,
                "z": -8441.133
              },
              "distanceAlongShapeM": 1139.569,
              "shapeOffsetM": 4.521,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:6817",
              "position": {
                "x": 4220.749,
                "z": -8438.604
              },
              "distanceAlongShapeM": 1547.053,
              "shapeOffsetM": 5.146,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:6814",
              "position": {
                "x": 3573.643,
                "z": -8378.361
              },
              "distanceAlongShapeM": 2526.453,
              "shapeOffsetM": 0.973,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:738",
              "position": {
                "x": 3339.773,
                "z": -8015.44
              },
              "distanceAlongShapeM": 3000.524,
              "shapeOffsetM": 0.144,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:1064",
              "position": {
                "x": 3556.685,
                "z": -8322.375
              },
              "distanceAlongShapeM": 3376.496,
              "shapeOffsetM": 4.446,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:6811",
              "position": {
                "x": 3548.675,
                "z": -8844.347
              },
              "distanceAlongShapeM": 3997.473,
              "shapeOffsetM": 3.304,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:6809",
              "position": {
                "x": 3346.691,
                "z": -9142.201
              },
              "distanceAlongShapeM": 4368.515,
              "shapeOffsetM": 0.381,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:6856",
              "position": {
                "x": 3684.789,
                "z": -9975.801
              },
              "distanceAlongShapeM": 5559.738,
              "shapeOffsetM": 3.581,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:10554",
              "position": {
                "x": 3850.114,
                "z": -10113.666
              },
              "distanceAlongShapeM": 5774.095,
              "shapeOffsetM": 6.956,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:9046",
              "position": {
                "x": 4200.33,
                "z": -10072.504
              },
              "distanceAlongShapeM": 6174.964,
              "shapeOffsetM": 3.408,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            },
            {
              "stopId": "judu:stop:9048",
              "position": {
                "x": 4616.81,
                "z": -10066.046
              },
              "distanceAlongShapeM": 6591.457,
              "shapeOffsetM": 8.935,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:15114",
              "position": {
                "x": 4852.251,
                "z": -10070.594
              },
              "distanceAlongShapeM": 6826.89,
              "shapeOffsetM": 3.425,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:9081",
              "position": {
                "x": 5073.204,
                "z": -10357.647
              },
              "distanceAlongShapeM": 7344.604,
              "shapeOffsetM": 5.75,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:16870",
              "position": {
                "x": 4715.978,
                "z": -10629.055
              },
              "distanceAlongShapeM": 7963.167,
              "shapeOffsetM": 3.897,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            },
            {
              "stopId": "judu:stop:9053",
              "position": {
                "x": 4522.866,
                "z": -10833.513
              },
              "distanceAlongShapeM": 8253.06,
              "shapeOffsetM": 6.17,
              "arrivalOffsetSeconds": 1380,
              "departureOffsetSeconds": 1380
            },
            {
              "stopId": "judu:stop:8315",
              "position": {
                "x": 4289.98,
                "z": -10965.964
              },
              "distanceAlongShapeM": 8557.494,
              "shapeOffsetM": 2.104,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            },
            {
              "stopId": "judu:stop:8004",
              "position": {
                "x": 4493.832,
                "z": -11638.971
              },
              "distanceAlongShapeM": 9304.625,
              "shapeOffsetM": 3.197,
              "arrivalOffsetSeconds": 1560,
              "departureOffsetSeconds": 1560
            },
            {
              "stopId": "judu:stop:8005",
              "position": {
                "x": 4404.772,
                "z": -12054.736
              },
              "distanceAlongShapeM": 9729.861,
              "shapeOffsetM": 3.061,
              "arrivalOffsetSeconds": 1620,
              "departureOffsetSeconds": 1620
            },
            {
              "stopId": "judu:stop:8006",
              "position": {
                "x": 4295.286,
                "z": -12697.221
              },
              "distanceAlongShapeM": 10418.114,
              "shapeOffsetM": 0.572,
              "arrivalOffsetSeconds": 1680,
              "departureOffsetSeconds": 1680
            },
            {
              "stopId": "judu:stop:10552",
              "position": {
                "x": 3803.923,
                "z": -12596.508
              },
              "distanceAlongShapeM": 10942.861,
              "shapeOffsetM": 4.325,
              "arrivalOffsetSeconds": 1800,
              "departureOffsetSeconds": 1800
            },
            {
              "stopId": "judu:stop:8008",
              "position": {
                "x": 3507.545,
                "z": -12522.939
              },
              "distanceAlongShapeM": 11248.23,
              "shapeOffsetM": 3.77,
              "arrivalOffsetSeconds": 1860,
              "departureOffsetSeconds": 1860
            },
            {
              "stopId": "judu:stop:8009",
              "position": {
                "x": 3081.528,
                "z": -12841.03
              },
              "distanceAlongShapeM": 11871.1,
              "shapeOffsetM": 3.419,
              "arrivalOffsetSeconds": 1980,
              "departureOffsetSeconds": 1980
            },
            {
              "stopId": "judu:stop:8363",
              "position": {
                "x": 2895.887,
                "z": -13169.269
              },
              "distanceAlongShapeM": 12270.93,
              "shapeOffsetM": 0.446,
              "arrivalOffsetSeconds": 2040,
              "departureOffsetSeconds": 2040
            },
            {
              "stopId": "judu:stop:8012",
              "position": {
                "x": 2390.75,
                "z": -13118.545
              },
              "distanceAlongShapeM": 12792.553,
              "shapeOffsetM": 3.116,
              "arrivalOffsetSeconds": 2100,
              "departureOffsetSeconds": 2100
            },
            {
              "stopId": "judu:stop:8011",
              "position": {
                "x": 2018.624,
                "z": -13347.572
              },
              "distanceAlongShapeM": 13318.045,
              "shapeOffsetM": 1.685,
              "arrivalOffsetSeconds": 2160,
              "departureOffsetSeconds": 2160
            }
          ],
          "departuresSeconds": [
            21180,
            26640,
            33180,
            38580,
            43920,
            50040,
            56340,
            61320,
            66300
          ]
        },
        {
          "id": "judu:pattern:vilnius_bus_65:1",
          "sourceRouteId": "vilnius_bus_65",
          "sourceShapeId": "vilnius_bus_65_b-a",
          "directionId": 1,
          "headsign": "Ožkiniai",
          "directionName": "Pagubė–Balsių g.–Naujieji Verkiai–Ožkiniai",
          "mode": "bus",
          "routeShortName": "65",
          "routeLongName": "Ožkiniai–Naujieji Verkiai–Balsių g.–Pagubė",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              2017.858,
              -13346.071,
              0
            ],
            [
              2051.984,
              -13326.762,
              39.211
            ],
            [
              2126.959,
              -13262.768,
              137.783
            ],
            [
              2212.276,
              -13205.365,
              240.613
            ],
            [
              2263.128,
              -13168.469,
              303.44
            ],
            [
              2313.98,
              -13136.249,
              363.641
            ],
            [
              2386.334,
              -13114.009,
              439.335
            ],
            [
              2419.118,
              -13102.235,
              474.169
            ],
            [
              2473.705,
              -13084.482,
              531.571
            ],
            [
              2519.357,
              -13081.033,
              577.353
            ],
            [
              2533.441,
              -13082.364,
              591.5
            ],
            [
              2578.853,
              -13091.667,
              637.855
            ],
            [
              2628.295,
              -13105.208,
              689.117
            ],
            [
              2927.996,
              -13174.635,
              996.755
            ],
            [
              3093.974,
              -12804.056,
              1402.806
            ],
            [
              3103.184,
              -12789.293,
              1420.206
            ],
            [
              3181.127,
              -12681.111,
              1553.541
            ],
            [
              3223.253,
              -12619.485,
              1628.19
            ],
            [
              3249.211,
              -12579.253,
              1676.069
            ],
            [
              3292.751,
              -12522.008,
              1747.991
            ],
            [
              3314.158,
              -12494.871,
              1782.555
            ],
            [
              3325.61,
              -12480.559,
              1800.885
            ],
            [
              3351.885,
              -12483.289,
              1827.301
            ],
            [
              3457.661,
              -12505.485,
              1935.381
            ],
            [
              3764.574,
              -12581.452,
              2251.556
            ],
            [
              4112.642,
              -12655.931,
              2607.503
            ],
            [
              4128.878,
              -12657.2,
              2623.789
            ],
            [
              4153.045,
              -12653.796,
              2648.194
            ],
            [
              4185.354,
              -12636.396,
              2684.891
            ],
            [
              4190.961,
              -12637.325,
              2690.575
            ],
            [
              4219.012,
              -12675.834,
              2738.217
            ],
            [
              4225.367,
              -12683.033,
              2747.819
            ],
            [
              4234.678,
              -12687.693,
              2758.232
            ],
            [
              4250.357,
              -12687.839,
              2773.911
            ],
            [
              4258.816,
              -12687.218,
              2782.393
            ],
            [
              4272.356,
              -12672.821,
              2802.156
            ],
            [
              4333.648,
              -12356.237,
              3124.619
            ],
            [
              4384.004,
              -12131.153,
              3355.267
            ],
            [
              4416.375,
              -11975.39,
              3514.359
            ],
            [
              4488.674,
              -11647.682,
              3849.947
            ],
            [
              4501.985,
              -11574.76,
              3924.075
            ],
            [
              4516.791,
              -11515.839,
              3984.827
            ],
            [
              4521.863,
              -11468.205,
              4032.73
            ],
            [
              4516.342,
              -11439.013,
              4062.44
            ],
            [
              4472.42,
              -11347.991,
              4163.505
            ],
            [
              4286.766,
              -10988.625,
              4567.993
            ],
            [
              4280.398,
              -10976.279,
              4581.885
            ],
            [
              4289.134,
              -10959.804,
              4600.533
            ],
            [
              4289.359,
              -10949.359,
              4610.98
            ],
            [
              4279.795,
              -10926.803,
              4635.48
            ],
            [
              4282.474,
              -10921.288,
              4641.611
            ],
            [
              4545.72,
              -10816.141,
              4925.08
            ],
            [
              4560.877,
              -10808.935,
              4941.862
            ],
            [
              4606.823,
              -10783.921,
              4994.176
            ],
            [
              4645.916,
              -10751.621,
              5044.887
            ],
            [
              4702.29,
              -10658.775,
              5153.507
            ],
            [
              4767.333,
              -10475.321,
              5348.151
            ],
            [
              4834.832,
              -10283.879,
              5551.143
            ],
            [
              4885.039,
              -10305.018,
              5605.619
            ],
            [
              5018.07,
              -10353.942,
              5747.361
            ],
            [
              5042.124,
              -10362.324,
              5772.834
            ],
            [
              5067.726,
              -10355.898,
              5799.23
            ],
            [
              5061.006,
              -10368.904,
              5813.869
            ],
            [
              5026.912,
              -10355.636,
              5850.453
            ],
            [
              4837.27,
              -10288.031,
              6051.785
            ],
            [
              4899.661,
              -10076.829,
              6272.011
            ],
            [
              4160.977,
              -10076.356,
              7010.695
            ],
            [
              4078.036,
              -10076.185,
              7093.636
            ],
            [
              4005.248,
              -10076.848,
              7166.428
            ],
            [
              3980.716,
              -10084.256,
              7192.053
            ],
            [
              3969.224,
              -10095.225,
              7207.939
            ],
            [
              3948.343,
              -10125.564,
              7244.77
            ],
            [
              3935.258,
              -10140.984,
              7264.994
            ],
            [
              3926.621,
              -10148.536,
              7276.466
            ],
            [
              3926.646,
              -10148.59,
              7276.525
            ],
            [
              3858.592,
              -10138.8,
              7345.28
            ],
            [
              3836.085,
              -10112.757,
              7379.7
            ],
            [
              3633.404,
              -9936.97,
              7647.992
            ],
            [
              3615.583,
              -9923.348,
              7670.424
            ],
            [
              3583.925,
              -9891.609,
              7715.252
            ],
            [
              3560.012,
              -9871.001,
              7746.82
            ],
            [
              3541.801,
              -9847.275,
              7776.729
            ],
            [
              3514.661,
              -9785.528,
              7844.177
            ],
            [
              3500.953,
              -9761.888,
              7871.504
            ],
            [
              3482.098,
              -9738.151,
              7901.818
            ],
            [
              3456.873,
              -9710.952,
              7938.914
            ],
            [
              3423.2,
              -9688.046,
              7979.639
            ],
            [
              3388.156,
              -9669.567,
              8019.257
            ],
            [
              3277.145,
              -9618.474,
              8141.461
            ],
            [
              3240.19,
              -9598.846,
              8183.306
            ],
            [
              3228.737,
              -9591.949,
              8196.675
            ],
            [
              3213.634,
              -9573.85,
              8220.248
            ],
            [
              3206.315,
              -9552.559,
              8242.762
            ],
            [
              3171.376,
              -9392.699,
              8406.395
            ],
            [
              3134.577,
              -9330.771,
              8478.432
            ],
            [
              3236.064,
              -9273.693,
              8594.868
            ],
            [
              3253.13,
              -9256.204,
              8619.304
            ],
            [
              3311.292,
              -9133.842,
              8754.786
            ],
            [
              3320.671,
              -9127.698,
              8765.998
            ],
            [
              3331.475,
              -9128.156,
              8776.812
            ],
            [
              3357.15,
              -9132.675,
              8802.882
            ],
            [
              3379.116,
              -9129.458,
              8825.082
            ],
            [
              3431.482,
              -9015.787,
              8950.235
            ],
            [
              3481.86,
              -8920.42,
              9058.091
            ],
            [
              3564.268,
              -8816.728,
              9190.541
            ],
            [
              3592.707,
              -8793.227,
              9227.433
            ],
            [
              3664.561,
              -8741.908,
              9315.732
            ],
            [
              3699.345,
              -8706.946,
              9365.05
            ],
            [
              3684.368,
              -8682.169,
              9394.002
            ],
            [
              3676.824,
              -8665.158,
              9412.611
            ],
            [
              3654.394,
              -8633.726,
              9451.226
            ],
            [
              3621.201,
              -8585.223,
              9509.999
            ],
            [
              3606.987,
              -8520.382,
              9576.38
            ],
            [
              3592.728,
              -8448.098,
              9650.056
            ],
            [
              3584.164,
              -8408.736,
              9690.34
            ],
            [
              3574.594,
              -8378.154,
              9722.384
            ],
            [
              3571.967,
              -8364.97,
              9735.827
            ],
            [
              3567.073,
              -8351.518,
              9750.142
            ],
            [
              3552.201,
              -8321.176,
              9783.932
            ],
            [
              3359.808,
              -8050.871,
              10115.715
            ],
            [
              3341.773,
              -8024.21,
              10147.904
            ],
            [
              3325.537,
              -8018.182,
              10165.222
            ],
            [
              3323.985,
              -8017.397,
              10166.961
            ],
            [
              3332.021,
              -8004.119,
              10182.481
            ],
            [
              3332.157,
              -8004.43,
              10182.82
            ],
            [
              3336.682,
              -8008.702,
              10189.043
            ],
            [
              3345.354,
              -8026.679,
              10209.003
            ],
            [
              3568.451,
              -8347.05,
              10599.4
            ],
            [
              3574.519,
              -8365.263,
              10618.597
            ],
            [
              3609.673,
              -8536.186,
              10793.097
            ],
            [
              3619.121,
              -8575.453,
              10833.485
            ],
            [
              3634.976,
              -8605.524,
              10867.48
            ],
            [
              3680.507,
              -8672.103,
              10948.138
            ],
            [
              3688.037,
              -8689.423,
              10967.024
            ],
            [
              3699.345,
              -8706.946,
              10987.88
            ],
            [
              3741.483,
              -8657.653,
              11052.729
            ],
            [
              3791.647,
              -8626.326,
              11111.871
            ],
            [
              3858.43,
              -8593.949,
              11186.089
            ],
            [
              3887.776,
              -8581.405,
              11218.003
            ],
            [
              3917.526,
              -8574.181,
              11248.618
            ],
            [
              3985.821,
              -8571.035,
              11316.985
            ],
            [
              4016.066,
              -8565.813,
              11347.678
            ],
            [
              4061.23,
              -8499.002,
              11428.322
            ],
            [
              4079.588,
              -8475.88,
              11457.845
            ],
            [
              4100.028,
              -8456.328,
              11486.131
            ],
            [
              4149.92,
              -8439.472,
              11538.794
            ],
            [
              4184.09,
              -8436.788,
              11573.069
            ],
            [
              4222.829,
              -8430.851,
              11612.26
            ],
            [
              4244.13,
              -8425.409,
              11634.245
            ],
            [
              4256.682,
              -8422.131,
              11647.219
            ],
            [
              4281.731,
              -8414.17,
              11673.502
            ],
            [
              4307.127,
              -8399.072,
              11703.047
            ],
            [
              4322.986,
              -8387.44,
              11722.715
            ],
            [
              4331.249,
              -8380.938,
              11733.229
            ],
            [
              4352.772,
              -8368.777,
              11757.95
            ],
            [
              4394.858,
              -8356.227,
              11801.867
            ],
            [
              4421.06,
              -8357.912,
              11828.124
            ],
            [
              4446.557,
              -8368.229,
              11855.629
            ],
            [
              4495.699,
              -8388.884,
              11908.935
            ],
            [
              4552.908,
              -8406.026,
              11968.657
            ],
            [
              4579.526,
              -8427.332,
              12002.752
            ],
            [
              4608.532,
              -8455.23,
              12042.997
            ],
            [
              4628.178,
              -8475.387,
              12071.144
            ],
            [
              4654.054,
              -8503.195,
              12109.129
            ],
            [
              4667.185,
              -8518.508,
              12129.301
            ],
            [
              4715.091,
              -8575.032,
              12203.395
            ],
            [
              4821.282,
              -8709.564,
              12374.788
            ],
            [
              4857.98,
              -8742.558,
              12424.137
            ],
            [
              4880.2,
              -8758.574,
              12451.527
            ],
            [
              4910.764,
              -8775.864,
              12486.643
            ],
            [
              5190.153,
              -8866.294,
              12780.303
            ],
            [
              5208.974,
              -8874.36,
              12800.779
            ],
            [
              5230.504,
              -8884.717,
              12824.671
            ],
            [
              5276.882,
              -8907.565,
              12876.371
            ],
            [
              5409.355,
              -8951.657,
              13015.989
            ],
            [
              5528.995,
              -9001.002,
              13145.406
            ],
            [
              5547.749,
              -9009.245,
              13165.892
            ],
            [
              5550.39,
              -9011.334,
              13169.259
            ],
            [
              5548.453,
              -9010.483,
              13171.374
            ],
            [
              5523.638,
              -9025.775,
              13200.523
            ],
            [
              5522.595,
              -9022.95,
              13203.534
            ],
            [
              5520.61,
              -9017.818,
              13209.037
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:8011",
              "position": {
                "x": 2018.624,
                "z": -13347.572
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 1.685,
              "arrivalOffsetSeconds": -240,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:8016",
              "position": {
                "x": 2445.252,
                "z": -13092.852
              },
              "distanceAlongShapeM": 501.924,
              "shapeOffsetM": 0.84,
              "arrivalOffsetSeconds": 60,
              "departureOffsetSeconds": 60
            },
            {
              "stopId": "judu:stop:8367",
              "position": {
                "x": 2941.349,
                "z": -13145.637
              },
              "distanceAlongShapeM": 1028.677,
              "shapeOffsetM": 0.333,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:8017",
              "position": {
                "x": 3092.532,
                "z": -12803.387
              },
              "distanceAlongShapeM": 1402.806,
              "shapeOffsetM": 1.59,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:8018",
              "position": {
                "x": 3458.421,
                "z": -12501.964
              },
              "distanceAlongShapeM": 1935.381,
              "shapeOffsetM": 3.602,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:10551",
              "position": {
                "x": 3765.709,
                "z": -12576.851
              },
              "distanceAlongShapeM": 2251.703,
              "shapeOffsetM": 4.737,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:18426",
              "position": {
                "x": 4270.854,
                "z": -12663.353
              },
              "distanceAlongShapeM": 2811.167,
              "shapeOffsetM": 3.274,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:8021",
              "position": {
                "x": 4413.388,
                "z": -11974.746
              },
              "distanceAlongShapeM": 3514.359,
              "shapeOffsetM": 3.056,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:8022",
              "position": {
                "x": 4500.864,
                "z": -11574.536
              },
              "distanceAlongShapeM": 3924.075,
              "shapeOffsetM": 1.143,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:9798",
              "position": {
                "x": 4287.063,
                "z": -10950.322
              },
              "distanceAlongShapeM": 4609.968,
              "shapeOffsetM": 2.275,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:9054",
              "position": {
                "x": 4558.82,
                "z": -10804.147
              },
              "distanceAlongShapeM": 4942.345,
              "shapeOffsetM": 5.189,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:16832",
              "position": {
                "x": 4764.013,
                "z": -10474.123
              },
              "distanceAlongShapeM": 5348.176,
              "shapeOffsetM": 3.529,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:9081",
              "position": {
                "x": 5073.204,
                "z": -10357.647
              },
              "distanceAlongShapeM": 5799.23,
              "shapeOffsetM": 5.75,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:15113",
              "position": {
                "x": 4825.104,
                "z": -10076.748
              },
              "distanceAlongShapeM": 6346.568,
              "shapeOffsetM": 0.033,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:9047",
              "position": {
                "x": 4559.944,
                "z": -10078.309
              },
              "distanceAlongShapeM": 6611.727,
              "shapeOffsetM": 1.698,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:9045",
              "position": {
                "x": 4160.961,
                "z": -10078.428
              },
              "distanceAlongShapeM": 7010.707,
              "shapeOffsetM": 2.072,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:10556",
              "position": {
                "x": 3832.039,
                "z": -10116.66
              },
              "distanceAlongShapeM": 7380.2,
              "shapeOffsetM": 5.6,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:6857",
              "position": {
                "x": 3613.674,
                "z": -9925.461
              },
              "distanceAlongShapeM": 7670.424,
              "shapeOffsetM": 2.847,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            },
            {
              "stopId": "judu:stop:6808",
              "position": {
                "x": 3308.92,
                "z": -9131.464
              },
              "distanceAlongShapeM": 8754.786,
              "shapeOffsetM": 3.359,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            },
            {
              "stopId": "judu:stop:6810",
              "position": {
                "x": 3562.117,
                "z": -8814.544
              },
              "distanceAlongShapeM": 9190.541,
              "shapeOffsetM": 3.065,
              "arrivalOffsetSeconds": 1500,
              "departureOffsetSeconds": 1500
            },
            {
              "stopId": "judu:stop:6814",
              "position": {
                "x": 3573.643,
                "z": -8378.361
              },
              "distanceAlongShapeM": 9722.384,
              "shapeOffsetM": 0.973,
              "arrivalOffsetSeconds": 1620,
              "departureOffsetSeconds": 1620
            },
            {
              "stopId": "judu:stop:738",
              "position": {
                "x": 3339.773,
                "z": -8015.44
              },
              "distanceAlongShapeM": 10196.455,
              "shapeOffsetM": 0.144,
              "arrivalOffsetSeconds": 1680,
              "departureOffsetSeconds": 1680
            },
            {
              "stopId": "judu:stop:1064",
              "position": {
                "x": 3556.685,
                "z": -8322.375
              },
              "distanceAlongShapeM": 10572.427,
              "shapeOffsetM": 4.446,
              "arrivalOffsetSeconds": 1740,
              "departureOffsetSeconds": 1740
            },
            {
              "stopId": "judu:stop:6816",
              "position": {
                "x": 4242.992,
                "z": -8420.106
              },
              "distanceAlongShapeM": 11634.484,
              "shapeOffsetM": 5.419,
              "arrivalOffsetSeconds": 1860,
              "departureOffsetSeconds": 1860
            },
            {
              "stopId": "judu:stop:6818",
              "position": {
                "x": 4655.998,
                "z": -8501.529
              },
              "distanceAlongShapeM": 12109.13,
              "shapeOffsetM": 2.56,
              "arrivalOffsetSeconds": 1920,
              "departureOffsetSeconds": 1920
            },
            {
              "stopId": "judu:stop:6820",
              "position": {
                "x": 5211.507,
                "z": -8868.529
              },
              "distanceAlongShapeM": 12800.779,
              "shapeOffsetM": 6.358,
              "arrivalOffsetSeconds": 1980,
              "departureOffsetSeconds": 1980
            },
            {
              "stopId": "judu:stop:1144",
              "position": {
                "x": 5527.927,
                "z": -9014.957
              },
              "distanceAlongShapeM": 13191.196,
              "shapeOffsetM": 6.96,
              "arrivalOffsetSeconds": 2040,
              "departureOffsetSeconds": 2040
            }
          ],
          "departuresSeconds": [
            23700,
            29220,
            36240,
            40980,
            46920,
            54000,
            58860,
            63840,
            68880
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_bus_68",
      "sourceRouteId": "vilnius_bus_68",
      "mode": "bus",
      "shortName": "68",
      "longName": "Lazdynai–Mūrinė Vokė–Lentvaris–Grigiškės",
      "color": "0073AC",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_bus_68:0",
          "sourceRouteId": "vilnius_bus_68",
          "sourceShapeId": "vilnius_bus_68_a-b",
          "directionId": 0,
          "headsign": "Grigiškės",
          "directionName": "Lazdynai–Mūrinė Vokė–Lentvaris–Grigiškės",
          "mode": "bus",
          "routeShortName": "68",
          "routeLongName": "Lazdynai–Mūrinė Vokė–Lentvaris–Grigiškės",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              -4212.237,
              1261.595,
              0
            ],
            [
              -4241.916,
              1271.669,
              31.342
            ],
            [
              -4268.203,
              1281.028,
              59.245
            ],
            [
              -4527.979,
              1404.616,
              346.921
            ],
            [
              -4557.013,
              1417.363,
              378.63
            ],
            [
              -4581.673,
              1433.369,
              408.029
            ],
            [
              -4718.251,
              1519.203,
              569.34
            ],
            [
              -4836.63,
              1608.523,
              717.635
            ],
            [
              -4906.917,
              1690.529,
              825.641
            ],
            [
              -4961.39,
              1738.988,
              898.549
            ],
            [
              -5068.788,
              1878.386,
              1074.521
            ],
            [
              -5048.449,
              1896.102,
              1101.495
            ],
            [
              -4996.021,
              1950.314,
              1176.911
            ],
            [
              -4992.511,
              1966.952,
              1193.915
            ],
            [
              -4995.545,
              1978.136,
              1205.503
            ],
            [
              -5002.796,
              1985.46,
              1215.809
            ],
            [
              -5010.228,
              1987.292,
              1223.464
            ],
            [
              -5028.5,
              1986.124,
              1241.773
            ],
            [
              -5177.583,
              1934.489,
              1399.545
            ],
            [
              -5251.262,
              1926.839,
              1473.62
            ],
            [
              -5286.129,
              1925.207,
              1508.525
            ],
            [
              -5329.267,
              1930.394,
              1551.974
            ],
            [
              -5390.957,
              1944.801,
              1615.324
            ],
            [
              -5430.093,
              1957.712,
              1656.534
            ],
            [
              -5538.852,
              2011.879,
              1778.036
            ],
            [
              -5604.833,
              2039.715,
              1849.648
            ],
            [
              -5664.553,
              2056.312,
              1911.631
            ],
            [
              -6261.201,
              2179.926,
              2520.95
            ],
            [
              -6367.656,
              2218.449,
              2634.161
            ],
            [
              -6455.072,
              2276.688,
              2739.201
            ],
            [
              -6521.774,
              2339.031,
              2830.501
            ],
            [
              -6563.365,
              2394.508,
              2899.837
            ],
            [
              -6591.947,
              2443.085,
              2956.2
            ],
            [
              -6687.246,
              2630.115,
              3166.109
            ],
            [
              -6717.477,
              2680.464,
              3224.836
            ],
            [
              -6732.812,
              2722.158,
              3269.261
            ],
            [
              -6787.208,
              2826.592,
              3387.013
            ],
            [
              -6821.115,
              2882.817,
              3452.671
            ],
            [
              -6849.514,
              2921.139,
              3500.368
            ],
            [
              -6915.475,
              2990.142,
              3595.827
            ],
            [
              -6953.037,
              3020.824,
              3644.327
            ],
            [
              -7039.186,
              3079.03,
              3748.296
            ],
            [
              -7610.996,
              3413.943,
              4410.967
            ],
            [
              -7650.801,
              3439.813,
              4458.441
            ],
            [
              -7848.444,
              3561.767,
              4690.681
            ],
            [
              -7970.179,
              3640.989,
              4835.924
            ],
            [
              -8010.925,
              3675.053,
              4889.033
            ],
            [
              -8074.26,
              3748.448,
              4985.977
            ],
            [
              -8116.454,
              3811.486,
              5061.834
            ],
            [
              -8127.628,
              3839.491,
              5091.985
            ],
            [
              -8128.299,
              3835.847,
              5095.69
            ],
            [
              -8161.184,
              3958.037,
              5222.229
            ],
            [
              -8165.573,
              4030.047,
              5294.373
            ],
            [
              -8128.206,
              4592.005,
              5857.571
            ],
            [
              -8114.065,
              4903.462,
              6169.349
            ],
            [
              -8124.873,
              4913.657,
              6184.207
            ],
            [
              -8158.233,
              4926.449,
              6219.935
            ],
            [
              -8180.177,
              4926.808,
              6241.882
            ],
            [
              -8198.839,
              4930.453,
              6260.897
            ],
            [
              -8215.237,
              4954.098,
              6289.672
            ],
            [
              -8225.899,
              4980.834,
              6318.456
            ],
            [
              -8226.272,
              4989.9,
              6327.529
            ],
            [
              -8636.135,
              4917.748,
              6743.694
            ],
            [
              -8675.296,
              4911.261,
              6783.389
            ],
            [
              -9185.609,
              4829.613,
              7300.192
            ],
            [
              -9269.178,
              4812.099,
              7385.577
            ],
            [
              -9558.498,
              4764.394,
              7678.803
            ],
            [
              -9589.112,
              4759.224,
              7709.851
            ],
            [
              -9674.339,
              4746.201,
              7796.067
            ],
            [
              -9691.455,
              4743.771,
              7813.355
            ],
            [
              -9773.861,
              4743.124,
              7895.763
            ],
            [
              -9804.36,
              4735.568,
              7927.185
            ],
            [
              -9850.41,
              4713.616,
              7978.199
            ],
            [
              -10016.825,
              4682.325,
              8147.53
            ],
            [
              -10031.193,
              4679.585,
              8162.157
            ],
            [
              -10038.335,
              4678.223,
              8169.427
            ],
            [
              -10047.296,
              4676.514,
              8178.551
            ],
            [
              -10038.868,
              4637.378,
              8218.584
            ],
            [
              -10034.44,
              4631.742,
              8225.751
            ],
            [
              -10024.132,
              4630.464,
              8236.138
            ],
            [
              -10003.374,
              4636.812,
              8257.845
            ],
            [
              -9985.268,
              4638.749,
              8276.054
            ],
            [
              -9974.208,
              4644.138,
              8288.357
            ],
            [
              -9966.985,
              4651.815,
              8298.898
            ],
            [
              -9959.247,
              4692.767,
              8340.575
            ],
            [
              -9958.404,
              4692.919,
              8341.432
            ],
            [
              -9962.757,
              4692.137,
              8345.856
            ],
            [
              -10095.007,
              4671.583,
              8479.693
            ],
            [
              -10133.842,
              4672.325,
              8518.535
            ],
            [
              -10283.071,
              4700.857,
              8670.467
            ],
            [
              -10348.224,
              4709.095,
              8736.139
            ],
            [
              -10488.216,
              4714.658,
              8876.241
            ],
            [
              -10818.891,
              4706.234,
              9207.023
            ],
            [
              -10909.241,
              4705.733,
              9297.375
            ],
            [
              -11064.862,
              4702.619,
              9453.027
            ],
            [
              -11095.805,
              4705.332,
              9484.089
            ],
            [
              -11488.881,
              4904.293,
              9924.65
            ],
            [
              -11511.635,
              4924,
              9954.752
            ],
            [
              -11576.997,
              4969.33,
              10034.294
            ],
            [
              -11610.053,
              4990.002,
              10073.281
            ],
            [
              -11622.157,
              4995.601,
              10086.618
            ],
            [
              -11659.874,
              5002.475,
              10124.956
            ],
            [
              -11800.921,
              4983.669,
              10267.251
            ],
            [
              -11847.38,
              4982.248,
              10313.732
            ],
            [
              -11885.871,
              4999.317,
              10355.838
            ],
            [
              -11989.205,
              5112.771,
              10509.297
            ],
            [
              -12040.673,
              5174.26,
              10589.483
            ],
            [
              -12077.728,
              5199.324,
              10634.219
            ],
            [
              -12102.186,
              5204.156,
              10659.15
            ],
            [
              -13347.776,
              5148.424,
              11905.986
            ],
            [
              -13626.789,
              5136.945,
              12185.235
            ],
            [
              -13650.897,
              5135.748,
              12209.372
            ],
            [
              -13690.397,
              5133.292,
              12248.949
            ],
            [
              -13794.598,
              5118.154,
              12354.244
            ],
            [
              -13943.603,
              5093.714,
              12505.24
            ],
            [
              -14184.098,
              5055.163,
              12748.805
            ],
            [
              -14298.079,
              5052.66,
              12862.814
            ],
            [
              -14383.424,
              5062.308,
              12948.702
            ],
            [
              -14395.72,
              5063.993,
              12961.113
            ],
            [
              -14410.118,
              5065.966,
              12975.645
            ],
            [
              -14428.956,
              5069.325,
              12994.781
            ],
            [
              -14436.701,
              5069.441,
              13002.527
            ],
            [
              -14454.349,
              5067.084,
              13020.331
            ],
            [
              -14463.439,
              5063.165,
              13030.23
            ],
            [
              -14479.243,
              5048.44,
              13051.831
            ],
            [
              -14483.806,
              5038.824,
              13062.475
            ],
            [
              -14483.521,
              5018.194,
              13083.106
            ],
            [
              -14482.731,
              5013.361,
              13088.004
            ],
            [
              -14469.697,
              4996.436,
              13109.366
            ],
            [
              -14470.189,
              4988.684,
              13117.134
            ],
            [
              -14478.875,
              4980.407,
              13129.132
            ],
            [
              -14492.308,
              4981.368,
              13142.6
            ],
            [
              -14508.524,
              4993.191,
              13162.668
            ],
            [
              -14530.793,
              4996.332,
              13185.158
            ],
            [
              -14639.08,
              4996.935,
              13293.447
            ],
            [
              -14655.303,
              4999.246,
              13309.833
            ],
            [
              -14663.939,
              5000.93,
              13318.632
            ],
            [
              -14705.711,
              4995.546,
              13360.75
            ],
            [
              -14720.043,
              4986.855,
              13377.511
            ],
            [
              -14756.022,
              4955.111,
              13425.492
            ],
            [
              -14780.067,
              4944.339,
              13451.839
            ],
            [
              -14785.859,
              4945.538,
              13457.754
            ],
            [
              -14787.001,
              4955.573,
              13467.854
            ],
            [
              -14781.902,
              4994.457,
              13507.071
            ],
            [
              -14777.88,
              5004.415,
              13517.81
            ],
            [
              -14771.31,
              5012.109,
              13527.928
            ],
            [
              -14708.06,
              5011.165,
              13591.185
            ],
            [
              -14697.039,
              5014.34,
              13602.654
            ],
            [
              -14663.881,
              5001.341,
              13638.269
            ],
            [
              -14663.84,
              5001.461,
              13638.396
            ],
            [
              -14621.13,
              4996.509,
              13681.392
            ],
            [
              -14555.946,
              4996.296,
              13746.576
            ],
            [
              -14512.17,
              5001.356,
              13790.644
            ],
            [
              -14490.079,
              5011.795,
              13815.077
            ],
            [
              -14480.529,
              5012.457,
              13824.651
            ],
            [
              -14469.922,
              5006.49,
              13836.82
            ],
            [
              -14468.698,
              5002.019,
              13841.456
            ],
            [
              -14468.798,
              4995.342,
              13848.134
            ],
            [
              -14473.183,
              4982.124,
              13862.06
            ],
            [
              -14474.776,
              4975.691,
              13868.688
            ],
            [
              -14475.209,
              4960.693,
              13883.692
            ],
            [
              -14497.189,
              4910.056,
              13938.893
            ],
            [
              -14830.549,
              4209.508,
              14714.713
            ],
            [
              -14869.864,
              4129.643,
              14803.731
            ],
            [
              -14875.544,
              4118.205,
              14816.502
            ],
            [
              -14912.921,
              4042.454,
              14900.972
            ],
            [
              -14923.825,
              4003.656,
              14941.273
            ],
            [
              -14920.815,
              3945.728,
              14999.279
            ],
            [
              -14912.825,
              3918.894,
              15027.277
            ],
            [
              -14827.286,
              3776.18,
              15193.663
            ],
            [
              -14757.838,
              3659.554,
              15329.401
            ],
            [
              -14721.023,
              3624.392,
              15380.309
            ],
            [
              -14683.948,
              3602.056,
              15423.593
            ],
            [
              -14656.325,
              3585.047,
              15456.033
            ],
            [
              -14637.091,
              3586.313,
              15475.308
            ],
            [
              -14582.87,
              3584.48,
              15529.56
            ],
            [
              -14537.941,
              3592.939,
              15575.279
            ],
            [
              -14221.023,
              3681.328,
              15904.292
            ],
            [
              -14179.98,
              3683.068,
              15945.372
            ],
            [
              -14149.059,
              3679.263,
              15976.526
            ],
            [
              -14111.176,
              3666.448,
              16016.518
            ],
            [
              -14031.067,
              3613.527,
              16112.529
            ],
            [
              -13979.062,
              3568.725,
              16181.171
            ],
            [
              -13933.091,
              3529.2,
              16241.797
            ],
            [
              -13746.7,
              3358.166,
              16494.768
            ],
            [
              -13683.212,
              3280.033,
              16595.443
            ],
            [
              -13657.933,
              3261.091,
              16627.031
            ],
            [
              -13609.134,
              3242.442,
              16679.272
            ],
            [
              -13574.858,
              3231.448,
              16715.269
            ],
            [
              -13500.118,
              3193.018,
              16799.31
            ],
            [
              -13456.795,
              3155.636,
              16856.531
            ],
            [
              -13432.053,
              3128.533,
              16893.229
            ],
            [
              -13214.852,
              2688.868,
              17383.618
            ],
            [
              -13178.797,
              2641.565,
              17443.096
            ],
            [
              -13063.98,
              2562.843,
              17582.308
            ],
            [
              -13031.345,
              2528.716,
              17629.528
            ],
            [
              -12936.975,
              2296.127,
              17880.532
            ],
            [
              -12923.43,
              2263.108,
              17916.221
            ],
            [
              -12918.975,
              2251.052,
              17929.075
            ],
            [
              -12897.858,
              2196.457,
              17987.611
            ],
            [
              -12824.021,
              2047.275,
              18154.066
            ],
            [
              -12807.017,
              2020.298,
              18185.955
            ],
            [
              -12700.869,
              1875.069,
              18365.84
            ],
            [
              -12697.18,
              1871.369,
              18371.065
            ],
            [
              -12695.83,
              1867.199,
              18375.448
            ],
            [
              -12673.142,
              1832.343,
              18417.038
            ],
            [
              -12664.786,
              1812.869,
              18438.228
            ],
            [
              -12627.875,
              1839.437,
              18483.706
            ],
            [
              -12614.702,
              1857.045,
              18505.696
            ],
            [
              -12597.151,
              1865.68,
              18525.257
            ],
            [
              -12592.773,
              1856.707,
              18535.241
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:6318",
              "position": {
                "x": -4215.081,
                "z": 1256.734
              },
              "distanceAlongShapeM": 1.13,
              "shapeOffsetM": 5.517,
              "arrivalOffsetSeconds": -720,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:6319",
              "position": {
                "x": -4558.781,
                "z": 1414.051
              },
              "distanceAlongShapeM": 378.63,
              "shapeOffsetM": 3.754,
              "arrivalOffsetSeconds": 60,
              "departureOffsetSeconds": 60
            },
            {
              "stopId": "judu:stop:6320",
              "position": {
                "x": -4838.028,
                "z": 1606.973
              },
              "distanceAlongShapeM": 717.635,
              "shapeOffsetM": 2.088,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:6309",
              "position": {
                "x": -6721.281,
                "z": 2678.551
              },
              "distanceAlongShapeM": 3224.836,
              "shapeOffsetM": 4.258,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:6297",
              "position": {
                "x": -7611.222,
                "z": 3413.556
              },
              "distanceAlongShapeM": 4410.967,
              "shapeOffsetM": 0.448,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:6294",
              "position": {
                "x": -8136.789,
                "z": 3831.848
              },
              "distanceAlongShapeM": 5095.69,
              "shapeOffsetM": 9.385,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:6290",
              "position": {
                "x": -8674.97,
                "z": 4909.278
              },
              "distanceAlongShapeM": 6783.389,
              "shapeOffsetM": 2.01,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:6282",
              "position": {
                "x": -9588.344,
                "z": 4754.839
              },
              "distanceAlongShapeM": 7709.824,
              "shapeOffsetM": 4.452,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:6286",
              "position": {
                "x": -10003.374,
                "z": 4636.812
              },
              "distanceAlongShapeM": 8257.845,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            },
            {
              "stopId": "judu:stop:9683",
              "position": {
                "x": -10818.872,
                "z": 4705.42
              },
              "distanceAlongShapeM": 9207.023,
              "shapeOffsetM": 0.814,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:9482",
              "position": {
                "x": -11491.699,
                "z": 4899.664
              },
              "distanceAlongShapeM": 9924.65,
              "shapeOffsetM": 5.42,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:9627",
              "position": {
                "x": -11995.222,
                "z": 5107.879
              },
              "distanceAlongShapeM": 10509.408,
              "shapeOffsetM": 7.754,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:16879",
              "position": {
                "x": -12788.934,
                "z": 5172.452
              },
              "distanceAlongShapeM": 11346.629,
              "shapeOffsetM": 0.976,
              "arrivalOffsetSeconds": 1380,
              "departureOffsetSeconds": 1380
            },
            {
              "stopId": "judu:stop:9483",
              "position": {
                "x": -13626.273,
                "z": 5128.461
              },
              "distanceAlongShapeM": 12185.068,
              "shapeOffsetM": 8.498,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            },
            {
              "stopId": "judu:stop:17320",
              "position": {
                "x": -14396.886,
                "z": 5055.486
              },
              "distanceAlongShapeM": 12961.113,
              "shapeOffsetM": 8.587,
              "arrivalOffsetSeconds": 1560,
              "departureOffsetSeconds": 1560
            },
            {
              "stopId": "judu:stop:16903",
              "position": {
                "x": -14697.039,
                "z": 5014.34
              },
              "distanceAlongShapeM": 13602.654,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1680,
              "departureOffsetSeconds": 1680
            },
            {
              "stopId": "judu:stop:9685",
              "position": {
                "x": -14869.884,
                "z": 4115.279
              },
              "distanceAlongShapeM": 14816.621,
              "shapeOffsetM": 6.37,
              "arrivalOffsetSeconds": 1860,
              "departureOffsetSeconds": 1860
            },
            {
              "stopId": "judu:stop:9686",
              "position": {
                "x": -14028.02,
                "z": 3617.329
              },
              "distanceAlongShapeM": 16112.529,
              "shapeOffsetM": 4.872,
              "arrivalOffsetSeconds": 1980,
              "departureOffsetSeconds": 1980
            },
            {
              "stopId": "judu:stop:9485",
              "position": {
                "x": -12916.15,
                "z": 2265.753
              },
              "distanceAlongShapeM": 17916.264,
              "shapeOffsetM": 7.745,
              "arrivalOffsetSeconds": 2160,
              "departureOffsetSeconds": 2160
            },
            {
              "stopId": "judu:stop:9484",
              "position": {
                "x": -12695.099,
                "z": 1872.754
              },
              "distanceAlongShapeM": 18371.065,
              "shapeOffsetM": 2.5,
              "arrivalOffsetSeconds": 2220,
              "departureOffsetSeconds": 2220
            },
            {
              "stopId": "judu:stop:9614",
              "position": {
                "x": -12592.773,
                "z": 1856.707
              },
              "distanceAlongShapeM": 18535.241,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2280,
              "departureOffsetSeconds": 2280
            }
          ],
          "departuresSeconds": [
            17340,
            19500,
            21840,
            23460,
            25500,
            27720,
            30600,
            32100,
            34260,
            36780,
            38520,
            40620,
            42780,
            44820,
            46860,
            49080,
            51240,
            53040,
            55080,
            56100,
            57840,
            60000,
            62580,
            64200,
            66720,
            68760,
            71100,
            73440,
            75540,
            77760,
            80040,
            82500
          ]
        },
        {
          "id": "judu:pattern:vilnius_bus_68:1",
          "sourceRouteId": "vilnius_bus_68",
          "sourceShapeId": "vilnius_bus_68_b-a",
          "directionId": 1,
          "headsign": "Lazdynai",
          "directionName": "Grigiškės–Lentvaris–Mūrinė Vokė–Lazdynai",
          "mode": "bus",
          "routeShortName": "68",
          "routeLongName": "Lazdynai–Mūrinė Vokė–Lentvaris–Grigiškės",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              -12592.773,
              1856.707,
              0
            ],
            [
              -12592.18,
              1853.358,
              3.401
            ],
            [
              -12594.845,
              1847.834,
              9.534
            ],
            [
              -12627.23,
              1839.428,
              42.993
            ],
            [
              -12666.305,
              1815.54,
              88.791
            ],
            [
              -12673.804,
              1831.24,
              106.19
            ],
            [
              -12705.978,
              1878.487,
              163.351
            ],
            [
              -12716.737,
              1892.011,
              180.633
            ],
            [
              -12724.503,
              1897.313,
              190.036
            ],
            [
              -12726.85,
              1905.524,
              198.576
            ],
            [
              -12803.301,
              2010.222,
              328.216
            ],
            [
              -12815.265,
              2029.33,
              350.76
            ],
            [
              -12897.888,
              2189.809,
              531.26
            ],
            [
              -12941.964,
              2307.335,
              656.779
            ],
            [
              -12944.39,
              2312.461,
              662.45
            ],
            [
              -12946.309,
              2318.533,
              668.818
            ],
            [
              -13001.746,
              2468.674,
              828.867
            ],
            [
              -13017.029,
              2503.287,
              866.704
            ],
            [
              -13025.821,
              2519.005,
              884.714
            ],
            [
              -13034.036,
              2530.263,
              898.65
            ],
            [
              -13065.368,
              2560.317,
              942.066
            ],
            [
              -13088.685,
              2578.016,
              971.34
            ],
            [
              -13132.524,
              2607.958,
              1024.428
            ],
            [
              -13178.118,
              2643.781,
              1082.412
            ],
            [
              -13202.024,
              2670.074,
              1117.948
            ],
            [
              -13224.935,
              2704.606,
              1159.389
            ],
            [
              -13276.185,
              2813.364,
              1279.617
            ],
            [
              -13420.117,
              3107.201,
              1606.812
            ],
            [
              -13442.834,
              3140.942,
              1647.488
            ],
            [
              -13465.075,
              3163.543,
              1679.197
            ],
            [
              -13498.199,
              3191.875,
              1722.785
            ],
            [
              -13516.706,
              3205.514,
              1745.775
            ],
            [
              -13555.372,
              3226.675,
              1789.853
            ],
            [
              -13639.254,
              3251.902,
              1877.446
            ],
            [
              -13657.183,
              3261.079,
              1897.587
            ],
            [
              -13673.788,
              3272.462,
              1917.719
            ],
            [
              -13697.95,
              3296.204,
              1951.594
            ],
            [
              -13725.118,
              3334.463,
              1998.518
            ],
            [
              -13753.017,
              3367.167,
              2041.505
            ],
            [
              -13908.319,
              3509.773,
              2252.349
            ],
            [
              -14028.783,
              3609.548,
              2408.767
            ],
            [
              -14037.087,
              3615.239,
              2418.834
            ],
            [
              -14044.635,
              3620.76,
              2428.186
            ],
            [
              -14049.195,
              3625.44,
              2434.72
            ],
            [
              -14077.698,
              3647.343,
              2470.667
            ],
            [
              -14097.447,
              3659.028,
              2493.614
            ],
            [
              -14147.786,
              3678.131,
              2547.455
            ],
            [
              -14178.061,
              3681.926,
              2577.967
            ],
            [
              -14216.162,
              3680.273,
              2616.104
            ],
            [
              -14262.802,
              3668.73,
              2664.151
            ],
            [
              -14568.692,
              3583.155,
              2981.786
            ],
            [
              -14584.227,
              3581.678,
              2997.391
            ],
            [
              -14625.899,
              3584.053,
              3039.131
            ],
            [
              -14669.177,
              3595.789,
              3083.972
            ],
            [
              -14694.798,
              3607.347,
              3112.079
            ],
            [
              -14722.314,
              3624.412,
              3144.457
            ],
            [
              -14727.962,
              3628.199,
              3151.258
            ],
            [
              -14842.574,
              3794.994,
              3353.635
            ],
            [
              -14875.121,
              3850.431,
              3417.919
            ],
            [
              -14905.104,
              3900.364,
              3476.163
            ],
            [
              -14921.928,
              3944.04,
              3522.967
            ],
            [
              -14925.494,
              4010.287,
              3589.309
            ],
            [
              -14922.17,
              4028.121,
              3607.451
            ],
            [
              -14914.807,
              4045.821,
              3626.621
            ],
            [
              -14761.762,
              4354.104,
              3970.803
            ],
            [
              -14476.191,
              4958.817,
              4639.554
            ],
            [
              -14480.66,
              4966.409,
              4648.364
            ],
            [
              -14484.243,
              4975.888,
              4658.498
            ],
            [
              -14504.407,
              4991.837,
              4684.207
            ],
            [
              -14508.524,
              4993.191,
              4688.54
            ],
            [
              -14557.9,
              4996.293,
              4738.014
            ],
            [
              -14617.268,
              4995.444,
              4797.389
            ],
            [
              -14663.936,
              5000.842,
              4844.367
            ],
            [
              -14663.939,
              5000.928,
              4844.454
            ],
            [
              -14703.13,
              4995.508,
              4884.018
            ],
            [
              -14720.026,
              4987.968,
              4902.52
            ],
            [
              -14757.958,
              4955.14,
              4952.685
            ],
            [
              -14769.691,
              4947.523,
              4966.673
            ],
            [
              -14780.067,
              4944.339,
              4977.527
            ],
            [
              -14787.134,
              4946.67,
              4984.968
            ],
            [
              -14781.885,
              4995.57,
              5034.149
            ],
            [
              -14777.88,
              5004.415,
              5043.859
            ],
            [
              -14770.681,
              5010.987,
              5053.606
            ],
            [
              -14760.967,
              5013.068,
              5063.541
            ],
            [
              -14708.06,
              5011.165,
              5116.482
            ],
            [
              -14697.039,
              5014.34,
              5127.951
            ],
            [
              -14663.879,
              5001.349,
              5163.565
            ],
            [
              -14663.849,
              5001.437,
              5163.657
            ],
            [
              -14614.045,
              4995.384,
              5213.828
            ],
            [
              -14509.648,
              5001.596,
              5318.41
            ],
            [
              -14503.291,
              5003.847,
              5325.153
            ],
            [
              -14486.742,
              5028.001,
              5354.432
            ],
            [
              -14484.466,
              5039.493,
              5366.148
            ],
            [
              -14478.53,
              5050.121,
              5378.321
            ],
            [
              -14467.628,
              5060.473,
              5393.355
            ],
            [
              -14450.255,
              5069.644,
              5413
            ],
            [
              -14421.823,
              5071.444,
              5441.489
            ],
            [
              -14385.135,
              5064.215,
              5478.883
            ],
            [
              -14325.212,
              5056.637,
              5539.283
            ],
            [
              -14306.08,
              5056.953,
              5558.417
            ],
            [
              -14291.005,
              5056.123,
              5573.515
            ],
            [
              -14263.914,
              5054.603,
              5600.649
            ],
            [
              -14210.312,
              5056.023,
              5654.27
            ],
            [
              -14146.961,
              5061.749,
              5717.879
            ],
            [
              -14062.704,
              5076.497,
              5803.417
            ],
            [
              -13936.002,
              5095.302,
              5931.507
            ],
            [
              -13715.869,
              5131.347,
              6154.571
            ],
            [
              -13686.815,
              5134.463,
              6183.792
            ],
            [
              -13667.876,
              5135.893,
              6202.785
            ],
            [
              -13195.007,
              5156.858,
              6676.118
            ],
            [
              -12654.441,
              5183.112,
              7217.322
            ],
            [
              -12102.797,
              5206.392,
              7769.457
            ],
            [
              -12068.116,
              5194.722,
              7806.048
            ],
            [
              -12048.943,
              5182.18,
              7828.959
            ],
            [
              -12031.758,
              5166.33,
              7852.338
            ],
            [
              -11969.158,
              5092.851,
              7948.867
            ],
            [
              -11944.96,
              5060.346,
              7989.39
            ],
            [
              -11906.247,
              5017.444,
              8047.176
            ],
            [
              -11887.79,
              5000.46,
              8072.259
            ],
            [
              -11853.808,
              4985.46,
              8109.404
            ],
            [
              -11828.009,
              4983.946,
              8135.247
            ],
            [
              -11802.839,
              4983.554,
              8160.42
            ],
            [
              -11679.271,
              5000.551,
              8285.152
            ],
            [
              -11652.775,
              5002.364,
              8311.71
            ],
            [
              -11614.319,
              4992.582,
              8351.391
            ],
            [
              -11499.863,
              4914.263,
              8490.077
            ],
            [
              -11460.859,
              4890.277,
              8535.866
            ],
            [
              -11439.701,
              4881.04,
              8558.953
            ],
            [
              -11427.573,
              4874.836,
              8572.576
            ],
            [
              -11287.32,
              4800.732,
              8731.202
            ],
            [
              -11111.628,
              4709.529,
              8929.156
            ],
            [
              -11086.383,
              4703.184,
              8955.186
            ],
            [
              -10937.69,
              4702.842,
              9103.879
            ],
            [
              -10706.911,
              4712.515,
              9334.861
            ],
            [
              -10616.051,
              4713.355,
              9425.724
            ],
            [
              -10437.81,
              4712.766,
              9603.967
            ],
            [
              -10390.138,
              4711.988,
              9651.645
            ],
            [
              -10343.689,
              4710.137,
              9698.131
            ],
            [
              -10129.941,
              4674.452,
              9914.837
            ],
            [
              -10101.059,
              4668.413,
              9944.344
            ],
            [
              -9972.732,
              4690.345,
              10074.532
            ],
            [
              -9958.174,
              4692.96,
              10089.323
            ],
            [
              -9955.488,
              4693.443,
              10092.052
            ],
            [
              -9964.253,
              4691.868,
              10100.957
            ],
            [
              -9966.949,
              4654.04,
              10138.881
            ],
            [
              -9974.262,
              4640.799,
              10154.007
            ],
            [
              -9987.867,
              4637.677,
              10167.966
            ],
            [
              -10015.813,
              4625.879,
              10198.3
            ],
            [
              -10037.72,
              4628.455,
              10220.358
            ],
            [
              -10042.829,
              4631.876,
              10226.507
            ],
            [
              -10045.914,
              4640.83,
              10235.977
            ],
            [
              -10046.939,
              4676.582,
              10271.744
            ],
            [
              -10040.995,
              4677.716,
              10277.795
            ],
            [
              -10034.075,
              4679.035,
              10284.839
            ],
            [
              -9847.833,
              4715.586,
              10474.634
            ],
            [
              -9780.57,
              4742.885,
              10547.226
            ],
            [
              -9738.284,
              4743.887,
              10589.524
            ],
            [
              -9619.286,
              4757.562,
              10709.305
            ],
            [
              -9574.56,
              4766.659,
              10754.947
            ],
            [
              -9427.227,
              4786.377,
              10903.594
            ],
            [
              -9186.254,
              4829.624,
              11148.416
            ],
            [
              -8761.616,
              4900.668,
              11578.956
            ],
            [
              -8565.827,
              4935.105,
              11777.751
            ],
            [
              -8440.538,
              4954.439,
              11904.523
            ],
            [
              -8110.415,
              5008.04,
              12238.969
            ],
            [
              -7984.14,
              5031.572,
              12367.418
            ],
            [
              -7997.04,
              5078.168,
              12415.767
            ],
            [
              -8005.189,
              5086.463,
              12427.395
            ],
            [
              -8032.863,
              5094.147,
              12456.116
            ],
            [
              -8056.05,
              5095.089,
              12479.322
            ],
            [
              -8074.858,
              5089.832,
              12498.851
            ],
            [
              -8087.322,
              5077.791,
              12516.181
            ],
            [
              -8094.275,
              5061.214,
              12534.157
            ],
            [
              -8097.824,
              5027.871,
              12567.688
            ],
            [
              -8123.102,
              4509.547,
              13086.628
            ],
            [
              -8153.328,
              4043.622,
              13553.533
            ],
            [
              -8152.03,
              4004.64,
              13592.536
            ],
            [
              -8148.06,
              3971.18,
              13626.231
            ],
            [
              -8140.12,
              3941.964,
              13656.506
            ],
            [
              -8122.972,
              3887.281,
              13713.815
            ],
            [
              -8107.695,
              3848.767,
              13755.249
            ],
            [
              -8056.297,
              3760.771,
              13857.156
            ],
            [
              -8007.887,
              3702.832,
              13932.657
            ],
            [
              -7953.829,
              3654.078,
              14005.453
            ],
            [
              -7691.803,
              3497.261,
              14310.82
            ],
            [
              -7552.547,
              3410.361,
              14474.966
            ],
            [
              -7508.479,
              3393.727,
              14522.069
            ],
            [
              -7243.876,
              3227.143,
              14834.743
            ],
            [
              -6939.838,
              3038.415,
              15192.594
            ],
            [
              -6822.27,
              2929.59,
              15352.797
            ],
            [
              -6681.993,
              2680.689,
              15638.505
            ],
            [
              -6663.874,
              2638.63,
              15684.301
            ],
            [
              -6617.715,
              2546.549,
              15787.304
            ],
            [
              -6572.047,
              2457.871,
              15887.051
            ],
            [
              -6515.563,
              2367.209,
              15993.868
            ],
            [
              -6469.844,
              2319.237,
              16060.137
            ],
            [
              -6422.765,
              2279.486,
              16121.753
            ],
            [
              -6367.289,
              2245.016,
              16187.066
            ],
            [
              -6337.172,
              2227.956,
              16221.68
            ],
            [
              -6224.894,
              2193.526,
              16339.118
            ],
            [
              -5648.753,
              2074.968,
              16927.331
            ],
            [
              -5407.978,
              2044.165,
              17170.068
            ],
            [
              -5248.741,
              2037.003,
              17329.466
            ],
            [
              -5237.188,
              2033.466,
              17341.549
            ],
            [
              -5229.201,
              2009.953,
              17366.381
            ],
            [
              -5217.875,
              1993.062,
              17386.718
            ],
            [
              -5096.905,
              1898.604,
              17540.198
            ],
            [
              -5077.101,
              1887.134,
              17563.083
            ],
            [
              -5062.888,
              1880.497,
              17578.769
            ],
            [
              -5063.879,
              1867.984,
              17591.322
            ],
            [
              -4984.799,
              1776.464,
              17712.274
            ],
            [
              -4951.187,
              1742.493,
              17760.063
            ],
            [
              -4931.684,
              1728.355,
              17784.152
            ],
            [
              -4906.917,
              1690.529,
              17829.365
            ],
            [
              -4953.434,
              1637.843,
              17899.647
            ],
            [
              -4966.71,
              1626.986,
              17916.797
            ],
            [
              -4976.574,
              1616.023,
              17931.545
            ],
            [
              -4993.932,
              1581.81,
              17969.909
            ],
            [
              -4999.643,
              1549.625,
              18002.597
            ],
            [
              -5000.423,
              1503.997,
              18048.232
            ],
            [
              -4985.973,
              1443.638,
              18110.296
            ],
            [
              -4965.718,
              1383.179,
              18174.058
            ],
            [
              -4931.334,
              1319.138,
              18246.746
            ],
            [
              -4880.829,
              1254.822,
              18328.522
            ],
            [
              -4857.956,
              1234.393,
              18359.189
            ],
            [
              -4836.703,
              1220.787,
              18384.424
            ],
            [
              -4813.463,
              1195.782,
              18418.562
            ],
            [
              -4785.375,
              1178.602,
              18451.487
            ],
            [
              -4668.299,
              1122.047,
              18581.507
            ],
            [
              -4620.374,
              1095.621,
              18636.235
            ],
            [
              -4574.442,
              1065.888,
              18690.951
            ],
            [
              -4541.69,
              1036.656,
              18734.851
            ],
            [
              -4440.575,
              860.983,
              18937.546
            ],
            [
              -4425.036,
              789.47,
              19010.728
            ],
            [
              -4406.248,
              756.864,
              19048.359
            ],
            [
              -4380.992,
              725.259,
              19088.816
            ],
            [
              -4355.565,
              703.67,
              19122.172
            ],
            [
              -4324.219,
              688.657,
              19156.928
            ],
            [
              -4302.372,
              683.828,
              19179.302
            ],
            [
              -4269.507,
              682.148,
              19212.21
            ],
            [
              -4233.908,
              689.326,
              19248.525
            ],
            [
              -4200.071,
              706.552,
              19286.495
            ],
            [
              -4154.906,
              744.734,
              19345.637
            ],
            [
              -4131.603,
              764.725,
              19376.339
            ],
            [
              -4089.107,
              782.559,
              19422.426
            ],
            [
              -4026.001,
              813.75,
              19492.819
            ],
            [
              -3968.169,
              838.352,
              19555.667
            ],
            [
              -3939.526,
              853.44,
              19588.041
            ],
            [
              -3921.201,
              868.708,
              19611.893
            ],
            [
              -3904.031,
              891.787,
              19640.658
            ],
            [
              -3887.976,
              924.905,
              19677.463
            ],
            [
              -3883.393,
              966.014,
              19718.826
            ],
            [
              -3887.876,
              1005.054,
              19758.123
            ],
            [
              -3903.754,
              1056.537,
              19811.999
            ],
            [
              -3912.994,
              1078.798,
              19836.101
            ],
            [
              -3919.363,
              1123.6,
              19881.354
            ],
            [
              -3949.447,
              1248.8,
              20010.117
            ],
            [
              -3955.799,
              1254.476,
              20018.636
            ],
            [
              -3966.06,
              1257.993,
              20029.483
            ],
            [
              -4052.898,
              1235.006,
              20119.312
            ],
            [
              -4088.424,
              1232.281,
              20154.942
            ],
            [
              -4119.34,
              1235.042,
              20185.981
            ],
            [
              -4212.237,
              1261.595,
              20282.599
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:9614",
              "position": {
                "x": -12592.773,
                "z": 1856.707
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": -660,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:9615",
              "position": {
                "x": -12727.005,
                "z": 1895.508
              },
              "distanceAlongShapeM": 190.036,
              "shapeOffsetM": 3.085,
              "arrivalOffsetSeconds": 60,
              "departureOffsetSeconds": 60
            },
            {
              "stopId": "judu:stop:9616",
              "position": {
                "x": -12949.008,
                "z": 2310.783
              },
              "distanceAlongShapeM": 662.45,
              "shapeOffsetM": 4.913,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:9688",
              "position": {
                "x": -14048.039,
                "z": 3616.518
              },
              "distanceAlongShapeM": 2428.186,
              "shapeOffsetM": 5.439,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:9689",
              "position": {
                "x": -14732.009,
                "z": 3623.443
              },
              "distanceAlongShapeM": 3151.258,
              "shapeOffsetM": 6.245,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:9690",
              "position": {
                "x": -14924.075,
                "z": 3943.551
              },
              "distanceAlongShapeM": 3522.967,
              "shapeOffsetM": 2.202,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:16903",
              "position": {
                "x": -14697.039,
                "z": 5014.34
              },
              "distanceAlongShapeM": 5127.951,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:9618",
              "position": {
                "x": -14305.749,
                "z": 5063.023
              },
              "distanceAlongShapeM": 5558.417,
              "shapeOffsetM": 6.079,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:9692",
              "position": {
                "x": -13668.056,
                "z": 5140.226
              },
              "distanceAlongShapeM": 6202.797,
              "shapeOffsetM": 4.336,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:16880",
              "position": {
                "x": -12654.97,
                "z": 5193.77
              },
              "distanceAlongShapeM": 7217.31,
              "shapeOffsetM": 10.671,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            },
            {
              "stopId": "judu:stop:9628",
              "position": {
                "x": -11968.984,
                "z": 5093
              },
              "distanceAlongShapeM": 7948.866,
              "shapeOffsetM": 0.23,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:9481",
              "position": {
                "x": -11426.2,
                "z": 4877.489
              },
              "distanceAlongShapeM": 8572.576,
              "shapeOffsetM": 2.987,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:9479",
              "position": {
                "x": -10706.995,
                "z": 4718.123
              },
              "distanceAlongShapeM": 9334.861,
              "shapeOffsetM": 5.609,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:9626",
              "position": {
                "x": -10015.813,
                "z": 4625.879
              },
              "distanceAlongShapeM": 10198.3,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            },
            {
              "stopId": "judu:stop:6283",
              "position": {
                "x": -9574.594,
                "z": 4766.863
              },
              "distanceAlongShapeM": 10754.947,
              "shapeOffsetM": 0.207,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            },
            {
              "stopId": "judu:stop:6291",
              "position": {
                "x": -8566.072,
                "z": 4936.448
              },
              "distanceAlongShapeM": 11777.742,
              "shapeOffsetM": 1.365,
              "arrivalOffsetSeconds": 1560,
              "departureOffsetSeconds": 1560
            },
            {
              "stopId": "judu:stop:6295",
              "position": {
                "x": -8134.965,
                "z": 3943.136
              },
              "distanceAlongShapeM": 13656.931,
              "shapeOffsetM": 5.27,
              "arrivalOffsetSeconds": 1740,
              "departureOffsetSeconds": 1740
            },
            {
              "stopId": "judu:stop:6609",
              "position": {
                "x": -7508.286,
                "z": 3394.045
              },
              "distanceAlongShapeM": 14522.069,
              "shapeOffsetM": 0.372,
              "arrivalOffsetSeconds": 1860,
              "departureOffsetSeconds": 1860
            },
            {
              "stopId": "judu:stop:6310",
              "position": {
                "x": -6676.677,
                "z": 2683.371
              },
              "distanceAlongShapeM": 15638.505,
              "shapeOffsetM": 5.954,
              "arrivalOffsetSeconds": 1980,
              "departureOffsetSeconds": 1980
            },
            {
              "stopId": "judu:stop:7350",
              "position": {
                "x": -4952.35,
                "z": 1636.759
              },
              "distanceAlongShapeM": 17899.647,
              "shapeOffsetM": 1.533,
              "arrivalOffsetSeconds": 2220,
              "departureOffsetSeconds": 2220
            },
            {
              "stopId": "judu:stop:329",
              "position": {
                "x": -4834.931,
                "z": 1222.866
              },
              "distanceAlongShapeM": 18384.424,
              "shapeOffsetM": 2.732,
              "arrivalOffsetSeconds": 2280,
              "departureOffsetSeconds": 2280
            },
            {
              "stopId": "judu:stop:4395",
              "position": {
                "x": -4540.743,
                "z": 1037.479
              },
              "distanceAlongShapeM": 18734.851,
              "shapeOffsetM": 1.254,
              "arrivalOffsetSeconds": 2340,
              "departureOffsetSeconds": 2340
            },
            {
              "stopId": "judu:stop:5703",
              "position": {
                "x": -4134.494,
                "z": 768.872
              },
              "distanceAlongShapeM": 19376.339,
              "shapeOffsetM": 5.055,
              "arrivalOffsetSeconds": 2400,
              "departureOffsetSeconds": 2400
            },
            {
              "stopId": "judu:stop:5702",
              "position": {
                "x": -3916.285,
                "z": 1077.905
              },
              "distanceAlongShapeM": 19836.101,
              "shapeOffsetM": 3.41,
              "arrivalOffsetSeconds": 2460,
              "departureOffsetSeconds": 2460
            },
            {
              "stopId": "judu:stop:6318",
              "position": {
                "x": -4215.081,
                "z": 1256.734
              },
              "distanceAlongShapeM": 20282.599,
              "shapeOffsetM": 5.632,
              "arrivalOffsetSeconds": 2580,
              "departureOffsetSeconds": 2580
            }
          ],
          "departuresSeconds": [
            18660,
            20100,
            22140,
            23640,
            25200,
            26640,
            28740,
            31020,
            33480,
            35220,
            37320,
            39600,
            41700,
            43680,
            45720,
            47820,
            49860,
            51900,
            54060,
            56100,
            58080,
            59160,
            60960,
            63120,
            65580,
            67680,
            69960,
            72180,
            74220,
            76560,
            78780,
            80820,
            82920
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_bus_69",
      "sourceRouteId": "vilnius_bus_69",
      "mode": "bus",
      "shortName": "69",
      "longName": "Šiaurės miestelis–Kernavės g.–Lazdynai–Lazdynėliai",
      "color": "0073AC",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_bus_69:0",
          "sourceRouteId": "vilnius_bus_69",
          "sourceShapeId": "vilnius_bus_69_a-b",
          "directionId": 0,
          "headsign": "Lazdynėliai",
          "directionName": "Šiaurės miestelis–Kernavės g.–Lazdynai–Lazdynėliai",
          "mode": "bus",
          "routeShortName": "69",
          "routeLongName": "Šiaurės miestelis–Kernavės g.–Lazdynai–Lazdynėliai",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              1407.302,
              -2542.364,
              0
            ],
            [
              1404.085,
              -2529.725,
              13.042
            ],
            [
              1492.99,
              -2519.128,
              102.577
            ],
            [
              1552.992,
              -2512.565,
              162.937
            ],
            [
              1553.131,
              -2520.895,
              171.269
            ],
            [
              1553.227,
              -2526.592,
              176.967
            ],
            [
              1553.355,
              -2534.309,
              184.685
            ],
            [
              1553.387,
              -2536.238,
              186.614
            ],
            [
              1447.352,
              -2569.169,
              297.645
            ],
            [
              1407.447,
              -2542.743,
              345.508
            ],
            [
              1407.868,
              -2547.344,
              350.128
            ],
            [
              1407.735,
              -2553.76,
              356.545
            ],
            [
              1415.904,
              -2574.474,
              378.812
            ],
            [
              1275.293,
              -2579.663,
              519.519
            ],
            [
              1255.056,
              -2585.375,
              540.546
            ],
            [
              1229.698,
              -2591.451,
              566.623
            ],
            [
              1196.042,
              -2600.83,
              601.561
            ],
            [
              955.306,
              -2665.04,
              850.713
            ],
            [
              918.306,
              -2677.632,
              889.797
            ],
            [
              895.761,
              -2678.415,
              912.355
            ],
            [
              887.466,
              -2673.809,
              921.843
            ],
            [
              879.035,
              -2624.079,
              972.283
            ],
            [
              876.281,
              -2581.204,
              1015.246
            ],
            [
              801.593,
              -2329.376,
              1277.917
            ],
            [
              790.842,
              -2289.971,
              1318.761
            ],
            [
              783.069,
              -2252.196,
              1357.328
            ],
            [
              779.214,
              -2216.501,
              1393.231
            ],
            [
              778.263,
              -2163.048,
              1446.692
            ],
            [
              706.997,
              -1866.729,
              1751.461
            ],
            [
              692.307,
              -1824.156,
              1796.497
            ],
            [
              638.805,
              -1718.529,
              1914.901
            ],
            [
              623.163,
              -1692.637,
              1945.151
            ],
            [
              616.718,
              -1692.519,
              1951.597
            ],
            [
              592.004,
              -1704.311,
              1978.98
            ],
            [
              576.207,
              -1710.199,
              1995.839
            ],
            [
              475.715,
              -1717.765,
              2096.615
            ],
            [
              322.189,
              -1722.747,
              2250.222
            ],
            [
              290.154,
              -1723.98,
              2282.281
            ],
            [
              177.023,
              -1729.001,
              2395.523
            ],
            [
              91.167,
              -1735.227,
              2481.605
            ],
            [
              -162.795,
              -1768.453,
              2737.731
            ],
            [
              -165.549,
              -1676.783,
              2829.442
            ],
            [
              -167.82,
              -1654.812,
              2851.53
            ],
            [
              -171.89,
              -1628.287,
              2878.365
            ],
            [
              -182.65,
              -1533.582,
              2973.68
            ],
            [
              -191.306,
              -1478.853,
              3029.089
            ],
            [
              -208.66,
              -1477.424,
              3046.502
            ],
            [
              -204.051,
              -1463.644,
              3061.032
            ],
            [
              -203.755,
              -1461.542,
              3063.155
            ],
            [
              -216.463,
              -1425.929,
              3100.967
            ],
            [
              -242.064,
              -1267.987,
              3260.97
            ],
            [
              -246.518,
              -1227.75,
              3301.454
            ],
            [
              -252.819,
              -1184.218,
              3345.439
            ],
            [
              -293.042,
              -1094.808,
              3443.48
            ],
            [
              -327.47,
              -1111.49,
              3481.736
            ],
            [
              -359.955,
              -1122.538,
              3516.049
            ],
            [
              -398.342,
              -1136.075,
              3556.753
            ],
            [
              -455.246,
              -1008.375,
              3696.558
            ],
            [
              -507.939,
              -1034.138,
              3755.211
            ],
            [
              -535.166,
              -1050.172,
              3786.809
            ],
            [
              -673.187,
              -1080.133,
              3928.044
            ],
            [
              -764.624,
              -1108.462,
              4023.769
            ],
            [
              -829.227,
              -1116.28,
              4088.843
            ],
            [
              -865.018,
              -1134.559,
              4129.032
            ],
            [
              -891.825,
              -1155.228,
              4162.882
            ],
            [
              -898.939,
              -1163.415,
              4173.728
            ],
            [
              -908.077,
              -1171.394,
              4185.859
            ],
            [
              -917.363,
              -1177.032,
              4196.723
            ],
            [
              -929.666,
              -1178.977,
              4209.179
            ],
            [
              -961.877,
              -1178.457,
              4241.394
            ],
            [
              -977.23,
              -1175.77,
              4256.98
            ],
            [
              -995.797,
              -1164.488,
              4278.706
            ],
            [
              -1006.474,
              -1148.711,
              4297.756
            ],
            [
              -1029.882,
              -1123.799,
              4331.94
            ],
            [
              -1062.634,
              -1116.531,
              4365.489
            ],
            [
              -1097.251,
              -1122.142,
              4400.558
            ],
            [
              -1143.947,
              -1120.636,
              4447.278
            ],
            [
              -1339.338,
              -1158.32,
              4646.27
            ],
            [
              -1374.945,
              -1168.896,
              4683.414
            ],
            [
              -1791.301,
              -1230.398,
              5104.288
            ],
            [
              -1855.793,
              -1231.475,
              5168.789
            ],
            [
              -1940.187,
              -1227.747,
              5253.265
            ],
            [
              -2027.705,
              -1218.399,
              5341.281
            ],
            [
              -2166.609,
              -1198.122,
              5481.657
            ],
            [
              -2255.397,
              -1187.643,
              5571.061
            ],
            [
              -2266.36,
              -1186.843,
              5582.054
            ],
            [
              -2295.924,
              -1182.472,
              5611.939
            ],
            [
              -2392.506,
              -1175.197,
              5708.795
            ],
            [
              -2431.277,
              -1180.078,
              5747.872
            ],
            [
              -2478.584,
              -1193.714,
              5797.105
            ],
            [
              -2533.196,
              -1219.467,
              5857.484
            ],
            [
              -2617.204,
              -1266.966,
              5953.991
            ],
            [
              -2663.944,
              -1285.067,
              6004.113
            ],
            [
              -2710.565,
              -1296.491,
              6052.113
            ],
            [
              -2762.381,
              -1304.469,
              6104.541
            ],
            [
              -2808.767,
              -1305.331,
              6150.934
            ],
            [
              -2858.119,
              -1300.984,
              6200.478
            ],
            [
              -3071.028,
              -1263.439,
              6416.671
            ],
            [
              -3139.719,
              -1251.188,
              6486.446
            ],
            [
              -3159.719,
              -1247.413,
              6506.799
            ],
            [
              -3359.526,
              -1207.182,
              6710.616
            ],
            [
              -3495.953,
              -1192.555,
              6847.825
            ],
            [
              -3569.469,
              -1193.5,
              6921.347
            ],
            [
              -3626.266,
              -1196.964,
              6978.25
            ],
            [
              -3657.704,
              -1114.039,
              7066.934
            ],
            [
              -3677.364,
              -1066.903,
              7118.006
            ],
            [
              -3685.368,
              -1042.059,
              7144.108
            ],
            [
              -3720.918,
              -930.373,
              7261.315
            ],
            [
              -3751.424,
              -837.404,
              7359.161
            ],
            [
              -3758.325,
              -817.25,
              7380.463
            ],
            [
              -3766.218,
              -791.548,
              7407.35
            ],
            [
              -3793.988,
              -719.82,
              7484.266
            ],
            [
              -3843.779,
              -616.54,
              7598.922
            ],
            [
              -3881.258,
              -546.871,
              7678.032
            ],
            [
              -3968.352,
              -399.129,
              7849.534
            ],
            [
              -3983.006,
              -376.666,
              7876.354
            ],
            [
              -3999.719,
              -350.005,
              7907.821
            ],
            [
              -4048.201,
              -282.373,
              7991.035
            ],
            [
              -4133.499,
              -180.709,
              8123.743
            ],
            [
              -4196.231,
              -117.271,
              8212.959
            ],
            [
              -4217.103,
              -95.271,
              8243.285
            ],
            [
              -4243.751,
              -67.483,
              8281.786
            ],
            [
              -4402.336,
              85.535,
              8502.158
            ],
            [
              -4449.086,
              142,
              8575.464
            ],
            [
              -4479.797,
              193.736,
              8635.629
            ],
            [
              -4502.905,
              237.549,
              8685.162
            ],
            [
              -4519.036,
              274.562,
              8725.538
            ],
            [
              -4536.228,
              324.952,
              8778.78
            ],
            [
              -4547.048,
              370.78,
              8825.868
            ],
            [
              -4566.578,
              510.266,
              8966.714
            ],
            [
              -4570.606,
              537.669,
              8994.412
            ],
            [
              -4575.517,
              590.57,
              9047.54
            ],
            [
              -4579.623,
              651.866,
              9108.974
            ],
            [
              -4586.366,
              709.869,
              9167.367
            ],
            [
              -4584.541,
              741.007,
              9198.559
            ],
            [
              -4573.306,
              794.248,
              9252.972
            ],
            [
              -4555.909,
              830.684,
              9293.348
            ],
            [
              -4554.237,
              852.919,
              9315.646
            ],
            [
              -4568.699,
              912.168,
              9376.635
            ],
            [
              -4567.748,
              929.963,
              9394.455
            ],
            [
              -4555.854,
              946.456,
              9414.789
            ],
            [
              -4510.16,
              977.953,
              9470.287
            ],
            [
              -4440.575,
              860.983,
              9606.39
            ],
            [
              -4425.036,
              789.47,
              9679.572
            ],
            [
              -4406.248,
              756.864,
              9717.204
            ],
            [
              -4380.992,
              725.259,
              9757.66
            ],
            [
              -4355.565,
              703.67,
              9791.016
            ],
            [
              -4324.219,
              688.657,
              9825.772
            ],
            [
              -4302.372,
              683.828,
              9848.146
            ],
            [
              -4269.507,
              682.148,
              9881.054
            ],
            [
              -4233.908,
              689.326,
              9917.37
            ],
            [
              -4200.071,
              706.552,
              9955.339
            ],
            [
              -4154.906,
              744.734,
              10014.481
            ],
            [
              -4131.603,
              764.725,
              10045.184
            ],
            [
              -4089.107,
              782.559,
              10091.27
            ],
            [
              -4026.001,
              813.75,
              10161.664
            ],
            [
              -3968.169,
              838.352,
              10224.511
            ],
            [
              -3939.526,
              853.44,
              10256.885
            ],
            [
              -3921.201,
              868.708,
              10280.737
            ],
            [
              -3904.031,
              891.787,
              10309.502
            ],
            [
              -3894.03,
              910.538,
              10330.754
            ],
            [
              -3887.976,
              924.905,
              10346.344
            ],
            [
              -3883.393,
              966.014,
              10387.708
            ],
            [
              -3887.876,
              1005.054,
              10427.004
            ],
            [
              -3903.754,
              1056.537,
              10480.88
            ],
            [
              -3912.994,
              1078.798,
              10504.982
            ],
            [
              -3919.363,
              1123.6,
              10550.235
            ],
            [
              -3953.633,
              1267.797,
              10698.449
            ],
            [
              -4000.81,
              1451.793,
              10888.396
            ],
            [
              -4002.478,
              1464.567,
              10901.279
            ],
            [
              -4050.827,
              1690.271,
              11132.103
            ],
            [
              -4136.394,
              1775.359,
              11252.775
            ],
            [
              -4148.475,
              1788.807,
              11270.853
            ],
            [
              -4177.913,
              1802.674,
              11303.393
            ],
            [
              -4315.532,
              1828.426,
              11443.401
            ],
            [
              -4369.14,
              1824.898,
              11497.125
            ],
            [
              -4499.926,
              1801.252,
              11630.031
            ],
            [
              -4609.985,
              1791.417,
              11740.529
            ],
            [
              -4563.305,
              1794.618,
              11787.317
            ],
            [
              -4774.467,
              1777.316,
              11999.187
            ],
            [
              -4906.917,
              1690.529,
              12157.538
            ],
            [
              -4961.39,
              1738.988,
              12230.446
            ],
            [
              -4976.074,
              1758.503,
              12254.868
            ],
            [
              -5065.283,
              1861.328,
              12390.998
            ],
            [
              -5077.888,
              1869.006,
              12405.757
            ],
            [
              -5084.328,
              1879.465,
              12418.04
            ],
            [
              -5215.138,
              1981.641,
              12584.025
            ],
            [
              -5233.729,
              2008.428,
              12616.631
            ],
            [
              -5239.666,
              2025.783,
              12634.974
            ],
            [
              -5242.006,
              2043.57,
              12652.914
            ],
            [
              -5238.791,
              2070.128,
              12679.666
            ],
            [
              -5223.962,
              2099.283,
              12712.375
            ],
            [
              -5207.931,
              2116.333,
              12735.778
            ],
            [
              -5183.957,
              2128.294,
              12762.57
            ],
            [
              -5143.89,
              2132.063,
              12802.814
            ],
            [
              -5127.139,
              2130.664,
              12819.623
            ],
            [
              -5118.637,
              2137.21,
              12830.353
            ],
            [
              -5118.275,
              2163.922,
              12857.067
            ],
            [
              -5118.414,
              2191.207,
              12884.353
            ],
            [
              -5122.291,
              2228.865,
              12922.21
            ],
            [
              -5129.697,
              2256.977,
              12951.281
            ],
            [
              -5177.599,
              2353.365,
              13058.916
            ],
            [
              -5256.746,
              2507.237,
              13231.95
            ],
            [
              -5434.652,
              2850.293,
              13618.393
            ],
            [
              -5447.218,
              2874.188,
              13645.391
            ],
            [
              -5456.675,
              2890.795,
              13664.502
            ],
            [
              -5471.207,
              2917.982,
              13695.329
            ],
            [
              -5499.465,
              2967.761,
              13752.569
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:7589",
              "position": {
                "x": 1524.687,
                "z": -2513.037
              },
              "distanceAlongShapeM": 134.748,
              "shapeOffsetM": 2.608,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:9565",
              "position": {
                "x": 1231.149,
                "z": -2596.659
              },
              "distanceAlongShapeM": 566.425,
              "shapeOffsetM": 5.403,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:9637",
              "position": {
                "x": 874.193,
                "z": -2624.582
              },
              "distanceAlongShapeM": 972.283,
              "shapeOffsetM": 4.868,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:9640",
              "position": {
                "x": 793.859,
                "z": -2331.434
              },
              "distanceAlongShapeM": 1277.967,
              "shapeOffsetM": 8.003,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:18847",
              "position": {
                "x": 578.225,
                "z": -1717.417
              },
              "distanceAlongShapeM": 1995.839,
              "shapeOffsetM": 7.495,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:5498",
              "position": {
                "x": 290.448,
                "z": -1731.073
              },
              "distanceAlongShapeM": 2282.26,
              "shapeOffsetM": 7.099,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:17315",
              "position": {
                "x": -226.936,
                "z": -1431.091
              },
              "distanceAlongShapeM": 3099.625,
              "shapeOffsetM": 11.599,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:17323",
              "position": {
                "x": -326.277,
                "z": -1114.243
              },
              "distanceAlongShapeM": 3481.736,
              "shapeOffsetM": 3,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:7382",
              "position": {
                "x": -534.689,
                "z": -1051.466
              },
              "distanceAlongShapeM": 3786.809,
              "shapeOffsetM": 1.38,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:988",
              "position": {
                "x": -763.423,
                "z": -1114.127
              },
              "distanceAlongShapeM": 4023.769,
              "shapeOffsetM": 5.791,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:6404",
              "position": {
                "x": -1096.995,
                "z": -1127.045
              },
              "distanceAlongShapeM": 4400.558,
              "shapeOffsetM": 4.91,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:814",
              "position": {
                "x": -1374.402,
                "z": -1172.164
              },
              "distanceAlongShapeM": 4683.414,
              "shapeOffsetM": 3.313,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            },
            {
              "stopId": "judu:stop:5906",
              "position": {
                "x": -2267.097,
                "z": -1193.002
              },
              "distanceAlongShapeM": 5582.054,
              "shapeOffsetM": 6.203,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            },
            {
              "stopId": "judu:stop:7415",
              "position": {
                "x": -3140.52,
                "z": -1255.542
              },
              "distanceAlongShapeM": 6486.446,
              "shapeOffsetM": 4.427,
              "arrivalOffsetSeconds": 1560,
              "departureOffsetSeconds": 1560
            },
            {
              "stopId": "judu:stop:5643",
              "position": {
                "x": -3680.758,
                "z": -1067.996
              },
              "distanceAlongShapeM": 7118.006,
              "shapeOffsetM": 3.566,
              "arrivalOffsetSeconds": 1680,
              "departureOffsetSeconds": 1680
            },
            {
              "stopId": "judu:stop:5646",
              "position": {
                "x": -3761.526,
                "z": -818.346
              },
              "distanceAlongShapeM": 7380.463,
              "shapeOffsetM": 3.383,
              "arrivalOffsetSeconds": 1740,
              "departureOffsetSeconds": 1740
            },
            {
              "stopId": "judu:stop:5651",
              "position": {
                "x": -3986.683,
                "z": -379.175
              },
              "distanceAlongShapeM": 7876.262,
              "shapeOffsetM": 4.451,
              "arrivalOffsetSeconds": 1800,
              "departureOffsetSeconds": 1800
            },
            {
              "stopId": "judu:stop:5656",
              "position": {
                "x": -4221.08,
                "z": -99.045
              },
              "distanceAlongShapeM": 8243.314,
              "shapeOffsetM": 5.483,
              "arrivalOffsetSeconds": 1860,
              "departureOffsetSeconds": 1860
            },
            {
              "stopId": "judu:stop:5668",
              "position": {
                "x": -4574.501,
                "z": 537.119
              },
              "distanceAlongShapeM": 8994.412,
              "shapeOffsetM": 3.934,
              "arrivalOffsetSeconds": 1920,
              "departureOffsetSeconds": 1920
            },
            {
              "stopId": "judu:stop:5703",
              "position": {
                "x": -4134.494,
                "z": 768.872
              },
              "distanceAlongShapeM": 10045.184,
              "shapeOffsetM": 5.055,
              "arrivalOffsetSeconds": 2070,
              "departureOffsetSeconds": 2070
            },
            {
              "stopId": "judu:stop:5702",
              "position": {
                "x": -3916.285,
                "z": 1077.905
              },
              "distanceAlongShapeM": 10504.982,
              "shapeOffsetM": 3.41,
              "arrivalOffsetSeconds": 2160,
              "departureOffsetSeconds": 2160
            },
            {
              "stopId": "judu:stop:5698",
              "position": {
                "x": -4003.354,
                "z": 1451.223
              },
              "distanceAlongShapeM": 10888.396,
              "shapeOffsetM": 2.607,
              "arrivalOffsetSeconds": 2220,
              "departureOffsetSeconds": 2220
            },
            {
              "stopId": "judu:stop:5694",
              "position": {
                "x": -4137.78,
                "z": 1773.038
              },
              "distanceAlongShapeM": 11252.121,
              "shapeOffsetM": 2.623,
              "arrivalOffsetSeconds": 2280,
              "departureOffsetSeconds": 2280
            },
            {
              "stopId": "judu:stop:5692",
              "position": {
                "x": -4609.774,
                "z": 1787.849
              },
              "distanceAlongShapeM": 11834.184,
              "shapeOffsetM": 2.952,
              "arrivalOffsetSeconds": 2340,
              "departureOffsetSeconds": 2340
            },
            {
              "stopId": "judu:stop:7341",
              "position": {
                "x": -4962.228,
                "z": 1738.229
              },
              "distanceAlongShapeM": 12230.446,
              "shapeOffsetM": 1.131,
              "arrivalOffsetSeconds": 2460,
              "departureOffsetSeconds": 2460
            },
            {
              "stopId": "judu:stop:7560",
              "position": {
                "x": -5126.114,
                "z": 2190.759
              },
              "distanceAlongShapeM": 12883.944,
              "shapeOffsetM": 7.703,
              "arrivalOffsetSeconds": 2580,
              "departureOffsetSeconds": 2580
            },
            {
              "stopId": "judu:stop:7171",
              "position": {
                "x": -5259.467,
                "z": 2505.84
              },
              "distanceAlongShapeM": 13231.963,
              "shapeOffsetM": 3.059,
              "arrivalOffsetSeconds": 2700,
              "departureOffsetSeconds": 2700
            },
            {
              "stopId": "judu:stop:16622",
              "position": {
                "x": -5500.051,
                "z": 2967.452
              },
              "distanceAlongShapeM": 13752.569,
              "shapeOffsetM": 0.662,
              "arrivalOffsetSeconds": 2820,
              "departureOffsetSeconds": 2820
            }
          ],
          "departuresSeconds": [
            17880,
            19800,
            22020,
            23880,
            25800,
            26880,
            28980,
            32220,
            33660,
            34860,
            37440,
            39660,
            41880,
            44040,
            46260,
            48480,
            50640,
            52860,
            54960,
            57060,
            58560,
            60240,
            62160,
            64080,
            66240,
            68940,
            70740,
            73140,
            75420,
            77520,
            79620,
            81720
          ]
        },
        {
          "id": "judu:pattern:vilnius_bus_69:1",
          "sourceRouteId": "vilnius_bus_69",
          "sourceShapeId": "vilnius_bus_69_b-a",
          "directionId": 1,
          "headsign": "Šiaurės miestelis",
          "directionName": "Lazdynėliai–Lazdynai–Kernavės g.–Kalvarijų–Šiaurės miestelis",
          "mode": "bus",
          "routeShortName": "69",
          "routeLongName": "Šiaurės miestelis–Kernavės g.–Lazdynai–Lazdynėliai",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              -5499.465,
              2967.761,
              0
            ],
            [
              -5504.864,
              2978.001,
              11.576
            ],
            [
              -5507.132,
              2984.125,
              18.106
            ],
            [
              -5507.064,
              2988.744,
              22.726
            ],
            [
              -5500.758,
              2997.505,
              33.52
            ],
            [
              -5483.457,
              2997.921,
              50.826
            ],
            [
              -5477.217,
              2994.663,
              57.865
            ],
            [
              -5475.234,
              2984.842,
              67.885
            ],
            [
              -5476.891,
              2939.215,
              113.542
            ],
            [
              -5471.207,
              2917.982,
              135.523
            ],
            [
              -5266.025,
              2529.648,
              574.73
            ],
            [
              -5254.606,
              2507.12,
              599.986
            ],
            [
              -5128.219,
              2256.474,
              880.695
            ],
            [
              -5121.579,
              2229.644,
              908.334
            ],
            [
              -5117.539,
              2201.745,
              936.524
            ],
            [
              -5116.758,
              2139.39,
              998.884
            ],
            [
              -5122.771,
              2125.053,
              1014.431
            ],
            [
              -5151.268,
              2124.22,
              1042.94
            ],
            [
              -5168.723,
              2123.338,
              1060.417
            ],
            [
              -5186.285,
              2118.906,
              1078.53
            ],
            [
              -5205.39,
              2106.815,
              1101.139
            ],
            [
              -5218.73,
              2094.377,
              1119.378
            ],
            [
              -5232.085,
              2067.888,
              1149.044
            ],
            [
              -5234.987,
              2049.013,
              1168.14
            ],
            [
              -5232.767,
              2027.825,
              1189.444
            ],
            [
              -5229.106,
              2015.517,
              1202.285
            ],
            [
              -5217.174,
              1996.39,
              1224.829
            ],
            [
              -5203.627,
              1982.351,
              1244.338
            ],
            [
              -5082.26,
              1887.222,
              1398.544
            ],
            [
              -5064.922,
              1882.473,
              1416.521
            ],
            [
              -5060.085,
              1863.466,
              1436.134
            ],
            [
              -4961.259,
              1757.137,
              1581.297
            ],
            [
              -4931.684,
              1728.355,
              1622.566
            ],
            [
              -4906.917,
              1690.529,
              1667.779
            ],
            [
              -4842.797,
              1742.865,
              1750.546
            ],
            [
              -4801.101,
              1766.641,
              1798.544
            ],
            [
              -4774.467,
              1777.316,
              1827.238
            ],
            [
              -4728.427,
              1790.998,
              1875.268
            ],
            [
              -4687.68,
              1796.979,
              1916.452
            ],
            [
              -4579.155,
              1805.134,
              2025.283
            ],
            [
              -4546.833,
              1810.069,
              2057.979
            ],
            [
              -4518.395,
              1811.882,
              2086.475
            ],
            [
              -4300.033,
              1829.272,
              2305.528
            ],
            [
              -4282.619,
              1828.972,
              2322.945
            ],
            [
              -4257.523,
              1825.2,
              2348.323
            ],
            [
              -4165.014,
              1802.452,
              2443.587
            ],
            [
              -4141.304,
              1793.136,
              2469.062
            ],
            [
              -4122.773,
              1782.797,
              2490.282
            ],
            [
              -4070.589,
              1735.287,
              2560.854
            ],
            [
              -4047.235,
              1694.122,
              2608.182
            ],
            [
              -4037.796,
              1664.197,
              2639.56
            ],
            [
              -4021.405,
              1600.417,
              2705.413
            ],
            [
              -3992.198,
              1462.162,
              2846.719
            ],
            [
              -3985.157,
              1436.356,
              2873.468
            ],
            [
              -3986.154,
              1438.68,
              2875.997
            ],
            [
              -3973.348,
              1390.702,
              2925.655
            ],
            [
              -3971.11,
              1376.08,
              2940.447
            ],
            [
              -3953.873,
              1291.178,
              3027.081
            ],
            [
              -3953.633,
              1267.797,
              3050.463
            ],
            [
              -3919.363,
              1123.6,
              3198.676
            ],
            [
              -3889.289,
              1035.135,
              3292.114
            ],
            [
              -3881.018,
              1009.279,
              3319.26
            ],
            [
              -3879.245,
              944.791,
              3383.773
            ],
            [
              -3886.86,
              914.867,
              3414.65
            ],
            [
              -3898.384,
              892.134,
              3440.137
            ],
            [
              -3911.432,
              874.104,
              3462.393
            ],
            [
              -3948.102,
              842.457,
              3510.831
            ],
            [
              -4089.107,
              782.559,
              3664.031
            ],
            [
              -4161.662,
              727.04,
              3755.391
            ],
            [
              -4178.229,
              714.534,
              3776.148
            ],
            [
              -4216.46,
              691.251,
              3820.911
            ],
            [
              -4255.439,
              676.425,
              3862.614
            ],
            [
              -4279.313,
              674.524,
              3886.564
            ],
            [
              -4304.422,
              677.184,
              3911.813
            ],
            [
              -4330.724,
              685.43,
              3939.378
            ],
            [
              -4370.887,
              712.839,
              3988.002
            ],
            [
              -4391.801,
              734.351,
              4018.005
            ],
            [
              -4418.25,
              771.542,
              4063.641
            ],
            [
              -4423.862,
              782.771,
              4076.195
            ],
            [
              -4434.781,
              784.705,
              4087.283
            ],
            [
              -4479.393,
              779.274,
              4132.225
            ],
            [
              -4503.366,
              773.007,
              4157.004
            ],
            [
              -4524.836,
              762.245,
              4181.02
            ],
            [
              -4546.478,
              741.466,
              4211.022
            ],
            [
              -4558.582,
              712.731,
              4242.203
            ],
            [
              -4564.028,
              688.195,
              4267.336
            ],
            [
              -4562.176,
              653.793,
              4301.788
            ],
            [
              -4542.083,
              471.996,
              4484.692
            ],
            [
              -4535.565,
              436.694,
              4520.59
            ],
            [
              -4533.311,
              419.524,
              4537.908
            ],
            [
              -4527.744,
              368.221,
              4589.512
            ],
            [
              -4516.259,
              323.495,
              4635.689
            ],
            [
              -4491.638,
              255.166,
              4708.318
            ],
            [
              -4427.619,
              152.763,
              4829.086
            ],
            [
              -4367.011,
              77.134,
              4926.004
            ],
            [
              -4080.333,
              -210.913,
              5332.397
            ],
            [
              -3954.469,
              -380.846,
              5543.865
            ],
            [
              -3926.158,
              -422.036,
              5593.847
            ],
            [
              -3919.036,
              -433.74,
              5607.548
            ],
            [
              -3857.936,
              -540.596,
              5730.638
            ],
            [
              -3823.641,
              -607.984,
              5806.251
            ],
            [
              -3766.483,
              -732.543,
              5943.299
            ],
            [
              -3707.64,
              -908.34,
              6128.682
            ],
            [
              -3695.741,
              -928.584,
              6152.164
            ],
            [
              -3679.687,
              -950.175,
              6179.07
            ],
            [
              -3668.232,
              -978.044,
              6209.201
            ],
            [
              -3606.925,
              -1085.98,
              6333.333
            ],
            [
              -3586.062,
              -1109.72,
              6364.938
            ],
            [
              -3575.241,
              -1117.701,
              6378.383
            ],
            [
              -3510.801,
              -1144.012,
              6447.988
            ],
            [
              -3355.367,
              -1190.556,
              6610.241
            ],
            [
              -3109.19,
              -1234.288,
              6860.272
            ],
            [
              -3070.013,
              -1242.306,
              6900.261
            ],
            [
              -2879.155,
              -1277.94,
              7094.417
            ],
            [
              -2839.273,
              -1283.094,
              7134.631
            ],
            [
              -2787.087,
              -1285.125,
              7186.856
            ],
            [
              -2748.376,
              -1283.58,
              7225.598
            ],
            [
              -2714.118,
              -1278.617,
              7260.214
            ],
            [
              -2670.7,
              -1266.023,
              7305.422
            ],
            [
              -2624.585,
              -1246.798,
              7355.383
            ],
            [
              -2499.949,
              -1183.085,
              7495.36
            ],
            [
              -2469.831,
              -1172.717,
              7527.213
            ],
            [
              -2418.716,
              -1162.489,
              7579.341
            ],
            [
              -2392.231,
              -1159.617,
              7605.981
            ],
            [
              -2152.041,
              -1187.387,
              7847.771
            ],
            [
              -2126.526,
              -1191.159,
              7873.563
            ],
            [
              -2118.854,
              -1195.63,
              7882.443
            ],
            [
              -1948.388,
              -1217.583,
              8054.317
            ],
            [
              -1827.9,
              -1221.953,
              8174.884
            ],
            [
              -1794.345,
              -1220.324,
              8208.479
            ],
            [
              -1747.175,
              -1214.486,
              8256.009
            ],
            [
              -1624.316,
              -1194.413,
              8380.497
            ],
            [
              -1544.075,
              -1178.035,
              8462.392
            ],
            [
              -1435.713,
              -1149.425,
              8574.468
            ],
            [
              -1393.22,
              -1142.883,
              8617.461
            ],
            [
              -1155.149,
              -1098.17,
              8859.694
            ],
            [
              -1103.532,
              -1084.281,
              8913.148
            ],
            [
              -1061.953,
              -1078.693,
              8955.1
            ],
            [
              -1023.12,
              -1070.486,
              8994.791
            ],
            [
              -991.176,
              -1051.022,
              9032.198
            ],
            [
              -945.757,
              -1035.141,
              9080.313
            ],
            [
              -919.956,
              -1036.204,
              9106.136
            ],
            [
              -900.214,
              -1048.207,
              9129.241
            ],
            [
              -890.221,
              -1066.198,
              9149.821
            ],
            [
              -873.824,
              -1086.532,
              9175.942
            ],
            [
              -856.017,
              -1100.212,
              9198.397
            ],
            [
              -827.072,
              -1104.073,
              9227.599
            ],
            [
              -688.757,
              -1085.417,
              9367.166
            ],
            [
              -656.163,
              -1208.462,
              9494.455
            ],
            [
              -632.999,
              -1246.73,
              9539.188
            ],
            [
              -612.813,
              -1224.107,
              9569.507
            ],
            [
              -548.807,
              -1190.364,
              9641.863
            ],
            [
              -430.03,
              -1146.872,
              9768.352
            ],
            [
              -296.224,
              -1092.523,
              9912.775
            ],
            [
              -252.864,
              -1158.755,
              9991.937
            ],
            [
              -249.072,
              -1204.678,
              10038.017
            ],
            [
              -223.613,
              -1384.162,
              10219.298
            ],
            [
              -216.864,
              -1409.009,
              10245.045
            ],
            [
              -200.929,
              -1441.11,
              10280.883
            ],
            [
              -189.352,
              -1453.095,
              10297.546
            ],
            [
              -182.693,
              -1458.503,
              10306.125
            ],
            [
              -181.32,
              -1464.963,
              10312.729
            ],
            [
              -182.467,
              -1477.356,
              10325.174
            ],
            [
              -168.478,
              -1604.657,
              10453.242
            ],
            [
              -167.798,
              -1655.759,
              10504.348
            ],
            [
              -156.792,
              -1757.43,
              10606.614
            ],
            [
              91.167,
              -1735.227,
              10855.565
            ],
            [
              238.547,
              -1717.597,
              11003.995
            ],
            [
              330.69,
              -1716.223,
              11096.149
            ],
            [
              544.836,
              -1710.126,
              11310.382
            ],
            [
              573.294,
              -1705.081,
              11339.283
            ],
            [
              608.985,
              -1692.377,
              11377.168
            ],
            [
              629.004,
              -1690.518,
              11397.273
            ],
            [
              692.096,
              -1810.228,
              11532.592
            ],
            [
              696.368,
              -1819.94,
              11543.202
            ],
            [
              713.36,
              -1871.299,
              11597.298
            ],
            [
              776.616,
              -2147.432,
              11880.584
            ],
            [
              787.286,
              -2195.757,
              11930.073
            ],
            [
              791.563,
              -2252.452,
              11986.929
            ],
            [
              803.126,
              -2297.432,
              12033.372
            ],
            [
              810.049,
              -2322.85,
              12059.716
            ],
            [
              815.482,
              -2347.417,
              12084.876
            ],
            [
              839.035,
              -2433.57,
              12174.19
            ],
            [
              880.709,
              -2566.011,
              12313.033
            ],
            [
              897.973,
              -2653.975,
              12402.675
            ],
            [
              898.288,
              -2661.896,
              12410.603
            ],
            [
              905.605,
              -2670.265,
              12421.72
            ],
            [
              909.345,
              -2669.084,
              12425.641
            ],
            [
              920.843,
              -2665.533,
              12437.675
            ],
            [
              979.504,
              -2648.954,
              12498.634
            ],
            [
              1030.623,
              -2635.258,
              12551.556
            ],
            [
              1259.04,
              -2573.328,
              12788.219
            ],
            [
              1329.708,
              -2568.104,
              12859.08
            ],
            [
              1359.181,
              -2574.537,
              12889.247
            ],
            [
              1423.013,
              -2573.493,
              12953.088
            ],
            [
              1423.056,
              -2568.528,
              12958.053
            ],
            [
              1406.874,
              -2540.387,
              12990.515
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:16622",
              "position": {
                "x": -5500.051,
                "z": 2967.452
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 0.662,
              "arrivalOffsetSeconds": -120,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:3560",
              "position": {
                "x": -5262.256,
                "z": 2531.491
              },
              "distanceAlongShapeM": 574.79,
              "shapeOffsetM": 4.195,
              "arrivalOffsetSeconds": 60,
              "departureOffsetSeconds": 60
            },
            {
              "stopId": "judu:stop:756",
              "position": {
                "x": -5151.175,
                "z": 2121.056
              },
              "distanceAlongShapeM": 1043.007,
              "shapeOffsetM": 3.165,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:437",
              "position": {
                "x": -4928.804,
                "z": 1730.978
              },
              "distanceAlongShapeM": 1622.566,
              "shapeOffsetM": 3.896,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:5691",
              "position": {
                "x": -4547.361,
                "z": 1815.72
              },
              "distanceAlongShapeM": 2057.979,
              "shapeOffsetM": 5.676,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:5693",
              "position": {
                "x": -4066.123,
                "z": 1738.403
              },
              "distanceAlongShapeM": 2560.854,
              "shapeOffsetM": 5.445,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:5697",
              "position": {
                "x": -3968.906,
                "z": 1391.627
              },
              "distanceAlongShapeM": 2925.655,
              "shapeOffsetM": 4.537,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:5701",
              "position": {
                "x": -3876.172,
                "z": 1010.417
              },
              "distanceAlongShapeM": 3319.26,
              "shapeOffsetM": 4.978,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:5704",
              "position": {
                "x": -4175.491,
                "z": 710.581
              },
              "distanceAlongShapeM": 3776.148,
              "shapeOffsetM": 4.809,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:1071",
              "position": {
                "x": -4530.426,
                "z": 437.286
              },
              "distanceAlongShapeM": 4520.672,
              "shapeOffsetM": 5.172,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:1004",
              "position": {
                "x": -4077.229,
                "z": -208.399
              },
              "distanceAlongShapeM": 5332.397,
              "shapeOffsetM": 3.995,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:6649",
              "position": {
                "x": -3921.604,
                "z": -419.265
              },
              "distanceAlongShapeM": 5593.847,
              "shapeOffsetM": 5.33,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            },
            {
              "stopId": "judu:stop:6643",
              "position": {
                "x": -3679.35,
                "z": -950.021
              },
              "distanceAlongShapeM": 6179.07,
              "shapeOffsetM": 0.37,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:7416",
              "position": {
                "x": -3108.49,
                "z": -1230.499
              },
              "distanceAlongShapeM": 6860.272,
              "shapeOffsetM": 3.854,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:6398",
              "position": {
                "x": -2151.528,
                "z": -1183.918
              },
              "distanceAlongShapeM": 7847.771,
              "shapeOffsetM": 3.507,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:6396",
              "position": {
                "x": -1436.465,
                "z": -1145.449
              },
              "distanceAlongShapeM": 8574.468,
              "shapeOffsetM": 4.046,
              "arrivalOffsetSeconds": 1380,
              "departureOffsetSeconds": 1380
            },
            {
              "stopId": "judu:stop:6397",
              "position": {
                "x": -1103.929,
                "z": -1082.392
              },
              "distanceAlongShapeM": 8913.148,
              "shapeOffsetM": 1.931,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            },
            {
              "stopId": "judu:stop:17495",
              "position": {
                "x": -615.134,
                "z": -1221.449
              },
              "distanceAlongShapeM": 9569.507,
              "shapeOffsetM": 3.529,
              "arrivalOffsetSeconds": 1620,
              "departureOffsetSeconds": 1620
            },
            {
              "stopId": "judu:stop:17317",
              "position": {
                "x": -250.988,
                "z": -1157.912
              },
              "distanceAlongShapeM": 9991.937,
              "shapeOffsetM": 2.057,
              "arrivalOffsetSeconds": 1740,
              "departureOffsetSeconds": 1740
            },
            {
              "stopId": "judu:stop:17313",
              "position": {
                "x": -178.826,
                "z": -1515.457
              },
              "distanceAlongShapeM": 10363.446,
              "shapeOffsetM": 0.542,
              "arrivalOffsetSeconds": 1800,
              "departureOffsetSeconds": 1800
            },
            {
              "stopId": "judu:stop:17318",
              "position": {
                "x": -103.866,
                "z": -1753.939
              },
              "distanceAlongShapeM": 10659.64,
              "shapeOffsetM": 1.243,
              "arrivalOffsetSeconds": 1920,
              "departureOffsetSeconds": 1920
            },
            {
              "stopId": "judu:stop:7691",
              "position": {
                "x": 238.49,
                "z": -1716.765
              },
              "distanceAlongShapeM": 11003.995,
              "shapeOffsetM": 0.834,
              "arrivalOffsetSeconds": 2040,
              "departureOffsetSeconds": 2040
            },
            {
              "stopId": "judu:stop:7331",
              "position": {
                "x": 704.051,
                "z": -1816.579
              },
              "distanceAlongShapeM": 11543.202,
              "shapeOffsetM": 8.386,
              "arrivalOffsetSeconds": 2160,
              "departureOffsetSeconds": 2160
            },
            {
              "stopId": "judu:stop:9638",
              "position": {
                "x": 808.047,
                "z": -2296.071
              },
              "distanceAlongShapeM": 12033.278,
              "shapeOffsetM": 5.105,
              "arrivalOffsetSeconds": 2280,
              "departureOffsetSeconds": 2280
            },
            {
              "stopId": "judu:stop:18532",
              "position": {
                "x": 978.247,
                "z": -2644.311
              },
              "distanceAlongShapeM": 12498.634,
              "shapeOffsetM": 4.81,
              "arrivalOffsetSeconds": 2400,
              "departureOffsetSeconds": 2400
            },
            {
              "stopId": "judu:stop:9566",
              "position": {
                "x": 1329.768,
                "z": -2561.746
              },
              "distanceAlongShapeM": 12859.08,
              "shapeOffsetM": 6.358,
              "arrivalOffsetSeconds": 2460,
              "departureOffsetSeconds": 2460
            },
            {
              "stopId": "judu:stop:15167",
              "position": {
                "x": 1413.343,
                "z": -2538.803
              },
              "distanceAlongShapeM": 12988.663,
              "shapeOffsetM": 6.397,
              "arrivalOffsetSeconds": 2520,
              "departureOffsetSeconds": 2520
            }
          ],
          "departuresSeconds": [
            20520,
            22440,
            24660,
            26700,
            28800,
            30000,
            32040,
            35280,
            36600,
            37800,
            40380,
            42600,
            44880,
            47040,
            49260,
            51480,
            53640,
            55860,
            57960,
            60060,
            61740,
            63420,
            65340,
            67260,
            69360,
            72000,
            73680,
            76080,
            78240,
            80280,
            82320,
            84420
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_bus_73",
      "sourceRouteId": "vilnius_bus_73",
      "mode": "bus",
      "shortName": "73",
      "longName": "Justiniškės–Centras–Naugarduko g.–Vilkpėdė (Apylanka Rygos g.)",
      "color": "0073AC",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_bus_73:0",
          "sourceRouteId": "vilnius_bus_73",
          "sourceShapeId": "vilnius_bus_73_a1-b",
          "directionId": 0,
          "headsign": "Vilkpėdė (Apylanka Rygos g.)",
          "directionName": "Justiniškės–Centras–Naugarduko g.–Vilkpėdė (Apylanka Rygos g.)",
          "mode": "bus",
          "routeShortName": "73",
          "routeLongName": "Justiniškės–Centras–Naugarduko g.–Vilkpėdė (Apylanka Rygos g.)",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              -4258.81,
              -2245.769,
              0
            ],
            [
              -4261.214,
              -2235.708,
              10.344
            ],
            [
              -4255.906,
              -2226.894,
              20.633
            ],
            [
              -4235.795,
              -2219.449,
              42.078
            ],
            [
              -4226.11,
              -2218.503,
              51.809
            ],
            [
              -4222.301,
              -2221.909,
              56.919
            ],
            [
              -4216.3,
              -2247.616,
              83.317
            ],
            [
              -4210.635,
              -2255.507,
              93.031
            ],
            [
              -4196.209,
              -2315.87,
              155.094
            ],
            [
              -4165.8,
              -2421.037,
              264.569
            ],
            [
              -4138.614,
              -2526.149,
              373.14
            ],
            [
              -4123.397,
              -2733.522,
              581.07
            ],
            [
              -4112.669,
              -2926.241,
              774.088
            ],
            [
              -4111.492,
              -2948.652,
              796.53
            ],
            [
              -4174.702,
              -3308.112,
              1161.505
            ],
            [
              -4109.871,
              -3292.845,
              1228.109
            ],
            [
              -4018.747,
              -3270.737,
              1321.877
            ],
            [
              -3940.176,
              -3236.477,
              1407.592
            ],
            [
              -3823.754,
              -3175.046,
              1539.227
            ],
            [
              -3810.118,
              -3166.508,
              1555.315
            ],
            [
              -3714.539,
              -3118.094,
              1662.457
            ],
            [
              -3714.983,
              -3109.031,
              1671.532
            ],
            [
              -3663.87,
              -3096.551,
              1724.146
            ],
            [
              -3644.524,
              -3091.72,
              1744.086
            ],
            [
              -3537.19,
              -3076.506,
              1852.493
            ],
            [
              -3288.387,
              -3074.173,
              2101.307
            ],
            [
              -3226.908,
              -3059.664,
              2164.475
            ],
            [
              -3088.313,
              -3020.904,
              2308.388
            ],
            [
              -3076.179,
              -3017.184,
              2321.079
            ],
            [
              -3065.414,
              -3014.303,
              2332.223
            ],
            [
              -3011.076,
              -2998.586,
              2388.788
            ],
            [
              -2972.094,
              -2983.696,
              2430.517
            ],
            [
              -2923.591,
              -2962.569,
              2483.422
            ],
            [
              -2796.251,
              -2867.959,
              2642.062
            ],
            [
              -2713.249,
              -2802.628,
              2747.69
            ],
            [
              -2678.551,
              -2772.069,
              2793.927
            ],
            [
              -2644.38,
              -2734.822,
              2844.474
            ],
            [
              -2633.43,
              -2718.353,
              2864.25
            ],
            [
              -2600.033,
              -2668.811,
              2923.998
            ],
            [
              -2574.02,
              -2619.176,
              2980.037
            ],
            [
              -2545.641,
              -2545.091,
              3059.371
            ],
            [
              -2520.523,
              -2473.175,
              3135.548
            ],
            [
              -2499.973,
              -2404.518,
              3207.214
            ],
            [
              -2490.126,
              -2357.937,
              3254.824
            ],
            [
              -2467.791,
              -2224.746,
              3389.875
            ],
            [
              -2432.042,
              -2227.602,
              3425.738
            ],
            [
              -2417.854,
              -2231.757,
              3440.522
            ],
            [
              -2373.845,
              -2246.595,
              3486.965
            ],
            [
              -2196.773,
              -2317.488,
              3677.701
            ],
            [
              -2137.794,
              -2339.218,
              3740.557
            ],
            [
              -2071.077,
              -2358.315,
              3809.953
            ],
            [
              -1991.404,
              -2367.89,
              3890.199
            ],
            [
              -1948.857,
              -2368.231,
              3932.747
            ],
            [
              -1899.081,
              -2359.513,
              3983.281
            ],
            [
              -1862.838,
              -2351.253,
              4020.453
            ],
            [
              -1818.039,
              -2333.126,
              4068.78
            ],
            [
              -1763.981,
              -2301.806,
              4131.256
            ],
            [
              -1728.668,
              -2273.492,
              4176.519
            ],
            [
              -1675.636,
              -2214.729,
              4255.673
            ],
            [
              -1645.063,
              -2175.906,
              4305.089
            ],
            [
              -1547.472,
              -2017.345,
              4491.276
            ],
            [
              -1343.434,
              -1674.784,
              4889.999
            ],
            [
              -1305.861,
              -1628.702,
              4949.457
            ],
            [
              -1268.647,
              -1602.651,
              4994.883
            ],
            [
              -1054.592,
              -1494.059,
              5234.908
            ],
            [
              -1027.103,
              -1471.176,
              5270.675
            ],
            [
              -1009.966,
              -1450.333,
              5297.658
            ],
            [
              -998.422,
              -1410.718,
              5338.921
            ],
            [
              -987.78,
              -1363.9,
              5386.933
            ],
            [
              -988.723,
              -1201.352,
              5549.484
            ],
            [
              -990.397,
              -1186.85,
              5564.082
            ],
            [
              -1017.615,
              -1122.906,
              5633.578
            ],
            [
              -1020.518,
              -1105.042,
              5651.676
            ],
            [
              -1018.304,
              -1089.497,
              5667.378
            ],
            [
              -1013.532,
              -1075.111,
              5682.535
            ],
            [
              -1005.537,
              -1060.783,
              5698.942
            ],
            [
              -990.532,
              -1051.034,
              5716.836
            ],
            [
              -976.596,
              -1029.02,
              5742.891
            ],
            [
              -969.87,
              -1013.556,
              5759.754
            ],
            [
              -967.031,
              -999.135,
              5774.452
            ],
            [
              -963.614,
              -973.419,
              5800.394
            ],
            [
              -954.808,
              -934.814,
              5839.991
            ],
            [
              -945.547,
              -916.03,
              5860.934
            ],
            [
              -940.714,
              -898.305,
              5879.306
            ],
            [
              -936.79,
              -859.413,
              5918.395
            ],
            [
              -924.604,
              -648.119,
              6130.04
            ],
            [
              -926.501,
              -610.235,
              6167.972
            ],
            [
              -934.701,
              -600.068,
              6181.033
            ],
            [
              -944.29,
              -595.443,
              6191.68
            ],
            [
              -952.65,
              -594.179,
              6200.135
            ],
            [
              -963.004,
              -596.219,
              6210.688
            ],
            [
              -972.833,
              -604.948,
              6223.833
            ],
            [
              -992.823,
              -641.327,
              6265.342
            ],
            [
              -992.319,
              -666.855,
              6290.875
            ],
            [
              -989.606,
              -677.006,
              6301.383
            ],
            [
              -978.263,
              -691.682,
              6319.931
            ],
            [
              -964.927,
              -703.054,
              6337.457
            ],
            [
              -939.343,
              -714.647,
              6365.545
            ],
            [
              -865.474,
              -730.449,
              6441.086
            ],
            [
              -798.395,
              -729.432,
              6508.172
            ],
            [
              -764.735,
              -722.247,
              6542.591
            ],
            [
              -714.638,
              -697.546,
              6598.446
            ],
            [
              -690.623,
              -676.974,
              6630.068
            ],
            [
              -655.859,
              -656.305,
              6670.512
            ],
            [
              -601.451,
              -607.193,
              6743.808
            ],
            [
              -500.911,
              -503.255,
              6888.416
            ],
            [
              -413.017,
              -421.354,
              7008.553
            ],
            [
              -450.326,
              -380.602,
              7063.805
            ],
            [
              -465.596,
              -369.193,
              7082.866
            ],
            [
              -470.512,
              -355.745,
              7097.184
            ],
            [
              -508.466,
              -314.982,
              7152.881
            ],
            [
              -611.52,
              -58.189,
              7429.581
            ],
            [
              -614.075,
              -53.155,
              7435.227
            ],
            [
              -625.745,
              -24.535,
              7466.134
            ],
            [
              -643.846,
              18.014,
              7512.373
            ],
            [
              -652.524,
              63.893,
              7559.066
            ],
            [
              -679.973,
              222.467,
              7719.998
            ],
            [
              -691.721,
              250.51,
              7750.402
            ],
            [
              -832.714,
              443.415,
              7989.34
            ],
            [
              -840.816,
              459.146,
              8007.035
            ],
            [
              -843.214,
              469.208,
              8017.379
            ],
            [
              -833.842,
              667.193,
              8215.586
            ],
            [
              -824.076,
              731.394,
              8280.525
            ],
            [
              -800.789,
              819.11,
              8371.28
            ],
            [
              -787.05,
              855.14,
              8409.84
            ],
            [
              -767.948,
              887.538,
              8447.45
            ],
            [
              -708.773,
              1021.171,
              8593.599
            ],
            [
              -697.048,
              1063.262,
              8637.293
            ],
            [
              -655.787,
              1240.633,
              8819.4
            ],
            [
              -653.864,
              1286.859,
              8865.665
            ],
            [
              -631.67,
              1361.539,
              8943.574
            ],
            [
              -586.657,
              1567.786,
              9154.676
            ],
            [
              -622.389,
              1588.449,
              9195.952
            ],
            [
              -767.651,
              1691.281,
              9373.928
            ],
            [
              -977.15,
              1861.698,
              9643.987
            ],
            [
              -1190.297,
              2047.317,
              9926.628
            ],
            [
              -1514.694,
              2380.408,
              10391.583
            ],
            [
              -1536.735,
              2401.048,
              10421.779
            ],
            [
              -1585.57,
              2434.895,
              10481.197
            ],
            [
              -1589.092,
              2441.85,
              10488.993
            ],
            [
              -1665.298,
              2474.379,
              10571.851
            ],
            [
              -1973.715,
              2584.507,
              10899.34
            ],
            [
              -1980.067,
              2590.186,
              10907.861
            ],
            [
              -1990.862,
              2563.661,
              10936.498
            ],
            [
              -1996.181,
              2554.849,
              10946.791
            ],
            [
              -2002.73,
              2549.399,
              10955.311
            ],
            [
              -2004.613,
              2546.083,
              10959.125
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:6990",
              "position": {
                "x": -4210.635,
                "z": -2255.507
              },
              "distanceAlongShapeM": 93.031,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:6993",
              "position": {
                "x": -4108.545,
                "z": -2948.576
              },
              "distanceAlongShapeM": 796.53,
              "shapeOffsetM": 2.948,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:15412",
              "position": {
                "x": -4111.181,
                "z": -3286.947
              },
              "distanceAlongShapeM": 1228.227,
              "shapeOffsetM": 6.04,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:7001",
              "position": {
                "x": -3665.065,
                "z": -3092.089
              },
              "distanceAlongShapeM": 1724.044,
              "shapeOffsetM": 4.618,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:855",
              "position": {
                "x": -3013.674,
                "z": -2991.043
              },
              "distanceAlongShapeM": 2388.389,
              "shapeOffsetM": 7.967,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:394",
              "position": {
                "x": -2636.314,
                "z": -2716.04
              },
              "distanceAlongShapeM": 2864.557,
              "shapeOffsetM": 3.684,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:1069",
              "position": {
                "x": -2415.576,
                "z": -2224.555
              },
              "distanceAlongShapeM": 3440.522,
              "shapeOffsetM": 7.553,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:5220",
              "position": {
                "x": -1001.511,
                "z": -1410.409
              },
              "distanceAlongShapeM": 5338.353,
              "shapeOffsetM": 3.052,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:5533",
              "position": {
                "x": -969.129,
                "z": -972.38
              },
              "distanceAlongShapeM": 5800.394,
              "shapeOffsetM": 5.612,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:5539",
              "position": {
                "x": -692.924,
                "z": -673.447
              },
              "distanceAlongShapeM": 6630.068,
              "shapeOffsetM": 4.211,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:5257",
              "position": {
                "x": -465.596,
                "z": -369.193
              },
              "distanceAlongShapeM": 7082.866,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1380,
              "departureOffsetSeconds": 1380
            },
            {
              "stopId": "judu:stop:5264",
              "position": {
                "x": -646.921,
                "z": 17.037
              },
              "distanceAlongShapeM": 7512.373,
              "shapeOffsetM": 3.227,
              "arrivalOffsetSeconds": 1500,
              "departureOffsetSeconds": 1500
            },
            {
              "stopId": "judu:stop:5266",
              "position": {
                "x": -793.638,
                "z": 857.944
              },
              "distanceAlongShapeM": 8409.84,
              "shapeOffsetM": 7.159,
              "arrivalOffsetSeconds": 1740,
              "departureOffsetSeconds": 1740
            },
            {
              "stopId": "judu:stop:5272",
              "position": {
                "x": -656.233,
                "z": 1287.397
              },
              "distanceAlongShapeM": 8865.665,
              "shapeOffsetM": 2.429,
              "arrivalOffsetSeconds": 1860,
              "departureOffsetSeconds": 1860
            },
            {
              "stopId": "judu:stop:5645",
              "position": {
                "x": -623.076,
                "z": 1587.369
              },
              "distanceAlongShapeM": 9195.952,
              "shapeOffsetM": 1.28,
              "arrivalOffsetSeconds": 1920,
              "departureOffsetSeconds": 1920
            },
            {
              "stopId": "judu:stop:5649",
              "position": {
                "x": -978.813,
                "z": 1859.839
              },
              "distanceAlongShapeM": 9644.02,
              "shapeOffsetM": 2.494,
              "arrivalOffsetSeconds": 2040,
              "departureOffsetSeconds": 2040
            },
            {
              "stopId": "judu:stop:9701",
              "position": {
                "x": -1232.774,
                "z": 2089.268
              },
              "distanceAlongShapeM": 9986.318,
              "shapeOffsetM": 1.161,
              "arrivalOffsetSeconds": 2160,
              "departureOffsetSeconds": 2160
            },
            {
              "stopId": "judu:stop:7941",
              "position": {
                "x": -1586.671,
                "z": 2432.901
              },
              "distanceAlongShapeM": 10480.966,
              "shapeOffsetM": 2.266,
              "arrivalOffsetSeconds": 2280,
              "departureOffsetSeconds": 2280
            },
            {
              "stopId": "judu:stop:19255",
              "position": {
                "x": -2002.849,
                "z": 2542.722
              },
              "distanceAlongShapeM": 10959.125,
              "shapeOffsetM": 3.796,
              "arrivalOffsetSeconds": 2340,
              "departureOffsetSeconds": 2340
            }
          ],
          "departuresSeconds": [
            19440,
            20700,
            22080,
            23040,
            23940,
            25200,
            26940,
            28440,
            30360,
            32040,
            33960,
            36120,
            38400,
            40320,
            42240,
            44400,
            46560,
            48420,
            50580,
            52740,
            54660,
            56100,
            57120,
            57960,
            59640,
            61560,
            63240,
            64980,
            66540,
            68940,
            71040,
            73200,
            75000,
            76680,
            78780,
            80460,
            81900
          ]
        },
        {
          "id": "judu:pattern:vilnius_bus_73:1",
          "sourceRouteId": "vilnius_bus_73",
          "sourceShapeId": "vilnius_bus_73_b-a1",
          "directionId": 1,
          "headsign": "Justiniškės (Apylanka Rygos g.)",
          "directionName": "Vilkpėdė–Naugarduko g.–Centras–Justiniškės (Apylanka Rygos g.)",
          "mode": "bus",
          "routeShortName": "73",
          "routeLongName": "Justiniškės–Centras–Naugarduko g.–Vilkpėdė (Apylanka Rygos g.)",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              -2004.833,
              2545.942,
              0
            ],
            [
              -2009.26,
              2545.063,
              4.513
            ],
            [
              -2019.015,
              2540.783,
              15.166
            ],
            [
              -2077.913,
              2530.695,
              74.921
            ],
            [
              -2082.858,
              2558.783,
              103.441
            ],
            [
              -2083.009,
              2570.861,
              115.52
            ],
            [
              -2085.436,
              2584.647,
              129.518
            ],
            [
              -2057.496,
              2590.447,
              158.053
            ],
            [
              -2049.628,
              2587.512,
              166.451
            ],
            [
              -2043.42,
              2571.065,
              184.031
            ],
            [
              -2044.167,
              2564.653,
              190.486
            ],
            [
              -2036.471,
              2538.866,
              217.397
            ],
            [
              -2016.375,
              2544.076,
              238.157
            ],
            [
              -2000.11,
              2551.579,
              256.07
            ],
            [
              -1974.301,
              2587.857,
              300.591
            ],
            [
              -1936.092,
              2569.619,
              342.93
            ],
            [
              -1765.274,
              2512.896,
              522.92
            ],
            [
              -1632.053,
              2457.088,
              667.358
            ],
            [
              -1568.278,
              2436.193,
              734.469
            ],
            [
              -1527.823,
              2404.02,
              786.157
            ],
            [
              -1400.63,
              2277.747,
              965.386
            ],
            [
              -1328.942,
              2195.633,
              1074.39
            ],
            [
              -1190.297,
              2047.317,
              1277.417
            ],
            [
              -1176.911,
              2038.172,
              1293.629
            ],
            [
              -1138.946,
              2018.251,
              1336.502
            ],
            [
              -1124.175,
              1992.697,
              1366.019
            ],
            [
              -768.296,
              1691.292,
              1832.382
            ],
            [
              -743.098,
              1677.396,
              1861.158
            ],
            [
              -730.212,
              1669.079,
              1876.494
            ],
            [
              -624.909,
              1600.54,
              2002.138
            ],
            [
              -585.791,
              1580.016,
              2046.313
            ],
            [
              -581.357,
              1575.483,
              2052.654
            ],
            [
              -578.293,
              1566.522,
              2062.125
            ],
            [
              -659.332,
              1222.885,
              2415.188
            ],
            [
              -678.532,
              1124.155,
              2515.768
            ],
            [
              -683.338,
              1093.819,
              2546.482
            ],
            [
              -691.829,
              1066.507,
              2575.083
            ],
            [
              -722.413,
              980.227,
              2666.624
            ],
            [
              -789.726,
              824.476,
              2836.298
            ],
            [
              -808.22,
              764.696,
              2898.874
            ],
            [
              -816.493,
              725.027,
              2939.396
            ],
            [
              -824.878,
              699.315,
              2966.441
            ],
            [
              -838.2,
              496.948,
              3169.246
            ],
            [
              -838.156,
              463.551,
              3202.643
            ],
            [
              -823.183,
              435.45,
              3234.484
            ],
            [
              -689.434,
              255.78,
              3458.47
            ],
            [
              -671.067,
              215.627,
              3502.625
            ],
            [
              -634.631,
              19.041,
              3702.559
            ],
            [
              -585.127,
              -96.516,
              3828.273
            ],
            [
              -572.146,
              -122.078,
              3856.943
            ],
            [
              -567.275,
              -143.594,
              3879.003
            ],
            [
              -513.161,
              -289.293,
              4034.427
            ],
            [
              -501.093,
              -299.53,
              4050.252
            ],
            [
              -508.466,
              -314.982,
              4067.373
            ],
            [
              -534.259,
              -344.928,
              4106.896
            ],
            [
              -695.752,
              -508.638,
              4336.854
            ],
            [
              -754.191,
              -530.962,
              4399.412
            ],
            [
              -813.838,
              -548.811,
              4461.672
            ],
            [
              -813.802,
              -550.154,
              4463.016
            ],
            [
              -859.203,
              -561.352,
              4509.777
            ],
            [
              -898.246,
              -574.502,
              4550.976
            ],
            [
              -908.595,
              -582.727,
              4564.195
            ],
            [
              -919.624,
              -908.704,
              4890.358
            ],
            [
              -906.184,
              -950.135,
              4933.915
            ],
            [
              -904.723,
              -968.011,
              4951.85
            ],
            [
              -906.763,
              -1018.032,
              5001.913
            ],
            [
              -903.416,
              -1047.036,
              5031.109
            ],
            [
              -878.9,
              -1081.988,
              5073.802
            ],
            [
              -875.273,
              -1095.412,
              5087.708
            ],
            [
              -879.138,
              -1130.965,
              5123.47
            ],
            [
              -892.47,
              -1155.216,
              5151.144
            ],
            [
              -917.464,
              -1182.597,
              5188.217
            ],
            [
              -926.283,
              -1206.929,
              5214.098
            ],
            [
              -917.431,
              -1323.977,
              5331.48
            ],
            [
              -911.942,
              -1448.758,
              5456.382
            ],
            [
              -922.391,
              -1491.986,
              5500.855
            ],
            [
              -939.829,
              -1529.521,
              5542.243
            ],
            [
              -961.618,
              -1558.073,
              5578.159
            ],
            [
              -995.732,
              -1590.856,
              5625.472
            ],
            [
              -1026.383,
              -1610.342,
              5661.792
            ],
            [
              -1072.441,
              -1626.213,
              5710.508
            ],
            [
              -1262.636,
              -1662.874,
              5904.204
            ],
            [
              -1320.472,
              -1688.554,
              5967.485
            ],
            [
              -1382.029,
              -1741.999,
              6049.006
            ],
            [
              -1597.414,
              -2106.624,
              6472.494
            ],
            [
              -1645.063,
              -2175.906,
              6556.58
            ],
            [
              -1682.619,
              -2257.615,
              6646.506
            ],
            [
              -1702.963,
              -2314.026,
              6706.474
            ],
            [
              -1715.793,
              -2345.231,
              6740.214
            ],
            [
              -1755.799,
              -2415.464,
              6821.041
            ],
            [
              -1791.442,
              -2468.3,
              6884.776
            ],
            [
              -1797.501,
              -2485.334,
              6902.855
            ],
            [
              -1794.575,
              -2499.414,
              6917.236
            ],
            [
              -1786.456,
              -2514.031,
              6933.956
            ],
            [
              -1773.708,
              -2522.051,
              6949.017
            ],
            [
              -1755.022,
              -2522.384,
              6967.706
            ],
            [
              -1739.399,
              -2513.757,
              6985.553
            ],
            [
              -1728.911,
              -2503.925,
              6999.929
            ],
            [
              -1701.579,
              -2453.204,
              7057.545
            ],
            [
              -1699.467,
              -2443.223,
              7067.747
            ],
            [
              -1706.803,
              -2420.827,
              7091.314
            ],
            [
              -1718.536,
              -2413.488,
              7105.154
            ],
            [
              -1731.05,
              -2407.036,
              7119.233
            ],
            [
              -1888.196,
              -2401.495,
              7276.476
            ],
            [
              -1933.866,
              -2394.517,
              7322.676
            ],
            [
              -2056.217,
              -2387.889,
              7445.207
            ],
            [
              -2112.006,
              -2376.568,
              7502.133
            ],
            [
              -2168.467,
              -2356.953,
              7561.904
            ],
            [
              -2218.449,
              -2337.7,
              7615.466
            ],
            [
              -2387.812,
              -2273.476,
              7796.598
            ],
            [
              -2400.864,
              -2268.936,
              7810.416
            ],
            [
              -2472.07,
              -2248.048,
              7884.623
            ],
            [
              -2473.439,
              -2303.416,
              7940.008
            ],
            [
              -2477.313,
              -2325.88,
              7962.803
            ],
            [
              -2484.017,
              -2376.97,
              8014.331
            ],
            [
              -2514.005,
              -2505.574,
              8146.385
            ],
            [
              -2552.25,
              -2627.352,
              8274.028
            ],
            [
              -2587.598,
              -2694.635,
              8350.031
            ],
            [
              -2669.545,
              -2793.221,
              8478.228
            ],
            [
              -2878.335,
              -2954.459,
              8742.029
            ],
            [
              -2942.823,
              -2993.401,
              8817.363
            ],
            [
              -2993.467,
              -3014.776,
              8872.333
            ],
            [
              -3056.314,
              -3033.711,
              8937.97
            ],
            [
              -3148.249,
              -3057.702,
              9032.984
            ],
            [
              -3175.722,
              -3067.532,
              9062.163
            ],
            [
              -3256.076,
              -3081.304,
              9143.688
            ],
            [
              -3258.184,
              -3079.154,
              9146.699
            ],
            [
              -3398.204,
              -3088.951,
              9287.061
            ],
            [
              -3540.683,
              -3092.03,
              9429.574
            ],
            [
              -3587.831,
              -3097.887,
              9477.084
            ],
            [
              -3688.781,
              -3121.733,
              9580.812
            ],
            [
              -4069.341,
              -3289.974,
              9996.902
            ],
            [
              -4174.702,
              -3308.112,
              10103.813
            ],
            [
              -4173.655,
              -3250.667,
              10161.268
            ],
            [
              -4124.202,
              -3034.023,
              10383.484
            ],
            [
              -4119.192,
              -3005.166,
              10412.773
            ],
            [
              -4115.728,
              -2954.018,
              10464.038
            ],
            [
              -4117.064,
              -2919.485,
              10498.597
            ],
            [
              -4121.349,
              -2884.733,
              10533.612
            ],
            [
              -4139.258,
              -2526.138,
              10892.654
            ],
            [
              -4203.711,
              -2302.381,
              11125.509
            ],
            [
              -4254.136,
              -2273.68,
              11183.53
            ],
            [
              -4258.81,
              -2245.769,
              11211.83
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:19255",
              "position": {
                "x": -2002.849,
                "z": 2542.722
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 3.782,
              "arrivalOffsetSeconds": -660,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:8311",
              "position": {
                "x": -2042.349,
                "z": 2571.254
              },
              "distanceAlongShapeM": 184.031,
              "shapeOffsetM": 1.087,
              "arrivalOffsetSeconds": 60,
              "departureOffsetSeconds": 60
            },
            {
              "stopId": "judu:stop:8309",
              "position": {
                "x": -1563.915,
                "z": 2442.514
              },
              "distanceAlongShapeM": 734.469,
              "shapeOffsetM": 7.681,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:9642",
              "position": {
                "x": -1399.067,
                "z": 2279.266
              },
              "distanceAlongShapeM": 965.386,
              "shapeOffsetM": 2.18,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:5655",
              "position": {
                "x": -1135.911,
                "z": 2021.851
              },
              "distanceAlongShapeM": 1336.502,
              "shapeOffsetM": 4.709,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:6852",
              "position": {
                "x": -740.744,
                "z": 1680.777
              },
              "distanceAlongShapeM": 1861.302,
              "shapeOffsetM": 4.117,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:6853",
              "position": {
                "x": -679.739,
                "z": 1093.006
              },
              "distanceAlongShapeM": 2546.482,
              "shapeOffsetM": 3.689,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:5267",
              "position": {
                "x": -810.251,
                "z": 723.543
              },
              "distanceAlongShapeM": 2939.396,
              "shapeOffsetM": 6.416,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:6736",
              "position": {
                "x": -570.097,
                "z": -121.279
              },
              "distanceAlongShapeM": 3856.943,
              "shapeOffsetM": 2.199,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            },
            {
              "stopId": "judu:stop:5259",
              "position": {
                "x": -532.258,
                "z": -346.835
              },
              "distanceAlongShapeM": 4106.896,
              "shapeOffsetM": 2.765,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:10360",
              "position": {
                "x": -813.253,
                "z": -552.161
              },
              "distanceAlongShapeM": 4463.016,
              "shapeOffsetM": 2.081,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:5534",
              "position": {
                "x": -902.638,
                "z": -968.011
              },
              "distanceAlongShapeM": 4951.85,
              "shapeOffsetM": 2.085,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:5290",
              "position": {
                "x": -1711.936,
                "z": -2347.263
              },
              "distanceAlongShapeM": 6740.214,
              "shapeOffsetM": 4.36,
              "arrivalOffsetSeconds": 1410,
              "departureOffsetSeconds": 1410
            },
            {
              "stopId": "judu:stop:5074",
              "position": {
                "x": -2470.476,
                "z": -2303.737
              },
              "distanceAlongShapeM": 7940.008,
              "shapeOffsetM": 2.98,
              "arrivalOffsetSeconds": 1650,
              "departureOffsetSeconds": 1650
            },
            {
              "stopId": "judu:stop:393",
              "position": {
                "x": -2667.366,
                "z": -2795.644
              },
              "distanceAlongShapeM": 8478.228,
              "shapeOffsetM": 3.259,
              "arrivalOffsetSeconds": 1770,
              "departureOffsetSeconds": 1770
            },
            {
              "stopId": "judu:stop:5137",
              "position": {
                "x": -3175.503,
                "z": -3068.357
              },
              "distanceAlongShapeM": 9062.163,
              "shapeOffsetM": 0.854,
              "arrivalOffsetSeconds": 1890,
              "departureOffsetSeconds": 1890
            },
            {
              "stopId": "judu:stop:15411",
              "position": {
                "x": -3782.29,
                "z": -3162.408
              },
              "distanceAlongShapeM": 9682.783,
              "shapeOffsetM": 0.607,
              "arrivalOffsetSeconds": 1980,
              "departureOffsetSeconds": 1980
            },
            {
              "stopId": "judu:stop:6995",
              "position": {
                "x": -4176.922,
                "z": -3250.186
              },
              "distanceAlongShapeM": 10161.268,
              "shapeOffsetM": 3.302,
              "arrivalOffsetSeconds": 2100,
              "departureOffsetSeconds": 2100
            },
            {
              "stopId": "judu:stop:6992",
              "position": {
                "x": -4123.554,
                "z": -2884.864
              },
              "distanceAlongShapeM": 10533.612,
              "shapeOffsetM": 2.209,
              "arrivalOffsetSeconds": 2160,
              "departureOffsetSeconds": 2160
            },
            {
              "stopId": "judu:stop:18975",
              "position": {
                "x": -4258.81,
                "z": -2245.769
              },
              "distanceAlongShapeM": 11211.83,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2220,
              "departureOffsetSeconds": 2220
            }
          ],
          "departuresSeconds": [
            19800,
            22020,
            23520,
            24960,
            26340,
            27120,
            28440,
            30360,
            31920,
            33900,
            35280,
            37020,
            39000,
            41280,
            43260,
            45180,
            47400,
            49500,
            51420,
            53520,
            55860,
            57960,
            59460,
            60660,
            61440,
            63240,
            65160,
            66720,
            68340,
            70140,
            72000,
            73860,
            75960,
            77640,
            79260,
            81420,
            82920,
            84360
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_bus_74",
      "sourceRouteId": "vilnius_bus_74",
      "mode": "bus",
      "shortName": "74",
      "longName": "Stotis–Subačiaus–Parko g.",
      "color": "0073AC",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_bus_74:0",
          "sourceRouteId": "vilnius_bus_74",
          "sourceShapeId": "vilnius_bus_74_a-b",
          "directionId": 0,
          "headsign": "Parko g.",
          "directionName": "Stotis–Subačiaus–Parko g.",
          "mode": "bus",
          "routeShortName": "74",
          "routeLongName": "Stotis–Subačiaus–Parko g.",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              493.411,
              1911.506,
              0
            ],
            [
              476.616,
              1921.478,
              19.531
            ],
            [
              453.967,
              1920.686,
              42.195
            ],
            [
              432.764,
              1925.527,
              63.943
            ],
            [
              422.444,
              1925.716,
              74.265
            ],
            [
              419.803,
              1922.424,
              78.485
            ],
            [
              402.263,
              1927.258,
              96.68
            ],
            [
              397.27,
              1925.063,
              102.134
            ],
            [
              384.004,
              1905.267,
              125.964
            ],
            [
              371.312,
              1878.4,
              155.677
            ],
            [
              344.166,
              1843.654,
              199.77
            ],
            [
              330.657,
              1810.504,
              235.567
            ],
            [
              391.321,
              1670.242,
              388.386
            ],
            [
              477.846,
              1568.468,
              521.969
            ],
            [
              485.021,
              1572.79,
              530.346
            ],
            [
              495.103,
              1594.87,
              554.618
            ],
            [
              501.968,
              1590.033,
              563.016
            ],
            [
              515.385,
              1586.833,
              576.81
            ],
            [
              552.903,
              1580.453,
              614.866
            ],
            [
              580.038,
              1581.942,
              642.043
            ],
            [
              658.651,
              1577.401,
              720.786
            ],
            [
              692.229,
              1579.012,
              754.403
            ],
            [
              741.723,
              1585.833,
              804.364
            ],
            [
              775.59,
              1587.408,
              838.268
            ],
            [
              809.306,
              1578.914,
              873.037
            ],
            [
              847.494,
              1567.254,
              912.966
            ],
            [
              881.41,
              1552.158,
              950.09
            ],
            [
              943.873,
              1514.16,
              1023.203
            ],
            [
              977.642,
              1498.755,
              1060.32
            ],
            [
              986.83,
              1496.24,
              1069.846
            ],
            [
              1014.875,
              1489.647,
              1098.656
            ],
            [
              1169.279,
              1454.457,
              1257.019
            ],
            [
              1174.911,
              1305.179,
              1406.403
            ],
            [
              1219.91,
              1296.555,
              1452.221
            ],
            [
              1269.292,
              1286.69,
              1502.579
            ],
            [
              1287.836,
              1282.198,
              1521.659
            ],
            [
              1461.257,
              1230.864,
              1702.518
            ],
            [
              1535.192,
              1217.248,
              1777.696
            ],
            [
              1586.927,
              1224.082,
              1829.881
            ],
            [
              1634.086,
              1227.66,
              1877.175
            ],
            [
              1673.656,
              1231.674,
              1916.948
            ],
            [
              1721.874,
              1230.483,
              1965.181
            ],
            [
              1775.523,
              1236.165,
              2019.13
            ],
            [
              1885.773,
              1260.149,
              2131.959
            ],
            [
              1890.6,
              1266.382,
              2139.843
            ],
            [
              1963.37,
              1277.199,
              2213.412
            ],
            [
              2043.065,
              1295.752,
              2295.238
            ],
            [
              2056.65,
              1297.725,
              2308.966
            ],
            [
              2074.707,
              1297.388,
              2327.026
            ],
            [
              2084.797,
              1284.954,
              2343.039
            ],
            [
              2090.422,
              1264.04,
              2364.696
            ],
            [
              2096.23,
              1229.103,
              2400.113
            ],
            [
              2092.782,
              1212.054,
              2417.507
            ],
            [
              2084.488,
              1199.24,
              2432.771
            ],
            [
              2081.118,
              1191.51,
              2441.203
            ],
            [
              2084.435,
              1172.338,
              2460.66
            ],
            [
              2162.024,
              1054.703,
              2601.579
            ],
            [
              2179.433,
              1032.707,
              2629.63
            ],
            [
              2183.916,
              1028.198,
              2635.989
            ],
            [
              2200.631,
              993.348,
              2674.64
            ],
            [
              2292.177,
              852.481,
              2842.64
            ],
            [
              2377.645,
              731.764,
              2990.55
            ],
            [
              2411.777,
              694.387,
              3041.167
            ],
            [
              2429.021,
              676.964,
              3065.681
            ],
            [
              2453.553,
              653.492,
              3099.633
            ],
            [
              2501.276,
              617.009,
              3159.704
            ],
            [
              2634.367,
              525.451,
              3321.246
            ],
            [
              2716.164,
              450.439,
              3432.231
            ],
            [
              2736.291,
              431.885,
              3459.605
            ],
            [
              2755.449,
              412.963,
              3486.532
            ],
            [
              2936.644,
              239.224,
              3737.564
            ],
            [
              2983.62,
              199.374,
              3799.165
            ],
            [
              3033.392,
              162.998,
              3860.813
            ],
            [
              3060.52,
              138.92,
              3897.086
            ],
            [
              3266.423,
              -23.054,
              4159.062
            ],
            [
              3339.574,
              -76.762,
              4249.812
            ],
            [
              3415.597,
              -114.94,
              4334.883
            ],
            [
              3440.614,
              -122.094,
              4360.903
            ],
            [
              3504.684,
              -140.35,
              4427.523
            ],
            [
              3501.543,
              -139.949,
              4430.69
            ],
            [
              3709.123,
              -178.405,
              4641.802
            ],
            [
              3851.65,
              -212.29,
              4788.302
            ],
            [
              3930.415,
              -241.623,
              4872.351
            ],
            [
              4021.131,
              -286.771,
              4973.681
            ],
            [
              4084.273,
              -323.602,
              5046.78
            ],
            [
              4228.208,
              -425.014,
              5222.853
            ],
            [
              4243.612,
              -437.324,
              5242.571
            ],
            [
              4278.232,
              -466.47,
              5287.827
            ],
            [
              4369.718,
              -538.359,
              5404.178
            ],
            [
              4422.518,
              -576.109,
              5469.085
            ],
            [
              4472.265,
              -604.896,
              5526.561
            ],
            [
              4515.715,
              -625.769,
              5574.765
            ],
            [
              4558.025,
              -638.827,
              5619.044
            ],
            [
              4617.783,
              -649.996,
              5679.837
            ],
            [
              4673.822,
              -653.3,
              5735.973
            ],
            [
              4754.55,
              -647.061,
              5816.942
            ],
            [
              4785.642,
              -639.867,
              5848.855
            ],
            [
              4844.087,
              -618.728,
              5911.005
            ],
            [
              5036.703,
              -528.931,
              6123.525
            ],
            [
              5111.461,
              -498.092,
              6204.394
            ],
            [
              5156.243,
              -483.372,
              6251.533
            ],
            [
              5224.275,
              -466.876,
              6321.536
            ],
            [
              5273.441,
              -458.923,
              6371.341
            ],
            [
              5284.768,
              -457.104,
              6382.814
            ],
            [
              5327.098,
              -452.169,
              6425.43
            ],
            [
              5348.35,
              -453.695,
              6446.737
            ],
            [
              5548.21,
              -426.923,
              6648.382
            ],
            [
              5629.62,
              -418.569,
              6730.22
            ],
            [
              5749.654,
              -415.325,
              6850.297
            ],
            [
              5806.905,
              -417.675,
              6907.596
            ],
            [
              5963.202,
              -440.053,
              7065.488
            ],
            [
              5998.147,
              -448.938,
              7101.544
            ],
            [
              6073.54,
              -468.999,
              7179.561
            ],
            [
              6189.436,
              -512.386,
              7303.312
            ],
            [
              6360.739,
              -590.332,
              7491.515
            ],
            [
              6402.87,
              -612.311,
              7539.034
            ],
            [
              6557.754,
              -672.13,
              7705.068
            ],
            [
              6602.659,
              -684.146,
              7751.553
            ],
            [
              6682.351,
              -697.96,
              7832.433
            ],
            [
              6780.934,
              -702.128,
              7931.105
            ],
            [
              6864.177,
              -699.316,
              8014.395
            ],
            [
              6937.971,
              -685.187,
              8089.529
            ],
            [
              7035.236,
              -658.162,
              8190.479
            ],
            [
              7126.343,
              -616.546,
              8290.641
            ],
            [
              7192.221,
              -578.885,
              8366.524
            ],
            [
              7263.567,
              -525.747,
              8455.484
            ],
            [
              7363.253,
              -442,
              8585.68
            ],
            [
              7412.953,
              -407.361,
              8646.26
            ],
            [
              7461.255,
              -378.261,
              8702.65
            ],
            [
              7507.446,
              -358.026,
              8753.079
            ],
            [
              7566.531,
              -338.048,
              8815.45
            ],
            [
              7666.431,
              -308.863,
              8919.526
            ],
            [
              7747.458,
              -288.21,
              9003.144
            ],
            [
              7874.867,
              -273.035,
              9131.453
            ],
            [
              7914.079,
              -274.485,
              9170.692
            ],
            [
              7971.362,
              -282.656,
              9228.555
            ],
            [
              8031.61,
              -296.506,
              9290.375
            ],
            [
              8097.029,
              -319.679,
              9359.776
            ],
            [
              8139.789,
              -341.705,
              9407.876
            ],
            [
              8190.291,
              -376.496,
              9469.202
            ],
            [
              8211.099,
              -398.071,
              9499.175
            ],
            [
              8367.171,
              -581.146,
              9739.748
            ],
            [
              8434.632,
              -625.918,
              9820.714
            ],
            [
              8481.22,
              -650.233,
              9873.266
            ],
            [
              8531.721,
              -672.4,
              9928.417
            ],
            [
              8541.441,
              -631.817,
              9970.148
            ],
            [
              8559.188,
              -557.169,
              10046.877
            ],
            [
              8576.654,
              -426.152,
              10179.053
            ],
            [
              8584.228,
              -306.068,
              10299.376
            ],
            [
              8588.332,
              -198.161,
              10407.361
            ],
            [
              8595.54,
              -160.454,
              10445.75
            ],
            [
              8696.309,
              -134.44,
              10549.823
            ],
            [
              8720.235,
              -127.625,
              10574.701
            ],
            [
              8744.3,
              -121.003,
              10599.66
            ],
            [
              8789.403,
              -109.804,
              10646.133
            ],
            [
              8826.448,
              -96.087,
              10685.636
            ],
            [
              8853.145,
              -83.257,
              10715.256
            ],
            [
              8900.484,
              -38.566,
              10780.358
            ],
            [
              8997.947,
              60.777,
              10919.527
            ],
            [
              9045.087,
              95.45,
              10978.045
            ],
            [
              9064.009,
              106.201,
              10999.808
            ],
            [
              9090.691,
              117.908,
              11028.945
            ],
            [
              9117.305,
              128.24,
              11057.495
            ],
            [
              9141.918,
              131.345,
              11082.303
            ],
            [
              9732.973,
              138.29,
              11673.399
            ],
            [
              9774.103,
              135.215,
              11714.643
            ],
            [
              9799.87,
              133.577,
              11740.462
            ],
            [
              9819.523,
              134.263,
              11760.127
            ],
            [
              9844.442,
              127.789,
              11785.874
            ],
            [
              9855.41,
              124.412,
              11797.35
            ],
            [
              9866.644,
              120.91,
              11809.117
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:4267",
              "position": {
                "x": 372.531,
                "z": 1877.646
              },
              "distanceAlongShapeM": 155.677,
              "shapeOffsetM": 1.434,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:5355",
              "position": {
                "x": 580.051,
                "z": 1583.295
              },
              "distanceAlongShapeM": 642.043,
              "shapeOffsetM": 1.353,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:5358",
              "position": {
                "x": 979.224,
                "z": 1503.603
              },
              "distanceAlongShapeM": 1059.747,
              "shapeOffsetM": 5.067,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:5360",
              "position": {
                "x": 1270.109,
                "z": 1290.062
              },
              "distanceAlongShapeM": 1502.579,
              "shapeOffsetM": 3.47,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:5362",
              "position": {
                "x": 1673.61,
                "z": 1236.945
              },
              "distanceAlongShapeM": 1916.948,
              "shapeOffsetM": 5.271,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:1123",
              "position": {
                "x": 2093.452,
                "z": 1264.754
              },
              "distanceAlongShapeM": 2364.696,
              "shapeOffsetM": 3.113,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:356",
              "position": {
                "x": 2187.13,
                "z": 1030.337
              },
              "distanceAlongShapeM": 2635.989,
              "shapeOffsetM": 3.86,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:931",
              "position": {
                "x": 2432.805,
                "z": 680.634
              },
              "distanceAlongShapeM": 3065.878,
              "shapeOffsetM": 5.268,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:387",
              "position": {
                "x": 2739.748,
                "z": 435.524
              },
              "distanceAlongShapeM": 3459.605,
              "shapeOffsetM": 5.02,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:5372",
              "position": {
                "x": 3035.88,
                "z": 166.104
              },
              "distanceAlongShapeM": 3860.813,
              "shapeOffsetM": 3.98,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:5373",
              "position": {
                "x": 3506.161,
                "z": -134.47
              },
              "distanceAlongShapeM": 4427.332,
              "shapeOffsetM": 6.06,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:7587",
              "position": {
                "x": 4231.381,
                "z": -421.043
              },
              "distanceAlongShapeM": 5222.853,
              "shapeOffsetM": 5.083,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:6719",
              "position": {
                "x": 5284.486,
                "z": -454.683
              },
              "distanceAlongShapeM": 6382.814,
              "shapeOffsetM": 2.437,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:6721",
              "position": {
                "x": 5749.654,
                "z": -411.396
              },
              "distanceAlongShapeM": 6850.297,
              "shapeOffsetM": 3.929,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:6724",
              "position": {
                "x": 6496.953,
                "z": -648.669
              },
              "distanceAlongShapeM": 7639.898,
              "shapeOffsetM": 0.02,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:6727",
              "position": {
                "x": 7874.837,
                "z": -271.823
              },
              "distanceAlongShapeM": 9131.453,
              "shapeOffsetM": 1.213,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:6225",
              "position": {
                "x": 8539.64,
                "z": -631.367
              },
              "distanceAlongShapeM": 9970.17,
              "shapeOffsetM": 1.856,
              "arrivalOffsetSeconds": 1380,
              "departureOffsetSeconds": 1380
            },
            {
              "stopId": "judu:stop:6040",
              "position": {
                "x": 8718.239,
                "z": -120.617
              },
              "distanceAlongShapeM": 10574.701,
              "shapeOffsetM": 7.287,
              "arrivalOffsetSeconds": 1560,
              "departureOffsetSeconds": 1560
            },
            {
              "stopId": "judu:stop:6042",
              "position": {
                "x": 9116.151,
                "z": 132.979
              },
              "distanceAlongShapeM": 11057.495,
              "shapeOffsetM": 4.877,
              "arrivalOffsetSeconds": 1620,
              "departureOffsetSeconds": 1620
            },
            {
              "stopId": "judu:stop:6044",
              "position": {
                "x": 9552.934,
                "z": 138.6
              },
              "distanceAlongShapeM": 11493.376,
              "shapeOffsetM": 2.425,
              "arrivalOffsetSeconds": 1680,
              "departureOffsetSeconds": 1680
            },
            {
              "stopId": "judu:stop:7444",
              "position": {
                "x": 9732.975,
                "z": 142.732
              },
              "distanceAlongShapeM": 11673.399,
              "shapeOffsetM": 4.442,
              "arrivalOffsetSeconds": 1740,
              "departureOffsetSeconds": 1740
            }
          ],
          "departuresSeconds": [
            18900,
            20280,
            21060,
            21780,
            22380,
            23220,
            24060,
            24900,
            25680,
            26460,
            27120,
            27960,
            28680,
            29580,
            30420,
            31260,
            31980,
            33420,
            35220,
            37260,
            38520,
            40440,
            42000,
            43380,
            45060,
            46620,
            47940,
            49680,
            51240,
            52500,
            54600,
            55260,
            56040,
            56880,
            57720,
            58500,
            59400,
            60180,
            61080,
            62040,
            63000,
            63780,
            64560,
            65340,
            66180,
            68160,
            70020,
            72780,
            74760,
            76500,
            77700,
            79260,
            80760,
            82020
          ]
        },
        {
          "id": "judu:pattern:vilnius_bus_74:1",
          "sourceRouteId": "vilnius_bus_74",
          "sourceShapeId": "vilnius_bus_74_b-a",
          "directionId": 1,
          "headsign": "Stotis",
          "directionName": "Parko–Subačiaus g.–Stotis",
          "mode": "bus",
          "routeShortName": "74",
          "routeLongName": "Stotis–Subačiaus–Parko g.",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              9868.776,
              118.274,
              0
            ],
            [
              9862.137,
              118.949,
              6.673
            ],
            [
              9810.14,
              131.141,
              60.081
            ],
            [
              9748.867,
              131.276,
              121.354
            ],
            [
              9682.329,
              129.236,
              187.923
            ],
            [
              9621.808,
              131.634,
              248.492
            ],
            [
              9517.36,
              133.756,
              352.961
            ],
            [
              9448.882,
              128.466,
              421.643
            ],
            [
              9389.611,
              131.895,
              481.013
            ],
            [
              9156.08,
              129.945,
              714.552
            ],
            [
              9090.691,
              117.908,
              781.04
            ],
            [
              9071.372,
              103.392,
              805.205
            ],
            [
              9049.578,
              94.246,
              828.84
            ],
            [
              8990.008,
              50.917,
              902.501
            ],
            [
              8869.532,
              -70.228,
              1073.354
            ],
            [
              8853.145,
              -83.257,
              1094.289
            ],
            [
              8819.883,
              -101.512,
              1132.231
            ],
            [
              8767.948,
              -118.279,
              1186.806
            ],
            [
              8695.316,
              -137.969,
              1262.059
            ],
            [
              8672.646,
              -150.383,
              1287.906
            ],
            [
              8624.533,
              -154.886,
              1336.229
            ],
            [
              8595.54,
              -160.454,
              1365.752
            ],
            [
              8590.933,
              -197.1,
              1402.686
            ],
            [
              8584.694,
              -314.984,
              1520.735
            ],
            [
              8567.281,
              -539.519,
              1745.944
            ],
            [
              8554.112,
              -617.185,
              1824.719
            ],
            [
              8531.721,
              -672.4,
              1884.301
            ],
            [
              8487.656,
              -660.31,
              1929.995
            ],
            [
              8367.171,
              -581.146,
              2074.16
            ],
            [
              8314.693,
              -528.882,
              2148.224
            ],
            [
              8254.878,
              -456.433,
              2242.174
            ],
            [
              8204.93,
              -406.448,
              2312.838
            ],
            [
              8163.673,
              -373.337,
              2365.738
            ],
            [
              8140.11,
              -358.393,
              2393.641
            ],
            [
              8089.693,
              -331.779,
              2450.651
            ],
            [
              8068.574,
              -323.563,
              2473.312
            ],
            [
              7987.101,
              -301.896,
              2557.617
            ],
            [
              7941.44,
              -295.418,
              2603.735
            ],
            [
              7928.015,
              -296.961,
              2617.248
            ],
            [
              7910.517,
              -293.688,
              2635.05
            ],
            [
              7877.639,
              -293.032,
              2667.934
            ],
            [
              7803.39,
              -297.118,
              2742.296
            ],
            [
              7662.12,
              -331.043,
              2887.582
            ],
            [
              7526.029,
              -370.999,
              3029.417
            ],
            [
              7481.619,
              -392.025,
              3078.553
            ],
            [
              7422.914,
              -425.371,
              3146.068
            ],
            [
              7391.551,
              -445.901,
              3183.553
            ],
            [
              7274.84,
              -542.67,
              3335.163
            ],
            [
              7223.786,
              -580.623,
              3398.779
            ],
            [
              7148.018,
              -629.221,
              3488.793
            ],
            [
              7093.297,
              -657.084,
              3550.199
            ],
            [
              6995.189,
              -694.109,
              3655.061
            ],
            [
              6921.973,
              -711.59,
              3730.335
            ],
            [
              6856.67,
              -720.321,
              3796.219
            ],
            [
              6795.988,
              -723.577,
              3856.988
            ],
            [
              6712.188,
              -721.926,
              3940.805
            ],
            [
              6649.147,
              -714.005,
              4004.341
            ],
            [
              6571.433,
              -698.004,
              4083.686
            ],
            [
              6523.349,
              -683.7,
              4133.852
            ],
            [
              6449.764,
              -654.422,
              4213.048
            ],
            [
              6436.826,
              -651.702,
              4226.269
            ],
            [
              6365.394,
              -616.028,
              4306.113
            ],
            [
              6247.14,
              -562.5,
              4435.918
            ],
            [
              6102.584,
              -501.78,
              4592.709
            ],
            [
              6033.375,
              -479.275,
              4665.485
            ],
            [
              5958.9,
              -462.234,
              4741.885
            ],
            [
              5902.989,
              -452.237,
              4798.682
            ],
            [
              5819.302,
              -444.914,
              4882.689
            ],
            [
              5710.368,
              -441.803,
              4991.667
            ],
            [
              5691.671,
              -442.516,
              5010.378
            ],
            [
              5642.585,
              -443.152,
              5059.468
            ],
            [
              5383.59,
              -465.511,
              5319.426
            ],
            [
              5245.194,
              -488.734,
              5459.757
            ],
            [
              5168.103,
              -503.64,
              5538.276
            ],
            [
              5099.964,
              -525.701,
              5609.898
            ],
            [
              5024.562,
              -556.529,
              5691.358
            ],
            [
              4957.541,
              -587.519,
              5765.197
            ],
            [
              4906.057,
              -615.47,
              5823.779
            ],
            [
              4828.015,
              -649.59,
              5908.954
            ],
            [
              4765.144,
              -666.191,
              5973.98
            ],
            [
              4704.378,
              -673.927,
              6035.236
            ],
            [
              4650.166,
              -676.224,
              6089.497
            ],
            [
              4614.755,
              -673.316,
              6125.027
            ],
            [
              4552.441,
              -660.985,
              6188.549
            ],
            [
              4508.24,
              -645.664,
              6235.33
            ],
            [
              4426.454,
              -606.243,
              6326.121
            ],
            [
              4266.373,
              -479.602,
              6530.238
            ],
            [
              4207.404,
              -435.42,
              6603.923
            ],
            [
              4102.373,
              -355.119,
              6736.134
            ],
            [
              4073.746,
              -334.533,
              6771.394
            ],
            [
              4021.499,
              -301.251,
              6833.341
            ],
            [
              3924.337,
              -255.979,
              6940.533
            ],
            [
              3871.834,
              -236.053,
              6996.69
            ],
            [
              3794.896,
              -212.322,
              7077.204
            ],
            [
              3748.025,
              -201.41,
              7125.329
            ],
            [
              3692.751,
              -191.452,
              7181.493
            ],
            [
              3533.915,
              -167.282,
              7342.157
            ],
            [
              3462.884,
              -150.608,
              7415.119
            ],
            [
              3394.357,
              -124.205,
              7488.557
            ],
            [
              3396.087,
              -123.476,
              7490.435
            ],
            [
              3343.728,
              -95.766,
              7549.674
            ],
            [
              3282.595,
              -54.531,
              7623.414
            ],
            [
              2977.671,
              191.693,
              8015.338
            ],
            [
              2944.561,
              216.482,
              8056.7
            ],
            [
              2919.043,
              240.05,
              8091.436
            ],
            [
              2733.61,
              417.827,
              8348.322
            ],
            [
              2697.486,
              451.904,
              8397.982
            ],
            [
              2679.584,
              466.091,
              8420.825
            ],
            [
              2656.286,
              490.528,
              8454.588
            ],
            [
              2582.473,
              544.237,
              8545.873
            ],
            [
              2406.492,
              653.296,
              8752.907
            ],
            [
              2359.589,
              697.591,
              8817.42
            ],
            [
              2330.053,
              739.334,
              8868.556
            ],
            [
              2306.383,
              784.307,
              8919.378
            ],
            [
              2285.937,
              829.219,
              8968.725
            ],
            [
              2237.179,
              912.511,
              9065.238
            ],
            [
              2178.144,
              998.221,
              9169.312
            ],
            [
              2120.129,
              1077.499,
              9267.55
            ],
            [
              2107.735,
              1096.818,
              9290.503
            ],
            [
              2088.256,
              1124.583,
              9324.42
            ],
            [
              2063.317,
              1145.824,
              9357.179
            ],
            [
              2049.437,
              1153.138,
              9372.867
            ],
            [
              2015.127,
              1163.632,
              9408.746
            ],
            [
              1965.977,
              1174.732,
              9459.134
            ],
            [
              1928.988,
              1197.686,
              9502.667
            ],
            [
              1911.304,
              1218.054,
              9529.64
            ],
            [
              1889.263,
              1249.836,
              9568.317
            ],
            [
              1817.405,
              1234.36,
              9641.822
            ],
            [
              1745.61,
              1223.362,
              9714.455
            ],
            [
              1634.607,
              1220.971,
              9825.484
            ],
            [
              1599.996,
              1216.751,
              9860.351
            ],
            [
              1535.192,
              1217.248,
              9925.157
            ],
            [
              1461.257,
              1230.864,
              10000.335
            ],
            [
              1250.055,
              1287.093,
              10218.894
            ],
            [
              1216.978,
              1291.043,
              10252.206
            ],
            [
              1174.911,
              1305.179,
              10296.585
            ],
            [
              1169.279,
              1454.457,
              10445.969
            ],
            [
              990.627,
              1492.26,
              10628.577
            ],
            [
              961.104,
              1500.597,
              10659.254
            ],
            [
              886.508,
              1548.725,
              10748.029
            ],
            [
              861.581,
              1561.429,
              10776.006
            ],
            [
              775.59,
              1587.408,
              10865.836
            ],
            [
              773.577,
              1623.63,
              10902.113
            ],
            [
              781.269,
              1649.737,
              10929.33
            ],
            [
              802.898,
              1738.399,
              11020.592
            ],
            [
              825.163,
              1791.425,
              11078.103
            ],
            [
              623.161,
              1858.587,
              11290.978
            ],
            [
              598.791,
              1864.715,
              11316.106
            ],
            [
              535.995,
              1890.241,
              11383.892
            ],
            [
              493.411,
              1911.506,
              11431.491
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:6073",
              "position": {
                "x": 9682.346,
                "z": 127.063
              },
              "distanceAlongShapeM": 187.923,
              "shapeOffsetM": 2.173,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:6045",
              "position": {
                "x": 9448.882,
                "z": 128.466
              },
              "distanceAlongShapeM": 421.643,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 60,
              "departureOffsetSeconds": 60
            },
            {
              "stopId": "judu:stop:6043",
              "position": {
                "x": 9073.545,
                "z": 99.328
              },
              "distanceAlongShapeM": 805.205,
              "shapeOffsetM": 4.609,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:6041",
              "position": {
                "x": 8673.105,
                "z": -151.995
              },
              "distanceAlongShapeM": 1287.906,
              "shapeOffsetM": 1.676,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:5400",
              "position": {
                "x": 8486.109,
                "z": -663.69
              },
              "distanceAlongShapeM": 1929.995,
              "shapeOffsetM": 3.717,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:6729",
              "position": {
                "x": 7927.813,
                "z": -299.599
              },
              "distanceAlongShapeM": 2617.248,
              "shapeOffsetM": 2.646,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:6725",
              "position": {
                "x": 6436.249,
                "z": -653.044
              },
              "distanceAlongShapeM": 4226.269,
              "shapeOffsetM": 1.461,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:6722",
              "position": {
                "x": 5691.565,
                "z": -447.003
              },
              "distanceAlongShapeM": 5010.542,
              "shapeOffsetM": 4.485,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:6732",
              "position": {
                "x": 5245.719,
                "z": -491.784
              },
              "distanceAlongShapeM": 5459.821,
              "shapeOffsetM": 3.094,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:5421",
              "position": {
                "x": 4205.92,
                "z": -437.254
              },
              "distanceAlongShapeM": 6603.988,
              "shapeOffsetM": 2.359,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:5423",
              "position": {
                "x": 3392.114,
                "z": -128.967
              },
              "distanceAlongShapeM": 7488.557,
              "shapeOffsetM": 5.264,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            },
            {
              "stopId": "judu:stop:5424",
              "position": {
                "x": 2941.964,
                "z": 213.518
              },
              "distanceAlongShapeM": 8056.7,
              "shapeOffsetM": 3.941,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:5425",
              "position": {
                "x": 2677.062,
                "z": 463.42
              },
              "distanceAlongShapeM": 8420.825,
              "shapeOffsetM": 3.673,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:5925",
              "position": {
                "x": 2116.361,
                "z": 1075.075
              },
              "distanceAlongShapeM": 9267.55,
              "shapeOffsetM": 4.48,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:946",
              "position": {
                "x": 1600.284,
                "z": 1213.815
              },
              "distanceAlongShapeM": 9860.351,
              "shapeOffsetM": 2.95,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            },
            {
              "stopId": "judu:stop:5428",
              "position": {
                "x": 1216.542,
                "z": 1288.825
              },
              "distanceAlongShapeM": 10252.206,
              "shapeOffsetM": 2.261,
              "arrivalOffsetSeconds": 1380,
              "departureOffsetSeconds": 1380
            },
            {
              "stopId": "judu:stop:6714",
              "position": {
                "x": 769.19,
                "z": 1624.355
              },
              "distanceAlongShapeM": 10902.113,
              "shapeOffsetM": 4.447,
              "arrivalOffsetSeconds": 1500,
              "departureOffsetSeconds": 1500
            },
            {
              "stopId": "judu:stop:8264",
              "position": {
                "x": 493.148,
                "z": 1911.064
              },
              "distanceAlongShapeM": 11431.491,
              "shapeOffsetM": 0.515,
              "arrivalOffsetSeconds": 1680,
              "departureOffsetSeconds": 1680
            }
          ],
          "departuresSeconds": [
            19140,
            19860,
            20460,
            21240,
            22020,
            22860,
            23640,
            24360,
            25080,
            25920,
            26640,
            27540,
            28380,
            29220,
            29940,
            31380,
            33120,
            35160,
            36480,
            38400,
            39900,
            41280,
            42960,
            44520,
            45840,
            47580,
            49140,
            50400,
            52140,
            53160,
            53940,
            54780,
            55620,
            56400,
            57300,
            58080,
            58980,
            59940,
            60900,
            61680,
            62460,
            63240,
            64080,
            65100,
            66060,
            66960,
            67920,
            70800,
            72780,
            74520,
            75720,
            77340,
            78900,
            80100,
            81720,
            83100,
            84360
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_bus_75",
      "sourceRouteId": "vilnius_bus_75",
      "mode": "bus",
      "shortName": "75",
      "longName": "Santariškės–Visorių g.–Fabijoniškės–Šeškinė–Justiniškės–Pilaitė",
      "color": "0073AC",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_bus_75:0",
          "sourceRouteId": "vilnius_bus_75",
          "sourceShapeId": "vilnius_bus_75_a-b",
          "directionId": 0,
          "headsign": "Pilaitė",
          "directionName": "Santariškės–Visorių g.–Fabijoniškės–Šeškinė–Justiniškės–Pilaitė",
          "mode": "bus",
          "routeShortName": "75",
          "routeLongName": "Santariškės–Visorių g.–Fabijoniškės–Šeškinė–Justiniškės–Pilaitė",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              71.413,
              -7563.928,
              0
            ],
            [
              68.088,
              -7589.527,
              25.814
            ],
            [
              45.368,
              -7598.945,
              50.409
            ],
            [
              37.787,
              -7591.014,
              61.38
            ],
            [
              26.258,
              -7471.636,
              181.314
            ],
            [
              8.189,
              -7201.951,
              451.603
            ],
            [
              -2.477,
              -7116.037,
              538.177
            ],
            [
              -10.317,
              -7079.698,
              575.352
            ],
            [
              -10.894,
              -7047.975,
              607.08
            ],
            [
              -21.671,
              -6897.49,
              757.951
            ],
            [
              -33.557,
              -6878.349,
              780.482
            ],
            [
              -59.463,
              -6851.158,
              818.038
            ],
            [
              -67.548,
              -6835.425,
              835.727
            ],
            [
              -70.502,
              -6820.899,
              850.55
            ],
            [
              -64.262,
              -6796.522,
              875.713
            ],
            [
              -53.909,
              -6786.595,
              890.056
            ],
            [
              -43.463,
              -6771.142,
              908.709
            ],
            [
              -44.234,
              -6722.3,
              957.557
            ],
            [
              -50.641,
              -6695.446,
              985.165
            ],
            [
              -48.526,
              -6639.841,
              1040.81
            ],
            [
              -52.099,
              -6588.567,
              1092.209
            ],
            [
              -70.555,
              -6505.85,
              1176.96
            ],
            [
              -125.166,
              -6286.66,
              1402.85
            ],
            [
              -158.525,
              -6137.991,
              1555.216
            ],
            [
              -180.294,
              -6069.166,
              1627.401
            ],
            [
              -186.217,
              -6031.729,
              1665.304
            ],
            [
              -210.448,
              -5912.171,
              1787.293
            ],
            [
              -214.688,
              -5861.998,
              1837.645
            ],
            [
              -215.425,
              -5796.303,
              1903.344
            ],
            [
              -210.007,
              -5746.306,
              1953.634
            ],
            [
              -195.772,
              -5671.978,
              2029.312
            ],
            [
              -200.158,
              -5665.219,
              2037.37
            ],
            [
              -245.834,
              -5662.161,
              2083.148
            ],
            [
              -275.267,
              -5661.057,
              2112.602
            ],
            [
              -299.862,
              -5657.84,
              2137.406
            ],
            [
              -394.957,
              -5644.98,
              2233.367
            ],
            [
              -428.258,
              -5634.356,
              2268.322
            ],
            [
              -633.019,
              -5523.775,
              2501.034
            ],
            [
              -662.96,
              -5509.616,
              2534.155
            ],
            [
              -740.412,
              -5464.845,
              2623.616
            ],
            [
              -765.768,
              -5455.693,
              2650.572
            ],
            [
              -887.614,
              -5390.039,
              2788.981
            ],
            [
              -926.205,
              -5371.757,
              2831.684
            ],
            [
              -988.998,
              -5332.549,
              2905.712
            ],
            [
              -1085.313,
              -5279.606,
              3015.619
            ],
            [
              -1171.043,
              -5246.894,
              3107.378
            ],
            [
              -1178.106,
              -5245.653,
              3114.549
            ],
            [
              -1187.142,
              -5246.604,
              3123.635
            ],
            [
              -1250.872,
              -5423.576,
              3311.732
            ],
            [
              -1257.227,
              -5454.633,
              3343.433
            ],
            [
              -1256.401,
              -5511.619,
              3400.425
            ],
            [
              -1287.303,
              -5515.321,
              3431.548
            ],
            [
              -1341.907,
              -5525.275,
              3487.052
            ],
            [
              -1438.174,
              -5559.37,
              3589.178
            ],
            [
              -1444.258,
              -5565.439,
              3597.771
            ],
            [
              -1477.108,
              -5575.371,
              3632.09
            ],
            [
              -1555.041,
              -5603.671,
              3715.002
            ],
            [
              -1589.241,
              -5614.554,
              3750.892
            ],
            [
              -1591.326,
              -5616.186,
              3753.54
            ],
            [
              -1595.648,
              -5617.758,
              3758.139
            ],
            [
              -1598.582,
              -5618.905,
              3761.289
            ],
            [
              -1600.268,
              -5618.809,
              3762.978
            ],
            [
              -1600.999,
              -5603.926,
              3777.879
            ],
            [
              -1683.803,
              -5391.33,
              4006.031
            ],
            [
              -1720.799,
              -5285.871,
              4117.791
            ],
            [
              -1734.269,
              -5223.444,
              4181.655
            ],
            [
              -1744.096,
              -5196.552,
              4210.286
            ],
            [
              -1762.78,
              -5160.595,
              4250.808
            ],
            [
              -1787.18,
              -5120.083,
              4298.1
            ],
            [
              -1783.781,
              -5110.125,
              4308.622
            ],
            [
              -1777.866,
              -5103.551,
              4317.466
            ],
            [
              -1755.713,
              -5089.474,
              4343.713
            ],
            [
              -1730.884,
              -5069.879,
              4375.343
            ],
            [
              -1682.819,
              -5011.736,
              4450.78
            ],
            [
              -1672.861,
              -4995.216,
              4470.069
            ],
            [
              -1662.744,
              -4969.792,
              4497.432
            ],
            [
              -1655.392,
              -4950.998,
              4517.614
            ],
            [
              -1638.506,
              -4911.224,
              4560.823
            ],
            [
              -1626.337,
              -4879.158,
              4595.121
            ],
            [
              -1604.435,
              -4807.19,
              4670.348
            ],
            [
              -1592.551,
              -4755.08,
              4723.796
            ],
            [
              -1586.265,
              -4691.738,
              4787.449
            ],
            [
              -1583.358,
              -4637.242,
              4842.022
            ],
            [
              -1588.338,
              -4591.511,
              4888.024
            ],
            [
              -1592.703,
              -4555.313,
              4924.484
            ],
            [
              -1592.123,
              -4561.86,
              4931.056
            ],
            [
              -1595.437,
              -4520.137,
              4972.911
            ],
            [
              -1616.287,
              -4244.797,
              5249.039
            ],
            [
              -1631.856,
              -4106.478,
              5388.231
            ],
            [
              -1635.514,
              -4066.939,
              5427.939
            ],
            [
              -1637.064,
              -4037.365,
              5457.554
            ],
            [
              -1635.048,
              -3960.588,
              5534.357
            ],
            [
              -1628.98,
              -3909.488,
              5585.816
            ],
            [
              -1609.35,
              -3809.976,
              5687.246
            ],
            [
              -1543.192,
              -3688.376,
              5825.678
            ],
            [
              -1515.42,
              -3648.796,
              5874.03
            ],
            [
              -1479.438,
              -3582.647,
              5949.332
            ],
            [
              -1461.972,
              -3542.883,
              5992.762
            ],
            [
              -1437.625,
              -3478.752,
              6061.359
            ],
            [
              -1385.229,
              -3323.838,
              6224.894
            ],
            [
              -1372.596,
              -3266.177,
              6283.923
            ],
            [
              -1370.241,
              -3230.903,
              6319.276
            ],
            [
              -1363.568,
              -3193.979,
              6356.798
            ],
            [
              -1359.808,
              -3163.989,
              6387.023
            ],
            [
              -1360.179,
              -3112.774,
              6438.239
            ],
            [
              -1362.723,
              -3074.878,
              6476.22
            ],
            [
              -1447.826,
              -3076.694,
              6561.343
            ],
            [
              -1522.501,
              -3072.018,
              6636.164
            ],
            [
              -1600.963,
              -3062.822,
              6715.163
            ],
            [
              -1630.583,
              -3058.786,
              6745.057
            ],
            [
              -1661.95,
              -3049.487,
              6777.773
            ],
            [
              -1775.996,
              -3011.829,
              6897.876
            ],
            [
              -1790.725,
              -3042.737,
              6932.114
            ],
            [
              -1806.584,
              -3064.719,
              6959.219
            ],
            [
              -1829.59,
              -3089.913,
              6993.337
            ],
            [
              -1853.041,
              -3103.967,
              7020.677
            ],
            [
              -1875.789,
              -3114.694,
              7045.827
            ],
            [
              -1903.67,
              -3124.217,
              7075.29
            ],
            [
              -1932.077,
              -3127.051,
              7103.838
            ],
            [
              -2119.439,
              -3117.041,
              7291.467
            ],
            [
              -2201.039,
              -3113.862,
              7373.128
            ],
            [
              -2257.755,
              -3103.073,
              7430.862
            ],
            [
              -2286.96,
              -3078.446,
              7469.064
            ],
            [
              -2300.838,
              -3061.502,
              7490.966
            ],
            [
              -2310.167,
              -3042.412,
              7512.214
            ],
            [
              -2315.611,
              -3022.278,
              7533.071
            ],
            [
              -2313.79,
              -2992.253,
              7563.151
            ],
            [
              -2304.843,
              -2960.128,
              7596.499
            ],
            [
              -2272.642,
              -2925.075,
              7644.097
            ],
            [
              -2238.843,
              -2908.976,
              7681.534
            ],
            [
              -2253.813,
              -2880.88,
              7713.37
            ],
            [
              -2299.624,
              -2811.049,
              7796.886
            ],
            [
              -2361.565,
              -2742.045,
              7889.613
            ],
            [
              -2438.543,
              -2685.023,
              7985.41
            ],
            [
              -2496.606,
              -2651.713,
              8052.349
            ],
            [
              -2552.25,
              -2627.352,
              8113.092
            ],
            [
              -2587.598,
              -2694.635,
              8189.096
            ],
            [
              -2669.545,
              -2793.221,
              8317.293
            ],
            [
              -2878.335,
              -2954.459,
              8581.094
            ],
            [
              -2942.823,
              -2993.401,
              8656.428
            ],
            [
              -2993.467,
              -3014.776,
              8711.398
            ],
            [
              -3056.314,
              -3033.711,
              8777.035
            ],
            [
              -3148.249,
              -3057.702,
              8872.049
            ],
            [
              -3175.722,
              -3067.532,
              8901.228
            ],
            [
              -3258.301,
              -3085.832,
              8985.81
            ],
            [
              -3322.825,
              -3090.269,
              9050.486
            ],
            [
              -3543.885,
              -3090.861,
              9271.547
            ],
            [
              -3642.787,
              -3108.062,
              9371.934
            ],
            [
              -3706.235,
              -3124.768,
              9437.544
            ],
            [
              -3736.941,
              -3062.562,
              9506.916
            ],
            [
              -3744.824,
              -3043.144,
              9527.873
            ],
            [
              -3749.61,
              -3024.938,
              9546.698
            ],
            [
              -3794.804,
              -2918.397,
              9662.428
            ],
            [
              -3982.054,
              -2455.389,
              10161.867
            ],
            [
              -3998.785,
              -2421.194,
              10199.935
            ],
            [
              -4007.392,
              -2392.61,
              10229.787
            ],
            [
              -4034.259,
              -2306.427,
              10320.061
            ],
            [
              -4048.116,
              -2250.527,
              10377.653
            ],
            [
              -4058.635,
              -2188.005,
              10441.053
            ],
            [
              -4065.192,
              -2119.986,
              10509.388
            ],
            [
              -4071.681,
              -2010.779,
              10618.787
            ],
            [
              -4063.29,
              -1898.49,
              10731.389
            ],
            [
              -4045.411,
              -1837.599,
              10794.851
            ],
            [
              -4006.94,
              -1771.447,
              10871.376
            ],
            [
              -3981.93,
              -1741.824,
              10910.145
            ],
            [
              -3941.981,
              -1705.781,
              10963.95
            ],
            [
              -3883.226,
              -1663.385,
              11036.404
            ],
            [
              -3846.573,
              -1643.357,
              11078.172
            ],
            [
              -3813.541,
              -1631.763,
              11113.18
            ],
            [
              -3808.468,
              -1630.446,
              11118.422
            ],
            [
              -3761.37,
              -1625.426,
              11165.786
            ],
            [
              -3487.628,
              -1602.363,
              11440.498
            ],
            [
              -3508.003,
              -1550.799,
              11495.941
            ],
            [
              -3521.109,
              -1520.135,
              11529.289
            ],
            [
              -3534.455,
              -1477.979,
              11573.507
            ],
            [
              -3626.266,
              -1196.964,
              11869.14
            ],
            [
              -3684.51,
              -1178.609,
              11930.207
            ],
            [
              -3714.349,
              -1169.288,
              11961.468
            ],
            [
              -3768.714,
              -1158.717,
              12016.851
            ],
            [
              -3858.305,
              -1156.194,
              12106.478
            ],
            [
              -4237.967,
              -1188.581,
              12487.519
            ],
            [
              -4268.356,
              -1193.623,
              12518.323
            ],
            [
              -4296.043,
              -1199.905,
              12546.715
            ],
            [
              -4333.704,
              -1206.966,
              12585.031
            ],
            [
              -4364.15,
              -1215.347,
              12616.61
            ],
            [
              -4597.068,
              -1300.392,
              12864.568
            ],
            [
              -4637.998,
              -1318.612,
              12909.371
            ],
            [
              -4714.189,
              -1362.945,
              12997.521
            ],
            [
              -4755.992,
              -1394.51,
              13049.903
            ],
            [
              -4809.036,
              -1442.581,
              13121.488
            ],
            [
              -4835.962,
              -1480.117,
              13167.683
            ],
            [
              -5091.057,
              -1790.801,
              13569.675
            ],
            [
              -5145.804,
              -1834.231,
              13639.557
            ],
            [
              -5350.813,
              -1948.734,
              13874.375
            ],
            [
              -5768.874,
              -2159.819,
              14342.704
            ],
            [
              -5759.931,
              -2298.028,
              14481.202
            ],
            [
              -5764.309,
              -2346.913,
              14530.282
            ],
            [
              -5745.608,
              -2354.913,
              14550.623
            ],
            [
              -5699.018,
              -2373.624,
              14600.83
            ],
            [
              -5698.581,
              -1978.091,
              14996.363
            ],
            [
              -5726.603,
              -1880.986,
              15097.43
            ],
            [
              -5827.254,
              -1945.668,
              15217.072
            ],
            [
              -5930.998,
              -1988.982,
              15329.495
            ],
            [
              -6228.224,
              -1992.872,
              15626.747
            ],
            [
              -6278.571,
              -1995.984,
              15677.19
            ],
            [
              -6312.713,
              -1995.515,
              15711.335
            ],
            [
              -6605.358,
              -1994.8,
              16003.981
            ],
            [
              -6631.353,
              -1995.05,
              16029.977
            ],
            [
              -6677.514,
              -1993.121,
              16076.178
            ],
            [
              -6680.925,
              -1734.803,
              16334.519
            ],
            [
              -6684.251,
              -1702.465,
              16367.028
            ],
            [
              -6705.09,
              -1676.513,
              16400.311
            ],
            [
              -6747.127,
              -1568.943,
              16515.803
            ],
            [
              -6771.666,
              -1532.911,
              16559.397
            ],
            [
              -6834.733,
              -1410.519,
              16697.082
            ],
            [
              -6861.847,
              -1368.999,
              16746.672
            ],
            [
              -6868.44,
              -1344.278,
              16772.257
            ],
            [
              -6865.755,
              -1340.811,
              16776.642
            ],
            [
              -6856.389,
              -1336.272,
              16787.05
            ],
            [
              -6847.396,
              -1333.735,
              16796.393
            ],
            [
              -6839.19,
              -1361.045,
              16824.91
            ],
            [
              -6825.084,
              -1411.793,
              16877.582
            ],
            [
              -6801.411,
              -1461.169,
              16932.339
            ],
            [
              -6771.957,
              -1511.755,
              16990.875
            ],
            [
              -6765.128,
              -1527.454,
              17007.995
            ],
            [
              -6769.807,
              -1537.394,
              17018.982
            ],
            [
              -6771.141,
              -1540.619,
              17022.472
            ],
            [
              -6827.09,
              -1597.371,
              17102.165
            ],
            [
              -6841.227,
              -1604.648,
              17118.065
            ],
            [
              -6863.189,
              -1570.343,
              17158.798
            ],
            [
              -6866.907,
              -1561.375,
              17168.506
            ],
            [
              -6864.843,
              -1553.618,
              17176.533
            ],
            [
              -6782.722,
              -1517.922,
              17266.077
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:7831",
              "position": {
                "x": 25.801,
                "z": -7471.678
              },
              "distanceAlongShapeM": 181.314,
              "shapeOffsetM": 0.459,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:6526",
              "position": {
                "x": -15.345,
                "z": -7080.178
              },
              "distanceAlongShapeM": 575.352,
              "shapeOffsetM": 5.051,
              "arrivalOffsetSeconds": 60,
              "departureOffsetSeconds": 60
            },
            {
              "stopId": "judu:stop:6503",
              "position": {
                "x": -50.829,
                "z": -6695.462
              },
              "distanceAlongShapeM": 985.165,
              "shapeOffsetM": 0.189,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:6501",
              "position": {
                "x": -182.398,
                "z": -6069.649
              },
              "distanceAlongShapeM": 1627.401,
              "shapeOffsetM": 2.159,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:6640",
              "position": {
                "x": -275.515,
                "z": -5664.961
              },
              "distanceAlongShapeM": 2112.602,
              "shapeOffsetM": 3.912,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:6634",
              "position": {
                "x": -663.705,
                "z": -5510.974
              },
              "distanceAlongShapeM": 2534.155,
              "shapeOffsetM": 1.549,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:5822",
              "position": {
                "x": -927.257,
                "z": -5373.739
              },
              "distanceAlongShapeM": 2831.684,
              "shapeOffsetM": 2.244,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:17872",
              "position": {
                "x": -1444.089,
                "z": -5565.944
              },
              "distanceAlongShapeM": 3597.771,
              "shapeOffsetM": 0.533,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:5813",
              "position": {
                "x": -1657.878,
                "z": -4949.841
              },
              "distanceAlongShapeM": 4517.707,
              "shapeOffsetM": 2.74,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:6917",
              "position": {
                "x": -1597.362,
                "z": -4555.726
              },
              "distanceAlongShapeM": 4924.484,
              "shapeOffsetM": 4.677,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            },
            {
              "stopId": "judu:stop:6921",
              "position": {
                "x": -1640.178,
                "z": -4067.366
              },
              "distanceAlongShapeM": 5427.939,
              "shapeOffsetM": 4.683,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:6924",
              "position": {
                "x": -1612.999,
                "z": -3808.47
              },
              "distanceAlongShapeM": 5687.246,
              "shapeOffsetM": 3.947,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:6928",
              "position": {
                "x": -1373.246,
                "z": -3230.542
              },
              "distanceAlongShapeM": 6319.276,
              "shapeOffsetM": 3.027,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:6941",
              "position": {
                "x": -1631.244,
                "z": -3062.281
              },
              "distanceAlongShapeM": 6745.057,
              "shapeOffsetM": 3.557,
              "arrivalOffsetSeconds": 1380,
              "departureOffsetSeconds": 1380
            },
            {
              "stopId": "judu:stop:733",
              "position": {
                "x": -2258.422,
                "z": -3104.556
              },
              "distanceAlongShapeM": 7430.862,
              "shapeOffsetM": 1.626,
              "arrivalOffsetSeconds": 1500,
              "departureOffsetSeconds": 1500
            },
            {
              "stopId": "judu:stop:393",
              "position": {
                "x": -2667.366,
                "z": -2795.644
              },
              "distanceAlongShapeM": 8317.293,
              "shapeOffsetM": 3.259,
              "arrivalOffsetSeconds": 1740,
              "departureOffsetSeconds": 1740
            },
            {
              "stopId": "judu:stop:5137",
              "position": {
                "x": -3175.503,
                "z": -3068.357
              },
              "distanceAlongShapeM": 8901.228,
              "shapeOffsetM": 0.854,
              "arrivalOffsetSeconds": 1860,
              "departureOffsetSeconds": 1860
            },
            {
              "stopId": "judu:stop:6580",
              "position": {
                "x": -3740.623,
                "z": -3064.057
              },
              "distanceAlongShapeM": 9506.916,
              "shapeOffsetM": 3.974,
              "arrivalOffsetSeconds": 2040,
              "departureOffsetSeconds": 2040
            },
            {
              "stopId": "judu:stop:6581",
              "position": {
                "x": -4002.758,
                "z": -2422.747
              },
              "distanceAlongShapeM": 10199.935,
              "shapeOffsetM": 4.266,
              "arrivalOffsetSeconds": 2160,
              "departureOffsetSeconds": 2160
            },
            {
              "stopId": "judu:stop:6588",
              "position": {
                "x": -4045.475,
                "z": -1837.572
              },
              "distanceAlongShapeM": 10794.851,
              "shapeOffsetM": 0.069,
              "arrivalOffsetSeconds": 2280,
              "departureOffsetSeconds": 2280
            },
            {
              "stopId": "judu:stop:6591",
              "position": {
                "x": -3809.119,
                "z": -1627.936
              },
              "distanceAlongShapeM": 11118.422,
              "shapeOffsetM": 2.593,
              "arrivalOffsetSeconds": 2340,
              "departureOffsetSeconds": 2340
            },
            {
              "stopId": "judu:stop:928",
              "position": {
                "x": -3525.544,
                "z": -1521.55
              },
              "distanceAlongShapeM": 11529.289,
              "shapeOffsetM": 4.655,
              "arrivalOffsetSeconds": 2460,
              "departureOffsetSeconds": 2460
            },
            {
              "stopId": "judu:stop:4991",
              "position": {
                "x": -3688.025,
                "z": -1189.21
              },
              "distanceAlongShapeM": 11930.402,
              "shapeOffsetM": 11.167,
              "arrivalOffsetSeconds": 2640,
              "departureOffsetSeconds": 2640
            },
            {
              "stopId": "judu:stop:4988",
              "position": {
                "x": -4294.993,
                "z": -1205.408
              },
              "distanceAlongShapeM": 12546.715,
              "shapeOffsetM": 5.602,
              "arrivalOffsetSeconds": 2760,
              "departureOffsetSeconds": 2760
            },
            {
              "stopId": "judu:stop:8060",
              "position": {
                "x": -4834.84,
                "z": -1481.101
              },
              "distanceAlongShapeM": 13167.731,
              "shapeOffsetM": 1.492,
              "arrivalOffsetSeconds": 2880,
              "departureOffsetSeconds": 2880
            },
            {
              "stopId": "judu:stop:17769",
              "position": {
                "x": -5758.969,
                "z": -2298.023
              },
              "distanceAlongShapeM": 14481.202,
              "shapeOffsetM": 0.962,
              "arrivalOffsetSeconds": 3000,
              "departureOffsetSeconds": 3000
            },
            {
              "stopId": "judu:stop:6619",
              "position": {
                "x": -5825.26,
                "z": -1949.582
              },
              "distanceAlongShapeM": 15217.072,
              "shapeOffsetM": 4.393,
              "arrivalOffsetSeconds": 3120,
              "departureOffsetSeconds": 3120
            },
            {
              "stopId": "judu:stop:6614",
              "position": {
                "x": -6278.639,
                "z": -2000.929
              },
              "distanceAlongShapeM": 15677.19,
              "shapeOffsetM": 4.946,
              "arrivalOffsetSeconds": 3240,
              "departureOffsetSeconds": 3240
            },
            {
              "stopId": "judu:stop:6612",
              "position": {
                "x": -6631.209,
                "z": -1999.462
              },
              "distanceAlongShapeM": 16029.876,
              "shapeOffsetM": 4.413,
              "arrivalOffsetSeconds": 3300,
              "departureOffsetSeconds": 3300
            },
            {
              "stopId": "judu:stop:7695",
              "position": {
                "x": -6705.09,
                "z": -1676.513
              },
              "distanceAlongShapeM": 16400.311,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 3360,
              "departureOffsetSeconds": 3360
            },
            {
              "stopId": "judu:stop:7693",
              "position": {
                "x": -6863.711,
                "z": -1369.96
              },
              "distanceAlongShapeM": 16746.672,
              "shapeOffsetM": 2.097,
              "arrivalOffsetSeconds": 3420,
              "departureOffsetSeconds": 3420
            }
          ],
          "departuresSeconds": [
            18960,
            21120,
            22560,
            24240,
            25680,
            27060,
            28860,
            30780,
            32580,
            34440,
            37260,
            39540,
            41820,
            44940,
            47580,
            49920,
            53160,
            56160,
            57240,
            58740,
            60000,
            61260,
            64800,
            66000,
            67320,
            68700,
            71880,
            74940,
            77760,
            79740,
            82560
          ]
        },
        {
          "id": "judu:pattern:vilnius_bus_75:1",
          "sourceRouteId": "vilnius_bus_75",
          "sourceShapeId": "vilnius_bus_75_b-a",
          "directionId": 1,
          "headsign": "Santariškės",
          "directionName": "Pilaitė–Justiniškės–Šeškinė–Fabijoniškės–Visorių g.–Santariškės",
          "mode": "bus",
          "routeShortName": "75",
          "routeLongName": "Santariškės–Visorių g.–Fabijoniškės–Šeškinė–Justiniškės–Pilaitė",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              -6782.722,
              -1517.922,
              0
            ],
            [
              -6790.213,
              -1503.239,
              16.483
            ],
            [
              -6789.666,
              -1493.237,
              26.501
            ],
            [
              -6789.574,
              -1493.338,
              26.637
            ],
            [
              -6793.888,
              -1496.036,
              31.725
            ],
            [
              -6804.801,
              -1471.131,
              58.916
            ],
            [
              -6817.871,
              -1443.083,
              89.859
            ],
            [
              -6849.755,
              -1383.551,
              157.392
            ],
            [
              -6861.847,
              -1368.999,
              176.312
            ],
            [
              -6868.44,
              -1344.278,
              201.897
            ],
            [
              -6865.755,
              -1340.811,
              206.282
            ],
            [
              -6856.389,
              -1336.272,
              216.69
            ],
            [
              -6847.396,
              -1333.735,
              226.034
            ],
            [
              -6839.19,
              -1361.045,
              254.55
            ],
            [
              -6823.318,
              -1421.841,
              317.384
            ],
            [
              -6726.31,
              -1602.786,
              522.693
            ],
            [
              -6717.082,
              -1622.391,
              544.361
            ],
            [
              -6684.251,
              -1702.465,
              630.904
            ],
            [
              -6676.395,
              -1733.766,
              663.176
            ],
            [
              -6677.514,
              -1993.121,
              922.533
            ],
            [
              -6624.319,
              -1987.967,
              975.977
            ],
            [
              -6584.624,
              -1989.111,
              1015.689
            ],
            [
              -6371.246,
              -1988.684,
              1229.067
            ],
            [
              -6349.222,
              -1988.597,
              1251.091
            ],
            [
              -6317.75,
              -1988.595,
              1282.563
            ],
            [
              -6227.58,
              -1992.883,
              1372.835
            ],
            [
              -5930.998,
              -1988.982,
              1669.443
            ],
            [
              -5872.445,
              -1960.324,
              1734.632
            ],
            [
              -5857.333,
              -1953.23,
              1751.327
            ],
            [
              -5672.246,
              -1870.029,
              1954.255
            ],
            [
              -5670.134,
              -1868.128,
              1957.096
            ],
            [
              -5643.415,
              -1866.17,
              1983.887
            ],
            [
              -5613.586,
              -1870.467,
              2014.024
            ],
            [
              -5587.52,
              -1877.073,
              2040.914
            ],
            [
              -5564.265,
              -1880.38,
              2064.403
            ],
            [
              -5542.301,
              -1877.807,
              2086.517
            ],
            [
              -5510.536,
              -1867.31,
              2119.972
            ],
            [
              -5409.021,
              -1770.744,
              2260.079
            ],
            [
              -5309.301,
              -1676.522,
              2397.273
            ],
            [
              -5284.902,
              -1667.131,
              2423.417
            ],
            [
              -5276.36,
              -1665.968,
              2432.037
            ],
            [
              -5229.899,
              -1662.476,
              2478.629
            ],
            [
              -5012.864,
              -1637.24,
              2697.126
            ],
            [
              -4867.118,
              -1446.038,
              2937.543
            ],
            [
              -4764.678,
              -1361.372,
              3070.442
            ],
            [
              -4704.75,
              -1314.599,
              3146.462
            ],
            [
              -4653.804,
              -1300.53,
              3199.316
            ],
            [
              -4405.208,
              -1203.507,
              3466.174
            ],
            [
              -4296.995,
              -1171.977,
              3578.887
            ],
            [
              -4246.587,
              -1162.091,
              3630.256
            ],
            [
              -4190.857,
              -1159.392,
              3686.051
            ],
            [
              -3912.052,
              -1135.777,
              3965.854
            ],
            [
              -3758.891,
              -1120.334,
              4119.791
            ],
            [
              -3704.617,
              -1115.802,
              4174.254
            ],
            [
              -3657.704,
              -1114.039,
              4221.2
            ],
            [
              -3599.031,
              -1113.947,
              4279.874
            ],
            [
              -3569.469,
              -1193.5,
              4364.742
            ],
            [
              -3554.873,
              -1243.849,
              4417.164
            ],
            [
              -3546.348,
              -1270.446,
              4445.093
            ],
            [
              -3520.478,
              -1415.883,
              4592.813
            ],
            [
              -3500.646,
              -1498.607,
              4677.881
            ],
            [
              -3461.302,
              -1608.388,
              4794.5
            ],
            [
              -3462.063,
              -1615.054,
              4801.209
            ],
            [
              -3466.214,
              -1618.635,
              4806.691
            ],
            [
              -3480.186,
              -1619.191,
              4820.674
            ],
            [
              -3518.97,
              -1623.742,
              4859.725
            ],
            [
              -3543.21,
              -1625.119,
              4884.003
            ],
            [
              -3571.837,
              -1625.385,
              4912.632
            ],
            [
              -3644.74,
              -1628.568,
              4985.604
            ],
            [
              -3721.548,
              -1633.911,
              5062.598
            ],
            [
              -3788.083,
              -1641.66,
              5129.582
            ],
            [
              -3841.2,
              -1656.322,
              5184.686
            ],
            [
              -3882.188,
              -1677.875,
              5230.995
            ],
            [
              -3931.102,
              -1710.422,
              5289.748
            ],
            [
              -3978.977,
              -1757.46,
              5356.864
            ],
            [
              -4022.062,
              -1825.732,
              5437.594
            ],
            [
              -4044.37,
              -1885.459,
              5501.352
            ],
            [
              -4052.817,
              -1926.501,
              5543.254
            ],
            [
              -4053.048,
              -1939.856,
              5556.611
            ],
            [
              -4053.478,
              -1959.825,
              5576.584
            ],
            [
              -4055.493,
              -2006.606,
              5623.409
            ],
            [
              -4046.573,
              -2161.497,
              5778.556
            ],
            [
              -4020.612,
              -2299.985,
              5919.457
            ],
            [
              -3990.129,
              -2400.702,
              6024.686
            ],
            [
              -3964.263,
              -2470.17,
              6098.813
            ],
            [
              -3946.156,
              -2503.88,
              6137.078
            ],
            [
              -3938.431,
              -2519.742,
              6154.722
            ],
            [
              -3933.698,
              -2531.347,
              6167.254
            ],
            [
              -3926.386,
              -2553.204,
              6190.302
            ],
            [
              -3765.67,
              -2947.847,
              6616.415
            ],
            [
              -3698.78,
              -3103.747,
              6786.059
            ],
            [
              -3686.788,
              -3103.033,
              6798.073
            ],
            [
              -3663.87,
              -3096.551,
              6821.89
            ],
            [
              -3644.524,
              -3091.72,
              6841.83
            ],
            [
              -3537.19,
              -3076.506,
              6950.237
            ],
            [
              -3288.387,
              -3074.173,
              7199.051
            ],
            [
              -3226.908,
              -3059.664,
              7262.218
            ],
            [
              -3088.313,
              -3020.904,
              7406.131
            ],
            [
              -3076.179,
              -3017.184,
              7418.823
            ],
            [
              -3065.414,
              -3014.303,
              7429.967
            ],
            [
              -3011.076,
              -2998.586,
              7486.532
            ],
            [
              -2972.094,
              -2983.696,
              7528.261
            ],
            [
              -2923.591,
              -2962.569,
              7581.165
            ],
            [
              -2796.251,
              -2867.959,
              7739.805
            ],
            [
              -2713.249,
              -2802.628,
              7845.434
            ],
            [
              -2678.551,
              -2772.069,
              7891.67
            ],
            [
              -2644.38,
              -2734.822,
              7942.217
            ],
            [
              -2633.43,
              -2718.353,
              7961.994
            ],
            [
              -2600.033,
              -2668.811,
              8021.742
            ],
            [
              -2574.02,
              -2619.176,
              8077.78
            ],
            [
              -2552.25,
              -2627.352,
              8101.035
            ],
            [
              -2471.713,
              -2665.511,
              8190.155
            ],
            [
              -2386.944,
              -2719.332,
              8290.566
            ],
            [
              -2340.637,
              -2761.341,
              8353.089
            ],
            [
              -2270.657,
              -2849.412,
              8465.578
            ],
            [
              -2238.843,
              -2908.976,
              8533.106
            ],
            [
              -2271.353,
              -2925.098,
              8569.394
            ],
            [
              -2292.95,
              -2943.64,
              8597.858
            ],
            [
              -2307.637,
              -2972.324,
              8630.084
            ],
            [
              -2313.343,
              -3003.393,
              8661.672
            ],
            [
              -2311.942,
              -3033.475,
              8691.787
            ],
            [
              -2302.653,
              -3054.791,
              8715.039
            ],
            [
              -2286.96,
              -3078.446,
              8743.426
            ],
            [
              -2258.264,
              -3095.653,
              8776.886
            ],
            [
              -2237.746,
              -3101.583,
              8798.243
            ],
            [
              -2215.841,
              -3101.972,
              8820.152
            ],
            [
              -2074.36,
              -3118.955,
              8962.648
            ],
            [
              -1943.03,
              -3126.856,
              9094.216
            ],
            [
              -1903.67,
              -3124.217,
              9133.664
            ],
            [
              -1868.018,
              -3112.606,
              9171.159
            ],
            [
              -1837.381,
              -3093.114,
              9207.471
            ],
            [
              -1816.447,
              -3075.675,
              9234.717
            ],
            [
              -1775.996,
              -3011.829,
              9310.299
            ],
            [
              -1683.756,
              -3043.532,
              9407.835
            ],
            [
              -1647.191,
              -3053.091,
              9445.629
            ],
            [
              -1571.382,
              -3065.693,
              9522.479
            ],
            [
              -1552.592,
              -3068.149,
              9541.428
            ],
            [
              -1523.92,
              -3071.312,
              9570.274
            ],
            [
              -1491.596,
              -3073.684,
              9602.685
            ],
            [
              -1438.786,
              -3075.742,
              9655.535
            ],
            [
              -1362.723,
              -3074.878,
              9731.603
            ],
            [
              -1357.098,
              -3120.622,
              9777.692
            ],
            [
              -1356.687,
              -3169.611,
              9826.682
            ],
            [
              -1363.762,
              -3240.731,
              9898.153
            ],
            [
              -1372.45,
              -3294.01,
              9952.136
            ],
            [
              -1374.779,
              -3312.201,
              9970.476
            ],
            [
              -1386.916,
              -3346.073,
              10006.456
            ],
            [
              -1441.889,
              -3500.94,
              10170.791
            ],
            [
              -1479.438,
              -3582.647,
              10260.713
            ],
            [
              -1526.789,
              -3671.971,
              10361.811
            ],
            [
              -1572.531,
              -3743.513,
              10446.726
            ],
            [
              -1605.428,
              -3817.511,
              10527.707
            ],
            [
              -1619.047,
              -3858.457,
              10570.859
            ],
            [
              -1621.258,
              -3874.003,
              10586.561
            ],
            [
              -1625.465,
              -3915.925,
              10628.693
            ],
            [
              -1630.122,
              -3937.298,
              10650.568
            ],
            [
              -1635.048,
              -3960.588,
              10674.374
            ],
            [
              -1633.18,
              -4036.321,
              10750.13
            ],
            [
              -1621.037,
              -4150.087,
              10864.542
            ],
            [
              -1615.667,
              -4168.374,
              10883.602
            ],
            [
              -1616.287,
              -4244.797,
              10960.027
            ],
            [
              -1593.127,
              -4499.027,
              11215.309
            ],
            [
              -1582.077,
              -4601.642,
              11318.518
            ],
            [
              -1576.639,
              -4648.623,
              11365.812
            ],
            [
              -1585.129,
              -4736.288,
              11453.887
            ],
            [
              -1597.975,
              -4806.192,
              11524.962
            ],
            [
              -1623.216,
              -4884.78,
              11607.504
            ],
            [
              -1642.847,
              -4937.864,
              11664.102
            ],
            [
              -1699.03,
              -5044.347,
              11784.497
            ],
            [
              -1723.84,
              -5072.231,
              11821.821
            ],
            [
              -1779.253,
              -5109.092,
              11888.374
            ],
            [
              -1785.792,
              -5114.542,
              11896.887
            ],
            [
              -1787.2,
              -5121.196,
              11903.688
            ],
            [
              -1739.044,
              -5202.208,
              11997.932
            ],
            [
              -1721.116,
              -5280.454,
              12078.206
            ],
            [
              -1691.717,
              -5365.585,
              12168.27
            ],
            [
              -1598.761,
              -5606.591,
              12426.581
            ],
            [
              -1589.202,
              -5612.328,
              12437.73
            ],
            [
              -1547.295,
              -5595.862,
              12482.755
            ],
            [
              -1523.425,
              -5587.537,
              12508.036
            ],
            [
              -1420.581,
              -5552.405,
              12616.715
            ],
            [
              -1332.085,
              -5521.983,
              12710.294
            ],
            [
              -1293.566,
              -5515.521,
              12749.351
            ],
            [
              -1258.266,
              -5512.502,
              12784.78
            ],
            [
              -1259.079,
              -5450.147,
              12847.14
            ],
            [
              -1252.12,
              -5421.328,
              12876.788
            ],
            [
              -1201.388,
              -5278.801,
              13028.075
            ],
            [
              -1187.102,
              -5244.378,
              13065.344
            ],
            [
              -1181.246,
              -5241.144,
              13072.034
            ],
            [
              -1067.322,
              -5282.156,
              13193.115
            ],
            [
              -979.178,
              -5323.82,
              13290.61
            ],
            [
              -879.042,
              -5379.061,
              13404.972
            ],
            [
              -827.457,
              -5404.886,
              13462.661
            ],
            [
              -674.33,
              -5492.97,
              13639.315
            ],
            [
              -590.252,
              -5533.933,
              13732.84
            ],
            [
              -565.267,
              -5552.833,
              13764.169
            ],
            [
              -421.759,
              -5631.135,
              13927.649
            ],
            [
              -383.93,
              -5640.727,
              13966.675
            ],
            [
              -342.157,
              -5645.939,
              14008.772
            ],
            [
              -257.182,
              -5648.596,
              14093.788
            ],
            [
              -196.756,
              -5655.261,
              14154.581
            ],
            [
              -180.177,
              -5664.469,
              14173.545
            ],
            [
              -177.649,
              -5676.666,
              14186.002
            ],
            [
              -188.191,
              -5725.09,
              14235.56
            ],
            [
              -190.648,
              -5736.736,
              14247.462
            ],
            [
              -196.91,
              -5769.923,
              14281.235
            ],
            [
              -201.665,
              -5818.819,
              14330.361
            ],
            [
              -201.086,
              -5857.793,
              14369.34
            ],
            [
              -195.599,
              -5910.215,
              14422.048
            ],
            [
              -136.015,
              -6175.138,
              14693.589
            ],
            [
              -127.679,
              -6205.529,
              14725.102
            ],
            [
              -123.468,
              -6228.802,
              14748.753
            ],
            [
              -113.557,
              -6285.758,
              14806.565
            ],
            [
              -58.166,
              -6532.794,
              15059.735
            ],
            [
              -46.468,
              -6597.576,
              15125.565
            ],
            [
              -39.377,
              -6667.839,
              15196.185
            ],
            [
              -35.045,
              -6748.072,
              15276.535
            ],
            [
              -26.235,
              -6767.677,
              15298.028
            ],
            [
              -16.413,
              -6780.218,
              15313.958
            ],
            [
              0.443,
              -6790.505,
              15333.705
            ],
            [
              9.552,
              -6811.226,
              15356.339
            ],
            [
              9.735,
              -6827.796,
              15372.911
            ],
            [
              7.024,
              -6842.352,
              15387.717
            ],
            [
              -10.864,
              -6869.857,
              15420.527
            ],
            [
              -21.671,
              -6897.49,
              15450.198
            ],
            [
              -11.966,
              -6926.765,
              15481.039
            ],
            [
              -9.853,
              -6955.595,
              15509.947
            ],
            [
              6.027,
              -7144.023,
              15699.043
            ],
            [
              11.629,
              -7176.924,
              15732.417
            ],
            [
              9.192,
              -7217.555,
              15773.122
            ],
            [
              36.523,
              -7443.114,
              16000.33
            ],
            [
              37.062,
              -7489.696,
              16046.915
            ],
            [
              41.201,
              -7509.81,
              16067.451
            ],
            [
              62.699,
              -7531.354,
              16097.886
            ],
            [
              71.413,
              -7563.928,
              16131.605
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:7694",
              "position": {
                "x": -6837.763,
                "z": -1360.375
              },
              "distanceAlongShapeM": 254.319,
              "shapeOffsetM": 1.56,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:4526",
              "position": {
                "x": -6711.23,
                "z": -1619.637
              },
              "distanceAlongShapeM": 544.361,
              "shapeOffsetM": 6.468,
              "arrivalOffsetSeconds": 60,
              "departureOffsetSeconds": 60
            },
            {
              "stopId": "judu:stop:6611",
              "position": {
                "x": -6624.485,
                "z": -1982.877
              },
              "distanceAlongShapeM": 975.977,
              "shapeOffsetM": 5.092,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:6615",
              "position": {
                "x": -6349.244,
                "z": -1983.044
              },
              "distanceAlongShapeM": 1251.091,
              "shapeOffsetM": 5.553,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:6618",
              "position": {
                "x": -5876.852,
                "z": -1950.936
              },
              "distanceAlongShapeM": 1734.632,
              "shapeOffsetM": 10.371,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:6621",
              "position": {
                "x": -5276.945,
                "z": -1661.673
              },
              "distanceAlongShapeM": 2432.037,
              "shapeOffsetM": 4.335,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:8934",
              "position": {
                "x": -4704.97,
                "z": -1314.122
              },
              "distanceAlongShapeM": 3146.462,
              "shapeOffsetM": 0.525,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:4989",
              "position": {
                "x": -4247.02,
                "z": -1152.802
              },
              "distanceAlongShapeM": 3630.272,
              "shapeOffsetM": 9.299,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:4990",
              "position": {
                "x": -3543.073,
                "z": -1269.659
              },
              "distanceAlongShapeM": 4445.093,
              "shapeOffsetM": 3.368,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:6597",
              "position": {
                "x": -3542.913,
                "z": -1630.342
              },
              "distanceAlongShapeM": 4884.003,
              "shapeOffsetM": 5.231,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:6587",
              "position": {
                "x": -4048.884,
                "z": -1959.966
              },
              "distanceAlongShapeM": 5576.584,
              "shapeOffsetM": 4.596,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:6582",
              "position": {
                "x": -3932.856,
                "z": -2517.469
              },
              "distanceAlongShapeM": 6154.722,
              "shapeOffsetM": 6.02,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:7001",
              "position": {
                "x": -3665.065,
                "z": -3092.089
              },
              "distanceAlongShapeM": 6821.89,
              "shapeOffsetM": 4.619,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            },
            {
              "stopId": "judu:stop:855",
              "position": {
                "x": -3013.674,
                "z": -2991.043
              },
              "distanceAlongShapeM": 7486.132,
              "shapeOffsetM": 7.967,
              "arrivalOffsetSeconds": 1500,
              "departureOffsetSeconds": 1500
            },
            {
              "stopId": "judu:stop:394",
              "position": {
                "x": -2636.314,
                "z": -2716.04
              },
              "distanceAlongShapeM": 7962.3,
              "shapeOffsetM": 3.684,
              "arrivalOffsetSeconds": 1560,
              "departureOffsetSeconds": 1560
            },
            {
              "stopId": "judu:stop:5208",
              "position": {
                "x": -2215.841,
                "z": -3101.972
              },
              "distanceAlongShapeM": 8820.152,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1740,
              "departureOffsetSeconds": 1740
            },
            {
              "stopId": "judu:stop:6940",
              "position": {
                "x": -1551.978,
                "z": -3062.585
              },
              "distanceAlongShapeM": 9541.316,
              "shapeOffsetM": 5.596,
              "arrivalOffsetSeconds": 1920,
              "departureOffsetSeconds": 1920
            },
            {
              "stopId": "judu:stop:6929",
              "position": {
                "x": -1372.145,
                "z": -3312.94
              },
              "distanceAlongShapeM": 9970.476,
              "shapeOffsetM": 2.736,
              "arrivalOffsetSeconds": 2040,
              "departureOffsetSeconds": 2040
            },
            {
              "stopId": "judu:stop:6926",
              "position": {
                "x": -1622.014,
                "z": -3916.292
              },
              "distanceAlongShapeM": 10628.693,
              "shapeOffsetM": 3.47,
              "arrivalOffsetSeconds": 2160,
              "departureOffsetSeconds": 2160
            },
            {
              "stopId": "judu:stop:6922",
              "position": {
                "x": -1612.338,
                "z": -4168.054
              },
              "distanceAlongShapeM": 10883.602,
              "shapeOffsetM": 3.344,
              "arrivalOffsetSeconds": 2220,
              "departureOffsetSeconds": 2220
            },
            {
              "stopId": "judu:stop:6918",
              "position": {
                "x": -1574.54,
                "z": -4648.532
              },
              "distanceAlongShapeM": 11365.812,
              "shapeOffsetM": 2.101,
              "arrivalOffsetSeconds": 2340,
              "departureOffsetSeconds": 2340
            },
            {
              "stopId": "judu:stop:5811",
              "position": {
                "x": -1696.959,
                "z": -5045.994
              },
              "distanceAlongShapeM": 11784.497,
              "shapeOffsetM": 2.646,
              "arrivalOffsetSeconds": 2460,
              "departureOffsetSeconds": 2460
            },
            {
              "stopId": "judu:stop:17871",
              "position": {
                "x": -1548.277,
                "z": -5593.022
              },
              "distanceAlongShapeM": 12482.764,
              "shapeOffsetM": 3.005,
              "arrivalOffsetSeconds": 2580,
              "departureOffsetSeconds": 2580
            },
            {
              "stopId": "judu:stop:5828",
              "position": {
                "x": -826.661,
                "z": -5403.385
              },
              "distanceAlongShapeM": 13462.661,
              "shapeOffsetM": 1.699,
              "arrivalOffsetSeconds": 2820,
              "departureOffsetSeconds": 2820
            },
            {
              "stopId": "judu:stop:6633",
              "position": {
                "x": -589.373,
                "z": -5532.358
              },
              "distanceAlongShapeM": 13732.84,
              "shapeOffsetM": 1.804,
              "arrivalOffsetSeconds": 2880,
              "departureOffsetSeconds": 2880
            },
            {
              "stopId": "judu:stop:6497",
              "position": {
                "x": -185.377,
                "z": -5737.848
              },
              "distanceAlongShapeM": 14247.577,
              "shapeOffsetM": 5.386,
              "arrivalOffsetSeconds": 3060,
              "departureOffsetSeconds": 3060
            },
            {
              "stopId": "judu:stop:6500",
              "position": {
                "x": -122.378,
                "z": -6204.331
              },
              "distanceAlongShapeM": 14725.102,
              "shapeOffsetM": 5.434,
              "arrivalOffsetSeconds": 3120,
              "departureOffsetSeconds": 3120
            },
            {
              "stopId": "judu:stop:6525",
              "position": {
                "x": -10.612,
                "z": -6926.637
              },
              "distanceAlongShapeM": 15481.039,
              "shapeOffsetM": 1.36,
              "arrivalOffsetSeconds": 3240,
              "departureOffsetSeconds": 3240
            },
            {
              "stopId": "judu:stop:6532",
              "position": {
                "x": 16.38,
                "z": -7176.496
              },
              "distanceAlongShapeM": 15732.417,
              "shapeOffsetM": 4.77,
              "arrivalOffsetSeconds": 3300,
              "departureOffsetSeconds": 3300
            },
            {
              "stopId": "judu:stop:6533",
              "position": {
                "x": 73.695,
                "z": -7563.839
              },
              "distanceAlongShapeM": 16131.605,
              "shapeOffsetM": 2.284,
              "arrivalOffsetSeconds": 3360,
              "departureOffsetSeconds": 3360
            }
          ],
          "departuresSeconds": [
            17880,
            19320,
            22980,
            24720,
            26400,
            28260,
            30360,
            33360,
            35220,
            37380,
            40980,
            43440,
            45840,
            49080,
            51900,
            53220,
            54600,
            55920,
            57120,
            60300,
            61620,
            63060,
            64380,
            67800,
            71160,
            73620,
            76140,
            78660,
            81240
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_bus_76",
      "sourceRouteId": "vilnius_bus_76",
      "mode": "bus",
      "shortName": "76",
      "longName": "Ateities–Balsių g.–Sakališkės–Bireliai",
      "color": "0073AC",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_bus_76:0",
          "sourceRouteId": "vilnius_bus_76",
          "sourceShapeId": "vilnius_bus_76_a-b",
          "directionId": 0,
          "headsign": "Bireliai",
          "directionName": "Ateities–Balsių g.–Sakališkės–Bireliai",
          "mode": "bus",
          "routeShortName": "76",
          "routeLongName": "Ateities–Balsių g.–Sakališkės–Bireliai",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              -837.459,
              -5315.912,
              0
            ],
            [
              -870.627,
              -5342.117,
              42.27
            ],
            [
              -874.492,
              -5355.616,
              56.312
            ],
            [
              -875.788,
              -5375.937,
              76.674
            ],
            [
              -865.47,
              -5384.739,
              90.236
            ],
            [
              -827.457,
              -5404.886,
              133.258
            ],
            [
              -674.33,
              -5492.97,
              309.912
            ],
            [
              -590.252,
              -5533.933,
              403.438
            ],
            [
              -565.267,
              -5552.833,
              434.766
            ],
            [
              -421.759,
              -5631.135,
              598.246
            ],
            [
              -383.93,
              -5640.727,
              637.272
            ],
            [
              -342.157,
              -5645.939,
              679.369
            ],
            [
              -257.182,
              -5648.596,
              764.386
            ],
            [
              -196.756,
              -5655.261,
              825.178
            ],
            [
              -180.177,
              -5664.469,
              844.143
            ],
            [
              -177.649,
              -5676.666,
              856.599
            ],
            [
              -188.191,
              -5725.09,
              906.157
            ],
            [
              -190.648,
              -5736.736,
              918.06
            ],
            [
              -196.91,
              -5769.923,
              951.832
            ],
            [
              -201.665,
              -5818.819,
              1000.959
            ],
            [
              -201.086,
              -5857.793,
              1039.937
            ],
            [
              -195.599,
              -5910.215,
              1092.645
            ],
            [
              -136.015,
              -6175.138,
              1364.186
            ],
            [
              -127.679,
              -6205.529,
              1395.7
            ],
            [
              -123.468,
              -6228.802,
              1419.351
            ],
            [
              -113.557,
              -6285.758,
              1477.163
            ],
            [
              -58.166,
              -6532.794,
              1730.332
            ],
            [
              -46.468,
              -6597.576,
              1796.162
            ],
            [
              -39.377,
              -6667.839,
              1866.782
            ],
            [
              -35.045,
              -6748.072,
              1947.132
            ],
            [
              -26.235,
              -6767.677,
              1968.625
            ],
            [
              -16.413,
              -6780.218,
              1984.555
            ],
            [
              316.667,
              -6965.921,
              2365.906
            ],
            [
              488.123,
              -7067.612,
              2565.25
            ],
            [
              569.198,
              -7111.985,
              2657.673
            ],
            [
              607.888,
              -7122.125,
              2697.67
            ],
            [
              857.011,
              -7088.385,
              2949.067
            ],
            [
              912.144,
              -7077.353,
              3005.293
            ],
            [
              963.953,
              -7074.956,
              3057.157
            ],
            [
              999.073,
              -7089.195,
              3095.055
            ],
            [
              1051.285,
              -7144.223,
              3170.911
            ],
            [
              1072.093,
              -7168.96,
              3203.235
            ],
            [
              1095.862,
              -7195.215,
              3238.652
            ],
            [
              1133.283,
              -7225.965,
              3287.086
            ],
            [
              1291.476,
              -7341.333,
              3482.879
            ],
            [
              1307.902,
              -7358.336,
              3506.52
            ],
            [
              1326.737,
              -7384.29,
              3538.588
            ],
            [
              1553.349,
              -7767.005,
              3983.362
            ],
            [
              1621.327,
              -7885.162,
              4119.678
            ],
            [
              1632.975,
              -7916.55,
              4153.158
            ],
            [
              1640.555,
              -7958.994,
              4196.273
            ],
            [
              1640.017,
              -8022.44,
              4259.722
            ],
            [
              1642.406,
              -8067.015,
              4304.361
            ],
            [
              1656.397,
              -8103.348,
              4343.294
            ],
            [
              1677.887,
              -8132.245,
              4379.306
            ],
            [
              1693.917,
              -8148.951,
              4402.459
            ],
            [
              1731.324,
              -8201.149,
              4466.677
            ],
            [
              1750.194,
              -8224.879,
              4496.995
            ],
            [
              1771.941,
              -8240.583,
              4523.82
            ],
            [
              1800.494,
              -8254.762,
              4555.699
            ],
            [
              1956.145,
              -8296.632,
              4716.883
            ],
            [
              2001.461,
              -8317.518,
              4766.781
            ],
            [
              2065.812,
              -8353.233,
              4840.379
            ],
            [
              2107.826,
              -8378.511,
              4889.411
            ],
            [
              2156.129,
              -8411.7,
              4948.017
            ],
            [
              2317.488,
              -8560.563,
              5167.555
            ],
            [
              2642.21,
              -8852.78,
              5604.402
            ],
            [
              2791.088,
              -8986.135,
              5804.272
            ],
            [
              2937.046,
              -9115.683,
              5999.429
            ],
            [
              2991.321,
              -9163.457,
              6071.735
            ],
            [
              3011.49,
              -9179.33,
              6097.401
            ],
            [
              3028.932,
              -9199.631,
              6124.166
            ],
            [
              3134.104,
              -9331.147,
              6292.563
            ],
            [
              3165.86,
              -9378.122,
              6349.265
            ],
            [
              3173.134,
              -9395.181,
              6367.811
            ],
            [
              3208.182,
              -9555.935,
              6532.341
            ],
            [
              3213.698,
              -9570.512,
              6547.926
            ],
            [
              3220.466,
              -9581.843,
              6561.125
            ],
            [
              3233.82,
              -9595.386,
              6580.144
            ],
            [
              3263.762,
              -9611.54,
              6614.166
            ],
            [
              3404.645,
              -9675.718,
              6768.978
            ],
            [
              3447.994,
              -9704.103,
              6820.794
            ],
            [
              3478.945,
              -9734.751,
              6864.351
            ],
            [
              3511.635,
              -9775.451,
              6916.554
            ],
            [
              3546.778,
              -9856.276,
              7004.689
            ],
            [
              3563.744,
              -9877.752,
              7032.058
            ],
            [
              3583.678,
              -9891.979,
              7056.548
            ],
            [
              3682.485,
              -9978.543,
              7187.91
            ],
            [
              3753.117,
              -10037.223,
              7279.738
            ],
            [
              3823.892,
              -10096.649,
              7372.153
            ],
            [
              3844.831,
              -10118.191,
              7402.194
            ],
            [
              3858.592,
              -10138.8,
              7426.975
            ],
            [
              3926.673,
              -10148.641,
              7495.764
            ],
            [
              3939.417,
              -10136.766,
              7513.183
            ],
            [
              3958.891,
              -10112.407,
              7544.369
            ],
            [
              3976.899,
              -10082.83,
              7578.997
            ],
            [
              4005.248,
              -10076.848,
              7607.969
            ],
            [
              4078.036,
              -10076.185,
              7680.761
            ],
            [
              4616.869,
              -10074.981,
              8219.595
            ],
            [
              4852.261,
              -10074.019,
              8454.989
            ],
            [
              4900.288,
              -10073.896,
              8503.016
            ],
            [
              4837.14,
              -10286.278,
              8724.587
            ],
            [
              5053.096,
              -10366.148,
              8954.84
            ],
            [
              5067.726,
              -10355.898,
              8972.703
            ],
            [
              5062.5,
              -10367.629,
              8985.544
            ],
            [
              4896.095,
              -10309.333,
              9161.865
            ],
            [
              4833.28,
              -10286.204,
              9228.803
            ],
            [
              4729.917,
              -10573.66,
              9534.278
            ],
            [
              4712.27,
              -10627.858,
              9591.276
            ],
            [
              4697.985,
              -10669.421,
              9635.226
            ],
            [
              4668.42,
              -10726.105,
              9699.156
            ],
            [
              4648.672,
              -10748.94,
              9729.346
            ],
            [
              4626.349,
              -10769.747,
              9759.862
            ],
            [
              4582.524,
              -10800.967,
              9813.671
            ],
            [
              4520.59,
              -10827.778,
              9881.159
            ],
            [
              4504.183,
              -10834.24,
              9898.793
            ],
            [
              4278.9,
              -10923.384,
              10141.072
            ],
            [
              4292.187,
              -10951.534,
              10172.2
            ],
            [
              4288.547,
              -10964.423,
              10185.593
            ],
            [
              4278.53,
              -10972.614,
              10198.533
            ],
            [
              4430.258,
              -11265.092,
              10528.024
            ],
            [
              4428.478,
              -11261.671,
              10531.88
            ],
            [
              4494.067,
              -11389.215,
              10675.3
            ],
            [
              4505.917,
              -11412.438,
              10701.372
            ],
            [
              4520.389,
              -11456.081,
              10747.351
            ],
            [
              4522.05,
              -11479.25,
              10770.58
            ],
            [
              4511.95,
              -11539.696,
              10831.864
            ],
            [
              4490.708,
              -11638.294,
              10932.724
            ],
            [
              4485.489,
              -11662.153,
              10957.147
            ],
            [
              4441.273,
              -11862.841,
              11162.648
            ],
            [
              4401.77,
              -12054.136,
              11357.98
            ],
            [
              4294.404,
              -12542.458,
              11857.965
            ],
            [
              4281.58,
              -12608.954,
              11925.686
            ],
            [
              4283.669,
              -12632.427,
              11949.252
            ],
            [
              4293.038,
              -12652.968,
              11971.83
            ],
            [
              4315.183,
              -12687.635,
              12012.965
            ],
            [
              4318.714,
              -12695.257,
              12021.366
            ],
            [
              4315.194,
              -12698.717,
              12026.301
            ],
            [
              4303.532,
              -12697.415,
              12038.036
            ],
            [
              4266.282,
              -12693.945,
              12075.447
            ],
            [
              4245.373,
              -12688.354,
              12097.091
            ],
            [
              4230.109,
              -12687.139,
              12112.403
            ],
            [
              4221.712,
              -12680.642,
              12123.02
            ],
            [
              4210.448,
              -12666.133,
              12141.388
            ],
            [
              4191.957,
              -12640.414,
              12173.065
            ],
            [
              4183.797,
              -12638.21,
              12181.516
            ],
            [
              4172.181,
              -12644.813,
              12194.878
            ],
            [
              4135.313,
              -12658.045,
              12234.049
            ],
            [
              4112.642,
              -12655.931,
              12256.818
            ],
            [
              3804.962,
              -12592.31,
              12571.007
            ],
            [
              3508.49,
              -12519.29,
              12876.339
            ],
            [
              3445.773,
              -12503.788,
              12940.943
            ],
            [
              3347.961,
              -12482.788,
              13040.984
            ],
            [
              3327.491,
              -12480.634,
              13061.567
            ],
            [
              3104.605,
              -12787.154,
              13440.557
            ],
            [
              3088.168,
              -12816.573,
              13474.256
            ],
            [
              3078.426,
              -12839.591,
              13499.251
            ],
            [
              3045.608,
              -12909.414,
              13576.402
            ],
            [
              3013.589,
              -12980.414,
              13654.288
            ],
            [
              2975.61,
              -13068.357,
              13750.081
            ],
            [
              2927.996,
              -13174.635,
              13866.538
            ],
            [
              2923.124,
              -13187.274,
              13880.083
            ],
            [
              2803.186,
              -13463.51,
              14181.234
            ],
            [
              2685.761,
              -13723.904,
              14466.879
            ],
            [
              2582.783,
              -13952.375,
              14717.486
            ],
            [
              2568.826,
              -13985.412,
              14753.35
            ],
            [
              2559.617,
              -14019.024,
              14788.201
            ],
            [
              2557.908,
              -14052.373,
              14821.593
            ],
            [
              2559.742,
              -14106.966,
              14876.217
            ],
            [
              2553.673,
              -14170.237,
              14939.779
            ],
            [
              2550.575,
              -14183.848,
              14953.738
            ],
            [
              2533.884,
              -14319.513,
              15090.426
            ],
            [
              2527.951,
              -14392.719,
              15163.872
            ],
            [
              2503.612,
              -14561.868,
              15334.763
            ],
            [
              2490.796,
              -14622.612,
              15396.844
            ],
            [
              2478.105,
              -14730.274,
              15505.251
            ],
            [
              2469.407,
              -14848.342,
              15623.639
            ],
            [
              2941.867,
              -15045.363,
              16135.533
            ],
            [
              2962.156,
              -15052.845,
              16157.158
            ],
            [
              3081.11,
              -15066.259,
              16276.866
            ],
            [
              3098.995,
              -15066.604,
              16294.754
            ],
            [
              3102.826,
              -15068.01,
              16298.835
            ],
            [
              3104.039,
              -15076.92,
              16307.828
            ],
            [
              3099.603,
              -15087.638,
              16319.428
            ],
            [
              3094.533,
              -15089.123,
              16324.71
            ],
            [
              3089.347,
              -15080.204,
              16335.027
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:5827",
              "position": {
                "x": -835.417,
                "z": -5317.507
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 2.591,
              "arrivalOffsetSeconds": -660,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:5828",
              "position": {
                "x": -826.661,
                "z": -5403.385
              },
              "distanceAlongShapeM": 133.258,
              "shapeOffsetM": 1.699,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:6633",
              "position": {
                "x": -589.373,
                "z": -5532.358
              },
              "distanceAlongShapeM": 403.438,
              "shapeOffsetM": 1.804,
              "arrivalOffsetSeconds": 60,
              "departureOffsetSeconds": 60
            },
            {
              "stopId": "judu:stop:6497",
              "position": {
                "x": -185.377,
                "z": -5737.848
              },
              "distanceAlongShapeM": 918.175,
              "shapeOffsetM": 5.386,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:6500",
              "position": {
                "x": -122.378,
                "z": -6204.331
              },
              "distanceAlongShapeM": 1395.7,
              "shapeOffsetM": 5.434,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:16627",
              "position": {
                "x": 320.415,
                "z": -6959.406
              },
              "distanceAlongShapeM": 2365.906,
              "shapeOffsetM": 7.516,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:6797",
              "position": {
                "x": 1056.317,
                "z": -7139.934
              },
              "distanceAlongShapeM": 3170.911,
              "shapeOffsetM": 6.612,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:6800",
              "position": {
                "x": 1694.973,
                "z": -8148.149
              },
              "distanceAlongShapeM": 4402.459,
              "shapeOffsetM": 1.326,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:6803",
              "position": {
                "x": 3013.269,
                "z": -9177.069
              },
              "distanceAlongShapeM": 6097.401,
              "shapeOffsetM": 2.877,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:6856",
              "position": {
                "x": 3684.789,
                "z": -9975.801
              },
              "distanceAlongShapeM": 7187.837,
              "shapeOffsetM": 3.581,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:10554",
              "position": {
                "x": 3850.114,
                "z": -10113.666
              },
              "distanceAlongShapeM": 7402.194,
              "shapeOffsetM": 6.956,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            },
            {
              "stopId": "judu:stop:9046",
              "position": {
                "x": 4200.33,
                "z": -10072.504
              },
              "distanceAlongShapeM": 7803.063,
              "shapeOffsetM": 3.408,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:9048",
              "position": {
                "x": 4616.81,
                "z": -10066.046
              },
              "distanceAlongShapeM": 8219.556,
              "shapeOffsetM": 8.935,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:15114",
              "position": {
                "x": 4852.251,
                "z": -10070.594
              },
              "distanceAlongShapeM": 8454.989,
              "shapeOffsetM": 3.425,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:9081",
              "position": {
                "x": 5073.204,
                "z": -10357.647
              },
              "distanceAlongShapeM": 8972.703,
              "shapeOffsetM": 5.75,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            },
            {
              "stopId": "judu:stop:16870",
              "position": {
                "x": 4715.978,
                "z": -10629.055
              },
              "distanceAlongShapeM": 9591.266,
              "shapeOffsetM": 3.897,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            },
            {
              "stopId": "judu:stop:9053",
              "position": {
                "x": 4522.866,
                "z": -10833.513
              },
              "distanceAlongShapeM": 9881.159,
              "shapeOffsetM": 6.17,
              "arrivalOffsetSeconds": 1500,
              "departureOffsetSeconds": 1500
            },
            {
              "stopId": "judu:stop:8315",
              "position": {
                "x": 4289.98,
                "z": -10965.964
              },
              "distanceAlongShapeM": 10185.593,
              "shapeOffsetM": 2.104,
              "arrivalOffsetSeconds": 1560,
              "departureOffsetSeconds": 1560
            },
            {
              "stopId": "judu:stop:8004",
              "position": {
                "x": 4493.832,
                "z": -11638.971
              },
              "distanceAlongShapeM": 10932.724,
              "shapeOffsetM": 3.197,
              "arrivalOffsetSeconds": 1680,
              "departureOffsetSeconds": 1680
            },
            {
              "stopId": "judu:stop:8005",
              "position": {
                "x": 4404.772,
                "z": -12054.736
              },
              "distanceAlongShapeM": 11357.96,
              "shapeOffsetM": 3.061,
              "arrivalOffsetSeconds": 1740,
              "departureOffsetSeconds": 1740
            },
            {
              "stopId": "judu:stop:8006",
              "position": {
                "x": 4295.286,
                "z": -12697.221
              },
              "distanceAlongShapeM": 12046.264,
              "shapeOffsetM": 0.572,
              "arrivalOffsetSeconds": 1800,
              "departureOffsetSeconds": 1800
            },
            {
              "stopId": "judu:stop:10552",
              "position": {
                "x": 3803.923,
                "z": -12596.508
              },
              "distanceAlongShapeM": 12571.012,
              "shapeOffsetM": 4.325,
              "arrivalOffsetSeconds": 1920,
              "departureOffsetSeconds": 1920
            },
            {
              "stopId": "judu:stop:8008",
              "position": {
                "x": 3507.545,
                "z": -12522.939
              },
              "distanceAlongShapeM": 12876.381,
              "shapeOffsetM": 3.77,
              "arrivalOffsetSeconds": 1980,
              "departureOffsetSeconds": 1980
            },
            {
              "stopId": "judu:stop:8009",
              "position": {
                "x": 3081.528,
                "z": -12841.03
              },
              "distanceAlongShapeM": 13499.251,
              "shapeOffsetM": 3.419,
              "arrivalOffsetSeconds": 2100,
              "departureOffsetSeconds": 2100
            },
            {
              "stopId": "judu:stop:8368",
              "position": {
                "x": 2926.385,
                "z": -13188.772
              },
              "distanceAlongShapeM": 13880.158,
              "shapeOffsetM": 3.588,
              "arrivalOffsetSeconds": 2160,
              "departureOffsetSeconds": 2160
            },
            {
              "stopId": "judu:stop:9001",
              "position": {
                "x": 2691.801,
                "z": -13726.501
              },
              "distanceAlongShapeM": 14466.764,
              "shapeOffsetM": 6.574,
              "arrivalOffsetSeconds": 2220,
              "departureOffsetSeconds": 2220
            },
            {
              "stopId": "judu:stop:8010",
              "position": {
                "x": 2561.815,
                "z": -14107.014
              },
              "distanceAlongShapeM": 14876.217,
              "shapeOffsetM": 2.074,
              "arrivalOffsetSeconds": 2280,
              "departureOffsetSeconds": 2280
            },
            {
              "stopId": "judu:stop:4777",
              "position": {
                "x": 2470.439,
                "z": -14827.807
              },
              "distanceAlongShapeM": 15603.084,
              "shapeOffsetM": 0.48,
              "arrivalOffsetSeconds": 2400,
              "departureOffsetSeconds": 2400
            },
            {
              "stopId": "judu:stop:8025",
              "position": {
                "x": 3085.299,
                "z": -15082.131
              },
              "distanceAlongShapeM": 16335.027,
              "shapeOffsetM": 4.483,
              "arrivalOffsetSeconds": 2460,
              "departureOffsetSeconds": 2460
            }
          ],
          "departuresSeconds": [
            19860,
            21000,
            22860,
            24360,
            26100,
            27240,
            28200,
            31500,
            33120,
            34740,
            37020,
            38400,
            39600,
            41400,
            42900,
            44700,
            46200,
            47700,
            49200,
            51000,
            52500,
            53400,
            54600,
            55500,
            57000,
            58500,
            60000,
            61200,
            62400,
            65580,
            67500,
            70020,
            71220,
            72600,
            74100,
            75900,
            76800,
            78600,
            80100,
            81480,
            82380
          ]
        },
        {
          "id": "judu:pattern:vilnius_bus_76:1",
          "sourceRouteId": "vilnius_bus_76",
          "sourceShapeId": "vilnius_bus_76_b-a",
          "directionId": 1,
          "headsign": "Ateities st.",
          "directionName": "Bireliai–Sakališkės–Balsių g.–Ateities st.",
          "mode": "bus",
          "routeShortName": "76",
          "routeLongName": "Ateities–Balsių g.–Sakališkės–Bireliai",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              3089.347,
              -15080.204,
              0
            ],
            [
              3084.543,
              -15069.117,
              12.083
            ],
            [
              3077.908,
              -15066.045,
              19.395
            ],
            [
              3035.537,
              -15063.707,
              61.83
            ],
            [
              2986.766,
              -15057.996,
              110.935
            ],
            [
              2945.95,
              -15046.88,
              153.238
            ],
            [
              2877.3,
              -15021.377,
              226.472
            ],
            [
              2694,
              -14946.315,
              424.545
            ],
            [
              2553.556,
              -14883.69,
              578.319
            ],
            [
              2464.664,
              -14851.123,
              672.989
            ],
            [
              2471.813,
              -14807.835,
              716.863
            ],
            [
              2474.715,
              -14772.412,
              752.405
            ],
            [
              2478.384,
              -14726.912,
              798.053
            ],
            [
              2488.027,
              -14641.668,
              883.841
            ],
            [
              2507.389,
              -14542.68,
              984.705
            ],
            [
              2514.001,
              -14502.083,
              1025.836
            ],
            [
              2528.221,
              -14389.439,
              1139.374
            ],
            [
              2535.87,
              -14294.953,
              1234.169
            ],
            [
              2555.441,
              -14153.666,
              1376.806
            ],
            [
              2557.372,
              -14127.031,
              1403.51
            ],
            [
              2558.993,
              -14102.533,
              1428.062
            ],
            [
              2559.584,
              -14066.836,
              1463.764
            ],
            [
              2556.521,
              -14044.521,
              1486.288
            ],
            [
              2557.894,
              -14023.648,
              1507.206
            ],
            [
              2575.723,
              -13965.121,
              1568.389
            ],
            [
              2769.294,
              -13538.708,
              2036.681
            ],
            [
              2827.721,
              -13407.333,
              2180.463
            ],
            [
              2927.996,
              -13174.635,
              2433.847
            ],
            [
              3093.974,
              -12804.056,
              2839.898
            ],
            [
              3103.184,
              -12789.293,
              2857.298
            ],
            [
              3204.615,
              -12648.425,
              3030.884
            ],
            [
              3249.211,
              -12579.253,
              3113.185
            ],
            [
              3314.158,
              -12494.871,
              3219.668
            ],
            [
              3325.61,
              -12480.559,
              3237.997
            ],
            [
              3351.885,
              -12483.289,
              3264.414
            ],
            [
              3457.661,
              -12505.485,
              3372.494
            ],
            [
              3764.574,
              -12581.452,
              3688.668
            ],
            [
              4112.642,
              -12655.931,
              4044.616
            ],
            [
              4128.878,
              -12657.2,
              4060.901
            ],
            [
              4153.045,
              -12653.796,
              4085.307
            ],
            [
              4185.354,
              -12636.396,
              4122.003
            ],
            [
              4190.961,
              -12637.325,
              4127.687
            ],
            [
              4219.012,
              -12675.834,
              4175.33
            ],
            [
              4225.367,
              -12683.033,
              4184.932
            ],
            [
              4234.678,
              -12687.693,
              4195.344
            ],
            [
              4250.357,
              -12687.839,
              4211.023
            ],
            [
              4258.816,
              -12687.218,
              4219.505
            ],
            [
              4264.007,
              -12686.435,
              4224.755
            ],
            [
              4272.356,
              -12672.821,
              4240.725
            ],
            [
              4333.648,
              -12356.237,
              4563.188
            ],
            [
              4384.004,
              -12131.153,
              4793.836
            ],
            [
              4416.375,
              -11975.39,
              4952.927
            ],
            [
              4488.674,
              -11647.682,
              5288.516
            ],
            [
              4501.985,
              -11574.76,
              5362.643
            ],
            [
              4516.791,
              -11515.839,
              5423.395
            ],
            [
              4521.863,
              -11468.205,
              5471.299
            ],
            [
              4516.342,
              -11439.013,
              5501.008
            ],
            [
              4472.42,
              -11347.991,
              5602.073
            ],
            [
              4286.766,
              -10988.625,
              6006.562
            ],
            [
              4280.398,
              -10976.279,
              6020.453
            ],
            [
              4289.134,
              -10959.804,
              6039.101
            ],
            [
              4289.359,
              -10949.359,
              6049.549
            ],
            [
              4279.795,
              -10926.803,
              6074.048
            ],
            [
              4282.474,
              -10921.288,
              6080.18
            ],
            [
              4545.72,
              -10816.141,
              6363.648
            ],
            [
              4560.877,
              -10808.935,
              6380.43
            ],
            [
              4606.823,
              -10783.921,
              6432.745
            ],
            [
              4645.916,
              -10751.621,
              6483.455
            ],
            [
              4702.29,
              -10658.775,
              6592.075
            ],
            [
              4767.333,
              -10475.321,
              6786.719
            ],
            [
              4834.832,
              -10283.879,
              6989.712
            ],
            [
              4885.039,
              -10305.018,
              7044.188
            ],
            [
              5018.07,
              -10353.942,
              7185.93
            ],
            [
              5042.124,
              -10362.324,
              7211.402
            ],
            [
              5067.726,
              -10355.898,
              7237.798
            ],
            [
              5061.006,
              -10368.904,
              7252.437
            ],
            [
              5026.912,
              -10355.636,
              7289.022
            ],
            [
              4837.27,
              -10288.031,
              7490.353
            ],
            [
              4899.661,
              -10076.829,
              7710.579
            ],
            [
              4160.977,
              -10076.356,
              8449.263
            ],
            [
              4078.036,
              -10076.185,
              8532.204
            ],
            [
              4005.248,
              -10076.848,
              8604.996
            ],
            [
              3980.716,
              -10084.256,
              8630.622
            ],
            [
              3969.224,
              -10095.225,
              8646.508
            ],
            [
              3948.343,
              -10125.564,
              8683.338
            ],
            [
              3935.258,
              -10140.984,
              8703.562
            ],
            [
              3926.621,
              -10148.536,
              8715.035
            ],
            [
              3926.646,
              -10148.59,
              8715.094
            ],
            [
              3858.592,
              -10138.8,
              8783.848
            ],
            [
              3836.085,
              -10112.757,
              8818.269
            ],
            [
              3633.404,
              -9936.97,
              9086.561
            ],
            [
              3615.583,
              -9923.348,
              9108.992
            ],
            [
              3583.925,
              -9891.609,
              9153.82
            ],
            [
              3560.012,
              -9871.001,
              9185.388
            ],
            [
              3541.801,
              -9847.275,
              9215.297
            ],
            [
              3514.661,
              -9785.528,
              9282.746
            ],
            [
              3500.953,
              -9761.888,
              9310.072
            ],
            [
              3482.098,
              -9738.151,
              9340.387
            ],
            [
              3456.873,
              -9710.952,
              9377.482
            ],
            [
              3423.2,
              -9688.046,
              9418.208
            ],
            [
              3388.156,
              -9669.567,
              9457.825
            ],
            [
              3277.145,
              -9618.474,
              9580.03
            ],
            [
              3228.737,
              -9591.949,
              9635.229
            ],
            [
              3213.634,
              -9573.85,
              9658.801
            ],
            [
              3206.315,
              -9552.559,
              9681.315
            ],
            [
              3171.376,
              -9392.699,
              9844.949
            ],
            [
              3164.552,
              -9379.21,
              9860.066
            ],
            [
              3134.104,
              -9331.147,
              9916.962
            ],
            [
              3021.317,
              -9193.92,
              10094.591
            ],
            [
              2970.687,
              -9148.431,
              10162.654
            ],
            [
              2956.452,
              -9138.027,
              10180.285
            ],
            [
              2944.749,
              -9124.562,
              10198.126
            ],
            [
              2590.356,
              -8808.28,
              10673.13
            ],
            [
              2140.228,
              -8401.383,
              11279.909
            ],
            [
              2107.826,
              -8378.511,
              11319.57
            ],
            [
              1978.502,
              -8305.956,
              11467.857
            ],
            [
              1955.502,
              -8296.62,
              11492.679
            ],
            [
              1919.797,
              -8287.49,
              11529.533
            ],
            [
              1794.124,
              -8252.003,
              11660.12
            ],
            [
              1773.386,
              -8241.44,
              11683.394
            ],
            [
              1750.194,
              -8224.879,
              11711.892
            ],
            [
              1684.136,
              -8142.38,
              11817.579
            ],
            [
              1655.922,
              -8101.778,
              11867.021
            ],
            [
              1643.486,
              -8078.168,
              11893.706
            ],
            [
              1639.977,
              -8059.177,
              11913.018
            ],
            [
              1639.433,
              -7950.068,
              12022.129
            ],
            [
              1629.362,
              -7903.123,
              12070.142
            ],
            [
              1545.21,
              -7754.608,
              12240.841
            ],
            [
              1341.067,
              -7410.16,
              12641.239
            ],
            [
              1312.907,
              -7366.221,
              12693.428
            ],
            [
              1291.476,
              -7341.333,
              12726.271
            ],
            [
              1145.93,
              -7238.444,
              12904.512
            ],
            [
              1102.154,
              -7203.124,
              12960.76
            ],
            [
              1045.977,
              -7141.97,
              13043.8
            ],
            [
              1029.249,
              -7124.149,
              13068.242
            ],
            [
              999.073,
              -7089.195,
              13114.42
            ],
            [
              951.943,
              -7073.438,
              13164.115
            ],
            [
              652.324,
              -7119.127,
              13467.197
            ],
            [
              622.009,
              -7121.909,
              13497.64
            ],
            [
              600.797,
              -7121.363,
              13518.858
            ],
            [
              577.752,
              -7115.358,
              13542.673
            ],
            [
              488.616,
              -7067.891,
              13643.66
            ],
            [
              60.82,
              -6823.295,
              14136.445
            ],
            [
              14.911,
              -6833.59,
              14183.494
            ],
            [
              -2.815,
              -6852.191,
              14209.188
            ],
            [
              -13.86,
              -6857.556,
              14221.467
            ],
            [
              -37.095,
              -6860.472,
              14244.885
            ],
            [
              -47.374,
              -6859.171,
              14255.246
            ],
            [
              -59.463,
              -6851.158,
              14269.749
            ],
            [
              -67.548,
              -6835.425,
              14287.438
            ],
            [
              -70.502,
              -6820.899,
              14302.261
            ],
            [
              -67.684,
              -6807.592,
              14315.863
            ],
            [
              -64.262,
              -6796.522,
              14327.45
            ],
            [
              -53.909,
              -6786.595,
              14341.793
            ],
            [
              -43.463,
              -6771.142,
              14360.446
            ],
            [
              -35.045,
              -6748.072,
              14385.004
            ],
            [
              -43.266,
              -6704.505,
              14429.34
            ],
            [
              -50.641,
              -6695.446,
              14441.021
            ],
            [
              -48.526,
              -6639.841,
              14496.666
            ],
            [
              -52.099,
              -6588.567,
              14548.065
            ],
            [
              -70.555,
              -6505.85,
              14632.816
            ],
            [
              -125.166,
              -6286.66,
              14858.706
            ],
            [
              -158.525,
              -6137.991,
              15011.072
            ],
            [
              -180.294,
              -6069.166,
              15083.257
            ],
            [
              -186.217,
              -6031.729,
              15121.16
            ],
            [
              -210.448,
              -5912.171,
              15243.149
            ],
            [
              -214.688,
              -5861.998,
              15293.501
            ],
            [
              -215.425,
              -5796.303,
              15359.2
            ],
            [
              -210.007,
              -5746.306,
              15409.49
            ],
            [
              -195.772,
              -5671.978,
              15485.169
            ],
            [
              -200.158,
              -5665.219,
              15493.226
            ],
            [
              -245.834,
              -5662.161,
              15539.004
            ],
            [
              -275.267,
              -5661.057,
              15568.458
            ],
            [
              -299.862,
              -5657.84,
              15593.262
            ],
            [
              -394.957,
              -5644.98,
              15689.223
            ],
            [
              -428.258,
              -5634.356,
              15724.178
            ],
            [
              -633.019,
              -5523.775,
              15956.89
            ],
            [
              -662.96,
              -5509.616,
              15990.011
            ],
            [
              -740.412,
              -5464.845,
              16079.472
            ],
            [
              -765.768,
              -5455.693,
              16106.428
            ],
            [
              -877.432,
              -5396.902,
              16232.624
            ],
            [
              -884.394,
              -5390.097,
              16242.359
            ],
            [
              -886.769,
              -5378.922,
              16253.784
            ],
            [
              -871.31,
              -5283.552,
              16350.399
            ],
            [
              -865.423,
              -5266.87,
              16368.089
            ],
            [
              -855.623,
              -5259.254,
              16380.5
            ],
            [
              -842.104,
              -5259.526,
              16394.022
            ],
            [
              -827.993,
              -5263.093,
              16408.577
            ],
            [
              -819.814,
              -5272.333,
              16420.917
            ],
            [
              -820.003,
              -5284.389,
              16432.974
            ],
            [
              -837.459,
              -5315.912,
              16469.008
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:8025",
              "position": {
                "x": 3085.299,
                "z": -15082.131
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 4.483,
              "arrivalOffsetSeconds": -420,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:8024",
              "position": {
                "x": 2461.841,
                "z": -14806.493
              },
              "distanceAlongShapeM": 717.387,
              "shapeOffsetM": 10.048,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:8364",
              "position": {
                "x": 2552.901,
                "z": -14102.393
              },
              "distanceAlongShapeM": 1427.799,
              "shapeOffsetM": 6.088,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:9002",
              "position": {
                "x": 2696.204,
                "z": -13697.639
              },
              "distanceAlongShapeM": 1861.751,
              "shapeOffsetM": 0.859,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:8367",
              "position": {
                "x": 2941.349,
                "z": -13145.637
              },
              "distanceAlongShapeM": 2465.769,
              "shapeOffsetM": 0.333,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:8017",
              "position": {
                "x": 3092.532,
                "z": -12803.387
              },
              "distanceAlongShapeM": 2839.898,
              "shapeOffsetM": 1.59,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:8018",
              "position": {
                "x": 3458.421,
                "z": -12501.964
              },
              "distanceAlongShapeM": 3372.494,
              "shapeOffsetM": 3.602,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:10551",
              "position": {
                "x": 3765.709,
                "z": -12576.851
              },
              "distanceAlongShapeM": 3688.816,
              "shapeOffsetM": 4.737,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:18426",
              "position": {
                "x": 4270.854,
                "z": -12663.353
              },
              "distanceAlongShapeM": 4249.735,
              "shapeOffsetM": 3.274,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:8021",
              "position": {
                "x": 4413.388,
                "z": -11974.746
              },
              "distanceAlongShapeM": 4952.927,
              "shapeOffsetM": 3.056,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:8022",
              "position": {
                "x": 4500.864,
                "z": -11574.536
              },
              "distanceAlongShapeM": 5362.643,
              "shapeOffsetM": 1.143,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:9798",
              "position": {
                "x": 4287.063,
                "z": -10950.322
              },
              "distanceAlongShapeM": 6048.536,
              "shapeOffsetM": 2.275,
              "arrivalOffsetSeconds": 870,
              "departureOffsetSeconds": 870
            },
            {
              "stopId": "judu:stop:9054",
              "position": {
                "x": 4558.82,
                "z": -10804.147
              },
              "distanceAlongShapeM": 6380.914,
              "shapeOffsetM": 5.189,
              "arrivalOffsetSeconds": 930,
              "departureOffsetSeconds": 930
            },
            {
              "stopId": "judu:stop:16832",
              "position": {
                "x": 4764.013,
                "z": -10474.123
              },
              "distanceAlongShapeM": 6786.745,
              "shapeOffsetM": 3.529,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:9081",
              "position": {
                "x": 5073.204,
                "z": -10357.647
              },
              "distanceAlongShapeM": 7237.798,
              "shapeOffsetM": 5.75,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:15113",
              "position": {
                "x": 4825.104,
                "z": -10076.748
              },
              "distanceAlongShapeM": 7785.136,
              "shapeOffsetM": 0.033,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:9047",
              "position": {
                "x": 4559.944,
                "z": -10078.309
              },
              "distanceAlongShapeM": 8050.295,
              "shapeOffsetM": 1.698,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:9045",
              "position": {
                "x": 4160.961,
                "z": -10078.428
              },
              "distanceAlongShapeM": 8449.275,
              "shapeOffsetM": 2.072,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            },
            {
              "stopId": "judu:stop:10556",
              "position": {
                "x": 3832.039,
                "z": -10116.66
              },
              "distanceAlongShapeM": 8818.768,
              "shapeOffsetM": 5.6,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            },
            {
              "stopId": "judu:stop:6857",
              "position": {
                "x": 3613.674,
                "z": -9925.461
              },
              "distanceAlongShapeM": 9108.992,
              "shapeOffsetM": 2.847,
              "arrivalOffsetSeconds": 1500,
              "departureOffsetSeconds": 1500
            },
            {
              "stopId": "judu:stop:6804",
              "position": {
                "x": 2953.441,
                "z": -9141.425
              },
              "distanceAlongShapeM": 10180.285,
              "shapeOffsetM": 4.54,
              "arrivalOffsetSeconds": 1620,
              "departureOffsetSeconds": 1620
            },
            {
              "stopId": "judu:stop:6801",
              "position": {
                "x": 1918.925,
                "z": -8290.37
              },
              "distanceAlongShapeM": 11529.59,
              "shapeOffsetM": 3.008,
              "arrivalOffsetSeconds": 1740,
              "departureOffsetSeconds": 1740
            },
            {
              "stopId": "judu:stop:6798",
              "position": {
                "x": 1026.954,
                "z": -7126.033
              },
              "distanceAlongShapeM": 13068.316,
              "shapeOffsetM": 2.968,
              "arrivalOffsetSeconds": 1860,
              "departureOffsetSeconds": 1860
            },
            {
              "stopId": "judu:stop:16628",
              "position": {
                "x": 229.7,
                "z": -6919.895
              },
              "distanceAlongShapeM": 13941.889,
              "shapeOffsetM": 0.036,
              "arrivalOffsetSeconds": 1980,
              "departureOffsetSeconds": 1980
            },
            {
              "stopId": "judu:stop:6503",
              "position": {
                "x": -50.829,
                "z": -6695.462
              },
              "distanceAlongShapeM": 14441.021,
              "shapeOffsetM": 0.189,
              "arrivalOffsetSeconds": 2100,
              "departureOffsetSeconds": 2100
            },
            {
              "stopId": "judu:stop:6501",
              "position": {
                "x": -182.398,
                "z": -6069.649
              },
              "distanceAlongShapeM": 15083.257,
              "shapeOffsetM": 2.159,
              "arrivalOffsetSeconds": 2220,
              "departureOffsetSeconds": 2220
            },
            {
              "stopId": "judu:stop:6640",
              "position": {
                "x": -275.515,
                "z": -5664.961
              },
              "distanceAlongShapeM": 15568.458,
              "shapeOffsetM": 3.912,
              "arrivalOffsetSeconds": 2340,
              "departureOffsetSeconds": 2340
            },
            {
              "stopId": "judu:stop:6634",
              "position": {
                "x": -663.705,
                "z": -5510.974
              },
              "distanceAlongShapeM": 15990.011,
              "shapeOffsetM": 1.549,
              "arrivalOffsetSeconds": 2400,
              "departureOffsetSeconds": 2400
            },
            {
              "stopId": "judu:stop:5827",
              "position": {
                "x": -835.417,
                "z": -5317.507
              },
              "distanceAlongShapeM": 16469.008,
              "shapeOffsetM": 2.591,
              "arrivalOffsetSeconds": 2550,
              "departureOffsetSeconds": 2550
            }
          ],
          "departuresSeconds": [
            20100,
            21420,
            22800,
            23700,
            24600,
            26100,
            27600,
            29100,
            30600,
            31800,
            34500,
            36000,
            38100,
            39900,
            41400,
            42900,
            44700,
            45900,
            47700,
            49200,
            51000,
            52200,
            54000,
            55500,
            56700,
            57900,
            58800,
            60300,
            61800,
            63300,
            64800,
            66000,
            68700,
            70800,
            72900,
            74040,
            75600,
            77100,
            78720,
            79620,
            81360,
            82860,
            84300,
            85140
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_bus_87",
      "sourceRouteId": "vilnius_bus_87",
      "mode": "bus",
      "shortName": "87",
      "longName": "Ateities g.–Molėtų pl.–Riešė–Bendorėliai–Šeškinė",
      "color": "0073AC",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_bus_87:0",
          "sourceRouteId": "vilnius_bus_87",
          "sourceShapeId": "vilnius_bus_87_a-b",
          "directionId": 0,
          "headsign": "Šeškinė",
          "directionName": "Ateities g.–Molėtų pl.–Riešė–Bendorėliai–Šeškinė",
          "mode": "bus",
          "routeShortName": "87",
          "routeLongName": "Ateities g.–Molėtų pl.–Riešė–Bendorėliai–Šeškinė",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              -837.459,
              -5315.912,
              0
            ],
            [
              -870.627,
              -5342.117,
              42.27
            ],
            [
              -874.492,
              -5355.616,
              56.312
            ],
            [
              -875.788,
              -5375.937,
              76.674
            ],
            [
              -865.47,
              -5384.739,
              90.236
            ],
            [
              -827.457,
              -5404.886,
              133.258
            ],
            [
              -674.33,
              -5492.97,
              309.912
            ],
            [
              -590.252,
              -5533.933,
              403.438
            ],
            [
              -565.267,
              -5552.833,
              434.766
            ],
            [
              -421.759,
              -5631.135,
              598.246
            ],
            [
              -383.93,
              -5640.727,
              637.272
            ],
            [
              -342.157,
              -5645.939,
              679.369
            ],
            [
              -257.182,
              -5648.596,
              764.386
            ],
            [
              -196.756,
              -5655.261,
              825.178
            ],
            [
              -180.177,
              -5664.469,
              844.143
            ],
            [
              -177.649,
              -5676.666,
              856.599
            ],
            [
              -188.191,
              -5725.09,
              906.157
            ],
            [
              -190.648,
              -5736.736,
              918.06
            ],
            [
              -196.91,
              -5769.923,
              951.832
            ],
            [
              -201.665,
              -5818.819,
              1000.959
            ],
            [
              -201.086,
              -5857.793,
              1039.937
            ],
            [
              -195.599,
              -5910.215,
              1092.645
            ],
            [
              -136.015,
              -6175.138,
              1364.186
            ],
            [
              -127.679,
              -6205.529,
              1395.7
            ],
            [
              -123.468,
              -6228.802,
              1419.351
            ],
            [
              -113.557,
              -6285.758,
              1477.163
            ],
            [
              -58.166,
              -6532.794,
              1730.332
            ],
            [
              -46.468,
              -6597.576,
              1796.162
            ],
            [
              -39.377,
              -6667.839,
              1866.782
            ],
            [
              -35.045,
              -6748.072,
              1947.132
            ],
            [
              -26.235,
              -6767.677,
              1968.625
            ],
            [
              -16.413,
              -6780.218,
              1984.555
            ],
            [
              0.443,
              -6790.505,
              2004.302
            ],
            [
              9.552,
              -6811.226,
              2026.937
            ],
            [
              9.735,
              -6827.796,
              2043.508
            ],
            [
              7.024,
              -6842.352,
              2058.314
            ],
            [
              -2.815,
              -6852.191,
              2072.229
            ],
            [
              -13.86,
              -6857.556,
              2084.508
            ],
            [
              -37.095,
              -6860.472,
              2107.925
            ],
            [
              -47.374,
              -6859.171,
              2118.286
            ],
            [
              -59.463,
              -6851.158,
              2132.79
            ],
            [
              -78.653,
              -6844.129,
              2153.226
            ],
            [
              -94.726,
              -6842.723,
              2169.361
            ],
            [
              -112.168,
              -6845.745,
              2187.063
            ],
            [
              -131.642,
              -6854.296,
              2208.331
            ],
            [
              -159.633,
              -6886.315,
              2250.86
            ],
            [
              -179.506,
              -6901.294,
              2275.746
            ],
            [
              -377.89,
              -7081.371,
              2543.671
            ],
            [
              -432.166,
              -7127.141,
              2614.67
            ],
            [
              -475.073,
              -7149.741,
              2663.165
            ],
            [
              -543.125,
              -7174.111,
              2735.449
            ],
            [
              -668.705,
              -7210.8,
              2866.278
            ],
            [
              -673.975,
              -7217.384,
              2874.712
            ],
            [
              -654.083,
              -7256.707,
              2918.78
            ],
            [
              -637.449,
              -7283.542,
              2950.352
            ],
            [
              -587.967,
              -7407.371,
              3083.702
            ],
            [
              -545.055,
              -7529.2,
              3212.867
            ],
            [
              -539.123,
              -7557.139,
              3241.429
            ],
            [
              -523.297,
              -7607.522,
              3294.239
            ],
            [
              -513.833,
              -7669.189,
              3356.628
            ],
            [
              -520.351,
              -7792.005,
              3479.617
            ],
            [
              -532.67,
              -7994.742,
              3682.728
            ],
            [
              -556.838,
              -8498.621,
              4187.186
            ],
            [
              -556.833,
              -8537.512,
              4226.077
            ],
            [
              -557.975,
              -8577.631,
              4266.212
            ],
            [
              -560.585,
              -8663.304,
              4351.925
            ],
            [
              -562.152,
              -8716.691,
              4405.335
            ],
            [
              -566.652,
              -8826.85,
              4515.586
            ],
            [
              -568.242,
              -8918.004,
              4606.754
            ],
            [
              -572.031,
              -8981.494,
              4670.357
            ],
            [
              -575.268,
              -9029.307,
              4718.279
            ],
            [
              -577.415,
              -9132.793,
              4821.787
            ],
            [
              -572.564,
              -9298.698,
              4987.763
            ],
            [
              -564.515,
              -9391.126,
              5080.541
            ],
            [
              -548.417,
              -9503.75,
              5194.31
            ],
            [
              -508.405,
              -9675.795,
              5370.946
            ],
            [
              -446.478,
              -9971.222,
              5672.794
            ],
            [
              -416.433,
              -10127.142,
              5831.582
            ],
            [
              -415.215,
              -10189.126,
              5893.578
            ],
            [
              -419.082,
              -10198.193,
              5903.435
            ],
            [
              -429.435,
              -10201.973,
              5914.457
            ],
            [
              -450.661,
              -10213.817,
              5938.763
            ],
            [
              -515.481,
              -10297.923,
              6044.949
            ],
            [
              -529.8,
              -10317.931,
              6069.553
            ],
            [
              -538.659,
              -10334.693,
              6088.512
            ],
            [
              -539.172,
              -10339.265,
              6093.113
            ],
            [
              -538.093,
              -10337.156,
              6095.482
            ],
            [
              -536.865,
              -10334.756,
              6098.178
            ],
            [
              -533.33,
              -10328.926,
              6104.995
            ],
            [
              -505.907,
              -10289.485,
              6153.033
            ],
            [
              -497.36,
              -10277.592,
              6167.679
            ],
            [
              -495.758,
              -10275.362,
              6170.425
            ],
            [
              -497.044,
              -10275.333,
              6171.712
            ],
            [
              -537.976,
              -10332.479,
              6242.005
            ],
            [
              -603.204,
              -10546.739,
              6465.974
            ],
            [
              -776.992,
              -10977.955,
              6930.893
            ],
            [
              -984.333,
              -11574.733,
              7562.663
            ],
            [
              -1248.476,
              -12217.969,
              8258.022
            ],
            [
              -1403.468,
              -12598.048,
              8668.488
            ],
            [
              -1425.089,
              -12649.824,
              8724.597
            ],
            [
              -1529.156,
              -12906.064,
              9001.164
            ],
            [
              -1581.108,
              -13029.98,
              9135.529
            ],
            [
              -1600.868,
              -13091.968,
              9200.591
            ],
            [
              -1612.856,
              -13159.806,
              9269.479
            ],
            [
              -1620.388,
              -13199.342,
              9309.726
            ],
            [
              -1625.599,
              -13201.538,
              9315.381
            ],
            [
              -1683.999,
              -13201.329,
              9373.782
            ],
            [
              -1727.186,
              -13203.258,
              9417.012
            ],
            [
              -1911.53,
              -13223.354,
              9602.449
            ],
            [
              -3275.105,
              -13355.611,
              10972.422
            ],
            [
              -3419.493,
              -13378.548,
              11118.62
            ],
            [
              -3481.895,
              -13376.06,
              11181.072
            ],
            [
              -3529.03,
              -13371.843,
              11228.396
            ],
            [
              -3652.994,
              -13361.385,
              11352.8
            ],
            [
              -3700.446,
              -13360.371,
              11400.263
            ],
            [
              -3735.59,
              -13367.667,
              11436.156
            ],
            [
              -3779.229,
              -13380.377,
              11481.608
            ],
            [
              -3810.533,
              -13389.939,
              11514.34
            ],
            [
              -3835.164,
              -13395.937,
              11539.691
            ],
            [
              -3866.027,
              -13397.92,
              11570.617
            ],
            [
              -3908.184,
              -13397.33,
              11612.779
            ],
            [
              -3954.849,
              -13393.106,
              11659.634
            ],
            [
              -4017.045,
              -13380.152,
              11723.165
            ],
            [
              -4109.591,
              -13350.318,
              11820.401
            ],
            [
              -4159.705,
              -13328.218,
              11875.172
            ],
            [
              -4419.504,
              -13151.186,
              12189.553
            ],
            [
              -4472.351,
              -13104.975,
              12259.755
            ],
            [
              -4856.51,
              -12759.948,
              12776.11
            ],
            [
              -4916.365,
              -12715.505,
              12850.66
            ],
            [
              -5068.71,
              -12639.629,
              13020.855
            ],
            [
              -5096.82,
              -12627.618,
              13051.423
            ],
            [
              -5140.405,
              -12612.677,
              13097.498
            ],
            [
              -5191.801,
              -12598.993,
              13150.684
            ],
            [
              -5240.584,
              -12586.417,
              13201.062
            ],
            [
              -5267.741,
              -12582.428,
              13228.511
            ],
            [
              -5287.066,
              -12584.323,
              13247.929
            ],
            [
              -5295.915,
              -12575.266,
              13260.591
            ],
            [
              -5312.699,
              -12165.314,
              13670.886
            ],
            [
              -5330.118,
              -12019.18,
              13818.055
            ],
            [
              -5348.399,
              -11925.2,
              13913.796
            ],
            [
              -5375.589,
              -11813.424,
              14028.831
            ],
            [
              -5395.282,
              -11737.165,
              14107.592
            ],
            [
              -5402.217,
              -11710.43,
              14135.212
            ],
            [
              -5548.058,
              -11129.824,
              14733.855
            ],
            [
              -5561.701,
              -11038.941,
              14825.756
            ],
            [
              -5579.297,
              -10922.479,
              14943.54
            ],
            [
              -5601.921,
              -10727.396,
              15139.931
            ],
            [
              -5637.047,
              -10400.899,
              15468.312
            ],
            [
              -5667.072,
              -10027.115,
              15843.299
            ],
            [
              -5672.079,
              -9888.224,
              15982.281
            ],
            [
              -5670.035,
              -9843.731,
              16026.821
            ],
            [
              -5663.147,
              -9779.281,
              16091.638
            ],
            [
              -5648.18,
              -9693.819,
              16178.4
            ],
            [
              -5545.409,
              -9280.455,
              16604.348
            ],
            [
              -5524.911,
              -9219.462,
              16668.694
            ],
            [
              -5443.06,
              -9025.007,
              16879.673
            ],
            [
              -5360.064,
              -8837.102,
              17085.091
            ],
            [
              -5337.712,
              -8766.35,
              17159.29
            ],
            [
              -5325.706,
              -8709.669,
              17217.229
            ],
            [
              -5314.944,
              -8645.611,
              17282.185
            ],
            [
              -5303.224,
              -8589.138,
              17339.861
            ],
            [
              -5290.247,
              -8555.538,
              17375.88
            ],
            [
              -5267.703,
              -8516.961,
              17420.561
            ],
            [
              -5173.632,
              -8375.916,
              17590.099
            ],
            [
              -5178.539,
              -8371.573,
              17596.652
            ],
            [
              -5182.076,
              -8361.185,
              17607.625
            ],
            [
              -5179.884,
              -8355.843,
              17613.399
            ],
            [
              -5181.592,
              -8350.787,
              17618.736
            ],
            [
              -5277.223,
              -8283.023,
              17735.942
            ],
            [
              -5286.156,
              -8278.418,
              17745.992
            ],
            [
              -5297.115,
              -8279.344,
              17756.99
            ],
            [
              -5304.742,
              -8273.647,
              17766.51
            ],
            [
              -5307.183,
              -8265.813,
              17774.715
            ],
            [
              -5306.939,
              -8256.957,
              17783.575
            ],
            [
              -5299.857,
              -8251.467,
              17792.535
            ],
            [
              -5290.81,
              -8249.395,
              17801.817
            ],
            [
              -5207.949,
              -8148.712,
              17932.212
            ],
            [
              -5185.887,
              -8139.074,
              17956.287
            ],
            [
              -5157.683,
              -8143.689,
              17984.866
            ],
            [
              -5141.162,
              -8143.156,
              18001.396
            ],
            [
              -5131.184,
              -8137.463,
              18012.884
            ],
            [
              -5121.711,
              -8125.88,
              18027.848
            ],
            [
              -4982.793,
              -7892.872,
              18299.124
            ],
            [
              -4893.434,
              -7752.799,
              18465.272
            ],
            [
              -4881.275,
              -7724.45,
              18496.119
            ],
            [
              -4761.02,
              -7574.962,
              18687.973
            ],
            [
              -4620.121,
              -7393.706,
              18917.551
            ],
            [
              -4514.978,
              -7232.989,
              19109.606
            ],
            [
              -4344.083,
              -6993.674,
              19403.676
            ],
            [
              -4337.156,
              -6965.549,
              19432.641
            ],
            [
              -4337.04,
              -6958.871,
              19439.32
            ],
            [
              -4340.76,
              -6950.694,
              19448.303
            ],
            [
              -4339.417,
              -6947.813,
              19451.482
            ],
            [
              -4349.817,
              -6878.499,
              19521.572
            ],
            [
              -4344.052,
              -6842.976,
              19557.56
            ],
            [
              -4325.834,
              -6796.97,
              19607.041
            ],
            [
              -4321.547,
              -6798.356,
              19611.548
            ],
            [
              -4314.563,
              -6800.404,
              19618.826
            ],
            [
              -4320.237,
              -6796.836,
              19625.528
            ],
            [
              -4299.794,
              -6787.421,
              19648.034
            ],
            [
              -4294.367,
              -6790.86,
              19654.459
            ],
            [
              -4291.544,
              -6797.796,
              19661.947
            ],
            [
              -4293.798,
              -6800.385,
              19665.379
            ],
            [
              -4301.979,
              -6802.203,
              19673.76
            ],
            [
              -4302.229,
              -6844.812,
              19716.37
            ],
            [
              -4281.614,
              -6879.294,
              19756.544
            ],
            [
              -4297.05,
              -6902.552,
              19784.458
            ],
            [
              -4318.547,
              -6930.646,
              19819.834
            ],
            [
              -4331.095,
              -6940.582,
              19835.839
            ],
            [
              -4333.111,
              -6942.057,
              19838.336
            ],
            [
              -4318.171,
              -6935.611,
              19854.607
            ],
            [
              -4302.855,
              -6918.273,
              19877.741
            ],
            [
              -4250.009,
              -6841.262,
              19971.14
            ],
            [
              -4167.288,
              -6712.448,
              20124.228
            ],
            [
              -4136.26,
              -6668.457,
              20178.06
            ],
            [
              -4095.853,
              -6603.478,
              20254.578
            ],
            [
              -4041.159,
              -6457.482,
              20410.483
            ],
            [
              -4021.737,
              -6414.403,
              20457.738
            ],
            [
              -3991.253,
              -6364.838,
              20515.927
            ],
            [
              -3967.007,
              -6340.768,
              20550.092
            ],
            [
              -3878.933,
              -6275.505,
              20659.71
            ],
            [
              -3859.174,
              -6250.244,
              20691.781
            ],
            [
              -3803.68,
              -6169.945,
              20789.39
            ],
            [
              -3744.108,
              -6077.471,
              20899.391
            ],
            [
              -3618.634,
              -5899.316,
              21117.297
            ],
            [
              -3485.286,
              -5750.246,
              21317.306
            ],
            [
              -3386.562,
              -5629.518,
              21473.26
            ],
            [
              -3374.401,
              -5614.415,
              21492.651
            ],
            [
              -3323.404,
              -5553.81,
              21571.857
            ],
            [
              -3282.741,
              -5512.22,
              21630.022
            ],
            [
              -3111.162,
              -5314.848,
              21891.547
            ],
            [
              -3040.755,
              -5230.366,
              22001.521
            ],
            [
              -3010.272,
              -5181.92,
              22058.76
            ],
            [
              -2985.976,
              -5155.629,
              22094.558
            ],
            [
              -2932.597,
              -5072.211,
              22193.592
            ],
            [
              -2911.623,
              -5041.062,
              22231.145
            ],
            [
              -2884.805,
              -5007.124,
              22274.4
            ],
            [
              -2783.196,
              -4834.137,
              22475.021
            ],
            [
              -2685.035,
              -4674.45,
              22662.466
            ],
            [
              -2617.123,
              -4549.854,
              22804.368
            ],
            [
              -2599.885,
              -4512.041,
              22845.925
            ],
            [
              -2575.776,
              -4470.432,
              22894.014
            ],
            [
              -2511.16,
              -4330.887,
              23047.792
            ],
            [
              -2380.854,
              -3977.381,
              23424.55
            ],
            [
              -2366.341,
              -3921.977,
              23481.824
            ],
            [
              -2313.476,
              -3774.854,
              23638.156
            ],
            [
              -2292.987,
              -3709.537,
              23706.611
            ],
            [
              -2280.97,
              -3679.424,
              23739.034
            ],
            [
              -2072.945,
              -3075.564,
              24377.721
            ],
            [
              -2040.52,
              -2976.08,
              24482.355
            ],
            [
              -2033.535,
              -2949.669,
              24509.675
            ],
            [
              -2045.608,
              -2925.031,
              24537.112
            ],
            [
              -2070.236,
              -2923.101,
              24561.815
            ],
            [
              -2092.617,
              -2921.15,
              24584.281
            ],
            [
              -2134.547,
              -2915.279,
              24626.62
            ],
            [
              -2189.877,
              -2909.844,
              24682.216
            ],
            [
              -2238.843,
              -2908.976,
              24731.19
            ],
            [
              -2271.353,
              -2925.098,
              24767.478
            ],
            [
              -2292.95,
              -2943.64,
              24795.943
            ],
            [
              -2307.637,
              -2972.324,
              24828.168
            ],
            [
              -2313.343,
              -3003.393,
              24859.757
            ],
            [
              -2311.942,
              -3033.475,
              24889.871
            ],
            [
              -2302.653,
              -3054.791,
              24913.123
            ],
            [
              -2286.96,
              -3078.446,
              24941.51
            ],
            [
              -2258.264,
              -3095.653,
              24974.97
            ],
            [
              -2237.746,
              -3101.583,
              24996.328
            ],
            [
              -2215.841,
              -3101.972,
              25018.236
            ],
            [
              -2134.198,
              -3113.439,
              25100.681
            ],
            [
              -2119.439,
              -3117.041,
              25115.873
            ],
            [
              -2116.823,
              -3121.023,
              25120.637
            ],
            [
              -2101.48,
              -3147.91,
              25151.594
            ],
            [
              -2105.863,
              -3160.185,
              25164.628
            ],
            [
              -2145.98,
              -3159.985,
              25204.746
            ],
            [
              -2161.481,
              -3161.937,
              25220.369
            ],
            [
              -2189.769,
              -3158.095,
              25248.917
            ],
            [
              -2192.892,
              -3152.474,
              25255.347
            ],
            [
              -2194.158,
              -3114.447,
              25293.395
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:5827",
              "position": {
                "x": -835.417,
                "z": -5317.507
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 2.591,
              "arrivalOffsetSeconds": -660,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:5828",
              "position": {
                "x": -826.661,
                "z": -5403.385
              },
              "distanceAlongShapeM": 133.258,
              "shapeOffsetM": 1.699,
              "arrivalOffsetSeconds": 60,
              "departureOffsetSeconds": 60
            },
            {
              "stopId": "judu:stop:6633",
              "position": {
                "x": -589.373,
                "z": -5532.358
              },
              "distanceAlongShapeM": 403.438,
              "shapeOffsetM": 1.804,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:6497",
              "position": {
                "x": -185.377,
                "z": -5737.848
              },
              "distanceAlongShapeM": 918.175,
              "shapeOffsetM": 5.386,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:6500",
              "position": {
                "x": -122.378,
                "z": -6204.331
              },
              "distanceAlongShapeM": 1395.7,
              "shapeOffsetM": 5.434,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:6783",
              "position": {
                "x": -156.753,
                "z": -6889.462
              },
              "distanceAlongShapeM": 2250.86,
              "shapeOffsetM": 4.266,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:7980",
              "position": {
                "x": -633.285,
                "z": -7281.575
              },
              "distanceAlongShapeM": 2950.352,
              "shapeOffsetM": 4.606,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:16295",
              "position": {
                "x": -511.201,
                "z": -7792.54
              },
              "distanceAlongShapeM": 3479.617,
              "shapeOffsetM": 9.166,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:7092",
              "position": {
                "x": -549.822,
                "z": -8537.712
              },
              "distanceAlongShapeM": 4226.077,
              "shapeOffsetM": 7.013,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:7374",
              "position": {
                "x": -561.229,
                "z": -8918.235
              },
              "distanceAlongShapeM": 4606.754,
              "shapeOffsetM": 7.017,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:7095",
              "position": {
                "x": -505.453,
                "z": -9675.14
              },
              "distanceAlongShapeM": 5370.946,
              "shapeOffsetM": 3.023,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:8472",
              "position": {
                "x": -520.046,
                "z": -10337.257
              },
              "distanceAlongShapeM": 6105.739,
              "shapeOffsetM": 15.663,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:7098",
              "position": {
                "x": -597.23,
                "z": -10548.487
              },
              "distanceAlongShapeM": 6465.906,
              "shapeOffsetM": 6.224,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:7100",
              "position": {
                "x": -776.158,
                "z": -10978.298
              },
              "distanceAlongShapeM": 6930.943,
              "shapeOffsetM": 0.901,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:7102",
              "position": {
                "x": -997.254,
                "z": -11643.363
              },
              "distanceAlongShapeM": 7631.057,
              "shapeOffsetM": 14.118,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:7104",
              "position": {
                "x": -1246.263,
                "z": -12218.875
              },
              "distanceAlongShapeM": 8258.025,
              "shapeOffsetM": 2.391,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            },
            {
              "stopId": "judu:stop:8324",
              "position": {
                "x": -1401.025,
                "z": -12599.047
              },
              "distanceAlongShapeM": 8668.488,
              "shapeOffsetM": 2.639,
              "arrivalOffsetSeconds": 1380,
              "departureOffsetSeconds": 1380
            },
            {
              "stopId": "judu:stop:7107",
              "position": {
                "x": -1607.248,
                "z": -13160.874
              },
              "distanceAlongShapeM": 9269.479,
              "shapeOffsetM": 5.708,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            },
            {
              "stopId": "judu:stop:7344",
              "position": {
                "x": -2212.085,
                "z": -13254.716
              },
              "distanceAlongShapeM": 9904.627,
              "shapeOffsetM": 2.2,
              "arrivalOffsetSeconds": 1560,
              "departureOffsetSeconds": 1560
            },
            {
              "stopId": "judu:stop:7110",
              "position": {
                "x": -3119.012,
                "z": -13343.313
              },
              "distanceAlongShapeM": 10815.871,
              "shapeOffsetM": 2.829,
              "arrivalOffsetSeconds": 1680,
              "departureOffsetSeconds": 1680
            },
            {
              "stopId": "judu:stop:10122",
              "position": {
                "x": -3482.333,
                "z": -13381.465
              },
              "distanceAlongShapeM": 11181.072,
              "shapeOffsetM": 5.423,
              "arrivalOffsetSeconds": 1740,
              "departureOffsetSeconds": 1740
            },
            {
              "stopId": "judu:stop:10091",
              "position": {
                "x": -5142.322,
                "z": -12619.086
              },
              "distanceAlongShapeM": 13097.233,
              "shapeOffsetM": 6.684,
              "arrivalOffsetSeconds": 1920,
              "departureOffsetSeconds": 1920
            },
            {
              "stopId": "judu:stop:10094",
              "position": {
                "x": -5407.215,
                "z": -11711.732
              },
              "distanceAlongShapeM": 14135.207,
              "shapeOffsetM": 5.165,
              "arrivalOffsetSeconds": 2040,
              "departureOffsetSeconds": 2040
            },
            {
              "stopId": "judu:stop:10096",
              "position": {
                "x": -5551.037,
                "z": -11130.406
              },
              "distanceAlongShapeM": 14733.855,
              "shapeOffsetM": 3.035,
              "arrivalOffsetSeconds": 2100,
              "departureOffsetSeconds": 2100
            },
            {
              "stopId": "judu:stop:10098",
              "position": {
                "x": -5671.872,
                "z": -10027.38
              },
              "distanceAlongShapeM": 15843.299,
              "shapeOffsetM": 4.807,
              "arrivalOffsetSeconds": 2220,
              "departureOffsetSeconds": 2220
            },
            {
              "stopId": "judu:stop:10100",
              "position": {
                "x": -5448.187,
                "z": -9022.618
              },
              "distanceAlongShapeM": 16879.787,
              "shapeOffsetM": 5.656,
              "arrivalOffsetSeconds": 2340,
              "departureOffsetSeconds": 2340
            },
            {
              "stopId": "judu:stop:7082",
              "position": {
                "x": -5267.811,
                "z": -8221.957
              },
              "distanceAlongShapeM": 17837.617,
              "shapeOffsetM": 0.322,
              "arrivalOffsetSeconds": 2520,
              "departureOffsetSeconds": 2520
            },
            {
              "stopId": "judu:stop:18939",
              "position": {
                "x": -4882.046,
                "z": -7724.279
              },
              "distanceAlongShapeM": 18495.972,
              "shapeOffsetM": 0.776,
              "arrivalOffsetSeconds": 2640,
              "departureOffsetSeconds": 2640
            },
            {
              "stopId": "judu:stop:18824",
              "position": {
                "x": -4302.229,
                "z": -6844.812
              },
              "distanceAlongShapeM": 19716.37,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2820,
              "departureOffsetSeconds": 2820
            },
            {
              "stopId": "judu:stop:7077",
              "position": {
                "x": -3618.634,
                "z": -5899.316
              },
              "distanceAlongShapeM": 21117.297,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 3120,
              "departureOffsetSeconds": 3120
            },
            {
              "stopId": "judu:stop:9153",
              "position": {
                "x": -3375.968,
                "z": -5613.005
              },
              "distanceAlongShapeM": 21492.721,
              "shapeOffsetM": 2.107,
              "arrivalOffsetSeconds": 3240,
              "departureOffsetSeconds": 3240
            },
            {
              "stopId": "judu:stop:5443",
              "position": {
                "x": -2914.996,
                "z": -5038.876
              },
              "distanceAlongShapeM": 22231.074,
              "shapeOffsetM": 4.019,
              "arrivalOffsetSeconds": 3360,
              "departureOffsetSeconds": 3360
            },
            {
              "stopId": "judu:stop:7896",
              "position": {
                "x": -2601.622,
                "z": -4511.165
              },
              "distanceAlongShapeM": 22845.925,
              "shapeOffsetM": 1.945,
              "arrivalOffsetSeconds": 3420,
              "departureOffsetSeconds": 3420
            },
            {
              "stopId": "judu:stop:5450",
              "position": {
                "x": -2366.341,
                "z": -3921.977
              },
              "distanceAlongShapeM": 23481.824,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 3540,
              "departureOffsetSeconds": 3540
            },
            {
              "stopId": "judu:stop:5451",
              "position": {
                "x": -2289.819,
                "z": -3676.197
              },
              "distanceAlongShapeM": 23738.751,
              "shapeOffsetM": 9.414,
              "arrivalOffsetSeconds": 3600,
              "departureOffsetSeconds": 3600
            },
            {
              "stopId": "judu:stop:5452",
              "position": {
                "x": -2044.086,
                "z": -2974.773
              },
              "distanceAlongShapeM": 24482.707,
              "shapeOffsetM": 3.782,
              "arrivalOffsetSeconds": 3720,
              "departureOffsetSeconds": 3720
            },
            {
              "stopId": "judu:stop:5209",
              "position": {
                "x": -2092.806,
                "z": -2923.813
              },
              "distanceAlongShapeM": 24584.238,
              "shapeOffsetM": 2.67,
              "arrivalOffsetSeconds": 3780,
              "departureOffsetSeconds": 3780
            },
            {
              "stopId": "judu:stop:5208",
              "position": {
                "x": -2215.841,
                "z": -3101.972
              },
              "distanceAlongShapeM": 25018.236,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 3840,
              "departureOffsetSeconds": 3840
            },
            {
              "stopId": "judu:stop:5206",
              "position": {
                "x": -2195.778,
                "z": -3133.498
              },
              "distanceAlongShapeM": 25274.409,
              "shapeOffsetM": 2.253,
              "arrivalOffsetSeconds": 3900,
              "departureOffsetSeconds": 3900
            }
          ],
          "departuresSeconds": [
            18900,
            20100,
            21780,
            23460,
            24720,
            26040,
            27360,
            28740,
            31620,
            32820,
            35220,
            36720,
            38580,
            39600,
            40860,
            42660,
            44640,
            45960,
            47220,
            48360,
            49800,
            51660,
            53460,
            55020,
            56220,
            57360,
            58440,
            59580,
            61080,
            64500,
            66060,
            67680,
            68520,
            69240,
            71100,
            72420,
            73800,
            75360,
            76860,
            78300,
            79740,
            81300
          ]
        },
        {
          "id": "judu:pattern:vilnius_bus_87:1",
          "sourceRouteId": "vilnius_bus_87",
          "sourceShapeId": "vilnius_bus_87_b-a",
          "directionId": 1,
          "headsign": "Ateities g.",
          "directionName": "Šeškinė–Bendorėliai–Riešė–Molėtų pl.–Ateities g.",
          "mode": "bus",
          "routeShortName": "87",
          "routeLongName": "Ateities g.–Molėtų pl.–Riešė–Bendorėliai–Šeškinė",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              -2194.158,
              -3114.447,
              0
            ],
            [
              -2187.067,
              -3114.727,
              7.097
            ],
            [
              -2174.766,
              -3111.606,
              19.787
            ],
            [
              -1943.03,
              -3126.856,
              252.025
            ],
            [
              -1903.67,
              -3124.217,
              291.473
            ],
            [
              -1868.018,
              -3112.606,
              328.968
            ],
            [
              -1816.447,
              -3075.675,
              392.399
            ],
            [
              -1790.686,
              -3040.511,
              435.99
            ],
            [
              -1771.148,
              -2992.991,
              487.369
            ],
            [
              -1760.293,
              -2926.391,
              554.848
            ],
            [
              -1751.757,
              -2845.278,
              636.409
            ],
            [
              -1755.82,
              -2783.978,
              697.844
            ],
            [
              -1781.888,
              -2655.492,
              828.947
            ],
            [
              -1792.088,
              -2613.008,
              872.639
            ],
            [
              -1805.103,
              -2583.832,
              904.586
            ],
            [
              -1815.859,
              -2572.508,
              920.204
            ],
            [
              -1830.081,
              -2565.972,
              935.856
            ],
            [
              -1848.195,
              -2578.611,
              957.944
            ],
            [
              -1876.019,
              -2641.711,
              1026.906
            ],
            [
              -1912.507,
              -2715.506,
              1109.229
            ],
            [
              -1995.657,
              -2933.332,
              1342.386
            ],
            [
              -2020.861,
              -3009.696,
              1422.802
            ],
            [
              -2029.851,
              -3041.625,
              1455.972
            ],
            [
              -2244.442,
              -3639.648,
              2091.331
            ],
            [
              -2268.114,
              -3687.714,
              2144.91
            ],
            [
              -2346.702,
              -3915.499,
              2385.87
            ],
            [
              -2363.609,
              -3964.478,
              2437.685
            ],
            [
              -2466.817,
              -4247.487,
              2738.926
            ],
            [
              -2539.058,
              -4427.617,
              2933.002
            ],
            [
              -2559.838,
              -4475.922,
              2985.587
            ],
            [
              -2704.304,
              -4744.243,
              3290.328
            ],
            [
              -2811.577,
              -4909.336,
              3487.211
            ],
            [
              -2905.084,
              -5061.315,
              3665.652
            ],
            [
              -2920.679,
              -5091.738,
              3699.839
            ],
            [
              -2950.713,
              -5128.419,
              3747.248
            ],
            [
              -3045.536,
              -5245.867,
              3898.196
            ],
            [
              -3100.371,
              -5323.943,
              3993.604
            ],
            [
              -3306.232,
              -5566.356,
              4311.634
            ],
            [
              -3330.246,
              -5592.97,
              4347.48
            ],
            [
              -3342.875,
              -5612.201,
              4370.488
            ],
            [
              -3386.425,
              -5658.464,
              4434.024
            ],
            [
              -3498.767,
              -5784.52,
              4602.875
            ],
            [
              -3581.293,
              -5888.171,
              4735.367
            ],
            [
              -3613.93,
              -5925.003,
              4784.579
            ],
            [
              -3668.235,
              -5993.496,
              4871.987
            ],
            [
              -3747.187,
              -6106.361,
              5009.726
            ],
            [
              -4223.914,
              -6821.676,
              5869.345
            ],
            [
              -4263.049,
              -6887.792,
              5946.175
            ],
            [
              -4307.275,
              -6950.48,
              6022.894
            ],
            [
              -4409.742,
              -7104.56,
              6207.934
            ],
            [
              -4661.216,
              -7462.018,
              6644.988
            ],
            [
              -4717.852,
              -7535.629,
              6737.865
            ],
            [
              -4734.153,
              -7547.594,
              6758.086
            ],
            [
              -4803.927,
              -7636.564,
              6871.152
            ],
            [
              -4829.015,
              -7672.869,
              6915.283
            ],
            [
              -4835.152,
              -7692.802,
              6936.139
            ],
            [
              -4858.971,
              -7730.242,
              6980.513
            ],
            [
              -4888.955,
              -7777.401,
              7036.397
            ],
            [
              -4960.969,
              -7896.586,
              7175.649
            ],
            [
              -5176.993,
              -8272.427,
              7609.15
            ],
            [
              -5200.998,
              -8309.905,
              7653.657
            ],
            [
              -5290.938,
              -8445.318,
              7816.217
            ],
            [
              -5293.95,
              -8470.87,
              7841.946
            ],
            [
              -5287.8,
              -8487.674,
              7859.84
            ],
            [
              -5274.498,
              -8499.669,
              7877.751
            ],
            [
              -5260.506,
              -8505.609,
              7892.952
            ],
            [
              -5264.207,
              -8520.05,
              7907.859
            ],
            [
              -5281.595,
              -8548.882,
              7941.529
            ],
            [
              -5300.559,
              -8598.173,
              7994.342
            ],
            [
              -5329.896,
              -8753.633,
              8152.546
            ],
            [
              -5341.217,
              -8797.895,
              8198.233
            ],
            [
              -5447.523,
              -9047.09,
              8469.156
            ],
            [
              -5461.74,
              -9080.752,
              8505.697
            ],
            [
              -5499.131,
              -9165.346,
              8598.185
            ],
            [
              -5540.842,
              -9282.174,
              8722.236
            ],
            [
              -5646.372,
              -9704.529,
              9157.576
            ],
            [
              -5659.416,
              -9774.444,
              9228.697
            ],
            [
              -5667.584,
              -9893.878,
              9348.411
            ],
            [
              -5664.724,
              -9981.918,
              9436.496
            ],
            [
              -5586.115,
              -10848.165,
              10306.303
            ],
            [
              -5510.019,
              -11276.193,
              10741.043
            ],
            [
              -5379.934,
              -11778.621,
              11260.038
            ],
            [
              -5326.052,
              -12014.593,
              11502.083
            ],
            [
              -5316.554,
              -12078.904,
              11567.092
            ],
            [
              -5307.82,
              -12172.278,
              11660.874
            ],
            [
              -5291.692,
              -12558.868,
              12047.8
            ],
            [
              -5285.346,
              -12566.723,
              12057.898
            ],
            [
              -5252.055,
              -12580.611,
              12093.97
            ],
            [
              -5111.671,
              -12618.499,
              12239.376
            ],
            [
              -5082.478,
              -12630.249,
              12270.846
            ],
            [
              -5044.693,
              -12648.451,
              12312.786
            ],
            [
              -4941.542,
              -12698.698,
              12427.524
            ],
            [
              -4885.532,
              -12733.585,
              12493.511
            ],
            [
              -4854.556,
              -12757.865,
              12532.869
            ],
            [
              -4600.255,
              -12985.17,
              12873.95
            ],
            [
              -4430.33,
              -13134.524,
              13100.183
            ],
            [
              -4363.415,
              -13187.774,
              13185.7
            ],
            [
              -4138.897,
              -13336.212,
              13454.85
            ],
            [
              -4051.904,
              -13366.377,
              13546.925
            ],
            [
              -3978.747,
              -13386.641,
              13622.837
            ],
            [
              -3908.321,
              -13394.468,
              13693.697
            ],
            [
              -3861.042,
              -13394.865,
              13740.977
            ],
            [
              -3811.794,
              -13387.337,
              13790.797
            ],
            [
              -3768.004,
              -13373.906,
              13836.601
            ],
            [
              -3721.422,
              -13361.281,
              13884.863
            ],
            [
              -3681.205,
              -13356.869,
              13925.322
            ],
            [
              -3632.264,
              -13360.147,
              13974.372
            ],
            [
              -3604.507,
              -13362.382,
              14002.219
            ],
            [
              -3442.545,
              -13375.771,
              14164.734
            ],
            [
              -3399.354,
              -13373.471,
              14207.986
            ],
            [
              -3224.677,
              -13345.545,
              14384.881
            ],
            [
              -3029.21,
              -13325.548,
              14581.368
            ],
            [
              -1906.592,
              -13219.913,
              15708.945
            ],
            [
              -1716.765,
              -13199.568,
              15899.859
            ],
            [
              -1630.15,
              -13198.145,
              15986.486
            ],
            [
              -1621.769,
              -13191.365,
              15997.265
            ],
            [
              -1617.706,
              -13170.034,
              16018.98
            ],
            [
              -1600.312,
              -13078.66,
              16111.995
            ],
            [
              -1521.504,
              -12879.969,
              16325.745
            ],
            [
              -1375.728,
              -12522.23,
              16712.044
            ],
            [
              -1242.683,
              -12196.294,
              17064.089
            ],
            [
              -974.684,
              -11543.409,
              17769.838
            ],
            [
              -959.911,
              -11507.579,
              17808.595
            ],
            [
              -927.761,
              -11428.778,
              17893.702
            ],
            [
              -747.527,
              -10900.488,
              18451.89
            ],
            [
              -733.294,
              -10866.145,
              18489.066
            ],
            [
              -629.667,
              -10621.496,
              18754.757
            ],
            [
              -581.363,
              -10464.582,
              18918.937
            ],
            [
              -572.426,
              -10433.002,
              18951.758
            ],
            [
              -561.098,
              -10401.08,
              18985.63
            ],
            [
              -548.64,
              -10362.848,
              19025.841
            ],
            [
              -547.473,
              -10359.684,
              19029.213
            ],
            [
              -545.939,
              -10355.522,
              19033.648
            ],
            [
              -544.189,
              -10350.777,
              19038.706
            ],
            [
              -533.33,
              -10328.926,
              19063.106
            ],
            [
              -496.934,
              -10276.998,
              19126.519
            ],
            [
              -495.437,
              -10274.916,
              19129.084
            ],
            [
              -495.717,
              -10273.13,
              19130.892
            ],
            [
              -494.116,
              -10268.194,
              19136.081
            ],
            [
              -455.073,
              -10214.496,
              19202.472
            ],
            [
              -433.052,
              -10188.549,
              19236.504
            ],
            [
              -425.915,
              -10176.299,
              19250.681
            ],
            [
              -422.857,
              -10158.676,
              19268.568
            ],
            [
              -447.786,
              -10013.478,
              19415.89
            ],
            [
              -543.423,
              -9576.303,
              19863.404
            ],
            [
              -555.093,
              -9513.89,
              19926.899
            ],
            [
              -557.907,
              -9496.336,
              19944.677
            ],
            [
              -566.009,
              -9430.241,
              20011.266
            ],
            [
              -581.42,
              -9286.353,
              20155.977
            ],
            [
              -582.35,
              -9053.668,
              20388.664
            ],
            [
              -571.804,
              -8909.159,
              20533.558
            ],
            [
              -578.071,
              -8870.094,
              20573.122
            ],
            [
              -573.871,
              -8834.512,
              20608.951
            ],
            [
              -566.291,
              -8522.941,
              20920.614
            ],
            [
              -563.836,
              -8494.041,
              20949.618
            ],
            [
              -565.136,
              -8465.113,
              20978.576
            ],
            [
              -535.864,
              -7874.472,
              21569.941
            ],
            [
              -532.185,
              -7696.516,
              21747.935
            ],
            [
              -529.998,
              -7657.496,
              21787.017
            ],
            [
              -539.024,
              -7587.198,
              21857.892
            ],
            [
              -551.05,
              -7540.224,
              21906.381
            ],
            [
              -600.885,
              -7412.411,
              22043.566
            ],
            [
              -641.916,
              -7331.515,
              22134.272
            ],
            [
              -699.26,
              -7226.946,
              22253.533
            ],
            [
              -700.949,
              -7213.556,
              22267.029
            ],
            [
              -541.073,
              -7167.469,
              22433.415
            ],
            [
              -513.641,
              -7155.124,
              22463.496
            ],
            [
              -490.912,
              -7147.103,
              22487.6
            ],
            [
              -472.731,
              -7139.026,
              22507.494
            ],
            [
              -433.975,
              -7120.429,
              22550.481
            ],
            [
              -356.786,
              -7053.923,
              22652.369
            ],
            [
              -147.918,
              -6864.018,
              22934.663
            ],
            [
              -114.729,
              -6832.74,
              22980.268
            ],
            [
              -100.778,
              -6821.461,
              22998.208
            ],
            [
              -58.991,
              -6789.938,
              23050.551
            ],
            [
              -47.746,
              -6774.569,
              23069.595
            ],
            [
              -39.488,
              -6758.546,
              23087.621
            ],
            [
              -44.133,
              -6716.735,
              23129.689
            ],
            [
              -50.641,
              -6695.446,
              23151.95
            ],
            [
              -48.526,
              -6639.841,
              23207.596
            ],
            [
              -52.099,
              -6588.567,
              23258.994
            ],
            [
              -70.555,
              -6505.85,
              23343.745
            ],
            [
              -125.166,
              -6286.66,
              23569.636
            ],
            [
              -158.525,
              -6137.991,
              23722.002
            ],
            [
              -180.294,
              -6069.166,
              23794.187
            ],
            [
              -186.217,
              -6031.729,
              23832.09
            ],
            [
              -210.448,
              -5912.171,
              23954.079
            ],
            [
              -214.688,
              -5861.998,
              24004.43
            ],
            [
              -215.425,
              -5796.303,
              24070.13
            ],
            [
              -210.007,
              -5746.306,
              24120.419
            ],
            [
              -195.772,
              -5671.978,
              24196.098
            ],
            [
              -200.158,
              -5665.219,
              24204.155
            ],
            [
              -245.834,
              -5662.161,
              24249.934
            ],
            [
              -275.267,
              -5661.057,
              24279.388
            ],
            [
              -299.862,
              -5657.84,
              24304.192
            ],
            [
              -394.957,
              -5644.98,
              24400.153
            ],
            [
              -428.258,
              -5634.356,
              24435.107
            ],
            [
              -633.019,
              -5523.775,
              24667.82
            ],
            [
              -662.96,
              -5509.616,
              24700.94
            ],
            [
              -740.412,
              -5464.845,
              24790.401
            ],
            [
              -765.768,
              -5455.693,
              24817.358
            ],
            [
              -877.432,
              -5396.902,
              24943.553
            ],
            [
              -884.394,
              -5390.097,
              24953.289
            ],
            [
              -886.769,
              -5378.922,
              24964.713
            ],
            [
              -871.302,
              -5283.486,
              25061.395
            ],
            [
              -865.423,
              -5266.87,
              25079.02
            ],
            [
              -855.623,
              -5259.254,
              25091.431
            ],
            [
              -842.104,
              -5259.526,
              25104.953
            ],
            [
              -827.993,
              -5263.093,
              25119.508
            ],
            [
              -819.814,
              -5272.333,
              25131.848
            ],
            [
              -820.003,
              -5284.389,
              25143.905
            ],
            [
              -837.459,
              -5315.912,
              25179.939
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:5206",
              "position": {
                "x": -2195.778,
                "z": -3133.498
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 19.12,
              "arrivalOffsetSeconds": -600,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:1039",
              "position": {
                "x": -1871.271,
                "z": -2643.88
              },
              "distanceAlongShapeM": 1026.906,
              "shapeOffsetM": 5.22,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:986",
              "position": {
                "x": -2025.964,
                "z": -3043.002
              },
              "distanceAlongShapeM": 1455.972,
              "shapeOffsetM": 4.124,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:4388",
              "position": {
                "x": -2242.142,
                "z": -3640.305
              },
              "distanceAlongShapeM": 2091.172,
              "shapeOffsetM": 2.386,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:823",
              "position": {
                "x": -2360.668,
                "z": -3965.493
              },
              "distanceAlongShapeM": 2437.685,
              "shapeOffsetM": 3.112,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:7897",
              "position": {
                "x": -2556.572,
                "z": -4477.451
              },
              "distanceAlongShapeM": 2985.587,
              "shapeOffsetM": 3.606,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:446",
              "position": {
                "x": -2704.304,
                "z": -4744.243
              },
              "distanceAlongShapeM": 3290.328,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:481",
              "position": {
                "x": -2916.619,
                "z": -5094.508
              },
              "distanceAlongShapeM": 3699.839,
              "shapeOffsetM": 4.915,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:9152",
              "position": {
                "x": -3341.197,
                "z": -5613.613
              },
              "distanceAlongShapeM": 4370.488,
              "shapeOffsetM": 2.193,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:7076",
              "position": {
                "x": -3580.452,
                "z": -5888.85
              },
              "distanceAlongShapeM": 4735.367,
              "shapeOffsetM": 1.08,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:18721",
              "position": {
                "x": -4884.932,
                "z": -7779.891
              },
              "distanceAlongShapeM": 7036.34,
              "shapeOffsetM": 4.731,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:7080",
              "position": {
                "x": -5171.533,
                "z": -8275.925
              },
              "distanceAlongShapeM": 7609.15,
              "shapeOffsetM": 6.484,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:10099",
              "position": {
                "x": -5455.021,
                "z": -9083.728
              },
              "distanceAlongShapeM": 8505.702,
              "shapeOffsetM": 7.348,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:10097",
              "position": {
                "x": -5645.443,
                "z": -10175.887
              },
              "distanceAlongShapeM": 9631.414,
              "shapeOffsetM": 1.672,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            },
            {
              "stopId": "judu:stop:10095",
              "position": {
                "x": -5504.608,
                "z": -11274.802
              },
              "distanceAlongShapeM": 10740.62,
              "shapeOffsetM": 5.571,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            },
            {
              "stopId": "judu:stop:10092",
              "position": {
                "x": -5373.594,
                "z": -11776.873
              },
              "distanceAlongShapeM": 11259.935,
              "shapeOffsetM": 6.576,
              "arrivalOffsetSeconds": 1500,
              "departureOffsetSeconds": 1500
            },
            {
              "stopId": "judu:stop:10089",
              "position": {
                "x": -5079.356,
                "z": -12622.392
              },
              "distanceAlongShapeM": 12270.808,
              "shapeOffsetM": 8.455,
              "arrivalOffsetSeconds": 1620,
              "departureOffsetSeconds": 1620
            },
            {
              "stopId": "judu:stop:10123",
              "position": {
                "x": -3631.638,
                "z": -13352.135
              },
              "distanceAlongShapeM": 13974.372,
              "shapeOffsetM": 8.037,
              "arrivalOffsetSeconds": 1800,
              "departureOffsetSeconds": 1800
            },
            {
              "stopId": "judu:stop:7109",
              "position": {
                "x": -3029.835,
                "z": -13318.165
              },
              "distanceAlongShapeM": 14581.437,
              "shapeOffsetM": 7.409,
              "arrivalOffsetSeconds": 1920,
              "departureOffsetSeconds": 1920
            },
            {
              "stopId": "judu:stop:7108",
              "position": {
                "x": -2108.818,
                "z": -13233.177
              },
              "distanceAlongShapeM": 15506.366,
              "shapeOffsetM": 5.739,
              "arrivalOffsetSeconds": 2040,
              "departureOffsetSeconds": 2040
            },
            {
              "stopId": "judu:stop:7106",
              "position": {
                "x": -1604.989,
                "z": -13070.742
              },
              "distanceAlongShapeM": 16117.631,
              "shapeOffsetM": 7.267,
              "arrivalOffsetSeconds": 2160,
              "departureOffsetSeconds": 2160
            },
            {
              "stopId": "judu:stop:8325",
              "position": {
                "x": -1386.063,
                "z": -12518.049
              },
              "distanceAlongShapeM": 16712.016,
              "shapeOffsetM": 11.149,
              "arrivalOffsetSeconds": 2220,
              "departureOffsetSeconds": 2220
            },
            {
              "stopId": "judu:stop:7103",
              "position": {
                "x": -1244.556,
                "z": -12195.527
              },
              "distanceAlongShapeM": 17064.089,
              "shapeOffsetM": 2.024,
              "arrivalOffsetSeconds": 2280,
              "departureOffsetSeconds": 2280
            },
            {
              "stopId": "judu:stop:7101",
              "position": {
                "x": -985.72,
                "z": -11538.926
              },
              "distanceAlongShapeM": 17769.795,
              "shapeOffsetM": 11.912,
              "arrivalOffsetSeconds": 2340,
              "departureOffsetSeconds": 2340
            },
            {
              "stopId": "judu:stop:7099",
              "position": {
                "x": -754.749,
                "z": -10897.419
              },
              "distanceAlongShapeM": 18451.961,
              "shapeOffsetM": 7.847,
              "arrivalOffsetSeconds": 2400,
              "departureOffsetSeconds": 2400
            },
            {
              "stopId": "judu:stop:7097",
              "position": {
                "x": -580.296,
                "z": -10430.79
              },
              "distanceAlongShapeM": 18951.743,
              "shapeOffsetM": 8.175,
              "arrivalOffsetSeconds": 2460,
              "departureOffsetSeconds": 2460
            },
            {
              "stopId": "judu:stop:8472",
              "position": {
                "x": -520.046,
                "z": -10337.257
              },
              "distanceAlongShapeM": 19061.558,
              "shapeOffsetM": 15.604,
              "arrivalOffsetSeconds": 2520,
              "departureOffsetSeconds": 2520
            },
            {
              "stopId": "judu:stop:7094",
              "position": {
                "x": -562.717,
                "z": -9497.095
              },
              "distanceAlongShapeM": 19944.677,
              "shapeOffsetM": 4.87,
              "arrivalOffsetSeconds": 2700,
              "departureOffsetSeconds": 2700
            },
            {
              "stopId": "judu:stop:7343",
              "position": {
                "x": -580.308,
                "z": -8870.019
              },
              "distanceAlongShapeM": 20573.122,
              "shapeOffsetM": 2.239,
              "arrivalOffsetSeconds": 2760,
              "departureOffsetSeconds": 2760
            },
            {
              "stopId": "judu:stop:7093",
              "position": {
                "x": -567.816,
                "z": -8465.025
              },
              "distanceAlongShapeM": 20978.576,
              "shapeOffsetM": 2.682,
              "arrivalOffsetSeconds": 2820,
              "departureOffsetSeconds": 2820
            },
            {
              "stopId": "judu:stop:16291",
              "position": {
                "x": -539.071,
                "z": -7696.295
              },
              "distanceAlongShapeM": 21747.935,
              "shapeOffsetM": 6.89,
              "arrivalOffsetSeconds": 2940,
              "departureOffsetSeconds": 2940
            },
            {
              "stopId": "judu:stop:8326",
              "position": {
                "x": -492.955,
                "z": -7141.624
              },
              "distanceAlongShapeM": 22487.957,
              "shapeOffsetM": 5.837,
              "arrivalOffsetSeconds": 3120,
              "departureOffsetSeconds": 3120
            },
            {
              "stopId": "judu:stop:8327",
              "position": {
                "x": -119.568,
                "z": -6827.798
              },
              "distanceAlongShapeM": 22980.136,
              "shapeOffsetM": 6.915,
              "arrivalOffsetSeconds": 3180,
              "departureOffsetSeconds": 3180
            },
            {
              "stopId": "judu:stop:6503",
              "position": {
                "x": -50.829,
                "z": -6695.462
              },
              "distanceAlongShapeM": 23151.95,
              "shapeOffsetM": 0.189,
              "arrivalOffsetSeconds": 3240,
              "departureOffsetSeconds": 3240
            },
            {
              "stopId": "judu:stop:6501",
              "position": {
                "x": -182.398,
                "z": -6069.649
              },
              "distanceAlongShapeM": 23794.187,
              "shapeOffsetM": 2.159,
              "arrivalOffsetSeconds": 3360,
              "departureOffsetSeconds": 3360
            },
            {
              "stopId": "judu:stop:6640",
              "position": {
                "x": -275.515,
                "z": -5664.961
              },
              "distanceAlongShapeM": 24279.388,
              "shapeOffsetM": 3.912,
              "arrivalOffsetSeconds": 3480,
              "departureOffsetSeconds": 3480
            },
            {
              "stopId": "judu:stop:6634",
              "position": {
                "x": -663.705,
                "z": -5510.974
              },
              "distanceAlongShapeM": 24700.94,
              "shapeOffsetM": 1.549,
              "arrivalOffsetSeconds": 3540,
              "departureOffsetSeconds": 3540
            },
            {
              "stopId": "judu:stop:348",
              "position": {
                "x": -871.52,
                "z": -5283.459
              },
              "distanceAlongShapeM": 25061.386,
              "shapeOffsetM": 0.219,
              "arrivalOffsetSeconds": 3660,
              "departureOffsetSeconds": 3660
            }
          ],
          "departuresSeconds": [
            17880,
            19200,
            20460,
            21780,
            22980,
            24180,
            25920,
            27360,
            28800,
            30240,
            31860,
            34500,
            36060,
            37080,
            38100,
            39660,
            41280,
            42840,
            44040,
            45360,
            47220,
            49140,
            50460,
            51780,
            52980,
            54600,
            56280,
            58020,
            59520,
            61560,
            62400,
            63300,
            64620,
            68220,
            69720,
            71280,
            72780,
            73980,
            75420,
            76740,
            78120,
            79560,
            80940,
            82260,
            83760
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_bus_88",
      "sourceRouteId": "vilnius_bus_88",
      "mode": "bus",
      "shortName": "88",
      "longName": "Oro uostas–Centras–Europos aikštė",
      "color": "0073AC",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_bus_88:0",
          "sourceRouteId": "vilnius_bus_88",
          "sourceShapeId": "vilnius_bus_88_a-b",
          "directionId": 0,
          "headsign": "Europos aikštė",
          "directionName": "Oro uostas–Centras–Europos aikštė",
          "mode": "bus",
          "routeShortName": "88",
          "routeLongName": "Oro uostas–Centras–Europos aikštė",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              182.349,
              4943.721,
              0
            ],
            [
              173.065,
              4882.548,
              61.873
            ],
            [
              169.677,
              4876.86,
              68.494
            ],
            [
              106.887,
              4896.161,
              134.183
            ],
            [
              65.284,
              4920.133,
              182.198
            ],
            [
              56.935,
              4922.512,
              190.879
            ],
            [
              38.922,
              4890.556,
              227.563
            ],
            [
              8.764,
              4794.253,
              328.477
            ],
            [
              -10.098,
              4715.557,
              409.402
            ],
            [
              -20.79,
              4660.091,
              465.889
            ],
            [
              -26.278,
              4606.755,
              519.507
            ],
            [
              -28.3,
              4495.47,
              630.81
            ],
            [
              -27.162,
              4273.918,
              852.365
            ],
            [
              -18.208,
              4269.302,
              862.439
            ],
            [
              130.759,
              4261.026,
              1011.636
            ],
            [
              339.461,
              4254.589,
              1220.437
            ],
            [
              343.708,
              4221.52,
              1253.778
            ],
            [
              363.696,
              4063.891,
              1412.669
            ],
            [
              363.124,
              4047.502,
              1429.068
            ],
            [
              390.325,
              3807.983,
              1670.126
            ],
            [
              407.395,
              3759.728,
              1721.312
            ],
            [
              430.163,
              3724.555,
              1763.211
            ],
            [
              456.693,
              3692.899,
              1804.514
            ],
            [
              510.785,
              3650.72,
              1873.107
            ],
            [
              565.222,
              3627.459,
              1932.305
            ],
            [
              683.997,
              3593,
              2055.978
            ],
            [
              739.323,
              3583.079,
              2112.186
            ],
            [
              805.719,
              3578.521,
              2178.739
            ],
            [
              892.824,
              3576.921,
              2265.858
            ],
            [
              954.888,
              3582.459,
              2328.169
            ],
            [
              1096.827,
              3614.356,
              2473.648
            ],
            [
              1674.798,
              3769.542,
              3072.09
            ],
            [
              1679.506,
              3729.433,
              3112.475
            ],
            [
              1684.234,
              3721.498,
              3121.711
            ],
            [
              1679.247,
              3710.449,
              3133.834
            ],
            [
              1680.184,
              3591.526,
              3252.76
            ],
            [
              1696.885,
              3464.105,
              3381.271
            ],
            [
              1701.035,
              3409.48,
              3436.053
            ],
            [
              1703.03,
              3134.473,
              3711.068
            ],
            [
              1699.891,
              3104.474,
              3741.23
            ],
            [
              1687.994,
              3054.599,
              3792.505
            ],
            [
              1659.262,
              3001.697,
              3852.706
            ],
            [
              1605.061,
              2932.568,
              3940.55
            ],
            [
              1556.997,
              2881.137,
              4010.943
            ],
            [
              1484.111,
              2813.466,
              4110.401
            ],
            [
              1478.391,
              2802.8,
              4122.504
            ],
            [
              1453.839,
              2781.743,
              4154.849
            ],
            [
              1433.991,
              2755.392,
              4187.838
            ],
            [
              1428.563,
              2741.021,
              4203.2
            ],
            [
              1397.31,
              2621.369,
              4326.867
            ],
            [
              1363.781,
              2448.324,
              4503.13
            ],
            [
              1344.313,
              2407.494,
              4548.364
            ],
            [
              1234.304,
              2215.824,
              4769.36
            ],
            [
              1203.934,
              2178.534,
              4817.452
            ],
            [
              1222.21,
              2196.952,
              4843.4
            ],
            [
              958.108,
              1933.7,
              5216.296
            ],
            [
              918.257,
              1878.079,
              5284.72
            ],
            [
              898.105,
              1863.557,
              5309.559
            ],
            [
              863.527,
              1836.207,
              5353.646
            ],
            [
              825.163,
              1791.425,
              5412.614
            ],
            [
              799.305,
              1718.426,
              5490.057
            ],
            [
              783.991,
              1657.48,
              5552.898
            ],
            [
              776.254,
              1587.488,
              5623.316
            ],
            [
              718.067,
              1580.764,
              5681.89
            ],
            [
              677.186,
              1572.743,
              5723.55
            ],
            [
              534.824,
              1579.67,
              5866.081
            ],
            [
              500.201,
              1591.437,
              5902.649
            ],
            [
              469.529,
              1536.247,
              5965.79
            ],
            [
              453.691,
              1517.701,
              5990.178
            ],
            [
              360.424,
              1427.008,
              6120.27
            ],
            [
              315.899,
              1391.085,
              6177.48
            ],
            [
              256.42,
              1348.755,
              6250.484
            ],
            [
              223.566,
              1315.958,
              6296.906
            ],
            [
              196.476,
              1280.829,
              6341.267
            ],
            [
              149.248,
              1202.651,
              6432.603
            ],
            [
              55.081,
              1061.873,
              6601.972
            ],
            [
              46.275,
              1047.293,
              6619.005
            ],
            [
              39.094,
              1036.402,
              6632.05
            ],
            [
              29.447,
              1013.439,
              6656.957
            ],
            [
              17.226,
              966.824,
              6705.148
            ],
            [
              -2.949,
              921.549,
              6754.715
            ],
            [
              -20.393,
              826.162,
              6851.684
            ],
            [
              -29.409,
              769.885,
              6908.678
            ],
            [
              -34.886,
              726.201,
              6952.704
            ],
            [
              -34.25,
              619.32,
              7059.587
            ],
            [
              -49.15,
              509.381,
              7170.531
            ],
            [
              -51.111,
              437.057,
              7242.882
            ],
            [
              -46.759,
              428.072,
              7252.865
            ],
            [
              -39.768,
              422.378,
              7261.882
            ],
            [
              15.61,
              348.039,
              7354.58
            ],
            [
              36.62,
              260.682,
              7444.429
            ],
            [
              56.855,
              132.292,
              7574.403
            ],
            [
              59.373,
              128.907,
              7578.622
            ],
            [
              70.978,
              128.695,
              7590.229
            ],
            [
              102.671,
              133.684,
              7622.312
            ],
            [
              112.53,
              93.98,
              7663.222
            ],
            [
              129.88,
              -107.271,
              7865.22
            ],
            [
              116.846,
              -256.206,
              8014.724
            ],
            [
              117.887,
              -305.208,
              8063.737
            ],
            [
              127.343,
              -387.845,
              8146.913
            ],
            [
              135.914,
              -423.248,
              8183.339
            ],
            [
              144.816,
              -445.964,
              8207.737
            ],
            [
              174.587,
              -519.993,
              8287.528
            ],
            [
              187.997,
              -562.53,
              8332.129
            ],
            [
              214.213,
              -645.388,
              8419.035
            ],
            [
              223.987,
              -656.808,
              8434.067
            ],
            [
              236.049,
              -695.879,
              8474.957
            ],
            [
              236.925,
              -708.144,
              8487.253
            ],
            [
              229.693,
              -715.805,
              8497.789
            ],
            [
              23.734,
              -765.484,
              8709.654
            ],
            [
              -55.388,
              -799.514,
              8795.785
            ],
            [
              -93.184,
              -812.338,
              8835.697
            ],
            [
              -182.323,
              -856.36,
              8935.113
            ],
            [
              -201.117,
              -861.585,
              8954.62
            ],
            [
              -349.798,
              -953.511,
              9129.424
            ],
            [
              -450.734,
              -1008.456,
              9244.346
            ],
            [
              -402.133,
              -1137.359,
              9382.107
            ],
            [
              -391.115,
              -1134.219,
              9393.563
            ],
            [
              -261.739,
              -1075.338,
              9535.708
            ],
            [
              -135.883,
              -997.471,
              9683.705
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:18375",
              "position": {
                "x": 190.96,
                "z": 4943.45
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 8.615,
              "arrivalOffsetSeconds": -420,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:9750",
              "position": {
                "x": 366.01,
                "z": 4064.148
              },
              "distanceAlongShapeM": 1412.669,
              "shapeOffsetM": 2.329,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:5998",
              "position": {
                "x": 1684.234,
                "z": 3721.498
              },
              "distanceAlongShapeM": 3121.711,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:5947",
              "position": {
                "x": 1478.744,
                "z": 2802.433
              },
              "distanceAlongShapeM": 4122.504,
              "shapeOffsetM": 0.509,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:5945",
              "position": {
                "x": 1224.883,
                "z": 2194.846
              },
              "distanceAlongShapeM": 4843.4,
              "shapeOffsetM": 3.403,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:5942",
              "position": {
                "x": 922.174,
                "z": 1874.247
              },
              "distanceAlongShapeM": 5284.72,
              "shapeOffsetM": 5.48,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:15581",
              "position": {
                "x": 677.252,
                "z": 1571.494
              },
              "distanceAlongShapeM": 5723.55,
              "shapeOffsetM": 1.251,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            },
            {
              "stopId": "judu:stop:6834",
              "position": {
                "x": 472.7,
                "z": 1534.052
              },
              "distanceAlongShapeM": 5965.79,
              "shapeOffsetM": 3.857,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:5346",
              "position": {
                "x": 52.802,
                "z": 1042.989
              },
              "distanceAlongShapeM": 6619.005,
              "shapeOffsetM": 7.818,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:5432",
              "position": {
                "x": -26.358,
                "z": 769.462
              },
              "distanceAlongShapeM": 6908.613,
              "shapeOffsetM": 3.079,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:5459",
              "position": {
                "x": 18.234,
                "z": 348.963
              },
              "distanceAlongShapeM": 7354.58,
              "shapeOffsetM": 2.781,
              "arrivalOffsetSeconds": 1380,
              "departureOffsetSeconds": 1380
            },
            {
              "stopId": "judu:stop:5492",
              "position": {
                "x": 116.145,
                "z": 94.475
              },
              "distanceAlongShapeM": 7663.222,
              "shapeOffsetM": 3.649,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            },
            {
              "stopId": "judu:stop:5245",
              "position": {
                "x": 150.182,
                "z": -443.837
              },
              "distanceAlongShapeM": 8207.766,
              "shapeOffsetM": 5.773,
              "arrivalOffsetSeconds": 1620,
              "departureOffsetSeconds": 1620
            },
            {
              "stopId": "judu:stop:753",
              "position": {
                "x": -53.078,
                "z": -805.275
              },
              "distanceAlongShapeM": 8795.785,
              "shapeOffsetM": 6.207,
              "arrivalOffsetSeconds": 1800,
              "departureOffsetSeconds": 1800
            }
          ],
          "departuresSeconds": [
            19140,
            20640,
            22440,
            24060,
            25740,
            27420,
            29160,
            30900,
            32700,
            34500,
            36300,
            41700,
            44340,
            46740,
            49140,
            51540,
            54180,
            56760,
            58560,
            60360,
            62160,
            63960,
            65760,
            67560,
            69420,
            73080,
            74940,
            77280,
            79500,
            81660,
            83820,
            86040,
            88260
          ]
        },
        {
          "id": "judu:pattern:vilnius_bus_88:1",
          "sourceRouteId": "vilnius_bus_88",
          "sourceShapeId": "vilnius_bus_88_b-a",
          "directionId": 1,
          "headsign": "Oro uostas",
          "directionName": "Europos aikštė–Centras–Oro uostas",
          "mode": "bus",
          "routeShortName": "88",
          "routeLongName": "Oro uostas–Centras–Europos aikštė",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              -144.74,
              -999.893,
              0
            ],
            [
              -111.147,
              -984.562,
              36.926
            ],
            [
              -194.732,
              -865.04,
              182.775
            ],
            [
              -199.062,
              -854.943,
              193.761
            ],
            [
              -193.763,
              -847.246,
              203.106
            ],
            [
              -168.966,
              -830.998,
              232.752
            ],
            [
              -118.847,
              -805.192,
              289.124
            ],
            [
              -80.599,
              -786.281,
              331.792
            ],
            [
              -40.176,
              -770.281,
              375.267
            ],
            [
              224.176,
              -700.119,
              648.771
            ],
            [
              211.01,
              -644.216,
              706.203
            ],
            [
              143.71,
              -480.456,
              883.253
            ],
            [
              126.134,
              -439.133,
              928.159
            ],
            [
              106.146,
              -277.163,
              1091.357
            ],
            [
              46.11,
              -280.522,
              1151.487
            ],
            [
              26.264,
              -279.764,
              1171.347
            ],
            [
              16.623,
              -264.894,
              1189.069
            ],
            [
              14.513,
              -253.218,
              1200.935
            ],
            [
              16.439,
              -245.471,
              1208.918
            ],
            [
              45.916,
              -220.403,
              1247.613
            ],
            [
              103.215,
              -190.277,
              1312.349
            ],
            [
              127.382,
              -102.772,
              1403.13
            ],
            [
              121.848,
              -52.576,
              1453.63
            ],
            [
              118.496,
              -36.512,
              1470.039
            ],
            [
              117.583,
              -3.516,
              1503.048
            ],
            [
              102.671,
              133.684,
              1641.056
            ],
            [
              63.181,
              125.497,
              1681.386
            ],
            [
              59.312,
              125.568,
              1685.256
            ],
            [
              57.419,
              127.829,
              1688.205
            ],
            [
              31.786,
              278.582,
              1841.121
            ],
            [
              4.856,
              358.112,
              1925.087
            ],
            [
              -8.924,
              380.627,
              1951.484
            ],
            [
              -39.768,
              422.378,
              2003.393
            ],
            [
              -46.8,
              425.846,
              2011.234
            ],
            [
              -51.212,
              431.492,
              2018.399
            ],
            [
              -51.307,
              497.175,
              2084.082
            ],
            [
              -54.16,
              522.615,
              2109.681
            ],
            [
              -44.593,
              547.148,
              2136.014
            ],
            [
              -34.25,
              619.32,
              2208.923
            ],
            [
              -34.886,
              726.201,
              2315.806
            ],
            [
              -29.964,
              784,
              2373.814
            ],
            [
              -28.88,
              804.74,
              2394.583
            ],
            [
              -24.076,
              823.969,
              2414.403
            ],
            [
              -6.94,
              914.942,
              2506.975
            ],
            [
              5.94,
              949.218,
              2543.591
            ],
            [
              14.89,
              980.225,
              2575.864
            ],
            [
              20.723,
              1007.284,
              2603.545
            ],
            [
              98.858,
              1127.869,
              2747.232
            ],
            [
              208.532,
              1302.485,
              2953.434
            ],
            [
              266.256,
              1357.482,
              3033.162
            ],
            [
              337.506,
              1408.502,
              3120.796
            ],
            [
              360.424,
              1427.008,
              3150.253
            ],
            [
              406.382,
              1470.698,
              3213.664
            ],
            [
              500.704,
              1583.635,
              3360.808
            ],
            [
              509.636,
              1588.204,
              3370.84
            ],
            [
              522.358,
              1585.17,
              3383.919
            ],
            [
              534.824,
              1579.67,
              3397.545
            ],
            [
              580.038,
              1581.942,
              3442.816
            ],
            [
              676.224,
              1578.551,
              3539.062
            ],
            [
              720.324,
              1583.12,
              3583.398
            ],
            [
              776.254,
              1587.488,
              3639.498
            ],
            [
              773.577,
              1623.63,
              3675.738
            ],
            [
              781.269,
              1649.737,
              3702.955
            ],
            [
              802.898,
              1738.399,
              3794.217
            ],
            [
              825.163,
              1791.425,
              3851.728
            ],
            [
              863.527,
              1836.207,
              3910.696
            ],
            [
              869.06,
              1862.978,
              3938.033
            ],
            [
              873.401,
              1888.503,
              3963.924
            ],
            [
              890.379,
              1910.039,
              3991.348
            ],
            [
              909.687,
              1916.752,
              4011.789
            ],
            [
              941.154,
              1923.993,
              4044.079
            ],
            [
              953.593,
              1933.783,
              4059.908
            ],
            [
              1083.618,
              2057.184,
              4239.169
            ],
            [
              1196.071,
              2172,
              4399.881
            ],
            [
              1233.034,
              2216.96,
              4458.085
            ],
            [
              1262.402,
              2269.853,
              4518.584
            ],
            [
              1275.582,
              2294.627,
              4546.646
            ],
            [
              1295.641,
              2322.675,
              4581.128
            ],
            [
              1353.693,
              2426.246,
              4699.859
            ],
            [
              1363.843,
              2451.663,
              4727.228
            ],
            [
              1395.21,
              2612.502,
              4891.097
            ],
            [
              1412.03,
              2684.551,
              4965.083
            ],
            [
              1428.563,
              2741.021,
              5023.923
            ],
            [
              1438.754,
              2768.663,
              5053.384
            ],
            [
              1469.827,
              2811.004,
              5105.904
            ],
            [
              1480.947,
              2816.864,
              5118.473
            ],
            [
              1584.045,
              2912.919,
              5259.384
            ],
            [
              1624.327,
              2962.268,
              5323.086
            ],
            [
              1644.883,
              2991.944,
              5359.186
            ],
            [
              1682.229,
              3056.932,
              5434.14
            ],
            [
              1693.837,
              3091.227,
              5470.347
            ],
            [
              1697.848,
              3133.456,
              5512.766
            ],
            [
              1698.943,
              3192.437,
              5571.757
            ],
            [
              1697.261,
              3310.472,
              5689.804
            ],
            [
              1700.204,
              3399.476,
              5778.857
            ],
            [
              1674.097,
              3592.551,
              5973.689
            ],
            [
              1669.889,
              3748.482,
              6129.676
            ],
            [
              1617.274,
              3730.533,
              6185.269
            ],
            [
              1602.425,
              3723.737,
              6201.599
            ],
            [
              1586.762,
              3721.079,
              6217.486
            ],
            [
              1086.216,
              3598.966,
              6732.712
            ],
            [
              972.811,
              3574.337,
              6848.76
            ],
            [
              908.77,
              3566.608,
              6913.266
            ],
            [
              815.757,
              3562.751,
              7006.359
            ],
            [
              771.943,
              3566.895,
              7050.369
            ],
            [
              685.084,
              3581.848,
              7138.505
            ],
            [
              566.974,
              3617.408,
              7261.852
            ],
            [
              386.18,
              3684.169,
              7454.579
            ],
            [
              313.695,
              3708.87,
              7531.157
            ],
            [
              296.98,
              3712.515,
              7548.265
            ],
            [
              262.781,
              3707.247,
              7582.867
            ],
            [
              233.038,
              3681.536,
              7622.183
            ],
            [
              228.738,
              3651.419,
              7652.605
            ],
            [
              239.2,
              3623.397,
              7682.517
            ],
            [
              258.938,
              3608.566,
              7707.206
            ],
            [
              278.193,
              3602.648,
              7727.35
            ],
            [
              304.708,
              3605.504,
              7754.018
            ],
            [
              321.687,
              3616.326,
              7774.153
            ],
            [
              336.289,
              3638.324,
              7800.556
            ],
            [
              367.859,
              3741.278,
              7908.241
            ],
            [
              373.006,
              3775.694,
              7943.04
            ],
            [
              376.156,
              3806.807,
              7974.312
            ],
            [
              342.825,
              4102.421,
              8271.799
            ],
            [
              334.908,
              4131.667,
              8302.098
            ],
            [
              328.44,
              4248.396,
              8419.006
            ],
            [
              -16.313,
              4267.041,
              8764.263
            ],
            [
              -27.868,
              4270.591,
              8776.351
            ],
            [
              -30.045,
              4292.895,
              8798.761
            ],
            [
              -28.186,
              4359.654,
              8865.546
            ],
            [
              -33.24,
              4507.805,
              9013.783
            ],
            [
              -26.822,
              4612.332,
              9118.507
            ],
            [
              -9.27,
              4725.561,
              9233.088
            ],
            [
              19.778,
              4831.903,
              9343.326
            ],
            [
              33.779,
              4891.762,
              9404.801
            ],
            [
              49.008,
              4912.637,
              9430.641
            ],
            [
              65.892,
              4953.519,
              9474.872
            ],
            [
              77.939,
              5047.924,
              9570.042
            ],
            [
              184.135,
              5048.078,
              9676.239
            ],
            [
              182.661,
              4953.647,
              9770.681
            ],
            [
              182.349,
              4943.721,
              9780.612
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:17638",
              "position": {
                "x": -42.035,
                "z": -765.399
              },
              "distanceAlongShapeM": 375.267,
              "shapeOffsetM": 5.224,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:5244",
              "position": {
                "x": 121.213,
                "z": -441.083
              },
              "distanceAlongShapeM": 928.159,
              "shapeOffsetM": 5.293,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:5409",
              "position": {
                "x": 115.041,
                "z": -36.866
              },
              "distanceAlongShapeM": 1470.039,
              "shapeOffsetM": 3.473,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:5338",
              "position": {
                "x": -56,
                "z": 522.864
              },
              "distanceAlongShapeM": 2109.681,
              "shapeOffsetM": 1.857,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:5345",
              "position": {
                "x": 17.976,
                "z": 1008
              },
              "distanceAlongShapeM": 2603.545,
              "shapeOffsetM": 2.839,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:5349",
              "position": {
                "x": 206.575,
                "z": 1304.022
              },
              "distanceAlongShapeM": 2953.434,
              "shapeOffsetM": 2.488,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:5355",
              "position": {
                "x": 580.051,
                "z": 1583.295
              },
              "distanceAlongShapeM": 3442.816,
              "shapeOffsetM": 1.353,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:6714",
              "position": {
                "x": 769.19,
                "z": 1624.355
              },
              "distanceAlongShapeM": 3675.738,
              "shapeOffsetM": 4.447,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:5941",
              "position": {
                "x": 889.31,
                "z": 1911.588
              },
              "distanceAlongShapeM": 3991.348,
              "shapeOffsetM": 1.882,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            },
            {
              "stopId": "judu:stop:5944",
              "position": {
                "x": 1272.571,
                "z": 2296.383
              },
              "distanceAlongShapeM": 4546.646,
              "shapeOffsetM": 3.486,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:5946",
              "position": {
                "x": 1466.069,
                "z": 2814.913
              },
              "distanceAlongShapeM": 5105.904,
              "shapeOffsetM": 5.422,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:16978",
              "position": {
                "x": 1602.913,
                "z": 3721.893
              },
              "distanceAlongShapeM": 6201.599,
              "shapeOffsetM": 1.908,
              "arrivalOffsetSeconds": 1380,
              "departureOffsetSeconds": 1380
            },
            {
              "stopId": "judu:stop:9738",
              "position": {
                "x": 333.674,
                "z": 4131.532
              },
              "distanceAlongShapeM": 8302.098,
              "shapeOffsetM": 1.242,
              "arrivalOffsetSeconds": 1560,
              "departureOffsetSeconds": 1560
            },
            {
              "stopId": "judu:stop:18375",
              "position": {
                "x": 190.96,
                "z": 4943.45
              },
              "distanceAlongShapeM": 9780.612,
              "shapeOffsetM": 8.615,
              "arrivalOffsetSeconds": 1740,
              "departureOffsetSeconds": 1740
            }
          ],
          "departuresSeconds": [
            21480,
            23580,
            24840,
            26340,
            28380,
            29760,
            32040,
            33660,
            35580,
            37140,
            39120,
            44580,
            46800,
            49380,
            51780,
            54300,
            56700,
            59580,
            61320,
            63180,
            65040,
            66540,
            68820,
            70440,
            72420,
            75360,
            77520,
            79740,
            81900,
            84060,
            86400,
            88380,
            90540
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_bus_89",
      "sourceRouteId": "vilnius_bus_89",
      "mode": "bus",
      "shortName": "89",
      "longName": "Nepriklausomybės aikštė–Senamiestis–Drujos g.–Stotis",
      "color": "0073AC",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_bus_89:0",
          "sourceRouteId": "vilnius_bus_89",
          "sourceShapeId": "vilnius_bus_89_a1-b1",
          "directionId": 0,
          "headsign": "Stotis",
          "directionName": "Nepriklausomybės aikštė–Senamiestis–Drujos g.–Stotis",
          "mode": "bus",
          "routeShortName": "89",
          "routeLongName": "Nepriklausomybės aikštė–Senamiestis–Drujos g.–Stotis",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              -1089.374,
              -411,
              0
            ],
            [
              -881.279,
              -355.007,
              215.497
            ],
            [
              -857.097,
              -444.501,
              308.2
            ],
            [
              -850.143,
              -488.042,
              352.293
            ],
            [
              -859.203,
              -561.352,
              426.161
            ],
            [
              -898.246,
              -574.502,
              467.359
            ],
            [
              -908.595,
              -582.727,
              480.578
            ],
            [
              -919.624,
              -908.704,
              806.742
            ],
            [
              -906.184,
              -950.135,
              850.298
            ],
            [
              -904.723,
              -968.011,
              868.234
            ],
            [
              -906.763,
              -1018.032,
              918.297
            ],
            [
              -903.416,
              -1047.036,
              947.493
            ],
            [
              -876.342,
              -1083.147,
              992.626
            ],
            [
              -864.236,
              -1091.158,
              1007.143
            ],
            [
              -846.005,
              -1097.331,
              1026.391
            ],
            [
              -813.038,
              -1094.85,
              1059.451
            ],
            [
              -785.651,
              -1089.799,
              1087.299
            ],
            [
              -774.937,
              -1088.05,
              1098.156
            ],
            [
              -717.669,
              -1083.853,
              1155.577
            ],
            [
              -647.083,
              -1062.792,
              1229.238
            ],
            [
              -599.769,
              -1049.176,
              1278.472
            ],
            [
              -511.525,
              -1018.488,
              1371.9
            ],
            [
              -361.843,
              -942.16,
              1539.92
            ],
            [
              -331.427,
              -923.524,
              1575.591
            ],
            [
              -286.654,
              -898.264,
              1626.998
            ],
            [
              -196.966,
              -846.075,
              1730.765
            ],
            [
              -115.583,
              -803.025,
              1822.833
            ],
            [
              -95.312,
              -792.953,
              1845.468
            ],
            [
              -40.176,
              -770.281,
              1905.084
            ],
            [
              224.8,
              -701.243,
              2178.906
            ],
            [
              238.603,
              -700.678,
              2192.721
            ],
            [
              294.146,
              -689.755,
              2249.327
            ],
            [
              331.506,
              -684.268,
              2287.088
            ],
            [
              436.802,
              -673.948,
              2392.889
            ],
            [
              647.48,
              -719,
              2608.33
            ],
            [
              718.871,
              -413.057,
              2922.492
            ],
            [
              707.994,
              -380.358,
              2956.953
            ],
            [
              685.601,
              -293.329,
              3046.816
            ],
            [
              645.363,
              9.096,
              3351.907
            ],
            [
              675.04,
              9.665,
              3381.589
            ],
            [
              707.88,
              6.836,
              3414.551
            ],
            [
              925.597,
              -42.81,
              3637.856
            ],
            [
              1129.224,
              -156.774,
              3871.205
            ],
            [
              1141.634,
              -163.763,
              3885.448
            ],
            [
              1606.423,
              -519.681,
              4470.859
            ],
            [
              1614.903,
              -526.354,
              4481.65
            ],
            [
              1648.803,
              -550.462,
              4523.248
            ],
            [
              1662.944,
              -552.951,
              4537.607
            ],
            [
              1695.279,
              -547.986,
              4570.321
            ],
            [
              1707.61,
              -543.762,
              4583.355
            ],
            [
              1715.531,
              -533.89,
              4596.012
            ],
            [
              1739.19,
              -475.328,
              4659.173
            ],
            [
              1739.832,
              -440.829,
              4693.677
            ],
            [
              1737.688,
              -417.411,
              4717.193
            ],
            [
              1728.721,
              -379.394,
              4756.254
            ],
            [
              1717.488,
              -353.728,
              4784.271
            ],
            [
              1709.957,
              -313.364,
              4825.331
            ],
            [
              1701.073,
              -270.896,
              4868.718
            ],
            [
              1691.292,
              -207.259,
              4933.102
            ],
            [
              1692.553,
              -139.375,
              5000.998
            ],
            [
              1699.889,
              -91.641,
              5049.292
            ],
            [
              1722.281,
              -31.942,
              5113.053
            ],
            [
              1763.619,
              40.763,
              5196.688
            ],
            [
              1784.543,
              87.474,
              5247.871
            ],
            [
              1803.689,
              114.605,
              5281.077
            ],
            [
              1864.141,
              209.22,
              5393.356
            ],
            [
              1913.636,
              269.526,
              5471.372
            ],
            [
              1990.962,
              334.88,
              5572.617
            ],
            [
              2018.633,
              366.989,
              5615.004
            ],
            [
              2052.586,
              388.28,
              5655.081
            ],
            [
              2087.216,
              412.125,
              5697.126
            ],
            [
              2136.967,
              451.273,
              5760.433
            ],
            [
              2182.309,
              496.069,
              5824.171
            ],
            [
              2210.658,
              528.937,
              5867.576
            ],
            [
              2229.877,
              556.409,
              5901.103
            ],
            [
              2248.742,
              590.591,
              5940.145
            ],
            [
              2266.569,
              621.404,
              5975.744
            ],
            [
              2281.67,
              670.105,
              6026.732
            ],
            [
              2285.519,
              703.43,
              6060.279
            ],
            [
              2286.06,
              732.364,
              6089.218
            ],
            [
              2274.704,
              814.957,
              6172.588
            ],
            [
              2261.392,
              861.962,
              6221.441
            ],
            [
              2144.257,
              1048.95,
              6442.088
            ],
            [
              2120.129,
              1077.499,
              6479.468
            ],
            [
              2077.146,
              1151.508,
              6565.053
            ],
            [
              1962.725,
              1277.211,
              6735.034
            ],
            [
              1820.714,
              1376.707,
              6908.431
            ],
            [
              1335.201,
              1600.566,
              7443.067
            ],
            [
              1292.203,
              1621.712,
              7490.984
            ],
            [
              1243.92,
              1653.461,
              7548.77
            ],
            [
              1199.83,
              1676.54,
              7598.535
            ],
            [
              1160.734,
              1690.621,
              7640.089
            ],
            [
              1108.739,
              1704.939,
              7694.02
            ],
            [
              1010.266,
              1717.886,
              7793.34
            ],
            [
              938.963,
              1734.784,
              7866.618
            ],
            [
              825.163,
              1791.425,
              7993.735
            ],
            [
              806.931,
              1747.23,
              8041.543
            ],
            [
              793.112,
              1697.389,
              8093.264
            ],
            [
              776.254,
              1587.488,
              8204.45
            ],
            [
              725.161,
              1580.634,
              8256.001
            ],
            [
              677.186,
              1572.743,
              8304.62
            ],
            [
              547.057,
              1578.333,
              8434.87
            ],
            [
              540.526,
              1574,
              8442.707
            ],
            [
              538.245,
              1555.117,
              8461.728
            ],
            [
              536.447,
              1546.84,
              8470.198
            ],
            [
              523.614,
              1489.089,
              8529.357
            ],
            [
              548.824,
              1401.981,
              8620.04
            ],
            [
              562.185,
              1347.617,
              8676.022
            ],
            [
              570.262,
              1290.218,
              8733.986
            ],
            [
              610.822,
              1291.064,
              8774.555
            ],
            [
              666.704,
              1277.793,
              8831.991
            ],
            [
              652.304,
              1231.302,
              8880.661
            ],
            [
              642.928,
              1212.549,
              8901.628
            ],
            [
              625.814,
              1193.937,
              8926.912
            ],
            [
              598.235,
              1174.703,
              8960.535
            ],
            [
              570.102,
              1163.962,
              8990.649
            ],
            [
              561.231,
              1178.588,
              9007.754
            ],
            [
              538.216,
              1202.194,
              9040.724
            ],
            [
              480.119,
              1234.456,
              9107.177
            ],
            [
              468.674,
              1243.572,
              9121.809
            ],
            [
              419.241,
              1362.479,
              9250.582
            ],
            [
              359.779,
              1427.02,
              9338.339
            ],
            [
              405.737,
              1470.709,
              9401.749
            ],
            [
              394.303,
              1485.728,
              9420.626
            ],
            [
              389.599,
              1492.257,
              9428.672
            ],
            [
              394.451,
              1523.047,
              9459.843
            ],
            [
              395.449,
              1569.043,
              9505.849
            ],
            [
              397.453,
              1582.184,
              9519.142
            ],
            [
              391.321,
              1670.242,
              9607.413
            ],
            [
              330.657,
              1810.504,
              9760.232
            ],
            [
              327.072,
              1826.155,
              9776.288
            ],
            [
              328.524,
              1835.034,
              9785.285
            ],
            [
              357.53,
              1884.349,
              9842.498
            ],
            [
              388.342,
              1930.792,
              9898.233
            ],
            [
              389.754,
              1937.446,
              9905.035
            ],
            [
              364.123,
              1982.443,
              9956.82
            ],
            [
              364.306,
              1992.459,
              9966.838
            ],
            [
              376.139,
              2004.488,
              9983.711
            ],
            [
              393.574,
              2005.283,
              10001.164
            ],
            [
              403.209,
              2002.88,
              10011.094
            ],
            [
              452.283,
              1969.699,
              10070.333
            ],
            [
              463.689,
              1958.358,
              10086.418
            ],
            [
              466.167,
              1952.747,
              10092.552
            ],
            [
              465.38,
              1944.969,
              10100.369
            ],
            [
              459.371,
              1933.946,
              10112.924
            ],
            [
              450.885,
              1928.535,
              10122.988
            ],
            [
              432.16,
              1927.765,
              10141.729
            ],
            [
              419.803,
              1922.424,
              10155.191
            ],
            [
              402.263,
              1927.258,
              10173.385
            ],
            [
              397.27,
              1925.063,
              10178.839
            ],
            [
              384.004,
              1905.267,
              10202.669
            ],
            [
              371.312,
              1878.4,
              10232.383
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:9004",
              "position": {
                "x": -1089.899,
                "z": -409.142
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 1.93,
              "arrivalOffsetSeconds": -660,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:5534",
              "position": {
                "x": -902.638,
                "z": -968.011
              },
              "distanceAlongShapeM": 868.234,
              "shapeOffsetM": 2.085,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:6635",
              "position": {
                "x": -775.751,
                "z": -1082.734
              },
              "distanceAlongShapeM": 1098.156,
              "shapeOffsetM": 5.378,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:7381",
              "position": {
                "x": -333.702,
                "z": -919.293
              },
              "distanceAlongShapeM": 1575.689,
              "shapeOffsetM": 4.803,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:17638",
              "position": {
                "x": -42.035,
                "z": -765.399
              },
              "distanceAlongShapeM": 1905.084,
              "shapeOffsetM": 5.224,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:5667",
              "position": {
                "x": 292.85,
                "z": -682.448
              },
              "distanceAlongShapeM": 2249.327,
              "shapeOffsetM": 7.421,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:7323",
              "position": {
                "x": 707.215,
                "z": -380.559
              },
              "distanceAlongShapeM": 2956.953,
              "shapeOffsetM": 0.804,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:7278",
              "position": {
                "x": 707.88,
                "z": 6.836
              },
              "distanceAlongShapeM": 3414.551,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:6573",
              "position": {
                "x": 1143.99,
                "z": -160.386
              },
              "distanceAlongShapeM": 3885.448,
              "shapeOffsetM": 4.117,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:5770",
              "position": {
                "x": 1610.786,
                "z": -514.132
              },
              "distanceAlongShapeM": 4470.859,
              "shapeOffsetM": 7.059,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            },
            {
              "stopId": "judu:stop:6565",
              "position": {
                "x": 1714.349,
                "z": -354.636
              },
              "distanceAlongShapeM": 4784.271,
              "shapeOffsetM": 3.268,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:6568",
              "position": {
                "x": 1781.292,
                "z": 89.417
              },
              "distanceAlongShapeM": 5247.871,
              "shapeOffsetM": 3.788,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:6571",
              "position": {
                "x": 2015.503,
                "z": 371.16
              },
              "distanceAlongShapeM": 5615.004,
              "shapeOffsetM": 5.214,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:6574",
              "position": {
                "x": 2244.749,
                "z": 592.868
              },
              "distanceAlongShapeM": 5940.145,
              "shapeOffsetM": 4.597,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:5925",
              "position": {
                "x": 2116.361,
                "z": 1075.075
              },
              "distanceAlongShapeM": 6479.468,
              "shapeOffsetM": 4.48,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            },
            {
              "stopId": "judu:stop:7841",
              "position": {
                "x": 1290.364,
                "z": 1618.093
              },
              "distanceAlongShapeM": 7490.984,
              "shapeOffsetM": 4.059,
              "arrivalOffsetSeconds": 1500,
              "departureOffsetSeconds": 1500
            },
            {
              "stopId": "judu:stop:15581",
              "position": {
                "x": 677.252,
                "z": 1571.494
              },
              "distanceAlongShapeM": 8304.62,
              "shapeOffsetM": 1.251,
              "arrivalOffsetSeconds": 1740,
              "departureOffsetSeconds": 1740
            },
            {
              "stopId": "judu:stop:9313",
              "position": {
                "x": 539.372,
                "z": 1546.19
              },
              "distanceAlongShapeM": 8470.198,
              "shapeOffsetM": 2.996,
              "arrivalOffsetSeconds": 1800,
              "departureOffsetSeconds": 1800
            },
            {
              "stopId": "judu:stop:17352",
              "position": {
                "x": 561.02,
                "z": 1178.426
              },
              "distanceAlongShapeM": 9007.786,
              "shapeOffsetM": 0.264,
              "arrivalOffsetSeconds": 1920,
              "departureOffsetSeconds": 1920
            },
            {
              "stopId": "judu:stop:5430",
              "position": {
                "x": 392.049,
                "z": 1568.924
              },
              "distanceAlongShapeM": 9505.657,
              "shapeOffsetM": 3.397,
              "arrivalOffsetSeconds": 2040,
              "departureOffsetSeconds": 2040
            },
            {
              "stopId": "judu:stop:7573",
              "position": {
                "x": 355.259,
                "z": 1885.754
              },
              "distanceAlongShapeM": 9842.498,
              "shapeOffsetM": 2.67,
              "arrivalOffsetSeconds": 2160,
              "departureOffsetSeconds": 2160
            }
          ],
          "departuresSeconds": [
            22200,
            24900,
            27900,
            32520,
            35700,
            38100,
            40800,
            43500,
            46200,
            48780,
            52020,
            54600,
            57600,
            60600,
            65700,
            68940,
            71400,
            74100,
            76800,
            79200
          ]
        },
        {
          "id": "judu:pattern:vilnius_bus_89:1",
          "sourceRouteId": "vilnius_bus_89",
          "sourceShapeId": "vilnius_bus_89_b1-a1",
          "directionId": 1,
          "headsign": "Nepriklausomybės aikštė (Apylanka per Bazilijonų st.)",
          "directionName": "Stotis–Drujos g.–Senamiestis–Nepriklausomybės aikštė (Apylanka per Bazilijonų st.)",
          "mode": "bus",
          "routeShortName": "89",
          "routeLongName": "Nepriklausomybės aikštė–Senamiestis–Drujos g.–Stotis",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              371.312,
              1878.4,
              0
            ],
            [
              359.991,
              1862.29,
              19.69
            ],
            [
              332.13,
              1820.496,
              69.919
            ],
            [
              336.8,
              1800.895,
              90.069
            ],
            [
              385.278,
              1692.617,
              208.704
            ],
            [
              391.321,
              1670.242,
              231.881
            ],
            [
              474.682,
              1571.866,
              360.826
            ],
            [
              481.233,
              1577.312,
              369.345
            ],
            [
              491.817,
              1591.59,
              387.118
            ],
            [
              500.361,
              1590.416,
              395.742
            ],
            [
              516.202,
              1584.464,
              412.664
            ],
            [
              542.257,
              1577.415,
              439.657
            ],
            [
              536.447,
              1546.84,
              470.779
            ],
            [
              523.614,
              1489.089,
              529.938
            ],
            [
              548.824,
              1401.981,
              620.621
            ],
            [
              562.185,
              1347.617,
              676.603
            ],
            [
              570.262,
              1290.218,
              734.567
            ],
            [
              610.822,
              1291.064,
              775.136
            ],
            [
              666.704,
              1277.793,
              832.572
            ],
            [
              652.304,
              1231.302,
              881.242
            ],
            [
              642.928,
              1212.549,
              902.208
            ],
            [
              625.814,
              1193.937,
              927.493
            ],
            [
              598.235,
              1174.703,
              961.116
            ],
            [
              570.102,
              1163.962,
              991.23
            ],
            [
              550.927,
              1190.857,
              1024.26
            ],
            [
              535.009,
              1202.281,
              1043.853
            ],
            [
              491.746,
              1225.648,
              1093.024
            ],
            [
              468.508,
              1240.822,
              1120.777
            ],
            [
              462.363,
              1249.12,
              1131.103
            ],
            [
              444.293,
              1290.977,
              1176.693
            ],
            [
              419.241,
              1362.479,
              1252.457
            ],
            [
              469.185,
              1398.444,
              1314.003
            ],
            [
              481.306,
              1419.044,
              1337.904
            ],
            [
              514.831,
              1517.728,
              1442.127
            ],
            [
              520.139,
              1548.753,
              1473.603
            ],
            [
              526.216,
              1567.582,
              1493.389
            ],
            [
              534.824,
              1579.67,
              1508.229
            ],
            [
              541.97,
              1582.534,
              1515.927
            ],
            [
              580.038,
              1581.942,
              1554
            ],
            [
              658.651,
              1577.401,
              1632.744
            ],
            [
              692.229,
              1579.012,
              1666.36
            ],
            [
              741.723,
              1585.833,
              1716.322
            ],
            [
              775.59,
              1587.408,
              1750.225
            ],
            [
              809.306,
              1578.914,
              1784.995
            ],
            [
              847.494,
              1567.254,
              1824.924
            ],
            [
              881.41,
              1552.158,
              1862.048
            ],
            [
              943.873,
              1514.16,
              1935.161
            ],
            [
              977.642,
              1498.755,
              1972.277
            ],
            [
              986.83,
              1496.24,
              1981.803
            ],
            [
              1014.875,
              1489.647,
              2010.613
            ],
            [
              1169.279,
              1454.457,
              2168.976
            ],
            [
              1223.933,
              1444.542,
              2224.522
            ],
            [
              1248.034,
              1479.023,
              2266.592
            ],
            [
              1335.324,
              1607.243,
              2421.704
            ],
            [
              1393.863,
              1583.245,
              2484.971
            ],
            [
              1416.531,
              1567.89,
              2512.35
            ],
            [
              1502.107,
              1520.663,
              2610.093
            ],
            [
              1842.1,
              1381.875,
              2977.322
            ],
            [
              1893.84,
              1354.194,
              3036.001
            ],
            [
              1975.634,
              1283.961,
              3143.811
            ],
            [
              2058.447,
              1213.363,
              3252.632
            ],
            [
              2130.485,
              1105.982,
              3381.939
            ],
            [
              2171.861,
              1041.755,
              3458.339
            ],
            [
              2183.916,
              1028.198,
              3476.481
            ],
            [
              2200.048,
              996.698,
              3511.872
            ],
            [
              2297.211,
              845.707,
              3691.424
            ],
            [
              2377.645,
              731.764,
              3830.896
            ],
            [
              2389.245,
              704.619,
              3860.416
            ],
            [
              2392.58,
              680.329,
              3884.934
            ],
            [
              2387.096,
              651.712,
              3914.071
            ],
            [
              2369.175,
              623.937,
              3947.126
            ],
            [
              2305.672,
              573.917,
              4027.963
            ],
            [
              2269.605,
              542.307,
              4075.922
            ],
            [
              2254.026,
              527.847,
              4097.178
            ],
            [
              2223.804,
              507.54,
              4133.588
            ],
            [
              1990.962,
              334.88,
              4423.462
            ],
            [
              1969.782,
              310.225,
              4455.965
            ],
            [
              1935.827,
              283.585,
              4499.123
            ],
            [
              1864.599,
              199.192,
              4609.557
            ],
            [
              1763.619,
              40.763,
              4797.431
            ],
            [
              1755.04,
              12.778,
              4826.702
            ],
            [
              1734.841,
              -15.477,
              4861.434
            ],
            [
              1714.048,
              -58.507,
              4909.225
            ],
            [
              1702.489,
              -90.576,
              4943.313
            ],
            [
              1692.553,
              -139.375,
              4993.114
            ],
            [
              1696.284,
              -216.258,
              5070.087
            ],
            [
              1701.445,
              -250.864,
              5105.076
            ],
            [
              1720.689,
              -325.809,
              5182.452
            ],
            [
              1730.124,
              -347.569,
              5206.169
            ],
            [
              1742.617,
              -429.749,
              5289.294
            ],
            [
              1739.19,
              -475.328,
              5335.001
            ],
            [
              1717.531,
              -565.098,
              5427.347
            ],
            [
              1721.402,
              -599.681,
              5462.146
            ],
            [
              1718.066,
              -610.324,
              5473.3
            ],
            [
              1706.711,
              -619.261,
              5487.75
            ],
            [
              1695.162,
              -623.684,
              5500.117
            ],
            [
              1670.687,
              -622.116,
              5524.642
            ],
            [
              1656.263,
              -617.38,
              5539.824
            ],
            [
              1647.146,
              -604.98,
              5555.215
            ],
            [
              1647.435,
              -589.4,
              5570.797
            ],
            [
              1641.361,
              -569.249,
              5591.844
            ],
            [
              1626.241,
              -550.043,
              5616.287
            ],
            [
              1613.941,
              -537.088,
              5634.151
            ],
            [
              1227.773,
              -233.181,
              6125.563
            ],
            [
              1061.875,
              -125.757,
              6323.205
            ],
            [
              912.058,
              -42.561,
              6494.571
            ],
            [
              652.936,
              0.051,
              6757.174
            ],
            [
              646.469,
              -0.943,
              6763.717
            ],
            [
              667.023,
              -146.041,
              6910.263
            ],
            [
              673.645,
              -171.767,
              6936.828
            ],
            [
              679.226,
              -196.092,
              6961.785
            ],
            [
              683.338,
              -240.966,
              7006.847
            ],
            [
              694.504,
              -300.172,
              7067.097
            ],
            [
              716.179,
              -384.063,
              7153.742
            ],
            [
              718.871,
              -413.057,
              7182.861
            ],
            [
              701.12,
              -501.79,
              7273.352
            ],
            [
              662.621,
              -666.955,
              7442.945
            ],
            [
              647.48,
              -719,
              7497.148
            ],
            [
              508.13,
              -687.5,
              7640.013
            ],
            [
              443.852,
              -676.304,
              7705.259
            ],
            [
              405.738,
              -680.059,
              7743.558
            ],
            [
              363.165,
              -686.919,
              7786.68
            ],
            [
              341.718,
              -690.021,
              7808.35
            ],
            [
              237.095,
              -710.389,
              7914.937
            ],
            [
              219.749,
              -721.682,
              7935.636
            ],
            [
              73.653,
              -750.808,
              8084.607
            ],
            [
              36.063,
              -761.255,
              8123.621
            ],
            [
              -18.428,
              -779.188,
              8180.987
            ],
            [
              -55.388,
              -799.514,
              8223.168
            ],
            [
              -306.711,
              -924.235,
              8503.736
            ],
            [
              -475.993,
              -1014.678,
              8695.664
            ],
            [
              -535.166,
              -1050.172,
              8764.666
            ],
            [
              -673.187,
              -1080.133,
              8905.901
            ],
            [
              -764.624,
              -1108.462,
              9001.626
            ],
            [
              -829.227,
              -1116.28,
              9066.701
            ],
            [
              -865.018,
              -1134.559,
              9106.889
            ],
            [
              -891.825,
              -1155.228,
              9140.739
            ],
            [
              -898.939,
              -1163.415,
              9151.585
            ],
            [
              -908.077,
              -1171.394,
              9163.716
            ],
            [
              -917.363,
              -1177.032,
              9174.58
            ],
            [
              -929.666,
              -1178.977,
              9187.036
            ],
            [
              -961.877,
              -1178.457,
              9219.251
            ],
            [
              -977.23,
              -1175.77,
              9234.837
            ],
            [
              -995.797,
              -1164.488,
              9256.563
            ],
            [
              -1006.474,
              -1148.711,
              9275.613
            ],
            [
              -1017.615,
              -1122.906,
              9303.72
            ],
            [
              -1020.518,
              -1105.042,
              9321.819
            ],
            [
              -1018.304,
              -1089.497,
              9337.521
            ],
            [
              -1013.532,
              -1075.111,
              9352.677
            ],
            [
              -1005.537,
              -1060.783,
              9369.085
            ],
            [
              -990.532,
              -1051.034,
              9386.979
            ],
            [
              -973.897,
              -1022.389,
              9420.104
            ],
            [
              -968.48,
              -1008.015,
              9435.465
            ],
            [
              -963.614,
              -973.419,
              9470.402
            ],
            [
              -938.721,
              -895.001,
              9552.676
            ],
            [
              -924.604,
              -648.119,
              9799.961
            ],
            [
              -924.747,
              -620.286,
              9827.794
            ],
            [
              -931.518,
              -602.352,
              9846.964
            ],
            [
              -950.716,
              -594.214,
              9867.816
            ],
            [
              -959.096,
              -594.063,
              9876.197
            ],
            [
              -985.143,
              -609.208,
              9906.327
            ],
            [
              -1012.636,
              -630.95,
              9941.378
            ],
            [
              -1031.45,
              -637.291,
              9961.232
            ],
            [
              -1041.099,
              -636.004,
              9970.966
            ],
            [
              -1094.292,
              -545.99,
              10075.523
            ],
            [
              -1119.562,
              -480.969,
              10145.282
            ],
            [
              -1126.878,
              -457.46,
              10169.903
            ],
            [
              -1129.037,
              -434.043,
              10193.419
            ],
            [
              -1126.359,
              -428.525,
              10199.552
            ],
            [
              -1089.374,
              -411,
              10240.479
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:4267",
              "position": {
                "x": 372.531,
                "z": 1877.646
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 1.434,
              "arrivalOffsetSeconds": -360,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:9313",
              "position": {
                "x": 539.372,
                "z": 1546.19
              },
              "distanceAlongShapeM": 470.779,
              "shapeOffsetM": 2.996,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:17352",
              "position": {
                "x": 561.02,
                "z": 1178.426
              },
              "distanceAlongShapeM": 1008.279,
              "shapeOffsetM": 1.002,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:5355",
              "position": {
                "x": 580.051,
                "z": 1583.295
              },
              "distanceAlongShapeM": 1553.992,
              "shapeOffsetM": 1.353,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:5358",
              "position": {
                "x": 979.224,
                "z": 1503.603
              },
              "distanceAlongShapeM": 1971.704,
              "shapeOffsetM": 5.067,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:6673",
              "position": {
                "x": 1245.249,
                "z": 1480.885
              },
              "distanceAlongShapeM": 2266.522,
              "shapeOffsetM": 3.349,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:7840",
              "position": {
                "x": 1396.909,
                "z": 1588.292
              },
              "distanceAlongShapeM": 2484.971,
              "shapeOffsetM": 5.895,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:356",
              "position": {
                "x": 2187.13,
                "z": 1030.337
              },
              "distanceAlongShapeM": 3476.481,
              "shapeOffsetM": 3.86,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:6572",
              "position": {
                "x": 2256.376,
                "z": 524.743
              },
              "distanceAlongShapeM": 4097.178,
              "shapeOffsetM": 3.893,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            },
            {
              "stopId": "judu:stop:449",
              "position": {
                "x": 1973.014,
                "z": 306.27
              },
              "distanceAlongShapeM": 4455.965,
              "shapeOffsetM": 5.108,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:603",
              "position": {
                "x": 1759.816,
                "z": 9.663
              },
              "distanceAlongShapeM": 4826.702,
              "shapeOffsetM": 5.702,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:6566",
              "position": {
                "x": 1735.144,
                "z": -346.116
              },
              "distanceAlongShapeM": 5206.169,
              "shapeOffsetM": 5.226,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:5768",
              "position": {
                "x": 1608.96,
                "z": -543.043
              },
              "distanceAlongShapeM": 5633.262,
              "shapeOffsetM": 7.713,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:5771",
              "position": {
                "x": 1060.09,
                "z": -128.781
              },
              "distanceAlongShapeM": 6323.059,
              "shapeOffsetM": 3.508,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:7322",
              "position": {
                "x": 684.82,
                "z": -195.35
              },
              "distanceAlongShapeM": 6961.785,
              "shapeOffsetM": 5.643,
              "arrivalOffsetSeconds": 1380,
              "departureOffsetSeconds": 1380
            },
            {
              "stopId": "judu:stop:677",
              "position": {
                "x": 364.219,
                "z": -693.772
              },
              "distanceAlongShapeM": 7786.68,
              "shapeOffsetM": 6.934,
              "arrivalOffsetSeconds": 1560,
              "departureOffsetSeconds": 1560
            },
            {
              "stopId": "judu:stop:753",
              "position": {
                "x": -53.078,
                "z": -805.275
              },
              "distanceAlongShapeM": 8223.66,
              "shapeOffsetM": 6.187,
              "arrivalOffsetSeconds": 1680,
              "departureOffsetSeconds": 1680
            },
            {
              "stopId": "judu:stop:7382",
              "position": {
                "x": -534.689,
                "z": -1051.466
              },
              "distanceAlongShapeM": 8764.666,
              "shapeOffsetM": 1.38,
              "arrivalOffsetSeconds": 1800,
              "departureOffsetSeconds": 1800
            },
            {
              "stopId": "judu:stop:988",
              "position": {
                "x": -763.423,
                "z": -1114.127
              },
              "distanceAlongShapeM": 9001.626,
              "shapeOffsetM": 5.791,
              "arrivalOffsetSeconds": 1860,
              "departureOffsetSeconds": 1860
            },
            {
              "stopId": "judu:stop:5533",
              "position": {
                "x": -969.129,
                "z": -972.38
              },
              "distanceAlongShapeM": 9470.402,
              "shapeOffsetM": 5.612,
              "arrivalOffsetSeconds": 1980,
              "departureOffsetSeconds": 1980
            },
            {
              "stopId": "judu:stop:9004",
              "position": {
                "x": -1089.899,
                "z": -409.142
              },
              "distanceAlongShapeM": 10240.479,
              "shapeOffsetM": 1.93,
              "arrivalOffsetSeconds": 2100,
              "departureOffsetSeconds": 2100
            }
          ],
          "departuresSeconds": [
            19620,
            22200,
            24900,
            27420,
            30660,
            35160,
            38220,
            40800,
            43500,
            46080,
            51360,
            54600,
            57600,
            60660,
            63900,
            68400,
            71400,
            74100,
            76500,
            79200,
            81900
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_bus_114",
      "sourceRouteId": "vilnius_bus_114",
      "mode": "bus",
      "shortName": "114",
      "longName": "Šiaurės miestelis–Antakalnis–Mileišiškių –S.Kerbedžio g.–Dvarčionys–Vinciūniškės",
      "color": "0073AC",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_bus_114:0",
          "sourceRouteId": "vilnius_bus_114",
          "sourceShapeId": "vilnius_bus_114_a-b",
          "directionId": 0,
          "headsign": "Vinciūniškės",
          "directionName": "Šiaurės miestelis–Antakalnis–Mileišiškių –S.Kerbedžio g.–Dvarčionys–Vinciūniškės",
          "mode": "bus",
          "routeShortName": "114",
          "routeLongName": "Šiaurės miestelis–Antakalnis–Mileišiškių –S.Kerbedžio g.–Dvarčionys–Vinciūniškės",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              1407.302,
              -2542.364,
              0
            ],
            [
              1404.085,
              -2529.725,
              13.042
            ],
            [
              1492.99,
              -2519.128,
              102.577
            ],
            [
              1552.992,
              -2512.565,
              162.937
            ],
            [
              1553.062,
              -2516.719,
              167.092
            ],
            [
              1555.121,
              -2529.24,
              179.781
            ],
            [
              1555.678,
              -2562.629,
              213.175
            ],
            [
              1562.253,
              -2572.736,
              225.233
            ],
            [
              1574.454,
              -2575.189,
              237.678
            ],
            [
              1684.596,
              -2579.462,
              347.903
            ],
            [
              1689.647,
              -2585.122,
              355.489
            ],
            [
              1692.552,
              -2638.806,
              409.252
            ],
            [
              1690.652,
              -2669.748,
              440.251
            ],
            [
              1690.731,
              -2873.474,
              643.977
            ],
            [
              1700.851,
              -3126.37,
              897.076
            ],
            [
              1707.344,
              -3177.803,
              948.917
            ],
            [
              1701.896,
              -3208.77,
              980.36
            ],
            [
              1697.306,
              -3247.648,
              1019.508
            ],
            [
              1679.831,
              -3286.287,
              1061.915
            ],
            [
              1593.247,
              -3437.193,
              1235.896
            ],
            [
              1579.69,
              -3472.235,
              1273.468
            ],
            [
              1566.424,
              -3493.47,
              1298.507
            ],
            [
              1520.486,
              -3572.771,
              1390.153
            ],
            [
              1584,
              -3657.444,
              1495.999
            ],
            [
              1660.25,
              -3750.148,
              1616.033
            ],
            [
              1866.498,
              -3989.997,
              1932.365
            ],
            [
              1889,
              -4009.127,
              1961.9
            ],
            [
              1892.95,
              -4022.775,
              1976.108
            ],
            [
              1975.005,
              -4114.479,
              2099.163
            ],
            [
              2057.826,
              -4199.52,
              2217.87
            ],
            [
              2170.271,
              -4319.627,
              2382.398
            ],
            [
              2237.981,
              -4385.463,
              2476.839
            ],
            [
              2278.639,
              -4416.283,
              2527.858
            ],
            [
              2288.882,
              -4419.815,
              2538.693
            ],
            [
              2297.281,
              -4420.426,
              2547.114
            ],
            [
              2310.823,
              -4417.999,
              2560.872
            ],
            [
              2320.672,
              -4408.165,
              2574.79
            ],
            [
              2330.583,
              -4394.991,
              2591.275
            ],
            [
              2336.672,
              -4379.52,
              2607.902
            ],
            [
              2338.759,
              -4373.358,
              2614.408
            ],
            [
              2346.709,
              -4359.67,
              2630.237
            ],
            [
              2358.18,
              -4332.053,
              2660.141
            ],
            [
              2390.982,
              -4163.454,
              2831.901
            ],
            [
              2453.858,
              -3937.529,
              3066.413
            ],
            [
              2472.257,
              -3849.927,
              3155.926
            ],
            [
              2499.323,
              -3746.903,
              3262.446
            ],
            [
              2506.29,
              -3702.5,
              3307.392
            ],
            [
              2508.663,
              -3661.358,
              3348.603
            ],
            [
              2467.501,
              -3518.217,
              3497.545
            ],
            [
              2463.864,
              -3499.82,
              3516.297
            ],
            [
              2434.339,
              -3309.248,
              3709.143
            ],
            [
              2430.841,
              -3283.862,
              3734.769
            ],
            [
              2426.976,
              -3256.769,
              3762.136
            ],
            [
              2328.687,
              -2639.354,
              4387.326
            ],
            [
              2422.077,
              -2608.82,
              4485.581
            ],
            [
              2444.816,
              -2599.227,
              4510.26
            ],
            [
              2646.504,
              -2533.994,
              4722.235
            ],
            [
              2717.262,
              -2507.494,
              4797.793
            ],
            [
              2743.995,
              -2491.298,
              4829.049
            ],
            [
              2805.445,
              -2445.699,
              4905.57
            ],
            [
              2826.856,
              -2438.309,
              4928.22
            ],
            [
              2849.016,
              -2425.368,
              4953.882
            ],
            [
              2992.535,
              -2369.073,
              5108.047
            ],
            [
              3051.699,
              -2342.359,
              5172.962
            ],
            [
              3144.148,
              -2294.01,
              5277.291
            ],
            [
              3171.465,
              -2281.167,
              5307.476
            ],
            [
              3196.764,
              -2272.74,
              5334.142
            ],
            [
              3228.339,
              -2273.338,
              5365.723
            ],
            [
              3336.411,
              -2291.815,
              5475.362
            ],
            [
              3341.954,
              -2292.861,
              5481.003
            ],
            [
              3369.017,
              -2299.382,
              5508.841
            ],
            [
              3397.349,
              -2301.032,
              5537.221
            ],
            [
              3430.9,
              -2299.443,
              5570.81
            ],
            [
              3478.067,
              -2293.658,
              5618.33
            ],
            [
              3484.236,
              -2308.248,
              5634.171
            ],
            [
              3493.838,
              -2318.189,
              5647.992
            ],
            [
              3501.632,
              -2321.016,
              5656.283
            ],
            [
              3511.041,
              -2322.823,
              5665.864
            ],
            [
              3520.089,
              -2321.175,
              5675.061
            ],
            [
              3550.396,
              -2320.637,
              5705.372
            ],
            [
              3610.299,
              -2326.915,
              5765.604
            ],
            [
              3749.947,
              -2348.687,
              5906.939
            ],
            [
              3826.638,
              -2342.488,
              5983.879
            ],
            [
              3880.671,
              -2342.483,
              6037.913
            ],
            [
              3899.892,
              -2348.445,
              6058.037
            ],
            [
              3964.658,
              -2390.015,
              6134.996
            ],
            [
              4005.181,
              -2426.318,
              6189.402
            ],
            [
              4020.144,
              -2445.95,
              6214.087
            ],
            [
              4040.888,
              -2492.522,
              6265.069
            ],
            [
              4043.21,
              -2505.925,
              6278.672
            ],
            [
              4042.848,
              -2524.844,
              6297.594
            ],
            [
              4028.232,
              -2581.341,
              6355.951
            ],
            [
              4029.2,
              -2614.614,
              6389.238
            ],
            [
              4036.551,
              -2628.85,
              6405.261
            ],
            [
              4048.304,
              -2644.068,
              6424.488
            ],
            [
              4085.128,
              -2679.035,
              6475.269
            ],
            [
              4090.171,
              -2679.379,
              6480.324
            ],
            [
              4122.851,
              -2695.319,
              6516.684
            ],
            [
              4140.69,
              -2700.385,
              6535.229
            ],
            [
              4203.083,
              -2707.145,
              6597.987
            ],
            [
              4239.365,
              -2704.002,
              6634.404
            ],
            [
              4462.339,
              -2838.279,
              6894.689
            ],
            [
              4653.136,
              -2974.321,
              7129.019
            ],
            [
              4761.133,
              -3060.724,
              7267.327
            ],
            [
              4805.406,
              -3092.779,
              7321.985
            ],
            [
              4843.655,
              -3114.669,
              7366.055
            ],
            [
              4866.097,
              -3120.669,
              7389.286
            ],
            [
              4905.237,
              -3123.934,
              7428.562
            ],
            [
              4918.329,
              -3142.483,
              7451.265
            ],
            [
              5111.959,
              -3383.869,
              7760.716
            ],
            [
              5182.292,
              -3447.697,
              7855.694
            ],
            [
              5236.068,
              -3487.321,
              7922.492
            ],
            [
              5457.178,
              -3547.54,
              8151.655
            ],
            [
              5524.457,
              -3579.518,
              8226.147
            ],
            [
              5556.753,
              -3602.706,
              8265.906
            ],
            [
              5627.672,
              -3688.831,
              8377.471
            ],
            [
              5808.546,
              -3721.809,
              8561.327
            ],
            [
              5846.782,
              -3728.627,
              8600.166
            ],
            [
              5857.795,
              -3726.733,
              8611.341
            ],
            [
              5881.363,
              -3715.305,
              8637.534
            ],
            [
              5898.795,
              -3705.15,
              8657.708
            ],
            [
              5913.164,
              -3700.253,
              8672.888
            ],
            [
              5960.05,
              -3695.961,
              8719.971
            ],
            [
              6112.623,
              -3700.546,
              8872.612
            ],
            [
              6123.534,
              -3709.366,
              8886.643
            ],
            [
              6143.657,
              -3736.69,
              8920.577
            ],
            [
              6164.382,
              -3768.809,
              8958.802
            ],
            [
              6239.965,
              -3823.155,
              9051.895
            ],
            [
              6248.404,
              -3834.658,
              9066.161
            ],
            [
              6251.015,
              -3851.204,
              9082.912
            ],
            [
              6257.572,
              -3879.35,
              9111.812
            ],
            [
              6260.764,
              -3891.033,
              9123.923
            ],
            [
              6260.99,
              -3891.888,
              9124.807
            ],
            [
              6268.358,
              -3939.468,
              9172.954
            ],
            [
              6267.047,
              -3970.54,
              9204.054
            ],
            [
              6263.68,
              -3992.528,
              9226.299
            ],
            [
              6254.941,
              -4015.317,
              9250.705
            ],
            [
              6200.333,
              -4076.551,
              9332.752
            ],
            [
              6190.078,
              -4097.146,
              9355.759
            ],
            [
              6191.1,
              -4118.008,
              9376.646
            ],
            [
              6215.367,
              -4178.503,
              9441.826
            ],
            [
              6222.196,
              -4203.55,
              9467.788
            ],
            [
              6222.443,
              -4227.968,
              9492.207
            ],
            [
              6191.798,
              -4319.997,
              9589.204
            ],
            [
              6145.405,
              -4424.403,
              9703.454
            ],
            [
              6138.189,
              -4451.094,
              9731.103
            ],
            [
              6140.094,
              -4494.668,
              9774.718
            ],
            [
              6146.779,
              -4528.121,
              9808.833
            ],
            [
              6113.79,
              -4573.262,
              9864.743
            ],
            [
              6101.095,
              -4596.392,
              9891.128
            ],
            [
              6100.769,
              -4613.085,
              9907.824
            ],
            [
              6110.802,
              -4660.039,
              9955.838
            ],
            [
              6125.051,
              -4655.893,
              9970.677
            ],
            [
              6131.803,
              -4659.647,
              9978.403
            ],
            [
              6138.028,
              -4669.628,
              9990.166
            ],
            [
              6142.269,
              -4679.446,
              10000.861
            ],
            [
              6157.107,
              -4716.379,
              10040.663
            ],
            [
              6163.114,
              -4752.353,
              10077.135
            ],
            [
              6148.487,
              -4775.446,
              10104.471
            ],
            [
              6122.934,
              -4797.211,
              10138.037
            ],
            [
              6095.897,
              -4828.966,
              10179.743
            ],
            [
              6024.895,
              -4934.452,
              10306.898
            ],
            [
              6018.15,
              -4949.906,
              10323.76
            ],
            [
              6009.703,
              -4986.479,
              10361.296
            ],
            [
              6001.73,
              -5101.059,
              10476.153
            ],
            [
              6002.517,
              -5123.272,
              10498.38
            ],
            [
              6007.161,
              -5135.764,
              10511.707
            ],
            [
              6016.623,
              -5161.362,
              10538.998
            ],
            [
              6030.604,
              -5169.466,
              10555.158
            ],
            [
              6078.772,
              -5177.089,
              10603.925
            ],
            [
              6272.282,
              -5197.581,
              10798.517
            ],
            [
              6910.627,
              -5258.468,
              11439.76
            ],
            [
              7009.219,
              -5271.64,
              11539.228
            ],
            [
              7655.857,
              -5403.073,
              12199.088
            ],
            [
              7709.038,
              -5417.492,
              12254.189
            ],
            [
              7740.925,
              -5433.715,
              12289.965
            ],
            [
              7791.434,
              -5473.105,
              12354.018
            ],
            [
              7852.17,
              -5508.3,
              12424.214
            ],
            [
              7918.972,
              -5517.522,
              12491.65
            ],
            [
              7947.874,
              -5518.947,
              12520.587
            ],
            [
              7968.947,
              -5526.348,
              12542.922
            ],
            [
              7969.509,
              -5538.756,
              12555.343
            ],
            [
              7801.253,
              -5670.938,
              12769.31
            ],
            [
              7791.372,
              -5681.873,
              12784.048
            ],
            [
              7782.646,
              -5699.512,
              12803.728
            ],
            [
              7724.095,
              -5954.402,
              13065.256
            ],
            [
              7696.143,
              -6031.775,
              13147.523
            ],
            [
              7655.004,
              -6156.757,
              13279.102
            ],
            [
              7645.716,
              -6190.071,
              13313.687
            ],
            [
              7635.141,
              -6240.82,
              13365.525
            ],
            [
              7604.789,
              -6349.47,
              13478.335
            ],
            [
              7581.913,
              -6443.656,
              13575.26
            ],
            [
              7581.97,
              -6460.345,
              13591.949
            ],
            [
              7624.685,
              -6611.491,
              13749.015
            ],
            [
              7815.833,
              -6820.768,
              14032.448
            ],
            [
              7812.887,
              -7009.16,
              14220.863
            ],
            [
              7812.51,
              -7019.27,
              14230.98
            ],
            [
              7808.948,
              -7043.931,
              14255.896
            ],
            [
              7772.351,
              -7080.181,
              14307.407
            ],
            [
              7703.89,
              -7114.421,
              14383.954
            ],
            [
              7167.223,
              -7284.534,
              14946.937
            ],
            [
              6850.874,
              -7507.92,
              15334.207
            ],
            [
              6898.316,
              -7584.728,
              15424.485
            ],
            [
              6955.285,
              -7699.232,
              15552.378
            ],
            [
              6978.344,
              -7741.327,
              15600.375
            ],
            [
              6999.078,
              -7777.448,
              15642.025
            ],
            [
              7014.385,
              -7790.38,
              15662.063
            ],
            [
              7037.95,
              -7797.952,
              15686.814
            ],
            [
              7078.202,
              -7804.764,
              15727.639
            ],
            [
              7105.344,
              -7807.36,
              15754.904
            ],
            [
              7133.745,
              -7814.098,
              15784.094
            ],
            [
              7161.984,
              -7829.046,
              15816.045
            ],
            [
              7250.665,
              -7891.797,
              15924.682
            ],
            [
              7259.417,
              -7907.449,
              15942.615
            ],
            [
              7268.282,
              -7948.85,
              15984.955
            ],
            [
              7284.728,
              -7968.516,
              16010.591
            ],
            [
              7366.869,
              -8019.083,
              16107.048
            ],
            [
              7387.349,
              -8013.151,
              16128.371
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:7589",
              "position": {
                "x": 1524.687,
                "z": -2513.037
              },
              "distanceAlongShapeM": 134.748,
              "shapeOffsetM": 2.608,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:5606",
              "position": {
                "x": 1696.386,
                "z": -2638.684
              },
              "distanceAlongShapeM": 409.252,
              "shapeOffsetM": 3.836,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:6667",
              "position": {
                "x": 1709.563,
                "z": -3177.741
              },
              "distanceAlongShapeM": 948.917,
              "shapeOffsetM": 2.22,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:6873",
              "position": {
                "x": 1553.844,
                "z": -3615.694
              },
              "distanceAlongShapeM": 1444.506,
              "shapeOffsetM": 0.929,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:6874",
              "position": {
                "x": 1889.999,
                "z": -4008.247
              },
              "distanceAlongShapeM": 1961.9,
              "shapeOffsetM": 1.331,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:5476",
              "position": {
                "x": 2336.174,
                "z": -4371.718
              },
              "distanceAlongShapeM": 2614.527,
              "shapeOffsetM": 3.059,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:5118",
              "position": {
                "x": 2463.001,
                "z": -3519.117
              },
              "distanceAlongShapeM": 3497.545,
              "shapeOffsetM": 4.589,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:5119",
              "position": {
                "x": 2425.512,
                "z": -3284.63
              },
              "distanceAlongShapeM": 3734.735,
              "shapeOffsetM": 5.384,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:6723",
              "position": {
                "x": 2444.816,
                "z": -2599.227
              },
              "distanceAlongShapeM": 4510.26,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:11047",
              "position": {
                "x": 2826.856,
                "z": -2438.309
              },
              "distanceAlongShapeM": 4928.22,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            },
            {
              "stopId": "judu:stop:4520",
              "position": {
                "x": 3336.988,
                "z": -2288.755
              },
              "distanceAlongShapeM": 5475.362,
              "shapeOffsetM": 3.114,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:9756",
              "position": {
                "x": 4203.083,
                "z": -2707.145
              },
              "distanceAlongShapeM": 6597.987,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:9612",
              "position": {
                "x": 4464.241,
                "z": -2835.727
              },
              "distanceAlongShapeM": 6894.756,
              "shapeOffsetM": 3.182,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:10548",
              "position": {
                "x": 4920.495,
                "z": -3140.644
              },
              "distanceAlongShapeM": 7451.012,
              "shapeOffsetM": 2.83,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            },
            {
              "stopId": "judu:stop:10611",
              "position": {
                "x": 5185.975,
                "z": -3443.023
              },
              "distanceAlongShapeM": 7855.28,
              "shapeOffsetM": 5.936,
              "arrivalOffsetSeconds": 1380,
              "departureOffsetSeconds": 1380
            },
            {
              "stopId": "judu:stop:10544",
              "position": {
                "x": 5809.614,
                "z": -3717.882
              },
              "distanceAlongShapeM": 8561.689,
              "shapeOffsetM": 4.053,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            },
            {
              "stopId": "judu:stop:10539",
              "position": {
                "x": 6126.903,
                "z": -3706.272
              },
              "distanceAlongShapeM": 8886.643,
              "shapeOffsetM": 4.574,
              "arrivalOffsetSeconds": 1500,
              "departureOffsetSeconds": 1500
            },
            {
              "stopId": "judu:stop:10538",
              "position": {
                "x": 6266.355,
                "z": -3890.47
              },
              "distanceAlongShapeM": 9124.807,
              "shapeOffsetM": 5.549,
              "arrivalOffsetSeconds": 1560,
              "departureOffsetSeconds": 1560
            },
            {
              "stopId": "judu:stop:8250",
              "position": {
                "x": 6147.186,
                "z": -4677.451
              },
              "distanceAlongShapeM": 10000.861,
              "shapeOffsetM": 5.306,
              "arrivalOffsetSeconds": 1680,
              "departureOffsetSeconds": 1680
            },
            {
              "stopId": "judu:stop:6183",
              "position": {
                "x": 7009.8,
                "z": -5268.893
              },
              "distanceAlongShapeM": 11539.25,
              "shapeOffsetM": 2.808,
              "arrivalOffsetSeconds": 1860,
              "departureOffsetSeconds": 1860
            },
            {
              "stopId": "judu:stop:16307",
              "position": {
                "x": 7913.164,
                "z": -5582.996
              },
              "distanceAlongShapeM": 12626.98,
              "shapeOffsetM": 0.02,
              "arrivalOffsetSeconds": 1980,
              "departureOffsetSeconds": 1980
            },
            {
              "stopId": "judu:stop:6895",
              "position": {
                "x": 7635.934,
                "z": -6240.988
              },
              "distanceAlongShapeM": 13365.525,
              "shapeOffsetM": 0.81,
              "arrivalOffsetSeconds": 2040,
              "departureOffsetSeconds": 2040
            },
            {
              "stopId": "judu:stop:6899",
              "position": {
                "x": 7824.11,
                "z": -7009.579
              },
              "distanceAlongShapeM": 14220.863,
              "shapeOffsetM": 11.231,
              "arrivalOffsetSeconds": 2160,
              "departureOffsetSeconds": 2160
            },
            {
              "stopId": "judu:stop:9925",
              "position": {
                "x": 7388.169,
                "z": -8011.764
              },
              "distanceAlongShapeM": 16128.371,
              "shapeOffsetM": 1.611,
              "arrivalOffsetSeconds": 2280,
              "departureOffsetSeconds": 2280
            }
          ],
          "departuresSeconds": [
            17580,
            18780,
            19980,
            20940,
            21960,
            22980,
            24180,
            25380,
            26880,
            28620,
            30420,
            32280,
            33660,
            35100,
            36480,
            37920,
            39360,
            40740,
            42120,
            43500,
            44880,
            46320,
            47760,
            49140,
            50460,
            51660,
            52860,
            54060,
            55260,
            56460,
            57660,
            58920,
            60240,
            61560,
            63060,
            64620,
            66420,
            67980,
            69540,
            71100,
            72660,
            74160,
            75660,
            77100,
            78540,
            80040,
            81480
          ]
        },
        {
          "id": "judu:pattern:vilnius_bus_114:1",
          "sourceRouteId": "vilnius_bus_114",
          "sourceShapeId": "vilnius_bus_114_b-a",
          "directionId": 1,
          "headsign": "Šiaurės miestelis",
          "directionName": "Vinciūniškės–Dvarčionys–S.Kerbedžio–Mileišiškių g.–Antakalnis–Šiaurės miestelis",
          "mode": "bus",
          "routeShortName": "114",
          "routeLongName": "Šiaurės miestelis–Antakalnis–Mileišiškių –S.Kerbedžio g.–Dvarčionys–Vinciūniškės",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              7388.189,
              -8013.718,
              0
            ],
            [
              7389.702,
              -8034.341,
              20.679
            ],
            [
              7386.477,
              -8033.047,
              24.154
            ],
            [
              7299.508,
              -7977.009,
              127.614
            ],
            [
              7269.641,
              -7952.512,
              166.242
            ],
            [
              7261.923,
              -7922.31,
              197.414
            ],
            [
              7258.11,
              -7902.303,
              217.781
            ],
            [
              7196.901,
              -7852.849,
              296.473
            ],
            [
              7172.077,
              -7835.531,
              326.74
            ],
            [
              7145.09,
              -7819.32,
              358.222
            ],
            [
              7106.85,
              -7807.492,
              398.249
            ],
            [
              7039.95,
              -7798.344,
              465.772
            ],
            [
              7023.153,
              -7793.946,
              483.135
            ],
            [
              7009.73,
              -7787.276,
              498.124
            ],
            [
              6988.415,
              -7760.371,
              532.449
            ],
            [
              6850.874,
              -7507.92,
              819.936
            ],
            [
              6999.325,
              -7415.531,
              994.789
            ],
            [
              7093.966,
              -7325.893,
              1125.142
            ],
            [
              7135.786,
              -7297.582,
              1175.643
            ],
            [
              7185.419,
              -7278.796,
              1228.712
            ],
            [
              7344.866,
              -7231.362,
              1395.066
            ],
            [
              7688.49,
              -7119.634,
              1756.398
            ],
            [
              7767.565,
              -7083.075,
              1843.515
            ],
            [
              7809.017,
              -7043.737,
              1900.662
            ],
            [
              7810.028,
              -7009.355,
              1935.059
            ],
            [
              7814.771,
              -6832.378,
              2112.099
            ],
            [
              7811.308,
              -6812.269,
              2132.504
            ],
            [
              7628.808,
              -6621.3,
              2396.655
            ],
            [
              7581.97,
              -6460.345,
              2564.286
            ],
            [
              7581.804,
              -6446.985,
              2577.647
            ],
            [
              7617.025,
              -6297.887,
              2730.849
            ],
            [
              7651.767,
              -6166.909,
              2866.356
            ],
            [
              7709.064,
              -5997.521,
              3045.172
            ],
            [
              7737.395,
              -5901.229,
              3145.546
            ],
            [
              7780.648,
              -5702.812,
              3348.622
            ],
            [
              7791.372,
              -5681.873,
              3372.148
            ],
            [
              7932.238,
              -5563.338,
              3556.25
            ],
            [
              7942.378,
              -5549.082,
              3573.745
            ],
            [
              7942.986,
              -5541.287,
              3581.563
            ],
            [
              7938.723,
              -5528.956,
              3594.61
            ],
            [
              7918.962,
              -5518.541,
              3616.948
            ],
            [
              7892.106,
              -5518.7,
              3643.804
            ],
            [
              6930.794,
              -5263.749,
              4638.35
            ],
            [
              6784.784,
              -5245.52,
              4785.494
            ],
            [
              6076.818,
              -5178.164,
              5496.657
            ],
            [
              6011.533,
              -5169.201,
              5562.554
            ],
            [
              5986.3,
              -5161.92,
              5588.816
            ],
            [
              5981.499,
              -5158.246,
              5594.862
            ],
            [
              5980.83,
              -5145.113,
              5608.012
            ],
            [
              5992.039,
              -5131.973,
              5625.284
            ],
            [
              5997.747,
              -5122.02,
              5636.757
            ],
            [
              6009.977,
              -5005.41,
              5754.007
            ],
            [
              6012.226,
              -4969.877,
              5789.61
            ],
            [
              6022.232,
              -4938.853,
              5822.208
            ],
            [
              6026.936,
              -4928.925,
              5833.194
            ],
            [
              6102.313,
              -4821.094,
              5964.759
            ],
            [
              6130.193,
              -4788.447,
              6007.69
            ],
            [
              6148.553,
              -4772.107,
              6032.269
            ],
            [
              6156.478,
              -4762.243,
              6044.922
            ],
            [
              6161.248,
              -4748.977,
              6059.019
            ],
            [
              6159.686,
              -4730.021,
              6078.039
            ],
            [
              6140.414,
              -4690.434,
              6122.068
            ],
            [
              6133.322,
              -4661.594,
              6151.768
            ],
            [
              6125.051,
              -4655.893,
              6161.813
            ],
            [
              6110.78,
              -4661.152,
              6177.022
            ],
            [
              6101.325,
              -4617.549,
              6221.638
            ],
            [
              6101.052,
              -4598.618,
              6240.571
            ],
            [
              6101.783,
              -4594.179,
              6245.07
            ],
            [
              6117.098,
              -4568.873,
              6274.649
            ],
            [
              6146.577,
              -4529.266,
              6324.023
            ],
            [
              6139.867,
              -4493.609,
              6360.306
            ],
            [
              6139.462,
              -4443.382,
              6410.534
            ],
            [
              6165.063,
              -4383.096,
              6476.031
            ],
            [
              6209.157,
              -4270.391,
              6597.054
            ],
            [
              6221.569,
              -4233.409,
              6636.064
            ],
            [
              6221.661,
              -4201.185,
              6668.287
            ],
            [
              6191.1,
              -4118.008,
              6756.901
            ],
            [
              6191.933,
              -4090.336,
              6784.587
            ],
            [
              6198.814,
              -4078.615,
              6798.178
            ],
            [
              6258.152,
              -4010.129,
              6888.795
            ],
            [
              6264.219,
              -3990.43,
              6909.407
            ],
            [
              6268.17,
              -3950.688,
              6949.344
            ],
            [
              6245.635,
              -3829.569,
              7072.541
            ],
            [
              6184.115,
              -3789.823,
              7145.784
            ],
            [
              6161.91,
              -3765.917,
              7178.412
            ],
            [
              6121.229,
              -3708.114,
              7249.095
            ],
            [
              6112.623,
              -3700.546,
              7260.556
            ],
            [
              6058.608,
              -3701.401,
              7314.577
            ],
            [
              6036.025,
              -3700.584,
              7337.175
            ],
            [
              5962.317,
              -3696.069,
              7411.021
            ],
            [
              5924.887,
              -3697.918,
              7448.497
            ],
            [
              5907.235,
              -3701.975,
              7466.609
            ],
            [
              5889.573,
              -3710.333,
              7486.149
            ],
            [
              5877.989,
              -3717.732,
              7499.894
            ],
            [
              5853.783,
              -3728.224,
              7526.276
            ],
            [
              5648.347,
              -3694.863,
              7734.403
            ],
            [
              5617.644,
              -3676.151,
              7770.359
            ],
            [
              5550.141,
              -3596.545,
              7874.732
            ],
            [
              5514.018,
              -3575.191,
              7916.695
            ],
            [
              5433.598,
              -3539.116,
              8004.835
            ],
            [
              5361.69,
              -3521.02,
              8078.985
            ],
            [
              5257.158,
              -3494.5,
              8186.829
            ],
            [
              5212.829,
              -3483.469,
              8232.51
            ],
            [
              5183.755,
              -3451.205,
              8275.941
            ],
            [
              5128.098,
              -3400.48,
              8351.245
            ],
            [
              5098.981,
              -3371.297,
              8392.47
            ],
            [
              4969.938,
              -3206.905,
              8601.46
            ],
            [
              4917.687,
              -3144.585,
              8682.786
            ],
            [
              4904.603,
              -3124.007,
              8707.171
            ],
            [
              4867.364,
              -3121.806,
              8744.475
            ],
            [
              4845.624,
              -3115.653,
              8767.069
            ],
            [
              4827.67,
              -3105.556,
              8787.667
            ],
            [
              4653.136,
              -2974.321,
              9006.036
            ],
            [
              4431.946,
              -2818.217,
              9276.763
            ],
            [
              4425.343,
              -2813.545,
              9284.852
            ],
            [
              4249.47,
              -2707.712,
              9490.113
            ],
            [
              4239.892,
              -2704.146,
              9500.333
            ],
            [
              4206.787,
              -2708.54,
              9533.728
            ],
            [
              4148.98,
              -2702.818,
              9591.818
            ],
            [
              4084.856,
              -2678.911,
              9660.254
            ],
            [
              4052.961,
              -2675.405,
              9692.341
            ],
            [
              4056.942,
              -2664.271,
              9704.165
            ],
            [
              4061.828,
              -2657.106,
              9712.838
            ],
            [
              4039.203,
              -2633.178,
              9745.769
            ],
            [
              4030.752,
              -2618.127,
              9763.03
            ],
            [
              4028.009,
              -2599.197,
              9782.158
            ],
            [
              4031.022,
              -2570.262,
              9811.249
            ],
            [
              4042.933,
              -2520.392,
              9862.522
            ],
            [
              4043.189,
              -2507.038,
              9875.878
            ],
            [
              4039.684,
              -2488.046,
              9895.191
            ],
            [
              4014.544,
              -2437.742,
              9951.427
            ],
            [
              3997.186,
              -2418.211,
              9977.557
            ],
            [
              3943.887,
              -2373.776,
              10046.949
            ],
            [
              3899.892,
              -2348.445,
              10097.715
            ],
            [
              3872.886,
              -2342.23,
              10125.427
            ],
            [
              3841.232,
              -2343.636,
              10157.113
            ],
            [
              3772.828,
              -2349.248,
              10225.747
            ],
            [
              3727.384,
              -2346.536,
              10271.272
            ],
            [
              3642.944,
              -2333.772,
              10356.671
            ],
            [
              3598.81,
              -2324.726,
              10401.722
            ],
            [
              3525.562,
              -2322.752,
              10474.997
            ],
            [
              3503.288,
              -2321.468,
              10497.308
            ],
            [
              3483.591,
              -2308.236,
              10521.037
            ],
            [
              3478.067,
              -2293.658,
              10536.626
            ],
            [
              3430.234,
              -2300.543,
              10584.952
            ],
            [
              3387.662,
              -2301.962,
              10627.548
            ],
            [
              3196.764,
              -2272.74,
              10820.67
            ],
            [
              3157.806,
              -2287.589,
              10862.362
            ],
            [
              3002.929,
              -2364.816,
              11035.425
            ],
            [
              2811.307,
              -2442.469,
              11242.183
            ],
            [
              2719.174,
              -2508.643,
              11355.618
            ],
            [
              2680.157,
              -2526.834,
              11398.667
            ],
            [
              2599.153,
              -2549.802,
              11482.865
            ],
            [
              2457.059,
              -2599.457,
              11633.385
            ],
            [
              2382.154,
              -2627.435,
              11713.344
            ],
            [
              2328.687,
              -2639.354,
              11768.124
            ],
            [
              2411.872,
              -3118.499,
              12254.436
            ],
            [
              2415.738,
              -3139.252,
              12275.546
            ],
            [
              2418.768,
              -3163.158,
              12299.643
            ],
            [
              2474.472,
              -3526.012,
              12666.748
            ],
            [
              2513.109,
              -3664.781,
              12810.795
            ],
            [
              2520.474,
              -3683.355,
              12830.777
            ],
            [
              2525.989,
              -3699.534,
              12847.869
            ],
            [
              2553.555,
              -3775.753,
              12928.92
            ],
            [
              2561.118,
              -3784.801,
              12940.713
            ],
            [
              2565.773,
              -3798.99,
              12955.645
            ],
            [
              2576.152,
              -3847.582,
              13005.334
            ],
            [
              2574.802,
              -3870.332,
              13028.125
            ],
            [
              2567.828,
              -3895.962,
              13054.686
            ],
            [
              2541.083,
              -3951.972,
              13116.754
            ],
            [
              2518.107,
              -3984.62,
              13156.676
            ],
            [
              2481.327,
              -4031.329,
              13216.128
            ],
            [
              2454.012,
              -4066.67,
              13260.794
            ],
            [
              2436.763,
              -4093.064,
              13292.325
            ],
            [
              2406.107,
              -4181.549,
              13385.97
            ],
            [
              2398.976,
              -4218.153,
              13423.262
            ],
            [
              2394.879,
              -4264.833,
              13470.121
            ],
            [
              2388.205,
              -4311.465,
              13517.229
            ],
            [
              2381.138,
              -4344.73,
              13551.236
            ],
            [
              2380.534,
              -4359.108,
              13565.627
            ],
            [
              2363.369,
              -4398.946,
              13609.005
            ],
            [
              2340.823,
              -4433.034,
              13649.875
            ],
            [
              2328.252,
              -4450.61,
              13671.484
            ],
            [
              2298.04,
              -4481.215,
              13714.489
            ],
            [
              2296.644,
              -4486.96,
              13720.401
            ],
            [
              2297.644,
              -4502.36,
              13735.833
            ],
            [
              2324.901,
              -4526.249,
              13772.077
            ],
            [
              2369.547,
              -4550.465,
              13822.868
            ],
            [
              2386.895,
              -4553.017,
              13840.403
            ],
            [
              2397.928,
              -4548.771,
              13852.225
            ],
            [
              2404.556,
              -4538.876,
              13864.134
            ],
            [
              2405.535,
              -4521.082,
              13881.955
            ],
            [
              2396.166,
              -4505.32,
              13900.291
            ],
            [
              2310.611,
              -4463.639,
              13995.46
            ],
            [
              2264.435,
              -4428.158,
              14053.693
            ],
            [
              2254.143,
              -4416.937,
              14068.919
            ],
            [
              2239.684,
              -4397.741,
              14092.951
            ],
            [
              2102.49,
              -4258.698,
              14288.285
            ],
            [
              2005.819,
              -4155.131,
              14429.958
            ],
            [
              1848.669,
              -3978.532,
              14666.355
            ],
            [
              1832.856,
              -3962.652,
              14688.765
            ],
            [
              1812.233,
              -3946.912,
              14714.709
            ],
            [
              1800.044,
              -3925.303,
              14739.518
            ],
            [
              1667.691,
              -3765.872,
              14946.727
            ],
            [
              1499.686,
              -3582.404,
              15195.497
            ],
            [
              1509.877,
              -3564.24,
              15216.324
            ],
            [
              1545.21,
              -3525.36,
              15268.861
            ],
            [
              1610.18,
              -3392.177,
              15417.046
            ],
            [
              1620.009,
              -3384.254,
              15429.67
            ],
            [
              1689.847,
              -3267.548,
              15565.676
            ],
            [
              1697.306,
              -3247.648,
              15586.928
            ],
            [
              1696.944,
              -3128.524,
              15706.053
            ],
            [
              1692.78,
              -3098.159,
              15736.702
            ],
            [
              1691.952,
              -3068.3,
              15766.573
            ],
            [
              1690.731,
              -2873.474,
              15961.402
            ],
            [
              1688.435,
              -2754.314,
              16080.584
            ],
            [
              1682.19,
              -2639.533,
              16195.535
            ],
            [
              1680.853,
              -2611.627,
              16223.473
            ],
            [
              1680.619,
              -2598.143,
              16236.96
            ],
            [
              1670.987,
              -2586.136,
              16252.352
            ],
            [
              1656.786,
              -2584.511,
              16266.646
            ],
            [
              1622.02,
              -2584.755,
              16301.413
            ],
            [
              1614.3,
              -2581.496,
              16309.793
            ],
            [
              1426.817,
              -2576.903,
              16497.332
            ],
            [
              1419.812,
              -2572.32,
              16505.703
            ],
            [
              1406.874,
              -2540.387,
              16540.157
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:9925",
              "position": {
                "x": 7388.169,
                "z": -8011.764
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 1.954,
              "arrivalOffsetSeconds": -300,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:6898",
              "position": {
                "x": 7806.73,
                "z": -7009.232
              },
              "distanceAlongShapeM": 1935.093,
              "shapeOffsetM": 3.3,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:6896",
              "position": {
                "x": 7614.845,
                "z": -6297.345
              },
              "distanceAlongShapeM": 2730.849,
              "shapeOffsetM": 2.247,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:16306",
              "position": {
                "x": 7891.85,
                "z": -5521.339
              },
              "distanceAlongShapeM": 3643.804,
              "shapeOffsetM": 2.651,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:6184",
              "position": {
                "x": 6930.636,
                "z": -5265.1
              },
              "distanceAlongShapeM": 4638.157,
              "shapeOffsetM": 1.346,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:6179",
              "position": {
                "x": 6139.84,
                "z": -4690.667
              },
              "distanceAlongShapeM": 6122.068,
              "shapeOffsetM": 0.619,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:10537",
              "position": {
                "x": 6262.545,
                "z": -3920.454
              },
              "distanceAlongShapeM": 6980.097,
              "shapeOffsetM": 0.001,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:10541",
              "position": {
                "x": 6058.663,
                "z": -3702.709
              },
              "distanceAlongShapeM": 7314.543,
              "shapeOffsetM": 1.309,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:10543",
              "position": {
                "x": 5882.321,
                "z": -3723.754
              },
              "distanceAlongShapeM": 7499.485,
              "shapeOffsetM": 7.407,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:10609",
              "position": {
                "x": 5215.327,
                "z": -3491.463
              },
              "distanceAlongShapeM": 8228.155,
              "shapeOffsetM": 7.154,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:10545",
              "position": {
                "x": 4915.877,
                "z": -3146.122
              },
              "distanceAlongShapeM": 8682.771,
              "shapeOffsetM": 2.374,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:9613",
              "position": {
                "x": 4422.037,
                "z": -2818.217
              },
              "distanceAlongShapeM": 9285.276,
              "shapeOffsetM": 5.708,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:9755",
              "position": {
                "x": 4148.315,
                "z": -2706.097
              },
              "distanceAlongShapeM": 9591.818,
              "shapeOffsetM": 3.346,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:4521",
              "position": {
                "x": 3280.303,
                "z": -2286.568
              },
              "distanceAlongShapeM": 10736,
              "shapeOffsetM": 1.028,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            },
            {
              "stopId": "judu:stop:11046",
              "position": {
                "x": 2680.157,
                "z": -2526.834
              },
              "distanceAlongShapeM": 11398.667,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1380,
              "departureOffsetSeconds": 1380
            },
            {
              "stopId": "judu:stop:6720",
              "position": {
                "x": 2382.396,
                "z": -2628.114
              },
              "distanceAlongShapeM": 11713.344,
              "shapeOffsetM": 0.721,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            },
            {
              "stopId": "judu:stop:1035",
              "position": {
                "x": 2419.872,
                "z": -3138.687
              },
              "distanceAlongShapeM": 12275.546,
              "shapeOffsetM": 4.173,
              "arrivalOffsetSeconds": 1620,
              "departureOffsetSeconds": 1620
            },
            {
              "stopId": "judu:stop:6711",
              "position": {
                "x": 2522.438,
                "z": -3682.768
              },
              "distanceAlongShapeM": 12830.854,
              "shapeOffsetM": 2.049,
              "arrivalOffsetSeconds": 1740,
              "departureOffsetSeconds": 1740
            },
            {
              "stopId": "judu:stop:5485",
              "position": {
                "x": 2577.544,
                "z": -3870.831
              },
              "distanceAlongShapeM": 13028.125,
              "shapeOffsetM": 2.787,
              "arrivalOffsetSeconds": 1800,
              "departureOffsetSeconds": 1800
            },
            {
              "stopId": "judu:stop:5490",
              "position": {
                "x": 2383.36,
                "z": -4363.697
              },
              "distanceAlongShapeM": 13568.723,
              "shapeOffsetM": 4.411,
              "arrivalOffsetSeconds": 1860,
              "departureOffsetSeconds": 1860
            },
            {
              "stopId": "judu:stop:5491",
              "position": {
                "x": 2261.601,
                "z": -4431.549
              },
              "distanceAlongShapeM": 14053.693,
              "shapeOffsetM": 4.419,
              "arrivalOffsetSeconds": 1920,
              "departureOffsetSeconds": 1920
            },
            {
              "stopId": "judu:stop:5494",
              "position": {
                "x": 1811.224,
                "z": -3947.777
              },
              "distanceAlongShapeM": 14714.709,
              "shapeOffsetM": 1.329,
              "arrivalOffsetSeconds": 1980,
              "departureOffsetSeconds": 1980
            },
            {
              "stopId": "judu:stop:5086",
              "position": {
                "x": 1607.644,
                "z": -3390.704
              },
              "distanceAlongShapeM": 15417.046,
              "shapeOffsetM": 2.933,
              "arrivalOffsetSeconds": 2100,
              "departureOffsetSeconds": 2100
            },
            {
              "stopId": "judu:stop:5087",
              "position": {
                "x": 1687.839,
                "z": -3098.296
              },
              "distanceAlongShapeM": 15736.702,
              "shapeOffsetM": 4.943,
              "arrivalOffsetSeconds": 2160,
              "departureOffsetSeconds": 2160
            },
            {
              "stopId": "judu:stop:5013",
              "position": {
                "x": 1621.888,
                "z": -2589.429
              },
              "distanceAlongShapeM": 16301.413,
              "shapeOffsetM": 4.676,
              "arrivalOffsetSeconds": 2280,
              "departureOffsetSeconds": 2280
            },
            {
              "stopId": "judu:stop:15167",
              "position": {
                "x": 1413.343,
                "z": -2538.803
              },
              "distanceAlongShapeM": 16539.196,
              "shapeOffsetM": 6.59,
              "arrivalOffsetSeconds": 2340,
              "departureOffsetSeconds": 2340
            }
          ],
          "departuresSeconds": [
            20160,
            21360,
            22560,
            23520,
            24480,
            25680,
            27000,
            28320,
            29700,
            31260,
            33240,
            35220,
            36540,
            37860,
            39240,
            40620,
            42060,
            43440,
            44820,
            46200,
            47580,
            49020,
            50460,
            51900,
            53220,
            54540,
            55740,
            56940,
            58200,
            59400,
            60600,
            61800,
            63000,
            64200,
            65820,
            67440,
            69120,
            70680,
            72240,
            73800,
            75360,
            76920,
            78360,
            79800,
            81180,
            82620,
            84060
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_bus_115",
      "sourceRouteId": "vilnius_bus_115",
      "mode": "bus",
      "shortName": "115",
      "longName": "Antakalnis–Rokantiškės–Parko–Linksmoji g.",
      "color": "0073AC",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_bus_115:0",
          "sourceRouteId": "vilnius_bus_115",
          "sourceShapeId": "vilnius_bus_115_a-b",
          "directionId": 0,
          "headsign": "Linksmoji g.",
          "directionName": "Antakalnis–Rokantiškės–Parko–Linksmoji g.",
          "mode": "bus",
          "routeShortName": "115",
          "routeLongName": "Antakalnis–Rokantiškės–Parko–Linksmoji g.",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              2558.505,
              -3824.161,
              0
            ],
            [
              2555.4,
              -3867.621,
              43.571
            ],
            [
              2550.54,
              -3888.998,
              65.493
            ],
            [
              2499.38,
              -3984.027,
              173.418
            ],
            [
              2493.87,
              -3987.392,
              179.874
            ],
            [
              2480.707,
              -3991.548,
              193.678
            ],
            [
              2470.701,
              -3991,
              203.699
            ],
            [
              2459.88,
              -3985.473,
              215.85
            ],
            [
              2450.261,
              -3972.454,
              232.037
            ],
            [
              2446.334,
              -3960.766,
              244.367
            ],
            [
              2458.099,
              -3917.57,
              289.136
            ],
            [
              2495.249,
              -3757.959,
              453.014
            ],
            [
              2503.087,
              -3718.029,
              493.706
            ],
            [
              2508.663,
              -3661.358,
              550.65
            ],
            [
              2467.501,
              -3518.217,
              699.593
            ],
            [
              2463.864,
              -3499.82,
              718.345
            ],
            [
              2434.339,
              -3309.248,
              911.191
            ],
            [
              2430.841,
              -3283.862,
              936.817
            ],
            [
              2426.976,
              -3256.769,
              964.184
            ],
            [
              2328.687,
              -2639.354,
              1589.374
            ],
            [
              2422.077,
              -2608.82,
              1687.628
            ],
            [
              2444.816,
              -2599.227,
              1712.308
            ],
            [
              2646.504,
              -2533.994,
              1924.283
            ],
            [
              2717.262,
              -2507.494,
              1999.841
            ],
            [
              2743.995,
              -2491.298,
              2031.097
            ],
            [
              2805.445,
              -2445.699,
              2107.618
            ],
            [
              2826.856,
              -2438.309,
              2130.268
            ],
            [
              2849.016,
              -2425.368,
              2155.93
            ],
            [
              2992.535,
              -2369.073,
              2310.095
            ],
            [
              3051.699,
              -2342.359,
              2375.01
            ],
            [
              3171.465,
              -2281.167,
              2509.503
            ],
            [
              3196.764,
              -2272.74,
              2536.169
            ],
            [
              3228.339,
              -2273.338,
              2567.75
            ],
            [
              3336.411,
              -2291.815,
              2677.389
            ],
            [
              3341.954,
              -2292.861,
              2683.03
            ],
            [
              3369.017,
              -2299.382,
              2710.868
            ],
            [
              3397.349,
              -2301.032,
              2739.248
            ],
            [
              3430.9,
              -2299.443,
              2772.837
            ],
            [
              3478.067,
              -2293.658,
              2820.357
            ],
            [
              3484.236,
              -2308.248,
              2836.198
            ],
            [
              3493.838,
              -2318.189,
              2850.019
            ],
            [
              3501.632,
              -2321.016,
              2858.31
            ],
            [
              3511.041,
              -2322.823,
              2867.891
            ],
            [
              3520.089,
              -2321.175,
              2877.088
            ],
            [
              3550.396,
              -2320.637,
              2907.399
            ],
            [
              3610.299,
              -2326.915,
              2967.631
            ],
            [
              3749.947,
              -2348.687,
              3108.966
            ],
            [
              3826.638,
              -2342.488,
              3185.906
            ],
            [
              3880.671,
              -2342.483,
              3239.939
            ],
            [
              3899.892,
              -2348.445,
              3260.064
            ],
            [
              3964.658,
              -2390.015,
              3337.023
            ],
            [
              4005.181,
              -2426.318,
              3391.429
            ],
            [
              4020.144,
              -2445.95,
              3416.113
            ],
            [
              4040.888,
              -2492.522,
              3467.096
            ],
            [
              4043.21,
              -2505.925,
              3480.699
            ],
            [
              4042.848,
              -2524.844,
              3499.621
            ],
            [
              4028.232,
              -2581.341,
              3557.978
            ],
            [
              4029.2,
              -2614.614,
              3591.265
            ],
            [
              4036.551,
              -2628.85,
              3607.287
            ],
            [
              4048.304,
              -2644.068,
              3626.515
            ],
            [
              4085.128,
              -2679.035,
              3677.296
            ],
            [
              4090.171,
              -2679.379,
              3682.351
            ],
            [
              4122.851,
              -2695.319,
              3718.711
            ],
            [
              4140.69,
              -2700.385,
              3737.256
            ],
            [
              4203.083,
              -2707.145,
              3800.014
            ],
            [
              4239.365,
              -2704.002,
              3836.431
            ],
            [
              4462.339,
              -2838.279,
              4096.715
            ],
            [
              4653.136,
              -2974.321,
              4331.046
            ],
            [
              4716.286,
              -2895.266,
              4432.228
            ],
            [
              4795.934,
              -2793.714,
              4561.288
            ],
            [
              4892.464,
              -2692.176,
              4701.388
            ],
            [
              4967.993,
              -2619.483,
              4806.216
            ],
            [
              5030.163,
              -2544.094,
              4903.933
            ],
            [
              5039.94,
              -2530.23,
              4920.898
            ],
            [
              5087.168,
              -2472.685,
              4995.342
            ],
            [
              5098.562,
              -2448.281,
              5022.274
            ],
            [
              5101.164,
              -2397.131,
              5073.491
            ],
            [
              5134.955,
              -2316.516,
              5160.901
            ],
            [
              5141.854,
              -2226.475,
              5251.206
            ],
            [
              5140.376,
              -2204.068,
              5273.662
            ],
            [
              5135.506,
              -2180.194,
              5298.028
            ],
            [
              5085.52,
              -2039.469,
              5447.366
            ],
            [
              5074.329,
              -2018.1,
              5471.488
            ],
            [
              5052.205,
              -1995.407,
              5503.181
            ],
            [
              5019.081,
              -1974.728,
              5542.23
            ],
            [
              4991.135,
              -1953.035,
              5577.608
            ],
            [
              4976.206,
              -1924.915,
              5609.445
            ],
            [
              4965.198,
              -1895.991,
              5640.393
            ],
            [
              4936.143,
              -1829.514,
              5712.942
            ],
            [
              4897.969,
              -1736.375,
              5813.601
            ],
            [
              4895.703,
              -1723.496,
              5826.677
            ],
            [
              4902.209,
              -1720.019,
              5834.054
            ],
            [
              4919.363,
              -1738.068,
              5858.954
            ],
            [
              4969.344,
              -1773.655,
              5920.309
            ],
            [
              5116.156,
              -1822.929,
              6075.17
            ],
            [
              5175.8,
              -1837.452,
              6136.557
            ],
            [
              5211.646,
              -1837.279,
              6172.403
            ],
            [
              5242.462,
              -1833.174,
              6203.491
            ],
            [
              5277.025,
              -1818.087,
              6241.203
            ],
            [
              5291.457,
              -1804.888,
              6260.761
            ],
            [
              5296.439,
              -1800.256,
              6267.564
            ],
            [
              5314.14,
              -1782.192,
              6292.855
            ],
            [
              5333.177,
              -1768.174,
              6316.496
            ],
            [
              5375.85,
              -1761.323,
              6359.716
            ],
            [
              5407.956,
              -1768.511,
              6392.616
            ],
            [
              5456.996,
              -1799.522,
              6450.638
            ],
            [
              5534.694,
              -1852.106,
              6544.458
            ],
            [
              5537.558,
              -1853.811,
              6547.791
            ],
            [
              5540.862,
              -1855.777,
              6551.636
            ],
            [
              5534.098,
              -1851.751,
              6559.507
            ],
            [
              5525.45,
              -1846.603,
              6569.571
            ],
            [
              5520.213,
              -1843.486,
              6575.666
            ],
            [
              5517.93,
              -1842.12,
              6578.326
            ],
            [
              5520.295,
              -1843.535,
              6581.082
            ],
            [
              5535.27,
              -1852.254,
              6598.411
            ],
            [
              5666.371,
              -1928.539,
              6750.091
            ],
            [
              5726.051,
              -1974.255,
              6825.269
            ],
            [
              5809.685,
              -2023.753,
              6922.452
            ],
            [
              5909.138,
              -2053.247,
              7026.187
            ],
            [
              5956.254,
              -2052.798,
              7073.305
            ],
            [
              6035.821,
              -2044.677,
              7153.285
            ],
            [
              6104.633,
              -2042.301,
              7222.138
            ],
            [
              6231.263,
              -2064.001,
              7350.614
            ],
            [
              6263.68,
              -2069.175,
              7383.442
            ],
            [
              6454.692,
              -2110.689,
              7578.913
            ],
            [
              6496.176,
              -2125.975,
              7623.123
            ],
            [
              6571.996,
              -2164.859,
              7708.332
            ],
            [
              6605.969,
              -2185.766,
              7748.224
            ],
            [
              6713.842,
              -2261.998,
              7880.314
            ],
            [
              6732.16,
              -2275.807,
              7903.254
            ],
            [
              6746.774,
              -2281.408,
              7918.905
            ],
            [
              6792.085,
              -2286.888,
              7964.546
            ],
            [
              6898.699,
              -2276.521,
              8071.662
            ],
            [
              6977.94,
              -2266.207,
              8151.572
            ],
            [
              7198.611,
              -2242.259,
              8373.538
            ],
            [
              7327.255,
              -2227.56,
              8503.02
            ],
            [
              7368.171,
              -2217.793,
              8545.085
            ],
            [
              7380.924,
              -1988.705,
              8774.527
            ],
            [
              7380.876,
              -1967.601,
              8795.631
            ],
            [
              7375.532,
              -1966.336,
              8801.123
            ],
            [
              7367.845,
              -1961.139,
              8810.402
            ],
            [
              7373.958,
              -1939.977,
              8832.428
            ],
            [
              7384.694,
              -1928.662,
              8848.026
            ],
            [
              7401.508,
              -1666.26,
              9110.966
            ],
            [
              7407.106,
              -1638.245,
              9139.535
            ],
            [
              7455.939,
              -1618.206,
              9192.319
            ],
            [
              7562.108,
              -1578.835,
              9305.554
            ],
            [
              7873.067,
              -1462.189,
              9637.671
            ],
            [
              7886.048,
              -1453.766,
              9653.145
            ],
            [
              7894.644,
              -1444.512,
              9665.776
            ],
            [
              7938.338,
              -1355.208,
              9765.196
            ],
            [
              7869.87,
              -1276.824,
              9869.272
            ],
            [
              7850.622,
              -1250.722,
              9901.704
            ],
            [
              7830.876,
              -1215.015,
              9942.507
            ],
            [
              7805.738,
              -1143.988,
              10017.851
            ],
            [
              7791.221,
              -1101.783,
              10062.483
            ],
            [
              7779.053,
              -1076.908,
              10090.175
            ],
            [
              7761.946,
              -1049.988,
              10122.07
            ],
            [
              7720.825,
              -1010.204,
              10179.287
            ],
            [
              7689.684,
              -987.318,
              10217.933
            ],
            [
              7657.987,
              -959.968,
              10259.798
            ],
            [
              7648.028,
              -941.957,
              10280.379
            ],
            [
              7642.025,
              -919.572,
              10303.555
            ],
            [
              7643.176,
              -861.704,
              10361.435
            ],
            [
              7643.14,
              -841.77,
              10381.369
            ],
            [
              7644.596,
              -822.767,
              10400.428
            ],
            [
              7675.302,
              -640.799,
              10584.968
            ],
            [
              7843.017,
              -670.859,
              10755.356
            ],
            [
              7940.902,
              -687.034,
              10854.568
            ],
            [
              7983.745,
              -695.934,
              10898.326
            ],
            [
              8105.956,
              -711.736,
              11021.554
            ],
            [
              8174.886,
              -715.341,
              11090.578
            ],
            [
              8196.247,
              -711.316,
              11112.315
            ],
            [
              8219.654,
              -701.765,
              11137.596
            ],
            [
              8291.234,
              -637.515,
              11233.782
            ],
            [
              8322.689,
              -612.539,
              11273.947
            ],
            [
              8367.171,
              -581.146,
              11328.391
            ],
            [
              8434.632,
              -625.918,
              11409.357
            ],
            [
              8481.22,
              -650.233,
              11461.909
            ],
            [
              8531.721,
              -672.4,
              11517.06
            ],
            [
              8541.441,
              -631.817,
              11558.791
            ],
            [
              8559.188,
              -557.169,
              11635.52
            ],
            [
              8576.654,
              -426.152,
              11767.696
            ],
            [
              8584.228,
              -306.068,
              11888.019
            ],
            [
              8588.332,
              -198.161,
              11996.004
            ],
            [
              8595.54,
              -160.454,
              12034.393
            ],
            [
              8696.309,
              -134.44,
              12138.466
            ],
            [
              8720.235,
              -127.625,
              12163.344
            ],
            [
              8744.3,
              -121.003,
              12188.303
            ],
            [
              8789.403,
              -109.804,
              12234.776
            ],
            [
              8826.448,
              -96.087,
              12274.279
            ],
            [
              8853.145,
              -83.257,
              12303.899
            ],
            [
              8900.484,
              -38.566,
              12369.001
            ],
            [
              8997.947,
              60.777,
              12508.17
            ],
            [
              9045.087,
              95.45,
              12566.688
            ],
            [
              9064.009,
              106.201,
              12588.451
            ],
            [
              9090.691,
              117.908,
              12617.588
            ],
            [
              9117.305,
              128.24,
              12646.138
            ],
            [
              9141.918,
              131.345,
              12670.946
            ],
            [
              9732.973,
              138.29,
              13262.042
            ],
            [
              9768.99,
              137.546,
              13298.066
            ],
            [
              9787.111,
              140.517,
              13316.429
            ],
            [
              9775.961,
              226.468,
              13403.1
            ],
            [
              9750.774,
              351.671,
              13530.812
            ],
            [
              9712.666,
              440.791,
              13627.737
            ],
            [
              9684.641,
              490.432,
              13684.743
            ],
            [
              9609.069,
              583.893,
              13804.935
            ],
            [
              9546.296,
              637.493,
              13887.478
            ],
            [
              9473.758,
              686.837,
              13975.208
            ],
            [
              9388.742,
              725.301,
              14068.521
            ],
            [
              9331.068,
              744.282,
              14129.238
            ],
            [
              9277.061,
              753.169,
              14183.971
            ],
            [
              9213.935,
              757.787,
              14247.266
            ],
            [
              9179.167,
              758.013,
              14282.034
            ],
            [
              9140.755,
              760.17,
              14320.507
            ],
            [
              9063.917,
              764.897,
              14397.49
            ],
            [
              9023.333,
              767.16,
              14438.137
            ],
            [
              8994.829,
              768.49,
              14466.672
            ],
            [
              8994.917,
              773.347,
              14471.531
            ],
            [
              9023.312,
              773.887,
              14499.931
            ],
            [
              9172.074,
              765.272,
              14648.942
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:5483",
              "position": {
                "x": 2562.319,
                "z": -3823.788
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 3.832,
              "arrivalOffsetSeconds": -420,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:5118",
              "position": {
                "x": 2463.001,
                "z": -3519.117
              },
              "distanceAlongShapeM": 699.593,
              "shapeOffsetM": 4.589,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:5119",
              "position": {
                "x": 2425.512,
                "z": -3284.63
              },
              "distanceAlongShapeM": 936.783,
              "shapeOffsetM": 5.384,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:6723",
              "position": {
                "x": 2444.816,
                "z": -2599.227
              },
              "distanceAlongShapeM": 1712.308,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:11047",
              "position": {
                "x": 2826.856,
                "z": -2438.309
              },
              "distanceAlongShapeM": 2130.268,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:4520",
              "position": {
                "x": 3336.988,
                "z": -2288.755
              },
              "distanceAlongShapeM": 2677.389,
              "shapeOffsetM": 3.114,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:9756",
              "position": {
                "x": 4203.083,
                "z": -2707.145
              },
              "distanceAlongShapeM": 3800.014,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:9612",
              "position": {
                "x": 4464.241,
                "z": -2835.727
              },
              "distanceAlongShapeM": 4096.783,
              "shapeOffsetM": 3.182,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:9675",
              "position": {
                "x": 4793.805,
                "z": -2791.972
              },
              "distanceAlongShapeM": 4561.288,
              "shapeOffsetM": 2.751,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:9968",
              "position": {
                "x": 5036.12,
                "z": -2527.239
              },
              "distanceAlongShapeM": 4920.898,
              "shapeOffsetM": 4.852,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:9609",
              "position": {
                "x": 5140.178,
                "z": -2246.481
              },
              "distanceAlongShapeM": 5231.131,
              "shapeOffsetM": 0.143,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            },
            {
              "stopId": "judu:stop:6888",
              "position": {
                "x": 5512.692,
                "z": -1852.928
              },
              "distanceAlongShapeM": 6577.275,
              "shapeOffsetM": 11.964,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:10319",
              "position": {
                "x": 5956.225,
                "z": -2051.94
              },
              "distanceAlongShapeM": 7073.363,
              "shapeOffsetM": 0.857,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:9606",
              "position": {
                "x": 6264.085,
                "z": -2066.871
              },
              "distanceAlongShapeM": 7383.442,
              "shapeOffsetM": 2.339,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:10531",
              "position": {
                "x": 6607.328,
                "z": -2183.827
              },
              "distanceAlongShapeM": 7748.224,
              "shapeOffsetM": 2.368,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            },
            {
              "stopId": "judu:stop:9604",
              "position": {
                "x": 6977.721,
                "z": -2263.494
              },
              "distanceAlongShapeM": 8151.647,
              "shapeOffsetM": 2.72,
              "arrivalOffsetSeconds": 1380,
              "departureOffsetSeconds": 1380
            },
            {
              "stopId": "judu:stop:14663",
              "position": {
                "x": 7198.611,
                "z": -2242.259
              },
              "distanceAlongShapeM": 8373.538,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            },
            {
              "stopId": "judu:stop:548",
              "position": {
                "x": 7367.276,
                "z": -1961.715
              },
              "distanceAlongShapeM": 8810.402,
              "shapeOffsetM": 0.81,
              "arrivalOffsetSeconds": 1500,
              "departureOffsetSeconds": 1500
            },
            {
              "stopId": "judu:stop:6218",
              "position": {
                "x": 7454.75,
                "z": -1614.993
              },
              "distanceAlongShapeM": 9192.322,
              "shapeOffsetM": 3.426,
              "arrivalOffsetSeconds": 1620,
              "departureOffsetSeconds": 1620
            },
            {
              "stopId": "judu:stop:6217",
              "position": {
                "x": 7918.757,
                "z": -1334.778
              },
              "distanceAlongShapeM": 9793.464,
              "shapeOffsetM": 1.307,
              "arrivalOffsetSeconds": 1680,
              "departureOffsetSeconds": 1680
            },
            {
              "stopId": "judu:stop:5394",
              "position": {
                "x": 7639.707,
                "z": -841.596
              },
              "distanceAlongShapeM": 10381.369,
              "shapeOffsetM": 3.437,
              "arrivalOffsetSeconds": 1800,
              "departureOffsetSeconds": 1800
            },
            {
              "stopId": "judu:stop:5396",
              "position": {
                "x": 7941.422,
                "z": -683.956
              },
              "distanceAlongShapeM": 10854.568,
              "shapeOffsetM": 3.122,
              "arrivalOffsetSeconds": 1860,
              "departureOffsetSeconds": 1860
            },
            {
              "stopId": "judu:stop:6225",
              "position": {
                "x": 8539.64,
                "z": -631.367
              },
              "distanceAlongShapeM": 11558.812,
              "shapeOffsetM": 1.856,
              "arrivalOffsetSeconds": 1980,
              "departureOffsetSeconds": 1980
            },
            {
              "stopId": "judu:stop:6040",
              "position": {
                "x": 8718.239,
                "z": -120.617
              },
              "distanceAlongShapeM": 12163.344,
              "shapeOffsetM": 7.287,
              "arrivalOffsetSeconds": 2160,
              "departureOffsetSeconds": 2160
            },
            {
              "stopId": "judu:stop:6042",
              "position": {
                "x": 9116.151,
                "z": 132.979
              },
              "distanceAlongShapeM": 12646.138,
              "shapeOffsetM": 4.877,
              "arrivalOffsetSeconds": 2220,
              "departureOffsetSeconds": 2220
            },
            {
              "stopId": "judu:stop:6044",
              "position": {
                "x": 9552.934,
                "z": 138.6
              },
              "distanceAlongShapeM": 13082.019,
              "shapeOffsetM": 2.425,
              "arrivalOffsetSeconds": 2280,
              "departureOffsetSeconds": 2280
            },
            {
              "stopId": "judu:stop:7444",
              "position": {
                "x": 9732.975,
                "z": 142.732
              },
              "distanceAlongShapeM": 13262.042,
              "shapeOffsetM": 4.442,
              "arrivalOffsetSeconds": 2340,
              "departureOffsetSeconds": 2340
            },
            {
              "stopId": "judu:stop:17007",
              "position": {
                "x": 9681.966,
                "z": 488.893
              },
              "distanceAlongShapeM": 13685.228,
              "shapeOffsetM": 3.047,
              "arrivalOffsetSeconds": 2400,
              "departureOffsetSeconds": 2400
            },
            {
              "stopId": "judu:stop:16454",
              "position": {
                "x": 9179.069,
                "z": 756.266
              },
              "distanceAlongShapeM": 14282.034,
              "shapeOffsetM": 1.75,
              "arrivalOffsetSeconds": 2520,
              "departureOffsetSeconds": 2520
            },
            {
              "stopId": "judu:stop:16453",
              "position": {
                "x": 9172.201,
                "z": 767.538
              },
              "distanceAlongShapeM": 14648.938,
              "shapeOffsetM": 2.269,
              "arrivalOffsetSeconds": 2580,
              "departureOffsetSeconds": 2580
            }
          ],
          "departuresSeconds": [
            17520,
            19500,
            20940,
            22020,
            23040,
            23880,
            25320,
            26940,
            27840,
            29280,
            32100,
            34140,
            36240,
            37740,
            40020,
            42060,
            43500,
            45780,
            48060,
            49680,
            51720,
            53640,
            54600,
            55560,
            56700,
            58020,
            59580,
            61260,
            63360,
            64920,
            66900,
            68700,
            71580,
            73860,
            76140,
            78540,
            81000
          ]
        },
        {
          "id": "judu:pattern:vilnius_bus_115:1",
          "sourceRouteId": "vilnius_bus_115",
          "sourceShapeId": "vilnius_bus_115_b-a",
          "directionId": 1,
          "headsign": "Antakalnis",
          "directionName": "Linksmoji–Parko g.–Rokantiškės–Antakalnis",
          "mode": "bus",
          "routeShortName": "115",
          "routeLongName": "Antakalnis–Rokantiškės–Parko–Linksmoji g.",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              9172.074,
              765.272,
              0
            ],
            [
              9194.013,
              761.53,
              22.256
            ],
            [
              9297.028,
              751.652,
              125.744
            ],
            [
              9354.837,
              739.348,
              184.847
            ],
            [
              9475.025,
              685.698,
              316.466
            ],
            [
              9548.875,
              637.441,
              404.685
            ],
            [
              9650.145,
              541.866,
              543.934
            ],
            [
              9694.397,
              487.212,
              614.257
            ],
            [
              9750.91,
              358.348,
              754.968
            ],
            [
              9760.037,
              331.443,
              783.379
            ],
            [
              9774.016,
              257.68,
              858.454
            ],
            [
              9785.97,
              179.506,
              937.537
            ],
            [
              9786.285,
              131.627,
              985.417
            ],
            [
              9682.329,
              129.236,
              1089.401
            ],
            [
              9621.808,
              131.634,
              1149.969
            ],
            [
              9517.36,
              133.756,
              1254.439
            ],
            [
              9448.882,
              128.466,
              1323.121
            ],
            [
              9389.611,
              131.895,
              1382.491
            ],
            [
              9156.08,
              129.945,
              1616.03
            ],
            [
              9090.691,
              117.908,
              1682.518
            ],
            [
              9071.372,
              103.392,
              1706.682
            ],
            [
              9049.578,
              94.246,
              1730.318
            ],
            [
              8990.008,
              50.917,
              1803.979
            ],
            [
              8869.532,
              -70.228,
              1974.831
            ],
            [
              8853.145,
              -83.257,
              1995.767
            ],
            [
              8819.883,
              -101.512,
              2033.709
            ],
            [
              8767.948,
              -118.279,
              2088.283
            ],
            [
              8695.316,
              -137.969,
              2163.537
            ],
            [
              8672.646,
              -150.383,
              2189.384
            ],
            [
              8624.533,
              -154.886,
              2237.706
            ],
            [
              8595.54,
              -160.454,
              2267.229
            ],
            [
              8590.933,
              -197.1,
              2304.164
            ],
            [
              8584.694,
              -314.984,
              2422.213
            ],
            [
              8567.281,
              -539.519,
              2647.422
            ],
            [
              8554.112,
              -617.185,
              2726.197
            ],
            [
              8531.721,
              -672.4,
              2785.779
            ],
            [
              8487.656,
              -660.31,
              2831.473
            ],
            [
              8367.171,
              -581.146,
              2975.638
            ],
            [
              8316.776,
              -617.987,
              3038.063
            ],
            [
              8223.611,
              -697.391,
              3160.475
            ],
            [
              8208.584,
              -707.11,
              3178.371
            ],
            [
              8186.511,
              -714.461,
              3201.636
            ],
            [
              8174.886,
              -715.341,
              3213.294
            ],
            [
              8111.113,
              -711.839,
              3277.163
            ],
            [
              7990.769,
              -699.414,
              3398.147
            ],
            [
              7876.325,
              -682.607,
              3513.819
            ],
            [
              7825.635,
              -669.399,
              3566.201
            ],
            [
              7675.302,
              -640.799,
              3719.23
            ],
            [
              7649.128,
              -789.458,
              3870.176
            ],
            [
              7642.645,
              -888.412,
              3969.342
            ],
            [
              7646.227,
              -935.241,
              4016.308
            ],
            [
              7655.475,
              -956.578,
              4039.563
            ],
            [
              7745.125,
              -1028.985,
              4154.801
            ],
            [
              7766.347,
              -1055.642,
              4188.874
            ],
            [
              7788.775,
              -1095.054,
              4234.221
            ],
            [
              7822.274,
              -1193.691,
              4338.391
            ],
            [
              7847.723,
              -1243.184,
              4394.044
            ],
            [
              7892.309,
              -1303.078,
              4468.711
            ],
            [
              7925.18,
              -1336.019,
              4515.247
            ],
            [
              7938.338,
              -1355.208,
              4538.514
            ],
            [
              7925.962,
              -1377.884,
              4564.347
            ],
            [
              7904.108,
              -1430.751,
              4621.554
            ],
            [
              7894.93,
              -1446.052,
              4639.396
            ],
            [
              7884.732,
              -1456.56,
              4654.039
            ],
            [
              7863.158,
              -1468.215,
              4678.56
            ],
            [
              7407.106,
              -1638.245,
              5165.277
            ],
            [
              7402.863,
              -1662.947,
              5190.341
            ],
            [
              7383.829,
              -1939.778,
              5467.826
            ],
            [
              7381.872,
              -1978.643,
              5506.74
            ],
            [
              7368.171,
              -2217.793,
              5746.282
            ],
            [
              7285.057,
              -2234.972,
              5831.152
            ],
            [
              6885.062,
              -2277.86,
              6233.44
            ],
            [
              6758.788,
              -2283.666,
              6359.847
            ],
            [
              6733.788,
              -2276.493,
              6385.856
            ],
            [
              6602.353,
              -2186.712,
              6545.028
            ],
            [
              6584.271,
              -2175.613,
              6566.245
            ],
            [
              6542.211,
              -2151.374,
              6614.789
            ],
            [
              6503.317,
              -2129.457,
              6659.434
            ],
            [
              6436.091,
              -2105.871,
              6730.677
            ],
            [
              6181.107,
              -2057.452,
              6990.218
            ],
            [
              6111.071,
              -2045.984,
              7061.186
            ],
            [
              6042.053,
              -2046.841,
              7130.21
            ],
            [
              5963.805,
              -2055.375,
              7208.922
            ],
            [
              5942.067,
              -2053.103,
              7230.778
            ],
            [
              5884.65,
              -2052.769,
              7288.196
            ],
            [
              5829.247,
              -2034.064,
              7346.671
            ],
            [
              5764.388,
              -2004.779,
              7417.835
            ],
            [
              5745.315,
              -1991.048,
              7441.337
            ],
            [
              5727.728,
              -1979.687,
              7462.274
            ],
            [
              5697.118,
              -1950.031,
              7504.894
            ],
            [
              5679.465,
              -1938.293,
              7526.093
            ],
            [
              5634.824,
              -1906.866,
              7580.687
            ],
            [
              5590.731,
              -1884.504,
              7630.126
            ],
            [
              5512.372,
              -1836.223,
              7722.165
            ],
            [
              5505.455,
              -1827.28,
              7733.471
            ],
            [
              5497.693,
              -1827.072,
              7741.236
            ],
            [
              5504.996,
              -1834.483,
              7751.64
            ],
            [
              5505.467,
              -1834.824,
              7752.222
            ],
            [
              5515.946,
              -1841.083,
              7764.429
            ],
            [
              5523.99,
              -1845.734,
              7773.72
            ],
            [
              5527.857,
              -1848.036,
              7778.221
            ],
            [
              5518.81,
              -1842.65,
              7788.75
            ],
            [
              5513.855,
              -1839.989,
              7794.374
            ],
            [
              5509.1,
              -1834.284,
              7801.801
            ],
            [
              5474.159,
              -1812.101,
              7843.189
            ],
            [
              5450.717,
              -1793.054,
              7873.394
            ],
            [
              5414.64,
              -1769.624,
              7916.411
            ],
            [
              5375.85,
              -1761.323,
              7956.079
            ],
            [
              5341.609,
              -1764.046,
              7990.429
            ],
            [
              5319.039,
              -1774.781,
              8015.421
            ],
            [
              5272.851,
              -1820.441,
              8080.369
            ],
            [
              5263.076,
              -1825.818,
              8091.525
            ],
            [
              5249.336,
              -1831.836,
              8106.526
            ],
            [
              5225.317,
              -1836.107,
              8130.921
            ],
            [
              5188.082,
              -1836.611,
              8168.16
            ],
            [
              5153.346,
              -1832.599,
              8203.126
            ],
            [
              4972.87,
              -1775.087,
              8392.544
            ],
            [
              4963.029,
              -1771.09,
              8403.167
            ],
            [
              4949.033,
              -1762.966,
              8419.349
            ],
            [
              4916.633,
              -1735.195,
              8462.022
            ],
            [
              4895.703,
              -1723.496,
              8486
            ],
            [
              4894.317,
              -1725.172,
              8488.175
            ],
            [
              4917.69,
              -1783.513,
              8551.023
            ],
            [
              4983.058,
              -1937.294,
              8718.121
            ],
            [
              4991.178,
              -1950.81,
              8733.888
            ],
            [
              5006.988,
              -1966.701,
              8756.305
            ],
            [
              5059.903,
              -2004.327,
              8821.233
            ],
            [
              5072.439,
              -2015.837,
              8838.252
            ],
            [
              5086.057,
              -2045.045,
              8870.478
            ],
            [
              5138.076,
              -2188.551,
              9023.122
            ],
            [
              5142.221,
              -2207.556,
              9042.573
            ],
            [
              5141.833,
              -2227.588,
              9062.609
            ],
            [
              5143.382,
              -2238.522,
              9073.653
            ],
            [
              5137.92,
              -2296.535,
              9131.922
            ],
            [
              5132.226,
              -2324.256,
              9160.221
            ],
            [
              5107.973,
              -2378.337,
              9219.492
            ],
            [
              5099.037,
              -2407.11,
              9249.62
            ],
            [
              5098.68,
              -2446.038,
              9288.55
            ],
            [
              5083.926,
              -2477.626,
              9323.414
            ],
            [
              5065.263,
              -2500.89,
              9353.238
            ],
            [
              4994.545,
              -2588.946,
              9466.177
            ],
            [
              4940.996,
              -2646.426,
              9544.735
            ],
            [
              4795.637,
              -2795.42,
              9752.889
            ],
            [
              4746.598,
              -2857.451,
              9831.963
            ],
            [
              4653.136,
              -2974.321,
              9981.609
            ],
            [
              4431.946,
              -2818.217,
              10252.337
            ],
            [
              4425.343,
              -2813.545,
              10260.425
            ],
            [
              4249.47,
              -2707.712,
              10465.686
            ],
            [
              4239.892,
              -2704.146,
              10475.906
            ],
            [
              4206.787,
              -2708.54,
              10509.302
            ],
            [
              4148.98,
              -2702.818,
              10567.392
            ],
            [
              4084.856,
              -2678.911,
              10635.827
            ],
            [
              4052.961,
              -2675.405,
              10667.914
            ],
            [
              4056.942,
              -2664.271,
              10679.739
            ],
            [
              4061.828,
              -2657.106,
              10688.411
            ],
            [
              4039.203,
              -2633.178,
              10721.342
            ],
            [
              4030.752,
              -2618.127,
              10738.604
            ],
            [
              4028.009,
              -2599.197,
              10757.731
            ],
            [
              4031.022,
              -2570.262,
              10786.823
            ],
            [
              4042.933,
              -2520.392,
              10838.096
            ],
            [
              4043.189,
              -2507.038,
              10851.452
            ],
            [
              4039.684,
              -2488.046,
              10870.765
            ],
            [
              4014.544,
              -2437.742,
              10927
            ],
            [
              3997.186,
              -2418.211,
              10953.131
            ],
            [
              3943.887,
              -2373.776,
              11022.523
            ],
            [
              3899.892,
              -2348.445,
              11073.289
            ],
            [
              3872.886,
              -2342.23,
              11101.001
            ],
            [
              3841.232,
              -2343.636,
              11132.686
            ],
            [
              3772.828,
              -2349.248,
              11201.32
            ],
            [
              3727.384,
              -2346.536,
              11246.845
            ],
            [
              3642.944,
              -2333.772,
              11332.245
            ],
            [
              3598.81,
              -2324.726,
              11377.296
            ],
            [
              3525.562,
              -2322.752,
              11450.57
            ],
            [
              3503.288,
              -2321.468,
              11472.881
            ],
            [
              3483.591,
              -2308.236,
              11496.61
            ],
            [
              3478.067,
              -2293.658,
              11512.2
            ],
            [
              3430.234,
              -2300.543,
              11560.526
            ],
            [
              3387.662,
              -2301.962,
              11603.121
            ],
            [
              3196.764,
              -2272.74,
              11796.243
            ],
            [
              3157.806,
              -2287.589,
              11837.935
            ],
            [
              3002.929,
              -2364.816,
              12010.998
            ],
            [
              2811.307,
              -2442.469,
              12217.757
            ],
            [
              2719.174,
              -2508.643,
              12331.192
            ],
            [
              2680.157,
              -2526.834,
              12374.241
            ],
            [
              2599.153,
              -2549.802,
              12458.438
            ],
            [
              2457.059,
              -2599.457,
              12608.958
            ],
            [
              2382.154,
              -2627.435,
              12688.918
            ],
            [
              2328.687,
              -2639.354,
              12743.697
            ],
            [
              2411.872,
              -3118.499,
              13230.009
            ],
            [
              2415.738,
              -3139.252,
              13251.119
            ],
            [
              2418.768,
              -3163.158,
              13275.217
            ],
            [
              2474.472,
              -3526.012,
              13642.322
            ],
            [
              2513.109,
              -3664.781,
              13786.369
            ],
            [
              2520.474,
              -3683.355,
              13806.35
            ],
            [
              2553.555,
              -3775.753,
              13904.491
            ],
            [
              2558.505,
              -3824.161,
              13953.152
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:16453",
              "position": {
                "x": 9172.201,
                "z": 767.538
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 2.269,
              "arrivalOffsetSeconds": -540,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:17009",
              "position": {
                "x": 9696.796,
                "z": 488.592
              },
              "distanceAlongShapeM": 614.257,
              "shapeOffsetM": 2.768,
              "arrivalOffsetSeconds": 60,
              "departureOffsetSeconds": 60
            },
            {
              "stopId": "judu:stop:6073",
              "position": {
                "x": 9682.346,
                "z": 127.063
              },
              "distanceAlongShapeM": 1089.401,
              "shapeOffsetM": 2.173,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:6045",
              "position": {
                "x": 9448.882,
                "z": 128.466
              },
              "distanceAlongShapeM": 1323.121,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:6043",
              "position": {
                "x": 9073.545,
                "z": 99.328
              },
              "distanceAlongShapeM": 1706.682,
              "shapeOffsetM": 4.609,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:6041",
              "position": {
                "x": 8673.105,
                "z": -151.995
              },
              "distanceAlongShapeM": 2189.384,
              "shapeOffsetM": 1.676,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:5400",
              "position": {
                "x": 8486.109,
                "z": -663.69
              },
              "distanceAlongShapeM": 2831.473,
              "shapeOffsetM": 3.717,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:5415",
              "position": {
                "x": 7876.316,
                "z": -682.656
              },
              "distanceAlongShapeM": 3513.819,
              "shapeOffsetM": 0.05,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:6230",
              "position": {
                "x": 7745.609,
                "z": -1028.51
              },
              "distanceAlongShapeM": 4154.801,
              "shapeOffsetM": 0.678,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:6216",
              "position": {
                "x": 7930.115,
                "z": -1379.536
              },
              "distanceAlongShapeM": 4563.808,
              "shapeOffsetM": 4.437,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:6219",
              "position": {
                "x": 7487.751,
                "z": -1608.969
              },
              "distanceAlongShapeM": 5079.486,
              "shapeOffsetM": 0.741,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            },
            {
              "stopId": "judu:stop:6221",
              "position": {
                "x": 7384.989,
                "z": -1978.766
              },
              "distanceAlongShapeM": 5506.706,
              "shapeOffsetM": 3.119,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:10612",
              "position": {
                "x": 7285.671,
                "z": -2240.645
              },
              "distanceAlongShapeM": 5831.152,
              "shapeOffsetM": 5.706,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:9605",
              "position": {
                "x": 6885.221,
                "z": -2279.48
              },
              "distanceAlongShapeM": 6233.44,
              "shapeOffsetM": 1.628,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:10530",
              "position": {
                "x": 6582.95,
                "z": -2177.781
              },
              "distanceAlongShapeM": 6566.307,
              "shapeOffsetM": 2.538,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:9607",
              "position": {
                "x": 6326.245,
                "z": -2085.902
              },
              "distanceAlongShapeM": 6842.32,
              "shapeOffsetM": 0.874,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:10317",
              "position": {
                "x": 5963.871,
                "z": -2056.543
              },
              "distanceAlongShapeM": 7208.922,
              "shapeOffsetM": 1.17,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            },
            {
              "stopId": "judu:stop:6888",
              "position": {
                "x": 5512.692,
                "z": -1852.928
              },
              "distanceAlongShapeM": 7767.54,
              "shapeOffsetM": 11.883,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            },
            {
              "stopId": "judu:stop:9608",
              "position": {
                "x": 5148.706,
                "z": -2238.854
              },
              "distanceAlongShapeM": 9073.653,
              "shapeOffsetM": 5.334,
              "arrivalOffsetSeconds": 1560,
              "departureOffsetSeconds": 1560
            },
            {
              "stopId": "judu:stop:9969",
              "position": {
                "x": 5089.862,
                "z": -2481.521
              },
              "distanceAlongShapeM": 9323.414,
              "shapeOffsetM": 7.1,
              "arrivalOffsetSeconds": 1620,
              "departureOffsetSeconds": 1620
            },
            {
              "stopId": "judu:stop:9676",
              "position": {
                "x": 4754.396,
                "z": -2863.575
              },
              "distanceAlongShapeM": 9831.932,
              "shapeOffsetM": 9.915,
              "arrivalOffsetSeconds": 1680,
              "departureOffsetSeconds": 1680
            },
            {
              "stopId": "judu:stop:9613",
              "position": {
                "x": 4422.037,
                "z": -2818.217
              },
              "distanceAlongShapeM": 10260.849,
              "shapeOffsetM": 5.708,
              "arrivalOffsetSeconds": 1800,
              "departureOffsetSeconds": 1800
            },
            {
              "stopId": "judu:stop:9755",
              "position": {
                "x": 4148.315,
                "z": -2706.097
              },
              "distanceAlongShapeM": 10567.392,
              "shapeOffsetM": 3.346,
              "arrivalOffsetSeconds": 1860,
              "departureOffsetSeconds": 1860
            },
            {
              "stopId": "judu:stop:4521",
              "position": {
                "x": 3280.303,
                "z": -2286.568
              },
              "distanceAlongShapeM": 11711.574,
              "shapeOffsetM": 1.028,
              "arrivalOffsetSeconds": 1980,
              "departureOffsetSeconds": 1980
            },
            {
              "stopId": "judu:stop:11046",
              "position": {
                "x": 2680.157,
                "z": -2526.834
              },
              "distanceAlongShapeM": 12374.241,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2040,
              "departureOffsetSeconds": 2040
            },
            {
              "stopId": "judu:stop:6720",
              "position": {
                "x": 2382.396,
                "z": -2628.114
              },
              "distanceAlongShapeM": 12688.918,
              "shapeOffsetM": 0.721,
              "arrivalOffsetSeconds": 2100,
              "departureOffsetSeconds": 2100
            },
            {
              "stopId": "judu:stop:1035",
              "position": {
                "x": 2419.872,
                "z": -3138.687
              },
              "distanceAlongShapeM": 13251.119,
              "shapeOffsetM": 4.173,
              "arrivalOffsetSeconds": 2220,
              "departureOffsetSeconds": 2220
            },
            {
              "stopId": "judu:stop:6711",
              "position": {
                "x": 2522.438,
                "z": -3682.768
              },
              "distanceAlongShapeM": 13806.459,
              "shapeOffsetM": 2.047,
              "arrivalOffsetSeconds": 2340,
              "departureOffsetSeconds": 2340
            },
            {
              "stopId": "judu:stop:5483",
              "position": {
                "x": 2562.319,
                "z": -3823.788
              },
              "distanceAlongShapeM": 13953.152,
              "shapeOffsetM": 3.832,
              "arrivalOffsetSeconds": 2400,
              "departureOffsetSeconds": 2400
            }
          ],
          "departuresSeconds": [
            19560,
            20880,
            22440,
            24000,
            24840,
            26100,
            26940,
            28560,
            30180,
            31080,
            32640,
            34980,
            37080,
            39120,
            40740,
            43020,
            45060,
            46440,
            48660,
            50940,
            52860,
            54720,
            56580,
            57900,
            59100,
            60300,
            61620,
            62880,
            64800,
            66780,
            68460,
            70380,
            72540,
            74940,
            77400,
            79680,
            81840,
            84000
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_bus_116",
      "sourceRouteId": "vilnius_bus_116",
      "mode": "bus",
      "shortName": "116",
      "longName": "Žvėrynas–Gudelių šilas–Lazdynai–Ungurių g. (Apylanka)",
      "color": "0073AC",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_bus_116:0",
          "sourceRouteId": "vilnius_bus_116",
          "sourceShapeId": "vilnius_bus_116_a1-b1",
          "directionId": 0,
          "headsign": "Ungurių g. (Apylanka)",
          "directionName": "Žvėrynas–Gudelių šilas–Lazdynai–Ungurių g. (Apylanka)",
          "mode": "bus",
          "routeShortName": "116",
          "routeLongName": "Žvėrynas–Gudelių šilas–Lazdynai–Ungurių g. (Apylanka)",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              -2126.184,
              -1067.567,
              0
            ],
            [
              -2101.779,
              -1069.748,
              24.503
            ],
            [
              -2090.919,
              -1074.785,
              36.474
            ],
            [
              -2072.667,
              -1084.451,
              57.127
            ],
            [
              -2070.025,
              -1103.286,
              76.147
            ],
            [
              -2072.195,
              -1109.627,
              82.849
            ],
            [
              -2142.708,
              -1122.847,
              154.591
            ],
            [
              -2159.624,
              -1131.453,
              173.57
            ],
            [
              -2184.705,
              -1155.271,
              208.158
            ],
            [
              -2202.716,
              -1161.859,
              227.336
            ],
            [
              -2224.67,
              -1163.697,
              249.367
            ],
            [
              -2246.137,
              -1174.448,
              273.376
            ],
            [
              -2255.963,
              -1183.18,
              286.521
            ],
            [
              -2262.447,
              -1185.292,
              293.34
            ],
            [
              -2339.674,
              -1177.245,
              370.985
            ],
            [
              -2392.506,
              -1175.197,
              423.857
            ],
            [
              -2433.855,
              -1180.032,
              465.488
            ],
            [
              -2474.658,
              -1190.444,
              507.598
            ],
            [
              -2521.496,
              -1214.107,
              560.074
            ],
            [
              -2594.45,
              -1256.235,
              644.318
            ],
            [
              -2624.997,
              -1270.168,
              677.893
            ],
            [
              -2680.78,
              -1289.223,
              736.84
            ],
            [
              -2710.565,
              -1296.491,
              767.499
            ],
            [
              -2777.752,
              -1304.214,
              835.129
            ],
            [
              -2815.153,
              -1304.669,
              872.533
            ],
            [
              -2855.028,
              -1301.32,
              912.548
            ],
            [
              -3099.309,
              -1258.49,
              1160.555
            ],
            [
              -3139.719,
              -1251.188,
              1201.62
            ],
            [
              -3159.719,
              -1247.413,
              1221.973
            ],
            [
              -3359.526,
              -1207.182,
              1425.79
            ],
            [
              -3495.953,
              -1192.555,
              1562.999
            ],
            [
              -3569.469,
              -1193.5,
              1636.521
            ],
            [
              -3626.266,
              -1196.964,
              1693.423
            ],
            [
              -3657.704,
              -1114.039,
              1782.108
            ],
            [
              -3677.364,
              -1066.903,
              1833.18
            ],
            [
              -3685.368,
              -1042.059,
              1859.281
            ],
            [
              -3720.918,
              -930.373,
              1976.488
            ],
            [
              -3751.424,
              -837.404,
              2074.334
            ],
            [
              -3758.325,
              -817.25,
              2095.637
            ],
            [
              -3766.218,
              -791.548,
              2122.524
            ],
            [
              -3793.988,
              -719.82,
              2199.44
            ],
            [
              -3843.779,
              -616.54,
              2314.095
            ],
            [
              -3881.258,
              -546.871,
              2393.206
            ],
            [
              -3968.352,
              -399.129,
              2564.708
            ],
            [
              -3983.006,
              -376.666,
              2591.528
            ],
            [
              -3999.719,
              -350.005,
              2622.995
            ],
            [
              -4048.201,
              -282.373,
              2706.209
            ],
            [
              -4133.499,
              -180.709,
              2838.916
            ],
            [
              -4196.231,
              -117.271,
              2928.133
            ],
            [
              -4217.103,
              -95.271,
              2958.458
            ],
            [
              -4245.021,
              -66.348,
              2998.658
            ],
            [
              -4257.704,
              -53.884,
              3016.44
            ],
            [
              -4301.14,
              -15.237,
              3074.581
            ],
            [
              -4337.856,
              20.353,
              3125.715
            ],
            [
              -4357.658,
              39.718,
              3153.412
            ],
            [
              -4372.725,
              44.949,
              3169.361
            ],
            [
              -4380.461,
              45.082,
              3177.098
            ],
            [
              -4440.12,
              26.073,
              3239.712
            ],
            [
              -4464.096,
              19.59,
              3264.549
            ],
            [
              -4478.879,
              22.287,
              3279.576
            ],
            [
              -4489.743,
              28.04,
              3291.869
            ],
            [
              -4529.153,
              107.182,
              3380.281
            ],
            [
              -4592.389,
              246.88,
              3533.625
            ],
            [
              -4602.309,
              268.218,
              3557.156
            ],
            [
              -4606.066,
              278.521,
              3568.123
            ],
            [
              -4633.818,
              364.581,
              3658.547
            ],
            [
              -4642.013,
              399.129,
              3694.053
            ],
            [
              -4647.134,
              406.31,
              3702.873
            ],
            [
              -4689.1,
              398.824,
              3745.501
            ],
            [
              -4692.163,
              397.149,
              3748.992
            ],
            [
              -4702.793,
              394.98,
              3759.841
            ],
            [
              -4828.883,
              371.165,
              3888.161
            ],
            [
              -4896.754,
              362.309,
              3956.607
            ],
            [
              -4951.046,
              348.442,
              4012.642
            ],
            [
              -5014.234,
              318.678,
              4082.489
            ],
            [
              -5076.317,
              282.31,
              4154.44
            ],
            [
              -5109.637,
              321.936,
              4206.213
            ],
            [
              -5124.409,
              345.341,
              4233.89
            ],
            [
              -5130.743,
              369.649,
              4259.009
            ],
            [
              -5144.1,
              401.652,
              4293.688
            ],
            [
              -5246.606,
              604.334,
              4520.816
            ],
            [
              -5256.535,
              624.129,
              4542.962
            ],
            [
              -5263.195,
              637.407,
              4557.817
            ],
            [
              -5266.907,
              644.807,
              4566.096
            ],
            [
              -5287.913,
              684.024,
              4610.584
            ],
            [
              -5304.033,
              684.298,
              4626.707
            ],
            [
              -5367.982,
              678.708,
              4690.899
            ],
            [
              -5415.868,
              669.503,
              4739.662
            ],
            [
              -5465.175,
              652.531,
              4791.808
            ],
            [
              -5472.135,
              660.441,
              4802.344
            ],
            [
              -5494.875,
              706.655,
              4853.85
            ],
            [
              -5524.047,
              755.945,
              4911.126
            ],
            [
              -5584.133,
              825.983,
              5003.406
            ],
            [
              -5631.614,
              863.758,
              5064.081
            ],
            [
              -5674.076,
              923.242,
              5137.166
            ],
            [
              -5690.844,
              944.195,
              5164.002
            ],
            [
              -5766.263,
              1040.576,
              5286.384
            ],
            [
              -5722.499,
              1094.246,
              5355.635
            ],
            [
              -5702.806,
              1135.452,
              5401.305
            ],
            [
              -5696.038,
              1153.984,
              5421.034
            ],
            [
              -5695.81,
              1174.424,
              5441.476
            ],
            [
              -5704.191,
              1206.105,
              5474.247
            ],
            [
              -5703.538,
              1219.672,
              5487.829
            ],
            [
              -5693.124,
              1234.147,
              5505.661
            ],
            [
              -5660.054,
              1255.85,
              5545.217
            ],
            [
              -5554.355,
              1326.415,
              5672.306
            ],
            [
              -5499.41,
              1371.123,
              5743.142
            ],
            [
              -5487.499,
              1388.732,
              5764.401
            ],
            [
              -5486.404,
              1413.203,
              5788.897
            ],
            [
              -5491.201,
              1436.662,
              5812.841
            ],
            [
              -5510.94,
              1458.278,
              5842.114
            ],
            [
              -5500.232,
              1474.664,
              5861.688
            ],
            [
              -5449.699,
              1519.719,
              5929.39
            ],
            [
              -5293.275,
              1657.048,
              6137.543
            ],
            [
              -5286.75,
              1661.39,
              6145.38
            ],
            [
              -5277.683,
              1663.462,
              6154.681
            ],
            [
              -5219.727,
              1665.876,
              6212.687
            ],
            [
              -5182.999,
              1682.466,
              6252.989
            ],
            [
              -5164.423,
              1707.389,
              6284.073
            ],
            [
              -5112.743,
              1806.02,
              6395.423
            ],
            [
              -5092.642,
              1829.268,
              6426.156
            ],
            [
              -5078.505,
              1842.63,
              6445.609
            ],
            [
              -5067.768,
              1840.868,
              6456.489
            ],
            [
              -5058.626,
              1835.611,
              6467.035
            ],
            [
              -5051.474,
              1838.829,
              6474.877
            ],
            [
              -5037.304,
              1837.474,
              6489.112
            ],
            [
              -5023.305,
              1826.102,
              6507.148
            ],
            [
              -4931.684,
              1728.355,
              6641.121
            ],
            [
              -4906.917,
              1690.529,
              6686.334
            ],
            [
              -4842.797,
              1742.865,
              6769.102
            ],
            [
              -4801.101,
              1766.641,
              6817.1
            ],
            [
              -4774.467,
              1777.316,
              6845.794
            ],
            [
              -4728.427,
              1790.998,
              6893.824
            ],
            [
              -4687.68,
              1796.979,
              6935.007
            ],
            [
              -4579.155,
              1805.134,
              7043.838
            ],
            [
              -4546.833,
              1810.069,
              7076.535
            ],
            [
              -4518.395,
              1811.882,
              7105.031
            ],
            [
              -4300.033,
              1829.272,
              7324.084
            ],
            [
              -4282.619,
              1828.972,
              7341.501
            ],
            [
              -4232.446,
              1820.314,
              7392.415
            ],
            [
              -4165.014,
              1802.452,
              7462.173
            ],
            [
              -4141.304,
              1793.136,
              7487.647
            ],
            [
              -4122.773,
              1782.797,
              7508.867
            ],
            [
              -4070.589,
              1735.287,
              7579.439
            ],
            [
              -4047.235,
              1694.122,
              7626.767
            ],
            [
              -4037.796,
              1664.197,
              7658.146
            ],
            [
              -4021.405,
              1600.417,
              7723.998
            ],
            [
              -3992.198,
              1462.162,
              7865.305
            ],
            [
              -3985.157,
              1436.356,
              7892.054
            ],
            [
              -3986.154,
              1438.68,
              7894.582
            ],
            [
              -3973.348,
              1390.702,
              7944.24
            ],
            [
              -3969.311,
              1368.257,
              7967.045
            ],
            [
              -3952.68,
              1285.592,
              8051.366
            ],
            [
              -3953.633,
              1267.797,
              8069.187
            ],
            [
              -3986.792,
              1252.786,
              8105.585
            ],
            [
              -4052.715,
              1233.557,
              8174.255
            ],
            [
              -4088.482,
              1228.943,
              8210.319
            ],
            [
              -4121.332,
              1231.737,
              8243.287
            ],
            [
              -4147.457,
              1237.551,
              8270.052
            ],
            [
              -4212.237,
              1261.595,
              8339.15
            ],
            [
              -4241.916,
              1271.669,
              8370.492
            ],
            [
              -4268.203,
              1281.028,
              8398.395
            ],
            [
              -4527.979,
              1404.616,
              8686.071
            ],
            [
              -4557.013,
              1417.363,
              8717.78
            ],
            [
              -4581.673,
              1433.369,
              8747.179
            ],
            [
              -4718.251,
              1519.203,
              8908.49
            ],
            [
              -4836.63,
              1608.523,
              9056.785
            ],
            [
              -4855.022,
              1631.754,
              9086.416
            ],
            [
              -4943.107,
              1724.544,
              9214.357
            ],
            [
              -4961.39,
              1738.988,
              9237.657
            ],
            [
              -5069.077,
              1865.846,
              9404.058
            ],
            [
              -5076.134,
              1868.193,
              9411.495
            ],
            [
              -5119.953,
              1909.016,
              9471.384
            ],
            [
              -5214.195,
              1981.867,
              9590.501
            ],
            [
              -5228.689,
              2002.152,
              9615.432
            ],
            [
              -5236.77,
              2020.101,
              9635.116
            ],
            [
              -5240.925,
              2041.322,
              9656.74
            ],
            [
              -5239.294,
              2061.332,
              9676.816
            ],
            [
              -5227.836,
              2090.08,
              9707.763
            ],
            [
              -5213.304,
              2109.87,
              9732.316
            ],
            [
              -5193.689,
              2125.12,
              9757.162
            ],
            [
              -5147.095,
              2133.196,
              9804.45
            ],
            [
              -5075.343,
              2126.977,
              9876.471
            ],
            [
              -4973.287,
              2110.226,
              9979.893
            ],
            [
              -4894.768,
              2098.864,
              10059.23
            ],
            [
              -4850.889,
              2099.226,
              10103.11
            ],
            [
              -4603.07,
              2140.618,
              10354.362
            ],
            [
              -4527.565,
              2141.547,
              10429.873
            ],
            [
              -4479.873,
              2138.5,
              10477.662
            ],
            [
              -4449.411,
              2138.771,
              10508.125
            ],
            [
              -4390.804,
              2140.306,
              10566.752
            ],
            [
              -4376.576,
              2142.288,
              10581.118
            ],
            [
              -4195.427,
              2208.182,
              10773.879
            ],
            [
              -4108.264,
              2248.978,
              10870.117
            ],
            [
              -4011,
              2314.088,
              10987.162
            ],
            [
              -3941.175,
              2365.804,
              11074.053
            ],
            [
              -3943.03,
              2364.119,
              11076.559
            ],
            [
              -3945.224,
              2386.421,
              11098.969
            ],
            [
              -3957.678,
              2411.388,
              11126.87
            ],
            [
              -3991.012,
              2499.647,
              11221.214
            ],
            [
              -4043.609,
              2629.688,
              11361.489
            ],
            [
              -4055.333,
              2651.102,
              11385.902
            ],
            [
              -4116.103,
              2803.488,
              11549.959
            ],
            [
              -4124.654,
              2831.465,
              11579.213
            ],
            [
              -4144.707,
              2922.194,
              11672.132
            ],
            [
              -4153.919,
              2967.781,
              11718.64
            ],
            [
              -4167.578,
              3027.061,
              11779.474
            ],
            [
              -4202.041,
              3133.366,
              11891.225
            ],
            [
              -4257.982,
              3220.047,
              11994.39
            ],
            [
              -4348.426,
              3289.511,
              12108.431
            ],
            [
              -4400.505,
              3313.702,
              12165.854
            ],
            [
              -4445.196,
              3329.026,
              12213.1
            ],
            [
              -4463.829,
              3333.799,
              12232.334
            ],
            [
              -4473.683,
              3334.443,
              12242.21
            ],
            [
              -4488.71,
              3337.606,
              12257.565
            ],
            [
              -4510.545,
              3342.827,
              12280.017
            ],
            [
              -4451.685,
              3955.857,
              12895.866
            ],
            [
              -4445.522,
              3966.737,
              12908.37
            ],
            [
              -4441.759,
              3966.39,
              12912.148
            ],
            [
              -4417.662,
              3969.109,
              12936.399
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:4898",
              "position": {
                "x": -2071.721,
                "z": -1082.918
              },
              "distanceAlongShapeM": 57.127,
              "shapeOffsetM": 1.801,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:7415",
              "position": {
                "x": -3140.52,
                "z": -1255.542
              },
              "distanceAlongShapeM": 1201.62,
              "shapeOffsetM": 4.427,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:5643",
              "position": {
                "x": -3680.758,
                "z": -1067.996
              },
              "distanceAlongShapeM": 1833.18,
              "shapeOffsetM": 3.566,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:5646",
              "position": {
                "x": -3761.526,
                "z": -818.346
              },
              "distanceAlongShapeM": 2095.637,
              "shapeOffsetM": 3.383,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:5651",
              "position": {
                "x": -3986.683,
                "z": -379.175
              },
              "distanceAlongShapeM": 2591.436,
              "shapeOffsetM": 4.451,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:5656",
              "position": {
                "x": -4221.08,
                "z": -99.045
              },
              "distanceAlongShapeM": 2958.506,
              "shapeOffsetM": 5.482,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:5920",
              "position": {
                "x": -4608.183,
                "z": 266.076
              },
              "distanceAlongShapeM": 3557.156,
              "shapeOffsetM": 6.252,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:19220",
              "position": {
                "x": -4691.149,
                "z": 392.18
              },
              "distanceAlongShapeM": 3748.992,
              "shapeOffsetM": 5.071,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:19223",
              "position": {
                "x": -5270.712,
                "z": 633.637
              },
              "distanceAlongShapeM": 4557.817,
              "shapeOffsetM": 8.41,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:9961",
              "position": {
                "x": -5693.1,
                "z": 942.489
              },
              "distanceAlongShapeM": 5164.049,
              "shapeOffsetM": 2.828,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:9636",
              "position": {
                "x": -5452.321,
                "z": 1522.831
              },
              "distanceAlongShapeM": 5929.472,
              "shapeOffsetM": 4.069,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            },
            {
              "stopId": "judu:stop:437",
              "position": {
                "x": -4928.804,
                "z": 1730.978
              },
              "distanceAlongShapeM": 6641.121,
              "shapeOffsetM": 3.896,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:5691",
              "position": {
                "x": -4547.361,
                "z": 1815.72
              },
              "distanceAlongShapeM": 7076.535,
              "shapeOffsetM": 5.676,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:5693",
              "position": {
                "x": -4066.123,
                "z": 1738.403
              },
              "distanceAlongShapeM": 7579.439,
              "shapeOffsetM": 5.445,
              "arrivalOffsetSeconds": 1230,
              "departureOffsetSeconds": 1230
            },
            {
              "stopId": "judu:stop:5697",
              "position": {
                "x": -3968.906,
                "z": 1391.627
              },
              "distanceAlongShapeM": 7944.24,
              "shapeOffsetM": 4.537,
              "arrivalOffsetSeconds": 1290,
              "departureOffsetSeconds": 1290
            },
            {
              "stopId": "judu:stop:6318",
              "position": {
                "x": -4215.081,
                "z": 1256.734
              },
              "distanceAlongShapeM": 8340.28,
              "shapeOffsetM": 5.517,
              "arrivalOffsetSeconds": 1380,
              "departureOffsetSeconds": 1380
            },
            {
              "stopId": "judu:stop:6319",
              "position": {
                "x": -4558.781,
                "z": 1414.051
              },
              "distanceAlongShapeM": 8717.78,
              "shapeOffsetM": 3.754,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            },
            {
              "stopId": "judu:stop:6320",
              "position": {
                "x": -4838.028,
                "z": 1606.973
              },
              "distanceAlongShapeM": 9056.785,
              "shapeOffsetM": 2.088,
              "arrivalOffsetSeconds": 1500,
              "departureOffsetSeconds": 1500
            },
            {
              "stopId": "judu:stop:7341",
              "position": {
                "x": -4962.228,
                "z": 1738.229
              },
              "distanceAlongShapeM": 9237.657,
              "shapeOffsetM": 1.131,
              "arrivalOffsetSeconds": 1530,
              "departureOffsetSeconds": 1530
            },
            {
              "stopId": "judu:stop:6401",
              "position": {
                "x": -5074.894,
                "z": 2129.773
              },
              "distanceAlongShapeM": 9876.471,
              "shapeOffsetM": 2.831,
              "arrivalOffsetSeconds": 1680,
              "departureOffsetSeconds": 1680
            },
            {
              "stopId": "judu:stop:6379",
              "position": {
                "x": -4449.462,
                "z": 2143.543
              },
              "distanceAlongShapeM": 10508.199,
              "shapeOffsetM": 4.772,
              "arrivalOffsetSeconds": 1800,
              "departureOffsetSeconds": 1800
            },
            {
              "stopId": "judu:stop:9102",
              "position": {
                "x": -3966.145,
                "z": 2407.934
              },
              "distanceAlongShapeM": 11126.87,
              "shapeOffsetM": 9.144,
              "arrivalOffsetSeconds": 1860,
              "departureOffsetSeconds": 1860
            },
            {
              "stopId": "judu:stop:6389",
              "position": {
                "x": -4060.699,
                "z": 2648.908
              },
              "distanceAlongShapeM": 11385.902,
              "shapeOffsetM": 5.798,
              "arrivalOffsetSeconds": 1920,
              "departureOffsetSeconds": 1920
            },
            {
              "stopId": "judu:stop:7722",
              "position": {
                "x": -4474.19,
                "z": 3331.751
              },
              "distanceAlongShapeM": 12242.21,
              "shapeOffsetM": 2.74,
              "arrivalOffsetSeconds": 2040,
              "departureOffsetSeconds": 2040
            },
            {
              "stopId": "judu:stop:10264",
              "position": {
                "x": -4415.001,
                "z": 3958.576
              },
              "distanceAlongShapeM": 12936.399,
              "shapeOffsetM": 10.863,
              "arrivalOffsetSeconds": 2100,
              "departureOffsetSeconds": 2100
            }
          ],
          "departuresSeconds": [
            20040,
            25320,
            28320,
            31320,
            34320,
            38460,
            41400,
            44160,
            46860,
            49560,
            52260,
            54900,
            57720,
            60360,
            66000,
            73020,
            78300,
            83520
          ]
        },
        {
          "id": "judu:pattern:vilnius_bus_116:1",
          "sourceRouteId": "vilnius_bus_116",
          "sourceShapeId": "vilnius_bus_116_b1-a1",
          "directionId": 1,
          "headsign": "Žvėrynas (Apylanka)",
          "directionName": "Ungurių g.–Lazdynai–Gudelių šilas–Žvėrynas (Apylanka)",
          "mode": "bus",
          "routeShortName": "116",
          "routeLongName": "Žvėrynas–Gudelių šilas–Lazdynai–Ungurių g. (Apylanka)",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              -4417.662,
              3969.109,
              0
            ],
            [
              -4451.685,
              3955.857,
              36.513
            ],
            [
              -4465.718,
              3786.903,
              206.049
            ],
            [
              -4510.545,
              3342.827,
              652.381
            ],
            [
              -4497.626,
              3342.407,
              665.307
            ],
            [
              -4441.951,
              3330.083,
              722.33
            ],
            [
              -4390.49,
              3312.436,
              776.733
            ],
            [
              -4348.426,
              3289.511,
              824.638
            ],
            [
              -4264.944,
              3227.96,
              928.358
            ],
            [
              -4234.003,
              3188.464,
              978.531
            ],
            [
              -4197.015,
              3125.487,
              1051.566
            ],
            [
              -4171.244,
              3048.231,
              1133.007
            ],
            [
              -4157.405,
              2990.106,
              1192.757
            ],
            [
              -4124.692,
              2829.24,
              1356.915
            ],
            [
              -4095.054,
              2751.917,
              1439.724
            ],
            [
              -4082.456,
              2725.06,
              1469.389
            ],
            [
              -4012.116,
              2547.88,
              1660.021
            ],
            [
              -3955.712,
              2419.407,
              1800.33
            ],
            [
              -3953.773,
              2414.399,
              1805.7
            ],
            [
              -3942.199,
              2386.283,
              1836.105
            ],
            [
              -3939.351,
              2371.866,
              1850.801
            ],
            [
              -3943.03,
              2364.119,
              1859.377
            ],
            [
              -4007.194,
              2316.209,
              1939.454
            ],
            [
              -4079.923,
              2267.378,
              2027.056
            ],
            [
              -4114.659,
              2244.056,
              2068.894
            ],
            [
              -4157.489,
              2223.171,
              2116.545
            ],
            [
              -4325.05,
              2156.176,
              2297.003
            ],
            [
              -4375.253,
              2139.958,
              2349.761
            ],
            [
              -4407.029,
              2135.374,
              2381.865
            ],
            [
              -4517.705,
              2137.698,
              2492.566
            ],
            [
              -4577.32,
              2138.604,
              2552.188
            ],
            [
              -4634.125,
              2135.585,
              2609.073
            ],
            [
              -4816.04,
              2099.743,
              2794.485
            ],
            [
              -4855.442,
              2097.078,
              2833.977
            ],
            [
              -4917.969,
              2100.374,
              2896.591
            ],
            [
              -4969.474,
              2106.821,
              2948.498
            ],
            [
              -5079.485,
              2125.398,
              3060.067
            ],
            [
              -5115.548,
              2129.353,
              3096.346
            ],
            [
              -5151.268,
              2124.22,
              3132.432
            ],
            [
              -5168.723,
              2123.338,
              3149.91
            ],
            [
              -5186.285,
              2118.906,
              3168.023
            ],
            [
              -5205.39,
              2106.815,
              3190.632
            ],
            [
              -5218.73,
              2094.377,
              3208.871
            ],
            [
              -5232.085,
              2067.888,
              3238.536
            ],
            [
              -5234.987,
              2049.013,
              3257.633
            ],
            [
              -5232.767,
              2027.825,
              3278.937
            ],
            [
              -5229.106,
              2015.517,
              3291.778
            ],
            [
              -5217.174,
              1996.39,
              3314.322
            ],
            [
              -5203.627,
              1982.351,
              3333.831
            ],
            [
              -5082.26,
              1887.222,
              3488.037
            ],
            [
              -5064.922,
              1882.473,
              3506.014
            ],
            [
              -5060.085,
              1863.466,
              3525.626
            ],
            [
              -4961.259,
              1757.137,
              3670.79
            ],
            [
              -4931.684,
              1728.355,
              3712.058
            ],
            [
              -4906.917,
              1690.529,
              3757.271
            ],
            [
              -4767.773,
              1565.694,
              3944.207
            ],
            [
              -4741.69,
              1550.026,
              3974.634
            ],
            [
              -4712.351,
              1524.668,
              4013.413
            ],
            [
              -4596.2,
              1451.429,
              4150.726
            ],
            [
              -4491.296,
              1399.532,
              4267.765
            ],
            [
              -4467.288,
              1389.272,
              4293.873
            ],
            [
              -4443.995,
              1374.227,
              4321.603
            ],
            [
              -4243.678,
              1281.718,
              4542.249
            ],
            [
              -4199.211,
              1271.037,
              4587.982
            ],
            [
              -4179.458,
              1265.024,
              4608.629
            ],
            [
              -4137.877,
              1254.669,
              4651.48
            ],
            [
              -4093.256,
              1251.097,
              4696.244
            ],
            [
              -4041.607,
              1253.735,
              4747.96
            ],
            [
              -3953.633,
              1267.797,
              4837.051
            ],
            [
              -4000.81,
              1451.793,
              5026.999
            ],
            [
              -4002.478,
              1464.567,
              5039.881
            ],
            [
              -4050.827,
              1690.271,
              5270.706
            ],
            [
              -4136.394,
              1775.359,
              5391.377
            ],
            [
              -4148.475,
              1788.807,
              5409.455
            ],
            [
              -4177.913,
              1802.674,
              5441.996
            ],
            [
              -4315.532,
              1828.426,
              5582.003
            ],
            [
              -4369.14,
              1824.898,
              5635.727
            ],
            [
              -4499.926,
              1801.252,
              5768.633
            ],
            [
              -4609.985,
              1791.417,
              5879.131
            ],
            [
              -4563.305,
              1794.618,
              5925.92
            ],
            [
              -4774.467,
              1777.316,
              6137.789
            ],
            [
              -4906.917,
              1690.529,
              6296.14
            ],
            [
              -4961.39,
              1738.988,
              6369.048
            ],
            [
              -5044.455,
              1834.256,
              6495.443
            ],
            [
              -5051.474,
              1838.829,
              6503.821
            ],
            [
              -5059.283,
              1834.99,
              6512.522
            ],
            [
              -5064.136,
              1836.12,
              6517.505
            ],
            [
              -5077.779,
              1840.186,
              6531.741
            ],
            [
              -5083.779,
              1836.041,
              6539.034
            ],
            [
              -5107.947,
              1811.872,
              6573.214
            ],
            [
              -5124.326,
              1784.882,
              6604.785
            ],
            [
              -5174.249,
              1691.694,
              6710.503
            ],
            [
              -5199.721,
              1672.853,
              6742.185
            ],
            [
              -5218.299,
              1665.943,
              6762.007
            ],
            [
              -5284.378,
              1662.493,
              6828.176
            ],
            [
              -5299.781,
              1653.82,
              6845.853
            ],
            [
              -5323.145,
              1629.816,
              6879.35
            ],
            [
              -5368.63,
              1590.887,
              6939.219
            ],
            [
              -5474.398,
              1495.617,
              7081.569
            ],
            [
              -5517.546,
              1458.203,
              7138.678
            ],
            [
              -5493.079,
              1440.033,
              7169.155
            ],
            [
              -5485.092,
              1416.521,
              7193.986
            ],
            [
              -5486.816,
              1390.947,
              7219.618
            ],
            [
              -5513.881,
              1354.671,
              7264.878
            ],
            [
              -5671.037,
              1249.221,
              7454.134
            ],
            [
              -5690.834,
              1235.787,
              7478.058
            ],
            [
              -5701.278,
              1224.747,
              7493.256
            ],
            [
              -5694.321,
              1161.319,
              7557.064
            ],
            [
              -5699.833,
              1143.332,
              7575.876
            ],
            [
              -5714.151,
              1108.711,
              7613.341
            ],
            [
              -5737.988,
              1072.38,
              7656.794
            ],
            [
              -5763.916,
              1039.528,
              7698.646
            ],
            [
              -5685.55,
              941.92,
              7823.82
            ],
            [
              -5677.832,
              929.985,
              7838.033
            ],
            [
              -5640.393,
              873.969,
              7905.409
            ],
            [
              -5575.883,
              818.05,
              7990.781
            ],
            [
              -5510.827,
              736.796,
              8094.87
            ],
            [
              -5467.754,
              652.574,
              8189.467
            ],
            [
              -5426.184,
              669.679,
              8234.419
            ],
            [
              -5362.103,
              683.06,
              8299.882
            ],
            [
              -5285.903,
              688.442,
              8376.272
            ],
            [
              -5275.148,
              661.237,
              8405.525
            ],
            [
              -5268.379,
              654.099,
              8415.362
            ],
            [
              -5262.292,
              635.72,
              8434.723
            ],
            [
              -5206.693,
              529.027,
              8555.034
            ],
            [
              -5136.299,
              384.215,
              8716.049
            ],
            [
              -5127.026,
              360.679,
              8741.346
            ],
            [
              -5123.872,
              342.886,
              8759.416
            ],
            [
              -5115.606,
              329.592,
              8775.071
            ],
            [
              -5078.009,
              285.258,
              8833.2
            ],
            [
              -5070.272,
              285.126,
              8840.938
            ],
            [
              -5036.895,
              306.637,
              8880.647
            ],
            [
              -4980.651,
              337.338,
              8944.724
            ],
            [
              -4938.658,
              352.459,
              8989.356
            ],
            [
              -4877.762,
              366.317,
              9051.809
            ],
            [
              -4716.939,
              392.623,
              9214.77
            ],
            [
              -4695.104,
              398.437,
              9237.365
            ],
            [
              -4674.132,
              402.715,
              9258.77
            ],
            [
              -4648.866,
              407.866,
              9284.555
            ],
            [
              -4636.172,
              401.255,
              9298.867
            ],
            [
              -4621.181,
              335.318,
              9366.487
            ],
            [
              -4591.687,
              250.208,
              9456.562
            ],
            [
              -4576.066,
              220.996,
              9489.689
            ],
            [
              -4572.392,
              217.886,
              9494.502
            ],
            [
              -4568.029,
              200.82,
              9512.117
            ],
            [
              -4518.608,
              112.027,
              9613.737
            ],
            [
              -4427.619,
              152.763,
              9713.428
            ],
            [
              -4384.818,
              166.497,
              9758.379
            ],
            [
              -4348.598,
              172.552,
              9795.102
            ],
            [
              -4322.828,
              170.994,
              9820.919
            ],
            [
              -4281.834,
              154.702,
              9865.031
            ],
            [
              -4267.159,
              145.543,
              9882.33
            ],
            [
              -4262.015,
              139.605,
              9890.186
            ],
            [
              -4264.811,
              132.144,
              9898.154
            ],
            [
              -4317.184,
              49.557,
              9995.948
            ],
            [
              -4317.318,
              41.767,
              10003.739
            ],
            [
              -4314.854,
              35.045,
              10010.898
            ],
            [
              -4265.47,
              -18.127,
              10083.466
            ],
            [
              -4080.333,
              -210.913,
              10350.752
            ],
            [
              -3954.469,
              -380.846,
              10562.221
            ],
            [
              -3926.158,
              -422.036,
              10612.202
            ],
            [
              -3919.036,
              -433.74,
              10625.903
            ],
            [
              -3857.936,
              -540.596,
              10748.994
            ],
            [
              -3823.641,
              -607.984,
              10824.607
            ],
            [
              -3766.483,
              -732.543,
              10961.654
            ],
            [
              -3707.64,
              -908.34,
              11147.038
            ],
            [
              -3695.741,
              -928.584,
              11170.52
            ],
            [
              -3679.687,
              -950.175,
              11197.425
            ],
            [
              -3668.232,
              -978.044,
              11227.557
            ],
            [
              -3606.925,
              -1085.98,
              11351.688
            ],
            [
              -3586.062,
              -1109.72,
              11383.293
            ],
            [
              -3575.241,
              -1117.701,
              11396.739
            ],
            [
              -3510.801,
              -1144.012,
              11466.344
            ],
            [
              -3355.367,
              -1190.556,
              11628.597
            ],
            [
              -3109.19,
              -1234.288,
              11878.628
            ],
            [
              -3070.013,
              -1242.306,
              11918.617
            ],
            [
              -2879.155,
              -1277.94,
              12112.773
            ],
            [
              -2839.273,
              -1283.094,
              12152.986
            ],
            [
              -2787.087,
              -1285.125,
              12205.212
            ],
            [
              -2748.376,
              -1283.58,
              12243.954
            ],
            [
              -2714.118,
              -1278.617,
              12278.569
            ],
            [
              -2670.7,
              -1266.023,
              12323.777
            ],
            [
              -2624.585,
              -1246.798,
              12373.739
            ],
            [
              -2499.949,
              -1183.085,
              12513.715
            ],
            [
              -2469.831,
              -1172.717,
              12545.568
            ],
            [
              -2418.716,
              -1162.489,
              12597.697
            ],
            [
              -2392.231,
              -1159.617,
              12624.337
            ],
            [
              -2246.137,
              -1174.448,
              12771.182
            ],
            [
              -2229.866,
              -1165.831,
              12789.594
            ],
            [
              -2190.996,
              -1155.388,
              12829.842
            ],
            [
              -2164.136,
              -1131.373,
              12865.872
            ],
            [
              -2142.708,
              -1122.847,
              12888.934
            ],
            [
              -2147.916,
              -1089.358,
              12922.826
            ],
            [
              -2143.91,
              -1081.069,
              12932.032
            ],
            [
              -2126.184,
              -1067.567,
              12954.314
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:10264",
              "position": {
                "x": -4415.001,
                "z": 3958.576
              },
              "distanceAlongShapeM": 1.343,
              "shapeOffsetM": 10.78,
              "arrivalOffsetSeconds": -300,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:7723",
              "position": {
                "x": -4497.206,
                "z": 3344.392
              },
              "distanceAlongShapeM": 665.307,
              "shapeOffsetM": 2.029,
              "arrivalOffsetSeconds": 60,
              "departureOffsetSeconds": 60
            },
            {
              "stopId": "judu:stop:6388",
              "position": {
                "x": -4080.014,
                "z": 2726.053
              },
              "distanceAlongShapeM": 1469.389,
              "shapeOffsetM": 2.636,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:8328",
              "position": {
                "x": -3954.322,
                "z": 2419.974
              },
              "distanceAlongShapeM": 1800.33,
              "shapeOffsetM": 1.501,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:6387",
              "position": {
                "x": -4156.496,
                "z": 2220.868
              },
              "distanceAlongShapeM": 2116.545,
              "shapeOffsetM": 2.508,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:6381",
              "position": {
                "x": -4518.062,
                "z": 2131.364
              },
              "distanceAlongShapeM": 2492.827,
              "shapeOffsetM": 6.338,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:756",
              "position": {
                "x": -5151.175,
                "z": 2121.056
              },
              "distanceAlongShapeM": 3132.5,
              "shapeOffsetM": 3.165,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:437",
              "position": {
                "x": -4928.804,
                "z": 1730.978
              },
              "distanceAlongShapeM": 3712.058,
              "shapeOffsetM": 3.896,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:783",
              "position": {
                "x": -4739.606,
                "z": 1552.966
              },
              "distanceAlongShapeM": 3974.634,
              "shapeOffsetM": 3.604,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:3589",
              "position": {
                "x": -4466.279,
                "z": 1391.309
              },
              "distanceAlongShapeM": 4293.873,
              "shapeOffsetM": 2.273,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:6317",
              "position": {
                "x": -4197.987,
                "z": 1275.363
              },
              "distanceAlongShapeM": 4587.982,
              "shapeOffsetM": 4.495,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:5698",
              "position": {
                "x": -4003.354,
                "z": 1451.223
              },
              "distanceAlongShapeM": 5026.999,
              "shapeOffsetM": 2.607,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:5694",
              "position": {
                "x": -4137.78,
                "z": 1773.038
              },
              "distanceAlongShapeM": 5390.724,
              "shapeOffsetM": 2.623,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:5692",
              "position": {
                "x": -4609.774,
                "z": 1787.849
              },
              "distanceAlongShapeM": 5972.786,
              "shapeOffsetM": 2.952,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            },
            {
              "stopId": "judu:stop:7341",
              "position": {
                "x": -4962.228,
                "z": 1738.229
              },
              "distanceAlongShapeM": 6369.048,
              "shapeOffsetM": 1.131,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:9635",
              "position": {
                "x": -5472.179,
                "z": 1493.112
              },
              "distanceAlongShapeM": 7081.569,
              "shapeOffsetM": 3.347,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:9466",
              "position": {
                "x": -5682.1,
                "z": 944.529
              },
              "distanceAlongShapeM": 7823.82,
              "shapeOffsetM": 4.326,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            },
            {
              "stopId": "judu:stop:19222",
              "position": {
                "x": -5267.128,
                "z": 654.727
              },
              "distanceAlongShapeM": 8415.362,
              "shapeOffsetM": 1.4,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            },
            {
              "stopId": "judu:stop:19221",
              "position": {
                "x": -4696.116,
                "z": 403.397
              },
              "distanceAlongShapeM": 9237.365,
              "shapeOffsetM": 5.062,
              "arrivalOffsetSeconds": 1500,
              "departureOffsetSeconds": 1500
            },
            {
              "stopId": "judu:stop:351",
              "position": {
                "x": -4568.349,
                "z": 219.75
              },
              "distanceAlongShapeM": 9494.502,
              "shapeOffsetM": 4.452,
              "arrivalOffsetSeconds": 1560,
              "departureOffsetSeconds": 1560
            },
            {
              "stopId": "judu:stop:1004",
              "position": {
                "x": -4077.229,
                "z": -208.399
              },
              "distanceAlongShapeM": 10350.752,
              "shapeOffsetM": 3.995,
              "arrivalOffsetSeconds": 1680,
              "departureOffsetSeconds": 1680
            },
            {
              "stopId": "judu:stop:6649",
              "position": {
                "x": -3921.604,
                "z": -419.265
              },
              "distanceAlongShapeM": 10612.202,
              "shapeOffsetM": 5.33,
              "arrivalOffsetSeconds": 1740,
              "departureOffsetSeconds": 1740
            },
            {
              "stopId": "judu:stop:6643",
              "position": {
                "x": -3679.35,
                "z": -950.021
              },
              "distanceAlongShapeM": 11197.425,
              "shapeOffsetM": 0.37,
              "arrivalOffsetSeconds": 1860,
              "departureOffsetSeconds": 1860
            },
            {
              "stopId": "judu:stop:7416",
              "position": {
                "x": -3108.49,
                "z": -1230.499
              },
              "distanceAlongShapeM": 11878.628,
              "shapeOffsetM": 3.854,
              "arrivalOffsetSeconds": 1980,
              "departureOffsetSeconds": 1980
            },
            {
              "stopId": "judu:stop:18481",
              "position": {
                "x": -2146.884,
                "z": -1103.849
              },
              "distanceAlongShapeM": 12908.348,
              "shapeOffsetM": 1.207,
              "arrivalOffsetSeconds": 2160,
              "departureOffsetSeconds": 2160
            }
          ],
          "departuresSeconds": [
            22500,
            27840,
            30840,
            33840,
            36840,
            40920,
            43860,
            46620,
            49320,
            52020,
            54720,
            57360,
            60120,
            63060,
            68760,
            75480,
            80700,
            85920
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_bus_117",
      "sourceRouteId": "vilnius_bus_117",
      "mode": "bus",
      "shortName": "117",
      "longName": "Pilaitė–Kriaučiūnai–Platiniškės",
      "color": "0073AC",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_bus_117:0",
          "sourceRouteId": "vilnius_bus_117",
          "sourceShapeId": "vilnius_bus_117_a-b",
          "directionId": 0,
          "headsign": "Platiniškės",
          "directionName": "Pilaitė–Kriaučiūnai–Platiniškės",
          "mode": "bus",
          "routeShortName": "117",
          "routeLongName": "Pilaitė–Kriaučiūnai–Platiniškės",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              -6782.722,
              -1517.922,
              0
            ],
            [
              -6790.213,
              -1503.239,
              16.483
            ],
            [
              -6789.666,
              -1493.237,
              26.501
            ],
            [
              -6789.574,
              -1493.338,
              26.637
            ],
            [
              -6793.888,
              -1496.036,
              31.725
            ],
            [
              -6804.801,
              -1471.131,
              58.916
            ],
            [
              -6817.871,
              -1443.083,
              89.859
            ],
            [
              -6849.755,
              -1383.551,
              157.392
            ],
            [
              -6861.847,
              -1368.999,
              176.312
            ],
            [
              -6869.747,
              -1345.369,
              201.228
            ],
            [
              -6867.063,
              -1343.514,
              204.49
            ],
            [
              -6860.969,
              -1338.463,
              212.405
            ],
            [
              -6854.775,
              -1336.714,
              218.842
            ],
            [
              -6851.79,
              -1340.583,
              223.729
            ],
            [
              -6839.19,
              -1361.045,
              247.759
            ],
            [
              -6823.318,
              -1421.841,
              310.592
            ],
            [
              -6726.31,
              -1602.786,
              515.901
            ],
            [
              -6717.082,
              -1622.391,
              537.57
            ],
            [
              -6684.251,
              -1702.465,
              624.112
            ],
            [
              -6676.395,
              -1733.766,
              656.384
            ],
            [
              -6677.514,
              -1993.121,
              915.742
            ],
            [
              -6624.319,
              -1987.967,
              969.186
            ],
            [
              -6584.624,
              -1989.111,
              1008.897
            ],
            [
              -6371.246,
              -1988.684,
              1222.275
            ],
            [
              -6349.222,
              -1988.597,
              1244.3
            ],
            [
              -6317.75,
              -1988.595,
              1275.772
            ],
            [
              -6227.58,
              -1992.883,
              1366.044
            ],
            [
              -5930.998,
              -1988.982,
              1662.651
            ],
            [
              -5872.445,
              -1960.324,
              1727.841
            ],
            [
              -5843.89,
              -1946.454,
              1759.587
            ],
            [
              -5738.678,
              -1888.118,
              1879.889
            ],
            [
              -5758.838,
              -1833.821,
              1937.807
            ],
            [
              -5785.02,
              -1791.002,
              1987.997
            ],
            [
              -5803.944,
              -1722.401,
              2059.16
            ],
            [
              -5835.908,
              -1571.933,
              2212.986
            ],
            [
              -5847.216,
              -1532.875,
              2253.648
            ],
            [
              -5860.279,
              -1504.824,
              2284.591
            ],
            [
              -5883.029,
              -1477.722,
              2319.976
            ],
            [
              -5930.704,
              -1434.851,
              2384.091
            ],
            [
              -5981.722,
              -1404.809,
              2443.298
            ],
            [
              -6075.788,
              -1363.147,
              2546.177
            ],
            [
              -6171.849,
              -1320.821,
              2651.15
            ],
            [
              -6226.123,
              -1293.821,
              2711.768
            ],
            [
              -6298.982,
              -1237.996,
              2803.556
            ],
            [
              -6390.202,
              -1159.705,
              2923.766
            ],
            [
              -6455.067,
              -1106.295,
              3007.79
            ],
            [
              -6514.152,
              -1063.847,
              3080.542
            ],
            [
              -6538.862,
              -1051.632,
              3108.107
            ],
            [
              -6594.991,
              -1030.478,
              3168.09
            ],
            [
              -6657.841,
              -1010.502,
              3234.038
            ],
            [
              -6736.082,
              -1019.599,
              3312.806
            ],
            [
              -6752.775,
              -1019.947,
              3329.502
            ],
            [
              -6917.945,
              -988.344,
              3497.669
            ],
            [
              -6950.818,
              -987.796,
              3530.546
            ],
            [
              -7253.728,
              -1058.451,
              3841.587
            ],
            [
              -7427.868,
              -1101.203,
              4020.899
            ],
            [
              -7470.885,
              -1120.289,
              4067.959
            ],
            [
              -7611.644,
              -1211.355,
              4235.608
            ],
            [
              -7647.223,
              -1226.669,
              4274.344
            ],
            [
              -7713.892,
              -1243.413,
              4343.083
            ],
            [
              -7831.874,
              -1282.655,
              4467.42
            ],
            [
              -7861.063,
              -1286.337,
              4496.84
            ],
            [
              -7977.831,
              -1259.101,
              4616.742
            ],
            [
              -8020.904,
              -1251.714,
              4660.444
            ],
            [
              -8051.311,
              -1256.704,
              4691.258
            ],
            [
              -8453.099,
              -1476.525,
              5149.248
            ],
            [
              -8514.55,
              -1509.501,
              5218.987
            ],
            [
              -8556.749,
              -1534.59,
              5268.082
            ],
            [
              -8626.94,
              -1595.207,
              5360.824
            ],
            [
              -8690.669,
              -1604.667,
              5425.251
            ],
            [
              -8709.289,
              -1598.893,
              5444.746
            ],
            [
              -8726.329,
              -1586.81,
              5465.636
            ],
            [
              -8740.966,
              -1566.084,
              5491.009
            ],
            [
              -8752.208,
              -1542.535,
              5517.104
            ],
            [
              -8779.931,
              -1503.123,
              5565.29
            ],
            [
              -8798.444,
              -1487.53,
              5589.494
            ],
            [
              -8820.633,
              -1476.547,
              5614.252
            ],
            [
              -8858.448,
              -1460.674,
              5655.264
            ],
            [
              -8927.047,
              -1429.281,
              5730.705
            ],
            [
              -9100.684,
              -1350.285,
              5921.467
            ],
            [
              -9157.938,
              -1318.879,
              5986.769
            ],
            [
              -9177.809,
              -1309.74,
              6008.641
            ],
            [
              -9247.183,
              -1296.284,
              6079.308
            ],
            [
              -9269.133,
              -1298.156,
              6101.337
            ],
            [
              -9703.624,
              -1473.262,
              6569.786
            ],
            [
              -9874.255,
              -1543.255,
              6754.215
            ],
            [
              -9917.227,
              -1551.548,
              6797.98
            ],
            [
              -9910.188,
              -1579.02,
              6826.339
            ],
            [
              -9875.262,
              -1693.27,
              6945.809
            ],
            [
              -9862.344,
              -1726.253,
              6981.232
            ],
            [
              -9833.663,
              -1778.848,
              7041.139
            ],
            [
              -9806.596,
              -1820.809,
              7091.071
            ],
            [
              -9768.425,
              -1877.17,
              7159.142
            ],
            [
              -9757.88,
              -1899.226,
              7183.59
            ],
            [
              -9745.017,
              -1987.335,
              7272.632
            ],
            [
              -9735.296,
              -2024.226,
              7310.783
            ],
            [
              -9695.194,
              -2126.242,
              7420.397
            ],
            [
              -9672.7,
              -2176.455,
              7475.419
            ],
            [
              -9660.329,
              -2212.445,
              7513.476
            ],
            [
              -9653.868,
              -2251.51,
              7553.071
            ],
            [
              -9647.692,
              -2308.381,
              7610.277
            ],
            [
              -9621.667,
              -2478.298,
              7782.175
            ],
            [
              -9617.964,
              -2503.665,
              7807.811
            ],
            [
              -9613.078,
              -2520.441,
              7825.284
            ],
            [
              -9580.307,
              -2566.609,
              7881.9
            ],
            [
              -9527.218,
              -2633.5,
              7967.298
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:7694",
              "position": {
                "x": -6837.763,
                "z": -1360.375
              },
              "distanceAlongShapeM": 247.759,
              "shapeOffsetM": 1.577,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:4526",
              "position": {
                "x": -6711.23,
                "z": -1619.637
              },
              "distanceAlongShapeM": 537.57,
              "shapeOffsetM": 6.468,
              "arrivalOffsetSeconds": 60,
              "departureOffsetSeconds": 60
            },
            {
              "stopId": "judu:stop:6611",
              "position": {
                "x": -6624.485,
                "z": -1982.877
              },
              "distanceAlongShapeM": 969.186,
              "shapeOffsetM": 5.092,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:6615",
              "position": {
                "x": -6349.244,
                "z": -1983.044
              },
              "distanceAlongShapeM": 1244.3,
              "shapeOffsetM": 5.553,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:6618",
              "position": {
                "x": -5876.852,
                "z": -1950.936
              },
              "distanceAlongShapeM": 1727.979,
              "shapeOffsetM": 10.37,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:17118",
              "position": {
                "x": -5823.871,
                "z": -1639.024
              },
              "distanceAlongShapeM": 2144.858,
              "shapeOffsetM": 2.167,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:17179",
              "position": {
                "x": -6173.116,
                "z": -1323.657
              },
              "distanceAlongShapeM": 2651.15,
              "shapeOffsetM": 3.106,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:17121",
              "position": {
                "x": -6539.27,
                "z": -1052.563
              },
              "distanceAlongShapeM": 3108.16,
              "shapeOffsetM": 1.015,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:17186",
              "position": {
                "x": -6863.951,
                "z": -998.15
              },
              "distanceAlongShapeM": 3442.794,
              "shapeOffsetM": 0.516,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:17190",
              "position": {
                "x": -7150.175,
                "z": -1034.569
              },
              "distanceAlongShapeM": 3735.317,
              "shapeOffsetM": 0.265,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:17194",
              "position": {
                "x": -7610.88,
                "z": -1212.833
              },
              "distanceAlongShapeM": 4235.608,
              "shapeOffsetM": 1.664,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:17203",
              "position": {
                "x": -8452.042,
                "z": -1478.415
              },
              "distanceAlongShapeM": 5149.228,
              "shapeOffsetM": 2.165,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:17208",
              "position": {
                "x": -8861.201,
                "z": -1466.179
              },
              "distanceAlongShapeM": 5655.476,
              "shapeOffsetM": 6.151,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:7625",
              "position": {
                "x": -9904.748,
                "z": -1577.351
              },
              "distanceAlongShapeM": 6826.073,
              "shapeOffsetM": 5.684,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:7624",
              "position": {
                "x": -9525.29,
                "z": -2632.06
              },
              "distanceAlongShapeM": 7967.298,
              "shapeOffsetM": 2.406,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            }
          ],
          "departuresSeconds": [
            19380,
            20940,
            22920,
            24360,
            25800,
            27600,
            29400,
            30960,
            33780,
            35400,
            37020,
            38640,
            40200,
            41760,
            43380,
            44940,
            46380,
            48060,
            49740,
            51540,
            53100,
            55020,
            56700,
            58200,
            59820,
            61380,
            63000,
            64680,
            66360,
            68160,
            70800,
            72660,
            74160,
            75660,
            77280,
            78840,
            80280,
            81840,
            83280,
            84720
          ]
        },
        {
          "id": "judu:pattern:vilnius_bus_117:1",
          "sourceRouteId": "vilnius_bus_117",
          "sourceShapeId": "vilnius_bus_117_b-a2",
          "directionId": 1,
          "headsign": "Pilaitė",
          "directionName": "Platiniškės–Pilaitė",
          "mode": "bus",
          "routeShortName": "117",
          "routeLongName": "Pilaitė–Kriaučiūnai–Platiniškės",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              -9527.218,
              -2633.5,
              0
            ],
            [
              -9523.64,
              -2638.291,
              5.98
            ],
            [
              -9524.772,
              -2639.86,
              7.915
            ],
            [
              -9528.807,
              -2636.135,
              13.406
            ],
            [
              -9611.217,
              -2524.924,
              151.823
            ],
            [
              -9616.801,
              -2511.476,
              166.384
            ],
            [
              -9621.06,
              -2495.823,
              182.607
            ],
            [
              -9634.023,
              -2403.262,
              276.071
            ],
            [
              -9650.771,
              -2299.426,
              381.249
            ],
            [
              -9654.642,
              -2251.46,
              429.371
            ],
            [
              -9662.262,
              -2212.414,
              469.153
            ],
            [
              -9667.686,
              -2188.95,
              493.236
            ],
            [
              -9695.735,
              -2129.501,
              558.97
            ],
            [
              -9732.147,
              -2036.478,
              658.866
            ],
            [
              -9742.689,
              -2002.957,
              694.005
            ],
            [
              -9749.152,
              -1963.892,
              733.601
            ],
            [
              -9753.556,
              -1917.318,
              780.383
            ],
            [
              -9757.88,
              -1899.226,
              798.984
            ],
            [
              -9770.904,
              -1873.376,
              827.93
            ],
            [
              -9817.16,
              -1806.051,
              909.614
            ],
            [
              -9855.151,
              -1740.67,
              985.231
            ],
            [
              -9876.278,
              -1691.351,
              1038.885
            ],
            [
              -9914.157,
              -1567.156,
              1168.728
            ],
            [
              -9915.294,
              -1551.579,
              1184.346
            ],
            [
              -9882.318,
              -1545.429,
              1217.891
            ],
            [
              -9847.302,
              -1532.632,
              1255.172
            ],
            [
              -9287.455,
              -1304.13,
              1859.855
            ],
            [
              -9269.24,
              -1298.762,
              1878.845
            ],
            [
              -9240.112,
              -1296.987,
              1908.027
            ],
            [
              -9211.102,
              -1300.999,
              1937.313
            ],
            [
              -9175.858,
              -1310.796,
              1973.893
            ],
            [
              -9147.698,
              -1323.497,
              2004.785
            ],
            [
              -9099.148,
              -1351,
              2060.584
            ],
            [
              -9063.343,
              -1368.314,
              2100.355
            ],
            [
              -8962.941,
              -1411.426,
              2209.623
            ],
            [
              -8878.976,
              -1449.193,
              2301.69
            ],
            [
              -8857.053,
              -1461.372,
              2326.769
            ],
            [
              -8804.758,
              -1483.795,
              2383.668
            ],
            [
              -8783.725,
              -1498.608,
              2409.394
            ],
            [
              -8760.977,
              -1526.808,
              2445.625
            ],
            [
              -8737.211,
              -1571.722,
              2496.44
            ],
            [
              -8720.742,
              -1593.061,
              2523.395
            ],
            [
              -8706.73,
              -1600.048,
              2539.052
            ],
            [
              -8686.179,
              -1604.836,
              2560.154
            ],
            [
              -8677.801,
              -1604.972,
              2568.533
            ],
            [
              -8628.445,
              -1595.764,
              2618.741
            ],
            [
              -8617.401,
              -1589.74,
              2631.321
            ],
            [
              -8587.705,
              -1560.108,
              2673.272
            ],
            [
              -8550.894,
              -1531.346,
              2719.987
            ],
            [
              -8448.084,
              -1472.913,
              2838.242
            ],
            [
              -8435.007,
              -1465.429,
              2853.309
            ],
            [
              -8209.48,
              -1340.773,
              3110.994
            ],
            [
              -8067.751,
              -1259.81,
              3274.218
            ],
            [
              -8051.177,
              -1254.733,
              3291.553
            ],
            [
              -8020.904,
              -1251.714,
              3321.976
            ],
            [
              -7941.222,
              -1267.496,
              3403.206
            ],
            [
              -7896.952,
              -1280.47,
              3449.338
            ],
            [
              -7871.226,
              -1284.233,
              3475.338
            ],
            [
              -7829.922,
              -1281.574,
              3516.727
            ],
            [
              -7722.308,
              -1245.501,
              3630.226
            ],
            [
              -7627.085,
              -1218.131,
              3729.305
            ],
            [
              -7532.532,
              -1155.873,
              3842.513
            ],
            [
              -7491.846,
              -1129.522,
              3890.988
            ],
            [
              -7457.002,
              -1109.661,
              3931.095
            ],
            [
              -7429.783,
              -1100.058,
              3959.958
            ],
            [
              -7062.071,
              -1009.319,
              4338.7
            ],
            [
              -7006.98,
              -993.643,
              4395.978
            ],
            [
              -6950.78,
              -985.57,
              4452.755
            ],
            [
              -6926.291,
              -985.429,
              4477.244
            ],
            [
              -6866.261,
              -995.702,
              4538.147
            ],
            [
              -6793.521,
              -1011.764,
              4612.639
            ],
            [
              -6750.162,
              -1017.863,
              4656.425
            ],
            [
              -6669.878,
              -1007.867,
              4737.329
            ],
            [
              -6650.463,
              -1010.723,
              4756.953
            ],
            [
              -6550.842,
              -1043.803,
              4861.922
            ],
            [
              -6504.306,
              -1067.804,
              4914.283
            ],
            [
              -6456.707,
              -1098.208,
              4970.764
            ],
            [
              -6395.488,
              -1154.334,
              5053.817
            ],
            [
              -6278.318,
              -1253.981,
              5207.63
            ],
            [
              -6242.049,
              -1282.421,
              5253.72
            ],
            [
              -6219.734,
              -1297.268,
              5280.523
            ],
            [
              -6161.019,
              -1318.155,
              5342.843
            ],
            [
              -6117.287,
              -1339.07,
              5391.318
            ],
            [
              -6043.087,
              -1373.717,
              5473.209
            ],
            [
              -5930.801,
              -1434.815,
              5601.041
            ],
            [
              -5889.893,
              -1464.248,
              5651.437
            ],
            [
              -5855.843,
              -1509.352,
              5707.951
            ],
            [
              -5832.257,
              -1563.184,
              5766.723
            ],
            [
              -5782.034,
              -1780.355,
              5989.626
            ],
            [
              -5738.678,
              -1888.118,
              6105.783
            ],
            [
              -5827.254,
              -1945.668,
              6211.413
            ],
            [
              -5930.998,
              -1988.982,
              6323.836
            ],
            [
              -6228.224,
              -1992.872,
              6621.088
            ],
            [
              -6278.571,
              -1995.984,
              6671.531
            ],
            [
              -6312.713,
              -1995.515,
              6705.675
            ],
            [
              -6605.358,
              -1994.8,
              6998.322
            ],
            [
              -6631.353,
              -1995.05,
              7024.318
            ],
            [
              -6677.514,
              -1993.121,
              7070.519
            ],
            [
              -6680.925,
              -1734.803,
              7328.86
            ],
            [
              -6684.251,
              -1702.465,
              7361.368
            ],
            [
              -6705.09,
              -1676.513,
              7394.651
            ],
            [
              -6747.127,
              -1568.943,
              7510.144
            ],
            [
              -6771.666,
              -1532.911,
              7553.738
            ],
            [
              -6834.733,
              -1410.519,
              7691.423
            ],
            [
              -6861.847,
              -1368.999,
              7741.012
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:7624",
              "position": {
                "x": -9525.29,
                "z": -2632.06
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 2.406,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:17205",
              "position": {
                "x": -8436.946,
                "z": -1461.964
              },
              "distanceAlongShapeM": 2853.309,
              "shapeOffsetM": 3.971,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:17196",
              "position": {
                "x": -7533.831,
                "z": -1153.995
              },
              "distanceAlongShapeM": 3842.462,
              "shapeOffsetM": 2.283,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:17191",
              "position": {
                "x": -7212.918,
                "z": -1046.884
              },
              "distanceAlongShapeM": 4183.246,
              "shapeOffsetM": 0.331,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:17124",
              "position": {
                "x": -6865.81,
                "z": -993.667
              },
              "distanceAlongShapeM": 4538.149,
              "shapeOffsetM": 2.084,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:17123",
              "position": {
                "x": -6502.736,
                "z": -1065.421
              },
              "distanceAlongShapeM": 4914.324,
              "shapeOffsetM": 2.853,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:17181",
              "position": {
                "x": -6160.094,
                "z": -1316.084
              },
              "distanceAlongShapeM": 5342.843,
              "shapeOffsetM": 2.268,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:17120",
              "position": {
                "x": -5784.265,
                "z": -1736.542
              },
              "distanceAlongShapeM": 5946.437,
              "shapeOffsetM": 7.698,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:6619",
              "position": {
                "x": -5825.26,
                "z": -1949.582
              },
              "distanceAlongShapeM": 6211.413,
              "shapeOffsetM": 4.393,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:6614",
              "position": {
                "x": -6278.639,
                "z": -2000.929
              },
              "distanceAlongShapeM": 6671.531,
              "shapeOffsetM": 4.946,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            },
            {
              "stopId": "judu:stop:6612",
              "position": {
                "x": -6631.209,
                "z": -1999.462
              },
              "distanceAlongShapeM": 7024.216,
              "shapeOffsetM": 4.413,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:7695",
              "position": {
                "x": -6705.09,
                "z": -1676.513
              },
              "distanceAlongShapeM": 7394.651,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:7693",
              "position": {
                "x": -6863.711,
                "z": -1369.96
              },
              "distanceAlongShapeM": 7741.012,
              "shapeOffsetM": 2.097,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            }
          ],
          "departuresSeconds": [
            20520,
            22080,
            24060,
            25500,
            27000,
            28800,
            30540,
            32100,
            34920,
            36540,
            38160,
            39780,
            41400,
            42960,
            44520,
            46080,
            47520,
            49200,
            50880,
            52680,
            54240,
            56160,
            57840,
            59340,
            60960,
            62640,
            64260,
            65820,
            67500,
            69300,
            71940,
            73800,
            75300,
            76740,
            78360,
            79920,
            81360,
            82920,
            84360,
            85800
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_bus_118",
      "sourceRouteId": "vilnius_bus_118",
      "mode": "bus",
      "shortName": "118",
      "longName": "Pilaitė–Varnės g.–Perkūnkiemis",
      "color": "0073AC",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_bus_118:0",
          "sourceRouteId": "vilnius_bus_118",
          "sourceShapeId": "vilnius_bus_118_a-b",
          "directionId": 0,
          "headsign": "Perkūnkiemis",
          "directionName": "Pilaitė–Varnės g.–Perkūnkiemis",
          "mode": "bus",
          "routeShortName": "118",
          "routeLongName": "Pilaitė–Varnės g.–Perkūnkiemis",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              -6782.722,
              -1517.922,
              0
            ],
            [
              -6790.213,
              -1503.239,
              16.483
            ],
            [
              -6789.666,
              -1493.237,
              26.501
            ],
            [
              -6789.574,
              -1493.338,
              26.637
            ],
            [
              -6793.888,
              -1496.036,
              31.725
            ],
            [
              -6804.801,
              -1471.131,
              58.916
            ],
            [
              -6817.871,
              -1443.083,
              89.859
            ],
            [
              -6849.755,
              -1383.551,
              157.392
            ],
            [
              -6861.847,
              -1368.999,
              176.312
            ],
            [
              -6868.44,
              -1344.278,
              201.897
            ],
            [
              -6865.755,
              -1340.811,
              206.282
            ],
            [
              -6856.389,
              -1336.272,
              216.69
            ],
            [
              -6847.396,
              -1333.735,
              226.034
            ],
            [
              -6839.19,
              -1361.045,
              254.55
            ],
            [
              -6823.318,
              -1421.841,
              317.384
            ],
            [
              -6726.31,
              -1602.786,
              522.693
            ],
            [
              -6717.082,
              -1622.391,
              544.361
            ],
            [
              -6684.251,
              -1702.465,
              630.904
            ],
            [
              -6676.395,
              -1733.766,
              663.176
            ],
            [
              -6677.514,
              -1993.121,
              922.533
            ],
            [
              -6624.319,
              -1987.967,
              975.977
            ],
            [
              -6584.624,
              -1989.111,
              1015.689
            ],
            [
              -6371.246,
              -1988.684,
              1229.067
            ],
            [
              -6349.222,
              -1988.597,
              1251.091
            ],
            [
              -6228.224,
              -1992.872,
              1372.165
            ],
            [
              -6226.946,
              -2337.985,
              1717.28
            ],
            [
              -6282.53,
              -2341.97,
              1773.007
            ],
            [
              -6377.159,
              -2339.91,
              1867.658
            ],
            [
              -6675.557,
              -2338.243,
              2166.061
            ],
            [
              -6743.953,
              -2341.19,
              2234.52
            ],
            [
              -6850.862,
              -2337.538,
              2341.492
            ],
            [
              -6995.956,
              -2341.796,
              2486.648
            ],
            [
              -7074.036,
              -2347.174,
              2564.913
            ],
            [
              -7144.675,
              -2331.526,
              2637.265
            ],
            [
              -7190.977,
              -2325.19,
              2683.998
            ],
            [
              -7292.824,
              -2325.724,
              2785.846
            ],
            [
              -7577.175,
              -2332.143,
              3070.27
            ],
            [
              -7619.606,
              -2550.971,
              3293.174
            ],
            [
              -7635.624,
              -2629.277,
              3373.101
            ],
            [
              -7663.869,
              -2776.633,
              3523.14
            ],
            [
              -7286.304,
              -2825.655,
              3903.875
            ],
            [
              -7256.777,
              -2832.825,
              3934.26
            ],
            [
              -6974.973,
              -2976.682,
              4250.659
            ],
            [
              -6950.006,
              -3001.795,
              4286.071
            ],
            [
              -6632.213,
              -3561.134,
              4929.384
            ],
            [
              -6501.664,
              -3824.834,
              5223.63
            ],
            [
              -6454.129,
              -3889.703,
              5304.051
            ],
            [
              -6427.689,
              -3927.592,
              5350.254
            ],
            [
              -6375.712,
              -4003.079,
              5441.904
            ],
            [
              -6363.283,
              -4020.751,
              5463.509
            ],
            [
              -6319.189,
              -3972.055,
              5529.202
            ],
            [
              -6292.282,
              -3942.524,
              5569.153
            ],
            [
              -6261.7,
              -3919.592,
              5607.378
            ],
            [
              -6204.851,
              -3884.138,
              5674.376
            ],
            [
              -6138.862,
              -3841.173,
              5753.12
            ],
            [
              -6130.086,
              -3838.626,
              5762.259
            ],
            [
              -6063.004,
              -3939.116,
              5883.082
            ],
            [
              -6039.971,
              -3971.722,
              5923.003
            ],
            [
              -6029.707,
              -3980.158,
              5936.289
            ],
            [
              -5982.973,
              -4047.605,
              6018.344
            ],
            [
              -5888.002,
              -4189.176,
              6188.82
            ],
            [
              -5885.573,
              -4200.458,
              6200.361
            ],
            [
              -5889.626,
              -4208.117,
              6209.026
            ],
            [
              -5900.587,
              -4218.301,
              6223.987
            ],
            [
              -5915.375,
              -4228.053,
              6241.702
            ],
            [
              -5993.646,
              -4281.77,
              6336.632
            ],
            [
              -6024.832,
              -4304.216,
              6375.056
            ],
            [
              -6145.801,
              -4387.352,
              6521.839
            ],
            [
              -6185.277,
              -4413.017,
              6568.924
            ],
            [
              -6227.195,
              -4446.218,
              6622.398
            ],
            [
              -6217.411,
              -4460.693,
              6639.869
            ],
            [
              -6174.391,
              -4515.863,
              6709.829
            ],
            [
              -6147.977,
              -4559.106,
              6760.502
            ],
            [
              -6136.229,
              -4584.016,
              6788.043
            ],
            [
              -5995.824,
              -4950.66,
              7180.651
            ],
            [
              -5997.296,
              -4947.917,
              7183.764
            ],
            [
              -5983.511,
              -4977.114,
              7216.052
            ],
            [
              -5963.946,
              -5025.616,
              7268.351
            ],
            [
              -5954.557,
              -5047.653,
              7292.305
            ],
            [
              -5917.492,
              -5099.709,
              7356.208
            ],
            [
              -5870.745,
              -5148.573,
              7423.832
            ],
            [
              -5845.606,
              -5167.502,
              7455.301
            ],
            [
              -5826.238,
              -5176.089,
              7476.487
            ],
            [
              -5803.951,
              -5182.624,
              7499.712
            ],
            [
              -5783.481,
              -5188.592,
              7521.034
            ],
            [
              -5768.708,
              -5191.069,
              7536.014
            ],
            [
              -5752.59,
              -5190.229,
              7552.153
            ],
            [
              -5745.811,
              -5188.92,
              7559.058
            ],
            [
              -5723.973,
              -5174.017,
              7585.496
            ],
            [
              -5700.812,
              -5158.945,
              7613.13
            ],
            [
              -5687.598,
              -5154.457,
              7627.085
            ],
            [
              -5645.843,
              -5145.22,
              7669.85
            ],
            [
              -5600.434,
              -5145.302,
              7715.259
            ],
            [
              -5575.256,
              -5150.983,
              7741.069
            ],
            [
              -5494.645,
              -5173.461,
              7824.756
            ],
            [
              -5460.904,
              -5178.949,
              7858.94
            ],
            [
              -5416.975,
              -5190.276,
              7904.306
            ],
            [
              -5372.043,
              -5191.233,
              7949.248
            ],
            [
              -5069.27,
              -5197.42,
              8252.084
            ],
            [
              -4792.724,
              -5185.463,
              8528.888
            ],
            [
              -4742.399,
              -5180.761,
              8579.433
            ],
            [
              -4156.396,
              -5191.488,
              9165.534
            ],
            [
              -4048.816,
              -5189.269,
              9273.137
            ],
            [
              -4047.433,
              -5048.201,
              9414.212
            ],
            [
              -3823.908,
              -5049.815,
              9637.743
            ],
            [
              -3827.684,
              -5087.455,
              9675.572
            ],
            [
              -3836.059,
              -5117.022,
              9706.302
            ],
            [
              -3846.109,
              -5119.902,
              9716.757
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:7694",
              "position": {
                "x": -6837.763,
                "z": -1360.375
              },
              "distanceAlongShapeM": 254.319,
              "shapeOffsetM": 1.56,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:4526",
              "position": {
                "x": -6711.23,
                "z": -1619.637
              },
              "distanceAlongShapeM": 544.361,
              "shapeOffsetM": 6.468,
              "arrivalOffsetSeconds": 60,
              "departureOffsetSeconds": 60
            },
            {
              "stopId": "judu:stop:6611",
              "position": {
                "x": -6624.485,
                "z": -1982.877
              },
              "distanceAlongShapeM": 975.977,
              "shapeOffsetM": 5.092,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:6615",
              "position": {
                "x": -6349.244,
                "z": -1983.044
              },
              "distanceAlongShapeM": 1251.091,
              "shapeOffsetM": 5.553,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:7948",
              "position": {
                "x": -6282.493,
                "z": -2344.842
              },
              "distanceAlongShapeM": 1773.007,
              "shapeOffsetM": 2.873,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:7950",
              "position": {
                "x": -6743.953,
                "z": -2342.665
              },
              "distanceAlongShapeM": 2234.52,
              "shapeOffsetM": 1.475,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:17221",
              "position": {
                "x": -7614.971,
                "z": -2551.929
              },
              "distanceAlongShapeM": 3293.183,
              "shapeOffsetM": 4.733,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:17225",
              "position": {
                "x": -6974.963,
                "z": -2976.665
              },
              "distanceAlongShapeM": 4250.659,
              "shapeOffsetM": 0.02,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:17230",
              "position": {
                "x": -6448.898,
                "z": -3886.047
              },
              "distanceAlongShapeM": 5304.051,
              "shapeOffsetM": 6.382,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:18926",
              "position": {
                "x": -5981.248,
                "z": -4046.438
              },
              "distanceAlongShapeM": 6018.344,
              "shapeOffsetM": 2.083,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            },
            {
              "stopId": "judu:stop:18928",
              "position": {
                "x": -6182.724,
                "z": -4417.071
              },
              "distanceAlongShapeM": 6569.44,
              "shapeOffsetM": 4.763,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:16896",
              "position": {
                "x": -6128.788,
                "z": -4580.508
              },
              "distanceAlongShapeM": 6788.043,
              "shapeOffsetM": 8.226,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:7392",
              "position": {
                "x": -5986.791,
                "z": -4945.811
              },
              "distanceAlongShapeM": 7179.353,
              "shapeOffsetM": 10.169,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:7845",
              "position": {
                "x": -5524.097,
                "z": -5162.941
              },
              "distanceAlongShapeM": 7793.56,
              "shapeOffsetM": 2.223,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:7395",
              "position": {
                "x": -4966.766,
                "z": -5192.496
              },
              "distanceAlongShapeM": 8354.705,
              "shapeOffsetM": 0.492,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            },
            {
              "stopId": "judu:stop:9768",
              "position": {
                "x": -4156.392,
                "z": -5190.871
              },
              "distanceAlongShapeM": 9165.551,
              "shapeOffsetM": 0.616,
              "arrivalOffsetSeconds": 1500,
              "departureOffsetSeconds": 1500
            },
            {
              "stopId": "judu:stop:6931",
              "position": {
                "x": -3827.361,
                "z": -5087.486
              },
              "distanceAlongShapeM": 9675.571,
              "shapeOffsetM": 0.325,
              "arrivalOffsetSeconds": 1620,
              "departureOffsetSeconds": 1620
            }
          ],
          "departuresSeconds": [
            19920,
            22020,
            23940,
            26040,
            29100,
            31380,
            34860,
            36960,
            39120,
            41220,
            43380,
            45540,
            47700,
            49860,
            52020,
            54180,
            56340,
            58560,
            60840,
            63120,
            65400,
            67500,
            70740,
            72840,
            74820,
            76800,
            78780,
            80760,
            82740,
            84720
          ]
        },
        {
          "id": "judu:pattern:vilnius_bus_118:1",
          "sourceRouteId": "vilnius_bus_118",
          "sourceShapeId": "vilnius_bus_118_b-a",
          "directionId": 1,
          "headsign": "Pilaitė",
          "directionName": "Perkūnkiemis–Varnės g.–Pilaitė",
          "mode": "bus",
          "routeShortName": "118",
          "routeLongName": "Pilaitė–Varnės g.–Perkūnkiemis",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              -3846.109,
              -5119.902,
              0
            ],
            [
              -3862.028,
              -5154.789,
              38.347
            ],
            [
              -3896.745,
              -5150.846,
              73.287
            ],
            [
              -3904.981,
              -5142.911,
              84.724
            ],
            [
              -3906.076,
              -5131.759,
              95.93
            ],
            [
              -3903.757,
              -5109.535,
              118.274
            ],
            [
              -3869.632,
              -5096.489,
              154.808
            ],
            [
              -3868.639,
              -5091.898,
              159.505
            ],
            [
              -3866.173,
              -5086.493,
              165.446
            ],
            [
              -3853.286,
              -5069.798,
              186.536
            ],
            [
              -3844.701,
              -5055.784,
              202.97
            ],
            [
              -4047.433,
              -5048.201,
              405.844
            ],
            [
              -4054.129,
              -5200.392,
              558.183
            ],
            [
              -4187.4,
              -5194.152,
              691.6
            ],
            [
              -4508.755,
              -5191.462,
              1012.967
            ],
            [
              -4560.955,
              -5192.789,
              1065.183
            ],
            [
              -4730.24,
              -5185.423,
              1234.629
            ],
            [
              -4792.724,
              -5185.463,
              1297.113
            ],
            [
              -4993.283,
              -5198.721,
              1498.109
            ],
            [
              -5032.681,
              -5200.077,
              1537.531
            ],
            [
              -5174.88,
              -5195.613,
              1679.8
            ],
            [
              -5316.341,
              -5190.444,
              1821.355
            ],
            [
              -5353.201,
              -5189.23,
              1858.235
            ],
            [
              -5402.148,
              -5191.901,
              1907.255
            ],
            [
              -5554.307,
              -5159.088,
              2062.912
            ],
            [
              -5574.822,
              -5151.098,
              2084.928
            ],
            [
              -5608.207,
              -5144.286,
              2119
            ],
            [
              -5629.424,
              -5144.453,
              2140.218
            ],
            [
              -5686.926,
              -5154.608,
              2198.61
            ],
            [
              -5717.438,
              -5168.562,
              2232.161
            ],
            [
              -5731.889,
              -5185.015,
              2254.06
            ],
            [
              -5748.774,
              -5192.431,
              2272.501
            ],
            [
              -5760.999,
              -5192.313,
              2284.727
            ],
            [
              -5810.631,
              -5183.905,
              2335.066
            ],
            [
              -5822.365,
              -5180.407,
              2347.311
            ],
            [
              -5857.729,
              -5160.617,
              2387.835
            ],
            [
              -5872.995,
              -5149.226,
              2406.882
            ],
            [
              -5920.769,
              -5100.255,
              2475.297
            ],
            [
              -5937.764,
              -5078.947,
              2502.552
            ],
            [
              -5972.136,
              -5012.508,
              2577.356
            ],
            [
              -5994.12,
              -4960.159,
              2634.134
            ],
            [
              -6022.55,
              -4902.824,
              2698.131
            ],
            [
              -6031.88,
              -4869.351,
              2732.879
            ],
            [
              -6038.764,
              -4848.198,
              2755.124
            ],
            [
              -6043.761,
              -4831.698,
              2772.364
            ],
            [
              -6051.008,
              -4805.423,
              2799.621
            ],
            [
              -6076.085,
              -4723.209,
              2885.574
            ],
            [
              -6109.893,
              -4644.28,
              2971.439
            ],
            [
              -6156.873,
              -4547.675,
              3078.862
            ],
            [
              -6191.78,
              -4498.381,
              3139.263
            ],
            [
              -6205.413,
              -4481.13,
              3161.25
            ],
            [
              -6223.89,
              -4456.353,
              3192.158
            ],
            [
              -6295.909,
              -4339.217,
              3329.664
            ],
            [
              -6279.379,
              -4328.279,
              3349.485
            ],
            [
              -6244.202,
              -4311.188,
              3388.594
            ],
            [
              -6196.102,
              -4278.968,
              3446.488
            ],
            [
              -6078.153,
              -4198.447,
              3589.301
            ],
            [
              -6038.165,
              -4171.208,
              3637.685
            ],
            [
              -5965.333,
              -4121.485,
              3725.872
            ],
            [
              -5944.077,
              -4107.053,
              3751.564
            ],
            [
              -6027.216,
              -3983.321,
              3900.634
            ],
            [
              -6041.169,
              -3971.808,
              3918.724
            ],
            [
              -6130.082,
              -3840.164,
              4077.581
            ],
            [
              -6281.322,
              -3933.328,
              4255.213
            ],
            [
              -6310.914,
              -3964.161,
              4297.949
            ],
            [
              -6362.99,
              -4026.641,
              4379.286
            ],
            [
              -6408.888,
              -3959.078,
              4460.964
            ],
            [
              -6473.734,
              -3866.624,
              4573.893
            ],
            [
              -6507.338,
              -3815.51,
              4635.063
            ],
            [
              -6573.849,
              -3678.446,
              4787.412
            ],
            [
              -6727.265,
              -3380.157,
              5122.842
            ],
            [
              -6894.905,
              -3083.755,
              5463.367
            ],
            [
              -6926.821,
              -3035.267,
              5521.416
            ],
            [
              -6964.803,
              -2985.741,
              5583.83
            ],
            [
              -7071.866,
              -2929.873,
              5704.593
            ],
            [
              -7107.861,
              -2907.659,
              5746.89
            ],
            [
              -7242.051,
              -2838.635,
              5897.792
            ],
            [
              -7274.762,
              -2829.186,
              5931.84
            ],
            [
              -7667.048,
              -2778.158,
              6327.431
            ],
            [
              -7640.652,
              -2645.077,
              6463.105
            ],
            [
              -7629.13,
              -2587.921,
              6521.41
            ],
            [
              -7577.61,
              -2332.332,
              6782.141
            ],
            [
              -7448.73,
              -2327.982,
              6911.094
            ],
            [
              -7201.882,
              -2323.377,
              7157.984
            ],
            [
              -7173.3,
              -2323.738,
              7186.569
            ],
            [
              -7097.84,
              -2344.551,
              7264.847
            ],
            [
              -7004.314,
              -2340.543,
              7358.458
            ],
            [
              -6921.18,
              -2340.332,
              7441.593
            ],
            [
              -6862.419,
              -2336.554,
              7500.475
            ],
            [
              -6640.332,
              -2313.345,
              7723.772
            ],
            [
              -6613.182,
              -2313.262,
              7750.922
            ],
            [
              -6383.798,
              -2313.082,
              7980.306
            ],
            [
              -6296.126,
              -2312.33,
              8067.981
            ],
            [
              -6225.814,
              -2309.061,
              8138.369
            ],
            [
              -6228.224,
              -1992.872,
              8454.567
            ],
            [
              -6278.571,
              -1995.984,
              8505.01
            ],
            [
              -6312.713,
              -1995.515,
              8539.155
            ],
            [
              -6605.358,
              -1994.8,
              8831.801
            ],
            [
              -6631.353,
              -1995.05,
              8857.797
            ],
            [
              -6677.514,
              -1993.121,
              8903.999
            ],
            [
              -6680.925,
              -1734.803,
              9162.339
            ],
            [
              -6684.251,
              -1702.465,
              9194.848
            ],
            [
              -6705.09,
              -1676.513,
              9228.131
            ],
            [
              -6747.127,
              -1568.943,
              9343.623
            ],
            [
              -6771.666,
              -1532.911,
              9387.217
            ],
            [
              -6834.733,
              -1410.519,
              9524.903
            ],
            [
              -6861.847,
              -1368.999,
              9574.492
            ],
            [
              -6869.747,
              -1345.369,
              9599.407
            ],
            [
              -6867.063,
              -1343.514,
              9602.67
            ],
            [
              -6860.969,
              -1338.463,
              9610.585
            ],
            [
              -6854.775,
              -1336.714,
              9617.021
            ],
            [
              -6851.79,
              -1340.583,
              9621.908
            ],
            [
              -6839.19,
              -1361.045,
              9645.938
            ],
            [
              -6825.084,
              -1411.793,
              9698.61
            ],
            [
              -6801.411,
              -1461.169,
              9753.368
            ],
            [
              -6771.957,
              -1511.755,
              9811.904
            ],
            [
              -6765.128,
              -1527.454,
              9829.024
            ],
            [
              -6769.807,
              -1537.394,
              9840.01
            ],
            [
              -6771.141,
              -1540.619,
              9843.501
            ],
            [
              -6827.09,
              -1597.371,
              9923.194
            ],
            [
              -6841.227,
              -1604.648,
              9939.094
            ],
            [
              -6863.189,
              -1570.343,
              9979.826
            ],
            [
              -6866.907,
              -1561.375,
              9989.535
            ],
            [
              -6864.843,
              -1553.618,
              9997.562
            ],
            [
              -6782.722,
              -1517.922,
              10087.106
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:7603",
              "position": {
                "x": -3854.099,
                "z": -5069.209
              },
              "distanceAlongShapeM": 186.614,
              "shapeOffsetM": 1,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:9766",
              "position": {
                "x": -4187.417,
                "z": -5197.013
              },
              "distanceAlongShapeM": 691.483,
              "shapeOffsetM": 2.859,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:17333",
              "position": {
                "x": -4394.793,
                "z": -5194.542
              },
              "distanceAlongShapeM": 898.983,
              "shapeOffsetM": 2.126,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:4479",
              "position": {
                "x": -5032.717,
                "z": -5206.951
              },
              "distanceAlongShapeM": 1537.531,
              "shapeOffsetM": 6.874,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:7844",
              "position": {
                "x": -5811.134,
                "z": -5185.897
              },
              "distanceAlongShapeM": 2335.066,
              "shapeOffsetM": 2.055,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:7393",
              "position": {
                "x": -6063.065,
                "z": -4808.711
              },
              "distanceAlongShapeM": 2799.993,
              "shapeOffsetM": 12.492,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:16898",
              "position": {
                "x": -6197.05,
                "z": -4502.546
              },
              "distanceAlongShapeM": 3138.91,
              "shapeOffsetM": 6.708,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:18927",
              "position": {
                "x": -6197.75,
                "z": -4276.554
              },
              "distanceAlongShapeM": 3446.462,
              "shapeOffsetM": 2.923,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:17232",
              "position": {
                "x": -6476.96,
                "z": -3868.878
              },
              "distanceAlongShapeM": 4573.893,
              "shapeOffsetM": 3.935,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:17228",
              "position": {
                "x": -7072.814,
                "z": -2931.62
              },
              "distanceAlongShapeM": 5704.593,
              "shapeOffsetM": 1.988,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:17223",
              "position": {
                "x": -7632.312,
                "z": -2587.264
              },
              "distanceAlongShapeM": 6521.426,
              "shapeOffsetM": 3.249,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:8371",
              "position": {
                "x": -7448.799,
                "z": -2325.363
              },
              "distanceAlongShapeM": 6911.094,
              "shapeOffsetM": 2.62,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:7951",
              "position": {
                "x": -6613.194,
                "z": -2309.232
              },
              "distanceAlongShapeM": 7750.922,
              "shapeOffsetM": 4.03,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:6614",
              "position": {
                "x": -6278.639,
                "z": -2000.929
              },
              "distanceAlongShapeM": 8505.01,
              "shapeOffsetM": 4.946,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            },
            {
              "stopId": "judu:stop:6612",
              "position": {
                "x": -6631.209,
                "z": -1999.462
              },
              "distanceAlongShapeM": 8857.696,
              "shapeOffsetM": 4.413,
              "arrivalOffsetSeconds": 1500,
              "departureOffsetSeconds": 1500
            },
            {
              "stopId": "judu:stop:7695",
              "position": {
                "x": -6705.09,
                "z": -1676.513
              },
              "distanceAlongShapeM": 9228.131,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1560,
              "departureOffsetSeconds": 1560
            },
            {
              "stopId": "judu:stop:7693",
              "position": {
                "x": -6863.711,
                "z": -1369.96
              },
              "distanceAlongShapeM": 9574.492,
              "shapeOffsetM": 2.097,
              "arrivalOffsetSeconds": 1620,
              "departureOffsetSeconds": 1620
            }
          ],
          "departuresSeconds": [
            21600,
            23760,
            26460,
            28680,
            30960,
            33540,
            36720,
            38820,
            41040,
            43020,
            45180,
            47340,
            49500,
            51660,
            53820,
            55980,
            58260,
            60480,
            62700,
            65040,
            67200,
            69300,
            72600,
            74700,
            76620,
            78480,
            80520,
            82500,
            84300,
            86280
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_bus_119",
      "sourceRouteId": "vilnius_bus_119",
      "mode": "bus",
      "shortName": "119",
      "longName": "Šiaurės miestelis–Antakalnis–Rokantiškės–Egliškės",
      "color": "0073AC",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_bus_119:0",
          "sourceRouteId": "vilnius_bus_119",
          "sourceShapeId": "vilnius_bus_119_a-b",
          "directionId": 0,
          "headsign": "Egliškės",
          "directionName": "Šiaurės miestelis–Antakalnis–Rokantiškės–Egliškės",
          "mode": "bus",
          "routeShortName": "119",
          "routeLongName": "Šiaurės miestelis–Antakalnis–Rokantiškės–Egliškės",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              1407.302,
              -2542.364,
              0
            ],
            [
              1404.085,
              -2529.725,
              13.042
            ],
            [
              1492.99,
              -2519.128,
              102.577
            ],
            [
              1552.992,
              -2512.565,
              162.937
            ],
            [
              1553.1,
              -2518.989,
              169.362
            ],
            [
              1555.103,
              -2528.173,
              178.763
            ],
            [
              1555.716,
              -2564.875,
              215.47
            ],
            [
              1565.454,
              -2573.909,
              228.753
            ],
            [
              1658.884,
              -2575.644,
              322.199
            ],
            [
              1668.545,
              -2575.213,
              331.87
            ],
            [
              1679.839,
              -2564.679,
              347.315
            ],
            [
              1679.479,
              -2552.424,
              359.575
            ],
            [
              1678.725,
              -2527.718,
              384.292
            ],
            [
              1679.06,
              -2495.866,
              416.146
            ],
            [
              1670.601,
              -2049.296,
              862.796
            ],
            [
              1665.105,
              -1963.474,
              948.794
            ],
            [
              1667.869,
              -1953.506,
              959.138
            ],
            [
              1677.147,
              -1950.75,
              968.816
            ],
            [
              1704.019,
              -1950.838,
              995.689
            ],
            [
              1835.898,
              -1931.027,
              1129.047
            ],
            [
              1974.971,
              -1905.788,
              1270.392
            ],
            [
              2068.207,
              -1884.15,
              1366.106
            ],
            [
              2082.899,
              -1876.616,
              1382.617
            ],
            [
              2103.214,
              -1873.671,
              1403.144
            ],
            [
              2192.003,
              -1848.613,
              1495.402
            ],
            [
              2201.025,
              -1848.782,
              1504.425
            ],
            [
              2213.852,
              -1852.361,
              1517.742
            ],
            [
              2234.245,
              -1864.989,
              1541.728
            ],
            [
              2253.259,
              -1873.113,
              1562.405
            ],
            [
              2259.919,
              -1871.035,
              1569.382
            ],
            [
              2494.922,
              -1772.432,
              1824.232
            ],
            [
              2535.981,
              -1760.432,
              1867.009
            ],
            [
              2561.157,
              -1758.678,
              1892.246
            ],
            [
              2583.027,
              -1761.316,
              1914.275
            ],
            [
              2605.004,
              -1760.128,
              1936.283
            ],
            [
              2739.18,
              -1719.722,
              2076.412
            ],
            [
              2791.156,
              -1698.435,
              2132.578
            ],
            [
              3080.798,
              -1542.666,
              2461.449
            ],
            [
              3132.044,
              -1502.255,
              2526.712
            ],
            [
              3259.998,
              -1401.722,
              2689.436
            ],
            [
              3309.234,
              -1365.006,
              2750.855
            ],
            [
              3355.774,
              -1345.811,
              2801.197
            ],
            [
              3462.231,
              -1316.43,
              2911.635
            ],
            [
              3532.238,
              -1289.832,
              2986.524
            ],
            [
              3600.113,
              -1232.754,
              3075.208
            ],
            [
              3620.624,
              -1217.957,
              3100.499
            ],
            [
              3648.222,
              -1211.625,
              3128.815
            ],
            [
              3749.954,
              -1235.046,
              3233.208
            ],
            [
              3788.2,
              -1241.53,
              3272
            ],
            [
              3871.206,
              -1244.237,
              3355.05
            ],
            [
              3891.797,
              -1248.622,
              3376.103
            ],
            [
              4021.303,
              -1318.898,
              3523.447
            ],
            [
              4085.972,
              -1351.449,
              3595.847
            ],
            [
              4121.001,
              -1359.416,
              3631.771
            ],
            [
              4500.92,
              -1362.466,
              4011.702
            ],
            [
              4515.089,
              -1343.238,
              4035.586
            ],
            [
              4527.688,
              -1345.168,
              4048.332
            ],
            [
              4536.864,
              -1358.631,
              4064.625
            ],
            [
              4570.501,
              -1388.687,
              4109.733
            ],
            [
              4585.807,
              -1407.515,
              4133.998
            ],
            [
              4687.775,
              -1502.991,
              4273.688
            ],
            [
              4747.032,
              -1556.868,
              4353.776
            ],
            [
              4850.416,
              -1650.635,
              4493.349
            ],
            [
              4873.291,
              -1681.796,
              4532.005
            ],
            [
              4892.083,
              -1707.317,
              4563.698
            ],
            [
              4935.048,
              -1752.677,
              4626.176
            ],
            [
              4957.325,
              -1767.58,
              4652.978
            ],
            [
              5027.779,
              -1793.3,
              4727.981
            ],
            [
              5112.316,
              -1820.673,
              4816.838
            ],
            [
              5148.212,
              -1831.387,
              4854.299
            ],
            [
              5188.082,
              -1836.611,
              4894.51
            ],
            [
              5235.836,
              -1834.197,
              4942.325
            ],
            [
              5256.588,
              -1827.919,
              4964.006
            ],
            [
              5278.737,
              -1816.102,
              4989.11
            ],
            [
              5310.481,
              -1781.433,
              5036.116
            ],
            [
              5325.291,
              -1770.751,
              5054.377
            ],
            [
              5346.147,
              -1762.9,
              5076.662
            ],
            [
              5394.475,
              -1763.224,
              5124.991
            ],
            [
              5407.279,
              -1766.587,
              5138.229
            ],
            [
              5445.017,
              -1788.439,
              5181.837
            ],
            [
              5454.706,
              -1796.631,
              5194.525
            ],
            [
              5471.603,
              -1809.858,
              5215.983
            ],
            [
              5510.705,
              -1835.123,
              5262.537
            ],
            [
              5537.621,
              -1850.531,
              5293.552
            ],
            [
              5539.738,
              -1854.567,
              5298.109
            ],
            [
              5540.886,
              -1855.792,
              5299.788
            ],
            [
              5539.401,
              -1854.908,
              5301.516
            ],
            [
              5531.692,
              -1850.319,
              5310.488
            ],
            [
              5526.895,
              -1847.463,
              5316.071
            ],
            [
              5524.505,
              -1846.04,
              5318.852
            ],
            [
              5518.81,
              -1842.65,
              5325.479
            ],
            [
              5520.295,
              -1843.535,
              5327.208
            ],
            [
              5535.27,
              -1852.254,
              5344.536
            ],
            [
              5666.371,
              -1928.539,
              5496.216
            ],
            [
              5726.051,
              -1974.255,
              5571.394
            ],
            [
              5809.685,
              -2023.753,
              5668.578
            ],
            [
              5909.138,
              -2053.247,
              5772.312
            ],
            [
              5956.254,
              -2052.798,
              5819.43
            ],
            [
              6035.821,
              -2044.677,
              5899.411
            ],
            [
              6104.633,
              -2042.301,
              5968.264
            ],
            [
              6231.263,
              -2064.001,
              6096.74
            ],
            [
              6263.68,
              -2069.175,
              6129.567
            ],
            [
              6454.692,
              -2110.689,
              6325.038
            ],
            [
              6496.176,
              -2125.975,
              6369.249
            ],
            [
              6571.996,
              -2164.859,
              6454.458
            ],
            [
              6605.969,
              -2185.766,
              6494.349
            ],
            [
              6713.842,
              -2261.998,
              6626.44
            ],
            [
              6732.16,
              -2275.807,
              6649.38
            ],
            [
              6746.774,
              -2281.408,
              6665.03
            ],
            [
              6792.085,
              -2286.888,
              6710.671
            ],
            [
              6827.465,
              -2283.873,
              6746.179
            ],
            [
              6898.699,
              -2276.521,
              6817.791
            ],
            [
              6977.94,
              -2266.207,
              6897.701
            ],
            [
              7198.611,
              -2242.259,
              7119.668
            ],
            [
              7367.753,
              -2220.704,
              7290.178
            ],
            [
              7413.967,
              -2206.342,
              7338.572
            ],
            [
              7496.697,
              -2196.963,
              7421.832
            ],
            [
              7554.833,
              -2193.576,
              7480.067
            ],
            [
              7595.621,
              -2197.91,
              7521.084
            ],
            [
              7635.166,
              -2210.524,
              7562.592
            ],
            [
              7780.374,
              -2282.316,
              7724.578
            ],
            [
              7810.216,
              -2289.218,
              7755.208
            ],
            [
              7871.881,
              -2293.386,
              7817.013
            ],
            [
              7914.559,
              -2298.299,
              7859.973
            ],
            [
              7945.325,
              -2307.414,
              7892.061
            ],
            [
              7987.417,
              -2326.802,
              7938.403
            ],
            [
              8079.752,
              -2383.123,
              8046.56
            ],
            [
              8150.657,
              -2429.153,
              8131.096
            ],
            [
              8171.95,
              -2445.187,
              8157.751
            ],
            [
              8197.194,
              -2466.998,
              8191.112
            ],
            [
              8283.308,
              -2576.713,
              8330.586
            ],
            [
              8323.583,
              -2623.697,
              8392.469
            ],
            [
              8361.264,
              -2675.134,
              8456.232
            ],
            [
              8375.149,
              -2689.885,
              8476.49
            ],
            [
              8401.998,
              -2710.147,
              8510.126
            ],
            [
              8500.566,
              -2760.671,
              8620.888
            ],
            [
              8528.241,
              -2769.797,
              8650.03
            ],
            [
              8612.872,
              -2792.634,
              8737.688
            ],
            [
              8666.681,
              -2809.303,
              8794.019
            ],
            [
              8692.666,
              -2817.195,
              8821.176
            ],
            [
              8758.059,
              -2860.845,
              8899.799
            ],
            [
              8799.632,
              -2886.665,
              8948.738
            ],
            [
              8865.284,
              -2933.543,
              9029.408
            ],
            [
              9007,
              -3088.489,
              9239.388
            ],
            [
              9241.125,
              -3386.903,
              9618.684
            ],
            [
              9285.21,
              -3444.426,
              9691.157
            ],
            [
              9304.87,
              -3471.303,
              9724.458
            ],
            [
              9316.301,
              -3483.759,
              9741.363
            ],
            [
              9353.766,
              -3446.642,
              9794.101
            ],
            [
              9396.351,
              -3400.538,
              9856.863
            ],
            [
              9459.816,
              -3334.125,
              9948.724
            ],
            [
              9470.282,
              -3326.545,
              9961.647
            ],
            [
              9471.417,
              -3324.174,
              9964.276
            ],
            [
              9477.938,
              -3310.666,
              9979.276
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:7589",
              "position": {
                "x": 1524.687,
                "z": -2513.037
              },
              "distanceAlongShapeM": 134.748,
              "shapeOffsetM": 2.608,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:5088",
              "position": {
                "x": 1670.083,
                "z": -2527.983
              },
              "distanceAlongShapeM": 384.291,
              "shapeOffsetM": 8.646,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:17239",
              "position": {
                "x": 2081.948,
                "z": -1873.274
              },
              "distanceAlongShapeM": 1382.617,
              "shapeOffsetM": 3.475,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:17241",
              "position": {
                "x": 2493.279,
                "z": -1768.537
              },
              "distanceAlongShapeM": 1824.224,
              "shapeOffsetM": 4.228,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:17246",
              "position": {
                "x": 2944.889,
                "z": -1614.499
              },
              "distanceAlongShapeM": 2307.729,
              "shapeOffsetM": 1.108,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:6883",
              "position": {
                "x": 4572.013,
                "z": -1387.211
              },
              "distanceAlongShapeM": 4109.733,
              "shapeOffsetM": 2.113,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:6887",
              "position": {
                "x": 4855.863,
                "z": -1646.502
              },
              "distanceAlongShapeM": 4493.349,
              "shapeOffsetM": 6.837,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:6888",
              "position": {
                "x": 5512.692,
                "z": -1852.928
              },
              "distanceAlongShapeM": 5325.479,
              "shapeOffsetM": 11.961,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            },
            {
              "stopId": "judu:stop:10319",
              "position": {
                "x": 5956.225,
                "z": -2051.94
              },
              "distanceAlongShapeM": 5819.489,
              "shapeOffsetM": 0.857,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:9606",
              "position": {
                "x": 6264.085,
                "z": -2066.871
              },
              "distanceAlongShapeM": 6129.567,
              "shapeOffsetM": 2.339,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:10531",
              "position": {
                "x": 6607.328,
                "z": -2183.827
              },
              "distanceAlongShapeM": 6494.349,
              "shapeOffsetM": 2.368,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:9604",
              "position": {
                "x": 6977.721,
                "z": -2263.494
              },
              "distanceAlongShapeM": 6897.776,
              "shapeOffsetM": 2.72,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:14663",
              "position": {
                "x": 7198.611,
                "z": -2242.259
              },
              "distanceAlongShapeM": 7119.668,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:17253",
              "position": {
                "x": 7871.964,
                "z": -2290.161
              },
              "distanceAlongShapeM": 7816.879,
              "shapeOffsetM": 3.223,
              "arrivalOffsetSeconds": 1380,
              "departureOffsetSeconds": 1380
            },
            {
              "stopId": "judu:stop:17256",
              "position": {
                "x": 8154.223,
                "z": -2423.832
              },
              "distanceAlongShapeM": 8131.096,
              "shapeOffsetM": 6.405,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            },
            {
              "stopId": "judu:stop:17263",
              "position": {
                "x": 8803.174,
                "z": -2881.078
              },
              "distanceAlongShapeM": 8948.738,
              "shapeOffsetM": 6.616,
              "arrivalOffsetSeconds": 1560,
              "departureOffsetSeconds": 1560
            },
            {
              "stopId": "judu:stop:18566",
              "position": {
                "x": 9022.984,
                "z": -3103.724
              },
              "distanceAlongShapeM": 9261.241,
              "shapeOffsetM": 3.171,
              "arrivalOffsetSeconds": 1560,
              "departureOffsetSeconds": 1560
            },
            {
              "stopId": "judu:stop:17272",
              "position": {
                "x": 9288.766,
                "z": -3441.984
              },
              "distanceAlongShapeM": 9691.286,
              "shapeOffsetM": 4.312,
              "arrivalOffsetSeconds": 1620,
              "departureOffsetSeconds": 1620
            },
            {
              "stopId": "judu:stop:17268",
              "position": {
                "x": 9473.131,
                "z": -3313.243
              },
              "distanceAlongShapeM": 9974.865,
              "shapeOffsetM": 3.209,
              "arrivalOffsetSeconds": 1620,
              "departureOffsetSeconds": 1620
            }
          ],
          "departuresSeconds": [
            19200,
            20640,
            21840,
            23040,
            24120,
            25200,
            26280,
            27420,
            28560,
            29880,
            31440,
            33000,
            34260,
            35520,
            36840,
            38220,
            39600,
            40980,
            42360,
            43740,
            45120,
            46500,
            47940,
            49320,
            50700,
            52140,
            53460,
            54780,
            56160,
            57000,
            58200,
            59460,
            60600,
            61560,
            62580,
            63840,
            65100,
            66120,
            67620,
            69300,
            70260,
            71580,
            72900,
            74400,
            75600,
            76980,
            78360,
            79680,
            81000,
            82320,
            83640
          ]
        },
        {
          "id": "judu:pattern:vilnius_bus_119:1",
          "sourceRouteId": "vilnius_bus_119",
          "sourceShapeId": "vilnius_bus_119_b-a",
          "directionId": 1,
          "headsign": "Šiaurės miestelis",
          "directionName": "Egliškės–Rokantiškės–Antakalnis–Šiaurės miestelis",
          "mode": "bus",
          "routeShortName": "119",
          "routeLongName": "Šiaurės miestelis–Antakalnis–Rokantiškės–Egliškės",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              9477.588,
              -3319.599,
              0
            ],
            [
              9478.066,
              -3310.905,
              8.707
            ],
            [
              9481.918,
              -3318.822,
              17.511
            ],
            [
              9463.082,
              -3331.965,
              40.48
            ],
            [
              9355,
              -3447.75,
              198.871
            ],
            [
              9333.615,
              -3469.574,
              229.426
            ],
            [
              9316.831,
              -3488.198,
              254.497
            ],
            [
              9252.607,
              -3402.292,
              361.757
            ],
            [
              9200.117,
              -3332.196,
              449.327
            ],
            [
              8993.566,
              -3075.509,
              778.8
            ],
            [
              8958.808,
              -3033.881,
              833.03
            ],
            [
              8896.213,
              -2972.997,
              920.351
            ],
            [
              8843.025,
              -2918.621,
              996.415
            ],
            [
              8782.698,
              -2880.488,
              1067.784
            ],
            [
              8693.078,
              -2817.376,
              1177.396
            ],
            [
              8678.811,
              -2815.114,
              1191.841
            ],
            [
              8648.73,
              -2804.488,
              1223.744
            ],
            [
              8489.833,
              -2756.76,
              1389.654
            ],
            [
              8417.095,
              -2719.673,
              1471.301
            ],
            [
              8391.009,
              -2703.531,
              1501.978
            ],
            [
              8366.929,
              -2681.927,
              1534.329
            ],
            [
              8316.077,
              -2614.109,
              1619.094
            ],
            [
              8263.757,
              -2555.168,
              1697.907
            ],
            [
              8239.373,
              -2517.367,
              1742.89
            ],
            [
              8207.88,
              -2480.571,
              1791.323
            ],
            [
              8190.102,
              -2461.089,
              1817.697
            ],
            [
              8169.883,
              -2443.697,
              1844.368
            ],
            [
              8144.618,
              -2426.129,
              1875.14
            ],
            [
              8119.932,
              -2409.618,
              1904.839
            ],
            [
              8070.056,
              -2377.616,
              1964.099
            ],
            [
              8014.018,
              -2343.096,
              2029.916
            ],
            [
              7948.338,
              -2309.363,
              2103.752
            ],
            [
              7907.455,
              -2297.896,
              2146.213
            ],
            [
              7871.246,
              -2294.22,
              2182.607
            ],
            [
              7850.005,
              -2293.672,
              2203.856
            ],
            [
              7781.274,
              -2282.588,
              2273.475
            ],
            [
              7680.553,
              -2231.165,
              2386.563
            ],
            [
              7634.722,
              -2209.394,
              2437.302
            ],
            [
              7591.844,
              -2197.288,
              2481.857
            ],
            [
              7565.633,
              -2193.74,
              2508.307
            ],
            [
              7422.876,
              -2204.569,
              2651.474
            ],
            [
              7344.075,
              -2225.649,
              2733.046
            ],
            [
              7312.312,
              -2230.04,
              2765.111
            ],
            [
              7285.057,
              -2234.972,
              2792.808
            ],
            [
              6885.062,
              -2277.86,
              3195.096
            ],
            [
              6758.788,
              -2283.666,
              3321.504
            ],
            [
              6733.788,
              -2276.493,
              3347.512
            ],
            [
              6602.353,
              -2186.712,
              3506.684
            ],
            [
              6584.271,
              -2175.613,
              3527.901
            ],
            [
              6542.211,
              -2151.374,
              3576.446
            ],
            [
              6503.317,
              -2129.457,
              3621.09
            ],
            [
              6436.091,
              -2105.871,
              3692.333
            ],
            [
              6181.107,
              -2057.452,
              3951.874
            ],
            [
              6111.071,
              -2045.984,
              4022.843
            ],
            [
              6042.053,
              -2046.841,
              4091.866
            ],
            [
              5963.805,
              -2055.375,
              4170.578
            ],
            [
              5942.067,
              -2053.103,
              4192.434
            ],
            [
              5884.65,
              -2052.769,
              4249.852
            ],
            [
              5829.247,
              -2034.064,
              4308.328
            ],
            [
              5764.388,
              -2004.779,
              4379.492
            ],
            [
              5745.315,
              -1991.048,
              4402.993
            ],
            [
              5727.728,
              -1979.687,
              4423.931
            ],
            [
              5697.118,
              -1950.031,
              4466.55
            ],
            [
              5679.465,
              -1938.293,
              4487.749
            ],
            [
              5634.824,
              -1906.866,
              4542.343
            ],
            [
              5590.731,
              -1884.504,
              4591.783
            ],
            [
              5512.372,
              -1836.223,
              4683.822
            ],
            [
              5505.455,
              -1827.28,
              4695.127
            ],
            [
              5497.693,
              -1827.072,
              4702.892
            ],
            [
              5504.996,
              -1834.483,
              4713.296
            ],
            [
              5505.467,
              -1834.824,
              4713.878
            ],
            [
              5515.946,
              -1841.083,
              4726.085
            ],
            [
              5523.99,
              -1845.734,
              4735.376
            ],
            [
              5527.857,
              -1848.036,
              4739.877
            ],
            [
              5518.81,
              -1842.65,
              4750.406
            ],
            [
              5511.083,
              -1836.198,
              4760.473
            ],
            [
              5475.747,
              -1812.651,
              4802.936
            ],
            [
              5448.75,
              -1791.349,
              4837.325
            ],
            [
              5407.793,
              -1766.782,
              4885.085
            ],
            [
              5375.85,
              -1761.323,
              4917.491
            ],
            [
              5339.515,
              -1764.574,
              4953.971
            ],
            [
              5328.445,
              -1768.78,
              4965.813
            ],
            [
              5308.521,
              -1783.482,
              4990.574
            ],
            [
              5287.701,
              -1808.287,
              5022.959
            ],
            [
              5270.213,
              -1822.586,
              5045.549
            ],
            [
              5244.776,
              -1832.724,
              5072.932
            ],
            [
              5198.333,
              -1837.541,
              5119.623
            ],
            [
              5188.082,
              -1836.611,
              5129.917
            ],
            [
              5172.595,
              -1837.357,
              5145.422
            ],
            [
              4985.466,
              -1779.256,
              5341.363
            ],
            [
              4940.762,
              -1757.24,
              5391.194
            ],
            [
              4874.771,
              -1688.658,
              5486.369
            ],
            [
              4817.852,
              -1611.266,
              5582.438
            ],
            [
              4761.938,
              -1568.989,
              5652.536
            ],
            [
              4592.397,
              -1415.215,
              5881.426
            ],
            [
              4538.493,
              -1360.135,
              5958.493
            ],
            [
              4529.838,
              -1367.475,
              5969.842
            ],
            [
              4518.882,
              -1367.264,
              5980.8
            ],
            [
              4505.978,
              -1363.834,
              5994.152
            ],
            [
              4351.306,
              -1364.048,
              6148.824
            ],
            [
              4139.238,
              -1363.741,
              6360.893
            ],
            [
              4110.991,
              -1358.947,
              6389.543
            ],
            [
              4077.651,
              -1348.216,
              6424.568
            ],
            [
              3897.38,
              -1250.687,
              6629.53
            ],
            [
              3861.528,
              -1243.026,
              6666.192
            ],
            [
              3808.141,
              -1243.453,
              6719.58
            ],
            [
              3786.905,
              -1241.513,
              6740.905
            ],
            [
              3754.701,
              -1236.079,
              6773.564
            ],
            [
              3662.853,
              -1213.128,
              6868.236
            ],
            [
              3635.268,
              -1213.444,
              6895.823
            ],
            [
              3604.725,
              -1231.186,
              6931.145
            ],
            [
              3510.759,
              -1302.242,
              7048.952
            ],
            [
              3365.726,
              -1344.886,
              7200.124
            ],
            [
              3321.066,
              -1359.996,
              7247.272
            ],
            [
              3073.135,
              -1549.012,
              7559.036
            ],
            [
              2976.151,
              -1602.69,
              7669.883
            ],
            [
              2869.871,
              -1657.496,
              7789.463
            ],
            [
              2778.12,
              -1705.983,
              7893.237
            ],
            [
              2746.955,
              -1717.642,
              7926.512
            ],
            [
              2617.246,
              -1758.619,
              8062.539
            ],
            [
              2535.96,
              -1761.545,
              8143.878
            ],
            [
              2369.041,
              -1827.436,
              8323.332
            ],
            [
              2272.849,
              -1869.051,
              8428.14
            ],
            [
              2224.183,
              -1885.952,
              8479.657
            ],
            [
              2215.971,
              -1876.892,
              8491.885
            ],
            [
              2210.565,
              -1859.208,
              8510.376
            ],
            [
              2204.247,
              -1848.842,
              8522.516
            ],
            [
              2079.807,
              -1884.367,
              8651.928
            ],
            [
              2025.955,
              -1900.505,
              8708.145
            ],
            [
              1998.15,
              -1907.334,
              8736.777
            ],
            [
              1855.148,
              -1935.839,
              8882.592
            ],
            [
              1712.252,
              -1958.784,
              9027.319
            ],
            [
              1677.37,
              -1962.589,
              9062.408
            ],
            [
              1675.815,
              -2011.543,
              9111.386
            ],
            [
              1684.596,
              -2579.462,
              9679.373
            ],
            [
              1622.02,
              -2584.755,
              9742.173
            ],
            [
              1614.3,
              -2581.496,
              9750.552
            ],
            [
              1426.817,
              -2576.903,
              9938.092
            ],
            [
              1419.812,
              -2572.32,
              9946.463
            ],
            [
              1406.874,
              -2540.387,
              9980.917
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:17268",
              "position": {
                "x": 9473.131,
                "z": -3313.243
              },
              "distanceAlongShapeM": 6.101,
              "shapeOffsetM": 4.8,
              "arrivalOffsetSeconds": -120,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:17270",
              "position": {
                "x": 9248.257,
                "z": -3405.537
              },
              "distanceAlongShapeM": 361.766,
              "shapeOffsetM": 5.427,
              "arrivalOffsetSeconds": 60,
              "departureOffsetSeconds": 60
            },
            {
              "stopId": "judu:stop:18565",
              "position": {
                "x": 8991.288,
                "z": -3077.477
              },
              "distanceAlongShapeM": 778.694,
              "shapeOffsetM": 3.008,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:17265",
              "position": {
                "x": 8781.89,
                "z": -2881.762
              },
              "distanceAlongShapeM": 1067.784,
              "shapeOffsetM": 1.509,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:17258",
              "position": {
                "x": 8141.847,
                "z": -2430.264
              },
              "distanceAlongShapeM": 1875.055,
              "shapeOffsetM": 4.977,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:17252",
              "position": {
                "x": 7849.877,
                "z": -2298.626
              },
              "distanceAlongShapeM": 2203.856,
              "shapeOffsetM": 4.955,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:10612",
              "position": {
                "x": 7285.671,
                "z": -2240.645
              },
              "distanceAlongShapeM": 2792.808,
              "shapeOffsetM": 5.706,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:9605",
              "position": {
                "x": 6885.221,
                "z": -2279.48
              },
              "distanceAlongShapeM": 3195.096,
              "shapeOffsetM": 1.628,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:10530",
              "position": {
                "x": 6582.95,
                "z": -2177.781
              },
              "distanceAlongShapeM": 3527.963,
              "shapeOffsetM": 2.538,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:9607",
              "position": {
                "x": 6326.245,
                "z": -2085.902
              },
              "distanceAlongShapeM": 3803.976,
              "shapeOffsetM": 0.874,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:10317",
              "position": {
                "x": 5963.871,
                "z": -2056.543
              },
              "distanceAlongShapeM": 4170.578,
              "shapeOffsetM": 1.17,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:6888",
              "position": {
                "x": 5512.692,
                "z": -1852.928
              },
              "distanceAlongShapeM": 4729.197,
              "shapeOffsetM": 11.883,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:6886",
              "position": {
                "x": 4871.116,
                "z": -1691.327
              },
              "distanceAlongShapeM": 5486.385,
              "shapeOffsetM": 4.526,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:17889",
              "position": {
                "x": 4588.816,
                "z": -1418.705
              },
              "distanceAlongShapeM": 5881.437,
              "shapeOffsetM": 5.001,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:17248",
              "position": {
                "x": 2977.926,
                "z": -1606.216
              },
              "distanceAlongShapeM": 7669.922,
              "shapeOffsetM": 3.948,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:17242",
              "position": {
                "x": 2480.742,
                "z": -1783.887
              },
              "distanceAlongShapeM": 8203.443,
              "shapeOffsetM": 0.507,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:5091",
              "position": {
                "x": 2031.037,
                "z": -1906.834
              },
              "distanceAlongShapeM": 8705.094,
              "shapeOffsetM": 7.522,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            },
            {
              "stopId": "judu:stop:5013",
              "position": {
                "x": 1621.888,
                "z": -2589.429
              },
              "distanceAlongShapeM": 9742.173,
              "shapeOffsetM": 4.676,
              "arrivalOffsetSeconds": 1500,
              "departureOffsetSeconds": 1500
            },
            {
              "stopId": "judu:stop:15167",
              "position": {
                "x": 1413.343,
                "z": -2538.803
              },
              "distanceAlongShapeM": 9979.956,
              "shapeOffsetM": 6.59,
              "arrivalOffsetSeconds": 1560,
              "departureOffsetSeconds": 1560
            }
          ],
          "departuresSeconds": [
            20820,
            22320,
            23580,
            24720,
            25800,
            27060,
            28200,
            29280,
            30420,
            31800,
            33360,
            34800,
            36060,
            37320,
            38640,
            40020,
            41400,
            42720,
            44100,
            45540,
            46980,
            48420,
            49860,
            51240,
            52620,
            54060,
            55440,
            56880,
            58260,
            59040,
            60240,
            61500,
            62640,
            63600,
            64620,
            65880,
            67020,
            67980,
            69480,
            71100,
            72120,
            73440,
            74700,
            76140,
            77340,
            78720,
            80100,
            81420,
            82740,
            84060,
            85380
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_bus_120",
      "sourceRouteId": "vilnius_bus_120",
      "mode": "bus",
      "shortName": "120",
      "longName": "Visoriai–Santariškės–Žaliųjų Ežerų g.–Kryžiokai",
      "color": "0073AC",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_bus_120:0",
          "sourceRouteId": "vilnius_bus_120",
          "sourceShapeId": "vilnius_bus_120_a-b",
          "directionId": 0,
          "headsign": "Kryžiokai",
          "directionName": "Visoriai–Santariškės–Žaliųjų Ežerų g.–Kryžiokai",
          "mode": "bus",
          "routeShortName": "120",
          "routeLongName": "Visoriai–Santariškės–Žaliųjų Ežerų g.–Kryžiokai",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              -996.594,
              -7701.107,
              0
            ],
            [
              -1008.525,
              -7702.28,
              11.989
            ],
            [
              -1017.416,
              -7702.312,
              20.88
            ],
            [
              -1031.635,
              -7698.523,
              35.595
            ],
            [
              -1034.149,
              -7695.138,
              39.812
            ],
            [
              -1034.672,
              -7688.449,
              46.521
            ],
            [
              -1028.056,
              -7678.549,
              58.428
            ],
            [
              -952.572,
              -7669.891,
              134.407
            ],
            [
              -687.301,
              -7633.495,
              402.163
            ],
            [
              -639.032,
              -7633.262,
              450.433
            ],
            [
              -608.156,
              -7636.041,
              481.434
            ],
            [
              -579.175,
              -7638.542,
              510.523
            ],
            [
              -565.284,
              -7641.614,
              524.749
            ],
            [
              -558.176,
              -7649.193,
              535.14
            ],
            [
              -554.82,
              -7712.708,
              598.743
            ],
            [
              -555.807,
              -7731.616,
              617.677
            ],
            [
              -545.691,
              -7741.818,
              632.044
            ],
            [
              -527.026,
              -7742.157,
              650.712
            ],
            [
              -486.981,
              -7735.09,
              691.376
            ],
            [
              -365.846,
              -7708.458,
              815.404
            ],
            [
              -195.003,
              -7692.779,
              986.965
            ],
            [
              49.054,
              -7679.166,
              1231.401
            ],
            [
              39.921,
              -7579.921,
              1331.066
            ],
            [
              26.258,
              -7471.636,
              1440.21
            ],
            [
              8.189,
              -7201.951,
              1710.499
            ],
            [
              -2.477,
              -7116.037,
              1797.072
            ],
            [
              -10.317,
              -7079.698,
              1834.248
            ],
            [
              -10.894,
              -7047.975,
              1865.976
            ],
            [
              -21.671,
              -6897.49,
              2016.846
            ],
            [
              -33.557,
              -6878.349,
              2039.377
            ],
            [
              -59.463,
              -6851.158,
              2076.934
            ],
            [
              -67.548,
              -6835.425,
              2094.623
            ],
            [
              -70.502,
              -6820.899,
              2109.446
            ],
            [
              -64.262,
              -6796.522,
              2134.609
            ],
            [
              -53.78,
              -6786.694,
              2148.978
            ],
            [
              -44.707,
              -6783.519,
              2158.59
            ],
            [
              -24.066,
              -6781.669,
              2179.314
            ],
            [
              0.443,
              -6790.505,
              2205.367
            ],
            [
              316.667,
              -6965.921,
              2566.986
            ],
            [
              488.123,
              -7067.612,
              2766.331
            ],
            [
              569.198,
              -7111.985,
              2858.754
            ],
            [
              607.888,
              -7122.125,
              2898.751
            ],
            [
              857.011,
              -7088.385,
              3150.148
            ],
            [
              912.144,
              -7077.353,
              3206.374
            ],
            [
              963.953,
              -7074.956,
              3258.238
            ],
            [
              999.073,
              -7089.195,
              3296.136
            ],
            [
              1051.285,
              -7144.223,
              3371.992
            ],
            [
              1072.093,
              -7168.96,
              3404.316
            ],
            [
              1095.862,
              -7195.215,
              3439.732
            ],
            [
              1133.283,
              -7225.965,
              3488.167
            ],
            [
              1291.476,
              -7341.333,
              3683.96
            ],
            [
              1307.902,
              -7358.336,
              3707.601
            ],
            [
              1326.737,
              -7384.29,
              3739.669
            ],
            [
              1553.349,
              -7767.005,
              4184.443
            ],
            [
              1621.327,
              -7885.162,
              4320.759
            ],
            [
              1632.975,
              -7916.55,
              4354.239
            ],
            [
              1640.555,
              -7958.994,
              4397.354
            ],
            [
              1640.017,
              -8022.44,
              4460.803
            ],
            [
              1642.406,
              -8067.015,
              4505.442
            ],
            [
              1656.397,
              -8103.348,
              4544.375
            ],
            [
              1677.887,
              -8132.245,
              4580.387
            ],
            [
              1693.917,
              -8148.951,
              4603.54
            ],
            [
              1731.324,
              -8201.149,
              4667.758
            ],
            [
              1750.194,
              -8224.879,
              4698.076
            ],
            [
              1771.941,
              -8240.583,
              4724.9
            ],
            [
              1800.494,
              -8254.762,
              4756.78
            ],
            [
              1956.145,
              -8296.632,
              4917.964
            ],
            [
              2001.461,
              -8317.518,
              4967.862
            ],
            [
              2065.812,
              -8353.233,
              5041.459
            ],
            [
              2107.826,
              -8378.511,
              5090.492
            ],
            [
              2156.129,
              -8411.7,
              5149.098
            ],
            [
              2317.488,
              -8560.563,
              5368.636
            ],
            [
              2642.21,
              -8852.78,
              5805.483
            ],
            [
              2791.088,
              -8986.135,
              6005.353
            ],
            [
              2937.046,
              -9115.683,
              6200.51
            ],
            [
              2991.321,
              -9163.457,
              6272.816
            ],
            [
              3011.49,
              -9179.33,
              6298.482
            ],
            [
              3028.932,
              -9199.631,
              6325.247
            ],
            [
              3134.104,
              -9331.147,
              6493.644
            ],
            [
              3165.86,
              -9378.122,
              6550.346
            ],
            [
              3173.134,
              -9395.181,
              6568.892
            ],
            [
              3208.182,
              -9555.935,
              6733.421
            ],
            [
              3213.698,
              -9570.512,
              6749.007
            ],
            [
              3220.466,
              -9581.843,
              6762.206
            ],
            [
              3233.82,
              -9595.386,
              6781.225
            ],
            [
              3263.762,
              -9611.54,
              6815.247
            ],
            [
              3404.645,
              -9675.718,
              6970.059
            ],
            [
              3447.994,
              -9704.103,
              7021.875
            ],
            [
              3478.945,
              -9734.751,
              7065.432
            ],
            [
              3511.635,
              -9775.451,
              7117.635
            ],
            [
              3546.778,
              -9856.276,
              7205.77
            ],
            [
              3563.744,
              -9877.752,
              7233.139
            ],
            [
              3583.678,
              -9891.979,
              7257.629
            ],
            [
              3682.485,
              -9978.543,
              7388.991
            ],
            [
              3753.117,
              -10037.223,
              7480.819
            ],
            [
              3823.892,
              -10096.649,
              7573.234
            ],
            [
              3844.831,
              -10118.191,
              7603.275
            ],
            [
              3858.592,
              -10138.8,
              7628.056
            ],
            [
              3926.673,
              -10148.641,
              7696.844
            ],
            [
              3939.417,
              -10136.766,
              7714.264
            ],
            [
              3958.891,
              -10112.407,
              7745.45
            ],
            [
              3976.899,
              -10082.83,
              7780.077
            ],
            [
              4005.248,
              -10076.848,
              7809.05
            ],
            [
              4078.036,
              -10076.185,
              7881.842
            ],
            [
              4616.869,
              -10074.981,
              8420.676
            ],
            [
              4852.261,
              -10074.019,
              8656.07
            ],
            [
              4900.288,
              -10073.896,
              8704.097
            ],
            [
              4837.14,
              -10286.278,
              8925.668
            ],
            [
              5053.096,
              -10366.148,
              9155.921
            ],
            [
              5067.726,
              -10355.898,
              9173.783
            ],
            [
              5077.073,
              -10342.162,
              9190.399
            ],
            [
              5140.98,
              -10365.235,
              9258.343
            ],
            [
              5193.783,
              -10214.258,
              9418.288
            ],
            [
              5482.746,
              -10294.379,
              9718.153
            ],
            [
              5760.86,
              -10375.066,
              10007.734
            ],
            [
              5751.64,
              -10409.001,
              10042.9
            ],
            [
              5655.864,
              -10678.028,
              10328.467
            ],
            [
              5647.437,
              -10698.509,
              10350.614
            ],
            [
              5534.566,
              -11051.436,
              10721.151
            ],
            [
              5456.299,
              -11281.484,
              10964.148
            ],
            [
              5343.994,
              -11250.024,
              11080.777
            ],
            [
              5282.147,
              -11227.842,
              11146.481
            ],
            [
              5096.68,
              -11163.671,
              11342.736
            ],
            [
              5050.627,
              -11147.787,
              11391.451
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:1115",
              "position": {
                "x": -995.773,
                "z": -7709.189
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 8.123,
              "arrivalOffsetSeconds": -420,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:7047",
              "position": {
                "x": -638.969,
                "z": -7631.03
              },
              "distanceAlongShapeM": 450.433,
              "shapeOffsetM": 2.233,
              "arrivalOffsetSeconds": 60,
              "departureOffsetSeconds": 60
            },
            {
              "stopId": "judu:stop:7831",
              "position": {
                "x": 25.801,
                "z": -7471.678
              },
              "distanceAlongShapeM": 1440.21,
              "shapeOffsetM": 0.459,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:6526",
              "position": {
                "x": -15.345,
                "z": -7080.178
              },
              "distanceAlongShapeM": 1834.248,
              "shapeOffsetM": 5.051,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:16627",
              "position": {
                "x": 320.415,
                "z": -6959.406
              },
              "distanceAlongShapeM": 2566.986,
              "shapeOffsetM": 7.516,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:6797",
              "position": {
                "x": 1056.317,
                "z": -7139.934
              },
              "distanceAlongShapeM": 3371.992,
              "shapeOffsetM": 6.612,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:6800",
              "position": {
                "x": 1694.973,
                "z": -8148.149
              },
              "distanceAlongShapeM": 4603.54,
              "shapeOffsetM": 1.326,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:6803",
              "position": {
                "x": 3013.269,
                "z": -9177.069
              },
              "distanceAlongShapeM": 6298.482,
              "shapeOffsetM": 2.877,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:6856",
              "position": {
                "x": 3684.789,
                "z": -9975.801
              },
              "distanceAlongShapeM": 7388.918,
              "shapeOffsetM": 3.581,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:10554",
              "position": {
                "x": 3850.114,
                "z": -10113.666
              },
              "distanceAlongShapeM": 7603.275,
              "shapeOffsetM": 6.956,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:9046",
              "position": {
                "x": 4200.33,
                "z": -10072.504
              },
              "distanceAlongShapeM": 8004.144,
              "shapeOffsetM": 3.408,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:9048",
              "position": {
                "x": 4616.81,
                "z": -10066.046
              },
              "distanceAlongShapeM": 8420.637,
              "shapeOffsetM": 8.935,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:15114",
              "position": {
                "x": 4852.251,
                "z": -10070.594
              },
              "distanceAlongShapeM": 8656.07,
              "shapeOffsetM": 3.425,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:9081",
              "position": {
                "x": 5073.204,
                "z": -10357.647
              },
              "distanceAlongShapeM": 9175.419,
              "shapeOffsetM": 5.513,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            },
            {
              "stopId": "judu:stop:17133",
              "position": {
                "x": 5483.07,
                "z": -10293.25
              },
              "distanceAlongShapeM": 9718.153,
              "shapeOffsetM": 1.175,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            },
            {
              "stopId": "judu:stop:19105",
              "position": {
                "x": 5735.162,
                "z": -10367.193
              },
              "distanceAlongShapeM": 9980.861,
              "shapeOffsetM": 0.401,
              "arrivalOffsetSeconds": 1500,
              "departureOffsetSeconds": 1500
            },
            {
              "stopId": "judu:stop:17131",
              "position": {
                "x": 5652.72,
                "z": -10700.683
              },
              "distanceAlongShapeM": 10351.075,
              "shapeOffsetM": 5.694,
              "arrivalOffsetSeconds": 1560,
              "departureOffsetSeconds": 1560
            },
            {
              "stopId": "judu:stop:17792",
              "position": {
                "x": 5537.763,
                "z": -11052.467
              },
              "distanceAlongShapeM": 10721.151,
              "shapeOffsetM": 3.359,
              "arrivalOffsetSeconds": 1620,
              "departureOffsetSeconds": 1620
            },
            {
              "stopId": "judu:stop:17130",
              "position": {
                "x": 5342.766,
                "z": -11253.514
              },
              "distanceAlongShapeM": 11080.777,
              "shapeOffsetM": 3.7,
              "arrivalOffsetSeconds": 1680,
              "departureOffsetSeconds": 1680
            },
            {
              "stopId": "judu:stop:17129",
              "position": {
                "x": 5048.769,
                "z": -11153.173
              },
              "distanceAlongShapeM": 11391.451,
              "shapeOffsetM": 5.698,
              "arrivalOffsetSeconds": 1740,
              "departureOffsetSeconds": 1740
            }
          ],
          "departuresSeconds": [
            19800,
            20880,
            22260,
            23640,
            25140,
            26640,
            28440,
            29880,
            31320,
            33900,
            36480,
            38280,
            40080,
            42000,
            43920,
            45840,
            47760,
            49740,
            51660,
            53460,
            55200,
            56940,
            57960,
            58980,
            60660,
            61980,
            63300,
            65160,
            67320,
            68700,
            70080,
            71460,
            72660,
            75060,
            76740,
            78480,
            80280
          ]
        },
        {
          "id": "judu:pattern:vilnius_bus_120:1",
          "sourceRouteId": "vilnius_bus_120",
          "sourceShapeId": "vilnius_bus_120_b-a",
          "directionId": 1,
          "headsign": "Visoriai",
          "directionName": "Kryžiokai–Žaliųjų Ežerų g.–Santariškės–Visoriai",
          "mode": "bus",
          "routeShortName": "120",
          "routeLongName": "Visoriai–Santariškės–Žaliųjų Ežerų g.–Kryžiokai",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              5050.627,
              -11147.787,
              0
            ],
            [
              4890.758,
              -11090.886,
              169.693
            ],
            [
              4694.841,
              -11023.862,
              376.757
            ],
            [
              4603.509,
              -11002.02,
              470.665
            ],
            [
              4535.959,
              -10823.73,
              661.323
            ],
            [
              4560.877,
              -10808.935,
              690.302
            ],
            [
              4623.16,
              -10770.877,
              763.292
            ],
            [
              4671.079,
              -10721.704,
              831.952
            ],
            [
              4731.771,
              -10570.304,
              995.065
            ],
            [
              4767.333,
              -10475.321,
              1096.487
            ],
            [
              4834.832,
              -10283.879,
              1299.479
            ],
            [
              5060.766,
              -10368.539,
              1540.754
            ],
            [
              5067.726,
              -10355.898,
              1555.184
            ],
            [
              5061.006,
              -10368.904,
              1569.823
            ],
            [
              5026.912,
              -10355.636,
              1606.408
            ],
            [
              4837.27,
              -10288.031,
              1807.739
            ],
            [
              4899.661,
              -10076.829,
              2027.965
            ],
            [
              4160.977,
              -10076.356,
              2766.649
            ],
            [
              4078.036,
              -10076.185,
              2849.59
            ],
            [
              4005.248,
              -10076.848,
              2922.382
            ],
            [
              3980.716,
              -10084.256,
              2948.007
            ],
            [
              3969.224,
              -10095.225,
              2963.893
            ],
            [
              3948.343,
              -10125.564,
              3000.724
            ],
            [
              3935.258,
              -10140.984,
              3020.948
            ],
            [
              3926.621,
              -10148.536,
              3032.421
            ],
            [
              3926.646,
              -10148.59,
              3032.479
            ],
            [
              3858.592,
              -10138.8,
              3101.234
            ],
            [
              3836.085,
              -10112.757,
              3135.655
            ],
            [
              3633.404,
              -9936.97,
              3403.947
            ],
            [
              3615.583,
              -9923.348,
              3426.378
            ],
            [
              3583.925,
              -9891.609,
              3471.206
            ],
            [
              3560.012,
              -9871.001,
              3502.774
            ],
            [
              3541.801,
              -9847.275,
              3532.683
            ],
            [
              3514.661,
              -9785.528,
              3600.131
            ],
            [
              3500.953,
              -9761.888,
              3627.458
            ],
            [
              3482.098,
              -9738.151,
              3657.773
            ],
            [
              3456.873,
              -9710.952,
              3694.868
            ],
            [
              3423.2,
              -9688.046,
              3735.594
            ],
            [
              3388.156,
              -9669.567,
              3775.211
            ],
            [
              3277.145,
              -9618.474,
              3897.416
            ],
            [
              3228.737,
              -9591.949,
              3952.614
            ],
            [
              3213.634,
              -9573.85,
              3976.187
            ],
            [
              3206.315,
              -9552.559,
              3998.701
            ],
            [
              3171.376,
              -9392.699,
              4162.335
            ],
            [
              3164.552,
              -9379.21,
              4177.452
            ],
            [
              3134.104,
              -9331.147,
              4234.348
            ],
            [
              3021.317,
              -9193.92,
              4411.977
            ],
            [
              2970.687,
              -9148.431,
              4480.04
            ],
            [
              2956.452,
              -9138.027,
              4497.671
            ],
            [
              2944.749,
              -9124.562,
              4515.512
            ],
            [
              2590.356,
              -8808.28,
              4990.516
            ],
            [
              2140.228,
              -8401.383,
              5597.295
            ],
            [
              2107.826,
              -8378.511,
              5636.956
            ],
            [
              1978.502,
              -8305.956,
              5785.242
            ],
            [
              1955.502,
              -8296.62,
              5810.065
            ],
            [
              1919.797,
              -8287.49,
              5846.919
            ],
            [
              1794.124,
              -8252.003,
              5977.506
            ],
            [
              1773.386,
              -8241.44,
              6000.78
            ],
            [
              1750.194,
              -8224.879,
              6029.277
            ],
            [
              1684.136,
              -8142.38,
              6134.964
            ],
            [
              1655.922,
              -8101.778,
              6184.407
            ],
            [
              1643.486,
              -8078.168,
              6211.092
            ],
            [
              1639.977,
              -8059.177,
              6230.404
            ],
            [
              1639.433,
              -7950.068,
              6339.515
            ],
            [
              1629.362,
              -7903.123,
              6387.528
            ],
            [
              1545.21,
              -7754.608,
              6558.227
            ],
            [
              1341.067,
              -7410.16,
              6958.625
            ],
            [
              1312.907,
              -7366.221,
              7010.814
            ],
            [
              1291.476,
              -7341.333,
              7043.657
            ],
            [
              1145.93,
              -7238.444,
              7221.898
            ],
            [
              1102.154,
              -7203.124,
              7278.146
            ],
            [
              1045.977,
              -7141.97,
              7361.186
            ],
            [
              1029.249,
              -7124.149,
              7385.628
            ],
            [
              999.073,
              -7089.195,
              7431.806
            ],
            [
              951.943,
              -7073.438,
              7481.5
            ],
            [
              652.324,
              -7119.127,
              7784.583
            ],
            [
              622.009,
              -7121.909,
              7815.025
            ],
            [
              600.797,
              -7121.363,
              7836.244
            ],
            [
              577.752,
              -7115.358,
              7860.059
            ],
            [
              329.932,
              -6977.833,
              8143.48
            ],
            [
              229.7,
              -6919.895,
              8259.253
            ],
            [
              60.82,
              -6823.295,
              8453.809
            ],
            [
              14.911,
              -6833.59,
              8500.858
            ],
            [
              7.024,
              -6842.352,
              8512.647
            ],
            [
              -10.864,
              -6869.857,
              8545.457
            ],
            [
              -21.671,
              -6897.49,
              8575.128
            ],
            [
              -11.966,
              -6926.765,
              8605.97
            ],
            [
              -9.853,
              -6955.595,
              8634.877
            ],
            [
              6.027,
              -7144.023,
              8823.973
            ],
            [
              11.629,
              -7176.924,
              8857.347
            ],
            [
              9.978,
              -7209.777,
              8890.242
            ],
            [
              38.024,
              -7507.525,
              9189.308
            ],
            [
              44.494,
              -7541.041,
              9223.443
            ],
            [
              49.677,
              -7680.291,
              9362.789
            ],
            [
              -112.073,
              -7688.472,
              9524.746
            ],
            [
              -235.869,
              -7698.463,
              9648.945
            ],
            [
              -384.304,
              -7718.029,
              9798.664
            ],
            [
              -496.736,
              -7740.48,
              9913.315
            ],
            [
              -530.928,
              -7744.312,
              9947.721
            ],
            [
              -541.206,
              -7743.013,
              9958.081
            ],
            [
              -548.225,
              -7739.546,
              9965.91
            ],
            [
              -551.986,
              -7733.911,
              9972.685
            ],
            [
              -555.282,
              -7702.681,
              10004.088
            ],
            [
              -554.988,
              -7674.967,
              10031.804
            ],
            [
              -555.823,
              -7661.481,
              10045.315
            ],
            [
              -559.997,
              -7652.425,
              10055.287
            ],
            [
              -567.106,
              -7644.578,
              10065.875
            ],
            [
              -661.958,
              -7636.641,
              10161.059
            ],
            [
              -677.044,
              -7635.907,
              10176.163
            ],
            [
              -928.758,
              -7670.321,
              10430.218
            ],
            [
              -968.788,
              -7695.626,
              10477.576
            ],
            [
              -996.594,
              -7701.107,
              10505.917
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:17129",
              "position": {
                "x": 5048.769,
                "z": -11153.173
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 5.698,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:9054",
              "position": {
                "x": 4558.82,
                "z": -10804.147
              },
              "distanceAlongShapeM": 691.043,
              "shapeOffsetM": 5.158,
              "arrivalOffsetSeconds": 60,
              "departureOffsetSeconds": 60
            },
            {
              "stopId": "judu:stop:16832",
              "position": {
                "x": 4764.013,
                "z": -10474.123
              },
              "distanceAlongShapeM": 1096.444,
              "shapeOffsetM": 3.529,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:9081",
              "position": {
                "x": 5073.204,
                "z": -10357.647
              },
              "distanceAlongShapeM": 1555.184,
              "shapeOffsetM": 5.75,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:15113",
              "position": {
                "x": 4825.104,
                "z": -10076.748
              },
              "distanceAlongShapeM": 2102.522,
              "shapeOffsetM": 0.033,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:9047",
              "position": {
                "x": 4559.944,
                "z": -10078.309
              },
              "distanceAlongShapeM": 2367.681,
              "shapeOffsetM": 1.698,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:9045",
              "position": {
                "x": 4160.961,
                "z": -10078.428
              },
              "distanceAlongShapeM": 2766.661,
              "shapeOffsetM": 2.072,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:10556",
              "position": {
                "x": 3832.039,
                "z": -10116.66
              },
              "distanceAlongShapeM": 3136.154,
              "shapeOffsetM": 5.6,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:6857",
              "position": {
                "x": 3613.674,
                "z": -9925.461
              },
              "distanceAlongShapeM": 3426.378,
              "shapeOffsetM": 2.847,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:6804",
              "position": {
                "x": 2953.441,
                "z": -9141.425
              },
              "distanceAlongShapeM": 4497.671,
              "shapeOffsetM": 4.54,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:6801",
              "position": {
                "x": 1918.925,
                "z": -8290.37
              },
              "distanceAlongShapeM": 5846.975,
              "shapeOffsetM": 3.008,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:6798",
              "position": {
                "x": 1026.954,
                "z": -7126.033
              },
              "distanceAlongShapeM": 7385.702,
              "shapeOffsetM": 2.968,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:16628",
              "position": {
                "x": 229.7,
                "z": -6919.895
              },
              "distanceAlongShapeM": 8259.253,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:6525",
              "position": {
                "x": -10.612,
                "z": -6926.637
              },
              "distanceAlongShapeM": 8605.97,
              "shapeOffsetM": 1.36,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:6532",
              "position": {
                "x": 16.38,
                "z": -7176.496
              },
              "distanceAlongShapeM": 8857.347,
              "shapeOffsetM": 4.77,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:8716",
              "position": {
                "x": 44.494,
                "z": -7541.041
              },
              "distanceAlongShapeM": 9223.443,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            },
            {
              "stopId": "judu:stop:7046",
              "position": {
                "x": -661.758,
                "z": -7645.09
              },
              "distanceAlongShapeM": 10160.155,
              "shapeOffsetM": 8.403,
              "arrivalOffsetSeconds": 1500,
              "departureOffsetSeconds": 1500
            },
            {
              "stopId": "judu:stop:1115",
              "position": {
                "x": -995.773,
                "z": -7709.189
              },
              "distanceAlongShapeM": 10505.917,
              "shapeOffsetM": 8.123,
              "arrivalOffsetSeconds": 1560,
              "departureOffsetSeconds": 1560
            }
          ],
          "departuresSeconds": [
            21480,
            22560,
            24000,
            25380,
            27000,
            28500,
            30300,
            31740,
            33120,
            35640,
            38220,
            40020,
            41820,
            43800,
            45720,
            47580,
            49500,
            51480,
            53400,
            55260,
            56940,
            58680,
            59760,
            60780,
            62520,
            63840,
            65160,
            66960,
            69120,
            70440,
            71820,
            73200,
            74340,
            76740,
            78420,
            80160,
            81960
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_bus_121",
      "sourceRouteId": "vilnius_bus_121",
      "mode": "bus",
      "shortName": "121",
      "longName": "Santariškės–Mažieji Gulbinai–Didžiųjų Gulbinų g.",
      "color": "0073AC",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_bus_121:0",
          "sourceRouteId": "vilnius_bus_121",
          "sourceShapeId": "vilnius_bus_121_a-b",
          "directionId": 0,
          "headsign": "Didžiųjų Gulbinų g.",
          "directionName": "Santariškės–Mažieji Gulbinai–Didžiųjų Gulbinų g.",
          "mode": "bus",
          "routeShortName": "121",
          "routeLongName": "Santariškės–Mažieji Gulbinai–Didžiųjų Gulbinų g.",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              71.413,
              -7563.928,
              0
            ],
            [
              68.088,
              -7589.527,
              25.814
            ],
            [
              45.368,
              -7598.945,
              50.409
            ],
            [
              37.787,
              -7591.014,
              61.38
            ],
            [
              26.258,
              -7471.636,
              181.314
            ],
            [
              8.189,
              -7201.951,
              451.603
            ],
            [
              -2.477,
              -7116.037,
              538.177
            ],
            [
              -10.317,
              -7079.698,
              575.352
            ],
            [
              -10.894,
              -7047.975,
              607.08
            ],
            [
              -21.671,
              -6897.49,
              757.951
            ],
            [
              -33.557,
              -6878.349,
              780.482
            ],
            [
              -59.463,
              -6851.158,
              818.038
            ],
            [
              -67.548,
              -6835.425,
              835.727
            ],
            [
              -70.502,
              -6820.899,
              850.55
            ],
            [
              -64.262,
              -6796.522,
              875.713
            ],
            [
              -53.78,
              -6786.694,
              890.082
            ],
            [
              -33.722,
              -6781.493,
              910.803
            ],
            [
              -15.095,
              -6784.06,
              929.606
            ],
            [
              0.443,
              -6790.505,
              946.428
            ],
            [
              316.667,
              -6965.921,
              1308.048
            ],
            [
              488.123,
              -7067.612,
              1507.392
            ],
            [
              569.198,
              -7111.985,
              1599.815
            ],
            [
              607.888,
              -7122.125,
              1639.812
            ],
            [
              857.011,
              -7088.385,
              1891.209
            ],
            [
              912.144,
              -7077.353,
              1947.435
            ],
            [
              963.953,
              -7074.956,
              1999.299
            ],
            [
              999.073,
              -7089.195,
              2037.197
            ],
            [
              1051.285,
              -7144.223,
              2113.053
            ],
            [
              1072.093,
              -7168.96,
              2145.377
            ],
            [
              1095.862,
              -7195.215,
              2180.794
            ],
            [
              1133.283,
              -7225.965,
              2229.228
            ],
            [
              1291.476,
              -7341.333,
              2425.021
            ],
            [
              1307.902,
              -7358.336,
              2448.662
            ],
            [
              1326.737,
              -7384.29,
              2480.73
            ],
            [
              1553.349,
              -7767.005,
              2925.504
            ],
            [
              1621.327,
              -7885.162,
              3061.82
            ],
            [
              1632.975,
              -7916.55,
              3095.3
            ],
            [
              1640.555,
              -7958.994,
              3138.415
            ],
            [
              1640.017,
              -8022.44,
              3201.864
            ],
            [
              1642.406,
              -8067.015,
              3246.503
            ],
            [
              1656.397,
              -8103.348,
              3285.436
            ],
            [
              1677.887,
              -8132.245,
              3321.448
            ],
            [
              1693.917,
              -8148.951,
              3344.601
            ],
            [
              1750.194,
              -8224.879,
              3439.111
            ],
            [
              1723.749,
              -8267.334,
              3489.129
            ],
            [
              1714.413,
              -8277.642,
              3503.036
            ],
            [
              1696.683,
              -8310.604,
              3540.464
            ],
            [
              1688.883,
              -8354.952,
              3585.493
            ],
            [
              1673.741,
              -8375.686,
              3611.167
            ],
            [
              1651.751,
              -8394.28,
              3639.965
            ],
            [
              1605.078,
              -8516.076,
              3770.398
            ],
            [
              1509.214,
              -8610.777,
              3905.15
            ],
            [
              1437.883,
              -8737.31,
              4050.404
            ],
            [
              1402.282,
              -8826.746,
              4146.665
            ],
            [
              1362.348,
              -9015.539,
              4339.636
            ],
            [
              1331.991,
              -9100.347,
              4429.713
            ],
            [
              1324.72,
              -9124.272,
              4454.718
            ],
            [
              1318.943,
              -9262.069,
              4592.636
            ],
            [
              1308.077,
              -9362.2,
              4693.355
            ],
            [
              1287.175,
              -9462.933,
              4796.233
            ],
            [
              1251.247,
              -9629.547,
              4966.677
            ],
            [
              1250.716,
              -9649.433,
              4986.57
            ],
            [
              1262.043,
              -9721.645,
              5059.666
            ],
            [
              1237.413,
              -9766.464,
              5110.807
            ],
            [
              1181.698,
              -9832.466,
              5197.18
            ],
            [
              1170.539,
              -9855.159,
              5222.469
            ],
            [
              1151.042,
              -9951.535,
              5320.797
            ],
            [
              1129.1,
              -10025.724,
              5398.163
            ],
            [
              1111.694,
              -10168.867,
              5542.36
            ],
            [
              1086.861,
              -10223.571,
              5602.437
            ],
            [
              1064.312,
              -10267.003,
              5651.374
            ],
            [
              1056.067,
              -10293.159,
              5678.798
            ],
            [
              1053.742,
              -10313.963,
              5699.732
            ],
            [
              1058.594,
              -10346.025,
              5732.159
            ],
            [
              1097.403,
              -10479.23,
              5870.902
            ],
            [
              1100.943,
              -10497.292,
              5889.308
            ],
            [
              1101.347,
              -10509.477,
              5901.5
            ],
            [
              1077.737,
              -10749.505,
              6142.686
            ],
            [
              1065.429,
              -10939.471,
              6333.051
            ],
            [
              1064.388,
              -10961.782,
              6355.385
            ],
            [
              1065.135,
              -10985.91,
              6379.525
            ],
            [
              966.068,
              -11058.228,
              6502.179
            ],
            [
              860.597,
              -11176.65,
              6660.76
            ],
            [
              833.925,
              -11230.341,
              6720.712
            ],
            [
              745.354,
              -11433.855,
              6942.663
            ],
            [
              724.934,
              -11494.437,
              7006.594
            ],
            [
              729.007,
              -11529.881,
              7042.272
            ],
            [
              747.956,
              -11576.084,
              7092.21
            ],
            [
              808.818,
              -11689.691,
              7221.092
            ],
            [
              814.071,
              -11718.733,
              7250.605
            ],
            [
              807.832,
              -11743.109,
              7275.767
            ],
            [
              788.337,
              -11801.07,
              7336.919
            ],
            [
              739.315,
              -11830.906,
              7394.306
            ],
            [
              746.162,
              -11843.278,
              7408.447
            ],
            [
              762.193,
              -11873.462,
              7442.623
            ],
            [
              775.162,
              -11898.819,
              7471.104
            ],
            [
              850.072,
              -12042.838,
              7633.441
            ],
            [
              886.761,
              -12119.07,
              7718.042
            ],
            [
              905.901,
              -12160.279,
              7763.479
            ],
            [
              920.871,
              -12204.973,
              7810.613
            ],
            [
              955.442,
              -12319.392,
              7930.141
            ],
            [
              969.905,
              -12370.642,
              7983.393
            ],
            [
              970.654,
              -12389.674,
              8002.44
            ],
            [
              967.102,
              -12409.479,
              8022.561
            ],
            [
              959.957,
              -12421.668,
              8036.689
            ],
            [
              947.165,
              -12452.603,
              8070.165
            ],
            [
              939.939,
              -12530.398,
              8148.295
            ],
            [
              941.173,
              -12602.783,
              8220.69
            ],
            [
              951.838,
              -12661.245,
              8280.117
            ],
            [
              954.982,
              -12717.955,
              8336.914
            ],
            [
              958.001,
              -12793.581,
              8412.601
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:7831",
              "position": {
                "x": 25.801,
                "z": -7471.678
              },
              "distanceAlongShapeM": 181.314,
              "shapeOffsetM": 0.459,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:6526",
              "position": {
                "x": -15.345,
                "z": -7080.178
              },
              "distanceAlongShapeM": 575.352,
              "shapeOffsetM": 5.051,
              "arrivalOffsetSeconds": 60,
              "departureOffsetSeconds": 60
            },
            {
              "stopId": "judu:stop:16627",
              "position": {
                "x": 320.415,
                "z": -6959.406
              },
              "distanceAlongShapeM": 1308.048,
              "shapeOffsetM": 7.516,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:6797",
              "position": {
                "x": 1056.317,
                "z": -7139.934
              },
              "distanceAlongShapeM": 2113.053,
              "shapeOffsetM": 6.612,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:6800",
              "position": {
                "x": 1694.973,
                "z": -8148.149
              },
              "distanceAlongShapeM": 3344.601,
              "shapeOffsetM": 1.326,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:17034",
              "position": {
                "x": 1320.872,
                "z": -9262.244
              },
              "distanceAlongShapeM": 4592.636,
              "shapeOffsetM": 1.937,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:17036",
              "position": {
                "x": 1260.221,
                "z": -9582.851
              },
              "distanceAlongShapeM": 4919.139,
              "shapeOffsetM": 1.07,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:17038",
              "position": {
                "x": 1074.858,
                "z": -10939.819
              },
              "distanceAlongShapeM": 6332.788,
              "shapeOffsetM": 9.432,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:17040",
              "position": {
                "x": 768.175,
                "z": -11870.402
              },
              "distanceAlongShapeM": 7442.623,
              "shapeOffsetM": 6.72,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:17150",
              "position": {
                "x": 910.804,
                "z": -12158.03
              },
              "distanceAlongShapeM": 7763.479,
              "shapeOffsetM": 5.395,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:17153",
              "position": {
                "x": 960.155,
                "z": -12793.501
              },
              "distanceAlongShapeM": 8412.601,
              "shapeOffsetM": 2.156,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            }
          ],
          "departuresSeconds": [
            18840,
            20340,
            21660,
            22980,
            24300,
            25860,
            27420,
            33240,
            34740,
            36240,
            37680,
            39120,
            40440,
            41760,
            43080,
            44400,
            45720,
            47040,
            51960,
            53280,
            54600,
            55920,
            57240,
            58620,
            60000,
            61800,
            67800,
            69300,
            70800,
            72120,
            76800,
            78120,
            79440,
            80760
          ]
        },
        {
          "id": "judu:pattern:vilnius_bus_121:1",
          "sourceRouteId": "vilnius_bus_121",
          "sourceShapeId": "vilnius_bus_121_b-a",
          "directionId": 1,
          "headsign": "Santariškės",
          "directionName": "Didžiųjų Gulbinų g.–Mažieji Gulbinai–Santariškės",
          "mode": "bus",
          "routeShortName": "121",
          "routeLongName": "Santariškės–Mažieji Gulbinai–Didžiųjų Gulbinų g.",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              958.001,
              -12793.581,
              0
            ],
            [
              954.77,
              -12841.272,
              47.8
            ],
            [
              959.188,
              -12845.807,
              54.131
            ],
            [
              959.607,
              -12854.297,
              62.631
            ],
            [
              953.102,
              -12858.545,
              70.4
            ],
            [
              947.115,
              -12857.47,
              76.483
            ],
            [
              943.201,
              -12853.35,
              82.166
            ],
            [
              942.778,
              -12846.138,
              89.39
            ],
            [
              945.894,
              -12841.821,
              94.714
            ],
            [
              952.567,
              -12839.065,
              101.934
            ],
            [
              957.498,
              -12780.111,
              161.093
            ],
            [
              953.696,
              -12725.473,
              215.864
            ],
            [
              953.908,
              -12695.443,
              245.894
            ],
            [
              938.72,
              -12561.547,
              380.649
            ],
            [
              938.817,
              -12521.471,
              420.725
            ],
            [
              940.7,
              -12489.221,
              453.03
            ],
            [
              944.306,
              -12468.136,
              474.421
            ],
            [
              947.829,
              -12451.502,
              491.424
            ],
            [
              963.939,
              -12415.062,
              531.266
            ],
            [
              970.137,
              -12392.912,
              554.267
            ],
            [
              969.905,
              -12370.642,
              576.538
            ],
            [
              946.873,
              -12294.515,
              656.073
            ],
            [
              924.004,
              -12209.484,
              744.126
            ],
            [
              912.965,
              -12180.335,
              775.295
            ],
            [
              890.891,
              -12132.994,
              827.53
            ],
            [
              854.807,
              -12055.689,
              912.841
            ],
            [
              751.518,
              -11856.654,
              1137.082
            ],
            [
              738.008,
              -11831.995,
              1165.199
            ],
            [
              780.256,
              -11808.283,
              1213.646
            ],
            [
              786.859,
              -11801.82,
              1222.885
            ],
            [
              813.928,
              -11726.523,
              1302.901
            ],
            [
              814.113,
              -11716.507,
              1312.918
            ],
            [
              806.93,
              -11687.43,
              1342.869
            ],
            [
              736.435,
              -11550.74,
              1496.667
            ],
            [
              724.252,
              -11505.518,
              1543.501
            ],
            [
              727.412,
              -11479.369,
              1569.841
            ],
            [
              848.827,
              -11195.03,
              1879.017
            ],
            [
              887.41,
              -11145.393,
              1941.886
            ],
            [
              963.687,
              -11060.636,
              2055.912
            ],
            [
              982.882,
              -11042.763,
              2082.14
            ],
            [
              1031.777,
              -11008.043,
              2142.108
            ],
            [
              1059.395,
              -10987.823,
              2176.337
            ],
            [
              1084.454,
              -10664.952,
              2500.179
            ],
            [
              1094.873,
              -10561.7,
              2603.955
            ],
            [
              1101.388,
              -10507.252,
              2658.792
            ],
            [
              1100.774,
              -10495.056,
              2671.003
            ],
            [
              1055.291,
              -10328.278,
              2843.872
            ],
            [
              1056.696,
              -10287.113,
              2885.061
            ],
            [
              1060.454,
              -10277.82,
              2895.085
            ],
            [
              1068.492,
              -10258.236,
              2916.255
            ],
            [
              1078.85,
              -10237.426,
              2939.5
            ],
            [
              1101.577,
              -10195.309,
              2987.357
            ],
            [
              1111.939,
              -10167.839,
              3016.717
            ],
            [
              1122.41,
              -10063.513,
              3121.567
            ],
            [
              1134.68,
              -10002.251,
              3184.046
            ],
            [
              1157.068,
              -9923.888,
              3265.544
            ],
            [
              1163.262,
              -9888.324,
              3301.643
            ],
            [
              1173.991,
              -9848.142,
              3343.233
            ],
            [
              1180.249,
              -9835.191,
              3357.617
            ],
            [
              1220.73,
              -9788.932,
              3419.087
            ],
            [
              1249.146,
              -9750.188,
              3467.135
            ],
            [
              1260.327,
              -9726.513,
              3493.318
            ],
            [
              1260.025,
              -9697.513,
              3522.319
            ],
            [
              1252.668,
              -9665.135,
              3555.522
            ],
            [
              1250.998,
              -9658.321,
              3562.537
            ],
            [
              1250.608,
              -9645.994,
              3574.871
            ],
            [
              1251.918,
              -9622.845,
              3598.057
            ],
            [
              1255.774,
              -9590.656,
              3630.477
            ],
            [
              1267.964,
              -9531.304,
              3691.067
            ],
            [
              1281.729,
              -9484.449,
              3739.902
            ],
            [
              1293.085,
              -9432.026,
              3793.541
            ],
            [
              1305.255,
              -9375.507,
              3851.355
            ],
            [
              1314.734,
              -9315.606,
              3912.002
            ],
            [
              1321.508,
              -9176.548,
              4051.225
            ],
            [
              1323.044,
              -9147.71,
              4080.103
            ],
            [
              1327.568,
              -9110.397,
              4117.69
            ],
            [
              1348.428,
              -9062.89,
              4169.575
            ],
            [
              1359.459,
              -9024.991,
              4209.046
            ],
            [
              1368.641,
              -8984.712,
              4250.359
            ],
            [
              1379.654,
              -8929.661,
              4306.501
            ],
            [
              1395.995,
              -8859.142,
              4378.888
            ],
            [
              1407.357,
              -8808.601,
              4430.69
            ],
            [
              1433.33,
              -8749.075,
              4495.635
            ],
            [
              1448.91,
              -8710.219,
              4537.499
            ],
            [
              1472.861,
              -8668.36,
              4585.726
            ],
            [
              1513.956,
              -8604.555,
              4661.62
            ],
            [
              1597.191,
              -8524.836,
              4776.873
            ],
            [
              1606.154,
              -8514.198,
              4790.783
            ],
            [
              1610.18,
              -8507.516,
              4798.584
            ],
            [
              1644.945,
              -8402.829,
              4908.893
            ],
            [
              1681.236,
              -8367.205,
              4959.747
            ],
            [
              1689.227,
              -8352.881,
              4976.149
            ],
            [
              1692.979,
              -8337.61,
              4991.874
            ],
            [
              1700.473,
              -8295.988,
              5034.165
            ],
            [
              1705.895,
              -8287.509,
              5044.23
            ],
            [
              1752.021,
              -8230.48,
              5117.577
            ],
            [
              1731.522,
              -8205.303,
              5150.044
            ],
            [
              1709.342,
              -8176.358,
              5186.51
            ],
            [
              1657.02,
              -8104.473,
              5275.421
            ],
            [
              1647.828,
              -8087.886,
              5294.384
            ],
            [
              1638.752,
              -8055.814,
              5327.716
            ],
            [
              1638.936,
              -7976.776,
              5406.754
            ],
            [
              1635.976,
              -7935.497,
              5448.139
            ],
            [
              1631.127,
              -7912.062,
              5472.07
            ],
            [
              1621.244,
              -7889.613,
              5496.599
            ],
            [
              1583.29,
              -7818.772,
              5576.966
            ],
            [
              1329.764,
              -7393.934,
              6071.701
            ],
            [
              1304.432,
              -7358.997,
              6114.855
            ],
            [
              1271.77,
              -7327.608,
              6160.155
            ],
            [
              1154.195,
              -7244.164,
              6304.332
            ],
            [
              1099.367,
              -7201.495,
              6373.806
            ],
            [
              1029.249,
              -7124.149,
              6478.204
            ],
            [
              999.073,
              -7089.195,
              6524.382
            ],
            [
              951.943,
              -7073.438,
              6574.077
            ],
            [
              652.324,
              -7119.127,
              6877.159
            ],
            [
              622.009,
              -7121.909,
              6907.602
            ],
            [
              600.797,
              -7121.363,
              6928.821
            ],
            [
              577.752,
              -7115.358,
              6952.635
            ],
            [
              488.616,
              -7067.891,
              7053.622
            ],
            [
              60.82,
              -6823.295,
              7546.407
            ],
            [
              14.911,
              -6833.59,
              7593.456
            ],
            [
              7.024,
              -6842.352,
              7605.245
            ],
            [
              -10.864,
              -6869.857,
              7638.055
            ],
            [
              -21.671,
              -6897.49,
              7667.726
            ],
            [
              -11.966,
              -6926.765,
              7698.567
            ],
            [
              -9.853,
              -6955.595,
              7727.475
            ],
            [
              6.027,
              -7144.023,
              7916.571
            ],
            [
              11.629,
              -7176.924,
              7949.945
            ],
            [
              10.845,
              -7197.547,
              7970.583
            ],
            [
              32.291,
              -7398.322,
              8172.5
            ],
            [
              36.523,
              -7443.114,
              8217.492
            ],
            [
              37.062,
              -7489.696,
              8264.077
            ],
            [
              41.201,
              -7509.81,
              8284.612
            ],
            [
              62.699,
              -7531.354,
              8315.048
            ],
            [
              71.413,
              -7563.928,
              8348.767
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:17153",
              "position": {
                "x": 960.155,
                "z": -12793.501
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 2.156,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:17152",
              "position": {
                "x": 888.089,
                "z": -12134.232
              },
              "distanceAlongShapeM": 827.593,
              "shapeOffsetM": 3.063,
              "arrivalOffsetSeconds": 60,
              "departureOffsetSeconds": 60
            },
            {
              "stopId": "judu:stop:17041",
              "position": {
                "x": 747.161,
                "z": -11858.882
              },
              "distanceAlongShapeM": 1137.221,
              "shapeOffsetM": 4.892,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:17039",
              "position": {
                "x": 1067.094,
                "z": -10907.39
              },
              "distanceAlongShapeM": 2257.125,
              "shapeOffsetM": 1.452,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:17037",
              "position": {
                "x": 1265.694,
                "z": -9530.629
              },
              "distanceAlongShapeM": 3691.075,
              "shapeOffsetM": 2.368,
              "arrivalOffsetSeconds": 390,
              "departureOffsetSeconds": 390
            },
            {
              "stopId": "judu:stop:17033",
              "position": {
                "x": 1319.782,
                "z": -9147.558
              },
              "distanceAlongShapeM": 4080.082,
              "shapeOffsetM": 3.265,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:6798",
              "position": {
                "x": 1026.954,
                "z": -7126.033
              },
              "distanceAlongShapeM": 6478.278,
              "shapeOffsetM": 2.968,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:16628",
              "position": {
                "x": 229.7,
                "z": -6919.895
              },
              "distanceAlongShapeM": 7351.851,
              "shapeOffsetM": 0.036,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:6525",
              "position": {
                "x": -10.612,
                "z": -6926.637
              },
              "distanceAlongShapeM": 7698.567,
              "shapeOffsetM": 1.36,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:6532",
              "position": {
                "x": 16.38,
                "z": -7176.496
              },
              "distanceAlongShapeM": 7949.945,
              "shapeOffsetM": 4.77,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:6533",
              "position": {
                "x": 73.695,
                "z": -7563.839
              },
              "distanceAlongShapeM": 8348.767,
              "shapeOffsetM": 2.284,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            }
          ],
          "departuresSeconds": [
            19800,
            21300,
            22620,
            23940,
            25260,
            31200,
            32700,
            34200,
            35700,
            37200,
            38640,
            40080,
            41400,
            42720,
            44040,
            45360,
            50280,
            51600,
            52920,
            54240,
            55560,
            56880,
            58200,
            59580,
            65460,
            67260,
            68760,
            70260,
            75120,
            76500,
            77760,
            79080,
            80400,
            81720
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_bus_122",
      "sourceRouteId": "vilnius_bus_122",
      "mode": "bus",
      "shortName": "122",
      "longName": "Naujininkai–Kalnėnai–Guriai–Pavilnys–Naujoji Vilnia (Apylanka)",
      "color": "0073AC",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_bus_122:0",
          "sourceRouteId": "vilnius_bus_122",
          "sourceShapeId": "vilnius_bus_122_a-b",
          "directionId": 0,
          "headsign": "Naujoji Vilnia (Apylanka)",
          "directionName": "Naujininkai–Kalnėnai–Guriai–Pavilnys–Naujoji Vilnia (Apylanka)",
          "mode": "bus",
          "routeShortName": "122",
          "routeLongName": "Naujininkai–Kalnėnai–Guriai–Pavilnys–Naujoji Vilnia (Apylanka)",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              -199.456,
              2858.125,
              0
            ],
            [
              -198.431,
              2849.811,
              8.377
            ],
            [
              -201.102,
              2838.395,
              20.1
            ],
            [
              -204.996,
              2833.294,
              26.518
            ],
            [
              -247.211,
              2818.474,
              71.259
            ],
            [
              -235.939,
              2941.838,
              195.137
            ],
            [
              -233.72,
              2993.006,
              246.353
            ],
            [
              -251.845,
              3073.034,
              328.408
            ],
            [
              -257.286,
              3117.001,
              372.71
            ],
            [
              -267.064,
              3182.859,
              439.29
            ],
            [
              -302.93,
              3376.096,
              635.827
            ],
            [
              -343.116,
              3580.544,
              844.187
            ],
            [
              -349.245,
              3594.025,
              858.996
            ],
            [
              -373.845,
              3598.553,
              884.009
            ],
            [
              -490.971,
              3577.653,
              1002.985
            ],
            [
              -509.843,
              3569.088,
              1023.71
            ],
            [
              -519.218,
              3550.333,
              1044.678
            ],
            [
              -518.774,
              3539.193,
              1055.827
            ],
            [
              -513.794,
              3529.084,
              1067.096
            ],
            [
              -504.316,
              3517.78,
              1081.847
            ],
            [
              -496.029,
              3512.064,
              1091.915
            ],
            [
              -468.245,
              3513.789,
              1119.752
            ],
            [
              -455.865,
              3520.244,
              1133.714
            ],
            [
              -318.9,
              3563.407,
              1277.319
            ],
            [
              -105.268,
              3669.742,
              1515.952
            ],
            [
              5.271,
              3714.489,
              1635.205
            ],
            [
              57.758,
              3725.78,
              1688.892
            ],
            [
              134.079,
              3734.409,
              1765.7
            ],
            [
              245.04,
              3731.274,
              1876.705
            ],
            [
              313.918,
              3721.112,
              1946.329
            ],
            [
              483.909,
              3663.458,
              2125.83
            ],
            [
              526.148,
              3643.76,
              2172.437
            ],
            [
              597.32,
              3617.966,
              2248.139
            ],
            [
              680.187,
              3596.409,
              2333.764
            ],
            [
              792.211,
              3580.995,
              2446.843
            ],
            [
              953.682,
              3591.913,
              2608.683
            ],
            [
              1038.954,
              3607.826,
              2695.427
            ],
            [
              1165.109,
              3642.042,
              2826.14
            ],
            [
              1250.045,
              3662.739,
              2913.561
            ],
            [
              1545.858,
              3742.988,
              3220.066
            ],
            [
              1743.856,
              3803.884,
              3427.217
            ],
            [
              1811.196,
              3832.214,
              3500.273
            ],
            [
              1875.636,
              3868.945,
              3574.446
            ],
            [
              2082.225,
              4019.124,
              3829.854
            ],
            [
              2137.697,
              4051.487,
              3894.076
            ],
            [
              3783.191,
              4734.089,
              5675.535
            ],
            [
              4094.837,
              4859.518,
              6011.475
            ],
            [
              4105.015,
              4851.531,
              6024.413
            ],
            [
              4106.76,
              4841.478,
              6034.616
            ],
            [
              3917.18,
              4757.37,
              6242.016
            ],
            [
              3791.824,
              4712.774,
              6375.068
            ],
            [
              2821.939,
              4306.494,
              7426.61
            ],
            [
              2770.246,
              4289.011,
              7481.18
            ],
            [
              2807.11,
              4258.26,
              7529.186
            ],
            [
              2948.179,
              4207.737,
              7679.029
            ],
            [
              2964.035,
              4199.549,
              7696.875
            ],
            [
              2979.047,
              4187.028,
              7716.423
            ],
            [
              3008.608,
              4155.968,
              7759.301
            ],
            [
              3084.382,
              4084.475,
              7863.479
            ],
            [
              3137.191,
              4039.772,
              7932.668
            ],
            [
              3297.481,
              3913.396,
              8136.785
            ],
            [
              3423.046,
              3790.94,
              8312.177
            ],
            [
              3464.872,
              3750.332,
              8370.473
            ],
            [
              3524.985,
              3693.825,
              8452.974
            ],
            [
              3679.16,
              3505.925,
              8696.031
            ],
            [
              3844.888,
              3667.535,
              8927.512
            ],
            [
              3894.16,
              3721.29,
              9000.432
            ],
            [
              3914.016,
              3738.58,
              9026.761
            ],
            [
              4011.736,
              3785.701,
              9135.248
            ],
            [
              4118.856,
              3834.577,
              9252.992
            ],
            [
              4455.787,
              3985.391,
              9622.136
            ],
            [
              4659.72,
              4077.746,
              9846.007
            ],
            [
              4783.97,
              3831.027,
              10122.247
            ],
            [
              4807.805,
              3794.944,
              10165.492
            ],
            [
              4844.485,
              3764.136,
              10213.393
            ],
            [
              4901.353,
              3711.915,
              10290.601
            ],
            [
              4947.841,
              3656.072,
              10363.261
            ],
            [
              4963.934,
              3627.118,
              10396.387
            ],
            [
              4993.336,
              3496.944,
              10529.84
            ],
            [
              5047.324,
              3251.4,
              10781.249
            ],
            [
              5063.846,
              3174.925,
              10859.489
            ],
            [
              5092.784,
              3042.453,
              10995.085
            ],
            [
              5045.989,
              3027.935,
              11044.079
            ],
            [
              4670.733,
              2928.273,
              11432.345
            ],
            [
              4632.851,
              2919.946,
              11471.131
            ],
            [
              4422.331,
              2863.859,
              11688.995
            ],
            [
              4138.843,
              2793.388,
              11981.11
            ],
            [
              4152.847,
              2750.842,
              12025.901
            ],
            [
              4165.87,
              2713.822,
              12065.145
            ],
            [
              4170.055,
              2702.335,
              12077.371
            ],
            [
              4191.056,
              2664.57,
              12120.582
            ],
            [
              4218.241,
              2635.106,
              12160.672
            ],
            [
              4282.48,
              2586.007,
              12241.526
            ],
            [
              4309.254,
              2568.796,
              12273.354
            ],
            [
              4467.307,
              2518.783,
              12439.132
            ],
            [
              4608.628,
              2469.276,
              12588.873
            ],
            [
              4652.542,
              2440.656,
              12641.29
            ],
            [
              4671.824,
              2429.363,
              12663.636
            ],
            [
              4814.301,
              2355.374,
              12824.179
            ],
            [
              4977.975,
              2276.518,
              13005.858
            ],
            [
              5036.251,
              2292.61,
              13066.315
            ],
            [
              5084.32,
              2303.41,
              13115.582
            ],
            [
              5241.303,
              2346.019,
              13278.245
            ],
            [
              5248.742,
              2330.289,
              13295.646
            ],
            [
              5275.468,
              2246.045,
              13384.027
            ],
            [
              5288.068,
              2206.568,
              13425.467
            ],
            [
              5291.848,
              2194.721,
              13437.902
            ],
            [
              5310.766,
              2134.268,
              13501.246
            ],
            [
              5382.085,
              2151.811,
              13574.691
            ],
            [
              5561.363,
              2199.362,
              13760.167
            ],
            [
              5722.872,
              2213.398,
              13922.285
            ],
            [
              5789.939,
              2217.696,
              13989.49
            ],
            [
              5836.183,
              2212.588,
              14036.015
            ],
            [
              5887.192,
              2211.017,
              14087.049
            ],
            [
              5905.833,
              2207.314,
              14106.054
            ],
            [
              5985.138,
              2172.029,
              14192.854
            ],
            [
              6000.929,
              2162.128,
              14211.492
            ],
            [
              6022.261,
              2131.591,
              14248.743
            ],
            [
              6133.166,
              2147.882,
              14360.837
            ],
            [
              6136.665,
              2123.417,
              14385.551
            ],
            [
              6139.225,
              2098.11,
              14410.987
            ],
            [
              6156.232,
              1911.861,
              14598.011
            ],
            [
              6182.699,
              1648.612,
              14862.587
            ],
            [
              6186.873,
              1628.256,
              14883.366
            ],
            [
              6187.271,
              1618.464,
              14893.166
            ],
            [
              6199.269,
              1539.187,
              14973.346
            ],
            [
              6224.257,
              1398.425,
              15116.309
            ],
            [
              6229.987,
              1361.575,
              15153.602
            ],
            [
              6230.798,
              1337.067,
              15178.123
            ],
            [
              6233.133,
              1328.137,
              15187.353
            ],
            [
              6229.847,
              1320.342,
              15195.813
            ],
            [
              6225.273,
              1252.567,
              15263.742
            ],
            [
              6209.33,
              1254.033,
              15279.752
            ],
            [
              6209.926,
              1259.547,
              15285.299
            ],
            [
              6223.709,
              1271.523,
              15303.558
            ],
            [
              6226.65,
              1283.659,
              15316.046
            ],
            [
              6228.386,
              1303.574,
              15336.036
            ],
            [
              6230.505,
              1332.607,
              15365.146
            ],
            [
              6228.205,
              1369.403,
              15402.014
            ],
            [
              6216.903,
              1436.855,
              15470.406
            ],
            [
              6187.161,
              1609.572,
              15645.665
            ],
            [
              6180.476,
              1651.061,
              15687.69
            ],
            [
              6163.34,
              1815.172,
              15852.693
            ],
            [
              6154.263,
              1906.342,
              15944.313
            ],
            [
              6130.476,
              2146.394,
              16185.541
            ],
            [
              6173.875,
              2154.21,
              16229.638
            ],
            [
              6187.19,
              2157.268,
              16243.299
            ],
            [
              6190.184,
              2157.873,
              16246.354
            ],
            [
              6302.78,
              2179.519,
              16361.012
            ],
            [
              6339.743,
              2188.814,
              16399.126
            ],
            [
              6485.314,
              2234.633,
              16551.738
            ],
            [
              6518.994,
              2247.642,
              16587.843
            ],
            [
              6647.152,
              2266.155,
              16717.33
            ],
            [
              6648.734,
              2249.547,
              16734.014
            ],
            [
              6664.061,
              2175.769,
              16809.367
            ],
            [
              6679.103,
              2087.525,
              16898.884
            ],
            [
              6685.858,
              2037.294,
              16949.567
            ],
            [
              6713.03,
              2017.898,
              16982.952
            ],
            [
              6722.098,
              2009.863,
              16995.067
            ],
            [
              6786.898,
              1954.139,
              17080.532
            ],
            [
              6934.171,
              1835.354,
              17269.739
            ],
            [
              6994.719,
              1797.421,
              17341.188
            ],
            [
              7151.902,
              1752.011,
              17504.799
            ],
            [
              7180.711,
              1747.342,
              17533.984
            ],
            [
              7232.816,
              1732.598,
              17588.135
            ],
            [
              7218.9,
              1583.694,
              17737.687
            ],
            [
              7576.848,
              1544.311,
              18097.796
            ],
            [
              7614.877,
              1542.442,
              18135.87
            ],
            [
              7753.696,
              1547.075,
              18274.767
            ],
            [
              7798.773,
              1543.236,
              18320.007
            ],
            [
              7797.757,
              1494.417,
              18368.836
            ],
            [
              7793.796,
              1487.671,
              18376.659
            ],
            [
              7754.104,
              1114.398,
              18752.037
            ],
            [
              7755.189,
              1097.018,
              18769.451
            ],
            [
              7751.793,
              1095.518,
              18773.163
            ],
            [
              7745.305,
              1028.85,
              18840.146
            ],
            [
              8018.963,
              975.009,
              19119.049
            ],
            [
              8065.926,
              965.532,
              19166.96
            ],
            [
              8092.242,
              957.359,
              19194.516
            ],
            [
              8117.792,
              944.602,
              19223.073
            ],
            [
              8150.835,
              919.449,
              19264.601
            ],
            [
              8217.435,
              859.556,
              19354.171
            ],
            [
              8287.693,
              795.361,
              19449.339
            ],
            [
              8311.795,
              774.839,
              19480.995
            ],
            [
              8341.723,
              755.313,
              19516.729
            ],
            [
              8683.89,
              590.023,
              19896.727
            ],
            [
              8697.385,
              584.51,
              19911.305
            ],
            [
              8699.953,
              575.322,
              19920.845
            ],
            [
              8694.685,
              567.872,
              19929.969
            ],
            [
              8685.547,
              537.815,
              19961.385
            ],
            [
              8661.183,
              441.631,
              20060.607
            ],
            [
              8618.998,
              285.592,
              20222.248
            ],
            [
              8586.11,
              199.304,
              20314.59
            ],
            [
              8585.045,
              183.764,
              20330.167
            ],
            [
              8590.333,
              158.052,
              20356.417
            ],
            [
              8621.917,
              92.846,
              20428.87
            ],
            [
              8636.204,
              33.555,
              20489.858
            ],
            [
              8637.068,
              12.385,
              20511.045
            ],
            [
              8604.283,
              -110.532,
              20638.259
            ],
            [
              8595.54,
              -160.454,
              20688.941
            ],
            [
              8696.309,
              -134.44,
              20793.014
            ],
            [
              8720.235,
              -127.625,
              20817.892
            ],
            [
              8744.3,
              -121.003,
              20842.851
            ],
            [
              8789.403,
              -109.804,
              20889.324
            ],
            [
              8826.448,
              -96.087,
              20928.826
            ],
            [
              8853.145,
              -83.257,
              20958.447
            ],
            [
              8900.484,
              -38.566,
              21023.548
            ],
            [
              8997.947,
              60.777,
              21162.718
            ],
            [
              9045.087,
              95.45,
              21221.236
            ],
            [
              9064.009,
              106.201,
              21242.999
            ],
            [
              9090.691,
              117.908,
              21272.136
            ],
            [
              9117.305,
              128.24,
              21300.686
            ],
            [
              9141.918,
              131.345,
              21325.494
            ],
            [
              9732.973,
              138.29,
              21916.59
            ],
            [
              9768.99,
              137.546,
              21952.614
            ],
            [
              9787.111,
              140.517,
              21970.977
            ],
            [
              9775.961,
              226.468,
              22057.648
            ],
            [
              9750.774,
              351.671,
              22185.36
            ],
            [
              9712.666,
              440.791,
              22282.285
            ],
            [
              9660.167,
              527.189,
              22383.383
            ],
            [
              9646.989,
              545.27,
              22405.757
            ],
            [
              9586.931,
              605.495,
              22490.81
            ],
            [
              9548.875,
              637.441,
              22540.497
            ],
            [
              9462.887,
              691.511,
              22642.072
            ],
            [
              9420.067,
              711.306,
              22689.246
            ],
            [
              9384.895,
              726.492,
              22727.556
            ],
            [
              9356.704,
              735.97,
              22757.298
            ],
            [
              9300.852,
              749.348,
              22814.73
            ],
            [
              9244.219,
              756.061,
              22871.759
            ],
            [
              9179.167,
              758.013,
              22936.841
            ],
            [
              9150.142,
              761.304,
              22966.052
            ],
            [
              9052.195,
              766.624,
              23064.143
            ],
            [
              9037.57,
              766.366,
              23078.77
            ],
            [
              9024.056,
              767.119,
              23092.305
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:5200",
              "position": {
                "x": -196.145,
                "z": 2858.737
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 3.367,
              "arrivalOffsetSeconds": -60,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:5175",
              "position": {
                "x": -255.513,
                "z": 3072.44
              },
              "distanceAlongShapeM": 328.408,
              "shapeOffsetM": 3.716,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:6024",
              "position": {
                "x": 1319.455,
                "z": 3681.496
              },
              "distanceAlongShapeM": 2985.461,
              "shapeOffsetM": 0.07,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:16977",
              "position": {
                "x": 1743.856,
                "z": 3803.884
              },
              "distanceAlongShapeM": 3427.217,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:616",
              "position": {
                "x": 2873.526,
                "z": 4357.203
              },
              "distanceAlongShapeM": 4690.886,
              "shapeOffsetM": 0.435,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:6121",
              "position": {
                "x": 3917.274,
                "z": 4757.143
              },
              "distanceAlongShapeM": 6242.016,
              "shapeOffsetM": 0.246,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:617",
              "position": {
                "x": 2822.207,
                "z": 4305.846
              },
              "distanceAlongShapeM": 7426.61,
              "shapeOffsetM": 0.701,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:16920",
              "position": {
                "x": 3009.186,
                "z": 4156.492
              },
              "distanceAlongShapeM": 7759.362,
              "shapeOffsetM": 0.778,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:9593",
              "position": {
                "x": 3527.875,
                "z": 3696.935
              },
              "distanceAlongShapeM": 8452.95,
              "shapeOffsetM": 4.246,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:9600",
              "position": {
                "x": 4116.685,
                "z": 3839.361
              },
              "distanceAlongShapeM": 9252.992,
              "shapeOffsetM": 5.253,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:16713",
              "position": {
                "x": 4688.859,
                "z": 4020.996
              },
              "distanceAlongShapeM": 9909.799,
              "shapeOffsetM": 0.499,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:16724",
              "position": {
                "x": 4948.434,
                "z": 3656.418
              },
              "distanceAlongShapeM": 10363.261,
              "shapeOffsetM": 0.687,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            },
            {
              "stopId": "judu:stop:7818",
              "position": {
                "x": 5046.033,
                "z": 3027.77
              },
              "distanceAlongShapeM": 11044.08,
              "shapeOffsetM": 0.171,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            },
            {
              "stopId": "judu:stop:7712",
              "position": {
                "x": 4671.063,
                "z": 2927.005
              },
              "distanceAlongShapeM": 11432.345,
              "shapeOffsetM": 1.31,
              "arrivalOffsetSeconds": 1500,
              "departureOffsetSeconds": 1500
            },
            {
              "stopId": "judu:stop:6687",
              "position": {
                "x": 4169.434,
                "z": 2715.08
              },
              "distanceAlongShapeM": 12065.183,
              "shapeOffsetM": 3.779,
              "arrivalOffsetSeconds": 1620,
              "departureOffsetSeconds": 1620
            },
            {
              "stopId": "judu:stop:6691",
              "position": {
                "x": 4467.714,
                "z": 2520.116
              },
              "distanceAlongShapeM": 12439.117,
              "shapeOffsetM": 1.394,
              "arrivalOffsetSeconds": 1680,
              "departureOffsetSeconds": 1680
            },
            {
              "stopId": "judu:stop:6694",
              "position": {
                "x": 5035.146,
                "z": 2296.566
              },
              "distanceAlongShapeM": 13066.303,
              "shapeOffsetM": 4.108,
              "arrivalOffsetSeconds": 1740,
              "departureOffsetSeconds": 1740
            },
            {
              "stopId": "judu:stop:18787",
              "position": {
                "x": 5292.838,
                "z": 2208.09
              },
              "distanceAlongShapeM": 13425.467,
              "shapeOffsetM": 5.007,
              "arrivalOffsetSeconds": 1860,
              "departureOffsetSeconds": 1860
            },
            {
              "stopId": "judu:stop:19203",
              "position": {
                "x": 6139.08,
                "z": 2123.718
              },
              "distanceAlongShapeM": 14385.551,
              "shapeOffsetM": 2.433,
              "arrivalOffsetSeconds": 2040,
              "departureOffsetSeconds": 2040
            },
            {
              "stopId": "judu:stop:19208",
              "position": {
                "x": 6188.112,
                "z": 1628.467
              },
              "distanceAlongShapeM": 14883.366,
              "shapeOffsetM": 1.257,
              "arrivalOffsetSeconds": 2160,
              "departureOffsetSeconds": 2160
            },
            {
              "stopId": "judu:stop:19204",
              "position": {
                "x": 6233.848,
                "z": 1328.101
              },
              "distanceAlongShapeM": 15187.353,
              "shapeOffsetM": 0.716,
              "arrivalOffsetSeconds": 2220,
              "departureOffsetSeconds": 2220
            },
            {
              "stopId": "judu:stop:19201",
              "position": {
                "x": 6186.283,
                "z": 2161.76
              },
              "distanceAlongShapeM": 16243.299,
              "shapeOffsetM": 4.582,
              "arrivalOffsetSeconds": 2400,
              "departureOffsetSeconds": 2400
            },
            {
              "stopId": "judu:stop:19206",
              "position": {
                "x": 6713.888,
                "z": 2018.931
              },
              "distanceAlongShapeM": 16982.952,
              "shapeOffsetM": 1.343,
              "arrivalOffsetSeconds": 2580,
              "departureOffsetSeconds": 2580
            },
            {
              "stopId": "judu:stop:19200",
              "position": {
                "x": 7280.06,
                "z": 1576.917
              },
              "distanceAlongShapeM": 17799.222,
              "shapeOffsetM": 0.048,
              "arrivalOffsetSeconds": 2760,
              "departureOffsetSeconds": 2760
            },
            {
              "stopId": "judu:stop:18884",
              "position": {
                "x": 7799.733,
                "z": 1494.232
              },
              "distanceAlongShapeM": 18368.836,
              "shapeOffsetM": 1.985,
              "arrivalOffsetSeconds": 2880,
              "departureOffsetSeconds": 2880
            },
            {
              "stopId": "judu:stop:18903",
              "position": {
                "x": 7760.199,
                "z": 1096.464
              },
              "distanceAlongShapeM": 18769.451,
              "shapeOffsetM": 5.041,
              "arrivalOffsetSeconds": 2940,
              "departureOffsetSeconds": 2940
            },
            {
              "stopId": "judu:stop:6035",
              "position": {
                "x": 8692.348,
                "z": 547.88
              },
              "distanceAlongShapeM": 19949.777,
              "shapeOffsetM": 3.579,
              "arrivalOffsetSeconds": 3060,
              "departureOffsetSeconds": 3060
            },
            {
              "stopId": "judu:stop:6040",
              "position": {
                "x": 8718.239,
                "z": -120.617
              },
              "distanceAlongShapeM": 20817.892,
              "shapeOffsetM": 7.287,
              "arrivalOffsetSeconds": 3210,
              "departureOffsetSeconds": 3210
            },
            {
              "stopId": "judu:stop:6042",
              "position": {
                "x": 9116.151,
                "z": 132.979
              },
              "distanceAlongShapeM": 21300.686,
              "shapeOffsetM": 4.877,
              "arrivalOffsetSeconds": 3270,
              "departureOffsetSeconds": 3270
            },
            {
              "stopId": "judu:stop:6044",
              "position": {
                "x": 9552.934,
                "z": 138.6
              },
              "distanceAlongShapeM": 21736.566,
              "shapeOffsetM": 2.425,
              "arrivalOffsetSeconds": 3330,
              "departureOffsetSeconds": 3330
            },
            {
              "stopId": "judu:stop:7444",
              "position": {
                "x": 9732.975,
                "z": 142.732
              },
              "distanceAlongShapeM": 21916.59,
              "shapeOffsetM": 4.442,
              "arrivalOffsetSeconds": 3390,
              "departureOffsetSeconds": 3390
            },
            {
              "stopId": "judu:stop:17007",
              "position": {
                "x": 9681.966,
                "z": 488.893
              },
              "distanceAlongShapeM": 22339.335,
              "shapeOffsetM": 1.257,
              "arrivalOffsetSeconds": 3450,
              "departureOffsetSeconds": 3450
            },
            {
              "stopId": "judu:stop:16454",
              "position": {
                "x": 9179.069,
                "z": 756.266
              },
              "distanceAlongShapeM": 22936.841,
              "shapeOffsetM": 1.75,
              "arrivalOffsetSeconds": 3510,
              "departureOffsetSeconds": 3510
            }
          ],
          "departuresSeconds": [
            19200,
            21600,
            23820,
            26460,
            29100,
            31620,
            34080,
            36720,
            39300,
            42840,
            45480,
            48060,
            51300,
            54000,
            56400,
            58980,
            61680,
            64140,
            66720,
            69300,
            72600,
            75540,
            78360,
            81240
          ]
        },
        {
          "id": "judu:pattern:vilnius_bus_122:1",
          "sourceRouteId": "vilnius_bus_122",
          "sourceShapeId": "vilnius_bus_122_b-a",
          "directionId": 1,
          "headsign": "Naujininkai (Apylanka)",
          "directionName": "Naujoji Vilnia–Pavilnys–Guriai–Kalnėnai–Naujininkai (Apylanka)",
          "mode": "bus",
          "routeShortName": "122",
          "routeLongName": "Naujininkai–Kalnėnai–Guriai–Pavilnys–Naujoji Vilnia (Apylanka)",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              9024.056,
              767.119,
              0
            ],
            [
              9003.501,
              768.265,
              20.586
            ],
            [
              8998.057,
              768.408,
              26.032
            ],
            [
              8998.097,
              771.056,
              28.68
            ],
            [
              9003.945,
              773.164,
              34.896
            ],
            [
              9172.074,
              765.272,
              203.21
            ],
            [
              9194.013,
              761.53,
              225.466
            ],
            [
              9297.028,
              751.652,
              328.954
            ],
            [
              9354.837,
              739.348,
              388.058
            ],
            [
              9475.025,
              685.698,
              519.676
            ],
            [
              9548.875,
              637.441,
              607.895
            ],
            [
              9650.145,
              541.866,
              747.144
            ],
            [
              9694.397,
              487.212,
              817.467
            ],
            [
              9750.91,
              358.348,
              958.178
            ],
            [
              9760.037,
              331.443,
              986.589
            ],
            [
              9774.016,
              257.68,
              1061.665
            ],
            [
              9785.97,
              179.506,
              1140.747
            ],
            [
              9786.285,
              131.627,
              1188.628
            ],
            [
              9682.329,
              129.236,
              1292.611
            ],
            [
              9621.808,
              131.634,
              1353.179
            ],
            [
              9517.36,
              133.756,
              1457.649
            ],
            [
              9448.882,
              128.466,
              1526.331
            ],
            [
              9389.611,
              131.895,
              1585.701
            ],
            [
              9156.08,
              129.945,
              1819.24
            ],
            [
              9090.691,
              117.908,
              1885.728
            ],
            [
              9071.372,
              103.392,
              1909.893
            ],
            [
              9049.578,
              94.246,
              1933.528
            ],
            [
              8990.008,
              50.917,
              2007.189
            ],
            [
              8869.532,
              -70.228,
              2178.042
            ],
            [
              8853.145,
              -83.257,
              2198.977
            ],
            [
              8819.883,
              -101.512,
              2236.919
            ],
            [
              8767.948,
              -118.279,
              2291.494
            ],
            [
              8695.316,
              -137.969,
              2366.747
            ],
            [
              8672.646,
              -150.383,
              2392.594
            ],
            [
              8624.533,
              -154.886,
              2440.917
            ],
            [
              8595.54,
              -160.454,
              2470.44
            ],
            [
              8604.283,
              -110.532,
              2521.122
            ],
            [
              8637.068,
              12.385,
              2648.336
            ],
            [
              8631.494,
              55.915,
              2692.221
            ],
            [
              8618.16,
              98.488,
              2736.833
            ],
            [
              8587.933,
              167.007,
              2811.724
            ],
            [
              8585.045,
              183.764,
              2828.728
            ],
            [
              8637.514,
              355.27,
              3008.08
            ],
            [
              8660.493,
              439.418,
              3095.309
            ],
            [
              8697.348,
              584.583,
              3245.079
            ],
            [
              8662.22,
              595.021,
              3281.726
            ],
            [
              8637.029,
              608.653,
              3310.368
            ],
            [
              8464.489,
              692.014,
              3501.99
            ],
            [
              8342.301,
              751.962,
              3638.092
            ],
            [
              8316.842,
              769.171,
              3668.822
            ],
            [
              8273.062,
              805.674,
              3725.823
            ],
            [
              8139.983,
              925.232,
              3904.72
            ],
            [
              8108.786,
              945.895,
              3942.139
            ],
            [
              8069.094,
              961.161,
              3984.666
            ],
            [
              8003.009,
              974.194,
              4052.024
            ],
            [
              7745.305,
              1028.85,
              4315.46
            ],
            [
              7744.926,
              1042.217,
              4328.832
            ],
            [
              7748.948,
              1082.215,
              4369.032
            ],
            [
              7750.105,
              1104.277,
              4391.124
            ],
            [
              7752.147,
              1113.323,
              4400.398
            ],
            [
              7763.904,
              1217.738,
              4505.473
            ],
            [
              7796.816,
              1542.162,
              4831.562
            ],
            [
              7665.182,
              1541.442,
              4963.198
            ],
            [
              7625.101,
              1540.027,
              5003.304
            ],
            [
              7556.811,
              1542.482,
              5071.638
            ],
            [
              7314.963,
              1571.564,
              5315.228
            ],
            [
              7312.682,
              1571.801,
              5317.521
            ],
            [
              7303.454,
              1572.758,
              5326.799
            ],
            [
              7234.452,
              1582.006,
              5396.418
            ],
            [
              7216.672,
              1583.301,
              5414.245
            ],
            [
              7231.658,
              1731.418,
              5563.118
            ],
            [
              7175.7,
              1748.2,
              5621.539
            ],
            [
              7154.008,
              1750.77,
              5643.382
            ],
            [
              7083.887,
              1771.168,
              5716.41
            ],
            [
              7000.183,
              1795.15,
              5803.482
            ],
            [
              6990.433,
              1798.231,
              5813.707
            ],
            [
              6963.009,
              1813.981,
              5845.332
            ],
            [
              6934.621,
              1833.741,
              5879.92
            ],
            [
              6851.474,
              1901.891,
              5987.428
            ],
            [
              6697.49,
              2028.4,
              6186.715
            ],
            [
              6685.346,
              2037.465,
              6201.869
            ],
            [
              6644.006,
              2265.164,
              6433.29
            ],
            [
              6518.972,
              2246.529,
              6559.705
            ],
            [
              6502.114,
              2242.407,
              6577.06
            ],
            [
              6487.77,
              2234.896,
              6593.252
            ],
            [
              6326.277,
              2184.028,
              6762.567
            ],
            [
              6132.914,
              2145.983,
              6959.637
            ],
            [
              6136.665,
              2123.417,
              6982.513
            ],
            [
              6153.014,
              1945.322,
              7161.357
            ],
            [
              6183.213,
              1641.922,
              7466.256
            ],
            [
              6231.212,
              1358.211,
              7753.999
            ],
            [
              6232.11,
              1338.155,
              7774.075
            ],
            [
              6230.014,
              1297.005,
              7815.278
            ],
            [
              6228.081,
              1266.988,
              7845.358
            ],
            [
              6225.252,
              1251.454,
              7861.147
            ],
            [
              6207.759,
              1251.802,
              7878.643
            ],
            [
              6209.238,
              1257.334,
              7884.369
            ],
            [
              6219.429,
              1269.099,
              7899.935
            ],
            [
              6223.064,
              1271.536,
              7904.311
            ],
            [
              6227.228,
              1290.298,
              7923.53
            ],
            [
              6229.299,
              1359.362,
              7992.625
            ],
            [
              6179.239,
              1664.421,
              8301.764
            ],
            [
              6130.461,
              2147.205,
              8787.005
            ],
            [
              6096.011,
              2142.926,
              8821.719
            ],
            [
              6041.878,
              2135.637,
              8876.341
            ],
            [
              6021.128,
              2130.475,
              8897.724
            ],
            [
              6015.482,
              2140.299,
              8909.055
            ],
            [
              5994.066,
              2165.515,
              8942.138
            ],
            [
              5901.318,
              2207.402,
              9043.906
            ],
            [
              5845.213,
              2209.963,
              9100.069
            ],
            [
              5804.067,
              2215.947,
              9141.648
            ],
            [
              5767.883,
              2214.454,
              9177.863
            ],
            [
              5564.331,
              2199.486,
              9381.964
            ],
            [
              5535.175,
              2193.373,
              9411.754
            ],
            [
              5305.929,
              2130.755,
              9649.399
            ],
            [
              5296.303,
              2171.389,
              9691.157
            ],
            [
              5293.875,
              2178.996,
              9699.143
            ],
            [
              5290.601,
              2192.548,
              9713.085
            ],
            [
              5241.948,
              2346.007,
              9874.072
            ],
            [
              4977.975,
              2276.518,
              10147.038
            ],
            [
              4916.401,
              2303.24,
              10214.16
            ],
            [
              4657.116,
              2436.326,
              10505.606
            ],
            [
              4613.807,
              2466.102,
              10558.163
            ],
            [
              4521.576,
              2499.239,
              10656.166
            ],
            [
              4411.017,
              2532.981,
              10771.759
            ],
            [
              4354.111,
              2552.351,
              10831.872
            ],
            [
              4310.879,
              2567.321,
              10877.623
            ],
            [
              4270.372,
              2594.031,
              10926.143
            ],
            [
              4200.477,
              2651.031,
              11016.333
            ],
            [
              4185.377,
              2671.358,
              11041.655
            ],
            [
              4171.029,
              2697.237,
              11071.245
            ],
            [
              4139.04,
              2791.278,
              11170.579
            ],
            [
              4163.33,
              2800.917,
              11196.711
            ],
            [
              4290.348,
              2828.546,
              11326.699
            ],
            [
              5090.216,
              3042.448,
              12154.674
            ],
            [
              4969.795,
              3592.55,
              12717.802
            ],
            [
              4957.082,
              3636.213,
              12763.278
            ],
            [
              4927.785,
              3683.05,
              12818.523
            ],
            [
              4847.561,
              3761.89,
              12931.002
            ],
            [
              4819.787,
              3779.139,
              12963.697
            ],
            [
              4710.681,
              3962.111,
              13176.73
            ],
            [
              4659.534,
              4073.006,
              13298.852
            ],
            [
              4127.493,
              3835.367,
              13881.552
            ],
            [
              3964.209,
              3764.342,
              14059.615
            ],
            [
              3925.736,
              3743.923,
              14103.17
            ],
            [
              3679.16,
              3505.925,
              14445.87
            ],
            [
              3423.046,
              3790.94,
              14829.051
            ],
            [
              3347.302,
              3865.756,
              14935.515
            ],
            [
              3289.347,
              3917.422,
              15013.156
            ],
            [
              3181.919,
              4004.914,
              15151.705
            ],
            [
              3071.739,
              4090.702,
              15291.344
            ],
            [
              3027.027,
              4131.437,
              15351.829
            ],
            [
              2994.997,
              4170.986,
              15402.722
            ],
            [
              2976.675,
              4189.151,
              15428.523
            ],
            [
              2942.434,
              4211.185,
              15469.24
            ],
            [
              2862.761,
              4236.857,
              15552.947
            ],
            [
              2800.72,
              4261.72,
              15619.785
            ],
            [
              2770.892,
              4288.999,
              15660.206
            ],
            [
              2389.026,
              4132.511,
              16072.892
            ],
            [
              2135.283,
              4025.927,
              16348.112
            ],
            [
              2048.824,
              3966.169,
              16453.213
            ],
            [
              1944.126,
              3882.541,
              16587.21
            ],
            [
              1902.157,
              3851.146,
              16639.622
            ],
            [
              1851.944,
              3819.688,
              16698.875
            ],
            [
              1756.889,
              3775.811,
              16803.568
            ],
            [
              1645.829,
              3738.909,
              16920.599
            ],
            [
              1602.425,
              3723.737,
              16966.578
            ],
            [
              1516.08,
              3703.463,
              17055.271
            ],
            [
              1225.342,
              3628.105,
              17355.616
            ],
            [
              1029.191,
              3586.658,
              17556.099
            ],
            [
              917.824,
              3567.555,
              17669.092
            ],
            [
              833.864,
              3564.645,
              17753.103
            ],
            [
              784.868,
              3567.771,
              17802.198
            ],
            [
              649.135,
              3592.526,
              17940.17
            ],
            [
              518.202,
              3632.773,
              18077.149
            ],
            [
              399.689,
              3681.696,
              18205.363
            ],
            [
              300.831,
              3711.331,
              18308.568
            ],
            [
              233.202,
              3719.244,
              18376.658
            ],
            [
              170.01,
              3722.623,
              18439.94
            ],
            [
              40.154,
              3716.081,
              18569.961
            ],
            [
              -65.324,
              3665.677,
              18686.863
            ],
            [
              -146.473,
              3606.893,
              18787.066
            ],
            [
              -173.508,
              3579.27,
              18825.718
            ],
            [
              -199.192,
              3544.539,
              18868.914
            ],
            [
              -221.836,
              3505.987,
              18913.624
            ],
            [
              -248.814,
              3477.532,
              18952.835
            ],
            [
              -305.633,
              3429.475,
              19027.252
            ],
            [
              -294.039,
              3332.52,
              19124.898
            ],
            [
              -238.76,
              3035.4,
              19427.116
            ],
            [
              -233.72,
              2993.006,
              19469.809
            ],
            [
              -227.915,
              2951.79,
              19511.432
            ],
            [
              -239.307,
              2898.483,
              19565.942
            ],
            [
              -217.937,
              2901.557,
              19587.532
            ],
            [
              -207.09,
              2897.871,
              19598.989
            ],
            [
              -199.456,
              2858.125,
              19639.462
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:16453",
              "position": {
                "x": 9172.201,
                "z": 767.538
              },
              "distanceAlongShapeM": 203.21,
              "shapeOffsetM": 2.269,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:17009",
              "position": {
                "x": 9696.796,
                "z": 488.592
              },
              "distanceAlongShapeM": 817.467,
              "shapeOffsetM": 2.768,
              "arrivalOffsetSeconds": 60,
              "departureOffsetSeconds": 60
            },
            {
              "stopId": "judu:stop:6073",
              "position": {
                "x": 9682.346,
                "z": 127.063
              },
              "distanceAlongShapeM": 1292.611,
              "shapeOffsetM": 2.173,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:6045",
              "position": {
                "x": 9448.882,
                "z": 128.466
              },
              "distanceAlongShapeM": 1526.331,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:6043",
              "position": {
                "x": 9073.545,
                "z": 99.328
              },
              "distanceAlongShapeM": 1909.893,
              "shapeOffsetM": 4.609,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:6041",
              "position": {
                "x": 8673.105,
                "z": -151.995
              },
              "distanceAlongShapeM": 2392.594,
              "shapeOffsetM": 1.676,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:6034",
              "position": {
                "x": 8662.337,
                "z": 595.242
              },
              "distanceAlongShapeM": 3281.676,
              "shapeOffsetM": 0.245,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:19076",
              "position": {
                "x": 7748.101,
                "z": 1104.498
              },
              "distanceAlongShapeM": 4391.124,
              "shapeOffsetM": 2.017,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:18891",
              "position": {
                "x": 7751.004,
                "z": 1541.96
              },
              "distanceAlongShapeM": 4877.374,
              "shapeOffsetM": 0.049,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:19135",
              "position": {
                "x": 7312.108,
                "z": 1566.262
              },
              "distanceAlongShapeM": 5317.521,
              "shapeOffsetM": 5.568,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:18938",
              "position": {
                "x": 6681.136,
                "z": 2059.653
              },
              "distanceAlongShapeM": 6224.453,
              "shapeOffsetM": 0.179,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:19203",
              "position": {
                "x": 6139.08,
                "z": 2123.718
              },
              "distanceAlongShapeM": 6982.513,
              "shapeOffsetM": 2.433,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:18983",
              "position": {
                "x": 6229.125,
                "z": 1350.459
              },
              "distanceAlongShapeM": 7983.72,
              "shapeOffsetM": 0.093,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            },
            {
              "stopId": "judu:stop:19209",
              "position": {
                "x": 6176.772,
                "z": 1675.446
              },
              "distanceAlongShapeM": 8312.981,
              "shapeOffsetM": 1.347,
              "arrivalOffsetSeconds": 1500,
              "departureOffsetSeconds": 1500
            },
            {
              "stopId": "judu:stop:19202",
              "position": {
                "x": 6096.19,
                "z": 2141.256
              },
              "distanceAlongShapeM": 8821.765,
              "shapeOffsetM": 1.679,
              "arrivalOffsetSeconds": 1620,
              "departureOffsetSeconds": 1620
            },
            {
              "stopId": "judu:stop:6695",
              "position": {
                "x": 5290.966,
                "z": 2178.068
              },
              "distanceAlongShapeM": 9699.143,
              "shapeOffsetM": 3.054,
              "arrivalOffsetSeconds": 1860,
              "departureOffsetSeconds": 1860
            },
            {
              "stopId": "judu:stop:6693",
              "position": {
                "x": 4915.878,
                "z": 2302.207
              },
              "distanceAlongShapeM": 10214.16,
              "shapeOffsetM": 1.158,
              "arrivalOffsetSeconds": 1920,
              "departureOffsetSeconds": 1920
            },
            {
              "stopId": "judu:stop:6690",
              "position": {
                "x": 4409.806,
                "z": 2529.019
              },
              "distanceAlongShapeM": 10771.759,
              "shapeOffsetM": 4.143,
              "arrivalOffsetSeconds": 1980,
              "departureOffsetSeconds": 1980
            },
            {
              "stopId": "judu:stop:7710",
              "position": {
                "x": 4207.39,
                "z": 2810.094
              },
              "distanceAlongShapeM": 11241.715,
              "shapeOffsetM": 0.398,
              "arrivalOffsetSeconds": 2100,
              "departureOffsetSeconds": 2100
            },
            {
              "stopId": "judu:stop:7711",
              "position": {
                "x": 4689.298,
                "z": 2935.561
              },
              "distanceAlongShapeM": 11739.753,
              "shapeOffsetM": 0.316,
              "arrivalOffsetSeconds": 2160,
              "departureOffsetSeconds": 2160
            },
            {
              "stopId": "judu:stop:7819",
              "position": {
                "x": 5061.022,
                "z": 3035.273
              },
              "distanceAlongShapeM": 12124.618,
              "shapeOffsetM": 0.61,
              "arrivalOffsetSeconds": 2220,
              "departureOffsetSeconds": 2220
            },
            {
              "stopId": "judu:stop:16725",
              "position": {
                "x": 4925.678,
                "z": 3681.348
              },
              "distanceAlongShapeM": 12818.198,
              "shapeOffsetM": 2.689,
              "arrivalOffsetSeconds": 2340,
              "departureOffsetSeconds": 2340
            },
            {
              "stopId": "judu:stop:16715",
              "position": {
                "x": 4705.105,
                "z": 3959.455
              },
              "distanceAlongShapeM": 13176.73,
              "shapeOffsetM": 6.177,
              "arrivalOffsetSeconds": 2400,
              "departureOffsetSeconds": 2400
            },
            {
              "stopId": "judu:stop:9599",
              "position": {
                "x": 4128.817,
                "z": 3832.45
              },
              "distanceAlongShapeM": 13881.533,
              "shapeOffsetM": 3.204,
              "arrivalOffsetSeconds": 2520,
              "departureOffsetSeconds": 2520
            },
            {
              "stopId": "judu:stop:9659",
              "position": {
                "x": 3502.858,
                "z": 3705.202
              },
              "distanceAlongShapeM": 14711.933,
              "shapeOffsetM": 2.059,
              "arrivalOffsetSeconds": 2700,
              "departureOffsetSeconds": 2700
            },
            {
              "stopId": "judu:stop:10614",
              "position": {
                "x": 3069.21,
                "z": 4087.452
              },
              "distanceAlongShapeM": 15291.343,
              "shapeOffsetM": 4.117,
              "arrivalOffsetSeconds": 2760,
              "departureOffsetSeconds": 2760
            },
            {
              "stopId": "judu:stop:16978",
              "position": {
                "x": 1602.913,
                "z": 3721.893
              },
              "distanceAlongShapeM": 16966.578,
              "shapeOffsetM": 1.908,
              "arrivalOffsetSeconds": 3000,
              "departureOffsetSeconds": 3000
            },
            {
              "stopId": "judu:stop:7414",
              "position": {
                "x": -225.435,
                "z": 2951.666
              },
              "distanceAlongShapeM": 19511.432,
              "shapeOffsetM": 2.483,
              "arrivalOffsetSeconds": 3240,
              "departureOffsetSeconds": 3240
            },
            {
              "stopId": "judu:stop:5200",
              "position": {
                "x": -196.145,
                "z": 2858.737
              },
              "distanceAlongShapeM": 19639.462,
              "shapeOffsetM": 3.367,
              "arrivalOffsetSeconds": 3240,
              "departureOffsetSeconds": 3240
            }
          ],
          "departuresSeconds": [
            23040,
            25740,
            28200,
            30660,
            33360,
            36000,
            39420,
            42060,
            44700,
            47340,
            49980,
            52620,
            55560,
            58200,
            60660,
            63240,
            65940,
            69120,
            72180,
            75060,
            77940,
            80400,
            82380,
            84840
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_bus_123",
      "sourceRouteId": "vilnius_bus_123",
      "mode": "bus",
      "shortName": "123",
      "longName": "Žemieji Paneriai (Vaduvos g.) – Centras (Lukiškių g.)",
      "color": "0073AC",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_bus_123:0",
          "sourceRouteId": "vilnius_bus_123",
          "sourceShapeId": "vilnius_bus_123_a-b",
          "directionId": 0,
          "headsign": "Centras (Lukiškių g.)",
          "directionName": "Žemieji Paneriai (Vaduvos g.) – Centras (Lukiškių g.)",
          "mode": "bus",
          "routeShortName": "123",
          "routeLongName": "Žemieji Paneriai (Vaduvos g.) – Centras (Lukiškių g.)",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              -4676.574,
              5608.67,
              0
            ],
            [
              -4686.726,
              5616.335,
              12.721
            ],
            [
              -4731.661,
              5630.554,
              59.852
            ],
            [
              -4761.003,
              5637.68,
              90.047
            ],
            [
              -4772.178,
              5641.176,
              101.756
            ],
            [
              -4792.483,
              5642.108,
              122.082
            ],
            [
              -4797.181,
              5651.623,
              132.694
            ],
            [
              -4795.814,
              5656.052,
              137.329
            ],
            [
              -4793.175,
              5659.346,
              141.55
            ],
            [
              -4786.045,
              5661.3,
              148.943
            ],
            [
              -4779.712,
              5658.316,
              155.944
            ],
            [
              -4773.248,
              5645.645,
              170.168
            ],
            [
              -4754.161,
              5637.528,
              190.909
            ],
            [
              -4684.125,
              5617.404,
              263.779
            ],
            [
              -4663.072,
              5602.571,
              289.533
            ],
            [
              -4640.177,
              5582.141,
              320.218
            ],
            [
              -4596.898,
              5507.928,
              406.128
            ],
            [
              -4573.874,
              5457.44,
              461.618
            ],
            [
              -4564.139,
              5422.764,
              497.635
            ],
            [
              -4561.528,
              5315.897,
              604.534
            ],
            [
              -4579.295,
              5179.234,
              742.347
            ],
            [
              -4580.889,
              5011.17,
              910.418
            ],
            [
              -4518.9,
              4977.81,
              980.814
            ],
            [
              -4503.635,
              4960.862,
              1003.623
            ],
            [
              -4444.377,
              4915.316,
              1078.362
            ],
            [
              -4189.698,
              4671.592,
              1430.871
            ],
            [
              -4167.195,
              4657.338,
              1457.509
            ],
            [
              -4146.524,
              4629.659,
              1492.055
            ],
            [
              -4048.773,
              4533.349,
              1629.28
            ],
            [
              -3823.59,
              4303.471,
              1951.074
            ],
            [
              -3802.623,
              4284.184,
              1979.563
            ],
            [
              -3780.952,
              4268.223,
              2006.477
            ],
            [
              -3768.394,
              4247.967,
              2030.31
            ],
            [
              -3367.467,
              3844.694,
              2598.968
            ],
            [
              -3344.636,
              3829.677,
              2626.294
            ],
            [
              -3315.43,
              3793.692,
              2672.64
            ],
            [
              -3282.402,
              3763.059,
              2717.687
            ],
            [
              -3142.94,
              3618.132,
              2918.818
            ],
            [
              -2996.449,
              3469.738,
              3127.337
            ],
            [
              -2905.063,
              3381.305,
              3254.506
            ],
            [
              -2851.864,
              3323.598,
              3332.993
            ],
            [
              -2827.523,
              3276.416,
              3386.084
            ],
            [
              -2808.656,
              3248.254,
              3419.981
            ],
            [
              -2806.545,
              3221.5,
              3446.819
            ],
            [
              -2772.86,
              3118.493,
              3555.194
            ],
            [
              -2707,
              2936.995,
              3748.271
            ],
            [
              -2660.341,
              2801.476,
              3891.598
            ],
            [
              -2637.179,
              2724.257,
              3972.216
            ],
            [
              -2612.218,
              2675.949,
              4026.591
            ],
            [
              -2598.361,
              2620.045,
              4084.187
            ],
            [
              -2580.849,
              2536.2,
              4169.842
            ],
            [
              -2576.299,
              2480.505,
              4225.722
            ],
            [
              -2568.347,
              2419.138,
              4287.602
            ],
            [
              -2533.425,
              2235.542,
              4474.49
            ],
            [
              -2536.272,
              2210.698,
              4499.496
            ],
            [
              -2548.095,
              2140.478,
              4570.705
            ],
            [
              -2550.229,
              2092.648,
              4618.583
            ],
            [
              -2549.196,
              2041.422,
              4669.819
            ],
            [
              -2537.883,
              1987.788,
              4724.633
            ],
            [
              -2509.509,
              1913.816,
              4803.86
            ],
            [
              -2480.295,
              1850.96,
              4873.174
            ],
            [
              -2442.052,
              1787.945,
              4946.885
            ],
            [
              -2399.099,
              1735.979,
              5014.305
            ],
            [
              -2337.094,
              1666.977,
              5107.073
            ],
            [
              -2299.874,
              1633.438,
              5157.175
            ],
            [
              -2031.65,
              1337.903,
              5556.28
            ],
            [
              -1983.792,
              1217.657,
              5685.7
            ],
            [
              -1971.707,
              1062.705,
              5841.123
            ],
            [
              -1868.597,
              735.51,
              6184.179
            ],
            [
              -1847.199,
              699.714,
              6225.884
            ],
            [
              -1784.443,
              622.304,
              6325.536
            ],
            [
              -1786.057,
              620.796,
              6327.745
            ],
            [
              -1777.149,
              613.958,
              6338.975
            ],
            [
              -1715.729,
              593.015,
              6403.867
            ],
            [
              -1582.912,
              572.925,
              6538.195
            ],
            [
              -1473.012,
              555.724,
              6649.433
            ],
            [
              -1384.209,
              514.979,
              6747.137
            ],
            [
              -1304.906,
              439.653,
              6856.513
            ],
            [
              -1304.242,
              440.754,
              6857.798
            ],
            [
              -1268.912,
              396.705,
              6914.265
            ],
            [
              -1250.068,
              368.537,
              6948.155
            ],
            [
              -1227.675,
              322.493,
              6999.356
            ],
            [
              -1219.127,
              295.623,
              7027.553
            ],
            [
              -1214.142,
              265.861,
              7057.729
            ],
            [
              -1200.621,
              173.264,
              7151.308
            ],
            [
              -1189.802,
              -11.04,
              7335.93
            ],
            [
              -1173.311,
              -206.15,
              7531.735
            ],
            [
              -1158.177,
              -289.849,
              7616.791
            ],
            [
              -1145.948,
              -370.286,
              7698.153
            ],
            [
              -1128.552,
              -442.958,
              7772.878
            ],
            [
              -1103.501,
              -520.22,
              7854.1
            ],
            [
              -1089.839,
              -549.409,
              7886.328
            ],
            [
              -1080.43,
              -564.05,
              7903.731
            ],
            [
              -1026.796,
              -638.192,
              7995.238
            ],
            [
              -986.543,
              -685.967,
              8057.711
            ],
            [
              -964.927,
              -703.054,
              8085.265
            ],
            [
              -944.499,
              -714.554,
              8108.707
            ],
            [
              -887.35,
              -727.829,
              8167.378
            ],
            [
              -849.963,
              -728.502,
              8204.771
            ],
            [
              -795.111,
              -726.152,
              8259.673
            ],
            [
              -764.735,
              -722.247,
              8290.299
            ],
            [
              -725.717,
              -704.026,
              8333.362
            ],
            [
              -702.814,
              -685.514,
              8362.811
            ],
            [
              -690.623,
              -676.974,
              8377.696
            ],
            [
              -655.859,
              -656.305,
              8418.14
            ],
            [
              -601.451,
              -607.193,
              8491.436
            ],
            [
              -500.911,
              -503.255,
              8636.043
            ],
            [
              -413.017,
              -421.354,
              8756.181
            ],
            [
              -305.298,
              -348.72,
              8886.101
            ],
            [
              -335.653,
              -209.016,
              9029.065
            ],
            [
              -372.626,
              -210.078,
              9066.053
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:17506",
              "position": {
                "x": -4640.177,
                "z": 5582.141
              },
              "distanceAlongShapeM": 320.218,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:17507",
              "position": {
                "x": -4560.164,
                "z": 5315.829
              },
              "distanceAlongShapeM": 604.534,
              "shapeOffsetM": 1.366,
              "arrivalOffsetSeconds": 60,
              "departureOffsetSeconds": 60
            },
            {
              "stopId": "judu:stop:6850",
              "position": {
                "x": -4517.509,
                "z": 4980.025
              },
              "distanceAlongShapeM": 980.814,
              "shapeOffsetM": 2.616,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:6851",
              "position": {
                "x": -4166.695,
                "z": 4657.837
              },
              "distanceAlongShapeM": 1457.509,
              "shapeOffsetM": 0.707,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:5546",
              "position": {
                "x": -3780.952,
                "z": 4268.223
              },
              "distanceAlongShapeM": 2006.477,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:9384",
              "position": {
                "x": -3344.49,
                "z": 3829.822
              },
              "distanceAlongShapeM": 2626.294,
              "shapeOffsetM": 0.206,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:857",
              "position": {
                "x": -2808.656,
                "z": 3248.254
              },
              "distanceAlongShapeM": 3419.981,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:5542",
              "position": {
                "x": -2612.218,
                "z": 2675.949
              },
              "distanceAlongShapeM": 4026.591,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:7359",
              "position": {
                "x": -2530.947,
                "z": 2234.799
              },
              "distanceAlongShapeM": 4474.946,
              "shapeOffsetM": 2.546,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:5780",
              "position": {
                "x": -2295.02,
                "z": 1638.403
              },
              "distanceAlongShapeM": 5157.175,
              "shapeOffsetM": 6.943,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:16772",
              "position": {
                "x": -1194.224,
                "z": 173.835
              },
              "distanceAlongShapeM": 7151.308,
              "shapeOffsetM": 6.422,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:9007",
              "position": {
                "x": -1150.937,
                "z": -288.931
              },
              "distanceAlongShapeM": 7616.972,
              "shapeOffsetM": 7.295,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:5539",
              "position": {
                "x": -692.924,
                "z": -673.447
              },
              "distanceAlongShapeM": 8377.696,
              "shapeOffsetM": 4.211,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:7663",
              "position": {
                "x": -372.48,
                "z": -212.801
              },
              "distanceAlongShapeM": 9065.985,
              "shapeOffsetM": 2.726,
              "arrivalOffsetSeconds": 1380,
              "departureOffsetSeconds": 1380
            }
          ],
          "departuresSeconds": [
            19800,
            21600,
            23580,
            25560,
            27540,
            29520,
            31500,
            33660,
            36540,
            38700,
            40740,
            42660,
            44580,
            46500,
            48420,
            50340,
            52260,
            54360,
            56460,
            58620,
            60600,
            62700,
            64860,
            67020,
            69240,
            72000,
            74220,
            76320,
            78120,
            79920,
            81720,
            83520
          ]
        },
        {
          "id": "judu:pattern:vilnius_bus_123:1",
          "sourceRouteId": "vilnius_bus_123",
          "sourceShapeId": "vilnius_bus_123_b-a",
          "directionId": 1,
          "headsign": "Žemieji Paneriai (Vaduvos g.)",
          "directionName": "Centras (Lukiškių g.) – Žemieji Paneriai (Vaduvos g.)",
          "mode": "bus",
          "routeShortName": "123",
          "routeLongName": "Žemieji Paneriai (Vaduvos g.) – Centras (Lukiškių g.)",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              -372.626,
              -210.078,
              0
            ],
            [
              -418.232,
              -210.859,
              45.613
            ],
            [
              -451.474,
              -230.295,
              84.12
            ],
            [
              -478.241,
              -268.382,
              130.672
            ],
            [
              -501.093,
              -299.53,
              169.304
            ],
            [
              -510.139,
              -300.48,
              178.399
            ],
            [
              -513.322,
              -298.196,
              182.317
            ],
            [
              -611.52,
              -58.189,
              441.636
            ],
            [
              -614.075,
              -53.155,
              447.281
            ],
            [
              -625.745,
              -24.535,
              478.189
            ],
            [
              -643.846,
              18.014,
              524.428
            ],
            [
              -658.953,
              100.746,
              608.528
            ],
            [
              -724.996,
              86.353,
              676.121
            ],
            [
              -736.71,
              77.277,
              690.94
            ],
            [
              -743.833,
              78.9,
              698.246
            ],
            [
              -798.875,
              66.534,
              754.66
            ],
            [
              -863.023,
              49.879,
              820.934
            ],
            [
              -871.015,
              45.142,
              830.225
            ],
            [
              -894.129,
              41.533,
              853.619
            ],
            [
              -1188.314,
              -26.001,
              1155.457
            ],
            [
              -1194.241,
              29.116,
              1210.891
            ],
            [
              -1202.035,
              133.899,
              1315.964
            ],
            [
              -1211.213,
              197.517,
              1380.24
            ],
            [
              -1216.562,
              218.17,
              1401.575
            ],
            [
              -1216.908,
              275.545,
              1458.951
            ],
            [
              -1295.108,
              410.533,
              1614.954
            ],
            [
              -1421.18,
              501.848,
              1770.622
            ],
            [
              -1664.877,
              569.298,
              2023.481
            ],
            [
              -1779.282,
              602.863,
              2142.708
            ],
            [
              -1835.797,
              652.851,
              2218.159
            ],
            [
              -1891.295,
              754.63,
              2334.086
            ],
            [
              -2014.022,
              1222.647,
              2817.926
            ],
            [
              -2053.129,
              1320.26,
              2923.082
            ],
            [
              -2069.692,
              1357.221,
              2963.584
            ],
            [
              -2131.9,
              1450.721,
              3075.887
            ],
            [
              -2187.002,
              1508.471,
              3155.708
            ],
            [
              -2364.512,
              1685.273,
              3406.245
            ],
            [
              -2405.647,
              1730.529,
              3467.402
            ],
            [
              -2432.322,
              1754.377,
              3503.183
            ],
            [
              -2454.599,
              1782.57,
              3539.115
            ],
            [
              -2465.207,
              1807.407,
              3566.122
            ],
            [
              -2517.308,
              1910.614,
              3681.735
            ],
            [
              -2537.025,
              1963.282,
              3737.972
            ],
            [
              -2549.238,
              2002.46,
              3779.01
            ],
            [
              -2554.454,
              2035.948,
              3812.902
            ],
            [
              -2559.337,
              2088.355,
              3865.536
            ],
            [
              -2553.059,
              2151.698,
              3929.189
            ],
            [
              -2549.631,
              2181.469,
              3959.157
            ],
            [
              -2546.675,
              2206.576,
              3984.437
            ],
            [
              -2548.769,
              2256.45,
              4034.355
            ],
            [
              -2553.934,
              2289.911,
              4068.212
            ],
            [
              -2570.383,
              2352.49,
              4132.918
            ],
            [
              -2586.213,
              2430.585,
              4212.6
            ],
            [
              -2602.898,
              2582.275,
              4365.205
            ],
            [
              -2619.569,
              2661.607,
              4446.27
            ],
            [
              -2672.012,
              2798.342,
              4592.717
            ],
            [
              -2693.846,
              2841.028,
              4640.663
            ],
            [
              -2698.439,
              2873.392,
              4673.351
            ],
            [
              -2831.804,
              3253.114,
              5075.812
            ],
            [
              -2853.662,
              3294.686,
              5122.781
            ],
            [
              -2869.962,
              3320.622,
              5153.413
            ],
            [
              -2887.849,
              3332.714,
              5175.005
            ],
            [
              -2904.222,
              3355.687,
              5203.215
            ],
            [
              -3126.24,
              3576.651,
              5516.451
            ],
            [
              -3256.351,
              3702.491,
              5697.461
            ],
            [
              -3334.924,
              3786.24,
              5812.298
            ],
            [
              -3406.008,
              3855.385,
              5911.465
            ],
            [
              -3427.01,
              3872.449,
              5938.525
            ],
            [
              -3454.8,
              3907.442,
              5983.211
            ],
            [
              -3626.746,
              4078.528,
              6225.772
            ],
            [
              -3781.512,
              4235.95,
              6446.53
            ],
            [
              -3884.317,
              4337.92,
              6591.329
            ],
            [
              -3915.514,
              4362.95,
              6631.326
            ],
            [
              -3928.112,
              4380.98,
              6653.321
            ],
            [
              -4226.292,
              4683.356,
              7077.989
            ],
            [
              -4305.622,
              4762.647,
              7190.151
            ],
            [
              -4338.114,
              4787.696,
              7231.177
            ],
            [
              -4349.425,
              4805.702,
              7252.441
            ],
            [
              -4420.502,
              4877.057,
              7353.156
            ],
            [
              -4439.501,
              4898.534,
              7381.83
            ],
            [
              -4461.157,
              4915.604,
              7409.405
            ],
            [
              -4476.532,
              4922.548,
              7426.275
            ],
            [
              -4485.887,
              4927.855,
              7437.031
            ],
            [
              -4508.363,
              4948.698,
              7467.684
            ],
            [
              -4600.366,
              5004.825,
              7575.456
            ],
            [
              -4658.205,
              5020.288,
              7635.326
            ],
            [
              -4736.87,
              5026.089,
              7714.205
            ],
            [
              -4780.797,
              5023.521,
              7758.206
            ],
            [
              -4794.293,
              5028.186,
              7772.486
            ],
            [
              -4887.841,
              5032.012,
              7866.112
            ],
            [
              -4834.705,
              5081.197,
              7938.518
            ],
            [
              -4785.441,
              5130.448,
              8008.179
            ],
            [
              -4754.629,
              5157.75,
              8049.346
            ],
            [
              -4724.691,
              5171.709,
              8082.379
            ],
            [
              -4669.049,
              5178.483,
              8138.431
            ],
            [
              -4623.964,
              5172.209,
              8183.951
            ],
            [
              -4586.132,
              5157.088,
              8224.693
            ],
            [
              -4572.818,
              5218.085,
              8287.126
            ],
            [
              -4569.635,
              5259.151,
              8328.316
            ],
            [
              -4563.466,
              5376.395,
              8445.721
            ],
            [
              -4563.99,
              5393.818,
              8463.152
            ],
            [
              -4568.722,
              5435.61,
              8505.211
            ],
            [
              -4574.084,
              5454.55,
              8524.896
            ],
            [
              -4589.045,
              5487.559,
              8561.138
            ],
            [
              -4645.752,
              5583.549,
              8672.626
            ],
            [
              -4661.838,
              5599.211,
              8695.077
            ],
            [
              -4676.574,
              5608.67,
              8712.588
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:6356",
              "position": {
                "x": -476.052,
                "z": -269.926
              },
              "distanceAlongShapeM": 130.672,
              "shapeOffsetM": 2.679,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:5264",
              "position": {
                "x": -646.921,
                "z": 17.037
              },
              "distanceAlongShapeM": 524.428,
              "shapeOffsetM": 3.227,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:5936",
              "position": {
                "x": -736.157,
                "z": 75.422
              },
              "distanceAlongShapeM": 690.94,
              "shapeOffsetM": 1.935,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:19193",
              "position": {
                "x": -870.86,
                "z": 44.454
              },
              "distanceAlongShapeM": 830.225,
              "shapeOffsetM": 0.705,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:16773",
              "position": {
                "x": -1221.169,
                "z": 217.734
              },
              "distanceAlongShapeM": 1401.575,
              "shapeOffsetM": 4.628,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:5778",
              "position": {
                "x": -2055.531,
                "z": 1319.12
              },
              "distanceAlongShapeM": 2922.917,
              "shapeOffsetM": 2.654,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:5779",
              "position": {
                "x": -2457.669,
                "z": 1780.429
              },
              "distanceAlongShapeM": 3539.115,
              "shapeOffsetM": 3.743,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:7358",
              "position": {
                "x": -2553.368,
                "z": 2207.364
              },
              "distanceAlongShapeM": 3985.505,
              "shapeOffsetM": 6.654,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:5543",
              "position": {
                "x": -2693.846,
                "z": 2841.028
              },
              "distanceAlongShapeM": 4640.663,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:5573",
              "position": {
                "x": -2888.502,
                "z": 3332.034
              },
              "distanceAlongShapeM": 5175.005,
              "shapeOffsetM": 0.943,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:5587",
              "position": {
                "x": -3427.01,
                "z": 3872.449
              },
              "distanceAlongShapeM": 5938.525,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            },
            {
              "stopId": "judu:stop:5588",
              "position": {
                "x": -3915.514,
                "z": 4362.95
              },
              "distanceAlongShapeM": 6631.326,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1050,
              "departureOffsetSeconds": 1050
            },
            {
              "stopId": "judu:stop:5554",
              "position": {
                "x": -4338.114,
                "z": 4787.696
              },
              "distanceAlongShapeM": 7231.177,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:5567",
              "position": {
                "x": -4488.111,
                "z": 4924.973
              },
              "distanceAlongShapeM": 7437.031,
              "shapeOffsetM": 3.641,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:5557",
              "position": {
                "x": -4780.873,
                "z": 5020.164
              },
              "distanceAlongShapeM": 7758.206,
              "shapeOffsetM": 3.358,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:5594",
              "position": {
                "x": -4669.05,
                "z": 5178.548
              },
              "distanceAlongShapeM": 8138.431,
              "shapeOffsetM": 0.065,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            },
            {
              "stopId": "judu:stop:17504",
              "position": {
                "x": -4570.105,
                "z": 5376.112
              },
              "distanceAlongShapeM": 8445.09,
              "shapeOffsetM": 6.615,
              "arrivalOffsetSeconds": 1380,
              "departureOffsetSeconds": 1380
            },
            {
              "stopId": "judu:stop:17505",
              "position": {
                "x": -4679.19,
                "z": 5603.961
              },
              "distanceAlongShapeM": 8712.246,
              "shapeOffsetM": 5.376,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            }
          ],
          "departuresSeconds": [
            21360,
            23220,
            25200,
            27180,
            29280,
            31200,
            33180,
            35340,
            38220,
            40380,
            42240,
            44340,
            46260,
            48120,
            50040,
            51900,
            54240,
            56400,
            58140,
            60360,
            62520,
            64680,
            66600,
            68700,
            70860,
            73560,
            75720,
            77820,
            79620,
            81420,
            83220,
            85080
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_bus_125",
      "sourceRouteId": "vilnius_bus_125",
      "mode": "bus",
      "shortName": "125",
      "longName": "Gabijos progimnazija–Visorių g.–Bajorai– Visoriai",
      "color": "0073AC",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_bus_125:0",
          "sourceRouteId": "vilnius_bus_125",
          "sourceShapeId": "vilnius_bus_125_a-b",
          "directionId": 0,
          "headsign": "Visoriai",
          "directionName": "Gabijos progimnazija–Visorių g.–Bajorai– Visoriai",
          "mode": "bus",
          "routeShortName": "125",
          "routeLongName": "Gabijos progimnazija–Visorių g.–Bajorai– Visoriai",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              -3251.841,
              -5200.123,
              0
            ],
            [
              -3237.885,
              -5231.361,
              34.214
            ],
            [
              -3198.857,
              -5246.517,
              76.082
            ],
            [
              -3170.932,
              -5270.384,
              112.816
            ],
            [
              -3134.21,
              -5337.848,
              189.627
            ],
            [
              -3123.704,
              -5346.5,
              203.237
            ],
            [
              -3113.758,
              -5352.652,
              214.932
            ],
            [
              -3083.903,
              -5376.554,
              253.176
            ],
            [
              -3052.839,
              -5404.93,
              295.25
            ],
            [
              -3047.2,
              -5413.934,
              305.874
            ],
            [
              -3035.925,
              -5397.775,
              325.578
            ],
            [
              -3033.871,
              -5388.564,
              335.015
            ],
            [
              -2977.67,
              -5306.06,
              434.842
            ],
            [
              -2859.367,
              -5119.841,
              655.462
            ],
            [
              -2787.712,
              -4995.277,
              799.165
            ],
            [
              -2737.802,
              -4912.753,
              895.608
            ],
            [
              -2672.209,
              -4823.848,
              1006.091
            ],
            [
              -2619.375,
              -4786.931,
              1070.545
            ],
            [
              -2578.679,
              -4744.234,
              1129.53
            ],
            [
              -2552.315,
              -4687.753,
              1191.86
            ],
            [
              -2488.392,
              -4702.414,
              1257.443
            ],
            [
              -2436.56,
              -4722.255,
              1312.943
            ],
            [
              -2367.109,
              -4765.787,
              1394.909
            ],
            [
              -2297.928,
              -4830.879,
              1489.898
            ],
            [
              -2247.29,
              -4911.517,
              1585.118
            ],
            [
              -2239.148,
              -4925.337,
              1601.158
            ],
            [
              -2217.405,
              -4969.935,
              1650.774
            ],
            [
              -2110.315,
              -5178.897,
              1885.579
            ],
            [
              -2057.336,
              -5161.028,
              1941.49
            ],
            [
              -2028.76,
              -5156.969,
              1970.353
            ],
            [
              -1894.397,
              -5142.15,
              2105.531
            ],
            [
              -1856.383,
              -5135.547,
              2144.114
            ],
            [
              -1800.644,
              -5116.503,
              2203.016
            ],
            [
              -1770.723,
              -5100.339,
              2237.024
            ],
            [
              -1738.711,
              -5075.306,
              2277.662
            ],
            [
              -1710.503,
              -5046.865,
              2317.719
            ],
            [
              -1676.24,
              -5004.061,
              2372.548
            ],
            [
              -1627.812,
              -5023.801,
              2424.844
            ],
            [
              -1586.957,
              -5054.639,
              2476.031
            ],
            [
              -1465.895,
              -5129.166,
              2618.194
            ],
            [
              -1407.208,
              -5161.388,
              2685.145
            ],
            [
              -1338.038,
              -5183.78,
              2757.849
            ],
            [
              -1272.777,
              -5203.963,
              2826.16
            ],
            [
              -1183.862,
              -5243.323,
              2923.397
            ],
            [
              -1239.325,
              -5390.387,
              3080.572
            ],
            [
              -1248.276,
              -5422.51,
              3113.919
            ],
            [
              -1254.01,
              -5446.885,
              3138.959
            ],
            [
              -1255.237,
              -5507.284,
              3199.371
            ],
            [
              -1340.403,
              -5524.771,
              3286.313
            ],
            [
              -1444.258,
              -5565.439,
              3397.847
            ],
            [
              -1495.217,
              -5579.5,
              3450.71
            ],
            [
              -1670.793,
              -5641.125,
              3636.786
            ],
            [
              -1700.422,
              -5655.384,
              3669.669
            ],
            [
              -1745.15,
              -5688.581,
              3725.37
            ],
            [
              -1794.861,
              -5731.109,
              3790.79
            ],
            [
              -1819.161,
              -5757.393,
              3826.586
            ],
            [
              -1840.095,
              -5789.898,
              3865.248
            ],
            [
              -1867.731,
              -5831.467,
              3915.166
            ],
            [
              -1886.236,
              -5870.86,
              3958.689
            ],
            [
              -1910.032,
              -5977.306,
              4067.762
            ],
            [
              -1913.76,
              -6064.119,
              4154.656
            ],
            [
              -1908.65,
              -6111.505,
              4202.316
            ],
            [
              -1876.202,
              -6248.15,
              4342.761
            ],
            [
              -1853.323,
              -6390.043,
              4486.486
            ],
            [
              -1844.77,
              -6434.894,
              4532.146
            ],
            [
              -1843.653,
              -6451.597,
              4548.886
            ],
            [
              -1845.08,
              -6463.311,
              4560.686
            ],
            [
              -1853.15,
              -6471.481,
              4572.17
            ],
            [
              -1878.996,
              -6475.348,
              4598.304
            ],
            [
              -1982.769,
              -6481.417,
              4702.254
            ],
            [
              -2132.094,
              -6486.559,
              4851.667
            ],
            [
              -2163.266,
              -6491.566,
              4883.239
            ],
            [
              -2270.6,
              -6527.777,
              4996.517
            ],
            [
              -2250.46,
              -6720.04,
              5189.831
            ],
            [
              -2245.796,
              -6776.152,
              5246.138
            ],
            [
              -2253.317,
              -6848.427,
              5318.802
            ],
            [
              -2252.91,
              -6861.793,
              5332.175
            ],
            [
              -2228.699,
              -6876.678,
              5360.595
            ],
            [
              -2110.971,
              -6917.793,
              5485.296
            ],
            [
              -2031.2,
              -6959.244,
              5575.194
            ],
            [
              -1964.611,
              -7003.787,
              5655.307
            ],
            [
              -1937.041,
              -7023.262,
              5689.062
            ],
            [
              -1903.786,
              -7036.1,
              5724.709
            ],
            [
              -1820.159,
              -7064.429,
              5813.004
            ],
            [
              -1672.686,
              -7122.327,
              5971.436
            ],
            [
              -1671.07,
              -7129.314,
              5978.607
            ],
            [
              -1691.867,
              -7140.074,
              6002.023
            ],
            [
              -1721.231,
              -7161.814,
              6038.558
            ],
            [
              -1757.734,
              -7213.74,
              6102.031
            ],
            [
              -1780.772,
              -7250.922,
              6145.772
            ],
            [
              -1795.815,
              -7264.013,
              6165.713
            ],
            [
              -1813.976,
              -7271.481,
              6185.35
            ],
            [
              -1905.151,
              -7293.233,
              6279.084
            ],
            [
              -1927.838,
              -7301.734,
              6303.311
            ],
            [
              -1954.522,
              -7314.206,
              6332.766
            ],
            [
              -2033.763,
              -7360.386,
              6424.481
            ],
            [
              -2181.211,
              -7464.674,
              6605.083
            ],
            [
              -2371.558,
              -7507.326,
              6800.15
            ],
            [
              -2672.29,
              -7564.577,
              7106.283
            ],
            [
              -2721.176,
              -7573.87,
              7156.045
            ],
            [
              -2749.794,
              -7578.826,
              7185.089
            ],
            [
              -2757.259,
              -7578.837,
              7192.553
            ],
            [
              -2764.478,
              -7572.527,
              7202.142
            ],
            [
              -2768.918,
              -7547.403,
              7227.655
            ],
            [
              -2776.371,
              -7516.016,
              7259.915
            ],
            [
              -2831.651,
              -7364.756,
              7420.959
            ],
            [
              -2959.943,
              -7378.775,
              7550.015
            ],
            [
              -3037.654,
              -7386.962,
              7628.156
            ],
            [
              -3196.959,
              -7403.148,
              7788.281
            ],
            [
              -3243.181,
              -7407.617,
              7834.719
            ],
            [
              -3248.513,
              -7412.068,
              7841.665
            ],
            [
              -3247.565,
              -7614.546,
              8044.145
            ],
            [
              -3249.912,
              -7644.616,
              8074.307
            ],
            [
              -3240.979,
              -7649.226,
              8084.359
            ],
            [
              -3135.153,
              -7635.497,
              8191.072
            ],
            [
              -3078.04,
              -7624.281,
              8249.275
            ],
            [
              -2956.659,
              -7592.178,
              8374.83
            ],
            [
              -2909.326,
              -7593.484,
              8422.181
            ],
            [
              -2880.148,
              -7595.779,
              8451.449
            ],
            [
              -2801.578,
              -7586.209,
              8530.6
            ],
            [
              -2724.915,
              -7572.696,
              8608.445
            ],
            [
              -2672.29,
              -7564.577,
              8661.693
            ],
            [
              -2423.247,
              -7515.651,
              8915.496
            ],
            [
              -2199.283,
              -7470.475,
              9143.971
            ],
            [
              -1983.025,
              -7327.469,
              9403.236
            ],
            [
              -1920.619,
              -7298.168,
              9472.178
            ],
            [
              -1856.905,
              -7280.04,
              9538.421
            ],
            [
              -1808.787,
              -7269.347,
              9587.712
            ],
            [
              -1791.249,
              -7260.755,
              9607.242
            ],
            [
              -1761.58,
              -7220.757,
              9657.042
            ],
            [
              -1726.273,
              -7161.772,
              9725.787
            ],
            [
              -1714.551,
              -7147.067,
              9744.593
            ],
            [
              -1705.378,
              -7127.17,
              9766.503
            ],
            [
              -1690.122,
              -7114.501,
              9786.333
            ],
            [
              -1672.882,
              -7122.602,
              9805.381
            ],
            [
              -1630.537,
              -7131.152,
              9848.581
            ],
            [
              -1593.251,
              -7133.926,
              9885.97
            ],
            [
              -1568.683,
              -7130.715,
              9910.747
            ],
            [
              -1548.965,
              -7133.145,
              9930.614
            ],
            [
              -1518.794,
              -7147.624,
              9964.079
            ],
            [
              -1410.181,
              -7230.837,
              10100.905
            ],
            [
              -1380.891,
              -7249.174,
              10135.461
            ],
            [
              -1311.07,
              -7269.352,
              10208.139
            ],
            [
              -1233.406,
              -7282.993,
              10286.992
            ],
            [
              -1124.102,
              -7291.639,
              10396.638
            ],
            [
              -1082.888,
              -7291.268,
              10437.853
            ],
            [
              -1077.696,
              -7289.237,
              10443.428
            ],
            [
              -1074.971,
              -7270.348,
              10462.513
            ],
            [
              -1062.473,
              -7266.031,
              10475.736
            ],
            [
              -1045.667,
              -7269.285,
              10492.854
            ],
            [
              -1002.208,
              -7280.476,
              10537.731
            ],
            [
              -979.66,
              -7279.769,
              10560.29
            ],
            [
              -935.71,
              -7270.543,
              10605.198
            ],
            [
              -707.406,
              -7214.553,
              10840.267
            ],
            [
              -684.153,
              -7210.52,
              10863.867
            ],
            [
              -637.449,
              -7283.542,
              10950.548
            ],
            [
              -627.895,
              -7303.938,
              10973.07
            ],
            [
              -546.854,
              -7512.775,
              11197.08
            ],
            [
              -515.78,
              -7627.271,
              11315.718
            ],
            [
              -515.818,
              -7656.64,
              11345.087
            ],
            [
              -519.805,
              -7734.495,
              11423.044
            ],
            [
              -528.583,
              -7735.443,
              11431.874
            ],
            [
              -533.22,
              -7728.712,
              11440.047
            ],
            [
              -553.645,
              -7714.385,
              11464.996
            ],
            [
              -554.029,
              -7703.108,
              11476.279
            ],
            [
              -548.387,
              -7640.899,
              11538.744
            ],
            [
              -637.752,
              -7637.15,
              11628.188
            ],
            [
              -661.958,
              -7636.641,
              11652.399
            ],
            [
              -677.044,
              -7635.907,
              11667.502
            ],
            [
              -928.758,
              -7670.321,
              11921.558
            ],
            [
              -968.788,
              -7695.626,
              11968.916
            ],
            [
              -996.594,
              -7701.107,
              11997.256
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:795",
              "position": {
                "x": -3249.554,
                "z": -5198.873
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 2.606,
              "arrivalOffsetSeconds": -240,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:7809",
              "position": {
                "x": -3033.871,
                "z": -5388.564
              },
              "distanceAlongShapeM": 335.015,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:5518",
              "position": {
                "x": -2739.468,
                "z": -4911.72
              },
              "distanceAlongShapeM": 895.608,
              "shapeOffsetM": 1.96,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:6911",
              "position": {
                "x": -2236.559,
                "z": -4923.953
              },
              "distanceAlongShapeM": 1601.158,
              "shapeOffsetM": 2.936,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:6913",
              "position": {
                "x": -2058.363,
                "z": -5155.329
              },
              "distanceAlongShapeM": 1941.49,
              "shapeOffsetM": 5.79,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:5810",
              "position": {
                "x": -1625.643,
                "z": -5020.551
              },
              "distanceAlongShapeM": 2424.844,
              "shapeOffsetM": 3.907,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:5815",
              "position": {
                "x": -1271.325,
                "z": -5199.449
              },
              "distanceAlongShapeM": 2826.16,
              "shapeOffsetM": 4.742,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:17872",
              "position": {
                "x": -1444.089,
                "z": -5565.944
              },
              "distanceAlongShapeM": 3397.847,
              "shapeOffsetM": 0.533,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:17863",
              "position": {
                "x": -1834.625,
                "z": -5793.854
              },
              "distanceAlongShapeM": 3865.515,
              "shapeOffsetM": 6.745,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:17866",
              "position": {
                "x": -1872.982,
                "z": -6247.368
              },
              "distanceAlongShapeM": 4342.744,
              "shapeOffsetM": 3.313,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:17869",
              "position": {
                "x": -2264.276,
                "z": -6558.793
              },
              "distanceAlongShapeM": 5028.023,
              "shapeOffsetM": 3.058,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:9693",
              "position": {
                "x": -1952.594,
                "z": -7317.992
              },
              "distanceAlongShapeM": 6333.007,
              "shapeOffsetM": 4.242,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:9970",
              "position": {
                "x": -2371.269,
                "z": -7508.706
              },
              "distanceAlongShapeM": 6800.15,
              "shapeOffsetM": 1.41,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:9496",
              "position": {
                "x": -2768.73,
                "z": -7557.34
              },
              "distanceAlongShapeM": 7217.837,
              "shapeOffsetM": 1.544,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            },
            {
              "stopId": "judu:stop:9815",
              "position": {
                "x": -3037.466,
                "z": -7388.964
              },
              "distanceAlongShapeM": 7628.172,
              "shapeOffsetM": 2.011,
              "arrivalOffsetSeconds": 1380,
              "departureOffsetSeconds": 1380
            },
            {
              "stopId": "judu:stop:15548",
              "position": {
                "x": -2725.784,
                "z": -7568.117
              },
              "distanceAlongShapeM": 8608.384,
              "shapeOffsetM": 4.661,
              "arrivalOffsetSeconds": 1500,
              "departureOffsetSeconds": 1500
            },
            {
              "stopId": "judu:stop:9971",
              "position": {
                "x": -2424.106,
                "z": -7511.11
              },
              "distanceAlongShapeM": 8915.552,
              "shapeOffsetM": 4.622,
              "arrivalOffsetSeconds": 1560,
              "departureOffsetSeconds": 1560
            },
            {
              "stopId": "judu:stop:9694",
              "position": {
                "x": -1983.025,
                "z": -7327.469
              },
              "distanceAlongShapeM": 9403.236,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1620,
              "departureOffsetSeconds": 1620
            },
            {
              "stopId": "judu:stop:7052",
              "position": {
                "x": -1045.114,
                "z": -7267.457
              },
              "distanceAlongShapeM": 10492.934,
              "shapeOffsetM": 1.908,
              "arrivalOffsetSeconds": 1800,
              "departureOffsetSeconds": 1800
            },
            {
              "stopId": "judu:stop:7980",
              "position": {
                "x": -633.285,
                "z": -7281.575
              },
              "distanceAlongShapeM": 10950.548,
              "shapeOffsetM": 4.606,
              "arrivalOffsetSeconds": 1980,
              "departureOffsetSeconds": 1980
            },
            {
              "stopId": "judu:stop:7046",
              "position": {
                "x": -661.758,
                "z": -7645.09
              },
              "distanceAlongShapeM": 11652.021,
              "shapeOffsetM": 8.443,
              "arrivalOffsetSeconds": 2160,
              "departureOffsetSeconds": 2160
            },
            {
              "stopId": "judu:stop:1115",
              "position": {
                "x": -995.773,
                "z": -7709.189
              },
              "distanceAlongShapeM": 11997.256,
              "shapeOffsetM": 8.123,
              "arrivalOffsetSeconds": 2160,
              "departureOffsetSeconds": 2160
            }
          ],
          "departuresSeconds": [
            17940,
            20520,
            22500,
            25260,
            27420,
            30540,
            33060,
            37140,
            39720,
            42300,
            44700,
            47220,
            50220,
            52680,
            55140,
            58080,
            60480,
            63540,
            66420,
            70440,
            72960,
            75660,
            78060,
            80640
          ]
        },
        {
          "id": "judu:pattern:vilnius_bus_125:1",
          "sourceRouteId": "vilnius_bus_125",
          "sourceShapeId": "vilnius_bus_125_b-a",
          "directionId": 1,
          "headsign": "Gabijos progimnazija",
          "directionName": "Visoriai–Bajorai–Visorių g.–Gabijos progimnazija",
          "mode": "bus",
          "routeShortName": "125",
          "routeLongName": "Gabijos progimnazija–Visorių g.–Bajorai– Visoriai",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              -995.773,
              -7709.189,
              0
            ],
            [
              -1008.525,
              -7702.28,
              14.503
            ],
            [
              -1017.555,
              -7703.23,
              23.584
            ],
            [
              -1031.635,
              -7698.523,
              38.429
            ],
            [
              -1034.149,
              -7695.138,
              42.646
            ],
            [
              -1034.672,
              -7688.449,
              49.355
            ],
            [
              -1028.056,
              -7678.549,
              61.262
            ],
            [
              -952.572,
              -7669.891,
              137.241
            ],
            [
              -687.301,
              -7633.495,
              404.997
            ],
            [
              -638.969,
              -7631.03,
              453.392
            ],
            [
              -576.036,
              -7639.963,
              516.956
            ],
            [
              -525.25,
              -7644.223,
              567.92
            ],
            [
              -547.168,
              -7539.181,
              675.224
            ],
            [
              -607.804,
              -7403.38,
              823.948
            ],
            [
              -698.737,
              -7233.634,
              1016.516
            ],
            [
              -752.866,
              -7235.995,
              1070.697
            ],
            [
              -779.861,
              -7233.281,
              1097.827
            ],
            [
              -817.998,
              -7241.497,
              1136.84
            ],
            [
              -975.194,
              -7282.076,
              1299.189
            ],
            [
              -999.07,
              -7284.985,
              1323.241
            ],
            [
              -1008.745,
              -7285.924,
              1332.962
            ],
            [
              -1020.815,
              -7276.801,
              1348.092
            ],
            [
              -1038.154,
              -7274.262,
              1365.615
            ],
            [
              -1047.829,
              -7275.201,
              1375.336
            ],
            [
              -1052.254,
              -7270.668,
              1381.671
            ],
            [
              -1063.8,
              -7268.234,
              1393.471
            ],
            [
              -1078.061,
              -7273.543,
              1408.688
            ],
            [
              -1073.172,
              -7288.103,
              1424.047
            ],
            [
              -1073.856,
              -7290.317,
              1426.364
            ],
            [
              -1077.095,
              -7291.372,
              1429.77
            ],
            [
              -1151.78,
              -7291.141,
              1504.456
            ],
            [
              -1217.998,
              -7285.497,
              1570.914
            ],
            [
              -1329.053,
              -7266.803,
              1683.531
            ],
            [
              -1377.069,
              -7251.469,
              1733.936
            ],
            [
              -1412.132,
              -7231.915,
              1774.083
            ],
            [
              -1507.971,
              -7154.497,
              1897.285
            ],
            [
              -1536.014,
              -7138.409,
              1929.615
            ],
            [
              -1559.731,
              -7132.419,
              1954.077
            ],
            [
              -1599.016,
              -7132.829,
              1993.364
            ],
            [
              -1638.222,
              -7128.788,
              2032.777
            ],
            [
              -1667.851,
              -7129.371,
              2062.413
            ],
            [
              -1685.974,
              -7134.613,
              2081.278
            ],
            [
              -1717.309,
              -7158.544,
              2120.706
            ],
            [
              -1736.997,
              -7179.344,
              2149.346
            ],
            [
              -1784.713,
              -7255.305,
              2239.051
            ],
            [
              -1799.697,
              -7265.057,
              2256.928
            ],
            [
              -1918.084,
              -7296.342,
              2379.379
            ],
            [
              -1942.097,
              -7307.046,
              2405.671
            ],
            [
              -1952.594,
              -7317.992,
              2420.836
            ],
            [
              -2033.201,
              -7361.085,
              2512.239
            ],
            [
              -2179.338,
              -7468.697,
              2693.722
            ],
            [
              -2371.269,
              -7508.706,
              2889.779
            ],
            [
              -2672.284,
              -7564.608,
              3195.941
            ],
            [
              -2720.772,
              -7575.998,
              3245.749
            ],
            [
              -2749.794,
              -7578.826,
              3274.908
            ],
            [
              -2757.498,
              -7577.576,
              3282.713
            ],
            [
              -2765.787,
              -7572.977,
              3292.192
            ],
            [
              -2768.554,
              -7547.324,
              3317.994
            ],
            [
              -2776.371,
              -7516.016,
              3350.263
            ],
            [
              -2831.651,
              -7364.756,
              3511.308
            ],
            [
              -2960.012,
              -7378.081,
              3640.36
            ],
            [
              -3037.466,
              -7388.964,
              3718.574
            ],
            [
              -3196.78,
              -7405.092,
              3878.702
            ],
            [
              -3243.181,
              -7407.617,
              3925.172
            ],
            [
              -3247.121,
              -7412.001,
              3931.067
            ],
            [
              -3244.879,
              -7614.647,
              4133.725
            ],
            [
              -3249.912,
              -7644.616,
              4164.113
            ],
            [
              -3240.979,
              -7649.226,
              4174.165
            ],
            [
              -3135.153,
              -7635.497,
              4280.878
            ],
            [
              -3078.28,
              -7623.138,
              4339.079
            ],
            [
              -2956.692,
              -7591.879,
              4464.62
            ],
            [
              -2909.025,
              -7590.491,
              4512.308
            ],
            [
              -2880.14,
              -7595.453,
              4541.616
            ],
            [
              -2802.026,
              -7583.471,
              4620.643
            ],
            [
              -2725.784,
              -7568.117,
              4698.416
            ],
            [
              -2672.284,
              -7564.608,
              4752.031
            ],
            [
              -2424.106,
              -7511.11,
              5005.909
            ],
            [
              -2200.558,
              -7467.206,
              5233.728
            ],
            [
              -1983.025,
              -7327.469,
              5492.276
            ],
            [
              -1916.757,
              -7294.139,
              5566.454
            ],
            [
              -1802.895,
              -7263.886,
              5684.266
            ],
            [
              -1791.15,
              -7255.19,
              5698.88
            ],
            [
              -1725.113,
              -7162.858,
              5812.397
            ],
            [
              -1689.896,
              -7137.883,
              5855.571
            ],
            [
              -1676.259,
              -7131.447,
              5870.65
            ],
            [
              -1676.1,
              -7122.544,
              5879.555
            ],
            [
              -1688.211,
              -7115.648,
              5893.491
            ],
            [
              -1835.287,
              -7058.473,
              6051.29
            ],
            [
              -1926.217,
              -7030.134,
              6146.533
            ],
            [
              -1961.907,
              -7009.46,
              6187.779
            ],
            [
              -1982.833,
              -6991.276,
              6215.502
            ],
            [
              -2000.015,
              -6979.838,
              6236.143
            ],
            [
              -2079.043,
              -6933.902,
              6327.552
            ],
            [
              -2123.104,
              -6913.08,
              6376.284
            ],
            [
              -2181.307,
              -6890.895,
              6438.572
            ],
            [
              -2240.837,
              -6870.913,
              6501.367
            ],
            [
              -2249.127,
              -6866.313,
              6510.847
            ],
            [
              -2254.703,
              -6853.968,
              6524.393
            ],
            [
              -2247.724,
              -6787.298,
              6591.427
            ],
            [
              -2270.745,
              -6524.168,
              6855.563
            ],
            [
              -2187.789,
              -6494.47,
              6943.675
            ],
            [
              -2141.922,
              -6486.379,
              6990.25
            ],
            [
              -2092.915,
              -6482.797,
              7039.387
            ],
            [
              -1922.838,
              -6479.145,
              7209.504
            ],
            [
              -1864.134,
              -6473.512,
              7268.477
            ],
            [
              -1849.892,
              -6469.313,
              7283.326
            ],
            [
              -1843.998,
              -6463.852,
              7291.36
            ],
            [
              -1844.225,
              -6440.47,
              7314.743
            ],
            [
              -1867.547,
              -6339.863,
              7418.018
            ],
            [
              -1867.259,
              -6287.547,
              7470.335
            ],
            [
              -1893.157,
              -6186.894,
              7574.266
            ],
            [
              -1916.006,
              -6059.579,
              7703.616
            ],
            [
              -1912.3,
              -5996.191,
              7767.112
            ],
            [
              -1895.885,
              -5906.312,
              7858.478
            ],
            [
              -1884.75,
              -5859.754,
              7906.348
            ],
            [
              -1855.289,
              -5796.825,
              7975.832
            ],
            [
              -1807.996,
              -5745.347,
              8045.736
            ],
            [
              -1760.119,
              -5697.219,
              8113.623
            ],
            [
              -1720.968,
              -5668.974,
              8161.898
            ],
            [
              -1679.985,
              -5646.328,
              8208.722
            ],
            [
              -1602.159,
              -5616.549,
              8292.051
            ],
            [
              -1596.889,
              -5609.964,
              8300.485
            ],
            [
              -1589.222,
              -5613.441,
              8308.904
            ],
            [
              -1569.785,
              -5607.109,
              8329.346
            ],
            [
              -1548.277,
              -5593.022,
              8355.056
            ],
            [
              -1320.847,
              -5518.058,
              8594.523
            ],
            [
              -1262.11,
              -5511.32,
              8653.645
            ],
            [
              -1258.186,
              -5508.051,
              8658.752
            ],
            [
              -1256.303,
              -5439.064,
              8727.764
            ],
            [
              -1183.862,
              -5243.323,
              8936.48
            ],
            [
              -1361.885,
              -5184.465,
              9123.98
            ],
            [
              -1387.604,
              -5181.778,
              9149.839
            ],
            [
              -1666.095,
              -5013.148,
              9475.406
            ],
            [
              -1677.043,
              -5012.953,
              9486.355
            ],
            [
              -1696.959,
              -5045.994,
              9524.935
            ],
            [
              -1770.723,
              -5100.339,
              9616.556
            ],
            [
              -1793.54,
              -5115.517,
              9643.96
            ],
            [
              -1840.927,
              -5135.823,
              9695.515
            ],
            [
              -1904.939,
              -5149.154,
              9760.9
            ],
            [
              -2065.02,
              -5167.456,
              9922.024
            ],
            [
              -2110.315,
              -5178.897,
              9968.742
            ],
            [
              -2139.87,
              -5138.296,
              10018.961
            ],
            [
              -2154.069,
              -5103.533,
              10056.511
            ],
            [
              -2263.659,
              -4890.076,
              10296.457
            ],
            [
              -2297.39,
              -4830.477,
              10364.94
            ],
            [
              -2351.324,
              -4783.879,
              10436.215
            ],
            [
              -2381.317,
              -4767.762,
              10470.264
            ],
            [
              -2406.02,
              -4743.947,
              10504.577
            ],
            [
              -2443.585,
              -4718.791,
              10549.787
            ],
            [
              -2496.725,
              -4700.04,
              10606.138
            ],
            [
              -2554.472,
              -4686.774,
              10665.39
            ],
            [
              -2573.291,
              -4730.97,
              10713.426
            ],
            [
              -2592.46,
              -4758.462,
              10746.941
            ],
            [
              -2618.048,
              -4784.728,
              10783.61
            ],
            [
              -2673.576,
              -4828.277,
              10854.178
            ],
            [
              -2687.375,
              -4843.619,
              10874.812
            ],
            [
              -2713.178,
              -4882.126,
              10921.166
            ],
            [
              -2770.874,
              -4975.733,
              11031.125
            ],
            [
              -2803.001,
              -5044.187,
              11106.743
            ],
            [
              -2859.092,
              -5120.012,
              11201.06
            ],
            [
              -3038.848,
              -5415.194,
              11546.668
            ],
            [
              -3072.82,
              -5405.692,
              11581.944
            ],
            [
              -3098.772,
              -5379.632,
              11618.722
            ],
            [
              -3115.924,
              -5365.973,
              11640.649
            ],
            [
              -3137.233,
              -5332.202,
              11680.58
            ],
            [
              -3160.824,
              -5281.693,
              11736.326
            ],
            [
              -3174.738,
              -5266.977,
              11756.578
            ],
            [
              -3209.14,
              -5245.223,
              11797.282
            ],
            [
              -3278.903,
              -5219.51,
              11871.633
            ],
            [
              -3282.025,
              -5213.889,
              11878.062
            ],
            [
              -3283.119,
              -5202.738,
              11889.267
            ],
            [
              -3271.313,
              -5190.699,
              11906.129
            ],
            [
              -3262.297,
              -5190.857,
              11915.145
            ],
            [
              -3249.554,
              -5198.873,
              11930.2
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:1115",
              "position": {
                "x": -995.773,
                "z": -7709.189
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": -600,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:7047",
              "position": {
                "x": -638.969,
                "z": -7631.03
              },
              "distanceAlongShapeM": 453.392,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 60,
              "departureOffsetSeconds": 60
            },
            {
              "stopId": "judu:stop:7968",
              "position": {
                "x": -752.866,
                "z": -7235.995
              },
              "distanceAlongShapeM": 1070.697,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:18018",
              "position": {
                "x": -1047.829,
                "z": -7275.201
              },
              "distanceAlongShapeM": 1375.336,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:9693",
              "position": {
                "x": -1952.594,
                "z": -7317.992
              },
              "distanceAlongShapeM": 2420.836,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:9970",
              "position": {
                "x": -2371.269,
                "z": -7508.706
              },
              "distanceAlongShapeM": 2889.779,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:9496",
              "position": {
                "x": -2768.73,
                "z": -7557.34
              },
              "distanceAlongShapeM": 3308.055,
              "shapeOffsetM": 1.25,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:9815",
              "position": {
                "x": -3037.466,
                "z": -7388.964
              },
              "distanceAlongShapeM": 3718.574,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:15548",
              "position": {
                "x": -2725.784,
                "z": -7568.117
              },
              "distanceAlongShapeM": 4698.416,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:9971",
              "position": {
                "x": -2424.106,
                "z": -7511.11
              },
              "distanceAlongShapeM": 5005.909,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:9694",
              "position": {
                "x": -1983.025,
                "z": -7327.469
              },
              "distanceAlongShapeM": 5492.276,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:17867",
              "position": {
                "x": -2187.789,
                "z": -6494.47
              },
              "distanceAlongShapeM": 6943.675,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:17865",
              "position": {
                "x": -1867.547,
                "z": -6339.863
              },
              "distanceAlongShapeM": 7418.018,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:17862",
              "position": {
                "x": -1855.289,
                "z": -5796.825
              },
              "distanceAlongShapeM": 7975.832,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:17871",
              "position": {
                "x": -1548.277,
                "z": -5593.022
              },
              "distanceAlongShapeM": 8355.056,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:5814",
              "position": {
                "x": -1387.604,
                "z": -5181.778
              },
              "distanceAlongShapeM": 9149.839,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            },
            {
              "stopId": "judu:stop:5811",
              "position": {
                "x": -1696.959,
                "z": -5045.994
              },
              "distanceAlongShapeM": 9524.935,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            },
            {
              "stopId": "judu:stop:6914",
              "position": {
                "x": -2139.87,
                "z": -5138.296
              },
              "distanceAlongShapeM": 10018.961,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1560,
              "departureOffsetSeconds": 1560
            },
            {
              "stopId": "judu:stop:6763",
              "position": {
                "x": -2381.317,
                "z": -4767.762
              },
              "distanceAlongShapeM": 10470.264,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1620,
              "departureOffsetSeconds": 1620
            },
            {
              "stopId": "judu:stop:5519",
              "position": {
                "x": -2803.001,
                "z": -5044.187
              },
              "distanceAlongShapeM": 11106.743,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1740,
              "departureOffsetSeconds": 1740
            },
            {
              "stopId": "judu:stop:795",
              "position": {
                "x": -3249.554,
                "z": -5198.873
              },
              "distanceAlongShapeM": 11930.2,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1980,
              "departureOffsetSeconds": 1980
            }
          ],
          "departuresSeconds": [
            20280,
            23100,
            25200,
            28080,
            30660,
            34980,
            37380,
            40080,
            42540,
            45060,
            47580,
            50100,
            52860,
            55500,
            58140,
            61020,
            63960,
            67980,
            70680,
            73380,
            75780,
            78360,
            80460
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_nightbus_N8",
      "sourceRouteId": "vilnius_nightbus_N8",
      "mode": "bus",
      "shortName": "N8",
      "longName": "Europos aikštė–Centras–Stotis–Naujininkai–Oro uostas",
      "color": "000000",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_nightbus_N8:0",
          "sourceRouteId": "vilnius_nightbus_N8",
          "sourceShapeId": "vilnius_nightbus_N8_a-b",
          "directionId": 0,
          "headsign": "Oro uostas",
          "directionName": "Europos aikštė–Centras–Stotis–Naujininkai–Oro uostas",
          "mode": "bus",
          "routeShortName": "N8",
          "routeLongName": "Europos aikštė–Centras–Stotis–Naujininkai–Oro uostas",
          "routeColor": "000000",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              -144.74,
              -999.893,
              0
            ],
            [
              -111.147,
              -984.562,
              36.926
            ],
            [
              -194.732,
              -865.04,
              182.775
            ],
            [
              -199.062,
              -854.943,
              193.761
            ],
            [
              -193.763,
              -847.246,
              203.106
            ],
            [
              -168.966,
              -830.998,
              232.752
            ],
            [
              -118.847,
              -805.192,
              289.124
            ],
            [
              -80.599,
              -786.281,
              331.792
            ],
            [
              -40.176,
              -770.281,
              375.267
            ],
            [
              224.176,
              -700.119,
              648.771
            ],
            [
              211.01,
              -644.216,
              706.203
            ],
            [
              143.71,
              -480.456,
              883.253
            ],
            [
              126.134,
              -439.133,
              928.159
            ],
            [
              106.146,
              -277.163,
              1091.357
            ],
            [
              46.11,
              -280.522,
              1151.487
            ],
            [
              26.264,
              -279.764,
              1171.347
            ],
            [
              16.623,
              -264.894,
              1189.069
            ],
            [
              14.513,
              -253.218,
              1200.935
            ],
            [
              16.439,
              -245.471,
              1208.918
            ],
            [
              45.916,
              -220.403,
              1247.613
            ],
            [
              103.215,
              -190.277,
              1312.349
            ],
            [
              127.382,
              -102.772,
              1403.13
            ],
            [
              121.848,
              -52.576,
              1453.63
            ],
            [
              118.496,
              -36.512,
              1470.039
            ],
            [
              117.583,
              -3.516,
              1503.048
            ],
            [
              102.671,
              133.684,
              1641.056
            ],
            [
              63.181,
              125.497,
              1681.386
            ],
            [
              59.312,
              125.568,
              1685.256
            ],
            [
              57.419,
              127.829,
              1688.205
            ],
            [
              31.786,
              278.582,
              1841.121
            ],
            [
              4.856,
              358.112,
              1925.087
            ],
            [
              -8.924,
              380.627,
              1951.484
            ],
            [
              -39.768,
              422.378,
              2003.393
            ],
            [
              -46.8,
              425.846,
              2011.234
            ],
            [
              -51.212,
              431.492,
              2018.399
            ],
            [
              -51.307,
              497.175,
              2084.082
            ],
            [
              -54.16,
              522.615,
              2109.681
            ],
            [
              -44.593,
              547.148,
              2136.014
            ],
            [
              -34.25,
              619.32,
              2208.923
            ],
            [
              -34.886,
              726.201,
              2315.806
            ],
            [
              -29.964,
              784,
              2373.814
            ],
            [
              -28.88,
              804.74,
              2394.583
            ],
            [
              -24.076,
              823.969,
              2414.403
            ],
            [
              -6.94,
              914.942,
              2506.975
            ],
            [
              5.94,
              949.218,
              2543.591
            ],
            [
              14.89,
              980.225,
              2575.864
            ],
            [
              20.723,
              1007.284,
              2603.545
            ],
            [
              98.858,
              1127.869,
              2747.232
            ],
            [
              208.532,
              1302.485,
              2953.434
            ],
            [
              265.611,
              1357.493,
              3032.704
            ],
            [
              347.967,
              1416.104,
              3133.787
            ],
            [
              403.761,
              1468.519,
              3210.34
            ],
            [
              407.254,
              1474.663,
              3217.408
            ],
            [
              398.727,
              1481.949,
              3228.624
            ],
            [
              393.766,
              1486.188,
              3235.149
            ],
            [
              391.311,
              1493.238,
              3242.615
            ],
            [
              396.156,
              1548.878,
              3298.465
            ],
            [
              395.449,
              1569.043,
              3318.643
            ],
            [
              392.267,
              1614.738,
              3364.448
            ],
            [
              391.036,
              1654.661,
              3404.39
            ],
            [
              386.324,
              1679.239,
              3429.416
            ],
            [
              339.3,
              1789.195,
              3549.005
            ],
            [
              328.864,
              1818.329,
              3579.952
            ],
            [
              328.986,
              1825.007,
              3586.631
            ],
            [
              341.729,
              1851.491,
              3616.021
            ],
            [
              382.191,
              1911.98,
              3688.795
            ],
            [
              388.24,
              1925.228,
              3703.359
            ],
            [
              387.819,
              1937.481,
              3715.619
            ],
            [
              377.301,
              1962.164,
              3742.45
            ],
            [
              365.148,
              1967.953,
              3755.911
            ],
            [
              365.392,
              1981.307,
              3769.267
            ],
            [
              368.739,
              1987.925,
              3776.684
            ],
            [
              383.296,
              1999.274,
              3795.142
            ],
            [
              393.432,
              1997.493,
              3805.433
            ],
            [
              406.251,
              1992.806,
              3819.082
            ],
            [
              468.163,
              1956.05,
              3891.083
            ],
            [
              473.242,
              1951.504,
              3897.899
            ],
            [
              475.7,
              1944.78,
              3905.058
            ],
            [
              474.81,
              1931.437,
              3918.431
            ],
            [
              481.158,
              1925.755,
              3926.95
            ],
            [
              623.161,
              1858.587,
              4084.038
            ],
            [
              825.163,
              1791.425,
              4296.912
            ],
            [
              862.14,
              1837.501,
              4355.991
            ],
            [
              759.825,
              1942.227,
              4502.401
            ],
            [
              745.862,
              1957.85,
              4523.355
            ],
            [
              722.942,
              1987.005,
              4560.44
            ],
            [
              680.883,
              2015.607,
              4611.303
            ],
            [
              612.97,
              2076.967,
              4702.83
            ],
            [
              575.791,
              2125.517,
              4763.98
            ],
            [
              554.513,
              2161.53,
              4805.81
            ],
            [
              539.42,
              2182.958,
              4832.02
            ],
            [
              519.811,
              2204.469,
              4861.127
            ],
            [
              468.195,
              2239.923,
              4923.746
            ],
            [
              433.065,
              2259.491,
              4963.959
            ],
            [
              407.979,
              2274.133,
              4993.005
            ],
            [
              348.251,
              2314.476,
              5065.081
            ],
            [
              296.511,
              2343.252,
              5124.285
            ],
            [
              241.342,
              2360.957,
              5182.225
            ],
            [
              16.426,
              2411.811,
              5412.819
            ],
            [
              -125.342,
              2457.804,
              5561.861
            ],
            [
              -287.151,
              2501.929,
              5729.578
            ],
            [
              -285.194,
              2584.883,
              5812.556
            ],
            [
              -278.622,
              2616.436,
              5844.786
            ],
            [
              -251.706,
              2819.669,
              6049.793
            ],
            [
              -239.003,
              2950.799,
              6181.537
            ],
            [
              -239.164,
              2977.519,
              6208.258
            ],
            [
              -243.808,
              3023.423,
              6254.396
            ],
            [
              -251.845,
              3073.034,
              6304.654
            ],
            [
              -253.335,
              3121.382,
              6353.025
            ],
            [
              -378.969,
              3774.894,
              7018.503
            ],
            [
              -384.152,
              3809.498,
              7053.493
            ],
            [
              -385.02,
              3832.891,
              7076.902
            ],
            [
              -382.299,
              3876.258,
              7120.355
            ],
            [
              -328.221,
              4117.961,
              7368.033
            ],
            [
              -328.111,
              4136.803,
              7386.876
            ],
            [
              -271.052,
              4387.439,
              7643.925
            ],
            [
              -225.312,
              4631.519,
              7892.253
            ],
            [
              -199.899,
              4822.533,
              8084.95
            ],
            [
              -198.969,
              4859.225,
              8121.655
            ],
            [
              -191.024,
              4884.712,
              8148.351
            ],
            [
              -172.749,
              5038.005,
              8302.729
            ],
            [
              -160.849,
              5053.375,
              8322.168
            ],
            [
              182.36,
              5048.046,
              8665.418
            ],
            [
              184.56,
              5043.71,
              8670.28
            ],
            [
              182.661,
              4953.638,
              8760.372
            ],
            [
              182.349,
              4943.721,
              8770.294
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:17638",
              "position": {
                "x": -42.035,
                "z": -765.399
              },
              "distanceAlongShapeM": 375.267,
              "shapeOffsetM": 5.224,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:5244",
              "position": {
                "x": 121.213,
                "z": -441.083
              },
              "distanceAlongShapeM": 928.159,
              "shapeOffsetM": 5.293,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:5409",
              "position": {
                "x": 115.041,
                "z": -36.866
              },
              "distanceAlongShapeM": 1470.039,
              "shapeOffsetM": 3.473,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:5338",
              "position": {
                "x": -56,
                "z": 522.864
              },
              "distanceAlongShapeM": 2109.681,
              "shapeOffsetM": 1.857,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:5339",
              "position": {
                "x": -31.514,
                "z": 805.179
              },
              "distanceAlongShapeM": 2394.583,
              "shapeOffsetM": 2.671,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:5345",
              "position": {
                "x": 17.976,
                "z": 1008
              },
              "distanceAlongShapeM": 2603.545,
              "shapeOffsetM": 2.839,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:5349",
              "position": {
                "x": 206.575,
                "z": 1304.022
              },
              "distanceAlongShapeM": 2953.434,
              "shapeOffsetM": 2.488,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:5430",
              "position": {
                "x": 392.049,
                "z": 1568.924
              },
              "distanceAlongShapeM": 3318.76,
              "shapeOffsetM": 3.4,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:8262",
              "position": {
                "x": 365.148,
                "z": 1967.953
              },
              "distanceAlongShapeM": 3755.911,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:6005",
              "position": {
                "x": 756.914,
                "z": 1939.625
              },
              "distanceAlongShapeM": 4502.401,
              "shapeOffsetM": 3.904,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:6008",
              "position": {
                "x": 406.177,
                "z": 2271.115
              },
              "distanceAlongShapeM": 4993.005,
              "shapeOffsetM": 3.515,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:5173",
              "position": {
                "x": -290.153,
                "z": 2585.475
              },
              "distanceAlongShapeM": 5812.556,
              "shapeOffsetM": 4.994,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:5175",
              "position": {
                "x": -255.513,
                "z": 3072.44
              },
              "distanceAlongShapeM": 6304.654,
              "shapeOffsetM": 3.716,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:5180",
              "position": {
                "x": -328.523,
                "z": 4136.892
              },
              "distanceAlongShapeM": 7386.876,
              "shapeOffsetM": 0.422,
              "arrivalOffsetSeconds": 1380,
              "departureOffsetSeconds": 1380
            },
            {
              "stopId": "judu:stop:5182",
              "position": {
                "x": -232.492,
                "z": 4591.573
              },
              "distanceAlongShapeM": 7851.668,
              "shapeOffsetM": 0.301,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            },
            {
              "stopId": "judu:stop:8240",
              "position": {
                "x": -199.233,
                "z": 4859.257
              },
              "distanceAlongShapeM": 8121.655,
              "shapeOffsetM": 0.266,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            },
            {
              "stopId": "judu:stop:18375",
              "position": {
                "x": 190.96,
                "z": 4943.45
              },
              "distanceAlongShapeM": 8770.294,
              "shapeOffsetM": 8.615,
              "arrivalOffsetSeconds": 1500,
              "departureOffsetSeconds": 1500
            }
          ],
          "departuresSeconds": [
            86880,
            88860,
            90900,
            92880,
            94920,
            96900,
            101160,
            103140,
            105180,
            107160
          ]
        },
        {
          "id": "judu:pattern:vilnius_nightbus_N8:1",
          "sourceRouteId": "vilnius_nightbus_N8",
          "sourceShapeId": "vilnius_nightbus_N8_b-a",
          "directionId": 1,
          "headsign": "Europos aikštė",
          "directionName": "Oro uostas–Naujininkai–Stotis–Centras–Europos aikštė",
          "mode": "bus",
          "routeShortName": "N8",
          "routeLongName": "Europos aikštė–Centras–Stotis–Naujininkai–Oro uostas",
          "routeColor": "000000",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              182.349,
              4943.721,
              0
            ],
            [
              180.147,
              4916.929,
              26.882
            ],
            [
              171.149,
              4883.696,
              61.312
            ],
            [
              160.096,
              4879.445,
              73.154
            ],
            [
              101.063,
              4899.444,
              135.483
            ],
            [
              60.903,
              4922.533,
              181.807
            ],
            [
              56.975,
              4924.737,
              186.311
            ],
            [
              65.084,
              4944.628,
              207.791
            ],
            [
              70.713,
              4970.13,
              233.907
            ],
            [
              75.861,
              5040.169,
              304.135
            ],
            [
              -161.696,
              5042.258,
              541.701
            ],
            [
              -169.039,
              5035.787,
              551.488
            ],
            [
              -173.264,
              4999.541,
              587.979
            ],
            [
              -176.211,
              4974.653,
              613.042
            ],
            [
              -230.472,
              4551.546,
              1039.614
            ],
            [
              -236.808,
              4531.537,
              1060.602
            ],
            [
              -315.819,
              4161.153,
              1439.32
            ],
            [
              -323.596,
              4115.749,
              1485.385
            ],
            [
              -345.945,
              4030.338,
              1573.672
            ],
            [
              -378.367,
              3879.526,
              1727.929
            ],
            [
              -382.056,
              3853.989,
              1753.731
            ],
            [
              -382.136,
              3813.914,
              1793.806
            ],
            [
              -379.958,
              3791.61,
              1816.216
            ],
            [
              -326.239,
              3550.182,
              2063.549
            ],
            [
              -300.672,
              3393.867,
              2221.941
            ],
            [
              -259.604,
              3167.138,
              2452.359
            ],
            [
              -234.366,
              2993.018,
              2628.299
            ],
            [
              -228.178,
              2946.542,
              2675.184
            ],
            [
              -227.915,
              2951.79,
              2680.439
            ],
            [
              -255.316,
              2762.96,
              2871.246
            ],
            [
              -268.934,
              2604.253,
              3030.537
            ],
            [
              -274.712,
              2582.969,
              3052.591
            ],
            [
              -285.719,
              2509.695,
              3126.687
            ],
            [
              -323.718,
              2371.231,
              3270.271
            ],
            [
              -331.076,
              2356.892,
              3286.387
            ],
            [
              -329.887,
              2351.305,
              3292.099
            ],
            [
              -313.862,
              2345.448,
              3309.161
            ],
            [
              -250.285,
              2328.71,
              3374.904
            ],
            [
              -202.713,
              2318.942,
              3423.469
            ],
            [
              -198.158,
              2321.085,
              3428.503
            ],
            [
              -184.007,
              2318.602,
              3442.87
            ],
            [
              -158.79,
              2321.484,
              3468.251
            ],
            [
              -133.775,
              2313.237,
              3494.591
            ],
            [
              347.135,
              2006.132,
              4065.194
            ],
            [
              358.76,
              2002.659,
              4077.327
            ],
            [
              380.736,
              2008.857,
              4100.16
            ],
            [
              392.929,
              2005.295,
              4112.863
            ],
            [
              440.775,
              1975.476,
              4169.24
            ],
            [
              476.503,
              1958.043,
              4208.994
            ],
            [
              482.271,
              1945.18,
              4223.091
            ],
            [
              477.309,
              1926.939,
              4241.995
            ],
            [
              467.128,
              1919.144,
              4254.818
            ],
            [
              410.21,
              1927.053,
              4312.282
            ],
            [
              405.736,
              1929.361,
              4317.317
            ],
            [
              398.6,
              1927.265,
              4324.754
            ],
            [
              329.489,
              1817.205,
              4454.714
            ],
            [
              330.657,
              1810.504,
              4461.516
            ],
            [
              391.321,
              1670.242,
              4614.334
            ],
            [
              473.433,
              1574.115,
              4740.758
            ],
            [
              482.238,
              1561.708,
              4755.971
            ],
            [
              478.313,
              1549.038,
              4769.235
            ],
            [
              469.529,
              1536.247,
              4784.752
            ],
            [
              453.691,
              1517.701,
              4809.141
            ],
            [
              360.424,
              1427.008,
              4939.233
            ],
            [
              315.899,
              1391.085,
              4996.442
            ],
            [
              256.42,
              1348.755,
              5069.446
            ],
            [
              223.566,
              1315.958,
              5115.869
            ],
            [
              196.476,
              1280.829,
              5160.23
            ],
            [
              149.248,
              1202.651,
              5251.566
            ],
            [
              55.081,
              1061.873,
              5420.935
            ],
            [
              46.275,
              1047.293,
              5437.968
            ],
            [
              35.556,
              1031.037,
              5457.44
            ],
            [
              -5.066,
              911.568,
              5583.626
            ],
            [
              -20.812,
              826.136,
              5670.497
            ],
            [
              -29.409,
              769.885,
              5727.401
            ],
            [
              -32.739,
              739.524,
              5757.944
            ],
            [
              -31.911,
              641.542,
              5855.93
            ],
            [
              -49.15,
              509.381,
              5989.21
            ],
            [
              -49.278,
              431.457,
              6067.134
            ],
            [
              15.61,
              348.039,
              6172.818
            ],
            [
              38.092,
              270.675,
              6253.383
            ],
            [
              60.241,
              141.136,
              6384.801
            ],
            [
              63.955,
              129.761,
              6396.767
            ],
            [
              96.95,
              138.241,
              6430.835
            ],
            [
              106.691,
              127.84,
              6445.085
            ],
            [
              112.53,
              93.98,
              6479.445
            ],
            [
              124.691,
              -38.156,
              6612.139
            ],
            [
              129.098,
              -79.426,
              6653.644
            ],
            [
              129.88,
              -107.271,
              6681.5
            ],
            [
              116.846,
              -256.206,
              6831.004
            ],
            [
              117.887,
              -305.208,
              6880.017
            ],
            [
              127.343,
              -387.845,
              6963.193
            ],
            [
              135.914,
              -423.248,
              6999.619
            ],
            [
              144.816,
              -445.964,
              7024.017
            ],
            [
              174.587,
              -519.993,
              7103.808
            ],
            [
              187.997,
              -562.53,
              7148.409
            ],
            [
              214.213,
              -645.388,
              7235.315
            ],
            [
              223.987,
              -656.808,
              7250.347
            ],
            [
              236.049,
              -695.879,
              7291.237
            ],
            [
              236.925,
              -708.144,
              7303.533
            ],
            [
              229.693,
              -715.805,
              7314.069
            ],
            [
              23.734,
              -765.484,
              7525.934
            ],
            [
              -55.388,
              -799.514,
              7612.065
            ],
            [
              -93.184,
              -812.338,
              7651.976
            ],
            [
              -182.323,
              -856.36,
              7751.393
            ],
            [
              -201.117,
              -861.585,
              7770.9
            ],
            [
              -349.798,
              -953.511,
              7945.704
            ],
            [
              -450.734,
              -1008.456,
              8060.626
            ],
            [
              -402.133,
              -1137.359,
              8198.387
            ],
            [
              -391.115,
              -1134.219,
              8209.843
            ],
            [
              -261.739,
              -1075.338,
              8351.988
            ],
            [
              -135.883,
              -997.471,
              8499.985
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:18375",
              "position": {
                "x": 190.96,
                "z": 4943.45
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 8.615,
              "arrivalOffsetSeconds": -240,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:5184",
              "position": {
                "x": -168.292,
                "z": 4998.962
              },
              "distanceAlongShapeM": 587.979,
              "shapeOffsetM": 5.005,
              "arrivalOffsetSeconds": 60,
              "departureOffsetSeconds": 60
            },
            {
              "stopId": "judu:stop:410",
              "position": {
                "x": -229.992,
                "z": 4551.452
              },
              "distanceAlongShapeM": 1039.614,
              "shapeOffsetM": 0.49,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:5181",
              "position": {
                "x": -323.098,
                "z": 4115.642
              },
              "distanceAlongShapeM": 1485.385,
              "shapeOffsetM": 0.509,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:7414",
              "position": {
                "x": -225.435,
                "z": 2951.666
              },
              "distanceAlongShapeM": 2680.439,
              "shapeOffsetM": 2.483,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:6854",
              "position": {
                "x": -266.588,
                "z": 2603.973
              },
              "distanceAlongShapeM": 3030.537,
              "shapeOffsetM": 2.363,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:5300",
              "position": {
                "x": 479.21,
                "z": 1960.301
              },
              "distanceAlongShapeM": 4208.994,
              "shapeOffsetM": 3.526,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:6834",
              "position": {
                "x": 472.7,
                "z": 1534.052
              },
              "distanceAlongShapeM": 4784.752,
              "shapeOffsetM": 3.857,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:5346",
              "position": {
                "x": 52.802,
                "z": 1042.989
              },
              "distanceAlongShapeM": 5437.968,
              "shapeOffsetM": 7.818,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:5432",
              "position": {
                "x": -26.358,
                "z": 769.462
              },
              "distanceAlongShapeM": 5727.489,
              "shapeOffsetM": 3.079,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            },
            {
              "stopId": "judu:stop:5459",
              "position": {
                "x": 18.234,
                "z": 348.963
              },
              "distanceAlongShapeM": 6172.818,
              "shapeOffsetM": 2.781,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:5492",
              "position": {
                "x": 116.145,
                "z": 94.475
              },
              "distanceAlongShapeM": 6479.445,
              "shapeOffsetM": 3.649,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:5245",
              "position": {
                "x": 150.182,
                "z": -443.837
              },
              "distanceAlongShapeM": 7024.046,
              "shapeOffsetM": 5.773,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:753",
              "position": {
                "x": -53.078,
                "z": -805.275
              },
              "distanceAlongShapeM": 7612.065,
              "shapeOffsetM": 6.207,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            }
          ],
          "departuresSeconds": [
            84600,
            86640,
            88740,
            90720,
            92760,
            94740,
            99000,
            100980,
            103020,
            105000
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_trol_1",
      "sourceRouteId": "vilnius_trol_1",
      "mode": "trolleybus",
      "shortName": "1",
      "longName": "Karoliniškės–Žvėrynas–Stotis",
      "color": "DC3131",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_trol_1:0",
          "sourceRouteId": "vilnius_trol_1",
          "sourceShapeId": "vilnius_trol_1_a-b",
          "directionId": 0,
          "headsign": "Stotis",
          "directionName": "Karoliniškės–Žvėrynas–Stotis",
          "mode": "trolleybus",
          "routeShortName": "1",
          "routeLongName": "Karoliniškės–Žvėrynas–Stotis",
          "routeColor": "DC3131",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              -4635.88,
              552.048,
              0
            ],
            [
              -4631.537,
              534.532,
              18.046
            ],
            [
              -4634.181,
              503.94,
              48.753
            ],
            [
              -4643.152,
              471.614,
              82.3
            ],
            [
              -4646.407,
              443.732,
              110.372
            ],
            [
              -4641.216,
              408.021,
              146.458
            ],
            [
              -4613.144,
              315.143,
              243.486
            ],
            [
              -4593.43,
              261.37,
              300.758
            ],
            [
              -4582.265,
              235.574,
              328.867
            ],
            [
              -4572.392,
              217.886,
              349.124
            ],
            [
              -4568.029,
              200.82,
              366.739
            ],
            [
              -4518.608,
              112.027,
              468.359
            ],
            [
              -4509.454,
              81.813,
              499.929
            ],
            [
              -4478.955,
              17.836,
              570.804
            ],
            [
              -4459.487,
              -12.556,
              606.896
            ],
            [
              -4426.085,
              -57.659,
              663.021
            ],
            [
              -4398.274,
              -90.421,
              705.995
            ],
            [
              -4367.713,
              -113.212,
              744.119
            ],
            [
              -4348.96,
              -128.914,
              768.577
            ],
            [
              -4335.314,
              -141.601,
              787.21
            ],
            [
              -4247.163,
              -227.726,
              910.45
            ],
            [
              -4197.821,
              -283.125,
              984.637
            ],
            [
              -4155.783,
              -350.644,
              1064.173
            ],
            [
              -4081.921,
              -462.729,
              1198.407
            ],
            [
              -4063.365,
              -492.829,
              1233.767
            ],
            [
              -4053.544,
              -508.761,
              1252.483
            ],
            [
              -3962.534,
              -660.121,
              1429.097
            ],
            [
              -3958.061,
              -662.425,
              1434.129
            ],
            [
              -3950.306,
              -661.447,
              1441.945
            ],
            [
              -3806.746,
              -600.485,
              1597.913
            ],
            [
              -3694.685,
              -571.263,
              1713.721
            ],
            [
              -3695.742,
              -557.886,
              1727.14
            ],
            [
              -3728.082,
              -489.418,
              1802.861
            ],
            [
              -3741.232,
              -466.925,
              1828.916
            ],
            [
              -3745.668,
              -462.395,
              1835.256
            ],
            [
              -3755.778,
              -460.516,
              1845.54
            ],
            [
              -3839.114,
              -496.394,
              1936.27
            ],
            [
              -3851.18,
              -510.321,
              1954.697
            ],
            [
              -3857.684,
              -524.093,
              1969.928
            ],
            [
              -3858.854,
              -532.879,
              1978.791
            ],
            [
              -3823.641,
              -607.984,
              2061.741
            ],
            [
              -3766.483,
              -732.543,
              2198.789
            ],
            [
              -3707.64,
              -908.34,
              2384.172
            ],
            [
              -3695.741,
              -928.584,
              2407.654
            ],
            [
              -3679.687,
              -950.175,
              2434.56
            ],
            [
              -3668.232,
              -978.044,
              2464.691
            ],
            [
              -3606.925,
              -1085.98,
              2588.823
            ],
            [
              -3586.062,
              -1109.72,
              2620.428
            ],
            [
              -3575.241,
              -1117.701,
              2633.873
            ],
            [
              -3510.801,
              -1144.012,
              2703.478
            ],
            [
              -3355.367,
              -1190.556,
              2865.731
            ],
            [
              -3109.19,
              -1234.288,
              3115.762
            ],
            [
              -3070.013,
              -1242.306,
              3155.751
            ],
            [
              -2879.155,
              -1277.94,
              3349.907
            ],
            [
              -2839.273,
              -1283.094,
              3390.121
            ],
            [
              -2787.087,
              -1285.125,
              3442.346
            ],
            [
              -2748.376,
              -1283.58,
              3481.088
            ],
            [
              -2714.118,
              -1278.617,
              3515.704
            ],
            [
              -2670.7,
              -1266.023,
              3560.912
            ],
            [
              -2624.585,
              -1246.798,
              3610.873
            ],
            [
              -2499.949,
              -1183.085,
              3750.85
            ],
            [
              -2469.831,
              -1172.717,
              3782.703
            ],
            [
              -2418.716,
              -1162.489,
              3834.831
            ],
            [
              -2392.231,
              -1159.617,
              3861.471
            ],
            [
              -2246.137,
              -1174.448,
              4008.316
            ],
            [
              -2236.291,
              -1164.604,
              4022.239
            ],
            [
              -2207.813,
              -1158.429,
              4051.379
            ],
            [
              -2189.628,
              -1150.959,
              4071.038
            ],
            [
              -2165.314,
              -1131.49,
              4102.187
            ],
            [
              -2151.107,
              -1123.812,
              4118.336
            ],
            [
              -2142.708,
              -1122.847,
              4126.79
            ],
            [
              -2107.347,
              -1112.773,
              4163.558
            ],
            [
              -2052.076,
              -1102.191,
              4219.833
            ],
            [
              -1847.461,
              -1053.546,
              4430.151
            ],
            [
              -1839.367,
              -996.878,
              4487.394
            ],
            [
              -1838.607,
              -973.666,
              4510.618
            ],
            [
              -1831.662,
              -962.505,
              4523.764
            ],
            [
              -1768.396,
              -596.269,
              4895.424
            ],
            [
              -1770.394,
              -575.212,
              4916.576
            ],
            [
              -1761.137,
              -550.756,
              4942.725
            ],
            [
              -1691.384,
              -146.787,
              5352.672
            ],
            [
              -1684.831,
              -90.433,
              5409.406
            ],
            [
              -1682.437,
              -79.04,
              5421.047
            ],
            [
              -1669.697,
              -10.31,
              5490.949
            ],
            [
              -1661.707,
              -1.484,
              5502.854
            ],
            [
              -1388.974,
              -39.407,
              5778.211
            ],
            [
              -1361.685,
              -39.532,
              5805.5
            ],
            [
              -1329.577,
              -37.478,
              5837.674
            ],
            [
              -1190.447,
              -11.028,
              5979.296
            ],
            [
              -1025.306,
              27.195,
              6148.803
            ],
            [
              -994.12,
              39.993,
              6182.512
            ],
            [
              -950.273,
              44.262,
              6226.567
            ],
            [
              -919.958,
              39.772,
              6257.213
            ],
            [
              -857.805,
              53.124,
              6320.783
            ],
            [
              -724.996,
              86.353,
              6457.686
            ],
            [
              -591.62,
              115.115,
              6594.128
            ],
            [
              -557.359,
              122.914,
              6629.266
            ],
            [
              -539.176,
              126.412,
              6647.782
            ],
            [
              -408.498,
              148.538,
              6780.32
            ],
            [
              -385.731,
              159.258,
              6805.485
            ],
            [
              -216.06,
              268.617,
              7007.345
            ],
            [
              -50.385,
              441.496,
              7246.793
            ],
            [
              -51.307,
              497.175,
              7302.48
            ],
            [
              -54.16,
              522.615,
              7328.079
            ],
            [
              -44.593,
              547.148,
              7354.412
            ],
            [
              -34.25,
              619.32,
              7427.321
            ],
            [
              -34.886,
              726.201,
              7534.204
            ],
            [
              -29.964,
              784,
              7592.212
            ],
            [
              -28.88,
              804.74,
              7612.98
            ],
            [
              -24.076,
              823.969,
              7632.8
            ],
            [
              -6.94,
              914.942,
              7725.373
            ],
            [
              5.94,
              949.218,
              7761.989
            ],
            [
              14.89,
              980.225,
              7794.262
            ],
            [
              20.723,
              1007.284,
              7821.943
            ],
            [
              98.858,
              1127.869,
              7965.629
            ],
            [
              208.532,
              1302.485,
              8171.831
            ],
            [
              265.611,
              1357.493,
              8251.102
            ],
            [
              347.967,
              1416.104,
              8352.185
            ],
            [
              403.761,
              1468.519,
              8428.738
            ],
            [
              407.254,
              1474.663,
              8435.806
            ],
            [
              398.727,
              1481.949,
              8447.022
            ],
            [
              393.766,
              1486.188,
              8453.547
            ],
            [
              391.311,
              1493.238,
              8461.013
            ],
            [
              396.156,
              1548.878,
              8516.863
            ],
            [
              395.449,
              1569.043,
              8537.041
            ],
            [
              397.453,
              1582.184,
              8550.333
            ],
            [
              391.321,
              1670.242,
              8638.605
            ],
            [
              327.595,
              1819.466,
              8800.866
            ],
            [
              328.524,
              1835.034,
              8816.462
            ],
            [
              390.297,
              1931.87,
              8931.323
            ],
            [
              384.797,
              1948.669,
              8949
            ],
            [
              364.123,
              1982.443,
              8988.599
            ],
            [
              361.04,
              1990.292,
              8997.032
            ],
            [
              361.142,
              1995.857,
              9002.597
            ],
            [
              367.089,
              2003.541,
              9012.314
            ],
            [
              374.225,
              2005.637,
              9019.751
            ],
            [
              387.77,
              2005.389,
              9033.299
            ],
            [
              447.829,
              1973.12,
              9101.478
            ],
            [
              476.503,
              1958.043,
              9133.874
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:5924",
              "position": {
                "x": -4631.834,
                "z": 503.595
              },
              "distanceAlongShapeM": 48.753,
              "shapeOffsetM": 2.372,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:351",
              "position": {
                "x": -4568.349,
                "z": 219.75
              },
              "distanceAlongShapeM": 349.124,
              "shapeOffsetM": 4.452,
              "arrivalOffsetSeconds": 60,
              "departureOffsetSeconds": 60
            },
            {
              "stopId": "judu:stop:6400",
              "position": {
                "x": -4345.341,
                "z": -124.73
              },
              "distanceAlongShapeM": 768.577,
              "shapeOffsetM": 5.532,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:596",
              "position": {
                "x": -4057.587,
                "z": -489.267
              },
              "distanceAlongShapeM": 1233.767,
              "shapeOffsetM": 6.788,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:6643",
              "position": {
                "x": -3679.35,
                "z": -950.021
              },
              "distanceAlongShapeM": 2434.56,
              "shapeOffsetM": 0.37,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:7416",
              "position": {
                "x": -3108.49,
                "z": -1230.499
              },
              "distanceAlongShapeM": 3115.762,
              "shapeOffsetM": 3.854,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:6430",
              "position": {
                "x": -2107.685,
                "z": -1111.223
              },
              "distanceAlongShapeM": 4163.558,
              "shapeOffsetM": 1.586,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:6433",
              "position": {
                "x": -1839.595,
                "z": -973.496
              },
              "distanceAlongShapeM": 4510.618,
              "shapeOffsetM": 1.002,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            },
            {
              "stopId": "judu:stop:6434",
              "position": {
                "x": -1771.243,
                "z": -575.067
              },
              "distanceAlongShapeM": 4916.576,
              "shapeOffsetM": 0.861,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:6437",
              "position": {
                "x": -1686.504,
                "z": -90.1
              },
              "distanceAlongShapeM": 5409.406,
              "shapeOffsetM": 1.705,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:18852",
              "position": {
                "x": -1457.753,
                "z": -28.505
              },
              "distanceAlongShapeM": 5708.586,
              "shapeOffsetM": 1.326,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:5881",
              "position": {
                "x": -949.475,
                "z": 48.095
              },
              "distanceAlongShapeM": 6226.795,
              "shapeOffsetM": 3.908,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:5332",
              "position": {
                "x": -557.893,
                "z": 125.637
              },
              "distanceAlongShapeM": 6629.266,
              "shapeOffsetM": 2.774,
              "arrivalOffsetSeconds": 1380,
              "departureOffsetSeconds": 1380
            },
            {
              "stopId": "judu:stop:5338",
              "position": {
                "x": -56,
                "z": 522.864
              },
              "distanceAlongShapeM": 7328.079,
              "shapeOffsetM": 1.857,
              "arrivalOffsetSeconds": 1560,
              "departureOffsetSeconds": 1560
            },
            {
              "stopId": "judu:stop:5345",
              "position": {
                "x": 17.976,
                "z": 1008
              },
              "distanceAlongShapeM": 7821.943,
              "shapeOffsetM": 2.839,
              "arrivalOffsetSeconds": 1680,
              "departureOffsetSeconds": 1680
            },
            {
              "stopId": "judu:stop:5349",
              "position": {
                "x": 206.575,
                "z": 1304.022
              },
              "distanceAlongShapeM": 8171.831,
              "shapeOffsetM": 2.488,
              "arrivalOffsetSeconds": 1740,
              "departureOffsetSeconds": 1740
            },
            {
              "stopId": "judu:stop:5430",
              "position": {
                "x": 392.049,
                "z": 1568.924
              },
              "distanceAlongShapeM": 8537.041,
              "shapeOffsetM": 3.402,
              "arrivalOffsetSeconds": 1860,
              "departureOffsetSeconds": 1860
            },
            {
              "stopId": "judu:stop:5300",
              "position": {
                "x": 479.21,
                "z": 1960.301
              },
              "distanceAlongShapeM": 9133.874,
              "shapeOffsetM": 3.526,
              "arrivalOffsetSeconds": 1980,
              "departureOffsetSeconds": 1980
            }
          ],
          "departuresSeconds": [
            19020,
            20340,
            21960,
            23520,
            25200,
            26940,
            28500,
            30300,
            32520,
            35460,
            37440,
            39360,
            40860,
            42360,
            44040,
            45780,
            47340,
            48900,
            50700,
            52200,
            53700,
            55500,
            57300,
            58860,
            60660,
            62640,
            64560,
            67620,
            69660,
            71460,
            73020,
            74580,
            76140,
            77700,
            79260,
            80700,
            82140
          ]
        },
        {
          "id": "judu:pattern:vilnius_trol_1:1",
          "sourceRouteId": "vilnius_trol_1",
          "sourceShapeId": "vilnius_trol_1_b-a",
          "directionId": 1,
          "headsign": "Karoliniškės",
          "directionName": "Stotis–Žvėrynas–Karoliniškės",
          "mode": "trolleybus",
          "routeShortName": "1",
          "routeLongName": "Karoliniškės–Žvėrynas–Stotis",
          "routeColor": "DC3131",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              476.503,
              1958.043,
              0
            ],
            [
              482.271,
              1945.18,
              14.097
            ],
            [
              477.309,
              1926.939,
              33.001
            ],
            [
              467.128,
              1919.144,
              45.824
            ],
            [
              410.21,
              1927.053,
              103.288
            ],
            [
              405.736,
              1929.361,
              108.323
            ],
            [
              398.6,
              1927.265,
              115.76
            ],
            [
              329.489,
              1817.205,
              245.72
            ],
            [
              330.657,
              1810.504,
              252.522
            ],
            [
              391.321,
              1670.242,
              405.34
            ],
            [
              473.433,
              1574.115,
              531.763
            ],
            [
              482.238,
              1561.708,
              546.977
            ],
            [
              478.313,
              1549.038,
              560.241
            ],
            [
              469.529,
              1536.247,
              575.758
            ],
            [
              453.691,
              1517.701,
              600.147
            ],
            [
              360.424,
              1427.008,
              730.239
            ],
            [
              315.899,
              1391.085,
              787.448
            ],
            [
              256.42,
              1348.755,
              860.452
            ],
            [
              223.566,
              1315.958,
              906.875
            ],
            [
              196.476,
              1280.829,
              951.236
            ],
            [
              149.248,
              1202.651,
              1042.572
            ],
            [
              55.081,
              1061.873,
              1211.941
            ],
            [
              46.275,
              1047.293,
              1228.974
            ],
            [
              39.094,
              1036.402,
              1242.019
            ],
            [
              29.447,
              1013.439,
              1266.926
            ],
            [
              17.226,
              966.824,
              1315.117
            ],
            [
              -2.949,
              921.549,
              1364.683
            ],
            [
              -20.393,
              826.162,
              1461.653
            ],
            [
              -29.409,
              769.885,
              1518.647
            ],
            [
              -34.886,
              726.201,
              1562.673
            ],
            [
              -34.25,
              619.32,
              1669.556
            ],
            [
              -49.15,
              509.381,
              1780.5
            ],
            [
              -50.587,
              430.368,
              1859.526
            ],
            [
              -55.202,
              424.885,
              1866.693
            ],
            [
              -86.677,
              396.514,
              1909.067
            ],
            [
              -98.36,
              381.073,
              1928.43
            ],
            [
              -191.298,
              289.447,
              2058.94
            ],
            [
              -216.06,
              268.617,
              2091.298
            ],
            [
              -386.375,
              159.27,
              2293.693
            ],
            [
              -408.498,
              148.538,
              2318.282
            ],
            [
              -583.944,
              111.636,
              2497.567
            ],
            [
              -658.953,
              100.746,
              2573.362
            ],
            [
              -724.996,
              86.353,
              2640.955
            ],
            [
              -736.71,
              77.277,
              2655.774
            ],
            [
              -743.833,
              78.9,
              2663.08
            ],
            [
              -798.875,
              66.534,
              2719.494
            ],
            [
              -863.023,
              49.879,
              2785.769
            ],
            [
              -871.015,
              45.142,
              2795.059
            ],
            [
              -877.911,
              46.807,
              2802.154
            ],
            [
              -930.978,
              36.63,
              2856.188
            ],
            [
              -998.108,
              33.385,
              2923.396
            ],
            [
              -1226.73,
              -20.397,
              3158.259
            ],
            [
              -1327.722,
              -41.964,
              3261.528
            ],
            [
              -1378.216,
              -54.917,
              3313.657
            ],
            [
              -1437.414,
              -46.326,
              3373.475
            ],
            [
              -1471.431,
              -36.053,
              3409.009
            ],
            [
              -1661.707,
              -1.484,
              3602.4
            ],
            [
              -1691.384,
              -146.787,
              3750.703
            ],
            [
              -1712.987,
              -273.309,
              3879.056
            ],
            [
              -1713.492,
              -281.762,
              3887.524
            ],
            [
              -1719.483,
              -312.156,
              3918.503
            ],
            [
              -1768.396,
              -596.269,
              4206.796
            ],
            [
              -1772.222,
              -628.201,
              4238.956
            ],
            [
              -1778.412,
              -651.752,
              4263.307
            ],
            [
              -1847.461,
              -1053.546,
              4670.99
            ],
            [
              -1903.255,
              -1072.553,
              4729.933
            ],
            [
              -1912.525,
              -1075.817,
              4739.762
            ],
            [
              -1954.393,
              -1083.889,
              4782.4
            ],
            [
              -2142.708,
              -1122.847,
              4974.703
            ],
            [
              -2154.408,
              -1128.206,
              4987.572
            ],
            [
              -2189.935,
              -1158.368,
              5034.176
            ],
            [
              -2202.233,
              -1162.567,
              5047.171
            ],
            [
              -2218.205,
              -1162.698,
              5063.143
            ],
            [
              -2227.932,
              -1165.865,
              5073.373
            ],
            [
              -2246.137,
              -1174.448,
              5093.5
            ],
            [
              -2255.397,
              -1187.643,
              5109.62
            ],
            [
              -2266.36,
              -1186.843,
              5120.612
            ],
            [
              -2295.924,
              -1182.472,
              5150.497
            ],
            [
              -2392.506,
              -1175.197,
              5247.353
            ],
            [
              -2431.277,
              -1180.078,
              5286.43
            ],
            [
              -2478.584,
              -1193.714,
              5335.663
            ],
            [
              -2533.196,
              -1219.467,
              5396.043
            ],
            [
              -2617.204,
              -1266.966,
              5492.549
            ],
            [
              -2663.944,
              -1285.067,
              5542.672
            ],
            [
              -2710.565,
              -1296.491,
              5590.672
            ],
            [
              -2762.381,
              -1304.469,
              5643.099
            ],
            [
              -2806.189,
              -1305.331,
              5686.915
            ],
            [
              -2858.757,
              -1300.914,
              5739.668
            ],
            [
              -3085.169,
              -1260.965,
              5969.578
            ],
            [
              -3139.719,
              -1251.188,
              6024.997
            ],
            [
              -3159.719,
              -1247.413,
              6045.35
            ],
            [
              -3359.526,
              -1207.182,
              6249.167
            ],
            [
              -3495.953,
              -1192.555,
              6386.376
            ],
            [
              -3569.469,
              -1193.5,
              6459.898
            ],
            [
              -3626.266,
              -1196.964,
              6516.8
            ],
            [
              -3657.704,
              -1114.039,
              6605.485
            ],
            [
              -3677.364,
              -1066.903,
              6656.557
            ],
            [
              -3685.368,
              -1042.059,
              6682.658
            ],
            [
              -3720.918,
              -930.373,
              6799.865
            ],
            [
              -3751.424,
              -837.404,
              6897.711
            ],
            [
              -3758.325,
              -817.25,
              6919.014
            ],
            [
              -3766.218,
              -791.548,
              6945.901
            ],
            [
              -3793.988,
              -719.82,
              7022.817
            ],
            [
              -3843.779,
              -616.54,
              7137.472
            ],
            [
              -3881.258,
              -546.871,
              7216.583
            ],
            [
              -3892.746,
              -539.992,
              7229.973
            ],
            [
              -3915.211,
              -534.036,
              7253.214
            ],
            [
              -4013.321,
              -576.864,
              7360.264
            ],
            [
              -4103.192,
              -441.723,
              7522.56
            ],
            [
              -4120.29,
              -416.592,
              7552.956
            ],
            [
              -4130.843,
              -399.669,
              7572.9
            ],
            [
              -4155.783,
              -350.644,
              7627.904
            ],
            [
              -4237.762,
              -243.473,
              7762.834
            ],
            [
              -4351.477,
              -138.439,
              7917.635
            ],
            [
              -4426.18,
              -63.224,
              8023.643
            ],
            [
              -4445.371,
              -41.623,
              8052.538
            ],
            [
              -4460.208,
              -16.996,
              8081.289
            ],
            [
              -4494.728,
              38.145,
              8146.344
            ],
            [
              -4529.153,
              107.182,
              8223.489
            ],
            [
              -4592.389,
              246.88,
              8376.832
            ],
            [
              -4602.309,
              268.218,
              8400.363
            ],
            [
              -4641.216,
              408.021,
              8545.479
            ],
            [
              -4659.752,
              487.017,
              8626.621
            ],
            [
              -4661.513,
              502.991,
              8642.691
            ],
            [
              -4670.535,
              540.995,
              8681.752
            ],
            [
              -4686.12,
              572.432,
              8716.84
            ],
            [
              -4701.876,
              593.853,
              8743.431
            ],
            [
              -4704.928,
              603.925,
              8753.956
            ],
            [
              -4700.939,
              612.618,
              8763.52
            ],
            [
              -4692.51,
              618.683,
              8773.904
            ],
            [
              -4676.757,
              618.614,
              8789.657
            ],
            [
              -4666.006,
              610.655,
              8803.034
            ],
            [
              -4635.88,
              552.048,
              8868.931
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:5300",
              "position": {
                "x": 479.21,
                "z": 1960.301
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 3.526,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:6834",
              "position": {
                "x": 472.7,
                "z": 1534.052
              },
              "distanceAlongShapeM": 575.758,
              "shapeOffsetM": 3.857,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:5346",
              "position": {
                "x": 52.802,
                "z": 1042.989
              },
              "distanceAlongShapeM": 1228.974,
              "shapeOffsetM": 7.818,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:5432",
              "position": {
                "x": -26.358,
                "z": 769.462
              },
              "distanceAlongShapeM": 1518.582,
              "shapeOffsetM": 3.079,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:5334",
              "position": {
                "x": -97.297,
                "z": 380.009
              },
              "distanceAlongShapeM": 1928.43,
              "shapeOffsetM": 1.504,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:5936",
              "position": {
                "x": -736.157,
                "z": 75.422
              },
              "distanceAlongShapeM": 2655.774,
              "shapeOffsetM": 1.935,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:19193",
              "position": {
                "x": -870.86,
                "z": 44.454
              },
              "distanceAlongShapeM": 2795.059,
              "shapeOffsetM": 0.705,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:6438",
              "position": {
                "x": -1438.145,
                "z": -50.007
              },
              "distanceAlongShapeM": 3373.475,
              "shapeOffsetM": 3.753,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:6436",
              "position": {
                "x": -1710.567,
                "z": -282.258
              },
              "distanceAlongShapeM": 3887.524,
              "shapeOffsetM": 2.967,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:6435",
              "position": {
                "x": -1770.261,
                "z": -628.519
              },
              "distanceAlongShapeM": 4238.956,
              "shapeOffsetM": 1.987,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:6432",
              "position": {
                "x": -1911.753,
                "z": -1079.081
              },
              "distanceAlongShapeM": 4739.762,
              "shapeOffsetM": 3.354,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:7415",
              "position": {
                "x": -3140.52,
                "z": -1255.542
              },
              "distanceAlongShapeM": 6024.997,
              "shapeOffsetM": 4.427,
              "arrivalOffsetSeconds": 1380,
              "departureOffsetSeconds": 1380
            },
            {
              "stopId": "judu:stop:5643",
              "position": {
                "x": -3680.758,
                "z": -1067.996
              },
              "distanceAlongShapeM": 6656.557,
              "shapeOffsetM": 3.566,
              "arrivalOffsetSeconds": 1560,
              "departureOffsetSeconds": 1560
            },
            {
              "stopId": "judu:stop:5646",
              "position": {
                "x": -3761.526,
                "z": -818.346
              },
              "distanceAlongShapeM": 6919.014,
              "shapeOffsetM": 3.383,
              "arrivalOffsetSeconds": 1620,
              "departureOffsetSeconds": 1620
            },
            {
              "stopId": "judu:stop:5915",
              "position": {
                "x": -4126.033,
                "z": -420.177
              },
              "distanceAlongShapeM": 7552.956,
              "shapeOffsetM": 6.77,
              "arrivalOffsetSeconds": 1740,
              "departureOffsetSeconds": 1740
            },
            {
              "stopId": "judu:stop:5919",
              "position": {
                "x": -4449.727,
                "z": -45.007
              },
              "distanceAlongShapeM": 8052.538,
              "shapeOffsetM": 5.516,
              "arrivalOffsetSeconds": 1860,
              "departureOffsetSeconds": 1860
            },
            {
              "stopId": "judu:stop:5920",
              "position": {
                "x": -4608.183,
                "z": 266.076
              },
              "distanceAlongShapeM": 8400.363,
              "shapeOffsetM": 6.252,
              "arrivalOffsetSeconds": 1920,
              "departureOffsetSeconds": 1920
            },
            {
              "stopId": "judu:stop:5923",
              "position": {
                "x": -4663.089,
                "z": 486.32
              },
              "distanceAlongShapeM": 8626.621,
              "shapeOffsetM": 3.409,
              "arrivalOffsetSeconds": 1980,
              "departureOffsetSeconds": 1980
            }
          ],
          "departuresSeconds": [
            21000,
            22320,
            23940,
            25500,
            27300,
            29100,
            30660,
            32400,
            34620,
            37560,
            39480,
            41400,
            42960,
            44460,
            46140,
            47880,
            49440,
            51000,
            52860,
            54360,
            55860,
            57660,
            59460,
            60960,
            62760,
            64740,
            66660,
            69660,
            71700,
            73500,
            75060,
            76560,
            78120,
            79680,
            81180,
            82620
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_trol_2",
      "sourceRouteId": "vilnius_trol_2",
      "mode": "trolleybus",
      "shortName": "2",
      "longName": "Saulėtekis–Žygimantų g.–Stotis",
      "color": "DC3131",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_trol_2:0",
          "sourceRouteId": "vilnius_trol_2",
          "sourceShapeId": "vilnius_trol_2_a-b",
          "directionId": 0,
          "headsign": "Stotis",
          "directionName": "Saulėtekis–Žygimantų g.–Stotis",
          "mode": "trolleybus",
          "routeShortName": "2",
          "routeLongName": "Saulėtekis–Žygimantų g.–Stotis",
          "routeColor": "DC3131",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              3954.003,
              -4105.097,
              0
            ],
            [
              3949.52,
              -4094.868,
              11.169
            ],
            [
              3943.333,
              -4069.038,
              37.729
            ],
            [
              3940.538,
              -4057,
              50.087
            ],
            [
              3918.536,
              -4045.003,
              75.147
            ],
            [
              3899.276,
              -4037.251,
              95.909
            ],
            [
              3898.616,
              -4036.13,
              97.209
            ],
            [
              3858.828,
              -4027.577,
              137.906
            ],
            [
              3592.048,
              -4028.061,
              404.687
            ],
            [
              3581.678,
              -4031.203,
              415.522
            ],
            [
              3564.996,
              -4038.354,
              433.672
            ],
            [
              3520.083,
              -4051.184,
              480.382
            ],
            [
              3445.458,
              -4078.711,
              559.922
            ],
            [
              3358.965,
              -4120.486,
              655.975
            ],
            [
              3358.852,
              -4122.75,
              658.242
            ],
            [
              3310.064,
              -4150.73,
              714.484
            ],
            [
              3021.059,
              -4338.966,
              1059.385
            ],
            [
              2959.695,
              -4278.804,
              1145.321
            ],
            [
              2940.311,
              -4262.522,
              1170.635
            ],
            [
              2920.517,
              -4237.987,
              1202.16
            ],
            [
              2810.169,
              -4110.107,
              1371.068
            ],
            [
              2739.116,
              -4050.879,
              1463.569
            ],
            [
              2661.391,
              -4003.772,
              1554.455
            ],
            [
              2637.654,
              -3993.387,
              1580.365
            ],
            [
              2619.338,
              -3978.489,
              1603.974
            ],
            [
              2604.004,
              -3971.521,
              1620.817
            ],
            [
              2521.22,
              -3923.064,
              1716.74
            ],
            [
              2506.601,
              -3911.447,
              1735.414
            ],
            [
              2490.099,
              -3890.638,
              1761.971
            ],
            [
              2480.459,
              -3864.316,
              1790.003
            ],
            [
              2475.702,
              -3831.185,
              1823.474
            ],
            [
              2503.004,
              -3722.48,
              1935.555
            ],
            [
              2508.663,
              -3661.358,
              1996.939
            ],
            [
              2467.501,
              -3518.217,
              2145.881
            ],
            [
              2463.864,
              -3499.82,
              2164.633
            ],
            [
              2434.339,
              -3309.248,
              2357.479
            ],
            [
              2430.841,
              -3283.862,
              2383.105
            ],
            [
              2426.976,
              -3256.769,
              2410.472
            ],
            [
              2328.687,
              -2639.354,
              3035.662
            ],
            [
              2308.053,
              -2536.548,
              3140.518
            ],
            [
              2300.116,
              -2511.178,
              3167.101
            ],
            [
              2295.002,
              -2476.188,
              3202.462
            ],
            [
              2274.24,
              -2414.57,
              3267.484
            ],
            [
              2234.812,
              -2316.979,
              3372.739
            ],
            [
              2177.257,
              -2188.992,
              3513.072
            ],
            [
              2082.177,
              -1964.565,
              3756.809
            ],
            [
              2063.994,
              -1895.874,
              3827.865
            ],
            [
              2052.283,
              -1842.34,
              3882.665
            ],
            [
              2048.593,
              -1825.761,
              3899.65
            ],
            [
              2041.617,
              -1789.027,
              3937.041
            ],
            [
              1994.191,
              -1532.095,
              4198.313
            ],
            [
              1989.006,
              -1510.962,
              4220.072
            ],
            [
              1983.619,
              -1477.347,
              4254.117
            ],
            [
              1966.491,
              -1323.401,
              4409.013
            ],
            [
              1951.301,
              -996.936,
              4735.831
            ],
            [
              1944.999,
              -954.515,
              4778.717
            ],
            [
              1926.174,
              -912.972,
              4824.327
            ],
            [
              1921.538,
              -904.629,
              4833.872
            ],
            [
              1905.301,
              -870.282,
              4871.863
            ],
            [
              1842.792,
              -798.983,
              4966.683
            ],
            [
              1722.529,
              -643.118,
              5163.551
            ],
            [
              1706.703,
              -627.239,
              5185.97
            ],
            [
              1656.515,
              -617.512,
              5237.092
            ],
            [
              1647.146,
              -604.98,
              5252.739
            ],
            [
              1647.435,
              -589.4,
              5268.322
            ],
            [
              1641.361,
              -569.249,
              5289.369
            ],
            [
              1626.241,
              -550.043,
              5313.812
            ],
            [
              1613.941,
              -537.088,
              5331.676
            ],
            [
              1227.773,
              -233.181,
              5823.088
            ],
            [
              1061.875,
              -125.757,
              6020.729
            ],
            [
              1042.305,
              -113.981,
              6043.569
            ],
            [
              992.552,
              -84.12,
              6101.595
            ],
            [
              920.398,
              -44.941,
              6183.7
            ],
            [
              895.357,
              -38.914,
              6209.456
            ],
            [
              797.689,
              -19.306,
              6309.073
            ],
            [
              670.384,
              1.958,
              6438.141
            ],
            [
              652.936,
              0.051,
              6455.693
            ],
            [
              630.873,
              -7.336,
              6478.96
            ],
            [
              602.561,
              -27.877,
              6513.939
            ],
            [
              564.962,
              -49.544,
              6557.334
            ],
            [
              476.44,
              -129.188,
              6676.411
            ],
            [
              402.286,
              -199.078,
              6778.31
            ],
            [
              346.776,
              -237.026,
              6845.551
            ],
            [
              281.176,
              -262.545,
              6915.94
            ],
            [
              119.684,
              -277.409,
              7078.115
            ],
            [
              35.151,
              -280.322,
              7162.698
            ],
            [
              26.264,
              -279.764,
              7171.602
            ],
            [
              16.623,
              -264.894,
              7189.324
            ],
            [
              14.513,
              -253.218,
              7201.19
            ],
            [
              16.439,
              -245.471,
              7209.172
            ],
            [
              25.627,
              -236.732,
              7221.853
            ],
            [
              45.916,
              -220.403,
              7247.896
            ],
            [
              103.215,
              -190.277,
              7312.632
            ],
            [
              127.382,
              -102.772,
              7403.413
            ],
            [
              121.848,
              -52.576,
              7453.913
            ],
            [
              118.496,
              -36.512,
              7470.323
            ],
            [
              117.583,
              -3.516,
              7503.332
            ],
            [
              102.671,
              133.684,
              7641.34
            ],
            [
              63.181,
              125.497,
              7681.67
            ],
            [
              59.312,
              125.568,
              7685.539
            ],
            [
              57.419,
              127.829,
              7688.488
            ],
            [
              31.786,
              278.582,
              7841.405
            ],
            [
              4.856,
              358.112,
              7925.371
            ],
            [
              -8.924,
              380.627,
              7951.768
            ],
            [
              -39.768,
              422.378,
              8003.677
            ],
            [
              -46.8,
              425.846,
              8011.517
            ],
            [
              -51.212,
              431.492,
              8018.683
            ],
            [
              -51.307,
              497.175,
              8084.366
            ],
            [
              -54.16,
              522.615,
              8109.965
            ],
            [
              -44.593,
              547.148,
              8136.297
            ],
            [
              -34.25,
              619.32,
              8209.207
            ],
            [
              -34.886,
              726.201,
              8316.09
            ],
            [
              -29.964,
              784,
              8374.098
            ],
            [
              -28.88,
              804.74,
              8394.866
            ],
            [
              -24.076,
              823.969,
              8414.686
            ],
            [
              -6.94,
              914.942,
              8507.259
            ],
            [
              5.94,
              949.218,
              8543.875
            ],
            [
              14.89,
              980.225,
              8576.148
            ],
            [
              20.723,
              1007.284,
              8603.829
            ],
            [
              98.858,
              1127.869,
              8747.515
            ],
            [
              208.532,
              1302.485,
              8953.717
            ],
            [
              265.611,
              1357.493,
              9032.988
            ],
            [
              347.967,
              1416.104,
              9134.071
            ],
            [
              403.761,
              1468.519,
              9210.623
            ],
            [
              407.254,
              1474.663,
              9217.691
            ],
            [
              398.727,
              1481.949,
              9228.908
            ],
            [
              393.766,
              1486.188,
              9235.433
            ],
            [
              391.311,
              1493.238,
              9242.898
            ],
            [
              396.156,
              1548.878,
              9298.749
            ],
            [
              395.449,
              1569.043,
              9318.926
            ],
            [
              397.453,
              1582.184,
              9332.219
            ],
            [
              391.321,
              1670.242,
              9420.49
            ],
            [
              330.657,
              1810.504,
              9573.309
            ],
            [
              327.072,
              1826.155,
              9589.366
            ],
            [
              328.524,
              1835.034,
              9598.362
            ],
            [
              390.297,
              1931.87,
              9713.224
            ],
            [
              384.797,
              1948.669,
              9730.9
            ],
            [
              364.123,
              1982.443,
              9770.499
            ],
            [
              361.04,
              1990.292,
              9778.932
            ],
            [
              363.158,
              2000.273,
              9789.135
            ],
            [
              374.225,
              2005.637,
              9801.434
            ],
            [
              387.77,
              2005.389,
              9814.981
            ],
            [
              447.829,
              1973.12,
              9883.16
            ],
            [
              476.503,
              1958.043,
              9915.556
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:6239",
              "position": {
                "x": 3898.552,
                "z": -4039.468
              },
              "distanceAlongShapeM": 95.752,
              "shapeOffsetM": 2.327,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:5116",
              "position": {
                "x": 3565.986,
                "z": -4043.151
              },
              "distanceAlongShapeM": 434.038,
              "shapeOffsetM": 4.885,
              "arrivalOffsetSeconds": 60,
              "departureOffsetSeconds": 60
            },
            {
              "stopId": "judu:stop:6715",
              "position": {
                "x": 3360.169,
                "z": -4124.962
              },
              "distanceAlongShapeM": 658.242,
              "shapeOffsetM": 2.574,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:5103",
              "position": {
                "x": 2937.404,
                "z": -4265.024
              },
              "distanceAlongShapeM": 1170.635,
              "shapeOffsetM": 3.836,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:5117",
              "position": {
                "x": 2636.416,
                "z": -3995.509
              },
              "distanceAlongShapeM": 1580.365,
              "shapeOffsetM": 2.457,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:5118",
              "position": {
                "x": 2463.001,
                "z": -3519.117
              },
              "distanceAlongShapeM": 2145.881,
              "shapeOffsetM": 4.589,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:5119",
              "position": {
                "x": 2425.512,
                "z": -3284.63
              },
              "distanceAlongShapeM": 2383.072,
              "shapeOffsetM": 5.384,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:5096",
              "position": {
                "x": 2296.913,
                "z": -2511.848
              },
              "distanceAlongShapeM": 3167.101,
              "shapeOffsetM": 3.272,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:5818",
              "position": {
                "x": 2043.488,
                "z": -1826.913
              },
              "distanceAlongShapeM": 3899.635,
              "shapeOffsetM": 5.233,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:5819",
              "position": {
                "x": 1983.608,
                "z": -1511.859
              },
              "distanceAlongShapeM": 4220.072,
              "shapeOffsetM": 5.471,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            },
            {
              "stopId": "judu:stop:5820",
              "position": {
                "x": 1921.875,
                "z": -915.121
              },
              "distanceAlongShapeM": 4824.536,
              "shapeOffsetM": 4.802,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:5768",
              "position": {
                "x": 1608.96,
                "z": -543.043
              },
              "distanceAlongShapeM": 5330.787,
              "shapeOffsetM": 7.713,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:5771",
              "position": {
                "x": 1060.09,
                "z": -128.781
              },
              "distanceAlongShapeM": 6020.583,
              "shapeOffsetM": 3.508,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:848",
              "position": {
                "x": 604.636,
                "z": -31.346
              },
              "distanceAlongShapeM": 6513.939,
              "shapeOffsetM": 4.042,
              "arrivalOffsetSeconds": 1380,
              "departureOffsetSeconds": 1380
            },
            {
              "stopId": "judu:stop:5409",
              "position": {
                "x": 115.041,
                "z": -36.866
              },
              "distanceAlongShapeM": 7470.323,
              "shapeOffsetM": 3.473,
              "arrivalOffsetSeconds": 1620,
              "departureOffsetSeconds": 1620
            },
            {
              "stopId": "judu:stop:5338",
              "position": {
                "x": -56,
                "z": 522.864
              },
              "distanceAlongShapeM": 8109.965,
              "shapeOffsetM": 1.857,
              "arrivalOffsetSeconds": 1800,
              "departureOffsetSeconds": 1800
            },
            {
              "stopId": "judu:stop:5345",
              "position": {
                "x": 17.976,
                "z": 1008
              },
              "distanceAlongShapeM": 8603.829,
              "shapeOffsetM": 2.839,
              "arrivalOffsetSeconds": 1920,
              "departureOffsetSeconds": 1920
            },
            {
              "stopId": "judu:stop:5349",
              "position": {
                "x": 206.575,
                "z": 1304.022
              },
              "distanceAlongShapeM": 8953.717,
              "shapeOffsetM": 2.488,
              "arrivalOffsetSeconds": 2040,
              "departureOffsetSeconds": 2040
            },
            {
              "stopId": "judu:stop:5430",
              "position": {
                "x": 392.049,
                "z": 1568.924
              },
              "distanceAlongShapeM": 9318.926,
              "shapeOffsetM": 3.402,
              "arrivalOffsetSeconds": 2160,
              "departureOffsetSeconds": 2160
            },
            {
              "stopId": "judu:stop:5300",
              "position": {
                "x": 479.21,
                "z": 1960.301
              },
              "distanceAlongShapeM": 9915.556,
              "shapeOffsetM": 3.526,
              "arrivalOffsetSeconds": 2280,
              "departureOffsetSeconds": 2280
            }
          ],
          "departuresSeconds": [
            18840,
            19680,
            20280,
            20760,
            21480,
            22080,
            22560,
            22920,
            23340,
            23700,
            24060,
            24480,
            24900,
            25320,
            25680,
            26100,
            26520,
            26940,
            27420,
            27900,
            28320,
            28800,
            29160,
            29640,
            30120,
            30900,
            31620,
            32400,
            33240,
            33840,
            34500,
            35040,
            35580,
            36180,
            36960,
            37740,
            38640,
            39360,
            40080,
            40740,
            41340,
            41940,
            42540,
            43200,
            43920,
            44640,
            45300,
            46020,
            46620,
            47280,
            47880,
            48480,
            49200,
            49920,
            50580,
            51240,
            51840,
            52200,
            52680,
            53100,
            53520,
            53940,
            54360,
            54780,
            55200,
            55620,
            56040,
            56400,
            56880,
            57360,
            57840,
            58320,
            58740,
            59160,
            59640,
            60060,
            60480,
            60900,
            61320,
            61740,
            62160,
            62640,
            63120,
            63600,
            64080,
            64500,
            64920,
            65400,
            66000,
            66780,
            67500,
            68280,
            69000,
            69720,
            70320,
            70920,
            71580,
            72180,
            72900,
            73620,
            74280,
            74880,
            75600,
            76200,
            76800,
            77400,
            78240,
            79080,
            79920,
            81060,
            82200,
            83400
          ]
        },
        {
          "id": "judu:pattern:vilnius_trol_2:1",
          "sourceRouteId": "vilnius_trol_2",
          "sourceShapeId": "vilnius_trol_2_b-a",
          "directionId": 1,
          "headsign": "Saulėtekis",
          "directionName": "Stotis–Žygimantų g.–Saulėtekis",
          "mode": "trolleybus",
          "routeShortName": "2",
          "routeLongName": "Saulėtekis–Žygimantų g.–Stotis",
          "routeColor": "DC3131",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              476.503,
              1958.043,
              0
            ],
            [
              482.271,
              1945.18,
              14.097
            ],
            [
              477.309,
              1926.939,
              33.001
            ],
            [
              467.128,
              1919.144,
              45.824
            ],
            [
              410.21,
              1927.053,
              103.288
            ],
            [
              405.736,
              1929.361,
              108.323
            ],
            [
              398.6,
              1927.265,
              115.76
            ],
            [
              329.489,
              1817.205,
              245.72
            ],
            [
              330.657,
              1810.504,
              252.522
            ],
            [
              391.321,
              1670.242,
              405.34
            ],
            [
              473.433,
              1574.115,
              531.763
            ],
            [
              482.238,
              1561.708,
              546.977
            ],
            [
              478.313,
              1549.038,
              560.241
            ],
            [
              469.529,
              1536.247,
              575.758
            ],
            [
              453.691,
              1517.701,
              600.147
            ],
            [
              360.424,
              1427.008,
              730.239
            ],
            [
              315.899,
              1391.085,
              787.448
            ],
            [
              256.42,
              1348.755,
              860.452
            ],
            [
              223.566,
              1315.958,
              906.875
            ],
            [
              196.476,
              1280.829,
              951.236
            ],
            [
              149.248,
              1202.651,
              1042.572
            ],
            [
              55.081,
              1061.873,
              1211.941
            ],
            [
              46.275,
              1047.293,
              1228.974
            ],
            [
              39.094,
              1036.402,
              1242.019
            ],
            [
              29.447,
              1013.439,
              1266.926
            ],
            [
              17.226,
              966.824,
              1315.117
            ],
            [
              -2.949,
              921.549,
              1364.683
            ],
            [
              -20.393,
              826.162,
              1461.653
            ],
            [
              -29.409,
              769.885,
              1518.647
            ],
            [
              -34.886,
              726.201,
              1562.673
            ],
            [
              -34.25,
              619.32,
              1669.556
            ],
            [
              -49.15,
              509.381,
              1780.5
            ],
            [
              -51.111,
              437.057,
              1852.851
            ],
            [
              -46.759,
              428.072,
              1862.834
            ],
            [
              -39.768,
              422.378,
              1871.85
            ],
            [
              15.61,
              348.039,
              1964.549
            ],
            [
              36.62,
              260.682,
              2054.397
            ],
            [
              56.855,
              132.292,
              2184.372
            ],
            [
              59.373,
              128.907,
              2188.591
            ],
            [
              70.978,
              128.695,
              2200.198
            ],
            [
              102.671,
              133.684,
              2232.281
            ],
            [
              112.53,
              93.98,
              2273.191
            ],
            [
              117.374,
              52.085,
              2315.364
            ],
            [
              129.077,
              -80.538,
              2448.503
            ],
            [
              129.194,
              -109.485,
              2477.45
            ],
            [
              121.493,
              -193.936,
              2562.252
            ],
            [
              118.351,
              -267.309,
              2635.692
            ],
            [
              179.196,
              -267.363,
              2696.536
            ],
            [
              270.197,
              -263.458,
              2787.621
            ],
            [
              305.837,
              -254.09,
              2824.471
            ],
            [
              342.264,
              -236.944,
              2864.732
            ],
            [
              410.165,
              -191.43,
              2946.476
            ],
            [
              461.971,
              -144.509,
              3016.372
            ],
            [
              541.549,
              -60.247,
              3132.272
            ],
            [
              557.019,
              -44.104,
              3154.63
            ],
            [
              589.799,
              -22.869,
              3193.688
            ],
            [
              630.571,
              1.522,
              3241.198
            ],
            [
              645.363,
              9.096,
              3257.817
            ],
            [
              675.04,
              9.665,
              3287.499
            ],
            [
              707.88,
              6.836,
              3320.461
            ],
            [
              925.597,
              -42.81,
              3543.766
            ],
            [
              1129.224,
              -156.774,
              3777.115
            ],
            [
              1141.634,
              -163.763,
              3791.358
            ],
            [
              1606.423,
              -519.681,
              4376.769
            ],
            [
              1614.903,
              -526.354,
              4387.56
            ],
            [
              1648.803,
              -550.462,
              4429.158
            ],
            [
              1657.142,
              -552.844,
              4437.831
            ],
            [
              1686.795,
              -553.394,
              4467.489
            ],
            [
              1704.118,
              -558.169,
              4485.458
            ],
            [
              1714.932,
              -566.163,
              4498.906
            ],
            [
              1727.769,
              -638.763,
              4572.632
            ],
            [
              1737.731,
              -657.873,
              4594.183
            ],
            [
              1757.197,
              -686.066,
              4628.443
            ],
            [
              1866.79,
              -826.148,
              4806.301
            ],
            [
              1905.301,
              -870.282,
              4864.875
            ],
            [
              1927.219,
              -905.201,
              4906.103
            ],
            [
              1944,
              -938.911,
              4943.759
            ],
            [
              1949.844,
              -971.304,
              4976.675
            ],
            [
              1955.317,
              -990.986,
              4997.104
            ],
            [
              1968.757,
              -1305.631,
              5312.036
            ],
            [
              1988.222,
              -1471.868,
              5479.409
            ],
            [
              2027.109,
              -1678.358,
              5689.528
            ],
            [
              2032.074,
              -1713.148,
              5724.671
            ],
            [
              2048.644,
              -1792.498,
              5805.732
            ],
            [
              2068.057,
              -1877.836,
              5893.251
            ],
            [
              2081.808,
              -1938.356,
              5955.313
            ],
            [
              2087.374,
              -1962.435,
              5980.027
            ],
            [
              2110.719,
              -2024.1,
              6045.963
            ],
            [
              2234.812,
              -2316.979,
              6364.047
            ],
            [
              2284.924,
              -2429.242,
              6486.987
            ],
            [
              2299.015,
              -2468.47,
              6528.669
            ],
            [
              2319.691,
              -2569.05,
              6631.352
            ],
            [
              2323.471,
              -2587.599,
              6650.282
            ],
            [
              2323.492,
              -2606.972,
              6669.655
            ],
            [
              2328.687,
              -2639.354,
              6702.451
            ],
            [
              2411.872,
              -3118.499,
              7188.763
            ],
            [
              2415.738,
              -3139.252,
              7209.873
            ],
            [
              2418.768,
              -3163.158,
              7233.971
            ],
            [
              2474.472,
              -3526.012,
              7601.076
            ],
            [
              2513.109,
              -3664.781,
              7745.123
            ],
            [
              2520.474,
              -3683.355,
              7765.104
            ],
            [
              2522.312,
              -3689.445,
              7771.465
            ],
            [
              2535.711,
              -3730.887,
              7815.019
            ],
            [
              2556.818,
              -3773.588,
              7862.652
            ],
            [
              2598.204,
              -3834.482,
              7936.279
            ],
            [
              2619.624,
              -3860.489,
              7969.971
            ],
            [
              2635.392,
              -3877.441,
              7993.123
            ],
            [
              2642.893,
              -3890.985,
              8008.605
            ],
            [
              2709.56,
              -3977.961,
              8118.192
            ],
            [
              3021.059,
              -4338.966,
              8595.011
            ],
            [
              3086.352,
              -4293.444,
              8674.607
            ],
            [
              3112.838,
              -4272.891,
              8708.132
            ],
            [
              3142.482,
              -4255.542,
              8742.479
            ],
            [
              3336.938,
              -4126.748,
              8975.72
            ],
            [
              3389.682,
              -4097.691,
              9035.938
            ],
            [
              3403.448,
              -4088.142,
              9052.691
            ],
            [
              3446.229,
              -4072.046,
              9098.4
            ],
            [
              3528.69,
              -4039.102,
              9187.199
            ],
            [
              3592.048,
              -4028.061,
              9251.512
            ],
            [
              3640.778,
              -4019.583,
              9300.973
            ],
            [
              3666.294,
              -4020.567,
              9326.508
            ],
            [
              3848.026,
              -4019.578,
              9508.243
            ],
            [
              3878.881,
              -4023.507,
              9539.347
            ],
            [
              3901.964,
              -4029.514,
              9563.199
            ],
            [
              3958.181,
              -4055.079,
              9624.956
            ],
            [
              3965.111,
              -4059.221,
              9633.03
            ],
            [
              4018.762,
              -4121.92,
              9715.55
            ],
            [
              4037.773,
              -4172.381,
              9769.473
            ],
            [
              4030.875,
              -4184.064,
              9783.041
            ],
            [
              4020.501,
              -4190.327,
              9795.159
            ],
            [
              4013.086,
              -4190.447,
              9802.574
            ],
            [
              4002.213,
              -4183.979,
              9815.226
            ],
            [
              3961.129,
              -4130.112,
              9882.972
            ],
            [
              3954.003,
              -4105.097,
              9908.982
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:5300",
              "position": {
                "x": 479.21,
                "z": 1960.301
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 3.526,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:6834",
              "position": {
                "x": 472.7,
                "z": 1534.052
              },
              "distanceAlongShapeM": 575.758,
              "shapeOffsetM": 3.857,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:5346",
              "position": {
                "x": 52.802,
                "z": 1042.989
              },
              "distanceAlongShapeM": 1228.974,
              "shapeOffsetM": 7.818,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:5432",
              "position": {
                "x": -26.358,
                "z": 769.462
              },
              "distanceAlongShapeM": 1518.582,
              "shapeOffsetM": 3.079,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:5459",
              "position": {
                "x": 18.234,
                "z": 348.963
              },
              "distanceAlongShapeM": 1964.549,
              "shapeOffsetM": 2.781,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:5492",
              "position": {
                "x": 116.145,
                "z": 94.475
              },
              "distanceAlongShapeM": 2273.191,
              "shapeOffsetM": 3.649,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:7278",
              "position": {
                "x": 707.88,
                "z": 6.836
              },
              "distanceAlongShapeM": 3320.461,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:6573",
              "position": {
                "x": 1143.99,
                "z": -160.386
              },
              "distanceAlongShapeM": 3791.358,
              "shapeOffsetM": 4.117,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:5770",
              "position": {
                "x": 1610.786,
                "z": -514.132
              },
              "distanceAlongShapeM": 4376.769,
              "shapeOffsetM": 7.059,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:5826",
              "position": {
                "x": 1961.738,
                "z": -990.451
              },
              "distanceAlongShapeM": 4997.104,
              "shapeOffsetM": 6.443,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:6702",
              "position": {
                "x": 2032.094,
                "z": -1677.525
              },
              "distanceAlongShapeM": 5689.528,
              "shapeOffsetM": 5.054,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            },
            {
              "stopId": "judu:stop:5092",
              "position": {
                "x": 2087.852,
                "z": -1936.84
              },
              "distanceAlongShapeM": 5955.174,
              "shapeOffsetM": 6.23,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            },
            {
              "stopId": "judu:stop:5095",
              "position": {
                "x": 2327.089,
                "z": -2587.001
              },
              "distanceAlongShapeM": 6650.282,
              "shapeOffsetM": 3.667,
              "arrivalOffsetSeconds": 1560,
              "departureOffsetSeconds": 1560
            },
            {
              "stopId": "judu:stop:1035",
              "position": {
                "x": 2419.872,
                "z": -3138.687
              },
              "distanceAlongShapeM": 7209.873,
              "shapeOffsetM": 4.173,
              "arrivalOffsetSeconds": 1680,
              "departureOffsetSeconds": 1680
            },
            {
              "stopId": "judu:stop:6711",
              "position": {
                "x": 2522.438,
                "z": -3682.768
              },
              "distanceAlongShapeM": 7765.109,
              "shapeOffsetM": 2.05,
              "arrivalOffsetSeconds": 1800,
              "departureOffsetSeconds": 1800
            },
            {
              "stopId": "judu:stop:741",
              "position": {
                "x": 2636.723,
                "z": -3876.397
              },
              "distanceAlongShapeM": 7993.123,
              "shapeOffsetM": 1.691,
              "arrivalOffsetSeconds": 1860,
              "departureOffsetSeconds": 1860
            },
            {
              "stopId": "judu:stop:5104",
              "position": {
                "x": 3111.27,
                "z": -4270.537
              },
              "distanceAlongShapeM": 8708.132,
              "shapeOffsetM": 2.828,
              "arrivalOffsetSeconds": 1980,
              "departureOffsetSeconds": 1980
            },
            {
              "stopId": "judu:stop:5105",
              "position": {
                "x": 3402.776,
                "z": -4086.807
              },
              "distanceAlongShapeM": 9052.691,
              "shapeOffsetM": 1.495,
              "arrivalOffsetSeconds": 2040,
              "departureOffsetSeconds": 2040
            },
            {
              "stopId": "judu:stop:5107",
              "position": {
                "x": 3640.634,
                "z": -4014.513
              },
              "distanceAlongShapeM": 9300.973,
              "shapeOffsetM": 5.072,
              "arrivalOffsetSeconds": 2100,
              "departureOffsetSeconds": 2100
            },
            {
              "stopId": "judu:stop:900",
              "position": {
                "x": 3967.843,
                "z": -4055.264
              },
              "distanceAlongShapeM": 9633.03,
              "shapeOffsetM": 4.809,
              "arrivalOffsetSeconds": 2160,
              "departureOffsetSeconds": 2160
            }
          ],
          "departuresSeconds": [
            18840,
            19980,
            21000,
            21840,
            22440,
            22920,
            23700,
            24300,
            24780,
            25140,
            25560,
            25980,
            26340,
            26940,
            27420,
            27840,
            28200,
            28620,
            29040,
            29460,
            29940,
            30420,
            30840,
            31380,
            31680,
            32220,
            32640,
            33420,
            34080,
            34860,
            35700,
            36300,
            36960,
            37500,
            37980,
            38580,
            39360,
            40140,
            40980,
            41700,
            42420,
            43080,
            43680,
            44280,
            44880,
            45540,
            46260,
            46980,
            47640,
            48360,
            48960,
            49620,
            50220,
            50820,
            51540,
            52260,
            52920,
            53580,
            54180,
            54540,
            55020,
            55440,
            55860,
            56340,
            56760,
            57180,
            57600,
            58020,
            58440,
            58800,
            59340,
            59820,
            60300,
            60780,
            61200,
            61620,
            62100,
            62520,
            62940,
            63360,
            63780,
            64200,
            64620,
            65100,
            65580,
            66060,
            66540,
            66960,
            67380,
            67860,
            68460,
            69240,
            69960,
            70680,
            71400,
            72120,
            72720,
            73260,
            73860,
            74460,
            75180,
            75900,
            76560,
            77160,
            77820,
            78420,
            79020,
            79620,
            80460,
            81240,
            82080,
            83220,
            84360
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_trol_3",
      "sourceRouteId": "vilnius_trol_3",
      "mode": "trolleybus",
      "shortName": "3",
      "longName": "Karoliniškės–Žvėrynas–Žirmūnai–Valakampiai",
      "color": "DC3131",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_trol_3:0",
          "sourceRouteId": "vilnius_trol_3",
          "sourceShapeId": "vilnius_trol_3_a-b",
          "directionId": 0,
          "headsign": "Valakampiai",
          "directionName": "Karoliniškės–Žvėrynas–Žirmūnai–Valakampiai",
          "mode": "trolleybus",
          "routeShortName": "3",
          "routeLongName": "Karoliniškės–Žvėrynas–Žirmūnai–Valakampiai",
          "routeColor": "DC3131",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              -4635.88,
              552.048,
              0
            ],
            [
              -4631.537,
              534.532,
              18.046
            ],
            [
              -4634.181,
              503.94,
              48.753
            ],
            [
              -4643.152,
              471.614,
              82.3
            ],
            [
              -4646.407,
              443.732,
              110.372
            ],
            [
              -4641.216,
              408.021,
              146.458
            ],
            [
              -4613.144,
              315.143,
              243.486
            ],
            [
              -4593.43,
              261.37,
              300.758
            ],
            [
              -4582.265,
              235.574,
              328.867
            ],
            [
              -4572.392,
              217.886,
              349.124
            ],
            [
              -4568.029,
              200.82,
              366.739
            ],
            [
              -4518.608,
              112.027,
              468.359
            ],
            [
              -4509.454,
              81.813,
              499.929
            ],
            [
              -4478.955,
              17.836,
              570.804
            ],
            [
              -4459.487,
              -12.556,
              606.896
            ],
            [
              -4426.085,
              -57.659,
              663.021
            ],
            [
              -4398.274,
              -90.421,
              705.995
            ],
            [
              -4367.713,
              -113.212,
              744.119
            ],
            [
              -4348.96,
              -128.914,
              768.577
            ],
            [
              -4335.314,
              -141.601,
              787.21
            ],
            [
              -4247.163,
              -227.726,
              910.45
            ],
            [
              -4197.821,
              -283.125,
              984.637
            ],
            [
              -4155.783,
              -350.644,
              1064.173
            ],
            [
              -4081.921,
              -462.729,
              1198.407
            ],
            [
              -4063.365,
              -492.829,
              1233.767
            ],
            [
              -4053.544,
              -508.761,
              1252.483
            ],
            [
              -3962.534,
              -660.121,
              1429.097
            ],
            [
              -3958.061,
              -662.425,
              1434.129
            ],
            [
              -3950.306,
              -661.447,
              1441.945
            ],
            [
              -3806.746,
              -600.485,
              1597.913
            ],
            [
              -3694.685,
              -571.263,
              1713.721
            ],
            [
              -3695.742,
              -557.886,
              1727.14
            ],
            [
              -3728.082,
              -489.418,
              1802.861
            ],
            [
              -3741.232,
              -466.925,
              1828.916
            ],
            [
              -3745.668,
              -462.395,
              1835.256
            ],
            [
              -3755.778,
              -460.516,
              1845.54
            ],
            [
              -3839.114,
              -496.394,
              1936.27
            ],
            [
              -3851.18,
              -510.321,
              1954.697
            ],
            [
              -3857.684,
              -524.093,
              1969.928
            ],
            [
              -3858.854,
              -532.879,
              1978.791
            ],
            [
              -3823.641,
              -607.984,
              2061.741
            ],
            [
              -3766.483,
              -732.543,
              2198.789
            ],
            [
              -3707.64,
              -908.34,
              2384.172
            ],
            [
              -3695.741,
              -928.584,
              2407.654
            ],
            [
              -3679.687,
              -950.175,
              2434.56
            ],
            [
              -3668.232,
              -978.044,
              2464.691
            ],
            [
              -3606.925,
              -1085.98,
              2588.823
            ],
            [
              -3586.062,
              -1109.72,
              2620.428
            ],
            [
              -3575.241,
              -1117.701,
              2633.873
            ],
            [
              -3510.801,
              -1144.012,
              2703.478
            ],
            [
              -3355.367,
              -1190.556,
              2865.731
            ],
            [
              -3109.19,
              -1234.288,
              3115.762
            ],
            [
              -3070.013,
              -1242.306,
              3155.751
            ],
            [
              -2879.155,
              -1277.94,
              3349.907
            ],
            [
              -2839.273,
              -1283.094,
              3390.121
            ],
            [
              -2787.087,
              -1285.125,
              3442.346
            ],
            [
              -2748.376,
              -1283.58,
              3481.088
            ],
            [
              -2714.118,
              -1278.617,
              3515.704
            ],
            [
              -2670.7,
              -1266.023,
              3560.912
            ],
            [
              -2624.585,
              -1246.798,
              3610.873
            ],
            [
              -2499.949,
              -1183.085,
              3750.85
            ],
            [
              -2469.831,
              -1172.717,
              3782.703
            ],
            [
              -2418.716,
              -1162.489,
              3834.831
            ],
            [
              -2392.231,
              -1159.617,
              3861.471
            ],
            [
              -2246.137,
              -1174.448,
              4008.316
            ],
            [
              -2236.291,
              -1164.604,
              4022.239
            ],
            [
              -2207.813,
              -1158.429,
              4051.379
            ],
            [
              -2189.628,
              -1150.959,
              4071.038
            ],
            [
              -2165.314,
              -1131.49,
              4102.187
            ],
            [
              -2151.107,
              -1123.812,
              4118.336
            ],
            [
              -2142.708,
              -1122.847,
              4126.79
            ],
            [
              -2107.347,
              -1112.773,
              4163.558
            ],
            [
              -2052.076,
              -1102.191,
              4219.833
            ],
            [
              -1847.461,
              -1053.546,
              4430.151
            ],
            [
              -1839.367,
              -996.878,
              4487.394
            ],
            [
              -1838.607,
              -973.666,
              4510.618
            ],
            [
              -1831.662,
              -962.505,
              4523.764
            ],
            [
              -1768.396,
              -596.269,
              4895.424
            ],
            [
              -1770.394,
              -575.212,
              4916.576
            ],
            [
              -1761.137,
              -550.756,
              4942.725
            ],
            [
              -1691.384,
              -146.787,
              5352.672
            ],
            [
              -1684.831,
              -90.433,
              5409.406
            ],
            [
              -1682.437,
              -79.04,
              5421.047
            ],
            [
              -1669.697,
              -10.31,
              5490.949
            ],
            [
              -1661.707,
              -1.484,
              5502.854
            ],
            [
              -1388.974,
              -39.407,
              5778.211
            ],
            [
              -1361.685,
              -39.532,
              5805.5
            ],
            [
              -1329.577,
              -37.478,
              5837.674
            ],
            [
              -1190.447,
              -11.028,
              5979.296
            ],
            [
              -1025.306,
              27.195,
              6148.803
            ],
            [
              -994.12,
              39.993,
              6182.512
            ],
            [
              -950.273,
              44.262,
              6226.567
            ],
            [
              -919.958,
              39.772,
              6257.213
            ],
            [
              -857.805,
              53.124,
              6320.783
            ],
            [
              -724.996,
              86.353,
              6457.686
            ],
            [
              -591.62,
              115.115,
              6594.128
            ],
            [
              -557.359,
              122.914,
              6629.266
            ],
            [
              -539.176,
              126.412,
              6647.782
            ],
            [
              -408.498,
              148.538,
              6780.32
            ],
            [
              -385.731,
              159.258,
              6805.485
            ],
            [
              -216.06,
              268.617,
              7007.345
            ],
            [
              -55.202,
              424.885,
              7231.611
            ],
            [
              -39.768,
              422.378,
              7247.247
            ],
            [
              15.61,
              348.039,
              7339.945
            ],
            [
              36.62,
              260.682,
              7429.794
            ],
            [
              56.855,
              132.292,
              7559.768
            ],
            [
              59.373,
              128.907,
              7563.987
            ],
            [
              70.978,
              128.695,
              7575.594
            ],
            [
              102.671,
              133.684,
              7607.677
            ],
            [
              112.53,
              93.98,
              7648.587
            ],
            [
              117.374,
              52.085,
              7690.761
            ],
            [
              129.077,
              -80.538,
              7823.9
            ],
            [
              129.194,
              -109.485,
              7852.847
            ],
            [
              121.493,
              -193.936,
              7937.648
            ],
            [
              118.351,
              -267.309,
              8011.088
            ],
            [
              179.196,
              -267.363,
              8071.933
            ],
            [
              270.197,
              -263.458,
              8163.017
            ],
            [
              305.837,
              -254.09,
              8199.868
            ],
            [
              342.264,
              -236.944,
              8240.128
            ],
            [
              410.165,
              -191.43,
              8321.872
            ],
            [
              461.971,
              -144.509,
              8391.768
            ],
            [
              541.549,
              -60.247,
              8507.668
            ],
            [
              557.019,
              -44.104,
              8530.026
            ],
            [
              589.799,
              -22.869,
              8569.084
            ],
            [
              630.571,
              1.522,
              8616.595
            ],
            [
              645.363,
              9.096,
              8633.213
            ],
            [
              675.04,
              9.665,
              8662.895
            ],
            [
              707.88,
              6.836,
              8695.857
            ],
            [
              925.597,
              -42.81,
              8919.163
            ],
            [
              1129.224,
              -156.774,
              9152.512
            ],
            [
              1141.634,
              -163.763,
              9166.755
            ],
            [
              1606.423,
              -519.681,
              9752.166
            ],
            [
              1614.903,
              -526.354,
              9762.957
            ],
            [
              1648.803,
              -550.462,
              9804.555
            ],
            [
              1662.944,
              -552.951,
              9818.913
            ],
            [
              1683.01,
              -548.871,
              9839.39
            ],
            [
              1698.481,
              -549.159,
              9854.863
            ],
            [
              1705.327,
              -547.896,
              9861.825
            ],
            [
              1715.935,
              -555.388,
              9874.812
            ],
            [
              1719.444,
              -566.247,
              9886.224
            ],
            [
              1721.402,
              -599.681,
              9919.715
            ],
            [
              1720.009,
              -605.221,
              9925.428
            ],
            [
              1711.776,
              -614.79,
              9938.051
            ],
            [
              1700.984,
              -622.679,
              9951.419
            ],
            [
              1684.224,
              -622.368,
              9968.182
            ],
            [
              1662.848,
              -627.537,
              9990.174
            ],
            [
              1583.13,
              -683.945,
              10087.831
            ],
            [
              1381.451,
              -814.909,
              10328.301
            ],
            [
              1363.471,
              -845.747,
              10363.998
            ],
            [
              1362.208,
              -879.121,
              10397.396
            ],
            [
              1367.85,
              -922.642,
              10441.281
            ],
            [
              1384.491,
              -964.14,
              10485.991
            ],
            [
              1464.439,
              -1103.664,
              10646.797
            ],
            [
              1477.634,
              -1123.116,
              10670.302
            ],
            [
              1488.813,
              -1145.306,
              10695.149
            ],
            [
              1537.374,
              -1238.606,
              10800.33
            ],
            [
              1587.871,
              -1366.453,
              10937.789
            ],
            [
              1626.598,
              -1502.988,
              11079.71
            ],
            [
              1647.564,
              -1589.097,
              11168.334
            ],
            [
              1670.179,
              -1759.844,
              11340.573
            ],
            [
              1672.682,
              -1787.97,
              11368.81
            ],
            [
              1672.408,
              -1813.321,
              11394.162
            ],
            [
              1676.981,
              -1962.613,
              11543.524
            ],
            [
              1684.587,
              -2475.93,
              12056.898
            ],
            [
              1691.063,
              -2612.98,
              12194.1
            ],
            [
              1692.552,
              -2638.806,
              12219.97
            ],
            [
              1690.652,
              -2669.748,
              12250.97
            ],
            [
              1690.731,
              -2873.474,
              12454.696
            ],
            [
              1700.851,
              -3126.37,
              12707.794
            ],
            [
              1707.344,
              -3177.803,
              12759.635
            ],
            [
              1701.896,
              -3208.77,
              12791.078
            ],
            [
              1697.306,
              -3247.648,
              12830.226
            ],
            [
              1679.831,
              -3286.287,
              12872.633
            ],
            [
              1593.247,
              -3437.193,
              13046.614
            ],
            [
              1579.69,
              -3472.235,
              13084.187
            ],
            [
              1566.424,
              -3493.47,
              13109.225
            ],
            [
              1520.486,
              -3572.771,
              13200.871
            ],
            [
              1584,
              -3657.444,
              13306.718
            ],
            [
              1660.25,
              -3750.148,
              13426.751
            ],
            [
              1866.498,
              -3989.997,
              13743.083
            ],
            [
              1889,
              -4009.127,
              13772.618
            ],
            [
              2239.227,
              -4387.713,
              14288.356
            ],
            [
              2241.845,
              -4385.536,
              14291.761
            ],
            [
              2278.681,
              -4414.057,
              14338.348
            ],
            [
              2318.758,
              -4441.526,
              14386.935
            ],
            [
              2353.827,
              -4461.109,
              14427.102
            ],
            [
              2406.203,
              -4485.47,
              14484.866
            ],
            [
              2429.992,
              -4488.143,
              14508.804
            ],
            [
              2442.271,
              -4486.147,
              14521.245
            ],
            [
              2442.663,
              -4484.561,
              14522.878
            ],
            [
              2454.801,
              -4470.797,
              14541.23
            ],
            [
              2456.963,
              -4458.592,
              14553.625
            ],
            [
              2455.031,
              -4458.555,
              14555.558
            ],
            [
              2441.777,
              -4443.834,
              14575.366
            ],
            [
              2402.241,
              -4421.94,
              14620.559
            ],
            [
              2384.311,
              -4416.038,
              14639.436
            ],
            [
              2354.704,
              -4414.369,
              14669.09
            ],
            [
              2298.04,
              -4481.215,
              14756.721
            ],
            [
              2194.425,
              -4557.766,
              14885.547
            ],
            [
              2023.857,
              -4667.428,
              15088.326
            ],
            [
              1937.537,
              -4728.535,
              15194.086
            ],
            [
              1867.134,
              -4788.872,
              15286.807
            ],
            [
              1634.717,
              -4873.729,
              15534.23
            ],
            [
              1419.845,
              -4960.882,
              15766.104
            ],
            [
              1390.251,
              -4966.37,
              15796.203
            ],
            [
              1372.845,
              -4968.418,
              15813.728
            ],
            [
              1253.552,
              -4950.953,
              15934.294
            ],
            [
              1217.033,
              -4945.712,
              15971.186
            ],
            [
              1176.266,
              -4939.77,
              16012.384
            ],
            [
              1118.975,
              -4934.63,
              16069.905
            ],
            [
              1098.764,
              -4947.615,
              16093.928
            ],
            [
              1088.192,
              -4961.892,
              16111.693
            ],
            [
              1083.868,
              -4972.85,
              16123.473
            ],
            [
              1006.146,
              -5218.651,
              16381.27
            ],
            [
              963.765,
              -5358.008,
              16526.928
            ],
            [
              947.584,
              -5434.792,
              16605.399
            ],
            [
              918.816,
              -5587.751,
              16761.04
            ],
            [
              921.352,
              -5743.695,
              16917.005
            ],
            [
              937.406,
              -5832.544,
              17007.292
            ],
            [
              967.755,
              -5975.104,
              17153.047
            ],
            [
              971.508,
              -6015.64,
              17193.756
            ],
            [
              989.292,
              -6050.631,
              17233.007
            ],
            [
              981.066,
              -6057.099,
              17243.471
            ],
            [
              960.828,
              -6058.109,
              17263.734
            ],
            [
              954.724,
              -6050.412,
              17273.557
            ],
            [
              952.792,
              -6050.376,
              17275.49
            ],
            [
              952.957,
              -6041.473,
              17284.394
            ],
            [
              959.602,
              -6030.072,
              17297.59
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:5924",
              "position": {
                "x": -4631.834,
                "z": 503.595
              },
              "distanceAlongShapeM": 48.753,
              "shapeOffsetM": 2.372,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:351",
              "position": {
                "x": -4568.349,
                "z": 219.75
              },
              "distanceAlongShapeM": 349.124,
              "shapeOffsetM": 4.452,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:6400",
              "position": {
                "x": -4345.341,
                "z": -124.73
              },
              "distanceAlongShapeM": 768.577,
              "shapeOffsetM": 5.532,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:596",
              "position": {
                "x": -4057.587,
                "z": -489.267
              },
              "distanceAlongShapeM": 1233.767,
              "shapeOffsetM": 6.788,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:6643",
              "position": {
                "x": -3679.35,
                "z": -950.021
              },
              "distanceAlongShapeM": 2434.56,
              "shapeOffsetM": 0.37,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:7416",
              "position": {
                "x": -3108.49,
                "z": -1230.499
              },
              "distanceAlongShapeM": 3115.762,
              "shapeOffsetM": 3.854,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:6430",
              "position": {
                "x": -2107.685,
                "z": -1111.223
              },
              "distanceAlongShapeM": 4163.558,
              "shapeOffsetM": 1.586,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:6433",
              "position": {
                "x": -1839.595,
                "z": -973.496
              },
              "distanceAlongShapeM": 4510.618,
              "shapeOffsetM": 1.002,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            },
            {
              "stopId": "judu:stop:6434",
              "position": {
                "x": -1771.243,
                "z": -575.067
              },
              "distanceAlongShapeM": 4916.576,
              "shapeOffsetM": 0.861,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:6437",
              "position": {
                "x": -1686.504,
                "z": -90.1
              },
              "distanceAlongShapeM": 5409.406,
              "shapeOffsetM": 1.705,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:18852",
              "position": {
                "x": -1457.753,
                "z": -28.505
              },
              "distanceAlongShapeM": 5708.586,
              "shapeOffsetM": 1.326,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:5881",
              "position": {
                "x": -949.475,
                "z": 48.095
              },
              "distanceAlongShapeM": 6226.795,
              "shapeOffsetM": 3.908,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:5332",
              "position": {
                "x": -557.893,
                "z": 125.637
              },
              "distanceAlongShapeM": 6629.266,
              "shapeOffsetM": 2.774,
              "arrivalOffsetSeconds": 1380,
              "departureOffsetSeconds": 1380
            },
            {
              "stopId": "judu:stop:5459",
              "position": {
                "x": 18.234,
                "z": 348.963
              },
              "distanceAlongShapeM": 7339.945,
              "shapeOffsetM": 2.781,
              "arrivalOffsetSeconds": 1620,
              "departureOffsetSeconds": 1620
            },
            {
              "stopId": "judu:stop:5492",
              "position": {
                "x": 116.145,
                "z": 94.475
              },
              "distanceAlongShapeM": 7648.587,
              "shapeOffsetM": 3.649,
              "arrivalOffsetSeconds": 1680,
              "departureOffsetSeconds": 1680
            },
            {
              "stopId": "judu:stop:7278",
              "position": {
                "x": 707.88,
                "z": 6.836
              },
              "distanceAlongShapeM": 8695.857,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1950,
              "departureOffsetSeconds": 1950
            },
            {
              "stopId": "judu:stop:6573",
              "position": {
                "x": 1143.99,
                "z": -160.386
              },
              "distanceAlongShapeM": 9166.755,
              "shapeOffsetM": 4.117,
              "arrivalOffsetSeconds": 2070,
              "departureOffsetSeconds": 2070
            },
            {
              "stopId": "judu:stop:5770",
              "position": {
                "x": 1610.786,
                "z": -514.132
              },
              "distanceAlongShapeM": 9752.166,
              "shapeOffsetM": 7.059,
              "arrivalOffsetSeconds": 2130,
              "departureOffsetSeconds": 2130
            },
            {
              "stopId": "judu:stop:6665",
              "position": {
                "x": 1480.223,
                "z": -1121.768
              },
              "distanceAlongShapeM": 10670.302,
              "shapeOffsetM": 2.918,
              "arrivalOffsetSeconds": 2370,
              "departureOffsetSeconds": 2370
            },
            {
              "stopId": "judu:stop:6666",
              "position": {
                "x": 1676.751,
                "z": -1787.797
              },
              "distanceAlongShapeM": 11368.81,
              "shapeOffsetM": 4.073,
              "arrivalOffsetSeconds": 2490,
              "departureOffsetSeconds": 2490
            },
            {
              "stopId": "judu:stop:5606",
              "position": {
                "x": 1696.386,
                "z": -2638.684
              },
              "distanceAlongShapeM": 12219.97,
              "shapeOffsetM": 3.836,
              "arrivalOffsetSeconds": 2760,
              "departureOffsetSeconds": 2760
            },
            {
              "stopId": "judu:stop:6667",
              "position": {
                "x": 1709.563,
                "z": -3177.741
              },
              "distanceAlongShapeM": 12759.635,
              "shapeOffsetM": 2.22,
              "arrivalOffsetSeconds": 2880,
              "departureOffsetSeconds": 2880
            },
            {
              "stopId": "judu:stop:6873",
              "position": {
                "x": 1553.844,
                "z": -3615.694
              },
              "distanceAlongShapeM": 13255.224,
              "shapeOffsetM": 0.929,
              "arrivalOffsetSeconds": 3000,
              "departureOffsetSeconds": 3000
            },
            {
              "stopId": "judu:stop:6874",
              "position": {
                "x": 1889.999,
                "z": -4008.247
              },
              "distanceAlongShapeM": 13772.65,
              "shapeOffsetM": 1.331,
              "arrivalOffsetSeconds": 3060,
              "departureOffsetSeconds": 3060
            },
            {
              "stopId": "judu:stop:16147",
              "position": {
                "x": 2194.798,
                "z": -4558.323
              },
              "distanceAlongShapeM": 14885.547,
              "shapeOffsetM": 0.671,
              "arrivalOffsetSeconds": 3180,
              "departureOffsetSeconds": 3180
            },
            {
              "stopId": "judu:stop:16148",
              "position": {
                "x": 1942.804,
                "z": -4735.073
              },
              "distanceAlongShapeM": 15193.564,
              "shapeOffsetM": 8.38,
              "arrivalOffsetSeconds": 3300,
              "departureOffsetSeconds": 3300
            },
            {
              "stopId": "judu:stop:16145",
              "position": {
                "x": 1216.637,
                "z": -4948.682
              },
              "distanceAlongShapeM": 15971.157,
              "shapeOffsetM": 2.996,
              "arrivalOffsetSeconds": 3420,
              "departureOffsetSeconds": 3420
            },
            {
              "stopId": "judu:stop:16149",
              "position": {
                "x": 953.825,
                "z": -5435.882
              },
              "distanceAlongShapeM": 16605.179,
              "shapeOffsetM": 6.332,
              "arrivalOffsetSeconds": 3540,
              "departureOffsetSeconds": 3540
            },
            {
              "stopId": "judu:stop:6104",
              "position": {
                "x": 957.71,
                "z": -6028.202
              },
              "distanceAlongShapeM": 17297.59,
              "shapeOffsetM": 2.66,
              "arrivalOffsetSeconds": 3660,
              "departureOffsetSeconds": 3660
            }
          ],
          "departuresSeconds": [
            36600,
            38040,
            39180,
            40080,
            40800,
            41400,
            42360,
            43440,
            44760,
            46080,
            47220,
            48360,
            49260,
            50640,
            51840,
            52980,
            53820,
            54540,
            55440,
            56580,
            57600,
            59100,
            60300,
            61680,
            62580,
            63540,
            64680,
            66840,
            68640,
            70440
          ]
        },
        {
          "id": "judu:pattern:vilnius_trol_3:1",
          "sourceRouteId": "vilnius_trol_3",
          "sourceShapeId": "vilnius_trol_3_b-a",
          "directionId": 1,
          "headsign": "Karoliniškės",
          "directionName": "Valakampiai–Žirmūnai–Žvėrynas–Karoliniškės",
          "mode": "trolleybus",
          "routeShortName": "3",
          "routeLongName": "Karoliniškės–Žvėrynas–Žirmūnai–Valakampiai",
          "routeColor": "DC3131",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              959.602,
              -6030.072,
              0
            ],
            [
              969.464,
              -6019.513,
              14.448
            ],
            [
              971.662,
              -6005.081,
              29.047
            ],
            [
              920.286,
              -5752.539,
              286.762
            ],
            [
              917.22,
              -5604.42,
              434.912
            ],
            [
              928.632,
              -5545.534,
              494.894
            ],
            [
              940.974,
              -5469.042,
              572.375
            ],
            [
              970.809,
              -5322.469,
              721.954
            ],
            [
              978.203,
              -5301.629,
              744.067
            ],
            [
              1054.122,
              -5062.569,
              994.892
            ],
            [
              1069.297,
              -5008.3,
              1051.243
            ],
            [
              1072.198,
              -4997.859,
              1062.08
            ],
            [
              1086.945,
              -4959.643,
              1103.042
            ],
            [
              1095.833,
              -4947.834,
              1117.822
            ],
            [
              1104.704,
              -4939.932,
              1129.702
            ],
            [
              1118.975,
              -4934.63,
              1144.926
            ],
            [
              1142.2,
              -4932.833,
              1168.221
            ],
            [
              1277.376,
              -4952.022,
              1304.752
            ],
            [
              1313.697,
              -4960.498,
              1342.049
            ],
            [
              1340.018,
              -4965.439,
              1368.83
            ],
            [
              1389.607,
              -4966.358,
              1418.427
            ],
            [
              1429.741,
              -4955.97,
              1459.884
            ],
            [
              1621.931,
              -4875.456,
              1668.257
            ],
            [
              1827.524,
              -4801.945,
              1886.597
            ],
            [
              1854.801,
              -4790.208,
              1916.292
            ],
            [
              1892.618,
              -4761.763,
              1963.613
            ],
            [
              1911.281,
              -4745.922,
              1988.092
            ],
            [
              2211.295,
              -4537.48,
              2353.409
            ],
            [
              2213.373,
              -4529.726,
              2361.437
            ],
            [
              2277.782,
              -4496.421,
              2433.947
            ],
            [
              2199.275,
              -4353.568,
              2596.951
            ],
            [
              1944.045,
              -4081.617,
              2969.912
            ],
            [
              1863.859,
              -3993.288,
              3089.209
            ],
            [
              1812.233,
              -3946.912,
              3158.607
            ],
            [
              1800.044,
              -3925.303,
              3183.416
            ],
            [
              1667.691,
              -3765.872,
              3390.625
            ],
            [
              1499.686,
              -3582.404,
              3639.394
            ],
            [
              1509.877,
              -3564.24,
              3660.222
            ],
            [
              1545.21,
              -3525.36,
              3712.758
            ],
            [
              1610.18,
              -3392.177,
              3860.943
            ],
            [
              1620.009,
              -3384.254,
              3873.568
            ],
            [
              1689.847,
              -3267.548,
              4009.574
            ],
            [
              1697.306,
              -3247.648,
              4030.826
            ],
            [
              1696.944,
              -3128.524,
              4149.951
            ],
            [
              1692.78,
              -3098.159,
              4180.6
            ],
            [
              1693.427,
              -3075.022,
              4203.746
            ],
            [
              1690.731,
              -2873.474,
              4405.312
            ],
            [
              1684.353,
              -2661.838,
              4617.044
            ],
            [
              1680.485,
              -2590.427,
              4688.56
            ],
            [
              1679.547,
              -2554.739,
              4724.26
            ],
            [
              1678.725,
              -2527.718,
              4751.293
            ],
            [
              1679.06,
              -2495.866,
              4783.147
            ],
            [
              1670.601,
              -2049.296,
              5229.797
            ],
            [
              1665.105,
              -1963.474,
              5315.795
            ],
            [
              1665.702,
              -1896.69,
              5382.582
            ],
            [
              1663.09,
              -1759.712,
              5519.585
            ],
            [
              1657.26,
              -1724.669,
              5555.109
            ],
            [
              1660.464,
              -1692.869,
              5587.07
            ],
            [
              1642.718,
              -1572.308,
              5708.93
            ],
            [
              1626.598,
              -1502.988,
              5780.1
            ],
            [
              1590.763,
              -1384.318,
              5904.063
            ],
            [
              1541.473,
              -1260.946,
              6036.916
            ],
            [
              1439.941,
              -1068.699,
              6254.328
            ],
            [
              1422.22,
              -1045.077,
              6283.858
            ],
            [
              1413.029,
              -1024.784,
              6306.135
            ],
            [
              1382.574,
              -969.885,
              6368.916
            ],
            [
              1372.327,
              -959.462,
              6383.532
            ],
            [
              1333.941,
              -943.166,
              6425.234
            ],
            [
              1307.513,
              -942.677,
              6451.667
            ],
            [
              1293.291,
              -944.641,
              6466.024
            ],
            [
              1278.614,
              -942.95,
              6480.798
            ],
            [
              1269.114,
              -935.31,
              6492.988
            ],
            [
              1257.937,
              -924.707,
              6508.395
            ],
            [
              1253.197,
              -916.068,
              6518.249
            ],
            [
              1249.597,
              -901.529,
              6533.227
            ],
            [
              1249.57,
              -868.132,
              6566.624
            ],
            [
              1251.975,
              -858.297,
              6576.749
            ],
            [
              1263.58,
              -842.786,
              6596.12
            ],
            [
              1271.438,
              -836.252,
              6606.34
            ],
            [
              1287.032,
              -829.861,
              6623.193
            ],
            [
              1306.39,
              -829.106,
              6642.565
            ],
            [
              1381.451,
              -814.909,
              6718.957
            ],
            [
              1598.931,
              -666.427,
              6982.291
            ],
            [
              1632.324,
              -639.216,
              7025.366
            ],
            [
              1644.195,
              -624.964,
              7043.915
            ],
            [
              1649.997,
              -609.491,
              7060.44
            ],
            [
              1647.435,
              -589.4,
              7080.694
            ],
            [
              1641.361,
              -569.249,
              7101.74
            ],
            [
              1626.241,
              -550.043,
              7126.184
            ],
            [
              1613.941,
              -537.088,
              7144.047
            ],
            [
              1227.773,
              -233.181,
              7635.459
            ],
            [
              1061.875,
              -125.757,
              7833.101
            ],
            [
              1042.305,
              -113.981,
              7855.94
            ],
            [
              992.552,
              -84.12,
              7913.966
            ],
            [
              920.398,
              -44.941,
              7996.071
            ],
            [
              797.689,
              -19.306,
              8121.429
            ],
            [
              670.384,
              1.958,
              8250.498
            ],
            [
              652.936,
              0.051,
              8268.05
            ],
            [
              630.873,
              -7.336,
              8291.317
            ],
            [
              602.561,
              -27.877,
              8326.295
            ],
            [
              564.962,
              -49.544,
              8369.69
            ],
            [
              476.44,
              -129.188,
              8488.767
            ],
            [
              402.286,
              -199.078,
              8590.666
            ],
            [
              346.776,
              -237.026,
              8657.908
            ],
            [
              291.552,
              -259.395,
              8717.49
            ],
            [
              265.664,
              -264.488,
              8743.875
            ],
            [
              119.684,
              -277.409,
              8890.425
            ],
            [
              35.151,
              -280.322,
              8975.008
            ],
            [
              26.264,
              -279.764,
              8983.913
            ],
            [
              16.623,
              -264.894,
              9001.635
            ],
            [
              14.513,
              -253.218,
              9013.5
            ],
            [
              16.439,
              -245.471,
              9021.483
            ],
            [
              45.916,
              -220.403,
              9060.178
            ],
            [
              103.215,
              -190.277,
              9124.914
            ],
            [
              127.382,
              -102.772,
              9215.695
            ],
            [
              121.848,
              -52.576,
              9266.195
            ],
            [
              118.496,
              -36.512,
              9282.605
            ],
            [
              117.583,
              -3.516,
              9315.614
            ],
            [
              102.671,
              133.684,
              9453.622
            ],
            [
              63.181,
              125.497,
              9493.951
            ],
            [
              59.312,
              125.568,
              9497.821
            ],
            [
              57.419,
              127.829,
              9500.77
            ],
            [
              31.786,
              278.582,
              9653.687
            ],
            [
              4.856,
              358.112,
              9737.652
            ],
            [
              -8.924,
              380.627,
              9764.049
            ],
            [
              -39.768,
              422.378,
              9815.958
            ],
            [
              -46.8,
              425.846,
              9823.799
            ],
            [
              -52.603,
              425.951,
              9829.603
            ],
            [
              -86.677,
              396.514,
              9874.631
            ],
            [
              -98.36,
              381.073,
              9893.994
            ],
            [
              -191.298,
              289.447,
              10024.504
            ],
            [
              -216.06,
              268.617,
              10056.862
            ],
            [
              -386.375,
              159.27,
              10259.257
            ],
            [
              -408.498,
              148.538,
              10283.846
            ],
            [
              -583.944,
              111.636,
              10463.131
            ],
            [
              -658.953,
              100.746,
              10538.926
            ],
            [
              -724.996,
              86.353,
              10606.519
            ],
            [
              -736.71,
              77.277,
              10621.338
            ],
            [
              -743.833,
              78.9,
              10628.644
            ],
            [
              -798.875,
              66.534,
              10685.058
            ],
            [
              -863.023,
              49.879,
              10751.333
            ],
            [
              -871.015,
              45.142,
              10760.624
            ],
            [
              -877.911,
              46.807,
              10767.718
            ],
            [
              -930.978,
              36.63,
              10821.752
            ],
            [
              -998.108,
              33.385,
              10888.96
            ],
            [
              -1226.73,
              -20.397,
              11123.823
            ],
            [
              -1327.722,
              -41.964,
              11227.092
            ],
            [
              -1378.216,
              -54.917,
              11279.221
            ],
            [
              -1437.414,
              -46.326,
              11339.039
            ],
            [
              -1471.431,
              -36.053,
              11374.574
            ],
            [
              -1661.707,
              -1.484,
              11567.964
            ],
            [
              -1691.384,
              -146.787,
              11716.267
            ],
            [
              -1712.987,
              -273.309,
              11844.62
            ],
            [
              -1713.492,
              -281.762,
              11853.089
            ],
            [
              -1719.483,
              -312.156,
              11884.067
            ],
            [
              -1768.396,
              -596.269,
              12172.36
            ],
            [
              -1772.222,
              -628.201,
              12204.52
            ],
            [
              -1778.412,
              -651.752,
              12228.871
            ],
            [
              -1847.461,
              -1053.546,
              12636.555
            ],
            [
              -1903.255,
              -1072.553,
              12695.497
            ],
            [
              -1912.525,
              -1075.817,
              12705.326
            ],
            [
              -1954.393,
              -1083.889,
              12747.964
            ],
            [
              -2142.708,
              -1122.847,
              12940.267
            ],
            [
              -2154.408,
              -1128.206,
              12953.136
            ],
            [
              -2189.935,
              -1158.368,
              12999.74
            ],
            [
              -2202.233,
              -1162.567,
              13012.735
            ],
            [
              -2218.205,
              -1162.698,
              13028.708
            ],
            [
              -2227.932,
              -1165.865,
              13038.937
            ],
            [
              -2246.137,
              -1174.448,
              13059.064
            ],
            [
              -2255.397,
              -1187.643,
              13075.184
            ],
            [
              -2266.36,
              -1186.843,
              13086.176
            ],
            [
              -2295.924,
              -1182.472,
              13116.062
            ],
            [
              -2392.506,
              -1175.197,
              13212.917
            ],
            [
              -2431.277,
              -1180.078,
              13251.994
            ],
            [
              -2478.584,
              -1193.714,
              13301.227
            ],
            [
              -2533.196,
              -1219.467,
              13361.607
            ],
            [
              -2617.204,
              -1266.966,
              13458.113
            ],
            [
              -2663.944,
              -1285.067,
              13508.236
            ],
            [
              -2710.565,
              -1296.491,
              13556.236
            ],
            [
              -2762.381,
              -1304.469,
              13608.663
            ],
            [
              -2806.189,
              -1305.331,
              13652.479
            ],
            [
              -2858.757,
              -1300.914,
              13705.233
            ],
            [
              -3085.169,
              -1260.965,
              13935.142
            ],
            [
              -3139.719,
              -1251.188,
              13990.561
            ],
            [
              -3159.719,
              -1247.413,
              14010.914
            ],
            [
              -3359.526,
              -1207.182,
              14214.731
            ],
            [
              -3495.953,
              -1192.555,
              14351.94
            ],
            [
              -3569.469,
              -1193.5,
              14425.462
            ],
            [
              -3626.266,
              -1196.964,
              14482.365
            ],
            [
              -3657.704,
              -1114.039,
              14571.049
            ],
            [
              -3677.364,
              -1066.903,
              14622.121
            ],
            [
              -3685.368,
              -1042.059,
              14648.222
            ],
            [
              -3720.918,
              -930.373,
              14765.429
            ],
            [
              -3751.424,
              -837.404,
              14863.276
            ],
            [
              -3758.325,
              -817.25,
              14884.578
            ],
            [
              -3766.218,
              -791.548,
              14911.465
            ],
            [
              -3793.988,
              -719.82,
              14988.381
            ],
            [
              -3843.779,
              -616.54,
              15103.037
            ],
            [
              -3881.258,
              -546.871,
              15182.147
            ],
            [
              -3892.746,
              -539.992,
              15195.537
            ],
            [
              -3915.211,
              -534.036,
              15218.778
            ],
            [
              -4013.321,
              -576.864,
              15325.829
            ],
            [
              -4103.192,
              -441.723,
              15488.124
            ],
            [
              -4120.29,
              -416.592,
              15518.52
            ],
            [
              -4130.843,
              -399.669,
              15538.464
            ],
            [
              -4155.783,
              -350.644,
              15593.468
            ],
            [
              -4237.762,
              -243.473,
              15728.398
            ],
            [
              -4351.477,
              -138.439,
              15883.199
            ],
            [
              -4426.18,
              -63.224,
              15989.208
            ],
            [
              -4445.371,
              -41.623,
              16018.102
            ],
            [
              -4460.208,
              -16.996,
              16046.853
            ],
            [
              -4494.728,
              38.145,
              16111.908
            ],
            [
              -4529.153,
              107.182,
              16189.053
            ],
            [
              -4592.389,
              246.88,
              16342.396
            ],
            [
              -4602.309,
              268.218,
              16365.927
            ],
            [
              -4641.216,
              408.021,
              16511.043
            ],
            [
              -4659.752,
              487.017,
              16592.185
            ],
            [
              -4661.513,
              502.991,
              16608.256
            ],
            [
              -4670.535,
              540.995,
              16647.316
            ],
            [
              -4686.12,
              572.432,
              16682.404
            ],
            [
              -4701.876,
              593.853,
              16708.995
            ],
            [
              -4704.928,
              603.925,
              16719.52
            ],
            [
              -4700.939,
              612.618,
              16729.084
            ],
            [
              -4692.51,
              618.683,
              16739.469
            ],
            [
              -4676.757,
              618.614,
              16755.222
            ],
            [
              -4666.006,
              610.655,
              16768.598
            ],
            [
              -4635.88,
              552.048,
              16834.495
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:6104",
              "position": {
                "x": 957.71,
                "z": -6028.202
              },
              "distanceAlongShapeM": 0.075,
              "shapeOffsetM": 2.659,
              "arrivalOffsetSeconds": -330,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:6106",
              "position": {
                "x": 967.53,
                "z": -5321.47
              },
              "distanceAlongShapeM": 721.954,
              "shapeOffsetM": 3.428,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:6107",
              "position": {
                "x": 1070.146,
                "z": -4997.183
              },
              "distanceAlongShapeM": 1062.08,
              "shapeOffsetM": 2.161,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:6109",
              "position": {
                "x": 1888.913,
                "z": -4757.446
              },
              "distanceAlongShapeM": 1963.247,
              "shapeOffsetM": 5.677,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:6110",
              "position": {
                "x": 2213.373,
                "z": -4529.726
              },
              "distanceAlongShapeM": 2361.437,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:5494",
              "position": {
                "x": 1811.224,
                "z": -3947.777
              },
              "distanceAlongShapeM": 3158.607,
              "shapeOffsetM": 1.329,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:5086",
              "position": {
                "x": 1607.644,
                "z": -3390.704
              },
              "distanceAlongShapeM": 3860.943,
              "shapeOffsetM": 2.933,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:5087",
              "position": {
                "x": 1687.839,
                "z": -3098.296
              },
              "distanceAlongShapeM": 4180.6,
              "shapeOffsetM": 4.943,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:5088",
              "position": {
                "x": 1670.083,
                "z": -2527.983
              },
              "distanceAlongShapeM": 4751.291,
              "shapeOffsetM": 8.646,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:5658",
              "position": {
                "x": 1653.419,
                "z": -1725.022
              },
              "distanceAlongShapeM": 5555.109,
              "shapeOffsetM": 3.857,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:5661",
              "position": {
                "x": 1418.417,
                "z": -1047.149
              },
              "distanceAlongShapeM": 6283.858,
              "shapeOffsetM": 4.331,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            },
            {
              "stopId": "judu:stop:5768",
              "position": {
                "x": 1608.96,
                "z": -543.043
              },
              "distanceAlongShapeM": 7143.159,
              "shapeOffsetM": 7.713,
              "arrivalOffsetSeconds": 1560,
              "departureOffsetSeconds": 1560
            },
            {
              "stopId": "judu:stop:5771",
              "position": {
                "x": 1060.09,
                "z": -128.781
              },
              "distanceAlongShapeM": 7832.955,
              "shapeOffsetM": 3.508,
              "arrivalOffsetSeconds": 1680,
              "departureOffsetSeconds": 1680
            },
            {
              "stopId": "judu:stop:848",
              "position": {
                "x": 604.636,
                "z": -31.346
              },
              "distanceAlongShapeM": 8326.295,
              "shapeOffsetM": 4.042,
              "arrivalOffsetSeconds": 1800,
              "departureOffsetSeconds": 1800
            },
            {
              "stopId": "judu:stop:5409",
              "position": {
                "x": 115.041,
                "z": -36.866
              },
              "distanceAlongShapeM": 9282.605,
              "shapeOffsetM": 3.473,
              "arrivalOffsetSeconds": 2040,
              "departureOffsetSeconds": 2040
            },
            {
              "stopId": "judu:stop:5334",
              "position": {
                "x": -97.297,
                "z": 380.009
              },
              "distanceAlongShapeM": 9893.994,
              "shapeOffsetM": 1.504,
              "arrivalOffsetSeconds": 2280,
              "departureOffsetSeconds": 2280
            },
            {
              "stopId": "judu:stop:5936",
              "position": {
                "x": -736.157,
                "z": 75.422
              },
              "distanceAlongShapeM": 10621.338,
              "shapeOffsetM": 1.935,
              "arrivalOffsetSeconds": 2460,
              "departureOffsetSeconds": 2460
            },
            {
              "stopId": "judu:stop:19193",
              "position": {
                "x": -870.86,
                "z": 44.454
              },
              "distanceAlongShapeM": 10760.624,
              "shapeOffsetM": 0.705,
              "arrivalOffsetSeconds": 2520,
              "departureOffsetSeconds": 2520
            },
            {
              "stopId": "judu:stop:6438",
              "position": {
                "x": -1438.145,
                "z": -50.007
              },
              "distanceAlongShapeM": 11339.039,
              "shapeOffsetM": 3.753,
              "arrivalOffsetSeconds": 2580,
              "departureOffsetSeconds": 2580
            },
            {
              "stopId": "judu:stop:6436",
              "position": {
                "x": -1710.567,
                "z": -282.258
              },
              "distanceAlongShapeM": 11853.089,
              "shapeOffsetM": 2.967,
              "arrivalOffsetSeconds": 2700,
              "departureOffsetSeconds": 2700
            },
            {
              "stopId": "judu:stop:6435",
              "position": {
                "x": -1770.261,
                "z": -628.519
              },
              "distanceAlongShapeM": 12204.52,
              "shapeOffsetM": 1.987,
              "arrivalOffsetSeconds": 2760,
              "departureOffsetSeconds": 2760
            },
            {
              "stopId": "judu:stop:6432",
              "position": {
                "x": -1911.753,
                "z": -1079.081
              },
              "distanceAlongShapeM": 12705.326,
              "shapeOffsetM": 3.354,
              "arrivalOffsetSeconds": 2850,
              "departureOffsetSeconds": 2850
            },
            {
              "stopId": "judu:stop:7415",
              "position": {
                "x": -3140.52,
                "z": -1255.542
              },
              "distanceAlongShapeM": 13990.561,
              "shapeOffsetM": 4.427,
              "arrivalOffsetSeconds": 3060,
              "departureOffsetSeconds": 3060
            },
            {
              "stopId": "judu:stop:5643",
              "position": {
                "x": -3680.758,
                "z": -1067.996
              },
              "distanceAlongShapeM": 14622.121,
              "shapeOffsetM": 3.566,
              "arrivalOffsetSeconds": 3240,
              "departureOffsetSeconds": 3240
            },
            {
              "stopId": "judu:stop:5646",
              "position": {
                "x": -3761.526,
                "z": -818.346
              },
              "distanceAlongShapeM": 14884.578,
              "shapeOffsetM": 3.383,
              "arrivalOffsetSeconds": 3300,
              "departureOffsetSeconds": 3300
            },
            {
              "stopId": "judu:stop:5915",
              "position": {
                "x": -4126.033,
                "z": -420.177
              },
              "distanceAlongShapeM": 15518.52,
              "shapeOffsetM": 6.77,
              "arrivalOffsetSeconds": 3420,
              "departureOffsetSeconds": 3420
            },
            {
              "stopId": "judu:stop:5919",
              "position": {
                "x": -4449.727,
                "z": -45.007
              },
              "distanceAlongShapeM": 16018.102,
              "shapeOffsetM": 5.516,
              "arrivalOffsetSeconds": 3540,
              "departureOffsetSeconds": 3540
            },
            {
              "stopId": "judu:stop:5920",
              "position": {
                "x": -4608.183,
                "z": 266.076
              },
              "distanceAlongShapeM": 16365.927,
              "shapeOffsetM": 6.252,
              "arrivalOffsetSeconds": 3600,
              "departureOffsetSeconds": 3600
            },
            {
              "stopId": "judu:stop:5923",
              "position": {
                "x": -4663.089,
                "z": 486.32
              },
              "distanceAlongShapeM": 16592.185,
              "shapeOffsetM": 3.409,
              "arrivalOffsetSeconds": 3660,
              "departureOffsetSeconds": 3660
            }
          ],
          "departuresSeconds": [
            40560,
            42060,
            43080,
            44040,
            44820,
            45420,
            46380,
            47460,
            48720,
            50220,
            51120,
            52320,
            53220,
            54660,
            55860,
            57120,
            58020,
            58920,
            59940,
            61320,
            62100,
            63660,
            64920,
            66300,
            67200,
            68100,
            69060,
            70920,
            72600,
            74220
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_trol_4",
      "sourceRouteId": "vilnius_trol_4",
      "mode": "trolleybus",
      "shortName": "4",
      "longName": "Antakalnis–Centras–Žemieji Paneriai",
      "color": "DC3131",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_trol_4:0",
          "sourceRouteId": "vilnius_trol_4",
          "sourceShapeId": "vilnius_trol_4_a-b",
          "directionId": 0,
          "headsign": "Žemieji Paneriai",
          "directionName": "Antakalnis–Centras–Žemieji Paneriai",
          "mode": "trolleybus",
          "routeShortName": "4",
          "routeLongName": "Antakalnis–Centras–Žemieji Paneriai",
          "routeColor": "DC3131",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              2550.54,
              -3888.998,
              0
            ],
            [
              2499.38,
              -3984.027,
              107.925
            ],
            [
              2493.87,
              -3987.392,
              114.381
            ],
            [
              2480.707,
              -3991.548,
              128.185
            ],
            [
              2470.701,
              -3991,
              138.206
            ],
            [
              2459.88,
              -3985.473,
              150.357
            ],
            [
              2450.261,
              -3972.454,
              166.544
            ],
            [
              2446.334,
              -3960.766,
              178.874
            ],
            [
              2458.099,
              -3917.57,
              223.643
            ],
            [
              2495.249,
              -3757.959,
              387.521
            ],
            [
              2503.087,
              -3718.029,
              428.213
            ],
            [
              2508.663,
              -3661.358,
              485.157
            ],
            [
              2467.501,
              -3518.217,
              634.1
            ],
            [
              2463.864,
              -3499.82,
              652.852
            ],
            [
              2434.339,
              -3309.248,
              845.698
            ],
            [
              2430.841,
              -3283.862,
              871.324
            ],
            [
              2426.976,
              -3256.769,
              898.691
            ],
            [
              2373.189,
              -2912.935,
              1246.707
            ],
            [
              2328.687,
              -2639.354,
              1523.883
            ],
            [
              2308.053,
              -2536.548,
              1628.74
            ],
            [
              2300.116,
              -2511.178,
              1655.322
            ],
            [
              2295.002,
              -2476.188,
              1690.684
            ],
            [
              2274.24,
              -2414.57,
              1755.706
            ],
            [
              2234.812,
              -2316.979,
              1860.961
            ],
            [
              2177.257,
              -2188.992,
              2001.293
            ],
            [
              2082.177,
              -1964.565,
              2245.03
            ],
            [
              2063.994,
              -1895.874,
              2316.086
            ],
            [
              2052.283,
              -1842.34,
              2370.887
            ],
            [
              2048.593,
              -1825.761,
              2387.871
            ],
            [
              2041.617,
              -1789.027,
              2425.262
            ],
            [
              1994.191,
              -1532.095,
              2686.535
            ],
            [
              1989.006,
              -1510.962,
              2708.294
            ],
            [
              1983.619,
              -1477.347,
              2742.338
            ],
            [
              1966.491,
              -1323.401,
              2897.234
            ],
            [
              1951.301,
              -996.936,
              3224.053
            ],
            [
              1944.999,
              -954.515,
              3266.939
            ],
            [
              1926.174,
              -912.972,
              3312.549
            ],
            [
              1921.538,
              -904.629,
              3322.093
            ],
            [
              1905.301,
              -870.282,
              3360.084
            ],
            [
              1842.792,
              -798.983,
              3454.905
            ],
            [
              1722.529,
              -643.118,
              3651.773
            ],
            [
              1706.703,
              -627.239,
              3674.192
            ],
            [
              1656.515,
              -617.512,
              3725.314
            ],
            [
              1647.146,
              -604.98,
              3740.961
            ],
            [
              1647.435,
              -589.4,
              3756.544
            ],
            [
              1641.361,
              -569.249,
              3777.59
            ],
            [
              1626.241,
              -550.043,
              3802.034
            ],
            [
              1613.941,
              -537.088,
              3819.897
            ],
            [
              1227.773,
              -233.181,
              4311.309
            ],
            [
              1061.875,
              -125.757,
              4508.951
            ],
            [
              1042.305,
              -113.981,
              4531.79
            ],
            [
              992.552,
              -84.12,
              4589.817
            ],
            [
              920.398,
              -44.941,
              4671.921
            ],
            [
              797.689,
              -19.306,
              4797.279
            ],
            [
              670.384,
              1.958,
              4926.348
            ],
            [
              652.936,
              0.051,
              4943.9
            ],
            [
              630.873,
              -7.336,
              4967.167
            ],
            [
              602.561,
              -27.877,
              5002.146
            ],
            [
              564.962,
              -49.544,
              5045.541
            ],
            [
              476.44,
              -129.188,
              5164.618
            ],
            [
              402.286,
              -199.078,
              5266.517
            ],
            [
              346.776,
              -237.026,
              5333.758
            ],
            [
              291.552,
              -259.395,
              5393.34
            ],
            [
              265.664,
              -264.488,
              5419.725
            ],
            [
              119.684,
              -277.409,
              5566.275
            ],
            [
              35.151,
              -280.322,
              5650.859
            ],
            [
              -101.904,
              -298.979,
              5789.178
            ],
            [
              -140.054,
              -304.394,
              5827.71
            ],
            [
              -153.37,
              -311.158,
              5842.645
            ],
            [
              -191.836,
              -315.156,
              5881.318
            ],
            [
              -244.276,
              -326.45,
              5934.961
            ],
            [
              -305.298,
              -348.72,
              5999.92
            ],
            [
              -413.017,
              -421.354,
              6129.839
            ],
            [
              -450.326,
              -380.602,
              6185.09
            ],
            [
              -465.596,
              -369.193,
              6204.152
            ],
            [
              -470.512,
              -355.745,
              6218.47
            ],
            [
              -508.466,
              -314.982,
              6274.167
            ],
            [
              -611.52,
              -58.189,
              6550.867
            ],
            [
              -614.075,
              -53.155,
              6556.512
            ],
            [
              -625.745,
              -24.535,
              6587.42
            ],
            [
              -643.846,
              18.014,
              6633.659
            ],
            [
              -652.524,
              63.893,
              6680.351
            ],
            [
              -682.331,
              234.755,
              6853.794
            ],
            [
              -830.115,
              444.481,
              7110.358
            ],
            [
              -843.054,
              478.111,
              7146.391
            ],
            [
              -829.673,
              683.817,
              7352.532
            ],
            [
              -833.364,
              729.525,
              7398.389
            ],
            [
              -839.916,
              759.701,
              7429.268
            ],
            [
              -842.83,
              772.274,
              7442.174
            ],
            [
              -845.743,
              794.315,
              7464.407
            ],
            [
              -856.909,
              819.008,
              7491.507
            ],
            [
              -958.695,
              862.029,
              7602.011
            ],
            [
              -1094.5,
              914.565,
              7747.624
            ],
            [
              -1148.512,
              960.063,
              7818.245
            ],
            [
              -1166.61,
              973.416,
              7840.736
            ],
            [
              -1183.42,
              991.86,
              7865.691
            ],
            [
              -1484.246,
              1267.759,
              8273.878
            ],
            [
              -1501.298,
              1275.764,
              8292.716
            ],
            [
              -1524.902,
              1302.995,
              8328.753
            ],
            [
              -1970.62,
              1705.012,
              8928.988
            ],
            [
              -1985.783,
              1723.093,
              8952.585
            ],
            [
              -2263.842,
              1978.495,
              9330.139
            ],
            [
              -2290.557,
              2000.118,
              9364.508
            ],
            [
              -2318.992,
              2034.018,
              9408.755
            ],
            [
              -2425.036,
              2130.514,
              9552.131
            ],
            [
              -2441.629,
              2140.826,
              9571.668
            ],
            [
              -2464.869,
              2140.123,
              9594.918
            ],
            [
              -2491.57,
              2126.123,
              9625.067
            ],
            [
              -2514.888,
              2120.968,
              9648.948
            ],
            [
              -2528.453,
              2120.094,
              9662.541
            ],
            [
              -2551.595,
              2124.955,
              9686.188
            ],
            [
              -2561.443,
              2130.364,
              9697.424
            ],
            [
              -2579.681,
              2142.148,
              9719.138
            ],
            [
              -2585.368,
              2148.928,
              9727.987
            ],
            [
              -2589.062,
              2159.012,
              9738.726
            ],
            [
              -2606.026,
              2184.914,
              9769.689
            ],
            [
              -2610.155,
              2197.282,
              9782.728
            ],
            [
              -2613.804,
              2219.561,
              9805.304
            ],
            [
              -2613.4,
              2232.891,
              9818.64
            ],
            [
              -2610.452,
              2250.329,
              9836.325
            ],
            [
              -2605.925,
              2263.95,
              9850.679
            ],
            [
              -2595.8,
              2280.361,
              9869.962
            ],
            [
              -2588.136,
              2284.788,
              9878.813
            ],
            [
              -2577.558,
              2305.756,
              9902.298
            ],
            [
              -2591.532,
              2385.037,
              9982.801
            ],
            [
              -2598.371,
              2436.365,
              10034.582
            ],
            [
              -2602.959,
              2542.201,
              10140.518
            ],
            [
              -2606.316,
              2602.394,
              10200.804
            ],
            [
              -2619.569,
              2661.607,
              10261.482
            ],
            [
              -2672.012,
              2798.342,
              10407.929
            ],
            [
              -2693.846,
              2841.028,
              10455.875
            ],
            [
              -2698.439,
              2873.392,
              10488.563
            ],
            [
              -2831.804,
              3253.114,
              10891.025
            ],
            [
              -2853.662,
              3294.686,
              10937.993
            ],
            [
              -2869.962,
              3320.622,
              10968.626
            ],
            [
              -2887.849,
              3332.714,
              10990.217
            ],
            [
              -2904.222,
              3355.687,
              11018.427
            ],
            [
              -3126.24,
              3576.651,
              11331.663
            ],
            [
              -3256.351,
              3702.491,
              11512.673
            ],
            [
              -3334.924,
              3786.24,
              11627.51
            ],
            [
              -3406.008,
              3855.385,
              11726.677
            ],
            [
              -3427.01,
              3872.449,
              11753.737
            ],
            [
              -3454.8,
              3907.442,
              11798.423
            ],
            [
              -3626.746,
              4078.528,
              12040.984
            ],
            [
              -3781.512,
              4235.95,
              12261.742
            ],
            [
              -3884.317,
              4337.92,
              12406.541
            ],
            [
              -3915.514,
              4362.95,
              12446.538
            ],
            [
              -3928.112,
              4380.98,
              12468.533
            ],
            [
              -4226.292,
              4683.356,
              12893.201
            ],
            [
              -4305.622,
              4762.647,
              13005.363
            ],
            [
              -4338.114,
              4787.696,
              13046.389
            ],
            [
              -4349.425,
              4805.702,
              13067.653
            ],
            [
              -4420.502,
              4877.057,
              13168.368
            ],
            [
              -4439.501,
              4898.534,
              13197.042
            ],
            [
              -4461.157,
              4915.604,
              13224.617
            ],
            [
              -4476.532,
              4922.548,
              13241.488
            ],
            [
              -4485.887,
              4927.855,
              13252.243
            ],
            [
              -4508.363,
              4948.698,
              13282.896
            ],
            [
              -4600.366,
              5004.825,
              13390.668
            ],
            [
              -4658.205,
              5020.288,
              13450.538
            ],
            [
              -4736.87,
              5026.089,
              13529.417
            ],
            [
              -4780.797,
              5023.521,
              13573.419
            ],
            [
              -4794.293,
              5028.186,
              13587.698
            ],
            [
              -4826.695,
              5058.796,
              13632.272
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:1017",
              "position": {
                "x": 2551.422,
                "z": -3889.265
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 0.921,
              "arrivalOffsetSeconds": -420,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:5118",
              "position": {
                "x": 2463.001,
                "z": -3519.117
              },
              "distanceAlongShapeM": 634.1,
              "shapeOffsetM": 4.589,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:5119",
              "position": {
                "x": 2425.512,
                "z": -3284.63
              },
              "distanceAlongShapeM": 871.29,
              "shapeOffsetM": 5.384,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:5096",
              "position": {
                "x": 2296.913,
                "z": -2511.848
              },
              "distanceAlongShapeM": 1655.322,
              "shapeOffsetM": 3.272,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:5818",
              "position": {
                "x": 2043.488,
                "z": -1826.913
              },
              "distanceAlongShapeM": 2387.856,
              "shapeOffsetM": 5.233,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:5819",
              "position": {
                "x": 1983.608,
                "z": -1511.859
              },
              "distanceAlongShapeM": 2708.294,
              "shapeOffsetM": 5.471,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:5820",
              "position": {
                "x": 1921.875,
                "z": -915.121
              },
              "distanceAlongShapeM": 3312.758,
              "shapeOffsetM": 4.802,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:5768",
              "position": {
                "x": 1608.96,
                "z": -543.043
              },
              "distanceAlongShapeM": 3819.009,
              "shapeOffsetM": 7.713,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:5771",
              "position": {
                "x": 1060.09,
                "z": -128.781
              },
              "distanceAlongShapeM": 4508.805,
              "shapeOffsetM": 3.508,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            },
            {
              "stopId": "judu:stop:848",
              "position": {
                "x": 604.636,
                "z": -31.346
              },
              "distanceAlongShapeM": 5002.146,
              "shapeOffsetM": 4.042,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:5249",
              "position": {
                "x": -153.095,
                "z": -312.52
              },
              "distanceAlongShapeM": 5842.645,
              "shapeOffsetM": 1.39,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:5257",
              "position": {
                "x": -465.596,
                "z": -369.193
              },
              "distanceAlongShapeM": 6204.152,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1380,
              "departureOffsetSeconds": 1380
            },
            {
              "stopId": "judu:stop:5264",
              "position": {
                "x": -646.921,
                "z": 17.037
              },
              "distanceAlongShapeM": 6633.659,
              "shapeOffsetM": 3.227,
              "arrivalOffsetSeconds": 1560,
              "departureOffsetSeconds": 1560
            },
            {
              "stopId": "judu:stop:683",
              "position": {
                "x": -844.854,
                "z": 772.035
              },
              "distanceAlongShapeM": 7442.202,
              "shapeOffsetM": 2.038,
              "arrivalOffsetSeconds": 1740,
              "departureOffsetSeconds": 1740
            },
            {
              "stopId": "judu:stop:5579",
              "position": {
                "x": -1168.303,
                "z": 971.551
              },
              "distanceAlongShapeM": 7840.736,
              "shapeOffsetM": 2.518,
              "arrivalOffsetSeconds": 1860,
              "departureOffsetSeconds": 1860
            },
            {
              "stopId": "judu:stop:6343",
              "position": {
                "x": -1502.183,
                "z": 1274.758
              },
              "distanceAlongShapeM": 8292.716,
              "shapeOffsetM": 1.34,
              "arrivalOffsetSeconds": 1980,
              "departureOffsetSeconds": 1980
            },
            {
              "stopId": "judu:stop:7852",
              "position": {
                "x": -1970.62,
                "z": 1705.012
              },
              "distanceAlongShapeM": 8928.988,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2100,
              "departureOffsetSeconds": 2100
            },
            {
              "stopId": "judu:stop:5532",
              "position": {
                "x": -2290.557,
                "z": 2000.118
              },
              "distanceAlongShapeM": 9364.508,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2220,
              "departureOffsetSeconds": 2220
            },
            {
              "stopId": "judu:stop:5543",
              "position": {
                "x": -2693.846,
                "z": 2841.028
              },
              "distanceAlongShapeM": 10455.875,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2460,
              "departureOffsetSeconds": 2460
            },
            {
              "stopId": "judu:stop:5573",
              "position": {
                "x": -2888.502,
                "z": 3332.034
              },
              "distanceAlongShapeM": 10990.217,
              "shapeOffsetM": 0.943,
              "arrivalOffsetSeconds": 2580,
              "departureOffsetSeconds": 2580
            },
            {
              "stopId": "judu:stop:5587",
              "position": {
                "x": -3427.01,
                "z": 3872.449
              },
              "distanceAlongShapeM": 11753.737,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2700,
              "departureOffsetSeconds": 2700
            },
            {
              "stopId": "judu:stop:5588",
              "position": {
                "x": -3915.514,
                "z": 4362.95
              },
              "distanceAlongShapeM": 12446.538,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2760,
              "departureOffsetSeconds": 2760
            },
            {
              "stopId": "judu:stop:5554",
              "position": {
                "x": -4338.114,
                "z": 4787.696
              },
              "distanceAlongShapeM": 13046.389,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2880,
              "departureOffsetSeconds": 2880
            },
            {
              "stopId": "judu:stop:5567",
              "position": {
                "x": -4488.111,
                "z": 4924.973
              },
              "distanceAlongShapeM": 13252.243,
              "shapeOffsetM": 3.641,
              "arrivalOffsetSeconds": 2940,
              "departureOffsetSeconds": 2940
            },
            {
              "stopId": "judu:stop:1076",
              "position": {
                "x": -4826.695,
                "z": 5058.796
              },
              "distanceAlongShapeM": 13632.272,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 3000,
              "departureOffsetSeconds": 3000
            }
          ],
          "departuresSeconds": [
            18060,
            19200,
            20340,
            21180,
            22260,
            22980,
            23700,
            24480,
            25200,
            25800,
            26460,
            27060,
            27780,
            28620,
            29760,
            30900,
            32040,
            33060,
            33780,
            34560,
            35280,
            35880,
            37080,
            38280,
            39000,
            39720,
            40740,
            41640,
            42840,
            43920,
            44940,
            45780,
            46680,
            47580,
            48360,
            49440,
            50580,
            51900,
            52860,
            53820,
            54780,
            55560,
            56220,
            56760,
            57540,
            58020,
            58920,
            59520,
            60180,
            61140,
            62220,
            63300,
            64320,
            65520,
            66780,
            68100,
            68940,
            69720,
            70500,
            71400,
            72480,
            73560,
            74640,
            75540,
            76440,
            77280,
            78180,
            79020,
            79800,
            80520,
            81720
          ]
        },
        {
          "id": "judu:pattern:vilnius_trol_4:1",
          "sourceRouteId": "vilnius_trol_4",
          "sourceShapeId": "vilnius_trol_4_b-a",
          "directionId": 1,
          "headsign": "Antakalnis",
          "directionName": "Žemieji Paneriai–Centras–Antakalnis",
          "mode": "trolleybus",
          "routeShortName": "4",
          "routeLongName": "Antakalnis–Centras–Žemieji Paneriai",
          "routeColor": "DC3131",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              -4826.663,
              5058.868,
              0
            ],
            [
              -4834.705,
              5081.197,
              23.733
            ],
            [
              -4785.441,
              5130.448,
              93.393
            ],
            [
              -4754.629,
              5157.75,
              134.561
            ],
            [
              -4724.691,
              5171.709,
              167.593
            ],
            [
              -4669.049,
              5178.483,
              223.646
            ],
            [
              -4632.924,
              5176.815,
              259.81
            ],
            [
              -4600.447,
              5171.052,
              292.794
            ],
            [
              -4586.132,
              5157.088,
              312.792
            ],
            [
              -4583.042,
              5111.394,
              358.59
            ],
            [
              -4580.889,
              5011.17,
              458.838
            ],
            [
              -4518.9,
              4977.81,
              529.233
            ],
            [
              -4503.635,
              4960.862,
              552.042
            ],
            [
              -4444.377,
              4915.316,
              626.781
            ],
            [
              -4189.698,
              4671.592,
              979.291
            ],
            [
              -4167.195,
              4657.338,
              1005.928
            ],
            [
              -4146.524,
              4629.659,
              1040.474
            ],
            [
              -4048.773,
              4533.349,
              1177.699
            ],
            [
              -3823.59,
              4303.471,
              1499.493
            ],
            [
              -3802.623,
              4284.184,
              1527.982
            ],
            [
              -3780.952,
              4268.223,
              1554.896
            ],
            [
              -3768.394,
              4247.967,
              1578.729
            ],
            [
              -3367.467,
              3844.694,
              2147.387
            ],
            [
              -3344.636,
              3829.677,
              2174.714
            ],
            [
              -3315.43,
              3793.692,
              2221.06
            ],
            [
              -3282.402,
              3763.059,
              2266.107
            ],
            [
              -3142.94,
              3618.132,
              2467.237
            ],
            [
              -2996.449,
              3469.738,
              2675.757
            ],
            [
              -2905.063,
              3381.305,
              2802.925
            ],
            [
              -2851.864,
              3323.598,
              2881.412
            ],
            [
              -2827.523,
              3276.416,
              2934.503
            ],
            [
              -2808.656,
              3248.254,
              2968.401
            ],
            [
              -2806.545,
              3221.5,
              2995.238
            ],
            [
              -2772.86,
              3118.493,
              3103.613
            ],
            [
              -2707,
              2936.995,
              3296.691
            ],
            [
              -2660.341,
              2801.476,
              3440.017
            ],
            [
              -2637.179,
              2724.257,
              3520.635
            ],
            [
              -2612.218,
              2675.949,
              3575.011
            ],
            [
              -2609.483,
              2648.071,
              3603.022
            ],
            [
              -2584.513,
              2574.315,
              3680.891
            ],
            [
              -2570.531,
              2514.913,
              3741.916
            ],
            [
              -2558.338,
              2437.886,
              3819.902
            ],
            [
              -2547.004,
              2385.365,
              3873.632
            ],
            [
              -2539.07,
              2359.622,
              3900.57
            ],
            [
              -2526.132,
              2324.884,
              3937.639
            ],
            [
              -2519.194,
              2315.856,
              3949.025
            ],
            [
              -2487.744,
              2306.396,
              3981.867
            ],
            [
              -2471.111,
              2298.31,
              4000.361
            ],
            [
              -2454.576,
              2284.659,
              4021.803
            ],
            [
              -2442.556,
              2271.088,
              4039.932
            ],
            [
              -2433.47,
              2237.532,
              4074.696
            ],
            [
              -2435.723,
              2169.786,
              4142.48
            ],
            [
              -2432.837,
              2155.209,
              4157.34
            ],
            [
              -2421.673,
              2138.248,
              4177.645
            ],
            [
              -2405.237,
              2119.033,
              4202.931
            ],
            [
              -2339.12,
              2063.317,
              4289.393
            ],
            [
              -2328.352,
              2051.995,
              4305.018
            ],
            [
              -2314.582,
              2044.048,
              4320.916
            ],
            [
              -2298.509,
              2024.75,
              4346.031
            ],
            [
              -1944.941,
              1697.877,
              4827.546
            ],
            [
              -1869.698,
              1631.955,
              4927.582
            ],
            [
              -1860.469,
              1622.903,
              4940.509
            ],
            [
              -1769.084,
              1537.785,
              5065.394
            ],
            [
              -1704.495,
              1480.033,
              5152.038
            ],
            [
              -1688.349,
              1470.667,
              5170.703
            ],
            [
              -1678.973,
              1453.802,
              5189.999
            ],
            [
              -1503.095,
              1295.926,
              5426.342
            ],
            [
              -1429.356,
              1232.268,
              5523.758
            ],
            [
              -1409.124,
              1211.868,
              5552.489
            ],
            [
              -1353.311,
              1158.548,
              5629.678
            ],
            [
              -1207.93,
              1027.923,
              5825.122
            ],
            [
              -1189.5,
              1013.819,
              5848.33
            ],
            [
              -1173.062,
              993.901,
              5874.155
            ],
            [
              -1066.972,
              902.938,
              6013.902
            ],
            [
              -958.695,
              862.029,
              6129.65
            ],
            [
              -800.989,
              807.981,
              6296.36
            ],
            [
              -799.135,
              803.495,
              6301.214
            ],
            [
              -800.094,
              794.656,
              6310.105
            ],
            [
              -808.22,
              764.696,
              6341.148
            ],
            [
              -816.493,
              725.027,
              6381.67
            ],
            [
              -824.878,
              699.315,
              6408.715
            ],
            [
              -838.2,
              496.948,
              6611.52
            ],
            [
              -838.156,
              463.551,
              6644.917
            ],
            [
              -823.183,
              435.45,
              6676.758
            ],
            [
              -689.434,
              255.78,
              6900.745
            ],
            [
              -671.067,
              215.627,
              6944.899
            ],
            [
              -634.631,
              19.041,
              7144.833
            ],
            [
              -585.127,
              -96.516,
              7270.547
            ],
            [
              -572.146,
              -122.078,
              7299.217
            ],
            [
              -567.275,
              -143.594,
              7321.277
            ],
            [
              -513.161,
              -289.293,
              7476.701
            ],
            [
              -501.093,
              -299.53,
              7492.526
            ],
            [
              -461.426,
              -352.57,
              7558.758
            ],
            [
              -452.174,
              -363.943,
              7573.419
            ],
            [
              -413.017,
              -421.354,
              7642.912
            ],
            [
              -305.298,
              -348.72,
              7772.832
            ],
            [
              -203.339,
              -309.381,
              7882.117
            ],
            [
              -102.285,
              -284.5,
              7986.189
            ],
            [
              -49.535,
              -271.256,
              8040.576
            ],
            [
              -22.626,
              -265.911,
              8068.011
            ],
            [
              -0.545,
              -257.407,
              8091.673
            ],
            [
              58.367,
              -209.498,
              8167.606
            ],
            [
              82.464,
              -196.578,
              8194.948
            ],
            [
              94.753,
              -194.576,
              8207.399
            ],
            [
              102.687,
              -199.192,
              8216.578
            ],
            [
              115.784,
              -208.318,
              8232.541
            ],
            [
              119.974,
              -268.346,
              8292.715
            ],
            [
              241.125,
              -266.267,
              8413.884
            ],
            [
              291.552,
              -259.395,
              8464.777
            ],
            [
              357.234,
              -229.425,
              8536.973
            ],
            [
              436.36,
              -169.644,
              8636.143
            ],
            [
              541.549,
              -60.247,
              8787.908
            ],
            [
              557.019,
              -44.104,
              8810.266
            ],
            [
              589.799,
              -22.869,
              8849.324
            ],
            [
              630.571,
              1.522,
              8896.834
            ],
            [
              645.363,
              9.096,
              8913.453
            ],
            [
              675.04,
              9.665,
              8943.135
            ],
            [
              707.88,
              6.836,
              8976.097
            ],
            [
              925.597,
              -42.81,
              9199.402
            ],
            [
              1129.224,
              -156.774,
              9432.751
            ],
            [
              1141.634,
              -163.763,
              9446.994
            ],
            [
              1606.423,
              -519.681,
              10032.405
            ],
            [
              1614.903,
              -526.354,
              10043.196
            ],
            [
              1648.803,
              -550.462,
              10084.794
            ],
            [
              1657.142,
              -552.844,
              10093.467
            ],
            [
              1686.795,
              -553.394,
              10123.125
            ],
            [
              1704.118,
              -558.169,
              10141.094
            ],
            [
              1714.932,
              -566.163,
              10154.542
            ],
            [
              1727.769,
              -638.763,
              10228.268
            ],
            [
              1737.731,
              -657.873,
              10249.819
            ],
            [
              1757.197,
              -686.066,
              10284.079
            ],
            [
              1866.79,
              -826.148,
              10461.938
            ],
            [
              1905.301,
              -870.282,
              10520.512
            ],
            [
              1927.219,
              -905.201,
              10561.739
            ],
            [
              1944,
              -938.911,
              10599.395
            ],
            [
              1949.844,
              -971.304,
              10632.311
            ],
            [
              1955.317,
              -990.986,
              10652.74
            ],
            [
              1968.757,
              -1305.631,
              10967.672
            ],
            [
              1988.222,
              -1471.868,
              11135.045
            ],
            [
              2027.109,
              -1678.358,
              11345.164
            ],
            [
              2032.074,
              -1713.148,
              11380.307
            ],
            [
              2048.644,
              -1792.498,
              11461.369
            ],
            [
              2068.057,
              -1877.836,
              11548.887
            ],
            [
              2081.808,
              -1938.356,
              11610.949
            ],
            [
              2087.374,
              -1962.435,
              11635.663
            ],
            [
              2110.719,
              -2024.1,
              11701.599
            ],
            [
              2234.812,
              -2316.979,
              12019.683
            ],
            [
              2284.924,
              -2429.242,
              12142.623
            ],
            [
              2299.015,
              -2468.47,
              12184.305
            ],
            [
              2319.691,
              -2569.05,
              12286.988
            ],
            [
              2323.471,
              -2587.599,
              12305.918
            ],
            [
              2323.492,
              -2606.972,
              12325.291
            ],
            [
              2328.687,
              -2639.354,
              12358.087
            ],
            [
              2411.872,
              -3118.499,
              12844.4
            ],
            [
              2415.738,
              -3139.252,
              12865.509
            ],
            [
              2418.768,
              -3163.158,
              12889.607
            ],
            [
              2474.472,
              -3526.012,
              13256.712
            ],
            [
              2513.109,
              -3664.781,
              13400.759
            ],
            [
              2520.474,
              -3683.355,
              13420.74
            ],
            [
              2542.483,
              -3747.714,
              13488.758
            ],
            [
              2553.555,
              -3775.753,
              13518.904
            ],
            [
              2558.505,
              -3824.161,
              13567.565
            ],
            [
              2550.54,
              -3888.998,
              13632.889
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:1076",
              "position": {
                "x": -4826.695,
                "z": 5058.796
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 0.079,
              "arrivalOffsetSeconds": -420,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:5594",
              "position": {
                "x": -4669.05,
                "z": 5178.548
              },
              "distanceAlongShapeM": 223.646,
              "shapeOffsetM": 0.065,
              "arrivalOffsetSeconds": 60,
              "departureOffsetSeconds": 60
            },
            {
              "stopId": "judu:stop:6850",
              "position": {
                "x": -4517.509,
                "z": 4980.025
              },
              "distanceAlongShapeM": 529.233,
              "shapeOffsetM": 2.616,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:6851",
              "position": {
                "x": -4166.695,
                "z": 4657.837
              },
              "distanceAlongShapeM": 1005.928,
              "shapeOffsetM": 0.707,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:5546",
              "position": {
                "x": -3780.952,
                "z": 4268.223
              },
              "distanceAlongShapeM": 1554.896,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:9384",
              "position": {
                "x": -3344.49,
                "z": 3829.822
              },
              "distanceAlongShapeM": 2174.714,
              "shapeOffsetM": 0.206,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:857",
              "position": {
                "x": -2808.656,
                "z": 3248.254
              },
              "distanceAlongShapeM": 2968.401,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:5542",
              "position": {
                "x": -2612.218,
                "z": 2675.949
              },
              "distanceAlongShapeM": 3575.011,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:5535",
              "position": {
                "x": -2313.635,
                "z": 2045.055
              },
              "distanceAlongShapeM": 4320.916,
              "shapeOffsetM": 1.383,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:7853",
              "position": {
                "x": -1868.675,
                "z": 1633.068
              },
              "distanceAlongShapeM": 4927.582,
              "shapeOffsetM": 1.512,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            },
            {
              "stopId": "judu:stop:6842",
              "position": {
                "x": -1427.428,
                "z": 1234.46
              },
              "distanceAlongShapeM": 5523.758,
              "shapeOffsetM": 2.919,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:5580",
              "position": {
                "x": -1188.159,
                "z": 1015.323
              },
              "distanceAlongShapeM": 5848.33,
              "shapeOffsetM": 2.015,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:5267",
              "position": {
                "x": -810.251,
                "z": 723.543
              },
              "distanceAlongShapeM": 6381.67,
              "shapeOffsetM": 6.416,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            },
            {
              "stopId": "judu:stop:6736",
              "position": {
                "x": -570.097,
                "z": -121.279
              },
              "distanceAlongShapeM": 7299.217,
              "shapeOffsetM": 2.199,
              "arrivalOffsetSeconds": 1500,
              "departureOffsetSeconds": 1500
            },
            {
              "stopId": "judu:stop:5258",
              "position": {
                "x": -449.339,
                "z": -361.695
              },
              "distanceAlongShapeM": 7573.419,
              "shapeOffsetM": 3.618,
              "arrivalOffsetSeconds": 1560,
              "departureOffsetSeconds": 1560
            },
            {
              "stopId": "judu:stop:5248",
              "position": {
                "x": -50.388,
                "z": -267.632
              },
              "distanceAlongShapeM": 8040.576,
              "shapeOffsetM": 3.723,
              "arrivalOffsetSeconds": 1680,
              "departureOffsetSeconds": 1680
            },
            {
              "stopId": "judu:stop:7278",
              "position": {
                "x": 707.88,
                "z": 6.836
              },
              "distanceAlongShapeM": 8976.097,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1980,
              "departureOffsetSeconds": 1980
            },
            {
              "stopId": "judu:stop:6573",
              "position": {
                "x": 1143.99,
                "z": -160.386
              },
              "distanceAlongShapeM": 9446.994,
              "shapeOffsetM": 4.117,
              "arrivalOffsetSeconds": 2100,
              "departureOffsetSeconds": 2100
            },
            {
              "stopId": "judu:stop:5770",
              "position": {
                "x": 1610.786,
                "z": -514.132
              },
              "distanceAlongShapeM": 10032.405,
              "shapeOffsetM": 7.059,
              "arrivalOffsetSeconds": 2160,
              "departureOffsetSeconds": 2160
            },
            {
              "stopId": "judu:stop:5826",
              "position": {
                "x": 1961.738,
                "z": -990.451
              },
              "distanceAlongShapeM": 10652.74,
              "shapeOffsetM": 6.443,
              "arrivalOffsetSeconds": 2340,
              "departureOffsetSeconds": 2340
            },
            {
              "stopId": "judu:stop:6702",
              "position": {
                "x": 2032.094,
                "z": -1677.525
              },
              "distanceAlongShapeM": 11345.164,
              "shapeOffsetM": 5.054,
              "arrivalOffsetSeconds": 2400,
              "departureOffsetSeconds": 2400
            },
            {
              "stopId": "judu:stop:5092",
              "position": {
                "x": 2087.852,
                "z": -1936.84
              },
              "distanceAlongShapeM": 11610.81,
              "shapeOffsetM": 6.23,
              "arrivalOffsetSeconds": 2520,
              "departureOffsetSeconds": 2520
            },
            {
              "stopId": "judu:stop:5095",
              "position": {
                "x": 2327.089,
                "z": -2587.001
              },
              "distanceAlongShapeM": 12305.918,
              "shapeOffsetM": 3.667,
              "arrivalOffsetSeconds": 2640,
              "departureOffsetSeconds": 2640
            },
            {
              "stopId": "judu:stop:1035",
              "position": {
                "x": 2419.872,
                "z": -3138.687
              },
              "distanceAlongShapeM": 12865.509,
              "shapeOffsetM": 4.173,
              "arrivalOffsetSeconds": 2760,
              "departureOffsetSeconds": 2760
            },
            {
              "stopId": "judu:stop:6711",
              "position": {
                "x": 2522.438,
                "z": -3682.768
              },
              "distanceAlongShapeM": 13420.82,
              "shapeOffsetM": 2.049,
              "arrivalOffsetSeconds": 2880,
              "departureOffsetSeconds": 2880
            },
            {
              "stopId": "judu:stop:1017",
              "position": {
                "x": 2551.422,
                "z": -3889.265
              },
              "distanceAlongShapeM": 13632.889,
              "shapeOffsetM": 0.921,
              "arrivalOffsetSeconds": 2880,
              "departureOffsetSeconds": 2880
            }
          ],
          "departuresSeconds": [
            18720,
            19860,
            21060,
            22140,
            23340,
            24540,
            25620,
            26400,
            27300,
            28200,
            28980,
            29580,
            30300,
            31080,
            31800,
            32580,
            33600,
            34620,
            35580,
            36480,
            37200,
            37980,
            38700,
            39180,
            40440,
            41580,
            42360,
            43140,
            44160,
            45060,
            46140,
            47280,
            48240,
            49140,
            50100,
            51180,
            52260,
            53220,
            54300,
            55320,
            56280,
            57240,
            58320,
            59160,
            60060,
            60900,
            61560,
            62220,
            63120,
            63720,
            64320,
            65100,
            66120,
            67140,
            68220,
            69240,
            70320,
            71460,
            72240,
            73020,
            73800,
            74700,
            75660,
            76620,
            77640,
            78600,
            79500,
            80280,
            81060,
            81840,
            82560,
            83280
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_trol_6",
      "sourceRouteId": "vilnius_trol_6",
      "mode": "trolleybus",
      "shortName": "6",
      "longName": "Žirmūnai–Kalvarijų–Tauro g.–Žemieji Paneriai (Apylanka be Reformatų st.)",
      "color": "DC3131",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_trol_6:0",
          "sourceRouteId": "vilnius_trol_6",
          "sourceShapeId": "vilnius_trol_6_a-b",
          "directionId": 0,
          "headsign": "Žemieji Paneriai (Apylanka be Reformatų st.)",
          "directionName": "Žirmūnai–Kalvarijų–Tauro g.–Žemieji Paneriai (Apylanka be Reformatų st.)",
          "mode": "trolleybus",
          "routeShortName": "6",
          "routeLongName": "Žirmūnai–Kalvarijų–Tauro g.–Žemieji Paneriai (Apylanka be Reformatų st.)",
          "routeColor": "DC3131",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              1017.506,
              -4299.224,
              0
            ],
            [
              1021.564,
              -4286.64,
              13.222
            ],
            [
              1026.249,
              -4282.222,
              19.661
            ],
            [
              1105.831,
              -4274.26,
              99.641
            ],
            [
              1128.035,
              -4270.234,
              122.207
            ],
            [
              1147.356,
              -4270.545,
              141.53
            ],
            [
              1189.631,
              -4265.192,
              184.142
            ],
            [
              1202.517,
              -4249.3,
              204.602
            ],
            [
              1214.522,
              -4227.257,
              229.702
            ],
            [
              1220.978,
              -4191.753,
              265.789
            ],
            [
              1217.195,
              -3943.429,
              514.141
            ],
            [
              1219.986,
              -3862.213,
              595.405
            ],
            [
              1375.611,
              -3774.922,
              773.84
            ],
            [
              1393.375,
              -3755.212,
              800.374
            ],
            [
              1412.221,
              -3746.656,
              821.071
            ],
            [
              1499.686,
              -3582.404,
              1007.159
            ],
            [
              1482.767,
              -3556.485,
              1038.112
            ],
            [
              1455.612,
              -3532.495,
              1074.346
            ],
            [
              1443.07,
              -3507.879,
              1101.973
            ],
            [
              1391.152,
              -3457.934,
              1174.014
            ],
            [
              1338.486,
              -3413.541,
              1242.894
            ],
            [
              1317.474,
              -3399.793,
              1268.004
            ],
            [
              978.337,
              -3198.709,
              1662.274
            ],
            [
              945.685,
              -3186.974,
              1696.971
            ],
            [
              931.778,
              -3172.246,
              1717.227
            ],
            [
              710.47,
              -3045.716,
              1972.153
            ],
            [
              680.065,
              -3035.6,
              2004.197
            ],
            [
              665.217,
              -3018.166,
              2027.097
            ],
            [
              641.604,
              -3005.487,
              2053.898
            ],
            [
              624.331,
              -2998.49,
              2072.535
            ],
            [
              521.572,
              -2978.793,
              2177.164
            ],
            [
              506.876,
              -2971.844,
              2193.421
            ],
            [
              504.844,
              -2912.819,
              2252.481
            ],
            [
              509.397,
              -2869.472,
              2296.066
            ],
            [
              513.301,
              -2797.183,
              2368.46
            ],
            [
              494.515,
              -2626.513,
              2540.161
            ],
            [
              487.991,
              -2601.316,
              2566.189
            ],
            [
              485.911,
              -2568.466,
              2599.105
            ],
            [
              462.343,
              -2342.047,
              2826.747
            ],
            [
              451.425,
              -2269.486,
              2900.125
            ],
            [
              407.333,
              -2116.119,
              3059.704
            ],
            [
              406.254,
              -2096.107,
              3079.745
            ],
            [
              361.405,
              -1904.922,
              3276.12
            ],
            [
              342.249,
              -1718.661,
              3463.364
            ],
            [
              326.222,
              -1640.218,
              3543.427
            ],
            [
              326.097,
              -1614.835,
              3568.811
            ],
            [
              277.22,
              -1255.479,
              3931.475
            ],
            [
              271.867,
              -1230.89,
              3956.64
            ],
            [
              269.371,
              -1219.076,
              3968.715
            ],
            [
              267.28,
              -1199.635,
              3988.268
            ],
            [
              257.056,
              -1141.194,
              4047.596
            ],
            [
              216.915,
              -885.896,
              4306.031
            ],
            [
              226.048,
              -703.492,
              4488.664
            ],
            [
              223.795,
              -685.64,
              4506.657
            ],
            [
              209.218,
              -636.391,
              4558.018
            ],
            [
              192.022,
              -589.321,
              4608.131
            ],
            [
              159.237,
              -513.023,
              4691.175
            ],
            [
              151.725,
              -500.641,
              4705.657
            ],
            [
              143.086,
              -479.332,
              4728.651
            ],
            [
              126.134,
              -439.133,
              4772.278
            ],
            [
              106.146,
              -277.163,
              4935.477
            ],
            [
              46.11,
              -280.522,
              4995.607
            ],
            [
              26.264,
              -279.764,
              5015.467
            ],
            [
              16.623,
              -264.894,
              5033.189
            ],
            [
              14.513,
              -253.218,
              5045.054
            ],
            [
              16.439,
              -245.471,
              5053.037
            ],
            [
              45.916,
              -220.403,
              5091.732
            ],
            [
              103.215,
              -190.277,
              5156.468
            ],
            [
              127.382,
              -102.772,
              5247.249
            ],
            [
              121.848,
              -52.576,
              5297.749
            ],
            [
              118.496,
              -36.512,
              5314.159
            ],
            [
              117.583,
              -3.516,
              5347.168
            ],
            [
              102.671,
              133.684,
              5485.176
            ],
            [
              63.181,
              125.497,
              5525.505
            ],
            [
              59.312,
              125.568,
              5529.375
            ],
            [
              57.419,
              127.829,
              5532.324
            ],
            [
              31.786,
              278.582,
              5685.241
            ],
            [
              4.856,
              358.112,
              5769.206
            ],
            [
              -8.924,
              380.627,
              5795.604
            ],
            [
              -39.768,
              422.378,
              5847.512
            ],
            [
              -46.8,
              425.846,
              5855.353
            ],
            [
              -55.202,
              424.885,
              5863.81
            ],
            [
              -86.677,
              396.514,
              5906.184
            ],
            [
              -98.36,
              381.073,
              5925.547
            ],
            [
              -216.06,
              268.617,
              6088.334
            ],
            [
              -407.853,
              148.526,
              6314.622
            ],
            [
              -402.875,
              316.534,
              6482.704
            ],
            [
              -399.691,
              349.873,
              6516.195
            ],
            [
              -379.219,
              381.017,
              6553.465
            ],
            [
              -261.81,
              448.677,
              6688.974
            ],
            [
              -291.826,
              642.924,
              6885.526
            ],
            [
              -330.752,
              844.011,
              7090.346
            ],
            [
              -575.219,
              737.113,
              7357.163
            ],
            [
              -620.102,
              729.911,
              7402.621
            ],
            [
              -799.94,
              794.603,
              7593.74
            ],
            [
              -810.157,
              800.354,
              7605.465
            ],
            [
              -958.695,
              862.029,
              7766.298
            ],
            [
              -1066.972,
              902.938,
              7882.046
            ],
            [
              -1103.368,
              923.63,
              7923.912
            ],
            [
              -1148.452,
              963.402,
              7984.032
            ],
            [
              -1166.61,
              973.416,
              8004.768
            ],
            [
              -1183.42,
              991.86,
              8029.724
            ],
            [
              -1484.246,
              1267.759,
              8437.91
            ],
            [
              -1501.298,
              1275.764,
              8456.748
            ],
            [
              -1524.902,
              1302.995,
              8492.785
            ],
            [
              -1970.62,
              1705.012,
              9093.02
            ],
            [
              -1985.783,
              1723.093,
              9116.618
            ],
            [
              -2263.842,
              1978.495,
              9494.172
            ],
            [
              -2290.557,
              2000.118,
              9528.541
            ],
            [
              -2318.992,
              2034.018,
              9572.787
            ],
            [
              -2425.036,
              2130.514,
              9716.164
            ],
            [
              -2441.629,
              2140.826,
              9735.7
            ],
            [
              -2464.869,
              2140.123,
              9758.951
            ],
            [
              -2491.57,
              2126.123,
              9789.099
            ],
            [
              -2514.888,
              2120.968,
              9812.981
            ],
            [
              -2528.453,
              2120.094,
              9826.574
            ],
            [
              -2551.595,
              2124.955,
              9850.221
            ],
            [
              -2561.443,
              2130.364,
              9861.457
            ],
            [
              -2579.681,
              2142.148,
              9883.17
            ],
            [
              -2585.368,
              2148.928,
              9892.019
            ],
            [
              -2589.062,
              2159.012,
              9902.759
            ],
            [
              -2606.026,
              2184.914,
              9933.721
            ],
            [
              -2610.155,
              2197.282,
              9946.761
            ],
            [
              -2613.804,
              2219.561,
              9969.336
            ],
            [
              -2613.4,
              2232.891,
              9982.673
            ],
            [
              -2610.452,
              2250.329,
              10000.358
            ],
            [
              -2605.925,
              2263.95,
              10014.711
            ],
            [
              -2595.8,
              2280.361,
              10033.994
            ],
            [
              -2588.136,
              2284.788,
              10042.845
            ],
            [
              -2577.558,
              2305.756,
              10066.33
            ],
            [
              -2591.532,
              2385.037,
              10146.833
            ],
            [
              -2598.371,
              2436.365,
              10198.615
            ],
            [
              -2602.959,
              2542.201,
              10304.55
            ],
            [
              -2606.316,
              2602.394,
              10364.836
            ],
            [
              -2619.569,
              2661.607,
              10425.515
            ],
            [
              -2672.012,
              2798.342,
              10571.962
            ],
            [
              -2693.846,
              2841.028,
              10619.908
            ],
            [
              -2698.439,
              2873.392,
              10652.596
            ],
            [
              -2831.804,
              3253.114,
              11055.057
            ],
            [
              -2853.662,
              3294.686,
              11102.025
            ],
            [
              -2869.962,
              3320.622,
              11132.658
            ],
            [
              -2887.849,
              3332.714,
              11154.249
            ],
            [
              -2904.222,
              3355.687,
              11182.459
            ],
            [
              -3126.24,
              3576.651,
              11495.696
            ],
            [
              -3256.351,
              3702.491,
              11676.706
            ],
            [
              -3334.924,
              3786.24,
              11791.543
            ],
            [
              -3406.008,
              3855.385,
              11890.709
            ],
            [
              -3427.01,
              3872.449,
              11917.77
            ],
            [
              -3454.8,
              3907.442,
              11962.455
            ],
            [
              -3626.746,
              4078.528,
              12205.016
            ],
            [
              -3781.512,
              4235.95,
              12425.774
            ],
            [
              -3884.317,
              4337.92,
              12570.573
            ],
            [
              -3915.514,
              4362.95,
              12610.57
            ],
            [
              -3928.112,
              4380.98,
              12632.566
            ],
            [
              -4226.292,
              4683.356,
              13057.233
            ],
            [
              -4305.622,
              4762.647,
              13169.395
            ],
            [
              -4338.114,
              4787.696,
              13210.422
            ],
            [
              -4349.425,
              4805.702,
              13231.686
            ],
            [
              -4420.502,
              4877.057,
              13332.401
            ],
            [
              -4439.501,
              4898.534,
              13361.075
            ],
            [
              -4461.157,
              4915.604,
              13388.65
            ],
            [
              -4476.532,
              4922.548,
              13405.52
            ],
            [
              -4485.887,
              4927.855,
              13416.276
            ],
            [
              -4508.363,
              4948.698,
              13446.928
            ],
            [
              -4600.366,
              5004.825,
              13554.7
            ],
            [
              -4658.205,
              5020.288,
              13614.571
            ],
            [
              -4736.87,
              5026.089,
              13693.449
            ],
            [
              -4780.797,
              5023.521,
              13737.451
            ],
            [
              -4794.293,
              5028.186,
              13751.731
            ],
            [
              -4826.695,
              5058.796,
              13796.305
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:5508",
              "position": {
                "x": 1128.033,
                "z": -4270.188
              },
              "distanceAlongShapeM": 122.207,
              "shapeOffsetM": 0.046,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:5149",
              "position": {
                "x": 1393.375,
                "z": -3755.212
              },
              "distanceAlongShapeM": 800.374,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:5125",
              "position": {
                "x": 1455.5,
                "z": -3532.601
              },
              "distanceAlongShapeM": 1074.346,
              "shapeOffsetM": 0.154,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:5127",
              "position": {
                "x": 945.685,
                "z": -3186.974
              },
              "distanceAlongShapeM": 1696.971,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:5128",
              "position": {
                "x": 679.709,
                "z": -3036.244
              },
              "distanceAlongShapeM": 2004.197,
              "shapeOffsetM": 0.735,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:5347",
              "position": {
                "x": 482.722,
                "z": -2601.805
              },
              "distanceAlongShapeM": 2566.189,
              "shapeOffsetM": 5.291,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:5351",
              "position": {
                "x": 407.176,
                "z": -2116.162
              },
              "distanceAlongShapeM": 3059.704,
              "shapeOffsetM": 0.163,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:5467",
              "position": {
                "x": 324.984,
                "z": -1640.419
              },
              "distanceAlongShapeM": 3543.427,
              "shapeOffsetM": 1.254,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            },
            {
              "stopId": "judu:stop:5378",
              "position": {
                "x": 265.625,
                "z": -1219.643
              },
              "distanceAlongShapeM": 3968.715,
              "shapeOffsetM": 3.789,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:5244",
              "position": {
                "x": 121.213,
                "z": -441.083
              },
              "distanceAlongShapeM": 4772.278,
              "shapeOffsetM": 5.293,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:5409",
              "position": {
                "x": 115.041,
                "z": -36.866
              },
              "distanceAlongShapeM": 5314.159,
              "shapeOffsetM": 3.473,
              "arrivalOffsetSeconds": 1500,
              "departureOffsetSeconds": 1500
            },
            {
              "stopId": "judu:stop:5334",
              "position": {
                "x": -97.297,
                "z": 380.009
              },
              "distanceAlongShapeM": 5925.547,
              "shapeOffsetM": 1.504,
              "arrivalOffsetSeconds": 1680,
              "departureOffsetSeconds": 1680
            },
            {
              "stopId": "judu:stop:5524",
              "position": {
                "x": -620.556,
                "z": 726.8
              },
              "distanceAlongShapeM": 7402.621,
              "shapeOffsetM": 3.143,
              "arrivalOffsetSeconds": 1980,
              "departureOffsetSeconds": 1980
            },
            {
              "stopId": "judu:stop:5579",
              "position": {
                "x": -1168.303,
                "z": 971.551
              },
              "distanceAlongShapeM": 8004.768,
              "shapeOffsetM": 2.518,
              "arrivalOffsetSeconds": 2160,
              "departureOffsetSeconds": 2160
            },
            {
              "stopId": "judu:stop:6343",
              "position": {
                "x": -1502.183,
                "z": 1274.758
              },
              "distanceAlongShapeM": 8456.748,
              "shapeOffsetM": 1.34,
              "arrivalOffsetSeconds": 2280,
              "departureOffsetSeconds": 2280
            },
            {
              "stopId": "judu:stop:7852",
              "position": {
                "x": -1970.62,
                "z": 1705.012
              },
              "distanceAlongShapeM": 9093.02,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2400,
              "departureOffsetSeconds": 2400
            },
            {
              "stopId": "judu:stop:5532",
              "position": {
                "x": -2290.557,
                "z": 2000.118
              },
              "distanceAlongShapeM": 9528.541,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2520,
              "departureOffsetSeconds": 2520
            },
            {
              "stopId": "judu:stop:5543",
              "position": {
                "x": -2693.846,
                "z": 2841.028
              },
              "distanceAlongShapeM": 10619.908,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2760,
              "departureOffsetSeconds": 2760
            },
            {
              "stopId": "judu:stop:5573",
              "position": {
                "x": -2888.502,
                "z": 3332.034
              },
              "distanceAlongShapeM": 11154.249,
              "shapeOffsetM": 0.943,
              "arrivalOffsetSeconds": 2880,
              "departureOffsetSeconds": 2880
            },
            {
              "stopId": "judu:stop:5587",
              "position": {
                "x": -3427.01,
                "z": 3872.449
              },
              "distanceAlongShapeM": 11917.77,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 3000,
              "departureOffsetSeconds": 3000
            },
            {
              "stopId": "judu:stop:5588",
              "position": {
                "x": -3915.514,
                "z": 4362.95
              },
              "distanceAlongShapeM": 12610.57,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 3060,
              "departureOffsetSeconds": 3060
            },
            {
              "stopId": "judu:stop:5554",
              "position": {
                "x": -4338.114,
                "z": 4787.696
              },
              "distanceAlongShapeM": 13210.422,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 3180,
              "departureOffsetSeconds": 3180
            },
            {
              "stopId": "judu:stop:5567",
              "position": {
                "x": -4488.111,
                "z": 4924.973
              },
              "distanceAlongShapeM": 13416.276,
              "shapeOffsetM": 3.641,
              "arrivalOffsetSeconds": 3240,
              "departureOffsetSeconds": 3240
            },
            {
              "stopId": "judu:stop:1076",
              "position": {
                "x": -4826.695,
                "z": 5058.796
              },
              "distanceAlongShapeM": 13796.305,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 3300,
              "departureOffsetSeconds": 3300
            }
          ],
          "departuresSeconds": [
            18240,
            18840,
            19680,
            20160,
            20640,
            21120,
            21600,
            22080,
            22560,
            23040,
            23580,
            24060,
            24540,
            25200,
            25920,
            26640,
            27360,
            27960,
            28500,
            29040,
            29700,
            30300,
            31320,
            32340,
            33300,
            34260,
            35220,
            36120,
            37020,
            37860,
            38880,
            39900,
            40800,
            41640,
            42540,
            43440,
            44340,
            45300,
            46320,
            47340,
            48300,
            49260,
            50160,
            51060,
            51960,
            52800,
            53220,
            53640,
            54060,
            54480,
            55020,
            55440,
            55920,
            56460,
            57000,
            57840,
            58740,
            59580,
            60420,
            61020,
            61620,
            62220,
            62820,
            63420,
            64020,
            64920,
            66060,
            67200,
            68340,
            69360,
            70320,
            71340,
            72420,
            73500,
            74340,
            75180,
            76080,
            76980,
            77880,
            78780,
            79680,
            80760
          ]
        },
        {
          "id": "judu:pattern:vilnius_trol_6:1",
          "sourceRouteId": "vilnius_trol_6",
          "sourceShapeId": "vilnius_trol_6_b-a",
          "directionId": 1,
          "headsign": "Žirmūnai (Apylanka be Reformatų st.)",
          "directionName": "Žemieji Paneriai–V. Kudirkos–Kalvarijų g.–Žirmūnai (Apylanka be Reformatų st.)",
          "mode": "trolleybus",
          "routeShortName": "6",
          "routeLongName": "Žirmūnai–Kalvarijų–Tauro g.–Žemieji Paneriai (Apylanka be Reformatų st.)",
          "routeColor": "DC3131",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              -4826.663,
              5058.868,
              0
            ],
            [
              -4834.705,
              5081.197,
              23.733
            ],
            [
              -4785.441,
              5130.448,
              93.393
            ],
            [
              -4754.629,
              5157.75,
              134.561
            ],
            [
              -4724.691,
              5171.709,
              167.593
            ],
            [
              -4669.049,
              5178.483,
              223.646
            ],
            [
              -4632.924,
              5176.815,
              259.81
            ],
            [
              -4600.447,
              5171.052,
              292.794
            ],
            [
              -4586.132,
              5157.088,
              312.792
            ],
            [
              -4583.042,
              5111.394,
              358.59
            ],
            [
              -4580.889,
              5011.17,
              458.838
            ],
            [
              -4518.9,
              4977.81,
              529.233
            ],
            [
              -4503.635,
              4960.862,
              552.042
            ],
            [
              -4444.377,
              4915.316,
              626.781
            ],
            [
              -4189.698,
              4671.592,
              979.291
            ],
            [
              -4167.195,
              4657.338,
              1005.928
            ],
            [
              -4146.524,
              4629.659,
              1040.474
            ],
            [
              -4048.773,
              4533.349,
              1177.699
            ],
            [
              -3823.59,
              4303.471,
              1499.493
            ],
            [
              -3802.623,
              4284.184,
              1527.982
            ],
            [
              -3780.952,
              4268.223,
              1554.896
            ],
            [
              -3768.394,
              4247.967,
              1578.729
            ],
            [
              -3367.467,
              3844.694,
              2147.387
            ],
            [
              -3344.636,
              3829.677,
              2174.714
            ],
            [
              -3315.43,
              3793.692,
              2221.06
            ],
            [
              -3282.402,
              3763.059,
              2266.107
            ],
            [
              -3142.94,
              3618.132,
              2467.237
            ],
            [
              -2996.449,
              3469.738,
              2675.757
            ],
            [
              -2905.063,
              3381.305,
              2802.925
            ],
            [
              -2851.864,
              3323.598,
              2881.412
            ],
            [
              -2827.523,
              3276.416,
              2934.503
            ],
            [
              -2808.656,
              3248.254,
              2968.401
            ],
            [
              -2806.545,
              3221.5,
              2995.238
            ],
            [
              -2772.86,
              3118.493,
              3103.613
            ],
            [
              -2707,
              2936.995,
              3296.691
            ],
            [
              -2660.341,
              2801.476,
              3440.017
            ],
            [
              -2637.179,
              2724.257,
              3520.635
            ],
            [
              -2612.218,
              2675.949,
              3575.011
            ],
            [
              -2609.483,
              2648.071,
              3603.022
            ],
            [
              -2584.513,
              2574.315,
              3680.891
            ],
            [
              -2570.531,
              2514.913,
              3741.916
            ],
            [
              -2558.338,
              2437.886,
              3819.902
            ],
            [
              -2547.004,
              2385.365,
              3873.632
            ],
            [
              -2539.07,
              2359.622,
              3900.57
            ],
            [
              -2526.132,
              2324.884,
              3937.639
            ],
            [
              -2519.194,
              2315.856,
              3949.025
            ],
            [
              -2487.744,
              2306.396,
              3981.867
            ],
            [
              -2471.111,
              2298.31,
              4000.361
            ],
            [
              -2454.576,
              2284.659,
              4021.803
            ],
            [
              -2442.556,
              2271.088,
              4039.932
            ],
            [
              -2433.47,
              2237.532,
              4074.696
            ],
            [
              -2435.723,
              2169.786,
              4142.48
            ],
            [
              -2432.837,
              2155.209,
              4157.34
            ],
            [
              -2421.673,
              2138.248,
              4177.645
            ],
            [
              -2405.237,
              2119.033,
              4202.931
            ],
            [
              -2339.12,
              2063.317,
              4289.393
            ],
            [
              -2328.352,
              2051.995,
              4305.018
            ],
            [
              -2314.582,
              2044.048,
              4320.916
            ],
            [
              -2298.509,
              2024.75,
              4346.031
            ],
            [
              -1944.941,
              1697.877,
              4827.546
            ],
            [
              -1869.698,
              1631.955,
              4927.582
            ],
            [
              -1860.469,
              1622.903,
              4940.509
            ],
            [
              -1769.084,
              1537.785,
              5065.394
            ],
            [
              -1704.495,
              1480.033,
              5152.038
            ],
            [
              -1688.349,
              1470.667,
              5170.703
            ],
            [
              -1678.973,
              1453.802,
              5189.999
            ],
            [
              -1503.095,
              1295.926,
              5426.342
            ],
            [
              -1429.356,
              1232.268,
              5523.758
            ],
            [
              -1409.124,
              1211.868,
              5552.489
            ],
            [
              -1353.311,
              1158.548,
              5629.678
            ],
            [
              -1207.93,
              1027.923,
              5825.122
            ],
            [
              -1189.5,
              1013.819,
              5848.33
            ],
            [
              -1173.062,
              993.901,
              5874.155
            ],
            [
              -1066.972,
              902.938,
              6013.902
            ],
            [
              -958.695,
              862.029,
              6129.65
            ],
            [
              -800.989,
              807.981,
              6296.36
            ],
            [
              -799.135,
              803.495,
              6301.214
            ],
            [
              -800.094,
              794.656,
              6310.105
            ],
            [
              -808.22,
              764.696,
              6341.148
            ],
            [
              -816.493,
              725.027,
              6381.67
            ],
            [
              -829.673,
              683.817,
              6424.936
            ],
            [
              -843.054,
              478.111,
              6631.077
            ],
            [
              -804.926,
              410.63,
              6708.585
            ],
            [
              -682.331,
              234.755,
              6922.971
            ],
            [
              -671.067,
              215.627,
              6945.169
            ],
            [
              -647.308,
              102.762,
              7060.508
            ],
            [
              -591.62,
              115.115,
              7117.55
            ],
            [
              -557.359,
              122.914,
              7152.687
            ],
            [
              -539.176,
              126.412,
              7171.203
            ],
            [
              -408.498,
              148.538,
              7303.741
            ],
            [
              -385.731,
              159.258,
              7328.906
            ],
            [
              -216.06,
              268.617,
              7530.766
            ],
            [
              -55.202,
              424.885,
              7755.032
            ],
            [
              -39.768,
              422.378,
              7770.668
            ],
            [
              15.61,
              348.039,
              7863.367
            ],
            [
              36.62,
              260.682,
              7953.215
            ],
            [
              56.855,
              132.292,
              8083.19
            ],
            [
              59.373,
              128.907,
              8087.408
            ],
            [
              70.978,
              128.695,
              8099.015
            ],
            [
              102.671,
              133.684,
              8131.099
            ],
            [
              112.53,
              93.98,
              8172.009
            ],
            [
              129.88,
              -107.271,
              8374.006
            ],
            [
              116.846,
              -256.206,
              8523.51
            ],
            [
              117.887,
              -305.208,
              8572.523
            ],
            [
              127.343,
              -387.845,
              8655.699
            ],
            [
              135.914,
              -423.248,
              8692.125
            ],
            [
              144.816,
              -445.964,
              8716.523
            ],
            [
              174.587,
              -519.993,
              8796.314
            ],
            [
              236.049,
              -695.879,
              8982.63
            ],
            [
              238.113,
              -713.732,
              9000.602
            ],
            [
              217.158,
              -872.542,
              9160.788
            ],
            [
              276.82,
              -1242.113,
              9535.144
            ],
            [
              294.15,
              -1318.635,
              9613.603
            ],
            [
              320.249,
              -1546.82,
              9843.276
            ],
            [
              342.249,
              -1718.661,
              10016.52
            ],
            [
              352.701,
              -1764.728,
              10063.758
            ],
            [
              354.758,
              -1810.175,
              10109.251
            ],
            [
              356.121,
              -1841.371,
              10140.477
            ],
            [
              372.957,
              -1942.984,
              10243.475
            ],
            [
              426.379,
              -2158.817,
              10465.822
            ],
            [
              439.077,
              -2195.331,
              10504.481
            ],
            [
              440.947,
              -2208.066,
              10517.352
            ],
            [
              462.343,
              -2342.047,
              10653.031
            ],
            [
              497.458,
              -2575.098,
              10888.712
            ],
            [
              511.756,
              -2776.003,
              11090.125
            ],
            [
              513.301,
              -2797.183,
              11111.362
            ],
            [
              524.563,
              -2850.825,
              11166.173
            ],
            [
              523.952,
              -2902.017,
              11217.369
            ],
            [
              521.193,
              -2964.305,
              11279.718
            ],
            [
              532.037,
              -2970.195,
              11292.058
            ],
            [
              600.884,
              -2980.955,
              11361.741
            ],
            [
              619.319,
              -2990.605,
              11382.549
            ],
            [
              631.438,
              -2997.507,
              11396.496
            ],
            [
              906.98,
              -3153.977,
              11713.365
            ],
            [
              1026.951,
              -3218.53,
              11849.601
            ],
            [
              1027.41,
              -3228.558,
              11859.639
            ],
            [
              1043.901,
              -3277.845,
              11911.612
            ],
            [
              1066.366,
              -3362.988,
              11999.668
            ],
            [
              1066.595,
              -3375.116,
              12011.799
            ],
            [
              1098.437,
              -3500.388,
              12141.054
            ],
            [
              1100.082,
              -3516.004,
              12156.757
            ],
            [
              1093.2,
              -3739.235,
              12380.094
            ],
            [
              1117.238,
              -3769.584,
              12418.809
            ],
            [
              1132.841,
              -3780.616,
              12437.918
            ],
            [
              1147.08,
              -3797.41,
              12459.936
            ],
            [
              1219.986,
              -3862.213,
              12557.479
            ],
            [
              1220.734,
              -4100.462,
              12795.73
            ],
            [
              1222.498,
              -4142.938,
              12838.242
            ],
            [
              1222.034,
              -4169.508,
              12864.816
            ],
            [
              1222.197,
              -4191.784,
              12887.092
            ],
            [
              1218.667,
              -4222.547,
              12918.057
            ],
            [
              1209.216,
              -4242.448,
              12940.089
            ],
            [
              1199.734,
              -4253.999,
              12955.034
            ],
            [
              1180.34,
              -4272.796,
              12982.042
            ],
            [
              1169.776,
              -4277.639,
              12993.663
            ],
            [
              1151.036,
              -4280.633,
              13012.641
            ],
            [
              1136.231,
              -4280.418,
              13027.447
            ],
            [
              1097.302,
              -4298.664,
              13070.44
            ],
            [
              1060.432,
              -4334.455,
              13121.824
            ],
            [
              1050.84,
              -4334.625,
              13131.418
            ],
            [
              1024.373,
              -4320.974,
              13161.198
            ],
            [
              1020.017,
              -4312.849,
              13170.417
            ],
            [
              1017.506,
              -4299.224,
              13184.272
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:1076",
              "position": {
                "x": -4826.695,
                "z": 5058.796
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 0.079,
              "arrivalOffsetSeconds": -480,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:5594",
              "position": {
                "x": -4669.05,
                "z": 5178.548
              },
              "distanceAlongShapeM": 223.646,
              "shapeOffsetM": 0.065,
              "arrivalOffsetSeconds": 60,
              "departureOffsetSeconds": 60
            },
            {
              "stopId": "judu:stop:6850",
              "position": {
                "x": -4517.509,
                "z": 4980.025
              },
              "distanceAlongShapeM": 529.233,
              "shapeOffsetM": 2.616,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:6851",
              "position": {
                "x": -4166.695,
                "z": 4657.837
              },
              "distanceAlongShapeM": 1005.928,
              "shapeOffsetM": 0.707,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:5546",
              "position": {
                "x": -3780.952,
                "z": 4268.223
              },
              "distanceAlongShapeM": 1554.896,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:9384",
              "position": {
                "x": -3344.49,
                "z": 3829.822
              },
              "distanceAlongShapeM": 2174.714,
              "shapeOffsetM": 0.206,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:857",
              "position": {
                "x": -2808.656,
                "z": 3248.254
              },
              "distanceAlongShapeM": 2968.401,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:5542",
              "position": {
                "x": -2612.218,
                "z": 2675.949
              },
              "distanceAlongShapeM": 3575.011,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:5535",
              "position": {
                "x": -2313.635,
                "z": 2045.055
              },
              "distanceAlongShapeM": 4320.916,
              "shapeOffsetM": 1.383,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:7853",
              "position": {
                "x": -1868.675,
                "z": 1633.068
              },
              "distanceAlongShapeM": 4927.582,
              "shapeOffsetM": 1.512,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            },
            {
              "stopId": "judu:stop:6842",
              "position": {
                "x": -1427.428,
                "z": 1234.46
              },
              "distanceAlongShapeM": 5523.758,
              "shapeOffsetM": 2.919,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:5580",
              "position": {
                "x": -1188.159,
                "z": 1015.323
              },
              "distanceAlongShapeM": 5848.33,
              "shapeOffsetM": 2.015,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:5267",
              "position": {
                "x": -810.251,
                "z": 723.543
              },
              "distanceAlongShapeM": 6381.67,
              "shapeOffsetM": 6.416,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            },
            {
              "stopId": "judu:stop:5332",
              "position": {
                "x": -557.893,
                "z": 125.637
              },
              "distanceAlongShapeM": 7152.687,
              "shapeOffsetM": 2.774,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            },
            {
              "stopId": "judu:stop:5459",
              "position": {
                "x": 18.234,
                "z": 348.963
              },
              "distanceAlongShapeM": 7863.367,
              "shapeOffsetM": 2.781,
              "arrivalOffsetSeconds": 1680,
              "departureOffsetSeconds": 1680
            },
            {
              "stopId": "judu:stop:5492",
              "position": {
                "x": 116.145,
                "z": 94.475
              },
              "distanceAlongShapeM": 8172.009,
              "shapeOffsetM": 3.649,
              "arrivalOffsetSeconds": 1740,
              "departureOffsetSeconds": 1740
            },
            {
              "stopId": "judu:stop:5245",
              "position": {
                "x": 150.182,
                "z": -443.837
              },
              "distanceAlongShapeM": 8716.552,
              "shapeOffsetM": 5.773,
              "arrivalOffsetSeconds": 1920,
              "departureOffsetSeconds": 1920
            },
            {
              "stopId": "judu:stop:6843",
              "position": {
                "x": 297.35,
                "z": -1318.188
              },
              "distanceAlongShapeM": 9613.603,
              "shapeOffsetM": 3.231,
              "arrivalOffsetSeconds": 2160,
              "departureOffsetSeconds": 2160
            },
            {
              "stopId": "judu:stop:6844",
              "position": {
                "x": 356.237,
                "z": -1764.56
              },
              "distanceAlongShapeM": 10063.758,
              "shapeOffsetM": 3.54,
              "arrivalOffsetSeconds": 2340,
              "departureOffsetSeconds": 2340
            },
            {
              "stopId": "judu:stop:6845",
              "position": {
                "x": 441.836,
                "z": -2194.724
              },
              "distanceAlongShapeM": 10504.481,
              "shapeOffsetM": 2.825,
              "arrivalOffsetSeconds": 2400,
              "departureOffsetSeconds": 2400
            },
            {
              "stopId": "judu:stop:5469",
              "position": {
                "x": 505.139,
                "z": -2574.385
              },
              "distanceAlongShapeM": 10888.712,
              "shapeOffsetM": 7.714,
              "arrivalOffsetSeconds": 2520,
              "departureOffsetSeconds": 2520
            },
            {
              "stopId": "judu:stop:6846",
              "position": {
                "x": 602.169,
                "z": -2976.932
              },
              "distanceAlongShapeM": 11361.741,
              "shapeOffsetM": 4.223,
              "arrivalOffsetSeconds": 2700,
              "departureOffsetSeconds": 2700
            },
            {
              "stopId": "judu:stop:6847",
              "position": {
                "x": 1066.821,
                "z": -3362.875
              },
              "distanceAlongShapeM": 11999.668,
              "shapeOffsetM": 0.469,
              "arrivalOffsetSeconds": 2880,
              "departureOffsetSeconds": 2880
            },
            {
              "stopId": "judu:stop:5147",
              "position": {
                "x": 1133.882,
                "z": -3779.354
              },
              "distanceAlongShapeM": 12437.918,
              "shapeOffsetM": 1.636,
              "arrivalOffsetSeconds": 2940,
              "departureOffsetSeconds": 2940
            },
            {
              "stopId": "judu:stop:6671",
              "position": {
                "x": 1228.325,
                "z": -4142.906
              },
              "distanceAlongShapeM": 12838.242,
              "shapeOffsetM": 5.827,
              "arrivalOffsetSeconds": 3060,
              "departureOffsetSeconds": 3060
            },
            {
              "stopId": "judu:stop:5505",
              "position": {
                "x": 1151.036,
                "z": -4280.633
              },
              "distanceAlongShapeM": 13012.641,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 3120,
              "departureOffsetSeconds": 3120
            }
          ],
          "departuresSeconds": [
            19800,
            20460,
            21360,
            22020,
            22980,
            23580,
            24120,
            24660,
            25200,
            25740,
            26220,
            26760,
            27360,
            27900,
            28500,
            29160,
            29880,
            30600,
            31320,
            31920,
            32520,
            33060,
            33660,
            34140,
            35100,
            36060,
            37020,
            37920,
            38820,
            39720,
            40620,
            41520,
            42480,
            43500,
            44460,
            45300,
            46140,
            47100,
            48000,
            48960,
            49980,
            51000,
            52080,
            53040,
            53820,
            54660,
            55620,
            56400,
            56880,
            57360,
            57960,
            58440,
            58980,
            59460,
            59940,
            60480,
            61020,
            61920,
            62880,
            63840,
            64620,
            66240,
            67500,
            69840,
            70920,
            72000,
            72960,
            73920,
            74880,
            75840,
            76860,
            77700,
            78600,
            79500,
            80400,
            81300,
            82260,
            83220
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_trol_7",
      "sourceRouteId": "vilnius_trol_7",
      "mode": "trolleybus",
      "shortName": "7",
      "longName": "Perkūnkiemis–Justiniškės–Žvėrynas–Stotis",
      "color": "DC3131",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_trol_7:0",
          "sourceRouteId": "vilnius_trol_7",
          "sourceShapeId": "vilnius_trol_7_a-b",
          "directionId": 0,
          "headsign": "Stotis",
          "directionName": "Perkūnkiemis–Justiniškės–Žvėrynas–Stotis",
          "mode": "trolleybus",
          "routeShortName": "7",
          "routeLongName": "Perkūnkiemis–Justiniškės–Žvėrynas–Stotis",
          "routeColor": "DC3131",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              -3921.595,
              -5098.093,
              0
            ],
            [
              -3918.942,
              -5093.687,
              5.143
            ],
            [
              -3911.137,
              -5089.369,
              14.063
            ],
            [
              -3868.616,
              -5091.681,
              56.646
            ],
            [
              -3868.597,
              -5091.579,
              56.751
            ],
            [
              -3866.626,
              -5087.439,
              61.336
            ],
            [
              -3858.762,
              -5078.034,
              73.595
            ],
            [
              -3853.286,
              -5069.798,
              83.486
            ],
            [
              -3845.592,
              -5061.565,
              94.754
            ],
            [
              -3838.726,
              -5037.193,
              120.075
            ],
            [
              -3828.914,
              -4880.4,
              277.175
            ],
            [
              -3839.647,
              -4756.647,
              401.392
            ],
            [
              -3856.989,
              -4679.534,
              480.431
            ],
            [
              -3893.073,
              -4568.698,
              596.993
            ],
            [
              -3919.183,
              -4476.961,
              692.373
            ],
            [
              -3925.083,
              -4445.689,
              724.197
            ],
            [
              -3932.868,
              -4417.028,
              753.896
            ],
            [
              -3934.344,
              -4385.414,
              785.545
            ],
            [
              -3933.945,
              -4325.308,
              845.652
            ],
            [
              -3923.556,
              -4246.45,
              925.192
            ],
            [
              -3859.131,
              -4078.116,
              1105.433
            ],
            [
              -3844.834,
              -4049.433,
              1137.481
            ],
            [
              -3724.705,
              -3815.753,
              1400.231
            ],
            [
              -3680.975,
              -3716.371,
              1508.809
            ],
            [
              -3652.775,
              -3644.457,
              1586.054
            ],
            [
              -3636.19,
              -3580.18,
              1652.437
            ],
            [
              -3630.111,
              -3520.538,
              1712.387
            ],
            [
              -3624.82,
              -3482.415,
              1750.876
            ],
            [
              -3626.214,
              -3414.484,
              1818.821
            ],
            [
              -3629.537,
              -3383.256,
              1850.226
            ],
            [
              -3641.883,
              -3315.135,
              1919.456
            ],
            [
              -3659.519,
              -3254.715,
              1982.398
            ],
            [
              -3681.569,
              -3188.651,
              2052.044
            ],
            [
              -3706.235,
              -3124.768,
              2120.524
            ],
            [
              -3736.941,
              -3062.562,
              2189.895
            ],
            [
              -3744.824,
              -3043.144,
              2210.853
            ],
            [
              -3749.61,
              -3024.938,
              2229.677
            ],
            [
              -3794.804,
              -2918.397,
              2345.408
            ],
            [
              -3982.054,
              -2455.389,
              2844.846
            ],
            [
              -3998.785,
              -2421.194,
              2882.915
            ],
            [
              -4007.392,
              -2392.61,
              2912.767
            ],
            [
              -4034.259,
              -2306.427,
              3003.04
            ],
            [
              -4048.116,
              -2250.527,
              3060.632
            ],
            [
              -4058.635,
              -2188.005,
              3124.033
            ],
            [
              -4065.192,
              -2119.986,
              3192.367
            ],
            [
              -4071.681,
              -2010.779,
              3301.767
            ],
            [
              -4069.66,
              -1968.512,
              3344.082
            ],
            [
              -4063.29,
              -1898.49,
              3414.393
            ],
            [
              -4045.411,
              -1837.599,
              3477.855
            ],
            [
              -4006.94,
              -1771.447,
              3554.38
            ],
            [
              -3981.93,
              -1741.824,
              3593.149
            ],
            [
              -3941.981,
              -1705.781,
              3646.954
            ],
            [
              -3883.226,
              -1663.385,
              3719.408
            ],
            [
              -3846.573,
              -1643.357,
              3761.176
            ],
            [
              -3813.541,
              -1631.763,
              3796.184
            ],
            [
              -3808.468,
              -1630.446,
              3801.426
            ],
            [
              -3761.37,
              -1625.426,
              3848.79
            ],
            [
              -3487.628,
              -1602.363,
              4123.502
            ],
            [
              -3508.003,
              -1550.799,
              4178.945
            ],
            [
              -3521.109,
              -1520.135,
              4212.293
            ],
            [
              -3534.455,
              -1477.979,
              4256.511
            ],
            [
              -3626.266,
              -1196.964,
              4552.144
            ],
            [
              -3643.222,
              -1150.713,
              4601.405
            ],
            [
              -3645.883,
              -1138.735,
              4613.675
            ],
            [
              -3642.486,
              -1128.776,
              4624.197
            ],
            [
              -3630.73,
              -1120.075,
              4638.823
            ],
            [
              -3599.031,
              -1113.947,
              4671.109
            ],
            [
              -3412.497,
              -1176.2,
              4867.757
            ],
            [
              -3355.367,
              -1190.556,
              4926.663
            ],
            [
              -3109.19,
              -1234.288,
              5176.694
            ],
            [
              -3070.013,
              -1242.306,
              5216.683
            ],
            [
              -2879.155,
              -1277.94,
              5410.839
            ],
            [
              -2839.273,
              -1283.094,
              5451.053
            ],
            [
              -2787.087,
              -1285.125,
              5503.278
            ],
            [
              -2748.376,
              -1283.58,
              5542.02
            ],
            [
              -2714.118,
              -1278.617,
              5576.636
            ],
            [
              -2670.7,
              -1266.023,
              5621.843
            ],
            [
              -2624.585,
              -1246.798,
              5671.805
            ],
            [
              -2499.949,
              -1183.085,
              5811.782
            ],
            [
              -2469.831,
              -1172.717,
              5843.634
            ],
            [
              -2418.716,
              -1162.489,
              5895.763
            ],
            [
              -2392.231,
              -1159.617,
              5922.403
            ],
            [
              -2246.137,
              -1174.448,
              6069.248
            ],
            [
              -2236.291,
              -1164.604,
              6083.171
            ],
            [
              -2207.813,
              -1158.429,
              6112.311
            ],
            [
              -2189.628,
              -1150.959,
              6131.97
            ],
            [
              -2165.314,
              -1131.49,
              6163.118
            ],
            [
              -2151.107,
              -1123.812,
              6179.267
            ],
            [
              -2142.708,
              -1122.847,
              6187.722
            ],
            [
              -2107.347,
              -1112.773,
              6224.49
            ],
            [
              -2052.076,
              -1102.191,
              6280.765
            ],
            [
              -1847.461,
              -1053.546,
              6491.083
            ],
            [
              -1839.367,
              -996.878,
              6548.325
            ],
            [
              -1838.607,
              -973.666,
              6571.55
            ],
            [
              -1831.662,
              -962.505,
              6584.695
            ],
            [
              -1768.396,
              -596.269,
              6956.356
            ],
            [
              -1770.394,
              -575.212,
              6977.507
            ],
            [
              -1761.137,
              -550.756,
              7003.657
            ],
            [
              -1691.384,
              -146.787,
              7413.604
            ],
            [
              -1684.831,
              -90.433,
              7470.338
            ],
            [
              -1682.437,
              -79.04,
              7481.979
            ],
            [
              -1669.697,
              -10.31,
              7551.88
            ],
            [
              -1661.707,
              -1.484,
              7563.786
            ],
            [
              -1388.974,
              -39.407,
              7839.142
            ],
            [
              -1361.685,
              -39.532,
              7866.432
            ],
            [
              -1329.577,
              -37.478,
              7898.606
            ],
            [
              -1190.447,
              -11.028,
              8040.227
            ],
            [
              -1025.306,
              27.195,
              8209.734
            ],
            [
              -994.12,
              39.993,
              8243.444
            ],
            [
              -950.273,
              44.262,
              8287.498
            ],
            [
              -919.958,
              39.772,
              8318.144
            ],
            [
              -857.805,
              53.124,
              8381.715
            ],
            [
              -724.996,
              86.353,
              8518.618
            ],
            [
              -591.62,
              115.115,
              8655.06
            ],
            [
              -557.359,
              122.914,
              8690.197
            ],
            [
              -539.176,
              126.412,
              8708.714
            ],
            [
              -408.498,
              148.538,
              8841.252
            ],
            [
              -385.731,
              159.258,
              8866.416
            ],
            [
              -216.06,
              268.617,
              9068.277
            ],
            [
              -50.385,
              441.496,
              9307.725
            ],
            [
              -51.307,
              497.175,
              9363.411
            ],
            [
              -54.16,
              522.615,
              9389.011
            ],
            [
              -44.593,
              547.148,
              9415.343
            ],
            [
              -34.25,
              619.32,
              9488.253
            ],
            [
              -34.886,
              726.201,
              9595.136
            ],
            [
              -29.964,
              784,
              9653.144
            ],
            [
              -28.88,
              804.74,
              9673.912
            ],
            [
              -24.076,
              823.969,
              9693.732
            ],
            [
              -6.94,
              914.942,
              9786.305
            ],
            [
              5.94,
              949.218,
              9822.921
            ],
            [
              14.89,
              980.225,
              9855.194
            ],
            [
              20.723,
              1007.284,
              9882.875
            ],
            [
              98.858,
              1127.869,
              10026.561
            ],
            [
              208.532,
              1302.485,
              10232.763
            ],
            [
              265.611,
              1357.493,
              10312.034
            ],
            [
              347.967,
              1416.104,
              10413.117
            ],
            [
              403.761,
              1468.519,
              10489.669
            ],
            [
              407.254,
              1474.663,
              10496.737
            ],
            [
              398.727,
              1481.949,
              10507.954
            ],
            [
              393.766,
              1486.188,
              10514.479
            ],
            [
              391.311,
              1493.238,
              10521.944
            ],
            [
              396.156,
              1548.878,
              10577.794
            ],
            [
              395.449,
              1569.043,
              10597.972
            ],
            [
              397.453,
              1582.184,
              10611.265
            ],
            [
              391.321,
              1670.242,
              10699.536
            ],
            [
              327.595,
              1819.466,
              10861.798
            ],
            [
              328.524,
              1835.034,
              10877.394
            ],
            [
              390.297,
              1931.87,
              10992.255
            ],
            [
              384.797,
              1948.669,
              11009.931
            ],
            [
              364.123,
              1982.443,
              11049.53
            ],
            [
              361.04,
              1990.292,
              11057.963
            ],
            [
              361.142,
              1995.857,
              11063.529
            ],
            [
              367.089,
              2003.541,
              11073.246
            ],
            [
              374.225,
              2005.637,
              11080.683
            ],
            [
              387.77,
              2005.389,
              11094.23
            ],
            [
              447.829,
              1973.12,
              11162.409
            ],
            [
              476.503,
              1958.043,
              11194.805
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:7603",
              "position": {
                "x": -3854.099,
                "z": -5069.209
              },
              "distanceAlongShapeM": 83.486,
              "shapeOffsetM": 1.003,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:687",
              "position": {
                "x": -3938.125,
                "z": -4417.632
              },
              "distanceAlongShapeM": 753.896,
              "shapeOffsetM": 5.291,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:949",
              "position": {
                "x": -3863.253,
                "z": -4076.062
              },
              "distanceAlongShapeM": 1105.433,
              "shapeOffsetM": 4.605,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:542",
              "position": {
                "x": -3683.061,
                "z": -3718.515
              },
              "distanceAlongShapeM": 1506.006,
              "shapeOffsetM": 1.046,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:5060",
              "position": {
                "x": -3633.854,
                "z": -3520.107
              },
              "distanceAlongShapeM": 1712.387,
              "shapeOffsetM": 3.767,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:6580",
              "position": {
                "x": -3740.623,
                "z": -3064.057
              },
              "distanceAlongShapeM": 2189.895,
              "shapeOffsetM": 3.974,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:6581",
              "position": {
                "x": -4002.758,
                "z": -2422.747
              },
              "distanceAlongShapeM": 2882.915,
              "shapeOffsetM": 4.266,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:6588",
              "position": {
                "x": -4045.475,
                "z": -1837.572
              },
              "distanceAlongShapeM": 3477.855,
              "shapeOffsetM": 0.069,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:6591",
              "position": {
                "x": -3809.119,
                "z": -1627.936
              },
              "distanceAlongShapeM": 3801.426,
              "shapeOffsetM": 2.593,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:928",
              "position": {
                "x": -3525.544,
                "z": -1521.55
              },
              "distanceAlongShapeM": 4212.293,
              "shapeOffsetM": 4.655,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:7416",
              "position": {
                "x": -3108.49,
                "z": -1230.499
              },
              "distanceAlongShapeM": 5176.694,
              "shapeOffsetM": 3.854,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:6430",
              "position": {
                "x": -2107.685,
                "z": -1111.223
              },
              "distanceAlongShapeM": 6224.49,
              "shapeOffsetM": 1.586,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:6433",
              "position": {
                "x": -1839.595,
                "z": -973.496
              },
              "distanceAlongShapeM": 6571.55,
              "shapeOffsetM": 1.002,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:6434",
              "position": {
                "x": -1771.243,
                "z": -575.067
              },
              "distanceAlongShapeM": 6977.507,
              "shapeOffsetM": 0.861,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            },
            {
              "stopId": "judu:stop:6437",
              "position": {
                "x": -1686.504,
                "z": -90.1
              },
              "distanceAlongShapeM": 7470.338,
              "shapeOffsetM": 1.705,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            },
            {
              "stopId": "judu:stop:18852",
              "position": {
                "x": -1457.753,
                "z": -28.505
              },
              "distanceAlongShapeM": 7769.518,
              "shapeOffsetM": 1.326,
              "arrivalOffsetSeconds": 1500,
              "departureOffsetSeconds": 1500
            },
            {
              "stopId": "judu:stop:5881",
              "position": {
                "x": -949.475,
                "z": 48.095
              },
              "distanceAlongShapeM": 8287.726,
              "shapeOffsetM": 3.908,
              "arrivalOffsetSeconds": 1560,
              "departureOffsetSeconds": 1560
            },
            {
              "stopId": "judu:stop:5332",
              "position": {
                "x": -557.893,
                "z": 125.637
              },
              "distanceAlongShapeM": 8690.197,
              "shapeOffsetM": 2.774,
              "arrivalOffsetSeconds": 1680,
              "departureOffsetSeconds": 1680
            },
            {
              "stopId": "judu:stop:5338",
              "position": {
                "x": -56,
                "z": 522.864
              },
              "distanceAlongShapeM": 9389.011,
              "shapeOffsetM": 1.857,
              "arrivalOffsetSeconds": 1860,
              "departureOffsetSeconds": 1860
            },
            {
              "stopId": "judu:stop:5345",
              "position": {
                "x": 17.976,
                "z": 1008
              },
              "distanceAlongShapeM": 9882.875,
              "shapeOffsetM": 2.839,
              "arrivalOffsetSeconds": 1980,
              "departureOffsetSeconds": 1980
            },
            {
              "stopId": "judu:stop:5349",
              "position": {
                "x": 206.575,
                "z": 1304.022
              },
              "distanceAlongShapeM": 10232.763,
              "shapeOffsetM": 2.488,
              "arrivalOffsetSeconds": 2040,
              "departureOffsetSeconds": 2040
            },
            {
              "stopId": "judu:stop:5430",
              "position": {
                "x": 392.049,
                "z": 1568.924
              },
              "distanceAlongShapeM": 10597.972,
              "shapeOffsetM": 3.402,
              "arrivalOffsetSeconds": 2160,
              "departureOffsetSeconds": 2160
            },
            {
              "stopId": "judu:stop:5300",
              "position": {
                "x": 479.21,
                "z": 1960.301
              },
              "distanceAlongShapeM": 11194.805,
              "shapeOffsetM": 3.526,
              "arrivalOffsetSeconds": 2280,
              "departureOffsetSeconds": 2280
            }
          ],
          "departuresSeconds": [
            17820,
            18780,
            19380,
            19980,
            20700,
            21420,
            22020,
            22500,
            22920,
            23340,
            23700,
            24060,
            24420,
            24720,
            25020,
            25320,
            25620,
            25920,
            26220,
            26580,
            27000,
            27420,
            27840,
            28260,
            28680,
            29160,
            29640,
            30120,
            30600,
            31080,
            31500,
            31980,
            32400,
            32820,
            33240,
            33720,
            34380,
            34920,
            35400,
            35940,
            36480,
            37080,
            37680,
            38280,
            38880,
            39420,
            39900,
            40380,
            40860,
            41280,
            41760,
            42240,
            42720,
            43260,
            43860,
            44400,
            44940,
            45420,
            45900,
            46380,
            46800,
            47280,
            47760,
            48240,
            48840,
            49440,
            50040,
            50520,
            51000,
            51420,
            51840,
            52260,
            52620,
            52980,
            53340,
            53700,
            54060,
            54420,
            54780,
            55200,
            55560,
            55980,
            56340,
            56700,
            57000,
            57300,
            57660,
            58020,
            58380,
            58740,
            59100,
            59400,
            59700,
            60000,
            60420,
            60840,
            61200,
            61620,
            61980,
            62340,
            62700,
            63060,
            63420,
            63780,
            64140,
            64680,
            65280,
            65940,
            66720,
            67500,
            68040,
            68640,
            69180,
            69720,
            70260,
            71040,
            71820,
            72420,
            73020,
            73620,
            74280,
            74760,
            75300,
            75780,
            76260,
            76800,
            77280,
            77880,
            78480,
            79080,
            79980,
            80880,
            81780,
            82680,
            83160
          ]
        },
        {
          "id": "judu:pattern:vilnius_trol_7:1",
          "sourceRouteId": "vilnius_trol_7",
          "sourceShapeId": "vilnius_trol_7_b-a",
          "directionId": 1,
          "headsign": "Perkūnkiemis",
          "directionName": "Stotis–Žvėrynas–Justiniškės–Perkūnkiemis",
          "mode": "trolleybus",
          "routeShortName": "7",
          "routeLongName": "Perkūnkiemis–Justiniškės–Žvėrynas–Stotis",
          "routeColor": "DC3131",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              476.503,
              1958.043,
              0
            ],
            [
              482.271,
              1945.18,
              14.097
            ],
            [
              477.309,
              1926.939,
              33.001
            ],
            [
              467.128,
              1919.144,
              45.824
            ],
            [
              410.21,
              1927.053,
              103.288
            ],
            [
              405.736,
              1929.361,
              108.323
            ],
            [
              398.6,
              1927.265,
              115.76
            ],
            [
              329.489,
              1817.205,
              245.72
            ],
            [
              330.657,
              1810.504,
              252.522
            ],
            [
              391.321,
              1670.242,
              405.34
            ],
            [
              473.433,
              1574.115,
              531.763
            ],
            [
              482.238,
              1561.708,
              546.977
            ],
            [
              478.313,
              1549.038,
              560.241
            ],
            [
              469.529,
              1536.247,
              575.758
            ],
            [
              453.691,
              1517.701,
              600.147
            ],
            [
              360.424,
              1427.008,
              730.239
            ],
            [
              315.899,
              1391.085,
              787.448
            ],
            [
              256.42,
              1348.755,
              860.452
            ],
            [
              223.566,
              1315.958,
              906.875
            ],
            [
              196.476,
              1280.829,
              951.236
            ],
            [
              149.248,
              1202.651,
              1042.572
            ],
            [
              55.081,
              1061.873,
              1211.941
            ],
            [
              46.275,
              1047.293,
              1228.974
            ],
            [
              39.094,
              1036.402,
              1242.019
            ],
            [
              29.447,
              1013.439,
              1266.926
            ],
            [
              17.226,
              966.824,
              1315.117
            ],
            [
              -2.949,
              921.549,
              1364.683
            ],
            [
              -20.393,
              826.162,
              1461.653
            ],
            [
              -29.409,
              769.885,
              1518.647
            ],
            [
              -34.886,
              726.201,
              1562.673
            ],
            [
              -34.25,
              619.32,
              1669.556
            ],
            [
              -49.15,
              509.381,
              1780.5
            ],
            [
              -50.587,
              430.368,
              1859.526
            ],
            [
              -86.677,
              396.514,
              1909.009
            ],
            [
              -98.36,
              381.073,
              1928.372
            ],
            [
              -191.298,
              289.447,
              2058.882
            ],
            [
              -216.06,
              268.617,
              2091.24
            ],
            [
              -386.375,
              159.27,
              2293.635
            ],
            [
              -408.498,
              148.538,
              2318.224
            ],
            [
              -583.944,
              111.636,
              2497.509
            ],
            [
              -658.953,
              100.746,
              2573.304
            ],
            [
              -724.996,
              86.353,
              2640.897
            ],
            [
              -736.71,
              77.277,
              2655.716
            ],
            [
              -743.833,
              78.9,
              2663.022
            ],
            [
              -798.875,
              66.534,
              2719.436
            ],
            [
              -863.023,
              49.879,
              2785.711
            ],
            [
              -871.015,
              45.142,
              2795.002
            ],
            [
              -877.911,
              46.807,
              2802.096
            ],
            [
              -930.978,
              36.63,
              2856.13
            ],
            [
              -998.108,
              33.385,
              2923.338
            ],
            [
              -1226.73,
              -20.397,
              3158.201
            ],
            [
              -1327.722,
              -41.964,
              3261.47
            ],
            [
              -1378.216,
              -54.917,
              3313.599
            ],
            [
              -1437.414,
              -46.326,
              3373.417
            ],
            [
              -1471.431,
              -36.053,
              3408.952
            ],
            [
              -1661.707,
              -1.484,
              3602.342
            ],
            [
              -1691.384,
              -146.787,
              3750.645
            ],
            [
              -1712.987,
              -273.309,
              3878.998
            ],
            [
              -1713.492,
              -281.762,
              3887.467
            ],
            [
              -1719.483,
              -312.156,
              3918.445
            ],
            [
              -1768.396,
              -596.269,
              4206.738
            ],
            [
              -1772.222,
              -628.201,
              4238.898
            ],
            [
              -1778.412,
              -651.752,
              4263.249
            ],
            [
              -1847.461,
              -1053.546,
              4670.932
            ],
            [
              -1903.255,
              -1072.553,
              4729.875
            ],
            [
              -1912.525,
              -1075.817,
              4739.704
            ],
            [
              -1954.393,
              -1083.889,
              4782.342
            ],
            [
              -2142.708,
              -1122.847,
              4974.645
            ],
            [
              -2154.408,
              -1128.206,
              4987.514
            ],
            [
              -2189.935,
              -1158.368,
              5034.118
            ],
            [
              -2202.233,
              -1162.567,
              5047.113
            ],
            [
              -2218.205,
              -1162.698,
              5063.085
            ],
            [
              -2227.932,
              -1165.865,
              5073.315
            ],
            [
              -2246.137,
              -1174.448,
              5093.442
            ],
            [
              -2255.397,
              -1187.643,
              5109.562
            ],
            [
              -2266.36,
              -1186.843,
              5120.554
            ],
            [
              -2295.924,
              -1182.472,
              5150.439
            ],
            [
              -2392.506,
              -1175.197,
              5247.295
            ],
            [
              -2431.277,
              -1180.078,
              5286.372
            ],
            [
              -2478.584,
              -1193.714,
              5335.605
            ],
            [
              -2533.196,
              -1219.467,
              5395.985
            ],
            [
              -2617.204,
              -1266.966,
              5492.491
            ],
            [
              -2663.944,
              -1285.067,
              5542.614
            ],
            [
              -2710.565,
              -1296.491,
              5590.614
            ],
            [
              -2762.381,
              -1304.469,
              5643.041
            ],
            [
              -2806.189,
              -1305.331,
              5686.857
            ],
            [
              -2858.757,
              -1300.914,
              5739.61
            ],
            [
              -3085.169,
              -1260.965,
              5969.52
            ],
            [
              -3139.719,
              -1251.188,
              6024.939
            ],
            [
              -3159.719,
              -1247.413,
              6045.292
            ],
            [
              -3359.526,
              -1207.182,
              6249.109
            ],
            [
              -3495.953,
              -1192.555,
              6386.318
            ],
            [
              -3539.19,
              -1199.062,
              6430.042
            ],
            [
              -3554.101,
              -1203.884,
              6445.713
            ],
            [
              -3558.842,
              -1212.61,
              6455.644
            ],
            [
              -3559.094,
              -1227.077,
              6470.113
            ],
            [
              -3554.873,
              -1243.849,
              6487.408
            ],
            [
              -3546.348,
              -1270.446,
              6515.337
            ],
            [
              -3520.478,
              -1415.883,
              6663.058
            ],
            [
              -3500.646,
              -1498.607,
              6748.126
            ],
            [
              -3461.302,
              -1608.388,
              6864.744
            ],
            [
              -3462.063,
              -1615.054,
              6871.453
            ],
            [
              -3466.214,
              -1618.635,
              6876.936
            ],
            [
              -3480.186,
              -1619.191,
              6890.919
            ],
            [
              -3518.97,
              -1623.742,
              6929.969
            ],
            [
              -3543.21,
              -1625.119,
              6954.247
            ],
            [
              -3571.837,
              -1625.385,
              6982.876
            ],
            [
              -3721.548,
              -1633.911,
              7132.83
            ],
            [
              -3788.083,
              -1641.66,
              7199.814
            ],
            [
              -3841.2,
              -1656.322,
              7254.918
            ],
            [
              -3882.188,
              -1677.875,
              7301.227
            ],
            [
              -3931.102,
              -1710.422,
              7359.98
            ],
            [
              -3978.977,
              -1757.46,
              7427.096
            ],
            [
              -4022.062,
              -1825.732,
              7507.826
            ],
            [
              -4044.37,
              -1885.459,
              7571.583
            ],
            [
              -4052.817,
              -1926.501,
              7613.486
            ],
            [
              -4053.048,
              -1939.856,
              7626.843
            ],
            [
              -4053.478,
              -1959.825,
              7646.816
            ],
            [
              -4055.493,
              -2006.606,
              7693.641
            ],
            [
              -4046.573,
              -2161.497,
              7848.788
            ],
            [
              -4020.612,
              -2299.985,
              7989.689
            ],
            [
              -3990.129,
              -2400.702,
              8094.917
            ],
            [
              -3964.263,
              -2470.17,
              8169.045
            ],
            [
              -3946.156,
              -2503.88,
              8207.31
            ],
            [
              -3938.431,
              -2519.742,
              8224.953
            ],
            [
              -3933.698,
              -2531.347,
              8237.486
            ],
            [
              -3926.386,
              -2553.204,
              8260.534
            ],
            [
              -3841.707,
              -2761.732,
              8485.599
            ],
            [
              -3765.67,
              -2947.847,
              8686.648
            ],
            [
              -3690.695,
              -3120.586,
              8874.956
            ],
            [
              -3680.304,
              -3153.05,
              8909.042
            ],
            [
              -3667.758,
              -3180.973,
              8939.654
            ],
            [
              -3659.777,
              -3201.747,
              8961.909
            ],
            [
              -3640.55,
              -3257.597,
              9020.975
            ],
            [
              -3617.776,
              -3346.817,
              9113.057
            ],
            [
              -3610.984,
              -3396.99,
              9163.687
            ],
            [
              -3610.019,
              -3500.257,
              9266.958
            ],
            [
              -3620.065,
              -3579.347,
              9346.684
            ],
            [
              -3630.094,
              -3629.184,
              9397.52
            ],
            [
              -3640.182,
              -3661.375,
              9431.255
            ],
            [
              -3673.181,
              -3743.178,
              9519.463
            ],
            [
              -3862.172,
              -4125.062,
              9945.553
            ],
            [
              -3878.53,
              -4166.876,
              9990.453
            ],
            [
              -3892.491,
              -4201.348,
              10027.645
            ],
            [
              -3906.204,
              -4248.978,
              10077.209
            ],
            [
              -3915.447,
              -4298.912,
              10127.992
            ],
            [
              -3918.758,
              -4341.156,
              10170.365
            ],
            [
              -3917.895,
              -4365.662,
              10194.886
            ],
            [
              -3914.159,
              -4410.256,
              10239.637
            ],
            [
              -3903.629,
              -4471.665,
              10301.942
            ],
            [
              -3893.942,
              -4507.456,
              10339.021
            ],
            [
              -3887.4,
              -4526.56,
              10359.214
            ],
            [
              -3876.856,
              -4562.301,
              10396.478
            ],
            [
              -3837.687,
              -4680.982,
              10521.455
            ],
            [
              -3830.05,
              -4723.417,
              10564.572
            ],
            [
              -3816.509,
              -4833.861,
              10675.843
            ],
            [
              -3815.714,
              -4936.291,
              10778.276
            ],
            [
              -3827.684,
              -5087.455,
              10929.913
            ],
            [
              -3835.986,
              -5117.005,
              10960.607
            ],
            [
              -3846.109,
              -5119.902,
              10971.137
            ],
            [
              -3879.396,
              -5153.374,
              11018.343
            ],
            [
              -3922.484,
              -5149.286,
              11061.624
            ],
            [
              -3928.106,
              -5139.169,
              11073.199
            ],
            [
              -3926.238,
              -5105.805,
              11106.615
            ],
            [
              -3921.595,
              -5098.093,
              11115.617
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:5300",
              "position": {
                "x": 479.21,
                "z": 1960.301
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 3.526,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:6834",
              "position": {
                "x": 472.7,
                "z": 1534.052
              },
              "distanceAlongShapeM": 575.758,
              "shapeOffsetM": 3.857,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:5346",
              "position": {
                "x": 52.802,
                "z": 1042.989
              },
              "distanceAlongShapeM": 1228.974,
              "shapeOffsetM": 7.818,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:5432",
              "position": {
                "x": -26.358,
                "z": 769.462
              },
              "distanceAlongShapeM": 1518.582,
              "shapeOffsetM": 3.079,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:5334",
              "position": {
                "x": -97.297,
                "z": 380.009
              },
              "distanceAlongShapeM": 1928.372,
              "shapeOffsetM": 1.504,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:5936",
              "position": {
                "x": -736.157,
                "z": 75.422
              },
              "distanceAlongShapeM": 2655.716,
              "shapeOffsetM": 1.935,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:19193",
              "position": {
                "x": -870.86,
                "z": 44.454
              },
              "distanceAlongShapeM": 2795.002,
              "shapeOffsetM": 0.705,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:6438",
              "position": {
                "x": -1438.145,
                "z": -50.007
              },
              "distanceAlongShapeM": 3373.417,
              "shapeOffsetM": 3.753,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:6436",
              "position": {
                "x": -1710.567,
                "z": -282.258
              },
              "distanceAlongShapeM": 3887.467,
              "shapeOffsetM": 2.967,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:6435",
              "position": {
                "x": -1770.261,
                "z": -628.519
              },
              "distanceAlongShapeM": 4238.898,
              "shapeOffsetM": 1.987,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:6432",
              "position": {
                "x": -1911.753,
                "z": -1079.081
              },
              "distanceAlongShapeM": 4739.704,
              "shapeOffsetM": 3.354,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:7415",
              "position": {
                "x": -3140.52,
                "z": -1255.542
              },
              "distanceAlongShapeM": 6024.939,
              "shapeOffsetM": 4.427,
              "arrivalOffsetSeconds": 1380,
              "departureOffsetSeconds": 1380
            },
            {
              "stopId": "judu:stop:4990",
              "position": {
                "x": -3543.073,
                "z": -1269.659
              },
              "distanceAlongShapeM": 6515.337,
              "shapeOffsetM": 3.368,
              "arrivalOffsetSeconds": 1500,
              "departureOffsetSeconds": 1500
            },
            {
              "stopId": "judu:stop:6597",
              "position": {
                "x": -3542.913,
                "z": -1630.342
              },
              "distanceAlongShapeM": 6954.247,
              "shapeOffsetM": 5.231,
              "arrivalOffsetSeconds": 1620,
              "departureOffsetSeconds": 1620
            },
            {
              "stopId": "judu:stop:6587",
              "position": {
                "x": -4048.884,
                "z": -1959.966
              },
              "distanceAlongShapeM": 7646.816,
              "shapeOffsetM": 4.596,
              "arrivalOffsetSeconds": 1800,
              "departureOffsetSeconds": 1800
            },
            {
              "stopId": "judu:stop:6582",
              "position": {
                "x": -3932.856,
                "z": -2517.469
              },
              "distanceAlongShapeM": 8224.953,
              "shapeOffsetM": 6.02,
              "arrivalOffsetSeconds": 1920,
              "departureOffsetSeconds": 1920
            },
            {
              "stopId": "judu:stop:5063",
              "position": {
                "x": -3662.711,
                "z": -3178.96
              },
              "distanceAlongShapeM": 8939.654,
              "shapeOffsetM": 5.433,
              "arrivalOffsetSeconds": 2040,
              "departureOffsetSeconds": 2040
            },
            {
              "stopId": "judu:stop:5140",
              "position": {
                "x": -3625.467,
                "z": -3630.461
              },
              "distanceAlongShapeM": 9397.52,
              "shapeOffsetM": 4.8,
              "arrivalOffsetSeconds": 2160,
              "departureOffsetSeconds": 2160
            },
            {
              "stopId": "judu:stop:5141",
              "position": {
                "x": -3875.164,
                "z": -4168.252
              },
              "distanceAlongShapeM": 9990.465,
              "shapeOffsetM": 3.636,
              "arrivalOffsetSeconds": 2220,
              "departureOffsetSeconds": 2220
            },
            {
              "stopId": "judu:stop:6925",
              "position": {
                "x": -3883.947,
                "z": -4525.441
              },
              "distanceAlongShapeM": 10359.214,
              "shapeOffsetM": 3.63,
              "arrivalOffsetSeconds": 2340,
              "departureOffsetSeconds": 2340
            },
            {
              "stopId": "judu:stop:6931",
              "position": {
                "x": -3827.361,
                "z": -5087.486
              },
              "distanceAlongShapeM": 10929.913,
              "shapeOffsetM": 0.325,
              "arrivalOffsetSeconds": 2400,
              "departureOffsetSeconds": 2400
            }
          ],
          "departuresSeconds": [
            18600,
            20280,
            21240,
            21840,
            22440,
            23160,
            23880,
            24480,
            24960,
            25380,
            25860,
            26220,
            26580,
            27000,
            27300,
            27600,
            27900,
            28200,
            28500,
            28800,
            29160,
            29580,
            30000,
            30420,
            30840,
            31260,
            31740,
            32160,
            32640,
            33120,
            33600,
            34020,
            34380,
            34800,
            35160,
            35580,
            36060,
            36720,
            37260,
            37740,
            38340,
            38880,
            39480,
            40080,
            40680,
            41280,
            41820,
            42300,
            42780,
            43260,
            43680,
            44160,
            44640,
            45120,
            45660,
            46260,
            46800,
            47340,
            47820,
            48300,
            48720,
            49140,
            49620,
            50100,
            50580,
            51180,
            51840,
            52440,
            52860,
            53340,
            53760,
            54180,
            54600,
            54960,
            55320,
            55680,
            56100,
            56460,
            56820,
            57180,
            57600,
            57960,
            58380,
            58740,
            59100,
            59400,
            59700,
            60060,
            60420,
            60780,
            61140,
            61500,
            61800,
            62100,
            62400,
            62820,
            63300,
            63600,
            64020,
            64380,
            64740,
            65100,
            65460,
            65880,
            66240,
            66540,
            67080,
            67680,
            68340,
            69120,
            69900,
            70440,
            70980,
            71520,
            72060,
            72600,
            73380,
            74160,
            74760,
            75360,
            75960,
            76620,
            77100,
            77640,
            78120,
            78600,
            79140,
            79620,
            80220,
            80820,
            81360,
            82260,
            83160,
            84060
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_trol_9",
      "sourceRouteId": "vilnius_trol_9",
      "mode": "trolleybus",
      "shortName": "9",
      "longName": "Karoliniškės–Šeimyniškių g.–Žirmūnai",
      "color": "DC3131",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_trol_9:0",
          "sourceRouteId": "vilnius_trol_9",
          "sourceShapeId": "vilnius_trol_9_a-b",
          "directionId": 0,
          "headsign": "Žirmūnai",
          "directionName": "Karoliniškės–Šeimyniškių g.–Žirmūnai",
          "mode": "trolleybus",
          "routeShortName": "9",
          "routeLongName": "Karoliniškės–Šeimyniškių g.–Žirmūnai",
          "routeColor": "DC3131",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              -4635.88,
              552.048,
              0
            ],
            [
              -4631.537,
              534.532,
              18.046
            ],
            [
              -4634.181,
              503.94,
              48.753
            ],
            [
              -4643.152,
              471.614,
              82.3
            ],
            [
              -4646.407,
              443.732,
              110.372
            ],
            [
              -4641.216,
              408.021,
              146.458
            ],
            [
              -4613.144,
              315.143,
              243.486
            ],
            [
              -4582.265,
              235.574,
              328.836
            ],
            [
              -4572.392,
              217.886,
              349.093
            ],
            [
              -4568.029,
              200.82,
              366.708
            ],
            [
              -4518.608,
              112.027,
              468.328
            ],
            [
              -4509.454,
              81.813,
              499.898
            ],
            [
              -4478.955,
              17.836,
              570.773
            ],
            [
              -4459.487,
              -12.556,
              606.866
            ],
            [
              -4426.085,
              -57.659,
              662.99
            ],
            [
              -4398.274,
              -90.421,
              705.965
            ],
            [
              -4367.713,
              -113.212,
              744.088
            ],
            [
              -4348.96,
              -128.914,
              768.547
            ],
            [
              -4335.314,
              -141.601,
              787.18
            ],
            [
              -4247.163,
              -227.726,
              910.42
            ],
            [
              -4197.821,
              -283.125,
              984.606
            ],
            [
              -4155.783,
              -350.644,
              1064.143
            ],
            [
              -4081.921,
              -462.729,
              1198.376
            ],
            [
              -4063.365,
              -492.829,
              1233.736
            ],
            [
              -4053.544,
              -508.761,
              1252.452
            ],
            [
              -3962.534,
              -660.121,
              1429.067
            ],
            [
              -3958.061,
              -662.425,
              1434.098
            ],
            [
              -3950.306,
              -661.447,
              1441.914
            ],
            [
              -3806.746,
              -600.485,
              1597.882
            ],
            [
              -3694.685,
              -571.263,
              1713.69
            ],
            [
              -3695.742,
              -557.886,
              1727.109
            ],
            [
              -3728.082,
              -489.418,
              1802.831
            ],
            [
              -3741.232,
              -466.925,
              1828.885
            ],
            [
              -3745.668,
              -462.395,
              1835.226
            ],
            [
              -3755.778,
              -460.516,
              1845.509
            ],
            [
              -3839.114,
              -496.394,
              1936.24
            ],
            [
              -3851.18,
              -510.321,
              1954.667
            ],
            [
              -3857.684,
              -524.093,
              1969.897
            ],
            [
              -3858.854,
              -532.879,
              1978.76
            ],
            [
              -3823.641,
              -607.984,
              2061.711
            ],
            [
              -3766.483,
              -732.543,
              2198.758
            ],
            [
              -3707.64,
              -908.34,
              2384.142
            ],
            [
              -3695.741,
              -928.584,
              2407.624
            ],
            [
              -3679.687,
              -950.175,
              2434.529
            ],
            [
              -3668.232,
              -978.044,
              2464.66
            ],
            [
              -3606.925,
              -1085.98,
              2588.792
            ],
            [
              -3586.062,
              -1109.72,
              2620.397
            ],
            [
              -3575.241,
              -1117.701,
              2633.843
            ],
            [
              -3510.801,
              -1144.012,
              2703.448
            ],
            [
              -3355.367,
              -1190.556,
              2865.7
            ],
            [
              -3109.19,
              -1234.288,
              3115.731
            ],
            [
              -3070.013,
              -1242.306,
              3155.721
            ],
            [
              -2879.155,
              -1277.94,
              3349.877
            ],
            [
              -2839.273,
              -1283.094,
              3390.09
            ],
            [
              -2787.087,
              -1285.125,
              3442.316
            ],
            [
              -2748.376,
              -1283.58,
              3481.058
            ],
            [
              -2714.118,
              -1278.617,
              3515.673
            ],
            [
              -2670.7,
              -1266.023,
              3560.881
            ],
            [
              -2624.585,
              -1246.798,
              3610.843
            ],
            [
              -2499.949,
              -1183.085,
              3750.819
            ],
            [
              -2469.831,
              -1172.717,
              3782.672
            ],
            [
              -2418.716,
              -1162.489,
              3834.8
            ],
            [
              -2392.231,
              -1159.617,
              3861.441
            ],
            [
              -2152.041,
              -1187.387,
              4103.231
            ],
            [
              -2126.526,
              -1191.159,
              4129.022
            ],
            [
              -2118.854,
              -1195.63,
              4137.903
            ],
            [
              -1988.935,
              -1213.522,
              4269.048
            ],
            [
              -1948.388,
              -1217.583,
              4309.798
            ],
            [
              -1827.9,
              -1221.953,
              4430.365
            ],
            [
              -1794.345,
              -1220.324,
              4463.959
            ],
            [
              -1747.175,
              -1214.486,
              4511.489
            ],
            [
              -1624.316,
              -1194.413,
              4635.977
            ],
            [
              -1544.075,
              -1178.035,
              4717.873
            ],
            [
              -1435.713,
              -1149.425,
              4829.948
            ],
            [
              -1393.22,
              -1142.883,
              4872.941
            ],
            [
              -1155.149,
              -1098.17,
              5115.175
            ],
            [
              -1103.532,
              -1084.281,
              5168.628
            ],
            [
              -1083.324,
              -1083.875,
              5188.84
            ],
            [
              -1022.536,
              -1073.836,
              5250.451
            ],
            [
              -998.991,
              -1055.334,
              5280.396
            ],
            [
              -969.041,
              -1039.175,
              5314.427
            ],
            [
              -947.066,
              -1036.231,
              5336.599
            ],
            [
              -930.307,
              -1036.533,
              5353.36
            ],
            [
              -906.579,
              -1043.639,
              5378.129
            ],
            [
              -895.802,
              -1053.852,
              5392.977
            ],
            [
              -890.221,
              -1066.198,
              5406.526
            ],
            [
              -882.043,
              -1077.478,
              5420.458
            ],
            [
              -864.236,
              -1091.158,
              5442.914
            ],
            [
              -846.005,
              -1097.331,
              5462.162
            ],
            [
              -813.038,
              -1094.85,
              5495.222
            ],
            [
              -785.651,
              -1089.799,
              5523.07
            ],
            [
              -774.937,
              -1088.05,
              5533.926
            ],
            [
              -717.669,
              -1083.853,
              5591.348
            ],
            [
              -647.083,
              -1062.792,
              5665.009
            ],
            [
              -599.769,
              -1049.176,
              5714.243
            ],
            [
              -511.525,
              -1018.488,
              5807.671
            ],
            [
              -361.843,
              -942.16,
              5975.691
            ],
            [
              -331.427,
              -923.524,
              6011.362
            ],
            [
              -286.654,
              -898.264,
              6062.769
            ],
            [
              -196.966,
              -846.075,
              6166.536
            ],
            [
              -115.583,
              -803.025,
              6258.604
            ],
            [
              -95.312,
              -792.953,
              6281.239
            ],
            [
              -40.176,
              -770.281,
              6340.855
            ],
            [
              224.8,
              -701.243,
              6614.677
            ],
            [
              238.603,
              -700.678,
              6628.492
            ],
            [
              294.146,
              -689.755,
              6685.098
            ],
            [
              331.506,
              -684.268,
              6722.859
            ],
            [
              436.802,
              -673.948,
              6828.66
            ],
            [
              647.48,
              -719,
              7044.101
            ],
            [
              692.52,
              -724.28,
              7089.449
            ],
            [
              727.857,
              -730.038,
              7125.252
            ],
            [
              752.192,
              -734.856,
              7150.059
            ],
            [
              1031.058,
              -793.963,
              7435.121
            ],
            [
              1157.03,
              -816.326,
              7563.062
            ],
            [
              1199.169,
              -824.315,
              7605.952
            ],
            [
              1220.015,
              -827.509,
              7627.041
            ],
            [
              1248.96,
              -831.383,
              7656.244
            ],
            [
              1325.104,
              -828.339,
              7732.449
            ],
            [
              1339.141,
              -836.391,
              7748.632
            ],
            [
              1354.364,
              -850.032,
              7769.072
            ],
            [
              1360.583,
              -862.393,
              7782.91
            ],
            [
              1367.85,
              -922.642,
              7843.595
            ],
            [
              1384.491,
              -964.14,
              7888.305
            ],
            [
              1464.439,
              -1103.664,
              8049.112
            ],
            [
              1477.634,
              -1123.116,
              8072.616
            ],
            [
              1488.813,
              -1145.306,
              8097.464
            ],
            [
              1537.374,
              -1238.606,
              8202.645
            ],
            [
              1587.871,
              -1366.453,
              8340.103
            ],
            [
              1626.598,
              -1502.988,
              8482.024
            ],
            [
              1647.564,
              -1589.097,
              8570.649
            ],
            [
              1670.179,
              -1759.844,
              8742.887
            ],
            [
              1672.682,
              -1787.97,
              8771.124
            ],
            [
              1672.408,
              -1813.321,
              8796.477
            ],
            [
              1676.981,
              -1962.613,
              8945.838
            ],
            [
              1684.587,
              -2475.93,
              9459.212
            ],
            [
              1691.063,
              -2612.98,
              9596.415
            ],
            [
              1692.552,
              -2638.806,
              9622.284
            ],
            [
              1690.652,
              -2669.748,
              9653.284
            ],
            [
              1690.731,
              -2873.474,
              9857.01
            ],
            [
              1700.851,
              -3126.37,
              10110.108
            ],
            [
              1707.344,
              -3177.803,
              10161.949
            ],
            [
              1701.896,
              -3208.77,
              10193.392
            ],
            [
              1697.306,
              -3247.648,
              10232.54
            ],
            [
              1679.831,
              -3286.287,
              10274.947
            ],
            [
              1593.247,
              -3437.193,
              10448.928
            ],
            [
              1579.69,
              -3472.235,
              10486.501
            ],
            [
              1566.424,
              -3493.47,
              10511.539
            ],
            [
              1508.519,
              -3591.87,
              10625.713
            ],
            [
              1412.221,
              -3746.656,
              10808.009
            ],
            [
              1401.002,
              -3760.92,
              10826.157
            ],
            [
              1342.534,
              -3804.924,
              10899.334
            ],
            [
              1325.974,
              -3810.739,
              10916.885
            ],
            [
              1219.986,
              -3862.213,
              11034.711
            ],
            [
              1220.734,
              -4100.462,
              11272.961
            ],
            [
              1222.498,
              -4142.938,
              11315.474
            ],
            [
              1222.034,
              -4169.508,
              11342.048
            ],
            [
              1222.197,
              -4191.784,
              11364.324
            ],
            [
              1218.667,
              -4222.547,
              11395.289
            ],
            [
              1209.216,
              -4242.448,
              11417.321
            ],
            [
              1199.734,
              -4253.999,
              11432.265
            ],
            [
              1180.34,
              -4272.796,
              11459.273
            ],
            [
              1169.776,
              -4277.639,
              11470.895
            ],
            [
              1151.036,
              -4280.633,
              11489.872
            ],
            [
              1136.231,
              -4280.418,
              11504.679
            ],
            [
              1097.302,
              -4298.664,
              11547.671
            ],
            [
              1060.432,
              -4334.455,
              11599.056
            ],
            [
              1050.84,
              -4334.625,
              11608.649
            ],
            [
              1024.373,
              -4320.974,
              11638.43
            ],
            [
              1020.017,
              -4312.849,
              11647.648
            ],
            [
              1017.506,
              -4299.224,
              11661.503
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:5924",
              "position": {
                "x": -4631.834,
                "z": 503.595
              },
              "distanceAlongShapeM": 48.753,
              "shapeOffsetM": 2.372,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:351",
              "position": {
                "x": -4568.349,
                "z": 219.75
              },
              "distanceAlongShapeM": 349.093,
              "shapeOffsetM": 4.452,
              "arrivalOffsetSeconds": 60,
              "departureOffsetSeconds": 60
            },
            {
              "stopId": "judu:stop:6400",
              "position": {
                "x": -4345.341,
                "z": -124.73
              },
              "distanceAlongShapeM": 768.547,
              "shapeOffsetM": 5.532,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:596",
              "position": {
                "x": -4057.587,
                "z": -489.267
              },
              "distanceAlongShapeM": 1233.736,
              "shapeOffsetM": 6.788,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:6643",
              "position": {
                "x": -3679.35,
                "z": -950.021
              },
              "distanceAlongShapeM": 2434.529,
              "shapeOffsetM": 0.37,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:7416",
              "position": {
                "x": -3108.49,
                "z": -1230.499
              },
              "distanceAlongShapeM": 3115.731,
              "shapeOffsetM": 3.854,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:6398",
              "position": {
                "x": -2151.528,
                "z": -1183.918
              },
              "distanceAlongShapeM": 4103.231,
              "shapeOffsetM": 3.507,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:6396",
              "position": {
                "x": -1436.465,
                "z": -1145.449
              },
              "distanceAlongShapeM": 4829.948,
              "shapeOffsetM": 4.046,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            },
            {
              "stopId": "judu:stop:6397",
              "position": {
                "x": -1103.929,
                "z": -1082.392
              },
              "distanceAlongShapeM": 5168.628,
              "shapeOffsetM": 1.931,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:6635",
              "position": {
                "x": -775.751,
                "z": -1082.734
              },
              "distanceAlongShapeM": 5533.926,
              "shapeOffsetM": 5.378,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:7381",
              "position": {
                "x": -333.702,
                "z": -919.293
              },
              "distanceAlongShapeM": 6011.46,
              "shapeOffsetM": 4.803,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:17638",
              "position": {
                "x": -42.035,
                "z": -765.399
              },
              "distanceAlongShapeM": 6340.855,
              "shapeOffsetM": 5.224,
              "arrivalOffsetSeconds": 1380,
              "departureOffsetSeconds": 1380
            },
            {
              "stopId": "judu:stop:5667",
              "position": {
                "x": 292.85,
                "z": -682.448
              },
              "distanceAlongShapeM": 6685.098,
              "shapeOffsetM": 7.421,
              "arrivalOffsetSeconds": 1560,
              "departureOffsetSeconds": 1560
            },
            {
              "stopId": "judu:stop:5665",
              "position": {
                "x": 729.304,
                "z": -722.729
              },
              "distanceAlongShapeM": 7125.252,
              "shapeOffsetM": 7.451,
              "arrivalOffsetSeconds": 1680,
              "departureOffsetSeconds": 1680
            },
            {
              "stopId": "judu:stop:6660",
              "position": {
                "x": 1200.176,
                "z": -819.349
              },
              "distanceAlongShapeM": 7606.195,
              "shapeOffsetM": 5.061,
              "arrivalOffsetSeconds": 1800,
              "departureOffsetSeconds": 1800
            },
            {
              "stopId": "judu:stop:6665",
              "position": {
                "x": 1480.223,
                "z": -1121.768
              },
              "distanceAlongShapeM": 8072.616,
              "shapeOffsetM": 2.918,
              "arrivalOffsetSeconds": 1920,
              "departureOffsetSeconds": 1920
            },
            {
              "stopId": "judu:stop:6666",
              "position": {
                "x": 1676.751,
                "z": -1787.797
              },
              "distanceAlongShapeM": 8771.124,
              "shapeOffsetM": 4.073,
              "arrivalOffsetSeconds": 2040,
              "departureOffsetSeconds": 2040
            },
            {
              "stopId": "judu:stop:5606",
              "position": {
                "x": 1696.386,
                "z": -2638.684
              },
              "distanceAlongShapeM": 9622.284,
              "shapeOffsetM": 3.836,
              "arrivalOffsetSeconds": 2280,
              "departureOffsetSeconds": 2280
            },
            {
              "stopId": "judu:stop:6667",
              "position": {
                "x": 1709.563,
                "z": -3177.741
              },
              "distanceAlongShapeM": 10161.949,
              "shapeOffsetM": 2.22,
              "arrivalOffsetSeconds": 2400,
              "departureOffsetSeconds": 2400
            },
            {
              "stopId": "judu:stop:6668",
              "position": {
                "x": 1582.257,
                "z": -3473.726
              },
              "distanceAlongShapeM": 10486.501,
              "shapeOffsetM": 2.969,
              "arrivalOffsetSeconds": 2460,
              "departureOffsetSeconds": 2460
            },
            {
              "stopId": "judu:stop:5154",
              "position": {
                "x": 1342.825,
                "z": -3805.485
              },
              "distanceAlongShapeM": 10899.334,
              "shapeOffsetM": 0.632,
              "arrivalOffsetSeconds": 2640,
              "departureOffsetSeconds": 2640
            },
            {
              "stopId": "judu:stop:6671",
              "position": {
                "x": 1228.325,
                "z": -4142.906
              },
              "distanceAlongShapeM": 11315.474,
              "shapeOffsetM": 5.827,
              "arrivalOffsetSeconds": 2700,
              "departureOffsetSeconds": 2700
            },
            {
              "stopId": "judu:stop:5505",
              "position": {
                "x": 1151.036,
                "z": -4280.633
              },
              "distanceAlongShapeM": 11489.872,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2760,
              "departureOffsetSeconds": 2760
            }
          ],
          "departuresSeconds": [
            18480,
            20100,
            21420,
            22440,
            23520,
            24360,
            25140,
            25920,
            26700,
            27840,
            29040,
            30240,
            31680,
            32880,
            34080,
            35220,
            37740,
            39480,
            41580,
            43740,
            45780,
            47820,
            50040,
            51420,
            52380,
            53340,
            54300,
            55320,
            56460,
            57240,
            58320,
            59160,
            60360,
            61560,
            62880,
            64500,
            66120,
            68520,
            70740,
            72480,
            74580,
            76440,
            78300,
            80280,
            82260
          ]
        },
        {
          "id": "judu:pattern:vilnius_trol_9:1",
          "sourceRouteId": "vilnius_trol_9",
          "sourceShapeId": "vilnius_trol_9_b-a",
          "directionId": 1,
          "headsign": "Karoliniškės",
          "directionName": "Žirmūnai–Šeimyniškių g.–Karoliniškės",
          "mode": "trolleybus",
          "routeShortName": "9",
          "routeLongName": "Karoliniškės–Šeimyniškių g.–Žirmūnai",
          "routeColor": "DC3131",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              1017.506,
              -4299.224,
              0
            ],
            [
              1021.564,
              -4286.64,
              13.222
            ],
            [
              1026.249,
              -4282.222,
              19.661
            ],
            [
              1105.831,
              -4274.26,
              99.641
            ],
            [
              1128.035,
              -4270.234,
              122.207
            ],
            [
              1147.356,
              -4270.545,
              141.53
            ],
            [
              1189.631,
              -4265.192,
              184.142
            ],
            [
              1202.517,
              -4249.3,
              204.602
            ],
            [
              1214.522,
              -4227.257,
              229.702
            ],
            [
              1220.978,
              -4191.753,
              265.789
            ],
            [
              1217.195,
              -3943.429,
              514.141
            ],
            [
              1219.986,
              -3862.213,
              595.405
            ],
            [
              1375.611,
              -3774.922,
              773.84
            ],
            [
              1393.375,
              -3755.212,
              800.374
            ],
            [
              1412.221,
              -3746.656,
              821.071
            ],
            [
              1509.877,
              -3564.24,
              1027.982
            ],
            [
              1556.885,
              -3486.613,
              1118.733
            ],
            [
              1610.18,
              -3392.177,
              1227.17
            ],
            [
              1620.009,
              -3384.254,
              1239.794
            ],
            [
              1689.847,
              -3267.548,
              1375.8
            ],
            [
              1697.306,
              -3247.648,
              1397.052
            ],
            [
              1696.944,
              -3128.524,
              1516.177
            ],
            [
              1692.78,
              -3098.159,
              1546.826
            ],
            [
              1693.427,
              -3075.022,
              1569.972
            ],
            [
              1690.731,
              -2873.474,
              1771.538
            ],
            [
              1684.353,
              -2661.838,
              1983.27
            ],
            [
              1680.485,
              -2590.427,
              2054.786
            ],
            [
              1679.547,
              -2554.739,
              2090.487
            ],
            [
              1678.725,
              -2527.718,
              2117.519
            ],
            [
              1679.06,
              -2495.866,
              2149.373
            ],
            [
              1670.601,
              -2049.296,
              2596.024
            ],
            [
              1665.105,
              -1963.474,
              2682.021
            ],
            [
              1665.702,
              -1896.69,
              2748.808
            ],
            [
              1663.09,
              -1759.712,
              2885.811
            ],
            [
              1657.26,
              -1724.669,
              2921.336
            ],
            [
              1660.464,
              -1692.869,
              2953.297
            ],
            [
              1642.718,
              -1572.308,
              3075.157
            ],
            [
              1626.598,
              -1502.988,
              3146.326
            ],
            [
              1590.763,
              -1384.318,
              3270.289
            ],
            [
              1541.473,
              -1260.946,
              3403.143
            ],
            [
              1439.941,
              -1068.699,
              3620.554
            ],
            [
              1422.22,
              -1045.077,
              3650.084
            ],
            [
              1413.029,
              -1024.784,
              3672.361
            ],
            [
              1382.574,
              -969.885,
              3735.142
            ],
            [
              1372.327,
              -959.462,
              3749.758
            ],
            [
              1333.941,
              -943.166,
              3791.46
            ],
            [
              1307.513,
              -942.677,
              3817.893
            ],
            [
              1293.291,
              -944.641,
              3832.25
            ],
            [
              1278.614,
              -942.95,
              3847.024
            ],
            [
              1269.114,
              -935.31,
              3859.215
            ],
            [
              1257.937,
              -924.707,
              3874.621
            ],
            [
              1253.197,
              -916.068,
              3884.475
            ],
            [
              1249.597,
              -901.529,
              3899.453
            ],
            [
              1250.468,
              -889.3,
              3911.713
            ],
            [
              1243.124,
              -868.013,
              3934.231
            ],
            [
              1234.408,
              -851.153,
              3953.211
            ],
            [
              1218.52,
              -838.613,
              3973.451
            ],
            [
              1192.86,
              -831.46,
              4000.09
            ],
            [
              1155.132,
              -824.781,
              4038.405
            ],
            [
              1120.288,
              -815.648,
              4074.425
            ],
            [
              1031.058,
              -793.963,
              4166.253
            ],
            [
              773.373,
              -745.803,
              4428.399
            ],
            [
              730.608,
              -739.605,
              4471.612
            ],
            [
              702.691,
              -732.259,
              4500.478
            ],
            [
              508.13,
              -687.5,
              4700.122
            ],
            [
              443.852,
              -676.304,
              4765.367
            ],
            [
              405.738,
              -680.059,
              4803.666
            ],
            [
              363.165,
              -686.919,
              4846.788
            ],
            [
              341.718,
              -690.021,
              4868.458
            ],
            [
              237.095,
              -710.389,
              4975.045
            ],
            [
              219.749,
              -721.682,
              4995.744
            ],
            [
              73.653,
              -750.808,
              5144.715
            ],
            [
              -18.428,
              -779.188,
              5241.07
            ],
            [
              -55.388,
              -799.514,
              5283.251
            ],
            [
              -306.711,
              -924.235,
              5563.819
            ],
            [
              -475.993,
              -1014.678,
              5755.747
            ],
            [
              -535.166,
              -1050.172,
              5824.748
            ],
            [
              -673.187,
              -1080.133,
              5965.984
            ],
            [
              -764.624,
              -1108.462,
              6061.709
            ],
            [
              -829.227,
              -1116.28,
              6126.783
            ],
            [
              -865.018,
              -1134.559,
              6166.972
            ],
            [
              -891.825,
              -1155.228,
              6200.822
            ],
            [
              -898.939,
              -1163.415,
              6211.668
            ],
            [
              -908.077,
              -1171.394,
              6223.799
            ],
            [
              -917.363,
              -1177.032,
              6234.662
            ],
            [
              -929.666,
              -1178.977,
              6247.118
            ],
            [
              -961.877,
              -1178.457,
              6279.333
            ],
            [
              -977.23,
              -1175.77,
              6294.919
            ],
            [
              -995.797,
              -1164.488,
              6316.646
            ],
            [
              -1006.474,
              -1148.711,
              6335.696
            ],
            [
              -1029.882,
              -1123.799,
              6369.88
            ],
            [
              -1062.634,
              -1116.531,
              6403.428
            ],
            [
              -1097.251,
              -1122.142,
              6438.498
            ],
            [
              -1143.947,
              -1120.636,
              6485.217
            ],
            [
              -1339.338,
              -1158.32,
              6684.209
            ],
            [
              -1374.945,
              -1168.896,
              6721.354
            ],
            [
              -1791.301,
              -1230.398,
              7142.228
            ],
            [
              -1855.793,
              -1231.475,
              7206.729
            ],
            [
              -1940.187,
              -1227.747,
              7291.205
            ],
            [
              -2027.705,
              -1218.399,
              7379.221
            ],
            [
              -2166.609,
              -1198.122,
              7519.597
            ],
            [
              -2255.397,
              -1187.643,
              7609.001
            ],
            [
              -2266.36,
              -1186.843,
              7619.993
            ],
            [
              -2295.924,
              -1182.472,
              7649.879
            ],
            [
              -2392.506,
              -1175.197,
              7746.734
            ],
            [
              -2431.277,
              -1180.078,
              7785.811
            ],
            [
              -2478.584,
              -1193.714,
              7835.044
            ],
            [
              -2533.196,
              -1219.467,
              7895.424
            ],
            [
              -2617.204,
              -1266.966,
              7991.93
            ],
            [
              -2663.944,
              -1285.067,
              8042.053
            ],
            [
              -2710.565,
              -1296.491,
              8090.053
            ],
            [
              -2762.381,
              -1304.469,
              8142.48
            ],
            [
              -2808.767,
              -1305.331,
              8188.874
            ],
            [
              -2858.119,
              -1300.984,
              8238.417
            ],
            [
              -3071.028,
              -1263.439,
              8454.611
            ],
            [
              -3139.719,
              -1251.188,
              8524.386
            ],
            [
              -3159.719,
              -1247.413,
              8544.739
            ],
            [
              -3359.526,
              -1207.182,
              8748.556
            ],
            [
              -3495.953,
              -1192.555,
              8885.765
            ],
            [
              -3569.469,
              -1193.5,
              8959.287
            ],
            [
              -3626.266,
              -1196.964,
              9016.189
            ],
            [
              -3657.704,
              -1114.039,
              9104.874
            ],
            [
              -3677.364,
              -1066.903,
              9155.946
            ],
            [
              -3685.368,
              -1042.059,
              9182.047
            ],
            [
              -3720.918,
              -930.373,
              9299.254
            ],
            [
              -3751.424,
              -837.404,
              9397.1
            ],
            [
              -3758.325,
              -817.25,
              9418.403
            ],
            [
              -3766.218,
              -791.548,
              9445.29
            ],
            [
              -3793.988,
              -719.82,
              9522.206
            ],
            [
              -3843.779,
              -616.54,
              9636.861
            ],
            [
              -3881.258,
              -546.871,
              9715.972
            ],
            [
              -3892.746,
              -539.992,
              9729.362
            ],
            [
              -3915.211,
              -534.036,
              9752.603
            ],
            [
              -4013.321,
              -576.864,
              9859.653
            ],
            [
              -4103.192,
              -441.723,
              10021.949
            ],
            [
              -4120.29,
              -416.592,
              10052.345
            ],
            [
              -4130.843,
              -399.669,
              10072.289
            ],
            [
              -4155.783,
              -350.644,
              10127.293
            ],
            [
              -4237.762,
              -243.473,
              10262.223
            ],
            [
              -4351.477,
              -138.439,
              10417.024
            ],
            [
              -4426.18,
              -63.224,
              10523.032
            ],
            [
              -4445.371,
              -41.623,
              10551.927
            ],
            [
              -4460.208,
              -16.996,
              10580.678
            ],
            [
              -4494.728,
              38.145,
              10645.733
            ],
            [
              -4529.153,
              107.182,
              10722.878
            ],
            [
              -4592.389,
              246.88,
              10876.221
            ],
            [
              -4602.309,
              268.218,
              10899.752
            ],
            [
              -4641.216,
              408.021,
              11044.868
            ],
            [
              -4659.752,
              487.017,
              11126.01
            ],
            [
              -4661.513,
              502.991,
              11142.08
            ],
            [
              -4670.535,
              540.995,
              11181.141
            ],
            [
              -4686.12,
              572.432,
              11216.229
            ],
            [
              -4701.876,
              593.853,
              11242.82
            ],
            [
              -4704.928,
              603.925,
              11253.345
            ],
            [
              -4700.939,
              612.618,
              11262.909
            ],
            [
              -4692.51,
              618.683,
              11273.293
            ],
            [
              -4676.757,
              618.614,
              11289.046
            ],
            [
              -4666.006,
              610.655,
              11302.423
            ],
            [
              -4635.88,
              552.048,
              11368.32
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:5508",
              "position": {
                "x": 1128.033,
                "z": -4270.188
              },
              "distanceAlongShapeM": 122.207,
              "shapeOffsetM": 0.046,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:5149",
              "position": {
                "x": 1393.375,
                "z": -3755.212
              },
              "distanceAlongShapeM": 800.374,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:5086",
              "position": {
                "x": 1607.644,
                "z": -3390.704
              },
              "distanceAlongShapeM": 1227.17,
              "shapeOffsetM": 2.933,
              "arrivalOffsetSeconds": 330,
              "departureOffsetSeconds": 330
            },
            {
              "stopId": "judu:stop:5087",
              "position": {
                "x": 1687.839,
                "z": -3098.296
              },
              "distanceAlongShapeM": 1546.826,
              "shapeOffsetM": 4.943,
              "arrivalOffsetSeconds": 390,
              "departureOffsetSeconds": 390
            },
            {
              "stopId": "judu:stop:5088",
              "position": {
                "x": 1670.083,
                "z": -2527.983
              },
              "distanceAlongShapeM": 2117.518,
              "shapeOffsetM": 8.646,
              "arrivalOffsetSeconds": 510,
              "departureOffsetSeconds": 510
            },
            {
              "stopId": "judu:stop:5658",
              "position": {
                "x": 1653.419,
                "z": -1725.022
              },
              "distanceAlongShapeM": 2921.336,
              "shapeOffsetM": 3.857,
              "arrivalOffsetSeconds": 690,
              "departureOffsetSeconds": 690
            },
            {
              "stopId": "judu:stop:5661",
              "position": {
                "x": 1418.417,
                "z": -1047.149
              },
              "distanceAlongShapeM": 3650.084,
              "shapeOffsetM": 4.331,
              "arrivalOffsetSeconds": 810,
              "departureOffsetSeconds": 810
            },
            {
              "stopId": "judu:stop:5662",
              "position": {
                "x": 1154.205,
                "z": -829.633
              },
              "distanceAlongShapeM": 4038.405,
              "shapeOffsetM": 4.939,
              "arrivalOffsetSeconds": 930,
              "departureOffsetSeconds": 930
            },
            {
              "stopId": "judu:stop:5664",
              "position": {
                "x": 729.54,
                "z": -744.998
              },
              "distanceAlongShapeM": 4471.612,
              "shapeOffsetM": 5.498,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:677",
              "position": {
                "x": 364.219,
                "z": -693.772
              },
              "distanceAlongShapeM": 4846.788,
              "shapeOffsetM": 6.934,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:753",
              "position": {
                "x": -53.078,
                "z": -805.275
              },
              "distanceAlongShapeM": 5283.742,
              "shapeOffsetM": 6.187,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:7382",
              "position": {
                "x": -534.689,
                "z": -1051.466
              },
              "distanceAlongShapeM": 5824.748,
              "shapeOffsetM": 1.38,
              "arrivalOffsetSeconds": 1380,
              "departureOffsetSeconds": 1380
            },
            {
              "stopId": "judu:stop:988",
              "position": {
                "x": -763.423,
                "z": -1114.127
              },
              "distanceAlongShapeM": 6061.709,
              "shapeOffsetM": 5.791,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            },
            {
              "stopId": "judu:stop:6404",
              "position": {
                "x": -1096.995,
                "z": -1127.045
              },
              "distanceAlongShapeM": 6438.498,
              "shapeOffsetM": 4.91,
              "arrivalOffsetSeconds": 1560,
              "departureOffsetSeconds": 1560
            },
            {
              "stopId": "judu:stop:814",
              "position": {
                "x": -1374.402,
                "z": -1172.164
              },
              "distanceAlongShapeM": 6721.354,
              "shapeOffsetM": 3.313,
              "arrivalOffsetSeconds": 1680,
              "departureOffsetSeconds": 1680
            },
            {
              "stopId": "judu:stop:5906",
              "position": {
                "x": -2267.097,
                "z": -1193.002
              },
              "distanceAlongShapeM": 7619.993,
              "shapeOffsetM": 6.203,
              "arrivalOffsetSeconds": 1800,
              "departureOffsetSeconds": 1800
            },
            {
              "stopId": "judu:stop:7415",
              "position": {
                "x": -3140.52,
                "z": -1255.542
              },
              "distanceAlongShapeM": 8524.386,
              "shapeOffsetM": 4.427,
              "arrivalOffsetSeconds": 1920,
              "departureOffsetSeconds": 1920
            },
            {
              "stopId": "judu:stop:5643",
              "position": {
                "x": -3680.758,
                "z": -1067.996
              },
              "distanceAlongShapeM": 9155.946,
              "shapeOffsetM": 3.566,
              "arrivalOffsetSeconds": 2100,
              "departureOffsetSeconds": 2100
            },
            {
              "stopId": "judu:stop:5646",
              "position": {
                "x": -3761.526,
                "z": -818.346
              },
              "distanceAlongShapeM": 9418.403,
              "shapeOffsetM": 3.383,
              "arrivalOffsetSeconds": 2160,
              "departureOffsetSeconds": 2160
            },
            {
              "stopId": "judu:stop:5915",
              "position": {
                "x": -4126.033,
                "z": -420.177
              },
              "distanceAlongShapeM": 10052.345,
              "shapeOffsetM": 6.77,
              "arrivalOffsetSeconds": 2280,
              "departureOffsetSeconds": 2280
            },
            {
              "stopId": "judu:stop:5919",
              "position": {
                "x": -4449.727,
                "z": -45.007
              },
              "distanceAlongShapeM": 10551.927,
              "shapeOffsetM": 5.516,
              "arrivalOffsetSeconds": 2400,
              "departureOffsetSeconds": 2400
            },
            {
              "stopId": "judu:stop:5920",
              "position": {
                "x": -4608.183,
                "z": 266.076
              },
              "distanceAlongShapeM": 10899.752,
              "shapeOffsetM": 6.252,
              "arrivalOffsetSeconds": 2460,
              "departureOffsetSeconds": 2460
            },
            {
              "stopId": "judu:stop:5923",
              "position": {
                "x": -4663.089,
                "z": 486.32
              },
              "distanceAlongShapeM": 11126.01,
              "shapeOffsetM": 3.409,
              "arrivalOffsetSeconds": 2520,
              "departureOffsetSeconds": 2520
            }
          ],
          "departuresSeconds": [
            21180,
            22800,
            24180,
            25560,
            26640,
            27600,
            28440,
            29340,
            30420,
            31380,
            32460,
            33720,
            35040,
            36300,
            37260,
            38580,
            40800,
            42780,
            44820,
            46920,
            49200,
            51120,
            53340,
            54900,
            55920,
            56880,
            58020,
            59100,
            60300,
            61080,
            62100,
            63000,
            64140,
            65340,
            66660,
            68160,
            69720,
            71640,
            73680,
            75360,
            77400,
            79140,
            81120,
            83160
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_trol_10",
      "sourceRouteId": "vilnius_trol_10",
      "mode": "trolleybus",
      "shortName": "10",
      "longName": "Saulėtekis–Kalvarijų g.–Naujininkai",
      "color": "DC3131",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_trol_10:0",
          "sourceRouteId": "vilnius_trol_10",
          "sourceShapeId": "vilnius_trol_10_a-b",
          "directionId": 0,
          "headsign": "Naujininkai",
          "directionName": "Saulėtekis–Kalvarijų g.–Naujininkai",
          "mode": "trolleybus",
          "routeShortName": "10",
          "routeLongName": "Saulėtekis–Kalvarijų g.–Naujininkai",
          "routeColor": "DC3131",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              3954.003,
              -4105.097,
              0
            ],
            [
              3949.52,
              -4094.868,
              11.169
            ],
            [
              3943.333,
              -4069.038,
              37.729
            ],
            [
              3940.538,
              -4057,
              50.087
            ],
            [
              3918.536,
              -4045.003,
              75.147
            ],
            [
              3899.276,
              -4037.251,
              95.909
            ],
            [
              3898.616,
              -4036.13,
              97.209
            ],
            [
              3858.828,
              -4027.577,
              137.906
            ],
            [
              3592.048,
              -4028.061,
              404.687
            ],
            [
              3581.678,
              -4031.203,
              415.522
            ],
            [
              3564.996,
              -4038.354,
              433.672
            ],
            [
              3520.083,
              -4051.184,
              480.382
            ],
            [
              3445.458,
              -4078.711,
              559.922
            ],
            [
              3358.965,
              -4120.486,
              655.975
            ],
            [
              3358.852,
              -4122.75,
              658.242
            ],
            [
              3310.064,
              -4150.73,
              714.484
            ],
            [
              3021.059,
              -4338.966,
              1059.385
            ],
            [
              2959.695,
              -4278.804,
              1145.321
            ],
            [
              2940.311,
              -4262.522,
              1170.635
            ],
            [
              2920.517,
              -4237.987,
              1202.16
            ],
            [
              2810.169,
              -4110.107,
              1371.068
            ],
            [
              2739.116,
              -4050.879,
              1463.569
            ],
            [
              2661.391,
              -4003.772,
              1554.455
            ],
            [
              2637.654,
              -3993.387,
              1580.365
            ],
            [
              2624.428,
              -3981.925,
              1597.866
            ],
            [
              2519.252,
              -3920.945,
              1719.441
            ],
            [
              2498.616,
              -3902.574,
              1747.07
            ],
            [
              2481.543,
              -3870.14,
              1783.723
            ],
            [
              2477.811,
              -3839.994,
              1814.099
            ],
            [
              2486.808,
              -3795.651,
              1859.346
            ],
            [
              2504.454,
              -3737.639,
              1919.982
            ],
            [
              2509.229,
              -3731.078,
              1928.097
            ],
            [
              2516.335,
              -3727.718,
              1935.957
            ],
            [
              2523.372,
              -3727.648,
              1942.994
            ],
            [
              2538.183,
              -3736.5,
              1960.249
            ],
            [
              2569.187,
              -3809.611,
              2039.663
            ],
            [
              2575.274,
              -3839.824,
              2070.482
            ],
            [
              2574.802,
              -3870.332,
              2100.995
            ],
            [
              2567.828,
              -3895.962,
              2127.556
            ],
            [
              2541.083,
              -3951.972,
              2189.624
            ],
            [
              2518.107,
              -3984.62,
              2229.546
            ],
            [
              2481.327,
              -4031.329,
              2288.998
            ],
            [
              2454.012,
              -4066.67,
              2333.664
            ],
            [
              2436.763,
              -4093.064,
              2365.195
            ],
            [
              2406.107,
              -4181.549,
              2458.84
            ],
            [
              2398.976,
              -4218.153,
              2496.132
            ],
            [
              2394.879,
              -4264.833,
              2542.992
            ],
            [
              2388.205,
              -4311.465,
              2590.099
            ],
            [
              2381.138,
              -4344.73,
              2624.106
            ],
            [
              2380.534,
              -4359.108,
              2638.497
            ],
            [
              2363.369,
              -4398.946,
              2681.875
            ],
            [
              2340.823,
              -4433.034,
              2722.745
            ],
            [
              2328.252,
              -4450.61,
              2744.354
            ],
            [
              2298.04,
              -4481.215,
              2787.359
            ],
            [
              2296.644,
              -4486.96,
              2793.271
            ],
            [
              2297.644,
              -4502.36,
              2808.704
            ],
            [
              2324.901,
              -4526.249,
              2844.948
            ],
            [
              2369.547,
              -4550.465,
              2895.738
            ],
            [
              2386.895,
              -4553.017,
              2913.273
            ],
            [
              2397.928,
              -4548.771,
              2925.095
            ],
            [
              2404.556,
              -4538.876,
              2937.004
            ],
            [
              2405.535,
              -4521.082,
              2954.825
            ],
            [
              2396.166,
              -4505.32,
              2973.162
            ],
            [
              2310.611,
              -4463.639,
              3068.33
            ],
            [
              2264.435,
              -4428.158,
              3126.563
            ],
            [
              2254.143,
              -4416.937,
              3141.789
            ],
            [
              2239.684,
              -4397.741,
              3165.821
            ],
            [
              2102.49,
              -4258.698,
              3361.155
            ],
            [
              2005.819,
              -4155.131,
              3502.828
            ],
            [
              1848.669,
              -3978.532,
              3739.225
            ],
            [
              1832.856,
              -3962.652,
              3761.635
            ],
            [
              1812.233,
              -3946.912,
              3787.579
            ],
            [
              1800.044,
              -3925.303,
              3812.388
            ],
            [
              1667.691,
              -3765.872,
              4019.597
            ],
            [
              1499.686,
              -3582.404,
              4268.367
            ],
            [
              1482.767,
              -3556.485,
              4299.319
            ],
            [
              1455.612,
              -3532.495,
              4335.554
            ],
            [
              1443.07,
              -3507.879,
              4363.18
            ],
            [
              1391.152,
              -3457.934,
              4435.222
            ],
            [
              1338.486,
              -3413.541,
              4504.102
            ],
            [
              1317.474,
              -3399.793,
              4529.212
            ],
            [
              978.337,
              -3198.709,
              4923.481
            ],
            [
              945.685,
              -3186.974,
              4958.178
            ],
            [
              931.778,
              -3172.246,
              4978.435
            ],
            [
              710.47,
              -3045.716,
              5233.36
            ],
            [
              680.065,
              -3035.6,
              5265.404
            ],
            [
              665.217,
              -3018.166,
              5288.304
            ],
            [
              624.331,
              -2998.49,
              5333.678
            ],
            [
              521.572,
              -2978.793,
              5438.308
            ],
            [
              506.876,
              -2971.844,
              5454.564
            ],
            [
              504.844,
              -2912.819,
              5513.624
            ],
            [
              509.397,
              -2869.472,
              5557.21
            ],
            [
              513.301,
              -2797.183,
              5629.604
            ],
            [
              494.515,
              -2626.513,
              5801.305
            ],
            [
              487.991,
              -2601.316,
              5827.333
            ],
            [
              485.911,
              -2568.466,
              5860.248
            ],
            [
              462.343,
              -2342.047,
              6087.891
            ],
            [
              451.425,
              -2269.486,
              6161.269
            ],
            [
              407.333,
              -2116.119,
              6320.847
            ],
            [
              406.254,
              -2096.107,
              6340.889
            ],
            [
              361.405,
              -1904.922,
              6537.264
            ],
            [
              342.249,
              -1718.661,
              6724.507
            ],
            [
              326.222,
              -1640.218,
              6804.571
            ],
            [
              326.097,
              -1614.835,
              6829.954
            ],
            [
              277.22,
              -1255.479,
              7192.619
            ],
            [
              271.867,
              -1230.89,
              7217.784
            ],
            [
              269.371,
              -1219.076,
              7229.859
            ],
            [
              267.28,
              -1199.635,
              7249.412
            ],
            [
              257.056,
              -1141.194,
              7308.74
            ],
            [
              216.915,
              -885.896,
              7567.175
            ],
            [
              226.048,
              -703.492,
              7749.807
            ],
            [
              223.795,
              -685.64,
              7767.801
            ],
            [
              209.218,
              -636.391,
              7819.162
            ],
            [
              192.022,
              -589.321,
              7869.275
            ],
            [
              159.237,
              -513.023,
              7952.318
            ],
            [
              151.725,
              -500.641,
              7966.801
            ],
            [
              143.086,
              -479.332,
              7989.794
            ],
            [
              126.134,
              -439.133,
              8033.422
            ],
            [
              119.827,
              -411,
              8062.253
            ],
            [
              106.146,
              -277.163,
              8196.787
            ],
            [
              35.151,
              -280.322,
              8267.853
            ],
            [
              -101.904,
              -298.979,
              8406.172
            ],
            [
              -140.054,
              -304.394,
              8444.704
            ],
            [
              -153.37,
              -311.158,
              8459.639
            ],
            [
              -191.836,
              -315.156,
              8498.312
            ],
            [
              -244.276,
              -326.45,
              8551.955
            ],
            [
              -305.298,
              -348.72,
              8616.914
            ],
            [
              -413.017,
              -421.354,
              8746.833
            ],
            [
              -450.326,
              -380.602,
              8802.084
            ],
            [
              -465.596,
              -369.193,
              8821.146
            ],
            [
              -470.512,
              -355.745,
              8835.464
            ],
            [
              -508.466,
              -314.982,
              8891.161
            ],
            [
              -611.52,
              -58.189,
              9167.861
            ],
            [
              -614.075,
              -53.155,
              9173.506
            ],
            [
              -625.745,
              -24.535,
              9204.414
            ],
            [
              -643.846,
              18.014,
              9250.653
            ],
            [
              -652.524,
              63.893,
              9297.345
            ],
            [
              -679.973,
              222.467,
              9458.277
            ],
            [
              -691.721,
              250.51,
              9488.682
            ],
            [
              -832.714,
              443.415,
              9727.62
            ],
            [
              -840.816,
              459.146,
              9745.315
            ],
            [
              -843.214,
              469.208,
              9755.658
            ],
            [
              -833.842,
              667.193,
              9953.865
            ],
            [
              -824.076,
              731.394,
              10018.805
            ],
            [
              -800.789,
              819.11,
              10109.559
            ],
            [
              -787.05,
              855.14,
              10148.12
            ],
            [
              -767.948,
              887.538,
              10185.73
            ],
            [
              -708.773,
              1021.171,
              10331.879
            ],
            [
              -697.048,
              1063.262,
              10375.572
            ],
            [
              -655.787,
              1240.633,
              10557.679
            ],
            [
              -653.864,
              1286.859,
              10603.945
            ],
            [
              -631.67,
              1361.539,
              10681.853
            ],
            [
              -535.95,
              1804.839,
              11135.37
            ],
            [
              -507.688,
              1932.818,
              11266.433
            ],
            [
              -496.901,
              1964.699,
              11300.089
            ],
            [
              -462.075,
              2106.562,
              11446.164
            ],
            [
              -436.719,
              2188.482,
              11531.918
            ],
            [
              -427.991,
              2207.248,
              11552.615
            ],
            [
              -344.32,
              2338.207,
              11708.021
            ],
            [
              -326.137,
              2380.181,
              11753.764
            ],
            [
              -285.296,
              2533.066,
              11912.01
            ],
            [
              -285.194,
              2584.883,
              11963.827
            ],
            [
              -278.461,
              2625.339,
              12004.84
            ],
            [
              -246.605,
              2887.483,
              12268.912
            ],
            [
              -240.554,
              2897.49,
              12280.607
            ],
            [
              -220.477,
              2901.557,
              12301.091
            ],
            [
              -210.989,
              2900.387,
              12310.651
            ],
            [
              -205.005,
              2887.499,
              12324.86
            ],
            [
              -199.456,
              2858.125,
              12354.754
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:6239",
              "position": {
                "x": 3898.552,
                "z": -4039.468
              },
              "distanceAlongShapeM": 95.752,
              "shapeOffsetM": 2.327,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:5116",
              "position": {
                "x": 3565.986,
                "z": -4043.151
              },
              "distanceAlongShapeM": 434.038,
              "shapeOffsetM": 4.885,
              "arrivalOffsetSeconds": 60,
              "departureOffsetSeconds": 60
            },
            {
              "stopId": "judu:stop:6715",
              "position": {
                "x": 3360.169,
                "z": -4124.962
              },
              "distanceAlongShapeM": 658.242,
              "shapeOffsetM": 2.574,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:5103",
              "position": {
                "x": 2937.404,
                "z": -4265.024
              },
              "distanceAlongShapeM": 1170.635,
              "shapeOffsetM": 3.836,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:5117",
              "position": {
                "x": 2636.416,
                "z": -3995.509
              },
              "distanceAlongShapeM": 1580.365,
              "shapeOffsetM": 2.457,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:5485",
              "position": {
                "x": 2577.544,
                "z": -3870.831
              },
              "distanceAlongShapeM": 2100.995,
              "shapeOffsetM": 2.787,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:5490",
              "position": {
                "x": 2383.36,
                "z": -4363.697
              },
              "distanceAlongShapeM": 2641.593,
              "shapeOffsetM": 4.411,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:5491",
              "position": {
                "x": 2261.601,
                "z": -4431.549
              },
              "distanceAlongShapeM": 3126.563,
              "shapeOffsetM": 4.419,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:5494",
              "position": {
                "x": 1811.224,
                "z": -3947.777
              },
              "distanceAlongShapeM": 3787.579,
              "shapeOffsetM": 1.329,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:5125",
              "position": {
                "x": 1455.5,
                "z": -3532.601
              },
              "distanceAlongShapeM": 4335.554,
              "shapeOffsetM": 0.154,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:5127",
              "position": {
                "x": 945.685,
                "z": -3186.974
              },
              "distanceAlongShapeM": 4958.178,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:5128",
              "position": {
                "x": 679.709,
                "z": -3036.244
              },
              "distanceAlongShapeM": 5265.404,
              "shapeOffsetM": 0.735,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:5347",
              "position": {
                "x": 482.722,
                "z": -2601.805
              },
              "distanceAlongShapeM": 5827.333,
              "shapeOffsetM": 5.291,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            },
            {
              "stopId": "judu:stop:5351",
              "position": {
                "x": 407.176,
                "z": -2116.162
              },
              "distanceAlongShapeM": 6320.847,
              "shapeOffsetM": 0.163,
              "arrivalOffsetSeconds": 1380,
              "departureOffsetSeconds": 1380
            },
            {
              "stopId": "judu:stop:5467",
              "position": {
                "x": 324.984,
                "z": -1640.419
              },
              "distanceAlongShapeM": 6804.571,
              "shapeOffsetM": 1.254,
              "arrivalOffsetSeconds": 1560,
              "departureOffsetSeconds": 1560
            },
            {
              "stopId": "judu:stop:5378",
              "position": {
                "x": 265.625,
                "z": -1219.643
              },
              "distanceAlongShapeM": 7229.859,
              "shapeOffsetM": 3.789,
              "arrivalOffsetSeconds": 1620,
              "departureOffsetSeconds": 1620
            },
            {
              "stopId": "judu:stop:5244",
              "position": {
                "x": 121.213,
                "z": -441.083
              },
              "distanceAlongShapeM": 8033.422,
              "shapeOffsetM": 5.293,
              "arrivalOffsetSeconds": 1860,
              "departureOffsetSeconds": 1860
            },
            {
              "stopId": "judu:stop:5249",
              "position": {
                "x": -153.095,
                "z": -312.52
              },
              "distanceAlongShapeM": 8459.639,
              "shapeOffsetM": 1.39,
              "arrivalOffsetSeconds": 2040,
              "departureOffsetSeconds": 2040
            },
            {
              "stopId": "judu:stop:5257",
              "position": {
                "x": -465.596,
                "z": -369.193
              },
              "distanceAlongShapeM": 8821.146,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2160,
              "departureOffsetSeconds": 2160
            },
            {
              "stopId": "judu:stop:5264",
              "position": {
                "x": -646.921,
                "z": 17.037
              },
              "distanceAlongShapeM": 9250.653,
              "shapeOffsetM": 3.227,
              "arrivalOffsetSeconds": 2280,
              "departureOffsetSeconds": 2280
            },
            {
              "stopId": "judu:stop:5266",
              "position": {
                "x": -793.638,
                "z": 857.944
              },
              "distanceAlongShapeM": 10148.12,
              "shapeOffsetM": 7.159,
              "arrivalOffsetSeconds": 2520,
              "departureOffsetSeconds": 2520
            },
            {
              "stopId": "judu:stop:5272",
              "position": {
                "x": -656.233,
                "z": 1287.397
              },
              "distanceAlongShapeM": 10603.945,
              "shapeOffsetM": 2.429,
              "arrivalOffsetSeconds": 2640,
              "departureOffsetSeconds": 2640
            },
            {
              "stopId": "judu:stop:7851",
              "position": {
                "x": -511.654,
                "z": 1933.795
              },
              "distanceAlongShapeM": 11266.433,
              "shapeOffsetM": 4.085,
              "arrivalOffsetSeconds": 2820,
              "departureOffsetSeconds": 2820
            },
            {
              "stopId": "judu:stop:5173",
              "position": {
                "x": -290.153,
                "z": 2585.475
              },
              "distanceAlongShapeM": 11963.827,
              "shapeOffsetM": 4.994,
              "arrivalOffsetSeconds": 3000,
              "departureOffsetSeconds": 3000
            },
            {
              "stopId": "judu:stop:5200",
              "position": {
                "x": -196.145,
                "z": 2858.737
              },
              "distanceAlongShapeM": 12354.754,
              "shapeOffsetM": 3.367,
              "arrivalOffsetSeconds": 3060,
              "departureOffsetSeconds": 3060
            }
          ],
          "departuresSeconds": [
            19440,
            20400,
            21480,
            22800,
            23400,
            24240,
            25020,
            25740,
            27180,
            28620,
            30360,
            31860,
            32820,
            33840,
            35280,
            36780,
            37980,
            39300,
            40560,
            42000,
            43380,
            44580,
            46080,
            47400,
            49140,
            50280,
            51480,
            53100,
            54480,
            55200,
            56040,
            57240,
            58440,
            59040,
            60180,
            61680,
            62700,
            63660,
            64920,
            66660,
            68220,
            69960,
            71400,
            72960,
            74220,
            75480,
            77040,
            78300,
            79620,
            80700,
            82020
          ]
        },
        {
          "id": "judu:pattern:vilnius_trol_10:1",
          "sourceRouteId": "vilnius_trol_10",
          "sourceShapeId": "vilnius_trol_10_b-a",
          "directionId": 1,
          "headsign": "Saulėtekis",
          "directionName": "Naujininkai–Kalvarijų g.–Saulėtekis",
          "mode": "trolleybus",
          "routeShortName": "10",
          "routeLongName": "Saulėtekis–Kalvarijų g.–Naujininkai",
          "routeColor": "DC3131",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              -199.456,
              2858.125,
              0
            ],
            [
              -199.082,
              2844.922,
              13.208
            ],
            [
              -203.563,
              2834.855,
              24.227
            ],
            [
              -247.856,
              2818.486,
              71.449
            ],
            [
              -268.934,
              2604.253,
              286.716
            ],
            [
              -287.151,
              2501.929,
              390.649
            ],
            [
              -327.226,
              2355.709,
              542.261
            ],
            [
              -350.367,
              2324.958,
              580.747
            ],
            [
              -412.128,
              2228.113,
              695.609
            ],
            [
              -425.492,
              2202.75,
              724.278
            ],
            [
              -439.803,
              2160.707,
              768.689
            ],
            [
              -445.668,
              2121.85,
              807.987
            ],
            [
              -471.768,
              2034.377,
              899.27
            ],
            [
              -499.661,
              1919.106,
              1017.868
            ],
            [
              -512.556,
              1856.885,
              1081.411
            ],
            [
              -515.909,
              1841.571,
              1097.088
            ],
            [
              -530.605,
              1766.267,
              1173.813
            ],
            [
              -536.862,
              1752.795,
              1188.667
            ],
            [
              -542.324,
              1736.195,
              1206.142
            ],
            [
              -601.244,
              1474.539,
              1474.35
            ],
            [
              -678.532,
              1124.155,
              1833.157
            ],
            [
              -683.338,
              1093.819,
              1863.872
            ],
            [
              -691.829,
              1066.507,
              1892.473
            ],
            [
              -722.413,
              980.227,
              1984.013
            ],
            [
              -789.726,
              824.476,
              2153.687
            ],
            [
              -808.22,
              764.696,
              2216.263
            ],
            [
              -816.493,
              725.027,
              2256.785
            ],
            [
              -824.878,
              699.315,
              2283.83
            ],
            [
              -838.2,
              496.948,
              2486.635
            ],
            [
              -838.156,
              463.551,
              2520.032
            ],
            [
              -823.183,
              435.45,
              2551.873
            ],
            [
              -689.434,
              255.78,
              2775.86
            ],
            [
              -671.067,
              215.627,
              2820.014
            ],
            [
              -634.631,
              19.041,
              3019.949
            ],
            [
              -585.127,
              -96.516,
              3145.663
            ],
            [
              -572.146,
              -122.078,
              3174.332
            ],
            [
              -567.275,
              -143.594,
              3196.392
            ],
            [
              -513.161,
              -289.293,
              3351.816
            ],
            [
              -501.093,
              -299.53,
              3367.641
            ],
            [
              -461.426,
              -352.57,
              3433.873
            ],
            [
              -452.174,
              -363.943,
              3448.535
            ],
            [
              -413.017,
              -421.354,
              3518.028
            ],
            [
              -305.298,
              -348.72,
              3647.947
            ],
            [
              -203.339,
              -309.381,
              3757.232
            ],
            [
              -102.285,
              -284.5,
              3861.304
            ],
            [
              -49.535,
              -271.256,
              3915.692
            ],
            [
              -22.626,
              -265.911,
              3943.126
            ],
            [
              -0.545,
              -257.407,
              3966.788
            ],
            [
              58.367,
              -209.498,
              4042.721
            ],
            [
              82.464,
              -196.578,
              4070.063
            ],
            [
              94.753,
              -194.576,
              4082.514
            ],
            [
              102.687,
              -199.192,
              4091.693
            ],
            [
              115.784,
              -208.318,
              4107.656
            ],
            [
              118.351,
              -267.309,
              4166.703
            ],
            [
              118.552,
              -304.106,
              4203.501
            ],
            [
              124.949,
              -377.696,
              4277.368
            ],
            [
              130.203,
              -407.85,
              4307.977
            ],
            [
              144.816,
              -445.964,
              4348.796
            ],
            [
              236.049,
              -695.879,
              4614.843
            ],
            [
              238.113,
              -713.732,
              4632.815
            ],
            [
              217.158,
              -872.542,
              4793.001
            ],
            [
              276.82,
              -1242.113,
              5167.357
            ],
            [
              294.15,
              -1318.635,
              5245.817
            ],
            [
              320.249,
              -1546.82,
              5475.49
            ],
            [
              342.249,
              -1718.661,
              5648.733
            ],
            [
              352.701,
              -1764.728,
              5695.971
            ],
            [
              354.758,
              -1810.175,
              5741.465
            ],
            [
              356.121,
              -1841.371,
              5772.69
            ],
            [
              372.957,
              -1942.984,
              5875.689
            ],
            [
              426.379,
              -2158.817,
              6098.035
            ],
            [
              439.077,
              -2195.331,
              6136.694
            ],
            [
              440.947,
              -2208.066,
              6149.565
            ],
            [
              462.343,
              -2342.047,
              6285.244
            ],
            [
              497.458,
              -2575.098,
              6520.925
            ],
            [
              511.756,
              -2776.003,
              6722.339
            ],
            [
              513.301,
              -2797.183,
              6743.575
            ],
            [
              524.563,
              -2850.825,
              6798.386
            ],
            [
              523.952,
              -2902.017,
              6849.582
            ],
            [
              521.193,
              -2964.305,
              6911.931
            ],
            [
              532.037,
              -2970.195,
              6924.271
            ],
            [
              600.884,
              -2980.955,
              6993.954
            ],
            [
              664.492,
              -3007.747,
              7062.975
            ],
            [
              899.771,
              -3141.112,
              7333.423
            ],
            [
              1021.838,
              -3216.21,
              7476.741
            ],
            [
              1074.157,
              -3240.804,
              7534.553
            ],
            [
              1095.125,
              -3260.979,
              7563.65
            ],
            [
              1260.9,
              -3357.556,
              7755.506
            ],
            [
              1339.233,
              -3407.989,
              7848.67
            ],
            [
              1373.568,
              -3433.117,
              7891.217
            ],
            [
              1493.843,
              -3550.011,
              8058.938
            ],
            [
              1520.486,
              -3572.771,
              8093.979
            ],
            [
              1584,
              -3657.444,
              8199.826
            ],
            [
              1660.25,
              -3750.148,
              8319.86
            ],
            [
              1866.498,
              -3989.997,
              8636.191
            ],
            [
              1889,
              -4009.127,
              8665.726
            ],
            [
              1892.95,
              -4022.775,
              8679.934
            ],
            [
              1975.005,
              -4114.479,
              8802.99
            ],
            [
              2057.826,
              -4199.52,
              8921.696
            ],
            [
              2170.271,
              -4319.627,
              9086.225
            ],
            [
              2237.981,
              -4385.463,
              9180.665
            ],
            [
              2278.639,
              -4416.283,
              9231.684
            ],
            [
              2288.882,
              -4419.815,
              9242.519
            ],
            [
              2297.281,
              -4420.426,
              9250.941
            ],
            [
              2310.823,
              -4417.999,
              9264.698
            ],
            [
              2320.672,
              -4408.165,
              9278.616
            ],
            [
              2330.583,
              -4394.991,
              9295.102
            ],
            [
              2336.672,
              -4379.52,
              9311.728
            ],
            [
              2338.759,
              -4373.358,
              9318.234
            ],
            [
              2352.029,
              -4350.863,
              9344.351
            ],
            [
              2362.441,
              -4310.981,
              9385.57
            ],
            [
              2385.909,
              -4193.416,
              9505.455
            ],
            [
              2408.961,
              -4098.109,
              9603.51
            ],
            [
              2465.77,
              -3886.543,
              9822.57
            ],
            [
              2503.327,
              -3739.507,
              9974.327
            ],
            [
              2513.829,
              -3729.363,
              9988.928
            ],
            [
              2523.211,
              -3727.63,
              9998.469
            ],
            [
              2532.532,
              -3728.601,
              10007.84
            ],
            [
              2540.338,
              -3736.718,
              10019.102
            ],
            [
              2566.251,
              -3786.011,
              10074.791
            ],
            [
              2598.162,
              -3836.707,
              10134.694
            ],
            [
              2614.638,
              -3851.49,
              10156.83
            ],
            [
              2635.392,
              -3877.441,
              10190.059
            ],
            [
              2642.893,
              -3890.985,
              10205.542
            ],
            [
              2709.56,
              -3977.961,
              10315.129
            ],
            [
              3021.059,
              -4338.966,
              10791.948
            ],
            [
              3086.352,
              -4293.444,
              10871.543
            ],
            [
              3112.838,
              -4272.891,
              10905.069
            ],
            [
              3142.482,
              -4255.542,
              10939.416
            ],
            [
              3336.938,
              -4126.748,
              11172.656
            ],
            [
              3389.682,
              -4097.691,
              11232.874
            ],
            [
              3403.448,
              -4088.142,
              11249.628
            ],
            [
              3446.229,
              -4072.046,
              11295.337
            ],
            [
              3528.69,
              -4039.102,
              11384.135
            ],
            [
              3592.048,
              -4028.061,
              11448.448
            ],
            [
              3640.778,
              -4019.583,
              11497.91
            ],
            [
              3666.294,
              -4020.567,
              11523.445
            ],
            [
              3848.026,
              -4019.578,
              11705.179
            ],
            [
              3878.881,
              -4023.507,
              11736.284
            ],
            [
              3901.964,
              -4029.514,
              11760.135
            ],
            [
              3958.181,
              -4055.079,
              11821.892
            ],
            [
              3965.111,
              -4059.221,
              11829.966
            ],
            [
              4018.762,
              -4121.92,
              11912.486
            ],
            [
              4037.773,
              -4172.381,
              11966.409
            ],
            [
              4030.875,
              -4184.064,
              11979.977
            ],
            [
              4020.501,
              -4190.327,
              11992.095
            ],
            [
              4013.086,
              -4190.447,
              11999.511
            ],
            [
              4002.213,
              -4183.979,
              12012.162
            ],
            [
              3961.129,
              -4130.112,
              12079.908
            ],
            [
              3954.003,
              -4105.097,
              12105.918
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:5200",
              "position": {
                "x": -196.145,
                "z": 2858.737
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 3.367,
              "arrivalOffsetSeconds": -450,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:6854",
              "position": {
                "x": -266.588,
                "z": 2603.973
              },
              "distanceAlongShapeM": 286.716,
              "shapeOffsetM": 2.363,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:5168",
              "position": {
                "x": -529.526,
                "z": 1766.021
              },
              "distanceAlongShapeM": 1173.813,
              "shapeOffsetM": 1.107,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:6853",
              "position": {
                "x": -679.739,
                "z": 1093.006
              },
              "distanceAlongShapeM": 1863.872,
              "shapeOffsetM": 3.689,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:5267",
              "position": {
                "x": -810.251,
                "z": 723.543
              },
              "distanceAlongShapeM": 2256.785,
              "shapeOffsetM": 6.416,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:6736",
              "position": {
                "x": -570.097,
                "z": -121.279
              },
              "distanceAlongShapeM": 3174.332,
              "shapeOffsetM": 2.199,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:5258",
              "position": {
                "x": -449.339,
                "z": -361.695
              },
              "distanceAlongShapeM": 3448.535,
              "shapeOffsetM": 3.618,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:5248",
              "position": {
                "x": -50.388,
                "z": -267.632
              },
              "distanceAlongShapeM": 3915.692,
              "shapeOffsetM": 3.723,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:5245",
              "position": {
                "x": 150.182,
                "z": -443.837
              },
              "distanceAlongShapeM": 4348.731,
              "shapeOffsetM": 5.772,
              "arrivalOffsetSeconds": 1050,
              "departureOffsetSeconds": 1050
            },
            {
              "stopId": "judu:stop:6843",
              "position": {
                "x": 297.35,
                "z": -1318.188
              },
              "distanceAlongShapeM": 5245.817,
              "shapeOffsetM": 3.231,
              "arrivalOffsetSeconds": 1290,
              "departureOffsetSeconds": 1290
            },
            {
              "stopId": "judu:stop:6844",
              "position": {
                "x": 356.237,
                "z": -1764.56
              },
              "distanceAlongShapeM": 5695.971,
              "shapeOffsetM": 3.54,
              "arrivalOffsetSeconds": 1470,
              "departureOffsetSeconds": 1470
            },
            {
              "stopId": "judu:stop:6845",
              "position": {
                "x": 441.836,
                "z": -2194.724
              },
              "distanceAlongShapeM": 6136.694,
              "shapeOffsetM": 2.825,
              "arrivalOffsetSeconds": 1530,
              "departureOffsetSeconds": 1530
            },
            {
              "stopId": "judu:stop:5469",
              "position": {
                "x": 505.139,
                "z": -2574.385
              },
              "distanceAlongShapeM": 6520.925,
              "shapeOffsetM": 7.714,
              "arrivalOffsetSeconds": 1650,
              "departureOffsetSeconds": 1650
            },
            {
              "stopId": "judu:stop:6846",
              "position": {
                "x": 602.169,
                "z": -2976.932
              },
              "distanceAlongShapeM": 6993.954,
              "shapeOffsetM": 4.223,
              "arrivalOffsetSeconds": 1800,
              "departureOffsetSeconds": 1800
            },
            {
              "stopId": "judu:stop:6871",
              "position": {
                "x": 1074.9,
                "z": -3239.454
              },
              "distanceAlongShapeM": 7534.553,
              "shapeOffsetM": 1.541,
              "arrivalOffsetSeconds": 1980,
              "departureOffsetSeconds": 1980
            },
            {
              "stopId": "judu:stop:6873",
              "position": {
                "x": 1553.844,
                "z": -3615.694
              },
              "distanceAlongShapeM": 8148.332,
              "shapeOffsetM": 0.929,
              "arrivalOffsetSeconds": 2100,
              "departureOffsetSeconds": 2100
            },
            {
              "stopId": "judu:stop:6874",
              "position": {
                "x": 1889.999,
                "z": -4008.247
              },
              "distanceAlongShapeM": 8665.726,
              "shapeOffsetM": 1.331,
              "arrivalOffsetSeconds": 2160,
              "departureOffsetSeconds": 2160
            },
            {
              "stopId": "judu:stop:5476",
              "position": {
                "x": 2336.174,
                "z": -4371.718
              },
              "distanceAlongShapeM": 9318.333,
              "shapeOffsetM": 3.059,
              "arrivalOffsetSeconds": 2280,
              "departureOffsetSeconds": 2280
            },
            {
              "stopId": "judu:stop:741",
              "position": {
                "x": 2636.723,
                "z": -3876.397
              },
              "distanceAlongShapeM": 10190.059,
              "shapeOffsetM": 1.691,
              "arrivalOffsetSeconds": 2460,
              "departureOffsetSeconds": 2460
            },
            {
              "stopId": "judu:stop:5104",
              "position": {
                "x": 3111.27,
                "z": -4270.537
              },
              "distanceAlongShapeM": 10905.069,
              "shapeOffsetM": 2.828,
              "arrivalOffsetSeconds": 2580,
              "departureOffsetSeconds": 2580
            },
            {
              "stopId": "judu:stop:5105",
              "position": {
                "x": 3402.776,
                "z": -4086.807
              },
              "distanceAlongShapeM": 11249.628,
              "shapeOffsetM": 1.495,
              "arrivalOffsetSeconds": 2640,
              "departureOffsetSeconds": 2640
            },
            {
              "stopId": "judu:stop:5107",
              "position": {
                "x": 3640.634,
                "z": -4014.513
              },
              "distanceAlongShapeM": 11497.91,
              "shapeOffsetM": 5.072,
              "arrivalOffsetSeconds": 2700,
              "departureOffsetSeconds": 2700
            },
            {
              "stopId": "judu:stop:900",
              "position": {
                "x": 3967.843,
                "z": -4055.264
              },
              "distanceAlongShapeM": 11829.966,
              "shapeOffsetM": 4.809,
              "arrivalOffsetSeconds": 2760,
              "departureOffsetSeconds": 2760
            }
          ],
          "departuresSeconds": [
            19860,
            21240,
            22500,
            23700,
            24780,
            26220,
            26820,
            27840,
            28740,
            29640,
            31140,
            32340,
            34080,
            35340,
            36420,
            37320,
            38700,
            40200,
            41400,
            42780,
            44040,
            45420,
            46860,
            48060,
            49860,
            51060,
            52860,
            54000,
            54900,
            56520,
            57960,
            58920,
            59760,
            60960,
            62160,
            62820,
            64080,
            65520,
            66540,
            67500,
            68640,
            70140,
            71760,
            73260,
            74760,
            76260,
            77520,
            78900,
            80100,
            81480,
            82620,
            83820
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_trol_12",
      "sourceRouteId": "vilnius_trol_12",
      "mode": "trolleybus",
      "shortName": "12",
      "longName": "Žirmūnai–Šeimyniškių–Tauro g.–Žemieji Paneriai (Apylanka be Reformatų st.)",
      "color": "DC3131",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_trol_12:0",
          "sourceRouteId": "vilnius_trol_12",
          "sourceShapeId": "vilnius_trol_12_a-b",
          "directionId": 0,
          "headsign": "Žemieji Paneriai (Apylanka be Reformatų st.)",
          "directionName": "Žirmūnai–Šeimyniškių–Tauro g.–Žemieji Paneriai (Apylanka be Reformatų st.)",
          "mode": "trolleybus",
          "routeShortName": "12",
          "routeLongName": "Žirmūnai–Šeimyniškių–Tauro g.–Žemieji Paneriai (Apylanka be Reformatų st.)",
          "routeColor": "DC3131",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              1017.506,
              -4299.224,
              0
            ],
            [
              1021.564,
              -4286.64,
              13.222
            ],
            [
              1026.249,
              -4282.222,
              19.661
            ],
            [
              1105.831,
              -4274.26,
              99.641
            ],
            [
              1128.035,
              -4270.234,
              122.207
            ],
            [
              1147.356,
              -4270.545,
              141.53
            ],
            [
              1189.631,
              -4265.192,
              184.142
            ],
            [
              1202.517,
              -4249.3,
              204.602
            ],
            [
              1214.522,
              -4227.257,
              229.702
            ],
            [
              1220.978,
              -4191.753,
              265.789
            ],
            [
              1217.195,
              -3943.429,
              514.141
            ],
            [
              1219.986,
              -3862.213,
              595.405
            ],
            [
              1375.611,
              -3774.922,
              773.84
            ],
            [
              1393.375,
              -3755.212,
              800.374
            ],
            [
              1412.221,
              -3746.656,
              821.071
            ],
            [
              1509.877,
              -3564.24,
              1027.982
            ],
            [
              1556.885,
              -3486.613,
              1118.733
            ],
            [
              1610.18,
              -3392.177,
              1227.17
            ],
            [
              1620.009,
              -3384.254,
              1239.794
            ],
            [
              1689.847,
              -3267.548,
              1375.8
            ],
            [
              1697.306,
              -3247.648,
              1397.052
            ],
            [
              1696.944,
              -3128.524,
              1516.177
            ],
            [
              1692.78,
              -3098.159,
              1546.826
            ],
            [
              1693.427,
              -3075.022,
              1569.972
            ],
            [
              1690.731,
              -2873.474,
              1771.538
            ],
            [
              1684.353,
              -2661.838,
              1983.27
            ],
            [
              1680.485,
              -2590.427,
              2054.786
            ],
            [
              1679.547,
              -2554.739,
              2090.487
            ],
            [
              1678.725,
              -2527.718,
              2117.519
            ],
            [
              1679.06,
              -2495.866,
              2149.373
            ],
            [
              1670.601,
              -2049.296,
              2596.024
            ],
            [
              1665.105,
              -1963.474,
              2682.021
            ],
            [
              1665.702,
              -1896.69,
              2748.808
            ],
            [
              1663.09,
              -1759.712,
              2885.811
            ],
            [
              1657.26,
              -1724.669,
              2921.336
            ],
            [
              1660.464,
              -1692.869,
              2953.297
            ],
            [
              1642.718,
              -1572.308,
              3075.157
            ],
            [
              1626.598,
              -1502.988,
              3146.326
            ],
            [
              1590.763,
              -1384.318,
              3270.289
            ],
            [
              1541.473,
              -1260.946,
              3403.143
            ],
            [
              1439.941,
              -1068.699,
              3620.554
            ],
            [
              1422.22,
              -1045.077,
              3650.084
            ],
            [
              1413.029,
              -1024.784,
              3672.361
            ],
            [
              1382.574,
              -969.885,
              3735.142
            ],
            [
              1372.327,
              -959.462,
              3749.758
            ],
            [
              1333.941,
              -943.166,
              3791.46
            ],
            [
              1307.513,
              -942.677,
              3817.893
            ],
            [
              1293.291,
              -944.641,
              3832.25
            ],
            [
              1278.614,
              -942.95,
              3847.024
            ],
            [
              1269.114,
              -935.31,
              3859.215
            ],
            [
              1257.937,
              -924.707,
              3874.621
            ],
            [
              1253.197,
              -916.068,
              3884.475
            ],
            [
              1249.597,
              -901.529,
              3899.453
            ],
            [
              1250.468,
              -889.3,
              3911.713
            ],
            [
              1243.124,
              -868.013,
              3934.231
            ],
            [
              1234.408,
              -851.153,
              3953.211
            ],
            [
              1218.52,
              -838.613,
              3973.451
            ],
            [
              1192.86,
              -831.46,
              4000.09
            ],
            [
              1155.132,
              -824.781,
              4038.405
            ],
            [
              1120.288,
              -815.648,
              4074.425
            ],
            [
              1031.058,
              -793.963,
              4166.253
            ],
            [
              773.373,
              -745.803,
              4428.399
            ],
            [
              730.608,
              -739.605,
              4471.612
            ],
            [
              702.691,
              -732.259,
              4500.478
            ],
            [
              508.13,
              -687.5,
              4700.122
            ],
            [
              443.852,
              -676.304,
              4765.367
            ],
            [
              405.738,
              -680.059,
              4803.666
            ],
            [
              363.165,
              -686.919,
              4846.788
            ],
            [
              341.718,
              -690.021,
              4868.458
            ],
            [
              237.095,
              -710.389,
              4975.045
            ],
            [
              229.733,
              -713.579,
              4983.069
            ],
            [
              224.637,
              -710.146,
              4989.213
            ],
            [
              207.157,
              -646.093,
              5055.609
            ],
            [
              172.17,
              -552.982,
              5155.076
            ],
            [
              159.237,
              -513.023,
              5197.076
            ],
            [
              126.134,
              -439.133,
              5278.043
            ],
            [
              106.146,
              -277.163,
              5441.241
            ],
            [
              46.11,
              -280.522,
              5501.371
            ],
            [
              26.264,
              -279.764,
              5521.231
            ],
            [
              16.623,
              -264.894,
              5538.953
            ],
            [
              14.513,
              -253.218,
              5550.819
            ],
            [
              16.439,
              -245.471,
              5558.801
            ],
            [
              45.916,
              -220.403,
              5597.496
            ],
            [
              103.215,
              -190.277,
              5662.232
            ],
            [
              127.382,
              -102.772,
              5753.013
            ],
            [
              121.848,
              -52.576,
              5803.513
            ],
            [
              118.496,
              -36.512,
              5819.923
            ],
            [
              117.583,
              -3.516,
              5852.932
            ],
            [
              102.671,
              133.684,
              5990.94
            ],
            [
              63.181,
              125.497,
              6031.27
            ],
            [
              59.312,
              125.568,
              6035.139
            ],
            [
              57.419,
              127.829,
              6038.088
            ],
            [
              31.786,
              278.582,
              6191.005
            ],
            [
              4.856,
              358.112,
              6274.97
            ],
            [
              -8.924,
              380.627,
              6301.368
            ],
            [
              -39.768,
              422.378,
              6353.276
            ],
            [
              -46.8,
              425.846,
              6361.117
            ],
            [
              -55.202,
              424.885,
              6369.574
            ],
            [
              -86.677,
              396.514,
              6411.948
            ],
            [
              -98.36,
              381.073,
              6431.311
            ],
            [
              -216.06,
              268.617,
              6594.098
            ],
            [
              -407.853,
              148.526,
              6820.386
            ],
            [
              -402.875,
              316.534,
              6988.468
            ],
            [
              -399.691,
              349.873,
              7021.959
            ],
            [
              -379.219,
              381.017,
              7059.229
            ],
            [
              -261.81,
              448.677,
              7194.738
            ],
            [
              -291.826,
              642.924,
              7391.29
            ],
            [
              -330.752,
              844.011,
              7596.11
            ],
            [
              -575.219,
              737.113,
              7862.927
            ],
            [
              -620.102,
              729.911,
              7908.385
            ],
            [
              -799.94,
              794.603,
              8099.505
            ],
            [
              -810.157,
              800.354,
              8111.229
            ],
            [
              -958.695,
              862.029,
              8272.062
            ],
            [
              -1066.972,
              902.938,
              8387.81
            ],
            [
              -1103.368,
              923.63,
              8429.676
            ],
            [
              -1148.452,
              963.402,
              8489.796
            ],
            [
              -1166.61,
              973.416,
              8510.532
            ],
            [
              -1183.42,
              991.86,
              8535.488
            ],
            [
              -1484.246,
              1267.759,
              8943.674
            ],
            [
              -1501.298,
              1275.764,
              8962.512
            ],
            [
              -1524.902,
              1302.995,
              8998.549
            ],
            [
              -1970.62,
              1705.012,
              9598.784
            ],
            [
              -1985.783,
              1723.093,
              9622.382
            ],
            [
              -2263.842,
              1978.495,
              9999.936
            ],
            [
              -2290.557,
              2000.118,
              10034.305
            ],
            [
              -2318.992,
              2034.018,
              10078.552
            ],
            [
              -2425.036,
              2130.514,
              10221.928
            ],
            [
              -2441.629,
              2140.826,
              10241.464
            ],
            [
              -2464.869,
              2140.123,
              10264.715
            ],
            [
              -2491.57,
              2126.123,
              10294.864
            ],
            [
              -2514.888,
              2120.968,
              10318.745
            ],
            [
              -2528.453,
              2120.094,
              10332.338
            ],
            [
              -2551.595,
              2124.955,
              10355.985
            ],
            [
              -2561.443,
              2130.364,
              10367.221
            ],
            [
              -2579.681,
              2142.148,
              10388.934
            ],
            [
              -2585.368,
              2148.928,
              10397.783
            ],
            [
              -2589.062,
              2159.012,
              10408.523
            ],
            [
              -2606.026,
              2184.914,
              10439.486
            ],
            [
              -2610.155,
              2197.282,
              10452.525
            ],
            [
              -2613.804,
              2219.561,
              10475.1
            ],
            [
              -2613.4,
              2232.891,
              10488.437
            ],
            [
              -2610.452,
              2250.329,
              10506.122
            ],
            [
              -2605.925,
              2263.95,
              10520.475
            ],
            [
              -2595.8,
              2280.361,
              10539.758
            ],
            [
              -2588.136,
              2284.788,
              10548.609
            ],
            [
              -2577.558,
              2305.756,
              10572.094
            ],
            [
              -2591.532,
              2385.037,
              10652.597
            ],
            [
              -2598.371,
              2436.365,
              10704.379
            ],
            [
              -2602.959,
              2542.201,
              10810.314
            ],
            [
              -2606.316,
              2602.394,
              10870.6
            ],
            [
              -2619.569,
              2661.607,
              10931.279
            ],
            [
              -2672.012,
              2798.342,
              11077.726
            ],
            [
              -2693.846,
              2841.028,
              11125.672
            ],
            [
              -2698.439,
              2873.392,
              11158.36
            ],
            [
              -2831.804,
              3253.114,
              11560.821
            ],
            [
              -2853.662,
              3294.686,
              11607.789
            ],
            [
              -2869.962,
              3320.622,
              11638.422
            ],
            [
              -2887.849,
              3332.714,
              11660.013
            ],
            [
              -2904.222,
              3355.687,
              11688.223
            ],
            [
              -3126.24,
              3576.651,
              12001.46
            ],
            [
              -3256.351,
              3702.491,
              12182.47
            ],
            [
              -3334.924,
              3786.24,
              12297.307
            ],
            [
              -3406.008,
              3855.385,
              12396.473
            ],
            [
              -3427.01,
              3872.449,
              12423.534
            ],
            [
              -3454.8,
              3907.442,
              12468.219
            ],
            [
              -3626.746,
              4078.528,
              12710.78
            ],
            [
              -3781.512,
              4235.95,
              12931.539
            ],
            [
              -3884.317,
              4337.92,
              13076.338
            ],
            [
              -3915.514,
              4362.95,
              13116.334
            ],
            [
              -3928.112,
              4380.98,
              13138.33
            ],
            [
              -4226.292,
              4683.356,
              13562.997
            ],
            [
              -4305.622,
              4762.647,
              13675.159
            ],
            [
              -4338.114,
              4787.696,
              13716.186
            ],
            [
              -4349.425,
              4805.702,
              13737.45
            ],
            [
              -4420.502,
              4877.057,
              13838.165
            ],
            [
              -4439.501,
              4898.534,
              13866.839
            ],
            [
              -4461.157,
              4915.604,
              13894.414
            ],
            [
              -4476.532,
              4922.548,
              13911.284
            ],
            [
              -4485.887,
              4927.855,
              13922.04
            ],
            [
              -4508.363,
              4948.698,
              13952.693
            ],
            [
              -4600.366,
              5004.825,
              14060.464
            ],
            [
              -4658.205,
              5020.288,
              14120.335
            ],
            [
              -4736.87,
              5026.089,
              14199.213
            ],
            [
              -4780.797,
              5023.521,
              14243.215
            ],
            [
              -4794.293,
              5028.186,
              14257.495
            ],
            [
              -4826.695,
              5058.796,
              14302.069
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:5508",
              "position": {
                "x": 1128.033,
                "z": -4270.188
              },
              "distanceAlongShapeM": 122.207,
              "shapeOffsetM": 0.046,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:5149",
              "position": {
                "x": 1393.375,
                "z": -3755.212
              },
              "distanceAlongShapeM": 800.374,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:5086",
              "position": {
                "x": 1607.644,
                "z": -3390.704
              },
              "distanceAlongShapeM": 1227.17,
              "shapeOffsetM": 2.933,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:5087",
              "position": {
                "x": 1687.839,
                "z": -3098.296
              },
              "distanceAlongShapeM": 1546.826,
              "shapeOffsetM": 4.943,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:5088",
              "position": {
                "x": 1670.083,
                "z": -2527.983
              },
              "distanceAlongShapeM": 2117.518,
              "shapeOffsetM": 8.646,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:5658",
              "position": {
                "x": 1653.419,
                "z": -1725.022
              },
              "distanceAlongShapeM": 2921.336,
              "shapeOffsetM": 3.857,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:5661",
              "position": {
                "x": 1418.417,
                "z": -1047.149
              },
              "distanceAlongShapeM": 3650.084,
              "shapeOffsetM": 4.331,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:5662",
              "position": {
                "x": 1154.205,
                "z": -829.633
              },
              "distanceAlongShapeM": 4038.405,
              "shapeOffsetM": 4.939,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:5664",
              "position": {
                "x": 729.54,
                "z": -744.998
              },
              "distanceAlongShapeM": 4471.612,
              "shapeOffsetM": 5.498,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            },
            {
              "stopId": "judu:stop:5244",
              "position": {
                "x": 121.213,
                "z": -441.083
              },
              "distanceAlongShapeM": 5278.043,
              "shapeOffsetM": 5.293,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:5409",
              "position": {
                "x": 115.041,
                "z": -36.866
              },
              "distanceAlongShapeM": 5819.923,
              "shapeOffsetM": 3.473,
              "arrivalOffsetSeconds": 1500,
              "departureOffsetSeconds": 1500
            },
            {
              "stopId": "judu:stop:5334",
              "position": {
                "x": -97.297,
                "z": 380.009
              },
              "distanceAlongShapeM": 6431.311,
              "shapeOffsetM": 1.504,
              "arrivalOffsetSeconds": 1740,
              "departureOffsetSeconds": 1740
            },
            {
              "stopId": "judu:stop:5524",
              "position": {
                "x": -620.556,
                "z": 726.8
              },
              "distanceAlongShapeM": 7908.385,
              "shapeOffsetM": 3.143,
              "arrivalOffsetSeconds": 2040,
              "departureOffsetSeconds": 2040
            },
            {
              "stopId": "judu:stop:5579",
              "position": {
                "x": -1168.303,
                "z": 971.551
              },
              "distanceAlongShapeM": 8510.532,
              "shapeOffsetM": 2.518,
              "arrivalOffsetSeconds": 2220,
              "departureOffsetSeconds": 2220
            },
            {
              "stopId": "judu:stop:6343",
              "position": {
                "x": -1502.183,
                "z": 1274.758
              },
              "distanceAlongShapeM": 8962.512,
              "shapeOffsetM": 1.34,
              "arrivalOffsetSeconds": 2280,
              "departureOffsetSeconds": 2280
            },
            {
              "stopId": "judu:stop:7852",
              "position": {
                "x": -1970.62,
                "z": 1705.012
              },
              "distanceAlongShapeM": 9598.784,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2460,
              "departureOffsetSeconds": 2460
            },
            {
              "stopId": "judu:stop:5532",
              "position": {
                "x": -2290.557,
                "z": 2000.118
              },
              "distanceAlongShapeM": 10034.305,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2580,
              "departureOffsetSeconds": 2580
            },
            {
              "stopId": "judu:stop:5543",
              "position": {
                "x": -2693.846,
                "z": 2841.028
              },
              "distanceAlongShapeM": 11125.672,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2820,
              "departureOffsetSeconds": 2820
            },
            {
              "stopId": "judu:stop:5573",
              "position": {
                "x": -2888.502,
                "z": 3332.034
              },
              "distanceAlongShapeM": 11660.013,
              "shapeOffsetM": 0.943,
              "arrivalOffsetSeconds": 2880,
              "departureOffsetSeconds": 2880
            },
            {
              "stopId": "judu:stop:5587",
              "position": {
                "x": -3427.01,
                "z": 3872.449
              },
              "distanceAlongShapeM": 12423.534,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 3000,
              "departureOffsetSeconds": 3000
            },
            {
              "stopId": "judu:stop:5588",
              "position": {
                "x": -3915.514,
                "z": 4362.95
              },
              "distanceAlongShapeM": 13116.334,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 3060,
              "departureOffsetSeconds": 3060
            },
            {
              "stopId": "judu:stop:5554",
              "position": {
                "x": -4338.114,
                "z": 4787.696
              },
              "distanceAlongShapeM": 13716.186,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 3180,
              "departureOffsetSeconds": 3180
            },
            {
              "stopId": "judu:stop:5567",
              "position": {
                "x": -4488.111,
                "z": 4924.973
              },
              "distanceAlongShapeM": 13922.04,
              "shapeOffsetM": 3.641,
              "arrivalOffsetSeconds": 3240,
              "departureOffsetSeconds": 3240
            },
            {
              "stopId": "judu:stop:1076",
              "position": {
                "x": -4826.695,
                "z": 5058.796
              },
              "distanceAlongShapeM": 14302.069,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 3300,
              "departureOffsetSeconds": 3300
            }
          ],
          "departuresSeconds": [
            17940,
            19560,
            20580,
            21720,
            22860,
            23580,
            24360,
            25260,
            26700,
            28080,
            29400,
            30600,
            32160,
            33900,
            36000,
            38460,
            41280,
            43620,
            46080,
            48900,
            51480,
            52740,
            54180,
            55560,
            56580,
            57300,
            58380,
            59940,
            61020,
            62520,
            64080,
            65820,
            66960,
            67920,
            70560,
            72960,
            75360,
            77460,
            79860
          ]
        },
        {
          "id": "judu:pattern:vilnius_trol_12:1",
          "sourceRouteId": "vilnius_trol_12",
          "sourceShapeId": "vilnius_trol_12_b-a",
          "directionId": 1,
          "headsign": "Žirmūnai (Apylanka be Reformatų st.)",
          "directionName": "Žemieji Paneriai–V. Kudirkos–Šeimyniškių g.–Žirmūnai (Apylanka be Reformatų st.)",
          "mode": "trolleybus",
          "routeShortName": "12",
          "routeLongName": "Žirmūnai–Šeimyniškių–Tauro g.–Žemieji Paneriai (Apylanka be Reformatų st.)",
          "routeColor": "DC3131",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              -4826.663,
              5058.868,
              0
            ],
            [
              -4834.705,
              5081.197,
              23.733
            ],
            [
              -4785.441,
              5130.448,
              93.393
            ],
            [
              -4754.629,
              5157.75,
              134.561
            ],
            [
              -4724.691,
              5171.709,
              167.593
            ],
            [
              -4669.049,
              5178.483,
              223.646
            ],
            [
              -4632.924,
              5176.815,
              259.81
            ],
            [
              -4600.447,
              5171.052,
              292.794
            ],
            [
              -4586.132,
              5157.088,
              312.792
            ],
            [
              -4583.042,
              5111.394,
              358.59
            ],
            [
              -4580.889,
              5011.17,
              458.838
            ],
            [
              -4518.9,
              4977.81,
              529.233
            ],
            [
              -4503.635,
              4960.862,
              552.042
            ],
            [
              -4444.377,
              4915.316,
              626.781
            ],
            [
              -4189.698,
              4671.592,
              979.291
            ],
            [
              -4167.195,
              4657.338,
              1005.928
            ],
            [
              -4146.524,
              4629.659,
              1040.474
            ],
            [
              -4048.773,
              4533.349,
              1177.699
            ],
            [
              -3823.59,
              4303.471,
              1499.493
            ],
            [
              -3802.623,
              4284.184,
              1527.982
            ],
            [
              -3780.952,
              4268.223,
              1554.896
            ],
            [
              -3768.394,
              4247.967,
              1578.729
            ],
            [
              -3367.467,
              3844.694,
              2147.387
            ],
            [
              -3344.636,
              3829.677,
              2174.714
            ],
            [
              -3315.43,
              3793.692,
              2221.06
            ],
            [
              -3282.402,
              3763.059,
              2266.107
            ],
            [
              -3142.94,
              3618.132,
              2467.237
            ],
            [
              -2996.449,
              3469.738,
              2675.757
            ],
            [
              -2905.063,
              3381.305,
              2802.925
            ],
            [
              -2851.864,
              3323.598,
              2881.412
            ],
            [
              -2827.523,
              3276.416,
              2934.503
            ],
            [
              -2808.656,
              3248.254,
              2968.401
            ],
            [
              -2806.545,
              3221.5,
              2995.238
            ],
            [
              -2772.86,
              3118.493,
              3103.613
            ],
            [
              -2707,
              2936.995,
              3296.691
            ],
            [
              -2660.341,
              2801.476,
              3440.017
            ],
            [
              -2637.179,
              2724.257,
              3520.635
            ],
            [
              -2612.218,
              2675.949,
              3575.011
            ],
            [
              -2609.483,
              2648.071,
              3603.022
            ],
            [
              -2584.513,
              2574.315,
              3680.891
            ],
            [
              -2570.531,
              2514.913,
              3741.916
            ],
            [
              -2558.338,
              2437.886,
              3819.902
            ],
            [
              -2547.004,
              2385.365,
              3873.632
            ],
            [
              -2539.07,
              2359.622,
              3900.57
            ],
            [
              -2526.132,
              2324.884,
              3937.639
            ],
            [
              -2519.194,
              2315.856,
              3949.025
            ],
            [
              -2487.744,
              2306.396,
              3981.867
            ],
            [
              -2471.111,
              2298.31,
              4000.361
            ],
            [
              -2454.576,
              2284.659,
              4021.803
            ],
            [
              -2442.556,
              2271.088,
              4039.932
            ],
            [
              -2433.47,
              2237.532,
              4074.696
            ],
            [
              -2435.723,
              2169.786,
              4142.48
            ],
            [
              -2432.837,
              2155.209,
              4157.34
            ],
            [
              -2421.673,
              2138.248,
              4177.645
            ],
            [
              -2405.237,
              2119.033,
              4202.931
            ],
            [
              -2339.12,
              2063.317,
              4289.393
            ],
            [
              -2328.352,
              2051.995,
              4305.018
            ],
            [
              -2314.582,
              2044.048,
              4320.916
            ],
            [
              -2298.509,
              2024.75,
              4346.031
            ],
            [
              -1944.941,
              1697.877,
              4827.546
            ],
            [
              -1869.698,
              1631.955,
              4927.582
            ],
            [
              -1860.469,
              1622.903,
              4940.509
            ],
            [
              -1769.084,
              1537.785,
              5065.394
            ],
            [
              -1704.495,
              1480.033,
              5152.038
            ],
            [
              -1688.349,
              1470.667,
              5170.703
            ],
            [
              -1678.973,
              1453.802,
              5189.999
            ],
            [
              -1503.095,
              1295.926,
              5426.342
            ],
            [
              -1429.356,
              1232.268,
              5523.758
            ],
            [
              -1409.124,
              1211.868,
              5552.489
            ],
            [
              -1353.311,
              1158.548,
              5629.678
            ],
            [
              -1207.93,
              1027.923,
              5825.122
            ],
            [
              -1189.5,
              1013.819,
              5848.33
            ],
            [
              -1173.062,
              993.901,
              5874.155
            ],
            [
              -1066.972,
              902.938,
              6013.902
            ],
            [
              -958.695,
              862.029,
              6129.65
            ],
            [
              -800.989,
              807.981,
              6296.36
            ],
            [
              -799.135,
              803.495,
              6301.214
            ],
            [
              -800.094,
              794.656,
              6310.105
            ],
            [
              -808.22,
              764.696,
              6341.148
            ],
            [
              -816.493,
              725.027,
              6381.67
            ],
            [
              -829.673,
              683.817,
              6424.936
            ],
            [
              -843.054,
              478.111,
              6631.077
            ],
            [
              -804.926,
              410.63,
              6708.585
            ],
            [
              -682.331,
              234.755,
              6922.971
            ],
            [
              -671.067,
              215.627,
              6945.169
            ],
            [
              -647.308,
              102.762,
              7060.508
            ],
            [
              -591.62,
              115.115,
              7117.55
            ],
            [
              -557.359,
              122.914,
              7152.687
            ],
            [
              -539.176,
              126.412,
              7171.203
            ],
            [
              -408.498,
              148.538,
              7303.741
            ],
            [
              -385.731,
              159.258,
              7328.906
            ],
            [
              -216.06,
              268.617,
              7530.766
            ],
            [
              -55.202,
              424.885,
              7755.032
            ],
            [
              -39.768,
              422.378,
              7770.668
            ],
            [
              15.61,
              348.039,
              7863.367
            ],
            [
              36.62,
              260.682,
              7953.215
            ],
            [
              56.855,
              132.292,
              8083.19
            ],
            [
              59.373,
              128.907,
              8087.408
            ],
            [
              70.978,
              128.695,
              8099.015
            ],
            [
              102.671,
              133.684,
              8131.099
            ],
            [
              112.53,
              93.98,
              8172.009
            ],
            [
              129.88,
              -107.271,
              8374.006
            ],
            [
              116.846,
              -256.206,
              8523.51
            ],
            [
              117.887,
              -305.208,
              8572.523
            ],
            [
              127.343,
              -387.845,
              8655.699
            ],
            [
              135.914,
              -423.248,
              8692.125
            ],
            [
              144.816,
              -445.964,
              8716.523
            ],
            [
              174.587,
              -519.993,
              8796.314
            ],
            [
              186.708,
              -562.507,
              8840.522
            ],
            [
              214.213,
              -645.388,
              8927.848
            ],
            [
              223.987,
              -656.808,
              8942.88
            ],
            [
              236.049,
              -695.879,
              8983.77
            ],
            [
              294.146,
              -689.755,
              9042.189
            ],
            [
              331.506,
              -684.268,
              9079.95
            ],
            [
              436.802,
              -673.948,
              9185.751
            ],
            [
              647.48,
              -719,
              9401.192
            ],
            [
              692.52,
              -724.28,
              9446.54
            ],
            [
              727.857,
              -730.038,
              9482.343
            ],
            [
              752.192,
              -734.856,
              9507.15
            ],
            [
              1031.058,
              -793.963,
              9792.212
            ],
            [
              1157.03,
              -816.326,
              9920.153
            ],
            [
              1199.169,
              -824.315,
              9963.043
            ],
            [
              1220.015,
              -827.509,
              9984.132
            ],
            [
              1248.96,
              -831.383,
              10013.335
            ],
            [
              1325.104,
              -828.339,
              10089.54
            ],
            [
              1339.141,
              -836.391,
              10105.723
            ],
            [
              1354.364,
              -850.032,
              10126.163
            ],
            [
              1360.583,
              -862.393,
              10140.001
            ],
            [
              1367.85,
              -922.642,
              10200.686
            ],
            [
              1384.491,
              -964.14,
              10245.397
            ],
            [
              1464.439,
              -1103.664,
              10406.203
            ],
            [
              1477.634,
              -1123.116,
              10429.708
            ],
            [
              1488.813,
              -1145.306,
              10454.555
            ],
            [
              1537.374,
              -1238.606,
              10559.736
            ],
            [
              1587.871,
              -1366.453,
              10697.194
            ],
            [
              1626.598,
              -1502.988,
              10839.115
            ],
            [
              1647.564,
              -1589.097,
              10927.74
            ],
            [
              1670.179,
              -1759.844,
              11099.978
            ],
            [
              1672.682,
              -1787.97,
              11128.215
            ],
            [
              1672.408,
              -1813.321,
              11153.568
            ],
            [
              1676.981,
              -1962.613,
              11302.929
            ],
            [
              1684.587,
              -2475.93,
              11816.303
            ],
            [
              1691.063,
              -2612.98,
              11953.506
            ],
            [
              1692.552,
              -2638.806,
              11979.375
            ],
            [
              1690.652,
              -2669.748,
              12010.375
            ],
            [
              1690.731,
              -2873.474,
              12214.101
            ],
            [
              1700.851,
              -3126.37,
              12467.199
            ],
            [
              1707.344,
              -3177.803,
              12519.04
            ],
            [
              1701.896,
              -3208.77,
              12550.483
            ],
            [
              1697.306,
              -3247.648,
              12589.631
            ],
            [
              1679.831,
              -3286.287,
              12632.038
            ],
            [
              1593.247,
              -3437.193,
              12806.019
            ],
            [
              1579.69,
              -3472.235,
              12843.592
            ],
            [
              1566.424,
              -3493.47,
              12868.63
            ],
            [
              1508.519,
              -3591.87,
              12982.804
            ],
            [
              1412.221,
              -3746.656,
              13165.1
            ],
            [
              1401.002,
              -3760.92,
              13183.248
            ],
            [
              1342.534,
              -3804.924,
              13256.425
            ],
            [
              1325.974,
              -3810.739,
              13273.976
            ],
            [
              1219.986,
              -3862.213,
              13391.802
            ],
            [
              1220.734,
              -4100.462,
              13630.052
            ],
            [
              1222.498,
              -4142.938,
              13672.565
            ],
            [
              1222.034,
              -4169.508,
              13699.139
            ],
            [
              1222.197,
              -4191.784,
              13721.415
            ],
            [
              1218.667,
              -4222.547,
              13752.38
            ],
            [
              1209.216,
              -4242.448,
              13774.412
            ],
            [
              1199.734,
              -4253.999,
              13789.356
            ],
            [
              1180.34,
              -4272.796,
              13816.364
            ],
            [
              1169.776,
              -4277.639,
              13827.986
            ],
            [
              1151.036,
              -4280.633,
              13846.963
            ],
            [
              1136.231,
              -4280.418,
              13861.77
            ],
            [
              1097.302,
              -4298.664,
              13904.762
            ],
            [
              1060.432,
              -4334.455,
              13956.147
            ],
            [
              1050.84,
              -4334.625,
              13965.74
            ],
            [
              1024.373,
              -4320.974,
              13995.521
            ],
            [
              1020.017,
              -4312.849,
              14004.739
            ],
            [
              1017.506,
              -4299.224,
              14018.594
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:1076",
              "position": {
                "x": -4826.695,
                "z": 5058.796
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 0.079,
              "arrivalOffsetSeconds": -480,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:5594",
              "position": {
                "x": -4669.05,
                "z": 5178.548
              },
              "distanceAlongShapeM": 223.646,
              "shapeOffsetM": 0.065,
              "arrivalOffsetSeconds": 60,
              "departureOffsetSeconds": 60
            },
            {
              "stopId": "judu:stop:6850",
              "position": {
                "x": -4517.509,
                "z": 4980.025
              },
              "distanceAlongShapeM": 529.233,
              "shapeOffsetM": 2.616,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:6851",
              "position": {
                "x": -4166.695,
                "z": 4657.837
              },
              "distanceAlongShapeM": 1005.928,
              "shapeOffsetM": 0.707,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:5546",
              "position": {
                "x": -3780.952,
                "z": 4268.223
              },
              "distanceAlongShapeM": 1554.896,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:9384",
              "position": {
                "x": -3344.49,
                "z": 3829.822
              },
              "distanceAlongShapeM": 2174.714,
              "shapeOffsetM": 0.206,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:857",
              "position": {
                "x": -2808.656,
                "z": 3248.254
              },
              "distanceAlongShapeM": 2968.401,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:5542",
              "position": {
                "x": -2612.218,
                "z": 2675.949
              },
              "distanceAlongShapeM": 3575.011,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:5535",
              "position": {
                "x": -2313.635,
                "z": 2045.055
              },
              "distanceAlongShapeM": 4320.916,
              "shapeOffsetM": 1.383,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:7853",
              "position": {
                "x": -1868.675,
                "z": 1633.068
              },
              "distanceAlongShapeM": 4927.582,
              "shapeOffsetM": 1.512,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            },
            {
              "stopId": "judu:stop:6842",
              "position": {
                "x": -1427.428,
                "z": 1234.46
              },
              "distanceAlongShapeM": 5523.758,
              "shapeOffsetM": 2.919,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:5580",
              "position": {
                "x": -1188.159,
                "z": 1015.323
              },
              "distanceAlongShapeM": 5848.33,
              "shapeOffsetM": 2.015,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:5267",
              "position": {
                "x": -810.251,
                "z": 723.543
              },
              "distanceAlongShapeM": 6381.67,
              "shapeOffsetM": 6.416,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            },
            {
              "stopId": "judu:stop:5332",
              "position": {
                "x": -557.893,
                "z": 125.637
              },
              "distanceAlongShapeM": 7152.687,
              "shapeOffsetM": 2.774,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            },
            {
              "stopId": "judu:stop:5459",
              "position": {
                "x": 18.234,
                "z": 348.963
              },
              "distanceAlongShapeM": 7863.367,
              "shapeOffsetM": 2.781,
              "arrivalOffsetSeconds": 1680,
              "departureOffsetSeconds": 1680
            },
            {
              "stopId": "judu:stop:5492",
              "position": {
                "x": 116.145,
                "z": 94.475
              },
              "distanceAlongShapeM": 8172.009,
              "shapeOffsetM": 3.649,
              "arrivalOffsetSeconds": 1740,
              "departureOffsetSeconds": 1740
            },
            {
              "stopId": "judu:stop:5245",
              "position": {
                "x": 150.182,
                "z": -443.837
              },
              "distanceAlongShapeM": 8716.552,
              "shapeOffsetM": 5.773,
              "arrivalOffsetSeconds": 1920,
              "departureOffsetSeconds": 1920
            },
            {
              "stopId": "judu:stop:5667",
              "position": {
                "x": 292.85,
                "z": -682.448
              },
              "distanceAlongShapeM": 9041.667,
              "shapeOffsetM": 7.402,
              "arrivalOffsetSeconds": 2070,
              "departureOffsetSeconds": 2070
            },
            {
              "stopId": "judu:stop:5665",
              "position": {
                "x": 729.304,
                "z": -722.729
              },
              "distanceAlongShapeM": 9482.343,
              "shapeOffsetM": 7.451,
              "arrivalOffsetSeconds": 2220,
              "departureOffsetSeconds": 2220
            },
            {
              "stopId": "judu:stop:6660",
              "position": {
                "x": 1200.176,
                "z": -819.349
              },
              "distanceAlongShapeM": 9963.286,
              "shapeOffsetM": 5.061,
              "arrivalOffsetSeconds": 2280,
              "departureOffsetSeconds": 2280
            },
            {
              "stopId": "judu:stop:6665",
              "position": {
                "x": 1480.223,
                "z": -1121.768
              },
              "distanceAlongShapeM": 10429.708,
              "shapeOffsetM": 2.918,
              "arrivalOffsetSeconds": 2400,
              "departureOffsetSeconds": 2400
            },
            {
              "stopId": "judu:stop:6666",
              "position": {
                "x": 1676.751,
                "z": -1787.797
              },
              "distanceAlongShapeM": 11128.215,
              "shapeOffsetM": 4.073,
              "arrivalOffsetSeconds": 2520,
              "departureOffsetSeconds": 2520
            },
            {
              "stopId": "judu:stop:5606",
              "position": {
                "x": 1696.386,
                "z": -2638.684
              },
              "distanceAlongShapeM": 11979.375,
              "shapeOffsetM": 3.836,
              "arrivalOffsetSeconds": 2760,
              "departureOffsetSeconds": 2760
            },
            {
              "stopId": "judu:stop:6667",
              "position": {
                "x": 1709.563,
                "z": -3177.741
              },
              "distanceAlongShapeM": 12519.04,
              "shapeOffsetM": 2.22,
              "arrivalOffsetSeconds": 2880,
              "departureOffsetSeconds": 2880
            },
            {
              "stopId": "judu:stop:6668",
              "position": {
                "x": 1582.257,
                "z": -3473.726
              },
              "distanceAlongShapeM": 12843.592,
              "shapeOffsetM": 2.969,
              "arrivalOffsetSeconds": 2940,
              "departureOffsetSeconds": 2940
            },
            {
              "stopId": "judu:stop:5154",
              "position": {
                "x": 1342.825,
                "z": -3805.485
              },
              "distanceAlongShapeM": 13256.425,
              "shapeOffsetM": 0.632,
              "arrivalOffsetSeconds": 3120,
              "departureOffsetSeconds": 3120
            },
            {
              "stopId": "judu:stop:6671",
              "position": {
                "x": 1228.325,
                "z": -4142.906
              },
              "distanceAlongShapeM": 13672.565,
              "shapeOffsetM": 5.827,
              "arrivalOffsetSeconds": 3180,
              "departureOffsetSeconds": 3180
            },
            {
              "stopId": "judu:stop:5505",
              "position": {
                "x": 1151.036,
                "z": -4280.633
              },
              "distanceAlongShapeM": 13846.963,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 3240,
              "departureOffsetSeconds": 3240
            }
          ],
          "departuresSeconds": [
            19860,
            21240,
            22920,
            24240,
            25440,
            26580,
            27540,
            28260,
            29280,
            30780,
            32160,
            33240,
            34380,
            35940,
            37560,
            39720,
            42060,
            44940,
            47220,
            49680,
            52500,
            55140,
            56640,
            58080,
            59520,
            60840,
            61440,
            62580,
            64140,
            66720,
            71760,
            73980,
            76440,
            78780,
            81000,
            83280
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_trol_15",
      "sourceRouteId": "vilnius_trol_15",
      "mode": "trolleybus",
      "shortName": "15",
      "longName": "Stotis–Žemieji Paneriai–Titnago g.",
      "color": "DC3131",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_trol_15:0",
          "sourceRouteId": "vilnius_trol_15",
          "sourceShapeId": "vilnius_trol_15_a-b",
          "directionId": 0,
          "headsign": "Titnago g.",
          "directionName": "Stotis–Žemieji Paneriai–Titnago g.",
          "mode": "trolleybus",
          "routeShortName": "15",
          "routeLongName": "Stotis–Žemieji Paneriai–Titnago g.",
          "routeColor": "DC3131",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              374.971,
              1912.538,
              0
            ],
            [
              381.688,
              1919.781,
              9.878
            ],
            [
              390.297,
              1931.87,
              24.719
            ],
            [
              381.613,
              1950.953,
              45.685
            ],
            [
              374.681,
              1959.986,
              57.072
            ],
            [
              359.73,
              1989.203,
              89.892
            ],
            [
              357.312,
              1998.153,
              99.163
            ],
            [
              360.055,
              2007.009,
              108.434
            ],
            [
              365.317,
              2012.479,
              116.024
            ],
            [
              381.462,
              2013.297,
              132.189
            ],
            [
              469.575,
              1962.704,
              233.794
            ],
            [
              480.298,
              1952.175,
              248.822
            ],
            [
              481.71,
              1947.816,
              253.405
            ],
            [
              476.141,
              1933.639,
              268.636
            ],
            [
              470.194,
              1925.956,
              278.352
            ],
            [
              463.683,
              1922.735,
              285.616
            ],
            [
              447.558,
              1923.03,
              301.744
            ],
            [
              415.411,
              1929.184,
              334.474
            ],
            [
              398.6,
              1927.265,
              351.395
            ],
            [
              334.106,
              1822.687,
              474.261
            ],
            [
              318.606,
              1821.856,
              489.783
            ],
            [
              29.934,
              1735.835,
              790.999
            ],
            [
              -11.394,
              1732.372,
              832.471
            ],
            [
              -46.755,
              1740.57,
              868.77
            ],
            [
              -320.217,
              1781.157,
              1145.228
            ],
            [
              -550.531,
              1853.232,
              1386.556
            ],
            [
              -581.279,
              1862.523,
              1418.677
            ],
            [
              -596.688,
              1869.651,
              1435.655
            ],
            [
              -1032.712,
              2019.998,
              1896.872
            ],
            [
              -1047.441,
              2021.391,
              1911.666
            ],
            [
              -1075.687,
              2034.129,
              1942.652
            ],
            [
              -1134.042,
              2054.101,
              2004.33
            ],
            [
              -1154.642,
              2056.697,
              2025.093
            ],
            [
              -1164.417,
              2051.306,
              2036.256
            ],
            [
              -1208.37,
              2010.905,
              2095.956
            ],
            [
              -1267.715,
              1939.609,
              2188.719
            ],
            [
              -1394.1,
              1799.379,
              2377.498
            ],
            [
              -1413.741,
              1770.628,
              2412.318
            ],
            [
              -1434.923,
              1753.354,
              2439.65
            ],
            [
              -1515.962,
              1659.065,
              2563.979
            ],
            [
              -1594.12,
              1581.422,
              2674.148
            ],
            [
              -1692.298,
              1466.285,
              2825.46
            ],
            [
              -1701.366,
              1464.22,
              2834.76
            ],
            [
              -1708.441,
              1465.459,
              2841.943
            ],
            [
              -1712.191,
              1472.205,
              2849.661
            ],
            [
              -1970.62,
              1705.012,
              3197.49
            ],
            [
              -1985.783,
              1723.093,
              3221.087
            ],
            [
              -2263.842,
              1978.495,
              3598.641
            ],
            [
              -2290.557,
              2000.118,
              3633.01
            ],
            [
              -2318.992,
              2034.018,
              3677.257
            ],
            [
              -2425.036,
              2130.514,
              3820.634
            ],
            [
              -2441.629,
              2140.826,
              3840.17
            ],
            [
              -2464.869,
              2140.123,
              3863.42
            ],
            [
              -2491.57,
              2126.123,
              3893.569
            ],
            [
              -2514.888,
              2120.968,
              3917.45
            ],
            [
              -2528.453,
              2120.094,
              3931.043
            ],
            [
              -2551.595,
              2124.955,
              3954.69
            ],
            [
              -2561.443,
              2130.364,
              3965.927
            ],
            [
              -2579.681,
              2142.148,
              3987.64
            ],
            [
              -2585.368,
              2148.928,
              3996.489
            ],
            [
              -2589.062,
              2159.012,
              4007.228
            ],
            [
              -2606.026,
              2184.914,
              4038.191
            ],
            [
              -2610.155,
              2197.282,
              4051.23
            ],
            [
              -2613.804,
              2219.561,
              4073.806
            ],
            [
              -2613.4,
              2232.891,
              4087.142
            ],
            [
              -2610.452,
              2250.329,
              4104.827
            ],
            [
              -2605.925,
              2263.95,
              4119.181
            ],
            [
              -2595.8,
              2280.361,
              4138.464
            ],
            [
              -2588.136,
              2284.788,
              4147.315
            ],
            [
              -2577.558,
              2305.756,
              4170.8
            ],
            [
              -2591.532,
              2385.037,
              4251.303
            ],
            [
              -2598.371,
              2436.365,
              4303.084
            ],
            [
              -2602.959,
              2542.201,
              4409.02
            ],
            [
              -2606.316,
              2602.394,
              4469.306
            ],
            [
              -2619.569,
              2661.607,
              4529.984
            ],
            [
              -2672.012,
              2798.342,
              4676.431
            ],
            [
              -2693.846,
              2841.028,
              4724.377
            ],
            [
              -2698.439,
              2873.392,
              4757.065
            ],
            [
              -2831.804,
              3253.114,
              5159.527
            ],
            [
              -2853.662,
              3294.686,
              5206.495
            ],
            [
              -2869.962,
              3320.622,
              5237.128
            ],
            [
              -2887.849,
              3332.714,
              5258.719
            ],
            [
              -2904.222,
              3355.687,
              5286.929
            ],
            [
              -3126.24,
              3576.651,
              5600.165
            ],
            [
              -3256.351,
              3702.491,
              5781.175
            ],
            [
              -3334.924,
              3786.24,
              5896.013
            ],
            [
              -3406.008,
              3855.385,
              5995.179
            ],
            [
              -3427.01,
              3872.449,
              6022.239
            ],
            [
              -3454.8,
              3907.442,
              6066.925
            ],
            [
              -3626.746,
              4078.528,
              6309.486
            ],
            [
              -3781.512,
              4235.95,
              6530.244
            ],
            [
              -3884.317,
              4337.92,
              6675.043
            ],
            [
              -3915.514,
              4362.95,
              6715.04
            ],
            [
              -3928.112,
              4380.98,
              6737.035
            ],
            [
              -4226.292,
              4683.356,
              7161.703
            ],
            [
              -4305.622,
              4762.647,
              7273.865
            ],
            [
              -4338.114,
              4787.696,
              7314.891
            ],
            [
              -4349.425,
              4805.702,
              7336.155
            ],
            [
              -4420.502,
              4877.057,
              7436.87
            ],
            [
              -4439.501,
              4898.534,
              7465.545
            ],
            [
              -4461.157,
              4915.604,
              7493.119
            ],
            [
              -4476.532,
              4922.548,
              7509.99
            ],
            [
              -4485.887,
              4927.855,
              7520.745
            ],
            [
              -4508.363,
              4948.698,
              7551.398
            ],
            [
              -4600.366,
              5004.825,
              7659.17
            ],
            [
              -4658.205,
              5020.288,
              7719.04
            ],
            [
              -4736.87,
              5026.089,
              7797.919
            ],
            [
              -4780.797,
              5023.521,
              7841.921
            ],
            [
              -4794.293,
              5028.186,
              7856.2
            ],
            [
              -4887.841,
              5032.012,
              7949.827
            ],
            [
              -5084.124,
              5030.911,
              8146.113
            ],
            [
              -5215.445,
              4939.641,
              8306.036
            ],
            [
              -5292.681,
              4884.129,
              8401.152
            ],
            [
              -5256.598,
              4911.398,
              8446.38
            ],
            [
              -5543.457,
              4708.104,
              8797.972
            ],
            [
              -5565.132,
              4686.208,
              8828.782
            ],
            [
              -5575.47,
              4670.817,
              8847.323
            ],
            [
              -5896.258,
              4344.494,
              9304.916
            ],
            [
              -5929.163,
              4307.201,
              9354.65
            ],
            [
              -5946.833,
              4308.097,
              9372.343
            ],
            [
              -5951.924,
              4313.34,
              9379.651
            ],
            [
              -5952.758,
              4324.297,
              9390.639
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:3616",
              "position": {
                "x": 373.827,
                "z": 1913.246
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 1.345,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:6650",
              "position": {
                "x": -11.424,
                "z": 1732.135
              },
              "distanceAlongShapeM": 832.471,
              "shapeOffsetM": 0.239,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:5167",
              "position": {
                "x": -582.7,
                "z": 1858.267
              },
              "distanceAlongShapeM": 1418.677,
              "shapeOffsetM": 4.487,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:6362",
              "position": {
                "x": -1048.212,
                "z": 2019.164
              },
              "distanceAlongShapeM": 1911.666,
              "shapeOffsetM": 2.357,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:6365",
              "position": {
                "x": -1411.426,
                "z": 1768.519
              },
              "distanceAlongShapeM": 2412.318,
              "shapeOffsetM": 3.132,
              "arrivalOffsetSeconds": 690,
              "departureOffsetSeconds": 690
            },
            {
              "stopId": "judu:stop:7852",
              "position": {
                "x": -1970.62,
                "z": 1705.012
              },
              "distanceAlongShapeM": 3197.49,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 870,
              "departureOffsetSeconds": 870
            },
            {
              "stopId": "judu:stop:5532",
              "position": {
                "x": -2290.557,
                "z": 2000.118
              },
              "distanceAlongShapeM": 3633.01,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 990,
              "departureOffsetSeconds": 990
            },
            {
              "stopId": "judu:stop:5543",
              "position": {
                "x": -2693.846,
                "z": 2841.028
              },
              "distanceAlongShapeM": 4724.377,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1230,
              "departureOffsetSeconds": 1230
            },
            {
              "stopId": "judu:stop:5573",
              "position": {
                "x": -2888.502,
                "z": 3332.034
              },
              "distanceAlongShapeM": 5258.719,
              "shapeOffsetM": 0.943,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            },
            {
              "stopId": "judu:stop:5587",
              "position": {
                "x": -3427.01,
                "z": 3872.449
              },
              "distanceAlongShapeM": 6022.239,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            },
            {
              "stopId": "judu:stop:5588",
              "position": {
                "x": -3915.514,
                "z": 4362.95
              },
              "distanceAlongShapeM": 6715.04,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1500,
              "departureOffsetSeconds": 1500
            },
            {
              "stopId": "judu:stop:5554",
              "position": {
                "x": -4338.114,
                "z": 4787.696
              },
              "distanceAlongShapeM": 7314.891,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1620,
              "departureOffsetSeconds": 1620
            },
            {
              "stopId": "judu:stop:5567",
              "position": {
                "x": -4488.111,
                "z": 4924.973
              },
              "distanceAlongShapeM": 7520.745,
              "shapeOffsetM": 3.641,
              "arrivalOffsetSeconds": 1680,
              "departureOffsetSeconds": 1680
            },
            {
              "stopId": "judu:stop:5557",
              "position": {
                "x": -4780.873,
                "z": 5020.164
              },
              "distanceAlongShapeM": 7841.921,
              "shapeOffsetM": 3.358,
              "arrivalOffsetSeconds": 1740,
              "departureOffsetSeconds": 1740
            },
            {
              "stopId": "judu:stop:7553",
              "position": {
                "x": -5291.942,
                "z": 4883.057
              },
              "distanceAlongShapeM": 8401.152,
              "shapeOffsetM": 1.302,
              "arrivalOffsetSeconds": 1800,
              "departureOffsetSeconds": 1800
            },
            {
              "stopId": "judu:stop:5571",
              "position": {
                "x": -5573.178,
                "z": 4668.533
              },
              "distanceAlongShapeM": 8847.344,
              "shapeOffsetM": 3.236,
              "arrivalOffsetSeconds": 1860,
              "departureOffsetSeconds": 1860
            },
            {
              "stopId": "judu:stop:16788",
              "position": {
                "x": -5896.258,
                "z": 4344.494
              },
              "distanceAlongShapeM": 9304.916,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1920,
              "departureOffsetSeconds": 1920
            }
          ],
          "departuresSeconds": [
            18540,
            19440,
            20820,
            22740,
            24000,
            25320,
            53640,
            54960,
            56700,
            58500,
            59880,
            61740
          ]
        },
        {
          "id": "judu:pattern:vilnius_trol_15:1",
          "sourceRouteId": "vilnius_trol_15",
          "sourceShapeId": "vilnius_trol_15_b-a",
          "directionId": 1,
          "headsign": "Stotis",
          "directionName": "Titnago g.–Žemieji Paneriai–Stotis",
          "mode": "trolleybus",
          "routeShortName": "15",
          "routeLongName": "Stotis–Žemieji Paneriai–Titnago g.",
          "routeColor": "DC3131",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              -5952.758,
              4324.297,
              0
            ],
            [
              -5927.145,
              4319.257,
              26.104
            ],
            [
              -5850.356,
              4408.94,
              144.17
            ],
            [
              -5542.812,
              4708.093,
              573.21
            ],
            [
              -5522.143,
              4730.228,
              603.495
            ],
            [
              -5495.647,
              4748.482,
              635.67
            ],
            [
              -5230.403,
              4933.216,
              958.906
            ],
            [
              -5256.503,
              4916.963,
              989.652
            ],
            [
              -5185.339,
              4963.618,
              1074.747
            ],
            [
              -5101.038,
              5023.407,
              1178.097
            ],
            [
              -5084.124,
              5030.911,
              1196.601
            ],
            [
              -4983.382,
              5032.532,
              1297.356
            ],
            [
              -4963.978,
              5034.293,
              1316.839
            ],
            [
              -4929.167,
              5031.606,
              1351.755
            ],
            [
              -4887.841,
              5032.012,
              1393.083
            ],
            [
              -4834.705,
              5081.197,
              1465.488
            ],
            [
              -4785.441,
              5130.448,
              1535.149
            ],
            [
              -4754.629,
              5157.75,
              1576.317
            ],
            [
              -4724.691,
              5171.709,
              1609.349
            ],
            [
              -4669.049,
              5178.483,
              1665.401
            ],
            [
              -4632.924,
              5176.815,
              1701.565
            ],
            [
              -4600.447,
              5171.052,
              1734.55
            ],
            [
              -4586.132,
              5157.088,
              1754.548
            ],
            [
              -4583.042,
              5111.394,
              1800.346
            ],
            [
              -4580.889,
              5011.17,
              1900.593
            ],
            [
              -4518.9,
              4977.81,
              1970.988
            ],
            [
              -4503.635,
              4960.862,
              1993.798
            ],
            [
              -4444.377,
              4915.316,
              2068.537
            ],
            [
              -4189.698,
              4671.592,
              2421.046
            ],
            [
              -4167.195,
              4657.338,
              2447.684
            ],
            [
              -4146.524,
              4629.659,
              2482.229
            ],
            [
              -4048.773,
              4533.349,
              2619.455
            ],
            [
              -3823.59,
              4303.471,
              2941.249
            ],
            [
              -3802.623,
              4284.184,
              2969.737
            ],
            [
              -3780.952,
              4268.223,
              2996.652
            ],
            [
              -3768.394,
              4247.967,
              3020.485
            ],
            [
              -3367.467,
              3844.694,
              3589.143
            ],
            [
              -3344.636,
              3829.677,
              3616.469
            ],
            [
              -3315.43,
              3793.692,
              3662.815
            ],
            [
              -3282.402,
              3763.059,
              3707.862
            ],
            [
              -3142.94,
              3618.132,
              3908.993
            ],
            [
              -2996.449,
              3469.738,
              4117.512
            ],
            [
              -2905.063,
              3381.305,
              4244.68
            ],
            [
              -2851.864,
              3323.598,
              4323.168
            ],
            [
              -2827.523,
              3276.416,
              4376.258
            ],
            [
              -2808.656,
              3248.254,
              4410.156
            ],
            [
              -2806.545,
              3221.5,
              4436.993
            ],
            [
              -2772.86,
              3118.493,
              4545.368
            ],
            [
              -2707,
              2936.995,
              4738.446
            ],
            [
              -2660.341,
              2801.476,
              4881.773
            ],
            [
              -2637.179,
              2724.257,
              4962.39
            ],
            [
              -2612.218,
              2675.949,
              5016.766
            ],
            [
              -2609.483,
              2648.071,
              5044.778
            ],
            [
              -2584.513,
              2574.315,
              5122.646
            ],
            [
              -2570.531,
              2514.913,
              5183.672
            ],
            [
              -2558.338,
              2437.886,
              5261.658
            ],
            [
              -2547.004,
              2385.365,
              5315.388
            ],
            [
              -2539.07,
              2359.622,
              5342.326
            ],
            [
              -2526.132,
              2324.884,
              5379.395
            ],
            [
              -2519.194,
              2315.856,
              5390.781
            ],
            [
              -2487.744,
              2306.396,
              5423.623
            ],
            [
              -2471.111,
              2298.31,
              5442.117
            ],
            [
              -2454.576,
              2284.659,
              5463.559
            ],
            [
              -2442.556,
              2271.088,
              5481.688
            ],
            [
              -2433.47,
              2237.532,
              5516.452
            ],
            [
              -2435.723,
              2169.786,
              5584.235
            ],
            [
              -2432.837,
              2155.209,
              5599.096
            ],
            [
              -2421.673,
              2138.248,
              5619.401
            ],
            [
              -2405.237,
              2119.033,
              5644.686
            ],
            [
              -2339.12,
              2063.317,
              5731.149
            ],
            [
              -2328.352,
              2051.995,
              5746.774
            ],
            [
              -2314.582,
              2044.048,
              5762.672
            ],
            [
              -2298.509,
              2024.75,
              5787.787
            ],
            [
              -1944.941,
              1697.877,
              6269.301
            ],
            [
              -1869.698,
              1631.955,
              6369.337
            ],
            [
              -1860.469,
              1622.903,
              6382.265
            ],
            [
              -1769.084,
              1537.785,
              6507.15
            ],
            [
              -1704.495,
              1480.033,
              6593.793
            ],
            [
              -1698.901,
              1478.9,
              6599.5
            ],
            [
              -1695.245,
              1481.922,
              6604.244
            ],
            [
              -1682.168,
              1491.708,
              6620.577
            ],
            [
              -1671.651,
              1502.653,
              6635.756
            ],
            [
              -1651.454,
              1530.355,
              6670.038
            ],
            [
              -1603.973,
              1571.579,
              6732.918
            ],
            [
              -1299.013,
              1921.245,
              7196.887
            ],
            [
              -1270.801,
              1947.457,
              7235.397
            ],
            [
              -1190.297,
              2047.317,
              7363.666
            ],
            [
              -1173.912,
              2061.495,
              7385.333
            ],
            [
              -1158.937,
              2069.019,
              7402.092
            ],
            [
              -1145.392,
              2068.776,
              7415.639
            ],
            [
              -1135.112,
              2066.366,
              7426.198
            ],
            [
              -987.662,
              2013.623,
              7582.797
            ],
            [
              -960.072,
              2006.847,
              7611.207
            ],
            [
              -943.398,
              1999.468,
              7629.441
            ],
            [
              -544.505,
              1865.369,
              8050.271
            ],
            [
              -471.457,
              1839.899,
              8127.632
            ],
            [
              -432.32,
              1825.49,
              8169.338
            ],
            [
              -327.19,
              1787.963,
              8280.965
            ],
            [
              -259.046,
              1774.482,
              8350.429
            ],
            [
              -147.106,
              1756.865,
              8463.747
            ],
            [
              9.981,
              1738.424,
              8621.913
            ],
            [
              41.02,
              1742.312,
              8653.194
            ],
            [
              64.443,
              1752.06,
              8678.564
            ],
            [
              97.435,
              1757.984,
              8712.084
            ],
            [
              156.41,
              1772.494,
              8772.818
            ],
            [
              318.606,
              1821.856,
              8942.359
            ],
            [
              328.524,
              1835.034,
              8958.852
            ],
            [
              374.971,
              1912.538,
              9049.208
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:1008",
              "position": {
                "x": -5851.894,
                "z": 4410.536
              },
              "distanceAlongShapeM": 144.18,
              "shapeOffsetM": 2.216,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:5570",
              "position": {
                "x": -5523.681,
                "z": 4732.259
              },
              "distanceAlongShapeM": 603.495,
              "shapeOffsetM": 2.547,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:7554",
              "position": {
                "x": -5256.503,
                "z": 4916.963
              },
              "distanceAlongShapeM": 989.652,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:5564",
              "position": {
                "x": -4963.962,
                "z": 5035.54
              },
              "distanceAlongShapeM": 1316.839,
              "shapeOffsetM": 1.247,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:5594",
              "position": {
                "x": -4669.05,
                "z": 5178.548
              },
              "distanceAlongShapeM": 1665.401,
              "shapeOffsetM": 0.065,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:6850",
              "position": {
                "x": -4517.509,
                "z": 4980.025
              },
              "distanceAlongShapeM": 1970.988,
              "shapeOffsetM": 2.616,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:6851",
              "position": {
                "x": -4166.695,
                "z": 4657.837
              },
              "distanceAlongShapeM": 2447.684,
              "shapeOffsetM": 0.707,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:5546",
              "position": {
                "x": -3780.952,
                "z": 4268.223
              },
              "distanceAlongShapeM": 2996.652,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:9384",
              "position": {
                "x": -3344.49,
                "z": 3829.822
              },
              "distanceAlongShapeM": 3616.469,
              "shapeOffsetM": 0.206,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:857",
              "position": {
                "x": -2808.656,
                "z": 3248.254
              },
              "distanceAlongShapeM": 4410.156,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:5542",
              "position": {
                "x": -2612.218,
                "z": 2675.949
              },
              "distanceAlongShapeM": 5016.766,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:5535",
              "position": {
                "x": -2313.635,
                "z": 2045.055
              },
              "distanceAlongShapeM": 5762.672,
              "shapeOffsetM": 1.383,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:7853",
              "position": {
                "x": -1868.675,
                "z": 1633.068
              },
              "distanceAlongShapeM": 6369.337,
              "shapeOffsetM": 1.512,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:6410",
              "position": {
                "x": -1654.972,
                "z": 1533.526
              },
              "distanceAlongShapeM": 6670.038,
              "shapeOffsetM": 4.736,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:6366",
              "position": {
                "x": -1299.013,
                "z": 1921.245
              },
              "distanceAlongShapeM": 7196.887,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1380,
              "departureOffsetSeconds": 1380
            },
            {
              "stopId": "judu:stop:6363",
              "position": {
                "x": -958.677,
                "z": 2010.875
              },
              "distanceAlongShapeM": 7611.207,
              "shapeOffsetM": 4.262,
              "arrivalOffsetSeconds": 1500,
              "departureOffsetSeconds": 1500
            },
            {
              "stopId": "judu:stop:5166",
              "position": {
                "x": -470.051,
                "z": 1843.985
              },
              "distanceAlongShapeM": 8127.615,
              "shapeOffsetM": 4.322,
              "arrivalOffsetSeconds": 1680,
              "departureOffsetSeconds": 1680
            },
            {
              "stopId": "judu:stop:5160",
              "position": {
                "x": 63.816,
                "z": 1754.143
              },
              "distanceAlongShapeM": 8678.564,
              "shapeOffsetM": 2.176,
              "arrivalOffsetSeconds": 1800,
              "departureOffsetSeconds": 1800
            },
            {
              "stopId": "judu:stop:3616",
              "position": {
                "x": 373.827,
                "z": 1913.246
              },
              "distanceAlongShapeM": 9049.208,
              "shapeOffsetM": 1.345,
              "arrivalOffsetSeconds": 1860,
              "departureOffsetSeconds": 1860
            }
          ],
          "departuresSeconds": [
            20940,
            22200,
            23520,
            25560,
            27240,
            28920,
            51600,
            52860,
            54660,
            56520,
            57900,
            59760,
            61560,
            63000,
            64860
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_trol_16",
      "sourceRouteId": "vilnius_trol_16",
      "mode": "trolleybus",
      "shortName": "16",
      "longName": "Pašilaičiai–Lazdynai–Stotis",
      "color": "DC3131",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_trol_16:0",
          "sourceRouteId": "vilnius_trol_16",
          "sourceShapeId": "vilnius_trol_16_a-b",
          "directionId": 0,
          "headsign": "Stotis",
          "directionName": "Pašilaičiai–Lazdynai–Stotis",
          "mode": "trolleybus",
          "routeShortName": "16",
          "routeLongName": "Pašilaičiai–Lazdynai–Stotis",
          "routeColor": "DC3131",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              -2898.02,
              -4403.939,
              0
            ],
            [
              -2904.267,
              -4392.283,
              13.224
            ],
            [
              -2902.49,
              -4364.484,
              41.08
            ],
            [
              -2922.066,
              -4325.629,
              84.588
            ],
            [
              -2938.397,
              -4244.738,
              167.111
            ],
            [
              -2943.47,
              -4203.459,
              208.7
            ],
            [
              -2943.332,
              -4158.933,
              253.226
            ],
            [
              -2942.883,
              -4106.854,
              305.307
            ],
            [
              -2936.886,
              -4048.837,
              363.633
            ],
            [
              -2933.232,
              -3950.938,
              461.601
            ],
            [
              -2933.288,
              -3880.804,
              531.735
            ],
            [
              -2935.53,
              -3825.104,
              587.48
            ],
            [
              -2941.624,
              -3778.189,
              634.789
            ],
            [
              -2941.11,
              -3739.288,
              673.693
            ],
            [
              -2942.553,
              -3711.432,
              701.587
            ],
            [
              -2962.772,
              -3578.604,
              835.945
            ],
            [
              -2994.393,
              -3434.443,
              983.533
            ],
            [
              -3009.522,
              -3378.516,
              1041.47
            ],
            [
              -3022.156,
              -3343.455,
              1078.738
            ],
            [
              -3029.648,
              -3313.596,
              1109.522
            ],
            [
              -3083.217,
              -3134.541,
              1296.419
            ],
            [
              -3102.428,
              -3054.053,
              1379.168
            ],
            [
              -3135.722,
              -2971.783,
              1467.919
            ],
            [
              -3158.619,
              -2877.179,
              1565.255
            ],
            [
              -3186.209,
              -2796.544,
              1650.479
            ],
            [
              -3248.067,
              -2685.253,
              1777.806
            ],
            [
              -3332.852,
              -2557.976,
              1930.737
            ],
            [
              -3345.044,
              -2540.486,
              1952.057
            ],
            [
              -3361.538,
              -2502.927,
              1993.078
            ],
            [
              -3386.79,
              -2435.693,
              2064.898
            ],
            [
              -3393.431,
              -2409.973,
              2091.462
            ],
            [
              -3395.464,
              -2378.768,
              2122.733
            ],
            [
              -3388.347,
              -2243.256,
              2258.432
            ],
            [
              -3384.424,
              -2226.45,
              2275.689
            ],
            [
              -3365.672,
              -2038.645,
              2464.428
            ],
            [
              -3370.713,
              -1991.384,
              2511.957
            ],
            [
              -3374.974,
              -1943.859,
              2559.673
            ],
            [
              -3391.774,
              -1872.32,
              2633.158
            ],
            [
              -3430.979,
              -1754.748,
              2757.094
            ],
            [
              -3480.186,
              -1619.191,
              2901.306
            ],
            [
              -3508.003,
              -1550.799,
              2975.139
            ],
            [
              -3521.109,
              -1520.135,
              3008.486
            ],
            [
              -3534.455,
              -1477.979,
              3052.704
            ],
            [
              -3620.717,
              -1211.532,
              3332.767
            ],
            [
              -3662.686,
              -1103.933,
              3448.261
            ],
            [
              -3677.364,
              -1066.903,
              3488.095
            ],
            [
              -3685.368,
              -1042.059,
              3514.196
            ],
            [
              -3720.918,
              -930.373,
              3631.403
            ],
            [
              -3751.424,
              -837.404,
              3729.249
            ],
            [
              -3758.325,
              -817.25,
              3750.552
            ],
            [
              -3766.218,
              -791.548,
              3777.439
            ],
            [
              -3793.988,
              -719.82,
              3854.355
            ],
            [
              -3843.779,
              -616.54,
              3969.01
            ],
            [
              -3881.258,
              -546.871,
              4048.121
            ],
            [
              -3968.352,
              -399.129,
              4219.623
            ],
            [
              -3983.006,
              -376.666,
              4246.443
            ],
            [
              -3999.719,
              -350.005,
              4277.91
            ],
            [
              -4048.201,
              -282.373,
              4361.124
            ],
            [
              -4133.499,
              -180.709,
              4493.831
            ],
            [
              -4196.231,
              -117.271,
              4583.048
            ],
            [
              -4217.103,
              -95.271,
              4613.373
            ],
            [
              -4243.751,
              -67.483,
              4651.874
            ],
            [
              -4402.336,
              85.535,
              4872.246
            ],
            [
              -4449.086,
              142,
              4945.553
            ],
            [
              -4479.797,
              193.736,
              5005.717
            ],
            [
              -4502.905,
              237.549,
              5055.251
            ],
            [
              -4519.036,
              274.562,
              5095.626
            ],
            [
              -4536.228,
              324.952,
              5148.868
            ],
            [
              -4547.048,
              370.78,
              5195.956
            ],
            [
              -4566.578,
              510.266,
              5336.803
            ],
            [
              -4570.606,
              537.669,
              5364.501
            ],
            [
              -4575.517,
              590.57,
              5417.629
            ],
            [
              -4579.623,
              651.866,
              5479.062
            ],
            [
              -4586.366,
              709.869,
              5537.456
            ],
            [
              -4584.541,
              741.007,
              5568.647
            ],
            [
              -4573.306,
              794.248,
              5623.061
            ],
            [
              -4555.909,
              830.684,
              5663.437
            ],
            [
              -4538.646,
              859.331,
              5696.883
            ],
            [
              -4503.175,
              896.569,
              5748.312
            ],
            [
              -4462.091,
              922.579,
              5796.937
            ],
            [
              -4443.54,
              937.916,
              5821.007
            ],
            [
              -4396.195,
              965.972,
              5876.04
            ],
            [
              -4188.107,
              1100.42,
              6123.784
            ],
            [
              -4152.942,
              1128.063,
              6168.514
            ],
            [
              -4048.114,
              1175.924,
              6283.75
            ],
            [
              -3997.487,
              1193.972,
              6337.498
            ],
            [
              -3829.673,
              1236.704,
              6510.667
            ],
            [
              -3789.4,
              1252.704,
              6554.002
            ],
            [
              -3749.695,
              1273.165,
              6598.669
            ],
            [
              -3705.908,
              1305.8,
              6653.28
            ],
            [
              -3669.839,
              1339.683,
              6702.768
            ],
            [
              -3634.26,
              1382.479,
              6758.422
            ],
            [
              -3619.001,
              1406.704,
              6787.052
            ],
            [
              -3601.633,
              1440.911,
              6825.416
            ],
            [
              -3592.427,
              1468.215,
              6854.23
            ],
            [
              -3579.402,
              1495.072,
              6884.078
            ],
            [
              -3566.606,
              1526.019,
              6917.567
            ],
            [
              -3560.672,
              1570.444,
              6962.386
            ],
            [
              -3561.909,
              1610.54,
              7002.501
            ],
            [
              -3553.124,
              1670.501,
              7063.102
            ],
            [
              -3546.511,
              1753.876,
              7146.739
            ],
            [
              -3528.502,
              1849.211,
              7243.761
            ],
            [
              -3507.519,
              1881.216,
              7282.03
            ],
            [
              -3466.64,
              1929.443,
              7345.252
            ],
            [
              -3411.117,
              1970.818,
              7414.496
            ],
            [
              -3378.421,
              1984.588,
              7449.973
            ],
            [
              -3293.772,
              2003.28,
              7536.661
            ],
            [
              -3253.06,
              2007.021,
              7577.545
            ],
            [
              -3234.374,
              2005.581,
              7596.286
            ],
            [
              -3211.057,
              2010.74,
              7620.167
            ],
            [
              -2960.432,
              2100.974,
              7886.541
            ],
            [
              -2902.519,
              2128.901,
              7950.836
            ],
            [
              -2763.528,
              2181.007,
              8099.273
            ],
            [
              -2704.044,
              2203.421,
              8162.84
            ],
            [
              -2694.973,
              2206.697,
              8172.484
            ],
            [
              -2620.644,
              2234.153,
              8251.722
            ],
            [
              -2602.113,
              2260.544,
              8283.969
            ],
            [
              -2588.136,
              2284.788,
              8311.953
            ],
            [
              -2571.13,
              2297.847,
              8333.395
            ],
            [
              -2532.153,
              2312.745,
              8375.122
            ],
            [
              -2506.977,
              2313.414,
              8400.307
            ],
            [
              -2483.854,
              2307.44,
              8424.189
            ],
            [
              -2455.846,
              2285.795,
              8459.586
            ],
            [
              -2438.355,
              2253.203,
              8496.575
            ],
            [
              -2433.47,
              2237.532,
              8512.99
            ],
            [
              -2435.723,
              2169.786,
              8580.773
            ],
            [
              -2432.837,
              2155.209,
              8595.634
            ],
            [
              -2421.673,
              2138.248,
              8615.939
            ],
            [
              -2405.237,
              2119.033,
              8641.224
            ],
            [
              -2339.12,
              2063.317,
              8727.687
            ],
            [
              -2328.352,
              2051.995,
              8743.311
            ],
            [
              -2314.582,
              2044.048,
              8759.21
            ],
            [
              -2298.509,
              2024.75,
              8784.325
            ],
            [
              -1944.941,
              1697.877,
              9265.839
            ],
            [
              -1869.698,
              1631.955,
              9365.875
            ],
            [
              -1860.469,
              1622.903,
              9378.803
            ],
            [
              -1769.084,
              1537.785,
              9503.688
            ],
            [
              -1704.495,
              1480.033,
              9590.331
            ],
            [
              -1698.901,
              1478.9,
              9596.038
            ],
            [
              -1682.168,
              1491.708,
              9617.111
            ],
            [
              -1671.651,
              1502.653,
              9632.289
            ],
            [
              -1651.454,
              1530.355,
              9666.572
            ],
            [
              -1603.973,
              1571.579,
              9729.452
            ],
            [
              -1299.013,
              1921.245,
              10193.421
            ],
            [
              -1270.801,
              1947.457,
              10231.93
            ],
            [
              -1190.297,
              2047.317,
              10360.199
            ],
            [
              -1173.912,
              2061.495,
              10381.867
            ],
            [
              -1158.937,
              2069.019,
              10398.626
            ],
            [
              -1145.392,
              2068.776,
              10412.173
            ],
            [
              -1135.112,
              2066.366,
              10422.732
            ],
            [
              -987.662,
              2013.623,
              10579.331
            ],
            [
              -960.072,
              2006.847,
              10607.741
            ],
            [
              -943.398,
              1999.468,
              10625.975
            ],
            [
              -544.505,
              1865.369,
              11046.805
            ],
            [
              -471.457,
              1839.899,
              11124.166
            ],
            [
              -432.32,
              1825.49,
              11165.871
            ],
            [
              -327.19,
              1787.963,
              11277.498
            ],
            [
              -259.046,
              1774.482,
              11346.963
            ],
            [
              -147.106,
              1756.865,
              11460.281
            ],
            [
              9.981,
              1738.424,
              11618.446
            ],
            [
              41.02,
              1742.312,
              11649.728
            ],
            [
              64.443,
              1752.06,
              11675.098
            ],
            [
              97.435,
              1757.984,
              11708.618
            ],
            [
              156.41,
              1772.494,
              11769.352
            ],
            [
              318.606,
              1821.856,
              11938.893
            ],
            [
              328.524,
              1835.034,
              11955.386
            ],
            [
              374.971,
              1912.538,
              12045.742
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:8275",
              "position": {
                "x": -2897.378,
                "z": -4403.536
              },
              "distanceAlongShapeM": 0.052,
              "shapeOffsetM": 0.756,
              "arrivalOffsetSeconds": -840,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:6484",
              "position": {
                "x": -2923.723,
                "z": -4326.261
              },
              "distanceAlongShapeM": 84.588,
              "shapeOffsetM": 1.774,
              "arrivalOffsetSeconds": 60,
              "departureOffsetSeconds": 60
            },
            {
              "stopId": "judu:stop:6523",
              "position": {
                "x": -2947.565,
                "z": -4106.537
              },
              "distanceAlongShapeM": 305.307,
              "shapeOffsetM": 4.693,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:6482",
              "position": {
                "x": -2942.439,
                "z": -3778.227
              },
              "distanceAlongShapeM": 634.789,
              "shapeOffsetM": 0.816,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:6478",
              "position": {
                "x": -3026.974,
                "z": -3344.813
              },
              "distanceAlongShapeM": 1078.738,
              "shapeOffsetM": 5.006,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:6477",
              "position": {
                "x": -3137.083,
                "z": -2972.18
              },
              "distanceAlongShapeM": 1467.919,
              "shapeOffsetM": 1.418,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:6476",
              "position": {
                "x": -3349.352,
                "z": -2543.216
              },
              "distanceAlongShapeM": 1952.057,
              "shapeOffsetM": 5.101,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:6475",
              "position": {
                "x": -3389.87,
                "z": -2243.053
              },
              "distanceAlongShapeM": 2258.432,
              "shapeOffsetM": 1.536,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:5620",
              "position": {
                "x": -3375.166,
                "z": -1991.724
              },
              "distanceAlongShapeM": 2512.016,
              "shapeOffsetM": 4.466,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:928",
              "position": {
                "x": -3525.544,
                "z": -1521.55
              },
              "distanceAlongShapeM": 3008.486,
              "shapeOffsetM": 4.655,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:5643",
              "position": {
                "x": -3680.758,
                "z": -1067.996
              },
              "distanceAlongShapeM": 3488.095,
              "shapeOffsetM": 3.566,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:5646",
              "position": {
                "x": -3761.526,
                "z": -818.346
              },
              "distanceAlongShapeM": 3750.552,
              "shapeOffsetM": 3.383,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            },
            {
              "stopId": "judu:stop:5651",
              "position": {
                "x": -3986.683,
                "z": -379.175
              },
              "distanceAlongShapeM": 4246.351,
              "shapeOffsetM": 4.451,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:5656",
              "position": {
                "x": -4221.08,
                "z": -99.045
              },
              "distanceAlongShapeM": 4613.403,
              "shapeOffsetM": 5.483,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:5668",
              "position": {
                "x": -4574.501,
                "z": 537.119
              },
              "distanceAlongShapeM": 5364.501,
              "shapeOffsetM": 3.934,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:6460",
              "position": {
                "x": -4445.644,
                "z": 941.22
              },
              "distanceAlongShapeM": 5821.007,
              "shapeOffsetM": 3.917,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:6461",
              "position": {
                "x": -4154.055,
                "z": 1129.888
              },
              "distanceAlongShapeM": 6168.514,
              "shapeOffsetM": 2.137,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            },
            {
              "stopId": "judu:stop:6333",
              "position": {
                "x": -3596.615,
                "z": 1469.767
              },
              "distanceAlongShapeM": 6854.23,
              "shapeOffsetM": 4.467,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            },
            {
              "stopId": "judu:stop:721",
              "position": {
                "x": -3293.772,
                "z": 2003.28
              },
              "distanceAlongShapeM": 7536.661,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1560,
              "departureOffsetSeconds": 1560
            },
            {
              "stopId": "judu:stop:6337",
              "position": {
                "x": -2705.632,
                "z": 2207.819
              },
              "distanceAlongShapeM": 8162.84,
              "shapeOffsetM": 4.675,
              "arrivalOffsetSeconds": 1620,
              "departureOffsetSeconds": 1620
            },
            {
              "stopId": "judu:stop:5535",
              "position": {
                "x": -2313.635,
                "z": 2045.055
              },
              "distanceAlongShapeM": 8759.21,
              "shapeOffsetM": 1.383,
              "arrivalOffsetSeconds": 1800,
              "departureOffsetSeconds": 1800
            },
            {
              "stopId": "judu:stop:7853",
              "position": {
                "x": -1868.675,
                "z": 1633.068
              },
              "distanceAlongShapeM": 9365.875,
              "shapeOffsetM": 1.512,
              "arrivalOffsetSeconds": 1920,
              "departureOffsetSeconds": 1920
            },
            {
              "stopId": "judu:stop:6410",
              "position": {
                "x": -1654.972,
                "z": 1533.526
              },
              "distanceAlongShapeM": 9666.572,
              "shapeOffsetM": 4.736,
              "arrivalOffsetSeconds": 2040,
              "departureOffsetSeconds": 2040
            },
            {
              "stopId": "judu:stop:6366",
              "position": {
                "x": -1299.013,
                "z": 1921.245
              },
              "distanceAlongShapeM": 10193.421,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2160,
              "departureOffsetSeconds": 2160
            },
            {
              "stopId": "judu:stop:6363",
              "position": {
                "x": -958.677,
                "z": 2010.875
              },
              "distanceAlongShapeM": 10607.741,
              "shapeOffsetM": 4.262,
              "arrivalOffsetSeconds": 2280,
              "departureOffsetSeconds": 2280
            },
            {
              "stopId": "judu:stop:5166",
              "position": {
                "x": -470.051,
                "z": 1843.985
              },
              "distanceAlongShapeM": 11124.148,
              "shapeOffsetM": 4.322,
              "arrivalOffsetSeconds": 2400,
              "departureOffsetSeconds": 2400
            },
            {
              "stopId": "judu:stop:5160",
              "position": {
                "x": 63.816,
                "z": 1754.143
              },
              "distanceAlongShapeM": 11675.098,
              "shapeOffsetM": 2.176,
              "arrivalOffsetSeconds": 2580,
              "departureOffsetSeconds": 2580
            },
            {
              "stopId": "judu:stop:3616",
              "position": {
                "x": 373.827,
                "z": 1913.246
              },
              "distanceAlongShapeM": 12045.742,
              "shapeOffsetM": 1.345,
              "arrivalOffsetSeconds": 2640,
              "departureOffsetSeconds": 2640
            }
          ],
          "departuresSeconds": [
            18240,
            19380,
            20520,
            21660,
            22680,
            23160,
            23640,
            24300,
            24900,
            25500,
            26100,
            26820,
            27540,
            28440,
            29400,
            30000,
            30600,
            31440,
            32400,
            33000,
            33660,
            34320,
            35340,
            36660,
            37800,
            39060,
            40320,
            41460,
            42660,
            43860,
            45060,
            46320,
            47460,
            48780,
            49860,
            51060,
            51660,
            52320,
            52980,
            53640,
            54420,
            55080,
            55920,
            56580,
            57300,
            57840,
            58380,
            58920,
            59640,
            60360,
            61320,
            62400,
            63360,
            63960,
            64860,
            65940,
            67380,
            68820,
            69960,
            71220,
            72300,
            73620,
            75120,
            76260,
            77460,
            78600,
            80100,
            81600,
            83160
          ]
        },
        {
          "id": "judu:pattern:vilnius_trol_16:1",
          "sourceRouteId": "vilnius_trol_16",
          "sourceShapeId": "vilnius_trol_16_b-a",
          "directionId": 1,
          "headsign": "Pašilaičiai",
          "directionName": "Stotis–Lazdynai–Pašilaičiai",
          "mode": "trolleybus",
          "routeShortName": "16",
          "routeLongName": "Pašilaičiai–Lazdynai–Stotis",
          "routeColor": "DC3131",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              374.971,
              1912.538,
              0
            ],
            [
              381.688,
              1919.781,
              9.878
            ],
            [
              390.297,
              1931.87,
              24.719
            ],
            [
              381.613,
              1950.953,
              45.685
            ],
            [
              374.681,
              1959.986,
              57.072
            ],
            [
              359.73,
              1989.203,
              89.892
            ],
            [
              357.312,
              1998.153,
              99.163
            ],
            [
              360.055,
              2007.009,
              108.434
            ],
            [
              365.317,
              2012.479,
              116.024
            ],
            [
              381.462,
              2013.297,
              132.189
            ],
            [
              469.575,
              1962.704,
              233.794
            ],
            [
              480.298,
              1952.175,
              248.822
            ],
            [
              481.71,
              1947.816,
              253.405
            ],
            [
              476.141,
              1933.639,
              268.636
            ],
            [
              470.194,
              1925.956,
              278.352
            ],
            [
              463.683,
              1922.735,
              285.616
            ],
            [
              447.558,
              1923.03,
              301.744
            ],
            [
              415.411,
              1929.184,
              334.474
            ],
            [
              398.6,
              1927.265,
              351.395
            ],
            [
              334.106,
              1822.687,
              474.261
            ],
            [
              318.606,
              1821.856,
              489.783
            ],
            [
              29.934,
              1735.835,
              790.999
            ],
            [
              -11.394,
              1732.372,
              832.471
            ],
            [
              -46.755,
              1740.57,
              868.77
            ],
            [
              -320.217,
              1781.157,
              1145.228
            ],
            [
              -550.531,
              1853.232,
              1386.556
            ],
            [
              -581.279,
              1862.523,
              1418.677
            ],
            [
              -596.688,
              1869.651,
              1435.655
            ],
            [
              -1032.712,
              2019.998,
              1896.872
            ],
            [
              -1047.441,
              2021.391,
              1911.666
            ],
            [
              -1075.687,
              2034.129,
              1942.652
            ],
            [
              -1134.042,
              2054.101,
              2004.33
            ],
            [
              -1154.642,
              2056.697,
              2025.093
            ],
            [
              -1164.417,
              2051.306,
              2036.256
            ],
            [
              -1208.37,
              2010.905,
              2095.956
            ],
            [
              -1267.715,
              1939.609,
              2188.719
            ],
            [
              -1394.1,
              1799.379,
              2377.498
            ],
            [
              -1413.741,
              1770.628,
              2412.318
            ],
            [
              -1434.923,
              1753.354,
              2439.65
            ],
            [
              -1515.962,
              1659.065,
              2563.979
            ],
            [
              -1594.12,
              1581.422,
              2674.148
            ],
            [
              -1692.298,
              1466.285,
              2825.46
            ],
            [
              -1701.366,
              1464.22,
              2834.76
            ],
            [
              -1708.441,
              1465.459,
              2841.943
            ],
            [
              -1712.191,
              1472.205,
              2849.661
            ],
            [
              -1970.62,
              1705.012,
              3197.49
            ],
            [
              -1985.783,
              1723.093,
              3221.087
            ],
            [
              -2263.842,
              1978.495,
              3598.641
            ],
            [
              -2290.557,
              2000.118,
              3633.01
            ],
            [
              -2318.992,
              2034.018,
              3677.257
            ],
            [
              -2425.036,
              2130.514,
              3820.634
            ],
            [
              -2441.629,
              2140.826,
              3840.17
            ],
            [
              -2453.884,
              2141.043,
              3852.427
            ],
            [
              -2464.869,
              2140.123,
              3863.45
            ],
            [
              -2491.57,
              2126.123,
              3893.599
            ],
            [
              -2514.888,
              2120.968,
              3917.48
            ],
            [
              -2528.453,
              2120.094,
              3931.073
            ],
            [
              -2551.595,
              2124.955,
              3954.72
            ],
            [
              -2561.443,
              2130.364,
              3965.956
            ],
            [
              -2579.681,
              2142.148,
              3987.669
            ],
            [
              -2607.297,
              2186.05,
              4039.535
            ],
            [
              -2618.809,
              2191.819,
              4052.412
            ],
            [
              -2640.075,
              2193.306,
              4073.729
            ],
            [
              -2665.388,
              2184.846,
              4100.419
            ],
            [
              -2681.67,
              2176.227,
              4118.841
            ],
            [
              -2692.184,
              2172.41,
              4130.027
            ],
            [
              -2738.119,
              2158.296,
              4178.081
            ],
            [
              -2899.782,
              2101.023,
              4349.59
            ],
            [
              -2971.67,
              2085.586,
              4423.116
            ],
            [
              -3160.259,
              2016.062,
              4624.112
            ],
            [
              -3215.258,
              1991.889,
              4684.189
            ],
            [
              -3241.166,
              1975.384,
              4714.908
            ],
            [
              -3275.786,
              1961.777,
              4752.106
            ],
            [
              -3353.278,
              1920.828,
              4839.752
            ],
            [
              -3402.898,
              1887.184,
              4899.702
            ],
            [
              -3447.61,
              1838.983,
              4965.448
            ],
            [
              -3464.825,
              1813.679,
              4996.053
            ],
            [
              -3479.576,
              1781.653,
              5031.313
            ],
            [
              -3552.495,
              1521.32,
              5301.665
            ],
            [
              -3561.139,
              1488.768,
              5335.346
            ],
            [
              -3571.509,
              1457.992,
              5367.821
            ],
            [
              -3607.243,
              1385.693,
              5448.469
            ],
            [
              -3647.326,
              1335.952,
              5512.35
            ],
            [
              -3697.872,
              1285.623,
              5583.68
            ],
            [
              -3750.727,
              1250.919,
              5646.91
            ],
            [
              -3785.215,
              1233.706,
              5685.455
            ],
            [
              -3881.236,
              1201.976,
              5786.583
            ],
            [
              -3947.947,
              1186.435,
              5855.08
            ],
            [
              -4028.355,
              1162.223,
              5939.054
            ],
            [
              -4081.657,
              1138.655,
              5997.334
            ],
            [
              -4117.491,
              1118.124,
              6038.633
            ],
            [
              -4158.16,
              1094.22,
              6085.806
            ],
            [
              -4168.309,
              1088.946,
              6097.244
            ],
            [
              -4405.143,
              935,
              6379.715
            ],
            [
              -4424.214,
              922.705,
              6402.405
            ],
            [
              -4433.353,
              916.8,
              6413.287
            ],
            [
              -4463.138,
              899.22,
              6447.873
            ],
            [
              -4519.455,
              850.095,
              6522.605
            ],
            [
              -4559.388,
              778.424,
              6604.65
            ],
            [
              -4567.189,
              737.369,
              6646.439
            ],
            [
              -4562.176,
              653.793,
              6730.165
            ],
            [
              -4542.083,
              471.996,
              6913.069
            ],
            [
              -4535.565,
              436.694,
              6948.968
            ],
            [
              -4533.311,
              419.524,
              6966.285
            ],
            [
              -4527.744,
              368.221,
              7017.89
            ],
            [
              -4516.259,
              323.495,
              7064.067
            ],
            [
              -4491.638,
              255.166,
              7136.696
            ],
            [
              -4427.619,
              152.763,
              7257.464
            ],
            [
              -4367.011,
              77.134,
              7354.382
            ],
            [
              -4080.333,
              -210.913,
              7760.774
            ],
            [
              -3954.469,
              -380.846,
              7972.243
            ],
            [
              -3926.158,
              -422.036,
              8022.225
            ],
            [
              -3919.036,
              -433.74,
              8035.925
            ],
            [
              -3857.936,
              -540.596,
              8159.016
            ],
            [
              -3823.641,
              -607.984,
              8234.629
            ],
            [
              -3766.483,
              -732.543,
              8371.676
            ],
            [
              -3707.64,
              -908.34,
              8557.06
            ],
            [
              -3695.741,
              -928.584,
              8580.542
            ],
            [
              -3679.687,
              -950.175,
              8607.447
            ],
            [
              -3673.878,
              -969.04,
              8627.187
            ],
            [
              -3654.555,
              -1007.226,
              8669.983
            ],
            [
              -3618.264,
              -1069.098,
              8741.713
            ],
            [
              -3599.031,
              -1113.947,
              8790.512
            ],
            [
              -3569.469,
              -1193.5,
              8875.38
            ],
            [
              -3554.873,
              -1243.849,
              8927.802
            ],
            [
              -3546.348,
              -1270.446,
              8955.732
            ],
            [
              -3520.478,
              -1415.883,
              9103.452
            ],
            [
              -3500.646,
              -1498.607,
              9188.52
            ],
            [
              -3461.302,
              -1608.388,
              9305.138
            ],
            [
              -3438.975,
              -1658.872,
              9360.339
            ],
            [
              -3424.066,
              -1696.754,
              9401.05
            ],
            [
              -3409.647,
              -1735.195,
              9442.106
            ],
            [
              -3354.323,
              -1899.889,
              9615.844
            ],
            [
              -3343.31,
              -1954.868,
              9671.915
            ],
            [
              -3339.232,
              -2037.994,
              9755.141
            ],
            [
              -3350.012,
              -2176.443,
              9894.008
            ],
            [
              -3368.406,
              -2305.768,
              10024.635
            ],
            [
              -3372.034,
              -2365.819,
              10084.796
            ],
            [
              -3365.771,
              -2420.444,
              10139.779
            ],
            [
              -3338.206,
              -2495.543,
              10219.777
            ],
            [
              -3294.464,
              -2574.233,
              10309.807
            ],
            [
              -3260.996,
              -2616.85,
              10363.995
            ],
            [
              -3240.415,
              -2653.104,
              10405.684
            ],
            [
              -3181.544,
              -2750.984,
              10519.904
            ],
            [
              -3157.274,
              -2800.391,
              10574.95
            ],
            [
              -3108.891,
              -2944.844,
              10727.29
            ],
            [
              -3088.313,
              -3020.904,
              10806.085
            ],
            [
              -3081.131,
              -3038.915,
              10825.475
            ],
            [
              -3066.407,
              -3094.76,
              10883.229
            ],
            [
              -3058.312,
              -3116.524,
              10906.45
            ],
            [
              -3044.503,
              -3168.617,
              10960.341
            ],
            [
              -2983.753,
              -3378.969,
              11179.29
            ],
            [
              -2973.575,
              -3406.127,
              11208.293
            ],
            [
              -2964.33,
              -3447.216,
              11250.409
            ],
            [
              -2935.834,
              -3585.756,
              11391.849
            ],
            [
              -2926.739,
              -3654.936,
              11461.624
            ],
            [
              -2914.467,
              -3799.87,
              11607.077
            ],
            [
              -2911.34,
              -3835.779,
              11643.122
            ],
            [
              -2910.491,
              -3863.444,
              11670.8
            ],
            [
              -2921.12,
              -4178.248,
              11985.783
            ],
            [
              -2920.043,
              -4206.629,
              12014.185
            ],
            [
              -2917.063,
              -4240.66,
              12048.346
            ],
            [
              -2899.032,
              -4314.449,
              12124.306
            ],
            [
              -2865.992,
              -4377.371,
              12195.375
            ],
            [
              -2823.799,
              -4432.662,
              12264.926
            ],
            [
              -2835.666,
              -4448.038,
              12284.349
            ],
            [
              -2850.011,
              -4458.605,
              12302.166
            ],
            [
              -2853.525,
              -4457.805,
              12305.77
            ],
            [
              -2898.02,
              -4403.939,
              12375.637
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:3616",
              "position": {
                "x": 373.827,
                "z": 1913.246
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 1.345,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:6650",
              "position": {
                "x": -11.424,
                "z": 1732.135
              },
              "distanceAlongShapeM": 832.471,
              "shapeOffsetM": 0.239,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:5167",
              "position": {
                "x": -582.7,
                "z": 1858.267
              },
              "distanceAlongShapeM": 1418.677,
              "shapeOffsetM": 4.487,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:6362",
              "position": {
                "x": -1048.212,
                "z": 2019.164
              },
              "distanceAlongShapeM": 1911.666,
              "shapeOffsetM": 2.357,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:6365",
              "position": {
                "x": -1411.426,
                "z": 1768.519
              },
              "distanceAlongShapeM": 2412.318,
              "shapeOffsetM": 3.132,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:7852",
              "position": {
                "x": -1970.62,
                "z": 1705.012
              },
              "distanceAlongShapeM": 3197.49,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:5532",
              "position": {
                "x": -2290.557,
                "z": 2000.118
              },
              "distanceAlongShapeM": 3633.01,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:6338",
              "position": {
                "x": -2690.837,
                "z": 2168.596
              },
              "distanceAlongShapeM": 4130.027,
              "shapeOffsetM": 4.045,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:720",
              "position": {
                "x": -3240.098,
                "z": 1973.399
              },
              "distanceAlongShapeM": 4714.908,
              "shapeOffsetM": 2.254,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:790",
              "position": {
                "x": -3555.031,
                "z": 1486.855
              },
              "distanceAlongShapeM": 5335.346,
              "shapeOffsetM": 6.401,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:6648",
              "position": {
                "x": -4156.018,
                "z": 1090.96
              },
              "distanceAlongShapeM": 6085.612,
              "shapeOffsetM": 3.896,
              "arrivalOffsetSeconds": 1380,
              "departureOffsetSeconds": 1380
            },
            {
              "stopId": "judu:stop:6462",
              "position": {
                "x": -4421.523,
                "z": 918.541
              },
              "distanceAlongShapeM": 6402.4,
              "shapeOffsetM": 4.958,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            },
            {
              "stopId": "judu:stop:1071",
              "position": {
                "x": -4530.426,
                "z": 437.286
              },
              "distanceAlongShapeM": 6949.05,
              "shapeOffsetM": 5.172,
              "arrivalOffsetSeconds": 1500,
              "departureOffsetSeconds": 1500
            },
            {
              "stopId": "judu:stop:1004",
              "position": {
                "x": -4077.229,
                "z": -208.399
              },
              "distanceAlongShapeM": 7760.774,
              "shapeOffsetM": 3.995,
              "arrivalOffsetSeconds": 1620,
              "departureOffsetSeconds": 1620
            },
            {
              "stopId": "judu:stop:6649",
              "position": {
                "x": -3921.604,
                "z": -419.265
              },
              "distanceAlongShapeM": 8022.225,
              "shapeOffsetM": 5.33,
              "arrivalOffsetSeconds": 1680,
              "departureOffsetSeconds": 1680
            },
            {
              "stopId": "judu:stop:6643",
              "position": {
                "x": -3679.35,
                "z": -950.021
              },
              "distanceAlongShapeM": 8607.447,
              "shapeOffsetM": 0.37,
              "arrivalOffsetSeconds": 1800,
              "departureOffsetSeconds": 1800
            },
            {
              "stopId": "judu:stop:4990",
              "position": {
                "x": -3543.073,
                "z": -1269.659
              },
              "distanceAlongShapeM": 8955.732,
              "shapeOffsetM": 3.368,
              "arrivalOffsetSeconds": 1920,
              "departureOffsetSeconds": 1920
            },
            {
              "stopId": "judu:stop:5722",
              "position": {
                "x": -3418.974,
                "z": -1694.844
              },
              "distanceAlongShapeM": 9401.05,
              "shapeOffsetM": 5.439,
              "arrivalOffsetSeconds": 2040,
              "departureOffsetSeconds": 2040
            },
            {
              "stopId": "judu:stop:6472",
              "position": {
                "x": -3345.53,
                "z": -2177.035
              },
              "distanceAlongShapeM": 9894.008,
              "shapeOffsetM": 4.521,
              "arrivalOffsetSeconds": 2160,
              "departureOffsetSeconds": 2160
            },
            {
              "stopId": "judu:stop:6651",
              "position": {
                "x": -3256.485,
                "z": -2613.86
              },
              "distanceAlongShapeM": 10363.995,
              "shapeOffsetM": 5.412,
              "arrivalOffsetSeconds": 2280,
              "departureOffsetSeconds": 2280
            },
            {
              "stopId": "judu:stop:5067",
              "position": {
                "x": -3053.229,
                "z": -3115.03
              },
              "distanceAlongShapeM": 10906.45,
              "shapeOffsetM": 5.298,
              "arrivalOffsetSeconds": 2340,
              "departureOffsetSeconds": 2340
            },
            {
              "stopId": "judu:stop:6479",
              "position": {
                "x": -2968.741,
                "z": -3404.837
              },
              "distanceAlongShapeM": 11208.293,
              "shapeOffsetM": 5.004,
              "arrivalOffsetSeconds": 2400,
              "departureOffsetSeconds": 2400
            },
            {
              "stopId": "judu:stop:6481",
              "position": {
                "x": -2906.719,
                "z": -3835.629
              },
              "distanceAlongShapeM": 11643.122,
              "shapeOffsetM": 4.623,
              "arrivalOffsetSeconds": 2460,
              "departureOffsetSeconds": 2460
            },
            {
              "stopId": "judu:stop:6653",
              "position": {
                "x": -2914.524,
                "z": -4206.195
              },
              "distanceAlongShapeM": 12013.96,
              "shapeOffsetM": 5.531,
              "arrivalOffsetSeconds": 2580,
              "departureOffsetSeconds": 2580
            },
            {
              "stopId": "judu:stop:8275",
              "position": {
                "x": -2897.378,
                "z": -4403.536
              },
              "distanceAlongShapeM": 12375.538,
              "shapeOffsetM": 0.752,
              "arrivalOffsetSeconds": 2640,
              "departureOffsetSeconds": 2640
            }
          ],
          "departuresSeconds": [
            18840,
            20700,
            21840,
            22980,
            24180,
            25200,
            25800,
            26400,
            27060,
            27720,
            28320,
            28920,
            29640,
            30360,
            31200,
            32160,
            32760,
            33420,
            34260,
            35220,
            35820,
            36480,
            37080,
            38040,
            39300,
            40500,
            41760,
            43020,
            44100,
            45360,
            46560,
            47760,
            49020,
            50160,
            51540,
            52620,
            53820,
            54420,
            55080,
            55740,
            56460,
            57180,
            57840,
            58680,
            59340,
            60180,
            60720,
            61260,
            61740,
            62460,
            63180,
            64140,
            65220,
            66180,
            66780,
            67680,
            68760,
            70020,
            71400,
            72480,
            73740,
            74820,
            76140,
            77640,
            78780,
            79980,
            81060,
            82560,
            84000
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_trol_17",
      "sourceRouteId": "vilnius_trol_17",
      "mode": "trolleybus",
      "shortName": "17",
      "longName": "Žirmūnai–Naujininkai",
      "color": "DC3131",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_trol_17:0",
          "sourceRouteId": "vilnius_trol_17",
          "sourceShapeId": "vilnius_trol_17_a-b",
          "directionId": 0,
          "headsign": "Naujininkai",
          "directionName": "Žirmūnai–Naujininkai",
          "mode": "trolleybus",
          "routeShortName": "17",
          "routeLongName": "Žirmūnai–Naujininkai",
          "routeColor": "DC3131",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              1017.506,
              -4299.224,
              0
            ],
            [
              1021.564,
              -4286.64,
              13.222
            ],
            [
              1026.249,
              -4282.222,
              19.661
            ],
            [
              1105.831,
              -4274.26,
              99.641
            ],
            [
              1128.035,
              -4270.234,
              122.207
            ],
            [
              1147.356,
              -4270.545,
              141.53
            ],
            [
              1189.631,
              -4265.192,
              184.142
            ],
            [
              1202.517,
              -4249.3,
              204.602
            ],
            [
              1214.522,
              -4227.257,
              229.702
            ],
            [
              1220.978,
              -4191.753,
              265.789
            ],
            [
              1217.195,
              -3943.429,
              514.141
            ],
            [
              1219.986,
              -3862.213,
              595.405
            ],
            [
              1375.611,
              -3774.922,
              773.84
            ],
            [
              1393.375,
              -3755.212,
              800.374
            ],
            [
              1412.221,
              -3746.656,
              821.071
            ],
            [
              1509.877,
              -3564.24,
              1027.982
            ],
            [
              1556.885,
              -3486.613,
              1118.733
            ],
            [
              1610.18,
              -3392.177,
              1227.17
            ],
            [
              1620.009,
              -3384.254,
              1239.794
            ],
            [
              1689.847,
              -3267.548,
              1375.8
            ],
            [
              1697.306,
              -3247.648,
              1397.052
            ],
            [
              1696.944,
              -3128.524,
              1516.177
            ],
            [
              1692.78,
              -3098.159,
              1546.826
            ],
            [
              1693.427,
              -3075.022,
              1569.972
            ],
            [
              1690.731,
              -2873.474,
              1771.538
            ],
            [
              1684.353,
              -2661.838,
              1983.27
            ],
            [
              1680.485,
              -2590.427,
              2054.786
            ],
            [
              1679.547,
              -2554.739,
              2090.487
            ],
            [
              1678.725,
              -2527.718,
              2117.519
            ],
            [
              1679.06,
              -2495.866,
              2149.373
            ],
            [
              1670.601,
              -2049.296,
              2596.024
            ],
            [
              1665.105,
              -1963.474,
              2682.021
            ],
            [
              1665.702,
              -1896.69,
              2748.808
            ],
            [
              1663.09,
              -1759.712,
              2885.811
            ],
            [
              1657.26,
              -1724.669,
              2921.336
            ],
            [
              1660.464,
              -1692.869,
              2953.297
            ],
            [
              1642.718,
              -1572.308,
              3075.157
            ],
            [
              1626.598,
              -1502.988,
              3146.326
            ],
            [
              1590.763,
              -1384.318,
              3270.289
            ],
            [
              1541.473,
              -1260.946,
              3403.143
            ],
            [
              1439.941,
              -1068.699,
              3620.554
            ],
            [
              1422.22,
              -1045.077,
              3650.084
            ],
            [
              1413.029,
              -1024.784,
              3672.361
            ],
            [
              1382.574,
              -969.885,
              3735.142
            ],
            [
              1372.327,
              -959.462,
              3749.758
            ],
            [
              1333.941,
              -943.166,
              3791.46
            ],
            [
              1307.513,
              -942.677,
              3817.893
            ],
            [
              1293.291,
              -944.641,
              3832.25
            ],
            [
              1278.614,
              -942.95,
              3847.024
            ],
            [
              1269.114,
              -935.31,
              3859.215
            ],
            [
              1257.916,
              -924.645,
              3874.679
            ],
            [
              1249.597,
              -901.529,
              3899.246
            ],
            [
              1249.57,
              -868.132,
              3932.643
            ],
            [
              1251.975,
              -858.297,
              3942.768
            ],
            [
              1256.345,
              -850.445,
              3951.754
            ],
            [
              1271.438,
              -836.252,
              3972.472
            ],
            [
              1287.032,
              -829.861,
              3989.325
            ],
            [
              1306.39,
              -829.106,
              4008.698
            ],
            [
              1381.451,
              -814.909,
              4085.089
            ],
            [
              1598.931,
              -666.427,
              4348.423
            ],
            [
              1632.324,
              -639.216,
              4391.499
            ],
            [
              1644.195,
              -624.964,
              4410.047
            ],
            [
              1649.997,
              -609.491,
              4426.572
            ],
            [
              1647.435,
              -589.4,
              4446.826
            ],
            [
              1641.361,
              -569.249,
              4467.872
            ],
            [
              1626.241,
              -550.043,
              4492.316
            ],
            [
              1613.941,
              -537.088,
              4510.18
            ],
            [
              1227.773,
              -233.181,
              5001.591
            ],
            [
              1061.875,
              -125.757,
              5199.233
            ],
            [
              1042.305,
              -113.981,
              5222.072
            ],
            [
              992.552,
              -84.12,
              5280.099
            ],
            [
              920.398,
              -44.941,
              5362.203
            ],
            [
              797.689,
              -19.306,
              5487.561
            ],
            [
              670.384,
              1.958,
              5616.63
            ],
            [
              652.936,
              0.051,
              5634.182
            ],
            [
              630.873,
              -7.336,
              5657.449
            ],
            [
              602.561,
              -27.877,
              5692.428
            ],
            [
              564.962,
              -49.544,
              5735.823
            ],
            [
              476.44,
              -129.188,
              5854.9
            ],
            [
              402.286,
              -199.078,
              5956.799
            ],
            [
              346.776,
              -237.026,
              6024.04
            ],
            [
              281.176,
              -262.545,
              6094.429
            ],
            [
              119.684,
              -277.409,
              6256.604
            ],
            [
              35.151,
              -280.322,
              6341.187
            ],
            [
              -101.904,
              -298.979,
              6479.506
            ],
            [
              -140.054,
              -304.394,
              6518.038
            ],
            [
              -153.37,
              -311.158,
              6532.973
            ],
            [
              -191.836,
              -315.156,
              6571.646
            ],
            [
              -244.276,
              -326.45,
              6625.289
            ],
            [
              -305.298,
              -348.72,
              6690.248
            ],
            [
              -413.017,
              -421.354,
              6820.167
            ],
            [
              -450.326,
              -380.602,
              6875.418
            ],
            [
              -465.596,
              -369.193,
              6894.48
            ],
            [
              -470.512,
              -355.745,
              6908.798
            ],
            [
              -508.466,
              -314.982,
              6964.495
            ],
            [
              -611.52,
              -58.189,
              7241.195
            ],
            [
              -614.075,
              -53.155,
              7246.84
            ],
            [
              -625.745,
              -24.535,
              7277.748
            ],
            [
              -643.846,
              18.014,
              7323.987
            ],
            [
              -652.524,
              63.893,
              7370.679
            ],
            [
              -679.973,
              222.467,
              7531.612
            ],
            [
              -691.721,
              250.51,
              7562.016
            ],
            [
              -832.714,
              443.415,
              7800.954
            ],
            [
              -840.816,
              459.146,
              7818.649
            ],
            [
              -843.214,
              469.208,
              7828.993
            ],
            [
              -842.813,
              491.465,
              7851.253
            ],
            [
              -833.842,
              667.193,
              8027.21
            ],
            [
              -824.076,
              731.394,
              8092.15
            ],
            [
              -800.789,
              819.11,
              8182.904
            ],
            [
              -787.05,
              855.14,
              8221.465
            ],
            [
              -767.948,
              887.538,
              8259.075
            ],
            [
              -708.773,
              1021.171,
              8405.224
            ],
            [
              -697.048,
              1063.262,
              8448.917
            ],
            [
              -655.787,
              1240.633,
              8631.024
            ],
            [
              -653.864,
              1286.859,
              8677.29
            ],
            [
              -631.67,
              1361.539,
              8755.198
            ],
            [
              -535.95,
              1804.839,
              9208.715
            ],
            [
              -507.688,
              1932.818,
              9339.777
            ],
            [
              -496.901,
              1964.699,
              9373.434
            ],
            [
              -462.075,
              2106.562,
              9519.509
            ],
            [
              -436.719,
              2188.482,
              9605.263
            ],
            [
              -427.991,
              2207.248,
              9625.96
            ],
            [
              -344.32,
              2338.207,
              9781.366
            ],
            [
              -326.137,
              2380.181,
              9827.109
            ],
            [
              -285.296,
              2533.066,
              9985.355
            ],
            [
              -285.194,
              2584.883,
              10037.172
            ],
            [
              -278.461,
              2625.339,
              10078.185
            ],
            [
              -246.605,
              2887.483,
              10342.257
            ],
            [
              -240.554,
              2897.49,
              10353.952
            ],
            [
              -220.477,
              2901.557,
              10374.436
            ],
            [
              -210.989,
              2900.387,
              10383.996
            ],
            [
              -205.005,
              2887.499,
              10398.205
            ],
            [
              -199.456,
              2858.125,
              10428.099
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:5508",
              "position": {
                "x": 1128.033,
                "z": -4270.188
              },
              "distanceAlongShapeM": 122.207,
              "shapeOffsetM": 0.046,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:5149",
              "position": {
                "x": 1393.375,
                "z": -3755.212
              },
              "distanceAlongShapeM": 800.374,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:5086",
              "position": {
                "x": 1607.644,
                "z": -3390.704
              },
              "distanceAlongShapeM": 1227.17,
              "shapeOffsetM": 2.933,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:5087",
              "position": {
                "x": 1687.839,
                "z": -3098.296
              },
              "distanceAlongShapeM": 1546.826,
              "shapeOffsetM": 4.943,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:5088",
              "position": {
                "x": 1670.083,
                "z": -2527.983
              },
              "distanceAlongShapeM": 2117.518,
              "shapeOffsetM": 8.646,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:5658",
              "position": {
                "x": 1653.419,
                "z": -1725.022
              },
              "distanceAlongShapeM": 2921.336,
              "shapeOffsetM": 3.857,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:5661",
              "position": {
                "x": 1418.417,
                "z": -1047.149
              },
              "distanceAlongShapeM": 3650.084,
              "shapeOffsetM": 4.331,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:5768",
              "position": {
                "x": 1608.96,
                "z": -543.043
              },
              "distanceAlongShapeM": 4509.291,
              "shapeOffsetM": 7.713,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:5771",
              "position": {
                "x": 1060.09,
                "z": -128.781
              },
              "distanceAlongShapeM": 5199.087,
              "shapeOffsetM": 3.508,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:848",
              "position": {
                "x": 604.636,
                "z": -31.346
              },
              "distanceAlongShapeM": 5692.428,
              "shapeOffsetM": 4.042,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:5249",
              "position": {
                "x": -153.095,
                "z": -312.52
              },
              "distanceAlongShapeM": 6532.973,
              "shapeOffsetM": 1.39,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            },
            {
              "stopId": "judu:stop:5257",
              "position": {
                "x": -465.596,
                "z": -369.193
              },
              "distanceAlongShapeM": 6894.48,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1560,
              "departureOffsetSeconds": 1560
            },
            {
              "stopId": "judu:stop:5264",
              "position": {
                "x": -646.921,
                "z": 17.037
              },
              "distanceAlongShapeM": 7323.987,
              "shapeOffsetM": 3.227,
              "arrivalOffsetSeconds": 1680,
              "departureOffsetSeconds": 1680
            },
            {
              "stopId": "judu:stop:5266",
              "position": {
                "x": -793.638,
                "z": 857.944
              },
              "distanceAlongShapeM": 8221.465,
              "shapeOffsetM": 7.159,
              "arrivalOffsetSeconds": 1980,
              "departureOffsetSeconds": 1980
            },
            {
              "stopId": "judu:stop:5272",
              "position": {
                "x": -656.233,
                "z": 1287.397
              },
              "distanceAlongShapeM": 8677.29,
              "shapeOffsetM": 2.429,
              "arrivalOffsetSeconds": 2100,
              "departureOffsetSeconds": 2100
            },
            {
              "stopId": "judu:stop:7851",
              "position": {
                "x": -511.654,
                "z": 1933.795
              },
              "distanceAlongShapeM": 9339.777,
              "shapeOffsetM": 4.085,
              "arrivalOffsetSeconds": 2280,
              "departureOffsetSeconds": 2280
            },
            {
              "stopId": "judu:stop:5173",
              "position": {
                "x": -290.153,
                "z": 2585.475
              },
              "distanceAlongShapeM": 10037.172,
              "shapeOffsetM": 4.994,
              "arrivalOffsetSeconds": 2460,
              "departureOffsetSeconds": 2460
            },
            {
              "stopId": "judu:stop:5200",
              "position": {
                "x": -196.145,
                "z": 2858.737
              },
              "distanceAlongShapeM": 10428.099,
              "shapeOffsetM": 3.367,
              "arrivalOffsetSeconds": 2520,
              "departureOffsetSeconds": 2520
            }
          ],
          "departuresSeconds": [
            18120,
            18960,
            19620,
            20400,
            21240,
            22080,
            22800,
            23400,
            24120,
            24600,
            25200,
            25860,
            26460,
            27240,
            28080,
            29220,
            30360,
            31560,
            32400,
            33240,
            34020,
            34920,
            35700,
            36480,
            37320,
            38220,
            39120,
            39900,
            40740,
            41520,
            42360,
            43200,
            44100,
            44940,
            45780,
            46560,
            47400,
            48240,
            49080,
            49980,
            50940,
            51840,
            52560,
            53460,
            54360,
            55320,
            56100,
            56640,
            57180,
            57720,
            58380,
            59040,
            59880,
            60900,
            61980,
            62820,
            63660,
            64680,
            65940,
            67260,
            68100,
            68940,
            69780,
            70680,
            71580,
            72420,
            73320,
            74100,
            74880,
            75600,
            76440,
            77280,
            78300,
            79500,
            80400,
            81420,
            82860
          ]
        },
        {
          "id": "judu:pattern:vilnius_trol_17:1",
          "sourceRouteId": "vilnius_trol_17",
          "sourceShapeId": "vilnius_trol_17_b-a",
          "directionId": 1,
          "headsign": "Žirmūnai",
          "directionName": "Naujininkai–Žirmūnai",
          "mode": "trolleybus",
          "routeShortName": "17",
          "routeLongName": "Žirmūnai–Naujininkai",
          "routeColor": "DC3131",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              -199.456,
              2858.125,
              0
            ],
            [
              -199.082,
              2844.922,
              13.208
            ],
            [
              -203.563,
              2834.855,
              24.227
            ],
            [
              -247.856,
              2818.486,
              71.449
            ],
            [
              -268.934,
              2604.253,
              286.716
            ],
            [
              -287.151,
              2501.929,
              390.649
            ],
            [
              -327.226,
              2355.709,
              542.261
            ],
            [
              -350.367,
              2324.958,
              580.747
            ],
            [
              -412.128,
              2228.113,
              695.609
            ],
            [
              -425.492,
              2202.75,
              724.278
            ],
            [
              -439.803,
              2160.707,
              768.689
            ],
            [
              -445.668,
              2121.85,
              807.987
            ],
            [
              -471.768,
              2034.377,
              899.27
            ],
            [
              -499.661,
              1919.106,
              1017.868
            ],
            [
              -512.556,
              1856.885,
              1081.411
            ],
            [
              -515.909,
              1841.571,
              1097.088
            ],
            [
              -530.605,
              1766.267,
              1173.813
            ],
            [
              -536.862,
              1752.795,
              1188.667
            ],
            [
              -542.324,
              1736.195,
              1206.142
            ],
            [
              -601.244,
              1474.539,
              1474.35
            ],
            [
              -678.532,
              1124.155,
              1833.157
            ],
            [
              -683.338,
              1093.819,
              1863.872
            ],
            [
              -691.829,
              1066.507,
              1892.473
            ],
            [
              -722.413,
              980.227,
              1984.013
            ],
            [
              -789.726,
              824.476,
              2153.687
            ],
            [
              -808.22,
              764.696,
              2216.263
            ],
            [
              -816.493,
              725.027,
              2256.785
            ],
            [
              -824.878,
              699.315,
              2283.83
            ],
            [
              -838.2,
              496.948,
              2486.635
            ],
            [
              -838.156,
              463.551,
              2520.032
            ],
            [
              -823.183,
              435.45,
              2551.873
            ],
            [
              -689.434,
              255.78,
              2775.86
            ],
            [
              -671.067,
              215.627,
              2820.014
            ],
            [
              -634.631,
              19.041,
              3019.949
            ],
            [
              -585.127,
              -96.516,
              3145.663
            ],
            [
              -572.146,
              -122.078,
              3174.332
            ],
            [
              -567.275,
              -143.594,
              3196.392
            ],
            [
              -513.161,
              -289.293,
              3351.816
            ],
            [
              -501.093,
              -299.53,
              3367.641
            ],
            [
              -461.426,
              -352.57,
              3433.873
            ],
            [
              -452.174,
              -363.943,
              3448.535
            ],
            [
              -413.017,
              -421.354,
              3518.028
            ],
            [
              -305.298,
              -348.72,
              3647.947
            ],
            [
              -203.339,
              -309.381,
              3757.232
            ],
            [
              -102.285,
              -284.5,
              3861.304
            ],
            [
              -49.535,
              -271.256,
              3915.692
            ],
            [
              -22.626,
              -265.911,
              3943.126
            ],
            [
              -0.545,
              -257.407,
              3966.788
            ],
            [
              58.367,
              -209.498,
              4042.721
            ],
            [
              82.464,
              -196.578,
              4070.063
            ],
            [
              94.753,
              -194.576,
              4082.514
            ],
            [
              102.687,
              -199.192,
              4091.693
            ],
            [
              115.784,
              -208.318,
              4107.656
            ],
            [
              119.974,
              -268.346,
              4167.831
            ],
            [
              241.125,
              -266.267,
              4288.999
            ],
            [
              291.552,
              -259.395,
              4339.892
            ],
            [
              357.234,
              -229.425,
              4412.089
            ],
            [
              436.36,
              -169.644,
              4511.259
            ],
            [
              541.549,
              -60.247,
              4663.023
            ],
            [
              557.019,
              -44.104,
              4685.381
            ],
            [
              589.799,
              -22.869,
              4724.439
            ],
            [
              630.571,
              1.522,
              4771.95
            ],
            [
              645.363,
              9.096,
              4788.568
            ],
            [
              675.04,
              9.665,
              4818.25
            ],
            [
              707.88,
              6.836,
              4851.212
            ],
            [
              925.597,
              -42.81,
              5074.518
            ],
            [
              1129.224,
              -156.774,
              5307.867
            ],
            [
              1141.634,
              -163.763,
              5322.11
            ],
            [
              1606.423,
              -519.681,
              5907.521
            ],
            [
              1614.903,
              -526.354,
              5918.312
            ],
            [
              1648.803,
              -550.462,
              5959.91
            ],
            [
              1662.944,
              -552.951,
              5974.268
            ],
            [
              1683.01,
              -548.871,
              5994.745
            ],
            [
              1705.327,
              -547.896,
              6017.083
            ],
            [
              1715.935,
              -555.388,
              6030.07
            ],
            [
              1719.444,
              -566.247,
              6041.482
            ],
            [
              1721.402,
              -599.681,
              6074.973
            ],
            [
              1718.066,
              -610.324,
              6086.127
            ],
            [
              1706.711,
              -619.261,
              6100.577
            ],
            [
              1700.984,
              -622.679,
              6107.246
            ],
            [
              1684.224,
              -622.368,
              6124.009
            ],
            [
              1662.848,
              -627.537,
              6146.001
            ],
            [
              1583.13,
              -683.945,
              6243.658
            ],
            [
              1381.451,
              -814.909,
              6484.128
            ],
            [
              1363.471,
              -845.747,
              6519.825
            ],
            [
              1362.208,
              -879.121,
              6553.223
            ],
            [
              1367.85,
              -922.642,
              6597.108
            ],
            [
              1384.491,
              -964.14,
              6641.818
            ],
            [
              1464.439,
              -1103.664,
              6802.625
            ],
            [
              1477.634,
              -1123.116,
              6826.129
            ],
            [
              1488.813,
              -1145.306,
              6850.977
            ],
            [
              1537.374,
              -1238.606,
              6956.158
            ],
            [
              1587.871,
              -1366.453,
              7093.616
            ],
            [
              1626.598,
              -1502.988,
              7235.537
            ],
            [
              1647.564,
              -1589.097,
              7324.162
            ],
            [
              1670.179,
              -1759.844,
              7496.4
            ],
            [
              1672.682,
              -1787.97,
              7524.637
            ],
            [
              1672.408,
              -1813.321,
              7549.99
            ],
            [
              1676.981,
              -1962.613,
              7699.351
            ],
            [
              1684.587,
              -2475.93,
              8212.725
            ],
            [
              1691.063,
              -2612.98,
              8349.928
            ],
            [
              1692.552,
              -2638.806,
              8375.797
            ],
            [
              1690.652,
              -2669.748,
              8406.797
            ],
            [
              1690.731,
              -2873.474,
              8610.523
            ],
            [
              1700.851,
              -3126.37,
              8863.621
            ],
            [
              1707.344,
              -3177.803,
              8915.462
            ],
            [
              1701.896,
              -3208.77,
              8946.905
            ],
            [
              1697.306,
              -3247.648,
              8986.053
            ],
            [
              1679.831,
              -3286.287,
              9028.46
            ],
            [
              1593.247,
              -3437.193,
              9202.441
            ],
            [
              1579.69,
              -3472.235,
              9240.014
            ],
            [
              1566.424,
              -3493.47,
              9265.052
            ],
            [
              1508.519,
              -3591.87,
              9379.226
            ],
            [
              1412.221,
              -3746.656,
              9561.522
            ],
            [
              1401.002,
              -3760.92,
              9579.67
            ],
            [
              1342.534,
              -3804.924,
              9652.847
            ],
            [
              1325.974,
              -3810.739,
              9670.398
            ],
            [
              1219.986,
              -3862.213,
              9788.224
            ],
            [
              1220.734,
              -4100.462,
              10026.474
            ],
            [
              1222.498,
              -4142.938,
              10068.987
            ],
            [
              1222.034,
              -4169.508,
              10095.561
            ],
            [
              1222.197,
              -4191.784,
              10117.837
            ],
            [
              1218.667,
              -4222.547,
              10148.802
            ],
            [
              1209.216,
              -4242.448,
              10170.834
            ],
            [
              1199.734,
              -4253.999,
              10185.778
            ],
            [
              1180.34,
              -4272.796,
              10212.786
            ],
            [
              1169.776,
              -4277.639,
              10224.408
            ],
            [
              1151.036,
              -4280.633,
              10243.385
            ],
            [
              1136.231,
              -4280.418,
              10258.192
            ],
            [
              1097.302,
              -4298.664,
              10301.184
            ],
            [
              1060.432,
              -4334.455,
              10352.569
            ],
            [
              1050.84,
              -4334.625,
              10362.162
            ],
            [
              1024.373,
              -4320.974,
              10391.943
            ],
            [
              1020.017,
              -4312.849,
              10401.161
            ],
            [
              1017.506,
              -4299.224,
              10415.016
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:5200",
              "position": {
                "x": -196.145,
                "z": 2858.737
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 3.367,
              "arrivalOffsetSeconds": -420,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:6854",
              "position": {
                "x": -266.588,
                "z": 2603.973
              },
              "distanceAlongShapeM": 286.716,
              "shapeOffsetM": 2.363,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:5168",
              "position": {
                "x": -529.526,
                "z": 1766.021
              },
              "distanceAlongShapeM": 1173.813,
              "shapeOffsetM": 1.107,
              "arrivalOffsetSeconds": 270,
              "departureOffsetSeconds": 270
            },
            {
              "stopId": "judu:stop:6853",
              "position": {
                "x": -679.739,
                "z": 1093.006
              },
              "distanceAlongShapeM": 1863.872,
              "shapeOffsetM": 3.689,
              "arrivalOffsetSeconds": 390,
              "departureOffsetSeconds": 390
            },
            {
              "stopId": "judu:stop:5267",
              "position": {
                "x": -810.251,
                "z": 723.543
              },
              "distanceAlongShapeM": 2256.785,
              "shapeOffsetM": 6.416,
              "arrivalOffsetSeconds": 510,
              "departureOffsetSeconds": 510
            },
            {
              "stopId": "judu:stop:6736",
              "position": {
                "x": -570.097,
                "z": -121.279
              },
              "distanceAlongShapeM": 3174.332,
              "shapeOffsetM": 2.199,
              "arrivalOffsetSeconds": 690,
              "departureOffsetSeconds": 690
            },
            {
              "stopId": "judu:stop:5258",
              "position": {
                "x": -449.339,
                "z": -361.695
              },
              "distanceAlongShapeM": 3448.535,
              "shapeOffsetM": 3.618,
              "arrivalOffsetSeconds": 750,
              "departureOffsetSeconds": 750
            },
            {
              "stopId": "judu:stop:5248",
              "position": {
                "x": -50.388,
                "z": -267.632
              },
              "distanceAlongShapeM": 3915.692,
              "shapeOffsetM": 3.723,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:7278",
              "position": {
                "x": 707.88,
                "z": 6.836
              },
              "distanceAlongShapeM": 4851.212,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:6573",
              "position": {
                "x": 1143.99,
                "z": -160.386
              },
              "distanceAlongShapeM": 5322.11,
              "shapeOffsetM": 4.117,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:5770",
              "position": {
                "x": 1610.786,
                "z": -514.132
              },
              "distanceAlongShapeM": 5907.521,
              "shapeOffsetM": 7.059,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            },
            {
              "stopId": "judu:stop:6665",
              "position": {
                "x": 1480.223,
                "z": -1121.768
              },
              "distanceAlongShapeM": 6826.129,
              "shapeOffsetM": 2.918,
              "arrivalOffsetSeconds": 1500,
              "departureOffsetSeconds": 1500
            },
            {
              "stopId": "judu:stop:6666",
              "position": {
                "x": 1676.751,
                "z": -1787.797
              },
              "distanceAlongShapeM": 7524.637,
              "shapeOffsetM": 4.073,
              "arrivalOffsetSeconds": 1620,
              "departureOffsetSeconds": 1620
            },
            {
              "stopId": "judu:stop:5606",
              "position": {
                "x": 1696.386,
                "z": -2638.684
              },
              "distanceAlongShapeM": 8375.797,
              "shapeOffsetM": 3.836,
              "arrivalOffsetSeconds": 1860,
              "departureOffsetSeconds": 1860
            },
            {
              "stopId": "judu:stop:6667",
              "position": {
                "x": 1709.563,
                "z": -3177.741
              },
              "distanceAlongShapeM": 8915.462,
              "shapeOffsetM": 2.22,
              "arrivalOffsetSeconds": 1980,
              "departureOffsetSeconds": 1980
            },
            {
              "stopId": "judu:stop:6668",
              "position": {
                "x": 1582.257,
                "z": -3473.726
              },
              "distanceAlongShapeM": 9240.014,
              "shapeOffsetM": 2.969,
              "arrivalOffsetSeconds": 2040,
              "departureOffsetSeconds": 2040
            },
            {
              "stopId": "judu:stop:5154",
              "position": {
                "x": 1342.825,
                "z": -3805.485
              },
              "distanceAlongShapeM": 9652.847,
              "shapeOffsetM": 0.632,
              "arrivalOffsetSeconds": 2220,
              "departureOffsetSeconds": 2220
            },
            {
              "stopId": "judu:stop:6671",
              "position": {
                "x": 1228.325,
                "z": -4142.906
              },
              "distanceAlongShapeM": 10068.987,
              "shapeOffsetM": 5.827,
              "arrivalOffsetSeconds": 2280,
              "departureOffsetSeconds": 2280
            },
            {
              "stopId": "judu:stop:5505",
              "position": {
                "x": 1151.036,
                "z": -4280.633
              },
              "distanceAlongShapeM": 10243.385,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2340,
              "departureOffsetSeconds": 2340
            }
          ],
          "departuresSeconds": [
            20700,
            21660,
            22380,
            23340,
            24060,
            24960,
            25740,
            26340,
            27120,
            27780,
            28500,
            29100,
            29700,
            30480,
            31320,
            32460,
            33480,
            34500,
            35400,
            36240,
            37020,
            37800,
            38580,
            39360,
            40140,
            41100,
            42000,
            42780,
            43620,
            44400,
            45240,
            46140,
            47100,
            47880,
            48900,
            49500,
            50340,
            51240,
            52200,
            53100,
            53880,
            54780,
            55560,
            56400,
            57420,
            58500,
            59280,
            59880,
            60420,
            61140,
            61740,
            62520,
            63420,
            64320,
            65400,
            66300,
            67200,
            68220,
            69240,
            70260,
            71100,
            71880,
            72720,
            73560,
            74400,
            75240,
            76080,
            76860,
            77640,
            78480,
            79440,
            80400,
            81240,
            82200,
            83040,
            84000
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_trol_18",
      "sourceRouteId": "vilnius_trol_18",
      "mode": "trolleybus",
      "shortName": "18",
      "longName": "Perkūnkiemis–Justiniškės–Žemieji Paneriai–Titnago g.",
      "color": "DC3131",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_trol_18:0",
          "sourceRouteId": "vilnius_trol_18",
          "sourceShapeId": "vilnius_trol_18_a-b",
          "directionId": 0,
          "headsign": "Titnago g.",
          "directionName": "Perkūnkiemis–Justiniškės–Žemieji Paneriai–Titnago g.",
          "mode": "trolleybus",
          "routeShortName": "18",
          "routeLongName": "Perkūnkiemis–Justiniškės–Žemieji Paneriai–Titnago g.",
          "routeColor": "DC3131",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              -3921.595,
              -5098.093,
              0
            ],
            [
              -3918.942,
              -5093.687,
              5.143
            ],
            [
              -3911.137,
              -5089.369,
              14.063
            ],
            [
              -3868.616,
              -5091.681,
              56.646
            ],
            [
              -3868.597,
              -5091.579,
              56.751
            ],
            [
              -3866.626,
              -5087.439,
              61.336
            ],
            [
              -3858.762,
              -5078.034,
              73.595
            ],
            [
              -3853.286,
              -5069.798,
              83.486
            ],
            [
              -3845.592,
              -5061.565,
              94.754
            ],
            [
              -3838.726,
              -5037.193,
              120.075
            ],
            [
              -3828.914,
              -4880.4,
              277.175
            ],
            [
              -3839.647,
              -4756.647,
              401.392
            ],
            [
              -3856.989,
              -4679.534,
              480.431
            ],
            [
              -3893.073,
              -4568.698,
              596.993
            ],
            [
              -3919.183,
              -4476.961,
              692.373
            ],
            [
              -3925.083,
              -4445.689,
              724.197
            ],
            [
              -3932.868,
              -4417.028,
              753.896
            ],
            [
              -3934.344,
              -4385.414,
              785.545
            ],
            [
              -3933.945,
              -4325.308,
              845.652
            ],
            [
              -3923.556,
              -4246.45,
              925.192
            ],
            [
              -3859.131,
              -4078.116,
              1105.433
            ],
            [
              -3844.834,
              -4049.433,
              1137.481
            ],
            [
              -3724.705,
              -3815.753,
              1400.231
            ],
            [
              -3680.975,
              -3716.371,
              1508.809
            ],
            [
              -3652.775,
              -3644.457,
              1586.054
            ],
            [
              -3636.19,
              -3580.18,
              1652.437
            ],
            [
              -3630.111,
              -3520.538,
              1712.387
            ],
            [
              -3624.82,
              -3482.415,
              1750.876
            ],
            [
              -3626.214,
              -3414.484,
              1818.821
            ],
            [
              -3629.537,
              -3383.256,
              1850.226
            ],
            [
              -3641.883,
              -3315.135,
              1919.456
            ],
            [
              -3659.519,
              -3254.715,
              1982.398
            ],
            [
              -3681.569,
              -3188.651,
              2052.044
            ],
            [
              -3706.235,
              -3124.768,
              2120.524
            ],
            [
              -3736.941,
              -3062.562,
              2189.895
            ],
            [
              -3744.824,
              -3043.144,
              2210.853
            ],
            [
              -3749.61,
              -3024.938,
              2229.677
            ],
            [
              -3794.804,
              -2918.397,
              2345.408
            ],
            [
              -3982.054,
              -2455.389,
              2844.846
            ],
            [
              -3998.785,
              -2421.194,
              2882.915
            ],
            [
              -4007.392,
              -2392.61,
              2912.767
            ],
            [
              -4034.259,
              -2306.427,
              3003.04
            ],
            [
              -4048.116,
              -2250.527,
              3060.632
            ],
            [
              -4058.635,
              -2188.005,
              3124.033
            ],
            [
              -4065.192,
              -2119.986,
              3192.367
            ],
            [
              -4071.681,
              -2010.779,
              3301.767
            ],
            [
              -4063.29,
              -1898.49,
              3414.369
            ],
            [
              -4045.411,
              -1837.599,
              3477.83
            ],
            [
              -4006.94,
              -1771.447,
              3554.356
            ],
            [
              -3981.93,
              -1741.824,
              3593.125
            ],
            [
              -3941.981,
              -1705.781,
              3646.93
            ],
            [
              -3883.226,
              -1663.385,
              3719.384
            ],
            [
              -3846.573,
              -1643.357,
              3761.152
            ],
            [
              -3813.541,
              -1631.763,
              3796.16
            ],
            [
              -3808.468,
              -1630.446,
              3801.401
            ],
            [
              -3761.37,
              -1625.426,
              3848.766
            ],
            [
              -3487.628,
              -1602.363,
              4123.477
            ],
            [
              -3508.003,
              -1550.799,
              4178.921
            ],
            [
              -3521.109,
              -1520.135,
              4212.268
            ],
            [
              -3534.455,
              -1477.979,
              4256.487
            ],
            [
              -3620.717,
              -1211.532,
              4536.549
            ],
            [
              -3662.686,
              -1103.933,
              4652.044
            ],
            [
              -3677.364,
              -1066.903,
              4691.877
            ],
            [
              -3685.368,
              -1042.059,
              4717.978
            ],
            [
              -3720.918,
              -930.373,
              4835.185
            ],
            [
              -3751.424,
              -837.404,
              4933.032
            ],
            [
              -3758.325,
              -817.25,
              4954.334
            ],
            [
              -3766.218,
              -791.548,
              4981.221
            ],
            [
              -3793.988,
              -719.82,
              5058.137
            ],
            [
              -3843.779,
              -616.54,
              5172.793
            ],
            [
              -3881.258,
              -546.871,
              5251.903
            ],
            [
              -3968.352,
              -399.129,
              5423.405
            ],
            [
              -3983.006,
              -376.666,
              5450.225
            ],
            [
              -3999.719,
              -350.005,
              5481.692
            ],
            [
              -4048.201,
              -282.373,
              5564.906
            ],
            [
              -4133.499,
              -180.709,
              5697.614
            ],
            [
              -4196.231,
              -117.271,
              5786.83
            ],
            [
              -4217.103,
              -95.271,
              5817.156
            ],
            [
              -4243.751,
              -67.483,
              5855.657
            ],
            [
              -4402.336,
              85.535,
              6076.029
            ],
            [
              -4449.086,
              142,
              6149.335
            ],
            [
              -4479.797,
              193.736,
              6209.5
            ],
            [
              -4502.905,
              237.549,
              6259.033
            ],
            [
              -4519.036,
              274.562,
              6299.409
            ],
            [
              -4536.228,
              324.952,
              6352.651
            ],
            [
              -4547.048,
              370.78,
              6399.739
            ],
            [
              -4566.578,
              510.266,
              6540.585
            ],
            [
              -4570.606,
              537.669,
              6568.283
            ],
            [
              -4575.517,
              590.57,
              6621.411
            ],
            [
              -4579.623,
              651.866,
              6682.844
            ],
            [
              -4586.366,
              709.869,
              6741.238
            ],
            [
              -4584.541,
              741.007,
              6772.43
            ],
            [
              -4573.306,
              794.248,
              6826.843
            ],
            [
              -4555.909,
              830.684,
              6867.219
            ],
            [
              -4538.646,
              859.331,
              6900.666
            ],
            [
              -4503.175,
              896.569,
              6952.094
            ],
            [
              -4462.091,
              922.579,
              7000.719
            ],
            [
              -4443.54,
              937.916,
              7024.789
            ],
            [
              -4396.195,
              965.972,
              7079.823
            ],
            [
              -4188.107,
              1100.42,
              7327.566
            ],
            [
              -4152.942,
              1128.063,
              7372.296
            ],
            [
              -4048.114,
              1175.924,
              7487.533
            ],
            [
              -3997.487,
              1193.972,
              7541.28
            ],
            [
              -3829.673,
              1236.704,
              7714.45
            ],
            [
              -3789.4,
              1252.704,
              7757.785
            ],
            [
              -3749.695,
              1273.165,
              7802.452
            ],
            [
              -3705.908,
              1305.8,
              7857.062
            ],
            [
              -3669.839,
              1339.683,
              7906.55
            ],
            [
              -3634.26,
              1382.479,
              7962.204
            ],
            [
              -3619.001,
              1406.704,
              7990.834
            ],
            [
              -3601.633,
              1440.911,
              8029.198
            ],
            [
              -3592.427,
              1468.215,
              8058.012
            ],
            [
              -3579.402,
              1495.072,
              8087.861
            ],
            [
              -3566.606,
              1526.019,
              8121.349
            ],
            [
              -3560.672,
              1570.444,
              8166.168
            ],
            [
              -3561.909,
              1610.54,
              8206.284
            ],
            [
              -3553.124,
              1670.501,
              8266.885
            ],
            [
              -3546.511,
              1753.876,
              8350.522
            ],
            [
              -3528.502,
              1849.211,
              8447.543
            ],
            [
              -3507.519,
              1881.216,
              8485.813
            ],
            [
              -3466.64,
              1929.443,
              8549.034
            ],
            [
              -3411.117,
              1970.818,
              8618.278
            ],
            [
              -3378.421,
              1984.588,
              8653.755
            ],
            [
              -3293.772,
              2003.28,
              8740.443
            ],
            [
              -3253.06,
              2007.021,
              8781.327
            ],
            [
              -3234.374,
              2005.581,
              8800.068
            ],
            [
              -3211.057,
              2010.74,
              8823.949
            ],
            [
              -2960.432,
              2100.974,
              9090.323
            ],
            [
              -2902.519,
              2128.901,
              9154.618
            ],
            [
              -2763.528,
              2181.007,
              9303.055
            ],
            [
              -2704.044,
              2203.421,
              9366.622
            ],
            [
              -2694.973,
              2206.697,
              9376.267
            ],
            [
              -2620.644,
              2234.153,
              9455.504
            ],
            [
              -2602.113,
              2260.544,
              9487.751
            ],
            [
              -2577.558,
              2305.756,
              9539.201
            ],
            [
              -2591.532,
              2385.037,
              9619.704
            ],
            [
              -2598.371,
              2436.365,
              9671.486
            ],
            [
              -2602.959,
              2542.201,
              9777.421
            ],
            [
              -2606.316,
              2602.394,
              9837.707
            ],
            [
              -2619.569,
              2661.607,
              9898.385
            ],
            [
              -2672.012,
              2798.342,
              10044.832
            ],
            [
              -2693.846,
              2841.028,
              10092.778
            ],
            [
              -2698.439,
              2873.392,
              10125.467
            ],
            [
              -2831.804,
              3253.114,
              10527.928
            ],
            [
              -2853.662,
              3294.686,
              10574.896
            ],
            [
              -2869.962,
              3320.622,
              10605.529
            ],
            [
              -2887.849,
              3332.714,
              10627.12
            ],
            [
              -2904.222,
              3355.687,
              10655.33
            ],
            [
              -3126.24,
              3576.651,
              10968.567
            ],
            [
              -3256.351,
              3702.491,
              11149.576
            ],
            [
              -3334.924,
              3786.24,
              11264.414
            ],
            [
              -3406.008,
              3855.385,
              11363.58
            ],
            [
              -3427.01,
              3872.449,
              11390.641
            ],
            [
              -3454.8,
              3907.442,
              11435.326
            ],
            [
              -3626.746,
              4078.528,
              11677.887
            ],
            [
              -3781.512,
              4235.95,
              11898.645
            ],
            [
              -3884.317,
              4337.92,
              12043.444
            ],
            [
              -3915.514,
              4362.95,
              12083.441
            ],
            [
              -3928.112,
              4380.98,
              12105.436
            ],
            [
              -4226.292,
              4683.356,
              12530.104
            ],
            [
              -4305.622,
              4762.647,
              12642.266
            ],
            [
              -4338.114,
              4787.696,
              12683.293
            ],
            [
              -4349.425,
              4805.702,
              12704.557
            ],
            [
              -4420.502,
              4877.057,
              12805.271
            ],
            [
              -4439.501,
              4898.534,
              12833.946
            ],
            [
              -4461.157,
              4915.604,
              12861.521
            ],
            [
              -4476.532,
              4922.548,
              12878.391
            ],
            [
              -4485.887,
              4927.855,
              12889.146
            ],
            [
              -4508.363,
              4948.698,
              12919.799
            ],
            [
              -4600.366,
              5004.825,
              13027.571
            ],
            [
              -4658.205,
              5020.288,
              13087.442
            ],
            [
              -4736.87,
              5026.089,
              13166.32
            ],
            [
              -4780.797,
              5023.521,
              13210.322
            ],
            [
              -4794.293,
              5028.186,
              13224.602
            ],
            [
              -4887.841,
              5032.012,
              13318.228
            ],
            [
              -5084.124,
              5030.911,
              13514.514
            ],
            [
              -5215.445,
              4939.641,
              13674.437
            ],
            [
              -5292.681,
              4884.129,
              13769.553
            ],
            [
              -5256.598,
              4911.398,
              13814.782
            ],
            [
              -5543.457,
              4708.104,
              14166.373
            ],
            [
              -5565.132,
              4686.208,
              14197.183
            ],
            [
              -5575.47,
              4670.817,
              14215.724
            ],
            [
              -5896.258,
              4344.494,
              14673.317
            ],
            [
              -5929.163,
              4307.201,
              14723.051
            ],
            [
              -5946.833,
              4308.097,
              14740.744
            ],
            [
              -5951.924,
              4313.34,
              14748.052
            ],
            [
              -5952.758,
              4324.297,
              14759.041
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:7603",
              "position": {
                "x": -3854.099,
                "z": -5069.209
              },
              "distanceAlongShapeM": 83.486,
              "shapeOffsetM": 1.003,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:687",
              "position": {
                "x": -3938.125,
                "z": -4417.632
              },
              "distanceAlongShapeM": 753.896,
              "shapeOffsetM": 5.291,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:949",
              "position": {
                "x": -3863.253,
                "z": -4076.062
              },
              "distanceAlongShapeM": 1105.433,
              "shapeOffsetM": 4.605,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:542",
              "position": {
                "x": -3683.061,
                "z": -3718.515
              },
              "distanceAlongShapeM": 1506.006,
              "shapeOffsetM": 1.046,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:5060",
              "position": {
                "x": -3633.854,
                "z": -3520.107
              },
              "distanceAlongShapeM": 1712.387,
              "shapeOffsetM": 3.767,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:6580",
              "position": {
                "x": -3740.623,
                "z": -3064.057
              },
              "distanceAlongShapeM": 2189.895,
              "shapeOffsetM": 3.974,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:6581",
              "position": {
                "x": -4002.758,
                "z": -2422.747
              },
              "distanceAlongShapeM": 2882.915,
              "shapeOffsetM": 4.266,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:6588",
              "position": {
                "x": -4045.475,
                "z": -1837.572
              },
              "distanceAlongShapeM": 3477.83,
              "shapeOffsetM": 0.069,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:6591",
              "position": {
                "x": -3809.119,
                "z": -1627.936
              },
              "distanceAlongShapeM": 3801.401,
              "shapeOffsetM": 2.593,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:928",
              "position": {
                "x": -3525.544,
                "z": -1521.55
              },
              "distanceAlongShapeM": 4212.268,
              "shapeOffsetM": 4.655,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:5643",
              "position": {
                "x": -3680.758,
                "z": -1067.996
              },
              "distanceAlongShapeM": 4691.877,
              "shapeOffsetM": 3.566,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            },
            {
              "stopId": "judu:stop:5646",
              "position": {
                "x": -3761.526,
                "z": -818.346
              },
              "distanceAlongShapeM": 4954.334,
              "shapeOffsetM": 3.383,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:5651",
              "position": {
                "x": -3986.683,
                "z": -379.175
              },
              "distanceAlongShapeM": 5450.133,
              "shapeOffsetM": 4.451,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:5656",
              "position": {
                "x": -4221.08,
                "z": -99.045
              },
              "distanceAlongShapeM": 5817.185,
              "shapeOffsetM": 5.483,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:5668",
              "position": {
                "x": -4574.501,
                "z": 537.119
              },
              "distanceAlongShapeM": 6568.283,
              "shapeOffsetM": 3.934,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:6460",
              "position": {
                "x": -4445.644,
                "z": 941.22
              },
              "distanceAlongShapeM": 7024.789,
              "shapeOffsetM": 3.917,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            },
            {
              "stopId": "judu:stop:6461",
              "position": {
                "x": -4154.055,
                "z": 1129.888
              },
              "distanceAlongShapeM": 7372.296,
              "shapeOffsetM": 2.137,
              "arrivalOffsetSeconds": 1380,
              "departureOffsetSeconds": 1380
            },
            {
              "stopId": "judu:stop:6333",
              "position": {
                "x": -3596.615,
                "z": 1469.767
              },
              "distanceAlongShapeM": 8058.012,
              "shapeOffsetM": 4.467,
              "arrivalOffsetSeconds": 1500,
              "departureOffsetSeconds": 1500
            },
            {
              "stopId": "judu:stop:721",
              "position": {
                "x": -3293.772,
                "z": 2003.28
              },
              "distanceAlongShapeM": 8740.443,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1620,
              "departureOffsetSeconds": 1620
            },
            {
              "stopId": "judu:stop:6337",
              "position": {
                "x": -2705.632,
                "z": 2207.819
              },
              "distanceAlongShapeM": 9366.622,
              "shapeOffsetM": 4.675,
              "arrivalOffsetSeconds": 1680,
              "departureOffsetSeconds": 1680
            },
            {
              "stopId": "judu:stop:5543",
              "position": {
                "x": -2693.846,
                "z": 2841.028
              },
              "distanceAlongShapeM": 10092.778,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1800,
              "departureOffsetSeconds": 1800
            },
            {
              "stopId": "judu:stop:5573",
              "position": {
                "x": -2888.502,
                "z": 3332.034
              },
              "distanceAlongShapeM": 10627.12,
              "shapeOffsetM": 0.943,
              "arrivalOffsetSeconds": 1920,
              "departureOffsetSeconds": 1920
            },
            {
              "stopId": "judu:stop:5587",
              "position": {
                "x": -3427.01,
                "z": 3872.449
              },
              "distanceAlongShapeM": 11390.641,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2040,
              "departureOffsetSeconds": 2040
            },
            {
              "stopId": "judu:stop:5588",
              "position": {
                "x": -3915.514,
                "z": 4362.95
              },
              "distanceAlongShapeM": 12083.441,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2100,
              "departureOffsetSeconds": 2100
            },
            {
              "stopId": "judu:stop:5554",
              "position": {
                "x": -4338.114,
                "z": 4787.696
              },
              "distanceAlongShapeM": 12683.293,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2220,
              "departureOffsetSeconds": 2220
            },
            {
              "stopId": "judu:stop:5567",
              "position": {
                "x": -4488.111,
                "z": 4924.973
              },
              "distanceAlongShapeM": 12889.146,
              "shapeOffsetM": 3.641,
              "arrivalOffsetSeconds": 2280,
              "departureOffsetSeconds": 2280
            },
            {
              "stopId": "judu:stop:5557",
              "position": {
                "x": -4780.873,
                "z": 5020.164
              },
              "distanceAlongShapeM": 13210.322,
              "shapeOffsetM": 3.358,
              "arrivalOffsetSeconds": 2340,
              "departureOffsetSeconds": 2340
            },
            {
              "stopId": "judu:stop:7553",
              "position": {
                "x": -5291.942,
                "z": 4883.057
              },
              "distanceAlongShapeM": 13769.553,
              "shapeOffsetM": 1.302,
              "arrivalOffsetSeconds": 2400,
              "departureOffsetSeconds": 2400
            },
            {
              "stopId": "judu:stop:5571",
              "position": {
                "x": -5573.178,
                "z": 4668.533
              },
              "distanceAlongShapeM": 14215.745,
              "shapeOffsetM": 3.236,
              "arrivalOffsetSeconds": 2460,
              "departureOffsetSeconds": 2460
            },
            {
              "stopId": "judu:stop:16788",
              "position": {
                "x": -5896.258,
                "z": 4344.494
              },
              "distanceAlongShapeM": 14673.317,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2520,
              "departureOffsetSeconds": 2520
            },
            {
              "stopId": "judu:stop:8374",
              "position": {
                "x": -5952.758,
                "z": 4324.297
              },
              "distanceAlongShapeM": 14759.041,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2520,
              "departureOffsetSeconds": 2520
            }
          ],
          "departuresSeconds": [
            17760,
            18600,
            19440,
            20220,
            21120,
            21720,
            22500,
            23100,
            23760,
            24360,
            24960,
            25680,
            26580,
            27600,
            28560,
            29760,
            30960,
            32160,
            33420,
            34560,
            35640,
            36780,
            38220,
            39420,
            40560,
            41760,
            42960,
            44220,
            45420,
            46560,
            47700,
            48900,
            49620,
            50460,
            51180,
            51720,
            52320,
            52920,
            53640,
            54480,
            55260,
            55980,
            56520,
            57000,
            57540,
            58080,
            58800,
            59460,
            60300,
            61260,
            62280,
            63780,
            65340,
            66960,
            68400,
            69960,
            71100,
            72240,
            73440,
            74760,
            76080,
            77400,
            78780,
            80580
          ]
        },
        {
          "id": "judu:pattern:vilnius_trol_18:1",
          "sourceRouteId": "vilnius_trol_18",
          "sourceShapeId": "vilnius_trol_18_b-a",
          "directionId": 1,
          "headsign": "Perkūnkiemis",
          "directionName": "Titnago g.–Žemieji Paneriai–Justiniškės–Perkūnkiemis",
          "mode": "trolleybus",
          "routeShortName": "18",
          "routeLongName": "Perkūnkiemis–Justiniškės–Žemieji Paneriai–Titnago g.",
          "routeColor": "DC3131",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              -5952.758,
              4324.297,
              0
            ],
            [
              -5927.145,
              4319.257,
              26.104
            ],
            [
              -5850.356,
              4408.94,
              144.17
            ],
            [
              -5542.812,
              4708.093,
              573.21
            ],
            [
              -5522.143,
              4730.228,
              603.495
            ],
            [
              -5495.647,
              4748.482,
              635.67
            ],
            [
              -5230.403,
              4933.216,
              958.906
            ],
            [
              -5256.503,
              4916.963,
              989.652
            ],
            [
              -5185.339,
              4963.618,
              1074.747
            ],
            [
              -5101.038,
              5023.407,
              1178.097
            ],
            [
              -5084.124,
              5030.911,
              1196.601
            ],
            [
              -4983.382,
              5032.532,
              1297.356
            ],
            [
              -4963.978,
              5034.293,
              1316.839
            ],
            [
              -4929.167,
              5031.606,
              1351.755
            ],
            [
              -4887.841,
              5032.012,
              1393.083
            ],
            [
              -4834.705,
              5081.197,
              1465.488
            ],
            [
              -4785.441,
              5130.448,
              1535.149
            ],
            [
              -4754.629,
              5157.75,
              1576.317
            ],
            [
              -4724.691,
              5171.709,
              1609.349
            ],
            [
              -4669.049,
              5178.483,
              1665.401
            ],
            [
              -4632.924,
              5176.815,
              1701.565
            ],
            [
              -4600.447,
              5171.052,
              1734.55
            ],
            [
              -4586.132,
              5157.088,
              1754.548
            ],
            [
              -4583.042,
              5111.394,
              1800.346
            ],
            [
              -4580.889,
              5011.17,
              1900.593
            ],
            [
              -4518.9,
              4977.81,
              1970.988
            ],
            [
              -4503.635,
              4960.862,
              1993.798
            ],
            [
              -4444.377,
              4915.316,
              2068.537
            ],
            [
              -4189.698,
              4671.592,
              2421.046
            ],
            [
              -4167.195,
              4657.338,
              2447.684
            ],
            [
              -4146.524,
              4629.659,
              2482.229
            ],
            [
              -4048.773,
              4533.349,
              2619.455
            ],
            [
              -3823.59,
              4303.471,
              2941.249
            ],
            [
              -3802.623,
              4284.184,
              2969.737
            ],
            [
              -3780.952,
              4268.223,
              2996.652
            ],
            [
              -3768.394,
              4247.967,
              3020.485
            ],
            [
              -3367.467,
              3844.694,
              3589.143
            ],
            [
              -3344.636,
              3829.677,
              3616.469
            ],
            [
              -3315.43,
              3793.692,
              3662.815
            ],
            [
              -3282.402,
              3763.059,
              3707.862
            ],
            [
              -3142.94,
              3618.132,
              3908.993
            ],
            [
              -2996.449,
              3469.738,
              4117.512
            ],
            [
              -2905.063,
              3381.305,
              4244.68
            ],
            [
              -2851.864,
              3323.598,
              4323.168
            ],
            [
              -2827.523,
              3276.416,
              4376.258
            ],
            [
              -2808.656,
              3248.254,
              4410.156
            ],
            [
              -2806.545,
              3221.5,
              4436.993
            ],
            [
              -2772.86,
              3118.493,
              4545.368
            ],
            [
              -2707,
              2936.995,
              4738.446
            ],
            [
              -2660.341,
              2801.476,
              4881.773
            ],
            [
              -2637.179,
              2724.257,
              4962.39
            ],
            [
              -2612.218,
              2675.949,
              5016.766
            ],
            [
              -2609.483,
              2648.071,
              5044.778
            ],
            [
              -2584.513,
              2574.315,
              5122.646
            ],
            [
              -2570.531,
              2514.913,
              5183.672
            ],
            [
              -2558.338,
              2437.886,
              5261.658
            ],
            [
              -2547.004,
              2385.365,
              5315.388
            ],
            [
              -2526.132,
              2324.884,
              5379.369
            ],
            [
              -2519.194,
              2315.856,
              5390.755
            ],
            [
              -2487.744,
              2306.396,
              5423.597
            ],
            [
              -2471.111,
              2298.31,
              5442.091
            ],
            [
              -2454.576,
              2284.659,
              5463.533
            ],
            [
              -2442.556,
              2271.088,
              5481.662
            ],
            [
              -2438.237,
              2259.88,
              5493.673
            ],
            [
              -2438.394,
              2250.977,
              5502.578
            ],
            [
              -2431.731,
              2226.369,
              5528.072
            ],
            [
              -2431.538,
              2200.762,
              5553.679
            ],
            [
              -2437.15,
              2175.257,
              5579.794
            ],
            [
              -2448.449,
              2156.532,
              5601.664
            ],
            [
              -2481.151,
              2131.505,
              5642.844
            ],
            [
              -2491.57,
              2126.123,
              5654.571
            ],
            [
              -2514.888,
              2120.968,
              5678.452
            ],
            [
              -2528.453,
              2120.094,
              5692.045
            ],
            [
              -2551.595,
              2124.955,
              5715.692
            ],
            [
              -2561.443,
              2130.364,
              5726.929
            ],
            [
              -2579.681,
              2142.148,
              5748.642
            ],
            [
              -2607.297,
              2186.05,
              5800.507
            ],
            [
              -2618.809,
              2191.819,
              5813.384
            ],
            [
              -2640.075,
              2193.306,
              5834.702
            ],
            [
              -2665.388,
              2184.846,
              5861.391
            ],
            [
              -2681.67,
              2176.227,
              5879.814
            ],
            [
              -2692.184,
              2172.41,
              5890.999
            ],
            [
              -2738.119,
              2158.296,
              5939.053
            ],
            [
              -2899.782,
              2101.023,
              6110.562
            ],
            [
              -2971.67,
              2085.586,
              6184.089
            ],
            [
              -3160.259,
              2016.062,
              6385.085
            ],
            [
              -3215.258,
              1991.889,
              6445.161
            ],
            [
              -3241.166,
              1975.384,
              6475.88
            ],
            [
              -3275.786,
              1961.777,
              6513.078
            ],
            [
              -3353.278,
              1920.828,
              6600.724
            ],
            [
              -3402.898,
              1887.184,
              6660.675
            ],
            [
              -3447.61,
              1838.983,
              6726.42
            ],
            [
              -3464.825,
              1813.679,
              6757.025
            ],
            [
              -3479.576,
              1781.653,
              6792.285
            ],
            [
              -3552.495,
              1521.32,
              7062.637
            ],
            [
              -3561.139,
              1488.768,
              7096.318
            ],
            [
              -3571.509,
              1457.992,
              7128.794
            ],
            [
              -3607.243,
              1385.693,
              7209.442
            ],
            [
              -3647.326,
              1335.952,
              7273.323
            ],
            [
              -3697.872,
              1285.623,
              7344.652
            ],
            [
              -3750.727,
              1250.919,
              7407.882
            ],
            [
              -3785.215,
              1233.706,
              7446.427
            ],
            [
              -3881.236,
              1201.976,
              7547.555
            ],
            [
              -3947.947,
              1186.435,
              7616.052
            ],
            [
              -4028.355,
              1162.223,
              7700.026
            ],
            [
              -4081.657,
              1138.655,
              7758.306
            ],
            [
              -4117.491,
              1118.124,
              7799.605
            ],
            [
              -4158.16,
              1094.22,
              7846.779
            ],
            [
              -4168.309,
              1088.946,
              7858.217
            ],
            [
              -4405.143,
              935,
              8140.688
            ],
            [
              -4424.214,
              922.705,
              8163.378
            ],
            [
              -4433.353,
              916.8,
              8174.259
            ],
            [
              -4463.138,
              899.22,
              8208.845
            ],
            [
              -4519.455,
              850.095,
              8283.577
            ],
            [
              -4559.388,
              778.424,
              8365.622
            ],
            [
              -4567.189,
              737.369,
              8407.411
            ],
            [
              -4562.176,
              653.793,
              8491.138
            ],
            [
              -4542.083,
              471.996,
              8674.042
            ],
            [
              -4535.565,
              436.694,
              8709.94
            ],
            [
              -4533.311,
              419.524,
              8727.258
            ],
            [
              -4527.744,
              368.221,
              8778.862
            ],
            [
              -4516.259,
              323.495,
              8825.039
            ],
            [
              -4491.638,
              255.166,
              8897.668
            ],
            [
              -4427.619,
              152.763,
              9018.436
            ],
            [
              -4367.011,
              77.134,
              9115.354
            ],
            [
              -4080.333,
              -210.913,
              9521.747
            ],
            [
              -3954.469,
              -380.846,
              9733.216
            ],
            [
              -3926.158,
              -422.036,
              9783.197
            ],
            [
              -3919.036,
              -433.74,
              9796.898
            ],
            [
              -3857.936,
              -540.596,
              9919.989
            ],
            [
              -3823.641,
              -607.984,
              9995.601
            ],
            [
              -3766.483,
              -732.543,
              10132.649
            ],
            [
              -3707.64,
              -908.34,
              10318.032
            ],
            [
              -3695.741,
              -928.584,
              10341.514
            ],
            [
              -3679.687,
              -950.175,
              10368.42
            ],
            [
              -3673.878,
              -969.04,
              10388.159
            ],
            [
              -3654.555,
              -1007.226,
              10430.956
            ],
            [
              -3618.264,
              -1069.098,
              10502.685
            ],
            [
              -3599.031,
              -1113.947,
              10551.484
            ],
            [
              -3569.469,
              -1193.5,
              10636.353
            ],
            [
              -3554.873,
              -1243.849,
              10688.775
            ],
            [
              -3546.348,
              -1270.446,
              10716.704
            ],
            [
              -3520.478,
              -1415.883,
              10864.424
            ],
            [
              -3500.646,
              -1498.607,
              10949.492
            ],
            [
              -3461.302,
              -1608.388,
              11066.111
            ],
            [
              -3462.063,
              -1615.054,
              11072.82
            ],
            [
              -3466.214,
              -1618.635,
              11078.302
            ],
            [
              -3480.186,
              -1619.191,
              11092.285
            ],
            [
              -3518.97,
              -1623.742,
              11131.336
            ],
            [
              -3543.21,
              -1625.119,
              11155.614
            ],
            [
              -3571.837,
              -1625.385,
              11184.243
            ],
            [
              -3644.74,
              -1628.568,
              11257.215
            ],
            [
              -3721.548,
              -1633.911,
              11334.209
            ],
            [
              -3788.083,
              -1641.66,
              11401.193
            ],
            [
              -3841.2,
              -1656.322,
              11456.297
            ],
            [
              -3882.188,
              -1677.875,
              11502.606
            ],
            [
              -3931.102,
              -1710.422,
              11561.359
            ],
            [
              -3978.977,
              -1757.46,
              11628.475
            ],
            [
              -4022.062,
              -1825.732,
              11709.205
            ],
            [
              -4044.37,
              -1885.459,
              11772.962
            ],
            [
              -4052.817,
              -1926.501,
              11814.865
            ],
            [
              -4053.048,
              -1939.856,
              11828.222
            ],
            [
              -4053.478,
              -1959.825,
              11848.195
            ],
            [
              -4055.493,
              -2006.606,
              11895.02
            ],
            [
              -4046.573,
              -2161.497,
              12050.167
            ],
            [
              -4020.612,
              -2299.985,
              12191.068
            ],
            [
              -3990.129,
              -2400.702,
              12296.297
            ],
            [
              -3964.263,
              -2470.17,
              12370.424
            ],
            [
              -3946.156,
              -2503.88,
              12408.689
            ],
            [
              -3938.431,
              -2519.742,
              12426.333
            ],
            [
              -3933.698,
              -2531.347,
              12438.865
            ],
            [
              -3926.386,
              -2553.204,
              12461.913
            ],
            [
              -3841.707,
              -2761.732,
              12686.978
            ],
            [
              -3765.67,
              -2947.847,
              12888.027
            ],
            [
              -3690.695,
              -3120.586,
              13076.335
            ],
            [
              -3680.304,
              -3153.05,
              13110.421
            ],
            [
              -3667.758,
              -3180.973,
              13141.033
            ],
            [
              -3659.777,
              -3201.747,
              13163.288
            ],
            [
              -3640.55,
              -3257.597,
              13222.354
            ],
            [
              -3617.776,
              -3346.817,
              13314.436
            ],
            [
              -3610.984,
              -3396.99,
              13365.066
            ],
            [
              -3610.019,
              -3500.257,
              13468.337
            ],
            [
              -3620.065,
              -3579.347,
              13548.063
            ],
            [
              -3630.094,
              -3629.184,
              13598.899
            ],
            [
              -3640.182,
              -3661.375,
              13632.634
            ],
            [
              -3673.181,
              -3743.178,
              13720.842
            ],
            [
              -3862.172,
              -4125.062,
              14146.932
            ],
            [
              -3878.53,
              -4166.876,
              14191.832
            ],
            [
              -3892.491,
              -4201.348,
              14229.024
            ],
            [
              -3906.204,
              -4248.978,
              14278.589
            ],
            [
              -3915.447,
              -4298.912,
              14329.371
            ],
            [
              -3918.758,
              -4341.156,
              14371.744
            ],
            [
              -3917.895,
              -4365.662,
              14396.266
            ],
            [
              -3914.159,
              -4410.256,
              14441.016
            ],
            [
              -3903.629,
              -4471.665,
              14503.321
            ],
            [
              -3893.942,
              -4507.456,
              14540.4
            ],
            [
              -3887.4,
              -4526.56,
              14560.593
            ],
            [
              -3876.856,
              -4562.301,
              14597.857
            ],
            [
              -3837.687,
              -4680.982,
              14722.834
            ],
            [
              -3830.05,
              -4723.417,
              14765.951
            ],
            [
              -3816.509,
              -4833.861,
              14877.222
            ],
            [
              -3815.714,
              -4936.291,
              14979.655
            ],
            [
              -3827.684,
              -5087.455,
              15131.292
            ],
            [
              -3835.986,
              -5117.005,
              15161.986
            ],
            [
              -3846.109,
              -5119.902,
              15172.516
            ],
            [
              -3879.396,
              -5153.374,
              15219.722
            ],
            [
              -3922.484,
              -5149.286,
              15263.004
            ],
            [
              -3928.106,
              -5139.169,
              15274.578
            ],
            [
              -3926.238,
              -5105.805,
              15307.994
            ],
            [
              -3921.595,
              -5098.093,
              15316.996
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:8374",
              "position": {
                "x": -5952.758,
                "z": 4324.297
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": -540,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:1008",
              "position": {
                "x": -5851.894,
                "z": 4410.536
              },
              "distanceAlongShapeM": 144.18,
              "shapeOffsetM": 2.216,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:5570",
              "position": {
                "x": -5523.681,
                "z": 4732.259
              },
              "distanceAlongShapeM": 603.495,
              "shapeOffsetM": 2.547,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:7554",
              "position": {
                "x": -5256.503,
                "z": 4916.963
              },
              "distanceAlongShapeM": 989.652,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:5564",
              "position": {
                "x": -4963.962,
                "z": 5035.54
              },
              "distanceAlongShapeM": 1316.839,
              "shapeOffsetM": 1.247,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:5594",
              "position": {
                "x": -4669.05,
                "z": 5178.548
              },
              "distanceAlongShapeM": 1665.401,
              "shapeOffsetM": 0.065,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:6850",
              "position": {
                "x": -4517.509,
                "z": 4980.025
              },
              "distanceAlongShapeM": 1970.988,
              "shapeOffsetM": 2.616,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:6851",
              "position": {
                "x": -4166.695,
                "z": 4657.837
              },
              "distanceAlongShapeM": 2447.684,
              "shapeOffsetM": 0.707,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:5546",
              "position": {
                "x": -3780.952,
                "z": 4268.223
              },
              "distanceAlongShapeM": 2996.652,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:9384",
              "position": {
                "x": -3344.49,
                "z": 3829.822
              },
              "distanceAlongShapeM": 3616.469,
              "shapeOffsetM": 0.206,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:857",
              "position": {
                "x": -2808.656,
                "z": 3248.254
              },
              "distanceAlongShapeM": 4410.156,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:5542",
              "position": {
                "x": -2612.218,
                "z": 2675.949
              },
              "distanceAlongShapeM": 5016.766,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:6338",
              "position": {
                "x": -2690.837,
                "z": 2168.596
              },
              "distanceAlongShapeM": 5890.999,
              "shapeOffsetM": 4.045,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:720",
              "position": {
                "x": -3240.098,
                "z": 1973.399
              },
              "distanceAlongShapeM": 6475.88,
              "shapeOffsetM": 2.254,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:790",
              "position": {
                "x": -3555.031,
                "z": 1486.855
              },
              "distanceAlongShapeM": 7096.318,
              "shapeOffsetM": 6.401,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:6648",
              "position": {
                "x": -4156.018,
                "z": 1090.96
              },
              "distanceAlongShapeM": 7846.584,
              "shapeOffsetM": 3.896,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            },
            {
              "stopId": "judu:stop:6462",
              "position": {
                "x": -4421.523,
                "z": 918.541
              },
              "distanceAlongShapeM": 8163.373,
              "shapeOffsetM": 4.958,
              "arrivalOffsetSeconds": 1380,
              "departureOffsetSeconds": 1380
            },
            {
              "stopId": "judu:stop:1071",
              "position": {
                "x": -4530.426,
                "z": 437.286
              },
              "distanceAlongShapeM": 8710.022,
              "shapeOffsetM": 5.172,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            },
            {
              "stopId": "judu:stop:1004",
              "position": {
                "x": -4077.229,
                "z": -208.399
              },
              "distanceAlongShapeM": 9521.747,
              "shapeOffsetM": 3.995,
              "arrivalOffsetSeconds": 1560,
              "departureOffsetSeconds": 1560
            },
            {
              "stopId": "judu:stop:6649",
              "position": {
                "x": -3921.604,
                "z": -419.265
              },
              "distanceAlongShapeM": 9783.197,
              "shapeOffsetM": 5.33,
              "arrivalOffsetSeconds": 1620,
              "departureOffsetSeconds": 1620
            },
            {
              "stopId": "judu:stop:6643",
              "position": {
                "x": -3679.35,
                "z": -950.021
              },
              "distanceAlongShapeM": 10368.42,
              "shapeOffsetM": 0.37,
              "arrivalOffsetSeconds": 1740,
              "departureOffsetSeconds": 1740
            },
            {
              "stopId": "judu:stop:4990",
              "position": {
                "x": -3543.073,
                "z": -1269.659
              },
              "distanceAlongShapeM": 10716.704,
              "shapeOffsetM": 3.368,
              "arrivalOffsetSeconds": 1860,
              "departureOffsetSeconds": 1860
            },
            {
              "stopId": "judu:stop:6597",
              "position": {
                "x": -3542.913,
                "z": -1630.342
              },
              "distanceAlongShapeM": 11155.614,
              "shapeOffsetM": 5.231,
              "arrivalOffsetSeconds": 1980,
              "departureOffsetSeconds": 1980
            },
            {
              "stopId": "judu:stop:6587",
              "position": {
                "x": -4048.884,
                "z": -1959.966
              },
              "distanceAlongShapeM": 11848.195,
              "shapeOffsetM": 4.596,
              "arrivalOffsetSeconds": 2100,
              "departureOffsetSeconds": 2100
            },
            {
              "stopId": "judu:stop:6582",
              "position": {
                "x": -3932.856,
                "z": -2517.469
              },
              "distanceAlongShapeM": 12426.333,
              "shapeOffsetM": 6.02,
              "arrivalOffsetSeconds": 2220,
              "departureOffsetSeconds": 2220
            },
            {
              "stopId": "judu:stop:5063",
              "position": {
                "x": -3662.711,
                "z": -3178.96
              },
              "distanceAlongShapeM": 13141.033,
              "shapeOffsetM": 5.433,
              "arrivalOffsetSeconds": 2340,
              "departureOffsetSeconds": 2340
            },
            {
              "stopId": "judu:stop:5140",
              "position": {
                "x": -3625.467,
                "z": -3630.461
              },
              "distanceAlongShapeM": 13598.899,
              "shapeOffsetM": 4.8,
              "arrivalOffsetSeconds": 2460,
              "departureOffsetSeconds": 2460
            },
            {
              "stopId": "judu:stop:5141",
              "position": {
                "x": -3875.164,
                "z": -4168.252
              },
              "distanceAlongShapeM": 14191.844,
              "shapeOffsetM": 3.636,
              "arrivalOffsetSeconds": 2520,
              "departureOffsetSeconds": 2520
            },
            {
              "stopId": "judu:stop:6925",
              "position": {
                "x": -3883.947,
                "z": -4525.441
              },
              "distanceAlongShapeM": 14560.593,
              "shapeOffsetM": 3.63,
              "arrivalOffsetSeconds": 2640,
              "departureOffsetSeconds": 2640
            },
            {
              "stopId": "judu:stop:6931",
              "position": {
                "x": -3827.361,
                "z": -5087.486
              },
              "distanceAlongShapeM": 15131.292,
              "shapeOffsetM": 0.325,
              "arrivalOffsetSeconds": 2700,
              "departureOffsetSeconds": 2700
            },
            {
              "stopId": "judu:stop:8441",
              "position": {
                "x": -3921.595,
                "z": -5098.093
              },
              "distanceAlongShapeM": 15316.996,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2760,
              "departureOffsetSeconds": 2760
            }
          ],
          "departuresSeconds": [
            19860,
            20700,
            21480,
            22380,
            23220,
            24120,
            24720,
            25320,
            25860,
            26400,
            27120,
            27840,
            28440,
            29160,
            30000,
            31020,
            32040,
            33060,
            34140,
            35160,
            36300,
            37440,
            38640,
            39840,
            41040,
            42240,
            43380,
            44580,
            45780,
            47040,
            48300,
            49440,
            50580,
            51720,
            52560,
            53280,
            54060,
            54660,
            55260,
            55920,
            56700,
            57540,
            58320,
            59100,
            59640,
            60120,
            60720,
            61260,
            61980,
            62700,
            63480,
            64380,
            65520,
            66960,
            68460,
            70020,
            71460,
            72840,
            74040,
            75180,
            76500,
            77580,
            79380,
            80580,
            81780,
            83280
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_trol_19",
      "sourceRouteId": "vilnius_trol_19",
      "mode": "trolleybus",
      "shortName": "19",
      "longName": "Pašilaičiai–Konstitucijos pr.–Antakalnis–Saulėtekis",
      "color": "DC3131",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_trol_19:0",
          "sourceRouteId": "vilnius_trol_19",
          "sourceShapeId": "vilnius_trol_19_a-b",
          "directionId": 0,
          "headsign": "Saulėtekis",
          "directionName": "Pašilaičiai–Konstitucijos pr.–Antakalnis–Saulėtekis",
          "mode": "trolleybus",
          "routeShortName": "19",
          "routeLongName": "Pašilaičiai–Konstitucijos pr.–Antakalnis–Saulėtekis",
          "routeColor": "DC3131",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              -2898.02,
              -4403.939,
              0
            ],
            [
              -2904.267,
              -4392.283,
              13.224
            ],
            [
              -2902.49,
              -4364.484,
              41.08
            ],
            [
              -2922.066,
              -4325.629,
              84.588
            ],
            [
              -2938.397,
              -4244.738,
              167.111
            ],
            [
              -2943.47,
              -4203.459,
              208.7
            ],
            [
              -2943.332,
              -4158.933,
              253.226
            ],
            [
              -2942.883,
              -4106.854,
              305.307
            ],
            [
              -2936.886,
              -4048.837,
              363.633
            ],
            [
              -2933.232,
              -3950.938,
              461.601
            ],
            [
              -2933.288,
              -3880.804,
              531.735
            ],
            [
              -2935.53,
              -3825.104,
              587.48
            ],
            [
              -2941.624,
              -3778.189,
              634.789
            ],
            [
              -2941.11,
              -3739.288,
              673.693
            ],
            [
              -2942.553,
              -3711.432,
              701.587
            ],
            [
              -2962.772,
              -3578.604,
              835.945
            ],
            [
              -2994.393,
              -3434.443,
              983.533
            ],
            [
              -3009.522,
              -3378.516,
              1041.47
            ],
            [
              -3022.156,
              -3343.455,
              1078.738
            ],
            [
              -3029.648,
              -3313.596,
              1109.522
            ],
            [
              -3083.217,
              -3134.541,
              1296.419
            ],
            [
              -3102.428,
              -3054.053,
              1379.168
            ],
            [
              -3135.722,
              -2971.783,
              1467.919
            ],
            [
              -3158.619,
              -2877.179,
              1565.255
            ],
            [
              -3186.209,
              -2796.544,
              1650.479
            ],
            [
              -3248.067,
              -2685.253,
              1777.806
            ],
            [
              -3332.852,
              -2557.976,
              1930.737
            ],
            [
              -3345.044,
              -2540.486,
              1952.057
            ],
            [
              -3361.538,
              -2502.927,
              1993.078
            ],
            [
              -3386.79,
              -2435.693,
              2064.898
            ],
            [
              -3393.431,
              -2409.973,
              2091.462
            ],
            [
              -3395.464,
              -2378.768,
              2122.733
            ],
            [
              -3388.347,
              -2243.256,
              2258.432
            ],
            [
              -3384.424,
              -2226.45,
              2275.689
            ],
            [
              -3365.672,
              -2038.645,
              2464.428
            ],
            [
              -3370.713,
              -1991.384,
              2511.957
            ],
            [
              -3374.974,
              -1943.859,
              2559.673
            ],
            [
              -3391.774,
              -1872.32,
              2633.158
            ],
            [
              -3430.979,
              -1754.748,
              2757.094
            ],
            [
              -3480.186,
              -1619.191,
              2901.306
            ],
            [
              -3508.003,
              -1550.799,
              2975.139
            ],
            [
              -3521.109,
              -1520.135,
              3008.486
            ],
            [
              -3534.455,
              -1477.979,
              3052.704
            ],
            [
              -3626.266,
              -1196.964,
              3348.337
            ],
            [
              -3643.222,
              -1150.713,
              3397.598
            ],
            [
              -3645.883,
              -1138.735,
              3409.868
            ],
            [
              -3642.486,
              -1128.776,
              3420.391
            ],
            [
              -3630.73,
              -1120.075,
              3435.016
            ],
            [
              -3599.031,
              -1113.947,
              3467.302
            ],
            [
              -3412.497,
              -1176.2,
              3663.95
            ],
            [
              -3355.367,
              -1190.556,
              3722.856
            ],
            [
              -3109.19,
              -1234.288,
              3972.887
            ],
            [
              -3070.013,
              -1242.306,
              4012.876
            ],
            [
              -2879.155,
              -1277.94,
              4207.032
            ],
            [
              -2839.273,
              -1283.094,
              4247.246
            ],
            [
              -2787.087,
              -1285.125,
              4299.471
            ],
            [
              -2748.376,
              -1283.58,
              4338.213
            ],
            [
              -2714.118,
              -1278.617,
              4372.829
            ],
            [
              -2670.7,
              -1266.023,
              4418.037
            ],
            [
              -2624.585,
              -1246.798,
              4467.999
            ],
            [
              -2499.949,
              -1183.085,
              4607.975
            ],
            [
              -2469.831,
              -1172.717,
              4639.828
            ],
            [
              -2418.716,
              -1162.489,
              4691.956
            ],
            [
              -2392.231,
              -1159.617,
              4718.596
            ],
            [
              -2152.041,
              -1187.387,
              4960.386
            ],
            [
              -2126.526,
              -1191.159,
              4986.178
            ],
            [
              -2118.854,
              -1195.63,
              4995.058
            ],
            [
              -1988.935,
              -1213.522,
              5126.203
            ],
            [
              -1948.388,
              -1217.583,
              5166.953
            ],
            [
              -1866.572,
              -1221.265,
              5248.852
            ],
            [
              -1794.345,
              -1220.324,
              5321.085
            ],
            [
              -1681.879,
              -1204.518,
              5434.657
            ],
            [
              -1544.075,
              -1178.035,
              5574.982
            ],
            [
              -1435.713,
              -1149.425,
              5687.058
            ],
            [
              -1393.22,
              -1142.883,
              5730.051
            ],
            [
              -1155.149,
              -1098.17,
              5972.285
            ],
            [
              -1103.532,
              -1084.281,
              6025.738
            ],
            [
              -1083.324,
              -1083.875,
              6045.949
            ],
            [
              -1022.536,
              -1073.836,
              6107.561
            ],
            [
              -998.991,
              -1055.334,
              6137.506
            ],
            [
              -969.041,
              -1039.175,
              6171.537
            ],
            [
              -947.066,
              -1036.231,
              6193.708
            ],
            [
              -930.307,
              -1036.533,
              6210.47
            ],
            [
              -906.579,
              -1043.639,
              6235.239
            ],
            [
              -895.802,
              -1053.852,
              6250.087
            ],
            [
              -890.221,
              -1066.198,
              6263.635
            ],
            [
              -876.342,
              -1083.147,
              6285.542
            ],
            [
              -864.236,
              -1091.158,
              6300.058
            ],
            [
              -846.005,
              -1097.331,
              6319.307
            ],
            [
              -813.038,
              -1094.85,
              6352.367
            ],
            [
              -785.651,
              -1089.799,
              6380.215
            ],
            [
              -774.937,
              -1088.05,
              6391.071
            ],
            [
              -717.669,
              -1083.853,
              6448.493
            ],
            [
              -647.083,
              -1062.792,
              6522.154
            ],
            [
              -535.555,
              -1028.072,
              6638.961
            ],
            [
              -464.693,
              -995.958,
              6716.761
            ],
            [
              -361.843,
              -942.16,
              6832.831
            ],
            [
              -331.427,
              -923.524,
              6868.502
            ],
            [
              -286.654,
              -898.264,
              6919.909
            ],
            [
              -196.966,
              -846.075,
              7023.676
            ],
            [
              -115.583,
              -803.025,
              7115.744
            ],
            [
              -95.312,
              -792.953,
              7138.379
            ],
            [
              -40.176,
              -770.281,
              7197.995
            ],
            [
              224.8,
              -701.243,
              7471.817
            ],
            [
              238.603,
              -700.678,
              7485.632
            ],
            [
              294.146,
              -689.755,
              7542.238
            ],
            [
              331.506,
              -684.268,
              7579.999
            ],
            [
              436.802,
              -673.948,
              7685.8
            ],
            [
              647.48,
              -719,
              7901.241
            ],
            [
              692.52,
              -724.28,
              7946.589
            ],
            [
              727.857,
              -730.038,
              7982.393
            ],
            [
              752.192,
              -734.856,
              8007.2
            ],
            [
              1031.058,
              -793.963,
              8292.261
            ],
            [
              1157.03,
              -816.326,
              8420.203
            ],
            [
              1199.169,
              -824.315,
              8463.092
            ],
            [
              1220.015,
              -827.509,
              8484.182
            ],
            [
              1248.96,
              -831.383,
              8513.385
            ],
            [
              1306.39,
              -829.106,
              8570.86
            ],
            [
              1367.853,
              -817.997,
              8633.319
            ],
            [
              1381.451,
              -814.909,
              8647.263
            ],
            [
              1598.931,
              -666.427,
              8910.596
            ],
            [
              1632.324,
              -639.216,
              8953.672
            ],
            [
              1644.195,
              -624.964,
              8972.22
            ],
            [
              1649.997,
              -609.491,
              8988.746
            ],
            [
              1647.435,
              -589.4,
              9008.999
            ],
            [
              1649.076,
              -570.506,
              9027.964
            ],
            [
              1661.593,
              -556.266,
              9046.924
            ],
            [
              1683.01,
              -548.871,
              9069.581
            ],
            [
              1705.327,
              -547.896,
              9091.92
            ],
            [
              1715.935,
              -555.388,
              9104.907
            ],
            [
              1719.444,
              -566.247,
              9116.319
            ],
            [
              1719.696,
              -587.403,
              9137.476
            ],
            [
              1723.546,
              -623.099,
              9173.379
            ],
            [
              1729.599,
              -644.363,
              9195.488
            ],
            [
              1821.456,
              -767.415,
              9349.044
            ],
            [
              1905.301,
              -870.282,
              9481.753
            ],
            [
              1935.932,
              -922.062,
              9541.915
            ],
            [
              1949.532,
              -953.487,
              9576.156
            ],
            [
              1955.317,
              -990.986,
              9614.099
            ],
            [
              1968.757,
              -1305.631,
              9929.031
            ],
            [
              1988.222,
              -1471.868,
              10096.403
            ],
            [
              2027.109,
              -1678.358,
              10306.523
            ],
            [
              2032.074,
              -1713.148,
              10341.666
            ],
            [
              2048.644,
              -1792.498,
              10422.727
            ],
            [
              2068.057,
              -1877.836,
              10510.246
            ],
            [
              2081.808,
              -1938.356,
              10572.308
            ],
            [
              2087.374,
              -1962.435,
              10597.022
            ],
            [
              2110.719,
              -2024.1,
              10662.958
            ],
            [
              2234.812,
              -2316.979,
              10981.042
            ],
            [
              2284.924,
              -2429.242,
              11103.981
            ],
            [
              2299.015,
              -2468.47,
              11145.664
            ],
            [
              2319.691,
              -2569.05,
              11248.347
            ],
            [
              2323.471,
              -2587.599,
              11267.277
            ],
            [
              2323.492,
              -2606.972,
              11286.65
            ],
            [
              2328.687,
              -2639.354,
              11319.446
            ],
            [
              2411.872,
              -3118.499,
              11805.758
            ],
            [
              2415.738,
              -3139.252,
              11826.868
            ],
            [
              2418.768,
              -3163.158,
              11850.966
            ],
            [
              2474.472,
              -3526.012,
              12218.07
            ],
            [
              2513.109,
              -3664.781,
              12362.118
            ],
            [
              2520.474,
              -3683.355,
              12382.099
            ],
            [
              2522.312,
              -3689.445,
              12388.46
            ],
            [
              2535.711,
              -3730.887,
              12432.014
            ],
            [
              2556.818,
              -3773.588,
              12479.647
            ],
            [
              2598.204,
              -3834.482,
              12553.274
            ],
            [
              2619.624,
              -3860.489,
              12586.966
            ],
            [
              2635.392,
              -3877.441,
              12610.118
            ],
            [
              2642.893,
              -3890.985,
              12625.6
            ],
            [
              2709.56,
              -3977.961,
              12735.187
            ],
            [
              3021.059,
              -4338.966,
              13212.006
            ],
            [
              3086.352,
              -4293.444,
              13291.602
            ],
            [
              3112.838,
              -4272.891,
              13325.127
            ],
            [
              3142.482,
              -4255.542,
              13359.474
            ],
            [
              3336.938,
              -4126.748,
              13592.715
            ],
            [
              3389.682,
              -4097.691,
              13652.933
            ],
            [
              3403.448,
              -4088.142,
              13669.686
            ],
            [
              3446.229,
              -4072.046,
              13715.395
            ],
            [
              3528.69,
              -4039.102,
              13804.194
            ],
            [
              3592.048,
              -4028.061,
              13868.506
            ],
            [
              3640.778,
              -4019.583,
              13917.968
            ],
            [
              3666.294,
              -4020.567,
              13943.503
            ],
            [
              3848.026,
              -4019.578,
              14125.238
            ],
            [
              3878.881,
              -4023.507,
              14156.342
            ],
            [
              3901.964,
              -4029.514,
              14180.194
            ],
            [
              3958.181,
              -4055.079,
              14241.951
            ],
            [
              3965.111,
              -4059.221,
              14250.025
            ],
            [
              4018.762,
              -4121.92,
              14332.545
            ],
            [
              4037.773,
              -4172.381,
              14386.468
            ],
            [
              4030.875,
              -4184.064,
              14400.036
            ],
            [
              4020.501,
              -4190.327,
              14412.154
            ],
            [
              4013.086,
              -4190.447,
              14419.569
            ],
            [
              4002.213,
              -4183.979,
              14432.22
            ],
            [
              3961.129,
              -4130.112,
              14499.967
            ],
            [
              3954.003,
              -4105.097,
              14525.977
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:6484",
              "position": {
                "x": -2923.723,
                "z": -4326.261
              },
              "distanceAlongShapeM": 84.588,
              "shapeOffsetM": 1.774,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:6523",
              "position": {
                "x": -2947.565,
                "z": -4106.537
              },
              "distanceAlongShapeM": 305.307,
              "shapeOffsetM": 4.693,
              "arrivalOffsetSeconds": 60,
              "departureOffsetSeconds": 60
            },
            {
              "stopId": "judu:stop:6482",
              "position": {
                "x": -2942.439,
                "z": -3778.227
              },
              "distanceAlongShapeM": 634.789,
              "shapeOffsetM": 0.816,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:6478",
              "position": {
                "x": -3026.974,
                "z": -3344.813
              },
              "distanceAlongShapeM": 1078.738,
              "shapeOffsetM": 5.006,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:6477",
              "position": {
                "x": -3137.083,
                "z": -2972.18
              },
              "distanceAlongShapeM": 1467.919,
              "shapeOffsetM": 1.418,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:6476",
              "position": {
                "x": -3349.352,
                "z": -2543.216
              },
              "distanceAlongShapeM": 1952.057,
              "shapeOffsetM": 5.101,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:6475",
              "position": {
                "x": -3389.87,
                "z": -2243.053
              },
              "distanceAlongShapeM": 2258.432,
              "shapeOffsetM": 1.536,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:5620",
              "position": {
                "x": -3375.166,
                "z": -1991.724
              },
              "distanceAlongShapeM": 2512.016,
              "shapeOffsetM": 4.466,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:928",
              "position": {
                "x": -3525.544,
                "z": -1521.55
              },
              "distanceAlongShapeM": 3008.486,
              "shapeOffsetM": 4.655,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:7416",
              "position": {
                "x": -3108.49,
                "z": -1230.499
              },
              "distanceAlongShapeM": 3972.887,
              "shapeOffsetM": 3.854,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:6398",
              "position": {
                "x": -2151.528,
                "z": -1183.918
              },
              "distanceAlongShapeM": 4960.386,
              "shapeOffsetM": 3.507,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:6396",
              "position": {
                "x": -1436.465,
                "z": -1145.449
              },
              "distanceAlongShapeM": 5687.058,
              "shapeOffsetM": 4.046,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:6397",
              "position": {
                "x": -1103.929,
                "z": -1082.392
              },
              "distanceAlongShapeM": 6025.738,
              "shapeOffsetM": 1.931,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:6635",
              "position": {
                "x": -775.751,
                "z": -1082.734
              },
              "distanceAlongShapeM": 6391.071,
              "shapeOffsetM": 5.378,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            },
            {
              "stopId": "judu:stop:7381",
              "position": {
                "x": -333.702,
                "z": -919.293
              },
              "distanceAlongShapeM": 6868.6,
              "shapeOffsetM": 4.803,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            },
            {
              "stopId": "judu:stop:17638",
              "position": {
                "x": -42.035,
                "z": -765.399
              },
              "distanceAlongShapeM": 7197.995,
              "shapeOffsetM": 5.224,
              "arrivalOffsetSeconds": 1560,
              "departureOffsetSeconds": 1560
            },
            {
              "stopId": "judu:stop:5667",
              "position": {
                "x": 292.85,
                "z": -682.448
              },
              "distanceAlongShapeM": 7542.238,
              "shapeOffsetM": 7.421,
              "arrivalOffsetSeconds": 1740,
              "departureOffsetSeconds": 1740
            },
            {
              "stopId": "judu:stop:5665",
              "position": {
                "x": 729.304,
                "z": -722.729
              },
              "distanceAlongShapeM": 7982.393,
              "shapeOffsetM": 7.451,
              "arrivalOffsetSeconds": 1920,
              "departureOffsetSeconds": 1920
            },
            {
              "stopId": "judu:stop:6660",
              "position": {
                "x": 1200.176,
                "z": -819.349
              },
              "distanceAlongShapeM": 8463.335,
              "shapeOffsetM": 5.061,
              "arrivalOffsetSeconds": 1980,
              "departureOffsetSeconds": 1980
            },
            {
              "stopId": "judu:stop:5826",
              "position": {
                "x": 1961.738,
                "z": -990.451
              },
              "distanceAlongShapeM": 9614.099,
              "shapeOffsetM": 6.443,
              "arrivalOffsetSeconds": 2220,
              "departureOffsetSeconds": 2220
            },
            {
              "stopId": "judu:stop:6702",
              "position": {
                "x": 2032.094,
                "z": -1677.525
              },
              "distanceAlongShapeM": 10306.523,
              "shapeOffsetM": 5.054,
              "arrivalOffsetSeconds": 2280,
              "departureOffsetSeconds": 2280
            },
            {
              "stopId": "judu:stop:5092",
              "position": {
                "x": 2087.852,
                "z": -1936.84
              },
              "distanceAlongShapeM": 10572.169,
              "shapeOffsetM": 6.23,
              "arrivalOffsetSeconds": 2400,
              "departureOffsetSeconds": 2400
            },
            {
              "stopId": "judu:stop:5095",
              "position": {
                "x": 2327.089,
                "z": -2587.001
              },
              "distanceAlongShapeM": 11267.277,
              "shapeOffsetM": 3.667,
              "arrivalOffsetSeconds": 2520,
              "departureOffsetSeconds": 2520
            },
            {
              "stopId": "judu:stop:1035",
              "position": {
                "x": 2419.872,
                "z": -3138.687
              },
              "distanceAlongShapeM": 11826.868,
              "shapeOffsetM": 4.173,
              "arrivalOffsetSeconds": 2640,
              "departureOffsetSeconds": 2640
            },
            {
              "stopId": "judu:stop:6711",
              "position": {
                "x": 2522.438,
                "z": -3682.768
              },
              "distanceAlongShapeM": 12382.104,
              "shapeOffsetM": 2.05,
              "arrivalOffsetSeconds": 2760,
              "departureOffsetSeconds": 2760
            },
            {
              "stopId": "judu:stop:741",
              "position": {
                "x": 2636.723,
                "z": -3876.397
              },
              "distanceAlongShapeM": 12610.118,
              "shapeOffsetM": 1.691,
              "arrivalOffsetSeconds": 2820,
              "departureOffsetSeconds": 2820
            },
            {
              "stopId": "judu:stop:5104",
              "position": {
                "x": 3111.27,
                "z": -4270.537
              },
              "distanceAlongShapeM": 13325.127,
              "shapeOffsetM": 2.828,
              "arrivalOffsetSeconds": 2940,
              "departureOffsetSeconds": 2940
            },
            {
              "stopId": "judu:stop:5105",
              "position": {
                "x": 3402.776,
                "z": -4086.807
              },
              "distanceAlongShapeM": 13669.686,
              "shapeOffsetM": 1.495,
              "arrivalOffsetSeconds": 3000,
              "departureOffsetSeconds": 3000
            },
            {
              "stopId": "judu:stop:5107",
              "position": {
                "x": 3640.634,
                "z": -4014.513
              },
              "distanceAlongShapeM": 13917.968,
              "shapeOffsetM": 5.072,
              "arrivalOffsetSeconds": 3060,
              "departureOffsetSeconds": 3060
            },
            {
              "stopId": "judu:stop:900",
              "position": {
                "x": 3967.843,
                "z": -4055.264
              },
              "distanceAlongShapeM": 14250.025,
              "shapeOffsetM": 4.809,
              "arrivalOffsetSeconds": 3120,
              "departureOffsetSeconds": 3120
            }
          ],
          "departuresSeconds": [
            18420,
            19620,
            20580,
            21780,
            22620,
            23340,
            24120,
            24900,
            25740,
            26640,
            27480,
            28200,
            29220,
            30420,
            31620,
            32820,
            33780,
            34800,
            35940,
            36720,
            37860,
            39060,
            40140,
            41220,
            42600,
            43980,
            45180,
            46500,
            47580,
            48660,
            50040,
            51480,
            52860,
            54180,
            55320,
            56040,
            56940,
            57660,
            58260,
            58920,
            59940,
            61140,
            62340,
            63540,
            64380,
            65700,
            66900,
            67500,
            68580,
            69960,
            71220,
            72540,
            74160,
            75120,
            76080,
            77160,
            78300,
            79740,
            81180,
            82440
          ]
        },
        {
          "id": "judu:pattern:vilnius_trol_19:1",
          "sourceRouteId": "vilnius_trol_19",
          "sourceShapeId": "vilnius_trol_19_b-a",
          "directionId": 1,
          "headsign": "Pašilaičiai",
          "directionName": "Saulėtekis–Antakalnis–Konstitucijos pr.–Pašilaičiai",
          "mode": "trolleybus",
          "routeShortName": "19",
          "routeLongName": "Pašilaičiai–Konstitucijos pr.–Antakalnis–Saulėtekis",
          "routeColor": "DC3131",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              3954.003,
              -4105.097,
              0
            ],
            [
              3949.52,
              -4094.868,
              11.169
            ],
            [
              3943.333,
              -4069.038,
              37.729
            ],
            [
              3940.538,
              -4057,
              50.087
            ],
            [
              3918.536,
              -4045.003,
              75.147
            ],
            [
              3899.276,
              -4037.251,
              95.909
            ],
            [
              3898.616,
              -4036.13,
              97.209
            ],
            [
              3858.828,
              -4027.577,
              137.906
            ],
            [
              3592.048,
              -4028.061,
              404.687
            ],
            [
              3581.678,
              -4031.203,
              415.522
            ],
            [
              3564.996,
              -4038.354,
              433.672
            ],
            [
              3520.083,
              -4051.184,
              480.382
            ],
            [
              3445.458,
              -4078.711,
              559.922
            ],
            [
              3358.965,
              -4120.486,
              655.975
            ],
            [
              3358.852,
              -4122.75,
              658.242
            ],
            [
              3310.064,
              -4150.73,
              714.484
            ],
            [
              3021.059,
              -4338.966,
              1059.385
            ],
            [
              2959.695,
              -4278.804,
              1145.321
            ],
            [
              2940.311,
              -4262.522,
              1170.635
            ],
            [
              2920.517,
              -4237.987,
              1202.16
            ],
            [
              2810.169,
              -4110.107,
              1371.068
            ],
            [
              2739.116,
              -4050.879,
              1463.569
            ],
            [
              2661.391,
              -4003.772,
              1554.455
            ],
            [
              2637.654,
              -3993.387,
              1580.365
            ],
            [
              2619.338,
              -3978.489,
              1603.974
            ],
            [
              2604.004,
              -3971.521,
              1620.817
            ],
            [
              2521.22,
              -3923.064,
              1716.74
            ],
            [
              2506.601,
              -3911.447,
              1735.414
            ],
            [
              2490.099,
              -3890.638,
              1761.971
            ],
            [
              2480.459,
              -3864.316,
              1790.003
            ],
            [
              2475.702,
              -3831.185,
              1823.474
            ],
            [
              2503.004,
              -3722.48,
              1935.555
            ],
            [
              2508.663,
              -3661.358,
              1996.939
            ],
            [
              2467.501,
              -3518.217,
              2145.881
            ],
            [
              2463.864,
              -3499.82,
              2164.633
            ],
            [
              2434.339,
              -3309.248,
              2357.479
            ],
            [
              2430.841,
              -3283.862,
              2383.105
            ],
            [
              2426.976,
              -3256.769,
              2410.472
            ],
            [
              2328.687,
              -2639.354,
              3035.662
            ],
            [
              2308.053,
              -2536.548,
              3140.518
            ],
            [
              2300.116,
              -2511.178,
              3167.101
            ],
            [
              2295.002,
              -2476.188,
              3202.462
            ],
            [
              2274.24,
              -2414.57,
              3267.484
            ],
            [
              2234.812,
              -2316.979,
              3372.739
            ],
            [
              2177.257,
              -2188.992,
              3513.072
            ],
            [
              2082.177,
              -1964.565,
              3756.809
            ],
            [
              2063.994,
              -1895.874,
              3827.865
            ],
            [
              2052.283,
              -1842.34,
              3882.665
            ],
            [
              2048.593,
              -1825.761,
              3899.65
            ],
            [
              2041.617,
              -1789.027,
              3937.041
            ],
            [
              1994.191,
              -1532.095,
              4198.313
            ],
            [
              1989.006,
              -1510.962,
              4220.072
            ],
            [
              1983.619,
              -1477.347,
              4254.117
            ],
            [
              1966.491,
              -1323.401,
              4409.013
            ],
            [
              1951.301,
              -996.936,
              4735.831
            ],
            [
              1944.999,
              -954.515,
              4778.717
            ],
            [
              1926.174,
              -912.972,
              4824.327
            ],
            [
              1921.538,
              -904.629,
              4833.872
            ],
            [
              1905.301,
              -870.282,
              4871.863
            ],
            [
              1842.792,
              -798.983,
              4966.683
            ],
            [
              1722.529,
              -643.118,
              5163.551
            ],
            [
              1706.703,
              -627.239,
              5185.97
            ],
            [
              1684.224,
              -622.368,
              5208.971
            ],
            [
              1662.848,
              -627.537,
              5230.963
            ],
            [
              1583.13,
              -683.945,
              5328.62
            ],
            [
              1381.451,
              -814.909,
              5569.09
            ],
            [
              1363.471,
              -845.747,
              5604.787
            ],
            [
              1363.126,
              -899.177,
              5658.218
            ],
            [
              1355.02,
              -919.065,
              5679.694
            ],
            [
              1339.886,
              -935.484,
              5702.024
            ],
            [
              1325.561,
              -943.011,
              5718.206
            ],
            [
              1293.291,
              -944.641,
              5750.518
            ],
            [
              1278.614,
              -942.95,
              5765.292
            ],
            [
              1269.114,
              -935.31,
              5777.482
            ],
            [
              1257.916,
              -924.645,
              5792.946
            ],
            [
              1250.784,
              -907.118,
              5811.869
            ],
            [
              1250.468,
              -889.3,
              5829.69
            ],
            [
              1243.124,
              -868.013,
              5852.208
            ],
            [
              1234.408,
              -851.153,
              5871.188
            ],
            [
              1218.52,
              -838.613,
              5891.428
            ],
            [
              1192.86,
              -831.46,
              5918.066
            ],
            [
              1155.132,
              -824.781,
              5956.381
            ],
            [
              1120.288,
              -815.648,
              5992.402
            ],
            [
              1031.058,
              -793.963,
              6084.229
            ],
            [
              773.373,
              -745.803,
              6346.376
            ],
            [
              730.608,
              -739.605,
              6389.588
            ],
            [
              702.691,
              -732.259,
              6418.455
            ],
            [
              508.13,
              -687.5,
              6618.098
            ],
            [
              443.852,
              -676.304,
              6683.344
            ],
            [
              405.738,
              -680.059,
              6721.643
            ],
            [
              363.165,
              -686.919,
              6764.765
            ],
            [
              341.718,
              -690.021,
              6786.435
            ],
            [
              237.095,
              -710.389,
              6893.022
            ],
            [
              219.749,
              -721.682,
              6913.721
            ],
            [
              73.653,
              -750.808,
              7062.692
            ],
            [
              -18.428,
              -779.188,
              7159.047
            ],
            [
              -55.388,
              -799.514,
              7201.228
            ],
            [
              -306.711,
              -924.235,
              7481.796
            ],
            [
              -475.993,
              -1014.678,
              7673.723
            ],
            [
              -535.166,
              -1050.172,
              7742.725
            ],
            [
              -673.187,
              -1080.133,
              7883.961
            ],
            [
              -764.624,
              -1108.462,
              7979.685
            ],
            [
              -829.227,
              -1116.28,
              8044.76
            ],
            [
              -865.018,
              -1134.559,
              8084.949
            ],
            [
              -891.825,
              -1155.228,
              8118.799
            ],
            [
              -898.939,
              -1163.415,
              8129.645
            ],
            [
              -908.077,
              -1171.394,
              8141.776
            ],
            [
              -917.363,
              -1177.032,
              8152.639
            ],
            [
              -929.666,
              -1178.977,
              8165.095
            ],
            [
              -961.877,
              -1178.457,
              8197.31
            ],
            [
              -977.23,
              -1175.77,
              8212.896
            ],
            [
              -995.797,
              -1164.488,
              8234.622
            ],
            [
              -1006.474,
              -1148.711,
              8253.673
            ],
            [
              -1029.882,
              -1123.799,
              8287.857
            ],
            [
              -1062.634,
              -1116.531,
              8321.405
            ],
            [
              -1097.251,
              -1122.142,
              8356.474
            ],
            [
              -1143.947,
              -1120.636,
              8403.194
            ],
            [
              -1339.338,
              -1158.32,
              8602.186
            ],
            [
              -1374.945,
              -1168.896,
              8639.331
            ],
            [
              -1791.301,
              -1230.398,
              9060.204
            ],
            [
              -1855.793,
              -1231.475,
              9124.705
            ],
            [
              -1940.187,
              -1227.747,
              9209.182
            ],
            [
              -2027.705,
              -1218.399,
              9297.197
            ],
            [
              -2166.609,
              -1198.122,
              9437.574
            ],
            [
              -2255.397,
              -1187.643,
              9526.978
            ],
            [
              -2266.36,
              -1186.843,
              9537.97
            ],
            [
              -2295.924,
              -1182.472,
              9567.855
            ],
            [
              -2392.506,
              -1175.197,
              9664.711
            ],
            [
              -2431.277,
              -1180.078,
              9703.788
            ],
            [
              -2478.584,
              -1193.714,
              9753.021
            ],
            [
              -2533.196,
              -1219.467,
              9813.401
            ],
            [
              -2617.204,
              -1266.966,
              9909.907
            ],
            [
              -2663.944,
              -1285.067,
              9960.03
            ],
            [
              -2710.565,
              -1296.491,
              10008.03
            ],
            [
              -2762.381,
              -1304.469,
              10060.457
            ],
            [
              -2808.767,
              -1305.331,
              10106.851
            ],
            [
              -2858.119,
              -1300.984,
              10156.394
            ],
            [
              -3071.028,
              -1263.439,
              10372.588
            ],
            [
              -3139.719,
              -1251.188,
              10442.363
            ],
            [
              -3159.719,
              -1247.413,
              10462.716
            ],
            [
              -3359.526,
              -1207.182,
              10666.533
            ],
            [
              -3495.953,
              -1192.555,
              10803.742
            ],
            [
              -3539.19,
              -1199.062,
              10847.466
            ],
            [
              -3554.101,
              -1203.884,
              10863.137
            ],
            [
              -3558.842,
              -1212.61,
              10873.067
            ],
            [
              -3559.094,
              -1227.077,
              10887.537
            ],
            [
              -3554.873,
              -1243.849,
              10904.832
            ],
            [
              -3546.348,
              -1270.446,
              10932.761
            ],
            [
              -3520.478,
              -1415.883,
              11080.481
            ],
            [
              -3500.646,
              -1498.607,
              11165.55
            ],
            [
              -3461.302,
              -1608.388,
              11282.168
            ],
            [
              -3438.975,
              -1658.872,
              11337.369
            ],
            [
              -3424.066,
              -1696.754,
              11378.079
            ],
            [
              -3409.647,
              -1735.195,
              11419.135
            ],
            [
              -3354.323,
              -1899.889,
              11592.873
            ],
            [
              -3343.31,
              -1954.868,
              11648.944
            ],
            [
              -3339.232,
              -2037.994,
              11732.17
            ],
            [
              -3350.012,
              -2176.443,
              11871.038
            ],
            [
              -3368.406,
              -2305.768,
              12001.665
            ],
            [
              -3372.034,
              -2365.819,
              12061.825
            ],
            [
              -3365.771,
              -2420.444,
              12116.808
            ],
            [
              -3338.206,
              -2495.543,
              12196.806
            ],
            [
              -3294.464,
              -2574.233,
              12286.837
            ],
            [
              -3260.996,
              -2616.85,
              12341.025
            ],
            [
              -3240.415,
              -2653.104,
              12382.713
            ],
            [
              -3181.544,
              -2750.984,
              12496.933
            ],
            [
              -3157.274,
              -2800.391,
              12551.979
            ],
            [
              -3108.891,
              -2944.844,
              12704.32
            ],
            [
              -3088.313,
              -3020.904,
              12783.114
            ],
            [
              -3081.131,
              -3038.915,
              12802.504
            ],
            [
              -3066.407,
              -3094.76,
              12860.258
            ],
            [
              -3058.312,
              -3116.524,
              12883.479
            ],
            [
              -3044.503,
              -3168.617,
              12937.371
            ],
            [
              -2983.753,
              -3378.969,
              13156.32
            ],
            [
              -2973.575,
              -3406.127,
              13185.322
            ],
            [
              -2964.33,
              -3447.216,
              13227.438
            ],
            [
              -2935.834,
              -3585.756,
              13368.879
            ],
            [
              -2926.739,
              -3654.936,
              13438.654
            ],
            [
              -2914.467,
              -3799.87,
              13584.106
            ],
            [
              -2911.34,
              -3835.779,
              13620.151
            ],
            [
              -2910.491,
              -3863.444,
              13647.829
            ],
            [
              -2921.12,
              -4178.248,
              13962.813
            ],
            [
              -2920.043,
              -4206.629,
              13991.215
            ],
            [
              -2917.063,
              -4240.66,
              14025.375
            ],
            [
              -2899.032,
              -4314.449,
              14101.335
            ],
            [
              -2865.992,
              -4377.371,
              14172.405
            ],
            [
              -2823.799,
              -4432.662,
              14241.956
            ],
            [
              -2835.666,
              -4448.038,
              14261.378
            ],
            [
              -2850.011,
              -4458.605,
              14279.195
            ],
            [
              -2853.525,
              -4457.805,
              14282.799
            ],
            [
              -2898.02,
              -4403.939,
              14352.666
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:6239",
              "position": {
                "x": 3898.552,
                "z": -4039.468
              },
              "distanceAlongShapeM": 95.752,
              "shapeOffsetM": 2.327,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:5116",
              "position": {
                "x": 3565.986,
                "z": -4043.151
              },
              "distanceAlongShapeM": 434.038,
              "shapeOffsetM": 4.885,
              "arrivalOffsetSeconds": 60,
              "departureOffsetSeconds": 60
            },
            {
              "stopId": "judu:stop:6715",
              "position": {
                "x": 3360.169,
                "z": -4124.962
              },
              "distanceAlongShapeM": 658.242,
              "shapeOffsetM": 2.574,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:5103",
              "position": {
                "x": 2937.404,
                "z": -4265.024
              },
              "distanceAlongShapeM": 1170.635,
              "shapeOffsetM": 3.836,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:5117",
              "position": {
                "x": 2636.416,
                "z": -3995.509
              },
              "distanceAlongShapeM": 1580.365,
              "shapeOffsetM": 2.457,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:5118",
              "position": {
                "x": 2463.001,
                "z": -3519.117
              },
              "distanceAlongShapeM": 2145.881,
              "shapeOffsetM": 4.589,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:5119",
              "position": {
                "x": 2425.512,
                "z": -3284.63
              },
              "distanceAlongShapeM": 2383.072,
              "shapeOffsetM": 5.384,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:5096",
              "position": {
                "x": 2296.913,
                "z": -2511.848
              },
              "distanceAlongShapeM": 3167.101,
              "shapeOffsetM": 3.272,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:5818",
              "position": {
                "x": 2043.488,
                "z": -1826.913
              },
              "distanceAlongShapeM": 3899.635,
              "shapeOffsetM": 5.233,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:5819",
              "position": {
                "x": 1983.608,
                "z": -1511.859
              },
              "distanceAlongShapeM": 4220.072,
              "shapeOffsetM": 5.471,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            },
            {
              "stopId": "judu:stop:5820",
              "position": {
                "x": 1921.875,
                "z": -915.121
              },
              "distanceAlongShapeM": 4824.536,
              "shapeOffsetM": 4.802,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:5662",
              "position": {
                "x": 1154.205,
                "z": -829.633
              },
              "distanceAlongShapeM": 5956.381,
              "shapeOffsetM": 4.939,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:5664",
              "position": {
                "x": 729.54,
                "z": -744.998
              },
              "distanceAlongShapeM": 6389.588,
              "shapeOffsetM": 5.498,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            },
            {
              "stopId": "judu:stop:677",
              "position": {
                "x": 364.219,
                "z": -693.772
              },
              "distanceAlongShapeM": 6764.765,
              "shapeOffsetM": 6.934,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            },
            {
              "stopId": "judu:stop:753",
              "position": {
                "x": -53.078,
                "z": -805.275
              },
              "distanceAlongShapeM": 7201.719,
              "shapeOffsetM": 6.187,
              "arrivalOffsetSeconds": 1620,
              "departureOffsetSeconds": 1620
            },
            {
              "stopId": "judu:stop:7382",
              "position": {
                "x": -534.689,
                "z": -1051.466
              },
              "distanceAlongShapeM": 7742.725,
              "shapeOffsetM": 1.38,
              "arrivalOffsetSeconds": 1740,
              "departureOffsetSeconds": 1740
            },
            {
              "stopId": "judu:stop:988",
              "position": {
                "x": -763.423,
                "z": -1114.127
              },
              "distanceAlongShapeM": 7979.685,
              "shapeOffsetM": 5.791,
              "arrivalOffsetSeconds": 1800,
              "departureOffsetSeconds": 1800
            },
            {
              "stopId": "judu:stop:6404",
              "position": {
                "x": -1096.995,
                "z": -1127.045
              },
              "distanceAlongShapeM": 8356.474,
              "shapeOffsetM": 4.91,
              "arrivalOffsetSeconds": 1920,
              "departureOffsetSeconds": 1920
            },
            {
              "stopId": "judu:stop:814",
              "position": {
                "x": -1374.402,
                "z": -1172.164
              },
              "distanceAlongShapeM": 8639.331,
              "shapeOffsetM": 3.313,
              "arrivalOffsetSeconds": 1980,
              "departureOffsetSeconds": 1980
            },
            {
              "stopId": "judu:stop:5906",
              "position": {
                "x": -2267.097,
                "z": -1193.002
              },
              "distanceAlongShapeM": 9537.97,
              "shapeOffsetM": 6.203,
              "arrivalOffsetSeconds": 2100,
              "departureOffsetSeconds": 2100
            },
            {
              "stopId": "judu:stop:7415",
              "position": {
                "x": -3140.52,
                "z": -1255.542
              },
              "distanceAlongShapeM": 10442.363,
              "shapeOffsetM": 4.427,
              "arrivalOffsetSeconds": 2220,
              "departureOffsetSeconds": 2220
            },
            {
              "stopId": "judu:stop:4990",
              "position": {
                "x": -3543.073,
                "z": -1269.659
              },
              "distanceAlongShapeM": 10932.761,
              "shapeOffsetM": 3.368,
              "arrivalOffsetSeconds": 2340,
              "departureOffsetSeconds": 2340
            },
            {
              "stopId": "judu:stop:5722",
              "position": {
                "x": -3418.974,
                "z": -1694.844
              },
              "distanceAlongShapeM": 11378.079,
              "shapeOffsetM": 5.439,
              "arrivalOffsetSeconds": 2460,
              "departureOffsetSeconds": 2460
            },
            {
              "stopId": "judu:stop:6472",
              "position": {
                "x": -3345.53,
                "z": -2177.035
              },
              "distanceAlongShapeM": 11871.038,
              "shapeOffsetM": 4.521,
              "arrivalOffsetSeconds": 2580,
              "departureOffsetSeconds": 2580
            },
            {
              "stopId": "judu:stop:6651",
              "position": {
                "x": -3256.485,
                "z": -2613.86
              },
              "distanceAlongShapeM": 12341.025,
              "shapeOffsetM": 5.412,
              "arrivalOffsetSeconds": 2700,
              "departureOffsetSeconds": 2700
            },
            {
              "stopId": "judu:stop:5067",
              "position": {
                "x": -3053.229,
                "z": -3115.03
              },
              "distanceAlongShapeM": 12883.479,
              "shapeOffsetM": 5.298,
              "arrivalOffsetSeconds": 2820,
              "departureOffsetSeconds": 2820
            },
            {
              "stopId": "judu:stop:6479",
              "position": {
                "x": -2968.741,
                "z": -3404.837
              },
              "distanceAlongShapeM": 13185.322,
              "shapeOffsetM": 5.004,
              "arrivalOffsetSeconds": 2880,
              "departureOffsetSeconds": 2880
            },
            {
              "stopId": "judu:stop:6481",
              "position": {
                "x": -2906.719,
                "z": -3835.629
              },
              "distanceAlongShapeM": 13620.151,
              "shapeOffsetM": 4.623,
              "arrivalOffsetSeconds": 2940,
              "departureOffsetSeconds": 2940
            },
            {
              "stopId": "judu:stop:6653",
              "position": {
                "x": -2914.524,
                "z": -4206.195
              },
              "distanceAlongShapeM": 13990.99,
              "shapeOffsetM": 5.531,
              "arrivalOffsetSeconds": 3000,
              "departureOffsetSeconds": 3000
            },
            {
              "stopId": "judu:stop:8275",
              "position": {
                "x": -2897.378,
                "z": -4403.536
              },
              "distanceAlongShapeM": 14352.568,
              "shapeOffsetM": 0.752,
              "arrivalOffsetSeconds": 3060,
              "departureOffsetSeconds": 3060
            }
          ],
          "departuresSeconds": [
            19920,
            20760,
            21420,
            22140,
            22860,
            23700,
            24360,
            25140,
            26040,
            26880,
            27780,
            28680,
            29640,
            30600,
            31440,
            32160,
            33060,
            34200,
            36420,
            38520,
            40320,
            41520,
            42660,
            43860,
            45060,
            46260,
            47580,
            48840,
            50160,
            51360,
            52140,
            52920,
            53880,
            54420,
            54960,
            56040,
            57120,
            58200,
            59280,
            60240,
            61080,
            61740,
            62340,
            63000,
            63960,
            65280,
            66660,
            68340,
            71040,
            72120,
            73440,
            74700,
            76080,
            77520,
            78480,
            79440,
            80640,
            81900,
            83160
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_trol_20",
      "sourceRouteId": "vilnius_trol_20",
      "mode": "trolleybus",
      "shortName": "20",
      "longName": "Žirmūnai–Žygimantų–Pylimo g.–Stotis",
      "color": "DC3131",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_trol_20:0",
          "sourceRouteId": "vilnius_trol_20",
          "sourceShapeId": "vilnius_trol_20_a-b",
          "directionId": 0,
          "headsign": "Stotis",
          "directionName": "Žirmūnai–Žygimantų–Pylimo g.–Stotis",
          "mode": "trolleybus",
          "routeShortName": "20",
          "routeLongName": "Žirmūnai–Žygimantų–Pylimo g.–Stotis",
          "routeColor": "DC3131",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              1017.506,
              -4299.224,
              0
            ],
            [
              1021.564,
              -4286.64,
              13.222
            ],
            [
              1026.249,
              -4282.222,
              19.661
            ],
            [
              1105.831,
              -4274.26,
              99.641
            ],
            [
              1128.035,
              -4270.234,
              122.207
            ],
            [
              1147.356,
              -4270.545,
              141.53
            ],
            [
              1189.631,
              -4265.192,
              184.142
            ],
            [
              1202.517,
              -4249.3,
              204.602
            ],
            [
              1214.522,
              -4227.257,
              229.702
            ],
            [
              1220.978,
              -4191.753,
              265.789
            ],
            [
              1217.195,
              -3943.429,
              514.141
            ],
            [
              1219.986,
              -3862.213,
              595.405
            ],
            [
              1375.611,
              -3774.922,
              773.84
            ],
            [
              1393.375,
              -3755.212,
              800.374
            ],
            [
              1412.221,
              -3746.656,
              821.071
            ],
            [
              1509.877,
              -3564.24,
              1027.982
            ],
            [
              1556.885,
              -3486.613,
              1118.733
            ],
            [
              1610.18,
              -3392.177,
              1227.17
            ],
            [
              1620.009,
              -3384.254,
              1239.794
            ],
            [
              1689.847,
              -3267.548,
              1375.8
            ],
            [
              1697.306,
              -3247.648,
              1397.052
            ],
            [
              1696.944,
              -3128.524,
              1516.177
            ],
            [
              1692.78,
              -3098.159,
              1546.826
            ],
            [
              1693.427,
              -3075.022,
              1569.972
            ],
            [
              1690.731,
              -2873.474,
              1771.538
            ],
            [
              1684.353,
              -2661.838,
              1983.27
            ],
            [
              1680.485,
              -2590.427,
              2054.786
            ],
            [
              1679.547,
              -2554.739,
              2090.487
            ],
            [
              1678.725,
              -2527.718,
              2117.519
            ],
            [
              1679.06,
              -2495.866,
              2149.373
            ],
            [
              1670.601,
              -2049.296,
              2596.024
            ],
            [
              1665.105,
              -1963.474,
              2682.021
            ],
            [
              1665.702,
              -1896.69,
              2748.808
            ],
            [
              1663.09,
              -1759.712,
              2885.811
            ],
            [
              1657.26,
              -1724.669,
              2921.336
            ],
            [
              1660.464,
              -1692.869,
              2953.297
            ],
            [
              1642.718,
              -1572.308,
              3075.157
            ],
            [
              1626.598,
              -1502.988,
              3146.326
            ],
            [
              1590.763,
              -1384.318,
              3270.289
            ],
            [
              1541.473,
              -1260.946,
              3403.143
            ],
            [
              1439.941,
              -1068.699,
              3620.554
            ],
            [
              1422.22,
              -1045.077,
              3650.084
            ],
            [
              1413.029,
              -1024.784,
              3672.361
            ],
            [
              1382.574,
              -969.885,
              3735.142
            ],
            [
              1372.327,
              -959.462,
              3749.758
            ],
            [
              1333.941,
              -943.166,
              3791.46
            ],
            [
              1307.513,
              -942.677,
              3817.893
            ],
            [
              1293.291,
              -944.641,
              3832.25
            ],
            [
              1278.614,
              -942.95,
              3847.024
            ],
            [
              1269.114,
              -935.31,
              3859.215
            ],
            [
              1257.916,
              -924.645,
              3874.679
            ],
            [
              1249.597,
              -901.529,
              3899.246
            ],
            [
              1249.57,
              -868.132,
              3932.643
            ],
            [
              1251.975,
              -858.297,
              3942.768
            ],
            [
              1256.345,
              -850.445,
              3951.754
            ],
            [
              1271.438,
              -836.252,
              3972.472
            ],
            [
              1287.032,
              -829.861,
              3989.325
            ],
            [
              1306.39,
              -829.106,
              4008.698
            ],
            [
              1381.451,
              -814.909,
              4085.089
            ],
            [
              1598.931,
              -666.427,
              4348.423
            ],
            [
              1632.324,
              -639.216,
              4391.499
            ],
            [
              1644.195,
              -624.964,
              4410.047
            ],
            [
              1649.997,
              -609.491,
              4426.572
            ],
            [
              1647.435,
              -589.4,
              4446.826
            ],
            [
              1641.361,
              -569.249,
              4467.872
            ],
            [
              1626.241,
              -550.043,
              4492.316
            ],
            [
              1613.941,
              -537.088,
              4510.18
            ],
            [
              1227.773,
              -233.181,
              5001.591
            ],
            [
              1061.875,
              -125.757,
              5199.233
            ],
            [
              1042.305,
              -113.981,
              5222.072
            ],
            [
              992.552,
              -84.12,
              5280.099
            ],
            [
              920.398,
              -44.941,
              5362.203
            ],
            [
              895.357,
              -38.914,
              5387.959
            ],
            [
              797.689,
              -19.306,
              5487.576
            ],
            [
              670.384,
              1.958,
              5616.645
            ],
            [
              652.936,
              0.051,
              5634.197
            ],
            [
              630.873,
              -7.336,
              5657.464
            ],
            [
              602.561,
              -27.877,
              5692.442
            ],
            [
              564.962,
              -49.544,
              5735.837
            ],
            [
              476.44,
              -129.188,
              5854.914
            ],
            [
              402.286,
              -199.078,
              5956.814
            ],
            [
              346.776,
              -237.026,
              6024.055
            ],
            [
              281.176,
              -262.545,
              6094.444
            ],
            [
              119.684,
              -277.409,
              6256.618
            ],
            [
              35.151,
              -280.322,
              6341.202
            ],
            [
              26.264,
              -279.764,
              6350.106
            ],
            [
              16.623,
              -264.894,
              6367.828
            ],
            [
              14.513,
              -253.218,
              6379.693
            ],
            [
              16.439,
              -245.471,
              6387.676
            ],
            [
              25.627,
              -236.732,
              6400.356
            ],
            [
              45.916,
              -220.403,
              6426.4
            ],
            [
              103.215,
              -190.277,
              6491.136
            ],
            [
              127.382,
              -102.772,
              6581.917
            ],
            [
              121.848,
              -52.576,
              6632.417
            ],
            [
              118.496,
              -36.512,
              6648.827
            ],
            [
              117.583,
              -3.516,
              6681.836
            ],
            [
              102.671,
              133.684,
              6819.844
            ],
            [
              63.181,
              125.497,
              6860.174
            ],
            [
              59.312,
              125.568,
              6864.043
            ],
            [
              57.419,
              127.829,
              6866.992
            ],
            [
              31.786,
              278.582,
              7019.909
            ],
            [
              4.856,
              358.112,
              7103.874
            ],
            [
              -8.924,
              380.627,
              7130.272
            ],
            [
              -39.768,
              422.378,
              7182.18
            ],
            [
              -46.8,
              425.846,
              7190.021
            ],
            [
              -51.212,
              431.492,
              7197.186
            ],
            [
              -51.307,
              497.175,
              7262.869
            ],
            [
              -54.16,
              522.615,
              7288.469
            ],
            [
              -44.593,
              547.148,
              7314.801
            ],
            [
              -34.25,
              619.32,
              7387.711
            ],
            [
              -34.886,
              726.201,
              7494.593
            ],
            [
              -29.964,
              784,
              7552.602
            ],
            [
              -28.88,
              804.74,
              7573.37
            ],
            [
              -24.076,
              823.969,
              7593.19
            ],
            [
              -6.94,
              914.942,
              7685.763
            ],
            [
              5.94,
              949.218,
              7722.379
            ],
            [
              14.89,
              980.225,
              7754.652
            ],
            [
              20.723,
              1007.284,
              7782.333
            ],
            [
              98.858,
              1127.869,
              7926.019
            ],
            [
              208.532,
              1302.485,
              8132.221
            ],
            [
              265.611,
              1357.493,
              8211.492
            ],
            [
              347.967,
              1416.104,
              8312.575
            ],
            [
              403.761,
              1468.519,
              8389.127
            ],
            [
              407.254,
              1474.663,
              8396.195
            ],
            [
              398.727,
              1481.949,
              8407.412
            ],
            [
              393.766,
              1486.188,
              8413.937
            ],
            [
              391.311,
              1493.238,
              8421.402
            ],
            [
              396.156,
              1548.878,
              8477.252
            ],
            [
              395.449,
              1569.043,
              8497.43
            ],
            [
              397.453,
              1582.184,
              8510.723
            ],
            [
              391.321,
              1670.242,
              8598.994
            ],
            [
              330.657,
              1810.504,
              8751.813
            ],
            [
              327.072,
              1826.155,
              8767.869
            ],
            [
              328.524,
              1835.034,
              8776.866
            ],
            [
              390.297,
              1931.87,
              8891.727
            ],
            [
              384.797,
              1948.669,
              8909.404
            ],
            [
              364.123,
              1982.443,
              8949.003
            ],
            [
              361.04,
              1990.292,
              8957.436
            ],
            [
              363.158,
              2000.273,
              8967.639
            ],
            [
              374.225,
              2005.637,
              8979.938
            ],
            [
              387.77,
              2005.389,
              8993.485
            ],
            [
              447.829,
              1973.12,
              9061.664
            ],
            [
              476.503,
              1958.043,
              9094.06
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:5508",
              "position": {
                "x": 1128.033,
                "z": -4270.188
              },
              "distanceAlongShapeM": 122.207,
              "shapeOffsetM": 0.046,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:5149",
              "position": {
                "x": 1393.375,
                "z": -3755.212
              },
              "distanceAlongShapeM": 800.374,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:5086",
              "position": {
                "x": 1607.644,
                "z": -3390.704
              },
              "distanceAlongShapeM": 1227.17,
              "shapeOffsetM": 2.933,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:5087",
              "position": {
                "x": 1687.839,
                "z": -3098.296
              },
              "distanceAlongShapeM": 1546.826,
              "shapeOffsetM": 4.943,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:5088",
              "position": {
                "x": 1670.083,
                "z": -2527.983
              },
              "distanceAlongShapeM": 2117.518,
              "shapeOffsetM": 8.646,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:5658",
              "position": {
                "x": 1653.419,
                "z": -1725.022
              },
              "distanceAlongShapeM": 2921.336,
              "shapeOffsetM": 3.857,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:5661",
              "position": {
                "x": 1418.417,
                "z": -1047.149
              },
              "distanceAlongShapeM": 3650.084,
              "shapeOffsetM": 4.331,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:5768",
              "position": {
                "x": 1608.96,
                "z": -543.043
              },
              "distanceAlongShapeM": 4509.291,
              "shapeOffsetM": 7.713,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:5771",
              "position": {
                "x": 1060.09,
                "z": -128.781
              },
              "distanceAlongShapeM": 5199.087,
              "shapeOffsetM": 3.508,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:848",
              "position": {
                "x": 604.636,
                "z": -31.346
              },
              "distanceAlongShapeM": 5692.442,
              "shapeOffsetM": 4.042,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:5409",
              "position": {
                "x": 115.041,
                "z": -36.866
              },
              "distanceAlongShapeM": 6648.827,
              "shapeOffsetM": 3.473,
              "arrivalOffsetSeconds": 1500,
              "departureOffsetSeconds": 1500
            },
            {
              "stopId": "judu:stop:5338",
              "position": {
                "x": -56,
                "z": 522.864
              },
              "distanceAlongShapeM": 7288.469,
              "shapeOffsetM": 1.857,
              "arrivalOffsetSeconds": 1680,
              "departureOffsetSeconds": 1680
            },
            {
              "stopId": "judu:stop:5345",
              "position": {
                "x": 17.976,
                "z": 1008
              },
              "distanceAlongShapeM": 7782.333,
              "shapeOffsetM": 2.839,
              "arrivalOffsetSeconds": 1800,
              "departureOffsetSeconds": 1800
            },
            {
              "stopId": "judu:stop:5349",
              "position": {
                "x": 206.575,
                "z": 1304.022
              },
              "distanceAlongShapeM": 8132.221,
              "shapeOffsetM": 2.488,
              "arrivalOffsetSeconds": 1860,
              "departureOffsetSeconds": 1860
            },
            {
              "stopId": "judu:stop:5430",
              "position": {
                "x": 392.049,
                "z": 1568.924
              },
              "distanceAlongShapeM": 8497.43,
              "shapeOffsetM": 3.402,
              "arrivalOffsetSeconds": 1980,
              "departureOffsetSeconds": 1980
            },
            {
              "stopId": "judu:stop:5300",
              "position": {
                "x": 479.21,
                "z": 1960.301
              },
              "distanceAlongShapeM": 9094.06,
              "shapeOffsetM": 3.526,
              "arrivalOffsetSeconds": 2160,
              "departureOffsetSeconds": 2160
            }
          ],
          "departuresSeconds": [
            19920,
            21300,
            22680,
            24000,
            25320,
            26640,
            28260,
            29940,
            32700,
            34380,
            35940,
            37320,
            38520,
            39900,
            41220,
            42540,
            43800,
            45240,
            46560,
            47760,
            49140,
            50460,
            51840,
            53160,
            54360,
            55860,
            57300,
            58800,
            60000,
            61680,
            63360,
            65280,
            67680,
            69360,
            71040,
            72720,
            73860,
            75000,
            76380,
            77640,
            78840,
            80220,
            81660
          ]
        },
        {
          "id": "judu:pattern:vilnius_trol_20:1",
          "sourceRouteId": "vilnius_trol_20",
          "sourceShapeId": "vilnius_trol_20_b-a",
          "directionId": 1,
          "headsign": "Žirmūnai",
          "directionName": "Stotis–Pylimo–Žygimantų g.–Žirmūnai",
          "mode": "trolleybus",
          "routeShortName": "20",
          "routeLongName": "Žirmūnai–Žygimantų–Pylimo g.–Stotis",
          "routeColor": "DC3131",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              476.503,
              1958.043,
              0
            ],
            [
              482.271,
              1945.18,
              14.097
            ],
            [
              477.309,
              1926.939,
              33.001
            ],
            [
              467.128,
              1919.144,
              45.824
            ],
            [
              410.21,
              1927.053,
              103.288
            ],
            [
              405.736,
              1929.361,
              108.323
            ],
            [
              398.6,
              1927.265,
              115.76
            ],
            [
              329.489,
              1817.205,
              245.72
            ],
            [
              330.657,
              1810.504,
              252.522
            ],
            [
              391.321,
              1670.242,
              405.34
            ],
            [
              473.433,
              1574.115,
              531.763
            ],
            [
              482.238,
              1561.708,
              546.977
            ],
            [
              478.313,
              1549.038,
              560.241
            ],
            [
              469.529,
              1536.247,
              575.758
            ],
            [
              453.691,
              1517.701,
              600.147
            ],
            [
              360.424,
              1427.008,
              730.239
            ],
            [
              315.899,
              1391.085,
              787.448
            ],
            [
              256.42,
              1348.755,
              860.452
            ],
            [
              223.566,
              1315.958,
              906.875
            ],
            [
              196.476,
              1280.829,
              951.236
            ],
            [
              149.248,
              1202.651,
              1042.572
            ],
            [
              55.081,
              1061.873,
              1211.941
            ],
            [
              46.275,
              1047.293,
              1228.974
            ],
            [
              39.094,
              1036.402,
              1242.019
            ],
            [
              29.447,
              1013.439,
              1266.926
            ],
            [
              17.226,
              966.824,
              1315.117
            ],
            [
              -2.949,
              921.549,
              1364.683
            ],
            [
              -20.393,
              826.162,
              1461.653
            ],
            [
              -29.409,
              769.885,
              1518.647
            ],
            [
              -34.886,
              726.201,
              1562.673
            ],
            [
              -34.25,
              619.32,
              1669.556
            ],
            [
              -49.15,
              509.381,
              1780.5
            ],
            [
              -51.111,
              437.057,
              1852.851
            ],
            [
              -46.759,
              428.072,
              1862.834
            ],
            [
              -39.768,
              422.378,
              1871.85
            ],
            [
              15.61,
              348.039,
              1964.549
            ],
            [
              36.62,
              260.682,
              2054.397
            ],
            [
              56.855,
              132.292,
              2184.372
            ],
            [
              59.373,
              128.907,
              2188.591
            ],
            [
              70.978,
              128.695,
              2200.198
            ],
            [
              102.671,
              133.684,
              2232.281
            ],
            [
              112.53,
              93.98,
              2273.191
            ],
            [
              117.374,
              52.085,
              2315.364
            ],
            [
              129.077,
              -80.538,
              2448.503
            ],
            [
              129.194,
              -109.485,
              2477.45
            ],
            [
              121.493,
              -193.936,
              2562.252
            ],
            [
              118.351,
              -267.309,
              2635.692
            ],
            [
              179.196,
              -267.363,
              2696.536
            ],
            [
              270.197,
              -263.458,
              2787.621
            ],
            [
              305.837,
              -254.09,
              2824.471
            ],
            [
              342.264,
              -236.944,
              2864.732
            ],
            [
              410.165,
              -191.43,
              2946.476
            ],
            [
              461.971,
              -144.509,
              3016.372
            ],
            [
              541.549,
              -60.247,
              3132.272
            ],
            [
              557.019,
              -44.104,
              3154.63
            ],
            [
              589.799,
              -22.869,
              3193.688
            ],
            [
              630.571,
              1.522,
              3241.198
            ],
            [
              645.363,
              9.096,
              3257.817
            ],
            [
              675.04,
              9.665,
              3287.499
            ],
            [
              707.88,
              6.836,
              3320.461
            ],
            [
              925.597,
              -42.81,
              3543.766
            ],
            [
              1129.224,
              -156.774,
              3777.115
            ],
            [
              1141.634,
              -163.763,
              3791.358
            ],
            [
              1606.423,
              -519.681,
              4376.769
            ],
            [
              1614.903,
              -526.354,
              4387.56
            ],
            [
              1648.803,
              -550.462,
              4429.158
            ],
            [
              1662.944,
              -552.951,
              4443.517
            ],
            [
              1683.01,
              -548.871,
              4463.993
            ],
            [
              1705.327,
              -547.896,
              4486.332
            ],
            [
              1715.935,
              -555.388,
              4499.319
            ],
            [
              1719.444,
              -566.247,
              4510.731
            ],
            [
              1721.402,
              -599.681,
              4544.222
            ],
            [
              1718.066,
              -610.324,
              4555.376
            ],
            [
              1706.711,
              -619.261,
              4569.826
            ],
            [
              1700.984,
              -622.679,
              4576.495
            ],
            [
              1684.224,
              -622.368,
              4593.258
            ],
            [
              1662.848,
              -627.537,
              4615.25
            ],
            [
              1583.13,
              -683.945,
              4712.907
            ],
            [
              1381.451,
              -814.909,
              4953.377
            ],
            [
              1363.471,
              -845.747,
              4989.074
            ],
            [
              1362.208,
              -879.121,
              5022.472
            ],
            [
              1367.85,
              -922.642,
              5066.357
            ],
            [
              1384.491,
              -964.14,
              5111.067
            ],
            [
              1464.439,
              -1103.664,
              5271.873
            ],
            [
              1477.634,
              -1123.116,
              5295.378
            ],
            [
              1488.813,
              -1145.306,
              5320.225
            ],
            [
              1537.374,
              -1238.606,
              5425.406
            ],
            [
              1587.871,
              -1366.453,
              5562.865
            ],
            [
              1626.598,
              -1502.988,
              5704.786
            ],
            [
              1647.564,
              -1589.097,
              5793.41
            ],
            [
              1670.179,
              -1759.844,
              5965.649
            ],
            [
              1672.682,
              -1787.97,
              5993.886
            ],
            [
              1672.408,
              -1813.321,
              6019.238
            ],
            [
              1676.981,
              -1962.613,
              6168.6
            ],
            [
              1684.587,
              -2475.93,
              6681.973
            ],
            [
              1691.063,
              -2612.98,
              6819.176
            ],
            [
              1692.552,
              -2638.806,
              6845.046
            ],
            [
              1690.652,
              -2669.748,
              6876.046
            ],
            [
              1690.731,
              -2873.474,
              7079.772
            ],
            [
              1700.851,
              -3126.37,
              7332.87
            ],
            [
              1707.344,
              -3177.803,
              7384.711
            ],
            [
              1701.896,
              -3208.77,
              7416.154
            ],
            [
              1697.306,
              -3247.648,
              7455.302
            ],
            [
              1679.831,
              -3286.287,
              7497.709
            ],
            [
              1593.247,
              -3437.193,
              7671.69
            ],
            [
              1579.69,
              -3472.235,
              7709.263
            ],
            [
              1566.424,
              -3493.47,
              7734.301
            ],
            [
              1508.519,
              -3591.87,
              7848.475
            ],
            [
              1412.221,
              -3746.656,
              8030.771
            ],
            [
              1401.002,
              -3760.92,
              8048.918
            ],
            [
              1342.534,
              -3804.924,
              8122.095
            ],
            [
              1325.974,
              -3810.739,
              8139.646
            ],
            [
              1219.986,
              -3862.213,
              8257.473
            ],
            [
              1220.734,
              -4100.462,
              8495.723
            ],
            [
              1222.498,
              -4142.938,
              8538.235
            ],
            [
              1222.034,
              -4169.508,
              8564.809
            ],
            [
              1222.197,
              -4191.784,
              8587.086
            ],
            [
              1218.667,
              -4222.547,
              8618.051
            ],
            [
              1209.216,
              -4242.448,
              8640.082
            ],
            [
              1199.734,
              -4253.999,
              8655.027
            ],
            [
              1180.34,
              -4272.796,
              8682.035
            ],
            [
              1169.776,
              -4277.639,
              8693.656
            ],
            [
              1151.036,
              -4280.633,
              8712.634
            ],
            [
              1136.231,
              -4280.418,
              8727.44
            ],
            [
              1097.302,
              -4298.664,
              8770.433
            ],
            [
              1060.432,
              -4334.455,
              8821.818
            ],
            [
              1050.84,
              -4334.625,
              8831.411
            ],
            [
              1024.373,
              -4320.974,
              8861.191
            ],
            [
              1020.017,
              -4312.849,
              8870.41
            ],
            [
              1017.506,
              -4299.224,
              8884.265
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:5300",
              "position": {
                "x": 479.21,
                "z": 1960.301
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 3.526,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:6834",
              "position": {
                "x": 472.7,
                "z": 1534.052
              },
              "distanceAlongShapeM": 575.758,
              "shapeOffsetM": 3.857,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:5346",
              "position": {
                "x": 52.802,
                "z": 1042.989
              },
              "distanceAlongShapeM": 1228.974,
              "shapeOffsetM": 7.818,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:5432",
              "position": {
                "x": -26.358,
                "z": 769.462
              },
              "distanceAlongShapeM": 1518.582,
              "shapeOffsetM": 3.079,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:5459",
              "position": {
                "x": 18.234,
                "z": 348.963
              },
              "distanceAlongShapeM": 1964.549,
              "shapeOffsetM": 2.781,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:5492",
              "position": {
                "x": 116.145,
                "z": 94.475
              },
              "distanceAlongShapeM": 2273.191,
              "shapeOffsetM": 3.649,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:7278",
              "position": {
                "x": 707.88,
                "z": 6.836
              },
              "distanceAlongShapeM": 3320.461,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:6573",
              "position": {
                "x": 1143.99,
                "z": -160.386
              },
              "distanceAlongShapeM": 3791.358,
              "shapeOffsetM": 4.117,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:5770",
              "position": {
                "x": 1610.786,
                "z": -514.132
              },
              "distanceAlongShapeM": 4376.769,
              "shapeOffsetM": 7.059,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:6665",
              "position": {
                "x": 1480.223,
                "z": -1121.768
              },
              "distanceAlongShapeM": 5295.378,
              "shapeOffsetM": 2.918,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            },
            {
              "stopId": "judu:stop:6666",
              "position": {
                "x": 1676.751,
                "z": -1787.797
              },
              "distanceAlongShapeM": 5993.886,
              "shapeOffsetM": 4.073,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            },
            {
              "stopId": "judu:stop:5606",
              "position": {
                "x": 1696.386,
                "z": -2638.684
              },
              "distanceAlongShapeM": 6845.046,
              "shapeOffsetM": 3.836,
              "arrivalOffsetSeconds": 1680,
              "departureOffsetSeconds": 1680
            },
            {
              "stopId": "judu:stop:6667",
              "position": {
                "x": 1709.563,
                "z": -3177.741
              },
              "distanceAlongShapeM": 7384.711,
              "shapeOffsetM": 2.22,
              "arrivalOffsetSeconds": 1800,
              "departureOffsetSeconds": 1800
            },
            {
              "stopId": "judu:stop:6668",
              "position": {
                "x": 1582.257,
                "z": -3473.726
              },
              "distanceAlongShapeM": 7709.263,
              "shapeOffsetM": 2.969,
              "arrivalOffsetSeconds": 1860,
              "departureOffsetSeconds": 1860
            },
            {
              "stopId": "judu:stop:5154",
              "position": {
                "x": 1342.825,
                "z": -3805.485
              },
              "distanceAlongShapeM": 8122.095,
              "shapeOffsetM": 0.632,
              "arrivalOffsetSeconds": 2040,
              "departureOffsetSeconds": 2040
            },
            {
              "stopId": "judu:stop:6671",
              "position": {
                "x": 1228.325,
                "z": -4142.906
              },
              "distanceAlongShapeM": 8538.235,
              "shapeOffsetM": 5.827,
              "arrivalOffsetSeconds": 2100,
              "departureOffsetSeconds": 2100
            },
            {
              "stopId": "judu:stop:5505",
              "position": {
                "x": 1151.036,
                "z": -4280.633
              },
              "distanceAlongShapeM": 8712.634,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2160,
              "departureOffsetSeconds": 2160
            }
          ],
          "departuresSeconds": [
            22080,
            23460,
            24840,
            26220,
            27720,
            29100,
            30720,
            32400,
            35040,
            36660,
            38220,
            39540,
            40740,
            42120,
            43440,
            44760,
            46020,
            47460,
            48780,
            49980,
            51360,
            52680,
            54060,
            55380,
            56580,
            58080,
            59640,
            61260,
            62460,
            64140,
            65820,
            67680,
            70020,
            71640,
            73260,
            74940,
            76020,
            77100,
            78480,
            79740,
            80940,
            82320,
            83700
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_trol_21",
      "sourceRouteId": "vilnius_trol_21",
      "mode": "trolleybus",
      "shortName": "21",
      "longName": "Antakalnis–Šilo tiltas–Žirmūnai",
      "color": "DC3131",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_trol_21:0",
          "sourceRouteId": "vilnius_trol_21",
          "sourceShapeId": "vilnius_trol_21_a-b",
          "directionId": 0,
          "headsign": "Žirmūnai",
          "directionName": "Antakalnis–Šilo tiltas–Žirmūnai",
          "mode": "trolleybus",
          "routeShortName": "21",
          "routeLongName": "Antakalnis–Šilo tiltas–Žirmūnai",
          "routeColor": "DC3131",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              2550.54,
              -3888.998,
              0
            ],
            [
              2499.38,
              -3984.027,
              107.925
            ],
            [
              2493.87,
              -3987.392,
              114.381
            ],
            [
              2480.707,
              -3991.548,
              128.185
            ],
            [
              2470.701,
              -3991,
              138.206
            ],
            [
              2459.88,
              -3985.473,
              150.357
            ],
            [
              2450.261,
              -3972.454,
              166.544
            ],
            [
              2446.334,
              -3960.766,
              178.874
            ],
            [
              2458.099,
              -3917.57,
              223.643
            ],
            [
              2495.249,
              -3757.959,
              387.521
            ],
            [
              2503.087,
              -3718.029,
              428.213
            ],
            [
              2508.663,
              -3661.358,
              485.157
            ],
            [
              2467.501,
              -3518.217,
              634.1
            ],
            [
              2463.864,
              -3499.82,
              652.852
            ],
            [
              2434.339,
              -3309.248,
              845.698
            ],
            [
              2430.841,
              -3283.862,
              871.324
            ],
            [
              2426.976,
              -3256.769,
              898.691
            ],
            [
              2328.687,
              -2639.354,
              1523.881
            ],
            [
              2308.053,
              -2536.548,
              1628.737
            ],
            [
              2300.116,
              -2511.178,
              1655.319
            ],
            [
              2295.002,
              -2476.188,
              1690.681
            ],
            [
              2274.24,
              -2414.57,
              1755.703
            ],
            [
              2234.812,
              -2316.979,
              1860.958
            ],
            [
              2177.257,
              -2188.992,
              2001.29
            ],
            [
              2082.177,
              -1964.565,
              2245.027
            ],
            [
              2063.994,
              -1895.874,
              2316.084
            ],
            [
              2025.955,
              -1900.505,
              2354.404
            ],
            [
              1998.15,
              -1907.334,
              2383.035
            ],
            [
              1855.148,
              -1935.839,
              2528.851
            ],
            [
              1712.252,
              -1958.784,
              2673.577
            ],
            [
              1676.981,
              -1962.613,
              2709.055
            ],
            [
              1684.587,
              -2475.93,
              3222.429
            ],
            [
              1691.063,
              -2612.98,
              3359.631
            ],
            [
              1692.552,
              -2638.806,
              3385.501
            ],
            [
              1690.652,
              -2669.748,
              3416.501
            ],
            [
              1690.731,
              -2873.474,
              3620.227
            ],
            [
              1700.851,
              -3126.37,
              3873.325
            ],
            [
              1707.344,
              -3177.803,
              3925.166
            ],
            [
              1701.896,
              -3208.77,
              3956.609
            ],
            [
              1697.306,
              -3247.648,
              3995.757
            ],
            [
              1679.831,
              -3286.287,
              4038.164
            ],
            [
              1593.247,
              -3437.193,
              4212.145
            ],
            [
              1579.69,
              -3472.235,
              4249.718
            ],
            [
              1566.424,
              -3493.47,
              4274.756
            ],
            [
              1508.519,
              -3591.87,
              4388.93
            ],
            [
              1412.221,
              -3746.656,
              4571.226
            ],
            [
              1401.002,
              -3760.92,
              4589.373
            ],
            [
              1342.534,
              -3804.924,
              4662.55
            ],
            [
              1325.974,
              -3810.739,
              4680.101
            ],
            [
              1219.986,
              -3862.213,
              4797.928
            ],
            [
              1220.734,
              -4100.462,
              5036.178
            ],
            [
              1222.498,
              -4142.938,
              5078.69
            ],
            [
              1222.034,
              -4169.508,
              5105.265
            ],
            [
              1222.197,
              -4191.784,
              5127.541
            ],
            [
              1218.667,
              -4222.547,
              5158.506
            ],
            [
              1209.216,
              -4242.448,
              5180.537
            ],
            [
              1199.734,
              -4253.999,
              5195.482
            ],
            [
              1180.34,
              -4272.796,
              5222.49
            ],
            [
              1169.776,
              -4277.639,
              5234.111
            ],
            [
              1151.036,
              -4280.633,
              5253.089
            ],
            [
              1136.231,
              -4280.418,
              5267.895
            ],
            [
              1097.302,
              -4298.664,
              5310.888
            ],
            [
              1060.432,
              -4334.455,
              5362.273
            ],
            [
              1050.84,
              -4334.625,
              5371.866
            ],
            [
              1024.373,
              -4320.974,
              5401.646
            ],
            [
              1020.017,
              -4312.849,
              5410.865
            ],
            [
              1017.506,
              -4299.224,
              5424.72
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:1017",
              "position": {
                "x": 2551.422,
                "z": -3889.265
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 0.921,
              "arrivalOffsetSeconds": -360,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:5118",
              "position": {
                "x": 2463.001,
                "z": -3519.117
              },
              "distanceAlongShapeM": 634.1,
              "shapeOffsetM": 4.589,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:5119",
              "position": {
                "x": 2425.512,
                "z": -3284.63
              },
              "distanceAlongShapeM": 871.29,
              "shapeOffsetM": 5.384,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:5096",
              "position": {
                "x": 2296.913,
                "z": -2511.848
              },
              "distanceAlongShapeM": 1655.319,
              "shapeOffsetM": 3.272,
              "arrivalOffsetSeconds": 390,
              "departureOffsetSeconds": 390
            },
            {
              "stopId": "judu:stop:5091",
              "position": {
                "x": 2031.037,
                "z": -1906.834
              },
              "distanceAlongShapeM": 2350.124,
              "shapeOffsetM": 6.897,
              "arrivalOffsetSeconds": 570,
              "departureOffsetSeconds": 570
            },
            {
              "stopId": "judu:stop:5606",
              "position": {
                "x": 1696.386,
                "z": -2638.684
              },
              "distanceAlongShapeM": 3385.501,
              "shapeOffsetM": 3.836,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:6667",
              "position": {
                "x": 1709.563,
                "z": -3177.741
              },
              "distanceAlongShapeM": 3925.166,
              "shapeOffsetM": 2.22,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            },
            {
              "stopId": "judu:stop:6668",
              "position": {
                "x": 1582.257,
                "z": -3473.726
              },
              "distanceAlongShapeM": 4249.718,
              "shapeOffsetM": 2.969,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:5154",
              "position": {
                "x": 1342.825,
                "z": -3805.485
              },
              "distanceAlongShapeM": 4662.55,
              "shapeOffsetM": 0.632,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:6671",
              "position": {
                "x": 1228.325,
                "z": -4142.906
              },
              "distanceAlongShapeM": 5078.69,
              "shapeOffsetM": 5.827,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:5505",
              "position": {
                "x": 1151.036,
                "z": -4280.633
              },
              "distanceAlongShapeM": 5253.089,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            }
          ],
          "departuresSeconds": [
            22020,
            23940,
            25380,
            27720,
            29400,
            31920,
            33480,
            39120,
            42540,
            45840,
            49200,
            52800,
            56160,
            57840,
            60120,
            62100,
            64260,
            67200,
            70380,
            73500,
            76620,
            79620
          ]
        },
        {
          "id": "judu:pattern:vilnius_trol_21:1",
          "sourceRouteId": "vilnius_trol_21",
          "sourceShapeId": "vilnius_trol_21_b-a",
          "directionId": 1,
          "headsign": "Antakalnis",
          "directionName": "Žirmūnai–Šilo tiltas–Antakalnis",
          "mode": "trolleybus",
          "routeShortName": "21",
          "routeLongName": "Antakalnis–Šilo tiltas–Žirmūnai",
          "routeColor": "DC3131",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              1017.506,
              -4299.224,
              0
            ],
            [
              1021.564,
              -4286.64,
              13.222
            ],
            [
              1026.249,
              -4282.222,
              19.661
            ],
            [
              1105.831,
              -4274.26,
              99.641
            ],
            [
              1128.035,
              -4270.234,
              122.207
            ],
            [
              1147.356,
              -4270.545,
              141.53
            ],
            [
              1189.631,
              -4265.192,
              184.142
            ],
            [
              1202.517,
              -4249.3,
              204.602
            ],
            [
              1214.522,
              -4227.257,
              229.702
            ],
            [
              1220.978,
              -4191.753,
              265.789
            ],
            [
              1217.195,
              -3943.429,
              514.141
            ],
            [
              1219.986,
              -3862.213,
              595.405
            ],
            [
              1375.611,
              -3774.922,
              773.84
            ],
            [
              1393.375,
              -3755.212,
              800.374
            ],
            [
              1412.221,
              -3746.656,
              821.071
            ],
            [
              1509.877,
              -3564.24,
              1027.982
            ],
            [
              1556.885,
              -3486.613,
              1118.733
            ],
            [
              1610.18,
              -3392.177,
              1227.17
            ],
            [
              1620.009,
              -3384.254,
              1239.794
            ],
            [
              1689.847,
              -3267.548,
              1375.8
            ],
            [
              1697.306,
              -3247.648,
              1397.052
            ],
            [
              1696.944,
              -3128.524,
              1516.177
            ],
            [
              1692.78,
              -3098.159,
              1546.826
            ],
            [
              1693.427,
              -3075.022,
              1569.972
            ],
            [
              1690.731,
              -2873.474,
              1771.538
            ],
            [
              1684.353,
              -2661.838,
              1983.27
            ],
            [
              1680.485,
              -2590.427,
              2054.786
            ],
            [
              1679.547,
              -2554.739,
              2090.487
            ],
            [
              1678.725,
              -2527.718,
              2117.519
            ],
            [
              1679.06,
              -2495.866,
              2149.373
            ],
            [
              1670.601,
              -2049.296,
              2596.024
            ],
            [
              1665.105,
              -1963.474,
              2682.021
            ],
            [
              1667.869,
              -1953.506,
              2692.365
            ],
            [
              1677.147,
              -1950.75,
              2702.044
            ],
            [
              1724.96,
              -1945.743,
              2750.118
            ],
            [
              1955.555,
              -1909.879,
              2983.486
            ],
            [
              1982.08,
              -1904.808,
              3010.491
            ],
            [
              2058.828,
              -1881.42,
              3090.724
            ],
            [
              2066.336,
              -1880.775,
              3098.259
            ],
            [
              2070.784,
              -1884.198,
              3103.872
            ],
            [
              2081.808,
              -1938.356,
              3159.14
            ],
            [
              2087.374,
              -1962.435,
              3183.855
            ],
            [
              2110.719,
              -2024.1,
              3249.791
            ],
            [
              2234.812,
              -2316.979,
              3567.874
            ],
            [
              2284.924,
              -2429.242,
              3690.814
            ],
            [
              2299.015,
              -2468.47,
              3732.496
            ],
            [
              2319.691,
              -2569.05,
              3835.179
            ],
            [
              2323.471,
              -2587.599,
              3854.109
            ],
            [
              2323.492,
              -2606.972,
              3873.483
            ],
            [
              2328.687,
              -2639.354,
              3906.279
            ],
            [
              2411.872,
              -3118.499,
              4392.591
            ],
            [
              2415.738,
              -3139.252,
              4413.701
            ],
            [
              2418.768,
              -3163.158,
              4437.798
            ],
            [
              2474.472,
              -3526.012,
              4804.903
            ],
            [
              2513.109,
              -3664.781,
              4948.95
            ],
            [
              2520.474,
              -3683.355,
              4968.932
            ],
            [
              2542.483,
              -3747.714,
              5036.949
            ],
            [
              2553.555,
              -3775.753,
              5067.095
            ],
            [
              2558.505,
              -3824.161,
              5115.756
            ],
            [
              2550.54,
              -3888.998,
              5181.08
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:5508",
              "position": {
                "x": 1128.033,
                "z": -4270.188
              },
              "distanceAlongShapeM": 122.207,
              "shapeOffsetM": 0.046,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:5149",
              "position": {
                "x": 1393.375,
                "z": -3755.212
              },
              "distanceAlongShapeM": 800.374,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:5086",
              "position": {
                "x": 1607.644,
                "z": -3390.704
              },
              "distanceAlongShapeM": 1227.17,
              "shapeOffsetM": 2.933,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:5087",
              "position": {
                "x": 1687.839,
                "z": -3098.296
              },
              "distanceAlongShapeM": 1546.826,
              "shapeOffsetM": 4.943,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:5088",
              "position": {
                "x": 1670.083,
                "z": -2527.983
              },
              "distanceAlongShapeM": 2117.518,
              "shapeOffsetM": 8.646,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:5092",
              "position": {
                "x": 2087.852,
                "z": -1936.84
              },
              "distanceAlongShapeM": 3158.861,
              "shapeOffsetM": 6.225,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:5095",
              "position": {
                "x": 2327.089,
                "z": -2587.001
              },
              "distanceAlongShapeM": 3854.109,
              "shapeOffsetM": 3.667,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:1035",
              "position": {
                "x": 2419.872,
                "z": -3138.687
              },
              "distanceAlongShapeM": 4413.701,
              "shapeOffsetM": 4.173,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:6711",
              "position": {
                "x": 2522.438,
                "z": -3682.768
              },
              "distanceAlongShapeM": 4969.011,
              "shapeOffsetM": 2.049,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:1017",
              "position": {
                "x": 2551.422,
                "z": -3889.265
              },
              "distanceAlongShapeM": 5181.08,
              "shapeOffsetM": 0.921,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            }
          ],
          "departuresSeconds": [
            20340,
            22500,
            23640,
            25860,
            27540,
            29940,
            31740,
            34500,
            37560,
            40860,
            44280,
            47640,
            51300,
            54660,
            58200,
            60120,
            62220,
            64860,
            68520,
            70140,
            72060,
            75120,
            78180
          ]
        }
      ]
    }
  ],
  "roadAlignment": {
    "sourceId": "grpk-open-2026-07-03",
    "method": "GTFS shape points outside the rendered carriageway envelope are clamped to the nearest official GRPK road, using heading as a tie-breaker and preserving a vehicle-width edge clearance.",
    "inspectedPointCount": 32335,
    "correctedPointCount": 11514,
    "alignedPatternCount": 199,
    "retainedPatternCount": 3,
    "retainedPatternIds": [
      "judu:pattern:vilnius_bus_62:0",
      "judu:pattern:vilnius_bus_62:1",
      "judu:pattern:vilnius_bus_125:1"
    ],
    "maximumOriginalOverflowM": 33.672,
    "vehicleHalfWidthM": 1.275,
    "roadEdgeClearanceM": 0.3
  }
}
